
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7VQPk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2xNuZ"));

});
parcelRegister("2xNuZ", function(module, exports) {
$parcel$export(module.exports, "Fragment", function () { return $1da50f4965e74954$export$ffb0004e005737fa; }, function (v) { return $1da50f4965e74954$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1da50f4965e74954$export$34b9dba7ce09269b; }, function (v) { return $1da50f4965e74954$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1da50f4965e74954$export$25062201e9e25d76; }, function (v) { return $1da50f4965e74954$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1da50f4965e74954$export$ffb0004e005737fa;
var $1da50f4965e74954$export$34b9dba7ce09269b;
var $1da50f4965e74954$export$25062201e9e25d76;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
var $1da50f4965e74954$var$k = Symbol.for("react.element"), $1da50f4965e74954$var$l = Symbol.for("react.fragment"), $1da50f4965e74954$var$m = Object.prototype.hasOwnProperty, $1da50f4965e74954$var$n = $1oC0p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1da50f4965e74954$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1da50f4965e74954$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1da50f4965e74954$var$m.call(a, b) && !$1da50f4965e74954$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1da50f4965e74954$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1da50f4965e74954$var$n.current
    };
}
$1da50f4965e74954$export$ffb0004e005737fa = $1da50f4965e74954$var$l;
$1da50f4965e74954$export$34b9dba7ce09269b = $1da50f4965e74954$var$q;
$1da50f4965e74954$export$25062201e9e25d76 = $1da50f4965e74954$var$q;

});
parcelRegister("1oC0p", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jxZ0d"));

});
parcelRegister("jxZ0d", function(module, exports) {
$parcel$export(module.exports, "Children", function () { return $e3b06b3bfbbfba26$export$dca3b0875bd9a954; }, function (v) { return $e3b06b3bfbbfba26$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e3b06b3bfbbfba26$export$16fa2f45be04daa8; }, function (v) { return $e3b06b3bfbbfba26$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e3b06b3bfbbfba26$export$ffb0004e005737fa; }, function (v) { return $e3b06b3bfbbfba26$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e3b06b3bfbbfba26$export$e2c29f18771995cb; }, function (v) { return $e3b06b3bfbbfba26$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e3b06b3bfbbfba26$export$221d75b3f55bb0bd; }, function (v) { return $e3b06b3bfbbfba26$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e3b06b3bfbbfba26$export$5f8d39834fd61797; }, function (v) { return $e3b06b3bfbbfba26$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e3b06b3bfbbfba26$export$74bf444e3cd11ea5; }, function (v) { return $e3b06b3bfbbfba26$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e3b06b3bfbbfba26$export$ae55be85d98224ed; }, function (v) { return $e3b06b3bfbbfba26$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $e3b06b3bfbbfba26$export$3ba232387fd5d6dd; }, function (v) { return $e3b06b3bfbbfba26$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e3b06b3bfbbfba26$export$e530037191fcd5d7; }, function (v) { return $e3b06b3bfbbfba26$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e3b06b3bfbbfba26$export$fd42f52fd3ae1109; }, function (v) { return $e3b06b3bfbbfba26$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e3b06b3bfbbfba26$export$c8a8987d4410bf2d; }, function (v) { return $e3b06b3bfbbfba26$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e3b06b3bfbbfba26$export$d38cd72104c1f0e9; }, function (v) { return $e3b06b3bfbbfba26$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e3b06b3bfbbfba26$export$7d1e3a5e95ceca43; }, function (v) { return $e3b06b3bfbbfba26$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e3b06b3bfbbfba26$export$257a8862b851cb5b; }, function (v) { return $e3b06b3bfbbfba26$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e3b06b3bfbbfba26$export$a8257692ac88316c; }, function (v) { return $e3b06b3bfbbfba26$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e3b06b3bfbbfba26$export$488013bae63b21da; }, function (v) { return $e3b06b3bfbbfba26$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e3b06b3bfbbfba26$export$7c73462e0d25e514; }, function (v) { return $e3b06b3bfbbfba26$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e3b06b3bfbbfba26$export$7568632d0d33d16d; }, function (v) { return $e3b06b3bfbbfba26$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e3b06b3bfbbfba26$export$88948ce120ea2619; }, function (v) { return $e3b06b3bfbbfba26$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e3b06b3bfbbfba26$export$35808ee640e87ca7; }, function (v) { return $e3b06b3bfbbfba26$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e3b06b3bfbbfba26$export$fae74005e78b1a27; }, function (v) { return $e3b06b3bfbbfba26$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e3b06b3bfbbfba26$export$dc8fbce3eb94dc1e; }, function (v) { return $e3b06b3bfbbfba26$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e3b06b3bfbbfba26$export$6a7bc4e911dc01cf; }, function (v) { return $e3b06b3bfbbfba26$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e3b06b3bfbbfba26$export$6d9c69b0de29b591; }, function (v) { return $e3b06b3bfbbfba26$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e3b06b3bfbbfba26$export$f680877a34711e37; }, function (v) { return $e3b06b3bfbbfba26$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e3b06b3bfbbfba26$export$d5a552a76deda3c2; }, function (v) { return $e3b06b3bfbbfba26$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e3b06b3bfbbfba26$export$aaabe4eda9ed9969; }, function (v) { return $e3b06b3bfbbfba26$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e3b06b3bfbbfba26$export$e5c5a5f917a5871c; }, function (v) { return $e3b06b3bfbbfba26$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e3b06b3bfbbfba26$export$1538c33de8887b59; }, function (v) { return $e3b06b3bfbbfba26$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e3b06b3bfbbfba26$export$13e3392192263954; }, function (v) { return $e3b06b3bfbbfba26$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e3b06b3bfbbfba26$export$b8f5890fc79d6aca; }, function (v) { return $e3b06b3bfbbfba26$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e3b06b3bfbbfba26$export$60241385465d0a34; }, function (v) { return $e3b06b3bfbbfba26$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e3b06b3bfbbfba26$export$306c0aa65ff9ec16; }, function (v) { return $e3b06b3bfbbfba26$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e3b06b3bfbbfba26$export$7b286972b8d8ccbf; }, function (v) { return $e3b06b3bfbbfba26$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e3b06b3bfbbfba26$export$83d89fbfd8236492; }, function (v) { return $e3b06b3bfbbfba26$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e3b06b3bfbbfba26$export$dca3b0875bd9a954;
var $e3b06b3bfbbfba26$export$16fa2f45be04daa8;
var $e3b06b3bfbbfba26$export$ffb0004e005737fa;
var $e3b06b3bfbbfba26$export$e2c29f18771995cb;
var $e3b06b3bfbbfba26$export$221d75b3f55bb0bd;
var $e3b06b3bfbbfba26$export$5f8d39834fd61797;
var $e3b06b3bfbbfba26$export$74bf444e3cd11ea5;
var $e3b06b3bfbbfba26$export$ae55be85d98224ed;
var $e3b06b3bfbbfba26$export$3ba232387fd5d6dd;
var $e3b06b3bfbbfba26$export$e530037191fcd5d7;
var $e3b06b3bfbbfba26$export$fd42f52fd3ae1109;
var $e3b06b3bfbbfba26$export$c8a8987d4410bf2d;
var $e3b06b3bfbbfba26$export$d38cd72104c1f0e9;
var $e3b06b3bfbbfba26$export$7d1e3a5e95ceca43;
var $e3b06b3bfbbfba26$export$257a8862b851cb5b;
var $e3b06b3bfbbfba26$export$a8257692ac88316c;
var $e3b06b3bfbbfba26$export$488013bae63b21da;
var $e3b06b3bfbbfba26$export$7c73462e0d25e514;
var $e3b06b3bfbbfba26$export$7568632d0d33d16d;
var $e3b06b3bfbbfba26$export$88948ce120ea2619;
var $e3b06b3bfbbfba26$export$35808ee640e87ca7;
var $e3b06b3bfbbfba26$export$fae74005e78b1a27;
var $e3b06b3bfbbfba26$export$dc8fbce3eb94dc1e;
var $e3b06b3bfbbfba26$export$6a7bc4e911dc01cf;
var $e3b06b3bfbbfba26$export$6d9c69b0de29b591;
var $e3b06b3bfbbfba26$export$f680877a34711e37;
var $e3b06b3bfbbfba26$export$d5a552a76deda3c2;
var $e3b06b3bfbbfba26$export$aaabe4eda9ed9969;
var $e3b06b3bfbbfba26$export$e5c5a5f917a5871c;
var $e3b06b3bfbbfba26$export$1538c33de8887b59;
var $e3b06b3bfbbfba26$export$13e3392192263954;
var $e3b06b3bfbbfba26$export$b8f5890fc79d6aca;
var $e3b06b3bfbbfba26$export$60241385465d0a34;
var $e3b06b3bfbbfba26$export$306c0aa65ff9ec16;
var $e3b06b3bfbbfba26$export$7b286972b8d8ccbf;
var $e3b06b3bfbbfba26$export$83d89fbfd8236492;
'use strict';
var $e3b06b3bfbbfba26$var$l = Symbol.for("react.element"), $e3b06b3bfbbfba26$var$n = Symbol.for("react.portal"), $e3b06b3bfbbfba26$var$p = Symbol.for("react.fragment"), $e3b06b3bfbbfba26$var$q = Symbol.for("react.strict_mode"), $e3b06b3bfbbfba26$var$r = Symbol.for("react.profiler"), $e3b06b3bfbbfba26$var$t = Symbol.for("react.provider"), $e3b06b3bfbbfba26$var$u = Symbol.for("react.context"), $e3b06b3bfbbfba26$var$v = Symbol.for("react.forward_ref"), $e3b06b3bfbbfba26$var$w = Symbol.for("react.suspense"), $e3b06b3bfbbfba26$var$x = Symbol.for("react.memo"), $e3b06b3bfbbfba26$var$y = Symbol.for("react.lazy"), $e3b06b3bfbbfba26$var$z = Symbol.iterator;
function $e3b06b3bfbbfba26$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e3b06b3bfbbfba26$var$z && a[$e3b06b3bfbbfba26$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e3b06b3bfbbfba26$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e3b06b3bfbbfba26$var$C = Object.assign, $e3b06b3bfbbfba26$var$D = {};
function $e3b06b3bfbbfba26$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e3b06b3bfbbfba26$var$D;
    this.updater = e || $e3b06b3bfbbfba26$var$B;
}
$e3b06b3bfbbfba26$var$E.prototype.isReactComponent = {};
$e3b06b3bfbbfba26$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e3b06b3bfbbfba26$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e3b06b3bfbbfba26$var$F() {}
$e3b06b3bfbbfba26$var$F.prototype = $e3b06b3bfbbfba26$var$E.prototype;
function $e3b06b3bfbbfba26$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e3b06b3bfbbfba26$var$D;
    this.updater = e || $e3b06b3bfbbfba26$var$B;
}
var $e3b06b3bfbbfba26$var$H = $e3b06b3bfbbfba26$var$G.prototype = new $e3b06b3bfbbfba26$var$F;
$e3b06b3bfbbfba26$var$H.constructor = $e3b06b3bfbbfba26$var$G;
$e3b06b3bfbbfba26$var$C($e3b06b3bfbbfba26$var$H, $e3b06b3bfbbfba26$var$E.prototype);
$e3b06b3bfbbfba26$var$H.isPureReactComponent = !0;
var $e3b06b3bfbbfba26$var$I = Array.isArray, $e3b06b3bfbbfba26$var$J = Object.prototype.hasOwnProperty, $e3b06b3bfbbfba26$var$K = {
    current: null
}, $e3b06b3bfbbfba26$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e3b06b3bfbbfba26$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e3b06b3bfbbfba26$var$J.call(b, d) && !$e3b06b3bfbbfba26$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e3b06b3bfbbfba26$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e3b06b3bfbbfba26$var$K.current
    };
}
function $e3b06b3bfbbfba26$var$N(a, b) {
    return {
        $$typeof: $e3b06b3bfbbfba26$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e3b06b3bfbbfba26$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e3b06b3bfbbfba26$var$l;
}
function $e3b06b3bfbbfba26$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e3b06b3bfbbfba26$var$P = /\/+/g;
function $e3b06b3bfbbfba26$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e3b06b3bfbbfba26$var$escape("" + a.key) : b.toString(36);
}
function $e3b06b3bfbbfba26$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e3b06b3bfbbfba26$var$l:
                case $e3b06b3bfbbfba26$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e3b06b3bfbbfba26$var$Q(h, 0) : d, $e3b06b3bfbbfba26$var$I(c) ? (e = "", null != a && (e = a.replace($e3b06b3bfbbfba26$var$P, "$&/") + "/"), $e3b06b3bfbbfba26$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e3b06b3bfbbfba26$var$O(c) && (c = $e3b06b3bfbbfba26$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e3b06b3bfbbfba26$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e3b06b3bfbbfba26$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e3b06b3bfbbfba26$var$Q(k, g);
        h += $e3b06b3bfbbfba26$var$R(k, b, e, f, c);
    }
    else if (f = $e3b06b3bfbbfba26$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e3b06b3bfbbfba26$var$Q(k, g++), h += $e3b06b3bfbbfba26$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e3b06b3bfbbfba26$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e3b06b3bfbbfba26$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e3b06b3bfbbfba26$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e3b06b3bfbbfba26$var$U = {
    current: null
}, $e3b06b3bfbbfba26$var$V = {
    transition: null
}, $e3b06b3bfbbfba26$var$W = {
    ReactCurrentDispatcher: $e3b06b3bfbbfba26$var$U,
    ReactCurrentBatchConfig: $e3b06b3bfbbfba26$var$V,
    ReactCurrentOwner: $e3b06b3bfbbfba26$var$K
};
function $e3b06b3bfbbfba26$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e3b06b3bfbbfba26$export$dca3b0875bd9a954 = {
    map: $e3b06b3bfbbfba26$var$S,
    forEach: function(a, b, e) {
        $e3b06b3bfbbfba26$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e3b06b3bfbbfba26$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e3b06b3bfbbfba26$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e3b06b3bfbbfba26$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e3b06b3bfbbfba26$export$16fa2f45be04daa8 = $e3b06b3bfbbfba26$var$E;
$e3b06b3bfbbfba26$export$ffb0004e005737fa = $e3b06b3bfbbfba26$var$p;
$e3b06b3bfbbfba26$export$e2c29f18771995cb = $e3b06b3bfbbfba26$var$r;
$e3b06b3bfbbfba26$export$221d75b3f55bb0bd = $e3b06b3bfbbfba26$var$G;
$e3b06b3bfbbfba26$export$5f8d39834fd61797 = $e3b06b3bfbbfba26$var$q;
$e3b06b3bfbbfba26$export$74bf444e3cd11ea5 = $e3b06b3bfbbfba26$var$w;
$e3b06b3bfbbfba26$export$ae55be85d98224ed = $e3b06b3bfbbfba26$var$W;
$e3b06b3bfbbfba26$export$3ba232387fd5d6dd = $e3b06b3bfbbfba26$var$X;
$e3b06b3bfbbfba26$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e3b06b3bfbbfba26$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e3b06b3bfbbfba26$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e3b06b3bfbbfba26$var$J.call(b, f) && !$e3b06b3bfbbfba26$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e3b06b3bfbbfba26$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e3b06b3bfbbfba26$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e3b06b3bfbbfba26$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e3b06b3bfbbfba26$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e3b06b3bfbbfba26$export$c8a8987d4410bf2d = $e3b06b3bfbbfba26$var$M;
$e3b06b3bfbbfba26$export$d38cd72104c1f0e9 = function(a) {
    var b = $e3b06b3bfbbfba26$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e3b06b3bfbbfba26$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e3b06b3bfbbfba26$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e3b06b3bfbbfba26$var$v,
        render: a
    };
};
$e3b06b3bfbbfba26$export$a8257692ac88316c = $e3b06b3bfbbfba26$var$O;
$e3b06b3bfbbfba26$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e3b06b3bfbbfba26$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e3b06b3bfbbfba26$var$T
    };
};
$e3b06b3bfbbfba26$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e3b06b3bfbbfba26$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e3b06b3bfbbfba26$export$7568632d0d33d16d = function(a) {
    var b = $e3b06b3bfbbfba26$var$V.transition;
    $e3b06b3bfbbfba26$var$V.transition = {};
    try {
        a();
    } finally{
        $e3b06b3bfbbfba26$var$V.transition = b;
    }
};
$e3b06b3bfbbfba26$export$88948ce120ea2619 = $e3b06b3bfbbfba26$var$X;
$e3b06b3bfbbfba26$export$35808ee640e87ca7 = function(a, b) {
    return $e3b06b3bfbbfba26$var$U.current.useCallback(a, b);
};
$e3b06b3bfbbfba26$export$fae74005e78b1a27 = function(a) {
    return $e3b06b3bfbbfba26$var$U.current.useContext(a);
};
$e3b06b3bfbbfba26$export$dc8fbce3eb94dc1e = function() {};
$e3b06b3bfbbfba26$export$6a7bc4e911dc01cf = function(a) {
    return $e3b06b3bfbbfba26$var$U.current.useDeferredValue(a);
};
$e3b06b3bfbbfba26$export$6d9c69b0de29b591 = function(a, b) {
    return $e3b06b3bfbbfba26$var$U.current.useEffect(a, b);
};
$e3b06b3bfbbfba26$export$f680877a34711e37 = function() {
    return $e3b06b3bfbbfba26$var$U.current.useId();
};
$e3b06b3bfbbfba26$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e3b06b3bfbbfba26$var$U.current.useImperativeHandle(a, b, e);
};
$e3b06b3bfbbfba26$export$aaabe4eda9ed9969 = function(a, b) {
    return $e3b06b3bfbbfba26$var$U.current.useInsertionEffect(a, b);
};
$e3b06b3bfbbfba26$export$e5c5a5f917a5871c = function(a, b) {
    return $e3b06b3bfbbfba26$var$U.current.useLayoutEffect(a, b);
};
$e3b06b3bfbbfba26$export$1538c33de8887b59 = function(a, b) {
    return $e3b06b3bfbbfba26$var$U.current.useMemo(a, b);
};
$e3b06b3bfbbfba26$export$13e3392192263954 = function(a, b, e) {
    return $e3b06b3bfbbfba26$var$U.current.useReducer(a, b, e);
};
$e3b06b3bfbbfba26$export$b8f5890fc79d6aca = function(a) {
    return $e3b06b3bfbbfba26$var$U.current.useRef(a);
};
$e3b06b3bfbbfba26$export$60241385465d0a34 = function(a) {
    return $e3b06b3bfbbfba26$var$U.current.useState(a);
};
$e3b06b3bfbbfba26$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e3b06b3bfbbfba26$var$U.current.useSyncExternalStore(a, b, e);
};
$e3b06b3bfbbfba26$export$7b286972b8d8ccbf = function() {
    return $e3b06b3bfbbfba26$var$U.current.useTransition();
};
$e3b06b3bfbbfba26$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("yhhhl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $067094145dcc5355$var$parse;
module.exports.serialize = $067094145dcc5355$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $067094145dcc5355$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $067094145dcc5355$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $067094145dcc5355$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $067094145dcc5355$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $067094145dcc5355$var$__toString = Object.prototype.toString;
const $067094145dcc5355$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $067094145dcc5355$var$parse(str, options) {
    const obj = new $067094145dcc5355$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $067094145dcc5355$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $067094145dcc5355$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $067094145dcc5355$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $067094145dcc5355$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $067094145dcc5355$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $067094145dcc5355$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $067094145dcc5355$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $067094145dcc5355$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$067094145dcc5355$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$067094145dcc5355$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$067094145dcc5355$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$067094145dcc5355$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$067094145dcc5355$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $067094145dcc5355$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $067094145dcc5355$var$isDate(val) {
    return $067094145dcc5355$var$__toString.call(val) === "[object Date]";
}

});

parcelRegister("konOj", function(module, exports) {
$parcel$export(module.exports, "createRoot", function () { return $ed8884c7ac64e427$export$882461b6382ed46c; }, function (v) { return $ed8884c7ac64e427$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ed8884c7ac64e427$export$757ceba2d55c277e; }, function (v) { return $ed8884c7ac64e427$export$757ceba2d55c277e = v; });
var $ed8884c7ac64e427$export$882461b6382ed46c;
var $ed8884c7ac64e427$export$757ceba2d55c277e;
'use strict';

var $gUjjH = parcelRequire("gUjjH");
var $ed8884c7ac64e427$var$i;
$ed8884c7ac64e427$export$882461b6382ed46c = $gUjjH.createRoot;
$ed8884c7ac64e427$export$757ceba2d55c277e = $gUjjH.hydrateRoot;

});
parcelRegister("gUjjH", function(module, exports) {
'use strict';
function $c4f0dc2e8af10586$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c4f0dc2e8af10586$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c4f0dc2e8af10586$var$checkDCE();

module.exports = (parcelRequire("3k7v3"));

});
parcelRegister("3k7v3", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $26b90eb13321ae4f$export$ae55be85d98224ed; }, function (v) { return $26b90eb13321ae4f$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $26b90eb13321ae4f$export$d39a5bbd09211389; }, function (v) { return $26b90eb13321ae4f$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $26b90eb13321ae4f$export$882461b6382ed46c; }, function (v) { return $26b90eb13321ae4f$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $26b90eb13321ae4f$export$466bfc07425424d5; }, function (v) { return $26b90eb13321ae4f$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $26b90eb13321ae4f$export$cd75ccfd720a3cd4; }, function (v) { return $26b90eb13321ae4f$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $26b90eb13321ae4f$export$fa8d919ba61d84db; }, function (v) { return $26b90eb13321ae4f$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $26b90eb13321ae4f$export$757ceba2d55c277e; }, function (v) { return $26b90eb13321ae4f$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $26b90eb13321ae4f$export$b3890eb0ae9dca99; }, function (v) { return $26b90eb13321ae4f$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $26b90eb13321ae4f$export$502457920280e6be; }, function (v) { return $26b90eb13321ae4f$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $26b90eb13321ae4f$export$c78a37762a8d58e1; }, function (v) { return $26b90eb13321ae4f$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $26b90eb13321ae4f$export$dc54d992c10e8a18; }, function (v) { return $26b90eb13321ae4f$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $26b90eb13321ae4f$export$83d89fbfd8236492; }, function (v) { return $26b90eb13321ae4f$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $26b90eb13321ae4f$export$ae55be85d98224ed;
var $26b90eb13321ae4f$export$d39a5bbd09211389;
var $26b90eb13321ae4f$export$882461b6382ed46c;
var $26b90eb13321ae4f$export$466bfc07425424d5;
var $26b90eb13321ae4f$export$cd75ccfd720a3cd4;
var $26b90eb13321ae4f$export$fa8d919ba61d84db;
var $26b90eb13321ae4f$export$757ceba2d55c277e;
var $26b90eb13321ae4f$export$b3890eb0ae9dca99;
var $26b90eb13321ae4f$export$502457920280e6be;
var $26b90eb13321ae4f$export$c78a37762a8d58e1;
var $26b90eb13321ae4f$export$dc54d992c10e8a18;
var $26b90eb13321ae4f$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $1oC0p = parcelRequire("1oC0p");

var $gZKXT = parcelRequire("gZKXT");
function $26b90eb13321ae4f$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $26b90eb13321ae4f$var$da = new Set, $26b90eb13321ae4f$var$ea = {};
function $26b90eb13321ae4f$var$fa(a, b) {
    $26b90eb13321ae4f$var$ha(a, b);
    $26b90eb13321ae4f$var$ha(a + "Capture", b);
}
function $26b90eb13321ae4f$var$ha(a, b) {
    $26b90eb13321ae4f$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$26b90eb13321ae4f$var$da.add(b[a]);
}
var $26b90eb13321ae4f$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $26b90eb13321ae4f$var$ja = Object.prototype.hasOwnProperty, $26b90eb13321ae4f$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $26b90eb13321ae4f$var$la = {}, $26b90eb13321ae4f$var$ma = {};
function $26b90eb13321ae4f$var$na(a) {
    if ($26b90eb13321ae4f$var$ja.call($26b90eb13321ae4f$var$ma, a)) return !0;
    if ($26b90eb13321ae4f$var$ja.call($26b90eb13321ae4f$var$la, a)) return !1;
    if ($26b90eb13321ae4f$var$ka.test(a)) return $26b90eb13321ae4f$var$ma[a] = !0;
    $26b90eb13321ae4f$var$la[a] = !0;
    return !1;
}
function $26b90eb13321ae4f$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $26b90eb13321ae4f$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $26b90eb13321ae4f$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $26b90eb13321ae4f$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $26b90eb13321ae4f$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $26b90eb13321ae4f$var$t[b] = new $26b90eb13321ae4f$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $26b90eb13321ae4f$var$ra = /[\-:]([a-z])/g;
function $26b90eb13321ae4f$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($26b90eb13321ae4f$var$ra, $26b90eb13321ae4f$var$ta);
    $26b90eb13321ae4f$var$t[b] = new $26b90eb13321ae4f$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($26b90eb13321ae4f$var$ra, $26b90eb13321ae4f$var$ta);
    $26b90eb13321ae4f$var$t[b] = new $26b90eb13321ae4f$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($26b90eb13321ae4f$var$ra, $26b90eb13321ae4f$var$ta);
    $26b90eb13321ae4f$var$t[b] = new $26b90eb13321ae4f$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$26b90eb13321ae4f$var$t.xlinkHref = new $26b90eb13321ae4f$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $26b90eb13321ae4f$var$t[a] = new $26b90eb13321ae4f$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $26b90eb13321ae4f$var$ua(a, b, c, d) {
    var e = $26b90eb13321ae4f$var$t.hasOwnProperty(b) ? $26b90eb13321ae4f$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $26b90eb13321ae4f$var$pa(b, c, e, d) && (c = null), d || null === e ? $26b90eb13321ae4f$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $26b90eb13321ae4f$var$va = $1oC0p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $26b90eb13321ae4f$var$wa = Symbol.for("react.element"), $26b90eb13321ae4f$var$xa = Symbol.for("react.portal"), $26b90eb13321ae4f$var$ya = Symbol.for("react.fragment"), $26b90eb13321ae4f$var$za = Symbol.for("react.strict_mode"), $26b90eb13321ae4f$var$Aa = Symbol.for("react.profiler"), $26b90eb13321ae4f$var$Ba = Symbol.for("react.provider"), $26b90eb13321ae4f$var$Ca = Symbol.for("react.context"), $26b90eb13321ae4f$var$Da = Symbol.for("react.forward_ref"), $26b90eb13321ae4f$var$Ea = Symbol.for("react.suspense"), $26b90eb13321ae4f$var$Fa = Symbol.for("react.suspense_list"), $26b90eb13321ae4f$var$Ga = Symbol.for("react.memo"), $26b90eb13321ae4f$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $26b90eb13321ae4f$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $26b90eb13321ae4f$var$Ja = Symbol.iterator;
function $26b90eb13321ae4f$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $26b90eb13321ae4f$var$Ja && a[$26b90eb13321ae4f$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $26b90eb13321ae4f$var$u = Object.assign, $26b90eb13321ae4f$var$La;
function $26b90eb13321ae4f$var$Ma(a) {
    if (void 0 === $26b90eb13321ae4f$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $26b90eb13321ae4f$var$La = b && b[1] || "";
    }
    return "\n" + $26b90eb13321ae4f$var$La + a;
}
var $26b90eb13321ae4f$var$Na = !1;
function $26b90eb13321ae4f$var$Oa(a, b) {
    if (!a || $26b90eb13321ae4f$var$Na) return "";
    $26b90eb13321ae4f$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $26b90eb13321ae4f$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $26b90eb13321ae4f$var$Ma(a) : "";
}
function $26b90eb13321ae4f$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $26b90eb13321ae4f$var$Ma(a.type);
        case 16:
            return $26b90eb13321ae4f$var$Ma("Lazy");
        case 13:
            return $26b90eb13321ae4f$var$Ma("Suspense");
        case 19:
            return $26b90eb13321ae4f$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $26b90eb13321ae4f$var$Oa(a.type, !1), a;
        case 11:
            return a = $26b90eb13321ae4f$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $26b90eb13321ae4f$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $26b90eb13321ae4f$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $26b90eb13321ae4f$var$ya:
            return "Fragment";
        case $26b90eb13321ae4f$var$xa:
            return "Portal";
        case $26b90eb13321ae4f$var$Aa:
            return "Profiler";
        case $26b90eb13321ae4f$var$za:
            return "StrictMode";
        case $26b90eb13321ae4f$var$Ea:
            return "Suspense";
        case $26b90eb13321ae4f$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $26b90eb13321ae4f$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $26b90eb13321ae4f$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $26b90eb13321ae4f$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $26b90eb13321ae4f$var$Ga:
            return b = a.displayName || null, null !== b ? b : $26b90eb13321ae4f$var$Qa(a.type) || "Memo";
        case $26b90eb13321ae4f$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $26b90eb13321ae4f$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $26b90eb13321ae4f$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $26b90eb13321ae4f$var$Qa(b);
        case 8:
            return b === $26b90eb13321ae4f$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $26b90eb13321ae4f$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $26b90eb13321ae4f$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $26b90eb13321ae4f$var$Ua(a) {
    var b = $26b90eb13321ae4f$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $26b90eb13321ae4f$var$Va(a) {
    a._valueTracker || (a._valueTracker = $26b90eb13321ae4f$var$Ua(a));
}
function $26b90eb13321ae4f$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $26b90eb13321ae4f$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $26b90eb13321ae4f$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $26b90eb13321ae4f$var$Ya(a, b) {
    var c = b.checked;
    return $26b90eb13321ae4f$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $26b90eb13321ae4f$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $26b90eb13321ae4f$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $26b90eb13321ae4f$var$$a(a, b) {
    b = b.checked;
    null != b && $26b90eb13321ae4f$var$ua(a, "checked", b, !1);
}
function $26b90eb13321ae4f$var$ab(a, b) {
    $26b90eb13321ae4f$var$$a(a, b);
    var c = $26b90eb13321ae4f$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $26b90eb13321ae4f$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $26b90eb13321ae4f$var$bb(a, b.type, $26b90eb13321ae4f$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $26b90eb13321ae4f$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $26b90eb13321ae4f$var$bb(a, b, c) {
    if ("number" !== b || $26b90eb13321ae4f$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $26b90eb13321ae4f$var$db = Array.isArray;
function $26b90eb13321ae4f$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $26b90eb13321ae4f$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $26b90eb13321ae4f$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($26b90eb13321ae4f$var$p(91));
    return $26b90eb13321ae4f$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $26b90eb13321ae4f$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($26b90eb13321ae4f$var$p(92));
            if ($26b90eb13321ae4f$var$db(c)) {
                if (1 < c.length) throw Error($26b90eb13321ae4f$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $26b90eb13321ae4f$var$Sa(c)
    };
}
function $26b90eb13321ae4f$var$hb(a, b) {
    var c = $26b90eb13321ae4f$var$Sa(b.value), d = $26b90eb13321ae4f$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $26b90eb13321ae4f$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $26b90eb13321ae4f$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $26b90eb13321ae4f$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $26b90eb13321ae4f$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $26b90eb13321ae4f$var$mb, $26b90eb13321ae4f$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $26b90eb13321ae4f$var$mb = $26b90eb13321ae4f$var$mb || document.createElement("div");
        $26b90eb13321ae4f$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $26b90eb13321ae4f$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $26b90eb13321ae4f$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $26b90eb13321ae4f$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $26b90eb13321ae4f$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($26b90eb13321ae4f$var$pb).forEach(function(a) {
    $26b90eb13321ae4f$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $26b90eb13321ae4f$var$pb[b] = $26b90eb13321ae4f$var$pb[a];
    });
});
function $26b90eb13321ae4f$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $26b90eb13321ae4f$var$pb.hasOwnProperty(a) && $26b90eb13321ae4f$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $26b90eb13321ae4f$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $26b90eb13321ae4f$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $26b90eb13321ae4f$var$tb = $26b90eb13321ae4f$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $26b90eb13321ae4f$var$ub(a, b) {
    if (b) {
        if ($26b90eb13321ae4f$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($26b90eb13321ae4f$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($26b90eb13321ae4f$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($26b90eb13321ae4f$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($26b90eb13321ae4f$var$p(62));
    }
}
function $26b90eb13321ae4f$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $26b90eb13321ae4f$var$wb = null;
function $26b90eb13321ae4f$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $26b90eb13321ae4f$var$yb = null, $26b90eb13321ae4f$var$zb = null, $26b90eb13321ae4f$var$Ab = null;
function $26b90eb13321ae4f$var$Bb(a) {
    if (a = $26b90eb13321ae4f$var$Cb(a)) {
        if ("function" !== typeof $26b90eb13321ae4f$var$yb) throw Error($26b90eb13321ae4f$var$p(280));
        var b = a.stateNode;
        b && (b = $26b90eb13321ae4f$var$Db(b), $26b90eb13321ae4f$var$yb(a.stateNode, a.type, b));
    }
}
function $26b90eb13321ae4f$var$Eb(a) {
    $26b90eb13321ae4f$var$zb ? $26b90eb13321ae4f$var$Ab ? $26b90eb13321ae4f$var$Ab.push(a) : $26b90eb13321ae4f$var$Ab = [
        a
    ] : $26b90eb13321ae4f$var$zb = a;
}
function $26b90eb13321ae4f$var$Fb() {
    if ($26b90eb13321ae4f$var$zb) {
        var a = $26b90eb13321ae4f$var$zb, b = $26b90eb13321ae4f$var$Ab;
        $26b90eb13321ae4f$var$Ab = $26b90eb13321ae4f$var$zb = null;
        $26b90eb13321ae4f$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$26b90eb13321ae4f$var$Bb(b[a]);
    }
}
function $26b90eb13321ae4f$var$Gb(a, b) {
    return a(b);
}
function $26b90eb13321ae4f$var$Hb() {}
var $26b90eb13321ae4f$var$Ib = !1;
function $26b90eb13321ae4f$var$Jb(a, b, c) {
    if ($26b90eb13321ae4f$var$Ib) return a(b, c);
    $26b90eb13321ae4f$var$Ib = !0;
    try {
        return $26b90eb13321ae4f$var$Gb(a, b, c);
    } finally{
        if ($26b90eb13321ae4f$var$Ib = !1, null !== $26b90eb13321ae4f$var$zb || null !== $26b90eb13321ae4f$var$Ab) $26b90eb13321ae4f$var$Hb(), $26b90eb13321ae4f$var$Fb();
    }
}
function $26b90eb13321ae4f$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $26b90eb13321ae4f$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($26b90eb13321ae4f$var$p(231, b, typeof c));
    return c;
}
var $26b90eb13321ae4f$var$Lb = !1;
if ($26b90eb13321ae4f$var$ia) try {
    var $26b90eb13321ae4f$var$Mb = {};
    Object.defineProperty($26b90eb13321ae4f$var$Mb, "passive", {
        get: function() {
            $26b90eb13321ae4f$var$Lb = !0;
        }
    });
    window.addEventListener("test", $26b90eb13321ae4f$var$Mb, $26b90eb13321ae4f$var$Mb);
    window.removeEventListener("test", $26b90eb13321ae4f$var$Mb, $26b90eb13321ae4f$var$Mb);
} catch (a) {
    $26b90eb13321ae4f$var$Lb = !1;
}
function $26b90eb13321ae4f$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $26b90eb13321ae4f$var$Ob = !1, $26b90eb13321ae4f$var$Pb = null, $26b90eb13321ae4f$var$Qb = !1, $26b90eb13321ae4f$var$Rb = null, $26b90eb13321ae4f$var$Sb = {
    onError: function(a) {
        $26b90eb13321ae4f$var$Ob = !0;
        $26b90eb13321ae4f$var$Pb = a;
    }
};
function $26b90eb13321ae4f$var$Tb(a, b, c, d, e, f, g, h, k) {
    $26b90eb13321ae4f$var$Ob = !1;
    $26b90eb13321ae4f$var$Pb = null;
    $26b90eb13321ae4f$var$Nb.apply($26b90eb13321ae4f$var$Sb, arguments);
}
function $26b90eb13321ae4f$var$Ub(a, b, c, d, e, f, g, h, k) {
    $26b90eb13321ae4f$var$Tb.apply(this, arguments);
    if ($26b90eb13321ae4f$var$Ob) {
        if ($26b90eb13321ae4f$var$Ob) {
            var l = $26b90eb13321ae4f$var$Pb;
            $26b90eb13321ae4f$var$Ob = !1;
            $26b90eb13321ae4f$var$Pb = null;
        } else throw Error($26b90eb13321ae4f$var$p(198));
        $26b90eb13321ae4f$var$Qb || ($26b90eb13321ae4f$var$Qb = !0, $26b90eb13321ae4f$var$Rb = l);
    }
}
function $26b90eb13321ae4f$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $26b90eb13321ae4f$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $26b90eb13321ae4f$var$Xb(a) {
    if ($26b90eb13321ae4f$var$Vb(a) !== a) throw Error($26b90eb13321ae4f$var$p(188));
}
function $26b90eb13321ae4f$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $26b90eb13321ae4f$var$Vb(a);
        if (null === b) throw Error($26b90eb13321ae4f$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $26b90eb13321ae4f$var$Xb(e), a;
                if (f === d) return $26b90eb13321ae4f$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($26b90eb13321ae4f$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($26b90eb13321ae4f$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($26b90eb13321ae4f$var$p(190));
    }
    if (3 !== c.tag) throw Error($26b90eb13321ae4f$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $26b90eb13321ae4f$var$Zb(a) {
    a = $26b90eb13321ae4f$var$Yb(a);
    return null !== a ? $26b90eb13321ae4f$var$$b(a) : null;
}
function $26b90eb13321ae4f$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $26b90eb13321ae4f$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $26b90eb13321ae4f$var$ac = $gZKXT.unstable_scheduleCallback, $26b90eb13321ae4f$var$bc = $gZKXT.unstable_cancelCallback, $26b90eb13321ae4f$var$cc = $gZKXT.unstable_shouldYield, $26b90eb13321ae4f$var$dc = $gZKXT.unstable_requestPaint, $26b90eb13321ae4f$var$A = $gZKXT.unstable_now, $26b90eb13321ae4f$var$ec = $gZKXT.unstable_getCurrentPriorityLevel, $26b90eb13321ae4f$var$fc = $gZKXT.unstable_ImmediatePriority, $26b90eb13321ae4f$var$gc = $gZKXT.unstable_UserBlockingPriority, $26b90eb13321ae4f$var$hc = $gZKXT.unstable_NormalPriority, $26b90eb13321ae4f$var$ic = $gZKXT.unstable_LowPriority, $26b90eb13321ae4f$var$jc = $gZKXT.unstable_IdlePriority, $26b90eb13321ae4f$var$kc = null, $26b90eb13321ae4f$var$lc = null, $26b90eb13321ae4f$var$B = null, $26b90eb13321ae4f$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $26b90eb13321ae4f$var$nc(a, b) {
    if ($26b90eb13321ae4f$var$lc && "function" === typeof $26b90eb13321ae4f$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $26b90eb13321ae4f$var$fc;
                break;
            case 4:
                d = $26b90eb13321ae4f$var$gc;
                break;
            case 16:
                d = $26b90eb13321ae4f$var$hc;
                break;
            case 536870912:
                d = $26b90eb13321ae4f$var$jc;
                break;
            default:
                d = $26b90eb13321ae4f$var$hc;
        }
        $26b90eb13321ae4f$var$lc.onCommitFiberRoot($26b90eb13321ae4f$var$kc, a, d, c);
    } catch (e) {}
}
function $26b90eb13321ae4f$var$oc(a) {
    $26b90eb13321ae4f$var$B = a;
}
function $26b90eb13321ae4f$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $26b90eb13321ae4f$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $26b90eb13321ae4f$var$rc() {
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markCommitStopped && $26b90eb13321ae4f$var$B.markCommitStopped();
}
function $26b90eb13321ae4f$var$sc(a) {
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentRenderStarted && $26b90eb13321ae4f$var$B.markComponentRenderStarted(a);
}
function $26b90eb13321ae4f$var$tc() {
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentRenderStopped && $26b90eb13321ae4f$var$B.markComponentRenderStopped();
}
function $26b90eb13321ae4f$var$uc(a) {
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentLayoutEffectUnmountStarted && $26b90eb13321ae4f$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $26b90eb13321ae4f$var$vc() {
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentLayoutEffectUnmountStopped && $26b90eb13321ae4f$var$B.markComponentLayoutEffectUnmountStopped();
}
function $26b90eb13321ae4f$var$wc(a) {
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markRenderStarted && $26b90eb13321ae4f$var$B.markRenderStarted(a);
}
function $26b90eb13321ae4f$var$xc() {
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markRenderStopped && $26b90eb13321ae4f$var$B.markRenderStopped();
}
function $26b90eb13321ae4f$var$yc(a, b) {
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markStateUpdateScheduled && $26b90eb13321ae4f$var$B.markStateUpdateScheduled(a, b);
}
var $26b90eb13321ae4f$var$Ac = Math.clz32 ? Math.clz32 : $26b90eb13321ae4f$var$zc, $26b90eb13321ae4f$var$Bc = Math.log, $26b90eb13321ae4f$var$Cc = Math.LN2;
function $26b90eb13321ae4f$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($26b90eb13321ae4f$var$Bc(a) / $26b90eb13321ae4f$var$Cc | 0) | 0;
}
function $26b90eb13321ae4f$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $26b90eb13321ae4f$var$Dc = 64, $26b90eb13321ae4f$var$Ec = 4194304;
function $26b90eb13321ae4f$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $26b90eb13321ae4f$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $26b90eb13321ae4f$var$Fc(h) : (f &= g, 0 !== f && (d = $26b90eb13321ae4f$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $26b90eb13321ae4f$var$Fc(g) : 0 !== f && (d = $26b90eb13321ae4f$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $26b90eb13321ae4f$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $26b90eb13321ae4f$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $26b90eb13321ae4f$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $26b90eb13321ae4f$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $26b90eb13321ae4f$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $26b90eb13321ae4f$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $26b90eb13321ae4f$var$Kc() {
    var a = $26b90eb13321ae4f$var$Dc;
    $26b90eb13321ae4f$var$Dc <<= 1;
    0 === ($26b90eb13321ae4f$var$Dc & 4194240) && ($26b90eb13321ae4f$var$Dc = 64);
    return a;
}
function $26b90eb13321ae4f$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $26b90eb13321ae4f$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $26b90eb13321ae4f$var$Ac(b);
    a[b] = c;
}
function $26b90eb13321ae4f$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $26b90eb13321ae4f$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $26b90eb13321ae4f$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $26b90eb13321ae4f$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $26b90eb13321ae4f$var$Pc(a, b, c) {
    if ($26b90eb13321ae4f$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $26b90eb13321ae4f$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $26b90eb13321ae4f$var$Qc(a, b) {
    if ($26b90eb13321ae4f$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $26b90eb13321ae4f$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $26b90eb13321ae4f$var$E = 0;
function $26b90eb13321ae4f$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $26b90eb13321ae4f$var$Sc, $26b90eb13321ae4f$var$Tc, $26b90eb13321ae4f$var$Uc, $26b90eb13321ae4f$var$Vc, $26b90eb13321ae4f$var$Wc, $26b90eb13321ae4f$var$Xc = !1, $26b90eb13321ae4f$var$Yc = [], $26b90eb13321ae4f$var$Zc = null, $26b90eb13321ae4f$var$$c = null, $26b90eb13321ae4f$var$ad = null, $26b90eb13321ae4f$var$bd = new Map, $26b90eb13321ae4f$var$cd = new Map, $26b90eb13321ae4f$var$dd = [], $26b90eb13321ae4f$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $26b90eb13321ae4f$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $26b90eb13321ae4f$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $26b90eb13321ae4f$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $26b90eb13321ae4f$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $26b90eb13321ae4f$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $26b90eb13321ae4f$var$cd.delete(b.pointerId);
    }
}
function $26b90eb13321ae4f$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $26b90eb13321ae4f$var$Cb(b), null !== b && $26b90eb13321ae4f$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $26b90eb13321ae4f$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $26b90eb13321ae4f$var$Zc = $26b90eb13321ae4f$var$gd($26b90eb13321ae4f$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $26b90eb13321ae4f$var$$c = $26b90eb13321ae4f$var$gd($26b90eb13321ae4f$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $26b90eb13321ae4f$var$ad = $26b90eb13321ae4f$var$gd($26b90eb13321ae4f$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $26b90eb13321ae4f$var$bd.set(f, $26b90eb13321ae4f$var$gd($26b90eb13321ae4f$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $26b90eb13321ae4f$var$cd.set(f, $26b90eb13321ae4f$var$gd($26b90eb13321ae4f$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $26b90eb13321ae4f$var$id(a) {
    var b = $26b90eb13321ae4f$var$jd(a.target);
    if (null !== b) {
        var c = $26b90eb13321ae4f$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $26b90eb13321ae4f$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $26b90eb13321ae4f$var$Wc(a.priority, function() {
                        $26b90eb13321ae4f$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $26b90eb13321ae4f$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $26b90eb13321ae4f$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $26b90eb13321ae4f$var$wb = d;
            c.target.dispatchEvent(d);
            $26b90eb13321ae4f$var$wb = null;
        } else return b = $26b90eb13321ae4f$var$Cb(c), null !== b && $26b90eb13321ae4f$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $26b90eb13321ae4f$var$md(a, b, c) {
    $26b90eb13321ae4f$var$kd(a) && c.delete(b);
}
function $26b90eb13321ae4f$var$nd() {
    $26b90eb13321ae4f$var$Xc = !1;
    null !== $26b90eb13321ae4f$var$Zc && $26b90eb13321ae4f$var$kd($26b90eb13321ae4f$var$Zc) && ($26b90eb13321ae4f$var$Zc = null);
    null !== $26b90eb13321ae4f$var$$c && $26b90eb13321ae4f$var$kd($26b90eb13321ae4f$var$$c) && ($26b90eb13321ae4f$var$$c = null);
    null !== $26b90eb13321ae4f$var$ad && $26b90eb13321ae4f$var$kd($26b90eb13321ae4f$var$ad) && ($26b90eb13321ae4f$var$ad = null);
    $26b90eb13321ae4f$var$bd.forEach($26b90eb13321ae4f$var$md);
    $26b90eb13321ae4f$var$cd.forEach($26b90eb13321ae4f$var$md);
}
function $26b90eb13321ae4f$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $26b90eb13321ae4f$var$Xc || ($26b90eb13321ae4f$var$Xc = !0, $gZKXT.unstable_scheduleCallback($gZKXT.unstable_NormalPriority, $26b90eb13321ae4f$var$nd)));
}
function $26b90eb13321ae4f$var$pd(a) {
    function b(b) {
        return $26b90eb13321ae4f$var$od(b, a);
    }
    if (0 < $26b90eb13321ae4f$var$Yc.length) {
        $26b90eb13321ae4f$var$od($26b90eb13321ae4f$var$Yc[0], a);
        for(var c = 1; c < $26b90eb13321ae4f$var$Yc.length; c++){
            var d = $26b90eb13321ae4f$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $26b90eb13321ae4f$var$Zc && $26b90eb13321ae4f$var$od($26b90eb13321ae4f$var$Zc, a);
    null !== $26b90eb13321ae4f$var$$c && $26b90eb13321ae4f$var$od($26b90eb13321ae4f$var$$c, a);
    null !== $26b90eb13321ae4f$var$ad && $26b90eb13321ae4f$var$od($26b90eb13321ae4f$var$ad, a);
    $26b90eb13321ae4f$var$bd.forEach(b);
    $26b90eb13321ae4f$var$cd.forEach(b);
    for(c = 0; c < $26b90eb13321ae4f$var$dd.length; c++)d = $26b90eb13321ae4f$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $26b90eb13321ae4f$var$dd.length && (c = $26b90eb13321ae4f$var$dd[0], null === c.blockedOn);)$26b90eb13321ae4f$var$id(c), null === c.blockedOn && $26b90eb13321ae4f$var$dd.shift();
}
var $26b90eb13321ae4f$var$qd = $26b90eb13321ae4f$var$va.ReactCurrentBatchConfig, $26b90eb13321ae4f$var$rd = !0;
function $26b90eb13321ae4f$var$sd(a, b, c, d) {
    var e = $26b90eb13321ae4f$var$E, f = $26b90eb13321ae4f$var$qd.transition;
    $26b90eb13321ae4f$var$qd.transition = null;
    try {
        $26b90eb13321ae4f$var$E = 1, $26b90eb13321ae4f$var$td(a, b, c, d);
    } finally{
        $26b90eb13321ae4f$var$E = e, $26b90eb13321ae4f$var$qd.transition = f;
    }
}
function $26b90eb13321ae4f$var$ud(a, b, c, d) {
    var e = $26b90eb13321ae4f$var$E, f = $26b90eb13321ae4f$var$qd.transition;
    $26b90eb13321ae4f$var$qd.transition = null;
    try {
        $26b90eb13321ae4f$var$E = 4, $26b90eb13321ae4f$var$td(a, b, c, d);
    } finally{
        $26b90eb13321ae4f$var$E = e, $26b90eb13321ae4f$var$qd.transition = f;
    }
}
function $26b90eb13321ae4f$var$td(a, b, c, d) {
    if ($26b90eb13321ae4f$var$rd) {
        var e = $26b90eb13321ae4f$var$ld(a, b, c, d);
        if (null === e) $26b90eb13321ae4f$var$vd(a, b, d, $26b90eb13321ae4f$var$wd, c), $26b90eb13321ae4f$var$fd(a, d);
        else if ($26b90eb13321ae4f$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($26b90eb13321ae4f$var$fd(a, d), b & 4 && -1 < $26b90eb13321ae4f$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $26b90eb13321ae4f$var$Cb(e);
                null !== f && $26b90eb13321ae4f$var$Sc(f);
                f = $26b90eb13321ae4f$var$ld(a, b, c, d);
                null === f && $26b90eb13321ae4f$var$vd(a, b, d, $26b90eb13321ae4f$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $26b90eb13321ae4f$var$vd(a, b, d, null, c);
    }
}
var $26b90eb13321ae4f$var$wd = null;
function $26b90eb13321ae4f$var$ld(a, b, c, d) {
    $26b90eb13321ae4f$var$wd = null;
    a = $26b90eb13321ae4f$var$xb(d);
    a = $26b90eb13321ae4f$var$jd(a);
    if (null !== a) {
        if (b = $26b90eb13321ae4f$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $26b90eb13321ae4f$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $26b90eb13321ae4f$var$wd = a;
    return null;
}
function $26b90eb13321ae4f$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($26b90eb13321ae4f$var$ec()){
                case $26b90eb13321ae4f$var$fc:
                    return 1;
                case $26b90eb13321ae4f$var$gc:
                    return 4;
                case $26b90eb13321ae4f$var$hc:
                case $26b90eb13321ae4f$var$ic:
                    return 16;
                case $26b90eb13321ae4f$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $26b90eb13321ae4f$var$yd = null, $26b90eb13321ae4f$var$zd = null, $26b90eb13321ae4f$var$Ad = null;
function $26b90eb13321ae4f$var$Bd() {
    if ($26b90eb13321ae4f$var$Ad) return $26b90eb13321ae4f$var$Ad;
    var a, b = $26b90eb13321ae4f$var$zd, c = b.length, d, e = "value" in $26b90eb13321ae4f$var$yd ? $26b90eb13321ae4f$var$yd.value : $26b90eb13321ae4f$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $26b90eb13321ae4f$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $26b90eb13321ae4f$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $26b90eb13321ae4f$var$Dd() {
    return !0;
}
function $26b90eb13321ae4f$var$Ed() {
    return !1;
}
function $26b90eb13321ae4f$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $26b90eb13321ae4f$var$Dd : $26b90eb13321ae4f$var$Ed;
        this.isPropagationStopped = $26b90eb13321ae4f$var$Ed;
        return this;
    }
    $26b90eb13321ae4f$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $26b90eb13321ae4f$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $26b90eb13321ae4f$var$Dd);
        },
        persist: function() {},
        isPersistent: $26b90eb13321ae4f$var$Dd
    });
    return b;
}
var $26b90eb13321ae4f$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $26b90eb13321ae4f$var$Hd = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$Gd), $26b90eb13321ae4f$var$Id = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Gd, {
    view: 0,
    detail: 0
}), $26b90eb13321ae4f$var$Jd = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$Id), $26b90eb13321ae4f$var$Kd, $26b90eb13321ae4f$var$Ld, $26b90eb13321ae4f$var$Md, $26b90eb13321ae4f$var$Od = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $26b90eb13321ae4f$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $26b90eb13321ae4f$var$Md && ($26b90eb13321ae4f$var$Md && "mousemove" === a.type ? ($26b90eb13321ae4f$var$Kd = a.screenX - $26b90eb13321ae4f$var$Md.screenX, $26b90eb13321ae4f$var$Ld = a.screenY - $26b90eb13321ae4f$var$Md.screenY) : $26b90eb13321ae4f$var$Ld = $26b90eb13321ae4f$var$Kd = 0, $26b90eb13321ae4f$var$Md = a);
        return $26b90eb13321ae4f$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $26b90eb13321ae4f$var$Ld;
    }
}), $26b90eb13321ae4f$var$Pd = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$Od), $26b90eb13321ae4f$var$Qd = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Od, {
    dataTransfer: 0
}), $26b90eb13321ae4f$var$Rd = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$Qd), $26b90eb13321ae4f$var$Sd = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Id, {
    relatedTarget: 0
}), $26b90eb13321ae4f$var$Td = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$Sd), $26b90eb13321ae4f$var$Ud = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $26b90eb13321ae4f$var$Vd = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$Ud), $26b90eb13321ae4f$var$Wd = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $26b90eb13321ae4f$var$Xd = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$Wd), $26b90eb13321ae4f$var$Yd = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Gd, {
    data: 0
}), $26b90eb13321ae4f$var$Zd = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$Yd), $26b90eb13321ae4f$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $26b90eb13321ae4f$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $26b90eb13321ae4f$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $26b90eb13321ae4f$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $26b90eb13321ae4f$var$be[a]) ? !!b[a] : !1;
}
function $26b90eb13321ae4f$var$Nd() {
    return $26b90eb13321ae4f$var$ce;
}
var $26b90eb13321ae4f$var$de = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $26b90eb13321ae4f$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $26b90eb13321ae4f$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $26b90eb13321ae4f$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $26b90eb13321ae4f$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $26b90eb13321ae4f$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $26b90eb13321ae4f$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $26b90eb13321ae4f$var$ee = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$de), $26b90eb13321ae4f$var$fe = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $26b90eb13321ae4f$var$ge = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$fe), $26b90eb13321ae4f$var$he = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $26b90eb13321ae4f$var$Nd
}), $26b90eb13321ae4f$var$ie = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$he), $26b90eb13321ae4f$var$je = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $26b90eb13321ae4f$var$ke = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$je), $26b90eb13321ae4f$var$le = $26b90eb13321ae4f$var$u({}, $26b90eb13321ae4f$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $26b90eb13321ae4f$var$me = $26b90eb13321ae4f$var$Fd($26b90eb13321ae4f$var$le), $26b90eb13321ae4f$var$ne = [
    9,
    13,
    27,
    32
], $26b90eb13321ae4f$var$oe = $26b90eb13321ae4f$var$ia && "CompositionEvent" in window, $26b90eb13321ae4f$var$pe = null;
$26b90eb13321ae4f$var$ia && "documentMode" in document && ($26b90eb13321ae4f$var$pe = document.documentMode);
var $26b90eb13321ae4f$var$qe = $26b90eb13321ae4f$var$ia && "TextEvent" in window && !$26b90eb13321ae4f$var$pe, $26b90eb13321ae4f$var$re = $26b90eb13321ae4f$var$ia && (!$26b90eb13321ae4f$var$oe || $26b90eb13321ae4f$var$pe && 8 < $26b90eb13321ae4f$var$pe && 11 >= $26b90eb13321ae4f$var$pe), $26b90eb13321ae4f$var$se = String.fromCharCode(32), $26b90eb13321ae4f$var$te = !1;
function $26b90eb13321ae4f$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $26b90eb13321ae4f$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $26b90eb13321ae4f$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $26b90eb13321ae4f$var$we = !1;
function $26b90eb13321ae4f$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $26b90eb13321ae4f$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $26b90eb13321ae4f$var$te = !0;
            return $26b90eb13321ae4f$var$se;
        case "textInput":
            return a = b.data, a === $26b90eb13321ae4f$var$se && $26b90eb13321ae4f$var$te ? null : a;
        default:
            return null;
    }
}
function $26b90eb13321ae4f$var$ye(a, b) {
    if ($26b90eb13321ae4f$var$we) return "compositionend" === a || !$26b90eb13321ae4f$var$oe && $26b90eb13321ae4f$var$ue(a, b) ? (a = $26b90eb13321ae4f$var$Bd(), $26b90eb13321ae4f$var$Ad = $26b90eb13321ae4f$var$zd = $26b90eb13321ae4f$var$yd = null, $26b90eb13321ae4f$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $26b90eb13321ae4f$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $26b90eb13321ae4f$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $26b90eb13321ae4f$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$26b90eb13321ae4f$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $26b90eb13321ae4f$var$Be(a, b, c, d) {
    $26b90eb13321ae4f$var$Eb(d);
    b = $26b90eb13321ae4f$var$Ce(b, "onChange");
    0 < b.length && (c = new $26b90eb13321ae4f$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $26b90eb13321ae4f$var$De = null, $26b90eb13321ae4f$var$Ee = null;
function $26b90eb13321ae4f$var$Fe(a) {
    $26b90eb13321ae4f$var$Ge(a, 0);
}
function $26b90eb13321ae4f$var$He(a) {
    var b = $26b90eb13321ae4f$var$Ie(a);
    if ($26b90eb13321ae4f$var$Wa(b)) return a;
}
function $26b90eb13321ae4f$var$Je(a, b) {
    if ("change" === a) return b;
}
var $26b90eb13321ae4f$var$Ke = !1;
if ($26b90eb13321ae4f$var$ia) {
    var $26b90eb13321ae4f$var$Le;
    if ($26b90eb13321ae4f$var$ia) {
        var $26b90eb13321ae4f$var$Me = "oninput" in document;
        if (!$26b90eb13321ae4f$var$Me) {
            var $26b90eb13321ae4f$var$Ne = document.createElement("div");
            $26b90eb13321ae4f$var$Ne.setAttribute("oninput", "return;");
            $26b90eb13321ae4f$var$Me = "function" === typeof $26b90eb13321ae4f$var$Ne.oninput;
        }
        $26b90eb13321ae4f$var$Le = $26b90eb13321ae4f$var$Me;
    } else $26b90eb13321ae4f$var$Le = !1;
    $26b90eb13321ae4f$var$Ke = $26b90eb13321ae4f$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $26b90eb13321ae4f$var$Oe() {
    $26b90eb13321ae4f$var$De && ($26b90eb13321ae4f$var$De.detachEvent("onpropertychange", $26b90eb13321ae4f$var$Pe), $26b90eb13321ae4f$var$Ee = $26b90eb13321ae4f$var$De = null);
}
function $26b90eb13321ae4f$var$Pe(a) {
    if ("value" === a.propertyName && $26b90eb13321ae4f$var$He($26b90eb13321ae4f$var$Ee)) {
        var b = [];
        $26b90eb13321ae4f$var$Be(b, $26b90eb13321ae4f$var$Ee, a, $26b90eb13321ae4f$var$xb(a));
        $26b90eb13321ae4f$var$Jb($26b90eb13321ae4f$var$Fe, b);
    }
}
function $26b90eb13321ae4f$var$Qe(a, b, c) {
    "focusin" === a ? ($26b90eb13321ae4f$var$Oe(), $26b90eb13321ae4f$var$De = b, $26b90eb13321ae4f$var$Ee = c, $26b90eb13321ae4f$var$De.attachEvent("onpropertychange", $26b90eb13321ae4f$var$Pe)) : "focusout" === a && $26b90eb13321ae4f$var$Oe();
}
function $26b90eb13321ae4f$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $26b90eb13321ae4f$var$He($26b90eb13321ae4f$var$Ee);
}
function $26b90eb13321ae4f$var$Se(a, b) {
    if ("click" === a) return $26b90eb13321ae4f$var$He(b);
}
function $26b90eb13321ae4f$var$Te(a, b) {
    if ("input" === a || "change" === a) return $26b90eb13321ae4f$var$He(b);
}
function $26b90eb13321ae4f$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $26b90eb13321ae4f$var$Ve = "function" === typeof Object.is ? Object.is : $26b90eb13321ae4f$var$Ue;
function $26b90eb13321ae4f$var$We(a, b) {
    if ($26b90eb13321ae4f$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$26b90eb13321ae4f$var$ja.call(b, e) || !$26b90eb13321ae4f$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $26b90eb13321ae4f$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $26b90eb13321ae4f$var$Ye(a, b) {
    var c = $26b90eb13321ae4f$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $26b90eb13321ae4f$var$Xe(c);
    }
}
function $26b90eb13321ae4f$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $26b90eb13321ae4f$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $26b90eb13321ae4f$var$$e() {
    for(var a = window, b = $26b90eb13321ae4f$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $26b90eb13321ae4f$var$Xa(a.document);
    }
    return b;
}
function $26b90eb13321ae4f$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $26b90eb13321ae4f$var$bf(a) {
    var b = $26b90eb13321ae4f$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $26b90eb13321ae4f$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $26b90eb13321ae4f$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $26b90eb13321ae4f$var$Ye(c, f);
                var g = $26b90eb13321ae4f$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $26b90eb13321ae4f$var$cf = $26b90eb13321ae4f$var$ia && "documentMode" in document && 11 >= document.documentMode, $26b90eb13321ae4f$var$df = null, $26b90eb13321ae4f$var$ef = null, $26b90eb13321ae4f$var$ff = null, $26b90eb13321ae4f$var$gf = !1;
function $26b90eb13321ae4f$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $26b90eb13321ae4f$var$gf || null == $26b90eb13321ae4f$var$df || $26b90eb13321ae4f$var$df !== $26b90eb13321ae4f$var$Xa(d) || (d = $26b90eb13321ae4f$var$df, "selectionStart" in d && $26b90eb13321ae4f$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $26b90eb13321ae4f$var$ff && $26b90eb13321ae4f$var$We($26b90eb13321ae4f$var$ff, d) || ($26b90eb13321ae4f$var$ff = d, d = $26b90eb13321ae4f$var$Ce($26b90eb13321ae4f$var$ef, "onSelect"), 0 < d.length && (b = new $26b90eb13321ae4f$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $26b90eb13321ae4f$var$df)));
}
function $26b90eb13321ae4f$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $26b90eb13321ae4f$var$kf = {
    animationend: $26b90eb13321ae4f$var$jf("Animation", "AnimationEnd"),
    animationiteration: $26b90eb13321ae4f$var$jf("Animation", "AnimationIteration"),
    animationstart: $26b90eb13321ae4f$var$jf("Animation", "AnimationStart"),
    transitionend: $26b90eb13321ae4f$var$jf("Transition", "TransitionEnd")
}, $26b90eb13321ae4f$var$lf = {}, $26b90eb13321ae4f$var$mf = {};
$26b90eb13321ae4f$var$ia && ($26b90eb13321ae4f$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $26b90eb13321ae4f$var$kf.animationend.animation, delete $26b90eb13321ae4f$var$kf.animationiteration.animation, delete $26b90eb13321ae4f$var$kf.animationstart.animation), "TransitionEvent" in window || delete $26b90eb13321ae4f$var$kf.transitionend.transition);
function $26b90eb13321ae4f$var$nf(a) {
    if ($26b90eb13321ae4f$var$lf[a]) return $26b90eb13321ae4f$var$lf[a];
    if (!$26b90eb13321ae4f$var$kf[a]) return a;
    var b = $26b90eb13321ae4f$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $26b90eb13321ae4f$var$mf) return $26b90eb13321ae4f$var$lf[a] = b[c];
    return a;
}
var $26b90eb13321ae4f$var$of = $26b90eb13321ae4f$var$nf("animationend"), $26b90eb13321ae4f$var$pf = $26b90eb13321ae4f$var$nf("animationiteration"), $26b90eb13321ae4f$var$qf = $26b90eb13321ae4f$var$nf("animationstart"), $26b90eb13321ae4f$var$rf = $26b90eb13321ae4f$var$nf("transitionend"), $26b90eb13321ae4f$var$sf = new Map, $26b90eb13321ae4f$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $26b90eb13321ae4f$var$uf(a, b) {
    $26b90eb13321ae4f$var$sf.set(a, b);
    $26b90eb13321ae4f$var$fa(b, [
        a
    ]);
}
for(var $26b90eb13321ae4f$var$vf = 0; $26b90eb13321ae4f$var$vf < $26b90eb13321ae4f$var$tf.length; $26b90eb13321ae4f$var$vf++){
    var $26b90eb13321ae4f$var$wf = $26b90eb13321ae4f$var$tf[$26b90eb13321ae4f$var$vf], $26b90eb13321ae4f$var$xf = $26b90eb13321ae4f$var$wf.toLowerCase(), $26b90eb13321ae4f$var$yf = $26b90eb13321ae4f$var$wf[0].toUpperCase() + $26b90eb13321ae4f$var$wf.slice(1);
    $26b90eb13321ae4f$var$uf($26b90eb13321ae4f$var$xf, "on" + $26b90eb13321ae4f$var$yf);
}
$26b90eb13321ae4f$var$uf($26b90eb13321ae4f$var$of, "onAnimationEnd");
$26b90eb13321ae4f$var$uf($26b90eb13321ae4f$var$pf, "onAnimationIteration");
$26b90eb13321ae4f$var$uf($26b90eb13321ae4f$var$qf, "onAnimationStart");
$26b90eb13321ae4f$var$uf("dblclick", "onDoubleClick");
$26b90eb13321ae4f$var$uf("focusin", "onFocus");
$26b90eb13321ae4f$var$uf("focusout", "onBlur");
$26b90eb13321ae4f$var$uf($26b90eb13321ae4f$var$rf, "onTransitionEnd");
$26b90eb13321ae4f$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$26b90eb13321ae4f$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$26b90eb13321ae4f$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$26b90eb13321ae4f$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$26b90eb13321ae4f$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$26b90eb13321ae4f$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$26b90eb13321ae4f$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$26b90eb13321ae4f$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$26b90eb13321ae4f$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$26b90eb13321ae4f$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $26b90eb13321ae4f$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $26b90eb13321ae4f$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($26b90eb13321ae4f$var$zf));
function $26b90eb13321ae4f$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $26b90eb13321ae4f$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $26b90eb13321ae4f$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $26b90eb13321ae4f$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $26b90eb13321ae4f$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($26b90eb13321ae4f$var$Qb) throw a = $26b90eb13321ae4f$var$Rb, $26b90eb13321ae4f$var$Qb = !1, $26b90eb13321ae4f$var$Rb = null, a;
}
function $26b90eb13321ae4f$var$F(a, b) {
    var c = b[$26b90eb13321ae4f$var$Cf];
    void 0 === c && (c = b[$26b90eb13321ae4f$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($26b90eb13321ae4f$var$Df(b, a, 2, !1), c.add(d));
}
function $26b90eb13321ae4f$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $26b90eb13321ae4f$var$Df(c, a, d, b);
}
var $26b90eb13321ae4f$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $26b90eb13321ae4f$var$Gf(a) {
    if (!a[$26b90eb13321ae4f$var$Ff]) {
        a[$26b90eb13321ae4f$var$Ff] = !0;
        $26b90eb13321ae4f$var$da.forEach(function(b) {
            "selectionchange" !== b && ($26b90eb13321ae4f$var$Af.has(b) || $26b90eb13321ae4f$var$Ef(b, !1, a), $26b90eb13321ae4f$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$26b90eb13321ae4f$var$Ff] || (b[$26b90eb13321ae4f$var$Ff] = !0, $26b90eb13321ae4f$var$Ef("selectionchange", !1, b));
    }
}
function $26b90eb13321ae4f$var$Df(a, b, c, d) {
    switch($26b90eb13321ae4f$var$xd(b)){
        case 1:
            var e = $26b90eb13321ae4f$var$sd;
            break;
        case 4:
            e = $26b90eb13321ae4f$var$ud;
            break;
        default:
            e = $26b90eb13321ae4f$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$26b90eb13321ae4f$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $26b90eb13321ae4f$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $26b90eb13321ae4f$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $26b90eb13321ae4f$var$Jb(function() {
        var d = f, e = $26b90eb13321ae4f$var$xb(c), g = [];
        a: {
            var h = $26b90eb13321ae4f$var$sf.get(a);
            if (void 0 !== h) {
                var k = $26b90eb13321ae4f$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $26b90eb13321ae4f$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $26b90eb13321ae4f$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $26b90eb13321ae4f$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $26b90eb13321ae4f$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $26b90eb13321ae4f$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $26b90eb13321ae4f$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $26b90eb13321ae4f$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $26b90eb13321ae4f$var$ie;
                        break;
                    case $26b90eb13321ae4f$var$of:
                    case $26b90eb13321ae4f$var$pf:
                    case $26b90eb13321ae4f$var$qf:
                        k = $26b90eb13321ae4f$var$Vd;
                        break;
                    case $26b90eb13321ae4f$var$rf:
                        k = $26b90eb13321ae4f$var$ke;
                        break;
                    case "scroll":
                        k = $26b90eb13321ae4f$var$Jd;
                        break;
                    case "wheel":
                        k = $26b90eb13321ae4f$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $26b90eb13321ae4f$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $26b90eb13321ae4f$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $26b90eb13321ae4f$var$Kb(y, x), null != D && w.push($26b90eb13321ae4f$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $26b90eb13321ae4f$var$wb && (m = c.relatedTarget || c.fromElement) && ($26b90eb13321ae4f$var$jd(m) || m[$26b90eb13321ae4f$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $26b90eb13321ae4f$var$jd(m) : null, null !== m && (C = $26b90eb13321ae4f$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $26b90eb13321ae4f$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $26b90eb13321ae4f$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $26b90eb13321ae4f$var$Ie(k);
                        v = null == m ? h : $26b90eb13321ae4f$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $26b90eb13321ae4f$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $26b90eb13321ae4f$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $26b90eb13321ae4f$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $26b90eb13321ae4f$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $26b90eb13321ae4f$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $26b90eb13321ae4f$var$Jf(w);
                                x = $26b90eb13321ae4f$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $26b90eb13321ae4f$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $26b90eb13321ae4f$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $26b90eb13321ae4f$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $26b90eb13321ae4f$var$Je;
                else if ($26b90eb13321ae4f$var$Ae(h)) {
                    if ($26b90eb13321ae4f$var$Ke) ca = $26b90eb13321ae4f$var$Te;
                    else {
                        ca = $26b90eb13321ae4f$var$Re;
                        var R = $26b90eb13321ae4f$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $26b90eb13321ae4f$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $26b90eb13321ae4f$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $26b90eb13321ae4f$var$bb(h, "number", h.value);
            }
            R = d ? $26b90eb13321ae4f$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($26b90eb13321ae4f$var$Ae(R) || "true" === R.contentEditable) $26b90eb13321ae4f$var$df = R, $26b90eb13321ae4f$var$ef = d, $26b90eb13321ae4f$var$ff = null;
                    break;
                case "focusout":
                    $26b90eb13321ae4f$var$ff = $26b90eb13321ae4f$var$ef = $26b90eb13321ae4f$var$df = null;
                    break;
                case "mousedown":
                    $26b90eb13321ae4f$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $26b90eb13321ae4f$var$gf = !1;
                    $26b90eb13321ae4f$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($26b90eb13321ae4f$var$cf) break;
                case "keydown":
                case "keyup":
                    $26b90eb13321ae4f$var$hf(g, c, e);
            }
            var sa;
            if ($26b90eb13321ae4f$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $26b90eb13321ae4f$var$we ? $26b90eb13321ae4f$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($26b90eb13321ae4f$var$re && "ko" !== c.locale && ($26b90eb13321ae4f$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $26b90eb13321ae4f$var$we && (sa = $26b90eb13321ae4f$var$Bd()) : ($26b90eb13321ae4f$var$yd = e, $26b90eb13321ae4f$var$zd = "value" in $26b90eb13321ae4f$var$yd ? $26b90eb13321ae4f$var$yd.value : $26b90eb13321ae4f$var$yd.textContent, $26b90eb13321ae4f$var$we = !0)), R = $26b90eb13321ae4f$var$Ce(d, V), 0 < R.length && (V = new $26b90eb13321ae4f$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $26b90eb13321ae4f$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $26b90eb13321ae4f$var$qe ? $26b90eb13321ae4f$var$xe(a, c) : $26b90eb13321ae4f$var$ye(a, c)) d = $26b90eb13321ae4f$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $26b90eb13321ae4f$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $26b90eb13321ae4f$var$Ge(g, b);
    });
}
function $26b90eb13321ae4f$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $26b90eb13321ae4f$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $26b90eb13321ae4f$var$Kb(a, c), null != f && d.unshift($26b90eb13321ae4f$var$Hf(a, f, e)), f = $26b90eb13321ae4f$var$Kb(a, b), null != f && d.push($26b90eb13321ae4f$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $26b90eb13321ae4f$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $26b90eb13321ae4f$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $26b90eb13321ae4f$var$Kb(c, f), null != k && g.unshift($26b90eb13321ae4f$var$Hf(c, k, h))) : e || (k = $26b90eb13321ae4f$var$Kb(c, f), null != k && g.push($26b90eb13321ae4f$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $26b90eb13321ae4f$var$Lf = /\r\n?/g, $26b90eb13321ae4f$var$Mf = /\u0000|\uFFFD/g;
function $26b90eb13321ae4f$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($26b90eb13321ae4f$var$Lf, "\n").replace($26b90eb13321ae4f$var$Mf, "");
}
function $26b90eb13321ae4f$var$Of(a, b, c) {
    b = $26b90eb13321ae4f$var$Nf(b);
    if ($26b90eb13321ae4f$var$Nf(a) !== b && c) throw Error($26b90eb13321ae4f$var$p(425));
}
function $26b90eb13321ae4f$var$Pf() {}
var $26b90eb13321ae4f$var$Qf = null, $26b90eb13321ae4f$var$Rf = null;
function $26b90eb13321ae4f$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $26b90eb13321ae4f$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $26b90eb13321ae4f$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $26b90eb13321ae4f$var$Vf = "function" === typeof Promise ? Promise : void 0, $26b90eb13321ae4f$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $26b90eb13321ae4f$var$Vf ? function(a) {
    return $26b90eb13321ae4f$var$Vf.resolve(null).then(a).catch($26b90eb13321ae4f$var$Wf);
} : $26b90eb13321ae4f$var$Tf;
function $26b90eb13321ae4f$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $26b90eb13321ae4f$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $26b90eb13321ae4f$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $26b90eb13321ae4f$var$pd(b);
}
function $26b90eb13321ae4f$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $26b90eb13321ae4f$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $26b90eb13321ae4f$var$ag = Math.random().toString(36).slice(2), $26b90eb13321ae4f$var$bg = "__reactFiber$" + $26b90eb13321ae4f$var$ag, $26b90eb13321ae4f$var$cg = "__reactProps$" + $26b90eb13321ae4f$var$ag, $26b90eb13321ae4f$var$If = "__reactContainer$" + $26b90eb13321ae4f$var$ag, $26b90eb13321ae4f$var$Cf = "__reactEvents$" + $26b90eb13321ae4f$var$ag, $26b90eb13321ae4f$var$dg = "__reactListeners$" + $26b90eb13321ae4f$var$ag, $26b90eb13321ae4f$var$eg = "__reactHandles$" + $26b90eb13321ae4f$var$ag;
function $26b90eb13321ae4f$var$jd(a) {
    var b = a[$26b90eb13321ae4f$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$26b90eb13321ae4f$var$If] || c[$26b90eb13321ae4f$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $26b90eb13321ae4f$var$$f(a); null !== a;){
                if (c = a[$26b90eb13321ae4f$var$bg]) return c;
                a = $26b90eb13321ae4f$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $26b90eb13321ae4f$var$Cb(a) {
    a = a[$26b90eb13321ae4f$var$bg] || a[$26b90eb13321ae4f$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $26b90eb13321ae4f$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($26b90eb13321ae4f$var$p(33));
}
function $26b90eb13321ae4f$var$Db(a) {
    return a[$26b90eb13321ae4f$var$cg] || null;
}
var $26b90eb13321ae4f$var$fg = [], $26b90eb13321ae4f$var$gg = -1;
function $26b90eb13321ae4f$var$hg(a) {
    return {
        current: a
    };
}
function $26b90eb13321ae4f$var$G(a) {
    0 > $26b90eb13321ae4f$var$gg || (a.current = $26b90eb13321ae4f$var$fg[$26b90eb13321ae4f$var$gg], $26b90eb13321ae4f$var$fg[$26b90eb13321ae4f$var$gg] = null, $26b90eb13321ae4f$var$gg--);
}
function $26b90eb13321ae4f$var$H(a, b) {
    $26b90eb13321ae4f$var$gg++;
    $26b90eb13321ae4f$var$fg[$26b90eb13321ae4f$var$gg] = a.current;
    a.current = b;
}
var $26b90eb13321ae4f$var$ig = {}, $26b90eb13321ae4f$var$I = $26b90eb13321ae4f$var$hg($26b90eb13321ae4f$var$ig), $26b90eb13321ae4f$var$jg = $26b90eb13321ae4f$var$hg(!1), $26b90eb13321ae4f$var$kg = $26b90eb13321ae4f$var$ig;
function $26b90eb13321ae4f$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $26b90eb13321ae4f$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $26b90eb13321ae4f$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $26b90eb13321ae4f$var$ng() {
    $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$jg);
    $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$I);
}
function $26b90eb13321ae4f$var$og(a, b, c) {
    if ($26b90eb13321ae4f$var$I.current !== $26b90eb13321ae4f$var$ig) throw Error($26b90eb13321ae4f$var$p(168));
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$I, b);
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$jg, c);
}
function $26b90eb13321ae4f$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($26b90eb13321ae4f$var$p(108, $26b90eb13321ae4f$var$Ra(a) || "Unknown", e));
    return $26b90eb13321ae4f$var$u({}, c, d);
}
function $26b90eb13321ae4f$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $26b90eb13321ae4f$var$ig;
    $26b90eb13321ae4f$var$kg = $26b90eb13321ae4f$var$I.current;
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$I, a);
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$jg, $26b90eb13321ae4f$var$jg.current);
    return !0;
}
function $26b90eb13321ae4f$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($26b90eb13321ae4f$var$p(169));
    c ? (a = $26b90eb13321ae4f$var$pg(a, b, $26b90eb13321ae4f$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$jg), $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$I), $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$I, a)) : $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$jg);
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$jg, c);
}
var $26b90eb13321ae4f$var$sg = null, $26b90eb13321ae4f$var$tg = !1, $26b90eb13321ae4f$var$ug = !1;
function $26b90eb13321ae4f$var$vg(a) {
    null === $26b90eb13321ae4f$var$sg ? $26b90eb13321ae4f$var$sg = [
        a
    ] : $26b90eb13321ae4f$var$sg.push(a);
}
function $26b90eb13321ae4f$var$wg(a) {
    $26b90eb13321ae4f$var$tg = !0;
    $26b90eb13321ae4f$var$vg(a);
}
function $26b90eb13321ae4f$var$xg() {
    if (!$26b90eb13321ae4f$var$ug && null !== $26b90eb13321ae4f$var$sg) {
        $26b90eb13321ae4f$var$ug = !0;
        var a = 0, b = $26b90eb13321ae4f$var$E;
        try {
            var c = $26b90eb13321ae4f$var$sg;
            for($26b90eb13321ae4f$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $26b90eb13321ae4f$var$sg = null;
            $26b90eb13321ae4f$var$tg = !1;
        } catch (e) {
            throw null !== $26b90eb13321ae4f$var$sg && ($26b90eb13321ae4f$var$sg = $26b90eb13321ae4f$var$sg.slice(a + 1)), $26b90eb13321ae4f$var$ac($26b90eb13321ae4f$var$fc, $26b90eb13321ae4f$var$xg), e;
        } finally{
            $26b90eb13321ae4f$var$E = b, $26b90eb13321ae4f$var$ug = !1;
        }
    }
    return null;
}
var $26b90eb13321ae4f$var$yg = [], $26b90eb13321ae4f$var$zg = 0, $26b90eb13321ae4f$var$Ag = null, $26b90eb13321ae4f$var$Bg = 0, $26b90eb13321ae4f$var$Cg = [], $26b90eb13321ae4f$var$Dg = 0, $26b90eb13321ae4f$var$Eg = null, $26b90eb13321ae4f$var$Fg = 1, $26b90eb13321ae4f$var$Gg = "";
function $26b90eb13321ae4f$var$Hg(a, b) {
    $26b90eb13321ae4f$var$yg[$26b90eb13321ae4f$var$zg++] = $26b90eb13321ae4f$var$Bg;
    $26b90eb13321ae4f$var$yg[$26b90eb13321ae4f$var$zg++] = $26b90eb13321ae4f$var$Ag;
    $26b90eb13321ae4f$var$Ag = a;
    $26b90eb13321ae4f$var$Bg = b;
}
function $26b90eb13321ae4f$var$Ig(a, b, c) {
    $26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg++] = $26b90eb13321ae4f$var$Fg;
    $26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg++] = $26b90eb13321ae4f$var$Gg;
    $26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg++] = $26b90eb13321ae4f$var$Eg;
    $26b90eb13321ae4f$var$Eg = a;
    var d = $26b90eb13321ae4f$var$Fg;
    a = $26b90eb13321ae4f$var$Gg;
    var e = 32 - $26b90eb13321ae4f$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $26b90eb13321ae4f$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $26b90eb13321ae4f$var$Fg = 1 << 32 - $26b90eb13321ae4f$var$Ac(b) + e | c << e | d;
        $26b90eb13321ae4f$var$Gg = f + a;
    } else $26b90eb13321ae4f$var$Fg = 1 << f | c << e | d, $26b90eb13321ae4f$var$Gg = a;
}
function $26b90eb13321ae4f$var$Jg(a) {
    null !== a.return && ($26b90eb13321ae4f$var$Hg(a, 1), $26b90eb13321ae4f$var$Ig(a, 1, 0));
}
function $26b90eb13321ae4f$var$Kg(a) {
    for(; a === $26b90eb13321ae4f$var$Ag;)$26b90eb13321ae4f$var$Ag = $26b90eb13321ae4f$var$yg[--$26b90eb13321ae4f$var$zg], $26b90eb13321ae4f$var$yg[$26b90eb13321ae4f$var$zg] = null, $26b90eb13321ae4f$var$Bg = $26b90eb13321ae4f$var$yg[--$26b90eb13321ae4f$var$zg], $26b90eb13321ae4f$var$yg[$26b90eb13321ae4f$var$zg] = null;
    for(; a === $26b90eb13321ae4f$var$Eg;)$26b90eb13321ae4f$var$Eg = $26b90eb13321ae4f$var$Cg[--$26b90eb13321ae4f$var$Dg], $26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg] = null, $26b90eb13321ae4f$var$Gg = $26b90eb13321ae4f$var$Cg[--$26b90eb13321ae4f$var$Dg], $26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg] = null, $26b90eb13321ae4f$var$Fg = $26b90eb13321ae4f$var$Cg[--$26b90eb13321ae4f$var$Dg], $26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg] = null;
}
var $26b90eb13321ae4f$var$Lg = null, $26b90eb13321ae4f$var$Mg = null, $26b90eb13321ae4f$var$J = !1, $26b90eb13321ae4f$var$Ng = null;
function $26b90eb13321ae4f$var$Og(a, b) {
    var c = $26b90eb13321ae4f$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $26b90eb13321ae4f$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $26b90eb13321ae4f$var$Lg = a, $26b90eb13321ae4f$var$Mg = $26b90eb13321ae4f$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $26b90eb13321ae4f$var$Lg = a, $26b90eb13321ae4f$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $26b90eb13321ae4f$var$Eg ? {
                id: $26b90eb13321ae4f$var$Fg,
                overflow: $26b90eb13321ae4f$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $26b90eb13321ae4f$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $26b90eb13321ae4f$var$Lg = a, $26b90eb13321ae4f$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $26b90eb13321ae4f$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $26b90eb13321ae4f$var$Sg(a) {
    if ($26b90eb13321ae4f$var$J) {
        var b = $26b90eb13321ae4f$var$Mg;
        if (b) {
            var c = b;
            if (!$26b90eb13321ae4f$var$Qg(a, b)) {
                if ($26b90eb13321ae4f$var$Rg(a)) throw Error($26b90eb13321ae4f$var$p(418));
                b = $26b90eb13321ae4f$var$Zf(c.nextSibling);
                var d = $26b90eb13321ae4f$var$Lg;
                b && $26b90eb13321ae4f$var$Qg(a, b) ? $26b90eb13321ae4f$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $26b90eb13321ae4f$var$J = !1, $26b90eb13321ae4f$var$Lg = a);
            }
        } else {
            if ($26b90eb13321ae4f$var$Rg(a)) throw Error($26b90eb13321ae4f$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $26b90eb13321ae4f$var$J = !1;
            $26b90eb13321ae4f$var$Lg = a;
        }
    }
}
function $26b90eb13321ae4f$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $26b90eb13321ae4f$var$Lg = a;
}
function $26b90eb13321ae4f$var$Ug(a) {
    if (a !== $26b90eb13321ae4f$var$Lg) return !1;
    if (!$26b90eb13321ae4f$var$J) return $26b90eb13321ae4f$var$Tg(a), $26b90eb13321ae4f$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$26b90eb13321ae4f$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $26b90eb13321ae4f$var$Mg)) {
        if ($26b90eb13321ae4f$var$Rg(a)) throw $26b90eb13321ae4f$var$Vg(), Error($26b90eb13321ae4f$var$p(418));
        for(; b;)$26b90eb13321ae4f$var$Og(a, b), b = $26b90eb13321ae4f$var$Zf(b.nextSibling);
    }
    $26b90eb13321ae4f$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($26b90eb13321ae4f$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $26b90eb13321ae4f$var$Mg = $26b90eb13321ae4f$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $26b90eb13321ae4f$var$Mg = null;
        }
    } else $26b90eb13321ae4f$var$Mg = $26b90eb13321ae4f$var$Lg ? $26b90eb13321ae4f$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $26b90eb13321ae4f$var$Vg() {
    for(var a = $26b90eb13321ae4f$var$Mg; a;)a = $26b90eb13321ae4f$var$Zf(a.nextSibling);
}
function $26b90eb13321ae4f$var$Wg() {
    $26b90eb13321ae4f$var$Mg = $26b90eb13321ae4f$var$Lg = null;
    $26b90eb13321ae4f$var$J = !1;
}
function $26b90eb13321ae4f$var$Xg(a) {
    null === $26b90eb13321ae4f$var$Ng ? $26b90eb13321ae4f$var$Ng = [
        a
    ] : $26b90eb13321ae4f$var$Ng.push(a);
}
var $26b90eb13321ae4f$var$Yg = $26b90eb13321ae4f$var$va.ReactCurrentBatchConfig;
function $26b90eb13321ae4f$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($26b90eb13321ae4f$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($26b90eb13321ae4f$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($26b90eb13321ae4f$var$p(284));
        if (!c._owner) throw Error($26b90eb13321ae4f$var$p(290, a));
    }
    return a;
}
function $26b90eb13321ae4f$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($26b90eb13321ae4f$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $26b90eb13321ae4f$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $26b90eb13321ae4f$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $26b90eb13321ae4f$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $26b90eb13321ae4f$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $26b90eb13321ae4f$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $26b90eb13321ae4f$var$Ha && $26b90eb13321ae4f$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $26b90eb13321ae4f$var$Zg(a, b, c), d.return = a, d;
        d = $26b90eb13321ae4f$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $26b90eb13321ae4f$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $26b90eb13321ae4f$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $26b90eb13321ae4f$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $26b90eb13321ae4f$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $26b90eb13321ae4f$var$wa:
                    return c = $26b90eb13321ae4f$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $26b90eb13321ae4f$var$Zg(a, null, b), c.return = a, c;
                case $26b90eb13321ae4f$var$xa:
                    return b = $26b90eb13321ae4f$var$fh(b, a.mode, c), b.return = a, b;
                case $26b90eb13321ae4f$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($26b90eb13321ae4f$var$db(b) || $26b90eb13321ae4f$var$Ka(b)) return b = $26b90eb13321ae4f$var$gh(b, a.mode, c, null), b.return = a, b;
            $26b90eb13321ae4f$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $26b90eb13321ae4f$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $26b90eb13321ae4f$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $26b90eb13321ae4f$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($26b90eb13321ae4f$var$db(c) || $26b90eb13321ae4f$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $26b90eb13321ae4f$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $26b90eb13321ae4f$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $26b90eb13321ae4f$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $26b90eb13321ae4f$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($26b90eb13321ae4f$var$db(d) || $26b90eb13321ae4f$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $26b90eb13321ae4f$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $26b90eb13321ae4f$var$J && $26b90eb13321ae4f$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $26b90eb13321ae4f$var$J && $26b90eb13321ae4f$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $26b90eb13321ae4f$var$J && $26b90eb13321ae4f$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $26b90eb13321ae4f$var$Ka(h);
        if ("function" !== typeof l) throw Error($26b90eb13321ae4f$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($26b90eb13321ae4f$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $26b90eb13321ae4f$var$J && $26b90eb13321ae4f$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $26b90eb13321ae4f$var$J && $26b90eb13321ae4f$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $26b90eb13321ae4f$var$J && $26b90eb13321ae4f$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $26b90eb13321ae4f$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $26b90eb13321ae4f$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $26b90eb13321ae4f$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $26b90eb13321ae4f$var$Ha && $26b90eb13321ae4f$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $26b90eb13321ae4f$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $26b90eb13321ae4f$var$ya ? (d = $26b90eb13321ae4f$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $26b90eb13321ae4f$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $26b90eb13321ae4f$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $26b90eb13321ae4f$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $26b90eb13321ae4f$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $26b90eb13321ae4f$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($26b90eb13321ae4f$var$db(f)) return m(a, d, f, h);
            if ($26b90eb13321ae4f$var$Ka(f)) return w(a, d, f, h);
            $26b90eb13321ae4f$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $26b90eb13321ae4f$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $26b90eb13321ae4f$var$hh = $26b90eb13321ae4f$var$bh(!0), $26b90eb13321ae4f$var$ih = $26b90eb13321ae4f$var$bh(!1), $26b90eb13321ae4f$var$jh = $26b90eb13321ae4f$var$hg(null), $26b90eb13321ae4f$var$kh = null, $26b90eb13321ae4f$var$lh = null, $26b90eb13321ae4f$var$mh = null;
function $26b90eb13321ae4f$var$nh() {
    $26b90eb13321ae4f$var$mh = $26b90eb13321ae4f$var$lh = $26b90eb13321ae4f$var$kh = null;
}
function $26b90eb13321ae4f$var$oh(a) {
    var b = $26b90eb13321ae4f$var$jh.current;
    $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$jh);
    a._currentValue = b;
}
function $26b90eb13321ae4f$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $26b90eb13321ae4f$var$qh(a, b) {
    $26b90eb13321ae4f$var$kh = a;
    $26b90eb13321ae4f$var$mh = $26b90eb13321ae4f$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($26b90eb13321ae4f$var$rh = !0), a.firstContext = null);
}
function $26b90eb13321ae4f$var$sh(a) {
    var b = a._currentValue;
    if ($26b90eb13321ae4f$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $26b90eb13321ae4f$var$lh) {
            if (null === $26b90eb13321ae4f$var$kh) throw Error($26b90eb13321ae4f$var$p(308));
            $26b90eb13321ae4f$var$lh = a;
            $26b90eb13321ae4f$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $26b90eb13321ae4f$var$lh = $26b90eb13321ae4f$var$lh.next = a;
    }
    return b;
}
var $26b90eb13321ae4f$var$th = null;
function $26b90eb13321ae4f$var$uh(a) {
    null === $26b90eb13321ae4f$var$th ? $26b90eb13321ae4f$var$th = [
        a
    ] : $26b90eb13321ae4f$var$th.push(a);
}
function $26b90eb13321ae4f$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $26b90eb13321ae4f$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $26b90eb13321ae4f$var$wh(a, d);
}
function $26b90eb13321ae4f$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $26b90eb13321ae4f$var$xh = !1;
function $26b90eb13321ae4f$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $26b90eb13321ae4f$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $26b90eb13321ae4f$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $26b90eb13321ae4f$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($26b90eb13321ae4f$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $26b90eb13321ae4f$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $26b90eb13321ae4f$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $26b90eb13321ae4f$var$wh(a, c);
}
function $26b90eb13321ae4f$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $26b90eb13321ae4f$var$Oc(a, c);
    }
}
function $26b90eb13321ae4f$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $26b90eb13321ae4f$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $26b90eb13321ae4f$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $26b90eb13321ae4f$var$u({}, q, r);
                            break a;
                        case 2:
                            $26b90eb13321ae4f$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $26b90eb13321ae4f$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $26b90eb13321ae4f$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($26b90eb13321ae4f$var$p(191, e));
            e.call(d);
        }
    }
}
var $26b90eb13321ae4f$var$Hh = {}, $26b90eb13321ae4f$var$Ih = $26b90eb13321ae4f$var$hg($26b90eb13321ae4f$var$Hh), $26b90eb13321ae4f$var$Jh = $26b90eb13321ae4f$var$hg($26b90eb13321ae4f$var$Hh), $26b90eb13321ae4f$var$Kh = $26b90eb13321ae4f$var$hg($26b90eb13321ae4f$var$Hh);
function $26b90eb13321ae4f$var$Lh(a) {
    if (a === $26b90eb13321ae4f$var$Hh) throw Error($26b90eb13321ae4f$var$p(174));
    return a;
}
function $26b90eb13321ae4f$var$Mh(a, b) {
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Kh, b);
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Jh, a);
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Ih, $26b90eb13321ae4f$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $26b90eb13321ae4f$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $26b90eb13321ae4f$var$kb(b, a);
    }
    $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$Ih);
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Ih, b);
}
function $26b90eb13321ae4f$var$Nh() {
    $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$Ih);
    $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$Jh);
    $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$Kh);
}
function $26b90eb13321ae4f$var$Oh(a) {
    $26b90eb13321ae4f$var$Lh($26b90eb13321ae4f$var$Kh.current);
    var b = $26b90eb13321ae4f$var$Lh($26b90eb13321ae4f$var$Ih.current);
    var c = $26b90eb13321ae4f$var$kb(b, a.type);
    b !== c && ($26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Jh, a), $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Ih, c));
}
function $26b90eb13321ae4f$var$Ph(a) {
    $26b90eb13321ae4f$var$Jh.current === a && ($26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$Ih), $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$Jh));
}
var $26b90eb13321ae4f$var$L = $26b90eb13321ae4f$var$hg(0);
function $26b90eb13321ae4f$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $26b90eb13321ae4f$var$Rh = [];
function $26b90eb13321ae4f$var$Sh() {
    for(var a = 0; a < $26b90eb13321ae4f$var$Rh.length; a++)$26b90eb13321ae4f$var$Rh[a]._workInProgressVersionPrimary = null;
    $26b90eb13321ae4f$var$Rh.length = 0;
}
var $26b90eb13321ae4f$var$Th = $26b90eb13321ae4f$var$va.ReactCurrentDispatcher, $26b90eb13321ae4f$var$Uh = $26b90eb13321ae4f$var$va.ReactCurrentBatchConfig, $26b90eb13321ae4f$var$Vh = 0, $26b90eb13321ae4f$var$M = null, $26b90eb13321ae4f$var$N = null, $26b90eb13321ae4f$var$O = null, $26b90eb13321ae4f$var$Wh = !1, $26b90eb13321ae4f$var$Xh = !1, $26b90eb13321ae4f$var$Yh = 0, $26b90eb13321ae4f$var$Zh = 0;
function $26b90eb13321ae4f$var$P() {
    throw Error($26b90eb13321ae4f$var$p(321));
}
function $26b90eb13321ae4f$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$26b90eb13321ae4f$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $26b90eb13321ae4f$var$ai(a, b, c, d, e, f) {
    $26b90eb13321ae4f$var$Vh = f;
    $26b90eb13321ae4f$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $26b90eb13321ae4f$var$Th.current = null === a || null === a.memoizedState ? $26b90eb13321ae4f$var$bi : $26b90eb13321ae4f$var$ci;
    a = c(d, e);
    if ($26b90eb13321ae4f$var$Xh) {
        f = 0;
        do {
            $26b90eb13321ae4f$var$Xh = !1;
            $26b90eb13321ae4f$var$Yh = 0;
            if (25 <= f) throw Error($26b90eb13321ae4f$var$p(301));
            f += 1;
            $26b90eb13321ae4f$var$O = $26b90eb13321ae4f$var$N = null;
            b.updateQueue = null;
            $26b90eb13321ae4f$var$Th.current = $26b90eb13321ae4f$var$di;
            a = c(d, e);
        }while ($26b90eb13321ae4f$var$Xh);
    }
    $26b90eb13321ae4f$var$Th.current = $26b90eb13321ae4f$var$ei;
    b = null !== $26b90eb13321ae4f$var$N && null !== $26b90eb13321ae4f$var$N.next;
    $26b90eb13321ae4f$var$Vh = 0;
    $26b90eb13321ae4f$var$O = $26b90eb13321ae4f$var$N = $26b90eb13321ae4f$var$M = null;
    $26b90eb13321ae4f$var$Wh = !1;
    if (b) throw Error($26b90eb13321ae4f$var$p(300));
    return a;
}
function $26b90eb13321ae4f$var$fi() {
    var a = 0 !== $26b90eb13321ae4f$var$Yh;
    $26b90eb13321ae4f$var$Yh = 0;
    return a;
}
function $26b90eb13321ae4f$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $26b90eb13321ae4f$var$O ? $26b90eb13321ae4f$var$M.memoizedState = $26b90eb13321ae4f$var$O = a : $26b90eb13321ae4f$var$O = $26b90eb13321ae4f$var$O.next = a;
    return $26b90eb13321ae4f$var$O;
}
function $26b90eb13321ae4f$var$hi() {
    if (null === $26b90eb13321ae4f$var$N) {
        var a = $26b90eb13321ae4f$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $26b90eb13321ae4f$var$N.next;
    var b = null === $26b90eb13321ae4f$var$O ? $26b90eb13321ae4f$var$M.memoizedState : $26b90eb13321ae4f$var$O.next;
    if (null !== b) $26b90eb13321ae4f$var$O = b, $26b90eb13321ae4f$var$N = a;
    else {
        if (null === a) throw Error($26b90eb13321ae4f$var$p(310));
        $26b90eb13321ae4f$var$N = a;
        a = {
            memoizedState: $26b90eb13321ae4f$var$N.memoizedState,
            baseState: $26b90eb13321ae4f$var$N.baseState,
            baseQueue: $26b90eb13321ae4f$var$N.baseQueue,
            queue: $26b90eb13321ae4f$var$N.queue,
            next: null
        };
        null === $26b90eb13321ae4f$var$O ? $26b90eb13321ae4f$var$M.memoizedState = $26b90eb13321ae4f$var$O = a : $26b90eb13321ae4f$var$O = $26b90eb13321ae4f$var$O.next = a;
    }
    return $26b90eb13321ae4f$var$O;
}
function $26b90eb13321ae4f$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $26b90eb13321ae4f$var$ji(a) {
    var b = $26b90eb13321ae4f$var$hi(), c = b.queue;
    if (null === c) throw Error($26b90eb13321ae4f$var$p(311));
    c.lastRenderedReducer = a;
    var d = $26b90eb13321ae4f$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($26b90eb13321ae4f$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $26b90eb13321ae4f$var$M.lanes |= n;
                $26b90eb13321ae4f$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $26b90eb13321ae4f$var$Ve(d, b.memoizedState) || ($26b90eb13321ae4f$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $26b90eb13321ae4f$var$M.lanes |= f, $26b90eb13321ae4f$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $26b90eb13321ae4f$var$ki(a) {
    var b = $26b90eb13321ae4f$var$hi(), c = b.queue;
    if (null === c) throw Error($26b90eb13321ae4f$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $26b90eb13321ae4f$var$Ve(f, b.memoizedState) || ($26b90eb13321ae4f$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $26b90eb13321ae4f$var$li() {}
function $26b90eb13321ae4f$var$mi(a, b) {
    var c = $26b90eb13321ae4f$var$M, d = $26b90eb13321ae4f$var$hi(), e = b(), f = !$26b90eb13321ae4f$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $26b90eb13321ae4f$var$rh = !0);
    d = d.queue;
    $26b90eb13321ae4f$var$ni($26b90eb13321ae4f$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $26b90eb13321ae4f$var$O && $26b90eb13321ae4f$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $26b90eb13321ae4f$var$pi(9, $26b90eb13321ae4f$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $26b90eb13321ae4f$var$Q) throw Error($26b90eb13321ae4f$var$p(349));
        0 !== ($26b90eb13321ae4f$var$Vh & 30) || $26b90eb13321ae4f$var$ri(c, b, e);
    }
    return e;
}
function $26b90eb13321ae4f$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $26b90eb13321ae4f$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $26b90eb13321ae4f$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $26b90eb13321ae4f$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $26b90eb13321ae4f$var$si(b) && $26b90eb13321ae4f$var$ti(a);
}
function $26b90eb13321ae4f$var$oi(a, b, c) {
    return c(function() {
        $26b90eb13321ae4f$var$si(b) && $26b90eb13321ae4f$var$ti(a);
    });
}
function $26b90eb13321ae4f$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$26b90eb13321ae4f$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $26b90eb13321ae4f$var$ti(a) {
    var b = $26b90eb13321ae4f$var$wh(a, 1);
    null !== b && $26b90eb13321ae4f$var$ui(b, a, 1, -1);
}
function $26b90eb13321ae4f$var$vi(a) {
    var b = $26b90eb13321ae4f$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $26b90eb13321ae4f$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $26b90eb13321ae4f$var$wi.bind(null, $26b90eb13321ae4f$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $26b90eb13321ae4f$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $26b90eb13321ae4f$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $26b90eb13321ae4f$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $26b90eb13321ae4f$var$xi() {
    return $26b90eb13321ae4f$var$hi().memoizedState;
}
function $26b90eb13321ae4f$var$Ai(a, b, c, d) {
    var e = $26b90eb13321ae4f$var$gi();
    $26b90eb13321ae4f$var$M.flags |= a;
    e.memoizedState = $26b90eb13321ae4f$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $26b90eb13321ae4f$var$Bi(a, b, c, d) {
    var e = $26b90eb13321ae4f$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $26b90eb13321ae4f$var$N) {
        var g = $26b90eb13321ae4f$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $26b90eb13321ae4f$var$$h(d, g.deps)) {
            e.memoizedState = $26b90eb13321ae4f$var$pi(b, c, f, d);
            return;
        }
    }
    $26b90eb13321ae4f$var$M.flags |= a;
    e.memoizedState = $26b90eb13321ae4f$var$pi(1 | b, c, f, d);
}
function $26b90eb13321ae4f$var$Ci(a, b) {
    return $26b90eb13321ae4f$var$Ai(8390656, 8, a, b);
}
function $26b90eb13321ae4f$var$ni(a, b) {
    return $26b90eb13321ae4f$var$Bi(2048, 8, a, b);
}
function $26b90eb13321ae4f$var$Di(a, b) {
    return $26b90eb13321ae4f$var$Bi(4, 2, a, b);
}
function $26b90eb13321ae4f$var$Ei(a, b) {
    return $26b90eb13321ae4f$var$Bi(4, 4, a, b);
}
function $26b90eb13321ae4f$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $26b90eb13321ae4f$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $26b90eb13321ae4f$var$Bi(4, 4, $26b90eb13321ae4f$var$Fi.bind(null, b, a), c);
}
function $26b90eb13321ae4f$var$Hi() {}
function $26b90eb13321ae4f$var$Ii(a, b) {
    var c = $26b90eb13321ae4f$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $26b90eb13321ae4f$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $26b90eb13321ae4f$var$Ji(a, b) {
    var c = $26b90eb13321ae4f$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $26b90eb13321ae4f$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $26b90eb13321ae4f$var$Ki(a, b, c) {
    if (0 === ($26b90eb13321ae4f$var$Vh & 21)) return a.baseState && (a.baseState = !1, $26b90eb13321ae4f$var$rh = !0), a.memoizedState = c;
    $26b90eb13321ae4f$var$Ve(c, b) || (c = $26b90eb13321ae4f$var$Kc(), $26b90eb13321ae4f$var$M.lanes |= c, $26b90eb13321ae4f$var$Fh |= c, a.baseState = !0);
    return b;
}
function $26b90eb13321ae4f$var$Li(a, b) {
    var c = $26b90eb13321ae4f$var$E;
    $26b90eb13321ae4f$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $26b90eb13321ae4f$var$Uh.transition;
    $26b90eb13321ae4f$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $26b90eb13321ae4f$var$E = c, $26b90eb13321ae4f$var$Uh.transition = d;
    }
}
function $26b90eb13321ae4f$var$Mi() {
    return $26b90eb13321ae4f$var$hi().memoizedState;
}
function $26b90eb13321ae4f$var$Ni(a, b, c) {
    var d = $26b90eb13321ae4f$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($26b90eb13321ae4f$var$Pi(a)) $26b90eb13321ae4f$var$Qi(b, c);
    else if (c = $26b90eb13321ae4f$var$vh(a, b, c, d), null !== c) {
        var e = $26b90eb13321ae4f$var$Ri();
        $26b90eb13321ae4f$var$ui(c, a, d, e);
        $26b90eb13321ae4f$var$Si(c, b, d);
    }
    $26b90eb13321ae4f$var$yc(a, d);
}
function $26b90eb13321ae4f$var$wi(a, b, c) {
    var d = $26b90eb13321ae4f$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($26b90eb13321ae4f$var$Pi(a)) $26b90eb13321ae4f$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($26b90eb13321ae4f$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $26b90eb13321ae4f$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $26b90eb13321ae4f$var$vh(a, b, e, d);
        null !== c && (e = $26b90eb13321ae4f$var$Ri(), $26b90eb13321ae4f$var$ui(c, a, d, e), $26b90eb13321ae4f$var$Si(c, b, d));
    }
    $26b90eb13321ae4f$var$yc(a, d);
}
function $26b90eb13321ae4f$var$Pi(a) {
    var b = a.alternate;
    return a === $26b90eb13321ae4f$var$M || null !== b && b === $26b90eb13321ae4f$var$M;
}
function $26b90eb13321ae4f$var$Qi(a, b) {
    $26b90eb13321ae4f$var$Xh = $26b90eb13321ae4f$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $26b90eb13321ae4f$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $26b90eb13321ae4f$var$Oc(a, c);
    }
}
var $26b90eb13321ae4f$var$ei = {
    readContext: $26b90eb13321ae4f$var$sh,
    useCallback: $26b90eb13321ae4f$var$P,
    useContext: $26b90eb13321ae4f$var$P,
    useEffect: $26b90eb13321ae4f$var$P,
    useImperativeHandle: $26b90eb13321ae4f$var$P,
    useInsertionEffect: $26b90eb13321ae4f$var$P,
    useLayoutEffect: $26b90eb13321ae4f$var$P,
    useMemo: $26b90eb13321ae4f$var$P,
    useReducer: $26b90eb13321ae4f$var$P,
    useRef: $26b90eb13321ae4f$var$P,
    useState: $26b90eb13321ae4f$var$P,
    useDebugValue: $26b90eb13321ae4f$var$P,
    useDeferredValue: $26b90eb13321ae4f$var$P,
    useTransition: $26b90eb13321ae4f$var$P,
    useMutableSource: $26b90eb13321ae4f$var$P,
    useSyncExternalStore: $26b90eb13321ae4f$var$P,
    useId: $26b90eb13321ae4f$var$P,
    unstable_isNewReconciler: !1
}, $26b90eb13321ae4f$var$bi = {
    readContext: $26b90eb13321ae4f$var$sh,
    useCallback: function(a, b) {
        $26b90eb13321ae4f$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $26b90eb13321ae4f$var$sh,
    useEffect: $26b90eb13321ae4f$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $26b90eb13321ae4f$var$Ai(4194308, 4, $26b90eb13321ae4f$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $26b90eb13321ae4f$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $26b90eb13321ae4f$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $26b90eb13321ae4f$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $26b90eb13321ae4f$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $26b90eb13321ae4f$var$Ni.bind(null, $26b90eb13321ae4f$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $26b90eb13321ae4f$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $26b90eb13321ae4f$var$vi,
    useDebugValue: $26b90eb13321ae4f$var$Hi,
    useDeferredValue: function(a) {
        return $26b90eb13321ae4f$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $26b90eb13321ae4f$var$vi(!1), b = a[0];
        a = $26b90eb13321ae4f$var$Li.bind(null, a[1]);
        $26b90eb13321ae4f$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $26b90eb13321ae4f$var$M, e = $26b90eb13321ae4f$var$gi();
        if ($26b90eb13321ae4f$var$J) {
            if (void 0 === c) throw Error($26b90eb13321ae4f$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $26b90eb13321ae4f$var$Q) throw Error($26b90eb13321ae4f$var$p(349));
            0 !== ($26b90eb13321ae4f$var$Vh & 30) || $26b90eb13321ae4f$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $26b90eb13321ae4f$var$Ci($26b90eb13321ae4f$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $26b90eb13321ae4f$var$pi(9, $26b90eb13321ae4f$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $26b90eb13321ae4f$var$gi(), b = $26b90eb13321ae4f$var$Q.identifierPrefix;
        if ($26b90eb13321ae4f$var$J) {
            var c = $26b90eb13321ae4f$var$Gg;
            var d = $26b90eb13321ae4f$var$Fg;
            c = (d & ~(1 << 32 - $26b90eb13321ae4f$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $26b90eb13321ae4f$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $26b90eb13321ae4f$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $26b90eb13321ae4f$var$ci = {
    readContext: $26b90eb13321ae4f$var$sh,
    useCallback: $26b90eb13321ae4f$var$Ii,
    useContext: $26b90eb13321ae4f$var$sh,
    useEffect: $26b90eb13321ae4f$var$ni,
    useImperativeHandle: $26b90eb13321ae4f$var$Gi,
    useInsertionEffect: $26b90eb13321ae4f$var$Di,
    useLayoutEffect: $26b90eb13321ae4f$var$Ei,
    useMemo: $26b90eb13321ae4f$var$Ji,
    useReducer: $26b90eb13321ae4f$var$ji,
    useRef: $26b90eb13321ae4f$var$xi,
    useState: function() {
        return $26b90eb13321ae4f$var$ji($26b90eb13321ae4f$var$ii);
    },
    useDebugValue: $26b90eb13321ae4f$var$Hi,
    useDeferredValue: function(a) {
        var b = $26b90eb13321ae4f$var$hi();
        return $26b90eb13321ae4f$var$Ki(b, $26b90eb13321ae4f$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $26b90eb13321ae4f$var$ji($26b90eb13321ae4f$var$ii)[0], b = $26b90eb13321ae4f$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $26b90eb13321ae4f$var$li,
    useSyncExternalStore: $26b90eb13321ae4f$var$mi,
    useId: $26b90eb13321ae4f$var$Mi,
    unstable_isNewReconciler: !1
}, $26b90eb13321ae4f$var$di = {
    readContext: $26b90eb13321ae4f$var$sh,
    useCallback: $26b90eb13321ae4f$var$Ii,
    useContext: $26b90eb13321ae4f$var$sh,
    useEffect: $26b90eb13321ae4f$var$ni,
    useImperativeHandle: $26b90eb13321ae4f$var$Gi,
    useInsertionEffect: $26b90eb13321ae4f$var$Di,
    useLayoutEffect: $26b90eb13321ae4f$var$Ei,
    useMemo: $26b90eb13321ae4f$var$Ji,
    useReducer: $26b90eb13321ae4f$var$ki,
    useRef: $26b90eb13321ae4f$var$xi,
    useState: function() {
        return $26b90eb13321ae4f$var$ki($26b90eb13321ae4f$var$ii);
    },
    useDebugValue: $26b90eb13321ae4f$var$Hi,
    useDeferredValue: function(a) {
        var b = $26b90eb13321ae4f$var$hi();
        return null === $26b90eb13321ae4f$var$N ? b.memoizedState = a : $26b90eb13321ae4f$var$Ki(b, $26b90eb13321ae4f$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $26b90eb13321ae4f$var$ki($26b90eb13321ae4f$var$ii)[0], b = $26b90eb13321ae4f$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $26b90eb13321ae4f$var$li,
    useSyncExternalStore: $26b90eb13321ae4f$var$mi,
    useId: $26b90eb13321ae4f$var$Mi,
    unstable_isNewReconciler: !1
}, $26b90eb13321ae4f$var$Ti = $gZKXT.unstable_now, $26b90eb13321ae4f$var$Ui = 0, $26b90eb13321ae4f$var$Vi = -1, $26b90eb13321ae4f$var$Wi = -1, $26b90eb13321ae4f$var$Xi = -1, $26b90eb13321ae4f$var$Yi = !1, $26b90eb13321ae4f$var$Zi = !1;
function $26b90eb13321ae4f$var$$i(a, b) {
    if (0 <= $26b90eb13321ae4f$var$Wi) {
        var c = $26b90eb13321ae4f$var$Ti() - $26b90eb13321ae4f$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $26b90eb13321ae4f$var$Wi = -1;
    }
}
function $26b90eb13321ae4f$var$aj(a) {
    if (0 <= $26b90eb13321ae4f$var$Vi) {
        var b = $26b90eb13321ae4f$var$Ti() - $26b90eb13321ae4f$var$Vi;
        $26b90eb13321ae4f$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $26b90eb13321ae4f$var$bj(a) {
    if (0 <= $26b90eb13321ae4f$var$Xi) {
        var b = $26b90eb13321ae4f$var$Ti() - $26b90eb13321ae4f$var$Xi;
        $26b90eb13321ae4f$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $26b90eb13321ae4f$var$cj() {
    $26b90eb13321ae4f$var$Vi = $26b90eb13321ae4f$var$Ti();
}
function $26b90eb13321ae4f$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $26b90eb13321ae4f$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $26b90eb13321ae4f$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $26b90eb13321ae4f$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $26b90eb13321ae4f$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $26b90eb13321ae4f$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $26b90eb13321ae4f$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $26b90eb13321ae4f$var$Ri(), e = $26b90eb13321ae4f$var$Oi(a), f = $26b90eb13321ae4f$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $26b90eb13321ae4f$var$Bh(a, f, e);
        null !== b && ($26b90eb13321ae4f$var$ui(b, a, e, d), $26b90eb13321ae4f$var$Ch(b, a, e));
        $26b90eb13321ae4f$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $26b90eb13321ae4f$var$Ri(), e = $26b90eb13321ae4f$var$Oi(a), f = $26b90eb13321ae4f$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $26b90eb13321ae4f$var$Bh(a, f, e);
        null !== b && ($26b90eb13321ae4f$var$ui(b, a, e, d), $26b90eb13321ae4f$var$Ch(b, a, e));
        $26b90eb13321ae4f$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $26b90eb13321ae4f$var$Ri(), d = $26b90eb13321ae4f$var$Oi(a), e = $26b90eb13321ae4f$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $26b90eb13321ae4f$var$Bh(a, e, d);
        null !== b && ($26b90eb13321ae4f$var$ui(b, a, d, c), $26b90eb13321ae4f$var$Ch(b, a, d));
        null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markForceUpdateScheduled && $26b90eb13321ae4f$var$B.markForceUpdateScheduled(a, d);
    }
};
function $26b90eb13321ae4f$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$26b90eb13321ae4f$var$We(c, d) || !$26b90eb13321ae4f$var$We(e, f) : !0;
}
function $26b90eb13321ae4f$var$ij(a, b, c) {
    var d = !1, e = $26b90eb13321ae4f$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $26b90eb13321ae4f$var$sh(f) : (e = $26b90eb13321ae4f$var$mg(b) ? $26b90eb13321ae4f$var$kg : $26b90eb13321ae4f$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $26b90eb13321ae4f$var$lg(a, e) : $26b90eb13321ae4f$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $26b90eb13321ae4f$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $26b90eb13321ae4f$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $26b90eb13321ae4f$var$gj.enqueueReplaceState(b, b.state, null);
}
function $26b90eb13321ae4f$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $26b90eb13321ae4f$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $26b90eb13321ae4f$var$sh(f) : (f = $26b90eb13321ae4f$var$mg(b) ? $26b90eb13321ae4f$var$kg : $26b90eb13321ae4f$var$I.current, e.context = $26b90eb13321ae4f$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($26b90eb13321ae4f$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $26b90eb13321ae4f$var$gj.enqueueReplaceState(e, e.state, null), $26b90eb13321ae4f$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $26b90eb13321ae4f$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $26b90eb13321ae4f$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $26b90eb13321ae4f$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $26b90eb13321ae4f$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $26b90eb13321ae4f$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $26b90eb13321ae4f$var$pj(a, b, c) {
    c = $26b90eb13321ae4f$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $26b90eb13321ae4f$var$qj || ($26b90eb13321ae4f$var$qj = !0, $26b90eb13321ae4f$var$rj = d);
        $26b90eb13321ae4f$var$nj(a, b);
    };
    return c;
}
function $26b90eb13321ae4f$var$sj(a, b, c) {
    c = $26b90eb13321ae4f$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $26b90eb13321ae4f$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $26b90eb13321ae4f$var$nj(a, b);
        "function" !== typeof d && (null === $26b90eb13321ae4f$var$tj ? $26b90eb13321ae4f$var$tj = new Set([
            this
        ]) : $26b90eb13321ae4f$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $26b90eb13321ae4f$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $26b90eb13321ae4f$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $26b90eb13321ae4f$var$vj.bind(null, a, b, c), $26b90eb13321ae4f$var$mc && $26b90eb13321ae4f$var$wj(a, c), b.then(d, d));
}
function $26b90eb13321ae4f$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $26b90eb13321ae4f$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $26b90eb13321ae4f$var$Ah(-1, 1), b.tag = 2, $26b90eb13321ae4f$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $26b90eb13321ae4f$var$zj = $26b90eb13321ae4f$var$va.ReactCurrentOwner, $26b90eb13321ae4f$var$rh = !1;
function $26b90eb13321ae4f$var$Aj(a, b, c, d) {
    b.child = null === a ? $26b90eb13321ae4f$var$ih(b, null, c, d) : $26b90eb13321ae4f$var$hh(b, a.child, c, d);
}
function $26b90eb13321ae4f$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $26b90eb13321ae4f$var$qh(b, e);
    $26b90eb13321ae4f$var$sc(b);
    d = $26b90eb13321ae4f$var$ai(a, b, c, d, f, e);
    c = $26b90eb13321ae4f$var$fi();
    $26b90eb13321ae4f$var$tc();
    if (null !== a && !$26b90eb13321ae4f$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $26b90eb13321ae4f$var$Cj(a, b, e);
    $26b90eb13321ae4f$var$J && c && $26b90eb13321ae4f$var$Jg(b);
    b.flags |= 1;
    $26b90eb13321ae4f$var$Aj(a, b, d, e);
    return b.child;
}
function $26b90eb13321ae4f$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$26b90eb13321ae4f$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $26b90eb13321ae4f$var$Fj(a, b, f, d, e);
        a = $26b90eb13321ae4f$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $26b90eb13321ae4f$var$We;
        if (c(g, d) && a.ref === b.ref) return $26b90eb13321ae4f$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $26b90eb13321ae4f$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $26b90eb13321ae4f$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($26b90eb13321ae4f$var$We(f, d) && a.ref === b.ref) {
            if ($26b90eb13321ae4f$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($26b90eb13321ae4f$var$rh = !0);
            else return b.lanes = a.lanes, $26b90eb13321ae4f$var$Cj(a, b, e);
        }
    }
    return $26b90eb13321ae4f$var$Gj(a, b, c, d, e);
}
function $26b90eb13321ae4f$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Ij, $26b90eb13321ae4f$var$Jj), $26b90eb13321ae4f$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Ij, $26b90eb13321ae4f$var$Jj), $26b90eb13321ae4f$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Ij, $26b90eb13321ae4f$var$Jj);
            $26b90eb13321ae4f$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$Ij, $26b90eb13321ae4f$var$Jj), $26b90eb13321ae4f$var$Jj |= d;
    $26b90eb13321ae4f$var$Aj(a, b, e, c);
    return b.child;
}
function $26b90eb13321ae4f$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $26b90eb13321ae4f$var$Gj(a, b, c, d, e) {
    var f = $26b90eb13321ae4f$var$mg(c) ? $26b90eb13321ae4f$var$kg : $26b90eb13321ae4f$var$I.current;
    f = $26b90eb13321ae4f$var$lg(b, f);
    $26b90eb13321ae4f$var$qh(b, e);
    $26b90eb13321ae4f$var$sc(b);
    c = $26b90eb13321ae4f$var$ai(a, b, c, d, f, e);
    d = $26b90eb13321ae4f$var$fi();
    $26b90eb13321ae4f$var$tc();
    if (null !== a && !$26b90eb13321ae4f$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $26b90eb13321ae4f$var$Cj(a, b, e);
    $26b90eb13321ae4f$var$J && d && $26b90eb13321ae4f$var$Jg(b);
    b.flags |= 1;
    $26b90eb13321ae4f$var$Aj(a, b, c, e);
    return b.child;
}
function $26b90eb13321ae4f$var$Lj(a, b, c, d, e) {
    if ($26b90eb13321ae4f$var$mg(c)) {
        var f = !0;
        $26b90eb13321ae4f$var$qg(b);
    } else f = !1;
    $26b90eb13321ae4f$var$qh(b, e);
    if (null === b.stateNode) $26b90eb13321ae4f$var$Mj(a, b), $26b90eb13321ae4f$var$ij(b, c, d), $26b90eb13321ae4f$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $26b90eb13321ae4f$var$sh(l) : (l = $26b90eb13321ae4f$var$mg(c) ? $26b90eb13321ae4f$var$kg : $26b90eb13321ae4f$var$I.current, l = $26b90eb13321ae4f$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $26b90eb13321ae4f$var$jj(b, g, d, l);
        $26b90eb13321ae4f$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $26b90eb13321ae4f$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $26b90eb13321ae4f$var$jg.current || $26b90eb13321ae4f$var$xh ? ("function" === typeof n && ($26b90eb13321ae4f$var$fj(b, c, n, d), k = b.memoizedState), (h = $26b90eb13321ae4f$var$xh || $26b90eb13321ae4f$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $26b90eb13321ae4f$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $26b90eb13321ae4f$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $26b90eb13321ae4f$var$sh(k) : (k = $26b90eb13321ae4f$var$mg(c) ? $26b90eb13321ae4f$var$kg : $26b90eb13321ae4f$var$I.current, k = $26b90eb13321ae4f$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $26b90eb13321ae4f$var$jj(b, g, d, k);
        $26b90eb13321ae4f$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $26b90eb13321ae4f$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $26b90eb13321ae4f$var$jg.current || $26b90eb13321ae4f$var$xh ? ("function" === typeof z && ($26b90eb13321ae4f$var$fj(b, c, z, d), m = b.memoizedState), (l = $26b90eb13321ae4f$var$xh || $26b90eb13321ae4f$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $26b90eb13321ae4f$var$Nj(a, b, c, d, f, e);
}
function $26b90eb13321ae4f$var$Nj(a, b, c, d, e, f) {
    $26b90eb13321ae4f$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $26b90eb13321ae4f$var$rg(b, c, !1), $26b90eb13321ae4f$var$Cj(a, b, f);
    d = b.stateNode;
    $26b90eb13321ae4f$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $26b90eb13321ae4f$var$Wi = -1;
    } else $26b90eb13321ae4f$var$sc(b), h = d.render(), $26b90eb13321ae4f$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $26b90eb13321ae4f$var$hh(b, a.child, null, f), b.child = $26b90eb13321ae4f$var$hh(b, null, g, f)) : $26b90eb13321ae4f$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $26b90eb13321ae4f$var$rg(b, c, !0);
    return b.child;
}
function $26b90eb13321ae4f$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $26b90eb13321ae4f$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $26b90eb13321ae4f$var$og(a, b.context, !1);
    $26b90eb13321ae4f$var$Mh(a, b.containerInfo);
}
function $26b90eb13321ae4f$var$Rj(a, b, c, d, e) {
    $26b90eb13321ae4f$var$Wg();
    $26b90eb13321ae4f$var$Xg(e);
    b.flags |= 256;
    $26b90eb13321ae4f$var$Aj(a, b, c, d);
    return b.child;
}
var $26b90eb13321ae4f$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $26b90eb13321ae4f$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $26b90eb13321ae4f$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $26b90eb13321ae4f$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$L, e & 1);
    if (null === a) {
        $26b90eb13321ae4f$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $26b90eb13321ae4f$var$Vj(g, d, 0, null), a = $26b90eb13321ae4f$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $26b90eb13321ae4f$var$Tj(c), b.memoizedState = $26b90eb13321ae4f$var$Sj, a) : $26b90eb13321ae4f$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $26b90eb13321ae4f$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $26b90eb13321ae4f$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $26b90eb13321ae4f$var$ch(h, f) : (f = $26b90eb13321ae4f$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $26b90eb13321ae4f$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $26b90eb13321ae4f$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $26b90eb13321ae4f$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $26b90eb13321ae4f$var$Wj(a, b) {
    b = $26b90eb13321ae4f$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $26b90eb13321ae4f$var$Yj(a, b, c, d) {
    null !== d && $26b90eb13321ae4f$var$Xg(d);
    $26b90eb13321ae4f$var$hh(b, a.child, null, c);
    a = $26b90eb13321ae4f$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $26b90eb13321ae4f$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $26b90eb13321ae4f$var$mj(Error($26b90eb13321ae4f$var$p(422))), $26b90eb13321ae4f$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $26b90eb13321ae4f$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $26b90eb13321ae4f$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $26b90eb13321ae4f$var$hh(b, a.child, null, g);
        b.child.memoizedState = $26b90eb13321ae4f$var$Tj(g);
        b.memoizedState = $26b90eb13321ae4f$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $26b90eb13321ae4f$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($26b90eb13321ae4f$var$p(419));
        d = $26b90eb13321ae4f$var$mj(f, d, void 0);
        return $26b90eb13321ae4f$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($26b90eb13321ae4f$var$rh || h) {
        d = $26b90eb13321ae4f$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $26b90eb13321ae4f$var$wh(a, e), $26b90eb13321ae4f$var$ui(d, a, e, -1));
        }
        $26b90eb13321ae4f$var$Zj();
        d = $26b90eb13321ae4f$var$mj(Error($26b90eb13321ae4f$var$p(421)));
        return $26b90eb13321ae4f$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $26b90eb13321ae4f$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $26b90eb13321ae4f$var$Mg = $26b90eb13321ae4f$var$Zf(e.nextSibling);
    $26b90eb13321ae4f$var$Lg = b;
    $26b90eb13321ae4f$var$J = !0;
    $26b90eb13321ae4f$var$Ng = null;
    null !== a && ($26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg++] = $26b90eb13321ae4f$var$Fg, $26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg++] = $26b90eb13321ae4f$var$Gg, $26b90eb13321ae4f$var$Cg[$26b90eb13321ae4f$var$Dg++] = $26b90eb13321ae4f$var$Eg, $26b90eb13321ae4f$var$Fg = a.id, $26b90eb13321ae4f$var$Gg = a.overflow, $26b90eb13321ae4f$var$Eg = b);
    b = $26b90eb13321ae4f$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $26b90eb13321ae4f$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $26b90eb13321ae4f$var$ph(a.return, b, c);
}
function $26b90eb13321ae4f$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $26b90eb13321ae4f$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $26b90eb13321ae4f$var$Aj(a, b, d.children, c);
    d = $26b90eb13321ae4f$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $26b90eb13321ae4f$var$bk(a, c, b);
            else if (19 === a.tag) $26b90eb13321ae4f$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $26b90eb13321ae4f$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $26b90eb13321ae4f$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $26b90eb13321ae4f$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $26b90eb13321ae4f$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $26b90eb13321ae4f$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $26b90eb13321ae4f$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $26b90eb13321ae4f$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $26b90eb13321ae4f$var$Wi = -1;
    $26b90eb13321ae4f$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($26b90eb13321ae4f$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $26b90eb13321ae4f$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $26b90eb13321ae4f$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $26b90eb13321ae4f$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $26b90eb13321ae4f$var$Oj(b);
            $26b90eb13321ae4f$var$Wg();
            break;
        case 5:
            $26b90eb13321ae4f$var$Oh(b);
            break;
        case 1:
            $26b90eb13321ae4f$var$mg(b.type) && $26b90eb13321ae4f$var$qg(b);
            break;
        case 4:
            $26b90eb13321ae4f$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$L, $26b90eb13321ae4f$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $26b90eb13321ae4f$var$Uj(a, b, c);
                $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$L, $26b90eb13321ae4f$var$L.current & 1);
                a = $26b90eb13321ae4f$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$L, $26b90eb13321ae4f$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $26b90eb13321ae4f$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$L, $26b90eb13321ae4f$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $26b90eb13321ae4f$var$Hj(a, b, c);
    }
    return $26b90eb13321ae4f$var$Cj(a, b, c);
}
var $26b90eb13321ae4f$var$fk, $26b90eb13321ae4f$var$gk, $26b90eb13321ae4f$var$hk, $26b90eb13321ae4f$var$ik;
$26b90eb13321ae4f$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$26b90eb13321ae4f$var$gk = function() {};
$26b90eb13321ae4f$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $26b90eb13321ae4f$var$Lh($26b90eb13321ae4f$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $26b90eb13321ae4f$var$Ya(a, e);
                d = $26b90eb13321ae4f$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $26b90eb13321ae4f$var$u({}, e, {
                    value: void 0
                });
                d = $26b90eb13321ae4f$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $26b90eb13321ae4f$var$fb(a, e);
                d = $26b90eb13321ae4f$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $26b90eb13321ae4f$var$Pf);
        }
        $26b90eb13321ae4f$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($26b90eb13321ae4f$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($26b90eb13321ae4f$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $26b90eb13321ae4f$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$26b90eb13321ae4f$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $26b90eb13321ae4f$var$jk(a, b) {
    if (!$26b90eb13321ae4f$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $26b90eb13321ae4f$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $26b90eb13321ae4f$var$kk(a, b, c) {
    var d = b.pendingProps;
    $26b90eb13321ae4f$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $26b90eb13321ae4f$var$S(b), null;
        case 1:
            return $26b90eb13321ae4f$var$mg(b.type) && $26b90eb13321ae4f$var$ng(), $26b90eb13321ae4f$var$S(b), null;
        case 3:
            d = b.stateNode;
            $26b90eb13321ae4f$var$Nh();
            $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$jg);
            $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$I);
            $26b90eb13321ae4f$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $26b90eb13321ae4f$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $26b90eb13321ae4f$var$Ng && ($26b90eb13321ae4f$var$lk($26b90eb13321ae4f$var$Ng), $26b90eb13321ae4f$var$Ng = null));
            $26b90eb13321ae4f$var$gk(a, b);
            $26b90eb13321ae4f$var$S(b);
            return null;
        case 5:
            $26b90eb13321ae4f$var$Ph(b);
            var e = $26b90eb13321ae4f$var$Lh($26b90eb13321ae4f$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $26b90eb13321ae4f$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($26b90eb13321ae4f$var$p(166));
                    $26b90eb13321ae4f$var$S(b);
                    return null;
                }
                a = $26b90eb13321ae4f$var$Lh($26b90eb13321ae4f$var$Ih.current);
                if ($26b90eb13321ae4f$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$26b90eb13321ae4f$var$bg] = b;
                    d[$26b90eb13321ae4f$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $26b90eb13321ae4f$var$F("cancel", d);
                            $26b90eb13321ae4f$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $26b90eb13321ae4f$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $26b90eb13321ae4f$var$zf.length; e++)$26b90eb13321ae4f$var$F($26b90eb13321ae4f$var$zf[e], d);
                            break;
                        case "source":
                            $26b90eb13321ae4f$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $26b90eb13321ae4f$var$F("error", d);
                            $26b90eb13321ae4f$var$F("load", d);
                            break;
                        case "details":
                            $26b90eb13321ae4f$var$F("toggle", d);
                            break;
                        case "input":
                            $26b90eb13321ae4f$var$Za(d, c);
                            $26b90eb13321ae4f$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $26b90eb13321ae4f$var$F("invalid", d);
                            break;
                        case "textarea":
                            $26b90eb13321ae4f$var$gb(d, c), $26b90eb13321ae4f$var$F("invalid", d);
                    }
                    $26b90eb13321ae4f$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $26b90eb13321ae4f$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $26b90eb13321ae4f$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $26b90eb13321ae4f$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $26b90eb13321ae4f$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $26b90eb13321ae4f$var$Va(d);
                            $26b90eb13321ae4f$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $26b90eb13321ae4f$var$Va(d);
                            $26b90eb13321ae4f$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $26b90eb13321ae4f$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $26b90eb13321ae4f$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$26b90eb13321ae4f$var$bg] = b;
                    a[$26b90eb13321ae4f$var$cg] = d;
                    $26b90eb13321ae4f$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $26b90eb13321ae4f$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $26b90eb13321ae4f$var$F("cancel", a);
                                $26b90eb13321ae4f$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $26b90eb13321ae4f$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $26b90eb13321ae4f$var$zf.length; e++)$26b90eb13321ae4f$var$F($26b90eb13321ae4f$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $26b90eb13321ae4f$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $26b90eb13321ae4f$var$F("error", a);
                                $26b90eb13321ae4f$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $26b90eb13321ae4f$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $26b90eb13321ae4f$var$Za(a, d);
                                e = $26b90eb13321ae4f$var$Ya(a, d);
                                $26b90eb13321ae4f$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $26b90eb13321ae4f$var$u({}, d, {
                                    value: void 0
                                });
                                $26b90eb13321ae4f$var$F("invalid", a);
                                break;
                            case "textarea":
                                $26b90eb13321ae4f$var$gb(a, d);
                                e = $26b90eb13321ae4f$var$fb(a, d);
                                $26b90eb13321ae4f$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $26b90eb13321ae4f$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $26b90eb13321ae4f$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $26b90eb13321ae4f$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $26b90eb13321ae4f$var$ob(a, k) : "number" === typeof k && $26b90eb13321ae4f$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($26b90eb13321ae4f$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $26b90eb13321ae4f$var$F("scroll", a) : null != k && $26b90eb13321ae4f$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $26b90eb13321ae4f$var$Va(a);
                                $26b90eb13321ae4f$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $26b90eb13321ae4f$var$Va(a);
                                $26b90eb13321ae4f$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $26b90eb13321ae4f$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $26b90eb13321ae4f$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $26b90eb13321ae4f$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $26b90eb13321ae4f$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $26b90eb13321ae4f$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $26b90eb13321ae4f$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($26b90eb13321ae4f$var$p(166));
                a = $26b90eb13321ae4f$var$Lh($26b90eb13321ae4f$var$Kh.current);
                $26b90eb13321ae4f$var$Lh($26b90eb13321ae4f$var$Ih.current);
                if ($26b90eb13321ae4f$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$26b90eb13321ae4f$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $26b90eb13321ae4f$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $26b90eb13321ae4f$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $26b90eb13321ae4f$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$26b90eb13321ae4f$var$bg] = b, b.stateNode = d;
            }
            $26b90eb13321ae4f$var$S(b);
            return null;
        case 13:
            $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($26b90eb13321ae4f$var$J && null !== $26b90eb13321ae4f$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $26b90eb13321ae4f$var$Vg(), $26b90eb13321ae4f$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $26b90eb13321ae4f$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($26b90eb13321ae4f$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($26b90eb13321ae4f$var$p(317));
                        f[$26b90eb13321ae4f$var$bg] = b;
                        $26b90eb13321ae4f$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $26b90eb13321ae4f$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $26b90eb13321ae4f$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $26b90eb13321ae4f$var$Ng && ($26b90eb13321ae4f$var$lk($26b90eb13321ae4f$var$Ng), $26b90eb13321ae4f$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $26b90eb13321ae4f$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($26b90eb13321ae4f$var$L.current & 1) ? 0 === $26b90eb13321ae4f$var$T && ($26b90eb13321ae4f$var$T = 3) : $26b90eb13321ae4f$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $26b90eb13321ae4f$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $26b90eb13321ae4f$var$Nh(), $26b90eb13321ae4f$var$gk(a, b), null === a && $26b90eb13321ae4f$var$Gf(b.stateNode.containerInfo), $26b90eb13321ae4f$var$S(b), null;
        case 10:
            return $26b90eb13321ae4f$var$oh(b.type._context), $26b90eb13321ae4f$var$S(b), null;
        case 17:
            return $26b90eb13321ae4f$var$mg(b.type) && $26b90eb13321ae4f$var$ng(), $26b90eb13321ae4f$var$S(b), null;
        case 19:
            $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$L);
            f = b.memoizedState;
            if (null === f) return $26b90eb13321ae4f$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $26b90eb13321ae4f$var$jk(f, !1);
                else {
                    if (0 !== $26b90eb13321ae4f$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $26b90eb13321ae4f$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $26b90eb13321ae4f$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$L, $26b90eb13321ae4f$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $26b90eb13321ae4f$var$A() > $26b90eb13321ae4f$var$mk && (b.flags |= 128, d = !0, $26b90eb13321ae4f$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $26b90eb13321ae4f$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $26b90eb13321ae4f$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$26b90eb13321ae4f$var$J) return $26b90eb13321ae4f$var$S(b), null;
                    } else 2 * $26b90eb13321ae4f$var$A() - f.renderingStartTime > $26b90eb13321ae4f$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $26b90eb13321ae4f$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $26b90eb13321ae4f$var$A(), b.sibling = null, a = $26b90eb13321ae4f$var$L.current, $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$L, d ? a & 1 | 2 : a & 1), b;
            $26b90eb13321ae4f$var$S(b);
            return null;
        case 22:
        case 23:
            return $26b90eb13321ae4f$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($26b90eb13321ae4f$var$Jj & 1073741824) && ($26b90eb13321ae4f$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $26b90eb13321ae4f$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($26b90eb13321ae4f$var$p(156, b.tag));
}
function $26b90eb13321ae4f$var$ok(a, b) {
    $26b90eb13321ae4f$var$Kg(b);
    switch(b.tag){
        case 1:
            return $26b90eb13321ae4f$var$mg(b.type) && $26b90eb13321ae4f$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $26b90eb13321ae4f$var$dj(b), b) : null;
        case 3:
            return $26b90eb13321ae4f$var$Nh(), $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$jg), $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$I), $26b90eb13321ae4f$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $26b90eb13321ae4f$var$Ph(b), null;
        case 13:
            $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($26b90eb13321ae4f$var$p(340));
                $26b90eb13321ae4f$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $26b90eb13321ae4f$var$dj(b), b) : null;
        case 19:
            return $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$L), null;
        case 4:
            return $26b90eb13321ae4f$var$Nh(), null;
        case 10:
            return $26b90eb13321ae4f$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $26b90eb13321ae4f$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $26b90eb13321ae4f$var$pk = !1, $26b90eb13321ae4f$var$qk = !1, $26b90eb13321ae4f$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $26b90eb13321ae4f$var$U = null, $26b90eb13321ae4f$var$sk = null, $26b90eb13321ae4f$var$tk = null;
function $26b90eb13321ae4f$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $26b90eb13321ae4f$var$cj(), b.componentWillUnmount();
    } finally{
        $26b90eb13321ae4f$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $26b90eb13321ae4f$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $26b90eb13321ae4f$var$cj(), c(null);
            } finally{
                $26b90eb13321ae4f$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $26b90eb13321ae4f$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $26b90eb13321ae4f$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $26b90eb13321ae4f$var$W(a, b, d);
    }
}
var $26b90eb13321ae4f$var$xk = !1;
function $26b90eb13321ae4f$var$yk(a, b) {
    $26b90eb13321ae4f$var$Qf = $26b90eb13321ae4f$var$rd;
    a = $26b90eb13321ae4f$var$$e();
    if ($26b90eb13321ae4f$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $26b90eb13321ae4f$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $26b90eb13321ae4f$var$rd = !1;
    for($26b90eb13321ae4f$var$U = b; null !== $26b90eb13321ae4f$var$U;)if (b = $26b90eb13321ae4f$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $26b90eb13321ae4f$var$U = a;
    else for(; null !== $26b90eb13321ae4f$var$U;){
        b = $26b90eb13321ae4f$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $26b90eb13321ae4f$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($26b90eb13321ae4f$var$p(163));
            }
        } catch (D) {
            $26b90eb13321ae4f$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $26b90eb13321ae4f$var$U = a;
            break;
        }
        $26b90eb13321ae4f$var$U = b.return;
    }
    m = $26b90eb13321ae4f$var$xk;
    $26b90eb13321ae4f$var$xk = !1;
    return m;
}
function $26b90eb13321ae4f$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentPassiveEffectUnmountStarted && $26b90eb13321ae4f$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $26b90eb13321ae4f$var$uc(b), $26b90eb13321ae4f$var$wk(b, c, f), 0 !== (a & 8) ? null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentPassiveEffectUnmountStopped && $26b90eb13321ae4f$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $26b90eb13321ae4f$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $26b90eb13321ae4f$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentPassiveEffectMountStarted && $26b90eb13321ae4f$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentLayoutEffectMountStarted && $26b90eb13321ae4f$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentPassiveEffectMountStopped && $26b90eb13321ae4f$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentLayoutEffectMountStopped && $26b90eb13321ae4f$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $26b90eb13321ae4f$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $26b90eb13321ae4f$var$cj(), b(c);
            } finally{
                $26b90eb13321ae4f$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $26b90eb13321ae4f$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $26b90eb13321ae4f$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$26b90eb13321ae4f$var$bg], delete b[$26b90eb13321ae4f$var$cg], delete b[$26b90eb13321ae4f$var$Cf], delete b[$26b90eb13321ae4f$var$dg], delete b[$26b90eb13321ae4f$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $26b90eb13321ae4f$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $26b90eb13321ae4f$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $26b90eb13321ae4f$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $26b90eb13321ae4f$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $26b90eb13321ae4f$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($26b90eb13321ae4f$var$Fk(a, b, c), a = a.sibling; null !== a;)$26b90eb13321ae4f$var$Fk(a, b, c), a = a.sibling;
}
function $26b90eb13321ae4f$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($26b90eb13321ae4f$var$Gk(a, b, c), a = a.sibling; null !== a;)$26b90eb13321ae4f$var$Gk(a, b, c), a = a.sibling;
}
var $26b90eb13321ae4f$var$X = null, $26b90eb13321ae4f$var$Hk = !1;
function $26b90eb13321ae4f$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$26b90eb13321ae4f$var$Jk(a, b, c), c = c.sibling;
}
function $26b90eb13321ae4f$var$Jk(a, b, c) {
    if ($26b90eb13321ae4f$var$lc && "function" === typeof $26b90eb13321ae4f$var$lc.onCommitFiberUnmount) try {
        $26b90eb13321ae4f$var$lc.onCommitFiberUnmount($26b90eb13321ae4f$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $26b90eb13321ae4f$var$qk || $26b90eb13321ae4f$var$vk(c, b);
        case 6:
            var d = $26b90eb13321ae4f$var$X, e = $26b90eb13321ae4f$var$Hk;
            $26b90eb13321ae4f$var$X = null;
            $26b90eb13321ae4f$var$Ik(a, b, c);
            $26b90eb13321ae4f$var$X = d;
            $26b90eb13321ae4f$var$Hk = e;
            null !== $26b90eb13321ae4f$var$X && ($26b90eb13321ae4f$var$Hk ? (a = $26b90eb13321ae4f$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $26b90eb13321ae4f$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $26b90eb13321ae4f$var$X && ($26b90eb13321ae4f$var$Hk ? (a = $26b90eb13321ae4f$var$X, c = c.stateNode, 8 === a.nodeType ? $26b90eb13321ae4f$var$Yf(a.parentNode, c) : 1 === a.nodeType && $26b90eb13321ae4f$var$Yf(a, c), $26b90eb13321ae4f$var$pd(a)) : $26b90eb13321ae4f$var$Yf($26b90eb13321ae4f$var$X, c.stateNode));
            break;
        case 4:
            d = $26b90eb13321ae4f$var$X;
            e = $26b90eb13321ae4f$var$Hk;
            $26b90eb13321ae4f$var$X = c.stateNode.containerInfo;
            $26b90eb13321ae4f$var$Hk = !0;
            $26b90eb13321ae4f$var$Ik(a, b, c);
            $26b90eb13321ae4f$var$X = d;
            $26b90eb13321ae4f$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$26b90eb13321ae4f$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $26b90eb13321ae4f$var$wk(c, b, g) : 0 !== (f & 4) && ($26b90eb13321ae4f$var$uc(c), c.mode & 2 ? ($26b90eb13321ae4f$var$cj(), $26b90eb13321ae4f$var$wk(c, b, g), $26b90eb13321ae4f$var$aj(c)) : $26b90eb13321ae4f$var$wk(c, b, g), $26b90eb13321ae4f$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $26b90eb13321ae4f$var$Ik(a, b, c);
            break;
        case 1:
            if (!$26b90eb13321ae4f$var$qk && ($26b90eb13321ae4f$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $26b90eb13321ae4f$var$uk(c, d);
            } catch (h) {
                $26b90eb13321ae4f$var$W(c, b, h);
            }
            $26b90eb13321ae4f$var$Ik(a, b, c);
            break;
        case 21:
            $26b90eb13321ae4f$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($26b90eb13321ae4f$var$qk = (d = $26b90eb13321ae4f$var$qk) || null !== c.memoizedState, $26b90eb13321ae4f$var$Ik(a, b, c), $26b90eb13321ae4f$var$qk = d) : $26b90eb13321ae4f$var$Ik(a, b, c);
            break;
        default:
            $26b90eb13321ae4f$var$Ik(a, b, c);
    }
}
function $26b90eb13321ae4f$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $26b90eb13321ae4f$var$rk);
        b.forEach(function(b) {
            var d = $26b90eb13321ae4f$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($26b90eb13321ae4f$var$mc) {
                    if (null !== $26b90eb13321ae4f$var$sk && null !== $26b90eb13321ae4f$var$tk) $26b90eb13321ae4f$var$wj($26b90eb13321ae4f$var$tk, $26b90eb13321ae4f$var$sk);
                    else throw Error($26b90eb13321ae4f$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $26b90eb13321ae4f$var$Mk(a, b, c) {
    $26b90eb13321ae4f$var$sk = c;
    $26b90eb13321ae4f$var$tk = a;
    $26b90eb13321ae4f$var$Nk(b, a);
    $26b90eb13321ae4f$var$tk = $26b90eb13321ae4f$var$sk = null;
}
function $26b90eb13321ae4f$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $26b90eb13321ae4f$var$X = h.stateNode;
                        $26b90eb13321ae4f$var$Hk = !1;
                        break a;
                    case 3:
                        $26b90eb13321ae4f$var$X = h.stateNode.containerInfo;
                        $26b90eb13321ae4f$var$Hk = !0;
                        break a;
                    case 4:
                        $26b90eb13321ae4f$var$X = h.stateNode.containerInfo;
                        $26b90eb13321ae4f$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $26b90eb13321ae4f$var$X) throw Error($26b90eb13321ae4f$var$p(160));
            $26b90eb13321ae4f$var$Jk(f, g, e);
            $26b90eb13321ae4f$var$X = null;
            $26b90eb13321ae4f$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $26b90eb13321ae4f$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$26b90eb13321ae4f$var$Nk(b, a), b = b.sibling;
}
function $26b90eb13321ae4f$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            if (d & 4) {
                try {
                    $26b90eb13321ae4f$var$zk(3, a, a.return), $26b90eb13321ae4f$var$Ak(3, a);
                } catch (m) {
                    $26b90eb13321ae4f$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $26b90eb13321ae4f$var$cj(), $26b90eb13321ae4f$var$zk(5, a, a.return);
                    } catch (m) {
                        $26b90eb13321ae4f$var$W(a, a.return, m);
                    }
                    $26b90eb13321ae4f$var$aj(a);
                } else try {
                    $26b90eb13321ae4f$var$zk(5, a, a.return);
                } catch (m) {
                    $26b90eb13321ae4f$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            d & 512 && null !== c && $26b90eb13321ae4f$var$vk(c, c.return);
            break;
        case 5:
            $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            d & 512 && null !== c && $26b90eb13321ae4f$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $26b90eb13321ae4f$var$ob(e, "");
                } catch (m) {
                    $26b90eb13321ae4f$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $26b90eb13321ae4f$var$$a(e, f);
                    $26b90eb13321ae4f$var$vb(h, g);
                    var l = $26b90eb13321ae4f$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $26b90eb13321ae4f$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $26b90eb13321ae4f$var$nb(e, q) : "children" === n ? $26b90eb13321ae4f$var$ob(e, q) : $26b90eb13321ae4f$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $26b90eb13321ae4f$var$ab(e, f);
                            break;
                        case "textarea":
                            $26b90eb13321ae4f$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $26b90eb13321ae4f$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $26b90eb13321ae4f$var$eb(e, !!f.multiple, f.defaultValue, !0) : $26b90eb13321ae4f$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$26b90eb13321ae4f$var$cg] = f;
                } catch (m) {
                    $26b90eb13321ae4f$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($26b90eb13321ae4f$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $26b90eb13321ae4f$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $26b90eb13321ae4f$var$pd(b.containerInfo);
            } catch (m) {
                $26b90eb13321ae4f$var$W(a, a.return, m);
            }
            break;
        case 4:
            $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            break;
        case 13:
            $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($26b90eb13321ae4f$var$Qk = $26b90eb13321ae4f$var$A()));
            d & 4 && $26b90eb13321ae4f$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($26b90eb13321ae4f$var$qk = (l = $26b90eb13321ae4f$var$qk) || n, $26b90eb13321ae4f$var$Ok(b, a), $26b90eb13321ae4f$var$qk = l) : $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($26b90eb13321ae4f$var$U = a, n = a.child; null !== n;){
                    for(q = $26b90eb13321ae4f$var$U = n; null !== $26b90eb13321ae4f$var$U;){
                        r = $26b90eb13321ae4f$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $26b90eb13321ae4f$var$cj(), $26b90eb13321ae4f$var$zk(4, r, r.return);
                                } finally{
                                    $26b90eb13321ae4f$var$aj(r);
                                }
                                else $26b90eb13321ae4f$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $26b90eb13321ae4f$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $26b90eb13321ae4f$var$uk(c, d);
                                    } catch (m) {
                                        $26b90eb13321ae4f$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $26b90eb13321ae4f$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $26b90eb13321ae4f$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $26b90eb13321ae4f$var$U = z) : $26b90eb13321ae4f$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $26b90eb13321ae4f$var$rb("display", g));
                            } catch (m) {
                                $26b90eb13321ae4f$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $26b90eb13321ae4f$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $26b90eb13321ae4f$var$Ok(b, a);
            $26b90eb13321ae4f$var$Pk(a);
            d & 4 && $26b90eb13321ae4f$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $26b90eb13321ae4f$var$Ok(b, a), $26b90eb13321ae4f$var$Pk(a);
    }
}
function $26b90eb13321ae4f$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($26b90eb13321ae4f$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($26b90eb13321ae4f$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($26b90eb13321ae4f$var$ob(e, ""), d.flags &= -33);
                    var f = $26b90eb13321ae4f$var$Ek(a);
                    $26b90eb13321ae4f$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $26b90eb13321ae4f$var$Ek(a);
                    $26b90eb13321ae4f$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($26b90eb13321ae4f$var$p(161));
            }
        } catch (k) {
            $26b90eb13321ae4f$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $26b90eb13321ae4f$var$Sk(a, b, c) {
    $26b90eb13321ae4f$var$sk = c;
    $26b90eb13321ae4f$var$tk = b;
    $26b90eb13321ae4f$var$U = a;
    $26b90eb13321ae4f$var$Tk(a, b, c);
    $26b90eb13321ae4f$var$tk = $26b90eb13321ae4f$var$sk = null;
}
function $26b90eb13321ae4f$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $26b90eb13321ae4f$var$U;){
        var e = $26b90eb13321ae4f$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $26b90eb13321ae4f$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $26b90eb13321ae4f$var$qk;
                h = $26b90eb13321ae4f$var$pk;
                var l = $26b90eb13321ae4f$var$qk;
                $26b90eb13321ae4f$var$pk = g;
                if (($26b90eb13321ae4f$var$qk = k) && !l) for($26b90eb13321ae4f$var$U = e; null !== $26b90eb13321ae4f$var$U;)g = $26b90eb13321ae4f$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $26b90eb13321ae4f$var$Uk(e) : null !== k ? (k.return = g, $26b90eb13321ae4f$var$U = k) : $26b90eb13321ae4f$var$Uk(e);
                for(; null !== f;)$26b90eb13321ae4f$var$U = f, $26b90eb13321ae4f$var$Tk(f, b, c), f = f.sibling;
                $26b90eb13321ae4f$var$U = e;
                $26b90eb13321ae4f$var$pk = h;
                $26b90eb13321ae4f$var$qk = l;
            }
            $26b90eb13321ae4f$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $26b90eb13321ae4f$var$U = f) : $26b90eb13321ae4f$var$Vk(a, b, c);
    }
}
function $26b90eb13321ae4f$var$Vk(a) {
    for(; null !== $26b90eb13321ae4f$var$U;){
        var b = $26b90eb13321ae4f$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$26b90eb13321ae4f$var$qk) {
                            if (b.mode & 2) try {
                                $26b90eb13321ae4f$var$cj(), $26b90eb13321ae4f$var$Ak(5, b);
                            } finally{
                                $26b90eb13321ae4f$var$aj(b);
                            }
                            else $26b90eb13321ae4f$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$26b90eb13321ae4f$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $26b90eb13321ae4f$var$cj(), d.componentDidMount();
                                } finally{
                                    $26b90eb13321ae4f$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $26b90eb13321ae4f$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $26b90eb13321ae4f$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $26b90eb13321ae4f$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $26b90eb13321ae4f$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $26b90eb13321ae4f$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $26b90eb13321ae4f$var$Ui;
                        c = null === c ? "mount" : "update";
                        $26b90eb13321ae4f$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $26b90eb13321ae4f$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $26b90eb13321ae4f$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($26b90eb13321ae4f$var$p(163));
                }
                $26b90eb13321ae4f$var$qk || b.flags & 512 && $26b90eb13321ae4f$var$Bk(b);
            } catch (v) {
                $26b90eb13321ae4f$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $26b90eb13321ae4f$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $26b90eb13321ae4f$var$U = k;
            break;
        }
        $26b90eb13321ae4f$var$U = b.return;
    }
}
function $26b90eb13321ae4f$var$Rk(a) {
    for(; null !== $26b90eb13321ae4f$var$U;){
        var b = $26b90eb13321ae4f$var$U;
        if (b === a) {
            $26b90eb13321ae4f$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $26b90eb13321ae4f$var$U = c;
            break;
        }
        $26b90eb13321ae4f$var$U = b.return;
    }
}
function $26b90eb13321ae4f$var$Uk(a) {
    for(; null !== $26b90eb13321ae4f$var$U;){
        var b = $26b90eb13321ae4f$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $26b90eb13321ae4f$var$cj();
                        var c = b.return;
                        try {
                            $26b90eb13321ae4f$var$Ak(4, b);
                        } catch (l) {
                            $26b90eb13321ae4f$var$W(b, c, l);
                        }
                    } finally{
                        $26b90eb13321ae4f$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $26b90eb13321ae4f$var$Ak(4, b);
                        } catch (l) {
                            $26b90eb13321ae4f$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $26b90eb13321ae4f$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $26b90eb13321ae4f$var$Bk(b);
                    } catch (l) {
                        $26b90eb13321ae4f$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $26b90eb13321ae4f$var$Bk(b);
                    } catch (l) {
                        $26b90eb13321ae4f$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $26b90eb13321ae4f$var$W(b, b.return, l);
        }
        if (b === a) {
            $26b90eb13321ae4f$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $26b90eb13321ae4f$var$U = k;
            break;
        }
        $26b90eb13321ae4f$var$U = b.return;
    }
}
var $26b90eb13321ae4f$var$Xk = Math.ceil, $26b90eb13321ae4f$var$Yk = $26b90eb13321ae4f$var$va.ReactCurrentDispatcher, $26b90eb13321ae4f$var$Zk = $26b90eb13321ae4f$var$va.ReactCurrentOwner, $26b90eb13321ae4f$var$$k = $26b90eb13321ae4f$var$va.ReactCurrentBatchConfig, $26b90eb13321ae4f$var$K = 0, $26b90eb13321ae4f$var$Q = null, $26b90eb13321ae4f$var$Y = null, $26b90eb13321ae4f$var$Z = 0, $26b90eb13321ae4f$var$Jj = 0, $26b90eb13321ae4f$var$Ij = $26b90eb13321ae4f$var$hg(0), $26b90eb13321ae4f$var$T = 0, $26b90eb13321ae4f$var$al = null, $26b90eb13321ae4f$var$Fh = 0, $26b90eb13321ae4f$var$bl = 0, $26b90eb13321ae4f$var$cl = 0, $26b90eb13321ae4f$var$dl = null, $26b90eb13321ae4f$var$el = null, $26b90eb13321ae4f$var$Qk = 0, $26b90eb13321ae4f$var$mk = Infinity, $26b90eb13321ae4f$var$fl = null, $26b90eb13321ae4f$var$qj = !1, $26b90eb13321ae4f$var$rj = null, $26b90eb13321ae4f$var$tj = null, $26b90eb13321ae4f$var$gl = !1, $26b90eb13321ae4f$var$hl = null, $26b90eb13321ae4f$var$il = 0, $26b90eb13321ae4f$var$jl = [], $26b90eb13321ae4f$var$kl = 0, $26b90eb13321ae4f$var$ll = null, $26b90eb13321ae4f$var$ml = -1, $26b90eb13321ae4f$var$nl = 0;
function $26b90eb13321ae4f$var$Ri() {
    return 0 !== ($26b90eb13321ae4f$var$K & 6) ? $26b90eb13321ae4f$var$A() : -1 !== $26b90eb13321ae4f$var$ml ? $26b90eb13321ae4f$var$ml : $26b90eb13321ae4f$var$ml = $26b90eb13321ae4f$var$A();
}
function $26b90eb13321ae4f$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($26b90eb13321ae4f$var$K & 2) && 0 !== $26b90eb13321ae4f$var$Z) return $26b90eb13321ae4f$var$Z & -$26b90eb13321ae4f$var$Z;
    if (null !== $26b90eb13321ae4f$var$Yg.transition) return 0 === $26b90eb13321ae4f$var$nl && ($26b90eb13321ae4f$var$nl = $26b90eb13321ae4f$var$Kc()), $26b90eb13321ae4f$var$nl;
    a = $26b90eb13321ae4f$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $26b90eb13321ae4f$var$xd(a.type);
    return a;
}
function $26b90eb13321ae4f$var$ui(a, b, c, d) {
    if (50 < $26b90eb13321ae4f$var$kl) throw $26b90eb13321ae4f$var$kl = 0, $26b90eb13321ae4f$var$ll = null, Error($26b90eb13321ae4f$var$p(185));
    $26b90eb13321ae4f$var$Mc(a, c, d);
    if (0 === ($26b90eb13321ae4f$var$K & 2) || a !== $26b90eb13321ae4f$var$Q) $26b90eb13321ae4f$var$mc && $26b90eb13321ae4f$var$Pc(a, b, c), a === $26b90eb13321ae4f$var$Q && (0 === ($26b90eb13321ae4f$var$K & 2) && ($26b90eb13321ae4f$var$bl |= c), 4 === $26b90eb13321ae4f$var$T && $26b90eb13321ae4f$var$ol(a, $26b90eb13321ae4f$var$Z)), $26b90eb13321ae4f$var$pl(a, d), 1 === c && 0 === $26b90eb13321ae4f$var$K && 0 === (b.mode & 1) && ($26b90eb13321ae4f$var$mk = $26b90eb13321ae4f$var$A() + 500, $26b90eb13321ae4f$var$tg && $26b90eb13321ae4f$var$xg());
}
function $26b90eb13321ae4f$var$pl(a, b) {
    var c = a.callbackNode;
    $26b90eb13321ae4f$var$Ic(a, b);
    var d = $26b90eb13321ae4f$var$Gc(a, a === $26b90eb13321ae4f$var$Q ? $26b90eb13321ae4f$var$Z : 0);
    if (0 === d) null !== c && $26b90eb13321ae4f$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $26b90eb13321ae4f$var$bc(c);
        if (1 === b) 0 === a.tag ? $26b90eb13321ae4f$var$wg($26b90eb13321ae4f$var$ql.bind(null, a)) : $26b90eb13321ae4f$var$vg($26b90eb13321ae4f$var$ql.bind(null, a)), $26b90eb13321ae4f$var$Xf(function() {
            0 === ($26b90eb13321ae4f$var$K & 6) && $26b90eb13321ae4f$var$xg();
        }), c = null;
        else {
            switch($26b90eb13321ae4f$var$Rc(d)){
                case 1:
                    c = $26b90eb13321ae4f$var$fc;
                    break;
                case 4:
                    c = $26b90eb13321ae4f$var$gc;
                    break;
                case 16:
                    c = $26b90eb13321ae4f$var$hc;
                    break;
                case 536870912:
                    c = $26b90eb13321ae4f$var$jc;
                    break;
                default:
                    c = $26b90eb13321ae4f$var$hc;
            }
            c = $26b90eb13321ae4f$var$rl(c, $26b90eb13321ae4f$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $26b90eb13321ae4f$var$sl(a, b) {
    $26b90eb13321ae4f$var$Zi = $26b90eb13321ae4f$var$Yi = !1;
    $26b90eb13321ae4f$var$ml = -1;
    $26b90eb13321ae4f$var$nl = 0;
    if (0 !== ($26b90eb13321ae4f$var$K & 6)) throw Error($26b90eb13321ae4f$var$p(327));
    var c = a.callbackNode;
    if ($26b90eb13321ae4f$var$tl() && a.callbackNode !== c) return null;
    var d = $26b90eb13321ae4f$var$Gc(a, a === $26b90eb13321ae4f$var$Q ? $26b90eb13321ae4f$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $26b90eb13321ae4f$var$ul(a, d);
    else {
        b = d;
        var e = $26b90eb13321ae4f$var$K;
        $26b90eb13321ae4f$var$K |= 2;
        var f = $26b90eb13321ae4f$var$vl();
        if ($26b90eb13321ae4f$var$Q !== a || $26b90eb13321ae4f$var$Z !== b) {
            if ($26b90eb13321ae4f$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($26b90eb13321ae4f$var$wj(a, $26b90eb13321ae4f$var$Z), g.clear());
                $26b90eb13321ae4f$var$Qc(a, b);
            }
            $26b90eb13321ae4f$var$fl = null;
            $26b90eb13321ae4f$var$mk = $26b90eb13321ae4f$var$A() + 500;
            $26b90eb13321ae4f$var$wl(a, b);
        }
        $26b90eb13321ae4f$var$wc(b);
        for(;;)try {
            $26b90eb13321ae4f$var$xl();
            break;
        } catch (h) {
            $26b90eb13321ae4f$var$yl(a, h);
        }
        $26b90eb13321ae4f$var$nh();
        $26b90eb13321ae4f$var$Yk.current = f;
        $26b90eb13321ae4f$var$K = e;
        null !== $26b90eb13321ae4f$var$Y ? (null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markRenderYielded && $26b90eb13321ae4f$var$B.markRenderYielded(), b = 0) : ($26b90eb13321ae4f$var$xc(), $26b90eb13321ae4f$var$Q = null, $26b90eb13321ae4f$var$Z = 0, b = $26b90eb13321ae4f$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $26b90eb13321ae4f$var$Jc(a), 0 !== e && (d = e, b = $26b90eb13321ae4f$var$zl(a, e)));
        if (1 === b) throw c = $26b90eb13321ae4f$var$al, $26b90eb13321ae4f$var$wl(a, 0), $26b90eb13321ae4f$var$ol(a, d), $26b90eb13321ae4f$var$pl(a, $26b90eb13321ae4f$var$A()), c;
        if (6 === b) $26b90eb13321ae4f$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$26b90eb13321ae4f$var$Al(e) && (b = $26b90eb13321ae4f$var$ul(a, d), 2 === b && (f = $26b90eb13321ae4f$var$Jc(a), 0 !== f && (d = f, b = $26b90eb13321ae4f$var$zl(a, f))), 1 === b)) throw c = $26b90eb13321ae4f$var$al, $26b90eb13321ae4f$var$wl(a, 0), $26b90eb13321ae4f$var$ol(a, d), $26b90eb13321ae4f$var$pl(a, $26b90eb13321ae4f$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($26b90eb13321ae4f$var$p(345));
                case 2:
                    $26b90eb13321ae4f$var$Cl(a, $26b90eb13321ae4f$var$el, $26b90eb13321ae4f$var$fl);
                    break;
                case 3:
                    $26b90eb13321ae4f$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $26b90eb13321ae4f$var$Qk + 500 - $26b90eb13321ae4f$var$A(), 10 < b)) {
                        if (0 !== $26b90eb13321ae4f$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $26b90eb13321ae4f$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $26b90eb13321ae4f$var$Tf($26b90eb13321ae4f$var$Cl.bind(null, a, $26b90eb13321ae4f$var$el, $26b90eb13321ae4f$var$fl), b);
                        break;
                    }
                    $26b90eb13321ae4f$var$Cl(a, $26b90eb13321ae4f$var$el, $26b90eb13321ae4f$var$fl);
                    break;
                case 4:
                    $26b90eb13321ae4f$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $26b90eb13321ae4f$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $26b90eb13321ae4f$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $26b90eb13321ae4f$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $26b90eb13321ae4f$var$Tf($26b90eb13321ae4f$var$Cl.bind(null, a, $26b90eb13321ae4f$var$el, $26b90eb13321ae4f$var$fl), d);
                        break;
                    }
                    $26b90eb13321ae4f$var$Cl(a, $26b90eb13321ae4f$var$el, $26b90eb13321ae4f$var$fl);
                    break;
                case 5:
                    $26b90eb13321ae4f$var$Cl(a, $26b90eb13321ae4f$var$el, $26b90eb13321ae4f$var$fl);
                    break;
                default:
                    throw Error($26b90eb13321ae4f$var$p(329));
            }
        }
    }
    $26b90eb13321ae4f$var$pl(a, $26b90eb13321ae4f$var$A());
    return a.callbackNode === c ? $26b90eb13321ae4f$var$sl.bind(null, a) : null;
}
function $26b90eb13321ae4f$var$zl(a, b) {
    var c = $26b90eb13321ae4f$var$dl;
    a.current.memoizedState.isDehydrated && ($26b90eb13321ae4f$var$wl(a, b).flags |= 256);
    a = $26b90eb13321ae4f$var$ul(a, b);
    2 !== a && (b = $26b90eb13321ae4f$var$el, $26b90eb13321ae4f$var$el = c, null !== b && $26b90eb13321ae4f$var$lk(b));
    return a;
}
function $26b90eb13321ae4f$var$lk(a) {
    null === $26b90eb13321ae4f$var$el ? $26b90eb13321ae4f$var$el = a : $26b90eb13321ae4f$var$el.push.apply($26b90eb13321ae4f$var$el, a);
}
function $26b90eb13321ae4f$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$26b90eb13321ae4f$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $26b90eb13321ae4f$var$ol(a, b) {
    b &= ~$26b90eb13321ae4f$var$cl;
    b &= ~$26b90eb13321ae4f$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $26b90eb13321ae4f$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $26b90eb13321ae4f$var$ql(a) {
    $26b90eb13321ae4f$var$Yi = $26b90eb13321ae4f$var$Zi;
    $26b90eb13321ae4f$var$Zi = !1;
    if (0 !== ($26b90eb13321ae4f$var$K & 6)) throw Error($26b90eb13321ae4f$var$p(327));
    $26b90eb13321ae4f$var$tl();
    var b = $26b90eb13321ae4f$var$Gc(a, 0);
    if (0 === (b & 1)) return $26b90eb13321ae4f$var$pl(a, $26b90eb13321ae4f$var$A()), null;
    var c = $26b90eb13321ae4f$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $26b90eb13321ae4f$var$Jc(a);
        0 !== d && (b = d, c = $26b90eb13321ae4f$var$zl(a, d));
    }
    if (1 === c) throw c = $26b90eb13321ae4f$var$al, $26b90eb13321ae4f$var$wl(a, 0), $26b90eb13321ae4f$var$ol(a, b), $26b90eb13321ae4f$var$pl(a, $26b90eb13321ae4f$var$A()), c;
    if (6 === c) throw Error($26b90eb13321ae4f$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $26b90eb13321ae4f$var$Cl(a, $26b90eb13321ae4f$var$el, $26b90eb13321ae4f$var$fl);
    $26b90eb13321ae4f$var$pl(a, $26b90eb13321ae4f$var$A());
    return null;
}
function $26b90eb13321ae4f$var$Dl(a, b) {
    var c = $26b90eb13321ae4f$var$K;
    $26b90eb13321ae4f$var$K |= 1;
    try {
        return a(b);
    } finally{
        $26b90eb13321ae4f$var$K = c, 0 === $26b90eb13321ae4f$var$K && ($26b90eb13321ae4f$var$mk = $26b90eb13321ae4f$var$A() + 500, $26b90eb13321ae4f$var$tg && $26b90eb13321ae4f$var$xg());
    }
}
function $26b90eb13321ae4f$var$El(a) {
    null !== $26b90eb13321ae4f$var$hl && 0 === $26b90eb13321ae4f$var$hl.tag && 0 === ($26b90eb13321ae4f$var$K & 6) && $26b90eb13321ae4f$var$tl();
    var b = $26b90eb13321ae4f$var$K;
    $26b90eb13321ae4f$var$K |= 1;
    var c = $26b90eb13321ae4f$var$$k.transition, d = $26b90eb13321ae4f$var$E;
    try {
        if ($26b90eb13321ae4f$var$$k.transition = null, $26b90eb13321ae4f$var$E = 1, a) return a();
    } finally{
        $26b90eb13321ae4f$var$E = d, $26b90eb13321ae4f$var$$k.transition = c, $26b90eb13321ae4f$var$K = b, 0 === ($26b90eb13321ae4f$var$K & 6) && $26b90eb13321ae4f$var$xg();
    }
}
function $26b90eb13321ae4f$var$nk() {
    $26b90eb13321ae4f$var$Jj = $26b90eb13321ae4f$var$Ij.current;
    $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$Ij);
}
function $26b90eb13321ae4f$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $26b90eb13321ae4f$var$Uf(c));
    if (null !== $26b90eb13321ae4f$var$Y) for(c = $26b90eb13321ae4f$var$Y.return; null !== c;){
        var d = c;
        $26b90eb13321ae4f$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $26b90eb13321ae4f$var$ng();
                break;
            case 3:
                $26b90eb13321ae4f$var$Nh();
                $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$jg);
                $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$I);
                $26b90eb13321ae4f$var$Sh();
                break;
            case 5:
                $26b90eb13321ae4f$var$Ph(d);
                break;
            case 4:
                $26b90eb13321ae4f$var$Nh();
                break;
            case 13:
                $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$L);
                break;
            case 19:
                $26b90eb13321ae4f$var$G($26b90eb13321ae4f$var$L);
                break;
            case 10:
                $26b90eb13321ae4f$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $26b90eb13321ae4f$var$nk();
        }
        c = c.return;
    }
    $26b90eb13321ae4f$var$Q = a;
    $26b90eb13321ae4f$var$Y = a = $26b90eb13321ae4f$var$ch(a.current, null);
    $26b90eb13321ae4f$var$Z = $26b90eb13321ae4f$var$Jj = b;
    $26b90eb13321ae4f$var$T = 0;
    $26b90eb13321ae4f$var$al = null;
    $26b90eb13321ae4f$var$cl = $26b90eb13321ae4f$var$bl = $26b90eb13321ae4f$var$Fh = 0;
    $26b90eb13321ae4f$var$el = $26b90eb13321ae4f$var$dl = null;
    if (null !== $26b90eb13321ae4f$var$th) {
        for(b = 0; b < $26b90eb13321ae4f$var$th.length; b++)if (c = $26b90eb13321ae4f$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $26b90eb13321ae4f$var$th = null;
    }
    return a;
}
function $26b90eb13321ae4f$var$yl(a, b) {
    do {
        var c = $26b90eb13321ae4f$var$Y;
        try {
            $26b90eb13321ae4f$var$nh();
            $26b90eb13321ae4f$var$Th.current = $26b90eb13321ae4f$var$ei;
            if ($26b90eb13321ae4f$var$Wh) {
                for(var d = $26b90eb13321ae4f$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $26b90eb13321ae4f$var$Wh = !1;
            }
            $26b90eb13321ae4f$var$Vh = 0;
            $26b90eb13321ae4f$var$O = $26b90eb13321ae4f$var$N = $26b90eb13321ae4f$var$M = null;
            $26b90eb13321ae4f$var$Xh = !1;
            $26b90eb13321ae4f$var$Yh = 0;
            $26b90eb13321ae4f$var$Zk.current = null;
            if (null === c || null === c.return) {
                $26b90eb13321ae4f$var$T = 1;
                $26b90eb13321ae4f$var$al = b;
                $26b90eb13321ae4f$var$Y = null;
                break;
            }
            c.mode & 2 && $26b90eb13321ae4f$var$$i(c, !0);
            $26b90eb13321ae4f$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentSuspended && $26b90eb13321ae4f$var$B.markComponentSuspended(c, f, $26b90eb13321ae4f$var$Z);
            } else null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markComponentErrored && $26b90eb13321ae4f$var$B.markComponentErrored(c, b, $26b90eb13321ae4f$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $26b90eb13321ae4f$var$Z;
                k.flags |= 32768;
                $26b90eb13321ae4f$var$mc && $26b90eb13321ae4f$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $26b90eb13321ae4f$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $26b90eb13321ae4f$var$yj(z, h, k, g, b);
                        z.mode & 1 && $26b90eb13321ae4f$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $26b90eb13321ae4f$var$uj(g, l, b);
                            $26b90eb13321ae4f$var$Zj();
                            break a;
                        }
                        f = Error($26b90eb13321ae4f$var$p(426));
                    }
                } else if ($26b90eb13321ae4f$var$J && k.mode & 1) {
                    var C = $26b90eb13321ae4f$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $26b90eb13321ae4f$var$yj(C, h, k, g, b);
                        $26b90eb13321ae4f$var$Xg($26b90eb13321ae4f$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $26b90eb13321ae4f$var$lj(f, k);
                4 !== $26b90eb13321ae4f$var$T && ($26b90eb13321ae4f$var$T = 2);
                null === $26b90eb13321ae4f$var$dl ? $26b90eb13321ae4f$var$dl = [
                    g
                ] : $26b90eb13321ae4f$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $26b90eb13321ae4f$var$pj(g, f, b);
                            $26b90eb13321ae4f$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $26b90eb13321ae4f$var$tj || !$26b90eb13321ae4f$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $26b90eb13321ae4f$var$sj(g, k, b);
                                $26b90eb13321ae4f$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $26b90eb13321ae4f$var$Fl(c);
        } catch (ca) {
            b = ca;
            $26b90eb13321ae4f$var$Y === c && null !== c && ($26b90eb13321ae4f$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $26b90eb13321ae4f$var$vl() {
    var a = $26b90eb13321ae4f$var$Yk.current;
    $26b90eb13321ae4f$var$Yk.current = $26b90eb13321ae4f$var$ei;
    return null === a ? $26b90eb13321ae4f$var$ei : a;
}
function $26b90eb13321ae4f$var$Zj() {
    if (0 === $26b90eb13321ae4f$var$T || 3 === $26b90eb13321ae4f$var$T || 2 === $26b90eb13321ae4f$var$T) $26b90eb13321ae4f$var$T = 4;
    null === $26b90eb13321ae4f$var$Q || 0 === ($26b90eb13321ae4f$var$Fh & 268435455) && 0 === ($26b90eb13321ae4f$var$bl & 268435455) || $26b90eb13321ae4f$var$ol($26b90eb13321ae4f$var$Q, $26b90eb13321ae4f$var$Z);
}
function $26b90eb13321ae4f$var$ul(a, b) {
    var c = $26b90eb13321ae4f$var$K;
    $26b90eb13321ae4f$var$K |= 2;
    var d = $26b90eb13321ae4f$var$vl();
    if ($26b90eb13321ae4f$var$Q !== a || $26b90eb13321ae4f$var$Z !== b) {
        if ($26b90eb13321ae4f$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($26b90eb13321ae4f$var$wj(a, $26b90eb13321ae4f$var$Z), e.clear());
            $26b90eb13321ae4f$var$Qc(a, b);
        }
        $26b90eb13321ae4f$var$fl = null;
        $26b90eb13321ae4f$var$wl(a, b);
    }
    $26b90eb13321ae4f$var$wc(b);
    for(;;)try {
        $26b90eb13321ae4f$var$Gl();
        break;
    } catch (f) {
        $26b90eb13321ae4f$var$yl(a, f);
    }
    $26b90eb13321ae4f$var$nh();
    $26b90eb13321ae4f$var$K = c;
    $26b90eb13321ae4f$var$Yk.current = d;
    if (null !== $26b90eb13321ae4f$var$Y) throw Error($26b90eb13321ae4f$var$p(261));
    $26b90eb13321ae4f$var$xc();
    $26b90eb13321ae4f$var$Q = null;
    $26b90eb13321ae4f$var$Z = 0;
    return $26b90eb13321ae4f$var$T;
}
function $26b90eb13321ae4f$var$Gl() {
    for(; null !== $26b90eb13321ae4f$var$Y;)$26b90eb13321ae4f$var$Hl($26b90eb13321ae4f$var$Y);
}
function $26b90eb13321ae4f$var$xl() {
    for(; null !== $26b90eb13321ae4f$var$Y && !$26b90eb13321ae4f$var$cc();)$26b90eb13321ae4f$var$Hl($26b90eb13321ae4f$var$Y);
}
function $26b90eb13321ae4f$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($26b90eb13321ae4f$var$Wi = $26b90eb13321ae4f$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $26b90eb13321ae4f$var$Ti()), b = $26b90eb13321ae4f$var$Il(b, a, $26b90eb13321ae4f$var$Jj), $26b90eb13321ae4f$var$$i(a, !0)) : b = $26b90eb13321ae4f$var$Il(b, a, $26b90eb13321ae4f$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $26b90eb13321ae4f$var$Fl(a) : $26b90eb13321ae4f$var$Y = b;
    $26b90eb13321ae4f$var$Zk.current = null;
}
function $26b90eb13321ae4f$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $26b90eb13321ae4f$var$kk(c, b, $26b90eb13321ae4f$var$Jj);
            else {
                var d = b;
                $26b90eb13321ae4f$var$Wi = $26b90eb13321ae4f$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $26b90eb13321ae4f$var$Ti());
                c = $26b90eb13321ae4f$var$kk(c, b, $26b90eb13321ae4f$var$Jj);
                $26b90eb13321ae4f$var$$i(b, !1);
            }
            if (null !== c) {
                $26b90eb13321ae4f$var$Y = c;
                return;
            }
        } else {
            c = $26b90eb13321ae4f$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $26b90eb13321ae4f$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $26b90eb13321ae4f$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $26b90eb13321ae4f$var$T = 6;
                $26b90eb13321ae4f$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $26b90eb13321ae4f$var$Y = b;
            return;
        }
        $26b90eb13321ae4f$var$Y = b = a;
    }while (null !== b);
    0 === $26b90eb13321ae4f$var$T && ($26b90eb13321ae4f$var$T = 5);
}
function $26b90eb13321ae4f$var$Cl(a, b, c) {
    var d = $26b90eb13321ae4f$var$E, e = $26b90eb13321ae4f$var$$k.transition;
    try {
        $26b90eb13321ae4f$var$$k.transition = null, $26b90eb13321ae4f$var$E = 1, $26b90eb13321ae4f$var$Jl(a, b, c, d);
    } finally{
        $26b90eb13321ae4f$var$$k.transition = e, $26b90eb13321ae4f$var$E = d;
    }
    return null;
}
function $26b90eb13321ae4f$var$Jl(a, b, c, d) {
    do $26b90eb13321ae4f$var$tl();
    while (null !== $26b90eb13321ae4f$var$hl);
    if (0 !== ($26b90eb13321ae4f$var$K & 6)) throw Error($26b90eb13321ae4f$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markCommitStarted && $26b90eb13321ae4f$var$B.markCommitStarted(e);
    if (null === c) return $26b90eb13321ae4f$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($26b90eb13321ae4f$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $26b90eb13321ae4f$var$Nc(a, f);
    a === $26b90eb13321ae4f$var$Q && ($26b90eb13321ae4f$var$Y = $26b90eb13321ae4f$var$Q = null, $26b90eb13321ae4f$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $26b90eb13321ae4f$var$gl || ($26b90eb13321ae4f$var$gl = !0, $26b90eb13321ae4f$var$rl($26b90eb13321ae4f$var$hc, function() {
        $26b90eb13321ae4f$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $26b90eb13321ae4f$var$$k.transition;
        $26b90eb13321ae4f$var$$k.transition = null;
        var g = $26b90eb13321ae4f$var$E;
        $26b90eb13321ae4f$var$E = 1;
        var h = $26b90eb13321ae4f$var$K;
        $26b90eb13321ae4f$var$K |= 4;
        $26b90eb13321ae4f$var$Zk.current = null;
        $26b90eb13321ae4f$var$yk(a, c);
        $26b90eb13321ae4f$var$Ui = $26b90eb13321ae4f$var$Ti();
        $26b90eb13321ae4f$var$Mk(a, c, e);
        $26b90eb13321ae4f$var$bf($26b90eb13321ae4f$var$Rf);
        $26b90eb13321ae4f$var$rd = !!$26b90eb13321ae4f$var$Qf;
        $26b90eb13321ae4f$var$Rf = $26b90eb13321ae4f$var$Qf = null;
        a.current = c;
        null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markLayoutEffectsStarted && $26b90eb13321ae4f$var$B.markLayoutEffectsStarted(e);
        $26b90eb13321ae4f$var$Sk(c, a, e);
        null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markLayoutEffectsStopped && $26b90eb13321ae4f$var$B.markLayoutEffectsStopped();
        $26b90eb13321ae4f$var$dc();
        $26b90eb13321ae4f$var$K = h;
        $26b90eb13321ae4f$var$E = g;
        $26b90eb13321ae4f$var$$k.transition = f;
    } else a.current = c, $26b90eb13321ae4f$var$Ui = $26b90eb13321ae4f$var$Ti();
    $26b90eb13321ae4f$var$gl && ($26b90eb13321ae4f$var$gl = !1, $26b90eb13321ae4f$var$hl = a, $26b90eb13321ae4f$var$il = e);
    f = a.pendingLanes;
    0 === f && ($26b90eb13321ae4f$var$tj = null);
    $26b90eb13321ae4f$var$nc(c.stateNode, d);
    $26b90eb13321ae4f$var$mc && a.memoizedUpdaters.clear();
    $26b90eb13321ae4f$var$pl(a, $26b90eb13321ae4f$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($26b90eb13321ae4f$var$qj) throw $26b90eb13321ae4f$var$qj = !1, a = $26b90eb13321ae4f$var$rj, $26b90eb13321ae4f$var$rj = null, a;
    0 !== ($26b90eb13321ae4f$var$il & 1) && 0 !== a.tag && $26b90eb13321ae4f$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($26b90eb13321ae4f$var$Zi = !0, a === $26b90eb13321ae4f$var$ll ? $26b90eb13321ae4f$var$kl++ : ($26b90eb13321ae4f$var$kl = 0, $26b90eb13321ae4f$var$ll = a)) : $26b90eb13321ae4f$var$kl = 0;
    $26b90eb13321ae4f$var$xg();
    $26b90eb13321ae4f$var$rc();
    return null;
}
function $26b90eb13321ae4f$var$tl() {
    if (null !== $26b90eb13321ae4f$var$hl) {
        var a = $26b90eb13321ae4f$var$Rc($26b90eb13321ae4f$var$il), b = $26b90eb13321ae4f$var$$k.transition, c = $26b90eb13321ae4f$var$E;
        try {
            $26b90eb13321ae4f$var$$k.transition = null;
            $26b90eb13321ae4f$var$E = 16 > a ? 16 : a;
            if (null === $26b90eb13321ae4f$var$hl) var d = !1;
            else {
                a = $26b90eb13321ae4f$var$hl;
                var e = $26b90eb13321ae4f$var$il;
                $26b90eb13321ae4f$var$hl = null;
                $26b90eb13321ae4f$var$il = 0;
                if (0 !== ($26b90eb13321ae4f$var$K & 6)) throw Error($26b90eb13321ae4f$var$p(331));
                null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markPassiveEffectsStarted && $26b90eb13321ae4f$var$B.markPassiveEffectsStarted(e);
                e = $26b90eb13321ae4f$var$K;
                $26b90eb13321ae4f$var$K |= 4;
                for($26b90eb13321ae4f$var$U = a.current; null !== $26b90eb13321ae4f$var$U;){
                    var f = $26b90eb13321ae4f$var$U, g = f.child;
                    if (0 !== ($26b90eb13321ae4f$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($26b90eb13321ae4f$var$U = l; null !== $26b90eb13321ae4f$var$U;){
                                    var n = $26b90eb13321ae4f$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($26b90eb13321ae4f$var$Xi = $26b90eb13321ae4f$var$Ti(), $26b90eb13321ae4f$var$zk(8, q, f), $26b90eb13321ae4f$var$bj(q)) : $26b90eb13321ae4f$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $26b90eb13321ae4f$var$U = r;
                                    else for(; null !== $26b90eb13321ae4f$var$U;){
                                        n = $26b90eb13321ae4f$var$U;
                                        var z = n.sibling, m = n.return;
                                        $26b90eb13321ae4f$var$Ck(n);
                                        if (n === l) {
                                            $26b90eb13321ae4f$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $26b90eb13321ae4f$var$U = z;
                                            break;
                                        }
                                        $26b90eb13321ae4f$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $26b90eb13321ae4f$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $26b90eb13321ae4f$var$U = g;
                    else b: for(; null !== $26b90eb13321ae4f$var$U;){
                        f = $26b90eb13321ae4f$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($26b90eb13321ae4f$var$Xi = $26b90eb13321ae4f$var$Ti(), $26b90eb13321ae4f$var$zk(9, k, k.return), $26b90eb13321ae4f$var$bj(k)) : $26b90eb13321ae4f$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $26b90eb13321ae4f$var$U = y;
                            break b;
                        }
                        $26b90eb13321ae4f$var$U = f.return;
                    }
                }
                var v = a.current;
                for($26b90eb13321ae4f$var$U = v; null !== $26b90eb13321ae4f$var$U;){
                    g = $26b90eb13321ae4f$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $26b90eb13321ae4f$var$U = D;
                    else b: for(g = v; null !== $26b90eb13321ae4f$var$U;){
                        h = $26b90eb13321ae4f$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $26b90eb13321ae4f$var$Xi = $26b90eb13321ae4f$var$Ti();
                                        try {
                                            $26b90eb13321ae4f$var$Ak(9, l);
                                        } finally{
                                            $26b90eb13321ae4f$var$bj(l);
                                        }
                                    } else $26b90eb13321ae4f$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $26b90eb13321ae4f$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $26b90eb13321ae4f$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $26b90eb13321ae4f$var$U = ca;
                            break b;
                        }
                        $26b90eb13321ae4f$var$U = h.return;
                    }
                }
                v = $26b90eb13321ae4f$var$jl;
                $26b90eb13321ae4f$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $26b90eb13321ae4f$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $26b90eb13321ae4f$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markPassiveEffectsStopped && $26b90eb13321ae4f$var$B.markPassiveEffectsStopped();
                $26b90eb13321ae4f$var$K = e;
                $26b90eb13321ae4f$var$xg();
                if ($26b90eb13321ae4f$var$lc && "function" === typeof $26b90eb13321ae4f$var$lc.onPostCommitFiberRoot) try {
                    $26b90eb13321ae4f$var$lc.onPostCommitFiberRoot($26b90eb13321ae4f$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $26b90eb13321ae4f$var$E = c, $26b90eb13321ae4f$var$$k.transition = b;
        }
    }
    return !1;
}
function $26b90eb13321ae4f$var$Wk(a) {
    $26b90eb13321ae4f$var$jl.push(a);
    $26b90eb13321ae4f$var$gl || ($26b90eb13321ae4f$var$gl = !0, $26b90eb13321ae4f$var$rl($26b90eb13321ae4f$var$hc, function() {
        $26b90eb13321ae4f$var$tl();
        return null;
    }));
}
function $26b90eb13321ae4f$var$Kl(a, b, c) {
    b = $26b90eb13321ae4f$var$lj(c, b);
    b = $26b90eb13321ae4f$var$pj(a, b, 1);
    a = $26b90eb13321ae4f$var$Bh(a, b, 1);
    b = $26b90eb13321ae4f$var$Ri();
    null !== a && ($26b90eb13321ae4f$var$Mc(a, 1, b), $26b90eb13321ae4f$var$pl(a, b));
}
function $26b90eb13321ae4f$var$W(a, b, c) {
    if (3 === a.tag) $26b90eb13321ae4f$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $26b90eb13321ae4f$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $26b90eb13321ae4f$var$tj || !$26b90eb13321ae4f$var$tj.has(d))) {
                a = $26b90eb13321ae4f$var$lj(c, a);
                a = $26b90eb13321ae4f$var$sj(b, a, 1);
                b = $26b90eb13321ae4f$var$Bh(b, a, 1);
                a = $26b90eb13321ae4f$var$Ri();
                null !== b && ($26b90eb13321ae4f$var$Mc(b, 1, a), $26b90eb13321ae4f$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $26b90eb13321ae4f$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $26b90eb13321ae4f$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $26b90eb13321ae4f$var$Q === a && ($26b90eb13321ae4f$var$Z & c) === c && (4 === $26b90eb13321ae4f$var$T || 3 === $26b90eb13321ae4f$var$T && ($26b90eb13321ae4f$var$Z & 130023424) === $26b90eb13321ae4f$var$Z && 500 > $26b90eb13321ae4f$var$A() - $26b90eb13321ae4f$var$Qk ? $26b90eb13321ae4f$var$wl(a, 0) : $26b90eb13321ae4f$var$cl |= c);
    $26b90eb13321ae4f$var$pl(a, b);
}
function $26b90eb13321ae4f$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $26b90eb13321ae4f$var$Ec, $26b90eb13321ae4f$var$Ec <<= 1, 0 === ($26b90eb13321ae4f$var$Ec & 130023424) && ($26b90eb13321ae4f$var$Ec = 4194304)));
    var c = $26b90eb13321ae4f$var$Ri();
    a = $26b90eb13321ae4f$var$wh(a, b);
    null !== a && ($26b90eb13321ae4f$var$Mc(a, b, c), $26b90eb13321ae4f$var$pl(a, c));
}
function $26b90eb13321ae4f$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $26b90eb13321ae4f$var$Ll(a, c);
}
function $26b90eb13321ae4f$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($26b90eb13321ae4f$var$p(314));
    }
    null !== d && d.delete(b);
    $26b90eb13321ae4f$var$Ll(a, c);
}
var $26b90eb13321ae4f$var$Il;
$26b90eb13321ae4f$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $26b90eb13321ae4f$var$jg.current) $26b90eb13321ae4f$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $26b90eb13321ae4f$var$rh = !1, $26b90eb13321ae4f$var$ek(a, b, c);
            $26b90eb13321ae4f$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $26b90eb13321ae4f$var$rh = !1, $26b90eb13321ae4f$var$J && 0 !== (b.flags & 1048576) && $26b90eb13321ae4f$var$Ig(b, $26b90eb13321ae4f$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $26b90eb13321ae4f$var$Mj(a, b);
            a = b.pendingProps;
            var e = $26b90eb13321ae4f$var$lg(b, $26b90eb13321ae4f$var$I.current);
            $26b90eb13321ae4f$var$qh(b, c);
            $26b90eb13321ae4f$var$sc(b);
            e = $26b90eb13321ae4f$var$ai(null, b, d, a, e, c);
            var f = $26b90eb13321ae4f$var$fi();
            $26b90eb13321ae4f$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $26b90eb13321ae4f$var$mg(d) ? (f = !0, $26b90eb13321ae4f$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $26b90eb13321ae4f$var$yh(b), e.updater = $26b90eb13321ae4f$var$gj, b.stateNode = e, e._reactInternals = b, $26b90eb13321ae4f$var$kj(b, d, a, c), b = $26b90eb13321ae4f$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $26b90eb13321ae4f$var$J && f && $26b90eb13321ae4f$var$Jg(b), $26b90eb13321ae4f$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $26b90eb13321ae4f$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $26b90eb13321ae4f$var$Ml(d);
                a = $26b90eb13321ae4f$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $26b90eb13321ae4f$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $26b90eb13321ae4f$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $26b90eb13321ae4f$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $26b90eb13321ae4f$var$Dj(null, b, d, $26b90eb13321ae4f$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($26b90eb13321ae4f$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $26b90eb13321ae4f$var$ej(d, e), $26b90eb13321ae4f$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $26b90eb13321ae4f$var$ej(d, e), $26b90eb13321ae4f$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $26b90eb13321ae4f$var$Oj(b);
                if (null === a) throw Error($26b90eb13321ae4f$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $26b90eb13321ae4f$var$zh(a, b);
                $26b90eb13321ae4f$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $26b90eb13321ae4f$var$lj(Error($26b90eb13321ae4f$var$p(423)), b);
                        b = $26b90eb13321ae4f$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $26b90eb13321ae4f$var$lj(Error($26b90eb13321ae4f$var$p(424)), b);
                        b = $26b90eb13321ae4f$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($26b90eb13321ae4f$var$Mg = $26b90eb13321ae4f$var$Zf(b.stateNode.containerInfo.firstChild), $26b90eb13321ae4f$var$Lg = b, $26b90eb13321ae4f$var$J = !0, $26b90eb13321ae4f$var$Ng = null, c = $26b90eb13321ae4f$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $26b90eb13321ae4f$var$Wg();
                    if (d === e) {
                        b = $26b90eb13321ae4f$var$Cj(a, b, c);
                        break a;
                    }
                    $26b90eb13321ae4f$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $26b90eb13321ae4f$var$Oh(b), null === a && $26b90eb13321ae4f$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $26b90eb13321ae4f$var$Sf(d, e) ? g = null : null !== f && $26b90eb13321ae4f$var$Sf(d, f) && (b.flags |= 32), $26b90eb13321ae4f$var$Kj(a, b), $26b90eb13321ae4f$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $26b90eb13321ae4f$var$Sg(b), null;
        case 13:
            return $26b90eb13321ae4f$var$Uj(a, b, c);
        case 4:
            return $26b90eb13321ae4f$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $26b90eb13321ae4f$var$hh(b, null, d, c) : $26b90eb13321ae4f$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $26b90eb13321ae4f$var$ej(d, e), $26b90eb13321ae4f$var$Bj(a, b, d, e, c);
        case 7:
            return $26b90eb13321ae4f$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $26b90eb13321ae4f$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $26b90eb13321ae4f$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $26b90eb13321ae4f$var$H($26b90eb13321ae4f$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($26b90eb13321ae4f$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$26b90eb13321ae4f$var$jg.current) {
                            b = $26b90eb13321ae4f$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $26b90eb13321ae4f$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $26b90eb13321ae4f$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($26b90eb13321ae4f$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $26b90eb13321ae4f$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $26b90eb13321ae4f$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $26b90eb13321ae4f$var$qh(b, c), e = $26b90eb13321ae4f$var$sh(e), $26b90eb13321ae4f$var$sc(b), d = d(e), $26b90eb13321ae4f$var$tc(), b.flags |= 1, $26b90eb13321ae4f$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $26b90eb13321ae4f$var$ej(d, b.pendingProps), e = $26b90eb13321ae4f$var$ej(d.type, e), $26b90eb13321ae4f$var$Dj(a, b, d, e, c);
        case 15:
            return $26b90eb13321ae4f$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $26b90eb13321ae4f$var$ej(d, e), $26b90eb13321ae4f$var$Mj(a, b), b.tag = 1, $26b90eb13321ae4f$var$mg(d) ? (a = !0, $26b90eb13321ae4f$var$qg(b)) : a = !1, $26b90eb13321ae4f$var$qh(b, c), $26b90eb13321ae4f$var$ij(b, d, e), $26b90eb13321ae4f$var$kj(b, d, e, c), $26b90eb13321ae4f$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $26b90eb13321ae4f$var$dk(a, b, c);
        case 22:
            return $26b90eb13321ae4f$var$Hj(a, b, c);
    }
    throw Error($26b90eb13321ae4f$var$p(156, b.tag));
};
function $26b90eb13321ae4f$var$wj(a, b) {
    $26b90eb13321ae4f$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $26b90eb13321ae4f$var$Pc(a, c, b);
    });
}
function $26b90eb13321ae4f$var$rl(a, b) {
    return $26b90eb13321ae4f$var$ac(a, b);
}
function $26b90eb13321ae4f$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $26b90eb13321ae4f$var$Pg(a, b, c, d) {
    return new $26b90eb13321ae4f$var$Nl(a, b, c, d);
}
function $26b90eb13321ae4f$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $26b90eb13321ae4f$var$Ml(a) {
    if ("function" === typeof a) return $26b90eb13321ae4f$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $26b90eb13321ae4f$var$Da) return 11;
        if (a === $26b90eb13321ae4f$var$Ga) return 14;
    }
    return 2;
}
function $26b90eb13321ae4f$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $26b90eb13321ae4f$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $26b90eb13321ae4f$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $26b90eb13321ae4f$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $26b90eb13321ae4f$var$ya:
            return $26b90eb13321ae4f$var$gh(c.children, e, f, b);
        case $26b90eb13321ae4f$var$za:
            g = 8;
            e |= 8;
            break;
        case $26b90eb13321ae4f$var$Aa:
            return a = $26b90eb13321ae4f$var$Pg(12, c, b, e | 2), a.elementType = $26b90eb13321ae4f$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $26b90eb13321ae4f$var$Ea:
            return a = $26b90eb13321ae4f$var$Pg(13, c, b, e), a.elementType = $26b90eb13321ae4f$var$Ea, a.lanes = f, a;
        case $26b90eb13321ae4f$var$Fa:
            return a = $26b90eb13321ae4f$var$Pg(19, c, b, e), a.elementType = $26b90eb13321ae4f$var$Fa, a.lanes = f, a;
        case $26b90eb13321ae4f$var$Ia:
            return $26b90eb13321ae4f$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $26b90eb13321ae4f$var$Ba:
                    g = 10;
                    break a;
                case $26b90eb13321ae4f$var$Ca:
                    g = 9;
                    break a;
                case $26b90eb13321ae4f$var$Da:
                    g = 11;
                    break a;
                case $26b90eb13321ae4f$var$Ga:
                    g = 14;
                    break a;
                case $26b90eb13321ae4f$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($26b90eb13321ae4f$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $26b90eb13321ae4f$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $26b90eb13321ae4f$var$gh(a, b, c, d) {
    a = $26b90eb13321ae4f$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $26b90eb13321ae4f$var$Vj(a, b, c, d) {
    a = $26b90eb13321ae4f$var$Pg(22, a, d, b);
    a.elementType = $26b90eb13321ae4f$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $26b90eb13321ae4f$var$dh(a, b, c) {
    a = $26b90eb13321ae4f$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $26b90eb13321ae4f$var$fh(a, b, c) {
    b = $26b90eb13321ae4f$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $26b90eb13321ae4f$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $26b90eb13321ae4f$var$Lc(0);
    this.expirationTimes = $26b90eb13321ae4f$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $26b90eb13321ae4f$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $26b90eb13321ae4f$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $26b90eb13321ae4f$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $26b90eb13321ae4f$var$mc && (b |= 2);
    f = $26b90eb13321ae4f$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $26b90eb13321ae4f$var$yh(f);
    return a;
}
function $26b90eb13321ae4f$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $26b90eb13321ae4f$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $26b90eb13321ae4f$var$Rl(a) {
    if (!a) return $26b90eb13321ae4f$var$ig;
    a = a._reactInternals;
    a: {
        if ($26b90eb13321ae4f$var$Vb(a) !== a || 1 !== a.tag) throw Error($26b90eb13321ae4f$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($26b90eb13321ae4f$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($26b90eb13321ae4f$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($26b90eb13321ae4f$var$mg(c)) return $26b90eb13321ae4f$var$pg(a, c, b);
    }
    return b;
}
function $26b90eb13321ae4f$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $26b90eb13321ae4f$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $26b90eb13321ae4f$var$Rl(null);
    c = a.current;
    d = $26b90eb13321ae4f$var$Ri();
    e = $26b90eb13321ae4f$var$Oi(c);
    f = $26b90eb13321ae4f$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $26b90eb13321ae4f$var$Bh(c, f, e);
    a.current.lanes = e;
    $26b90eb13321ae4f$var$Mc(a, e, d);
    $26b90eb13321ae4f$var$pl(a, d);
    return a;
}
function $26b90eb13321ae4f$var$Tl(a, b, c, d) {
    var e = b.current, f = $26b90eb13321ae4f$var$Ri(), g = $26b90eb13321ae4f$var$Oi(e);
    null !== $26b90eb13321ae4f$var$B && "function" === typeof $26b90eb13321ae4f$var$B.markRenderScheduled && $26b90eb13321ae4f$var$B.markRenderScheduled(g);
    c = $26b90eb13321ae4f$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $26b90eb13321ae4f$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $26b90eb13321ae4f$var$Bh(e, b, g);
    null !== a && ($26b90eb13321ae4f$var$ui(a, e, g, f), $26b90eb13321ae4f$var$Ch(a, e, g));
    return g;
}
function $26b90eb13321ae4f$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $26b90eb13321ae4f$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $26b90eb13321ae4f$var$Wl(a, b) {
    $26b90eb13321ae4f$var$Vl(a, b);
    (a = a.alternate) && $26b90eb13321ae4f$var$Vl(a, b);
}
function $26b90eb13321ae4f$var$Xl() {
    return null;
}
var $26b90eb13321ae4f$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $26b90eb13321ae4f$var$Zl(a) {
    this._internalRoot = a;
}
$26b90eb13321ae4f$var$$l.prototype.render = $26b90eb13321ae4f$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($26b90eb13321ae4f$var$p(409));
    $26b90eb13321ae4f$var$Tl(a, b, null, null);
};
$26b90eb13321ae4f$var$$l.prototype.unmount = $26b90eb13321ae4f$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $26b90eb13321ae4f$var$El(function() {
            $26b90eb13321ae4f$var$Tl(null, a, null, null);
        });
        b[$26b90eb13321ae4f$var$If] = null;
    }
};
function $26b90eb13321ae4f$var$$l(a) {
    this._internalRoot = a;
}
$26b90eb13321ae4f$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $26b90eb13321ae4f$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $26b90eb13321ae4f$var$dd.length && 0 !== b && b < $26b90eb13321ae4f$var$dd[c].priority; c++);
        $26b90eb13321ae4f$var$dd.splice(c, 0, a);
        0 === c && $26b90eb13321ae4f$var$id(a);
    }
};
function $26b90eb13321ae4f$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $26b90eb13321ae4f$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $26b90eb13321ae4f$var$cm() {}
function $26b90eb13321ae4f$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $26b90eb13321ae4f$var$Ul(g);
                f.call(a);
            };
        }
        var g = $26b90eb13321ae4f$var$Sl(b, d, a, 0, null, !1, !1, "", $26b90eb13321ae4f$var$cm);
        a._reactRootContainer = g;
        a[$26b90eb13321ae4f$var$If] = g.current;
        $26b90eb13321ae4f$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $26b90eb13321ae4f$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $26b90eb13321ae4f$var$Ul(k);
            h.call(a);
        };
    }
    var k = $26b90eb13321ae4f$var$Pl(a, 0, !1, null, null, !1, !1, "", $26b90eb13321ae4f$var$cm);
    a._reactRootContainer = k;
    a[$26b90eb13321ae4f$var$If] = k.current;
    $26b90eb13321ae4f$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $26b90eb13321ae4f$var$El(function() {
        $26b90eb13321ae4f$var$Tl(b, k, c, d);
    });
    return k;
}
function $26b90eb13321ae4f$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $26b90eb13321ae4f$var$Ul(g);
                h.call(a);
            };
        }
        $26b90eb13321ae4f$var$Tl(b, g, a, e);
    } else g = $26b90eb13321ae4f$var$dm(c, b, a, e, d);
    return $26b90eb13321ae4f$var$Ul(g);
}
$26b90eb13321ae4f$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $26b90eb13321ae4f$var$Fc(b.pendingLanes);
                0 !== c && ($26b90eb13321ae4f$var$Oc(b, c | 1), $26b90eb13321ae4f$var$pl(b, $26b90eb13321ae4f$var$A()), 0 === ($26b90eb13321ae4f$var$K & 6) && ($26b90eb13321ae4f$var$mk = $26b90eb13321ae4f$var$A() + 500, $26b90eb13321ae4f$var$xg()));
            }
            break;
        case 13:
            $26b90eb13321ae4f$var$El(function() {
                var b = $26b90eb13321ae4f$var$wh(a, 1);
                if (null !== b) {
                    var c = $26b90eb13321ae4f$var$Ri();
                    $26b90eb13321ae4f$var$ui(b, a, 1, c);
                }
            }), $26b90eb13321ae4f$var$Wl(a, 1);
    }
};
$26b90eb13321ae4f$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $26b90eb13321ae4f$var$wh(a, 134217728);
        if (null !== b) {
            var c = $26b90eb13321ae4f$var$Ri();
            $26b90eb13321ae4f$var$ui(b, a, 134217728, c);
        }
        $26b90eb13321ae4f$var$Wl(a, 134217728);
    }
};
$26b90eb13321ae4f$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $26b90eb13321ae4f$var$Oi(a), c = $26b90eb13321ae4f$var$wh(a, b);
        if (null !== c) {
            var d = $26b90eb13321ae4f$var$Ri();
            $26b90eb13321ae4f$var$ui(c, a, b, d);
        }
        $26b90eb13321ae4f$var$Wl(a, b);
    }
};
$26b90eb13321ae4f$var$Vc = function() {
    return $26b90eb13321ae4f$var$E;
};
$26b90eb13321ae4f$var$Wc = function(a, b) {
    var c = $26b90eb13321ae4f$var$E;
    try {
        return $26b90eb13321ae4f$var$E = a, b();
    } finally{
        $26b90eb13321ae4f$var$E = c;
    }
};
$26b90eb13321ae4f$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $26b90eb13321ae4f$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $26b90eb13321ae4f$var$Db(d);
                        if (!e) throw Error($26b90eb13321ae4f$var$p(90));
                        $26b90eb13321ae4f$var$Wa(d);
                        $26b90eb13321ae4f$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $26b90eb13321ae4f$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $26b90eb13321ae4f$var$eb(a, !!c.multiple, b, !1);
    }
};
$26b90eb13321ae4f$var$Gb = $26b90eb13321ae4f$var$Dl;
$26b90eb13321ae4f$var$Hb = $26b90eb13321ae4f$var$El;
var $26b90eb13321ae4f$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $26b90eb13321ae4f$var$Cb,
        $26b90eb13321ae4f$var$Ie,
        $26b90eb13321ae4f$var$Db,
        $26b90eb13321ae4f$var$Eb,
        $26b90eb13321ae4f$var$Fb,
        $26b90eb13321ae4f$var$Dl
    ]
}, $26b90eb13321ae4f$var$gm = {
    findFiberByHostInstance: $26b90eb13321ae4f$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $26b90eb13321ae4f$var$u({}, a, {
            getLaneLabelMap: $26b90eb13321ae4f$var$pc,
            injectProfilingHooks: $26b90eb13321ae4f$var$oc
        }), $26b90eb13321ae4f$var$kc = b.inject(a), $26b90eb13321ae4f$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $26b90eb13321ae4f$var$gm.bundleType,
    version: $26b90eb13321ae4f$var$gm.version,
    rendererPackageName: $26b90eb13321ae4f$var$gm.rendererPackageName,
    rendererConfig: $26b90eb13321ae4f$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $26b90eb13321ae4f$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $26b90eb13321ae4f$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $26b90eb13321ae4f$var$gm.findFiberByHostInstance || $26b90eb13321ae4f$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$26b90eb13321ae4f$export$ae55be85d98224ed = $26b90eb13321ae4f$var$fm;
$26b90eb13321ae4f$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$26b90eb13321ae4f$var$am(b)) throw Error($26b90eb13321ae4f$var$p(200));
    return $26b90eb13321ae4f$var$Ql(a, b, null, c);
};
$26b90eb13321ae4f$export$882461b6382ed46c = function(a, b) {
    if (!$26b90eb13321ae4f$var$am(a)) throw Error($26b90eb13321ae4f$var$p(299));
    var c = !1, d = "", e = $26b90eb13321ae4f$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $26b90eb13321ae4f$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$26b90eb13321ae4f$var$If] = b.current;
    $26b90eb13321ae4f$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $26b90eb13321ae4f$var$Zl(b);
};
$26b90eb13321ae4f$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($26b90eb13321ae4f$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($26b90eb13321ae4f$var$p(268, a));
    }
    a = $26b90eb13321ae4f$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$26b90eb13321ae4f$export$cd75ccfd720a3cd4 = function(a) {
    return $26b90eb13321ae4f$var$El(a);
};
$26b90eb13321ae4f$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$26b90eb13321ae4f$var$bm(b)) throw Error($26b90eb13321ae4f$var$p(200));
    return $26b90eb13321ae4f$var$em(null, a, b, !0, c);
};
$26b90eb13321ae4f$export$757ceba2d55c277e = function(a, b, c) {
    if (!$26b90eb13321ae4f$var$am(a)) throw Error($26b90eb13321ae4f$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $26b90eb13321ae4f$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $26b90eb13321ae4f$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$26b90eb13321ae4f$var$If] = b.current;
    $26b90eb13321ae4f$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $26b90eb13321ae4f$var$$l(b);
};
$26b90eb13321ae4f$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$26b90eb13321ae4f$var$bm(b)) throw Error($26b90eb13321ae4f$var$p(200));
    return $26b90eb13321ae4f$var$em(null, a, b, !1, c);
};
$26b90eb13321ae4f$export$502457920280e6be = function(a) {
    if (!$26b90eb13321ae4f$var$bm(a)) throw Error($26b90eb13321ae4f$var$p(40));
    return a._reactRootContainer ? ($26b90eb13321ae4f$var$El(function() {
        $26b90eb13321ae4f$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$26b90eb13321ae4f$var$If] = null;
        });
    }), !0) : !1;
};
$26b90eb13321ae4f$export$c78a37762a8d58e1 = $26b90eb13321ae4f$var$Dl;
$26b90eb13321ae4f$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$26b90eb13321ae4f$var$bm(c)) throw Error($26b90eb13321ae4f$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($26b90eb13321ae4f$var$p(38));
    return $26b90eb13321ae4f$var$em(a, b, c, !1, d);
};
$26b90eb13321ae4f$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("gZKXT", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i5WVP"));

});
parcelRegister("i5WVP", function(module, exports) {
$parcel$export(module.exports, "unstable_now", function () { return $d2c66841a5897776$export$c4744153514ff05d; }, function (v) { return $d2c66841a5897776$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d2c66841a5897776$export$3e506c1ccc9cc1a7; }, function (v) { return $d2c66841a5897776$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d2c66841a5897776$export$e26fe2ed2fa76875; }, function (v) { return $d2c66841a5897776$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d2c66841a5897776$export$502329bbf4b505b1; }, function (v) { return $d2c66841a5897776$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d2c66841a5897776$export$6e3807111c4874c4; }, function (v) { return $d2c66841a5897776$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d2c66841a5897776$export$c27134553091fb3a; }, function (v) { return $d2c66841a5897776$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d2c66841a5897776$export$33ee1acdc04fd2a2; }, function (v) { return $d2c66841a5897776$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d2c66841a5897776$export$b00a404bbd5edef2; }, function (v) { return $d2c66841a5897776$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d2c66841a5897776$export$8352ce38b91d0c62; }, function (v) { return $d2c66841a5897776$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d2c66841a5897776$export$d66a1c1c77bd778b; }, function (v) { return $d2c66841a5897776$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d2c66841a5897776$export$d3dfb8e4810cb555; }, function (v) { return $d2c66841a5897776$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d2c66841a5897776$export$839f9183b0465a69; }, function (v) { return $d2c66841a5897776$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d2c66841a5897776$export$72fdf0e06517287b; }, function (v) { return $d2c66841a5897776$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d2c66841a5897776$export$4b844e58a3e414b4; }, function (v) { return $d2c66841a5897776$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d2c66841a5897776$export$816d2913ae6b83b1; }, function (v) { return $d2c66841a5897776$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d2c66841a5897776$export$61bcfe829111a1d0; }, function (v) { return $d2c66841a5897776$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d2c66841a5897776$export$7ee8c9beb337bc3f; }, function (v) { return $d2c66841a5897776$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d2c66841a5897776$export$b5836b71941fa3ed; }, function (v) { return $d2c66841a5897776$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d2c66841a5897776$export$cf845f2c119da08a; }, function (v) { return $d2c66841a5897776$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2c66841a5897776$export$c4744153514ff05d;
var $d2c66841a5897776$export$3e506c1ccc9cc1a7;
var $d2c66841a5897776$export$e26fe2ed2fa76875;
var $d2c66841a5897776$export$502329bbf4b505b1;
var $d2c66841a5897776$export$6e3807111c4874c4;
var $d2c66841a5897776$export$c27134553091fb3a;
var $d2c66841a5897776$export$33ee1acdc04fd2a2;
var $d2c66841a5897776$export$b00a404bbd5edef2;
var $d2c66841a5897776$export$8352ce38b91d0c62;
var $d2c66841a5897776$export$d66a1c1c77bd778b;
var $d2c66841a5897776$export$d3dfb8e4810cb555;
var $d2c66841a5897776$export$839f9183b0465a69;
var $d2c66841a5897776$export$72fdf0e06517287b;
var $d2c66841a5897776$export$4b844e58a3e414b4;
var $d2c66841a5897776$export$816d2913ae6b83b1;
var $d2c66841a5897776$export$61bcfe829111a1d0;
var $d2c66841a5897776$export$7ee8c9beb337bc3f;
var $d2c66841a5897776$export$b5836b71941fa3ed;
var $d2c66841a5897776$export$cf845f2c119da08a;
'use strict';
function $d2c66841a5897776$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $d2c66841a5897776$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d2c66841a5897776$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $d2c66841a5897776$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $d2c66841a5897776$var$g(C, c)) n < e && 0 > $d2c66841a5897776$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $d2c66841a5897776$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $d2c66841a5897776$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d2c66841a5897776$var$l = performance;
    $d2c66841a5897776$export$c4744153514ff05d = function() {
        return $d2c66841a5897776$var$l.now();
    };
} else {
    var $d2c66841a5897776$var$p = Date, $d2c66841a5897776$var$q = $d2c66841a5897776$var$p.now();
    $d2c66841a5897776$export$c4744153514ff05d = function() {
        return $d2c66841a5897776$var$p.now() - $d2c66841a5897776$var$q;
    };
}
var $d2c66841a5897776$var$r = [], $d2c66841a5897776$var$t = [], $d2c66841a5897776$var$u = 1, $d2c66841a5897776$var$v = null, $d2c66841a5897776$var$y = 3, $d2c66841a5897776$var$z = !1, $d2c66841a5897776$var$A = !1, $d2c66841a5897776$var$B = !1, $d2c66841a5897776$var$D = "function" === typeof setTimeout ? setTimeout : null, $d2c66841a5897776$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $d2c66841a5897776$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $d2c66841a5897776$var$G(a) {
    for(var b = $d2c66841a5897776$var$h($d2c66841a5897776$var$t); null !== b;){
        if (null === b.callback) $d2c66841a5897776$var$k($d2c66841a5897776$var$t);
        else if (b.startTime <= a) $d2c66841a5897776$var$k($d2c66841a5897776$var$t), b.sortIndex = b.expirationTime, $d2c66841a5897776$var$f($d2c66841a5897776$var$r, b);
        else break;
        b = $d2c66841a5897776$var$h($d2c66841a5897776$var$t);
    }
}
function $d2c66841a5897776$var$H(a) {
    $d2c66841a5897776$var$B = !1;
    $d2c66841a5897776$var$G(a);
    if (!$d2c66841a5897776$var$A) {
        if (null !== $d2c66841a5897776$var$h($d2c66841a5897776$var$r)) $d2c66841a5897776$var$A = !0, $d2c66841a5897776$var$I($d2c66841a5897776$var$J);
        else {
            var b = $d2c66841a5897776$var$h($d2c66841a5897776$var$t);
            null !== b && $d2c66841a5897776$var$K($d2c66841a5897776$var$H, b.startTime - a);
        }
    }
}
function $d2c66841a5897776$var$J(a, b) {
    $d2c66841a5897776$var$A = !1;
    $d2c66841a5897776$var$B && ($d2c66841a5897776$var$B = !1, $d2c66841a5897776$var$E($d2c66841a5897776$var$L), $d2c66841a5897776$var$L = -1);
    $d2c66841a5897776$var$z = !0;
    var c = $d2c66841a5897776$var$y;
    try {
        $d2c66841a5897776$var$G(b);
        for($d2c66841a5897776$var$v = $d2c66841a5897776$var$h($d2c66841a5897776$var$r); null !== $d2c66841a5897776$var$v && (!($d2c66841a5897776$var$v.expirationTime > b) || a && !$d2c66841a5897776$var$M());){
            var d = $d2c66841a5897776$var$v.callback;
            if ("function" === typeof d) {
                $d2c66841a5897776$var$v.callback = null;
                $d2c66841a5897776$var$y = $d2c66841a5897776$var$v.priorityLevel;
                var e = d($d2c66841a5897776$var$v.expirationTime <= b);
                b = $d2c66841a5897776$export$c4744153514ff05d();
                "function" === typeof e ? $d2c66841a5897776$var$v.callback = e : $d2c66841a5897776$var$v === $d2c66841a5897776$var$h($d2c66841a5897776$var$r) && $d2c66841a5897776$var$k($d2c66841a5897776$var$r);
                $d2c66841a5897776$var$G(b);
            } else $d2c66841a5897776$var$k($d2c66841a5897776$var$r);
            $d2c66841a5897776$var$v = $d2c66841a5897776$var$h($d2c66841a5897776$var$r);
        }
        if (null !== $d2c66841a5897776$var$v) var w = !0;
        else {
            var m = $d2c66841a5897776$var$h($d2c66841a5897776$var$t);
            null !== m && $d2c66841a5897776$var$K($d2c66841a5897776$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $d2c66841a5897776$var$v = null, $d2c66841a5897776$var$y = c, $d2c66841a5897776$var$z = !1;
    }
}
var $d2c66841a5897776$var$N = !1, $d2c66841a5897776$var$O = null, $d2c66841a5897776$var$L = -1, $d2c66841a5897776$var$P = 5, $d2c66841a5897776$var$Q = -1;
function $d2c66841a5897776$var$M() {
    return $d2c66841a5897776$export$c4744153514ff05d() - $d2c66841a5897776$var$Q < $d2c66841a5897776$var$P ? !1 : !0;
}
function $d2c66841a5897776$var$R() {
    if (null !== $d2c66841a5897776$var$O) {
        var a = $d2c66841a5897776$export$c4744153514ff05d();
        $d2c66841a5897776$var$Q = a;
        var b = !0;
        try {
            b = $d2c66841a5897776$var$O(!0, a);
        } finally{
            b ? $d2c66841a5897776$var$S() : ($d2c66841a5897776$var$N = !1, $d2c66841a5897776$var$O = null);
        }
    } else $d2c66841a5897776$var$N = !1;
}
var $d2c66841a5897776$var$S;
if ("function" === typeof $d2c66841a5897776$var$F) $d2c66841a5897776$var$S = function() {
    $d2c66841a5897776$var$F($d2c66841a5897776$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d2c66841a5897776$var$T = new MessageChannel, $d2c66841a5897776$var$U = $d2c66841a5897776$var$T.port2;
    $d2c66841a5897776$var$T.port1.onmessage = $d2c66841a5897776$var$R;
    $d2c66841a5897776$var$S = function() {
        $d2c66841a5897776$var$U.postMessage(null);
    };
} else $d2c66841a5897776$var$S = function() {
    $d2c66841a5897776$var$D($d2c66841a5897776$var$R, 0);
};
function $d2c66841a5897776$var$I(a) {
    $d2c66841a5897776$var$O = a;
    $d2c66841a5897776$var$N || ($d2c66841a5897776$var$N = !0, $d2c66841a5897776$var$S());
}
function $d2c66841a5897776$var$K(a, b) {
    $d2c66841a5897776$var$L = $d2c66841a5897776$var$D(function() {
        a($d2c66841a5897776$export$c4744153514ff05d());
    }, b);
}
$d2c66841a5897776$export$3e506c1ccc9cc1a7 = 5;
$d2c66841a5897776$export$e26fe2ed2fa76875 = 1;
$d2c66841a5897776$export$502329bbf4b505b1 = 4;
$d2c66841a5897776$export$6e3807111c4874c4 = 3;
$d2c66841a5897776$export$c27134553091fb3a = null;
$d2c66841a5897776$export$33ee1acdc04fd2a2 = 2;
$d2c66841a5897776$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d2c66841a5897776$export$8352ce38b91d0c62 = function() {
    $d2c66841a5897776$var$A || $d2c66841a5897776$var$z || ($d2c66841a5897776$var$A = !0, $d2c66841a5897776$var$I($d2c66841a5897776$var$J));
};
$d2c66841a5897776$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d2c66841a5897776$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$d2c66841a5897776$export$d3dfb8e4810cb555 = function() {
    return $d2c66841a5897776$var$y;
};
$d2c66841a5897776$export$839f9183b0465a69 = function() {
    return $d2c66841a5897776$var$h($d2c66841a5897776$var$r);
};
$d2c66841a5897776$export$72fdf0e06517287b = function(a) {
    switch($d2c66841a5897776$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d2c66841a5897776$var$y;
    }
    var c = $d2c66841a5897776$var$y;
    $d2c66841a5897776$var$y = b;
    try {
        return a();
    } finally{
        $d2c66841a5897776$var$y = c;
    }
};
$d2c66841a5897776$export$4b844e58a3e414b4 = function() {};
$d2c66841a5897776$export$816d2913ae6b83b1 = function() {};
$d2c66841a5897776$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d2c66841a5897776$var$y;
    $d2c66841a5897776$var$y = a;
    try {
        return b();
    } finally{
        $d2c66841a5897776$var$y = c;
    }
};
$d2c66841a5897776$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d2c66841a5897776$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d2c66841a5897776$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d2c66841a5897776$var$f($d2c66841a5897776$var$t, a), null === $d2c66841a5897776$var$h($d2c66841a5897776$var$r) && a === $d2c66841a5897776$var$h($d2c66841a5897776$var$t) && ($d2c66841a5897776$var$B ? ($d2c66841a5897776$var$E($d2c66841a5897776$var$L), $d2c66841a5897776$var$L = -1) : $d2c66841a5897776$var$B = !0, $d2c66841a5897776$var$K($d2c66841a5897776$var$H, c - d))) : (a.sortIndex = e, $d2c66841a5897776$var$f($d2c66841a5897776$var$r, a), $d2c66841a5897776$var$A || $d2c66841a5897776$var$z || ($d2c66841a5897776$var$A = !0, $d2c66841a5897776$var$I($d2c66841a5897776$var$J)));
    return a;
};
$d2c66841a5897776$export$b5836b71941fa3ed = $d2c66841a5897776$var$M;
$d2c66841a5897776$export$cf845f2c119da08a = function(a) {
    var b = $d2c66841a5897776$var$y;
    return function() {
        var c = $d2c66841a5897776$var$y;
        $d2c66841a5897776$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d2c66841a5897776$var$y = c;
        }
    };
};

});





parcelRegister("fuLgT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b47e537ec137ebd0$export$2e2bcd8739ae039; });

var $ll4DM = parcelRequire("ll4DM");

var $8ztQ2 = parcelRequire("8ztQ2");

var $dLubS = parcelRequire("dLubS");
function $b47e537ec137ebd0$var$v4(options, buf, offset) {
    if ((0, $ll4DM.default).randomUUID && !buf && !options) return (0, $ll4DM.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $8ztQ2.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $dLubS.unsafeStringify)(rnds);
}
var $b47e537ec137ebd0$export$2e2bcd8739ae039 = $b47e537ec137ebd0$var$v4;

});
parcelRegister("ll4DM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f88f28aaf23e57c8$export$2e2bcd8739ae039; });
const $f88f28aaf23e57c8$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $f88f28aaf23e57c8$export$2e2bcd8739ae039 = {
    randomUUID: $f88f28aaf23e57c8$var$randomUUID
};

});

parcelRegister("8ztQ2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63d8bcdd3a4eb4ab$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $63d8bcdd3a4eb4ab$var$getRandomValues;
const $63d8bcdd3a4eb4ab$var$rnds8 = new Uint8Array(16);
function $63d8bcdd3a4eb4ab$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$63d8bcdd3a4eb4ab$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $63d8bcdd3a4eb4ab$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$63d8bcdd3a4eb4ab$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $63d8bcdd3a4eb4ab$var$getRandomValues($63d8bcdd3a4eb4ab$var$rnds8);
}

});

parcelRegister("dLubS", function(module, exports) {
$parcel$export(module.exports, "unsafeStringify", function () { return $a0571563e2cd7560$export$8fb373d660548968; });

var $jAl7Q = parcelRequire("jAl7Q");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $a0571563e2cd7560$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$a0571563e2cd7560$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $a0571563e2cd7560$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $a0571563e2cd7560$var$byteToHex[arr[offset + 0]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 1]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 2]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 3]] + '-' + $a0571563e2cd7560$var$byteToHex[arr[offset + 4]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 5]] + '-' + $a0571563e2cd7560$var$byteToHex[arr[offset + 6]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 7]] + '-' + $a0571563e2cd7560$var$byteToHex[arr[offset + 8]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 9]] + '-' + $a0571563e2cd7560$var$byteToHex[arr[offset + 10]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 11]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 12]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 13]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 14]] + $a0571563e2cd7560$var$byteToHex[arr[offset + 15]];
}
function $a0571563e2cd7560$var$stringify(arr, offset = 0) {
    const uuid = $a0571563e2cd7560$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $jAl7Q.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $a0571563e2cd7560$export$2e2bcd8739ae039 = $a0571563e2cd7560$var$stringify;

});
parcelRegister("jAl7Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e421c439d2df18ba$export$2e2bcd8739ae039; });

var $7B4E2 = parcelRequire("7B4E2");
function $e421c439d2df18ba$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $7B4E2.default).test(uuid);
}
var $e421c439d2df18ba$export$2e2bcd8739ae039 = $e421c439d2df18ba$var$validate;

});
parcelRegister("7B4E2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $587f9774c0cec9af$export$2e2bcd8739ae039; });
var $587f9774c0cec9af$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("eQyIx", function(module, exports) {
$parcel$export(module.exports, "initUFO", function () { return $2f002489cca51c20$export$af995ee1d7017fea; });

var $eLT4U = parcelRequire("eLT4U");

var $gyWh8 = parcelRequire("gyWh8");

var $1CoTB = parcelRequire("1CoTB");

var $2ttAa = parcelRequire("2ttAa");

var $46WV6 = parcelRequire("46WV6");

var $g59aM = parcelRequire("g59aM");

var $dSyvH = parcelRequire("dSyvH");
const $2f002489cca51c20$export$8f9224b08ba8536e = (path)=>{
    if (path.length) {
        if (window !== undefined && window.isUniform) {
            if (window.compositionStatusCode !== 404) return 'uniform.all';
            return 'uniform.404';
        }
        return window !== undefined && window.cmsPageVariant ? path.replace(/^\//, '').replace(/\//g, '-').toLowerCase() + '-' + window.cmsPageVariant : path.replace(/^\//, '').replace(/\//g, '-').toLowerCase();
    }
    return 'home';
};
const $2f002489cca51c20$export$6ce22e22308598d = ()=>{
    try {
        return (window.SSR_totalMetrics || {})['duration'] || 0;
    } catch (e) {
        console.warn('Error getting SSR total', e);
        return 0;
    }
};
const $2f002489cca51c20$export$bf7408e83532dcd0 = ()=>{
    try {
        return window.SSR_detailMetrics || {};
    } catch (e) {
        console.warn('Error getting SSR timings', e);
        return {};
    }
};
const $2f002489cca51c20$export$a2649d59716eb83a = (interaction)=>{
    try {
        return {
            custom: (0, $g59aM.getCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
};
const $2f002489cca51c20$var$getFCPStartTime = ()=>{
    try {
        const paintEntries = window.performance.getEntriesByType('paint');
        const firstContentfulPaint = paintEntries.find((entry)=>entry.name === 'first-contentful-paint');
        return firstContentfulPaint?.startTime || 0;
    } catch (e) {
        console.warn('Error getting first contentful paint', e);
        return 0;
    }
};
const $2f002489cca51c20$export$ea92d4e542ec02b3 = {
    getDoneMark: $2f002489cca51c20$export$6ce22e22308598d,
    getTimings: $2f002489cca51c20$export$bf7408e83532dcd0,
    getFeatureFlags: ()=>null
};
const $2f002489cca51c20$export$e506a1d27d1eaa20 = {
    ssr: {
        getSSRDoneTime: $2f002489cca51c20$var$getFCPStartTime
    },
    product: 'marketing',
    region: window.SSR_region || 'unknown',
    additionalPayloadData: $2f002489cca51c20$export$a2649d59716eb83a,
    assetsConfig: {
        classification: (0, $46WV6.assetsClassification)
    },
    kind: {
        page_load: 1,
        transition: 1,
        hover: 0,
        legacy: 1,
        typing: 0,
        press: 1
    },
    capability: {
        feature_flag_access: 100,
        react_profiler: 1
    },
    segmentPrefix: 'ufo-',
    typingMethod: 'timeout',
    //removeInteractionsUFOPrefixes: true,
    //removePageSegmentsUFOPrefixes: false,
    vc: {
        enabled: true,
        heatmapSize: 200,
        oldDomUpdates: false,
        devToolsEnabled: true,
        selectorConfig: {
            id: false,
            role: true,
            className: true,
            testId: true
        }
    }
};
const $2f002489cca51c20$var$handleDynamicImportFailures = ()=>{
    if (typeof window !== 'undefined') window.addEventListener('unhandledrejection', (event)=>{
        const reason = event.reason ?? event.detail?.reason;
        if (reason) {
            const message = typeof reason === 'string' ? reason : reason.message;
            if (typeof message === 'string' && message.includes('dynamically imported module') && (message.includes('segment-highlight') || message.includes('create-payload') || message.includes('create-post-interaction-log-payload'))) {
                console.error(reason);
                event.preventDefault();
                // Prevent the error from reaching the global handler.
                // This keeps the error out of our Sentry logs.
                event.stopImmediatePropagation();
                return;
            }
        }
    });
};
const $2f002489cca51c20$export$af995ee1d7017fea = (analyticsClient, path)=>{
    // HACK: react-ufo does some unprotected dynamic importing internally.
    // So, we attach a global handler for when those dynamic imports fail
    // (usually due to network problems), report them in the console,
    // and move on.
    $2f002489cca51c20$var$handleDynamicImportFailures();
    // Resource Timings Configuration
    (0, $gyWh8.configure)((0, $dSyvH.resourceTimingsConfig));
    // SSR Configuration
    (0, $1CoTB.configure)($2f002489cca51c20$export$ea92d4e542ec02b3);
    // UFO Configuration
    (0, $eLT4U.init)(Promise.resolve(analyticsClient), $2f002489cca51c20$export$e506a1d27d1eaa20);
    const ufoName = $2f002489cca51c20$export$8f9224b08ba8536e(path);
    (0, $2ttAa.default)(ufoName, path || '/');
};

});
parcelRegister("eLT4U", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $ac102ddc9189192a$export$2cd8252107eb640b; });

var $6HNZJ = parcelRequire("6HNZJ");

var $eAzuA = parcelRequire("eAzuA");

var $c3LVh = parcelRequire("c3LVh");
parcelRequire("gN5RF");
var $ct4al = parcelRequire("ct4al");

var $39c3M = parcelRequire("39c3M");

var $ceERr = parcelRequire("ceERr");

var $03EZb = parcelRequire("03EZb");

var $f3CCR = parcelRequire("f3CCR");

var $ndMIw = parcelRequire("ndMIw");

var $iUdsP = parcelRequire("iUdsP");

var $4gtBF = parcelRequire("4gtBF");

var $a48Mt = parcelRequire("a48Mt");

var $bHUpV = parcelRequire("bHUpV");

var $kqXw0 = parcelRequire("kqXw0");

var $2Vke6 = parcelRequire("2Vke6");

var $cNHx9 = parcelRequire("cNHx9");
var $ac102ddc9189192a$var$initialized = false;
function $ac102ddc9189192a$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, $cNHx9.default)(onIdle);
    }
    (0, $a48Mt.sinkInteractionHandler)(sinkFn);
}
function $ac102ddc9189192a$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            var payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then(function(payload) {
                if (payload) instance.sendOperationalEvent(payload);
            });
        }
        (0, $cNHx9.default)(experimentalMetricsOnIdle);
    }
    (0, $f3CCR.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $ac102ddc9189192a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $a48Mt.sinkPostInteractionLogHandler)(function(logOutput) {
        (0, $cNHx9.default)(function() {
            var payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $ac102ddc9189192a$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $2Vke6.sinkTerminalErrorHandler)(function(errorData, context) {
        (0, $cNHx9.default)(function() {
            var payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $ac102ddc9189192a$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $a48Mt.interactionExtraMetrics).sinkHandler(function(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult) {
        (0, $cNHx9.default)(/*#__PURE__*/ (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee() {
            var payload;
            return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
                    case 2:
                        payload = _context.sent;
                        if (payload) instance.sendOperationalEvent(payload);
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    });
}
function $ac102ddc9189192a$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, $cNHx9.default)(onIdle);
    }
    (0, $ndMIw.sinkExtraSearchPageInteractionHandler)(sinkFn);
}




function $ac102ddc9189192a$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($ac102ddc9189192a$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $03EZb.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $03EZb.isUFOEnabled)()) {
        $ac102ddc9189192a$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $kqXw0.initialisePressureObserver)();
    (0, $kqXw0.initialiseMemoryObserver)();
    if ((0, $39c3M.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        var contextManager = new (0, $iUdsP.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $iUdsP.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $ct4al.context).setGlobalContextManager(contextManager);
    }
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        var _config$experimentalI, _config$extraInteract;
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $a48Mt.postInteractionLog).initializeVCObserver(vcOptions);
        if (config !== null && config !== void 0 && (_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) (0, $f3CCR.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
        if (config !== null && config !== void 0 && (_config$extraInteract = config.extraInteractionMetrics) !== null && _config$extraInteract !== void 0 && _config$extraInteract.enabled) (0, $a48Mt.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $4gtBF.setupHiddenTimingCapture)();
    (0, $ceERr.startLighthouseObserver)();
    (0, $4gtBF.setupThrottleDetection)();
    $ac102ddc9189192a$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        var observer = (0, $bHUpV.getPerformanceObserver)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("9OJFO")),
        (parcelRequire("7zXN1")),
        (parcelRequire("8KDEO")),
        (parcelRequire("e6pRn"))
    ]).then(function(_ref2) {
        var _ref3 = (0, $6HNZJ.default)(_ref2, 5), awc = _ref3[0], payloadPackage = _ref3[1], createPostInteractionLogPayloadPackage = _ref3[2], createInteractionExtraMetricsPayloadPackage = _ref3[3], createTerminalErrorPayloadPackage = _ref3[4];
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then(function(client) {
            var _config$terminalError, _config$experimentalI2, _config$postInteracti, _config$extraInteract2, _config$extraSearchPa;
            var instance = client.getInstance();
            $ac102ddc9189192a$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError = config.terminalErrors) !== null && _config$terminalError !== void 0 && _config$terminalError.enabled && (0, $39c3M.fg)('platform_ufo_enable_terminal_errors')) $ac102ddc9189192a$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$experimentalI2 = config.experimentalInteractionMetrics) !== null && _config$experimentalI2 !== void 0 && _config$experimentalI2.enabled) $ac102ddc9189192a$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $ac102ddc9189192a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraInteract2 = config.extraInteractionMetrics) !== null && _config$extraInteract2 !== void 0 && _config$extraInteract2.enabled) $ac102ddc9189192a$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa = config.extraSearchPageInteraction) !== null && _config$extraSearchPa !== void 0 && _config$extraSearchPa.enabled) $ac102ddc9189192a$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config$terminalError2, _config$experimentalI3, _config$postInteracti2, _config$extraInteract3, _config$extraSearchPa2;
            $ac102ddc9189192a$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError2 = config.terminalErrors) !== null && _config$terminalError2 !== void 0 && _config$terminalError2.enabled && (0, $39c3M.fg)('platform_ufo_enable_terminal_errors')) $ac102ddc9189192a$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$experimentalI3 = config.experimentalInteractionMetrics) !== null && _config$experimentalI3 !== void 0 && _config$experimentalI3.enabled) $ac102ddc9189192a$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $ac102ddc9189192a$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraInteract3 = config.extraInteractionMetrics) !== null && _config$extraInteract3 !== void 0 && _config$extraInteract3.enabled) $ac102ddc9189192a$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa2 = config.extraSearchPageInteraction) !== null && _config$extraSearchPa2 !== void 0 && _config$extraSearchPa2.enabled) $ac102ddc9189192a$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}

});
parcelRegister("6HNZJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4e1d8a258f52368f$export$2e2bcd8739ae039; });

var $6ywSU = parcelRequire("6ywSU");

var $5xUrt = parcelRequire("5xUrt");

var $kU3AR = parcelRequire("kU3AR");

var $lDKH7 = parcelRequire("lDKH7");
function $4e1d8a258f52368f$export$2e2bcd8739ae039(r, e) {
    return (0, $6ywSU.default)(r) || (0, $5xUrt.default)(r, e) || (0, $kU3AR.default)(r, e) || (0, $lDKH7.default)();
}

});
parcelRegister("6ywSU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c5f6d3ef21f079a$export$2e2bcd8739ae039; });
function $4c5f6d3ef21f079a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("5xUrt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $409bd10772a86827$export$2e2bcd8739ae039; });
function $409bd10772a86827$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("kU3AR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f37bd3360b91c28c$export$2e2bcd8739ae039; });

var $deuCz = parcelRequire("deuCz");
function $f37bd3360b91c28c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $deuCz.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $deuCz.default)(r, a) : void 0;
    }
}

});
parcelRegister("deuCz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a2455e83ea36ffe$export$2e2bcd8739ae039; });
function $9a2455e83ea36ffe$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("lDKH7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc11760477f0d747$export$2e2bcd8739ae039; });
function $fc11760477f0d747$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("eAzuA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a9eff589a9609cfc$export$2e2bcd8739ae039; });
function $a9eff589a9609cfc$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $a9eff589a9609cfc$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $a9eff589a9609cfc$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $a9eff589a9609cfc$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("c3LVh", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $8c7af0549de459cb$var$runtime = (parcelRequire("gXGyv"))();
module.exports = $8c7af0549de459cb$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $8c7af0549de459cb$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $8c7af0549de459cb$var$runtime;
    else Function("r", "regeneratorRuntime = r")($8c7af0549de459cb$var$runtime);
}

});
parcelRegister("gXGyv", function(module, exports) {

var $jQnSw = parcelRequire("jQnSw");

var $jHSzl = parcelRequire("jHSzl");

var $5eWo4 = parcelRequire("5eWo4");

var $aYU5E = parcelRequire("aYU5E");

var $9PXsz = parcelRequire("9PXsz");

var $5I0ph = parcelRequire("5I0ph");

var $evrXf = parcelRequire("evrXf");
function $c5932aaa02521c07$var$_regeneratorRuntime() {
    "use strict";
    var r = $jHSzl(), e = r.m($c5932aaa02521c07$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $evrXf(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $c5932aaa02521c07$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $jQnSw(r, e);
            },
            AsyncIterator: $9PXsz,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $aYU5E : $5eWo4)(a(r), e, t, o, u);
            },
            keys: $5I0ph,
            values: $evrXf
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $c5932aaa02521c07$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jQnSw", function(module, exports) {
function $e725656ba5826d55$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $e725656ba5826d55$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jHSzl", function(module, exports) {

var $f8MdJ = parcelRequire("f8MdJ");
function $e58c5cc56539f8cc$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $f8MdJ(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($f8MdJ(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $f8MdJ(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $f8MdJ(u, "constructor", GeneratorFunctionPrototype), $f8MdJ(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $f8MdJ(GeneratorFunctionPrototype, o, "GeneratorFunction"), $f8MdJ(u), $f8MdJ(u, o, "Generator"), $f8MdJ(u, n, function() {
        return this;
    }), $f8MdJ(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $e58c5cc56539f8cc$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $e58c5cc56539f8cc$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f8MdJ", function(module, exports) {
function $b05d01f99b409ef6$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $b05d01f99b409ef6$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $b05d01f99b409ef6$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b05d01f99b409ef6$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $b05d01f99b409ef6$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5eWo4", function(module, exports) {

var $aYU5E = parcelRequire("aYU5E");
function $3d0b8d0d07a91253$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $aYU5E(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $3d0b8d0d07a91253$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aYU5E", function(module, exports) {

var $jHSzl = parcelRequire("jHSzl");

var $9PXsz = parcelRequire("9PXsz");
function $7feb045581c251b2$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $9PXsz($jHSzl().w(r, e, t, o), n || Promise);
}
module.exports = $7feb045581c251b2$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9PXsz", function(module, exports) {

var $jQnSw = parcelRequire("jQnSw");

var $f8MdJ = parcelRequire("f8MdJ");
function $7296fffb2ebb09c3$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $jQnSw ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($f8MdJ($7296fffb2ebb09c3$var$AsyncIterator.prototype), $f8MdJ($7296fffb2ebb09c3$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $f8MdJ(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $7296fffb2ebb09c3$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("5I0ph", function(module, exports) {
function $42816091b3bb91a5$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $42816091b3bb91a5$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("evrXf", function(module, exports) {

var $jQOms = parcelRequire("jQOms");
var $a8f9a525c5e32ce1$var$_typeof = $jQOms.default;
function $a8f9a525c5e32ce1$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($a8f9a525c5e32ce1$var$_typeof(e) + " is not iterable");
}
module.exports = $a8f9a525c5e32ce1$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jQOms", function(module, exports) {
function $e739f058a0d3c567$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $e739f058a0d3c567$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e739f058a0d3c567$var$_typeof(o);
}
module.exports = $e739f058a0d3c567$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("gN5RF", function(module, exports) {
$parcel$export(module.exports, "context", function () { return (parcelRequire("ct4al")).context; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $8GZT6 = parcelRequire("8GZT6");















var $ct4al = parcelRequire("ct4al");

var $kIq4G = parcelRequire("kIq4G");

var $drumB = parcelRequire("drumB");

var $kj1ST = parcelRequire("kj1ST");

var $dmnrM = parcelRequire("dmnrM");
var // Default export.
$c395c584b173e571$export$2e2bcd8739ae039 = {
    context: (0, $ct4al.context),
    diag: (0, $kIq4G.diag),
    metrics: (0, $drumB.metrics),
    propagation: (0, $kj1ST.propagation),
    trace: (0, $dmnrM.trace)
};

});
parcelRegister("8GZT6", function(module, exports) {
$parcel$export(module.exports, "createContextKey", function () { return $654240968fc7505b$export$b8c322c5a7cfce78; });
$parcel$export(module.exports, "ROOT_CONTEXT", function () { return $654240968fc7505b$export$78df28f9b2f9a7dc; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $654240968fc7505b$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $654240968fc7505b$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $654240968fc7505b$export$78df28f9b2f9a7dc = new $654240968fc7505b$var$BaseContext();

});

parcelRegister("ct4al", function(module, exports) {
$parcel$export(module.exports, "context", function () { return $913b6cbc82e9af08$export$a078c61943f9dbbe; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $8mCvh = parcelRequire("8mCvh");
var $913b6cbc82e9af08$export$a078c61943f9dbbe = (0, $8mCvh.ContextAPI).getInstance();

});
parcelRegister("8mCvh", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", function () { return $616e3ed0451c4644$export$4148866f0a453927; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $do9MH = parcelRequire("do9MH");

var $98Ll1 = parcelRequire("98Ll1");

var $kpcC3 = parcelRequire("kpcC3");
var $616e3ed0451c4644$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $616e3ed0451c4644$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $616e3ed0451c4644$var$API_NAME = 'context';
var $616e3ed0451c4644$var$NOOP_CONTEXT_MANAGER = new (0, $do9MH.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $616e3ed0451c4644$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $98Ll1.registerGlobal)($616e3ed0451c4644$var$API_NAME, contextManager, (0, $kpcC3.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $616e3ed0451c4644$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $616e3ed0451c4644$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $98Ll1.getGlobal)($616e3ed0451c4644$var$API_NAME) || $616e3ed0451c4644$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $98Ll1.unregisterGlobal)($616e3ed0451c4644$var$API_NAME, (0, $kpcC3.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("do9MH", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", function () { return $9bf51b43922a1a01$export$a27e5df35d1539a6; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8GZT6 = parcelRequire("8GZT6");
var $9bf51b43922a1a01$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $9bf51b43922a1a01$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9bf51b43922a1a01$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $8GZT6.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $9bf51b43922a1a01$var$__spreadArray([
            thisArg
        ], $9bf51b43922a1a01$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});

parcelRegister("98Ll1", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", function () { return $6a7994c335012249$export$d586ae880b433238; });
$parcel$export(module.exports, "getGlobal", function () { return $6a7994c335012249$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "unregisterGlobal", function () { return $6a7994c335012249$export$d42ac835f38d1fb2; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5GVxz = parcelRequire("5GVxz");

var $e3N75 = parcelRequire("e3N75");

var $ddSQP = parcelRequire("ddSQP");
var $6a7994c335012249$var$major = (0, $e3N75.VERSION).split('.')[0];
var $6a7994c335012249$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $6a7994c335012249$var$major);
var $6a7994c335012249$var$_global = (0, $5GVxz._globalThis);
function $6a7994c335012249$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $6a7994c335012249$var$_global[$6a7994c335012249$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $6a7994c335012249$var$_global[$6a7994c335012249$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $e3N75.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $e3N75.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $e3N75.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $e3N75.VERSION) + ".");
    return true;
}
function $6a7994c335012249$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $6a7994c335012249$var$_global[$6a7994c335012249$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $ddSQP.isCompatible)(globalVersion)) return;
    return (_b = $6a7994c335012249$var$_global[$6a7994c335012249$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $6a7994c335012249$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $e3N75.VERSION) + ".");
    var api = $6a7994c335012249$var$_global[$6a7994c335012249$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("5GVxz", function(module, exports) {
$parcel$export(module.exports, "_globalThis", function () { return $424d82545840eca9$export$5c524ddf7208c00c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $424d82545840eca9$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});

parcelRegister("e3N75", function(module, exports) {
$parcel$export(module.exports, "VERSION", function () { return $a3c7716131b7494c$export$a4ad2735b021c132; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $a3c7716131b7494c$export$a4ad2735b021c132 = '1.9.0';

});

parcelRegister("ddSQP", function(module, exports) {
$parcel$export(module.exports, "isCompatible", function () { return $9a07098433ec0c4c$export$7fc0d8c3ab188c4c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $e3N75 = parcelRequire("e3N75");
var $9a07098433ec0c4c$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $9a07098433ec0c4c$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($9a07098433ec0c4c$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($9a07098433ec0c4c$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $9a07098433ec0c4c$export$7fc0d8c3ab188c4c = $9a07098433ec0c4c$export$a5733a4d26a1ec61((0, $e3N75.VERSION));

});


parcelRegister("kpcC3", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", function () { return $edafed1902d9318c$export$5c8937ffc688cfd3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3ELv3 = parcelRequire("3ELv3");

var $kx8Po = parcelRequire("kx8Po");

var $8cvtX = parcelRequire("8cvtX");

var $98Ll1 = parcelRequire("98Ll1");
var $edafed1902d9318c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $edafed1902d9318c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $edafed1902d9318c$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $edafed1902d9318c$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $98Ll1.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $edafed1902d9318c$var$__spreadArray([], $edafed1902d9318c$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $8cvtX.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $98Ll1.getGlobal)('diag');
            var newLogger = (0, $kx8Po.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $8cvtX.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $98Ll1.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $98Ll1.unregisterGlobal)($edafed1902d9318c$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $3ELv3.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("3ELv3", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", function () { return $2a99f40683e1a741$export$b4bccc12f5b13129; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $98Ll1 = parcelRequire("98Ll1");
var $2a99f40683e1a741$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2a99f40683e1a741$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $2a99f40683e1a741$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $2a99f40683e1a741$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $2a99f40683e1a741$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $2a99f40683e1a741$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $2a99f40683e1a741$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $2a99f40683e1a741$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $2a99f40683e1a741$var$logProxy(funcName, namespace, args) {
    var logger = (0, $98Ll1.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $2a99f40683e1a741$var$__spreadArray([], $2a99f40683e1a741$var$__read(args), false));
}

});

parcelRegister("kx8Po", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", function () { return $ef2dbcc7a9a1d7a9$export$9a9cc475abb19689; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8cvtX = parcelRequire("8cvtX");
function $ef2dbcc7a9a1d7a9$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $8cvtX.DiagLogLevel).NONE) maxLevel = (0, $8cvtX.DiagLogLevel).NONE;
    else if (maxLevel > (0, $8cvtX.DiagLogLevel).ALL) maxLevel = (0, $8cvtX.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $8cvtX.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $8cvtX.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $8cvtX.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $8cvtX.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $8cvtX.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("8cvtX", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", function () { return $5f87dd6ce096472b$export$b7d7b4c0f3c95263; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $5f87dd6ce096472b$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($5f87dd6ce096472b$export$b7d7b4c0f3c95263 || ($5f87dd6ce096472b$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("kIq4G", function(module, exports) {
$parcel$export(module.exports, "diag", function () { return $f14c2494de5fddec$export$c042e7c2f59bc046; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $kpcC3 = parcelRequire("kpcC3");
var $f14c2494de5fddec$export$c042e7c2f59bc046 = (0, $kpcC3.DiagAPI).instance();

});

parcelRegister("drumB", function(module, exports) {
$parcel$export(module.exports, "metrics", function () { return $9c955991b24e4349$export$b0c5c2fac8144e54; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $duCgz = parcelRequire("duCgz");
var $9c955991b24e4349$export$b0c5c2fac8144e54 = (0, $duCgz.MetricsAPI).getInstance();

});
parcelRegister("duCgz", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", function () { return $9d2bc2929183a3d0$export$1339f6eb6111c638; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $g9Hcq = parcelRequire("g9Hcq");

var $98Ll1 = parcelRequire("98Ll1");

var $kpcC3 = parcelRequire("kpcC3");
var $9d2bc2929183a3d0$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $9d2bc2929183a3d0$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $98Ll1.registerGlobal)($9d2bc2929183a3d0$var$API_NAME, provider, (0, $kpcC3.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $98Ll1.getGlobal)($9d2bc2929183a3d0$var$API_NAME) || (0, $g9Hcq.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $98Ll1.unregisterGlobal)($9d2bc2929183a3d0$var$API_NAME, (0, $kpcC3.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("g9Hcq", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", function () { return $bc2eff1cb114db70$export$d21fe83355c56e18; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1gCZh = parcelRequire("1gCZh");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $bc2eff1cb114db70$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $1gCZh.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $bc2eff1cb114db70$export$d21fe83355c56e18 = new $bc2eff1cb114db70$export$51c513ea08316108();

});
parcelRegister("1gCZh", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", function () { return $0ec5872111e348c2$export$65e277d35235a01f; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0ec5872111e348c2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $0ec5872111e348c2$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $0ec5872111e348c2$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $0ec5872111e348c2$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $0ec5872111e348c2$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $0ec5872111e348c2$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $0ec5872111e348c2$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $0ec5872111e348c2$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $0ec5872111e348c2$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $0ec5872111e348c2$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $0ec5872111e348c2$export$b556ba0f560c45b = /** @class */ function(_super) {
    $0ec5872111e348c2$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($0ec5872111e348c2$export$834a616d1cf278b);
var $0ec5872111e348c2$export$df09a35db160df98 = /** @class */ function(_super) {
    $0ec5872111e348c2$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($0ec5872111e348c2$export$834a616d1cf278b);
var $0ec5872111e348c2$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $0ec5872111e348c2$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($0ec5872111e348c2$export$834a616d1cf278b);
var $0ec5872111e348c2$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $0ec5872111e348c2$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($0ec5872111e348c2$export$834a616d1cf278b);
var $0ec5872111e348c2$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $0ec5872111e348c2$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $0ec5872111e348c2$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($0ec5872111e348c2$export$a5a3e7829c289482);
var $0ec5872111e348c2$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $0ec5872111e348c2$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($0ec5872111e348c2$export$a5a3e7829c289482);
var $0ec5872111e348c2$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $0ec5872111e348c2$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($0ec5872111e348c2$export$a5a3e7829c289482);
var $0ec5872111e348c2$export$65e277d35235a01f = new $0ec5872111e348c2$export$c23c6f85dd4fc1e9();
var $0ec5872111e348c2$export$e6d19fe5233efc54 = new $0ec5872111e348c2$export$b556ba0f560c45b();
var $0ec5872111e348c2$export$dd01300aacbcec1c = new $0ec5872111e348c2$export$b7f4a3c7ea16c24();
var $0ec5872111e348c2$export$689c32a6a552e1a6 = new $0ec5872111e348c2$export$ef064c3e0426c607();
var $0ec5872111e348c2$export$2f189cd99d2b7429 = new $0ec5872111e348c2$export$df09a35db160df98();
var $0ec5872111e348c2$export$163422b94c3edbcb = new $0ec5872111e348c2$export$7a7e4b169d5c93a8();
var $0ec5872111e348c2$export$ea67e3c6ff624776 = new $0ec5872111e348c2$export$6990a2f90809ffc1();
var $0ec5872111e348c2$export$5b8be9ab17b673b3 = new $0ec5872111e348c2$export$3ec3555bc6f693a4();
function $0ec5872111e348c2$export$bc3a498ccbb5c2b5() {
    return $0ec5872111e348c2$export$65e277d35235a01f;
}

});




parcelRegister("kj1ST", function(module, exports) {
$parcel$export(module.exports, "propagation", function () { return $ec870b2d0cc78969$export$3e49040daa9dba20; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $dajb8 = parcelRequire("dajb8");
var $ec870b2d0cc78969$export$3e49040daa9dba20 = (0, $dajb8.PropagationAPI).getInstance();

});
parcelRegister("dajb8", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", function () { return $995b1605834b7545$export$471eda0a6213cac9; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $98Ll1 = parcelRequire("98Ll1");

var $jZGaS = parcelRequire("jZGaS");

var $l9rW1 = parcelRequire("l9rW1");

var $7W74P = parcelRequire("7W74P");

var $lUTF8 = parcelRequire("lUTF8");

var $kpcC3 = parcelRequire("kpcC3");
var $995b1605834b7545$var$API_NAME = 'propagation';
var $995b1605834b7545$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $jZGaS.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $995b1605834b7545$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $lUTF8.createBaggage);
        this.getBaggage = (0, $7W74P.getBaggage);
        this.getActiveBaggage = (0, $7W74P.getActiveBaggage);
        this.setBaggage = (0, $7W74P.setBaggage);
        this.deleteBaggage = (0, $7W74P.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $98Ll1.registerGlobal)($995b1605834b7545$var$API_NAME, propagator, (0, $kpcC3.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $l9rW1.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $l9rW1.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $98Ll1.unregisterGlobal)($995b1605834b7545$var$API_NAME, (0, $kpcC3.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $98Ll1.getGlobal)($995b1605834b7545$var$API_NAME) || $995b1605834b7545$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("jZGaS", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", function () { return $e8e46dc9fe1a1a96$export$8356c7eb3af7963b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $e8e46dc9fe1a1a96$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("l9rW1", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", function () { return $f6601b7d63710945$export$a0f575f55f38720a; });
$parcel$export(module.exports, "defaultTextMapSetter", function () { return $f6601b7d63710945$export$f70f1d111fccf1c1; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f6601b7d63710945$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $f6601b7d63710945$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("7W74P", function(module, exports) {
$parcel$export(module.exports, "getBaggage", function () { return $5c7370823f2b0f51$export$f3bffa0b5dd10d1e; });
$parcel$export(module.exports, "getActiveBaggage", function () { return $5c7370823f2b0f51$export$120a1756099436ee; });
$parcel$export(module.exports, "setBaggage", function () { return $5c7370823f2b0f51$export$adc9ca19eab3f500; });
$parcel$export(module.exports, "deleteBaggage", function () { return $5c7370823f2b0f51$export$4ca3a8a743c9f633; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8mCvh = parcelRequire("8mCvh");

var $8GZT6 = parcelRequire("8GZT6");
/**
 * Baggage key
 */ var $5c7370823f2b0f51$var$BAGGAGE_KEY = (0, $8GZT6.createContextKey)('OpenTelemetry Baggage Key');
function $5c7370823f2b0f51$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($5c7370823f2b0f51$var$BAGGAGE_KEY) || undefined;
}
function $5c7370823f2b0f51$export$120a1756099436ee() {
    return $5c7370823f2b0f51$export$f3bffa0b5dd10d1e((0, $8mCvh.ContextAPI).getInstance().active());
}
function $5c7370823f2b0f51$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($5c7370823f2b0f51$var$BAGGAGE_KEY, baggage);
}
function $5c7370823f2b0f51$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($5c7370823f2b0f51$var$BAGGAGE_KEY);
}

});

parcelRegister("lUTF8", function(module, exports) {
$parcel$export(module.exports, "createBaggage", function () { return $ff4a015a8e97d7d4$export$1034a425c7384452; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kpcC3 = parcelRequire("kpcC3");

var $g7yUi = parcelRequire("g7yUi");

var $e83SW = parcelRequire("e83SW");
var $ff4a015a8e97d7d4$var$diag = (0, $kpcC3.DiagAPI).instance();
function $ff4a015a8e97d7d4$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $g7yUi.BaggageImpl)(new Map(Object.entries(entries)));
}
function $ff4a015a8e97d7d4$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $ff4a015a8e97d7d4$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $e83SW.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("g7yUi", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", function () { return $bbc86090fe6f64a7$export$b8c511fa1a5f4987; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $bbc86090fe6f64a7$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bbc86090fe6f64a7$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $bbc86090fe6f64a7$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $bbc86090fe6f64a7$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $bbc86090fe6f64a7$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("e83SW", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", function () { return $a494d3889aa8af26$export$92dd2fe8ddb5cb7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $a494d3889aa8af26$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("dmnrM", function(module, exports) {
$parcel$export(module.exports, "trace", function () { return $9b9f84873ba6155d$export$357889f174732d38; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $3VfuO = parcelRequire("3VfuO");
var $9b9f84873ba6155d$export$357889f174732d38 = (0, $3VfuO.TraceAPI).getInstance();

});
parcelRegister("3VfuO", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", function () { return $2db2b724c7e241fc$export$2cccde6fcc7b568a; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $98Ll1 = parcelRequire("98Ll1");

var $iJg7a = parcelRequire("iJg7a");

var $85XaU = parcelRequire("85XaU");

var $eYWgg = parcelRequire("eYWgg");

var $kpcC3 = parcelRequire("kpcC3");
var $2db2b724c7e241fc$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $2db2b724c7e241fc$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $iJg7a.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $85XaU.wrapSpanContext);
        this.isSpanContextValid = (0, $85XaU.isSpanContextValid);
        this.deleteSpan = (0, $eYWgg.deleteSpan);
        this.getSpan = (0, $eYWgg.getSpan);
        this.getActiveSpan = (0, $eYWgg.getActiveSpan);
        this.getSpanContext = (0, $eYWgg.getSpanContext);
        this.setSpan = (0, $eYWgg.setSpan);
        this.setSpanContext = (0, $eYWgg.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $98Ll1.registerGlobal)($2db2b724c7e241fc$var$API_NAME, this._proxyTracerProvider, (0, $kpcC3.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $98Ll1.getGlobal)($2db2b724c7e241fc$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $98Ll1.unregisterGlobal)($2db2b724c7e241fc$var$API_NAME, (0, $kpcC3.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $iJg7a.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("iJg7a", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", function () { return $da28edf878abcd57$export$4137aabcb4254962; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $982pQ = parcelRequire("982pQ");

var $a1E7B = parcelRequire("a1E7B");
var $da28edf878abcd57$var$NOOP_TRACER_PROVIDER = new (0, $a1E7B.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $da28edf878abcd57$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $982pQ.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $da28edf878abcd57$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("982pQ", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", function () { return $6a56bc2925977649$export$df2c38268c6bb6b3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $ae3oT = parcelRequire("ae3oT");
var $6a56bc2925977649$var$NOOP_TRACER = new (0, $ae3oT.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $6a56bc2925977649$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $6a56bc2925977649$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("ae3oT", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", function () { return $771dd97af97946b6$export$714c1036cabcd223; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8mCvh = parcelRequire("8mCvh");

var $eYWgg = parcelRequire("eYWgg");

var $jsi7b = parcelRequire("jsi7b");

var $85XaU = parcelRequire("85XaU");
var $771dd97af97946b6$var$contextApi = (0, $8mCvh.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $771dd97af97946b6$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $771dd97af97946b6$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $jsi7b.NonRecordingSpan)();
        var parentFromContext = context && (0, $eYWgg.getSpanContext)(context);
        if ($771dd97af97946b6$var$isSpanContext(parentFromContext) && (0, $85XaU.isSpanContextValid)(parentFromContext)) return new (0, $jsi7b.NonRecordingSpan)(parentFromContext);
        else return new (0, $jsi7b.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $771dd97af97946b6$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $eYWgg.setSpan)(parentContext, span);
        return $771dd97af97946b6$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $771dd97af97946b6$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("eYWgg", function(module, exports) {
$parcel$export(module.exports, "getSpan", function () { return $ae83dcc24132d5b5$export$246e04ba06066af1; });
$parcel$export(module.exports, "getActiveSpan", function () { return $ae83dcc24132d5b5$export$1be426a8e585c83e; });
$parcel$export(module.exports, "setSpan", function () { return $ae83dcc24132d5b5$export$8ab2f2e6ee8ed0a8; });
$parcel$export(module.exports, "deleteSpan", function () { return $ae83dcc24132d5b5$export$a6bbfe9a17f7941c; });
$parcel$export(module.exports, "setSpanContext", function () { return $ae83dcc24132d5b5$export$c90bf5428c14cdb1; });
$parcel$export(module.exports, "getSpanContext", function () { return $ae83dcc24132d5b5$export$1a635f8f0b912781; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8GZT6 = parcelRequire("8GZT6");

var $jsi7b = parcelRequire("jsi7b");

var $8mCvh = parcelRequire("8mCvh");
/**
 * span key
 */ var $ae83dcc24132d5b5$var$SPAN_KEY = (0, $8GZT6.createContextKey)('OpenTelemetry Context Key SPAN');
function $ae83dcc24132d5b5$export$246e04ba06066af1(context) {
    return context.getValue($ae83dcc24132d5b5$var$SPAN_KEY) || undefined;
}
function $ae83dcc24132d5b5$export$1be426a8e585c83e() {
    return $ae83dcc24132d5b5$export$246e04ba06066af1((0, $8mCvh.ContextAPI).getInstance().active());
}
function $ae83dcc24132d5b5$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($ae83dcc24132d5b5$var$SPAN_KEY, span);
}
function $ae83dcc24132d5b5$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($ae83dcc24132d5b5$var$SPAN_KEY);
}
function $ae83dcc24132d5b5$export$c90bf5428c14cdb1(context, spanContext) {
    return $ae83dcc24132d5b5$export$8ab2f2e6ee8ed0a8(context, new (0, $jsi7b.NonRecordingSpan)(spanContext));
}
function $ae83dcc24132d5b5$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $ae83dcc24132d5b5$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("jsi7b", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", function () { return $e29eaf167422bf3b$export$972d28f7c6a8c6c7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $hfmww = parcelRequire("hfmww");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $e29eaf167422bf3b$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $hfmww.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});
parcelRegister("hfmww", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", function () { return $c8e54f13ee34d0cd$export$55cc39fb0d4bb4c0; });
$parcel$export(module.exports, "INVALID_TRACEID", function () { return $c8e54f13ee34d0cd$export$22be96e88d95e128; });
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", function () { return $c8e54f13ee34d0cd$export$8591e4c852b66703; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $d6D02 = parcelRequire("d6D02");
var $c8e54f13ee34d0cd$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $c8e54f13ee34d0cd$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $c8e54f13ee34d0cd$export$8591e4c852b66703 = {
    traceId: $c8e54f13ee34d0cd$export$22be96e88d95e128,
    spanId: $c8e54f13ee34d0cd$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $d6D02.TraceFlags).NONE
};

});
parcelRegister("d6D02", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", function () { return $98aa166d4f0826cb$export$bf9049ad2b0883ff; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $98aa166d4f0826cb$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($98aa166d4f0826cb$export$bf9049ad2b0883ff || ($98aa166d4f0826cb$export$bf9049ad2b0883ff = {}));

});




parcelRegister("85XaU", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", function () { return $5e4cb1461dca5442$export$e4373b9a2c09216c; });
$parcel$export(module.exports, "wrapSpanContext", function () { return $5e4cb1461dca5442$export$c19cc0f1911bdb85; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $hfmww = parcelRequire("hfmww");

var $jsi7b = parcelRequire("jsi7b");
var $5e4cb1461dca5442$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $5e4cb1461dca5442$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $5e4cb1461dca5442$export$29dd34cf1269f6da(traceId) {
    return $5e4cb1461dca5442$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $hfmww.INVALID_TRACEID);
}
function $5e4cb1461dca5442$export$8e51c6d8f0586aff(spanId) {
    return $5e4cb1461dca5442$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $hfmww.INVALID_SPANID);
}
function $5e4cb1461dca5442$export$e4373b9a2c09216c(spanContext) {
    return $5e4cb1461dca5442$export$29dd34cf1269f6da(spanContext.traceId) && $5e4cb1461dca5442$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $5e4cb1461dca5442$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $jsi7b.NonRecordingSpan)(spanContext);
}

});



parcelRegister("a1E7B", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", function () { return $74c91eb13e6dd278$export$87d8e93756f9e86e; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $ae3oT = parcelRequire("ae3oT");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $74c91eb13e6dd278$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $ae3oT.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("39c3M", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $24ab91327fcf082a$export$b40ec24ac8275656; });

var $9tjjp = parcelRequire("9tjjp");
function $24ab91327fcf082a$export$ba05d765b8392e5e(flagResolver) {
    (0, $9tjjp.setBooleanResolver)(flagResolver);
}
function $24ab91327fcf082a$export$470e5c2be1411c89(name) {
    return (0, $9tjjp.resolveBooleanFlag)(name);
}
function $24ab91327fcf082a$export$b40ec24ac8275656(name) {
    return (0, $9tjjp.resolveBooleanFlag)(name);
}

});
parcelRegister("9tjjp", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $6e55cd7ac9be3e5a$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $6e55cd7ac9be3e5a$export$6333b6aff9fc6275; });

var $3L8ZR = parcelRequire("3L8ZR");

var $diiJb = parcelRequire("diiJb");

var $7t0tI = parcelRequire("7t0tI");
var $6e55cd7ac9be3e5a$var$pkgName = '@atlaskit/platform-feature-flags';
var $6e55cd7ac9be3e5a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $6e55cd7ac9be3e5a$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $6e55cd7ac9be3e5a$var$ENV_ENABLE_PLATFORM_FF = $6e55cd7ac9be3e5a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $6e55cd7ac9be3e5a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $6e55cd7ac9be3e5a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $6e55cd7ac9be3e5a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $6e55cd7ac9be3e5a$var$ENV_ENABLE_PLATFORM_FF || $6e55cd7ac9be3e5a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $6e55cd7ac9be3e5a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $6e55cd7ac9be3e5a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$6e55cd7ac9be3e5a$var$globalVar[$6e55cd7ac9be3e5a$export$7e41b1b2bdee3f98] = $6e55cd7ac9be3e5a$var$globalVar[$6e55cd7ac9be3e5a$export$7e41b1b2bdee3f98] || $6e55cd7ac9be3e5a$var$DEFAULT_PFF_GLOBAL;
function $6e55cd7ac9be3e5a$export$f2b591175b3e424c(resolver) {
    $6e55cd7ac9be3e5a$var$globalVar[$6e55cd7ac9be3e5a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $6e55cd7ac9be3e5a$export$6333b6aff9fc6275(flagKey) {
    if ($6e55cd7ac9be3e5a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $diiJb.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $6e55cd7ac9be3e5a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $6e55cd7ac9be3e5a$var$globalVar[$6e55cd7ac9be3e5a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $6e55cd7ac9be3e5a$var$globalVar[$6e55cd7ac9be3e5a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $3L8ZR.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $6e55cd7ac9be3e5a$var$globalVar[$6e55cd7ac9be3e5a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3L8ZR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2bccbd73ae69aad8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("eydMo")).CLIENT_VERSION; });

var $1pngT = parcelRequire("1pngT");

var $ap6hD = parcelRequire("ap6hD");

var $5IxoE = parcelRequire("5IxoE");

var $b6Usy = parcelRequire("b6Usy");

var $eydMo = parcelRequire("eydMo");



var $gJrsj = parcelRequire("gJrsj");
var $2bccbd73ae69aad8$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $2bccbd73ae69aad8$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $1pngT.default)(this, FeatureGates);
    }
    return (0, $ap6hD.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$2bccbd73ae69aad8$var$_FeatureGates = $2bccbd73ae69aad8$var$FeatureGates;
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "client", new (0, $b6Usy.Client)());
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$2bccbd73ae69aad8$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $2bccbd73ae69aad8$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $2bccbd73ae69aad8$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$2bccbd73ae69aad8$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $2bccbd73ae69aad8$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $2bccbd73ae69aad8$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "initializeCalled", $2bccbd73ae69aad8$var$_FeatureGates.client.initializeCalled.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "initializeCompleted", $2bccbd73ae69aad8$var$_FeatureGates.client.initializeCompleted.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "initialize", $2bccbd73ae69aad8$var$_FeatureGates.client.initialize.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "initializeWithProvider", $2bccbd73ae69aad8$var$_FeatureGates.client.initializeWithProvider.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "initializeFromValues", $2bccbd73ae69aad8$var$_FeatureGates.client.initializeFromValues.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "manuallyLogGateExposure", $2bccbd73ae69aad8$var$_FeatureGates.client.manuallyLogGateExposure.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "getExperiment", $2bccbd73ae69aad8$var$_FeatureGates.client.getExperiment.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "manuallyLogExperimentExposure", $2bccbd73ae69aad8$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "manuallyLogLayerExposure", $2bccbd73ae69aad8$var$_FeatureGates.client.manuallyLogLayerExposure.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "shutdownStatsig", $2bccbd73ae69aad8$var$_FeatureGates.client.shutdownStatsig.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "overrideGate", $2bccbd73ae69aad8$var$_FeatureGates.client.overrideGate.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "clearGateOverride", $2bccbd73ae69aad8$var$_FeatureGates.client.clearGateOverride.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "overrideConfig", $2bccbd73ae69aad8$var$_FeatureGates.client.overrideConfig.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "clearConfigOverride", $2bccbd73ae69aad8$var$_FeatureGates.client.clearConfigOverride.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "setOverrides", $2bccbd73ae69aad8$var$_FeatureGates.client.setOverrides.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "getOverrides", $2bccbd73ae69aad8$var$_FeatureGates.client.getOverrides.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "clearAllOverrides", $2bccbd73ae69aad8$var$_FeatureGates.client.clearAllOverrides.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "isCurrentUser", $2bccbd73ae69aad8$var$_FeatureGates.client.isCurrentUser.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "onGateUpdated", $2bccbd73ae69aad8$var$_FeatureGates.client.onGateUpdated.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "onExperimentValueUpdated", $2bccbd73ae69aad8$var$_FeatureGates.client.onExperimentValueUpdated.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "onAnyUpdated", $2bccbd73ae69aad8$var$_FeatureGates.client.onAnyUpdated.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "updateUser", $2bccbd73ae69aad8$var$_FeatureGates.client.updateUser.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "updateUserWithProvider", $2bccbd73ae69aad8$var$_FeatureGates.client.updateUserWithProvider.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "updateUserWithValues", $2bccbd73ae69aad8$var$_FeatureGates.client.updateUserWithValues.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "getPackageVersion", $2bccbd73ae69aad8$var$_FeatureGates.client.getPackageVersion.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "getLayer", $2bccbd73ae69aad8$var$_FeatureGates.client.getLayer.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
(0, $5IxoE.default)($2bccbd73ae69aad8$var$FeatureGates, "getLayerValue", $2bccbd73ae69aad8$var$_FeatureGates.client.getLayerValue.bind($2bccbd73ae69aad8$var$_FeatureGates.client));
var $2bccbd73ae69aad8$var$boundFGJS = $2bccbd73ae69aad8$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $2bccbd73ae69aad8$var$FeatureGates;
    else {
        var $2bccbd73ae69aad8$var$_boundFGJS, $2bccbd73ae69aad8$var$_boundFGJS$getPackage;
        $2bccbd73ae69aad8$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $2bccbd73ae69aad8$var$boundVersion = (($2bccbd73ae69aad8$var$_boundFGJS = $2bccbd73ae69aad8$var$boundFGJS) === null || $2bccbd73ae69aad8$var$_boundFGJS === void 0 || ($2bccbd73ae69aad8$var$_boundFGJS$getPackage = $2bccbd73ae69aad8$var$_boundFGJS.getPackageVersion) === null || $2bccbd73ae69aad8$var$_boundFGJS$getPackage === void 0 ? void 0 : $2bccbd73ae69aad8$var$_boundFGJS$getPackage.call($2bccbd73ae69aad8$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($2bccbd73ae69aad8$var$boundVersion !== (0, $eydMo.CLIENT_VERSION)) {
            var $2bccbd73ae69aad8$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($2bccbd73ae69aad8$var$boundVersion, " when module version ").concat((0, $eydMo.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($2bccbd73ae69aad8$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $2bccbd73ae69aad8$export$2e2bcd8739ae039 = $2bccbd73ae69aad8$var$boundFGJS;

});
parcelRegister("1pngT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $106a2d748fe0954f$export$2e2bcd8739ae039; });
function $106a2d748fe0954f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("ap6hD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $79311cf6bd3a6ba5$export$2e2bcd8739ae039; });

var $id7Hp = parcelRequire("id7Hp");
function $79311cf6bd3a6ba5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $id7Hp.default)(o.key), o);
    }
}
function $79311cf6bd3a6ba5$export$2e2bcd8739ae039(e, r, t) {
    return r && $79311cf6bd3a6ba5$var$_defineProperties(e.prototype, r), t && $79311cf6bd3a6ba5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("id7Hp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d41f69c3d0173250$export$2e2bcd8739ae039; });

var $03egE = parcelRequire("03egE");

var $iuImK = parcelRequire("iuImK");
function $d41f69c3d0173250$export$2e2bcd8739ae039(t) {
    var i = (0, $iuImK.default)(t, "string");
    return "symbol" == (0, $03egE.default)(i) ? i : i + "";
}

});
parcelRegister("03egE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $009b592fe6969c8f$export$2e2bcd8739ae039; });
function $009b592fe6969c8f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $009b592fe6969c8f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $009b592fe6969c8f$export$2e2bcd8739ae039(o);
}

});

parcelRegister("iuImK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d76d717b0f5cfca1$export$2e2bcd8739ae039; });

var $03egE = parcelRequire("03egE");
function $d76d717b0f5cfca1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $03egE.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $03egE.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("5IxoE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $429af7ab33d639b5$export$2e2bcd8739ae039; });

var $id7Hp = parcelRequire("id7Hp");
function $429af7ab33d639b5$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $id7Hp.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("b6Usy", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $816c0cf1a59140d0$export$1f2bb630327ac4b6; });

var $e12aH = parcelRequire("e12aH");

var $3FMi9 = parcelRequire("3FMi9");

var $3YOJZ = parcelRequire("3YOJZ");

var $1pngT = parcelRequire("1pngT");

var $ap6hD = parcelRequire("ap6hD");

var $5IxoE = parcelRequire("5IxoE");

var $lY0K8 = parcelRequire("lY0K8");

var $apSbF = parcelRequire("apSbF");

var $1ZBiw = parcelRequire("1ZBiw");

var $aHqn9 = parcelRequire("aHqn9");

var $80oJ0 = parcelRequire("80oJ0");

var $bsnS2 = parcelRequire("bsnS2");

var $1xFVn = parcelRequire("1xFVn");

var $g2bRu = parcelRequire("g2bRu");

var $d8bqN = parcelRequire("d8bqN");

var $gJrsj = parcelRequire("gJrsj");

var $iF2Jb = parcelRequire("iF2Jb");

var $eydMo = parcelRequire("eydMo");
var $816c0cf1a59140d0$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $816c0cf1a59140d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $816c0cf1a59140d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $816c0cf1a59140d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5IxoE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $816c0cf1a59140d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $816c0cf1a59140d0$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $816c0cf1a59140d0$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $816c0cf1a59140d0$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $d8bqN.LOCAL_STORAGE_KEY) : _ref$localStorageKey;
        (0, $1pngT.default)(this, Client);
        (0, $5IxoE.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $5IxoE.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $5IxoE.default)(this, "initWithDefaults", false);
        (0, $5IxoE.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $5IxoE.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $5IxoE.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $5IxoE.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $5IxoE.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $5IxoE.default)(this, "subscriptions", new (0, $1ZBiw.default)());
        (0, $5IxoE.default)(this, "dataAdapter", new (0, $g2bRu.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $5IxoE.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = new (0, $d8bqN.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $ap6hD.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $iF2Jb.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $iF2Jb.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $iF2Jb.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $iF2Jb.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $eydMo.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $816c0cf1a59140d0$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $eydMo.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $gJrsj.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $iF2Jb.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $iF2Jb.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $iF2Jb.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $1xFVn.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $aHqn9.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $aHqn9.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $bsnS2.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $iF2Jb.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $iF2Jb.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $816c0cf1a59140d0$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $1xFVn.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $1xFVn.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $3FMi9.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $816c0cf1a59140d0$var$_objectSpread($816c0cf1a59140d0$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $3FMi9.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $iF2Jb.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $816c0cf1a59140d0$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $816c0cf1a59140d0$var$_objectSpread($816c0cf1a59140d0$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $816c0cf1a59140d0$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $gJrsj.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $e12aH.default)(newClientOptions, $816c0cf1a59140d0$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $iF2Jb.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $816c0cf1a59140d0$var$_objectSpread($816c0cf1a59140d0$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $apSbF.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $apSbF.StatsigClient)($816c0cf1a59140d0$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $iF2Jb.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $eydMo.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $80oJ0.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $80oJ0.Layer).fromLayer((0, $apSbF._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("e12aH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a342d7ec7da30607$export$2e2bcd8739ae039; });

var $hXKsc = parcelRequire("hXKsc");
function $a342d7ec7da30607$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $hXKsc.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("hXKsc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d13bfb1e3cc821ea$export$2e2bcd8739ae039; });
function $d13bfb1e3cc821ea$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("3FMi9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2acaa927508478ae$export$2e2bcd8739ae039; });

var $fH9MZ = parcelRequire("fH9MZ");

var $jY2NM = parcelRequire("jY2NM");

var $effWz = parcelRequire("effWz");

var $fdSz4 = parcelRequire("fdSz4");
function $2acaa927508478ae$export$2e2bcd8739ae039(r, e) {
    return (0, $fH9MZ.default)(r) || (0, $jY2NM.default)(r, e) || (0, $effWz.default)(r, e) || (0, $fdSz4.default)();
}

});
parcelRegister("fH9MZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b6d277134ae06310$export$2e2bcd8739ae039; });
function $b6d277134ae06310$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("jY2NM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e895cb4d969dc204$export$2e2bcd8739ae039; });
function $e895cb4d969dc204$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("effWz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a5eed5799354dc3a$export$2e2bcd8739ae039; });

var $9okTo = parcelRequire("9okTo");
function $a5eed5799354dc3a$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9okTo.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9okTo.default)(r, a) : void 0;
    }
}

});
parcelRegister("9okTo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d668fc5922c633d$export$2e2bcd8739ae039; });
function $6d668fc5922c633d$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("fdSz4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b152654dbf0228c4$export$2e2bcd8739ae039; });
function $b152654dbf0228c4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3YOJZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e5e55be77e2e235$export$2e2bcd8739ae039; });
function $2e5e55be77e2e235$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $2e5e55be77e2e235$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $2e5e55be77e2e235$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $2e5e55be77e2e235$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("lY0K8", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $ffdfc7260c9c6b0a$var$runtime = (parcelRequire("7l8rT"))();
module.exports = $ffdfc7260c9c6b0a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $ffdfc7260c9c6b0a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $ffdfc7260c9c6b0a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($ffdfc7260c9c6b0a$var$runtime);
}

});
parcelRegister("7l8rT", function(module, exports) {

var $gliML = parcelRequire("gliML");

var $cHXJb = parcelRequire("cHXJb");

var $4qkzi = parcelRequire("4qkzi");

var $31O1G = parcelRequire("31O1G");

var $S00YK = parcelRequire("S00YK");

var $kZJ4a = parcelRequire("kZJ4a");

var $bJFOr = parcelRequire("bJFOr");
function $55810c5899f8bcc6$var$_regeneratorRuntime() {
    "use strict";
    var r = $cHXJb(), e = r.m($55810c5899f8bcc6$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $bJFOr(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $55810c5899f8bcc6$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $gliML(r, e);
            },
            AsyncIterator: $S00YK,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $31O1G : $4qkzi)(a(r), e, t, o, u);
            },
            keys: $kZJ4a,
            values: $bJFOr
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $55810c5899f8bcc6$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gliML", function(module, exports) {
function $be5d2df13970b65e$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $be5d2df13970b65e$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cHXJb", function(module, exports) {

var $3HYrk = parcelRequire("3HYrk");
function $9407d4e6bd2c1509$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $3HYrk(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($3HYrk(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $3HYrk(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $3HYrk(u, "constructor", GeneratorFunctionPrototype), $3HYrk(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $3HYrk(GeneratorFunctionPrototype, o, "GeneratorFunction"), $3HYrk(u), $3HYrk(u, o, "Generator"), $3HYrk(u, n, function() {
        return this;
    }), $3HYrk(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $9407d4e6bd2c1509$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $9407d4e6bd2c1509$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3HYrk", function(module, exports) {
function $2b344550f36a6d93$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $2b344550f36a6d93$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $2b344550f36a6d93$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2b344550f36a6d93$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $2b344550f36a6d93$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4qkzi", function(module, exports) {

var $31O1G = parcelRequire("31O1G");
function $33898b918d675261$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $31O1G(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $33898b918d675261$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("31O1G", function(module, exports) {

var $cHXJb = parcelRequire("cHXJb");

var $S00YK = parcelRequire("S00YK");
function $2348453862f9fb48$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $S00YK($cHXJb().w(r, e, t, o), n || Promise);
}
module.exports = $2348453862f9fb48$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("S00YK", function(module, exports) {

var $gliML = parcelRequire("gliML");

var $3HYrk = parcelRequire("3HYrk");
function $0a250e327df8063d$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $gliML ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($3HYrk($0a250e327df8063d$var$AsyncIterator.prototype), $3HYrk($0a250e327df8063d$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $3HYrk(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $0a250e327df8063d$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kZJ4a", function(module, exports) {
function $f48c765c97f88588$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $f48c765c97f88588$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bJFOr", function(module, exports) {

var $h3Kw7 = parcelRequire("h3Kw7");
var $88b454c2d1ecc4c3$var$_typeof = $h3Kw7.default;
function $88b454c2d1ecc4c3$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($88b454c2d1ecc4c3$var$_typeof(e) + " is not iterable");
}
module.exports = $88b454c2d1ecc4c3$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("h3Kw7", function(module, exports) {
function $c6b6ccd0d63d4b1c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $c6b6ccd0d63d4b1c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c6b6ccd0d63d4b1c$var$_typeof(o);
}
module.exports = $c6b6ccd0d63d4b1c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("apSbF", function(module, exports) {
"use strict";
var $795645a34ea9052d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $795645a34ea9052d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $795645a34ea9052d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;

var $cfvnG = parcelRequire("cfvnG");
module.exports.StatsigClient = $cfvnG.default;

$795645a34ea9052d$var$__exportStar((parcelRequire("ctK4w")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    StatsigClient: $cfvnG.default
});
module.exports.default = __STATSIG__;

});
parcelRegister("cfvnG", function(module, exports) {
"use strict";
var $8eaf3a6027816b89$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ctK4w = parcelRequire("ctK4w");

var $gSHkR = parcelRequire("gSHkR");

var $dUK6I = parcelRequire("dUK6I");

var $d1lcm = parcelRequire("d1lcm");

var $gTKA8 = parcelRequire("gTKA8");
class $8eaf3a6027816b89$var$StatsigClient extends $ctK4w.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $ctK4w._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $8eaf3a6027816b89$var$StatsigClient) return instance;
        $ctK4w.Log.warn((0, $ctK4w._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $8eaf3a6027816b89$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $ctK4w.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $dUK6I.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $gTKA8.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($ctK4w.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($ctK4w.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($ctK4w.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($ctK4w.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($ctK4w.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $gSHkR.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $ctK4w.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $8eaf3a6027816b89$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $ctK4w.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $ctK4w.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $8eaf3a6027816b89$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $ctK4w.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $ctK4w.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $ctK4w.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $ctK4w.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($ctK4w.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $ctK4w.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $ctK4w.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $ctK4w.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $ctK4w.StatsigSession.get(this._sdkKey),
            stableID: $ctK4w.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $8eaf3a6027816b89$var$__awaiter(this, void 0, void 0, function*() {
            if (!$ctK4w.Storage.isReady()) yield $ctK4w.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $ctK4w.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $ctK4w._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $ctK4w.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $ctK4w._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $ctK4w._createGateExposure)(this._user, result), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $ctK4w._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $ctK4w._createConfigExposure)(this._user, result), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $ctK4w._makeExperiment)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getExperimentOverride) === null || _b === void 0 ? void 0 : _b.call(_a, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $ctK4w._createConfigExposure)(this._user, result), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $ctK4w._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $ctK4w._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $ctK4w._createLayerParameterExposure)(this._user, result, param), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        return {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $d1lcm._makeParamStoreGetter)(this, configuration, options)
        };
    }
}
module.exports.default = $8eaf3a6027816b89$var$StatsigClient;

});
parcelRegister("ctK4w", function(module, exports) {
"use strict";
var $915bee670b0c6520$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $915bee670b0c6520$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $915bee670b0c6520$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;


Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("4woX0")).Diagnostics;
    }
});

var $cyufg = parcelRequire("cyufg");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $cyufg.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("kjeZa")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("ew5hk")).Storage;
    }
});

$915bee670b0c6520$var$__exportStar((parcelRequire("eTY8R")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("1YEnC")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("fVB2B")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("82ska")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("4woX0")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("bHObL")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("e8wVm")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("hz8vk")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("jrECm")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("3fzC1")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("bJGRz")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("kjeZa")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("cPrw2")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("b9JnD")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("dobXx")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("eVoTP")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("iJsCh")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("cq1SB")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("97sCK")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("a7C7B")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("fWuLw")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("9LWVG")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("lJFpJ")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("iIqZJ")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("fvfv0")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("ogwOt")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("8DK2A")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("67mpC")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("7m7ly")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("cfXlx")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("bmDiA")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("ew5hk")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("2LyGs")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("lqtus")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("4ijEb")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("XT3YN")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("6cH3Q")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("kyGUG")), module.exports);

$915bee670b0c6520$var$__exportStar((parcelRequire("38RF3")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    Log: (parcelRequire("kjeZa")).Log,
    SDK_VERSION: (parcelRequire("ogwOt")).SDK_VERSION
});

});
parcelRegister("eTY8R", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $ad94daadb69b63cb$var$_a, $ad94daadb69b63cb$var$_b, $ad94daadb69b63cb$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $kjeZa = parcelRequire("kjeZa");
const $ad94daadb69b63cb$var$_getStatsigGlobal = ()=>{
    return __STATSIG__ ? __STATSIG__ : $ad94daadb69b63cb$var$statsigGlobal;
};
module.exports._getStatsigGlobal = $ad94daadb69b63cb$var$_getStatsigGlobal;
const $ad94daadb69b63cb$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $ad94daadb69b63cb$var$_getStatsigGlobalFlag;
const $ad94daadb69b63cb$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $kjeZa.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $ad94daadb69b63cb$var$_getInstance;
const $ad94daadb69b63cb$var$GLOBAL_KEY = '__STATSIG__';
const $ad94daadb69b63cb$var$_window = typeof window !== 'undefined' ? window : {};
const $ad94daadb69b63cb$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $ad94daadb69b63cb$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $ad94daadb69b63cb$var$statsigGlobal = ($ad94daadb69b63cb$var$_c = ($ad94daadb69b63cb$var$_b = ($ad94daadb69b63cb$var$_a = $ad94daadb69b63cb$var$_window[$ad94daadb69b63cb$var$GLOBAL_KEY]) !== null && $ad94daadb69b63cb$var$_a !== void 0 ? $ad94daadb69b63cb$var$_a : $ad94daadb69b63cb$var$_global[$ad94daadb69b63cb$var$GLOBAL_KEY]) !== null && $ad94daadb69b63cb$var$_b !== void 0 ? $ad94daadb69b63cb$var$_b : $ad94daadb69b63cb$var$_globalThis[$ad94daadb69b63cb$var$GLOBAL_KEY]) !== null && $ad94daadb69b63cb$var$_c !== void 0 ? $ad94daadb69b63cb$var$_c : {
    instance: module.exports._getInstance
};
$ad94daadb69b63cb$var$_window[$ad94daadb69b63cb$var$GLOBAL_KEY] = $ad94daadb69b63cb$var$statsigGlobal;
$ad94daadb69b63cb$var$_global[$ad94daadb69b63cb$var$GLOBAL_KEY] = $ad94daadb69b63cb$var$statsigGlobal;
$ad94daadb69b63cb$var$_globalThis[$ad94daadb69b63cb$var$GLOBAL_KEY] = $ad94daadb69b63cb$var$statsigGlobal;

});
parcelRegister("kjeZa", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $ec9134ce604d6e4b$var$DEBUG = ' DEBUG ';
const $ec9134ce604d6e4b$var$_INFO = '  INFO ';
const $ec9134ce604d6e4b$var$_WARN = '  WARN ';
const $ec9134ce604d6e4b$var$ERROR = ' ERROR ';
function $ec9134ce604d6e4b$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $ec9134ce604d6e4b$var$Log {
    static info(...args) {
        if ($ec9134ce604d6e4b$var$Log.level >= module.exports.LogLevel.Info) console.info($ec9134ce604d6e4b$var$_INFO, ...$ec9134ce604d6e4b$var$addTag(args));
    }
    static debug(...args) {
        if ($ec9134ce604d6e4b$var$Log.level >= module.exports.LogLevel.Debug) console.debug($ec9134ce604d6e4b$var$DEBUG, ...$ec9134ce604d6e4b$var$addTag(args));
    }
    static warn(...args) {
        if ($ec9134ce604d6e4b$var$Log.level >= module.exports.LogLevel.Warn) console.warn($ec9134ce604d6e4b$var$_WARN, ...$ec9134ce604d6e4b$var$addTag(args));
    }
    static error(...args) {
        if ($ec9134ce604d6e4b$var$Log.level >= module.exports.LogLevel.Error) console.error($ec9134ce604d6e4b$var$ERROR, ...$ec9134ce604d6e4b$var$addTag(args));
    }
}
module.exports.Log = $ec9134ce604d6e4b$var$Log;
$ec9134ce604d6e4b$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("4woX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $34ad81484cb4140a$var$MARKER_MAP = new Map();
const $34ad81484cb4140a$var$ACT_START = 'start';
const $34ad81484cb4140a$var$ACT_END = 'end';
const $34ad81484cb4140a$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $34ad81484cb4140a$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $34ad81484cb4140a$var$_addMarker(sdkKey, $34ad81484cb4140a$var$_createMarker({}, $34ad81484cb4140a$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $34ad81484cb4140a$var$_addMarker(sdkKey, $34ad81484cb4140a$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $34ad81484cb4140a$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $34ad81484cb4140a$var$_addMarker(sdkKey, $34ad81484cb4140a$var$_createMarker(data, $34ad81484cb4140a$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $34ad81484cb4140a$var$_addMarker(sdkKey, $34ad81484cb4140a$var$_createMarker(data, $34ad81484cb4140a$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $34ad81484cb4140a$var$_addMarker(sdkKey, $34ad81484cb4140a$var$_createMarker({}, $34ad81484cb4140a$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $34ad81484cb4140a$var$_addMarker(sdkKey, $34ad81484cb4140a$var$_createMarker(data, $34ad81484cb4140a$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $34ad81484cb4140a$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $34ad81484cb4140a$var$_safeGetField(e, 'code'),
            name: $34ad81484cb4140a$var$_safeGetField(e, 'name'),
            message: $34ad81484cb4140a$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $34ad81484cb4140a$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $34ad81484cb4140a$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $34ad81484cb4140a$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $34ad81484cb4140a$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $34ad81484cb4140a$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $34ad81484cb4140a$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $34ad81484cb4140a$var$MARKER_MAP.set(sdkKey, markers);
}
function $34ad81484cb4140a$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("cyufg", function(module, exports) {
"use strict";
var $92401f1449c7d31e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $1YEnC = parcelRequire("1YEnC");

var $3fzC1 = parcelRequire("3fzC1");

var $kjeZa = parcelRequire("kjeZa");

var $b9JnD = parcelRequire("b9JnD");

var $cq1SB = parcelRequire("cq1SB");

var $fvfv0 = parcelRequire("fvfv0");

var $ew5hk = parcelRequire("ew5hk");

var $4ijEb = parcelRequire("4ijEb");

var $6cH3Q = parcelRequire("6cH3Q");
const $92401f1449c7d31e$var$DEFAULT_QUEUE_SIZE = 100;
const $92401f1449c7d31e$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $92401f1449c7d31e$var$MAX_DEDUPER_KEYS = 1000;
const $92401f1449c7d31e$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $92401f1449c7d31e$var$MAX_FAILED_LOGS = 500;
const $92401f1449c7d31e$var$QUICK_FLUSH_WINDOW_MS = 200;
const $92401f1449c7d31e$var$EVENT_LOGGER_MAP = {};
const $92401f1449c7d31e$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $92401f1449c7d31e$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $92401f1449c7d31e$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $92401f1449c7d31e$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($92401f1449c7d31e$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._isLoggingDisabled = (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true;
        this._maxQueueSize = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _a !== void 0 ? _a : $92401f1449c7d31e$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $4ijEb.UrlConfiguration($b9JnD.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLoggingDisabled(isDisabled) {
        this._isLoggingDisabled = isDisabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $92401f1449c7d31e$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        if ((0, $cq1SB._isServerEnv)()) return; // do not run in server environments
        $92401f1449c7d31e$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        (0, $6cH3Q._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $92401f1449c7d31e$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $92401f1449c7d31e$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($92401f1449c7d31e$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $92401f1449c7d31e$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $92401f1449c7d31e$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $92401f1449c7d31e$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $92401f1449c7d31e$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$92401f1449c7d31e$var$EventLogger._safeFlushAndForget(this._sdkKey), $92401f1449c7d31e$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        if ((0, $cq1SB._isServerEnv)()) return false; // do not run in server environments
        if (!(0, $fvfv0._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $1YEnC._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $92401f1449c7d31e$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $92401f1449c7d31e$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $92401f1449c7d31e$var$__awaiter(this, void 0, void 0, function*() {
            if (this._isLoggingDisabled) {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $6cH3Q._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? yield this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $kjeZa.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $kjeZa.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $92401f1449c7d31e$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return $92401f1449c7d31e$var$__awaiter(this, void 0, void 0, function*() {
            return {
                success: yield this._network.beacon(this._getRequestData(events))
            };
        });
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$b9JnD.NetworkParam.EventCount]: String(events.length)
            }
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $92401f1449c7d31e$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $ew5hk._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $kjeZa.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$92401f1449c7d31e$var$__awaiter(this, void 0, void 0, function*() {
                if (!$ew5hk.Storage.isReady()) yield $ew5hk.Storage.isReadyResolver();
                const events = (0, $ew5hk._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $92401f1449c7d31e$var$RetryFailedLogsTrigger.Startup) $ew5hk.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $92401f1449c7d31e$var$RetryFailedLogsTrigger.GainedFocus) $ew5hk.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $kjeZa.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $3fzC1._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $kjeZa.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $cq1SB._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $92401f1449c7d31e$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $92401f1449c7d31e$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $92401f1449c7d31e$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $92401f1449c7d31e$var$EventLogger;

});
parcelRegister("1YEnC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $3fzC1 = parcelRequire("3fzC1");
function $170ab7aa5798a263$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $3fzC1._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $170ab7aa5798a263$var$_getUserStorageKey;
function $170ab7aa5798a263$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $170ab7aa5798a263$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $3fzC1._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $170ab7aa5798a263$var$_getStorageKey;

});
parcelRegister("3fzC1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $lqtus = parcelRequire("lqtus");
const $25de65a5199da357$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $25de65a5199da357$var$_DJB2;
const $25de65a5199da357$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $25de65a5199da357$var$_DJB2Object;
const $25de65a5199da357$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $lqtus._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $25de65a5199da357$var$_getSortedObject;

});
parcelRegister("lqtus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $04067f980fc32560$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $04067f980fc32560$var$_typeOf;
function $04067f980fc32560$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $04067f980fc32560$var$_isTypeMatch;

});



parcelRegister("b9JnD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("cq1SB", function(module, exports) {

var $7t0tI = parcelRequire("7t0tI");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $90a95f056c61a051$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $90a95f056c61a051$var$_getWindowSafe;
const $90a95f056c61a051$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $90a95f056c61a051$var$_getDocumentSafe;
const $90a95f056c61a051$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $7t0tI !== 'undefined' && $7t0tI.versions != null && $7t0tI.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $90a95f056c61a051$var$_isServerEnv;
const $90a95f056c61a051$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $90a95f056c61a051$var$_addWindowEventListenerSafe;
const $90a95f056c61a051$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $90a95f056c61a051$var$_addDocumentEventListenerSafe;
const $90a95f056c61a051$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $90a95f056c61a051$var$_getCurrentPageUrlSafe;

});
parcelRegister("7t0tI", function(module, exports) {
// shim for using process in browser
var $56fb9cd3fca0fac9$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $56fb9cd3fca0fac9$var$cachedSetTimeout;
var $56fb9cd3fca0fac9$var$cachedClearTimeout;
function $56fb9cd3fca0fac9$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $56fb9cd3fca0fac9$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $56fb9cd3fca0fac9$var$cachedSetTimeout = setTimeout;
        else $56fb9cd3fca0fac9$var$cachedSetTimeout = $56fb9cd3fca0fac9$var$defaultSetTimout;
    } catch (e) {
        $56fb9cd3fca0fac9$var$cachedSetTimeout = $56fb9cd3fca0fac9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $56fb9cd3fca0fac9$var$cachedClearTimeout = clearTimeout;
        else $56fb9cd3fca0fac9$var$cachedClearTimeout = $56fb9cd3fca0fac9$var$defaultClearTimeout;
    } catch (e) {
        $56fb9cd3fca0fac9$var$cachedClearTimeout = $56fb9cd3fca0fac9$var$defaultClearTimeout;
    }
})();
function $56fb9cd3fca0fac9$var$runTimeout(fun) {
    if ($56fb9cd3fca0fac9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($56fb9cd3fca0fac9$var$cachedSetTimeout === $56fb9cd3fca0fac9$var$defaultSetTimout || !$56fb9cd3fca0fac9$var$cachedSetTimeout) && setTimeout) {
        $56fb9cd3fca0fac9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $56fb9cd3fca0fac9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $56fb9cd3fca0fac9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $56fb9cd3fca0fac9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $56fb9cd3fca0fac9$var$runClearTimeout(marker) {
    if ($56fb9cd3fca0fac9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($56fb9cd3fca0fac9$var$cachedClearTimeout === $56fb9cd3fca0fac9$var$defaultClearTimeout || !$56fb9cd3fca0fac9$var$cachedClearTimeout) && clearTimeout) {
        $56fb9cd3fca0fac9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $56fb9cd3fca0fac9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $56fb9cd3fca0fac9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $56fb9cd3fca0fac9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $56fb9cd3fca0fac9$var$queue = [];
var $56fb9cd3fca0fac9$var$draining = false;
var $56fb9cd3fca0fac9$var$currentQueue;
var $56fb9cd3fca0fac9$var$queueIndex = -1;
function $56fb9cd3fca0fac9$var$cleanUpNextTick() {
    if (!$56fb9cd3fca0fac9$var$draining || !$56fb9cd3fca0fac9$var$currentQueue) return;
    $56fb9cd3fca0fac9$var$draining = false;
    if ($56fb9cd3fca0fac9$var$currentQueue.length) $56fb9cd3fca0fac9$var$queue = $56fb9cd3fca0fac9$var$currentQueue.concat($56fb9cd3fca0fac9$var$queue);
    else $56fb9cd3fca0fac9$var$queueIndex = -1;
    if ($56fb9cd3fca0fac9$var$queue.length) $56fb9cd3fca0fac9$var$drainQueue();
}
function $56fb9cd3fca0fac9$var$drainQueue() {
    if ($56fb9cd3fca0fac9$var$draining) return;
    var timeout = $56fb9cd3fca0fac9$var$runTimeout($56fb9cd3fca0fac9$var$cleanUpNextTick);
    $56fb9cd3fca0fac9$var$draining = true;
    var len = $56fb9cd3fca0fac9$var$queue.length;
    while(len){
        $56fb9cd3fca0fac9$var$currentQueue = $56fb9cd3fca0fac9$var$queue;
        $56fb9cd3fca0fac9$var$queue = [];
        while(++$56fb9cd3fca0fac9$var$queueIndex < len)if ($56fb9cd3fca0fac9$var$currentQueue) $56fb9cd3fca0fac9$var$currentQueue[$56fb9cd3fca0fac9$var$queueIndex].run();
        $56fb9cd3fca0fac9$var$queueIndex = -1;
        len = $56fb9cd3fca0fac9$var$queue.length;
    }
    $56fb9cd3fca0fac9$var$currentQueue = null;
    $56fb9cd3fca0fac9$var$draining = false;
    $56fb9cd3fca0fac9$var$runClearTimeout(timeout);
}
$56fb9cd3fca0fac9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $56fb9cd3fca0fac9$var$queue.push(new $56fb9cd3fca0fac9$var$Item(fun, args));
    if ($56fb9cd3fca0fac9$var$queue.length === 1 && !$56fb9cd3fca0fac9$var$draining) $56fb9cd3fca0fac9$var$runTimeout($56fb9cd3fca0fac9$var$drainQueue);
};
// v8 likes predictible objects
function $56fb9cd3fca0fac9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$56fb9cd3fca0fac9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$56fb9cd3fca0fac9$var$process.title = 'browser';
$56fb9cd3fca0fac9$var$process.browser = true;
$56fb9cd3fca0fac9$var$process.env = {};
$56fb9cd3fca0fac9$var$process.argv = [];
$56fb9cd3fca0fac9$var$process.version = ''; // empty string to avoid regexp issues
$56fb9cd3fca0fac9$var$process.versions = {};
function $56fb9cd3fca0fac9$var$noop() {}
$56fb9cd3fca0fac9$var$process.on = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.addListener = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.once = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.off = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.removeListener = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.removeAllListeners = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.emit = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.prependListener = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.prependOnceListener = $56fb9cd3fca0fac9$var$noop;
$56fb9cd3fca0fac9$var$process.listeners = function(name) {
    return [];
};
$56fb9cd3fca0fac9$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$56fb9cd3fca0fac9$var$process.cwd = function() {
    return '/';
};
$56fb9cd3fca0fac9$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$56fb9cd3fca0fac9$var$process.umask = function() {
    return 0;
};

});


parcelRegister("fvfv0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $b495c61307beec00$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $b495c61307beec00$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $b495c61307beec00$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $b495c61307beec00$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $b495c61307beec00$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $b495c61307beec00$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $b495c61307beec00$var$GATE_EXPOSURE_NAME || eventName === $b495c61307beec00$var$CONFIG_EXPOSURE_NAME || eventName === $b495c61307beec00$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $b495c61307beec00$var$_isExposureEvent;
const $b495c61307beec00$var$_createGateExposure = (user, gate)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $b495c61307beec00$var$_createExposure($b495c61307beec00$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, (_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : []);
};
module.exports._createGateExposure = $b495c61307beec00$var$_createGateExposure;
const $b495c61307beec00$var$_createConfigExposure = (user, config)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $b495c61307beec00$var$_createExposure($b495c61307beec00$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, (_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : []);
};
module.exports._createConfigExposure = $b495c61307beec00$var$_createConfigExposure;
const $b495c61307beec00$var$_createLayerParameterExposure = (user, layer, parameterName)=>{
    var _a, _b, _c, _d;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = evaluation.secondary_exposures;
    }
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $b495c61307beec00$var$_createExposure($b495c61307beec00$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, secondaryExposures);
};
module.exports._createLayerParameterExposure = $b495c61307beec00$var$_createLayerParameterExposure;
const $b495c61307beec00$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("ew5hk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $kjeZa = parcelRequire("kjeZa");

var $cq1SB = parcelRequire("cq1SB");
const $a9182610592ce83a$var$inMemoryStore = {};
const $a9182610592ce83a$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$a9182610592ce83a$var$inMemoryStore[key] ? $a9182610592ce83a$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $a9182610592ce83a$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $a9182610592ce83a$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($a9182610592ce83a$var$inMemoryStore)
};
let $a9182610592ce83a$var$_localStorageProvider = null;
try {
    const win = (0, $cq1SB._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $a9182610592ce83a$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $kjeZa.Log.warn('Failed to setup localStorageProvider.');
}
let $a9182610592ce83a$var$_main = $a9182610592ce83a$var$_localStorageProvider !== null && $a9182610592ce83a$var$_localStorageProvider !== void 0 ? $a9182610592ce83a$var$_localStorageProvider : $a9182610592ce83a$var$_inMemoryProvider;
let $a9182610592ce83a$var$_current = $a9182610592ce83a$var$_main;
function $a9182610592ce83a$var$_inMemoryBreaker(get) {
    try {
        return get();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($a9182610592ce83a$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$a9182610592ce83a$var$_current.isReady(),
    isReadyResolver: ()=>$a9182610592ce83a$var$_current.isReadyResolver(),
    getProviderName: ()=>$a9182610592ce83a$var$_current.getProviderName(),
    getItem: (key)=>$a9182610592ce83a$var$_inMemoryBreaker(()=>$a9182610592ce83a$var$_current.getItem(key)),
    setItem: (key, value)=>$a9182610592ce83a$var$_current.setItem(key, value),
    removeItem: (key)=>$a9182610592ce83a$var$_current.removeItem(key),
    getAllKeys: ()=>$a9182610592ce83a$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $a9182610592ce83a$var$_main = newProvider;
        $a9182610592ce83a$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $a9182610592ce83a$var$_current = $a9182610592ce83a$var$_inMemoryProvider;
        else $a9182610592ce83a$var$_current = $a9182610592ce83a$var$_main;
    }
};
function $a9182610592ce83a$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $a9182610592ce83a$var$_getObjectFromStorage;
function $a9182610592ce83a$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $a9182610592ce83a$var$_setObjectInStorage;

});

parcelRegister("4ijEb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $b9JnD = parcelRequire("b9JnD");
const $3208155de8f26b01$var$ENDPOINT_DNS_KEY_MAP = {
    [$b9JnD.Endpoint._initialize]: 'i',
    [$b9JnD.Endpoint._rgstr]: 'e',
    [$b9JnD.Endpoint._download_config_specs]: 'd'
};
class $3208155de8f26b01$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $3208155de8f26b01$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $b9JnD.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
}
module.exports.UrlConfiguration = $3208155de8f26b01$var$UrlConfiguration;

});

parcelRegister("6cH3Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $cq1SB = parcelRequire("cq1SB");
const $48454416e7c0f0c7$var$FOREGROUND = 'foreground';
const $48454416e7c0f0c7$var$BACKGROUND = 'background';
const $48454416e7c0f0c7$var$LISTENERS = [];
let $48454416e7c0f0c7$var$current = $48454416e7c0f0c7$var$FOREGROUND;
let $48454416e7c0f0c7$var$isUnloading = false;
const $48454416e7c0f0c7$var$_isCurrentlyVisible = ()=>{
    return $48454416e7c0f0c7$var$current === $48454416e7c0f0c7$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $48454416e7c0f0c7$var$_isCurrentlyVisible;
const $48454416e7c0f0c7$var$_isUnloading = ()=>$48454416e7c0f0c7$var$isUnloading;
module.exports._isUnloading = $48454416e7c0f0c7$var$_isUnloading;
const $48454416e7c0f0c7$var$_subscribeToVisiblityChanged = (listener)=>{
    $48454416e7c0f0c7$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $48454416e7c0f0c7$var$_subscribeToVisiblityChanged;
const $48454416e7c0f0c7$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $48454416e7c0f0c7$var$current) return;
    $48454416e7c0f0c7$var$current = visibility;
    $48454416e7c0f0c7$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $48454416e7c0f0c7$var$_notifyVisibilityChanged;
(0, $cq1SB._addWindowEventListenerSafe)('focus', ()=>{
    $48454416e7c0f0c7$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($48454416e7c0f0c7$var$FOREGROUND);
});
(0, $cq1SB._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($48454416e7c0f0c7$var$BACKGROUND));
(0, $cq1SB._addWindowEventListenerSafe)('beforeunload', ()=>{
    $48454416e7c0f0c7$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($48454416e7c0f0c7$var$BACKGROUND);
});
(0, $cq1SB._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $48454416e7c0f0c7$var$FOREGROUND : $48454416e7c0f0c7$var$BACKGROUND);
});

});


parcelRegister("ogwOt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.12.0';
let $048f102bad5003b7$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$048f102bad5003b7$var$metadata,
    add: (additions)=>{
        $048f102bad5003b7$var$metadata = Object.assign(Object.assign({}, $048f102bad5003b7$var$metadata), additions);
    }
};

});

parcelRegister("fVB2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("82ska", function(module, exports) {
"use strict";
var $5da47b3d90008f4f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $kjeZa = parcelRequire("kjeZa");

var $fWuLw = parcelRequire("fWuLw");

var $bmDiA = parcelRequire("bmDiA");

var $ew5hk = parcelRequire("ew5hk");

var $2LyGs = parcelRequire("2LyGs");
const $5da47b3d90008f4f$var$CACHE_LIMIT = 10;
class $5da47b3d90008f4f$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $5da47b3d90008f4f$var$InMemoryCache();
    }
    attach(sdkKey, options) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $bmDiA._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $bmDiA._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $5da47b3d90008f4f$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $5da47b3d90008f4f$var$__awaiter(this, void 0, void 0, function*() {
            if (!$ew5hk.Storage.isReady()) yield $ew5hk.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $kjeZa.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $5da47b3d90008f4f$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $bmDiA._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $5da47b3d90008f4f$var$__awaiter(this, void 0, void 0, function*() {
            let cachedData = null;
            if (cachedResult && this._isCachedResultValidFor204(cachedResult, user)) cachedData = cachedResult.data;
            const latest = yield this._fetchFromNetwork(cachedData, user, options);
            if (!latest) {
                $kjeZa.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $2LyGs._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $fWuLw.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $5da47b3d90008f4f$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $5da47b3d90008f4f$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $kjeZa.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $ew5hk.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($ew5hk.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $2LyGs._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $ew5hk.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $ew5hk._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $5da47b3d90008f4f$var$_getEvictableKey(lastModifiedTimeMap, $5da47b3d90008f4f$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $ew5hk.Storage.removeItem(evictable);
        }
        (0, $ew5hk._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $5da47b3d90008f4f$var$DataAdapterCore;
function $5da47b3d90008f4f$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $bmDiA._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $5da47b3d90008f4f$var$_makeDataAdapterResult;
class $5da47b3d90008f4f$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $kjeZa.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $5da47b3d90008f4f$var$_getEvictableKey(this._data, $5da47b3d90008f4f$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $5da47b3d90008f4f$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("fWuLw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $1YEnC = parcelRequire("1YEnC");

var $kjeZa = parcelRequire("kjeZa");

var $ew5hk = parcelRequire("ew5hk");

var $XT3YN = parcelRequire("XT3YN");
const $b9b4232e40c4c86c$var$PROMISE_MAP = {};
module.exports.StableID = {
    get: (sdkKey)=>{
        if ($b9b4232e40c4c86c$var$PROMISE_MAP[sdkKey] == null) {
            let stableID = $b9b4232e40c4c86c$var$_loadFromStorage(sdkKey);
            if (stableID == null) {
                stableID = (0, $XT3YN.getUUID)();
                $b9b4232e40c4c86c$var$_persistToStorage(stableID, sdkKey);
            }
            $b9b4232e40c4c86c$var$PROMISE_MAP[sdkKey] = stableID;
        }
        return $b9b4232e40c4c86c$var$PROMISE_MAP[sdkKey];
    },
    setOverride: (override, sdkKey)=>{
        $b9b4232e40c4c86c$var$PROMISE_MAP[sdkKey] = override;
        $b9b4232e40c4c86c$var$_persistToStorage(override, sdkKey);
    }
};
function $b9b4232e40c4c86c$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $1YEnC._getStorageKey)(sdkKey)}`;
}
function $b9b4232e40c4c86c$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $b9b4232e40c4c86c$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $ew5hk._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $kjeZa.Log.warn('Failed to save StableID');
    }
}
function $b9b4232e40c4c86c$var$_loadFromStorage(sdkKey) {
    const storageKey = $b9b4232e40c4c86c$var$_getStableIDStorageKey(sdkKey);
    return (0, $ew5hk._getObjectFromStorage)(storageKey);
}

});
parcelRegister("XT3YN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $0b4039346585d30e$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $0b4039346585d30e$var$getUUID;

});


parcelRegister("bmDiA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $3fzC1 = parcelRequire("3fzC1");

var $kjeZa = parcelRequire("kjeZa");
function $84603bafa4c11b8c$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $kjeZa.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $84603bafa4c11b8c$var$_normalizeUser;
function $84603bafa4c11b8c$var$_getFullUserHash(user) {
    return user ? (0, $3fzC1._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $84603bafa4c11b8c$var$_getFullUserHash;

});

parcelRegister("2LyGs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $kjeZa = parcelRequire("kjeZa");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $203ae00ac3dfbf23$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $kjeZa.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $203ae00ac3dfbf23$var$_typedJsonParse;

});


parcelRegister("bHObL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("e8wVm", function(module, exports) {
"use strict";
var $a4ab5a16536ddb9d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $kjeZa = parcelRequire("kjeZa");

var $97sCK = parcelRequire("97sCK");

var $ogwOt = parcelRequire("ogwOt");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $a4ab5a16536ddb9d$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $a4ab5a16536ddb9d$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $a4ab5a16536ddb9d$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $a4ab5a16536ddb9d$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $kjeZa.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$a4ab5a16536ddb9d$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($a4ab5a16536ddb9d$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $a4ab5a16536ddb9d$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $97sCK.SDKType._get(this._sdkKey);
                    const statsigMetadata = $ogwOt.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $a4ab5a16536ddb9d$var$_getDescription(unwrapped);
                    const body = JSON.stringify(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: body
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $a4ab5a16536ddb9d$var$ErrorBoundary;
function $a4ab5a16536ddb9d$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $a4ab5a16536ddb9d$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $a4ab5a16536ddb9d$var$UNKNOWN_ERROR;
    }
}
function $a4ab5a16536ddb9d$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}

});
parcelRegister("97sCK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $6a3af8a608f24c81$var$SDK_CLIENT = {};
let $6a3af8a608f24c81$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $6a3af8a608f24c81$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($6a3af8a608f24c81$var$suffix !== null && $6a3af8a608f24c81$var$suffix !== void 0 ? $6a3af8a608f24c81$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $6a3af8a608f24c81$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$6a3af8a608f24c81$var$suffix || $6a3af8a608f24c81$var$suffix === '-react') $6a3af8a608f24c81$var$suffix = '-' + binding;
    }
};

});


parcelRegister("hz8vk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jrECm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bJGRz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cPrw2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _layer: 'l',
    _paramStore: 'p'
};
const $956f97879202f1cb$var$EXIST_KEYS = new Set([]);
const $956f97879202f1cb$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $956f97879202f1cb$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($956f97879202f1cb$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($956f97879202f1cb$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $956f97879202f1cb$var$createMemoKey;

});

parcelRegister("dobXx", function(module, exports) {
"use strict";
var $9bf6cb228fe6c4b9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $eTY8R = parcelRequire("eTY8R");

var $eTY8R = parcelRequire("eTY8R");

var $4woX0 = parcelRequire("4woX0");

var $kjeZa = parcelRequire("kjeZa");

var $b9JnD = parcelRequire("b9JnD");

var $iouRT = parcelRequire("iouRT");

var $97sCK = parcelRequire("97sCK");

var $cq1SB = parcelRequire("cq1SB");

var $a7C7B = parcelRequire("a7C7B");

var $fWuLw = parcelRequire("fWuLw");

var $lJFpJ = parcelRequire("lJFpJ");

var $ogwOt = parcelRequire("ogwOt");

var $6cH3Q = parcelRequire("6cH3Q");
const $9bf6cb228fe6c4b9$var$DEFAULT_TIMEOUT_MS = 10000;
const $9bf6cb228fe6c4b9$var$BACKOFF_BASE_MS = 500;
const $9bf6cb228fe6c4b9$var$BACKOFF_MAX_MS = 30000;
const $9bf6cb228fe6c4b9$var$RATE_LIMIT_WINDOW_MS = 1000;
const $9bf6cb228fe6c4b9$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $9bf6cb228fe6c4b9$var$LEAK_RATE = $9bf6cb228fe6c4b9$var$RATE_LIMIT_MAX_REQ_COUNT / $9bf6cb228fe6c4b9$var$RATE_LIMIT_WINDOW_MS;
const $9bf6cb228fe6c4b9$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $9bf6cb228fe6c4b9$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $9bf6cb228fe6c4b9$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $iouRT.NetworkFallbackResolver(this._options);
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        return $9bf6cb228fe6c4b9$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9bf6cb228fe6c4b9$var$_ensureValidSdkKey(args)) return false;
            const argsInternal = this._getInternalRequestArgs('POST', args);
            const body = yield this._getPopulatedBody(argsInternal, args.data);
            const url = yield this._getPopulatedURL(argsInternal);
            const nav = navigator;
            return nav.sendBeacon.bind(nav)(url, body);
        });
    }
    post(args) {
        return $9bf6cb228fe6c4b9$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            argsInternal.body = yield this._getPopulatedBody(argsInternal, args.data);
            if (args.isStatsigEncodable) argsInternal.body = this._attemptToEncodeString(argsInternal, argsInternal.body);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $9bf6cb228fe6c4b9$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9bf6cb228fe6c4b9$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $kjeZa.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = yield this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $6cH3Q._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $9bf6cb228fe6c4b9$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $9bf6cb228fe6c4b9$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $9bf6cb228fe6c4b9$var$_getErrorMessage(abortController, error);
                const timedOut = $9bf6cb228fe6c4b9$var$_didTimeout(abortController);
                $9bf6cb228fe6c4b9$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$9bf6cb228fe6c4b9$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $lJFpJ.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $kjeZa.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $9bf6cb228fe6c4b9$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $9bf6cb228fe6c4b9$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $9bf6cb228fe6c4b9$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        return $9bf6cb228fe6c4b9$var$__awaiter(this, void 0, void 0, function*() {
            const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
            if (args.urlConfig.endpoint === $b9JnD.Endpoint._initialize || args.urlConfig.endpoint === $b9JnD.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
            const params = Object.assign({
                [$b9JnD.NetworkParam.SdkKey]: args.sdkKey,
                [$b9JnD.NetworkParam.SdkType]: $97sCK.SDKType._get(args.sdkKey),
                [$b9JnD.NetworkParam.SdkVersion]: $ogwOt.SDK_VERSION,
                [$b9JnD.NetworkParam.Time]: String(Date.now()),
                [$b9JnD.NetworkParam.SessionID]: $a7C7B.SessionID.get(args.sdkKey)
            }, args.params);
            const query = Object.keys(params).map((key)=>{
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            }).join('&');
            return `${url}${query ? `?${query}` : ''}`;
        });
    }
    _getPopulatedBody(args, data) {
        return $9bf6cb228fe6c4b9$var$__awaiter(this, void 0, void 0, function*() {
            const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
            const stableID = $fWuLw.StableID.get(sdkKey);
            const sessionID = $a7C7B.SessionID.get(sdkKey);
            const sdkType = $97sCK.SDKType._get(sdkKey);
            return JSON.stringify(Object.assign(Object.assign({}, data), {
                statsigMetadata: Object.assign(Object.assign({}, $ogwOt.StatsigMetadataProvider.get()), {
                    stableID: stableID,
                    sessionID: sessionID,
                    sdkType: sdkType,
                    fallbackUrl: fallbackUrl
                })
            }));
        });
    }
    _attemptToEncodeString(args, input) {
        var _a, _b;
        const win = (0, $cq1SB._getWindowSafe)();
        if (this._options.disableStatsigEncoding || (0, $eTY8R._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return input;
        try {
            const result = (_a = win.btoa(input).split('').reverse().join('')) !== null && _a !== void 0 ? _a : input;
            args.params = Object.assign(Object.assign({}, (_b = args.params) !== null && _b !== void 0 ? _b : {}), {
                [$b9JnD.NetworkParam.StatsigEncoded]: '1'
            });
            return result;
        } catch (_c) {
            $kjeZa.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`);
            return input;
        }
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        return Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
    }
}
module.exports.NetworkCore = $9bf6cb228fe6c4b9$var$NetworkCore;
const $9bf6cb228fe6c4b9$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $kjeZa.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
function $9bf6cb228fe6c4b9$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $9bf6cb228fe6c4b9$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $9bf6cb228fe6c4b9$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $b9JnD.Endpoint._initialize) return;
    $4woX0.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $9bf6cb228fe6c4b9$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $b9JnD.Endpoint._initialize) return;
    $4woX0.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $4woX0.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $9bf6cb228fe6c4b9$var$_exponentialBackoff(attempt) {
    return $9bf6cb228fe6c4b9$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($9bf6cb228fe6c4b9$var$BACKOFF_BASE_MS * (attempt * attempt), $9bf6cb228fe6c4b9$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("iouRT", function(module, exports) {
"use strict";
var $d64269ac4a7bd25d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $5GNgH = parcelRequire("5GNgH");

var $3fzC1 = parcelRequire("3fzC1");

var $kjeZa = parcelRequire("kjeZa");

var $ew5hk = parcelRequire("ew5hk");
const $d64269ac4a7bd25d$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $d64269ac4a7bd25d$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $d64269ac4a7bd25d$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $d64269ac4a7bd25d$var$DEFAULT_TTL_MS;
        $d64269ac4a7bd25d$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $d64269ac4a7bd25d$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0)) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $d64269ac4a7bd25d$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    getFallbackFromProvided(url) {
        const path = $d64269ac4a7bd25d$var$_extractPathFromUrl(url);
        if (path) return url.replace(path, '');
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $d64269ac4a7bd25d$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$d64269ac4a7bd25d$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig.endpoint, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, endpoint, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            url: newUrl,
            expiryTime: Date.now() + $d64269ac4a7bd25d$var$DEFAULT_TTL_MS,
            previous: []
        };
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $d64269ac4a7bd25d$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $d64269ac4a7bd25d$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $d64269ac4a7bd25d$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $5GNgH._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $d64269ac4a7bd25d$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $d64269ac4a7bd25d$var$NetworkFallbackResolver;
function $d64269ac4a7bd25d$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $d64269ac4a7bd25d$var$_isDomainFailure;
function $d64269ac4a7bd25d$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $3fzC1._DJB2)(sdkKey)}`;
}
function $d64269ac4a7bd25d$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $d64269ac4a7bd25d$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $ew5hk.Storage.removeItem(hashKey);
        return;
    }
    $ew5hk.Storage.setItem(hashKey, JSON.stringify(info));
}
function $d64269ac4a7bd25d$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $d64269ac4a7bd25d$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $ew5hk.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $kjeZa.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $d64269ac4a7bd25d$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("5GNgH", function(module, exports) {
"use strict";
var $424717a4bbd54f4b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $424717a4bbd54f4b$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $424717a4bbd54f4b$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $424717a4bbd54f4b$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $424717a4bbd54f4b$var$MAX_START_LOOKUP = 200;
function $424717a4bbd54f4b$var$_fetchTxtRecords(networkFunc) {
    return $424717a4bbd54f4b$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($424717a4bbd54f4b$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $424717a4bbd54f4b$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $424717a4bbd54f4b$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $424717a4bbd54f4b$var$_fetchTxtRecords;
function $424717a4bbd54f4b$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $424717a4bbd54f4b$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $424717a4bbd54f4b$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("a7C7B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $1YEnC = parcelRequire("1YEnC");

var $kjeZa = parcelRequire("kjeZa");

var $ew5hk = parcelRequire("ew5hk");

var $XT3YN = parcelRequire("XT3YN");
const $75e820fdecf5fc5e$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $75e820fdecf5fc5e$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $75e820fdecf5fc5e$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($75e820fdecf5fc5e$var$PROMISE_MAP[sdkKey] == null) $75e820fdecf5fc5e$var$PROMISE_MAP[sdkKey] = $75e820fdecf5fc5e$var$_loadSession(sdkKey);
        const session = $75e820fdecf5fc5e$var$PROMISE_MAP[sdkKey];
        return $75e820fdecf5fc5e$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $75e820fdecf5fc5e$var$PROMISE_MAP[sdkKey] = $75e820fdecf5fc5e$var$_overrideSessionId(override, sdkKey);
    }
};
function $75e820fdecf5fc5e$var$_loadSession(sdkKey) {
    let data = $75e820fdecf5fc5e$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $XT3YN.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $75e820fdecf5fc5e$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $75e820fdecf5fc5e$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    if ($75e820fdecf5fc5e$var$_isIdle(data) || $75e820fdecf5fc5e$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $XT3YN.getUUID)();
        data.startTime = now;
    }
    data.lastUpdate = now;
    $75e820fdecf5fc5e$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    const sdkKey = session.sdkKey;
    session.idleTimeoutID = $75e820fdecf5fc5e$var$_createSessionTimeout(sdkKey, $75e820fdecf5fc5e$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $75e820fdecf5fc5e$var$_createSessionTimeout(sdkKey, $75e820fdecf5fc5e$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $75e820fdecf5fc5e$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $75e820fdecf5fc5e$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $75e820fdecf5fc5e$var$MAX_SESSION_IDLE_TIME;
}
function $75e820fdecf5fc5e$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $75e820fdecf5fc5e$var$MAX_SESSION_AGE;
}
function $75e820fdecf5fc5e$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $1YEnC._getStorageKey)(sdkKey)}`;
}
function $75e820fdecf5fc5e$var$_persistToStorage(session, sdkKey) {
    const storageKey = $75e820fdecf5fc5e$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $ew5hk._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $kjeZa.Log.warn('Failed to save SessionID');
    }
}
function $75e820fdecf5fc5e$var$_loadFromStorage(sdkKey) {
    const storageKey = $75e820fdecf5fc5e$var$_getSessionIDStorageKey(sdkKey);
    return (0, $ew5hk._getObjectFromStorage)(storageKey);
}

});

parcelRegister("lJFpJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("eVoTP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iJsCh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9LWVG", function(module, exports) {
"use strict";
var $71d63702343f2c7e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $eTY8R = parcelRequire("eTY8R");

var $eTY8R = parcelRequire("eTY8R");

var $e8wVm = parcelRequire("e8wVm");

var $cyufg = parcelRequire("cyufg");

var $kjeZa = parcelRequire("kjeZa");

var $cPrw2 = parcelRequire("cPrw2");

var $cq1SB = parcelRequire("cq1SB");

var $a7C7B = parcelRequire("a7C7B");

var $ew5hk = parcelRequire("ew5hk");
const $71d63702343f2c7e$var$MAX_MEMO_CACHE_SIZE = 3000;
class $71d63702343f2c7e$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($kjeZa.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $ew5hk.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $a7C7B.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $ew5hk.Storage._setProvider(options.storageProvider);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $cyufg.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $e8wVm.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options);
        this.storageProvider = $ew5hk.Storage;
        this._primeReadyRipcord();
        $71d63702343f2c7e$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingDisabled(options.disableLogging);
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $ew5hk.Storage._setDisabled(options.disableStorage);
        }
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $71d63702343f2c7e$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $kjeZa.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $cPrw2.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $71d63702343f2c7e$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $71d63702343f2c7e$var$StatsigClientBase;
function $71d63702343f2c7e$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $cq1SB._isServerEnv)()) return;
    const statsigGlobal = (0, $eTY8R._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $kjeZa.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("iIqZJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("8DK2A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("67mpC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7m7ly", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $kjeZa = parcelRequire("kjeZa");

var $lqtus = parcelRequire("lqtus");
const $55b0496207be0764$var$DEFAULT_RULE = 'default';
function $55b0496207be0764$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : $55b0496207be0764$var$DEFAULT_RULE,
        __evaluation: evaluation,
        value: value
    };
}
function $55b0496207be0764$var$_makeFeatureGate(name, details, evaluation) {
    return $55b0496207be0764$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true);
}
module.exports._makeFeatureGate = $55b0496207be0764$var$_makeFeatureGate;
function $55b0496207be0764$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $55b0496207be0764$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $55b0496207be0764$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $55b0496207be0764$var$_makeDynamicConfig;
function $55b0496207be0764$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $55b0496207be0764$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $55b0496207be0764$var$_makeExperiment;
function $55b0496207be0764$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $55b0496207be0764$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $55b0496207be0764$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $55b0496207be0764$var$_makeLayer;
function $55b0496207be0764$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $55b0496207be0764$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $55b0496207be0764$var$_mergeOverride;
function $55b0496207be0764$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $lqtus._isTypeMatch)(found, fallback)) {
            $kjeZa.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $55b0496207be0764$var$_makeTypedGet;

});

parcelRegister("cfXlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kyGUG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $ef78454e8f7d7de5$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $ef78454e8f7d7de5$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});

parcelRegister("38RF3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $249bbe75533caf1c$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $249bbe75533caf1c$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $249bbe75533caf1c$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});


parcelRegister("gSHkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ctK4w = parcelRequire("ctK4w");
class $c4a34e05695fd1ae$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $ctK4w._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        if (!result) return false;
        const values = (0, $ctK4w._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        if (values.sdk_flags) $ctK4w.SDKFlags.setFlags(this._sdkKey, values.sdk_flags);
        else $ctK4w.SDKFlags.setFlags(this._sdkKey, {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $ctK4w._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a;
        const stableID = $ctK4w.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            if ((0, $ctK4w._getFullUserHash)(user) !== (0, $ctK4w._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $c4a34e05695fd1ae$var$EvaluationStore;

});

parcelRegister("dUK6I", function(module, exports) {
"use strict";
var $a21445479a35024d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ctK4w = parcelRequire("ctK4w");

var $bW61A = parcelRequire("bW61A");
class $a21445479a35024d$var$StatsigNetwork extends $ctK4w.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._initializeUrlConfig = new $ctK4w.UrlConfiguration($ctK4w.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user) {
        return $a21445479a35024d$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $ctK4w._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) data = Object.assign(Object.assign({}, data), {
                sinceTime: cache.time,
                previousDerivedFields: 'derived_fields' in cache ? cache.derived_fields : {},
                deltasResponseRequested: true,
                full_checksum: cache.full_checksum
            });
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $a21445479a35024d$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $bW61A._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $a21445479a35024d$var$StatsigNetwork;

});
parcelRegister("bW61A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $ctK4w = parcelRequire("ctK4w");
const $8b09c8d90fdd7e02$var$MAX_DELTAS_SORT_DEPTH = 2;
function $8b09c8d90fdd7e02$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $ctK4w._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $8b09c8d90fdd7e02$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $8b09c8d90fdd7e02$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $ctK4w._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $8b09c8d90fdd7e02$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $8b09c8d90fdd7e02$var$_resolveDeltasResponse;
function $8b09c8d90fdd7e02$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $8b09c8d90fdd7e02$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $8b09c8d90fdd7e02$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $8b09c8d90fdd7e02$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $8b09c8d90fdd7e02$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $8b09c8d90fdd7e02$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("d1lcm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $ctK4w = parcelRequire("ctK4w");
const $97abcfee94b7784a$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $97abcfee94b7784a$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $97abcfee94b7784a$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $ctK4w._isTypeMatch)(value, fallback);
}
function $97abcfee94b7784a$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $97abcfee94b7784a$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $97abcfee94b7784a$var$_shouldLogExposure(options) ? undefined : $97abcfee94b7784a$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $97abcfee94b7784a$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $97abcfee94b7784a$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($97abcfee94b7784a$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($97abcfee94b7784a$var$_shouldLogExposure(options)) client.getDynamicConfig(param.config_name);
    return value;
}
function $97abcfee94b7784a$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $97abcfee94b7784a$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($97abcfee94b7784a$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($97abcfee94b7784a$var$_shouldLogExposure(options)) client.getExperiment(param.experiment_name);
    return value;
}
function $97abcfee94b7784a$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $97abcfee94b7784a$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($97abcfee94b7784a$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($97abcfee94b7784a$var$_shouldLogExposure(options)) client.getLayer(param.layer_name).get(param.param_name);
    return value;
}
function $97abcfee94b7784a$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $ctK4w._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $97abcfee94b7784a$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $97abcfee94b7784a$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $97abcfee94b7784a$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $97abcfee94b7784a$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $97abcfee94b7784a$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $97abcfee94b7784a$var$_makeParamStoreGetter;

});

parcelRegister("gTKA8", function(module, exports) {
"use strict";
var $c4d5ea8cd954bb33$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $ctK4w = parcelRequire("ctK4w");

var $dUK6I = parcelRequire("dUK6I");
class $c4d5ea8cd954bb33$var$StatsigEvaluationsDataAdapter extends $ctK4w.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options) {
        super.attach(sdkKey, options);
        this._network = new $dUK6I.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $ctK4w._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $ctK4w._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $ctK4w.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options) {
        var _a;
        return $c4d5ea8cd954bb33$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $ctK4w._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$ctK4w.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $ctK4w._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $c4d5ea8cd954bb33$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("1ZBiw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17386b7fae890977$export$2e2bcd8739ae039; });

var $1pngT = parcelRequire("1pngT");

var $ap6hD = parcelRequire("ap6hD");

var $5IxoE = parcelRequire("5IxoE");

var $WZI3E = parcelRequire("WZI3E");
function $17386b7fae890977$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $17386b7fae890977$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $17386b7fae890977$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5IxoE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $17386b7fae890977$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $17386b7fae890977$export$a66cbd9b2289cd78 = '@all-features';
var $17386b7fae890977$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $1pngT.default)(this, Subscriptions);
        (0, $5IxoE.default)(this, "eventToValue", new Map());
        this.emitter = new (0, $WZI3E.EventEmitter2)();
    }
    return (0, $ap6hD.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $17386b7fae890977$var$_objectSpread($17386b7fae890977$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $17386b7fae890977$var$_objectSpread($17386b7fae890977$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $17386b7fae890977$var$_objectSpread($17386b7fae890977$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $17386b7fae890977$var$_objectSpread($17386b7fae890977$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($17386b7fae890977$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($17386b7fae890977$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($17386b7fae890977$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $17386b7fae890977$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("WZI3E", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ 
var $7t0tI = parcelRequire("7t0tI");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $7t0tI !== 'undefined' && $7t0tI.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $7t0tI.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("aHqn9", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $7ca2608ee4a3ffb4$export$6dc24881a3d96325; });

var $03egE = parcelRequire("03egE");

var $1pngT = parcelRequire("1pngT");

var $ap6hD = parcelRequire("ap6hD");

var $iF2Jb = parcelRequire("iF2Jb");
var $7ca2608ee4a3ffb4$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $1pngT.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $ap6hD.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $03egE.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $03egE.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $iF2Jb.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("iF2Jb", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $038184d6ae64591d$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $038184d6ae64591d$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $038184d6ae64591d$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $038184d6ae64591d$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $038184d6ae64591d$export$18ad168d3dbac899; });

var $e12aH = parcelRequire("e12aH");

var $3FMi9 = parcelRequire("3FMi9");

var $5IxoE = parcelRequire("5IxoE");

var $apSbF = parcelRequire("apSbF");

var $1MUfy = parcelRequire("1MUfy");

var $bsnS2 = parcelRequire("bsnS2");

var $gJrsj = parcelRequire("gJrsj");
var $038184d6ae64591d$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $038184d6ae64591d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $038184d6ae64591d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $038184d6ae64591d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5IxoE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $038184d6ae64591d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $038184d6ae64591d$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $038184d6ae64591d$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $1MUfy.isFedRamp)() ? (0, $gJrsj.PerimeterType).FEDRAMP_MODERATE : (0, $gJrsj.PerimeterType).COMMERCIAL
    }, options);
};
var $038184d6ae64591d$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $3FMi9.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $3FMi9.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $3FMi9.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $3FMi9.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $038184d6ae64591d$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $038184d6ae64591d$var$_objectSpread({
            stableID: (0, $apSbF.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $038184d6ae64591d$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $e12aH.default)(options, $038184d6ae64591d$var$_excluded);
    return $038184d6ae64591d$var$_objectSpread($038184d6ae64591d$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $038184d6ae64591d$var$evaluationReasonMappings = Object.entries((0, $bsnS2.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $3FMi9.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $038184d6ae64591d$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $038184d6ae64591d$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $3FMi9.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $bsnS2.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("1MUfy", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", function () { return $14d5e832024c418c$export$64d6499adf9b2e51; });

var $8DTjO = parcelRequire("8DTjO");
function $14d5e832024c418c$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $8DTjO.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("8DTjO", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $64ace059bf099efa$export$ce553301d55c2fd8; });
var $64ace059bf099efa$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $64ace059bf099efa$export$f005e2e9f707cb5f = 'commercial';
var $64ace059bf099efa$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $64ace059bf099efa$export$a739cd5aac835909 = 'stg';
var $64ace059bf099efa$export$42dd0cdd351a4a9 = 'prod';
var $64ace059bf099efa$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("bsnS2", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $8574d36a6f295467$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $8574d36a6f295467$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("gJrsj", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $c2e625710fe6325b$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $c2e625710fe6325b$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $c2e625710fe6325b$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $c2e625710fe6325b$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $c2e625710fe6325b$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("80oJ0", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $5d4180ab1c532851$export$936d0764594b6eb3; });

var $03egE = parcelRequire("03egE");

var $1pngT = parcelRequire("1pngT");

var $ap6hD = parcelRequire("ap6hD");

var $iF2Jb = parcelRequire("iF2Jb");
var $5d4180ab1c532851$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $1pngT.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $ap6hD.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $03egE.default)(val) === (0, $03egE.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $iF2Jb.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("1xFVn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $11f964d9e71548b8$export$2e2bcd8739ae039; });

var $5IxoE = parcelRequire("5IxoE");

var $3YOJZ = parcelRequire("3YOJZ");

var $1pngT = parcelRequire("1pngT");

var $ap6hD = parcelRequire("ap6hD");

var $lY0K8 = parcelRequire("lY0K8");

var $gJrsj = parcelRequire("gJrsj");

var $eydMo = parcelRequire("eydMo");

var $255An = parcelRequire("255An");
function $11f964d9e71548b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11f964d9e71548b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11f964d9e71548b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5IxoE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11f964d9e71548b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $11f964d9e71548b8$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $11f964d9e71548b8$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $11f964d9e71548b8$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $11f964d9e71548b8$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $11f964d9e71548b8$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $11f964d9e71548b8$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $11f964d9e71548b8$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $11f964d9e71548b8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $1pngT.default)(this, Fetcher);
    }
    return (0, $ap6hD.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $255An.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $255An.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $11f964d9e71548b8$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $gJrsj.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $gJrsj.FeatureGateEnvironment).Production:
                        return $11f964d9e71548b8$export$18c93900db9358a4;
                    case (0, $gJrsj.FeatureGateEnvironment).Staging:
                        return $11f964d9e71548b8$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $gJrsj.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $gJrsj.FeatureGateEnvironment).Development:
                        return $11f964d9e71548b8$export$f058dbf75c3bc647;
                    case (0, $gJrsj.FeatureGateEnvironment).Staging:
                        return $11f964d9e71548b8$export$942ba04389b0d5a2;
                    default:
                        return $11f964d9e71548b8$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $11f964d9e71548b8$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $11f964d9e71548b8$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $eydMo.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("eydMo", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $a97eedff2354ece2$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $a97eedff2354ece2$export$a59f8d67326bd1cb = "4.26.5";

});

parcelRegister("255An", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $1840619ac3fbc598$export$286baf652d0b1206; });

var $ap6hD = parcelRequire("ap6hD");

var $1pngT = parcelRequire("1pngT");

var $jMjLT = parcelRequire("jMjLT");

var $1Ch0O = parcelRequire("1Ch0O");

var $5GP73 = parcelRequire("5GP73");

var $a0Yo3 = parcelRequire("a0Yo3");
function $1840619ac3fbc598$var$_callSuper(t, o, e) {
    return o = (0, $1Ch0O.default)(o), (0, $jMjLT.default)(t, $1840619ac3fbc598$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $1Ch0O.default)(t).constructor) : o.apply(t, e));
}
function $1840619ac3fbc598$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1840619ac3fbc598$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1840619ac3fbc598$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $1pngT.default)(this, ResponseError);
        return $1840619ac3fbc598$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $5GP73.default)(ResponseError, _Error);
    return (0, $ap6hD.default)(ResponseError);
}(/*#__PURE__*/ (0, $a0Yo3.default)(Error));

});
parcelRegister("jMjLT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e661d632093b1989$export$2e2bcd8739ae039; });

var $03egE = parcelRequire("03egE");

var $gtyZk = parcelRequire("gtyZk");
function $e661d632093b1989$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $03egE.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $gtyZk.default)(t);
}

});
parcelRegister("gtyZk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bfea7eb4c6910bbf$export$2e2bcd8739ae039; });
function $bfea7eb4c6910bbf$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("1Ch0O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $12d68947abcfa13f$export$2e2bcd8739ae039; });
function $12d68947abcfa13f$export$2e2bcd8739ae039(t) {
    return $12d68947abcfa13f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $12d68947abcfa13f$export$2e2bcd8739ae039(t);
}

});

parcelRegister("5GP73", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $424885e6f5017c41$export$2e2bcd8739ae039; });

var $fUe0I = parcelRequire("fUe0I");
function $424885e6f5017c41$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $fUe0I.default)(t, e);
}

});
parcelRegister("fUe0I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b946f42f6fd49a93$export$2e2bcd8739ae039; });
function $b946f42f6fd49a93$export$2e2bcd8739ae039(t, e) {
    return $b946f42f6fd49a93$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b946f42f6fd49a93$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("a0Yo3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74a8bf132a42f127$export$2e2bcd8739ae039; });

var $1Ch0O = parcelRequire("1Ch0O");

var $fUe0I = parcelRequire("fUe0I");

var $52AyY = parcelRequire("52AyY");

var $eYf2Q = parcelRequire("eYf2Q");
function $74a8bf132a42f127$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $74a8bf132a42f127$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $52AyY.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $eYf2Q.default)(t, arguments, (0, $1Ch0O.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $fUe0I.default)(Wrapper, t);
    }, $74a8bf132a42f127$export$2e2bcd8739ae039(t);
}

});
parcelRegister("52AyY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ab98052da7f2218$export$2e2bcd8739ae039; });
function $3ab98052da7f2218$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("eYf2Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ae6256e65eb4b098$export$2e2bcd8739ae039; });

var $8twLH = parcelRequire("8twLH");

var $fUe0I = parcelRequire("fUe0I");
function $ae6256e65eb4b098$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $8twLH.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $fUe0I.default)(p, r.prototype), p;
}

});
parcelRegister("8twLH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $62ba73461f524cfe$export$2e2bcd8739ae039; });
function $62ba73461f524cfe$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($62ba73461f524cfe$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("g2bRu", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $bac608b99e1e5859$export$55fffef3474104af; });

var $3YOJZ = parcelRequire("3YOJZ");

var $1pngT = parcelRequire("1pngT");

var $ap6hD = parcelRequire("ap6hD");

var $jMjLT = parcelRequire("jMjLT");

var $1Ch0O = parcelRequire("1Ch0O");

var $3eEvb = parcelRequire("3eEvb");

var $5GP73 = parcelRequire("5GP73");

var $5IxoE = parcelRequire("5IxoE");

var $lY0K8 = parcelRequire("lY0K8");

var $apSbF = parcelRequire("apSbF");
function $bac608b99e1e5859$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bac608b99e1e5859$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bac608b99e1e5859$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5IxoE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bac608b99e1e5859$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bac608b99e1e5859$var$_callSuper(t, o, e) {
    return o = (0, $1Ch0O.default)(o), (0, $jMjLT.default)(t, $bac608b99e1e5859$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $1Ch0O.default)(t).constructor) : o.apply(t, e));
}
function $bac608b99e1e5859$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bac608b99e1e5859$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bac608b99e1e5859$var$_superPropGet(t, o, e, r) {
    var p = (0, $3eEvb.default)((0, $1Ch0O.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $bac608b99e1e5859$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $1pngT.default)(this, NoFetchDataAdapter);
        _this = $bac608b99e1e5859$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $5IxoE.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $5GP73.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $ap6hD.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $apSbF.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $bac608b99e1e5859$var$_objectSpread($bac608b99e1e5859$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $apSbF._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $bac608b99e1e5859$var$_objectSpread($bac608b99e1e5859$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $apSbF._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $3YOJZ.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lY0K8))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $apSbF._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $apSbF.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $bac608b99e1e5859$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $bac608b99e1e5859$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $apSbF.DataAdapterCore));

});
parcelRegister("3eEvb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $25b218c3de9fdeb0$export$2e2bcd8739ae039; });

var $3DNZ9 = parcelRequire("3DNZ9");
function $25b218c3de9fdeb0$export$2e2bcd8739ae039() {
    return $25b218c3de9fdeb0$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $3DNZ9.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $25b218c3de9fdeb0$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("3DNZ9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2a6bc9abe6ac87b9$export$2e2bcd8739ae039; });

var $1Ch0O = parcelRequire("1Ch0O");
function $2a6bc9abe6ac87b9$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $1Ch0O.default)(t)););
    return t;
}

});



parcelRegister("d8bqN", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $98f4e3bbb2e0e8f7$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $98f4e3bbb2e0e8f7$export$bcb28fbac1def494; });

var $5IxoE = parcelRequire("5IxoE");

var $3FMi9 = parcelRequire("3FMi9");

var $1pngT = parcelRequire("1pngT");

var $ap6hD = parcelRequire("ap6hD");

var $ctK4w = parcelRequire("ctK4w");
function $98f4e3bbb2e0e8f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98f4e3bbb2e0e8f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98f4e3bbb2e0e8f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5IxoE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98f4e3bbb2e0e8f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $98f4e3bbb2e0e8f7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $98f4e3bbb2e0e8f7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $98f4e3bbb2e0e8f7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $98f4e3bbb2e0e8f7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $98f4e3bbb2e0e8f7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $98f4e3bbb2e0e8f7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $98f4e3bbb2e0e8f7$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $98f4e3bbb2e0e8f7$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $98f4e3bbb2e0e8f7$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $98f4e3bbb2e0e8f7$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $98f4e3bbb2e0e8f7$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $98f4e3bbb2e0e8f7$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $1pngT.default)(this, PersistentOverrideAdapter);
        this._overrides = $98f4e3bbb2e0e8f7$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $ap6hD.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $98f4e3bbb2e0e8f7$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $98f4e3bbb2e0e8f7$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $98f4e3bbb2e0e8f7$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $3FMi9.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $3FMi9.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $3FMi9.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($98f4e3bbb2e0e8f7$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($98f4e3bbb2e0e8f7$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $98f4e3bbb2e0e8f7$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $ctK4w._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $98f4e3bbb2e0e8f7$var$_objectSpread($98f4e3bbb2e0e8f7$var$_objectSpread({}, $98f4e3bbb2e0e8f7$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $3FMi9.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $3FMi9.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($98f4e3bbb2e0e8f7$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $98f4e3bbb2e0e8f7$var$_objectSpread($98f4e3bbb2e0e8f7$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $98f4e3bbb2e0e8f7$var$_objectSpread($98f4e3bbb2e0e8f7$var$_objectSpread({}, current.details), {}, {
                        reason: $98f4e3bbb2e0e8f7$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($98f4e3bbb2e0e8f7$var$djb2MapKey((0, $ctK4w._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $98f4e3bbb2e0e8f7$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($98f4e3bbb2e0e8f7$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $98f4e3bbb2e0e8f7$var$_objectSpread($98f4e3bbb2e0e8f7$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $ctK4w._makeTypedGet)(current.name, overridden),
                    details: $98f4e3bbb2e0e8f7$var$_objectSpread($98f4e3bbb2e0e8f7$var$_objectSpread({}, current.details), {}, {
                        reason: $98f4e3bbb2e0e8f7$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($98f4e3bbb2e0e8f7$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $98f4e3bbb2e0e8f7$var$_objectSpread($98f4e3bbb2e0e8f7$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $ctK4w._makeTypedGet)(current.name, overridden),
                    details: $98f4e3bbb2e0e8f7$var$_objectSpread($98f4e3bbb2e0e8f7$var$_objectSpread({}, current.details), {}, {
                        reason: $98f4e3bbb2e0e8f7$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("diiJb", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $9adb7bba0aa214a2$export$1c9f709888824e05; });
var $9adb7bba0aa214a2$var$_process, $9adb7bba0aa214a2$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $9adb7bba0aa214a2$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($9adb7bba0aa214a2$var$_process = globalThis.process) === null || $9adb7bba0aa214a2$var$_process === void 0 || ($9adb7bba0aa214a2$var$_process = $9adb7bba0aa214a2$var$_process.env) === null || $9adb7bba0aa214a2$var$_process === void 0 ? void 0 : $9adb7bba0aa214a2$var$_process.JEST_WORKER_ID) !== undefined;
var $9adb7bba0aa214a2$var$DEBUG_MODE = !$9adb7bba0aa214a2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($9adb7bba0aa214a2$var$_process2 = globalThis.process) === null || $9adb7bba0aa214a2$var$_process2 === void 0 || ($9adb7bba0aa214a2$var$_process2 = $9adb7bba0aa214a2$var$_process2.env) === null || $9adb7bba0aa214a2$var$_process2 === void 0 ? void 0 : $9adb7bba0aa214a2$var$_process2.NODE_ENV) !== 'production';
var $9adb7bba0aa214a2$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$9adb7bba0aa214a2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("ceERr", function(module, exports) {
$parcel$export(module.exports, "startLighthouseObserver", function () { return $8e867cff46eb53d1$export$5ecf2aafafee3e0; });
$parcel$export(module.exports, "getLighthouseMetrics", function () { return $8e867cff46eb53d1$export$b46cecdf698e4bb5; });

var $4BsHe = parcelRequire("4BsHe");

var $aZbZm = parcelRequire("aZbZm");

var $kxwek = parcelRequire("kxwek");

var $8ZO5Y = parcelRequire("8ZO5Y");

var $4WwQn = parcelRequire("4WwQn");
function $8e867cff46eb53d1$export$5ecf2aafafee3e0() {
    (0, $4WwQn.startLSObserver)();
    (0, $4WwQn.startLTObserver)();
}
function $8e867cff46eb53d1$export$b46cecdf698e4bb5(_ref) {
    var start = _ref.start, stop = _ref.stop;
    var tbt = (0, $kxwek.getTBT)(start, stop, (0, $8ZO5Y.EntriesBuffer)[(0, $aZbZm.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    var cls = (0, $4BsHe.getCLS)(start, stop, (0, $8ZO5Y.EntriesBuffer)[(0, $aZbZm.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("4BsHe", function(module, exports) {
$parcel$export(module.exports, "getCLS", function () { return $35a0e0a2c57f4c48$export$fc6227831ee7c7; });

var $39c3M = parcelRequire("39c3M");
function $35a0e0a2c57f4c48$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $35a0e0a2c57f4c48$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $35a0e0a2c57f4c48$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $35a0e0a2c57f4c48$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $35a0e0a2c57f4c48$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $35a0e0a2c57f4c48$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $35a0e0a2c57f4c48$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $35a0e0a2c57f4c48$export$fc6227831ee7c7(start, stop, buffer) {
    var layoutShifts = buffer.getAll().filter(function(_entry) {
        var entry = _entry;
        var isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $39c3M.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            var _entry$sources;
            var allSourcesHaveSameRects = entry === null || entry === void 0 || (_entry$sources = entry.sources) === null || _entry$sources === void 0 ? void 0 : _entry$sources.every(function(_ref) {
                var previousRect = _ref.previousRect, currentRect = _ref.currentRect;
                return $35a0e0a2c57f4c48$var$isSameRects(previousRect, currentRect);
            });
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    var sessionWindows = [];
    var currentWindow = null;
    // Group layout shifts into session windows
    var _iterator = $35a0e0a2c57f4c48$var$_createForOfIteratorHelper(layoutShifts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var shift = _step.value;
            var startTime = shift.startTime;
            var endTime = shift.startTime + shift.duration;
            var score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                // Start a new session window
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                // Add layout shift to current session window
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
    // Find session window with highest cumulative score
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var maxScore = sessionWindows.reduce(function(max, sessionWindow) {
        return sessionWindow.score > max ? sessionWindow.score : max;
    }, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("aZbZm", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", function () { return $7ff8e699cf6d3652$export$a4def92db6fc8e17; });
var $7ff8e699cf6d3652$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("kxwek", function(module, exports) {
$parcel$export(module.exports, "getTBT", function () { return $ef3fe3f5a98541f0$export$2d6e933b35bd3407; });
var $ef3fe3f5a98541f0$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $ef3fe3f5a98541f0$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter(function(entry) {
        return entry.startTime <= stop && entry.duration > $ef3fe3f5a98541f0$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop);
    }).reduce(function(tbt, entry) {
        var longTaskStop = entry.startTime + entry.duration;
        var intersectStart = Math.max(entry.startTime + $ef3fe3f5a98541f0$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        var intersectStop = Math.min(longTaskStop, stop);
        var longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $ef3fe3f5a98541f0$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("8ZO5Y", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", function () { return $68cae11f048c5457$export$f7dc16cbd16f7bbe; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $aZbZm = parcelRequire("aZbZm");
var $68cae11f048c5457$export$2c6e86519c9e8188 = /*#__PURE__*/ function() {
    function BufferWithMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
        (0, $zhrfT.default)(this, BufferWithMaxLength);
        (0, $gNkVH.default)(this, "buffer", []);
        (0, $gNkVH.default)(this, "full", false);
        this.maxLength = maxLength;
    }
    return (0, $j9c2S.default)(BufferWithMaxLength, [
        {
            key: "push",
            value: function push(item) {
                if (this.full || this.maxLength === this.buffer.length) {
                    this.full = true;
                    this.buffer.shift();
                }
                this.buffer.push(item);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.buffer;
            }
        }
    ]);
}();
var $68cae11f048c5457$export$f7dc16cbd16f7bbe = (0, $gNkVH.default)((0, $gNkVH.default)({}, (0, $aZbZm.PerformanceObserverEntryTypes).LongTask, new $68cae11f048c5457$export$2c6e86519c9e8188()), (0, $aZbZm.PerformanceObserverEntryTypes).LayoutShift, new $68cae11f048c5457$export$2c6e86519c9e8188());

});
parcelRegister("zhrfT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $06a0cbf1218fec74$export$2e2bcd8739ae039; });
function $06a0cbf1218fec74$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("j9c2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0398e80e8ecf7909$export$2e2bcd8739ae039; });

var $eCCbA = parcelRequire("eCCbA");
function $0398e80e8ecf7909$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $eCCbA.default)(o.key), o);
    }
}
function $0398e80e8ecf7909$export$2e2bcd8739ae039(e, r, t) {
    return r && $0398e80e8ecf7909$var$_defineProperties(e.prototype, r), t && $0398e80e8ecf7909$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("eCCbA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aa523c3471eedf42$export$2e2bcd8739ae039; });

var $1nEzb = parcelRequire("1nEzb");

var $9bDdn = parcelRequire("9bDdn");
function $aa523c3471eedf42$export$2e2bcd8739ae039(t) {
    var i = (0, $9bDdn.default)(t, "string");
    return "symbol" == (0, $1nEzb.default)(i) ? i : i + "";
}

});
parcelRegister("1nEzb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $10176815db9eea66$export$2e2bcd8739ae039; });
function $10176815db9eea66$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $10176815db9eea66$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $10176815db9eea66$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9bDdn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b038f5b2e768afb$export$2e2bcd8739ae039; });

var $1nEzb = parcelRequire("1nEzb");
function $6b038f5b2e768afb$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1nEzb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1nEzb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("gNkVH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c3a1752564618818$export$2e2bcd8739ae039; });

var $eCCbA = parcelRequire("eCCbA");
function $c3a1752564618818$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $eCCbA.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("4WwQn", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", function () { return $39960e4c456cfdc4$export$768ccc3ab7bac3ea; });
$parcel$export(module.exports, "startLTObserver", function () { return $39960e4c456cfdc4$export$54fb8b6aaf70ec9c; });

var $aZbZm = parcelRequire("aZbZm");

var $8ZO5Y = parcelRequire("8ZO5Y");
var $39960e4c456cfdc4$var$pe = null;
function $39960e4c456cfdc4$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($39960e4c456cfdc4$var$pe !== null) return $39960e4c456cfdc4$var$pe;
    var performanceObserverCallback = function performanceObserverCallback(list) {
        list.getEntries().forEach(function(entry) {
            if (entry.entryType === (0, $aZbZm.PerformanceObserverEntryTypes).LayoutShift) (0, $8ZO5Y.EntriesBuffer)[(0, $aZbZm.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $aZbZm.PerformanceObserverEntryTypes).LongTask) (0, $8ZO5Y.EntriesBuffer)[(0, $aZbZm.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $39960e4c456cfdc4$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $39960e4c456cfdc4$var$pe;
}
function $39960e4c456cfdc4$export$768ccc3ab7bac3ea() {
    var _getObserver;
    (_getObserver = $39960e4c456cfdc4$var$getObserver()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $aZbZm.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $39960e4c456cfdc4$export$54fb8b6aaf70ec9c() {
    var _getObserver2;
    (_getObserver2 = $39960e4c456cfdc4$var$getObserver()) === null || _getObserver2 === void 0 || _getObserver2.observe({
        type: (0, $aZbZm.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("03EZb", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", function () { return $00b012dab2e6868d$export$f9bb3bb330fb9609; });
$parcel$export(module.exports, "setUFOConfig", function () { return $00b012dab2e6868d$export$10d6139a8fb42158; });
$parcel$export(module.exports, "getConfig", function () { return $00b012dab2e6868d$export$44487a86467333c3; });
$parcel$export(module.exports, "isUFOEnabled", function () { return $00b012dab2e6868d$export$74bdb753f1cf4860; });
$parcel$export(module.exports, "isVCRevisionEnabled", function () { return $00b012dab2e6868d$export$4babcefc81a3ef0b; });
$parcel$export(module.exports, "getMostRecentVCRevision", function () { return $00b012dab2e6868d$export$70184d6e2c753893; });
$parcel$export(module.exports, "getReactHydrationStats", function () { return $00b012dab2e6868d$export$2d8f8d64dc343d7b; });
$parcel$export(module.exports, "getInteractionRate", function () { return $00b012dab2e6868d$export$9466a8f085fa7d4e; });
$parcel$export(module.exports, "getExperimentalInteractionRate", function () { return $00b012dab2e6868d$export$563f73272328c0d; });
$parcel$export(module.exports, "getVCRawDataInteractionRate", function () { return $00b012dab2e6868d$export$48f4e0d964030a96; });
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", function () { return $00b012dab2e6868d$export$9c69f5a724f05f38; });
$parcel$export(module.exports, "getPostInteractionRate", function () { return $00b012dab2e6868d$export$1d459f020c06ae34; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $00b012dab2e6868d$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getExtraInteractionRate", function () { return $00b012dab2e6868d$export$203bd06a99c66a0d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $00b012dab2e6868d$export$2d311b3fd18dcab1; });
$parcel$export(module.exports, "getUfoNameOverrides", function () { return $00b012dab2e6868d$export$4f4649ef27b6f5d6; });
$parcel$export(module.exports, "getMinorInteractions", function () { return $00b012dab2e6868d$export$b150ddad71c80d77; });
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", function () { return $00b012dab2e6868d$export$3c170167645a0eff; });
$parcel$export(module.exports, "getFinishInteractionOnTransition", function () { return $00b012dab2e6868d$export$20e8108b8ccdd0bd; });
$parcel$export(module.exports, "getInteractionTimeout", function () { return $00b012dab2e6868d$export$c681731847989445; });

var $gNkVH = parcelRequire("gNkVH");

var $kOzMB = parcelRequire("kOzMB");

var $1nEzb = parcelRequire("1nEzb");

var $39c3M = parcelRequire("39c3M");
function $00b012dab2e6868d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $00b012dab2e6868d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $00b012dab2e6868d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $00b012dab2e6868d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $00b012dab2e6868d$var$config;
var $00b012dab2e6868d$export$f9bb3bb330fb9609 = 'fy26.04';
function $00b012dab2e6868d$export$2182e73d31080cbc() {
    return $00b012dab2e6868d$export$f9bb3bb330fb9609;
}
var $00b012dab2e6868d$export$d50dacda7fe6392b = 1000;
function $00b012dab2e6868d$export$10d6139a8fb42158(newConfig) {
    var _newConfig$vc;
    // Handle edge cases with `enabledVCRevisions`
    var _ref = (_newConfig$vc = newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) !== null && _newConfig$vc !== void 0 ? _newConfig$vc : {}, enabledVCRevisions = _ref.enabledVCRevisions;
    if (enabledVCRevisions) {
        var _enabledVCRevisions$a;
        var byExperience = (0, $1nEzb.default)(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        var allRevisions = [].concat((0, $kOzMB.default)((_enabledVCRevisions$a = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) !== null && _enabledVCRevisions$a !== void 0 ? _enabledVCRevisions$a : []), (0, $kOzMB.default)(Object.values(byExperience).flat()));
        $00b012dab2e6868d$var$config = $00b012dab2e6868d$var$_objectSpread($00b012dab2e6868d$var$_objectSpread({}, newConfig), {}, {
            vc: $00b012dab2e6868d$var$_objectSpread($00b012dab2e6868d$var$_objectSpread({}, newConfig.vc), {}, {
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            })
        });
    } else $00b012dab2e6868d$var$config = newConfig;
}
function $00b012dab2e6868d$export$44487a86467333c3() {
    return $00b012dab2e6868d$var$config;
}
function $00b012dab2e6868d$export$74bdb753f1cf4860() {
    var _config;
    // Default to enabled if config is not set or enabled is not explicitly false
    return ((_config = $00b012dab2e6868d$var$config) === null || _config === void 0 ? void 0 : _config.enabled) !== false;
}
var $00b012dab2e6868d$var$isValidConfigArray = function isValidConfigArray(array) {
    return Array.isArray(array) && array.length > 0;
};
function $00b012dab2e6868d$export$87fbc8e01b137811() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    try {
        var _config$vc;
        if (!$00b012dab2e6868d$var$config) return [];
        if ((_config$vc = $00b012dab2e6868d$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _config$vc2, _enabledVCRevisions$b;
            var _ref2 = (_config$vc2 = $00b012dab2e6868d$var$config.vc) !== null && _config$vc2 !== void 0 ? _config$vc2 : {}, enabledVCRevisions = _ref2.enabledVCRevisions;
            if ($00b012dab2e6868d$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            if ($00b012dab2e6868d$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all)) return enabledVCRevisions.all;
            return [
                $00b012dab2e6868d$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch (_unused) {
        return [];
    }
}
function $00b012dab2e6868d$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $00b012dab2e6868d$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $00b012dab2e6868d$export$70184d6e2c753893() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var enabledVCRevisions = $00b012dab2e6868d$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $00b012dab2e6868d$export$2d8f8d64dc343d7b() {
    if (!$00b012dab2e6868d$var$config) return undefined;
    try {
        var _config2, _config2$getReactHydr;
        var stats = (_config2 = $00b012dab2e6868d$var$config) === null || _config2 === void 0 || (_config2$getReactHydr = _config2.getReactHydrationStats) === null || _config2$getReactHydr === void 0 ? void 0 : _config2$getReactHydr.call(_config2);
        return stats !== null && stats !== void 0 ? stats : undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $00b012dab2e6868d$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$00b012dab2e6868d$var$config) return 0;
        var _config3 = $00b012dab2e6868d$var$config, killswitch = _config3.killswitch, rates = _config3.rates, rules = _config3.rules, kind = _config3.kind, autoGeneratedRate = _config3.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        var isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $00b012dab2e6868d$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (_unused2) {
        // Fallback
        return 0;
    }
}
function $00b012dab2e6868d$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$00b012dab2e6868d$var$config) return 0;
        var _config4 = $00b012dab2e6868d$var$config, experimentalInteractionMetrics = _config4.experimentalInteractionMetrics;
        if (!(experimentalInteractionMetrics !== null && experimentalInteractionMetrics !== void 0 && experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (_unused3) {
        return 0;
    }
}
function $00b012dab2e6868d$export$48f4e0d964030a96(name, interactionType) {
    return $00b012dab2e6868d$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $00b012dab2e6868d$export$9c69f5a724f05f38(name, interactionType) {
    if (!(0, $39c3M.fg)('platform_ufo_raw_data_thirdparty')) return false;
    return $00b012dab2e6868d$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $00b012dab2e6868d$export$1d459f020c06ae34(name, interactionType) {
    return $00b012dab2e6868d$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $00b012dab2e6868d$export$29b9ffb14861a1d(capability) {
    if ((0, $39c3M.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$00b012dab2e6868d$var$config) return 0;
        var _config5 = $00b012dab2e6868d$var$config, capabilityRate = _config5.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused4) {
        return 0;
    }
}
function $00b012dab2e6868d$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$00b012dab2e6868d$var$config) return 0;
        var gotConfig = $00b012dab2e6868d$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch (_unused5) {
        return 0;
    }
}
function $00b012dab2e6868d$export$203bd06a99c66a0d(name, interactionType) {
    return $00b012dab2e6868d$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
var $00b012dab2e6868d$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $00b012dab2e6868d$export$7e32aae12bf9b50f() {
    var defaultMethod = 'timeout';
    try {
        if (!$00b012dab2e6868d$var$config) return defaultMethod;
        var _config6 = $00b012dab2e6868d$var$config, typingMethod = _config6.typingMethod;
        if (typingMethod != null && $00b012dab2e6868d$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (_unused6) {
        return defaultMethod;
    }
}
function $00b012dab2e6868d$export$2d311b3fd18dcab1() {
    try {
        if (!$00b012dab2e6868d$var$config) return [];
        var _config7 = $00b012dab2e6868d$var$config, awaitBM3TTI = _config7.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (_unused7) {
        return [];
    }
}
function $00b012dab2e6868d$export$4f4649ef27b6f5d6() {
    try {
        if (!$00b012dab2e6868d$var$config) return undefined;
        var _config8 = $00b012dab2e6868d$var$config, ufoNameOverrides = _config8.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (_unused8) {
        return undefined;
    }
}
function $00b012dab2e6868d$export$b150ddad71c80d77() {
    try {
        if (!$00b012dab2e6868d$var$config) return undefined;
        var _config9 = $00b012dab2e6868d$var$config, minorInteractions = _config9.minorInteractions;
        return minorInteractions;
    } catch (_unused9) {
        return undefined;
    }
}
function $00b012dab2e6868d$export$3c170167645a0eff() {
    try {
        if (!$00b012dab2e6868d$var$config) return undefined;
        var _config0 = $00b012dab2e6868d$var$config, doNotAbortActivePressInteraction = _config0.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (_unused0) {
        return undefined;
    }
}
function $00b012dab2e6868d$export$d6dc9444bd15f70f() {
    try {
        if (!$00b012dab2e6868d$var$config) return undefined;
        var _config1 = $00b012dab2e6868d$var$config, doNotAbortActivePressInteractionOnTransition = _config1.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (_unused1) {
        return undefined;
    }
}
function $00b012dab2e6868d$export$20e8108b8ccdd0bd() {
    try {
        if (!$00b012dab2e6868d$var$config) return undefined;
        var _config10 = $00b012dab2e6868d$var$config, finishInteractionOnTransition = _config10.finishInteractionOnTransition;
        return finishInteractionOnTransition;
    } catch (_unused10) {
        return undefined;
    }
}
var $00b012dab2e6868d$export$2a8604960d7d23d9 = 60000;
function $00b012dab2e6868d$export$c681731847989445(ufoName) {
    try {
        if (!$00b012dab2e6868d$var$config) return $00b012dab2e6868d$export$2a8604960d7d23d9;
        var _config11 = $00b012dab2e6868d$var$config, interactionTimeout = _config11.interactionTimeout;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $00b012dab2e6868d$export$2a8604960d7d23d9;
    } catch (_unused11) {
        return $00b012dab2e6868d$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("kOzMB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2743be19dee712b$export$2e2bcd8739ae039; });

var $5mSVP = parcelRequire("5mSVP");

var $aA1nN = parcelRequire("aA1nN");

var $kU3AR = parcelRequire("kU3AR");

var $i0rPt = parcelRequire("i0rPt");
function $f2743be19dee712b$export$2e2bcd8739ae039(r) {
    return (0, $5mSVP.default)(r) || (0, $aA1nN.default)(r) || (0, $kU3AR.default)(r) || (0, $i0rPt.default)();
}

});
parcelRegister("5mSVP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e899e2088fc44e7$export$2e2bcd8739ae039; });

var $deuCz = parcelRequire("deuCz");
function $3e899e2088fc44e7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $deuCz.default)(r);
}

});

parcelRegister("aA1nN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b3e56c49838f8ae$export$2e2bcd8739ae039; });
function $7b3e56c49838f8ae$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("i0rPt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1bdd05df160db2b$export$2e2bcd8739ae039; });
function $d1bdd05df160db2b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("f3CCR", function(module, exports) {
$parcel$export(module.exports, "sinkExperimentalHandler", function () { return $02d436150130b2b5$export$7aa99c40634ac65f; });
$parcel$export(module.exports, "onExperimentalInteractionComplete", function () { return $02d436150130b2b5$export$1aed449484dedf63; });
$parcel$export(module.exports, "experimentalVC", function () { return $02d436150130b2b5$export$81b28dca2587ec47; });
$parcel$export(module.exports, "getExperimentalVCMetrics", function () { return $02d436150130b2b5$export$d17d2b5c5e8d732e; });

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $c3LVh = parcelRequire("c3LVh");

var $4gtBF = parcelRequire("4gtBF");

var $6BIm3 = parcelRequire("6BIm3");
function $02d436150130b2b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $02d436150130b2b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $02d436150130b2b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $02d436150130b2b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $02d436150130b2b5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $02d436150130b2b5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $02d436150130b2b5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $02d436150130b2b5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $02d436150130b2b5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $02d436150130b2b5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $02d436150130b2b5$var$interactionBuffer = [];
var $02d436150130b2b5$var$bufferInteractionData = function bufferInteractionData(interactionId, data) {
    $02d436150130b2b5$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $02d436150130b2b5$var$clearInteractionBuffer() {
    $02d436150130b2b5$var$interactionBuffer.length = 0;
}
function $02d436150130b2b5$var$appendInteractionData(interactionId, data) {
    $02d436150130b2b5$var$bufferInteractionData(interactionId, data);
}
function $02d436150130b2b5$export$c8a9e17ae62a073d(handler) {
    var _iterator = $02d436150130b2b5$var$_createForOfIteratorHelper($02d436150130b2b5$var$interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, _interactionId = _step$value.interactionId, data = _step$value.data;
            handler(_interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    $02d436150130b2b5$var$clearInteractionBuffer();
    $02d436150130b2b5$var$bufferInteractionData = handler;
}
function $02d436150130b2b5$export$7aa99c40634ac65f(sinkFn) {
    $02d436150130b2b5$export$c8a9e17ae62a073d(sinkFn);
}
function $02d436150130b2b5$export$1aed449484dedf63(interactionId, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (data.ufoName) {
        data.end = endTime;
        $02d436150130b2b5$var$appendInteractionData(interactionId, data);
        $02d436150130b2b5$var$clearInteractionBuffer();
    }
}
var $02d436150130b2b5$export$f9a59f57e0282541 = /*#__PURE__*/ function() {
    function ExperimentalVCMetrics() {
        (0, $zhrfT.default)(this, ExperimentalVCMetrics);
        (0, $gNkVH.default)(this, "vcObserver", null);
    }
    return (0, $j9c2S.default)(ExperimentalVCMetrics, [
        {
            key: "initialize",
            value: function initialize(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $6BIm3.VCObserver)($02d436150130b2b5$var$_objectSpread($02d436150130b2b5$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
                return this;
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        }
    ]);
}();
var $02d436150130b2b5$export$81b28dca2587ec47 = new $02d436150130b2b5$export$f9a59f57e0282541();
function $02d436150130b2b5$export$d17d2b5c5e8d732e(_x) {
    return $02d436150130b2b5$var$_getExperimentalVCMetrics.apply(this, arguments);
}
function $02d436150130b2b5$var$_getExperimentalVCMetrics() {
    $02d436150130b2b5$var$_getExperimentalVCMetrics = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(interaction) {
        var vcObserver, pageVisibilityUpToTTAI, _interaction$apdex, prefix, result, VC;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
                    vcObserver = interaction.experimentalVCObserver || $02d436150130b2b5$export$81b28dca2587ec47.vcObserver;
                    pageVisibilityUpToTTAI = (0, $4gtBF.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!vcObserver) {
                        _context.next = 13;
                        break;
                    }
                    prefix = 'ufo-experimental';
                    _context.next = 6;
                    return vcObserver.getVCResult({
                        start: interaction.start,
                        stop: interaction.end,
                        tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
                        isEventAborted: !!interaction.abortReason,
                        prefix: prefix,
                        vc: interaction.vc,
                        experienceKey: interaction.ufoName,
                        interactionId: interaction.id,
                        interactionType: interaction.type,
                        isPageVisible: pageVisibilityUpToTTAI === 'visible',
                        interactionAbortReason: interaction.abortReason
                    });
                case 6:
                    result = _context.sent;
                    VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
                    if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 10:
                    if (!(interaction.abortReason || pageVisibilityUpToTTAI !== 'visible')) {
                        _context.next = 12;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 12:
                    return _context.abrupt("return", $02d436150130b2b5$var$_objectSpread($02d436150130b2b5$var$_objectSpread({}, result), {}, {
                        'metric:experimental:vc90': VC['90']
                    }));
                case 13:
                    return _context.abrupt("return", null);
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $02d436150130b2b5$var$_getExperimentalVCMetrics.apply(this, arguments);
}

});
parcelRegister("4gtBF", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", function () { return $31af9f4b08123bcf$export$754443ce7c615bd7; });
$parcel$export(module.exports, "isOpenedInBackground", function () { return $31af9f4b08123bcf$export$21a1a62a307062f1; });
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", function () { return $31af9f4b08123bcf$export$95f048bd8bcdda23; });
$parcel$export(module.exports, "setupHiddenTimingCapture", function () { return $31af9f4b08123bcf$export$554cefe0f0373da4; });
$parcel$export(module.exports, "getPageVisibilityState", function () { return $31af9f4b08123bcf$export$768b2008623433e1; });
$parcel$export(module.exports, "setupThrottleDetection", function () { return $31af9f4b08123bcf$export$fa0d29a9c87052da; });
$parcel$export(module.exports, "isTabThrottled", function () { return $31af9f4b08123bcf$export$62a28c860277b3bf; });
$parcel$export(module.exports, "getPageVisibilityTimeline", function () { return $31af9f4b08123bcf$export$5a06b84e47ad70d9; });

var $dH1HR = parcelRequire("dH1HR");

var $39c3M = parcelRequire("39c3M");
var $31af9f4b08123bcf$var$timings = [];
var $31af9f4b08123bcf$var$wasHiddenFlag;
var $31af9f4b08123bcf$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
var $31af9f4b08123bcf$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
var $31af9f4b08123bcf$var$openedInBackground = null;
function $31af9f4b08123bcf$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $31af9f4b08123bcf$var$SIZE = 50;
var $31af9f4b08123bcf$var$insertIndex = 0;
function $31af9f4b08123bcf$export$754443ce7c615bd7(startTime, endTime) {
    var _timings$find;
    var earliestHiddenTiming = (_timings$find = $31af9f4b08123bcf$var$timings.find(function(_ref) {
        var hidden = _ref.hidden, time = _ref.time;
        return hidden && time > 0 && time >= startTime && time <= endTime;
    })) === null || _timings$find === void 0 ? void 0 : _timings$find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $31af9f4b08123bcf$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        var entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some(function(entry) {
            return entry.name === 'hidden' && entry.startTime <= $31af9f4b08123bcf$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        });
    } catch (_unused) {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $31af9f4b08123bcf$var$openedInBackground === true;
}
function $31af9f4b08123bcf$var$pushHidden(isPageHiddenFlag, time) {
    $31af9f4b08123bcf$var$timings[$31af9f4b08123bcf$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $31af9f4b08123bcf$var$insertIndex = ($31af9f4b08123bcf$var$insertIndex + 1) % $31af9f4b08123bcf$var$SIZE;
    $31af9f4b08123bcf$var$wasHiddenFlag = isPageHiddenFlag;
}
function $31af9f4b08123bcf$var$handleChange() {
    var isPageHiddenFlag = $31af9f4b08123bcf$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$31af9f4b08123bcf$var$wasHiddenFlag) $31af9f4b08123bcf$var$pushHidden(isPageHiddenFlag);
        $31af9f4b08123bcf$var$wasHiddenFlag = true;
    } else {
        if ($31af9f4b08123bcf$var$wasHiddenFlag) $31af9f4b08123bcf$var$pushHidden(isPageHiddenFlag);
        $31af9f4b08123bcf$var$wasHiddenFlag = false;
    }
}
var $31af9f4b08123bcf$var$hasHiddenTimingBeforeSetup = false;
function $31af9f4b08123bcf$export$95f048bd8bcdda23() {
    return $31af9f4b08123bcf$var$hasHiddenTimingBeforeSetup;
}
function $31af9f4b08123bcf$var$setup() {
    try {
        var results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 || results.forEach(function(result) {
            if ((0, $39c3M.fg)('platform_ufo_use_native_page_visibility_api')) $31af9f4b08123bcf$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $31af9f4b08123bcf$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch (_unused2) {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $dH1HR.bind)(window, {
        type: 'pageshow',
        listener: $31af9f4b08123bcf$var$handleChange
    });
    (0, $dH1HR.bind)(window, {
        type: 'pagehide',
        listener: $31af9f4b08123bcf$var$handleChange
    });
    (0, $dH1HR.bind)(document, {
        type: 'visibilitychange',
        listener: $31af9f4b08123bcf$var$handleChange
    });
}
function $31af9f4b08123bcf$export$554cefe0f0373da4() {
    if (!$31af9f4b08123bcf$var$setupFlag) {
        var isPageHiddenFlag = $31af9f4b08123bcf$var$isPageHidden();
        var setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($31af9f4b08123bcf$var$openedInBackground === null) $31af9f4b08123bcf$var$openedInBackground = isPageHiddenFlag && setupTime < $31af9f4b08123bcf$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $31af9f4b08123bcf$var$pushHidden(isPageHiddenFlag, 0);
        $31af9f4b08123bcf$var$setup();
        $31af9f4b08123bcf$var$setupFlag = true;
    }
}
function $31af9f4b08123bcf$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($31af9f4b08123bcf$var$timings.length === 0) return 'visible';
    var currentSize = $31af9f4b08123bcf$var$timings.length;
    var hiddenState = 'mixed';
    var startIdx = $31af9f4b08123bcf$var$insertIndex;
    var endIdx = $31af9f4b08123bcf$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($31af9f4b08123bcf$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($31af9f4b08123bcf$var$timings[tmpIdx] && $31af9f4b08123bcf$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($31af9f4b08123bcf$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $31af9f4b08123bcf$var$timings[startIdx]) hiddenState = $31af9f4b08123bcf$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
var $31af9f4b08123bcf$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
var $31af9f4b08123bcf$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
var $31af9f4b08123bcf$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
var $31af9f4b08123bcf$var$throttleMeasurements = [];
var $31af9f4b08123bcf$var$throttleInsertIndex = 0;
var $31af9f4b08123bcf$var$throttleIntervalId = null;
var $31af9f4b08123bcf$var$lastThrottleCheckTime = null;
var $31af9f4b08123bcf$var$throttleSetupDone = false;
function $31af9f4b08123bcf$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    var isThrottled = actualElapsed > expectedElapsed * $31af9f4b08123bcf$var$THROTTLE_DRIFT_THRESHOLD;
    $31af9f4b08123bcf$var$throttleMeasurements[$31af9f4b08123bcf$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $31af9f4b08123bcf$var$throttleInsertIndex = ($31af9f4b08123bcf$var$throttleInsertIndex + 1) % $31af9f4b08123bcf$var$THROTTLE_BUFFER_SIZE;
}
function $31af9f4b08123bcf$var$throttleCheckCallback() {
    var currentTime = performance.now();
    if ($31af9f4b08123bcf$var$lastThrottleCheckTime !== null) {
        var actualElapsed = currentTime - $31af9f4b08123bcf$var$lastThrottleCheckTime;
        $31af9f4b08123bcf$var$recordThrottleMeasurement($31af9f4b08123bcf$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $31af9f4b08123bcf$var$lastThrottleCheckTime = currentTime;
}
function $31af9f4b08123bcf$export$fa0d29a9c87052da() {
    if ($31af9f4b08123bcf$var$throttleSetupDone) return;
    $31af9f4b08123bcf$var$throttleSetupDone = true;
    // Record the initial timestamp
    $31af9f4b08123bcf$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $31af9f4b08123bcf$var$throttleIntervalId = setInterval($31af9f4b08123bcf$var$throttleCheckCallback, $31af9f4b08123bcf$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $31af9f4b08123bcf$export$3279694d66e4a1() {
    if ($31af9f4b08123bcf$var$throttleIntervalId !== null) {
        clearInterval($31af9f4b08123bcf$var$throttleIntervalId);
        $31af9f4b08123bcf$var$throttleIntervalId = null;
    }
    $31af9f4b08123bcf$var$lastThrottleCheckTime = null;
    $31af9f4b08123bcf$var$throttleSetupDone = false;
    $31af9f4b08123bcf$var$throttleMeasurements.length = 0;
    $31af9f4b08123bcf$var$throttleInsertIndex = 0;
}
function $31af9f4b08123bcf$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($31af9f4b08123bcf$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(var i = 0; i < $31af9f4b08123bcf$var$throttleMeasurements.length; i++){
        var measurement = $31af9f4b08123bcf$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $31af9f4b08123bcf$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $31af9f4b08123bcf$var$throttleMeasurements.filter(function(measurement) {
        return measurement && measurement.time >= startTime && measurement.time <= endTime;
    });
}
function $31af9f4b08123bcf$export$9332de935653b687(measurement) {
    $31af9f4b08123bcf$var$throttleMeasurements[$31af9f4b08123bcf$var$throttleInsertIndex] = measurement;
    $31af9f4b08123bcf$var$throttleInsertIndex = ($31af9f4b08123bcf$var$throttleInsertIndex + 1) % $31af9f4b08123bcf$var$THROTTLE_BUFFER_SIZE;
}
function $31af9f4b08123bcf$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($31af9f4b08123bcf$var$timings.length === 0) return [];
    var result = [];
    // Find the most recent entry at or before startTime to establish initial state
    var initialEntry;
    var currentSize = $31af9f4b08123bcf$var$timings.length;
    for(var i = 0; i < currentSize; i++){
        var idx = ($31af9f4b08123bcf$var$insertIndex + i) % currentSize;
        var entry = $31af9f4b08123bcf$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(var _i = 0; _i < currentSize; _i++){
        var _idx = ($31af9f4b08123bcf$var$insertIndex + _i) % currentSize;
        var _entry = $31af9f4b08123bcf$var$timings[_idx];
        if (_entry && _entry.time > startTime && _entry.time <= endTime) result.push({
            time: Math.round(_entry.time - startTime),
            hidden: _entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $31af9f4b08123bcf$export$9332de935653b687
};

});
parcelRegister("dH1HR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $lbhxY = parcelRequire("lbhxY");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $lbhxY.bind;
    }
});

var $65V0f = parcelRequire("65V0f");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $65V0f.bindAll;
    }
});

});
parcelRegister("lbhxY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $f6b83c87931d7cc8$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $f6b83c87931d7cc8$var$bind;

});

parcelRegister("65V0f", function(module, exports) {
"use strict";
var $46ff6d50cf965e4a$var$__assign = module.exports && module.exports.__assign || function() {
    $46ff6d50cf965e4a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $46ff6d50cf965e4a$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $lbhxY = parcelRequire("lbhxY");
function $46ff6d50cf965e4a$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $46ff6d50cf965e4a$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $46ff6d50cf965e4a$var$__assign($46ff6d50cf965e4a$var$__assign({}, original), {
        options: $46ff6d50cf965e4a$var$__assign($46ff6d50cf965e4a$var$__assign({}, $46ff6d50cf965e4a$var$toOptions(sharedOptions)), $46ff6d50cf965e4a$var$toOptions(original.options))
    });
    return binding;
}
function $46ff6d50cf965e4a$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $46ff6d50cf965e4a$var$getBinding(original, sharedOptions);
        return (0, $lbhxY.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $46ff6d50cf965e4a$var$bindAll;

});



parcelRegister("6BIm3", function(module, exports) {
$parcel$export(module.exports, "VCObserver", function () { return $4cf89ab2b7ed9325$export$1f70d263701b1d01; });

var $kOzMB = parcelRequire("kOzMB");

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $lrM5r = parcelRequire("lrM5r");

var $6HNZJ = parcelRequire("6HNZJ");

var $c3LVh = parcelRequire("c3LVh");

var $39c3M = parcelRequire("39c3M");

var $03EZb = parcelRequire("03EZb");

var $a48Mt = parcelRequire("a48Mt");

var $3O5xd = parcelRequire("3O5xd");

var $57vXu = parcelRequire("57vXu");

var $3E7yZ = parcelRequire("3E7yZ");

var $7zJ6n = parcelRequire("7zJ6n");

var $4sqTw = parcelRequire("4sqTw");
var $4cf89ab2b7ed9325$var$_excluded = [
    "__debug__element"
];
function $4cf89ab2b7ed9325$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cf89ab2b7ed9325$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cf89ab2b7ed9325$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cf89ab2b7ed9325$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4cf89ab2b7ed9325$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
var $4cf89ab2b7ed9325$var$UNUSED_SECTOR = 0;
function $4cf89ab2b7ed9325$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, $6HNZJ.default)(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, $lrM5r.default)(entry, $4cf89ab2b7ed9325$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $4cf89ab2b7ed9325$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, $zhrfT.default)(this, VCObserver);
        /* abort logic */ (0, $gNkVH.default)(this, "abortReason", {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        });
        (0, $gNkVH.default)(this, "outOfBoundaryInfo", '');
        (0, $gNkVH.default)(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, $gNkVH.default)(this, "arraySize", 0);
        (0, $gNkVH.default)(this, "componentsLog", {});
        (0, $gNkVH.default)(this, "vcRatios", {});
        (0, $gNkVH.default)(this, "active", false);
        (0, $gNkVH.default)(this, "totalTime", 0);
        (0, $gNkVH.default)(this, "startTime", 0);
        (0, $gNkVH.default)(this, "_startMeasureTimestamp", -1);
        (0, $gNkVH.default)(this, "ssr", {
            reactRendered: -1
        });
        (0, $gNkVH.default)(this, "unbind", []);
        (0, $gNkVH.default)(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, $gNkVH.default)(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $4cf89ab2b7ed9325$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $4cf89ab2b7ed9325$var$_objectSpread({}, _this.componentsLog),
                viewport: $4cf89ab2b7ed9325$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, $gNkVH.default)(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, experienceKey, interactionId, includeSSRRatio, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, isTTVCv1Disabled, vcAbortedResultWithRevisions, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, shouldCreateDebugDetails, v1RevisionDebugDetails, v2RevisionDebugDetails, _window$__ufo_devtool2, _window2, _window$__ufo_devtool, _window, _window$__on_ufo_vc_d2, _window4, _window$__on_ufo_vc_d, _window3, isVCClean, revisionsData, speedIndex, SSRRatio, SSRRatioNext, SSRRatioPayload, isTTVCv3Enabled;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted, experienceKey = _ref3.experienceKey, interactionId = _ref3.interactionId, includeSSRRatio = _ref3.includeSSRRatio;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 6;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 6:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
                            isTTVCv1Disabled = !(0, $03EZb.isVCRevisionEnabled)('fy25.01', experienceKey);
                            if (!(abortReasonInfo !== null)) {
                                _context.next = 13;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (_unused) {}
                            vcAbortedResultWithRevisions = (0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:rev"), [
                                {
                                    revision: 'fy25.02',
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: abortReason.reason,
                                    abortTimestamp: Math.round(abortReason.timestamp)
                                }
                            ]);
                            if (!isTTVCv1Disabled) vcAbortedResultWithRevisions["".concat(fullPrefix, "vc:rev")].push({
                                revision: 'fy25.01',
                                clean: false,
                                'metric:vc90': null,
                                abortReason: abortReason.reason,
                                abortTimestamp: Math.round(abortReason.timestamp)
                            });
                            return _context.abrupt("return", vcAbortedResultWithRevisions);
                        case 13:
                            ttvcV1Result = isTTVCv1Disabled ? {
                                VC: {},
                                VCBox: {},
                                VCEntries: {
                                    abs: [],
                                    rel: [],
                                    speedIndex: -1
                                },
                                totalPainted: -1
                            } : VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $4cf89ab2b7ed9325$var$_objectSpread({}, componentsLog),
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                            _componentsLog = {};
                            Object.entries(_this.componentsLog).forEach(function(_ref5) {
                                var _ref6 = (0, $6HNZJ.default)(_ref5, 2), _timestamp = _ref6[0], value = _ref6[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            outOfBoundary = outOfBoundaryInfo ? (0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': VC['75'],
                                            '80': VC['80'],
                                            '85': VC['85'],
                                            '90': VC['90'],
                                            '95': VC['95'],
                                            '98': VC['98'],
                                            '99': VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    ttvcV2DevToolInfo = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': vcNext.VC['75'],
                                            '80': vcNext.VC['80'],
                                            '85': vcNext.VC['85'],
                                            '90': vcNext.VC['90'],
                                            '95': vcNext.VC['95'],
                                            '98': vcNext.VC['98'],
                                            '99': vcNext.VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    if (isTTVCv1Disabled) {
                                        window.__vc = ttvcV2DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    } else {
                                        window.__vc = ttvcV1DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    }
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent('vcReady', {
                                        detail: {
                                            log: $4cf89ab2b7ed9325$var$filterComponentsLog(componentsLog),
                                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                        }
                                    }));
                                }
                                if (!_this.isPostInteraction) {
                                    // Only create revision debug details if callbacks exist
                                    shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                                    if (shouldCreateDebugDetails) {
                                        v1RevisionDebugDetails = (0, $57vXu.getVCRevisionDebugDetails)({
                                            revision: 'fy25.01',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        });
                                        v2RevisionDebugDetails = (0, $57vXu.getVCRevisionDebugDetails)({
                                            revision: 'fy25.02',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: vcNext.VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        }); // Add devtool callback for both v1 and v2
                                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                                            // Handle v1 if not disabled
                                            if (!isTTVCv1Disabled) (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                                            // Handle v2
                                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                                        }
                                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                                            if (!isTTVCv1Disabled) (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                                        }
                                    }
                                }
                            } catch (_unused2) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            revisionsData = (0, $3E7yZ.getVCRevisionsData)({
                                fullPrefix: fullPrefix,
                                interaction: {
                                    start: start,
                                    end: stop
                                },
                                isVCClean: isVCClean,
                                calculatedVC: {
                                    VC: VC,
                                    VCBox: VCBox
                                },
                                calculatedVCNext: {
                                    VC: vcNext.VC,
                                    VCBox: vcNext.VCBox
                                },
                                isEventAborted: isEventAborted,
                                experienceKey: experienceKey,
                                ratios: ratios
                            });
                            speedIndex = (0, $gNkVH.default)((0, $gNkVH.default)({}, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            SSRRatio = VCObserver.getSSRRatio(VCEntries.rel, ssr);
                            SSRRatioNext = VCObserver.getSSRRatio(vcNext.VCEntries.rel, ssr);
                            SSRRatioPayload = includeSSRRatio ? (0, $gNkVH.default)((0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:ssrRatio"), isTTVCv1Disabled ? SSRRatioNext : SSRRatio), "".concat(fullPrefix, "vc:next:ssrRatio"), SSRRatioNext) : {};
                            if (!isTTVCv1Disabled) {
                                _context.next = 29;
                                break;
                            }
                            return _context.abrupt("return", $4cf89ab2b7ed9325$var$_objectSpread($4cf89ab2b7ed9325$var$_objectSpread($4cf89ab2b7ed9325$var$_objectSpread($4cf89ab2b7ed9325$var$_objectSpread((0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), SSRRatioPayload), {}, (0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:ssrRatio"), SSRRatioNext), revisionsData), speedIndex));
                        case 29:
                            isTTVCv3Enabled = (0, $03EZb.isVCRevisionEnabled)('fy25.03', experienceKey);
                            return _context.abrupt("return", $4cf89ab2b7ed9325$var$_objectSpread($4cf89ab2b7ed9325$var$_objectSpread($4cf89ab2b7ed9325$var$_objectSpread($4cf89ab2b7ed9325$var$_objectSpread((0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)({
                                'metrics:vc': VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), "".concat(fullPrefix, "vc:ssrRatio"), SSRRatio), outOfBoundary), {}, (0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), SSRRatioPayload), {}, (0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), speedIndex));
                        case 31:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, $gNkVH.default)(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var interaction = (0, $a48Mt.getActiveInteraction)();
                var isTTVCv1Disabled = !(0, $03EZb.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        });
        (0, $gNkVH.default)(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === '') {
                var outOfBoundaryInfo = '';
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, $gNkVH.default)(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, $gNkVH.default)(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case 'wheel':
                    _this.setAbortReason($4cf89ab2b7ed9325$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $39c3M.fg)('platform_ufo_keypress_interaction_abort')) {
                        var interaction = (0, $a48Mt.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    _this.setAbortReason($4cf89ab2b7ed9325$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    _this.setAbortReason($4cf89ab2b7ed9325$var$abortReason.resize, time);
                    break;
            }
        });
        (0, $gNkVH.default)(this, "attachAbortListeners", function() {
            var _window5;
            _this.detachAbortListeners();
            var unbinds = (0, $3O5xd.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref9) {
                var _ref0 = (0, $6HNZJ.default)(_ref9, 2), key = _ref0[0], time = _ref0[1];
                if (time) _this.abortReasonCallback(key, time);
            });
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        var ssrEnablePageLayoutPlaceholder = options.ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler = options.ssrPlaceholderHandler;
        this.observers = new (0, $4sqTw.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $03EZb.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    return (0, $j9c2S.default)(VCObserver, [
        {
            key: "start",
            value: function start(_ref1) {
                var startTime = _ref1.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason('not-supported', startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref10) {
                    var ignoreReason = _ref10.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref11) {
                    var targetName = _ref11.targetName, ignoreReason = _ref11.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $4cf89ab2b7ed9325$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: '',
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = !(0, $03EZb.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill('').map(function() {
                    return Array(_this2.arraySize).fill($4cf89ab2b7ed9325$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $7zJ6n.getViewportWidth)();
                this.viewport.h = (0, $7zJ6n.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($4cf89ab2b7ed9325$var$abortReason.error, time, "index - ".concat(row));
                        } catch (_unused3) {
                            this.setAbortReason($4cf89ab2b7ed9325$var$abortReason.error, time, 'row error');
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                if (this.unbind) {
                    var unbind = this.unbind;
                    for(var i = 0; i < unbind.length; i++)unbind[i]();
                    this.unbind.length = 0;
                }
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "getSSRRatio",
            value: function getSSRRatio(entries, ssr) {
                if (ssr === undefined || entries.length === 0) return undefined;
                var maybeSSR = entries[0];
                if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
                return 0;
            }
        },
        {
            key: "calculateVC",
            value: function calculateVC(_ref12) {
                var heatmap = _ref12.heatmap, _ref12$ssr = _ref12.ssr, ssr = _ref12$ssr === void 0 ? $4cf89ab2b7ed9325$var$UNUSED_SECTOR : _ref12$ssr, componentsLog = _ref12.componentsLog, viewport = _ref12.viewport, fixSSRAttribution = _ref12.fixSSRAttribution;
                var lastUpdate = {};
                var totalPainted = 0;
                var ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
                if (ssrTime !== $4cf89ab2b7ed9325$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: 'SSR'
                    };
                    if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
                    componentsLog[ssrTime].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $4cf89ab2b7ed9325$var$UNUSED_SECTOR && ssrTime !== $4cf89ab2b7ed9325$var$UNUSED_SECTOR ? ssrTime : entry);
                        totalPainted += rounded !== $4cf89ab2b7ed9325$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $4cf89ab2b7ed9325$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var currRatio = v[1] / totalPainted;
                    var VCRatio = currRatio + acc;
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (0, $kOzMB.default)(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter(function(v) {
                                return !v.ignoreReason;
                            }).map(function(v) {
                                return v.targetName;
                            })));
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref13, i) {
                    var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
                    var _ref14 = (0, $6HNZJ.default)(_ref13, 2), timestamp = _ref14[0], entryPainted = _ref14[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (0, $kOzMB.default)(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter(function(v) {
                        return !v.ignoreReason;
                    }).map(function(v) {
                        return v.targetName;
                    })));
                    var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
                    var speedIndex = timestamp * ratioDelta;
                    acc.speedIndex += speedIndex;
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: [],
                    speedIndex: 0
                });
                VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
}();
/** config * */ (0, $gNkVH.default)($4cf89ab2b7ed9325$export$1f70d263701b1d01, "VCParts", [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
]);

});
parcelRegister("lrM5r", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9d16b999c050358$export$2e2bcd8739ae039; });

var $gDn4x = parcelRequire("gDn4x");
function $f9d16b999c050358$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $gDn4x.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("gDn4x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c1c22f7ef6cf67d1$export$2e2bcd8739ae039; });
function $c1c22f7ef6cf67d1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("a48Mt", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", function () { return $754116c580521ac6$export$dbba6cdedab4e68b; });
$parcel$export(module.exports, "postInteractionLog", function () { return $754116c580521ac6$export$d8f52e8f804021e8; });
$parcel$export(module.exports, "interactionExtraMetrics", function () { return $754116c580521ac6$export$481f88116dc8b7ad; });
$parcel$export(module.exports, "segmentUnmountCache", function () { return $754116c580521ac6$export$a2b14406ded37d60; });
$parcel$export(module.exports, "getActiveInteraction", function () { return $754116c580521ac6$export$2b3954d2e8509985; });
$parcel$export(module.exports, "remove", function () { return $754116c580521ac6$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "updatePageLoadInteractionName", function () { return $754116c580521ac6$export$f6f1cf5bedf83c71; });
$parcel$export(module.exports, "addCustomData", function () { return $754116c580521ac6$export$e4380431c2bdabee; });
$parcel$export(module.exports, "addCustomTiming", function () { return $754116c580521ac6$export$27cacb7d7f3fe20a; });
$parcel$export(module.exports, "addMark", function () { return $754116c580521ac6$export$728e28c22a0fba4; });
$parcel$export(module.exports, "markFirstSegmentLoad", function () { return $754116c580521ac6$export$85d1eb835f669bf; });
$parcel$export(module.exports, "addSpan", function () { return $754116c580521ac6$export$2c1d6e17cfa9bbc7; });
$parcel$export(module.exports, "addHold", function () { return $754116c580521ac6$export$7606887303596f82; });
$parcel$export(module.exports, "addHoldByID", function () { return $754116c580521ac6$export$10582acd678c213; });
$parcel$export(module.exports, "removeHoldByID", function () { return $754116c580521ac6$export$4983dfbbb996f7ae; });
$parcel$export(module.exports, "getCurrentInteractionType", function () { return $754116c580521ac6$export$2df109852219d16e; });
$parcel$export(module.exports, "addError", function () { return $754116c580521ac6$export$239c33984d9b1367; });
$parcel$export(module.exports, "addProfilerTimings", function () { return $754116c580521ac6$export$53d6f611de951a13; });
$parcel$export(module.exports, "sinkInteractionHandler", function () { return $754116c580521ac6$export$9e614a29a1ac213e; });
$parcel$export(module.exports, "sinkPostInteractionLogHandler", function () { return $754116c580521ac6$export$8a1ba7bef607358a; });
$parcel$export(module.exports, "tryComplete", function () { return $754116c580521ac6$export$673be905888f8839; });
$parcel$export(module.exports, "abort", function () { return $754116c580521ac6$export$5def58af4fd46132; });
$parcel$export(module.exports, "abortByNewInteraction", function () { return $754116c580521ac6$export$c4a545284f55edf2; });
$parcel$export(module.exports, "abortAll", function () { return $754116c580521ac6$export$614a7af2affc5dff; });
$parcel$export(module.exports, "addNewInteraction", function () { return $754116c580521ac6$export$1a1ed1e1fdb2006b; });
$parcel$export(module.exports, "addApdex", function () { return $754116c580521ac6$export$35220fd6cdd1b731; });
$parcel$export(module.exports, "addRequestInfo", function () { return $754116c580521ac6$export$57d55b4569823d8f; });
$parcel$export(module.exports, "addSegment", function () { return $754116c580521ac6$export$1c43f9ac826b6462; });
$parcel$export(module.exports, "removeSegment", function () { return $754116c580521ac6$export$d0365e48b58231c3; });
$parcel$export(module.exports, "interactionSpans", function () { return $754116c580521ac6$export$6ce04c7ca6810a7e; });

var $eAzuA = parcelRequire("eAzuA");

var $6HNZJ = parcelRequire("6HNZJ");

var $gNkVH = parcelRequire("gNkVH");

var $kOzMB = parcelRequire("kOzMB");

var $c3LVh = parcelRequire("c3LVh");

var $jFqL6 = parcelRequire("jFqL6");

var $39c3M = parcelRequire("39c3M");

var $as5v9 = parcelRequire("as5v9");

var $03EZb = parcelRequire("03EZb");

var $f3CCR = parcelRequire("f3CCR");

var $ndMIw = parcelRequire("ndMIw");

var $hij2V = parcelRequire("hij2V");

var $bMbcH = parcelRequire("bMbcH");

var $ak0Ep = parcelRequire("ak0Ep");

var $1BTY2 = parcelRequire("1BTY2");

var $88sSl = parcelRequire("88sSl");

var $4PhwH = parcelRequire("4PhwH");

var $kpqve = parcelRequire("kpqve");

var $48vrX = parcelRequire("48vrX");

var $lgv6U = parcelRequire("lgv6U");
function $754116c580521ac6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $754116c580521ac6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $754116c580521ac6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $754116c580521ac6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $754116c580521ac6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $754116c580521ac6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $754116c580521ac6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $754116c580521ac6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $754116c580521ac6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $754116c580521ac6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $754116c580521ac6$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
var $754116c580521ac6$export$d8f52e8f804021e8 = new (0, $lgv6U.default)();
var $754116c580521ac6$export$481f88116dc8b7ad = new (0, $48vrX.default)();
var $754116c580521ac6$var$interactionQueue = [];
var $754116c580521ac6$var$segmentCache = new Map();
var $754116c580521ac6$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
var $754116c580521ac6$var$firstSegmentLoadMarked = false;
var $754116c580521ac6$var$segmentObservers = [];
function $754116c580521ac6$export$2b3954d2e8509985() {
    var interactionId = (0, $1BTY2.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $kpqve.interactions).get(interactionId.current);
}
function $754116c580521ac6$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $03EZb.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
var $754116c580521ac6$var$performanceEventObserver;
var $754116c580521ac6$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $754116c580521ac6$var$performanceEventObserver = $754116c580521ac6$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $754116c580521ac6$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === 'click') $754116c580521ac6$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $754116c580521ac6$var$performanceEventObserver;
};
var $754116c580521ac6$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = $754116c580521ac6$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $754116c580521ac6$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, $kOzMB.default)(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $754116c580521ac6$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return 'segmentId' in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $754116c580521ac6$var$addSegmentObserver(observer) {
    $754116c580521ac6$var$segmentObservers.push(observer);
    var _iterator2 = $754116c580521ac6$var$_createForOfIteratorHelper($754116c580521ac6$var$segmentCache.values()), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var segmentInfo = _step2.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $754116c580521ac6$var$removeSegmentObserver(observer) {
    var index = $754116c580521ac6$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $754116c580521ac6$var$segmentObservers.splice(index, 1);
}
function $754116c580521ac6$export$cd7f480d6b8286c3(interactionId) {
    (0, $kpqve.interactions).delete(interactionId);
}
function $754116c580521ac6$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $754116c580521ac6$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $754116c580521ac6$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $754116c580521ac6$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, $gNkVH.default)({}, i, data[i])
        });
    });
}
function $754116c580521ac6$export$20265b12c6625451(interactionId, key, value) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $754116c580521ac6$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($754116c580521ac6$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, $6HNZJ.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($754116c580521ac6$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch (_unused) {
            // do nothing
            }
        }
    }
}
function $754116c580521ac6$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($754116c580521ac6$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($754116c580521ac6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $754116c580521ac6$export$85d1eb835f669bf(interactionId, labelStack) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (!(0, $39c3M.fg)('platform_mark_ufo_segment_first_load')) return;
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null && !$754116c580521ac6$var$firstSegmentLoadMarked) {
        $754116c580521ac6$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function $754116c580521ac6$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $kpqve.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($754116c580521ac6$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($754116c580521ac6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $754116c580521ac6$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($754116c580521ac6$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($754116c580521ac6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch (_unused2) {
        // do nothing
        }
    }
}
function $754116c580521ac6$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $kpqve.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($754116c580521ac6$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($754116c580521ac6$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch (_unused3) {
    // do nothing
    }
}
function $754116c580521ac6$export$9e04fe1a58571ec(moduleId, timestamp) {
    $754116c580521ac6$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $754116c580521ac6$export$6f228d1fdc911d7(identifier, start, end) {
    $754116c580521ac6$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
var $754116c580521ac6$var$moduleLoadingRequests = {};
function $754116c580521ac6$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $754116c580521ac6$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $754116c580521ac6$var$labelStackToString(labelStack), name, startTime);
}
function $754116c580521ac6$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $754116c580521ac6$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var id = (0, $jFqL6.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $754116c580521ac6$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        var is3pHold = labelStack.some(function(l) {
            return 'type' in l && l.type === 'third-party';
        });
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, $754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, holdActive), {}, {
                start: start
            }));
        } else {
            interaction.holdActive.set(id, $754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, holdActive), {}, {
                start: start
            }));
            $754116c580521ac6$var$addHoldCriterion(id, labelStack, name, start);
        }
        return function() {
            var end = performance.now();
            if ($754116c580521ac6$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($754116c580521ac6$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch (_unused4) {
            // do nothing
            }
            $754116c580521ac6$var$removeHoldCriterion(id);
            var currentInteraction = (0, $kpqve.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            var expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push($754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, expHold), {}, {
                        end: end
                    }));
                    interaction.holdExpActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    var current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push($754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, current3pHold), {}, {
                            end: end
                        }));
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return function() {};
}
function $754116c580521ac6$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        var is3pHold = labelStack.some(function(l) {
            return 'type' in l && l.type === 'third-party';
        });
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $754116c580521ac6$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return function() {};
}
function $754116c580521ac6$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $kpqve.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $754116c580521ac6$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            var current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push($754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, current3pHold), {}, {
                    end: end
                }));
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $754116c580521ac6$export$2df109852219d16e(interactionId) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $754116c580521ac6$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $754116c580521ac6$export$9e04fe1a58571ec($754116c580521ac6$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $754116c580521ac6$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $754116c580521ac6$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $754116c580521ac6$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $754116c580521ac6$var$moduleLoadingRequests[info.identifier];
            $754116c580521ac6$export$6f228d1fdc911d7($754116c580521ac6$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $1BTY2.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $754116c580521ac6$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $1BTY2.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $754116c580521ac6$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $754116c580521ac6$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $754116c580521ac6$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $kpqve.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $754116c580521ac6$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($754116c580521ac6$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($754116c580521ac6$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch (_unused5) {
    // do nothing
    }
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $03EZb.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $754116c580521ac6$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $754116c580521ac6$var$pushToQueue(id, data) {
    $754116c580521ac6$var$interactionQueue.push({
        id: id,
        data: data
    });
}
var $754116c580521ac6$var$handleInteraction = $754116c580521ac6$var$pushToQueue;
function $754116c580521ac6$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
function $754116c580521ac6$var$finishInteraction(id, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark("TTAI", {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch (_unused6) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $ak0Ep.currentFeatureFlagsAccessed));
    (0, $bMbcH.clearActiveTrace)();
    $754116c580521ac6$var$callCleanUpCallbacks(data);
    (0, $88sSl.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $03EZb.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    var sanitisedUfoName = (0, $hij2V.sanitizeUfoName)(data.ufoName);
    if (!(0, $as5v9.default)((0, $03EZb.getPostInteractionRate)(sanitisedUfoName, data.type))) $754116c580521ac6$export$d8f52e8f804021e8.stopVCObserver();
    if (!(0, $as5v9.default)((0, $03EZb.getExtraInteractionRate)(sanitisedUfoName, data.type))) $754116c580521ac6$export$481f88116dc8b7ad.stopAll(id);
    else if (!data.hold3pActive || data.hold3pActive.size === 0) {
        var _getConfig3;
        if (!((_getConfig3 = (0, $03EZb.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.experimentalInteractionMetrics) !== null && _getConfig3 !== void 0 && _getConfig3.enabled)) $754116c580521ac6$export$cd7f480d6b8286c3(id);
    }
    if ((0, $39c3M.fg)('platform_ufo_enable_terminal_errors')) {
        $754116c580521ac6$export$dbba6cdedab4e68b.id = data.id;
        $754116c580521ac6$export$dbba6cdedab4e68b.type = data.type;
        $754116c580521ac6$export$dbba6cdedab4e68b.timestamp = data.end;
    }
    $754116c580521ac6$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $754116c580521ac6$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) {
        var _interactionExtraMetr;
        if (((_interactionExtraMetr = $754116c580521ac6$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr === void 0 ? void 0 : _interactionExtraMetr.id) !== id) // If this same interaction was not already handled, handle it
        $754116c580521ac6$var$handleInteraction(id, data);
    }
    if ($754116c580521ac6$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $754116c580521ac6$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator3 = $754116c580521ac6$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _step3$value = (0, $6HNZJ.default)(_step3.value, 2), _step3$value$ = _step3$value[1], labelStack = _step3$value$.labelStack, start = _step3$value$.start, end = _step3$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($754116c580521ac6$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end,
                        detail: {
                            devtools: {
                                track: "\uD83D\uDEF8 reactUFO detailed timings",
                                color: 'secondary-dark'
                            }
                        }
                    });
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        } catch (_unused7) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (_unused8) {
    // do nothing
    }
}
function $754116c580521ac6$export$9e614a29a1ac213e(sinkFn) {
    if ($754116c580521ac6$var$handleInteraction === $754116c580521ac6$var$pushToQueue) {
        $754116c580521ac6$var$handleInteraction = sinkFn;
        $754116c580521ac6$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $754116c580521ac6$var$interactionQueue.length = 0;
    }
}
function $754116c580521ac6$export$8a1ba7bef607358a(sinkFn) {
    $754116c580521ac6$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
var $754116c580521ac6$var$activeSubmitted = false;
function $754116c580521ac6$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc;
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var noMoreExpHolds = interaction.holdExpActive.size === 0;
        var shouldUseRawDataThirdParty = (0, $03EZb.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var postInteraction = /*#__PURE__*/ function() {
            var _ref = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee() {
                var _getConfig4, _interactionExtraMetr2;
                var _getConfig5, experimentalVC90, experimentalTTAI, _yield$getExperimenta, start, end, _getConfig6;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!((_getConfig4 = (0, $03EZb.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.postInteractionLog) !== null && _getConfig4 !== void 0 && _getConfig4.enabled)) {
                                _context.next = 17;
                                break;
                            }
                            if (!((_getConfig5 = (0, $03EZb.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.experimentalInteractionMetrics) !== null && _getConfig5 !== void 0 && _getConfig5.enabled)) {
                                _context.next = 16;
                                break;
                            }
                            _context.next = 4;
                            return (0, $f3CCR.getExperimentalVCMetrics)(interaction);
                        case 4:
                            _context.t1 = _yield$getExperimenta = _context.sent;
                            _context.t0 = _context.t1 === null;
                            if (_context.t0) {
                                _context.next = 8;
                                break;
                            }
                            _context.t0 = _yield$getExperimenta === void 0;
                        case 8:
                            if (!_context.t0) {
                                _context.next = 12;
                                break;
                            }
                            _context.t2 = void 0;
                            _context.next = 13;
                            break;
                        case 12:
                            _context.t2 = _yield$getExperimenta['metric:experimental:vc90'];
                        case 13:
                            experimentalVC90 = _context.t2;
                            start = interaction.start, end = interaction.end;
                            experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                        case 16:
                            $754116c580521ac6$export$d8f52e8f804021e8.onInteractionComplete($754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, interaction), {}, {
                                experimentalTTAI: experimentalTTAI,
                                experimentalVC90: experimentalVC90
                            }));
                        case 17:
                            if (((_interactionExtraMetr2 = $754116c580521ac6$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr2 === void 0 ? void 0 : _interactionExtraMetr2.id) !== interactionId) // If interactionExtraMetrics is not waiting for measuring this interaction
                            {
                                if ((_getConfig6 = (0, $03EZb.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.experimentalInteractionMetrics) !== null && _getConfig6 !== void 0 && _getConfig6.enabled) $754116c580521ac6$export$cd7f480d6b8286c3(interactionId);
                            }
                            $754116c580521ac6$var$activeSubmitted = false;
                        case 19:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref.apply(this, arguments);
            };
        }();
        var noMoreActive3pHolds = ((_interaction$hold3pAc = interaction.hold3pActive) === null || _interaction$hold3pAc === void 0 ? void 0 : _interaction$hold3pAc.size) === 0 || interaction.hold3pActive === undefined;
        // If using raw data third party behavior, wait for 3p holds to clear
        if (shouldUseRawDataThirdParty) {
            // If there are no non-3p holds active, mark the interaction as successful
            // but don't finish until 3p holds are cleared
            if (noMoreActiveHolds && !noMoreActive3pHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                // Wait for 3p holds to clear before finishing
                return;
            }
            // If all holds (including 3p) are cleared, finish the interaction
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                if (!$754116c580521ac6$var$activeSubmitted) {
                    var _getConfig7, _getConfig8, _getConfig9;
                    // Set end3p to current time when 3p holds cleared, but ensure it's at least interaction.end
                    var currentTime = endTime !== null && endTime !== void 0 ? endTime : performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    $754116c580521ac6$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((_getConfig7 = (0, $03EZb.getConfig)()) !== null && _getConfig7 !== void 0 && (_getConfig7 = _getConfig7.extraInteractionMetrics) !== null && _getConfig7 !== void 0 && _getConfig7.enabled) $754116c580521ac6$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig8 = (0, $03EZb.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.extraSearchPageInteraction) !== null && _getConfig8 !== void 0 && _getConfig8.enabled && interaction.ufoName === ((_getConfig9 = (0, $03EZb.getConfig)()) === null || _getConfig9 === void 0 || (_getConfig9 = _getConfig9.extraSearchPageInteraction) === null || _getConfig9 === void 0 ? void 0 : _getConfig9.searchPageMetricName)) (0, $ndMIw.onSearchPageInteractionComplete)(interactionId, interaction);
                    $754116c580521ac6$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig0;
                    if ((_getConfig0 = (0, $03EZb.getConfig)()) !== null && _getConfig0 !== void 0 && (_getConfig0 = _getConfig0.experimentalInteractionMetrics) !== null && _getConfig0 !== void 0 && _getConfig0.enabled) (0, $f3CCR.onExperimentalInteractionComplete)(interactionId, interaction, endTime || interaction.end);
                    postInteraction();
                }
            }
            // Send separated third-party event even when feature flag is active
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                var data = $754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, interaction), {}, {
                    end: endTime || interaction.end
                });
                $754116c580521ac6$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else {
            var _interactionExtraMetr3;
            // Original behavior when feature flag is not active
            if (noMoreActiveHolds && ((_interactionExtraMetr3 = $754116c580521ac6$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr3 === void 0 ? void 0 : _interactionExtraMetr3.id) !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$754116c580521ac6$var$activeSubmitted) {
                    var _getConfig1, _getConfig10, _getConfig11;
                    $754116c580521ac6$var$finishInteraction(interactionId, interaction, endTime);
                    if ((_getConfig1 = (0, $03EZb.getConfig)()) !== null && _getConfig1 !== void 0 && (_getConfig1 = _getConfig1.extraInteractionMetrics) !== null && _getConfig1 !== void 0 && _getConfig1.enabled) $754116c580521ac6$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig10 = (0, $03EZb.getConfig)()) !== null && _getConfig10 !== void 0 && (_getConfig10 = _getConfig10.extraSearchPageInteraction) !== null && _getConfig10 !== void 0 && _getConfig10.enabled && interaction.ufoName === ((_getConfig11 = (0, $03EZb.getConfig)()) === null || _getConfig11 === void 0 || (_getConfig11 = _getConfig11.extraSearchPageInteraction) === null || _getConfig11 === void 0 ? void 0 : _getConfig11.searchPageMetricName)) (0, $ndMIw.onSearchPageInteractionComplete)(interactionId, interaction);
                    $754116c580521ac6$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig12;
                    if ((_getConfig12 = (0, $03EZb.getConfig)()) !== null && _getConfig12 !== void 0 && (_getConfig12 = _getConfig12.experimentalInteractionMetrics) !== null && _getConfig12 !== void 0 && _getConfig12.enabled) (0, $f3CCR.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                    postInteraction();
                }
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                var _data2 = $754116c580521ac6$var$_objectSpread($754116c580521ac6$var$_objectSpread({}, interaction), {}, {
                    end: endTime
                });
                $754116c580521ac6$export$481f88116dc8b7ad.onInteractionComplete(interactionId, _data2);
            }
        }
    }
}
function $754116c580521ac6$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $754116c580521ac6$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        var shouldUseRawDataThirdParty = (0, $03EZb.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $754116c580521ac6$var$finishInteraction(interactionId, interaction, endTime);
            $754116c580521ac6$export$d8f52e8f804021e8.reset();
            $754116c580521ac6$export$d8f52e8f804021e8.stopVCObserver();
            $754116c580521ac6$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $as5v9.default)((0, $03EZb.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $f3CCR.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $754116c580521ac6$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $754116c580521ac6$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $754116c580521ac6$var$finishInteraction(interactionId, interaction);
        $754116c580521ac6$export$d8f52e8f804021e8.reset();
        $754116c580521ac6$export$d8f52e8f804021e8.stopVCObserver();
        $754116c580521ac6$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $as5v9.default)((0, $03EZb.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $f3CCR.onExperimentalInteractionComplete)(interactionId, interaction);
            $754116c580521ac6$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $754116c580521ac6$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        var shouldUseRawDataThirdParty = (0, $03EZb.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $754116c580521ac6$var$finishInteraction(interactionId, interaction, endTime);
            $754116c580521ac6$export$d8f52e8f804021e8.reset();
            $754116c580521ac6$export$d8f52e8f804021e8.stopVCObserver();
            $754116c580521ac6$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $as5v9.default)((0, $03EZb.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $f3CCR.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $754116c580521ac6$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $754116c580521ac6$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $754116c580521ac6$var$finishInteraction(interactionId, interaction);
        $754116c580521ac6$export$d8f52e8f804021e8.reset();
        $754116c580521ac6$export$d8f52e8f804021e8.stopVCObserver();
        $754116c580521ac6$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $as5v9.default)((0, $03EZb.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $f3CCR.onExperimentalInteractionComplete)(interactionId, interaction);
            $754116c580521ac6$export$cd7f480d6b8286c3(interactionId);
        }
    } else if ((0, $39c3M.fg)('platform_reset_post_interaction_on_new_interaction')) {
        // post-interaction log is active after interaction is aborted by new one
        $754116c580521ac6$export$d8f52e8f804021e8.reset();
        $754116c580521ac6$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $754116c580521ac6$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    var activeInteraction = $754116c580521ac6$export$2b3954d2e8509985();
    var finishInteractions = (0, $03EZb.getFinishInteractionOnTransition)();
    (0, $kpqve.interactions).forEach(function(interaction, interactionId) {
        var isActiveInteraction = activeInteraction === interaction;
        var hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName)) hasFinished = true;
        var shouldUseRawDataThirdParty = (0, $03EZb.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $754116c580521ac6$var$finishInteraction(interactionId, interaction, endTime);
            $754116c580521ac6$export$d8f52e8f804021e8.reset();
            $754116c580521ac6$export$d8f52e8f804021e8.stopVCObserver();
            $754116c580521ac6$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $as5v9.default)((0, $03EZb.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $f3CCR.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $754116c580521ac6$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        if (!hasFinished) {
            $754116c580521ac6$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $754116c580521ac6$var$finishInteraction(interactionId, interaction);
        $754116c580521ac6$export$d8f52e8f804021e8.reset();
        $754116c580521ac6$export$d8f52e8f804021e8.stopVCObserver();
        $754116c580521ac6$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $as5v9.default)((0, $03EZb.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $f3CCR.onExperimentalInteractionComplete)(interactionId, interaction);
            $754116c580521ac6$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $754116c580521ac6$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $kpqve.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $754116c580521ac6$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _config$extraSearchPa, _config$extraSearchPa2;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    $754116c580521ac6$export$481f88116dc8b7ad.reset();
    $754116c580521ac6$export$d8f52e8f804021e8.reset();
    var vcObserver;
    var previousTime = startTime;
    var timeoutTime = (0, $03EZb.getInteractionTimeout)(ufoName);
    var timerID = setTimeout(function() {
        $754116c580521ac6$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $754116c580521ac6$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $as5v9.default)((0, $03EZb.getCapabilityRate)('feature_flag_access'));
    var config = (0, $03EZb.getConfig)();
    var searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 || (_config$extraSearchPa = config.extraSearchPageInteraction) === null || _config$extraSearchPa === void 0 ? void 0 : _config$extraSearchPa.enabled,
        searchPageRoute: config === null || config === void 0 || (_config$extraSearchPa2 = config.extraSearchPageInteraction) === null || _config$extraSearchPa2 === void 0 ? void 0 : _config$extraSearchPa2.searchPageRoute
    };
    if (config && config.vc) {
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $4PhwH.newVCObserver)(vcOptions);
    }
    var priorAccessedFg = type === 'press' && (0, $39c3M.fg)('platform_ufo_drop_prior_fg_interactions') ? {} : Object.fromEntries((0, $ak0Ep.allFeatureFlagsAccessed));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $754116c580521ac6$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $754116c580521ac6$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $ak0Ep.currentFeatureFlagsAccessed).clear();
    (0, $kpqve.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $754116c580521ac6$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $754116c580521ac6$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(function() {
        vcObserver.stop(ufoName);
    });
    var awaitBM3TTIList = (0, $03EZb.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $754116c580521ac6$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig13, _config$extraInteract;
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig13 = (0, $03EZb.getConfig)()) !== null && _getConfig13 !== void 0 && (_getConfig13 = _getConfig13.postInteractionLog) !== null && _getConfig13 !== void 0 && _getConfig13.enabled) $754116c580521ac6$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $as5v9.default)((0, $03EZb.getExperimentalInteractionRate)(ufoName, type))) (0, $f3CCR.experimentalVC).start({
            startTime: startTime
        });
        if (config !== null && config !== void 0 && (_config$extraInteract = config.extraInteractionMetrics) !== null && _config$extraInteract !== void 0 && _config$extraInteract.enabled) $754116c580521ac6$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var _observer = vcObserver;
        if (_observer) _observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $754116c580521ac6$export$4a759336b50e86e3(event) {
    var interaction = $754116c580521ac6$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') $754116c580521ac6$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $754116c580521ac6$export$ad216cc25852d44b(apdex) {
    (0, $kpqve.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (_unused9) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $754116c580521ac6$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $754116c580521ac6$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (_unused0) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $754116c580521ac6$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $754116c580521ac6$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($754116c580521ac6$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $754116c580521ac6$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $754116c580521ac6$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($754116c580521ac6$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join('|');
}
function $754116c580521ac6$export$1c43f9ac826b6462(labelStack) {
    var key = $754116c580521ac6$var$getSegmentCacheKey(labelStack);
    var existingSegment = $754116c580521ac6$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $754116c580521ac6$var$segmentCache.set(key, segmentInfo);
        $754116c580521ac6$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $754116c580521ac6$export$d0365e48b58231c3(labelStack) {
    var key = $754116c580521ac6$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $754116c580521ac6$var$segmentCache.get(key);
    if (segmentInfo) {
        $754116c580521ac6$var$segmentCache.delete(JSON.stringify(labelStack));
        var cacheKey = (0, $hij2V.stringifyLabelStackFully)(labelStack);
        $754116c580521ac6$export$a2b14406ded37d60.set(cacheKey, ($754116c580521ac6$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $754116c580521ac6$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $754116c580521ac6$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $kpqve.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($754116c580521ac6$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch (_unused1) {
            // do nothing
            }
        }
    }
}
var $754116c580521ac6$export$6ce04c7ca6810a7e = [];
var $754116c580521ac6$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $754116c580521ac6$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $754116c580521ac6$var$defaultLabelStack;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $754116c580521ac6$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("jFqL6", function(module, exports) {

var $jOlGb = parcelRequire("jOlGb");

var $4AZzf = parcelRequire("4AZzf");
var $e5169a5d1e0f24b1$var$uuid = $4AZzf;
$e5169a5d1e0f24b1$var$uuid.v1 = $jOlGb;
$e5169a5d1e0f24b1$var$uuid.v4 = $4AZzf;
module.exports = $e5169a5d1e0f24b1$var$uuid;

});
parcelRegister("jOlGb", function(module, exports) {

var $jzL4z = parcelRequire("jzL4z");

var $h9PZS = parcelRequire("h9PZS");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $e6c380e91d925fb4$var$_nodeId;
var $e6c380e91d925fb4$var$_clockseq;
// Previous uuid creation time
var $e6c380e91d925fb4$var$_lastMSecs = 0;
var $e6c380e91d925fb4$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $e6c380e91d925fb4$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $e6c380e91d925fb4$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $e6c380e91d925fb4$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $jzL4z();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $e6c380e91d925fb4$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $e6c380e91d925fb4$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $e6c380e91d925fb4$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $e6c380e91d925fb4$var$_lastMSecs + (nsecs - $e6c380e91d925fb4$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $e6c380e91d925fb4$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $e6c380e91d925fb4$var$_lastMSecs = msecs;
    $e6c380e91d925fb4$var$_lastNSecs = nsecs;
    $e6c380e91d925fb4$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $h9PZS(b);
}
module.exports = $e6c380e91d925fb4$var$v1;

});
parcelRegister("jzL4z", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $e405ccdd30439cc3$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($e405ccdd30439cc3$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $e405ccdd30439cc3$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $e405ccdd30439cc3$var$getRandomValues($e405ccdd30439cc3$var$rnds8);
        return $e405ccdd30439cc3$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $e405ccdd30439cc3$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $e405ccdd30439cc3$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $e405ccdd30439cc3$var$rnds;
    };
}

});

parcelRegister("h9PZS", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $c7db9c6f5f206437$var$byteToHex = [];
for(var $c7db9c6f5f206437$var$i = 0; $c7db9c6f5f206437$var$i < 256; ++$c7db9c6f5f206437$var$i)$c7db9c6f5f206437$var$byteToHex[$c7db9c6f5f206437$var$i] = ($c7db9c6f5f206437$var$i + 0x100).toString(16).substr(1);
function $c7db9c6f5f206437$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $c7db9c6f5f206437$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $c7db9c6f5f206437$var$bytesToUuid;

});


parcelRegister("4AZzf", function(module, exports) {

var $jzL4z = parcelRequire("jzL4z");

var $h9PZS = parcelRequire("h9PZS");
function $358a483924391ef2$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $jzL4z)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $h9PZS(rnds);
}
module.exports = $358a483924391ef2$var$v4;

});


parcelRegister("as5v9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $79c0c95eab4565aa$export$2e2bcd8739ae039; });
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $79c0c95eab4565aa$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $79c0c95eab4565aa$export$2e2bcd8739ae039 = $79c0c95eab4565aa$var$coinflip;

});

parcelRegister("ndMIw", function(module, exports) {
$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", function () { return $045cd776a23ef0b3$export$e6a07a94f3e112d4; });
$parcel$export(module.exports, "onSearchPageInteractionComplete", function () { return $045cd776a23ef0b3$export$74b9ce7e9d206a8; });
function $045cd776a23ef0b3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $045cd776a23ef0b3$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $045cd776a23ef0b3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $045cd776a23ef0b3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $045cd776a23ef0b3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $045cd776a23ef0b3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $045cd776a23ef0b3$var$interactionBuffer = [];
var $045cd776a23ef0b3$var$bufferInteractionData = function bufferInteractionData(interactionId, data) {
    $045cd776a23ef0b3$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $045cd776a23ef0b3$var$clearInteractionBuffer() {
    $045cd776a23ef0b3$var$interactionBuffer.length = 0;
}
function $045cd776a23ef0b3$var$appendInteractionData(interactionId, data) {
    $045cd776a23ef0b3$var$bufferInteractionData(interactionId, data);
}
function $045cd776a23ef0b3$var$installInteractionSink(handler) {
    var _iterator = $045cd776a23ef0b3$var$_createForOfIteratorHelper($045cd776a23ef0b3$var$interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, _interactionId = _step$value.interactionId, data = _step$value.data;
            handler(_interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    $045cd776a23ef0b3$var$clearInteractionBuffer();
    $045cd776a23ef0b3$var$bufferInteractionData = handler;
}
function $045cd776a23ef0b3$export$e6a07a94f3e112d4(sinkFn) {
    $045cd776a23ef0b3$var$installInteractionSink(sinkFn);
}
function $045cd776a23ef0b3$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $045cd776a23ef0b3$var$appendInteractionData(interactionId, data);
        $045cd776a23ef0b3$var$clearInteractionBuffer();
    }
}

});

parcelRegister("hij2V", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", function () { return $c972e443a79fb0fe$export$e08487ea3ae92adb; });
$parcel$export(module.exports, "isSegmentLabel", function () { return $c972e443a79fb0fe$export$1adbaf5c2363e4ae; });
$parcel$export(module.exports, "buildSegmentTree", function () { return $c972e443a79fb0fe$export$1569bc0edeecbcd8; });
$parcel$export(module.exports, "stringifyLabelStackFully", function () { return $c972e443a79fb0fe$export$caeee352b541de1f; });
$parcel$export(module.exports, "labelStackStartWith", function () { return $c972e443a79fb0fe$export$1787b1cd413c7e2; });
$parcel$export(module.exports, "optimizeLabelStack", function () { return $c972e443a79fb0fe$export$a0cd72da07c76b4c; });
$parcel$export(module.exports, "getOldSegmentsLabelStack", function () { return $c972e443a79fb0fe$export$b70bcfd92c93435e; });

var $lrM5r = parcelRequire("lrM5r");

var $gNkVH = parcelRequire("gNkVH");

var $03EZb = parcelRequire("03EZb");
var $c972e443a79fb0fe$var$_excluded = [
    "labelStack"
];
function $c972e443a79fb0fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c972e443a79fb0fe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c972e443a79fb0fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c972e443a79fb0fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c972e443a79fb0fe$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c972e443a79fb0fe$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c972e443a79fb0fe$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c972e443a79fb0fe$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c972e443a79fb0fe$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c972e443a79fb0fe$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c972e443a79fb0fe$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $c972e443a79fb0fe$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $c972e443a79fb0fe$export$1569bc0edeecbcd8(labelStacks) {
    var r = {
        n: 'segment-tree-root',
        c: {}
    };
    var config = (0, $03EZb.getConfig)();
    var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    var addSegmentsMap = new Map();
    labelStacks.forEach(function(labelStack) {
        var stringifiedLabelStack = $c972e443a79fb0fe$export$88f21baa687271f4(labelStack);
        var currentNode = r;
        var _iterator = $c972e443a79fb0fe$var$_createForOfIteratorHelper(labelStack), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var label = _step.value;
                var isSegment = $c972e443a79fb0fe$export$1adbaf5c2363e4ae(label);
                var name = label.name;
                if (isSegment && segmentThreshold && segmentThreshold[name]) {
                    var threshold = segmentThreshold[name];
                    var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                var id = isSegment ? label.segmentId : undefined;
                var key = id !== undefined ? id : name;
                var type = isSegment ? label.type : undefined;
                if (!currentNode.c) currentNode.c = {};
                if (!currentNode.c[key]) currentNode.c[key] = $c972e443a79fb0fe$var$_objectSpread({
                    n: name
                }, type ? {
                    t: type
                } : {});
                currentNode = currentNode.c[key];
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return {
        r: r
    };
}
function $c972e443a79fb0fe$export$caeee352b541de1f(labelStack) {
    return labelStack.map(function(l) {
        if ($c972e443a79fb0fe$export$1adbaf5c2363e4ae(l)) return "".concat(l.name, ":").concat(l.segmentId);
        return l.name;
    }).join('/');
}
function $c972e443a79fb0fe$export$88f21baa687271f4(labelStack) {
    return labelStack.map(function(l) {
        if ($c972e443a79fb0fe$export$1adbaf5c2363e4ae(l)) return "".concat(l.name, ":segment");
        return l.name;
    }).join('/');
}
function $c972e443a79fb0fe$var$getLabelStackReference(labelStack) {
    return labelStack.map(function(l) {
        return $c972e443a79fb0fe$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name;
    }).join('/');
}
function $c972e443a79fb0fe$export$1787b1cd413c7e2(labelStack, startWith) {
    return $c972e443a79fb0fe$export$caeee352b541de1f(labelStack).startsWith($c972e443a79fb0fe$export$caeee352b541de1f(startWith));
}
function $c972e443a79fb0fe$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $c972e443a79fb0fe$var$getLabelStackReference(labelStack) : labelStack.map(function(ls) {
        return $c972e443a79fb0fe$var$_objectSpread($c972e443a79fb0fe$var$_objectSpread({
            n: ls.name
        }, ls.segmentId ? {
            s: ls.segmentId
        } : {}), ls.type ? {
            t: ls.type
        } : {});
    });
}
function $c972e443a79fb0fe$export$b70bcfd92c93435e(segments, _interactionType) {
    var config = (0, $03EZb.getConfig)();
    var addSegmentsMap = new Map();
    var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    return segments.map(function(_ref) {
        var labelStack = _ref.labelStack, others = (0, $lrM5r.default)(_ref, $c972e443a79fb0fe$var$_excluded);
        var stringifiedLabelStack = $c972e443a79fb0fe$export$88f21baa687271f4(labelStack);
        var segmentsInfo = [];
        var _iterator2 = $c972e443a79fb0fe$var$_createForOfIteratorHelper(labelStack), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var ls = _step2.value;
                var isSegment = $c972e443a79fb0fe$export$1adbaf5c2363e4ae(ls);
                if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                    var threshold = segmentThreshold[ls.name];
                    var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                segmentsInfo.push($c972e443a79fb0fe$var$_objectSpread($c972e443a79fb0fe$var$_objectSpread({
                    n: ls.name
                }, ls.segmentId ? {
                    s: ls.segmentId
                } : {}), ls.type ? {
                    t: ls.type
                } : {}));
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        return $c972e443a79fb0fe$var$_objectSpread($c972e443a79fb0fe$var$_objectSpread({}, others), {}, {
            labelStack: segmentsInfo
        });
    });
}

});

parcelRegister("bMbcH", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", function () { return $892cde3d5d413a27$export$f2e521e495a88544; });
$parcel$export(module.exports, "getActiveTrace", function () { return $892cde3d5d413a27$export$b6ac780db3a3cc77; });
$parcel$export(module.exports, "clearActiveTrace", function () { return $892cde3d5d413a27$export$17ab21d7be720b; });
parcelRequire("gN5RF");
var $ct4al = parcelRequire("ct4al");
var $8GZT6 = parcelRequire("8GZT6");

var $39c3M = parcelRequire("39c3M");

var $iUdsP = parcelRequire("iUdsP");

var $bGcoj = parcelRequire("bGcoj");
var $892cde3d5d413a27$var$state = {
    context: null
};
var $892cde3d5d413a27$var$traceIdKey = (0, $8GZT6.createContextKey)('traceId');
var $892cde3d5d413a27$var$spanIdKey = (0, $8GZT6.createContextKey)('spanId');
var $892cde3d5d413a27$var$experienceTypeKey = (0, $8GZT6.createContextKey)('type');
function $892cde3d5d413a27$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}
function $892cde3d5d413a27$export$f2e521e495a88544(interactionId, experienceType) {
    $892cde3d5d413a27$export$a1002be327997103(interactionId.replace(/-/g, ''), $892cde3d5d413a27$export$295213bc4d0c54ad(), experienceType);
}
function $892cde3d5d413a27$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $39c3M.fg)('platform_ufo_enable_otel_context_manager')) {
        var activeTraceContext = (0, $8GZT6.ROOT_CONTEXT).setValue($892cde3d5d413a27$var$traceIdKey, traceId).setValue($892cde3d5d413a27$var$spanIdKey, spanId).setValue($892cde3d5d413a27$var$experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $iUdsP.getContextManager)() instanceof (0, $iUdsP.UFOContextManager)) {
            var contextManager = (0, $iUdsP.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else $892cde3d5d413a27$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $892cde3d5d413a27$export$b6ac780db3a3cc77() {
    if ((0, $39c3M.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        var activeTraceContext = {
            traceId: String((0, $ct4al.context).active().getValue($892cde3d5d413a27$var$traceIdKey)),
            spanId: String((0, $ct4al.context).active().getValue($892cde3d5d413a27$var$spanIdKey)),
            type: String((0, $ct4al.context).active().getValue($892cde3d5d413a27$var$experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return $892cde3d5d413a27$var$state.context || undefined;
}
function $892cde3d5d413a27$export$17ab21d7be720b() {
    if ((0, $39c3M.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $iUdsP.getContextManager)() instanceof (0, $iUdsP.UFOContextManager)) {
            var contextManager = (0, $iUdsP.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $8GZT6.ROOT_CONTEXT));
        }
    } else $892cde3d5d413a27$var$state.context = null;
}
function $892cde3d5d413a27$export$6e17cce6446848f9(_url) {
    if ($892cde3d5d413a27$export$b6ac780db3a3cc77() === undefined) return null;
    var _ref = $892cde3d5d413a27$export$b6ac780db3a3cc77(), traceId = _ref.traceId, spanId = _ref.spanId;
    return (0, $bGcoj.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $892cde3d5d413a27$export$a1e7396778592551(_url) {
    var traceHeaders = $892cde3d5d413a27$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("iUdsP", function(module, exports) {
$parcel$export(module.exports, "setContextManager", function () { return $dc37e69f8a5b088a$export$4a00ab8a5dd9b5cf; });
$parcel$export(module.exports, "getContextManager", function () { return $dc37e69f8a5b088a$export$831109c9f7727010; });
$parcel$export(module.exports, "UFOContextManager", function () { return $dc37e69f8a5b088a$export$dd301b96c16f583d; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $8GZT6 = parcelRequire("8GZT6");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ var $dc37e69f8a5b088a$var$contextManager;
function $dc37e69f8a5b088a$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $dc37e69f8a5b088a$var$contextManager = ctxMgr;
}
function $dc37e69f8a5b088a$export$831109c9f7727010() {
    return $dc37e69f8a5b088a$var$contextManager;
}
var $dc37e69f8a5b088a$export$dd301b96c16f583d = /*#__PURE__*/ function() {
    function UFOContextManager() {
        (0, $zhrfT.default)(this, UFOContextManager);
        /**
     * whether the context manager is enabled or not
     */ (0, $gNkVH.default)(this, "_enabled", false);
        /**
     * Keeps the reference to current context
     */ (0, $gNkVH.default)(this, "_currentContext", (0, $8GZT6.ROOT_CONTEXT));
    }
    return (0, $j9c2S.default)(UFOContextManager, [
        {
            key: "_bindFunction",
            value: /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
            function _bindFunction() {
                var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $8GZT6.ROOT_CONTEXT);
                var target = arguments.length > 1 ? arguments[1] : undefined;
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var manager = this;
                var contextWrapper = function contextWrapper() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return manager.with(context, function() {
                        return target.apply(_this, args);
                    });
                };
                Object.defineProperty(contextWrapper, 'length', {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: target.length
                });
                return contextWrapper;
            }
        },
        {
            key: "active",
            value: function active() {
                return this._currentContext;
            }
        },
        {
            key: "bind",
            value: function bind(context, target) {
                // if no specific context to propagate is given, we use the current one
                if (context === undefined) context = this.active();
                if (typeof target === 'function') return this._bindFunction(context, target);
                return target;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._currentContext = (0, $8GZT6.ROOT_CONTEXT);
                this._enabled = false;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                if (this._enabled) return this;
                this._enabled = true;
                this._currentContext = (0, $8GZT6.ROOT_CONTEXT);
                return this;
            }
        },
        {
            key: "with",
            value: function _with(context, fn, thisArg) {
                var previousContext = this._currentContext;
                this._currentContext = context || (0, $8GZT6.ROOT_CONTEXT);
                try {
                    for(var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)args[_key2 - 3] = arguments[_key2];
                    return fn.call.apply(fn, [
                        thisArg
                    ].concat(args));
                } finally{
                    this._currentContext = previousContext;
                }
            }
        },
        {
            key: "setActive",
            value: function setActive(context) {
                if (this._enabled) this._currentContext = context;
            }
        }
    ]);
}();

});

parcelRegister("bGcoj", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $880d3a93fc3c90a6$export$1115c5277eb10d5e; });
function $880d3a93fc3c90a6$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("ak0Ep", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $783c46df5f2fa8b6$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $783c46df5f2fa8b6$export$2a5c8df26bb89760; });
$parcel$export(module.exports, "addFeatureFlagAccessed", function () { return $783c46df5f2fa8b6$export$47fade9662f71000; });

var $cnTQr = parcelRequire("cnTQr");
var $783c46df5f2fa8b6$export$5b78c989c8db2561 = new Map();
var $783c46df5f2fa8b6$export$2a5c8df26bb89760 = new Map();
function $783c46df5f2fa8b6$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $cnTQr.redactValue)(featureFlagValue);
    $783c46df5f2fa8b6$export$5b78c989c8db2561.set(featureFlagName, value);
    $783c46df5f2fa8b6$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("cnTQr", function(module, exports) {
$parcel$export(module.exports, "redactValue", function () { return $9042f39e3d10c3d1$export$fcc03ee4c944962f; });

var $1nEzb = parcelRequire("1nEzb");

var $bzgmH = parcelRequire("bzgmH");
function $9042f39e3d10c3d1$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $9042f39e3d10c3d1$var$isObject(value) {
    return value && (0, $1nEzb.default)(value) === 'object' && value.constructor === Object;
}
function $9042f39e3d10c3d1$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $9042f39e3d10c3d1$export$7b4abba432e57989(value) {
    return $9042f39e3d10c3d1$var$isString(value) && $9042f39e3d10c3d1$var$startsAsObject(value) || $9042f39e3d10c3d1$var$isObject(value);
}
function $9042f39e3d10c3d1$export$fcc03ee4c944962f(featureFlagValue) {
    return $9042f39e3d10c3d1$export$7b4abba432e57989(featureFlagValue) ? (0, $bzgmH.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("bzgmH", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $86bfa85a82b52ec0$export$42f4885608027d0c; });
var $86bfa85a82b52ec0$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("1BTY2", function(module, exports) {
$parcel$export(module.exports, "DefaultInteractionID", function () { return $12c4a91763eba6ec$export$3109542b68df9ba1; });
$parcel$export(module.exports, "subscribeToInteractionIdChanges", function () { return $12c4a91763eba6ec$export$3e0c3023952f6774; });
$parcel$export(module.exports, "default", function () { return $12c4a91763eba6ec$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getInteractionId", function () { return $12c4a91763eba6ec$export$37bca3107733ac1e; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $1oC0p = parcelRequire("1oC0p");
// Same structure as react's useRef.
// This allows modals to use a ref to scope their value
// const id = useRef(null);
// <InteractionIDContext.Provider value={id}>...<
// Subscription system for interaction ID changes
var $12c4a91763eba6ec$var$listeners = new Set();
// Observable interaction ID implementation
var $12c4a91763eba6ec$var$ObservableInteractionID = /*#__PURE__*/ function() {
    function ObservableInteractionID() {
        (0, $zhrfT.default)(this, ObservableInteractionID);
        (0, $gNkVH.default)(this, "_current", null);
    }
    return (0, $j9c2S.default)(ObservableInteractionID, [
        {
            key: "current",
            get: function get() {
                return this._current;
            },
            set: function set(newId) {
                var oldId = this._current;
                this._current = newId;
                // Notify all listeners if the ID actually changed
                if (oldId !== newId) $12c4a91763eba6ec$var$listeners.forEach(function(listener) {
                    return listener(newId);
                });
            }
        }
    ]);
}(); // Type declaration for globalThis extension
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
var $12c4a91763eba6ec$var$initializeGlobalDefaultInteractionID = function initializeGlobalDefaultInteractionID() {
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    var instance = new $12c4a91763eba6ec$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
var $12c4a91763eba6ec$export$3109542b68df9ba1 = $12c4a91763eba6ec$var$initializeGlobalDefaultInteractionID();
var $12c4a91763eba6ec$export$3e0c3023952f6774 = function subscribeToInteractionIdChanges(listener) {
    $12c4a91763eba6ec$var$listeners.add(listener);
    return function() {
        $12c4a91763eba6ec$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
var $12c4a91763eba6ec$var$interactionContext = /*#__PURE__*/ (0, $1oC0p.createContext)($12c4a91763eba6ec$export$3109542b68df9ba1);
var $12c4a91763eba6ec$export$2e2bcd8739ae039 = $12c4a91763eba6ec$var$interactionContext;
var $12c4a91763eba6ec$export$37bca3107733ac1e = function getInteractionId() {
    return $12c4a91763eba6ec$export$3109542b68df9ba1;
};
var $12c4a91763eba6ec$export$9f6000531b78127e = function useInteractionId() {
    return $12c4a91763eba6ec$export$3109542b68df9ba1;
};

});

parcelRegister("88sSl", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", function () { return $5ec5782666c5b9ab$export$c8760e11c713fafc; });
$parcel$export(module.exports, "default", function () { return $5ec5782666c5b9ab$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $03EZb = parcelRequire("03EZb");

var $a48Mt = parcelRequire("a48Mt");

var $7t0tI = parcelRequire("7t0tI");
var $5ec5782666c5b9ab$var$_process;
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
var $5ec5782666c5b9ab$var$startTimes = new Map();
var $5ec5782666c5b9ab$var$spanStates = new Map();
var $5ec5782666c5b9ab$export$cf4e4023c0a34c8d = function clearState() {
    $5ec5782666c5b9ab$var$startTimes.clear();
    $5ec5782666c5b9ab$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
var $5ec5782666c5b9ab$var$lastActiveInteraction;
function $5ec5782666c5b9ab$var$checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    var activeInteractionId = (_getActiveInteraction = (0, $a48Mt.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!$5ec5782666c5b9ab$var$lastActiveInteraction && $5ec5782666c5b9ab$var$lastActiveInteraction !== activeInteractionId) $5ec5782666c5b9ab$export$cf4e4023c0a34c8d();
    $5ec5782666c5b9ab$var$lastActiveInteraction = activeInteractionId;
}
var $5ec5782666c5b9ab$var$getIsNativeTracingEnabled = function getIsNativeTracingEnabled() {
    var _getConfig$ssr$enable, _getConfig;
    return (_getConfig$ssr$enable = (_getConfig = (0, $03EZb.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.ssr) === null || _getConfig === void 0 ? void 0 : _getConfig.enableNativeTracing) !== null && _getConfig$ssr$enable !== void 0 ? _getConfig$ssr$enable : false;
};
var $5ec5782666c5b9ab$var$onStartRender = function onStartRender(id, currentSegmentName, parentContext) {
    var _startTimes$get, _vm_internals__, _spanStates$get;
    if (!$5ec5782666c5b9ab$var$startTimes.has(id)) $5ec5782666c5b9ab$var$startTimes.set(id, []);
    (_startTimes$get = $5ec5782666c5b9ab$var$startTimes.get(id)) === null || _startTimes$get === void 0 || _startTimes$get.push(performance.now());
    if (!$5ec5782666c5b9ab$var$getIsNativeTracingEnabled()) return null;
    var startSpan = (_vm_internals__ = globalThis.__vm_internals__) === null || _vm_internals__ === void 0 || (_vm_internals__ = _vm_internals__.telemetry) === null || _vm_internals__ === void 0 ? void 0 : _vm_internals__.startSpan;
    var spanState = (_spanStates$get = $5ec5782666c5b9ab$var$spanStates.get(id)) !== null && _spanStates$get !== void 0 ? _spanStates$get : null;
    if (!spanState && startSpan) {
        var span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span: span
        };
        $5ec5782666c5b9ab$var$spanStates.set(id, spanState);
    }
    return spanState;
};
var $5ec5782666c5b9ab$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $7t0tI !== 'undefined' && Boolean((($5ec5782666c5b9ab$var$_process = $7t0tI) === null || $5ec5782666c5b9ab$var$_process === void 0 || ($5ec5782666c5b9ab$var$_process = $5ec5782666c5b9ab$var$_process.env) === null || $5ec5782666c5b9ab$var$_process === void 0 ? void 0 : $5ec5782666c5b9ab$var$_process.REACT_SSR) || false);
var $5ec5782666c5b9ab$var$ProfilerMarker = function ProfilerMarker(_ref) {
    var onRender = _ref.onRender;
    onRender === null || onRender === void 0 || onRender();
    return null;
};
var $5ec5782666c5b9ab$var$ParentSpanContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $5ec5782666c5b9ab$export$c8760e11c713fafc = function flushSsrRenderProfilerTraces() {
    $5ec5782666c5b9ab$var$spanStates.forEach(function(spanState) {
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $5ec5782666c5b9ab$var$spanStates.clear();
};
var $5ec5782666c5b9ab$export$b8bd105b650b1c1e = function SsrRenderProfilerInner(_ref2) {
    var _currentSpanState$spa;
    var children = _ref2.children, labelStack = _ref2.labelStack, _onRender = _ref2.onRender;
    var reactProfilerId = (0, $1oC0p.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join('/');
    }, [
        labelStack
    ]);
    $5ec5782666c5b9ab$var$checkActiveInteractionAndResetStartMarksIfSet();
    var parentSpan = (0, $1oC0p.useContext)($5ec5782666c5b9ab$var$ParentSpanContext);
    var currentSpanState = $5ec5782666c5b9ab$var$onStartRender(reactProfilerId, labelStack[labelStack.length - 1].name, parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($5ec5782666c5b9ab$var$ParentSpanContext.Provider, {
        value: (_currentSpanState$spa = currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) !== null && _currentSpanState$spa !== void 0 ? _currentSpanState$spa : null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($5ec5782666c5b9ab$var$ProfilerMarker, {
        onRender: function onRender() {
            var startTimesForId = $5ec5782666c5b9ab$var$startTimes.get(reactProfilerId);
            if (startTimesForId !== null && startTimesForId !== void 0 && startTimesForId.length) {
                var _endTime = performance.now();
                var firstStartTime = startTimesForId[0];
                var lastStartTime = startTimesForId[startTimesForId.length - 1];
                var baseDuration = _endTime - lastStartTime;
                var actualDuration = _endTime - firstStartTime;
                _onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, _endTime);
            }
            var spanState = $5ec5782666c5b9ab$var$spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};
var $5ec5782666c5b9ab$var$SsrRenderProfiler = function SsrRenderProfiler(props) {
    if ($5ec5782666c5b9ab$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($5ec5782666c5b9ab$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($5ec5782666c5b9ab$var$ProfilerMarker, null), props.children);
};
var $5ec5782666c5b9ab$export$2e2bcd8739ae039 = $5ec5782666c5b9ab$var$SsrRenderProfiler;

});

parcelRegister("4PhwH", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", function () { return VCObserverWrapper; });
$parcel$export(module.exports, "newVCObserver", function () { return newVCObserver; });

var $kOzMB = parcelRequire("kOzMB");

var $eAzuA = parcelRequire("eAzuA");

var $gNkVH = parcelRequire("gNkVH");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $c3LVh = parcelRequire("c3LVh");

var $03EZb = parcelRequire("03EZb");

var $ePvsN = parcelRequire("ePvsN");

var $6BIm3 = parcelRequire("6BIm3");

var $fBGIz = parcelRequire("fBGIz");

var $bYqEg = parcelRequire("bYqEg");

var $hzedL = parcelRequire("hzedL");

var $7t0tI = parcelRequire("7t0tI");
var _process;
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var VCObserverWrapper = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _opts$ssrEnablePageLa;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $zhrfT.default)(this, VCObserverWrapper);
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $hzedL.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa !== void 0 ? _opts$ssrEnablePageLa : false
        });
        if ((0, $03EZb.isVCRevisionEnabled)('fy25.03') || (0, $03EZb.isVCRevisionEnabled)('fy26.04')) {
            var _opts$ssrEnablePageLa2, _opts$trackLayoutShif;
            this.newVCObserver = new (0, $fBGIz.default)({
                selectorConfig: opts.selectorConfig,
                isPostInteraction: opts.isPostInteraction,
                SSRConfig: {
                    enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa2 = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa2 !== void 0 ? _opts$ssrEnablePageLa2 : false
                },
                ssrPlaceholderHandler: this.ssrPlaceholderHandler,
                trackLayoutShiftOffenders: (_opts$trackLayoutShif = opts.trackLayoutShiftOffenders) !== null && _opts$trackLayoutShif !== void 0 ? _opts$trackLayoutShif : false,
                searchPageConfig: opts.searchPageConfig
            });
        }
        if ((0, $03EZb.isVCRevisionEnabled)('fy25.01') || (0, $03EZb.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $6BIm3.VCObserver)(_objectSpread(_objectSpread({}, opts), {}, {
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        }));
    }
    // Helper method to process SSR abort listeners
    return (0, $j9c2S.default)(VCObserverWrapper, [
        {
            key: "processSsrAbortListeners",
            value: function processSsrAbortListeners() {
                var _window;
                // Process any SSR abort listeners that remain
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    // Clean up any event listeners that may have been registered during SSR
                    // This is centralized here so only the wrapper handles unbinding, not individual observers
                    if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach(function(unbind) {
                        if (typeof unbind === 'function') unbind();
                    });
                    // After all observers had a chance to process abort events,
                    // we can safely delete the SSR_ABORT_LISTENERS object
                    delete window.__SSR_ABORT_LISTENERS__;
                }
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var startTime = _ref.startTime, experienceKey = _ref.experienceKey;
                if ((0, $03EZb.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $03EZb.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver;
                    (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                        startTime: startTime
                    });
                }
                if ((0, $03EZb.isVCRevisionEnabled)('fy25.03', experienceKey) || (0, $03EZb.isVCRevisionEnabled)('fy26.04', experienceKey)) {
                    var _this$newVCObserver;
                    (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                        startTime: startTime
                    });
                }
                // Clean up any remaining SSR abort listeners after all observers have been started
                this.processSsrAbortListeners();
            }
        },
        {
            key: "stop",
            value: function stop(experienceKey) {
                if ((0, $03EZb.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $03EZb.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver2;
                    (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                }
                if ((0, $03EZb.isVCRevisionEnabled)('fy25.03', experienceKey) || (0, $03EZb.isVCRevisionEnabled)('fy26.04', experienceKey)) {
                    var _this$newVCObserver2;
                    (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
                }
                (0, $bYqEg.RLLPlaceholderHandlers).getInstance().reset();
                // Clear shared SSR placeholder handler
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _v3v4Result$, _ref2;
                    var experienceKey, include3p, excludeSmartAnswersInSearch, includeSSRRatio, includeRawData, v1v2Result, v3v4Result, ssrRatio;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                experienceKey = param.experienceKey, include3p = param.include3p, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeSSRRatio = param.includeSSRRatio, includeRawData = param.includeRawData;
                                if (!((0, $03EZb.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $03EZb.isVCRevisionEnabled)('fy25.02', experienceKey))) {
                                    _context.next = 7;
                                    break;
                                }
                                _context.next = 4;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 4:
                                _context.t0 = _context.sent;
                                _context.next = 8;
                                break;
                            case 7:
                                _context.t0 = {};
                            case 8:
                                v1v2Result = _context.t0;
                                if (!((0, $03EZb.isVCRevisionEnabled)('fy25.03', experienceKey) || (0, $03EZb.isVCRevisionEnabled)('fy26.04', experienceKey))) {
                                    _context.next = 15;
                                    break;
                                }
                                _context.next = 12;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: param.stop,
                                    interactionId: param.interactionId,
                                    ssr: param.ssr,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    interactionType: param.interactionType,
                                    isPageVisible: param.isPageVisible,
                                    interactionAbortReason: param.interactionAbortReason,
                                    includeRawData: includeRawData,
                                    includeSSRInV3: param.includeSSRInV3,
                                    rawDataStopTime: param.rawDataStopTime,
                                    reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
                                });
                            case 12:
                                _context.t1 = _context.sent;
                                _context.next = 16;
                                break;
                            case 15:
                                _context.t1 = [];
                            case 16:
                                v3v4Result = _context.t1;
                                if (!(!v3v4Result || v3v4Result.length === 0)) {
                                    _context.next = 19;
                                    break;
                                }
                                return _context.abrupt("return", v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {});
                            case 19:
                                ssrRatio = v3v4Result === null || v3v4Result === void 0 || (_v3v4Result$ = v3v4Result[0]) === null || _v3v4Result$ === void 0 ? void 0 : _v3v4Result$.ssrRatio;
                                return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, includeSSRRatio && ssrRatio !== undefined ? {
                                    'ufo:vc:ssrRatio': ssrRatio
                                } : {}), v1v2Result), {}, {
                                    'ufo:vc:rev': [].concat((0, $kOzMB.default)((_ref2 = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) !== null && _ref2 !== void 0 ? _ref2 : []), (0, $kOzMB.default)(v3v4Result !== null && v3v4Result !== void 0 ? v3v4Result : []))
                                }));
                            case 21:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5, _this$newVCObserver4;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
                (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6, _this$newVCObserver5;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
                (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7, _this$newVCObserver6;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
                (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
                this.ssrPlaceholderHandler.collectExistingPlaceholders();
            }
        }
    ]);
}();
// Some products set this variable to indicate it is running in SSR
var isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var isReactSSR = typeof $7t0tI !== 'undefined' && Boolean(((_process = $7t0tI) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR) || false);
function isEnvironmentSupported() {
    // SSR environment aren't supported
    if (isReactSSR || isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}
function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!globalThis.__vcObserver) {
        var shouldMockVCObserver = !isEnvironmentSupported();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $ePvsN.VCObserverNOOP)() : new VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}
function newVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldMockVCObserver = !isEnvironmentSupported();
    var observer = shouldMockVCObserver ? new (0, $ePvsN.VCObserverNOOP)() : new VCObserverWrapper(opts);
    return observer;
}

});
parcelRegister("ePvsN", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", function () { return $acbe3c19786de15c$export$24d07287b49da906; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");
var $acbe3c19786de15c$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, $zhrfT.default)(this, VCObserverNOOP);
    }
    return (0, $j9c2S.default)(VCObserverNOOP, [
        {
            key: "start",
            value: function start(_) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(_) {
                return Promise.resolve({
                    'ufo:vc:noop': true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(_) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(_) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(_) {}
        }
    ]);
}();

});

parcelRegister("fBGIz", function(module, exports) {
$parcel$export(module.exports, "getHasAbortingEventDuringSSR", function () { return $b5cb7294906c63c6$export$88af4849fcc5bbc9; });
$parcel$export(module.exports, "default", function () { return $b5cb7294906c63c6$export$2e2bcd8739ae039; });

var $eAzuA = parcelRequire("eAzuA");

var $6HNZJ = parcelRequire("6HNZJ");

var $1nEzb = parcelRequire("1nEzb");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $c3LVh = parcelRequire("c3LVh");

var $39c3M = parcelRequire("39c3M");

var $03EZb = parcelRequire("03EZb");

var $a48Mt = parcelRequire("a48Mt");

var $hzedL = parcelRequire("hzedL");

var $cUZMY = parcelRequire("cUZMY");

var $4EoCy = parcelRequire("4EoCy");

var $kBgcN = parcelRequire("kBgcN");

var $6vPx8 = parcelRequire("6vPx8");

var $eGFOB = parcelRequire("eGFOB");

var $a9FxO = parcelRequire("a9FxO");

var $gaczG = parcelRequire("gaczG");

var $e4kJV = parcelRequire("e4kJV");

var $7A4yH = parcelRequire("7A4yH");

var $k0eLW = parcelRequire("k0eLW");
var $b5cb7294906c63c6$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $b5cb7294906c63c6$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
var $b5cb7294906c63c6$var$hasAbortingEventDuringSSR = false;
function $b5cb7294906c63c6$export$88af4849fcc5bbc9() {
    return $b5cb7294906c63c6$var$hasAbortingEventDuringSSR;
}
var $b5cb7294906c63c6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$isPostInterac, _config$selectorConfi, _config$trackLayoutSh, _this = this;
        (0, $zhrfT.default)(this, VCObserverNew);
        (0, $gNkVH.default)(this, "viewportObserver", null);
        (0, $gNkVH.default)(this, "windowEventObserver", null);
        // SSR related properties
        (0, $gNkVH.default)(this, "ssrPlaceholderHandler", null);
        (0, $gNkVH.default)(this, "ssr", {
            state: $b5cb7294906c63c6$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        this.entriesTimeline = new (0, $cUZMY.default)();
        this.isPostInteraction = (_config$isPostInterac = config.isPostInteraction) !== null && _config$isPostInterac !== void 0 ? _config$isPostInterac : false;
        this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : $b5cb7294906c63c6$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig$ena, _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $hzedL.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_config$SSRConfig$ena = (_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) !== null && _config$SSRConfig$ena !== void 0 ? _config$SSRConfig$ena : false
            });
        }
        this.trackLayoutShiftOffenders = (_config$trackLayoutSh = config.trackLayoutShiftOffenders) !== null && _config$trackLayoutSh !== void 0 ? _config$trackLayoutSh : false;
        this.viewportObserver = new (0, $7A4yH.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = 'unknown';
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                var data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    var labelStacks = $b5cb7294906c63c6$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: function getSSRState() {
                return _this.getSSRState();
            },
            getSSRPlaceholderHandler: function getSSRPlaceholderHandler() {
                return _this.getSSRPlaceholderHandler();
            },
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $k0eLW.default)({
            onEvent: function onEvent(_ref) {
                var time = _ref.time, type = _ref.type;
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $39c3M.fg)('platform_ufo_keypress_interaction_abort')) {
                    var interaction = (0, $a48Mt.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
    return (0, $j9c2S.default)(VCObserverNew, [
        {
            key: "start",
            value: function start(_) {
                var _this$viewportObserve, _this2 = this;
                // Reset SSR state on start (matches old VCObserver behavior)
                this.ssr = {
                    state: $b5cb7294906c63c6$var$SSRState.normal,
                    reactRootElement: null,
                    // Reset to null (matches old VCObserver)
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                if ((0, $39c3M.fg)('ufo_fix_aborting_interaction_detection_during_ssr')) {
                    var _window, _this$windowEventObse;
                    this.entriesTimeline.clear();
                    if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                        var abortListeners = window.__SSR_ABORT_LISTENERS__;
                        var aborts = abortListeners.aborts;
                        if (aborts && (0, $1nEzb.default)(aborts) === 'object') Object.entries(aborts).forEach(function(_ref2) {
                            var _ref3 = (0, $6HNZJ.default)(_ref2, 2), key = _ref3[0], time = _ref3[1];
                            if (typeof time === 'number') _this2.entriesTimeline.push({
                                time: time,
                                data: {
                                    type: 'window:event',
                                    eventType: key
                                }
                            });
                        });
                    }
                    (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
                } else {
                    var _window2, _this$windowEventObse2;
                    if ((_window2 = window) !== null && _window2 !== void 0 && _window2.__SSR_ABORT_LISTENERS__) {
                        var _abortListeners = window.__SSR_ABORT_LISTENERS__;
                        var _aborts = _abortListeners.aborts;
                        if (_aborts && (0, $1nEzb.default)(_aborts) === 'object') Object.entries(_aborts).forEach(function(_ref4) {
                            var _ref5 = (0, $6HNZJ.default)(_ref4, 2), key = _ref5[0], time = _ref5[1];
                            if (typeof time === 'number') {
                                _this2.entriesTimeline.push({
                                    time: time,
                                    data: {
                                        type: 'window:event',
                                        eventType: key
                                    }
                                });
                                if ((0, $39c3M.fg)('ufo_detect_aborting_interaction_during_ssr')) $b5cb7294906c63c6$var$hasAbortingEventDuringSSR = true;
                            }
                        });
                    }
                    (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.start();
                    this.entriesTimeline.clear();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse3;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse3 = this.windowEventObserver) === null || _this$windowEventObse3 === void 0 || _this$windowEventObse3.stop();
                // Clear SSR state on stop (matches old VCObserver behavior)
                this.ssr.reactRootElement = null;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $b5cb7294906c63c6$var$SSRState.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "getSSRState",
            value: function getSSRState() {
                return this.ssr;
            }
        },
        {
            key: "getSSRPlaceholderHandler",
            value: function getSSRPlaceholderHandler() {
                return this.ssrPlaceholderHandler;
            }
        },
        {
            key: "addSSR",
            value: function addSSR(ssr) {
                this.entriesTimeline.push({
                    time: ssr,
                    data: {
                        elementName: 'SSR',
                        type: 'mutation:element',
                        rect: {
                            height: (0, $eGFOB.default)(),
                            width: (0, $a9FxO.default)(),
                            left: 0,
                            top: 0,
                            x: 0,
                            y: 0,
                            bottom: (0, $eGFOB.default)(),
                            right: (0, $a9FxO.default)(),
                            toJSON: function toJSON() {
                                return null;
                            }
                        },
                        visible: true
                    }
                });
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(param) {
                    var start, stop, interactionId, interactionType, interactionAbortReason, isPageVisible, include3p, includeSSRRatio, excludeSmartAnswersInSearch, includeRawData, rawDataStopTime, results, feVCCalculationStartTime, calculator_fy25_03, orderedEntries, fy25_03, calculator_fy26_04, calculator_next, calculatorParams, isFy2604Enabled, _yield$Promise$all, _yield$Promise$all2, fy26_04, vcNext, feVCCalculationEndTime, shouldIncludeRawData, rawVCCalculationStartTime, rawHandler, rawStopTime, rawOrderedEntries, raw;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop, interactionId = param.interactionId, interactionType = param.interactionType, interactionAbortReason = param.interactionAbortReason, isPageVisible = param.isPageVisible, include3p = param.include3p, includeSSRRatio = param.includeSSRRatio, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeRawData = param.includeRawData, rawDataStopTime = param.rawDataStopTime;
                                results = [];
                                this.addStartEntry(start);
                                feVCCalculationStartTime = performance.now();
                                calculator_fy25_03 = new (0, $kBgcN.default)();
                                if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                if (!(0, $03EZb.isVCRevisionEnabled)('fy25.03')) {
                                    _context.next = 13;
                                    break;
                                }
                                _context.next = 10;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                });
                            case 10:
                                _context.t0 = _context.sent;
                                _context.next = 14;
                                break;
                            case 13:
                                _context.t0 = null;
                            case 14:
                                fy25_03 = _context.t0;
                                if (fy25_03) results.push(fy25_03);
                                // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
                                if (param.ssr) this.addSSR(param.ssr);
                                calculator_fy26_04 = new (0, $6vPx8.default)();
                                calculator_next = new (0, $gaczG.default)();
                                calculatorParams = {
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                };
                                isFy2604Enabled = (0, $03EZb.isVCRevisionEnabled)('fy26.04');
                                _context.next = 23;
                                return Promise.all([
                                    isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
                                    (0, $03EZb.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
                                ]);
                            case 23:
                                _yield$Promise$all = _context.sent;
                                _yield$Promise$all2 = (0, $6HNZJ.default)(_yield$Promise$all, 2);
                                fy26_04 = _yield$Promise$all2[0];
                                vcNext = _yield$Promise$all2[1];
                                if (fy26_04) results.push(fy26_04);
                                if (vcNext) results.push(vcNext);
                                feVCCalculationEndTime = performance.now(); // Always include raw data when fy26.04 is not in the client config so the server
                                // can recalculate fy26.04 metrics (ssrRatio, labelStacks, speedIndex) from raw observations.
                                shouldIncludeRawData = includeRawData || !isFy2604Enabled;
                                if (!shouldIncludeRawData) {
                                    _context.next = 41;
                                    break;
                                }
                                rawVCCalculationStartTime = performance.now();
                                rawHandler = new (0, $e4kJV.default)(); // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
                                rawStopTime = rawDataStopTime !== null && rawDataStopTime !== void 0 ? rawDataStopTime : stop;
                                rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: rawStopTime
                                }) : orderedEntries;
                                _context.next = 38;
                                return rawHandler.getRawData({
                                    entries: rawOrderedEntries,
                                    startTime: start,
                                    stopTime: rawStopTime,
                                    isPageVisible: isPageVisible
                                });
                            case 38:
                                raw = _context.sent;
                                results.forEach(function(result) {
                                    delete result.vcDetails;
                                    delete result.ratios;
                                });
                                if (raw) {
                                    raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                                    raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                                    results.push(raw);
                                }
                            case 41:
                                return _context.abrupt("return", results);
                            case 42:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "addStartEntry",
            value: function addStartEntry(startTime) {
                this.entriesTimeline.push({
                    time: startTime,
                    data: {
                        type: 'mutation:element',
                        elementName: 'START',
                        visible: true,
                        rect: {
                            x: 0,
                            y: 0,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight,
                            right: window.innerWidth,
                            toJSON: function toJSON() {
                                return {
                                    x: this.x,
                                    y: this.y,
                                    width: this.width,
                                    height: this.height,
                                    top: this.top,
                                    left: this.left,
                                    bottom: this.bottom,
                                    right: this.right
                                };
                            }
                        }
                    }
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $4EoCy.default)(this.selectorConfig, element);
            }
        }
    ]);
}();
function $b5cb7294906c63c6$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    var value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $b5cb7294906c63c6$var$labelStackToString(labelStack) {
    return labelStack.map(function(label) {
        return label.name;
    }).join('/');
}
function $b5cb7294906c63c6$var$labelStackToSegment(labelStack) {
    var segmentIndex = -1;
    for(var i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map(function(label) {
        return label.name;
    }).join('/');
}
function $b5cb7294906c63c6$var$traverseFiber(fiber) {
    var segment = 'unknown';
    var labelStackString = 'unknown';
    var currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            var componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                var labelStack = $b5cb7294906c63c6$var$labelStackFromFiber(currentFiber);
                labelStackString = $b5cb7294906c63c6$var$labelStackToString(labelStack) || 'unknown';
                segment = $b5cb7294906c63c6$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $b5cb7294906c63c6$var$getLabelStacks(element) {
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (!reactFiberKey) return null;
    var fiber = element[reactFiberKey];
    return fiber ? $b5cb7294906c63c6$var$traverseFiber(fiber) : null;
}

});
parcelRegister("hzedL", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $cca0bc8a9c71d6b5$export$c0102f1a1198d10f; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");
var $cca0bc8a9c71d6b5$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $cca0bc8a9c71d6b5$var$PAGE_LAYOUT_ID = 'page-layout.root';
var $cca0bc8a9c71d6b5$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers(_ref) {
        var _this = this;
        var _ref$enablePageLayout = _ref.enablePageLayoutPlaceholder, enablePageLayoutPlaceholder = _ref$enablePageLayout === void 0 ? false : _ref$enablePageLayout;
        (0, $zhrfT.default)(this, SSRPlaceholderHandlers);
        (0, $gNkVH.default)(this, "staticPlaceholders", new Map());
        (0, $gNkVH.default)(this, "callbacks", new Map());
        (0, $gNkVH.default)(this, "getSizeCallbacks", new Map());
        (0, $gNkVH.default)(this, "reactValidateCallbacks", new Map());
        (0, $gNkVH.default)(this, "EQUALITY_THRESHOLD", 1);
        (0, $gNkVH.default)(this, "getPlaceholderId", function(el) {
            var _el$dataset;
            var ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $cca0bc8a9c71d6b5$var$PAGE_LAYOUT_ID) return $cca0bc8a9c71d6b5$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, $gNkVH.default)(this, "getPlaceholderReplacementId", function(el) {
            var _el$dataset2;
            var ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $cca0bc8a9c71d6b5$var$PAGE_LAYOUT_ID) return $cca0bc8a9c71d6b5$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, $gNkVH.default)(this, "intersectionObserverCallback", function(_ref2) {
            var _this$intersectionObs;
            var target = _ref2.target, boundingClientRect = _ref2.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = _this.getPlaceholderId(target);
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = _this.getEffectiveBoundingRect(target);
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = _this.getPlaceholderReplacementId(target);
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = _this.getEffectiveBoundingRect(target);
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch (_unused) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    return (0, $j9c2S.default)(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "collectPlaceholdersInternal",
            value: function collectPlaceholdersInternal() {
                var _this2 = this;
                var selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
                var existingElements = document.querySelectorAll(selector);
                existingElements.forEach(function(el) {
                    var placeholderId = el instanceof HTMLElement && _this2.getPlaceholderId(el);
                    if (placeholderId && !_this2.staticPlaceholders.has(placeholderId)) {
                        var _window$__SSR_PLACEHO, _this2$intersectionOb;
                        var width = -1;
                        var height = -1;
                        var x = -1;
                        var y = -1;
                        // Use SSR dimensions from window global if available
                        var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        } else {
                            // Fallback to current bounding rect if SSR dimensions not available
                            var rect = el.getBoundingClientRect();
                            width = rect.width;
                            height = rect.height;
                            x = rect.x;
                            y = rect.y;
                        }
                        _this2.staticPlaceholders.set(placeholderId, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "collectExistingPlaceholders",
            value: function collectExistingPlaceholders() {
                if (!window.document) return;
                try {
                    // Collect placeholders using SSR dimensions or fallback to live dimensions
                    this.collectPlaceholdersInternal();
                } catch (_unused2) {
                // Silently fail if there are any issues
                } finally{
                    delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
                }
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(this.getPlaceholderId(element));
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(this.getPlaceholderReplacementId(element));
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return 'ssrPlaceholderIgnored' in element.dataset;
            }
        },
        {
            key: "isPlaceholderV4",
            value: function isPlaceholderV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $cca0bc8a9c71d6b5$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "isPlaceholderReplacementV4",
            value: function isPlaceholderReplacementV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $cca0bc8a9c71d6b5$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $cca0bc8a9c71d6b5$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "findNearestPlaceholderOrContainer",
            value: function findNearestPlaceholderOrContainer(element) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $cca0bc8a9c71d6b5$var$ANCESTOR_LOOKUP_LIMIT;
                var ancestor = element;
                if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < limit){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    if (ancestor.parentElement) {
                        ancestor = ancestor.parentElement;
                        i++;
                    } else break;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this3 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                return new Promise(function(resolve) {
                    if (!_this3.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this3$intersectionOb;
                        _this3.callbacks.set(id, resolve);
                        (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "checkIfExistedAndSizeMatchingV3",
            value: function checkIfExistedAndSizeMatchingV3(el) {
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                var placeholderRects = this.staticPlaceholders.get(id);
                if (!placeholderRects) return false;
                return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    var _this4$intersectionOb;
                    _this4.getSizeCallbacks.set(_this4.getPlaceholderId(el), resolve);
                    (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this5 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderReplacementId(el);
                return new Promise(function(resolve) {
                    if (!_this5.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this5$intersectionOb;
                        _this5.reactValidateCallbacks.set(id, resolve);
                        (_this5$intersectionOb = _this5.intersectionObserver) === null || _this5$intersectionOb === void 0 || _this5$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholderV4",
            value: function validateReactComponentMatchToPlaceholderV4(el) {
                el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
                var id = this.getPlaceholderReplacementId(el);
                return this.staticPlaceholders.has(id);
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                if (!rect) return false;
                var horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
                var verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
                return horizontalCheck && verticalCheck || false;
            }
        },
        {
            key: "getEffectiveBoundingRect",
            value: function getEffectiveBoundingRect(el) {
                var computedStyle = window.getComputedStyle(el);
                // If element has display: contents, collect bounding rect from children
                if (computedStyle.display === 'contents') {
                    var children = Array.from(el.children);
                    if (children.length === 0) // No children, return zero rect
                    return new DOMRect(0, 0, 0, 0);
                    // Calculate union of all children's bounding rects
                    var minX = Infinity;
                    var minY = Infinity;
                    var maxX = -Infinity;
                    var maxY = -Infinity;
                    children.forEach(function(child) {
                        var childRect = child.getBoundingClientRect();
                        // Skip children with zero dimensions (likely also display: contents)
                        if (childRect.width > 0 || childRect.height > 0) {
                            minX = Math.min(minX, childRect.left);
                            minY = Math.min(minY, childRect.top);
                            maxX = Math.max(maxX, childRect.right);
                            maxY = Math.max(maxY, childRect.bottom);
                        }
                    });
                    // If no children with dimensions found, return zero rect
                    if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
                    return new DOMRect(minX, minY, maxX - minX, maxY - minY);
                }
                // Normal element, return its bounding rect
                return el.getBoundingClientRect();
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});

parcelRegister("cUZMY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $967aa4ff9d89f8ec$export$2e2bcd8739ae039; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");
var $967aa4ff9d89f8ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, $zhrfT.default)(this, EntriesTimeline);
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    return (0, $j9c2S.default)(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : 'null', "_").concat(stop !== null && stop !== void 0 ? stop : 'null');
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("4EoCy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $362dff0d9ea32e3e$export$2e2bcd8739ae039; });
var $362dff0d9ea32e3e$var$nameCache = new WeakMap();
function $362dff0d9ea32e3e$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        var elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            var parentElementSelector = $362dff0d9ea32e3e$var$getElementName(selectorConfig, element.parentElement);
            return "".concat(parentElementSelector, " > ").concat(elementInstance);
        } else return elementInstance;
    }
    var cachedName = $362dff0d9ea32e3e$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (_unused) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (element && typeof element.getAttribute !== 'function') return '';
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, "=\"").concat(encondedAttrValue, "\"]");
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : '';
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector('role') : '';
    var classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? $362dff0d9ea32e3e$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $362dff0d9ea32e3e$var$nameCache.set(element, name);
    return name;
}
var $362dff0d9ea32e3e$export$2e2bcd8739ae039 = $362dff0d9ea32e3e$var$getElementName;

});

parcelRegister("kBgcN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eff3d5698f354cac$export$2e2bcd8739ae039; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $4GP2Y = parcelRequire("4GP2Y");

var $ewpge = parcelRequire("ewpge");

var $6Ru4o = parcelRequire("6Ru4o");

var $39c3M = parcelRequire("39c3M");

var $fsqMW = parcelRequire("fsqMW");

var $kedcC = parcelRequire("kedcC");

var $dKwwe = parcelRequire("dKwwe");

var $cLUNX = parcelRequire("cLUNX");

var $1NfLP = parcelRequire("1NfLP");
function $eff3d5698f354cac$var$_callSuper(t, o, e) {
    return o = (0, $ewpge.default)(o), (0, $4GP2Y.default)(t, $eff3d5698f354cac$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $ewpge.default)(t).constructor) : o.apply(t, e));
}
function $eff3d5698f354cac$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($eff3d5698f354cac$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $eff3d5698f354cac$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $eff3d5698f354cac$var$REVISION_NO = 'fy25.03';
var $eff3d5698f354cac$var$getConsideredEntryTypes = function getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch) {
    var entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
var $eff3d5698f354cac$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03(revisionNo) {
        (0, $zhrfT.default)(this, VCCalculator_FY25_03);
        return $eff3d5698f354cac$var$_callSuper(this, VCCalculator_FY25_03, [
            revisionNo !== null && revisionNo !== void 0 ? revisionNo : $eff3d5698f354cac$var$REVISION_NO
        ]);
    }
    (0, $6Ru4o.default)(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, $j9c2S.default)(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                if (!$eff3d5698f354cac$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
                if (entry.data.type === 'mutation:attribute:framework-routing') return false;
                if (entry.data.type === 'mutation:media' && (0, $39c3M.fg)('media-perf-uplift-mutation-fix')) {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $fsqMW.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
                    // special case for style attribute to ignore only anchor-name changes
                    if ((0, $fsqMW.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                        if ((0, $kedcC.containsDnDMutationInStyle)({
                            attributeName: entryData.attributeName,
                            oldValue: entryData.oldValue,
                            newValue: entryData.newValue
                        })) return false;
                    }
                }
                if (entry.data.type === 'mutation:attribute') {
                    var _entryData = entry.data;
                    var _attributeName = _entryData.attributeName;
                    if (!_attributeName || (0, $cLUNX.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(_attributeName)) return false;
                    if (_attributeName.startsWith('data-test') || (0, $cLUNX.NON_VISUAL_ARIA_ATTRIBUTES).includes(_attributeName) || (0, $cLUNX.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(_attributeName) && (0, $39c3M.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, $cLUNX.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(_attributeName) && (0, $39c3M.fg)('platform_ufo_exclude_dark_reader_extension') || (0, $cLUNX.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(_attributeName) && (0, $39c3M.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
                    return true;
                }
                if ((0, $1NfLP.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($eff3d5698f354cac$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $dKwwe.default));

});
parcelRegister("4GP2Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $36a2ae8491e86dd2$export$2e2bcd8739ae039; });

var $1nEzb = parcelRequire("1nEzb");

var $lmuu7 = parcelRequire("lmuu7");
function $36a2ae8491e86dd2$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $1nEzb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $lmuu7.default)(t);
}

});
parcelRegister("lmuu7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f8d34cb5f30a343c$export$2e2bcd8739ae039; });
function $f8d34cb5f30a343c$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("ewpge", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a927a61ff387e984$export$2e2bcd8739ae039; });
function $a927a61ff387e984$export$2e2bcd8739ae039(t) {
    return $a927a61ff387e984$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $a927a61ff387e984$export$2e2bcd8739ae039(t);
}

});

parcelRegister("6Ru4o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4fef04945b0a107c$export$2e2bcd8739ae039; });

var $bF8XE = parcelRequire("bF8XE");
function $4fef04945b0a107c$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $bF8XE.default)(t, e);
}

});
parcelRegister("bF8XE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87da79891b2dd1dc$export$2e2bcd8739ae039; });
function $87da79891b2dd1dc$export$2e2bcd8739ae039(t, e) {
    return $87da79891b2dd1dc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $87da79891b2dd1dc$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("fsqMW", function(module, exports) {
$parcel$export(module.exports, "expVal", function () { return $b40e4028d32852a2$export$9db1624a8af791a4; });

var $imeNq = parcelRequire("imeNq");

var $ak0Ep = parcelRequire("ak0Ep");
var $b40e4028d32852a2$export$9db1624a8af791a4 = function expVal(experimentName, experimentParam, defaultValue) {
    // If client is not initialized, we return the default value
    if (!(0, $imeNq.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $imeNq.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $ak0Ep.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue;
};

});
parcelRegister("imeNq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d5d5c243a98208af$export$2e2bcd8739ae039; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $cQbBb = parcelRequire("cQbBb");

var $iuQfp = parcelRequire("iuQfp");



var $d5d5c243a98208af$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $d5d5c243a98208af$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $zhrfT.default)(this, FeatureGates);
    }
    return (0, $j9c2S.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$d5d5c243a98208af$var$_FeatureGates = $d5d5c243a98208af$var$FeatureGates;
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "client", new (0, $cQbBb.Client)());
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$d5d5c243a98208af$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $d5d5c243a98208af$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $d5d5c243a98208af$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$d5d5c243a98208af$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $d5d5c243a98208af$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $d5d5c243a98208af$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "initializeCalled", $d5d5c243a98208af$var$_FeatureGates.client.initializeCalled.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "initializeCompleted", $d5d5c243a98208af$var$_FeatureGates.client.initializeCompleted.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "initialize", $d5d5c243a98208af$var$_FeatureGates.client.initialize.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "initializeWithProvider", $d5d5c243a98208af$var$_FeatureGates.client.initializeWithProvider.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "initializeFromValues", $d5d5c243a98208af$var$_FeatureGates.client.initializeFromValues.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "manuallyLogGateExposure", $d5d5c243a98208af$var$_FeatureGates.client.manuallyLogGateExposure.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "getExperiment", $d5d5c243a98208af$var$_FeatureGates.client.getExperiment.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "manuallyLogExperimentExposure", $d5d5c243a98208af$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "manuallyLogLayerExposure", $d5d5c243a98208af$var$_FeatureGates.client.manuallyLogLayerExposure.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "shutdownStatsig", $d5d5c243a98208af$var$_FeatureGates.client.shutdownStatsig.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "overrideGate", $d5d5c243a98208af$var$_FeatureGates.client.overrideGate.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "clearGateOverride", $d5d5c243a98208af$var$_FeatureGates.client.clearGateOverride.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "overrideConfig", $d5d5c243a98208af$var$_FeatureGates.client.overrideConfig.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "clearConfigOverride", $d5d5c243a98208af$var$_FeatureGates.client.clearConfigOverride.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "setOverrides", $d5d5c243a98208af$var$_FeatureGates.client.setOverrides.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "getOverrides", $d5d5c243a98208af$var$_FeatureGates.client.getOverrides.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "clearAllOverrides", $d5d5c243a98208af$var$_FeatureGates.client.clearAllOverrides.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "isCurrentUser", $d5d5c243a98208af$var$_FeatureGates.client.isCurrentUser.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "onGateUpdated", $d5d5c243a98208af$var$_FeatureGates.client.onGateUpdated.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "onExperimentValueUpdated", $d5d5c243a98208af$var$_FeatureGates.client.onExperimentValueUpdated.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "onAnyUpdated", $d5d5c243a98208af$var$_FeatureGates.client.onAnyUpdated.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "updateUser", $d5d5c243a98208af$var$_FeatureGates.client.updateUser.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "updateUserWithProvider", $d5d5c243a98208af$var$_FeatureGates.client.updateUserWithProvider.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "updateUserWithValues", $d5d5c243a98208af$var$_FeatureGates.client.updateUserWithValues.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "getPackageVersion", $d5d5c243a98208af$var$_FeatureGates.client.getPackageVersion.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "getLayer", $d5d5c243a98208af$var$_FeatureGates.client.getLayer.bind($d5d5c243a98208af$var$_FeatureGates.client));
(0, $gNkVH.default)($d5d5c243a98208af$var$FeatureGates, "getLayerValue", $d5d5c243a98208af$var$_FeatureGates.client.getLayerValue.bind($d5d5c243a98208af$var$_FeatureGates.client));
var $d5d5c243a98208af$var$boundFGJS = $d5d5c243a98208af$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $d5d5c243a98208af$var$FeatureGates;
    else {
        var $d5d5c243a98208af$var$_boundFGJS, $d5d5c243a98208af$var$_boundFGJS$getPackage;
        $d5d5c243a98208af$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $d5d5c243a98208af$var$boundVersion = (($d5d5c243a98208af$var$_boundFGJS = $d5d5c243a98208af$var$boundFGJS) === null || $d5d5c243a98208af$var$_boundFGJS === void 0 || ($d5d5c243a98208af$var$_boundFGJS$getPackage = $d5d5c243a98208af$var$_boundFGJS.getPackageVersion) === null || $d5d5c243a98208af$var$_boundFGJS$getPackage === void 0 ? void 0 : $d5d5c243a98208af$var$_boundFGJS$getPackage.call($d5d5c243a98208af$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($d5d5c243a98208af$var$boundVersion !== (0, $iuQfp.CLIENT_VERSION)) {
            var $d5d5c243a98208af$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($d5d5c243a98208af$var$boundVersion, " when module version ").concat((0, $iuQfp.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($d5d5c243a98208af$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $d5d5c243a98208af$export$2e2bcd8739ae039 = $d5d5c243a98208af$var$boundFGJS;

});
parcelRegister("cQbBb", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $959356a5a545ace2$export$1f2bb630327ac4b6; });

var $lrM5r = parcelRequire("lrM5r");

var $6HNZJ = parcelRequire("6HNZJ");

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $c3LVh = parcelRequire("c3LVh");

var $ec1qE = parcelRequire("ec1qE");

var $5gKQb = parcelRequire("5gKQb");

var $bMImJ = parcelRequire("bMImJ");

var $9OPky = parcelRequire("9OPky");

var $8LElh = parcelRequire("8LElh");

var $crHTm = parcelRequire("crHTm");

var $50WPW = parcelRequire("50WPW");

var $7lrmE = parcelRequire("7lrmE");

var $fJGGD = parcelRequire("fJGGD");

var $l5392 = parcelRequire("l5392");

var $iuQfp = parcelRequire("iuQfp");
var $959356a5a545ace2$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $959356a5a545ace2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $959356a5a545ace2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $959356a5a545ace2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $959356a5a545ace2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $959356a5a545ace2$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $959356a5a545ace2$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $959356a5a545ace2$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $7lrmE.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $zhrfT.default)(this, Client);
        (0, $gNkVH.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $gNkVH.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $gNkVH.default)(this, "initWithDefaults", false);
        (0, $gNkVH.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $gNkVH.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $gNkVH.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $gNkVH.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $gNkVH.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $gNkVH.default)(this, "subscriptions", new (0, $5gKQb.default)());
        (0, $gNkVH.default)(this, "dataAdapter", new (0, $50WPW.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $gNkVH.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $7lrmE.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $j9c2S.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $l5392.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $l5392.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $l5392.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $l5392.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $iuQfp.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $959356a5a545ace2$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $iuQfp.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $fJGGD.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $l5392.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $l5392.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $l5392.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $crHTm.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $bMImJ.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $bMImJ.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $8LElh.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $l5392.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $l5392.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $959356a5a545ace2$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $crHTm.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $crHTm.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $6HNZJ.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $959356a5a545ace2$var$_objectSpread($959356a5a545ace2$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $6HNZJ.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $l5392.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $959356a5a545ace2$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $959356a5a545ace2$var$_objectSpread($959356a5a545ace2$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $959356a5a545ace2$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $fJGGD.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $lrM5r.default)(newClientOptions, $959356a5a545ace2$var$_excluded);
                                this.user = (0, $l5392.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $959356a5a545ace2$var$_objectSpread($959356a5a545ace2$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($959356a5a545ace2$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $l5392.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $iuQfp.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $9OPky.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $9OPky.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("ec1qE", function(module, exports) {
"use strict";
var $a5534b64b90e8bb7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a5534b64b90e8bb7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a5534b64b90e8bb7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $kmjKS = parcelRequire("kmjKS");
module.exports.StatsigClient = $kmjKS.default;

$a5534b64b90e8bb7$var$__exportStar((parcelRequire("3wfvf")), module.exports);
const $a5534b64b90e8bb7$var$__STATSIG__ = Object.assign((0, (parcelRequire("3wfvf"))._getStatsigGlobal)(), {
    StatsigClient: $kmjKS.default
});
module.exports.default = $a5534b64b90e8bb7$var$__STATSIG__;

});
parcelRegister("3wfvf", function(module, exports) {
"use strict";
var $290062d377b98678$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $290062d377b98678$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $290062d377b98678$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cNoBO")).Diagnostics;
    }
});

var $jk1UR = parcelRequire("jk1UR");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $jk1UR.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("h8zQz")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1t55x")).Storage;
    }
});

$290062d377b98678$var$__exportStar((parcelRequire("8hwyQ")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("3UfbT")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("hjNCl")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("98KAi")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("cNoBO")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("7W5Q6")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("fLblJ")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("9ERy0")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("lffUl")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("4YCTW")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("6mDJF")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("h8zQz")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("21UEO")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("f3mOz")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("jCAxg")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("4NkWJ")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("9FKO2")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("fGeIs")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("4PNbh")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("jTyty")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("lPDql")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("hw3W7")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("fIgnZ")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("4Kxyc")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("7WRgq")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("grUKi")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("5eSvi")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("afBAd")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("6tqtC")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("6n5RP")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("8LQvF")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("il5Et")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("1t55x")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("6Pv6p")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("h2d8E")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("c0H08")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("lWGvq")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("6MbBU")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("8z4cO")), module.exports);

$290062d377b98678$var$__exportStar((parcelRequire("5wm3q")), module.exports);
Object.assign((0, (parcelRequire("8hwyQ"))._getStatsigGlobal)(), {
    Log: (parcelRequire("h8zQz")).Log,
    SDK_VERSION: (parcelRequire("5eSvi")).SDK_VERSION
});

});
parcelRegister("8hwyQ", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $60792b2f4a86604e$var$_a, $60792b2f4a86604e$var$_b, $60792b2f4a86604e$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $h8zQz = parcelRequire("h8zQz");
const $60792b2f4a86604e$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $60792b2f4a86604e$var$statsigGlobal;
    } catch (e) {
        return $60792b2f4a86604e$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $60792b2f4a86604e$var$_getStatsigGlobal;
const $60792b2f4a86604e$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $60792b2f4a86604e$var$_getStatsigGlobalFlag;
const $60792b2f4a86604e$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $h8zQz.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $60792b2f4a86604e$var$_getInstance;
const $60792b2f4a86604e$var$GLOBAL_KEY = '__STATSIG__';
const $60792b2f4a86604e$var$_window = typeof window !== 'undefined' ? window : {};
const $60792b2f4a86604e$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $60792b2f4a86604e$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $60792b2f4a86604e$var$statsigGlobal = ($60792b2f4a86604e$var$_c = ($60792b2f4a86604e$var$_b = ($60792b2f4a86604e$var$_a = $60792b2f4a86604e$var$_window[$60792b2f4a86604e$var$GLOBAL_KEY]) !== null && $60792b2f4a86604e$var$_a !== void 0 ? $60792b2f4a86604e$var$_a : $60792b2f4a86604e$var$_global[$60792b2f4a86604e$var$GLOBAL_KEY]) !== null && $60792b2f4a86604e$var$_b !== void 0 ? $60792b2f4a86604e$var$_b : $60792b2f4a86604e$var$_globalThis[$60792b2f4a86604e$var$GLOBAL_KEY]) !== null && $60792b2f4a86604e$var$_c !== void 0 ? $60792b2f4a86604e$var$_c : {
    instance: module.exports._getInstance
};
$60792b2f4a86604e$var$_window[$60792b2f4a86604e$var$GLOBAL_KEY] = $60792b2f4a86604e$var$statsigGlobal;
$60792b2f4a86604e$var$_global[$60792b2f4a86604e$var$GLOBAL_KEY] = $60792b2f4a86604e$var$statsigGlobal;
$60792b2f4a86604e$var$_globalThis[$60792b2f4a86604e$var$GLOBAL_KEY] = $60792b2f4a86604e$var$statsigGlobal;

});
parcelRegister("h8zQz", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $c79efd76d1859a68$var$DEBUG = ' DEBUG ';
const $c79efd76d1859a68$var$_INFO = '  INFO ';
const $c79efd76d1859a68$var$_WARN = '  WARN ';
const $c79efd76d1859a68$var$ERROR = ' ERROR ';
function $c79efd76d1859a68$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $c79efd76d1859a68$var$Log {
    static info(...args) {
        if ($c79efd76d1859a68$var$Log.level >= module.exports.LogLevel.Info) console.info($c79efd76d1859a68$var$_INFO, ...$c79efd76d1859a68$var$addTag(args));
    }
    static debug(...args) {
        if ($c79efd76d1859a68$var$Log.level >= module.exports.LogLevel.Debug) console.debug($c79efd76d1859a68$var$DEBUG, ...$c79efd76d1859a68$var$addTag(args));
    }
    static warn(...args) {
        if ($c79efd76d1859a68$var$Log.level >= module.exports.LogLevel.Warn) console.warn($c79efd76d1859a68$var$_WARN, ...$c79efd76d1859a68$var$addTag(args));
    }
    static error(...args) {
        if ($c79efd76d1859a68$var$Log.level >= module.exports.LogLevel.Error) console.error($c79efd76d1859a68$var$ERROR, ...$c79efd76d1859a68$var$addTag(args));
    }
}
module.exports.Log = $c79efd76d1859a68$var$Log;
$c79efd76d1859a68$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("cNoBO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $950d26721f7e7620$var$MARKER_MAP = new Map();
const $950d26721f7e7620$var$ACT_START = 'start';
const $950d26721f7e7620$var$ACT_END = 'end';
const $950d26721f7e7620$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $950d26721f7e7620$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $950d26721f7e7620$var$_addMarker(sdkKey, $950d26721f7e7620$var$_createMarker({}, $950d26721f7e7620$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $950d26721f7e7620$var$_addMarker(sdkKey, $950d26721f7e7620$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $950d26721f7e7620$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $950d26721f7e7620$var$_addMarker(sdkKey, $950d26721f7e7620$var$_createMarker(data, $950d26721f7e7620$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $950d26721f7e7620$var$_addMarker(sdkKey, $950d26721f7e7620$var$_createMarker(data, $950d26721f7e7620$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $950d26721f7e7620$var$_addMarker(sdkKey, $950d26721f7e7620$var$_createMarker({}, $950d26721f7e7620$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $950d26721f7e7620$var$_addMarker(sdkKey, $950d26721f7e7620$var$_createMarker(data, $950d26721f7e7620$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $950d26721f7e7620$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $950d26721f7e7620$var$_safeGetField(e, 'code'),
            name: $950d26721f7e7620$var$_safeGetField(e, 'name'),
            message: $950d26721f7e7620$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $950d26721f7e7620$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $950d26721f7e7620$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $950d26721f7e7620$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $950d26721f7e7620$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $950d26721f7e7620$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $950d26721f7e7620$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $950d26721f7e7620$var$MARKER_MAP.set(sdkKey, markers);
}
function $950d26721f7e7620$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("jk1UR", function(module, exports) {
"use strict";
var $e1115f178984e9a3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $3UfbT = parcelRequire("3UfbT");

var $4YCTW = parcelRequire("4YCTW");

var $h8zQz = parcelRequire("h8zQz");

var $f3mOz = parcelRequire("f3mOz");

var $fGeIs = parcelRequire("fGeIs");

var $grUKi = parcelRequire("grUKi");

var $afBAd = parcelRequire("afBAd");

var $1t55x = parcelRequire("1t55x");

var $c0H08 = parcelRequire("c0H08");

var $6MbBU = parcelRequire("6MbBU");
const $e1115f178984e9a3$var$DEFAULT_QUEUE_SIZE = 100;
const $e1115f178984e9a3$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $e1115f178984e9a3$var$MAX_DEDUPER_KEYS = 1000;
const $e1115f178984e9a3$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $e1115f178984e9a3$var$MAX_FAILED_LOGS = 500;
const $e1115f178984e9a3$var$QUICK_FLUSH_WINDOW_MS = 200;
const $e1115f178984e9a3$var$EVENT_LOGGER_MAP = {};
const $e1115f178984e9a3$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $e1115f178984e9a3$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $e1115f178984e9a3$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $e1115f178984e9a3$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($e1115f178984e9a3$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $afBAd.LoggingEnabledOption.disabled : $afBAd.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $h8zQz.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $e1115f178984e9a3$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $c0H08.UrlConfiguration($f3mOz.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $e1115f178984e9a3$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $fGeIs._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $e1115f178984e9a3$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $6MbBU._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $e1115f178984e9a3$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $e1115f178984e9a3$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($e1115f178984e9a3$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $e1115f178984e9a3$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $e1115f178984e9a3$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $e1115f178984e9a3$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $e1115f178984e9a3$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$e1115f178984e9a3$var$EventLogger._safeFlushAndForget(this._sdkKey), $e1115f178984e9a3$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $fGeIs._isServerEnv)()) return false;
        if (!(0, $grUKi._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $3UfbT._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $e1115f178984e9a3$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $e1115f178984e9a3$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $e1115f178984e9a3$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $6MbBU._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $h8zQz.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $h8zQz.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $e1115f178984e9a3$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$f3mOz.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $e1115f178984e9a3$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $1t55x._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $h8zQz.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$e1115f178984e9a3$var$__awaiter(this, void 0, void 0, function*() {
                if (!$1t55x.Storage.isReady()) yield $1t55x.Storage.isReadyResolver();
                const events = (0, $1t55x._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $e1115f178984e9a3$var$RetryFailedLogsTrigger.Startup) $1t55x.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $e1115f178984e9a3$var$RetryFailedLogsTrigger.GainedFocus) $1t55x.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $h8zQz.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $4YCTW._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $h8zQz.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $fGeIs._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $e1115f178984e9a3$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $e1115f178984e9a3$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $e1115f178984e9a3$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $e1115f178984e9a3$var$EventLogger;

});
parcelRegister("3UfbT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $4YCTW = parcelRequire("4YCTW");
function $2d8262a348be037c$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $4YCTW._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $2d8262a348be037c$var$_getUserStorageKey;
function $2d8262a348be037c$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $2d8262a348be037c$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $4YCTW._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $2d8262a348be037c$var$_getStorageKey;

});
parcelRegister("4YCTW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $h2d8E = parcelRequire("h2d8E");
const $39faf107d15c421f$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $39faf107d15c421f$var$_DJB2;
const $39faf107d15c421f$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $39faf107d15c421f$var$_DJB2Object;
const $39faf107d15c421f$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $h2d8E._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $39faf107d15c421f$var$_getSortedObject;

});
parcelRegister("h2d8E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $c66cd09d5329aaef$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $c66cd09d5329aaef$var$_typeOf;
function $c66cd09d5329aaef$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $c66cd09d5329aaef$var$_isTypeMatch;

});



parcelRegister("f3mOz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("fGeIs", function(module, exports) {

var $7t0tI = parcelRequire("7t0tI");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $b6a6318e702ad4d7$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $b6a6318e702ad4d7$var$_getWindowSafe;
const $b6a6318e702ad4d7$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $b6a6318e702ad4d7$var$_getDocumentSafe;
const $b6a6318e702ad4d7$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $7t0tI !== 'undefined' && $7t0tI.versions != null && $7t0tI.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $b6a6318e702ad4d7$var$_isServerEnv;
const $b6a6318e702ad4d7$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $b6a6318e702ad4d7$var$_addWindowEventListenerSafe;
const $b6a6318e702ad4d7$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $b6a6318e702ad4d7$var$_addDocumentEventListenerSafe;
const $b6a6318e702ad4d7$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $b6a6318e702ad4d7$var$_getCurrentPageUrlSafe;
const $b6a6318e702ad4d7$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $b6a6318e702ad4d7$var$_getUnloadEvent;

});

parcelRegister("grUKi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $bf9b2f76168973ae$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $bf9b2f76168973ae$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $bf9b2f76168973ae$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $bf9b2f76168973ae$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $bf9b2f76168973ae$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $bf9b2f76168973ae$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $bf9b2f76168973ae$var$GATE_EXPOSURE_NAME || eventName === $bf9b2f76168973ae$var$CONFIG_EXPOSURE_NAME || eventName === $bf9b2f76168973ae$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $bf9b2f76168973ae$var$_isExposureEvent;
const $bf9b2f76168973ae$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $bf9b2f76168973ae$var$_createExposure($bf9b2f76168973ae$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $bf9b2f76168973ae$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $bf9b2f76168973ae$var$_createGateExposure;
function $bf9b2f76168973ae$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $bf9b2f76168973ae$var$_mapExposures;
const $bf9b2f76168973ae$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $bf9b2f76168973ae$var$_createExposure($bf9b2f76168973ae$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $bf9b2f76168973ae$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $bf9b2f76168973ae$var$_createConfigExposure;
const $bf9b2f76168973ae$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $bf9b2f76168973ae$var$_createExposure($bf9b2f76168973ae$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $bf9b2f76168973ae$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $bf9b2f76168973ae$var$_createLayerParameterExposure;
const $bf9b2f76168973ae$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("afBAd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("1t55x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $h8zQz = parcelRequire("h8zQz");

var $fGeIs = parcelRequire("fGeIs");
const $111c72536c2ebba1$var$inMemoryStore = {};
const $111c72536c2ebba1$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$111c72536c2ebba1$var$inMemoryStore[key] ? $111c72536c2ebba1$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $111c72536c2ebba1$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $111c72536c2ebba1$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($111c72536c2ebba1$var$inMemoryStore)
};
let $111c72536c2ebba1$var$_localStorageProvider = null;
try {
    const win = (0, $fGeIs._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $111c72536c2ebba1$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $h8zQz.Log.warn('Failed to setup localStorageProvider.');
}
let $111c72536c2ebba1$var$_main = $111c72536c2ebba1$var$_localStorageProvider !== null && $111c72536c2ebba1$var$_localStorageProvider !== void 0 ? $111c72536c2ebba1$var$_localStorageProvider : $111c72536c2ebba1$var$_inMemoryProvider;
let $111c72536c2ebba1$var$_current = $111c72536c2ebba1$var$_main;
function $111c72536c2ebba1$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($111c72536c2ebba1$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$111c72536c2ebba1$var$_current.isReady(),
    isReadyResolver: ()=>$111c72536c2ebba1$var$_current.isReadyResolver(),
    getProviderName: ()=>$111c72536c2ebba1$var$_current.getProviderName(),
    getItem: (key)=>$111c72536c2ebba1$var$_inMemoryBreaker(()=>$111c72536c2ebba1$var$_current.getItem(key)),
    setItem: (key, value)=>$111c72536c2ebba1$var$_inMemoryBreaker(()=>$111c72536c2ebba1$var$_current.setItem(key, value)),
    removeItem: (key)=>$111c72536c2ebba1$var$_current.removeItem(key),
    getAllKeys: ()=>$111c72536c2ebba1$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $111c72536c2ebba1$var$_main = newProvider;
        $111c72536c2ebba1$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $111c72536c2ebba1$var$_current = $111c72536c2ebba1$var$_inMemoryProvider;
        else $111c72536c2ebba1$var$_current = $111c72536c2ebba1$var$_main;
    }
};
function $111c72536c2ebba1$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $111c72536c2ebba1$var$_getObjectFromStorage;
function $111c72536c2ebba1$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $111c72536c2ebba1$var$_setObjectInStorage;

});

parcelRegister("c0H08", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $4YCTW = parcelRequire("4YCTW");

var $f3mOz = parcelRequire("f3mOz");
const $8be6d7489dcf1e4c$var$ENDPOINT_DNS_KEY_MAP = {
    [$f3mOz.Endpoint._initialize]: 'i',
    [$f3mOz.Endpoint._rgstr]: 'e',
    [$f3mOz.Endpoint._download_config_specs]: 'd'
};
class $8be6d7489dcf1e4c$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $8be6d7489dcf1e4c$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $f3mOz.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $4YCTW._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $8be6d7489dcf1e4c$var$UrlConfiguration;

});

parcelRegister("6MbBU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $fGeIs = parcelRequire("fGeIs");
const $4ef03b5f61bac3f5$var$FOREGROUND = 'foreground';
const $4ef03b5f61bac3f5$var$BACKGROUND = 'background';
const $4ef03b5f61bac3f5$var$LISTENERS = [];
let $4ef03b5f61bac3f5$var$current = $4ef03b5f61bac3f5$var$FOREGROUND;
let $4ef03b5f61bac3f5$var$isUnloading = false;
const $4ef03b5f61bac3f5$var$_isCurrentlyVisible = ()=>{
    return $4ef03b5f61bac3f5$var$current === $4ef03b5f61bac3f5$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $4ef03b5f61bac3f5$var$_isCurrentlyVisible;
const $4ef03b5f61bac3f5$var$_isUnloading = ()=>$4ef03b5f61bac3f5$var$isUnloading;
module.exports._isUnloading = $4ef03b5f61bac3f5$var$_isUnloading;
const $4ef03b5f61bac3f5$var$_subscribeToVisiblityChanged = (listener)=>{
    $4ef03b5f61bac3f5$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $4ef03b5f61bac3f5$var$_subscribeToVisiblityChanged;
const $4ef03b5f61bac3f5$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $4ef03b5f61bac3f5$var$current) return;
    $4ef03b5f61bac3f5$var$current = visibility;
    $4ef03b5f61bac3f5$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $4ef03b5f61bac3f5$var$_notifyVisibilityChanged;
(0, $fGeIs._addWindowEventListenerSafe)('focus', ()=>{
    $4ef03b5f61bac3f5$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($4ef03b5f61bac3f5$var$FOREGROUND);
});
(0, $fGeIs._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($4ef03b5f61bac3f5$var$BACKGROUND));
(0, $fGeIs._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $4ef03b5f61bac3f5$var$FOREGROUND : $4ef03b5f61bac3f5$var$BACKGROUND);
});
(0, $fGeIs._addWindowEventListenerSafe)((0, $fGeIs._getUnloadEvent)(), ()=>{
    $4ef03b5f61bac3f5$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($4ef03b5f61bac3f5$var$BACKGROUND);
});

});


parcelRegister("5eSvi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.22.0';
let $3d0889db42bb3bd8$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$3d0889db42bb3bd8$var$metadata,
    add: (additions)=>{
        $3d0889db42bb3bd8$var$metadata = Object.assign(Object.assign({}, $3d0889db42bb3bd8$var$metadata), additions);
    }
};

});

parcelRegister("hjNCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("98KAi", function(module, exports) {
"use strict";
var $6a78ff1e581bf8c9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $h8zQz = parcelRequire("h8zQz");

var $hw3W7 = parcelRequire("hw3W7");

var $il5Et = parcelRequire("il5Et");

var $1t55x = parcelRequire("1t55x");

var $6Pv6p = parcelRequire("6Pv6p");
const $6a78ff1e581bf8c9$var$CACHE_LIMIT = 10;
class $6a78ff1e581bf8c9$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $6a78ff1e581bf8c9$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $il5Et._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $il5Et._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $6a78ff1e581bf8c9$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $hw3W7.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $6a78ff1e581bf8c9$var$__awaiter(this, void 0, void 0, function*() {
            if (!$1t55x.Storage.isReady()) yield $1t55x.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $h8zQz.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $6a78ff1e581bf8c9$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $il5Et._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $6a78ff1e581bf8c9$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $h8zQz.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $6Pv6p._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $hw3W7.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $6a78ff1e581bf8c9$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $6a78ff1e581bf8c9$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $h8zQz.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $1t55x.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($1t55x.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $6Pv6p._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $1t55x.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $1t55x._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $6a78ff1e581bf8c9$var$_getEvictableKey(lastModifiedTimeMap, $6a78ff1e581bf8c9$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $1t55x.Storage.removeItem(evictable);
        }
        (0, $1t55x._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $6a78ff1e581bf8c9$var$DataAdapterCore;
function $6a78ff1e581bf8c9$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $il5Et._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $6a78ff1e581bf8c9$var$_makeDataAdapterResult;
class $6a78ff1e581bf8c9$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $h8zQz.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $6a78ff1e581bf8c9$var$_getEvictableKey(this._data, $6a78ff1e581bf8c9$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $6a78ff1e581bf8c9$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("hw3W7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $3UfbT = parcelRequire("3UfbT");

var $h8zQz = parcelRequire("h8zQz");

var $fGeIs = parcelRequire("fGeIs");

var $1t55x = parcelRequire("1t55x");

var $lWGvq = parcelRequire("lWGvq");
const $cc087a869c2e7c09$var$PROMISE_MAP = {};
const $cc087a869c2e7c09$var$COOKIE_ENABLED_MAP = {};
const $cc087a869c2e7c09$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($cc087a869c2e7c09$var$DISABLED_MAP[sdkKey]) return null;
        if ($cc087a869c2e7c09$var$PROMISE_MAP[sdkKey] != null) return $cc087a869c2e7c09$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $cc087a869c2e7c09$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $cc087a869c2e7c09$var$PROMISE_MAP[sdkKey] = stableID;
            $cc087a869c2e7c09$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $cc087a869c2e7c09$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $lWGvq.getUUID)();
        $cc087a869c2e7c09$var$_persistToStorage(stableID, sdkKey);
        $cc087a869c2e7c09$var$_persistToCookie(stableID, sdkKey);
        $cc087a869c2e7c09$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $cc087a869c2e7c09$var$PROMISE_MAP[sdkKey] = override;
        $cc087a869c2e7c09$var$_persistToStorage(override, sdkKey);
        $cc087a869c2e7c09$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $cc087a869c2e7c09$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $cc087a869c2e7c09$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $cc087a869c2e7c09$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $3UfbT._getStorageKey)(sdkKey)}`;
}
function $cc087a869c2e7c09$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $cc087a869c2e7c09$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $1t55x._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $h8zQz.Log.warn('Failed to save StableID to storage');
    }
}
function $cc087a869c2e7c09$var$_loadFromStorage(sdkKey) {
    const storageKey = $cc087a869c2e7c09$var$_getStableIDStorageKey(sdkKey);
    return (0, $1t55x._getObjectFromStorage)(storageKey);
}
function $cc087a869c2e7c09$var$_loadFromCookie(sdkKey) {
    if (!$cc087a869c2e7c09$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $fGeIs._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $cc087a869c2e7c09$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $cc087a869c2e7c09$var$_persistToCookie(stableID, sdkKey) {
    if (!$cc087a869c2e7c09$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$cc087a869c2e7c09$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $cc087a869c2e7c09$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $3UfbT._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("lWGvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $ff9ffc8a34abcc83$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $ff9ffc8a34abcc83$var$getUUID;

});


parcelRegister("il5Et", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $4YCTW = parcelRequire("4YCTW");

var $h8zQz = parcelRequire("h8zQz");
function $d59e927cde110e5f$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $h8zQz.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $d59e927cde110e5f$var$_normalizeUser;
function $d59e927cde110e5f$var$_getFullUserHash(user) {
    return user ? (0, $4YCTW._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $d59e927cde110e5f$var$_getFullUserHash;

});

parcelRegister("6Pv6p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $h8zQz = parcelRequire("h8zQz");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $4f8fa1cddda289fa$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $h8zQz.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $4f8fa1cddda289fa$var$_typedJsonParse;

});


parcelRegister("7W5Q6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fLblJ", function(module, exports) {
"use strict";
var $b7940c97f217b561$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $h8zQz = parcelRequire("h8zQz");

var $4PNbh = parcelRequire("4PNbh");

var $5eSvi = parcelRequire("5eSvi");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $b7940c97f217b561$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $b7940c97f217b561$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $b7940c97f217b561$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $b7940c97f217b561$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $h8zQz.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$b7940c97f217b561$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($b7940c97f217b561$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $b7940c97f217b561$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $4PNbh.SDKType._get(this._sdkKey);
                    const statsigMetadata = $5eSvi.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $b7940c97f217b561$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $b7940c97f217b561$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $b7940c97f217b561$var$ErrorBoundary;
function $b7940c97f217b561$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $b7940c97f217b561$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $b7940c97f217b561$var$UNKNOWN_ERROR;
    }
}
function $b7940c97f217b561$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $b7940c97f217b561$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("4PNbh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $385213235419b5b2$var$SDK_CLIENT = {};
let $385213235419b5b2$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $385213235419b5b2$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($385213235419b5b2$var$suffix !== null && $385213235419b5b2$var$suffix !== void 0 ? $385213235419b5b2$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $385213235419b5b2$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$385213235419b5b2$var$suffix || $385213235419b5b2$var$suffix === '-react') $385213235419b5b2$var$suffix = '-' + binding;
    }
};

});


parcelRegister("9ERy0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lffUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6mDJF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("21UEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $17a79fb787a33814$var$EXIST_KEYS = new Set([]);
const $17a79fb787a33814$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $17a79fb787a33814$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($17a79fb787a33814$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($17a79fb787a33814$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $17a79fb787a33814$var$createMemoKey;

});

parcelRegister("jCAxg", function(module, exports) {
"use strict";
var $e48de81cfaca3817$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $8hwyQ = parcelRequire("8hwyQ");

var $8hwyQ = parcelRequire("8hwyQ");

var $cNoBO = parcelRequire("cNoBO");

var $h8zQz = parcelRequire("h8zQz");

var $f3mOz = parcelRequire("f3mOz");

var $gGxdv = parcelRequire("gGxdv");

var $5wm3q = parcelRequire("5wm3q");

var $4PNbh = parcelRequire("4PNbh");

var $fGeIs = parcelRequire("fGeIs");

var $jTyty = parcelRequire("jTyty");

var $hw3W7 = parcelRequire("hw3W7");

var $4Kxyc = parcelRequire("4Kxyc");

var $5eSvi = parcelRequire("5eSvi");

var $afBAd = parcelRequire("afBAd");

var $6MbBU = parcelRequire("6MbBU");
const $e48de81cfaca3817$var$DEFAULT_TIMEOUT_MS = 10000;
const $e48de81cfaca3817$var$BACKOFF_BASE_MS = 500;
const $e48de81cfaca3817$var$BACKOFF_MAX_MS = 30000;
const $e48de81cfaca3817$var$RATE_LIMIT_WINDOW_MS = 1000;
const $e48de81cfaca3817$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $e48de81cfaca3817$var$LEAK_RATE = $e48de81cfaca3817$var$RATE_LIMIT_MAX_REQ_COUNT / $e48de81cfaca3817$var$RATE_LIMIT_WINDOW_MS;
const $e48de81cfaca3817$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $e48de81cfaca3817$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $e48de81cfaca3817$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $gGxdv.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$e48de81cfaca3817$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $e48de81cfaca3817$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $e48de81cfaca3817$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$e48de81cfaca3817$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $h8zQz.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $6MbBU._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $e48de81cfaca3817$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $e48de81cfaca3817$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $e48de81cfaca3817$var$_getErrorMessage(abortController, error);
                const timedOut = $e48de81cfaca3817$var$_didTimeout(abortController);
                $e48de81cfaca3817$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$e48de81cfaca3817$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $4Kxyc.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $h8zQz.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $e48de81cfaca3817$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $afBAd.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $afBAd.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $e48de81cfaca3817$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $e48de81cfaca3817$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $f3mOz.Endpoint._initialize || args.urlConfig.endpoint === $f3mOz.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$f3mOz.NetworkParam.SdkKey]: args.sdkKey,
            [$f3mOz.NetworkParam.SdkType]: $4PNbh.SDKType._get(args.sdkKey),
            [$f3mOz.NetworkParam.SdkVersion]: $5eSvi.SDK_VERSION,
            [$f3mOz.NetworkParam.Time]: String(Date.now()),
            [$f3mOz.NetworkParam.SessionID]: $jTyty.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $fGeIs._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $8hwyQ._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$f3mOz.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $h8zQz.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $e48de81cfaca3817$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$e48de81cfaca3817$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($h8zQz.Log.error);
                writer.close().catch($h8zQz.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$f3mOz.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $h8zQz.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $e48de81cfaca3817$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $e48de81cfaca3817$var$NetworkCore;
const $e48de81cfaca3817$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $h8zQz.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $e48de81cfaca3817$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $hw3W7.StableID.get(sdkKey);
    const sessionID = $jTyty.SessionID.get(sdkKey);
    const sdkType = $4PNbh.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $5eSvi.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $e48de81cfaca3817$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $8hwyQ._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $5wm3q.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $afBAd.LogEventCompressionMode.Disabled:
            return false;
        case $afBAd.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $afBAd.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $e48de81cfaca3817$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $e48de81cfaca3817$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $e48de81cfaca3817$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $f3mOz.Endpoint._initialize) return;
    $cNoBO.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $e48de81cfaca3817$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $f3mOz.Endpoint._initialize) return;
    $cNoBO.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $cNoBO.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $e48de81cfaca3817$var$_exponentialBackoff(attempt) {
    return $e48de81cfaca3817$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($e48de81cfaca3817$var$BACKOFF_BASE_MS * (attempt * attempt), $e48de81cfaca3817$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("gGxdv", function(module, exports) {
"use strict";
var $03227d40f8a3a018$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $dctaD = parcelRequire("dctaD");

var $4YCTW = parcelRequire("4YCTW");

var $h8zQz = parcelRequire("h8zQz");

var $1t55x = parcelRequire("1t55x");
const $03227d40f8a3a018$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $03227d40f8a3a018$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $03227d40f8a3a018$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $03227d40f8a3a018$var$DEFAULT_TTL_MS;
        $03227d40f8a3a018$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $03227d40f8a3a018$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $03227d40f8a3a018$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $03227d40f8a3a018$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$03227d40f8a3a018$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $03227d40f8a3a018$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $03227d40f8a3a018$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $03227d40f8a3a018$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $03227d40f8a3a018$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $dctaD._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $03227d40f8a3a018$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $03227d40f8a3a018$var$NetworkFallbackResolver;
function $03227d40f8a3a018$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $03227d40f8a3a018$var$_isDomainFailure;
function $03227d40f8a3a018$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $4YCTW._DJB2)(sdkKey)}`;
}
function $03227d40f8a3a018$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $03227d40f8a3a018$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $1t55x.Storage.removeItem(hashKey);
        return;
    }
    $1t55x.Storage.setItem(hashKey, JSON.stringify(info));
}
function $03227d40f8a3a018$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $03227d40f8a3a018$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $1t55x.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $h8zQz.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $03227d40f8a3a018$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("dctaD", function(module, exports) {
"use strict";
var $99c30608c56a8cab$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $99c30608c56a8cab$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $99c30608c56a8cab$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $99c30608c56a8cab$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $99c30608c56a8cab$var$MAX_START_LOOKUP = 200;
function $99c30608c56a8cab$var$_fetchTxtRecords(networkFunc) {
    return $99c30608c56a8cab$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($99c30608c56a8cab$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $99c30608c56a8cab$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $99c30608c56a8cab$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $99c30608c56a8cab$var$_fetchTxtRecords;
function $99c30608c56a8cab$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $99c30608c56a8cab$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $99c30608c56a8cab$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("5wm3q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $40510c6d4a58ccd1$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $40510c6d4a58ccd1$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $40510c6d4a58ccd1$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("jTyty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $8hwyQ = parcelRequire("8hwyQ");

var $3UfbT = parcelRequire("3UfbT");

var $h8zQz = parcelRequire("h8zQz");

var $1t55x = parcelRequire("1t55x");

var $lWGvq = parcelRequire("lWGvq");
const $e7bde589d4b7d10d$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $e7bde589d4b7d10d$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $e7bde589d4b7d10d$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($e7bde589d4b7d10d$var$PROMISE_MAP[sdkKey] == null) $e7bde589d4b7d10d$var$PROMISE_MAP[sdkKey] = $e7bde589d4b7d10d$var$_loadSession(sdkKey);
        const session = $e7bde589d4b7d10d$var$PROMISE_MAP[sdkKey];
        return $e7bde589d4b7d10d$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $e7bde589d4b7d10d$var$PROMISE_MAP[sdkKey] = $e7bde589d4b7d10d$var$_overrideSessionId(override, sdkKey);
    }
};
function $e7bde589d4b7d10d$var$_loadSession(sdkKey) {
    let data = $e7bde589d4b7d10d$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $lWGvq.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $e7bde589d4b7d10d$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $e7bde589d4b7d10d$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($e7bde589d4b7d10d$var$_isIdle(data) || $e7bde589d4b7d10d$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $lWGvq.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $e7bde589d4b7d10d$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $e7bde589d4b7d10d$var$_createSessionTimeout(sdkKey, $e7bde589d4b7d10d$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $e7bde589d4b7d10d$var$_createSessionTimeout(sdkKey, $e7bde589d4b7d10d$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $e7bde589d4b7d10d$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $8hwyQ._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $e7bde589d4b7d10d$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $e7bde589d4b7d10d$var$MAX_SESSION_IDLE_TIME;
}
function $e7bde589d4b7d10d$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $e7bde589d4b7d10d$var$MAX_SESSION_AGE;
}
function $e7bde589d4b7d10d$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $3UfbT._getStorageKey)(sdkKey)}`;
}
function $e7bde589d4b7d10d$var$_persistToStorage(session, sdkKey) {
    const storageKey = $e7bde589d4b7d10d$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $1t55x._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $h8zQz.Log.warn('Failed to save SessionID');
    }
}
function $e7bde589d4b7d10d$var$_loadFromStorage(sdkKey) {
    const storageKey = $e7bde589d4b7d10d$var$_getSessionIDStorageKey(sdkKey);
    return (0, $1t55x._getObjectFromStorage)(storageKey);
}

});

parcelRegister("4Kxyc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("4NkWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9FKO2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lPDql", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $fe4cf1286704d567$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $fe4cf1286704d567$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $fe4cf1286704d567$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $fe4cf1286704d567$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $fe4cf1286704d567$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $fe4cf1286704d567$var$_fastApproxSizeOf;

});

parcelRegister("fIgnZ", function(module, exports) {
"use strict";
var $b707acf61b88a9ff$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $8hwyQ = parcelRequire("8hwyQ");

var $8hwyQ = parcelRequire("8hwyQ");

var $fLblJ = parcelRequire("fLblJ");

var $jk1UR = parcelRequire("jk1UR");

var $h8zQz = parcelRequire("h8zQz");

var $21UEO = parcelRequire("21UEO");

var $fGeIs = parcelRequire("fGeIs");

var $jTyty = parcelRequire("jTyty");

var $hw3W7 = parcelRequire("hw3W7");

var $afBAd = parcelRequire("afBAd");

var $1t55x = parcelRequire("1t55x");
const $b707acf61b88a9ff$var$MAX_MEMO_CACHE_SIZE = 3000;
class $b707acf61b88a9ff$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($h8zQz.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $1t55x.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $jTyty.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $1t55x.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $hw3W7.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $hw3W7.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $jk1UR.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $fLblJ.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $1t55x.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $b707acf61b88a9ff$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $1t55x.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $hw3W7.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($afBAd.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $b707acf61b88a9ff$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $h8zQz.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $21UEO.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $b707acf61b88a9ff$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $b707acf61b88a9ff$var$StatsigClientBase;
function $b707acf61b88a9ff$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $fGeIs._isServerEnv)()) return;
    const statsigGlobal = (0, $8hwyQ._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $h8zQz.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("7WRgq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("6tqtC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6n5RP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $h8zQz = parcelRequire("h8zQz");

var $h2d8E = parcelRequire("h2d8E");
function $4a39712e53260b9a$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $4a39712e53260b9a$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $4a39712e53260b9a$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $4a39712e53260b9a$var$_makeFeatureGate;
function $4a39712e53260b9a$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $4a39712e53260b9a$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $4a39712e53260b9a$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $4a39712e53260b9a$var$_makeDynamicConfig;
function $4a39712e53260b9a$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $4a39712e53260b9a$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $4a39712e53260b9a$var$_makeExperiment;
function $4a39712e53260b9a$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $4a39712e53260b9a$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $4a39712e53260b9a$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $4a39712e53260b9a$var$_makeLayer;
function $4a39712e53260b9a$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $4a39712e53260b9a$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $4a39712e53260b9a$var$_mergeOverride;
function $4a39712e53260b9a$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $h2d8E._isTypeMatch)(found, fallback)) {
            $h8zQz.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $4a39712e53260b9a$var$_makeTypedGet;

});

parcelRegister("8LQvF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8z4cO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $63c4dac67f15eff7$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $63c4dac67f15eff7$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("kmjKS", function(module, exports) {
"use strict";
var $ed252fb09aac521a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3wfvf = parcelRequire("3wfvf");

var $kUjKj = parcelRequire("kUjKj");

var $bUCKT = parcelRequire("bUCKT");

var $fTBe1 = parcelRequire("fTBe1");

var $glKoP = parcelRequire("glKoP");
class $ed252fb09aac521a$var$StatsigClient extends $3wfvf.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $3wfvf._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $ed252fb09aac521a$var$StatsigClient) return instance;
        $3wfvf.Log.warn((0, $3wfvf._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $ed252fb09aac521a$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $3wfvf.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $bUCKT.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $glKoP.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($3wfvf.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($3wfvf.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($3wfvf.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($3wfvf.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($3wfvf.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($3wfvf.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $kUjKj.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $3wfvf.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $3wfvf.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $ed252fb09aac521a$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $3wfvf.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $3wfvf.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $ed252fb09aac521a$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $ed252fb09aac521a$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $3wfvf.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $3wfvf.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $3wfvf.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $3wfvf.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($3wfvf.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $3wfvf.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $3wfvf.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $3wfvf.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $3wfvf.StatsigSession.get(this._sdkKey),
            stableID: $3wfvf.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $ed252fb09aac521a$var$__awaiter(this, void 0, void 0, function*() {
            if (!$3wfvf.Storage.isReady()) yield $3wfvf.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $3wfvf.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $3wfvf.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $3wfvf._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $3wfvf.StableID.setOverride(stableIdOverride, this._sdkKey);
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $3wfvf._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $3wfvf._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $3wfvf._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $3wfvf._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $3wfvf._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $3wfvf._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $3wfvf._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $3wfvf._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $3wfvf._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $3wfvf._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $fTBe1._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $fTBe1._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $ed252fb09aac521a$var$StatsigClient;

});
parcelRegister("kUjKj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3wfvf = parcelRequire("3wfvf");
class $f3885ac2466b7976$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $3wfvf._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $3wfvf._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $3wfvf.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $3wfvf._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $3wfvf.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $3wfvf._getFullUserHash)(userForComparison) !== (0, $3wfvf._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $f3885ac2466b7976$var$EvaluationStore;

});

parcelRegister("bUCKT", function(module, exports) {
"use strict";
var $8ac2fca968fcc6a4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3wfvf = parcelRequire("3wfvf");

var $hpLmY = parcelRequire("hpLmY");
class $8ac2fca968fcc6a4$var$StatsigNetwork extends $3wfvf.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $3wfvf.UrlConfiguration($3wfvf.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $8ac2fca968fcc6a4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $3wfvf._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $8ac2fca968fcc6a4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $hpLmY._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $8ac2fca968fcc6a4$var$StatsigNetwork;

});
parcelRegister("hpLmY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $3wfvf = parcelRequire("3wfvf");
const $cad9840c545af971$var$MAX_DELTAS_SORT_DEPTH = 2;
function $cad9840c545af971$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $3wfvf._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $cad9840c545af971$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $cad9840c545af971$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $3wfvf._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $cad9840c545af971$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $cad9840c545af971$var$_resolveDeltasResponse;
function $cad9840c545af971$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $cad9840c545af971$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $cad9840c545af971$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $cad9840c545af971$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $cad9840c545af971$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $cad9840c545af971$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("fTBe1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $3wfvf = parcelRequire("3wfvf");
const $b928de3b9488013d$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $b928de3b9488013d$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $b928de3b9488013d$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $3wfvf._isTypeMatch)(value, fallback);
}
function $b928de3b9488013d$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $b928de3b9488013d$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $b928de3b9488013d$var$_shouldLogExposure(options) ? undefined : $b928de3b9488013d$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $b928de3b9488013d$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $b928de3b9488013d$var$_shouldLogExposure(options) ? undefined : $b928de3b9488013d$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($b928de3b9488013d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $b928de3b9488013d$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $b928de3b9488013d$var$_shouldLogExposure(options) ? undefined : $b928de3b9488013d$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($b928de3b9488013d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $b928de3b9488013d$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $b928de3b9488013d$var$_shouldLogExposure(options) ? undefined : $b928de3b9488013d$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($b928de3b9488013d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $b928de3b9488013d$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $3wfvf._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $b928de3b9488013d$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $b928de3b9488013d$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $b928de3b9488013d$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $b928de3b9488013d$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $b928de3b9488013d$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $b928de3b9488013d$var$_makeParamStoreGetter;

});

parcelRegister("glKoP", function(module, exports) {
"use strict";
var $be72997d8f5c63c2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $3wfvf = parcelRequire("3wfvf");

var $bUCKT = parcelRequire("bUCKT");
class $be72997d8f5c63c2$var$StatsigEvaluationsDataAdapter extends $3wfvf.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $bUCKT.default) this._network = network;
        else this._network = new $bUCKT.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $3wfvf._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $3wfvf._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $3wfvf.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $be72997d8f5c63c2$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $3wfvf._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$3wfvf.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $3wfvf._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $be72997d8f5c63c2$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("5gKQb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d62c7f27dfa461a$export$2e2bcd8739ae039; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $f72YL = parcelRequire("f72YL");
function $3d62c7f27dfa461a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d62c7f27dfa461a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d62c7f27dfa461a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d62c7f27dfa461a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3d62c7f27dfa461a$export$a66cbd9b2289cd78 = '@all-features';
var $3d62c7f27dfa461a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $zhrfT.default)(this, Subscriptions);
        (0, $gNkVH.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $j9c2S.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $3d62c7f27dfa461a$var$_objectSpread($3d62c7f27dfa461a$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $3d62c7f27dfa461a$var$_objectSpread($3d62c7f27dfa461a$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $3d62c7f27dfa461a$var$_objectSpread($3d62c7f27dfa461a$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $3d62c7f27dfa461a$var$_objectSpread($3d62c7f27dfa461a$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($3d62c7f27dfa461a$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($3d62c7f27dfa461a$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($3d62c7f27dfa461a$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $3d62c7f27dfa461a$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("f72YL", function(module, exports) {
'use strict';
var $b009d2076aa9fc78$var$has = Object.prototype.hasOwnProperty, $b009d2076aa9fc78$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $b009d2076aa9fc78$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $b009d2076aa9fc78$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $b009d2076aa9fc78$var$Events().__proto__) $b009d2076aa9fc78$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $b009d2076aa9fc78$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $b009d2076aa9fc78$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $b009d2076aa9fc78$var$EE(fn, context || emitter, once), evt = $b009d2076aa9fc78$var$prefix ? $b009d2076aa9fc78$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $b009d2076aa9fc78$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $b009d2076aa9fc78$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $b009d2076aa9fc78$var$EventEmitter() {
    this._events = new $b009d2076aa9fc78$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $b009d2076aa9fc78$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($b009d2076aa9fc78$var$has.call(events, name)) names.push($b009d2076aa9fc78$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $b009d2076aa9fc78$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $b009d2076aa9fc78$var$prefix ? $b009d2076aa9fc78$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $b009d2076aa9fc78$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $b009d2076aa9fc78$var$prefix ? $b009d2076aa9fc78$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $b009d2076aa9fc78$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $b009d2076aa9fc78$var$prefix ? $b009d2076aa9fc78$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $b009d2076aa9fc78$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $b009d2076aa9fc78$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $b009d2076aa9fc78$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $b009d2076aa9fc78$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $b009d2076aa9fc78$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $b009d2076aa9fc78$var$prefix ? $b009d2076aa9fc78$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $b009d2076aa9fc78$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $b009d2076aa9fc78$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $b009d2076aa9fc78$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $b009d2076aa9fc78$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $b009d2076aa9fc78$var$prefix ? $b009d2076aa9fc78$var$prefix + event : event;
        if (this._events[evt]) $b009d2076aa9fc78$var$clearEvent(this, evt);
    } else {
        this._events = new $b009d2076aa9fc78$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$b009d2076aa9fc78$var$EventEmitter.prototype.off = $b009d2076aa9fc78$var$EventEmitter.prototype.removeListener;
$b009d2076aa9fc78$var$EventEmitter.prototype.addListener = $b009d2076aa9fc78$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$b009d2076aa9fc78$var$EventEmitter.prefixed = $b009d2076aa9fc78$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$b009d2076aa9fc78$var$EventEmitter.EventEmitter = $b009d2076aa9fc78$var$EventEmitter;
module.exports = $b009d2076aa9fc78$var$EventEmitter;

});


parcelRegister("bMImJ", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $89469783f94575dc$export$6dc24881a3d96325; });

var $1nEzb = parcelRequire("1nEzb");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $l5392 = parcelRequire("l5392");
var $89469783f94575dc$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $zhrfT.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $j9c2S.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $1nEzb.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $1nEzb.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $l5392.migrateEvaluationDetails)(experiment.details), (0, $l5392.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("l5392", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $f58c8114c5bbb3ed$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $f58c8114c5bbb3ed$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $f58c8114c5bbb3ed$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $f58c8114c5bbb3ed$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $f58c8114c5bbb3ed$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $f58c8114c5bbb3ed$export$55fd683752d01e67; });

var $lrM5r = parcelRequire("lrM5r");

var $6HNZJ = parcelRequire("6HNZJ");

var $gNkVH = parcelRequire("gNkVH");

var $8cOyg = parcelRequire("8cOyg");

var $8LElh = parcelRequire("8LElh");

var $fJGGD = parcelRequire("fJGGD");
var $f58c8114c5bbb3ed$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $f58c8114c5bbb3ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f58c8114c5bbb3ed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f58c8114c5bbb3ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f58c8114c5bbb3ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f58c8114c5bbb3ed$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $f58c8114c5bbb3ed$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $8cOyg.isFedRamp)() ? (0, $fJGGD.PerimeterType).FEDRAMP_MODERATE : (0, $fJGGD.PerimeterType).COMMERCIAL
    }, options);
};
var $f58c8114c5bbb3ed$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $6HNZJ.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $6HNZJ.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $6HNZJ.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $6HNZJ.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $f58c8114c5bbb3ed$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $f58c8114c5bbb3ed$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $lrM5r.default)(options, $f58c8114c5bbb3ed$var$_excluded);
    return $f58c8114c5bbb3ed$var$_objectSpread($f58c8114c5bbb3ed$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $f58c8114c5bbb3ed$var$evaluationReasonMappings = Object.entries((0, $8LElh.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $6HNZJ.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $f58c8114c5bbb3ed$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $f58c8114c5bbb3ed$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $6HNZJ.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $8LElh.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $f58c8114c5bbb3ed$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("8cOyg", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", function () { return $5f96a83bc58e4e9e$export$64d6499adf9b2e51; });

var $cikRV = parcelRequire("cikRV");
function $5f96a83bc58e4e9e$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $cikRV.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("cikRV", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $8f375a98d3103e04$export$ce553301d55c2fd8; });
var $8f375a98d3103e04$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $8f375a98d3103e04$export$f005e2e9f707cb5f = 'commercial';
var $8f375a98d3103e04$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $8f375a98d3103e04$export$a739cd5aac835909 = 'stg';
var $8f375a98d3103e04$export$42dd0cdd351a4a9 = 'prod';
var $8f375a98d3103e04$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("8LElh", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $662201aa0f7d4d2c$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $662201aa0f7d4d2c$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("fJGGD", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $b74c2ba8ca16dcac$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $b74c2ba8ca16dcac$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $b74c2ba8ca16dcac$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $b74c2ba8ca16dcac$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $b74c2ba8ca16dcac$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("9OPky", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $726099c098834772$export$936d0764594b6eb3; });

var $1nEzb = parcelRequire("1nEzb");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $l5392 = parcelRequire("l5392");
var $726099c098834772$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $zhrfT.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $j9c2S.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $1nEzb.default)(val) === (0, $1nEzb.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $l5392.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $l5392.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $l5392.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("crHTm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90fa0daf2cc5ec61$export$2e2bcd8739ae039; });

var $gNkVH = parcelRequire("gNkVH");

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $c3LVh = parcelRequire("c3LVh");

var $fJGGD = parcelRequire("fJGGD");

var $iuQfp = parcelRequire("iuQfp");

var $cQtqr = parcelRequire("cQtqr");
function $90fa0daf2cc5ec61$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $90fa0daf2cc5ec61$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $90fa0daf2cc5ec61$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $90fa0daf2cc5ec61$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $90fa0daf2cc5ec61$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $90fa0daf2cc5ec61$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $90fa0daf2cc5ec61$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $90fa0daf2cc5ec61$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $90fa0daf2cc5ec61$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $90fa0daf2cc5ec61$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $90fa0daf2cc5ec61$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $90fa0daf2cc5ec61$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $90fa0daf2cc5ec61$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $90fa0daf2cc5ec61$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $90fa0daf2cc5ec61$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $zhrfT.default)(this, Fetcher);
    }
    return (0, $j9c2S.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $cQtqr.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $cQtqr.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $90fa0daf2cc5ec61$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $fJGGD.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $fJGGD.FeatureGateEnvironment).Production:
                        return $90fa0daf2cc5ec61$export$18c93900db9358a4;
                    case (0, $fJGGD.FeatureGateEnvironment).Staging:
                        return $90fa0daf2cc5ec61$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $fJGGD.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $fJGGD.FeatureGateEnvironment).Development:
                        return $90fa0daf2cc5ec61$export$f058dbf75c3bc647;
                    case (0, $fJGGD.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $90fa0daf2cc5ec61$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $90fa0daf2cc5ec61$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $90fa0daf2cc5ec61$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $90fa0daf2cc5ec61$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $iuQfp.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $90fa0daf2cc5ec61$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($90fa0daf2cc5ec61$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($90fa0daf2cc5ec61$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("iuQfp", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $d7738e9b27568c0a$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $d7738e9b27568c0a$export$a59f8d67326bd1cb = "5.5.3";

});

parcelRegister("cQtqr", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $95a12aaaec1a2ee9$export$286baf652d0b1206; });

var $j9c2S = parcelRequire("j9c2S");

var $zhrfT = parcelRequire("zhrfT");

var $4GP2Y = parcelRequire("4GP2Y");

var $ewpge = parcelRequire("ewpge");

var $6Ru4o = parcelRequire("6Ru4o");

var $jSJAq = parcelRequire("jSJAq");
function $95a12aaaec1a2ee9$var$_callSuper(t, o, e) {
    return o = (0, $ewpge.default)(o), (0, $4GP2Y.default)(t, $95a12aaaec1a2ee9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $ewpge.default)(t).constructor) : o.apply(t, e));
}
function $95a12aaaec1a2ee9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($95a12aaaec1a2ee9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $95a12aaaec1a2ee9$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $zhrfT.default)(this, ResponseError);
        return $95a12aaaec1a2ee9$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $6Ru4o.default)(ResponseError, _Error);
    return (0, $j9c2S.default)(ResponseError);
}(/*#__PURE__*/ (0, $jSJAq.default)(Error));

});
parcelRegister("jSJAq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e7966c03716fc543$export$2e2bcd8739ae039; });

var $ewpge = parcelRequire("ewpge");

var $bF8XE = parcelRequire("bF8XE");

var $e6hvf = parcelRequire("e6hvf");

var $aNgpo = parcelRequire("aNgpo");
function $e7966c03716fc543$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $e7966c03716fc543$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $e6hvf.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $aNgpo.default)(t, arguments, (0, $ewpge.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $bF8XE.default)(Wrapper, t);
    }, $e7966c03716fc543$export$2e2bcd8739ae039(t);
}

});
parcelRegister("e6hvf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a43f33f1a598c364$export$2e2bcd8739ae039; });
function $a43f33f1a598c364$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("aNgpo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7dbb3566603cd27f$export$2e2bcd8739ae039; });

var $f1sLJ = parcelRequire("f1sLJ");

var $bF8XE = parcelRequire("bF8XE");
function $7dbb3566603cd27f$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $f1sLJ.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $bF8XE.default)(p, r.prototype), p;
}

});
parcelRegister("f1sLJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aefd43e4e8bf945e$export$2e2bcd8739ae039; });
function $aefd43e4e8bf945e$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($aefd43e4e8bf945e$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("50WPW", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $3a6a9791a41dd942$export$55fffef3474104af; });

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $4GP2Y = parcelRequire("4GP2Y");

var $ewpge = parcelRequire("ewpge");

var $7TaZ5 = parcelRequire("7TaZ5");

var $6Ru4o = parcelRequire("6Ru4o");

var $gNkVH = parcelRequire("gNkVH");

var $c3LVh = parcelRequire("c3LVh");

var $ec1qE = parcelRequire("ec1qE");
function $3a6a9791a41dd942$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a6a9791a41dd942$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a6a9791a41dd942$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a6a9791a41dd942$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a6a9791a41dd942$var$_callSuper(t, o, e) {
    return o = (0, $ewpge.default)(o), (0, $4GP2Y.default)(t, $3a6a9791a41dd942$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $ewpge.default)(t).constructor) : o.apply(t, e));
}
function $3a6a9791a41dd942$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3a6a9791a41dd942$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3a6a9791a41dd942$var$_superPropGet(t, o, e, r) {
    var p = (0, $7TaZ5.default)((0, $ewpge.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $3a6a9791a41dd942$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $zhrfT.default)(this, NoFetchDataAdapter);
        _this = $3a6a9791a41dd942$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $gNkVH.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $6Ru4o.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $j9c2S.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $3a6a9791a41dd942$var$_objectSpread($3a6a9791a41dd942$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $3a6a9791a41dd942$var$_objectSpread($3a6a9791a41dd942$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $3a6a9791a41dd942$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $3a6a9791a41dd942$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});
parcelRegister("7TaZ5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5be630b9285898a7$export$2e2bcd8739ae039; });

var $j5GIP = parcelRequire("j5GIP");
function $5be630b9285898a7$export$2e2bcd8739ae039() {
    return $5be630b9285898a7$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $j5GIP.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $5be630b9285898a7$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("j5GIP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de5f9faa93c9d686$export$2e2bcd8739ae039; });

var $ewpge = parcelRequire("ewpge");
function $de5f9faa93c9d686$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $ewpge.default)(t)););
    return t;
}

});



parcelRegister("7lrmE", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $558fb88e88f133a4$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $558fb88e88f133a4$export$bcb28fbac1def494; });

var $gNkVH = parcelRequire("gNkVH");

var $6HNZJ = parcelRequire("6HNZJ");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $3wfvf = parcelRequire("3wfvf");
function $558fb88e88f133a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $558fb88e88f133a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $558fb88e88f133a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $558fb88e88f133a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $558fb88e88f133a4$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $558fb88e88f133a4$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $558fb88e88f133a4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $558fb88e88f133a4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $558fb88e88f133a4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $558fb88e88f133a4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $558fb88e88f133a4$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $558fb88e88f133a4$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $558fb88e88f133a4$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $558fb88e88f133a4$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $558fb88e88f133a4$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $558fb88e88f133a4$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $zhrfT.default)(this, PersistentOverrideAdapter);
        this._overrides = $558fb88e88f133a4$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $j9c2S.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $558fb88e88f133a4$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $558fb88e88f133a4$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $558fb88e88f133a4$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $6HNZJ.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $6HNZJ.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $6HNZJ.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($558fb88e88f133a4$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($558fb88e88f133a4$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $558fb88e88f133a4$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $558fb88e88f133a4$var$_objectSpread($558fb88e88f133a4$var$_objectSpread({}, $558fb88e88f133a4$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $6HNZJ.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $6HNZJ.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($558fb88e88f133a4$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $558fb88e88f133a4$var$_objectSpread($558fb88e88f133a4$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $558fb88e88f133a4$var$_objectSpread($558fb88e88f133a4$var$_objectSpread({}, current.details), {}, {
                        reason: $558fb88e88f133a4$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($558fb88e88f133a4$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $558fb88e88f133a4$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($558fb88e88f133a4$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $558fb88e88f133a4$var$_objectSpread($558fb88e88f133a4$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $558fb88e88f133a4$var$_objectSpread($558fb88e88f133a4$var$_objectSpread({}, current.details), {}, {
                        reason: $558fb88e88f133a4$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($558fb88e88f133a4$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $558fb88e88f133a4$var$_objectSpread($558fb88e88f133a4$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $558fb88e88f133a4$var$_objectSpread($558fb88e88f133a4$var$_objectSpread({}, current.details), {}, {
                        reason: $558fb88e88f133a4$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});




parcelRegister("kedcC", function(module, exports) {
$parcel$export(module.exports, "containsDnDMutationInStyle", function () { return $eb9f5b33db16754f$export$7867ddcf372cd2bf; });
$parcel$export(module.exports, "default", function () { return $eb9f5b33db16754f$export$2e2bcd8739ae039; });
function $eb9f5b33db16754f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $eb9f5b33db16754f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $eb9f5b33db16754f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $eb9f5b33db16754f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $eb9f5b33db16754f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $eb9f5b33db16754f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $eb9f5b33db16754f$var$isDnDStyleChange = function isDnDStyleChange(style) {
    return style.startsWith('anchor-name: --node-anchor');
};
var $eb9f5b33db16754f$var$parseStyleSet = function parseStyleSet(style) {
    if (!style) return null;
    var set = new Set();
    var _iterator = $eb9f5b33db16754f$var$_createForOfIteratorHelper(style.split(';')), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var part = _step.value;
            var t = part.trim();
            if (t) set.add(t);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $eb9f5b33db16754f$export$e20e7bf2c822f3df(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    if (!(target instanceof Element)) return false;
    return $eb9f5b33db16754f$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $eb9f5b33db16754f$export$7867ddcf372cd2bf(_ref2) {
    var attributeName = _ref2.attributeName, oldValue = _ref2.oldValue, newValue = _ref2.newValue;
    if (attributeName !== 'style') return false;
    var oldStyles = $eb9f5b33db16754f$var$parseStyleSet(oldValue);
    var newStyles = $eb9f5b33db16754f$var$parseStyleSet(newValue);
    var isDnDMutation = false;
    var _iterator2 = $eb9f5b33db16754f$var$_createForOfIteratorHelper(oldStyles !== null && oldStyles !== void 0 ? oldStyles : []), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var s = _step2.value;
            if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
                if (!$eb9f5b33db16754f$var$isDnDStyleChange(s)) return false;
                isDnDMutation = true;
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var _iterator3 = $eb9f5b33db16754f$var$_createForOfIteratorHelper(newStyles !== null && newStyles !== void 0 ? newStyles : []), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _s = _step3.value;
            if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(_s))) {
                if (!$eb9f5b33db16754f$var$isDnDStyleChange(_s)) return false;
                isDnDMutation = true;
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    return isDnDMutation;
}
var $eb9f5b33db16754f$export$2e2bcd8739ae039 = $eb9f5b33db16754f$export$e20e7bf2c822f3df;

});

parcelRegister("dKwwe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a028cbd0c20550d0$export$2e2bcd8739ae039; });

var $gNkVH = parcelRequire("gNkVH");

var $kOzMB = parcelRequire("kOzMB");

var $eAzuA = parcelRequire("eAzuA");

var $6HNZJ = parcelRequire("6HNZJ");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $c3LVh = parcelRequire("c3LVh");

var $9muGz = parcelRequire("9muGz");

var $hE35Q = parcelRequire("hE35Q");

var $eGFOB = parcelRequire("eGFOB");

var $a9FxO = parcelRequire("a9FxO");
function $a028cbd0c20550d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a028cbd0c20550d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a028cbd0c20550d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a028cbd0c20550d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a028cbd0c20550d0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a028cbd0c20550d0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a028cbd0c20550d0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a028cbd0c20550d0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a028cbd0c20550d0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a028cbd0c20550d0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Create comprehensive debug details including ignored entries
// Helper function for reporting ratios
function $a028cbd0c20550d0$var$roundDecimal(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
var $a028cbd0c20550d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, $zhrfT.default)(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
    }
    return (0, $j9c2S.default)(AbstractVCCalculatorBase, [
        {
            key: "filterViewportEntries",
            value: function filterViewportEntries(entries) {
                return entries.filter(function(entry) {
                    return 'rect' in entry.data;
                });
            }
        },
        {
            key: "calculateRatios",
            value: function calculateRatios(filteredEntries) {
                var ratios = {};
                var viewportWidth = (0, $a9FxO.default)();
                var viewportHeight = (0, $eGFOB.default)();
                var totalViewportArea = viewportWidth * viewportHeight;
                if (totalViewportArea === 0) return ratios;
                var elementRects = new Map();
                var _iterator = $a028cbd0c20550d0$var$_createForOfIteratorHelper(filteredEntries), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _entry = _step.value;
                        if ('rect' in _entry.data) {
                            var viewportEntry = _entry.data;
                            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var _iterator2 = $a028cbd0c20550d0$var$_createForOfIteratorHelper(elementRects), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var _step2$value = (0, $6HNZJ.default)(_step2.value, 2), elementName = _step2$value[0], rect = _step2$value[1];
                        var elementArea = rect.width * rect.height;
                        ratios[elementName] = $a028cbd0c20550d0$var$roundDecimal(elementArea / totalViewportArea);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return ratios;
            }
        },
        {
            key: "getLabelStacks",
            value: function getLabelStacks(filteredEntries, isPostInteraction) {
                var labelStacks = {};
                var _iterator3 = $a028cbd0c20550d0$var$_createForOfIteratorHelper(filteredEntries), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _entry2 = _step3.value;
                        if ('elementName' in _entry2.data && _entry2.data.labelStacks) {
                            if (isPostInteraction) labelStacks[_entry2.data.elementName] = {
                                segment: _entry2.data.labelStacks.segment,
                                labelStack: _entry2.data.labelStacks.labelStack
                            };
                            else labelStacks[_entry2.data.elementName] = _entry2.data.labelStacks.labelStack;
                        }
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return labelStacks;
            }
        },
        {
            key: "calculateWithDebugInfo",
            value: function() {
                var _calculateWithDebugInfo = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
                    var _window, _window2, _window3, _window4, _window6;
                    var percentiles, viewportEntries, _yield$calculateTTVCP, vcLogs, speedIndex, vcDetails, percentileIndex, entryDataBuffer, ssrRatio, layoutShiftInsights, previousViewportPercentage, _iterator4, _step4, _entry3, time, viewportPercentage, entries, elementNames, layoutShiftEntries, previousResult, i, percentile, enhancedVcLogs, shouldCalculate3p, shouldCalculateDebugDetails, sortedVcLogs, maxViewportPercentageAtTime, maxSoFar, _iterator5, _step5, log, getBiggestPreviousViewportPercentage, ignoredEntriesByTime, _iterator6, _step6, _entry4, _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou, viewportData, timestamp, additionalVcLogs, _iterator7, _step7, _step7$value, _timestamp, ignoredEntries, _viewportPercentage, v3RevisionDebugDetails, _window5, _window5$__ufo_devtoo, _window7, _window7$__on_ufo_vc_;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                percentiles = [
                                    25,
                                    50,
                                    75,
                                    80,
                                    85,
                                    90,
                                    95,
                                    98,
                                    99,
                                    100
                                ];
                                viewportEntries = this.filterViewportEntries(filteredEntries);
                                _context.next = 4;
                                return (0, $9muGz.calculateTTVCPercentilesWithDebugInfo)({
                                    viewport: {
                                        width: (0, $a9FxO.default)(),
                                        height: (0, $eGFOB.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: viewportEntries
                                });
                            case 4:
                                _yield$calculateTTVCP = _context.sent;
                                vcLogs = _yield$calculateTTVCP.entries;
                                speedIndex = _yield$calculateTTVCP.speedIndex;
                                vcDetails = {};
                                percentileIndex = 0;
                                entryDataBuffer = new Set();
                                ssrRatio = -1;
                                layoutShiftInsights = null;
                                previousViewportPercentage = 0;
                                if (!vcLogs) {
                                    _context.next = 35;
                                    break;
                                }
                                _iterator4 = $a028cbd0c20550d0$var$_createForOfIteratorHelper(vcLogs);
                                _context.prev = 15;
                                _iterator4.s();
                            case 17:
                                if ((_step4 = _iterator4.n()).done) {
                                    _context.next = 27;
                                    break;
                                }
                                _entry3 = _step4.value;
                                time = _entry3.time, viewportPercentage = _entry3.viewportPercentage, entries = _entry3.entries;
                                if (includeSSRRatio && ssrRatio === -1 && entries.some(function(e) {
                                    return e.elementName === 'SSR';
                                })) ssrRatio = viewportPercentage;
                                // Only process entries if we haven't reached all percentiles
                                if (!(percentileIndex >= percentiles.length)) {
                                    _context.next = 23;
                                    break;
                                }
                                return _context.abrupt("break", 27);
                            case 23:
                                // Check if this entry matches any checkpoint percentiles
                                if (viewportPercentage >= percentiles[percentileIndex]) {
                                    elementNames = (0, $kOzMB.default)(new Set(entries.map(function(e) {
                                        return e.elementName;
                                    }))); // Process all matching percentiles in one go
                                    while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                                        vcDetails["".concat(percentiles[percentileIndex])] = {
                                            t: Math.round(time),
                                            e: elementNames
                                        };
                                        if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some(function(e) {
                                            return e.type === 'layout-shift';
                                        })) {
                                            layoutShiftEntries = entries.filter(function(e) {
                                                return e.type === 'layout-shift';
                                            });
                                            layoutShiftInsights = {
                                                layoutShiftOffendersResult: (0, $hE35Q.detectLayoutShiftCause)({
                                                    viewportEntries: viewportEntries,
                                                    layoutShiftEntries: layoutShiftEntries,
                                                    time: time,
                                                    startTime: startTime
                                                }),
                                                layoutShiftEntriesCount: layoutShiftEntries.length,
                                                layoutShiftImpact: viewportPercentage - previousViewportPercentage
                                            };
                                        }
                                        percentileIndex++;
                                    }
                                    // Clear buffer after processing all matching percentiles
                                    entryDataBuffer.clear();
                                } else // Only add to buffer if we haven't reached all percentiles
                                entries.forEach(function(e) {
                                    return entryDataBuffer.add(e);
                                });
                                previousViewportPercentage = viewportPercentage;
                            case 25:
                                _context.next = 17;
                                break;
                            case 27:
                                _context.next = 32;
                                break;
                            case 29:
                                _context.prev = 29;
                                _context.t0 = _context["catch"](15);
                                _iterator4.e(_context.t0);
                            case 32:
                                _context.prev = 32;
                                _iterator4.f();
                                return _context.finish(32);
                            case 35:
                                // Fill in any missing percentiles with the last known values
                                previousResult = {
                                    t: 0,
                                    e: []
                                };
                                for(i = 0; i < percentiles.length; i++){
                                    percentile = percentiles[i];
                                    if (!(percentile in vcDetails)) vcDetails["".concat(percentile)] = previousResult;
                                    else previousResult = vcDetails["".concat(percentile)];
                                }
                                enhancedVcLogs = vcLogs ? vcLogs.map(function(log) {
                                    return $a028cbd0c20550d0$var$_objectSpread($a028cbd0c20550d0$var$_objectSpread({}, log), {}, {
                                        entries: log.entries.map(function(entry) {
                                            var _entry$rect, _entry$previousRect;
                                            return $a028cbd0c20550d0$var$_objectSpread($a028cbd0c20550d0$var$_objectSpread({}, entry), {}, {
                                                rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                                                previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                                            });
                                        }),
                                        viewportPercentage: log.viewportPercentage
                                    });
                                }) : []; // If 3p metric enabled - calculate the debug details
                                shouldCalculate3p = include3p; // Only calculate enhanced debug details if devtool callbacks exist
                                shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_vc_3p_debug_data) === 'function');
                                if (shouldCalculateDebugDetails && allEntries && vcLogs) {
                                    // Pre-sort vcLogs by time for efficient lookups
                                    sortedVcLogs = (0, $kOzMB.default)(vcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    }); // Pre-calculate max viewport percentage up to each time for efficient lookups
                                    maxViewportPercentageAtTime = new Map();
                                    maxSoFar = 0;
                                    _iterator5 = $a028cbd0c20550d0$var$_createForOfIteratorHelper(sortedVcLogs);
                                    try {
                                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                            log = _step5.value;
                                            if (log.viewportPercentage !== null) {
                                                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                                                maxViewportPercentageAtTime.set(log.time, maxSoFar);
                                            }
                                        }
                                    // Helper function to find the biggest previous viewport percentage
                                    } catch (err) {
                                        _iterator5.e(err);
                                    } finally{
                                        _iterator5.f();
                                    }
                                    getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
                                        // Binary search for the largest time <= targetTime
                                        var left = 0;
                                        var right = sortedVcLogs.length - 1;
                                        var result = -1;
                                        while(left <= right){
                                            var mid = Math.floor((left + right) / 2);
                                            if (sortedVcLogs[mid].time <= targetTime) {
                                                result = mid;
                                                left = mid + 1;
                                            } else right = mid - 1;
                                        }
                                        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
                                    }; // Group ignored entries by timestamp
                                    ignoredEntriesByTime = new Map();
                                    _iterator6 = $a028cbd0c20550d0$var$_createForOfIteratorHelper(allEntries);
                                    try {
                                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                            _entry4 = _step6.value;
                                            if ('rect' in _entry4.data && !this.isEntryIncluded(_entry4, include3p, excludeSmartAnswersInSearch)) {
                                                viewportData = _entry4.data;
                                                timestamp = Math.round(_entry4.time);
                                                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                                                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push($a028cbd0c20550d0$var$_objectSpread($a028cbd0c20550d0$var$_objectSpread({}, viewportData), {}, {
                                                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                                                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                                                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                                                }));
                                            }
                                        }
                                    // Add ignored entries to vcLogs
                                    } catch (err) {
                                        _iterator6.e(err);
                                    } finally{
                                        _iterator6.f();
                                    }
                                    additionalVcLogs = [];
                                    _iterator7 = $a028cbd0c20550d0$var$_createForOfIteratorHelper(ignoredEntriesByTime);
                                    try {
                                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                            _step7$value = (0, $6HNZJ.default)(_step7.value, 2), _timestamp = _step7$value[0], ignoredEntries = _step7$value[1];
                                            if (ignoredEntries.length > 0) {
                                                _viewportPercentage = getBiggestPreviousViewportPercentage(_timestamp);
                                                additionalVcLogs.push({
                                                    time: _timestamp,
                                                    viewportPercentage: _viewportPercentage,
                                                    entries: ignoredEntries
                                                });
                                            }
                                        }
                                    // Combine and sort all vcLogs
                                    } catch (err) {
                                        _iterator7.e(err);
                                    } finally{
                                        _iterator7.f();
                                    }
                                    enhancedVcLogs = [].concat((0, $kOzMB.default)(enhancedVcLogs), additionalVcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    });
                                }
                                // Only create debug details if callbacks exist
                                v3RevisionDebugDetails = null;
                                if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
                                    revision: this.revisionNo,
                                    isClean: isVCClean && !interactionAbortReason && isPageVisible,
                                    abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason !== null && dirtyReason !== void 0 ? dirtyReason : interactionAbortReason,
                                    vcLogs: enhancedVcLogs,
                                    interactionId: interactionId,
                                    interactionType: interactionType
                                };
                                // Handle devtool callback
                                if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
                                    (_window5 = window) === null || _window5 === void 0 || (_window5$__ufo_devtoo = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window5$__ufo_devtoo === void 0 || _window5$__ufo_devtoo.call(_window5, v3RevisionDebugDetails);
                                } catch (e) {
                                    // if any error communicating with devtool, we don't want to break the app
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
                                    (_window7 = window) === null || _window7 === void 0 || (_window7$__on_ufo_vc_ = _window7.__on_ufo_vc_debug_data_ready) === null || _window7$__on_ufo_vc_ === void 0 || _window7$__on_ufo_vc_.call(_window7, v3RevisionDebugDetails);
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && shouldCalculate3p) try {
                                    // Log vc details with 3p for debugging
                                    window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in 3pDebugData', e);
                                }
                                return _context.abrupt("return", {
                                    vcDetails: vcDetails,
                                    ssrRatio: ssrRatio,
                                    speedIndex: speedIndex,
                                    VC90layoutShiftInsights: layoutShiftInsights
                                });
                            case 47:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            15,
                            29,
                            32,
                            35
                        ]
                    ]);
                }));
                function calculateWithDebugInfo(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x0, _x1, _x10, _x11, _x12, _x13) {
                    return _calculateWithDebugInfo.apply(this, arguments);
                }
                return calculateWithDebugInfo;
            }()
        },
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee2(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, interactionId, isPostInteraction, include3p, excludeSmartAnswersInSearch, includeSSRRatio, interactionType, isPageVisible, interactionAbortReason, reportLayoutShiftOffenders, filteredEntries, isVCClean, dirtyReason, getVCCleanStatusResult, _yield$this$calculate, vcDetails, ssrRatio, speedIndex, VC90layoutShiftInsights, layoutShiftInsightsPayload, _layoutShiftOffenders, _layoutShiftOffenders2, _layoutShiftOffenders3, layoutShiftOffendersResult, layoutShiftEntriesCount, layoutShiftImpact, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries, interactionId = _ref.interactionId, isPostInteraction = _ref.isPostInteraction, include3p = _ref.include3p, excludeSmartAnswersInSearch = _ref.excludeSmartAnswersInSearch, includeSSRRatio = _ref.includeSSRRatio, interactionType = _ref.interactionType, isPageVisible = _ref.isPageVisible, interactionAbortReason = _ref.interactionAbortReason, reportLayoutShiftOffenders = _ref.reportLayoutShiftOffenders;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
                                });
                                getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isVCClean) {
                                    _context2.next = 7;
                                    break;
                                }
                                return _context2.abrupt("return", {
                                    revision: this.revisionNo,
                                    'metric:vc90': null,
                                    clean: false,
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp
                                });
                            case 7:
                                _context2.next = 9;
                                return this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
                            case 9:
                                _yield$this$calculate = _context2.sent;
                                vcDetails = _yield$this$calculate.vcDetails;
                                ssrRatio = _yield$this$calculate.ssrRatio;
                                speedIndex = _yield$this$calculate.speedIndex;
                                VC90layoutShiftInsights = _yield$this$calculate.VC90layoutShiftInsights;
                                if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
                                    layoutShiftOffendersResult = VC90layoutShiftInsights.layoutShiftOffendersResult, layoutShiftEntriesCount = VC90layoutShiftInsights.layoutShiftEntriesCount, layoutShiftImpact = VC90layoutShiftInsights.layoutShiftImpact;
                                    layoutShiftInsightsPayload = {
                                        impact: layoutShiftImpact,
                                        sources: layoutShiftEntriesCount !== null && layoutShiftEntriesCount !== void 0 ? layoutShiftEntriesCount : 0,
                                        same: {
                                            dir: (_layoutShiftOffenders = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) !== null && _layoutShiftOffenders !== void 0 ? _layoutShiftOffenders : false,
                                            dist: (_layoutShiftOffenders2 = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) !== null && _layoutShiftOffenders2 !== void 0 ? _layoutShiftOffenders2 : false
                                        },
                                        total_mut: (_layoutShiftOffenders3 = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) !== null && _layoutShiftOffenders3 !== void 0 ? _layoutShiftOffenders3 : 0,
                                        mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort(function(a, b) {
                                            return Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS);
                                        }).slice(0, 5).map(function(offender) {
                                            return {
                                                e: offender.offender,
                                                size: -1,
                                                // @todo: calculate size
                                                attr: {
                                                    t_before: offender.happenedBefore,
                                                    t_distance: offender.distanceToLS,
                                                    p_above: offender.isAbove,
                                                    p_left: offender.isLeft,
                                                    p_right: offender.isRight,
                                                    p_h_overlap: offender.hasHorizontalOverlap,
                                                    p_v_overlap: offender.hasVerticalOverlap,
                                                    p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                                                }
                                            };
                                        })
                                    };
                                }
                                result = {
                                    revision: this.revisionNo,
                                    clean: true,
                                    'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
                                    'vc90:ls': layoutShiftInsightsPayload !== null && layoutShiftInsightsPayload !== void 0 ? layoutShiftInsightsPayload : undefined
                                };
                                result.ratios = this.calculateRatios(filteredEntries);
                                if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
                                // speedIndex is only included in the result when it has a meaningful value (> 0)
                                if (speedIndex > 0) result.speedIndex = speedIndex;
                                result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
                                return _context2.abrupt("return", result);
                            case 21:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function calculate(_x14) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("9muGz", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", function () { return $6d0df8a9253eb6b1$export$96ea73435089b05a; });

var $6HNZJ = parcelRequire("6HNZJ");

var $eAzuA = parcelRequire("eAzuA");

var $c3LVh = parcelRequire("c3LVh");

var $39c3M = parcelRequire("39c3M");

var $rObII = parcelRequire("rObII");
function $6d0df8a9253eb6b1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6d0df8a9253eb6b1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6d0df8a9253eb6b1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6d0df8a9253eb6b1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6d0df8a9253eb6b1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6d0df8a9253eb6b1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6d0df8a9253eb6b1$var$calculateTTVCPercentiles(_x) {
    return $6d0df8a9253eb6b1$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $6d0df8a9253eb6b1$var$_calculateTTVCPercentiles() {
    $6d0df8a9253eb6b1$var$_calculateTTVCPercentiles = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator2, _step2, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $rObII.ViewportCanvas)(viewport, (0, $39c3M.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator2 = $6d0df8a9253eb6b1$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 4;
                    _iterator2.s();
                case 6:
                    if ((_step2 = _iterator2.n()).done) {
                        _context.next = 17;
                        break;
                    }
                    entry = _step2.value;
                    if ('rect' in entry.data) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("continue", 15);
                case 10:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 15:
                    _context.next = 6;
                    break;
                case 17:
                    _context.next = 22;
                    break;
                case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](4);
                    _iterator2.e(_context.t0);
                case 22:
                    _context.prev = 22;
                    _iterator2.f();
                    return _context.finish(22);
                case 25:
                    _context.next = 27;
                    return canvas.getPixelCounts();
                case 27:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", $6d0df8a9253eb6b1$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 31:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                19,
                22,
                25
            ]
        ]);
    }));
    return $6d0df8a9253eb6b1$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $6d0df8a9253eb6b1$export$96ea73435089b05a(_x2) {
    return $6d0df8a9253eb6b1$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
function $6d0df8a9253eb6b1$var$_calculateTTVCPercentilesWithDebugInfo() {
    $6d0df8a9253eb6b1$var$_calculateTTVCPercentilesWithDebugInfo = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee2(_ref2) {
        var viewport, orderedEntries, startTime, canvas, elementMap, _iterator3, _step3, entry, rect, timePixelCounts, canvasDimensions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    viewport = _ref2.viewport, orderedEntries = _ref2.orderedEntries, startTime = _ref2.startTime;
                    canvas = new (0, $rObII.ViewportCanvas)(viewport, (0, $39c3M.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator3 = $6d0df8a9253eb6b1$var$_createForOfIteratorHelper(orderedEntries);
                    _context2.prev = 4;
                    _iterator3.s();
                case 6:
                    if ((_step3 = _iterator3.n()).done) {
                        _context2.next = 16;
                        break;
                    }
                    entry = _step3.value;
                    if ('rect' in entry.data) {
                        _context2.next = 10;
                        break;
                    }
                    return _context2.abrupt("continue", 14);
                case 10:
                    rect = entry.data.rect;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
                    elementMap.get(entry.time).push(entry.data);
                case 14:
                    _context2.next = 6;
                    break;
                case 16:
                    _context2.next = 21;
                    break;
                case 18:
                    _context2.prev = 18;
                    _context2.t0 = _context2["catch"](4);
                    _iterator3.e(_context2.t0);
                case 21:
                    _context2.prev = 21;
                    _iterator3.f();
                    return _context2.finish(21);
                case 24:
                    _context2.next = 26;
                    return canvas.getPixelCounts();
                case 26:
                    timePixelCounts = _context2.sent;
                    canvasDimensions = canvas.getScaledDimensions();
                    totalPixels = canvasDimensions.width * canvasDimensions.height;
                    return _context2.abrupt("return", $6d0df8a9253eb6b1$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime));
                case 30:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                4,
                18,
                21,
                24
            ]
        ]);
    }));
    return $6d0df8a9253eb6b1$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
var $6d0df8a9253eb6b1$export$2e2bcd8739ae039 = $6d0df8a9253eb6b1$var$calculateTTVCPercentiles;
function $6d0df8a9253eb6b1$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref3, _ref4) {
        var _ref5 = (0, $6HNZJ.default)(_ref3, 1), timeA = _ref5[0];
        var _ref6 = (0, $6HNZJ.default)(_ref4, 1), timeB = _ref6[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator = $6d0df8a9253eb6b1$var$_createForOfIteratorHelper(sortedEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, $6HNZJ.default)(_step.value, 2), time = _step$value[0], pixelCount = _step$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}
function $6d0df8a9253eb6b1$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    var entries = new Array(elementMap.size);
    var cumulativePixels = 0;
    var speedIndex = 0;
    var previousPercentCovered = 0;
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref7, _ref8) {
        var _ref9 = (0, $6HNZJ.default)(_ref7, 1), timeA = _ref9[0];
        var _ref0 = (0, $6HNZJ.default)(_ref8, 1), timeB = _ref0[0];
        return Number(timeA) - Number(timeB);
    });
    for(var i = 0; i < sortedEntries.length; i++){
        var _sortedEntries$i = (0, $6HNZJ.default)(sortedEntries[i], 2), time = _sortedEntries$i[0], pixelCount = _sortedEntries$i[1];
        cumulativePixels += pixelCount;
        var percentCovered = cumulativePixels / totalPixels * 100;
        var entryDatas = elementMap.get(time) || [];
        var relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        var ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});
parcelRegister("rObII", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", function () { return $053974079c0f2bac$export$3e59ac9de7402fb1; });

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $c3LVh = parcelRequire("c3LVh");

var $hSXy9 = parcelRequire("hSXy9");
var $053974079c0f2bac$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, $zhrfT.default)(this, ViewportCanvas);
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        var ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ return (0, $j9c2S.default)(ViewportCanvas, [
        {
            key: "createCanvas",
            value: function createCanvas(width, height) {
                if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                return canvas;
            }
        },
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return $053974079c0f2bac$export$54591583ed0b20ce(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 4;
                                return $053974079c0f2bac$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
                            case 4:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 7:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 18;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== 'number')) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("continue", 15);
                            case 11:
                                color = i + 1;
                                rgbColor = $053974079c0f2bac$export$54591583ed0b20ce(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 15:
                                i++;
                                _context.next = 7;
                                break;
                            case 18:
                                return _context.abrupt("return", timePixelCounts);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();
function $053974079c0f2bac$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}
function $053974079c0f2bac$export$fafc9be44839f9c8(_x, _x2, _x3) {
    return $053974079c0f2bac$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}
function $053974079c0f2bac$var$_calculateDrawnPixelsRaw() {
    $053974079c0f2bac$var$_calculateDrawnPixelsRaw = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee2(imageData, _, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 3:
                    if (!(i < data.length)) {
                        _context2.next = 11;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.next = 8;
                    return (0, $hSXy9.default)();
                case 8:
                    i += 4;
                    _context2.next = 3;
                    break;
                case 11:
                    return _context2.abrupt("return", arr);
                case 12:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $053974079c0f2bac$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}

});
parcelRegister("hSXy9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d055ac302dbee454$export$2e2bcd8739ae039; });

var $eAzuA = parcelRequire("eAzuA");

var $c3LVh = parcelRequire("c3LVh");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
function $d055ac302dbee454$var$taskYield() {
    return $d055ac302dbee454$var$_taskYield.apply(this, arguments);
}
function $d055ac302dbee454$var$_taskYield() {
    $d055ac302dbee454$var$_taskYield = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!('scheduler' in globalThis && // @ts-ignore
                    'yield' in globalThis.scheduler)) {
                        _context.next = 4;
                        break;
                    }
                    _context.next = 3;
                    return scheduler.yield();
                case 3:
                    return _context.abrupt("return");
                case 4:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 9;
                    return p;
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $d055ac302dbee454$var$_taskYield.apply(this, arguments);
}
var $d055ac302dbee454$export$2e2bcd8739ae039 = $d055ac302dbee454$var$taskYield;

});



parcelRegister("hE35Q", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", function () { return $cd889260768d08e1$export$93ce39b765ea2cd3; });
function $cd889260768d08e1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cd889260768d08e1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cd889260768d08e1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cd889260768d08e1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cd889260768d08e1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cd889260768d08e1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $cd889260768d08e1$var$calculateOffenderState = function calculateOffenderState(current, matchesCurrentEntry) {
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    var entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
var $cd889260768d08e1$var$calculateLayoutShiftMovement = function calculateLayoutShiftMovement(layoutShiftEntries) {
    var movements = layoutShiftEntries.map(function(lsEntry) {
        var rect = lsEntry.rect;
        var previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        var dx = rect.x - previousRect.x;
        var dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    var hasMovement = function hasMovement(m) {
        return m !== null;
    };
    var validMovements = movements.filter(hasMovement);
    var allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    var first = validMovements[0];
    var allMovedSameWay = validMovements.every(function(m) {
        return m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY;
    });
    var allMovedSameAmount = allMovedSameWay && validMovements.every(function(m) {
        return m.absDx === first.absDx && m.absDy === first.absDy;
    });
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
var $cd889260768d08e1$export$93ce39b765ea2cd3 = function detectLayoutShiftCause(_ref) {
    var viewportEntries = _ref.viewportEntries, layoutShiftEntries = _ref.layoutShiftEntries, time = _ref.time, startTime = _ref.startTime, _ref$offenderWindowMs = _ref.offenderWindowMs, offenderWindowMs = _ref$offenderWindowMs === void 0 ? 250 : _ref$offenderWindowMs;
    var checkpointTimestamp = startTime + time;
    var filteredLSPotentialOffenders = viewportEntries.filter(function(viewportEntry) {
        return (viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift';
    });
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    var layoutShiftVariables = $cd889260768d08e1$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    var layoutShiftOffenders = filteredLSPotentialOffenders.reduce(function(acc, offender) {
        var _offenderData$origina;
        var offenderData = offender.data;
        var offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        var offenderTimestamp = (_offenderData$origina = offenderData.originalMutationTimestamp) !== null && _offenderData$origina !== void 0 ? _offenderData$origina : offender.time;
        var happenedBefore = offenderTimestamp <= checkpointTimestamp;
        var offenderLeft = offenderRect.x;
        var offenderRight = offenderRect.x + offenderRect.width;
        var offenderTop = offenderRect.y;
        var offenderBottom = offenderRect.y + offenderRect.height;
        var shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        var isAbove = null;
        var isLeft = null;
        var isRight = null;
        var hasHorizontalOverlap = null;
        var hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) {
            var _iterator = $cd889260768d08e1$var$_createForOfIteratorHelper(layoutShiftEntries), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var lsEntry = _step.value;
                    var lsRect = lsEntry.rect;
                    if (!lsRect) continue;
                    var lsLeft = lsRect.x;
                    var lsRight = lsRect.x + lsRect.width;
                    var lsTop = lsRect.y;
                    var lsBottom = lsRect.y + lsRect.height;
                    isAbove = $cd889260768d08e1$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
                    isLeft = $cd889260768d08e1$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
                    isRight = $cd889260768d08e1$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
                    hasHorizontalOverlap = $cd889260768d08e1$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
                    hasVerticalOverlap = $cd889260768d08e1$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        var matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            var dx = offenderRect.x - offenderData.previousRect.x;
            var dy = offenderRect.y - offenderData.previousRect.y;
            var isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            var isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove !== null && isAbove !== void 0 ? isAbove : 'none',
            isLeft: isLeft !== null && isLeft !== void 0 ? isLeft : 'none',
            isRight: isRight !== null && isRight !== void 0 ? isRight : 'none',
            hasHorizontalOverlap: hasHorizontalOverlap !== null && hasHorizontalOverlap !== void 0 ? hasHorizontalOverlap : 'none',
            hasVerticalOverlap: hasVerticalOverlap !== null && hasVerticalOverlap !== void 0 ? hasVerticalOverlap : 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("eGFOB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab156c904c7c05b6$export$2e2bcd8739ae039; });
function $ab156c904c7c05b6$var$getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (_unused) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $ab156c904c7c05b6$export$2e2bcd8739ae039 = $ab156c904c7c05b6$var$getViewportHeight;

});

parcelRegister("a9FxO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $764af877a04b04ea$export$2e2bcd8739ae039; });
function $764af877a04b04ea$var$getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (_unused) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $764af877a04b04ea$export$2e2bcd8739ae039 = $764af877a04b04ea$var$getViewportWidth;

});


parcelRegister("cLUNX", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", function () { return $94c5f01183a2693b$export$98812f4e79596e2b; });
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", function () { return $94c5f01183a2693b$export$44331555a87fcd9e; });
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", function () { return $94c5f01183a2693b$export$c4351da6279bef53; });
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", function () { return $94c5f01183a2693b$export$2492353b2cc31cc0; });
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", function () { return $94c5f01183a2693b$export$5a7b359ee5e32a5b; });
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
var $94c5f01183a2693b$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate'
];
var $94c5f01183a2693b$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
var $94c5f01183a2693b$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
var $94c5f01183a2693b$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
var $94c5f01183a2693b$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});

parcelRegister("1NfLP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14e699b8054f93e4$export$2e2bcd8739ae039; });
function $14e699b8054f93e4$var$isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === 'string';
        var hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $14e699b8054f93e4$export$2e2bcd8739ae039 = $14e699b8054f93e4$var$isViewportEntryData;

});


parcelRegister("6vPx8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4bdd9cc4fef5e554$export$2e2bcd8739ae039; });

var $kOzMB = parcelRequire("kOzMB");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $4GP2Y = parcelRequire("4GP2Y");

var $ewpge = parcelRequire("ewpge");

var $7TaZ5 = parcelRequire("7TaZ5");

var $6Ru4o = parcelRequire("6Ru4o");

var $39c3M = parcelRequire("39c3M");

var $kBgcN = parcelRequire("kBgcN");

var $cLUNX = parcelRequire("cLUNX");
function $4bdd9cc4fef5e554$var$_callSuper(t, o, e) {
    return o = (0, $ewpge.default)(o), (0, $4GP2Y.default)(t, $4bdd9cc4fef5e554$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $ewpge.default)(t).constructor) : o.apply(t, e));
}
function $4bdd9cc4fef5e554$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4bdd9cc4fef5e554$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4bdd9cc4fef5e554$var$_superPropGet(t, o, e, r) {
    var p = (0, $7TaZ5.default)((0, $ewpge.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $4bdd9cc4fef5e554$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
var $4bdd9cc4fef5e554$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
var $4bdd9cc4fef5e554$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
var $4bdd9cc4fef5e554$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY25_) {
    function VCCalculator_FY26_04() {
        var revisionNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'fy26.04';
        (0, $zhrfT.default)(this, VCCalculator_FY26_04);
        return $4bdd9cc4fef5e554$var$_callSuper(this, VCCalculator_FY26_04, [
            revisionNo
        ]);
    }
    (0, $6Ru4o.default)(VCCalculator_FY26_04, _VCCalculator_FY25_);
    return (0, $j9c2S.default)(VCCalculator_FY26_04, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var extra_fy26_04_excluded_attributes = (0, $39c3M.fg)('platform_ufo_ignore_data_fabric_mode') ? [
                    'data-fabric-mode'
                ] : [];
                var entryData = entry.data;
                var attributeName = entryData.attributeName;
                if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
                var isEntryIncludedInV3 = $4bdd9cc4fef5e554$var$_superPropGet(VCCalculator_FY26_04, "isEntryIncluded", this, 3)([
                    entry,
                    include3p,
                    excludeSmartAnswersInSearch
                ]);
                if (isEntryIncludedInV3 && !$4bdd9cc4fef5e554$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                if (entry.data.type === 'mutation:attribute' && (!attributeName || $4bdd9cc4fef5e554$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $39c3M.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
                var thirdPartyAttributes = [].concat((0, $kOzMB.default)((0, $cLUNX.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES)), (0, $kOzMB.default)((0, $39c3M.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, $cLUNX.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES) : []), (0, $kOzMB.default)((0, $39c3M.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $cLUNX.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []));
                if (entryData.type === 'mutation:display-contents-children-attribute') {
                    if (!attributeName || attributeName.startsWith('data-test') || (0, $cLUNX.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $cLUNX.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
                    return true;
                }
                return $4bdd9cc4fef5e554$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        }
    ]);
}((0, $kBgcN.default));

});

parcelRegister("gaczG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc47558d5bd2fce5$export$2e2bcd8739ae039; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $4GP2Y = parcelRequire("4GP2Y");

var $ewpge = parcelRequire("ewpge");

var $7TaZ5 = parcelRequire("7TaZ5");

var $6Ru4o = parcelRequire("6Ru4o");

var $6vPx8 = parcelRequire("6vPx8");
function $bc47558d5bd2fce5$var$_callSuper(t, o, e) {
    return o = (0, $ewpge.default)(o), (0, $4GP2Y.default)(t, $bc47558d5bd2fce5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $ewpge.default)(t).constructor) : o.apply(t, e));
}
function $bc47558d5bd2fce5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bc47558d5bd2fce5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bc47558d5bd2fce5$var$_superPropGet(t, o, e, r) {
    var p = (0, $7TaZ5.default)((0, $ewpge.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $bc47558d5bd2fce5$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
var $bc47558d5bd2fce5$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [];
    return consideredEntryTypes;
};
var $bc47558d5bd2fce5$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [];
    return excludedEntryTypes;
};
var $bc47558d5bd2fce5$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY26_) {
    function VCCalculator_Next() {
        (0, $zhrfT.default)(this, VCCalculator_Next);
        return $bc47558d5bd2fce5$var$_callSuper(this, VCCalculator_Next, [
            'next'
        ]);
    }
    (0, $6Ru4o.default)(VCCalculator_Next, _VCCalculator_FY26_);
    return (0, $j9c2S.default)(VCCalculator_Next, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var isEntryIncludedInV4 = $bc47558d5bd2fce5$var$_superPropGet(VCCalculator_Next, "isEntryIncluded", this, 3)([
                    entry,
                    include3p,
                    excludeSmartAnswersInSearch
                ]);
                if (isEntryIncludedInV4 && !$bc47558d5bd2fce5$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                return $bc47558d5bd2fce5$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($bc47558d5bd2fce5$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            if (eventType === 'keydown') dirtyReason = 'keypress';
                            else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                            else dirtyReason = eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $6vPx8.default));

});

parcelRegister("e4kJV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a3e186e88a3bcd98$export$2e2bcd8739ae039; });

var $kOzMB = parcelRequire("kOzMB");

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $c3LVh = parcelRequire("c3LVh");

var $4gtBF = parcelRequire("4gtBF");

var $eGFOB = parcelRequire("eGFOB");

var $a9FxO = parcelRequire("a9FxO");
function $a3e186e88a3bcd98$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a3e186e88a3bcd98$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a3e186e88a3bcd98$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a3e186e88a3bcd98$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a3e186e88a3bcd98$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a3e186e88a3bcd98$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a3e186e88a3bcd98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3e186e88a3bcd98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3e186e88a3bcd98$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3e186e88a3bcd98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a3e186e88a3bcd98$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $a3e186e88a3bcd98$var$MAX_OBSERVATIONS = 200;
var $a3e186e88a3bcd98$var$encodeRect = function encodeRect(rect) {
    return [
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
};
var $a3e186e88a3bcd98$var$areRectsEqual = function areRectsEqual(left, right) {
    return left.every(function(value, index) {
        return value === right[index];
    });
};
function $a3e186e88a3bcd98$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
var $a3e186e88a3bcd98$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RawDataHandler() {
        (0, $zhrfT.default)(this, RawDataHandler);
        (0, $gNkVH.default)(this, "revisionNo", 'raw-handler');
    }
    return (0, $j9c2S.default)(RawDataHandler, [
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($a3e186e88a3bcd98$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        },
        {
            key: "getRawData",
            value: function() {
                var _getRawData = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(_ref) {
                    var entries, startTime, stopTime, isPageVisible, isVCClean, dirtyReason, getVCCleanStatusResult, _getEarliestHiddenTim, viewportEntries, windowEventEntries, targetNameToIdMap, elementMapEntriesMap, nextElementId, typeMap, typeMapEntriesMap, nextTypeId, attributeMap, attributeEntriesMap, nextAttributeId, eventTypeMap, eventTypeMapEntriesMap, nextEventTypeId, labelStacksMap, rawObservations, rawEventObservations, firstObservation, lastObservations, ssrEid, ssrObservation, ssrAlreadyIncluded, referencedEids, referencedChgs, referencedAtts, _iterator, _step, observation, _iterator2, _step2, eid, _iterator3, _step3, chg, _iterator4, _step4, att, firstEventObservation, lastEventObservations, referencedEvts, _iterator5, _step5, _observation, _iterator6, _step6, evt, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                entries = _ref.entries, startTime = _ref.startTime, stopTime = _ref.stopTime, isPageVisible = _ref.isPageVisible;
                                getVCCleanStatusResult = this.getVCCleanStatus(entries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isPageVisible) {
                                    _context.next = 6;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: 'browser_backgrounded',
                                    abortTimestamp: (_getEarliestHiddenTim = (0, $4gtBF.getEarliestHiddenTiming)(startTime, stopTime)) !== null && _getEarliestHiddenTim !== void 0 ? _getEarliestHiddenTim : -1,
                                    viewport: {
                                        w: (0, $a9FxO.default)(),
                                        h: (0, $eGFOB.default)()
                                    }
                                });
                            case 6:
                                viewportEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
                                });
                                windowEventEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && $a3e186e88a3bcd98$var$isWindowEventEntryData(entry.data);
                                });
                                targetNameToIdMap = new Map();
                                elementMapEntriesMap = {};
                                nextElementId = 1;
                                typeMap = new Map();
                                typeMapEntriesMap = {};
                                nextTypeId = 1;
                                attributeMap = new Map();
                                attributeEntriesMap = {};
                                nextAttributeId = 1;
                                eventTypeMap = new Map();
                                eventTypeMapEntriesMap = {};
                                nextEventTypeId = 1;
                                labelStacksMap = {};
                                rawObservations = viewportEntries.map(function(entry) {
                                    var viewportEntry = entry.data;
                                    var targetName = viewportEntry.elementName || '';
                                    var type = viewportEntry.type || '';
                                    var rect = viewportEntry.rect;
                                    var attributeName = viewportEntry.attributeName || '';
                                    var eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
                                    if (eid === 0) {
                                        eid = nextElementId;
                                        nextElementId += 1;
                                        targetNameToIdMap.set(targetName, eid);
                                        elementMapEntriesMap[eid] = targetName;
                                    }
                                    // Capture labelStacks per element (only stored once per unique element)
                                    if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                                        var labelInfo = {
                                            s: viewportEntry.labelStacks.segment,
                                            l: viewportEntry.labelStacks.labelStack
                                        };
                                        var shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                                        labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
                                    }
                                    var chg = typeMap.get(type || '') || 0;
                                    if (chg === 0) {
                                        chg = nextTypeId;
                                        nextTypeId += 1;
                                        typeMap.set(type, chg);
                                        typeMapEntriesMap[chg] = type;
                                    }
                                    var att = 0;
                                    if (attributeName) {
                                        att = attributeMap.get(attributeName) || 0;
                                        if (att === 0) {
                                            att = nextAttributeId;
                                            nextAttributeId += 1;
                                            attributeMap.set(attributeName, att);
                                            attributeEntriesMap[att] = attributeName;
                                        }
                                    }
                                    var encodedRect = $a3e186e88a3bcd98$var$encodeRect(rect);
                                    var encodedPreviousRect = viewportEntry.previousRect ? $a3e186e88a3bcd98$var$encodeRect(viewportEntry.previousRect) : null;
                                    var shouldIncludePreviousRect = encodedPreviousRect === null || !$a3e186e88a3bcd98$var$areRectsEqual(encodedRect, encodedPreviousRect);
                                    var observation = $a3e186e88a3bcd98$var$_objectSpread($a3e186e88a3bcd98$var$_objectSpread({
                                        t: Math.round(entry.time - startTime),
                                        r: encodedRect
                                    }, shouldIncludePreviousRect ? {
                                        pr: encodedPreviousRect
                                    } : {}), {}, {
                                        chg: chg,
                                        eid: eid || 0
                                    }, att > 0 ? {
                                        att: att
                                    } : {});
                                    return observation;
                                });
                                rawEventObservations = windowEventEntries.map(function(entry) {
                                    var windowEventEntry = entry.data;
                                    var eventType = windowEventEntry.eventType;
                                    var evtId = eventTypeMap.get(eventType) || 0;
                                    if (evtId === 0) {
                                        evtId = nextEventTypeId;
                                        nextEventTypeId += 1;
                                        eventTypeMap.set(eventType, evtId);
                                        eventTypeMapEntriesMap[evtId] = eventType;
                                    }
                                    var eventObservation = {
                                        t: Math.round(entry.time - startTime),
                                        evt: evtId
                                    };
                                    return eventObservation;
                                }); // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
                                // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
                                // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
                                if (rawObservations.length > $a3e186e88a3bcd98$var$MAX_OBSERVATIONS) {
                                    firstObservation = rawObservations[0];
                                    lastObservations = rawObservations.slice(-$a3e186e88a3bcd98$var$MAX_OBSERVATIONS); // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
                                    ssrEid = targetNameToIdMap.get('SSR');
                                    ssrObservation = ssrEid ? rawObservations.find(function(obs) {
                                        return obs.eid === ssrEid && obs !== firstObservation;
                                    }) : undefined; // Include SSR observation if it exists and is not already in the kept observations
                                    ssrAlreadyIncluded = ssrObservation && lastObservations.some(function(obs) {
                                        return obs === ssrObservation;
                                    });
                                    rawObservations = [
                                        firstObservation
                                    ].concat((0, $kOzMB.default)(ssrObservation && !ssrAlreadyIncluded ? [
                                        ssrObservation
                                    ] : []), (0, $kOzMB.default)(lastObservations));
                                    // Collect referenced IDs from remaining observations
                                    referencedEids = new Set();
                                    referencedChgs = new Set();
                                    referencedAtts = new Set();
                                    _iterator = $a3e186e88a3bcd98$var$_createForOfIteratorHelper(rawObservations);
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            observation = _step.value;
                                            if (observation.eid > 0) referencedEids.add(observation.eid);
                                            if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                                            if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
                                        }
                                    // Remove unreferenced entries from maps
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                    _iterator2 = $a3e186e88a3bcd98$var$_createForOfIteratorHelper(Object.keys(elementMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                            eid = _step2.value;
                                            if (!referencedEids.has(eid)) {
                                                delete elementMapEntriesMap[eid];
                                                delete labelStacksMap[eid];
                                            }
                                        }
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                    _iterator3 = $a3e186e88a3bcd98$var$_createForOfIteratorHelper(Object.keys(typeMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            chg = _step3.value;
                                            if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                    _iterator4 = $a3e186e88a3bcd98$var$_createForOfIteratorHelper(Object.keys(attributeEntriesMap).map(Number));
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            att = _step4.value;
                                            if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                }
                                // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
                                // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
                                // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
                                if (rawEventObservations.length > $a3e186e88a3bcd98$var$MAX_OBSERVATIONS) {
                                    firstEventObservation = rawEventObservations[0];
                                    lastEventObservations = rawEventObservations.slice(-$a3e186e88a3bcd98$var$MAX_OBSERVATIONS);
                                    rawEventObservations = [
                                        firstEventObservation
                                    ].concat((0, $kOzMB.default)(lastEventObservations));
                                    // Collect referenced IDs from remaining observations
                                    referencedEvts = new Set();
                                    _iterator5 = $a3e186e88a3bcd98$var$_createForOfIteratorHelper(rawEventObservations);
                                    try {
                                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                            _observation = _step5.value;
                                            if (_observation.evt > 0) referencedEvts.add(_observation.evt);
                                        }
                                    // Remove unreferenced entries from maps
                                    } catch (err) {
                                        _iterator5.e(err);
                                    } finally{
                                        _iterator5.f();
                                    }
                                    _iterator6 = $a3e186e88a3bcd98$var$_createForOfIteratorHelper(Object.keys(eventTypeMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                            evt = _step6.value;
                                            if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
                                        }
                                    } catch (err) {
                                        _iterator6.e(err);
                                    } finally{
                                        _iterator6.f();
                                    }
                                }
                                result = {
                                    revision: this.revisionNo,
                                    clean: isVCClean,
                                    'metric:vc90': null,
                                    rawData: {
                                        obs: rawObservations !== null && rawObservations !== void 0 ? rawObservations : undefined,
                                        eid: elementMapEntriesMap !== null && elementMapEntriesMap !== void 0 ? elementMapEntriesMap : undefined,
                                        chg: typeMapEntriesMap !== null && typeMapEntriesMap !== void 0 ? typeMapEntriesMap : undefined,
                                        att: attributeEntriesMap !== null && attributeEntriesMap !== void 0 ? attributeEntriesMap : undefined,
                                        evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                                        evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                                        lbl: Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                                        lblMode: Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
                                    },
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp,
                                    viewport: {
                                        w: (0, $a9FxO.default)(),
                                        h: (0, $eGFOB.default)()
                                    }
                                };
                                return _context.abrupt("return", result);
                            case 27:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getRawData(_x) {
                    return _getRawData.apply(this, arguments);
                }
                return getRawData;
            }()
        }
    ]);
}();

});

parcelRegister("7A4yH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $584f6e71ff083612$export$2e2bcd8739ae039; });

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $c3LVh = parcelRequire("c3LVh");

var $hiR4V = parcelRequire("hiR4V");

var $kedcC = parcelRequire("kedcC");

var $85nqV = parcelRequire("85nqV");

var $bYqEg = parcelRequire("bYqEg");

var $l0DPX = parcelRequire("l0DPX");

var $hQxIT = parcelRequire("hQxIT");

var $jnoL4 = parcelRequire("jnoL4");

var $aRJAF = parcelRequire("aRJAF");

var $8iw0a = parcelRequire("8iw0a");

var $4gQBe = parcelRequire("4gQBe");

var $dy7go = parcelRequire("dy7go");

var $1r05E = parcelRequire("1r05E");

var $fC7UT = parcelRequire("fC7UT");

var $gwvLG = parcelRequire("gwvLG");
function $584f6e71ff083612$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $584f6e71ff083612$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $584f6e71ff083612$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $584f6e71ff083612$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $584f6e71ff083612$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $584f6e71ff083612$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $584f6e71ff083612$var$createElementMutationsWatcher = function createElementMutationsWatcher(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref) {
        var target = _ref.target, rect = _ref.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $dy7go.default)(target)) return 'mutation:remount';
        if ((0, $hiR4V.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        var isInIgnoreLsMarker = (0, $dy7go.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        var isRLLPlaceholder = (0, $bYqEg.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $fC7UT.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
};
var $584f6e71ff083612$var$createElementMutationsWatcherNew = function createElementMutationsWatcherNew(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref2) {
        var target = _ref2.target, rect = _ref2.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $dy7go.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $hiR4V.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        var isInIgnoreLsMarker = (0, $dy7go.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        var isRLLPlaceholder = (0, $bYqEg.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $fC7UT.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
};
var $584f6e71ff083612$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // SSR context functions
    function ViewportObserver(_ref3) {
        var _this = this;
        var onChange = _ref3.onChange, getSSRState = _ref3.getSSRState, getSSRPlaceholderHandler = _ref3.getSSRPlaceholderHandler, _ref3$trackLayoutShif = _ref3.trackLayoutShiftOffenders, trackLayoutShiftOffenders = _ref3$trackLayoutShif === void 0 ? false : _ref3$trackLayoutShif, searchPageConfig = _ref3.searchPageConfig;
        (0, $zhrfT.default)(this, ViewportObserver);
        (0, $gNkVH.default)(this, "handleIntersectionEntry", function(_ref4) {
            var target = _ref4.target, rect = _ref4.rect, time = _ref4.time, type = _ref4.type, mutationData = _ref4.mutationData;
            if (!target) return;
            var visible = (0, $4gQBe.isElementVisible)(target);
            var lastElementRect = _this.mapVisibleNodeRects.get(target);
            _this.mapVisibleNodeRects.set(target, rect);
            _this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        });
        (0, $gNkVH.default)(this, "handleChildListMutation", /*#__PURE__*/ function() {
            var _ref6 = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(_ref5) {
                var target, addedNodes, removedNodes, timestamp, removedNodeRects, targetNode, _iterator, _step, _loop;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            target = _ref5.target, addedNodes = _ref5.addedNodes, removedNodes = _ref5.removedNodes, timestamp = _ref5.timestamp;
                            removedNodeRects = removedNodes.map(function(ref) {
                                var n = ref.deref();
                                if (!n) return;
                                return _this.mapVisibleNodeRects.get(n);
                            });
                            targetNode = target.deref();
                            _iterator = $584f6e71ff083612$var$_createForOfIteratorHelper(addedNodes);
                            _context2.prev = 4;
                            _loop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _loop() {
                                var _this$getSSRState, _this$intersectionObs;
                                var addedNodeRef, addedNode, hasSameDeletedNode, _checkWithinComponent, isWithinThirdPartySegment, isWithinSmartAnswersSegment, isTargetReactRoot;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _loop$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            addedNodeRef = _step.value;
                                            addedNode = addedNodeRef.deref();
                                            if (addedNode) {
                                                _context.next = 4;
                                                break;
                                            }
                                            return _context.abrupt("return", 1);
                                        case 4:
                                            hasSameDeletedNode = removedNodes.find(function(ref) {
                                                var n = ref.deref();
                                                if (!n || !addedNode) return false;
                                                return n.isEqualNode(addedNode);
                                            });
                                            _checkWithinComponent = (0, $aRJAF.default)(addedNode, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent.isWithin;
                                            isWithinSmartAnswersSegment = Boolean(_this.shouldCheckSmartAnswersMutations() && (0, $8iw0a.isContainedWithinSmartAnswers)(addedNode));
                                            isTargetReactRoot = targetNode === ((_this$getSSRState = _this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(_this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                                            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, (_this.trackLayoutShiftOffenders ? $584f6e71ff083612$var$createElementMutationsWatcherNew : $584f6e71ff083612$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, _this.getSSRState, _this.getSSRPlaceholderHandler));
                                        case 9:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _loop);
                            });
                            _iterator.s();
                        case 7:
                            if ((_step = _iterator.n()).done) {
                                _context2.next = 13;
                                break;
                            }
                            return _context2.delegateYield(_loop(), "t0", 9);
                        case 9:
                            if (!_context2.t0) {
                                _context2.next = 11;
                                break;
                            }
                            return _context2.abrupt("continue", 11);
                        case 11:
                            _context2.next = 7;
                            break;
                        case 13:
                            _context2.next = 18;
                            break;
                        case 15:
                            _context2.prev = 15;
                            _context2.t1 = _context2["catch"](4);
                            _iterator.e(_context2.t1);
                        case 18:
                            _context2.prev = 18;
                            _iterator.f();
                            return _context2.finish(18);
                        case 21:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        15,
                        18,
                        21
                    ]
                ]);
            }));
            return function(_x) {
                return _ref6.apply(this, arguments);
            };
        }());
        (0, $gNkVH.default)(this, "handleAttributeMutation", function(_ref7) {
            var _this$intersectionObs2;
            var target = _ref7.target, attributeName = _ref7.attributeName, oldValue = _ref7.oldValue, newValue = _ref7.newValue, timestamp = _ref7.timestamp;
            (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(target, function(_ref8) {
                var target = _ref8.target, rect = _ref8.rect;
                if ((0, $hiR4V.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var _checkWithinComponent2 = (0, $aRJAF.default)(target, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent2.isWithin;
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (_this.shouldCheckSmartAnswersMutations() && (0, $8iw0a.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $kedcC.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $85nqV.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $1r05E.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var isRLLPlaceholder = (0, $bYqEg.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $gwvLG.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        });
        (0, $gNkVH.default)(this, "handleLayoutShift", function(_ref9) {
            var time = _ref9.time, changedRects = _ref9.changedRects;
            var _iterator2 = $584f6e71ff083612$var$_createForOfIteratorHelper(changedRects), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var changedRect = _step2.value;
                    var target = changedRect.node;
                    if (target) {
                        var isSameCurrentAndPreviousRects = (0, $fC7UT.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                        _this.onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                        });
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        });
        (0, $gNkVH.default)(this, "shouldCheckSmartAnswersMutations", function() {
            var _this$searchPageConfi, _this$searchPageConfi2, _window;
            return ((_this$searchPageConfi = _this.searchPageConfig) === null || _this$searchPageConfi === void 0 ? void 0 : _this$searchPageConfi.enableSmartAnswersMutations) && ((_this$searchPageConfi2 = _this.searchPageConfig) === null || _this$searchPageConfi2 === void 0 ? void 0 : _this$searchPageConfi2.searchPageRoute) && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname) && window.location.pathname === _this.searchPageConfig.searchPageRoute;
        });
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    return (0, $j9c2S.default)(ViewportObserver, [
        {
            key: "initializeObservers",
            value: function initializeObservers() {
                if (this.isStarted) return;
                this.intersectionObserver = (0, $l0DPX.createIntersectionObserver)({
                    onEntry: this.handleIntersectionEntry
                });
                this.mutationObserver = (0, $hQxIT.default)({
                    onChildListMutation: this.handleChildListMutation,
                    onAttributeMutation: this.handleAttributeMutation
                });
                this.performanceObserver = (0, $jnoL4.default)({
                    onLayoutShift: this.handleLayoutShift
                });
            }
        },
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                if (this.isStarted) return;
                this.initializeObservers();
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: 'layout-shift',
                    buffered: true,
                    // @ts-ignore -error
                    durationThreshold: 30
                });
                this.isStarted = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs3, _this$performanceObse2;
                if (!this.isStarted) return;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
                this.isStarted = false;
                // Clean up caches when stopping
                (0, $aRJAF.cleanupCaches)(this.mapIs3pResult);
            }
        }
    ]);
}();

});
parcelRegister("hiR4V", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", function () { return $c98d4a61de90f25d$export$f61fbc3b9c4a9019; });

var $hM7lf = parcelRequire("hM7lf");
function $c98d4a61de90f25d$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $hM7lf.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("hM7lf", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", function () { return $cf0c9d408351e11b$export$7674290405cc25b0; });

var $gNkVH = parcelRequire("gNkVH");

var $1oC0p = parcelRequire("1oC0p");
var $cf0c9d408351e11b$export$7674290405cc25b0 = 'data-media-vc-wrapper';
var $cf0c9d408351e11b$export$7028e9efe569888c = (0, $gNkVH.default)({}, $cf0c9d408351e11b$export$7674290405cc25b0, true);
function $cf0c9d408351e11b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $cf0c9d408351e11b$export$7028e9efe569888c, children);
}

});


parcelRegister("85nqV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e30f7b47b311e58$export$2e2bcd8739ae039; });
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $5e30f7b47b311e58$var$isNonVisualStyleMutation(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $5e30f7b47b311e58$export$2e2bcd8739ae039 = $5e30f7b47b311e58$var$isNonVisualStyleMutation;

});

parcelRegister("bYqEg", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", function () { return $8b79f825a86afff5$export$166779fc0f49d4df; });

var $kOzMB = parcelRequire("kOzMB");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");
var $8b79f825a86afff5$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
var $8b79f825a86afff5$export$166779fc0f49d4df = /*#__PURE__*/ function() {
    function RLLPlaceholderHandlers() {
        (0, $zhrfT.default)(this, RLLPlaceholderHandlers);
        (0, $gNkVH.default)(this, "placeholders", []);
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ return (0, $j9c2S.default)(RLLPlaceholderHandlers, [
        {
            key: "reset",
            value: function reset() {
                this.placeholders = [];
            }
        },
        {
            key: "collectRLLPlaceholders",
            value: function collectRLLPlaceholders() {
                if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
                var beginElements = document.querySelectorAll('input[data-lazy-begin]');
                var beginCount = beginElements.length;
                if (beginCount === 0) return;
                // Performance optimization: pre-allocate array with estimated size
                var allElements = [];
                // Performance optimization: use traditional for loop instead of forEach
                for(var i = 0; i < beginCount; i++){
                    var beginEl = beginElements[i];
                    var id = beginEl.getAttribute('data-lazy-begin');
                    if (!id) continue;
                    var elements = this.refElements(beginEl, id);
                    if (elements.length > 0) allElements.push.apply(allElements, (0, $kOzMB.default)(elements));
                }
                // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
                var allElementsLength = allElements.length;
                if (allElementsLength > 0) {
                    // Performance optimization: pre-allocate array with exact size
                    var intersectingRects = [];
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    for(var _i = 0; _i < allElementsLength; _i++){
                        var rect = allElements[_i].getBoundingClientRect();
                        // Performance optimization: inline intersection calculation to avoid function call overhead
                        var left = Math.max(rect.left, 0);
                        var top = Math.max(rect.top, 0);
                        var right = Math.min(rect.right, windowWidth);
                        var bottom = Math.min(rect.bottom, windowHeight);
                        // Check if there's a valid intersection with non-zero width and height
                        if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
                    }
                    this.placeholders = intersectingRects;
                }
            }
        },
        {
            key: "refElements",
            value: function refElements(fromEl, id) {
                var result = [];
                var el = fromEl.nextSibling;
                // Performance optimization: use while loop instead of recursive calls
                while(el){
                    var _el$dataset;
                    if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
                    if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
                    el = el.nextSibling;
                }
                return result;
            }
        },
        {
            key: "getPlaceholders",
            value: function getPlaceholders() {
                return this.placeholders;
            }
        },
        {
            key: "isRLLPlaceholderHydration",
            value: function isRLLPlaceholderHydration(intersectingRect) {
                var placeholdersLength = this.placeholders.length;
                if (placeholdersLength === 0) return false;
                // Performance optimization: cache array length and use traditional for loop
                for(var i = 0; i < placeholdersLength; i++){
                    var placeholderRect = this.placeholders[i];
                    if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
                }
                return false;
            }
        },
        {
            key: "areRectsEqual",
            value: function areRectsEqual(rect1, rect2) {
                // Early exit for exact matches (most common case)
                if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
                // Performance optimization: check largest differences first for early exit
                var leftDiff = rect1.left - rect2.left;
                if (leftDiff > 1 || leftDiff < -1) return false;
                var rightDiff = rect1.right - rect2.right;
                if (rightDiff > 1 || rightDiff < -1) return false;
                var topDiff = rect1.top - rect2.top;
                if (topDiff > 1 || topDiff < -1) return false;
                var bottomDiff = rect1.bottom - rect2.bottom;
                if (bottomDiff > 1 || bottomDiff < -1) return false;
                return true;
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (typeof globalThis !== 'undefined') {
                    if (!globalThis[$8b79f825a86afff5$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$8b79f825a86afff5$var$GLOBAL_RLL_HANDLERS_KEY] = new RLLPlaceholderHandlers();
                    return globalThis[$8b79f825a86afff5$var$GLOBAL_RLL_HANDLERS_KEY];
                }
                // Fallback for environments without globalThis (should be rare)
                return new RLLPlaceholderHandlers();
            }
        }
    ]);
}();

});

parcelRegister("l0DPX", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", function () { return $f4b87fddd85acd76$export$c3799d33e0ae80a5; });

var $8FUkf = parcelRequire("8FUkf");
function $f4b87fddd85acd76$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f4b87fddd85acd76$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f4b87fddd85acd76$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f4b87fddd85acd76$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f4b87fddd85acd76$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f4b87fddd85acd76$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f4b87fddd85acd76$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $f4b87fddd85acd76$export$c3799d33e0ae80a5(_ref) {
    var onEntry = _ref.onEntry, onObserved = _ref.onObserved;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = function intersectionObserverCallback(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement)) return;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $8FUkf.isZeroDimensionRectangle)(entry.intersectionRect)) {
                var zeroDimensionRectangleTagCallback = function zeroDimensionRectangleTagCallback(props) {
                    var tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        var _tagOrCallbackResult$ = tagOrCallbackResult.mutationData, attributeName = _tagOrCallbackResult$.attributeName, oldValue = _tagOrCallbackResult$.oldValue, newValue = _tagOrCallbackResult$.newValue;
                        var isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                var _iterator = $f4b87fddd85acd76$var$_createForOfIteratorHelper(entry.target.children), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var child = _step.value;
                        observer.observe(child);
                        callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return;
            }
            if (!$f4b87fddd85acd76$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            if (typeof tagOrCallback === 'function') {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: function disconnect() {
            observer.disconnect();
        },
        unobserve: function unobserve(target) {
            observer.unobserve(target);
        },
        watchAndTag: function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("8FUkf", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", function () { return $650dd826f8ec196b$export$80d6b07c2266a1c6; });
function $650dd826f8ec196b$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("hQxIT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cfe173b9072d74db$export$2e2bcd8739ae039; });

var $fsqMW = parcelRequire("fsqMW");
function $cfe173b9072d74db$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cfe173b9072d74db$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cfe173b9072d74db$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cfe173b9072d74db$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cfe173b9072d74db$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cfe173b9072d74db$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Batched mutation data for performance optimization
function $cfe173b9072d74db$var$createMutationObserver(_ref) {
    var onAttributeMutation = _ref.onAttributeMutation, onChildListMutation = _ref.onChildListMutation, onMutationFinished = _ref.onMutationFinished;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var mutationObserverCallback = function mutationObserverCallback(mutations) {
        var targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        var batchedMutations = new Map();
        var _iterator = $cfe173b9072d74db$var$_createForOfIteratorHelper(mutations), _step;
        try {
            var _loop = function _loop() {
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) return 0; // continue
                if ((0, $fsqMW.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                    // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                    // Currently being tested in Confluence
                    // Skip elements with data-vc-oob attribute
                    if (mut.target.dataset.vcOob) return {
                        v: void 0
                    };
                }
                if (mut.type === 'attributes') {
                    var _mut$oldValue;
                    /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
                    var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                    if (oldValue !== newValue) {
                        var _mut$attributeName;
                        onAttributeMutation({
                            target: mut.target,
                            attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : 'unknown',
                            oldValue: oldValue,
                            newValue: newValue,
                            timestamp: mut.timestamp || performance.now()
                        });
                    }
                    return 0; // continue
                } else if (mut.type === 'childList') {
                    var _mut$addedNodes, _mut$removedNodes;
                    // In chromium browser MutationRecord has timestamp field, which we should use.
                    var timestamp = Math.round(mut.timestamp || performance.now());
                    // Get or create timestamp bucket
                    var timestampBucket = batchedMutations.get(timestamp);
                    if (!timestampBucket) {
                        timestampBucket = new Map();
                        batchedMutations.set(timestamp, timestampBucket);
                    }
                    // Get or create target batch within timestamp bucket
                    var batch = timestampBucket.get(mut.target);
                    if (!batch) {
                        batch = {
                            target: new WeakRef(mut.target),
                            addedNodes: [],
                            removedNodes: [],
                            timestamp: timestamp
                        };
                        timestampBucket.set(mut.target, batch);
                    }
                    // Accumulate added nodes
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                    });
                    // Accumulate removed nodes
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                    });
                }
                targets.push(mut.target);
            }, _ret;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                _ret = _loop();
                if (_ret === 0) continue;
                if (_ret) return _ret.v;
            }
        // Process all batched childList mutations
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var _iterator2 = $cfe173b9072d74db$var$_createForOfIteratorHelper(batchedMutations.values()), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var timestampBucket = _step2.value;
                var _iterator3 = $cfe173b9072d74db$var$_createForOfIteratorHelper(timestampBucket.values()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var batch = _step3.value;
                        onChildListMutation({
                            target: batch.target,
                            addedNodes: batch.addedNodes,
                            removedNodes: batch.removedNodes,
                            timestamp: batch.timestamp
                        });
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $cfe173b9072d74db$export$2e2bcd8739ae039 = $cfe173b9072d74db$var$createMutationObserver;

});

parcelRegister("jnoL4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1b35ec301fa6296$export$2e2bcd8739ae039; });
function $e1b35ec301fa6296$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e1b35ec301fa6296$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e1b35ec301fa6296$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e1b35ec301fa6296$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e1b35ec301fa6296$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e1b35ec301fa6296$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e1b35ec301fa6296$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $e1b35ec301fa6296$var$createPerformanceObserver(_ref) {
    var onLayoutShift = _ref.onLayoutShift;
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    var performanceObserverCallback = function performanceObserverCallback(entries) {
        var _iterator = $e1b35ec301fa6296$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === 'layout-shift' && 'sources' in entry) {
                    // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: $e1b35ec301fa6296$export$5e3f54cad8cb65e2(attr.currentRect),
                            previousRect: $e1b35ec301fa6296$export$5e3f54cad8cb65e2(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $e1b35ec301fa6296$export$2e2bcd8739ae039 = $e1b35ec301fa6296$var$createPerformanceObserver;

});

parcelRegister("aRJAF", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", function () { return $7e9237f30d2a1850$export$6a35c3789c327630; });
$parcel$export(module.exports, "default", function () { return $7e9237f30d2a1850$export$2e2bcd8739ae039; });

var $39c3M = parcelRequire("39c3M");

var $as5v9 = parcelRequire("as5v9");

var $8PqNV = parcelRequire("8PqNV");

var $hmGTk = parcelRequire("hmGTk");
var $7e9237f30d2a1850$var$DEFAULT_MAX_LEVEL = 20;
var $7e9237f30d2a1850$var$INCREASED_DOM_WALK_MAX_LEVEL = 40;
var $7e9237f30d2a1850$var$INCREASED_FIBER_WALK_MAX_LEVEL = 40;
function $7e9237f30d2a1850$var$getDomWalkMaxLevel() {
    return (0, $39c3M.fg)('platform_ufo_3p_forge_detection_fix') ? $7e9237f30d2a1850$var$INCREASED_DOM_WALK_MAX_LEVEL : $7e9237f30d2a1850$var$DEFAULT_MAX_LEVEL;
}
function $7e9237f30d2a1850$var$getFiberWalkMaxLevel() {
    return (0, $39c3M.fg)('platform_ufo_3p_forge_detection_fix') ? $7e9237f30d2a1850$var$INCREASED_FIBER_WALK_MAX_LEVEL : $7e9237f30d2a1850$var$DEFAULT_MAX_LEVEL;
}
// Cache cleanup
var $7e9237f30d2a1850$var$callCount = 0;
var $7e9237f30d2a1850$var$CLEANUP_THRESHOLD = 50;
function $7e9237f30d2a1850$var$maybeCleanup(resultCache) {
    $7e9237f30d2a1850$var$callCount++;
    if ($7e9237f30d2a1850$var$callCount >= $7e9237f30d2a1850$var$CLEANUP_THRESHOLD && (0, $as5v9.default)(0.3)) $7e9237f30d2a1850$export$6a35c3789c327630(resultCache);
}
function $7e9237f30d2a1850$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $7e9237f30d2a1850$var$callCount = 0;
    return resultCache;
}
function $7e9237f30d2a1850$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $7e9237f30d2a1850$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) {
        var _resultCache$get;
        return {
            isWithin: (_resultCache$get = resultCache.get(node)) !== null && _resultCache$get !== void 0 ? _resultCache$get : false
        };
    }
    var fiber = null;
    var checkedNodes = [];
    var domWalkMaxLevel = $7e9237f30d2a1850$var$getDomWalkMaxLevel();
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, $hmGTk.default)(node, domWalkMaxLevel, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach(function(checkedNode) {
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    var isWithin = (0, $8PqNV.default)(fiber, targetComponentName, $7e9237f30d2a1850$var$getFiberWalkMaxLevel());
    checkedNodes.forEach(function(checkedNode) {
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("8PqNV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66d7e0eabba2d546$export$2e2bcd8739ae039; });

var $3vbB4 = parcelRequire("3vbB4");
function $66d7e0eabba2d546$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    var componentName = (0, $3vbB4.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $66d7e0eabba2d546$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("3vbB4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $28cd4341792b3074$export$2e2bcd8739ae039; });

var $1nEzb = parcelRequire("1nEzb");
function $28cd4341792b3074$export$2e2bcd8739ae039(fiber) {
    var type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || (0, $1nEzb.default)(type) === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("hmGTk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca45c3112a88d912$export$2e2bcd8739ae039; });

var $ievoe = parcelRequire("ievoe");
function $ca45c3112a88d912$export$2e2bcd8739ae039(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    var fiber = (0, $ievoe.default)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    var parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return $ca45c3112a88d912$export$2e2bcd8739ae039(parent, maxLevel - 1, checkedNodes);
}

});
parcelRegister("ievoe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d461e2279f45f350$export$2e2bcd8739ae039; });
// Helper function to find React fiber on an element
function $d461e2279f45f350$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(var key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("8iw0a", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", function () { return $60a8d40f3e9d397e$export$16c2770458939f21; });

var $6xVyM = parcelRequire("6xVyM");
function $60a8d40f3e9d397e$export$16c2770458939f21(node) {
    var doc = (0, $6xVyM.getDocument)();
    if (!doc) return false;
    var smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("6xVyM", function(module, exports) {
$parcel$export(module.exports, "getDocument", function () { return $4c42795f4a1f6a8c$export$f65ca476c09acec0; });
var $4c42795f4a1f6a8c$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("4gQBe", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", function () { return $31c1753d237dfaab$export$e989c0fffaa6b27a; });
function $31c1753d237dfaab$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (_unused) {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("dy7go", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9dd415b13caa2ab6$export$2e2bcd8739ae039; });
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $9dd415b13caa2ab6$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $9dd415b13caa2ab6$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("1r05E", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", function () { return $10b861efe7943bbb$export$80a5724ceedcfd3d; });
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $10b861efe7943bbb$export$80a5724ceedcfd3d(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("fC7UT", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", function () { return $b5e08bb0ca5e8929$export$fde63bc968551821; });
var $b5e08bb0ca5e8929$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $b5e08bb0ca5e8929$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $b5e08bb0ca5e8929$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $b5e08bb0ca5e8929$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $b5e08bb0ca5e8929$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $b5e08bb0ca5e8929$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("gwvLG", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", function () { return $c07846ff00b32782$export$597b41700f7dcd36; });
var $c07846ff00b32782$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $c07846ff00b32782$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $c07846ff00b32782$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $c07846ff00b32782$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("k0eLW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8ff4430bf25bb06$export$2e2bcd8739ae039; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $dH1HR = parcelRequire("dH1HR");
var $e8ff4430bf25bb06$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, $zhrfT.default)(this, WindowEventObserver);
        (0, $gNkVH.default)(this, "unbindFns", []);
        this.onEvent = opts.onEvent;
    }
    return (0, $j9c2S.default)(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $dH1HR.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "bindCaptureScrollEvent",
            value: function bindCaptureScrollEvent() {
                var _this2 = this;
                var unbindCallback = (0, $dH1HR.bind)(document, {
                    type: 'scroll',
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this2.onEvent({
                            time: event.timeStamp,
                            type: 'scroll-container',
                            event: event
                        });
                    },
                    options: {
                        capture: true,
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent('wheel');
                this.bindEvent('scroll');
                this.bindEvent('keydown');
                this.bindEvent('resize');
                this.bindCaptureScrollEvent();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});



parcelRegister("kpqve", function(module, exports) {
$parcel$export(module.exports, "interactions", function () { return $edbab35c8b0fc7ca$export$cc97b17ef9aeb088; });
var $edbab35c8b0fc7ca$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("48vrX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $30304e1651a335f5$export$2e2bcd8739ae039; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $4PhwH = parcelRequire("4PhwH");

var $kpqve = parcelRequire("kpqve");

var $a48Mt = parcelRequire("a48Mt");
function $30304e1651a335f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $30304e1651a335f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $30304e1651a335f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $30304e1651a335f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $30304e1651a335f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function InteractionExtraMetrics() {
        (0, $zhrfT.default)(this, InteractionExtraMetrics);
        // Store the finished interaction (as non-3p interaction)
        (0, $gNkVH.default)(this, "finishedInteraction", null);
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        (0, $gNkVH.default)(this, "vcObserver", null);
        (0, $gNkVH.default)(this, "sinkHandlerFn", function() {});
    }
    return (0, $j9c2S.default)(InteractionExtraMetrics, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $4PhwH.VCObserverWrapper)($30304e1651a335f5$var$_objectSpread($30304e1651a335f5$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref, interactionId) {
                var startTime = _ref.startTime;
                if (this.eligibleToMeasure(interactionId)) {
                    var _this$vcObserver;
                    (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                        startTime: startTime
                    });
                }
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this$vcObserver2;
                (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
            }
        },
        {
            key: "eligibleToMeasure",
            value: function eligibleToMeasure(interactionId) {
                var interaction = (0, $kpqve.interactions).get(interactionId);
                return (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition';
            }
        },
        {
            key: "updateFinishedInteraction",
            value: function updateFinishedInteraction(interaction) {
                if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition') this.finishedInteraction = interaction;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: function sinkHandler(fn) {
                this.sinkHandlerFn = fn;
            }
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(id, data) {
                if (data.ufoName) {
                    var _this$vcObserver3;
                    var updatedData = $30304e1651a335f5$var$_objectSpread($30304e1651a335f5$var$_objectSpread({}, data), {}, {
                        vcObserver: (_this$vcObserver3 = this.vcObserver) !== null && _this$vcObserver3 !== void 0 ? _this$vcObserver3 : undefined
                    });
                    this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
                }
                this.stopVCObserver();
                (0, $a48Mt.remove)(id);
                this.reset();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this$finishedInterac;
                this.stopVCObserver();
                if ((_this$finishedInterac = this.finishedInteraction) !== null && _this$finishedInterac !== void 0 && _this$finishedInterac.id) (0, $a48Mt.remove)(this.finishedInteraction.id);
                this.finishedInteraction = null;
                this.lastInteractionFinishVCResult = undefined;
            }
        },
        {
            key: "stopAll",
            value: function stopAll(id) {
                (0, $a48Mt.remove)(id);
                this.reset();
            }
        }
    ]);
}();

});

parcelRegister("lgv6U", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f7b3398196296bcc$export$2e2bcd8739ae039; });

var $eAzuA = parcelRequire("eAzuA");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $c3LVh = parcelRequire("c3LVh");

var $03EZb = parcelRequire("03EZb");

var $4gtBF = parcelRequire("4gtBF");

var $4PhwH = parcelRequire("4PhwH");
function $f7b3398196296bcc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7b3398196296bcc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7b3398196296bcc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7b3398196296bcc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f7b3398196296bcc$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $f7b3398196296bcc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, $zhrfT.default)(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, $gNkVH.default)(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, $gNkVH.default)(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, $gNkVH.default)(this, "sinkTimeoutId", null);
        (0, $gNkVH.default)(this, "holdInfo", []);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, $gNkVH.default)(this, "vcObserver", null);
        (0, $gNkVH.default)(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, $gNkVH.default)(this, "sinkHandlerFn", function() {});
    }
    return (0, $j9c2S.default)(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $4PhwH.VCObserverWrapper)($f7b3398196296bcc$var$_objectSpread($f7b3398196296bcc$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this$vcObserver2;
                (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                this.holdInfo = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee() {
                    var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
                    var _this$vcObserver3, pageVisibilityState, isPageVisible, config, postInteractionFinishVCResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.lastInteractionFinish || !this.sinkHandlerFn)) {
                                    _context.next = 4;
                                    break;
                                }
                                this.reset();
                                (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
                                return _context.abrupt("return");
                            case 4:
                                pageVisibilityState = (0, $4gtBF.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
                                isPageVisible = pageVisibilityState === 'visible';
                                config = (0, $03EZb.getConfig)();
                                _context.next = 9;
                                return (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult($f7b3398196296bcc$var$_objectSpread($f7b3398196296bcc$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: 'ufo',
                                    experienceKey: this.lastInteractionFinish.ufoName,
                                    interactionId: this.lastInteractionFinish.id,
                                    includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
                                    includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio
                                }, this.vcObserverSSRConfig), {}, {
                                    interactionType: this.lastInteractionFinish.type,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: this.lastInteractionFinish.abortReason
                                }));
                            case 9:
                                postInteractionFinishVCResult = _context.sent;
                                (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
                                    postInteractionHoldInfo: this.holdInfo
                                });
                                this.reset();
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, experimentalTTAI = _ref2.experimentalTTAI, experimentalVC90 = _ref2.experimentalVC90, errors = _ref2.errors;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90,
                    errors: errors
                };
                var timeout = ((_getConfig = (0, $03EZb.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $f7b3398196296bcc$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return _this.sendPostInteractionLog();
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        },
        {
            key: "addHoldInfo",
            value: function addHoldInfo(labelStack, name, start) {
                this.holdInfo.push({
                    name: name,
                    labelStack: labelStack,
                    start: start
                });
            }
        }
    ]);
}();

});


parcelRegister("3O5xd", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", function () { return $2c5a55aee762dc10$export$9010aa71841a6887; });

var $dH1HR = parcelRequire("dH1HR");

var $a3PiC = parcelRequire("a3PiC");

var $7zJ6n = parcelRequire("7zJ6n");
function $2c5a55aee762dc10$export$9010aa71841a6887(window, initialViewPort, callback) {
    var unbindWheel = (0, $dH1HR.bind)(window, {
        type: (0, $a3PiC.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $a3PiC.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $dH1HR.bind)(window, {
        type: (0, $a3PiC.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $a3PiC.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $dH1HR.bind)(window, {
        type: (0, $a3PiC.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $7zJ6n.getViewportWidth)() !== initialViewPort.w || (0, $7zJ6n.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $a3PiC.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("a3PiC", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", function () { return $7531fa2a287d3760$export$199edc0307b5587f; });
var $7531fa2a287d3760$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("7zJ6n", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", function () { return $583ec990ec38d8f7$export$a497a1dcb4408212; });
$parcel$export(module.exports, "getViewportHeight", function () { return $583ec990ec38d8f7$export$4f01c15d21ef9cc6; });
function $583ec990ec38d8f7$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (_unused) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $583ec990ec38d8f7$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (_unused2) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("57vXu", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", function () { return $3ba665790db6991a$export$72e6dda9d5859230; });

var $6HNZJ = parcelRequire("6HNZJ");

var $kOzMB = parcelRequire("kOzMB");
function $3ba665790db6991a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3ba665790db6991a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3ba665790db6991a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3ba665790db6991a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3ba665790db6991a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3ba665790db6991a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3ba665790db6991a$export$72e6dda9d5859230(_ref) {
    var revision = _ref.revision, isClean = _ref.isClean, abortReason = _ref.abortReason, VCEntries = _ref.VCEntries, componentsLog = _ref.componentsLog, interactionId = _ref.interactionId;
    // Pre-sort VCEntries by time for efficient lookups
    var sortedVCEntries = (0, $kOzMB.default)(VCEntries).sort(function(a, b) {
        return a.time - b.time;
    });
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    var maxViewportPercentageAtTime = new Map();
    var maxSoFar = 0;
    var _iterator = $3ba665790db6991a$var$_createForOfIteratorHelper(sortedVCEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var entry = _step.value;
            maxSoFar = Math.max(maxSoFar, entry.vc);
            maxViewportPercentageAtTime.set(entry.time, maxSoFar);
        }
    // Helper function to find the biggest previous viewport percentage
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
        // Binary search for the largest time <= targetTime
        var left = 0;
        var right = sortedVCEntries.length - 1;
        var result = -1;
        while(left <= right){
            var mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    var allVcLogs = [];
    // Add regular VC entries
    var _iterator2 = $3ba665790db6991a$var$_createForOfIteratorHelper(VCEntries), _step2;
    try {
        var _loop = function _loop() {
            var entry = _step2.value;
            var timeLogEntries = componentsLog[entry.time];
            allVcLogs.push({
                time: entry.time,
                viewportPercentage: entry.vc,
                entries: entry.elements.map(function(element) {
                    var logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find(function(log) {
                        return log.targetName === element;
                    });
                    return {
                        elementName: element,
                        type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                        rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                        visible: true,
                        attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                        oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                        newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                        ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                    };
                })
            });
        };
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
    // Add ignored elements - only process timestamps that have ignored elements
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    for(var _i = 0, _Object$entries = Object.entries(componentsLog); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $6HNZJ.default)(_Object$entries[_i], 2), timestamp = _Object$entries$_i[0], timeLogEntries = _Object$entries$_i[1];
        var ignoredElements = timeLogEntries.filter(function(log) {
            return log.ignoreReason;
        });
        if (ignoredElements.length === 0) continue;
        var time = Number(timestamp);
        var viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map(function(logEntry) {
                return {
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                };
            })
        });
    }
    // Sort once at the end
    allVcLogs.sort(function(a, b) {
        return a.time - b.time;
    });
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("3E7yZ", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", function () { return $2a7af96e6720c45e$export$5c86a34c9becd6d0; });

var $gNkVH = parcelRequire("gNkVH");

var $03EZb = parcelRequire("03EZb");

var $4gtBF = parcelRequire("4gtBF");
function $2a7af96e6720c45e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2a7af96e6720c45e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2a7af96e6720c45e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2a7af96e6720c45e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2a7af96e6720c45e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2a7af96e6720c45e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $2a7af96e6720c45e$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
var $2a7af96e6720c45e$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $2a7af96e6720c45e$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    var _iterator = $2a7af96e6720c45e$var$_createForOfIteratorHelper($2a7af96e6720c45e$var$VCParts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            details[key] = {
                t: VC[key] || -1,
                e: VCBox[key] || $2a7af96e6720c45e$var$READONLY_EMPTY_ARRAY
            };
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return details;
}
function $2a7af96e6720c45e$export$5c86a34c9becd6d0(_ref) {
    var fullPrefix = _ref.fullPrefix, interaction = _ref.interaction, isVCClean = _ref.isVCClean, isEventAborted = _ref.isEventAborted, calculatedVC = _ref.calculatedVC, calculatedVCNext = _ref.calculatedVCNext, experienceKey = _ref.experienceKey, ratios = _ref.ratios;
    var pageVisibilityUpToTTAI = (0, $4gtBF.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    var availableVCRevisionPayloads = [];
    if ((0, $03EZb.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        var revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $2a7af96e6720c45e$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $03EZb.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        var _revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $2a7af96e6720c45e$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) _revision.ratios = ratios;
        availableVCRevisionPayloads.push(_revision);
    }
    return (0, $gNkVH.default)({}, "".concat(fullPrefix, "vc:rev"), availableVCRevisionPayloads);
}

});

parcelRegister("4sqTw", function(module, exports) {
$parcel$export(module.exports, "Observers", function () { return $33eea3a4427cc115$export$b65d046240060e78; });

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $hiR4V = parcelRequire("hiR4V");

var $85nqV = parcelRequire("85nqV");

var $bYqEg = parcelRequire("bYqEg");

var $hzedL = parcelRequire("hzedL");
function $33eea3a4427cc115$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33eea3a4427cc115$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33eea3a4427cc115$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33eea3a4427cc115$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $33eea3a4427cc115$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $33eea3a4427cc115$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
var $33eea3a4427cc115$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, $zhrfT.default)(this, Observers);
        (0, $gNkVH.default)(this, "observedMutations", new WeakMap());
        (0, $gNkVH.default)(this, "elementsInView", new Set());
        (0, $gNkVH.default)(this, "callbacks", new Set());
        (0, $gNkVH.default)(this, "totalTime", 0);
        (0, $gNkVH.default)(this, "_startMeasureTimestamp", -1);
        (0, $gNkVH.default)(this, "ssr", {
            state: $33eea3a4427cc115$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, $gNkVH.default)(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, $gNkVH.default)(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, $gNkVH.default)(this, "observeElement", function(node, mutation, type, ignoreReason, attributeName) {
            var _this$intersectionObs;
            var oldValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var newValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        this.selectorConfig = $33eea3a4427cc115$var$_objectSpread($33eea3a4427cc115$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $hzedL.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    return (0, $j9c2S.default)(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $33eea3a4427cc115$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        'hidden',
                        'style',
                        'src',
                        'class'
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView.clear();
                this.callbacks.clear();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $33eea3a4427cc115$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                if (!this.isBrowserSupported()) return null;
                return new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = '';
                        if (_this2.ssr.state === $33eea3a4427cc115$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $33eea3a4427cc115$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = 'ssr-hydration';
                        }
                        if (_this2.ssr.state === $33eea3a4427cc115$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = 'ssr-hydration';
                            else _this2.ssr.state = $33eea3a4427cc115$var$state.normal;
                        }
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $hiR4V.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, 'html', ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === 'attributes') {
                            if (mutation.target instanceof HTMLElement) {
                                var _mutation$oldValue;
                                var attributeName = mutation.attributeName;
                                /*
              	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
              	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
              	Conceptually there is after all a mutation: there is an old value replaced with a new one,
              	and whether or not they are the same doesn't really matter.
              	And Custom elements should work the same way as MutationObserver."
              	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
              */ var oldValue = (_mutation$oldValue = mutation.oldValue) !== null && _mutation$oldValue !== void 0 ? _mutation$oldValue : undefined;
                                var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                if (oldValue !== newValue) {
                                    if ((0, $85nqV.default)(mutation)) ignoreReason = 'non-visual-style';
                                    if ((0, $hiR4V.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                    _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                                }
                            }
                        }
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute('data-vc');
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? "[data-vc=\"".concat(dataVCAttr, "\"]") : '';
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
                    var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                    testId = testId ? "[testid=".concat(testId, "]") : '';
                    var role = this.selectorConfig.role ? element.getAttribute('role') : '';
                    role = role ? "[role=".concat(role, "]") : '';
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                    classList = classList === '' ? '' : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join('');
                    var idString = '';
                    if (attrs === '' && classList === '') {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join('');
                    return idString;
                } catch (_unused) {
                    return 'error';
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!$33eea3a4427cc115$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                            if ((0, $bYqEg.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (_unused2) {
                                    elementName = 'error';
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});



parcelRegister("bHUpV", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserver", function () { return $885f791d2b9ab6be$export$17afbba0f16b4b19; });

var $gNkVH = parcelRequire("gNkVH");

var $a48Mt = parcelRequire("a48Mt");

var $cEUW7 = parcelRequire("cEUW7");
function $885f791d2b9ab6be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $885f791d2b9ab6be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $885f791d2b9ab6be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $885f791d2b9ab6be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $885f791d2b9ab6be$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $885f791d2b9ab6be$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $885f791d2b9ab6be$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $885f791d2b9ab6be$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $885f791d2b9ab6be$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $885f791d2b9ab6be$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $885f791d2b9ab6be$var$performanceEventObserver;
var $885f791d2b9ab6be$var$selectorConfig = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $885f791d2b9ab6be$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return "[data-testid=".concat(memoizedProps['data-testid'], "]");
    else if (memoizedProps['data-test-id']) return "[data-test-id=".concat(memoizedProps['data-testid'], "]");
    else if (memoizedProps['data-vc']) return "[data-vc=".concat(memoizedProps['data-vc'], "]");
    return null;
}
function $885f791d2b9ab6be$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return "UFOSegment[name=".concat(memoizedProps['name'], "]");
    return componentName;
}
function $885f791d2b9ab6be$var$getReactComponentHierarchy(element) {
    var componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        var currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                var componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($885f791d2b9ab6be$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                var dataIdInfo = $885f791d2b9ab6be$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (reactFiberKey) {
        var fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
var $885f791d2b9ab6be$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $885f791d2b9ab6be$var$performanceEventObserver = $885f791d2b9ab6be$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $885f791d2b9ab6be$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === 'click') $885f791d2b9ab6be$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $885f791d2b9ab6be$var$performanceEventObserver;
};
var $885f791d2b9ab6be$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = (0, $a48Mt.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var _interaction$responsi;
        if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
            var _interaction$responsi2, _interaction$responsi3;
            interaction.responsiveness = $885f791d2b9ab6be$var$_objectSpread($885f791d2b9ab6be$var$_objectSpread({}, interaction.responsiveness), {}, {
                experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
            });
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    var componentHierarchy = $885f791d2b9ab6be$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $cEUW7.default)($885f791d2b9ab6be$var$selectorConfig, entry.target);
            }
        }
    }
};

});
parcelRegister("cEUW7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $937562dbb1f8404b$export$2e2bcd8739ae039; });
var $937562dbb1f8404b$var$nameCache = new WeakMap();
function $937562dbb1f8404b$var$getAttributeSelector(element, attributeName) {
    var attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return "[".concat(attributeName, "=\"").concat(attrValue, "\"]");
}
function $937562dbb1f8404b$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (_unused) {
        return false;
    }
}
function $937562dbb1f8404b$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $937562dbb1f8404b$var$getUniqueSelector(selectorConfig, element) {
    var currentElement = element;
    var parts = [];
    var MAX_DEPTH = 3;
    var currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        var tagName = currentElement.localName;
        var selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $937562dbb1f8404b$var$isValidSelector("#".concat(currentElement.id))) selectorPart += "#".concat(currentElement.id);
        else if (selectorConfig.dataVC) selectorPart += $937562dbb1f8404b$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $937562dbb1f8404b$var$getAttributeSelector(currentElement, 'data-testid') || $937562dbb1f8404b$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $937562dbb1f8404b$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            var classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($937562dbb1f8404b$var$isValidSelector(".".concat(classNames))) selectorPart += ".".concat(classNames);
            }
        }
        parts.unshift(selectorPart);
        var _potentialSelector = parts.join(' > ').trim();
        if (_potentialSelector && $937562dbb1f8404b$var$isSelectorUnique(_potentialSelector)) return _potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    var potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$937562dbb1f8404b$var$isSelectorUnique(potentialSelector)) {
        var parentElement = element.parentElement;
        if (parentElement) return "".concat(potentialSelector, ":nth-child"); // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $937562dbb1f8404b$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    var cachedName = $937562dbb1f8404b$var$nameCache.get(element);
    if (cachedName) return cachedName;
    var uniqueSelector = $937562dbb1f8404b$var$getUniqueSelector(selectorConfig, element);
    $937562dbb1f8404b$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $937562dbb1f8404b$export$2e2bcd8739ae039 = $937562dbb1f8404b$var$getElementName;

});


parcelRegister("kqXw0", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", function () { return $ee0466dbba90c432$export$1f0ff35da084986e; });
$parcel$export(module.exports, "createMemoryStateReport", function () { return $ee0466dbba90c432$export$3b47ebb9832b4e24; });
$parcel$export(module.exports, "initialisePressureObserver", function () { return $ee0466dbba90c432$export$117ebc554c6e9f2f; });
$parcel$export(module.exports, "initialiseMemoryObserver", function () { return $ee0466dbba90c432$export$a3271f53e91faab7; });

var $kOzMB = parcelRequire("kOzMB");
var $ee0466dbba90c432$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
var $ee0466dbba90c432$var$pressureRecordBuffer = [];
var $ee0466dbba90c432$var$pressureObserver = null;
var $ee0466dbba90c432$var$memoryRecordBuffer = [];
var $ee0466dbba90c432$var$memoryInterval;
function $ee0466dbba90c432$export$6c1060bed5fea050() {
    $ee0466dbba90c432$var$pressureRecordBuffer.length = 0;
}
function $ee0466dbba90c432$export$aa672c7221b183b0() {
    $ee0466dbba90c432$var$memoryRecordBuffer.length = 0;
}
function $ee0466dbba90c432$export$ec86686c1d2e65bc(filter) {
    $ee0466dbba90c432$var$pressureRecordBuffer = $ee0466dbba90c432$var$pressureRecordBuffer.filter(function(_ref) {
        var time = _ref.time;
        return time > filter;
    });
}
function $ee0466dbba90c432$export$c0142ac82f5d0c28(filter) {
    $ee0466dbba90c432$var$memoryRecordBuffer = $ee0466dbba90c432$var$memoryRecordBuffer.filter(function(_ref2) {
        var time = _ref2.time;
        return time > filter;
    });
}
function $ee0466dbba90c432$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        var pressureStateCount = $ee0466dbba90c432$var$pressureRecordBuffer.reduce(function(pressureReport, _ref3) {
            var time = _ref3.time, state = _ref3.state;
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        var pressureStateTotal = Object.values(pressureStateCount).reduce(function(total, count) {
            return total + count;
        }) || 1;
        $ee0466dbba90c432$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch (_unused) {
        return null;
    }
}
function $ee0466dbba90c432$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $ee0466dbba90c432$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        var accumulatedMemoryUsage = $ee0466dbba90c432$var$memoryRecordBuffer.reduce(function(acc, snapshot) {
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        var memoryStateReport = {
            jsHeapSizeLimitInMB: $ee0466dbba90c432$var$convertBytesToMegabytes($ee0466dbba90c432$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $ee0466dbba90c432$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $ee0466dbba90c432$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $ee0466dbba90c432$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch (_unused2) {
        return null;
    }
}
function $ee0466dbba90c432$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $ee0466dbba90c432$var$pressureObserver = new PressureObserver(function(records) {
                if ($ee0466dbba90c432$var$pressureRecordBuffer.length + records.length <= $ee0466dbba90c432$var$BUFFER_MAX_LENGTH) {
                    var _pressureRecordBuffer;
                    (_pressureRecordBuffer = $ee0466dbba90c432$var$pressureRecordBuffer).push.apply(_pressureRecordBuffer, (0, $kOzMB.default)(records));
                }
            });
            $ee0466dbba90c432$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(function() {
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (_unused3) {
    /* do nothing, this is a best efforts metric */ }
}
function $ee0466dbba90c432$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $ee0466dbba90c432$var$memoryInterval = setInterval(function() {
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                var memory = performance.memory;
                if ($ee0466dbba90c432$var$memoryRecordBuffer.length <= $ee0466dbba90c432$var$BUFFER_MAX_LENGTH) $ee0466dbba90c432$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch (_unused4) {
    /* do nothing, this is a best efforts metric */ }
}
function $ee0466dbba90c432$export$10899ada382f2ae3() {
    clearInterval($ee0466dbba90c432$var$memoryInterval);
}
function $ee0466dbba90c432$export$b9fdd785f0fc1d40() {
    var _pressureObserver;
    (_pressureObserver = $ee0466dbba90c432$var$pressureObserver) === null || _pressureObserver === void 0 || _pressureObserver.disconnect();
}

});

parcelRegister("2Vke6", function(module, exports) {
$parcel$export(module.exports, "sinkTerminalErrorHandler", function () { return $221098329ff08f17$export$e5fa3ac6dc44efff; });

var $gNkVH = parcelRequire("gNkVH");

var $1nEzb = parcelRequire("1nEzb");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $bMbcH = parcelRequire("bMbcH");

var $iqOwP = parcelRequire("iqOwP");

var $a48Mt = parcelRequire("a48Mt");

var $kBQuN = parcelRequire("kBQuN");
function $221098329ff08f17$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $221098329ff08f17$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $221098329ff08f17$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $221098329ff08f17$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $221098329ff08f17$var$sinkHandlerFn = function sinkHandlerFn() {};
function $221098329ff08f17$export$e5fa3ac6dc44efff(fn) {
    $221098329ff08f17$var$sinkHandlerFn = fn;
}
var $221098329ff08f17$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
var $221098329ff08f17$export$1a949ef92fd30eca = function isRelayNetworkError(error) {
    return error.name === $221098329ff08f17$var$RELAY_NETWORK_ERRORS_NAME;
};
var $221098329ff08f17$var$isErrorObject = function isErrorObject(error) {
    return (0, $1nEzb.default)(error) === 'object' && error !== null;
};
var $221098329ff08f17$var$getErrorStatusCode = function getErrorStatusCode(error) {
    if (!$221098329ff08f17$var$isErrorObject(error)) return undefined;
    if ($221098329ff08f17$export$1a949ef92fd30eca(error)) {
        var _error$source;
        return (_error$source = error.source) === null || _error$source === void 0 || (_error$source = _error$source.errors) === null || _error$source === void 0 || (_error$source = _error$source[0]) === null || _error$source === void 0 || (_error$source = _error$source.extensions) === null || _error$source === void 0 ? void 0 : _error$source.statusCode;
    }
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
var $221098329ff08f17$var$getErrorTraceId = function getErrorTraceId(error) {
    return $221098329ff08f17$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
};
function $221098329ff08f17$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    var _error$message, _additionalAttributes, _getActiveTrace$trace, _getActiveTrace, _activeInteraction$uf, _activeInteraction$id, _activeInteraction$ty, _PreviousInteractionL, _PreviousInteractionL2, _PreviousInteractionL3, _UFORouteName$current;
    if (additionalAttributes !== null && additionalAttributes !== void 0 && additionalAttributes.isClientNetworkError) // Exclude client network errors from being reported to UFO
    return;
    var activeInteraction = (0, $a48Mt.getActiveInteraction)();
    var currentTime = performance.now();
    var baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: ((_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.slice(0, 100)) || 'Unknown error',
        timestamp: currentTime
    };
    var errorData = (0, $39c3M.fg)('platform_ufo_terminal_errors_fix_missing_data') ? $221098329ff08f17$var$_objectSpread($221098329ff08f17$var$_objectSpread({}, baseErrorData), {}, {
        statusCode: (_additionalAttributes = additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) !== null && _additionalAttributes !== void 0 ? _additionalAttributes : $221098329ff08f17$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (_getActiveTrace$trace = (_getActiveTrace = (0, $bMbcH.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) !== null && _getActiveTrace$trace !== void 0 ? _getActiveTrace$trace : $221098329ff08f17$var$getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    }) : $221098329ff08f17$var$_objectSpread($221098329ff08f17$var$_objectSpread({}, baseErrorData), additionalAttributes);
    // Calculate time since previous interaction
    var timeSincePreviousInteraction = (0, $a48Mt.PreviousInteractionLog).timestamp != null ? currentTime - (0, $a48Mt.PreviousInteractionLog).timestamp : null;
    var context = {
        labelStack: labelStack !== null && labelStack !== void 0 ? labelStack : null,
        activeInteractionName: (_activeInteraction$uf = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) !== null && _activeInteraction$uf !== void 0 ? _activeInteraction$uf : null,
        activeInteractionId: (_activeInteraction$id = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) !== null && _activeInteraction$id !== void 0 ? _activeInteraction$id : null,
        activeInteractionType: (_activeInteraction$ty = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) !== null && _activeInteraction$ty !== void 0 ? _activeInteraction$ty : null,
        previousInteractionId: (_PreviousInteractionL = (0, $a48Mt.PreviousInteractionLog).id) !== null && _PreviousInteractionL !== void 0 ? _PreviousInteractionL : null,
        previousInteractionName: (_PreviousInteractionL2 = (0, $a48Mt.PreviousInteractionLog).name) !== null && _PreviousInteractionL2 !== void 0 ? _PreviousInteractionL2 : null,
        previousInteractionType: (_PreviousInteractionL3 = (0, $a48Mt.PreviousInteractionLog).type) !== null && _PreviousInteractionL3 !== void 0 ? _PreviousInteractionL3 : null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (_UFORouteName$current = (0, $kBQuN.default).current) !== null && _UFORouteName$current !== void 0 ? _UFORouteName$current : null
    };
    $221098329ff08f17$var$sinkHandlerFn(errorData, context);
}
function $221098329ff08f17$export$79ee0f0d40355053(error, additionalAttributes) {
    var interactionContext = (0, $iqOwP.useInteractionContext)();
    var hasReportedRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $221098329ff08f17$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}

});
parcelRegister("iqOwP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d6b1d99f80f94220$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useInteractionContext", function () { return $d6b1d99f80f94220$export$11bcb6e9af2aca35; });

var $1oC0p = parcelRequire("1oC0p");

var $cfcpE = parcelRequire("cfcpE");
var $d6b1d99f80f94220$export$2e2bcd8739ae039 = (0, $cfcpE.default);
function $d6b1d99f80f94220$export$11bcb6e9af2aca35() {
    return (0, $1oC0p.useContext)((0, $cfcpE.default));
}

});
parcelRegister("cfcpE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8ea083ae6ed938ea$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $8ea083ae6ed938ea$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});


parcelRegister("kBQuN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f00ffbe2d25d531a$export$2e2bcd8739ae039; });
// The UFORouteName object is a global singleton
var $f00ffbe2d25d531a$var$UFORouteName = {
    current: null
};
var $f00ffbe2d25d531a$export$2e2bcd8739ae039 = $f00ffbe2d25d531a$var$UFORouteName;

});


parcelRegister("cNHx9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $951bd48914683e99$export$2e2bcd8739ae039; });

var $8OZ01 = parcelRequire("8OZ01");

var $39c3M = parcelRequire("39c3M");
function $951bd48914683e99$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $39c3M.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $8OZ01.unstable_scheduleCallback)((0, $8OZ01.unstable_IdlePriority), work);
}
var $951bd48914683e99$export$2e2bcd8739ae039 = $951bd48914683e99$var$scheduleIdleCallback;

});
parcelRegister("8OZ01", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9tpPu"));

});
parcelRegister("9tpPu", function(module, exports) {
$parcel$export(module.exports, "unstable_now", function () { return $6e5adbb4307eb917$export$c4744153514ff05d; }, function (v) { return $6e5adbb4307eb917$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6e5adbb4307eb917$export$3e506c1ccc9cc1a7; }, function (v) { return $6e5adbb4307eb917$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6e5adbb4307eb917$export$e26fe2ed2fa76875; }, function (v) { return $6e5adbb4307eb917$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6e5adbb4307eb917$export$502329bbf4b505b1; }, function (v) { return $6e5adbb4307eb917$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6e5adbb4307eb917$export$6e3807111c4874c4; }, function (v) { return $6e5adbb4307eb917$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6e5adbb4307eb917$export$c27134553091fb3a; }, function (v) { return $6e5adbb4307eb917$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6e5adbb4307eb917$export$33ee1acdc04fd2a2; }, function (v) { return $6e5adbb4307eb917$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6e5adbb4307eb917$export$b00a404bbd5edef2; }, function (v) { return $6e5adbb4307eb917$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6e5adbb4307eb917$export$8352ce38b91d0c62; }, function (v) { return $6e5adbb4307eb917$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6e5adbb4307eb917$export$d66a1c1c77bd778b; }, function (v) { return $6e5adbb4307eb917$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6e5adbb4307eb917$export$d3dfb8e4810cb555; }, function (v) { return $6e5adbb4307eb917$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6e5adbb4307eb917$export$839f9183b0465a69; }, function (v) { return $6e5adbb4307eb917$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6e5adbb4307eb917$export$72fdf0e06517287b; }, function (v) { return $6e5adbb4307eb917$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6e5adbb4307eb917$export$4b844e58a3e414b4; }, function (v) { return $6e5adbb4307eb917$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6e5adbb4307eb917$export$816d2913ae6b83b1; }, function (v) { return $6e5adbb4307eb917$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6e5adbb4307eb917$export$61bcfe829111a1d0; }, function (v) { return $6e5adbb4307eb917$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6e5adbb4307eb917$export$7ee8c9beb337bc3f; }, function (v) { return $6e5adbb4307eb917$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6e5adbb4307eb917$export$b5836b71941fa3ed; }, function (v) { return $6e5adbb4307eb917$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6e5adbb4307eb917$export$cf845f2c119da08a; }, function (v) { return $6e5adbb4307eb917$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6e5adbb4307eb917$export$c4744153514ff05d;
var $6e5adbb4307eb917$export$3e506c1ccc9cc1a7;
var $6e5adbb4307eb917$export$e26fe2ed2fa76875;
var $6e5adbb4307eb917$export$502329bbf4b505b1;
var $6e5adbb4307eb917$export$6e3807111c4874c4;
var $6e5adbb4307eb917$export$c27134553091fb3a;
var $6e5adbb4307eb917$export$33ee1acdc04fd2a2;
var $6e5adbb4307eb917$export$b00a404bbd5edef2;
var $6e5adbb4307eb917$export$8352ce38b91d0c62;
var $6e5adbb4307eb917$export$d66a1c1c77bd778b;
var $6e5adbb4307eb917$export$d3dfb8e4810cb555;
var $6e5adbb4307eb917$export$839f9183b0465a69;
var $6e5adbb4307eb917$export$72fdf0e06517287b;
var $6e5adbb4307eb917$export$4b844e58a3e414b4;
var $6e5adbb4307eb917$export$816d2913ae6b83b1;
var $6e5adbb4307eb917$export$61bcfe829111a1d0;
var $6e5adbb4307eb917$export$7ee8c9beb337bc3f;
var $6e5adbb4307eb917$export$b5836b71941fa3ed;
var $6e5adbb4307eb917$export$cf845f2c119da08a;
'use strict';
function $6e5adbb4307eb917$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6e5adbb4307eb917$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6e5adbb4307eb917$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6e5adbb4307eb917$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6e5adbb4307eb917$var$g(C, c)) n < e && 0 > $6e5adbb4307eb917$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6e5adbb4307eb917$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6e5adbb4307eb917$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6e5adbb4307eb917$var$l = performance;
    $6e5adbb4307eb917$export$c4744153514ff05d = function() {
        return $6e5adbb4307eb917$var$l.now();
    };
} else {
    var $6e5adbb4307eb917$var$p = Date, $6e5adbb4307eb917$var$q = $6e5adbb4307eb917$var$p.now();
    $6e5adbb4307eb917$export$c4744153514ff05d = function() {
        return $6e5adbb4307eb917$var$p.now() - $6e5adbb4307eb917$var$q;
    };
}
var $6e5adbb4307eb917$var$r = [], $6e5adbb4307eb917$var$t = [], $6e5adbb4307eb917$var$u = 1, $6e5adbb4307eb917$var$v = null, $6e5adbb4307eb917$var$y = 3, $6e5adbb4307eb917$var$z = !1, $6e5adbb4307eb917$var$A = !1, $6e5adbb4307eb917$var$B = !1, $6e5adbb4307eb917$var$D = "function" === typeof setTimeout ? setTimeout : null, $6e5adbb4307eb917$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6e5adbb4307eb917$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6e5adbb4307eb917$var$G(a) {
    for(var b = $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$t); null !== b;){
        if (null === b.callback) $6e5adbb4307eb917$var$k($6e5adbb4307eb917$var$t);
        else if (b.startTime <= a) $6e5adbb4307eb917$var$k($6e5adbb4307eb917$var$t), b.sortIndex = b.expirationTime, $6e5adbb4307eb917$var$f($6e5adbb4307eb917$var$r, b);
        else break;
        b = $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$t);
    }
}
function $6e5adbb4307eb917$var$H(a) {
    $6e5adbb4307eb917$var$B = !1;
    $6e5adbb4307eb917$var$G(a);
    if (!$6e5adbb4307eb917$var$A) {
        if (null !== $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$r)) $6e5adbb4307eb917$var$A = !0, $6e5adbb4307eb917$var$I($6e5adbb4307eb917$var$J);
        else {
            var b = $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$t);
            null !== b && $6e5adbb4307eb917$var$K($6e5adbb4307eb917$var$H, b.startTime - a);
        }
    }
}
function $6e5adbb4307eb917$var$J(a, b) {
    $6e5adbb4307eb917$var$A = !1;
    $6e5adbb4307eb917$var$B && ($6e5adbb4307eb917$var$B = !1, $6e5adbb4307eb917$var$E($6e5adbb4307eb917$var$L), $6e5adbb4307eb917$var$L = -1);
    $6e5adbb4307eb917$var$z = !0;
    var c = $6e5adbb4307eb917$var$y;
    try {
        $6e5adbb4307eb917$var$G(b);
        for($6e5adbb4307eb917$var$v = $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$r); null !== $6e5adbb4307eb917$var$v && (!($6e5adbb4307eb917$var$v.expirationTime > b) || a && !$6e5adbb4307eb917$var$M());){
            var d = $6e5adbb4307eb917$var$v.callback;
            if ("function" === typeof d) {
                $6e5adbb4307eb917$var$v.callback = null;
                $6e5adbb4307eb917$var$y = $6e5adbb4307eb917$var$v.priorityLevel;
                var e = d($6e5adbb4307eb917$var$v.expirationTime <= b);
                b = $6e5adbb4307eb917$export$c4744153514ff05d();
                "function" === typeof e ? $6e5adbb4307eb917$var$v.callback = e : $6e5adbb4307eb917$var$v === $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$r) && $6e5adbb4307eb917$var$k($6e5adbb4307eb917$var$r);
                $6e5adbb4307eb917$var$G(b);
            } else $6e5adbb4307eb917$var$k($6e5adbb4307eb917$var$r);
            $6e5adbb4307eb917$var$v = $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$r);
        }
        if (null !== $6e5adbb4307eb917$var$v) var w = !0;
        else {
            var m = $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$t);
            null !== m && $6e5adbb4307eb917$var$K($6e5adbb4307eb917$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6e5adbb4307eb917$var$v = null, $6e5adbb4307eb917$var$y = c, $6e5adbb4307eb917$var$z = !1;
    }
}
var $6e5adbb4307eb917$var$N = !1, $6e5adbb4307eb917$var$O = null, $6e5adbb4307eb917$var$L = -1, $6e5adbb4307eb917$var$P = 5, $6e5adbb4307eb917$var$Q = -1;
function $6e5adbb4307eb917$var$M() {
    return $6e5adbb4307eb917$export$c4744153514ff05d() - $6e5adbb4307eb917$var$Q < $6e5adbb4307eb917$var$P ? !1 : !0;
}
function $6e5adbb4307eb917$var$R() {
    if (null !== $6e5adbb4307eb917$var$O) {
        var a = $6e5adbb4307eb917$export$c4744153514ff05d();
        $6e5adbb4307eb917$var$Q = a;
        var b = !0;
        try {
            b = $6e5adbb4307eb917$var$O(!0, a);
        } finally{
            b ? $6e5adbb4307eb917$var$S() : ($6e5adbb4307eb917$var$N = !1, $6e5adbb4307eb917$var$O = null);
        }
    } else $6e5adbb4307eb917$var$N = !1;
}
var $6e5adbb4307eb917$var$S;
if ("function" === typeof $6e5adbb4307eb917$var$F) $6e5adbb4307eb917$var$S = function() {
    $6e5adbb4307eb917$var$F($6e5adbb4307eb917$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6e5adbb4307eb917$var$T = new MessageChannel, $6e5adbb4307eb917$var$U = $6e5adbb4307eb917$var$T.port2;
    $6e5adbb4307eb917$var$T.port1.onmessage = $6e5adbb4307eb917$var$R;
    $6e5adbb4307eb917$var$S = function() {
        $6e5adbb4307eb917$var$U.postMessage(null);
    };
} else $6e5adbb4307eb917$var$S = function() {
    $6e5adbb4307eb917$var$D($6e5adbb4307eb917$var$R, 0);
};
function $6e5adbb4307eb917$var$I(a) {
    $6e5adbb4307eb917$var$O = a;
    $6e5adbb4307eb917$var$N || ($6e5adbb4307eb917$var$N = !0, $6e5adbb4307eb917$var$S());
}
function $6e5adbb4307eb917$var$K(a, b) {
    $6e5adbb4307eb917$var$L = $6e5adbb4307eb917$var$D(function() {
        a($6e5adbb4307eb917$export$c4744153514ff05d());
    }, b);
}
$6e5adbb4307eb917$export$3e506c1ccc9cc1a7 = 5;
$6e5adbb4307eb917$export$e26fe2ed2fa76875 = 1;
$6e5adbb4307eb917$export$502329bbf4b505b1 = 4;
$6e5adbb4307eb917$export$6e3807111c4874c4 = 3;
$6e5adbb4307eb917$export$c27134553091fb3a = null;
$6e5adbb4307eb917$export$33ee1acdc04fd2a2 = 2;
$6e5adbb4307eb917$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6e5adbb4307eb917$export$8352ce38b91d0c62 = function() {
    $6e5adbb4307eb917$var$A || $6e5adbb4307eb917$var$z || ($6e5adbb4307eb917$var$A = !0, $6e5adbb4307eb917$var$I($6e5adbb4307eb917$var$J));
};
$6e5adbb4307eb917$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6e5adbb4307eb917$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6e5adbb4307eb917$export$d3dfb8e4810cb555 = function() {
    return $6e5adbb4307eb917$var$y;
};
$6e5adbb4307eb917$export$839f9183b0465a69 = function() {
    return $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$r);
};
$6e5adbb4307eb917$export$72fdf0e06517287b = function(a) {
    switch($6e5adbb4307eb917$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6e5adbb4307eb917$var$y;
    }
    var c = $6e5adbb4307eb917$var$y;
    $6e5adbb4307eb917$var$y = b;
    try {
        return a();
    } finally{
        $6e5adbb4307eb917$var$y = c;
    }
};
$6e5adbb4307eb917$export$4b844e58a3e414b4 = function() {};
$6e5adbb4307eb917$export$816d2913ae6b83b1 = function() {};
$6e5adbb4307eb917$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6e5adbb4307eb917$var$y;
    $6e5adbb4307eb917$var$y = a;
    try {
        return b();
    } finally{
        $6e5adbb4307eb917$var$y = c;
    }
};
$6e5adbb4307eb917$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6e5adbb4307eb917$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6e5adbb4307eb917$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6e5adbb4307eb917$var$f($6e5adbb4307eb917$var$t, a), null === $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$r) && a === $6e5adbb4307eb917$var$h($6e5adbb4307eb917$var$t) && ($6e5adbb4307eb917$var$B ? ($6e5adbb4307eb917$var$E($6e5adbb4307eb917$var$L), $6e5adbb4307eb917$var$L = -1) : $6e5adbb4307eb917$var$B = !0, $6e5adbb4307eb917$var$K($6e5adbb4307eb917$var$H, c - d))) : (a.sortIndex = e, $6e5adbb4307eb917$var$f($6e5adbb4307eb917$var$r, a), $6e5adbb4307eb917$var$A || $6e5adbb4307eb917$var$z || ($6e5adbb4307eb917$var$A = !0, $6e5adbb4307eb917$var$I($6e5adbb4307eb917$var$J)));
    return a;
};
$6e5adbb4307eb917$export$b5836b71941fa3ed = $6e5adbb4307eb917$var$M;
$6e5adbb4307eb917$export$cf845f2c119da08a = function(a) {
    var b = $6e5adbb4307eb917$var$y;
    return function() {
        var c = $6e5adbb4307eb917$var$y;
        $6e5adbb4307eb917$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6e5adbb4307eb917$var$y = c;
        }
    };
};

});



parcelRegister("9OJFO", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("afJih"),
    $eao4m("9BftR")
]).then(()=>parcelRequire('9RhoK'));

});
parcelRegister("eao4m", function(module, exports) {
"use strict";

function $a504ab8c5934a050$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("hwrhg")).resolve(id));
}
module.exports = $a504ab8c5934a050$var$load;

});
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});



parcelRegister("7zXN1", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("lM1L3").then(()=>parcelRequire('26AAR'));

});

parcelRegister("8KDEO", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("afJih"),
    $eao4m("7ij57")
]).then(()=>parcelRequire('lqt9D'));

});

parcelRegister("e6pRn", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("9mWn8").then(()=>parcelRequire('79Co0'));

});


parcelRegister("gyWh8", function(module, exports) {
$parcel$export(module.exports, "configure", function () { return $c0ed069aa305b9cd$export$8d21e34596265fa2; });
$parcel$export(module.exports, "getConfig", function () { return $c0ed069aa305b9cd$export$44487a86467333c3; });

var $6HNZJ = parcelRequire("6HNZJ");

var $03EZb = parcelRequire("03EZb");
function $c0ed069aa305b9cd$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c0ed069aa305b9cd$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c0ed069aa305b9cd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c0ed069aa305b9cd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c0ed069aa305b9cd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c0ed069aa305b9cd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c0ed069aa305b9cd$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $c0ed069aa305b9cd$var$getAllowedParams() {
    var config = (0, $03EZb.getConfig)();
    return (config === null || config === void 0 ? void 0 : config.allowedResourcesParams) || $c0ed069aa305b9cd$var$defaultAllowedParams;
}
function $c0ed069aa305b9cd$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        var url = new URL(urlString);
        var params = new URLSearchParams(url.search);
        var allowedParams = $c0ed069aa305b9cd$var$getAllowedParams();
        var _iterator = $c0ed069aa305b9cd$var$_createForOfIteratorHelper(params), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = (0, $6HNZJ.default)(_step.value, 1), key = _step$value[0];
                if (!allowedParams.includes(key)) url.searchParams.delete(key);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return url.toString();
    } catch (_unused) {
        return urlString;
    }
}
var $c0ed069aa305b9cd$var$config = {
    mapResources: function mapResources(url) {
        return url;
    },
    sanitiseEndpoints: function sanitiseEndpoints(url) {
        return $c0ed069aa305b9cd$var$handleQueryParams(url);
    }
};
function $c0ed069aa305b9cd$export$8d21e34596265fa2(resourceTimingConfig) {
    var newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: function sanitiseEndpoints(url) {
            var sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $c0ed069aa305b9cd$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $c0ed069aa305b9cd$var$config = newConfig;
}
function $c0ed069aa305b9cd$export$44487a86467333c3() {
    return $c0ed069aa305b9cd$var$config;
}

});

parcelRegister("1CoTB", function(module, exports) {
$parcel$export(module.exports, "configure", function () { return $12dca6d5167ba1d6$export$8d21e34596265fa2; });
$parcel$export(module.exports, "getSSRTimings", function () { return $12dca6d5167ba1d6$export$bf7408e83532dcd0; });
$parcel$export(module.exports, "getSSRSuccess", function () { return $12dca6d5167ba1d6$export$c7ad864055e75537; });
$parcel$export(module.exports, "getSSRPhaseSuccess", function () { return $12dca6d5167ba1d6$export$5eade9354185583d; });
$parcel$export(module.exports, "getSSRDoneTime", function () { return $12dca6d5167ba1d6$export$3def7672244bab0c; });
$parcel$export(module.exports, "getSSRFeatureFlags", function () { return $12dca6d5167ba1d6$export$1c4a9b5e6e22393d; });

var $gNkVH = parcelRequire("gNkVH");

var $1nEzb = parcelRequire("1nEzb");
function $12dca6d5167ba1d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12dca6d5167ba1d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12dca6d5167ba1d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12dca6d5167ba1d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $12dca6d5167ba1d6$var$NESTED_METRIC_SEPARATOR = '/';
function $12dca6d5167ba1d6$var$filterEntry(entry) {
    return !(!entry || (0, $1nEzb.default)(entry) !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $12dca6d5167ba1d6$var$mapEntry(entry) {
    return $12dca6d5167ba1d6$var$_objectSpread({
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    }, entry.size ? {
        size: Math.round(entry.size)
    } : {});
}
var $12dca6d5167ba1d6$var$SSR_PREFIX = 'ssr';
function $12dca6d5167ba1d6$var$mapKey(key) {
    if (key === 'total') return $12dca6d5167ba1d6$var$SSR_PREFIX;
    return "".concat($12dca6d5167ba1d6$var$SSR_PREFIX).concat($12dca6d5167ba1d6$var$NESTED_METRIC_SEPARATOR).concat(key);
}
var $12dca6d5167ba1d6$var$config;
function $12dca6d5167ba1d6$export$8d21e34596265fa2(ssrConfig) {
    $12dca6d5167ba1d6$var$config = ssrConfig;
}
function $12dca6d5167ba1d6$var$getPerformanceNavigationTiming() {
    var _performance$getEntri;
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (_performance$getEntri = performance.getEntriesByType('navigation')) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri[0];
}
function $12dca6d5167ba1d6$var$getServerTimingsByName() {
    var _getPerformanceNaviga, _getPerformanceNaviga2;
    var serverTimingsByName = Object.fromEntries((_getPerformanceNaviga = (_getPerformanceNaviga2 = $12dca6d5167ba1d6$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga2 === void 0 || (_getPerformanceNaviga2 = _getPerformanceNaviga2.serverTiming) === null || _getPerformanceNaviga2 === void 0 ? void 0 : _getPerformanceNaviga2.map(function(timing) {
        return [
            timing.name,
            timing
        ];
    })) !== null && _getPerformanceNaviga !== void 0 ? _getPerformanceNaviga : []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $12dca6d5167ba1d6$var$getEdgeOffset(edgeTtfb) {
    var _getPerformanceNaviga3;
    var clientTtfb = (_getPerformanceNaviga3 = $12dca6d5167ba1d6$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga3 === void 0 ? void 0 : _getPerformanceNaviga3.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $12dca6d5167ba1d6$export$5300d1b82e594615() {
    var _serverTimingsByName$, _serverTimingsByName$2, _serverTimingsByName$3, _serverTimingsByName$4, _serverTimingsByName$5, _serverTimingsByName$6, _serverTimingsByName$7, _serverTimingsByName$8, _serverTimingsByName$9;
    var serverTimingsByName = $12dca6d5167ba1d6$var$getServerTimingsByName();
    var edgeTotalDuration = (_serverTimingsByName$ = (_serverTimingsByName$2 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$2 === void 0 ? void 0 : _serverTimingsByName$2.duration) !== null && _serverTimingsByName$ !== void 0 ? _serverTimingsByName$ : (_serverTimingsByName$3 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$3 === void 0 ? void 0 : _serverTimingsByName$3.duration;
    if (!edgeTotalDuration) return null;
    var edgeOffset = $12dca6d5167ba1d6$var$getEdgeOffset(edgeTotalDuration);
    var cfInternalDuration = (((_serverTimingsByName$4 = serverTimingsByName['cdn-upstream-dns']) === null || _serverTimingsByName$4 === void 0 ? void 0 : _serverTimingsByName$4.duration) || 0) + (((_serverTimingsByName$5 = serverTimingsByName['cdn-upstream-connect']) === null || _serverTimingsByName$5 === void 0 ? void 0 : _serverTimingsByName$5.duration) || 0);
    var cfUpstreamDuration = (((_serverTimingsByName$6 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$6 === void 0 ? void 0 : _serverTimingsByName$6.duration) || 0) - cfInternalDuration;
    var cfDownstreamDuration = (((_serverTimingsByName$7 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$7 === void 0 ? void 0 : _serverTimingsByName$7.duration) || 0) - (((_serverTimingsByName$8 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$8 === void 0 ? void 0 : _serverTimingsByName$8.duration) || 0);
    var atlEdgeDuration = (_serverTimingsByName$9 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$9 === void 0 ? void 0 : _serverTimingsByName$9.duration;
    var cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    var edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        var _serverTimingsByName$0;
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: (_serverTimingsByName$0 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$0 === void 0 ? void 0 : _serverTimingsByName$0.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        var _serverTimingsByName$1;
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: (_serverTimingsByName$1 = serverTimingsByName['atl-edge-internal']) === null || _serverTimingsByName$1 === void 0 ? void 0 : _serverTimingsByName$1.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    (edgeTimings === null || edgeTimings === void 0 ? void 0 : edgeTimings.edge) && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $12dca6d5167ba1d6$export$bf7408e83532dcd0() {
    var _config;
    var defaultSSRTimings = $12dca6d5167ba1d6$export$5300d1b82e594615() || {};
    var configTimings = {};
    if (typeof ((_config = $12dca6d5167ba1d6$var$config) === null || _config === void 0 ? void 0 : _config.getTimings) === 'function') configTimings = $12dca6d5167ba1d6$var$config.getTimings();
    var ssrTimings = Object.entries($12dca6d5167ba1d6$var$_objectSpread($12dca6d5167ba1d6$var$_objectSpread({}, configTimings), defaultSSRTimings)).reduce(function(acc, entry) {
        if ($12dca6d5167ba1d6$var$filterEntry(entry[1])) acc[$12dca6d5167ba1d6$var$mapKey(entry[0])] = $12dca6d5167ba1d6$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $12dca6d5167ba1d6$export$c7ad864055e75537() {
    var _config2;
    return !!((_config2 = $12dca6d5167ba1d6$var$config) !== null && _config2 !== void 0 && _config2.getDoneMark());
}
function $12dca6d5167ba1d6$export$5eade9354185583d() {
    var _config3, _config3$getSsrPhaseS;
    return (_config3 = $12dca6d5167ba1d6$var$config) === null || _config3 === void 0 || (_config3$getSsrPhaseS = _config3.getSsrPhaseSuccess) === null || _config3$getSsrPhaseS === void 0 ? void 0 : _config3$getSsrPhaseS.call(_config3);
}
function $12dca6d5167ba1d6$export$3def7672244bab0c() {
    var _config$getDoneMark, _config4;
    return (_config$getDoneMark = (_config4 = $12dca6d5167ba1d6$var$config) === null || _config4 === void 0 ? void 0 : _config4.getDoneMark()) !== null && _config$getDoneMark !== void 0 ? _config$getDoneMark : undefined;
}
function $12dca6d5167ba1d6$export$1c4a9b5e6e22393d() {
    var _config5;
    if (!((_config5 = $12dca6d5167ba1d6$var$config) !== null && _config5 !== void 0 && _config5.getFeatureFlags)) return undefined;
    try {
        var _config$getFeatureFla;
        return (_config$getFeatureFla = $12dca6d5167ba1d6$var$config.getFeatureFlags()) !== null && _config$getFeatureFla !== void 0 ? _config$getFeatureFla : undefined;
    // eslint-disable-next-line no-empty
    } catch (_unused) {}
    return undefined;
}

});

parcelRegister("2ttAa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1cd53c9fdd86cd2b$export$2e2bcd8739ae039; });
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $jFqL6 = parcelRequire("jFqL6");

var $as5v9 = parcelRequire("as5v9");

var $03EZb = parcelRequire("03EZb");

var $bMbcH = parcelRequire("bMbcH");

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");

var $kBQuN = parcelRequire("kBQuN");
var $1cd53c9fdd86cd2b$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $1cd53c9fdd86cd2b$var$traceUFOPageLoad(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    if (!(0, $03EZb.isUFOEnabled)()) return;
    var activeInteraction = (0, $a48Mt.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $kBQuN.default).current = routeName || null;
    var rate = ufoName ? (0, $03EZb.getInteractionRate)(ufoName, 'page_load') : 1;
    var enabledBySamplingRate = (0, $as5v9.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        var newId = (0, $jFqL6.v4)();
        (0, $1BTY2.DefaultInteractionID).current = newId;
        (0, $a48Mt.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $bMbcH.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $a48Mt.addHoldByID)(newId, [], $1cd53c9fdd86cd2b$var$AWAITING_PAGELOAD_NAME, $1cd53c9fdd86cd2b$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $a48Mt.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $a48Mt.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $a48Mt.removeHoldByID)(activeInteraction.id, $1cd53c9fdd86cd2b$var$AWAITING_PAGELOAD_NAME);
    }
}
var $1cd53c9fdd86cd2b$export$2e2bcd8739ae039 = $1cd53c9fdd86cd2b$var$traceUFOPageLoad;
function $1cd53c9fdd86cd2b$export$d0f99433cd4f4028(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    if (!(0, $03EZb.isUFOEnabled)()) return;
    var interaction = (0, $a48Mt.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        var rate = (0, $03EZb.getInteractionRate)(ufoName, 'page_load');
        (0, $a48Mt.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $as5v9.default)(rate)) (0, $kBQuN.default).current = ufoName;
        else (0, $a48Mt.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $a48Mt.removeHoldByID)(interaction.id, $1cd53c9fdd86cd2b$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("46WV6", function(module, exports) {
$parcel$export(module.exports, "assetsClassification", function () { return $d95ec89043c4c1d1$export$719ed4b1b5e94425; });
const $d95ec89043c4c1d1$var$allAtlassian = ({ label: label })=>{
    if (label.startsWith('atlaskit') || label.startsWith('atlassian') || label.startsWith('atlassiansox')) return true;
    return false;
};
const $d95ec89043c4c1d1$var$domContentLoadedEventEnd = (()=>{
    const navigationEntry = typeof window !== 'undefined' && window.performance?.getEntriesByType?.('navigation')?.[0];
    if (typeof PerformanceNavigationTiming !== 'undefined' && navigationEntry instanceof PerformanceNavigationTiming) return navigationEntry.domContentLoadedEventEnd;
    return null;
})();
const $d95ec89043c4c1d1$var$preloaded = ({ entry: entry })=>{
    const isBeforeSSR = $d95ec89043c4c1d1$var$domContentLoadedEventEnd !== null && entry.startTime < $d95ec89043c4c1d1$var$domContentLoadedEventEnd;
    if (entry.type === 'link' && isBeforeSSR) return true;
    return false;
};
const $d95ec89043c4c1d1$export$719ed4b1b5e94425 = {
    all: true,
    allAtlassian: $d95ec89043c4c1d1$var$allAtlassian,
    preloaded: $d95ec89043c4c1d1$var$preloaded
};

});

parcelRegister("g59aM", function(module, exports) {
$parcel$export(module.exports, "getCustomData", function () { return $64398929e6ef2e3a$export$c740a965f4a07e8e; });

var $1oC0p = parcelRequire("1oC0p");

var $2NTow = parcelRequire("2NTow");
function $64398929e6ef2e3a$export$c740a965f4a07e8e(interaction) {
    let customData = {};
    const nextHopProtocol = performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol);
    // @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    customData.httpProtocol = nextHopProtocol?.nextHopProtocol ?? 'unknown';
    const { start: start } = interaction;
    if (interaction.type === 'page_load') {
        customData = {
            ...customData,
            ...(0, $2NTow.getCacheHitRatio)({
                start: start
            }),
            'app:framework:name': 'react',
            'app:framework:version': (0, $1oC0p.version)
        };
        // Add custom metadata for uniform.all experience key events
        if (typeof window !== 'undefined' && window.isUniform) {
            const compositionId = window._uniformPreloadedComposition?._id;
            if (compositionId) customData['uniformCompositionId'] = compositionId;
            const pageRoute = window.location?.pathname || '';
            if (pageRoute) customData['pageRoute'] = pageRoute;
        }
    }
    return customData;
}

});
parcelRegister("2NTow", function(module, exports) {
$parcel$export(module.exports, "getCacheHitRatio", function () { return $20ab208c816fcd61$export$e8a9322c3d9da8a6; });
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ var $20ab208c816fcd61$var$cacheableTypes = [
    'script',
    'link'
];
var $20ab208c816fcd61$var$CACHE_NETWORK = 'network';
var $20ab208c816fcd61$var$CACHE_MEMORY = 'memory';
var $20ab208c816fcd61$var$CACHE_DISK = 'disk';
function $20ab208c816fcd61$var$calculateTransferType(type, duration, size) {
    if (!$20ab208c816fcd61$var$cacheableTypes.includes(type)) return $20ab208c816fcd61$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $20ab208c816fcd61$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $20ab208c816fcd61$var$CACHE_DISK;
    if (size === undefined) return null;
    return $20ab208c816fcd61$var$CACHE_NETWORK;
}
function $20ab208c816fcd61$export$e8a9322c3d9da8a6(_ref) {
    var start = _ref.start;
    var fromCache = 0;
    var preloadFromCache = 0;
    var total = 0;
    var totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        for(var _i = 0, _arr = performance.getEntriesByType('resource'); _i < _arr.length; _i++){
            var entry = _arr[_i];
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            var transferType = $20ab208c816fcd61$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            var isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        var result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
}

});


parcelRegister("dSyvH", function(module, exports) {
$parcel$export(module.exports, "resourceTimingsConfig", function () { return $17f783bc41a3f73d$export$5fc9317dcf7889c3; });

var $kSQ6J = parcelRequire("kSQ6J");

var $3w9zg = parcelRequire("3w9zg");
const $17f783bc41a3f73d$var$isDevelopment = false;
// Web Resource Manager (WRM)
// https://developer.atlassian.com/server/framework/atlassian-sdk/WRM-resource-loading-phases/
const $17f783bc41a3f73d$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $17f783bc41a3f73d$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $3w9zg.sanitiseAssetName)($17f783bc41a3f73d$var$isDevelopment)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $17f783bc41a3f73d$var$getFileName = (url)=>$17f783bc41a3f73d$var$isWRMResource(url) ? $17f783bc41a3f73d$var$getWRMAssetName(url) ?? null : (0, $3w9zg.sanitiseAssetName)($17f783bc41a3f73d$var$isDevelopment)(url) ?? null;
const $17f783bc41a3f73d$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($kSQ6J)))(url, true);
    const fileName = parsedUrl.pathname.replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/gi, '<uuid>').replace(/\/\d+$/i, '/<id>');
    return fileName;
};
const $17f783bc41a3f73d$export$5fc9317dcf7889c3 = {
    sanitiseEndpoints: $17f783bc41a3f73d$var$sanitiseEndpoints,
    mapResources: $17f783bc41a3f73d$var$getFileName,
    hasTimingHeaders: (url)=>$17f783bc41a3f73d$var$isWRMResource(url),
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});
parcelRegister("kSQ6J", function(module, exports) {
'use strict';

var $dlh30 = parcelRequire("dlh30");

var $MG0Sh = parcelRequire("MG0Sh");
var $f3414543268a27b0$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $f3414543268a27b0$var$CRHTLF = /[\n\r\t]/g, $f3414543268a27b0$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $f3414543268a27b0$var$port = /:\d+$/, $f3414543268a27b0$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $f3414543268a27b0$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $f3414543268a27b0$var$trimLeft(str) {
    return (str ? str : '').toString().replace($f3414543268a27b0$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $f3414543268a27b0$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $f3414543268a27b0$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $f3414543268a27b0$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $f3414543268a27b0$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $f3414543268a27b0$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $f3414543268a27b0$var$Url(loc, {});
        for(key in $f3414543268a27b0$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $f3414543268a27b0$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $f3414543268a27b0$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $f3414543268a27b0$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $f3414543268a27b0$var$extractProtocol(address, location) {
    address = $f3414543268a27b0$var$trimLeft(address);
    address = address.replace($f3414543268a27b0$var$CRHTLF, '');
    location = location || {};
    var match = $f3414543268a27b0$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($f3414543268a27b0$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $f3414543268a27b0$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $f3414543268a27b0$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $f3414543268a27b0$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $f3414543268a27b0$var$Url(address, location, parser) {
    address = $f3414543268a27b0$var$trimLeft(address);
    address = address.replace($f3414543268a27b0$var$CRHTLF, '');
    if (!(this instanceof $f3414543268a27b0$var$Url)) return new $f3414543268a27b0$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $f3414543268a27b0$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $MG0Sh.parse;
    location = $f3414543268a27b0$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $f3414543268a27b0$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $f3414543268a27b0$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$f3414543268a27b0$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $f3414543268a27b0$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $f3414543268a27b0$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$dlh30(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $f3414543268a27b0$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $f3414543268a27b0$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $MG0Sh.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$dlh30(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($f3414543268a27b0$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $f3414543268a27b0$var$rules.length; i++){
        var ins = $f3414543268a27b0$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $f3414543268a27b0$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $f3414543268a27b0$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $MG0Sh.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $f3414543268a27b0$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $f3414543268a27b0$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $f3414543268a27b0$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$f3414543268a27b0$var$Url.prototype = {
    set: $f3414543268a27b0$var$set,
    toString: $f3414543268a27b0$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$f3414543268a27b0$var$Url.extractProtocol = $f3414543268a27b0$var$extractProtocol;
$f3414543268a27b0$var$Url.location = $f3414543268a27b0$var$lolcation;
$f3414543268a27b0$var$Url.trimLeft = $f3414543268a27b0$var$trimLeft;
$f3414543268a27b0$var$Url.qs = $MG0Sh;
module.exports = $f3414543268a27b0$var$Url;

});
parcelRegister("dlh30", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("MG0Sh", function(module, exports) {
$parcel$export(module.exports, "stringify", function () { return $092512bc9a8641b7$export$fac44ee5b035f737; }, function (v) { return $092512bc9a8641b7$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parse", function () { return $092512bc9a8641b7$export$98e6a39c04603d36; }, function (v) { return $092512bc9a8641b7$export$98e6a39c04603d36 = v; });
//
// Expose the module.
//
var $092512bc9a8641b7$export$fac44ee5b035f737;
var $092512bc9a8641b7$export$98e6a39c04603d36;
'use strict';
var $092512bc9a8641b7$var$has = Object.prototype.hasOwnProperty, $092512bc9a8641b7$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $092512bc9a8641b7$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $092512bc9a8641b7$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $092512bc9a8641b7$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $092512bc9a8641b7$var$decode(part[1]), value = $092512bc9a8641b7$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $092512bc9a8641b7$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($092512bc9a8641b7$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $092512bc9a8641b7$var$undef || isNaN(value))) value = '';
        key = $092512bc9a8641b7$var$encode(key);
        value = $092512bc9a8641b7$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$092512bc9a8641b7$export$fac44ee5b035f737 = $092512bc9a8641b7$var$querystringify;
$092512bc9a8641b7$export$98e6a39c04603d36 = $092512bc9a8641b7$var$querystring;

});


parcelRegister("3w9zg", function(module, exports) {
$parcel$export(module.exports, "sanitiseAssetName", function () { return $e042a0a96a6d1e5f$export$f1e684104ed4e1d4; });
const $e042a0a96a6d1e5f$var$getBaseName = (assetPathOrURL)=>assetPathOrURL.split('#')[0]?.split('?')[0]?.split('/').pop() ?? '';
const $e042a0a96a6d1e5f$export$f1e684104ed4e1d4 = (isDevelopment)=>(assetPathOrURL)=>{
        const baseName = $e042a0a96a6d1e5f$var$getBaseName(assetPathOrURL);
        // we desire "[name.with.dots].[ext]"
        // in debug we expect "[name.with.dots].[ext]"
        // in production we expect "[name.with.dots].[hash].[cache-bust].[ext]"
        const split = baseName.split('.');
        // CHANGED: Need to add to process.env.BUNDLER
        const BUNDLER = 'parcel';
        if (BUNDLER === 'parcel') {
            if (split.length === 1) // Inline bundles are only an id
            return split[0];
            // return the first part and extension - this should always be valid for Parcel bundles.
            // In the case of shared bundles (e.g. shared.hash.js) this will return 'shared.js'.
            // This will cause only the first shared bundle loaded to be tracked.
            // In the short term this is desired to prevent too much noise.
            return [
                split[0],
                split[split.length - 1]
            ].join('.');
        }
        if (isDevelopment || split.length < 2) return baseName;
        // CHANGED
        const file = split.slice(0, 1);
        const extension = split.slice(-1);
        return `${file}.${extension}`;
    };

});



parcelRegister("8oqW7", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});

parcelRegister("g0QpW", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", function () { return $feb7e5abcc1937e7$export$e9ba7ef9458d1a4a; });

var $2H71x = parcelRequire("2H71x");

var $aHnuZ = parcelRequire("aHnuZ");
var $wetcE = parcelRequire("wetcE");

var $gx3aw = parcelRequire("gx3aw");
const $feb7e5abcc1937e7$var$getAnonIdUsedByFeatureGatesClientInSSR = ()=>window.featureGateBootstrapValues?.identifiers?.analyticsAnonymousId ?? '';
const $feb7e5abcc1937e7$var$getAtlassianUserId = ()=>{
    const userId = (0, $gx3aw.Cookie).readCookie('__aid_user_id');
    if (userId) return decodeURIComponent(userId);
    return null;
};
const $feb7e5abcc1937e7$var$getGASv3Environment = ()=>{
    return (0, $wetcE.envType).PROD;
};
const $feb7e5abcc1937e7$var$getXidEnvironment = ()=>{
    return (0, $2H71x.Environment).PROD;
};
const $feb7e5abcc1937e7$var$shouldUseStargate = ()=>{
    return true;
};
const $feb7e5abcc1937e7$var$getBuildVersion = ()=>{
    return "p-df99072e01";
};
const $feb7e5abcc1937e7$export$e9ba7ef9458d1a4a = ()=>{
    const client = new (0, $aHnuZ.default)({
        env: $feb7e5abcc1937e7$var$getGASv3Environment(),
        product: 'marketing',
        version: $feb7e5abcc1937e7$var$getBuildVersion(),
        locale: 'en-us'
    }, {
        useStargate: $feb7e5abcc1937e7$var$shouldUseStargate(),
        xidConsent: true,
        xidPromiseFn: ()=>new (0, $2H71x.XID)($feb7e5abcc1937e7$var$getXidEnvironment()).getXidCallbackForPromise(),
        // If SSR wasn't given an anonymous ID cookie, then it will generate one and pass it down.
        // This function will ensure the analytics client uses the same one instead of generating another.
        customAnonymousIdGenerator: $feb7e5abcc1937e7$var$getAnonIdUsedByFeatureGatesClientInSSR,
        // Default is 500, reducing to increase reliabilty of events fired before redirect
        flushWaitInterval: 100
    });
    const aaid = $feb7e5abcc1937e7$var$getAtlassianUserId();
    if (aaid) client.setUserInfo((0, $wetcE.userType).ATLASSIAN_ACCOUNT, aaid);
    return client;
};

});
parcelRegister("2H71x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3IQL = parcelRequire("d3IQL");

$d3IQL.__exportStar((parcelRequire("bG2z2")), module.exports);

var $2hx57 = parcelRequire("2hx57");
module.exports.XID = $2hx57.XID;

});
parcelRegister("d3IQL", function(module, exports) {
$parcel$export(module.exports, "__extends", function () { return $981e587a709efa1d$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $981e587a709efa1d$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $981e587a709efa1d$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $981e587a709efa1d$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $981e587a709efa1d$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $981e587a709efa1d$export$f33643c0debef087; });
$parcel$export(module.exports, "__spread", function () { return $981e587a709efa1d$export$afc72e2116322959; });
$parcel$export(module.exports, "__spreadArrays", function () { return $981e587a709efa1d$export$6388937ca91ccae8; });
$parcel$export(module.exports, "__spreadArray", function () { return $981e587a709efa1d$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importDefault", function () { return $981e587a709efa1d$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $981e587a709efa1d$var$extendStatics = function(d, b) {
    $981e587a709efa1d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $981e587a709efa1d$var$extendStatics(d, b);
};
function $981e587a709efa1d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $981e587a709efa1d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $981e587a709efa1d$export$18ce0697a983be9b = function() {
    $981e587a709efa1d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $981e587a709efa1d$export$18ce0697a983be9b.apply(this, arguments);
};
function $981e587a709efa1d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $981e587a709efa1d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $981e587a709efa1d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $981e587a709efa1d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $981e587a709efa1d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $981e587a709efa1d$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $981e587a709efa1d$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $981e587a709efa1d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $981e587a709efa1d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $981e587a709efa1d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $981e587a709efa1d$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $981e587a709efa1d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $981e587a709efa1d$export$45d3717a4c69092e(o, m, p);
}
function $981e587a709efa1d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $981e587a709efa1d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $981e587a709efa1d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($981e587a709efa1d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $981e587a709efa1d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $981e587a709efa1d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $981e587a709efa1d$export$10c90e4f7922046c(v) {
    return this instanceof $981e587a709efa1d$export$10c90e4f7922046c ? (this.v = v, this) : new $981e587a709efa1d$export$10c90e4f7922046c(v);
}
function $981e587a709efa1d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $981e587a709efa1d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $981e587a709efa1d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $981e587a709efa1d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $981e587a709efa1d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $981e587a709efa1d$export$19a8beecd37a4c45 === "function" ? $981e587a709efa1d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $981e587a709efa1d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $981e587a709efa1d$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $981e587a709efa1d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $981e587a709efa1d$export$45d3717a4c69092e(result, mod, k);
    }
    $981e587a709efa1d$var$__setModuleDefault(result, mod);
    return result;
}
function $981e587a709efa1d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $981e587a709efa1d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $981e587a709efa1d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $981e587a709efa1d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $981e587a709efa1d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $981e587a709efa1d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $981e587a709efa1d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $981e587a709efa1d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $981e587a709efa1d$export$2e2bcd8739ae039 = {
    __extends: $981e587a709efa1d$export$a8ba968b8961cb8a,
    __assign: $981e587a709efa1d$export$18ce0697a983be9b,
    __rest: $981e587a709efa1d$export$3c9a16f847548506,
    __decorate: $981e587a709efa1d$export$29e00dfd3077644b,
    __param: $981e587a709efa1d$export$d5ad3fd78186038f,
    __metadata: $981e587a709efa1d$export$f1db080c865becb9,
    __awaiter: $981e587a709efa1d$export$1050f835b63b671e,
    __generator: $981e587a709efa1d$export$67ebef60e6f28a6,
    __createBinding: $981e587a709efa1d$export$45d3717a4c69092e,
    __exportStar: $981e587a709efa1d$export$f33643c0debef087,
    __values: $981e587a709efa1d$export$19a8beecd37a4c45,
    __read: $981e587a709efa1d$export$8d051b38c9118094,
    __spread: $981e587a709efa1d$export$afc72e2116322959,
    __spreadArrays: $981e587a709efa1d$export$6388937ca91ccae8,
    __spreadArray: $981e587a709efa1d$export$1216008129fb82ed,
    __await: $981e587a709efa1d$export$10c90e4f7922046c,
    __asyncGenerator: $981e587a709efa1d$export$e427f37a30a4de9b,
    __asyncDelegator: $981e587a709efa1d$export$bbd80228419bb833,
    __asyncValues: $981e587a709efa1d$export$e3b29a3d6162315f,
    __makeTemplateObject: $981e587a709efa1d$export$4fb47efe1390b86f,
    __importStar: $981e587a709efa1d$export$c21735bcef00d192,
    __importDefault: $981e587a709efa1d$export$da59b14a69baef04,
    __classPrivateFieldGet: $981e587a709efa1d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $981e587a709efa1d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $981e587a709efa1d$export$81fdc39f203e4e04,
    __addDisposableResource: $981e587a709efa1d$export$88ac25d8e944e405,
    __disposeResources: $981e587a709efa1d$export$8f076105dc360e92
};

});

parcelRegister("bG2z2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $88059b26c17c7e63$var$Environment;
(function(Environment) {
    Environment["TEST"] = "test";
    Environment["LOCAL"] = "local";
    Environment["DEV"] = "dev";
    Environment["STAGE"] = "stage";
    Environment["PROD"] = "prod";
})($88059b26c17c7e63$var$Environment = module.exports.Environment || (module.exports.Environment = {}));
var $88059b26c17c7e63$var$XIDItemType;
(function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
})($88059b26c17c7e63$var$XIDItemType = module.exports.XIDItemType || (module.exports.XIDItemType = {}));
var $88059b26c17c7e63$var$XIDState;
(function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
})($88059b26c17c7e63$var$XIDState = module.exports.XIDState || (module.exports.XIDState = {}));
var $88059b26c17c7e63$var$XIDGenerateMode;
(function(XIDGenerateMode) {
    XIDGenerateMode["XC_ONLY"] = "XC_ONLY";
    XIDGenerateMode["UID_ONLY"] = "UID_ONLY";
    XIDGenerateMode["CACHE_ONLY"] = "CACHE_ONLY";
    XIDGenerateMode["XC_UID"] = "XC_UID";
    XIDGenerateMode["CACHE_XC_UID"] = "CACHE_XC_UID";
})($88059b26c17c7e63$var$XIDGenerateMode = module.exports.XIDGenerateMode || (module.exports.XIDGenerateMode = {}));

});

parcelRegister("2hx57", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3IQL = parcelRequire("d3IQL");

var $1a96d49fa11c79dc$var$promise_polyfill_1 = $d3IQL.__importDefault((parcelRequire("i2O2X")));

var $k1N3S = parcelRequire("k1N3S");

var $1tpFw = parcelRequire("1tpFw");

var $1NXMv = parcelRequire("1NXMv");

var $c7F1s = parcelRequire("c7F1s");

var $bG2z2 = parcelRequire("bG2z2");
module.exports.defaultTimeout = 5000;
var $1a96d49fa11c79dc$var$delayUidGenerate = 1e3;
var $1a96d49fa11c79dc$var$nonProdMaxTimeout = 30000;
var $1a96d49fa11c79dc$var$prodMaxTimeout = 10000;
var $1a96d49fa11c79dc$var$minTimeout = 2000;
var $1a96d49fa11c79dc$var$XID = function() {
    function XID(env, timeout) {
        if (env === void 0) env = $bG2z2.Environment.LOCAL;
        if (timeout === void 0) timeout = module.exports.defaultTimeout;
        this.storageEnabled = true;
        this.timeoutUid = {
            type: $bG2z2.XIDItemType.UID,
            state: $bG2z2.XIDState.TIMEOUT
        };
        if (!env) throw new Error('Missing env configuration');
        this.env = env;
        var maxTimeout = this.env === $bG2z2.Environment.PROD ? $1a96d49fa11c79dc$var$prodMaxTimeout : $1a96d49fa11c79dc$var$nonProdMaxTimeout;
        if (timeout >= $1a96d49fa11c79dc$var$minTimeout && timeout <= maxTimeout) this.timeout = timeout;
        else {
            if (this.env !== $bG2z2.Environment.PROD) console.log("timeout configuration must be in the range of [" + $1a96d49fa11c79dc$var$minTimeout + ", " + maxTimeout + "] seconds");
            this.timeout = module.exports.defaultTimeout;
        }
    }
    XID.prototype.getTimeoutPromise = function(timeoutXid) {
        var _this = this;
        return new $1a96d49fa11c79dc$var$promise_polyfill_1.default(function(resolve) {
            setTimeout(function() {
                resolve([
                    timeoutXid
                ]);
            }, (_this.timeout - $1a96d49fa11c79dc$var$delayUidGenerate) / 2);
        });
    };
    XID.prototype.getXcPromiseAndSave = function() {
        var _this = this;
        return new $1a96d49fa11c79dc$var$promise_polyfill_1.default(function(resolve) {
            _this.getXc().then(function(xc) {
                if (_this.storageEnabled) $k1N3S.Storage.saveXid([
                    xc
                ]);
                resolve([
                    xc
                ]);
            });
        });
    };
    XID.prototype.getUidPromiseAndSave = function() {
        var _this = this;
        return new $1a96d49fa11c79dc$var$promise_polyfill_1.default(function(resolve) {
            var handleUid = function() {
                var cachedUids = [];
                if (_this.storageEnabled) cachedUids = $k1N3S.Storage.getUids();
                var uids = $1tpFw.UIDGenerator.getValue(cachedUids);
                if (_this.storageEnabled) {
                    $k1N3S.Storage.saveUids(uids);
                    $k1N3S.Storage.saveXid(uids);
                }
                resolve(uids);
            };
            var requestIdleCallback = window.requestIdleCallback;
            requestIdleCallback ? requestIdleCallback(handleUid) : setTimeout(handleUid, $1a96d49fa11c79dc$var$delayUidGenerate);
        });
    };
    XID.prototype.getXidPromiseInXcUidOnly = function() {
        var _this = this;
        return this.getXcPromiseAndSave().then(function(xc) {
            if (xc && xc.length > 0 && xc[0].createdAt && xc[0].value) return xc;
            else return _this.getTimeoutPromise(_this.timeoutUid), _this.getUidPromiseAndSave().then(function(uid) {
                return $d3IQL.__spreadArrays(uid, xc);
            });
        });
    };
    XID.prototype.getXidCallbackForPromise = function(mode, storageEnabled) {
        if (mode === void 0) mode = $bG2z2.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        var transformedXids;
        var transform = function(xids) {
            if (transformedXids) return transformedXids;
            transformedXids = xids.map(function(xid) {
                if (xid.state === $bG2z2.XIDState.NEW || xid.state === $bG2z2.XIDState.CHANGED) return {
                    state: $bG2z2.XIDState.EXISTING,
                    type: xid.type,
                    createdAt: xid.createdAt,
                    value: xid.value
                };
                return xid;
            });
            return xids;
        };
        return this.getXidPromise(mode, storageEnabled).then(function(xid) {
            return function() {
                return transform(xid);
            };
        });
    };
    XID.prototype.getXidPromise = function(mode, storageEnabled) {
        var _this = this;
        if (mode === void 0) mode = $bG2z2.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        this.storageEnabled = storageEnabled;
        var cachedXidValue = mode === $bG2z2.XIDGenerateMode.CACHE_ONLY || mode === $bG2z2.XIDGenerateMode.CACHE_XC_UID ? $k1N3S.Storage.getCachedXID() : [];
        switch(mode){
            case $bG2z2.XIDGenerateMode.XC_ONLY:
                return $c7F1s.promiseWithTimer(function() {
                    return _this.getXcPromiseAndSave();
                });
            case $bG2z2.XIDGenerateMode.UID_ONLY:
                return $c7F1s.promiseWithTimer(function() {
                    return $1a96d49fa11c79dc$var$promise_polyfill_1.default.race([
                        _this.getTimeoutPromise(_this.timeoutUid),
                        _this.getUidPromiseAndSave()
                    ]);
                });
            case $bG2z2.XIDGenerateMode.XC_UID:
                return $c7F1s.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
            case $bG2z2.XIDGenerateMode.CACHE_ONLY:
                return $1a96d49fa11c79dc$var$promise_polyfill_1.default.resolve(cachedXidValue);
            case $bG2z2.XIDGenerateMode.CACHE_XC_UID:
            default:
                return cachedXidValue.length > 0 ? $1a96d49fa11c79dc$var$promise_polyfill_1.default.resolve(cachedXidValue) : $c7F1s.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
        }
    };
    XID.prototype.getXc = function() {
        return $1NXMv.XCGenerator.getValue(this.env, (this.timeout - $1a96d49fa11c79dc$var$delayUidGenerate) / 2, this.storageEnabled);
    };
    XID.prototype.getUidDetails = function() {
        return $1tpFw.UIDGenerator.getDetails();
    };
    return XID;
}();
module.exports.XID = $1a96d49fa11c79dc$var$XID;

});
parcelRegister("i2O2X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $d22f3c274cf2d5ab$export$2e2bcd8739ae039; });

var $idqBN = parcelRequire("idqBN");

var $8KLZl = parcelRequire("8KLZl");

var $lh0F4 = parcelRequire("lh0F4");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $d22f3c274cf2d5ab$var$setTimeoutFunc = setTimeout;
function $d22f3c274cf2d5ab$var$isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
}
function $d22f3c274cf2d5ab$var$noop() {}
// Polyfill for Function.prototype.bind
function $d22f3c274cf2d5ab$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $d22f3c274cf2d5ab$var$Promise(fn) {
    if (!(this instanceof $d22f3c274cf2d5ab$var$Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $d22f3c274cf2d5ab$var$doResolve(fn, this);
}
function $d22f3c274cf2d5ab$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $d22f3c274cf2d5ab$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $d22f3c274cf2d5ab$var$resolve : $d22f3c274cf2d5ab$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $d22f3c274cf2d5ab$var$reject(deferred.promise, e);
            return;
        }
        $d22f3c274cf2d5ab$var$resolve(deferred.promise, ret);
    });
}
function $d22f3c274cf2d5ab$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof $d22f3c274cf2d5ab$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $d22f3c274cf2d5ab$var$finale(self);
                return;
            } else if (typeof then === 'function') {
                $d22f3c274cf2d5ab$var$doResolve($d22f3c274cf2d5ab$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $d22f3c274cf2d5ab$var$finale(self);
    } catch (e) {
        $d22f3c274cf2d5ab$var$reject(self, e);
    }
}
function $d22f3c274cf2d5ab$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $d22f3c274cf2d5ab$var$finale(self);
}
function $d22f3c274cf2d5ab$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $d22f3c274cf2d5ab$var$Promise._immediateFn(function() {
        if (!self._handled) $d22f3c274cf2d5ab$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$d22f3c274cf2d5ab$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $d22f3c274cf2d5ab$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $d22f3c274cf2d5ab$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $d22f3c274cf2d5ab$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $d22f3c274cf2d5ab$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $d22f3c274cf2d5ab$var$reject(self, ex);
    }
}
$d22f3c274cf2d5ab$var$Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
$d22f3c274cf2d5ab$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($d22f3c274cf2d5ab$var$noop);
    $d22f3c274cf2d5ab$var$handle(this, new $d22f3c274cf2d5ab$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$d22f3c274cf2d5ab$var$Promise.prototype['finally'] = (0, $idqBN.default);
$d22f3c274cf2d5ab$var$Promise.all = function(arr) {
    return new $d22f3c274cf2d5ab$var$Promise(function(resolve, reject) {
        if (!$d22f3c274cf2d5ab$var$isArray(arr)) return reject(new TypeError('Promise.all accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$d22f3c274cf2d5ab$var$Promise.any = (0, $lh0F4.default);
$d22f3c274cf2d5ab$var$Promise.allSettled = (0, $8KLZl.default);
$d22f3c274cf2d5ab$var$Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === $d22f3c274cf2d5ab$var$Promise) return value;
    return new $d22f3c274cf2d5ab$var$Promise(function(resolve) {
        resolve(value);
    });
};
$d22f3c274cf2d5ab$var$Promise.reject = function(value) {
    return new $d22f3c274cf2d5ab$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$d22f3c274cf2d5ab$var$Promise.race = function(arr) {
    return new $d22f3c274cf2d5ab$var$Promise(function(resolve, reject) {
        if (!$d22f3c274cf2d5ab$var$isArray(arr)) return reject(new TypeError('Promise.race accepts an array'));
        for(var i = 0, len = arr.length; i < len; i++)$d22f3c274cf2d5ab$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$d22f3c274cf2d5ab$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === 'function' && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $d22f3c274cf2d5ab$var$setTimeoutFunc(fn, 0);
};
$d22f3c274cf2d5ab$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
};
var $d22f3c274cf2d5ab$export$2e2bcd8739ae039 = $d22f3c274cf2d5ab$var$Promise;

});
parcelRegister("idqBN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d42e14ccf7c3d72c$export$2e2bcd8739ae039; });
/**
 * @this {Promise}
 */ function $d42e14ccf7c3d72c$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $d42e14ccf7c3d72c$export$2e2bcd8739ae039 = $d42e14ccf7c3d72c$var$finallyConstructor;

});

parcelRegister("8KLZl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $65f7d81dd0d926c3$export$2e2bcd8739ae039; });
function $65f7d81dd0d926c3$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError(typeof arr + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: 'rejected',
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: 'fulfilled',
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $65f7d81dd0d926c3$export$2e2bcd8739ae039 = $65f7d81dd0d926c3$var$allSettled;

});

parcelRegister("lh0F4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f7cbb2d8f1896c08$export$2e2bcd8739ae039; });
/**
 * @constructor
 */ function $f7cbb2d8f1896c08$var$AggregateError(errors, message) {
    this.name = 'AggregateError', this.errors = errors;
    this.message = message || '';
}
$f7cbb2d8f1896c08$var$AggregateError.prototype = Error.prototype;
function $f7cbb2d8f1896c08$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError('Promise.any accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $f7cbb2d8f1896c08$var$AggregateError(rejectionReasons, 'All promises were rejected'));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $f7cbb2d8f1896c08$export$2e2bcd8739ae039 = $f7cbb2d8f1896c08$var$any;

});


parcelRegister("k1N3S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3IQL = parcelRequire("d3IQL");

var $9DMQ7 = parcelRequire("9DMQ7");

var $bG2z2 = parcelRequire("bG2z2");

var $edQBq = parcelRequire("edQBq");

var $6TpLk = parcelRequire("6TpLk");

var $4WQkp = parcelRequire("4WQkp");
var $e949f53ee079f731$var$UID_REFRESH_PERIOD = 604800000;
var $e949f53ee079f731$var$XC_REFRESH_PERIOD = 2592000000;
module.exports.XC_CURRENT = 'atl_xid.xc';
var $e949f53ee079f731$var$XID_REFRESHED_AT = 'atl_xid.ts';
var $e949f53ee079f731$var$XID_CURRENT = 'atl_xid.current';
var $e949f53ee079f731$var$UIDS_ALL = 'atl_xid.uid';
var $e949f53ee079f731$var$UIDS_STORE_LIMIT = 20;
var $e949f53ee079f731$var$Storage = function() {
    function Storage() {}
    Storage.getCachedXID = function() {
        try {
            var currentXID = $edQBq.getXidItemFromCache($e949f53ee079f731$var$XID_CURRENT);
            var refreshedAt = $edQBq.getCache($e949f53ee079f731$var$XID_REFRESHED_AT);
            var isFresh = false;
            if (currentXID.length > 0 && currentXID[0].type === $bG2z2.XIDItemType.UID) isFresh = parseInt(refreshedAt || '', 10) >= new Date().getTime() - $e949f53ee079f731$var$UID_REFRESH_PERIOD;
            else if (currentXID.length > 0 && currentXID[0].type === $bG2z2.XIDItemType.XC) isFresh = parseInt(refreshedAt || '', 10) >= new Date().getTime() - $e949f53ee079f731$var$XC_REFRESH_PERIOD;
            if (isFresh) {
                for(var _i = 0, currentXID_1 = currentXID; _i < currentXID_1.length; _i++){
                    var entry = currentXID_1[_i];
                    entry.state = $bG2z2.XIDState.EXISTING;
                }
                return currentXID;
            } else return [];
        } catch (err) {
            return [];
        }
    };
    Storage.saveXid = function(xid) {
        try {
            $9DMQ7.setCookie($e949f53ee079f731$var$XID_REFRESHED_AT, new Date().getTime());
            $edQBq.setLocalstorage($e949f53ee079f731$var$XID_REFRESHED_AT, new Date().getTime().toString());
            var xidCache = [];
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                if (entry.value && entry.createdAt) {
                    xidCache.push({
                        type: entry.type,
                        value: entry.value,
                        createdAt: entry.createdAt
                    });
                    break;
                }
            }
            $9DMQ7.setCookie($e949f53ee079f731$var$XID_CURRENT, JSON.stringify(xidCache));
            $edQBq.setLocalstorage($e949f53ee079f731$var$XID_CURRENT, JSON.stringify(xidCache));
        } catch (err) {
            console.error('Error setting xid cookie.');
        }
    };
    Storage.updateXc = function(env, xc) {
        try {
            if (env === $bG2z2.Environment.PROD && $6TpLk.isAtlassianComDomain()) return Storage.processAtlassianComDomainXc(xc);
            else Storage.saveXcLocalstorage(xc);
        } catch (err) {
            console.error('Error setting xc cookie.');
        }
        return xc;
    };
    Storage.getUids = function() {
        var uid = $edQBq.getXidItemFromCache($e949f53ee079f731$var$UIDS_ALL) || [];
        for(var _i = 0, uid_1 = uid; _i < uid_1.length; _i++){
            var entry = uid_1[_i];
            entry.state = $bG2z2.XIDState.EXISTING;
        }
        return uid;
    };
    Storage.saveUids = function(uid) {
        try {
            var uidCache = [];
            for(var _i = 0, uid_2 = uid; _i < uid_2.length; _i++){
                var entry = uid_2[_i];
                if (entry.value && entry.createdAt) uidCache.push({
                    type: entry.type,
                    value: entry.value,
                    createdAt: entry.createdAt
                });
            }
            uidCache.slice(0, $e949f53ee079f731$var$UIDS_STORE_LIMIT);
            $edQBq.setLocalstorage($e949f53ee079f731$var$UIDS_ALL, JSON.stringify(uidCache));
        } catch (err) {
            console.error('Error setting uid cookie.');
        }
    };
    Storage.saveXcLocalstorage = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $edQBq.getXidFromLocalStorage(module.exports.XC_CURRENT);
            if (currentXcCache && currentXcCache.value === xc.value) return;
            else if (currentXcCache && currentXcCache.value !== xc.value) xc.state = $bG2z2.XIDState.CHANGED;
            var xidCache = {
                type: xc.type,
                value: xc.value,
                createdAt: xc.createdAt
            };
            $edQBq.setLocalstorage(module.exports.XC_CURRENT, JSON.stringify(xidCache));
        }
    };
    Storage.processAtlassianComDomainXc = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $edQBq.getXidFromCookie(module.exports.XC_CURRENT);
            if (currentXcCache) {
                $9DMQ7.setCookie(module.exports.XC_CURRENT, JSON.stringify(currentXcCache), $9DMQ7.getCrossDomainCookieOption());
                var currentXc = $d3IQL.__assign({
                    state: $bG2z2.XIDState.EXISTING
                }, currentXcCache);
                Storage.saveXcLocalstorage(currentXc);
                return currentXc;
            } else {
                var newXcCache = {
                    value: $4WQkp.uuidv4(),
                    createdAt: new Date().toISOString(),
                    type: $bG2z2.XIDItemType.XC
                };
                $9DMQ7.setCookie(module.exports.XC_CURRENT, JSON.stringify(newXcCache), $9DMQ7.getCrossDomainCookieOption());
                var newXc = $d3IQL.__assign({
                    state: $bG2z2.XIDState.NEW
                }, newXcCache);
                Storage.saveXcLocalstorage(newXc);
                return newXc;
            }
        } else return xc;
    };
    return Storage;
}();
module.exports.Storage = $e949f53ee079f731$var$Storage;

});
parcelRegister("9DMQ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3IQL = parcelRequire("d3IQL");
var $704da42180282fe3$var$set = function(name, value, options) {
    var str = $704da42180282fe3$var$encode(name) + '=' + $704da42180282fe3$var$encode((value || '').toString());
    if (value == null) options.maxage = -1;
    var expiry;
    if (options.maxage) expiry = new Date(+new Date() + options.maxage);
    if (options.path) str += '; path=' + options.path;
    if (options.domain) str += '; domain=' + options.domain;
    if (expiry) str += '; expires=' + expiry.toUTCString();
    if (options.secure) str += '; secure';
    if (options.sameSite) str += '; samesite=' + options.sameSite;
    document.cookie = str;
    return str;
};
var $704da42180282fe3$var$all = function() {
    try {
        return $704da42180282fe3$var$parse(document.cookie);
    } catch (err) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(err.stack || err);
        return {};
    }
};
function $704da42180282fe3$var$get(name) {
    return $704da42180282fe3$var$all()[name];
}
function $704da42180282fe3$var$parse(str) {
    var obj = {};
    var pairs = str.split(/ *; */);
    if (pairs[0] === '') return obj;
    pairs.forEach(function(item) {
        var pair = item.split('=');
        var key = $704da42180282fe3$var$decode(pair[0]);
        var value = $704da42180282fe3$var$decode(pair[1]);
        if (key && value) obj[key] = value;
    });
    return obj;
}
function $704da42180282fe3$var$encode(value) {
    try {
        return encodeURIComponent(value);
    } catch (e) {
        console.log('error `encode(%o)` - %o', value, e);
        return "";
    }
}
function $704da42180282fe3$var$decode(value) {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        console.log('error `decode(%o)` - %o', value, e);
        return "";
    }
}
function $704da42180282fe3$var$getCookie(name) {
    return $704da42180282fe3$var$get(name);
}
module.exports.getCookie = $704da42180282fe3$var$getCookie;
function $704da42180282fe3$var$getAllCookies() {
    return $704da42180282fe3$var$all();
}
module.exports.getAllCookies = $704da42180282fe3$var$getAllCookies;
function $704da42180282fe3$var$setCookie(name, value, options) {
    var finalOption = $d3IQL.__assign({
        maxage: 31536000000,
        secure: true,
        path: '/',
        expires: null,
        domain: null,
        sameSite: 'lax'
    }, options);
    return $704da42180282fe3$var$set(name, value, finalOption);
}
module.exports.setCookie = $704da42180282fe3$var$setCookie;
function $704da42180282fe3$var$getCrossDomainCookieOption() {
    var domain = window.location.hostname.split('.').slice(-2).join('.');
    return {
        sameSite: 'None',
        domain: domain
    };
}
module.exports.getCrossDomainCookieOption = $704da42180282fe3$var$getCrossDomainCookieOption;

});

parcelRegister("edQBq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9DMQ7 = parcelRequire("9DMQ7");

var $fj8JW = parcelRequire("fj8JW");
var $a5ab15655e826d30$var$parseCachedXidItem = function(value) {
    try {
        var xid = JSON.parse(value);
        if (xid instanceof Array) {
            var valid = true;
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                valid = valid && $fj8JW.checkXidValid(entry);
            }
            return valid ? xid : undefined;
        } else return $fj8JW.checkXidValid(xid) ? xid : undefined;
    } catch (err) {
        return;
    }
};
function $a5ab15655e826d30$var$getFromLocalStorage(name) {
    try {
        return localStorage.getItem(name) || '';
    } catch (err) {}
}
function $a5ab15655e826d30$var$getXidFromCookie(name) {
    var cookieValue = $9DMQ7.getCookie(name);
    return $a5ab15655e826d30$var$parseCachedXidItem(cookieValue);
}
module.exports.getXidFromCookie = $a5ab15655e826d30$var$getXidFromCookie;
function $a5ab15655e826d30$var$getXidFromLocalStorage(name) {
    var lsValue = '';
    try {
        lsValue = localStorage.getItem(name) || '';
    } catch (err) {}
    return $a5ab15655e826d30$var$parseCachedXidItem(lsValue);
}
module.exports.getXidFromLocalStorage = $a5ab15655e826d30$var$getXidFromLocalStorage;
function $a5ab15655e826d30$var$setLocalstorage(name, value) {
    try {
        localStorage.setItem(name, value);
    } catch (err) {}
}
module.exports.setLocalstorage = $a5ab15655e826d30$var$setLocalstorage;
function $a5ab15655e826d30$var$getCache(name) {
    return $9DMQ7.getCookie(name) || $a5ab15655e826d30$var$getFromLocalStorage(name);
}
module.exports.getCache = $a5ab15655e826d30$var$getCache;
function $a5ab15655e826d30$var$getXidItemFromCache(name) {
    return $a5ab15655e826d30$var$getXidFromCookie(name) || $a5ab15655e826d30$var$getXidFromLocalStorage(name);
}
module.exports.getXidItemFromCache = $a5ab15655e826d30$var$getXidItemFromCache;

});
parcelRegister("fj8JW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bG2z2 = parcelRequire("bG2z2");
module.exports.checkXidValid = function(xid) {
    return (xid.type === $bG2z2.XIDItemType.UID || xid.type === $bG2z2.XIDItemType.XC) && !!xid.value && !!Date.parse(xid.createdAt);
};

});


parcelRegister("6TpLk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9DMQ7 = parcelRequire("9DMQ7");

var $2AgrJ = parcelRequire("2AgrJ");
var $504bdd054794f238$var$getLevels = function(url) {
    var host = $2AgrJ.parse(url).hostname;
    var parts = host.split('.');
    var last = parts[parts.length - 1];
    var levels = [];
    if (parts.length === 4 && !isNaN(parseInt(last, 10))) return levels;
    if (parts.length <= 1) return levels;
    for(var i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join('.'));
    return levels;
};
module.exports.domain = function(url) {
    var domainLevels = $504bdd054794f238$var$getLevels(url);
    for(var _i = 0, domainLevels_1 = domainLevels; _i < domainLevels_1.length; _i++){
        var domainLevel = domainLevels_1[_i];
        var cname = '__tld__';
        var opts = {
            domain: '.' + domainLevel
        };
        $9DMQ7.setCookie(cname, 1, opts);
        if ($9DMQ7.getCookie(cname)) {
            $9DMQ7.setCookie(cname, null, opts);
            return domainLevel;
        }
    }
    return '';
};
module.exports.inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
module.exports.isAtlassianComDomain = function() {
    return /atlassian\.com$/.test(window.location.hostname);
};

});
parcelRegister("2AgrJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = function(url) {
    var a = document.createElement('a');
    a.href = url;
    return {
        href: a.href,
        host: a.host || location.host,
        port: '0' === a.port || '' === a.port ? module.exports.port(a.protocol) : a.port,
        hash: a.hash,
        hostname: a.hostname || location.hostname,
        pathname: a.pathname.charAt(0) !== '/' ? '/' + a.pathname : a.pathname,
        protocol: !a.protocol || ':' === a.protocol ? location.protocol : a.protocol,
        search: a.search,
        query: a.search.slice(1)
    };
};
module.exports.isAbsolute = function(url) {
    return 0 === url.indexOf('//') || !!~url.indexOf('://');
};
module.exports.isRelative = function(url) {
    return !module.exports.isAbsolute(url);
};
module.exports.isCrossDomain = function(url) {
    var finalUrl = module.exports.parse(url);
    var location1 = module.exports.parse(window.location.href);
    return finalUrl.hostname !== location1.hostname || finalUrl.port !== location1.port || finalUrl.protocol !== location1.protocol;
};
module.exports.port = function(protocol) {
    switch(protocol){
        case 'http:':
            return 80;
        case 'https:':
            return 443;
        default:
            return location.port;
    }
};
module.exports.getParam = function(name) {
    var b = window.location.href.match('[?&]' + name + '=([^&#]+)');
    return b ? b.pop() : '';
};

});


parcelRegister("4WQkp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uuidv4 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(char) {
        var random = Math.random() * 16 | 0;
        var uuid = char === 'x' ? random : random & 0x3 | 0x8;
        return uuid.toString(16);
    });
};

});


parcelRegister("1tpFw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3IQL = parcelRequire("d3IQL");

var $ahqVC = parcelRequire("ahqVC");

var $csx3e = parcelRequire("csx3e");

var $fN1qj = parcelRequire("fN1qj");

var $k5U2N = parcelRequire("k5U2N");

var $3D1le = parcelRequire("3D1le");

var $2H71x = parcelRequire("2H71x");

var $dpus0 = parcelRequire("dpus0");
var $112c6922e327cbb5$var$UIDGenerator = function() {
    function UIDGenerator() {}
    UIDGenerator.getDetails = function() {
        try {
            return {
                browser: {
                    browserDefaultEvalLength: $ahqVC.browserDefaultEvalLength(),
                    canWriteCookie: $ahqVC.canWriteCookie(),
                    getBrowserVendor: $ahqVC.getBrowserVendor(),
                    getHardwareConcurrency: $ahqVC.getHardwareConcurrency(),
                    getLanguage: $ahqVC.getLanguage(),
                    getPlatform: $ahqVC.getPlatform(),
                    getPlugins: $ahqVC.getPlugins(),
                    getProductSub: $ahqVC.getProductSub(),
                    getTimeZone: $ahqVC.getTimeZone(),
                    getTimeZoneOffset: $ahqVC.getTimeZoneOffset(),
                    getUserAgent: $ahqVC.getUserAgent(),
                    isIndexedDBAvailable: $ahqVC.isIndexedDBAvailable(),
                    isLocalStorageAvailable: $ahqVC.isLocalStorageAvailable(),
                    isSessionStorageAvailable: $ahqVC.isSessionStorageAvailable(),
                    isTestingBot: $ahqVC.isTestingBot(),
                    isWebDriver: $ahqVC.isWebDriver()
                },
                canvas: {
                    studyPrint: $csx3e.studyPrint()
                },
                font: {
                    jsFonts: new $k5U2N.DetectFonts().detect()
                },
                webGL: {
                    getWebGL: $3D1le.getWebGL()
                }
            };
        } catch (err) {
            return $fN1qj.ERROR;
        }
    };
    UIDGenerator.getValue = function(cachedUids) {
        try {
            var values = [
                $ahqVC.browserDefaultEvalLength(),
                $ahqVC.canWriteCookie(),
                $ahqVC.getBrowserVendor(),
                $ahqVC.getHardwareConcurrency(),
                $ahqVC.getLanguage(),
                $ahqVC.getPlatform(),
                $ahqVC.getPlugins(),
                $ahqVC.getProductSub(),
                $ahqVC.getTimeZone(),
                $ahqVC.getTimeZoneOffset(),
                $ahqVC.getUserAgent(),
                $ahqVC.isIndexedDBAvailable(),
                $ahqVC.isLocalStorageAvailable(),
                $ahqVC.isSessionStorageAvailable(),
                $ahqVC.isTestingBot(),
                $ahqVC.isWebDriver(),
                $csx3e.studyPrint(),
                new $k5U2N.DetectFonts().result(),
                $3D1le.getWebGL()
            ];
            var value = $dpus0.x64hash128(values.join("|"), 64);
            var state = void 0;
            if (!cachedUids.length) state = $2H71x.XIDState.NEW;
            else if (cachedUids[0].value === value) state = $2H71x.XIDState.EXISTING;
            else state = $2H71x.XIDState.CHANGED;
            return state === $2H71x.XIDState.EXISTING ? cachedUids : $d3IQL.__spreadArrays([
                {
                    type: $2H71x.XIDItemType.UID,
                    createdAt: new Date().toISOString(),
                    state: state,
                    value: value
                }
            ], cachedUids);
        } catch (err) {
            return [
                {
                    type: $2H71x.XIDItemType.UID,
                    state: $2H71x.XIDState.ERROR
                }
            ];
        }
    };
    return UIDGenerator;
}();
module.exports.UIDGenerator = $112c6922e327cbb5$var$UIDGenerator;

});
parcelRegister("ahqVC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fV5mI = parcelRequire("fV5mI");
module.exports.browserDefaultEvalLength = $fV5mI.browserDefaultEvalLength;

var $bqpSC = parcelRequire("bqpSC");
module.exports.canWriteCookie = $bqpSC.canWriteCookie;

var $4HXUy = parcelRequire("4HXUy");
module.exports.getBrowserVendor = $4HXUy.getBrowserVendor;

var $70ABb = parcelRequire("70ABb");
module.exports.getHardwareConcurrency = $70ABb.getHardwareConcurrency;

var $eJa3Y = parcelRequire("eJa3Y");
module.exports.getLanguage = $eJa3Y.getLanguage;

var $bgHHi = parcelRequire("bgHHi");
module.exports.getPlatform = $bgHHi.getPlatform;

var $gbFlY = parcelRequire("gbFlY");
module.exports.getPlugins = $gbFlY.getPlugins;

var $jc1Nl = parcelRequire("jc1Nl");
module.exports.getProductSub = $jc1Nl.getProductSub;

var $ldfKJ = parcelRequire("ldfKJ");
module.exports.getTimeZone = $ldfKJ.getTimeZone;

var $aEUsn = parcelRequire("aEUsn");
module.exports.getTimeZoneOffset = $aEUsn.getTimeZoneOffset;

var $kvz08 = parcelRequire("kvz08");
module.exports.getUserAgent = $kvz08.getUserAgent;

var $jtdJi = parcelRequire("jtdJi");
module.exports.isIndexedDBAvailable = $jtdJi.isIndexedDBAvailable;

var $24Vwa = parcelRequire("24Vwa");
module.exports.isLocalStorageAvailable = $24Vwa.isLocalStorageAvailable;

var $iEfug = parcelRequire("iEfug");
module.exports.isSessionStorageAvailable = $iEfug.isSessionStorageAvailable;

var $bKkjZ = parcelRequire("bKkjZ");
module.exports.isTestingBot = $bKkjZ.isTestingBot;

var $6hPqZ = parcelRequire("6hPqZ");
module.exports.isWebDriver = $6hPqZ.isWebDriver;

});
parcelRegister("fV5mI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $b9705751046fcde8$var$browserDefaultEvalLength() {
    try {
        return eval.toString().length || 0;
    } catch (err) {
        return $fN1qj.ERROR;
    }
}
module.exports.browserDefaultEvalLength = $b9705751046fcde8$var$browserDefaultEvalLength;

});
parcelRegister("fN1qj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UNAVAILABLE = "UNAVAILABLE";
module.exports.ERROR = "ERROR";
module.exports.YES = "YES";
module.exports.NO = "NO";

});


parcelRegister("bqpSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $851632a51121ccf9$var$canWriteCookie() {
    try {
        document.cookie = "cookietest=1";
        if (document.cookie.indexOf("cookietest=") !== -1) {
            document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
            return $fN1qj.YES;
        }
        return $fN1qj.NO;
    } catch (t) {
        return $fN1qj.ERROR;
    }
}
module.exports.canWriteCookie = $851632a51121ccf9$var$canWriteCookie;

});

parcelRegister("4HXUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $36d9a6b6021a8dd7$var$getBrowserVendor() {
    try {
        return navigator.vendor || $fN1qj.UNAVAILABLE;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.getBrowserVendor = $36d9a6b6021a8dd7$var$getBrowserVendor;

});

parcelRegister("70ABb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $51a4ec37fff91ba5$var$getHardwareConcurrency() {
    try {
        var result = parseInt(navigator.hardwareConcurrency.toString(), 10);
        return isNaN(result) ? 1 : result;
    } catch (t) {
        return 1;
    }
}
module.exports.getHardwareConcurrency = $51a4ec37fff91ba5$var$getHardwareConcurrency;

});

parcelRegister("eJa3Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $ab8d12fee28e9591$var$getLanguage() {
    try {
        return navigator.language || $fN1qj.UNAVAILABLE;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.getLanguage = $ab8d12fee28e9591$var$getLanguage;

});

parcelRegister("bgHHi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $834315b1836e45ce$var$getPlatform() {
    try {
        return navigator.platform || $fN1qj.UNAVAILABLE;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.getPlatform = $834315b1836e45ce$var$getPlatform;

});

parcelRegister("gbFlY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $bc8dc053252a5c51$var$getPlugins() {
    try {
        var MSIE = "Microsoft Internet Explorer";
        var NETSCAPE = "Netscape";
        var isIE = navigator.appName === MSIE;
        var isNetscape = navigator.appName === NETSCAPE;
        var isTrident = /Trident/.test(navigator.userAgent);
        if (isIE || isNetscape && isTrident) return $fN1qj.UNAVAILABLE;
        var navigatorPlugins = navigator.plugins;
        var s = "";
        for(var i = 0; i < navigatorPlugins.length; i++){
            var plugin = navigator.plugins[i];
            var name_1 = plugin.name;
            var fileName = plugin.filename;
            var pluginMimeTypes = plugin.length;
            for(var j = 0; j < pluginMimeTypes; j++){
                var o = plugin[j];
                if (o) s = s + name_1 + "," + fileName + "," + o.type + "|";
            }
        }
        return s;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.getPlugins = $bc8dc053252a5c51$var$getPlugins;

});

parcelRegister("jc1Nl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $df9087c2ccb52701$var$getProductSub() {
    try {
        return navigator.productSub || $fN1qj.UNAVAILABLE;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.getProductSub = $df9087c2ccb52701$var$getProductSub;

});

parcelRegister("ldfKJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $f717080a416ded30$var$getTimeZone() {
    try {
        if (window.Intl && window.Intl.DateTimeFormat) return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $fN1qj.UNAVAILABLE;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.getTimeZone = $f717080a416ded30$var$getTimeZone;

});

parcelRegister("aEUsn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $7c296eeefb840d9f$var$getTimeZoneOffset() {
    try {
        return new Date().getTimezoneOffset() || $fN1qj.UNAVAILABLE;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.getTimeZoneOffset = $7c296eeefb840d9f$var$getTimeZoneOffset;

});

parcelRegister("kvz08", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $eee1da621bf59c5f$var$getUserAgent() {
    try {
        return navigator.userAgent || $fN1qj.UNAVAILABLE;
    } catch (d) {
        return $fN1qj.ERROR;
    }
}
module.exports.getUserAgent = $eee1da621bf59c5f$var$getUserAgent;

});

parcelRegister("jtdJi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $e2cb6026066abe22$var$isIndexedDBAvailable() {
    try {
        return window.indexedDB ? $fN1qj.YES : $fN1qj.NO;
    } catch (e) {
        return $fN1qj.ERROR;
    }
}
module.exports.isIndexedDBAvailable = $e2cb6026066abe22$var$isIndexedDBAvailable;

});

parcelRegister("24Vwa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $183892590974fb44$var$isLocalStorageAvailable() {
    try {
        return window.localStorage ? $fN1qj.YES : $fN1qj.NO;
    } catch (e) {
        return $fN1qj.ERROR;
    }
}
module.exports.isLocalStorageAvailable = $183892590974fb44$var$isLocalStorageAvailable;

});

parcelRegister("iEfug", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $d937f9d59f5e7c20$var$isSessionStorageAvailable() {
    try {
        return window.sessionStorage ? $fN1qj.YES : $fN1qj.NO;
    } catch (e) {
        return $fN1qj.ERROR;
    }
}
module.exports.isSessionStorageAvailable = $d937f9d59f5e7c20$var$isSessionStorageAvailable;

});

parcelRegister("bKkjZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $88d3c0fb1e29462c$var$isTestingBot() {
    try {
        var t = [
            "webdriver" in window,
            "_Selenium_IDE_Recorder" in window,
            "callSelenium" in window,
            "_selenium" in window,
            "__webdriver_script_fn" in document,
            "__driver_evaluate" in document,
            "__webdriver_evaluate" in document,
            "__selenium_evaluate" in document,
            "__fxdriver_evaluate" in document,
            "__driver_unwrapped" in document,
            "__webdriver_unwrapped" in document,
            "__selenium_unwrapped" in document,
            "__fxdriver_unwrapped" in document,
            "__webdriver_script_func" in document,
            null !== document.documentElement.getAttribute("selenium"),
            null !== document.documentElement.getAttribute("webdriver"),
            null !== document.documentElement.getAttribute("driver")
        ];
        return t.some(function(e) {
            return e === true;
        }) ? $fN1qj.YES : $fN1qj.NO;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.isTestingBot = $88d3c0fb1e29462c$var$isTestingBot;

});

parcelRegister("6hPqZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $493c3a61afd0a30b$var$isWebDriver() {
    try {
        return navigator.webdriver ? $fN1qj.YES : $fN1qj.NO;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.isWebDriver = $493c3a61afd0a30b$var$isWebDriver;

});


parcelRegister("csx3e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bxPoT = parcelRequire("bxPoT");
module.exports.studyPrint = $bxPoT.studyPrint;

});
parcelRegister("bxPoT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $867aa5d207fb439a$var$studyPrint() {
    try {
        var canvasElement = document.createElement("canvas");
        canvasElement.width = 240;
        canvasElement.height = 140;
        canvasElement.style.display = "inline";
        var canvasContext = canvasElement.getContext("2d");
        if (canvasContext) {
            canvasContext.rect(0, 0, 10, 10);
            canvasContext.rect(2, 2, 6, 6);
            canvasContext.isPointInPath(5, 5, "evenodd");
            canvasContext.textBaseline = "alphabetic";
            canvasContext.fillStyle = "#f60";
            canvasContext.fillRect(125, 1, 62, 20);
            canvasContext.fillStyle = "#069";
            canvasContext.font = "11pt no-real-font-123";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 2, 15);
            canvasContext.fillStyle = "rgba(102, 204, 0, 0.2)";
            canvasContext.font = "18pt Arial";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 4, 45);
            canvasContext.globalCompositeOperation = "multiply";
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.beginPath();
            canvasContext.arc(50, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(0,255,255)";
            canvasContext.beginPath();
            canvasContext.arc(100, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,255,0)";
            canvasContext.beginPath();
            canvasContext.arc(75, 100, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.arc(75, 75, 75, 0, 2 * Math.PI, !0);
            canvasContext.arc(75, 75, 25, 0, 2 * Math.PI, !0);
            canvasContext.fill("evenodd");
            return canvasElement.toDataURL();
        }
        return $fN1qj.UNAVAILABLE;
    } catch (error) {
        return $fN1qj.ERROR;
    }
}
module.exports.studyPrint = $867aa5d207fb439a$var$studyPrint;

});


parcelRegister("k5U2N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kNsnO = parcelRequire("kNsnO");
module.exports.DetectFonts = $kNsnO.DetectFonts;

});
parcelRegister("kNsnO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");

var $jGPmm = parcelRequire("jGPmm");
var $f23e6683c8fc0ccc$var$DetectFonts = function() {
    function DetectFonts() {
        var _this = this;
        this.baseFonts = [
            'monospace',
            'sans-serif',
            'serif'
        ];
        this.testString = 'mmmmmmmmmmlli';
        this.testSize = '72px';
        this.defaultWidth = {};
        this.defaultHeight = {};
        this.createSpan = function() {
            var s = document.createElement('span');
            s.style.position = 'absolute';
            s.style.left = '-9999px';
            s.style.fontSize = _this.testSize;
            s.style.fontStyle = 'normal';
            s.style.fontWeight = 'normal';
            s.style.letterSpacing = 'normal';
            s.style.lineBreak = 'auto';
            s.style.lineHeight = 'normal';
            s.style.textTransform = 'none';
            s.style.textAlign = 'left';
            s.style.textDecoration = 'none';
            s.style.textShadow = 'none';
            s.style.whiteSpace = 'normal';
            s.style.wordBreak = 'normal';
            s.style.wordSpacing = 'normal';
            s.innerHTML = _this.testString;
            return s;
        };
        this.createSpanWithFonts = function(fontToDetect, baseFont) {
            var s = _this.createSpan();
            s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
            return s;
        };
        this.initializeBaseFontsSpans = function() {
            var spans = [];
            for(var _i = 0, _a = _this.baseFonts; _i < _a.length; _i++){
                var font = _a[_i];
                var s = _this.createSpan();
                s.style.fontFamily = font;
                _this.baseFontsDiv.appendChild(s);
                spans.push(s);
            }
            return spans;
        };
        this.initializeFontsSpans = function() {
            var spans = {};
            for(var _i = 0, fontsToCheck_2 = $jGPmm.fontsToCheck; _i < fontsToCheck_2.length; _i++){
                var fontToDetect = fontsToCheck_2[_i];
                var fontSpans = [];
                for(var _a = 0, _b = _this.baseFonts; _a < _b.length; _a++){
                    var baseFont = _b[_a];
                    var s = _this.createSpanWithFonts(fontToDetect, baseFont);
                    _this.fontsDiv.appendChild(s);
                    fontSpans.push(s);
                }
                var key = fontToDetect;
                spans[key] = fontSpans;
            }
            return spans;
        };
        this.isFontAvailable = function(fontSpans) {
            var detected = false;
            for(var i = 0; i < _this.baseFonts.length; i++){
                var fontWidth = fontSpans[i].offsetWidth;
                var fontDefaultWidth = _this.defaultWidth[_this.baseFonts[i]];
                var fontHeight = fontSpans[i].offsetHeight;
                var fontDefaultHeight = _this.defaultHeight[_this.baseFonts[i]];
                detected = fontWidth !== fontDefaultWidth || fontHeight !== fontDefaultHeight;
                if (detected) return detected;
            }
            return detected;
        };
        this.bodyElement = document.getElementsByTagName('body')[0];
        this.baseFontsDiv = document.createElement('div');
        this.fontsDiv = document.createElement('div');
    }
    DetectFonts.prototype.detect = function() {
        var baseFontsSpans = this.initializeBaseFontsSpans();
        this.bodyElement.appendChild(this.baseFontsDiv);
        for(var index = 0; index < this.baseFonts.length; index++){
            this.defaultWidth[this.baseFonts[index]] = baseFontsSpans[index].offsetWidth;
            this.defaultHeight[this.baseFonts[index]] = baseFontsSpans[index].offsetHeight;
        }
        var fontsSpans = this.initializeFontsSpans();
        this.bodyElement.appendChild(this.fontsDiv);
        var available = [];
        for(var _i = 0, fontsToCheck_3 = $jGPmm.fontsToCheck; _i < fontsToCheck_3.length; _i++){
            var fontToCheck = fontsToCheck_3[_i];
            var result = 0;
            if (this.isFontAvailable(fontsSpans[fontToCheck])) result = 1;
            available.push(result);
        }
        this.bodyElement.removeChild(this.fontsDiv);
        this.bodyElement.removeChild(this.baseFontsDiv);
        return available.join("|");
    };
    DetectFonts.prototype.result = function() {
        try {
            return this.detect();
        } catch (error) {
            return $fN1qj.ERROR;
        }
    };
    return DetectFonts;
}();
module.exports.DetectFonts = $f23e6683c8fc0ccc$var$DetectFonts;

});
parcelRegister("jGPmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fontsToCheck = [
    "Adobe Garamond",
    "Adobe Hebrew",
    "Agency FB",
    "Airstream",
    "Andale Mono",
    "Aparajita",
    "Arial",
    "BN Manson Nights",
    "Baskerville",
    "BlackChancery",
    "Book Antiqua",
    "Bookman Old Style",
    "CG Times",
    "Calibri",
    "Cambria",
    "Cambria Math",
    "Century",
    "Century Gothic",
    "Century Schoolbook",
    "Chalkboard",
    "Comic Sans",
    "Comic Sans MS",
    "Consolas",
    "Cooper Black",
    "Corbel",
    "Courier",
    "Courier New",
    "Curlz MT",
    "DS Sans Serif",
    "Degrassi",
    "Didot",
    "Ebrima",
    "GOST Common",
    "Geneva",
    "Georgia",
    "Gulim",
    "Heiti TC",
    "Helvetica",
    "Helvetica Neue",
    "Hoefler Text",
    "Impact",
    "Kalinga",
    "Letter Gothic",
    "Lithos Pro",
    "Lucida Bright",
    "Lucida Calligraphy",
    "Lucida Console",
    "Lucida Fax",
    "Lucida Handwriting",
    "Lucida Sans",
    "MS Gothic",
    "MS Outlook",
    "MS PGothic",
    "MYRIAD",
    "Malgun Gothic",
    "Mangal",
    "MapInfo Miscellaneous",
    "Meiryo UI",
    "Monaco",
    "Monotype Corsiva",
    "NSimSun",
    "OSAKA",
    "Palatino",
    "Pickwick",
    "Playbill",
    "Pristina",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Shonar Bangla",
    "Snell Roundhand",
    "Styllo",
    "Tahoma",
    "Times",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
    "Wingdings"
];

});



parcelRegister("3D1le", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l6dIo = parcelRequire("l6dIo");
module.exports.getWebGL = $l6dIo.getWebGL;

});
parcelRegister("l6dIo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");

var $1kvgn = parcelRequire("1kvgn");
function $f5c4cc013ba9db32$var$getWebGL() {
    try {
        var gl = $1kvgn.getContext();
        if (typeof gl === "undefined") return $fN1qj.UNAVAILABLE;
        if (gl && typeof gl === "object" && gl.context) {
            var glContext = gl.context;
            var rendererInfo = glContext.getExtension("WEBGL_debug_renderer_info");
            if (rendererInfo !== null) return [
                glContext.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL),
                glContext.getParameter(glContext.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
                glContext.getParameter(glContext.MAX_CUBE_MAP_TEXTURE_SIZE)
            ].join("|");
            return $fN1qj.UNAVAILABLE;
        }
    } catch (p) {
        return $fN1qj.ERROR;
    }
}
module.exports.getWebGL = $f5c4cc013ba9db32$var$getWebGL;

});
parcelRegister("1kvgn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fN1qj = parcelRequire("fN1qj");
function $0f7fe8e8551b3138$var$getContext() {
    if (window.WebGLRenderingContext) {
        var canvasElement = document.createElement("canvas");
        var webGLcontexts = [
            "webgl",
            "experimental-webgl",
            "moz-webgl",
            "webkit-3d"
        ];
        for(var _i = 0, webGLcontexts_1 = webGLcontexts; _i < webGLcontexts_1.length; _i++){
            var contextName = webGLcontexts_1[_i];
            try {
                var canvasRenderingContext = canvasElement.getContext(contextName);
                if (canvasRenderingContext && canvasRenderingContext instanceof WebGLRenderingContext && typeof canvasRenderingContext.getParameter === "function") return {
                    name: contextName,
                    context: canvasRenderingContext
                };
            } catch (p) {
                return $fN1qj.ERROR;
            }
        }
    }
    return $fN1qj.UNAVAILABLE;
}
module.exports.getContext = $0f7fe8e8551b3138$var$getContext;

});



parcelRegister("dpus0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9c353b0904374d67$var$x64Add = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] + n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] + n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] + n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] + n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $9c353b0904374d67$var$x64Multiply = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] * n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] * n[3];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[2] += m[3] * n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] * n[3];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[2] * n[2];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[3] * n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $9c353b0904374d67$var$x64Rotl = function(m, n) {
    n %= 64;
    if (n === 32) return [
        m[1],
        m[0]
    ];
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n | m[0] >>> 32 - n
    ];
    else {
        n -= 32;
        return [
            m[1] << n | m[0] >>> 32 - n,
            m[0] << n | m[1] >>> 32 - n
        ];
    }
};
var $9c353b0904374d67$var$x64LeftShift = function(m, n) {
    n %= 64;
    if (n === 0) return m;
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n
    ];
    else return [
        m[1] << n - 32,
        0
    ];
};
var $9c353b0904374d67$var$x64Xor = function(m, n) {
    return [
        m[0] ^ n[0],
        m[1] ^ n[1]
    ];
};
var $9c353b0904374d67$var$x64Fmix = function(h) {
    h = $9c353b0904374d67$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $9c353b0904374d67$var$x64Multiply(h, [
        0xff51afd7,
        0xed558ccd
    ]);
    h = $9c353b0904374d67$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $9c353b0904374d67$var$x64Multiply(h, [
        0xc4ceb9fe,
        0x1a85ec53
    ]);
    h = $9c353b0904374d67$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    return h;
};
module.exports.x64hash128 = function(key, seed) {
    key = key || '';
    seed = seed || 0;
    var remainder = key.length % 16;
    var bytes = key.length - remainder;
    var h1 = [
        0,
        seed
    ];
    var h2 = [
        0,
        seed
    ];
    var k1 = [
        0,
        0
    ];
    var k2 = [
        0,
        0
    ];
    var c1 = [
        0x87c37b91,
        0x114253d5
    ];
    var c2 = [
        0x4cf5ad43,
        0x2745937f
    ];
    for(var i = 0; i < bytes; i = i + 16){
        k1 = [
            key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24,
            key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24
        ];
        k2 = [
            key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24,
            key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24
        ];
        k1 = $9c353b0904374d67$var$x64Multiply(k1, c1);
        k1 = $9c353b0904374d67$var$x64Rotl(k1, 31);
        k1 = $9c353b0904374d67$var$x64Multiply(k1, c2);
        h1 = $9c353b0904374d67$var$x64Xor(h1, k1);
        h1 = $9c353b0904374d67$var$x64Rotl(h1, 27);
        h1 = $9c353b0904374d67$var$x64Add(h1, h2);
        h1 = $9c353b0904374d67$var$x64Add($9c353b0904374d67$var$x64Multiply(h1, [
            0,
            5
        ]), [
            0,
            0x52dce729
        ]);
        k2 = $9c353b0904374d67$var$x64Multiply(k2, c2);
        k2 = $9c353b0904374d67$var$x64Rotl(k2, 33);
        k2 = $9c353b0904374d67$var$x64Multiply(k2, c1);
        h2 = $9c353b0904374d67$var$x64Xor(h2, k2);
        h2 = $9c353b0904374d67$var$x64Rotl(h2, 31);
        h2 = $9c353b0904374d67$var$x64Add(h2, h1);
        h2 = $9c353b0904374d67$var$x64Add($9c353b0904374d67$var$x64Multiply(h2, [
            0,
            5
        ]), [
            0,
            0x38495ab5
        ]);
    }
    k1 = [
        0,
        0
    ];
    k2 = [
        0,
        0
    ];
    var iX = bytes;
    switch(remainder){
        case 15:
            k2 = $9c353b0904374d67$var$x64Xor(k2, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 14)
            ], 48));
        case 14:
            k2 = $9c353b0904374d67$var$x64Xor(k2, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 13)
            ], 40));
        case 13:
            k2 = $9c353b0904374d67$var$x64Xor(k2, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 12)
            ], 32));
        case 12:
            k2 = $9c353b0904374d67$var$x64Xor(k2, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 11)
            ], 24));
        case 11:
            k2 = $9c353b0904374d67$var$x64Xor(k2, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 10)
            ], 16));
        case 10:
            k2 = $9c353b0904374d67$var$x64Xor(k2, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 9)
            ], 8));
        case 9:
            k2 = $9c353b0904374d67$var$x64Xor(k2, [
                0,
                key.charCodeAt(iX + 8)
            ]);
            k2 = $9c353b0904374d67$var$x64Multiply(k2, c2);
            k2 = $9c353b0904374d67$var$x64Rotl(k2, 33);
            k2 = $9c353b0904374d67$var$x64Multiply(k2, c1);
            h2 = $9c353b0904374d67$var$x64Xor(h2, k2);
        case 8:
            k1 = $9c353b0904374d67$var$x64Xor(k1, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 7)
            ], 56));
        case 7:
            k1 = $9c353b0904374d67$var$x64Xor(k1, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 6)
            ], 48));
        case 6:
            k1 = $9c353b0904374d67$var$x64Xor(k1, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 5)
            ], 40));
        case 5:
            k1 = $9c353b0904374d67$var$x64Xor(k1, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 4)
            ], 32));
        case 4:
            k1 = $9c353b0904374d67$var$x64Xor(k1, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 3)
            ], 24));
        case 3:
            k1 = $9c353b0904374d67$var$x64Xor(k1, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 2)
            ], 16));
        case 2:
            k1 = $9c353b0904374d67$var$x64Xor(k1, $9c353b0904374d67$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 1)
            ], 8));
        case 1:
            k1 = $9c353b0904374d67$var$x64Xor(k1, [
                0,
                key.charCodeAt(iX)
            ]);
            k1 = $9c353b0904374d67$var$x64Multiply(k1, c1);
            k1 = $9c353b0904374d67$var$x64Rotl(k1, 31);
            k1 = $9c353b0904374d67$var$x64Multiply(k1, c2);
            h1 = $9c353b0904374d67$var$x64Xor(h1, k1);
    }
    h1 = $9c353b0904374d67$var$x64Xor(h1, [
        0,
        key.length
    ]);
    h2 = $9c353b0904374d67$var$x64Xor(h2, [
        0,
        key.length
    ]);
    h1 = $9c353b0904374d67$var$x64Add(h1, h2);
    h2 = $9c353b0904374d67$var$x64Add(h2, h1);
    h1 = $9c353b0904374d67$var$x64Fmix(h1);
    h2 = $9c353b0904374d67$var$x64Fmix(h2);
    h1 = $9c353b0904374d67$var$x64Add(h1, h2);
    h2 = $9c353b0904374d67$var$x64Add(h2, h1);
    return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8);
};

});


parcelRegister("1NXMv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d3IQL = parcelRequire("d3IQL");

var $1508bd64aadd6490$var$promise_polyfill_1 = $d3IQL.__importDefault((parcelRequire("i2O2X")));

var $6TpLk = parcelRequire("6TpLk");

var $k1N3S = parcelRequire("k1N3S");

var $2H71x = parcelRequire("2H71x");
var $1508bd64aadd6490$var$TEST_HOST = '';
var $1508bd64aadd6490$var$DEV_HOST = 'xxid.dev.atl-paas.net';
var $1508bd64aadd6490$var$STG_HOST = 'xxid.staging.atl-paas.net';
var $1508bd64aadd6490$var$PROD_FALLBACK_HOST = 'xxid.atl-paas.net';
var $1508bd64aadd6490$var$PROD_HOST = 'xxid.atlassian.com';
var $1508bd64aadd6490$var$defaultTimeout = 3000;
var $1508bd64aadd6490$var$XCGenerator = function() {
    function XCGenerator() {}
    XCGenerator.getValue = function(env, timeout, isStorageEnabled) {
        if (timeout === void 0) timeout = $1508bd64aadd6490$var$defaultTimeout;
        if (isStorageEnabled === void 0) isStorageEnabled = true;
        var xxidHost = XCGenerator.getHost(env);
        var xxidOrigin = xxidHost ? "https://" + xxidHost : '';
        var iframeUrl = xxidOrigin ? xxidOrigin + "?t=" + new Date().getTime() : '';
        var frame = XCGenerator.addFrame(iframeUrl);
        return new $1508bd64aadd6490$var$promise_polyfill_1.default(function(resolve) {
            var listen = function(event) {
                if (event.data.type === "xcReady" && event.origin === xxidOrigin) {
                    var xc = XCGenerator.messageToXc(event);
                    if (isStorageEnabled) xc = $k1N3S.Storage.updateXc(env, xc);
                    resolve(xc);
                    XCGenerator.removeFrame(frame, listen);
                }
            };
            window.addEventListener('message', listen);
            setTimeout(function() {
                resolve({
                    type: $2H71x.XIDItemType.XC,
                    state: $2H71x.XIDState.TIMEOUT
                });
                XCGenerator.removeFrame(frame, listen);
            }, timeout);
        });
    };
    XCGenerator.messageToXc = function(event) {
        var _a = event.data, xc = _a.xc, ts = _a.ts, state = _a.state;
        if (xc && !!Date.parse(ts) && state) return {
            type: $2H71x.XIDItemType.XC,
            value: xc,
            createdAt: ts,
            state: state
        };
        else return {
            type: $2H71x.XIDItemType.XC,
            state: state ? state : $2H71x.XIDState.MALFORMED
        };
    };
    XCGenerator.addFrame = function(url) {
        var frame = document.createElement('iframe');
        frame.id = "xc-" + new Date().getTime();
        frame.src = url;
        frame.style.display = 'none';
        frame.style.position = 'fixed';
        document.body.appendChild(frame);
        return frame;
    };
    XCGenerator.removeFrame = function(frame, listen) {
        if (document.body.contains(frame)) {
            document.body.removeChild(frame);
            window.removeEventListener('message', listen);
        }
    };
    XCGenerator.getHost = function(env) {
        switch(env){
            case $2H71x.Environment.STAGE:
                return $1508bd64aadd6490$var$STG_HOST;
            case $2H71x.Environment.PROD:
                return $6TpLk.isAtlassianComDomain() ? $1508bd64aadd6490$var$PROD_FALLBACK_HOST : $1508bd64aadd6490$var$PROD_HOST;
            case $2H71x.Environment.TEST:
                return $1508bd64aadd6490$var$TEST_HOST;
            case $2H71x.Environment.LOCAL:
            case $2H71x.Environment.DEV:
            default:
                return $1508bd64aadd6490$var$DEV_HOST;
        }
    };
    return XCGenerator;
}();
module.exports.XCGenerator = $1508bd64aadd6490$var$XCGenerator;

});

parcelRegister("c7F1s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bG2z2 = parcelRequire("bG2z2");
var $8d35f5ad8426acf6$var$maptoNewXidCandidate = function(item, promiseStartTime) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && (state === $bG2z2.XIDState.NEW || state === $bG2z2.XIDState.CHANGED)) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt,
        timeTaken: $8d35f5ad8426acf6$var$getCurrentTime() - promiseStartTime
    };
    return null;
};
var $8d35f5ad8426acf6$var$maptoExistingXid = function(item) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && state === $bG2z2.XIDState.EXISTING) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt
    };
    return null;
};
var $8d35f5ad8426acf6$var$mapToAmbiguousXid = function(item) {
    var state = item.state, type = item.type;
    if (item && state && type) switch(state){
        case $bG2z2.XIDState.TIMEOUT:
        case $bG2z2.XIDState.ERROR:
        case $bG2z2.XIDState.UNAVAILABLE:
        case $bG2z2.XIDState.UNKNOWN:
        case $bG2z2.XIDState.MALFORMED:
            return {
                type: type,
                state: state
            };
    }
    return null;
};
var $8d35f5ad8426acf6$var$mapToMalformedXid = function(item) {
    var type = item.type;
    if (item && type) return {
        type: type,
        state: $bG2z2.XIDState.MALFORMED
    };
    return null;
};
function $8d35f5ad8426acf6$var$promiseWithTimer(fn) {
    var addTimeTaken = function(item) {
        var fallbackXid = {
            type: $bG2z2.XIDItemType.UID,
            state: $bG2z2.XIDState.MALFORMED
        };
        return $8d35f5ad8426acf6$var$maptoNewXidCandidate(item, start) || $8d35f5ad8426acf6$var$maptoExistingXid(item) || $8d35f5ad8426acf6$var$mapToAmbiguousXid(item) || $8d35f5ad8426acf6$var$mapToMalformedXid(item) || fallbackXid;
    };
    var onPromiseDone = function(data) {
        return data.map(function(item) {
            return addTimeTaken(item);
        });
    };
    var start = $8d35f5ad8426acf6$var$getCurrentTime();
    return fn().then(onPromiseDone);
}
module.exports.promiseWithTimer = $8d35f5ad8426acf6$var$promiseWithTimer;
var $8d35f5ad8426acf6$var$getCurrentTime = function() {
    if (performance && performance.now) return performance.now();
    return new Date().getTime();
};

});



parcelRegister("aHnuZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7ca025eba80ffcd7$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $cVSvQ = parcelRequire("cVSvQ");

var $wetcE = parcelRequire("wetcE");

var $4rv9G = parcelRequire("4rv9G");

var $4LKl0 = parcelRequire("4LKl0");

var $b1zOW = parcelRequire("b1zOW");

var $amnta = parcelRequire("amnta");

var $6c0mc = parcelRequire("6c0mc");

var $fDpO1 = parcelRequire("fDpO1");

var $hNFBz = parcelRequire("hNFBz");

var $4MN8H = parcelRequire("4MN8H");

var $gZDdI = parcelRequire("gZDdI");

var $eSFJR = parcelRequire("eSFJR");

var $2Zwj7 = parcelRequire("2Zwj7");

var $4z0qw = parcelRequire("4z0qw");

var $hAB65 = parcelRequire("hAB65");

var $jny5S = parcelRequire("jny5S");

var $hRDV8 = parcelRequire("hRDV8");

var $eB8ma = parcelRequire("eB8ma");

var $jERzP = parcelRequire("jERzP");

var $2UmDY = parcelRequire("2UmDY");

var $8yyrG = parcelRequire("8yyrG");

var $EBaXY = parcelRequire("EBaXY");

var $78X8a = parcelRequire("78X8a");

var $e9Kpz = parcelRequire("e9Kpz");

var $dTDvO = parcelRequire("dTDvO");
function $7ca025eba80ffcd7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ca025eba80ffcd7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ca025eba80ffcd7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ca025eba80ffcd7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7ca025eba80ffcd7$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $7ca025eba80ffcd7$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $7ca025eba80ffcd7$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $7ca025eba80ffcd7$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, $hMyHv.default)(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, $hMyHv.default)(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, $hMyHv.default)(this, "_createSubproductGetter", (subproduct)=>(0, $4LKl0.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.'));
        (0, $hMyHv.default)(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $4LKl0.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.'));
        (0, $hMyHv.default)(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($7ca025eba80ffcd7$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (_unused) {
                this._safeSessionStorage.removeItem($7ca025eba80ffcd7$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, $hMyHv.default)(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($7ca025eba80ffcd7$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, $hMyHv.default)(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, $hMyHv.default)(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $wetcE.eventType).UI:
                case (0, $wetcE.eventType).OPERATIONAL:
                case (0, $wetcE.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $wetcE.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $wetcE.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, $hMyHv.default)(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, $hMyHv.default)(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, $hMyHv.default)(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, $hMyHv.default)(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, $hMyHv.default)(this, "clearEmbeddedProduct", ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, $hMyHv.default)(this, "setSubproduct", (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, $hMyHv.default)(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, $hMyHv.default)(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $wetcE.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $wetcE.isType)((0, $wetcE.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $wetcE.objectValues)((0, $wetcE.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, $hMyHv.default)(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, $hMyHv.default)(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, $hMyHv.default)(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, $hMyHv.default)(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, $hMyHv.default)(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, $hMyHv.default)(this, "setUserInfo", (userIdType, userId)=>{
            (0, $hNFBz.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, $hMyHv.default)(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, $hMyHv.default)(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $wetcE.isType)((0, $wetcE.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $wetcE.objectValues)((0, $wetcE.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, $hMyHv.default)(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, $hMyHv.default)(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $wetcE.isType)((0, $wetcE.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $wetcE.objectValues)((0, $wetcE.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, $hMyHv.default)(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, $hMyHv.default)(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, $hMyHv.default)(this, "getCurrentSessionId", ()=>this._sessionTracking.getCurrentSessionId());
        (0, $hMyHv.default)(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = $7ca025eba80ffcd7$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, $hMyHv.default)(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, $hMyHv.default)(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, $hMyHv.default)(this, "appendUIViewedAttributes", (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = $7ca025eba80ffcd7$var$_objectSpread($7ca025eba80ffcd7$var$_objectSpread({}, this._uiViewedAttributes), attributes);
        });
        (0, $hMyHv.default)(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $wetcE.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, $hMyHv.default)(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, $hMyHv.default)(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $hNFBz.validateScreenEvent)(screenName);
            (0, $hNFBz.validateContainers)(screenContainers);
            const builtEvent = (0, $6c0mc.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $7ca025eba80ffcd7$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $e9Kpz.default)(callback, builtEventWithName));
        });
        (0, $hMyHv.default)(this, "sendTrackEvent", (event, callback)=>{
            (0, $hNFBz.validateTrackEvent)(event);
            const builtEvent = (0, $6c0mc.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $wetcE.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $6c0mc.buildActionName)(event), builtEvent, this._context, (0, $e9Kpz.default)(callback, builtEvent));
        });
        (0, $hMyHv.default)(this, "sendUIEvent", (event, callback)=>{
            (0, $hNFBz.validateUIEvent)(event);
            const builtEvent = (0, $6c0mc.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $wetcE.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $6c0mc.buildActionName)(event), builtEvent, this._context, (0, $e9Kpz.default)(callback, builtEvent));
        });
        (0, $hMyHv.default)(this, "sendOperationalEvent", (event, callback)=>{
            (0, $hNFBz.validateOperationalEvent)(event);
            const builtEvent = (0, $6c0mc.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $wetcE.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $6c0mc.buildActionName)(event), builtEvent, this._context, (0, $e9Kpz.default)(callback, builtEvent));
        });
        (0, $hMyHv.default)(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        });
        (0, $hMyHv.default)(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, $hMyHv.default)(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, $hMyHv.default)(this, "signalUserActive", ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        });
        (0, $hMyHv.default)(this, "createUIViewedEvent", (callback)=>{
            return new (0, $2UmDY.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        });
        (0, $hMyHv.default)(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, $hMyHv.default)(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, $hMyHv.default)(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, $hMyHv.default)(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, $hMyHv.default)(this, "stopLowPriorityEventDelay", ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, $hMyHv.default)(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $wetcE.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $wetcE.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $wetcE.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $wetcE.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $wetcE.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $wetcE.objectValues)((0, $wetcE.eventType))}]`);
        });
        (0, $hMyHv.default)(this, "setResponseCallback", (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $wetcE.isType)((0, $wetcE.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $wetcE.objectValues)((0, $wetcE.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $wetcE.originType).WEB;
        else if (!(0, $wetcE.isType)((0, $wetcE.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $wetcE.objectValues)((0, $wetcE.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $wetcE.originType).WEB ? (0, $wetcE.platformType).WEB : (0, $wetcE.platformType).DESKTOP;
        else (0, $hNFBz.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $cVSvQ.isFedrampModerate)()) productInfo.perimeter = (0, $wetcE.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $wetcE.perimeterType).COMMERCIAL;
        if (!(0, $wetcE.isType)((0, $wetcE.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $wetcE.objectValues)((0, $wetcE.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $cVSvQ.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = $7ca025eba80ffcd7$var$_objectSpread($7ca025eba80ffcd7$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $amnta.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $amnta.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $6c0mc.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $jny5S.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $4z0qw.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $dTDvO.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $gZDdI.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $4MN8H.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $7ca025eba80ffcd7$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $2Zwj7.default)();
        this._tabTracking = new (0, $hRDV8.default)();
        this._sessionTracking = new (0, $hAB65.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $eB8ma.default)();
        this._originTracing = new (0, $eSFJR.default)();
        // Init Apdex
        this._apdexEvent = new (0, $4rv9G.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $8yyrG.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $fDpO1.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $jERzP.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $78X8a.default)();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $b1zOW.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $EBaXY.TestSupport).isGeminiVREnvironment() && !(0, $EBaXY.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $EBaXY.TestSupport).isGeminiVREnvironment() && !(0, $EBaXY.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("hMyHv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf21d62e80f736d1$export$2e2bcd8739ae039; });

var $90Na3 = parcelRequire("90Na3");
function $cf21d62e80f736d1$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $90Na3.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("90Na3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $68fa3f88f694c69a$export$2e2bcd8739ae039; });

var $bvF5V = parcelRequire("bvF5V");

var $k96Au = parcelRequire("k96Au");
function $68fa3f88f694c69a$export$2e2bcd8739ae039(t) {
    var i = (0, $k96Au.default)(t, "string");
    return "symbol" == (0, $bvF5V.default)(i) ? i : i + "";
}

});
parcelRegister("bvF5V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8612777c984f31a1$export$2e2bcd8739ae039; });
function $8612777c984f31a1$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8612777c984f31a1$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8612777c984f31a1$export$2e2bcd8739ae039(o);
}

});

parcelRegister("k96Au", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eaa9c20adcdae47c$export$2e2bcd8739ae039; });

var $bvF5V = parcelRequire("bvF5V");
function $eaa9c20adcdae47c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $bvF5V.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $bvF5V.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("cVSvQ", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", function () { return $96a517ff4986d2b5$export$9186ccba8effc5de; });
$parcel$export(module.exports, "isFedrampModerate", function () { return $96a517ff4986d2b5$export$104cb891a6e90b3a; });
$parcel$export(module.exports, "isolatedCloudDomain", function () { return $96a517ff4986d2b5$export$80638ee198476daf; });
$parcel$export(module.exports, "isolationContextId", function () { return $96a517ff4986d2b5$export$839b022803d38d4d; });
$parcel$export(module.exports, "cloudEnvironment", function () { return $96a517ff4986d2b5$export$9e04105551ffc5c4; });

var $oHcM1 = parcelRequire("oHcM1");

var $9GqjT = parcelRequire("9GqjT");
function $96a517ff4986d2b5$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInIC;
    var atlCtxCookieValues = (0, $9GqjT.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $oHcM1.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $96a517ff4986d2b5$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInFedramp;
    var atlCtxCookieValues = (0, $9GqjT.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $oHcM1.FEDRAMP_MODERATE);
}
function $96a517ff4986d2b5$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location.hostname;
    var atlCtxCookieValues = (0, $9GqjT.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $96a517ff4986d2b5$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $96a517ff4986d2b5$export$9186ccba8effc5de() ? globalThis.ssrContext.icName : undefined;
    var atlCtxCookieValues = (0, $9GqjT.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}
function $96a517ff4986d2b5$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $96a517ff4986d2b5$var$cloudEnvironmentSsrLookup();
    return $96a517ff4986d2b5$var$cloudEnvironmentCookieLookup();
}
function $96a517ff4986d2b5$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $oHcM1.COMMERCIAL)
    };
    // @ts-ignore
    if (globalThis.ssrContext.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $oHcM1.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $oHcM1.COMMERCIAL)
    };
}
function $96a517ff4986d2b5$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    var atlCtxCookieValues = (0, $9GqjT.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $oHcM1.COMMERCIAL)
    };
    var isIc = (0, $oHcM1.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $oHcM1.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $oHcM1.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $oHcM1.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

});
parcelRegister("oHcM1", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $04a3c19fc14d83f8$export$ce553301d55c2fd8; });
$parcel$export(module.exports, "COMMERCIAL", function () { return $04a3c19fc14d83f8$export$f005e2e9f707cb5f; });
$parcel$export(module.exports, "STAGING", function () { return $04a3c19fc14d83f8$export$a739cd5aac835909; });
$parcel$export(module.exports, "PRODUCTION", function () { return $04a3c19fc14d83f8$export$42dd0cdd351a4a9; });
$parcel$export(module.exports, "DEV", function () { return $04a3c19fc14d83f8$export$404582bc18fe4d9e; });
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", function () { return $04a3c19fc14d83f8$export$d8347b4aae768c2d; });
$parcel$export(module.exports, "ATL_CTX_PERIMETER", function () { return $04a3c19fc14d83f8$export$87285944378c596; });
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", function () { return $04a3c19fc14d83f8$export$715603e81922c3ec; });
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", function () { return $04a3c19fc14d83f8$export$a0ffa0598c95dfb7; });
var $04a3c19fc14d83f8$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $04a3c19fc14d83f8$export$f005e2e9f707cb5f = 'commercial';
var $04a3c19fc14d83f8$export$a739cd5aac835909 = 'staging';
var $04a3c19fc14d83f8$export$42dd0cdd351a4a9 = 'prod';
var $04a3c19fc14d83f8$export$404582bc18fe4d9e = 'dev';
var $04a3c19fc14d83f8$export$d8347b4aae768c2d = [
    $04a3c19fc14d83f8$export$f005e2e9f707cb5f
];
var $04a3c19fc14d83f8$export$b1b1ccc8f3e7f954 = [
    $04a3c19fc14d83f8$export$f005e2e9f707cb5f,
    $04a3c19fc14d83f8$export$ce553301d55c2fd8
];
var $04a3c19fc14d83f8$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $04a3c19fc14d83f8$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $04a3c19fc14d83f8$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("9GqjT", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", function () { return $70cc73deb2aa55e8$export$3fa7b7af96286cc9; });

var $3En6q = parcelRequire("3En6q");

var $oHcM1 = parcelRequire("oHcM1");
function $70cc73deb2aa55e8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $70cc73deb2aa55e8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $70cc73deb2aa55e8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $70cc73deb2aa55e8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $70cc73deb2aa55e8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $70cc73deb2aa55e8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $70cc73deb2aa55e8$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $70cc73deb2aa55e8$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, $3En6q.default)(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}
function $70cc73deb2aa55e8$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = $70cc73deb2aa55e8$var$getRawCookieValue((0, $oHcM1.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = $70cc73deb2aa55e8$var$getRawCookieValue((0, $oHcM1.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = $70cc73deb2aa55e8$var$getRawCookieValue((0, $oHcM1.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("3En6q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2a87073bb7c06ec9$export$2e2bcd8739ae039; });

var $awFWA = parcelRequire("awFWA");

var $g0cQ6 = parcelRequire("g0cQ6");

var $3xMmM = parcelRequire("3xMmM");

var $jN2wT = parcelRequire("jN2wT");
function $2a87073bb7c06ec9$export$2e2bcd8739ae039(r, e) {
    return (0, $awFWA.default)(r) || (0, $g0cQ6.default)(r, e) || (0, $3xMmM.default)(r, e) || (0, $jN2wT.default)();
}

});
parcelRegister("awFWA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7a9d6dbea921b10a$export$2e2bcd8739ae039; });
function $7a9d6dbea921b10a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("g0cQ6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ba669b15606bd097$export$2e2bcd8739ae039; });
function $ba669b15606bd097$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("3xMmM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2949f8c117ca58fe$export$2e2bcd8739ae039; });

var $3yEJu = parcelRequire("3yEJu");
function $2949f8c117ca58fe$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $3yEJu.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $3yEJu.default)(r, a) : void 0;
    }
}

});
parcelRegister("3yEJu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $297424c061cc0335$export$2e2bcd8739ae039; });
function $297424c061cc0335$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("jN2wT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e6848e404d829d98$export$2e2bcd8739ae039; });
function $e6848e404d829d98$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("wetcE", function(module, exports) {
$parcel$export(module.exports, "envType", function () { return $060e36b797e818f0$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $060e36b797e818f0$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $060e36b797e818f0$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $060e36b797e818f0$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $060e36b797e818f0$export$496f06ac2a964da2; });
$parcel$export(module.exports, "productEmbedType", function () { return $060e36b797e818f0$export$f49776dca27a2e7c; });
$parcel$export(module.exports, "userType", function () { return $060e36b797e818f0$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $060e36b797e818f0$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $060e36b797e818f0$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $060e36b797e818f0$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $060e36b797e818f0$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $060e36b797e818f0$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $060e36b797e818f0$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $060e36b797e818f0$export$bdd41749d2096e4b; });
$parcel$export(module.exports, "aliasType", function () { return $060e36b797e818f0$export$a8c99e46b781d936; });
$parcel$export(module.exports, "groupType", function () { return $060e36b797e818f0$export$e73680b18d9b7c6e; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $060e36b797e818f0$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $060e36b797e818f0$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $060e36b797e818f0$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $060e36b797e818f0$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $060e36b797e818f0$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $060e36b797e818f0$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
let $060e36b797e818f0$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $060e36b797e818f0$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $060e36b797e818f0$export$809831be6c4c6227 = Object.freeze([
    $060e36b797e818f0$export$6b4f396210e539f3.DESKTOP,
    $060e36b797e818f0$export$6b4f396210e539f3.MAC,
    $060e36b797e818f0$export$6b4f396210e539f3.LINUX,
    $060e36b797e818f0$export$6b4f396210e539f3.WINDOWS
]);
const $060e36b797e818f0$export$19c579398ad213e7 = Object.freeze([
    $060e36b797e818f0$export$6b4f396210e539f3.WEB,
    $060e36b797e818f0$export$6b4f396210e539f3.MOBILE_WEB
]);
let $060e36b797e818f0$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $060e36b797e818f0$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $060e36b797e818f0$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $060e36b797e818f0$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $060e36b797e818f0$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $060e36b797e818f0$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $060e36b797e818f0$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("4rv9G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $33c1d9c98facc1fa$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $wetcE = parcelRequire("wetcE");

var $2Zwj7 = parcelRequire("2Zwj7");

var $j7feg = parcelRequire("j7feg");
function $33c1d9c98facc1fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33c1d9c98facc1fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33c1d9c98facc1fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33c1d9c98facc1fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $33c1d9c98facc1fa$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, $hMyHv.default)(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, $hMyHv.default)(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, $hMyHv.default)(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $33c1d9c98facc1fa$var$_objectSpread($33c1d9c98facc1fa$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, $hMyHv.default)(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, $hMyHv.default)(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $wetcE.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, $hMyHv.default)(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, $hMyHv.default)(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, $hMyHv.default)(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $wetcE.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $wetcE.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, $hMyHv.default)(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, $hMyHv.default)(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, $hMyHv.default)(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $wetcE.isType)((0, $wetcE.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $wetcE.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, $hMyHv.default)(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, $hMyHv.default)(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $33c1d9c98facc1fa$var$_objectSpread($33c1d9c98facc1fa$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $2Zwj7.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $j7feg.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($33c1d9c98facc1fa$var$_objectSpread($33c1d9c98facc1fa$var$_objectSpread($33c1d9c98facc1fa$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("2Zwj7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $22da56d90fa57168$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");
class $22da56d90fa57168$export$2e2bcd8739ae039 {
    constructor(){
        (0, $hMyHv.default)(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, $hMyHv.default)(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("j7feg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $deaa7bed18c14295$export$2e2bcd8739ae039; });
class $deaa7bed18c14295$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("4LKl0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $378f7ee93ca801cd$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $378f7ee93ca801cd$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $378f7ee93ca801cd$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($378f7ee93ca801cd$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("b1zOW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $806b92eb7b7a8f14$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $dcBcW = parcelRequire("dcBcW");
var $5Jvfa = parcelRequire("5Jvfa");
var $WQrcx = parcelRequire("WQrcx");

var $wetcE = parcelRequire("wetcE");

var $8yyrG = parcelRequire("8yyrG");
const $806b92eb7b7a8f14$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $5Jvfa.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $806b92eb7b7a8f14$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $hMyHv.default)(this, "validProduct", false);
        this.isEnabled = options.perimeter !== (0, $wetcE.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $WQrcx.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $8yyrG.default)($806b92eb7b7a8f14$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $5Jvfa.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $5Jvfa.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch (_unused) {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $dcBcW.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("dcBcW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $99c9420bdbfac92a$export$2e2bcd8739ae039; });

var $RY6oS = parcelRequire("RY6oS");

var $9NQYG = parcelRequire("9NQYG");

var $kIqJs = parcelRequire("kIqJs");

var $cVSvQ = parcelRequire("cVSvQ");

var $jsuBj = parcelRequire("jsuBj");

var $2lpqZ = parcelRequire("2lpqZ");
var $99c9420bdbfac92a$export$b9dd752fb13352ce = 'interactionSession.source';
var $99c9420bdbfac92a$export$e04e3c50573f9af7 = 'interactionSession.bridge';
/**
 * AnalyticsCrossProductInteractionClient is a wrapper for the InteractionSessionTracking class.
 * It is designed to be used internally within the Atlassian Analytics Pipeline as well as useCrossProductUrlWrapper hook.
 * It is not intended to be used directly by end-users.
 *
 * This will create an instance of the interaction session tracker on the window object, which can be shared across different parts of a document.
 * If the internal client already exists, it will use the existing instance. Creating the client in a singleton manner like this enables us
 * to debounce updates to Session Storage, which is important when a large number of links using our hook are rendered on a page.
 *
 * The other interaction session parameters are written directly to session storage as they are predominantly read-only,
 * with the only update being the initialisation of the client
 */ var $99c9420bdbfac92a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $RY6oS.default)(function AnalyticsCrossProductInteractionClient(interactionSessionOptions, bridge, interactionSource) {
    var _this = this;
    (0, $9NQYG.default)(this, AnalyticsCrossProductInteractionClient);
    (0, $kIqJs.default)(this, "getCurrentInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
    });
    (0, $kIqJs.default)(this, "getPreviousInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
    });
    (0, $kIqJs.default)(this, "getBridge", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($99c9420bdbfac92a$export$e04e3c50573f9af7) : null;
    });
    (0, $kIqJs.default)(this, "getInteractionSource", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($99c9420bdbfac92a$export$b9dd752fb13352ce) : null;
    });
    this.isEnabled = !(0, $cVSvQ.isFedrampModerate)();
    if (this.isEnabled) {
        // Get singleton interaction session tracking instance
        this.interactionSessionTracking = (0, $jsuBj.default).getInstance();
        var isValidPersistedId = false;
        if (this.interactionSessionTracking) {
            if (interactionSessionOptions) {
                this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
            }
        }
        this.safeSessionStorage = new (0, $2lpqZ.default)();
        // Store other interaction session parameters directly in session storage if ID has been validated
        if (isValidPersistedId) {
            bridge && this.safeSessionStorage.setItem($99c9420bdbfac92a$export$e04e3c50573f9af7, bridge);
            interactionSource && this.safeSessionStorage.setItem($99c9420bdbfac92a$export$b9dd752fb13352ce, interactionSource);
        }
    }
});

});
parcelRegister("RY6oS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0a2392670a6ee464$export$2e2bcd8739ae039; });

var $8C9iw = parcelRequire("8C9iw");
function $0a2392670a6ee464$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $8C9iw.default)(o.key), o);
    }
}
function $0a2392670a6ee464$export$2e2bcd8739ae039(e, r, t) {
    return r && $0a2392670a6ee464$var$_defineProperties(e.prototype, r), t && $0a2392670a6ee464$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("8C9iw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $645915a919492e25$export$2e2bcd8739ae039; });

var $1QYbe = parcelRequire("1QYbe");

var $5JcZv = parcelRequire("5JcZv");
function $645915a919492e25$export$2e2bcd8739ae039(t) {
    var i = (0, $5JcZv.default)(t, "string");
    return "symbol" == (0, $1QYbe.default)(i) ? i : i + "";
}

});
parcelRegister("1QYbe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1599544aa170f2e9$export$2e2bcd8739ae039; });
function $1599544aa170f2e9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1599544aa170f2e9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1599544aa170f2e9$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5JcZv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $42bb3b73eb91bb0b$export$2e2bcd8739ae039; });

var $1QYbe = parcelRequire("1QYbe");
function $42bb3b73eb91bb0b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1QYbe.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1QYbe.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("9NQYG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7231c8ef0b35dabe$export$2e2bcd8739ae039; });
function $7231c8ef0b35dabe$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kIqJs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f14ca72e3d9d0b89$export$2e2bcd8739ae039; });

var $8C9iw = parcelRequire("8C9iw");
function $f14ca72e3d9d0b89$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $8C9iw.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("jsuBj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e2a85e88ecd0ee22$export$2e2bcd8739ae039; });

var $9NQYG = parcelRequire("9NQYG");

var $RY6oS = parcelRequire("RY6oS");

var $29gw5 = parcelRequire("29gw5");
var $e2a85e88ecd0ee22$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
var $e2a85e88ecd0ee22$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function GlobalInteractionSessionTracking() {
        (0, $9NQYG.default)(this, GlobalInteractionSessionTracking);
    }
    return (0, $RY6oS.default)(GlobalInteractionSessionTracking, null, [
        {
            key: "getInstance",
            value: function getInstance() {
                var interactionSessionTracking;
                try {
                    // Check if InteractionSessionTracking in global window object
                    if ($e2a85e88ecd0ee22$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$e2a85e88ecd0ee22$export$7bc189309d2ad463];
                    else {
                        // Initialise InteractionSessionTracking on global window object
                        window[$e2a85e88ecd0ee22$export$7bc189309d2ad463] = new (0, $29gw5.default)();
                        interactionSessionTracking = window[$e2a85e88ecd0ee22$export$7bc189309d2ad463];
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error initialising InteractionSessionTracking - ".concat(error instanceof Error ? error.message : String(error)));
                }
                return interactionSessionTracking;
            }
        }
    ]);
}();

});
parcelRegister("29gw5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $19093bda83ce0cc2$export$2e2bcd8739ae039; });

var $9NQYG = parcelRequire("9NQYG");

var $RY6oS = parcelRequire("RY6oS");

var $kIqJs = parcelRequire("kIqJs");

var $2lpqZ = parcelRequire("2lpqZ");
// WARNING: The value of INTERACTION_SESSION_ID_STORAGE_KEY will be used by Analytics Web Client to attach the session ID to events.
// If you change this, you will need to update the Analytics Web Client code as well.
var $19093bda83ce0cc2$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
var $19093bda83ce0cc2$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
var $19093bda83ce0cc2$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
var $19093bda83ce0cc2$export$285f6bddd927a06d = 1800000; // 30 minutes
var $19093bda83ce0cc2$export$d050a4cab1b9f734 = 86400000; // 24 hours
var $19093bda83ce0cc2$export$a92e915d70316eb2 = 5000; // 5 seconds
var $19093bda83ce0cc2$export$de43760b2dc10c19 = 0.9; // 90% of expiry
var $19093bda83ce0cc2$var$INTEGER_REGEX = /^\d+$/;
var $19093bda83ce0cc2$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * This class is essentially a wrapper around SessionStorage that introduces some failsafes (such as switching to InMemoryStorage if SessionStorage is not available)
 * and providing resilient methods for accessing and updating the interaction session ID.
 * This class can be initialised anywhere within a document, and `getCurrentInteractionSessionId` will always return the latest interaction session ID.
 *
 * The `setAnalyticsCallback` method must be called with a valid analytics event callback function provided by an Analytics Web Client before any other methods are used.
 * This is to ensure that any generated or renewed session IDs can be reported via an analytics event.
 *
 * The `setInteractionSessionId` method will write the SessionStorage with the persisted session ID, and is only intended to be used by the Analytics Web Client
 */ var $19093bda83ce0cc2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // This callback function will be called whenever a new session ID is generated
    // It expects a function that sends an operational analytics event, with
    // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
    // an InteractionSession object containing the new session ID and previous session ID.
    function InteractionSessionTracking() {
        var _this = this;
        (0, $9NQYG.default)(this, InteractionSessionTracking);
        (0, $kIqJs.default)(this, "analyticsReady", false);
        (0, $kIqJs.default)(this, "generateNewSessionId", function() {
            if (!_this.analyticsReady) return null;
            var currentSessionId = _this.safeSessionStorage.getItem($19093bda83ce0cc2$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            var newSessionId = Date.now().toString();
            _this.safeSessionStorage.setItem($19093bda83ce0cc2$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            var _this$getCurrentSessi = _this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi.isValidSession;
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                _this.safeSessionStorage.setItem($19093bda83ce0cc2$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                _this.sendInteractionSessionEvent('renewed');
            } else _this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($19093bda83ce0cc2$export$5d4c4eab0863aae3));
            return newSessionId;
        });
        (0, $kIqJs.default)(this, "updateSessionExpiry", function() {
            var expiry = Date.now() + _this.sessionExpiryTime;
            _this.safeSessionStorage.setItem($19093bda83ce0cc2$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, $kIqJs.default)(this, "debouncedUpdateSessionExpiry", function(currentExpiry) {
            var updateSessionExpiry = _this.updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this.sessionExpiryDebounceThresholdPercentage * _this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (_this.sessionExpiryDebounceTimer) clearTimeout(_this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this.sessionExpiryDebounceTimer = setTimeout(function() {
                    updateSessionExpiry();
                }, _this.sessionExpiryDebounce);
            }
        });
        this.sessionExpiryTime = $19093bda83ce0cc2$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $19093bda83ce0cc2$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $19093bda83ce0cc2$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $2lpqZ.default)();
    }
    return (0, $RY6oS.default)(InteractionSessionTracking, [
        {
            key: "getCurrentInteractionSessionId",
            value: function getCurrentInteractionSessionId() {
                try {
                    var _this$getCurrentSessi2 = this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi2.isValidSession, sessionExpiry = _this$getCurrentSessi2.sessionExpiry, sessionId = _this$getCurrentSessi2.sessionId;
                    // If we have an existing valid session we can return the sessionId straight away
                    if (isValidSession) {
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return sessionId;
                    }
                    // To generate a new session ID we must ensure analytics is ready
                    if (this.analyticsReady) {
                        // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                        // into issues of calls attempting to read the session ID before a valid expiry had been set
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return this.generateNewSessionId();
                    }
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error("Error retrieving interaction session ID - ".concat(err instanceof Error ? err.message : String(err)));
                }
                return null;
            }
        },
        {
            key: "getPreviousInteractionSessionId",
            value: function getPreviousInteractionSessionId() {
                return this.safeSessionStorage.getItem($19093bda83ce0cc2$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            }
        },
        {
            key: "setInteractionSessionId",
            value: function setInteractionSessionId(persistedSessionId) {
                if (this.validateSessionId(persistedSessionId)) {
                    var currentSessionId = this.safeSessionStorage.getItem($19093bda83ce0cc2$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                    // If we are already on the required session ID, just return true and make no changes
                    // This can happen if the persisted session ID in options is the same as the current session ID
                    // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
                    // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
                    if (currentSessionId === persistedSessionId) return false;
                    // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
                    // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
                    this.debouncedUpdateSessionExpiry(0);
                    this.safeSessionStorage.setItem($19093bda83ce0cc2$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
                    this.safeSessionStorage.removeItem($19093bda83ce0cc2$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
                    document.dispatchEvent(new Event($19093bda83ce0cc2$export$5d4c4eab0863aae3));
                    return true;
                }
                return false;
            }
        },
        {
            key: "setAnalyticsCallback",
            value: function setAnalyticsCallback(sendEventCallback) {
                if (this.analyticsReady) // If we already have a valid callback, don't over-write it
                return;
                if (sendEventCallback && typeof sendEventCallback === 'function') {
                    this.sendEventCallback = sendEventCallback;
                    this.analyticsReady = true;
                } else this.analyticsReady = false;
            }
        },
        {
            key: "validateSessionId",
            value: function validateSessionId(sessionId) {
                // Check if persisted session ID can parse as valid Unix timestamp
                if (sessionId && $19093bda83ce0cc2$var$INTEGER_REGEX.test(sessionId)) {
                    var sessionAge = Date.now() - parseInt(sessionId, 10);
                    // Validate that timestamp is not a future time, and is also within the TTL
                    if (sessionAge >= 0 && sessionAge <= $19093bda83ce0cc2$export$d050a4cab1b9f734) return true;
                }
                return false;
            }
        },
        {
            key: "getCurrentSessionParams",
            value: function getCurrentSessionParams() {
                var sessionId = this.safeSessionStorage.getItem($19093bda83ce0cc2$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this.safeSessionStorage.getItem($19093bda83ce0cc2$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
                if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
                    isValidSession: true,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
                return {
                    isValidSession: false,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
            }
        },
        {
            key: "sendInteractionSessionEvent",
            value: function sendInteractionSessionEvent(action) {
                this.sendEventCallback && this.sendEventCallback({
                    action: action,
                    actionSubject: 'interactionSession',
                    source: 'interactionComponent',
                    tags: [
                        'navigationExperiences'
                    ] // InteractionSession events will be registered under this platform product
                });
            }
        }
    ]);
}();

});
parcelRegister("2lpqZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1b5145a83b571b84$export$2e2bcd8739ae039; });

var $RY6oS = parcelRequire("RY6oS");

var $9NQYG = parcelRequire("9NQYG");

var $5BJH9 = parcelRequire("5BJH9");

var $6tnHp = parcelRequire("6tnHp");

var $bc6Zb = parcelRequire("bc6Zb");

var $2KUBO = parcelRequire("2KUBO");

var $8vrN7 = parcelRequire("8vrN7");
function $1b5145a83b571b84$var$_callSuper(t, o, e) {
    return o = (0, $6tnHp.default)(o), (0, $5BJH9.default)(t, $1b5145a83b571b84$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $6tnHp.default)(t).constructor) : o.apply(t, e));
}
function $1b5145a83b571b84$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1b5145a83b571b84$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line import/no-anonymous-default-export
var $1b5145a83b571b84$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_SafeStorage) {
    function _default(options) {
        (0, $9NQYG.default)(this, _default);
        var storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $2KUBO.default);
        } catch (err) {
            storageToUse = (0, $2KUBO.default);
        }
        return $1b5145a83b571b84$var$_callSuper(this, _default, [
            storageToUse,
            options
        ]);
    }
    (0, $bc6Zb.default)(_default, _SafeStorage);
    return (0, $RY6oS.default)(_default);
}((0, $8vrN7.default));

});
parcelRegister("5BJH9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4153da888f0b51ed$export$2e2bcd8739ae039; });

var $1QYbe = parcelRequire("1QYbe");

var $gYngg = parcelRequire("gYngg");
function $4153da888f0b51ed$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $1QYbe.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $gYngg.default)(t);
}

});
parcelRegister("gYngg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c5b44b2a3a939076$export$2e2bcd8739ae039; });
function $c5b44b2a3a939076$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("6tnHp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b67d5a65b3cd2fb$export$2e2bcd8739ae039; });
function $4b67d5a65b3cd2fb$export$2e2bcd8739ae039(t) {
    return $4b67d5a65b3cd2fb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4b67d5a65b3cd2fb$export$2e2bcd8739ae039(t);
}

});

parcelRegister("bc6Zb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82663beb2a355426$export$2e2bcd8739ae039; });

var $6kEZy = parcelRequire("6kEZy");
function $82663beb2a355426$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6kEZy.default)(t, e);
}

});
parcelRegister("6kEZy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $49c4686fa45a4d42$export$2e2bcd8739ae039; });
function $49c4686fa45a4d42$export$2e2bcd8739ae039(t, e) {
    return $49c4686fa45a4d42$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $49c4686fa45a4d42$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("2KUBO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $201bc9f9def17b35$export$2e2bcd8739ae039; });

var $RY6oS = parcelRequire("RY6oS");

var $9NQYG = parcelRequire("9NQYG");

var $kIqJs = parcelRequire("kIqJs");
var $201bc9f9def17b35$export$90e3e001bcac59c7 = /*#__PURE__*/ (0, $RY6oS.default)(function InMemoryStore() {
    var _this = this;
    (0, $9NQYG.default)(this, InMemoryStore);
    (0, $kIqJs.default)(this, "data", {});
    (0, $kIqJs.default)(this, "length", 0);
    (0, $kIqJs.default)(this, "setItem", function(key, value) {
        _this.data[key] = value;
        _this.length = Object.keys(_this.data).length;
        return value;
    });
    (0, $kIqJs.default)(this, "getItem", function(key) {
        if (key in _this.data) return _this.data[key];
        return null;
    });
    (0, $kIqJs.default)(this, "removeItem", function(key) {
        if (key in _this.data) delete _this.data[key];
        _this.length = Object.keys(_this.data).length;
        return null;
    });
    (0, $kIqJs.default)(this, "clear", function() {
        _this.data = {};
        _this.length = 0;
    });
    (0, $kIqJs.default)(this, "key", function(index) {
        return Object.keys(_this.data)[index];
    });
});
// eslint-disable-next-line import/no-anonymous-default-export
var $201bc9f9def17b35$var$inmemorystorage = new $201bc9f9def17b35$export$90e3e001bcac59c7();
var $201bc9f9def17b35$export$2e2bcd8739ae039 = $201bc9f9def17b35$var$inmemorystorage;

});

parcelRegister("8vrN7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6316c6bb441c9314$export$2e2bcd8739ae039; });

var $RY6oS = parcelRequire("RY6oS");

var $9NQYG = parcelRequire("9NQYG");

var $kIqJs = parcelRequire("kIqJs");

var $2KUBO = parcelRequire("2KUBO");
var $6316c6bb441c9314$export$41c06fdd37b7e9a5 = 'awc';
var $6316c6bb441c9314$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $6316c6bb441c9314$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $6316c6bb441c9314$export$48c17662a6902497(store) {
    var TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        var key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
var $6316c6bb441c9314$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $RY6oS.default)(function SafeStorage(storageToUse) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $9NQYG.default)(this, SafeStorage);
    (0, $kIqJs.default)(this, "getStore", function() {
        return _this.store;
    });
    (0, $kIqJs.default)(this, "getItem", function(key) {
        return _this.store.getItem(_this.createKey(key));
    });
    (0, $kIqJs.default)(this, "removeItem", function(key) {
        return _this.store.removeItem(_this.createKey(key));
    });
    (0, $kIqJs.default)(this, "setItem", function(key, value) {
        try {
            _this.store.setItem(_this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            _this.swapToInMemory();
            _this.store.setItem(_this.createKey(key), value);
        }
    });
    (0, $kIqJs.default)(this, "swapToInMemory", function() {
        if (_this.store === (0, $2KUBO.default) || typeof window === 'undefined') return;
        var keys = Object.keys(_this.store || {});
        var inMemoryStorage;
        if ($6316c6bb441c9314$export$48c17662a6902497(window[$6316c6bb441c9314$export$770aa8bc07b3de03])) inMemoryStorage = window[$6316c6bb441c9314$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $2KUBO.default);
            if (!window[$6316c6bb441c9314$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[$6316c6bb441c9314$export$770aa8bc07b3de03] = (0, $2KUBO.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this.store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this.store = inMemoryStorage;
    });
    (0, $kIqJs.default)(this, "clear", function() {
        return _this.store.clear();
    });
    (0, $kIqJs.default)(this, "key", function(index) {
        return _this.store.key(index);
    });
    (0, $kIqJs.default)(this, "getPrefix", function() {
        return _this.prefix;
    });
    (0, $kIqJs.default)(this, "createKey", function(key) {
        if (_this.prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    });
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($6316c6bb441c9314$export$41c06fdd37b7e9a5);
    if (options.envPrefix && options.envPrefix !== $6316c6bb441c9314$export$56ac8ebc9870b1b9.PROD) prefixes.push(options.envPrefix);
    this.prefix = prefixes.join('-');
    if ($6316c6bb441c9314$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
    else this.swapToInMemory();
});

});





parcelRegister("5Jvfa", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", function () { return $42c9640fd7b3498e$export$81d16f1428ce0486; });
var $42c9640fd7b3498e$export$81d16f1428ce0486 = 'xpis';
var $42c9640fd7b3498e$export$2e3999ec51334ffe = function generateUrlWithParams(url, bridge, interactionSessionId, product, subProduct) {
    var interactionSource = subProduct ? "".concat(product, "-").concat(subProduct) : product;
    var interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    var paramValueEncoded = btoa(JSON.stringify(interactionSession));
    var urlObj = new URL(url);
    urlObj.searchParams.set($42c9640fd7b3498e$export$81d16f1428ce0486, paramValueEncoded);
    return urlObj.toString();
};

});

parcelRegister("WQrcx", function(module, exports) {
$parcel$export(module.exports, "validProducts", function () { return $0b0e17ef53aac4b4$export$b1e8b4360a046e61; });
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
var $0b0e17ef53aac4b4$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];

});

parcelRegister("8yyrG", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $63ac37dd20ca0eed$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $63ac37dd20ca0eed$export$2e2bcd8739ae039; });

var $9NAYc = parcelRequire("9NAYc");

var $hoQGK = parcelRequire("hoQGK");
const $63ac37dd20ca0eed$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $63ac37dd20ca0eed$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $63ac37dd20ca0eed$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $9NAYc.parseUrl)(removedFragmentURL);
    const captureParams = (0, $hoQGK.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $hoQGK.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $9NAYc.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $63ac37dd20ca0eed$export$2e2bcd8739ae039 = $63ac37dd20ca0eed$var$urlParamExtractor;

});
parcelRegister("9NAYc", function(module, exports) {
$parcel$export(module.exports, "extract", function () { return $72255e21ad16943a$export$f9380c9a627682d3; }, function (v) { return $72255e21ad16943a$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $72255e21ad16943a$export$98e6a39c04603d36; }, function (v) { return $72255e21ad16943a$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $72255e21ad16943a$export$fac44ee5b035f737; }, function (v) { return $72255e21ad16943a$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $72255e21ad16943a$export$7a5253c0f62e0150; }, function (v) { return $72255e21ad16943a$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $72255e21ad16943a$export$a8c1621ea79325d3; }, function (v) { return $72255e21ad16943a$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $72255e21ad16943a$export$357523c63a2253b9; }, function (v) { return $72255e21ad16943a$export$357523c63a2253b9 = v; });
var $72255e21ad16943a$export$f9380c9a627682d3;
var $72255e21ad16943a$export$98e6a39c04603d36;
var $72255e21ad16943a$export$fac44ee5b035f737;
var $72255e21ad16943a$export$7a5253c0f62e0150;
var $72255e21ad16943a$export$a8c1621ea79325d3;
var $72255e21ad16943a$export$357523c63a2253b9;
var $72255e21ad16943a$export$44c361b8ec72ef7f;
'use strict';

var $Tgi7x = parcelRequire("Tgi7x");

var $2yLHC = parcelRequire("2yLHC");

var $6rjNb = parcelRequire("6rjNb");

var $gNyr9 = parcelRequire("gNyr9");
const $72255e21ad16943a$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $72255e21ad16943a$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $72255e21ad16943a$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $72255e21ad16943a$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $72255e21ad16943a$var$encode(key, options),
                            '[',
                            $72255e21ad16943a$var$encode(index, options),
                            ']=',
                            $72255e21ad16943a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $72255e21ad16943a$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $72255e21ad16943a$var$encode(key, options),
                            '[]=',
                            $72255e21ad16943a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $72255e21ad16943a$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $72255e21ad16943a$var$encode(key, options),
                            ':list=',
                            $72255e21ad16943a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $72255e21ad16943a$var$encode(key, options),
                                keyValueSep,
                                $72255e21ad16943a$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $72255e21ad16943a$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $72255e21ad16943a$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $72255e21ad16943a$var$encode(key, options),
                            '=',
                            $72255e21ad16943a$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $72255e21ad16943a$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $72255e21ad16943a$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $72255e21ad16943a$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$72255e21ad16943a$var$decode(item, options)) : value === null ? value : $72255e21ad16943a$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $72255e21ad16943a$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$72255e21ad16943a$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $72255e21ad16943a$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $72255e21ad16943a$var$encode(value, options) {
    if (options.encode) return options.strict ? $Tgi7x(value) : encodeURIComponent(value);
    return value;
}
function $72255e21ad16943a$var$decode(value, options) {
    if (options.decode) return $2yLHC(value);
    return value;
}
function $72255e21ad16943a$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $72255e21ad16943a$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $72255e21ad16943a$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $72255e21ad16943a$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $72255e21ad16943a$var$extract(input) {
    input = $72255e21ad16943a$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $72255e21ad16943a$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $72255e21ad16943a$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $72255e21ad16943a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $72255e21ad16943a$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $6rjNb(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $72255e21ad16943a$var$decode(value, options);
        formatter($72255e21ad16943a$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $72255e21ad16943a$var$parseValue(value[k], options);
        else ret[key] = $72255e21ad16943a$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $72255e21ad16943a$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$72255e21ad16943a$export$f9380c9a627682d3 = $72255e21ad16943a$var$extract;
$72255e21ad16943a$export$98e6a39c04603d36 = $72255e21ad16943a$var$parse;
$72255e21ad16943a$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $72255e21ad16943a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $72255e21ad16943a$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $72255e21ad16943a$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $72255e21ad16943a$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $72255e21ad16943a$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $72255e21ad16943a$var$encode(key, options) + '=' + $72255e21ad16943a$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$72255e21ad16943a$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $6rjNb(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $72255e21ad16943a$var$parse($72255e21ad16943a$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $72255e21ad16943a$var$decode(hash, options)
    } : {});
};
$72255e21ad16943a$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$72255e21ad16943a$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $72255e21ad16943a$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $72255e21ad16943a$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $72255e21ad16943a$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $72255e21ad16943a$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $72255e21ad16943a$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$72255e21ad16943a$var$encodeFragmentIdentifier] ? $72255e21ad16943a$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$72255e21ad16943a$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$72255e21ad16943a$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $72255e21ad16943a$export$7a5253c0f62e0150(input, options);
    return $72255e21ad16943a$export$a8c1621ea79325d3({
        url: url,
        query: $gNyr9(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$72255e21ad16943a$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $72255e21ad16943a$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("Tgi7x", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("2yLHC", function(module, exports) {
'use strict';
var $1dd3c2752a0699ae$var$token = '%[a-f0-9]{2}';
var $1dd3c2752a0699ae$var$singleMatcher = new RegExp('(' + $1dd3c2752a0699ae$var$token + ')|([^%]+?)', 'gi');
var $1dd3c2752a0699ae$var$multiMatcher = new RegExp('(' + $1dd3c2752a0699ae$var$token + ')+', 'gi');
function $1dd3c2752a0699ae$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $1dd3c2752a0699ae$var$decodeComponents(left), $1dd3c2752a0699ae$var$decodeComponents(right));
}
function $1dd3c2752a0699ae$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($1dd3c2752a0699ae$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $1dd3c2752a0699ae$var$decodeComponents(tokens, i).join('');
            tokens = input.match($1dd3c2752a0699ae$var$singleMatcher) || [];
        }
        return input;
    }
}
function $1dd3c2752a0699ae$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $1dd3c2752a0699ae$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $1dd3c2752a0699ae$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $1dd3c2752a0699ae$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $1dd3c2752a0699ae$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("6rjNb", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("gNyr9", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("hoQGK", function(module, exports) {
$parcel$export(module.exports, "mapKeys", function () { return $caad8c681ce97720$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $caad8c681ce97720$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $caad8c681ce97720$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $caad8c681ce97720$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $caad8c681ce97720$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $caad8c681ce97720$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $caad8c681ce97720$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $caad8c681ce97720$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $caad8c681ce97720$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $caad8c681ce97720$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $caad8c681ce97720$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $caad8c681ce97720$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $caad8c681ce97720$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$caad8c681ce97720$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $caad8c681ce97720$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("amnta", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", function () { return $78ae29fcdd3b428e$export$f56713ced121eb91; });
$parcel$export(module.exports, "isThirdParty", function () { return $78ae29fcdd3b428e$export$ab34f90cc32c8960; });

var $wetcE = parcelRequire("wetcE");
const $78ae29fcdd3b428e$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $wetcE.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $78ae29fcdd3b428e$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $wetcE.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("6c0mc", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", function () { return $482423f4c80e9e1e$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $482423f4c80e9e1e$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $482423f4c80e9e1e$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $482423f4c80e9e1e$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $482423f4c80e9e1e$export$7bf451af4a8e3dd9; });

var $hMyHv = parcelRequire("hMyHv");

var $wetcE = parcelRequire("wetcE");

var $6FPUz = parcelRequire("6FPUz");
function $482423f4c80e9e1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $482423f4c80e9e1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $482423f4c80e9e1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $482423f4c80e9e1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $482423f4c80e9e1e$var$libraryVersion = "0.0.0-development";
function $482423f4c80e9e1e$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $482423f4c80e9e1e$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $482423f4c80e9e1e$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $482423f4c80e9e1e$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $482423f4c80e9e1e$var$buildAliases(aliases) {
    if ($482423f4c80e9e1e$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $482423f4c80e9e1e$var$buildGroups(groups) {
    if ($482423f4c80e9e1e$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $482423f4c80e9e1e$var$buildEventOverrides(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}
function $482423f4c80e9e1e$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $482423f4c80e9e1e$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $482423f4c80e9e1e$var$getProductField(productInfo.env, overrides.env);
    const product = $482423f4c80e9e1e$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $482423f4c80e9e1e$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $482423f4c80e9e1e$var$getProductField(productInfo.version, overrides.version);
    const origin = $482423f4c80e9e1e$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $482423f4c80e9e1e$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic
    };
}
function $482423f4c80e9e1e$var$isNotEmptyObject(obj) {
    return (0, $6FPUz.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $482423f4c80e9e1e$var$buildAttributesWithName(name, attrObject) {
    return $482423f4c80e9e1e$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $482423f4c80e9e1e$var$buildAttributes(attributes) {
    return $482423f4c80e9e1e$var$buildAttributesWithName('attributes', attributes);
}
function $482423f4c80e9e1e$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $482423f4c80e9e1e$export$f045f238d77c002a(containers) {
    if ($482423f4c80e9e1e$var$isNotEmptyObject(containers)) {
        const validContainers = $482423f4c80e9e1e$export$3f5115a568819c1a(containers);
        return $482423f4c80e9e1e$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $482423f4c80e9e1e$export$655ecf7241feac42(event, actionEventType) {
    return $482423f4c80e9e1e$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $482423f4c80e9e1e$export$f045f238d77c002a(event.containers));
}
function $482423f4c80e9e1e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $482423f4c80e9e1e$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $482423f4c80e9e1e$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $482423f4c80e9e1e$var$buildProductFields(productInfo);
    const tenantFields = $482423f4c80e9e1e$var$buildTenantFields(tenantInfo);
    const userFields = $482423f4c80e9e1e$var$buildUserFields(userInfo);
    const orgFields = $482423f4c80e9e1e$var$buildOrgFields(orgInfo);
    const workspaceFields = $482423f4c80e9e1e$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $wetcE.eventType).SCREEN
    };
    return $482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $482423f4c80e9e1e$var$buildAttributes(attributes)), $482423f4c80e9e1e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $482423f4c80e9e1e$export$f045f238d77c002a(containers)), $482423f4c80e9e1e$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }, workspaceFields), $482423f4c80e9e1e$var$buildAliases(aliases)), $482423f4c80e9e1e$var$buildGroups(groups));
}
function $482423f4c80e9e1e$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
let $482423f4c80e9e1e$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $482423f4c80e9e1e$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return $482423f4c80e9e1e$export$fbd92247fb4d6159.QUIET;
    if (environment.includes('prod')) return $482423f4c80e9e1e$export$fbd92247fb4d6159.QUIET;
    return $482423f4c80e9e1e$export$fbd92247fb4d6159.COMPLETE;
}
function $482423f4c80e9e1e$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $482423f4c80e9e1e$var$libraryVersion
            },
            validationMode: $482423f4c80e9e1e$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $482423f4c80e9e1e$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $482423f4c80e9e1e$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $482423f4c80e9e1e$var$buildProductFields(productInfo, $482423f4c80e9e1e$export$e3d99b4bfec06f6e(event));
    const tenantFields = $482423f4c80e9e1e$var$buildTenantFields(tenantInfo);
    const orgFields = $482423f4c80e9e1e$var$buildOrgFields(orgInfo);
    const workspaceFields = $482423f4c80e9e1e$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $482423f4c80e9e1e$var$buildUserFields(userInfo);
    const actionFields = $482423f4c80e9e1e$export$655ecf7241feac42(event, actionEventType);
    return $482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread($482423f4c80e9e1e$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $482423f4c80e9e1e$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }, workspaceFields), $482423f4c80e9e1e$var$buildAliases(aliases)), $482423f4c80e9e1e$var$buildGroups(groups));
}

});
parcelRegister("6FPUz", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", function () { return $4dbed6f2d8936d3d$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $4dbed6f2d8936d3d$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $4dbed6f2d8936d3d$var$isObjectObject(o) {
    return $4dbed6f2d8936d3d$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $4dbed6f2d8936d3d$export$53b83ca8eaab0383(o) {
    if ($4dbed6f2d8936d3d$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($4dbed6f2d8936d3d$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("fDpO1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b61e8408a89c04bd$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $sG63p = parcelRequire("sG63p");

var $hk7y6 = parcelRequire("hk7y6");

var $4Jw0t = parcelRequire("4Jw0t");
class $b61e8408a89c04bd$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, $hMyHv.default)(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, $hMyHv.default)(this, "startLowPriorityEventDelay", (timeout = (0, $sG63p.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $sG63p.MAX_DELAY_TIMEOUT)) : (0, $sG63p.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $4Jw0t.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, $hMyHv.default)(this, "stopLowPriorityEventDelay", (reason = (0, $4Jw0t.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, $hMyHv.default)(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $hk7y6.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("sG63p", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $056345280648ddb8$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $056345280648ddb8$export$8575e30be0feb909; });
const $056345280648ddb8$export$cf090d5281b5ae06 = 10000;
const $056345280648ddb8$export$8575e30be0feb909 = 30000;

});

parcelRegister("hk7y6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c9ca2903d1a40f3b$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $6c0mc = parcelRequire("6c0mc");

var $hoQGK = parcelRequire("hoQGK");

var $32BNI = parcelRequire("32BNI");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $c9ca2903d1a40f3b$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $c9ca2903d1a40f3b$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $c9ca2903d1a40f3b$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, $hMyHv.default)(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, $hMyHv.default)(this, "size", ()=>this.eventArgs.length);
        (0, $hMyHv.default)(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, $hMyHv.default)(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, $hMyHv.default)(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $c9ca2903d1a40f3b$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $c9ca2903d1a40f3b$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, $hMyHv.default)(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $hoQGK.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $hoQGK.equals)(group.userInfo, args.userInfo) && (0, $hoQGK.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $6c0mc.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $32BNI.default)(compressionRules);
    }
}

});
parcelRegister("32BNI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $236ee17268da3548$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $6c0mc = parcelRequire("6c0mc");

var $hoQGK = parcelRequire("hoQGK");

var $bYe74 = parcelRequire("bYe74");
function $236ee17268da3548$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $236ee17268da3548$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $236ee17268da3548$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $236ee17268da3548$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $236ee17268da3548$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, $hMyHv.default)(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, $hMyHv.default)(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, $hMyHv.default)(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $6c0mc.buildActionFields)(event, event.eventType);
                    contextFields = (0, $hoQGK.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $hoQGK.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, $hMyHv.default)(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$236ee17268da3548$var$_objectSpread($236ee17268da3548$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $bYe74.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("bYe74", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", function () { return $8b703edccb0d5006$export$89b3253ddfd2e6e8; });

var $hMyHv = parcelRequire("hMyHv");

var $hNFBz = parcelRequire("hNFBz");

var $hoQGK = parcelRequire("hoQGK");
class $8b703edccb0d5006$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, $hMyHv.default)(this, "canCompress", (event)=>{
            try {
                return event && (0, $hNFBz.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, $hMyHv.default)(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $hoQGK.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $hNFBz.validateActionEventType)(event.eventType);
                (0, $hNFBz.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("hNFBz", function(module, exports) {
$parcel$export(module.exports, "validateContainers", function () { return $cf57492a1e62d3b7$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $cf57492a1e62d3b7$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $cf57492a1e62d3b7$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $cf57492a1e62d3b7$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $cf57492a1e62d3b7$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $cf57492a1e62d3b7$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateDwellBaseEvent", function () { return $cf57492a1e62d3b7$export$39d6334da9a44984; });
$parcel$export(module.exports, "validateUIEvent", function () { return $cf57492a1e62d3b7$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $cf57492a1e62d3b7$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $cf57492a1e62d3b7$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $cf57492a1e62d3b7$export$801b46c35394d316; });

var $wetcE = parcelRequire("wetcE");

var $6FPUz = parcelRequire("6FPUz");
const $cf57492a1e62d3b7$var$actionEventTypes = Object.freeze([
    (0, $wetcE.eventType).OPERATIONAL,
    (0, $wetcE.eventType).TRACK,
    (0, $wetcE.eventType).UI
]);
function $cf57492a1e62d3b7$export$df8ff30e3c960006(container) {
    if (!(0, $6FPUz.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $cf57492a1e62d3b7$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$cf57492a1e62d3b7$export$df8ff30e3c960006(container));
}
function $cf57492a1e62d3b7$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $wetcE.eventType).OPERATIONAL:
        case (0, $wetcE.eventType).TRACK:
        case (0, $wetcE.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $cf57492a1e62d3b7$export$4a8d7476662aebcc(type) {
    if (!$cf57492a1e62d3b7$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$cf57492a1e62d3b7$var$actionEventTypes}]`);
    return true;
}
function $cf57492a1e62d3b7$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $cf57492a1e62d3b7$export$e63ea5d8477971d3(event.containers);
}
function $cf57492a1e62d3b7$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $cf57492a1e62d3b7$export$8c014fd74b0c8b99(event) {
    $cf57492a1e62d3b7$export$e0c121325c66ed4c(event);
}
function $cf57492a1e62d3b7$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $cf57492a1e62d3b7$export$e5bac0930c812e90(event) {
    $cf57492a1e62d3b7$export$e0c121325c66ed4c(event);
}
function $cf57492a1e62d3b7$export$1e561554275607ef(event) {
    $cf57492a1e62d3b7$export$e0c121325c66ed4c(event);
}
function $cf57492a1e62d3b7$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $wetcE.isType)((0, $wetcE.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $wetcE.objectValues)((0, $wetcE.userType))}]`);
}
function $cf57492a1e62d3b7$export$801b46c35394d316(productInfo) {
    if (!(0, $wetcE.isType)((0, $wetcE.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $wetcE.objectValues)((0, $wetcE.platformType))}]`);
    if (productInfo.origin === (0, $wetcE.originType).DESKTOP && !(0, $wetcE.isType)((0, $wetcE.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $wetcE.originType).WEB && !(0, $wetcE.isType)((0, $wetcE.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("4Jw0t", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $3724313c8b0eb749$export$fa6e3729c21cb8f; });
let $3724313c8b0eb749$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("4MN8H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $37c1c323b4761e77$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $l5BiW = parcelRequire("l5BiW");

var $4UUl3 = parcelRequire("4UUl3");

var $78X8a = parcelRequire("78X8a");

var $l3Ejd = parcelRequire("l3Ejd");

var $1cpFH = parcelRequire("1cpFH");

var $b7UVb = parcelRequire("b7UVb");

var $dpT7Z = parcelRequire("dpT7Z");

var $hig21 = parcelRequire("hig21");

var $2PIJg = parcelRequire("2PIJg");

var $7rtn8 = parcelRequire("7rtn8");
function $37c1c323b4761e77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37c1c323b4761e77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37c1c323b4761e77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37c1c323b4761e77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $37c1c323b4761e77$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $37c1c323b4761e77$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $37c1c323b4761e77$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $37c1c323b4761e77$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $37c1c323b4761e77$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $37c1c323b4761e77$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $37c1c323b4761e77$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, $hMyHv.default)(this, "sendEvents", async (items, callback)=>{
            var _this$lastSendEventsE, _this$metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = $37c1c323b4761e77$var$_objectSpread($37c1c323b4761e77$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: ((_this$lastSendEventsE = this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this$metadataClient = this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
            });
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $dpT7Z.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $hig21.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $hig21.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $hig21.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $hig21.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        });
        this.options = $37c1c323b4761e77$var$_objectSpread($37c1c323b4761e77$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $1cpFH.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        });
        this.user = new (0, $2PIJg.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $4UUl3.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $l5BiW.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hig21.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $37c1c323b4761e77$var$_objectSpread($37c1c323b4761e77$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hig21.SegmentEventTypes).TRACK,
            properties: (0, $7rtn8.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $37c1c323b4761e77$var$_objectSpread($37c1c323b4761e77$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hig21.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $37c1c323b4761e77$var$_objectSpread($37c1c323b4761e77$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hig21.SegmentEventTypes).PAGE,
            properties: (0, $7rtn8.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $37c1c323b4761e77$var$_objectSpread($37c1c323b4761e77$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hig21.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $37c1c323b4761e77$var$_objectSpread($37c1c323b4761e77$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hig21.SegmentEventTypes).IDENTIFY,
            traits: (0, $7rtn8.prepareEventProperties)(builtEvent)
        });
        const event = $37c1c323b4761e77$var$_objectSpread($37c1c323b4761e77$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $7rtn8.prepareEventContext)(context);
        const segmentContext = (0, $7rtn8.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $78X8a.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        var _msg$context;
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = (_msg$context = msg.context) === null || _msg$context === void 0 ? void 0 : _msg$context.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject$messa;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (_unused) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $37c1c323b4761e77$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $37c1c323b4761e77$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $37c1c323b4761e77$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $l3Ejd.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $37c1c323b4761e77$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $37c1c323b4761e77$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $37c1c323b4761e77$export$133650fcdde1b226(success, statusCode, (0, $b7UVb.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $b7UVb.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $b7UVb.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $b7UVb.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $37c1c323b4761e77$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $37c1c323b4761e77$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error !== void 0 && error.message) {
            const match = error.message.match($37c1c323b4761e77$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $37c1c323b4761e77$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $37c1c323b4761e77$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $37c1c323b4761e77$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $37c1c323b4761e77$export$133650fcdde1b226(false, -1, (0, $b7UVb.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
(0, $hMyHv.default)($37c1c323b4761e77$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);

});
parcelRegister("l5BiW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f5a7008128534ecb$export$2e2bcd8739ae039; });

var $j0cUv = parcelRequire("j0cUv");

var $f5a7008128534ecb$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $j0cUv.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("j0cUv", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", function () { return $dd580823e1b5ca0e$export$d219df4fe04c04a7; });
$parcel$export(module.exports, "default", function () { return $dd580823e1b5ca0e$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $hPuB6 = parcelRequire("hPuB6");
var $dwFDP = parcelRequire("dwFDP");

var $fTvE9 = parcelRequire("fTvE9");
var $h9iSq = parcelRequire("h9iSq");
var $eKk5d = parcelRequire("eKk5d");

var $4UUl3 = parcelRequire("4UUl3");

var $76OmR = parcelRequire("76OmR");

var $bdOMa = parcelRequire("bdOMa");
var $aJ8H1 = parcelRequire("aJ8H1");

var $02RqU = parcelRequire("02RqU");
function $dd580823e1b5ca0e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd580823e1b5ca0e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd580823e1b5ca0e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd580823e1b5ca0e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $dd580823e1b5ca0e$var$ONE_MINUTE = 60000;
const $dd580823e1b5ca0e$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $dd580823e1b5ca0e$var$ONE_MINUTE,
    minRetryDelay: $dd580823e1b5ca0e$var$ONE_MINUTE,
    maxRetryDelay: $dd580823e1b5ca0e$var$ONE_MINUTE
};
const $dd580823e1b5ca0e$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $dd580823e1b5ca0e$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $h9iSq.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $bdOMa.default)($dd580823e1b5ca0e$var$_objectSpread($dd580823e1b5ca0e$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $bdOMa.default)($dd580823e1b5ca0e$var$_objectSpread($dd580823e1b5ca0e$var$_objectSpread({}, $dd580823e1b5ca0e$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $dd580823e1b5ca0e$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $4UUl3.default)();
        this.networkStatus = new (0, $76OmR.default)((status)=>{
            if (status === (0, $02RqU.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $eKk5d.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $02RqU.NetworkStatusEnum).OFFLINE) {
            done((0, $aJ8H1.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $fTvE9.CallbackProcessingErrorName)) {
                done((0, $aJ8H1.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $hPuB6.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $dwFDP.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $eKk5d.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $aJ8H1.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $aJ8H1.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $aJ8H1.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $dd580823e1b5ca0e$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $dd580823e1b5ca0e$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("hPuB6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cfaeef1432a8ff77$export$2e2bcd8739ae039; });

var $faL4z = parcelRequire("faL4z");

var $bqzL4 = parcelRequire("bqzL4");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $cfaeef1432a8ff77$var$validSuffixs = Object.values((0, $faL4z.LocalStorageKeySuffix));
var $cfaeef1432a8ff77$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $cfaeef1432a8ff77$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $faL4z.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $bqzL4.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("faL4z", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $b0bc4ddc7ef06282$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $b0bc4ddc7ef06282$export$8bb2c1fb2b1765a9; });
let $b0bc4ddc7ef06282$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $b0bc4ddc7ef06282$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("bqzL4", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", function () { return $851ddc423af7e25a$export$8433d54f767cbec5; });

var $faL4z = parcelRequire("faL4z");
const $851ddc423af7e25a$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $faL4z.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $faL4z.LocalStorageKeySuffix).ACK}`,
        [(0, $faL4z.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $faL4z.LocalStorageKeySuffix).QUEUE}`,
        [(0, $faL4z.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $faL4z.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $faL4z.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $faL4z.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $faL4z.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $faL4z.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("dwFDP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d8e90a7696f716f$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $78X8a = parcelRequire("78X8a");

var $faL4z = parcelRequire("faL4z");

var $bqzL4 = parcelRequire("bqzL4");
function $9d8e90a7696f716f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d8e90a7696f716f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d8e90a7696f716f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d8e90a7696f716f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $9d8e90a7696f716f$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $9d8e90a7696f716f$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $faL4z.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $faL4z.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (_unused) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_unused2) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $9d8e90a7696f716f$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $9d8e90a7696f716f$var$promisedSetTimeout((0, $faL4z.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $faL4z.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $9d8e90a7696f716f$var$promisedSetTimeout((0, $faL4z.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $faL4z.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $9d8e90a7696f716f$var$reclaim(options, callback);
};
const $9d8e90a7696f716f$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $9d8e90a7696f716f$var$_objectSpread($9d8e90a7696f716f$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $9d8e90a7696f716f$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $9d8e90a7696f716f$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $9d8e90a7696f716f$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $9d8e90a7696f716f$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $78X8a.default)();
    const queuesToReclaim = $9d8e90a7696f716f$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$9d8e90a7696f716f$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $bqzL4.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("78X8a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $533725e6173a5cf5$export$2e2bcd8739ae039; });
// UUID v4 generator with fallback for non-secure contexts
function $533725e6173a5cf5$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch (_unused) {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("fTvE9", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $b9248a72f73473c1$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $b9248a72f73473c1$export$2e2bcd8739ae039; });
const $b9248a72f73473c1$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $b9248a72f73473c1$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $b9248a72f73473c1$export$2e2bcd8739ae039.prototype);
        this.name = $b9248a72f73473c1$export$a409c8de90e11e14;
    }
}

});

parcelRegister("h9iSq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7c1eb78304e930d$export$2e2bcd8739ae039; });

var $cHZAM = parcelRequire("cHZAM");

var $eKk5d = parcelRequire("eKk5d");

var $fTvE9 = parcelRequire("fTvE9");
var $c7c1eb78304e930d$export$2e2bcd8739ae039 = (0, $cHZAM.default);

});
parcelRegister("cHZAM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9409471ea107ca8a$export$2e2bcd8739ae039; });

var $eKk5d = parcelRequire("eKk5d");

var $aNi62 = parcelRequire("aNi62");
var $aY4Py = parcelRequire("aY4Py");

var $9Z7gx = parcelRequire("9Z7gx");

var $9dmaO = parcelRequire("9dmaO");

var $97N2X = parcelRequire("97N2X");
class $9409471ea107ca8a$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $97N2X.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $9Z7gx.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $aNi62.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $9dmaO.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $eKk5d.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $eKk5d.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $aY4Py.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $eKk5d.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $9dmaO.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $eKk5d.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("eKk5d", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $abc4f0a94a431ade$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $abc4f0a94a431ade$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $abc4f0a94a431ade$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $abc4f0a94a431ade$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $abc4f0a94a431ade$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $abc4f0a94a431ade$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $abc4f0a94a431ade$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $abc4f0a94a431ade$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $abc4f0a94a431ade$export$7710d69e6f450f20; });
const $abc4f0a94a431ade$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $abc4f0a94a431ade$export$8cad224051643259 = 'analytics-web-client';
const $abc4f0a94a431ade$export$3d8420be07b276ab = 'analytics-resilience';
const $abc4f0a94a431ade$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $abc4f0a94a431ade$export$89d9c1ff8ac91862 = 'timeAdded';
const $abc4f0a94a431ade$export$a37d385bcd713809 = 'retryAttempts';
const $abc4f0a94a431ade$export$6d8635fed0e4b14d = 15000;
let $abc4f0a94a431ade$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $abc4f0a94a431ade$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("aNi62", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7dbc8491b735de3c$export$2e2bcd8739ae039; });
const $7dbc8491b735de3c$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $7dbc8491b735de3c$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $7dbc8491b735de3c$export$2e2bcd8739ae039.prototype);
        this.name = $7dbc8491b735de3c$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("aY4Py", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $7fc34136c4689d6c$export$74101021e0969375; });

var $2bpAQ = parcelRequire("2bpAQ");

var $fTvE9 = parcelRequire("fTvE9");

var $jJgRO = parcelRequire("jJgRO");
const $7fc34136c4689d6c$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $2bpAQ.AbandonWriteErrorName) || errorWithName.name === (0, $fTvE9.CallbackProcessingErrorName) || errorWithName.name === (0, $jJgRO.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("2bpAQ", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $1970762195207b5a$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $1970762195207b5a$export$2e2bcd8739ae039; });
const $1970762195207b5a$export$ba95206613c96b28 = 'AbandonWriteError';
class $1970762195207b5a$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $1970762195207b5a$export$2e2bcd8739ae039.prototype);
        this.name = $1970762195207b5a$export$ba95206613c96b28;
    }
}

});

parcelRegister("jJgRO", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $e5cf4dbd22c8c6b2$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $e5cf4dbd22c8c6b2$export$2e2bcd8739ae039; });
const $e5cf4dbd22c8c6b2$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $e5cf4dbd22c8c6b2$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $e5cf4dbd22c8c6b2$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("9Z7gx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $01e03fc7d4d58241$export$2e2bcd8739ae039; });

var $5P3bh = parcelRequire("5P3bh");

var $hMyHv = parcelRequire("hMyHv");

var $eKk5d = parcelRequire("eKk5d");

var $8CdJ9 = parcelRequire("8CdJ9");

var $fTvE9 = parcelRequire("fTvE9");
var $jJgRO = parcelRequire("jJgRO");
var $aNi62 = parcelRequire("aNi62");
var $aY4Py = parcelRequire("aY4Py");

var $8TKqC = parcelRequire("8TKqC");

var $97N2X = parcelRequire("97N2X");
const $01e03fc7d4d58241$var$_excluded = [
    "item"
], $01e03fc7d4d58241$var$_excluded2 = [
    "items"
];
function $01e03fc7d4d58241$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01e03fc7d4d58241$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01e03fc7d4d58241$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01e03fc7d4d58241$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $01e03fc7d4d58241$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, $hMyHv.default)(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $aNi62.default)());
                    }, (0, $eKk5d.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $eKk5d.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $eKk5d.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $eKk5d.TIME_TO_PROCESS_AFTER_INDEX), (0, $eKk5d.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $eKk5d.RETRY_INDEX), (0, $eKk5d.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $eKk5d.TIME_ADDED_INDEX), (0, $eKk5d.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $eKk5d.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $aNi62.default)());
                    };
                    try {
                        await (0, $97N2X.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $aNi62.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $aNi62.default)());
                }
            });
        });
        (0, $hMyHv.default)(this, "addItem", async (item, options = {}, policy = (0, $eKk5d.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $97N2X.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $eKk5d.GuardPolicy).IGNORE) throw new (0, $jJgRO.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $aY4Py.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, $hMyHv.default)(this, "bulkAddItem", async (itemOptions, policy = (0, $eKk5d.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, $5P3bh.default)(_ref, $01e03fc7d4d58241$var$_excluded);
                return (0, $97N2X.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $aY4Py.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, $hMyHv.default)(this, "getItems", async (count = (0, $8CdJ9.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $8CdJ9.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $eKk5d.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $01e03fc7d4d58241$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $8CdJ9.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $97N2X.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $97N2X.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $97N2X.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, $hMyHv.default)(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $97N2X.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        (0, $hMyHv.default)(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $eKk5d.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $97N2X.requestToPromise)(request);
            await (0, $97N2X.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, $hMyHv.default)(this, "processItems", async (processFn, count = (0, $8CdJ9.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, $5P3bh.default)(_await$this$getItems, $01e03fc7d4d58241$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $fTvE9.default)(error);
            }
        });
        (0, $hMyHv.default)(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $97N2X.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        });
        (0, $hMyHv.default)(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $eKk5d.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $eKk5d.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $97N2X.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $aNi62.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $8TKqC.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $eKk5d.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("5P3bh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43d42ed40345148e$export$2e2bcd8739ae039; });

var $5Zw3W = parcelRequire("5Zw3W");
function $43d42ed40345148e$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $5Zw3W.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("5Zw3W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $45cb8537e6ca98ac$export$2e2bcd8739ae039; });
function $45cb8537e6ca98ac$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("8CdJ9", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $645c8543730a62ae$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $645c8543730a62ae$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $645c8543730a62ae$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $645c8543730a62ae$export$1188664dfff364c8; });
const $645c8543730a62ae$export$b6df3d334cec060f = 7;
const $645c8543730a62ae$export$14ef152a03a4b6ee = 60000;
const $645c8543730a62ae$export$da9ab7b2fd5998e8 = 10;
const $645c8543730a62ae$export$1188664dfff364c8 = 8000;

});

parcelRegister("8TKqC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67a7797c5c9368a8$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $eKk5d = parcelRequire("eKk5d");

var $2bpAQ = parcelRequire("2bpAQ");

var $97N2X = parcelRequire("97N2X");
class $67a7797c5c9368a8$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, $hMyHv.default)(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $eKk5d.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $97N2X.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $eKk5d.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $eKk5d.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $eKk5d.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $eKk5d.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $97N2X.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $97N2X.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $2bpAQ.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $eKk5d.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $97N2X.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("97N2X", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", function () { return $6a4ad02b6e678e89$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $6a4ad02b6e678e89$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $6a4ad02b6e678e89$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $6a4ad02b6e678e89$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $6a4ad02b6e678e89$export$342d941b6f724995; });

var $78X8a = parcelRequire("78X8a");

var $8CdJ9 = parcelRequire("8CdJ9");
const $6a4ad02b6e678e89$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $78X8a.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $6a4ad02b6e678e89$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $8CdJ9.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $8CdJ9.EVENT_COUNT_LIMIT)
    });
const $6a4ad02b6e678e89$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $6a4ad02b6e678e89$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $6a4ad02b6e678e89$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $6a4ad02b6e678e89$export$2a5213bce1720b42(transaction);
};
const $6a4ad02b6e678e89$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("9dmaO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b568720b89ac66e$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $5P3bh = parcelRequire("5P3bh");

var $eKk5d = parcelRequire("eKk5d");

var $8CdJ9 = parcelRequire("8CdJ9");

var $fTvE9 = parcelRequire("fTvE9");
var $jJgRO = parcelRequire("jJgRO");

var $8fSZr = parcelRequire("8fSZr");

var $97N2X = parcelRequire("97N2X");
const $6b568720b89ac66e$var$_excluded = [
    "item"
], $6b568720b89ac66e$var$_excluded2 = [
    "items"
];
function $6b568720b89ac66e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b568720b89ac66e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b568720b89ac66e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b568720b89ac66e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $6b568720b89ac66e$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $97N2X.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $8fSZr.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $eKk5d.GuardPolicy).ABANDON) {
        if (policy === (0, $eKk5d.GuardPolicy).IGNORE) throw new (0, $jJgRO.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $97N2X.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $eKk5d.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, $5P3bh.default)(_ref, $6b568720b89ac66e$var$_excluded);
            return (0, $97N2X.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $eKk5d.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $8CdJ9.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $8CdJ9.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $8CdJ9.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($6b568720b89ac66e$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $8CdJ9.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, $5P3bh.default)(_this$synchronousGetI, $6b568720b89ac66e$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $fTvE9.default)(error);
        }
    }
    storeType() {
        return (0, $eKk5d.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("8fSZr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $602a614d66a16428$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $eKk5d = parcelRequire("eKk5d");

var $2bpAQ = parcelRequire("2bpAQ");
class $602a614d66a16428$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, $hMyHv.default)(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $eKk5d.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $eKk5d.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $eKk5d.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $2bpAQ.default)((0, $eKk5d.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("4UUl3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $394818091677685a$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $02RqU = parcelRequire("02RqU");
class $394818091677685a$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, $hMyHv.default)(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, $hMyHv.default)(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, $hMyHv.default)(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, $hMyHv.default)(this, "resilienceMechanism", (0, $02RqU.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, $hMyHv.default)(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, $hMyHv.default)(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, $hMyHv.default)(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, $hMyHv.default)(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $394818091677685a$var$cachedMetricsClient = null;
var $394818091677685a$export$2e2bcd8739ae039 = ()=>{
    if (!$394818091677685a$var$cachedMetricsClient) $394818091677685a$var$cachedMetricsClient = new $394818091677685a$export$4b62ee5120ab50a8();
    return $394818091677685a$var$cachedMetricsClient;
};

});
parcelRegister("02RqU", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", function () { return $0089a2ae7e9e2fd6$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $0089a2ae7e9e2fd6$export$ee138fa712d11b84; });
let $0089a2ae7e9e2fd6$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $0089a2ae7e9e2fd6$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("76OmR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $52d029f0b274c598$export$2e2bcd8739ae039; });

var $02RqU = parcelRequire("02RqU");
class $52d029f0b274c598$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $02RqU.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $02RqU.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $02RqU.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $02RqU.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $02RqU.NetworkStatusEnum).ONLINE;
        return (0, $02RqU.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("bdOMa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82b84b9dc8270810$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $kdQse = parcelRequire("kdQse");

var $aJ8H1 = parcelRequire("aJ8H1");
const $82b84b9dc8270810$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $82b84b9dc8270810$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $82b84b9dc8270810$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, $hMyHv.default)(this, "schedule", ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $82b84b9dc8270810$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $82b84b9dc8270810$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $82b84b9dc8270810$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        });
        (0, $hMyHv.default)(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $82b84b9dc8270810$export$8bb92baee001fc60.NONE;
        });
        (0, $hMyHv.default)(this, "getFailureCount", ()=>this.failureCount);
        (0, $hMyHv.default)(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, $hMyHv.default)(this, "clearTimeout", ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, $hMyHv.default)(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $aJ8H1.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, $hMyHv.default)(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $aJ8H1.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $kdQse.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $aJ8H1.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, $hMyHv.default)(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $82b84b9dc8270810$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $82b84b9dc8270810$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $82b84b9dc8270810$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, $hMyHv.default)(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $82b84b9dc8270810$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $82b84b9dc8270810$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $82b84b9dc8270810$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $82b84b9dc8270810$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $82b84b9dc8270810$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $82b84b9dc8270810$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $82b84b9dc8270810$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $kdQse.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("kdQse", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", function () { return $eb8db5e8ea85465b$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $eb8db5e8ea85465b$export$590a718599f8f8b3; });

var $hMyHv = parcelRequire("hMyHv");
let $eb8db5e8ea85465b$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $eb8db5e8ea85465b$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $eb8db5e8ea85465b$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, $hMyHv.default)(this, "timeoutHandle", undefined);
        (0, $hMyHv.default)(this, "callbackStatus", $eb8db5e8ea85465b$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $eb8db5e8ea85465b$export$ef3353088fca369c.IDLE:
            case $eb8db5e8ea85465b$export$ef3353088fca369c.TIMED_OUT:
            case $eb8db5e8ea85465b$export$ef3353088fca369c.COMPLETED:
                if (event === $eb8db5e8ea85465b$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $eb8db5e8ea85465b$export$ef3353088fca369c.RUNNING;
                break;
            case $eb8db5e8ea85465b$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $eb8db5e8ea85465b$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $eb8db5e8ea85465b$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $eb8db5e8ea85465b$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $eb8db5e8ea85465b$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, $eb8db5e8ea85465b$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $eb8db5e8ea85465b$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $eb8db5e8ea85465b$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $eb8db5e8ea85465b$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("aJ8H1", function(module, exports) {
$parcel$export(module.exports, "DoneState", function () { return $7cf4d98ea9da5d38$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $7cf4d98ea9da5d38$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("l3Ejd", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $f549254d1b79624a$export$c21270cab66ab290; });

var $hMyHv = parcelRequire("hMyHv");

var $hig21 = parcelRequire("hig21");
function $f549254d1b79624a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f549254d1b79624a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f549254d1b79624a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f549254d1b79624a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f549254d1b79624a$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $hig21.SegmentEventTypes).PAGE || item.msg.type === (0, $hig21.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $f549254d1b79624a$var$_objectSpread($f549254d1b79624a$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $hig21.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $f549254d1b79624a$var$_objectSpread($f549254d1b79624a$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $f549254d1b79624a$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$f549254d1b79624a$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("hig21", function(module, exports) {
$parcel$export(module.exports, "LastError", function () { return $c9708da15d484e9c$export$a63e16b3351b8c36; });
$parcel$export(module.exports, "FetchError", function () { return $c9708da15d484e9c$export$26e841bcf1aeb894; });
$parcel$export(module.exports, "SegmentEventTypes", function () { return $c9708da15d484e9c$export$ddf929981dc6feb3; });
$parcel$export(module.exports, "MetadataResponse", function () { return $c9708da15d484e9c$export$4b1a5e5486cc0d80; });
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", function () { return $c9708da15d484e9c$export$96f086dcf574a9e2; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
class $c9708da15d484e9c$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $c9708da15d484e9c$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
let $c9708da15d484e9c$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $c9708da15d484e9c$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $c9708da15d484e9c$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $c9708da15d484e9c$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
        return new $c9708da15d484e9c$export$4b1a5e5486cc0d80((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
    }
}
class $c9708da15d484e9c$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $c9708da15d484e9c$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("1cpFH", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $0dfad34845ce173c$export$9175ce0e1c95daf2; });
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", function () { return $0dfad34845ce173c$export$8fddcd1eff390364; });
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", function () { return $0dfad34845ce173c$export$92ed669a3d41dad3; });
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", function () { return $0dfad34845ce173c$export$6649d5c857717efe; });
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", function () { return $0dfad34845ce173c$export$33e7628d3b2c0e2; });
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", function () { return $0dfad34845ce173c$export$6f1c008dd0c3b67e; });
const $0dfad34845ce173c$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $0dfad34845ce173c$export$8fddcd1eff390364 = 60000; // 60 seconds
const $0dfad34845ce173c$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $0dfad34845ce173c$export$6649d5c857717efe = 5000; // 5 seconds
const $0dfad34845ce173c$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $0dfad34845ce173c$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("b7UVb", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", function () { return $819c8088c8505e8e$export$ba118f9de1e5ac63; });
const $819c8088c8505e8e$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("dpT7Z", function(module, exports) {
$parcel$export(module.exports, "sendEvents", function () { return $9c485f692e55f7ab$export$8e8f0180c1b41fad; });

var $hMyHv = parcelRequire("hMyHv");

var $dWJ7u = parcelRequire("dWJ7u");

var $hig21 = parcelRequire("hig21");
function $9c485f692e55f7ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c485f692e55f7ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c485f692e55f7ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c485f692e55f7ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9c485f692e55f7ab$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $9c485f692e55f7ab$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $9c485f692e55f7ab$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $9c485f692e55f7ab$var$_objectSpread({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status !== 200) throw new (0, $hig21.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch (_unused) {}
    throw new (0, $hig21.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $9c485f692e55f7ab$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $9c485f692e55f7ab$var$getCorsForUrl = (0, $dWJ7u.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("dWJ7u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a273b100aa408519$export$2e2bcd8739ae039; });
var $a273b100aa408519$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $a273b100aa408519$var$isEqual(first, second) {
    if (first === second) return true;
    if ($a273b100aa408519$var$safeIsNaN(first) && $a273b100aa408519$var$safeIsNaN(second)) return true;
    return false;
}
function $a273b100aa408519$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$a273b100aa408519$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $a273b100aa408519$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $a273b100aa408519$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("2PIJg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $21030a7087b4c38b$export$2e2bcd8739ae039; });

var $fKnsg = parcelRequire("fKnsg");

var $1tdwU = parcelRequire("1tdwU");
var $7pdQP = parcelRequire("7pdQP");

var $hOfru = parcelRequire("hOfru");

var $78X8a = parcelRequire("78X8a");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $21030a7087b4c38b$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $21030a7087b4c38b$var$SAFE = 'SAFE';
const $21030a7087b4c38b$var$UNSAFE = 'UNSAFE';
const $21030a7087b4c38b$var$NOT_FOUND = 'NOT_FOUND';
const $21030a7087b4c38b$var$COOKIE = 'COOKIE';
const $21030a7087b4c38b$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $21030a7087b4c38b$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $hOfru.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $7pdQP.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $1tdwU.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $1tdwU.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $21030a7087b4c38b$var$LOCAL_STORAGE ? this.store.getItem((0, $1tdwU.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $1tdwU.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $21030a7087b4c38b$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $21030a7087b4c38b$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (_unused) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $21030a7087b4c38b$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($21030a7087b4c38b$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $fKnsg.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $21030a7087b4c38b$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $21030a7087b4c38b$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $21030a7087b4c38b$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $21030a7087b4c38b$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($21030a7087b4c38b$var$COOKIE);
        switch(cookieValue.type){
            case $21030a7087b4c38b$var$SAFE:
            case $21030a7087b4c38b$var$UNSAFE:
                this.store.setItem((0, $1tdwU.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $21030a7087b4c38b$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $78X8a.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("fKnsg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b76d58904d605afa$export$2e2bcd8739ae039; });

var $kJyUx = parcelRequire("kJyUx");

var $lcreU = parcelRequire("lcreU");

var $8byRP = parcelRequire("8byRP");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $b76d58904d605afa$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $b76d58904d605afa$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $8byRP.default)(2, arguments);
    var dateLeft = (0, $kJyUx.default)(dirtyDateLeft);
    var dateRight = (0, $kJyUx.default)(dirtyDateRight);
    var sign = $b76d58904d605afa$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $lcreU.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($b76d58904d605afa$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("kJyUx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f18317374e5db530$export$2e2bcd8739ae039; });

var $bvF5V = parcelRequire("bvF5V");

var $8byRP = parcelRequire("8byRP");
function $f18317374e5db530$export$2e2bcd8739ae039(argument) {
    (0, $8byRP.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $bvF5V.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("8byRP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f5a65bbaf568b06$export$2e2bcd8739ae039; });
function $5f5a65bbaf568b06$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("lcreU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6efd9257232a273$export$2e2bcd8739ae039; });

var $hd0BB = parcelRequire("hd0BB");

var $jDGef = parcelRequire("jDGef");

var $8byRP = parcelRequire("8byRP");
var $f6efd9257232a273$var$MILLISECONDS_IN_DAY = 86400000;
function $f6efd9257232a273$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $8byRP.default)(2, arguments);
    var startOfDayLeft = (0, $jDGef.default)(dirtyDateLeft);
    var startOfDayRight = (0, $jDGef.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $hd0BB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $hd0BB.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f6efd9257232a273$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("hd0BB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8741ecde8abeae8$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $c8741ecde8abeae8$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("jDGef", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e4c26a934ec0ffd1$export$2e2bcd8739ae039; });

var $kJyUx = parcelRequire("kJyUx");

var $8byRP = parcelRequire("8byRP");
function $e4c26a934ec0ffd1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $8byRP.default)(1, arguments);
    var date = (0, $kJyUx.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("1tdwU", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", function () { return $1122fe9cd7426aa5$export$202d555a5dbfd90c; });
$parcel$export(module.exports, "AllAnalyticsCookies", function () { return $1122fe9cd7426aa5$export$d4cb17942ea57c95; });
let $1122fe9cd7426aa5$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $1122fe9cd7426aa5$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $1122fe9cd7426aa5$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $1122fe9cd7426aa5$export$d4cb17942ea57c95 = {
    [$1122fe9cd7426aa5$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $1122fe9cd7426aa5$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $1122fe9cd7426aa5$var$isSecure(),
        path: '/'
    }),
    [$1122fe9cd7426aa5$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $1122fe9cd7426aa5$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $1122fe9cd7426aa5$var$isSecure(),
        path: '/'
    }),
    [$1122fe9cd7426aa5$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $1122fe9cd7426aa5$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $1122fe9cd7426aa5$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("7pdQP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $56459cbd4eb74cb9$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $jvqm6 = parcelRequire("jvqm6");

var $1tdwU = parcelRequire("1tdwU");

var $5a2uu = parcelRequire("5a2uu");

var $i8h8B = parcelRequire("i8h8B");
function $56459cbd4eb74cb9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56459cbd4eb74cb9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56459cbd4eb74cb9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56459cbd4eb74cb9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $56459cbd4eb74cb9$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $i8h8B.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($jvqm6))) : new (0, $5a2uu.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $1tdwU.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $1tdwU.AllAnalyticsCookies)[name].getKey(), value, $56459cbd4eb74cb9$var$_objectSpread($56459cbd4eb74cb9$var$_objectSpread({}, (0, $1tdwU.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $i8h8B.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $1tdwU.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $1tdwU.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $1tdwU.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $1tdwU.AllAnalyticsCookies)[name].getKey(), $56459cbd4eb74cb9$var$_objectSpread({}, options));
    }
}

});
parcelRegister("jvqm6", function(module, exports) {
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("5a2uu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3c1fd18ee37beb93$export$2e2bcd8739ae039; });

var $hOfru = parcelRequire("hOfru");
class $3c1fd18ee37beb93$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $hOfru.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("hOfru", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf7315b25a9644d2$export$2e2bcd8739ae039; });

var $jmONi = parcelRequire("jmONi");

var $b1Vgl = parcelRequire("b1Vgl");
class $cf7315b25a9644d2$export$2e2bcd8739ae039 extends (0, $b1Vgl.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.localStorage || (0, $jmONi.default);
        } catch (err) {
            storageToUse = (0, $jmONi.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("jmONi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e197790eeb77bf15$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");
class $e197790eeb77bf15$export$90e3e001bcac59c7 {
    constructor(){
        (0, $hMyHv.default)(this, "_data", {});
        (0, $hMyHv.default)(this, "length", 0);
        (0, $hMyHv.default)(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, $hMyHv.default)(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, $hMyHv.default)(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, $hMyHv.default)(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, $hMyHv.default)(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $e197790eeb77bf15$var$inmemorystorage = new $e197790eeb77bf15$export$90e3e001bcac59c7();
var $e197790eeb77bf15$export$2e2bcd8739ae039 = $e197790eeb77bf15$var$inmemorystorage;

});

parcelRegister("b1Vgl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $807c34e1b8939799$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $wetcE = parcelRequire("wetcE");

var $jmONi = parcelRequire("jmONi");
const $807c34e1b8939799$export$41c06fdd37b7e9a5 = 'awc';
const $807c34e1b8939799$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $807c34e1b8939799$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $807c34e1b8939799$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, $hMyHv.default)(this, "getStore", ()=>this._store);
        (0, $hMyHv.default)(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, $hMyHv.default)(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, $hMyHv.default)(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        });
        (0, $hMyHv.default)(this, "swapToInMemory", ()=>{
            if (this._store === (0, $jmONi.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($807c34e1b8939799$export$48c17662a6902497(globalThis[$807c34e1b8939799$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$807c34e1b8939799$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $jmONi.default);
                if (!globalThis[$807c34e1b8939799$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$807c34e1b8939799$export$770aa8bc07b3de03] = (0, $jmONi.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, $hMyHv.default)(this, "clear", ()=>this._store.clear());
        (0, $hMyHv.default)(this, "key", (index)=>this._store.key(index));
        (0, $hMyHv.default)(this, "getPrefix", ()=>this._prefix);
        (0, $hMyHv.default)(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($807c34e1b8939799$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $wetcE.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($807c34e1b8939799$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("i8h8B", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", function () { return $d33644909524d59e$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $d33644909524d59e$export$de6821eed3d5f32d; });

var $jvqm6 = parcelRequire("jvqm6");

var $dWJ7u = parcelRequire("dWJ7u");

var $1tdwU = parcelRequire("1tdwU");
const $d33644909524d59e$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $d33644909524d59e$export$eb80e1beaa8dacf8 = (0, $1tdwU.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $d33644909524d59e$export$19164982d36535d8 = 'tld_test';
const $d33644909524d59e$export$de6821eed3d5f32d = (0, $dWJ7u.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($jvqm6))).set($d33644909524d59e$export$eb80e1beaa8dacf8, $d33644909524d59e$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jvqm6))).get($d33644909524d59e$export$eb80e1beaa8dacf8) === $d33644909524d59e$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jvqm6))).remove($d33644909524d59e$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("7rtn8", function(module, exports) {
$parcel$export(module.exports, "buildContext", function () { return $56b1d6b4f490f596$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventContext", function () { return $56b1d6b4f490f596$export$6b26e26d40264200; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $56b1d6b4f490f596$export$44d22e5fb02cc68e; });

var $hMyHv = parcelRequire("hMyHv");

var $lvCVB = parcelRequire("lvCVB");
function $56b1d6b4f490f596$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56b1d6b4f490f596$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56b1d6b4f490f596$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56b1d6b4f490f596$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $56b1d6b4f490f596$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = $56b1d6b4f490f596$var$_objectSpread($56b1d6b4f490f596$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides !== null && overrides !== void 0 && overrides.excludedProperties) result.excludedProperties = $56b1d6b4f490f596$var$_objectSpread($56b1d6b4f490f596$var$_objectSpread({}, result.excludedProperties), $56b1d6b4f490f596$var$nestedRemoveUndefinedValues(overrides.excludedProperties, '$.excludedProperties'));
    if (overrides !== null && overrides !== void 0 && overrides.userConsents) result.userConsents = $56b1d6b4f490f596$var$_objectSpread($56b1d6b4f490f596$var$_objectSpread({}, result.userConsents), $56b1d6b4f490f596$var$nestedRemoveUndefinedValues(overrides.userConsents, '$.userConsents'));
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $56b1d6b4f490f596$var$removeFalseyProperties(result.excludedProperties);
    return result;
};
const $56b1d6b4f490f596$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = $56b1d6b4f490f596$var$nestedRemoveUndefinedValues(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($lvCVB)))(propertiesWithoutUndefined);
};
const $56b1d6b4f490f596$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $56b1d6b4f490f596$var$nestedRemoveUndefinedValues(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lvCVB)))(propertiesWithoutUndefined);
};
// Shallow removal of all falsey properties from an object, returning a new object.
const $56b1d6b4f490f596$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
// This function will essentially deepClone as well
const $56b1d6b4f490f596$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});
parcelRegister("lvCVB", function(module, exports) {
'use strict';

var $kBr0S = parcelRequire("kBr0S");
/**
 * Expose `traverse`.
 */ module.exports = $fa8ab081e51e57db$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $fa8ab081e51e57db$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $fa8ab081e51e57db$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $fa8ab081e51e57db$var$traverseArray(input, strict);
    else if ($kBr0S.is(input, strict)) return $kBr0S.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $fa8ab081e51e57db$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $fa8ab081e51e57db$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $fa8ab081e51e57db$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $fa8ab081e51e57db$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("kBr0S", function(module, exports) {
$parcel$export(module.exports, "parse", function () { return $effc3795864ab33a$export$98e6a39c04603d36; }, function (v) { return $effc3795864ab33a$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $effc3795864ab33a$export$226b3eccf92c9ed9; }, function (v) { return $effc3795864ab33a$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $effc3795864ab33a$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $effc3795864ab33a$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $effc3795864ab33a$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$effc3795864ab33a$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $effc3795864ab33a$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$effc3795864ab33a$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $effc3795864ab33a$var$matcher.test(string);
};

});




parcelRegister("gZDdI", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", function () { return $c5f0c4277394733a$export$1ac223ae496131c9; });

var $hMyHv = parcelRequire("hMyHv");

var $76OmR = parcelRequire("76OmR");

var $j0cUv = parcelRequire("j0cUv");

var $bdOMa = parcelRequire("bdOMa");
var $aJ8H1 = parcelRequire("aJ8H1");

var $02RqU = parcelRequire("02RqU");

var $4z0qw = parcelRequire("4z0qw");

var $EBaXY = parcelRequire("EBaXY");

var $1cpFH = parcelRequire("1cpFH");

var $ekyYq = parcelRequire("ekyYq");

var $hig21 = parcelRequire("hig21");
var $c5f0c4277394733a$var$_MetadataClient;
function $c5f0c4277394733a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5f0c4277394733a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5f0c4277394733a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5f0c4277394733a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $c5f0c4277394733a$export$1ac223ae496131c9 {
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $4z0qw.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $1cpFH.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $1cpFH.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $bdOMa.default)($c5f0c4277394733a$var$_objectSpread($c5f0c4277394733a$var$_objectSpread({}, this._options), {}, {
            waitInterval: (0, $1cpFH.DEFAULT_METADATA_REFRESH_INTERVAL)
        }), this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $c5f0c4277394733a$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this$_fetchAbortCont;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $76OmR.default)((status)=>{
            if (status === (0, $02RqU.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this$_fetchAbortCont2;
        if ((0, $EBaXY.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $ekyYq.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $1cpFH.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $hig21.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $hig21.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $hig21.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this$_userInfo, _this$_userInfo2;
        if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this$_tenantInfo, _this$_tenantInfo2;
        if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this$_networkStatus;
        if (((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $02RqU.NetworkStatusEnum).OFFLINE) {
            done((0, $aJ8H1.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $aJ8H1.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (_unused) {
            done((0, $aJ8H1.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $1cpFH.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $j0cUv.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $j0cUv.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $j0cUv.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $j0cUv.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}
$c5f0c4277394733a$var$_MetadataClient = $c5f0c4277394733a$export$1ac223ae496131c9;
(0, $hMyHv.default)($c5f0c4277394733a$export$1ac223ae496131c9, "INITIAL_REFRESH_DELAY", 1);
(0, $hMyHv.default)($c5f0c4277394733a$export$1ac223ae496131c9, "Factory", (apiHostProtocol, apiHost, product)=>{
    return new $c5f0c4277394733a$var$_MetadataClient(apiHostProtocol, apiHost, product);
});

});
parcelRegister("4z0qw", function(module, exports) {
$parcel$export(module.exports, "selectHost", function () { return $352ac30d507c226b$export$18c0b81944902eae; });
$parcel$export(module.exports, "isStargateProxyPath", function () { return $352ac30d507c226b$export$83a9dd8d74be72c; });

var $wetcE = parcelRequire("wetcE");
const $352ac30d507c226b$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $352ac30d507c226b$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $352ac30d507c226b$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $352ac30d507c226b$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $352ac30d507c226b$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $352ac30d507c226b$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $352ac30d507c226b$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $352ac30d507c226b$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $352ac30d507c226b$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
 * Returns the full Stargate proxy URL (host + proxy path) for the current host.
 *
 * This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
 * and Oasis IC environments. Using the first-party proxy works around browser
 * restrictions with third-party cookies.
 *
 * In non-browser environments (e.g. SSR) where `window` is not defined, the host
 * portion is omitted and the function returns only `STARGATE_PROXY_PATH`
 * (i.e. `/gateway/api/gasv3/api/v1`).
 */ function $352ac30d507c226b$var$stargateProxyUrl() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $352ac30d507c226b$export$5df9262e102d0c32;
}
const $352ac30d507c226b$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $wetcE.envType).LOCAL || env === (0, $wetcE.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $wetcE.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $wetcE.envType).PROD ? $352ac30d507c226b$var$FEDRAMP_PROD_HOST : $352ac30d507c226b$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $wetcE.envType).PROD ? $352ac30d507c226b$var$STARGATE_FEDRAMP_PROD_HOST : $352ac30d507c226b$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $352ac30d507c226b$var$stargateProxyUrl();
};
const $352ac30d507c226b$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $wetcE.envType).PROD ? $352ac30d507c226b$var$PROD_HOST : $352ac30d507c226b$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $wetcE.envType).PROD ? $352ac30d507c226b$var$STARGATE_PROD_HOST : $352ac30d507c226b$var$STARGATE_STAGING_HOST;
    return $352ac30d507c226b$var$stargateProxyUrl();
};
function $352ac30d507c226b$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $352ac30d507c226b$var$stargateProxyUrl();
    }
    if (perimeter === (0, $wetcE.perimeterType).FEDRAMP_MODERATE) return $352ac30d507c226b$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $352ac30d507c226b$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $352ac30d507c226b$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === $352ac30d507c226b$var$stargateProxyUrl();
}

});

parcelRegister("EBaXY", function(module, exports) {
$parcel$export(module.exports, "TestSupport", function () { return $07a092e56f31e1ef$export$44b578549c42d779; });

var $hMyHv = parcelRequire("hMyHv");
class $07a092e56f31e1ef$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($07a092e56f31e1ef$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($07a092e56f31e1ef$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($07a092e56f31e1ef$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($07a092e56f31e1ef$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}
(0, $hMyHv.default)($07a092e56f31e1ef$export$44b578549c42d779, "DISABLE_METADATA_CALLS_PROPERTY", '__awc_disable_metadata_calls__');
(0, $hMyHv.default)($07a092e56f31e1ef$export$44b578549c42d779, "DISABLE_EVENT_CALLS_PROPERTY", '__awc_disable_event_calls__');
(0, $hMyHv.default)($07a092e56f31e1ef$export$44b578549c42d779, "DISABLE_FETCH_CALLS_PROPERTY", '__awc_disable_fetch_calls__');
(0, $hMyHv.default)($07a092e56f31e1ef$export$44b578549c42d779, "SYNTHETIC_FLAG_OVERRIDE_PROPERTY", '__awc_synthetic_flag_override__');

});

parcelRegister("ekyYq", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", function () { return $a6ee0ff76f8c08c9$export$55b0d0261469055; });

var $hMyHv = parcelRequire("hMyHv");

var $dWJ7u = parcelRequire("dWJ7u");

var $hig21 = parcelRequire("hig21");
function $a6ee0ff76f8c08c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a6ee0ff76f8c08c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a6ee0ff76f8c08c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a6ee0ff76f8c08c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a6ee0ff76f8c08c9$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
    const requestAbortController = $a6ee0ff76f8c08c9$var$createRequestAbortController(timeout, signal);
    const corsOptions = $a6ee0ff76f8c08c9$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''}`,
        userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''}`,
        tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''}`,
        tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ''}`
    }).toString();
    const response = await fetch(metadataUrl, $a6ee0ff76f8c08c9$var$_objectSpread({
        method: 'GET',
        signal: requestAbortController.signal
    }, corsOptions));
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $hig21.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $a6ee0ff76f8c08c9$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $a6ee0ff76f8c08c9$var$getCorsForUrl = (0, $dWJ7u.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("eSFJR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad567c4ae851fdc2$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $wetcE = parcelRequire("wetcE");

var $8yyrG = parcelRequire("8yyrG");
class $ad567c4ae851fdc2$export$2e2bcd8739ae039 {
    constructor(){
        (0, $hMyHv.default)(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $wetcE.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $8yyrG.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});

parcelRegister("hAB65", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cce2932c76d3fe05$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $hOfru = parcelRequire("hOfru");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $cce2932c76d3fe05$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $cce2932c76d3fe05$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $cce2932c76d3fe05$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $cce2932c76d3fe05$export$285f6bddd927a06d = 1800000; // 30 minutes
const $cce2932c76d3fe05$export$a92e915d70316eb2 = 5000; // 5 seconds
const $cce2932c76d3fe05$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $cce2932c76d3fe05$export$5702a91a6f42969f = ()=>{};
class $cce2932c76d3fe05$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, $hMyHv.default)(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($cce2932c76d3fe05$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, $hMyHv.default)(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($cce2932c76d3fe05$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, $hMyHv.default)(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $cce2932c76d3fe05$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $cce2932c76d3fe05$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $cce2932c76d3fe05$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $cce2932c76d3fe05$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $hOfru.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($cce2932c76d3fe05$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($cce2932c76d3fe05$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$cce2932c76d3fe05$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("jny5S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1ba9ca4fa392e5b$export$2e2bcd8739ae039; });

var $jmONi = parcelRequire("jmONi");

var $b1Vgl = parcelRequire("b1Vgl");
class $e1ba9ca4fa392e5b$export$2e2bcd8739ae039 extends (0, $b1Vgl.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.sessionStorage || (0, $jmONi.default);
        } catch (err) {
            storageToUse = (0, $jmONi.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("hRDV8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d0165a4817ec60e7$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $jny5S = parcelRequire("jny5S");

var $78X8a = parcelRequire("78X8a");
const $d0165a4817ec60e7$var$STORAGE_KEY = 'tab.id';
class $d0165a4817ec60e7$export$2e2bcd8739ae039 {
    constructor(){
        (0, $hMyHv.default)(this, "_generateNewTabId", ()=>{
            const newTabId = (0, $78X8a.default)();
            this._safeSessionStorage.setItem($d0165a4817ec60e7$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $jny5S.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($d0165a4817ec60e7$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("eB8ma", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aa0b00cc97b1f58e$export$2e2bcd8739ae039; });

var $hMyHv = parcelRequire("hMyHv");

var $9NAYc = parcelRequire("9NAYc");

var $wetcE = parcelRequire("wetcE");

var $hoQGK = parcelRequire("hoQGK");

var $jny5S = parcelRequire("jny5S");

var $8yyrG = parcelRequire("8yyrG");

var $78X8a = parcelRequire("78X8a");
function $aa0b00cc97b1f58e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa0b00cc97b1f58e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa0b00cc97b1f58e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa0b00cc97b1f58e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $aa0b00cc97b1f58e$var$STORAGE_KEY = 'taskSessions';
const $aa0b00cc97b1f58e$var$INIT_KEY = 'taskSessionsInit';
const $aa0b00cc97b1f58e$var$AWC_PARAM_PREFIX = 'awc.';
const $aa0b00cc97b1f58e$var$TASK_SESSION_RELOAD_TIME = 3000;
class $aa0b00cc97b1f58e$export$2e2bcd8739ae039 {
    constructor(){
        (0, $hMyHv.default)(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($aa0b00cc97b1f58e$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($aa0b00cc97b1f58e$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($aa0b00cc97b1f58e$var$INIT_KEY) || '0', 10) < currentTimestamp - $aa0b00cc97b1f58e$var$TASK_SESSION_RELOAD_TIME);
        (0, $hMyHv.default)(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($aa0b00cc97b1f58e$var$AWC_PARAM_PREFIX)[1]);
        (0, $hMyHv.default)(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($aa0b00cc97b1f58e$var$AWC_PARAM_PREFIX));
        (0, $hMyHv.default)(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($aa0b00cc97b1f58e$var$STORAGE_KEY) || '');
            } catch (_unused) {
                return {};
            }
        });
        (0, $hMyHv.default)(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($aa0b00cc97b1f58e$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (_unused2) {}
        });
        (0, $hMyHv.default)(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, $hMyHv.default)(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, $hMyHv.default)(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, $78X8a.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, $hMyHv.default)(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, $hMyHv.default)(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, $hMyHv.default)(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $9NAYc.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $hoQGK.pick)(currentState, includedTaskSessions) : (0, $hoQGK.omit)(currentState, Object.values((0, $wetcE.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $aa0b00cc97b1f58e$var$_objectSpread($aa0b00cc97b1f58e$var$_objectSpread({}, (0, $hoQGK.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$aa0b00cc97b1f58e$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $9NAYc.stringify)(queryWithTaskSessions)}`;
        });
        (0, $hMyHv.default)(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $hoQGK.mapKeys)((0, $8yyrG.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $jny5S.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($aa0b00cc97b1f58e$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (_unused3) {}
    }
}

});

parcelRegister("jERzP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e4fb4ffd3c62f40a$export$2e2bcd8739ae039; });

var $jvqm6 = parcelRequire("jvqm6");

var $1tdwU = parcelRequire("1tdwU");

var $EBaXY = parcelRequire("EBaXY");
const $e4fb4ffd3c62f40a$var$MAX_CACHE_SIZE = 100;
const $e4fb4ffd3c62f40a$var$COOKIE_NAME = (0, $1tdwU.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $e4fb4ffd3c62f40a$var$DEBUG_TAG = 'synthetic';
class $e4fb4ffd3c62f40a$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $e4fb4ffd3c62f40a$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch (_unused) {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch (_unused2) {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $e4fb4ffd3c62f40a$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($e4fb4ffd3c62f40a$var$DEBUG_TAG)) event.tags.push($e4fb4ffd3c62f40a$var$DEBUG_TAG);
        } else event.tags = [
            $e4fb4ffd3c62f40a$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $EBaXY.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($jvqm6))).get($e4fb4ffd3c62f40a$var$COOKIE_NAME) || 'false') === true;
        } catch (_unused3) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jvqm6))).remove($e4fb4ffd3c62f40a$var$COOKIE_NAME);
        }
        return false;
    }
}
var $e4fb4ffd3c62f40a$export$2e2bcd8739ae039 = $e4fb4ffd3c62f40a$var$TestingCache;

});

parcelRegister("2UmDY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $21e26053b1dce85f$export$2e2bcd8739ae039; });

var $5P3bh = parcelRequire("5P3bh");

var $hMyHv = parcelRequire("hMyHv");

var $wetcE = parcelRequire("wetcE");

var $jFs3v = parcelRequire("jFs3v");

var $hOfru = parcelRequire("hOfru");
const $21e26053b1dce85f$var$_excluded = [
    "embeddedProduct"
];
function $21e26053b1dce85f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21e26053b1dce85f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21e26053b1dce85f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hMyHv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21e26053b1dce85f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $21e26053b1dce85f$var$DEFAULT_DELAY = 2000; // 2 seconds
const $21e26053b1dce85f$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $21e26053b1dce85f$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $21e26053b1dce85f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $21e26053b1dce85f$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($21e26053b1dce85f$var$SendEventDecision || {});
class $21e26053b1dce85f$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, $hMyHv.default)(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, $hMyHv.default)(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, $hMyHv.default)(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, $hMyHv.default)(this, "signalUserActive", ()=>{
            this._sendUserActiveEvents();
        });
        (0, $hMyHv.default)(this, "_bindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        });
        (0, $hMyHv.default)(this, "_unbindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        });
        (0, $hMyHv.default)(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        });
        (0, $hMyHv.default)(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, $hMyHv.default)(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, $hMyHv.default)(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, $hMyHv.default)(this, "_parseLocalStorageData", (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (_unused) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        });
        (0, $hMyHv.default)(this, "_getMalformedLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, $hMyHv.default)(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, $hMyHv.default)(this, "_setMalformedLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        });
        (0, $hMyHv.default)(this, "_handleDwellTimerTriggered", ()=>{
            const document = (0, $jFs3v.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        });
        (0, $hMyHv.default)(this, "_sendUserActiveEvents", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, $5P3bh.default)(_this$_getContext, $21e26053b1dce85f$var$_excluded);
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, $hMyHv.default)(this, "_sendEvent", (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case $21e26053b1dce85f$var$SendEventDecision.EligibleToSend:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case $21e26053b1dce85f$var$SendEventDecision.UserOrTenantIncomplete:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        });
        (0, $hMyHv.default)(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $wetcE.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return $21e26053b1dce85f$var$SendEventDecision.UserOrTenantIncomplete;
                return $21e26053b1dce85f$var$SendEventDecision.MalformedUiViewedRateLimited;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return $21e26053b1dce85f$var$SendEventDecision.EligibleToSend;
            return $21e26053b1dce85f$var$SendEventDecision.UiViewedRateLimited;
        });
        (0, $hMyHv.default)(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $21e26053b1dce85f$var$_objectSpread($21e26053b1dce85f$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $21e26053b1dce85f$var$_objectSpread($21e26053b1dce85f$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $21e26053b1dce85f$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $21e26053b1dce85f$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $21e26053b1dce85f$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $21e26053b1dce85f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $hOfru.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("jFs3v", function(module, exports) {
$parcel$export(module.exports, "getDocument", function () { return $e5179be811ca5f2c$export$f65ca476c09acec0; });
const $e5179be811ca5f2c$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("e9Kpz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4e5e84ffbaec309$export$2e2bcd8739ae039; });
function $a4e5e84ffbaec309$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("dTDvO", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", function () { return $a1df0fafd91dd6de$export$fbe53bbbe682bcdd; });

var $hVkpe = parcelRequire("hVkpe");
const $a1df0fafd91dd6de$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $hVkpe.createTimeoutXid)()), (0, $hVkpe.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $hVkpe.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("hVkpe", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", function () { return $d0c796c2980ba3c1$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $d0c796c2980ba3c1$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $d0c796c2980ba3c1$export$fa341d0c750d705b; });

var $4t1Ed = parcelRequire("4t1Ed");
const $d0c796c2980ba3c1$export$545bcbd53afabfa3 = 5000;
const $d0c796c2980ba3c1$export$af4087e36d63846 = ()=>[
        {
            type: (0, $4t1Ed.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $4t1Ed.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $d0c796c2980ba3c1$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $4t1Ed.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $4t1Ed.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("4t1Ed", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", function () { return $340b26112c807c05$export$92ca0438bcb0d396; });
let $340b26112c807c05$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $340b26112c807c05$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("gx3aw", function(module, exports) {
$parcel$export(module.exports, "Cookie", function () { return $a4d5b6036faa8a22$export$bd0cf18531183c14; });
class $a4d5b6036faa8a22$export$bd0cf18531183c14 {
    static getCookieUrl(cookieName, defaultUrl) {
        const cookieUrl = $a4d5b6036faa8a22$export$bd0cf18531183c14.readCookie(cookieName);
        if (cookieUrl !== null) return cookieUrl;
        return defaultUrl;
    }
    static readCookie(name, requestCookie) {
        try {
            const nameEQ = name + '=';
            const ca = (requestCookie || document.cookie).split(';');
            for (let c of ca){
                while(c.startsWith(' '))c = c.substring(1, c.length);
                if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length);
            }
        } catch (e) {
            // Helpers.sendWrapperLoadError uses this method to get some context
            // for the reported error, so we don't want to call that here, otherwise
            // we would get stuck in an infinite loop
            // Missing login_user_detected cookie is expected for logged out users, so no need to log it.
            if (name !== 'login_user_detected') console.warn(`Error reading cookie - ${name}`, e);
        }
        return null;
    }
    static writeCookie(name, value, days, topLevelDomain) {
        const seconds = days ? days * 86400 : null;
        $a4d5b6036faa8a22$export$bd0cf18531183c14.writeCookieInSeconds(name, value, seconds, topLevelDomain);
    }
    static writeCookieInSeconds(name, value, seconds, topLevelDomain) {
        try {
            let expires = '';
            if (seconds) {
                const date = new Date();
                date.setTime(date.getTime() + seconds * 1000);
                expires = '; expires=' + date.toUTCString();
            }
            let cookie = name + '=' + value + expires + '; path=/;';
            let domain = window.location.hostname;
            if (domain !== 'localhost' && topLevelDomain) {
                const domainTokens = domain.split('.');
                if (domainTokens.length > 2) {
                    const lastToken = domainTokens[domainTokens.length - 1];
                    const secondLastToken = domainTokens[domainTokens.length - 2];
                    if (isNaN(Number(lastToken)) || isNaN(Number(secondLastToken))) domain = '.' + secondLastToken + '.' + lastToken;
                } else if (domainTokens.length === 2) domain = '.' + domain;
                cookie += ' domain=' + domain + ';';
            }
            document.cookie = cookie;
        } catch (e) {
            console.warn(`Error writing cookie - ${name}`, e);
        }
    }
}

});


parcelRegister("gLm0b", function(module, exports) {
$parcel$export(module.exports, "extractOptanonConsentCookie", function () { return $ff178efaceb69336$export$29027ffe85b122de; });
$parcel$export(module.exports, "isPerformanceOnetrustEnabled", function () { return $ff178efaceb69336$export$f31515c886c1288b; });
$parcel$export(module.exports, "useOneTrustContext", function () { return $ff178efaceb69336$export$b224af886b957a5e; });
$parcel$export(module.exports, "OneTrustProvider", function () { return $ff178efaceb69336$export$52310512b1bd7aec; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");
const $ff178efaceb69336$var$isCPRA = (locationData)=>{
    const country = locationData?.countryIsoCode?.toUpperCase();
    const state = locationData?.regionIsoCode?.toUpperCase();
    return country === 'US' && state === 'CA';
};
const $ff178efaceb69336$export$29027ffe85b122de = (cookieString)=>{
    if (!cookieString) return undefined;
    const cookies = (0, $yhhhl.parse)(cookieString);
    return cookies['OptanonConsent'];
};
const $ff178efaceb69336$export$f31515c886c1288b = (optanonConsentCookie, locationData)=>{
    if (optanonConsentCookie === null || optanonConsentCookie === undefined) {
        if ($ff178efaceb69336$var$isCPRA(locationData)) return false;
        return true;
    }
    const params = new URLSearchParams(optanonConsentCookie);
    const groups = params.get('groups');
    if (groups === null) return true;
    const groupPairs = groups.split(',');
    return groupPairs.includes('2:1');
};
const $ff178efaceb69336$var$OneTrustContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    analyticsOptOut: true,
    isConsentLoaded: false
});
const $ff178efaceb69336$export$b224af886b957a5e = ()=>{
    const context = (0, $1oC0p.useContext)($ff178efaceb69336$var$OneTrustContext);
    if (!context) throw new Error('calls to useOneTrustContext must be wrapped in <OneTrustProvider>');
    return context;
};
const $ff178efaceb69336$export$52310512b1bd7aec = ({ children: children, isUniformPlayground: isUniformPlayground = false })=>{
    // In Uniform Playground (preview authoring environment) we skip OneTrust entirely
    // and assume all cookies are accepted so the consent banner does not interrupt authors.
    const [analyticsOptOut, setAnalyticsOptOut] = (0, $1oC0p.useState)(!!!isUniformPlayground);
    // check if onetrust consent is loaded to GTM data layer
    const [isConsentLoaded, setIsConsentLoaded] = (0, $1oC0p.useState)(isUniformPlayground);
    (0, $1oC0p.useEffect)(()=>{
        // Skip OneTrust polling entirely in Uniform Playground — banner should never appear for authors.
        if (isUniformPlayground) return;
        const checkOnetrustActiveGroups = ()=>{
            if (window.OnetrustActiveGroups === undefined) return;
            const currentAnalyticsOptOut = !window.OnetrustActiveGroups.includes(',2,');
            if (analyticsOptOut !== currentAnalyticsOptOut) setAnalyticsOptOut(currentAnalyticsOptOut);
            /**
       * Clear the interval once the OneTrust has been initialized and only recheck every 1 sec if the optout status is still the default (true).
       */ clearInterval(setIntervalId);
            if (currentAnalyticsOptOut) setIntervalId = setInterval(checkOnetrustActiveGroups, 1000);
        };
        let setIntervalId = setInterval(checkOnetrustActiveGroups, 250);
        return ()=>{
            clearInterval(setIntervalId);
        };
    }, [
        analyticsOptOut,
        isUniformPlayground
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // Skip data layer monitoring in Uniform Playground — consent is already assumed.
        if (isUniformPlayground) return;
        // Monitor data layer for consent update events
        const checkDataLayerForConsentUpdates = ()=>{
            if (!window.dataLayer) return;
            const dataLayer = window.dataLayer;
            for (const event of dataLayer){
                // Check for OneTrust consent update events which are arrays like
                if (event && event[0] && event[1]) {
                    if (event[0] === 'consent' && event[1] === 'update') {
                        setIsConsentLoaded(true);
                        clearInterval(dataLayerIntervalId);
                    }
                }
            }
        };
        // Check data layer for consent updates every 250ms
        const dataLayerIntervalId = setInterval(checkDataLayerForConsentUpdates, 250);
        return ()=>{
            clearInterval(dataLayerIntervalId);
        };
    }, [
        isConsentLoaded,
        isUniformPlayground
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($ff178efaceb69336$var$OneTrustContext.Provider, {
        value: {
            analyticsOptOut: analyticsOptOut,
            isConsentLoaded: isConsentLoaded
        },
        children: children
    });
};

});

parcelRegister("6r14Z", function(module, exports) {
$parcel$export(module.exports, "canonicalPathForHref", function () { return $2b5d36aae06250ff$export$2e5c4f2abb256e11; });
$parcel$export(module.exports, "getCanonicalBaseUrl", function () { return $2b5d36aae06250ff$export$f8a4a419027a7160; });
const $2b5d36aae06250ff$var$ATLASSIAN_CANONICAL_BASE = 'https://www.atlassian.com';
const $2b5d36aae06250ff$export$fc907882dfa46986 = 'https://www.sourcetreeapp.com';
const $2b5d36aae06250ff$export$2762387d1fe92df = 'https://bitbucket.org';
const $2b5d36aae06250ff$var$SOURCETREEAPP_MARKER = 'sourcetreeapp';
const $2b5d36aae06250ff$var$BITBUCKET_PATH_MARKER = 'bitbucketapp';
const $2b5d36aae06250ff$var$SUPPORTED_LOCALES = new Set([
    'br',
    'de',
    'en',
    'es',
    'fr',
    'it',
    'ja',
    'ko',
    'nl',
    'pl',
    'ru',
    'xx',
    'zh',
    'zz'
]);
function $2b5d36aae06250ff$var$hostnameContainsSourcetreeApp(hostname) {
    return hostname.toLowerCase().includes($2b5d36aae06250ff$var$SOURCETREEAPP_MARKER);
}
function $2b5d36aae06250ff$var$hostnameContainsBitbucket(hostname) {
    return hostname.toLowerCase().includes('bitbucket');
}
/**
 * Parsed route path (no leading slash), e.g. `sourcetreeapp` for `/sourcetreeapp`
 * or `ja/sourcetreeapp` for localized URLs.
 */ function $2b5d36aae06250ff$var$pathContainsSourcetreeApp(pathWithoutLeadingSlash) {
    return pathWithoutLeadingSlash.toLowerCase().includes($2b5d36aae06250ff$var$SOURCETREEAPP_MARKER);
}
/**
 * Returns true when `bitbucketapp` is the first path segment, or the second
 * segment after a supported locale prefix (e.g. `ja/bitbucketapp/product`).
 *
 * Paths like `software/bitbucketapp/pricing` return false because
 * `bitbucketapp` is not in the leading position.
 */ function $2b5d36aae06250ff$var$isBitbucketAppPath(pathWithoutLeadingSlash) {
    const segments = pathWithoutLeadingSlash.toLowerCase().split('/').filter((s)=>s.length > 0);
    const first = segments[0];
    const second = segments[1];
    if (first === undefined) return false;
    if (first === $2b5d36aae06250ff$var$BITBUCKET_PATH_MARKER) return true;
    if (second !== undefined && $2b5d36aae06250ff$var$SUPPORTED_LOCALES.has(first) && second === $2b5d36aae06250ff$var$BITBUCKET_PATH_MARKER) return true;
    return false;
}
function $2b5d36aae06250ff$var$stripSourcetreeAppPathSegments(segmentPath) {
    return segmentPath.split('/').filter((segment)=>segment.length > 0 && segment.toLowerCase() !== $2b5d36aae06250ff$var$SOURCETREEAPP_MARKER).join('/');
}
function $2b5d36aae06250ff$var$stripBitbucketPathSegments(segmentPath) {
    return segmentPath.split('/').filter((segment)=>segment.length > 0 && segment.toLowerCase() !== $2b5d36aae06250ff$var$BITBUCKET_PATH_MARKER).join('/');
}
function $2b5d36aae06250ff$export$2e5c4f2abb256e11(canonicalBaseUrl, segmentPath) {
    if (segmentPath === undefined || segmentPath === '') return undefined;
    if (canonicalBaseUrl === $2b5d36aae06250ff$export$fc907882dfa46986) return $2b5d36aae06250ff$var$stripSourcetreeAppPathSegments(segmentPath);
    if (canonicalBaseUrl === $2b5d36aae06250ff$export$2762387d1fe92df) return $2b5d36aae06250ff$var$stripBitbucketPathSegments(segmentPath);
    return segmentPath;
}
function $2b5d36aae06250ff$export$1d282c5a66e70e9d(canonicalBaseUrl, segmentPath) {
    if (segmentPath === undefined) return undefined;
    const rest = $2b5d36aae06250ff$export$2e5c4f2abb256e11(canonicalBaseUrl, segmentPath);
    if (rest === undefined) return undefined;
    return rest === '' ? canonicalBaseUrl : `${canonicalBaseUrl}/${rest}`;
}
function $2b5d36aae06250ff$export$f8a4a419027a7160(hostname, pathWithoutLeadingSlash) {
    if (hostname && $2b5d36aae06250ff$var$hostnameContainsSourcetreeApp(hostname)) return $2b5d36aae06250ff$export$fc907882dfa46986;
    if (pathWithoutLeadingSlash && $2b5d36aae06250ff$var$pathContainsSourcetreeApp(pathWithoutLeadingSlash)) return $2b5d36aae06250ff$export$fc907882dfa46986;
    if (hostname && $2b5d36aae06250ff$var$hostnameContainsBitbucket(hostname)) return $2b5d36aae06250ff$export$2762387d1fe92df;
    if (pathWithoutLeadingSlash && $2b5d36aae06250ff$var$isBitbucketAppPath(pathWithoutLeadingSlash)) return $2b5d36aae06250ff$export$2762387d1fe92df;
    return $2b5d36aae06250ff$var$ATLASSIAN_CANONICAL_BASE;
}

});

parcelRegister("hgaI1", function(module, exports) {
$parcel$export(module.exports, "TARGET_APP", function () { return $404a7964d8952fbc$export$5a16cf6d9176400b; });
$parcel$export(module.exports, "initializeFeatureGatesClient", function () { return $404a7964d8952fbc$export$933af3c61da21c8d; });
$parcel$export(module.exports, "updateFeatureGatesClientWithUserIdentifiers", function () { return $404a7964d8952fbc$export$d9ae7fa24aec8e06; });
$parcel$export(module.exports, "useUpdateFeatureGatesClientWithTenantId", function () { return $404a7964d8952fbc$export$2502765481599a5c; });

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $eY3N6 = parcelRequire("eY3N6");

var $3L8ZR = parcelRequire("3L8ZR");
var $gJrsj = parcelRequire("gJrsj");

var $fKfE1 = parcelRequire("fKfE1");

var $4X0dO = parcelRequire("4X0dO");

var $ai3ZP = parcelRequire("ai3ZP");

var $gx3aw = parcelRequire("gx3aw");

var $9JVlg = parcelRequire("9JVlg");
const $404a7964d8952fbc$export$5a16cf6d9176400b = 'bxp-web-platform_web';
const $404a7964d8952fbc$var$getEnvironment = ()=>{
    return (0, $gJrsj.FeatureGateEnvironment).Production;
};
const $404a7964d8952fbc$export$b8dcf00f0f359b67 = (experiments, targetName)=>{
    for(const key in experiments){
        if (experiments[key] && experiments[key].experimentName === targetName) return experiments[key];
    }
    return null;
};
const $404a7964d8952fbc$export$44d6d69ba7841b6d = (featureFlags, targetName)=>{
    for(const key in featureFlags){
        if (featureFlags[key] && featureFlags[key].featureFlagName === targetName) return featureFlags[key];
    }
    return null;
};
const $404a7964d8952fbc$export$933af3c61da21c8d = async (bootstrapValues, options = {
    overrideValues: {
        experimentOverrides: {},
        featureGateOverrides: {}
    }
})=>{
    const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
    if (!isStatic) {
        await (0, $3L8ZR.default).initializeFromValues({
            ...options,
            environment: $404a7964d8952fbc$var$getEnvironment(),
            targetApp: $404a7964d8952fbc$export$5a16cf6d9176400b,
            sdkKey: bootstrapValues.clientSdkKey,
            eventLoggingApi: 'https://xp.atlassian.com/v1/'
        }, bootstrapValues.identifiers, bootstrapValues.customAttributes, bootstrapValues.experimentValues);
        const overrideValues = options['overrideValues'];
        if (overrideValues && (overrideValues.experimentOverrides && Object.keys(overrideValues.experimentOverrides).length > 0 || overrideValues.featureGateOverrides && Object.keys(overrideValues.featureGateOverrides).length > 0)) {
            const overrideConfig = {
                configs: {},
                gates: {}
            };
            for (const experimentName of Object.keys(overrideValues.experimentOverrides)){
                const experiment = $404a7964d8952fbc$export$b8dcf00f0f359b67((0, $4X0dO.experiments), experimentName);
                if (!experiment) {
                    console.warn(`Experiment ${experimentName} not found`);
                    continue;
                }
                const { defaultValue: defaultValue, parameterName: parameterName } = experiment;
                const overrideValue = overrideValues.experimentOverrides[experimentName][parameterName];
                // Validate that experimentOverrideValue is a valid parameter
                if (typeof overrideValue === typeof defaultValue) overrideConfig.configs[experimentName] = overrideValues.experimentOverrides[experimentName];
                else console.warn(`Expected type ${typeof defaultValue} for experiment ${experimentName}, but received ${typeof overrideValue} ${overrideValue}. Attempted override will be skipped`);
            }
            const featureGateOverrides = overrideValues['featureGateOverrides'];
            for (const featureFlagName of Object.keys(featureGateOverrides)){
                const featureFlag = $404a7964d8952fbc$export$44d6d69ba7841b6d((0, $ai3ZP.featureFlags), featureFlagName);
                if (!featureFlag) {
                    console.warn(`Feature flag ${featureFlagName} not found`);
                    continue;
                }
                const overrideValue = featureGateOverrides[featureFlagName];
                if (typeof overrideValue === 'boolean') overrideConfig.gates[featureFlagName] = overrideValue;
                else console.warn(`Expected boolean for feature flag ${featureFlagName}, but received ${typeof overrideValue} ${overrideValue}. Attempted override will be skipped`);
            }
            (0, $3L8ZR.default).setOverrides(overrideConfig);
        } else (0, $3L8ZR.default).setOverrides({
            configs: {},
            gates: {}
        });
    } else {
        /**
     * Client side initialization of FeatureGates.
     * On the browser, get values from cookies as request headers are not available.
     * If values don't exist in the cookie, create and set them in the cookie.
     *  This is mainly for new users landing for the first time.
     **/ if (!(0, $6GqRO.default).get((0, $9JVlg.ANALYTICS_ANONYMOUS_ID_COOKIE_KEY))) (0, $gx3aw.Cookie).writeCookie((0, $9JVlg.ANALYTICS_ANONYMOUS_ID_COOKIE_KEY), `%22${bootstrapValues.identifiers.analyticsAnonymousId}%22`, 3650, true);
        if (!(0, $gx3aw.Cookie).readCookie((0, $fKfE1.ATL_COHORT))) (0, $fKfE1.Cohort).writeAtlCohort({
            bucketAll: (0, $fKfE1.Cohort).createBucket('bucketAll')
        });
        const identifiers = {
            analyticsAnonymousId: decodeURIComponent((0, $6GqRO.default).get((0, $9JVlg.ANALYTICS_ANONYMOUS_ID_COOKIE_KEY)) || '').replace(/['"]+/g, ''),
            atlassianAccountId: (0, $6GqRO.default).get((0, $9JVlg.ATLASSIAN_ACCOUNT_ID_COOKIE_KEY))
        };
        const customAttributes = (0, $9JVlg.getCustomAttributes)({
            headers: {
                'user-agent': window.navigator.userAgent,
                cookieOverride: JSON.stringify({
                    [(0, $fKfE1.ATL_COHORT)]: (0, $gx3aw.Cookie).readCookie((0, $fKfE1.ATL_COHORT)),
                    'cloud.session.token': (0, $6GqRO.default).get('cloud.session.token'),
                    'cloud.session.token.stg': (0, $6GqRO.default).get('cloud.session.token.stg')
                })
            }
        });
        await (0, $3L8ZR.default).initialize({
            ...options,
            environment: $404a7964d8952fbc$var$getEnvironment(),
            targetApp: $404a7964d8952fbc$export$5a16cf6d9176400b,
            apiKey: "4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f",
            eventLoggingApi: 'https://xp.atlassian.com/v1/'
        }, identifiers, customAttributes);
    }
};
const $404a7964d8952fbc$export$d9ae7fa24aec8e06 = async (bootstrapValues, updatedIdentifiers)=>{
    return (0, $3L8ZR.default).updateUser(// @ts-ignore
    {
        environment: $404a7964d8952fbc$var$getEnvironment(),
        targetApp: $404a7964d8952fbc$export$5a16cf6d9176400b,
        apiKey: "4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f"
    }, {
        ...bootstrapValues.identifiers,
        ...updatedIdentifiers
    }, bootstrapValues.customAttributes);
};
const $404a7964d8952fbc$export$2502765481599a5c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (0, $1oC0p.useCallback)(async ({ cloudId: cloudId })=>{
        if (typeof window !== 'undefined' && window.featureGateBootstrapValues && cloudId) try {
            await $404a7964d8952fbc$export$d9ae7fa24aec8e06(window.featureGateBootstrapValues, {
                tenantId: cloudId
            });
        } catch (error) {
            createAnalyticsEvent({
                action: 'failed',
                actionSubject: 'TenantAwareStatsigClientUpdaterProvider.updateStatsigClient',
                eventType: 'operational',
                attributes: {
                    error: error instanceof Error ? error.message : ''
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("6GqRO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ddb8183072e9b02$export$2e2bcd8739ae039; });
/*! js-cookie v3.0.5 | MIT */ /* eslint-disable no-var */ function $4ddb8183072e9b02$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)target[key] = source[key];
    }
    return target;
}
/* eslint-enable no-var */ /* eslint-disable no-var */ var $4ddb8183072e9b02$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
/* eslint-enable no-var */ /* eslint-disable no-var */ function $4ddb8183072e9b02$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $4ddb8183072e9b02$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (e) {}
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $4ddb8183072e9b02$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $4ddb8183072e9b02$var$init(this.converter, $4ddb8183072e9b02$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $4ddb8183072e9b02$var$init($4ddb8183072e9b02$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $4ddb8183072e9b02$export$2e2bcd8739ae039 = $4ddb8183072e9b02$var$init($4ddb8183072e9b02$var$defaultConverter, {
    path: '/'
});

});

parcelRegister("eY3N6", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $ae599c176b0e6483$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $loByL = parcelRequire("loByL");

var $e1T86 = parcelRequire("e1T86");
function $ae599c176b0e6483$export$5bf35293e545f20c() {
    var analyticsContext = (0, $e1T86.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $loByL.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("hcVab", function(module, exports) {
$parcel$export(module.exports, "useCallbackOne", function () { return $c86fe6178ca3fdce$export$33752cf3ee811995; });

var $1oC0p = parcelRequire("1oC0p");
function $c86fe6178ca3fdce$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $c86fe6178ca3fdce$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $1oC0p.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $1oC0p.useRef)(true);
    var committed = (0, $1oC0p.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $c86fe6178ca3fdce$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $1oC0p.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $c86fe6178ca3fdce$export$33752cf3ee811995(callback, inputs) {
    return $c86fe6178ca3fdce$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $c86fe6178ca3fdce$export$1538c33de8887b59 = $c86fe6178ca3fdce$export$b6feb8998cd9b342;
var $c86fe6178ca3fdce$export$35808ee640e87ca7 = $c86fe6178ca3fdce$export$33752cf3ee811995;

});

parcelRegister("loByL", function(module, exports) {
$parcel$export(module.exports, "isUIAnalyticsEvent", function () { return $f938f9762a812290$export$35f8383928ba8d7; });
$parcel$export(module.exports, "default", function () { return $f938f9762a812290$export$2e2bcd8739ae039; });

var $9GFoj = parcelRequire("9GFoj");

var $1itsa = parcelRequire("1itsa");

var $4A0Tr = parcelRequire("4A0Tr");

var $i1kpm = parcelRequire("i1kpm");

var $9C5uk = parcelRequire("9C5uk");

var $jfDAi = parcelRequire("jfDAi");

var $djanu = parcelRequire("djanu");

var $gc1Dl = parcelRequire("gc1Dl");

var $9c1Qf = parcelRequire("9c1Qf");

var $kbqWF = parcelRequire("kbqWF");
function $f938f9762a812290$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f938f9762a812290$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $gc1Dl.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gc1Dl.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $djanu.default)(this, result);
    };
}
function $f938f9762a812290$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $f938f9762a812290$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f938f9762a812290$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $f938f9762a812290$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, $jfDAi.default)(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $f938f9762a812290$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $1itsa.default)(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "_isUIAnalyticsEvent", true);
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $9GFoj.default)(_this.context);
            var handlers = (0, $9GFoj.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, $i1kpm.default)(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $4A0Tr.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, $9C5uk.default)((0, $gc1Dl.default)(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $kbqWF.default));

});
parcelRegister("9GFoj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70d824bbd3f69570$export$2e2bcd8739ae039; });

var $89nax = parcelRequire("89nax");

var $l0J2O = parcelRequire("l0J2O");

var $i3pJy = parcelRequire("i3pJy");

var $ddvRn = parcelRequire("ddvRn");
function $70d824bbd3f69570$export$2e2bcd8739ae039(r) {
    return (0, $89nax.default)(r) || (0, $l0J2O.default)(r) || (0, $i3pJy.default)(r) || (0, $ddvRn.default)();
}

});
parcelRegister("89nax", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ef122da035a8c54$export$2e2bcd8739ae039; });

var $9jWp5 = parcelRequire("9jWp5");
function $5ef122da035a8c54$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9jWp5.default)(r);
}

});
parcelRegister("9jWp5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6c933124d3e857ec$export$2e2bcd8739ae039; });
function $6c933124d3e857ec$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("l0J2O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f4bc89ea7f097c38$export$2e2bcd8739ae039; });
function $f4bc89ea7f097c38$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("i3pJy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d24c7802fc0bdd5e$export$2e2bcd8739ae039; });

var $9jWp5 = parcelRequire("9jWp5");
function $d24c7802fc0bdd5e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9jWp5.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9jWp5.default)(r, a) : void 0;
    }
}

});

parcelRegister("ddvRn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $99f533fb09ab9016$export$2e2bcd8739ae039; });
function $99f533fb09ab9016$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1itsa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f1e51b1558afd20$export$2e2bcd8739ae039; });
function $0f1e51b1558afd20$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("4A0Tr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $355b37947803cc63$export$2e2bcd8739ae039; });

var $hENF4 = parcelRequire("hENF4");
function $355b37947803cc63$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $hENF4.default)(o.key), o);
    }
}
function $355b37947803cc63$export$2e2bcd8739ae039(e, r, t) {
    return r && $355b37947803cc63$var$_defineProperties(e.prototype, r), t && $355b37947803cc63$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("hENF4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cdacb1d5841c7143$export$2e2bcd8739ae039; });

var $6vNM7 = parcelRequire("6vNM7");

var $j1VoU = parcelRequire("j1VoU");
function $cdacb1d5841c7143$export$2e2bcd8739ae039(t) {
    var i = (0, $j1VoU.default)(t, "string");
    return "symbol" == (0, $6vNM7.default)(i) ? i : i + "";
}

});
parcelRegister("6vNM7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4bdc3f9a70a6fa9c$export$2e2bcd8739ae039; });
function $4bdc3f9a70a6fa9c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $4bdc3f9a70a6fa9c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4bdc3f9a70a6fa9c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("j1VoU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ddaaa2eeb9e46a6e$export$2e2bcd8739ae039; });

var $6vNM7 = parcelRequire("6vNM7");
function $ddaaa2eeb9e46a6e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6vNM7.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6vNM7.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("i1kpm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1e8269aa0d8f2fb$export$2e2bcd8739ae039; });
function $d1e8269aa0d8f2fb$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("9C5uk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6ffbeb8246f6148d$export$2e2bcd8739ae039; });

var $bhRt8 = parcelRequire("bhRt8");
function $6ffbeb8246f6148d$export$2e2bcd8739ae039() {
    return $6ffbeb8246f6148d$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $bhRt8.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $6ffbeb8246f6148d$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("bhRt8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $837ac20943d12abe$export$2e2bcd8739ae039; });

var $gc1Dl = parcelRequire("gc1Dl");
function $837ac20943d12abe$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $gc1Dl.default)(t)););
    return t;
}

});
parcelRegister("gc1Dl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc9f08b49ee6c7f3$export$2e2bcd8739ae039; });
function $bc9f08b49ee6c7f3$export$2e2bcd8739ae039(t) {
    return $bc9f08b49ee6c7f3$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $bc9f08b49ee6c7f3$export$2e2bcd8739ae039(t);
}

});



parcelRegister("jfDAi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e03e1faf45b9be0e$export$2e2bcd8739ae039; });

var $2H1JU = parcelRequire("2H1JU");
function $e03e1faf45b9be0e$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $2H1JU.default)(t, e);
}

});
parcelRegister("2H1JU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f60f259e6dadc56$export$2e2bcd8739ae039; });
function $1f60f259e6dadc56$export$2e2bcd8739ae039(t, e) {
    return $1f60f259e6dadc56$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $1f60f259e6dadc56$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("djanu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b05198f8d19dbc9$export$2e2bcd8739ae039; });

var $6vNM7 = parcelRequire("6vNM7");

var $i1kpm = parcelRequire("i1kpm");
function $9b05198f8d19dbc9$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $6vNM7.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $i1kpm.default)(t);
}

});

parcelRegister("9c1Qf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b16a9c7e4845bbf$export$2e2bcd8739ae039; });

var $hENF4 = parcelRequire("hENF4");
function $6b16a9c7e4845bbf$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $hENF4.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("kbqWF", function(module, exports) {
$parcel$export(module.exports, "isAnalyticsEvent", function () { return $eb19bc7d5055c093$export$ad4be5c2ec28cecf; });
$parcel$export(module.exports, "default", function () { return $eb19bc7d5055c093$export$2e2bcd8739ae039; });

var $6vNM7 = parcelRequire("6vNM7");

var $1itsa = parcelRequire("1itsa");

var $4A0Tr = parcelRequire("4A0Tr");

var $9c1Qf = parcelRequire("9c1Qf");
function $eb19bc7d5055c093$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eb19bc7d5055c093$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eb19bc7d5055c093$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $9c1Qf.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eb19bc7d5055c093$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $eb19bc7d5055c093$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $eb19bc7d5055c093$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $eb19bc7d5055c093$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $1itsa.default)(this, AnalyticsEvent);
        (0, $9c1Qf.default)(this, "_isAnalyticsEvent", true);
        (0, $9c1Qf.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $eb19bc7d5055c093$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, $4A0Tr.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $6vNM7.default)(updater) === 'object') this.payload = $eb19bc7d5055c093$var$_objectSpread($eb19bc7d5055c093$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("e1T86", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $a36bec4445a6d125$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $a36bec4445a6d125$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});
parcelRegister("bEiDG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $87b1e379a6f311f5$export$2e2bcd8739ae039; });

var $enBKk = parcelRequire("enBKk");
var $87b1e379a6f311f5$export$2e2bcd8739ae039 = (0, $enBKk.default);

});
parcelRegister("enBKk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a7807e4867f5f5c0$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $a7807e4867f5f5c0$var$AnalyticsNextContext = (0, $1oC0p.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $a7807e4867f5f5c0$export$2e2bcd8739ae039 = $a7807e4867f5f5c0$var$AnalyticsNextContext;

});




parcelRegister("fKfE1", function(module, exports) {
$parcel$export(module.exports, "ATL_COHORT", function () { return $9a2c9714e688fe53$export$69c4df819eb57a1b; });
$parcel$export(module.exports, "Cohort", function () { return $9a2c9714e688fe53$export$b76685d1b5a37732; });
/**
 * @typedef {object} Cohort
 * @property {string} ATL_COHORT The cookie name
 * @property {object | null} readWriteAtlCohort The cohort object or null
 * @property {object | null} readAtlCohort The cohort object or null
 */ 
var $gx3aw = parcelRequire("gx3aw");

var $7NStU = parcelRequire("7NStU");

var $i0bD5 = parcelRequire("i0bD5");
const $9a2c9714e688fe53$export$69c4df819eb57a1b = 'atlCohort';
const $9a2c9714e688fe53$export$d2bea30496ddbdeb = '2';
const $9a2c9714e688fe53$export$d28e176424fc1872 = [
    'index',
    'bucketedAtUTC',
    'version',
    'bucketId'
];
const $9a2c9714e688fe53$var$cohortBuckets = {
    bucketAll: {
        bucketId: 0
    }
};
class $9a2c9714e688fe53$export$b76685d1b5a37732 {
    /*
      Hypothetical way to add other buckets (adding their name to the types above):
          if (isMobileDevice()) {
             cohortBuckets.bucket_mobile = {
                 bucketId: 1
             };
         }
          if (isEnglishSpeaking()) {
             cohortBuckets.bucket_english = {};
         }
          function isMobileDevice() {
             // some logic here...
             return true;
         }
     
         function isEnglishSpeaking() {
             // some logic here...
             return false;
         }
     */ /**
   * Tries to read the ATL_COHORT cookie and return it
   * @function readAtlCohort
   * @return {object | null} the cohort object or null
   */ static readAtlCohort() {
        const atlCohortCookie = (0, $gx3aw.Cookie).readCookie($9a2c9714e688fe53$export$69c4df819eb57a1b);
        try {
            const decodedCookie = atlCohortCookie ? decodeURIComponent(atlCohortCookie) : null;
            const atlCohort = decodedCookie ? JSON.parse(decodedCookie) : null;
            if (!(0, $i0bD5.Helpers).isObject(atlCohort)) return null;
            if (atlCohortCookie && atlCohortCookie !== decodedCookie) $9a2c9714e688fe53$export$b76685d1b5a37732.writeAtlCohort(atlCohort);
            return atlCohort;
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error reading ALT_COHORT Cookie');
            return null;
        }
    }
    /**
   * Writes the stringified `atlCohort` object to the `ATL_COHORT` cookie
   * @function writeAtlCohort
   * @ignore
   * @param {object} atlCohort the cohort object
   */ static writeAtlCohort(atlCohort) {
        if ((0, $i0bD5.Helpers).isObject(atlCohort)) (0, $gx3aw.Cookie).writeCookie($9a2c9714e688fe53$export$69c4df819eb57a1b, JSON.stringify(atlCohort), 3650, true);
    }
    /**
   * Checks to see if a bucket is in the `atlCohort` object and returns `true` if it does and `false` if it does not
   * @function bucketExists
   * @ignore
   * @param  {BucketName} key a bucket key
   * @param  {Partial<AtlCohort>} atlCohort the cohort object
   * @return {boolean} whether or not a bucket is in the cohort object
   */ static bucketExists(key, atlCohort) {
        if ((0, $i0bD5.Helpers).isObject(atlCohort)) {
            const bucket = atlCohort[key];
            if (bucket && (0, $i0bD5.Helpers).isObject(bucket)) return $9a2c9714e688fe53$export$d28e176424fc1872.every((bucketAttribute)=>typeof bucket[bucketAttribute] !== 'undefined');
        }
        return false;
    }
    /**
   * Takes a `bucketKey` and returns and object with `index` and `bucketedAtUTC` properties and optional attribute properties
   * @function createBucket
   * @ignore
   * @param  {string} bucketKey
   * @param  {string} [anonymousIdOverride] optional pre-read anonymousId (e.g. from SSR request cookies),
   *                  used to avoid falling back to Math.random() when document.cookie is unavailable
   * @return {object} a bucket object
   */ static createBucket(bucketKey, anonymousIdOverride) {
        const bucketAttributes = $9a2c9714e688fe53$var$cohortBuckets[bucketKey];
        const anonymousId = anonymousIdOverride ?? (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id');
        const strippedAnonymousId = decodeURIComponent(anonymousId || '').replace(/"/g, '');
        const bucket = {
            bucketedAtUTC: new Date().toISOString(),
            version: $9a2c9714e688fe53$export$d2bea30496ddbdeb,
            index: strippedAnonymousId ? (0, $7NStU.Guid).guidHashCode((0, $7NStU.Guid).addNumberToGUID(strippedAnonymousId, bucketAttributes.bucketId)) % 100 : Math.ceil(Math.random() * 100),
            bucketId: bucketAttributes.bucketId
        };
        return bucket;
    }
    /**
   * Reads `ATL_COHORT` cookie and if there are any missing buckets, it adds them and writes them to the cookie. Returns the `atlCohort` object
   * @function readWriteAtlCohort
   * @param {boolean} writeOverride when present, trigger a cohort rewrite
   * @return {object | null} the cohort object or null
   */ static readWriteAtlCohort(writeOverride) {
        // if overriding the cohort, do not read the existing cohort; set to empty to force a write
        const atlCohort = writeOverride ? {} : $9a2c9714e688fe53$export$b76685d1b5a37732.readAtlCohort() || {};
        const missingBuckets = Object.keys($9a2c9714e688fe53$var$cohortBuckets).filter((bucket)=>!$9a2c9714e688fe53$export$b76685d1b5a37732.bucketExists(bucket, atlCohort));
        if (missingBuckets.length) {
            missingBuckets.forEach((missingBucket)=>atlCohort[missingBucket] = $9a2c9714e688fe53$export$b76685d1b5a37732.createBucket(missingBucket));
            $9a2c9714e688fe53$export$b76685d1b5a37732.writeAtlCohort(atlCohort);
        }
        return atlCohort;
    }
}

});
parcelRegister("7NStU", function(module, exports) {
$parcel$export(module.exports, "Guid", function () { return $dd3e9cd4c4c332af$export$f6d5d4774149a3bf; });

var $fuLgT = parcelRequire("fuLgT");

var $i0bD5 = parcelRequire("i0bD5");

var $danx7 = parcelRequire("danx7");
class $dd3e9cd4c4c332af$export$f6d5d4774149a3bf {
    static guid() {
        try {
            return (0, $fuLgT.default)();
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error getting uuidV4');
            return (0, $danx7.mathGuid)();
        }
    }
    static guidNoDashes() {
        return (0, $fuLgT.default)().replace(/-/g, '');
    }
    /**
   * Convert a GUID deterministically based on the passed in number
   * @param guid - guid to convert
   * @param number - a number to modify the guid by
   * @returns the modified guid or the original in case of failure
   */ static addNumberToGUID(guid, number) {
        // take the last 4 digits and convert to a hex string representation
        let hex = guid.slice(-4);
        let value = parseInt(hex, 16);
        if (isNaN(value)) return guid;
        const valLength = value.toString(16).length;
        value += number;
        // clamp to 2 bytes
        if (value > 65535) value -= 65536;
        else if (value < 0) value += 65536;
        // convert back to hex and make sure its as long as many digits as the initial value
        // This is needed for subtraction
        hex = value.toString(16);
        if (hex.length < valLength) hex = ('00000' + hex).slice(-valLength);
        // replace the last 4 digits of the guid with the last 4 digits of the converted value
        return guid.slice(0, guid.length - hex.length) + hex;
    }
    // guidHashCode takes in a String and returns a Number
    // e.g. "51c96b99-f1b0-4727-9802-a40c096929ae" => 411024693
    static guidHashCode(guid) {
        let hash = 0;
        for(let i = 0; i < guid.length; i++){
            hash += Math.pow(guid.charCodeAt(i) * 31, guid.length - i);
            hash = hash & hash; // Convert to 32bit integer
        }
        return Math.abs(hash);
    }
}

});
parcelRegister("i0bD5", function(module, exports) {
$parcel$export(module.exports, "Helpers", function () { return $d42d788de91ef703$export$4dc2b60021baefca; });

var $btgvr = parcelRequire("btgvr");

var $2gCne = parcelRequire("2gCne");

var $gx3aw = parcelRequire("gx3aw");

var $cYY9z = parcelRequire("cYY9z");

var $9bczE = parcelRequire("9bczE");
// This regex is the simplified RFC 5322 expression from http://www.regular-expressions.info/email.html with added %40 for encoded urls
const $d42d788de91ef703$var$EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*[@(%40)](?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
const $d42d788de91ef703$var$PATH_OVERRIDE = '/path-contained-email-address';
const $d42d788de91ef703$var$CROSS_DOMAIN_UTM_EXPIRY = 3600000; // 1hr in ms
class $d42d788de91ef703$export$4dc2b60021baefca {
    /**
   * Attempts to send an HTTP request.
   * @function makeRestRequest
   * @param {string} method the request method
   * @param {string} url the request URL
   * @param {Object[]} headers an array of headers to set in the request
   * @param {string} body the body of the request
   * @param {boolean} credentials whether to send request with credentials; defaults to false
   * @param {callback} callback optional callback function
   * @param {object} mockReq used in testing so we don't actually send a request
   */ static makeRestRequest(method, url, headers, body, credentials, callback, mockReq) {
        const xhr = mockReq || new XMLHttpRequest();
        xhr.open(method, url);
        xhr.withCredentials = credentials ? credentials : false;
        if (!!headers) // set headers
        for (const item of headers)xhr.setRequestHeader(item.header, item.value);
        if (!body) body = null;
        xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    if (callback) callback(xhr.responseText);
                } else if (callback) callback('error');
            }
        };
        xhr.send(body);
    }
    static sendWrapperLoadError(message, data) {
        const anonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id');
        let decodedAnonymousId;
        if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
        decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, '');
        const userId = (0, $gx3aw.Cookie).readCookie('__aid_user_id');
        let decodedUserId;
        if (userId) decodedUserId = decodeURIComponent(userId);
        const xid = (0, $gx3aw.Cookie).readCookie('seg_xid');
        const body = {
            anonymousId: decodedAnonymousId || null,
            userId: decodedUserId || null,
            xid: xid || null,
            message: message || null,
            version: (0, $cYY9z.AnalyticsState).version,
            additionalData: data || null
        };
        const env = "production";
        const url = env === 'production' ? 'https://www.atlassian.com/endpoint/atlglobalload' : 'https://wac.stg.internal.atlassian.com/endpoint/atlglobalload';
        const headers = [
            {
                header: 'Content-type',
                value: 'application/json'
            },
            {
                header: 'accept',
                value: '*/*'
            }
        ];
        $d42d788de91ef703$export$4dc2b60021baefca.makeRestRequest('POST', url, headers, JSON.stringify(body), false);
    }
    static getParameterByName(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(window.location.search);
        const value = results && results.length >= 2 ? results[1] : null;
        return !value ? '' : decodeURIComponent(value.replace(/\+/g, ' '));
    }
    static getLocalMarketingContext() {
        try {
            const localMarketingContext = (0, $2gCne.getLocalStorage)('marketingContext', true);
            const parsedMarketingContext = localMarketingContext && JSON.parse(localMarketingContext) || null;
            return parsedMarketingContext;
        } catch (error) {
            console.error('Failed to parse marketingContext from localStorage:', error);
            return null;
        }
    }
    static getUtmsFromUrl(utms) {
        if (window.location.search.includes('utm_')) {
            for(const utmKey in utms)if (utms.hasOwnProperty(utmKey)) utms[utmKey] = $d42d788de91ef703$export$4dc2b60021baefca.getParameterByName(utmKey);
            return utms;
        }
        return null;
    }
    static newUtmsMatchLocalUtms(urlUtms, localUtms) {
        return urlUtms['utm_sfdc-campaign_id'] === localUtms['sfdcCampaignId'] && urlUtms['utm_campaign'] === localUtms['campaign'] && urlUtms['utm_source'] === localUtms['source'] && urlUtms['utm_medium'] === localUtms['medium'] && urlUtms['utm_content'] === localUtms['content'];
    }
    static getAndSetUtms(utmKeys) {
        const urlUtms = $d42d788de91ef703$export$4dc2b60021baefca.getUtmsFromUrl(utmKeys);
        let anonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id');
        anonymousId = anonymousId && decodeURIComponent(anonymousId).replace(/['"]+/g, '');
        const awcSessionId = (0, $2gCne.getLocalStorage)('awc.session.id', true);
        const domain = window.location.hostname;
        const localMarketingContext = $d42d788de91ef703$export$4dc2b60021baefca.getLocalMarketingContext();
        const nullMarketingContext = JSON.stringify({
            sessionId: awcSessionId,
            domain: domain,
            lastUpdated: awcSessionId,
            utm: {
                sfdcCampaignId: '',
                campaign: '',
                source: '',
                medium: '',
                content: ''
            }
        });
        if (urlUtms) {
            if (!localMarketingContext || localMarketingContext && (awcSessionId !== localMarketingContext.sessionId || !$d42d788de91ef703$export$4dc2b60021baefca.newUtmsMatchLocalUtms(urlUtms, localMarketingContext.utm))) (0, $9bczE.GUPS).setMarketingContext(anonymousId, awcSessionId, domain, urlUtms);
            return urlUtms;
        } else if (localMarketingContext) {
            const localUtms = {
                'utm_sfdc-campaign_id': localMarketingContext.utm.sfdcCampaignId,
                utm_campaign: localMarketingContext.utm.campaign,
                utm_source: localMarketingContext.utm.source,
                utm_medium: localMarketingContext.utm.medium,
                utm_content: localMarketingContext.utm.content
            };
            if (localMarketingContext.sessionId === null) {
                const hasUtms = Object.values(localUtms).some((value)=>value !== '');
                if (hasUtms) (0, $9bczE.GUPS).setMarketingContext(anonymousId, awcSessionId, domain, localUtms);
                else (0, $9bczE.GUPS).getMarketingContext(anonymousId, awcSessionId, domain, awcSessionId, nullMarketingContext);
            } else if (domain === localMarketingContext.domain) {
                if (localMarketingContext.sessionId === awcSessionId) return localUtms;
                else (0, $9bczE.GUPS).getMarketingContext(anonymousId, awcSessionId, domain, localMarketingContext.lastUpdated, nullMarketingContext);
            } else {
                const validCrossDomainUtms = awcSessionId && Number(awcSessionId) - Number(localMarketingContext.lastUpdated) < $d42d788de91ef703$var$CROSS_DOMAIN_UTM_EXPIRY;
                if (validCrossDomainUtms) {
                    // overwrite session.id and domain in marketingContext to enable single domain logic on subsequent data fetches
                    (0, $2gCne.setLocalStorage)('marketingContext', JSON.stringify({
                        sessionId: awcSessionId,
                        domain: domain,
                        lastUpdated: awcSessionId,
                        utm: localMarketingContext.utm
                    }));
                    return localUtms;
                }
            }
        } else (0, $9bczE.GUPS).getMarketingContext(anonymousId, awcSessionId, domain, awcSessionId, nullMarketingContext);
        (0, $2gCne.setLocalStorage)('marketingContext', nullMarketingContext);
        return null;
    }
    // taken from https://github.com/segmentio/canonical/blob/master/lib/index.js
    static canonical() {
        const tags = Array.from(document.getElementsByTagName('link'));
        for (const tag of tags){
            if (tag && tag.getAttribute('rel') === 'canonical') return tag.getAttribute('href');
        }
        return null;
    }
    // taken from https://github.com/segmentio/analytics.js-core/blob/master/lib/pageDefaults.js
    static getCanonicalUrl() {
        const canon = $d42d788de91ef703$export$4dc2b60021baefca.canonical();
        if (canon) return canon;
        const url = window.location.href;
        const i = url.indexOf('#');
        return i === -1 ? url : url.slice(0, i);
    }
    static addActualUrl(obj) {
        if (window.location.href !== $d42d788de91ef703$export$4dc2b60021baefca.getCanonicalUrl()) {
            // respect cleaned url
            if (obj['url']) obj['actualUrl'] = obj['url'];
            else obj['actualUrl'] = $d42d788de91ef703$export$4dc2b60021baefca.maskURL(window.location.href);
        }
    }
    static isObject(o) {
        return o !== null && typeof o === 'object' && Array.isArray(o) === false;
    }
    static urlContainsEmail(url) {
        return Boolean($d42d788de91ef703$var$EMAIL_REGEX.exec(decodeURIComponent(url)));
    }
    // dropping attributes containing email
    static dropEmailQueryParams(obj) {
        const sanitizedObj = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (!$d42d788de91ef703$export$4dc2b60021baefca.urlContainsEmail(value)) sanitizedObj[key] = value;
        });
        return sanitizedObj;
    }
    // mask search terms
    static maskSearchTerms(obj) {
        const sanitizedObj = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (key === 'term' || key === 'q') sanitizedObj[key] = '[REDACTED]';
            else sanitizedObj[key] = value;
        });
        return sanitizedObj;
    }
    // dropping email from the url path
    static dropEmailFromPath(path) {
        let newPath = '';
        if ($d42d788de91ef703$export$4dc2b60021baefca.urlContainsEmail(path)) {
            const pathArray = path.split('/');
            pathArray.forEach(function(value) {
                if (value !== '' && !$d42d788de91ef703$export$4dc2b60021baefca.urlContainsEmail(value)) newPath = newPath + '/' + value;
            });
        }
        return newPath === '' ? path : newPath;
    }
    // convert query params object to query params string
    static convertQueryObjToString(obj) {
        let queryString = new URLSearchParams(obj).toString();
        if (queryString !== '') queryString = '?' + queryString;
        return queryString;
    }
    static emailAddressIsDetected() {
        return $d42d788de91ef703$export$4dc2b60021baefca.urlContainsEmail(window.location.href) || $d42d788de91ef703$export$4dc2b60021baefca.urlContainsEmail(document.referrer);
    }
    static hostnameFromUrl(url) {
        return url.replace(/http(s|):\/\//g, '').split(/(\/|:)/g)[0];
    }
    static addCleanedUrlAndPaths(obj) {
        obj['url'] = window.location.origin + $d42d788de91ef703$var$PATH_OVERRIDE;
        obj['path'] = $d42d788de91ef703$var$PATH_OVERRIDE;
        obj['search'] = '';
        return obj;
    }
    static addCleanedReferrer(obj) {
        obj['referrer'] = $d42d788de91ef703$export$4dc2b60021baefca.urlWithoutPath(document.referrer) + $d42d788de91ef703$var$PATH_OVERRIDE;
        return obj;
    }
    static urlWithoutPath(url) {
        const fakeTag = document.createElement('a');
        fakeTag.href = url;
        return fakeTag.protocol + '//' + fakeTag.host;
    }
    /**
   * Urls containing email address in url path or query params are dropped and
   * search term query params are masked.
   * Search terms (and all UGC) should no longer be tracked.
   */ static maskURL(input) {
        if (input === '' || input === undefined) return input;
        const url = new URL(input);
        let obj = (0, (/*@__PURE__*/$parcel$interopDefault($btgvr))).parse(url.search);
        obj = $d42d788de91ef703$export$4dc2b60021baefca.dropEmailQueryParams(obj);
        if (url.pathname.includes('/search')) obj = $d42d788de91ef703$export$4dc2b60021baefca.maskSearchTerms(obj);
        return url.origin + $d42d788de91ef703$export$4dc2b60021baefca.dropEmailFromPath(url.pathname) + $d42d788de91ef703$export$4dc2b60021baefca.convertQueryObjToString(obj);
    }
}

});
parcelRegister("btgvr", function(module, exports) {
$parcel$export(module.exports, "extract", function () { return $859f34e5154fea5c$export$f9380c9a627682d3; }, function (v) { return $859f34e5154fea5c$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $859f34e5154fea5c$export$98e6a39c04603d36; }, function (v) { return $859f34e5154fea5c$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $859f34e5154fea5c$export$fac44ee5b035f737; }, function (v) { return $859f34e5154fea5c$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $859f34e5154fea5c$export$7a5253c0f62e0150; }, function (v) { return $859f34e5154fea5c$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $859f34e5154fea5c$export$a8c1621ea79325d3; }, function (v) { return $859f34e5154fea5c$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $859f34e5154fea5c$export$357523c63a2253b9; }, function (v) { return $859f34e5154fea5c$export$357523c63a2253b9 = v; });
$parcel$export(module.exports, "exclude", function () { return $859f34e5154fea5c$export$44c361b8ec72ef7f; }, function (v) { return $859f34e5154fea5c$export$44c361b8ec72ef7f = v; });
var $859f34e5154fea5c$export$f9380c9a627682d3;
var $859f34e5154fea5c$export$98e6a39c04603d36;
var $859f34e5154fea5c$export$fac44ee5b035f737;
var $859f34e5154fea5c$export$7a5253c0f62e0150;
var $859f34e5154fea5c$export$a8c1621ea79325d3;
var $859f34e5154fea5c$export$357523c63a2253b9;
var $859f34e5154fea5c$export$44c361b8ec72ef7f;
'use strict';

var $Tgi7x = parcelRequire("Tgi7x");

var $2yLHC = parcelRequire("2yLHC");

var $6rjNb = parcelRequire("6rjNb");

var $gNyr9 = parcelRequire("gNyr9");
const $859f34e5154fea5c$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $859f34e5154fea5c$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $859f34e5154fea5c$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $859f34e5154fea5c$var$encode(key, options),
                            '[',
                            $859f34e5154fea5c$var$encode(index, options),
                            ']=',
                            $859f34e5154fea5c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $859f34e5154fea5c$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $859f34e5154fea5c$var$encode(key, options),
                            '[]=',
                            $859f34e5154fea5c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $859f34e5154fea5c$var$encode(key, options),
                            '=',
                            $859f34e5154fea5c$var$encode(value, options)
                        ].join('')
                    ];
                    return [
                        [
                            result,
                            $859f34e5154fea5c$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $859f34e5154fea5c$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $859f34e5154fea5c$var$encode(key, options),
                            '=',
                            $859f34e5154fea5c$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $859f34e5154fea5c$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $859f34e5154fea5c$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $859f34e5154fea5c$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$859f34e5154fea5c$var$decode(item, options)) : value === null ? value : $859f34e5154fea5c$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $859f34e5154fea5c$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $859f34e5154fea5c$var$encode(value, options) {
    if (options.encode) return options.strict ? $Tgi7x(value) : encodeURIComponent(value);
    return value;
}
function $859f34e5154fea5c$var$decode(value, options) {
    if (options.decode) return $2yLHC(value);
    return value;
}
function $859f34e5154fea5c$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $859f34e5154fea5c$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $859f34e5154fea5c$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $859f34e5154fea5c$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $859f34e5154fea5c$var$extract(input) {
    input = $859f34e5154fea5c$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $859f34e5154fea5c$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $859f34e5154fea5c$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $859f34e5154fea5c$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $859f34e5154fea5c$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $6rjNb(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator'
        ].includes(options.arrayFormat) ? value : $859f34e5154fea5c$var$decode(value, options);
        formatter($859f34e5154fea5c$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $859f34e5154fea5c$var$parseValue(value[k], options);
        else ret[key] = $859f34e5154fea5c$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $859f34e5154fea5c$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$859f34e5154fea5c$export$f9380c9a627682d3 = $859f34e5154fea5c$var$extract;
$859f34e5154fea5c$export$98e6a39c04603d36 = $859f34e5154fea5c$var$parse;
$859f34e5154fea5c$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $859f34e5154fea5c$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $859f34e5154fea5c$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $859f34e5154fea5c$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $859f34e5154fea5c$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join('&');
        return $859f34e5154fea5c$var$encode(key, options) + '=' + $859f34e5154fea5c$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$859f34e5154fea5c$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $6rjNb(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $859f34e5154fea5c$var$parse($859f34e5154fea5c$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $859f34e5154fea5c$var$decode(hash, options)
    } : {});
};
$859f34e5154fea5c$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $859f34e5154fea5c$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $859f34e5154fea5c$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $859f34e5154fea5c$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $859f34e5154fea5c$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $859f34e5154fea5c$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$859f34e5154fea5c$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$859f34e5154fea5c$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $859f34e5154fea5c$export$7a5253c0f62e0150(input, options);
    return $859f34e5154fea5c$export$a8c1621ea79325d3({
        url: url,
        query: $gNyr9(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$859f34e5154fea5c$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $859f34e5154fea5c$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("2gCne", function(module, exports) {
$parcel$export(module.exports, "getLocalStorage", function () { return $320091122b07f63c$export$d3720feff416e85b; });
$parcel$export(module.exports, "removeLocalStorage", function () { return $320091122b07f63c$export$720fb0373088e6ec; });
$parcel$export(module.exports, "setLocalStorage", function () { return $320091122b07f63c$export$1f73f60bdb811cb1; });
/**
 * Test if we have localstorage enabled
 * @returns boolean
 */ const $320091122b07f63c$var$isLocalStorageEnabled = ()=>{
    try {
        // First check if localStorage object is accessible
        // In some environments (iframes, private browsing), accessing window.localStorage
        // itself can throw a SecurityError, so we need to check for existence first
        if (typeof window === 'undefined' || !window) return false;
        // Assign to variable to ensure property access is wrapped in try-catch
        const storage = window.localStorage;
        if (!storage) return false;
        const key = `_storage_test`;
        storage.setItem(key, 'yes');
        storage.removeItem(key);
        return true;
    } catch (e) {
        // SecurityError: Failed to read the 'localStorage' property from 'Window'
        // or QuotaExceededError, etc. All mean localStorage is not available
        return false;
    }
};
/**
 *
 * @param name name of the localstorage
 * @returns string
 */ const $320091122b07f63c$var$defaultExpiry = 3600; // one hour
const $320091122b07f63c$var$expiresKey = '_expiresIn';
const $320091122b07f63c$export$d3720feff416e85b = (name, skipExpiryCheck = false)=>{
    if (!$320091122b07f63c$var$isLocalStorageEnabled()) {
        console.log('Localstorage is not available. Please check if the browser supports localstorage.');
        return null;
    }
    const now = Date.now();
    const expiresIn = parseInt(localStorage.getItem(name + $320091122b07f63c$var$expiresKey) || '0');
    if (expiresIn < now && !skipExpiryCheck) {
        $320091122b07f63c$export$720fb0373088e6ec(name);
        return null;
    } else try {
        const value = localStorage.getItem(name);
        return value;
    } catch (e) {
        console.log(`Error reading ${name} from localstorage ${JSON.stringify(e)}`);
        return null;
    }
};
const $320091122b07f63c$export$1f73f60bdb811cb1 = (name, value, expires = $320091122b07f63c$var$defaultExpiry)=>{
    if (!$320091122b07f63c$var$isLocalStorageEnabled()) {
        console.log('Localstorage is not available. Please check if the browser supports localstorage.');
        return false;
    }
    expires = Math.abs(expires);
    const now = Date.now();
    const schedule = now + expires * 1000;
    try {
        localStorage.setItem(name, value);
        localStorage.setItem(name + $320091122b07f63c$var$expiresKey, schedule.toString());
    } catch (e) {
        console.log(`Error setting ${name} in localstorage ${JSON.stringify(e)}`);
        return false;
    }
    return true;
};
const $320091122b07f63c$export$720fb0373088e6ec = (name)=>{
    if (!$320091122b07f63c$var$isLocalStorageEnabled()) {
        console.log('Localstorage is not available. Please check if the browser supports localstorage.');
        return false;
    }
    try {
        localStorage.removeItem(name);
        localStorage.removeItem(name + $320091122b07f63c$var$expiresKey);
    } catch (e) {
        console.log(`Error removing ${name} in localstorage ${JSON.stringify(e)}`);
        return false;
    }
    return true;
};

});

parcelRegister("cYY9z", function(module, exports) {
$parcel$export(module.exports, "AnalyticsState", function () { return $6bb06fb40e3dc2d1$export$4a20ceb938e79e70; });
class $6bb06fb40e3dc2d1$export$4a20ceb938e79e70 {
    static #_ = this.analyticsOptOut = true;
}

});

parcelRegister("9bczE", function(module, exports) {
$parcel$export(module.exports, "GUPS", function () { return $5ab79df103be8536$export$bf3cce71df5bd3b; });

var $2gCne = parcelRequire("2gCne");

var $cYY9z = parcelRequire("cYY9z");

var $i0bD5 = parcelRequire("i0bD5");
class $5ab79df103be8536$export$bf3cce71df5bd3b {
    static #_ = this.CROSS_DOMAIN_UTM_EXPIRY = 3600000 // 1hr in ms
    ;
    static sendGUPSQuery(headers, body, callback) {
        const gupsEndpoint = 'https://www.atlassian.com/gateway/api/graphql';
        (0, $i0bD5.Helpers).makeRestRequest('POST', gupsEndpoint, headers, body, false, callback);
    }
    static getMarketingContext(anonymousId, sessionId, domain, localLastUpdated, nullMarketingContext) {
        const query = `query getUnifiedProfile($anonymousId: ID) {
            growthUnifiedProfile_getUnifiedProfile(
                anonymousId: $anonymousId
            ){
                marketingContext {
                    sessionId, 
                    domain,
                    lastUpdated,
                    utm {
                        sfdcCampaignId,
                        medium,
                        source,
                        campaign,
                        content
                    }
                }
            }
        }`;
        const variables = {
            anonymousId: anonymousId
        };
        const payload = JSON.stringify({
            query: query,
            variables: variables
        });
        const headers = [
            {
                header: 'Content-type',
                value: 'application/json'
            },
            {
                header: 'x-use-case',
                value: 'voltron-marketing-context'
            }
        ];
        const callback = function(result) {
            if (result === 'error') console.error('Failed request to retrieve marketingContext from GUPS');
            else {
                const parsedResponse = JSON.parse(result);
                const marketingContext = parsedResponse?.data?.growthUnifiedProfile_getUnifiedProfile?.marketingContext;
                let validSameDomainUtms;
                let validCrossDomainUtms;
                if (marketingContext) {
                    validSameDomainUtms = domain === marketingContext.domain && sessionId === marketingContext.sessionId;
                    validCrossDomainUtms = domain !== marketingContext.domain && sessionId && Number(sessionId) - Number(localLastUpdated) < $5ab79df103be8536$export$bf3cce71df5bd3b.CROSS_DOMAIN_UTM_EXPIRY;
                }
                if (validSameDomainUtms || validCrossDomainUtms) {
                    if (validSameDomainUtms) (0, $2gCne.setLocalStorage)('marketingContext', JSON.stringify(marketingContext));
                    else if (validCrossDomainUtms) (0, $2gCne.setLocalStorage)('marketingContext', JSON.stringify({
                        sessionId: sessionId,
                        domain: domain,
                        lastUpdated: sessionId,
                        utm: marketingContext.utm
                    }));
                    const gupsUtms = marketingContext.utm;
                    (0, $cYY9z.AnalyticsState).utms = {
                        'utm_sfdc-campaign_id': gupsUtms.sfdcCampaignId,
                        utm_campaign: gupsUtms.campaign,
                        utm_source: gupsUtms.source,
                        utm_medium: gupsUtms.medium,
                        utm_content: gupsUtms.content
                    };
                } else {
                    (0, $2gCne.setLocalStorage)('marketingContext', nullMarketingContext);
                    (0, $cYY9z.AnalyticsState).utms = null;
                }
            }
        };
        try {
            $5ab79df103be8536$export$bf3cce71df5bd3b.sendGUPSQuery(headers, payload, callback);
        } catch (error) {
            console.error('Failed to retrieve marketingContext from GUPS with error:', error);
        }
    }
    static setMarketingContext(anonymousId, sessionId, domain, utms) {
        const mutation = `mutation SetMarketingContext {
            growthUnifiedProfile_createUnifiedProfile(profile: 
                { 
                    anonymousId: "${anonymousId}", 
                    unifiedProfile: { 
                        marketingContext : {
                            sessionId: "${sessionId}",
                            domain: "${domain}", 
                            utm: {
                                sfdcCampaignId: "${utms['utm_sfdc-campaign_id']}"
                                source: "${utms['utm_source']}"
                                medium: "${utms['utm_medium']}"
                                content: "${utms['utm_content']}"
                                campaign: "${utms['utm_campaign']}"
                            }
                        }
                    } 
                }) {
                    marketingContext {
                        lastUpdated
                    }
                }
        }`;
        const headers = [
            {
                header: 'Content-type',
                value: 'application/json'
            },
            {
                header: 'x-use-case',
                value: 'create-voltron-marketing-context'
            }
        ];
        const payload = JSON.stringify({
            query: mutation
        });
        const callback = function(result) {
            if (result === 'error') console.error('Failed request to set marketingContext in GUPS');
            else {
                let parsedResponse;
                try {
                    parsedResponse = JSON.parse(result);
                    const lastUpdated = parsedResponse.data.growthUnifiedProfile_createUnifiedProfile.marketingContext.lastUpdated;
                    (0, $2gCne.setLocalStorage)('marketingContext', JSON.stringify({
                        sessionId: sessionId,
                        domain: domain,
                        lastUpdated: lastUpdated,
                        utm: {
                            sfdcCampaignId: utms['utm_sfdc-campaign_id'],
                            campaign: utms['utm_campaign'],
                            source: utms['utm_source'],
                            medium: utms['utm_medium'],
                            content: utms['utm_content']
                        }
                    }));
                } catch (error) {
                    console.error('Failed to retrieve lastUpdated from GUPS with error:', error);
                }
            }
        };
        try {
            $5ab79df103be8536$export$bf3cce71df5bd3b.sendGUPSQuery(headers, payload, callback);
        } catch (error) {
            console.error('Failed to set marketingContext in GUPS with error:', error);
        }
    }
}

});


parcelRegister("danx7", function(module, exports) {
$parcel$export(module.exports, "mathGuid", function () { return $a53f70e0498f3401$export$dba5740cd1e5d9ea; });
/**
 * See:
 *  - http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/24891600#24891600
 * for more context around the issue of psuedo-randomness used by browsers and the solution used below.
 *
 * and:
 *  - http://web.archive.org/web/20120503063359/http://baagoe.com/en/RandomMusings/javascript/
 * for info regarding the Alea code used below.
 */ const $a53f70e0498f3401$var$trueRandom = function() {
    function Mash() {
        let n = 0xefc8249d;
        const mash = function(data) {
            for(let i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                let h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    function Alea() {
        return function(args) {
            // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
            let s0 = 0;
            let s1 = 0;
            let s2 = 0;
            let c = 1;
            if (args.length == 0) args = [
                +new Date()
            ];
            const mash = Mash();
            s0 = mash(' ');
            s1 = mash(' ');
            s2 = mash(' ');
            for (const item of args){
                s0 -= mash(item);
                if (s0 < 0) s0 += 1;
                s1 -= mash(item);
                if (s1 < 0) s1 += 1;
                s2 -= mash(item);
                if (s2 < 0) s2 += 1;
            }
            const random = function() {
                const t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
            };
            random.uint32 = function() {
                return random() * 0x100000000; // 2^32
            };
            random.fract53 = function() {
                return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
            };
            random.version = 'Alea 0.9';
            random.args = args;
            return random;
        }(Array.prototype.slice.call(arguments));
    }
    return Alea();
}();
const $a53f70e0498f3401$export$dba5740cd1e5d9ea = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = $a53f70e0498f3401$var$trueRandom() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};

});



parcelRegister("4X0dO", function(module, exports) {
$parcel$export(module.exports, "experiments", function () { return $4fa4252e8fdfe8c2$export$367c0902ef62c425; });

var $2WL8B = parcelRequire("2WL8B");

var $7FWq8 = parcelRequire("7FWq8");
const $4fa4252e8fdfe8c2$var$booleanTypeGuard = (value)=>typeof value === 'boolean';
const $4fa4252e8fdfe8c2$export$367c0902ef62c425 = {
    gwp9322WacHomepageRefresh: {
        experimentName: 'gwp-9322-wac-homepage-refresh-experiment',
        parameterName: 'variantName',
        defaultValue: 'control',
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== 'string') return false;
                return [
                    'control',
                    'test'
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Teamwork Collection refresh changes on homepage',
            expectedReleaseDate: '01/15/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    cfind4782LandingPageSubAnchorV3: {
        experimentName: 'cfind-4782-landing-page-sub-anchor-v3',
        parameterName: 'enrolled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: (value)=>typeof value === 'boolean'
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Test if personalizing the landing page off the sub anchor will increase d1to6',
            expectedReleaseDate: '07/14/2025',
            expectedRuntime: '6 weeks',
            // TODO: GWP-5270 to fill these urls
            context: {
                urls: []
            }
        }
    },
    jiraOnboardingAiMadlibV2: {
        experimentName: 'jira-onboarding-ai-madlib-v2',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useEligibleForJiraMadlibSetup)
        },
        metadata: {
            description: 'Enable AI Madlib during Jira onboarding experience V2 expanded iteration with all team types',
            expectedReleaseDate: '2/27/2026',
            expectedRuntime: '30 days',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    signupAddPaymentAb: {
        experimentName: 'signup_trialing_add_payment_ab',
        parameterName: 'cohort',
        defaultValue: 'control',
        options: {
            // we need to fire our exposure event manually because we can't determine if the user is eligible from here
            fireExperimentExposure: false,
            typeGuard: (value)=>{
                if (typeof value !== 'string') return false;
                return [
                    'control',
                    'test'
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Experiment to enable users with valid sites to go to payment at the sign-up screen',
            expectedReleaseDate: '02/27/25',
            expectedRuntime: 'TBD',
            // TODO: GWP-5270 to fill these urls
            context: {
                urls: []
            }
        }
    },
    gwp5090ExperimentBannerConfluence: {
        experimentName: 'gwp-5090-experiment-banner-confluence',
        parameterName: 'variantName',
        defaultValue: 'control',
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== 'string') return false;
                return [
                    'control',
                    'butterbar',
                    'lifted'
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Testing butterbar vs lifted banner for Jira Service Management product tour',
            expectedReleaseDate: '02/18/25',
            expectedRuntime: '2 weeks',
            // TODO: GWP-5270 to fill these urls
            context: {
                urls: []
            }
        }
    },
    gwp7617JiraShortTermAiInfusionExperiment: {
        experimentName: 'gwp-7617-jira-short-term-ai-infusion-experiment',
        parameterName: 'variantName',
        defaultValue: 'control',
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== 'string') return false;
                return [
                    'control',
                    'test'
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Short term AI',
            expectedReleaseDate: '08/21/25',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    gwp4948GartnerJiraProductTourExperiment: {
        experimentName: 'gwp-4948-gartner-jira-product-tour-experiment',
        parameterName: 'variantName',
        defaultValue: 'control',
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== 'string') return false;
                return [
                    'control',
                    'test'
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'gartner section on jira product tour',
            expectedReleaseDate: 'April 2025',
            expectedRuntime: '2 weeks',
            clientOnly: true,
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    gwp6441ConfluenceTemplatesProductNavCta: {
        experimentName: 'gwp-6441-confluence-templates-product-nav-cta',
        parameterName: 'variant',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>{
                // oxlint-disable-next-line react-hooks/rules-of-hooks
                return !(0, $2WL8B.useLoggedOut)();
            }
        },
        metadata: {
            description: 'Confluence Templates Product Nav CTA experiment',
            expectedReleaseDate: 'undefined',
            expectedRuntime: '77 days',
            clientOnly: true,
            context: {
                urls: [
                    '/software/confluence/templates/*'
                ]
            }
        }
    },
    jfindOnboardingWizardInviteStep: {
        experimentName: 'jfind-add-invite-step-to-onboarding-wizard',
        parameterName: 'enrolled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Add invite step to the Jira onboarding wizard',
            expectedReleaseDate: '09/12/2025',
            expectedRuntime: '3 weeks',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    wacRoutingTableMvpPerf: {
        experimentName: 'wac-routing-table-mvp',
        parameterName: 'enrolled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>typeof value === 'boolean'
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Measure performance degredation of wac-routing-table in wac-web',
            expectedReleaseDate: '08/28/2025',
            expectedRuntime: '5 days',
            context: {
                urls: [
                    '/software/jira/enterprise'
                ]
            }
        }
    },
    confluencePricingPageWaeMigration: {
        experimentName: 'confluence_pricing_wae_migration_exp_rerun_exp_1',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Migration of Confluence pricing page to WAE, rerun',
            expectedReleaseDate: '03/06/2026',
            expectedRuntime: '80 days',
            context: {
                urls: [
                    '/software/confluence/pricing'
                ]
            }
        }
    },
    wacAISearchSummaryV2: {
        experimentName: 'wac-ai-search-summary-v2',
        parameterName: 'enrolled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>{
                // oxlint-disable-next-line react-hooks/rules-of-hooks
                return (0, $2WL8B.useIsDesktop)();
            }
        },
        metadata: {
            description: 'AI Search Summary Experiment V2',
            expectedReleaseDate: 'N/A',
            expectedRuntime: 'N/A',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    gwp8288PersonalizingWacSoftwarePage: {
        experimentName: 'gwp-8288-personalizing-wac-software-page',
        parameterName: 'enrolled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Personalizing WAC Software Page Experiment',
            expectedReleaseDate: '10/30/2025',
            expectedRuntime: '6 weeks',
            context: {
                urls: [
                    '/software'
                ]
            }
        }
    },
    twcg790ContextualBackground: {
        experimentName: 'twcg-790-contextual-backgrounds-wac-sign-in',
        parameterName: 'cohort',
        defaultValue: 'control',
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== 'string') return false;
                return [
                    'control',
                    'test'
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'adding atlOrigin and application query strings to IDAC login URL to enable contextual background on sign in page',
            expectedReleaseDate: '01/12/2025',
            expectedRuntime: '7 weeks',
            clientOnly: true,
            context: {
                // eslint-disable-next-line
                urls: [
                    '*'
                ]
            }
        }
    },
    jiraPricingWaeMigrationExperimentRerunExp: {
        experimentName: 'jira_pricing_wae_migration_experiment_rerun_exp_1',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Rerun of migration of Jira pricing page to WAE',
            expectedReleaseDate: '03/06/2026',
            expectedRuntime: '43 days',
            context: {
                urls: [
                    '/software/jira/pricing'
                ]
            }
        }
    },
    dxpMigrationConfluenceAnchorJourney: {
        experimentName: 'dxp_migration_confluence_anchor_journey',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Migration of Confluence anchor journey to DXP',
            expectedReleaseDate: 'TBD',
            expectedRuntime: 'TBD',
            context: {
                urls: [
                    '/software/confluence'
                ]
            }
        }
    },
    gwp9508ConfluenceBannerIosNativeApp: {
        experimentName: 'gwp-9508-confluence-banner-ios-native-app',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useIsSoftwareConfluencePath)
        },
        metadata: {
            description: 'Confluence Banner Ios Native App Experiment',
            expectedReleaseDate: '01/22/2026',
            expectedRuntime: '39 days',
            context: {
                urls: [
                    '/software/confluence/*'
                ]
            }
        }
    },
    gwp9507JiraBannerIosNativeApp: {
        experimentName: 'gwp-9507-jira-banner-ios-native-app',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useIsSoftwareJiraPath)
        },
        metadata: {
            description: 'Jira Banner App Experiment',
            expectedReleaseDate: '01/22/2026',
            expectedRuntime: '60 days',
            context: {
                urls: [
                    '/software/jira/*'
                ]
            }
        }
    },
    cfind6469FrictionlessFirstLookJiraV3: {
        experimentName: 'cfind-6469-frictionless-first-look-jira-v3',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'v3 of the Jira frictionless first look: Update the prompt box to be more intuitive',
            expectedReleaseDate: '06/18/2026',
            expectedRuntime: '',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    d1d6redirectLoggedInUsers: {
        experimentName: 'd1d6-151-redirect-logged-in-users',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useLoggedInHasJira)
        },
        metadata: {
            description: 'Redirect logged in users to most recent jira site',
            expectedReleaseDate: '07/27/2026',
            expectedRuntime: '',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    cfind6214WacLandingForAiNativeTeams: {
        experimentName: 'cfind-6214-wac-landing-for-ai-native-teams',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            // Exposure is fired manually so that only logged-out branded
            // paid search (BPS) traffic on /software/jira is exposed.
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useLoggedOut)
        },
        metadata: {
            description: 'Split /software/jira traffic for logged-out branded paid search (BPS) users; treatment serves the WAE (Uniform) landing page.',
            expectedReleaseDate: '06/30/2026',
            expectedRuntime: 'TBD',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    cfind6214WacLandingForAiNativeTeamsPt: {
        experimentName: 'cfind-6214-wac-landing-for-ai-native-teams-pt',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>{
                return(// oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $2WL8B.useLoggedOut)() && // oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $2WL8B.useExcludeJiraImcCampaign)());
            }
        },
        metadata: {
            description: 'Split /software/jira traffic for logged-out PT users (excluding the Jira IMC paid campaign); treatment serves the WAE (Uniform) landing page.',
            expectedReleaseDate: '06/30/2026',
            expectedRuntime: 'TBD',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    d1d6DeferSiteNaming: {
        experimentName: 'd1d6-defer-site-naming',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useLoggedOutJira)
        },
        metadata: {
            description: 'Remove the explicit site naming step from the Jira signup flow. In treatment, the continueUrl passes deferSiteNaming=true to the confirmation page, which auto-generates the site name and activates the product without a separate site naming step.',
            expectedReleaseDate: 'TBD',
            expectedRuntime: 'TBD',
            context: {
                urls: [
                    '/software/jira',
                    '/try/cloud/signup'
                ]
            }
        }
    },
    jiraWacActivationChecklist: {
        experimentName: 'wac-jira-activation-checklist',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useLoggedInHasJiraSiteD1toD14)
        },
        metadata: {
            description: "Per-product activation checklist surfaced on wac.com/software/jira, rendered directly below the user's most recently accessed Jira site card. Hosts the @post-office/placements--growth-starburst/wac-product-activation-checklist placement.",
            expectedReleaseDate: '06/01/2026',
            expectedRuntime: '4 weeks',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    jiraWacActivationChecklistAa: {
        experimentName: 'wac-jira-activation-checklist-aa',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useLoggedInHasJiraSiteD1toD14)
        },
        metadata: {
            description: 'AA test for the Jira activation checklist cohort on wac.com/software/jira. Uses the same D1-D14 Jira-site targeting as the launch experiment to validate exposure volume before rollout.',
            expectedReleaseDate: '06/01/2026',
            expectedRuntime: '2 weeks',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    gwp10724JiraAgentHeroChangesOnJiraPt: {
        experimentName: 'gwp-10724-jira-agent-hero-changes-on-jira-pt',
        parameterName: 'isEnabled',
        defaultValue: true,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Post-rollout retroactive experiment for visual changes above the fold on the Jira PT, related to Jira Agent release',
            expectedReleaseDate: '2026-03-18',
            expectedRuntime: '24 days',
            clientOnly: false,
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    twcg947TwcLandAiLedOnboarding: {
        experimentName: 'twcg-947_twc_land_ai-led_onboarding',
        parameterName: 'cohort',
        defaultValue: 'not-enrolled',
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== 'string') return false;
                return [
                    'control',
                    'variation'
                ].includes(value);
            }
        },
        targeting: {
            cohort: (0, $2WL8B.useIsEligibleForTWCAILedOnboarding)
        },
        metadata: {
            description: '[TWCG-947] TWC LAND AI-Led Onboarding Experiment',
            expectedReleaseDate: '',
            // to be updated when known
            expectedRuntime: '',
            // to be updated when known
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    wacRefreshQ4Fy26AaTest: {
        experimentName: 'wac_refresh_q4fy26_aa_test',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'AA test for WAC Refresh Q4 FY26',
            expectedReleaseDate: 'Team26',
            expectedRuntime: 'TBD',
            context: {
                urls: [
                    '/',
                    '/software/jira',
                    '/software/confluence',
                    '/software/rovo',
                    '/collections/teamwork'
                ]
            }
        }
    },
    softwareTryRovoCta: {
        experimentName: 'try_rovo_cta',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useLoggedOut)
        },
        metadata: {
            description: 'Try rovo cta on /software page',
            expectedReleaseDate: '04/10/2026',
            expectedRuntime: '35 days',
            context: {
                urls: [
                    '/software'
                ]
            }
        }
    },
    servCoLofiBackground: {
        experimentName: 'gwp-9785-servco-lofi-background-signup',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Lofi background for servco signup pages',
            expectedReleaseDate: '04/30/2026',
            expectedRuntime: '4 weeks',
            context: {
                urls: [
                    '/try/cloud/signup?bundle=service-collection',
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    sparkSkipOnboardingWizard: {
        experimentName: 'spark-jira-skip-onboarding-wizard',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'adding skip button to Jira onboarding wizard',
            expectedReleaseDate: '04/30/2026',
            expectedRuntime: '4 weeks',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    jfindSampleTasksForLandingGateNonTech: {
        experimentName: 'jfind-sample-tasks-for-landing-gate-non-tech',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Provides sample task data during Jira onboarding for non-technical team types',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    twcg1659RemoveWorkTypeScreen: {
        experimentName: 'twcg-1659-remove-work-type-screen',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Remove the Work Types selection step from the Jira onboarding wizard',
            expectedReleaseDate: 'TBD',
            expectedRuntime: '4 weeks',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    twcg1935CodingAgentChoice: {
        experimentName: 'spice-agentic-development-onboarding',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useEligibleForTwcg1935CodingAgentChoice)
        },
        metadata: {
            description: 'Show coding agent choice screen during Jira onboarding',
            expectedReleaseDate: '06/29/2026',
            expectedRuntime: '4 weeks',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    cfindTemplatesHeroIntentValueV6: {
        experimentName: 'cfind_templates_hero_intent_value_v6',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Intent + Value Hero on Confluence templates page \u2014 optimize above-fold hero with intent-matched heading, value prop, social proof, and CTA",
            expectedReleaseDate: '06/15/2026',
            expectedRuntime: '3 weeks',
            context: {
                urls: [
                    '/software/confluence/templates'
                ]
            }
        }
    },
    jsmContextualBanditsInWae: {
        experimentName: 'jsm-contextual-bandits-in-wae',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: 'Contextual bandits in WAE on the JSM product page',
            expectedReleaseDate: '06/25/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/jira/service-management'
                ]
            }
        }
    },
    jsmGrowth519JsmLandUseCaseOnboarding: {
        experimentName: 'jsmgrowth_519_jsm_land_use_case_onboarding',
        parameterName: 'isEnabled',
        defaultValue: false,
        options: {
            // Exposure is fired only when the Team Choice screen is viewed.
            // Other reads of this experiment must not count exposure.
            fireExperimentExposure: false,
            typeGuard: $4fa4252e8fdfe8c2$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $2WL8B.useEligibleForJsmLandUseCaseOnboarding)
        },
        metadata: {
            description: "JSM Land use-case driven onboarding \u2014 reorders the team choice screen and adds expand/collapse options for JSM new user signups",
            expectedReleaseDate: '07/06/2026',
            expectedRuntime: '8 weeks',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    wacRefreshJira: $7FWq8.wacRefreshJira,
    wacRefreshConfluence: $7FWq8.wacRefreshConfluence,
    wacRefreshHomepage: $7FWq8.wacRefreshHomepage,
    wacRefreshTwcRovo: $7FWq8.wacRefreshTwcRovo
};

});
parcelRegister("2WL8B", function(module, exports) {
$parcel$export(module.exports, "COHORTS", function () { return $37a656fc797532d9$export$f1a98e82c0c821bd; });
$parcel$export(module.exports, "JIRA_AI_NATIVE_SIGNUP_SOURCE", function () { return $37a656fc797532d9$export$328c3dd1f446a77; });
$parcel$export(module.exports, "useEligibleForJsmLandUseCaseOnboarding", function () { return $37a656fc797532d9$export$300bcf2298df2b85; });
$parcel$export(module.exports, "useCohort", function () { return $37a656fc797532d9$export$1f67603e8501a488; });
$parcel$export(module.exports, "useProductD0to6Site", function () { return $37a656fc797532d9$export$deca29e2536116f5; });
$parcel$export(module.exports, "useIsUpgradeEligible", function () { return $37a656fc797532d9$export$626907243cad789; });
$parcel$export(module.exports, "useConfluenceD0to6", function () { return $37a656fc797532d9$export$a99dbfe8dbbd7466; });
$parcel$export(module.exports, "useFirstName", function () { return $37a656fc797532d9$export$bed8abde9fdecb85; });
$parcel$export(module.exports, "useLoggedOut", function () { return $37a656fc797532d9$export$2f15ce1cde67833e; });
$parcel$export(module.exports, "useLoggedIn", function () { return $37a656fc797532d9$export$3b062b02b4537682; });
$parcel$export(module.exports, "useLoggedOutJira", function () { return $37a656fc797532d9$export$eaaff87ad9e02759; });
$parcel$export(module.exports, "useFreeIntent", function () { return $37a656fc797532d9$export$cd55d04fc7ff1e12; });
$parcel$export(module.exports, "useExcludeJiraImcCampaign", function () { return $37a656fc797532d9$export$b21ec5248a1af107; });
$parcel$export(module.exports, "useSitesWithCurrentProduct", function () { return $37a656fc797532d9$export$6ece9302e262a8ba; });
$parcel$export(module.exports, "useLoggedInHasJira", function () { return $37a656fc797532d9$export$84a160b212c75a38; });
$parcel$export(module.exports, "useLoggedInHasJiraSiteD1toD14", function () { return $37a656fc797532d9$export$f205df8e360cbc3e; });
$parcel$export(module.exports, "useLoggedInHasJSM", function () { return $37a656fc797532d9$export$fc6f9a676ac2d20; });
$parcel$export(module.exports, "useHomePageJSMXflowTargetingCohort", function () { return $37a656fc797532d9$export$e197bb1368a4ef86; });
$parcel$export(module.exports, "useHomePageJPDXflowTargetingCohort", function () { return $37a656fc797532d9$export$55a03ab347a6458a; });
$parcel$export(module.exports, "useHomePageLoomXflowTargetingCohort", function () { return $37a656fc797532d9$export$922f0a01637bf976; });
$parcel$export(module.exports, "usePrefersDarkColorScheme", function () { return $37a656fc797532d9$export$6ee1c85a91cf2903; });
$parcel$export(module.exports, "useStandardIntent", function () { return $37a656fc797532d9$export$38abfe23fcbef130; });
$parcel$export(module.exports, "usePremiumIntent", function () { return $37a656fc797532d9$export$8321978ac3198c2e; });
$parcel$export(module.exports, "useJiraServiceManagementIntent", function () { return $37a656fc797532d9$export$a0475dc95ccbcf50; });
$parcel$export(module.exports, "useManagingOrgUserSites", function () { return $37a656fc797532d9$export$cf11cf307fde2f61; });
$parcel$export(module.exports, "useCrossflowEligibleSites", function () { return $37a656fc797532d9$export$b5d9e6bb3dda68c5; });
$parcel$export(module.exports, "useLoggedInHasJiraAndNotConfluence", function () { return $37a656fc797532d9$export$b856a73c0ae1da63; });
$parcel$export(module.exports, "useIsSoftwareConfluencePath", function () { return $37a656fc797532d9$export$b30de9e5e1e6ddb6; });
$parcel$export(module.exports, "useIsSoftwareJiraPath", function () { return $37a656fc797532d9$export$da27afec777e5a82; });
$parcel$export(module.exports, "useUpgradableSites", function () { return $37a656fc797532d9$export$f209e5281b75b7a1; });
$parcel$export(module.exports, "useUpliftableSites", function () { return $37a656fc797532d9$export$9a364c26a41530c6; });
$parcel$export(module.exports, "useIsStandardToPremiumUpgradeEligible", function () { return $37a656fc797532d9$export$cb6c82b1dd091b1; });
$parcel$export(module.exports, "useUpgradableStandardSites", function () { return $37a656fc797532d9$export$d51a19bb23af218a; });
$parcel$export(module.exports, "useIsConfluenceContactCompanyExpandEligible", function () { return $37a656fc797532d9$export$cc01f81ad039310f; });
$parcel$export(module.exports, "useIsJiraContactCompanyExpandEligible", function () { return $37a656fc797532d9$export$3efd720c078c8268; });
$parcel$export(module.exports, "useDeveloperBundleIntent", function () { return $37a656fc797532d9$export$46259f1c5dadf021; });
$parcel$export(module.exports, "useIsDesktop", function () { return $37a656fc797532d9$export$e31fbf0af7c148e4; });
$parcel$export(module.exports, "useLoggedOutHasExistingSites", function () { return $37a656fc797532d9$export$a810ea9e597e4b89; });
$parcel$export(module.exports, "useSignupTransactionSelectorCohort", function () { return $37a656fc797532d9$export$724a9c1f66c780e; });
$parcel$export(module.exports, "useRovoEnabledCohort", function () { return $37a656fc797532d9$export$5d6fa06f1d687f9c; });
$parcel$export(module.exports, "useEligibleForJiraMadlibSetup", function () { return $37a656fc797532d9$export$94261b4b0b38f1cd; });
$parcel$export(module.exports, "useIsEligibleForTWCAILedOnboarding", function () { return $37a656fc797532d9$export$79db58cc9c75d79; });
$parcel$export(module.exports, "useEligibleForTwcg1935CodingAgentChoice", function () { return $37a656fc797532d9$export$74b50ac429b5c3cf; });

var $1oC0p = parcelRequire("1oC0p");

var $kS3iu = parcelRequire("kS3iu");

var $a0utR = parcelRequire("a0utR");

var $ik40B = parcelRequire("ik40B");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $dqd4k = parcelRequire("dqd4k");

var $lcW33 = parcelRequire("lcW33");

var $gx3aw = parcelRequire("gx3aw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $80kL5 = parcelRequire("80kL5");

var $1ka2O = parcelRequire("1ka2O");

var $6gQvZ = parcelRequire("6gQvZ");

var $5mv0J = parcelRequire("5mv0J");

var $5yuBp = parcelRequire("5yuBp");

var $7GVWk = parcelRequire("7GVWk");

var $aXBsz = parcelRequire("aXBsz");

var $3dtkR = parcelRequire("3dtkR");
const $37a656fc797532d9$export$f1a98e82c0c821bd = Object.freeze({
    NEW_USER: 'new-user',
    EXISTING_USER: 'existing-user',
    MANAGED_NEW_USER: 'managed-new-user',
    MANAGED_USER: 'managed-user',
    WEEK_ONE_USER: 'week-one-user',
    UPGRADE_ELIGIBLE_USER: 'upgrade-eligible-user',
    UPLIFT_ELIGIBLE_USER: 'uplift-eligible-user',
    CURRENT_PRODUCT_JOINABLE_USER: 'current-product-joinable-user',
    CURRENT_PRODUCT_USER: 'current-product-user',
    CROSSFLOW_ELIGIBLE_USER: 'crossflow-eligible-user'
});
const $37a656fc797532d9$export$328c3dd1f446a77 = 'jira-ai-native';
const $37a656fc797532d9$export$39f198badfd10683 = 'developer';
const $37a656fc797532d9$export$300bcf2298df2b85 = ()=>{
    if (typeof window === 'undefined') return false;
    const urlParams = new URLSearchParams(window.location.search);
    const products = urlParams.get('products') ?? '';
    const primaryCollectionProduct = urlParams.get('primaryCollectionProduct');
    return products.includes((0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT) || products.includes((0, $fcO7r.ProductKey).SERVICE_COLLECTION) && primaryCollectionProduct === (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT;
};
const $37a656fc797532d9$export$1f67603e8501a488 = (useContactExpandCohortLogic = false)=>{
    const { profile: profile, product: product } = (0, $7GVWk.useUserContext)();
    const isManaged = $37a656fc797532d9$export$fa35732e6a6c6c71();
    const isManagedUser = $37a656fc797532d9$export$33d0115fcc5e7239();
    const isWeekOneUser = $37a656fc797532d9$export$deca29e2536116f5({
        productKey: product?.key
    });
    const isNewUser = $37a656fc797532d9$export$d2349a5f3b162a3e();
    const isUpgradeEligible = $37a656fc797532d9$export$626907243cad789();
    const isUpliftEligible = $37a656fc797532d9$export$ced14a2b669aff9a();
    const isCurrentProductJoinableUser = $37a656fc797532d9$export$f0f246e4b54f5cc8();
    const isCurrentProductUser = $37a656fc797532d9$export$2ca4a5691b50e92f();
    const isCrossflowEligible = $37a656fc797532d9$export$3ab50f0ad2618995();
    if (profile.requestInProgress) return undefined;
    if (useContactExpandCohortLogic) {
        if (isUpgradeEligible) return $37a656fc797532d9$export$f1a98e82c0c821bd.UPGRADE_ELIGIBLE_USER;
        if (isCurrentProductUser) return $37a656fc797532d9$export$f1a98e82c0c821bd.CURRENT_PRODUCT_USER;
        if (isCurrentProductJoinableUser) return $37a656fc797532d9$export$f1a98e82c0c821bd.CURRENT_PRODUCT_JOINABLE_USER;
        if (isUpliftEligible) return $37a656fc797532d9$export$f1a98e82c0c821bd.UPLIFT_ELIGIBLE_USER;
        if (isCrossflowEligible) return $37a656fc797532d9$export$f1a98e82c0c821bd.CROSSFLOW_ELIGIBLE_USER;
        if (isManaged) return $37a656fc797532d9$export$f1a98e82c0c821bd.MANAGED_NEW_USER;
        return $37a656fc797532d9$export$f1a98e82c0c821bd.NEW_USER;
    }
    if (isManagedUser) return $37a656fc797532d9$export$f1a98e82c0c821bd.MANAGED_USER;
    if (isUpgradeEligible) return $37a656fc797532d9$export$f1a98e82c0c821bd.UPGRADE_ELIGIBLE_USER;
    if (isWeekOneUser) return $37a656fc797532d9$export$f1a98e82c0c821bd.WEEK_ONE_USER;
    if (isCurrentProductUser) return $37a656fc797532d9$export$f1a98e82c0c821bd.CURRENT_PRODUCT_USER;
    if (isUpliftEligible) return $37a656fc797532d9$export$f1a98e82c0c821bd.UPLIFT_ELIGIBLE_USER;
    if (isNewUser) return $37a656fc797532d9$export$f1a98e82c0c821bd.NEW_USER;
    if (isCrossflowEligible) return $37a656fc797532d9$export$f1a98e82c0c821bd.CROSSFLOW_ELIGIBLE_USER;
    return $37a656fc797532d9$export$f1a98e82c0c821bd.EXISTING_USER;
};
const $37a656fc797532d9$export$a99dbfe8dbbd7466 = ()=>{
    const d1to6ConfluenceSite = $37a656fc797532d9$export$deca29e2536116f5({
        productKey: (0, $fcO7r.ProductKey).CONFLUENCE
    });
    return !d1to6ConfluenceSite ? d1to6ConfluenceSite : true;
};
const $37a656fc797532d9$export$bed8abde9fdecb85 = ()=>{
    const { user: user } = (0, $7GVWk.useUserContext)();
    if (user['requestInProgress']) return undefined;
    return (user['name'] ?? '').split(' ')[0];
};
const $37a656fc797532d9$export$b55e4b5e174e7299 = ()=>{
    const d1toW2JiraSite = $37a656fc797532d9$export$d7b83d5aca4ac99d();
    return !d1toW2JiraSite ? d1toW2JiraSite : true;
};
const $37a656fc797532d9$export$e3d98c17bbadabcb = ()=>{
    const jiraD0to6Site = $37a656fc797532d9$export$deca29e2536116f5({
        productKey: (0, $fcO7r.ProductKey).JIRA_SOFTWARE
    });
    return !jiraD0to6Site ? jiraD0to6Site : true;
};
const $37a656fc797532d9$export$d7b83d5aca4ac99d = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress }, referrer: referrer } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        if (attributes?.existingSites.length !== 1 || referrer !== 'jira.com') return false;
        const twoWeeksAgo = (0, $aXBsz.daysAgo)(14);
        return attributes?.existingSites.find(({ siteCreatedAt: siteCreatedAt, products: products })=>siteCreatedAt > twoWeeksAgo && products.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE) && products.every((product)=>product.productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE || product.productKey === (0, $fcO7r.ProductKey).ROVO)) ?? false;
    }, [
        requestInProgress,
        referrer
    ]);
};
const $37a656fc797532d9$export$d298000033f99943 = ()=>{
    const oneW2OrOlderJiraSite = $37a656fc797532d9$export$d1d417f90015cc8d();
    const multipleJiraSites = $37a656fc797532d9$export$6c60fb15c322899a();
    if (oneW2OrOlderJiraSite === undefined || multipleJiraSites === undefined) return undefined;
    return oneW2OrOlderJiraSite || multipleJiraSites;
};
const $37a656fc797532d9$export$d1d417f90015cc8d = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        const oneWeekAgo = (0, $aXBsz.daysAgo)(7);
        const matchingSitesCount = attributes?.existingSites.filter(({ siteCreatedAt: siteCreatedAt, products: products })=>siteCreatedAt < oneWeekAgo && products.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE)).length ?? 0;
        return matchingSitesCount === 1;
    }, [
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$6c60fb15c322899a = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        const matchingSitesCount = attributes?.existingSites.filter(({ products: products })=>products.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE)).length ?? 0;
        return matchingSitesCount > 1;
    }, [
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$2f15ce1cde67833e = ()=>{
    const { user: { requestInProgress: requestInProgress, isUserLoggedIn: isUserLoggedIn } } = (0, $7GVWk.useUserContext)();
    const { hasCloudSessionTokenCookie: hasCloudSessionTokenCookie } = (0, $5mv0J.useSSRLoginState)();
    if (typeof window === 'undefined') // If SSR return if cloud session token cookie is present
    return hasCloudSessionTokenCookie === false;
    if (requestInProgress) {
        // Cloud session token cookie is created as http only cookie, so can't reference from browser's JS.
        // Instead, using login_user_detected cookie.
        const loginUserDetectedCookie = (0, $gx3aw.Cookie).readCookie('login_user_detected');
        return loginUserDetectedCookie === undefined || loginUserDetectedCookie !== 'true';
    }
    return isUserLoggedIn === false;
};
const $37a656fc797532d9$export$3b062b02b4537682 = ()=>{
    const { user: { requestInProgress: requestInProgress, isUserLoggedIn: isUserLoggedIn } } = (0, $7GVWk.useUserContext)();
    if (requestInProgress) return undefined;
    return isUserLoggedIn;
};
const $37a656fc797532d9$export$f15129e00889eb41 = ()=>{
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    const { loggedOutProfile: loggedOutProfile } = (0, $7GVWk.useUserContext)();
    if (loggedOut === undefined) return undefined;
    if (!loggedOut) return false;
    return loggedOutProfile?.sites?.some(({ products: products })=>products?.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE));
};
const $37a656fc797532d9$export$18075269258eafed = ()=>{
    const confluence = $37a656fc797532d9$export$c0fe219adfba1c8c();
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    return confluence && loggedOut;
};
const $37a656fc797532d9$export$eaaff87ad9e02759 = ()=>{
    const jira = $37a656fc797532d9$export$5dc07a09424afaf8();
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    return jira && loggedOut;
};
const $37a656fc797532d9$export$b9541c4305527a4e = ()=>{
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    const { loggedOutProfile: loggedOutProfile } = (0, $7GVWk.useUserContext)();
    if (loggedOut === undefined) return undefined;
    if (!loggedOut) return false;
    return !loggedOutProfile || loggedOutProfile.sites?.every(({ products: products })=>!products?.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE));
};
const $37a656fc797532d9$export$b0bf45fdefa54485 = ()=>{
    const jira = $37a656fc797532d9$export$5dc07a09424afaf8();
    const free = $37a656fc797532d9$export$cd55d04fc7ff1e12();
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    return jira && free && loggedOut;
};
const $37a656fc797532d9$export$b21ec5248a1af107 = ()=>{
    const { search: search } = (0, $1ka2O.useLocation)();
    const utmCampaign = new URLSearchParams(search).get('utm_campaign');
    return !(0, $gZgIU.hasJiraImcCampaignKey)(utmCampaign);
};
const $37a656fc797532d9$export$d2349a5f3b162a3e = ()=>{
    const { profile: { requestInProgress: requestInProgress, cohorts: cohorts } } = (0, $7GVWk.useUserContext)();
    if (requestInProgress) return undefined;
    return cohorts?.userType === 'new-user';
};
const $37a656fc797532d9$export$deca29e2536116f5 = ({ productKey: productKey })=>{
    const { profile: { requestInProgress: requestInProgress, attributes: attributes } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        if (attributes?.existingSites.length !== 1) return false;
        const oneWeekAgo = (0, $aXBsz.daysAgo)(7);
        // sites may only have the current productKey, rovo, project, or goal
        const weekOneProductKeys = [
            productKey,
            (0, $fcO7r.ProductKey).ROVO,
            'project',
            'goal'
        ];
        return attributes?.existingSites.find(({ siteCreatedAt: siteCreatedAt, products: products })=>{
            const isRecent = siteCreatedAt > oneWeekAgo;
            const hasTargetProduct = products.some((product)=>product.productKey === productKey);
            const allProductsAllowed = products.every(({ productKey: productKey })=>weekOneProductKeys.includes(productKey));
            return isRecent && hasTargetProduct && allProductsAllowed;
        }) ?? false;
    }, [
        requestInProgress,
        productKey
    ]);
};
const $37a656fc797532d9$export$6ece9302e262a8ba = ()=>{
    const { product: product, profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        if (!product?.key) return [];
        return attributes?.existingSites.filter((site)=>site.products.some(({ productKey: productKey, partOfCollection: partOfCollection })=>productKey === product?.key || partOfCollection === product?.key)) ?? [];
    }, [
        requestInProgress,
        attributes?.existingSites,
        product?.key
    ]);
};
const $37a656fc797532d9$export$84a160b212c75a38 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.some((product)=>product.productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$f205df8e360cbc3e = (cloudSiteId)=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    const existingSites = attributes?.existingSites;
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        const oneDayAgo = (0, $aXBsz.daysAgo)(1);
        const fourteenDaysAgo = (0, $aXBsz.daysAgo)(14);
        return existingSites?.some(({ cloudId: cloudId, siteCreatedAt: siteCreatedAt, products: products })=>{
            if (cloudSiteId && cloudId !== cloudSiteId) return false;
            const siteIsD1ToD14 = siteCreatedAt >= fourteenDaysAgo && siteCreatedAt <= oneDayAgo;
            const siteHasJiraSoftware = products.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE);
            return siteIsD1ToD14 && siteHasJiraSoftware;
        }) ?? false;
    }, [
        cloudSiteId,
        existingSites,
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$485cf218c5871683 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $fcO7r.ProductKey).CONFLUENCE)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$fc6f9a676ac2d20 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$90f6e3b3a7bfc07 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $fcO7r.ProductKey).LOOM)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$fb04b6df09d62152 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$9c796ff56b860b9 = ()=>{
    const hasJiraSites = $37a656fc797532d9$export$84a160b212c75a38();
    const hasConfluenceSites = $37a656fc797532d9$export$485cf218c5871683();
    return hasJiraSites && hasConfluenceSites;
};
const $37a656fc797532d9$var$JSM_ELIGIBLE_JOB_FUNCTIONS = new Set([
    'engineering',
    'information technology',
    'customer service',
    'operations',
    'human resources',
    'data science'
]);
const $37a656fc797532d9$var$LOOM_ELIGIBLE_JOB_FUNCTIONS = new Set([
    'program management',
    'finance',
    'legal',
    'c-suite',
    'other',
    'undefined',
    null,
    'sales',
    'marketing',
    'design'
]);
const $37a656fc797532d9$var$JPD_ELIGIBLE_JOB_FUNCTIONS = new Set([
    'product management'
]);
const $37a656fc797532d9$export$e2e44b7b9e61cc71 = ()=>{
    const { getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback } = (0, $dqd4k.useGupsStatus)();
    const [hasJSMJobFunction, setHasJSMJobFunction] = (0, $1oC0p.useState)(undefined);
    (0, $1oC0p.useEffect)(()=>{
        const checkTeamType = async ()=>{
            const result = await getUserProfileJobFunctionCallback('homepage-xflow-job-function');
            const jobFunction = result?.data?.jobFunction;
            const matches = jobFunction && $37a656fc797532d9$var$JSM_ELIGIBLE_JOB_FUNCTIONS.has(jobFunction);
            setHasJSMJobFunction(matches || false);
        };
        checkTeamType();
    }, [
        getUserProfileJobFunctionCallback
    ]);
    return hasJSMJobFunction;
};
const $37a656fc797532d9$export$5f2f0baa902c1044 = ()=>{
    const hasJSMJobFunction = $37a656fc797532d9$export$e2e44b7b9e61cc71();
    const hasJiraAndConfluence = $37a656fc797532d9$export$9c796ff56b860b9();
    const isEnglishLocale = (0, $6gQvZ.useEnglishLocale)();
    return hasJSMJobFunction && hasJiraAndConfluence && isEnglishLocale;
};
const $37a656fc797532d9$export$17f3ceaf5eb291b7 = ()=>{
    const { getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback } = (0, $dqd4k.useGupsStatus)();
    const [hasJPDJobFunction, setHasJPDJobFunction] = (0, $1oC0p.useState)(undefined);
    (0, $1oC0p.useEffect)(()=>{
        const checkTeamType = async ()=>{
            const result = await getUserProfileJobFunctionCallback('homepage-xflow-job-function');
            const jobFunction = result?.data?.jobFunction;
            const matches = jobFunction && $37a656fc797532d9$var$JPD_ELIGIBLE_JOB_FUNCTIONS.has(jobFunction);
            setHasJPDJobFunction(matches || false);
        };
        checkTeamType();
    }, [
        getUserProfileJobFunctionCallback
    ]);
    return hasJPDJobFunction;
};
const $37a656fc797532d9$export$6504d847bbe5528a = ()=>{
    const hasJPDJobFunction = $37a656fc797532d9$export$17f3ceaf5eb291b7();
    const hasJiraAndConfluence = $37a656fc797532d9$export$9c796ff56b860b9();
    const isEnglishLocale = (0, $6gQvZ.useEnglishLocale)();
    return hasJPDJobFunction && hasJiraAndConfluence && isEnglishLocale;
};
const $37a656fc797532d9$export$24267c23d03635b3 = ()=>{
    const { getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback } = (0, $dqd4k.useGupsStatus)();
    const [hasLoomJobFunction, setHasLoomJobFunction] = (0, $1oC0p.useState)(undefined);
    (0, $1oC0p.useEffect)(()=>{
        const checkTeamType = async ()=>{
            const result = await getUserProfileJobFunctionCallback('homepage-xflow-job-function');
            const jobFunction = result?.data?.jobFunction;
            const matches = jobFunction === null || jobFunction === undefined || $37a656fc797532d9$var$LOOM_ELIGIBLE_JOB_FUNCTIONS.has(jobFunction);
            setHasLoomJobFunction(matches || false);
        };
        checkTeamType();
    }, [
        getUserProfileJobFunctionCallback
    ]);
    return hasLoomJobFunction;
};
const $37a656fc797532d9$export$412a4b4f6068c934 = ()=>{
    const hasLoomJobFunction = $37a656fc797532d9$export$24267c23d03635b3();
    const hasJiraAndConfluence = $37a656fc797532d9$export$9c796ff56b860b9();
    const isEnglishLocale = (0, $6gQvZ.useEnglishLocale)();
    return hasLoomJobFunction && hasJiraAndConfluence && isEnglishLocale;
};
const $37a656fc797532d9$export$e197bb1368a4ef86 = ()=>{
    const hasJSMCohortQualification = $37a656fc797532d9$export$5f2f0baa902c1044();
    const hasLoomCohortQualification = $37a656fc797532d9$export$412a4b4f6068c934();
    const hasJPDCohortQualification = $37a656fc797532d9$export$6504d847bbe5528a();
    const hasJSM = $37a656fc797532d9$export$fc6f9a676ac2d20();
    const hasLoom = $37a656fc797532d9$export$90f6e3b3a7bfc07();
    const hasJPD = $37a656fc797532d9$export$fb04b6df09d62152();
    if (// “JSM team types | job function” and no JSM entitlement
    hasJSMCohortQualification && !hasJSM) return true;
    else if (// “Loom team types | job function” and has loom and no JSM entitlement
    hasLoomCohortQualification && hasLoom && !hasJSM) return true;
    else if (// “JPD team types | job function” and has loom and JPD entitlement and no JSM entitlement
    hasJPDCohortQualification && hasLoom && hasJPD && !hasJSM) return true;
    return false;
};
const $37a656fc797532d9$export$55a03ab347a6458a = ()=>{
    const hasJSMCohortQualification = $37a656fc797532d9$export$5f2f0baa902c1044();
    const hasLoomCohortQualification = $37a656fc797532d9$export$412a4b4f6068c934();
    const hasJPDCohortQualification = $37a656fc797532d9$export$6504d847bbe5528a();
    const hasJSM = $37a656fc797532d9$export$fc6f9a676ac2d20();
    const hasLoom = $37a656fc797532d9$export$90f6e3b3a7bfc07();
    const hasJPD = $37a656fc797532d9$export$fb04b6df09d62152();
    if (// “JPD team types | job function” and no JPD entitlement
    hasJPDCohortQualification && !hasJPD) return true;
    else if (// “Loom team types | job function” and has loom and has JSM and no JPD entitlement
    hasLoomCohortQualification && hasLoom && hasJSM && !hasJPD) return true;
    else if (// “JSM team types | job function” and has JSM and has loom and no JPD entitlement
    hasJSMCohortQualification && hasJSM && hasLoom && !hasJPD) return true;
    return false;
};
const $37a656fc797532d9$export$922f0a01637bf976 = ()=>{
    const hasJSMCohortQualification = $37a656fc797532d9$export$5f2f0baa902c1044();
    const hasLoomCohortQualification = $37a656fc797532d9$export$412a4b4f6068c934();
    const hasJPDCohortQualification = $37a656fc797532d9$export$6504d847bbe5528a();
    const hasJSM = $37a656fc797532d9$export$fc6f9a676ac2d20();
    const hasLoom = $37a656fc797532d9$export$90f6e3b3a7bfc07();
    const hasJPD = $37a656fc797532d9$export$fb04b6df09d62152();
    if (// "Loom team types | job function” and no Loom entitlement
    hasLoomCohortQualification && !hasLoom) return true;
    else if (// “JSM team types | job function” and has JSM and no Loom entitlement
    hasJSMCohortQualification && hasJSM && !hasLoom) return true;
    else if (// “JPD team types | job function” and has JPD and no Loom entitlement
    hasJPDCohortQualification && hasJPD && !hasLoom) return true;
    return false;
};
const $37a656fc797532d9$export$6ee1c85a91cf2903 = ()=>{
    return $37a656fc797532d9$export$16e080529ee7ce8e('dark');
};
const $37a656fc797532d9$export$16e080529ee7ce8e = (color)=>{
    return window?.matchMedia && window?.matchMedia(`(prefers-color-scheme: ${color})`).matches ? true : false;
};
const $37a656fc797532d9$export$842e95cf1a436387 = ()=>{
    const isConfluence = $37a656fc797532d9$export$c0fe219adfba1c8c();
    const isFree = $37a656fc797532d9$export$cd55d04fc7ff1e12();
    return isConfluence && isFree;
};
const $37a656fc797532d9$export$af2d59ad7176b983 = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return product?.key === (0, $fcO7r.ProductKey).COMPASS;
};
const $37a656fc797532d9$export$c0fe219adfba1c8c = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return product?.name === 'confluence';
};
const $37a656fc797532d9$export$cd55d04fc7ff1e12 = ()=>{
    const { edition: edition } = (0, $7GVWk.useUserContext)();
    return edition === 'free';
};
const $37a656fc797532d9$export$38abfe23fcbef130 = ()=>{
    const { edition: edition } = (0, $7GVWk.useUserContext)();
    return edition === 'standard';
};
const $37a656fc797532d9$export$8321978ac3198c2e = ()=>{
    const { edition: edition } = (0, $7GVWk.useUserContext)();
    return edition === 'premium';
};
const $37a656fc797532d9$export$5dc07a09424afaf8 = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return product?.name === 'jira';
};
const $37a656fc797532d9$export$10ee22f17966eb68 = ()=>{
    const { edition: edition, product: product } = (0, $7GVWk.useUserContext)();
    return product?.name === 'jira' && edition === 'free';
};
const $37a656fc797532d9$export$3b2a64cf46b3c332 = ()=>{
    const isJiraServiceManagement = $37a656fc797532d9$export$a0475dc95ccbcf50();
    const isFree = $37a656fc797532d9$export$cd55d04fc7ff1e12();
    return isJiraServiceManagement && isFree;
};
const $37a656fc797532d9$export$a0475dc95ccbcf50 = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return product?.name === 'jira-servicedesk';
};
const $37a656fc797532d9$export$50cabacb4690842b = ()=>{
    const isJiraProductDiscovery = $37a656fc797532d9$export$9631c56770d0fcbf();
    const isFree = $37a656fc797532d9$export$cd55d04fc7ff1e12();
    return isJiraProductDiscovery && isFree;
};
const $37a656fc797532d9$export$9631c56770d0fcbf = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return product?.name === 'jira-product-discovery';
};
const $37a656fc797532d9$export$aa30b981cc3856d4 = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return product?.name === 'devai';
};
const $37a656fc797532d9$export$caf5e021ec9bba69 = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return product?.name === 'loom';
};
const $37a656fc797532d9$export$182a2a33692f7de1 = ()=>{
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    // todo share with bxp-ui-signup's orgBasedOfferingIdMap
    const GUARD_PREMIUM = '2f5e5808-d501-450a-b246-b0bd50a0b72a';
    const GUARD_STANDARD = '1ac3b7dd-7141-414e-bc00-c890acc458b0';
    const GUARD_HAMS = 'GUARD_HAMS';
    const GUARD_OFFERING_IDS = [
        GUARD_PREMIUM,
        GUARD_STANDARD,
        GUARD_HAMS
    ];
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.managingOrg?.offeringIds?.some((offeringId)=>GUARD_OFFERING_IDS.includes(offeringId));
};
const $37a656fc797532d9$export$cf11cf307fde2f61 = ()=>{
    const { product: product, profile: profile } = (0, $7GVWk.useUserContext)();
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.existingSites.filter(({ cloudId: cloudId, products: products })=>profile.attributes?.managingOrg?.cloudIds?.includes(cloudId) && products.some(({ productKey: productKey })=>productKey === product?.key));
};
const $37a656fc797532d9$export$b5d9e6bb3dda68c5 = ()=>{
    const { product: product, profile: profile } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>profile.attributes?.existingSites.filter(({ hasAdminAccess: hasAdminAccess, products: products })=>product && hasAdminAccess && !products.some(({ productKey: productKey })=>product.key === (0, $fcO7r.ProductKey).SERVICE_COLLECTION ? // exclude sites with servco constituent products from site activation crossflow
                [
                    (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT,
                    (0, $fcO7r.ProductKey).JIRA_CUSTOMER_SERVICE
                ].includes(productKey) : productKey === product.key)) ?? [], [
        profile.attributes?.existingSites,
        product
    ]);
};
const $37a656fc797532d9$export$3ab50f0ad2618995 = ()=>{
    const crossflowEligibleSites = $37a656fc797532d9$export$b5d9e6bb3dda68c5();
    return crossflowEligibleSites?.length > 0;
};
const $37a656fc797532d9$export$fa35732e6a6c6c71 = ()=>{
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    if (profile.requestInProgress) return undefined;
    return !!profile.attributes?.hasAccountManagedByOrg;
};
const $37a656fc797532d9$export$33d0115fcc5e7239 = ()=>{
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    const managingOrgHasGuard = $37a656fc797532d9$export$182a2a33692f7de1();
    const managingOrgUserSites = $37a656fc797532d9$export$cf11cf307fde2f61();
    if (profile.requestInProgress) return undefined;
    return managingOrgHasGuard && managingOrgUserSites?.length;
};
const $37a656fc797532d9$export$b856a73c0ae1da63 = ()=>{
    const { profile: { requestInProgress: profileRequestInProgress, attributes: attributes }, user: { requestInProgress: userRequestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        // Checking for both user and profile request in progress,
        // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
        // This is probably not needed since this experiment is wrapped within <LoggedInHeroContainer /> and has the same logic.
        // But adding it here incase this experiment is used outside of <LoggedInHeroContainer />
        if (userRequestInProgress || profileRequestInProgress) return undefined;
        return (attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE)) && !attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $fcO7r.ProductKey).CONFLUENCE))) ?? false;
    }, [
        userRequestInProgress,
        profileRequestInProgress
    ]);
};
const $37a656fc797532d9$export$1f50eb8420f49d3e = (pathnames)=>{
    const { pathname: currentPathname } = (0, $1ka2O.useLocation)();
    if (pathnames.includes(currentPathname)) return true;
    return false;
};
const $37a656fc797532d9$export$417ca7eef6ef89c7 = (pathnames)=>{
    const { pathname: currentPathname } = (0, $1ka2O.useLocation)();
    const delocalizedPathname = (0, $80kL5.delocalizePathname)(currentPathname);
    return pathnames.some((pattern)=>{
        if (pattern.endsWith('/*')) {
            // Wildcard: match prefix
            const prefix = pattern.slice(0, -2); // Remove the /*
            return delocalizedPathname === prefix || delocalizedPathname.startsWith(`${prefix}/`);
        }
        return delocalizedPathname === pattern;
    });
};
const $37a656fc797532d9$export$b30de9e5e1e6ddb6 = ()=>{
    const loggedIn = $37a656fc797532d9$export$3b062b02b4537682();
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    const isMobile = (0, $5yuBp.useIsMobile)();
    const { profile: profile, loggedOutProfile: loggedOutProfile } = (0, $7GVWk.useUserContext)();
    const isConfluencePath = $37a656fc797532d9$export$417ca7eef6ef89c7([
        '/software/confluence/*'
    ]);
    if (loggedIn === undefined || loggedOut === undefined) return undefined;
    if (typeof window !== 'undefined' && window.cmsPageVariant) return false;
    const sites = loggedIn ? profile.attributes?.existingSites : loggedOutProfile?.sites;
    return isConfluencePath && isMobile && (sites?.some((site)=>site.products?.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).CONFLUENCE)) ?? false);
};
const $37a656fc797532d9$export$da27afec777e5a82 = ()=>{
    const loggedIn = $37a656fc797532d9$export$3b062b02b4537682();
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    const isMobile = (0, $5yuBp.useIsMobile)();
    const { profile: profile, loggedOutProfile: loggedOutProfile } = (0, $7GVWk.useUserContext)();
    const isJiraPath = $37a656fc797532d9$export$417ca7eef6ef89c7([
        '/software/jira/*'
    ]);
    const isJiraProductDiscoveryPath = $37a656fc797532d9$export$417ca7eef6ef89c7([
        '/software/jira/product-discovery/*'
    ]);
    const isJiraAgilePath = $37a656fc797532d9$export$417ca7eef6ef89c7([
        '/software/jira/agile/*'
    ]);
    if (loggedIn === undefined || loggedOut === undefined) return undefined;
    if (typeof window !== 'undefined' && window.cmsPageVariant) return false;
    const sites = loggedIn ? profile.attributes?.existingSites : loggedOutProfile?.sites;
    return isJiraPath && isMobile && !isJiraProductDiscoveryPath && !isJiraAgilePath && (sites?.some((site)=>site.products?.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE)) ?? false);
};
const $37a656fc797532d9$export$626907243cad789 = ()=>{
    const { product: product, edition: edition } = (0, $7GVWk.useUserContext)();
    const upgradableSites = $37a656fc797532d9$export$f209e5281b75b7a1();
    // you need to be in a paid product edition flow
    if (!product || edition === 'free') return undefined;
    return !!upgradableSites?.length;
};
const $37a656fc797532d9$export$ced14a2b669aff9a = ()=>{
    const upliftableSites = $37a656fc797532d9$export$9a364c26a41530c6();
    return !!upliftableSites?.length;
};
const $37a656fc797532d9$export$cb6c82b1dd091b1 = ()=>{
    const upgradableStandardSites = $37a656fc797532d9$export$d51a19bb23af218a();
    return !!upgradableStandardSites?.length;
};
const $37a656fc797532d9$export$cc01f81ad039310f = ()=>{
    const isConfluenceIntent = $37a656fc797532d9$export$c0fe219adfba1c8c();
    const isLoggedIn = $37a656fc797532d9$export$3b062b02b4537682();
    const isPremiumIntent = $37a656fc797532d9$export$8321978ac3198c2e();
    const s2pUpgradeEligible = $37a656fc797532d9$export$cb6c82b1dd091b1();
    return isConfluenceIntent && isLoggedIn && !(isPremiumIntent && s2pUpgradeEligible);
};
const $37a656fc797532d9$export$3efd720c078c8268 = ()=>{
    const isJiraIntent = $37a656fc797532d9$export$5dc07a09424afaf8();
    const isLoggedIn = $37a656fc797532d9$export$3b062b02b4537682();
    const isPremiumIntent = $37a656fc797532d9$export$8321978ac3198c2e();
    const s2pUpgradeEligible = $37a656fc797532d9$export$cb6c82b1dd091b1();
    return isJiraIntent && isLoggedIn && !(isPremiumIntent && s2pUpgradeEligible);
};
const $37a656fc797532d9$export$d51a19bb23af218a = ()=>{
    const { product: product, edition: edition, profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (!product?.key || requestInProgress) return undefined;
        const eligibleProducts = [
            (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
            (0, $fcO7r.ProductKey).CONFLUENCE,
            (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY
        ];
        if (edition !== 'premium' || !eligibleProducts.includes(product.key)) return undefined;
        return attributes?.existingSites.filter(({ hasAdminAccess: hasAdminAccess, products: products })=>hasAdminAccess && products.some(({ productKey: productKey, productEdition: productEdition, entitlementId: entitlementId, billingSourceSystem: billingSourceSystem })=>productKey === product.key && productEdition === 'standard' && entitlementId !== undefined && billingSourceSystem !== undefined)) ?? [];
    }, [
        product?.key,
        edition,
        attributes?.existingSites,
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$f209e5281b75b7a1 = ()=>{
    const { product: product, profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    const isGateEnabledForEntitlementCheck = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).includeEntitlementIdCheckInCohortsGate);
    return (0, $1oC0p.useMemo)(()=>{
        if (!product?.key || requestInProgress) return undefined;
        return attributes?.existingSites.filter(({ products: products })=>products.some(({ productKey: productKey, productEdition: productEdition, partOfCollection: partOfCollection, entitlementId: entitlementId, billingSourceSystem: billingSourceSystem })=>isGateEnabledForEntitlementCheck ? (productKey === product.key || partOfCollection === product.key) && productEdition === 'free' && entitlementId !== undefined && billingSourceSystem !== undefined : (productKey === product.key || partOfCollection === product.key) && productEdition === 'free')) ?? [];
    }, [
        product?.key,
        attributes?.existingSites,
        requestInProgress,
        isGateEnabledForEntitlementCheck
    ]);
};
const $37a656fc797532d9$export$9a364c26a41530c6 = ()=>{
    const { product: product, profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $7GVWk.useUserContext)();
    return (0, $1oC0p.useMemo)(()=>{
        if (!product?.key || requestInProgress) return undefined;
        // currently only applies to teamwork collection
        if (product.key !== (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION) return [];
        const constituentProducts = [
            (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
            (0, $fcO7r.ProductKey).CONFLUENCE,
            (0, $fcO7r.ProductKey).LOOM
        ];
        return attributes?.existingSites.filter(({ products: products })=>products.some(({ productKey: productKey, partOfCollection: partOfCollection })=>constituentProducts.includes(productKey) && !partOfCollection)) ?? [];
    }, [
        product?.key,
        attributes?.existingSites,
        requestInProgress
    ]);
};
const $37a656fc797532d9$export$46259f1c5dadf021 = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const { bundle: bundle } = (0, $3dtkR.useProductIntent)(location.href);
    return bundle === $37a656fc797532d9$export$39f198badfd10683;
};
const $37a656fc797532d9$export$3714723c568623ba = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    if (!product) return undefined;
    return product.key === (0, $fcO7r.ProductKey).SERVICE_COLLECTION;
};
const $37a656fc797532d9$export$339db86d4934ad1f = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    if (!product) return undefined;
    return product.key === (0, $fcO7r.ProductKey).STATUSPAGE;
};
const $37a656fc797532d9$export$d8884d6708cb94a7 = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    if (!product) return undefined;
    return product.key === (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION;
};
const $37a656fc797532d9$export$7be2df8926e395bf = ()=>{
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.existingSites.some(({ products: products })=>products.some(({ partOfCollection: partOfCollection })=>partOfCollection === (0, $fcO7r.ProductKey).SERVICE_COLLECTION));
};
const $37a656fc797532d9$export$bc61bdb4c380dd8 = ()=>{
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.existingSites.some(({ products: products })=>products.some(({ partOfCollection: partOfCollection })=>partOfCollection === (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION));
};
const $37a656fc797532d9$export$e31fbf0af7c148e4 = ()=>{
    const { userAgent: userAgent } = (0, $5mv0J.useSSRLoginState)();
    const { isDesktop: isDesktop } = userAgent === undefined ? {} : (0, $kS3iu.getSelectorsByUserAgent)(userAgent) ?? {};
    return isDesktop;
};
const $37a656fc797532d9$export$f0f246e4b54f5cc8 = ()=>{
    const { product: product, profile: profile } = (0, $7GVWk.useUserContext)();
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.existingProductsFromOrg.some(({ productKey: productKey })=>productKey === product?.key);
};
const $37a656fc797532d9$export$2ca4a5691b50e92f = ()=>{
    const { product: product, profile: profile } = (0, $7GVWk.useUserContext)();
    const hasServiceCollection = $37a656fc797532d9$export$7be2df8926e395bf();
    const hasTeamworkCollection = $37a656fc797532d9$export$bc61bdb4c380dd8();
    if (profile.requestInProgress) return undefined;
    if (product?.key === (0, $fcO7r.ProductKey).SERVICE_COLLECTION) return hasServiceCollection;
    if (product?.key === (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION) return hasTeamworkCollection;
    return profile.attributes?.existingSites.some(({ products: products })=>products.some(({ productKey: productKey })=>productKey === product?.key));
};
const $37a656fc797532d9$export$a810ea9e597e4b89 = ()=>{
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    const { loggedOutProfile: loggedOutProfile } = (0, $7GVWk.useUserContext)();
    if (loggedOut === undefined) return undefined;
    if (!loggedOut) return false;
    return loggedOutProfile?.sites && loggedOutProfile.sites.length > 0 && loggedOutProfile.sites.some(({ products: products })=>products && products.length > 0);
};
const $37a656fc797532d9$export$8e74edbd6f6309e9 = ()=>{
    const isLoggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    const { loggedOutProfile: loggedOutProfile } = (0, $7GVWk.useUserContext)();
    if (isLoggedOut === undefined) return undefined;
    if (!isLoggedOut) return false;
    const hasSites = loggedOutProfile?.sites && loggedOutProfile.sites.length > 0 && loggedOutProfile.sites.some(({ products: products })=>products && products.length > 0);
    return !hasSites;
};
const $37a656fc797532d9$export$1b0e0e9d76f07fbf = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $7GVWk.useUserContext)();
    return transactionAccounts.length > 1;
};
const $37a656fc797532d9$export$421bb31bf2b802f9 = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $7GVWk.useUserContext)();
    const result = transactionAccounts.some((account)=>{
        const { partnerStatus: partnerStatus } = account;
        // Check if any field in partnerStatus is not null
        return partnerStatus.discountTier !== null || partnerStatus.programLevelGlobal !== null || partnerStatus.externalSystemIdentifier !== null || partnerStatus.programLevel !== null;
    });
    console.log('useHasPartnerStatusCohort result:', result, 'transactionAccounts:', transactionAccounts);
    return result;
};
const $37a656fc797532d9$export$724a9c1f66c780e = ()=>{
    const isLoggedIn = $37a656fc797532d9$export$3b062b02b4537682();
    const hasPartnerStatus = $37a656fc797532d9$export$421bb31bf2b802f9();
    const hasMultipleAccounts = $37a656fc797532d9$export$1b0e0e9d76f07fbf();
    return isLoggedIn && hasPartnerStatus && hasMultipleAccounts;
};
const $37a656fc797532d9$export$5d6fa06f1d687f9c = ()=>{
    const loggedIn = $37a656fc797532d9$export$3b062b02b4537682();
    const loggedOut = $37a656fc797532d9$export$2f15ce1cde67833e();
    const { profile: profile, loggedOutProfile: loggedOutProfile } = (0, $7GVWk.useUserContext)();
    const { pathname: pathname } = (0, $1ka2O.useLocation)();
    if (loggedIn === undefined || loggedOut === undefined) return undefined;
    // Check if user is on the /software/rovo path (handles locale-prefixed paths like /en/software/rovo)
    // Ensure the path includes /software/rovo AND ends with it (no subpages or appended text)
    const isRovoPath = pathname.includes('/software/rovo') && pathname.endsWith('/software/rovo') || pathname.includes('/search');
    const sites = loggedIn ? profile.attributes?.existingSites : loggedOutProfile?.sites;
    return isRovoPath && (sites?.some((site)=>site.products?.some(({ productKey: productKey })=>productKey === (0, $fcO7r.ProductKey).ROVO)) ?? false);
};
const $37a656fc797532d9$export$94261b4b0b38f1cd = ()=>{
    if (typeof window === 'undefined') return false;
    const urlParams = new URLSearchParams(window.location.search);
    const templateId = urlParams.get('templateId');
    const supportedTemplates = new Set([
        (0, $fcO7r.TemplateKeys).Kanban,
        (0, $fcO7r.TemplateKeys).Scrum
    ]);
    if (templateId) return supportedTemplates.has(templateId);
    return !templateId;
};
const $37a656fc797532d9$export$3bf16ac9e0f0f9a = ()=>{
    if (typeof window === 'undefined') return false;
    const urlParams = new URLSearchParams(window.location.search);
    const products = urlParams.get('products');
    return products === 'com.atlassian.teamwork-collection';
};
const $37a656fc797532d9$export$79db58cc9c75d79 = ()=>{
    if (typeof window === 'undefined') return false;
    const urlParams = new URLSearchParams(window.location.search);
    const products = urlParams.get('products');
    const edition = urlParams.get('edition');
    const isTWC = products === (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION;
    const isPaidEdition = edition === 'standard' || edition === 'premium';
    return isTWC && isPaidEdition;
};
const $37a656fc797532d9$export$c561bb579e60ca35 = ()=>{
    const { search: search } = (0, $1ka2O.useLocation)();
    const params = search.split('&');
    const subAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('subAnchor'))[0]?.split('=')[1] || ''));
    return subAnchor;
};
const $37a656fc797532d9$export$c7262d790750093d = ()=>{
    const subAnchor = $37a656fc797532d9$export$c561bb579e60ca35();
    return (0, $ik40B.isInContextualBanditsSubAnchor)(subAnchor);
};
const $37a656fc797532d9$export$74b50ac429b5c3cf = ()=>{
    const isDesktop = $37a656fc797532d9$export$e31fbf0af7c148e4();
    if (!isDesktop) return false;
    if (typeof window === 'undefined') return false;
    const urlParams = new URLSearchParams(window.location.search);
    const teamType = urlParams.get('team_type');
    const signupSource = urlParams.get('signupSource');
    // exclude users who are journeying through /software/jira/dev.
    // these users will be forced into the coding agent question and
    // should not be included in the experiment.
    if (signupSource === $37a656fc797532d9$export$328c3dd1f446a77) return false;
    return !!teamType && (0, $lcW33.LANDING_GATE_TECH_TEAM_TYPES).includes(teamType);
};

});
parcelRegister("kS3iu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $f31b68886732dfa3$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $1oC0p = parcelRequire("1oC0p");
var $f31b68886732dfa3$var$React__default = $f31b68886732dfa3$var$_interopDefault($1oC0p);

var $1cF8J = parcelRequire("1cF8J");
var $f31b68886732dfa3$var$ClientUAInstance = new $1cF8J();
var $f31b68886732dfa3$var$browser = $f31b68886732dfa3$var$ClientUAInstance.getBrowser();
var $f31b68886732dfa3$var$cpu = $f31b68886732dfa3$var$ClientUAInstance.getCPU();
var $f31b68886732dfa3$var$device = $f31b68886732dfa3$var$ClientUAInstance.getDevice();
var $f31b68886732dfa3$var$engine = $f31b68886732dfa3$var$ClientUAInstance.getEngine();
var $f31b68886732dfa3$var$os = $f31b68886732dfa3$var$ClientUAInstance.getOS();
var $f31b68886732dfa3$var$ua = $f31b68886732dfa3$var$ClientUAInstance.getUA();
var $f31b68886732dfa3$var$setUa = function setUa(userAgentString) {
    return $f31b68886732dfa3$var$ClientUAInstance.setUA(userAgentString);
};
var $f31b68886732dfa3$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $1cF8J(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $f31b68886732dfa3$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $f31b68886732dfa3$var$ClientUAInstance,
    browser: $f31b68886732dfa3$var$browser,
    cpu: $f31b68886732dfa3$var$cpu,
    device: $f31b68886732dfa3$var$device,
    engine: $f31b68886732dfa3$var$engine,
    os: $f31b68886732dfa3$var$os,
    ua: $f31b68886732dfa3$var$ua,
    setUa: $f31b68886732dfa3$var$setUa,
    parseUserAgent: $f31b68886732dfa3$var$parseUserAgent
});
function $f31b68886732dfa3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f31b68886732dfa3$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f31b68886732dfa3$var$ownKeys(Object(source), true).forEach(function(key) {
            $f31b68886732dfa3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f31b68886732dfa3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f31b68886732dfa3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f31b68886732dfa3$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $f31b68886732dfa3$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f31b68886732dfa3$var$_typeof(obj);
}
function $f31b68886732dfa3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f31b68886732dfa3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f31b68886732dfa3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f31b68886732dfa3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f31b68886732dfa3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f31b68886732dfa3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f31b68886732dfa3$var$_extends() {
    $f31b68886732dfa3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f31b68886732dfa3$var$_extends.apply(this, arguments);
}
function $f31b68886732dfa3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f31b68886732dfa3$var$_setPrototypeOf(subClass, superClass);
}
function $f31b68886732dfa3$var$_getPrototypeOf(o) {
    $f31b68886732dfa3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f31b68886732dfa3$var$_getPrototypeOf(o);
}
function $f31b68886732dfa3$var$_setPrototypeOf(o, p) {
    $f31b68886732dfa3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f31b68886732dfa3$var$_setPrototypeOf(o, p);
}
function $f31b68886732dfa3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f31b68886732dfa3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f31b68886732dfa3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f31b68886732dfa3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f31b68886732dfa3$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f31b68886732dfa3$var$_assertThisInitialized(self);
}
function $f31b68886732dfa3$var$_slicedToArray(arr, i) {
    return $f31b68886732dfa3$var$_arrayWithHoles(arr) || $f31b68886732dfa3$var$_iterableToArrayLimit(arr, i) || $f31b68886732dfa3$var$_unsupportedIterableToArray(arr, i) || $f31b68886732dfa3$var$_nonIterableRest();
}
function $f31b68886732dfa3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f31b68886732dfa3$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f31b68886732dfa3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f31b68886732dfa3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f31b68886732dfa3$var$_arrayLikeToArray(o, minLen);
}
function $f31b68886732dfa3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f31b68886732dfa3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $f31b68886732dfa3$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $f31b68886732dfa3$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $f31b68886732dfa3$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $f31b68886732dfa3$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $f31b68886732dfa3$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $f31b68886732dfa3$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $f31b68886732dfa3$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $f31b68886732dfa3$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $f31b68886732dfa3$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $f31b68886732dfa3$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $f31b68886732dfa3$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $f31b68886732dfa3$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $f31b68886732dfa3$var$InitialDeviceTypes;
    }
};
var $f31b68886732dfa3$var$setUserAgent = function setUserAgent(userAgent) {
    return $f31b68886732dfa3$var$setUa(userAgent);
};
var $f31b68886732dfa3$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $f31b68886732dfa3$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $f31b68886732dfa3$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $f31b68886732dfa3$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $f31b68886732dfa3$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $f31b68886732dfa3$var$setDefaults(browser.major),
        browserFullVersion: $f31b68886732dfa3$var$setDefaults(browser.version),
        browserName: $f31b68886732dfa3$var$setDefaults(browser.name),
        engineName: $f31b68886732dfa3$var$setDefaults(engine.name),
        engineVersion: $f31b68886732dfa3$var$setDefaults(engine.version),
        osName: $f31b68886732dfa3$var$setDefaults(os.name),
        osVersion: $f31b68886732dfa3$var$setDefaults(os.version),
        userAgent: $f31b68886732dfa3$var$setDefaults(ua)
    };
};
var $f31b68886732dfa3$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $f31b68886732dfa3$var$_objectSpread2({}, type, {
        vendor: $f31b68886732dfa3$var$setDefaults(device.vendor),
        model: $f31b68886732dfa3$var$setDefaults(device.model),
        os: $f31b68886732dfa3$var$setDefaults(os.name),
        osVersion: $f31b68886732dfa3$var$setDefaults(os.version),
        ua: $f31b68886732dfa3$var$setDefaults(ua)
    });
};
var $f31b68886732dfa3$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $f31b68886732dfa3$var$setDefaults(engine.name),
        engineVersion: $f31b68886732dfa3$var$setDefaults(engine.version),
        osName: $f31b68886732dfa3$var$setDefaults(os.name),
        osVersion: $f31b68886732dfa3$var$setDefaults(os.version),
        userAgent: $f31b68886732dfa3$var$setDefaults(ua)
    };
};
var $f31b68886732dfa3$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $f31b68886732dfa3$var$setDefaults(engine.name),
        engineVersion: $f31b68886732dfa3$var$setDefaults(engine.version),
        osName: $f31b68886732dfa3$var$setDefaults(os.name),
        osVersion: $f31b68886732dfa3$var$setDefaults(os.version),
        userAgent: $f31b68886732dfa3$var$setDefaults(ua)
    };
};
var $f31b68886732dfa3$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $f31b68886732dfa3$var$setDefaults(engine.name),
        engineVersion: $f31b68886732dfa3$var$setDefaults(engine.version),
        osName: $f31b68886732dfa3$var$setDefaults(os.name),
        osVersion: $f31b68886732dfa3$var$setDefaults(os.version),
        userAgent: $f31b68886732dfa3$var$setDefaults(ua)
    };
};
var $f31b68886732dfa3$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $f31b68886732dfa3$var$setDefaults(device.vendor),
        model: $f31b68886732dfa3$var$setDefaults(device.model),
        engineName: $f31b68886732dfa3$var$setDefaults(engine.name),
        engineVersion: $f31b68886732dfa3$var$setDefaults(engine.version),
        osName: $f31b68886732dfa3$var$setDefaults(os.name),
        osVersion: $f31b68886732dfa3$var$setDefaults(os.version),
        userAgent: $f31b68886732dfa3$var$setDefaults(ua)
    };
};
function $f31b68886732dfa3$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $f31b68886732dfa3$var$parseUserAgent(userAgent) : $f31b68886732dfa3$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $f31b68886732dfa3$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $f31b68886732dfa3$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $f31b68886732dfa3$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $f31b68886732dfa3$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $f31b68886732dfa3$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $f31b68886732dfa3$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $f31b68886732dfa3$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $f31b68886732dfa3$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $f31b68886732dfa3$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $f31b68886732dfa3$var$DeviceTypes.Mobile;
};
var $f31b68886732dfa3$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $f31b68886732dfa3$var$DeviceTypes.Tablet;
};
var $f31b68886732dfa3$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $f31b68886732dfa3$var$DeviceTypes.Mobile || type === $f31b68886732dfa3$var$DeviceTypes.Tablet;
};
var $f31b68886732dfa3$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $f31b68886732dfa3$var$DeviceTypes.SmartTv;
};
var $f31b68886732dfa3$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $f31b68886732dfa3$var$DeviceTypes.Browser;
};
var $f31b68886732dfa3$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $f31b68886732dfa3$var$DeviceTypes.Wearable;
};
var $f31b68886732dfa3$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $f31b68886732dfa3$var$DeviceTypes.Console;
};
var $f31b68886732dfa3$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $f31b68886732dfa3$var$DeviceTypes.Embedded;
};
var $f31b68886732dfa3$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $f31b68886732dfa3$var$setDefaults(vendor);
};
var $f31b68886732dfa3$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $f31b68886732dfa3$var$setDefaults(model);
};
var $f31b68886732dfa3$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $f31b68886732dfa3$var$setDefaults(type, 'browser');
}; // os types
var $f31b68886732dfa3$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $f31b68886732dfa3$var$OsTypes.Android;
};
var $f31b68886732dfa3$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $f31b68886732dfa3$var$OsTypes.Windows;
};
var $f31b68886732dfa3$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $f31b68886732dfa3$var$OsTypes.MAC_OS;
};
var $f31b68886732dfa3$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $f31b68886732dfa3$var$OsTypes.WindowsPhone;
};
var $f31b68886732dfa3$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $f31b68886732dfa3$var$OsTypes.IOS;
};
var $f31b68886732dfa3$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $f31b68886732dfa3$var$setDefaults(version);
};
var $f31b68886732dfa3$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $f31b68886732dfa3$var$setDefaults(name);
}; // browser types
var $f31b68886732dfa3$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.Chrome;
};
var $f31b68886732dfa3$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.Firefox;
};
var $f31b68886732dfa3$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.Chromium;
};
var $f31b68886732dfa3$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.Edge;
};
var $f31b68886732dfa3$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.Yandex;
};
var $f31b68886732dfa3$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.Safari || name === $f31b68886732dfa3$var$BrowserTypes.MobileSafari;
};
var $f31b68886732dfa3$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.MobileSafari;
};
var $f31b68886732dfa3$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.Opera;
};
var $f31b68886732dfa3$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.InternetExplorer || name === $f31b68886732dfa3$var$BrowserTypes.Ie;
};
var $f31b68886732dfa3$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.MIUI;
};
var $f31b68886732dfa3$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $f31b68886732dfa3$var$BrowserTypes.SamsungBrowser;
};
var $f31b68886732dfa3$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $f31b68886732dfa3$var$setDefaults(version);
};
var $f31b68886732dfa3$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $f31b68886732dfa3$var$setDefaults(major);
};
var $f31b68886732dfa3$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $f31b68886732dfa3$var$setDefaults(name);
}; // engine types
var $f31b68886732dfa3$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $f31b68886732dfa3$var$setDefaults(name);
};
var $f31b68886732dfa3$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $f31b68886732dfa3$var$setDefaults(version);
};
var $f31b68886732dfa3$var$isElectronType = function isElectronType() {
    var nav = $f31b68886732dfa3$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $f31b68886732dfa3$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $f31b68886732dfa3$var$getIOS13 = function getIOS13() {
    var nav = $f31b68886732dfa3$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $f31b68886732dfa3$var$getIPad13 = function getIPad13() {
    return $f31b68886732dfa3$var$isIOS13Check('iPad');
};
var $f31b68886732dfa3$var$getIphone13 = function getIphone13() {
    return $f31b68886732dfa3$var$isIOS13Check('iPhone');
};
var $f31b68886732dfa3$var$getIPod13 = function getIPod13() {
    return $f31b68886732dfa3$var$isIOS13Check('iPod');
};
var $f31b68886732dfa3$var$getUseragent = function getUseragent(userAg) {
    return $f31b68886732dfa3$var$setDefaults(userAg);
};
function $f31b68886732dfa3$var$buildSelectorsObject(options) {
    var _ref = options ? options : $f31b68886732dfa3$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $f31b68886732dfa3$var$isSmartTVType(device),
        isConsole: $f31b68886732dfa3$var$isConsoleType(device),
        isWearable: $f31b68886732dfa3$var$isWearableType(device),
        isEmbedded: $f31b68886732dfa3$var$isEmbeddedType(device),
        isMobileSafari: $f31b68886732dfa3$var$isMobileSafariType(browser) || $f31b68886732dfa3$var$getIPad13(),
        isChromium: $f31b68886732dfa3$var$isChromiumType(browser),
        isMobile: $f31b68886732dfa3$var$isMobileAndTabletType(device) || $f31b68886732dfa3$var$getIPad13(),
        isMobileOnly: $f31b68886732dfa3$var$isMobileType(device),
        isTablet: $f31b68886732dfa3$var$isTabletType(device) || $f31b68886732dfa3$var$getIPad13(),
        isBrowser: $f31b68886732dfa3$var$isBrowserType(device),
        isDesktop: $f31b68886732dfa3$var$isBrowserType(device),
        isAndroid: $f31b68886732dfa3$var$isAndroidType(os),
        isWinPhone: $f31b68886732dfa3$var$isWinPhoneType(os),
        isIOS: $f31b68886732dfa3$var$isIOSType(os) || $f31b68886732dfa3$var$getIPad13(),
        isChrome: $f31b68886732dfa3$var$isChromeType(browser),
        isFirefox: $f31b68886732dfa3$var$isFirefoxType(browser),
        isSafari: $f31b68886732dfa3$var$isSafariType(browser),
        isOpera: $f31b68886732dfa3$var$isOperaType(browser),
        isIE: $f31b68886732dfa3$var$isIEType(browser),
        osVersion: $f31b68886732dfa3$var$getOsVersion(os),
        osName: $f31b68886732dfa3$var$getOsName(os),
        fullBrowserVersion: $f31b68886732dfa3$var$getBrowserFullVersion(browser),
        browserVersion: $f31b68886732dfa3$var$getBrowserVersion(browser),
        browserName: $f31b68886732dfa3$var$getBrowserName(browser),
        mobileVendor: $f31b68886732dfa3$var$getMobileVendor(device),
        mobileModel: $f31b68886732dfa3$var$getMobileModel(device),
        engineName: $f31b68886732dfa3$var$getEngineName(engine),
        engineVersion: $f31b68886732dfa3$var$getEngineVersion(engine),
        getUA: $f31b68886732dfa3$var$getUseragent(ua),
        isEdge: $f31b68886732dfa3$var$isEdgeType(browser) || $f31b68886732dfa3$var$isEdgeChromiumType(ua),
        isYandex: $f31b68886732dfa3$var$isYandexType(browser),
        deviceType: $f31b68886732dfa3$var$getDeviceType(device),
        isIOS13: $f31b68886732dfa3$var$getIOS13(),
        isIPad13: $f31b68886732dfa3$var$getIPad13(),
        isIPhone13: $f31b68886732dfa3$var$getIphone13(),
        isIPod13: $f31b68886732dfa3$var$getIPod13(),
        isElectron: $f31b68886732dfa3$var$isElectronType(),
        isEdgeChromium: $f31b68886732dfa3$var$isEdgeChromiumType(ua),
        isLegacyEdge: $f31b68886732dfa3$var$isEdgeType(browser) && !$f31b68886732dfa3$var$isEdgeChromiumType(ua),
        isWindows: $f31b68886732dfa3$var$isWindowsType(os),
        isMacOs: $f31b68886732dfa3$var$isMacOsType(os),
        isMIUI: $f31b68886732dfa3$var$isMIUIType(browser),
        isSamsungBrowser: $f31b68886732dfa3$var$isSamsungBrowserType(browser)
    };
}
var $f31b68886732dfa3$var$isSmartTV = $f31b68886732dfa3$var$isSmartTVType($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$isConsole = $f31b68886732dfa3$var$isConsoleType($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$isWearable = $f31b68886732dfa3$var$isWearableType($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$isEmbedded = $f31b68886732dfa3$var$isEmbeddedType($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$isMobileSafari = $f31b68886732dfa3$var$isMobileSafariType($f31b68886732dfa3$var$browser) || $f31b68886732dfa3$var$getIPad13();
var $f31b68886732dfa3$var$isChromium = $f31b68886732dfa3$var$isChromiumType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$isMobile = $f31b68886732dfa3$var$isMobileAndTabletType($f31b68886732dfa3$var$device) || $f31b68886732dfa3$var$getIPad13();
var $f31b68886732dfa3$var$isMobileOnly = $f31b68886732dfa3$var$isMobileType($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$isTablet = $f31b68886732dfa3$var$isTabletType($f31b68886732dfa3$var$device) || $f31b68886732dfa3$var$getIPad13();
var $f31b68886732dfa3$var$isBrowser = $f31b68886732dfa3$var$isBrowserType($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$isDesktop = $f31b68886732dfa3$var$isBrowserType($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$isAndroid = $f31b68886732dfa3$var$isAndroidType($f31b68886732dfa3$var$os);
var $f31b68886732dfa3$var$isWinPhone = $f31b68886732dfa3$var$isWinPhoneType($f31b68886732dfa3$var$os);
var $f31b68886732dfa3$var$isIOS = $f31b68886732dfa3$var$isIOSType($f31b68886732dfa3$var$os) || $f31b68886732dfa3$var$getIPad13();
var $f31b68886732dfa3$var$isChrome = $f31b68886732dfa3$var$isChromeType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$isFirefox = $f31b68886732dfa3$var$isFirefoxType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$isSafari = $f31b68886732dfa3$var$isSafariType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$isOpera = $f31b68886732dfa3$var$isOperaType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$isIE = $f31b68886732dfa3$var$isIEType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$osVersion = $f31b68886732dfa3$var$getOsVersion($f31b68886732dfa3$var$os);
var $f31b68886732dfa3$var$osName = $f31b68886732dfa3$var$getOsName($f31b68886732dfa3$var$os);
var $f31b68886732dfa3$var$fullBrowserVersion = $f31b68886732dfa3$var$getBrowserFullVersion($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$browserVersion = $f31b68886732dfa3$var$getBrowserVersion($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$browserName = $f31b68886732dfa3$var$getBrowserName($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$mobileVendor = $f31b68886732dfa3$var$getMobileVendor($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$mobileModel = $f31b68886732dfa3$var$getMobileModel($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$engineName = $f31b68886732dfa3$var$getEngineName($f31b68886732dfa3$var$engine);
var $f31b68886732dfa3$var$engineVersion = $f31b68886732dfa3$var$getEngineVersion($f31b68886732dfa3$var$engine);
var $f31b68886732dfa3$var$getUA = $f31b68886732dfa3$var$getUseragent($f31b68886732dfa3$var$ua);
var $f31b68886732dfa3$var$isEdge = $f31b68886732dfa3$var$isEdgeType($f31b68886732dfa3$var$browser) || $f31b68886732dfa3$var$isEdgeChromiumType($f31b68886732dfa3$var$ua);
var $f31b68886732dfa3$var$isYandex = $f31b68886732dfa3$var$isYandexType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$deviceType = $f31b68886732dfa3$var$getDeviceType($f31b68886732dfa3$var$device);
var $f31b68886732dfa3$var$isIOS13 = $f31b68886732dfa3$var$getIOS13();
var $f31b68886732dfa3$var$isIPad13 = $f31b68886732dfa3$var$getIPad13();
var $f31b68886732dfa3$var$isIPhone13 = $f31b68886732dfa3$var$getIphone13();
var $f31b68886732dfa3$var$isIPod13 = $f31b68886732dfa3$var$getIPod13();
var $f31b68886732dfa3$var$isElectron = $f31b68886732dfa3$var$isElectronType();
var $f31b68886732dfa3$var$isEdgeChromium = $f31b68886732dfa3$var$isEdgeChromiumType($f31b68886732dfa3$var$ua);
var $f31b68886732dfa3$var$isLegacyEdge = $f31b68886732dfa3$var$isEdgeType($f31b68886732dfa3$var$browser) && !$f31b68886732dfa3$var$isEdgeChromiumType($f31b68886732dfa3$var$ua);
var $f31b68886732dfa3$var$isWindows = $f31b68886732dfa3$var$isWindowsType($f31b68886732dfa3$var$os);
var $f31b68886732dfa3$var$isMacOs = $f31b68886732dfa3$var$isMacOsType($f31b68886732dfa3$var$os);
var $f31b68886732dfa3$var$isMIUI = $f31b68886732dfa3$var$isMIUIType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$isSamsungBrowser = $f31b68886732dfa3$var$isSamsungBrowserType($f31b68886732dfa3$var$browser);
var $f31b68886732dfa3$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $f31b68886732dfa3$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $f31b68886732dfa3$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $f31b68886732dfa3$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isAndroid ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isBrowser ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isIE ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isIOS ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isMobile ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isTablet ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isWinPhone ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $f31b68886732dfa3$var$isMobileOnly ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isSmartTV ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isConsole ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $f31b68886732dfa3$var$isWearable ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
var $f31b68886732dfa3$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $f31b68886732dfa3$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $f31b68886732dfa3$var$React__default.createElement($1oC0p.Fragment, null, children) : $f31b68886732dfa3$var$React__default.createElement("div", props, children) : null;
};
function $f31b68886732dfa3$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $f31b68886732dfa3$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $f31b68886732dfa3$var$_classCallCheck(this, _class);
            _this = $f31b68886732dfa3$var$_possibleConstructorReturn(this, $f31b68886732dfa3$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($f31b68886732dfa3$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($f31b68886732dfa3$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($f31b68886732dfa3$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $f31b68886732dfa3$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $f31b68886732dfa3$var$_typeof(window)) !== undefined && $f31b68886732dfa3$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $f31b68886732dfa3$var$React__default.createElement(WrappedComponent, $f31b68886732dfa3$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($f31b68886732dfa3$var$React__default.Component);
}
function $f31b68886732dfa3$var$useMobileOrientation() {
    var _useState = $1oC0p.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $f31b68886732dfa3$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $1oC0p.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $1oC0p.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $f31b68886732dfa3$var$_typeof(window)) !== undefined && $f31b68886732dfa3$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $f31b68886732dfa3$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $f31b68886732dfa3$var$parseUserAgent(hookUserAgent);
}
function $f31b68886732dfa3$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $f31b68886732dfa3$var$useDeviceData(hookUserAgent);
    var selectors = $f31b68886732dfa3$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
module.exports.AndroidView = $f31b68886732dfa3$var$AndroidView;
module.exports.BrowserTypes = $f31b68886732dfa3$var$BrowserTypes;
module.exports.BrowserView = $f31b68886732dfa3$var$BrowserView;
module.exports.ConsoleView = $f31b68886732dfa3$var$ConsoleView;
module.exports.CustomView = $f31b68886732dfa3$var$CustomView;
module.exports.IEView = $f31b68886732dfa3$var$IEView;
module.exports.IOSView = $f31b68886732dfa3$var$IOSView;
module.exports.MobileOnlyView = $f31b68886732dfa3$var$MobileOnlyView;
module.exports.MobileView = $f31b68886732dfa3$var$MobileView;
module.exports.OsTypes = $f31b68886732dfa3$var$OsTypes;
module.exports.SmartTVView = $f31b68886732dfa3$var$SmartTVView;
module.exports.TabletView = $f31b68886732dfa3$var$TabletView;
module.exports.WearableView = $f31b68886732dfa3$var$WearableView;
module.exports.WinPhoneView = $f31b68886732dfa3$var$WinPhoneView;
module.exports.browserName = $f31b68886732dfa3$var$browserName;
module.exports.browserVersion = $f31b68886732dfa3$var$browserVersion;
module.exports.deviceDetect = $f31b68886732dfa3$var$deviceDetect;
module.exports.deviceType = $f31b68886732dfa3$var$deviceType;
module.exports.engineName = $f31b68886732dfa3$var$engineName;
module.exports.engineVersion = $f31b68886732dfa3$var$engineVersion;
module.exports.fullBrowserVersion = $f31b68886732dfa3$var$fullBrowserVersion;
module.exports.getSelectorsByUserAgent = $f31b68886732dfa3$var$getSelectorsByUserAgent;
module.exports.getUA = $f31b68886732dfa3$var$getUA;
module.exports.isAndroid = $f31b68886732dfa3$var$isAndroid;
module.exports.isBrowser = $f31b68886732dfa3$var$isBrowser;
module.exports.isChrome = $f31b68886732dfa3$var$isChrome;
module.exports.isChromium = $f31b68886732dfa3$var$isChromium;
module.exports.isConsole = $f31b68886732dfa3$var$isConsole;
module.exports.isDesktop = $f31b68886732dfa3$var$isDesktop;
module.exports.isEdge = $f31b68886732dfa3$var$isEdge;
module.exports.isEdgeChromium = $f31b68886732dfa3$var$isEdgeChromium;
module.exports.isElectron = $f31b68886732dfa3$var$isElectron;
module.exports.isEmbedded = $f31b68886732dfa3$var$isEmbedded;
module.exports.isFirefox = $f31b68886732dfa3$var$isFirefox;
module.exports.isIE = $f31b68886732dfa3$var$isIE;
module.exports.isIOS = $f31b68886732dfa3$var$isIOS;
module.exports.isIOS13 = $f31b68886732dfa3$var$isIOS13;
module.exports.isIPad13 = $f31b68886732dfa3$var$isIPad13;
module.exports.isIPhone13 = $f31b68886732dfa3$var$isIPhone13;
module.exports.isIPod13 = $f31b68886732dfa3$var$isIPod13;
module.exports.isLegacyEdge = $f31b68886732dfa3$var$isLegacyEdge;
module.exports.isMIUI = $f31b68886732dfa3$var$isMIUI;
module.exports.isMacOs = $f31b68886732dfa3$var$isMacOs;
module.exports.isMobile = $f31b68886732dfa3$var$isMobile;
module.exports.isMobileOnly = $f31b68886732dfa3$var$isMobileOnly;
module.exports.isMobileSafari = $f31b68886732dfa3$var$isMobileSafari;
module.exports.isOpera = $f31b68886732dfa3$var$isOpera;
module.exports.isSafari = $f31b68886732dfa3$var$isSafari;
module.exports.isSamsungBrowser = $f31b68886732dfa3$var$isSamsungBrowser;
module.exports.isSmartTV = $f31b68886732dfa3$var$isSmartTV;
module.exports.isTablet = $f31b68886732dfa3$var$isTablet;
module.exports.isWearable = $f31b68886732dfa3$var$isWearable;
module.exports.isWinPhone = $f31b68886732dfa3$var$isWinPhone;
module.exports.isWindows = $f31b68886732dfa3$var$isWindows;
module.exports.isYandex = $f31b68886732dfa3$var$isYandex;
module.exports.mobileModel = $f31b68886732dfa3$var$mobileModel;
module.exports.mobileVendor = $f31b68886732dfa3$var$mobileVendor;
module.exports.osName = $f31b68886732dfa3$var$osName;
module.exports.osVersion = $f31b68886732dfa3$var$osVersion;
module.exports.parseUserAgent = $f31b68886732dfa3$var$parseUserAgent;
module.exports.setUserAgent = $f31b68886732dfa3$var$setUserAgent;
module.exports.useDeviceData = $f31b68886732dfa3$var$useDeviceData;
module.exports.useDeviceSelectors = $f31b68886732dfa3$var$useDeviceSelectors;
module.exports.useMobileOrientation = $f31b68886732dfa3$var$useMobileOrientation;
module.exports.withOrientationChange = $f31b68886732dfa3$var$withOrientationChange;

});
parcelRegister("1cF8J", function(module, exports) {
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});


parcelRegister("a0utR", function(module, exports) {

var $dUSo4 = parcelRequire("dUSo4");

var $5cbFW = parcelRequire("5cbFW");

var $jX8y7 = parcelRequire("jX8y7");
var $74918c48698d0732$require$isPlainObject = $jX8y7.isPlainObject;

var $4lQO5 = parcelRequire("4lQO5");

var $pY0nV = parcelRequire("pY0nV");

var $cM5eX = parcelRequire("cM5eX");
var $74918c48698d0732$require$postcssParse = $cM5eX.parse;
// Tags that can conceivably represent stand-alone media.
const $74918c48698d0732$var$mediaTags = [
    'img',
    'audio',
    'video',
    'picture',
    'svg',
    'object',
    'map',
    'iframe',
    'embed'
];
// Tags that are inherently vulnerable to being used in XSS attacks.
const $74918c48698d0732$var$vulnerableTags = [
    'script',
    'style'
];
function $74918c48698d0732$var$each(obj, cb) {
    if (obj) Object.keys(obj).forEach(function(key) {
        cb(obj[key], key);
    });
}
// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function $74918c48698d0732$var$has(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
// Returns those elements of `a` for which `cb(a)` returns truthy
function $74918c48698d0732$var$filter(a, cb) {
    const n = [];
    $74918c48698d0732$var$each(a, function(v) {
        if (cb(v)) n.push(v);
    });
    return n;
}
function $74918c48698d0732$var$isEmptyObject(obj) {
    for(const key in obj){
        if ($74918c48698d0732$var$has(obj, key)) return false;
    }
    return true;
}
function $74918c48698d0732$var$stringifySrcset(parsedSrcset) {
    return parsedSrcset.map(function(part) {
        if (!part.url) throw new Error('URL missing');
        return part.url + (part.w ? ` ${part.w}w` : '') + (part.h ? ` ${part.h}h` : '') + (part.d ? ` ${part.d}x` : '');
    }).join(', ');
}
module.exports = $74918c48698d0732$var$sanitizeHtml;
// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const $74918c48698d0732$var$VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105
function $74918c48698d0732$var$sanitizeHtml(html, options, _recursing) {
    if (html == null) return '';
    if (typeof html === 'number') html = html.toString();
    let result = '';
    // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
    let tempResult = '';
    function Frame(tag, attribs) {
        const that = this;
        this.tag = tag;
        this.attribs = attribs || {};
        this.tagPosition = result.length;
        this.text = ''; // Node inner text
        this.mediaChildren = [];
        this.updateParentNodeText = function() {
            if (stack.length) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.text += that.text;
            }
        };
        this.updateParentNodeMediaChildren = function() {
            if (stack.length && $74918c48698d0732$var$mediaTags.includes(this.tag)) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.mediaChildren.push(this.tag);
            }
        };
    }
    options = Object.assign({}, $74918c48698d0732$var$sanitizeHtml.defaults, options);
    options.parser = Object.assign({}, $74918c48698d0732$var$htmlParserDefaults, options.parser);
    const tagAllowed = function(name) {
        return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
    };
    // vulnerableTags
    $74918c48698d0732$var$vulnerableTags.forEach(function(tag) {
        if (tagAllowed(tag) && !options.allowVulnerableTags) console.warn(`

\u{26A0}\u{FE0F} Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
    });
    // Tags that contain something other than HTML, or where discarding
    // the text when the tag is disallowed makes sense for other reasons.
    // If we are not allowing these tags, we should drop their content too.
    // For other tags you would drop the tag but keep its content.
    const nonTextTagsArray = options.nonTextTags || [
        'script',
        'style',
        'textarea',
        'option'
    ];
    let allowedAttributesMap;
    let allowedAttributesGlobMap;
    if (options.allowedAttributes) {
        allowedAttributesMap = {};
        allowedAttributesGlobMap = {};
        $74918c48698d0732$var$each(options.allowedAttributes, function(attributes, tag) {
            allowedAttributesMap[tag] = [];
            const globRegex = [];
            attributes.forEach(function(obj) {
                if (typeof obj === 'string' && obj.indexOf('*') >= 0) globRegex.push($5cbFW(obj).replace(/\\\*/g, '.*'));
                else allowedAttributesMap[tag].push(obj);
            });
            if (globRegex.length) allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
        });
    }
    const allowedClassesMap = {};
    const allowedClassesGlobMap = {};
    const allowedClassesRegexMap = {};
    $74918c48698d0732$var$each(options.allowedClasses, function(classes, tag) {
        // Implicitly allows the class attribute
        if (allowedAttributesMap) {
            if (!$74918c48698d0732$var$has(allowedAttributesMap, tag)) allowedAttributesMap[tag] = [];
            allowedAttributesMap[tag].push('class');
        }
        allowedClassesMap[tag] = classes;
        if (Array.isArray(classes)) {
            const globRegex = [];
            allowedClassesMap[tag] = [];
            allowedClassesRegexMap[tag] = [];
            classes.forEach(function(obj) {
                if (typeof obj === 'string' && obj.indexOf('*') >= 0) globRegex.push($5cbFW(obj).replace(/\\\*/g, '.*'));
                else if (obj instanceof RegExp) allowedClassesRegexMap[tag].push(obj);
                else allowedClassesMap[tag].push(obj);
            });
            if (globRegex.length) allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
        }
    });
    const transformTagsMap = {};
    let transformTagsAll;
    $74918c48698d0732$var$each(options.transformTags, function(transform, tag) {
        let transFun;
        if (typeof transform === 'function') transFun = transform;
        else if (typeof transform === 'string') transFun = $74918c48698d0732$var$sanitizeHtml.simpleTransform(transform);
        if (tag === '*') transformTagsAll = transFun;
        else transformTagsMap[tag] = transFun;
    });
    let depth;
    let stack;
    let skipMap;
    let transformMap;
    let skipText;
    let skipTextDepth;
    let addedText = false;
    initializeState();
    const parser = new $dUSo4.Parser({
        onopentag: function(name, attribs) {
            // If `enforceHtmlBoundary` is `true` and this has found the opening
            // `html` tag, reset the state.
            if (options.enforceHtmlBoundary && name === 'html') initializeState();
            if (skipText) {
                skipTextDepth++;
                return;
            }
            const frame = new Frame(name, attribs);
            stack.push(frame);
            let skip = false;
            const hasText = !!frame.text;
            let transformedTag;
            if ($74918c48698d0732$var$has(transformTagsMap, name)) {
                transformedTag = transformTagsMap[name](name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (transformedTag.text !== undefined) frame.innerText = transformedTag.text;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (transformTagsAll) {
                transformedTag = transformTagsAll(name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (!tagAllowed(name) || options.disallowedTagsMode === 'recursiveEscape' && !$74918c48698d0732$var$isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
                skip = true;
                skipMap[depth] = true;
                if (options.disallowedTagsMode === 'discard') {
                    if (nonTextTagsArray.indexOf(name) !== -1) {
                        skipText = true;
                        skipTextDepth = 1;
                    }
                }
                skipMap[depth] = true;
            }
            depth++;
            if (skip) {
                if (options.disallowedTagsMode === 'discard') // We want the contents but not this tag
                return;
                tempResult = result;
                result = '';
            }
            result += '<' + name;
            if (name === 'script') {
                if (options.allowedScriptHostnames || options.allowedScriptDomains) frame.innerText = '';
            }
            if (!allowedAttributesMap || $74918c48698d0732$var$has(allowedAttributesMap, name) || allowedAttributesMap['*']) $74918c48698d0732$var$each(attribs, function(value, a) {
                if (!$74918c48698d0732$var$VALID_HTML_ATTRIBUTE_NAME.test(a)) {
                    // This prevents part of an attribute name in the output from being
                    // interpreted as the end of an attribute, or end of a tag.
                    delete frame.attribs[a];
                    return;
                }
                // If the value is empty, and this is a known non-boolean attribute, delete it
                // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
                if (value === '' && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes('*'))) {
                    delete frame.attribs[a];
                    return;
                }
                // check allowedAttributesMap for the element and attribute and modify the value
                // as necessary if there are specific values defined.
                let passedAllowedAttributesMapCheck = false;
                if (!allowedAttributesMap || $74918c48698d0732$var$has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 || $74918c48698d0732$var$has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a)) passedAllowedAttributesMapCheck = true;
                else if (allowedAttributesMap && allowedAttributesMap[name]) {
                    for (const o of allowedAttributesMap[name])if ($74918c48698d0732$require$isPlainObject(o) && o.name && o.name === a) {
                        passedAllowedAttributesMapCheck = true;
                        let newValue = '';
                        if (o.multiple === true) {
                            // verify the values that are allowed
                            const splitStrArray = value.split(' ');
                            for (const s of splitStrArray)if (o.values.indexOf(s) !== -1) {
                                if (newValue === '') newValue = s;
                                else newValue += ' ' + s;
                            }
                        } else if (o.values.indexOf(value) >= 0) // verified an allowed value matches the entire attribute value
                        newValue = value;
                        value = newValue;
                    }
                }
                if (passedAllowedAttributesMapCheck) {
                    if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
                        if (naughtyHref(name, value)) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === 'script' && a === 'src') {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                                const allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === 'iframe' && a === 'src') {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (parsed.isRelativeUrl) // default value of allowIframeRelativeUrls is true
                            // unless allowedIframeHostnames or allowedIframeDomains specified
                            allowed = $74918c48698d0732$var$has(options, 'allowIframeRelativeUrls') ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                            else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                                const allowedHostname = (options.allowedIframeHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            // Unparseable iframe src
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === 'srcset') try {
                        let parsed = $pY0nV(value);
                        parsed.forEach(function(value) {
                            if (naughtyHref('srcset', value.url)) value.evil = true;
                        });
                        parsed = $74918c48698d0732$var$filter(parsed, function(v) {
                            return !v.evil;
                        });
                        if (!parsed.length) {
                            delete frame.attribs[a];
                            return;
                        } else {
                            value = $74918c48698d0732$var$stringifySrcset($74918c48698d0732$var$filter(parsed, function(v) {
                                return !v.evil;
                            }));
                            frame.attribs[a] = value;
                        }
                    } catch (e) {
                        // Unparseable srcset
                        delete frame.attribs[a];
                        return;
                    }
                    if (a === 'class') {
                        const allowedSpecificClasses = allowedClassesMap[name];
                        const allowedWildcardClasses = allowedClassesMap['*'];
                        const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                        const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                        const allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
                        const allowedClassesGlobs = [
                            allowedSpecificClassesGlob,
                            allowedWildcardClassesGlob
                        ].concat(allowedSpecificClassesRegex).filter(function(t) {
                            return t;
                        });
                        if (allowedSpecificClasses && allowedWildcardClasses) value = filterClasses(value, $4lQO5(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                        else value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                        if (!value.length) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === 'style') {
                        if (options.parseStyleAttributes) try {
                            const abstractSyntaxTree = $74918c48698d0732$require$postcssParse(name + ' {' + value + '}');
                            const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                            value = stringifyStyleAttributes(filteredAST);
                            if (value.length === 0) {
                                delete frame.attribs[a];
                                return;
                            }
                        } catch (e) {
                            if (typeof window !== 'undefined') console.warn('Failed to parse "' + name + ' {' + value + '}' + '", If you\'re running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547');
                            delete frame.attribs[a];
                            return;
                        }
                        else if (options.allowedStyles) throw new Error('allowedStyles option cannot be used together with parseStyleAttributes: false.');
                    }
                    result += ' ' + a;
                    if (value && value.length) result += '="' + escapeHtml(value, true) + '"';
                } else delete frame.attribs[a];
            });
            if (options.selfClosing.indexOf(name) !== -1) result += ' />';
            else {
                result += '>';
                if (frame.innerText && !hasText && !options.textFilter) {
                    result += escapeHtml(frame.innerText);
                    addedText = true;
                }
            }
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = '';
            }
        },
        ontext: function(text) {
            if (skipText) return;
            const lastFrame = stack[stack.length - 1];
            let tag;
            if (lastFrame) {
                tag = lastFrame.tag;
                // If inner text was set by transform function then let's use it
                text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
            }
            if (options.disallowedTagsMode === 'discard' && (tag === 'script' || tag === 'style')) // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
            // script tags is, by definition, game over for XSS protection, so if that's
            // your concern, don't allow them. The same is essentially true for style tags
            // which have their own collection of XSS vectors.
            result += text;
            else {
                const escaped = escapeHtml(text, false);
                if (options.textFilter && !addedText) result += options.textFilter(escaped, tag);
                else if (!addedText) result += escaped;
            }
            if (stack.length) {
                const frame = stack[stack.length - 1];
                frame.text += text;
            }
        },
        onclosetag: function(name, isImplied) {
            if (skipText) {
                skipTextDepth--;
                if (!skipTextDepth) skipText = false;
                else return;
            }
            const frame = stack.pop();
            if (!frame) // Do not crash on bad markup
            return;
            if (frame.tag !== name) {
                // Another case of bad markup.
                // Push to stack, so that it will be used in future closing tags.
                stack.push(frame);
                return;
            }
            skipText = options.enforceHtmlBoundary ? name === 'html' : false;
            depth--;
            const skip = skipMap[depth];
            if (skip) {
                delete skipMap[depth];
                if (options.disallowedTagsMode === 'discard') {
                    frame.updateParentNodeText();
                    return;
                }
                tempResult = result;
                result = '';
            }
            if (transformMap[depth]) {
                name = transformMap[depth];
                delete transformMap[depth];
            }
            if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
                result = result.substr(0, frame.tagPosition);
                return;
            }
            frame.updateParentNodeMediaChildren();
            frame.updateParentNodeText();
            if (// Already output />
            options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
            isImplied && !tagAllowed(name) && [
                'escape',
                'recursiveEscape'
            ].indexOf(options.disallowedTagsMode) >= 0) {
                if (skip) {
                    result = tempResult;
                    tempResult = '';
                }
                return;
            }
            result += '</' + name + '>';
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = '';
            }
            addedText = false;
        }
    }, options.parser);
    parser.write(html);
    parser.end();
    return result;
    function initializeState() {
        result = '';
        depth = 0;
        stack = [];
        skipMap = {};
        transformMap = {};
        skipText = false;
        skipTextDepth = 0;
    }
    function escapeHtml(s, quote) {
        if (typeof s !== 'string') s = s + '';
        if (options.parser.decodeEntities) {
            s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            if (quote) s = s.replace(/"/g, '&quot;');
        }
        // TODO: this is inadequate because it will pass `&0;`. This approach
        // will not work, each & must be considered with regard to whether it
        // is followed by a 100% syntactically valid entity or not, and escaped
        // if it is not. If this bothers you, don't set parser.decodeEntities
        // to false. (The default is true.)
        s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');
        if (quote) s = s.replace(/"/g, '&quot;');
        return s;
    }
    function naughtyHref(name, href) {
        // Browsers ignore character codes of 32 (space) and below in a surprising
        // number of situations. Start reading here:
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
        // eslint-disable-next-line no-control-regex
        href = href.replace(/[\x00-\x20]+/g, '');
        // Clobber any comments in URLs, which the browser might
        // interpret inside an XML data island, allowing
        // a javascript: URL to be snuck through
        while(true){
            const firstIndex = href.indexOf('<!--');
            if (firstIndex === -1) break;
            const lastIndex = href.indexOf('-->', firstIndex + 4);
            if (lastIndex === -1) break;
            href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
        }
        // Case insensitive so we don't get faked out by JAVASCRIPT #1
        // Allow more characters after the first so we don't get faked
        // out by certain schemes browsers accept
        const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
        if (!matches) {
            // Protocol-relative URL starting with any combination of '/' and '\'
            if (href.match(/^[/\\]{2}/)) return !options.allowProtocolRelative;
            // No scheme
            return false;
        }
        const scheme = matches[1].toLowerCase();
        if ($74918c48698d0732$var$has(options.allowedSchemesByTag, name)) return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
        return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
    }
    function parseUrl(value) {
        value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');
        if (value.startsWith('relative:')) // An attempt to exploit our workaround for base URLs being
        // mandatory for relative URL validation in the WHATWG
        // URL parser, reject it
        throw new Error('relative: exploit attempt');
        // naughtyHref is in charge of whether protocol relative URLs
        // are cool. Here we are concerned just with allowed hostnames and
        // whether to allow relative URLs.
        //
        // Build a placeholder "base URL" against which any reasonable
        // relative URL may be parsed successfully
        let base = 'relative://relative-site';
        for(let i = 0; i < 100; i++)base += `/${i}`;
        const parsed = new URL(value, base);
        const isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
        return {
            isRelativeUrl: isRelativeUrl,
            url: parsed
        };
    }
    /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */ function filterCss(abstractSyntaxTree, allowedStyles) {
        if (!allowedStyles) return abstractSyntaxTree;
        const astRules = abstractSyntaxTree.nodes[0];
        let selectedRule;
        // Merge global and tag-specific styles into new AST.
        if (allowedStyles[astRules.selector] && allowedStyles['*']) selectedRule = $4lQO5(allowedStyles[astRules.selector], allowedStyles['*']);
        else selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
        if (selectedRule) abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
        return abstractSyntaxTree;
    }
    /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */ function stringifyStyleAttributes(filteredAST) {
        return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
            extractedAttributes.push(`${attrObject.prop}:${attrObject.value}${attrObject.important ? ' !important' : ''}`);
            return extractedAttributes;
        }, []).join(';');
    }
    /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */ function filterDeclarations(selectedRule) {
        return function(allowedDeclarationsList, attributeObject) {
            // If this property is allowlisted...
            if ($74918c48698d0732$var$has(selectedRule, attributeObject.prop)) {
                const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
                    return regularExpression.test(attributeObject.value);
                });
                if (matchesRegex) allowedDeclarationsList.push(attributeObject);
            }
            return allowedDeclarationsList;
        };
    }
    function filterClasses(classes, allowed, allowedGlobs) {
        if (!allowed) // The class attribute is allowed without filtering on this tag
        return classes;
        classes = classes.split(/\s+/);
        return classes.filter(function(clss) {
            return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
                return glob.test(clss);
            });
        }).join(' ');
    }
}
// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish
const $74918c48698d0732$var$htmlParserDefaults = {
    decodeEntities: true
};
$74918c48698d0732$var$sanitizeHtml.defaults = {
    allowedTags: [
        // Sections derived from MDN element categories and limited to the more
        // benign categories.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
        // Content sectioning
        'address',
        'article',
        'aside',
        'footer',
        'header',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'hgroup',
        'main',
        'nav',
        'section',
        // Text content
        'blockquote',
        'dd',
        'div',
        'dl',
        'dt',
        'figcaption',
        'figure',
        'hr',
        'li',
        'main',
        'ol',
        'p',
        'pre',
        'ul',
        // Inline text semantics
        'a',
        'abbr',
        'b',
        'bdi',
        'bdo',
        'br',
        'cite',
        'code',
        'data',
        'dfn',
        'em',
        'i',
        'kbd',
        'mark',
        'q',
        'rb',
        'rp',
        'rt',
        'rtc',
        'ruby',
        's',
        'samp',
        'small',
        'span',
        'strong',
        'sub',
        'sup',
        'time',
        'u',
        'var',
        'wbr',
        // Table content
        'caption',
        'col',
        'colgroup',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'tr'
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
        'abbr',
        'accept',
        'accept-charset',
        'accesskey',
        'action',
        'allow',
        'alt',
        'as',
        'autocapitalize',
        'autocomplete',
        'blocking',
        'charset',
        'cite',
        'class',
        'color',
        'cols',
        'colspan',
        'content',
        'contenteditable',
        'coords',
        'crossorigin',
        'data',
        'datetime',
        'decoding',
        'dir',
        'dirname',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'fetchpriority',
        'for',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formtarget',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'http-equiv',
        'id',
        'imagesizes',
        'imagesrcset',
        'inputmode',
        'integrity',
        'is',
        'itemid',
        'itemprop',
        'itemref',
        'itemtype',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'name',
        'nonce',
        'optimum',
        'pattern',
        'ping',
        'placeholder',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'referrerpolicy',
        'rel',
        'rows',
        'rowspan',
        'sandbox',
        'scope',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'spellcheck',
        'src',
        'srcdoc',
        'srclang',
        'srcset',
        'start',
        'step',
        'style',
        'tabindex',
        'target',
        'title',
        'translate',
        'type',
        'usemap',
        'value',
        'width',
        'wrap',
        // Event handlers
        'onauxclick',
        'onafterprint',
        'onbeforematch',
        'onbeforeprint',
        'onbeforeunload',
        'onbeforetoggle',
        'onblur',
        'oncancel',
        'oncanplay',
        'oncanplaythrough',
        'onchange',
        'onclick',
        'onclose',
        'oncontextlost',
        'oncontextmenu',
        'oncontextrestored',
        'oncopy',
        'oncuechange',
        'oncut',
        'ondblclick',
        'ondrag',
        'ondragend',
        'ondragenter',
        'ondragleave',
        'ondragover',
        'ondragstart',
        'ondrop',
        'ondurationchange',
        'onemptied',
        'onended',
        'onerror',
        'onfocus',
        'onformdata',
        'onhashchange',
        'oninput',
        'oninvalid',
        'onkeydown',
        'onkeypress',
        'onkeyup',
        'onlanguagechange',
        'onload',
        'onloadeddata',
        'onloadedmetadata',
        'onloadstart',
        'onmessage',
        'onmessageerror',
        'onmousedown',
        'onmouseenter',
        'onmouseleave',
        'onmousemove',
        'onmouseout',
        'onmouseover',
        'onmouseup',
        'onoffline',
        'ononline',
        'onpagehide',
        'onpageshow',
        'onpaste',
        'onpause',
        'onplay',
        'onplaying',
        'onpopstate',
        'onprogress',
        'onratechange',
        'onreset',
        'onresize',
        'onrejectionhandled',
        'onscroll',
        'onscrollend',
        'onsecuritypolicyviolation',
        'onseeked',
        'onseeking',
        'onselect',
        'onslotchange',
        'onstalled',
        'onstorage',
        'onsubmit',
        'onsuspend',
        'ontimeupdate',
        'ontoggle',
        'onunhandledrejection',
        'onunload',
        'onvolumechange',
        'onwaiting',
        'onwheel'
    ],
    disallowedTagsMode: 'discard',
    allowedAttributes: {
        a: [
            'href',
            'name',
            'target'
        ],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: [
            'src',
            'srcset',
            'alt',
            'title',
            'width',
            'height',
            'loading'
        ]
    },
    // Lots of these won't come up by default because we don't allow them
    selfClosing: [
        'img',
        'br',
        'hr',
        'area',
        'base',
        'basefont',
        'input',
        'link',
        'meta'
    ],
    // URL schemes we permit
    allowedSchemes: [
        'http',
        'https',
        'ftp',
        'mailto',
        'tel'
    ],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
        'href',
        'src',
        'cite'
    ],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    parseStyleAttributes: true
};
$74918c48698d0732$var$sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
    merge = merge === undefined ? true : merge;
    newAttribs = newAttribs || {};
    return function(tagName, attribs) {
        let attrib;
        if (merge) for(attrib in newAttribs)attribs[attrib] = newAttribs[attrib];
        else attribs = newAttribs;
        return {
            tagName: newTagName,
            attribs: attribs
        };
    };
};

});
parcelRegister("dUSo4", function(module, exports) {
"use strict";
var $a21ab17f6090c72e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a21ab17f6090c72e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a21ab17f6090c72e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a21ab17f6090c72e$var$__createBinding(result, mod, k);
    }
    $a21ab17f6090c72e$var$__setModuleDefault(result, mod);
    return result;
};
var $a21ab17f6090c72e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DomUtils = module.exports.parseFeed = module.exports.getFeed = module.exports.ElementType = module.exports.Tokenizer = module.exports.createDomStream = module.exports.parseDOM = module.exports.parseDocument = module.exports.DefaultHandler = module.exports.DomHandler = module.exports.Parser = void 0;

var $kiwvl = parcelRequire("kiwvl");

var $kiwvl = parcelRequire("kiwvl");
Object.defineProperty(module.exports, "Parser", {
    enumerable: true,
    get: function() {
        return $kiwvl.Parser;
    }
});

var $lbkvM = parcelRequire("lbkvM");

var $lbkvM = parcelRequire("lbkvM");
Object.defineProperty(module.exports, "DomHandler", {
    enumerable: true,
    get: function() {
        return $lbkvM.DomHandler;
    }
});
// Old name for DomHandler
Object.defineProperty(module.exports, "DefaultHandler", {
    enumerable: true,
    get: function() {
        return $lbkvM.DomHandler;
    }
});
// Helper methods
/**
 * Parses the data, returns the resulting document.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 */ function $a21ab17f6090c72e$var$parseDocument(data, options) {
    var handler = new $lbkvM.DomHandler(undefined, options);
    new $kiwvl.Parser(handler, options).end(data);
    return handler.root;
}
module.exports.parseDocument = $a21ab17f6090c72e$var$parseDocument;
/**
 * Parses data, returns an array of the root nodes.
 *
 * Note that the root nodes still have a `Document` node as their parent.
 * Use `parseDocument` to get the `Document` node instead.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 * @deprecated Use `parseDocument` instead.
 */ function $a21ab17f6090c72e$var$parseDOM(data, options) {
    return $a21ab17f6090c72e$var$parseDocument(data, options).children;
}
module.exports.parseDOM = $a21ab17f6090c72e$var$parseDOM;
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param callback A callback that will be called once parsing has been completed.
 * @param options Optional options for the parser and DOM builder.
 * @param elementCallback An optional callback that will be called every time a tag has been completed inside of the DOM.
 */ function $a21ab17f6090c72e$var$createDomStream(callback, options, elementCallback) {
    var handler = new $lbkvM.DomHandler(callback, options, elementCallback);
    return new $kiwvl.Parser(handler, options);
}
module.exports.createDomStream = $a21ab17f6090c72e$var$createDomStream;

var $i5one = parcelRequire("i5one");
Object.defineProperty(module.exports, "Tokenizer", {
    enumerable: true,
    get: function() {
        return $a21ab17f6090c72e$var$__importDefault($i5one).default;
    }
});

/*
 * All of the following exports exist for backwards-compatibility.
 * They should probably be removed eventually.
 */ module.exports.ElementType = $a21ab17f6090c72e$var$__importStar((parcelRequire("lLWbo")));


Object.defineProperty(module.exports, "getFeed", {
    enumerable: true,
    get: function() {
        return (parcelRequire("7uUlf")).getFeed;
    }
});
var $a21ab17f6090c72e$var$parseFeedDefaultOptions = {
    xmlMode: true
};
/**
 * Parse a feed.
 *
 * @param feed The feed that should be parsed, as a string.
 * @param options Optionally, options for parsing. When using this, you should set `xmlMode` to `true`.
 */ function $a21ab17f6090c72e$var$parseFeed(feed, options) {
    if (options === void 0) options = $a21ab17f6090c72e$var$parseFeedDefaultOptions;
    return (0, (parcelRequire("7uUlf")).getFeed)($a21ab17f6090c72e$var$parseDOM(feed, options));
}
module.exports.parseFeed = $a21ab17f6090c72e$var$parseFeed;

module.exports.DomUtils = $a21ab17f6090c72e$var$__importStar((parcelRequire("7uUlf")));

});
parcelRegister("kiwvl", function(module, exports) {
"use strict";
var $ec6eb3d6136b5d28$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ec6eb3d6136b5d28$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ec6eb3d6136b5d28$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ec6eb3d6136b5d28$var$__createBinding(result, mod, k);
    }
    $ec6eb3d6136b5d28$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $ec6eb3d6136b5d28$var$Tokenizer_js_1 = $ec6eb3d6136b5d28$var$__importStar((parcelRequire("i5one")));

var $5N771 = parcelRequire("5N771");
var $ec6eb3d6136b5d28$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
var $ec6eb3d6136b5d28$var$pTag = new Set([
    "p"
]);
var $ec6eb3d6136b5d28$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
var $ec6eb3d6136b5d28$var$ddtTags = new Set([
    "dd",
    "dt"
]);
var $ec6eb3d6136b5d28$var$rtpTags = new Set([
    "rt",
    "rp"
]);
var $ec6eb3d6136b5d28$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "h1",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "h2",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "h3",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "h4",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "h5",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "h6",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "select",
        $ec6eb3d6136b5d28$var$formTags
    ],
    [
        "input",
        $ec6eb3d6136b5d28$var$formTags
    ],
    [
        "output",
        $ec6eb3d6136b5d28$var$formTags
    ],
    [
        "button",
        $ec6eb3d6136b5d28$var$formTags
    ],
    [
        "datalist",
        $ec6eb3d6136b5d28$var$formTags
    ],
    [
        "textarea",
        $ec6eb3d6136b5d28$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $ec6eb3d6136b5d28$var$ddtTags
    ],
    [
        "dt",
        $ec6eb3d6136b5d28$var$ddtTags
    ],
    [
        "address",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "article",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "aside",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "blockquote",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "details",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "div",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "dl",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "fieldset",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "figcaption",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "figure",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "footer",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "form",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "header",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "hr",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "main",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "nav",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "ol",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "pre",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "section",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "table",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "ul",
        $ec6eb3d6136b5d28$var$pTag
    ],
    [
        "rt",
        $ec6eb3d6136b5d28$var$rtpTags
    ],
    [
        "rp",
        $ec6eb3d6136b5d28$var$rtpTags
    ],
    [
        "tbody",
        $ec6eb3d6136b5d28$var$tableSectionTags
    ],
    [
        "tfoot",
        $ec6eb3d6136b5d28$var$tableSectionTags
    ]
]);
var $ec6eb3d6136b5d28$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
var $ec6eb3d6136b5d28$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
var $ec6eb3d6136b5d28$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
var $ec6eb3d6136b5d28$var$reNameEnd = /\s|\//;
var $ec6eb3d6136b5d28$var$Parser = /** @class */ function() {
    function Parser(cbs, options) {
        if (options === void 0) options = {};
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : $ec6eb3d6136b5d28$var$Tokenizer_js_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */ Parser.prototype.ontext = function(start, endIndex) {
        var _a, _b;
        var data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    };
    /** @internal */ Parser.prototype.ontextentity = function(cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ var index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $5N771.fromCodePoint)(cp));
        this.startIndex = index;
    };
    Parser.prototype.isVoidElement = function(name) {
        return !this.options.xmlMode && $ec6eb3d6136b5d28$var$voidElements.has(name);
    };
    /** @internal */ Parser.prototype.onopentagname = function(start, endIndex) {
        this.endIndex = endIndex;
        var name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    };
    Parser.prototype.emitOpenTag = function(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        var impliesClose = !this.options.xmlMode && $ec6eb3d6136b5d28$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
            var element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if ($ec6eb3d6136b5d28$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($ec6eb3d6136b5d28$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    };
    Parser.prototype.endOpenTag = function(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    };
    /** @internal */ Parser.prototype.onopentagend = function(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.onclosetag = function(start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        var name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($ec6eb3d6136b5d28$var$foreignContextElements.has(name) || $ec6eb3d6136b5d28$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (!this.isVoidElement(name)) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    var count = this.stack.length - pos;
                    while(count--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop(), count !== 0);
                } else this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.onselfclosingtag = function(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    };
    Parser.prototype.closeCurrentTag = function(isOpenImplied) {
        var _a, _b;
        var name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    };
    /** @internal */ Parser.prototype.onattribname = function(start, endIndex) {
        this.startIndex = start;
        var name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    };
    /** @internal */ Parser.prototype.onattribdata = function(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    };
    /** @internal */ Parser.prototype.onattribentity = function(cp) {
        this.attribvalue += (0, $5N771.fromCodePoint)(cp);
    };
    /** @internal */ Parser.prototype.onattribend = function(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === $ec6eb3d6136b5d28$var$Tokenizer_js_1.QuoteType.Double ? '"' : quote === $ec6eb3d6136b5d28$var$Tokenizer_js_1.QuoteType.Single ? "'" : quote === $ec6eb3d6136b5d28$var$Tokenizer_js_1.QuoteType.NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    };
    Parser.prototype.getInstructionName = function(value) {
        var index = value.search($ec6eb3d6136b5d28$var$reNameEnd);
        var name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    };
    /** @internal */ Parser.prototype.ondeclaration = function(start, endIndex) {
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            var name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.onprocessinginstruction = function(start, endIndex) {
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            var name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.oncomment = function(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.oncdata = function(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, "[CDATA[".concat(value, "]]"));
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.onend = function() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    };
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ Parser.prototype.reset = function() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    };
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ Parser.prototype.parseComplete = function(data) {
        this.reset();
        this.end(data);
    };
    Parser.prototype.getSlice = function(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    };
    Parser.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    };
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ Parser.prototype.write = function(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    };
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ Parser.prototype.end = function(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    };
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ Parser.prototype.pause = function() {
        this.tokenizer.pause();
    };
    /**
     * Resumes parsing after `pause` was called.
     */ Parser.prototype.resume = function() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    };
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ Parser.prototype.parseChunk = function(chunk) {
        this.write(chunk);
    };
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ Parser.prototype.done = function(chunk) {
        this.end(chunk);
    };
    return Parser;
}();
module.exports.Parser = $ec6eb3d6136b5d28$var$Parser;

});
parcelRegister("i5one", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuoteType = void 0;

var $5N771 = parcelRequire("5N771");
var $d2ab99bf23c5bfa6$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($d2ab99bf23c5bfa6$var$CharCodes || ($d2ab99bf23c5bfa6$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $d2ab99bf23c5bfa6$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($d2ab99bf23c5bfa6$var$State || ($d2ab99bf23c5bfa6$var$State = {}));
function $d2ab99bf23c5bfa6$var$isWhitespace(c) {
    return c === $d2ab99bf23c5bfa6$var$CharCodes.Space || c === $d2ab99bf23c5bfa6$var$CharCodes.NewLine || c === $d2ab99bf23c5bfa6$var$CharCodes.Tab || c === $d2ab99bf23c5bfa6$var$CharCodes.FormFeed || c === $d2ab99bf23c5bfa6$var$CharCodes.CarriageReturn;
}
function $d2ab99bf23c5bfa6$var$isEndOfTagSection(c) {
    return c === $d2ab99bf23c5bfa6$var$CharCodes.Slash || c === $d2ab99bf23c5bfa6$var$CharCodes.Gt || $d2ab99bf23c5bfa6$var$isWhitespace(c);
}
function $d2ab99bf23c5bfa6$var$isNumber(c) {
    return c >= $d2ab99bf23c5bfa6$var$CharCodes.Zero && c <= $d2ab99bf23c5bfa6$var$CharCodes.Nine;
}
function $d2ab99bf23c5bfa6$var$isASCIIAlpha(c) {
    return c >= $d2ab99bf23c5bfa6$var$CharCodes.LowerA && c <= $d2ab99bf23c5bfa6$var$CharCodes.LowerZ || c >= $d2ab99bf23c5bfa6$var$CharCodes.UpperA && c <= $d2ab99bf23c5bfa6$var$CharCodes.UpperZ;
}
function $d2ab99bf23c5bfa6$var$isHexDigit(c) {
    return c >= $d2ab99bf23c5bfa6$var$CharCodes.UpperA && c <= $d2ab99bf23c5bfa6$var$CharCodes.UpperF || c >= $d2ab99bf23c5bfa6$var$CharCodes.LowerA && c <= $d2ab99bf23c5bfa6$var$CharCodes.LowerF;
}
var $d2ab99bf23c5bfa6$var$QuoteType;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($d2ab99bf23c5bfa6$var$QuoteType = module.exports.QuoteType || (module.exports.QuoteType = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ var $d2ab99bf23c5bfa6$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
var $d2ab99bf23c5bfa6$var$Tokenizer = /** @class */ function() {
    function Tokenizer(_a, cbs) {
        var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $d2ab99bf23c5bfa6$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $d2ab99bf23c5bfa6$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? $5N771.xmlDecodeTree : $5N771.htmlDecodeTree;
    }
    Tokenizer.prototype.reset = function() {
        this.state = $d2ab99bf23c5bfa6$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $d2ab99bf23c5bfa6$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    };
    Tokenizer.prototype.write = function(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    };
    Tokenizer.prototype.end = function() {
        if (this.running) this.finish();
    };
    Tokenizer.prototype.pause = function() {
        this.running = false;
    };
    Tokenizer.prototype.resume = function() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    };
    /**
     * The current index within all of the written data.
     */ Tokenizer.prototype.getIndex = function() {
        return this.index;
    };
    /**
     * The start of the current section.
     */ Tokenizer.prototype.getSectionStart = function() {
        return this.sectionStart;
    };
    Tokenizer.prototype.stateText = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($d2ab99bf23c5bfa6$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $d2ab99bf23c5bfa6$var$CharCodes.Amp) this.state = $d2ab99bf23c5bfa6$var$State.BeforeEntity;
    };
    Tokenizer.prototype.stateSpecialStartSequence = function(c) {
        var isEnd = this.sequenceIndex === this.currentSequence.length;
        var isMatch = isEnd ? $d2ab99bf23c5bfa6$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $d2ab99bf23c5bfa6$var$State.InTagName;
        this.stateInTagName(c);
    };
    /** Look for an end tag. For <title> tags, also decode entities. */ Tokenizer.prototype.stateInSpecialTag = function(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt || $d2ab99bf23c5bfa6$var$isWhitespace(c)) {
                var endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    var actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $d2ab99bf23c5bfa6$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $d2ab99bf23c5bfa6$var$CharCodes.Amp) this.state = $d2ab99bf23c5bfa6$var$State.BeforeEntity;
            } else if (this.fastForwardTo($d2ab99bf23c5bfa6$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $d2ab99bf23c5bfa6$var$CharCodes.Lt);
    };
    Tokenizer.prototype.stateCDATASequence = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $d2ab99bf23c5bfa6$var$Sequences.Cdata.length) {
                this.state = $d2ab99bf23c5bfa6$var$State.InCommentLike;
                this.currentSequence = $d2ab99bf23c5bfa6$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $d2ab99bf23c5bfa6$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    };
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ Tokenizer.prototype.fastForwardTo = function(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    };
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ Tokenizer.prototype.stateInCommentLike = function(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $d2ab99bf23c5bfa6$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $d2ab99bf23c5bfa6$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    };
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ Tokenizer.prototype.isTagStartChar = function(c) {
        return this.xmlMode ? !$d2ab99bf23c5bfa6$var$isEndOfTagSection(c) : $d2ab99bf23c5bfa6$var$isASCIIAlpha(c);
    };
    Tokenizer.prototype.startSpecial = function(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $d2ab99bf23c5bfa6$var$State.SpecialStartSequence;
    };
    Tokenizer.prototype.stateBeforeTagName = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.ExclamationMark) {
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $d2ab99bf23c5bfa6$var$CharCodes.Questionmark) {
            this.state = $d2ab99bf23c5bfa6$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            var lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $d2ab99bf23c5bfa6$var$Sequences.TitleEnd[2]) this.startSpecial($d2ab99bf23c5bfa6$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $d2ab99bf23c5bfa6$var$Sequences.ScriptEnd[2] ? $d2ab99bf23c5bfa6$var$State.BeforeSpecialS : $d2ab99bf23c5bfa6$var$State.InTagName;
        } else if (c === $d2ab99bf23c5bfa6$var$CharCodes.Slash) this.state = $d2ab99bf23c5bfa6$var$State.BeforeClosingTagName;
        else {
            this.state = $d2ab99bf23c5bfa6$var$State.Text;
            this.stateText(c);
        }
    };
    Tokenizer.prototype.stateInTagName = function(c) {
        if ($d2ab99bf23c5bfa6$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateBeforeClosingTagName = function(c) {
        if ($d2ab99bf23c5bfa6$var$isWhitespace(c)) ;
        else if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt) this.state = $d2ab99bf23c5bfa6$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $d2ab99bf23c5bfa6$var$State.InClosingTagName : $d2ab99bf23c5bfa6$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    };
    Tokenizer.prototype.stateInClosingTagName = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt || $d2ab99bf23c5bfa6$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $d2ab99bf23c5bfa6$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    };
    Tokenizer.prototype.stateAfterClosingTagName = function(c) {
        // Skip everything until ">"
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt || this.fastForwardTo($d2ab99bf23c5bfa6$var$CharCodes.Gt)) {
            this.state = $d2ab99bf23c5bfa6$var$State.Text;
            this.baseState = $d2ab99bf23c5bfa6$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeName = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $d2ab99bf23c5bfa6$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $d2ab99bf23c5bfa6$var$State.Text;
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
        } else if (c === $d2ab99bf23c5bfa6$var$CharCodes.Slash) this.state = $d2ab99bf23c5bfa6$var$State.InSelfClosingTag;
        else if (!$d2ab99bf23c5bfa6$var$isWhitespace(c)) {
            this.state = $d2ab99bf23c5bfa6$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    };
    Tokenizer.prototype.stateInSelfClosingTag = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $d2ab99bf23c5bfa6$var$State.Text;
            this.baseState = $d2ab99bf23c5bfa6$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$d2ab99bf23c5bfa6$var$isWhitespace(c)) {
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateInAttributeName = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Eq || $d2ab99bf23c5bfa6$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $d2ab99bf23c5bfa6$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    };
    Tokenizer.prototype.stateAfterAttributeName = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Eq) this.state = $d2ab99bf23c5bfa6$var$State.BeforeAttributeValue;
        else if (c === $d2ab99bf23c5bfa6$var$CharCodes.Slash || c === $d2ab99bf23c5bfa6$var$CharCodes.Gt) {
            this.cbs.onattribend($d2ab99bf23c5bfa6$var$QuoteType.NoValue, this.index);
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$d2ab99bf23c5bfa6$var$isWhitespace(c)) {
            this.cbs.onattribend($d2ab99bf23c5bfa6$var$QuoteType.NoValue, this.index);
            this.state = $d2ab99bf23c5bfa6$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeValue = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.DoubleQuote) {
            this.state = $d2ab99bf23c5bfa6$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $d2ab99bf23c5bfa6$var$CharCodes.SingleQuote) {
            this.state = $d2ab99bf23c5bfa6$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$d2ab99bf23c5bfa6$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $d2ab99bf23c5bfa6$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    };
    Tokenizer.prototype.handleInAttributeValue = function(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $d2ab99bf23c5bfa6$var$CharCodes.DoubleQuote ? $d2ab99bf23c5bfa6$var$QuoteType.Double : $d2ab99bf23c5bfa6$var$QuoteType.Single, this.index);
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $d2ab99bf23c5bfa6$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeEntity;
        }
    };
    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function(c) {
        this.handleInAttributeValue(c, $d2ab99bf23c5bfa6$var$CharCodes.DoubleQuote);
    };
    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function(c) {
        this.handleInAttributeValue(c, $d2ab99bf23c5bfa6$var$CharCodes.SingleQuote);
    };
    Tokenizer.prototype.stateInAttributeValueNoQuotes = function(c) {
        if ($d2ab99bf23c5bfa6$var$isWhitespace(c) || c === $d2ab99bf23c5bfa6$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($d2ab99bf23c5bfa6$var$QuoteType.Unquoted, this.index);
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $d2ab99bf23c5bfa6$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $d2ab99bf23c5bfa6$var$State.BeforeEntity;
        }
    };
    Tokenizer.prototype.stateBeforeDeclaration = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.OpeningSquareBracket) {
            this.state = $d2ab99bf23c5bfa6$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $d2ab99bf23c5bfa6$var$CharCodes.Dash ? $d2ab99bf23c5bfa6$var$State.BeforeComment : $d2ab99bf23c5bfa6$var$State.InDeclaration;
    };
    Tokenizer.prototype.stateInDeclaration = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt || this.fastForwardTo($d2ab99bf23c5bfa6$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $d2ab99bf23c5bfa6$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    };
    Tokenizer.prototype.stateInProcessingInstruction = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt || this.fastForwardTo($d2ab99bf23c5bfa6$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $d2ab99bf23c5bfa6$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeComment = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Dash) {
            this.state = $d2ab99bf23c5bfa6$var$State.InCommentLike;
            this.currentSequence = $d2ab99bf23c5bfa6$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $d2ab99bf23c5bfa6$var$State.InDeclaration;
    };
    Tokenizer.prototype.stateInSpecialComment = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Gt || this.fastForwardTo($d2ab99bf23c5bfa6$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $d2ab99bf23c5bfa6$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeSpecialS = function(c) {
        var lower = c | 0x20;
        if (lower === $d2ab99bf23c5bfa6$var$Sequences.ScriptEnd[3]) this.startSpecial($d2ab99bf23c5bfa6$var$Sequences.ScriptEnd, 4);
        else if (lower === $d2ab99bf23c5bfa6$var$Sequences.StyleEnd[3]) this.startSpecial($d2ab99bf23c5bfa6$var$Sequences.StyleEnd, 4);
        else {
            this.state = $d2ab99bf23c5bfa6$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    };
    Tokenizer.prototype.stateBeforeEntity = function(c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Number) this.state = $d2ab99bf23c5bfa6$var$State.BeforeNumericEntity;
        else if (c === $d2ab99bf23c5bfa6$var$CharCodes.Amp) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = $d2ab99bf23c5bfa6$var$State.InNamedEntity;
            this.stateInNamedEntity(c);
        }
    };
    Tokenizer.prototype.stateInNamedEntity = function(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, $5N771.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var masked = this.trieCurrent & $5N771.BinTrieFlags.VALUE_LENGTH;
        // If the branch is a value, store it and continue
        if (masked) {
            // The mask is the number of bytes of the value, including the current byte.
            var valueLength = (masked >> 14) - 1;
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== $d2ab99bf23c5bfa6$var$CharCodes.Semi) this.trieIndex += valueLength;
            else {
                // Add 1 as we have already incremented the excess
                var entityStart = this.index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                // If this is a surrogate pair, consume the next two bytes
                this.entityResult = this.trieIndex;
                this.trieIndex += valueLength;
                this.entityExcess = 0;
                this.sectionStart = this.index + 1;
                if (valueLength === 0) this.emitNamedEntity();
            }
        }
    };
    Tokenizer.prototype.emitNamedEntity = function() {
        this.state = this.baseState;
        if (this.entityResult === 0) return;
        var valueLength = (this.entityTrie[this.entityResult] & $5N771.BinTrieFlags.VALUE_LENGTH) >> 14;
        switch(valueLength){
            case 1:
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~$5N771.BinTrieFlags.VALUE_LENGTH);
                break;
            case 2:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
            case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    };
    Tokenizer.prototype.stateBeforeNumericEntity = function(c) {
        if ((c | 0x20) === $d2ab99bf23c5bfa6$var$CharCodes.LowerX) {
            this.entityExcess++;
            this.state = $d2ab99bf23c5bfa6$var$State.InHexEntity;
        } else {
            this.state = $d2ab99bf23c5bfa6$var$State.InNumericEntity;
            this.stateInNumericEntity(c);
        }
    };
    Tokenizer.prototype.emitNumericEntity = function(strict) {
        var entityStart = this.index - this.entityExcess - 1;
        var numberStart = entityStart + 2 + Number(this.state === $d2ab99bf23c5bfa6$var$State.InHexEntity);
        if (numberStart !== this.index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, $5N771.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
    };
    Tokenizer.prototype.stateInNumericEntity = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($d2ab99bf23c5bfa6$var$isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - $d2ab99bf23c5bfa6$var$CharCodes.Zero);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    };
    Tokenizer.prototype.stateInHexEntity = function(c) {
        if (c === $d2ab99bf23c5bfa6$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($d2ab99bf23c5bfa6$var$isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - $d2ab99bf23c5bfa6$var$CharCodes.Zero);
            this.entityExcess++;
        } else if ($d2ab99bf23c5bfa6$var$isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 0x20) - $d2ab99bf23c5bfa6$var$CharCodes.LowerA + 10);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    };
    Tokenizer.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === $d2ab99bf23c5bfa6$var$State.Text || this.baseState === $d2ab99bf23c5bfa6$var$State.InSpecialTag);
    };
    /**
     * Remove data that has already been consumed from the buffer.
     */ Tokenizer.prototype.cleanup = function() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $d2ab99bf23c5bfa6$var$State.Text || this.state === $d2ab99bf23c5bfa6$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $d2ab99bf23c5bfa6$var$State.InAttributeValueDq || this.state === $d2ab99bf23c5bfa6$var$State.InAttributeValueSq || this.state === $d2ab99bf23c5bfa6$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    };
    Tokenizer.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
    };
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ Tokenizer.prototype.parse = function() {
        while(this.shouldContinue()){
            var c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $d2ab99bf23c5bfa6$var$State.Text:
                    this.stateText(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InNamedEntity:
                    this.stateInNamedEntity(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.BeforeEntity:
                    this.stateBeforeEntity(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InHexEntity:
                    this.stateInHexEntity(c);
                    break;
                case $d2ab99bf23c5bfa6$var$State.InNumericEntity:
                    this.stateInNumericEntity(c);
                    break;
                default:
                    // `this._state === State.BeforeNumericEntity`
                    this.stateBeforeNumericEntity(c);
            }
            this.index++;
        }
        this.cleanup();
    };
    Tokenizer.prototype.finish = function() {
        if (this.state === $d2ab99bf23c5bfa6$var$State.InNamedEntity) this.emitNamedEntity();
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this.index) this.handleTrailingData();
        this.cbs.onend();
    };
    /** Handle any trailing data. */ Tokenizer.prototype.handleTrailingData = function() {
        var endIndex = this.buffer.length + this.offset;
        if (this.state === $d2ab99bf23c5bfa6$var$State.InCommentLike) {
            if (this.currentSequence === $d2ab99bf23c5bfa6$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $d2ab99bf23c5bfa6$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $d2ab99bf23c5bfa6$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $d2ab99bf23c5bfa6$var$State.InTagName || this.state === $d2ab99bf23c5bfa6$var$State.BeforeAttributeName || this.state === $d2ab99bf23c5bfa6$var$State.BeforeAttributeValue || this.state === $d2ab99bf23c5bfa6$var$State.AfterAttributeName || this.state === $d2ab99bf23c5bfa6$var$State.InAttributeName || this.state === $d2ab99bf23c5bfa6$var$State.InAttributeValueSq || this.state === $d2ab99bf23c5bfa6$var$State.InAttributeValueDq || this.state === $d2ab99bf23c5bfa6$var$State.InAttributeValueNq || this.state === $d2ab99bf23c5bfa6$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    };
    Tokenizer.prototype.emitPartial = function(start, endIndex) {
        if (this.baseState !== $d2ab99bf23c5bfa6$var$State.Text && this.baseState !== $d2ab99bf23c5bfa6$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
        else this.cbs.ontext(start, endIndex);
    };
    Tokenizer.prototype.emitCodePoint = function(cp) {
        if (this.baseState !== $d2ab99bf23c5bfa6$var$State.Text && this.baseState !== $d2ab99bf23c5bfa6$var$State.InSpecialTag) this.cbs.onattribentity(cp);
        else this.cbs.ontextentity(cp);
    };
    return Tokenizer;
}();
module.exports.default = $d2ab99bf23c5bfa6$var$Tokenizer;

});
parcelRegister("5N771", function(module, exports) {
"use strict";
var $43770bb441d9d016$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $43770bb441d9d016$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $43770bb441d9d016$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $43770bb441d9d016$var$__createBinding(result, mod, k);
    }
    $43770bb441d9d016$var$__setModuleDefault(result, mod);
    return result;
};
var $43770bb441d9d016$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXML = module.exports.decodeHTMLStrict = module.exports.decodeHTMLAttribute = module.exports.decodeHTML = module.exports.determineBranch = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = void 0;

var $43770bb441d9d016$var$decode_data_html_js_1 = $43770bb441d9d016$var$__importDefault((parcelRequire("1DRB4")));
module.exports.htmlDecodeTree = $43770bb441d9d016$var$decode_data_html_js_1.default;

var $43770bb441d9d016$var$decode_data_xml_js_1 = $43770bb441d9d016$var$__importDefault((parcelRequire("6rWFK")));
module.exports.xmlDecodeTree = $43770bb441d9d016$var$decode_data_xml_js_1.default;

var $43770bb441d9d016$var$decode_codepoint_js_1 = $43770bb441d9d016$var$__importStar((parcelRequire("8xWi9")));
module.exports.decodeCodePoint = $43770bb441d9d016$var$decode_codepoint_js_1.default;

Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8xWi9")).replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8xWi9")).fromCodePoint;
    }
});
var $43770bb441d9d016$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($43770bb441d9d016$var$CharCodes || ($43770bb441d9d016$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $43770bb441d9d016$var$TO_LOWER_BIT = 32;
var $43770bb441d9d016$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($43770bb441d9d016$var$BinTrieFlags = module.exports.BinTrieFlags || (module.exports.BinTrieFlags = {}));
function $43770bb441d9d016$var$isNumber(code) {
    return code >= $43770bb441d9d016$var$CharCodes.ZERO && code <= $43770bb441d9d016$var$CharCodes.NINE;
}
function $43770bb441d9d016$var$isHexadecimalCharacter(code) {
    return code >= $43770bb441d9d016$var$CharCodes.UPPER_A && code <= $43770bb441d9d016$var$CharCodes.UPPER_F || code >= $43770bb441d9d016$var$CharCodes.LOWER_A && code <= $43770bb441d9d016$var$CharCodes.LOWER_F;
}
function $43770bb441d9d016$var$isAsciiAlphaNumeric(code) {
    return code >= $43770bb441d9d016$var$CharCodes.UPPER_A && code <= $43770bb441d9d016$var$CharCodes.UPPER_Z || code >= $43770bb441d9d016$var$CharCodes.LOWER_A && code <= $43770bb441d9d016$var$CharCodes.LOWER_Z || $43770bb441d9d016$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $43770bb441d9d016$var$isEntityInAttributeInvalidEnd(code) {
    return code === $43770bb441d9d016$var$CharCodes.EQUALS || $43770bb441d9d016$var$isAsciiAlphaNumeric(code);
}
var $43770bb441d9d016$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($43770bb441d9d016$var$EntityDecoderState || ($43770bb441d9d016$var$EntityDecoderState = {}));
var $43770bb441d9d016$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($43770bb441d9d016$var$DecodingMode = module.exports.DecodingMode || (module.exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $43770bb441d9d016$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $43770bb441d9d016$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $43770bb441d9d016$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $43770bb441d9d016$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $43770bb441d9d016$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $43770bb441d9d016$var$CharCodes.NUM) {
                    this.state = $43770bb441d9d016$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $43770bb441d9d016$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $43770bb441d9d016$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $43770bb441d9d016$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $43770bb441d9d016$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $43770bb441d9d016$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $43770bb441d9d016$var$TO_LOWER_BIT) === $43770bb441d9d016$var$CharCodes.LOWER_X) {
            this.state = $43770bb441d9d016$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $43770bb441d9d016$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($43770bb441d9d016$var$isNumber(char) || $43770bb441d9d016$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($43770bb441d9d016$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $43770bb441d9d016$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $43770bb441d9d016$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $43770bb441d9d016$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $43770bb441d9d016$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $43770bb441d9d016$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $43770bb441d9d016$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $43770bb441d9d016$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $43770bb441d9d016$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $43770bb441d9d016$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $43770bb441d9d016$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $43770bb441d9d016$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $43770bb441d9d016$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$43770bb441d9d016$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $43770bb441d9d016$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $43770bb441d9d016$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $43770bb441d9d016$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $43770bb441d9d016$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $43770bb441d9d016$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $43770bb441d9d016$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
module.exports.EntityDecoder = $43770bb441d9d016$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $43770bb441d9d016$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $43770bb441d9d016$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $43770bb441d9d016$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $43770bb441d9d016$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $43770bb441d9d016$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $43770bb441d9d016$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
module.exports.determineBranch = $43770bb441d9d016$var$determineBranch;
var $43770bb441d9d016$var$htmlDecoder = $43770bb441d9d016$var$getDecoder($43770bb441d9d016$var$decode_data_html_js_1.default);
var $43770bb441d9d016$var$xmlDecoder = $43770bb441d9d016$var$getDecoder($43770bb441d9d016$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $43770bb441d9d016$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $43770bb441d9d016$var$DecodingMode.Legacy;
    return $43770bb441d9d016$var$htmlDecoder(str, mode);
}
module.exports.decodeHTML = $43770bb441d9d016$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $43770bb441d9d016$var$decodeHTMLAttribute(str) {
    return $43770bb441d9d016$var$htmlDecoder(str, $43770bb441d9d016$var$DecodingMode.Attribute);
}
module.exports.decodeHTMLAttribute = $43770bb441d9d016$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $43770bb441d9d016$var$decodeHTMLStrict(str) {
    return $43770bb441d9d016$var$htmlDecoder(str, $43770bb441d9d016$var$DecodingMode.Strict);
}
module.exports.decodeHTMLStrict = $43770bb441d9d016$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $43770bb441d9d016$var$decodeXML(str) {
    return $43770bb441d9d016$var$xmlDecoder(str, $43770bb441d9d016$var$DecodingMode.Strict);
}
module.exports.decodeXML = $43770bb441d9d016$var$decodeXML;

});
parcelRegister("1DRB4", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("6rWFK", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("8xWi9", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $638e9f536b2bacb2$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $638e9f536b2bacb2$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($638e9f536b2bacb2$var$_a = String.fromCodePoint) !== null && $638e9f536b2bacb2$var$_a !== void 0 ? $638e9f536b2bacb2$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $638e9f536b2bacb2$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $638e9f536b2bacb2$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $638e9f536b2bacb2$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $638e9f536b2bacb2$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($638e9f536b2bacb2$var$replaceCodePoint(codePoint));
}
module.exports.default = $638e9f536b2bacb2$var$decodeCodePoint;

});




parcelRegister("lbkvM", function(module, exports) {
"use strict";
var $f6ba8938584963ca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f6ba8938584963ca$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f6ba8938584963ca$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DomHandler = void 0;

var $lLWbo = parcelRequire("lLWbo");


$f6ba8938584963ca$var$__exportStar((parcelRequire("cDdEA")), module.exports);
// Default options
var $f6ba8938584963ca$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $f6ba8938584963ca$var$DomHandler = /** @class */ function() {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (parcelRequire("cDdEA")).Document(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $f6ba8938584963ca$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $f6ba8938584963ca$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function(parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function() {
        this.dom = [];
        this.root = new (parcelRequire("cDdEA")).Document(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function(error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? $lLWbo.ElementType.Tag : undefined;
        var element = new (parcelRequire("cDdEA")).Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function(data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === $lLWbo.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            var node = new (parcelRequire("cDdEA")).Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === $lLWbo.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new (parcelRequire("cDdEA")).Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function() {
        var text = new (parcelRequire("cDdEA")).Text("");
        var node = new (parcelRequire("cDdEA")).CDATA([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function(name, data) {
        var node = new (parcelRequire("cDdEA")).ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    };
    DomHandler.prototype.addNode = function(node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}();
module.exports.DomHandler = $f6ba8938584963ca$var$DomHandler;
module.exports.default = $f6ba8938584963ca$var$DomHandler;

});
parcelRegister("lLWbo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Doctype = module.exports.CDATA = module.exports.Tag = module.exports.Style = module.exports.Script = module.exports.Comment = module.exports.Directive = module.exports.Text = module.exports.Root = module.exports.isTag = module.exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */ var $fd9b1ea99b600663$var$ElementType;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($fd9b1ea99b600663$var$ElementType = module.exports.ElementType || (module.exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */ function $fd9b1ea99b600663$var$isTag(elem) {
    return elem.type === $fd9b1ea99b600663$var$ElementType.Tag || elem.type === $fd9b1ea99b600663$var$ElementType.Script || elem.type === $fd9b1ea99b600663$var$ElementType.Style;
}
module.exports.isTag = $fd9b1ea99b600663$var$isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */ module.exports.Root = $fd9b1ea99b600663$var$ElementType.Root;
/** Type for Text */ module.exports.Text = $fd9b1ea99b600663$var$ElementType.Text;
/** Type for <? ... ?> */ module.exports.Directive = $fd9b1ea99b600663$var$ElementType.Directive;
/** Type for <!-- ... --> */ module.exports.Comment = $fd9b1ea99b600663$var$ElementType.Comment;
/** Type for <script> tags */ module.exports.Script = $fd9b1ea99b600663$var$ElementType.Script;
/** Type for <style> tags */ module.exports.Style = $fd9b1ea99b600663$var$ElementType.Style;
/** Type for Any tag */ module.exports.Tag = $fd9b1ea99b600663$var$ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */ module.exports.CDATA = $fd9b1ea99b600663$var$ElementType.CDATA;
/** Type for <!doctype ...> */ module.exports.Doctype = $fd9b1ea99b600663$var$ElementType.Doctype;

});

parcelRegister("cDdEA", function(module, exports) {
"use strict";
var $9323b7dcbbacadf8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9323b7dcbbacadf8$var$__assign = module.exports && module.exports.__assign || function() {
    $9323b7dcbbacadf8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9323b7dcbbacadf8$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneNode = module.exports.hasChildren = module.exports.isDocument = module.exports.isDirective = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = module.exports.Element = module.exports.Document = module.exports.CDATA = module.exports.NodeWithChildren = module.exports.ProcessingInstruction = module.exports.Comment = module.exports.Text = module.exports.DataNode = module.exports.Node = void 0;

var $lLWbo = parcelRequire("lLWbo");
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ var $9323b7dcbbacadf8$var$Node = /** @class */ function() {
    function Node() {
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.parent;
        },
        set: function(parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.prev;
        },
        set: function(prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.next;
        },
        set: function(next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ Node.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) recursive = false;
        return $9323b7dcbbacadf8$var$cloneNode(this, recursive);
    };
    return Node;
}();
module.exports.Node = $9323b7dcbbacadf8$var$Node;
/**
 * A node that contains some data.
 */ var $9323b7dcbbacadf8$var$DataNode = /** @class */ function(_super) {
    $9323b7dcbbacadf8$var$__extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */ function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.data;
        },
        set: function(data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}($9323b7dcbbacadf8$var$Node);
module.exports.DataNode = $9323b7dcbbacadf8$var$DataNode;
/**
 * Text within the document.
 */ var $9323b7dcbbacadf8$var$Text = /** @class */ function(_super) {
    $9323b7dcbbacadf8$var$__extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $lLWbo.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function() {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}($9323b7dcbbacadf8$var$DataNode);
module.exports.Text = $9323b7dcbbacadf8$var$Text;
/**
 * Comments within the document.
 */ var $9323b7dcbbacadf8$var$Comment = /** @class */ function(_super) {
    $9323b7dcbbacadf8$var$__extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $lLWbo.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function() {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}($9323b7dcbbacadf8$var$DataNode);
module.exports.Comment = $9323b7dcbbacadf8$var$Comment;
/**
 * Processing instructions, including doc types.
 */ var $9323b7dcbbacadf8$var$ProcessingInstruction = /** @class */ function(_super) {
    $9323b7dcbbacadf8$var$__extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = $lLWbo.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}($9323b7dcbbacadf8$var$DataNode);
module.exports.ProcessingInstruction = $9323b7dcbbacadf8$var$ProcessingInstruction;
/**
 * A `Node` that can have children.
 */ var $9323b7dcbbacadf8$var$NodeWithChildren = /** @class */ function(_super) {
    $9323b7dcbbacadf8$var$__extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */ get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */ get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.children;
        },
        set: function(children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}($9323b7dcbbacadf8$var$Node);
module.exports.NodeWithChildren = $9323b7dcbbacadf8$var$NodeWithChildren;
var $9323b7dcbbacadf8$var$CDATA = /** @class */ function(_super) {
    $9323b7dcbbacadf8$var$__extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $lLWbo.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function() {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}($9323b7dcbbacadf8$var$NodeWithChildren);
module.exports.CDATA = $9323b7dcbbacadf8$var$CDATA;
/**
 * The root node of the document.
 */ var $9323b7dcbbacadf8$var$Document = /** @class */ function(_super) {
    $9323b7dcbbacadf8$var$__extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $lLWbo.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function() {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}($9323b7dcbbacadf8$var$NodeWithChildren);
module.exports.Document = $9323b7dcbbacadf8$var$Document;
/**
 * An element within the DOM.
 */ var $9323b7dcbbacadf8$var$Element = /** @class */ function(_super) {
    $9323b7dcbbacadf8$var$__extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ function Element(name, attribs, children, type) {
        if (children === void 0) children = [];
        if (type === void 0) type = name === "script" ? $lLWbo.ElementType.Script : name === "style" ? $lLWbo.ElementType.Style : $lLWbo.ElementType.Tag;
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.name;
        },
        set: function(name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
                var _a, _b;
                return {
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}($9323b7dcbbacadf8$var$NodeWithChildren);
module.exports.Element = $9323b7dcbbacadf8$var$Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $9323b7dcbbacadf8$var$isTag(node) {
    return (0, $lLWbo.isTag)(node);
}
module.exports.isTag = $9323b7dcbbacadf8$var$isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $9323b7dcbbacadf8$var$isCDATA(node) {
    return node.type === $lLWbo.ElementType.CDATA;
}
module.exports.isCDATA = $9323b7dcbbacadf8$var$isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $9323b7dcbbacadf8$var$isText(node) {
    return node.type === $lLWbo.ElementType.Text;
}
module.exports.isText = $9323b7dcbbacadf8$var$isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $9323b7dcbbacadf8$var$isComment(node) {
    return node.type === $lLWbo.ElementType.Comment;
}
module.exports.isComment = $9323b7dcbbacadf8$var$isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $9323b7dcbbacadf8$var$isDirective(node) {
    return node.type === $lLWbo.ElementType.Directive;
}
module.exports.isDirective = $9323b7dcbbacadf8$var$isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $9323b7dcbbacadf8$var$isDocument(node) {
    return node.type === $lLWbo.ElementType.Root;
}
module.exports.isDocument = $9323b7dcbbacadf8$var$isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */ function $9323b7dcbbacadf8$var$hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
module.exports.hasChildren = $9323b7dcbbacadf8$var$hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $9323b7dcbbacadf8$var$cloneNode(node, recursive) {
    if (recursive === void 0) recursive = false;
    var result;
    if ($9323b7dcbbacadf8$var$isText(node)) result = new $9323b7dcbbacadf8$var$Text(node.data);
    else if ($9323b7dcbbacadf8$var$isComment(node)) result = new $9323b7dcbbacadf8$var$Comment(node.data);
    else if ($9323b7dcbbacadf8$var$isTag(node)) {
        var children = recursive ? $9323b7dcbbacadf8$var$cloneChildren(node.children) : [];
        var clone_1 = new $9323b7dcbbacadf8$var$Element(node.name, $9323b7dcbbacadf8$var$__assign({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone_1;
        });
        if (node.namespace != null) clone_1.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = $9323b7dcbbacadf8$var$__assign({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = $9323b7dcbbacadf8$var$__assign({}, node["x-attribsPrefix"]);
        result = clone_1;
    } else if ($9323b7dcbbacadf8$var$isCDATA(node)) {
        var children = recursive ? $9323b7dcbbacadf8$var$cloneChildren(node.children) : [];
        var clone_2 = new $9323b7dcbbacadf8$var$CDATA(children);
        children.forEach(function(child) {
            return child.parent = clone_2;
        });
        result = clone_2;
    } else if ($9323b7dcbbacadf8$var$isDocument(node)) {
        var children = recursive ? $9323b7dcbbacadf8$var$cloneChildren(node.children) : [];
        var clone_3 = new $9323b7dcbbacadf8$var$Document(children);
        children.forEach(function(child) {
            return child.parent = clone_3;
        });
        if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
        result = clone_3;
    } else if ($9323b7dcbbacadf8$var$isDirective(node)) {
        var instruction = new $9323b7dcbbacadf8$var$ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
module.exports.cloneNode = $9323b7dcbbacadf8$var$cloneNode;
function $9323b7dcbbacadf8$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $9323b7dcbbacadf8$var$cloneNode(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("7uUlf", function(module, exports) {
"use strict";
var $57570a08a0a52b96$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $57570a08a0a52b96$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $57570a08a0a52b96$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasChildren = module.exports.isDocument = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = void 0;

$57570a08a0a52b96$var$__exportStar((parcelRequire("ayQYq")), module.exports);

$57570a08a0a52b96$var$__exportStar((parcelRequire("lwUuB")), module.exports);

$57570a08a0a52b96$var$__exportStar((parcelRequire("bgSz2")), module.exports);

$57570a08a0a52b96$var$__exportStar((parcelRequire("4WNii")), module.exports);

$57570a08a0a52b96$var$__exportStar((parcelRequire("2jbht")), module.exports);

$57570a08a0a52b96$var$__exportStar((parcelRequire("dBtdr")), module.exports);

$57570a08a0a52b96$var$__exportStar((parcelRequire("cXR0y")), module.exports);

var $lbkvM = parcelRequire("lbkvM");
Object.defineProperty(module.exports, "isTag", {
    enumerable: true,
    get: function() {
        return $lbkvM.isTag;
    }
});
Object.defineProperty(module.exports, "isCDATA", {
    enumerable: true,
    get: function() {
        return $lbkvM.isCDATA;
    }
});
Object.defineProperty(module.exports, "isText", {
    enumerable: true,
    get: function() {
        return $lbkvM.isText;
    }
});
Object.defineProperty(module.exports, "isComment", {
    enumerable: true,
    get: function() {
        return $lbkvM.isComment;
    }
});
Object.defineProperty(module.exports, "isDocument", {
    enumerable: true,
    get: function() {
        return $lbkvM.isDocument;
    }
});
Object.defineProperty(module.exports, "hasChildren", {
    enumerable: true,
    get: function() {
        return $lbkvM.hasChildren;
    }
});

});
parcelRegister("ayQYq", function(module, exports) {
"use strict";
var $7b062bd2aeb31228$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.innerText = module.exports.textContent = module.exports.getText = module.exports.getInnerHTML = module.exports.getOuterHTML = void 0;

var $lbkvM = parcelRequire("lbkvM");

var $7b062bd2aeb31228$var$dom_serializer_1 = $7b062bd2aeb31228$var$__importDefault((parcelRequire("kafeT")));

var $lLWbo = parcelRequire("lLWbo");
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @returns `node`'s outer HTML.
 */ function $7b062bd2aeb31228$var$getOuterHTML(node, options) {
    return (0, $7b062bd2aeb31228$var$dom_serializer_1.default)(node, options);
}
module.exports.getOuterHTML = $7b062bd2aeb31228$var$getOuterHTML;
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @returns `node`'s inner HTML.
 */ function $7b062bd2aeb31228$var$getInnerHTML(node, options) {
    return (0, $lbkvM.hasChildren)(node) ? node.children.map(function(node) {
        return $7b062bd2aeb31228$var$getOuterHTML(node, options);
    }).join("") : "";
}
module.exports.getInnerHTML = $7b062bd2aeb31228$var$getInnerHTML;
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags. Ignores comments.
 *
 * @category Stringify
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */ function $7b062bd2aeb31228$var$getText(node) {
    if (Array.isArray(node)) return node.map($7b062bd2aeb31228$var$getText).join("");
    if ((0, $lbkvM.isTag)(node)) return node.name === "br" ? "\n" : $7b062bd2aeb31228$var$getText(node.children);
    if ((0, $lbkvM.isCDATA)(node)) return $7b062bd2aeb31228$var$getText(node.children);
    if ((0, $lbkvM.isText)(node)) return node.data;
    return "";
}
module.exports.getText = $7b062bd2aeb31228$var$getText;
/**
 * Get a node's text content. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */ function $7b062bd2aeb31228$var$textContent(node) {
    if (Array.isArray(node)) return node.map($7b062bd2aeb31228$var$textContent).join("");
    if ((0, $lbkvM.hasChildren)(node) && !(0, $lbkvM.isComment)(node)) return $7b062bd2aeb31228$var$textContent(node.children);
    if ((0, $lbkvM.isText)(node)) return node.data;
    return "";
}
module.exports.textContent = $7b062bd2aeb31228$var$textContent;
/**
 * Get a node's inner text, ignoring `<script>` and `<style>` tags. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */ function $7b062bd2aeb31228$var$innerText(node) {
    if (Array.isArray(node)) return node.map($7b062bd2aeb31228$var$innerText).join("");
    if ((0, $lbkvM.hasChildren)(node) && (node.type === $lLWbo.ElementType.Tag || (0, $lbkvM.isCDATA)(node))) return $7b062bd2aeb31228$var$innerText(node.children);
    if ((0, $lbkvM.isText)(node)) return node.data;
    return "";
}
module.exports.innerText = $7b062bd2aeb31228$var$innerText;

});
parcelRegister("kafeT", function(module, exports) {
"use strict";
var $eae09001f36e240f$var$__assign = module.exports && module.exports.__assign || function() {
    $eae09001f36e240f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eae09001f36e240f$var$__assign.apply(this, arguments);
};
var $eae09001f36e240f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eae09001f36e240f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eae09001f36e240f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eae09001f36e240f$var$__createBinding(result, mod, k);
    }
    $eae09001f36e240f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.render = void 0;

/*
 * Module dependencies
 */ var $eae09001f36e240f$var$ElementType = $eae09001f36e240f$var$__importStar((parcelRequire("lLWbo")));

var $7anmF = parcelRequire("7anmF");

var $8jHD2 = parcelRequire("8jHD2");
var $eae09001f36e240f$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $eae09001f36e240f$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $eae09001f36e240f$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $eae09001f36e240f$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? $7anmF.encodeXML : $7anmF.escapeAttribute;
    return Object.keys(attributes).map(function(key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = $8jHD2.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return "".concat(key, "=\"").concat(encode(value), "\"");
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ var $eae09001f36e240f$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */ function $eae09001f36e240f$var$render(node, options) {
    if (options === void 0) options = {};
    var nodes = "length" in node ? node : [
        node
    ];
    var output = "";
    for(var i = 0; i < nodes.length; i++)output += $eae09001f36e240f$var$renderNode(nodes[i], options);
    return output;
}
module.exports.render = $eae09001f36e240f$var$render;
module.exports.default = $eae09001f36e240f$var$render;
function $eae09001f36e240f$var$renderNode(node, options) {
    switch(node.type){
        case $eae09001f36e240f$var$ElementType.Root:
            return $eae09001f36e240f$var$render(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $eae09001f36e240f$var$ElementType.Doctype:
        case $eae09001f36e240f$var$ElementType.Directive:
            return $eae09001f36e240f$var$renderDirective(node);
        case $eae09001f36e240f$var$ElementType.Comment:
            return $eae09001f36e240f$var$renderComment(node);
        case $eae09001f36e240f$var$ElementType.CDATA:
            return $eae09001f36e240f$var$renderCdata(node);
        case $eae09001f36e240f$var$ElementType.Script:
        case $eae09001f36e240f$var$ElementType.Style:
        case $eae09001f36e240f$var$ElementType.Tag:
            return $eae09001f36e240f$var$renderTag(node, options);
        case $eae09001f36e240f$var$ElementType.Text:
            return $eae09001f36e240f$var$renderText(node, options);
    }
}
var $eae09001f36e240f$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
var $eae09001f36e240f$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $eae09001f36e240f$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = $8jHD2.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $eae09001f36e240f$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = $eae09001f36e240f$var$__assign($eae09001f36e240f$var$__assign({}, opts), {
            xmlMode: false
        });
    }
    if (!opts.xmlMode && $eae09001f36e240f$var$foreignElements.has(elem.name)) opts = $eae09001f36e240f$var$__assign($eae09001f36e240f$var$__assign({}, opts), {
        xmlMode: "foreign"
    });
    var tag = "<".concat(elem.name);
    var attribs = $eae09001f36e240f$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += " ".concat(attribs);
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $eae09001f36e240f$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $eae09001f36e240f$var$render(elem.children, opts);
        if (opts.xmlMode || !$eae09001f36e240f$var$singleTag.has(elem.name)) tag += "</".concat(elem.name, ">");
    }
    return tag;
}
function $eae09001f36e240f$var$renderDirective(elem) {
    return "<".concat(elem.data, ">");
}
function $eae09001f36e240f$var$renderText(elem, opts) {
    var _a;
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $eae09001f36e240f$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $7anmF.encodeXML)(data) : (0, $7anmF.escapeText)(data);
    return data;
}
function $eae09001f36e240f$var$renderCdata(elem) {
    return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function $eae09001f36e240f$var$renderComment(elem) {
    return "<!--".concat(elem.data, "-->");
}

});
parcelRegister("7anmF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXMLStrict = module.exports.decodeHTML5Strict = module.exports.decodeHTML4Strict = module.exports.decodeHTML5 = module.exports.decodeHTML4 = module.exports.decodeHTMLAttribute = module.exports.decodeHTMLStrict = module.exports.decodeHTML = module.exports.decodeXML = module.exports.DecodingMode = module.exports.EntityDecoder = module.exports.encodeHTML5 = module.exports.encodeHTML4 = module.exports.encodeNonAsciiHTML = module.exports.encodeHTML = module.exports.escapeText = module.exports.escapeAttribute = module.exports.escapeUTF8 = module.exports.escape = module.exports.encodeXML = module.exports.encode = module.exports.decodeStrict = module.exports.decode = module.exports.EncodingMode = module.exports.EntityLevel = void 0;

var $5N771 = parcelRequire("5N771");

var $2bjwt = parcelRequire("2bjwt");

var $d5hvR = parcelRequire("d5hvR");
/** The level of entities to support. */ var $537b974d3389080a$var$EntityLevel;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($537b974d3389080a$var$EntityLevel = module.exports.EntityLevel || (module.exports.EntityLevel = {}));
var $537b974d3389080a$var$EncodingMode;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($537b974d3389080a$var$EncodingMode = module.exports.EncodingMode || (module.exports.EncodingMode = {}));
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 */ function $537b974d3389080a$var$decode(data, options) {
    if (options === void 0) options = $537b974d3389080a$var$EntityLevel.XML;
    var level = typeof options === "number" ? options : options.level;
    if (level === $537b974d3389080a$var$EntityLevel.HTML) {
        var mode = typeof options === "object" ? options.mode : undefined;
        return (0, $5N771.decodeHTML)(data, mode);
    }
    return (0, $5N771.decodeXML)(data);
}
module.exports.decode = $537b974d3389080a$var$decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 * @deprecated Use `decode` with the `mode` set to `Strict`.
 */ function $537b974d3389080a$var$decodeStrict(data, options) {
    var _a;
    if (options === void 0) options = $537b974d3389080a$var$EntityLevel.XML;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = $5N771.DecodingMode.Strict;
    return $537b974d3389080a$var$decode(data, opts);
}
module.exports.decodeStrict = $537b974d3389080a$var$decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param options Encoding options.
 */ function $537b974d3389080a$var$encode(data, options) {
    if (options === void 0) options = $537b974d3389080a$var$EntityLevel.XML;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $537b974d3389080a$var$EncodingMode.UTF8) return (0, $d5hvR.escapeUTF8)(data);
    if (opts.mode === $537b974d3389080a$var$EncodingMode.Attribute) return (0, $d5hvR.escapeAttribute)(data);
    if (opts.mode === $537b974d3389080a$var$EncodingMode.Text) return (0, $d5hvR.escapeText)(data);
    if (opts.level === $537b974d3389080a$var$EntityLevel.HTML) {
        if (opts.mode === $537b974d3389080a$var$EncodingMode.ASCII) return (0, $2bjwt.encodeNonAsciiHTML)(data);
        return (0, $2bjwt.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $d5hvR.encodeXML)(data);
}
module.exports.encode = $537b974d3389080a$var$encode;

var $d5hvR = parcelRequire("d5hvR");
Object.defineProperty(module.exports, "encodeXML", {
    enumerable: true,
    get: function() {
        return $d5hvR.encodeXML;
    }
});
Object.defineProperty(module.exports, "escape", {
    enumerable: true,
    get: function() {
        return $d5hvR.escape;
    }
});
Object.defineProperty(module.exports, "escapeUTF8", {
    enumerable: true,
    get: function() {
        return $d5hvR.escapeUTF8;
    }
});
Object.defineProperty(module.exports, "escapeAttribute", {
    enumerable: true,
    get: function() {
        return $d5hvR.escapeAttribute;
    }
});
Object.defineProperty(module.exports, "escapeText", {
    enumerable: true,
    get: function() {
        return $d5hvR.escapeText;
    }
});

var $2bjwt = parcelRequire("2bjwt");
Object.defineProperty(module.exports, "encodeHTML", {
    enumerable: true,
    get: function() {
        return $2bjwt.encodeHTML;
    }
});
Object.defineProperty(module.exports, "encodeNonAsciiHTML", {
    enumerable: true,
    get: function() {
        return $2bjwt.encodeNonAsciiHTML;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty(module.exports, "encodeHTML4", {
    enumerable: true,
    get: function() {
        return $2bjwt.encodeHTML;
    }
});
Object.defineProperty(module.exports, "encodeHTML5", {
    enumerable: true,
    get: function() {
        return $2bjwt.encodeHTML;
    }
});

var $5N771 = parcelRequire("5N771");
Object.defineProperty(module.exports, "EntityDecoder", {
    enumerable: true,
    get: function() {
        return $5N771.EntityDecoder;
    }
});
Object.defineProperty(module.exports, "DecodingMode", {
    enumerable: true,
    get: function() {
        return $5N771.DecodingMode;
    }
});
Object.defineProperty(module.exports, "decodeXML", {
    enumerable: true,
    get: function() {
        return $5N771.decodeXML;
    }
});
Object.defineProperty(module.exports, "decodeHTML", {
    enumerable: true,
    get: function() {
        return $5N771.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTMLStrict", {
    enumerable: true,
    get: function() {
        return $5N771.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeHTMLAttribute", {
    enumerable: true,
    get: function() {
        return $5N771.decodeHTMLAttribute;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty(module.exports, "decodeHTML4", {
    enumerable: true,
    get: function() {
        return $5N771.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTML5", {
    enumerable: true,
    get: function() {
        return $5N771.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTML4Strict", {
    enumerable: true,
    get: function() {
        return $5N771.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeHTML5Strict", {
    enumerable: true,
    get: function() {
        return $5N771.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeXMLStrict", {
    enumerable: true,
    get: function() {
        return $5N771.decodeXML;
    }
});

});
parcelRegister("2bjwt", function(module, exports) {
"use strict";
var $196bc0b100e483e9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeNonAsciiHTML = module.exports.encodeHTML = void 0;

var $196bc0b100e483e9$var$encode_html_js_1 = $196bc0b100e483e9$var$__importDefault((parcelRequire("7Ws4G")));

var $d5hvR = parcelRequire("d5hvR");
var $196bc0b100e483e9$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
/**
 * Encodes all characters in the input using HTML entities. This includes
 * characters that are valid ASCII characters in HTML documents, such as `#`.
 *
 * To get a more compact output, consider using the `encodeNonAsciiHTML`
 * function, which will only encode characters that are not valid in HTML
 * documents, as well as non-ASCII characters.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */ function $196bc0b100e483e9$var$encodeHTML(data) {
    return $196bc0b100e483e9$var$encodeHTMLTrieRe($196bc0b100e483e9$var$htmlReplacer, data);
}
module.exports.encodeHTML = $196bc0b100e483e9$var$encodeHTML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities. This function will not encode characters that
 * are valid in HTML documents, such as `#`.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */ function $196bc0b100e483e9$var$encodeNonAsciiHTML(data) {
    return $196bc0b100e483e9$var$encodeHTMLTrieRe($d5hvR.xmlReplacer, data);
}
module.exports.encodeNonAsciiHTML = $196bc0b100e483e9$var$encodeNonAsciiHTML;
function $196bc0b100e483e9$var$encodeHTMLTrieRe(regExp, str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = regExp.exec(str)) !== null){
        var i = match.index;
        ret += str.substring(lastIdx, i);
        var char = str.charCodeAt(i);
        var next = $196bc0b100e483e9$var$encode_html_js_1.default.get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                var nextChar = str.charCodeAt(i + 1);
                var value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            var cp = (0, $d5hvR.getCodePoint)(str, i);
            ret += "&#x".concat(cp.toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("7Ws4G", function(module, exports) {
"use strict";
// Generated using scripts/write-encode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $5c83ba3757da0c1b$var$restoreDiff(arr) {
    for(var i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
// prettier-ignore
module.exports.default = new Map(/* #__PURE__ */ $5c83ba3757da0c1b$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $5c83ba3757da0c1b$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $5c83ba3757da0c1b$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $5c83ba3757da0c1b$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("d5hvR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.escapeText = module.exports.escapeAttribute = module.exports.escapeUTF8 = module.exports.escape = module.exports.encodeXML = module.exports.getCodePoint = module.exports.xmlReplacer = void 0;
module.exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
var $986953aa73c4694e$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
// For compatibility with node < 4, we wrap `codePointAt`
module.exports.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function(str, index) {
    return str.codePointAt(index);
} : function(c, index) {
    return (c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
};
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ function $986953aa73c4694e$var$encodeXML(str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = module.exports.xmlReplacer.exec(str)) !== null){
        var i = match.index;
        var char = str.charCodeAt(i);
        var next = $986953aa73c4694e$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, module.exports.getCodePoint)(str, i).toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = module.exports.xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
module.exports.encodeXML = $986953aa73c4694e$var$encodeXML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */ module.exports.escape = $986953aa73c4694e$var$encodeXML;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $986953aa73c4694e$var$getEscaper(regex, map) {
    return function escape(data) {
        var match;
        var lastIdx = 0;
        var result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
/**
 * Encodes all characters not valid in XML documents using XML entities.
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */ module.exports.escapeUTF8 = $986953aa73c4694e$var$getEscaper(/[&<>'"]/g, $986953aa73c4694e$var$xmlCodeMap);
/**
 * Encodes all characters that have to be escaped in HTML attributes,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ module.exports.escapeAttribute = $986953aa73c4694e$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
/**
 * Encodes all characters that have to be escaped in HTML text,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ module.exports.escapeText = $986953aa73c4694e$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("8jHD2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attributeNames = module.exports.elementNames = void 0;
module.exports.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));
module.exports.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));

});



parcelRegister("lwUuB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prevElementSibling = module.exports.nextElementSibling = module.exports.getName = module.exports.hasAttrib = module.exports.getAttributeValue = module.exports.getSiblings = module.exports.getParent = module.exports.getChildren = void 0;

var $lbkvM = parcelRequire("lbkvM");
/**
 * Get a node's children.
 *
 * @category Traversal
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */ function $fac86861b5d6d5be$var$getChildren(elem) {
    return (0, $lbkvM.hasChildren)(elem) ? elem.children : [];
}
module.exports.getChildren = $fac86861b5d6d5be$var$getChildren;
/**
 * Get a node's parent.
 *
 * @category Traversal
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node, or `null` if `elem` is a root node.
 */ function $fac86861b5d6d5be$var$getParent(elem) {
    return elem.parent || null;
}
module.exports.getParent = $fac86861b5d6d5be$var$getParent;
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first. If we don't
 * have a parent (the element is a root node), we walk the element's `prev` &
 * `next` to get all remaining nodes.
 *
 * @category Traversal
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings, including `elem`.
 */ function $fac86861b5d6d5be$var$getSiblings(elem) {
    var _a, _b;
    var parent = $fac86861b5d6d5be$var$getParent(elem);
    if (parent != null) return $fac86861b5d6d5be$var$getChildren(parent);
    var siblings = [
        elem
    ];
    var prev = elem.prev, next = elem.next;
    while(prev != null){
        siblings.unshift(prev);
        _a = prev, prev = _a.prev;
    }
    while(next != null){
        siblings.push(next);
        _b = next, next = _b.next;
    }
    return siblings;
}
module.exports.getSiblings = $fac86861b5d6d5be$var$getSiblings;
/**
 * Gets an attribute from an element.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */ function $fac86861b5d6d5be$var$getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
module.exports.getAttributeValue = $fac86861b5d6d5be$var$getAttributeValue;
/**
 * Checks whether an element has an attribute.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */ function $fac86861b5d6d5be$var$hasAttrib(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
module.exports.hasAttrib = $fac86861b5d6d5be$var$hasAttrib;
/**
 * Get the tag name of an element.
 *
 * @category Traversal
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */ function $fac86861b5d6d5be$var$getName(elem) {
    return elem.name;
}
module.exports.getName = $fac86861b5d6d5be$var$getName;
/**
 * Returns the next element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag, or `null` if there is no next
 * sibling.
 */ function $fac86861b5d6d5be$var$nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while(next !== null && !(0, $lbkvM.isTag)(next))_a = next, next = _a.next;
    return next;
}
module.exports.nextElementSibling = $fac86861b5d6d5be$var$nextElementSibling;
/**
 * Returns the previous element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag, or `null` if there is no
 * previous sibling.
 */ function $fac86861b5d6d5be$var$prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while(prev !== null && !(0, $lbkvM.isTag)(prev))_a = prev, prev = _a.prev;
    return prev;
}
module.exports.prevElementSibling = $fac86861b5d6d5be$var$prevElementSibling;

});

parcelRegister("bgSz2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepend = module.exports.prependChild = module.exports.append = module.exports.appendChild = module.exports.replaceElement = module.exports.removeElement = void 0;
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $834b83a76a07907b$var$removeElement(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        var childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
module.exports.removeElement = $834b83a76a07907b$var$removeElement;
/**
 * Replace an element in the dom
 *
 * @category Manipulation
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */ function $834b83a76a07907b$var$replaceElement(elem, replacement) {
    var prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    var next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    var parent = replacement.parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
module.exports.replaceElement = $834b83a76a07907b$var$replaceElement;
/**
 * Append a child to an element.
 *
 * @category Manipulation
 * @param parent The element to append to.
 * @param child The element to be added as a child.
 */ function $834b83a76a07907b$var$appendChild(parent, child) {
    $834b83a76a07907b$var$removeElement(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        var sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
module.exports.appendChild = $834b83a76a07907b$var$appendChild;
/**
 * Append an element after another.
 *
 * @category Manipulation
 * @param elem The element to append after.
 * @param next The element be added.
 */ function $834b83a76a07907b$var$append(elem, next) {
    $834b83a76a07907b$var$removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
module.exports.append = $834b83a76a07907b$var$append;
/**
 * Prepend a child to an element.
 *
 * @category Manipulation
 * @param parent The element to prepend before.
 * @param child The element to be added as a child.
 */ function $834b83a76a07907b$var$prependChild(parent, child) {
    $834b83a76a07907b$var$removeElement(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        var sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
module.exports.prependChild = $834b83a76a07907b$var$prependChild;
/**
 * Prepend an element before another.
 *
 * @category Manipulation
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */ function $834b83a76a07907b$var$prepend(elem, prev) {
    $834b83a76a07907b$var$removeElement(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}
module.exports.prepend = $834b83a76a07907b$var$prepend;

});

parcelRegister("4WNii", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAll = module.exports.existsOne = module.exports.findOne = module.exports.findOneChild = module.exports.find = module.exports.filter = void 0;

var $lbkvM = parcelRequire("lbkvM");
/**
 * Search a node and its children for nodes passing a test function. If `node` is not an array, it will be wrapped in one.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */ function $39a2d0f751085c93$var$filter(test, node, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return $39a2d0f751085c93$var$find(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
module.exports.filter = $39a2d0f751085c93$var$filter;
/**
 * Search an array of nodes and their children for nodes passing a test function.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */ function $39a2d0f751085c93$var$find(test, nodes, recurse, limit) {
    var result = [];
    /** Stack of the arrays we are looking at. */ var nodeStack = [
        nodes
    ];
    /** Stack of the indices within the arrays. */ var indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $lbkvM.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
module.exports.find = $39a2d0f751085c93$var$find;
/**
 * Finds the first element inside of an array that matches a test function. This is an alias for `Array.prototype.find`.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 * @deprecated Use `Array.prototype.find` directly.
 */ function $39a2d0f751085c93$var$findOneChild(test, nodes) {
    return nodes.find(test);
}
module.exports.findOneChild = $39a2d0f751085c93$var$findOneChild;
/**
 * Finds one element in a tree that passes a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Node or array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first node that passes `test`.
 */ function $39a2d0f751085c93$var$findOne(test, nodes, recurse) {
    if (recurse === void 0) recurse = true;
    var elem = null;
    for(var i = 0; i < nodes.length && !elem; i++){
        var node = nodes[i];
        if (!(0, $lbkvM.isTag)(node)) continue;
        else if (test(node)) elem = node;
        else if (recurse && node.children.length > 0) elem = $39a2d0f751085c93$var$findOne(test, node.children, true);
    }
    return elem;
}
module.exports.findOne = $39a2d0f751085c93$var$findOne;
/**
 * Checks if a tree of nodes contains at least one node passing a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing the test.
 */ function $39a2d0f751085c93$var$existsOne(test, nodes) {
    return nodes.some(function(checked) {
        return (0, $lbkvM.isTag)(checked) && (test(checked) || $39a2d0f751085c93$var$existsOne(test, checked.children));
    });
}
module.exports.existsOne = $39a2d0f751085c93$var$existsOne;
/**
 * Search an array of nodes and their children for elements passing a test function.
 *
 * Same as `find`, but limited to elements and with less options, leading to reduced complexity.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */ function $39a2d0f751085c93$var$findAll(test, nodes) {
    var result = [];
    var nodeStack = [
        nodes
    ];
    var indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (!(0, $lbkvM.isTag)(elem)) continue;
        if (test(elem)) result.push(elem);
        if (elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
module.exports.findAll = $39a2d0f751085c93$var$findAll;

});

parcelRegister("2jbht", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getElementsByTagType = module.exports.getElementsByTagName = module.exports.getElementById = module.exports.getElements = module.exports.testElement = void 0;

var $lbkvM = parcelRequire("lbkvM");

var $4WNii = parcelRequire("4WNii");
/**
 * A map of functions to check nodes against.
 */ var $1ae61b480ef43b09$var$Checks = {
    tag_name: function(name) {
        if (typeof name === "function") return function(elem) {
            return (0, $lbkvM.isTag)(elem) && name(elem.name);
        };
        else if (name === "*") return $lbkvM.isTag;
        return function(elem) {
            return (0, $lbkvM.isTag)(elem) && elem.name === name;
        };
    },
    tag_type: function(type) {
        if (typeof type === "function") return function(elem) {
            return type(elem.type);
        };
        return function(elem) {
            return elem.type === type;
        };
    },
    tag_contains: function(data) {
        if (typeof data === "function") return function(elem) {
            return (0, $lbkvM.isText)(elem) && data(elem.data);
        };
        return function(elem) {
            return (0, $lbkvM.isText)(elem) && elem.data === data;
        };
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $1ae61b480ef43b09$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return function(elem) {
        return (0, $lbkvM.isTag)(elem) && value(elem.attribs[attrib]);
    };
    return function(elem) {
        return (0, $lbkvM.isTag)(elem) && elem.attribs[attrib] === value;
    };
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $1ae61b480ef43b09$var$combineFuncs(a, b) {
    return function(elem) {
        return a(elem) || b(elem);
    };
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $1ae61b480ef43b09$var$compileTest(options) {
    var funcs = Object.keys(options).map(function(key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call($1ae61b480ef43b09$var$Checks, key) ? $1ae61b480ef43b09$var$Checks[key](value) : $1ae61b480ef43b09$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($1ae61b480ef43b09$var$combineFuncs);
}
/**
 * Checks whether a node matches the description in `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */ function $1ae61b480ef43b09$var$testElement(options, node) {
    var test = $1ae61b480ef43b09$var$compileTest(options);
    return test ? test(node) : true;
}
module.exports.testElement = $1ae61b480ef43b09$var$testElement;
/**
 * Returns all nodes that match `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */ function $1ae61b480ef43b09$var$getElements(options, nodes, recurse, limit) {
    if (limit === void 0) limit = Infinity;
    var test = $1ae61b480ef43b09$var$compileTest(options);
    return test ? (0, $4WNii.filter)(test, nodes, recurse, limit) : [];
}
module.exports.getElements = $1ae61b480ef43b09$var$getElements;
/**
 * Returns the node with the supplied ID.
 *
 * @category Legacy Query Functions
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */ function $1ae61b480ef43b09$var$getElementById(id, nodes, recurse) {
    if (recurse === void 0) recurse = true;
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $4WNii.findOne)($1ae61b480ef43b09$var$getAttribCheck("id", id), nodes, recurse);
}
module.exports.getElementById = $1ae61b480ef43b09$var$getElementById;
/**
 * Returns all nodes with the supplied `tagName`.
 *
 * @category Legacy Query Functions
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */ function $1ae61b480ef43b09$var$getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $4WNii.filter)($1ae61b480ef43b09$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
module.exports.getElementsByTagName = $1ae61b480ef43b09$var$getElementsByTagName;
/**
 * Returns all nodes with the supplied `type`.
 *
 * @category Legacy Query Functions
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */ function $1ae61b480ef43b09$var$getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $4WNii.filter)($1ae61b480ef43b09$var$Checks["tag_type"](type), nodes, recurse, limit);
}
module.exports.getElementsByTagType = $1ae61b480ef43b09$var$getElementsByTagType;

});

parcelRegister("dBtdr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uniqueSort = module.exports.compareDocumentPosition = module.exports.DocumentPosition = module.exports.removeSubsets = void 0;

var $lbkvM = parcelRequire("lbkvM");
/**
 * Given an array of nodes, remove any member that is contained by another
 * member.
 *
 * @category Helpers
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't contained by other nodes.
 */ function $9e7564bc63c80b17$var$removeSubsets(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(var ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
module.exports.removeSubsets = $9e7564bc63c80b17$var$removeSubsets;
/**
 * @category Helpers
 * @see {@link http://dom.spec.whatwg.org/#dom-node-comparedocumentposition}
 */ var $9e7564bc63c80b17$var$DocumentPosition;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($9e7564bc63c80b17$var$DocumentPosition = module.exports.DocumentPosition || (module.exports.DocumentPosition = {}));
/**
 * Compare the position of one node against another node in any other document,
 * returning a bitmask with the values from {@link DocumentPosition}.
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent.
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @category Helpers
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */ function $9e7564bc63c80b17$var$compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) return 0;
    var current = (0, $lbkvM.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $lbkvM.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $9e7564bc63c80b17$var$DocumentPosition.DISCONNECTED;
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $9e7564bc63c80b17$var$DocumentPosition.FOLLOWING | $9e7564bc63c80b17$var$DocumentPosition.CONTAINED_BY;
        return $9e7564bc63c80b17$var$DocumentPosition.FOLLOWING;
    }
    if (sharedParent === nodeA) return $9e7564bc63c80b17$var$DocumentPosition.PRECEDING | $9e7564bc63c80b17$var$DocumentPosition.CONTAINS;
    return $9e7564bc63c80b17$var$DocumentPosition.PRECEDING;
}
module.exports.compareDocumentPosition = $9e7564bc63c80b17$var$compareDocumentPosition;
/**
 * Sort an array of nodes based on their relative position in the document,
 * removing any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @category Helpers
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */ function $9e7564bc63c80b17$var$uniqueSort(nodes) {
    nodes = nodes.filter(function(node, i, arr) {
        return !arr.includes(node, i + 1);
    });
    nodes.sort(function(a, b) {
        var relative = $9e7564bc63c80b17$var$compareDocumentPosition(a, b);
        if (relative & $9e7564bc63c80b17$var$DocumentPosition.PRECEDING) return -1;
        else if (relative & $9e7564bc63c80b17$var$DocumentPosition.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}
module.exports.uniqueSort = $9e7564bc63c80b17$var$uniqueSort;

});

parcelRegister("cXR0y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeed = void 0;

var $ayQYq = parcelRequire("ayQYq");

var $2jbht = parcelRequire("2jbht");
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @category Feeds
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */ function $97041d0086276814$var$getFeed(doc) {
    var feedRoot = $97041d0086276814$var$getOneElement($97041d0086276814$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $97041d0086276814$var$getAtomFeed(feedRoot) : $97041d0086276814$var$getRssFeed(feedRoot);
}
module.exports.getFeed = $97041d0086276814$var$getFeed;
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $97041d0086276814$var$getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, $2jbht.getElementsByTagName)("entry", childs).map(function(item) {
            var _a;
            var children = item.children;
            var entry = {
                media: $97041d0086276814$var$getMediaElements(children)
            };
            $97041d0086276814$var$addConditionally(entry, "id", "id", children);
            $97041d0086276814$var$addConditionally(entry, "title", "title", children);
            var href = (_a = $97041d0086276814$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            var description = $97041d0086276814$var$fetch("summary", children) || $97041d0086276814$var$fetch("content", children);
            if (description) entry.description = description;
            var pubDate = $97041d0086276814$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $97041d0086276814$var$addConditionally(feed, "id", "id", childs);
    $97041d0086276814$var$addConditionally(feed, "title", "title", childs);
    var href = (_a = $97041d0086276814$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $97041d0086276814$var$addConditionally(feed, "description", "subtitle", childs);
    var updated = $97041d0086276814$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $97041d0086276814$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $97041d0086276814$var$getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = $97041d0086276814$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $2jbht.getElementsByTagName)("item", feedRoot.children).map(function(item) {
            var children = item.children;
            var entry = {
                media: $97041d0086276814$var$getMediaElements(children)
            };
            $97041d0086276814$var$addConditionally(entry, "id", "guid", children);
            $97041d0086276814$var$addConditionally(entry, "title", "title", children);
            $97041d0086276814$var$addConditionally(entry, "link", "link", children);
            $97041d0086276814$var$addConditionally(entry, "description", "description", children);
            var pubDate = $97041d0086276814$var$fetch("pubDate", children) || $97041d0086276814$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $97041d0086276814$var$addConditionally(feed, "title", "title", childs);
    $97041d0086276814$var$addConditionally(feed, "link", "link", childs);
    $97041d0086276814$var$addConditionally(feed, "description", "description", childs);
    var updated = $97041d0086276814$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $97041d0086276814$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var $97041d0086276814$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
var $97041d0086276814$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $97041d0086276814$var$getMediaElements(where) {
    return (0, $2jbht.getElementsByTagName)("media:content", where).map(function(elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for(var _i = 0, MEDIA_KEYS_STRING_1 = $97041d0086276814$var$MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++){
            var attrib = MEDIA_KEYS_STRING_1[_i];
            if (attribs[attrib]) media[attrib] = attribs[attrib];
        }
        for(var _a = 0, MEDIA_KEYS_INT_1 = $97041d0086276814$var$MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++){
            var attrib = MEDIA_KEYS_INT_1[_a];
            if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        }
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $97041d0086276814$var$getOneElement(tagName, node) {
    return (0, $2jbht.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $97041d0086276814$var$fetch(tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    return (0, $ayQYq.textContent)((0, $2jbht.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $97041d0086276814$var$addConditionally(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    var val = $97041d0086276814$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $97041d0086276814$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});



parcelRegister("5cbFW", function(module, exports) {
'use strict';
module.exports = (string)=>{
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};

});

parcelRegister("jX8y7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $e86a28b4125f4dd2$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $e86a28b4125f4dd2$var$isPlainObject(o) {
    var ctor, prot;
    if ($e86a28b4125f4dd2$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($e86a28b4125f4dd2$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}
module.exports.isPlainObject = $e86a28b4125f4dd2$var$isPlainObject;

});

parcelRegister("4lQO5", function(module, exports) {
'use strict';
var $32b215f01a060d7d$var$isMergeableObject = function isMergeableObject(value) {
    return $32b215f01a060d7d$var$isNonNullObject(value) && !$32b215f01a060d7d$var$isSpecial(value);
};
function $32b215f01a060d7d$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $32b215f01a060d7d$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $32b215f01a060d7d$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $32b215f01a060d7d$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $32b215f01a060d7d$var$REACT_ELEMENT_TYPE = $32b215f01a060d7d$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $32b215f01a060d7d$var$isReactElement(value) {
    return value.$$typeof === $32b215f01a060d7d$var$REACT_ELEMENT_TYPE;
}
function $32b215f01a060d7d$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $32b215f01a060d7d$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $32b215f01a060d7d$var$deepmerge($32b215f01a060d7d$var$emptyTarget(value), value, options) : value;
}
function $32b215f01a060d7d$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $32b215f01a060d7d$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $32b215f01a060d7d$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $32b215f01a060d7d$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : $32b215f01a060d7d$var$deepmerge;
}
function $32b215f01a060d7d$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $32b215f01a060d7d$var$getKeys(target) {
    return Object.keys(target).concat($32b215f01a060d7d$var$getEnumerableOwnPropertySymbols(target));
}
function $32b215f01a060d7d$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $32b215f01a060d7d$var$propertyIsUnsafe(target, key) {
    return $32b215f01a060d7d$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $32b215f01a060d7d$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $32b215f01a060d7d$var$getKeys(target).forEach(function(key) {
        destination[key] = $32b215f01a060d7d$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $32b215f01a060d7d$var$getKeys(source).forEach(function(key) {
        if ($32b215f01a060d7d$var$propertyIsUnsafe(target, key)) return;
        if ($32b215f01a060d7d$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $32b215f01a060d7d$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $32b215f01a060d7d$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $32b215f01a060d7d$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $32b215f01a060d7d$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $32b215f01a060d7d$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $32b215f01a060d7d$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $32b215f01a060d7d$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $32b215f01a060d7d$var$mergeObject(target, source, options);
}
$32b215f01a060d7d$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $32b215f01a060d7d$var$deepmerge(prev, next, options);
    }, {});
};
var $32b215f01a060d7d$var$deepmerge_1 = $32b215f01a060d7d$var$deepmerge;
module.exports = $32b215f01a060d7d$var$deepmerge_1;

});

parcelRegister("pY0nV", function(module, exports) {
/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.parseSrcset = factory();
})(module.exports, function() {
    // 1. Let input be the value passed to this algorithm.
    return function(input) {
        // UTILITY FUNCTIONS
        // Manual is faster than RegEx
        // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
        // http://jsperf.com/whitespace-character/5
        function isSpace(c) {
            return c === "\u0020" || // space
            c === "\u0009" || // horizontal tab
            c === "\u000A" || // new line
            c === "\u000C" || // form feed
            c === "\u000D"; // carriage return
        }
        function collectCharacters(regEx) {
            var chars, match = regEx.exec(input.substring(pos));
            if (match) {
                chars = match[0];
                pos += chars.length;
                return chars;
            }
        }
        var inputLength = input.length, // (Don't use \s, to avoid matching non-breaking space)
        regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, // ( Positive or negative or unsigned integers or decimals, without or without exponents.
        // Must include at least one digit.
        // According to spec tests any decimal point must be followed by a digit.
        // No leading plus sign is allowed.)
        // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
        regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c, // 2. Let position be a pointer into input, initially pointing at the start
        //    of the string.
        pos = 0, // 3. Let candidates be an initially empty source set.
        candidates = [];
        // 4. Splitting loop: Collect a sequence of characters that are space
        //    characters or U+002C COMMA characters. If any U+002C COMMA characters
        //    were collected, that is a parse error.
        while(true){
            collectCharacters(regexLeadingCommasOrSpaces);
            // 5. If position is past the end of input, return candidates and abort these steps.
            if (pos >= inputLength) return candidates; // (we're done, this is the sole return path)
            // 6. Collect a sequence of characters that are not space characters,
            //    and let that be url.
            url = collectCharacters(regexLeadingNotSpaces);
            // 7. Let descriptors be a new empty list.
            descriptors = [];
            // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
            //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
            //         more than one character, that is a parse error.
            if (url.slice(-1) === ",") {
                url = url.replace(regexTrailingCommas, "");
                // (Jump ahead to step 9 to skip tokenization and just push the candidate).
                parseDescriptors();
            //	Otherwise, follow these substeps:
            } else tokenize();
             // (close else of step 8)
        // 16. Return to the step labeled splitting loop.
        } // (Close of big while loop.)
        /**
		 * Tokenizes descriptor properties prior to parsing
		 * Returns undefined.
		 */ function tokenize() {
            // 8.1. Descriptor tokeniser: Skip whitespace
            collectCharacters(regexLeadingSpaces);
            // 8.2. Let current descriptor be the empty string.
            currentDescriptor = "";
            // 8.3. Let state be in descriptor.
            state = "in descriptor";
            while(true){
                // 8.4. Let c be the character at position.
                c = input.charAt(pos);
                //  Do the following depending on the value of state.
                //  For the purpose of this step, "EOF" is a special character representing
                //  that position is past the end of input.
                // In descriptor
                if (state === "in descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors and let current descriptor be the empty string.
                    // Set state to after descriptor.
                    if (isSpace(c)) {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                            currentDescriptor = "";
                            state = "after descriptor";
                        }
                    } else if (c === ",") {
                        pos += 1;
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // U+0028 LEFT PARENTHESIS (()
                    // Append c to current descriptor. Set state to in parens.
                    } else if (c === "\u0028") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in parens";
                    // EOF
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors. Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // (end "in descriptor"
                // In parens
                } else if (state === "in parens") {
                    // U+0029 RIGHT PARENTHESIS ())
                    // Append c to current descriptor. Set state to in descriptor.
                    if (c === ")") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in descriptor";
                    // EOF
                    // Append current descriptor to descriptors. Jump to the step labeled
                    // descriptor parser.
                    } else if (c === "") {
                        descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // After descriptor
                } else if (state === "after descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character: Stay in this state.
                    if (isSpace(c)) ;
                    else if (c === "") {
                        parseDescriptors();
                        return;
                    // Anything else
                    // Set state to in descriptor. Set position to the previous character in input.
                    } else {
                        state = "in descriptor";
                        pos -= 1;
                    }
                }
                // Advance position to the next character in input.
                pos += 1;
            // Repeat this step.
            } // (close while true loop)
        }
        /**
		 * Adds descriptor properties to a candidate, pushes to the candidates array
		 * @return undefined
		 */ // Declared outside of the while loop so that it's only created once.
        function parseDescriptors() {
            // 9. Descriptor parser: Let error be no.
            var pError = false, // 10. Let width be absent.
            // 11. Let density be absent.
            // 12. Let future-compat-h be absent. (We're implementing it now as h)
            w, d, h, i, candidate = {}, desc, lastChar, value, intVal, floatVal;
            // 13. For each descriptor in descriptors, run the appropriate set of steps
            // from the following list:
            for(i = 0; i < descriptors.length; i++){
                desc = descriptors[i];
                lastChar = desc[desc.length - 1];
                value = desc.substring(0, desc.length - 1);
                intVal = parseInt(value, 10);
                floatVal = parseFloat(value);
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0077 LATIN SMALL LETTER W character
                if (regexNonNegativeInteger.test(value) && lastChar === "w") {
                    // If width and density are not both absent, then let error be yes.
                    if (w || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes.
                    // Otherwise, let width be the result.
                    if (intVal === 0) pError = true;
                    else w = intVal;
                // If the descriptor consists of a valid floating-point number followed by
                // a U+0078 LATIN SMALL LETTER X character
                } else if (regexFloatingPoint.test(value) && lastChar === "x") {
                    // If width, density and future-compat-h are not all absent, then let error
                    // be yes.
                    if (w || d || h) pError = true;
                    // Apply the rules for parsing floating-point number values to the descriptor.
                    // If the result is less than zero, let error be yes. Otherwise, let density
                    // be the result.
                    if (floatVal < 0) pError = true;
                    else d = floatVal;
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0068 LATIN SMALL LETTER H character
                } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
                    // If height and density are not both absent, then let error be yes.
                    if (h || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes. Otherwise, let future-compat-h
                    // be the result.
                    if (intVal === 0) pError = true;
                    else h = intVal;
                // Anything else, Let error be yes.
                } else pError = true;
            } // (close step 13 for loop)
            // 15. If error is still no, then append a new image source to candidates whose
            // URL is url, associated with a width width if not absent and a pixel
            // density density if not absent. Otherwise, there is a parse error.
            if (!pError) {
                candidate.url = url;
                if (w) candidate.w = w;
                if (d) candidate.d = d;
                if (h) candidate.h = h;
                candidates.push(candidate);
            } else if (console && console.log) console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
        } // (close parseDescriptors fn)
    };
});

});

parcelRegister("cM5eX", function(module, exports) {
'use strict';

var $52u6H = parcelRequire("52u6H");

var $kmNwY = parcelRequire("kmNwY");

var $etTkx = parcelRequire("etTkx");

var $kn5GT = parcelRequire("kn5GT");

var $6LzYO = parcelRequire("6LzYO");

var $ceQvC = parcelRequire("ceQvC");

var $6sfgU = parcelRequire("6sfgU");

var $37fY5 = parcelRequire("37fY5");

var $h9jM6 = parcelRequire("h9jM6");

var $1Zscw = parcelRequire("1Zscw");

var $5rixA = parcelRequire("5rixA");

var $gFMnm = parcelRequire("gFMnm");

var $kwhQ7 = parcelRequire("kwhQ7");

var $3xfLS = parcelRequire("3xfLS");

var $jmTyl = parcelRequire("jmTyl");

var $2YUr2 = parcelRequire("2YUr2");

var $cDOWD = parcelRequire("cDOWD");

var $1SmAa = parcelRequire("1SmAa");
function $94ce0859df124dc1$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $6LzYO(plugins);
}
$94ce0859df124dc1$var$postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ': postcss.plugin was deprecated. Migration guide:\n' + 'https://evilmartians.com/chronicles/postcss-8-plugin-migration');
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $6LzYO().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, 'postcss', {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $94ce0859df124dc1$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$94ce0859df124dc1$var$postcss.stringify = $ceQvC;
$94ce0859df124dc1$var$postcss.parse = $3xfLS;
$94ce0859df124dc1$var$postcss.fromJSON = $6sfgU;
$94ce0859df124dc1$var$postcss.list = $jmTyl;
$94ce0859df124dc1$var$postcss.comment = (defaults)=>new $1Zscw(defaults);
$94ce0859df124dc1$var$postcss.atRule = (defaults)=>new $5rixA(defaults);
$94ce0859df124dc1$var$postcss.decl = (defaults)=>new $kmNwY(defaults);
$94ce0859df124dc1$var$postcss.rule = (defaults)=>new $2YUr2(defaults);
$94ce0859df124dc1$var$postcss.root = (defaults)=>new $cDOWD(defaults);
$94ce0859df124dc1$var$postcss.document = (defaults)=>new $37fY5(defaults);
$94ce0859df124dc1$var$postcss.CssSyntaxError = $52u6H;
$94ce0859df124dc1$var$postcss.Declaration = $kmNwY;
$94ce0859df124dc1$var$postcss.Container = $kn5GT;
$94ce0859df124dc1$var$postcss.Processor = $6LzYO;
$94ce0859df124dc1$var$postcss.Document = $37fY5;
$94ce0859df124dc1$var$postcss.Comment = $1Zscw;
$94ce0859df124dc1$var$postcss.Warning = $h9jM6;
$94ce0859df124dc1$var$postcss.AtRule = $5rixA;
$94ce0859df124dc1$var$postcss.Result = $gFMnm;
$94ce0859df124dc1$var$postcss.Input = $kwhQ7;
$94ce0859df124dc1$var$postcss.Rule = $2YUr2;
$94ce0859df124dc1$var$postcss.Root = $cDOWD;
$94ce0859df124dc1$var$postcss.Node = $1SmAa;
$etTkx.registerPostcss($94ce0859df124dc1$var$postcss);
module.exports = $94ce0859df124dc1$var$postcss;
$94ce0859df124dc1$var$postcss.default = $94ce0859df124dc1$var$postcss;

});
parcelRegister("52u6H", function(module, exports) {
'use strict';

var $8RvTv = parcelRequire("8RvTv");

var $jBKLa = parcelRequire("jBKLa");
class $3ab47e455381fcbd$var$CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin){
        super(message);
        this.name = 'CssSyntaxError';
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin) this.plugin = plugin;
        if (typeof line !== 'undefined' && typeof column !== 'undefined') {
            if (typeof line === 'number') {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, $3ab47e455381fcbd$var$CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ': ' : '';
        this.message += this.file ? this.file : '<css input>';
        if (typeof this.line !== 'undefined') this.message += ':' + this.line + ':' + this.column;
        this.message += ': ' + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return '';
        let css = this.source;
        if (color == null) color = $8RvTv.isColorSupported;
        if ($jBKLa) {
            if (color) css = $jBKLa(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $8RvTv.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else mark = aside = (str)=>str;
        return lines.slice(start, end).map((line, index)=>{
            let number = start + 1 + index;
            let gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, this.column - 1).replace(/[^\t]/g, ' ');
                return mark('>') + aside(gutter) + line + '\n ' + spacing + mark('^');
            }
            return ' ' + aside(gutter) + line;
        }).join('\n');
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = '\n\n' + code + '\n';
        return this.name + ': ' + this.message + code;
    }
}
module.exports = $3ab47e455381fcbd$var$CssSyntaxError;
$3ab47e455381fcbd$var$CssSyntaxError.default = $3ab47e455381fcbd$var$CssSyntaxError;

});
parcelRegister("8RvTv", function(module, exports) {
var $673c037b2406aad2$var$x = String;
var $673c037b2406aad2$var$create = function() {
    return {
        isColorSupported: false,
        reset: $673c037b2406aad2$var$x,
        bold: $673c037b2406aad2$var$x,
        dim: $673c037b2406aad2$var$x,
        italic: $673c037b2406aad2$var$x,
        underline: $673c037b2406aad2$var$x,
        inverse: $673c037b2406aad2$var$x,
        hidden: $673c037b2406aad2$var$x,
        strikethrough: $673c037b2406aad2$var$x,
        black: $673c037b2406aad2$var$x,
        red: $673c037b2406aad2$var$x,
        green: $673c037b2406aad2$var$x,
        yellow: $673c037b2406aad2$var$x,
        blue: $673c037b2406aad2$var$x,
        magenta: $673c037b2406aad2$var$x,
        cyan: $673c037b2406aad2$var$x,
        white: $673c037b2406aad2$var$x,
        gray: $673c037b2406aad2$var$x,
        bgBlack: $673c037b2406aad2$var$x,
        bgRed: $673c037b2406aad2$var$x,
        bgGreen: $673c037b2406aad2$var$x,
        bgYellow: $673c037b2406aad2$var$x,
        bgBlue: $673c037b2406aad2$var$x,
        bgMagenta: $673c037b2406aad2$var$x,
        bgCyan: $673c037b2406aad2$var$x,
        bgWhite: $673c037b2406aad2$var$x
    };
};
module.exports = $673c037b2406aad2$var$create();
module.exports.createColors = $673c037b2406aad2$var$create;

});

parcelRegister("jBKLa", function(module, exports) {
"use strict";

});


parcelRegister("kmNwY", function(module, exports) {
'use strict';

var $1SmAa = parcelRequire("1SmAa");
class $ed3c48804d118806$var$Declaration extends $1SmAa {
    constructor(defaults){
        if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = 'decl';
    }
    get variable() {
        return this.prop.startsWith('--') || this.prop[0] === '$';
    }
}
module.exports = $ed3c48804d118806$var$Declaration;
$ed3c48804d118806$var$Declaration.default = $ed3c48804d118806$var$Declaration;

});
parcelRegister("1SmAa", function(module, exports) {
'use strict';

var $ldpuD = parcelRequire("ldpuD");
var $15dc59fe4fd8d787$require$isClean = $ldpuD.isClean;
var $15dc59fe4fd8d787$require$my = $ldpuD.my;

var $52u6H = parcelRequire("52u6H");

var $7COgz = parcelRequire("7COgz");

var $ceQvC = parcelRequire("ceQvC");
function $15dc59fe4fd8d787$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        if (i === 'proxyCache') continue;
        let value = obj[i];
        let type = typeof value;
        if (i === 'parent' && type === 'object') {
            if (parent) cloned[i] = parent;
        } else if (i === 'source') cloned[i] = value;
        else if (Array.isArray(value)) cloned[i] = value.map((j)=>$15dc59fe4fd8d787$var$cloneNode(j, cloned));
        else {
            if (type === 'object' && value !== null) value = $15dc59fe4fd8d787$var$cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
class $15dc59fe4fd8d787$var$Node {
    constructor(defaults = {}){
        this.raws = {};
        this[$15dc59fe4fd8d787$require$isClean] = false;
        this[$15dc59fe4fd8d787$require$my] = true;
        for(let name in defaults)if (name === 'nodes') {
            this.nodes = [];
            for (let node of defaults[name])if (typeof node.clone === 'function') this.append(node.clone());
            else this.append(node);
        } else this[name] = defaults[name];
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $15dc59fe4fd8d787$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $52u6H(message);
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === 'proxyOf') return node;
                else if (prop === 'root') return ()=>node.root().toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === 'prop' || prop === 'value' || prop === 'name' || prop === 'params' || prop === 'important' || /* c8 ignore next */ prop === 'text') node.markDirty();
                return true;
            }
        };
    }
    markDirty() {
        if (this[$15dc59fe4fd8d787$require$isClean]) {
            this[$15dc59fe4fd8d787$require$isClean] = false;
            let next = this;
            while(next = next.parent)next[$15dc59fe4fd8d787$require$isClean] = false;
        }
    }
    next() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) pos = this.positionInside(index, stringRepresentation);
        }
        return pos;
    }
    positionInside(index, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i = 0; i < index; i++)if (string[i] === '\n') {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    }
    prev() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) {
                start = this.positionInside(index, stringRepresentation);
                end = this.positionInside(index + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (opts.endIndex) end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $7COgz();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node of nodes){
                if (node === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node);
                    bookmark = node;
                } else this.parent.insertBefore(bookmark, node);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result = this;
        while(result.parent && result.parent.type !== 'document')result = result.parent;
        return result;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === 'parent' || name === 'proxyCache') continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i)=>{
                if (typeof i === 'object' && i.toJSON) return i.toJSON(null, inputs);
                else return i;
            });
            else if (typeof value === 'object' && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === 'source') {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input)=>input.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier = $ceQvC) {
        if (stringifier.stringify) stringifier = stringifier.stringify;
        let result = '';
        stringifier(this, (i)=>{
            result += i;
        });
        return result;
    }
    warn(result, text, opts) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
}
module.exports = $15dc59fe4fd8d787$var$Node;
$15dc59fe4fd8d787$var$Node.default = $15dc59fe4fd8d787$var$Node;

});
parcelRegister("ldpuD", function(module, exports) {
$parcel$export(module.exports, "isClean", function () { return $f71e964b34236427$export$ae5e7911ce0728f9; }, function (v) { return $f71e964b34236427$export$ae5e7911ce0728f9 = v; });
$parcel$export(module.exports, "my", function () { return $f71e964b34236427$export$94fa0a6beb22f989; }, function (v) { return $f71e964b34236427$export$94fa0a6beb22f989 = v; });
var $f71e964b34236427$export$ae5e7911ce0728f9;
var $f71e964b34236427$export$94fa0a6beb22f989;
'use strict';
$f71e964b34236427$export$ae5e7911ce0728f9 = Symbol('isClean');
$f71e964b34236427$export$94fa0a6beb22f989 = Symbol('my');

});

parcelRegister("7COgz", function(module, exports) {
'use strict';
const $58d312d4880ee59d$var$DEFAULT_RAW = {
    after: '\n',
    beforeClose: '\n',
    beforeComment: '\n',
    beforeDecl: '\n',
    beforeOpen: ' ',
    beforeRule: '\n',
    colon: ': ',
    commentLeft: ' ',
    commentRight: ' ',
    emptyBody: '',
    indent: '    ',
    semicolon: false
};
function $58d312d4880ee59d$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
class $58d312d4880ee59d$var$Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node, semicolon) {
        let name = '@' + node.name;
        let params = node.params ? this.rawValue(node, 'params') : '';
        if (typeof node.raws.afterName !== 'undefined') name += node.raws.afterName;
        else if (params) name += ' ';
        if (node.nodes) this.block(node, name + params);
        else {
            let end = (node.raws.between || '') + (semicolon ? ';' : '');
            this.builder(name + params + end, node);
        }
    }
    beforeAfter(node, detect) {
        let value;
        if (node.type === 'decl') value = this.raw(node, null, 'beforeDecl');
        else if (node.type === 'comment') value = this.raw(node, null, 'beforeComment');
        else if (detect === 'before') value = this.raw(node, null, 'beforeRule');
        else value = this.raw(node, null, 'beforeClose');
        let buf = node.parent;
        let depth = 0;
        while(buf && buf.type !== 'root'){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes('\n')) {
            let indent = this.raw(node, null, 'indent');
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node, start) {
        let between = this.raw(node, 'between', 'beforeOpen');
        this.builder(start + between + '{', node, 'start');
        let after;
        if (node.nodes && node.nodes.length) {
            this.body(node);
            after = this.raw(node, 'after');
        } else after = this.raw(node, 'after', 'emptyBody');
        if (after) this.builder(after);
        this.builder('}', node, 'end');
    }
    body(node) {
        let last = node.nodes.length - 1;
        while(last > 0){
            if (node.nodes[last].type !== 'comment') break;
            last -= 1;
        }
        let semicolon = this.raw(node, 'semicolon');
        for(let i = 0; i < node.nodes.length; i++){
            let child = node.nodes[i];
            let before = this.raw(child, 'before');
            if (before) this.builder(before);
            this.stringify(child, last !== i || semicolon);
        }
    }
    comment(node) {
        let left = this.raw(node, 'left', 'commentLeft');
        let right = this.raw(node, 'right', 'commentRight');
        this.builder('/*' + left + node.text + right + '*/', node);
    }
    decl(node, semicolon) {
        let between = this.raw(node, 'between', 'colon');
        let string = node.prop + between + this.rawValue(node, 'value');
        if (node.important) string += node.raws.important || ' !important';
        if (semicolon) string += ';';
        this.builder(string, node);
    }
    document(node) {
        this.body(node);
    }
    raw(node, own, detect) {
        let value;
        if (!detect) detect = own;
        // Already had
        if (own) {
            value = node.raws[own];
            if (typeof value !== 'undefined') return value;
        }
        let parent = node.parent;
        if (detect === 'before') {
            // Hack for first rule in CSS
            if (!parent || parent.type === 'root' && parent.first === node) return '';
            // `root` nodes in `document` should use only their own raws
            if (parent && parent.type === 'document') return '';
        }
        // Floating child without parent
        if (!parent) return $58d312d4880ee59d$var$DEFAULT_RAW[detect];
        // Detect style by other nodes
        let root = node.root();
        if (!root.rawCache) root.rawCache = {};
        if (typeof root.rawCache[detect] !== 'undefined') return root.rawCache[detect];
        if (detect === 'before' || detect === 'after') return this.beforeAfter(node, detect);
        else {
            let method = 'raw' + $58d312d4880ee59d$var$capitalize(detect);
            if (this[method]) value = this[method](root, node);
            else root.walk((i)=>{
                value = i.raws[own];
                if (typeof value !== 'undefined') return false;
            });
        }
        if (typeof value === 'undefined') value = $58d312d4880ee59d$var$DEFAULT_RAW[detect];
        root.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== 'undefined') {
                    value = i.raws.after;
                    if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeComment(root, node) {
        let value;
        root.walkComments((i)=>{
            if (typeof i.raws.before !== 'undefined') {
                value = i.raws.before;
                if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                return false;
            }
        });
        if (typeof value === 'undefined') value = this.raw(node, null, 'beforeDecl');
        else if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeDecl(root, node) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.before !== 'undefined') {
                value = i.raws.before;
                if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                return false;
            }
        });
        if (typeof value === 'undefined') value = this.raw(node, null, 'beforeRule');
        else if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeOpen(root) {
        let value;
        root.walk((i)=>{
            if (i.type !== 'decl') {
                value = i.raws.between;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawBeforeRule(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && (i.parent !== root || root.first !== i)) {
                if (typeof i.raws.before !== 'undefined') {
                    value = i.raws.before;
                    if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawColon(root) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.between !== 'undefined') {
                value = i.raws.between.replace(/[^\s:]/g, '');
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawIndent(root) {
        if (root.raws.indent) return root.raws.indent;
        let value;
        root.walk((i)=>{
            let p = i.parent;
            if (p && p !== root && p.parent && p.parent === root) {
                if (typeof i.raws.before !== 'undefined') {
                    let parts = i.raws.before.split('\n');
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, '');
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === 'decl') {
                value = i.raws.semicolon;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawValue(node, prop) {
        let value = node[prop];
        let raw = node.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node) {
        this.body(node);
        if (node.raws.after) this.builder(node.raws.after);
    }
    rule(node) {
        this.block(node, this.rawValue(node, 'selector'));
        if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, 'end');
    }
    stringify(node, semicolon) {
        /* c8 ignore start */ if (!this[node.type]) throw new Error('Unknown AST node type ' + node.type + '. ' + 'Maybe you need to change PostCSS stringifier.');
        /* c8 ignore stop */ this[node.type](node, semicolon);
    }
}
module.exports = $58d312d4880ee59d$var$Stringifier;
$58d312d4880ee59d$var$Stringifier.default = $58d312d4880ee59d$var$Stringifier;

});

parcelRegister("ceQvC", function(module, exports) {
'use strict';

var $7COgz = parcelRequire("7COgz");
function $8e8f860689b4f2dd$var$stringify(node, builder) {
    let str = new $7COgz(builder);
    str.stringify(node);
}
module.exports = $8e8f860689b4f2dd$var$stringify;
$8e8f860689b4f2dd$var$stringify.default = $8e8f860689b4f2dd$var$stringify;

});



parcelRegister("etTkx", function(module, exports) {
'use strict';

var $ldpuD = parcelRequire("ldpuD");
var $a8aeb19260ae2639$require$isClean = $ldpuD.isClean;
var $a8aeb19260ae2639$require$my = $ldpuD.my;

var $cKWXg = parcelRequire("cKWXg");

var $ceQvC = parcelRequire("ceQvC");

var $kn5GT = parcelRequire("kn5GT");

var $37fY5 = parcelRequire("37fY5");
parcelRequire("bpKNc");

var $gFMnm = parcelRequire("gFMnm");

var $3xfLS = parcelRequire("3xfLS");

var $cDOWD = parcelRequire("cDOWD");
const $a8aeb19260ae2639$var$TYPE_TO_CLASS_NAME = {
    atrule: 'AtRule',
    comment: 'Comment',
    decl: 'Declaration',
    document: 'Document',
    root: 'Root',
    rule: 'Rule'
};
const $a8aeb19260ae2639$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $a8aeb19260ae2639$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $a8aeb19260ae2639$var$CHILDREN = 0;
function $a8aeb19260ae2639$var$isPromise(obj) {
    return typeof obj === 'object' && typeof obj.then === 'function';
}
function $a8aeb19260ae2639$var$getEvents(node) {
    let key = false;
    let type = $a8aeb19260ae2639$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === 'decl') key = node.prop.toLowerCase();
    else if (node.type === 'atrule') key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + '-' + key,
        $a8aeb19260ae2639$var$CHILDREN,
        type + 'Exit',
        type + 'Exit-' + key
    ];
    else if (key) return [
        type,
        type + '-' + key,
        type + 'Exit',
        type + 'Exit-' + key
    ];
    else if (node.append) return [
        type,
        $a8aeb19260ae2639$var$CHILDREN,
        type + 'Exit'
    ];
    else return [
        type,
        type + 'Exit'
    ];
}
function $a8aeb19260ae2639$var$toStack(node) {
    let events;
    if (node.type === 'document') events = [
        'Document',
        $a8aeb19260ae2639$var$CHILDREN,
        'DocumentExit'
    ];
    else if (node.type === 'root') events = [
        'Root',
        $a8aeb19260ae2639$var$CHILDREN,
        'RootExit'
    ];
    else events = $a8aeb19260ae2639$var$getEvents(node);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node,
        visitorIndex: 0,
        visitors: []
    };
}
function $a8aeb19260ae2639$var$cleanMarks(node) {
    node[$a8aeb19260ae2639$require$isClean] = false;
    if (node.nodes) node.nodes.forEach((i)=>$a8aeb19260ae2639$var$cleanMarks(i));
    return node;
}
let $a8aeb19260ae2639$var$postcss = {};
class $a8aeb19260ae2639$var$LazyResult {
    constructor(processor, css, opts){
        this.stringified = false;
        this.processed = false;
        let root;
        if (typeof css === 'object' && css !== null && (css.type === 'root' || css.type === 'document')) root = $a8aeb19260ae2639$var$cleanMarks(css);
        else if (css instanceof $a8aeb19260ae2639$var$LazyResult || css instanceof $gFMnm) {
            root = $a8aeb19260ae2639$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === 'undefined') opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser = $3xfLS;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$a8aeb19260ae2639$require$my]) /* c8 ignore next 2 */ $kn5GT.rebuild(root);
        }
        this.result = new $gFMnm(processor, root, opts);
        this.helpers = {
            ...$a8aeb19260ae2639$var$postcss,
            postcss: $a8aeb19260ae2639$var$postcss,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin)=>{
            if (typeof plugin === 'object' && plugin.prepare) return {
                ...plugin,
                ...plugin.prepare(this.result)
            };
            else return plugin;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error('Use process(css).then(cb) to work with async plugins');
    }
    handleError(error, node) {
        let plugin = this.result.lastPlugin;
        try {
            if (node) node.addToError(error);
            this.error = error;
            if (error.name === 'CssSyntaxError' && !error.plugin) {
                error.plugin = plugin.postcssPlugin;
                error.setMessage();
            } else plugin.postcssVersion;
        } catch (err) {
            /* c8 ignore next 3 */ // eslint-disable-next-line no-console
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin,
                cb
            ]);
        };
        for (let plugin of this.plugins){
            if (typeof plugin === 'object') for(let event in plugin){
                if (!$a8aeb19260ae2639$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin.postcssPlugin}. ` + `Try to update PostCSS (${this.processor.version} now).`);
                if (!$a8aeb19260ae2639$var$NOT_VISITORS[event]) {
                    if (typeof plugin[event] === 'object') {
                        for(let filter in plugin[event])if (filter === '*') add(plugin, event, plugin[event][filter]);
                        else add(plugin, event + '-' + filter.toLowerCase(), plugin[event][filter]);
                    } else if (typeof plugin[event] === 'function') add(plugin, event, plugin[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i = 0; i < this.plugins.length; i++){
            let plugin = this.plugins[i];
            let promise = this.runOnRoot(plugin);
            if ($a8aeb19260ae2639$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$a8aeb19260ae2639$require$isClean]){
                root[$a8aeb19260ae2639$require$isClean] = true;
                let stack = [
                    $a8aeb19260ae2639$var$toStack(root)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($a8aeb19260ae2639$var$isPromise(promise)) try {
                        await promise;
                    } catch (e) {
                        let node = stack[stack.length - 1].node;
                        throw this.handleError(e, node);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin;
                try {
                    if (root.type === 'document') {
                        let roots = root.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root, this.helpers);
                } catch (e) {
                    throw this.handleError(e);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin) {
        this.result.lastPlugin = plugin;
        try {
            if (typeof plugin === 'object' && plugin.Once) {
                if (this.result.root.type === 'document') {
                    let roots = this.result.root.nodes.map((root)=>plugin.Once(root, this.helpers));
                    if ($a8aeb19260ae2639$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin.Once(this.result.root, this.helpers);
            } else if (typeof plugin === 'function') return plugin(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $ceQvC;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $cKWXg(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin of this.plugins){
            let promise = this.runOnRoot(plugin);
            if ($a8aeb19260ae2639$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$a8aeb19260ae2639$require$isClean]){
                root[$a8aeb19260ae2639$require$isClean] = true;
                this.walkSync(root);
            }
            if (this.listeners.OnceExit) {
                if (root.type === 'document') for (let subRoot of root.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node) {
        for (let [plugin, visitor] of visitors){
            this.result.lastPlugin = plugin;
            let promise;
            try {
                promise = visitor(node, this.helpers);
            } catch (e) {
                throw this.handleError(e, node.proxyOf);
            }
            if (node.type !== 'root' && node.type !== 'document' && !node.parent) return true;
            if ($a8aeb19260ae2639$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit = stack[stack.length - 1];
        let { node: node, visitors: visitors } = visit;
        if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
            let [plugin, visitor] = visitors[visit.visitorIndex];
            visit.visitorIndex += 1;
            if (visit.visitorIndex === visitors.length) {
                visit.visitors = [];
                visit.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin;
            try {
                return visitor(node.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node);
            }
        }
        if (visit.iterator !== 0) {
            let iterator = visit.iterator;
            let child;
            while(child = node.nodes[node.indexes[iterator]]){
                node.indexes[iterator] += 1;
                if (!child[$a8aeb19260ae2639$require$isClean]) {
                    child[$a8aeb19260ae2639$require$isClean] = true;
                    stack.push($a8aeb19260ae2639$var$toStack(child));
                    return;
                }
            }
            visit.iterator = 0;
            delete node.indexes[iterator];
        }
        let events = visit.events;
        while(visit.eventIndex < events.length){
            let event = events[visit.eventIndex];
            visit.eventIndex += 1;
            if (event === $a8aeb19260ae2639$var$CHILDREN) {
                if (node.nodes && node.nodes.length) {
                    node[$a8aeb19260ae2639$require$isClean] = true;
                    visit.iterator = node.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node) {
        node[$a8aeb19260ae2639$require$isClean] = true;
        let events = $a8aeb19260ae2639$var$getEvents(node);
        for (let event of events){
            if (event === $a8aeb19260ae2639$var$CHILDREN) {
                if (node.nodes) node.each((child)=>{
                    if (!child[$a8aeb19260ae2639$require$isClean]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return 'LazyResult';
    }
}
$a8aeb19260ae2639$var$LazyResult.registerPostcss = (dependant)=>{
    $a8aeb19260ae2639$var$postcss = dependant;
};
module.exports = $a8aeb19260ae2639$var$LazyResult;
$a8aeb19260ae2639$var$LazyResult.default = $a8aeb19260ae2639$var$LazyResult;
$cDOWD.registerLazyResult($a8aeb19260ae2639$var$LazyResult);
$37fY5.registerLazyResult($a8aeb19260ae2639$var$LazyResult);

});
parcelRegister("cKWXg", function(module, exports) {

var $567QU = parcelRequire("567QU");
var $94978323e6d8e40a$require$Buffer = $567QU.Buffer;
'use strict';

var $jBKLa = parcelRequire("jBKLa");
var $94978323e6d8e40a$require$SourceMapConsumer = $jBKLa.SourceMapConsumer;
var $94978323e6d8e40a$require$SourceMapGenerator = $jBKLa.SourceMapGenerator;

var $jBKLa = parcelRequire("jBKLa");
var $94978323e6d8e40a$require$dirname = $jBKLa.dirname;
var $94978323e6d8e40a$require$relative = $jBKLa.relative;
var $94978323e6d8e40a$require$resolve = $jBKLa.resolve;
var $94978323e6d8e40a$require$sep = $jBKLa.sep;

var $jBKLa = parcelRequire("jBKLa");
var $94978323e6d8e40a$require$pathToFileURL = $jBKLa.pathToFileURL;

var $kwhQ7 = parcelRequire("kwhQ7");
let $94978323e6d8e40a$var$sourceMapAvailable = Boolean($94978323e6d8e40a$require$SourceMapConsumer && $94978323e6d8e40a$require$SourceMapGenerator);
let $94978323e6d8e40a$var$pathAvailable = Boolean($94978323e6d8e40a$require$dirname && $94978323e6d8e40a$require$resolve && $94978323e6d8e40a$require$relative && $94978323e6d8e40a$require$sep);
class $94978323e6d8e40a$var$MapGenerator {
    constructor(stringify, root, opts, cssString){
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = new Map();
        this.memoizedPaths = new Map();
        this.memoizedURLs = new Map();
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = 'data:application/json;base64,' + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === 'string') content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === 'function') content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + '.map';
        let eol = '\n';
        if (this.css.includes('\r\n')) eol = '\r\n';
        this.css += eol + '/*# sourceMappingURL=' + content + ' */';
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root = prev.root || $94978323e6d8e40a$require$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $94978323e6d8e40a$require$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = map.sourcesContent.map(()=>null);
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node = this.root.nodes[i];
                if (node.type !== 'comment') continue;
                if (node.text.indexOf('# sourceMappingURL=') === 0) this.root.removeChild(i);
            }
        } else if (this.css) this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, '');
    }
    generate() {
        this.clearAnnotation();
        if ($94978323e6d8e40a$var$pathAvailable && $94978323e6d8e40a$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result = '';
            this.stringify(this.root, (i)=>{
                result += i;
            });
            return [
                result
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $94978323e6d8e40a$require$SourceMapGenerator.fromSourceMap(prev);
        } else {
            this.map = new $94978323e6d8e40a$require$SourceMapGenerator({
                file: this.outputFile()
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>'
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = '';
        this.map = new $94978323e6d8e40a$require$SourceMapGenerator({
            file: this.outputFile()
        });
        let line = 1;
        let column = 1;
        let noSource = '<no source>';
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ''
        };
        let lines, last;
        this.stringify(this.root, (str, node, type)=>{
            this.css += str;
            if (node && type !== 'end') {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node.source && node.source.start) {
                    mapping.source = this.sourcePath(node);
                    mapping.original.line = node.source.start.line;
                    mapping.original.column = node.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf('\n');
                column = str.length - last;
            } else column += str.length;
            if (node && type !== 'start') {
                let p = node.parent || {
                    raws: {}
                };
                let childless = node.type === 'decl' || node.type === 'atrule' && !node.nodes;
                if (!childless || node !== p.last || p.raws.semicolon) {
                    if (node.source && node.source.end) {
                        mapping.source = this.sourcePath(node);
                        mapping.original.line = node.source.end.line;
                        mapping.original.column = node.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== 'undefined') return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i)=>i.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== 'undefined') return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== 'undefined' && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i)=>i.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== 'undefined') return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== 'undefined') return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i)=>i.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return 'to.css';
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60 /* `<` */ ) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? $94978323e6d8e40a$require$dirname(this.opts.to) : '.';
        if (typeof this.mapOpts.annotation === 'string') from = $94978323e6d8e40a$require$dirname($94978323e6d8e40a$require$resolve(from, this.mapOpts.annotation));
        let path = $94978323e6d8e40a$require$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node)=>{
                if (node.source && node.source.input.map) {
                    let map = node.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input = new $kwhQ7(this.css, this.opts);
                if (input.map) this.previousMaps.push(input.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node)=>{
            if (node.source) {
                let from = node.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>';
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
        else return this.toUrl(this.path(node.source.input.from));
    }
    toBase64(str) {
        if ($94978323e6d8e40a$require$Buffer) return $94978323e6d8e40a$require$Buffer.from(str).toString('base64');
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($94978323e6d8e40a$require$pathToFileURL) {
            let fileURL = $94978323e6d8e40a$require$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error('`map.absolute` option is not available in this PostCSS build');
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($94978323e6d8e40a$require$sep === '\\') path = path.replace(/\\/g, '/');
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
}
module.exports = $94978323e6d8e40a$var$MapGenerator;

});
parcelRegister("567QU", function(module, exports) {
$parcel$export(module.exports, "Buffer", function () { return $3b639a98fe48d616$export$a143d493d941bafc; }, function (v) { return $3b639a98fe48d616$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $3b639a98fe48d616$export$e4cf37d7f6fb9e0a; }, function (v) { return $3b639a98fe48d616$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $3b639a98fe48d616$export$f99ded8fe4b79145; }, function (v) { return $3b639a98fe48d616$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $3b639a98fe48d616$export$599f31c3813fae4d; }, function (v) { return $3b639a98fe48d616$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3b639a98fe48d616$export$a143d493d941bafc;
var $3b639a98fe48d616$export$e4cf37d7f6fb9e0a;
var $3b639a98fe48d616$export$f99ded8fe4b79145;
var $3b639a98fe48d616$export$599f31c3813fae4d;
'use strict';

var $eKcWJ = parcelRequire("eKcWJ");

var $auzN2 = parcelRequire("auzN2");
const $3b639a98fe48d616$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3b639a98fe48d616$export$a143d493d941bafc = $3b639a98fe48d616$var$Buffer;
$3b639a98fe48d616$export$e4cf37d7f6fb9e0a = $3b639a98fe48d616$var$SlowBuffer;
$3b639a98fe48d616$export$f99ded8fe4b79145 = 50;
const $3b639a98fe48d616$var$K_MAX_LENGTH = 0x7fffffff;
$3b639a98fe48d616$export$599f31c3813fae4d = $3b639a98fe48d616$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3b639a98fe48d616$var$Buffer.TYPED_ARRAY_SUPPORT = $3b639a98fe48d616$var$typedArraySupport();
if (!$3b639a98fe48d616$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3b639a98fe48d616$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3b639a98fe48d616$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$3b639a98fe48d616$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3b639a98fe48d616$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$3b639a98fe48d616$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3b639a98fe48d616$var$createBuffer(length) {
    if (length > $3b639a98fe48d616$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3b639a98fe48d616$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3b639a98fe48d616$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3b639a98fe48d616$var$allocUnsafe(arg);
    }
    return $3b639a98fe48d616$var$from(arg, encodingOrOffset, length);
}
$3b639a98fe48d616$var$Buffer.poolSize = 8192; // not used by this implementation
function $3b639a98fe48d616$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3b639a98fe48d616$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3b639a98fe48d616$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3b639a98fe48d616$var$isInstance(value, ArrayBuffer) || value && $3b639a98fe48d616$var$isInstance(value.buffer, ArrayBuffer)) return $3b639a98fe48d616$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3b639a98fe48d616$var$isInstance(value, SharedArrayBuffer) || value && $3b639a98fe48d616$var$isInstance(value.buffer, SharedArrayBuffer))) return $3b639a98fe48d616$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3b639a98fe48d616$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3b639a98fe48d616$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3b639a98fe48d616$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3b639a98fe48d616$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3b639a98fe48d616$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3b639a98fe48d616$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3b639a98fe48d616$var$Buffer, Uint8Array);
function $3b639a98fe48d616$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3b639a98fe48d616$var$alloc(size, fill, encoding) {
    $3b639a98fe48d616$var$assertSize(size);
    if (size <= 0) return $3b639a98fe48d616$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3b639a98fe48d616$var$createBuffer(size).fill(fill, encoding) : $3b639a98fe48d616$var$createBuffer(size).fill(fill);
    return $3b639a98fe48d616$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3b639a98fe48d616$var$Buffer.alloc = function(size, fill, encoding) {
    return $3b639a98fe48d616$var$alloc(size, fill, encoding);
};
function $3b639a98fe48d616$var$allocUnsafe(size) {
    $3b639a98fe48d616$var$assertSize(size);
    return $3b639a98fe48d616$var$createBuffer(size < 0 ? 0 : $3b639a98fe48d616$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3b639a98fe48d616$var$Buffer.allocUnsafe = function(size) {
    return $3b639a98fe48d616$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3b639a98fe48d616$var$Buffer.allocUnsafeSlow = function(size) {
    return $3b639a98fe48d616$var$allocUnsafe(size);
};
function $3b639a98fe48d616$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3b639a98fe48d616$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $3b639a98fe48d616$var$byteLength(string, encoding) | 0;
    let buf = $3b639a98fe48d616$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3b639a98fe48d616$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3b639a98fe48d616$var$checked(array.length) | 0;
    const buf = $3b639a98fe48d616$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3b639a98fe48d616$var$fromArrayView(arrayView) {
    if ($3b639a98fe48d616$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3b639a98fe48d616$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3b639a98fe48d616$var$fromArrayLike(arrayView);
}
function $3b639a98fe48d616$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3b639a98fe48d616$var$Buffer.prototype);
    return buf;
}
function $3b639a98fe48d616$var$fromObject(obj) {
    if ($3b639a98fe48d616$var$Buffer.isBuffer(obj)) {
        const len = $3b639a98fe48d616$var$checked(obj.length) | 0;
        const buf = $3b639a98fe48d616$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3b639a98fe48d616$var$numberIsNaN(obj.length)) return $3b639a98fe48d616$var$createBuffer(0);
        return $3b639a98fe48d616$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3b639a98fe48d616$var$fromArrayLike(obj.data);
}
function $3b639a98fe48d616$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3b639a98fe48d616$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3b639a98fe48d616$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3b639a98fe48d616$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3b639a98fe48d616$var$Buffer.alloc(+length);
}
$3b639a98fe48d616$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3b639a98fe48d616$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3b639a98fe48d616$var$Buffer.compare = function compare(a, b) {
    if ($3b639a98fe48d616$var$isInstance(a, Uint8Array)) a = $3b639a98fe48d616$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3b639a98fe48d616$var$isInstance(b, Uint8Array)) b = $3b639a98fe48d616$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3b639a98fe48d616$var$Buffer.isBuffer(a) || !$3b639a98fe48d616$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3b639a98fe48d616$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3b639a98fe48d616$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3b639a98fe48d616$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3b639a98fe48d616$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3b639a98fe48d616$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3b639a98fe48d616$var$Buffer.isBuffer(buf)) buf = $3b639a98fe48d616$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3b639a98fe48d616$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3b639a98fe48d616$var$byteLength(string, encoding) {
    if ($3b639a98fe48d616$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3b639a98fe48d616$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3b639a98fe48d616$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3b639a98fe48d616$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3b639a98fe48d616$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3b639a98fe48d616$var$Buffer.byteLength = $3b639a98fe48d616$var$byteLength;
function $3b639a98fe48d616$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3b639a98fe48d616$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3b639a98fe48d616$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3b639a98fe48d616$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3b639a98fe48d616$var$latin1Slice(this, start, end);
        case 'base64':
            return $3b639a98fe48d616$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3b639a98fe48d616$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3b639a98fe48d616$var$Buffer.prototype._isBuffer = true;
function $3b639a98fe48d616$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3b639a98fe48d616$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$3b639a98fe48d616$var$swap(this, i, i + 1);
    return this;
};
$3b639a98fe48d616$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $3b639a98fe48d616$var$swap(this, i, i + 3);
        $3b639a98fe48d616$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3b639a98fe48d616$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $3b639a98fe48d616$var$swap(this, i, i + 7);
        $3b639a98fe48d616$var$swap(this, i + 1, i + 6);
        $3b639a98fe48d616$var$swap(this, i + 2, i + 5);
        $3b639a98fe48d616$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3b639a98fe48d616$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3b639a98fe48d616$var$utf8Slice(this, 0, length);
    return $3b639a98fe48d616$var$slowToString.apply(this, arguments);
};
$3b639a98fe48d616$var$Buffer.prototype.toLocaleString = $3b639a98fe48d616$var$Buffer.prototype.toString;
$3b639a98fe48d616$var$Buffer.prototype.equals = function equals(b) {
    if (!$3b639a98fe48d616$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3b639a98fe48d616$var$Buffer.compare(this, b) === 0;
};
$3b639a98fe48d616$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $3b639a98fe48d616$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3b639a98fe48d616$var$customInspectSymbol) $3b639a98fe48d616$var$Buffer.prototype[$3b639a98fe48d616$var$customInspectSymbol] = $3b639a98fe48d616$var$Buffer.prototype.inspect;
$3b639a98fe48d616$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3b639a98fe48d616$var$isInstance(target, Uint8Array)) target = $3b639a98fe48d616$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3b639a98fe48d616$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3b639a98fe48d616$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if ($3b639a98fe48d616$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3b639a98fe48d616$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3b639a98fe48d616$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3b639a98fe48d616$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3b639a98fe48d616$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3b639a98fe48d616$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3b639a98fe48d616$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3b639a98fe48d616$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3b639a98fe48d616$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3b639a98fe48d616$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3b639a98fe48d616$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3b639a98fe48d616$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3b639a98fe48d616$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3b639a98fe48d616$var$utf8Write(buf, string, offset, length) {
    return $3b639a98fe48d616$var$blitBuffer($3b639a98fe48d616$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3b639a98fe48d616$var$asciiWrite(buf, string, offset, length) {
    return $3b639a98fe48d616$var$blitBuffer($3b639a98fe48d616$var$asciiToBytes(string), buf, offset, length);
}
function $3b639a98fe48d616$var$base64Write(buf, string, offset, length) {
    return $3b639a98fe48d616$var$blitBuffer($3b639a98fe48d616$var$base64ToBytes(string), buf, offset, length);
}
function $3b639a98fe48d616$var$ucs2Write(buf, string, offset, length) {
    return $3b639a98fe48d616$var$blitBuffer($3b639a98fe48d616$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3b639a98fe48d616$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3b639a98fe48d616$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3b639a98fe48d616$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3b639a98fe48d616$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3b639a98fe48d616$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3b639a98fe48d616$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3b639a98fe48d616$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3b639a98fe48d616$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eKcWJ.fromByteArray(buf);
    else return $eKcWJ.fromByteArray(buf.slice(start, end));
}
function $3b639a98fe48d616$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3b639a98fe48d616$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3b639a98fe48d616$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3b639a98fe48d616$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3b639a98fe48d616$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3b639a98fe48d616$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3b639a98fe48d616$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3b639a98fe48d616$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3b639a98fe48d616$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $3b639a98fe48d616$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3b639a98fe48d616$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3b639a98fe48d616$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3b639a98fe48d616$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3b639a98fe48d616$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3b639a98fe48d616$var$Buffer.prototype.readUintLE = $3b639a98fe48d616$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3b639a98fe48d616$var$Buffer.prototype.readUintBE = $3b639a98fe48d616$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3b639a98fe48d616$var$Buffer.prototype.readUint8 = $3b639a98fe48d616$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3b639a98fe48d616$var$Buffer.prototype.readUint16LE = $3b639a98fe48d616$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3b639a98fe48d616$var$Buffer.prototype.readUint16BE = $3b639a98fe48d616$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3b639a98fe48d616$var$Buffer.prototype.readUint32LE = $3b639a98fe48d616$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3b639a98fe48d616$var$Buffer.prototype.readUint32BE = $3b639a98fe48d616$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3b639a98fe48d616$var$Buffer.prototype.readBigUInt64LE = $3b639a98fe48d616$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3b639a98fe48d616$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3b639a98fe48d616$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3b639a98fe48d616$var$Buffer.prototype.readBigUInt64BE = $3b639a98fe48d616$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3b639a98fe48d616$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3b639a98fe48d616$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3b639a98fe48d616$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3b639a98fe48d616$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3b639a98fe48d616$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3b639a98fe48d616$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3b639a98fe48d616$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3b639a98fe48d616$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3b639a98fe48d616$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3b639a98fe48d616$var$Buffer.prototype.readBigInt64LE = $3b639a98fe48d616$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3b639a98fe48d616$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3b639a98fe48d616$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3b639a98fe48d616$var$Buffer.prototype.readBigInt64BE = $3b639a98fe48d616$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3b639a98fe48d616$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3b639a98fe48d616$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3b639a98fe48d616$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 4, this.length);
    return $auzN2.read(this, offset, true, 23, 4);
};
$3b639a98fe48d616$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 4, this.length);
    return $auzN2.read(this, offset, false, 23, 4);
};
$3b639a98fe48d616$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 8, this.length);
    return $auzN2.read(this, offset, true, 52, 8);
};
$3b639a98fe48d616$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkOffset(offset, 8, this.length);
    return $auzN2.read(this, offset, false, 52, 8);
};
function $3b639a98fe48d616$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3b639a98fe48d616$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3b639a98fe48d616$var$Buffer.prototype.writeUintLE = $3b639a98fe48d616$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3b639a98fe48d616$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3b639a98fe48d616$var$Buffer.prototype.writeUintBE = $3b639a98fe48d616$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3b639a98fe48d616$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3b639a98fe48d616$var$Buffer.prototype.writeUint8 = $3b639a98fe48d616$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3b639a98fe48d616$var$Buffer.prototype.writeUint16LE = $3b639a98fe48d616$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3b639a98fe48d616$var$Buffer.prototype.writeUint16BE = $3b639a98fe48d616$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3b639a98fe48d616$var$Buffer.prototype.writeUint32LE = $3b639a98fe48d616$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3b639a98fe48d616$var$Buffer.prototype.writeUint32BE = $3b639a98fe48d616$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3b639a98fe48d616$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3b639a98fe48d616$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3b639a98fe48d616$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3b639a98fe48d616$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3b639a98fe48d616$var$Buffer.prototype.writeBigUInt64LE = $3b639a98fe48d616$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3b639a98fe48d616$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3b639a98fe48d616$var$Buffer.prototype.writeBigUInt64BE = $3b639a98fe48d616$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3b639a98fe48d616$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3b639a98fe48d616$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3b639a98fe48d616$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3b639a98fe48d616$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3b639a98fe48d616$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3b639a98fe48d616$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3b639a98fe48d616$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3b639a98fe48d616$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3b639a98fe48d616$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3b639a98fe48d616$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3b639a98fe48d616$var$Buffer.prototype.writeBigInt64LE = $3b639a98fe48d616$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3b639a98fe48d616$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3b639a98fe48d616$var$Buffer.prototype.writeBigInt64BE = $3b639a98fe48d616$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3b639a98fe48d616$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3b639a98fe48d616$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3b639a98fe48d616$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    $auzN2.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3b639a98fe48d616$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3b639a98fe48d616$var$writeFloat(this, value, offset, true, noAssert);
};
$3b639a98fe48d616$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3b639a98fe48d616$var$writeFloat(this, value, offset, false, noAssert);
};
function $3b639a98fe48d616$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3b639a98fe48d616$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    $auzN2.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3b639a98fe48d616$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3b639a98fe48d616$var$writeDouble(this, value, offset, true, noAssert);
};
$3b639a98fe48d616$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3b639a98fe48d616$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3b639a98fe48d616$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3b639a98fe48d616$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3b639a98fe48d616$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3b639a98fe48d616$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3b639a98fe48d616$var$Buffer.isBuffer(val) ? val : $3b639a98fe48d616$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3b639a98fe48d616$var$errors = {};
function $3b639a98fe48d616$var$E(sym, getMessage, Base) {
    $3b639a98fe48d616$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack; // eslint-disable-line no-unused-expressions
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$3b639a98fe48d616$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3b639a98fe48d616$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3b639a98fe48d616$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3b639a98fe48d616$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3b639a98fe48d616$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3b639a98fe48d616$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3b639a98fe48d616$var$checkBounds(buf, offset, byteLength) {
    $3b639a98fe48d616$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3b639a98fe48d616$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3b639a98fe48d616$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3b639a98fe48d616$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3b639a98fe48d616$var$checkBounds(buf, offset, byteLength);
}
function $3b639a98fe48d616$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3b639a98fe48d616$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3b639a98fe48d616$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3b639a98fe48d616$var$validateNumber(value, type);
        throw new $3b639a98fe48d616$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3b639a98fe48d616$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3b639a98fe48d616$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3b639a98fe48d616$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3b639a98fe48d616$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3b639a98fe48d616$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3b639a98fe48d616$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3b639a98fe48d616$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3b639a98fe48d616$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3b639a98fe48d616$var$base64ToBytes(str) {
    return $eKcWJ.toByteArray($3b639a98fe48d616$var$base64clean(str));
}
function $3b639a98fe48d616$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3b639a98fe48d616$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3b639a98fe48d616$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3b639a98fe48d616$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3b639a98fe48d616$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3b639a98fe48d616$var$BufferBigIntNotDefined : fn;
}
function $3b639a98fe48d616$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("eKcWJ", function(module, exports) {
$parcel$export(module.exports, "toByteArray", function () { return $abbf676e8ca87b91$export$d622b2ad8d90c771; }, function (v) { return $abbf676e8ca87b91$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $abbf676e8ca87b91$export$6100ba28696e12de; }, function (v) { return $abbf676e8ca87b91$export$6100ba28696e12de = v; });
var $abbf676e8ca87b91$export$a48f0734ac7c2329;
var $abbf676e8ca87b91$export$d622b2ad8d90c771;
var $abbf676e8ca87b91$export$6100ba28696e12de;
'use strict';
$abbf676e8ca87b91$export$a48f0734ac7c2329 = $abbf676e8ca87b91$var$byteLength;
$abbf676e8ca87b91$export$d622b2ad8d90c771 = $abbf676e8ca87b91$var$toByteArray;
$abbf676e8ca87b91$export$6100ba28696e12de = $abbf676e8ca87b91$var$fromByteArray;
var $abbf676e8ca87b91$var$lookup = [];
var $abbf676e8ca87b91$var$revLookup = [];
var $abbf676e8ca87b91$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $abbf676e8ca87b91$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $abbf676e8ca87b91$var$i = 0, $abbf676e8ca87b91$var$len = $abbf676e8ca87b91$var$code.length; $abbf676e8ca87b91$var$i < $abbf676e8ca87b91$var$len; ++$abbf676e8ca87b91$var$i){
    $abbf676e8ca87b91$var$lookup[$abbf676e8ca87b91$var$i] = $abbf676e8ca87b91$var$code[$abbf676e8ca87b91$var$i];
    $abbf676e8ca87b91$var$revLookup[$abbf676e8ca87b91$var$code.charCodeAt($abbf676e8ca87b91$var$i)] = $abbf676e8ca87b91$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$abbf676e8ca87b91$var$revLookup['-'.charCodeAt(0)] = 62;
$abbf676e8ca87b91$var$revLookup['_'.charCodeAt(0)] = 63;
function $abbf676e8ca87b91$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $abbf676e8ca87b91$var$byteLength(b64) {
    var lens = $abbf676e8ca87b91$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $abbf676e8ca87b91$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $abbf676e8ca87b91$var$toByteArray(b64) {
    var tmp;
    var lens = $abbf676e8ca87b91$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $abbf676e8ca87b91$var$Arr($abbf676e8ca87b91$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i)] << 18 | $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i)] << 2 | $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i)] << 10 | $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $abbf676e8ca87b91$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $abbf676e8ca87b91$var$tripletToBase64(num) {
    return $abbf676e8ca87b91$var$lookup[num >> 18 & 0x3F] + $abbf676e8ca87b91$var$lookup[num >> 12 & 0x3F] + $abbf676e8ca87b91$var$lookup[num >> 6 & 0x3F] + $abbf676e8ca87b91$var$lookup[num & 0x3F];
}
function $abbf676e8ca87b91$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($abbf676e8ca87b91$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $abbf676e8ca87b91$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($abbf676e8ca87b91$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($abbf676e8ca87b91$var$lookup[tmp >> 2] + $abbf676e8ca87b91$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($abbf676e8ca87b91$var$lookup[tmp >> 10] + $abbf676e8ca87b91$var$lookup[tmp >> 4 & 0x3F] + $abbf676e8ca87b91$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("auzN2", function(module, exports) {
$parcel$export(module.exports, "read", function () { return $7a3877dd9be937f2$export$aafa59e2e03f2942; }, function (v) { return $7a3877dd9be937f2$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $7a3877dd9be937f2$export$68d8715fc104d294; }, function (v) { return $7a3877dd9be937f2$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7a3877dd9be937f2$export$aafa59e2e03f2942;
var $7a3877dd9be937f2$export$68d8715fc104d294;
$7a3877dd9be937f2$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7a3877dd9be937f2$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("kwhQ7", function(module, exports) {
'use strict';

var $jBKLa = parcelRequire("jBKLa");
var $ef04a263b9661b12$require$SourceMapConsumer = $jBKLa.SourceMapConsumer;
var $ef04a263b9661b12$require$SourceMapGenerator = $jBKLa.SourceMapGenerator;

var $jBKLa = parcelRequire("jBKLa");
var $ef04a263b9661b12$require$fileURLToPath = $jBKLa.fileURLToPath;
var $ef04a263b9661b12$require$pathToFileURL = $jBKLa.pathToFileURL;

var $jBKLa = parcelRequire("jBKLa");
var $ef04a263b9661b12$require$isAbsolute = $jBKLa.isAbsolute;
var $ef04a263b9661b12$require$resolve = $jBKLa.resolve;

var $eGZoR = parcelRequire("eGZoR");
var $ef04a263b9661b12$require$nanoid = $eGZoR.nanoid;

var $jBKLa = parcelRequire("jBKLa");

var $52u6H = parcelRequire("52u6H");

var $hTnj1 = parcelRequire("hTnj1");
let $ef04a263b9661b12$var$fromOffsetCache = Symbol('fromOffsetCache');
let $ef04a263b9661b12$var$sourceMapAvailable = Boolean($ef04a263b9661b12$require$SourceMapConsumer && $ef04a263b9661b12$require$SourceMapGenerator);
let $ef04a263b9661b12$var$pathAvailable = Boolean($ef04a263b9661b12$require$resolve && $ef04a263b9661b12$require$isAbsolute);
class $ef04a263b9661b12$var$Input {
    constructor(css, opts = {}){
        if (css === null || typeof css === 'undefined' || typeof css === 'object' && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$ef04a263b9661b12$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $ef04a263b9661b12$require$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $ef04a263b9661b12$require$resolve(opts.from);
        }
        if ($ef04a263b9661b12$var$pathAvailable && $ef04a263b9661b12$var$sourceMapAvailable) {
            let map = new $hTnj1(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = '<input css ' + $ef04a263b9661b12$require$nanoid(6) + '>';
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let result, endLine, endColumn;
        if (line && typeof line === 'object') {
            let start = line;
            let end = column;
            if (typeof start.offset === 'number') {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === 'number') {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result = new $52u6H(message, origin.endLine === undefined ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === undefined ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result = new $52u6H(message, endLine === undefined ? line : {
            column: column,
            line: line
        }, endLine === undefined ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($ef04a263b9661b12$require$pathToFileURL) result.input.url = $ef04a263b9661b12$require$pathToFileURL(this.file).toString();
            result.input.file = this.file;
        }
        return result;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$ef04a263b9661b12$var$fromOffsetCache]) {
            let lines = this.css.split('\n');
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i = 0, l = lines.length; i < l; i++){
                lineToIndex[i] = prevIndex;
                prevIndex += lines[i].length + 1;
            }
            this[$ef04a263b9661b12$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$ef04a263b9661b12$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $ef04a263b9661b12$require$resolve(this.map.consumer().sourceRoot || this.map.root || '.', file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === 'number') to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        let fromUrl;
        if ($ef04a263b9661b12$require$isAbsolute(from.source)) fromUrl = $ef04a263b9661b12$require$pathToFileURL(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $ef04a263b9661b12$require$pathToFileURL(this.map.mapFile));
        let result = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === 'file:') {
            if ($ef04a263b9661b12$require$fileURLToPath) result.file = $ef04a263b9661b12$require$fileURLToPath(fromUrl);
            else /* c8 ignore next 2 */ throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result.source = source;
        return result;
    }
    toJSON() {
        let json = {};
        for (let name of [
            'hasBOM',
            'css',
            'file',
            'id'
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = undefined;
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
}
module.exports = $ef04a263b9661b12$var$Input;
$ef04a263b9661b12$var$Input.default = $ef04a263b9661b12$var$Input;
if ($jBKLa && $jBKLa.registerInput) $jBKLa.registerInput($ef04a263b9661b12$var$Input);

});
parcelRegister("eGZoR", function(module, exports) {
let $ab249db18a4dd390$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $ab249db18a4dd390$var$customAlphabet = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $ab249db18a4dd390$var$nanoid = (size = 21)=>{
    let id = '';
    let i = size;
    while(i--)id += $ab249db18a4dd390$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
module.exports = {
    nanoid: $ab249db18a4dd390$var$nanoid,
    customAlphabet: $ab249db18a4dd390$var$customAlphabet
};

});

parcelRegister("hTnj1", function(module, exports) {

var $567QU = parcelRequire("567QU");
var $d069a6c2dccdddb9$require$Buffer = $567QU.Buffer;
'use strict';

var $jBKLa = parcelRequire("jBKLa");
var $d069a6c2dccdddb9$require$SourceMapConsumer = $jBKLa.SourceMapConsumer;
var $d069a6c2dccdddb9$require$SourceMapGenerator = $jBKLa.SourceMapGenerator;

var $jBKLa = parcelRequire("jBKLa");
var $d069a6c2dccdddb9$require$existsSync = $jBKLa.existsSync;
var $d069a6c2dccdddb9$require$readFileSync = $jBKLa.readFileSync;

var $jBKLa = parcelRequire("jBKLa");
var $d069a6c2dccdddb9$require$dirname = $jBKLa.dirname;
var $d069a6c2dccdddb9$require$join = $jBKLa.join;
function $d069a6c2dccdddb9$var$fromBase64(str) {
    if ($d069a6c2dccdddb9$require$Buffer) return $d069a6c2dccdddb9$require$Buffer.from(str, 'base64').toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
class $d069a6c2dccdddb9$var$PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, 'data:');
        let prev = opts.map ? opts.map.prev : undefined;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $d069a6c2dccdddb9$require$dirname(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $d069a6c2dccdddb9$require$SourceMapConsumer(this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $d069a6c2dccdddb9$var$fromBase64(text.substr(RegExp.lastMatch.length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error('Unsupported source map encoding ' + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim();
    }
    isMap(map) {
        if (typeof map !== 'object') return false;
        return typeof map.mappings === 'string' || typeof map._mappings === 'string' || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        // sourceMappingURLs from comments, strings, etc.
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf('*/', start);
        if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
        this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path) {
        this.root = $d069a6c2dccdddb9$require$dirname(path);
        if ($d069a6c2dccdddb9$require$existsSync(path)) {
            this.mapFile = path;
            return $d069a6c2dccdddb9$require$readFileSync(path, 'utf-8').toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === 'string') return prev;
            else if (typeof prev === 'function') {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error('Unable to load previous source map: ' + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $d069a6c2dccdddb9$require$SourceMapConsumer) return $d069a6c2dccdddb9$require$SourceMapGenerator.fromSourceMap(prev).toString();
            else if (prev instanceof $d069a6c2dccdddb9$require$SourceMapGenerator) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error('Unsupported previous source map format: ' + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $d069a6c2dccdddb9$require$join($d069a6c2dccdddb9$require$dirname(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
}
module.exports = $d069a6c2dccdddb9$var$PreviousMap;
$d069a6c2dccdddb9$var$PreviousMap.default = $d069a6c2dccdddb9$var$PreviousMap;

});



parcelRegister("kn5GT", function(module, exports) {
'use strict';

var $ldpuD = parcelRequire("ldpuD");
var $ed4a5eb535cd271e$require$isClean = $ldpuD.isClean;
var $ed4a5eb535cd271e$require$my = $ldpuD.my;

var $kmNwY = parcelRequire("kmNwY");

var $1Zscw = parcelRequire("1Zscw");

var $1SmAa = parcelRequire("1SmAa");
let $ed4a5eb535cd271e$var$parse, $ed4a5eb535cd271e$var$Rule, $ed4a5eb535cd271e$var$AtRule, $ed4a5eb535cd271e$var$Root;
function $ed4a5eb535cd271e$var$cleanSource(nodes) {
    return nodes.map((i)=>{
        if (i.nodes) i.nodes = $ed4a5eb535cd271e$var$cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function $ed4a5eb535cd271e$var$markDirtyUp(node) {
    node[$ed4a5eb535cd271e$require$isClean] = false;
    if (node.proxyOf.nodes) for (let i of node.proxyOf.nodes)$ed4a5eb535cd271e$var$markDirtyUp(i);
}
class $ed4a5eb535cd271e$var$Container extends $1SmAa {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node of nodes)this.proxyOf.nodes.push(node);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node of this.nodes)node.cleanRaws(keepBetween);
    }
    each(callback) {
        if (!this.proxyOf.nodes) return undefined;
        let iterator = this.getIterator();
        let index, result;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index = this.indexes[iterator];
            result = callback(this.proxyOf.nodes[index], index);
            if (result === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === 'proxyOf') return node;
                else if (!node[prop]) return node[prop];
                else if (prop === 'each' || typeof prop === 'string' && prop.startsWith('walk')) return (...args)=>{
                    return node[prop](...args.map((i)=>{
                        if (typeof i === 'function') return (child, index)=>i(child.toProxy(), index);
                        else return i;
                    }));
                };
                else if (prop === 'every' || prop === 'some') return (cb)=>{
                    return node[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === 'root') return ()=>node.root().toProxy();
                else if (prop === 'nodes') return node.nodes.map((i)=>i.toProxy());
                else if (prop === 'first' || prop === 'last') return node[prop].toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === 'name' || prop === 'params' || prop === 'selector') node.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === 'number') return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex < index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? 'prepend' : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex <= index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === 'string') nodes = $ed4a5eb535cd271e$var$cleanSource($ed4a5eb535cd271e$var$parse(nodes).nodes);
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, 'ignore');
        } else if (nodes.type === 'root' && this.type !== 'document') {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, 'ignore');
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === 'undefined') throw new Error('Value field is missed in node creation');
            else if (typeof nodes.value !== 'string') nodes.value = String(nodes.value);
            nodes = [
                new $kmNwY(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $ed4a5eb535cd271e$var$Rule(nodes)
        ];
        else if (nodes.name) nodes = [
            new $ed4a5eb535cd271e$var$AtRule(nodes)
        ];
        else if (nodes.text) nodes = [
            new $1Zscw(nodes)
        ];
        else throw new Error('Unknown node type in node creation');
        let processed = nodes.map((i)=>{
            /* c8 ignore next */ if (!i[$ed4a5eb535cd271e$require$my]) $ed4a5eb535cd271e$var$Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[$ed4a5eb535cd271e$require$isClean]) $ed4a5eb535cd271e$var$markDirtyUp(i);
            if (typeof i.raws.before === 'undefined') {
                if (sample && typeof sample.raws.before !== 'undefined') i.raws.before = sample.raws.before.replace(/\S/g, '');
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, 'prepend').reverse();
            for (let node of nodes)this.proxyOf.nodes.unshift(node);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node of this.proxyOf.nodes)node.parent = undefined;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = undefined;
        this.proxyOf.nodes.splice(child, 1);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i)=>{
            let result;
            try {
                result = callback(child, i);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result !== false && child.walk) result = child.walk(callback);
            return result;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === 'atrule') return callback(child, i);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'atrule' && name.test(child.name)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'atrule' && child.name === name) return callback(child, i);
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === 'comment') return callback(child, i);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === 'decl') return callback(child, i);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'decl' && prop.test(child.prop)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'decl' && child.prop === prop) return callback(child, i);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === 'rule') return callback(child, i);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'rule' && selector.test(child.selector)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'rule' && child.selector === selector) return callback(child, i);
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
}
$ed4a5eb535cd271e$var$Container.registerParse = (dependant)=>{
    $ed4a5eb535cd271e$var$parse = dependant;
};
$ed4a5eb535cd271e$var$Container.registerRule = (dependant)=>{
    $ed4a5eb535cd271e$var$Rule = dependant;
};
$ed4a5eb535cd271e$var$Container.registerAtRule = (dependant)=>{
    $ed4a5eb535cd271e$var$AtRule = dependant;
};
$ed4a5eb535cd271e$var$Container.registerRoot = (dependant)=>{
    $ed4a5eb535cd271e$var$Root = dependant;
};
module.exports = $ed4a5eb535cd271e$var$Container;
$ed4a5eb535cd271e$var$Container.default = $ed4a5eb535cd271e$var$Container;
/* c8 ignore start */ $ed4a5eb535cd271e$var$Container.rebuild = (node)=>{
    if (node.type === 'atrule') Object.setPrototypeOf(node, $ed4a5eb535cd271e$var$AtRule.prototype);
    else if (node.type === 'rule') Object.setPrototypeOf(node, $ed4a5eb535cd271e$var$Rule.prototype);
    else if (node.type === 'decl') Object.setPrototypeOf(node, $kmNwY.prototype);
    else if (node.type === 'comment') Object.setPrototypeOf(node, $1Zscw.prototype);
    else if (node.type === 'root') Object.setPrototypeOf(node, $ed4a5eb535cd271e$var$Root.prototype);
    node[$ed4a5eb535cd271e$require$my] = true;
    if (node.nodes) node.nodes.forEach((child)=>{
        $ed4a5eb535cd271e$var$Container.rebuild(child);
    });
}; /* c8 ignore stop */ 

});
parcelRegister("1Zscw", function(module, exports) {
'use strict';

var $1SmAa = parcelRequire("1SmAa");
class $17315d19ac1edab1$var$Comment extends $1SmAa {
    constructor(defaults){
        super(defaults);
        this.type = 'comment';
    }
}
module.exports = $17315d19ac1edab1$var$Comment;
$17315d19ac1edab1$var$Comment.default = $17315d19ac1edab1$var$Comment;

});


parcelRegister("37fY5", function(module, exports) {
'use strict';

var $kn5GT = parcelRequire("kn5GT");
let $244e697caddc4517$var$LazyResult, $244e697caddc4517$var$Processor;
class $244e697caddc4517$var$Document extends $kn5GT {
    constructor(defaults){
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        super({
            type: 'document',
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $244e697caddc4517$var$LazyResult(new $244e697caddc4517$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$244e697caddc4517$var$Document.registerLazyResult = (dependant)=>{
    $244e697caddc4517$var$LazyResult = dependant;
};
$244e697caddc4517$var$Document.registerProcessor = (dependant)=>{
    $244e697caddc4517$var$Processor = dependant;
};
module.exports = $244e697caddc4517$var$Document;
$244e697caddc4517$var$Document.default = $244e697caddc4517$var$Document;

});

parcelRegister("bpKNc", function(module, exports) {
/* eslint-disable no-console */ 'use strict';
let $84f65382b59b3577$var$printed = {};
module.exports = function warnOnce(message) {
    if ($84f65382b59b3577$var$printed[message]) return;
    $84f65382b59b3577$var$printed[message] = true;
    if (typeof console !== 'undefined' && console.warn) console.warn(message);
};

});

parcelRegister("gFMnm", function(module, exports) {
'use strict';

var $h9jM6 = parcelRequire("h9jM6");
class $c236001e150ba122$var$Result {
    constructor(processor, root, opts){
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = undefined;
        this.map = undefined;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning = new $h9jM6(text, opts);
        this.messages.push(warning);
        return warning;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === 'warning');
    }
    get content() {
        return this.css;
    }
}
module.exports = $c236001e150ba122$var$Result;
$c236001e150ba122$var$Result.default = $c236001e150ba122$var$Result;

});
parcelRegister("h9jM6", function(module, exports) {
'use strict';
class $c7c29dceccea94be$var$Warning {
    constructor(text, opts = {}){
        this.type = 'warning';
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ': ' + this.text;
        return this.text;
    }
}
module.exports = $c7c29dceccea94be$var$Warning;
$c7c29dceccea94be$var$Warning.default = $c7c29dceccea94be$var$Warning;

});


parcelRegister("3xfLS", function(module, exports) {
'use strict';

var $kn5GT = parcelRequire("kn5GT");

var $47TZD = parcelRequire("47TZD");

var $kwhQ7 = parcelRequire("kwhQ7");
function $2930affe442743be$var$parse(css, opts) {
    let input = new $kwhQ7(css, opts);
    let parser = new $47TZD(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
module.exports = $2930affe442743be$var$parse;
$2930affe442743be$var$parse.default = $2930affe442743be$var$parse;
$kn5GT.registerParse($2930affe442743be$var$parse);

});
parcelRegister("47TZD", function(module, exports) {
'use strict';

var $kmNwY = parcelRequire("kmNwY");

var $jKkG9 = parcelRequire("jKkG9");

var $1Zscw = parcelRequire("1Zscw");

var $5rixA = parcelRequire("5rixA");

var $cDOWD = parcelRequire("cDOWD");

var $2YUr2 = parcelRequire("2YUr2");
const $30133feddc6aecc7$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $30133feddc6aecc7$var$findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
class $30133feddc6aecc7$var$Parser {
    constructor(input){
        this.input = input;
        this.root = new $cDOWD();
        this.current = this.root;
        this.spaces = '';
        this.semicolon = false;
        this.customProperty = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node = new $5rixA();
        node.name = token[1].slice(1);
        if (node.name === '') this.unnamedAtrule(node, token);
        this.init(node, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === '(' || type === '[') brackets.push(type === '(' ? ')' : ']');
            else if (type === '{' && brackets.length > 0) brackets.push('}');
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ';') {
                    node.source.end = this.getPosition(token[2]);
                    node.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === '{') {
                    open = true;
                    break;
                } else if (type === '}') {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === 'space')prev = params[--shift];
                        if (prev) {
                            node.source.end = this.getPosition(prev[3] || prev[2]);
                            node.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node, 'params', params);
            if (last) {
                token = params[params.length - 1];
                node.source.end = this.getPosition(token[3] || token[2]);
                node.source.end.offset++;
                this.spaces = node.raws.between;
                node.raws.between = '';
            }
        } else {
            node.raws.afterName = '';
            node.params = '';
        }
        if (open) {
            node.nodes = [];
            this.current = node;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== 'space') {
                founded += 1;
                if (founded === 2) break;
            }
        }
        // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
        // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
        // And because we need it after that one we do +1 to get the next one.
        throw this.input.error('Missed semicolon', token[0] === 'word' ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === '(') brackets += 1;
            if (type === ')') brackets -= 1;
            if (brackets === 0 && type === ':') {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === 'word' && prev[1] === 'progid') continue;
                else return i;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node = new $1Zscw();
        this.init(node, token[2]);
        node.source.end = this.getPosition(token[3] || token[2]);
        node.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node.text = '';
            node.raws.left = text;
            node.raws.right = '';
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node.text = match[2];
            node.raws.left = match[1];
            node.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $jKkG9(this.input);
    }
    decl(tokens, customProperty) {
        let node = new $kmNwY();
        this.init(node, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ';') {
            this.semicolon = true;
            tokens.pop();
        }
        node.source.end = this.getPosition(last[3] || last[2] || $30133feddc6aecc7$var$findLastWithPosition(tokens));
        node.source.end.offset++;
        while(tokens[0][0] !== 'word'){
            if (tokens.length === 1) this.unknownWord(tokens);
            node.raws.before += tokens.shift()[1];
        }
        node.source.start = this.getPosition(tokens[0][2]);
        node.prop = '';
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ':' || type === 'space' || type === 'comment') break;
            node.prop += tokens.shift()[1];
        }
        node.raws.between = '';
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ':') {
                node.raws.between += token[1];
                break;
            } else {
                if (token[0] === 'word' && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node.raws.between += token[1];
            }
        }
        if (node.prop[0] === '_' || node.prop[0] === '*') {
            node.raws.before += node.prop[0];
            node.prop = node.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== 'space' && next !== 'comment') break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === '!important') {
                node.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== ' !important') node.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === 'important') {
                let cache = tokens.slice(0);
                let str = '';
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf('!') === 0 && type !== 'space') break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf('!') === 0) {
                    node.important = true;
                    node.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== 'space' && token[0] !== 'comment') break;
        }
        let hasWord = tokens.some((i)=>i[0] !== 'space' && i[0] !== 'comment');
        if (hasWord) {
            node.raws.between += firstSpaces.map((i)=>i[1]).join('');
            firstSpaces = [];
        }
        this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);
        if (node.value.includes(':') && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error('Double colon', {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node = new $2YUr2();
        this.init(node, token[2]);
        node.selector = '';
        node.raws.between = '';
        this.current = node;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
        this.spaces = '';
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = '';
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node, offset) {
        this.current.push(node);
        node.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node.raws.before = this.spaces;
        this.spaces = '';
        if (node.type !== 'comment') this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith('--');
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === '(' || type === '[') {
                if (!bracket) bracket = token;
                brackets.push(type === '(' ? ')' : ']');
            } else if (customProperty && colon && type === '{') {
                if (!bracket) bracket = token;
                brackets.push('}');
            } else if (brackets.length === 0) {
                if (type === ';') {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === '{') {
                    this.rule(tokens);
                    return;
                } else if (type === '}') {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ':') colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== 'space' && token !== 'comment') break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case 'space':
                    this.spaces += token[1];
                    break;
                case ';':
                    this.freeSemicolon(token);
                    break;
                case '}':
                    this.end(token);
                    break;
                case 'comment':
                    this.comment(token);
                    break;
                case 'at-word':
                    this.atrule(token);
                    break;
                case '{':
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {
    // Hook for Safe Parser
    }
    raw(node, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = '';
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === 'space' && i === length - 1 && !customProperty) clean = false;
            else if (type === 'comment') {
                prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
                next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
                if (!$30133feddc6aecc7$var$SAFE_COMMENT_NEIGHBOR[prev] && !$30133feddc6aecc7$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ',') clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], '');
            node.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node = new $2YUr2();
        this.init(node, tokens[0][2]);
        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node, 'selector', tokens);
        this.current = node;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = '';
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = '';
        while(tokens.length){
            next = tokens[0][0];
            if (next !== 'space' && next !== 'comment') break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = '';
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== 'space') break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result = '';
        for(let i = from; i < tokens.length; i++)result += tokens[i][1];
        tokens.splice(from, tokens.length - from);
        return result;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error('Unclosed block', pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error('Unclosed bracket', {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error('Unexpected }', {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error('Unknown word', {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node, token) {
        throw this.input.error('At-rule without name', {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
}
module.exports = $30133feddc6aecc7$var$Parser;

});
parcelRegister("jKkG9", function(module, exports) {
'use strict';
const $e6025a90e0ffe029$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $e6025a90e0ffe029$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $e6025a90e0ffe029$var$BACKSLASH = '\\'.charCodeAt(0);
const $e6025a90e0ffe029$var$SLASH = '/'.charCodeAt(0);
const $e6025a90e0ffe029$var$NEWLINE = '\n'.charCodeAt(0);
const $e6025a90e0ffe029$var$SPACE = ' '.charCodeAt(0);
const $e6025a90e0ffe029$var$FEED = '\f'.charCodeAt(0);
const $e6025a90e0ffe029$var$TAB = '\t'.charCodeAt(0);
const $e6025a90e0ffe029$var$CR = '\r'.charCodeAt(0);
const $e6025a90e0ffe029$var$OPEN_SQUARE = '['.charCodeAt(0);
const $e6025a90e0ffe029$var$CLOSE_SQUARE = ']'.charCodeAt(0);
const $e6025a90e0ffe029$var$OPEN_PARENTHESES = '('.charCodeAt(0);
const $e6025a90e0ffe029$var$CLOSE_PARENTHESES = ')'.charCodeAt(0);
const $e6025a90e0ffe029$var$OPEN_CURLY = '{'.charCodeAt(0);
const $e6025a90e0ffe029$var$CLOSE_CURLY = '}'.charCodeAt(0);
const $e6025a90e0ffe029$var$SEMICOLON = ';'.charCodeAt(0);
const $e6025a90e0ffe029$var$ASTERISK = '*'.charCodeAt(0);
const $e6025a90e0ffe029$var$COLON = ':'.charCodeAt(0);
const $e6025a90e0ffe029$var$AT = '@'.charCodeAt(0);
const $e6025a90e0ffe029$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $e6025a90e0ffe029$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $e6025a90e0ffe029$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const $e6025a90e0ffe029$var$RE_HEX_ESCAPE = /[\da-f]/i;
module.exports = function tokenizer(input, options = {}) {
    let css = input.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error('Unclosed ' + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $e6025a90e0ffe029$var$NEWLINE:
            case $e6025a90e0ffe029$var$SPACE:
            case $e6025a90e0ffe029$var$TAB:
            case $e6025a90e0ffe029$var$CR:
            case $e6025a90e0ffe029$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $e6025a90e0ffe029$var$SPACE || code === $e6025a90e0ffe029$var$NEWLINE || code === $e6025a90e0ffe029$var$TAB || code === $e6025a90e0ffe029$var$CR || code === $e6025a90e0ffe029$var$FEED);
                currentToken = [
                    'space',
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $e6025a90e0ffe029$var$OPEN_SQUARE:
            case $e6025a90e0ffe029$var$CLOSE_SQUARE:
            case $e6025a90e0ffe029$var$OPEN_CURLY:
            case $e6025a90e0ffe029$var$CLOSE_CURLY:
            case $e6025a90e0ffe029$var$COLON:
            case $e6025a90e0ffe029$var$SEMICOLON:
            case $e6025a90e0ffe029$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $e6025a90e0ffe029$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : '';
                n = css.charCodeAt(pos + 1);
                if (prev === 'url' && n !== $e6025a90e0ffe029$var$SINGLE_QUOTE && n !== $e6025a90e0ffe029$var$DOUBLE_QUOTE && n !== $e6025a90e0ffe029$var$SPACE && n !== $e6025a90e0ffe029$var$NEWLINE && n !== $e6025a90e0ffe029$var$TAB && n !== $e6025a90e0ffe029$var$FEED && n !== $e6025a90e0ffe029$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(')', next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed('bracket');
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $e6025a90e0ffe029$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        'brackets',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(')', pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $e6025a90e0ffe029$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        '(',
                        '(',
                        pos
                    ];
                    else {
                        currentToken = [
                            'brackets',
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $e6025a90e0ffe029$var$SINGLE_QUOTE:
            case $e6025a90e0ffe029$var$DOUBLE_QUOTE:
                quote = code === $e6025a90e0ffe029$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed('string');
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $e6025a90e0ffe029$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    'string',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $e6025a90e0ffe029$var$AT:
                $e6025a90e0ffe029$var$RE_AT_END.lastIndex = pos + 1;
                $e6025a90e0ffe029$var$RE_AT_END.test(css);
                if ($e6025a90e0ffe029$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $e6025a90e0ffe029$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    'at-word',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $e6025a90e0ffe029$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $e6025a90e0ffe029$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $e6025a90e0ffe029$var$SLASH && code !== $e6025a90e0ffe029$var$SPACE && code !== $e6025a90e0ffe029$var$NEWLINE && code !== $e6025a90e0ffe029$var$TAB && code !== $e6025a90e0ffe029$var$CR && code !== $e6025a90e0ffe029$var$FEED) {
                    next += 1;
                    if ($e6025a90e0ffe029$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($e6025a90e0ffe029$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $e6025a90e0ffe029$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    'word',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $e6025a90e0ffe029$var$SLASH && css.charCodeAt(pos + 1) === $e6025a90e0ffe029$var$ASTERISK) {
                    next = css.indexOf('*/', pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed('comment');
                    }
                    currentToken = [
                        'comment',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $e6025a90e0ffe029$var$RE_WORD_END.lastIndex = pos + 1;
                    $e6025a90e0ffe029$var$RE_WORD_END.test(css);
                    if ($e6025a90e0ffe029$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $e6025a90e0ffe029$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        'word',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};

});

parcelRegister("5rixA", function(module, exports) {
'use strict';

var $kn5GT = parcelRequire("kn5GT");
class $3f5ddb247d8a6578$var$AtRule extends $kn5GT {
    constructor(defaults){
        super(defaults);
        this.type = 'atrule';
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
}
module.exports = $3f5ddb247d8a6578$var$AtRule;
$3f5ddb247d8a6578$var$AtRule.default = $3f5ddb247d8a6578$var$AtRule;
$kn5GT.registerAtRule($3f5ddb247d8a6578$var$AtRule);

});

parcelRegister("cDOWD", function(module, exports) {
'use strict';

var $kn5GT = parcelRequire("kn5GT");
let $9340a51df265f5c5$var$LazyResult, $9340a51df265f5c5$var$Processor;
class $9340a51df265f5c5$var$Root extends $kn5GT {
    constructor(defaults){
        super(defaults);
        this.type = 'root';
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === 'prepend') {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node of nodes)node.raws.before = sample.raws.before;
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index = this.index(child);
        if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $9340a51df265f5c5$var$LazyResult(new $9340a51df265f5c5$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$9340a51df265f5c5$var$Root.registerLazyResult = (dependant)=>{
    $9340a51df265f5c5$var$LazyResult = dependant;
};
$9340a51df265f5c5$var$Root.registerProcessor = (dependant)=>{
    $9340a51df265f5c5$var$Processor = dependant;
};
module.exports = $9340a51df265f5c5$var$Root;
$9340a51df265f5c5$var$Root.default = $9340a51df265f5c5$var$Root;
$kn5GT.registerRoot($9340a51df265f5c5$var$Root);

});

parcelRegister("2YUr2", function(module, exports) {
'use strict';

var $kn5GT = parcelRequire("kn5GT");

var $jmTyl = parcelRequire("jmTyl");
class $22bcf62f1ffa8b19$var$Rule extends $kn5GT {
    constructor(defaults){
        super(defaults);
        this.type = 'rule';
        if (!this.nodes) this.nodes = [];
    }
    get selectors() {
        return $jmTyl.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
        this.selector = values.join(sep);
    }
}
module.exports = $22bcf62f1ffa8b19$var$Rule;
$22bcf62f1ffa8b19$var$Rule.default = $22bcf62f1ffa8b19$var$Rule;
$kn5GT.registerRule($22bcf62f1ffa8b19$var$Rule);

});
parcelRegister("jmTyl", function(module, exports) {
'use strict';
let $e19b2a0aa28c00a3$var$list = {
    comma (string) {
        return $e19b2a0aa28c00a3$var$list.split(string, [
            ','
        ], true);
    },
    space (string) {
        let spaces = [
            ' ',
            '\n',
            '\t'
        ];
        return $e19b2a0aa28c00a3$var$list.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = '';
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = '';
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === '\\') escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === '(') func += 1;
            else if (letter === ')') {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== '') array.push(current.trim());
                current = '';
                split = false;
            } else current += letter;
        }
        if (last || current !== '') array.push(current.trim());
        return array;
    }
};
module.exports = $e19b2a0aa28c00a3$var$list;
$e19b2a0aa28c00a3$var$list.default = $e19b2a0aa28c00a3$var$list;

});





parcelRegister("6LzYO", function(module, exports) {
'use strict';

var $gRLFe = parcelRequire("gRLFe");

var $etTkx = parcelRequire("etTkx");

var $37fY5 = parcelRequire("37fY5");

var $cDOWD = parcelRequire("cDOWD");
class $4ed30ab83a6e6409$var$Processor {
    constructor(plugins = []){
        this.version = '8.4.31';
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) i = i();
            else if (i.postcss) i = i.postcss;
            if (typeof i === 'object' && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
            else if (typeof i === 'object' && i.postcssPlugin) normalized.push(i);
            else if (typeof i === 'function') normalized.push(i);
            else if (typeof i === 'object' && (i.parse || i.stringify)) ;
            else throw new Error(i + ' is not a PostCSS plugin');
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (this.plugins.length === 0 && typeof opts.parser === 'undefined' && typeof opts.stringifier === 'undefined' && typeof opts.syntax === 'undefined') return new $gRLFe(this, css, opts);
        else return new $etTkx(this, css, opts);
    }
    use(plugin) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin
        ]));
        return this;
    }
}
module.exports = $4ed30ab83a6e6409$var$Processor;
$4ed30ab83a6e6409$var$Processor.default = $4ed30ab83a6e6409$var$Processor;
$cDOWD.registerProcessor($4ed30ab83a6e6409$var$Processor);
$37fY5.registerProcessor($4ed30ab83a6e6409$var$Processor);

});
parcelRegister("gRLFe", function(module, exports) {
'use strict';

var $cKWXg = parcelRequire("cKWXg");

var $ceQvC = parcelRequire("ceQvC");
parcelRequire("bpKNc");

var $3xfLS = parcelRequire("3xfLS");

var $gFMnm = parcelRequire("gFMnm");
class $c47691acb854dec1$var$NoWorkResult {
    constructor(processor, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        let root;
        let str = $ceQvC;
        this.result = new $gFMnm(this._processor, root, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, 'root', {
            get () {
                return self.root;
            }
        });
        let map = new $cKWXg(str, root, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root;
        let parser = $3xfLS;
        try {
            root = parser(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root;
            return root;
        }
    }
    get [Symbol.toStringTag]() {
        return 'NoWorkResult';
    }
}
module.exports = $c47691acb854dec1$var$NoWorkResult;
$c47691acb854dec1$var$NoWorkResult.default = $c47691acb854dec1$var$NoWorkResult;

});


parcelRegister("6sfgU", function(module, exports) {
'use strict';

var $kmNwY = parcelRequire("kmNwY");

var $hTnj1 = parcelRequire("hTnj1");

var $1Zscw = parcelRequire("1Zscw");

var $5rixA = parcelRequire("5rixA");

var $kwhQ7 = parcelRequire("kwhQ7");

var $cDOWD = parcelRequire("cDOWD");

var $2YUr2 = parcelRequire("2YUr2");
function $4b31343a52a3b043$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>$4b31343a52a3b043$var$fromJSON(n));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input of ownInputs){
            let inputHydrated = {
                ...input,
                __proto__: $kwhQ7.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $hTnj1.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n)=>$4b31343a52a3b043$var$fromJSON(n, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === 'root') return new $cDOWD(defaults);
    else if (defaults.type === 'decl') return new $kmNwY(defaults);
    else if (defaults.type === 'rule') return new $2YUr2(defaults);
    else if (defaults.type === 'comment') return new $1Zscw(defaults);
    else if (defaults.type === 'atrule') return new $5rixA(defaults);
    else throw new Error('Unknown node type: ' + json.type);
}
module.exports = $4b31343a52a3b043$var$fromJSON;
$4b31343a52a3b043$var$fromJSON.default = $4b31343a52a3b043$var$fromJSON;

});



parcelRegister("ik40B", function(module, exports) {
$parcel$export(module.exports, "isTargetedSubAnchor", function () { return $a19b13a40a2836b7$export$ae62859ac3ba0a1d; });
$parcel$export(module.exports, "isInContextualBanditsSubAnchor", function () { return $a19b13a40a2836b7$export$bf10147d0ac61da9; });
$parcel$export(module.exports, "getPageId", function () { return $a19b13a40a2836b7$export$2ce6e339a89daf7a; });
$parcel$export(module.exports, "generateTabComponentSubAnchor", function () { return $a19b13a40a2836b7$export$c2a9c65e5ab46a75; });
$parcel$export(module.exports, "getAnimationBySubAnchor", function () { return $a19b13a40a2836b7$export$2e051bef3a49a4ad; });

var $7VQPk = parcelRequire("7VQPk");

var $2exic = parcelRequire("2exic");

var $cwx2f = parcelRequire("cwx2f");

var $eFBwf = parcelRequire("eFBwf");

var $ayQSY = parcelRequire("ayQSY");

var $kb1Ca = parcelRequire("kb1Ca");

var $8uiKg = parcelRequire("8uiKg");

var $k6cCS = parcelRequire("k6cCS");

var $iyOcM = parcelRequire("iyOcM");

var $2Y4QO = parcelRequire("2Y4QO");

var $a2Szx = parcelRequire("a2Szx");

var $4HcEI = parcelRequire("4HcEI");

var $cLuPb = parcelRequire("cLuPb");
const $a19b13a40a2836b7$var$databaseVideoData = {
    videoSrcMp4: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4',
    videoSrcWebm: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm',
    videoPreviewSrc: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp'
};
const $a19b13a40a2836b7$var$whiteboardsVideoData = {
    videoSrcMp4: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4',
    videoSrcWebm: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm',
    videoPreviewSrc: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp'
};
const $a19b13a40a2836b7$var$pagesVideoData = {
    videoSrcMp4: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4',
    videoSrcWebm: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm',
    videoPreviewSrc: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp'
};
const $a19b13a40a2836b7$var$subAnchorMap = {
    brainstorm: {
        pageId: 'paid-lp-conf-sub-anchor-brainstorm',
        video: $a19b13a40a2836b7$var$whiteboardsVideoData,
        animation: (0, $k6cCS.MindMap)
    },
    'business plan': {
        pageId: 'paid-lp-conf-sub-anchor-business-plan',
        video: $a19b13a40a2836b7$var$whiteboardsVideoData,
        animation: (0, $eFBwf.Page)
    },
    coda: {
        pageId: 'paid-lp-conf-keywords-competitors',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $eFBwf.Page)
    },
    'collaboration tool': {
        pageId: 'paid-lp-conf-sub-anchor-collaboration-tools',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $eFBwf.Page)
    },
    'documentation tools': {
        pageId: 'paid-lp-conf-keywords-documentation',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $eFBwf.Page)
    },
    'google docs': {
        pageId: 'paid-lp-conf-keywords-competitors',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $eFBwf.Page)
    },
    'knowledge management': {
        pageId: 'paid-lp-conf-sub-anchor-knowledge-management',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $cwx2f.Wiki)
    },
    'microsoft sharepoint': {
        pageId: 'paid-lp-conf-keywords-competitors',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $eFBwf.Page)
    },
    'microsoft teams': {
        pageId: 'paid-lp-conf-keywords-competitors',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $eFBwf.Page)
    },
    notion: {
        pageId: 'paid-lp-conf-keywords-competitors',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $eFBwf.Page)
    },
    'organization chart': {
        pageId: 'paid-lp-conf-sub-anchor-organization-chart',
        video: $a19b13a40a2836b7$var$whiteboardsVideoData,
        animation: (0, $8uiKg.OrgChart)
    },
    'project management software': {
        pageId: 'paid-lp-conf-sub-anchor-project-plan',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $2exic.ProjectPlan)
    },
    'project management templates': {
        pageId: 'paid-lp-conf-sub-anchor-project-plan',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $2exic.ProjectPlan)
    },
    'project plan': {
        pageId: 'paid-lp-conf-keywords-project-plan',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $2exic.ProjectPlan)
    },
    spreadsheet: {
        pageId: 'paid-lp-conf-keywords-spreadsheets',
        video: $a19b13a40a2836b7$var$databaseVideoData,
        animation: (0, $kb1Ca.Spreadsheet)
    },
    'task management': {
        pageId: 'paid-lp-conf-keywords-task-list',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $kb1Ca.Spreadsheet)
    },
    whiteboard: {
        pageId: 'paid-lp-conf-sub-anchor-whiteboard',
        video: $a19b13a40a2836b7$var$whiteboardsVideoData,
        animation: (0, $ayQSY.Whiteboard)
    },
    wiki: {
        pageId: 'paid-lp-conf-sub-anchor-wiki',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $cwx2f.Wiki)
    },
    'word editor': {
        pageId: 'paid-lp-conf-keywords-documentation',
        video: $a19b13a40a2836b7$var$pagesVideoData,
        animation: (0, $eFBwf.Page)
    }
};
const $a19b13a40a2836b7$export$ae62859ac3ba0a1d = (subAnchor = '')=>!!$a19b13a40a2836b7$var$subAnchorMap[subAnchor];
const $a19b13a40a2836b7$export$92331d2e4a7d36a8 = (subAnchor = '')=>[
        'brainstorm',
        'business plan',
        'coda',
        'collaboration tool',
        'documentation tools',
        'google docs',
        'knowledge management',
        'microsoft sharepoint',
        'microsoft teams',
        'notion',
        'online flowchart',
        'organization chart',
        'project management templates',
        'task management',
        'whiteboard',
        'wiki'
    ].includes(subAnchor);
const $a19b13a40a2836b7$export$bf10147d0ac61da9 = (subAnchor = '')=>[
        'analytics tools',
        'brainstorm',
        'business plan',
        'coda',
        'collaboration tools',
        'communication system',
        'content management',
        'digital diagram',
        'documentation tools',
        'file sharing',
        'gantt chart',
        'google docs',
        'intranet',
        'knowledge management',
        'organization chart',
        'other templates',
        'others',
        'process management',
        'project management software',
        'project management templates',
        'project plan',
        'project reporting',
        'remote',
        'spreadsheet',
        'task management',
        'team management',
        'time management',
        'whiteboard',
        'wiki',
        'word editor',
        'work management',
        'workflow'
    ].includes(subAnchor);
const $a19b13a40a2836b7$export$2ce6e339a89daf7a = (subAnchor = '')=>$a19b13a40a2836b7$var$subAnchorMap[subAnchor]?.pageId || 'paid-lp-conf-keywords-documentation';
const $a19b13a40a2836b7$export$c2a9c65e5ab46a75 = (keyword = '', tab)=>{
    const videoProps = $a19b13a40a2836b7$var$subAnchorMap[keyword]?.video || $a19b13a40a2836b7$var$pagesVideoData;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyOcM.Adg4Tabs), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
            ...videoProps,
            showBackground: true,
            active: true,
            showAsterisks: true,
            hideSeparator: true,
            title: tab.title,
            description: tab.description,
            iconCollection: Array.from(new DOMParser().parseFromString(tab.content, 'text/html').querySelectorAll('p')).slice(0, 3).map((p, i)=>({
                    description: p.textContent || '',
                    icon: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4HcEI.Rocket), {
                            size: "small"
                        }, "Rocket"),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Y4QO.Megaphone), {
                            size: "small"
                        }, "Megaphone"),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a2Szx.Notepad), {
                            size: "small"
                        }, "Notepad")
                    ][i]
                }))
        })
    });
};
const $a19b13a40a2836b7$export$2e051bef3a49a4ad = (subAnchor)=>{
    const riveAnimation = $a19b13a40a2836b7$var$subAnchorMap[subAnchor]?.animation;
    return riveAnimation ? {
        riveAnimation: riveAnimation
    } : undefined;
};

});
parcelRegister("2exic", function(module, exports) {
$parcel$export(module.exports, "ProjectPlan", function () { return $bbd482e288c4be97$export$be46c88e95f4d491; });

var $7VQPk = parcelRequire("7VQPk");

var $95rvY = parcelRequire("95rvY");
const $bbd482e288c4be97$export$be46c88e95f4d491 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95rvY.AnimationWithSize), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/50miwctfdsfv7srn8cq3q65fs047esh8.riv"
    });

});
parcelRegister("95rvY", function(module, exports) {
$parcel$export(module.exports, "AnimationWithSize", function () { return $a05c312d3542227e$export$17e92986bb7fd081; });

var $7VQPk = parcelRequire("7VQPk");

var $5nxFN = parcelRequire("5nxFN");
const $a05c312d3542227e$export$17e92986bb7fd081 = ({ src: src })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5nxFN.RiveAnimation), {
        src: src,
        height: "350px",
        width: "600px"
    });

});
parcelRegister("5nxFN", function(module, exports) {
$parcel$export(module.exports, "RiveAnimation", function () { return $3232a10e214d731a$export$e77ffad62888ca02; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $e0QlR = parcelRequire("e0QlR");
const $3232a10e214d731a$export$e77ffad62888ca02 = ({ width: width, height: height, loadingElement: loadingElement = null, ...rest })=>{
    const [isLoading, setIsLoading] = (0, $1oC0p.useState)(true);
    const { RiveComponent: RiveComponent } = (0, $e0QlR.useRive)({
        ...rest,
        autoplay: true,
        onLoad: ()=>{
            setIsLoading(false);
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: {
            width: width,
            height: height
        },
        children: [
            isLoading && loadingElement,
            /*#__PURE__*/ (0, $7VQPk.jsx)(RiveComponent, {})
        ]
    });
};

});
parcelRegister("e0QlR", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $1oC0p = parcelRequire("1oC0p");

var $1g18o = parcelRequire("1g18o");
function $a339acb540ac88ae$var$n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
var $a339acb540ac88ae$var$i = /*#__PURE__*/ $a339acb540ac88ae$var$n($1oC0p), $a339acb540ac88ae$var$r = function() {
    return $a339acb540ac88ae$var$r = Object.assign || function(e) {
        for(var t, n = 1, i = arguments.length; n < i; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $a339acb540ac88ae$var$r.apply(this, arguments);
};
function $a339acb540ac88ae$var$o(e, t) {
    var n = {};
    for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(i = Object.getOwnPropertySymbols(e); r < i.length; r++)t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (n[i[r]] = e[i[r]]);
    }
    return n;
}
function $a339acb540ac88ae$var$a(e, t, n, i) {
    return new (n || (n = Promise))(function(r, o) {
        function a(e) {
            try {
                s(i.next(e));
            } catch (e) {
                o(e);
            }
        }
        function u(e) {
            try {
                s(i.throw(e));
            } catch (e) {
                o(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, u);
        }
        s((i = i.apply(e, t || [])).next());
    });
}
function $a339acb540ac88ae$var$u(e, t) {
    var n, i, r, o = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = u(0), a.throw = u(1), a.return = u(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function u(u) {
        return function(s) {
            return function(u) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, u[0] && (o = 0)), o;)try {
                    if (n = 1, i && (r = 2 & u[0] ? i.return : u[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, u[1])).done) return r;
                    switch(i = 0, r && (u = [
                        2 & u[0],
                        r.value
                    ]), u[0]){
                        case 0:
                        case 1:
                            r = u;
                            break;
                        case 4:
                            return o.label++, {
                                value: u[1],
                                done: !1
                            };
                        case 5:
                            o.label++, i = u[1], u = [
                                0
                            ];
                            continue;
                        case 7:
                            u = o.ops.pop(), o.trys.pop();
                            continue;
                        default:
                            if (!(r = o.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== u[0] && 2 !== u[0])) {
                                o = 0;
                                continue;
                            }
                            if (3 === u[0] && (!r || u[1] > r[0] && u[1] < r[3])) {
                                o.label = u[1];
                                break;
                            }
                            if (6 === u[0] && o.label < r[1]) {
                                o.label = r[1], r = u;
                                break;
                            }
                            if (r && o.label < r[2]) {
                                o.label = r[2], o.ops.push(u);
                                break;
                            }
                            r[2] && o.ops.pop(), o.trys.pop();
                            continue;
                    }
                    u = t.call(e, o);
                } catch (e) {
                    u = [
                        6,
                        e
                    ], i = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & u[0]) throw u[1];
                return {
                    value: u[0] ? u[1] : void 0,
                    done: !0
                };
            }([
                u,
                s
            ]);
        };
    }
}
function $a339acb540ac88ae$var$s(t) {
    var n = t || $a339acb540ac88ae$var$c(), i = $1oC0p.useState(n), r = i[0], o = i[1];
    return $1oC0p.useEffect(function() {
        if ("undefined" != typeof window && "matchMedia" in window) {
            var e = function() {
                var e = t || $a339acb540ac88ae$var$c();
                o(e);
            }, n = window.matchMedia("screen and (resolution: ".concat(r, "dppx)"));
            return n.hasOwnProperty("addEventListener") ? n.addEventListener("change", e) : n.addListener(e), function() {
                n.hasOwnProperty("removeEventListener") ? n.removeEventListener("change", e) : n.removeListener(e);
            };
        }
    }, [
        r,
        t
    ]), r;
}
function $a339acb540ac88ae$var$c() {
    var e = "undefined" != typeof window && "number" == typeof window.devicePixelRatio ? window.devicePixelRatio : 1;
    return Math.min(Math.max(1, e), 3);
}
"function" == typeof SuppressedError && SuppressedError;
var $a339acb540ac88ae$var$l = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}();
var $a339acb540ac88ae$var$f = globalThis.ResizeObserver || $a339acb540ac88ae$var$l, $a339acb540ac88ae$var$d = void 0 !== globalThis.ResizeObserver, $a339acb540ac88ae$var$v = !$a339acb540ac88ae$var$d;
function $a339acb540ac88ae$var$h(t, n) {
    void 0 === n && (n = !0);
    var i = $1oC0p.useState({
        width: 0,
        height: 0
    }), r = i[0], o = i[1];
    $1oC0p.useEffect(function() {
        if ("undefined" != typeof window && n) {
            var e = function() {
                o({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            return $a339acb540ac88ae$var$v && (e(), window.addEventListener("resize", e)), function() {
                return window.removeEventListener("resize", e);
            };
        }
    }, []);
    var a, u, s, c = $1oC0p.useRef(new $a339acb540ac88ae$var$f((a = function(e) {
        $a339acb540ac88ae$var$d && o({
            width: e[e.length - 1].contentRect.width,
            height: e[e.length - 1].contentRect.height
        });
    }, u = 0, s = 0, function() {
        for(var e = this, t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
        clearTimeout(s), s = window.setTimeout(function() {
            return a.apply(e, t);
        }, u);
    })));
    return $1oC0p.useEffect(function() {
        var e = c.current;
        if (n) {
            var i = t.current;
            return t.current && $a339acb540ac88ae$var$d && e.observe(t.current), function() {
                e.disconnect(), i && $a339acb540ac88ae$var$d && e.unobserve(i);
            };
        }
        e.disconnect();
    }, [
        t,
        c
    ]), r;
}
var $a339acb540ac88ae$var$p = {
    useDevicePixelRatio: !0,
    fitCanvasToArtboardHeight: !1,
    useOffscreenRenderer: !0,
    shouldResizeCanvasToContainer: !0
};
function $a339acb540ac88ae$var$b(e) {
    return Object.assign({}, $a339acb540ac88ae$var$p, e);
}
function $a339acb540ac88ae$var$w(t) {
    var n = t.riveLoaded, i = void 0 !== n && n, r = t.canvasElem, o = t.containerRef, a = t.options, u = void 0 === a ? {} : a, c = t.onCanvasHasResized, l = t.artboardBounds, f = $a339acb540ac88ae$var$b(u), d = $1oC0p.useState({
        height: 0,
        width: 0
    }), v = d[0], p = v.height, w = v.width, y = d[1], g = $1oC0p.useState({
        height: 0,
        width: 0
    }), m = g[0], R = m.height, C = m.width, E = g[1], O = $1oC0p.useState(!0), x = O[0], T = O[1], P = f.fitCanvasToArtboardHeight, L = f.shouldResizeCanvasToContainer, S = f.useDevicePixelRatio, k = f.customDevicePixelRatio, M = $a339acb540ac88ae$var$h(o, L), j = $a339acb540ac88ae$var$s(k), z = null != l ? l : {}, H = z.maxX, I = z.maxY, D = $1oC0p.useCallback(function() {
        var e, t, n, i, r = null !== (t = null === (e = o.current) || void 0 === e ? void 0 : e.clientWidth) && void 0 !== t ? t : 0, a = null !== (i = null === (n = o.current) || void 0 === n ? void 0 : n.clientHeight) && void 0 !== i ? i : 0;
        return P && l ? {
            width: r,
            height: r * (l.maxY / l.maxX)
        } : {
            width: r,
            height: a
        };
    }, [
        o,
        P,
        H,
        I
    ]);
    $1oC0p.useEffect(function() {
        if (L && o.current && i) {
            var e = D(), t = e.width, n = e.height, a = !1;
            if (r) {
                var u = t !== w || n !== p;
                if (f.fitCanvasToArtboardHeight && u && (o.current.style.height = n + "px", a = !0), f.useDevicePixelRatio) {
                    if (u || t * j !== C || n * j !== R) {
                        var s = j * t, l = j * n;
                        r.width = s, r.height = l, r.style.width = t + "px", r.style.height = n + "px", E({
                            width: s,
                            height: l
                        }), a = !0;
                    }
                } else u && (r.width = t, r.height = n, E({
                    width: t,
                    height: n
                }), a = !0);
                y({
                    width: t,
                    height: n
                });
            }
            c && (x || a) && c && c(), x && T(!1);
        }
    }, [
        r,
        o,
        M,
        j,
        D,
        x,
        T,
        R,
        C,
        p,
        w,
        c,
        L,
        P,
        S,
        i
    ]), $1oC0p.useEffect(function() {
        E({
            width: 0,
            height: 0
        });
    }, [
        r
    ]);
}
var $a339acb540ac88ae$var$y, $a339acb540ac88ae$var$g = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}(), $a339acb540ac88ae$var$m = globalThis.IntersectionObserver || $a339acb540ac88ae$var$g, $a339acb540ac88ae$var$R = function() {
    function e() {
        var e = this;
        this.elementsMap = new Map, this.onObserved = function(t) {
            t.forEach(function(t) {
                var n = e.elementsMap.get(t.target);
                n && n(t);
            });
        }, this.observer = new $a339acb540ac88ae$var$m(this.onObserved);
    }
    return e.prototype.registerCallback = function(e, t) {
        this.observer.observe(e), this.elementsMap.set(e, t);
    }, e.prototype.removeCallback = function(e) {
        this.observer.unobserve(e), this.elementsMap.delete(e);
    }, e;
}(), $a339acb540ac88ae$var$C = function() {
    return $a339acb540ac88ae$var$y || ($a339acb540ac88ae$var$y = new $a339acb540ac88ae$var$R), $a339acb540ac88ae$var$y;
};
function $a339acb540ac88ae$var$E(e) {
    var t = e.setContainerRef, n = e.setCanvasRef, a = e.className, u = void 0 === a ? "" : a, s = e.style, c = e.children, l = $a339acb540ac88ae$var$o(e, [
        "setContainerRef",
        "setCanvasRef",
        "className",
        "style",
        "children"
    ]), f = $a339acb540ac88ae$var$r({
        width: "100%",
        height: "100%"
    }, s);
    return $a339acb540ac88ae$var$i.default.createElement("div", $a339acb540ac88ae$var$r({
        ref: t,
        className: u
    }, !u && {
        style: f
    }), $a339acb540ac88ae$var$i.default.createElement("canvas", $a339acb540ac88ae$var$r({
        ref: n,
        style: {
            verticalAlign: "top",
            width: 0,
            height: 0
        }
    }, l), c));
}
function $a339acb540ac88ae$var$O(n, o) {
    void 0 === o && (o = {});
    var a = $1oC0p.useState(null), u = a[0], c = a[1], l = $1oC0p.useRef(null), f = $1oC0p.useState(null), d = f[0], v = f[1], h = Boolean(n), p = $a339acb540ac88ae$var$b(o), y = $a339acb540ac88ae$var$s(), g = $1oC0p.useCallback(function() {
        if (d) {
            if (d.layout && d.layout.fit === $1g18o.Fit.Layout && u) {
                var e = y * d.layout.layoutScaleFactor;
                d.devicePixelRatioUsed = y, d.artboardWidth = (null == u ? void 0 : u.width) / e, d.artboardHeight = (null == u ? void 0 : u.height) / e;
            }
            d.startRendering(), d.resizeToCanvas();
        }
    }, [
        d,
        y
    ]);
    $a339acb540ac88ae$var$w({
        riveLoaded: !!d,
        canvasElem: u,
        containerRef: l,
        options: p,
        onCanvasHasResized: g,
        artboardBounds: null == d ? void 0 : d.bounds
    });
    var m = $1oC0p.useCallback(function(e) {
        null === e && u && (u.height = 0, u.width = 0), c(e);
    }, []);
    $1oC0p.useEffect(function() {
        if (u && n) {
            var e, i = null != d;
            if (null == d) {
                var o = p.useOffscreenRenderer;
                (e = new $1g18o.Rive($a339acb540ac88ae$var$r($a339acb540ac88ae$var$r({
                    useOffscreenRenderer: o
                }, n), {
                    canvas: u
                }))).on($1g18o.EventType.Load, function() {
                    i = !0, u ? v(e) : e.cleanup();
                });
            }
            return function() {
                i || null == e || e.cleanup();
            };
        }
    }, [
        u,
        h,
        d
    ]);
    var R = $1oC0p.useCallback(function(e) {
        l.current = e;
    }, []), O = {
        observe: $1oC0p.useCallback(function(e, t) {
            $a339acb540ac88ae$var$C().registerCallback(e, t);
        }, []),
        unobserve: $1oC0p.useCallback(function(e) {
            $a339acb540ac88ae$var$C().removeCallback(e);
        }, [])
    }, x = O.observe, T = O.unobserve;
    $1oC0p.useEffect(function() {
        var e, t = !1, n = function() {
            if (u && t) {
                var e = u.getBoundingClientRect();
                e.width > 0 && e.height > 0 && e.top < (window.innerHeight || document.documentElement.clientHeight) && e.bottom > 0 && e.left < (window.innerWidth || document.documentElement.clientWidth) && e.right > 0 && (null == d || d.startRendering(), t = !1);
            }
        };
        return u && !1 !== p.shouldUseIntersectionObserver && x(u, function(i) {
            i.isIntersecting ? d && d.startRendering() : d && d.stopRendering(), t = !i.isIntersecting, clearTimeout(e), i.isIntersecting || 0 !== i.boundingClientRect.width || (e = setTimeout(n, 10));
        }), function() {
            u && T(u);
        };
    }, [
        x,
        T,
        d,
        u,
        p.shouldUseIntersectionObserver
    ]), $1oC0p.useEffect(function() {
        return function() {
            d && (d.cleanup(), v(null));
        };
    }, [
        d,
        u
    ]);
    var P = null == n ? void 0 : n.animations;
    $1oC0p.useEffect(function() {
        d && P && (d.isPlaying ? (d.stop(d.animationNames), d.play(P)) : d.isPaused && (d.stop(d.animationNames), d.pause(P)));
    }, [
        P,
        d
    ]);
    var L = $1oC0p.useCallback(function(e) {
        return $a339acb540ac88ae$var$i.default.createElement($a339acb540ac88ae$var$E, $a339acb540ac88ae$var$r({
            setContainerRef: R,
            setCanvasRef: m
        }, e));
    }, [
        m,
        R
    ]);
    return {
        canvas: u,
        container: l.current,
        setCanvasRef: m,
        setContainerRef: R,
        rive: d,
        RiveComponent: L
    };
}
module.exports.default = function(e) {
    var t = e.src, n = e.artboard, a = e.animations, u = e.stateMachines, s = e.layout, c = e.useOffscreenRenderer, l = void 0 === c || c, f = e.shouldDisableRiveListeners, d = void 0 !== f && f, v = e.shouldResizeCanvasToContainer, h = void 0 === v || v, p = e.automaticallyHandleEvents, b = void 0 !== p && p, w = e.children, y = $a339acb540ac88ae$var$o(e, [
        "src",
        "artboard",
        "animations",
        "stateMachines",
        "layout",
        "useOffscreenRenderer",
        "shouldDisableRiveListeners",
        "shouldResizeCanvasToContainer",
        "automaticallyHandleEvents",
        "children"
    ]), g = $a339acb540ac88ae$var$O({
        src: t,
        artboard: n,
        animations: a,
        layout: s,
        stateMachines: u,
        autoplay: !0,
        shouldDisableRiveListeners: d,
        automaticallyHandleEvents: b
    }, {
        useOffscreenRenderer: l,
        shouldResizeCanvasToContainer: h
    }).RiveComponent;
    return $a339acb540ac88ae$var$i.default.createElement(g, $a339acb540ac88ae$var$r({}, y), w);
}, module.exports.useResizeCanvas = $a339acb540ac88ae$var$w, module.exports.useRive = $a339acb540ac88ae$var$O, module.exports.useRiveFile = function(n) {
    var i = this, r = $1oC0p.useState(null), o = r[0], s = r[1], c = $1oC0p.useState("idle"), l = c[0], f = c[1];
    return $1oC0p.useEffect(function() {
        var e = null;
        return $a339acb540ac88ae$var$a(i, void 0, void 0, function() {
            return $a339acb540ac88ae$var$u(this, function(i) {
                try {
                    f("loading"), (e = new $1g18o.RiveFile(n)).init(), e.on($1g18o.EventType.Load, function() {
                        null == e || e.getInstance(), s(e), f("success");
                    }), e.on($1g18o.EventType.LoadError, function() {
                        f("failed");
                    }), s(e);
                } catch (e) {
                    console.error(e), f("failed");
                }
                return [
                    2
                ];
            });
        }), function() {
            null == e || e.cleanup();
        };
    }, [
        n.src,
        n.buffer
    ]), {
        riveFile: o,
        status: l
    };
}, module.exports.useStateMachineInput = function(n, i, r, o) {
    var a = $1oC0p.useState(null), u = a[0], s = a[1];
    return $1oC0p.useEffect(function() {
        function e() {
            if (n && i && r || s(null), n && i && r) {
                var e = n.stateMachineInputs(i);
                if (e) {
                    var t = e.find(function(e) {
                        return e.name === r;
                    });
                    void 0 !== o && t && (t.value = o), s(t || null);
                }
            } else s(null);
        }
        e(), n && n.on($1g18o.EventType.Load, function() {
            e();
        });
    }, [
        n
    ]), u;
}, Object.keys($1g18o).forEach(function(e) {
    "default" === e || module.exports.hasOwnProperty(e) || Object.defineProperty(module.exports, e, {
        enumerable: !0,
        get: function() {
            return $1g18o[e];
        }
    });
});

});
parcelRegister("1g18o", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                var Rive = (()=>{
                    var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
                    return function(moduleArg = {}) {
                        var m = moduleArg, aa, ea;
                        m.ready = new Promise((a, b)=>{
                            aa = a;
                            ea = b;
                        });
                        function fa() {
                            function a(g) {
                                const n = d;
                                c = b = 0;
                                d = new Map();
                                n.forEach((p)=>{
                                    try {
                                        p(g);
                                    } catch (l) {
                                        console.error(l);
                                    }
                                });
                                this.ob();
                                e && e.Tb();
                            }
                            let b = 0, c = 0, d = new Map(), e = null, f = null;
                            this.requestAnimationFrame = function(g) {
                                b || (b = requestAnimationFrame(a.bind(this)));
                                const n = ++c;
                                d.set(n, g);
                                return n;
                            };
                            this.cancelAnimationFrame = function(g) {
                                d.delete(g);
                                b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
                            };
                            this.Rb = function(g) {
                                f && (document.body.remove(f), f = null);
                                g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(n) {
                                    f.innerHTML = "RIVE FPS " + n.toFixed(1);
                                }, document.body.appendChild(f));
                                e = new function() {
                                    let n = 0, p = 0;
                                    this.Tb = function() {
                                        var l = performance.now();
                                        p ? (++n, l -= p, 1000 < l && (g(1000 * n / l), n = p = 0)) : (p = l, n = 0);
                                    };
                                }();
                            };
                            this.Ob = function() {
                                f && (document.body.remove(f), f = null);
                                e = null;
                            };
                            this.ob = function() {};
                        }
                        function ha(a) {
                            console.assert(!0);
                            const b = new Map();
                            let c = -Infinity;
                            this.push = function(d) {
                                d = d + ((1 << a) - 1) >> a;
                                b.has(d) && clearTimeout(b.get(d));
                                b.set(d, setTimeout(function() {
                                    b.delete(d);
                                    0 == b.length ? c = -Infinity : d == c && (c = Math.max(...b.keys()), console.assert(c < d));
                                }, 1000));
                                c = Math.max(d, c);
                                return c << a;
                            };
                        }
                        const ia = m.onRuntimeInitialized;
                        m.onRuntimeInitialized = function() {
                            ia && ia();
                            let a = m.decodeAudio;
                            m.decodeAudio = function(e, f) {
                                e = a(e);
                                f(e);
                            };
                            let b = m.decodeFont;
                            m.decodeFont = function(e, f) {
                                e = b(e);
                                f(e);
                            };
                            const c = m.FileAssetLoader;
                            m.ptrToAsset = (e)=>{
                                let f = m.ptrToFileAsset(e);
                                return f.isImage ? m.ptrToImageAsset(e) : f.isFont ? m.ptrToFontAsset(e) : f.isAudio ? m.ptrToAudioAsset(e) : f;
                            };
                            m.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {
                                __construct: function({ loadContents: e }) {
                                    this.__parent.__construct.call(this);
                                    this.Gb = e;
                                },
                                loadContents: function(e, f) {
                                    e = m.ptrToAsset(e);
                                    return this.Gb(e, f);
                                }
                            });
                            m.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                },
                                loadContents: function(e) {
                                    let f = m.ptrToAsset(e);
                                    e = f.cdnUuid;
                                    if ("" === e) return !1;
                                    (function(g, n) {
                                        var p = new XMLHttpRequest();
                                        p.responseType = "arraybuffer";
                                        p.onreadystatechange = function() {
                                            4 == p.readyState && 200 == p.status && n(p);
                                        };
                                        p.open("GET", g, !0);
                                        p.send(null);
                                    })(f.cdnBaseUrl + "/" + e, (g)=>{
                                        f.decode(new Uint8Array(g.response));
                                    });
                                    return !0;
                                }
                            });
                            m.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.kb = [];
                                },
                                addLoader: function(e) {
                                    this.kb.push(e);
                                },
                                loadContents: function(e, f) {
                                    for (let g of this.kb){
                                        if (g.loadContents(e, f)) return !0;
                                    }
                                    return !1;
                                }
                            });
                            let d = m.computeAlignment;
                            m.computeAlignment = function(e, f, g, n, p = 1.0) {
                                return d.call(this, e, f, g, n, p);
                            };
                        };
                        const ja = "createConicGradient createImageData createLinearGradient createPattern createRadialGradient getContextAttributes getImageData getLineDash getTransform isContextLost isPointInPath isPointInStroke measureText".split(" "), ka = new function() {
                            function a() {
                                if (!b) {
                                    var k = document.createElement("canvas"), t = {
                                        alpha: 1,
                                        depth: 0,
                                        stencil: 0,
                                        antialias: 0,
                                        premultipliedAlpha: 1,
                                        preserveDrawingBuffer: 0,
                                        powerPreference: "high-performance",
                                        failIfMajorPerformanceCaveat: 0,
                                        enableExtensionsByDefault: 1,
                                        explicitSwapControl: 1,
                                        renderViaOffscreenBackBuffer: 1
                                    };
                                    let r;
                                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                                        if (r = k.getContext("webgl", t), c = 1, !r) return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    } else if (r = k.getContext("webgl2", t)) c = 2;
                                    else {
                                        if (r = k.getContext("webgl", t)) c = 1;
                                        else return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    }
                                    r = new Proxy(r, {
                                        get (D, w) {
                                            if (D.isContextLost()) {
                                                if (p || (console.error("Cannot render the mesh because the GL Context was lost. Tried to invoke ", w), p = !0), "function" === typeof D[w]) return function() {};
                                            } else return "function" === typeof D[w] ? function(...M) {
                                                return D[w].apply(D, M);
                                            } : D[w];
                                        },
                                        set (D, w, M) {
                                            if (D.isContextLost()) p || (console.error("Cannot render the mesh because the GL Context was lost. Tried to set property " + w), p = !0);
                                            else return D[w] = M, !0;
                                        }
                                    });
                                    d = Math.min(r.getParameter(r.MAX_RENDERBUFFER_SIZE), r.getParameter(r.MAX_TEXTURE_SIZE));
                                    function B(D, w, M) {
                                        w = r.createShader(w);
                                        r.shaderSource(w, M);
                                        r.compileShader(w);
                                        M = r.getShaderInfoLog(w);
                                        if (0 < (M || "").length) throw M;
                                        r.attachShader(D, w);
                                    }
                                    k = r.createProgram();
                                    B(k, r.VERTEX_SHADER, "attribute vec2 vertex;\n                attribute vec2 uv;\n                uniform vec4 mat;\n                uniform vec2 translate;\n                varying vec2 st;\n                void main() {\n                    st = uv;\n                    gl_Position = vec4(mat2(mat) * vertex + translate, 0, 1);\n                }");
                                    B(k, r.FRAGMENT_SHADER, "precision highp float;\n                uniform sampler2D image;\n                varying vec2 st;\n                void main() {\n                    gl_FragColor = texture2D(image, st);\n                }");
                                    r.bindAttribLocation(k, 0, "vertex");
                                    r.bindAttribLocation(k, 1, "uv");
                                    r.linkProgram(k);
                                    t = r.getProgramInfoLog(k);
                                    if (0 < (t || "").trim().length) throw t;
                                    e = r.getUniformLocation(k, "mat");
                                    f = r.getUniformLocation(k, "translate");
                                    r.useProgram(k);
                                    r.bindBuffer(r.ARRAY_BUFFER, r.createBuffer());
                                    r.enableVertexAttribArray(0);
                                    r.enableVertexAttribArray(1);
                                    r.bindBuffer(r.ELEMENT_ARRAY_BUFFER, r.createBuffer());
                                    r.uniform1i(r.getUniformLocation(k, "image"), 0);
                                    r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0);
                                    b = r;
                                }
                                return !0;
                            }
                            let b = null, c = 0, d = 0, e = null, f = null, g = 0, n = 0, p = !1;
                            a();
                            this.hc = function() {
                                a();
                                return d;
                            };
                            this.Mb = function(k) {
                                b.deleteTexture && b.deleteTexture(k);
                            };
                            this.Lb = function(k) {
                                if (!a()) return null;
                                const t = b.createTexture();
                                if (!t) return null;
                                b.bindTexture(b.TEXTURE_2D, t);
                                b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, b.RGBA, b.UNSIGNED_BYTE, k);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_S, b.CLAMP_TO_EDGE);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_T, b.CLAMP_TO_EDGE);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MAG_FILTER, b.LINEAR);
                                2 == c ? (b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR_MIPMAP_LINEAR), b.generateMipmap(b.TEXTURE_2D)) : b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR);
                                return t;
                            };
                            const l = new ha(8), u = new ha(8), v = new ha(10), x = new ha(10);
                            this.Qb = function(k, t, r, B, D) {
                                if (a()) {
                                    var w = l.push(k), M = u.push(t);
                                    if (b.canvas) {
                                        if (b.canvas.width != w || b.canvas.height != M) b.canvas.width = w, b.canvas.height = M;
                                        b.viewport(0, M - t, k, t);
                                        b.disable(b.SCISSOR_TEST);
                                        b.clearColor(0, 0, 0, 0);
                                        b.clear(b.COLOR_BUFFER_BIT);
                                        b.enable(b.SCISSOR_TEST);
                                        r.sort((H, ba)=>ba.wb - H.wb);
                                        w = v.push(B);
                                        g != w && (b.bufferData(b.ARRAY_BUFFER, 8 * w, b.DYNAMIC_DRAW), g = w);
                                        w = 0;
                                        for (var T of r)b.bufferSubData(b.ARRAY_BUFFER, w, T.Ta), w += 4 * T.Ta.length;
                                        console.assert(w == 4 * B);
                                        for (var ca of r)b.bufferSubData(b.ARRAY_BUFFER, w, ca.Db), w += 4 * ca.Db.length;
                                        console.assert(w == 8 * B);
                                        w = x.push(D);
                                        n != w && (b.bufferData(b.ELEMENT_ARRAY_BUFFER, 2 * w, b.DYNAMIC_DRAW), n = w);
                                        T = 0;
                                        for (var ra of r)b.bufferSubData(b.ELEMENT_ARRAY_BUFFER, T, ra.indices), T += 2 * ra.indices.length;
                                        console.assert(T == 2 * D);
                                        ra = 0;
                                        ca = !0;
                                        w = T = 0;
                                        for (const H of r){
                                            H.image.Ka != ra && (b.bindTexture(b.TEXTURE_2D, H.image.Ja || null), ra = H.image.Ka);
                                            H.mc ? (b.scissor(H.Ya, M - H.Za - H.jb, H.Ac, H.jb), ca = !0) : ca && (b.scissor(0, M - t, k, t), ca = !1);
                                            r = 2 / k;
                                            const ba = -2 / t;
                                            b.uniform4f(e, H.ha[0] * r * H.Ba, H.ha[1] * ba * H.Ca, H.ha[2] * r * H.Ba, H.ha[3] * ba * H.Ca);
                                            b.uniform2f(f, H.ha[4] * r * H.Ba + r * (H.Ya - H.ic * H.Ba) - 1, H.ha[5] * ba * H.Ca + ba * (H.Za - H.jc * H.Ca) + 1);
                                            b.vertexAttribPointer(0, 2, b.FLOAT, !1, 0, w);
                                            b.vertexAttribPointer(1, 2, b.FLOAT, !1, 0, w + 4 * B);
                                            b.drawElements(b.TRIANGLES, H.indices.length, b.UNSIGNED_SHORT, T);
                                            w += 4 * H.Ta.length;
                                            T += 2 * H.indices.length;
                                        }
                                        console.assert(w == 4 * B);
                                        console.assert(T == 2 * D);
                                    }
                                }
                            };
                            this.canvas = function() {
                                return a() && b.canvas;
                            };
                        }(), la = m.onRuntimeInitialized;
                        m.onRuntimeInitialized = function() {
                            function a(q) {
                                switch(q){
                                    case l.srcOver:
                                        return "source-over";
                                    case l.screen:
                                        return "screen";
                                    case l.overlay:
                                        return "overlay";
                                    case l.darken:
                                        return "darken";
                                    case l.lighten:
                                        return "lighten";
                                    case l.colorDodge:
                                        return "color-dodge";
                                    case l.colorBurn:
                                        return "color-burn";
                                    case l.hardLight:
                                        return "hard-light";
                                    case l.softLight:
                                        return "soft-light";
                                    case l.difference:
                                        return "difference";
                                    case l.exclusion:
                                        return "exclusion";
                                    case l.multiply:
                                        return "multiply";
                                    case l.hue:
                                        return "hue";
                                    case l.saturation:
                                        return "saturation";
                                    case l.color:
                                        return "color";
                                    case l.luminosity:
                                        return "luminosity";
                                }
                            }
                            function b(q) {
                                return "rgba(" + ((16711680 & q) >>> 16) + "," + ((65280 & q) >>> 8) + "," + ((255 & q) >>> 0) + "," + ((4278190080 & q) >>> 24) / 255 + ")";
                            }
                            function c() {
                                0 < M.length && (ka.Qb(w.drawWidth(), w.drawHeight(), M, T, ca), M = [], ca = T = 0, w.reset(512, 512));
                                for (const q of D){
                                    for (const y of q.H)y();
                                    q.H = [];
                                }
                                D.clear();
                            }
                            la && la();
                            var d = m.RenderPaintStyle;
                            const e = m.RenderPath, f = m.RenderPaint, g = m.Renderer, n = m.StrokeCap, p = m.StrokeJoin, l = m.BlendMode, u = d.fill, v = d.stroke, x = m.FillRule.evenOdd;
                            let k = 1;
                            var t = m.RenderImage.extend("CanvasRenderImage", {
                                __construct: function({ la: q, xa: y } = {}) {
                                    this.__parent.__construct.call(this);
                                    this.Ka = k;
                                    k = k + 1 & 2147483647 || 1;
                                    this.la = q;
                                    this.xa = y;
                                },
                                __destruct: function() {
                                    this.Ja && (ka.Mb(this.Ja), URL.revokeObjectURL(this.Wa));
                                    this.__parent.__destruct.call(this);
                                },
                                decode: function(q) {
                                    var y = this;
                                    y.xa && y.xa(y);
                                    var F = new Image();
                                    y.Wa = URL.createObjectURL(new Blob([
                                        q
                                    ], {
                                        type: "image/png"
                                    }));
                                    F.onload = function() {
                                        y.Fb = F;
                                        y.Ja = ka.Lb(F);
                                        y.size(F.width, F.height);
                                        y.la && y.la(y);
                                    };
                                    F.src = y.Wa;
                                }
                            }), r = e.extend("CanvasRenderPath", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.T = new Path2D();
                                },
                                rewind: function() {
                                    this.T = new Path2D();
                                },
                                addPath: function(q, y, F, G, A, I, J) {
                                    var K = this.T, X = K.addPath;
                                    q = q.T;
                                    const Q = new DOMMatrix();
                                    Q.a = y;
                                    Q.b = F;
                                    Q.c = G;
                                    Q.d = A;
                                    Q.e = I;
                                    Q.f = J;
                                    X.call(K, q, Q);
                                },
                                fillRule: function(q) {
                                    this.Va = q;
                                },
                                moveTo: function(q, y) {
                                    this.T.moveTo(q, y);
                                },
                                lineTo: function(q, y) {
                                    this.T.lineTo(q, y);
                                },
                                cubicTo: function(q, y, F, G, A, I) {
                                    this.T.bezierCurveTo(q, y, F, G, A, I);
                                },
                                close: function() {
                                    this.T.closePath();
                                }
                            }), B = f.extend("CanvasRenderPaint", {
                                color: function(q) {
                                    this.Xa = b(q);
                                },
                                thickness: function(q) {
                                    this.Ib = q;
                                },
                                join: function(q) {
                                    switch(q){
                                        case p.miter:
                                            this.Ia = "miter";
                                            break;
                                        case p.round:
                                            this.Ia = "round";
                                            break;
                                        case p.bevel:
                                            this.Ia = "bevel";
                                    }
                                },
                                cap: function(q) {
                                    switch(q){
                                        case n.butt:
                                            this.Ha = "butt";
                                            break;
                                        case n.round:
                                            this.Ha = "round";
                                            break;
                                        case n.square:
                                            this.Ha = "square";
                                    }
                                },
                                style: function(q) {
                                    this.Hb = q;
                                },
                                blendMode: function(q) {
                                    this.Eb = a(q);
                                },
                                clearGradient: function() {
                                    this.ja = null;
                                },
                                linearGradient: function(q, y, F, G) {
                                    this.ja = {
                                        yb: q,
                                        zb: y,
                                        bb: F,
                                        cb: G,
                                        Ra: []
                                    };
                                },
                                radialGradient: function(q, y, F, G) {
                                    this.ja = {
                                        yb: q,
                                        zb: y,
                                        bb: F,
                                        cb: G,
                                        Ra: [],
                                        ec: !0
                                    };
                                },
                                addStop: function(q, y) {
                                    this.ja.Ra.push({
                                        color: q,
                                        stop: y
                                    });
                                },
                                completeGradient: function() {},
                                draw: function(q, y, F) {
                                    let G = this.Hb;
                                    var A = this.Xa, I = this.ja;
                                    q.globalCompositeOperation = this.Eb;
                                    if (null != I) {
                                        A = I.yb;
                                        var J = I.zb;
                                        const X = I.bb;
                                        var K = I.cb;
                                        const Q = I.Ra;
                                        I.ec ? (I = X - A, K -= J, A = q.createRadialGradient(A, J, 0, A, J, Math.sqrt(I * I + K * K))) : A = q.createLinearGradient(A, J, X, K);
                                        for(let da = 0, R = Q.length; da < R; da++)J = Q[da], A.addColorStop(J.stop, b(J.color));
                                        this.Xa = A;
                                        this.ja = null;
                                    }
                                    switch(G){
                                        case v:
                                            q.strokeStyle = A;
                                            q.lineWidth = this.Ib;
                                            q.lineCap = this.Ha;
                                            q.lineJoin = this.Ia;
                                            q.stroke(y);
                                            break;
                                        case u:
                                            q.fillStyle = A, q.fill(y, F);
                                    }
                                }
                            });
                            const D = new Set();
                            let w = null, M = [], T = 0, ca = 0;
                            var ra = m.CanvasRenderer = g.extend("Renderer", {
                                __construct: function(q) {
                                    this.__parent.__construct.call(this);
                                    this.S = [
                                        1,
                                        0,
                                        0,
                                        1,
                                        0,
                                        0
                                    ];
                                    this.C = q.getContext("2d");
                                    this.Ua = q;
                                    this.H = [];
                                },
                                save: function() {
                                    this.S.push(...this.S.slice(this.S.length - 6));
                                    this.H.push(this.C.save.bind(this.C));
                                },
                                restore: function() {
                                    const q = this.S.length - 6;
                                    if (6 > q) throw "restore() called without matching save().";
                                    this.S.splice(q);
                                    this.H.push(this.C.restore.bind(this.C));
                                },
                                transform: function(q, y, F, G, A, I) {
                                    const J = this.S, K = J.length - 6;
                                    J.splice(K, 6, J[K] * q + J[K + 2] * y, J[K + 1] * q + J[K + 3] * y, J[K] * F + J[K + 2] * G, J[K + 1] * F + J[K + 3] * G, J[K] * A + J[K + 2] * I + J[K + 4], J[K + 1] * A + J[K + 3] * I + J[K + 5]);
                                    this.H.push(this.C.transform.bind(this.C, q, y, F, G, A, I));
                                },
                                rotate: function(q) {
                                    const y = Math.sin(q);
                                    q = Math.cos(q);
                                    this.transform(q, y, -y, q, 0, 0);
                                },
                                _drawPath: function(q, y) {
                                    this.H.push(y.draw.bind(y, this.C, q.T, q.Va === x ? "evenodd" : "nonzero"));
                                },
                                _drawRiveImage: function(q, y, F) {
                                    var G = q.Fb;
                                    if (G) {
                                        var A = this.C, I = a(y);
                                        this.H.push(function() {
                                            A.globalCompositeOperation = I;
                                            A.globalAlpha = F;
                                            A.drawImage(G, 0, 0);
                                            A.globalAlpha = 1;
                                        });
                                    }
                                },
                                _getMatrix: function(q) {
                                    const y = this.S, F = y.length - 6;
                                    for(let G = 0; 6 > G; ++G)q[G] = y[F + G];
                                },
                                _drawImageMesh: function(q, y, F, G, A, I, J, K, X, Q) {
                                    var da = this.C.canvas.width, R = this.C.canvas.height;
                                    const Yb = X - J, Zb = Q - K;
                                    J = Math.max(J, 0);
                                    K = Math.max(K, 0);
                                    X = Math.min(X, da);
                                    Q = Math.min(Q, R);
                                    const Ga = X - J, Ha = Q - K;
                                    console.assert(Ga <= Math.min(Yb, da));
                                    console.assert(Ha <= Math.min(Zb, R));
                                    if (!(0 >= Ga || 0 >= Ha)) {
                                        X = Ga < Yb || Ha < Zb;
                                        da = Q = 1;
                                        var sa = Math.ceil(Ga * Q), ta = Math.ceil(Ha * da);
                                        R = ka.hc();
                                        sa > R && (Q *= R / sa, sa = R);
                                        ta > R && (da *= R / ta, ta = R);
                                        w || (w = new m.DynamicRectanizer(R), w.reset(512, 512));
                                        R = w.addRect(sa, ta);
                                        0 > R && (c(), D.add(this), R = w.addRect(sa, ta), console.assert(0 <= R));
                                        var $b = R & 65535, ac = R >> 16;
                                        M.push({
                                            ha: this.S.slice(this.S.length - 6),
                                            image: q,
                                            Ya: $b,
                                            Za: ac,
                                            ic: J,
                                            jc: K,
                                            Ac: sa,
                                            jb: ta,
                                            Ba: Q,
                                            Ca: da,
                                            Ta: new Float32Array(G),
                                            Db: new Float32Array(A),
                                            indices: new Uint16Array(I),
                                            mc: X,
                                            wb: q.Ka << 1 | (X ? 1 : 0)
                                        });
                                        T += G.length;
                                        ca += I.length;
                                        var za = this.C, qd = a(y);
                                        this.H.push(function() {
                                            za.save();
                                            za.resetTransform();
                                            za.globalCompositeOperation = qd;
                                            za.globalAlpha = F;
                                            const bc = ka.canvas();
                                            bc && za.drawImage(bc, $b, ac, sa, ta, J, K, Ga, Ha);
                                            za.restore();
                                        });
                                    }
                                },
                                _clipPath: function(q) {
                                    this.H.push(this.C.clip.bind(this.C, q.T, q.Va === x ? "evenodd" : "nonzero"));
                                },
                                clear: function() {
                                    D.add(this);
                                    this.H.push(this.C.clearRect.bind(this.C, 0, 0, this.Ua.width, this.Ua.height));
                                },
                                flush: function() {},
                                translate: function(q, y) {
                                    this.transform(1, 0, 0, 1, q, y);
                                }
                            });
                            m.makeRenderer = function(q) {
                                const y = new ra(q), F = y.C;
                                return new Proxy(y, {
                                    get (G, A) {
                                        if ("function" === typeof G[A]) return function(...I) {
                                            return G[A].apply(G, I);
                                        };
                                        if ("function" === typeof F[A]) {
                                            if (-1 < ja.indexOf(A)) throw Error("RiveException: Method call to '" + A + "()' is not allowed, as the renderer cannot immediately pass through the return                 values of any canvas 2d context methods.");
                                            return function(...I) {
                                                y.H.push(F[A].bind(F, ...I));
                                            };
                                        }
                                        return G[A];
                                    },
                                    set (G, A, I) {
                                        if (A in F) return y.H.push(()=>{
                                            F[A] = I;
                                        }), !0;
                                    }
                                });
                            };
                            m.decodeImage = function(q, y) {
                                new t({
                                    la: y
                                }).decode(q);
                            };
                            m.renderFactory = {
                                makeRenderPaint: function() {
                                    return new B();
                                },
                                makeRenderPath: function() {
                                    return new r();
                                },
                                makeRenderImage: function() {
                                    let q = ba;
                                    return new t({
                                        xa: ()=>{
                                            q.total++;
                                        },
                                        la: ()=>{
                                            q.loaded++;
                                            if (q.loaded === q.total) {
                                                const y = q.ready;
                                                y && (y(), q.ready = null);
                                            }
                                        }
                                    });
                                }
                            };
                            let H = m.load, ba = null;
                            m.load = function(q, y, F = !0) {
                                const G = new m.FallbackFileAssetLoader();
                                void 0 !== y && G.addLoader(y);
                                F && (y = new m.CDNFileAssetLoader(), G.addLoader(y));
                                return new Promise(function(A) {
                                    let I = null;
                                    ba = {
                                        total: 0,
                                        loaded: 0,
                                        ready: function() {
                                            A(I);
                                        }
                                    };
                                    I = H(q, G);
                                    0 == ba.total && A(I);
                                });
                            };
                            let rd = m.RendererWrapper.prototype.align;
                            m.RendererWrapper.prototype.align = function(q, y, F, G, A = 1.0) {
                                rd.call(this, q, y, F, G, A);
                            };
                            d = new fa();
                            m.requestAnimationFrame = d.requestAnimationFrame.bind(d);
                            m.cancelAnimationFrame = d.cancelAnimationFrame.bind(d);
                            m.enableFPSCounter = d.Rb.bind(d);
                            m.disableFPSCounter = d.Ob;
                            d.ob = c;
                            m.resolveAnimationFrame = c;
                            m.cleanup = function() {
                                w && w.delete();
                            };
                        };
                        var ma = Object.assign({}, m), na = "./this.program", oa = "object" == typeof window, pa = "function" == typeof importScripts, qa = "", ua, va;
                        if (oa || pa) pa ? qa = self.location.href : "undefined" != typeof document && document.currentScript && (qa = document.currentScript.src), _scriptDir && (qa = _scriptDir), 0 !== qa.indexOf("blob:") ? qa = qa.substr(0, qa.replace(/[?#].*/, "").lastIndexOf("/") + 1) : qa = "", pa && (va = (a)=>{
                            var b = new XMLHttpRequest();
                            b.open("GET", a, !1);
                            b.responseType = "arraybuffer";
                            b.send(null);
                            return new Uint8Array(b.response);
                        }), ua = (a, b, c)=>{
                            var d = new XMLHttpRequest();
                            d.open("GET", a, !0);
                            d.responseType = "arraybuffer";
                            d.onload = ()=>{
                                200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
                            };
                            d.onerror = c;
                            d.send(null);
                        };
                        var wa = m.print || console.log.bind(console), xa = m.printErr || console.error.bind(console);
                        Object.assign(m, ma);
                        ma = null;
                        m.thisProgram && (na = m.thisProgram);
                        var ya;
                        m.wasmBinary && (ya = m.wasmBinary);
                        var noExitRuntime = m.noExitRuntime || !0;
                        "object" != typeof WebAssembly && Aa("no native wasm support detected");
                        var Ba, z, Ca = !1, C, E, Da, Ea, L, N, Fa, Ia;
                        function Ja() {
                            var a = Ba.buffer;
                            m.HEAP8 = C = new Int8Array(a);
                            m.HEAP16 = Da = new Int16Array(a);
                            m.HEAP32 = L = new Int32Array(a);
                            m.HEAPU8 = E = new Uint8Array(a);
                            m.HEAPU16 = Ea = new Uint16Array(a);
                            m.HEAPU32 = N = new Uint32Array(a);
                            m.HEAPF32 = Fa = new Float32Array(a);
                            m.HEAPF64 = Ia = new Float64Array(a);
                        }
                        var Ka, La = [], Ma = [], Na = [];
                        function Oa() {
                            var a = m.preRun.shift();
                            La.unshift(a);
                        }
                        var Pa = 0, Qa = null, Ra = null;
                        function Aa(a) {
                            if (m.onAbort) m.onAbort(a);
                            a = "Aborted(" + a + ")";
                            xa(a);
                            Ca = !0;
                            a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
                            ea(a);
                            throw a;
                        }
                        function Sa(a) {
                            return a.startsWith("data:application/octet-stream;base64,");
                        }
                        var Ta;
                        Ta = "canvas_advanced.wasm";
                        if (!Sa(Ta)) {
                            var Ua = Ta;
                            Ta = m.locateFile ? m.locateFile(Ua, qa) : qa + Ua;
                        }
                        function Va(a) {
                            if (a == Ta && ya) return new Uint8Array(ya);
                            if (va) return va(a);
                            throw "both async and sync fetching of the wasm failed";
                        }
                        function Wa(a) {
                            if (!ya && (oa || pa)) {
                                if ("function" == typeof fetch && !a.startsWith("file://")) return fetch(a, {
                                    credentials: "same-origin"
                                }).then((b)=>{
                                    if (!b.ok) throw "failed to load wasm binary file at '" + a + "'";
                                    return b.arrayBuffer();
                                }).catch(()=>Va(a));
                                if (ua) return new Promise((b, c)=>{
                                    ua(a, (d)=>b(new Uint8Array(d)), c);
                                });
                            }
                            return Promise.resolve().then(()=>Va(a));
                        }
                        function Xa(a, b, c) {
                            return Wa(a).then((d)=>WebAssembly.instantiate(d, b)).then((d)=>d).then(c, (d)=>{
                                xa("failed to asynchronously prepare wasm: " + d);
                                Aa(d);
                            });
                        }
                        function Ya(a, b) {
                            var c = Ta;
                            return ya || "function" != typeof WebAssembly.instantiateStreaming || Sa(c) || c.startsWith("file://") || "function" != typeof fetch ? Xa(c, a, b) : fetch(c, {
                                credentials: "same-origin"
                            }).then((d)=>WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
                                    xa("wasm streaming compile failed: " + e);
                                    xa("falling back to ArrayBuffer instantiation");
                                    return Xa(c, a, b);
                                }));
                        }
                        var Za, $a, db = {
                            448252: (a, b, c, d, e)=>{
                                if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) return 0;
                                if ("undefined" === typeof window.h) {
                                    window.h = {
                                        Aa: 0
                                    };
                                    window.h.I = {};
                                    window.h.I.ya = a;
                                    window.h.I.capture = b;
                                    window.h.I.La = c;
                                    window.h.ga = {};
                                    window.h.ga.stopped = d;
                                    window.h.ga.xb = e;
                                    let f = window.h;
                                    f.D = [];
                                    f.yc = function(g) {
                                        for(var n = 0; n < f.D.length; ++n){
                                            if (null == f.D[n]) return f.D[n] = g, n;
                                        }
                                        f.D.push(g);
                                        return f.D.length - 1;
                                    };
                                    f.Cb = function(g) {
                                        for(f.D[g] = null; 0 < f.D.length;){
                                            if (null == f.D[f.D.length - 1]) f.D.pop();
                                            else break;
                                        }
                                    };
                                    f.Sc = function(g) {
                                        for(var n = 0; n < f.D.length; ++n){
                                            if (f.D[n] == g) return f.Cb(n);
                                        }
                                    };
                                    f.ra = function(g) {
                                        return f.D[g];
                                    };
                                    f.Bb = [
                                        "touchend",
                                        "click"
                                    ];
                                    f.unlock = function() {
                                        for(var g = 0; g < f.D.length; ++g){
                                            var n = f.D[g];
                                            null != n && null != n.J && n.state === f.ga.xb && n.J.resume().then(()=>{
                                                ab(n.pb);
                                            }, (p)=>{
                                                console.error("Failed to resume audiocontext", p);
                                            });
                                        }
                                        f.Bb.map(function(p) {
                                            document.removeEventListener(p, f.unlock, !0);
                                        });
                                    };
                                    f.Bb.map(function(g) {
                                        document.addEventListener(g, f.unlock, !0);
                                    });
                                }
                                window.h.Aa += 1;
                                return 1;
                            },
                            450430: ()=>{
                                "undefined" !== typeof window.h && (--window.h.Aa, 0 === window.h.Aa && delete window.h);
                            },
                            450594: ()=>void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia,
                            450698: ()=>{
                                try {
                                    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
                                    a.close();
                                    return b;
                                } catch (c) {
                                    return 0;
                                }
                            },
                            450869: (a, b, c, d, e, f)=>{
                                if ("undefined" === typeof window.h) return -1;
                                var g = {}, n = {};
                                a == window.h.I.ya && 0 != c && (n.sampleRate = c);
                                g.J = new (window.AudioContext || window.webkitAudioContext)(n);
                                g.J.suspend();
                                g.state = window.h.ga.stopped;
                                c = 0;
                                a != window.h.I.ya && (c = b);
                                g.Z = g.J.createScriptProcessor(d, c, b);
                                g.Z.onaudioprocess = function(p) {
                                    if (null == g.sa || 0 == g.sa.length) g.sa = new Float32Array(Fa.buffer, e, d * b);
                                    if (a == window.h.I.capture || a == window.h.I.La) {
                                        for(var l = 0; l < b; l += 1)for(var u = p.inputBuffer.getChannelData(l), v = g.sa, x = 0; x < d; x += 1)v[x * b + l] = u[x];
                                        bb(f, d, e);
                                    }
                                    if (a == window.h.I.ya || a == window.h.I.La) {
                                        for(cb(f, d, e), l = 0; l < p.outputBuffer.numberOfChannels; ++l)for(u = p.outputBuffer.getChannelData(l), v = g.sa, x = 0; x < d; x += 1)u[x] = v[x * b + l];
                                    } else for(l = 0; l < p.outputBuffer.numberOfChannels; ++l)p.outputBuffer.getChannelData(l).fill(0.0);
                                };
                                a != window.h.I.capture && a != window.h.I.La || navigator.mediaDevices.getUserMedia({
                                    audio: !0,
                                    video: !1
                                }).then(function(p) {
                                    g.Da = g.J.createMediaStreamSource(p);
                                    g.Da.connect(g.Z);
                                    g.Z.connect(g.J.destination);
                                }).catch(function(p) {
                                    console.log("Failed to get user media: " + p);
                                });
                                a == window.h.I.ya && g.Z.connect(g.J.destination);
                                g.pb = f;
                                return window.h.yc(g);
                            },
                            453746: (a)=>window.h.ra(a).J.sampleRate,
                            453819: (a)=>{
                                a = window.h.ra(a);
                                void 0 !== a.Z && (a.Z.onaudioprocess = function() {}, a.Z.disconnect(), a.Z = void 0);
                                void 0 !== a.Da && (a.Da.disconnect(), a.Da = void 0);
                                a.J.close();
                                a.J = void 0;
                                a.pb = void 0;
                            },
                            454219: (a)=>{
                                window.h.Cb(a);
                            },
                            454269: (a)=>{
                                a = window.h.ra(a);
                                a.J.resume();
                                a.state = window.h.ga.xb;
                            },
                            454408: (a)=>{
                                a = window.h.ra(a);
                                a.J.suspend();
                                a.state = window.h.ga.stopped;
                            }
                        }, eb = (a)=>{
                            for(; 0 < a.length;)a.shift()(m);
                        }, fb = (a, b)=>{
                            for(var c = 0, d = a.length - 1; 0 <= d; d--){
                                var e = a[d];
                                "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
                            }
                            if (b) for(; c; c--)a.unshift("..");
                            return a;
                        }, gb = (a)=>{
                            var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
                            (a = fb(a.split("/").filter((d)=>!!d), !b).join("/")) || b || (a = ".");
                            a && c && (a += "/");
                            return (b ? "/" : "") + a;
                        }, hb = (a)=>{
                            var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
                            a = b[0];
                            b = b[1];
                            if (!a && !b) return ".";
                            b && (b = b.substr(0, b.length - 1));
                            return a + b;
                        }, ib = (a)=>{
                            if ("/" === a) return "/";
                            a = gb(a);
                            a = a.replace(/\/$/, "");
                            var b = a.lastIndexOf("/");
                            return -1 === b ? a : a.substr(b + 1);
                        }, jb = ()=>{
                            if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) return (a)=>crypto.getRandomValues(a);
                            Aa("initRandomDevice");
                        }, kb = (a)=>(kb = jb())(a);
                        function lb() {
                            for(var a = "", b = !1, c = arguments.length - 1; -1 <= c && !b; c--){
                                b = 0 <= c ? arguments[c] : "/";
                                if ("string" != typeof b) throw new TypeError("Arguments to path.resolve must be strings");
                                if (!b) return "";
                                a = b + "/" + a;
                                b = "/" === b.charAt(0);
                            }
                            a = fb(a.split("/").filter((d)=>!!d), !b).join("/");
                            return (b ? "/" : "") + a || ".";
                        }
                        var mb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, nb = (a, b, c)=>{
                            var d = b + c;
                            for(c = b; a[c] && !(c >= d);)++c;
                            if (16 < c - b && a.buffer && mb) return mb.decode(a.subarray(b, c));
                            for(d = ""; b < c;){
                                var e = a[b++];
                                if (e & 128) {
                                    var f = a[b++] & 63;
                                    if (192 == (e & 224)) d += String.fromCharCode((e & 31) << 6 | f);
                                    else {
                                        var g = a[b++] & 63;
                                        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
                                        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
                                    }
                                } else d += String.fromCharCode(e);
                            }
                            return d;
                        }, ob = [], pb = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
                            }
                            return b;
                        }, qb = (a, b, c, d)=>{
                            if (!(0 < d)) return 0;
                            var e = c;
                            d = c + d - 1;
                            for(var f = 0; f < a.length; ++f){
                                var g = a.charCodeAt(f);
                                if (55296 <= g && 57343 >= g) {
                                    var n = a.charCodeAt(++f);
                                    g = 65536 + ((g & 1023) << 10) | n & 1023;
                                }
                                if (127 >= g) {
                                    if (c >= d) break;
                                    b[c++] = g;
                                } else {
                                    if (2047 >= g) {
                                        if (c + 1 >= d) break;
                                        b[c++] = 192 | g >> 6;
                                    } else {
                                        if (65535 >= g) {
                                            if (c + 2 >= d) break;
                                            b[c++] = 224 | g >> 12;
                                        } else {
                                            if (c + 3 >= d) break;
                                            b[c++] = 240 | g >> 18;
                                            b[c++] = 128 | g >> 12 & 63;
                                        }
                                        b[c++] = 128 | g >> 6 & 63;
                                    }
                                    b[c++] = 128 | g & 63;
                                }
                            }
                            b[c] = 0;
                            return c - e;
                        };
                        function rb(a, b) {
                            var c = Array(pb(a) + 1);
                            a = qb(a, c, 0, c.length);
                            b && (c.length = a);
                            return c;
                        }
                        var sb = [];
                        function tb(a, b) {
                            sb[a] = {
                                input: [],
                                F: [],
                                V: b
                            };
                            ub(a, vb);
                        }
                        var vb = {
                            open: function(a) {
                                var b = sb[a.node.za];
                                if (!b) throw new O(43);
                                a.s = b;
                                a.seekable = !1;
                            },
                            close: function(a) {
                                a.s.V.qa(a.s);
                            },
                            qa: function(a) {
                                a.s.V.qa(a.s);
                            },
                            read: function(a, b, c, d) {
                                if (!a.s || !a.s.V.ib) throw new O(60);
                                for(var e = 0, f = 0; f < d; f++){
                                    try {
                                        var g = a.s.V.ib(a.s);
                                    } catch (n) {
                                        throw new O(29);
                                    }
                                    if (void 0 === g && 0 === e) throw new O(6);
                                    if (null === g || void 0 === g) break;
                                    e++;
                                    b[c + f] = g;
                                }
                                e && (a.node.timestamp = Date.now());
                                return e;
                            },
                            write: function(a, b, c, d) {
                                if (!a.s || !a.s.V.Oa) throw new O(60);
                                try {
                                    for(var e = 0; e < d; e++)a.s.V.Oa(a.s, b[c + e]);
                                } catch (f) {
                                    throw new O(29);
                                }
                                d && (a.node.timestamp = Date.now());
                                return e;
                            }
                        }, wb = {
                            ib: function() {
                                a: {
                                    if (!ob.length) {
                                        var a = null;
                                        "undefined" != typeof window && "function" == typeof window.prompt ? (a = window.prompt("Input: "), null !== a && (a += "\n")) : "function" == typeof readline && (a = readline(), null !== a && (a += "\n"));
                                        if (!a) {
                                            a = null;
                                            break a;
                                        }
                                        ob = rb(a, !0);
                                    }
                                    a = ob.shift();
                                }
                                return a;
                            },
                            Oa: function(a, b) {
                                null === b || 10 === b ? (wa(nb(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
                            },
                            qa: function(a) {
                                a.F && 0 < a.F.length && (wa(nb(a.F, 0)), a.F = []);
                            },
                            bc: function() {
                                return {
                                    Fc: 25856,
                                    Hc: 5,
                                    Ec: 191,
                                    Gc: 35387,
                                    Dc: [
                                        3,
                                        28,
                                        127,
                                        21,
                                        4,
                                        0,
                                        1,
                                        0,
                                        17,
                                        19,
                                        26,
                                        0,
                                        18,
                                        15,
                                        23,
                                        22,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ]
                                };
                            },
                            cc: function() {
                                return 0;
                            },
                            dc: function() {
                                return [
                                    24,
                                    80
                                ];
                            }
                        }, xb = {
                            Oa: function(a, b) {
                                null === b || 10 === b ? (xa(nb(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
                            },
                            qa: function(a) {
                                a.F && 0 < a.F.length && (xa(nb(a.F, 0)), a.F = []);
                            }
                        };
                        function yb(a, b) {
                            var c = a.j ? a.j.length : 0;
                            c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.j, a.j = new Uint8Array(b), 0 < a.v && a.j.set(c.subarray(0, a.v), 0));
                        }
                        var P = {
                            O: null,
                            U () {
                                return P.createNode(null, "/", 16895, 0);
                            },
                            createNode (a, b, c, d) {
                                if (24576 === (c & 61440) || 4096 === (c & 61440)) throw new O(63);
                                P.O || (P.O = {
                                    dir: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P,
                                            ka: P.l.ka,
                                            va: P.l.va,
                                            ub: P.l.ub,
                                            Ab: P.l.Ab,
                                            vb: P.l.vb,
                                            sb: P.l.sb,
                                            Ea: P.l.Ea
                                        },
                                        stream: {
                                            ba: P.m.ba
                                        }
                                    },
                                    file: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P
                                        },
                                        stream: {
                                            ba: P.m.ba,
                                            read: P.m.read,
                                            write: P.m.write,
                                            pa: P.m.pa,
                                            lb: P.m.lb,
                                            nb: P.m.nb
                                        }
                                    },
                                    link: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P,
                                            ma: P.l.ma
                                        },
                                        stream: {}
                                    },
                                    $a: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P
                                        },
                                        stream: zb
                                    }
                                });
                                c = Ab(a, b, c, d);
                                16384 === (c.mode & 61440) ? (c.l = P.O.dir.node, c.m = P.O.dir.stream, c.j = {}) : 32768 === (c.mode & 61440) ? (c.l = P.O.file.node, c.m = P.O.file.stream, c.v = 0, c.j = null) : 40960 === (c.mode & 61440) ? (c.l = P.O.link.node, c.m = P.O.link.stream) : 8192 === (c.mode & 61440) && (c.l = P.O.$a.node, c.m = P.O.$a.stream);
                                c.timestamp = Date.now();
                                a && (a.j[b] = c, a.timestamp = c.timestamp);
                                return c;
                            },
                            Kc (a) {
                                return a.j ? a.j.subarray ? a.j.subarray(0, a.v) : new Uint8Array(a.j) : new Uint8Array(0);
                            },
                            l: {
                                Y (a) {
                                    var b = {};
                                    b.Jc = 8192 === (a.mode & 61440) ? a.id : 1;
                                    b.Mc = a.id;
                                    b.mode = a.mode;
                                    b.Oc = 1;
                                    b.uid = 0;
                                    b.Lc = 0;
                                    b.za = a.za;
                                    16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
                                    b.Bc = new Date(a.timestamp);
                                    b.Nc = new Date(a.timestamp);
                                    b.Ic = new Date(a.timestamp);
                                    b.Jb = 4096;
                                    b.Cc = Math.ceil(b.size / b.Jb);
                                    return b;
                                },
                                P (a, b) {
                                    void 0 !== b.mode && (a.mode = b.mode);
                                    void 0 !== b.timestamp && (a.timestamp = b.timestamp);
                                    if (void 0 !== b.size && (b = b.size, a.v != b)) {
                                        if (0 == b) a.j = null, a.v = 0;
                                        else {
                                            var c = a.j;
                                            a.j = new Uint8Array(b);
                                            c && a.j.set(c.subarray(0, Math.min(b, a.v)));
                                            a.v = b;
                                        }
                                    }
                                },
                                ka () {
                                    throw Bb[44];
                                },
                                va (a, b, c, d) {
                                    return P.createNode(a, b, c, d);
                                },
                                ub (a, b, c) {
                                    if (16384 === (a.mode & 61440)) {
                                        try {
                                            var d = Cb(b, c);
                                        } catch (f) {}
                                        if (d) {
                                            for(var e in d.j)throw new O(55);
                                        }
                                    }
                                    delete a.parent.j[a.name];
                                    a.parent.timestamp = Date.now();
                                    a.name = c;
                                    b.j[c] = a;
                                    b.timestamp = a.parent.timestamp;
                                    a.parent = b;
                                },
                                Ab (a, b) {
                                    delete a.j[b];
                                    a.timestamp = Date.now();
                                },
                                vb (a, b) {
                                    var c = Cb(a, b), d;
                                    for(d in c.j)throw new O(55);
                                    delete a.j[b];
                                    a.timestamp = Date.now();
                                },
                                sb (a) {
                                    var b = [
                                        ".",
                                        ".."
                                    ], c;
                                    for(c in a.j)a.j.hasOwnProperty(c) && b.push(c);
                                    return b;
                                },
                                Ea (a, b, c) {
                                    a = P.createNode(a, b, 41471, 0);
                                    a.link = c;
                                    return a;
                                },
                                ma (a) {
                                    if (40960 !== (a.mode & 61440)) throw new O(28);
                                    return a.link;
                                }
                            },
                            m: {
                                read (a, b, c, d, e) {
                                    var f = a.node.j;
                                    if (e >= a.node.v) return 0;
                                    a = Math.min(a.node.v - e, d);
                                    if (8 < a && f.subarray) b.set(f.subarray(e, e + a), c);
                                    else for(d = 0; d < a; d++)b[c + d] = f[e + d];
                                    return a;
                                },
                                write (a, b, c, d, e, f) {
                                    b.buffer === C.buffer && (f = !1);
                                    if (!d) return 0;
                                    a = a.node;
                                    a.timestamp = Date.now();
                                    if (b.subarray && (!a.j || a.j.subarray)) {
                                        if (f) return a.j = b.subarray(c, c + d), a.v = d;
                                        if (0 === a.v && 0 === e) return a.j = b.slice(c, c + d), a.v = d;
                                        if (e + d <= a.v) return a.j.set(b.subarray(c, c + d), e), d;
                                    }
                                    yb(a, e + d);
                                    if (a.j.subarray && b.subarray) a.j.set(b.subarray(c, c + d), e);
                                    else for(f = 0; f < d; f++)a.j[e + f] = b[c + f];
                                    a.v = Math.max(a.v, e + d);
                                    return d;
                                },
                                ba (a, b, c) {
                                    1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
                                    if (0 > b) throw new O(28);
                                    return b;
                                },
                                pa (a, b, c) {
                                    yb(a.node, b + c);
                                    a.node.v = Math.max(a.node.v, b + c);
                                },
                                lb (a, b, c, d, e) {
                                    if (32768 !== (a.node.mode & 61440)) throw new O(43);
                                    a = a.node.j;
                                    if (e & 2 || a.buffer !== C.buffer) {
                                        if (0 < c || c + b < a.length) a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
                                        c = !0;
                                        Aa();
                                        b = void 0;
                                        if (!b) throw new O(48);
                                        C.set(a, b);
                                    } else c = !1, b = a.byteOffset;
                                    return {
                                        o: b,
                                        M: c
                                    };
                                },
                                nb (a, b, c, d) {
                                    P.m.write(a, b, 0, d, c, !1);
                                    return 0;
                                }
                            }
                        };
                        function Db(a, b) {
                            var c = 0;
                            a && (c |= 365);
                            b && (c |= 146);
                            return c;
                        }
                        var Eb = null, Fb = {}, Gb = [], Hb = 1, Ib = null, Jb = !0, O = null, Bb = {}, Lb = (a, b = {})=>{
                            a = lb(a);
                            if (!a) return {
                                path: "",
                                node: null
                            };
                            b = Object.assign({
                                gb: !0,
                                Qa: 0
                            }, b);
                            if (8 < b.Qa) throw new O(32);
                            a = a.split("/").filter((g)=>!!g);
                            for(var c = Eb, d = "/", e = 0; e < a.length; e++){
                                var f = e === a.length - 1;
                                if (f && b.parent) break;
                                c = Cb(c, a[e]);
                                d = gb(d + "/" + a[e]);
                                c.wa && (!f || f && b.gb) && (c = c.wa.root);
                                if (!f || b.fb) for(f = 0; 40960 === (c.mode & 61440);){
                                    if (c = Kb(d), d = lb(hb(d), c), c = Lb(d, {
                                        Qa: b.Qa + 1
                                    }).node, 40 < f++) throw new O(32);
                                }
                            }
                            return {
                                path: d,
                                node: c
                            };
                        }, Mb = (a)=>{
                            for(var b;;){
                                if (a === a.parent) return a = a.U.mb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
                                b = b ? `${a.name}/${b}` : a.name;
                                a = a.parent;
                            }
                        }, Nb = (a, b)=>{
                            for(var c = 0, d = 0; d < b.length; d++)c = (c << 5) - c + b.charCodeAt(d) | 0;
                            return (a + c >>> 0) % Ib.length;
                        }, Cb = (a, b)=>{
                            var c;
                            if (c = (c = Ob(a, "x")) ? c : a.l.ka ? 0 : 2) throw new O(c, a);
                            for(c = Ib[Nb(a.id, b)]; c; c = c.lc){
                                var d = c.name;
                                if (c.parent.id === a.id && d === b) return c;
                            }
                            return a.l.ka(a, b);
                        }, Ab = (a, b, c, d)=>{
                            a = new Pb(a, b, c, d);
                            b = Nb(a.parent.id, a.name);
                            a.lc = Ib[b];
                            return Ib[b] = a;
                        }, Qb = (a)=>{
                            var b = [
                                "r",
                                "w",
                                "rw"
                            ][a & 3];
                            a & 512 && (b += "w");
                            return b;
                        }, Ob = (a, b)=>{
                            if (Jb) return 0;
                            if (!b.includes("r") || a.mode & 292) {
                                if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) return 2;
                            } else return 2;
                            return 0;
                        }, Rb = (a, b)=>{
                            try {
                                return Cb(a, b), 20;
                            } catch (c) {}
                            return Ob(a, "wx");
                        }, Sb = ()=>{
                            for(var a = 0; 4096 >= a; a++){
                                if (!Gb[a]) return a;
                            }
                            throw new O(33);
                        }, Tb = (a)=>{
                            a = Gb[a];
                            if (!a) throw new O(8);
                            return a;
                        }, Vb = (a, b = -1)=>{
                            Ub || (Ub = function() {
                                this.h = {};
                            }, Ub.prototype = {}, Object.defineProperties(Ub.prototype, {
                                object: {
                                    get () {
                                        return this.node;
                                    },
                                    set (c) {
                                        this.node = c;
                                    }
                                },
                                flags: {
                                    get () {
                                        return this.h.flags;
                                    },
                                    set (c) {
                                        this.h.flags = c;
                                    }
                                },
                                position: {
                                    get () {
                                        return this.h.position;
                                    },
                                    set (c) {
                                        this.h.position = c;
                                    }
                                }
                            }));
                            a = Object.assign(new Ub(), a);
                            -1 == b && (b = Sb());
                            a.X = b;
                            return Gb[b] = a;
                        }, zb = {
                            open: (a)=>{
                                a.m = Fb[a.node.za].m;
                                a.m.open && a.m.open(a);
                            },
                            ba: ()=>{
                                throw new O(70);
                            }
                        }, ub = (a, b)=>{
                            Fb[a] = {
                                m: b
                            };
                        }, Wb = (a, b)=>{
                            var c = "/" === b, d = !b;
                            if (c && Eb) throw new O(10);
                            if (!c && !d) {
                                var e = Lb(b, {
                                    gb: !1
                                });
                                b = e.path;
                                e = e.node;
                                if (e.wa) throw new O(10);
                                if (16384 !== (e.mode & 61440)) throw new O(54);
                            }
                            b = {
                                type: a,
                                Qc: {},
                                mb: b,
                                kc: []
                            };
                            a = a.U(b);
                            a.U = b;
                            b.root = a;
                            c ? Eb = a : e && (e.wa = b, e.U && e.U.kc.push(b));
                        }, S = (a, b, c)=>{
                            var d = Lb(a, {
                                parent: !0
                            }).node;
                            a = ib(a);
                            if (!a || "." === a || ".." === a) throw new O(28);
                            var e = Rb(d, a);
                            if (e) throw new O(e);
                            if (!d.l.va) throw new O(63);
                            return d.l.va(d, a, b, c);
                        }, Xb = (a, b, c)=>{
                            "undefined" == typeof c && (c = b, b = 438);
                            S(a, b | 8192, c);
                        }, cc = (a, b)=>{
                            if (!lb(a)) throw new O(44);
                            var c = Lb(b, {
                                parent: !0
                            }).node;
                            if (!c) throw new O(44);
                            b = ib(b);
                            var d = Rb(c, b);
                            if (d) throw new O(d);
                            if (!c.l.Ea) throw new O(63);
                            c.l.Ea(c, b, a);
                        }, Kb = (a)=>{
                            a = Lb(a).node;
                            if (!a) throw new O(44);
                            if (!a.l.ma) throw new O(28);
                            return lb(Mb(a.parent), a.l.ma(a));
                        }, ec = (a, b, c)=>{
                            if ("" === a) throw new O(44);
                            if ("string" == typeof b) {
                                var d = {
                                    r: 0,
                                    "r+": 2,
                                    w: 577,
                                    "w+": 578,
                                    a: 1089,
                                    "a+": 1090
                                }[b];
                                if ("undefined" == typeof d) throw Error(`Unknown file open mode: ${b}`);
                                b = d;
                            }
                            c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
                            if ("object" == typeof a) var e = a;
                            else {
                                a = gb(a);
                                try {
                                    e = Lb(a, {
                                        fb: !(b & 131072)
                                    }).node;
                                } catch (f) {}
                            }
                            d = !1;
                            if (b & 64) {
                                if (e) {
                                    if (b & 128) throw new O(20);
                                } else e = S(a, c, 0), d = !0;
                            }
                            if (!e) throw new O(44);
                            8192 === (e.mode & 61440) && (b &= -513);
                            if (b & 65536 && 16384 !== (e.mode & 61440)) throw new O(54);
                            if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Qb(b) || b & 512) ? 31 : Ob(e, Qb(b)) : 44)) throw new O(c);
                            if (b & 512 && !d) {
                                c = e;
                                c = "string" == typeof c ? Lb(c, {
                                    fb: !0
                                }).node : c;
                                if (!c.l.P) throw new O(63);
                                if (16384 === (c.mode & 61440)) throw new O(31);
                                if (32768 !== (c.mode & 61440)) throw new O(28);
                                if (d = Ob(c, "w")) throw new O(d);
                                c.l.P(c, {
                                    size: 0,
                                    timestamp: Date.now()
                                });
                            }
                            b &= -131713;
                            e = Vb({
                                node: e,
                                path: Mb(e),
                                flags: b,
                                seekable: !0,
                                position: 0,
                                m: e.m,
                                zc: [],
                                error: !1
                            });
                            e.m.open && e.m.open(e);
                            !m.logReadFiles || b & 1 || (dc || (dc = {}), a in dc || (dc[a] = 1));
                            return e;
                        }, fc = (a, b, c)=>{
                            if (null === a.X) throw new O(8);
                            if (!a.seekable || !a.m.ba) throw new O(70);
                            if (0 != c && 1 != c && 2 != c) throw new O(28);
                            a.position = a.m.ba(a, b, c);
                            a.zc = [];
                        }, gc = ()=>{
                            O || (O = function(a, b) {
                                this.name = "ErrnoError";
                                this.node = b;
                                this.pc = function(c) {
                                    this.aa = c;
                                };
                                this.pc(a);
                                this.message = "FS error";
                            }, O.prototype = Error(), O.prototype.constructor = O, [
                                44
                            ].forEach((a)=>{
                                Bb[a] = new O(a);
                                Bb[a].stack = "<generic error, no stack>";
                            }));
                        }, hc, jc = (a, b, c)=>{
                            a = gb("/dev/" + a);
                            var d = Db(!!b, !!c);
                            ic || (ic = 64);
                            var e = ic++ << 8 | 0;
                            ub(e, {
                                open: (f)=>{
                                    f.seekable = !1;
                                },
                                close: ()=>{
                                    c && c.buffer && c.buffer.length && c(10);
                                },
                                read: (f, g, n, p)=>{
                                    for(var l = 0, u = 0; u < p; u++){
                                        try {
                                            var v = b();
                                        } catch (x) {
                                            throw new O(29);
                                        }
                                        if (void 0 === v && 0 === l) throw new O(6);
                                        if (null === v || void 0 === v) break;
                                        l++;
                                        g[n + u] = v;
                                    }
                                    l && (f.node.timestamp = Date.now());
                                    return l;
                                },
                                write: (f, g, n, p)=>{
                                    for(var l = 0; l < p; l++)try {
                                        c(g[n + l]);
                                    } catch (u) {
                                        throw new O(29);
                                    }
                                    p && (f.node.timestamp = Date.now());
                                    return l;
                                }
                            });
                            Xb(a, d, e);
                        }, ic, kc = {}, Ub, dc, lc = void 0;
                        function mc() {
                            lc += 4;
                            return L[lc - 4 >> 2];
                        }
                        function nc(a) {
                            if (void 0 === a) return "_unknown";
                            a = a.replace(/[^a-zA-Z0-9_]/g, "$");
                            var b = a.charCodeAt(0);
                            return 48 <= b && 57 >= b ? `_${a}` : a;
                        }
                        function oc(a, b) {
                            a = nc(a);
                            return ({
                                [a]: function() {
                                    return b.apply(this, arguments);
                                }
                            })[a];
                        }
                        function pc() {
                            this.M = [
                                void 0
                            ];
                            this.hb = [];
                        }
                        var U = new pc(), qc = void 0;
                        function V(a) {
                            throw new qc(a);
                        }
                        var rc = (a)=>{
                            a || V("Cannot use deleted val. handle = " + a);
                            return U.get(a).value;
                        }, sc = (a)=>{
                            switch(a){
                                case void 0:
                                    return 1;
                                case null:
                                    return 2;
                                case !0:
                                    return 3;
                                case !1:
                                    return 4;
                                default:
                                    return U.pa({
                                        tb: 1,
                                        value: a
                                    });
                            }
                        };
                        function tc(a) {
                            var b = Error, c = oc(a, function(d) {
                                this.name = a;
                                this.message = d;
                                d = Error(d).stack;
                                void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
                            });
                            c.prototype = Object.create(b.prototype);
                            c.prototype.constructor = c;
                            c.prototype.toString = function() {
                                return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
                            };
                            return c;
                        }
                        var uc = void 0, vc = void 0;
                        function W(a) {
                            for(var b = ""; E[a];)b += vc[E[a++]];
                            return b;
                        }
                        var wc = [];
                        function xc() {
                            for(; wc.length;){
                                var a = wc.pop();
                                a.g.fa = !1;
                                a["delete"]();
                            }
                        }
                        var yc = void 0, zc = {};
                        function Ac(a, b) {
                            for(void 0 === b && V("ptr should not be undefined"); a.A;)b = a.na(b), a = a.A;
                            return b;
                        }
                        var Bc = {};
                        function Cc(a) {
                            a = Dc(a);
                            var b = W(a);
                            Ec(a);
                            return b;
                        }
                        function Fc(a, b) {
                            var c = Bc[a];
                            void 0 === c && V(b + " has unknown type " + Cc(a));
                            return c;
                        }
                        function Gc() {}
                        var Hc = !1;
                        function Ic(a) {
                            --a.count.value;
                            0 === a.count.value && (a.G ? a.L.W(a.G) : a.u.i.W(a.o));
                        }
                        function Jc(a, b, c) {
                            if (b === c) return a;
                            if (void 0 === c.A) return null;
                            a = Jc(a, b, c.A);
                            return null === a ? null : c.Pb(a);
                        }
                        var Kc = {};
                        function Lc(a, b) {
                            b = Ac(a, b);
                            return zc[b];
                        }
                        var Mc = void 0;
                        function Nc(a) {
                            throw new Mc(a);
                        }
                        function Oc(a, b) {
                            b.u && b.o || Nc("makeClassHandle requires ptr and ptrType");
                            !!b.L !== !!b.G && Nc("Both smartPtrType and smartPtr must be specified");
                            b.count = {
                                value: 1
                            };
                            return Pc(Object.create(a, {
                                g: {
                                    value: b
                                }
                            }));
                        }
                        function Pc(a) {
                            if ("undefined" === typeof FinalizationRegistry) return Pc = (b)=>b, a;
                            Hc = new FinalizationRegistry((b)=>{
                                Ic(b.g);
                            });
                            Pc = (b)=>{
                                var c = b.g;
                                c.G && Hc.register(b, {
                                    g: c
                                }, b);
                                return b;
                            };
                            Gc = (b)=>{
                                Hc.unregister(b);
                            };
                            return Pc(a);
                        }
                        var Qc = {};
                        function Rc(a) {
                            for(; a.length;){
                                var b = a.pop();
                                a.pop()(b);
                            }
                        }
                        function Sc(a) {
                            return this.fromWireType(L[a >> 2]);
                        }
                        var Tc = {}, Uc = {};
                        function Y(a, b, c) {
                            function d(n) {
                                n = c(n);
                                n.length !== a.length && Nc("Mismatched type converter count");
                                for(var p = 0; p < a.length; ++p)Vc(a[p], n[p]);
                            }
                            a.forEach(function(n) {
                                Uc[n] = b;
                            });
                            var e = Array(b.length), f = [], g = 0;
                            b.forEach((n, p)=>{
                                Bc.hasOwnProperty(n) ? e[p] = Bc[n] : (f.push(n), Tc.hasOwnProperty(n) || (Tc[n] = []), Tc[n].push(()=>{
                                    e[p] = Bc[n];
                                    ++g;
                                    g === f.length && d(e);
                                }));
                            });
                            0 === f.length && d(e);
                        }
                        function Wc(a) {
                            switch(a){
                                case 1:
                                    return 0;
                                case 2:
                                    return 1;
                                case 4:
                                    return 2;
                                case 8:
                                    return 3;
                                default:
                                    throw new TypeError(`Unknown type size: ${a}`);
                            }
                        }
                        function Xc(a, b, c = {}) {
                            var d = b.name;
                            a || V(`type "${d}" must have a positive integer typeid pointer`);
                            if (Bc.hasOwnProperty(a)) {
                                if (c.$b) return;
                                V(`Cannot register type '${d}' twice`);
                            }
                            Bc[a] = b;
                            delete Uc[a];
                            Tc.hasOwnProperty(a) && (b = Tc[a], delete Tc[a], b.forEach((e)=>e()));
                        }
                        function Vc(a, b, c = {}) {
                            if (!("argPackAdvance" in b)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
                            Xc(a, b, c);
                        }
                        function Yc(a) {
                            V(a.g.u.i.name + " instance already deleted");
                        }
                        function Zc() {}
                        function $c(a, b, c) {
                            if (void 0 === a[b].B) {
                                var d = a[b];
                                a[b] = function() {
                                    a[b].B.hasOwnProperty(arguments.length) || V(`Function '${c}' called with an invalid number of arguments (${arguments.length}) - expects one of (${a[b].B})!`);
                                    return a[b].B[arguments.length].apply(this, arguments);
                                };
                                a[b].B = [];
                                a[b].B[d.ea] = d;
                            }
                        }
                        function ad(a, b, c) {
                            m.hasOwnProperty(a) ? ((void 0 === c || void 0 !== m[a].B && void 0 !== m[a].B[c]) && V(`Cannot register public name '${a}' twice`), $c(m, a, a), m.hasOwnProperty(c) && V(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`), m[a].B[c] = b) : (m[a] = b, void 0 !== c && (m[a].Pc = c));
                        }
                        function bd(a, b, c, d, e, f, g, n) {
                            this.name = a;
                            this.constructor = b;
                            this.N = c;
                            this.W = d;
                            this.A = e;
                            this.Ub = f;
                            this.na = g;
                            this.Pb = n;
                            this.qb = [];
                        }
                        function cd(a, b, c) {
                            for(; b !== c;)b.na || V(`Expected null or instance of ${c.name}, got an instance of ${b.name}`), a = b.na(a), b = b.A;
                            return a;
                        }
                        function dd(a, b) {
                            if (null === b) return this.Na && V(`null is not a valid ${this.name}`), 0;
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            return cd(b.g.o, b.g.u.i, this.i);
                        }
                        function fd(a, b) {
                            if (null === b) {
                                this.Na && V(`null is not a valid ${this.name}`);
                                if (this.ua) {
                                    var c = this.Pa();
                                    null !== a && a.push(this.W, c);
                                    return c;
                                }
                                return 0;
                            }
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            !this.ta && b.g.u.ta && V(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
                            c = cd(b.g.o, b.g.u.i, this.i);
                            if (this.ua) switch(void 0 === b.g.G && V("Passing raw pointer to smart pointer is illegal"), this.tc){
                                case 0:
                                    b.g.L === this ? c = b.g.G : V(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
                                    break;
                                case 1:
                                    c = b.g.G;
                                    break;
                                case 2:
                                    if (b.g.L === this) c = b.g.G;
                                    else {
                                        var d = b.clone();
                                        c = this.oc(c, sc(function() {
                                            d["delete"]();
                                        }));
                                        null !== a && a.push(this.W, c);
                                    }
                                    break;
                                default:
                                    V("Unsupporting sharing policy");
                            }
                            return c;
                        }
                        function gd(a, b) {
                            if (null === b) return this.Na && V(`null is not a valid ${this.name}`), 0;
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            b.g.u.ta && V(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
                            return cd(b.g.o, b.g.u.i, this.i);
                        }
                        function hd(a, b, c, d) {
                            this.name = a;
                            this.i = b;
                            this.Na = c;
                            this.ta = d;
                            this.ua = !1;
                            this.W = this.oc = this.Pa = this.rb = this.tc = this.nc = void 0;
                            void 0 !== b.A ? this.toWireType = fd : (this.toWireType = d ? dd : gd, this.K = null);
                        }
                        function jd(a, b, c) {
                            m.hasOwnProperty(a) || Nc("Replacing nonexistant public symbol");
                            void 0 !== m[a].B && void 0 !== c ? m[a].B[c] = b : (m[a] = b, m[a].ea = c);
                        }
                        var kd = [], ld = (a)=>{
                            var b = kd[a];
                            b || (a >= kd.length && (kd.length = a + 1), kd[a] = b = Ka.get(a));
                            return b;
                        }, md = (a, b)=>{
                            var c = [];
                            return function() {
                                c.length = 0;
                                Object.assign(c, arguments);
                                if (a.includes("j")) {
                                    var d = m["dynCall_" + a];
                                    d = c && c.length ? d.apply(null, [
                                        b
                                    ].concat(c)) : d.call(null, b);
                                } else d = ld(b).apply(null, c);
                                return d;
                            };
                        };
                        function Z(a, b) {
                            a = W(a);
                            var c = a.includes("j") ? md(a, b) : ld(b);
                            "function" != typeof c && V(`unknown function pointer with signature ${a}: ${b}`);
                            return c;
                        }
                        var nd = void 0;
                        function od(a, b) {
                            function c(f) {
                                e[f] || Bc[f] || (Uc[f] ? Uc[f].forEach(c) : (d.push(f), e[f] = !0));
                            }
                            var d = [], e = {};
                            b.forEach(c);
                            throw new nd(`${a}: ` + d.map(Cc).join([
                                ", "
                            ]));
                        }
                        function pd(a, b, c, d, e) {
                            var f = b.length;
                            2 > f && V("argTypes array size mismatch! Must at least get return value and 'this' types!");
                            var g = null !== b[1] && null !== c, n = !1;
                            for(c = 1; c < b.length; ++c)if (null !== b[c] && void 0 === b[c].K) {
                                n = !0;
                                break;
                            }
                            var p = "void" !== b[0].name, l = f - 2, u = Array(l), v = [], x = [];
                            return function() {
                                arguments.length !== l && V(`function ${a} called with ${arguments.length} arguments, expected ${l} args!`);
                                x.length = 0;
                                v.length = g ? 2 : 1;
                                v[0] = e;
                                if (g) {
                                    var k = b[1].toWireType(x, this);
                                    v[1] = k;
                                }
                                for(var t = 0; t < l; ++t)u[t] = b[t + 2].toWireType(x, arguments[t]), v.push(u[t]);
                                t = d.apply(null, v);
                                if (n) Rc(x);
                                else for(var r = g ? 1 : 2; r < b.length; r++){
                                    var B = 1 === r ? k : u[r - 2];
                                    null !== b[r].K && b[r].K(B);
                                }
                                k = p ? b[0].fromWireType(t) : void 0;
                                return k;
                            };
                        }
                        function sd(a, b) {
                            for(var c = [], d = 0; d < a; d++)c.push(N[b + 4 * d >> 2]);
                            return c;
                        }
                        function td(a, b, c) {
                            a instanceof Object || V(`${c} with invalid "this": ${a}`);
                            a instanceof b.i.constructor || V(`${c} incompatible with "this" of type ${a.constructor.name}`);
                            a.g.o || V(`cannot call emscripten binding method ${c} on deleted object`);
                            return cd(a.g.o, a.g.u.i, b.i);
                        }
                        function ud(a) {
                            a >= U.h && 0 === --U.get(a).tb && U.Zb(a);
                        }
                        function vd(a, b, c) {
                            switch(b){
                                case 0:
                                    return function(d) {
                                        return this.fromWireType((c ? C : E)[d]);
                                    };
                                case 1:
                                    return function(d) {
                                        return this.fromWireType((c ? Da : Ea)[d >> 1]);
                                    };
                                case 2:
                                    return function(d) {
                                        return this.fromWireType((c ? L : N)[d >> 2]);
                                    };
                                default:
                                    throw new TypeError("Unknown integer type: " + a);
                            }
                        }
                        function ed(a) {
                            if (null === a) return "null";
                            var b = typeof a;
                            return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
                        }
                        function wd(a, b) {
                            switch(b){
                                case 2:
                                    return function(c) {
                                        return this.fromWireType(Fa[c >> 2]);
                                    };
                                case 3:
                                    return function(c) {
                                        return this.fromWireType(Ia[c >> 3]);
                                    };
                                default:
                                    throw new TypeError("Unknown float type: " + a);
                            }
                        }
                        function xd(a, b, c) {
                            switch(b){
                                case 0:
                                    return c ? function(d) {
                                        return C[d];
                                    } : function(d) {
                                        return E[d];
                                    };
                                case 1:
                                    return c ? function(d) {
                                        return Da[d >> 1];
                                    } : function(d) {
                                        return Ea[d >> 1];
                                    };
                                case 2:
                                    return c ? function(d) {
                                        return L[d >> 2];
                                    } : function(d) {
                                        return N[d >> 2];
                                    };
                                default:
                                    throw new TypeError("Unknown integer type: " + a);
                            }
                        }
                        var yd = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, zd = (a, b)=>{
                            var c = a >> 1;
                            for(var d = c + b / 2; !(c >= d) && Ea[c];)++c;
                            c <<= 1;
                            if (32 < c - a && yd) return yd.decode(E.subarray(a, c));
                            c = "";
                            for(d = 0; !(d >= b / 2); ++d){
                                var e = Da[a + 2 * d >> 1];
                                if (0 == e) break;
                                c += String.fromCharCode(e);
                            }
                            return c;
                        }, Ad = (a, b, c)=>{
                            void 0 === c && (c = 2147483647);
                            if (2 > c) return 0;
                            c -= 2;
                            var d = b;
                            c = c < 2 * a.length ? c / 2 : a.length;
                            for(var e = 0; e < c; ++e)Da[b >> 1] = a.charCodeAt(e), b += 2;
                            Da[b >> 1] = 0;
                            return b - d;
                        }, Bd = (a)=>2 * a.length, Cd = (a, b)=>{
                            for(var c = 0, d = ""; !(c >= b / 4);){
                                var e = L[a + 4 * c >> 2];
                                if (0 == e) break;
                                ++c;
                                65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
                            }
                            return d;
                        }, Dd = (a, b, c)=>{
                            void 0 === c && (c = 2147483647);
                            if (4 > c) return 0;
                            var d = b;
                            c = d + c - 4;
                            for(var e = 0; e < a.length; ++e){
                                var f = a.charCodeAt(e);
                                if (55296 <= f && 57343 >= f) {
                                    var g = a.charCodeAt(++e);
                                    f = 65536 + ((f & 1023) << 10) | g & 1023;
                                }
                                L[b >> 2] = f;
                                b += 4;
                                if (b + 4 > c) break;
                            }
                            L[b >> 2] = 0;
                            return b - d;
                        }, Ed = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                55296 <= d && 57343 >= d && ++c;
                                b += 4;
                            }
                            return b;
                        }, Fd = {};
                        function Gd(a) {
                            var b = Fd[a];
                            return void 0 === b ? W(a) : b;
                        }
                        var Hd = [];
                        function Id(a) {
                            var b = Hd.length;
                            Hd.push(a);
                            return b;
                        }
                        function Jd(a, b) {
                            for(var c = Array(a), d = 0; d < a; ++d)c[d] = Fc(N[b + 4 * d >> 2], "parameter " + d);
                            return c;
                        }
                        var Kd = [], Ld = [], Md = {}, Od = ()=>{
                            if (!Nd) {
                                var a = {
                                    USER: "web_user",
                                    LOGNAME: "web_user",
                                    PATH: "/",
                                    PWD: "/",
                                    HOME: "/home/web_user",
                                    LANG: ("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                                    _: na || "./this.program"
                                }, b;
                                for(b in Md)void 0 === Md[b] ? delete a[b] : a[b] = Md[b];
                                var c = [];
                                for(b in a)c.push(`${b}=${a[b]}`);
                                Nd = c;
                            }
                            return Nd;
                        }, Nd, Pd = (a)=>0 === a % 4 && (0 !== a % 100 || 0 === a % 400), Qd = [
                            31,
                            29,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Rd = [
                            31,
                            28,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Sd = (a, b, c, d)=>{
                            function e(k, t, r) {
                                for(k = "number" == typeof k ? k.toString() : k || ""; k.length < t;)k = r[0] + k;
                                return k;
                            }
                            function f(k, t) {
                                return e(k, t, "0");
                            }
                            function g(k, t) {
                                function r(D) {
                                    return 0 > D ? -1 : 0 < D ? 1 : 0;
                                }
                                var B;
                                0 === (B = r(k.getFullYear() - t.getFullYear())) && 0 === (B = r(k.getMonth() - t.getMonth())) && (B = r(k.getDate() - t.getDate()));
                                return B;
                            }
                            function n(k) {
                                switch(k.getDay()){
                                    case 0:
                                        return new Date(k.getFullYear() - 1, 11, 29);
                                    case 1:
                                        return k;
                                    case 2:
                                        return new Date(k.getFullYear(), 0, 3);
                                    case 3:
                                        return new Date(k.getFullYear(), 0, 2);
                                    case 4:
                                        return new Date(k.getFullYear(), 0, 1);
                                    case 5:
                                        return new Date(k.getFullYear() - 1, 11, 31);
                                    case 6:
                                        return new Date(k.getFullYear() - 1, 11, 30);
                                }
                            }
                            function p(k) {
                                var t = k.ca;
                                for(k = new Date(new Date(k.da + 1900, 0, 1).getTime()); 0 < t;){
                                    var r = k.getMonth(), B = (Pd(k.getFullYear()) ? Qd : Rd)[r];
                                    if (t > B - k.getDate()) t -= B - k.getDate() + 1, k.setDate(1), 11 > r ? k.setMonth(r + 1) : (k.setMonth(0), k.setFullYear(k.getFullYear() + 1));
                                    else {
                                        k.setDate(k.getDate() + t);
                                        break;
                                    }
                                }
                                r = new Date(k.getFullYear() + 1, 0, 4);
                                t = n(new Date(k.getFullYear(), 0, 4));
                                r = n(r);
                                return 0 >= g(t, k) ? 0 >= g(r, k) ? k.getFullYear() + 1 : k.getFullYear() : k.getFullYear() - 1;
                            }
                            var l = L[d + 40 >> 2];
                            d = {
                                wc: L[d >> 2],
                                vc: L[d + 4 >> 2],
                                Fa: L[d + 8 >> 2],
                                Sa: L[d + 12 >> 2],
                                Ga: L[d + 16 >> 2],
                                da: L[d + 20 >> 2],
                                R: L[d + 24 >> 2],
                                ca: L[d + 28 >> 2],
                                Rc: L[d + 32 >> 2],
                                uc: L[d + 36 >> 2],
                                xc: l ? l ? nb(E, l) : "" : ""
                            };
                            c = c ? nb(E, c) : "";
                            l = {
                                "%c": "%a %b %d %H:%M:%S %Y",
                                "%D": "%m/%d/%y",
                                "%F": "%Y-%m-%d",
                                "%h": "%b",
                                "%r": "%I:%M:%S %p",
                                "%R": "%H:%M",
                                "%T": "%H:%M:%S",
                                "%x": "%m/%d/%y",
                                "%X": "%H:%M:%S",
                                "%Ec": "%c",
                                "%EC": "%C",
                                "%Ex": "%m/%d/%y",
                                "%EX": "%H:%M:%S",
                                "%Ey": "%y",
                                "%EY": "%Y",
                                "%Od": "%d",
                                "%Oe": "%e",
                                "%OH": "%H",
                                "%OI": "%I",
                                "%Om": "%m",
                                "%OM": "%M",
                                "%OS": "%S",
                                "%Ou": "%u",
                                "%OU": "%U",
                                "%OV": "%V",
                                "%Ow": "%w",
                                "%OW": "%W",
                                "%Oy": "%y"
                            };
                            for(var u in l)c = c.replace(new RegExp(u, "g"), l[u]);
                            var v = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), x = "January February March April May June July August September October November December".split(" ");
                            l = {
                                "%a": (k)=>v[k.R].substring(0, 3),
                                "%A": (k)=>v[k.R],
                                "%b": (k)=>x[k.Ga].substring(0, 3),
                                "%B": (k)=>x[k.Ga],
                                "%C": (k)=>f((k.da + 1900) / 100 | 0, 2),
                                "%d": (k)=>f(k.Sa, 2),
                                "%e": (k)=>e(k.Sa, 2, " "),
                                "%g": (k)=>p(k).toString().substring(2),
                                "%G": (k)=>p(k),
                                "%H": (k)=>f(k.Fa, 2),
                                "%I": (k)=>{
                                    k = k.Fa;
                                    0 == k ? k = 12 : 12 < k && (k -= 12);
                                    return f(k, 2);
                                },
                                "%j": (k)=>{
                                    for(var t = 0, r = 0; r <= k.Ga - 1; t += (Pd(k.da + 1900) ? Qd : Rd)[r++]);
                                    return f(k.Sa + t, 3);
                                },
                                "%m": (k)=>f(k.Ga + 1, 2),
                                "%M": (k)=>f(k.vc, 2),
                                "%n": ()=>"\n",
                                "%p": (k)=>0 <= k.Fa && 12 > k.Fa ? "AM" : "PM",
                                "%S": (k)=>f(k.wc, 2),
                                "%t": ()=>"\t",
                                "%u": (k)=>k.R || 7,
                                "%U": (k)=>f(Math.floor((k.ca + 7 - k.R) / 7), 2),
                                "%V": (k)=>{
                                    var t = Math.floor((k.ca + 7 - (k.R + 6) % 7) / 7);
                                    2 >= (k.R + 371 - k.ca - 2) % 7 && t++;
                                    if (t) 53 == t && (r = (k.R + 371 - k.ca) % 7, 4 == r || 3 == r && Pd(k.da) || (t = 1));
                                    else {
                                        t = 52;
                                        var r = (k.R + 7 - k.ca - 1) % 7;
                                        (4 == r || 5 == r && Pd(k.da % 400 - 1)) && t++;
                                    }
                                    return f(t, 2);
                                },
                                "%w": (k)=>k.R,
                                "%W": (k)=>f(Math.floor((k.ca + 7 - (k.R + 6) % 7) / 7), 2),
                                "%y": (k)=>(k.da + 1900).toString().substring(2),
                                "%Y": (k)=>k.da + 1900,
                                "%z": (k)=>{
                                    k = k.uc;
                                    var t = 0 <= k;
                                    k = Math.abs(k) / 60;
                                    return (t ? "+" : "-") + String("0000" + (k / 60 * 100 + k % 60)).slice(-4);
                                },
                                "%Z": (k)=>k.xc,
                                "%%": ()=>"%"
                            };
                            c = c.replace(/%%/g, "\x00\x00");
                            for(u in l)c.includes(u) && (c = c.replace(new RegExp(u, "g"), l[u](d)));
                            c = c.replace(/\0\0/g, "%");
                            u = rb(c, !1);
                            if (u.length > b) return 0;
                            C.set(u, a);
                            return u.length - 1;
                        };
                        function Pb(a, b, c, d) {
                            a || (a = this);
                            this.parent = a;
                            this.U = a.U;
                            this.wa = null;
                            this.id = Hb++;
                            this.name = b;
                            this.mode = c;
                            this.l = {};
                            this.m = {};
                            this.za = d;
                        }
                        Object.defineProperties(Pb.prototype, {
                            read: {
                                get: function() {
                                    return 365 === (this.mode & 365);
                                },
                                set: function(a) {
                                    a ? this.mode |= 365 : this.mode &= -366;
                                }
                            },
                            write: {
                                get: function() {
                                    return 146 === (this.mode & 146);
                                },
                                set: function(a) {
                                    a ? this.mode |= 146 : this.mode &= -147;
                                }
                            }
                        });
                        gc();
                        Ib = Array(4096);
                        Wb(P, "/");
                        S("/tmp", 16895, 0);
                        S("/home", 16895, 0);
                        S("/home/web_user", 16895, 0);
                        (()=>{
                            S("/dev", 16895, 0);
                            ub(259, {
                                read: ()=>0,
                                write: (d, e, f, g)=>g
                            });
                            Xb("/dev/null", 259);
                            tb(1280, wb);
                            tb(1536, xb);
                            Xb("/dev/tty", 1280);
                            Xb("/dev/tty1", 1536);
                            var a = new Uint8Array(1024), b = 0, c = ()=>{
                                0 === b && (b = kb(a).byteLength);
                                return a[--b];
                            };
                            jc("random", c);
                            jc("urandom", c);
                            S("/dev/shm", 16895, 0);
                            S("/dev/shm/tmp", 16895, 0);
                        })();
                        (()=>{
                            S("/proc", 16895, 0);
                            var a = S("/proc/self", 16895, 0);
                            S("/proc/self/fd", 16895, 0);
                            Wb({
                                U: ()=>{
                                    var b = Ab(a, "fd", 16895, 73);
                                    b.l = {
                                        ka: (c, d)=>{
                                            var e = Tb(+d);
                                            c = {
                                                parent: null,
                                                U: {
                                                    mb: "fake"
                                                },
                                                l: {
                                                    ma: ()=>e.path
                                                }
                                            };
                                            return c.parent = c;
                                        }
                                    };
                                    return b;
                                }
                            }, "/proc/self/fd");
                        })();
                        Object.assign(pc.prototype, {
                            get (a) {
                                return this.M[a];
                            },
                            has (a) {
                                return void 0 !== this.M[a];
                            },
                            pa (a) {
                                var b = this.hb.pop() || this.M.length;
                                this.M[b] = a;
                                return b;
                            },
                            Zb (a) {
                                this.M[a] = void 0;
                                this.hb.push(a);
                            }
                        });
                        qc = m.BindingError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "BindingError";
                            }
                        };
                        U.M.push({
                            value: void 0
                        }, {
                            value: null
                        }, {
                            value: !0
                        }, {
                            value: !1
                        });
                        U.h = U.M.length;
                        m.count_emval_handles = function() {
                            for(var a = 0, b = U.h; b < U.M.length; ++b)void 0 !== U.M[b] && ++a;
                            return a;
                        };
                        uc = m.PureVirtualError = tc("PureVirtualError");
                        for(var Td = Array(256), Ud = 0; 256 > Ud; ++Ud)Td[Ud] = String.fromCharCode(Ud);
                        vc = Td;
                        m.getInheritedInstanceCount = function() {
                            return Object.keys(zc).length;
                        };
                        m.getLiveInheritedInstances = function() {
                            var a = [], b;
                            for(b in zc)zc.hasOwnProperty(b) && a.push(zc[b]);
                            return a;
                        };
                        m.flushPendingDeletes = xc;
                        m.setDelayFunction = function(a) {
                            yc = a;
                            wc.length && yc && yc(xc);
                        };
                        Mc = m.InternalError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "InternalError";
                            }
                        };
                        Zc.prototype.isAliasOf = function(a) {
                            if (!(this instanceof Zc && a instanceof Zc)) return !1;
                            var b = this.g.u.i, c = this.g.o, d = a.g.u.i;
                            for(a = a.g.o; b.A;)c = b.na(c), b = b.A;
                            for(; d.A;)a = d.na(a), d = d.A;
                            return b === d && c === a;
                        };
                        Zc.prototype.clone = function() {
                            this.g.o || Yc(this);
                            if (this.g.ia) return this.g.count.value += 1, this;
                            var a = Pc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
                            a = a(c.call(b, d, {
                                g: {
                                    value: {
                                        count: e.count,
                                        fa: e.fa,
                                        ia: e.ia,
                                        o: e.o,
                                        u: e.u,
                                        G: e.G,
                                        L: e.L
                                    }
                                }
                            }));
                            a.g.count.value += 1;
                            a.g.fa = !1;
                            return a;
                        };
                        Zc.prototype["delete"] = function() {
                            this.g.o || Yc(this);
                            this.g.fa && !this.g.ia && V("Object already scheduled for deletion");
                            Gc(this);
                            Ic(this.g);
                            this.g.ia || (this.g.G = void 0, this.g.o = void 0);
                        };
                        Zc.prototype.isDeleted = function() {
                            return !this.g.o;
                        };
                        Zc.prototype.deleteLater = function() {
                            this.g.o || Yc(this);
                            this.g.fa && !this.g.ia && V("Object already scheduled for deletion");
                            wc.push(this);
                            1 === wc.length && yc && yc(xc);
                            this.g.fa = !0;
                            return this;
                        };
                        hd.prototype.Vb = function(a) {
                            this.rb && (a = this.rb(a));
                            return a;
                        };
                        hd.prototype.ab = function(a) {
                            this.W && this.W(a);
                        };
                        hd.prototype.argPackAdvance = 8;
                        hd.prototype.readValueFromPointer = Sc;
                        hd.prototype.deleteObject = function(a) {
                            if (null !== a) a["delete"]();
                        };
                        hd.prototype.fromWireType = function(a) {
                            function b() {
                                return this.ua ? Oc(this.i.N, {
                                    u: this.nc,
                                    o: c,
                                    L: this,
                                    G: a
                                }) : Oc(this.i.N, {
                                    u: this,
                                    o: a
                                });
                            }
                            var c = this.Vb(a);
                            if (!c) return this.ab(a), null;
                            var d = Lc(this.i, c);
                            if (void 0 !== d) {
                                if (0 === d.g.count.value) return d.g.o = c, d.g.G = a, d.clone();
                                d = d.clone();
                                this.ab(a);
                                return d;
                            }
                            d = this.i.Ub(c);
                            d = Kc[d];
                            if (!d) return b.call(this);
                            d = this.ta ? d.Kb : d.pointerType;
                            var e = Jc(c, this.i, d.i);
                            return null === e ? b.call(this) : this.ua ? Oc(d.i.N, {
                                u: d,
                                o: e,
                                L: this,
                                G: a
                            }) : Oc(d.i.N, {
                                u: d,
                                o: e
                            });
                        };
                        nd = m.UnboundTypeError = tc("UnboundTypeError");
                        var Xd = {
                            __syscall_fcntl64: function(a, b, c) {
                                lc = c;
                                try {
                                    var d = Tb(a);
                                    switch(b){
                                        case 0:
                                            var e = mc();
                                            return 0 > e ? -28 : Vb(d, e).X;
                                        case 1:
                                        case 2:
                                            return 0;
                                        case 3:
                                            return d.flags;
                                        case 4:
                                            return e = mc(), d.flags |= e, 0;
                                        case 5:
                                            return e = mc(), Da[e + 0 >> 1] = 2, 0;
                                        case 6:
                                        case 7:
                                            return 0;
                                        case 16:
                                        case 8:
                                            return -28;
                                        case 9:
                                            return L[Vd() >> 2] = 28, -1;
                                        default:
                                            return -28;
                                    }
                                } catch (f) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== f.name) throw f;
                                    return -f.aa;
                                }
                            },
                            __syscall_ioctl: function(a, b, c) {
                                lc = c;
                                try {
                                    var d = Tb(a);
                                    switch(b){
                                        case 21509:
                                            return d.s ? 0 : -59;
                                        case 21505:
                                            if (!d.s) return -59;
                                            if (d.s.V.bc) {
                                                b = [
                                                    3,
                                                    28,
                                                    127,
                                                    21,
                                                    4,
                                                    0,
                                                    1,
                                                    0,
                                                    17,
                                                    19,
                                                    26,
                                                    0,
                                                    18,
                                                    15,
                                                    23,
                                                    22,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                var e = mc();
                                                L[e >> 2] = 25856;
                                                L[e + 4 >> 2] = 5;
                                                L[e + 8 >> 2] = 191;
                                                L[e + 12 >> 2] = 35387;
                                                for(var f = 0; 32 > f; f++)C[e + f + 17 >> 0] = b[f] || 0;
                                            }
                                            return 0;
                                        case 21510:
                                        case 21511:
                                        case 21512:
                                            return d.s ? 0 : -59;
                                        case 21506:
                                        case 21507:
                                        case 21508:
                                            if (!d.s) return -59;
                                            if (d.s.V.cc) for(e = mc(), b = [], f = 0; 32 > f; f++)b.push(C[e + f + 17 >> 0]);
                                            return 0;
                                        case 21519:
                                            if (!d.s) return -59;
                                            e = mc();
                                            return L[e >> 2] = 0;
                                        case 21520:
                                            return d.s ? -28 : -59;
                                        case 21531:
                                            e = mc();
                                            if (!d.m.ac) throw new O(59);
                                            return d.m.ac(d, b, e);
                                        case 21523:
                                            if (!d.s) return -59;
                                            d.s.V.dc && (f = [
                                                24,
                                                80
                                            ], e = mc(), Da[e >> 1] = f[0], Da[e + 2 >> 1] = f[1]);
                                            return 0;
                                        case 21524:
                                            return d.s ? 0 : -59;
                                        case 21515:
                                            return d.s ? 0 : -59;
                                        default:
                                            return -28;
                                    }
                                } catch (g) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== g.name) throw g;
                                    return -g.aa;
                                }
                            },
                            __syscall_openat: function(a, b, c, d) {
                                lc = d;
                                try {
                                    b = b ? nb(E, b) : "";
                                    var e = b;
                                    if ("/" === e.charAt(0)) b = e;
                                    else {
                                        var f = -100 === a ? "/" : Tb(a).path;
                                        if (0 == e.length) throw new O(44);
                                        b = gb(f + "/" + e);
                                    }
                                    var g = d ? mc() : 0;
                                    return ec(b, c, g).X;
                                } catch (n) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== n.name) throw n;
                                    return -n.aa;
                                }
                            },
                            _embind_create_inheriting_constructor: function(a, b, c) {
                                a = W(a);
                                b = Fc(b, "wrapper");
                                c = rc(c);
                                var d = [].slice, e = b.i, f = e.N, g = e.A.N, n = e.A.constructor;
                                a = oc(a, function() {
                                    e.A.qb.forEach((function(l) {
                                        if (this[l] === g[l]) throw new uc(`Pure virtual function ${l} must be implemented in JavaScript`);
                                    }).bind(this));
                                    Object.defineProperty(this, "__parent", {
                                        value: f
                                    });
                                    this.__construct.apply(this, d.call(arguments));
                                });
                                f.__construct = function() {
                                    this === f && V("Pass correct 'this' to __construct");
                                    var l = n.implement.apply(void 0, [
                                        this
                                    ].concat(d.call(arguments)));
                                    Gc(l);
                                    var u = l.g;
                                    l.notifyOnDestruction();
                                    u.ia = !0;
                                    Object.defineProperties(this, {
                                        g: {
                                            value: u
                                        }
                                    });
                                    Pc(this);
                                    l = u.o;
                                    l = Ac(e, l);
                                    zc.hasOwnProperty(l) ? V(`Tried to register registered instance: ${l}`) : zc[l] = this;
                                };
                                f.__destruct = function() {
                                    this === f && V("Pass correct 'this' to __destruct");
                                    Gc(this);
                                    var l = this.g.o;
                                    l = Ac(e, l);
                                    zc.hasOwnProperty(l) ? delete zc[l] : V(`Tried to unregister unregistered instance: ${l}`);
                                };
                                a.prototype = Object.create(f);
                                for(var p in c)a.prototype[p] = c[p];
                                return sc(a);
                            },
                            _embind_finalize_value_object: function(a) {
                                var b = Qc[a];
                                delete Qc[a];
                                var c = b.Pa, d = b.W, e = b.eb, f = e.map((g)=>g.Yb).concat(e.map((g)=>g.rc));
                                Y([
                                    a
                                ], f, (g)=>{
                                    var n = {};
                                    e.forEach((p, l)=>{
                                        var u = g[l], v = p.Wb, x = p.Xb, k = g[l + e.length], t = p.qc, r = p.sc;
                                        n[p.Sb] = {
                                            read: (B)=>u.fromWireType(v(x, B)),
                                            write: (B, D)=>{
                                                var w = [];
                                                t(r, B, k.toWireType(w, D));
                                                Rc(w);
                                            }
                                        };
                                    });
                                    return [
                                        {
                                            name: b.name,
                                            fromWireType: function(p) {
                                                var l = {}, u;
                                                for(u in n)l[u] = n[u].read(p);
                                                d(p);
                                                return l;
                                            },
                                            toWireType: function(p, l) {
                                                for(var u in n){
                                                    if (!(u in l)) throw new TypeError(`Missing field: "${u}"`);
                                                }
                                                var v = c();
                                                for(u in n)n[u].write(v, l[u]);
                                                null !== p && p.push(d, v);
                                                return v;
                                            },
                                            argPackAdvance: 8,
                                            readValueFromPointer: Sc,
                                            K: d
                                        }
                                    ];
                                });
                            },
                            _embind_register_bigint: function() {},
                            _embind_register_bool: function(a, b, c, d, e) {
                                var f = Wc(c);
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(g) {
                                        return !!g;
                                    },
                                    toWireType: function(g, n) {
                                        return n ? d : e;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: function(g) {
                                        if (1 === c) var n = C;
                                        else if (2 === c) n = Da;
                                        else if (4 === c) n = L;
                                        else throw new TypeError("Unknown boolean type size: " + b);
                                        return this.fromWireType(n[g >> f]);
                                    },
                                    K: null
                                });
                            },
                            _embind_register_class: function(a, b, c, d, e, f, g, n, p, l, u, v, x) {
                                u = W(u);
                                f = Z(e, f);
                                n && (n = Z(g, n));
                                l && (l = Z(p, l));
                                x = Z(v, x);
                                var k = nc(u);
                                ad(k, function() {
                                    od(`Cannot construct ${u} due to unbound types`, [
                                        d
                                    ]);
                                });
                                Y([
                                    a,
                                    b,
                                    c
                                ], d ? [
                                    d
                                ] : [], function(t) {
                                    t = t[0];
                                    if (d) {
                                        var r = t.i;
                                        var B = r.N;
                                    } else B = Zc.prototype;
                                    t = oc(k, function() {
                                        if (Object.getPrototypeOf(this) !== D) throw new qc("Use 'new' to construct " + u);
                                        if (void 0 === w.$) throw new qc(u + " has no accessible constructor");
                                        var T = w.$[arguments.length];
                                        if (void 0 === T) throw new qc(`Tried to invoke ctor of ${u} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(w.$).toString()}) parameters instead!`);
                                        return T.apply(this, arguments);
                                    });
                                    var D = Object.create(B, {
                                        constructor: {
                                            value: t
                                        }
                                    });
                                    t.prototype = D;
                                    var w = new bd(u, t, D, x, r, f, n, l);
                                    w.A && (void 0 === w.A.oa && (w.A.oa = []), w.A.oa.push(w));
                                    r = new hd(u, w, !0, !1);
                                    B = new hd(u + "*", w, !1, !1);
                                    var M = new hd(u + " const*", w, !1, !0);
                                    Kc[a] = {
                                        pointerType: B,
                                        Kb: M
                                    };
                                    jd(k, t);
                                    return [
                                        r,
                                        B,
                                        M
                                    ];
                                });
                            },
                            _embind_register_class_class_function: function(a, b, c, d, e, f, g) {
                                var n = sd(c, d);
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(p) {
                                    function l() {
                                        od(`Cannot call ${u} due to unbound types`, n);
                                    }
                                    p = p[0];
                                    var u = `${p.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    var v = p.i.constructor;
                                    void 0 === v[b] ? (l.ea = c - 1, v[b] = l) : ($c(v, b, u), v[b].B[c - 1] = l);
                                    Y([], n, function(x) {
                                        x = pd(u, [
                                            x[0],
                                            null
                                        ].concat(x.slice(1)), null, f, g);
                                        void 0 === v[b].B ? (x.ea = c - 1, v[b] = x) : v[b].B[c - 1] = x;
                                        if (p.i.oa) for (const k of p.i.oa)k.constructor.hasOwnProperty(b) || (k.constructor[b] = x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_class_property: function(a, b, c, d, e, f, g, n) {
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(p) {
                                    p = p[0];
                                    var l = `${p.name}.${b}`, u = {
                                        get () {
                                            od(`Cannot access ${l} due to unbound types`, [
                                                c
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    u.set = n ? ()=>{
                                        od(`Cannot access ${l} due to unbound types`, [
                                            c
                                        ]);
                                    } : ()=>{
                                        V(`${l} is a read-only property`);
                                    };
                                    Object.defineProperty(p.i.constructor, b, u);
                                    Y([], [
                                        c
                                    ], function(v) {
                                        v = v[0];
                                        var x = {
                                            get () {
                                                return v.fromWireType(f(d));
                                            },
                                            enumerable: !0
                                        };
                                        n && (n = Z(g, n), x.set = (k)=>{
                                            var t = [];
                                            n(d, v.toWireType(t, k));
                                            Rc(t);
                                        });
                                        Object.defineProperty(p.i.constructor, b, x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_constructor: function(a, b, c, d, e, f) {
                                var g = sd(b, c);
                                e = Z(d, e);
                                Y([], [
                                    a
                                ], function(n) {
                                    n = n[0];
                                    var p = `constructor ${n.name}`;
                                    void 0 === n.i.$ && (n.i.$ = []);
                                    if (void 0 !== n.i.$[b - 1]) throw new qc(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${n.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                                    n.i.$[b - 1] = ()=>{
                                        od(`Cannot construct ${n.name} due to unbound types`, g);
                                    };
                                    Y([], g, function(l) {
                                        l.splice(1, 0, null);
                                        n.i.$[b - 1] = pd(p, l, null, e, f);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_function: function(a, b, c, d, e, f, g, n) {
                                var p = sd(c, d);
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(l) {
                                    function u() {
                                        od(`Cannot call ${v} due to unbound types`, p);
                                    }
                                    l = l[0];
                                    var v = `${l.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    n && l.i.qb.push(b);
                                    var x = l.i.N, k = x[b];
                                    void 0 === k || void 0 === k.B && k.className !== l.name && k.ea === c - 2 ? (u.ea = c - 2, u.className = l.name, x[b] = u) : ($c(x, b, v), x[b].B[c - 2] = u);
                                    Y([], p, function(t) {
                                        t = pd(v, t, l, f, g);
                                        void 0 === x[b].B ? (t.ea = c - 2, x[b] = t) : x[b].B[c - 2] = t;
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_property: function(a, b, c, d, e, f, g, n, p, l) {
                                b = W(b);
                                e = Z(d, e);
                                Y([], [
                                    a
                                ], function(u) {
                                    u = u[0];
                                    var v = `${u.name}.${b}`, x = {
                                        get () {
                                            od(`Cannot access ${v} due to unbound types`, [
                                                c,
                                                g
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    x.set = p ? ()=>{
                                        od(`Cannot access ${v} due to unbound types`, [
                                            c,
                                            g
                                        ]);
                                    } : ()=>{
                                        V(v + " is a read-only property");
                                    };
                                    Object.defineProperty(u.i.N, b, x);
                                    Y([], p ? [
                                        c,
                                        g
                                    ] : [
                                        c
                                    ], function(k) {
                                        var t = k[0], r = {
                                            get () {
                                                var D = td(this, u, v + " getter");
                                                return t.fromWireType(e(f, D));
                                            },
                                            enumerable: !0
                                        };
                                        if (p) {
                                            p = Z(n, p);
                                            var B = k[1];
                                            r.set = function(D) {
                                                var w = td(this, u, v + " setter"), M = [];
                                                p(l, w, B.toWireType(M, D));
                                                Rc(M);
                                            };
                                        }
                                        Object.defineProperty(u.i.N, b, r);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_emval: function(a, b) {
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(c) {
                                        var d = rc(c);
                                        ud(c);
                                        return d;
                                    },
                                    toWireType: function(c, d) {
                                        return sc(d);
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: null
                                });
                            },
                            _embind_register_enum: function(a, b, c, d) {
                                function e() {}
                                c = Wc(c);
                                b = W(b);
                                e.values = {};
                                Vc(a, {
                                    name: b,
                                    constructor: e,
                                    fromWireType: function(f) {
                                        return this.constructor.values[f];
                                    },
                                    toWireType: function(f, g) {
                                        return g.value;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: vd(b, c, d),
                                    K: null
                                });
                                ad(b, e);
                            },
                            _embind_register_enum_value: function(a, b, c) {
                                var d = Fc(a, "enum");
                                b = W(b);
                                a = d.constructor;
                                d = Object.create(d.constructor.prototype, {
                                    value: {
                                        value: c
                                    },
                                    constructor: {
                                        value: oc(`${d.name}_${b}`, function() {})
                                    }
                                });
                                a.values[c] = d;
                                a[b] = d;
                            },
                            _embind_register_float: function(a, b, c) {
                                c = Wc(c);
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(d) {
                                        return d;
                                    },
                                    toWireType: function(d, e) {
                                        return e;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: wd(b, c),
                                    K: null
                                });
                            },
                            _embind_register_function: function(a, b, c, d, e, f) {
                                var g = sd(b, c);
                                a = W(a);
                                e = Z(d, e);
                                ad(a, function() {
                                    od(`Cannot call ${a} due to unbound types`, g);
                                }, b - 1);
                                Y([], g, function(n) {
                                    jd(a, pd(a, [
                                        n[0],
                                        null
                                    ].concat(n.slice(1)), null, e, f), b - 1);
                                    return [];
                                });
                            },
                            _embind_register_integer: function(a, b, c, d, e) {
                                b = W(b);
                                -1 === e && (e = 4294967295);
                                e = Wc(c);
                                var f = (n)=>n;
                                if (0 === d) {
                                    var g = 32 - 8 * c;
                                    f = (n)=>n << g >>> g;
                                }
                                c = b.includes("unsigned") ? function(n, p) {
                                    return p >>> 0;
                                } : function(n, p) {
                                    return p;
                                };
                                Vc(a, {
                                    name: b,
                                    fromWireType: f,
                                    toWireType: c,
                                    argPackAdvance: 8,
                                    readValueFromPointer: xd(b, e, 0 !== d),
                                    K: null
                                });
                            },
                            _embind_register_memory_view: function(a, b, c) {
                                function d(f) {
                                    f >>= 2;
                                    var g = N;
                                    return new e(g.buffer, g[f + 1], g[f]);
                                }
                                var e = [
                                    Int8Array,
                                    Uint8Array,
                                    Int16Array,
                                    Uint16Array,
                                    Int32Array,
                                    Uint32Array,
                                    Float32Array,
                                    Float64Array
                                ][b];
                                c = W(c);
                                Vc(a, {
                                    name: c,
                                    fromWireType: d,
                                    argPackAdvance: 8,
                                    readValueFromPointer: d
                                }, {
                                    $b: !0
                                });
                            },
                            _embind_register_std_string: function(a, b) {
                                b = W(b);
                                var c = "std::string" === b;
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(d) {
                                        var e = N[d >> 2], f = d + 4;
                                        if (c) for(var g = f, n = 0; n <= e; ++n){
                                            var p = f + n;
                                            if (n == e || 0 == E[p]) {
                                                g = g ? nb(E, g, p - g) : "";
                                                if (void 0 === l) var l = g;
                                                else l += String.fromCharCode(0), l += g;
                                                g = p + 1;
                                            }
                                        }
                                        else {
                                            l = Array(e);
                                            for(n = 0; n < e; ++n)l[n] = String.fromCharCode(E[f + n]);
                                            l = l.join("");
                                        }
                                        Ec(d);
                                        return l;
                                    },
                                    toWireType: function(d, e) {
                                        e instanceof ArrayBuffer && (e = new Uint8Array(e));
                                        var f = "string" == typeof e;
                                        f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || V("Cannot pass non-string to std::string");
                                        var g = c && f ? pb(e) : e.length;
                                        var n = Wd(4 + g + 1), p = n + 4;
                                        N[n >> 2] = g;
                                        if (c && f) qb(e, E, p, g + 1);
                                        else {
                                            if (f) for(f = 0; f < g; ++f){
                                                var l = e.charCodeAt(f);
                                                255 < l && (Ec(p), V("String has UTF-16 code units that do not fit in 8 bits"));
                                                E[p + f] = l;
                                            }
                                            else for(f = 0; f < g; ++f)E[p + f] = e[f];
                                        }
                                        null !== d && d.push(Ec, n);
                                        return n;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: function(d) {
                                        Ec(d);
                                    }
                                });
                            },
                            _embind_register_std_wstring: function(a, b, c) {
                                c = W(c);
                                if (2 === b) {
                                    var d = zd;
                                    var e = Ad;
                                    var f = Bd;
                                    var g = ()=>Ea;
                                    var n = 1;
                                } else 4 === b && (d = Cd, e = Dd, f = Ed, g = ()=>N, n = 2);
                                Vc(a, {
                                    name: c,
                                    fromWireType: function(p) {
                                        for(var l = N[p >> 2], u = g(), v, x = p + 4, k = 0; k <= l; ++k){
                                            var t = p + 4 + k * b;
                                            if (k == l || 0 == u[t >> n]) x = d(x, t - x), void 0 === v ? v = x : (v += String.fromCharCode(0), v += x), x = t + b;
                                        }
                                        Ec(p);
                                        return v;
                                    },
                                    toWireType: function(p, l) {
                                        "string" != typeof l && V(`Cannot pass non-string to C++ string type ${c}`);
                                        var u = f(l), v = Wd(4 + u + b);
                                        N[v >> 2] = u >> n;
                                        e(l, v + 4, u + b);
                                        null !== p && p.push(Ec, v);
                                        return v;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: function(p) {
                                        Ec(p);
                                    }
                                });
                            },
                            _embind_register_value_object: function(a, b, c, d, e, f) {
                                Qc[a] = {
                                    name: W(b),
                                    Pa: Z(c, d),
                                    W: Z(e, f),
                                    eb: []
                                };
                            },
                            _embind_register_value_object_field: function(a, b, c, d, e, f, g, n, p, l) {
                                Qc[a].eb.push({
                                    Sb: W(b),
                                    Yb: c,
                                    Wb: Z(d, e),
                                    Xb: f,
                                    rc: g,
                                    qc: Z(n, p),
                                    sc: l
                                });
                            },
                            _embind_register_void: function(a, b) {
                                b = W(b);
                                Vc(a, {
                                    fc: !0,
                                    name: b,
                                    argPackAdvance: 0,
                                    fromWireType: function() {},
                                    toWireType: function() {}
                                });
                            },
                            _emscripten_get_now_is_monotonic: ()=>!0,
                            _emval_as: function(a, b, c) {
                                a = rc(a);
                                b = Fc(b, "emval::as");
                                var d = [], e = sc(d);
                                N[c >> 2] = e;
                                return b.toWireType(d, a);
                            },
                            _emval_call_method: function(a, b, c, d, e) {
                                a = Hd[a];
                                b = rc(b);
                                c = Gd(c);
                                var f = [];
                                N[d >> 2] = sc(f);
                                return a(b, c, f, e);
                            },
                            _emval_call_void_method: function(a, b, c, d) {
                                a = Hd[a];
                                b = rc(b);
                                c = Gd(c);
                                a(b, c, null, d);
                            },
                            _emval_decref: ud,
                            _emval_get_method_caller: function(a, b) {
                                var c = Jd(a, b), d = c[0];
                                b = d.name + "_$" + c.slice(1).map(function(g) {
                                    return g.name;
                                }).join("_") + "$";
                                var e = Kd[b];
                                if (void 0 !== e) return e;
                                var f = Array(a - 1);
                                e = Id((g, n, p, l)=>{
                                    for(var u = 0, v = 0; v < a - 1; ++v)f[v] = c[v + 1].readValueFromPointer(l + u), u += c[v + 1].argPackAdvance;
                                    g = g[n].apply(g, f);
                                    for(v = 0; v < a - 1; ++v)c[v + 1].Nb && c[v + 1].Nb(f[v]);
                                    if (!d.fc) return d.toWireType(p, g);
                                });
                                return Kd[b] = e;
                            },
                            _emval_get_module_property: function(a) {
                                a = Gd(a);
                                return sc(m[a]);
                            },
                            _emval_get_property: function(a, b) {
                                a = rc(a);
                                b = rc(b);
                                return sc(a[b]);
                            },
                            _emval_incref: function(a) {
                                4 < a && (U.get(a).tb += 1);
                            },
                            _emval_new_cstring: function(a) {
                                return sc(Gd(a));
                            },
                            _emval_new_object: function() {
                                return sc({});
                            },
                            _emval_run_destructors: function(a) {
                                var b = rc(a);
                                Rc(b);
                                ud(a);
                            },
                            _emval_set_property: function(a, b, c) {
                                a = rc(a);
                                b = rc(b);
                                c = rc(c);
                                a[b] = c;
                            },
                            _emval_take_value: function(a, b) {
                                a = Fc(a, "_emval_take_value");
                                a = a.readValueFromPointer(b);
                                return sc(a);
                            },
                            abort: ()=>{
                                Aa("");
                            },
                            emscripten_asm_const_int: (a, b, c)=>{
                                Ld.length = 0;
                                var d;
                                for(c >>= 2; d = E[b++];)c += 105 != d & c, Ld.push(105 == d ? L[c] : Ia[c++ >> 1]), ++c;
                                return db[a].apply(null, Ld);
                            },
                            emscripten_date_now: function() {
                                return Date.now();
                            },
                            emscripten_get_now: ()=>performance.now(),
                            emscripten_memcpy_big: (a, b, c)=>E.copyWithin(a, b, b + c),
                            emscripten_resize_heap: (a)=>{
                                var b = E.length;
                                a >>>= 0;
                                if (2147483648 < a) return !1;
                                for(var c = 1; 4 >= c; c *= 2){
                                    var d = b * (1 + 0.2 / c);
                                    d = Math.min(d, a + 100663296);
                                    var e = Math;
                                    d = Math.max(a, d);
                                    a: {
                                        e = e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - Ba.buffer.byteLength + 65535 >>> 16;
                                        try {
                                            Ba.grow(e);
                                            Ja();
                                            var f = 1;
                                            break a;
                                        } catch (g) {}
                                        f = void 0;
                                    }
                                    if (f) return !0;
                                }
                                return !1;
                            },
                            environ_get: (a, b)=>{
                                var c = 0;
                                Od().forEach(function(d, e) {
                                    var f = b + c;
                                    e = N[a + 4 * e >> 2] = f;
                                    for(f = 0; f < d.length; ++f)C[e++ >> 0] = d.charCodeAt(f);
                                    C[e >> 0] = 0;
                                    c += d.length + 1;
                                });
                                return 0;
                            },
                            environ_sizes_get: (a, b)=>{
                                var c = Od();
                                N[a >> 2] = c.length;
                                var d = 0;
                                c.forEach(function(e) {
                                    d += e.length + 1;
                                });
                                N[b >> 2] = d;
                                return 0;
                            },
                            fd_close: function(a) {
                                try {
                                    var b = Tb(a);
                                    if (null === b.X) throw new O(8);
                                    b.Ma && (b.Ma = null);
                                    try {
                                        b.m.close && b.m.close(b);
                                    } catch (c) {
                                        throw c;
                                    } finally{
                                        Gb[b.X] = null;
                                    }
                                    b.X = null;
                                    return 0;
                                } catch (c) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== c.name) throw c;
                                    return c.aa;
                                }
                            },
                            fd_read: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Tb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var n = N[a >> 2], p = N[a + 4 >> 2];
                                            a += 8;
                                            var l = e, u = n, v = p, x = f, k = C;
                                            if (0 > v || 0 > x) throw new O(28);
                                            if (null === l.X) throw new O(8);
                                            if (1 === (l.flags & 2097155)) throw new O(8);
                                            if (16384 === (l.node.mode & 61440)) throw new O(31);
                                            if (!l.m.read) throw new O(28);
                                            var t = "undefined" != typeof x;
                                            if (!t) x = l.position;
                                            else if (!l.seekable) throw new O(70);
                                            var r = l.m.read(l, k, u, v, x);
                                            t || (l.position += r);
                                            var B = r;
                                            if (0 > B) {
                                                var D = -1;
                                                break a;
                                            }
                                            b += B;
                                            if (B < p) break;
                                            "undefined" !== typeof f && (f += B);
                                        }
                                        D = b;
                                    }
                                    N[d >> 2] = D;
                                    return 0;
                                } catch (w) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== w.name) throw w;
                                    return w.aa;
                                }
                            },
                            fd_seek: function(a, b, c, d, e) {
                                b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
                                try {
                                    if (isNaN(b)) return 61;
                                    var f = Tb(a);
                                    fc(f, b, d);
                                    $a = [
                                        f.position >>> 0,
                                        (Za = f.position, 1.0 <= +Math.abs(Za) ? 0.0 < Za ? +Math.floor(Za / 4294967296.0) >>> 0 : ~~+Math.ceil((Za - +(~~Za >>> 0)) / 4294967296.0) >>> 0 : 0)
                                    ];
                                    L[e >> 2] = $a[0];
                                    L[e + 4 >> 2] = $a[1];
                                    f.Ma && 0 === b && 0 === d && (f.Ma = null);
                                    return 0;
                                } catch (g) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== g.name) throw g;
                                    return g.aa;
                                }
                            },
                            fd_write: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Tb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var n = N[a >> 2], p = N[a + 4 >> 2];
                                            a += 8;
                                            var l = e, u = n, v = p, x = f, k = C;
                                            if (0 > v || 0 > x) throw new O(28);
                                            if (null === l.X) throw new O(8);
                                            if (0 === (l.flags & 2097155)) throw new O(8);
                                            if (16384 === (l.node.mode & 61440)) throw new O(31);
                                            if (!l.m.write) throw new O(28);
                                            l.seekable && l.flags & 1024 && fc(l, 0, 2);
                                            var t = "undefined" != typeof x;
                                            if (!t) x = l.position;
                                            else if (!l.seekable) throw new O(70);
                                            var r = l.m.write(l, k, u, v, x, void 0);
                                            t || (l.position += r);
                                            var B = r;
                                            if (0 > B) {
                                                var D = -1;
                                                break a;
                                            }
                                            b += B;
                                            "undefined" !== typeof f && (f += B);
                                        }
                                        D = b;
                                    }
                                    N[d >> 2] = D;
                                    return 0;
                                } catch (w) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== w.name) throw w;
                                    return w.aa;
                                }
                            },
                            strftime_l: (a, b, c, d)=>Sd(a, b, c, d)
                        };
                        (function() {
                            function a(c) {
                                z = c = c.exports;
                                Ba = z.memory;
                                Ja();
                                Ka = z.__indirect_function_table;
                                Ma.unshift(z.__wasm_call_ctors);
                                Pa--;
                                m.monitorRunDependencies && m.monitorRunDependencies(Pa);
                                if (0 == Pa && (null !== Qa && (clearInterval(Qa), Qa = null), Ra)) {
                                    var d = Ra;
                                    Ra = null;
                                    d();
                                }
                                return c;
                            }
                            var b = {
                                env: Xd,
                                wasi_snapshot_preview1: Xd
                            };
                            Pa++;
                            m.monitorRunDependencies && m.monitorRunDependencies(Pa);
                            if (m.instantiateWasm) try {
                                return m.instantiateWasm(b, a);
                            } catch (c) {
                                xa("Module.instantiateWasm callback failed with error: " + c), ea(c);
                            }
                            Ya(b, function(c) {
                                a(c.instance);
                            }).catch(ea);
                            return {};
                        })();
                        var Ec = (a)=>(Ec = z.free)(a), Wd = (a)=>(Wd = z.malloc)(a), ab = m._ma_device__on_notification_unlocked = (a)=>(ab = m._ma_device__on_notification_unlocked = z.ma_device__on_notification_unlocked)(a);
                        m._ma_malloc_emscripten = (a, b)=>(m._ma_malloc_emscripten = z.ma_malloc_emscripten)(a, b);
                        m._ma_free_emscripten = (a, b)=>(m._ma_free_emscripten = z.ma_free_emscripten)(a, b);
                        var bb = m._ma_device_process_pcm_frames_capture__webaudio = (a, b, c)=>(bb = m._ma_device_process_pcm_frames_capture__webaudio = z.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), cb = m._ma_device_process_pcm_frames_playback__webaudio = (a, b, c)=>(cb = m._ma_device_process_pcm_frames_playback__webaudio = z.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), Vd = ()=>(Vd = z.__errno_location)(), Dc = (a)=>(Dc = z.__getTypeName)(a);
                        m.__embind_initialize_bindings = ()=>(m.__embind_initialize_bindings = z._embind_initialize_bindings)();
                        m.dynCall_iiji = (a, b, c, d, e)=>(m.dynCall_iiji = z.dynCall_iiji)(a, b, c, d, e);
                        m.dynCall_jiji = (a, b, c, d, e)=>(m.dynCall_jiji = z.dynCall_jiji)(a, b, c, d, e);
                        m.dynCall_iiiji = (a, b, c, d, e, f)=>(m.dynCall_iiiji = z.dynCall_iiiji)(a, b, c, d, e, f);
                        m.dynCall_iij = (a, b, c, d)=>(m.dynCall_iij = z.dynCall_iij)(a, b, c, d);
                        m.dynCall_jii = (a, b, c)=>(m.dynCall_jii = z.dynCall_jii)(a, b, c);
                        m.dynCall_viijii = (a, b, c, d, e, f, g)=>(m.dynCall_viijii = z.dynCall_viijii)(a, b, c, d, e, f, g);
                        m.dynCall_iiiiij = (a, b, c, d, e, f, g)=>(m.dynCall_iiiiij = z.dynCall_iiiiij)(a, b, c, d, e, f, g);
                        m.dynCall_iiiiijj = (a, b, c, d, e, f, g, n, p)=>(m.dynCall_iiiiijj = z.dynCall_iiiiijj)(a, b, c, d, e, f, g, n, p);
                        m.dynCall_iiiiiijj = (a, b, c, d, e, f, g, n, p, l)=>(m.dynCall_iiiiiijj = z.dynCall_iiiiiijj)(a, b, c, d, e, f, g, n, p, l);
                        var Yd;
                        Ra = function Zd() {
                            Yd || $d();
                            Yd || (Ra = Zd);
                        };
                        function $d() {
                            function a() {
                                if (!Yd && (Yd = !0, m.calledRun = !0, !Ca)) {
                                    m.noFSInit || hc || (hc = !0, gc(), m.stdin = m.stdin, m.stdout = m.stdout, m.stderr = m.stderr, m.stdin ? jc("stdin", m.stdin) : cc("/dev/tty", "/dev/stdin"), m.stdout ? jc("stdout", null, m.stdout) : cc("/dev/tty", "/dev/stdout"), m.stderr ? jc("stderr", null, m.stderr) : cc("/dev/tty1", "/dev/stderr"), ec("/dev/stdin", 0), ec("/dev/stdout", 1), ec("/dev/stderr", 1));
                                    Jb = !1;
                                    eb(Ma);
                                    aa(m);
                                    if (m.onRuntimeInitialized) m.onRuntimeInitialized();
                                    if (m.postRun) for("function" == typeof m.postRun && (m.postRun = [
                                        m.postRun
                                    ]); m.postRun.length;){
                                        var b = m.postRun.shift();
                                        Na.unshift(b);
                                    }
                                    eb(Na);
                                }
                            }
                            if (!(0 < Pa)) {
                                if (m.preRun) for("function" == typeof m.preRun && (m.preRun = [
                                    m.preRun
                                ]); m.preRun.length;)Oa();
                                eb(La);
                                0 < Pa || (m.setStatus ? (m.setStatus("Running..."), setTimeout(function() {
                                    setTimeout(function() {
                                        m.setStatus("");
                                    }, 1);
                                    a();
                                }, 1)) : a());
                            }
                        }
                        if (m.preInit) for("function" == typeof m.preInit && (m.preInit = [
                            m.preInit
                        ]); 0 < m.preInit.length;)m.preInit.pop()();
                        $d();
                        return moduleArg.ready;
                    };
                })();
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Rive;
            /***/ },
            /* 2 */ /***/ (module1)=>{
                module1.exports = /*#__PURE__*/ JSON.parse('{"name":"@rive-app/canvas","version":"2.26.4","description":"Rive\'s canvas based web api.","main":"rive.js","homepage":"https://rive.app","repository":{"type":"git","url":"https://github.com/rive-app/rive-wasm/tree/master/js"},"keywords":["rive","animation"],"author":"Rive","contributors":["Luigi Rosso <luigi@rive.app> (https://rive.app)","Maxwell Talbot <max@rive.app> (https://rive.app)","Arthur Vivian <arthur@rive.app> (https://rive.app)","Umberto Sonnino <umberto@rive.app> (https://rive.app)","Matthew Sullivan <matt.j.sullivan@gmail.com> (mailto:matt.j.sullivan@gmail.com)"],"license":"MIT","files":["rive.js","rive.js.map","rive.wasm","rive_fallback.wasm","rive.d.ts","rive_advanced.mjs.d.ts"],"typings":"rive.d.ts","dependencies":{},"browser":{"fs":false,"path":false}}');
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* reexport safe */ _Animation__WEBPACK_IMPORTED_MODULE_0__.Animation
                });
                /* harmony import */ var _Animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* binding */ Animation
                });
                /**
 * Represents an animation that can be played on an Artboard.
 * Wraps animations and instances from the runtime and keeps track of playback state.
 *
 * The `Animation` class manages the state and behavior of a single animation instance,
 * including its current time, loop count, and ability to scrub to a specific time.
 *
 * The class provides methods to advance the animation, apply its interpolated keyframe
 * values to the Artboard, and clean up the underlying animation instance when the
 * animation is no longer needed.
 */ var Animation = /** @class */ function() {
                    /**
     * Constructs a new animation
     * @constructor
     * @param {any} animation: runtime animation object
     * @param {any} instance: runtime animation instance object
     */ function Animation(animation, artboard, runtime, playing) {
                        this.animation = animation;
                        this.artboard = artboard;
                        this.playing = playing;
                        this.loopCount = 0;
                        /**
         * The time to which the animation should move to on the next render.
         * If not null, the animation will scrub to this time instead of advancing by the given time.
         */ this.scrubTo = null;
                        this.instance = new runtime.LinearAnimationInstance(animation, artboard);
                    }
                    Object.defineProperty(Animation.prototype, "name", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.animation.name;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "time", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.instance.time;
                        },
                        /**
         * Sets the animation's current time
         */ set: function(value) {
                            this.instance.time = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "loopValue", {
                        /**
         * Returns the animation's loop type
         */ get: function() {
                            return this.animation.loopValue;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "needsScrub", {
                        /**
         * Indicates whether the animation needs to be scrubbed.
         * @returns `true` if the animation needs to be scrubbed, `false` otherwise.
         */ get: function() {
                            return this.scrubTo !== null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Advances the animation by the give time. If the animation needs scrubbing,
     * time is ignored and the stored scrub value is used.
     * @param time the time to advance the animation by if no scrubbing required
     */ Animation.prototype.advance = function(time) {
                        if (this.scrubTo === null) this.instance.advance(time);
                        else {
                            this.instance.time = 0;
                            this.instance.advance(this.scrubTo);
                            this.scrubTo = null;
                        }
                    };
                    /**
     * Apply interpolated keyframe values to the artboard. This should be called after calling
     * .advance() on an animation instance so that new values are applied to properties.
     *
     * Note: This does not advance the artboard, which updates all objects on the artboard
     * @param mix - Mix value for the animation from 0 to 1
     */ Animation.prototype.apply = function(mix) {
                        this.instance.apply(mix);
                    };
                    /**
     * Deletes the backing Wasm animation instance; once this is called, this
     * animation is no more.
     */ Animation.prototype.cleanup = function() {
                        this.instance.delete();
                    };
                    return Animation;
                }();
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.BLANK_URL,
                    /* harmony export */ registerTouchInteractions: ()=>/* reexport safe */ _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__.registerTouchInteractions,
                    /* harmony export */ sanitizeUrl: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.sanitizeUrl
                });
                /* harmony import */ var _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
                /* harmony import */ var _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ registerTouchInteractions: ()=>/* binding */ registerTouchInteractions
                });
                var _this = undefined;
                /**
 * Returns the clientX and clientY properties from touch or mouse events. Also
 * calls preventDefault() on the event if it is a touchstart or touchmove to prevent
 * scrolling the page on mobile devices
 * @param event - Either a TouchEvent or a MouseEvent
 * @returns - Coordinates of the clientX and clientY properties from the touch/mouse event
 */ var getClientCoordinates = function(event, isTouchScrollEnabled) {
                    var _a, _b;
                    if ([
                        "touchstart",
                        "touchmove"
                    ].indexOf(event.type) > -1 && ((_a = event.touches) === null || _a === void 0 ? void 0 : _a.length)) {
                        // This flag, if false, prevents touch events on the canvas default behavior
                        // which may prevent scrolling if a drag motion on the canvas is performed
                        if (!isTouchScrollEnabled) event.preventDefault();
                        return {
                            clientX: event.touches[0].clientX,
                            clientY: event.touches[0].clientY
                        };
                    } else if (event.type === "touchend" && ((_b = event.changedTouches) === null || _b === void 0 ? void 0 : _b.length)) return {
                        clientX: event.changedTouches[0].clientX,
                        clientY: event.changedTouches[0].clientY
                    };
                    else return {
                        clientX: event.clientX,
                        clientY: event.clientY
                    };
                };
                /**
 * Registers mouse move/up/down callback handlers on the canvas to send meaningful coordinates to
 * the state machine pointer move/up/down functions based on cursor interaction
 */ var registerTouchInteractions = function(_a) {
                    var canvas = _a.canvas, artboard = _a.artboard, _b = _a.stateMachines, stateMachines = _b === void 0 ? [] : _b, renderer = _a.renderer, rive = _a.rive, fit = _a.fit, alignment = _a.alignment, _c = _a.isTouchScrollEnabled, isTouchScrollEnabled = _c === void 0 ? false : _c, _d = _a.layoutScaleFactor, layoutScaleFactor = _d === void 0 ? 1.0 : _d;
                    if (!canvas || !stateMachines.length || !renderer || !rive || !artboard || typeof window === "undefined") return null;
                    /**
     * After a touchend event, some browsers may fire synthetic mouse events
     * (mouseover, mousedown, mousemove, mouseup) if the touch interaction did not cause
     * any default action (such as scrolling).
     *
     * This is done to simulate the behavior of a mouse for applications that do not support
     * touch events.
     *
     * We're keeping track of the previous event to not send the synthetic mouse events if the
     * touch event was a click (touchstart -> touchend).
     *
     * This is only needed when `isTouchScrollEnabled` is false
     * When true, `preventDefault()` is called which prevents this behaviour.
     **/ var _prevEventType = null;
                    var _syntheticEventsActive = false;
                    var processEventCallback = function(event) {
                        // Exit early out of all synthetic mouse events
                        // https://stackoverflow.com/questions/9656990/how-to-prevent-simulated-mouse-events-in-mobile-browsers
                        // https://stackoverflow.com/questions/25572070/javascript-touchend-versus-click-dilemma
                        if (_syntheticEventsActive && event instanceof MouseEvent) {
                            // Synthetic event finished
                            if (event.type == "mouseup") _syntheticEventsActive = false;
                            return;
                        }
                        // Test if it's a "touch click". This could cause the browser to send
                        // synthetic mouse events.
                        _syntheticEventsActive = isTouchScrollEnabled && event.type === "touchend" && _prevEventType === "touchstart";
                        _prevEventType = event.type;
                        var boundingRect = event.currentTarget.getBoundingClientRect();
                        var _a = getClientCoordinates(event, isTouchScrollEnabled), clientX = _a.clientX, clientY = _a.clientY;
                        if (!clientX && !clientY) return;
                        var canvasX = clientX - boundingRect.left;
                        var canvasY = clientY - boundingRect.top;
                        var forwardMatrix = rive.computeAlignment(fit, alignment, {
                            minX: 0,
                            minY: 0,
                            maxX: boundingRect.width,
                            maxY: boundingRect.height
                        }, artboard.bounds, layoutScaleFactor);
                        var invertedMatrix = new rive.Mat2D();
                        forwardMatrix.invert(invertedMatrix);
                        var canvasCoordinatesVector = new rive.Vec2D(canvasX, canvasY);
                        var transformedVector = rive.mapXY(invertedMatrix, canvasCoordinatesVector);
                        var transformedX = transformedVector.x();
                        var transformedY = transformedVector.y();
                        transformedVector.delete();
                        invertedMatrix.delete();
                        canvasCoordinatesVector.delete();
                        forwardMatrix.delete();
                        switch(event.type){
                            /**
             * There's a 2px buffer for a hitRadius when translating the pointer coordinates
             * down to the state machine. In cases where the hitbox is about that much away
             * from the Artboard border, we don't have exact precision on determining pointer
             * exit. We're therefore adding to the translated coordinates on mouseout of a canvas
             * to ensure that we report the mouse has truly exited the hitarea.
             * https://github.com/rive-app/rive-cpp/blob/master/src/animation/state_machine_instance.cpp#L336
             *
             * We add/subtract 10000 to account for when the graphic goes beyond the canvas bound
             * due to for example, a fit: 'cover'. Not perfect, but helps reliably (for now) ensure
             * we report going out of bounds when the mouse is out of the canvas
             */ case "mouseout":
                                for(var _i = 0, stateMachines_1 = stateMachines; _i < stateMachines_1.length; _i++){
                                    var stateMachine = stateMachines_1[_i];
                                    stateMachine.pointerMove(transformedX, transformedY);
                                }
                                break;
                            // Pointer moving/hovering on the canvas
                            case "touchmove":
                            case "mouseover":
                            case "mousemove":
                                for(var _b = 0, stateMachines_2 = stateMachines; _b < stateMachines_2.length; _b++){
                                    var stateMachine = stateMachines_2[_b];
                                    stateMachine.pointerMove(transformedX, transformedY);
                                }
                                break;
                            // Pointer click initiated but not released yet on the canvas
                            case "touchstart":
                            case "mousedown":
                                for(var _c = 0, stateMachines_3 = stateMachines; _c < stateMachines_3.length; _c++){
                                    var stateMachine = stateMachines_3[_c];
                                    stateMachine.pointerDown(transformedX, transformedY);
                                }
                                break;
                            // Pointer click released on the canvas
                            case "touchend":
                            case "mouseup":
                                for(var _d = 0, stateMachines_4 = stateMachines; _d < stateMachines_4.length; _d++){
                                    var stateMachine = stateMachines_4[_d];
                                    stateMachine.pointerUp(transformedX, transformedY);
                                }
                                break;
                            default:
                        }
                    };
                    var callback = processEventCallback.bind(_this);
                    canvas.addEventListener("mouseover", callback);
                    canvas.addEventListener("mouseout", callback);
                    canvas.addEventListener("mousemove", callback);
                    canvas.addEventListener("mousedown", callback);
                    canvas.addEventListener("mouseup", callback);
                    canvas.addEventListener("touchmove", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchstart", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchend", callback);
                    return function() {
                        canvas.removeEventListener("mouseover", callback);
                        canvas.removeEventListener("mouseout", callback);
                        canvas.removeEventListener("mousemove", callback);
                        canvas.removeEventListener("mousedown", callback);
                        canvas.removeEventListener("mouseup", callback);
                        canvas.removeEventListener("touchmove", callback);
                        canvas.removeEventListener("touchstart", callback);
                        canvas.removeEventListener("touchend", callback);
                    };
                };
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: ()=>/* binding */ BLANK_URL,
                    /* harmony export */ sanitizeUrl: ()=>/* binding */ sanitizeUrl
                });
                // Reference: https://github.com/braintree/sanitize-url/tree/main
                var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
                var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
                var htmlCtrlEntityRegex = /&(newline|tab);/gi;
                var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
                var urlSchemeRegex = /^.+(:|&colon;)/gim;
                var relativeFirstCharacters = [
                    ".",
                    "/"
                ];
                var BLANK_URL = "about:blank";
                function isRelativeUrlWithoutProtocol(url) {
                    return relativeFirstCharacters.indexOf(url[0]) > -1;
                }
                // adapted from https://stackoverflow.com/a/29824550/2601552
                function decodeHtmlCharacters(str) {
                    var removedNullByte = str.replace(ctrlCharactersRegex, "");
                    return removedNullByte.replace(htmlEntitiesRegex, function(match, dec) {
                        return String.fromCharCode(dec);
                    });
                }
                function sanitizeUrl(url) {
                    if (!url) return BLANK_URL;
                    var sanitizedUrl = decodeHtmlCharacters(url).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").trim();
                    if (!sanitizedUrl) return BLANK_URL;
                    if (isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
                    var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
                    if (!urlSchemeParseResults) return sanitizedUrl;
                    var urlScheme = urlSchemeParseResults[0];
                    if (invalidProtocolRegex.test(urlScheme)) return BLANK_URL;
                    return sanitizedUrl;
                }
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
        (()=>{
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ Alignment: ()=>/* binding */ Alignment,
                /* harmony export */ EventType: ()=>/* binding */ EventType,
                /* harmony export */ Fit: ()=>/* binding */ Fit,
                /* harmony export */ Layout: ()=>/* binding */ Layout,
                /* harmony export */ LoopType: ()=>/* binding */ LoopType,
                /* harmony export */ Rive: ()=>/* binding */ Rive,
                /* harmony export */ RiveEventType: ()=>/* binding */ RiveEventType,
                /* harmony export */ RiveFile: ()=>/* binding */ RiveFile,
                /* harmony export */ RuntimeLoader: ()=>/* binding */ RuntimeLoader,
                /* harmony export */ StateMachineInput: ()=>/* binding */ StateMachineInput,
                /* harmony export */ StateMachineInputType: ()=>/* binding */ StateMachineInputType,
                /* harmony export */ Testing: ()=>/* binding */ Testing,
                /* harmony export */ decodeAudio: ()=>/* binding */ decodeAudio,
                /* harmony export */ decodeFont: ()=>/* binding */ decodeFont,
                /* harmony export */ decodeImage: ()=>/* binding */ decodeImage
            });
            /* harmony import */ var _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
            /* harmony import */ var package_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
            /* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
            /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
                return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            var RiveError = /** @class */ function(_super) {
                __extends(RiveError, _super);
                function RiveError() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.isHandledError = true;
                    return _this;
                }
                return RiveError;
            }(Error);
            // #regions helpers
            var resolveErrorMessage = function(error) {
                return error && error.isHandledError ? error.message : "Problem loading file; may be corrupt!";
            };
            // #region layout
            // Fit options for the canvas
            var Fit;
            (function(Fit) {
                Fit["Cover"] = "cover";
                Fit["Contain"] = "contain";
                Fit["Fill"] = "fill";
                Fit["FitWidth"] = "fitWidth";
                Fit["FitHeight"] = "fitHeight";
                Fit["None"] = "none";
                Fit["ScaleDown"] = "scaleDown";
                Fit["Layout"] = "layout";
            })(Fit || (Fit = {}));
            // Alignment options for the canvas
            var Alignment;
            (function(Alignment) {
                Alignment["Center"] = "center";
                Alignment["TopLeft"] = "topLeft";
                Alignment["TopCenter"] = "topCenter";
                Alignment["TopRight"] = "topRight";
                Alignment["CenterLeft"] = "centerLeft";
                Alignment["CenterRight"] = "centerRight";
                Alignment["BottomLeft"] = "bottomLeft";
                Alignment["BottomCenter"] = "bottomCenter";
                Alignment["BottomRight"] = "bottomRight";
            })(Alignment || (Alignment = {}));
            // Alignment options for Rive animations in a HTML canvas
            var Layout = /** @class */ function() {
                function Layout(params) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    this.fit = (_a = params === null || params === void 0 ? void 0 : params.fit) !== null && _a !== void 0 ? _a : Fit.Contain;
                    this.alignment = (_b = params === null || params === void 0 ? void 0 : params.alignment) !== null && _b !== void 0 ? _b : Alignment.Center;
                    this.layoutScaleFactor = (_c = params === null || params === void 0 ? void 0 : params.layoutScaleFactor) !== null && _c !== void 0 ? _c : 1;
                    this.minX = (_d = params === null || params === void 0 ? void 0 : params.minX) !== null && _d !== void 0 ? _d : 0;
                    this.minY = (_e = params === null || params === void 0 ? void 0 : params.minY) !== null && _e !== void 0 ? _e : 0;
                    this.maxX = (_f = params === null || params === void 0 ? void 0 : params.maxX) !== null && _f !== void 0 ? _f : 0;
                    this.maxY = (_g = params === null || params === void 0 ? void 0 : params.maxY) !== null && _g !== void 0 ? _g : 0;
                }
                // Alternative constructor to build a Layout from an interface/object
                Layout.new = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    console.warn("This function is deprecated: please use `new Layout({})` instead");
                    return new Layout({
                        fit: fit,
                        alignment: alignment,
                        minX: minX,
                        minY: minY,
                        maxX: maxX,
                        maxY: maxY
                    });
                };
                /**
     * Makes a copy of the layout, replacing any specified parameters
     */ Layout.prototype.copyWith = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, layoutScaleFactor = _a.layoutScaleFactor, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    return new Layout({
                        fit: fit !== null && fit !== void 0 ? fit : this.fit,
                        alignment: alignment !== null && alignment !== void 0 ? alignment : this.alignment,
                        layoutScaleFactor: layoutScaleFactor !== null && layoutScaleFactor !== void 0 ? layoutScaleFactor : this.layoutScaleFactor,
                        minX: minX !== null && minX !== void 0 ? minX : this.minX,
                        minY: minY !== null && minY !== void 0 ? minY : this.minY,
                        maxX: maxX !== null && maxX !== void 0 ? maxX : this.maxX,
                        maxY: maxY !== null && maxY !== void 0 ? maxY : this.maxY
                    });
                };
                // Returns fit for the Wasm runtime format
                Layout.prototype.runtimeFit = function(rive) {
                    if (this.cachedRuntimeFit) return this.cachedRuntimeFit;
                    var fit;
                    if (this.fit === Fit.Cover) fit = rive.Fit.cover;
                    else if (this.fit === Fit.Contain) fit = rive.Fit.contain;
                    else if (this.fit === Fit.Fill) fit = rive.Fit.fill;
                    else if (this.fit === Fit.FitWidth) fit = rive.Fit.fitWidth;
                    else if (this.fit === Fit.FitHeight) fit = rive.Fit.fitHeight;
                    else if (this.fit === Fit.ScaleDown) fit = rive.Fit.scaleDown;
                    else if (this.fit === Fit.Layout) fit = rive.Fit.layout;
                    else fit = rive.Fit.none;
                    this.cachedRuntimeFit = fit;
                    return fit;
                };
                // Returns alignment for the Wasm runtime format
                Layout.prototype.runtimeAlignment = function(rive) {
                    if (this.cachedRuntimeAlignment) return this.cachedRuntimeAlignment;
                    var alignment;
                    if (this.alignment === Alignment.TopLeft) alignment = rive.Alignment.topLeft;
                    else if (this.alignment === Alignment.TopCenter) alignment = rive.Alignment.topCenter;
                    else if (this.alignment === Alignment.TopRight) alignment = rive.Alignment.topRight;
                    else if (this.alignment === Alignment.CenterLeft) alignment = rive.Alignment.centerLeft;
                    else if (this.alignment === Alignment.CenterRight) alignment = rive.Alignment.centerRight;
                    else if (this.alignment === Alignment.BottomLeft) alignment = rive.Alignment.bottomLeft;
                    else if (this.alignment === Alignment.BottomCenter) alignment = rive.Alignment.bottomCenter;
                    else if (this.alignment === Alignment.BottomRight) alignment = rive.Alignment.bottomRight;
                    else alignment = rive.Alignment.center;
                    this.cachedRuntimeAlignment = alignment;
                    return alignment;
                };
                return Layout;
            }();
            // Runtime singleton; use getInstance to provide a callback that returns the
            // Rive runtime
            var RuntimeLoader = /** @class */ function() {
                // Class is never instantiated
                function RuntimeLoader() {}
                // Loads the runtime
                RuntimeLoader.loadRuntime = function() {
                    _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__["default"]({
                        // Loads Wasm bundle
                        locateFile: function() {
                            return RuntimeLoader.wasmURL;
                        }
                    }).then(function(rive) {
                        var _a;
                        RuntimeLoader.runtime = rive;
                        // Fire all the callbacks
                        while(RuntimeLoader.callBackQueue.length > 0)(_a = RuntimeLoader.callBackQueue.shift()) === null || _a === void 0 || _a(RuntimeLoader.runtime);
                    }).catch(function(error) {
                        // Capture specific error details
                        var errorDetails = {
                            message: (error === null || error === void 0 ? void 0 : error.message) || "Unknown error",
                            type: (error === null || error === void 0 ? void 0 : error.name) || "Error",
                            // Some browsers may provide additional WebAssembly-specific details
                            wasmError: error instanceof WebAssembly.CompileError || error instanceof WebAssembly.RuntimeError,
                            originalError: error
                        };
                        // Log detailed error for debugging
                        console.debug("Rive WASM load error details:", errorDetails);
                        // In case unpkg fails, or the wasm was not supported, we try to load the fallback module from jsdelivr.
                        // This `rive_fallback.wasm` is compiled to support older architecture.
                        // TODO: (Gordon): preemptively test browser support and load the correct wasm file. Then use jsdelvr only if unpkg fails.
                        var backupJsdelivrUrl = "https://cdn.jsdelivr.net/npm/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive_fallback.wasm");
                        if (RuntimeLoader.wasmURL.toLowerCase() !== backupJsdelivrUrl) {
                            console.warn("Failed to load WASM from ".concat(RuntimeLoader.wasmURL, " (").concat(errorDetails.message, "), trying jsdelivr as a backup"));
                            RuntimeLoader.setWasmUrl(backupJsdelivrUrl);
                            RuntimeLoader.loadRuntime();
                        } else {
                            var errorMessage = [
                                "Could not load Rive WASM file from ".concat(RuntimeLoader.wasmURL, " or ").concat(backupJsdelivrUrl, "."),
                                "Possible reasons:",
                                "- Network connection is down",
                                "- WebAssembly is not supported in this environment",
                                "- The WASM file is corrupted or incompatible",
                                "\nError details:",
                                "- Type: ".concat(errorDetails.type),
                                "- Message: ".concat(errorDetails.message),
                                "- WebAssembly-specific error: ".concat(errorDetails.wasmError),
                                "\nTo resolve, you may need to:",
                                "1. Check your network connection",
                                "2. Set a new WASM source via RuntimeLoader.setWasmUrl()",
                                "3. Call RuntimeLoader.loadRuntime() again"
                            ].join("\n");
                            console.error(errorMessage);
                        }
                    });
                };
                // Provides a runtime instance via a callback
                RuntimeLoader.getInstance = function(callback) {
                    // If it's not loading, start loading runtime
                    if (!RuntimeLoader.isLoading) {
                        RuntimeLoader.isLoading = true;
                        RuntimeLoader.loadRuntime();
                    }
                    if (!RuntimeLoader.runtime) RuntimeLoader.callBackQueue.push(callback);
                    else callback(RuntimeLoader.runtime);
                };
                // Provides a runtime instance via a promise
                RuntimeLoader.awaitInstance = function() {
                    return new Promise(function(resolve) {
                        return RuntimeLoader.getInstance(function(rive) {
                            return resolve(rive);
                        });
                    });
                };
                // Manually sets the wasm url
                RuntimeLoader.setWasmUrl = function(url) {
                    RuntimeLoader.wasmURL = url;
                };
                // Gets the current wasm url
                RuntimeLoader.getWasmUrl = function() {
                    return RuntimeLoader.wasmURL;
                };
                // Flag to indicate that loading has started/completed
                RuntimeLoader.isLoading = false;
                // List of callbacks for the runtime that come in while loading
                RuntimeLoader.callBackQueue = [];
                // Path to the Wasm file; default path works for testing only;
                // if embedded wasm is used then this is never used.
                RuntimeLoader.wasmURL = "https://unpkg.com/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive.wasm");
                return RuntimeLoader;
            }();
            // #endregion
            // #region state machines
            var StateMachineInputType;
            (function(StateMachineInputType) {
                StateMachineInputType[StateMachineInputType["Number"] = 56] = "Number";
                StateMachineInputType[StateMachineInputType["Trigger"] = 58] = "Trigger";
                StateMachineInputType[StateMachineInputType["Boolean"] = 59] = "Boolean";
            })(StateMachineInputType || (StateMachineInputType = {}));
            /**
 * An input for a state machine
 */ var StateMachineInput = /** @class */ function() {
                function StateMachineInput(type, runtimeInput) {
                    this.type = type;
                    this.runtimeInput = runtimeInput;
                }
                Object.defineProperty(StateMachineInput.prototype, "name", {
                    /**
         * Returns the name of the input
         */ get: function() {
                        return this.runtimeInput.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachineInput.prototype, "value", {
                    /**
         * Returns the current value of the input
         */ get: function() {
                        return this.runtimeInput.value;
                    },
                    /**
         * Sets the value of the input
         */ set: function(value) {
                        this.runtimeInput.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Fires a trigger; does nothing on Number or Boolean input types
     */ StateMachineInput.prototype.fire = function() {
                    if (this.type === StateMachineInputType.Trigger) this.runtimeInput.fire();
                };
                /**
     * Deletes the input
     */ StateMachineInput.prototype.delete = function() {
                    this.runtimeInput = null;
                };
                return StateMachineInput;
            }();
            var RiveEventType;
            (function(RiveEventType) {
                RiveEventType[RiveEventType["General"] = 128] = "General";
                RiveEventType[RiveEventType["OpenUrl"] = 131] = "OpenUrl";
            })(RiveEventType || (RiveEventType = {}));
            var StateMachine = /** @class */ function() {
                /**
     * @constructor
     * @param stateMachine runtime state machine object
     * @param instance runtime state machine instance object
     */ function StateMachine(stateMachine, runtime, playing, artboard) {
                    this.stateMachine = stateMachine;
                    this.playing = playing;
                    this.artboard = artboard;
                    /**
         * Caches the inputs from the runtime
         */ this.inputs = [];
                    this.instance = new runtime.StateMachineInstance(stateMachine, artboard);
                    this.initInputs(runtime);
                }
                Object.defineProperty(StateMachine.prototype, "name", {
                    get: function() {
                        return this.stateMachine.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachine.prototype, "statesChanged", {
                    /**
         * Returns a list of state names that have changed on this frame
         */ get: function() {
                        var names = [];
                        for(var i = 0; i < this.instance.stateChangedCount(); i++)names.push(this.instance.stateChangedNameByIndex(i));
                        return names;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Advances the state machine instance by a given time.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advance = function(time) {
                    this.instance.advance(time);
                };
                /**
     * Advances the state machine instance by a given time and apply changes to artboard.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advanceAndApply = function(time) {
                    this.instance.advanceAndApply(time);
                };
                /**
     * Returns the number of events reported from the last advance call
     * @returns Number of events reported
     */ StateMachine.prototype.reportedEventCount = function() {
                    return this.instance.reportedEventCount();
                };
                /**
     * Returns a RiveEvent object emitted from the last advance call at the given index
     * of a list of potentially multiple events. If an event at the index is not found,
     * undefined is returned.
     * @param i index of the event reported in a list of potentially multiple events
     * @returns RiveEvent or extended RiveEvent object returned, or undefined
     */ StateMachine.prototype.reportedEventAt = function(i) {
                    return this.instance.reportedEventAt(i);
                };
                /**
     * Fetches references to the state machine's inputs and caches them
     * @param runtime an instance of the runtime; needed for the SMIInput types
     */ StateMachine.prototype.initInputs = function(runtime) {
                    // Fetch the inputs from the runtime if we don't have them
                    for(var i = 0; i < this.instance.inputCount(); i++){
                        var input = this.instance.input(i);
                        this.inputs.push(this.mapRuntimeInput(input, runtime));
                    }
                };
                /**
     * Maps a runtime input to it's appropriate type
     * @param input
     */ StateMachine.prototype.mapRuntimeInput = function(input, runtime) {
                    if (input.type === runtime.SMIInput.bool) return new StateMachineInput(StateMachineInputType.Boolean, input.asBool());
                    else if (input.type === runtime.SMIInput.number) return new StateMachineInput(StateMachineInputType.Number, input.asNumber());
                    else if (input.type === runtime.SMIInput.trigger) return new StateMachineInput(StateMachineInputType.Trigger, input.asTrigger());
                };
                /**
     * Deletes the backing Wasm state machine instance; once this is called, this
     * state machine is no more.
     */ StateMachine.prototype.cleanup = function() {
                    this.inputs.forEach(function(input) {
                        input.delete();
                    });
                    this.inputs.length = 0;
                    this.instance.delete();
                };
                return StateMachine;
            }();
            // #endregion
            // #region animator
            /**
 * Manages animation
 */ var Animator = /** @class */ function() {
                /**
     * Constructs a new animator
     * @constructor
     * @param runtime Rive runtime; needed to instance animations & state machines
     * @param artboard the artboard that holds all animations and state machines
     * @param animations optional list of animations
     * @param stateMachines optional list of state machines
     */ function Animator(runtime, artboard, eventManager, animations, stateMachines) {
                    if (animations === void 0) animations = [];
                    if (stateMachines === void 0) stateMachines = [];
                    this.runtime = runtime;
                    this.artboard = artboard;
                    this.eventManager = eventManager;
                    this.animations = animations;
                    this.stateMachines = stateMachines;
                }
                /**
     * Adds animations and state machines by their names. If names are shared
     * between animations & state machines, then the first one found will be
     * created. Best not to use the same names for these in your Rive file.
     * @param animatable the name(s) of animations and state machines to add
     * @returns a list of names of the playing animations and state machines
     */ Animator.prototype.add = function(animatables, playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    animatables = mapToStringArray(animatables);
                    // If animatables is empty, play or pause everything
                    if (animatables.length === 0) {
                        this.animations.forEach(function(a) {
                            return a.playing = playing;
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.playing = playing;
                        });
                    } else {
                        // Play/pause already instanced items, or create new instances
                        var instancedAnimationNames = this.animations.map(function(a) {
                            return a.name;
                        });
                        var instancedMachineNames = this.stateMachines.map(function(m) {
                            return m.name;
                        });
                        for(var i = 0; i < animatables.length; i++){
                            var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                            var mIndex = instancedMachineNames.indexOf(animatables[i]);
                            if (aIndex >= 0 || mIndex >= 0) {
                                if (aIndex >= 0) // Animation is instanced, play/pause it
                                this.animations[aIndex].playing = playing;
                                else // State machine is instanced, play/pause it
                                this.stateMachines[mIndex].playing = playing;
                            } else {
                                // Try to create a new animation instance
                                var anim = this.artboard.animationByName(animatables[i]);
                                if (anim) {
                                    var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                    // Display the first frame of the specified animation
                                    newAnimation.advance(0);
                                    newAnimation.apply(1.0);
                                    this.animations.push(newAnimation);
                                } else {
                                    // Try to create a new state machine instance
                                    var sm = this.artboard.stateMachineByName(animatables[i]);
                                    if (sm) {
                                        var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                        this.stateMachines.push(newStateMachine);
                                    }
                                }
                            }
                        }
                    }
                    // Fire play/paused events for animations
                    if (fireEvent) {
                        if (playing) this.eventManager.fire({
                            type: EventType.Play,
                            data: this.playing
                        });
                        else this.eventManager.fire({
                            type: EventType.Pause,
                            data: this.paused
                        });
                    }
                    return playing ? this.playing : this.paused;
                };
                /**
     * Adds linear animations by their names.
     * @param animatables the name(s) of animations to add
     * @param playing whether animations should play on instantiation
     */ Animator.prototype.initLinearAnimations = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedAnimationNames = this.animations.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.animations[aIndex].playing = playing;
                        else {
                            // Try to create a new animation instance
                            var anim = this.artboard.animationByName(animatables[i]);
                            if (anim) {
                                var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                // Display the first frame of the specified animation
                                newAnimation.advance(0);
                                newAnimation.apply(1.0);
                                this.animations.push(newAnimation);
                            }
                        }
                    }
                };
                /**
     * Adds state machines by their names.
     * @param animatables the name(s) of state machines to add
     * @param playing whether state machines should play on instantiation
     */ Animator.prototype.initStateMachines = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedStateMachineNames = this.stateMachines.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedStateMachineNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.stateMachines[aIndex].playing = playing;
                        else {
                            // Try to create a new state machine instance
                            var sm = this.artboard.stateMachineByName(animatables[i]);
                            if (sm) {
                                var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                this.stateMachines.push(newStateMachine);
                            } else // In order to maintain compatibility with current behavior, if a state machine is not found
                            // we look for an animation with the same name
                            this.initLinearAnimations([
                                animatables[i]
                            ], playing);
                        }
                    }
                };
                /**
     * Play the named animations/state machines
     * @param animatables the names of the animations/machines to play; plays all if empty
     * @returns a list of the playing items
     */ Animator.prototype.play = function(animatables) {
                    return this.add(animatables, true);
                };
                /**
     * Pauses named animations and state machines, or everything if nothing is
     * specified
     * @param animatables names of the animations and state machines to pause
     * @returns a list of names of the animations and state machines paused
     */ Animator.prototype.pause = function(animatables) {
                    return this.add(animatables, false);
                };
                /**
     * Set time of named animations
     * @param animations names of the animations to scrub
     * @param value time scrub value, a floating point number to which the playhead is jumped
     * @returns a list of names of the animations that were scrubbed
     */ Animator.prototype.scrub = function(animatables, value) {
                    var forScrubbing = this.animations.filter(function(a) {
                        return animatables.includes(a.name);
                    });
                    forScrubbing.forEach(function(a) {
                        return a.scrubTo = value;
                    });
                    return forScrubbing.map(function(a) {
                        return a.name;
                    });
                };
                Object.defineProperty(Animator.prototype, "playing", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * playing
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "paused", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * paused
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Stops and removes all named animations and state machines
     * @param animatables animations and state machines to remove
     * @returns a list of names of removed items
     */ Animator.prototype.stop = function(animatables) {
                    var _this = this;
                    animatables = mapToStringArray(animatables);
                    // If nothing's specified, wipe them out, all of them
                    var removedNames = [];
                    // Stop everything
                    if (animatables.length === 0) {
                        removedNames = this.animations.map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.map(function(m) {
                            return m.name;
                        }));
                        // Clean up before emptying the arrays
                        this.animations.forEach(function(a) {
                            return a.cleanup();
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.cleanup();
                        });
                        // Empty out the arrays
                        this.animations.splice(0, this.animations.length);
                        this.stateMachines.splice(0, this.stateMachines.length);
                    } else {
                        // Remove only the named animations/state machines
                        var animationsToRemove = this.animations.filter(function(a) {
                            return animatables.includes(a.name);
                        });
                        animationsToRemove.forEach(function(a) {
                            a.cleanup();
                            _this.animations.splice(_this.animations.indexOf(a), 1);
                        });
                        var machinesToRemove = this.stateMachines.filter(function(m) {
                            return animatables.includes(m.name);
                        });
                        machinesToRemove.forEach(function(m) {
                            m.cleanup();
                            _this.stateMachines.splice(_this.stateMachines.indexOf(m), 1);
                        });
                        removedNames = animationsToRemove.map(function(a) {
                            return a.name;
                        }).concat(machinesToRemove.map(function(m) {
                            return m.name;
                        }));
                    }
                    this.eventManager.fire({
                        type: EventType.Stop,
                        data: removedNames
                    });
                    // Return the list of animations removed
                    return removedNames;
                };
                Object.defineProperty(Animator.prototype, "isPlaying", {
                    /**
         * Returns true if at least one animation is active
         */ get: function() {
                        return this.animations.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false) || this.stateMachines.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isPaused", {
                    /**
         * Returns true if all animations are paused and there's at least one animation
         */ get: function() {
                        return !this.isPlaying && (this.animations.length > 0 || this.stateMachines.length > 0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isStopped", {
                    /**
         * Returns true if there are no playing or paused animations/state machines
         */ get: function() {
                        return this.animations.length === 0 && this.stateMachines.length === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * If there are no animations or state machines, add the first one found
     * @returns the name of the animation or state machine instanced
     */ Animator.prototype.atLeastOne = function(playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    var instancedName;
                    if (this.animations.length === 0 && this.stateMachines.length === 0) {
                        if (this.artboard.animationCount() > 0) // Add the first animation
                        this.add([
                            instancedName = this.artboard.animationByIndex(0).name
                        ], playing, fireEvent);
                        else if (this.artboard.stateMachineCount() > 0) // Add the first state machine
                        this.add([
                            instancedName = this.artboard.stateMachineByIndex(0).name
                        ], playing, fireEvent);
                    }
                    return instancedName;
                };
                /**
     * Checks if any animations have looped and if so, fire the appropriate event
     */ Animator.prototype.handleLooping = function() {
                    for(var _i = 0, _a = this.animations.filter(function(a) {
                        return a.playing;
                    }); _i < _a.length; _i++){
                        var animation = _a[_i];
                        // Emit if the animation looped
                        if (animation.loopValue === 0 && animation.loopCount) {
                            animation.loopCount = 0;
                            // This is a one-shot; if it has ended, delete the instance
                            this.stop(animation.name);
                        } else if (animation.loopValue === 1 && animation.loopCount) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.Loop
                                }
                            });
                            animation.loopCount = 0;
                        } else if (animation.loopValue === 2 && animation.loopCount > 1) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.PingPong
                                }
                            });
                            animation.loopCount = 0;
                        }
                    }
                };
                /**
     * Checks if states have changed in state machines and fires a statechange
     * event
     */ Animator.prototype.handleStateChanges = function() {
                    var statesChanged = [];
                    for(var _i = 0, _a = this.stateMachines.filter(function(sm) {
                        return sm.playing;
                    }); _i < _a.length; _i++){
                        var stateMachine = _a[_i];
                        statesChanged.push.apply(statesChanged, stateMachine.statesChanged);
                    }
                    if (statesChanged.length > 0) this.eventManager.fire({
                        type: EventType.StateChange,
                        data: statesChanged
                    });
                };
                Animator.prototype.handleAdvancing = function(time) {
                    this.eventManager.fire({
                        type: EventType.Advance,
                        data: time
                    });
                };
                return Animator;
            }();
            // #endregion
            // #region events
            /**
 * Supported event types triggered in Rive
 */ var EventType;
            (function(EventType) {
                EventType["Load"] = "load";
                EventType["LoadError"] = "loaderror";
                EventType["Play"] = "play";
                EventType["Pause"] = "pause";
                EventType["Stop"] = "stop";
                EventType["Loop"] = "loop";
                EventType["Draw"] = "draw";
                EventType["Advance"] = "advance";
                EventType["StateChange"] = "statechange";
                EventType["RiveEvent"] = "riveevent";
                EventType["AudioStatusChange"] = "audiostatuschange";
            })(EventType || (EventType = {}));
            /**
 * Looping types: one-shot, loop, and ping-pong
 */ var LoopType;
            (function(LoopType) {
                LoopType["OneShot"] = "oneshot";
                LoopType["Loop"] = "loop";
                LoopType["PingPong"] = "pingpong";
            })(LoopType || (LoopType = {}));
            // Manages Rive events and listeners
            var EventManager = /** @class */ function() {
                function EventManager(listeners) {
                    if (listeners === void 0) listeners = [];
                    this.listeners = listeners;
                }
                // Gets listeners of specified type
                EventManager.prototype.getListeners = function(type) {
                    return this.listeners.filter(function(e) {
                        return e.type === type;
                    });
                };
                // Adds a listener
                EventManager.prototype.add = function(listener) {
                    if (!this.listeners.includes(listener)) this.listeners.push(listener);
                };
                /**
     * Removes a listener
     * @param listener the listener with the callback to be removed
     */ EventManager.prototype.remove = function(listener) {
                    // We can't simply look for the listener as it'll be a different instance to
                    // one originally subscribed. Find all the listeners of the right type and
                    // then check their callbacks which should match.
                    for(var i = 0; i < this.listeners.length; i++){
                        var currentListener = this.listeners[i];
                        if (currentListener.type === listener.type) {
                            if (currentListener.callback === listener.callback) {
                                this.listeners.splice(i, 1);
                                break;
                            }
                        }
                    }
                };
                /**
     * Clears all listeners of specified type, or every listener if no type is
     * specified
     * @param type the type of listeners to clear, or all listeners if not
     * specified
     */ EventManager.prototype.removeAll = function(type) {
                    var _this = this;
                    if (!type) this.listeners.splice(0, this.listeners.length);
                    else this.listeners.filter(function(l) {
                        return l.type === type;
                    }).forEach(function(l) {
                        return _this.remove(l);
                    });
                };
                // Fires an event
                EventManager.prototype.fire = function(event) {
                    var eventListeners = this.getListeners(event.type);
                    eventListeners.forEach(function(listener) {
                        return listener.callback(event);
                    });
                };
                return EventManager;
            }();
            // Manages a queue of tasks
            var TaskQueueManager = /** @class */ function() {
                function TaskQueueManager(eventManager) {
                    this.eventManager = eventManager;
                    this.queue = [];
                }
                // Adds a task top the queue
                TaskQueueManager.prototype.add = function(task) {
                    this.queue.push(task);
                };
                // Processes all tasks in the queue
                TaskQueueManager.prototype.process = function() {
                    while(this.queue.length > 0){
                        var task = this.queue.shift();
                        if (task === null || task === void 0 ? void 0 : task.action) task.action();
                        if (task === null || task === void 0 ? void 0 : task.event) this.eventManager.fire(task.event);
                    }
                };
                return TaskQueueManager;
            }();
            // #endregion
            // #region Audio
            var SystemAudioStatus;
            (function(SystemAudioStatus) {
                SystemAudioStatus[SystemAudioStatus["AVAILABLE"] = 0] = "AVAILABLE";
                SystemAudioStatus[SystemAudioStatus["UNAVAILABLE"] = 1] = "UNAVAILABLE";
            })(SystemAudioStatus || (SystemAudioStatus = {}));
            // Class to handle audio context availability and status changes
            var AudioManager = /** @class */ function(_super) {
                __extends(AudioManager, _super);
                function AudioManager() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this._started = false;
                    _this._enabled = false;
                    _this._status = SystemAudioStatus.UNAVAILABLE;
                    return _this;
                }
                AudioManager.prototype.delay = function(time) {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, time);
                                })
                            ];
                        });
                    });
                };
                AudioManager.prototype.timeout = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(_, reject) {
                                    return setTimeout(reject, 50);
                                })
                            ];
                        });
                    });
                };
                // Alerts animations on status changes and removes the listeners to avoid alerting twice.
                AudioManager.prototype.reportToListeners = function() {
                    this.fire({
                        type: EventType.AudioStatusChange
                    });
                    this.removeAll();
                };
                /**
     * The audio context has been resolved.
     * Alert any listeners that we can now play audio.
     * Rive will now play audio at the configured volume.
     */ AudioManager.prototype.enableAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            if (!this._enabled) {
                                this._enabled = true;
                                this._status = SystemAudioStatus.AVAILABLE;
                                this.reportToListeners();
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                /**
     * Check if we are able to play audio.
     *
     * We currently check the audio context, when resume() returns before a timeout we know that the
     * audio context is running and we can enable audio.
     */ AudioManager.prototype.testAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE && this._audioContext !== null)) return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            this._audioContext.resume(),
                                            this.timeout()
                                        ])
                                    ];
                                case 2:
                                    _b.sent();
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 3:
                                    _a = _b.sent();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                /**
     * Establish audio for use with rive.
     * We both test if we can use audio intermittently and listen for user interaction.
     * The aim is to enable audio playback as soon as the browser allows this.
     */ AudioManager.prototype._establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    if (!!this._started) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    this._started = true;
                                    if (!(typeof window == "undefined")) return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 1:
                                    this._audioContext = new AudioContext();
                                    this.listenForUserAction();
                                    _a.label = 2;
                                case 2:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE)) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.testAudio()
                                    ];
                                case 3:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.delay(1000)
                                    ];
                                case 4:
                                    _a.sent();
                                    return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                AudioManager.prototype.listenForUserAction = function() {
                    var _this = this;
                    // NOTE: AudioContexts are ready immediately if requested in a ui callback
                    // we *could* re request one in this listener.
                    var _clickListener = function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                // note this has "better" results than calling `await this.testAudio()`
                                // as we force audio to be enabled in the current thread, rather than chancing
                                // the thread to be passed over for some other async context
                                this.enableAudio();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    // NOTE: we should test this on mobile/pads
                    document.addEventListener("pointerdown", _clickListener, {
                        once: true
                    });
                };
                /**
     * Establish the audio context for rive, this lets rive know that we can play audio.
     */ AudioManager.prototype.establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            this._establishAudio();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                Object.defineProperty(AudioManager.prototype, "systemVolume", {
                    get: function() {
                        if (this._status === SystemAudioStatus.UNAVAILABLE) {
                            // We do an immediate test to avoid depending on the delay of the running test
                            this.testAudio();
                            return 0;
                        }
                        return 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AudioManager.prototype, "status", {
                    get: function() {
                        return this._status;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AudioManager;
            }(EventManager);
            var audioManager = new AudioManager();
            var FakeResizeObserver = /** @class */ function() {
                function FakeResizeObserver() {}
                FakeResizeObserver.prototype.observe = function() {};
                FakeResizeObserver.prototype.unobserve = function() {};
                FakeResizeObserver.prototype.disconnect = function() {};
                return FakeResizeObserver;
            }();
            var MyResizeObserver = globalThis.ResizeObserver || FakeResizeObserver;
            /**
 * This class takes care of any observers that will be attached to an animation.
 * It should be treated as a singleton because observers are much more performant
 * when used for observing multiple elements by a single instance.
 */ var ObjectObservers = /** @class */ function() {
                function ObjectObservers() {
                    var _this = this;
                    this._elementsMap = new Map();
                    /**
         * Resize observers trigger both when the element changes its size and also when the
         * element is added or removed from the document.
         */ this._onObservedEntry = function(entry) {
                        var observed = _this._elementsMap.get(entry.target);
                        if (observed !== null) observed.onResize(entry.target.clientWidth == 0 || entry.target.clientHeight == 0);
                        else _this._resizeObserver.unobserve(entry.target);
                    };
                    this._onObserved = function(entries) {
                        entries.forEach(_this._onObservedEntry);
                    };
                    this._resizeObserver = new MyResizeObserver(this._onObserved);
                }
                // Adds an observable element
                ObjectObservers.prototype.add = function(element, onResize) {
                    var observed = {
                        onResize: onResize,
                        element: element
                    };
                    this._elementsMap.set(element, observed);
                    this._resizeObserver.observe(element);
                    return observed;
                };
                // Removes an observable element
                ObjectObservers.prototype.remove = function(observed) {
                    this._resizeObserver.unobserve(observed.element);
                    this._elementsMap.delete(observed.element);
                };
                return ObjectObservers;
            }();
            var observers = new ObjectObservers();
            var RiveFile = /** @class */ function() {
                function RiveFile(params) {
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    this.referenceCount = 0;
                    this.destroyed = false;
                    this.src = params.src;
                    this.buffer = params.buffer;
                    if (params.assetLoader) this.assetLoader = params.assetLoader;
                    this.enableRiveAssetCDN = typeof params.enableRiveAssetCDN == "boolean" ? params.enableRiveAssetCDN : true;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                }
                RiveFile.prototype.initData = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a, loader, _b;
                        var _c;
                        return __generator(this, function(_d) {
                            switch(_d.label){
                                case 0:
                                    if (!this.src) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        loadRiveFile(this.src)
                                    ];
                                case 1:
                                    _a.buffer = _d.sent();
                                    _d.label = 2;
                                case 2:
                                    if (this.destroyed) return [
                                        2 /*return*/ 
                                    ];
                                    if (this.assetLoader) loader = new this.runtime.CustomFileAssetLoader({
                                        loadContents: this.assetLoader
                                    });
                                    // Load the Rive file
                                    _b = this;
                                    return [
                                        4 /*yield*/ ,
                                        this.runtime.load(new Uint8Array(this.buffer), loader, this.enableRiveAssetCDN)
                                    ];
                                case 3:
                                    // Load the Rive file
                                    _b.file = _d.sent();
                                    if (this.destroyed) {
                                        (_c = this.file) === null || _c === void 0 || _c.delete();
                                        this.file = null;
                                        return [
                                            2 /*return*/ 
                                        ];
                                    }
                                    if (this.file !== null) this.eventManager.fire({
                                        type: EventType.Load,
                                        data: this
                                    });
                                    else {
                                        this.eventManager.fire({
                                            type: EventType.LoadError,
                                            data: null
                                        });
                                        throw new Error(RiveFile.fileLoadErrorMessage);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                RiveFile.prototype.init = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    // If no source file url specified, it's a bust
                                    if (!this.src && !this.buffer) throw new Error(RiveFile.missingErrorMessage);
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        RuntimeLoader.awaitInstance()
                                    ];
                                case 1:
                                    _a.runtime = _b.sent();
                                    if (this.destroyed) return [
                                        2 /*return*/ 
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.initData()
                                    ];
                                case 2:
                                    _b.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ RiveFile.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ RiveFile.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                RiveFile.prototype.cleanup = function() {
                    var _a;
                    this.referenceCount -= 1;
                    if (this.referenceCount <= 0) {
                        this.removeAllRiveEventListeners();
                        (_a = this.file) === null || _a === void 0 || _a.delete();
                        this.file = null;
                        this.destroyed = true;
                    }
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ RiveFile.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                RiveFile.prototype.getInstance = function() {
                    if (this.file !== null) {
                        this.referenceCount += 1;
                        return this.file;
                    }
                };
                // Error message for missing source or buffer
                RiveFile.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for file load error
                RiveFile.fileLoadErrorMessage = "The file failed to load";
                return RiveFile;
            }();
            var Rive = /** @class */ function() {
                function Rive(params) {
                    var _this = this;
                    var _a;
                    // Tracks if a Rive file is loaded
                    this.loaded = false;
                    // Tracks if a Rive file is destroyed
                    this.destroyed = false;
                    // Reference of an object that handles any observers for the animation
                    this._observed = null;
                    /**
         * Tracks if a Rive file is loaded; we need this in addition to loaded as some
         * commands (e.g. contents) can be called as soon as the file is loaded.
         * However, playback commands need to be queued and run in order once initial
         * animations and autoplay has been sorted out. This applies to play, pause,
         * and start.
         */ this.readyForPlaying = false;
                    // Runtime artboard
                    this.artboard = null;
                    // place to clear up event listeners
                    this.eventCleanup = null;
                    this.shouldDisableRiveListeners = false;
                    this.automaticallyHandleEvents = false;
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    // Keep a local value of the set volume to update it asynchronously
                    this._volume = 1;
                    // Keep a local value of the set width to update it asynchronously
                    this._artboardWidth = undefined;
                    // Keep a local value of the set height to update it asynchronously
                    this._artboardHeight = undefined;
                    // Keep a local value of the device pixel ratio used in rendering and canvas/artboard resizing
                    this._devicePixelRatioUsed = 1;
                    // Whether the canvas element's size is 0
                    this._hasZeroSize = false;
                    // Audio event listener
                    this._audioEventListener = null;
                    // draw method bound to the class
                    this._boundDraw = null;
                    // Durations to generate a frame for the last second. Used for performance profiling.
                    this.durations = [];
                    this.frameTimes = [];
                    this.frameCount = 0;
                    this.isTouchScrollEnabled = false;
                    this.onCanvasResize = function(hasZeroSize) {
                        var toggledDisplay = _this._hasZeroSize !== hasZeroSize;
                        _this._hasZeroSize = hasZeroSize;
                        if (!hasZeroSize) {
                            if (toggledDisplay) _this.resizeDrawingSurfaceToCanvas();
                        } else if (!_this._layout.maxX || !_this._layout.maxY) _this.resizeToCanvas();
                    };
                    /**
         * Used be draw to track when a second of active rendering time has passed.
         * Used for debugging purposes
         */ this.renderSecondTimer = 0;
                    this._boundDraw = this.draw.bind(this);
                    this.canvas = params.canvas;
                    if (params.canvas.constructor === HTMLCanvasElement) this._observed = observers.add(this.canvas, this.onCanvasResize);
                    this.src = params.src;
                    this.buffer = params.buffer;
                    this.riveFile = params.riveFile;
                    this.layout = (_a = params.layout) !== null && _a !== void 0 ? _a : new Layout();
                    this.shouldDisableRiveListeners = !!params.shouldDisableRiveListeners;
                    this.isTouchScrollEnabled = !!params.isTouchScrollEnabled;
                    this.automaticallyHandleEvents = !!params.automaticallyHandleEvents;
                    this.enableRiveAssetCDN = params.enableRiveAssetCDN === undefined ? true : params.enableRiveAssetCDN;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                    if (params.onPlay) this.on(EventType.Play, params.onPlay);
                    if (params.onPause) this.on(EventType.Pause, params.onPause);
                    if (params.onStop) this.on(EventType.Stop, params.onStop);
                    if (params.onLoop) this.on(EventType.Loop, params.onLoop);
                    if (params.onStateChange) this.on(EventType.StateChange, params.onStateChange);
                    if (params.onAdvance) this.on(EventType.Advance, params.onAdvance);
                    /**
         * @deprecated Use camelCase'd versions instead.
         */ if (params.onload && !params.onLoad) this.on(EventType.Load, params.onload);
                    if (params.onloaderror && !params.onLoadError) this.on(EventType.LoadError, params.onloaderror);
                    if (params.onplay && !params.onPlay) this.on(EventType.Play, params.onplay);
                    if (params.onpause && !params.onPause) this.on(EventType.Pause, params.onpause);
                    if (params.onstop && !params.onStop) this.on(EventType.Stop, params.onstop);
                    if (params.onloop && !params.onLoop) this.on(EventType.Loop, params.onloop);
                    if (params.onstatechange && !params.onStateChange) this.on(EventType.StateChange, params.onstatechange);
                    /**
         * Asset loading
         */ if (params.assetLoader) this.assetLoader = params.assetLoader;
                    // Hook up the task queue
                    this.taskQueue = new TaskQueueManager(this.eventManager);
                    this.init({
                        src: this.src,
                        buffer: this.buffer,
                        riveFile: this.riveFile,
                        autoplay: params.autoplay,
                        animations: params.animations,
                        stateMachines: params.stateMachines,
                        artboard: params.artboard,
                        useOffscreenRenderer: params.useOffscreenRenderer
                    });
                }
                // Alternative constructor to build a Rive instance from an interface/object
                Rive.new = function(params) {
                    console.warn("This function is deprecated: please use `new Rive({})` instead");
                    return new Rive(params);
                };
                // Event handler for when audio context becomes available
                Rive.prototype.onSystemAudioChanged = function() {
                    this.volume = this._volume;
                };
                // Initializes the Rive object either from constructor or load()
                Rive.prototype.init = function(_a) {
                    var _this = this;
                    var src = _a.src, buffer = _a.buffer, riveFile = _a.riveFile, animations = _a.animations, stateMachines = _a.stateMachines, artboard = _a.artboard, _b = _a.autoplay, autoplay = _b === void 0 ? false : _b, _c = _a.useOffscreenRenderer, useOffscreenRenderer = _c === void 0 ? false : _c;
                    if (this.destroyed) return;
                    this.src = src;
                    this.buffer = buffer;
                    this.riveFile = riveFile;
                    // If no source file url specified, it's a bust
                    if (!this.src && !this.buffer && !this.riveFile) throw new RiveError(Rive.missingErrorMessage);
                    // List of animations that should be initialized.
                    var startingAnimationNames = mapToStringArray(animations);
                    // List of state machines that should be initialized
                    var startingStateMachineNames = mapToStringArray(stateMachines);
                    // Ensure loaded is marked as false if loading new file
                    this.loaded = false;
                    this.readyForPlaying = false;
                    // Ensure the runtime is loaded
                    RuntimeLoader.awaitInstance().then(function(runtime) {
                        if (_this.destroyed) return;
                        _this.runtime = runtime;
                        _this.removeRiveListeners();
                        _this.deleteRiveRenderer();
                        // Get the canvas where you want to render the animation and create a renderer
                        _this.renderer = _this.runtime.makeRenderer(_this.canvas, useOffscreenRenderer);
                        // Initial size adjustment based on devicePixelRatio if no width/height are
                        // specified explicitly
                        if (!(_this.canvas.width || _this.canvas.height)) _this.resizeDrawingSurfaceToCanvas();
                        // Load Rive data from a source uri or a data buffer
                        _this.initData(artboard, startingAnimationNames, startingStateMachineNames, autoplay).then(function() {
                            return _this.setupRiveListeners();
                        }).catch(function(e) {
                            console.error(e);
                        });
                    }).catch(function(e) {
                        console.error(e);
                    });
                };
                /**
     * Setup Rive Listeners on the canvas
     * @param riveListenerOptions - Enables TouchEvent events on the canvas. Set to true to allow
     * touch scrolling on the canvas element on touch-enabled devices
     * i.e. { isTouchScrollEnabled: true }
     */ Rive.prototype.setupRiveListeners = function(riveListenerOptions) {
                    var _this = this;
                    if (this.eventCleanup) this.eventCleanup();
                    if (!this.shouldDisableRiveListeners) {
                        var activeStateMachines = (this.animator.stateMachines || []).filter(function(sm) {
                            return sm.playing && _this.runtime.hasListeners(sm.instance);
                        }).map(function(sm) {
                            return sm.instance;
                        });
                        var touchScrollEnabledOption = this.isTouchScrollEnabled;
                        if (riveListenerOptions && "isTouchScrollEnabled" in riveListenerOptions) touchScrollEnabledOption = riveListenerOptions.isTouchScrollEnabled;
                        this.eventCleanup = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.registerTouchInteractions)({
                            canvas: this.canvas,
                            artboard: this.artboard,
                            stateMachines: activeStateMachines,
                            renderer: this.renderer,
                            rive: this.runtime,
                            fit: this._layout.runtimeFit(this.runtime),
                            alignment: this._layout.runtimeAlignment(this.runtime),
                            isTouchScrollEnabled: touchScrollEnabledOption,
                            layoutScaleFactor: this._layout.layoutScaleFactor
                        });
                    }
                };
                /**
     * Remove Rive Listeners setup on the canvas
     */ Rive.prototype.removeRiveListeners = function() {
                    if (this.eventCleanup) {
                        this.eventCleanup();
                        this.eventCleanup = null;
                    }
                };
                /**
     * If the instance has audio and the system audio is not ready
     * we hook the instance to the audio manager
     */ Rive.prototype.initializeAudio = function() {
                    var _this = this;
                    var _a;
                    // Initialize audio if needed
                    if (audioManager.status == SystemAudioStatus.UNAVAILABLE) {
                        if (((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.hasAudio) && this._audioEventListener === null) {
                            this._audioEventListener = {
                                type: EventType.AudioStatusChange,
                                callback: function() {
                                    return _this.onSystemAudioChanged();
                                }
                            };
                            audioManager.add(this._audioEventListener);
                            audioManager.establishAudio();
                        }
                    }
                };
                Rive.prototype.initArtboardSize = function() {
                    if (!this.artboard) return;
                    // Use preset values if they are not undefined
                    this._artboardWidth = this.artboard.width = this._artboardWidth || this.artboard.width;
                    this._artboardHeight = this.artboard.height = this._artboardHeight || this.artboard.height;
                };
                // Initializes runtime with Rive data and preps for playing
                Rive.prototype.initData = function(artboardName, animationNames, stateMachineNames, autoplay) {
                    return __awaiter(this, void 0, void 0, function() {
                        var error_1, msg;
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    _b.trys.push([
                                        0,
                                        3,
                                        ,
                                        4
                                    ]);
                                    if (!(this.riveFile == null)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    this.riveFile = new RiveFile({
                                        src: this.src,
                                        buffer: this.buffer,
                                        enableRiveAssetCDN: this.enableRiveAssetCDN,
                                        assetLoader: this.assetLoader
                                    });
                                    return [
                                        4 /*yield*/ ,
                                        this.riveFile.init()
                                    ];
                                case 1:
                                    _b.sent();
                                    _b.label = 2;
                                case 2:
                                    // Check for riveFile in case it has been cleaned up while initializing;
                                    if (!this.riveFile) throw new RiveError(Rive.cleanupErrorMessage);
                                    this.file = this.riveFile.getInstance();
                                    // Initialize and draw frame
                                    this.initArtboard(artboardName, animationNames, stateMachineNames, autoplay);
                                    // Initialize the artboard size
                                    this.initArtboardSize();
                                    // Check for audio
                                    this.initializeAudio();
                                    // Everything's set up, emit a load event
                                    this.loaded = true;
                                    this.eventManager.fire({
                                        type: EventType.Load,
                                        data: (_a = this.src) !== null && _a !== void 0 ? _a : "buffer"
                                    });
                                    // Flag ready for playback commands and clear the task queue; this order
                                    // is important or it may infinitely recurse
                                    this.readyForPlaying = true;
                                    this.taskQueue.process();
                                    this.drawFrame();
                                    return [
                                        2 /*return*/ ,
                                        Promise.resolve()
                                    ];
                                case 3:
                                    error_1 = _b.sent();
                                    msg = resolveErrorMessage(error_1);
                                    console.warn(msg);
                                    this.eventManager.fire({
                                        type: EventType.LoadError,
                                        data: msg
                                    });
                                    return [
                                        2 /*return*/ ,
                                        Promise.reject(msg)
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                // Initialize for playback
                Rive.prototype.initArtboard = function(artboardName, animationNames, stateMachineNames, autoplay) {
                    if (!this.file) return;
                    // Fetch the artboard
                    var rootArtboard = artboardName ? this.file.artboardByName(artboardName) : this.file.defaultArtboard();
                    // Check we have a working artboard
                    if (!rootArtboard) {
                        var msg = "Invalid artboard name or no default artboard";
                        console.warn(msg);
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        return;
                    }
                    this.artboard = rootArtboard;
                    rootArtboard.volume = this._volume * audioManager.systemVolume;
                    // Check that the artboard has at least 1 animation
                    if (this.artboard.animationCount() < 1) {
                        var msg = "Artboard has no animations";
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        throw msg;
                    }
                    // Initialize the animator
                    this.animator = new Animator(this.runtime, this.artboard, this.eventManager);
                    // Initialize the animations; as loaded hasn't happened yet, we need to
                    // suppress firing the play/pause events until the load event has fired. To
                    // do this we tell the animator to suppress firing events, and add event
                    // firing to the task queue.
                    var instanceNames;
                    if (animationNames.length > 0 || stateMachineNames.length > 0) {
                        instanceNames = animationNames.concat(stateMachineNames);
                        this.animator.initLinearAnimations(animationNames, autoplay);
                        this.animator.initStateMachines(stateMachineNames, autoplay);
                    } else instanceNames = [
                        this.animator.atLeastOne(autoplay, false)
                    ];
                    // Queue up firing the playback events
                    this.taskQueue.add({
                        event: {
                            type: autoplay ? EventType.Play : EventType.Pause,
                            data: instanceNames
                        }
                    });
                };
                // Draws the current artboard frame
                Rive.prototype.drawFrame = function() {
                    var _a;
                    if ((_a = document === null || document === void 0 ? void 0 : document.timeline) === null || _a === void 0 ? void 0 : _a.currentTime) {
                        if (this.loaded && this.artboard && !this.frameRequestId) this._boundDraw(document.timeline.currentTime);
                    } else this.startRendering();
                };
                /**
     * Draw rendering loop; renders animation frames at the correct time interval.
     * @param time the time at which to render a frame
     */ Rive.prototype.draw = function(time, onSecond) {
                    // Clear the frameRequestId, as we're now rendering a fresh frame
                    this.frameRequestId = null;
                    var before = performance.now();
                    // On the first pass, make sure lastTime has a valid value
                    if (!this.lastRenderTime) this.lastRenderTime = time;
                    // Handle the onSecond callback
                    this.renderSecondTimer += time - this.lastRenderTime;
                    if (this.renderSecondTimer > 5000) {
                        this.renderSecondTimer = 0;
                        onSecond === null || onSecond === void 0 || onSecond();
                    }
                    // Calculate the elapsed time between frames in seconds
                    var elapsedTime = (time - this.lastRenderTime) / 1000;
                    this.lastRenderTime = time;
                    // - Advance non-paused animations by the elapsed number of seconds
                    // - Advance any animations that require scrubbing
                    // - Advance to the first frame even when autoplay is false
                    var activeAnimations = this.animator.animations.filter(function(a) {
                        return a.playing || a.needsScrub;
                    })// The scrubbed animations must be applied first to prevent weird artifacts
                    // if the playing animations conflict with the scrubbed animating attribuates.
                    .sort(function(first) {
                        return first.needsScrub ? -1 : 1;
                    });
                    for(var _i = 0, activeAnimations_1 = activeAnimations; _i < activeAnimations_1.length; _i++){
                        var animation = activeAnimations_1[_i];
                        animation.advance(elapsedTime);
                        if (animation.instance.didLoop) animation.loopCount += 1;
                        animation.apply(1.0);
                    }
                    // - Advance non-paused state machines by the elapsed number of seconds
                    // - Advance to the first frame even when autoplay is false
                    var activeStateMachines = this.animator.stateMachines.filter(function(a) {
                        return a.playing;
                    });
                    for(var _a = 0, activeStateMachines_1 = activeStateMachines; _a < activeStateMachines_1.length; _a++){
                        var stateMachine = activeStateMachines_1[_a];
                        // Check for events before the current frame's state machine advance
                        var numEventsReported = stateMachine.reportedEventCount();
                        if (numEventsReported) for(var i = 0; i < numEventsReported; i++){
                            var event_1 = stateMachine.reportedEventAt(i);
                            if (event_1) {
                                if (event_1.type === RiveEventType.OpenUrl) {
                                    this.eventManager.fire({
                                        type: EventType.RiveEvent,
                                        data: event_1
                                    });
                                    // Handle the event side effect if explicitly enabled
                                    if (this.automaticallyHandleEvents) {
                                        var newAnchorTag = document.createElement("a");
                                        var _b = event_1, url = _b.url, target = _b.target;
                                        var sanitizedUrl = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.sanitizeUrl)(url);
                                        url && newAnchorTag.setAttribute("href", sanitizedUrl);
                                        target && newAnchorTag.setAttribute("target", target);
                                        if (sanitizedUrl && sanitizedUrl !== _utils__WEBPACK_IMPORTED_MODULE_3__.BLANK_URL) newAnchorTag.click();
                                    }
                                } else this.eventManager.fire({
                                    type: EventType.RiveEvent,
                                    data: event_1
                                });
                            }
                        }
                        stateMachine.advanceAndApply(elapsedTime);
                    // stateMachine.instance.apply(this.artboard);
                    }
                    // Once the animations have been applied to the artboard, advance it
                    // by the elapsed time.
                    if (this.animator.stateMachines.length == 0) this.artboard.advance(elapsedTime);
                    var renderer = this.renderer;
                    // Canvas must be wiped to prevent artifacts
                    renderer.clear();
                    renderer.save();
                    // Update the renderer alignment if necessary
                    this.alignRenderer();
                    // Do not draw on 0 canvas size
                    if (!this._hasZeroSize) this.artboard.draw(renderer);
                    renderer.restore();
                    renderer.flush();
                    // Check for any animations that looped
                    this.animator.handleLooping();
                    // Check for any state machines that had a state change
                    this.animator.handleStateChanges();
                    // Report advanced time
                    this.animator.handleAdvancing(elapsedTime);
                    // Add duration to create frame to durations array
                    this.frameCount++;
                    var after = performance.now();
                    this.frameTimes.push(after);
                    this.durations.push(after - before);
                    while(this.frameTimes[0] <= after - 1000){
                        this.frameTimes.shift();
                        this.durations.shift();
                    }
                    // Calling requestAnimationFrame will rerun draw() at the correct rate:
                    // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Basic_animations
                    if (this.animator.isPlaying) // Request a new rendering frame
                    this.startRendering();
                    else if (this.animator.isPaused) // Reset the end time so on playback it starts at the correct frame
                    this.lastRenderTime = 0;
                    else if (this.animator.isStopped) // Reset animation instances, artboard and time
                    // TODO: implement this properly when we have instancing
                    // this.initArtboard();
                    // this.drawFrame();
                    this.lastRenderTime = 0;
                };
                /**
     * Align the renderer
     */ Rive.prototype.alignRenderer = function() {
                    var _a = this, renderer = _a.renderer, runtime = _a.runtime, _layout = _a._layout, artboard = _a.artboard;
                    // Align things up safe in the knowledge we can restore if changed
                    renderer.align(_layout.runtimeFit(runtime), _layout.runtimeAlignment(runtime), {
                        minX: _layout.minX,
                        minY: _layout.minY,
                        maxX: _layout.maxX,
                        maxY: _layout.maxY
                    }, artboard.bounds, this._devicePixelRatioUsed * _layout.layoutScaleFactor);
                };
                Object.defineProperty(Rive.prototype, "fps", {
                    get: function() {
                        return this.durations.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "frameTime", {
                    get: function() {
                        if (this.durations.length === 0) return 0;
                        return (this.durations.reduce(function(a, b) {
                            return a + b;
                        }, 0) / this.durations.length).toFixed(4);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Cleans up all Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances,
     * renderer instance, file and runtime.
     *
     * Once this is called, you will need to initialise a new instance of the
     * Rive class
     */ Rive.prototype.cleanup = function() {
                    var _a;
                    this.destroyed = true;
                    // Stop the renderer if it hasn't already been stopped.
                    this.stopRendering();
                    // Clean up any artboard, animation or state machine instances.
                    this.cleanupInstances();
                    // Remove from observer
                    if (this._observed !== null) observers.remove(this._observed);
                    this.removeRiveListeners();
                    if (this.file) {
                        (_a = this.riveFile) === null || _a === void 0 || _a.cleanup();
                        this.file = null;
                    }
                    this.riveFile = null;
                    this.deleteRiveRenderer();
                    if (this._audioEventListener !== null) {
                        audioManager.remove(this._audioEventListener);
                        this._audioEventListener = null;
                    }
                };
                /**
     * Cleans up the Renderer object. Only call this API if you no longer
     * need to render Rive content in your session.
     */ Rive.prototype.deleteRiveRenderer = function() {
                    var _a;
                    (_a = this.renderer) === null || _a === void 0 || _a.delete();
                    this.renderer = null;
                };
                /**
     * Cleans up any Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances.
     *
     * Once this is called, things will need to be reinitialized or bad things
     * might happen.
     */ Rive.prototype.cleanupInstances = function() {
                    if (this.eventCleanup !== null) this.eventCleanup();
                    // Delete all animation and state machine instances
                    this.stop();
                    if (this.artboard) {
                        this.artboard.delete();
                        this.artboard = null;
                    }
                };
                /**
     * Tries to query the setup Artboard for a text run node with the given name.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - TextValueRun node or undefined if the text run cannot be queried
     */ Rive.prototype.retrieveTextRun = function(textRunName) {
                    var _a;
                    if (!textRunName) {
                        console.warn("No text run name provided");
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text run, but the Artboard is null");
                        return;
                    }
                    var textRun = this.artboard.textRun(textRunName);
                    if (!textRun) {
                        console.warn("Could not access a text run with name '".concat(textRunName, "' in the '").concat((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.name, "' Artboard. Note that you must rename a text run node in the Rive editor to make it queryable at runtime."));
                        return;
                    }
                    return textRun;
                };
                /**
     * Returns a string from a given text run node name, or undefined if the text run
     * cannot be queried.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - String value of the text run node or undefined
     */ Rive.prototype.getTextRunValue = function(textRunName) {
                    var textRun = this.retrieveTextRun(textRunName);
                    return textRun ? textRun.text : undefined;
                };
                /**
     * Sets a text value for a given text run node name if possible
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @param textRunValue - String value to set on the text run node
     */ Rive.prototype.setTextRunValue = function(textRunName, textRunValue) {
                    var textRun = this.retrieveTextRun(textRunName);
                    if (textRun) textRun.text = textRunValue;
                };
                // Plays specified animations; if none specified, it unpauses everything.
                Rive.prototype.play = function(animationNames, autoplay) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, queue up the play
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.play(animationNames, autoplay);
                            }
                        });
                        return;
                    }
                    this.animator.play(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                    this.setupRiveListeners();
                    this.startRendering();
                };
                // Pauses specified animations; if none specified, pauses all.
                Rive.prototype.pause = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.pause(animationNames);
                            }
                        });
                        return;
                    }
                    if (this.eventCleanup) this.eventCleanup();
                    this.animator.pause(animationNames);
                };
                Rive.prototype.scrub = function(animationNames, value) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.scrub(animationNames, value);
                            }
                        });
                        return;
                    }
                    // Scrub the animation time; we draw a single frame here so that if
                    // nothing's currently playing, the scrubbed animation is still rendered/
                    this.animator.scrub(animationNames, value || 0);
                    this.drawFrame();
                };
                // Stops specified animations; if none specifies, stops them all.
                Rive.prototype.stop = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.stop(animationNames);
                            }
                        });
                        return;
                    }
                    // If there is no artboard, this.animator will be undefined
                    if (this.animator) this.animator.stop(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                };
                /**
     * Resets the animation
     * @param artboard the name of the artboard, or default if none given
     * @param animations the names of animations for playback
     * @param stateMachines the names of state machines for playback
     * @param autoplay whether to autoplay when reset, defaults to false
     *
     */ Rive.prototype.reset = function(params) {
                    var _a;
                    // Get the current artboard, animations, state machines, and playback states
                    var artBoardName = params === null || params === void 0 ? void 0 : params.artboard;
                    var animationNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.animations);
                    var stateMachineNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.stateMachines);
                    var autoplay = (_a = params === null || params === void 0 ? void 0 : params.autoplay) !== null && _a !== void 0 ? _a : false;
                    // Stop everything and clean up
                    this.cleanupInstances();
                    // Reinitialize an artboard instance with the state
                    this.initArtboard(artBoardName, animationNames, stateMachineNames, autoplay);
                    this.taskQueue.process();
                };
                // Loads a new Rive file, keeping listeners in place
                Rive.prototype.load = function(params) {
                    this.file = null;
                    // Stop all animations
                    this.stop();
                    // Reinitialize
                    this.init(params);
                };
                Object.defineProperty(Rive.prototype, "layout", {
                    /**
         * Returns the current layout. Note that layout should be treated as
         * immutable. If you want to change the layout, create a new one use the
         * layout setter
         */ get: function() {
                        return this._layout;
                    },
                    // Sets a new layout
                    set: function(layout) {
                        this._layout = layout;
                        // If the maxX or maxY are 0, then set them to the canvas width and height
                        if (!layout.maxX || !layout.maxY) this.resizeToCanvas();
                        if (this.loaded && !this.animator.isPlaying) this.drawFrame();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets the layout bounds to the current canvas size; this is typically called
     * when the canvas is resized
     */ Rive.prototype.resizeToCanvas = function() {
                    this._layout = this.layout.copyWith({
                        minX: 0,
                        minY: 0,
                        maxX: this.canvas.width,
                        maxY: this.canvas.height
                    });
                };
                /**
     * Accounts for devicePixelRatio as a multiplier to render the size of the canvas drawing surface.
     * Uses the size of the backing canvas to set new width/height attributes. Need to re-render
     * and resize the layout to match the new drawing surface afterwards.
     * Useful function for consumers to include in a window resize listener.
     *
     * This method will set the {@link devicePixelRatioUsed} property.
     *
     * Optionally, you can provide a {@link customDevicePixelRatio} to provide a
     * custom value.
     */ Rive.prototype.resizeDrawingSurfaceToCanvas = function(customDevicePixelRatio) {
                    if (this.canvas instanceof HTMLCanvasElement && !!window) {
                        var _a = this.canvas.getBoundingClientRect(), width = _a.width, height = _a.height;
                        var dpr = customDevicePixelRatio || window.devicePixelRatio || 1;
                        this.devicePixelRatioUsed = dpr;
                        this.canvas.width = dpr * width;
                        this.canvas.height = dpr * height;
                        this.resizeToCanvas();
                        this.drawFrame();
                        if (this.layout.fit === Fit.Layout) {
                            var scaleFactor = this._layout.layoutScaleFactor;
                            this.artboard.width = width / scaleFactor;
                            this.artboard.height = height / scaleFactor;
                        }
                    }
                };
                Object.defineProperty(Rive.prototype, "source", {
                    // Returns the animation source, which may be undefined
                    get: function() {
                        return this.src;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "activeArtboard", {
                    /**
         * Returns the name of the active artboard
         */ get: function() {
                        return this.artboard ? this.artboard.name : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "animationNames", {
                    // Returns a list of animation names on the chosen artboard
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var animationNames = [];
                        for(var i = 0; i < this.artboard.animationCount(); i++)animationNames.push(this.artboard.animationByIndex(i).name);
                        return animationNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "stateMachineNames", {
                    /**
         * Returns a list of state machine names from the current artboard
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var stateMachineNames = [];
                        for(var i = 0; i < this.artboard.stateMachineCount(); i++)stateMachineNames.push(this.artboard.stateMachineByIndex(i).name);
                        return stateMachineNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns the inputs for the specified instanced state machine, or an empty
     * list if the name is invalid or the state machine is not instanced
     * @param name the state machine name
     * @returns the inputs for the named state machine
     */ Rive.prototype.stateMachineInputs = function(name) {
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.loaded) return;
                    var stateMachine = this.animator.stateMachines.find(function(m) {
                        return m.name === name;
                    });
                    return stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.inputs;
                };
                // Returns the input with the provided name at the given path
                Rive.prototype.retrieveInputAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No input name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access input: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var input = this.artboard.inputByPath(name, path);
                    if (!input) {
                        console.warn("Could not access an input with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return input;
                };
                /**
     * Set the boolean input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setBooleanStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Boolean) input.asBool().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a boolean"));
                };
                /**
     * Set the number input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setNumberStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Number) input.asNumber().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a number"));
                };
                /**
     * Fire the trigger with the provided name at the given path
     * @param input the state machine input name
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.fireStateAtPath = function(inputName, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Trigger) input.asTrigger().fire();
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a trigger"));
                };
                // Returns the TextValueRun object for the provided name at the given path
                Rive.prototype.retrieveTextAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No text name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!path) {
                        console.warn("No path provided for text '".concat(name, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var text = this.artboard.textByPath(name, path);
                    if (!text) {
                        console.warn("Could not access text with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return text;
                };
                /**
     * Retrieves the text value for a specified text run at a given path
     * @param textName The name of the text run
     * @param path The path to the text run within the artboard
     * @returns The text value of the text run, or undefined if not found
     *
     * @example
     * // Get the text value for a text run named "title" at one nested artboard deep
     * const titleText = riveInstance.getTextRunValueAtPath("title", "artboard1");
     *
     * @example
     * // Get the text value for a text run named "subtitle" within a nested group two artboards deep
     * const subtitleText = riveInstance.getTextRunValueAtPath("subtitle", "group/nestedGroup");
     *
     * @remarks
     * If the text run cannot be found at the specified path, a warning will be logged to the console.
     */ Rive.prototype.getTextRunValueAtPath = function(textName, path) {
                    var run = this.retrieveTextAtPath(textName, path);
                    if (!run) {
                        console.warn("Could not get text with name: '".concat(textName, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return run.text;
                };
                /**
     * Sets the text value for a specified text run at a given path
     * @param textName The name of the text run
     * @param value The new text value to set
     * @param path The path to the text run within the artboard
     * @returns void
     *
     * @example
     * // Set the text value for a text run named "title" at one nested artboard deep
     * riveInstance.setTextRunValueAtPath("title", "New Title", "artboard1");
     *
     * @example
     * // Set the text value for a text run named "subtitle" within a nested group two artboards deep
     * riveInstance.setTextRunValueAtPath("subtitle", "New Subtitle", "group/nestedGroup");
     *
     * @remarks
     * If the text run cannot be found at the specified path, a warning will be logged to the console.
     */ Rive.prototype.setTextRunValueAtPath = function(textName, value, path) {
                    var run = this.retrieveTextAtPath(textName, path);
                    if (!run) {
                        console.warn("Could not set text with name: '".concat(textName, "', at path:'").concat(path, "'"));
                        return;
                    }
                    run.text = value;
                };
                Object.defineProperty(Rive.prototype, "playingStateMachineNames", {
                    // Returns a list of playing machine names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "playingAnimationNames", {
                    // Returns a list of playing animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedAnimationNames", {
                    // Returns a list of paused animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedStateMachineNames", {
                    /**
         *  Returns a list of paused machine names
         * @returns a list of state machine names that are paused
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPlaying", {
                    /**
         * @returns true if any animation is playing
         */ get: function() {
                        return this.animator.isPlaying;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPaused", {
                    /**
         * @returns true if all instanced animations are paused
         */ get: function() {
                        return this.animator.isPaused;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isStopped", {
                    /**
         * @returns true if no animations are playing or paused
         */ get: function() {
                        return this.animator.isStopped;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "bounds", {
                    /**
         * @returns the bounds of the current artboard, or undefined if the artboard
         * isn't loaded yet.
         */ get: function() {
                        return this.artboard ? this.artboard.bounds : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ Rive.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ Rive.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @deprecated
     * @param callback the callback to unsubscribe from
     */ Rive.prototype.unsubscribe = function(type, callback) {
                    console.warn("This function is deprecated: please use `off()` instead.");
                    this.off(type, callback);
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                /**
     * Unsubscribes all listeners from an event type, or everything if no type is
     * given
     * @deprecated
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.unsubscribeAll = function(type) {
                    console.warn("This function is deprecated: please use `removeAllRiveEventListeners()` instead.");
                    this.removeAllRiveEventListeners(type);
                };
                /**
     * Stops the rendering loop; this is different from pausing in that it doesn't
     * change the state of any animation. It stops rendering from occurring. This
     * is designed for situations such as when Rive isn't visible.
     *
     * The only way to start rendering again is to call `startRendering`.
     * Animations that are marked as playing will start from the position that
     * they would have been at if rendering had not been stopped.
     */ Rive.prototype.stopRendering = function() {
                    if (this.loaded && this.frameRequestId) {
                        if (this.runtime.cancelAnimationFrame) this.runtime.cancelAnimationFrame(this.frameRequestId);
                        else cancelAnimationFrame(this.frameRequestId);
                        this.frameRequestId = null;
                    }
                };
                /**
     * Starts the rendering loop if it has been previously stopped. If the
     * renderer is already active, then this will have zero effect.
     */ Rive.prototype.startRendering = function() {
                    if (this.loaded && this.artboard && !this.frameRequestId) {
                        if (this.runtime.requestAnimationFrame) this.frameRequestId = this.runtime.requestAnimationFrame(this._boundDraw);
                        else this.frameRequestId = requestAnimationFrame(this._boundDraw);
                    }
                };
                /**
     * Enables frames-per-second (FPS) reporting for the runtime
     * If no callback is provided, Rive will append a fixed-position div at the top-right corner of
     * the page with the FPS reading
     * @param fpsCallback - Callback from the runtime during the RAF loop that supplies the FPS value
     */ Rive.prototype.enableFPSCounter = function(fpsCallback) {
                    this.runtime.enableFPSCounter(fpsCallback);
                };
                /**
     * Disables frames-per-second (FPS) reporting for the runtime
     */ Rive.prototype.disableFPSCounter = function() {
                    this.runtime.disableFPSCounter();
                };
                Object.defineProperty(Rive.prototype, "contents", {
                    /**
         * Returns the contents of a Rive file: the artboards, animations, and state machines
         */ get: function() {
                        if (!this.loaded) return undefined;
                        var riveContents = {
                            artboards: []
                        };
                        for(var i = 0; i < this.file.artboardCount(); i++){
                            var artboard = this.file.artboardByIndex(i);
                            var artboardContents = {
                                name: artboard.name,
                                animations: [],
                                stateMachines: []
                            };
                            for(var j = 0; j < artboard.animationCount(); j++){
                                var animation = artboard.animationByIndex(j);
                                artboardContents.animations.push(animation.name);
                            }
                            for(var k = 0; k < artboard.stateMachineCount(); k++){
                                var stateMachine = artboard.stateMachineByIndex(k);
                                var name_1 = stateMachine.name;
                                var instance = new this.runtime.StateMachineInstance(stateMachine, artboard);
                                var inputContents = [];
                                for(var l = 0; l < instance.inputCount(); l++){
                                    var input = instance.input(l);
                                    inputContents.push({
                                        name: input.name,
                                        type: input.type
                                    });
                                }
                                artboardContents.stateMachines.push({
                                    name: name_1,
                                    inputs: inputContents
                                });
                            }
                            riveContents.artboards.push(artboardContents);
                        }
                        return riveContents;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "volume", {
                    /**
         * Getter / Setter for the volume of the artboard
         */ get: function() {
                        if (this.artboard && this.artboard.volume !== this._volume) this._volume = this.artboard.volume;
                        return this._volume;
                    },
                    set: function(value) {
                        this._volume = value;
                        if (this.artboard) this.artboard.volume = value * audioManager.systemVolume;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "artboardWidth", {
                    /**
         * The width of the artboard.
         *
         * This will return 0 if the artboard is not loaded yet and a custom
         * width has not been set.
         *
         * Do not set this value manually when using {@link resizeDrawingSurfaceToCanvas}
         * with a {@link Layout.fit} of {@link Fit.Layout}, as the artboard width is
         * automatically set.
         */ get: function() {
                        var _a;
                        if (this.artboard) return this.artboard.width;
                        return (_a = this._artboardWidth) !== null && _a !== void 0 ? _a : 0;
                    },
                    set: function(value) {
                        this._artboardWidth = value;
                        if (this.artboard) this.artboard.width = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "artboardHeight", {
                    /**
         * The height of the artboard.
         *
         * This will return 0 if the artboard is not loaded yet and a custom
         * height has not been set.
         *
         * Do not set this value manually when using {@link resizeDrawingSurfaceToCanvas}
         * with a {@link Layout.fit} of {@link Fit.Layout}, as the artboard height is
         * automatically set.
         */ get: function() {
                        var _a;
                        if (this.artboard) return this.artboard.height;
                        return (_a = this._artboardHeight) !== null && _a !== void 0 ? _a : 0;
                    },
                    set: function(value) {
                        this._artboardHeight = value;
                        if (this.artboard) this.artboard.height = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Reset the artboard size to its original values.
     */ Rive.prototype.resetArtboardSize = function() {
                    if (this.artboard) {
                        this.artboard.resetArtboardSize();
                        this._artboardWidth = this.artboard.width;
                        this._artboardHeight = this.artboard.height;
                    } else {
                        // If the artboard isn't loaded, we need to reset the custom width and height
                        this._artboardWidth = undefined;
                        this._artboardHeight = undefined;
                    }
                };
                Object.defineProperty(Rive.prototype, "devicePixelRatioUsed", {
                    /**
         * The device pixel ratio used in rendering and canvas/artboard resizing.
         *
         * This value will be overidden by the device pixel ratio used in
         * {@link resizeDrawingSurfaceToCanvas}. If you use that method, do not set this value.
         */ get: function() {
                        return this._devicePixelRatioUsed;
                    },
                    set: function(value) {
                        this._devicePixelRatioUsed = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                // Error message for missing source or buffer
                Rive.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for removed rive file
                Rive.cleanupErrorMessage = "Attempt to use file after calling cleanup.";
                return Rive;
            }();
            // Loads Rive data from a URI via fetch.
            var loadRiveFile = function(src) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var req, res, buffer;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                req = new Request(src);
                                return [
                                    4 /*yield*/ ,
                                    fetch(req)
                                ];
                            case 1:
                                res = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    res.arrayBuffer()
                                ];
                            case 2:
                                buffer = _a.sent();
                                return [
                                    2 /*return*/ ,
                                    buffer
                                ];
                        }
                    });
                });
            };
            // #endregion
            // #region utility functions
            /*
 * Utility function to ensure an object is a string array
 */ var mapToStringArray = function(obj) {
                if (typeof obj === "string") return [
                    obj
                ];
                else if (obj instanceof Array) return obj;
                // If obj is undefined, return empty array
                return [];
            };
            // #endregion
            // #region testing utilities
            // Exports to only be used for tests
            var Testing = {
                EventManager: EventManager,
                TaskQueueManager: TaskQueueManager
            };
            // #endregion
            // #region asset loaders
            /**
 * Decodes bytes into an audio asset.
 *
 * Be sure to call `.unref()` on the audio once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeAudio = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeAudio(bytes, resolve);
                    });
                });
            };
            /**
 * Decodes bytes into an image.
 *
 * Be sure to call `.unref()` on the image once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeImage = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeImage(bytes, resolve);
                    });
                });
            };
            /**
 * Decodes bytes into a font.
 *
 * Be sure to call `.unref()` on the font once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeFont = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeFont(bytes, resolve);
                    });
                });
            };
        // #endregion
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});





parcelRegister("cwx2f", function(module, exports) {
$parcel$export(module.exports, "Wiki", function () { return $c1e9d288a7dd952f$export$ee89167f055f4c61; });

var $7VQPk = parcelRequire("7VQPk");

var $95rvY = parcelRequire("95rvY");
const $c1e9d288a7dd952f$export$ee89167f055f4c61 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95rvY.AnimationWithSize), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d8up4bbs57m1i281l14ghllan3w30h63.riv"
    });

});

parcelRegister("eFBwf", function(module, exports) {
$parcel$export(module.exports, "Page", function () { return $389218972e8790a9$export$6955bcca4cd3539f; });

var $7VQPk = parcelRequire("7VQPk");

var $95rvY = parcelRequire("95rvY");
const $389218972e8790a9$export$6955bcca4cd3539f = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95rvY.AnimationWithSize), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/38q0358viy2mcd14c3tvx2s437634r53.riv"
    });

});

parcelRegister("ayQSY", function(module, exports) {
$parcel$export(module.exports, "Whiteboard", function () { return $6fb1962a3d12e3cd$export$92e2b3062e1f1116; });

var $7VQPk = parcelRequire("7VQPk");

var $95rvY = parcelRequire("95rvY");
const $6fb1962a3d12e3cd$export$92e2b3062e1f1116 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95rvY.AnimationWithSize), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/j2os26c533drhayq0qx6e705h5vh328b.riv"
    });

});

parcelRegister("kb1Ca", function(module, exports) {
$parcel$export(module.exports, "Spreadsheet", function () { return $575a4064cc3b46de$export$2ada22cf838dec7d; });

var $7VQPk = parcelRequire("7VQPk");

var $95rvY = parcelRequire("95rvY");
const $575a4064cc3b46de$export$2ada22cf838dec7d = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95rvY.AnimationWithSize), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/e75324xa0uc61rda6s00p210neq15e57.riv"
    });

});

parcelRegister("8uiKg", function(module, exports) {
$parcel$export(module.exports, "OrgChart", function () { return $789d41414421f5c5$export$8929951f37b9096e; });

var $7VQPk = parcelRequire("7VQPk");

var $95rvY = parcelRequire("95rvY");
const $789d41414421f5c5$export$8929951f37b9096e = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95rvY.AnimationWithSize), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8y40h4qsl1sj30uv326g405fh6rch485.riv"
    });

});

parcelRegister("k6cCS", function(module, exports) {
$parcel$export(module.exports, "MindMap", function () { return $d51abf46d2b27a1a$export$164e79f76a2d9d14; });

var $7VQPk = parcelRequire("7VQPk");

var $95rvY = parcelRequire("95rvY");
const $d51abf46d2b27a1a$export$164e79f76a2d9d14 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95rvY.AnimationWithSize), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/28nn7y04kk8jwnv45hr78c2d8o53510t.riv"
    });

});

parcelRegister("iyOcM", function(module, exports) {
$parcel$export(module.exports, "useAdg4TabsContext", function () { return $3ff496372397c15b$export$8fc90cd28db43001; });
$parcel$export(module.exports, "Adg4Tabs", function () { return $3ff496372397c15b$export$e329eabcff0a2a4a; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $aHkxS = parcelRequire("aHkxS");

var $6jJHH = parcelRequire("6jJHH");
const $3ff496372397c15b$var$Adg4TabsContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $3ff496372397c15b$export$8fc90cd28db43001 = ()=>{
    const context = (0, $1oC0p.useContext)($3ff496372397c15b$var$Adg4TabsContext);
    if (!context) throw new Error('useAdg4TabsContext must be used within Adg4Tabs');
    return context;
};
let $3ff496372397c15b$var$nextId = 0;
const $3ff496372397c15b$export$e329eabcff0a2a4a = ({ id: id, initialTab: initialTab, loop: loop = true, children: children, tabSwitchInterval: tabSwitchInterval, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(initialTab ?? 0);
    const [userSelected, setUserSelected] = (0, $1oC0p.useState)(false);
    const [focus, setFocus] = (0, $1oC0p.useState)(false);
    const tabIds = (0, $1oC0p.useRef)([]);
    const contextId = (0, $1oC0p.useRef)(`:tabs:${id ? id : $3ff496372397c15b$var$nextId++}:`);
    const timerRef = (0, $1oC0p.useRef)();
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD,
        ...useInViewOptionsContainer
    });
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $6jJHH.deepForEach)(children, (child)=>{
            if ((0, $6jJHH.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount();
        // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
        // Map children to dynamically setup refs
        return (0, $6jJHH.deepMap)(children, (child)=>{
            let result = child;
            // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement;
            // Get the active element id
            const activeElementId = windowAvailable ? window.document.activeElement?.id : null;
            // Clone TabList and Tab components to have refs
            if ((0, $6jJHH.isTabList)(child)) {
                let listIndex = 0;
                // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $1oC0p.Children).toArray(child.props.children).filter((0, $6jJHH.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                    children: (0, $6jJHH.deepMap)(child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $1oC0p.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $6jJHH.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = {
                    ...existingProps,
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                };
                panelIndex++;
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, props);
            }
            return result;
        });
    }
    const goToTab = (tabIndex, clearTimer)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
        if (clearTimer) {
            setUserSelected(true);
            clearInterval(timerRef.current);
        }
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === 'ArrowLeft' || e.code === 'ArrowUp') goToPrevTab();
        else if (e.code === 'ArrowRight' || e.code === 'ArrowDown') goToNextTab();
        else if (e.code === 'End') // Select last tab (End key)
        goToFirstTab();
        else if (e.code === 'Home') // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true);
        // This prevents scrollbars from moving around
        e.preventDefault();
    };
    // Reset the userSelected state when the section is visible again
    (0, $1oC0p.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]);
    // Auto switch tabs effect
    (0, $1oC0p.useEffect)(()=>{
        // clear out any timer that exists
        if (timerRef.current) clearTimeout(timerRef.current);
        if (tabSwitchInterval && tabsContainerIsVisible && !userSelected) timerRef.current = setTimeout(goToNextTab, tabSwitchInterval);
        return ()=>{
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [
        currentTab,
        tabSwitchInterval,
        tabsContainerIsVisible,
        goToNextTab,
        userSelected
    ]);
    // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($3ff496372397c15b$var$Adg4TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: containerScrollRef,
            children: getChildren()
        })
    });
};

});
parcelRegister("jKShK", function(module, exports) {
$parcel$export(module.exports, "useInView", function () { return $e61c6c1e0f34bce3$export$2f62ee6831462844; });

var $1oC0p = parcelRequire("1oC0p");
"use client";
var $e61c6c1e0f34bce3$var$__defProp = Object.defineProperty;
var $e61c6c1e0f34bce3$var$__defNormalProp = (obj, key, value)=>key in obj ? $e61c6c1e0f34bce3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e61c6c1e0f34bce3$var$__publicField = (obj, key, value)=>{
    $e61c6c1e0f34bce3$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/observe.ts
var $e61c6c1e0f34bce3$var$observerMap = /* @__PURE__ */ new Map();
var $e61c6c1e0f34bce3$var$RootIds = /* @__PURE__ */ new WeakMap();
var $e61c6c1e0f34bce3$var$rootId = 0;
var $e61c6c1e0f34bce3$var$unsupportedValue = void 0;
function $e61c6c1e0f34bce3$export$2ef3a60ee1f37bec(inView) {
    $e61c6c1e0f34bce3$var$unsupportedValue = inView;
}
function $e61c6c1e0f34bce3$var$getRootId(root) {
    if (!root) return "0";
    if ($e61c6c1e0f34bce3$var$RootIds.has(root)) return $e61c6c1e0f34bce3$var$RootIds.get(root);
    $e61c6c1e0f34bce3$var$rootId += 1;
    $e61c6c1e0f34bce3$var$RootIds.set(root, $e61c6c1e0f34bce3$var$rootId.toString());
    return $e61c6c1e0f34bce3$var$RootIds.get(root);
}
function $e61c6c1e0f34bce3$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $e61c6c1e0f34bce3$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $e61c6c1e0f34bce3$var$createObserver(options) {
    const id = $e61c6c1e0f34bce3$var$optionsToId(options);
    let instance = $e61c6c1e0f34bce3$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $e61c6c1e0f34bce3$var$observerMap.set(id, instance);
    }
    return instance;
}
function $e61c6c1e0f34bce3$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $e61c6c1e0f34bce3$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $e61c6c1e0f34bce3$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $e61c6c1e0f34bce3$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $e61c6c1e0f34bce3$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $e61c6c1e0f34bce3$export$a62107ca74432f44 = class extends $1oC0p.Component {
    constructor(props){
        super(props);
        $e61c6c1e0f34bce3$var$__publicField(this, "node", null);
        $e61c6c1e0f34bce3$var$__publicField(this, "_unobserveCb", null);
        $e61c6c1e0f34bce3$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $e61c6c1e0f34bce3$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$e61c6c1e0f34bce3$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $e61c6c1e0f34bce3$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $1oC0p.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $e61c6c1e0f34bce3$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $1oC0p.useState(null);
    const callback = $1oC0p.useRef();
    const [state, setState] = $1oC0p.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $1oC0p.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $e61c6c1e0f34bce3$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $1oC0p.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});

parcelRegister("aHkxS", function(module, exports) {
$parcel$export(module.exports, "Initializer", function () { return $bc1a912ec4e44a09$export$9e14a7677ef1423c; });

var $fuLgT = parcelRequire("fuLgT");

var $gx3aw = parcelRequire("gx3aw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $cuuGB = parcelRequire("cuuGB");

var $cYY9z = parcelRequire("cYY9z");

var $fLpER = parcelRequire("fLpER");

var $axCad = parcelRequire("axCad");

var $i0bD5 = parcelRequire("i0bD5");

var $1P8AQ = parcelRequire("1P8AQ");

var $92PV0 = parcelRequire("92PV0");
class $bc1a912ec4e44a09$export$9e14a7677ef1423c {
    /**
   * Loads and initializes segment.io.
   * @function initWithPageAnalytics
   * @param {string} writeKey - required, Segment.io key
   * @param {object} pageViewProperties - optional, dictionary of properties of the page (see: https://segment.com/docs/libraries/analytics.js/#page)
   * @param {object} loadOptions - optional, object with a dictionary of which integrations to load (see: https://segment.com/docs/sources/website/analytics.js/#load-options)
   * @param {number} loadTimestamp - optional, the timestamp at which the initializing site loaded this script
   * @param {string} anonymousId - GASv3 analytics client anonymous id
   * @param {function} createAnalyticsEvent - analytics next CreateUIAnalyticsEvent
   */ static initWithPageAnalytics(writeKey, pageViewProperties, loadOptions, loadTimestamp, anonymousId, createAnalyticsEvent, analyticsOptOut) {
        (0, $cYY9z.AnalyticsState).anonymousId = anonymousId;
        (0, $cYY9z.AnalyticsState).analyticsOptOut = analyticsOptOut;
        // Always set createAnalyticsEvent so operational events can fire when opt-out
        (0, $cYY9z.AnalyticsState).createAnalyticsEvent = createAnalyticsEvent;
        // set unpopulated params to empty objects
        if (typeof loadOptions !== 'object' || loadOptions === null) loadOptions = {};
        if (typeof pageViewProperties !== 'object' || pageViewProperties === null) pageViewProperties = {};
        $bc1a912ec4e44a09$export$9e14a7677ef1423c.captureUTMs();
        // adding marketing boolean if current product comes under marketing domain
        $bc1a912ec4e44a09$export$9e14a7677ef1423c.setIsMarketingEvent(pageViewProperties);
        // set load timestamp for calculating metrics
        (0, $1P8AQ.Metrics).setLoadTimestamp(loadTimestamp);
        // store params for later reporting if necessary.
        (0, $cYY9z.AnalyticsState).writeKey = writeKey;
        // TODO: pageViewOptions used to be passed in, but doesn't appear to be used outside of Segment.
        // Can we just delete this completely?
        (0, $cYY9z.AnalyticsState).pageViewOptions = {};
        // auto-fire page view
        (0, $i0bD5.Helpers).addActualUrl(pageViewProperties);
        const isEnableOperationalEventWhenOptedOut = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10416DisableNonOperationalAnalyticsGateUip);
        if (isEnableOperationalEventWhenOptedOut) {
            $bc1a912ec4e44a09$export$9e14a7677ef1423c.setSnIdAndAtlFirstVisit(writeKey, pageViewProperties);
            // updates the activeGroups property in atl_first_visit when window.OnetrustActiveGroups changes
            $bc1a912ec4e44a09$export$9e14a7677ef1423c.updateAtlFirstVisitActiveGroups();
            $bc1a912ec4e44a09$export$9e14a7677ef1423c.listenForActiveGroupsChange();
        }
        (0, $92PV0.Tracking).pageView(pageViewProperties);
        if (!analyticsOptOut) {
            // TODO: Switch these params to dynamically config based on writeKey
            (0, $axCad.Gtm).initialize(writeKey);
            // add auto tracking and configure google analytics integration
            $bc1a912ec4e44a09$export$9e14a7677ef1423c.autoTrack();
            $bc1a912ec4e44a09$export$9e14a7677ef1423c.gaIntegration();
            $bc1a912ec4e44a09$export$9e14a7677ef1423c.globalCallReady();
        }
    }
    /**
   * Set SN_ID in the cookie
   */ static setSnIdAndAtlFirstVisit(writeKey, pageViewProperties) {
        // Get SN_ID from cookie, if doesn't exist make one
        let snId = (0, $gx3aw.Cookie).readCookie('sn_id') ?? null;
        if (snId) // if sn_id cookie does exist, we verify to make sure the atl_first_visit local storage item is also present and not expired
        {
            if ($bc1a912ec4e44a09$export$9e14a7677ef1423c.isSetAtlFirstVisit()) $bc1a912ec4e44a09$export$9e14a7677ef1423c.setAtlFirstVisitInLocalStorage(writeKey, pageViewProperties);
        } else {
            (0, $cuuGB.polyfillGetRandomValuesIfNecessary)();
            snId = (0, $fuLgT.default)();
            (0, $gx3aw.Cookie).writeCookie('sn_id', encodeURIComponent('"' + snId + '"'), 1, true);
            // if sn_id cookie doesn't exist or has expired, then we'll just create a new atl_first_visit locat storage item
            $bc1a912ec4e44a09$export$9e14a7677ef1423c.setAtlFirstVisitInLocalStorage(writeKey, pageViewProperties);
        }
        (0, $cYY9z.AnalyticsState).snId = decodeURIComponent(snId).replace(/['"]+/g, '');
        (0, $cYY9z.AnalyticsState).atlFirstVisit = localStorage.getItem('atl_first_visit') || '{}';
    }
    /**
   * Check if atl_first_visit is missing and or has expired then we return true, else false
   * @returns boolean
   */ static isSetAtlFirstVisit() {
        const atl_first_visit_data = localStorage.getItem('atl_first_visit');
        if (atl_first_visit_data) {
            const parsedAtlFirstVisitData = JSON.parse(atl_first_visit_data);
            const expiresAt = parsedAtlFirstVisitData?.expiresAt;
            if (expiresAt === null) return true;
            if (new Date(expiresAt).getTime() < Date.now()) return true;
            return false;
        }
        return true;
    }
    /**
   * Set the atl_first_visit data in localStorage
   * @param {string} writeKey
   * @param pageViewProperties
   */ static setAtlFirstVisitInLocalStorage(writeKey, pageViewProperties) {
        const referrer = document.referrer || 'about:blank';
        const refUrl = new URL(referrer);
        const atl_first_visit_data = $bc1a912ec4e44a09$export$9e14a7677ef1423c.buildAtlFirstVisitData(writeKey, pageViewProperties, refUrl);
        try {
            localStorage.setItem('atl_first_visit', JSON.stringify(atl_first_visit_data));
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('atl_first_visit localStorage update failed', JSON.stringify(e));
        }
    }
    /**
   * Build the atl_first_visit data
   * @param {string} writeKey
   * @param pageViewProperties
   * @param refUrl
   * @returns
   */ // eslint-disable-next-line complexity
    static buildAtlFirstVisitData(writeKey, pageViewProperties, refUrl) {
        const expiry = 86400000; // 24 hours
        const orEmpty = (v)=>v !== null && v !== '' ? String(v) : '';
        const searchLogicEntries = JSON.stringify(Object.fromEntries(new URLSearchParams(window.location.search ?? '').entries()));
        const utms = (0, $cYY9z.AnalyticsState).utms;
        const transformedUtms = {
            name: utms?.['utm_campaign'] ?? '',
            campaign: utms?.['utm_campaign'] ?? '',
            'sfdc-campaign_id': utms?.['utm_sfdc-campaign_id'] ?? '',
            medium: utms?.['utm_medium'] ?? '',
            source: utms?.['utm_source'] ?? '',
            content: utms?.['utm_content'] ?? ''
        };
        return {
            originProduct: pageViewProperties['originProduct'] ?? '',
            campaign: transformedUtms,
            page_url_params_json: searchLogicEntries,
            page_url: orEmpty(window.location.href),
            page_canonical_url: orEmpty((0, $i0bD5.Helpers).maskURL((0, $i0bD5.Helpers).getCanonicalUrl())),
            page_path: orEmpty(window.location.pathname),
            page_domain: orEmpty(window.location.hostname),
            page_subdomain: orEmpty(window.location.hostname),
            page_referrer_url: orEmpty(document.referrer),
            page_referrer_domain: orEmpty(refUrl.hostname),
            page_referrer_subdomain: orEmpty(refUrl.hostname),
            page_url_parameters: orEmpty(window.location.search),
            page_referrer_url_parameters: orEmpty(refUrl.search),
            isMarketingEvent: (0, $fLpER.GASv3).isMarketingEvent ?? false,
            cookiesEnabled: window.navigator.cookieEnabled ?? 'unknown',
            activeGroups: orEmpty(window.OnetrustActiveGroups),
            onboardingJourney: orEmpty(localStorage.getItem('onboarding-journey')),
            cmsPageVariant: orEmpty(window.cmsPageVariant),
            bxpGatewayRequestId: orEmpty((0, $gx3aw.Cookie).readCookie('bxp_gateway_request_id')),
            'user-agent': orEmpty(window.navigator.userAgent),
            'onboarding-journey': orEmpty(localStorage.getItem('onboarding-journey')),
            writeKey: orEmpty(writeKey),
            expiresAt: Date.now() + expiry
        };
    }
    static updateAtlFirstVisitActiveGroups() {
        const atl_first_visit_data = localStorage.getItem('atl_first_visit');
        if (atl_first_visit_data) {
            let parsedData;
            try {
                parsedData = JSON.parse(atl_first_visit_data);
                if (parsedData['activeGroups'] !== window.OnetrustActiveGroups) {
                    parsedData['activeGroups'] = window.OnetrustActiveGroups;
                    localStorage.setItem('atl_first_visit', JSON.stringify(parsedData));
                }
            } catch (e) {
                (0, $i0bD5.Helpers).sendWrapperLoadError('atl_first_visit activeGroups update failed on page load', JSON.stringify(e));
            }
        }
    }
    static listenForActiveGroupsChange() {
        // listen for active groups change and update the atl_first_visit data
        let _activeGroups = window.OnetrustActiveGroups;
        try {
            Object.defineProperty(window, 'OnetrustActiveGroups', {
                get: function() {
                    return _activeGroups;
                },
                set: function(newGroups) {
                    if (newGroups !== _activeGroups) {
                        _activeGroups = newGroups;
                        const atl_first_visit_data = localStorage.getItem('atl_first_visit');
                        if (atl_first_visit_data) {
                            let parsedData;
                            try {
                                parsedData = JSON.parse(atl_first_visit_data);
                            } catch  {
                                parsedData = {};
                            }
                            if (Object.keys(parsedData).length > 0) {
                                parsedData['activeGroups'] = newGroups;
                                localStorage.setItem('atl_first_visit', JSON.stringify(parsedData));
                            }
                        }
                    }
                },
                configurable: true
            });
        } catch (e) {
            const message = e instanceof Error ? e.message : String(e);
            (0, $i0bD5.Helpers).sendWrapperLoadError('atl_first_visit activeGroups update failed', message);
        }
    }
    /**
   * Calls window functions that are awaiting a wrapper ready state
   * @function globalCallReady
   */ static globalCallReady() {
        if (typeof window.analyticsPageReady === 'function') window.analyticsPageReady();
        (0, $1P8AQ.Metrics).logMetric((0, $1P8AQ.MetricKey).TIME_TO_READY);
        (0, $1P8AQ.Metrics).sendMetrics();
    }
    static captureAtlFirstVisitUTMs() {
        return {
            'utm_sfdc-campaign_id': '',
            utm_campaign: '',
            utm_medium: '',
            utm_source: '',
            utm_content: '',
            utm_term: ''
        };
    }
    static captureUTMs() {
        const utmKeys = $bc1a912ec4e44a09$export$9e14a7677ef1423c.captureAtlFirstVisitUTMs();
        (0, $cYY9z.AnalyticsState).utms = (0, $i0bD5.Helpers).getAndSetUtms(utmKeys);
    }
    /**
   * Applies auto-tracking for select domains
   * @function autoTrack
   */ static autoTrack() {
        (0, $92PV0.Tracking).autoTrackButtons(true);
        (0, $92PV0.Tracking).autoTrackLinks(true);
        (0, $92PV0.Tracking).autoTrackVideos();
        (0, $92PV0.Tracking).autoTrackSelects();
        (0, $92PV0.Tracking).autoTrackTabs();
        (0, $92PV0.Tracking).autoTrackDetails();
    }
    /**
   * Completes path overrides for Google Analytics
   * @function gaIntegration
   */ static gaIntegration() {
        const emailDetected = (0, $i0bD5.Helpers).emailAddressIsDetected();
        const pathOverride = '/path-contained-email-address';
        if (typeof window.ga !== 'undefined') {
            window.ga('require', 'linker');
            window.ga('linker:autoLink', [
                'atlassian.com',
                'bitbucket.org',
                'hipchat.com',
                'attendease.com',
                'get.atlassian.com',
                'eegeventsite.secure.force.com',
                'atlassian.swoogo.com'
            ]);
            if (emailDetected) {
                // only override what is needed
                if ((0, $i0bD5.Helpers).urlContainsEmail(window.location.href)) {
                    window.ga('set', 'location', window.location.origin + pathOverride);
                    window.ga('set', 'path', pathOverride);
                }
                if ((0, $i0bD5.Helpers).urlContainsEmail(document.referrer)) window.ga('set', 'referrer', (0, $i0bD5.Helpers).hostnameFromUrl(document.referrer) + pathOverride);
            }
        }
    }
    static setIsMarketingEvent(pageViewProperties) {
        if (typeof pageViewProperties['isMarketingEvent'] !== 'boolean') (0, $fLpER.GASv3).isMarketingEvent = true;
        else (0, $fLpER.GASv3).isMarketingEvent = pageViewProperties['isMarketingEvent'];
    }
    static setXID(xid) {
        (0, $92PV0.Tracking).xid = xid;
    }
}

});
parcelRegister("cN0Nw", function(module, exports) {
$parcel$export(module.exports, "checkFeatureFlagGate", function () { return $6881819918724b39$export$3331b5930c252bb2; });

var $3L8ZR = parcelRequire("3L8ZR");

var $k4D4E = parcelRequire("k4D4E");
function $6881819918724b39$export$3331b5930c252bb2(featureFlag) {
    const { featureFlagName: featureFlagName } = featureFlag;
    const value = (0, $3L8ZR.default).checkGate(featureFlagName);
    (0, $k4D4E.addFeatureFlagExposureToSentry)(featureFlagName, value);
    return value;
}

});
parcelRegister("k4D4E", function(module, exports) {
$parcel$export(module.exports, "addFeatureFlagExposureToSentry", function () { return $58f6cf3ce7730148$export$823d4c94f9c66ca0; });

var $i7nxO = parcelRequire("i7nxO");
function $58f6cf3ce7730148$export$823d4c94f9c66ca0(experimentName, value) {
    // Sentry FeatureFlagsIntegration only supports boolean flags (for now).
    if (typeof value !== 'boolean') return;
    const flagsIntegration = $i7nxO.getClient()?.getIntegrationByName('FeatureFlags');
    if (flagsIntegration) try {
        flagsIntegration.addFeatureFlag(experimentName, value);
    } catch (e) {
        // Something went wrong, check your DSN and/or integrations
        console.error(e);
    }
}

});
parcelRegister("i7nxO", function(module, exports) {
$parcel$export(module.exports, "getCurrentScope", function () { return $d30b24d868030ce7$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $d30b24d868030ce7$export$68f3af03034c9e90; });
$parcel$export(module.exports, "getGlobalScope", function () { return $d30b24d868030ce7$export$aa55d5ab8e05984f; });
$parcel$export(module.exports, "withScope", function () { return $d30b24d868030ce7$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $d30b24d868030ce7$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "getClient", function () { return $d30b24d868030ce7$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "getTraceContextFromScope", function () { return $d30b24d868030ce7$export$1e83db7ee4876dc4; });

var $eM6ET = parcelRequire("eM6ET");

var $5TFFW = parcelRequire("5TFFW");

var $fex0p = parcelRequire("fex0p");

var $gTm65 = parcelRequire("gTm65");
/**
 * Get the currently active scope.
 */ function $d30b24d868030ce7$export$c7be4b0125a10cba() {
    const carrier = (0, $5TFFW.getMainCarrier)();
    const acs = (0, $eM6ET.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $d30b24d868030ce7$export$68f3af03034c9e90() {
    const carrier = (0, $5TFFW.getMainCarrier)();
    const acs = (0, $eM6ET.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $d30b24d868030ce7$export$aa55d5ab8e05984f() {
    return (0, $5TFFW.getGlobalSingleton)('globalScope', ()=>new (0, $fex0p.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $d30b24d868030ce7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $5TFFW.getMainCarrier)();
    const acs = (0, $eM6ET.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $d30b24d868030ce7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $5TFFW.getMainCarrier)();
    const acs = (0, $eM6ET.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $d30b24d868030ce7$export$6bb76d6eba7e258c() {
    return $d30b24d868030ce7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $d30b24d868030ce7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $gTm65.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("eM6ET", function(module, exports) {
$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $ac1ab69cfaf6440d$export$f639b0c2752203be; });

var $5TFFW = parcelRequire("5TFFW");

var $d4s5r = parcelRequire("d4s5r");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $ac1ab69cfaf6440d$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $5TFFW.getMainCarrier)();
    const sentry = (0, $5TFFW.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $ac1ab69cfaf6440d$export$f639b0c2752203be(carrier) {
    const sentry = (0, $5TFFW.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $d4s5r.getStackAsyncContextStrategy)();
}

});
parcelRegister("5TFFW", function(module, exports) {
$parcel$export(module.exports, "getMainCarrier", function () { return $44b26ab0c96d9ca0$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $44b26ab0c96d9ca0$export$c8bfa33e4e8ae492; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $44b26ab0c96d9ca0$export$7e223ec222791509; });

var $gMJ1n = parcelRequire("gMJ1n");

var $9ishN = parcelRequire("9ishN");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $44b26ab0c96d9ca0$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $44b26ab0c96d9ca0$export$c8bfa33e4e8ae492((0, $9ishN.GLOBAL_OBJ));
    return 0, $9ishN.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $44b26ab0c96d9ca0$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $gMJ1n.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $gMJ1n.SDK_VERSION] = __SENTRY__[0, $gMJ1n.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $44b26ab0c96d9ca0$export$7e223ec222791509(name, creator, obj = (0, $9ishN.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $gMJ1n.SDK_VERSION] = __SENTRY__[0, $gMJ1n.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("gMJ1n", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", function () { return $c3840d52e542ca75$export$31499a9cd224b78c; });
// This is a magic string replaced by rollup
const $c3840d52e542ca75$export$31499a9cd224b78c = "9.15.0";

});

parcelRegister("9ishN", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $6c4bbc7f8fbf39b2$export$f1a6cdb1459e81d1; });
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $6c4bbc7f8fbf39b2$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("d4s5r", function(module, exports) {
$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $98416f863ee47813$export$329d4d4d54e42710; });

var $3HTeF = parcelRequire("3HTeF");

var $fex0p = parcelRequire("fex0p");

var $86GZW = parcelRequire("86GZW");

var $5TFFW = parcelRequire("5TFFW");
/**
 * This is an object that holds a stack of scopes.
 */ class $98416f863ee47813$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $fex0p.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $fex0p.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $86GZW.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $98416f863ee47813$var$getAsyncContextStack() {
    const registry = (0, $5TFFW.getMainCarrier)();
    const sentry = (0, $5TFFW.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $98416f863ee47813$export$d36ec451f120cfba((0, $3HTeF.getDefaultCurrentScope)(), (0, $3HTeF.getDefaultIsolationScope)());
}
function $98416f863ee47813$var$withScope(callback) {
    return $98416f863ee47813$var$getAsyncContextStack().withScope(callback);
}
function $98416f863ee47813$var$withSetScope(scope, callback) {
    const stack = $98416f863ee47813$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $98416f863ee47813$var$withIsolationScope(callback) {
    return $98416f863ee47813$var$getAsyncContextStack().withScope(()=>{
        return callback($98416f863ee47813$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $98416f863ee47813$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $98416f863ee47813$var$withIsolationScope,
        withScope: $98416f863ee47813$var$withScope,
        withSetScope: $98416f863ee47813$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $98416f863ee47813$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$98416f863ee47813$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$98416f863ee47813$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("3HTeF", function(module, exports) {
$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $2b303be1dad3f283$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $2b303be1dad3f283$export$de9862929b76bf57; });

var $5TFFW = parcelRequire("5TFFW");

var $fex0p = parcelRequire("fex0p");
/** Get the default current scope. */ function $2b303be1dad3f283$export$6f1b9191db9c4d5() {
    return (0, $5TFFW.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $fex0p.Scope)());
}
/** Get the default isolation scope. */ function $2b303be1dad3f283$export$de9862929b76bf57() {
    return (0, $5TFFW.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $fex0p.Scope)());
}

});
parcelRegister("fex0p", function(module, exports) {
$parcel$export(module.exports, "Scope", function () { return $b171c40d15c6ba4d$export$775b6bb06e53a214; });

var $cEs1A = parcelRequire("cEs1A");

var $4xUZv = parcelRequire("4xUZv");

var $k1akT = parcelRequire("k1akT");

var $86GZW = parcelRequire("86GZW");

var $9sRth = parcelRequire("9sRth");

var $hqa9f = parcelRequire("hqa9f");

var $gTm65 = parcelRequire("gTm65");

var $gUnvu = parcelRequire("gUnvu");

var $2CVVa = parcelRequire("2CVVa");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $b171c40d15c6ba4d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $b171c40d15c6ba4d$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $gTm65.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $b171c40d15c6ba4d$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $k1akT._setSpanForScope)(newScope, (0, $k1akT._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $cEs1A.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $b171c40d15c6ba4d$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $86GZW.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $k1akT._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $gTm65.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $b171c40d15c6ba4d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $2CVVa.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $gUnvu.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $k1akT._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $4xUZv.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $hqa9f.uuid4)();
        if (!this._client) {
            (0, $9sRth.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $hqa9f.uuid4)();
        if (!this._client) {
            (0, $9sRth.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $hqa9f.uuid4)();
        if (!this._client) {
            (0, $9sRth.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("cEs1A", function(module, exports) {
$parcel$export(module.exports, "makeSession", function () { return $935ef58999d5c03d$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $935ef58999d5c03d$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $935ef58999d5c03d$export$56521d9ba90f62ee; });

var $hqa9f = parcelRequire("hqa9f");

var $2CVVa = parcelRequire("2CVVa");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $935ef58999d5c03d$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $2CVVa.timestampInSeconds)();
    const session = {
        sid: (0, $hqa9f.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$935ef58999d5c03d$var$sessionToJSON(session)
    };
    if (context) $935ef58999d5c03d$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $935ef58999d5c03d$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $2CVVa.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $hqa9f.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $935ef58999d5c03d$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $935ef58999d5c03d$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $935ef58999d5c03d$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("hqa9f", function(module, exports) {
$parcel$export(module.exports, "uuid4", function () { return $caecbc983dc03e8f$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $caecbc983dc03e8f$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $caecbc983dc03e8f$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $caecbc983dc03e8f$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $caecbc983dc03e8f$export$6de4ffac6a2f1098; });

var $3eJmu = parcelRequire("3eJmu");

var $gUnvu = parcelRequire("gUnvu");

var $9ishN = parcelRequire("9ishN");
function $caecbc983dc03e8f$var$getCrypto() {
    const gbl = (0, $9ishN.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $caecbc983dc03e8f$export$19f53698e68b2496(crypto = $caecbc983dc03e8f$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $caecbc983dc03e8f$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $caecbc983dc03e8f$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $caecbc983dc03e8f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $caecbc983dc03e8f$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $caecbc983dc03e8f$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $caecbc983dc03e8f$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $caecbc983dc03e8f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $caecbc983dc03e8f$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $caecbc983dc03e8f$export$d364f2020ab30578(input) {
    const match = input.match($caecbc983dc03e8f$var$SEMVER_REGEXP) || [];
    const major = $caecbc983dc03e8f$var$_parseInt(match[1]);
    const minor = $caecbc983dc03e8f$var$_parseInt(match[2]);
    const patch = $caecbc983dc03e8f$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $caecbc983dc03e8f$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $gUnvu.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $gUnvu.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $gUnvu.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $caecbc983dc03e8f$export$6de4ffac6a2f1098(exception) {
    if ($caecbc983dc03e8f$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $3eJmu.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $caecbc983dc03e8f$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});
parcelRegister("3eJmu", function(module, exports) {
$parcel$export(module.exports, "fill", function () { return $25b5ddce51505ed0$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $25b5ddce51505ed0$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $25b5ddce51505ed0$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $25b5ddce51505ed0$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $25b5ddce51505ed0$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $25b5ddce51505ed0$export$b0244d5063c0b61b; });

var $7skVW = parcelRequire("7skVW");

var $e6nMd = parcelRequire("e6nMd");

var $86GZW = parcelRequire("86GZW");

var $9sRth = parcelRequire("9sRth");

var $gUnvu = parcelRequire("gUnvu");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $25b5ddce51505ed0$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $25b5ddce51505ed0$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $e6nMd.DEBUG_BUILD) && (0, $9sRth.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $25b5ddce51505ed0$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $e6nMd.DEBUG_BUILD) && (0, $9sRth.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $25b5ddce51505ed0$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $25b5ddce51505ed0$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $25b5ddce51505ed0$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $25b5ddce51505ed0$export$62ff257738bf57f5(value) {
    if ((0, $86GZW.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$25b5ddce51505ed0$var$getOwnProperties(value)
    };
    else if ((0, $86GZW.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $25b5ddce51505ed0$var$serializeEventTarget(value.target),
            currentTarget: $25b5ddce51505ed0$var$serializeEventTarget(value.currentTarget),
            ...$25b5ddce51505ed0$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $86GZW.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $25b5ddce51505ed0$var$serializeEventTarget(target) {
    try {
        return (0, $86GZW.isElement)(target) ? (0, $7skVW.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $25b5ddce51505ed0$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $25b5ddce51505ed0$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($25b5ddce51505ed0$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $gUnvu.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $gUnvu.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $25b5ddce51505ed0$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $25b5ddce51505ed0$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $25b5ddce51505ed0$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($25b5ddce51505ed0$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($25b5ddce51505ed0$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $25b5ddce51505ed0$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $25b5ddce51505ed0$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $25b5ddce51505ed0$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $86GZW.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("7skVW", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", function () { return $56db62e1c0e22242$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $56db62e1c0e22242$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $56db62e1c0e22242$export$26727cfcc4d7e0fc; });

var $86GZW = parcelRequire("86GZW");

var $9ishN = parcelRequire("9ishN");
const $56db62e1c0e22242$var$WINDOW = (0, $9ishN.GLOBAL_OBJ);
const $56db62e1c0e22242$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $56db62e1c0e22242$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $56db62e1c0e22242$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $56db62e1c0e22242$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $56db62e1c0e22242$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($56db62e1c0e22242$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $86GZW.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $56db62e1c0e22242$export$1cfafeee2987818b() {
    try {
        return $56db62e1c0e22242$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $56db62e1c0e22242$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$56db62e1c0e22242$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("86GZW", function(module, exports) {
$parcel$export(module.exports, "isError", function () { return $5e703cc6424192c6$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $5e703cc6424192c6$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $5e703cc6424192c6$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $5e703cc6424192c6$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $5e703cc6424192c6$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $5e703cc6424192c6$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $5e703cc6424192c6$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $5e703cc6424192c6$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $5e703cc6424192c6$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $5e703cc6424192c6$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $5e703cc6424192c6$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $5e703cc6424192c6$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $5e703cc6424192c6$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $5e703cc6424192c6$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $5e703cc6424192c6$export$7916fad0ebc23f48; });
$parcel$export(module.exports, "isRequest", function () { return $5e703cc6424192c6$export$6d3d1f317d7cda57; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $5e703cc6424192c6$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$e6127cc7fe7395c3(wat) {
    switch($5e703cc6424192c6$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $5e703cc6424192c6$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$var$isBuiltin(wat, className) {
    return $5e703cc6424192c6$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$9f9636d330b71954(wat) {
    return $5e703cc6424192c6$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$ef9e2056653f0c8e(wat) {
    return $5e703cc6424192c6$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$12e869b2a583f783(wat) {
    return $5e703cc6424192c6$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$844ec244b1367d54(wat) {
    return $5e703cc6424192c6$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$c3825b437cbdea5c(wat) {
    return wat === null || $5e703cc6424192c6$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$53b83ca8eaab0383(wat) {
    return $5e703cc6424192c6$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $5e703cc6424192c6$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $5e703cc6424192c6$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$49841c62b9eff15(wat) {
    return $5e703cc6424192c6$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $5e703cc6424192c6$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$bc2894c7158efbac(wat) {
    return $5e703cc6424192c6$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $5e703cc6424192c6$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $5e703cc6424192c6$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $5e703cc6424192c6$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("e6nMd", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", function () { return $a44411c676a63879$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a44411c676a63879$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("9sRth", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $6e4034deac02bb31$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $6e4034deac02bb31$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $6e4034deac02bb31$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $6e4034deac02bb31$export$af88d00dbe7f521; });

var $5TFFW = parcelRequire("5TFFW");

var $e6nMd = parcelRequire("e6nMd");

var $9ishN = parcelRequire("9ishN");
/** Prefix for logging strings */ const $6e4034deac02bb31$var$PREFIX = 'Sentry Logger ';
const $6e4034deac02bb31$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $6e4034deac02bb31$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $6e4034deac02bb31$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $9ishN.GLOBAL_OBJ))) return callback();
    const console = (0, $9ishN.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($6e4034deac02bb31$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $6e4034deac02bb31$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $6e4034deac02bb31$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $e6nMd.DEBUG_BUILD) $6e4034deac02bb31$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $6e4034deac02bb31$export$cda52e2a8927a2ca(()=>{
                (0, $9ishN.GLOBAL_OBJ).console[name](`${$6e4034deac02bb31$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $6e4034deac02bb31$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $6e4034deac02bb31$export$af88d00dbe7f521 = (0, $5TFFW.getGlobalSingleton)('logger', $6e4034deac02bb31$var$makeLogger);

});

parcelRegister("gUnvu", function(module, exports) {
$parcel$export(module.exports, "truncate", function () { return $c4f41c4a9e1527cd$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $c4f41c4a9e1527cd$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $c4f41c4a9e1527cd$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $c4f41c4a9e1527cd$export$a7a5ec66062ea5d; });

var $86GZW = parcelRequire("86GZW");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $c4f41c4a9e1527cd$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $c4f41c4a9e1527cd$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $c4f41c4a9e1527cd$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $86GZW.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $c4f41c4a9e1527cd$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $86GZW.isString)(value)) return false;
    if ((0, $86GZW.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $86GZW.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $c4f41c4a9e1527cd$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$c4f41c4a9e1527cd$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("2CVVa", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $1e9c0f50de7ca259$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $1e9c0f50de7ca259$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $1e9c0f50de7ca259$export$baf075a948ffc0bf; });

var $9ishN = parcelRequire("9ishN");
const $1e9c0f50de7ca259$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $1e9c0f50de7ca259$export$7740643b9eeaf0c4() {
    return Date.now() / $1e9c0f50de7ca259$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $1e9c0f50de7ca259$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $9ishN.GLOBAL_OBJ);
    if (!performance?.now) return $1e9c0f50de7ca259$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $1e9c0f50de7ca259$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $1e9c0f50de7ca259$export$ee52dced521e3e18 = $1e9c0f50de7ca259$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $1e9c0f50de7ca259$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $1e9c0f50de7ca259$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $9ishN.GLOBAL_OBJ);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $1e9c0f50de7ca259$export$baf075a948ffc0bf() {
    if (!$1e9c0f50de7ca259$var$cachedTimeOrigin) $1e9c0f50de7ca259$var$cachedTimeOrigin = $1e9c0f50de7ca259$var$getBrowserTimeOrigin();
    return $1e9c0f50de7ca259$var$cachedTimeOrigin[0];
}

});


parcelRegister("4xUZv", function(module, exports) {
$parcel$export(module.exports, "merge", function () { return $34f673bf79042280$export$4950aa0f605343fb; });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $34f673bf79042280$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $34f673bf79042280$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("k1akT", function(module, exports) {
$parcel$export(module.exports, "_setSpanForScope", function () { return $e92beb2a86bb7227$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $e92beb2a86bb7227$export$91f063ebb8eff307; });

var $3eJmu = parcelRequire("3eJmu");
const $e92beb2a86bb7227$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $e92beb2a86bb7227$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $3eJmu.addNonEnumerableProperty)(scope, $e92beb2a86bb7227$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$e92beb2a86bb7227$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $e92beb2a86bb7227$export$91f063ebb8eff307(scope) {
    return scope[$e92beb2a86bb7227$var$SCOPE_SPAN_FIELD];
}

});

parcelRegister("gTm65", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", function () { return $c4c2ec6901c7071d$export$dc6d7ea554bcce10; });
$parcel$export(module.exports, "generateSpanId", function () { return $c4c2ec6901c7071d$export$295213bc4d0c54ad; });

var $hqa9f = parcelRequire("hqa9f");
/**
 * Generate a random, valid trace ID.
 */ function $c4c2ec6901c7071d$export$dc6d7ea554bcce10() {
    return (0, $hqa9f.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $c4c2ec6901c7071d$export$295213bc4d0c54ad() {
    return (0, $hqa9f.uuid4)().substring(16);
}

});








parcelRegister("ai3ZP", function(module, exports) {
$parcel$export(module.exports, "featureFlags", function () { return $4eef58e4d43b08f2$export$e62953d023125748; });
const $4eef58e4d43b08f2$export$e62953d023125748 = {
    wacSalesLeadsCtaGlobalNav: {
        featureFlagName: 'wac_sales_leads_cta_global_nav',
        metadata: {
            description: 'Flag to enable UI button to contact sales if user is determined to be an SMB inbound sales lead',
            expectedReleaseDate: '02/28/2025',
            expectedRuntime: '12 weeks',
            context: {
                urls: [
                    '/',
                    '/software/jira',
                    '/software/confluence'
                ]
            }
        }
    },
    salesWidgetBxpWebPlatform: {
        featureFlagName: 'sales_widget_bxp_web_platform',
        metadata: {
            description: 'Flag to enable sales widget on BXP web platform',
            expectedReleaseDate: '10/03/2026',
            expectedRuntime: 'Indefinite',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    salesWidgetBxpWebPlatformDeveloper: {
        featureFlagName: 'sales_widget_bxp_web_platform_dev',
        metadata: {
            description: 'Flag to enable sales widget on BXP web platform for developers',
            expectedReleaseDate: '10/03/2026',
            expectedRuntime: 'Indefinite',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    preloadAtlaskitStyles: {
        featureFlagName: 'token-style-wrapper-wac-web-gate',
        metadata: {
            description: 'Flag to enable optimized Atlas token head loading.',
            expectedReleaseDate: '08/30/2025',
            expectedRuntime: 'Can be cleaned up after monitored in PROD and ensure no issues',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    castleIoEvent: {
        featureFlagName: 'wac-castle-io-event',
        metadata: {
            description: 'Feature gate to control Castle.io custom event sending',
            expectedReleaseDate: '2026-06-30',
            expectedRuntime: '4 weeks',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    jsmPaidLpAuxiaIntegration: {
        featureFlagName: 'jsm-paid-lp-auxia-integration',
        metadata: {
            description: 'Feature gate to roll out Auxia integration for JSM Paid LP Anchor pages',
            expectedReleaseDate: '9/22/2025',
            expectedRuntime: '12 weeks',
            context: {
                urls: [
                    '/software/jira/service-management'
                ]
            }
        }
    },
    signupVisualAlignmentFeedback: {
        featureFlagName: 'signup-visual-alignment-feedback',
        metadata: {
            description: 'Design feedback to align appearance of signup components',
            expectedReleaseDate: '6/4/2026',
            expectedRuntime: '3 weeks',
            context: {
                urls: [
                    '/software/confluence',
                    '/software/jira',
                    '/software/jira/service-management',
                    '/try/cloud/signup',
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    sxpFastshiftPortalEnableRollUpStatus: {
        featureFlagName: 'sxp-fastshift-portal-enable-roll-up-status',
        metadata: {
            description: 'Feature gate to enable roll up status in FastShift Portal',
            expectedReleaseDate: '01/31/2026',
            expectedRuntime: '1 month',
            context: {
                urls: [
                    '/fastshift/**'
                ]
            }
        }
    },
    sxpFastshiftPortalUnder1kCustomerExperience: {
        featureFlagName: 'sxp-fastshift-portal-under-1k-experience',
        metadata: {
            description: 'Feature gate to enable a tailored experience for small customers with under 1k paid seats',
            expectedReleaseDate: '01/22/2026',
            expectedRuntime: '3 weeks',
            context: {
                urls: [
                    '/fastshift/**'
                ]
            }
        }
    },
    gwp1304AddIntercomToJpdProductTour: {
        featureFlagName: 'gwp-1304-add-intercom-to-jpd-product-tour',
        metadata: {
            description: 'Add Intercom to JPD Product Tour',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                urls: [
                    '/software/jira/product-discovery'
                ]
            }
        }
    },
    jiraOnboardingAiMadlibV2: {
        featureFlagName: 'jira-onboarding-ai-madlib-v2-gate',
        metadata: {
            description: 'Feature gate for AI Madlib V2 iteration in Jira onboarding',
            expectedReleaseDate: '2/27/2026',
            expectedRuntime: '30 days',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    provisioningFunnelUfoImprovements: {
        featureFlagName: 'provisioning-funnel-ufo-improvements',
        metadata: {
            description: 'Feature gate to enable provisioningFunnelUfoImprovements for UFO tracking in provisioning UI',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    cfindOutroAnimationBeforeRedirect: {
        featureFlagName: 'cfind_outro_animation_before_redirect',
        metadata: {
            description: 'Defers the redirect until the outro animation and final message play on the Confluence provisioning page',
            expectedReleaseDate: '07/15/2026',
            expectedRuntime: '30 days',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    wacWebExtendedCachingOfBfldrAssetsForJsw: {
        featureFlagName: 'wac-web-extended-caching-of-bfldr-assets-for-jsw',
        metadata: {
            description: 'WAC Web Extended Caching of Bfldr Assets for JSW',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    wacWebTrafficAAGate: {
        featureFlagName: 'wac-web-traffic-aa-gate',
        metadata: {
            description: 'WAC Web Traffic AA Gate',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    wacWebLoggedInTrafficAAGate: {
        featureFlagName: 'wac-web_a-a_gate_for_loggedin_users',
        metadata: {
            description: 'WAC Web LoggedIn Traffic AA Gate',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    gwp5158FocusProductAdd: {
        featureFlagName: 'gwp-5158-focus-product-add',
        metadata: {
            description: 'Adding Focus to global nav',
            expectedReleaseDate: 'April 9, 2025',
            expectedRuntime: 'Forever (gate to be used for Team launch, will be cleaned up)',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    gwp4947Team25HeroHomepageTakeover: {
        featureFlagName: 'gwp-4947-team-25-hero-homepage-takeover',
        metadata: {
            description: 'Team 25 hero takeover',
            expectedReleaseDate: 'February',
            expectedRuntime: 'Until April 8th',
            context: {
                urls: [
                    '/',
                    '/enterprise'
                ]
            }
        }
    },
    gwp5046TurboBannerEnterprise: {
        featureFlagName: 'gwp-5046-turbo-banner-enterprise',
        metadata: {
            description: 'Turbo racing banner',
            expectedReleaseDate: 'February',
            expectedRuntime: 'Until April 8th',
            context: {
                urls: [
                    '/enterprise'
                ]
            }
        }
    },
    gwp5381AddIntercomWidgetToUniform: {
        featureFlagName: 'gwp-5381-add-intercom-widget-to-uniform',
        metadata: {
            description: 'Add Intercom widget to Uniform Page component',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                urls: [
                    '/customers/*'
                ]
            }
        }
    },
    wacProductsLoomURL: {
        featureFlagName: 'wac-products-loom-url',
        metadata: {
            description: 'Change loom URL',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    edgeLambdaCacheProductDiscovery: {
        featureFlagName: 'edge-lambda-cache-product-discovery',
        metadata: {
            description: 'Flag to enable edge lambda caching for product discovery page',
            expectedReleaseDate: '03/18/2025',
            expectedRuntime: 'Indefinite',
            context: {
                urls: [
                    '/software/jira/product-discovery',
                    '/',
                    '/customers*',
                    '/software/confluence/templates*',
                    '/work-management*',
                    '/itsm*',
                    '/incident-management*',
                    '/agile*'
                ]
            }
        }
    },
    edgeCacheSourcetreapp: {
        featureFlagName: 'edge-cache-sourcetreapp',
        metadata: {
            description: 'Flag to enable edge caching for all sourcetreeapp.com domain paths',
            expectedReleaseDate: '05/05/2026',
            expectedRuntime: 'Indefinite',
            context: {
                urls: [
                    // eslint-disable-next-line local/warn-wildcard-usage-eslint
                    'sourcetreeapp.com/**'
                ]
            }
        }
    },
    wacWebUseEsModulesScripts: {
        featureFlagName: 'wac-web-use-esmodules-scripts',
        metadata: {
            description: 'Use Esmodules script',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    signupPopBackBtn: {
        featureFlagName: 'signup-pop-back-btn',
        metadata: {
            description: 'Show back button in post order signup site picker page',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                urls: [
                    '/buy/cloud/site-setup'
                ]
            }
        }
    },
    gwp5548Team25DuringEventBanner: {
        featureFlagName: 'gwp-5548-team-25-during-event-banner',
        metadata: {
            description: 'Team 25 During event banner',
            expectedReleaseDate: '4/9/2025',
            expectedRuntime: '1 day',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp5421CollectionsHero: {
        featureFlagName: 'gwp-5421-collections-hero',
        metadata: {
            description: 'Collections hero takeover on homepage',
            expectedReleaseDate: '4/9/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp8165EnterpriseContactServiceCollection: {
        featureFlagName: 'gwp-8165-enterprise-contact-service-collection',
        metadata: {
            description: 'Feature gate to enable Service Collection option in enterprise contact forms',
            expectedReleaseDate: '10/01/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwp9286ConfluenceAnchorUpdates: {
        featureFlagName: 'gwp-9286-confluence-anchor-updates',
        metadata: {
            description: 'Confluence Anchor Updates',
            expectedReleaseDate: '12/19/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/confluence'
                ]
            }
        }
    },
    gwp9287JSMAnchorUpdates: {
        featureFlagName: 'gwp-9287-jsm-anchor-updates',
        metadata: {
            description: 'JSM Anchor Updates',
            expectedReleaseDate: '12/15/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/jira/service-management'
                ]
            }
        }
    },
    gwp9473JSWAnchorUpdates: {
        featureFlagName: 'gwp-9473-jsw-anchor-updates',
        metadata: {
            description: 'Jira Anchor Updates',
            expectedReleaseDate: '12/19/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    voltronGupsDataInAnalyticsWrapper: {
        featureFlagName: 'voltron-gups-data-in-analytics-wrapper',
        metadata: {
            description: 'Add gups storage and retrieval of utm data in analytics wrapper',
            expectedReleaseDate: '4/11/2025',
            expectedRuntime: 'indefinite',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    gwp737EnableIntercomChatHome: {
        featureFlagName: 'gwp-737-enable-intercom-chat-home',
        metadata: {
            description: 'Triggers boot intercom on home page',
            expectedReleaseDate: '',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp737EnableIntercomChatJsw: {
        featureFlagName: 'gwp-737-enable-intercom-chat-jsw',
        metadata: {
            description: 'Triggers boot intercom on Jira Software pages',
            expectedReleaseDate: '',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    wacLiftedBannerSticky: {
        featureFlagName: 'wac-lifted-banner-sticky',
        metadata: {
            description: 'Lifted banner sticky',
            expectedReleaseDate: '',
            expectedRuntime: '',
            context: {
                urls: [
                    '/',
                    '/software/confluence',
                    '/jira',
                    '/software/jira/service-management',
                    '/software/jira'
                ]
            }
        }
    },
    gwp5682RemoveRovoFromPricingForm: {
        featureFlagName: 'gwp-5682-remove-rovo-from-pricing-form',
        metadata: {
            description: 'Remove rovo from pricing form',
            expectedReleaseDate: '4/9/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwp6474RemoveOpsgenieContactSalesForm: {
        featureFlagName: 'gwp-6474-remove-opsgenie-contact-sales-form',
        metadata: {
            description: 'Remove rovo from contact form',
            expectedReleaseDate: '06/04/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwp8238BannerAnnouncement: {
        featureFlagName: 'gwp-8238-banner-announcement',
        metadata: {
            description: 'GWP-8238 Banner announcement for homepage and Jira software page',
            expectedReleaseDate: '9/18/2025',
            expectedRuntime: '2 weeks',
            context: {
                urls: [
                    '/',
                    '/software/jira'
                ]
            }
        }
    },
    gwp6473JpdPremiumBanner: {
        featureFlagName: 'gwp-5810-nonprofit-pricing-changes',
        metadata: {
            description: 'JPD Premium Announcement',
            expectedReleaseDate: '6/03/2025',
            expectedRuntime: '2 weeks',
            context: {
                urls: [
                    '/software/jira/product-discovery',
                    '/software/jira/product-discovery/pricing'
                ]
            }
        }
    },
    wacUipButterBarJsmGate: {
        featureFlagName: 'wac-uip-butter-bar-jsm-gate',
        metadata: {
            description: 'Forrester banner',
            expectedReleaseDate: 'unknown',
            expectedRuntime: 'unknown',
            context: {
                urls: [
                    '/software/jira/service-management'
                ]
            }
        }
    },
    gwp6701ForresterBanner: {
        featureFlagName: 'gwp-6701-forrester-banner',
        metadata: {
            description: 'Forrester banner',
            expectedReleaseDate: '6/16/2025',
            expectedRuntime: 'Two weeks',
            context: {
                urls: [
                    '/software/jira/service-management'
                ]
            }
        }
    },
    gwp6524OpsgenieSignupEol: {
        featureFlagName: 'gwp-6524-opsgenie-signup-eol',
        metadata: {
            description: 'Opsgenie EOL',
            expectedReleaseDate: '6/04/2025',
            expectedRuntime: 'Operational Flag',
            context: {
                urls: [
                    '/try/cloud/signup?bundle=jira-service-desk'
                ]
            }
        }
    },
    confluencePricingPageWaeMigration: {
        featureFlagName: 'confluence_pricing_wae_migration_exp_rerun_gate_1',
        metadata: {
            description: 'migration of Confluence pricing page to WAE, rerun',
            expectedReleaseDate: '03/06/2026',
            expectedRuntime: '80 days',
            context: {
                urls: [
                    '/software/confluence/pricing'
                ]
            }
        }
    },
    gwp7856PricingPagesWaeMigrationM3: {
        featureFlagName: 'gwp-7856-pricing-pages-wae-migration-m3-1',
        metadata: {
            description: 'migration of pricing pages to WAE, milestone-3',
            expectedReleaseDate: 'ongoing',
            expectedRuntime: '',
            context: {
                urls: [
                    '/collections/teamwork/pricing',
                    '/collections/strategy/pricing',
                    '/software/guard/pricing',
                    '/software/compass/pricing',
                    '/software/loom/pricing'
                ]
            }
        }
    },
    routingTable: {
        featureFlagName: 'wac-routing-table-gate',
        metadata: {
            description: 'Uses wac-routing-table to identify Uniform-supported pages in WACs',
            expectedReleaseDate: '8/07/2025',
            expectedRuntime: '',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    wacCompositionCutover: {
        featureFlagName: 'wac_composition_cutover',
        metadata: {
            description: 'Switches composition fetches from wac-uniform-promotion CloudFront to wac-management-service',
            expectedReleaseDate: 'TBD',
            expectedRuntime: 'TBD',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    wacRegenerationCutover: {
        featureFlagName: 'wac_regeneration_cutover',
        metadata: {
            description: 'Switches regeneration SQS messages from wac-uniform-promotion to wac-management-service',
            expectedReleaseDate: 'TBD',
            expectedRuntime: 'TBD',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    wacRoutingTableCutover: {
        featureFlagName: 'wac_routing_table_cutover',
        metadata: {
            description: 'Switches routing table fetches from wac-routing-table CloudFront to wac-management-service',
            expectedReleaseDate: 'TBD',
            expectedRuntime: 'TBD',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    gwp7617JiraShortTermAiInfusionGate: {
        featureFlagName: 'gwp-7617-jira-short-term-ai-infusion-gate',
        metadata: {
            description: 'Short term updates to Jira page',
            expectedReleaseDate: '8/21/2025',
            expectedRuntime: '',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    gwp7999JiraFeatures: {
        featureFlagName: 'gwp-7999-jira-features',
        metadata: {
            description: 'Feature gate to conditionally hide tabs section on Jira features page',
            expectedReleaseDate: 'TBD',
            expectedRuntime: 'TBD',
            context: {
                urls: [
                    '/software/jira/features'
                ]
            }
        }
    },
    gwp8240ButterbarGuard: {
        featureFlagName: 'gwp-8240-butterbar-guard',
        metadata: {
            description: 'Guard workshop banner',
            expectedReleaseDate: '11/11/2025',
            expectedRuntime: '',
            context: {
                urls: [
                    '/software/guard/pricing'
                ]
            }
        }
    },
    enableBitbucketCcpProvisioningWac: {
        featureFlagName: 'enable_bitbucket_ccp_provisioning_wac',
        metadata: {
            description: 'Enable Bitbucket CCP provisioning in WAC',
            expectedReleaseDate: '9/08/2025',
            expectedRuntime: '5 weeks',
            context: {
                urls: [
                    '/try/cloud/signup'
                ]
            }
        }
    },
    bxpActivationCmtCcpIntegration: {
        featureFlagName: 'bxp-activation-cmt-ccp-integration',
        metadata: {
            description: 'Enable CMT signups through CCP by sending migrationId in /activate-product',
            expectedReleaseDate: '05/06/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/try/cloud/signup'
                ]
            }
        }
    },
    accountCreationTermsAndConditions: {
        featureFlagName: 'account-creation-terms-and-conditions',
        metadata: {
            description: 'show terms and conditions by default in AccountCreation',
            expectedReleaseDate: '2026-06-08',
            expectedRuntime: '',
            context: {
                urls: [
                    '/software/confluence',
                    '/software/jira',
                    '/software/jira/service-management',
                    '/try/cloud/signup'
                ]
            }
        }
    },
    bxpActivationBitbucketCmtCcpIntegration: {
        featureFlagName: 'bxp-activation-bitbucket-cmt-ccp-integration',
        metadata: {
            description: 'Force edition=premium for Bitbucket CMT signups so /activate-product receives the correct edition',
            expectedReleaseDate: '05/14/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/try/cloud/signup'
                ]
            }
        }
    },
    gwp7546ConfluencePricingCtaCtaUrlSource: {
        featureFlagName: 'gwp-7546-confluence-pricing-cta-ctaurlsource',
        metadata: {
            description: 'Change the Confluence pricing ctaUrlSource to productPlans',
            expectedReleaseDate: '8/22/2025',
            expectedRuntime: '',
            context: {
                urls: [
                    '/software/confluence/pricing'
                ]
            }
        }
    },
    gwp7518NavIconUpdates: {
        featureFlagName: 'gwp-7518-nav-icon-updates',
        metadata: {
            description: 'Update icons on global nav',
            expectedReleaseDate: '8/29/2025',
            expectedRuntime: '',
            context: {
                urls: [
                    '/*'
                ]
            }
        }
    },
    gwp7711Team25BannerPhase3: {
        featureFlagName: 'gwp-7711-team-25-banner-phase-3',
        metadata: {
            description: 'Team 25 banner phase 3',
            expectedReleaseDate: '9/1/2025',
            expectedRuntime: '1 month',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp7456JpdStateOfProductBanner: {
        featureFlagName: 'gwp-7456-jpd-state-of-product-banner',
        metadata: {
            description: 'Enable JPD State of Product Banner',
            expectedReleaseDate: '9/3/2025',
            expectedRuntime: '7 days',
            context: {
                urls: [
                    '/software/jira/product-discovery'
                ]
            }
        }
    },
    gwp8038JpdBannerWebinar: {
        featureFlagName: 'gwp-8038-jpd-banner-webinar',
        metadata: {
            description: 'Enable JPD webinar banner to replace State of Product banner',
            expectedReleaseDate: '9/11/2025',
            expectedRuntime: '2 weeks',
            context: {
                urls: [
                    '/software/jira/product-discovery'
                ]
            }
        }
    },
    EnableJPDXflowLofiSignup: {
        featureFlagName: 'gwp-7564-integrate-jpd-xflow-lofi-signup',
        metadata: {
            description: 'Enable JPD Xflow Lofi Signup',
            expectedReleaseDate: '8/28/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    enableRovoDevBetaSignup: {
        featureFlagName: 'rovo_dev_beta_signup_backup',
        metadata: {
            description: 'Enable Rovo Dev Beta Signup',
            expectedReleaseDate: '09/19/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp7603UniformPageDwellTime: {
        featureFlagName: 'gwp-7603-uniform-page-dwell-time',
        metadata: {
            description: 'Enable Uniform Page Dwell Time Tracking',
            expectedReleaseDate: '9/04/2025',
            expectedRuntime: '1 week',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    dxpMigrationJiraProductTourGate: {
        featureFlagName: 'dxp-migration-jira-product-tour-gate',
        metadata: {
            description: 'Enable Jira Product Tour Migration for Team 25 EU',
            expectedReleaseDate: '10/07/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/jira',
                    '/jira'
                ]
            }
        }
    },
    gwp8037ServiceCollectionPricingPage: {
        featureFlagName: 'gwp-8037-service-collection-pricing-page',
        metadata: {
            description: 'Feature gate for Service Collection Pricing page',
            expectedReleaseDate: '9/30/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/collections/service/pricing'
                ]
            }
        }
    },
    gwp8011RovoProductTour: {
        featureFlagName: 'gwp-8011-rovo-product-tour',
        metadata: {
            description: 'Feature gate for Rovo Product Tour',
            expectedReleaseDate: '10/3/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/rovo'
                ]
            }
        }
    },
    gwp8036RovoDevPricingPage: {
        featureFlagName: 'gwp-8036-rovo-dev-pricing-page',
        metadata: {
            description: 'Feature gate for Rovo Dev pricing page',
            expectedReleaseDate: '9/30/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/rovo-dev/pricing'
                ]
            }
        }
    },
    gwp7923NewJsmRouteDeIndex: {
        featureFlagName: 'gwp-7923-new-jsm-route-de-index',
        metadata: {
            description: 'Feature gate for new JSM route, and de-indexing old route',
            expectedReleaseDate: '9/30/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/jira/service-management/pricing',
                    '/software/jira/service-management/product-pricing'
                ]
            }
        }
    },
    dxpMigrationConfluenceProductTourGate: {
        featureFlagName: 'dxp-migration-confluence-product-tour-gate',
        metadata: {
            description: 'Enable Confluence Product Tour Migration for Team 25 EU',
            expectedReleaseDate: '10/07/2025',
            expectedRuntime: 'Forever (gate to be used for launch, will be cleaned up after)',
            context: {
                urls: [
                    'software/confluence'
                ]
            }
        }
    },
    gwpRovoProductTourStudioTab: {
        featureFlagName: 'gwp-rovo-product-tour-studio-tab',
        metadata: {
            description: 'Update copy and CTA for Rovo Product Tour Studio Tab on Oct 8',
            expectedReleaseDate: '10/08/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    'software/rovo'
                ]
            }
        }
    },
    gwp7823AnimationOverlayOption: {
        featureFlagName: 'gwp-7823-animation-overlay-option',
        metadata: {
            description: 'Feature gate for animation overlay option',
            expectedReleaseDate: '10/03/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/rovo'
                ]
            }
        }
    },
    gwp8279CollectionHeroIntl: {
        featureFlagName: 'gwp-8279-collection-hero-intl',
        metadata: {
            description: 'Enables hardcoded translation strings in the collection-pricing-hero component',
            expectedReleaseDate: '10/06/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/collection/service/pricing',
                    '/collection/teamwork/pricing',
                    '/collection/strategy/pricing'
                ]
            }
        }
    },
    wacSearchIndexV3_2: {
        featureFlagName: 'wac_search_index_v3-2',
        metadata: {
            description: 'Feature gate for search index v3-2',
            expectedReleaseDate: '10/23/2025',
            expectedRuntime: 'indefinite',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    gwp8510AustinGrandPrixBanner: {
        featureFlagName: 'gwp-5810-austin-grand-prix',
        metadata: {
            description: 'Austin Grand Prix banner on homepage',
            expectedReleaseDate: '10/14/2025',
            expectedRuntime: '2 weeks',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp8577ServiceCollectionBanners: {
        featureFlagName: 'gwp-8577-service-collection-banners',
        metadata: {
            description: 'Feature gate for service collection banners',
            expectedReleaseDate: '11/03/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/jira/service-management'
                ]
            }
        }
    },
    gwp9038JdpAIWebinarBanner: {
        featureFlagName: 'gwp-9038-jdp-ai-webinar-banner',
        metadata: {
            description: 'Feature gate for GWP-9038',
            expectedReleaseDate: '11/17/2025',
            expectedRuntime: '2 weeks',
            context: {
                urls: [
                    '/software/jira/product-discovery'
                ]
            }
        }
    },
    gwp9000NewRovoVideoHero: {
        featureFlagName: 'gwp-9000-new-rovo-video-hero',
        metadata: {
            description: 'showing rovo video',
            expectedReleaseDate: '2025-11-19',
            expectedRuntime: '1 month',
            context: {
                urls: [
                    '/software/rovo'
                ]
            }
        }
    },
    gwp9226Team26Banner: {
        featureFlagName: 'gwp-9226-team-26-banner',
        metadata: {
            description: 'Team 26 Banners on WAC Homepage',
            expectedReleaseDate: '2026-01-05',
            expectedRuntime: '1 month',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp9034WacPricingCcpStaging: {
        featureFlagName: 'gwp-9034-wac-pricing-ccp-staging',
        metadata: {
            description: 'When enabled, WAC fetches its pricing data from the ccp_staging space in Contentful > Product Catalog',
            expectedReleaseDate: '11/20/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/*/pricing',
                    '/collections/*/pricing'
                ]
            }
        }
    },
    gwp9214HomepageScreenshots: {
        featureFlagName: 'gwp-9214-homepage-screenshots',
        metadata: {
            description: 'Updated screenshots for homepage scroll pinned sections',
            expectedReleaseDate: '12/03/2025',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    enableCsmAjLogo: {
        featureFlagName: 'enable-csm-aj-logo',
        metadata: {
            description: 'Enable Customer Service Management logo on CSM variant in JSM Anchor Journey',
            expectedReleaseDate: '12/08/2025',
            expectedRuntime: 'indefinite',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    jiraPricingWaeMigrationExperimentRerunGate: {
        featureFlagName: 'jira_pricing_wae_migration_exper_rerun_exp_1_gate',
        metadata: {
            description: 'Rerun of migration of Jira pricing page to WAE',
            expectedReleaseDate: '03/06/2026',
            expectedRuntime: '43 days',
            context: {
                urls: [
                    '/software/jira/pricing'
                ]
            }
        }
    },
    waePricingDisableComparePlansEnhancer: {
        featureFlagName: 'wae-pricing-disable-compare-plans-enhancer',
        metadata: {
            description: 'Toggle ON to DISABLE server-side fetching of product catalog data for WAE pricing pages',
            expectedReleaseDate: '03/25/2026',
            expectedRuntime: 'indefinte',
            context: {
                urls: [
                    '/software/*/pricing'
                ]
            }
        }
    },
    waePricingStripExcessData: {
        featureFlagName: 'wae-pricing-strip-excess-data',
        metadata: {
            description: 'Enable this for WAE enhancers to strip excess data from pricing page SSR payloads',
            expectedReleaseDate: '04/05/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/*/pricing'
                ]
            }
        }
    },
    waePricingGql: {
        featureFlagName: 'gwp-11369-wae-pricing-gql',
        metadata: {
            description: 'Enables GQL fetching on WAE pricing',
            expectedReleaseDate: '05/08/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/software/*/pricing',
                    '/collections/*/pricing'
                ]
            }
        }
    },
    wacIcLogin: {
        featureFlagName: 'wac-ic-login',
        metadata: {
            description: "Feature gate to add application query parameter 'wac--ic' to enable IC logins",
            expectedReleaseDate: '01/12/2026',
            expectedRuntime: '04/01/2026',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    includeEntitlementIdCheckInCohortsGate: {
        featureFlagName: 'astro_786_entitlement_id_check_in_cohort',
        metadata: {
            description: 'Gate to introduce the check for entitlemnt Id and billing source system',
            expectedReleaseDate: '01/08/2026',
            expectedRuntime: '14 days',
            context: {
                urls: [
                    '/try/cloud/signup'
                ]
            }
        }
    },
    gwp9763BackupRestoreContactForm: {
        featureFlagName: 'gwp-9763-backup-restore-contact-form',
        metadata: {
            description: 'Feature gate to enable Backup and Restore product option',
            expectedReleaseDate: '01/22/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwp9608AdditionalSandboxContactForm: {
        featureFlagName: 'gwp-9608-enterprise-contact-additional-sandbox',
        metadata: {
            description: 'Feature gate to enable Additional Sandbox product options in enterprise contact forms',
            expectedReleaseDate: '01/25/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwp11663AtlassianIsolatedCloudContactForm: {
        featureFlagName: 'gwp-11663-atlassian-isolated-cloud-contact-form',
        metadata: {
            description: 'Feature gate to enable Atlassian Isolated Cloud in enterprise contact forms',
            expectedReleaseDate: '06/01/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwp9365TeamOnTourSydneyBanner: {
        featureFlagName: 'gwp-9365-team-on-tour-sydney-homepage-banner-au-nz',
        metadata: {
            description: 'Team on Tour Sydney Banner on WAC Homepage',
            expectedReleaseDate: '2026-02-04',
            expectedRuntime: '33 days',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp9191Team26HeroHomepageTakeover: {
        featureFlagName: 'gwp-9191-team-26-hero-homepage-takeover',
        metadata: {
            description: 'Team 26 hero takeover',
            expectedReleaseDate: '02/02/2026',
            expectedRuntime: '04/18/2026',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp10221RovoProductTourFixScrollAnimation: {
        featureFlagName: 'gwp-10221-rovo-product-tour-fix-scroll-animation',
        metadata: {
            description: 'Updated headline, reordered rovo section on homepage - converted from experiment to feature gate',
            expectedReleaseDate: '02/17/2025',
            expectedRuntime: '3 days',
            context: {
                urls: [
                    '/software/rovo'
                ]
            }
        }
    },
    rovoDevSignupFlowsCommerceDisclaimer: {
        featureFlagName: 'rovo-dev-signup-flows-commerce-disclaimer',
        metadata: {
            description: 'Update to the Rovo Dev sign-up flow legal text',
            expectedReleaseDate: '01/27/2026',
            expectedRuntime: '14 days',
            context: {
                urls: [
                    '/try/cloud/signup?bundle=devai'
                ]
            }
        }
    },
    gwp10027NonprofitPricingPage: {
        featureFlagName: 'gwp-10027-nonprofit-pricing-page',
        metadata: {
            description: 'Nonprofit pricing page changes FY26Q3',
            expectedReleaseDate: '02/25/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/teams/nonprofits/discount-pricing'
                ]
            }
        }
    },
    gwp10416DisableNonOperationalAnalyticsGateUip: {
        featureFlagName: 'gwp-10416-disable-non-operational-analytics-uip',
        metadata: {
            description: 'Feature gate to only enable operational analytics events in atl-analytics wrapper when users are opted out of performance cookies',
            expectedReleaseDate: '03/02/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp11138ServcoPricingIncreaseMaxUsers: {
        featureFlagName: 'gwp-11138-servco-pricing-increase-max-users',
        metadata: {
            description: 'Increase ServCo pricing max user limit from 20,000 to 100,000',
            expectedReleaseDate: '3/24/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/collections/service/pricing'
                ]
            }
        }
    },
    gwp11118UsageBasedPricingCalculator: {
        featureFlagName: 'gwp-11118-usage-based-pricing-calculator',
        metadata: {
            description: 'Feature gate to enable the Usage-Based Pricing Calculator',
            expectedReleaseDate: '05/05/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/resources/usage/calculator'
                ]
            }
        }
    },
    voltronMultiTouchAnalytics: {
        featureFlagName: 'voltron-multi-touch-analytics-gate',
        metadata: {
            description: 'Feature gate to enable voltron multi-touch tracking',
            expectedReleaseDate: '04/15/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    wacRefreshTeam26Gate: {
        featureFlagName: 'wac_refresh_q4fy26_gate',
        metadata: {
            description: 'Feature Gate to enable WAC Refresh',
            expectedReleaseDate: '05/05/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/',
                    '/software/jira',
                    '/software/confluence',
                    '/software/rovo',
                    '/collections/teamwork'
                ]
            }
        }
    },
    passLocaleInSignupContext: {
        featureFlagName: 'pass_locale_in_signup_context',
        metadata: {
            description: 'Feature gate to pass the WAC page locale into the signupContext field of signup API requests',
            expectedReleaseDate: '04/22/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/try/cloud/signup'
                ]
            }
        }
    },
    gwp10907JpdEnterpriseSku: {
        featureFlagName: 'gwp-10907-jpd-enterprise-sku',
        metadata: {
            description: 'Feature gate to roll out the new JPD Enterprise SKU column on the Jira Product Discovery pricing page',
            expectedReleaseDate: '05/06/2026',
            expectedRuntime: '12 weeks',
            context: {
                urls: [
                    '/software/jira/product-discovery/pricing'
                ]
            }
        }
    },
    gwpGlobalNavHoverVClick: {
        featureFlagName: 'gwp-global-nav-hover-v-click',
        metadata: {
            description: 'Toggle nav expand interaction model (click vs hover)',
            expectedReleaseDate: '05/06/2026',
            expectedRuntime: 'indefinite',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    team26Keynote: {
        featureFlagName: 'wac_team26_keynote',
        metadata: {
            description: 'Feature Gate to enable Team 26 changes timed with Keynote',
            expectedReleaseDate: '05/06/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/',
                    '/software/confluence',
                    '/software/rovo',
                    '/enterprise/contact'
                ]
            }
        }
    },
    wacTeam26PromoteOnDemandBanner: {
        featureFlagName: 'wac_team_26_promote_on_demand_banner',
        metadata: {
            description: 'Post-Team On-Demand Banner',
            expectedReleaseDate: '2026-05-11',
            expectedRuntime: '',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp1072SunsetCompass: {
        featureFlagName: 'gwp-10723-compass-gate',
        metadata: {
            description: 'Feature gate to sunset Compass',
            expectedReleaseDate: '05/13/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    gwp9582ProductCollection: {
        featureFlagName: 'gwp-9582-product-collection',
        metadata: {
            description: 'Show product collections',
            expectedReleaseDate: '05/13/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    cmkRedirectExistingEntitlement: {
        featureFlagName: 'cmk_redirect_existing_entitlement',
        metadata: {
            description: 'Redirect users with existing CMK entitlement to CMK support page during post-order provisioning',
            expectedReleaseDate: '2026-06-15',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/buy/cloud/post-order-provisioning',
                    '/buy/cloud/org-setup'
                ]
            }
        }
    },
    jiraWacActivationChecklistGate: {
        featureFlagName: 'wac-jira-activation-checklist-gate',
        metadata: {
            description: "Ops kill switch + ring-0 rollout lever in front of the WAC product activation checklist placement on /software/jira. Mounted directly below the user's most-recently-accessed Jira site card.",
            expectedReleaseDate: '2026-06-01',
            expectedRuntime: 'indefinite (kill switch)',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    jiraWacActivationChecklistAaGate: {
        featureFlagName: 'wac-jira-activation-checklist-aa-gate',
        metadata: {
            description: 'Rollout lever for the WAC Jira activation checklist AA exposure validation on /software/jira. Does not render the checklist UI.',
            expectedReleaseDate: '2026-06-01',
            expectedRuntime: '2 weeks',
            context: {
                urls: [
                    '/software/jira'
                ]
            }
        }
    },
    wacUnifiedTemplatesNavigation: {
        featureFlagName: 'wac-unified-templates-navigation',
        metadata: {
            description: 'Navigation to /templates',
            expectedReleaseDate: '2026-06-29',
            expectedRuntime: '2 weeks',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    wacDwellTimeTracking: {
        featureFlagName: 'wac_dwell-time_tracking',
        metadata: {
            description: 'Master switch for the dwell-time tracking system (DwellTimeContextProvider). When off, no tracker mounts and no analytics fire regardless of consumer opt-in.',
            expectedReleaseDate: '2026-06-26',
            expectedRuntime: 'indefinite',
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    '*'
                ]
            }
        }
    },
    team26EuAnnouncementBanner: {
        featureFlagName: 'team26-eu-announcement-banner',
        metadata: {
            description: 'Feature gate for banner announcing TEAM 26 EU event',
            expectedReleaseDate: '2026-06-16',
            expectedRuntime: '6 weeks',
            context: {
                urls: [
                    '/'
                ]
            }
        }
    },
    jiraFY27H1HoldoutExclusion: {
        featureFlagName: 'spice-jira-fy27h1-holdout-exclusion',
        metadata: {
            description: 'Feature gate to control firing the jiraFY27H1HoldoutExclusion event that populates the TAP trait for Jira FY27H1 agentic-template holdout exclusion.',
            expectedReleaseDate: '2026-07-31',
            expectedRuntime: 'Indefinite',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    },
    wacAiSdlcTemplateId: {
        featureFlagName: 'wac-ai-sdlc-template-id',
        metadata: {
            description: 'Feature gate for the template id of the AI SDLC campaign on the Jira dev page.',
            expectedReleaseDate: '2026-07-17',
            expectedRuntime: 'temporary',
            context: {
                urls: [
                    '/software/jira/dev'
                ]
            }
        }
    },
    gwp12021AddDX: {
        featureFlagName: 'gwp-12021-dx-enterprise-form-gate',
        metadata: {
            description: 'Feature gate to rollout the addition of DX to the enterprise contact form',
            expectedReleaseDate: '08/17/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwpEnterpriseRolloutGateTwc: {
        featureFlagName: 'gwp-enterprise-rollout-gate-twc',
        metadata: {
            description: 'Feature gate for enterprise rollout of Team Workflow Collaboration (TWC)',
            expectedReleaseDate: 'Indefinite',
            expectedRuntime: 'Indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwpEnterpriseRolloutGateStrategyCollection: {
        featureFlagName: 'gwp-enterprise-rollout-gate-strategy-collection',
        metadata: {
            description: 'Feature gate for enterprise rollout of strategy collection',
            expectedReleaseDate: 'Indefinite',
            expectedRuntime: 'Indefinite',
            context: {
                urls: [
                    '/enterprise/contact'
                ]
            }
        }
    },
    gwp12437MatchPricingPlansByOfferingKey: {
        featureFlagName: 'gwp-12437-match-pricing-plans-by-offering-key',
        metadata: {
            description: 'Match CCP pricing plans to their offering by offeringKey instead of offeringName, so name collisions across products no longer pull in the wrong plans',
            expectedReleaseDate: '07/14/2026',
            expectedRuntime: 'indefinite',
            context: {
                urls: [
                    '/resources/usage/calculator',
                    '/software/jira/pricing',
                    '/software/confluence/pricing'
                ]
            }
        }
    },
    spiceEnableCardCoverOnBoardCreate: {
        featureFlagName: 'spice-enable-card-cover-on-board-create',
        metadata: {
            description: 'Enable the card cover board setting on onboarding project creation. Mirrors the server-side gate of the same name so the client only sends enableCardCover when the backend will honour it.',
            expectedReleaseDate: '07/16/2026',
            expectedRuntime: '2 weeks',
            context: {
                urls: [
                    '/ondemand/signup/confirmation'
                ]
            }
        }
    }
};

});

parcelRegister("cuuGB", function(module, exports) {
$parcel$export(module.exports, "polyfillGetRandomValuesIfNecessary", function () { return $debcb5a7e0ec92aa$export$5c073f9c8bff1ad3; });
/**
 * We need this polyfill in order to generate uuids.
 *
 * The uuid package depends on crypto.getRandomValues
 * https://github.com/uuidjs/uuid#getrandomvalues-not-supported
 *
 * ...but the crypto-browserify package that we're using does not include this method:
 * https://github.com/browserify/crypto-browserify
 */ const $debcb5a7e0ec92aa$export$5c073f9c8bff1ad3 = ()=>{
    /**
   * TODO: I tried calling this immediately without the wrapper function, but it was causing
   * 'crypto is not defined' errors when the module is loaded. For some reason, the
   * crypto polyfill seems to be loaded _after_ this module so we have to do this lazily.
   */ if (typeof crypto.getRandomValues === 'undefined') Object.defineProperty(crypto, 'getRandomValues', {
        // @ts-ignore
        value: (arr)=>crypto.randomBytes(arr.length)
    });
};

});

parcelRegister("fLpER", function(module, exports) {
$parcel$export(module.exports, "GASv3", function () { return $e7a97474ba273a1b$export$d3e9576dd68d5e11; });

var $btgvr = parcelRequire("btgvr");

var $fzOo8 = parcelRequire("fzOo8");

var $gx3aw = parcelRequire("gx3aw");

var $cYY9z = parcelRequire("cYY9z");

var $7NStU = parcelRequire("7NStU");

var $i0bD5 = parcelRequire("i0bD5");

var $ieoZa = parcelRequire("ieoZa");

var $92PV0 = parcelRequire("92PV0");

var $h9TyE = parcelRequire("h9TyE");
const $e7a97474ba273a1b$var$attributeWhiteList = [
    'atlCohort',
    'featureFlags'
];
const $e7a97474ba273a1b$var$ATL_USER_HASH = 'atlUserHash';
class $e7a97474ba273a1b$export$d3e9576dd68d5e11 {
    /**
   * Sends a UI event to GASv3
   * @function sendUIEvent
   * @param {string} name
   * @param {object} data
   * @param {object} skipEnrichment - whether to add additional data
   */ static sendUIEvent(name, data, skipEnrichment) {
        if (!skipEnrichment) data = $e7a97474ba273a1b$export$d3e9576dd68d5e11.enrichEventData(data);
        data['trackEventName'] = name;
        data.href = data.href ? (0, $i0bD5.Helpers).maskURL(data.href) : undefined;
        data.signupUrl = data.signupUrl ? (0, $i0bD5.Helpers).maskURL(data.signupUrl) : undefined;
        const source = $e7a97474ba273a1b$export$d3e9576dd68d5e11.setSource(data);
        const uiEvent = {
            // this will likely change
            action: data['event'] || 'clicked',
            actionSubject: data['eventComponent'] || 'component',
            actionSubjectId: data['actionSubjectId'] || undefined,
            source: source,
            attributes: data
        };
        this._createAndFireEvent('ui', uiEvent);
    }
    /**
   * Sends a page view operational event to GASv3
   * @param data - The data to send to GASv3
   * @param skipEnrichment - Whether to skip enrichment
   */ static sendOperationalEvent(data, skipEnrichment) {
        if (!skipEnrichment) data = $e7a97474ba273a1b$export$d3e9576dd68d5e11.enrichEventData(data);
        data.href = data.href ? (0, $i0bD5.Helpers).maskURL(data.href) : undefined;
        data.signupUrl = data.signupUrl ? (0, $i0bD5.Helpers).maskURL(data.signupUrl) : undefined;
        const source = $e7a97474ba273a1b$export$d3e9576dd68d5e11.setSource(data);
        if ((0, $cYY9z.AnalyticsState).analyticsOptOut) {
            const fieldsToRemove = [
                'atlCohort',
                'name',
                'atlXid',
                'marketoId'
            ];
            const dataRecord = data;
            fieldsToRemove.forEach(function(key) {
                delete dataRecord[key];
            });
        }
        const operationalEvent = {
            // this will likely change
            action: data['event'] || '',
            actionSubject: data['eventComponent'] || '',
            actionSubjectId: data['actionSubjectId'] || undefined,
            source: source,
            attributes: data,
            ...(0, $cYY9z.AnalyticsState).analyticsOptOut ? {
                excludedProperties: {
                    anonymousId: true,
                    authenticatedUserId: true,
                    userId: true,
                    xid: true
                }
            } : {}
        };
        this._createAndFireEvent('operational', operationalEvent);
    }
    static _createAndFireEvent(eventType, payload) {
        if (!(0, $cYY9z.AnalyticsState).createAnalyticsEvent) return;
        // When user has opted out, only allow operational events (e.g. errors, diagnostics)
        if ((0, $cYY9z.AnalyticsState).analyticsOptOut && eventType !== 'operational') return;
        const payloadToSend = {
            ...payload,
            eventType: eventType
        };
        (0, $fzOo8.default)('atl-global')(payloadToSend)((0, $cYY9z.AnalyticsState).createAnalyticsEvent);
    }
    /**
   * Sends a Screen event to GASv3
   * @function sendScreenEvent
   * @param {string} name
   * @param {object} data - GASv3 screen event attributes
   *                 data.screenNameOverride - special data attribute that overrides the screen name for the event, instead of the default 'page'.
   *                                           If used, this attribute will be stripped from the data before sending to GASv3.
   * @param {object} skipEnrichment - whether to add additional data
   */ static sendScreenEvent(name, data, skipEnrichment) {
        if (!skipEnrichment) data = $e7a97474ba273a1b$export$d3e9576dd68d5e11.enrichEventData(data);
        data.href = data.href ? (0, $i0bD5.Helpers).maskURL(data.href) : undefined;
        data.signupUrl = data.signupUrl ? (0, $i0bD5.Helpers).maskURL(data.signupUrl) : undefined;
        data['name'] = name;
        const screenName = typeof data !== 'undefined' && data['screenNameOverride'] || 'page';
        if (typeof data === 'object') delete data['screenNameOverride'];
        this._createAndFireEvent('screen', {
            name: screenName,
            attributes: data
        });
        $e7a97474ba273a1b$export$d3e9576dd68d5e11.sendIdentityEvent();
    }
    /**
   *
   * @function sendIdentityEvent
   */ static sendIdentityEvent() {
        // load the identity hash cookie
        const atlUserHash = (0, $gx3aw.Cookie).readCookie($e7a97474ba273a1b$var$ATL_USER_HASH);
        // get the user identifiers
        const identifiers = $e7a97474ba273a1b$export$d3e9576dd68d5e11.getUserIdentifiers();
        // calculate the data hash of the known identifiers
        const calculatedHash = (0, $7NStU.Guid).guidHashCode(JSON.stringify(identifiers)).toString();
        if (!atlUserHash || atlUserHash !== calculatedHash) {
            // save new hash and send UI event
            (0, $gx3aw.Cookie).writeCookie($e7a97474ba273a1b$var$ATL_USER_HASH, calculatedHash, 3650, true);
            const data = {
                event: 'identified',
                eventComponent: 'user',
                identifiers: identifiers,
                writeKey: (0, $cYY9z.AnalyticsState).writeKey
            };
            $e7a97474ba273a1b$export$d3e9576dd68d5e11.sendUIEvent('', data, true);
        }
    }
    static getUserIdentifiers() {
        return {
            anonymousId: (0, $cYY9z.AnalyticsState).anonymousId,
            atlassianAccountId: (0, $ieoZa.Identity).getAtlassianUserId(),
            crossDomainId: (0, $92PV0.Tracking).xid,
            optimizelyEndUserId: null,
            trelloUserId: (0, $ieoZa.Identity).getTrelloUserId()
        };
    }
    static setSource(data) {
        let set = false;
        let source = '';
        if (data['eventContainer']) {
            source += data['eventContainer'].split(' ')[0];
            set = true;
        }
        if (data['eventColumn']) {
            source += data['eventColumn'].split(' ')[0];
            set = true;
        }
        if (!set) source = 'none';
        return source;
    }
    // fix for hot-99118
    static getReferrerURL(ref) {
        if ((0, $ieoZa.Identity).isReferrerTrello()) {
            const referrer = new URL(ref);
            return referrer.hostname + (0, $h9TyE.TrelloUrlScrubber).scrubUrl(referrer.pathname, '');
        }
        return ref;
    }
    /**
   * This function is to specifically add data needed in Socrates but not provided by default in GASv3 like it is for Segment
   * @function enrichEventData
   * @param {object} inputData  // a dictionary of data to enrich
   */ // eslint-disable-next-line complexity
    static enrichEventData(inputData) {
        let data = {};
        if (typeof inputData !== 'object' || inputData === null) {
            const dataValue = inputData;
            if (typeof dataValue !== 'undefined') data.data = dataValue;
        } else data = inputData;
        const newData = JSON.parse(JSON.stringify(data));
        newData.writeKey = (0, $cYY9z.AnalyticsState).writeKey;
        newData.isMarketingEvent = $e7a97474ba273a1b$export$d3e9576dd68d5e11.isMarketingEvent;
        let page;
        let ref;
        let page_canonical_url;
        try {
            // convert all passed in values to string if they are currently objects
            Object.keys(newData).forEach((inputKey)=>{
                const key = inputKey;
                if (newData[key] && typeof newData[key] === 'object' && !Array.isArray(newData[key]) && !$e7a97474ba273a1b$var$attributeWhiteList.includes(key)) // @ts-ignore
                newData[key] = JSON.stringify(newData[key]);
            });
            const href = $e7a97474ba273a1b$export$d3e9576dd68d5e11.getLocation();
            page = href ? new URL((0, $i0bD5.Helpers).maskURL(href)) : null;
            const referredByJiraDotCom = page?.searchParams.get('referer') === 'jira.com';
            ref = referredByJiraDotCom ? new URL('https://www.jira.com') : document.referrer ? new URL((0, $i0bD5.Helpers).maskURL(document.referrer)) : null;
            page_canonical_url = (0, $i0bD5.Helpers).maskURL((0, $i0bD5.Helpers).getCanonicalUrl());
            newData.page_title = newData.page_title || document.title || '';
            newData.page_domain = page ? page.hostname || '' : '';
            newData.page_subdomain = page ? page.hostname || '' : '';
            // referrer attributes
            newData.page_referrer_domain = ref ? ref.hostname || '' : '';
            newData.page_referrer_subdomain = ref ? ref.hostname || '' : '';
            if ((0, $ieoZa.Identity).isReferrerTrello()) {
                // fix for hot-99118
                newData.page_canonical_url = page ? (0, $h9TyE.TrelloUrlScrubber).scrubUrl(page.href, page.origin) || '' : '';
                newData.page_url = page ? (0, $h9TyE.TrelloUrlScrubber).scrubUrl(page.href, page.origin) || '' : '';
                newData.page_path = page ? (0, $h9TyE.TrelloUrlScrubber).scrubUrl(page.pathname, new URL(page.href).pathname) || '' : '';
                newData.page_url_parameters = page ? (0, $h9TyE.TrelloUrlScrubber).scrubUrl(page.search, '') : '';
                newData.page_url_params_json = page ? JSON.stringify($btgvr.parse((0, $h9TyE.TrelloUrlScrubber).scrubUrl(page.search, new URL(page.origin).pathname))) : '';
                newData.page_referrer_url_params_json = ref ? JSON.stringify($btgvr.parse((0, $h9TyE.TrelloUrlScrubber).scrubUrl(ref.search, new URL(ref.origin).pathname))) : '';
                newData.page_referrer_path = ref ? (0, $h9TyE.TrelloUrlScrubber).scrubUrl(ref.pathname, new URL(ref.origin).pathname) || '' : '';
                newData.page_referrer_url = ref ? ref.origin + (0, $h9TyE.TrelloUrlScrubber).scrubUrl(ref.pathname, new URL(ref.origin).pathname) || '' : '';
            } else {
                newData.page_canonical_url = page_canonical_url;
                newData.page_url = page ? page.href || '' : '';
                newData.page_path = page ? page.pathname || '' : '';
                newData.page_url_parameters = page ? page.search || '' : '';
                newData.page_url_params_json = page ? JSON.stringify($btgvr.parse(page.search)) : '';
                newData.page_referrer_url_params_json = ref ? JSON.stringify($btgvr.parse(ref.search)) : '';
                newData.page_referrer_path = ref ? ref.pathname || '' : '';
                newData.page_referrer_url = ref ? ref.href || '' : '';
            }
            newData.cookiesEnabled = window.navigator ? window.navigator.cookieEnabled : 'unknown';
            newData.activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups : '';
        } catch (e) {
            // fix for hot-99118
            const additionalData = {
                error: e instanceof Error ? e.message : JSON.stringify(e),
                href: location ? location.href : 'no location',
                referrer: document ? document.referrer ? $e7a97474ba273a1b$export$d3e9576dd68d5e11.getReferrerURL(document.referrer) : 'no referrer' : 'no document'
            };
            (0, $i0bD5.Helpers).sendWrapperLoadError('GASv3 enrichEventData error', JSON.stringify(additionalData));
        }
        return newData;
    }
    static getLocation() {
        return location.href;
    }
}

});
parcelRegister("fzOo8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b57135f44816e345$export$2e2bcd8739ae039; });
var $b57135f44816e345$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("ieoZa", function(module, exports) {
$parcel$export(module.exports, "Identity", function () { return $246fe80bbac8bca0$export$544bf02140fa9a77; });

var $gx3aw = parcelRequire("gx3aw");

var $cYY9z = parcelRequire("cYY9z");

var $fKfE1 = parcelRequire("fKfE1");

var $i0bD5 = parcelRequire("i0bD5");

var $92PV0 = parcelRequire("92PV0");
const $246fe80bbac8bca0$var$TRELLO_USER_ID = 'token';
const $246fe80bbac8bca0$var$XID = 'seg_xid';
const $246fe80bbac8bca0$var$pageViewProperties = {};
const $246fe80bbac8bca0$var$MARKETO_ID = '_mkto_trk';
const $246fe80bbac8bca0$var$REFERRER_TRELLO_DOMAINS = [
    'trello.com',
    'trellis.coffee'
];
class $246fe80bbac8bca0$export$544bf02140fa9a77 {
    /**
   * Sends a track event with known identifiers
   * @function identify
   * @param {string} userId - required
   * @param {object} traits - optional, dictionary of custom traits to send
   */ static identify(userId, traits) {
        traits = !!traits && typeof traits === 'object' ? traits : {};
        const data = traits;
        data['atlassian_id'] = userId;
        data['atlJSVersion'] = (0, $cYY9z.AnalyticsState).version || '1.0.0';
        try {
            data['ga_clientid'] = (0, $gx3aw.Cookie).readCookie('_ga');
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error reading _ga cookie');
        }
        (0, $92PV0.Tracking).trackEvent('known_identifiers', data);
    }
    /**
   * used internally to gather all known ids and call identify
   * @function autoIdentify
   */ static autoIdentify() {
        const emailDetected = (0, $i0bD5.Helpers).emailAddressIsDetected();
        const userId = $246fe80bbac8bca0$export$544bf02140fa9a77.getAtlassianUserId();
        const xid = (0, $gx3aw.Cookie).readCookie($246fe80bbac8bca0$var$XID);
        if (emailDetected) {
            const integrations = {
                All: false,
                'Google Analytics': true
            };
            if (!(0, $cYY9z.AnalyticsState).pageViewOptions) (0, $cYY9z.AnalyticsState).pageViewOptions = {
                integrations: integrations
            };
            else (0, $cYY9z.AnalyticsState).pageViewOptions['integrations'] = integrations;
            if ((0, $i0bD5.Helpers).urlContainsEmail(window.location.href)) (0, $i0bD5.Helpers).addCleanedUrlAndPaths($246fe80bbac8bca0$var$pageViewProperties);
            if ((0, $i0bD5.Helpers).urlContainsEmail(document.referrer)) (0, $i0bD5.Helpers).addCleanedReferrer($246fe80bbac8bca0$var$pageViewProperties);
        }
        try {
            $246fe80bbac8bca0$var$pageViewProperties['anonymous_id'] = (0, $cYY9z.AnalyticsState).anonymousId;
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error reading segment anonymousId');
        }
        try {
            $246fe80bbac8bca0$var$pageViewProperties[0, $fKfE1.ATL_COHORT] = (0, $fKfE1.Cohort).readWriteAtlCohort();
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error read / writing atlCohort cookie');
        }
        if (userId || xid) $246fe80bbac8bca0$export$544bf02140fa9a77.identify(userId, $246fe80bbac8bca0$var$pageViewProperties);
    }
    static getAtlassianUserId() {
        const userId = (0, $gx3aw.Cookie).readCookie('__aid_user_id');
        if (userId) return decodeURIComponent(userId);
        return null;
    }
    static getTrelloUserId() {
        try {
            const page = location.href ? new URL(location.href) : null;
            // since the trello cookie is such a common name. check to make sure we're actually on a trello page
            if (page && (page.hostname.includes('trello.com') || page.hostname.includes('trellis.coffee'))) {
                const token = (0, $gx3aw.Cookie).readCookie($246fe80bbac8bca0$var$TRELLO_USER_ID);
                if (token) return decodeURIComponent(token).split('/')[0];
            }
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error reading Trello userId');
        }
        return null;
    }
    static getMarketoId() {
        const marketoId = (0, $gx3aw.Cookie).readCookie($246fe80bbac8bca0$var$MARKETO_ID);
        if (marketoId) return decodeURIComponent(marketoId);
        return null;
    }
    static getMarketoIdPromise(enableRetry = true) {
        const waitCount = 0;
        const maxWait = enableRetry ? 5000 : 0;
        return new Promise((resolve)=>{
            $246fe80bbac8bca0$export$544bf02140fa9a77._internalMarketoPromise(waitCount, maxWait, resolve);
        });
    }
    static _internalMarketoPromise(waitCount, maxWait, resolve) {
        const delay = 500;
        const marketoId = (0, $gx3aw.Cookie).readCookie($246fe80bbac8bca0$var$MARKETO_ID);
        // wait for up to 5 seconds for the marketo cookie to show up
        if (marketoId) resolve(decodeURIComponent(marketoId));
        else {
            waitCount += delay;
            if (waitCount >= maxWait) {
                (0, $i0bD5.Helpers).sendWrapperLoadError('getMarketoIdPromise error');
                resolve('');
            } else setTimeout(function() {
                $246fe80bbac8bca0$export$544bf02140fa9a77._internalMarketoPromise(waitCount, maxWait, resolve);
            }, delay);
        }
    }
    static isReferrerTrello() {
        if (!document.referrer) return false;
        const ref = new URL(document.referrer);
        return $246fe80bbac8bca0$var$REFERRER_TRELLO_DOMAINS.includes(ref.hostname);
    }
}

});
parcelRegister("92PV0", function(module, exports) {
$parcel$export(module.exports, "Tracking", function () { return $30eaac7cdd8ec4f2$export$3672a9a17fd672c4; });

var $l8REe = parcelRequire("l8REe");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $2gCne = parcelRequire("2gCne");

var $gx3aw = parcelRequire("gx3aw");

var $cYY9z = parcelRequire("cYY9z");

var $fKfE1 = parcelRequire("fKfE1");

var $fLpER = parcelRequire("fLpER");

var $axCad = parcelRequire("axCad");

var $7NStU = parcelRequire("7NStU");

var $i0bD5 = parcelRequire("i0bD5");

var $ieoZa = parcelRequire("ieoZa");
class $30eaac7cdd8ec4f2$export$3672a9a17fd672c4 {
    static _getEventDomain() {
        return location && location.href ? new URL(location.href).hostname : '';
    }
    static _browserSupportsPromises() {
        return typeof Promise === 'function';
    }
    static _userOptedOutOfTrackingCookies() {
        return window.OnetrustActiveGroups && !/,4,/.exec(window.OnetrustActiveGroups);
    }
    static _shouldUsePromise() {
        return $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._browserSupportsPromises() && !$30eaac7cdd8ec4f2$export$3672a9a17fd672c4._userOptedOutOfTrackingCookies();
    }
    /**
   * Send a track/UI event
   * @method trackEvent
   * @param {string} event the name of the event
   * @param {object} data the properties to be sent with the event
   */ static trackEvent(event, data) {
        if ($30eaac7cdd8ec4f2$export$3672a9a17fd672c4._shouldUsePromise()) $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.enrichEventDataPromise(data).then((enrichedData)=>$30eaac7cdd8ec4f2$export$3672a9a17fd672c4._trackEvent(event, enrichedData)).catch((e)=>{
            console.warn('enrich Event + tracking._trackEvent invocation failed', e);
        });
        else try {
            data = $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.enrichEventData(data);
            $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._trackEvent(event, data);
        } catch (e) {
            console.warn('enrich Event + tracking._trackEvent invocation failed', e);
        }
    }
    static _trackEvent(event, enrichedData) {
        (0, $fLpER.GASv3).sendUIEvent(event, enrichedData);
        (0, $axCad.Gtm).track(enrichedData, event);
    }
    /**
   * send a page/screen event
   * @function pageView
   * @param {object} pageViewProperties - optional, dictionary of properties of the page (see: https://segment.com/docs/libraries/analytics.js/#page)
   * @param {object} pageViewOptions - optional, dictionary options to enable or disable specific integrations for the call (see: https://segment.com/docs/libraries/analytics.js/#page)
   * */ static pageView(pageViewProperties) {
        if ($30eaac7cdd8ec4f2$export$3672a9a17fd672c4._shouldUsePromise()) $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.enrichEventDataPromise(pageViewProperties).then(function(enrichedPageViewProperties) {
            $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._pageView(enrichedPageViewProperties);
        }).catch((e)=>{
            console.warn('enrich Event + tracking._pageView invocation failed', e);
        });
        else try {
            pageViewProperties = $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.enrichEventData(pageViewProperties);
            $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._pageView(pageViewProperties);
        } catch (e) {
            console.warn('enrich Event + tracking._pageView invocation failed', e);
        }
    }
    static _pageView(enrichedPageViewProperties) {
        enrichedPageViewProperties.wrapperName = 'atl-global';
        enrichedPageViewProperties.destinationFlag = 'gasv3';
        enrichedPageViewProperties.isBot = (0, $l8REe.isbot)(navigator.userAgent);
        if (!!window.cmsPageVariant) enrichedPageViewProperties.cmsPageVariant = window.cmsPageVariant;
        if (!!window.isUniform && window.compositionStatusCode !== 404) enrichedPageViewProperties.isUniform = window.isUniform;
        // AJ attributes — surfaced as top-level page view properties so they
        // are available on the page event itself (not nested inside
        // atl_first_visit).
        if (!!window.channel) enrichedPageViewProperties.page_channel = window.channel;
        if (!!window.anchor) enrichedPageViewProperties.page_anchor = window.anchor;
        if (!!window.subAnchor) enrichedPageViewProperties.page_subAnchor = window.subAnchor;
        if (!!window.keyword) enrichedPageViewProperties.page_aj_keyword = window.keyword;
        const isEnableOperationalEventWhenOptedOut = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10416DisableNonOperationalAnalyticsGateUip);
        if (isEnableOperationalEventWhenOptedOut) {
            enrichedPageViewProperties.sn_id = (0, $cYY9z.AnalyticsState).snId ?? '';
            enrichedPageViewProperties.atl_first_visit = (0, $cYY9z.AnalyticsState).atlFirstVisit ?? '{}';
            enrichedPageViewProperties.event = 'page';
            enrichedPageViewProperties.eventComponent = 'requested';
            (0, $fLpER.GASv3).sendOperationalEvent(enrichedPageViewProperties);
        }
        if ((0, $cYY9z.AnalyticsState).analyticsOptOut) return;
        (0, $axCad.Gtm).page(null, null, enrichedPageViewProperties);
        (0, $fLpER.GASv3).sendScreenEvent(null, enrichedPageViewProperties);
    }
    /**
   * Gets the pageViewId. Creates one if it doesn't exist
   * @function getPageViewId()
   */ static getPageViewId() {
        if (!$30eaac7cdd8ec4f2$export$3672a9a17fd672c4.pageViewId) $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.pageViewId = (0, $7NStU.Guid).guid();
        return $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.pageViewId;
    }
    /**
   * adds common data attributes to all track/UI and page/screen events
   * @function enrichEventData
   * @param {object} data the data to enrich
   */ static enrichEventDataPromise(data) {
        // If the data contains a href, then we have clicked a link and are navigating away
        // to a different page, so we don't have time to wait for the retry logic.
        const enableRetryForMarketoId = !data?.href && !data?.form;
        return new Promise((resolve)=>{
            (0, $ieoZa.Identity).getMarketoIdPromise(enableRetryForMarketoId).then((marketoId)=>{
                resolve($30eaac7cdd8ec4f2$export$3672a9a17fd672c4._enrichEventData(data, marketoId));
            });
        });
    }
    /**
   * adds common data attributes to all track/UI and page/screen events
   * @function enrichEventData
   * @param {object} data the data to enrich
   */ static enrichEventData(data) {
        return $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._enrichEventData(data, (0, $ieoZa.Identity).getMarketoId());
    }
    static _enrichEventData(inputData, marketoId) {
        let data = {};
        if (typeof inputData !== 'object' || inputData === null) {
            const dataValue = inputData;
            if (typeof dataValue !== 'undefined') data['data'] = dataValue;
        } else data = inputData;
        // if not already done, read the request Id cookie set by bxp-gateway
        if (!$30eaac7cdd8ec4f2$export$3672a9a17fd672c4.bxpGatewayRequestId) $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.bxpGatewayRequestId = (0, $gx3aw.Cookie).readCookie('bxp_gateway_request_id');
        // Only set the property if the cookie was there and readCookie didn't return null
        if ($30eaac7cdd8ec4f2$export$3672a9a17fd672c4.bxpGatewayRequestId) data['bxpGatewayRequestId'] = $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.bxpGatewayRequestId;
        data['pageViewId'] = $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.getPageViewId();
        // add identity data, if not present
        data['atlEventId'] = (0, $7NStU.Guid).guid();
        data['atlJSVersion'] = (0, $cYY9z.AnalyticsState).version || '1.0.0';
        data['browserLanguages'] = navigator.languages;
        // add category, if not present
        data['category'] = data['category'] || (document.title !== 'undefined' ? document.title.trim().replace(/\W+/g, '_') : '');
        // add the cohort to the object
        data[0, $fKfE1.ATL_COHORT] = (0, $fKfE1.Cohort).readWriteAtlCohort();
        const utms = (0, $cYY9z.AnalyticsState).utms;
        if (!!utms) data['campaign'] = {
            name: utms['utm_campaign'],
            campaign: utms['utm_campaign'],
            'sfdc-campaign_id': utms['utm_sfdc-campaign_id'],
            medium: utms['utm_medium'],
            source: utms['utm_source'],
            content: utms['utm_content'],
            term: utms['utm_term']
        };
        data['clientSessionId'] = $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.readWriteSessionCookie();
        if ($30eaac7cdd8ec4f2$export$3672a9a17fd672c4.xid) data['atlXid'] = $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.xid;
        data['marketoId'] = marketoId ? marketoId : '';
        data['onboardingJourney'] = JSON.parse((0, $2gCne.getLocalStorage)('onboarding-journey') || '""');
        return data;
    }
    /**
   * @function buildTrackEventProperties
   * @param {HTMLElement} el target element
   * @param {object} dataset takes data set from event.target.dataset
   * @param {string} label
   * @param {string} href
   * @returns {object} trackEventProperties
   */ static buildTrackEventProperties(el, dataset, label, href) {
        if (!dataset) return;
        const trackEventProperties = {
            label: label,
            href: href
        };
        if (el && el.nodeName === 'BUTTON') {
            const form = el.getAttribute('form');
            if (form) trackEventProperties.form = form;
        }
        const expectedProperties = [
            'actionSubjectId',
            'eventContainer',
            'eventColumn',
            'eventComponent',
            'uuid',
            'event',
            'inputValue',
            'parentLabel',
            'label',
            'labelEnglish',
            'productKey',
            'productVersion',
            'productEdition',
            'productPlatform',
            'schemaVersion',
            'name'
        ];
        const isExpectedProperty = (value)=>expectedProperties.includes(value);
        const dataSetEntries = [];
        for(const dataProperty in dataset)if (dataProperty !== 'track-event' && dataset.hasOwnProperty(dataProperty)) {
            const dataPropertyValue = dataset[dataProperty];
            if (dataPropertyValue) {
                if (isExpectedProperty(dataProperty)) trackEventProperties[dataProperty] = dataPropertyValue;
                else {
                    const dataEntry = {};
                    dataEntry[dataProperty] = dataPropertyValue;
                    dataSetEntries.push(dataEntry);
                }
            }
        }
        trackEventProperties.dataSet = dataSetEntries;
        return trackEventProperties;
    }
    /**
   * callback for auto track click events
   * @function _autoTrackClickEvent
   * @ignore
   */ // eslint-disable-next-line complexity
    static _autoTrackClickEvent(event) {
        try {
            const currentTargetElem = event.currentTarget;
            let targetElem = event.target;
            let rawText = targetElem.textContent;
            const isInput = (elem)=>elem.tagName === 'INPUT';
            const isAnchor = (elem)=>elem.hasAttribute('href');
            const isSelect = (elem)=>elem.tagName === 'SELECT';
            // handle form buttons differently
            if (isInput(targetElem)) // targetElem.value of an input text field is considered UGC and should not be tracked
            rawText = targetElem.type === 'text' ? '[REDACTED]' : targetElem.value !== '' ? targetElem.value : targetElem.textContent;
            else if (isSelect(targetElem)) {
                targetElem = targetElem.options[targetElem.selectedIndex] || targetElem;
                rawText = targetElem.getAttribute('data-label') || targetElem.textContent || targetElem.ariaLabel || targetElem.className;
            } else if (rawText === '') rawText = targetElem.parentNode?.textContent || targetElem.title || targetElem.ariaLabel || targetElem.className;
            const href = isAnchor(targetElem) ? targetElem.href : isAnchor(currentTargetElem) ? currentTargetElem.href : '';
            const trackEventName = targetElem.getAttribute('data-track-event') || currentTargetElem.getAttribute('data-track-event') || 'Clicked-Auto-CTA';
            const eventLabel = rawText ? rawText.toLowerCase().trim().replace(/ /g, '-') : '';
            const trackEventProperties = $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.buildTrackEventProperties(currentTargetElem, currentTargetElem.dataset, eventLabel, href);
            //@ts-ignore
            $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.trackEvent(trackEventName, trackEventProperties);
        } catch (err) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking click event');
        }
    }
    /**
   * queries the document for all selects and adds a change handler to them for tracking
   * @function autoTrackSelects
   */ static autoTrackSelects() {
        try {
            const selects = Array.from(document.querySelectorAll('select'));
            for (const select of selects)if (!$30eaac7cdd8ec4f2$export$3672a9a17fd672c4.isAutoTrackingDisabled(select)) {
                select.removeEventListener('change', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackClickEvent);
                select.addEventListener('change', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackClickEvent);
            }
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking select event');
        }
    }
    /**
   * queries the document for all submit buttons and adds a click handler to them for tracking
   * @function autoTrackButtons
   * @param {boolean} trackAll Indicates whether to use WAC's extended auto-tracking
   */ static autoTrackButtons(trackAll) {
        try {
            const selector = trackAll ? "button, input[type='submit'], input[type='button']" : "button, input[type='submit']";
            const btns = Array.from(document.querySelectorAll(selector));
            for (const btn of btns)if (!$30eaac7cdd8ec4f2$export$3672a9a17fd672c4.isAutoTrackingDisabled(btn)) {
                // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                btn.removeEventListener('click', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackClickEvent);
                // add an event listener
                btn.addEventListener('click', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackClickEvent);
            }
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking button event');
        }
    }
    /**
   * queries the document for all links with a class of 'button', 'btn', 'cta' and 'external-link' and adds click handler for tracking
   * @function autoTrackLinks
   * @param {boolean} trackAll Indicates whether to use WAC's extended auto-tracking
   */ static autoTrackLinks(trackAll) {
        try {
            const links = [], selector = trackAll ? 'a, .external-link' : "a[class*='button'], a[class*='btn'], .external-link", btnyLinks = Array.from(document.querySelectorAll(selector));
            for (const el of btnyLinks){
                const htmlEl = el;
                if (trackAll || htmlEl.offsetWidth >= 50 || el.className.includes('cta') || el.className.includes('external-link')) links.push(el);
            }
            for (const link of links)if (!$30eaac7cdd8ec4f2$export$3672a9a17fd672c4.isAutoTrackingDisabled(link)) {
                link.removeEventListener('click', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackClickEvent);
                link.addEventListener('click', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackClickEvent);
            }
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking link event');
        }
    }
    /**
   * callback for auto track video events
   * @function _autoTrackVideoEvent
   * @ignore
   */ static _autoTrackVideoEvent(element, eventName) {
        try {
            const className = typeof element.className !== 'undefined' ? element.className : element.parentElement?.className, eventLabel = typeof element.textContent !== 'undefined' ? element.textContent : '', eventCategory = typeof document.title !== 'undefined' ? document.title.replace(/\W+/g, '_').trim() : '';
            $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.trackEvent(eventName, {
                className: className,
                category: eventCategory,
                label: eventLabel,
                _sio: (0, $gx3aw.Cookie).readCookie('_sio') || '',
                _atl_path: (0, $gx3aw.Cookie).readCookie('__atl_path') || ''
            });
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking video event');
        }
    }
    /**
   * queries the document for all divs with video open and close links and adds a click handler for tracking
   * @function autoTrackVideos
   */ static autoTrackVideos() {
        try {
            const videoOpenLinks = Array.from(document.querySelectorAll("div[class*='videoPlayButton'], .video-link, .video_link, .customer-story-video-link"));
            const videoCloseLinks = Array.from(document.querySelectorAll("div[class='overlay'], .modal.video .close"));
            const trackVideoOpenEvent = function(ev) {
                const currentTargetElem = ev.currentTarget;
                $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackVideoEvent(currentTargetElem, 'Opened Video');
            };
            const trackVideoCloseEvent = function(ev) {
                const currentTargetElem = ev.currentTarget;
                $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackVideoEvent(currentTargetElem, 'Closed Video');
            };
            for (const videoOpenLink of videoOpenLinks){
                videoOpenLink.removeEventListener('click', trackVideoOpenEvent);
                videoOpenLink.addEventListener('click', trackVideoOpenEvent);
            }
            for (const videoCloseLink of videoCloseLinks){
                videoCloseLink.removeEventListener('click', trackVideoCloseEvent);
                videoCloseLink.addEventListener('click', trackVideoCloseEvent);
            }
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking video event');
        }
    }
    /**
   * queries the document for all role='tab' and adds a click handler to them for tracking
   * @function autoTrackTabs
   */ static autoTrackTabs() {
        try {
            const selector = "[role='tab']";
            const tabs = Array.from(document.querySelectorAll(selector));
            for (const tab of tabs)if (!$30eaac7cdd8ec4f2$export$3672a9a17fd672c4.isAutoTrackingDisabled(tab)) {
                // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                tab.removeEventListener('select', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackClickEvent);
                // add an event listener
                tab.addEventListener('select', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackClickEvent);
            }
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking tab event');
        }
    }
    /**
   * queries the document for all details elements and adds a toggle handler to them for tracking
   * @function autoTrackDetails
   */ static autoTrackDetails() {
        try {
            const details = Array.from(document.querySelectorAll('details'));
            for (const detail of details)if (!$30eaac7cdd8ec4f2$export$3672a9a17fd672c4.isAutoTrackingDisabled(detail)) {
                detail.removeEventListener('toggle', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackToggleEvent);
                detail.addEventListener('toggle', $30eaac7cdd8ec4f2$export$3672a9a17fd672c4._autoTrackToggleEvent);
            }
        } catch (e) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking details event');
        }
    }
    /**
   * callback for auto track toggle events on details elements
   * @function _autoTrackToggleEvent
   * @ignore
   */ static _autoTrackToggleEvent(event) {
        try {
            const detailsElem = event.currentTarget;
            const summaryElem = detailsElem.querySelector('summary');
            const rawText = summaryElem?.textContent || detailsElem.textContent || '';
            const isOpen = detailsElem.open;
            const trackEventName = detailsElem.getAttribute('data-track-event') || 'Toggled-Auto-Details';
            const eventLabel = rawText.toLowerCase().trim().replace(/ /g, '-');
            const trackEventProperties = $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.buildTrackEventProperties(detailsElem, detailsElem.dataset, eventLabel, '');
            if (trackEventProperties) trackEventProperties.event = isOpen ? 'opened' : 'closed';
            //@ts-ignore
            $30eaac7cdd8ec4f2$export$3672a9a17fd672c4.trackEvent(trackEventName, trackEventProperties);
        } catch (err) {
            (0, $i0bD5.Helpers).sendWrapperLoadError('Error auto-tracking toggle event');
        }
    }
    /**
   * check to see if the element in question contains class 'doNotAutoTrack'
   * @function isAutoTrackingDisabled
   * @param element
   */ static isAutoTrackingDisabled(element) {
        return element.classList.contains('doNotAutoTrack');
    }
    /**
   * return an existing session cookie
   * @function readWriteSessionCookie
   * @returns {string}
   */ static readWriteSessionCookie() {
        const cookie = (0, $gx3aw.Cookie).readCookie('atl_session');
        const name = 'atl_session';
        const value = cookie || (0, $7NStU.Guid).guid();
        const seconds = 1800;
        if ((0, $gx3aw.Cookie).writeCookieInSeconds) (0, $gx3aw.Cookie).writeCookieInSeconds(name, value, seconds);
        return value;
    }
}

});
parcelRegister("l8REe", function(module, exports) {
$parcel$export(module.exports, "isbot", function () { return $f643f5aff3a35a68$export$353239a0a95facc4; });
// src/patterns.json
var $f643f5aff3a35a68$var$patterns_default = [
    " daum[ /]",
    " deusu/",
    "(?:^|[^g])news(?!sapphire)",
    "(?<! (?:channel/|google/))google(?!(app|/google| pixel))",
    "(?<! cu)bots?(?:\\b|_)",
    "(?<!(?:lib))http",
    "(?<!cam)scan",
    "24x7",
    "@[a-z][\\w-]+\\.",
    "\\(\\)",
    "\\.com\\b",
    "\\b\\w+\\.ai",
    "\\bmanus-user/",
    "\\bort/",
    "\\bperl\\b",
    "\\bplaywright\\b",
    "\\bsecurityheaders\\b",
    "\\bselenium\\b",
    "\\btime/",
    "\\|",
    "^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)",
    "^[\\w\\-]+/[\\w]+$",
    "^[^ ]{50,}$",
    "^\\d+\\b",
    "^\\W",
    "^\\w*search\\b",
    "^\\w+/[\\w\\(\\)]*$",
    "^\\w+/\\d\\.\\d\\s\\([\\w@]+\\)$",
    "^active",
    "^ad muncher",
    "^amaya",
    "^apache/",
    "^avsdevicesdk/",
    "^azure",
    "^biglotron",
    "^bot",
    "^bw/",
    "^clamav[ /]",
    "^client/",
    "^cobweb/",
    "^custom",
    "^ddg[_-]android",
    "^discourse",
    "^dispatch/\\d",
    "^downcast/",
    "^duckduckgo",
    "^email",
    "^facebook",
    "^getright/",
    "^gozilla/",
    "^hobbit",
    "^hotzonu",
    "^hwcdn/",
    "^igetter/",
    "^jeode/",
    "^jetty/",
    "^jigsaw",
    "^microsoft bits",
    "^movabletype",
    "^mozilla/\\d\\.\\d\\s[\\w\\.-]+$",
    "^mozilla/\\d\\.\\d\\s\\((?:compatible;)?(?:\\s?[\\w\\d-.]+\\/\\d+\\.\\d+)?\\)$",
    "^navermailapp",
    "^netsurf",
    "^offline",
    "^openai/",
    "^owler",
    "^php",
    "^postman",
    "^python",
    "^rank",
    "^read",
    "^reed",
    "^rest",
    "^rss",
    "^snapchat",
    "^space bison",
    "^svn",
    "^swcd ",
    "^taringa",
    "^thumbor/",
    "^track",
    "^w3c",
    "^webbandit/",
    "^webcopier",
    "^wget",
    "^whatsapp",
    "^wordpress",
    "^xenu link sleuth",
    "^yahoo",
    "^yandex",
    "^zdm/\\d",
    "^zoom marketplace/",
    "advisor",
    "agent\\b",
    "analyzer",
    "archive",
    "ask jeeves/teoma",
    "audit",
    "bit\\.ly/",
    "bluecoat drtr",
    "browsex",
    "burpcollaborator",
    "capture",
    "catch",
    "check\\b",
    "checker",
    "chrome-lighthouse",
    "chromeframe",
    "classifier",
    "cloudflare",
    "convertify",
    "crawl",
    "cypress/",
    "dareboost",
    "datanyze",
    "dejaclick",
    "detect",
    "dmbrowser",
    "download",
    "exaleadcloudview",
    "feed",
    "fetcher",
    "firephp",
    "functionize",
    "grab",
    "headless",
    "httrack",
    "hubspot marketing grader",
    "ibisbrowser",
    "infrawatch",
    "insight",
    "inspect",
    "iplabel",
    "java(?!;)",
    "library",
    "linkcheck",
    "mail\\.ru/",
    "manager",
    "measure",
    "monitor\\b",
    "neustar wpm",
    "node\\b",
    "nutch",
    "offbyone",
    "onetrust",
    "optimize",
    "pageburst",
    "pagespeed",
    "parser",
    "phantomjs",
    "pingdom",
    "powermarks",
    "preview",
    "proxy",
    "ptst[ /]\\d",
    "retriever",
    "rexx;",
    "rigor",
    "rss\\b",
    "scrape",
    "server",
    "sogou",
    "sparkler/",
    "speedcurve",
    "spider",
    "splash",
    "statuscake",
    "supercleaner",
    "synapse",
    "synthetic",
    "tools",
    "torrent",
    "transcoder",
    "url",
    "validator",
    "virtuoso",
    "wappalyzer",
    "webglance",
    "webkit2png",
    "whatcms/",
    "xtate/"
];
// src/pattern.ts
var $f643f5aff3a35a68$var$fullPattern = " daum[ /]| deusu/|(?:^|[^g])news(?!sapphire)|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bots?(?:\\b|_)|(?<!(?:lib))http|(?<!cam)scan|24x7|@[a-z][\\w-]+\\.|\\(\\)|\\.com\\b|\\b\\w+\\.ai|\\bmanus-user/|\\bort/|\\bperl\\b|\\bplaywright\\b|\\bsecurityheaders\\b|\\bselenium\\b|\\btime/|\\||^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[\\w\\-]+/[\\w]+$|^[^ ]{50,}$|^\\d+\\b|^\\W|^\\w*search\\b|^\\w+/[\\w\\(\\)]*$|^\\w+/\\d\\.\\d\\s\\([\\w@]+\\)$|^active|^ad muncher|^amaya|^apache/|^avsdevicesdk/|^azure|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^email|^facebook|^getright/|^gozilla/|^hobbit|^hotzonu|^hwcdn/|^igetter/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/\\d\\.\\d\\s[\\w\\.-]+$|^mozilla/\\d\\.\\d\\s\\((?:compatible;)?(?:\\s?[\\w\\d-.]+\\/\\d+\\.\\d+)?\\)$|^navermailapp|^netsurf|^offline|^openai/|^owler|^php|^postman|^python|^rank|^read|^reed|^rest|^rss|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|advisor|agent\\b|analyzer|archive|ask jeeves/teoma|audit|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check\\b|checker|chrome-lighthouse|chromeframe|classifier|cloudflare|convertify|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|exaleadcloudview|feed|fetcher|firephp|functionize|grab|headless|httrack|hubspot marketing grader|ibisbrowser|infrawatch|insight|inspect|iplabel|java(?!;)|library|linkcheck|mail\\.ru/|manager|measure|monitor\\b|neustar wpm|node\\b|nutch|offbyone|onetrust|optimize|pageburst|pagespeed|parser|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|retriever|rexx;|rigor|rss\\b|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|synthetic|tools|torrent|transcoder|url|validator|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|xtate/";
// src/index.ts
var $f643f5aff3a35a68$var$naivePattern = /bot|crawl|http|lighthouse|scan|search|spider/i;
var $f643f5aff3a35a68$var$pattern;
function $f643f5aff3a35a68$export$2adb6bbc893073f4() {
    if ($f643f5aff3a35a68$var$pattern instanceof RegExp) return $f643f5aff3a35a68$var$pattern;
    try {
        $f643f5aff3a35a68$var$pattern = new RegExp($f643f5aff3a35a68$var$fullPattern, "i");
    } catch (error) {
        $f643f5aff3a35a68$var$pattern = $f643f5aff3a35a68$var$naivePattern;
    }
    return $f643f5aff3a35a68$var$pattern;
}
var $f643f5aff3a35a68$var$isNonEmptyString = (value)=>typeof value === "string" && value !== "";
var $f643f5aff3a35a68$export$8837f4fc672e936d = $f643f5aff3a35a68$var$patterns_default;
function $f643f5aff3a35a68$export$353239a0a95facc4(userAgent) {
    return $f643f5aff3a35a68$var$isNonEmptyString(userAgent) && $f643f5aff3a35a68$export$2adb6bbc893073f4().test(userAgent);
}
var $f643f5aff3a35a68$export$45b7009f916562f6 = (userAgent)=>$f643f5aff3a35a68$var$isNonEmptyString(userAgent) && $f643f5aff3a35a68$var$naivePattern.test(userAgent);
var $f643f5aff3a35a68$export$310558728bbed3b4 = (customPattern)=>(userAgent)=>$f643f5aff3a35a68$var$isNonEmptyString(userAgent) && customPattern.test(userAgent);
var $f643f5aff3a35a68$export$cdec6abc0f81ec40 = (list2)=>{
    const pattern2 = new RegExp(list2.join("|"), "i");
    return (userAgent)=>$f643f5aff3a35a68$var$isNonEmptyString(userAgent) && pattern2.test(userAgent);
};
var $f643f5aff3a35a68$export$22f77009018b89bb = (userAgent)=>{
    var _a, _b;
    return (_b = (_a = userAgent == null ? void 0 : userAgent.match($f643f5aff3a35a68$export$2adb6bbc893073f4())) == null ? void 0 : _a[0]) != null ? _b : null;
};
var $f643f5aff3a35a68$export$d417bbbb5748c4c6 = (userAgent)=>$f643f5aff3a35a68$export$8837f4fc672e936d.map((part)=>{
        var _a;
        return (_a = userAgent == null ? void 0 : userAgent.match(new RegExp(part, "i"))) == null ? void 0 : _a[0];
    }).filter($f643f5aff3a35a68$var$isNonEmptyString);
var $f643f5aff3a35a68$export$126fbb46d867761c = (userAgent)=>{
    var _a;
    return userAgent ? (_a = $f643f5aff3a35a68$export$8837f4fc672e936d.find((pattern2)=>new RegExp(pattern2, "i").test(userAgent))) != null ? _a : null : null;
};
var $f643f5aff3a35a68$export$6ad01fc2047d6909 = (userAgent)=>userAgent ? $f643f5aff3a35a68$export$8837f4fc672e936d.filter((pattern2)=>new RegExp(pattern2, "i").test(userAgent)) : [];

});

parcelRegister("axCad", function(module, exports) {
$parcel$export(module.exports, "Gtm", function () { return $2accd27397868091$export$9ab4d56492766a00; });
/**
 * Internal module for initializing Snowplow and making Snowplow-specific event calls. Public init functions can be found in Initializer module
 * @module Gtm
 */ 
var $g1HEd = parcelRequire("g1HEd");
var $1jDl2 = parcelRequire("1jDl2");

var $cYY9z = parcelRequire("cYY9z");
class $2accd27397868091$export$9ab4d56492766a00 {
    /**
   * Initializes Google Tag Manager
   * @function initialize
   */ // eslint-disable-next-line complexity
    static initialize(writeKey) {
        // Add Sentry breadcrumb for debugging script loading issues
        $g1HEd.addBreadcrumb({
            message: 'GTM initialization started',
            data: {
                writeKey: writeKey,
                pathname: window.location.pathname,
                onetrustStatus: window.OnetrustActiveGroups !== undefined ? 'ready' : 'not ready',
                onetrustActiveGroups: window.OnetrustActiveGroups !== undefined ? window.OnetrustActiveGroups : 'window.OnetrustActiveGroups undefined',
                dataLayerExists: !!window['dataLayer']
            },
            level: 'info',
            category: 'gtm'
        });
        /* eslint-disable no-restricted-syntax -- GTM init must detect/polyfill raw localStorage for third-party script */ // Polyfill localStorage to prevent third-party script errors
        let isStorageInaccessible = false;
        try {
            if (!window.localStorage || typeof window.localStorage.setItem !== 'function') isStorageInaccessible = true;
        } catch (error) {
            isStorageInaccessible = true;
            $g1HEd.addBreadcrumb({
                message: 'localStorage not accessible, installed polyfill',
                data: {
                    error: error instanceof Error ? error.message : String(error)
                },
                level: 'warning',
                category: 'gtm'
            });
        }
        if (isStorageInaccessible) try {
            window.localStorage = {
                getItem: ()=>null,
                setItem: ()=>{
                /* no-op */ },
                removeItem: ()=>{
                /* no-op */ },
                clear: ()=>{
                /* no-op */ },
                length: 0,
                key: ()=>null
            };
        } catch (error) {
            // In some environments, the localStorage object cannot be reassigned, due to it's descriptor setter being undefined
            $g1HEd.addBreadcrumb({
                message: 'localStorage could not be polyfilled',
                data: {
                    error: error instanceof Error ? error.message : String(error),
                    localStorageDescriptor: JSON.stringify(Object.getOwnPropertyDescriptor(window, 'localStorage'))
                },
                level: 'warning',
                category: 'gtm'
            });
        }
        /* eslint-enable no-restricted-syntax */ const containerId = $2accd27397868091$export$9ab4d56492766a00.getContainerId(writeKey);
        $g1HEd.addBreadcrumb({
            message: 'GTM container ID resolved',
            data: {
                writeKey: writeKey,
                containerId: containerId
            },
            level: 'info',
            category: 'gtm'
        });
        if (containerId) {
            window['dataLayer'] = window['dataLayer'] || [];
            window['dataLayer'].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            $g1HEd.addBreadcrumb({
                message: 'GTM dataLayer initialized',
                data: {
                    containerId: containerId,
                    dataLayerLength: window['dataLayer'].length
                },
                level: 'info',
                category: 'gtm'
            });
            const firstScript = document.getElementsByTagName('script')[0];
            const gtmScript = document.createElement('script');
            gtmScript.async = true;
            gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId;
            // Add error handling and monitoring for the GTM script
            gtmScript.onerror = (error)=>{
                const errorString = error instanceof Error ? error.toString() : String(error);
                const errorMessage = error instanceof Error ? error.message : String(error);
                $g1HEd.addBreadcrumb({
                    message: 'GTM script failed to load',
                    data: {
                        containerId: containerId,
                        src: gtmScript.src,
                        error: errorString
                    },
                    level: 'error',
                    category: 'gtm'
                });
                $1jDl2.captureException(new Error(`GTM script load failed: ${errorMessage}`), {
                    tags: {
                        component: 'gtm-integration',
                        containerId: containerId,
                        pathname: window.location.pathname
                    }
                });
            };
            gtmScript.onload = ()=>{
                $g1HEd.addBreadcrumb({
                    message: 'GTM script loaded successfully',
                    data: {
                        containerId: containerId,
                        src: gtmScript.src
                    },
                    level: 'info',
                    category: 'gtm'
                });
            };
            $g1HEd.addBreadcrumb({
                message: 'Attempting to inject GTM script',
                data: {
                    containerId: containerId,
                    src: gtmScript.src,
                    hasFirstScript: !!firstScript,
                    parentNode: firstScript?.parentNode?.nodeName
                },
                level: 'info',
                category: 'gtm'
            });
            firstScript?.parentNode?.insertBefore(gtmScript, firstScript);
        } else $g1HEd.addBreadcrumb({
            message: 'GTM container ID not found',
            data: {
                writeKey: writeKey
            },
            level: 'warning',
            category: 'gtm'
        });
    }
    /**
   * Sends a gtm page call
   * @function page
   */ static page(name, category, data) {
        let event = 'Loaded a Page';
        $2accd27397868091$export$9ab4d56492766a00.track(data, event);
        if (category) {
            event = 'Viewed ' + name + ' ' + category + ' Page';
            $2accd27397868091$export$9ab4d56492766a00.track(data, event);
        }
        if (name) {
            event = 'Viewed ' + name + ' Page';
            $2accd27397868091$export$9ab4d56492766a00.track(data, event);
        }
    }
    static track(data, event) {
        try {
            const props = typeof data !== 'undefined' ? JSON.parse(JSON.stringify(data)) : {};
            const analyticsOptOut = (0, $cYY9z.AnalyticsState).analyticsOptOut;
            if (analyticsOptOut) return;
            const anonId = (0, $cYY9z.AnalyticsState).anonymousId;
            if (anonId) props.gasv3AnonymousId = anonId;
            if (event) props.event = event;
            const dataLayer = 'dataLayer';
            window[dataLayer] = window[dataLayer] || [];
            $g1HEd.addBreadcrumb({
                message: 'GTM track event',
                data: {
                    event: event,
                    dataLayerLength: window[dataLayer].length,
                    hasData: !!data,
                    pathname: window.location.pathname
                },
                level: 'debug',
                category: 'gtm'
            });
            window[dataLayer].push(props);
        } catch (error) {
            $g1HEd.addBreadcrumb({
                message: 'GTM track failed',
                data: {
                    event: event,
                    error: error instanceof Error ? error.message : String(error),
                    pathname: window.location.pathname
                },
                level: 'error',
                category: 'gtm'
            });
            $1jDl2.captureException(error, {
                tags: {
                    component: 'gtm-track',
                    event: event,
                    pathname: window.location.pathname
                }
            });
        }
    }
    static getContainerId(writeKey) {
        const containerIds = $2accd27397868091$export$9ab4d56492766a00.getContainerIdMapping();
        return containerIds[writeKey];
    }
    static getContainerIdMapping() {
        return {
            // Production
            ycih1ygfsk: 'GTM-MR6PJQR',
            // support.atlassian.com
            '9nfqb81km3': 'GTM-TSGXFNC',
            // confluence.atlassian.com
            kFTUHPhH9Q: 'GTM-TRS3MV',
            // bitbucket
            u7y09b0olq: 'GTM-5VS67RK',
            // developer.atlassian.com
            eNVsl3NOQquS5E0YXjD4prfiNVqVP3mr: 'GTM-KZLJPX4',
            // opsgenie
            bvsetm1g1y: 'GTM-5RJSBR',
            // atlassian.com-cart
            kiv6wyh2nw: 'GTM-5RJSBR',
            // atlassian.com
            r4n974s99s: 'GTM-5RJSBR',
            // blogs.atlassian.com
            swoogo: 'GTM-5RJSBR',
            // events.atlassian.com
            '8oi64no': 'GTM-K7MDT22',
            // statuspage.io
            xjtlog1hqa: 'GTM-KQ6R2C3',
            // marketplace.atlassian.com
            bNSPpYAL9OiAkamBRvfRJoRu9YANW14I: 'GTM-MGV77B',
            // docs.atlassian.com-aui
            TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw: 'GTM-TQZMFCL',
            // community.atlassian.com
            trello: 'GTM-PJ8M5SK',
            // trello
            // Test
            '4J6H7c3XTcpm1dbenkOILSyOachvf9It': 'GTM-TQZMFCL',
            // community.stg.atlassian.com
            SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold: 'GTM-TQZMFCL',
            // community.dev1.dev.atlassian.com
            QVFu18jjHlCNaBXizZ3mtiqlBXVRkg1M: 'GTM-TQZMFCL',
            // community.dev2.dev.atlassian.com
            QmWM6iw7auEJw5gDQi6910Xk1wqyZ6bE: 'GTM-TQZMFCL',
            // community.dev3.dev.atlassian.com
            hWTszOAQMuItRdv8J30A3mNpCWd891bx: 'GTM-TQZMFCL',
            // community.dev4.dev.atlassian.com
            EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I: 'GTM-5RJSBR',
            // qa-wac.internal.atlassian.com
            Z2S07IGcRYkPJ7XHy3OIXcjpYoy9E6bs: 'GTM-5RJSBR' // CXP Local Dev
        };
    }
}

});
parcelRegister("g1HEd", function(module, exports) {
$parcel$export(module.exports, "addBreadcrumb", function () { return $baae98dd72a19493$export$efda9a273d7a036d; });

var $i7nxO = parcelRequire("i7nxO");

var $9sRth = parcelRequire("9sRth");

var $2CVVa = parcelRequire("2CVVa");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $baae98dd72a19493$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $baae98dd72a19493$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $i7nxO.getClient)();
    const isolationScope = (0, $i7nxO.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $baae98dd72a19493$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $2CVVa.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $9sRth.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});

parcelRegister("1jDl2", function(module, exports) {
$parcel$export(module.exports, "captureException", function () { return $0f561492237a3218$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureEvent", function () { return $0f561492237a3218$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "setContext", function () { return $0f561492237a3218$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setTag", function () { return $0f561492237a3218$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "setUser", function () { return $0f561492237a3218$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "lastEventId", function () { return $0f561492237a3218$export$5d4e9fd7fac8e617; });
$parcel$export(module.exports, "isEnabled", function () { return $0f561492237a3218$export$3b029eb57ac4d562; });
$parcel$export(module.exports, "startSession", function () { return $0f561492237a3218$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $0f561492237a3218$export$667e7b4d445d566b; });

var $i7nxO = parcelRequire("i7nxO");

var $4YMns = parcelRequire("4YMns");

var $cEs1A = parcelRequire("cEs1A");

var $cXjEa = parcelRequire("cXjEa");

var $86GZW = parcelRequire("86GZW");

var $9sRth = parcelRequire("9sRth");

var $hqa9f = parcelRequire("hqa9f");

var $2CVVa = parcelRequire("2CVVa");

var $9ishN = parcelRequire("9ishN");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $0f561492237a3218$export$f5282963edea4a68(exception, hint) {
    return (0, $i7nxO.getCurrentScope)().captureException(exception, (0, $cXjEa.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $0f561492237a3218$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $i7nxO.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $0f561492237a3218$export$1462b974fdcf6ba2(event, hint) {
    return (0, $i7nxO.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $0f561492237a3218$export$2f04de43fe27971a(name, context) {
    (0, $i7nxO.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $0f561492237a3218$export$bb4922da0dd51b92(extras) {
    (0, $i7nxO.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $0f561492237a3218$export$8e8e7789d42ed61d(key, extra) {
    (0, $i7nxO.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $0f561492237a3218$export$74a8fb34822092e6(tags) {
    (0, $i7nxO.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $0f561492237a3218$export$a37d07ee78eb4569(key, value) {
    (0, $i7nxO.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $0f561492237a3218$export$8b6bb3dd62a01be2(user) {
    (0, $i7nxO.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $0f561492237a3218$export$5d4e9fd7fac8e617() {
    return (0, $i7nxO.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $0f561492237a3218$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $i7nxO.getCurrentScope)();
    const client = (0, $i7nxO.getClient)();
    if (!client) (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $hqa9f.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $0f561492237a3218$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $0f561492237a3218$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $2CVVa.timestampInSeconds)();
    function finishCheckIn(status) {
        $0f561492237a3218$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $2CVVa.timestampInSeconds)() - now
        });
    }
    return (0, $i7nxO.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $86GZW.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $0f561492237a3218$export$4909b86c8034bf73(timeout) {
    const client = (0, $i7nxO.getClient)();
    if (client) return client.flush(timeout);
    (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $0f561492237a3218$export$8360e631d277ea4d(timeout) {
    const client = (0, $i7nxO.getClient)();
    if (client) return client.close(timeout);
    (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $0f561492237a3218$export$3f95c6f800b78024() {
    return !!(0, $i7nxO.getClient)();
}
/** If the SDK is initialized & enabled. */ function $0f561492237a3218$export$3b029eb57ac4d562() {
    const client = (0, $i7nxO.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $0f561492237a3218$export$9aac0b9f77928fbf(callback) {
    (0, $i7nxO.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $0f561492237a3218$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $i7nxO.getIsolationScope)();
    const currentScope = (0, $i7nxO.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $9ishN.GLOBAL_OBJ).navigator || {};
    const session = (0, $cEs1A.makeSession)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $cEs1A.updateSession)(currentSession, {
        status: 'exited'
    });
    $0f561492237a3218$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $0f561492237a3218$export$17a5be43989a0bc1() {
    const isolationScope = (0, $i7nxO.getIsolationScope)();
    const currentScope = (0, $i7nxO.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $cEs1A.closeSession)(session);
    $0f561492237a3218$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $0f561492237a3218$var$_sendSessionUpdate() {
    const isolationScope = (0, $i7nxO.getIsolationScope)();
    const client = (0, $i7nxO.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $0f561492237a3218$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $0f561492237a3218$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $0f561492237a3218$var$_sendSessionUpdate();
}

});
parcelRegister("4YMns", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", function () { return $3a024ac5f9b31891$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3a024ac5f9b31891$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("cXjEa", function(module, exports) {
$parcel$export(module.exports, "prepareEvent", function () { return $96ea3c33296d6829$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $96ea3c33296d6829$export$76b5f966996d1653; });

var $aPJPH = parcelRequire("aPJPH");

var $i7nxO = parcelRequire("i7nxO");

var $bm66r = parcelRequire("bm66r");

var $fex0p = parcelRequire("fex0p");

var $jr3Im = parcelRequire("jr3Im");

var $hqa9f = parcelRequire("hqa9f");

var $lvx9g = parcelRequire("lvx9g");

var $gUnvu = parcelRequire("gUnvu");

var $2CVVa = parcelRequire("2CVVa");

var $hnnqy = parcelRequire("hnnqy");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $96ea3c33296d6829$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $hqa9f.uuid4)(),
        timestamp: event.timestamp || (0, $2CVVa.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $96ea3c33296d6829$export$d7e04067a6fbc882(prepared, options);
    $96ea3c33296d6829$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $96ea3c33296d6829$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $96ea3c33296d6829$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $hqa9f.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $i7nxO.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $hnnqy.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $hnnqy.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $hnnqy.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $bm66r.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $96ea3c33296d6829$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $96ea3c33296d6829$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $96ea3c33296d6829$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $aPJPH.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $gUnvu.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $96ea3c33296d6829$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $jr3Im.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $96ea3c33296d6829$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $96ea3c33296d6829$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $96ea3c33296d6829$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $lvx9g.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $lvx9g.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $lvx9g.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $lvx9g.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $lvx9g.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $lvx9g.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $lvx9g.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $96ea3c33296d6829$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $fex0p.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $96ea3c33296d6829$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($96ea3c33296d6829$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($96ea3c33296d6829$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $96ea3c33296d6829$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $fex0p.Scope) || typeof hint === 'function';
}
const $96ea3c33296d6829$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $96ea3c33296d6829$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$96ea3c33296d6829$var$captureContextKeys.includes(key));
}

});
parcelRegister("aPJPH", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $7e32384161f255f6$export$849dbeeeda01ae98; });
const $7e32384161f255f6$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("bm66r", function(module, exports) {
$parcel$export(module.exports, "notifyEventProcessors", function () { return $84467bb622c54fa2$export$bf2a096c3e883e79; });

var $4YMns = parcelRequire("4YMns");

var $86GZW = parcelRequire("86GZW");

var $9sRth = parcelRequire("9sRth");

var $deiyZ = parcelRequire("deiyZ");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $84467bb622c54fa2$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $deiyZ.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $4YMns.DEBUG_BUILD) && processor.id && result === null && (0, $9sRth.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $86GZW.isThenable)(result)) result.then((final)=>$84467bb622c54fa2$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $84467bb622c54fa2$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("deiyZ", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", function () { return $9a1afb79f6a9269e$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $9a1afb79f6a9269e$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $9a1afb79f6a9269e$export$78e43115b553f358; });

var $86GZW = parcelRequire("86GZW");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9a1afb79f6a9269e$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9a1afb79f6a9269e$var$States || ($9a1afb79f6a9269e$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9a1afb79f6a9269e$export$1fda8aa4d135f8aa(value) {
    return new $9a1afb79f6a9269e$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9a1afb79f6a9269e$export$78e43115b553f358(reason) {
    return new $9a1afb79f6a9269e$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9a1afb79f6a9269e$export$6f292d4960313241 {
    constructor(executor){
        this._state = $9a1afb79f6a9269e$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $9a1afb79f6a9269e$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $9a1afb79f6a9269e$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $9a1afb79f6a9269e$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $9a1afb79f6a9269e$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $9a1afb79f6a9269e$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $9a1afb79f6a9269e$var$States.PENDING) return;
            if ((0, $86GZW.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($9a1afb79f6a9269e$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($9a1afb79f6a9269e$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("jr3Im", function(module, exports) {
$parcel$export(module.exports, "getFilenameToDebugIdMap", function () { return $e2636b9273346444$export$e069fee9c632ed00; });

var $9ishN = parcelRequire("9ishN");
let $e2636b9273346444$var$parsedStackResults;
let $e2636b9273346444$var$lastKeysCount;
let $e2636b9273346444$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $e2636b9273346444$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $9ishN.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($e2636b9273346444$var$cachedFilenameDebugIds && debugIdKeys.length === $e2636b9273346444$var$lastKeysCount) return $e2636b9273346444$var$cachedFilenameDebugIds;
    $e2636b9273346444$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $e2636b9273346444$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$e2636b9273346444$var$parsedStackResults) $e2636b9273346444$var$parsedStackResults = {};
        const result = $e2636b9273346444$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $e2636b9273346444$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $e2636b9273346444$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $e2636b9273346444$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $e2636b9273346444$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("lvx9g", function(module, exports) {
$parcel$export(module.exports, "normalize", function () { return $fa8634caefd012a4$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $fa8634caefd012a4$export$23fbbb20bed71033; });

var $86GZW = parcelRequire("86GZW");

var $3eJmu = parcelRequire("3eJmu");

var $eE5Vk = parcelRequire("eE5Vk");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fa8634caefd012a4$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $fa8634caefd012a4$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $fa8634caefd012a4$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $fa8634caefd012a4$export$a3295358bff77e(object, depth);
    if ($fa8634caefd012a4$var$jsonSize(normalized) > maxSize) return $fa8634caefd012a4$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $fa8634caefd012a4$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $fa8634caefd012a4$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $fa8634caefd012a4$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $fa8634caefd012a4$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $3eJmu.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $fa8634caefd012a4$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $fa8634caefd012a4$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $86GZW.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $86GZW.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $eE5Vk.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $fa8634caefd012a4$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $fa8634caefd012a4$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $fa8634caefd012a4$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fa8634caefd012a4$var$jsonSize(value) {
    return $fa8634caefd012a4$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $fa8634caefd012a4$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $fa8634caefd012a4$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});
parcelRegister("eE5Vk", function(module, exports) {
$parcel$export(module.exports, "UNKNOWN_FUNCTION", function () { return $aa9965728944ef00$export$27c7e15d453fc0ac; });
$parcel$export(module.exports, "createStackParser", function () { return $aa9965728944ef00$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $aa9965728944ef00$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $aa9965728944ef00$export$aad197c7121a6651; });
$parcel$export(module.exports, "getFramesFromEvent", function () { return $aa9965728944ef00$export$91d8ca51bd9f6a47; });
const $aa9965728944ef00$var$STACKTRACE_FRAME_LIMIT = 50;
const $aa9965728944ef00$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $aa9965728944ef00$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $aa9965728944ef00$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $aa9965728944ef00$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $aa9965728944ef00$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($aa9965728944ef00$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $aa9965728944ef00$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $aa9965728944ef00$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $aa9965728944ef00$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $aa9965728944ef00$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $aa9965728944ef00$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($aa9965728944ef00$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($aa9965728944ef00$var$STRIP_FRAME_REGEXP.test($aa9965728944ef00$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($aa9965728944ef00$var$STRIP_FRAME_REGEXP.test($aa9965728944ef00$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $aa9965728944ef00$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $aa9965728944ef00$var$getLastStackFrame(localStack).filename,
            function: frame.function || $aa9965728944ef00$export$27c7e15d453fc0ac
        }));
}
function $aa9965728944ef00$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $aa9965728944ef00$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $aa9965728944ef00$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $aa9965728944ef00$var$defaultFunctionName;
        return fn.name || $aa9965728944ef00$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $aa9965728944ef00$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $aa9965728944ef00$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});


parcelRegister("hnnqy", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $ca66c1d81d28a10e$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $ca66c1d81d28a10e$export$25ac7e259a513db4; });

var $64wec = parcelRequire("64wec");

var $4xUZv = parcelRequire("4xUZv");

var $8j0KV = parcelRequire("8j0KV");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $ca66c1d81d28a10e$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $ca66c1d81d28a10e$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $ca66c1d81d28a10e$var$applySpanToEvent(event, span);
    $ca66c1d81d28a10e$var$applyFingerprintToEvent(event, fingerprint);
    $ca66c1d81d28a10e$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $ca66c1d81d28a10e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $ca66c1d81d28a10e$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $ca66c1d81d28a10e$export$b1a120a2871faa46(data, 'extra', extra);
    $ca66c1d81d28a10e$export$b1a120a2871faa46(data, 'tags', tags);
    $ca66c1d81d28a10e$export$b1a120a2871faa46(data, 'user', user);
    $ca66c1d81d28a10e$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $4xUZv.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $ca66c1d81d28a10e$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $4xUZv.merge)(data[prop], mergeVal, 1);
}
function $ca66c1d81d28a10e$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $ca66c1d81d28a10e$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $ca66c1d81d28a10e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $ca66c1d81d28a10e$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $8j0KV.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $64wec.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $8j0KV.getRootSpan)(span);
    const transactionName = (0, $8j0KV.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $ca66c1d81d28a10e$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("64wec", function(module, exports) {
$parcel$export(module.exports, "freezeDscOnSpan", function () { return $46bc1d99237d51a3$export$7398c93e763ca9fd; });
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", function () { return $46bc1d99237d51a3$export$89ef1736f08c6b2b; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $46bc1d99237d51a3$export$a117f995597e25df; });

var $aPJPH = parcelRequire("aPJPH");

var $i7nxO = parcelRequire("i7nxO");

var $dhhBD = parcelRequire("dhhBD");

var $isIB5 = parcelRequire("isIB5");

var $8j0KV = parcelRequire("8j0KV");

var $j8ubf = parcelRequire("j8ubf");

var $3eJmu = parcelRequire("3eJmu");

var $7brnw = parcelRequire("7brnw");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $46bc1d99237d51a3$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $46bc1d99237d51a3$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $3eJmu.addNonEnumerableProperty)(spanWithMaybeDsc, $46bc1d99237d51a3$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $46bc1d99237d51a3$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $aPJPH.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $46bc1d99237d51a3$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $46bc1d99237d51a3$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $46bc1d99237d51a3$export$a117f995597e25df(span) {
    const client = (0, $i7nxO.getClient)();
    if (!client) return {};
    const rootSpan = (0, $8j0KV.getRootSpan)(span);
    const rootSpanJson = (0, $8j0KV.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$46bc1d99237d51a3$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $j8ubf.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $46bc1d99237d51a3$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $isIB5.hasSpansEnabled)()) {
        dsc.sampled = String((0, $8j0KV.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $7brnw.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $46bc1d99237d51a3$export$95cf936fdacaff7b(span) {
    const dsc = $46bc1d99237d51a3$export$a117f995597e25df(span);
    return (0, $j8ubf.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("dhhBD", function(module, exports) {
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $9aaa8518ef8f6a2e$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $9aaa8518ef8f6a2e$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $9aaa8518ef8f6a2e$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $9aaa8518ef8f6a2e$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", function () { return $9aaa8518ef8f6a2e$export$ba73f34502b7a3b3; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function () { return $9aaa8518ef8f6a2e$export$f5f95cff026507b5; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function () { return $9aaa8518ef8f6a2e$export$69cd5c610c7bb96a; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function () { return $9aaa8518ef8f6a2e$export$165ce9a229f6f050; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $9aaa8518ef8f6a2e$export$1efec95406bbe327; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function () { return $9aaa8518ef8f6a2e$export$fea48ba9f4550879; });
$parcel$export(module.exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", function () { return $9aaa8518ef8f6a2e$export$ff77b5fd5b2d627b; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $9aaa8518ef8f6a2e$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $9aaa8518ef8f6a2e$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $9aaa8518ef8f6a2e$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $9aaa8518ef8f6a2e$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $9aaa8518ef8f6a2e$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $9aaa8518ef8f6a2e$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $9aaa8518ef8f6a2e$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $9aaa8518ef8f6a2e$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $9aaa8518ef8f6a2e$export$1efec95406bbe327 = 'sentry.profile_id';
const $9aaa8518ef8f6a2e$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $9aaa8518ef8f6a2e$export$b016f89ac1066ec = 'cache.hit';
const $9aaa8518ef8f6a2e$export$3110e4c3f4386399 = 'cache.key';
const $9aaa8518ef8f6a2e$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $9aaa8518ef8f6a2e$export$be7a251980e7e946 = 'http.request.method';
const $9aaa8518ef8f6a2e$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $9aaa8518ef8f6a2e$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("isIB5", function(module, exports) {
$parcel$export(module.exports, "hasSpansEnabled", function () { return $d70d6f97995f794c$export$1f70765132c3c225; });

var $i7nxO = parcelRequire("i7nxO");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $d70d6f97995f794c$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $i7nxO.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $d70d6f97995f794c$export$5008da00b1b6dee6 = $d70d6f97995f794c$export$1f70765132c3c225;

});

parcelRegister("8j0KV", function(module, exports) {
$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $60c0af2ad87a6870$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $60c0af2ad87a6870$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTransactionTraceContext", function () { return $60c0af2ad87a6870$export$4c3967a8a2f6bbd6; });
$parcel$export(module.exports, "spanToJSON", function () { return $60c0af2ad87a6870$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $60c0af2ad87a6870$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $60c0af2ad87a6870$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $60c0af2ad87a6870$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "convertSpanLinksForEnvelope", function () { return $60c0af2ad87a6870$export$cb3e3a12e0eec16c; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $60c0af2ad87a6870$export$3f7581298f56c6d7; });
$parcel$export(module.exports, "getStatusMessage", function () { return $60c0af2ad87a6870$export$e238a77ea3a8cd66; });
$parcel$export(module.exports, "addChildSpanToSpan", function () { return $60c0af2ad87a6870$export$81397d924722cc65; });
$parcel$export(module.exports, "removeChildSpanFromSpan", function () { return $60c0af2ad87a6870$export$c2a0c9438bb89d91; });
$parcel$export(module.exports, "getSpanDescendants", function () { return $60c0af2ad87a6870$export$340c5c8a13ffc680; });
$parcel$export(module.exports, "getRootSpan", function () { return $60c0af2ad87a6870$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $60c0af2ad87a6870$export$1be426a8e585c83e; });
$parcel$export(module.exports, "showSpanDropWarning", function () { return $60c0af2ad87a6870$export$d11691ff45a3e535; });

var $eM6ET = parcelRequire("eM6ET");

var $5TFFW = parcelRequire("5TFFW");

var $i7nxO = parcelRequire("i7nxO");

var $dhhBD = parcelRequire("dhhBD");

var $lkPDN = parcelRequire("lkPDN");

var $7brnw = parcelRequire("7brnw");

var $9sRth = parcelRequire("9sRth");

var $3eJmu = parcelRequire("3eJmu");

var $gTm65 = parcelRequire("gTm65");

var $2CVVa = parcelRequire("2CVVa");

var $6Cwl7 = parcelRequire("6Cwl7");

var $k1akT = parcelRequire("k1akT");
// These are aligned with OpenTelemetry trace flags
const $60c0af2ad87a6870$export$208d5b368507fb8b = 0x0;
const $60c0af2ad87a6870$export$eb571cd9b5d98de8 = 0x1;
let $60c0af2ad87a6870$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $60c0af2ad87a6870$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $60c0af2ad87a6870$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $60c0af2ad87a6870$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $60c0af2ad87a6870$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $7brnw.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $gTm65.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $60c0af2ad87a6870$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $60c0af2ad87a6870$export$5caecac1caaf3a71(span);
    return (0, $6Cwl7.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $60c0af2ad87a6870$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $60c0af2ad87a6870$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $60c0af2ad87a6870$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $60c0af2ad87a6870$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $60c0af2ad87a6870$var$ensureTimestampInSeconds(input.getTime());
    return (0, $2CVVa.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $60c0af2ad87a6870$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $60c0af2ad87a6870$export$92d8c23565496537(span) {
    if ($60c0af2ad87a6870$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($60c0af2ad87a6870$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $60c0af2ad87a6870$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $60c0af2ad87a6870$export$3f7581298f56c6d7(endTime) || undefined,
            status: $60c0af2ad87a6870$export$e238a77ea3a8cd66(status),
            op: attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $60c0af2ad87a6870$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $60c0af2ad87a6870$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $60c0af2ad87a6870$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $60c0af2ad87a6870$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $60c0af2ad87a6870$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $60c0af2ad87a6870$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $lkPDN.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $lkPDN.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $60c0af2ad87a6870$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $60c0af2ad87a6870$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $60c0af2ad87a6870$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$60c0af2ad87a6870$var$ROOT_SPAN_FIELD] || span;
    (0, $3eJmu.addNonEnumerableProperty)(childSpan, $60c0af2ad87a6870$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$60c0af2ad87a6870$var$CHILD_SPANS_FIELD]) span[$60c0af2ad87a6870$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $3eJmu.addNonEnumerableProperty)(span, $60c0af2ad87a6870$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $60c0af2ad87a6870$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$60c0af2ad87a6870$var$CHILD_SPANS_FIELD]) span[$60c0af2ad87a6870$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $60c0af2ad87a6870$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($60c0af2ad87a6870$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$60c0af2ad87a6870$var$CHILD_SPANS_FIELD] ? Array.from(span[$60c0af2ad87a6870$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $60c0af2ad87a6870$export$c4c6a79b1260ca1b(span) {
    return span[$60c0af2ad87a6870$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $60c0af2ad87a6870$export$1be426a8e585c83e() {
    const carrier = (0, $5TFFW.getMainCarrier)();
    const acs = (0, $eM6ET.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $k1akT._getSpanForScope)((0, $i7nxO.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $60c0af2ad87a6870$export$d11691ff45a3e535() {
    if (!$60c0af2ad87a6870$var$hasShownSpanDropWarning) {
        (0, $9sRth.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $60c0af2ad87a6870$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $60c0af2ad87a6870$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("lkPDN", function(module, exports) {
$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $f883860edbbd11d0$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $f883860edbbd11d0$export$58f7963109c806fc; });
$parcel$export(module.exports, "SPAN_STATUS_ERROR", function () { return $f883860edbbd11d0$export$f966a0446ece71e; });
$parcel$export(module.exports, "setHttpStatus", function () { return $f883860edbbd11d0$export$2ad6630ec8164254; });
const $f883860edbbd11d0$export$136e25984ba4a383 = 0;
const $f883860edbbd11d0$export$58f7963109c806fc = 1;
const $f883860edbbd11d0$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $f883860edbbd11d0$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $f883860edbbd11d0$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $f883860edbbd11d0$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $f883860edbbd11d0$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $f883860edbbd11d0$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $f883860edbbd11d0$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("7brnw", function(module, exports) {
$parcel$export(module.exports, "setCapturedScopesOnSpan", function () { return $53aecc4345d31205$export$cddb4027e3b0dd66; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $53aecc4345d31205$export$c08fbc656a245d03; });

var $3eJmu = parcelRequire("3eJmu");
const $53aecc4345d31205$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $53aecc4345d31205$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $53aecc4345d31205$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $3eJmu.addNonEnumerableProperty)(span, $53aecc4345d31205$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $3eJmu.addNonEnumerableProperty)(span, $53aecc4345d31205$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $53aecc4345d31205$export$c08fbc656a245d03(span) {
    return {
        scope: span[$53aecc4345d31205$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$53aecc4345d31205$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("6Cwl7", function(module, exports) {
$parcel$export(module.exports, "TRACEPARENT_REGEXP", function () { return $4d1f60a4460a899b$export$394a210812ba3012; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $4d1f60a4460a899b$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $4d1f60a4460a899b$export$f35d907436da45cf; });

var $en7rT = parcelRequire("en7rT");

var $j8ubf = parcelRequire("j8ubf");

var $gTm65 = parcelRequire("gTm65");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $4d1f60a4460a899b$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $4d1f60a4460a899b$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($4d1f60a4460a899b$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $4d1f60a4460a899b$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $4d1f60a4460a899b$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $j8ubf.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $gTm65.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $4d1f60a4460a899b$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $4d1f60a4460a899b$export$f35d907436da45cf(traceId = (0, $gTm65.generateTraceId)(), spanId = (0, $gTm65.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $4d1f60a4460a899b$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $en7rT.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $en7rT.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("en7rT", function(module, exports) {
$parcel$export(module.exports, "parseSampleRate", function () { return $a768fddffea73ae4$export$a5bd2d81656d9546; });
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $a768fddffea73ae4$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});

parcelRegister("j8ubf", function(module, exports) {
$parcel$export(module.exports, "SENTRY_BAGGAGE_KEY_PREFIX", function () { return $dee62cde3895daae$export$6e69537d67fa20f; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $dee62cde3895daae$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $dee62cde3895daae$export$56766feef403f365; });

var $e6nMd = parcelRequire("e6nMd");

var $86GZW = parcelRequire("86GZW");

var $9sRth = parcelRequire("9sRth");
const $dee62cde3895daae$export$6e69537d67fa20f = 'sentry-';
const $dee62cde3895daae$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $dee62cde3895daae$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $dee62cde3895daae$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $dee62cde3895daae$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($dee62cde3895daae$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($dee62cde3895daae$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $dee62cde3895daae$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$dee62cde3895daae$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $dee62cde3895daae$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $dee62cde3895daae$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $86GZW.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $dee62cde3895daae$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $dee62cde3895daae$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $dee62cde3895daae$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $dee62cde3895daae$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $dee62cde3895daae$export$bdd844ddb2def819) {
            (0, $e6nMd.DEBUG_BUILD) && (0, $9sRth.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});










parcelRegister("h9TyE", function(module, exports) {
$parcel$export(module.exports, "TrelloUrlScrubber", function () { return $05be387b5363ecae$export$6177d4ea0363b1de; });
const $05be387b5363ecae$var$routeTypes = {
    BOARD: 'board',
    BOARD_BUTLER: 'board-butler',
    BOARD_BUTLER_PAGE: 'board-butler-page',
    BOARD_RECOMMEND: 'board-recommend',
    CARD: 'card',
    ENTERPRISE_ADMIN: 'enterprise-admin',
    ENTERPRISE_ADMIN_TAB: 'enterprise-admin-tab',
    ENTERPRISE_ADMIN_TAB_SUBSECTION: 'enterprise-admin-tab-subsection',
    HOME: 'home',
    TEMPLATES: 'templates',
    TEMPLATES_CATEGORIES: 'templates-categories',
    TEMPLATES_STORY: 'templates-story',
    TEMPLATES_RECOMMEND: 'templates-recommend',
    TEMPLATES_SUBMIT: 'templates-submit',
    TEMPLATE: 'template',
    USER: 'user',
    USER_TABS: 'user-tabs',
    USER_CARDS_WORKSPACE: 'user-cards-workspace',
    VIEW: 'view',
    WORKSPACE: 'workspace',
    WORKSPACE_SECTION: 'workspace-section',
    WORKSPACE_MEMBERS_SUBSECTION: 'workspace-members-subsection',
    WORKSPACE_VIEWS_SUBSECTION: 'workspace-views-subsection',
    POWER_UPS_HOME: 'power-ups-home',
    POWER_UPS_ALL: 'power-ups-all',
    POWER_UPS_TRELLO: 'power-ups-trello',
    POWER_UPS_CATEGORIES: 'power-ups-categories',
    UPGRADE_TEAM: 'select-team-to-upgrade',
    SHORTCUTS: 'shortcuts'
};
// Trello indices of non UGC/PII in the pathname depending on their route type
const $05be387b5363ecae$var$ALLOWLIST_INDICES = {
    ROUTE_IDENTIFIER: 0,
    ROUTE_SHORTLINK: 1,
    B_ROUTE_BUTLER: 3,
    B_ROUTE_BUTLER_PAGE: 4,
    B_ROUTE_RECOMMEND: 4,
    E_ROUTE_ADMIN: 2,
    E_ROUTE_ADMIN_TAB_NAME: 3,
    E_ROUTE_ADMIN_TAB_SUBSECTION_NAME: 4,
    POWER_UPS_ROUTE_PAGE: 1,
    POWER_UPS_ROUTE_CATEGORY: 1,
    POWER_UPS_ROUTE_CATEGORY_NAME: 2,
    TEMPLATES_ROUTE_PAGE: 1,
    TEMPLATES_ROUTE_CATEGORY: 1,
    TEMPLATES_ROUTE_TEMPLATE_NAME: 2,
    TEMPLATES_ROUTE_RECOMMEND: 4,
    U_ROUTE_TAB_NAME: 2,
    W_ROUTE_PAGE: 2,
    W_ROUTE_PAGE_SUBSECTION: 3
};
const $05be387b5363ecae$var$routePatternMap = new Map([
    [
        $05be387b5363ecae$var$routeTypes.BOARD_RECOMMEND,
        {
            id: $05be387b5363ecae$var$routeTypes.BOARD_RECOMMEND,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/([^/]+)/recommend$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.B_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.BOARD_BUTLER_PAGE,
        {
            id: $05be387b5363ecae$var$routeTypes.BOARD_BUTLER_PAGE,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/butler/(rules|card-buttons|board-buttons|schedule|on-dates|connected-apps)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER_PAGE
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.BOARD_BUTLER,
        {
            id: $05be387b5363ecae$var$routeTypes.BOARD_BUTLER,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/butler/$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.BOARD,
        {
            id: $05be387b5363ecae$var$routeTypes.BOARD,
            regExp: new RegExp('^/b/([^/]+)(?:/(.*?))?$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.CARD,
        {
            id: $05be387b5363ecae$var$routeTypes.CARD,
            regExp: new RegExp('^/c/'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
        {
            id: $05be387b5363ecae$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
            regExp: new RegExp('^/e/([^/]+)/admin/(members|workspaces|boards)/(managed|boardguests|deactivated|non-enterprise|pending|public)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_SUBSECTION_NAME
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.ENTERPRISE_ADMIN_TAB,
        {
            id: $05be387b5363ecae$var$routeTypes.ENTERPRISE_ADMIN_TAB,
            regExp: new RegExp('^/e/([^/]+)/admin/(members|workspaces|settings|attachment-restrictions|boards|power-ups|auditlog|account-administration|sso|api-tokens)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.ENTERPRISE_ADMIN,
        {
            id: $05be387b5363ecae$var$routeTypes.ENTERPRISE_ADMIN,
            regExp: new RegExp('^/e/([^/]+)/admin$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.POWER_UPS_HOME,
        {
            id: $05be387b5363ecae$var$routeTypes.POWER_UPS_HOME,
            regExp: new RegExp('^/power-ups$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.POWER_UPS_ALL,
        {
            id: $05be387b5363ecae$var$routeTypes.POWER_UPS_ALL,
            regExp: new RegExp('^/power-ups/all$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.POWER_UPS_TRELLO,
        {
            id: $05be387b5363ecae$var$routeTypes.POWER_UPS_TRELLO,
            regExp: new RegExp('^/power-ups/made-by-trello$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.POWER_UPS_CATEGORIES,
        {
            id: $05be387b5363ecae$var$routeTypes.POWER_UPS_CATEGORIES,
            regExp: new RegExp('^/power-ups/category/(automation|analytics-reporting|board-utilities|communication-collaboration|developer-tools|file-management|hr-operations|it-project-management|marketing-social-media|product-design|sales-support)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY_NAME
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.HOME,
        {
            id: $05be387b5363ecae$var$routeTypes.HOME,
            regExp: new RegExp('^/$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.UPGRADE_TEAM,
        {
            id: $05be387b5363ecae$var$routeTypes.UPGRADE_TEAM,
            regExp: new RegExp('^/select-team-to-upgrade$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.SHORTCUTS,
        {
            id: $05be387b5363ecae$var$routeTypes.SHORTCUTS,
            regExp: new RegExp('^/shortcuts$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.TEMPLATES_SUBMIT,
        {
            id: $05be387b5363ecae$var$routeTypes.TEMPLATES_SUBMIT,
            regExp: new RegExp('^/templates/submit$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_PAGE
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.TEMPLATES_RECOMMEND,
        {
            id: $05be387b5363ecae$var$routeTypes.TEMPLATES_RECOMMEND,
            regExp: new RegExp('^/templates/([^/]+)/([^/]+)/([^/]+)/recommend$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.TEMPLATES_CATEGORIES,
        {
            id: $05be387b5363ecae$var$routeTypes.TEMPLATES_CATEGORIES,
            regExp: new RegExp('^/templates/(business|design|education|engineering|marketing|operations-hr|personal|productivity|product-management|project-management|remote-work|sales|support|team-management)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.TEMPLATES_STORY,
        {
            id: $05be387b5363ecae$var$routeTypes.TEMPLATES_STORY,
            regExp: new RegExp('^/templates/([^/]+)/([^/]+)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.TEMPLATES,
        {
            id: $05be387b5363ecae$var$routeTypes.TEMPLATES,
            regExp: new RegExp('^/templates$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.USER_CARDS_WORKSPACE,
        {
            id: $05be387b5363ecae$var$routeTypes.USER_CARDS_WORKSPACE,
            regExp: new RegExp('^/u/([^/]+)/cards/([^/]+)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.USER_TABS,
        {
            id: $05be387b5363ecae$var$routeTypes.USER_TABS,
            regExp: new RegExp('^/u/([^/]+)/(profile|activity|boards|cards|labs|tasks)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.USER,
        {
            id: $05be387b5363ecae$var$routeTypes.USER,
            regExp: new RegExp('^/u/'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.VIEW,
        {
            id: $05be387b5363ecae$var$routeTypes.VIEW,
            regExp: new RegExp('^/v/'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.WORKSPACE_SECTION,
        {
            id: $05be387b5363ecae$var$routeTypes.WORKSPACE_SECTION,
            regExp: new RegExp('^/w/([^/]+)/(account|billing|home|export|free-trial|members|tables|getting-started|highlights|reports)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.W_ROUTE_PAGE
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
        {
            id: $05be387b5363ecae$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
            regExp: new RegExp('^/w/([^/]+)/members/(guests|requests)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
        {
            id: $05be387b5363ecae$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
            regExp: new RegExp('^/w/([^/]+)/views/(table|calendar|)$'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $05be387b5363ecae$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $05be387b5363ecae$var$routeTypes.WORKSPACE,
        {
            id: $05be387b5363ecae$var$routeTypes.WORKSPACE,
            regExp: new RegExp('^/w/'),
            allowlist: [
                $05be387b5363ecae$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ]
]);
class $05be387b5363ecae$export$6177d4ea0363b1de {
    static _determineRoute(urlPathname) {
        const routePatternArray = Array.from($05be387b5363ecae$var$routePatternMap.values());
        for (const routeDefinition of routePatternArray){
            if (routeDefinition.regExp.exec(urlPathname)) return routeDefinition;
        }
        return null;
    }
    // reconstructs the pathname to include sections that do NOT include UGC/PII
    static _reconstructPathname(pathnameSections, sectionsToKeep) {
        let reconstructedUrl = '';
        for(let i = 0; i < pathnameSections.length; i++)if (sectionsToKeep.includes(i)) reconstructedUrl += '/' + pathnameSections[i];
        return reconstructedUrl;
    }
    // finds the matching route for the pathname we want to include in our marketing
    // analytics and then sanitizes it of UGC/PII
    static scrubUrl(urlPathname, defaultPathname) {
        const matchingRoute = $05be387b5363ecae$export$6177d4ea0363b1de._determineRoute(urlPathname);
        // remove starting slash to allow matchers to use ^ properly
        const partialUrl = urlPathname.substring(1, urlPathname.length);
        const pathnameSections = partialUrl.split('/');
        // to avoid UGC/PII related HOTs, we should be extra cautious & return a
        // generic path for URLs that don't follow a known pattern
        return matchingRoute ? $05be387b5363ecae$export$6177d4ea0363b1de._reconstructPathname(pathnameSections, matchingRoute.allowlist) : defaultPathname;
    }
}

});


parcelRegister("1P8AQ", function(module, exports) {
$parcel$export(module.exports, "MetricKey", function () { return $672cd6aa24713a68$export$4657ae8822aeedd; });
$parcel$export(module.exports, "Metrics", function () { return $672cd6aa24713a68$export$ed9166ec0f465b5e; });
/**
 * Module for segment metrics tracking events.
 * @module Metrics
 */ 
var $cYY9z = parcelRequire("cYY9z");

var $fKfE1 = parcelRequire("fKfE1");

var $fLpER = parcelRequire("fLpER");

var $i0bD5 = parcelRequire("i0bD5");

var $92PV0 = parcelRequire("92PV0");
var $672cd6aa24713a68$export$4657ae8822aeedd = /*#__PURE__*/ function(MetricKey) {
    MetricKey["TIME_TO_LOAD"] = "timeToLoad";
    MetricKey["TIME_TO_SEGMENT_LOAD"] = "timeToSegmentLoad";
    MetricKey["TIME_TO_AVAILABLE"] = "timeToAvailable";
    MetricKey["TIME_TO_READY"] = "timeToReady";
    MetricKey["TIME_TO_START_LOAD_XID"] = "timeToStartLoadXID";
    MetricKey["TIME_TO_START_GET_XID"] = "timeToStartGetXID";
    MetricKey["TIME_TO_LOAD_XID"] = "timeToLoadXID";
    return MetricKey;
}({});
class $672cd6aa24713a68$export$ed9166ec0f465b5e {
    static #_ = this.metricsData = {};
    /**
   * Store the value of a single performance metric
   * @function logMetrics
   * @param {MetricKey} metricKey - the metric to log
   * @param {number} mockDate - a mock timestamp
   */ static logMetric(metricKey, mockDate) {
        $672cd6aa24713a68$export$ed9166ec0f465b5e.metricsData[metricKey] = mockDate || Date.now();
    }
    static setLoadTimestamp(loadTimestamp) {
        $672cd6aa24713a68$export$ed9166ec0f465b5e.loadTimestamp = loadTimestamp;
    }
    /**
   * Logs an performance metrics track call to segment via the HTTP API
   * @function sendMetrics
   * @param {object} mockReq used in testing so we don't actually send anything to Segment
   */ static sendMetrics(mockReq) {
        const loadTimestamp = $672cd6aa24713a68$export$ed9166ec0f465b5e.loadTimestamp;
        if (!loadTimestamp) return;
        // calculate all of the times
        Object.entries($672cd6aa24713a68$export$ed9166ec0f465b5e.metricsData).forEach(([key, value])=>{
            if (value > 0) // Todo .. should this be > loadTimestamp ??
            $672cd6aa24713a68$export$ed9166ec0f465b5e.metricsData[key] = value - loadTimestamp;
        });
        const cohort = (0, $fKfE1.Cohort).readAtlCohort();
        const properties = {
            event: 'metrics',
            eventComponent: 'atlGlobal',
            metrics: $672cd6aa24713a68$export$ed9166ec0f465b5e.metricsData,
            atlJSVersion: (0, $cYY9z.AnalyticsState).version,
            cohort: cohort ? cohort.bucketAll.index : null,
            host: mockReq ? mockReq.hostFake : window.location.host,
            path: mockReq ? mockReq.pathFake : (0, $i0bD5.Helpers).dropEmailFromPath(window.location.pathname),
            pageViewId: (0, $92PV0.Tracking).getPageViewId() // used to tie to other events
        };
        (0, $fLpER.GASv3).sendUIEvent('', properties, true);
        $672cd6aa24713a68$export$ed9166ec0f465b5e.resetMetrics();
    }
    // testing only
    static resetMetrics() {
        $672cd6aa24713a68$export$ed9166ec0f465b5e.metricsData = {};
    }
}

});


parcelRegister("6jJHH", function(module, exports) {
$parcel$export(module.exports, "isTab", function () { return $1c86e48bee23314f$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $1c86e48bee23314f$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $1c86e48bee23314f$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $1c86e48bee23314f$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $1c86e48bee23314f$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $1c86e48bee23314f$export$519ada94592b97fc; });

var $1oC0p = parcelRequire("1oC0p");
function $1c86e48bee23314f$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $1c86e48bee23314f$export$bdc9792d96913679 = $1c86e48bee23314f$var$makeTypeChecker('Adg4Tab');
const $1c86e48bee23314f$export$9c326233b9ae5588 = $1c86e48bee23314f$var$makeTypeChecker('Adg4TabList');
const $1c86e48bee23314f$export$9e12445c79db89b = $1c86e48bee23314f$var$makeTypeChecker('Adg4TabPanel');
const $1c86e48bee23314f$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === 'function';
function $1c86e48bee23314f$var$isTabChild(child) {
    return $1c86e48bee23314f$export$bdc9792d96913679(child) || $1c86e48bee23314f$export$9c326233b9ae5588(child) || $1c86e48bee23314f$export$9e12445c79db89b(child);
}
function $1c86e48bee23314f$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($1c86e48bee23314f$export$dbaa4172856e20ab(child)) return (0, $1oC0p.cloneElement)(child, {
        ...child.props,
        ...additionalProps
    });
    return child;
}
function $1c86e48bee23314f$export$ce7eaaed37329a1b(children, callback) {
    return (0, $1oC0p.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($1c86e48bee23314f$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === 'object') // Clone the child that has children and map them too
        return (0, $1oC0p.cloneElement)(child, {
            ...child.props,
            children: $1c86e48bee23314f$export$ce7eaaed37329a1b(child.props.children, callback)
        });
        return child;
    });
}
function $1c86e48bee23314f$export$519ada94592b97fc(children, callback) {
    return (0, $1oC0p.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($1c86e48bee23314f$export$bdc9792d96913679(child) || $1c86e48bee23314f$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === 'object') {
            if ($1c86e48bee23314f$export$9c326233b9ae5588(child)) callback(child, index);
            $1c86e48bee23314f$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});


parcelRegister("2Y4QO", function(module, exports) {
$parcel$export(module.exports, "Megaphone", function () { return $86e6885e3dfd6a28$export$79c66221ddbb3eb1; });

var $7VQPk = parcelRequire("7VQPk");
const $86e6885e3dfd6a28$export$79c66221ddbb3eb1 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "none",
        id: "icon-megaphone",
        width: size,
        height: size,
        version: "1.1",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.5166 8.72656L16.2433 11.6366V19.3966L23.5166 22.3066V8.72656Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.1066 12.1201V18.9001H14.3033V23.2734H11.3933V18.9001H8.48328V12.1201H18.1066Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.1066 12.1201H16.2433V18.8968H18.1066V12.1201Z",
                fill: "#AE2A19"
            })
        ]
    });

});

parcelRegister("a2Szx", function(module, exports) {
$parcel$export(module.exports, "Notepad", function () { return $f3b554fd30efc8a6$export$223f1f409e24a208; });

var $7VQPk = parcelRequire("7VQPk");
const $f3b554fd30efc8a6$export$223f1f409e24a208 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "none",
        id: "icon-notepad",
        width: size,
        height: size,
        version: "1.1",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.67 10.3564H8.02332V23.9998H21.6666V10.3564H21.67ZM10.95 14.7431H18.7466V13.2798H10.95V14.7431ZM10.95 17.9098H18.7466V16.4464H10.95V17.9098ZM15.8233 21.0764H10.95V19.6131H15.8233V21.0764Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.9833 15.1633L16 16L16.8367 13.0167L24.2767 5.57666L26.4233 7.72333L18.9833 15.1633Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.4967 10.3564L16.8367 13.0164L16.7633 13.2798H18.7467V14.7431H16.3533L16 15.9998L18.9833 15.1631L21.67 12.4764V10.3564H19.4967Z",
                fill: "#09326C"
            })
        ]
    });

});

parcelRegister("4HcEI", function(module, exports) {
$parcel$export(module.exports, "Rocket", function () { return $90f7e6af9f224437$export$c622ac6ddd491a46; });

var $7VQPk = parcelRequire("7VQPk");
const $90f7e6af9f224437$export$c622ac6ddd491a46 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 33",
        fill: "none",
        id: "icon-rocket",
        width: size,
        height: size,
        version: "1.1",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.1933 16.3702L13.3067 14.2568L11.1933 12.1435L12.9567 10.3802H17.1867L20.36 7.20685H25.2933V12.1402L22.12 15.3135V19.5435L20.3567 21.3068L18.2433 19.1935L16.13 21.3068L14.1933 19.3702L16.5133 17.0502L15.4567 15.9935L13.1367 18.3135L11.1967 16.3735L11.1933 16.3702ZM22.8233 11.4368C22.3367 11.9235 21.5467 11.9235 21.06 11.4368C20.5733 10.9502 20.5733 10.1602 21.06 9.67351C21.5467 9.18685 22.3367 9.18685 22.8233 9.67351C23.31 10.1602 23.31 10.9502 22.8233 11.4368Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.8133 22.2068C14.69 24.3302 11.7067 25.7535 6.75333 25.6468C6.64333 20.6935 8.06667 17.7135 10.1933 15.5868C12.14 13.6402 15.17 13.2202 18.2233 14.1735C19.1767 17.2268 18.76 20.2568 16.81 22.2035L16.8133 22.2068Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.4367 19.3802L18.2467 19.1902L16.13 21.3035L14.1933 19.3669L16.5133 17.0469L15.4567 15.9902L13.1367 18.3102L11.1967 16.3702L13.31 14.2535L13.02 13.9635C14.5967 13.5235 16.4067 13.6069 18.2267 14.1735C18.7933 15.9935 18.8767 17.8035 18.4367 19.3802Z",
                fill: "#09326C"
            })
        ]
    });

});

parcelRegister("cLuPb", function(module, exports) {
$parcel$export(module.exports, "ContentTypeVideo", function () { return $b9513ca6b04aaf10$export$fcfc83b800268bb4; });
/* content-type-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $ep4tq = parcelRequire("ep4tq");

var $iyOcM = parcelRequire("iyOcM");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $9D0tJ = parcelRequire("9D0tJ");
const $b9513ca6b04aaf10$var$imageStyle = null;
const $b9513ca6b04aaf10$var$reusableImageStyle = null;
const $b9513ca6b04aaf10$var$backgroundStyle = null;
const $b9513ca6b04aaf10$var$reusuablePurpleBackgroundStyle = null;
const $b9513ca6b04aaf10$var$reusuableGreenBackgroundStyle = null;
const $b9513ca6b04aaf10$var$reusuableOrangeBackgroundStyle = null;
const $b9513ca6b04aaf10$var$videoStyle = null;
const $b9513ca6b04aaf10$var$combinedVideoSizing = null;
const $b9513ca6b04aaf10$var$iconSpacingOverride = null;
const $b9513ca6b04aaf10$export$fcfc83b800268bb4 = ({ active: active, videoSrcMp4: videoSrcMp4, videoSrcWebm: videoSrcWebm, videoPreviewSrc: videoPreviewSrc, showBackground: showBackground, useSpecificBackgroundStyle: useSpecificBackgroundStyle = 'none', isUseReusableXflowFeatureInfo: isUseReusableXflowFeatureInfo = false, addPaddingAboveListInReusableXflow: addPaddingAboveListInReusableXflow = false, ...props })=>{
    const { userSelected: userSelected, goToNextTab: goToNextTab } = (0, $iyOcM.useAdg4TabsContext)();
    const { ref: containerRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        initialInView: true,
        threshold: 0.3
    });
    const videoRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    (0, $1oC0p.useEffect)(()=>{
        if (sectionIsVisible && active && videoRef.current && videoRef.current.play) {
            videoRef.current.autoplay = true;
            videoRef.current.currentTime = 0;
            videoRef.current.play().catch(()=>{
            // Ignore error likely due to autoplay restrictions
            });
        } else if (!active || !sectionIsVisible) {
            if (videoRef.current?.paused) return;
            videoRef.current?.pause();
        }
    }, [
        active,
        videoRef,
        sectionIsVisible
    ]);
    const FeatureInfoImageAndVideo = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            isUseReusableXflowFeatureInfo ? "_1rjct7po _18zr16gx _kqswh2mm _1pbykb7n" : "_85i51tcg _26vx1tcg _d2ik1tcg",
            showBackground && useSpecificBackgroundStyle === 'none' && "_1kt9b3bt _1rusodbs _1cs8stnw _qnec1hnc _1aukidpf _1mp411be _kfgt1osq _1g0v1mrw _tgsmyvst _11r71lk2 _1c9g1ghs _aw8s3pft _9n3r13va _8n7u1vuk _16ho16gx _b4lq13sl _lu7ho2qy _1kgg1w8u _1res9by0 _1hup12it _1knvgojt _11bbglyw _aetrb3bt _3p6mvjx7 _18postnw _19do1avk _1x881h6c _z0ai1iyx _1qdgypwq _idl91r5k _15cz1x1l _maqlscyu _j9q0qdsu _184p1nuc _15i6obt3 _jw3xx19p _1f4cyrmy _1606p1rm _1y3iglyw",
            showBackground && useSpecificBackgroundStyle === 'purple' && "_1kt9b3bt _1rus1l60 _1cs8stnw _z5wtidpf _iajmidpf _1mp41osq _kfgt1osq _1g0v1mrw _tgsm1x17",
            showBackground && useSpecificBackgroundStyle === 'green' && "_1kt9b3bt _1rusodbs _1cs8stnw _z5wtidpf _iajmidpf _1mp41osq _kfgt1osq _1g0v1mrw _tgsmhz6d",
            showBackground && useSpecificBackgroundStyle === 'orange' && "_1kt9b3bt _1rusuol8 _1cs8stnw _z5wtbz2e _iajmidpf _1mp41vuk _kfgt1osq _1g0v1mrw _tgsm8z3g"
        ]),
        style: {
            "--_5p9fny": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.lime')),
            "--_gc8zf8": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.purple')),
            "--_td2gmy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.saffron'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ep4tq.Adg4RaisedMedia), {
            className: isUseReusableXflowFeatureInfo ? 'reusable-xflow-video' : '',
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _tnru9hbq _1vkh1xbk _1dny1wug _1lxi1wug",
                    isUseReusableXflowFeatureInfo ? 'reusable' : ''
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                    playsInline: true,
                    muted: true,
                    preload: "auto",
                    poster: videoPreviewSrc,
                    autoPlay: !!active,
                    loop: userSelected,
                    ref: videoRef,
                    onEnded: ()=>{
                        if (!userSelected && !isUseReusableXflowFeatureInfo) goToNextTab();
                    },
                    // Use onLoadedMetadata to trigger a Safari autplay workaround
                    onLoadedMetadata: (videoEvent)=>{
                        if (!active) return;
                        try {
                            videoEvent.currentTarget.currentTime = 0; // Set currentTime to workaround Safari not autplaying
                            if (videoEvent.currentTarget.parentElement) videoEvent.currentTarget.play().catch(()=>false); // Call play() as backup to ensure the video is playing
                        } catch (error) {
                            console.log('Error calling play method on video after onCanPlay is invoked.');
                        }
                    },
                    className: (0, $2jatx.default)([
                        "_p12f1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoSrcMp4,
                            type: `video/mp4`
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoSrcWebm,
                            type: `video/webm`
                        })
                    ]
                })
            })
        })
    });
    return isUseReusableXflowFeatureInfo ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_pi1jftgi _w0qwidpf _8lhc1crf _1lre1osq _10mf1wug _1ya5idpf _445tidpf",
            "tab-content-image-container"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9D0tJ.FeatureInfo), {
            ...props,
            reverseLayout: true,
            children: FeatureInfoImageAndVideo
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9D0tJ.FeatureInfo), {
        ...props,
        reverseLayout: true,
        children: FeatureInfoImageAndVideo
    });
};

});
parcelRegister("2jatx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1ae57b53715547f1$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $1ae57b53715547f1$var$ATOMIC_GROUP_LENGTH = 5;
function $1ae57b53715547f1$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $1ae57b53715547f1$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("6ZVlx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5184ec66eabfc53e$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $5184ec66eabfc53e$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("ep4tq", function(module, exports) {
$parcel$export(module.exports, "Adg4RaisedMedia", function () { return $a8655f617dfdbc3c$export$bfa1278d9934b266; });
/* raised-media.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $a8655f617dfdbc3c$var$raisedImage = null;
const $a8655f617dfdbc3c$export$bfa1278d9934b266 = ({ className: className, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_16qs1qw3 _2rko1crf _1e0c1txw _1reo15vq _18m915vq",
            className
        ]),
        children: children
    });
};

});

parcelRegister("kbpa7", function(module, exports) {
$parcel$export(module.exports, "wacToken", function () { return (parcelRequire("bNzAT")).default; });
$parcel$export(module.exports, "ColumnLayout", function () { return (parcelRequire("wjvXx")).ColumnLayout; });
$parcel$export(module.exports, "SubColumnLayout", function () { return (parcelRequire("wjvXx")).SubColumnLayout; });

var $wjvXx = parcelRequire("wjvXx");

var $bNzAT = parcelRequire("bNzAT");

});
parcelRegister("wjvXx", function(module, exports) {
$parcel$export(module.exports, "ColumnLayout", function () { return $81d29aa81524eb4c$export$c7e5bac7049eee2a; });
$parcel$export(module.exports, "SubColumnLayout", function () { return $81d29aa81524eb4c$export$12bf7d6826410442; });
/* column-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $i4BST = parcelRequire("i4BST");
const $81d29aa81524eb4c$var$baseStyle = null;
const $81d29aa81524eb4c$var$fullWidthStyles = null;
const $81d29aa81524eb4c$var$xlDesktopBreakpointStyles = null;
const $81d29aa81524eb4c$var$layout10 = null;
const $81d29aa81524eb4c$var$layout8 = null;
const $81d29aa81524eb4c$var$layout84 = null;
const $81d29aa81524eb4c$var$layout48 = null;
const $81d29aa81524eb4c$var$layout93 = null;
const $81d29aa81524eb4c$var$layout39 = null;
const $81d29aa81524eb4c$var$layout66 = null;
const $81d29aa81524eb4c$var$layout75 = null;
const $81d29aa81524eb4c$var$layout57 = null;
const $81d29aa81524eb4c$var$layout336 = null;
const $81d29aa81524eb4c$var$layout633 = null;
const $81d29aa81524eb4c$var$layout444 = null;
const $81d29aa81524eb4c$var$layout3333 = null;
const $81d29aa81524eb4c$var$layout222222 = null;
const $81d29aa81524eb4c$var$layoutArticle = null;
const $81d29aa81524eb4c$var$layoutOverlay = null;
const $81d29aa81524eb4c$var$tabletLayout12 = null;
const $81d29aa81524eb4c$var$tabletLayout10 = null;
const $81d29aa81524eb4c$var$tabletLayout66 = null;
const $81d29aa81524eb4c$var$tabletLayout444 = null;
const $81d29aa81524eb4c$var$tabletLayout84 = null;
const $81d29aa81524eb4c$var$tabletLayout48 = null;
const $81d29aa81524eb4c$var$tabletLayout75 = null;
const $81d29aa81524eb4c$var$tabletLayout57 = null;
const $81d29aa81524eb4c$var$tabletLayout1266 = null;
const $81d29aa81524eb4c$var$tabletLayout6612 = null;
const $81d29aa81524eb4c$var$mobileLayout12 = null;
const $81d29aa81524eb4c$var$mobileLayout66 = null;
const $81d29aa81524eb4c$var$mobileLayout1266 = null;
const $81d29aa81524eb4c$var$mobileLayout6612 = null;
const $81d29aa81524eb4c$var$resetListStyles = null;
const $81d29aa81524eb4c$var$mobileReverseOrderStyles = null;
const $81d29aa81524eb4c$export$c7e5bac7049eee2a = ({ layout: layout = '12', tabletLayout: tabletLayout, mobileLayout: mobileLayout, paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = 'normal', horizontalAlignment: horizontalAlignment = 'normal', renderAsList: renderAsList, mobileReverseOrder: mobileReverseOrder = false, children: children })=>{
    const paddingTopObject = {
        // @ts-ignore
        mobile: paddingTopv2?.mobile ?? paddingTopv2 ?? '0',
        tablet: // @ts-ignore
        paddingTopv2?.tablet ?? paddingTopv2?.mobile ?? paddingTopv2 ?? '0',
        desktop: // @ts-ignore
        paddingTopv2?.desktop ?? // @ts-ignore
        paddingTopv2?.tablet ?? // @ts-ignore
        paddingTopv2?.mobile ?? paddingTopv2 ?? '0'
    };
    const paddingBottomObject = {
        // @ts-ignore
        mobile: paddingBottomv2?.mobile ?? paddingBottomv2 ?? '0',
        tablet: // @ts-ignore
        paddingBottomv2?.tablet ?? // @ts-ignore
        paddingBottomv2?.mobile ?? paddingBottomv2 ?? '0',
        desktop: // @ts-ignore
        paddingBottomv2?.desktop ?? // @ts-ignore
        paddingBottomv2?.tablet ?? // @ts-ignore
        paddingBottomv2?.mobile ?? paddingBottomv2 ?? '0'
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList ?? 'div';
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)(Container, {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            renderAsList && "_qtt815ep _bozgidpf _1mouidpf _1xtx1txw _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            "_195g1wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
            isWacRefresh && "_12z7bv7e _14mbbv7e _1i7q107j",
            "_1q51qdoc _85i51h9o _1wafnu5b _1yd319pc _26vxu0xk _40tu9cm2",
            "_4cvr1ekp _1bahghyw",
            mobileReverseOrder && "_14ls11wp _pecscs5v _xt6dkb7n",
            layout === '10' && "_1j8bcx6w _klsv179g",
            layout === '8' && "_1j8bcx6w _klsveqnf",
            layout === '8-4' && "_19smexmx _1j8b1890",
            layout === '4-8' && "_19smexmx _1j8bi0c8",
            layout === '9-3' && "_1i4gqiai _1j8b1i9f",
            layout === '3-9' && "_1i4gqiai _1j8bvfzv",
            layout === '7-5' && "_13wb12kr _1j8bkxgm",
            layout === '5-7' && "_13wb12kr _1j8bdq95",
            layout === '6-6' && "_1j8bwxkt",
            layout === '4-4-4' && "_1j8b16hb",
            layout === '3-3-3-3' && "_1j8bwxkt _1rqt1ezz",
            layout === '2-2-2-2-2-2' && "_yv0ewxkt _1j8b1g7m",
            layout === '6-3-3' && "_1i4gqiai _1j8b1jr3",
            layout === '3-3-6' && "_1i4gqiai _1j8bmdi6",
            layout === 'article' && "_z9r4exmx _1rqti0c8",
            layout === 'overlay' && "_yv0ecx6w",
            tabletLayout && tabletLayout === '12' && "_1da7n7od _ju75n7od",
            tabletLayout && tabletLayout === '10' && "_1da7cx6w _ju75179g",
            tabletLayout && tabletLayout === '6-6' && "_1da7wxkt",
            tabletLayout && tabletLayout === '4-4-4' && "_1da716hb",
            tabletLayout && tabletLayout === '8-4' && "_rcp0exmx _1da71890",
            tabletLayout && tabletLayout === '4-8' && "_rcp0exmx _1da7i0c8",
            tabletLayout && tabletLayout === '7-5' && "_osdn12kr _1da7kxgm",
            tabletLayout && tabletLayout === '5-7' && "_osdn12kr _1da7dq95",
            tabletLayout && tabletLayout === '12, 6-6' && "_1da7cx6w _xkuwuufb _1p8l1xic",
            tabletLayout && tabletLayout === '6-6, 12' && "_1da7cx6w _10chuufb _1f0v1xic",
            mobileLayout && mobileLayout === '12' && "_19d7n7od _kw77n7od",
            mobileLayout && mobileLayout === '6-6' && "_19d7wxkt",
            mobileLayout && mobileLayout === '12, 6-6' && "_19d7cx6w _17y1uufb _17541xic",
            mobileLayout && mobileLayout === '6-6, 12' && "_19d7cx6w _yu5luufb _18kp1xic"
        ]),
        style: {
            "--_1tx57ax": (0, $6ZVlx.default)('var(--ds-space-' + paddingTopObject.mobile + ')'),
            "--_1adzvs4": (0, $6ZVlx.default)('var(--ds-space-' + paddingBottomObject.mobile + ')'),
            "--_1rzbai": (0, $6ZVlx.default)('var(--ds-space-' + paddingTopObject.tablet + ')'),
            "--_cwvv9f": (0, $6ZVlx.default)('var(--ds-space-' + paddingBottomObject.tablet + ')'),
            "--_wyz0lv": (0, $6ZVlx.default)('var(--ds-space-' + paddingTopObject.desktop + ')'),
            "--_1obwbb5": (0, $6ZVlx.default)('var(--ds-space-' + paddingBottomObject.desktop + ')'),
            "--_1813xhc": (0, $6ZVlx.default)(verticalAlignment),
            "--_1p6jxu0": (0, $6ZVlx.default)(horizontalAlignment)
        },
        children: children
    });
};
const $81d29aa81524eb4c$export$12bf7d6826410442 = ({ layout: layout = '12', tabletLayout: tabletLayout, mobileLayout: mobileLayout, paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = 'normal', renderAsList: renderAsList, mobileReverseOrder: mobileReverseOrder = false, children: children })=>{
    const paddingTopObject = {
        // @ts-ignore
        mobile: paddingTopv2?.mobile ?? '0',
        // @ts-ignore
        tablet: paddingTopv2?.tablet ?? paddingTopv2?.mobile ?? '0',
        desktop: // @ts-ignore
        paddingTopv2?.desktop ?? // @ts-ignore
        paddingTopv2?.tablet ?? // @ts-ignore
        paddingTopv2?.mobile ?? '0'
    };
    const paddingBottomObject = {
        // @ts-ignore
        mobile: paddingBottomv2?.mobile ?? '0',
        // @ts-ignore
        tablet: paddingBottomv2?.tablet ?? paddingBottomv2?.mobile ?? '0',
        // @ts-ignore
        desktop: // @ts-ignore
        paddingBottomv2?.desktop ?? // @ts-ignore
        paddingBottomv2?.tablet ?? // @ts-ignore
        paddingBottomv2?.mobile ?? '0'
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList ?? 'div';
    return /*#__PURE__*/ (0, $7VQPk.jsx)(Container, {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            "_1q51qdoc _85i51h9o _1wafnu5b _1yd319pc _26vxu0xk _40tu9cm2",
            "_4cvr1ekp",
            renderAsList && "_qtt815ep _bozgidpf _1mouidpf _1xtx1txw _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            mobileReverseOrder && "_14ls11wp _pecscs5v _xt6dkb7n",
            layout === '10' && "_1j8bcx6w _klsv179g",
            layout === '8' && "_1j8bcx6w _klsveqnf",
            layout === '8-4' && "_19smexmx _1j8b1890",
            layout === '4-8' && "_19smexmx _1j8bi0c8",
            layout === '9-3' && "_1i4gqiai _1j8b1i9f",
            layout === '3-9' && "_1i4gqiai _1j8bvfzv",
            layout === '7-5' && "_13wb12kr _1j8bkxgm",
            layout === '5-7' && "_13wb12kr _1j8bdq95",
            layout === '6-6' && "_1j8bwxkt",
            layout === '4-4-4' && "_1j8b16hb",
            layout === '3-3-3-3' && "_1j8bwxkt _1rqt1ezz",
            layout === '2-2-2-2-2-2' && "_yv0ewxkt _1j8b1g7m",
            layout === '6-3-3' && "_1i4gqiai _1j8b1jr3",
            layout === '3-3-6' && "_1i4gqiai _1j8bmdi6",
            tabletLayout && tabletLayout === '12' && "_1da7n7od _ju75n7od",
            tabletLayout && tabletLayout === '10' && "_1da7cx6w _ju75179g",
            tabletLayout && tabletLayout === '6-6' && "_1da7wxkt",
            tabletLayout && tabletLayout === '4-4-4' && "_1da716hb",
            tabletLayout && tabletLayout === '8-4' && "_rcp0exmx _1da71890",
            tabletLayout && tabletLayout === '4-8' && "_rcp0exmx _1da7i0c8",
            tabletLayout && tabletLayout === '7-5' && "_osdn12kr _1da7kxgm",
            tabletLayout && tabletLayout === '5-7' && "_osdn12kr _1da7dq95",
            tabletLayout && tabletLayout === '12, 6-6' && "_1da7cx6w _xkuwuufb _1p8l1xic",
            tabletLayout && tabletLayout === '6-6, 12' && "_1da7cx6w _10chuufb _1f0v1xic",
            mobileLayout && mobileLayout === '12' && "_19d7n7od _kw77n7od",
            mobileLayout && mobileLayout === '6-6' && "_19d7wxkt",
            mobileLayout && mobileLayout === '12, 6-6' && "_19d7cx6w _17y1uufb _17541xic",
            mobileLayout && mobileLayout === '6-6, 12' && "_19d7cx6w _yu5luufb _18kp1xic"
        ]),
        style: {
            "--_1tx57ax": (0, $6ZVlx.default)('var(--ds-space-' + paddingTopObject.mobile + ')'),
            "--_1adzvs4": (0, $6ZVlx.default)('var(--ds-space-' + paddingBottomObject.mobile + ')'),
            "--_1rzbai": (0, $6ZVlx.default)('var(--ds-space-' + paddingTopObject.tablet + ')'),
            "--_cwvv9f": (0, $6ZVlx.default)('var(--ds-space-' + paddingBottomObject.tablet + ')'),
            "--_wyz0lv": (0, $6ZVlx.default)('var(--ds-space-' + paddingTopObject.desktop + ')'),
            "--_1obwbb5": (0, $6ZVlx.default)('var(--ds-space-' + paddingBottomObject.desktop + ')'),
            "--_1813xhc": (0, $6ZVlx.default)(verticalAlignment)
        },
        children: children
    });
}; // Both components are exported as named exports above

});
parcelRegister("i4BST", function(module, exports) {
$parcel$export(module.exports, "WacRefreshProvider", function () { return $f0b1df7585ebb616$export$9fac0d8112b57bab; });
$parcel$export(module.exports, "useWacRefresh", function () { return $f0b1df7585ebb616$export$861b2ebd3848bc68; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $gIKKj = parcelRequire("gIKKj");

var $7FWq8 = parcelRequire("7FWq8");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $f0b1df7585ebb616$var$WacRefreshContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    isWacRefresh: false
});
const $f0b1df7585ebb616$export$9fac0d8112b57bab = ({ isWacRefresh: isWacRefreshOverride, children: children })=>{
    const isWACRefreshGateEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacRefreshTeam26Gate);
    // Get the experiments without firing exposures.
    // Exposures are fired in the Uniform experiment container (Jira, Confluence, TWC, Rovo)
    // and in get-route.tsx (Homepage)
    const jiraExperiment = (0, $gIKKj.getExperiment)((0, $7FWq8.wacRefreshJira));
    const confluenceExperiment = (0, $gIKKj.getExperiment)((0, $7FWq8.wacRefreshConfluence));
    const homepageExperiment = (0, $gIKKj.getExperiment)((0, $7FWq8.wacRefreshHomepage));
    const twcRovoExperiment = (0, $gIKKj.getExperiment)((0, $7FWq8.wacRefreshTwcRovo));
    const wacRefreshExperimentEnabled = jiraExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && jiraExperiment.value || confluenceExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && confluenceExperiment.value || homepageExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && homepageExperiment.value || twcRovoExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && twcRovoExperiment.value;
    const value = (0, $1oC0p.useMemo)(()=>({
            isWacRefresh: isWacRefreshOverride ?? (isWACRefreshGateEnabled || wacRefreshExperimentEnabled)
        }), [
        isWacRefreshOverride,
        isWACRefreshGateEnabled,
        wacRefreshExperimentEnabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f0b1df7585ebb616$var$WacRefreshContext.Provider, {
        value: value,
        children: children
    });
};
const $f0b1df7585ebb616$export$861b2ebd3848bc68 = ()=>{
    const { isWacRefresh: isWacRefresh } = (0, $1oC0p.useContext)($f0b1df7585ebb616$var$WacRefreshContext);
    return isWacRefresh;
};

});
parcelRegister("gIKKj", function(module, exports) {
$parcel$export(module.exports, "EnrollmentType", function () { return $e63d5b4b182704d7$export$7184a614b8d5eae2; });
$parcel$export(module.exports, "useExperiment", function () { return $e63d5b4b182704d7$export$12481f4d12442b59; });
$parcel$export(module.exports, "getExperiment", function () { return $e63d5b4b182704d7$export$2f86411d819a755e; });
$parcel$export(module.exports, "getExperimentWithExposures", function () { return $e63d5b4b182704d7$export$37ab8203aaeb6e80; });

var $1oC0p = parcelRequire("1oC0p");

var $g57Lc = parcelRequire("g57Lc");

var $eY3N6 = parcelRequire("eY3N6");

var $3L8ZR = parcelRequire("3L8ZR");

var $fLpER = parcelRequire("fLpER");

var $iSeHD = parcelRequire("iSeHD");

var $gx3aw = parcelRequire("gx3aw");

var $dajtI = parcelRequire("dajtI");

var $k4D4E = parcelRequire("k4D4E");
const $e63d5b4b182704d7$export$7184a614b8d5eae2 = {
    ENROLLED: 'enrolled',
    NOT_ENROLLED: 'notEnrolled',
    INDETERMINATE: 'indeterminate'
};
function $e63d5b4b182704d7$var$getExperimentKeyValue(query, key) {
    if (!query.startsWith('?')) query = '?' + query;
    const params = new URLSearchParams(query);
    return params.get(key);
}
const $e63d5b4b182704d7$var$X_EXPERIMENTS_KEY = 'X-Experiments-Key';
function $e63d5b4b182704d7$export$12481f4d12442b59(experiment, metadata) {
    const isInCohort = experiment.targeting.cohort();
    const { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options } = experiment;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const hasFiredRef = (0, $1oC0p.useRef)(false);
    // Stabilize metadata to prevent unnecessary re-renders
    const stableMetadata = (0, $1oC0p.useMemo)(()=>metadata ?? {}, [
        metadata
    ]);
    const fireTrackingEvent = (0, $1oC0p.useCallback)((group, info)=>isInCohort ? $e63d5b4b182704d7$export$f86304593290690b(experimentName, analyticsClient, createAnalyticsEvent, {
            ...stableMetadata,
            ...info
        }, group) : ()=>console.warn(`${experimentName}: cannot fire tracking event; targeting criteria not met.`), [
        stableMetadata,
        isInCohort,
        experimentName,
        analyticsClient,
        createAnalyticsEvent
    ]);
    const experimentEnrollment = (0, $1oC0p.useMemo)(()=>{
        const status = $e63d5b4b182704d7$var$getExperimentStatus(experimentName, parameterName, defaultValue, isInCohort, options);
        if (status.type === $e63d5b4b182704d7$export$7184a614b8d5eae2.ENROLLED) return {
            ...status,
            fireExposure: ()=>{
                if (!options.fireExperimentExposure) {
                    fireTrackingEvent(status.value, {
                        usingDefault: status.usingDefault
                    });
                    try {
                        (0, $3L8ZR.default).manuallyLogExperimentExposure(experimentName);
                    } catch (error) {
                        console.warn(`Failed to fire exposure event for ${experimentName}: ${error}`);
                    }
                } else console.warn(`Exposure events for ${experimentName} are automatic and cannot be fired manually.`);
            }
        };
        return status;
    }, [
        isInCohort,
        experimentName,
        parameterName,
        defaultValue,
        options,
        fireTrackingEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== 'undefined' && experimentEnrollment.type === $e63d5b4b182704d7$export$7184a614b8d5eae2.ENROLLED) {
            const xExperimentsKey = (0, $gx3aw.Cookie).readCookie($e63d5b4b182704d7$var$X_EXPERIMENTS_KEY);
            if (xExperimentsKey) {
                const decodedExperimentsKey = (0, (/*@__PURE__*/$parcel$interopDefault($g57Lc))).decompressFromBase64(xExperimentsKey.split('~')[1]);
                const evaluatedValueInExpKey = $e63d5b4b182704d7$var$getExperimentKeyValue(decodedExperimentsKey, experimentName);
                if (evaluatedValueInExpKey != null && String(experimentEnrollment.value) !== evaluatedValueInExpKey) {
                    const edgeTraceId = (0, $gx3aw.Cookie).readCookie('X-Experiments-Trace-Id');
                    const featureGatesAnonIdUsedInSSR = window?.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
                    analyticsClient?.sendOperationalEvent({
                        action: 'mismatched',
                        actionSubject: 'experimentValue',
                        source: 'useExperiment',
                        attributes: {
                            experimentName: experiment.experimentName,
                            route: window.location.pathname,
                            // @ts-ignore
                            anonIdUsedInSsrBeforeOverride: window?.ssrAnonId,
                            anonIdUsedInSSR: featureGatesAnonIdUsedInSSR,
                            anonIdInAnalyticsClient: analyticsClient.getAnonymousId(),
                            experimentKeyValue: evaluatedValueInExpKey,
                            traceId: edgeTraceId,
                            experimentValue: String(experimentEnrollment.value),
                            // @ts-ignore
                            fallback: window.IS_STATIC ? 'true' : 'false'
                        }
                    });
                }
            }
        }
        // fire tracking if automatic exposures are enabled.
        // Only fire once when user becomes enrolled, not on every state change
        if (experimentEnrollment.type === $e63d5b4b182704d7$export$7184a614b8d5eae2.ENROLLED && options.fireExperimentExposure && !hasFiredRef.current) {
            const enrolled = experimentEnrollment;
            fireTrackingEvent(enrolled.value, {
                usingDefault: enrolled.usingDefault
            });
            hasFiredRef.current = true;
        }
    }, [
        experimentEnrollment.type,
        options.fireExperimentExposure,
        fireTrackingEvent
    ]);
    return experimentEnrollment;
}
function $e63d5b4b182704d7$export$2f86411d819a755e(experiment) {
    const { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options } = experiment;
    const isInCohort = experiment.targeting.cohort();
    return $e63d5b4b182704d7$var$getExperimentStatus(experimentName, parameterName, defaultValue, isInCohort, // Disable automatic firing of exposure events.
    {
        ...options,
        fireExperimentExposure: false
    });
}
function $e63d5b4b182704d7$export$37ab8203aaeb6e80(experiment) {
    const { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options } = experiment;
    const isInCohort = experiment.targeting.cohort();
    return $e63d5b4b182704d7$var$getExperimentStatus(experimentName, parameterName, defaultValue, isInCohort, // Automatically fire experiment exposures
    {
        ...options,
        fireExperimentExposure: true
    });
}
function $e63d5b4b182704d7$var$getExperimentStatus(experimentName, parameterName, defaultValue, isInCohort, options) {
    if (isInCohort === undefined) return {
        type: $e63d5b4b182704d7$export$7184a614b8d5eae2.INDETERMINATE
    };
    if (!isInCohort) return {
        type: $e63d5b4b182704d7$export$7184a614b8d5eae2.NOT_ENROLLED,
        value: defaultValue
    };
    const experimentValue = (0, $3L8ZR.default).getExperimentValue(experimentName, parameterName, undefined, options);
    const usingDefault = experimentValue === undefined;
    const value = usingDefault ? defaultValue : experimentValue;
    return {
        type: $e63d5b4b182704d7$export$7184a614b8d5eae2.ENROLLED,
        parameterName: parameterName,
        value: value,
        usingDefault: usingDefault
    };
}
function $e63d5b4b182704d7$export$f86304593290690b(experimentName, analyticsClient, createAnalyticsEvent, metadata, group) {
    if (!analyticsClient) return;
    if (!(0, $dajtI.claimExposureOncePerPage)(experimentName, String(group))) return;
    // register feature flag exposure with Sentry client
    (0, $k4D4E.addFeatureFlagExposureToSentry)(experimentName, group);
    const traceId = (0, $gx3aw.Cookie).readCookie('X-Experiments-Trace-Id');
    // fire feature exposed event
    createAnalyticsEvent({
        source: experimentName,
        actionSubject: 'feature',
        action: 'exposed',
        actionSubjectId: experimentName,
        attributes: (0, $fLpER.GASv3).enrichEventData({
            ...metadata,
            group: group,
            edgeTraceId: traceId ? traceId : undefined
        }),
        eventType: 'track'
    }).fire();
}

});
parcelRegister("g57Lc", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

});

parcelRegister("iSeHD", function(module, exports) {
$parcel$export(module.exports, "WacAnalyticsClientProvider", function () { return $5264c6a577de7017$export$f84a51d6dd0d7383; });
$parcel$export(module.exports, "useAnalyticsClient", function () { return $5264c6a577de7017$export$923054f18cb06572; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $gLm0b = parcelRequire("gLm0b");
const $5264c6a577de7017$var$getAnonIdUsedByFeatureGatesClientInSSR = ()=>window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
const $5264c6a577de7017$var$AnalyticsWebClientContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    analyticsWebClientInstance: null
});
const $5264c6a577de7017$export$f84a51d6dd0d7383 = (props)=>{
    const [analyticsWebClientInstance, setAnalyticsWebClientInstance] = (0, $1oC0p.useState)(null);
    const { analyticsOptOut: analyticsOptOut } = (0, $gLm0b.useOneTrustContext)();
    (0, $1oC0p.useEffect)(()=>{
        if (!props.analyticsWebClient) return;
        if (!analyticsOptOut) {
            // If the FeatureGates and analytics clients are using different identifiers,
            // it means that the client already had an anonymousId in localStorage and/or cookies,
            // but SSR was unable to use it, either because the client had blocked sending cookies,
            // or because there was some issue extracting it.
            // An identifier mismatch means we won't be able to include this session in the experiment metrics.
            // We capture an operational event here as a way to tell how much data we've lost in our experiment results.
            const featureGatesAnonId = $5264c6a577de7017$var$getAnonIdUsedByFeatureGatesClientInSSR();
            if (featureGatesAnonId !== props.analyticsWebClient.getAnonymousId()) props.analyticsWebClient.sendOperationalEvent({
                action: 'mismatched',
                actionSubject: 'anonymousId',
                source: 'awcInitialization',
                attributes: {
                    featureGatesAnonId: featureGatesAnonId,
                    route: props.location.pathname
                }
            });
            setAnalyticsWebClientInstance(props.analyticsWebClient);
            return;
        }
        const isEnableOperationalEventWhenOptedOut = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10416DisableNonOperationalAnalyticsGateUip);
        if (isEnableOperationalEventWhenOptedOut) // Set client even when opted out so the listener can send operational events (e.g. page view)
        setAnalyticsWebClientInstance(props.analyticsWebClient);
    }, [
        analyticsOptOut,
        props.analyticsWebClient,
        props.location.pathname
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($5264c6a577de7017$var$AnalyticsWebClientContext.Provider, {
        value: {
            analyticsWebClientInstance: analyticsWebClientInstance
        },
        children: props.children
    });
};
const $5264c6a577de7017$export$923054f18cb06572 = ()=>{
    const context = (0, $1oC0p.useContext)($5264c6a577de7017$var$AnalyticsWebClientContext);
    if (!context) throw new Error('calls to useAnalyticsClient must be wrapped in <WacAnalyticsClientProvider>!');
    return context.analyticsWebClientInstance;
};

});

parcelRegister("dajtI", function(module, exports) {
$parcel$export(module.exports, "hasFiredExposure", function () { return $afbacfd95a7a8b98$export$633a89f47b4b506d; });
$parcel$export(module.exports, "claimExposureOncePerPage", function () { return $afbacfd95a7a8b98$export$f3fc467b2bb3ee62; });
const $afbacfd95a7a8b98$var$firedExposures = new Map();
function $afbacfd95a7a8b98$export$633a89f47b4b506d(experimentName, group) {
    return $afbacfd95a7a8b98$var$firedExposures.get(experimentName)?.has(group) ?? false;
}
function $afbacfd95a7a8b98$export$f3fc467b2bb3ee62(experimentName, group) {
    const groups = $afbacfd95a7a8b98$var$firedExposures.get(experimentName) ?? new Set();
    if (groups.has(group)) return false;
    groups.add(group);
    $afbacfd95a7a8b98$var$firedExposures.set(experimentName, groups);
    return true;
}
function $afbacfd95a7a8b98$export$405f168c82b98ae9() {
    $afbacfd95a7a8b98$var$firedExposures.clear();
}

});


parcelRegister("7FWq8", function(module, exports) {
$parcel$export(module.exports, "wacRefreshJira", function () { return $c4fe2ed4002b79ef$export$4fb3c8eb9a885607; });
$parcel$export(module.exports, "wacRefreshConfluence", function () { return $c4fe2ed4002b79ef$export$789dc19b5cc98fa8; });
$parcel$export(module.exports, "wacRefreshHomepage", function () { return $c4fe2ed4002b79ef$export$2e5d92ea3e9294ac; });
$parcel$export(module.exports, "wacRefreshTwcRovo", function () { return $c4fe2ed4002b79ef$export$7e8138eb6f7646bb; });
/**
 * Standalone definitions for the four WAC Refresh Q4 FY26 experiments.
 *
 * These are intentionally kept OUT of `./manifest.ts` so that consumers
 * (notably `wac-refresh-context.tsx`, which is imported by foundation
 * components like `column-layout.tsx`) can reference them without
 * transitively pulling in the manifest's `@/components/user-context`
 * import — which causes a circular module-evaluation crash in tests
 * that load `signup/utils` while it is mid-evaluation.
 *
 * The manifest re-exports these so the rest of the codebase continues
 * to access them via `experiments.wacRefreshJira` etc. unchanged.
 *
 * Note: the `cohort` callbacks intentionally do NOT import from
 * `@/components/user-context` (which would re-introduce the circular
 * dependency). Instead we inline a local copy of `useSpecifiedPathnames`
 * — a 4-line helper that only reads the current pathname from the
 * location provider — see source at
 * `services/wac-web/src/components/user-context/helpers/cohorts.ts`.
 */ 
var $1ka2O = parcelRequire("1ka2O");
const $c4fe2ed4002b79ef$var$booleanTypeGuard = (value)=>typeof value === 'boolean';
/**
 * Local copy of `useSpecifiedPathnames` from
 * `@/components/user-context/helpers/cohorts` — inlined here to avoid
 * re-introducing the circular import chain that this whole file exists
 * to break. Behaviour must stay in sync with the source.
 */ const $c4fe2ed4002b79ef$var$useSpecifiedPathnames = (pathnames)=>{
    const { pathname: currentPathname } = (0, $1ka2O.useLocation)();
    return pathnames.includes(currentPathname);
};
const $c4fe2ed4002b79ef$export$4fb3c8eb9a885607 = {
    experimentName: 'wac-refresh-jira',
    parameterName: 'isEnabled',
    defaultValue: false,
    options: {
        fireExperimentExposure: true,
        typeGuard: $c4fe2ed4002b79ef$var$booleanTypeGuard
    },
    targeting: {
        cohort: ()=>{
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            return $c4fe2ed4002b79ef$var$useSpecifiedPathnames([
                '/software/jira'
            ]);
        }
    },
    metadata: {
        description: '50/50 A/B test of the WAC Refresh design on the Jira Product Tour page',
        expectedReleaseDate: '06/02/2026',
        expectedRuntime: '19 days',
        context: {
            urls: [
                '/software/jira'
            ]
        }
    }
};
const $c4fe2ed4002b79ef$export$789dc19b5cc98fa8 = {
    experimentName: 'wac-refresh-confluence',
    parameterName: 'isEnabled',
    defaultValue: false,
    options: {
        fireExperimentExposure: true,
        typeGuard: $c4fe2ed4002b79ef$var$booleanTypeGuard
    },
    targeting: {
        cohort: ()=>{
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            return $c4fe2ed4002b79ef$var$useSpecifiedPathnames([
                '/software/confluence'
            ]);
        }
    },
    metadata: {
        description: '50/50 A/B test of the WAC Refresh design on the Confluence Product Tour page',
        expectedReleaseDate: '06/02/2026',
        expectedRuntime: '21 days',
        context: {
            urls: [
                '/software/confluence'
            ]
        }
    }
};
const $c4fe2ed4002b79ef$export$2e5d92ea3e9294ac = {
    experimentName: 'wac-refresh-homepage',
    parameterName: 'isEnabled',
    defaultValue: false,
    options: {
        fireExperimentExposure: true,
        typeGuard: $c4fe2ed4002b79ef$var$booleanTypeGuard
    },
    targeting: {
        cohort: ()=>{
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            return $c4fe2ed4002b79ef$var$useSpecifiedPathnames([
                '/'
            ]);
        }
    },
    metadata: {
        description: '50/50 A/B test of the WAC Refresh design on the Atlassian homepage',
        expectedReleaseDate: '06/02/2026',
        expectedRuntime: '23 days',
        context: {
            urls: [
                '/'
            ]
        }
    }
};
const $c4fe2ed4002b79ef$export$7e8138eb6f7646bb = {
    experimentName: 'wac-refresh-twc-rovo',
    parameterName: 'isEnabled',
    defaultValue: false,
    options: {
        fireExperimentExposure: true,
        typeGuard: $c4fe2ed4002b79ef$var$booleanTypeGuard
    },
    targeting: {
        cohort: ()=>{
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            return $c4fe2ed4002b79ef$var$useSpecifiedPathnames([
                '/software/rovo',
                '/collections/teamwork'
            ]);
        }
    },
    metadata: {
        description: '50/50 A/B test of the WAC Refresh design on the Rovo and Teamwork Collection pages',
        expectedReleaseDate: '06/02/2026',
        expectedRuntime: 'TBD',
        context: {
            urls: [
                '/software/rovo',
                '/collections/teamwork'
            ]
        }
    }
};

});
parcelRegister("1ka2O", function(module, exports) {
$parcel$export(module.exports, "LocationProvider", function () { return $ba39092fe3985e3e$export$5af065edda80e75c; });
$parcel$export(module.exports, "useLocation", function () { return $ba39092fe3985e3e$export$45d76561a5302f2b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $7t0tI = parcelRequire("7t0tI");
const $ba39092fe3985e3e$export$e6a44b110a0c44d3 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $ba39092fe3985e3e$export$5af065edda80e75c = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($ba39092fe3985e3e$export$e6a44b110a0c44d3.Provider, {
        value: props.location,
        children: props.children
    });
};
/**
 * True when running in a non-production environment where useLocation() may run
 * without a LocationProvider (Jest, Gemini VR, Storybook). Production bundles
 * inline process.env.NODE_ENV as "production", so this branch is dead code in
 * deployed builds and useLocation still throws without a provider in production.
 */ function $ba39092fe3985e3e$var$isNonProductionEnv() {
    if (typeof $7t0tI === 'undefined') return false;
    const nodeEnv = "production";
    return nodeEnv === 'test' || nodeEnv === 'development';
}
const $ba39092fe3985e3e$export$45d76561a5302f2b = ()=>{
    const location = (0, $1oC0p.useContext)($ba39092fe3985e3e$export$e6a44b110a0c44d3);
    if (location) return location;
    if ($ba39092fe3985e3e$var$isNonProductionEnv() && typeof window !== 'undefined' && window.location) return window.location;
    throw new Error('useLocation must be used within a LocationProvider');
};

});




parcelRegister("bNzAT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e28cfefd495fcb08$export$2e2bcd8739ae039; });

var $hlkJP = parcelRequire("hlkJP");
const $e28cfefd495fcb08$var$wacToken = (token)=>{
    return (0, $hlkJP.getWacValue)(token);
};
var $e28cfefd495fcb08$export$2e2bcd8739ae039 = $e28cfefd495fcb08$var$wacToken;

});
parcelRegister("hlkJP", function(module, exports) {
$parcel$export(module.exports, "getWacValue", function () { return $1733ce6b06bbdd98$export$29f256318842afd6; });
// WAC name for a token we created
const $1733ce6b06bbdd98$export$dbddf1c117e75747 = [
    // Colors
    // Primary
    "color.primary.blue",
    "color.primary.lime",
    "color.primary.purple",
    "color.primary.saffron",
    "color.primary.black",
    // Secondary
    "color.secondary.navy",
    "color.secondary.green",
    "color.secondary.red",
    // Extended
    // Blues
    "color.extended.blue100",
    "color.extended.blue200",
    "color.extended.blue300",
    "color.extended.blue400",
    "color.extended.blue500",
    "color.extended.blue600",
    "color.extended.blue700",
    "color.extended.blue800",
    "color.extended.blue900",
    "color.extended.blue1000",
    // Limes
    "color.extended.lime100",
    "color.extended.lime200",
    "color.extended.lime300",
    "color.extended.lime400",
    "color.extended.lime500",
    "color.extended.lime600",
    "color.extended.lime700",
    "color.extended.lime800",
    "color.extended.lime900",
    "color.extended.lime1000",
    // Purples
    "color.extended.purple100",
    "color.extended.purple200",
    "color.extended.purple300",
    "color.extended.purple400",
    "color.extended.purple500",
    "color.extended.purple600",
    "color.extended.purple700",
    "color.extended.purple800",
    "color.extended.purple900",
    "color.extended.purple1000",
    // Saffrons
    "color.extended.saffron100",
    "color.extended.saffron200",
    "color.extended.saffron300",
    "color.extended.saffron400",
    "color.extended.saffron500",
    "color.extended.saffron600",
    "color.extended.saffron700",
    "color.extended.saffron800",
    "color.extended.saffron900",
    "color.extended.saffron1000",
    // Neutral Opaque
    "color.neutral.light0",
    "color.neutral.light100",
    "color.neutral.light200",
    "color.neutral.light300",
    "color.neutral.light400",
    "color.neutral.light500",
    "color.neutral.light600",
    "color.neutral.light700",
    "color.neutral.light800",
    "color.neutral.light900",
    "color.neutral.light1000",
    "color.neutral.light1100",
    // Dark Neutral Opaque
    "color.neutral.dark0",
    "color.neutral.dark100",
    "color.neutral.dark200",
    "color.neutral.dark250",
    "color.neutral.dark300",
    "color.neutral.dark350",
    "color.neutral.dark400",
    "color.neutral.dark500",
    "color.neutral.dark600",
    "color.neutral.dark700",
    "color.neutral.dark800",
    "color.neutral.dark900",
    "color.neutral.dark1000",
    "color.neutral.dark1100",
    // Yellows
    "color.extended.yellow100",
    "color.extended.yellow200",
    "color.extended.yellow300",
    "color.extended.yellow400",
    "color.extended.yellow500",
    "color.extended.yellow600",
    "color.extended.yellow700",
    "color.extended.yellow800",
    "color.extended.yellow900",
    "color.extended.yellow1000",
    // Oranges
    "color.extended.orange100",
    "color.extended.orange200",
    "color.extended.orange300",
    "color.extended.orange400",
    "color.extended.orange500",
    "color.extended.orange600",
    "color.extended.orange700",
    "color.extended.orange800",
    "color.extended.orange900",
    "color.extended.orange1000",
    // ASOW Primary
    "color.asow.primary.blue",
    "color.asow.primary.lime",
    "color.asow.primary.purple",
    "color.asow.primary.yellow",
    "color.asow.primary.orange",
    "color.asow.primary.neutral",
    // Typography
    "font.charlie.display",
    "font.charlie.text",
    // Corner Radius
    "corner.radius.pill",
    "corner.radius.card",
    // Motion Property
    "motion.property.fade-in",
    "motion.property.fade-up",
    "motion.property.scale-in",
    "motion.property.slide-in-top",
    "motion.property.slide-in-bottom",
    "motion.property.slide-in-left",
    "motion.property.slide-in-right",
    "motion.property.fade-out",
    "motion.property.scale-out",
    "motion.property.slide-out-top",
    "motion.property.slide-out-bottom",
    "motion.property.slide-out-left",
    "motion.property.slide-out-right",
    // Motion Duration
    "motion.duration.0ms",
    "motion.duration.50ms",
    "motion.duration.100ms",
    "motion.duration.150ms",
    "motion.duration.200ms",
    "motion.duration.250ms",
    "motion.duration.400ms",
    "motion.duration.750ms",
    "motion.duration.1000ms",
    "motion.duration.6400ms",
    // Motion Easing
    "motion.easing.ease40-out",
    "motion.easing.quick-entrance",
    "motion.easing.ease.cubic-out",
    "motion.easing.natural-entrance",
    "motion.easing.ease60-in",
    "motion.easing.slow-exit",
    "motion.easing.ease40-in-out",
    "motion.easing.ease-both",
    "motion.easing.linear",
    "motion.easing.constant",
    // Motion Delay
    "motion.delay.0ms",
    "motion.delay.50ms",
    "motion.delay.100ms",
    "motion.delay.150ms",
    "motion.delay.200ms",
    "motion.delay.250ms",
    "motion.delay.300ms",
    "motion.delay.350ms",
    "motion.delay.400ms",
    "motion.delay.450ms",
    "motion.delay.500ms",
    "motion.delay.550ms"
];
const $1733ce6b06bbdd98$export$8f4a6bdcbe7cb2d3 = {
    // Typography
    "font.charlie.display": "var(--bxp-charlie-display-font-family)",
    "font.charlie.text": "var(--bxp-charlie-text-font-family)",
    // Corner Radius
    "corner.radius.card": "20px",
    "corner.radius.pill": "10000px",
    // Motion Property (animation names; @keyframes live in index.css)
    "motion.property.fade-in": "wac-fade-in",
    "motion.property.fade-up": "wac-fade-up",
    "motion.property.scale-in": "wac-scale-in",
    "motion.property.slide-in-top": "wac-slide-in-top",
    "motion.property.slide-in-bottom": "wac-slide-in-bottom",
    "motion.property.slide-in-left": "wac-slide-in-left",
    "motion.property.slide-in-right": "wac-slide-in-right",
    "motion.property.fade-out": "wac-fade-out",
    "motion.property.scale-out": "wac-scale-out",
    "motion.property.slide-out-top": "wac-slide-out-top",
    "motion.property.slide-out-bottom": "wac-slide-out-bottom",
    "motion.property.slide-out-left": "wac-slide-out-left",
    "motion.property.slide-out-right": "wac-slide-out-right",
    // Motion Duration
    "motion.duration.0ms": "0ms",
    "motion.duration.50ms": "50ms",
    "motion.duration.100ms": "100ms",
    "motion.duration.150ms": "150ms",
    "motion.duration.200ms": "200ms",
    "motion.duration.250ms": "250ms",
    "motion.duration.400ms": "400ms",
    "motion.duration.750ms": "750ms",
    "motion.duration.1000ms": "1000ms",
    "motion.duration.6400ms": "6400ms",
    // Motion Easing
    "motion.easing.ease40-out": "cubic-bezier(0, 0.4, 0, 1)",
    "motion.easing.quick-entrance": "cubic-bezier(0, 0.4, 0, 1)",
    "motion.easing.ease.cubic-out": "cubic-bezier(0.33, 1, 0.68, 1)",
    "motion.easing.natural-entrance": "cubic-bezier(0.33, 1, 0.68, 1)",
    "motion.easing.ease60-in": "cubic-bezier(0.6, 0.01, 0.8, 0.6)",
    "motion.easing.slow-exit": "cubic-bezier(0.6, 0.01, 0.8, 0.6)",
    "motion.easing.ease40-in-out": "cubic-bezier(0.4, 0, 0, 1)",
    "motion.easing.ease-both": "cubic-bezier(0.4, 0, 0, 1)",
    "motion.easing.linear": "cubic-bezier(0, 0, 1, 1)",
    "motion.easing.constant": "cubic-bezier(0, 0, 1, 1)",
    // Motion Delay
    "motion.delay.0ms": "0ms",
    "motion.delay.50ms": "50ms",
    "motion.delay.100ms": "100ms",
    "motion.delay.150ms": "150ms",
    "motion.delay.200ms": "200ms",
    "motion.delay.250ms": "250ms",
    "motion.delay.300ms": "300ms",
    "motion.delay.350ms": "350ms",
    "motion.delay.400ms": "400ms",
    "motion.delay.450ms": "450ms",
    "motion.delay.500ms": "500ms",
    "motion.delay.550ms": "550ms",
    // Primary
    "color.primary.blue": "#1868DB",
    "color.primary.lime": "#82B536",
    "color.primary.purple": "#BF63F3",
    "color.primary.saffron": "#FCA700",
    "color.primary.black": "#101214",
    // Secondary
    "color.secondary.navy": "#09326C",
    "color.secondary.green": "#164B35",
    "color.secondary.red": "#AE2A19",
    // Extended
    // Blues
    "color.extended.blue100": "#e9f2fe",
    "color.extended.blue200": "#cfe1fd",
    "color.extended.blue300": "#8fb8f6",
    "color.extended.blue400": "#669DF1",
    "color.extended.blue500": "#4D8Ced",
    "color.extended.blue600": "#357DE8",
    "color.extended.blue700": "#1868DB",
    "color.extended.blue800": "#1558BC",
    "color.extended.blue900": "#123263",
    "color.extended.blue1000": "#1C2B42",
    // Limes
    "color.extended.lime100": "#EFFFD6",
    "color.extended.lime200": "#D3F1A7",
    "color.extended.lime300": "#B3DF72",
    "color.extended.lime400": "#94C748",
    "color.extended.lime500": "#82B536",
    "color.extended.lime600": "#6A9A23",
    "color.extended.lime700": "#5B7F24",
    "color.extended.lime800": "#4C6B1F",
    "color.extended.lime900": "#37471F",
    "color.extended.lime1000": "#28311B",
    // Purples
    "color.extended.purple100": "#F8EEFE",
    "color.extended.purple200": "#EED7FC",
    "color.extended.purple300": "#D8A0F7",
    "color.extended.purple400": "#C97CF4",
    "color.extended.purple500": "#BF63F3",
    "color.extended.purple600": "#AF59E1",
    "color.extended.purple700": "#964AC0",
    "color.extended.purple800": "#803FA5",
    "color.extended.purple900": "#48245D",
    "color.extended.purple1000": "#35243F",
    // Saffrons
    "color.extended.saffron100": "#FFF5D4",
    "color.extended.saffron200": "#FFE48F",
    "color.extended.saffron300": "#FFC716",
    "color.extended.saffron400": "#FCA700",
    "color.extended.saffron500": "#FA8700",
    "color.extended.saffron600": "#E56910",
    "color.extended.saffron700": "#BD5B00",
    "color.extended.saffron800": "#9E4C00",
    "color.extended.saffron900": "#693200",
    "color.extended.saffron1000": "#3A2C1F",
    // Neutral Opaque
    "color.neutral.light0": "#FFFFFF",
    "color.neutral.light100": "#f8f8f8",
    "color.neutral.light200": "#F0F1F2",
    "color.neutral.light300": "#DDDEE1",
    "color.neutral.light400": "#B7B9BE",
    "color.neutral.light500": "#8C8F97",
    "color.neutral.light600": "#7D818A",
    "color.neutral.light700": "#6C6F77",
    "color.neutral.light800": "#505258",
    "color.neutral.light900": "#3B3D42",
    "color.neutral.light1000": "#292A2E",
    "color.neutral.light1100": "#1E1F21",
    // Dark Neutral Opaque
    "color.neutral.dark0": "#18191A",
    "color.neutral.dark100": "#1F1F21",
    "color.neutral.dark200": "#242528",
    "color.neutral.dark250": "#B2C2F",
    "color.neutral.dark300": "#303134",
    "color.neutral.dark350": "#3D3F43",
    "color.neutral.dark400": "#4B4D51",
    "color.neutral.dark500": "#63666B",
    "color.neutral.dark600": "#7E8188",
    "color.neutral.dark700": "#96999E",
    "color.neutral.dark800": "#A9ABAF",
    "color.neutral.dark900": "#BFC1C4",
    "color.neutral.dark1000": "#CECFD2",
    "color.neutral.dark1100": "#E2E3E4",
    // Yellows
    "color.extended.yellow100": "#FFF6CB",
    "color.extended.yellow200": "#FFE88C",
    "color.extended.yellow300": "#FFC716",
    "color.extended.yellow400": "#F2AC00",
    "color.extended.yellow500": "#DF9800",
    "color.extended.yellow600": "#CB7E00",
    "color.extended.yellow700": "#B87000",
    "color.extended.yellow800": "#905500",
    "color.extended.yellow900": "#623600",
    "color.extended.yellow1000": "#43281A",
    // Oranges
    "color.extended.orange100": "#FFF0D7",
    "color.extended.orange200": "#FFDA9C",
    "color.extended.orange300": "#FB9700",
    "color.extended.orange400": "#F47B00",
    "color.extended.orange500": "#E56E00",
    "color.extended.orange600": "#D45D00",
    "color.extended.orange700": "#C75300",
    "color.extended.orange800": "#A13D00",
    "color.extended.orange900": "#641A00",
    "color.extended.orange1000": "#4B1C17",
    // ASOW Primary
    "color.asow.primary.blue": "#1868DB",
    "color.asow.primary.lime": "#94C748",
    "color.asow.primary.purple": "#C97CF4",
    "color.asow.primary.yellow": "#FFC716",
    "color.asow.primary.orange": "#FB9700",
    "color.asow.primary.neutral": "#DDDEE1"
};
function $1733ce6b06bbdd98$export$29f256318842afd6(wacToken) {
    return $1733ce6b06bbdd98$export$8f4a6bdcbe7cb2d3[wacToken];
}

});



parcelRegister("9D0tJ", function(module, exports) {
$parcel$export(module.exports, "FeatureInfo", function () { return $b5198a7903f910a7$export$64a41dfe32d2aceb; });
/* feature-info.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $bI2br = parcelRequire("bI2br");
const $b5198a7903f910a7$var$containerStyles = null;
const $b5198a7903f910a7$var$containerReverseStyles = null;
const $b5198a7903f910a7$var$contentStyles = null;
const $b5198a7903f910a7$var$textContentStyles = null;
const $b5198a7903f910a7$var$textSpaceStyles = null;
const $b5198a7903f910a7$var$asterisksStyle = null;
const $b5198a7903f910a7$var$eyebrowStyles = null;
const $b5198a7903f910a7$var$titleStyles = null;
const $b5198a7903f910a7$var$descriptionStyles = null;
const $b5198a7903f910a7$var$separatorStyles = null;
const $b5198a7903f910a7$var$iconTitleStyles = null;
const $b5198a7903f910a7$var$iconContainerStyles = null;
const $b5198a7903f910a7$var$iconAndTextStyles = null;
const $b5198a7903f910a7$var$iconStyles = null;
const $b5198a7903f910a7$var$buttonSpaceStyles = null;
const $b5198a7903f910a7$var$displayNoneBelowLg = null;
const $b5198a7903f910a7$var$topPaddingStyles = null;
const $b5198a7903f910a7$export$64a41dfe32d2aceb = ({ eyebrow: eyebrow, title: title, description: description, iconTitle: iconTitle, iconCollection: iconCollection, reverseLayout: reverseLayout, cta: cta, showAsterisks: showAsterisks, hideSeparator: hideSeparator, addPaddingAboveList: addPaddingAboveList, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bahesu3 _p12f1fra _zulpzwfg _1s4p1osq _na0i1sxn _tnv21afi _2osnidpf _15951w8u _1vkh1w8u _11qb1w8u _15sj1vuk",
            reverseLayout && "_2lx21sbv _na0i1bp4",
            "container-styles"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _ahbq1wug _12l21wug"
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1r5k _2rkoqslr _11q71afi _1s4p1osq _1d2yr60k"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1q511crf",
                        "tab-text-content"
                    ]),
                    children: [
                        showAsterisks && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1mjbglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bI2br.Asterisks), {
                                size: "64"
                            })
                        }),
                        eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth14y2",
                                "eyebrow-md"
                            ]),
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_1mouidpf",
                                "h3"
                            ]),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_1wyb1k92 _1pfh7vkz _srwz7vkz",
                                "tab-text-content-description"
                            ]),
                            children: description
                        }),
                        !hideSeparator && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3it94y _11q7p4k8 _1pfhzwfg",
                                "_1mjbglyw"
                            ]),
                            style: {
                                "--_1aetymw": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light500'))
                            }
                        }),
                        iconTitle && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_1pfhzwfg _6rthrdoj _1bsbn8ye",
                                "_1mjbglyw",
                                "body-md"
                            ]),
                            children: iconTitle
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_1e0c116y _2lx21bp4 _4cvr1y6m _qtt8glyw _18zridpf _1mouidpf _zulpftgi _81641y44",
                                addPaddingAboveList && "_1q517vkz"
                            ]),
                            children: iconCollection.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1bah1h6o _4cvr1y6m _15ueidpf _1uz3idpf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1bsb1tcg _4t3i1tcg _y3gn1h6o _1o9zidpf"
                                            ]),
                                            children: icon.icon
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: "body-sm",
                                            children: icon.description
                                        })
                                    ]
                                }, index))
                        }),
                        cta && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhzwfg _476d7vkz _srwz7vkz",
                                "tab-text-content-cta"
                            ]),
                            children: cta
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("bI2br", function(module, exports) {
$parcel$export(module.exports, "Asterisks", function () { return $e111e62d40ed69b4$export$73598a4b20da4aa6; });

var $7VQPk = parcelRequire("7VQPk");
const $e111e62d40ed69b4$export$73598a4b20da4aa6 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 68 69",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.557 39.6214C19.5694 39.6016 19.5693 39.5658 19.5941 39.538C18.8722 39.1886 18.7897 38.3308 18.2329 37.8185L18.2122 37.7986C17.6471 37.6239 17.7997 37.0798 17.0985 37.0758C17.0985 37.0758 17.28 36.9884 17.2841 36.9884C16.1456 35.9003 13.3323 33.2276 13.3323 33.2276C13.2704 33.4699 13.7819 33.0489 14.2976 33.1204C14.2976 33.1204 14.3347 33.0291 14.3718 33.1006C15.6877 31.8655 17.1686 31.3929 18.8516 30.8051C19.6931 30.5867 19.821 28.2952 18.3814 29.2444C18.3649 29.2285 18.3277 29.2166 18.3112 29.1888C17.808 29.7527 16.9706 29.5462 16.3353 29.8401L16.3106 29.852L15.2545 30.3484C14.6812 30.5748 14.0005 30.7535 13.2869 30.9283C13.3075 30.9084 13.3282 30.8885 13.3488 30.8687C13.3488 30.8687 13.423 29.7686 13.4024 29.2245C13.4024 29.2245 14.1243 28.3509 13.8851 27.7512C14.2934 27.0483 15.7454 25.5113 14.4254 25.0745C13.9923 25.0745 13.654 24.7131 13.5055 25.3843C13.4808 25.3803 13.4478 25.3882 13.4148 25.3763C13.3364 26.0713 12.4826 26.5638 12.2474 27.223L12.2392 27.2508C12.2969 27.8147 11.8432 28.3707 11.8391 28.3707C11.6245 28.887 11.344 29.4509 11.047 30.0386C10.9233 29.7209 10.7872 29.439 10.651 29.2365C10.156 28.7202 10.3664 21.6671 8.53489 23.2239C8.62152 24.5543 9.05873 25.9403 8.70398 27.1237C8.53073 27.215 8.79473 27.6876 9.00923 28.0729C8.99273 28.5613 8.88961 28.8234 8.86073 29.5224C7.95323 28.891 3.9932 25.6941 4.23658 27.8465C4.66146 28.0649 4.97082 28.3151 5.19357 28.8234C5.39982 29.0419 7.21898 30.0268 7.27673 30.273C7.15711 30.6145 9.30628 30.8885 8.43589 31.1427C8.56377 31.4127 8.73701 31.6709 8.93914 31.9211C7.99863 32.0164 6.87247 32.2824 6.28258 32.6279C6.17946 32.7987 2.42566 33.029 1.0644 33.8749C0.251765 34.3158 -0.465956 34.5342 0.379678 35.1974C0.684931 34.9591 1.83168 35.3007 1.80693 34.9869C2.08743 35.0981 3.98496 34.3991 4.19534 34.5183C4.29847 34.6771 5.79171 33.8352 5.61433 34.2324C6.64971 34.5143 7.91198 34.284 9.22374 33.9623C8.70399 34.7566 8.19252 35.8884 8.12652 36.5913C7.68101 37.4928 6.50534 39.4864 6.12996 40.7096C5.5937 41.5992 5.77935 41.6706 6.45585 42.1273L6.46824 42.1393C6.60849 42.2306 6.45174 42.1392 6.98387 42.1591C6.93025 42.1114 6.85184 41.905 6.74872 41.9407C6.81884 41.8017 7.62737 41.6031 7.28912 41.4165C7.27675 41.3887 7.80475 40.9995 7.85838 40.5785C8.32863 39.0774 9.45477 38.3188 10.288 36.6072C10.2674 36.7859 11.6699 40.1496 11.6039 41.8255C11.5008 42.6515 13.5798 43.8827 13.2787 42.04C13.3034 42.032 13.324 42.0003 13.3612 41.9963C13.027 41.2378 13.4684 40.4554 13.2952 39.685L13.2869 39.6532C12.9115 39.1846 13.3447 38.7954 12.7507 38.4142C12.7507 38.4142 12.9528 38.434 12.9569 38.438C12.6929 37.3459 12.5279 36.0115 12.2804 34.8161C13.1673 35.5905 13.9469 36.4245 14.2687 37.3419L14.3099 37.2824C14.3099 37.3102 14.3718 37.33 14.3182 37.3935C15.0648 37.5444 15.3206 37.8463 15.861 38.0488C15.861 38.0488 16.4384 39.0535 17.1108 39.0893L18.1338 40.4832C18.5752 41.202 20.9554 40.789 19.5735 39.6373L19.557 39.6214Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.5669 2.2075C42.553 2.2157 42.5416 2.23755 42.5177 2.24667C42.8478 2.69041 42.625 3.24131 42.8023 3.73206L42.8086 3.7508C43.0986 4.03772 42.8319 4.32183 43.2595 4.54769C43.2595 4.54769 43.1207 4.54332 43.1182 4.54201C43.4678 5.57026 44.3369 8.10121 44.3369 8.10121C44.4519 7.97276 44.0049 8.06727 43.7123 7.85926C43.7123 7.85926 43.6606 7.90329 43.6606 7.84774C42.4623 8.18387 41.406 8.00108 40.1894 7.82434C39.6051 7.68982 38.7969 9.05056 39.9797 8.92873C39.9848 8.9437 40.0037 8.9628 40.0049 8.98506C40.4924 8.8005 40.9388 9.19363 41.4209 9.21628L41.4398 9.21687L42.2439 9.24972C42.6667 9.29395 43.1399 9.40149 43.6321 9.52199C43.6131 9.52756 43.5942 9.53313 43.5752 9.53871C43.5752 9.53871 43.1793 10.1879 43.0186 10.5272C43.0186 10.5272 42.2987 10.8315 42.254 11.2745C41.7803 11.5743 40.4025 12.0517 41.0707 12.7394C41.3356 12.8774 41.4273 13.2062 41.732 12.8431C41.7459 12.8534 41.7686 12.859 41.7849 12.8768C42.0543 12.4768 42.7334 12.4476 43.0873 12.1193L43.1012 12.1049C43.2455 11.7416 43.7002 11.5462 43.7027 11.5475C43.9984 11.3001 44.3496 11.0446 44.7185 10.7797C44.693 11.0135 44.6864 11.2292 44.7051 11.3965C44.8434 11.87 42.4676 16.1166 44.0838 15.748C44.4546 14.9068 44.6288 13.9198 45.2228 13.309C45.3579 13.3084 45.347 12.9352 45.3386 12.6313C45.5043 12.3378 45.6509 12.2103 45.8912 11.792C46.2451 12.4674 47.6485 15.6843 48.1854 14.2903C47.9952 14.0213 47.8857 13.7698 47.9114 13.3879C47.8548 13.1886 47.056 12.0066 47.0991 11.8376C47.2811 11.6669 46.054 10.8145 46.6673 10.9364C46.6751 10.7305 46.6514 10.5174 46.6075 10.3C47.2131 10.5413 47.9866 10.7374 48.4575 10.7141C48.5749 10.6425 50.9442 11.6976 52.0463 11.6139C52.6837 11.6032 53.1923 11.6983 52.8864 11.0233C52.6238 11.0717 52.0312 10.4975 51.9464 10.6973C51.8103 10.5399 50.427 10.3628 50.3363 10.2229C50.3239 10.0929 49.1423 10.1321 49.3774 9.94569C48.8339 9.44336 47.9885 9.18209 47.0838 8.96089C47.6547 8.64071 48.3281 8.11144 48.5925 7.70256C49.1522 7.29314 50.5064 6.44839 51.1257 5.81989C51.7371 5.44667 51.6463 5.34382 51.3781 4.84896L51.3743 4.83772C51.3176 4.73717 51.3844 4.84299 51.0652 4.66131C51.0829 4.70754 51.065 4.85881 51.1395 4.8698C51.0523 4.93247 50.4945 4.79633 50.6419 5.01826C50.6407 5.0392 50.1937 5.109 50.0268 5.34938C49.2609 6.11767 48.3305 6.22279 47.2755 7.00416C47.3451 6.90143 47.559 4.39732 48.1333 3.39336C48.4596 2.92101 47.5803 1.50565 47.1773 2.72859C47.1597 2.72556 47.1369 2.73843 47.113 2.72903C47.0757 3.2994 46.5565 3.63728 46.4169 4.16369L46.4119 4.18574C46.4922 4.59194 46.1032 4.69197 46.3451 5.11439C46.3451 5.11439 46.2278 5.03786 46.2265 5.03412C46.04 5.78618 45.7158 6.65485 45.4863 7.4648C45.1906 6.7086 44.9795 5.95015 45.075 5.28657L45.0308 5.30982C45.0397 5.29282 45.0082 5.261 45.0612 5.23922C44.6526 4.90904 44.5924 4.64294 44.3264 4.3469C44.3264 4.3469 44.2933 3.54841 43.8935 3.31232L43.7119 2.13385C43.671 1.5536 42.0836 1.04786 42.5619 2.19251L42.5669 2.2075Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M56.2986 51.5129C57.3201 51.4258 70.9872 48.1615 67.4022 47.4532C66.0723 47.8212 65.0389 47.4493 64.3739 48.4464C64.1817 47.2712 61.574 49.1468 61.1735 49.218C60.9932 48.3277 56.9075 50.6187 57.5043 49.7917C55.6497 49.8154 53.3465 50.4564 50.9512 51.2082C49.7775 50.4208 54.8086 44.8022 52.6936 46.0169C52.8418 45.7004 53.4106 44.3313 53.3345 45.2374C54.0034 44.4619 61.2856 32.5916 58.2574 34.6016C56.2145 37.0509 54.6804 41.1541 52.95 43.1799C51.2676 43.8645 50.102 49.7442 48.2274 49.1586C47.1338 47.8371 44.3139 31.6538 42.3111 33.0901C42.6596 34.3484 42.3431 35.4761 43.3165 36.0814C42.1268 36.2714 44.0255 38.8472 44.0976 39.2429C43.2164 39.4091 45.4996 43.4609 44.6784 42.8673C44.6944 44.0108 44.9548 45.3324 45.3313 46.7371C44.8306 46.3612 44.2819 45.5025 43.9654 45.3759C40.5927 44.0267 38.0371 40.9245 34.5242 39.2429C31.5721 42.9583 57.6766 52.3319 41.49 53.7326C38.4457 55.6952 34.4 55.9959 31.0033 57.8833C30.7109 61.9706 50.0739 50.6939 44.4861 57.1711C43.6169 59.9092 42.3271 62.9836 40.5446 65.6821C39.407 75.9737 49.0806 48.0151 48.68 58.6826C50.0139 61.2307 51.3037 64.3012 51.9646 67.4627C56.6952 74.3158 50.2382 56.1859 49.5612 53.6179C52.1248 52.5377 62.0347 64.7879 63.8292 62.857C63.9133 62.584 62.4873 61.0685 62.0547 60.9063C61.7623 61.0527 61.6141 61.1714 61.4418 60.9023C62.3111 60.0753 59.2628 59.0308 58.9744 58.7459C59.6153 58.1168 55.3734 56.0711 56.4028 56.1027C55.6097 55.0067 54.396 53.9028 53.0141 52.7909C55.4655 52.324 56.531 50.6147 56.3067 51.505L56.2986 51.5129Z",
                fill: "#101214"
            })
        ]
    });

});




parcelRegister("fcO7r", function(module, exports) {
$parcel$export(module.exports, "ProductKey", function () { return $b5041272d7b35505$export$f3a53bd43617a593; });
$parcel$export(module.exports, "getProductData", function () { return $b5041272d7b35505$export$920b38c8c1070ab; });
$parcel$export(module.exports, "ProductData", function () { return $b5041272d7b35505$export$d4e88a65c1af65bf; });
$parcel$export(module.exports, "OrgBasedProduct", function () { return $b5041272d7b35505$export$c654666118e350a8; });
$parcel$export(module.exports, "CMK_SUPPORT_URL", function () { return $b5041272d7b35505$export$4b199ba4373834; });
$parcel$export(module.exports, "ORG_BASED_OFFERING_IDS", function () { return $b5041272d7b35505$export$470b3b1706479a64; });
$parcel$export(module.exports, "CMK_OFFERING_IDS", function () { return $b5041272d7b35505$export$629756db0300364b; });
$parcel$export(module.exports, "collectionOfferingIds", function () { return $b5041272d7b35505$export$7d55d65617002a4c; });
$parcel$export(module.exports, "orgBasedOfferingIdMap", function () { return $b5041272d7b35505$export$a20d8b3133159060; });
$parcel$export(module.exports, "mapProductKeyAndEditionToCcpProduct", function () { return $b5041272d7b35505$export$f9f96fa5fb066102; });
$parcel$export(module.exports, "mapOfferingIdToProductKeyAndEdition", function () { return $b5041272d7b35505$export$1a4f641784fb4df4; });
$parcel$export(module.exports, "DefaultCollectionProductMap", function () { return $b5041272d7b35505$export$75ed3732be18be33; });
$parcel$export(module.exports, "CollectionConstituentProductsMap", function () { return $b5041272d7b35505$export$c1955d02b55bd9be; });
$parcel$export(module.exports, "CollectionBundleNameToProductKeyMap", function () { return $b5041272d7b35505$export$288c8597359c2277; });
$parcel$export(module.exports, "TemplateKeys", function () { return $b5041272d7b35505$export$fe3cfcb5926c814e; });

var $3L8ZR = parcelRequire("3L8ZR");

var $6A2DX = parcelRequire("6A2DX");

var $4IlVP = parcelRequire("4IlVP");

var $69SrI = parcelRequire("69SrI");
var $b5041272d7b35505$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["BITBUCKET"] = "com.atlassian.bitbucket";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- intentional alias of JIRA_SERVICE_DESK
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- intentional alias of JIRA_CORE
    ProductKey["JIRA_WORK_MANAGEMENT"] = "jira-core.ondemand";
    ProductKey["ACCESS"] = "com.atlassian.identity-manager";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["CONFLUENCE_PLUGIN_QUESTIONS"] = "com.atlassian.confluence.plugins.confluence-questions.ondemand";
    ProductKey["CONFLUENCE_TEAM_CALENDARS"] = "team.calendars.confluence.ondemand";
    ProductKey["JIRA_ROADMAPS"] = "com.radiantminds.roadmaps-jira.ondemand";
    ProductKey["JIRA_BONFIRE"] = "bonfire.jira.ondemand";
    ProductKey["JIRA_REFAPP"] = "refapp";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    ProductKey["COMPASS"] = "compass";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- intentional alias of TEAM_CENTRAL
    ProductKey["ATLAS"] = "townsquare";
    ProductKey["FABRIC"] = "atlassian-whiteboard";
    ProductKey["BEACON"] = "beacon";
    ProductKey["LOOM"] = "loom";
    ProductKey["ROVO"] = "rovo.ondemand";
    ProductKey["DEVAI"] = "devai.ondemand";
    ProductKey["CUSTOMER_MANAGED_KEYS"] = "com.atlassian.customer-managed-keys";
    ProductKey["JIRA_CUSTOMER_SERVICE"] = "jira-customer-service";
    ProductKey["TEAMWORK_COLLECTION"] = "com.atlassian.teamwork-collection";
    ProductKey["SERVICE_COLLECTION"] = "com.atlassian.service-collection";
    ProductKey["STRATEGY_COLLECTION"] = "com.atlassian.strategy-collection";
    return ProductKey;
}({});
const $b5041272d7b35505$export$920b38c8c1070ab = (productKey)=>{
    if (productKey === "com.atlassian.service-collection") return $b5041272d7b35505$export$d4e88a65c1af65bf["jira-servicedesk.ondemand"];
    if (productKey in $b5041272d7b35505$export$d4e88a65c1af65bf) return $b5041272d7b35505$export$d4e88a65c1af65bf[productKey];
    return $b5041272d7b35505$export$d4e88a65c1af65bf["jira-software.ondemand"];
};
var $b5041272d7b35505$var$PricingType = /*#__PURE__*/ function(PricingType) {
    PricingType["FREE"] = "FREE";
    PricingType["PAID"] = "PAID";
    PricingType["LIMITED_FREE"] = "LIMITED_FREE";
    return PricingType;
}($b5041272d7b35505$var$PricingType || {});
const $b5041272d7b35505$export$801c92020d021357 = [
    'beacon',
    'bitbucket',
    'compass',
    'confluence',
    'confluence-jira-service-management',
    'confluence-jira-software',
    'developer',
    'fabric',
    'jira',
    'jira-product-discovery',
    'jira-service-management',
    'jira-service-management-confluence',
    'jira-service-management-jira-software',
    'jira-service-management-jira-software-confluence',
    'jira-software',
    'jira-software-confluence',
    'jira-software-confluence-compass',
    'jira-software-jira-service-management',
    'jira-software-jira-service-management-confluence',
    'loom',
    'opsgenie',
    'statuspage',
    'devai',
    'service-collection',
    'teamwork-collection',
    'strategy-collection'
];
const $b5041272d7b35505$export$d1f2f60c2544179d = [
    'free',
    'standard',
    'premium'
];
const $b5041272d7b35505$export$d4e88a65c1af65bf = {
    ["confluence.ondemand"]: {
        productKey: "confluence.ondemand",
        productName: 'Confluence',
        productLogo: (0, $6A2DX.ConfluenceLogo)
    },
    ["devai.ondemand"]: {
        productKey: "devai.ondemand",
        productName: 'Rovo Dev Agents',
        productLogo: (0, $69SrI.RovoDevAgentsLogo // Placeholder, replace with actual Dev AI logo when available
        )
    },
    ["jira-servicedesk.ondemand"]: {
        productKey: "jira-servicedesk.ondemand",
        productName: 'Jira Service Management',
        productLogo: (0, $6A2DX.JiraServiceManagementLogo)
    },
    ["jira-software.ondemand"]: {
        productKey: "jira-software.ondemand",
        productName: 'Jira',
        productLogo: (0, $6A2DX.JiraLogo)
    },
    ["com.atlassian.teamwork-collection"]: {
        productKey: "com.atlassian.teamwork-collection",
        productName: 'Teamwork Collection',
        productLogo: (0, $6A2DX.JiraLogo // Placeholder - can be updated when Teamwork Collection logo is available
        )
    },
    ["com.atlassian.service-collection"]: {
        productKey: "com.atlassian.service-collection",
        productName: 'Service Collection',
        productLogo: (0, $6A2DX.JiraLogo)
    },
    ["com.atlassian.strategy-collection"]: {
        productKey: "com.atlassian.strategy-collection",
        productName: 'Strategy Collection',
        productLogo: (0, $6A2DX.JiraLogo)
    },
    ["jira-product-discovery"]: {
        productKey: "jira-product-discovery",
        productName: 'Jira Product Discovery',
        productLogo: (0, $6A2DX.JiraProductDiscoveryLogo)
    },
    ["jira-customer-service"]: {
        productKey: "jira-customer-service",
        productName: 'Customer Service Management',
        productLogo: (0, $6A2DX.JiraServiceManagementIcon)
    }
};
const $b5041272d7b35505$var$OFFERING_IDS = {
    dev: {
        ["jira-software.ondemand"]: {
            free: {
                offeringId: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
                productKey: "jira-software.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["confluence.ondemand"]: {
            free: {
                offeringId: '7547cfd6-a804-4e42-8bed-e656d49ea09e',
                productKey: "confluence.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '2eda1119-fab4-4699-ab37-ff8f12052cde',
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '06ef245c-5fa3-473b-8822-5e6fe072ae4b',
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["jira-servicedesk.ondemand"]: {
            free: {
                offeringId: '2bad3c2f-d740-44a9-b08d-849202f11830',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'agent'
            },
            standard: {
                offeringId: '396efb16-749b-41fa-9cd1-ad10cfefa1d0',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'agent'
            },
            premium: {
                offeringId: '0c6683b4-4633-4673-beca-690d171de6a5',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'agent'
            },
            halp: {
                offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`,
                // https://workbench.staging.atl-paas.net/offerings/396efb16-749b-41fa-9cd1-ad10cfefa1d0
                pricingPlanId: '7701f274-6c84-45cd-bdb0-493a67355e61',
                // https://workbench.staging.atl-paas.net/products/jira-servicedesk.ondemand/plans/7701f274-6c84-45cd-bdb0-493a67355e61
                pricingType: "PAID",
                // pricing type for CCP
                productKey: "jira-servicedesk.ondemand",
                edition: 'standard',
                chargeElement: 'agent'
            }
        },
        ["jira-core.ondemand"]: {
            free: {
                offeringId: '769055e8-05f5-4b1a-ba1a-a1afc874ee6d',
                productKey: "jira-core.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '5ab35ef5-e441-493a-b6e0-ba2d21a72ac6',
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'd8e9a61a-c83b-4e40-a757-997d5bae2bb2',
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["jira-product-discovery"]: {
            free: {
                offeringId: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
                productKey: "jira-product-discovery",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["compass"]: {
            beta: {
                offeringId: '7af07cb3-d4e5-473e-87b3-3ae3bc9248a6',
                productKey: "compass",
                edition: 'beta',
                chargeElement: 'user'
            },
            free: {
                offeringId: '1d1951e5-881c-4f75-b0cd-3c6859dd5759',
                productKey: "compass",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '575abf20-6cac-4bbc-9666-1791fae8d822',
                productKey: "compass",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '4b41c4e3-7f26-4182-a12b-8ed7468350c4',
                productKey: "compass",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["townsquare"]: {
            free: {
                offeringId: '88064fa1-b573-4358-a9de-ec350aac1ddc',
                productKey: "townsquare",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '01c8ddad-8ea4-4da9-8127-71d6ff6de1c9',
                productKey: "townsquare",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5',
                productKey: "townsquare",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["opsgenie"]: {
            free: {
                offeringId: 'd0c6ab1d-d8ea-49f8-8893-eafca2e05158',
                productKey: "opsgenie",
                pricingType: "FREE",
                edition: 'essentials',
                chargeElement: 'user'
            }
        },
        ["atlassian-whiteboard"]: {
            free: {
                offeringId: 'b0c7b413-b264-4c01-8b67-c61aa2c3e455',
                productKey: "atlassian-whiteboard",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            }
        },
        ["statuspage"]: {
            free: {
                offeringId: 'cff16c60-539b-11ea-8d77-2e728ce88125',
                productKey: "statuspage",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            }
        },
        ["com.atlassian.bitbucket"]: {
            free: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["devai.ondemand"]: {
            free: {
                offeringId: 'd69d4faa-7677-48f2-a432-fda525d2e223',
                productKey: "devai.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '7618c3e4-2e84-4a47-b322-d2515835c55a',
                productKey: "devai.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            }
        },
        ["com.atlassian.service-collection"]: {
            free: {
                offeringId: '9705f74d-d4af-48e1-b443-94a8ae9dff54',
                productKey: "com.atlassian.service-collection",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '3e6a7923-6df0-4ab6-b819-2168e8decef3',
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'agent'
            },
            premium: {
                offeringId: '24698695-2f89-495b-b266-109b3f5c2210',
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'agent'
            }
        },
        ["com.atlassian.teamwork-collection"]: {
            free: {
                offeringId: '666dec82-def0-4675-8abe-171d26c968a0',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '7e16cb96-ade2-4220-9010-c71ef9a70cf2',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'b296663a-50d7-4e51-bc53-be058da00dad',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["loom"]: {
            free: {
                offeringId: '67737b67-caad-48af-ac36-01a64e9f220b',
                productKey: "loom",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: 'd009c283-d868-4d90-aa1e-17609d515f0f',
                productKey: "loom",
                pricingType: "PAID",
                edition: 'business',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '3f72cea3-aa1c-446c-a3e4-d09fed86a62c',
                productKey: "loom",
                pricingType: "PAID",
                edition: 'business-ai',
                chargeElement: 'user'
            }
        }
    },
    staging: {
        ["jira-software.ondemand"]: {
            free: {
                offeringId: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
                productKey: "jira-software.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user',
                jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
            },
            standard: {
                offeringId: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user',
                jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
            },
            premium: {
                offeringId: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user',
                jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
            }
        },
        ["confluence.ondemand"]: {
            free: {
                offeringId: '7547cfd6-a804-4e42-8bed-e656d49ea09e',
                productKey: "confluence.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '2eda1119-fab4-4699-ab37-ff8f12052cde',
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '06ef245c-5fa3-473b-8822-5e6fe072ae4b',
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["jira-servicedesk.ondemand"]: {
            free: {
                offeringId: '2bad3c2f-d740-44a9-b08d-849202f11830',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'agent',
                jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
            },
            standard: {
                offeringId: '396efb16-749b-41fa-9cd1-ad10cfefa1d0',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'agent',
                jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
            },
            premium: {
                offeringId: '0c6683b4-4633-4673-beca-690d171de6a5',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'agent',
                jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
            },
            halp: {
                offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`,
                // https://workbench.staging.atl-paas.net/offerings/396efb16-749b-41fa-9cd1-ad10cfefa1d0
                pricingPlanId: '7701f274-6c84-45cd-bdb0-493a67355e61',
                // https://workbench.staging.atl-paas.net/products/jira-servicedesk.ondemand/plans/7701f274-6c84-45cd-bdb0-493a67355e61
                pricingType: "PAID",
                // pricing type for CCP
                productKey: "jira-servicedesk.ondemand",
                edition: 'standard',
                chargeElement: 'agent'
            }
        },
        ["jira-core.ondemand"]: {
            free: {
                offeringId: '769055e8-05f5-4b1a-ba1a-a1afc874ee6d',
                productKey: "jira-core.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user',
                jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
            },
            standard: {
                offeringId: '5ab35ef5-e441-493a-b6e0-ba2d21a72ac6',
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user',
                jiraFamilyOfferingId: '009f8789-c10c-4366-9420-f712d02a6499'
            },
            premium: {
                offeringId: 'd8e9a61a-c83b-4e40-a757-997d5bae2bb2',
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["jira-product-discovery"]: {
            free: {
                offeringId: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
                productKey: "jira-product-discovery",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["compass"]: {
            beta: {
                offeringId: '7af07cb3-d4e5-473e-87b3-3ae3bc9248a6',
                productKey: "compass",
                edition: 'beta',
                chargeElement: 'user'
            },
            free: {
                offeringId: '1d1951e5-881c-4f75-b0cd-3c6859dd5759',
                productKey: "compass",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '575abf20-6cac-4bbc-9666-1791fae8d822',
                productKey: "compass",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '4b41c4e3-7f26-4182-a12b-8ed7468350c4',
                productKey: "compass",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["townsquare"]: {
            free: {
                offeringId: '88064fa1-b573-4358-a9de-ec350aac1ddc',
                productKey: "townsquare",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '01c8ddad-8ea4-4da9-8127-71d6ff6de1c9',
                productKey: "townsquare",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5',
                productKey: "townsquare",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["opsgenie"]: {
            free: {
                offeringId: 'd0c6ab1d-d8ea-49f8-8893-eafca2e05158',
                productKey: "opsgenie",
                pricingType: "FREE",
                edition: 'essentials',
                chargeElement: 'user'
            }
        },
        ["atlassian-whiteboard"]: {
            free: {
                offeringId: 'b0c7b413-b264-4c01-8b67-c61aa2c3e455',
                productKey: "atlassian-whiteboard",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            }
        },
        ["statuspage"]: {
            free: {
                offeringId: 'cff16c60-539b-11ea-8d77-2e728ce88125',
                productKey: "statuspage",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            }
        },
        ["com.atlassian.bitbucket"]: {
            free: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["devai.ondemand"]: {
            free: {
                offeringId: 'd69d4faa-7677-48f2-a432-fda525d2e223',
                productKey: "devai.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '7618c3e4-2e84-4a47-b322-d2515835c55a',
                productKey: "devai.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            }
        },
        ["com.atlassian.customer-managed-keys"]: {
            standard: {
                offeringId: 'c8a6f3e4-0134-4cd3-9d23-63d834651c6b',
                productKey: "com.atlassian.customer-managed-keys",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            }
        },
        ["com.atlassian.service-collection"]: {
            free: {
                offeringId: '9705f74d-d4af-48e1-b443-94a8ae9dff54',
                productKey: "com.atlassian.service-collection",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '3e6a7923-6df0-4ab6-b819-2168e8decef3',
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'agent'
            },
            premium: {
                offeringId: '24698695-2f89-495b-b266-109b3f5c2210',
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'agent'
            }
        },
        ["com.atlassian.teamwork-collection"]: {
            free: {
                offeringId: '666dec82-def0-4675-8abe-171d26c968a0',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '7e16cb96-ade2-4220-9010-c71ef9a70cf2',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'b296663a-50d7-4e51-bc53-be058da00dad',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["loom"]: {
            free: {
                offeringId: '67737b67-caad-48af-ac36-01a64e9f220b',
                productKey: "loom",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: 'd009c283-d868-4d90-aa1e-17609d515f0f',
                productKey: "loom",
                pricingType: "PAID",
                edition: 'business',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '3f72cea3-aa1c-446c-a3e4-d09fed86a62c',
                productKey: "loom",
                pricingType: "PAID",
                edition: 'business-ai',
                chargeElement: 'user'
            }
        }
    },
    production: {
        ["jira-software.ondemand"]: {
            free: {
                offeringId: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
                productKey: "jira-software.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["confluence.ondemand"]: {
            free: {
                offeringId: '7547cfd6-a804-4e42-8bed-e656d49ea09e',
                productKey: "confluence.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '2eda1119-fab4-4699-ab37-ff8f12052cde',
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '06ef245c-5fa3-473b-8822-5e6fe072ae4b',
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["jira-servicedesk.ondemand"]: {
            free: {
                offeringId: '2bad3c2f-d740-44a9-b08d-849202f11830',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'agent'
            },
            standard: {
                offeringId: '396efb16-749b-41fa-9cd1-ad10cfefa1d0',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'agent'
            },
            premium: {
                offeringId: '0c6683b4-4633-4673-beca-690d171de6a5',
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'agent'
            },
            halp: {
                offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`,
                pricingPlanId: '200b2088-934b-4669-b7c5-7ae6961c9368',
                // https://workbench.prod.atl-paas.net/products/jira-servicedesk.ondemand/plans/200b2088-934b-4669-b7c5-7ae6961c9368
                pricingType: "PAID",
                // pricing type for CCP
                productKey: "jira-servicedesk.ondemand",
                edition: 'standard',
                chargeElement: 'agent'
            }
        },
        ["jira-core.ondemand"]: {
            free: {
                offeringId: '769055e8-05f5-4b1a-ba1a-a1afc874ee6d',
                productKey: "jira-core.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '5ab35ef5-e441-493a-b6e0-ba2d21a72ac6',
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'd8e9a61a-c83b-4e40-a757-997d5bae2bb2',
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["jira-product-discovery"]: {
            free: {
                offeringId: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
                productKey: "jira-product-discovery",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["compass"]: {
            beta: {
                offeringId: '7af07cb3-d4e5-473e-87b3-3ae3bc9248a6',
                productKey: 'compass',
                edition: 'beta',
                chargeElement: 'user'
            },
            free: {
                offeringId: '1d1951e5-881c-4f75-b0cd-3c6859dd5759',
                productKey: "compass",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '575abf20-6cac-4bbc-9666-1791fae8d822',
                productKey: "compass",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '4b41c4e3-7f26-4182-a12b-8ed7468350c4',
                productKey: "compass",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["townsquare"]: {
            free: {
                offeringId: '88064fa1-b573-4358-a9de-ec350aac1ddc',
                productKey: "townsquare",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '01c8ddad-8ea4-4da9-8127-71d6ff6de1c9',
                productKey: "townsquare",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5',
                productKey: "townsquare",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["opsgenie"]: {
            free: {
                offeringId: 'd0c6ab1d-d8ea-49f8-8893-eafca2e05158',
                productKey: "opsgenie",
                pricingType: "FREE",
                edition: 'essentials',
                chargeElement: 'user'
            }
        },
        ["atlassian-whiteboard"]: {
            free: {
                offeringId: 'b0c7b413-b264-4c01-8b67-c61aa2c3e455',
                productKey: "atlassian-whiteboard",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            }
        },
        ["statuspage"]: {
            free: {
                offeringId: 'cff16c60-539b-11ea-8d77-2e728ce88125',
                productKey: "statuspage",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            }
        },
        ["com.atlassian.bitbucket"]: {
            free: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '00000000-0000-0000-0000-000000000000',
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["devai.ondemand"]: {
            free: {
                offeringId: 'd69d4faa-7677-48f2-a432-fda525d2e223',
                productKey: "devai.ondemand",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '7618c3e4-2e84-4a47-b322-d2515835c55a',
                productKey: "devai.ondemand",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            }
        },
        ["com.atlassian.customer-managed-keys"]: {
            standard: {
                offeringId: 'c8a6f3e4-0134-4cd3-9d23-63d834651c6b',
                productKey: "com.atlassian.customer-managed-keys",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            }
        },
        ["com.atlassian.service-collection"]: {
            free: {
                offeringId: '9705f74d-d4af-48e1-b443-94a8ae9dff54',
                productKey: "com.atlassian.service-collection",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '3e6a7923-6df0-4ab6-b819-2168e8decef3',
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'agent'
            },
            premium: {
                offeringId: '24698695-2f89-495b-b266-109b3f5c2210',
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'agent'
            }
        },
        ["com.atlassian.teamwork-collection"]: {
            free: {
                offeringId: '666dec82-def0-4675-8abe-171d26c968a0',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: '7e16cb96-ade2-4220-9010-c71ef9a70cf2',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: 'standard',
                chargeElement: 'user'
            },
            premium: {
                offeringId: 'b296663a-50d7-4e51-bc53-be058da00dad',
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: 'premium',
                chargeElement: 'user'
            }
        },
        ["loom"]: {
            free: {
                offeringId: '67737b67-caad-48af-ac36-01a64e9f220b',
                productKey: "loom",
                pricingType: "FREE",
                edition: 'free',
                chargeElement: 'user'
            },
            standard: {
                offeringId: 'd009c283-d868-4d90-aa1e-17609d515f0f',
                productKey: "loom",
                pricingType: "PAID",
                edition: 'business',
                chargeElement: 'user'
            },
            premium: {
                offeringId: '3f72cea3-aa1c-446c-a3e4-d09fed86a62c',
                productKey: "loom",
                pricingType: "PAID",
                edition: 'business-ai',
                chargeElement: 'user'
            }
        }
    }
};
var $b5041272d7b35505$export$c654666118e350a8 = /*#__PURE__*/ function(OrgBasedProduct) {
    OrgBasedProduct["GUARD_PREMIUM"] = "GUARD_PREMIUM";
    OrgBasedProduct["GUARD_PREMIUM_DEMO"] = "GUARD_PREMIUM_DEMO";
    OrgBasedProduct["GUARD_STANDARD"] = "GUARD_STANDARD";
    OrgBasedProduct["ROVO_ORG"] = "ROVO_ORG";
    OrgBasedProduct["ROVO_ORG_DEMO"] = "ROVO_ORG_DEMO";
    OrgBasedProduct["ROVO_ORG_FREE"] = "ROVO_ORG_FREE";
    OrgBasedProduct["ROVO_CREDITS_PACK"] = "ROVO_CREDITS_PACK";
    OrgBasedProduct["ASSET_CREDITS_PACK"] = "ASSET_CREDITS_PACK";
    OrgBasedProduct["AUTOMATION_CREDITS_PACK"] = "AUTOMATION_CREDITS_PACK";
    OrgBasedProduct["CS_RESOLUTION_CREDITS_PACK"] = "CS_RESOLUTION_CREDITS_PACK";
    OrgBasedProduct["BITBUCKET_LFS_STORAGE_CREDITS_PACK"] = "BITBUCKET_LFS_STORAGE_CREDITS_PACK";
    OrgBasedProduct["BITBUCKET_BUILD_TIME_CREDITS_PACK"] = "BITBUCKET_BUILD_TIME_CREDITS_PACK";
    OrgBasedProduct["BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK"] = "BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK";
    OrgBasedProduct["BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK"] = "BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK";
    OrgBasedProduct["INDEXED_OBJECTS_PACK"] = "INDEXED_OBJECTS_PACK";
    OrgBasedProduct["TWC_ORG_FREE"] = "TWC_ORG_FREE";
    OrgBasedProduct["TWC_ORG_STANDARD"] = "TWC_ORG_STANDARD";
    OrgBasedProduct["TWC_ORG_PREMIUM"] = "TWC_ORG_PREMIUM";
    OrgBasedProduct["TWC_ORG_PREMIUM_BILLED_SEPARATELY"] = "TWC_ORG_PREMIUM_BILLED_SEPARATELY";
    OrgBasedProduct["TWC_ORG_ENTERPRISE"] = "TWC_ORG_ENTERPRISE";
    OrgBasedProduct["STRATEGY_ORG_ENTERPRISE"] = "STRATEGY_ORG_ENTERPRISE";
    OrgBasedProduct["CUSTOMER_MANAGED_KEYS"] = "CUSTOMER_MANAGED_KEYS";
    OrgBasedProduct["CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY"] = "CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY";
    OrgBasedProduct["SERVICE_COLLECTION_ORG_FREE"] = "SERVICE_COLLECTION_ORG_FREE";
    OrgBasedProduct["SERVICE_COLLECTION_ORG_STANDARD"] = "SERVICE_COLLECTION_ORG_STANDARD";
    OrgBasedProduct["SERVICE_COLLECTION_ORG_PREMIUM"] = "SERVICE_COLLECTION_ORG_PREMIUM";
    OrgBasedProduct["SERVICE_COLLECTION_ORG_ENTERPRISE"] = "SERVICE_COLLECTION_ORG_ENTERPRISE";
    return OrgBasedProduct;
}({});
const $b5041272d7b35505$export$4b199ba4373834 = 'https://support.atlassian.com/security-and-access-policies/docs/set-up-cmk-enabled-atlassian-apps/';
const $b5041272d7b35505$export$470b3b1706479a64 = {
    GUARD_PREMIUM: '2f5e5808-d501-450a-b246-b0bd50a0b72a',
    GUARD_PREMIUM_DEMO: '2081c1b7-2ad6-3e40-a7c2-5a7f876a38a7',
    GUARD_STANDARD: '1ac3b7dd-7141-414e-bc00-c890acc458b0',
    ROVO_ORG: 'e7de08be-3d20-423e-b928-dd1fd325da7a',
    ROVO_ORG_DEMO: 'df531ba8-186a-3924-96a3-23056fa96f3f',
    ROVO_ORG_FREE: '71f2d378-1960-4336-8e7b-6af35174650c',
    ROVO_CREDITS_PACK: '918c0980-3992-4e57-a76e-0bde1c94e435',
    ASSET_CREDITS_PACK: '36a69b0a-bf2f-4d40-bb95-6b2a40d52718',
    AUTOMATION_CREDITS_PACK: 'bf680870-2670-4487-8ba3-ba6c9c49eb63',
    CS_RESOLUTION_CREDITS_PACK: '2b89e53d-62e7-42da-9174-9177ad961054',
    BITBUCKET_LFS_STORAGE_CREDITS_PACK: '3912fe8d-5b2e-4c38-a3d8-84552ca5b9d0',
    BITBUCKET_BUILD_TIME_CREDITS_PACK: '6e224a30-1516-49c9-ae19-69c803f25df4',
    BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK: '050ca109-c952-45bf-ace9-3ecea0db8752',
    BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK: '2cbd0691-5925-43e6-93d8-da14e2570ee9',
    INDEXED_OBJECTS_PACK: '083e1434-9d6a-4478-8534-7e586038775c',
    TWC_ORG_STANDARD: '7e16cb96-ade2-4220-9010-c71ef9a70cf2',
    TWC_ORG_PREMIUM: 'b296663a-50d7-4e51-bc53-be058da00dad',
    TWC_ORG_PREMIUM_BILLED_SEPARATELY: '17c64528-3ce0-3ce5-8d61-26726b323416',
    TWC_ORG_ENTERPRISE: 'cf0b0103-2f08-4c87-97cf-a69448d6e69a',
    TWC_ORG_FREE: '666dec82-def0-4675-8abe-171d26c968a0',
    STRATEGY_ORG_ENTERPRISE: 'b7da0afa-6941-4010-9c29-cc8739f6fbf8',
    CUSTOMER_MANAGED_KEYS: 'c8a6f3e4-0134-4cd3-9d23-63d834651c6b',
    CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY: '742112ad-8294-302d-bcab-b08362e15dee',
    SERVICE_COLLECTION_ORG_FREE: '9705f74d-d4af-48e1-b443-94a8ae9dff54',
    SERVICE_COLLECTION_ORG_STANDARD: '3e6a7923-6df0-4ab6-b819-2168e8decef3',
    SERVICE_COLLECTION_ORG_PREMIUM: '24698695-2f89-495b-b266-109b3f5c2210',
    SERVICE_COLLECTION_ORG_ENTERPRISE: 'c1b6f7ce-21f9-4e85-b136-91f4c484b95d'
};
const $b5041272d7b35505$export$629756db0300364b = [
    $b5041272d7b35505$export$470b3b1706479a64.CUSTOMER_MANAGED_KEYS,
    $b5041272d7b35505$export$470b3b1706479a64.CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY
];
const $b5041272d7b35505$export$7d55d65617002a4c = new Set([
    $b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_FREE,
    $b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_STANDARD,
    $b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_PREMIUM,
    $b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_PREMIUM_BILLED_SEPARATELY,
    $b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_ENTERPRISE,
    $b5041272d7b35505$export$470b3b1706479a64.STRATEGY_ORG_ENTERPRISE,
    $b5041272d7b35505$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_FREE,
    $b5041272d7b35505$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_STANDARD,
    $b5041272d7b35505$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_PREMIUM,
    $b5041272d7b35505$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_ENTERPRISE
]);
const $b5041272d7b35505$export$a20d8b3133159060 = {
    [$b5041272d7b35505$export$470b3b1706479a64.GUARD_PREMIUM]: "GUARD_PREMIUM",
    [$b5041272d7b35505$export$470b3b1706479a64.GUARD_PREMIUM_DEMO]: "GUARD_PREMIUM_DEMO",
    [$b5041272d7b35505$export$470b3b1706479a64.GUARD_STANDARD]: "GUARD_STANDARD",
    [$b5041272d7b35505$export$470b3b1706479a64.ROVO_ORG]: "ROVO_ORG",
    [$b5041272d7b35505$export$470b3b1706479a64.ROVO_ORG_DEMO]: "ROVO_ORG_DEMO",
    [$b5041272d7b35505$export$470b3b1706479a64.ROVO_ORG_FREE]: "ROVO_ORG_FREE",
    [$b5041272d7b35505$export$470b3b1706479a64.ROVO_CREDITS_PACK]: "ROVO_CREDITS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.ASSET_CREDITS_PACK]: "ASSET_CREDITS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.AUTOMATION_CREDITS_PACK]: "AUTOMATION_CREDITS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.CS_RESOLUTION_CREDITS_PACK]: "CS_RESOLUTION_CREDITS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.BITBUCKET_LFS_STORAGE_CREDITS_PACK]: "BITBUCKET_LFS_STORAGE_CREDITS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.BITBUCKET_BUILD_TIME_CREDITS_PACK]: "BITBUCKET_BUILD_TIME_CREDITS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK]: "BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK]: "BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.INDEXED_OBJECTS_PACK]: "INDEXED_OBJECTS_PACK",
    [$b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_FREE]: "TWC_ORG_FREE",
    [$b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_STANDARD]: "TWC_ORG_STANDARD",
    [$b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_PREMIUM]: "TWC_ORG_PREMIUM",
    [$b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_PREMIUM_BILLED_SEPARATELY]: "TWC_ORG_PREMIUM_BILLED_SEPARATELY",
    [$b5041272d7b35505$export$470b3b1706479a64.TWC_ORG_ENTERPRISE]: "TWC_ORG_ENTERPRISE",
    [$b5041272d7b35505$export$470b3b1706479a64.STRATEGY_ORG_ENTERPRISE]: "STRATEGY_ORG_ENTERPRISE",
    [$b5041272d7b35505$export$470b3b1706479a64.CUSTOMER_MANAGED_KEYS]: "CUSTOMER_MANAGED_KEYS",
    [$b5041272d7b35505$export$470b3b1706479a64.CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY]: "CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY",
    [$b5041272d7b35505$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_FREE]: "SERVICE_COLLECTION_ORG_FREE",
    [$b5041272d7b35505$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_STANDARD]: "SERVICE_COLLECTION_ORG_STANDARD",
    [$b5041272d7b35505$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_PREMIUM]: "SERVICE_COLLECTION_ORG_PREMIUM",
    [$b5041272d7b35505$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_ENTERPRISE]: "SERVICE_COLLECTION_ORG_ENTERPRISE"
};
const $b5041272d7b35505$export$f9f96fa5fb066102 = ({ productKey: productKey, edition: edition, primaryCollectionProduct: primaryCollectionProduct })=>{
    const products = $b5041272d7b35505$var$OFFERING_IDS[(0, $4IlVP.getEnvironment)()];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- referenced as a type via `keyof typeof editions`
    const editions = $b5041272d7b35505$var$OFFERING_IDS[(0, $4IlVP.getEnvironment)()][productKey];
    const ccpProduct = products[productKey][edition];
    // Update JSM standard offeringId to the new one if feature gate is enabled
    // TODO: Remove this once successfully migrated to use the new offeringId
    if (ccpProduct.offeringId === '396efb16-749b-41fa-9cd1-ad10cfefa1d0') {
        const isNewJSMOfferingIdEnabled = (0, $3L8ZR.default).checkGate('signup_update_jsm_standard_offeringid');
        if (isNewJSMOfferingIdEnabled) {
            const newCcpProduct = {
                ...ccpProduct,
                offeringId: '99bcbf6c-4fff-4a45-8303-a854e7fbd17c'
            };
            return newCcpProduct;
        }
    } else if (ccpProduct.offeringId === 'd843dd9e-23c5-4d27-af44-5009d568cb6e') {
        // JPD Free
        const isNewJPDOfferingIdEnabled = (0, $3L8ZR.default).checkGate('signup_update_jpd_offeringids');
        if (isNewJPDOfferingIdEnabled) {
            const newCcpProduct = {
                ...ccpProduct,
                offeringId: 'd2b66d44-0754-4c89-8d3b-c8f9a8102184'
            };
            return newCcpProduct;
        }
    } else if (ccpProduct.offeringId === '35b9268e-66e2-45fb-81d3-dacd1e31831a') {
        // JPD Standard
        const isNewJPDOfferingIdEnabled = (0, $3L8ZR.default).checkGate('signup_update_jpd_offeringids');
        if (isNewJPDOfferingIdEnabled) {
            const newCcpProduct = {
                ...ccpProduct,
                offeringId: 'cb8bc8af-491f-41be-8502-ae5de94d04f0'
            };
            return newCcpProduct;
        }
    }
    // service collections with a primaryCollectionProduct prioritize that product first
    const childProductsForPriorityActivation = productKey === "com.atlassian.service-collection" && primaryCollectionProduct ? [
        primaryCollectionProduct
    ] : [];
    if (childProductsForPriorityActivation.length > 0) return {
        ...ccpProduct,
        childProductsForPriorityActivation: childProductsForPriorityActivation
    };
    return ccpProduct;
};
const $b5041272d7b35505$export$1a4f641784fb4df4 = (offeringId)=>{
    const products = $b5041272d7b35505$var$OFFERING_IDS[(0, $4IlVP.getEnvironment)()];
    // Search through all productKeys and editions to find the matching offeringId
    for(const productKey in products){
        const productEditions = products[productKey];
        if (!productEditions) continue;
        for(const edition in productEditions){
            const ccpProduct = productEditions[edition];
            if (ccpProduct.offeringId === offeringId) return {
                productKey: ccpProduct.productKey,
                edition: ccpProduct.edition
            };
        }
    }
    return null;
};
const $b5041272d7b35505$export$75ed3732be18be33 = {
    ["com.atlassian.teamwork-collection"]: "jira-software.ondemand",
    ["com.atlassian.service-collection"]: "jira-servicedesk.ondemand"
};
const $b5041272d7b35505$export$5c5446db708910b8 = {
    ["jira-servicedesk.ondemand"]: 'jira-servicedesk',
    ["jira-customer-service"]: 'jira-customer-service',
    ["jira-software.ondemand"]: 'jira-software',
    ["confluence.ondemand"]: 'confluence',
    ["loom"]: 'loom'
};
const $b5041272d7b35505$export$c1955d02b55bd9be = {
    ["com.atlassian.service-collection"]: [
        "jira-servicedesk.ondemand",
        "jira-customer-service"
    ],
    ["com.atlassian.teamwork-collection"]: [
        "jira-software.ondemand",
        "confluence.ondemand",
        "loom"
    ]
};
const $b5041272d7b35505$export$288c8597359c2277 = {
    'service-collection': "com.atlassian.service-collection",
    'teamwork-collection': "com.atlassian.teamwork-collection"
};
const $b5041272d7b35505$export$d7e04b0ebb68822a = Object.entries($b5041272d7b35505$export$288c8597359c2277).reduce((acc, [bundleName, productKey])=>{
    acc[productKey] = bundleName;
    return acc;
}, {});
const $b5041272d7b35505$export$fe3cfcb5926c814e = {
    SimplifiedBasic: 'com.pyxis.greenhopper.jira:gh-simplified-basic',
    Scrum: 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum',
    Kanban: 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban',
    WebDesignProcess: 'com.atlassian.jira-core-project-templates:jira-work-management-web-design-process',
    GoToMarket: 'com.atlassian.jira-core-project-templates:jira-work-management-go-to-market',
    SimplifiedProcessControl: 'com.atlassian.jira-core-project-templates:jira-core-simplified-process-control',
    ProcessControlTeamManaged: 'com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed',
    SalesPipeline: 'com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline',
    SimplifiedProcurement: 'com.atlassian.jira-core-project-templates:jira-core-simplified-procurement',
    EmployeeOnboarding: 'com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding',
    PersonalTaskPlanner: 'com.atlassian.jira-core-project-templates:jira-work-management-personal-task-planner',
    CampaignManagement: 'com.atlassian.jira-core-project-templates:jira-work-management-campaign-management',
    CampaignManagementTeamManaged: 'com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed',
    CampaignManagementV2TeamManaged: 'com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed-v2',
    Recruitment: 'com.atlassian.jira-core-project-templates:jira-core-simplified-recruitment',
    RecruitmentTeamManaged: 'com.atlassian.jira-core-project-templates:jira-work-management-recruitment-team-managed',
    LeadTracking: 'com.atlassian.jira-core-project-templates:jira-core-simplified-lead-tracking',
    LeadTrackingTeamManaged: 'com.atlassian.jira-core-project-templates:jira-work-management-lead-tracking-team-managed',
    MonthEndClose: 'com.atlassian.jira-core-project-templates:jira-work-management-month-end-close',
    MonthEndCloseTeamManaged: 'com.atlassian.jira-core-project-templates:jira-work-management-month-end-close-team-managed'
};

});
parcelRegister("6A2DX", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", function () { return $4ca827d54330e86a$export$ef8e5f836dd989d3; });
$parcel$export(module.exports, "AdminLogo", function () { return $4ca827d54330e86a$export$ebcd30672e67406; });
$parcel$export(module.exports, "AnalyticsIcon", function () { return $4ca827d54330e86a$export$af3460f51ce3602a; });
$parcel$export(module.exports, "AnalyticsLogo", function () { return $4ca827d54330e86a$export$c8415b6abe4a8587; });
$parcel$export(module.exports, "AssetsIcon", function () { return $4ca827d54330e86a$export$d89497e7f33ca6f5; });
$parcel$export(module.exports, "AssetsLogo", function () { return $4ca827d54330e86a$export$48ca930f3071e3e4; });
$parcel$export(module.exports, "ChatIcon", function () { return $4ca827d54330e86a$export$52cd484a7ef4f2b9; });
$parcel$export(module.exports, "ChatLogo", function () { return $4ca827d54330e86a$export$9ca9881809919df8; });
$parcel$export(module.exports, "CustomerServiceManagementIcon", function () { return $4ca827d54330e86a$export$6da5aa77c402ba0f; });
$parcel$export(module.exports, "CustomerServiceManagementLogo", function () { return $4ca827d54330e86a$export$abc95e6180bb1d88; });
$parcel$export(module.exports, "GoalsIcon", function () { return $4ca827d54330e86a$export$9eb74917ea768ed4; });
$parcel$export(module.exports, "GoalsLogo", function () { return $4ca827d54330e86a$export$d2577aa28451395f; });
$parcel$export(module.exports, "HomeIcon", function () { return $4ca827d54330e86a$export$92c8767b874048d; });
$parcel$export(module.exports, "HomeLogo", function () { return $4ca827d54330e86a$export$d5648119d5b68e90; });
$parcel$export(module.exports, "HubIcon", function () { return $4ca827d54330e86a$export$80b8b269d8b5014e; });
$parcel$export(module.exports, "HubLogo", function () { return $4ca827d54330e86a$export$fc9bd6687b80fe3b; });
$parcel$export(module.exports, "ProjectsIcon", function () { return $4ca827d54330e86a$export$5ed3e1bb3b04fc02; });
$parcel$export(module.exports, "ProjectsLogo", function () { return $4ca827d54330e86a$export$aeefab651bcf2338; });
$parcel$export(module.exports, "RovoDevIcon", function () { return $4ca827d54330e86a$export$8b784b3227531b3e; });
$parcel$export(module.exports, "RovoDevLogo", function () { return $4ca827d54330e86a$export$f0750468d67c6902; });
$parcel$export(module.exports, "RovoDevAgentIcon", function () { return $4ca827d54330e86a$export$813cff80931d9dbf; });
$parcel$export(module.exports, "RovoDevAgentLogo", function () { return $4ca827d54330e86a$export$409b7a5b7f180eba; });
$parcel$export(module.exports, "SearchIcon", function () { return $4ca827d54330e86a$export$82eafebb825fc23f; });
$parcel$export(module.exports, "SearchLogo", function () { return $4ca827d54330e86a$export$e4c5487c9a8ae3b1; });
$parcel$export(module.exports, "StudioIcon", function () { return $4ca827d54330e86a$export$290a0f24614cde9f; });
$parcel$export(module.exports, "StudioLogo", function () { return $4ca827d54330e86a$export$8aceb78c659789b6; });
$parcel$export(module.exports, "TalentIcon", function () { return $4ca827d54330e86a$export$4b05688514531169; });
$parcel$export(module.exports, "TalentLogo", function () { return $4ca827d54330e86a$export$4f6453e012279f89; });
$parcel$export(module.exports, "TeamsIcon", function () { return $4ca827d54330e86a$export$1bcbc9c337da86da; });
$parcel$export(module.exports, "TeamsLogo", function () { return $4ca827d54330e86a$export$9b1a0a0c574cec2a; });
$parcel$export(module.exports, "BambooIcon", function () { return $4ca827d54330e86a$export$e812398311cab9a3; });
$parcel$export(module.exports, "BambooLogo", function () { return $4ca827d54330e86a$export$765f5afcc1a5a7e3; });
$parcel$export(module.exports, "BitbucketDataCenterIcon", function () { return $4ca827d54330e86a$export$d3ab16bbf4f954ee; });
$parcel$export(module.exports, "BitbucketDataCenterLogo", function () { return $4ca827d54330e86a$export$36044946916e84a0; });
$parcel$export(module.exports, "ConfluenceDataCenterIcon", function () { return $4ca827d54330e86a$export$53305f1f2855d3be; });
$parcel$export(module.exports, "ConfluenceDataCenterLogo", function () { return $4ca827d54330e86a$export$5e06396bce773a3; });
$parcel$export(module.exports, "CrowdIcon", function () { return $4ca827d54330e86a$export$eaf73f391f7103bd; });
$parcel$export(module.exports, "CrowdLogo", function () { return $4ca827d54330e86a$export$6128b385660fd3c6; });
$parcel$export(module.exports, "JiraDataCenterIcon", function () { return $4ca827d54330e86a$export$f8455b5667a3ee0c; });
$parcel$export(module.exports, "JiraDataCenterLogo", function () { return $4ca827d54330e86a$export$eb152ab3801b2ae3; });
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", function () { return $4ca827d54330e86a$export$65fae0eaf343f2ca; });
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogo", function () { return $4ca827d54330e86a$export$fffc0d480fb1ebf1; });
$parcel$export(module.exports, "AtlassianAdministrationIcon", function () { return $4ca827d54330e86a$export$74517ed253186308; });
$parcel$export(module.exports, "AtlassianAdministrationLogo", function () { return $4ca827d54330e86a$export$833abe6c2ce5ebfd; });
$parcel$export(module.exports, "AtlassianAdminIcon", function () { return $4ca827d54330e86a$export$84109e099492cb5f; });
$parcel$export(module.exports, "AtlassianAdminLogo", function () { return $4ca827d54330e86a$export$f845d9b9254f0541; });
$parcel$export(module.exports, "AtlassianAnalyticsIcon", function () { return $4ca827d54330e86a$export$c42ad8a0b925c762; });
$parcel$export(module.exports, "AtlassianAnalyticsLogo", function () { return $4ca827d54330e86a$export$e6470bfc39010cc4; });
$parcel$export(module.exports, "BitbucketIcon", function () { return $4ca827d54330e86a$export$5fc1066e677788d4; });
$parcel$export(module.exports, "BitbucketLogo", function () { return $4ca827d54330e86a$export$bd40525f5333524b; });
$parcel$export(module.exports, "CompassIcon", function () { return $4ca827d54330e86a$export$f7857fe64d7161d9; });
$parcel$export(module.exports, "CompassLogo", function () { return $4ca827d54330e86a$export$eb7d748e4f9c9676; });
$parcel$export(module.exports, "DxIcon", function () { return $4ca827d54330e86a$export$9951d02c2d848122; });
$parcel$export(module.exports, "ConfluenceIcon", function () { return $4ca827d54330e86a$export$68f3db7f6af48bcb; });
$parcel$export(module.exports, "ConfluenceLogo", function () { return $4ca827d54330e86a$export$1b2e4fe6ef471556; });
$parcel$export(module.exports, "AlignIcon", function () { return $4ca827d54330e86a$export$70a0c2f5862937b6; });
$parcel$export(module.exports, "AlignLogo", function () { return $4ca827d54330e86a$export$1b8596b4b0ef673b; });
$parcel$export(module.exports, "JiraAlignIcon", function () { return $4ca827d54330e86a$export$407687b2dd89cc68; });
$parcel$export(module.exports, "JiraAlignLogo", function () { return $4ca827d54330e86a$export$ee11e928d3d045fd; });
$parcel$export(module.exports, "JiraIcon", function () { return $4ca827d54330e86a$export$c4b5b1f965d8b3eb; });
$parcel$export(module.exports, "JiraLogo", function () { return $4ca827d54330e86a$export$17d3acb0b4379d02; });
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $4ca827d54330e86a$export$21bfbeb62fdcce8d; });
$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $4ca827d54330e86a$export$c49a2b642fe9eef4; });
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $4ca827d54330e86a$export$3c6158790f5e01c4; });
$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $4ca827d54330e86a$export$dabef2be6cd28c20; });
$parcel$export(module.exports, "LoomIcon", function () { return $4ca827d54330e86a$export$8d789f76fde3e05; });
$parcel$export(module.exports, "LoomLogo", function () { return $4ca827d54330e86a$export$94e206806e36c2ec; });
$parcel$export(module.exports, "LoomAttributionIcon", function () { return $4ca827d54330e86a$export$1bf47cdade1a9fcb; });
$parcel$export(module.exports, "LoomAttributionLogo", function () { return $4ca827d54330e86a$export$6e87ce8d41eda665; });
$parcel$export(module.exports, "LoomBlurpleLogo", function () { return $4ca827d54330e86a$export$e84e925618e0e5bc; });
$parcel$export(module.exports, "LoomBlurpleIcon", function () { return $4ca827d54330e86a$export$1940ba72c868b663; });
$parcel$export(module.exports, "OpsgenieIcon", function () { return $4ca827d54330e86a$export$eeccc49dc7a12d9f; });
$parcel$export(module.exports, "OpsgenieLogo", function () { return $4ca827d54330e86a$export$a1c6484cdecc2c4b; });
$parcel$export(module.exports, "StatuspageIcon", function () { return $4ca827d54330e86a$export$f3f5aa321d88adf9; });
$parcel$export(module.exports, "StatuspageLogo", function () { return $4ca827d54330e86a$export$bb4ae5b41b43be04; });
$parcel$export(module.exports, "TrelloIcon", function () { return $4ca827d54330e86a$export$4384da9b8b140bf4; });
$parcel$export(module.exports, "TrelloLogo", function () { return $4ca827d54330e86a$export$60e26212f3b61a28; });
$parcel$export(module.exports, "RovoIcon", function () { return $4ca827d54330e86a$export$e23ae35269442b4f; });
$parcel$export(module.exports, "RovoLogo", function () { return $4ca827d54330e86a$export$a0f6cb8061290bbb; });
$parcel$export(module.exports, "GuardIcon", function () { return $4ca827d54330e86a$export$3f95fcfdc25a741d; });
$parcel$export(module.exports, "GuardLogo", function () { return $4ca827d54330e86a$export$a4a891d202775deb; });
$parcel$export(module.exports, "FocusIcon", function () { return $4ca827d54330e86a$export$1e02e7298035a77c; });
$parcel$export(module.exports, "FocusLogo", function () { return $4ca827d54330e86a$export$33908560ea1b226d; });
$parcel$export(module.exports, "AtlasIcon", function () { return (parcelRequire("gk333")).AtlasIcon; });
$parcel$export(module.exports, "AtlasLogo", function () { return (parcelRequire("2PLlk")).AtlasLogo; });
$parcel$export(module.exports, "AtlassianMarketplaceIcon", function () { return (parcelRequire("eghee")).AtlassianMarketplaceIcon; });
$parcel$export(module.exports, "AtlassianMarketplaceLogo", function () { return (parcelRequire("lhNXG")).AtlassianMarketplaceLogo; });
$parcel$export(module.exports, "AtlassianAccessIcon", function () { return (parcelRequire("7RMEp")).AtlassianAccessIcon; });
$parcel$export(module.exports, "AtlassianAccessLogo", function () { return (parcelRequire("iE23F")).AtlassianAccessLogo; });
$parcel$export(module.exports, "JiraWorkManagementLogo", function () { return (parcelRequire("19O2G")).JiraWorkManagementLogo; });
$parcel$export(module.exports, "JiraWorkManagementIcon", function () { return (parcelRequire("hwfCF")).JiraWorkManagementIcon; });
$parcel$export(module.exports, "AtlassianIcon", function () { return (parcelRequire("zADBD")).AtlassianIcon; });
$parcel$export(module.exports, "AtlassianLogo", function () { return (parcelRequire("5YGzb")).AtlassianLogo; });
$parcel$export(module.exports, "JiraSoftwareIcon", function () { return (parcelRequire("2b30R")).JiraSoftwareIcon; });
$parcel$export(module.exports, "JiraSoftwareLogo", function () { return (parcelRequire("ebfhn")).JiraSoftwareLogo; });

var $cPO2v = parcelRequire("cPO2v");
var $9cCpG = parcelRequire("9cCpG");

var $bCzpe = parcelRequire("bCzpe");
var $cDJWV = parcelRequire("cDJWV");

var $8rxGh = parcelRequire("8rxGh");
var $91WqM = parcelRequire("91WqM");

var $17kte = parcelRequire("17kte");
var $kHB7Y = parcelRequire("kHB7Y");

var $8S3nu = parcelRequire("8S3nu");
var $7ybpy = parcelRequire("7ybpy");

var $8jaqE = parcelRequire("8jaqE");
var $2Ckgd = parcelRequire("2Ckgd");

var $6it9A = parcelRequire("6it9A");
var $lMzFA = parcelRequire("lMzFA");

var $krlR6 = parcelRequire("krlR6");
var $9EwIf = parcelRequire("9EwIf");

var $6boaO = parcelRequire("6boaO");
var $2ZeZj = parcelRequire("2ZeZj");

var $l2w68 = parcelRequire("l2w68");
var $hOHDu = parcelRequire("hOHDu");

var $gsgV2 = parcelRequire("gsgV2");
var $cYGO7 = parcelRequire("cYGO7");

var $mgmkw = parcelRequire("mgmkw");
var $ccTJE = parcelRequire("ccTJE");

var $6EBpU = parcelRequire("6EBpU");
var $aywfR = parcelRequire("aywfR");

var $gfMhR = parcelRequire("gfMhR");
var $jcuNg = parcelRequire("jcuNg");

var $k4uq6 = parcelRequire("k4uq6");

var $iVUHF = parcelRequire("iVUHF");
var $emWUl = parcelRequire("emWUl");

var $bMqI2 = parcelRequire("bMqI2");
var $h7oHz = parcelRequire("h7oHz");

var $cATbk = parcelRequire("cATbk");
var $fLwT1 = parcelRequire("fLwT1");

var $b55pH = parcelRequire("b55pH");
var $hixXY = parcelRequire("hixXY");

var $2zQvJ = parcelRequire("2zQvJ");
var $c7kN4 = parcelRequire("c7kN4");

var $gKUuh = parcelRequire("gKUuh");
var $4OBCw = parcelRequire("4OBCw");

var $bfUhP = parcelRequire("bfUhP");
var $d1Gg9 = parcelRequire("d1Gg9");

var $uFmLq = parcelRequire("uFmLq");
var $auFFx = parcelRequire("auFFx");

var $b7ZVv = parcelRequire("b7ZVv");
var $dase6 = parcelRequire("dase6");

var $cb0JV = parcelRequire("cb0JV");
var $6iqYv = parcelRequire("6iqYv");

var $94Obf = parcelRequire("94Obf");
var $5ygiY = parcelRequire("5ygiY");

var $2VaPc = parcelRequire("2VaPc");

var $eSOFc = parcelRequire("eSOFc");
var $5mfRz = parcelRequire("5mfRz");

var $bdJK4 = parcelRequire("bdJK4");
var $6sxrx = parcelRequire("6sxrx");

var $1trjx = parcelRequire("1trjx");
var $kZgnd = parcelRequire("kZgnd");

var $3GWux = parcelRequire("3GWux");
var $lUjNR = parcelRequire("lUjNR");

var $aSP5A = parcelRequire("aSP5A");
var $5WtOI = parcelRequire("5WtOI");

var $2KoyJ = parcelRequire("2KoyJ");
var $76sdQ = parcelRequire("76sdQ");

var $890Mg = parcelRequire("890Mg");
var $ls9Kb = parcelRequire("ls9Kb");

var $6orqk = parcelRequire("6orqk");
var $4W5VS = parcelRequire("4W5VS");

var $7Pxsd = parcelRequire("7Pxsd");
var $cBoEs = parcelRequire("cBoEs");

var $cPm2G = parcelRequire("cPm2G");
var $es9dC = parcelRequire("es9dC");

var $bCK6O = parcelRequire("bCK6O");
var $kyzxr = parcelRequire("kyzxr");

var $hfi1o = parcelRequire("hfi1o");
var $zJhZR = parcelRequire("zJhZR");

var $4APwg = parcelRequire("4APwg");
var $hesoK = parcelRequire("hesoK");

var $15Jjw = parcelRequire("15Jjw");
var $bw1LU = parcelRequire("bw1LU");

var $fCq7C = parcelRequire("fCq7C");
var $jarpY = parcelRequire("jarpY");

var $3l6DX = parcelRequire("3l6DX");
var $kUM4Q = parcelRequire("kUM4Q");

var $gF1sr = parcelRequire("gF1sr");
var $bCqmd = parcelRequire("bCqmd");

var $1IlGC = parcelRequire("1IlGC");
var $90UgS = parcelRequire("90UgS");

var $aNQRJ = parcelRequire("aNQRJ");
var $dH1al = parcelRequire("dH1al");

var $2av0D = parcelRequire("2av0D");
var $iBaHp = parcelRequire("iBaHp");

var $gjb7I = parcelRequire("gjb7I");
var $fN1CB = parcelRequire("fN1CB");

var $gaRjA = parcelRequire("gaRjA");
var $l27EY = parcelRequire("l27EY");

var $7AQx3 = parcelRequire("7AQx3");
var $3V5Yh = parcelRequire("3V5Yh");

var $8ehmC = parcelRequire("8ehmC");
var $69qyP = parcelRequire("69qyP");

var $bqZk8 = parcelRequire("bqZk8");
var $ia3Z8 = parcelRequire("ia3Z8");

var $hIoKY = parcelRequire("hIoKY");
var $aVGqQ = parcelRequire("aVGqQ");

var $cjbiZ = parcelRequire("cjbiZ");
var $krxIx = parcelRequire("krxIx");

var $1DsrN = parcelRequire("1DsrN");
var $bhpyz = parcelRequire("bhpyz");

var $5H7M3 = parcelRequire("5H7M3");
var $hKgv2 = parcelRequire("hKgv2");

var $WVLe6 = parcelRequire("WVLe6");
var $4yvQw = parcelRequire("4yvQw");

var $cn9y3 = parcelRequire("cn9y3");
var $39aLD = parcelRequire("39aLD");

var $eYwU3 = parcelRequire("eYwU3");
var $h9MNM = parcelRequire("h9MNM");

var $6sRcE = parcelRequire("6sRcE");
var $hULUE = parcelRequire("hULUE");

var $gk333 = parcelRequire("gk333");
var $2PLlk = parcelRequire("2PLlk");

var $eghee = parcelRequire("eghee");
var $lhNXG = parcelRequire("lhNXG");

var $7RMEp = parcelRequire("7RMEp");
var $iE23F = parcelRequire("iE23F");

var $hwfCF = parcelRequire("hwfCF");
var $19O2G = parcelRequire("19O2G");

var $zADBD = parcelRequire("zADBD");
var $5YGzb = parcelRequire("5YGzb");

var $2b30R = parcelRequire("2b30R");
var $ebfhn = parcelRequire("ebfhn");

var $udLOo = parcelRequire("udLOo");
/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $4ca827d54330e86a$export$ef8e5f836dd989d3 = (0, $udLOo.tempSizeWrapper)((0, $cPO2v.AdminIcon));
var $4ca827d54330e86a$export$ebcd30672e67406 = (0, $udLOo.tempSizeWrapper)((0, $9cCpG.AdminLogoCS));
var $4ca827d54330e86a$export$af3460f51ce3602a = (0, $udLOo.tempSizeWrapper)((0, $8rxGh.AnalyticsIcon));
var $4ca827d54330e86a$export$c8415b6abe4a8587 = (0, $udLOo.tempSizeWrapper)((0, $91WqM.AnalyticsLogoCS));
var $4ca827d54330e86a$export$d89497e7f33ca6f5 = (0, $udLOo.tempSizeWrapper)((0, $17kte.AssetsIcon));
var $4ca827d54330e86a$export$48ca930f3071e3e4 = (0, $udLOo.tempSizeWrapper)((0, $kHB7Y.AssetsLogoCS));
var $4ca827d54330e86a$export$52cd484a7ef4f2b9 = (0, $udLOo.teamEUFlaggedIcon)((0, $krlR6.ChatIcon), (0, $6boaO.ChatNewIcon));
var $4ca827d54330e86a$export$9ca9881809919df8 = (0, $udLOo.teamEUFlaggedIcon)((0, $9EwIf.ChatLogoCS), (0, $2ZeZj.ChatNewLogoCS));
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $4ca827d54330e86a$export$6da5aa77c402ba0f = (0, $udLOo.tempSizeWrapper)((0, $gfMhR.CustomerServiceManagementIcon));
var $4ca827d54330e86a$export$abc95e6180bb1d88 = (0, $udLOo.tempSizeWrapper)((0, $jcuNg.CustomerServiceManagementLogoCS));
var $4ca827d54330e86a$export$9eb74917ea768ed4 = (0, $udLOo.tempSizeWrapper)((0, $bMqI2.GoalsIcon));
var $4ca827d54330e86a$export$d2577aa28451395f = (0, $udLOo.tempSizeWrapper)((0, $h7oHz.GoalsLogoCS));
var $4ca827d54330e86a$export$92c8767b874048d = (0, $udLOo.tempSizeWrapper)((0, $b55pH.HomeIcon));
var $4ca827d54330e86a$export$d5648119d5b68e90 = (0, $udLOo.tempSizeWrapper)((0, $hixXY.HomeLogoCS));
var $4ca827d54330e86a$export$80b8b269d8b5014e = (0, $udLOo.tempSizeWrapper)((0, $2zQvJ.HubIcon));
var $4ca827d54330e86a$export$fc9bd6687b80fe3b = (0, $udLOo.tempSizeWrapper)((0, $c7kN4.HubLogoCS));
var $4ca827d54330e86a$export$5ed3e1bb3b04fc02 = (0, $udLOo.tempSizeWrapper)((0, $1trjx.ProjectsIcon));
var $4ca827d54330e86a$export$aeefab651bcf2338 = (0, $udLOo.tempSizeWrapper)((0, $kZgnd.ProjectsLogoCS));
var $4ca827d54330e86a$export$8b784b3227531b3e = (0, $udLOo.tempSizeWrapper)((0, $aSP5A.RovoDevIcon));
var $4ca827d54330e86a$export$f0750468d67c6902 = (0, $udLOo.tempSizeWrapper)((0, $5WtOI.RovoDevLogoCS));
var $4ca827d54330e86a$export$813cff80931d9dbf = (0, $udLOo.tempSizeWrapper)((0, $2KoyJ.RovoDevAgentIcon));
var $4ca827d54330e86a$export$409b7a5b7f180eba = (0, $udLOo.tempSizeWrapper)((0, $76sdQ.RovoDevAgentLogoCS));
var $4ca827d54330e86a$export$82eafebb825fc23f = (0, $udLOo.teamEUFlaggedIcon)((0, $6orqk.SearchIcon), (0, $7Pxsd.SearchNewIcon));
var $4ca827d54330e86a$export$e4c5487c9a8ae3b1 = (0, $udLOo.teamEUFlaggedIcon)((0, $4W5VS.SearchLogoCS), (0, $cBoEs.SearchNewLogoCS));
var $4ca827d54330e86a$export$290a0f24614cde9f = (0, $udLOo.teamEUFlaggedIcon)((0, $bCK6O.StudioIcon), (0, $hfi1o.StudioNewIcon));
var $4ca827d54330e86a$export$8aceb78c659789b6 = (0, $udLOo.teamEUFlaggedIcon)((0, $kyzxr.StudioLogoCS), (0, $zJhZR.StudioNewLogoCS));
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $4ca827d54330e86a$export$4b05688514531169 = (0, $udLOo.tempSizeWrapper)((0, $4APwg.TalentIcon));
var $4ca827d54330e86a$export$4f6453e012279f89 = (0, $udLOo.tempSizeWrapper)((0, $hesoK.TalentLogoCS));
var $4ca827d54330e86a$export$1bcbc9c337da86da = (0, $udLOo.tempSizeWrapper)((0, $15Jjw.TeamsIcon));
var $4ca827d54330e86a$export$9b1a0a0c574cec2a = (0, $udLOo.tempSizeWrapper)((0, $bw1LU.TeamsLogoCS));
var $4ca827d54330e86a$export$e812398311cab9a3 = (0, $udLOo.tempSizeWrapper)((0, $8S3nu.BambooIcon));
var $4ca827d54330e86a$export$765f5afcc1a5a7e3 = (0, $udLOo.tempSizeWrapper)((0, $7ybpy.BambooLogoCS));
var $4ca827d54330e86a$export$d3ab16bbf4f954ee = (0, $udLOo.tempSizeWrapper)((0, $6it9A.BitbucketDataCenterIcon));
var $4ca827d54330e86a$export$36044946916e84a0 = (0, $udLOo.tempSizeWrapper)((0, $lMzFA.BitbucketDataCenterLogoCS));
var $4ca827d54330e86a$export$53305f1f2855d3be = (0, $udLOo.tempSizeWrapper)((0, $mgmkw.ConfluenceDataCenterIcon));
var $4ca827d54330e86a$export$5e06396bce773a3 = (0, $udLOo.tempSizeWrapper)((0, $ccTJE.ConfluenceDataCenterLogoCS));
var $4ca827d54330e86a$export$eaf73f391f7103bd = (0, $udLOo.tempSizeWrapper)((0, $6EBpU.CrowdIcon));
var $4ca827d54330e86a$export$6128b385660fd3c6 = (0, $udLOo.tempSizeWrapper)((0, $aywfR.CrowdLogoCS));
var $4ca827d54330e86a$export$f8455b5667a3ee0c = (0, $udLOo.tempSizeWrapper)((0, $bfUhP.JiraDataCenterIcon));
var $4ca827d54330e86a$export$eb152ab3801b2ae3 = (0, $udLOo.tempSizeWrapper)((0, $d1Gg9.JiraDataCenterLogoCS));
var $4ca827d54330e86a$export$65fae0eaf343f2ca = (0, $udLOo.tempSizeWrapper)((0, $cb0JV.JiraServiceManagementDataCenterIcon));
var $4ca827d54330e86a$export$fffc0d480fb1ebf1 = (0, $udLOo.tempSizeWrapper)((0, $6iqYv.JiraServiceManagementDataCenterLogoCS));
var $4ca827d54330e86a$export$74517ed253186308 = (0, $udLOo.createFeatureFlaggedComponent)((0, $gF1sr.AtlassianAdministrationIcon), (0, $cPO2v.AdminIcon));
var $4ca827d54330e86a$export$833abe6c2ce5ebfd = (0, $udLOo.createFeatureFlaggedComponent)((0, $bCqmd.AtlassianAdministrationLogo), (0, $9cCpG.AdminLogoCS));
var $4ca827d54330e86a$export$84109e099492cb5f = (0, $udLOo.createFeatureFlaggedComponent)((0, $3l6DX.AtlassianAdminIcon), (0, $cPO2v.AdminIcon));
var $4ca827d54330e86a$export$f845d9b9254f0541 = (0, $udLOo.createFeatureFlaggedComponent)((0, $kUM4Q.AtlassianAdminLogo), (0, $9cCpG.AdminLogoCS));
var $4ca827d54330e86a$export$c42ad8a0b925c762 = (0, $udLOo.createFeatureFlaggedComponent)((0, $1IlGC.AtlassianAnalyticsIcon), (0, $8rxGh.AnalyticsIcon));
var $4ca827d54330e86a$export$e6470bfc39010cc4 = (0, $udLOo.createFeatureFlaggedComponent)((0, $90UgS.AtlassianAnalyticsLogo), (0, $91WqM.AnalyticsLogoCS));
var $4ca827d54330e86a$export$5fc1066e677788d4 = (0, $udLOo.createFeatureFlaggedComponent)((0, $aNQRJ.BitbucketIcon), (0, $8jaqE.BitbucketIcon));
var $4ca827d54330e86a$export$bd40525f5333524b = (0, $udLOo.createFeatureFlaggedComponent)((0, $dH1al.BitbucketLogo), (0, $2Ckgd.BitbucketLogoCS));
var $4ca827d54330e86a$export$f7857fe64d7161d9 = (0, $udLOo.createFeatureFlaggedComponent)((0, $2av0D.CompassIcon), (0, $l2w68.CompassIcon));
var $4ca827d54330e86a$export$eb7d748e4f9c9676 = (0, $udLOo.createFeatureFlaggedComponent)((0, $iBaHp.CompassLogo), (0, $hOHDu.CompassLogoCS));
var $4ca827d54330e86a$export$9951d02c2d848122 = (0, $udLOo.tempSizeWrapper)((0, $k4uq6.DxIcon));
var $4ca827d54330e86a$export$68f3db7f6af48bcb = (0, $udLOo.createFeatureFlaggedComponent)((0, $gjb7I.ConfluenceIcon), (0, $gsgV2.ConfluenceIcon));
var $4ca827d54330e86a$export$1b2e4fe6ef471556 = (0, $udLOo.createFeatureFlaggedComponent)((0, $fN1CB.ConfluenceLogo), (0, $cYGO7.ConfluenceLogoCS));
var $4ca827d54330e86a$export$70a0c2f5862937b6 = (0, $udLOo.tempSizeWrapper)((0, $bCzpe.AlignIcon));
var $4ca827d54330e86a$export$1b8596b4b0ef673b = (0, $udLOo.tempSizeWrapper)((0, $cDJWV.AlignLogoCS));
var $4ca827d54330e86a$export$407687b2dd89cc68 = (0, $udLOo.createFeatureFlaggedComponent)((0, $bqZk8.JiraAlignIcon), (0, $bCzpe.AlignIcon));
var $4ca827d54330e86a$export$ee11e928d3d045fd = (0, $udLOo.createFeatureFlaggedComponent)((0, $ia3Z8.JiraAlignLogo), (0, $cDJWV.AlignLogoCS));
var $4ca827d54330e86a$export$c4b5b1f965d8b3eb = (0, $udLOo.createFeatureFlaggedComponent)((0, $8ehmC.JiraIcon), (0, $gKUuh.JiraIcon));
var $4ca827d54330e86a$export$17d3acb0b4379d02 = (0, $udLOo.createFeatureFlaggedComponent)((0, $69qyP.JiraLogo), (0, $4OBCw.JiraLogoCS));
var $4ca827d54330e86a$export$21bfbeb62fdcce8d = (0, $udLOo.createFeatureFlaggedComponent)((0, $hIoKY.JiraProductDiscoveryIcon), (0, $uFmLq.JiraProductDiscoveryIcon));
var $4ca827d54330e86a$export$c49a2b642fe9eef4 = (0, $udLOo.createFeatureFlaggedComponent)((0, $aVGqQ.JiraProductDiscoveryLogo), (0, $auFFx.JiraProductDiscoveryLogoCS));
var $4ca827d54330e86a$export$3c6158790f5e01c4 = (0, $udLOo.createFeatureFlaggedServiceCollectionComponent)((0, $cjbiZ.JiraServiceManagementIcon), (0, $b7ZVv.JiraServiceManagementIcon));
var $4ca827d54330e86a$export$dabef2be6cd28c20 = (0, $udLOo.createFeatureFlaggedServiceCollectionComponent)((0, $krxIx.JiraServiceManagementLogo), (0, $dase6.JiraServiceManagementLogoCS));
var $4ca827d54330e86a$export$8d789f76fde3e05 = (0, $udLOo.createFeatureFlaggedComponent)((0, $1DsrN.LoomIcon), (0, $94Obf.LoomIcon));
var $4ca827d54330e86a$export$94e206806e36c2ec = (0, $udLOo.createFeatureFlaggedComponent)((0, $bhpyz.LoomLogo), (0, $5ygiY.LoomLogoCS));
var $4ca827d54330e86a$export$1bf47cdade1a9fcb = (0, $udLOo.createFeatureFlaggedComponent)((0, $5H7M3.LoomAttributionIcon), (0, $94Obf.LoomIcon));
var $4ca827d54330e86a$export$6e87ce8d41eda665 = (0, $udLOo.createFeatureFlaggedComponent)((0, $hKgv2.LoomAttributionLogo), (0, $2VaPc.LoomAttributionLogoCS));
var $4ca827d54330e86a$export$e84e925618e0e5bc = (0, $udLOo.tempSizeWrapper)((0, $5mfRz.LoomInternalLogoCS));
var $4ca827d54330e86a$export$1940ba72c868b663 = (0, $udLOo.tempSizeWrapper)((0, $eSOFc.LoomInternalIcon));
var $4ca827d54330e86a$export$eeccc49dc7a12d9f = (0, $udLOo.createFeatureFlaggedServiceCollectionComponent)((0, $WVLe6.OpsgenieIcon), (0, $bdJK4.OpsgenieIcon));
var $4ca827d54330e86a$export$a1c6484cdecc2c4b = (0, $udLOo.createFeatureFlaggedServiceCollectionComponent)((0, $4yvQw.OpsgenieLogo), (0, $6sxrx.OpsgenieLogoCS));
var $4ca827d54330e86a$export$f3f5aa321d88adf9 = (0, $udLOo.createFeatureFlaggedServiceCollectionComponent)((0, $eYwU3.StatuspageIcon), (0, $cPm2G.StatuspageIcon));
var $4ca827d54330e86a$export$bb4ae5b41b43be04 = (0, $udLOo.createFeatureFlaggedServiceCollectionComponent)((0, $h9MNM.StatuspageLogo), (0, $es9dC.StatuspageLogoCS));
var $4ca827d54330e86a$export$4384da9b8b140bf4 = (0, $udLOo.createFeatureFlaggedComponent)((0, $6sRcE.TrelloIcon), (0, $fCq7C.TrelloIcon));
var $4ca827d54330e86a$export$60e26212f3b61a28 = (0, $udLOo.createFeatureFlaggedComponent)((0, $hULUE.TrelloLogo), (0, $jarpY.TrelloLogoCS));
var $4ca827d54330e86a$export$e23ae35269442b4f = (0, $udLOo.createFeatureFlaggedRovoComponent)((0, $cn9y3.RovoIcon), (0, $3GWux.RovoIcon), (0, $890Mg.RovoHexIcon));
var $4ca827d54330e86a$export$a0f6cb8061290bbb = (0, $udLOo.createFeatureFlaggedRovoComponent)((0, $39aLD.RovoLogo), (0, $lUjNR.RovoLogoCS), (0, $ls9Kb.RovoHexLogoCS));
var $4ca827d54330e86a$export$3f95fcfdc25a741d = (0, $udLOo.createFeatureFlaggedComponent)((0, $7AQx3.GuardIcon), (0, $cATbk.GuardIcon));
var $4ca827d54330e86a$export$a4a891d202775deb = (0, $udLOo.createFeatureFlaggedComponent)((0, $3V5Yh.GuardLogo), (0, $fLwT1.GuardLogoCS));
var $4ca827d54330e86a$export$1e02e7298035a77c = (0, $udLOo.createFeatureFlaggedComponent)((0, $gaRjA.FocusIcon), (0, $iVUHF.FocusIcon));
var $4ca827d54330e86a$export$33908560ea1b226d = (0, $udLOo.createFeatureFlaggedComponent)((0, $l27EY.FocusLogo), (0, $emWUl.FocusLogoCS));

});
parcelRegister("cPO2v", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", function () { return $95811040f27aa4e1$export$ef8e5f836dd989d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $95811040f27aa4e1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $95811040f27aa4e1$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $95811040f27aa4e1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("f2yks", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", function () { return $af31abee494515a8$export$be58b4326e23250f; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $39c3M = parcelRequire("39c3M");

var $l8aSY = parcelRequire("l8aSY");
var $af31abee494515a8$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $af31abee494515a8$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $af31abee494515a8$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $af31abee494515a8$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $af31abee494515a8$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $af31abee494515a8$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $af31abee494515a8$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $af31abee494515a8$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $af31abee494515a8$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $2jatx.default)([
            $af31abee494515a8$var$styles.root,
            $af31abee494515a8$var$sizeMap[size],
            colorMode === 'dark' ? $af31abee494515a8$var$dataCenterDarkAppearanceMap[appearance] : $af31abee494515a8$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $af31abee494515a8$var$rovoDarkAppearanceMap[appearance] : $af31abee494515a8$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $af31abee494515a8$var$cloudDarkAppearanceMap[appearance] : $af31abee494515a8$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $39c3M.fg)('assets-platform-branding') && $af31abee494515a8$var$styles.TEMP_assets
        ])
    });
}

});
parcelRegister("l8aSY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f622ca00e7965e80$export$2e2bcd8739ae039; });

var $714jJ = parcelRequire("714jJ");

var $1oC0p = parcelRequire("1oC0p");

var $efQdp = parcelRequire("efQdp");

var $ad4F3 = parcelRequire("ad4F3");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $f622ca00e7965e80$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $1oC0p.useState)((0, $efQdp.default)()), _useState2 = (0, $714jJ.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        var observer = new (0, $ad4F3.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $f622ca00e7965e80$export$2e2bcd8739ae039 = $f622ca00e7965e80$var$useThemeObserver;

});
parcelRegister("714jJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $51bbf9b51765567e$export$2e2bcd8739ae039; });

var $hlVfQ = parcelRequire("hlVfQ");

var $jvEjU = parcelRequire("jvEjU");

var $4FIzu = parcelRequire("4FIzu");

var $fwFpR = parcelRequire("fwFpR");
function $51bbf9b51765567e$export$2e2bcd8739ae039(r, e) {
    return (0, $hlVfQ.default)(r) || (0, $jvEjU.default)(r, e) || (0, $4FIzu.default)(r, e) || (0, $fwFpR.default)();
}

});
parcelRegister("hlVfQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca20cf67f3f24612$export$2e2bcd8739ae039; });
function $ca20cf67f3f24612$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("jvEjU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e340304e0dca258d$export$2e2bcd8739ae039; });
function $e340304e0dca258d$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("4FIzu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $366d90b445619686$export$2e2bcd8739ae039; });

var $23u59 = parcelRequire("23u59");
function $366d90b445619686$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $23u59.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $23u59.default)(r, a) : void 0;
    }
}

});
parcelRegister("23u59", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17f33245d8e2dca2$export$2e2bcd8739ae039; });
function $17f33245d8e2dca2$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("fwFpR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b4d9f8912c87b788$export$2e2bcd8739ae039; });
function $b4d9f8912c87b788$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("efQdp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a60af848c1de7ef1$export$2e2bcd8739ae039; });

var $iubPz = parcelRequire("iubPz");

var $ixZaF = parcelRequire("ixZaF");

var $lHztt = parcelRequire("lHztt");

var $eVezN = parcelRequire("eVezN");
function $a60af848c1de7ef1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a60af848c1de7ef1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a60af848c1de7ef1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iubPz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a60af848c1de7ef1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a60af848c1de7ef1$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $lHztt.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $a60af848c1de7ef1$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $ixZaF.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $ixZaF.THEME_DATA_ATTRIBUTE)) || '';
    return $a60af848c1de7ef1$var$_objectSpread($a60af848c1de7ef1$var$_objectSpread({}, (0, $eVezN.themeStringToObject)(theme)), $a60af848c1de7ef1$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $a60af848c1de7ef1$export$2e2bcd8739ae039 = $a60af848c1de7ef1$var$getGlobalTheme;

});
parcelRegister("iubPz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d75434ad585008e9$export$2e2bcd8739ae039; });

var $iBqI2 = parcelRequire("iBqI2");
function $d75434ad585008e9$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $iBqI2.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("iBqI2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8b0669af481d2af$export$2e2bcd8739ae039; });

var $2SXKI = parcelRequire("2SXKI");

var $bewba = parcelRequire("bewba");
function $d8b0669af481d2af$export$2e2bcd8739ae039(t) {
    var i = (0, $bewba.default)(t, "string");
    return "symbol" == (0, $2SXKI.default)(i) ? i : i + "";
}

});
parcelRegister("2SXKI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $219ef98337e615d2$export$2e2bcd8739ae039; });
function $219ef98337e615d2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $219ef98337e615d2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $219ef98337e615d2$export$2e2bcd8739ae039(o);
}

});

parcelRegister("bewba", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82d9f69c6f011262$export$2e2bcd8739ae039; });

var $2SXKI = parcelRequire("2SXKI");
function $82d9f69c6f011262$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2SXKI.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2SXKI.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ixZaF", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $d80ac258969b0350$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $d80ac258969b0350$export$a00eac3f8684bcd0; });
var $d80ac258969b0350$export$4ef52930e33717cd = 'data-theme';
var $d80ac258969b0350$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $d80ac258969b0350$export$a00eac3f8684bcd0 = 'data-color-mode';
var $d80ac258969b0350$export$2112803007239c61 = 'data-contrast-mode';
var $d80ac258969b0350$export$352e418ed5b6193a = 'data-custom-theme';
var $d80ac258969b0350$export$6f0c6fb8c80fcc92 = 'ds';
var $d80ac258969b0350$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $d80ac258969b0350$export$dddac1532e822863 = "--".concat($d80ac258969b0350$export$6f0c6fb8c80fcc92, "-token-not-found");
var $d80ac258969b0350$export$9d7b58831ae93caa = "--".concat($d80ac258969b0350$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("lHztt", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $fcc9219d5d6f2230$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $fcc9219d5d6f2230$export$7d43e72a58e3283f; });

var $39c3M = parcelRequire("39c3M");
var $fcc9219d5d6f2230$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $fcc9219d5d6f2230$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $fcc9219d5d6f2230$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $fcc9219d5d6f2230$var$themeOverrideIds = [];
var $fcc9219d5d6f2230$export$92ba366331403db2 = [].concat($fcc9219d5d6f2230$export$7d43e72a58e3283f, $fcc9219d5d6f2230$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $fcc9219d5d6f2230$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var $fcc9219d5d6f2230$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $39c3M.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    motion: function motion() {
        if ((0, $39c3M.fg)('platform-dst-motion-theme-default')) return 'motion';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $fcc9219d5d6f2230$export$2e2bcd8739ae039 = $fcc9219d5d6f2230$var$themeConfig;

});

parcelRegister("eVezN", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $add1b21967fda769$export$f19b488f7c0547ee; });

var $2SXKI = parcelRequire("2SXKI");

var $714jJ = parcelRequire("714jJ");

var $lHztt = parcelRequire("lHztt");
var $add1b21967fda769$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $add1b21967fda769$var$customThemeOptions = 'UNSAFE_themeOptions';
var $add1b21967fda769$var$isThemeKind = function isThemeKind(themeKind) {
    return $add1b21967fda769$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $add1b21967fda769$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $lHztt.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $add1b21967fda769$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $add1b21967fda769$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $714jJ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $add1b21967fda769$var$isColorMode(id)) themeObject[kind] = id;
        if ($add1b21967fda769$var$isThemeKind(kind) && $add1b21967fda769$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $add1b21967fda769$var$customThemeOptions) try {
            themeObject[$add1b21967fda769$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $add1b21967fda769$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $714jJ.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $add1b21967fda769$var$isColorMode(id) || // custom theme state
        kind === $add1b21967fda769$var$customThemeOptions && (0, $2SXKI.default)(id) === 'object' || // other theme states
        $add1b21967fda769$var$isThemeKind(kind) && typeof id === 'string' && $add1b21967fda769$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $2SXKI.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("ad4F3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76eebbdf147cfe32$export$2e2bcd8739ae039; });

var $lVVrp = parcelRequire("lVVrp");

var $h7MUW = parcelRequire("h7MUW");

var $iubPz = parcelRequire("iubPz");

var $ixZaF = parcelRequire("ixZaF");

var $efQdp = parcelRequire("efQdp");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $76eebbdf147cfe32$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $lVVrp.default)(this, ThemeMutationObserver);
        (0, $iubPz.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $h7MUW.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $efQdp.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $ixZaF.THEME_DATA_ATTRIBUTE),
                            (0, $ixZaF.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $iubPz.default)($76eebbdf147cfe32$export$2e2bcd8739ae039, "observer", null);
(0, $iubPz.default)($76eebbdf147cfe32$export$2e2bcd8739ae039, "callbacks", new Set());

});
parcelRegister("lVVrp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff7b7a77f823a5c5$export$2e2bcd8739ae039; });
function $ff7b7a77f823a5c5$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("h7MUW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c779091a90cffb41$export$2e2bcd8739ae039; });

var $iBqI2 = parcelRequire("iBqI2");
function $c779091a90cffb41$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $iBqI2.default)(o.key), o);
    }
}
function $c779091a90cffb41$export$2e2bcd8739ae039(e, r, t) {
    return r && $c779091a90cffb41$var$_defineProperties(e.prototype, r), t && $c779091a90cffb41$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});





parcelRegister("9cCpG", function(module, exports) {
$parcel$export(module.exports, "AdminLogoCS", function () { return $6b33081c9e71474d$export$61afcb38c001e19; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6b33081c9e71474d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6b33081c9e71474d$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $6b33081c9e71474d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("cBkhx", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", function () { return $92c8ac4e8d05e42d$export$f827d3c5a9c3f644; });
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $39c3M = parcelRequire("39c3M");

var $l8aSY = parcelRequire("l8aSY");
var $92c8ac4e8d05e42d$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $92c8ac4e8d05e42d$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $92c8ac4e8d05e42d$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $92c8ac4e8d05e42d$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $92c8ac4e8d05e42d$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $92c8ac4e8d05e42d$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $92c8ac4e8d05e42d$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $92c8ac4e8d05e42d$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $92c8ac4e8d05e42d$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $92c8ac4e8d05e42d$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $92c8ac4e8d05e42d$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $92c8ac4e8d05e42d$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $2jatx.default)([
            $92c8ac4e8d05e42d$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $92c8ac4e8d05e42d$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $92c8ac4e8d05e42d$var$sizeMap[size],
            colorMode === 'dark' ? $92c8ac4e8d05e42d$var$textDarkAppearanceMap[appearance] : $92c8ac4e8d05e42d$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $92c8ac4e8d05e42d$var$dataCenterDarkAppearanceMap[appearance] : $92c8ac4e8d05e42d$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $92c8ac4e8d05e42d$var$rovoDarkAppearanceMap[appearance] : $92c8ac4e8d05e42d$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $92c8ac4e8d05e42d$var$cloudDarkAppearanceMap[appearance] : $92c8ac4e8d05e42d$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $39c3M.fg)('assets-platform-branding') && $92c8ac4e8d05e42d$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("bCzpe", function(module, exports) {
$parcel$export(module.exports, "AlignIcon", function () { return $875eb536a5d5b6c0$export$70a0c2f5862937b6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $875eb536a5d5b6c0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $875eb536a5d5b6c0$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $875eb536a5d5b6c0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cDJWV", function(module, exports) {
$parcel$export(module.exports, "AlignLogoCS", function () { return $933cc525ac84a21c$export$8b5103382c06639c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $933cc525ac84a21c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $933cc525ac84a21c$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $933cc525ac84a21c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8rxGh", function(module, exports) {
$parcel$export(module.exports, "AnalyticsIcon", function () { return $625af8a7c5d0af6c$export$af3460f51ce3602a; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $625af8a7c5d0af6c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $625af8a7c5d0af6c$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $625af8a7c5d0af6c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("91WqM", function(module, exports) {
$parcel$export(module.exports, "AnalyticsLogoCS", function () { return $693188387fb809b3$export$f0bac2b7ac3e3504; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $693188387fb809b3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $693188387fb809b3$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $693188387fb809b3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("17kte", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", function () { return $0d0652ec835cb8ea$export$d89497e7f33ca6f5; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0d0652ec835cb8ea$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $0d0652ec835cb8ea$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $0d0652ec835cb8ea$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $0d0652ec835cb8ea$var$svg,
        customThemeSvg: $0d0652ec835cb8ea$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kHB7Y", function(module, exports) {
$parcel$export(module.exports, "AssetsLogoCS", function () { return $03e3affe2550959f$export$81c47abe19675c4c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $03e3affe2550959f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $03e3affe2550959f$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $03e3affe2550959f$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8S3nu", function(module, exports) {
$parcel$export(module.exports, "BambooIcon", function () { return $6755fcac26e9e4c1$export$e812398311cab9a3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6755fcac26e9e4c1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $6755fcac26e9e4c1$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $6755fcac26e9e4c1$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7ybpy", function(module, exports) {
$parcel$export(module.exports, "BambooLogoCS", function () { return $57f48f67c8938b5d$export$7c51958462d750e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $57f48f67c8938b5d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $57f48f67c8938b5d$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $57f48f67c8938b5d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8jaqE", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", function () { return $60c8300341fb9f5f$export$5fc1066e677788d4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $60c8300341fb9f5f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $60c8300341fb9f5f$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $60c8300341fb9f5f$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $60c8300341fb9f5f$var$svg,
        customThemeSvg: $60c8300341fb9f5f$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2Ckgd", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogoCS", function () { return $1e7ed8ae534c222f$export$f7ef5e5488e4b430; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1e7ed8ae534c222f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $1e7ed8ae534c222f$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $1e7ed8ae534c222f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6it9A", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterIcon", function () { return $495b09d2fa539f25$export$d3ab16bbf4f954ee; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $495b09d2fa539f25$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $495b09d2fa539f25$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $495b09d2fa539f25$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lMzFA", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterLogoCS", function () { return $fdb9bff59a735bd1$export$cc55e2a4c4b40552; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $fdb9bff59a735bd1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $fdb9bff59a735bd1$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $fdb9bff59a735bd1$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("krlR6", function(module, exports) {
$parcel$export(module.exports, "ChatIcon", function () { return $ee17484b76829a19$export$52cd484a7ef4f2b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a833c6410fabd244b1134a630f9a005>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ee17484b76829a19$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ee17484b76829a19$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $ee17484b76829a19$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9EwIf", function(module, exports) {
$parcel$export(module.exports, "ChatLogoCS", function () { return $70713985bf93ae1c$export$a529e78951cd6709; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3a55f079b563dca3c91045ce0a761dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $70713985bf93ae1c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $70713985bf93ae1c$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $70713985bf93ae1c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6boaO", function(module, exports) {
$parcel$export(module.exports, "ChatNewIcon", function () { return $48068582e6601080$export$402a257da320c93c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad5b8ef64559dc5207c779379dec44c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $48068582e6601080$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $48068582e6601080$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $48068582e6601080$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2ZeZj", function(module, exports) {
$parcel$export(module.exports, "ChatNewLogoCS", function () { return $22cce78cdfb2336d$export$a3af32a9109d706d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb74baaf9574600817f9bd5473029df>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $22cce78cdfb2336d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $22cce78cdfb2336d$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $22cce78cdfb2336d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("l2w68", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", function () { return $f512aedda56868d7$export$f7857fe64d7161d9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f512aedda56868d7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $f512aedda56868d7$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $f512aedda56868d7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hOHDu", function(module, exports) {
$parcel$export(module.exports, "CompassLogoCS", function () { return $cf88f459cf07df8e$export$a16f50a81d183ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cf88f459cf07df8e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $cf88f459cf07df8e$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $cf88f459cf07df8e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gsgV2", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", function () { return $bfac62a2c21692e5$export$68f3db7f6af48bcb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $bfac62a2c21692e5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $bfac62a2c21692e5$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $bfac62a2c21692e5$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $bfac62a2c21692e5$var$svg,
        customThemeSvg: $bfac62a2c21692e5$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cYGO7", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoCS", function () { return $972c4b46a6a06fab$export$a88b0b0da9ef63ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $972c4b46a6a06fab$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $972c4b46a6a06fab$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $972c4b46a6a06fab$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("mgmkw", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterIcon", function () { return $042ebec6fb179077$export$53305f1f2855d3be; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $042ebec6fb179077$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $042ebec6fb179077$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $042ebec6fb179077$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ccTJE", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", function () { return $8e31d6e3b431f745$export$b3e508cb103e1f93; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8e31d6e3b431f745$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $8e31d6e3b431f745$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $8e31d6e3b431f745$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6EBpU", function(module, exports) {
$parcel$export(module.exports, "CrowdIcon", function () { return $4d8380b425dccc61$export$eaf73f391f7103bd; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4d8380b425dccc61$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $4d8380b425dccc61$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $4d8380b425dccc61$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aywfR", function(module, exports) {
$parcel$export(module.exports, "CrowdLogoCS", function () { return $7af6197a077d127d$export$3c371bdbcdfcdce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7af6197a077d127d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $7af6197a077d127d$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $7af6197a077d127d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gfMhR", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", function () { return $bd5380dcd83d026e$export$6da5aa77c402ba0f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $bd5380dcd83d026e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $bd5380dcd83d026e$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $bd5380dcd83d026e$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $bd5380dcd83d026e$var$svg,
        customThemeSvg: $bd5380dcd83d026e$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jcuNg", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoCS", function () { return $dfa7064529e4963e$export$f597f0f7fadce0b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dfa7064529e4963e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $dfa7064529e4963e$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $dfa7064529e4963e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("k4uq6", function(module, exports) {
$parcel$export(module.exports, "DxIcon", function () { return $e9cbc727c616a05c$export$9951d02c2d848122; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e9cbc727c616a05c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $e9cbc727c616a05c$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $e9cbc727c616a05c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iVUHF", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", function () { return $dc8988eff21c1815$export$1e02e7298035a77c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $dc8988eff21c1815$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $dc8988eff21c1815$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $dc8988eff21c1815$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("emWUl", function(module, exports) {
$parcel$export(module.exports, "FocusLogoCS", function () { return $a760d0a09f2db2f5$export$3a6e8b37e069a69d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a760d0a09f2db2f5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $a760d0a09f2db2f5$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $a760d0a09f2db2f5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bMqI2", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", function () { return $8938e5540f29a07f$export$9eb74917ea768ed4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $8938e5540f29a07f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $8938e5540f29a07f$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $8938e5540f29a07f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("h7oHz", function(module, exports) {
$parcel$export(module.exports, "GoalsLogoCS", function () { return $c766405db9669496$export$c527a545aa426db3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c766405db9669496$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $c766405db9669496$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $c766405db9669496$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cATbk", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", function () { return $92b3a6c1156819e0$export$3f95fcfdc25a741d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $92b3a6c1156819e0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $92b3a6c1156819e0$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $92b3a6c1156819e0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fLwT1", function(module, exports) {
$parcel$export(module.exports, "GuardLogoCS", function () { return $b7a4c15974c6c90e$export$2b896c4d595a4331; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b7a4c15974c6c90e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $b7a4c15974c6c90e$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $b7a4c15974c6c90e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b55pH", function(module, exports) {
$parcel$export(module.exports, "HomeIcon", function () { return $81145c54d7f627e9$export$92c8767b874048d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $81145c54d7f627e9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $81145c54d7f627e9$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $81145c54d7f627e9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hixXY", function(module, exports) {
$parcel$export(module.exports, "HomeLogoCS", function () { return $c97e7718487837c4$export$8b6b7f1b1b2367d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c97e7718487837c4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $c97e7718487837c4$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $c97e7718487837c4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2zQvJ", function(module, exports) {
$parcel$export(module.exports, "HubIcon", function () { return $1e07953825359d7d$export$80b8b269d8b5014e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1e07953825359d7d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $1e07953825359d7d$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $1e07953825359d7d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("c7kN4", function(module, exports) {
$parcel$export(module.exports, "HubLogoCS", function () { return $8d26440484a80f56$export$7a38180641471460; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8d26440484a80f56$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $8d26440484a80f56$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $8d26440484a80f56$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gKUuh", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", function () { return $c32cc2729bfccf35$export$c4b5b1f965d8b3eb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c32cc2729bfccf35$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $c32cc2729bfccf35$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $c32cc2729bfccf35$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $c32cc2729bfccf35$var$svg,
        customThemeSvg: $c32cc2729bfccf35$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4OBCw", function(module, exports) {
$parcel$export(module.exports, "JiraLogoCS", function () { return $3819039281100a39$export$bf4c5f97b468e8d6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3819039281100a39$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $3819039281100a39$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $3819039281100a39$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bfUhP", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterIcon", function () { return $831cc1c4ef4ba050$export$f8455b5667a3ee0c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $831cc1c4ef4ba050$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $831cc1c4ef4ba050$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $831cc1c4ef4ba050$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("d1Gg9", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterLogoCS", function () { return $97bc2638f2457fe6$export$3224b07bc93ef23e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $97bc2638f2457fe6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $97bc2638f2457fe6$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $97bc2638f2457fe6$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("uFmLq", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $05c2e3ea1b77440d$export$21bfbeb62fdcce8d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $05c2e3ea1b77440d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $05c2e3ea1b77440d$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $05c2e3ea1b77440d$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $05c2e3ea1b77440d$var$svg,
        customThemeSvg: $05c2e3ea1b77440d$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("auFFx", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", function () { return $7a3d074bd82db679$export$602140a6a10b02bf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7a3d074bd82db679$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $7a3d074bd82db679$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $7a3d074bd82db679$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b7ZVv", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $81a0627b07158dc7$export$3c6158790f5e01c4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $81a0627b07158dc7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $81a0627b07158dc7$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $81a0627b07158dc7$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $81a0627b07158dc7$var$svg,
        customThemeSvg: $81a0627b07158dc7$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dase6", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", function () { return $99621ab4154a2a78$export$de148263c75d2bc1; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $99621ab4154a2a78$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $99621ab4154a2a78$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $99621ab4154a2a78$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cb0JV", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", function () { return $8dd7160187d266c9$export$65fae0eaf343f2ca; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $8dd7160187d266c9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $8dd7160187d266c9$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $8dd7160187d266c9$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6iqYv", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", function () { return $4959592848d81b18$export$f64bc7a7f04428d0; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4959592848d81b18$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $4959592848d81b18$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $4959592848d81b18$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("94Obf", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", function () { return $69bb698c1edcf5f6$export$8d789f76fde3e05; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $69bb698c1edcf5f6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $69bb698c1edcf5f6$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $69bb698c1edcf5f6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5ygiY", function(module, exports) {
$parcel$export(module.exports, "LoomLogoCS", function () { return $40acc68dbe6defde$export$78c0b4d8be34c9b2; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $40acc68dbe6defde$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $40acc68dbe6defde$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $40acc68dbe6defde$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2VaPc", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogoCS", function () { return $22094d32f201f844$export$68d7391318cdef11; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $22094d32f201f844$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $22094d32f201f844$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $22094d32f201f844$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eSOFc", function(module, exports) {
$parcel$export(module.exports, "LoomInternalIcon", function () { return $02cbd444695b0467$export$38c7b37a3e5e8d70; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $02cbd444695b0467$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $02cbd444695b0467$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $02cbd444695b0467$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5mfRz", function(module, exports) {
$parcel$export(module.exports, "LoomInternalLogoCS", function () { return $3e6b4fe142b91bae$export$71743a944cb62e48; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3e6b4fe142b91bae$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $3e6b4fe142b91bae$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $3e6b4fe142b91bae$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bdJK4", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", function () { return $82b46406e6ee425e$export$eeccc49dc7a12d9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $82b46406e6ee425e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $82b46406e6ee425e$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $82b46406e6ee425e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6sxrx", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogoCS", function () { return $4b3f4cb4620b7af9$export$a5b9122e89b32ad3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4b3f4cb4620b7af9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $4b3f4cb4620b7af9$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $4b3f4cb4620b7af9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1trjx", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", function () { return $112dafdfaf30aece$export$5ed3e1bb3b04fc02; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $112dafdfaf30aece$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $112dafdfaf30aece$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $112dafdfaf30aece$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kZgnd", function(module, exports) {
$parcel$export(module.exports, "ProjectsLogoCS", function () { return $f4763497dcf6e6d9$export$e3d1678155aaab99; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f4763497dcf6e6d9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f4763497dcf6e6d9$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $f4763497dcf6e6d9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3GWux", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", function () { return $2b02aa8b8113aaa7$export$e23ae35269442b4f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2b02aa8b8113aaa7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $2b02aa8b8113aaa7$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $2b02aa8b8113aaa7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lUjNR", function(module, exports) {
$parcel$export(module.exports, "RovoLogoCS", function () { return $ff2e306e79eba5c9$export$b0e15f0a1c9f4c55; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ff2e306e79eba5c9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $ff2e306e79eba5c9$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $ff2e306e79eba5c9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aSP5A", function(module, exports) {
$parcel$export(module.exports, "RovoDevIcon", function () { return $7ec693c3a7fd9886$export$8b784b3227531b3e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7ec693c3a7fd9886$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $7ec693c3a7fd9886$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $7ec693c3a7fd9886$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5WtOI", function(module, exports) {
$parcel$export(module.exports, "RovoDevLogoCS", function () { return $011dd4a3767eed27$export$4145bd793c9ed1d0; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $011dd4a3767eed27$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $011dd4a3767eed27$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $011dd4a3767eed27$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2KoyJ", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentIcon", function () { return $2002ed9663eb734d$export$813cff80931d9dbf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2002ed9663eb734d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $2002ed9663eb734d$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $2002ed9663eb734d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("76sdQ", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentLogoCS", function () { return $52befc489bd0659b$export$58747af448450872; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $52befc489bd0659b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $52befc489bd0659b$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $52befc489bd0659b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("890Mg", function(module, exports) {
$parcel$export(module.exports, "RovoHexIcon", function () { return $5edfc45aebda19fa$export$9e62346a60cfb459; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $5edfc45aebda19fa$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5edfc45aebda19fa$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $5edfc45aebda19fa$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ls9Kb", function(module, exports) {
$parcel$export(module.exports, "RovoHexLogoCS", function () { return $f9e3c56e95982b36$export$5e38d02efdb45577; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f9e3c56e95982b36$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f9e3c56e95982b36$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $f9e3c56e95982b36$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6orqk", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", function () { return $4a7a41be40128f98$export$82eafebb825fc23f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88ee37f21199df8c4f6de50b597bc415>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4a7a41be40128f98$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4a7a41be40128f98$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $4a7a41be40128f98$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4W5VS", function(module, exports) {
$parcel$export(module.exports, "SearchLogoCS", function () { return $39812e40c03a8f71$export$fa08cbfe393f2a68; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4165d5d8279c6abbf1ec41290594700b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $39812e40c03a8f71$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $39812e40c03a8f71$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $39812e40c03a8f71$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7Pxsd", function(module, exports) {
$parcel$export(module.exports, "SearchNewIcon", function () { return $5b373f17660a829b$export$3599582ddc9fc5cf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fb81b6548e62d67fc83daf888114f8f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $5b373f17660a829b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5b373f17660a829b$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $5b373f17660a829b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cBoEs", function(module, exports) {
$parcel$export(module.exports, "SearchNewLogoCS", function () { return $92cc100764dded38$export$d669f6cbbb67e061; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12cecbe0aa290ffe5232721f12ef458f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $92cc100764dded38$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $92cc100764dded38$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $92cc100764dded38$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cPm2G", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", function () { return $956b5898c42f2d6e$export$f3f5aa321d88adf9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $956b5898c42f2d6e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $956b5898c42f2d6e$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $956b5898c42f2d6e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("es9dC", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogoCS", function () { return $a85ad4d5bc40e5ca$export$2bc88a281410ffa7; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a85ad4d5bc40e5ca$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $a85ad4d5bc40e5ca$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $a85ad4d5bc40e5ca$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bCK6O", function(module, exports) {
$parcel$export(module.exports, "StudioIcon", function () { return $87670298b0900cc7$export$290a0f24614cde9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2be4b98bf6f70e39467c5c4d0f75c6d5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $87670298b0900cc7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $87670298b0900cc7$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $87670298b0900cc7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kyzxr", function(module, exports) {
$parcel$export(module.exports, "StudioLogoCS", function () { return $ef728cc988038594$export$273fd56580e523ae; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a96e3d2d2d3910fdbea7d20bda091bd2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ef728cc988038594$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $ef728cc988038594$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $ef728cc988038594$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hfi1o", function(module, exports) {
$parcel$export(module.exports, "StudioNewIcon", function () { return $c8e1d1182ca917ed$export$8bb9894377e04e04; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6df92ef654dd711bfb690d95b2c06d7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c8e1d1182ca917ed$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $c8e1d1182ca917ed$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $c8e1d1182ca917ed$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("zJhZR", function(module, exports) {
$parcel$export(module.exports, "StudioNewLogoCS", function () { return $06b666814abe36c2$export$170353c338ac5f4a; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88f184410a9d6dcf22f1ca1246d077a0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $06b666814abe36c2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $06b666814abe36c2$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $06b666814abe36c2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4APwg", function(module, exports) {
$parcel$export(module.exports, "TalentIcon", function () { return $35827ce279aa7a50$export$4b05688514531169; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $35827ce279aa7a50$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $35827ce279aa7a50$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $35827ce279aa7a50$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hesoK", function(module, exports) {
$parcel$export(module.exports, "TalentLogoCS", function () { return $c8b9c5c2bbb0dfa3$export$1b3979d995ebbc6e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c8b9c5c2bbb0dfa3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $c8b9c5c2bbb0dfa3$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $c8b9c5c2bbb0dfa3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("15Jjw", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", function () { return $0cb968729338b221$export$1bcbc9c337da86da; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0cb968729338b221$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $0cb968729338b221$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $0cb968729338b221$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bw1LU", function(module, exports) {
$parcel$export(module.exports, "TeamsLogoCS", function () { return $86240eb36d129184$export$bfd8d1c4da84ce71; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $86240eb36d129184$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $86240eb36d129184$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $86240eb36d129184$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fCq7C", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", function () { return $b5eeaae6f3cd3f20$export$4384da9b8b140bf4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f2yks = parcelRequire("f2yks");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b5eeaae6f3cd3f20$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $b5eeaae6f3cd3f20$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $b5eeaae6f3cd3f20$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f2yks.IconWrapper), {
        svg: $b5eeaae6f3cd3f20$var$svg,
        customThemeSvg: $b5eeaae6f3cd3f20$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jarpY", function(module, exports) {
$parcel$export(module.exports, "TrelloLogoCS", function () { return $df44382058c7419c$export$1b13139dfc0336af; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cBkhx = parcelRequire("cBkhx");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $df44382058c7419c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $df44382058c7419c$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cBkhx.LogoWrapper), {
        svg: $df44382058c7419c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3l6DX", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminIcon", function () { return $26e87c80c4d94487$export$84109e099492cb5f; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $26e87c80c4d94487$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $26e87c80c4d94487$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        svg: $26e87c80c4d94487$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("eggzj", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", function () { return $a61f6979ae7c8706$export$438460117ae6b7ee; });
$parcel$export(module.exports, "legacyDefaultLogoParams", function () { return $a61f6979ae7c8706$export$793fba32aed8942a; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $a61f6979ae7c8706$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $a61f6979ae7c8706$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("cTVn3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $96471fc0ef43d2b2$export$2e2bcd8739ae039; });
/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $8PRJC = parcelRequire("8PRJC");

var $iubPz = parcelRequire("iubPz");

var $5EQbP = parcelRequire("5EQbP");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $96471fc0ef43d2b2$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $96471fc0ef43d2b2$var$CSS_VAR_COLOR = '--logo-color';
var $96471fc0ef43d2b2$var$CSS_VAR_FILL = '--logo-fill';
var $96471fc0ef43d2b2$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $96471fc0ef43d2b2$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, $5EQbP.default)(_ref, $96471fc0ef43d2b2$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $8PRJC.default)({
        "data-testid": testId,
        style: (0, $iubPz.default)((0, $iubPz.default)({}, $96471fc0ef43d2b2$var$CSS_VAR_COLOR, iconColor), $96471fc0ef43d2b2$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $2jatx.default)([
            $96471fc0ef43d2b2$var$styles.root,
            shouldApplyStopColor && $96471fc0ef43d2b2$var$styles.stop,
            size && $96471fc0ef43d2b2$var$styles[size]
        ])
    }));
};
var $96471fc0ef43d2b2$export$2e2bcd8739ae039 = $96471fc0ef43d2b2$var$Wrapper;

});
parcelRegister("8PRJC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66ecc4c511abed56$export$2e2bcd8739ae039; });
function $66ecc4c511abed56$export$2e2bcd8739ae039() {
    return $66ecc4c511abed56$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $66ecc4c511abed56$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5EQbP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $41e92bf95601f1c5$export$2e2bcd8739ae039; });

var $JIHju = parcelRequire("JIHju");
function $41e92bf95601f1c5$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $JIHju.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("JIHju", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0896e018b1b6fa63$export$2e2bcd8739ae039; });
function $0896e018b1b6fa63$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});



parcelRegister("d2w8Y", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", function () { return $97e4655215c274ac$export$362a25f017e2bc8a; });
$parcel$export(module.exports, "getColorsFromAppearance", function () { return $97e4655215c274ac$export$bbacc3980e0f3029; });
$parcel$export(module.exports, "getColorsForLoom", function () { return $97e4655215c274ac$export$7818df200941dbbf; });

var $itlwH = parcelRequire("itlwH");
var $97e4655215c274ac$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $itlwH.B400);
            iconGradientStop = (0, $itlwH.B200);
            iconColor = (0, $itlwH.B200);
            textColor = "var(--ds-text, ".concat((0, $itlwH.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $itlwH.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $itlwH.N600);
            iconGradientStop = (0, $itlwH.N100);
            iconColor = (0, $itlwH.N100);
            textColor = (0, $itlwH.N400);
            atlassianLogoTextColor = (0, $itlwH.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $97e4655215c274ac$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $itlwH.N0);
            textColor = (0, $itlwH.N0);
            atlassianLogoTextColor = (0, $itlwH.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $97e4655215c274ac$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $97e4655215c274ac$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $97e4655215c274ac$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
parcelRegister("itlwH", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $d72ba21ad5986e6b$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $d72ba21ad5986e6b$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $d72ba21ad5986e6b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N100", function () { return $d72ba21ad5986e6b$export$d6447c357493214f; });
$parcel$export(module.exports, "N400", function () { return $d72ba21ad5986e6b$export$eece5f492e429f08; });
$parcel$export(module.exports, "N600", function () { return $d72ba21ad5986e6b$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $d72ba21ad5986e6b$export$7d61b15e0da132af; });
// Reds
var $d72ba21ad5986e6b$export$4b84fd0e2c617bd = '#FFEBE6';
var $d72ba21ad5986e6b$export$b34b069eff244586 = '#FFBDAD';
var $d72ba21ad5986e6b$export$be802dd0d8b57f35 = '#FF8F73';
var $d72ba21ad5986e6b$export$60847d42f9da92a6 = '#FF7452';
var $d72ba21ad5986e6b$export$4a7404f376229999 = '#FF5630';
var $d72ba21ad5986e6b$export$2010d0fb4295b346 = '#DE350B';
var $d72ba21ad5986e6b$export$2837b5a1a71d5c02 = '#BF2600';
var $d72ba21ad5986e6b$export$8d9596b529bbb9cf = '#FFFAE6';
var $d72ba21ad5986e6b$export$41060a744ab0b7ae = '#FFF0B3';
var $d72ba21ad5986e6b$export$1cc05bbbf340e559 = '#FFE380';
var $d72ba21ad5986e6b$export$5aae31392d72caaa = '#FFC400';
var $d72ba21ad5986e6b$export$c6930421db9fa514 = '#FFAB00';
var $d72ba21ad5986e6b$export$59619663aa6500fb = '#FF991F';
var $d72ba21ad5986e6b$export$874739ea9e379ab6 = '#FF8B00';
var $d72ba21ad5986e6b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d72ba21ad5986e6b$export$69a3bf21b9686c2b = '#ABF5D1';
var $d72ba21ad5986e6b$export$afbce1382ec95f73 = '#79F2C0';
var $d72ba21ad5986e6b$export$747d86715d4175de = '#57D9A3';
var $d72ba21ad5986e6b$export$940e1f69e873f202 = '#36B37E';
var $d72ba21ad5986e6b$export$a49394138f7b8e85 = '#00875A';
var $d72ba21ad5986e6b$export$6fa04827ac68a4fb = '#006644';
var $d72ba21ad5986e6b$export$226de0355ed012f8 = '#DEEBFF';
var $d72ba21ad5986e6b$export$8c13c2ee36917869 = '#B3D4FF';
var $d72ba21ad5986e6b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d72ba21ad5986e6b$export$215b7063051591f1 = '#2684FF';
var $d72ba21ad5986e6b$export$e62e8919cca44969 = '#0065FF';
var $d72ba21ad5986e6b$export$b3de0ae08da2ce64 = '#0052CC';
var $d72ba21ad5986e6b$export$a6ee3d71bc067634 = '#0747A6';
var $d72ba21ad5986e6b$export$67f15409e87642a1 = '#669DF1';
var $d72ba21ad5986e6b$export$f0539dbc42dbb067 = '#8FB8F6';
var $d72ba21ad5986e6b$export$363e4475840015bb = '#EAE6FF';
var $d72ba21ad5986e6b$export$4b0a4417ed59760f = '#C0B6F2';
var $d72ba21ad5986e6b$export$6011520a64d9a187 = '#998DD9';
var $d72ba21ad5986e6b$export$a7175d4e9206bc80 = '#8777D9';
var $d72ba21ad5986e6b$export$b48405b95304b5a1 = '#6554C0';
var $d72ba21ad5986e6b$export$c71e4279dd54a18d = '#5243AA';
var $d72ba21ad5986e6b$export$147899de772240ec = '#403294';
var $d72ba21ad5986e6b$export$2cf711fe14c66f06 = '#E6FCFF';
var $d72ba21ad5986e6b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d72ba21ad5986e6b$export$776c9c497ef08533 = '#79E2F2';
var $d72ba21ad5986e6b$export$69cb3ca10c1e330e = '#00C7E6';
var $d72ba21ad5986e6b$export$9dc1ef0f3f48059b = '#00B8D9';
var $d72ba21ad5986e6b$export$7c835c78b6fcdef8 = '#00A3BF';
var $d72ba21ad5986e6b$export$6036577f95c3877e = '#008DA6';
var $d72ba21ad5986e6b$export$29a4f05edc054374 = '#FFFFFF';
var $d72ba21ad5986e6b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d72ba21ad5986e6b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d72ba21ad5986e6b$export$3e51e8f1440314ba = '#EBECF0';
var $d72ba21ad5986e6b$export$1ce2d1575d444ceb = '#DFE1E6';
var $d72ba21ad5986e6b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d72ba21ad5986e6b$export$c2e91cbeada39b8b = '#B3BAC5';
var $d72ba21ad5986e6b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d72ba21ad5986e6b$export$eaa8c8a70ac22806 = '#97A0AF';
var $d72ba21ad5986e6b$export$7c87d337fb91a97d = '#8993A4';
var $d72ba21ad5986e6b$export$d6447c357493214f = '#7A869A';
var $d72ba21ad5986e6b$export$f563ee71e9ee74cd = '#6B778C';
var $d72ba21ad5986e6b$export$e2ef2124cf4024b1 = '#5E6C84';
var $d72ba21ad5986e6b$export$eece5f492e429f08 = '#505F79';
var $d72ba21ad5986e6b$export$c39c0fe0f26207ae = '#42526E';
var $d72ba21ad5986e6b$export$7090862dc3038a9f = '#344563';
var $d72ba21ad5986e6b$export$ad0bacf983b7ddaa = '#253858';
var $d72ba21ad5986e6b$export$7d61b15e0da132af = '#172B4D';
var $d72ba21ad5986e6b$export$fbda843f0a27fe96 = '#091E42';
var $d72ba21ad5986e6b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d72ba21ad5986e6b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d72ba21ad5986e6b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d72ba21ad5986e6b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d72ba21ad5986e6b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d72ba21ad5986e6b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d72ba21ad5986e6b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d72ba21ad5986e6b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d72ba21ad5986e6b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d72ba21ad5986e6b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d72ba21ad5986e6b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d72ba21ad5986e6b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d72ba21ad5986e6b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d72ba21ad5986e6b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d72ba21ad5986e6b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d72ba21ad5986e6b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d72ba21ad5986e6b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d72ba21ad5986e6b$export$2f6319cf7d736c2a = '#E6EDFA';
var $d72ba21ad5986e6b$export$95126bc8884d6634 = '#DCE5F5';
var $d72ba21ad5986e6b$export$8338d8c35d44ff1 = '#CED9EB';
var $d72ba21ad5986e6b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d72ba21ad5986e6b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d72ba21ad5986e6b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d72ba21ad5986e6b$export$97e81faa16a182c7 = '#8C9CB8';
var $d72ba21ad5986e6b$export$bfe21c59123ecf33 = '#7988A3';
var $d72ba21ad5986e6b$export$ee82aa2ea6a1558 = '#67758F';
var $d72ba21ad5986e6b$export$682927c6ed76be02 = '#56637A';
var $d72ba21ad5986e6b$export$91fd9994c5be9757 = '#455166';
var $d72ba21ad5986e6b$export$d281fbfe3cff2df6 = '#3B475C';
var $d72ba21ad5986e6b$export$3902c91d8b98a753 = '#313D52';
var $d72ba21ad5986e6b$export$8e8133c1ba5845b5 = '#283447';
var $d72ba21ad5986e6b$export$33ff357f6620b39 = '#202B3D';
var $d72ba21ad5986e6b$export$633847cf062b69e0 = '#1B2638';
var $d72ba21ad5986e6b$export$9776a6e503bdbf76 = '#121A29';
var $d72ba21ad5986e6b$export$6c813d5160dff5db = '#0E1624';
var $d72ba21ad5986e6b$export$3d4f271a500072a = '#0D1424';
var $d72ba21ad5986e6b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d72ba21ad5986e6b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d72ba21ad5986e6b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d72ba21ad5986e6b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d72ba21ad5986e6b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d72ba21ad5986e6b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d72ba21ad5986e6b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d72ba21ad5986e6b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d72ba21ad5986e6b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d72ba21ad5986e6b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d72ba21ad5986e6b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d72ba21ad5986e6b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d72ba21ad5986e6b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d72ba21ad5986e6b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d72ba21ad5986e6b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d72ba21ad5986e6b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d72ba21ad5986e6b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d72ba21ad5986e6b$export$d2adc5dedf09fced = '#292A2E';
var $d72ba21ad5986e6b$export$f51762073d2bb381 = '#94C748';
var $d72ba21ad5986e6b$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("kUM4Q", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminLogo", function () { return $f39e54becbfb6094$export$f845d9b9254f0541; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $f39e54becbfb6094$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $f39e54becbfb6094$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $f39e54becbfb6094$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gF1sr", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationIcon", function () { return $c2119b221c164c0d$export$74517ed253186308; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $c2119b221c164c0d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $c2119b221c164c0d$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        svg: $c2119b221c164c0d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bCqmd", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationLogo", function () { return $8757b0503f3b7152$export$833abe6c2ce5ebfd; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $8757b0503f3b7152$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $8757b0503f3b7152$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $8757b0503f3b7152$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1IlGC", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsIcon", function () { return $13fab8fe06358f07$export$c42ad8a0b925c762; });

var $1oC0p = parcelRequire("1oC0p");

var $kKPLy = parcelRequire("kKPLy");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $13fab8fe06358f07$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $13fab8fe06358f07$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $kKPLy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $13fab8fe06358f07$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("kKPLy", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $f1c0423122792582$export$f680877a34711e37; });

var $2SXKI = parcelRequire("2SXKI");

var $1oC0p = parcelRequire("1oC0p");
function $f1c0423122792582$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId().replace(/[:«»]/g, '_');
}
var $f1c0423122792582$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($f1c0423122792582$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2SXKI.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2SXKI.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $f1c0423122792582$export$6ee17796e3d70de2() {
    var uid = $f1c0423122792582$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});


parcelRegister("90UgS", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsLogo", function () { return $68ffc36c35d3c3e3$export$e6470bfc39010cc4; });

var $1oC0p = parcelRequire("1oC0p");

var $kKPLy = parcelRequire("kKPLy");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $68ffc36c35d3c3e3$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $68ffc36c35d3c3e3$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $kKPLy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $68ffc36c35d3c3e3$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aNQRJ", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", function () { return $7dd77cfb957a9453$export$5fc1066e677788d4; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $7dd77cfb957a9453$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $7dd77cfb957a9453$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $7dd77cfb957a9453$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dH1al", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", function () { return $9f80320273d5a26c$export$bd40525f5333524b; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $9f80320273d5a26c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $9f80320273d5a26c$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9f80320273d5a26c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2av0D", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", function () { return $194491bfd52c60be$export$f7857fe64d7161d9; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $194491bfd52c60be$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $194491bfd52c60be$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $194491bfd52c60be$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iBaHp", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", function () { return $d8a3fb530dacea30$export$eb7d748e4f9c9676; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $d8a3fb530dacea30$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $d8a3fb530dacea30$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d8a3fb530dacea30$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gjb7I", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", function () { return $bdf70c91202088b4$export$68f3db7f6af48bcb; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $bdf70c91202088b4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $bdf70c91202088b4$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $bdf70c91202088b4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fN1CB", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogo", function () { return $b7ecb0a64b6ba3a8$export$1b2e4fe6ef471556; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $b7ecb0a64b6ba3a8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $b7ecb0a64b6ba3a8$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $b7ecb0a64b6ba3a8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gaRjA", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", function () { return $bc66efc50647119f$export$1e02e7298035a77c; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $bc66efc50647119f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $bc66efc50647119f$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $bc66efc50647119f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("l27EY", function(module, exports) {
$parcel$export(module.exports, "FocusLogo", function () { return $f4ffb9fad8ff29c2$export$33908560ea1b226d; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $f4ffb9fad8ff29c2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $f4ffb9fad8ff29c2$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f4ffb9fad8ff29c2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7AQx3", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", function () { return $5874a4fc35aca870$export$3f95fcfdc25a741d; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $5874a4fc35aca870$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $5874a4fc35aca870$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        svg: $5874a4fc35aca870$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3V5Yh", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", function () { return $2dab53bdc506fb6c$export$a4a891d202775deb; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $2dab53bdc506fb6c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $2dab53bdc506fb6c$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $2dab53bdc506fb6c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8ehmC", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", function () { return $5fdd19a525c40fe0$export$c4b5b1f965d8b3eb; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $5fdd19a525c40fe0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $5fdd19a525c40fe0$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $5fdd19a525c40fe0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("69qyP", function(module, exports) {
$parcel$export(module.exports, "JiraLogo", function () { return $47a82fbba0c51bbc$export$17d3acb0b4379d02; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $47a82fbba0c51bbc$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $47a82fbba0c51bbc$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $47a82fbba0c51bbc$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bqZk8", function(module, exports) {
$parcel$export(module.exports, "JiraAlignIcon", function () { return $8531b105295c42c1$export$407687b2dd89cc68; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $8531b105295c42c1$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $8531b105295c42c1$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $8531b105295c42c1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ia3Z8", function(module, exports) {
$parcel$export(module.exports, "JiraAlignLogo", function () { return $d38c4084074a01f2$export$ee11e928d3d045fd; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $d38c4084074a01f2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $d38c4084074a01f2$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d38c4084074a01f2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hIoKY", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $ce59bfdc6f59d3ea$export$21bfbeb62fdcce8d; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $ce59bfdc6f59d3ea$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $ce59bfdc6f59d3ea$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $ce59bfdc6f59d3ea$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aVGqQ", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $7f502459b8ba1cfc$export$c49a2b642fe9eef4; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $7f502459b8ba1cfc$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $7f502459b8ba1cfc$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7f502459b8ba1cfc$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cjbiZ", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $8f60075c6ffdb608$export$3c6158790f5e01c4; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $8f60075c6ffdb608$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $8f60075c6ffdb608$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $8f60075c6ffdb608$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("krxIx", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $ee207bd3b6fc3598$export$dabef2be6cd28c20; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $ee207bd3b6fc3598$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $ee207bd3b6fc3598$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $ee207bd3b6fc3598$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1DsrN", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", function () { return $130f80088e4e514b$export$8d789f76fde3e05; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $130f80088e4e514b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsForLoom)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $130f80088e4e514b$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $130f80088e4e514b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bhpyz", function(module, exports) {
$parcel$export(module.exports, "LoomLogo", function () { return $83651b3afb6c633b$export$94e206806e36c2ec; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $83651b3afb6c633b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsForLoom)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $83651b3afb6c633b$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $83651b3afb6c633b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5H7M3", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionIcon", function () { return $4256ffb08983bfef$export$1bf47cdade1a9fcb; });

var $1oC0p = parcelRequire("1oC0p");

var $eggzj = parcelRequire("eggzj");

var $1DsrN = parcelRequire("1DsrN");
var $4256ffb08983bfef$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1DsrN.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("hKgv2", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", function () { return $ceb3880070863fbe$export$6e87ce8d41eda665; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $ceb3880070863fbe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $ceb3880070863fbe$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $ceb3880070863fbe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("WVLe6", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", function () { return $0b1238f83e82572c$export$eeccc49dc7a12d9f; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $0b1238f83e82572c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $0b1238f83e82572c$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        svg: $0b1238f83e82572c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4yvQw", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogo", function () { return $35130a60e79f7a46$export$a1c6484cdecc2c4b; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $35130a60e79f7a46$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $35130a60e79f7a46$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $35130a60e79f7a46$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cn9y3", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", function () { return $901f0a15cadc3a6d$export$e23ae35269442b4f; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $901f0a15cadc3a6d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $901f0a15cadc3a6d$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        svg: $901f0a15cadc3a6d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("39aLD", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", function () { return $24aa908218ed4967$export$a0f6cb8061290bbb; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $24aa908218ed4967$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $24aa908218ed4967$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $24aa908218ed4967$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eYwU3", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", function () { return $ae703121cad7a83b$export$f3f5aa321d88adf9; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $ae703121cad7a83b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $ae703121cad7a83b$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $ae703121cad7a83b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("h9MNM", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogo", function () { return $c7d921f9da4832fd$export$bb4ae5b41b43be04; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $c7d921f9da4832fd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $c7d921f9da4832fd$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c7d921f9da4832fd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6sRcE", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", function () { return $4b4ea0a2e3779d33$export$4384da9b8b140bf4; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $4b4ea0a2e3779d33$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $4b4ea0a2e3779d33$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $4b4ea0a2e3779d33$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hULUE", function(module, exports) {
$parcel$export(module.exports, "TrelloLogo", function () { return $d0acd51e51d4bfc1$export$60e26212f3b61a28; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $d0acd51e51d4bfc1$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $d0acd51e51d4bfc1$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d0acd51e51d4bfc1$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gk333", function(module, exports) {
$parcel$export(module.exports, "AtlasIcon", function () { return $be20e0f1b2d87a63$export$9d0b19639662f94b; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $be20e0f1b2d87a63$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance;
    var colors = (0, $d2w8Y.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"".concat(colors.iconColor, "\">\n      <path d=\"M16 28.532c-6.656 0-12.068-5.412-12.068-12.068S9.344 4.396 16 4.396v1.921c-5.597 0-10.146 4.549-10.146 10.146S10.403 26.609 16 26.609zm0 0v-1.921c5.597 0 10.146-4.549 10.146-10.146h1.921c0 6.656-5.412 12.068-12.068 12.068zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V4.397c6.656 0 12.068 5.412 12.068 12.068zm-6.928 3.695c-1.28-.251-2.292-.706-3.973-1.467-.464-.204-.974-.436-1.559-.696a59 59 0 0 0-1.003-.436c-2.534-1.123-3.926-1.736-5.634-1.736-1.198 0-2.098.325-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.706 1.606.724 2.488 1.123 3.555 1.327l-.371 1.885Zm1.877.185c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.149 1.504.149 1.188 0 2.089-.298 2.609-.864s.539-1.253.51-1.615l1.913-.167c.102 1.169-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485M16 28.532v-1.921c2.757 0 4.4-2.813 4.4-7.52s-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.476 5.616 13.618 0 5.821-2.423 9.441-6.322 9.441m-.001 0c-4.15 0-6.526-3.379-6.526-9.273 0-6.879 3.008-10.722 5.82-13.776l1.412 1.299c-3.277 3.565-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352z\"/>\n      <path d=\"M10.857 17.467a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.871a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M15.998 7.96a2.247 2.247 0 1 0 0-4.493 2.247 2.247 0 0 0 0 4.494Z\"/>\n    </g>\n  </svg>");
};
var $be20e0f1b2d87a63$export$9d0b19639662f94b = function AtlasIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlas' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $be20e0f1b2d87a63$var$svg({
            appearance: appearance
        }, colorMode),
        size: size,
        testId: testId
    });
};

});

parcelRegister("2PLlk", function(module, exports) {
$parcel$export(module.exports, "AtlasLogo", function () { return $2105118b6e70b56b$export$e388b783bff06f6c; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $2105118b6e70b56b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance;
    var colors = (0, $d2w8Y.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return "<svg viewBox=\"0 0 102 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M12.068 27.865C5.412 27.865 0 22.453 0 15.797S5.412 3.73 12.068 3.73v1.922c-5.597 0-10.146 4.548-10.146 10.146 0 5.597 4.549 10.145 10.146 10.145z M12.068 27.865v-1.92c5.597 0 10.146-4.55 10.146-10.147h1.921c0 6.656-5.412 12.068-12.068 12.068h.001Zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V3.73c6.656 0 12.068 5.412 12.068 12.068zm-6.927 3.695c-1.282-.25-2.293-.705-3.974-1.466-.464-.204-.974-.436-1.559-.696a58 58 0 0 0-1.003-.436C8.14 15.77 6.747 15.158 5.04 15.158c-1.198 0-2.098.324-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.705 1.606.724 2.488 1.124 3.555 1.328l-.371 1.884Z M19.085 19.677c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.15 1.504.15 1.188 0 2.089-.298 2.609-.864s.539-1.254.51-1.616l1.913-.167c.102 1.17-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485 M12.068 27.865v-1.92c2.757 0 4.4-2.814 4.4-7.52 0-4.707-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.475 5.616 13.618 0 5.82-2.423 9.44-6.322 9.44 M12.067 27.866c-4.15 0-6.526-3.379-6.526-9.274 0-6.878 3.008-10.722 5.82-13.776l1.412 1.3c-3.277 3.564-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352v1.921Z\" fill=\"".concat(colors.iconColor, "\"/>\n    <path d=\"M6.925 16.8a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.872a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M12.066 7.294a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494\" fill=\"").concat(colors.iconColor, "\"/>\n    <path d=\"M101.019 21.163c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.89-1.84-3.803-2.545-3.404-.828-4.845-2.147-4.845-4.661 0-2.668 2.054-4.294 5.55-4.294 1.994 0 3.803.491 4.938 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.675-2.975 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.122 2.086 5.122 4.754m-25.873-3.496c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-12.784-.03c-.214.061-.674.122-1.349.122-2.514 0-4.11-1.196-4.11-4.017V3.591h2.638V21.1c0 1.38.92 1.871 2.055 1.871.276 0 .46 0 .767-.03v2.36ZM58.12 20.58c0 1.35.798 2.27 2.423 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.779.245c-3.28 0-4.876-1.932-4.876-4.784v-8.188h-2.483V10h2.483V6.75h2.577V10h4.078v2.453h-4.078v8.127Zm-14.675.736c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.81.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\" fill=\"").concat(colors.textColor, "\"/>\n  </svg>");
};
var $2105118b6e70b56b$export$e388b783bff06f6c = function AtlasLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlas' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        size: size,
        svg: $2105118b6e70b56b$var$svg({
            appearance: appearance
        }, colorMode),
        testId: testId
    });
};

});

parcelRegister("eghee", function(module, exports) {
$parcel$export(module.exports, "AtlassianMarketplaceIcon", function () { return $a61fec8ad1ff6211$export$94c87d39a54a1894; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $a61fec8ad1ff6211$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.817 16.96 3.647c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.816c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.9c-.167.334-.208.459-.208.626 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n  </svg>\n  ");
};
var $a61fec8ad1ff6211$export$94c87d39a54a1894 = function AtlassianMarketplaceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Marketplace' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        svg: $a61fec8ad1ff6211$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lhNXG", function(module, exports) {
$parcel$export(module.exports, "AtlassianMarketplaceLogo", function () { return $f7f1f0dbb1cbc92f$export$32e7eace0c9d6a57; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $f7f1f0dbb1cbc92f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 377 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M369.828 12.524c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.638v15.333zm-12.783-.031c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V4.03h2.637v17.51c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-11.153-7.635c0-3.68-1.472-5.52-4.202-5.52-2.361 0-4.477 1.502-4.477 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.974 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.239 0-3.956-1.012-4.876-3.005v8.678h-2.637V10.44h2.637v2.76c.981-2.024 2.821-3.067 5.183-3.067 4.078 0 6.133 3.466 6.133 7.974 0 4.324-2.147 7.973-6.44 7.973zm-14.975-5.06c0 1.35.798 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.779.245c-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10.44h2.484V7.19h2.576v3.25h4.079v2.453h-4.079zm-13.537-8.495c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-23.82.613h-2.637V4.03H269v13.585l6.593-7.176h3.435l-7.207 7.544 7.514 7.79h-3.588L269 18.595zm-10.333-9.046v9.046h-2.576V10.44h2.576v2.699c.889-1.81 2.422-3.098 5.428-2.914V12.8c-3.374-.337-5.428.675-5.428 3.926m-17.869 1.38c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.638v15.333zm-31.445-11.009-2.76-7.483v18.492h-2.76V5.624h4.784l4.569 11.562 1.871 5.55 1.871-5.55 4.6-11.562h4.446v20.148h-2.76V7.495l-2.361 7.268-4.447 11.01h-2.668z\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 11.267c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.807c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V10.417l1.769 4.034 6.087 11.325h5.379V5.604h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.156c0-3.54-1.841-5.167-7.149-6.3-2.902-.636-3.609-1.273-3.609-2.194 0-1.132 1.061-1.627 2.972-1.627 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.308 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3zM71.069 5.604v20.172h9.625l1.486-4.389h-6.44V5.604zm-19.039 0v4.318h5.167v15.854h4.741V9.922h5.592V5.604zm-6.866 0h-6.157L32 25.776h5.379l.99-3.398c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.698c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.604H91.17l-7.08 20.172h5.38l.99-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.114 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.094h-6.157l-7.007 20.172h5.379l.991-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.817 12.293 3.647c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.043 13.795.333.666.583.791 1.166.791h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.816c-.833-1.25-1.083-1.334-1.292-1.334s-.333.084-.708.834L.208 24.9c-.166.334-.208.459-.208.626 0 .333.292.666.917.666h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.875.333-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $f7f1f0dbb1cbc92f$export$32e7eace0c9d6a57 = function AtlassianMarketplaceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Marketplace' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $f7f1f0dbb1cbc92f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7RMEp", function(module, exports) {
$parcel$export(module.exports, "AtlassianAccessIcon", function () { return $5ba338a9d8111c8d$export$a825993f361832f7; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $5ba338a9d8111c8d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 32 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.042 13.794.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.462c-.167.333-.208.458-.208.625 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $5ba338a9d8111c8d$export$a825993f361832f7 = function AtlassianAccessIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Access' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        svg: $5ba338a9d8111c8d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iE23F", function(module, exports) {
$parcel$export(module.exports, "AtlassianAccessLogo", function () { return $d92d8f19ddb1b9e2$export$5aa23cd4d8596f56; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $d92d8f19ddb1b9e2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 299 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M298.505 21.163c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754m-13.626 0c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.828-4.845-2.147-4.845-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.802.491 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.675-2.975 1.87 0 1.074.736 1.749 3.558 2.423 3.404.828 5.121 2.086 5.121 4.754m-20.467-9.078c-2.791 0-4.202 1.81-4.478 4.478h8.556c-.153-2.852-1.441-4.478-4.078-4.478M270.3 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.147v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.546-.215 3.496-.553m-13.836 0v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.546-.215 3.496-.553m-22.45-1.257c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.337h5.379l.99-3.398c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.172h5.38l.99-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.172h5.379l.991-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.043 13.794.333.666.583.791 1.166.791h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.084-.708.834L.208 24.462c-.166.333-.208.458-.208.625 0 .333.292.666.917.666h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.875.333-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $d92d8f19ddb1b9e2$export$5aa23cd4d8596f56 = function AtlassianAccessLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Access' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d92d8f19ddb1b9e2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hwfCF", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementIcon", function () { return $cc118b2cbe537e3f$export$7330b9fc5718fd30; });

var $1oC0p = parcelRequire("1oC0p");

var $kKPLy = parcelRequire("kKPLy");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $cc118b2cbe537e3f$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n    <svg\n      fill=\"none\"\n      height=\"32\"\n      viewBox=\"0 0 32 32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <linearGradient\n        id=\"".concat(id, "\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"13.9485\"\n        x2=\"20.7792\"\n        y1=\"20.2388\"\n        y2=\"11.8277\"\n      >\n        <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " />\n        <stop offset=\"100%\" stop-color=\"").concat(colors.iconGradientStop, "\" />\n      </linearGradient>\n      <path\n        d=\"m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z\"\n        fill=\"url(#").concat(id, ")\"\n      />\n      <path\n      fill=\"").concat(colors.iconColor, "\"\n      d=\"m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z\"\n      />\n    </svg>");
};
var $cc118b2cbe537e3f$export$7330b9fc5718fd30 = function JiraWorkManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Work Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $kKPLy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $cc118b2cbe537e3f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("19O2G", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementLogo", function () { return $0d7d730b759064bb$export$56cadce97cc7cc; });

var $1oC0p = parcelRequire("1oC0p");

var $kKPLy = parcelRequire("kKPLy");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $0d7d730b759064bb$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg\n  fill=\"none\"\n  height=\"32\"\n  viewBox=\"0 0 303 32\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n>\n  <linearGradient\n    id=\"".concat(id, "\"\n    gradientUnits=\"userSpaceOnUse\"\n    x1=\"7.94848\"\n    x2=\"14.7792\"\n    y1=\"19.536\"\n    y2=\"11.1249\"\n  >\n    <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " />\n    <stop offset=\"100%\" stop-color=\"").concat(colors.iconGradientStop, "\" />\n  </linearGradient>\n  <path\n    d=\"m12.3893 6.29721-3.42568 13.18669c4.35918 1.2052 7.83828-.3558 9.17088-5.4802l1.9988-7.69729z\"\n    fill=\"url(#").concat(id, ")\"\n  />\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m7.75657 24.1237 3.42573-13.1866c-4.3623-1.19602-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z\" />\n  <g fill=\"").concat(colors.textColor, "\">\n    <path\n      clip-rule=\"evenodd\"\n      d=\"m122.757 5v19.1237h2.379v-6.305l6.085 6.305h3.234l-6.776-6.8448 6.499-6.6485h-3.095l-5.947 6.3296v-11.96zm-84.0053.55058c-.2088-.0757-.4319-.1066-.654-.09058-.222-.0155-.4448.01575-.6533.09164-.2086.07589-.398.19465-.5553.34821-.1574.15356-.2791.33835-.3569.54183s-.1098.4209-.0939.63752c0 .42944.1748.84129.486 1.14495s.7333.47425 1.1734.47425.8622-.17059 1.1734-.47425.4861-.71551.4861-1.14495c.0164-.21674-.0153-.43438-.0929-.6381s-.1993-.38872-.3568-.5424c-.1574-.15367-.347-.27241-.5558-.34812zm.5089 5.07982h-2.3792v13.4933h2.3792zm-5.6979-4.22587h-2.4891l.0094 12.49357c0 1.7695-.726 2.9962-2.8286 2.9962-.88.0065-1.7534-.1496-2.574-.46v2.349c.9621.3182 1.9731.4727 2.9889.457 3.4288 0 4.8934-2.2387 4.8934-5.5047zm11.6158 17.71917h-2.3225v-13.4933h2.3225v2.3736c.8015-1.5916 2.1843-2.7232 4.8966-2.5637v2.2693c-3.0423-.3067-4.8966.5919-4.8966 3.4531zm11.3678.2791c2.1309 0 3.7903-.9169 4.6734-2.6987l.0032 2.4196h2.3791v-13.4933h-2.3791v2.3828c-.8329-1.7541-2.3823-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.8543 7.0165 5.5314 7.0165zm4.6734-6.4768c0 2.9961-1.9077 4.3179-4.0385 4.3179-2.4609 0-3.7872-1.6192-3.7966-4.8576 0-3.1311 1.3829-4.8576 4.0637-4.8576 2.0303 0 3.7714 1.3217 3.7714 4.3178zm8.6023-11.52147h2.5709l4.7143 15.43457 5.1731-15.43457h2.9291l5.1732 15.43457 4.73-15.43457h2.4891l-5.7105 17.71917h-3.1806l-5.0286-15.1401-5.0285 15.1401h-3.0989zm34.376 3.96517c-4.148 0-6.5808 2.941-6.5808 6.989s2.4608 7.0533 6.5808 7.0533c4.121 0 6.528-3.0053 6.528-7.0533s-2.379-6.989-6.528-6.989zm0 11.8742c-2.957 0-4.2582-2.3215-4.2582-4.8852h.0031c0-2.5638 1.3231-4.83 4.2551-4.83 2.933 0 4.205 2.2662 4.205 4.83 0 2.5637-1.247 4.8852-4.205 4.8852zm11.617 1.8798h-2.323v-13.4933h2.323v2.3736c.801-1.5916 2.184-2.7232 4.896-2.5637v2.2693c-3.042-.3067-4.896.5919-4.896 3.4531zm28.734-16.2533v16.2533h-2.492v-17.71917h4.315l4.121 10.17217 1.687 4.8852 1.688-4.8852 4.149-10.17217h4.01v17.71917h-2.489v-16.07543l-2.131 6.39703-4.007 9.6784h-2.408l-3.953-9.6784zm26.165 16.5324c2.131 0 3.79-.9169 4.673-2.6987l.003 2.4196h2.38v-13.4933h-2.38v2.3828c-.833-1.7541-2.382-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.855 7.0165 5.532 7.0165zm4.673-6.4768c0 2.9961-1.907 4.3179-4.038 4.3179-2.461 0-3.787-1.6192-3.797-4.8576 0-3.1311 1.383-4.8576 4.064-4.8576 2.03 0 3.771 1.3217 3.771 4.3178zm17.729 6.1977h-2.379v-8.142c0-2.4288-.996-3.5082-3.262-3.5082-2.2 0-3.734 1.4321-3.734 4.1584v7.4918h-2.379v-13.4933h2.379v2.2141c.423-.7665 1.055-1.4041 1.826-1.8424s1.651-.6603 2.543-.6416c3.18 0 5.006 2.1467 5.006 5.8574zm8.021.2791c2.131 0 3.79-.9169 4.673-2.6987l.003 2.4196h2.379v-13.4933h-2.379v2.3828c-.833-1.7541-2.382-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.855 7.0165 5.532 7.0165zm4.673-6.4768c0 2.9961-1.908 4.3179-4.038 4.3179-2.461 0-3.772-1.6192-3.772-4.8668 0-3.1219 1.367-4.8484 4.039-4.8484 2.03 0 3.771 1.3217 3.771 4.3178zm15.293 3.7781c-.883 1.7818-2.542 2.6987-4.673 2.6987-3.658 0-5.475-3.0391-5.475-7.0257 0-3.8058 1.908-7.0166 5.752-7.0166 2.02 0 3.567.8894 4.4 2.6435v-2.3736h2.325v12.2667c0 3.9682-1.911 6.6393-6.861 6.6393-1.672.0477-3.339-.1995-4.921-.7299v-2.2294c1.549.5193 3.173.7927 4.811.8096 3.458 0 4.646-1.8094 4.646-4.3179zm-4.035.5398c2.128 0 4.035-1.3218 4.035-4.3179v-1.0795c0-2.9961-1.741-4.3178-3.771-4.3178-2.684 0-4.067 1.7265-4.067 4.8576.013 3.2384 1.339 4.8576 3.803 4.8576zm9.127-4.8944c0 4.14 2.266 7.0533 7.439 7.0533 1.411 0 3.152-.2147 4.281-.7943v-2.1466c-1.346.477-2.767.7199-4.199.7176-3.263 0-4.784-1.4843-5.117-3.7782h10.092v-1.0518c0-4.1002-1.71-6.989-5.972-6.989-4.202 0-6.524 2.9134-6.524 6.989zm10.095-.92h-7.719v-.0154c.251-2.346 1.521-3.9437 4.038-3.9437 2.38 0 3.542 1.4352 3.681 3.9591zm16.98 7.6942h-2.379v-8.142c0-2.4288-.996-3.5082-3.265-3.5082-2.2 0-3.731 1.4321-3.731 4.1584v7.4918h-2.379v-13.4933h2.37v2.2141c.423-.7667 1.054-1.4045 1.825-1.8428.771-.4384 1.651-.6603 2.543-.6412 2.351 0 3.954 1.1592 4.646 3.2936.776-2.0792 2.627-3.2936 4.924-3.2936 3.096 0 4.812 2.0516 4.812 5.8574v7.9058h-2.379v-7.4918c.009-2.7815-.971-4.1615-3.253-4.1615-2.2 0-3.734 1.4321-3.734 4.1584zm11.865-6.7742c0 4.14 2.266 7.0533 7.439 7.0533 1.411 0 3.152-.2147 4.287-.8035v-2.1466c-1.347.4808-2.771.7269-4.205.7268-3.263 0-4.784-1.4843-5.117-3.7782h10.095v-1.0518c0-4.1002-1.713-6.989-5.972-6.989-4.205 0-6.527 2.9134-6.527 6.989zm10.095-.92h-7.716v-.0154c.258-2.346 1.515-3.9437 4.029-3.9437 2.385 0 3.548 1.4352 3.687 3.9591zm16.98 7.6942h-2.379v-8.142c0-2.4288-1.002-3.5113-3.262-3.5113-2.2 0-3.734 1.4321-3.734 4.1584v7.4949h-2.379v-13.4933h2.379v2.2141c.423-.7667 1.055-1.4045 1.826-1.8428.771-.4384 1.651-.6603 2.543-.6412 3.18 0 5.006 2.1467 5.006 5.8574zm10.287-2.3644c-.49.1102-.99.1728-1.493.1871-1.464 0-2.184-.8096-2.187-1.9964v-7.1729h3.677v-2.1467h-3.677v-2.852h-2.323v2.852h-2.241v2.1681h2.241v7.2067c0 2.5085 1.44 4.2075 4.4 4.2075.542.0028 1.082-.0695 1.603-.2147z\"\n      fill-rule=\"evenodd\"\n    />\n  </g>\n</svg>");
};
var $0d7d730b759064bb$export$56cadce97cc7cc = function JiraWorkManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Work Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $kKPLy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $0d7d730b759064bb$var$svg({
            appearance: appearance,
            size: size,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("zADBD", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", function () { return $06afb0811940995d$export$8a485e2e7ed91e8f; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $06afb0811940995d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $06afb0811940995d$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $06afb0811940995d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("5YGzb", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogo", function () { return $45a3932414e26e5e$export$765cacec8b0843f3; });

var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $45a3932414e26e5e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearance)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $45a3932414e26e5e$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $45a3932414e26e5e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2b30R", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareIcon", function () { return $195ef226fe3b4752$export$c3835feba2a66e67; });

var $1oC0p = parcelRequire("1oC0p");

var $kKPLy = parcelRequire("kKPLy");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $195ef226fe3b4752$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 32 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"108.695%\" x2=\"12.439%\" y1=\"-14.936%\" y2=\"45.215%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"0%\" x2=\"91.029%\" y1=\"118.55%\" y2=\"63.971%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z\" />\n      <path fill=\"url(#").concat(id, "-1\" d=\"M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z\" />\n      <path fill=\"url(#").concat(id, "-2\" d=\"M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z\" />\n    </g>\n  </svg>");
};
var $195ef226fe3b4752$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $kKPLy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $195ef226fe3b4752$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ebfhn", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareLogo", function () { return $a52df1ee042dbe77$export$8869c52f95591fed; });

var $1oC0p = parcelRequire("1oC0p");

var $kKPLy = parcelRequire("kKPLy");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $cTVn3 = parcelRequire("cTVn3");

var $d2w8Y = parcelRequire("d2w8Y");
var $a52df1ee042dbe77$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $d2w8Y.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 179 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"97.6553341%\" y1=\"35.6591143%\" x2=\"37.202032%\" y2=\"75.4891864%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"7%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"8.43371138%\" y1=\"60.1495759%\" x2=\"64.1161517%\" y2=\"23.5790285%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M11.3881081,27.9242105 C12.4881804,26.8071817 13.1062496,25.2917664 13.1062496,23.7115789 C13.1062496,22.1313915 12.4881804,20.6159762 11.3881081,19.4989474 L11.3881081,19.4989474 L3.74837838,11.7621053 L0.273513514,15.2926316 C-0.0900771727,15.6625064 -0.0900771727,16.2617042 0.273513514,16.6315789 L11.3881081,27.9242105 L11.3881081,27.9242105 Z\" fill-rule=\"nonzero\"></path>\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M22.5027027,15.2926316 L11.3881081,4 L11.3881081,4 L11.3539189,4.03473684 L11.3539189,4.03473684 C9.08852466,6.36456187 9.09963243,10.1156459 11.3787838,12.4315789 L19.0247297,20.1652632 L22.5027027,16.6315789 C22.8662934,16.2617042 22.8662934,15.6625064 22.5027027,15.2926316 Z\" fill-rule=\"nonzero\"></path>\n      <path d=\"M11.3881081,12.4252632 C9.10895676,10.1093301 9.09784899,6.35824608 11.3632432,4.02842105 L3.43445946,12.0810526 L7.58067568,16.2936842 L11.3881081,12.4252632 Z\" fill=\"url(#").concat(id, "-1)\" fill-rule=\"nonzero\"></path>\n      <path fill=\"url(#").concat(id, "-2)\" d=\"M15.1893243,15.6368421 L11.3881081,19.4989474 C12.4881804,20.6159762 13.1062496,22.1313915 13.1062496,23.7115789 C13.1062496,25.2917664 12.4881804,26.8071817 11.3881081,27.9242105 L19.3355405,19.8494737 L15.1893243,15.6368421 Z\" fill-rule=\"nonzero\"></path>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M36.07,18.956 C36.07,20.646 35.394,21.842 33.418,21.842 C32.56,21.842 31.702,21.686 31,21.4 L31,23.662 C31.65,23.896 32.586,24.104 33.808,24.104 C37.032,24.104 38.41,21.946 38.41,18.8 L38.41,6.918 L36.07,6.918 L36.07,18.956 Z M41.894,7.568 C41.894,8.556 42.544,9.128 43.454,9.128 C44.364,9.128 45.014,8.556 45.014,7.568 C45.014,6.58 44.364,6.008 43.454,6.008 C42.544,6.008 41.894,6.58 41.894,7.568 Z M42.31,24 L44.546,24 L44.546,11 L42.31,11 L42.31,24 Z M47.926,24 L50.11,24 L50.11,16.33 C50.11,13.574 51.852,12.716 54.712,13.002 L54.712,10.818 C52.164,10.662 50.864,11.754 50.11,13.288 L50.11,11 L47.926,11 L47.926,24 Z M65.45,24 L65.45,21.66 C64.618,23.376 63.058,24.26 61.056,24.26 C57.598,24.26 55.856,21.322 55.856,17.5 C55.856,13.834 57.676,10.74 61.316,10.74 C63.214,10.74 64.67,11.598 65.45,13.288 L65.45,11 L67.686,11 L67.686,24 L65.45,24 Z M58.092,17.5 C58.092,20.62 59.34,22.18 61.654,22.18 C63.656,22.18 65.45,20.906 65.45,18.02 L65.45,16.98 C65.45,14.094 63.812,12.82 61.914,12.82 C59.392,12.82 58.092,14.484 58.092,17.5 Z M86.926,19.294 C86.926,16.226 84.898,15.056 81.284,14.146 C78.268,13.392 77.176,12.69 77.176,11.286 C77.176,9.726 78.502,8.946 80.738,8.946 C82.506,8.946 84.352,9.258 86.068,10.246 L86.068,7.906 C84.898,7.256 83.312,6.658 80.842,6.658 C76.864,6.658 74.836,8.634 74.836,11.286 C74.836,14.094 76.552,15.42 80.4,16.356 C83.65,17.136 84.586,17.942 84.586,19.45 C84.586,20.958 83.624,21.972 81.05,21.972 C78.788,21.972 76.344,21.374 74.758,20.542 L74.758,22.934 C76.084,23.61 77.618,24.26 80.92,24.26 C85.158,24.26 86.926,22.258 86.926,19.294 Z M95.09,24.26 C91.19,24.26 88.902,21.374 88.902,17.474 C88.902,13.574 91.19,10.74 95.09,10.74 C98.964,10.74 101.226,13.574 101.226,17.474 C101.226,21.374 98.964,24.26 95.09,24.26 Z M95.09,12.82 C92.308,12.82 91.086,15.004 91.086,17.474 C91.086,19.944 92.308,22.18 95.09,22.18 C97.846,22.18 99.042,19.944 99.042,17.474 C99.042,15.004 97.846,12.82 95.09,12.82 Z M106.92,9.622 C106.92,8.452 107.596,7.646 108.974,7.646 C109.494,7.646 109.988,7.698 110.378,7.776 L110.378,5.722 C109.988,5.618 109.546,5.514 108.87,5.514 C106.088,5.514 104.736,7.152 104.736,9.57 L104.736,11 L102.63,11 L102.63,13.08 L104.736,13.08 L104.736,24 L106.92,24 L106.92,13.08 L110.274,13.08 L110.274,11 L106.92,11 L106.92,9.622 Z M115.786,19.892 L115.786,13.08 L119.244,13.08 L119.244,11 L115.786,11 L115.786,8.244 L113.602,8.244 L113.602,11 L111.496,11 L111.496,13.08 L113.602,13.08 L113.602,19.944 C113.602,22.362 114.954,24 117.736,24 C118.412,24 118.854,23.896 119.244,23.792 L119.244,21.634 C118.854,21.712 118.36,21.816 117.84,21.816 C116.462,21.816 115.786,21.036 115.786,19.892 Z M125.432,24 L128.292,24 L130.528,17.708 L131.724,13.704 L132.92,17.708 L135.156,24 L138.016,24 L142.8,11 L140.33,11 L136.586,22.024 L132.79,11 L130.658,11 L126.862,22.024 L123.118,11 L120.648,11 L125.432,24 Z M153.538,24 L153.538,21.66 C152.706,23.376 151.146,24.26 149.144,24.26 C145.686,24.26 143.944,21.322 143.944,17.5 C143.944,13.834 145.764,10.74 149.404,10.74 C151.302,10.74 152.758,11.598 153.538,13.288 L153.538,11 L155.774,11 L155.774,24 L153.538,24 Z M146.18,17.5 C146.18,20.62 147.428,22.18 149.742,22.18 C151.744,22.18 153.538,20.906 153.538,18.02 L153.538,16.98 C153.538,14.094 151.9,12.82 150.002,12.82 C147.48,12.82 146.18,14.484 146.18,17.5 Z M159.154,24 L161.338,24 L161.338,16.33 C161.338,13.574 163.08,12.716 165.94,13.002 L165.94,10.818 C163.392,10.662 162.092,11.754 161.338,13.288 L161.338,11 L159.154,11 L159.154,24 Z M178.108,23.48 C177.042,24.052 175.404,24.26 174.078,24.26 C169.216,24.26 167.084,21.452 167.084,17.474 C167.084,13.548 169.268,10.74 173.22,10.74 C177.224,10.74 178.836,13.522 178.836,17.474 L178.836,18.488 L169.346,18.488 C169.658,20.698 171.088,22.128 174.156,22.128 C175.664,22.128 176.938,21.842 178.108,21.426 L178.108,23.48 Z M173.116,12.768 C170.75,12.768 169.554,14.302 169.32,16.564 L176.574,16.564 C176.444,14.146 175.352,12.768 173.116,12.768 Z\" fill-rule=\"evenodd\"></path>\n    </g>\n  </svg>");
};
var $a52df1ee042dbe77$export$8869c52f95591fed = function JiraSoftwareLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $kKPLy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a52df1ee042dbe77$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("udLOo", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedComponent", function () { return $05ad7bec4c4dce92$export$e30d2ddc605f6bb; });
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", function () { return $05ad7bec4c4dce92$export$436fcf6e31fbacea; });
$parcel$export(module.exports, "createFeatureFlaggedRovoComponent", function () { return $05ad7bec4c4dce92$export$2469203854060337; });
$parcel$export(module.exports, "tempSizeWrapper", function () { return $05ad7bec4c4dce92$export$667425256e2e7296; });
$parcel$export(module.exports, "teamEUFlaggedIcon", function () { return $05ad7bec4c4dce92$export$3fe521abfbbe6ab3; });

var $8PRJC = parcelRequire("8PRJC");

var $5EQbP = parcelRequire("5EQbP");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");
var $05ad7bec4c4dce92$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $05ad7bec4c4dce92$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $05ad7bec4c4dce92$var$_excluded3 = [
    "shouldUseHexLogo"
], $05ad7bec4c4dce92$var$_excluded4 = [
    "size"
];
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */ var $05ad7bec4c4dce92$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, $5EQbP.default)(_ref, $05ad7bec4c4dce92$var$_excluded);
        if ((0, $39c3M.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(NewComponent, (0, $8PRJC.default)({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LegacyComponent, (0, $8PRJC.default)({
            size: size
        }, props));
    };
};
var $05ad7bec4c4dce92$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, $5EQbP.default)(_ref2, $05ad7bec4c4dce92$var$_excluded2);
        if ((0, $39c3M.fg)('platform-logo-rebrand-servco') || (0, $39c3M.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(NewComponent, (0, $8PRJC.default)({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LegacyComponent, (0, $8PRJC.default)({
            size: size
        }, props));
    };
};
var $05ad7bec4c4dce92$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $05ad7bec4c4dce92$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $05ad7bec4c4dce92$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, $5EQbP.default)(_ref3, $05ad7bec4c4dce92$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $39c3M.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $05ad7bec4c4dce92$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, $5EQbP.default)(_ref4, $05ad7bec4c4dce92$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(NewComponent, (0, $8PRJC.default)({
            size: size || 'medium'
        }, props));
    };
};
var $05ad7bec4c4dce92$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $39c3M.fg)('platform-logo-rebrand-team-eu') ? $05ad7bec4c4dce92$export$667425256e2e7296(NewComponent) : $05ad7bec4c4dce92$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Logo, props);
    };
};
var $05ad7bec4c4dce92$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $05ad7bec4c4dce92$export$62e1212796a86b1b = $05ad7bec4c4dce92$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $05ad7bec4c4dce92$export$e0dee4a765830f4d = $05ad7bec4c4dce92$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $05ad7bec4c4dce92$export$a13ce90e90d7bfc1 = $05ad7bec4c4dce92$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'agent' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $05ad7bec4c4dce92$export$516fce44c502c1d3 = $05ad7bec4c4dce92$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $05ad7bec4c4dce92$export$b805fae8e798ed39 = $05ad7bec4c4dce92$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $05ad7bec4c4dce92$export$3f9abd26214cd85f = $05ad7bec4c4dce92$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});

});


parcelRegister("4IlVP", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", function () { return $6c507d1aa65bc8ef$export$57570b1603cf6adb; });
const $6c507d1aa65bc8ef$export$57570b1603cf6adb = (useDev)=>{
    // Don't check for `window` if in a node environment
    const isBrowser = Boolean(typeof window !== 'undefined' && window.IS_STATIC);
    if (useDev && isBrowser && window.location.hostname.includes('local')) return 'dev';
    return 'production';
};

});

parcelRegister("69SrI", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentsLogo", function () { return $d4d0a553b8475361$export$cfb19d3a192c6fe2; });
/* rovo-dev-agents-logo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $d4d0a553b8475361$export$cfb19d3a192c6fe2 = ()=>{
    const cmsLogoStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: `https://dam-cdn.atl.orangelogic.com/AssetLink/5t47pkm4i4ohq647450a58xbtp5m5f08.svg`,
            alt: 'Rovo Dev Logo'
        },
        className: (0, $2jatx.default)([
            "_4t3ickbl"
        ])
    }, 'devai.ondemand');
};

});
parcelRegister("hnmMQ", function(module, exports) {
$parcel$export(module.exports, "extendBfldrCacheTime", function () { return $2a1a286563cd49a9$export$54f5ec149fac9f45; });
$parcel$export(module.exports, "Image", function () { return $2a1a286563cd49a9$export$3e431a229df88919; });
$parcel$export(module.exports, "getSrcSet", function () { return $2a1a286563cd49a9$export$7ab3f8b89543d628; });
$parcel$export(module.exports, "Picture", function () { return $2a1a286563cd49a9$export$f0d5dc2ce3e4cb5f; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $2a1a286563cd49a9$var$imageCSS = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== 'none' ? {
        aspectRatio: ratio,
        objectFit: 'cover',
        width: '100%'
    } : {};
    return {
        maxWidth: '100%',
        ...aspectRatioCSS
    };
};
function $2a1a286563cd49a9$export$54f5ec149fac9f45(src) {
    const extendCachingOfBfldrAssets = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacWebExtendedCachingOfBfldrAssetsForJsw);
    const maxAge = 31536000;
    if (extendCachingOfBfldrAssets && // eslint-disable-next-line local/no-brandfolder-images-eslint
    src.includes('wac-cdn-bfldr.atlassian.com')) try {
        const url = new URL(src);
        url.searchParams.append('max_age', maxAge.toString());
        return url.toString();
    } catch (error) {
        return src;
    }
    else return src;
}
const $2a1a286563cd49a9$export$3e431a229df88919 = ({ src: src, alt: alt, aspectRatio: aspectRatio, ...rest })=>{
    let modifiedSrc = src;
    // eslint-disable-next-line local/no-brandfolder-images-eslint
    if (src.includes('wac-cdn-bfldr.atlassian.com')) modifiedSrc = $2a1a286563cd49a9$export$54f5ec149fac9f45(src);
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        src: modifiedSrc,
        alt: alt,
        style: $2a1a286563cd49a9$var$imageCSS(aspectRatio),
        ...rest
    }));
};
const $2a1a286563cd49a9$export$ef1c8480e0b65584 = (src, width, height)=>{
    const extendCachingOfBfldrAssets = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacWebExtendedCachingOfBfldrAssetsForJsw);
    if (src.includes('dam-cdn.atl.orangelogic.com')) {
        if (width) {
            const srcSet = $2a1a286563cd49a9$export$990d7fb4a6e407a3(src, width);
            return srcSet.length > 0 ? srcSet.join(',') : `${src}`;
        } else return `${src}`; // Return the original src if no width is provided
    } else if (extendCachingOfBfldrAssets) {
        const maxAge = 31536000;
        if (width) {
            const srcSet = $2a1a286563cd49a9$export$7ab3f8b89543d628(src, width, [
                'auto=webp',
                `max_age=${maxAge}`
            ]);
            return srcSet.length > 0 ? srcSet.join(',') : `${src}?&max_age=${maxAge}`;
        } else if (height) return `${src}?auto=webp&height=${height}&max_age=${maxAge}`;
        else return `${src}?auto=webp&max_age=${maxAge}`;
    } else {
        if (width) {
            const srcSet = $2a1a286563cd49a9$export$7ab3f8b89543d628(src, width, [
                'auto=webp'
            ]);
            return srcSet.length > 0 ? srcSet.join(',') : src;
        } else if (height) return `${src}?auto=webp&height=${height}`;
        else return `${src}?auto=webp`;
    }
};
const $2a1a286563cd49a9$export$ada5537b2c061996 = (maxWidth, width, height)=>{
    if (width && height && width > maxWidth) return {
        width: maxWidth,
        height: Math.round(maxWidth * (height / width) * 100) / 100
    };
    else if (width && height) return {
        width: width,
        height: height
    };
    else if (width && width > maxWidth) return {
        width: maxWidth,
        height: maxWidth
    };
    else if (width) return {
        width: width,
        height: width
    };
    else return {
        width: maxWidth,
        height: maxWidth
    };
};
const $2a1a286563cd49a9$export$f0d5dc2ce3e4cb5f = ({ sources: sources, image: { src: src, alt: alt, width: width, height: height, ...imageProps }, className: className, style: style, forceEagerLoad: forceEagerLoad = false })=>{
    const DECORATIVE_IMGS = [
        'https://dam-cdn.atl.orangelogic.com/AssetLink/504175ycu5d01061dg4evte5l0m72pea.svg',
        'https://dam-cdn.atl.orangelogic.com/AssetLink/q6j1k002cmxpvr2145m8q3u70gfrm2qt.svg',
        'https://dam-cdn.atl.orangelogic.com/AssetLink/0ho3162460jba51mgj0a16k3cpvy074s.svg',
        'https://dam-cdn.atl.orangelogic.com/AssetLink/3ixqjd5540sdn251h25h55i82occ48sa.svg',
        'https://dam-cdn.atl.orangelogic.com/AssetLink/ua18axib18162bej4n515osj7675wepi.webp'
    ];
    const isDecorativeImg = DECORATIVE_IMGS.includes(src);
    const finalAlt = isDecorativeImg ? '' : alt ?? '';
    const loadingMethod = (0, $1oC0p.useMemo)(()=>forceEagerLoad ? {
            fetchpriority: 'high',
            loading: 'eager'
        } : {
            loading: 'lazy'
        }, [
        forceEagerLoad
    ]);
    // SVG images are already optimized for responsiveness
    if (src && src.endsWith('.svg')) {
        const modifiedSrc = $2a1a286563cd49a9$export$54f5ec149fac9f45(src);
        return(// eslint-disable-next-line no-restricted-syntax
        /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
            ...loadingMethod,
            ...imageProps,
            src: modifiedSrc,
            alt: finalAlt,
            width: width,
            height: height,
            style: {
                maxWidth: '100%',
                ...style
            },
            className: className
        }));
    }
    if (sources) {
        const modifiedSrc = $2a1a286563cd49a9$export$54f5ec149fac9f45(src);
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("picture", {
            className: className,
            children: [
                sources.map((source, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                        ...source
                    }, index)),
                /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    ...loadingMethod,
                    ...imageProps,
                    src: modifiedSrc,
                    alt: finalAlt,
                    width: width,
                    height: height,
                    style: {
                        maxWidth: '100%',
                        ...style
                    }
                })
            ]
        });
    }
    if (src && // eslint-disable-next-line local/no-brandfolder-images-eslint
    (src.includes('wac-cdn-bfldr.atlassian.com') || src.includes('dam-cdn.atl.orangelogic.com'))) {
        const { width: tabletWidth, height: tabletHeight } = $2a1a286563cd49a9$export$ada5537b2c061996(768, width, height);
        const { width: mobileWidth, height: mobileHeight } = $2a1a286563cd49a9$export$ada5537b2c061996(480, width, height);
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("picture", {
            className: className,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    srcSet: $2a1a286563cd49a9$export$ef1c8480e0b65584(src, mobileWidth, mobileHeight),
                    type: "image/webp",
                    media: "(max-width: 480px)",
                    width: mobileWidth,
                    height: mobileHeight
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    srcSet: $2a1a286563cd49a9$export$ef1c8480e0b65584(src, tabletWidth, tabletHeight),
                    type: "image/webp",
                    media: "(max-width: 768px)",
                    width: tabletWidth,
                    height: tabletHeight
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    ...loadingMethod,
                    ...imageProps,
                    src: $2a1a286563cd49a9$export$ef1c8480e0b65584(src),
                    alt: finalAlt,
                    width: width,
                    height: height,
                    style: {
                        ...style
                    }
                })
            ]
        });
    }
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        ...loadingMethod,
        ...imageProps,
        src: src,
        alt: finalAlt,
        width: width,
        height: height,
        style: {
            maxWidth: '100%',
            ...style
        },
        className: className
    }));
};
const $2a1a286563cd49a9$export$7ab3f8b89543d628 = (src, baseWidth, queryPairs, widthKey = 'width')=>{
    return [
        baseWidth,
        baseWidth * 1.8,
        baseWidth * 2.6
    ].map((w, i)=>{
        const srcSetQueryPairs = [
            ...queryPairs,
            `${widthKey}=${Math.ceil(w)}`
        ];
        return `${src}?${srcSetQueryPairs.join('&')} ${i + 1}x`;
    });
};
// @ts-ignore
function $2a1a286563cd49a9$var$separateUrlAndExtension(url) {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    const lastDotIndex = pathname.lastIndexOf('.');
    const extension = pathname.substring(lastDotIndex);
    const baseUrl = url.slice(0, url.length - extension.length);
    return {
        baseUrl: baseUrl,
        extension: extension
    };
}
const $2a1a286563cd49a9$export$990d7fb4a6e407a3 = (src, baseWidth)=>{
    // @ts-ignore
    return [
        baseWidth,
        baseWidth * 1.8,
        baseWidth * 2.6
    ].map((w, i)=>{
        // const { baseUrl, extension } = separateUrlAndExtension(src);
        // const srcSetQueryPairs = `/t/re_w_${Math.ceil(w)}/`;
        // return `${baseUrl}${srcSetQueryPairs}${extension} ${i + 1}x`;
        return `${src} ${i + 1}x`;
    });
};

});



parcelRegister("gZgIU", function(module, exports) {
$parcel$export(module.exports, "getContinueParam", function () { return $9c4fdf28a38e0209$export$46b6a16917b33fad; });
$parcel$export(module.exports, "hasJiraImcCampaignKey", function () { return $9c4fdf28a38e0209$export$8b0e0387dd06d72b; });
$parcel$export(module.exports, "getLocalePath", function () { return $9c4fdf28a38e0209$export$881f05c9f097031e; });
$parcel$export(module.exports, "getLoginUrl", function () { return $9c4fdf28a38e0209$export$8abe2e83e8d74da2; });
$parcel$export(module.exports, "getIdentityInterstitialUrl", function () { return $9c4fdf28a38e0209$export$9996970bc91cf103; });
$parcel$export(module.exports, "getNameYourSiteRedirectUrl", function () { return $9c4fdf28a38e0209$export$fe82873cf9bd9e7e; });
$parcel$export(module.exports, "getConfirmationPageUrl", function () { return $9c4fdf28a38e0209$export$95a87dbace0b33a0; });
$parcel$export(module.exports, "getDeferSiteNamingConfirmationPageUrl", function () { return $9c4fdf28a38e0209$export$f03910293318c542; });
$parcel$export(module.exports, "getSwitchAccountUrl", function () { return $9c4fdf28a38e0209$export$1b05c3730ec97967; });
$parcel$export(module.exports, "getAdminHubUpgradeProductUrl", function () { return $9c4fdf28a38e0209$export$5295fefa042f6101; });
$parcel$export(module.exports, "getCrossFlowActivationUrl", function () { return $9c4fdf28a38e0209$export$10da5dfd3e881279; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $ikT6N = parcelRequire("ikT6N");
parcelRequire("kNE9Z");
var $eRzlV = parcelRequire("eRzlV");

var $6fz8F = parcelRequire("6fz8F");

var $fcO7r = parcelRequire("fcO7r");

var $c0vG6 = parcelRequire("c0vG6");
function $9c4fdf28a38e0209$export$46b6a16917b33fad(location) {
    const url = new URL(location.href);
    const continueParam = url.searchParams.get('continue');
    if (continueParam) try {
        const continueUrl = new URL(continueParam);
        if (continueUrl.origin === (0, $eRzlV.getWacIntegrationUrl)()) // only use continue param if it's a valid WAC URL
        return decodeURIComponent(continueParam);
    } catch  {
    // continue param is not a valid URL
    }
    return null;
}
// Ensure the correct path to the module
const $9c4fdf28a38e0209$var$JIRA_IMC_CAMPAIGN_KEY = 'I:imc-jira-twc-pm';
const $9c4fdf28a38e0209$export$8b0e0387dd06d72b = (value)=>Boolean(value?.split('|').includes($9c4fdf28a38e0209$var$JIRA_IMC_CAMPAIGN_KEY));
const $9c4fdf28a38e0209$export$e66c8b4c45e63463 = 'paid-lp-jsw-features';
function $9c4fdf28a38e0209$export$881f05c9f097031e(locale) {
    return (locale || 'en') === 'en' ? '' : `/${locale}`;
}
const $9c4fdf28a38e0209$export$8abe2e83e8d74da2 = (location)=>{
    const loginUrl = new URL('/login', (0, $eRzlV.getIdentityBaseUrl)());
    const continueParam = $9c4fdf28a38e0209$export$46b6a16917b33fad(location);
    if (continueParam) loginUrl.searchParams.append('continue', continueParam);
    else {
        const defaultContinueUrl = new URL('/gateway/api/start/authredirect', (0, $eRzlV.getWacIntegrationUrl)()).toString();
        loginUrl.searchParams.append('continue', defaultContinueUrl);
    }
    const isWacIcLoginEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacIcLogin);
    if (isWacIcLoginEnabled) loginUrl.searchParams.append('application', 'wac--ic');
    const finalLoginUrl = loginUrl.toString();
    return finalLoginUrl;
};
const $9c4fdf28a38e0209$export$9996970bc91cf103 = (email, redirectTo, identityCobranding = 'wac', castleToken)=>{
    const url = new URL('/signup/onboard', (0, $eRzlV.getIdentityBaseUrl)());
    url.searchParams.append('email', email);
    url.searchParams.append('captcha_type', 'google-score');
    url.searchParams.append('application', identityCobranding);
    url.searchParams.append('continue', redirectTo);
    // Forwarded to Identity so it can call Castle's /v1/risk server-side
    if (castleToken) url.searchParams.append('castle_token', castleToken);
    return url.toString();
};
const $9c4fdf28a38e0209$export$fe82873cf9bd9e7e = ({ bundle: bundle, edition: edition, application: application, localePath: localePath = '', templateId: templateId, isEmbedded: isEmbedded })=>{
    const baseUrl = (0, $eRzlV.getWacIntegrationUrl)();
    const siteNamePageUrl = '/try/cloud/signup';
    const searchParameters = new URLSearchParams(window.location.search);
    const isTwcEmbedded = bundle === 'teamwork-collection' && isEmbedded;
    if (!templateId) templateId = searchParameters.get('templateId') ?? undefined;
    const primaryCollectionProduct = searchParameters.get('primaryCollectionProduct');
    const cgsKey = searchParameters.get('cgsKey') || undefined;
    const params = new URLSearchParams();
    // bundle first
    if (bundle) params.append('bundle', bundle);
    // edition comes after bundle
    if (edition) params.append('edition', edition);
    if (templateId) params.append('templateId', templateId);
    if (application) params.append('application', application);
    if (cgsKey) params.append('cgsKey', cgsKey);
    if (isTwcEmbedded) params.append('touchpoint', 'twc-embedded-signup');
    [
        'platform',
        'continue',
        'team_type',
        'publicLinkId',
        'editionIntent'
    ].forEach((param)=>{
        const value = searchParameters.get(param);
        if (value) params.append(param, value);
    });
    // if product is collection
    const collectionProductKey = bundle ? (0, $fcO7r.CollectionBundleNameToProductKeyMap)[bundle] : undefined;
    const isCollectionBundle = !!collectionProductKey && collectionProductKey in (0, $fcO7r.CollectionConstituentProductsMap);
    if (isCollectionBundle) {
        const primaryProduct = (0, $c0vG6.validatePrimaryCollectionProduct)(collectionProductKey, primaryCollectionProduct);
        params.append('primaryCollectionProduct', primaryProduct);
    }
    return `${baseUrl}${localePath}${siteNamePageUrl}?${params}`;
};
function $9c4fdf28a38e0209$export$95a87dbace0b33a0({ locale: locale, productKey: productKey, siteName: siteName, signupId: signupId, response: response, edition: originalEdition, primaryCollectionProduct: primaryCollectionProduct }) {
    // required query parameters from activation
    const redirectParams = new URLSearchParams();
    /**
   * Rovo Dev (aka DEVAI) is a special case, it only has a single
   * edition, standard. There is an outstanding DACI:
   * https://hello.atlassian.net/wiki/spaces/uts/pages/5807772710/Rovo+Dev+Everywhere+SKU+DACI
   * If/when this DACI is resolved and Rovo Dev supports the free
   * edition, this special case can then be removed.
   */ let edition = originalEdition;
    if (productKey === (0, $fcO7r.ProductKey).DEVAI) edition = 'standard';
    // SPICE-1705: prefer the provisioned edition reported by the server
    // over the form-side edition, since the two can diverge (e.g. Reverse
    // Trial signs the user up for Free but provisions Premium).
    // DEVAI is excluded so the "standard" invariant above is preserved.
    if (productKey !== (0, $fcO7r.ProductKey).DEVAI && response.service === 'ccp') {
        const provisionedEdition = response.metadata?.products?.[0]?.edition;
        if (provisionedEdition) edition = provisionedEdition;
    }
    redirectParams.append('ondemandurl', siteName);
    redirectParams.append('products', productKey);
    redirectParams.append('edition', edition);
    const isCollection = (0, $fcO7r.DefaultCollectionProductMap)[productKey];
    // excluding orchestrationId param in URL makes confirmation page use polling instead of graphql subscription
    if (response.orchestrationId && !isCollection) redirectParams.append('orchestrationId', response.orchestrationId);
    if (signupId) redirectParams.append('signupId', signupId);
    if (response.service === 'ccp') {
        const ccpResponse = response;
        const requestId = ccpResponse.metadata?.provisionRequestId;
        redirectParams.append('platform', 'ccp');
        redirectParams.append('provisioningRequestId', requestId);
    } else {
        const cofsResponse = response;
        const requestId = (0, $6fz8F.getRequestId)(cofsResponse.progressUri);
        redirectParams.append('cloudId', cofsResponse.cloudId);
        if (requestId) redirectParams.append('requestId', requestId);
    }
    if (isCollection) {
        const primaryProduct = (0, $c0vG6.validatePrimaryCollectionProduct)(productKey, primaryCollectionProduct);
        redirectParams.append('primaryCollectionProduct', primaryProduct);
    }
    // pass through current query parameters
    const searchParameters = new URLSearchParams(window.location.search);
    const n2n = searchParameters.get('n2n') === 'true';
    if (n2n) redirectParams.append('n2n', 'true');
    const signupSource = searchParameters.get('signupSource');
    if (signupSource) redirectParams.append('signupSource', signupSource);
    const team_type = searchParameters.get('team_type');
    if (team_type) redirectParams.append('team_type', team_type);
    const templateId = searchParameters.get('templateId');
    if (templateId) redirectParams.append('templateId', templateId);
    const cgsKey = searchParameters.get('cgsKey');
    if (cgsKey) redirectParams.append('cgsKey', cgsKey);
    const localePath = $9c4fdf28a38e0209$export$881f05c9f097031e(locale);
    return `${localePath}/ondemand/signup/confirmation?${redirectParams}`;
}
function $9c4fdf28a38e0209$export$f03910293318c542({ locale: locale, productKey: productKey, edition: edition }) {
    const redirectParams = new URLSearchParams();
    redirectParams.append('deferSiteNaming', 'true');
    redirectParams.append('products', productKey);
    redirectParams.append('edition', edition);
    // pass through current query parameters (mirrors getConfirmationPageUrl).
    // Guarded against SSR — `window` is undefined on the server. In practice
    // this helper is only invoked from event handlers on the client, but the
    // guard keeps the function safe to call from anywhere.
    if (typeof window !== 'undefined') {
        const searchParameters = new URLSearchParams(window.location.search);
        const n2n = searchParameters.get('n2n') === 'true';
        if (n2n) redirectParams.append('n2n', 'true');
        const signupSource = searchParameters.get('signupSource');
        if (signupSource) redirectParams.append('signupSource', signupSource);
        const team_type = searchParameters.get('team_type');
        if (team_type) redirectParams.append('team_type', team_type);
        const templateId = searchParameters.get('templateId');
        if (templateId) redirectParams.append('templateId', templateId);
        const cgsKey = searchParameters.get('cgsKey');
        if (cgsKey) redirectParams.append('cgsKey', cgsKey);
    }
    const localePath = $9c4fdf28a38e0209$export$881f05c9f097031e(locale);
    // Return an absolute URL so identity onboarding can validate the
    // `continue` redirect target against its trusted-domain allowlist
    // and forward it verbatim (preserving `deferSiteNaming=true` and
    // other custom params). When the continueUrl is a relative path,
    // identity strips unknown query params during sanitization. This
    // matches the behavior of `getNameYourSiteRedirectUrl` (the default
    // getContinueUrl path used in the control arm), which also returns
    // an absolute URL via `getWacIntegrationUrl()`.
    return `${(0, $eRzlV.getWacIntegrationUrl)()}${localePath}/ondemand/signup/confirmation?${redirectParams}`;
}
const $9c4fdf28a38e0209$export$43548fa5abef524a = (bundle)=>{
    switch(bundle){
        case 'confluence':
            return (0, $fcO7r.ProductKey).CONFLUENCE;
        case 'jira-service-management':
        case 'jira-service-management-jira-software':
            return (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT;
        case 'devai':
            return (0, $fcO7r.ProductKey).DEVAI;
        default:
            return (0, $fcO7r.ProductKey).JIRA_SOFTWARE;
    }
};
const $9c4fdf28a38e0209$export$1975a427183bb141 = (bundle)=>{
    switch(bundle){
        case 'confluence':
            return [
                (0, $fcO7r.ProductData)[(0, $fcO7r.ProductKey).CONFLUENCE]
            ];
        case 'jira-service-management':
            return [
                (0, $fcO7r.ProductData)[(0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT]
            ];
        case 'jira-service-management-jira-software':
            return [
                (0, $fcO7r.ProductData)[(0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT],
                (0, $fcO7r.ProductData)[(0, $fcO7r.ProductKey).JIRA_SOFTWARE]
            ];
        case 'devai':
            return [
                (0, $fcO7r.ProductData)[(0, $fcO7r.ProductKey).DEVAI]
            ];
        default:
            return [
                (0, $fcO7r.ProductData)[(0, $fcO7r.ProductKey).JIRA_SOFTWARE]
            ];
    }
};
const $9c4fdf28a38e0209$export$1b05c3730ec97967 = ()=>{
    const params = new URLSearchParams({
        continue: window.location.href
    });
    return `${(0, $eRzlV.getIdentityBaseUrl)()}/login/select-account?${params}`;
};
const $9c4fdf28a38e0209$export$5295fefa042f6101 = async (site, productKey, targetEdition)=>{
    let billingSourceSystem, entitlementId;
    const productToUpgrade = site.products.find((product)=>product.productKey === productKey);
    if (productToUpgrade) {
        billingSourceSystem = productToUpgrade.billingSourceSystem;
        entitlementId = productToUpgrade.entitlementId;
    } else {
        const collectionToUpgrade = site.products.find((product)=>product.partOfCollection === productKey);
        if (collectionToUpgrade) {
            billingSourceSystem = collectionToUpgrade.billingSourceSystem;
            entitlementId = collectionToUpgrade.collectionEntitlementId;
        }
    }
    if (!entitlementId || !billingSourceSystem) throw new Error(`Cannot find product ${productKey} with entitlementId or billingSourceSystem`);
    if (billingSourceSystem === 'CCP') return await (0, $ikT6N.generateCCPUpgradeLink)(entitlementId, targetEdition);
    return (0, $ikT6N.generateHAMSUpgradeLink)(entitlementId, productKey, targetEdition);
};
const $9c4fdf28a38e0209$export$10da5dfd3e881279 = ({ cloudId: cloudId, edition: originalEdition, productKey: productKey, siteName: siteName, hasPaidTargetEditionRequiringConfirmationScreen: hasPaidTargetEditionRequiringConfirmationScreen })=>{
    const startUrl = new URL((0, $eRzlV.isProduction)() ? 'https://start.atlassian.com' : 'https://start.stg.atlassian.com');
    startUrl.searchParams.set('startTrialProduct', productKey);
    startUrl.searchParams.set('startTrialCloudId', cloudId);
    startUrl.searchParams.set('startTrialInstance', siteName);
    startUrl.searchParams.set('cloudId', cloudId);
    /**
   * Rovo Dev (aka DEVAI) is a special case, it only has a single
   * edition, standard. There is an outstanding DACI:
   * https://hello.atlassian.net/wiki/spaces/uts/pages/5807772710/Rovo+Dev+Everywhere+SKU+DACI
   * If/when this DACI is resolved and Rovo Dev supports the free
   * edition, this special case can then be removed.
   */ let edition = originalEdition;
    if (productKey === (0, $fcO7r.ProductKey).DEVAI) edition = 'standard';
    const searchParameters = new URLSearchParams(window?.location.search);
    const signupSource = searchParameters.get('signupSource');
    const shouldForceConfirmationScreen = edition === 'free' && signupSource !== 'pricing' && hasPaidTargetEditionRequiringConfirmationScreen && [
        (0, $fcO7r.ProductKey).CONFLUENCE,
        (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
        (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY,
        (0, $fcO7r.ProductKey).JIRA_SERVICE_DESK,
        (0, $fcO7r.ProductKey).SERVICE_COLLECTION
    ].includes(productKey);
    if (shouldForceConfirmationScreen) startUrl.searchParams.set('forceConfirmationScreen', 'true');
    else if (edition) startUrl.searchParams.set('edition', edition);
    // pass through current query parameters
    const templateId = searchParameters.get('templateId');
    if (templateId) startUrl.searchParams.set('templateId', templateId);
    const billingCode = searchParameters.get('billingMode');
    if (billingCode) startUrl.searchParams.set('billingMode', billingCode);
    const billingMode = searchParameters.get('billingMode');
    if (billingMode) startUrl.searchParams.set('billingMode', billingMode);
    return startUrl.toString();
};

});
parcelRegister("ikT6N", function(module, exports) {
$parcel$export(module.exports, "generateCCPUpgradeLink", function () { return $58d693b47b2098c0$export$443dece3bfbc9141; });
$parcel$export(module.exports, "generateHAMSUpgradeLink", function () { return $58d693b47b2098c0$export$81b850f8ad5069e6; });

var $aHTfr = parcelRequire("aHTfr");
parcelRequire("kNE9Z");
var $eRzlV = parcelRequire("eRzlV");
function $58d693b47b2098c0$var$getBaseUrlForUpgrade() {
    return (0, $eRzlV.isProduction)() ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
}
function $58d693b47b2098c0$var$getCCPTransactionId(entitlementId) {
    return `${(0, $eRzlV.getWacIntegrationUrl)()}/gateway/api/ccp/api/v2/entitlements/${entitlementId}/details`;
}
function $58d693b47b2098c0$var$attachOrigin(paymentLink) {
    const origin = new (0, $aHTfr.default)({
        product: 'wac-sign-up'
    });
    const linkWithOriginAttached = origin.addToUrl(paymentLink);
    return linkWithOriginAttached;
}
async function $58d693b47b2098c0$export$443dece3bfbc9141(entitlementId, targetEdition) {
    const fetchEndpointUrl = $58d693b47b2098c0$var$getCCPTransactionId(entitlementId);
    const resp = await fetch(fetchEndpointUrl, {
        method: 'GET',
        credentials: 'include'
    });
    if (resp.ok) {
        const data = await resp.json();
        const ccpTransactionAccountId = data.transactionAccountId;
        return $58d693b47b2098c0$var$attachOrigin(`${$58d693b47b2098c0$var$getBaseUrlForUpgrade()}/billing/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=wac&offeringName=${targetEdition}`);
    } else throw new Error('Unsuccessful Fetch');
}
function $58d693b47b2098c0$export$81b850f8ad5069e6(entitlementId, productKey, targetEdition) {
    return `${$58d693b47b2098c0$var$getBaseUrlForUpgrade()}/s/${entitlementId}/billing/applications/change-edition/${productKey}/${targetEdition}`;
}

});
parcelRegister("aHTfr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7cb8c6a4ea4ec737$export$2e2bcd8739ae039; });

var $6lWOc = parcelRequire("6lWOc");

var $hQuJz = parcelRequire("hQuJz");

var $6yERP = parcelRequire("6yERP");

var $5S91q = parcelRequire("5S91q");

var $cTgjZ = parcelRequire("cTgjZ");

var $5kEbn = parcelRequire("5kEbn");

var $dfMXP = parcelRequire("dfMXP");

var $hoYjw = parcelRequire("hoYjw");

var $byQzI = parcelRequire("byQzI");
function $7cb8c6a4ea4ec737$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7cb8c6a4ea4ec737$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $6yERP.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6yERP.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hQuJz.default)(this, result);
    };
}
function $7cb8c6a4ea4ec737$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7cb8c6a4ea4ec737$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7cb8c6a4ea4ec737$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7cb8c6a4ea4ec737$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5S91q.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7cb8c6a4ea4ec737$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7cb8c6a4ea4ec737$var$packageVersion = "6.1.3";
var $7cb8c6a4ea4ec737$var$originParamName = 'atlOrigin';
var $7cb8c6a4ea4ec737$var$originVersioningAttributes = {
    originLibrary: "origin-tracing.js@".concat($7cb8c6a4ea4ec737$var$packageVersion)
};
var $7cb8c6a4ea4ec737$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function OriginTracer(_ref) {
        var _ref$id = _ref.id, id = _ref$id === void 0 ? OriginTracer.generateId() : _ref$id, product = _ref.product, _ref$dangerouslySkipV = _ref.dangerouslySkipValidation, dangerouslySkipValidation = _ref$dangerouslySkipV === void 0 ? false : _ref$dangerouslySkipV;
        (0, $cTgjZ.default)(this, OriginTracer);
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    (0, $5kEbn.default)(OriginTracer, [
        {
            key: "encode",
            value: function encode() {
                return (0, $hoYjw.encode)({
                    id: this.id,
                    product: this.product
                });
            }
        },
        {
            key: "addToUrl",
            value: function addToUrl(url) {
                var _this = this;
                return $7cb8c6a4ea4ec737$var$replaceQuery(url, function(originalQueryString) {
                    var params = new ((0, $byQzI.getEnv)()).URLSearchParams(originalQueryString);
                    params.set($7cb8c6a4ea4ec737$var$originParamName, _this.encode());
                    return params.toString();
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "isMalformed",
            value: function isMalformed() {
                return !this.isEmpty() && !this.isValid();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                var _objectSpread2;
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$transformValue = _ref2.transformValue, transformValue = _ref2$transformValue === void 0 ? function(v) {
                    return v === null ? undefined : v;
                } : _ref2$transformValue, _ref2$hasGeneratedId = _ref2.hasGeneratedId, hasGeneratedId = _ref2$hasGeneratedId === void 0 ? false : _ref2$hasGeneratedId;
                // `originIdGenerated` should be used in analytic events that generated this originId.
                // Subsequent events should use `originId`.
                // No two events should have the same value of originIdGenerated.
                var originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
                return $7cb8c6a4ea4ec737$var$_objectSpread((_objectSpread2 = {}, (0, $5S91q.default)(_objectSpread2, originIdProp, transformValue(this.id)), (0, $5S91q.default)(_objectSpread2, "originProduct", transformValue(this.product)), _objectSpread2), $7cb8c6a4ea4ec737$var$originVersioningAttributes);
            }
        },
        {
            key: "validate",
            value: function validate() {
                if (!OriginTracer.isValidId(this.id)) throw new TypeError('Invalid Origin id');
                if (!OriginTracer.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
            }
        }
    ], [
        {
            key: "isValidId",
            value: function isValidId(value) {
                return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
            }
        },
        {
            key: "isValidProduct",
            value: function isValidProduct(value) {
                return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                var id = (0, (/*@__PURE__*/$parcel$interopDefault($dfMXP)))();
                // Dash positions are fixed so they don't add to uniqueness.
                // Remove them to save space in the encoded form.
                return id.replace(/-/g, '');
            }
        },
        {
            key: "createEmpty",
            value: function createEmpty() {
                return new $7cb8c6a4ea4ec737$var$EmptyOriginTracer();
            }
        },
        {
            key: "createMalformed",
            value: function createMalformed() {
                return new $7cb8c6a4ea4ec737$var$MalformedOriginTracer();
            }
        },
        {
            key: "fromUrl",
            value: function fromUrl(url) {
                var params = new ((0, $byQzI.getEnv)()).URLSearchParams();
                $7cb8c6a4ea4ec737$var$replaceQuery(url, function(queryString) {
                    params = new ((0, $byQzI.getEnv)()).URLSearchParams(queryString);
                });
                return OriginTracer.fromEncoded(params.get($7cb8c6a4ea4ec737$var$originParamName));
            }
        },
        {
            key: "fromEncoded",
            value: function fromEncoded(encoded) {
                if (!encoded) return OriginTracer.createEmpty();
                try {
                    return OriginTracer.decode(encoded);
                } catch (e) {
                    return OriginTracer.createMalformed();
                }
            }
        },
        {
            key: "removeFromUrl",
            value: function removeFromUrl(url) {
                return $7cb8c6a4ea4ec737$var$replaceQuery(url, function(queryString) {
                    var params = new ((0, $byQzI.getEnv)()).URLSearchParams(queryString);
                    params.delete($7cb8c6a4ea4ec737$var$originParamName);
                    return params.toString();
                });
            }
        },
        {
            key: "decode",
            value: function decode(encodedOrigin) {
                var originData = (0, $hoYjw.decode)(encodedOrigin);
                return new OriginTracer(originData);
            }
        }
    ]);
    return OriginTracer;
}();
var $7cb8c6a4ea4ec737$var$EmptyOriginTracer = /*#__PURE__*/ function(_OriginTracer) {
    (0, $6lWOc.default)(EmptyOriginTracer, _OriginTracer);
    var _super = $7cb8c6a4ea4ec737$var$_createSuper(EmptyOriginTracer);
    function EmptyOriginTracer() {
        (0, $cTgjZ.default)(this, EmptyOriginTracer);
        return _super.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, $5kEbn.default)(EmptyOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $7cb8c6a4ea4ec737$var$_objectSpread({}, $7cb8c6a4ea4ec737$var$originVersioningAttributes);
            }
        }
    ]);
    return EmptyOriginTracer;
}($7cb8c6a4ea4ec737$export$2e2bcd8739ae039);
var $7cb8c6a4ea4ec737$var$MalformedOriginTracer = /*#__PURE__*/ function(_OriginTracer2) {
    (0, $6lWOc.default)(MalformedOriginTracer, _OriginTracer2);
    var _super2 = $7cb8c6a4ea4ec737$var$_createSuper(MalformedOriginTracer);
    function MalformedOriginTracer() {
        (0, $cTgjZ.default)(this, MalformedOriginTracer);
        return _super2.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, $5kEbn.default)(MalformedOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $7cb8c6a4ea4ec737$var$_objectSpread({
                    originMalformed: true
                }, $7cb8c6a4ea4ec737$var$originVersioningAttributes);
            }
        }
    ]);
    return MalformedOriginTracer;
}($7cb8c6a4ea4ec737$export$2e2bcd8739ae039);
function $7cb8c6a4ea4ec737$var$replaceQuery(url, replacer) {
    var urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    var urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, function(wholeMatch, beforeQuery, queryString, afterQuery) {
        var newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = "?".concat(newQueryString);
        return "".concat(beforeQuery).concat(newQueryString).concat(afterQuery);
    });
}

});
parcelRegister("6lWOc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4a025270998faee5$export$2e2bcd8739ae039; });

var $2yUvF = parcelRequire("2yUvF");
function $4a025270998faee5$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $2yUvF.default)(t, e);
}

});
parcelRegister("2yUvF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1dda976b58a7d6da$export$2e2bcd8739ae039; });
function $1dda976b58a7d6da$export$2e2bcd8739ae039(t, e) {
    return $1dda976b58a7d6da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $1dda976b58a7d6da$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("hQuJz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cfdf22254217a875$export$2e2bcd8739ae039; });

var $42UPt = parcelRequire("42UPt");

var $k6Q52 = parcelRequire("k6Q52");
function $cfdf22254217a875$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $42UPt.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $k6Q52.default)(t);
}

});
parcelRegister("42UPt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f236e6ae5957ef9$export$2e2bcd8739ae039; });
function $2f236e6ae5957ef9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2f236e6ae5957ef9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2f236e6ae5957ef9$export$2e2bcd8739ae039(o);
}

});

parcelRegister("k6Q52", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea3cc4429939c3ca$export$2e2bcd8739ae039; });
function $ea3cc4429939c3ca$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("6yERP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c659e702594b687$export$2e2bcd8739ae039; });
function $4c659e702594b687$export$2e2bcd8739ae039(t) {
    return $4c659e702594b687$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4c659e702594b687$export$2e2bcd8739ae039(t);
}

});

parcelRegister("5S91q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4468fe7cf76b2aa0$export$2e2bcd8739ae039; });

var $9d8cg = parcelRequire("9d8cg");
function $4468fe7cf76b2aa0$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9d8cg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("9d8cg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b4bafa76f4aa116$export$2e2bcd8739ae039; });

var $42UPt = parcelRequire("42UPt");

var $eVCFu = parcelRequire("eVCFu");
function $6b4bafa76f4aa116$export$2e2bcd8739ae039(t) {
    var i = (0, $eVCFu.default)(t, "string");
    return "symbol" == (0, $42UPt.default)(i) ? i : i + "";
}

});
parcelRegister("eVCFu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ade4623beb2f980b$export$2e2bcd8739ae039; });

var $42UPt = parcelRequire("42UPt");
function $ade4623beb2f980b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $42UPt.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $42UPt.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("cTgjZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $96274832348f76fe$export$2e2bcd8739ae039; });
function $96274832348f76fe$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("5kEbn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e1dfd6bb5d57536$export$2e2bcd8739ae039; });

var $9d8cg = parcelRequire("9d8cg");
function $3e1dfd6bb5d57536$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9d8cg.default)(o.key), o);
    }
}
function $3e1dfd6bb5d57536$export$2e2bcd8739ae039(e, r, t) {
    return r && $3e1dfd6bb5d57536$var$_defineProperties(e.prototype, r), t && $3e1dfd6bb5d57536$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("dfMXP", function(module, exports) {

var $3zOZH = parcelRequire("3zOZH");

var $i3rdt = parcelRequire("i3rdt");
function $9a62a84c04e632f5$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $3zOZH)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $i3rdt(rnds);
}
module.exports = $9a62a84c04e632f5$var$v4;

});
parcelRegister("3zOZH", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $29ac325b21dc1692$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($29ac325b21dc1692$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $29ac325b21dc1692$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $29ac325b21dc1692$var$getRandomValues($29ac325b21dc1692$var$rnds8);
        return $29ac325b21dc1692$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $29ac325b21dc1692$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $29ac325b21dc1692$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $29ac325b21dc1692$var$rnds;
    };
}

});

parcelRegister("i3rdt", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $d24d9e61a3347cf5$var$byteToHex = [];
for(var $d24d9e61a3347cf5$var$i = 0; $d24d9e61a3347cf5$var$i < 256; ++$d24d9e61a3347cf5$var$i)$d24d9e61a3347cf5$var$byteToHex[$d24d9e61a3347cf5$var$i] = ($d24d9e61a3347cf5$var$i + 0x100).toString(16).substr(1);
function $d24d9e61a3347cf5$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $d24d9e61a3347cf5$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $d24d9e61a3347cf5$var$bytesToUuid;

});


parcelRegister("hoYjw", function(module, exports) {
$parcel$export(module.exports, "encode", function () { return $cab376a11f5aa0b9$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $cab376a11f5aa0b9$export$2f872c0f2117be69; });

var $ggf7d = parcelRequire("ggf7d");

var $byQzI = parcelRequire("byQzI");
var $cab376a11f5aa0b9$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $cab376a11f5aa0b9$export$c564cdbbe6da493(originData) {
    var json = JSON.stringify($cab376a11f5aa0b9$export$4bc4b533a565aabe(originData));
    var base64 = (0, $byQzI.getEnv)().btoa(json);
    return (0, $ggf7d.base64ToBase64Url)(base64);
}
function $cab376a11f5aa0b9$export$2f872c0f2117be69(encodedOriginString) {
    var base64 = (0, $ggf7d.base64UrlToBase64)(encodedOriginString);
    var json = (0, $byQzI.getEnv)().atob(base64);
    return $cab376a11f5aa0b9$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $cab376a11f5aa0b9$export$4bc4b533a565aabe(_ref) {
    var id = _ref.id, product = _ref.product;
    return {
        i: id,
        p: product && product in $cab376a11f5aa0b9$var$productShorthands ? $cab376a11f5aa0b9$var$productShorthands[product] : product
    };
}
function $cab376a11f5aa0b9$export$46d5cda6b884b7ab(originJSONObject) {
    var originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $cab376a11f5aa0b9$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $cab376a11f5aa0b9$var$expandProductShorthand(maybeShorthand) {
    var products = Object.keys($cab376a11f5aa0b9$var$productShorthands);
    for(var i = 0; i < products.length; i++){
        var product = products[i];
        var shorthand = $cab376a11f5aa0b9$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("ggf7d", function(module, exports) {
$parcel$export(module.exports, "base64ToBase64Url", function () { return $bd69dd963191fe13$export$3b91e21dac1023c6; });
$parcel$export(module.exports, "base64UrlToBase64", function () { return $bd69dd963191fe13$export$47c5265a25535d02; });
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $bd69dd963191fe13$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $bd69dd963191fe13$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    var base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    var padLength = (4 - base64url.length % 4) % 4;
    var pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("byQzI", function(module, exports) {
$parcel$export(module.exports, "getEnv", function () { return $86aba700875382c0$export$4bd44a2aa29d3d6e; });

var $567QU = parcelRequire("567QU");

var $86aba700875382c0$export$d3cd91e0fdbfdbc0 = function getEnvGlobals() {
    return {
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $567QU.Buffer) !== 'undefined' && function(encoded) {
            return (0, $567QU.Buffer).from(encoded, 'base64').toString();
        },
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $567QU.Buffer) !== 'undefined' && function(str) {
            return (0, $567QU.Buffer).from(str).toString('base64');
        },
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (parcelRequire("h0B4r")).URLSearchParams
    };
};
var $86aba700875382c0$var$env;
var $86aba700875382c0$export$4bd44a2aa29d3d6e = function getEnv() {
    return $86aba700875382c0$var$env || ($86aba700875382c0$var$env = $86aba700875382c0$var$validateEnv($86aba700875382c0$export$d3cd91e0fdbfdbc0()));
};
var $86aba700875382c0$var$validateEnv = function validateEnv(env) {
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError("Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).");
    return env;
};

});
parcelRegister("h0B4r", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $3kkxV = parcelRequire("3kkxV");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $gBGeW = parcelRequire("gBGeW");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $gBGeW.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $3kkxV.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $gBGeW.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $gBGeW.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("3kkxV", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("gBGeW", function(module, exports) {
'use strict';

var $nVupR = parcelRequire("nVupR");

var $dzysB = parcelRequire("dzysB");

var $aTDGG = parcelRequire("aTDGG");
module.exports = {
    formats: $aTDGG,
    parse: $dzysB,
    stringify: $nVupR
};

});
parcelRegister("nVupR", function(module, exports) {
'use strict';

var $2L6qV = parcelRequire("2L6qV");

var $f46HZ = parcelRequire("f46HZ");

var $aTDGG = parcelRequire("aTDGG");
var $047ebe54b3d444e3$var$has = Object.prototype.hasOwnProperty;
var $047ebe54b3d444e3$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $047ebe54b3d444e3$var$isArray = Array.isArray;
var $047ebe54b3d444e3$var$push = Array.prototype.push;
var $047ebe54b3d444e3$var$pushToArray = function(arr, valueOrArray) {
    $047ebe54b3d444e3$var$push.apply(arr, $047ebe54b3d444e3$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $047ebe54b3d444e3$var$toISO = Date.prototype.toISOString;
var $047ebe54b3d444e3$var$defaultFormat = $aTDGG.default;
var $047ebe54b3d444e3$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $f46HZ.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $047ebe54b3d444e3$var$defaultFormat,
    formatter: $aTDGG.formatters[$047ebe54b3d444e3$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $047ebe54b3d444e3$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $047ebe54b3d444e3$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $047ebe54b3d444e3$var$sentinel = {};
var $047ebe54b3d444e3$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($047ebe54b3d444e3$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($047ebe54b3d444e3$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $047ebe54b3d444e3$var$isArray(obj)) obj = $f46HZ.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $047ebe54b3d444e3$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($047ebe54b3d444e3$var$isNonNullishPrimitive(obj) || $f46HZ.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $047ebe54b3d444e3$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $047ebe54b3d444e3$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $047ebe54b3d444e3$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $f46HZ.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($047ebe54b3d444e3$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $047ebe54b3d444e3$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $047ebe54b3d444e3$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $047ebe54b3d444e3$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $2L6qV();
        valueSideChannel.set($047ebe54b3d444e3$var$sentinel, sideChannel);
        $047ebe54b3d444e3$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $047ebe54b3d444e3$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $047ebe54b3d444e3$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $047ebe54b3d444e3$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $047ebe54b3d444e3$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $aTDGG.default;
    if (typeof opts.format !== 'undefined') {
        if (!$047ebe54b3d444e3$var$has.call($aTDGG.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $aTDGG.formatters[format];
    var filter = $047ebe54b3d444e3$var$defaults.filter;
    if (typeof opts.filter === 'function' || $047ebe54b3d444e3$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $047ebe54b3d444e3$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $047ebe54b3d444e3$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $047ebe54b3d444e3$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $047ebe54b3d444e3$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $047ebe54b3d444e3$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $047ebe54b3d444e3$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $047ebe54b3d444e3$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $047ebe54b3d444e3$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $047ebe54b3d444e3$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $047ebe54b3d444e3$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $047ebe54b3d444e3$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $047ebe54b3d444e3$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $047ebe54b3d444e3$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $047ebe54b3d444e3$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $047ebe54b3d444e3$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($047ebe54b3d444e3$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $047ebe54b3d444e3$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $2L6qV();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $047ebe54b3d444e3$var$pushToArray(keys, $047ebe54b3d444e3$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("2L6qV", function(module, exports) {
'use strict';

var $bhDW8 = parcelRequire("bhDW8");

var $3wGFR = parcelRequire("3wGFR");

var $2SiPC = parcelRequire("2SiPC");

var $ifSG1 = parcelRequire("ifSG1");

var $cAAH9 = parcelRequire("cAAH9");
var $2024f617e265a0c6$var$makeChannel = $cAAH9 || $ifSG1 || $2SiPC;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bhDW8('Side channel does not contain ' + $3wGFR(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $2024f617e265a0c6$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("bhDW8", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("3wGFR", function(module, exports) {
var $291576753e7ed690$var$hasMap = typeof Map === 'function' && Map.prototype;
var $291576753e7ed690$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $291576753e7ed690$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $291576753e7ed690$var$mapSize = $291576753e7ed690$var$hasMap && $291576753e7ed690$var$mapSizeDescriptor && typeof $291576753e7ed690$var$mapSizeDescriptor.get === 'function' ? $291576753e7ed690$var$mapSizeDescriptor.get : null;
var $291576753e7ed690$var$mapForEach = $291576753e7ed690$var$hasMap && Map.prototype.forEach;
var $291576753e7ed690$var$hasSet = typeof Set === 'function' && Set.prototype;
var $291576753e7ed690$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $291576753e7ed690$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $291576753e7ed690$var$setSize = $291576753e7ed690$var$hasSet && $291576753e7ed690$var$setSizeDescriptor && typeof $291576753e7ed690$var$setSizeDescriptor.get === 'function' ? $291576753e7ed690$var$setSizeDescriptor.get : null;
var $291576753e7ed690$var$setForEach = $291576753e7ed690$var$hasSet && Set.prototype.forEach;
var $291576753e7ed690$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $291576753e7ed690$var$weakMapHas = $291576753e7ed690$var$hasWeakMap ? WeakMap.prototype.has : null;
var $291576753e7ed690$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $291576753e7ed690$var$weakSetHas = $291576753e7ed690$var$hasWeakSet ? WeakSet.prototype.has : null;
var $291576753e7ed690$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $291576753e7ed690$var$weakRefDeref = $291576753e7ed690$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $291576753e7ed690$var$booleanValueOf = Boolean.prototype.valueOf;
var $291576753e7ed690$var$objectToString = Object.prototype.toString;
var $291576753e7ed690$var$functionToString = Function.prototype.toString;
var $291576753e7ed690$var$$match = String.prototype.match;
var $291576753e7ed690$var$$slice = String.prototype.slice;
var $291576753e7ed690$var$$replace = String.prototype.replace;
var $291576753e7ed690$var$$toUpperCase = String.prototype.toUpperCase;
var $291576753e7ed690$var$$toLowerCase = String.prototype.toLowerCase;
var $291576753e7ed690$var$$test = RegExp.prototype.test;
var $291576753e7ed690$var$$concat = Array.prototype.concat;
var $291576753e7ed690$var$$join = Array.prototype.join;
var $291576753e7ed690$var$$arrSlice = Array.prototype.slice;
var $291576753e7ed690$var$$floor = Math.floor;
var $291576753e7ed690$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $291576753e7ed690$var$gOPS = Object.getOwnPropertySymbols;
var $291576753e7ed690$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $291576753e7ed690$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $291576753e7ed690$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $291576753e7ed690$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $291576753e7ed690$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $291576753e7ed690$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $291576753e7ed690$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $291576753e7ed690$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$291576753e7ed690$var$$floor(-num) : $291576753e7ed690$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $291576753e7ed690$var$$slice.call(str, intStr.length + 1);
            return $291576753e7ed690$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $291576753e7ed690$var$$replace.call($291576753e7ed690$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $291576753e7ed690$var$$replace.call(str, sepRegex, '$&_');
}

var $jBKLa = parcelRequire("jBKLa");
var $291576753e7ed690$var$inspectCustom = $jBKLa.custom;
var $291576753e7ed690$var$inspectSymbol = $291576753e7ed690$var$isSymbol($291576753e7ed690$var$inspectCustom) ? $291576753e7ed690$var$inspectCustom : null;
var $291576753e7ed690$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $291576753e7ed690$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($291576753e7ed690$var$has(opts, 'quoteStyle') && !$291576753e7ed690$var$has($291576753e7ed690$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($291576753e7ed690$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $291576753e7ed690$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($291576753e7ed690$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($291576753e7ed690$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $291576753e7ed690$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $291576753e7ed690$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $291576753e7ed690$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $291576753e7ed690$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $291576753e7ed690$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($291576753e7ed690$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $291576753e7ed690$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($291576753e7ed690$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$291576753e7ed690$var$isRegExp(obj)) {
        var name = $291576753e7ed690$var$nameOf(obj);
        var keys = $291576753e7ed690$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $291576753e7ed690$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($291576753e7ed690$var$isSymbol(obj)) {
        var symString = $291576753e7ed690$var$hasShammedSymbols ? $291576753e7ed690$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $291576753e7ed690$var$symToString.call(obj);
        return typeof obj === 'object' && !$291576753e7ed690$var$hasShammedSymbols ? $291576753e7ed690$var$markBoxed(symString) : symString;
    }
    if ($291576753e7ed690$var$isElement(obj)) {
        var s = '<' + $291576753e7ed690$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $291576753e7ed690$var$wrapQuotes($291576753e7ed690$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $291576753e7ed690$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($291576753e7ed690$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $291576753e7ed690$var$arrObjKeys(obj, inspect);
        if (indent && !$291576753e7ed690$var$singleLineValues(xs)) return '[' + $291576753e7ed690$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $291576753e7ed690$var$$join.call(xs, ', ') + ' ]';
    }
    if ($291576753e7ed690$var$isError(obj)) {
        var parts = $291576753e7ed690$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$291576753e7ed690$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $291576753e7ed690$var$$join.call($291576753e7ed690$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $291576753e7ed690$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($291576753e7ed690$var$inspectSymbol && typeof obj[$291576753e7ed690$var$inspectSymbol] === 'function' && $jBKLa) return $jBKLa(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($291576753e7ed690$var$isMap(obj)) {
        var mapParts = [];
        if ($291576753e7ed690$var$mapForEach) $291576753e7ed690$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $291576753e7ed690$var$collectionOf('Map', $291576753e7ed690$var$mapSize.call(obj), mapParts, indent);
    }
    if ($291576753e7ed690$var$isSet(obj)) {
        var setParts = [];
        if ($291576753e7ed690$var$setForEach) $291576753e7ed690$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $291576753e7ed690$var$collectionOf('Set', $291576753e7ed690$var$setSize.call(obj), setParts, indent);
    }
    if ($291576753e7ed690$var$isWeakMap(obj)) return $291576753e7ed690$var$weakCollectionOf('WeakMap');
    if ($291576753e7ed690$var$isWeakSet(obj)) return $291576753e7ed690$var$weakCollectionOf('WeakSet');
    if ($291576753e7ed690$var$isWeakRef(obj)) return $291576753e7ed690$var$weakCollectionOf('WeakRef');
    if ($291576753e7ed690$var$isNumber(obj)) return $291576753e7ed690$var$markBoxed(inspect(Number(obj)));
    if ($291576753e7ed690$var$isBigInt(obj)) return $291576753e7ed690$var$markBoxed(inspect($291576753e7ed690$var$bigIntValueOf.call(obj)));
    if ($291576753e7ed690$var$isBoolean(obj)) return $291576753e7ed690$var$markBoxed($291576753e7ed690$var$booleanValueOf.call(obj));
    if ($291576753e7ed690$var$isString(obj)) return $291576753e7ed690$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$291576753e7ed690$var$isDate(obj) && !$291576753e7ed690$var$isRegExp(obj)) {
        var ys = $291576753e7ed690$var$arrObjKeys(obj, inspect);
        var isPlainObject = $291576753e7ed690$var$gPO ? $291576753e7ed690$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $291576753e7ed690$var$toStringTag && Object(obj) === obj && $291576753e7ed690$var$toStringTag in obj ? $291576753e7ed690$var$$slice.call($291576753e7ed690$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $291576753e7ed690$var$$join.call($291576753e7ed690$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $291576753e7ed690$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $291576753e7ed690$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $291576753e7ed690$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $291576753e7ed690$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $291576753e7ed690$var$quote(s) {
    return $291576753e7ed690$var$$replace.call(String(s), /"/g, '&quot;');
}
function $291576753e7ed690$var$isArray(obj) {
    return $291576753e7ed690$var$toStr(obj) === '[object Array]' && (!$291576753e7ed690$var$toStringTag || !(typeof obj === 'object' && $291576753e7ed690$var$toStringTag in obj));
}
function $291576753e7ed690$var$isDate(obj) {
    return $291576753e7ed690$var$toStr(obj) === '[object Date]' && (!$291576753e7ed690$var$toStringTag || !(typeof obj === 'object' && $291576753e7ed690$var$toStringTag in obj));
}
function $291576753e7ed690$var$isRegExp(obj) {
    return $291576753e7ed690$var$toStr(obj) === '[object RegExp]' && (!$291576753e7ed690$var$toStringTag || !(typeof obj === 'object' && $291576753e7ed690$var$toStringTag in obj));
}
function $291576753e7ed690$var$isError(obj) {
    return $291576753e7ed690$var$toStr(obj) === '[object Error]' && (!$291576753e7ed690$var$toStringTag || !(typeof obj === 'object' && $291576753e7ed690$var$toStringTag in obj));
}
function $291576753e7ed690$var$isString(obj) {
    return $291576753e7ed690$var$toStr(obj) === '[object String]' && (!$291576753e7ed690$var$toStringTag || !(typeof obj === 'object' && $291576753e7ed690$var$toStringTag in obj));
}
function $291576753e7ed690$var$isNumber(obj) {
    return $291576753e7ed690$var$toStr(obj) === '[object Number]' && (!$291576753e7ed690$var$toStringTag || !(typeof obj === 'object' && $291576753e7ed690$var$toStringTag in obj));
}
function $291576753e7ed690$var$isBoolean(obj) {
    return $291576753e7ed690$var$toStr(obj) === '[object Boolean]' && (!$291576753e7ed690$var$toStringTag || !(typeof obj === 'object' && $291576753e7ed690$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $291576753e7ed690$var$isSymbol(obj) {
    if ($291576753e7ed690$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$291576753e7ed690$var$symToString) return false;
    try {
        $291576753e7ed690$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $291576753e7ed690$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$291576753e7ed690$var$bigIntValueOf) return false;
    try {
        $291576753e7ed690$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $291576753e7ed690$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $291576753e7ed690$var$has(obj, key) {
    return $291576753e7ed690$var$hasOwn.call(obj, key);
}
function $291576753e7ed690$var$toStr(obj) {
    return $291576753e7ed690$var$objectToString.call(obj);
}
function $291576753e7ed690$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $291576753e7ed690$var$$match.call($291576753e7ed690$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $291576753e7ed690$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $291576753e7ed690$var$isMap(x) {
    if (!$291576753e7ed690$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $291576753e7ed690$var$mapSize.call(x);
        try {
            $291576753e7ed690$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $291576753e7ed690$var$isWeakMap(x) {
    if (!$291576753e7ed690$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $291576753e7ed690$var$weakMapHas.call(x, $291576753e7ed690$var$weakMapHas);
        try {
            $291576753e7ed690$var$weakSetHas.call(x, $291576753e7ed690$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $291576753e7ed690$var$isWeakRef(x) {
    if (!$291576753e7ed690$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $291576753e7ed690$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $291576753e7ed690$var$isSet(x) {
    if (!$291576753e7ed690$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $291576753e7ed690$var$setSize.call(x);
        try {
            $291576753e7ed690$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $291576753e7ed690$var$isWeakSet(x) {
    if (!$291576753e7ed690$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $291576753e7ed690$var$weakSetHas.call(x, $291576753e7ed690$var$weakSetHas);
        try {
            $291576753e7ed690$var$weakMapHas.call(x, $291576753e7ed690$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $291576753e7ed690$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $291576753e7ed690$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $291576753e7ed690$var$inspectString($291576753e7ed690$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $291576753e7ed690$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $291576753e7ed690$var$$replace.call($291576753e7ed690$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $291576753e7ed690$var$lowbyte);
    return $291576753e7ed690$var$wrapQuotes(s, 'single', opts);
}
function $291576753e7ed690$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $291576753e7ed690$var$$toUpperCase.call(n.toString(16));
}
function $291576753e7ed690$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $291576753e7ed690$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $291576753e7ed690$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $291576753e7ed690$var$indentedJoin(entries, indent) : $291576753e7ed690$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $291576753e7ed690$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($291576753e7ed690$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $291576753e7ed690$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $291576753e7ed690$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $291576753e7ed690$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $291576753e7ed690$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $291576753e7ed690$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $291576753e7ed690$var$arrObjKeys(obj, inspect) {
    var isArr = $291576753e7ed690$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $291576753e7ed690$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $291576753e7ed690$var$gOPS === 'function' ? $291576753e7ed690$var$gOPS(obj) : [];
    var symMap;
    if ($291576753e7ed690$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$291576753e7ed690$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($291576753e7ed690$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($291576753e7ed690$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $291576753e7ed690$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($291576753e7ed690$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});

parcelRegister("2SiPC", function(module, exports) {
'use strict';

var $3wGFR = parcelRequire("3wGFR");

var $bhDW8 = parcelRequire("bhDW8");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $217f3b78794d28fe$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $217f3b78794d28fe$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $217f3b78794d28fe$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $217f3b78794d28fe$var$listSet = function(objects, key, value) {
    var node = $217f3b78794d28fe$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $217f3b78794d28fe$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$217f3b78794d28fe$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $217f3b78794d28fe$var$listDelete = function(objects, key) {
    if (objects) return $217f3b78794d28fe$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bhDW8('Side channel does not contain ' + $3wGFR(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $217f3b78794d28fe$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $217f3b78794d28fe$var$listGet($o, key);
        },
        has: function(key) {
            return $217f3b78794d28fe$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $217f3b78794d28fe$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("ifSG1", function(module, exports) {
'use strict';

var $3LE7K = parcelRequire("3LE7K");

var $kghK8 = parcelRequire("kghK8");

var $3wGFR = parcelRequire("3wGFR");

var $bhDW8 = parcelRequire("bhDW8");
var $d4a40a630b76a645$var$$Map = $3LE7K('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $d4a40a630b76a645$var$$mapGet = $kghK8('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $d4a40a630b76a645$var$$mapSet = $kghK8('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $d4a40a630b76a645$var$$mapHas = $kghK8('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $d4a40a630b76a645$var$$mapDelete = $kghK8('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $d4a40a630b76a645$var$$mapSize = $kghK8('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$d4a40a630b76a645$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bhDW8('Side channel does not contain ' + $3wGFR(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $d4a40a630b76a645$var$$mapDelete($m, key);
                if ($d4a40a630b76a645$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $d4a40a630b76a645$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $d4a40a630b76a645$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $d4a40a630b76a645$var$$Map();
            $d4a40a630b76a645$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("3LE7K", function(module, exports) {
'use strict';
var $2be4e2ae2a944a29$var$undefined1;

var $kp3Tw = parcelRequire("kp3Tw");

var $cWwsi = parcelRequire("cWwsi");

var $9VaPA = parcelRequire("9VaPA");

var $6SbTD = parcelRequire("6SbTD");

var $dlerY = parcelRequire("dlerY");

var $jN9dF = parcelRequire("jN9dF");

var $bhDW8 = parcelRequire("bhDW8");

var $dOK75 = parcelRequire("dOK75");

var $6Y5IA = parcelRequire("6Y5IA");

var $7WWcb = parcelRequire("7WWcb");

var $9r5So = parcelRequire("9r5So");

var $fWM4K = parcelRequire("fWM4K");

var $i6OZx = parcelRequire("i6OZx");

var $ab2pT = parcelRequire("ab2pT");

var $4ruRC = parcelRequire("4ruRC");
var $2be4e2ae2a944a29$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $2be4e2ae2a944a29$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $2be4e2ae2a944a29$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $b9CRH = parcelRequire("b9CRH");

var $gBWXW = parcelRequire("gBWXW");
var $2be4e2ae2a944a29$var$throwTypeError = function() {
    throw new $bhDW8();
};
var $2be4e2ae2a944a29$var$ThrowTypeError = $b9CRH ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $2be4e2ae2a944a29$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $b9CRH(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $2be4e2ae2a944a29$var$throwTypeError;
        }
    }
}() : $2be4e2ae2a944a29$var$throwTypeError;

var $2be4e2ae2a944a29$var$hasSymbols = (parcelRequire("aDpje"))();

var $kWPUK = parcelRequire("kWPUK");

var $aJh6i = parcelRequire("aJh6i");

var $a3BKo = parcelRequire("a3BKo");

var $eViEM = parcelRequire("eViEM");

var $9s6SW = parcelRequire("9s6SW");
var $2be4e2ae2a944a29$var$needsEval = {};
var $2be4e2ae2a944a29$var$TypedArray = typeof Uint8Array === 'undefined' || !$kWPUK ? undefined : $kWPUK(Uint8Array);
var $2be4e2ae2a944a29$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $2be4e2ae2a944a29$var$hasSymbols && $kWPUK ? $kWPUK([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $2be4e2ae2a944a29$var$needsEval,
    '%AsyncGenerator%': $2be4e2ae2a944a29$var$needsEval,
    '%AsyncGeneratorFunction%': $2be4e2ae2a944a29$var$needsEval,
    '%AsyncIteratorPrototype%': $2be4e2ae2a944a29$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $cWwsi,
    '%eval%': eval,
    '%EvalError%': $9VaPA,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $2be4e2ae2a944a29$var$$Function,
    '%GeneratorFunction%': $2be4e2ae2a944a29$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $2be4e2ae2a944a29$var$hasSymbols && $kWPUK ? $kWPUK($kWPUK([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$2be4e2ae2a944a29$var$hasSymbols || !$kWPUK ? undefined : $kWPUK(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $kp3Tw,
    '%Object.getOwnPropertyDescriptor%': $b9CRH,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6SbTD,
    '%ReferenceError%': $dlerY,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$2be4e2ae2a944a29$var$hasSymbols || !$kWPUK ? undefined : $kWPUK(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $2be4e2ae2a944a29$var$hasSymbols && $kWPUK ? $kWPUK(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $2be4e2ae2a944a29$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $jN9dF,
    '%ThrowTypeError%': $2be4e2ae2a944a29$var$ThrowTypeError,
    '%TypedArray%': $2be4e2ae2a944a29$var$TypedArray,
    '%TypeError%': $bhDW8,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $dOK75,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9s6SW,
    '%Function.prototype.apply%': $eViEM,
    '%Object.defineProperty%': $gBWXW,
    '%Object.getPrototypeOf%': $aJh6i,
    '%Math.abs%': $6Y5IA,
    '%Math.floor%': $7WWcb,
    '%Math.max%': $9r5So,
    '%Math.min%': $fWM4K,
    '%Math.pow%': $i6OZx,
    '%Math.round%': $ab2pT,
    '%Math.sign%': $4ruRC,
    '%Reflect.getPrototypeOf%': $a3BKo
};
if ($kWPUK) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $2be4e2ae2a944a29$var$errorProto = $kWPUK($kWPUK(e));
    $2be4e2ae2a944a29$var$INTRINSICS['%Error.prototype%'] = $2be4e2ae2a944a29$var$errorProto;
}
var $2be4e2ae2a944a29$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $2be4e2ae2a944a29$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $2be4e2ae2a944a29$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $2be4e2ae2a944a29$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $kWPUK) value = $kWPUK(gen.prototype);
    }
    $2be4e2ae2a944a29$var$INTRINSICS[name] = value;
    return value;
};
var $2be4e2ae2a944a29$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $hPnoH = parcelRequire("hPnoH");

var $7L7DX = parcelRequire("7L7DX");
var $2be4e2ae2a944a29$var$$concat = $hPnoH.call($9s6SW, Array.prototype.concat);
var $2be4e2ae2a944a29$var$$spliceApply = $hPnoH.call($eViEM, Array.prototype.splice);
var $2be4e2ae2a944a29$var$$replace = $hPnoH.call($9s6SW, String.prototype.replace);
var $2be4e2ae2a944a29$var$$strSlice = $hPnoH.call($9s6SW, String.prototype.slice);
var $2be4e2ae2a944a29$var$$exec = $hPnoH.call($9s6SW, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $2be4e2ae2a944a29$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $2be4e2ae2a944a29$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $2be4e2ae2a944a29$var$stringToPath = function stringToPath(string) {
    var first = $2be4e2ae2a944a29$var$$strSlice(string, 0, 1);
    var last = $2be4e2ae2a944a29$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $jN9dF('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $jN9dF('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $2be4e2ae2a944a29$var$$replace(string, $2be4e2ae2a944a29$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $2be4e2ae2a944a29$var$$replace(subString, $2be4e2ae2a944a29$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $2be4e2ae2a944a29$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7L7DX($2be4e2ae2a944a29$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $2be4e2ae2a944a29$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7L7DX($2be4e2ae2a944a29$var$INTRINSICS, intrinsicName)) {
        var value = $2be4e2ae2a944a29$var$INTRINSICS[intrinsicName];
        if (value === $2be4e2ae2a944a29$var$needsEval) value = $2be4e2ae2a944a29$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $bhDW8('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $jN9dF('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $bhDW8('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $bhDW8('"allowMissing" argument must be a boolean');
    if ($2be4e2ae2a944a29$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $jN9dF('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $2be4e2ae2a944a29$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $2be4e2ae2a944a29$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $2be4e2ae2a944a29$var$$spliceApply(parts, $2be4e2ae2a944a29$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $2be4e2ae2a944a29$var$$strSlice(part, 0, 1);
        var last = $2be4e2ae2a944a29$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $jN9dF('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7L7DX($2be4e2ae2a944a29$var$INTRINSICS, intrinsicRealName)) value = $2be4e2ae2a944a29$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bhDW8('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($b9CRH && i + 1 >= parts.length) {
                var desc = $b9CRH(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7L7DX(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $2be4e2ae2a944a29$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("kp3Tw", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("cWwsi", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("9VaPA", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("6SbTD", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("dlerY", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("jN9dF", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("dOK75", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("6Y5IA", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("7WWcb", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("9r5So", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("fWM4K", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("i6OZx", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("ab2pT", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4ruRC", function(module, exports) {
'use strict';

var $aix9d = parcelRequire("aix9d");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($aix9d(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("aix9d", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("b9CRH", function(module, exports) {
'use strict';

var $1xWmc = parcelRequire("1xWmc");
var $81eeaec06ba316e5$require$$gOPD = $1xWmc;
if ($81eeaec06ba316e5$require$$gOPD) try {
    $81eeaec06ba316e5$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $81eeaec06ba316e5$require$$gOPD = null;
}
module.exports = $81eeaec06ba316e5$require$$gOPD;

});
parcelRegister("1xWmc", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("gBWXW", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $c17dd770e38f1604$var$$defineProperty = Object.defineProperty || false;
if ($c17dd770e38f1604$var$$defineProperty) try {
    $c17dd770e38f1604$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $c17dd770e38f1604$var$$defineProperty = false;
}
module.exports = $c17dd770e38f1604$var$$defineProperty;

});

parcelRegister("aDpje", function(module, exports) {
'use strict';
var $7be12dc2811e19e8$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $lqQ7L = parcelRequire("lqQ7L");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $7be12dc2811e19e8$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $7be12dc2811e19e8$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $lqQ7L();
};

});
parcelRegister("lqQ7L", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("kWPUK", function(module, exports) {
'use strict';

var $a3BKo = parcelRequire("a3BKo");

var $aJh6i = parcelRequire("aJh6i");

var $4MTlI = parcelRequire("4MTlI");
/** @type {import('.')} */ module.exports = $a3BKo ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $a3BKo(O);
} : $aJh6i ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $aJh6i(O);
} : $4MTlI ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4MTlI(O);
} : null;

});
parcelRegister("a3BKo", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("aJh6i", function(module, exports) {
'use strict';

var $1iC5p = parcelRequire("1iC5p");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $1iC5p.getPrototypeOf || null;

});
parcelRegister("1iC5p", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});


parcelRegister("4MTlI", function(module, exports) {
'use strict';

var $7Uwjf = parcelRequire("7Uwjf");

var $leHRJ = parcelRequire("leHRJ");
var $37c69452291383b2$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $37c69452291383b2$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $37c69452291383b2$var$desc = !!$37c69452291383b2$var$hasProtoAccessor && $leHRJ && $leHRJ(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $37c69452291383b2$var$$Object = Object;
var $37c69452291383b2$var$$getPrototypeOf = $37c69452291383b2$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $37c69452291383b2$var$desc && typeof $37c69452291383b2$var$desc.get === 'function' ? $7Uwjf([
    $37c69452291383b2$var$desc.get
]) : typeof $37c69452291383b2$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $37c69452291383b2$var$$getPrototypeOf(value == null ? value : $37c69452291383b2$var$$Object(value));
} : false;

});
parcelRegister("7Uwjf", function(module, exports) {
'use strict';

var $hPnoH = parcelRequire("hPnoH");

var $bhDW8 = parcelRequire("bhDW8");

var $9s6SW = parcelRequire("9s6SW");

var $15aGf = parcelRequire("15aGf");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $bhDW8('a function is required');
    return $15aGf($hPnoH, $9s6SW, args);
};

});
parcelRegister("hPnoH", function(module, exports) {
'use strict';

var $449sv = parcelRequire("449sv");
module.exports = Function.prototype.bind || $449sv;

});
parcelRegister("449sv", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $2f5edf70701ce5e3$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $2f5edf70701ce5e3$var$toStr = Object.prototype.toString;
var $2f5edf70701ce5e3$var$max = Math.max;
var $2f5edf70701ce5e3$var$funcType = '[object Function]';
var $2f5edf70701ce5e3$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $2f5edf70701ce5e3$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $2f5edf70701ce5e3$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $2f5edf70701ce5e3$var$toStr.apply(target) !== $2f5edf70701ce5e3$var$funcType) throw new TypeError($2f5edf70701ce5e3$var$ERROR_MESSAGE + target);
    var args = $2f5edf70701ce5e3$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $2f5edf70701ce5e3$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $2f5edf70701ce5e3$var$concatty(args, arguments));
    };
    var boundLength = $2f5edf70701ce5e3$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $2f5edf70701ce5e3$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9s6SW", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("15aGf", function(module, exports) {
'use strict';

var $hPnoH = parcelRequire("hPnoH");

var $eViEM = parcelRequire("eViEM");

var $9s6SW = parcelRequire("9s6SW");

var $kcJgL = parcelRequire("kcJgL");
/** @type {import('./actualApply')} */ module.exports = $kcJgL || $hPnoH.call($9s6SW, $eViEM);

});
parcelRegister("eViEM", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("kcJgL", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});



parcelRegister("leHRJ", function(module, exports) {
'use strict';

var $dofcD = parcelRequire("dofcD");
var $f75cee92e7643fd2$require$$gOPD = $dofcD;
if ($f75cee92e7643fd2$require$$gOPD) try {
    $f75cee92e7643fd2$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $f75cee92e7643fd2$require$$gOPD = null;
}
module.exports = $f75cee92e7643fd2$require$$gOPD;

});
parcelRegister("dofcD", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});




parcelRegister("7L7DX", function(module, exports) {
'use strict';
var $5a62da03bf1e08c4$var$call = Function.prototype.call;
var $5a62da03bf1e08c4$var$$hasOwn = Object.prototype.hasOwnProperty;

var $hPnoH = parcelRequire("hPnoH");
/** @type {import('.')} */ module.exports = $hPnoH.call($5a62da03bf1e08c4$var$call, $5a62da03bf1e08c4$var$$hasOwn);

});


parcelRegister("kghK8", function(module, exports) {
'use strict';

var $7NYQZ = parcelRequire("7NYQZ");

var $7Uwjf = parcelRequire("7Uwjf");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $ec0310a84bbae302$var$$indexOf = $7Uwjf([
    $7NYQZ('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $7NYQZ(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $ec0310a84bbae302$var$$indexOf(name, '.prototype.') > -1) return $7Uwjf(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("7NYQZ", function(module, exports) {
'use strict';
var $5aec504d4960bdf8$var$undefined1;

var $9HIak = parcelRequire("9HIak");

var $cWwsi = parcelRequire("cWwsi");

var $9VaPA = parcelRequire("9VaPA");

var $6SbTD = parcelRequire("6SbTD");

var $dlerY = parcelRequire("dlerY");

var $jN9dF = parcelRequire("jN9dF");

var $bhDW8 = parcelRequire("bhDW8");

var $dOK75 = parcelRequire("dOK75");

var $6Y5IA = parcelRequire("6Y5IA");

var $7WWcb = parcelRequire("7WWcb");

var $9r5So = parcelRequire("9r5So");

var $fWM4K = parcelRequire("fWM4K");

var $i6OZx = parcelRequire("i6OZx");

var $ab2pT = parcelRequire("ab2pT");

var $4ruRC = parcelRequire("4ruRC");
var $5aec504d4960bdf8$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $5aec504d4960bdf8$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $5aec504d4960bdf8$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $9mK3J = parcelRequire("9mK3J");

var $hojN4 = parcelRequire("hojN4");
var $5aec504d4960bdf8$var$throwTypeError = function() {
    throw new $bhDW8();
};
var $5aec504d4960bdf8$var$ThrowTypeError = $9mK3J ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $5aec504d4960bdf8$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $9mK3J(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $5aec504d4960bdf8$var$throwTypeError;
        }
    }
}() : $5aec504d4960bdf8$var$throwTypeError;

var $5aec504d4960bdf8$var$hasSymbols = (parcelRequire("cPEiH"))();

var $kWPUK = parcelRequire("kWPUK");

var $aJh6i = parcelRequire("aJh6i");

var $a3BKo = parcelRequire("a3BKo");

var $eViEM = parcelRequire("eViEM");

var $9s6SW = parcelRequire("9s6SW");
var $5aec504d4960bdf8$var$needsEval = {};
var $5aec504d4960bdf8$var$TypedArray = typeof Uint8Array === 'undefined' || !$kWPUK ? undefined : $kWPUK(Uint8Array);
var $5aec504d4960bdf8$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $5aec504d4960bdf8$var$hasSymbols && $kWPUK ? $kWPUK([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $5aec504d4960bdf8$var$needsEval,
    '%AsyncGenerator%': $5aec504d4960bdf8$var$needsEval,
    '%AsyncGeneratorFunction%': $5aec504d4960bdf8$var$needsEval,
    '%AsyncIteratorPrototype%': $5aec504d4960bdf8$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $cWwsi,
    '%eval%': eval,
    '%EvalError%': $9VaPA,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $5aec504d4960bdf8$var$$Function,
    '%GeneratorFunction%': $5aec504d4960bdf8$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $5aec504d4960bdf8$var$hasSymbols && $kWPUK ? $kWPUK($kWPUK([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$5aec504d4960bdf8$var$hasSymbols || !$kWPUK ? undefined : $kWPUK(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $9HIak,
    '%Object.getOwnPropertyDescriptor%': $9mK3J,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6SbTD,
    '%ReferenceError%': $dlerY,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$5aec504d4960bdf8$var$hasSymbols || !$kWPUK ? undefined : $kWPUK(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $5aec504d4960bdf8$var$hasSymbols && $kWPUK ? $kWPUK(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $5aec504d4960bdf8$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $jN9dF,
    '%ThrowTypeError%': $5aec504d4960bdf8$var$ThrowTypeError,
    '%TypedArray%': $5aec504d4960bdf8$var$TypedArray,
    '%TypeError%': $bhDW8,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $dOK75,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9s6SW,
    '%Function.prototype.apply%': $eViEM,
    '%Object.defineProperty%': $hojN4,
    '%Object.getPrototypeOf%': $aJh6i,
    '%Math.abs%': $6Y5IA,
    '%Math.floor%': $7WWcb,
    '%Math.max%': $9r5So,
    '%Math.min%': $fWM4K,
    '%Math.pow%': $i6OZx,
    '%Math.round%': $ab2pT,
    '%Math.sign%': $4ruRC,
    '%Reflect.getPrototypeOf%': $a3BKo
};
if ($kWPUK) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $5aec504d4960bdf8$var$errorProto = $kWPUK($kWPUK(e));
    $5aec504d4960bdf8$var$INTRINSICS['%Error.prototype%'] = $5aec504d4960bdf8$var$errorProto;
}
var $5aec504d4960bdf8$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $5aec504d4960bdf8$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $5aec504d4960bdf8$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $5aec504d4960bdf8$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $kWPUK) value = $kWPUK(gen.prototype);
    }
    $5aec504d4960bdf8$var$INTRINSICS[name] = value;
    return value;
};
var $5aec504d4960bdf8$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $hPnoH = parcelRequire("hPnoH");

var $7L7DX = parcelRequire("7L7DX");
var $5aec504d4960bdf8$var$$concat = $hPnoH.call($9s6SW, Array.prototype.concat);
var $5aec504d4960bdf8$var$$spliceApply = $hPnoH.call($eViEM, Array.prototype.splice);
var $5aec504d4960bdf8$var$$replace = $hPnoH.call($9s6SW, String.prototype.replace);
var $5aec504d4960bdf8$var$$strSlice = $hPnoH.call($9s6SW, String.prototype.slice);
var $5aec504d4960bdf8$var$$exec = $hPnoH.call($9s6SW, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $5aec504d4960bdf8$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $5aec504d4960bdf8$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $5aec504d4960bdf8$var$stringToPath = function stringToPath(string) {
    var first = $5aec504d4960bdf8$var$$strSlice(string, 0, 1);
    var last = $5aec504d4960bdf8$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $jN9dF('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $jN9dF('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $5aec504d4960bdf8$var$$replace(string, $5aec504d4960bdf8$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $5aec504d4960bdf8$var$$replace(subString, $5aec504d4960bdf8$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $5aec504d4960bdf8$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7L7DX($5aec504d4960bdf8$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $5aec504d4960bdf8$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7L7DX($5aec504d4960bdf8$var$INTRINSICS, intrinsicName)) {
        var value = $5aec504d4960bdf8$var$INTRINSICS[intrinsicName];
        if (value === $5aec504d4960bdf8$var$needsEval) value = $5aec504d4960bdf8$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $bhDW8('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $jN9dF('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $bhDW8('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $bhDW8('"allowMissing" argument must be a boolean');
    if ($5aec504d4960bdf8$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $jN9dF('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $5aec504d4960bdf8$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $5aec504d4960bdf8$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $5aec504d4960bdf8$var$$spliceApply(parts, $5aec504d4960bdf8$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $5aec504d4960bdf8$var$$strSlice(part, 0, 1);
        var last = $5aec504d4960bdf8$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $jN9dF('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7L7DX($5aec504d4960bdf8$var$INTRINSICS, intrinsicRealName)) value = $5aec504d4960bdf8$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bhDW8('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($9mK3J && i + 1 >= parts.length) {
                var desc = $9mK3J(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7L7DX(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $5aec504d4960bdf8$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("9HIak", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("9mK3J", function(module, exports) {
'use strict';

var $2m1ld = parcelRequire("2m1ld");
var $6d19e580dfee379d$require$$gOPD = $2m1ld;
if ($6d19e580dfee379d$require$$gOPD) try {
    $6d19e580dfee379d$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $6d19e580dfee379d$require$$gOPD = null;
}
module.exports = $6d19e580dfee379d$require$$gOPD;

});
parcelRegister("2m1ld", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("hojN4", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $ca9407847eb0dff1$var$$defineProperty = Object.defineProperty || false;
if ($ca9407847eb0dff1$var$$defineProperty) try {
    $ca9407847eb0dff1$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $ca9407847eb0dff1$var$$defineProperty = false;
}
module.exports = $ca9407847eb0dff1$var$$defineProperty;

});

parcelRegister("cPEiH", function(module, exports) {
'use strict';
var $9579825103047403$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $aiejA = parcelRequire("aiejA");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $9579825103047403$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $9579825103047403$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $aiejA();
};

});
parcelRegister("aiejA", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});





parcelRegister("cAAH9", function(module, exports) {
'use strict';

var $35qHC = parcelRequire("35qHC");

var $kghK8 = parcelRequire("kghK8");

var $3wGFR = parcelRequire("3wGFR");

var $ifSG1 = parcelRequire("ifSG1");

var $bhDW8 = parcelRequire("bhDW8");
var $92a54fb177563a3c$var$$WeakMap = $35qHC('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $92a54fb177563a3c$var$$weakMapGet = $kghK8('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $92a54fb177563a3c$var$$weakMapSet = $kghK8('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $92a54fb177563a3c$var$$weakMapHas = $kghK8('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $92a54fb177563a3c$var$$weakMapDelete = $kghK8('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $92a54fb177563a3c$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bhDW8('Side channel does not contain ' + $3wGFR(key));
        },
        'delete': function(key) {
            if ($92a54fb177563a3c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $92a54fb177563a3c$var$$weakMapDelete($wm, key);
            } else if ($ifSG1) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($92a54fb177563a3c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $92a54fb177563a3c$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($92a54fb177563a3c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $92a54fb177563a3c$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($92a54fb177563a3c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $92a54fb177563a3c$var$$WeakMap();
                $92a54fb177563a3c$var$$weakMapSet($wm, key, value);
            } else if ($ifSG1) {
                if (!$m) $m = $ifSG1();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $ifSG1;

});
parcelRegister("35qHC", function(module, exports) {
'use strict';
var $23f68d4915c5e691$var$undefined1;

var $eWm81 = parcelRequire("eWm81");

var $cWwsi = parcelRequire("cWwsi");

var $9VaPA = parcelRequire("9VaPA");

var $6SbTD = parcelRequire("6SbTD");

var $dlerY = parcelRequire("dlerY");

var $jN9dF = parcelRequire("jN9dF");

var $bhDW8 = parcelRequire("bhDW8");

var $dOK75 = parcelRequire("dOK75");

var $6Y5IA = parcelRequire("6Y5IA");

var $7WWcb = parcelRequire("7WWcb");

var $9r5So = parcelRequire("9r5So");

var $fWM4K = parcelRequire("fWM4K");

var $i6OZx = parcelRequire("i6OZx");

var $ab2pT = parcelRequire("ab2pT");

var $4ruRC = parcelRequire("4ruRC");
var $23f68d4915c5e691$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $23f68d4915c5e691$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $23f68d4915c5e691$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $ki3A2 = parcelRequire("ki3A2");

var $dheSY = parcelRequire("dheSY");
var $23f68d4915c5e691$var$throwTypeError = function() {
    throw new $bhDW8();
};
var $23f68d4915c5e691$var$ThrowTypeError = $ki3A2 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $23f68d4915c5e691$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $ki3A2(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $23f68d4915c5e691$var$throwTypeError;
        }
    }
}() : $23f68d4915c5e691$var$throwTypeError;

var $23f68d4915c5e691$var$hasSymbols = (parcelRequire("biyeq"))();

var $kWPUK = parcelRequire("kWPUK");

var $aJh6i = parcelRequire("aJh6i");

var $a3BKo = parcelRequire("a3BKo");

var $eViEM = parcelRequire("eViEM");

var $9s6SW = parcelRequire("9s6SW");
var $23f68d4915c5e691$var$needsEval = {};
var $23f68d4915c5e691$var$TypedArray = typeof Uint8Array === 'undefined' || !$kWPUK ? undefined : $kWPUK(Uint8Array);
var $23f68d4915c5e691$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $23f68d4915c5e691$var$hasSymbols && $kWPUK ? $kWPUK([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $23f68d4915c5e691$var$needsEval,
    '%AsyncGenerator%': $23f68d4915c5e691$var$needsEval,
    '%AsyncGeneratorFunction%': $23f68d4915c5e691$var$needsEval,
    '%AsyncIteratorPrototype%': $23f68d4915c5e691$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $cWwsi,
    '%eval%': eval,
    '%EvalError%': $9VaPA,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $23f68d4915c5e691$var$$Function,
    '%GeneratorFunction%': $23f68d4915c5e691$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $23f68d4915c5e691$var$hasSymbols && $kWPUK ? $kWPUK($kWPUK([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$23f68d4915c5e691$var$hasSymbols || !$kWPUK ? undefined : $kWPUK(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $eWm81,
    '%Object.getOwnPropertyDescriptor%': $ki3A2,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6SbTD,
    '%ReferenceError%': $dlerY,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$23f68d4915c5e691$var$hasSymbols || !$kWPUK ? undefined : $kWPUK(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $23f68d4915c5e691$var$hasSymbols && $kWPUK ? $kWPUK(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $23f68d4915c5e691$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $jN9dF,
    '%ThrowTypeError%': $23f68d4915c5e691$var$ThrowTypeError,
    '%TypedArray%': $23f68d4915c5e691$var$TypedArray,
    '%TypeError%': $bhDW8,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $dOK75,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9s6SW,
    '%Function.prototype.apply%': $eViEM,
    '%Object.defineProperty%': $dheSY,
    '%Object.getPrototypeOf%': $aJh6i,
    '%Math.abs%': $6Y5IA,
    '%Math.floor%': $7WWcb,
    '%Math.max%': $9r5So,
    '%Math.min%': $fWM4K,
    '%Math.pow%': $i6OZx,
    '%Math.round%': $ab2pT,
    '%Math.sign%': $4ruRC,
    '%Reflect.getPrototypeOf%': $a3BKo
};
if ($kWPUK) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $23f68d4915c5e691$var$errorProto = $kWPUK($kWPUK(e));
    $23f68d4915c5e691$var$INTRINSICS['%Error.prototype%'] = $23f68d4915c5e691$var$errorProto;
}
var $23f68d4915c5e691$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $23f68d4915c5e691$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $23f68d4915c5e691$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $23f68d4915c5e691$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $kWPUK) value = $kWPUK(gen.prototype);
    }
    $23f68d4915c5e691$var$INTRINSICS[name] = value;
    return value;
};
var $23f68d4915c5e691$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $hPnoH = parcelRequire("hPnoH");

var $7L7DX = parcelRequire("7L7DX");
var $23f68d4915c5e691$var$$concat = $hPnoH.call($9s6SW, Array.prototype.concat);
var $23f68d4915c5e691$var$$spliceApply = $hPnoH.call($eViEM, Array.prototype.splice);
var $23f68d4915c5e691$var$$replace = $hPnoH.call($9s6SW, String.prototype.replace);
var $23f68d4915c5e691$var$$strSlice = $hPnoH.call($9s6SW, String.prototype.slice);
var $23f68d4915c5e691$var$$exec = $hPnoH.call($9s6SW, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $23f68d4915c5e691$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $23f68d4915c5e691$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $23f68d4915c5e691$var$stringToPath = function stringToPath(string) {
    var first = $23f68d4915c5e691$var$$strSlice(string, 0, 1);
    var last = $23f68d4915c5e691$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $jN9dF('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $jN9dF('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $23f68d4915c5e691$var$$replace(string, $23f68d4915c5e691$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $23f68d4915c5e691$var$$replace(subString, $23f68d4915c5e691$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $23f68d4915c5e691$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7L7DX($23f68d4915c5e691$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $23f68d4915c5e691$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7L7DX($23f68d4915c5e691$var$INTRINSICS, intrinsicName)) {
        var value = $23f68d4915c5e691$var$INTRINSICS[intrinsicName];
        if (value === $23f68d4915c5e691$var$needsEval) value = $23f68d4915c5e691$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $bhDW8('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $jN9dF('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $bhDW8('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $bhDW8('"allowMissing" argument must be a boolean');
    if ($23f68d4915c5e691$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $jN9dF('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $23f68d4915c5e691$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $23f68d4915c5e691$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $23f68d4915c5e691$var$$spliceApply(parts, $23f68d4915c5e691$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $23f68d4915c5e691$var$$strSlice(part, 0, 1);
        var last = $23f68d4915c5e691$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $jN9dF('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7L7DX($23f68d4915c5e691$var$INTRINSICS, intrinsicRealName)) value = $23f68d4915c5e691$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bhDW8('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($ki3A2 && i + 1 >= parts.length) {
                var desc = $ki3A2(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7L7DX(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $23f68d4915c5e691$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("eWm81", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("ki3A2", function(module, exports) {
'use strict';

var $1cJYc = parcelRequire("1cJYc");
var $ec584407501f042b$require$$gOPD = $1cJYc;
if ($ec584407501f042b$require$$gOPD) try {
    $ec584407501f042b$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $ec584407501f042b$require$$gOPD = null;
}
module.exports = $ec584407501f042b$require$$gOPD;

});
parcelRegister("1cJYc", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("dheSY", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $9aa868dd11417380$var$$defineProperty = Object.defineProperty || false;
if ($9aa868dd11417380$var$$defineProperty) try {
    $9aa868dd11417380$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9aa868dd11417380$var$$defineProperty = false;
}
module.exports = $9aa868dd11417380$var$$defineProperty;

});

parcelRegister("biyeq", function(module, exports) {
'use strict';
var $839bedd7ff78722a$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $hPQW8 = parcelRequire("hPQW8");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $839bedd7ff78722a$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $839bedd7ff78722a$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $hPQW8();
};

});
parcelRegister("hPQW8", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});





parcelRegister("f46HZ", function(module, exports) {
'use strict';

var $aTDGG = parcelRequire("aTDGG");

var $2L6qV = parcelRequire("2L6qV");
var $af7c6ee655acee7d$var$has = Object.prototype.hasOwnProperty;
var $af7c6ee655acee7d$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $af7c6ee655acee7d$var$overflowChannel = $2L6qV();
var $af7c6ee655acee7d$var$markOverflow = function markOverflow(obj, maxIndex) {
    $af7c6ee655acee7d$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $af7c6ee655acee7d$var$isOverflow = function isOverflow(obj) {
    return $af7c6ee655acee7d$var$overflowChannel.has(obj);
};
var $af7c6ee655acee7d$var$getMaxIndex = function getMaxIndex(obj) {
    return $af7c6ee655acee7d$var$overflowChannel.get(obj);
};
var $af7c6ee655acee7d$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $af7c6ee655acee7d$var$overflowChannel.set(obj, maxIndex);
};
var $af7c6ee655acee7d$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $af7c6ee655acee7d$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($af7c6ee655acee7d$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $af7c6ee655acee7d$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $af7c6ee655acee7d$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($af7c6ee655acee7d$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if ($af7c6ee655acee7d$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $af7c6ee655acee7d$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $af7c6ee655acee7d$var$setMaxIndex(target, newIndex);
            } else if (options && (options.plainObjects || options.allowPrototypes) || !$af7c6ee655acee7d$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($af7c6ee655acee7d$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $af7c6ee655acee7d$var$markOverflow(result, $af7c6ee655acee7d$var$getMaxIndex(source) + 1);
        }
        return [
            target
        ].concat(source);
    }
    var mergeTarget = target;
    if ($af7c6ee655acee7d$var$isArray(target) && !$af7c6ee655acee7d$var$isArray(source)) mergeTarget = $af7c6ee655acee7d$var$arrayToObject(target, options);
    if ($af7c6ee655acee7d$var$isArray(target) && $af7c6ee655acee7d$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($af7c6ee655acee7d$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($af7c6ee655acee7d$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $af7c6ee655acee7d$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $af7c6ee655acee7d$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $af7c6ee655acee7d$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $af7c6ee655acee7d$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $af7c6ee655acee7d$var$limit){
        var segment = string.length >= $af7c6ee655acee7d$var$limit ? string.slice(j, j + $af7c6ee655acee7d$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $aTDGG.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $af7c6ee655acee7d$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $af7c6ee655acee7d$var$hexTable[0xC0 | c >> 6] + $af7c6ee655acee7d$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $af7c6ee655acee7d$var$hexTable[0xE0 | c >> 12] + $af7c6ee655acee7d$var$hexTable[0x80 | c >> 6 & 0x3F] + $af7c6ee655acee7d$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $af7c6ee655acee7d$var$hexTable[0xF0 | c >> 18] + $af7c6ee655acee7d$var$hexTable[0x80 | c >> 12 & 0x3F] + $af7c6ee655acee7d$var$hexTable[0x80 | c >> 6 & 0x3F] + $af7c6ee655acee7d$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $af7c6ee655acee7d$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $af7c6ee655acee7d$var$compactQueue(queue);
    return value;
};
var $af7c6ee655acee7d$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $af7c6ee655acee7d$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $af7c6ee655acee7d$var$combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if ($af7c6ee655acee7d$var$isOverflow(a)) {
        var newIndex = $af7c6ee655acee7d$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $af7c6ee655acee7d$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) return $af7c6ee655acee7d$var$markOverflow($af7c6ee655acee7d$var$arrayToObject(result, {
        plainObjects: plainObjects
    }), result.length - 1);
    return result;
};
var $af7c6ee655acee7d$var$maybeMap = function maybeMap(val, fn) {
    if ($af7c6ee655acee7d$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $af7c6ee655acee7d$var$arrayToObject,
    assign: $af7c6ee655acee7d$var$assign,
    combine: $af7c6ee655acee7d$var$combine,
    compact: $af7c6ee655acee7d$var$compact,
    decode: $af7c6ee655acee7d$var$decode,
    encode: $af7c6ee655acee7d$var$encode,
    isBuffer: $af7c6ee655acee7d$var$isBuffer,
    isOverflow: $af7c6ee655acee7d$var$isOverflow,
    isRegExp: $af7c6ee655acee7d$var$isRegExp,
    maybeMap: $af7c6ee655acee7d$var$maybeMap,
    merge: $af7c6ee655acee7d$var$merge
};

});
parcelRegister("aTDGG", function(module, exports) {
'use strict';
var $7eedd382cb6b7ce9$var$replace = String.prototype.replace;
var $7eedd382cb6b7ce9$var$percentTwenties = /%20/g;
var $7eedd382cb6b7ce9$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $7eedd382cb6b7ce9$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $7eedd382cb6b7ce9$var$replace.call(value, $7eedd382cb6b7ce9$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $7eedd382cb6b7ce9$var$Format.RFC1738,
    RFC3986: $7eedd382cb6b7ce9$var$Format.RFC3986
};

});



parcelRegister("dzysB", function(module, exports) {
'use strict';

var $f46HZ = parcelRequire("f46HZ");
var $9e19465ee1289a84$var$has = Object.prototype.hasOwnProperty;
var $9e19465ee1289a84$var$isArray = Array.isArray;
var $9e19465ee1289a84$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $f46HZ.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $9e19465ee1289a84$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $9e19465ee1289a84$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $9e19465ee1289a84$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $9e19465ee1289a84$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $9e19465ee1289a84$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $9e19465ee1289a84$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $9e19465ee1289a84$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $9e19465ee1289a84$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $9e19465ee1289a84$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $f46HZ.maybeMap($9e19465ee1289a84$var$parseArrayValue(part.slice(pos + 1), options, $9e19465ee1289a84$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $9e19465ee1289a84$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $9e19465ee1289a84$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $9e19465ee1289a84$var$isArray(val) ? [
            val
        ] : val;
        if (key !== null) {
            var existing = $9e19465ee1289a84$var$has.call(obj, key);
            if (existing && options.duplicates === 'combine') obj[key] = $f46HZ.combine(obj[key], val, options.arrayLimit, options.plainObjects);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $9e19465ee1289a84$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $9e19465ee1289a84$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($f46HZ.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $f46HZ.combine([], leaf, options.arrayLimit, options.plainObjects);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $9e19465ee1289a84$var$splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    if (options.depth <= 0) {
        if (!options.plainObjects && $9e19465ee1289a84$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    var keys = [];
    if (parent) {
        if (!options.plainObjects && $9e19465ee1289a84$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && $9e19465ee1289a84$var$has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return keys;
};
var $9e19465ee1289a84$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $9e19465ee1289a84$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $9e19465ee1289a84$var$parseObject(keys, val, options, valuesParsed);
};
var $9e19465ee1289a84$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $9e19465ee1289a84$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $9e19465ee1289a84$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $9e19465ee1289a84$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $9e19465ee1289a84$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $9e19465ee1289a84$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $9e19465ee1289a84$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $9e19465ee1289a84$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $9e19465ee1289a84$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $9e19465ee1289a84$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $9e19465ee1289a84$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $9e19465ee1289a84$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $9e19465ee1289a84$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $f46HZ.isRegExp(opts.delimiter) ? opts.delimiter : $9e19465ee1289a84$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $9e19465ee1289a84$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $9e19465ee1289a84$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $9e19465ee1289a84$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $9e19465ee1289a84$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $9e19465ee1289a84$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $9e19465ee1289a84$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $9e19465ee1289a84$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $9e19465ee1289a84$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $9e19465ee1289a84$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $f46HZ.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $f46HZ.compact(obj);
};

});






parcelRegister("kNE9Z", function(module, exports) {
$parcel$export(module.exports, "getReCaptchaKey", function () { return $166490c8ee752610$export$4682c216c5c4d5d7; });
$parcel$export(module.exports, "isProduction", function () { return (parcelRequire("eRzlV")).isProduction; });
$parcel$export(module.exports, "getIdentityBaseUrl", function () { return (parcelRequire("eRzlV")).getIdentityBaseUrl; });
$parcel$export(module.exports, "getWacIntegrationUrl", function () { return (parcelRequire("eRzlV")).getWacIntegrationUrl; });

var $eRzlV = parcelRequire("eRzlV");
const $166490c8ee752610$var$IDENTITY_RECAPTCHA_KEY = '6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD';
const $166490c8ee752610$var$IDENTITY_RECAPTCHA_KEY_TEST = '6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN';
const $166490c8ee752610$export$4682c216c5c4d5d7 = ()=>{
    return (0, $eRzlV.isProduction)() ? $166490c8ee752610$var$IDENTITY_RECAPTCHA_KEY : $166490c8ee752610$var$IDENTITY_RECAPTCHA_KEY_TEST;
};

});
parcelRegister("eRzlV", function(module, exports) {
$parcel$export(module.exports, "CONTENTFUL_GRAPHQL_API_URL", function () { return $e76e945429b50eca$export$d5d3d254f14e9a42; });
$parcel$export(module.exports, "isProduction", function () { return $e76e945429b50eca$export$f15d00aa73aafac4; });
$parcel$export(module.exports, "getIdentityBaseUrl", function () { return $e76e945429b50eca$export$752967ea6498a4b5; });
$parcel$export(module.exports, "getWacIntegrationUrl", function () { return $e76e945429b50eca$export$e844e0b5527ae7a6; });
$parcel$export(module.exports, "getProductNameFromBundle", function () { return $e76e945429b50eca$export$882be03a94b7d874; });
const $e76e945429b50eca$var$URL_STAGING_IDENTITY = 'https://id.stg.internal.atlassian.com';
const $e76e945429b50eca$var$URL_PRODUCTION_IDENTITY = 'https://id.atlassian.com';
const $e76e945429b50eca$var$URL_STAGING_WAC = 'https://wac.stg.internal.atlassian.com';
const $e76e945429b50eca$var$URL_PRODUCTION_WAC = 'https://www.atlassian.com';
const $e76e945429b50eca$var$URL_STAGING_API = 'https://wac.stg.internal.atlassian.com/gateway/api';
const $e76e945429b50eca$var$URL_PRODUCTION_API = 'https://www.atlassian.com/gateway/api';
const $e76e945429b50eca$export$d5d3d254f14e9a42 = typeof window !== 'undefined' ? // @ts-ignore - Client side
`${window.CONTENTFUL_BASE_URL_GQL}/content/v1/spaces/${window.CONTENTFUL_SPACE_ID_PRODUCT_TEMPLATES}/environments/${window.CONTENTFUL_ENVIRONMENT_PRODUCT_TEMPLATES}` : // Server side
`${"https://graphql.contentful.com"}/content/v1/spaces/${"xjcz23wx147q"}/environments/${"master"}`;
const $e76e945429b50eca$export$f15d00aa73aafac4 = ()=>// assume production when environment is unknown
    ![
        'dev',
        'development',
        'staging'
    ].includes(String("production"));
const $e76e945429b50eca$export$752967ea6498a4b5 = ()=>$e76e945429b50eca$export$f15d00aa73aafac4() ? $e76e945429b50eca$var$URL_PRODUCTION_IDENTITY : $e76e945429b50eca$var$URL_STAGING_IDENTITY;
const $e76e945429b50eca$export$e844e0b5527ae7a6 = ()=>$e76e945429b50eca$export$f15d00aa73aafac4() ? $e76e945429b50eca$var$URL_PRODUCTION_WAC : $e76e945429b50eca$var$URL_STAGING_WAC;
const $e76e945429b50eca$export$4d28219d42798a75 = ()=>$e76e945429b50eca$export$f15d00aa73aafac4() ? $e76e945429b50eca$var$URL_PRODUCTION_API : $e76e945429b50eca$var$URL_STAGING_API;
const $e76e945429b50eca$export$9704458d7fccee2d = $e76e945429b50eca$export$752967ea6498a4b5();
const $e76e945429b50eca$export$422c73a9b9ad2bf3 = $e76e945429b50eca$export$e844e0b5527ae7a6();
const $e76e945429b50eca$export$882be03a94b7d874 = (bundleParam, productParam)=>{
    if (productParam) bundleParam = $e76e945429b50eca$export$14416f7267a645f4(productParam);
    switch(bundleParam){
        case 'confluence':
            return 'Confluence';
        case 'jira-service-management':
            return 'Jira Service Management';
        case 'jira-service-management-jira-software':
            return 'Jira Service Management + Jira';
        case 'compass':
            return 'Compass';
        case 'jira-product-discovery':
            return 'Jira Product Discovery';
        case 'loom':
            return 'Loom';
        case 'bitbucket':
            return 'Bitbucket';
        case 'jira-software':
        case '':
            return 'Jira';
        default:
            return '';
    }
};
const $e76e945429b50eca$export$14416f7267a645f4 = (productParam)=>{
    switch(productParam){
        case 'jira-software.ondemand':
        case '':
            return 'jira-software';
        case 'jira-servicedesk.ondemand':
            return 'jira-service-management';
        case 'confluence.ondemand':
            return 'confluence';
        case 'jira-product-discovery':
            return 'jira-product-discovery';
        case 'jira-servicedesk.ondemand,jira-software.ondemand':
            return 'jira-service-management-jira-software';
        case 'compass.ondemand':
            return 'compass';
        case 'com.atlassian.bitbucket.manual':
            return 'bitbucket';
        default:
            return '';
    }
};

});



parcelRegister("6fz8F", function(module, exports) {
$parcel$export(module.exports, "getRequestId", function () { return $e55da69e9b5829c1$export$710171574ebc9a51; });
function $e55da69e9b5829c1$export$710171574ebc9a51(progressUri) {
    const pattern = new RegExp(/cloud\/[\w-]+\/status\/([\w-]+)$/);
    const matches = pattern.exec(progressUri);
    return matches ? matches[1] : '';
}

});

parcelRegister("c0vG6", function(module, exports) {
$parcel$export(module.exports, "validatePrimaryCollectionProduct", function () { return $27999f4ccdabaec4$export$167732ef9bd4155a; });

var $fcO7r = parcelRequire("fcO7r");
const $27999f4ccdabaec4$export$167732ef9bd4155a = (productKey, primaryCollectionProduct)=>{
    const defaultCollectionProduct = (0, $fcO7r.DefaultCollectionProductMap)[productKey];
    if (defaultCollectionProduct) {
        const isValidCollectionProduct = primaryCollectionProduct && (0, $fcO7r.CollectionConstituentProductsMap)[productKey] && Object.values((0, $fcO7r.CollectionConstituentProductsMap)[productKey]).includes(primaryCollectionProduct);
        return isValidCollectionProduct ? primaryCollectionProduct : defaultCollectionProduct;
    }
    return '';
};

});


parcelRegister("dqd4k", function(module, exports) {
$parcel$export(module.exports, "useGupsStatus", function () { return $585017e4a8ab972d$export$eb068a7cf20a51ae; });
$parcel$export(module.exports, "GupsProvider", function () { return $585017e4a8ab972d$export$a5989227294cd90a; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $4Ois3 = parcelRequire("4Ois3");

var $2hTwF = parcelRequire("2hTwF");

var $3riD8 = parcelRequire("3riD8");

var $iSeHD = parcelRequire("iSeHD");

var $lcW33 = parcelRequire("lcW33");

var $17GU1 = parcelRequire("17GU1");
const $585017e4a8ab972d$export$82f756bfe5bba24e = {
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE)]: 'SOFTWARE_DEVELOPMENT',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT)]: 'IT_SUPPORT',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_DESIGN)]: 'DESIGN',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE)]: 'CUSTOMER_SERVICE',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_HR)]: 'HUMAN_RESOURCES',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)]: 'OPERATIONS',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_SALES)]: 'SALES',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_FINANCE)]: 'FINANCE',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_LEGAL)]: 'LEGAL',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL)]: 'OTHER',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_MARKETING)]: 'MARKETING',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE)]: 'DATA_SCIENCE',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT)]: 'PRODUCT_MANAGEMENT',
    [(0, $lcW33.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT)]: 'PROJECT_MANAGEMENT',
    'software-engineering': 'SOFTWARE_ENGINEERING'
};
const $585017e4a8ab972d$export$a1f86f8a748f57da = (jtbd)=>{
    return jtbd.filter(({ isChecked: isChecked })=>isChecked).map(({ value: value })=>value);
};
const $585017e4a8ab972d$export$644da7ba1500a73c = (teamType)=>{
    for (const [key, value] of Object.entries($585017e4a8ab972d$export$82f756bfe5bba24e)){
        if (key === teamType) return value;
    }
    return undefined;
};
function $585017e4a8ab972d$export$eb068a7cf20a51ae() {
    return (0, $1oC0p.useContext)($585017e4a8ab972d$var$GupsContext);
}
const $585017e4a8ab972d$var$GupsContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    addTeamTypeCallback: async ()=>undefined,
    getUserProfileJobFunctionCallback: async ()=>({
            requestInProgress: true,
            data: undefined,
            error: undefined
        }),
    getFullProfileCallback: async ()=>({
            data: undefined,
            error: undefined
        }),
    addJtbdCallback: async ()=>undefined,
    addTemplateCallback: async ()=>undefined,
    addTenantIdCallback: async ()=>undefined,
    getProfileSitesCallback: async ()=>undefined,
    linkAccountToAnonymousIdCallback: async ()=>undefined,
    addTemplateCardCallback: async ()=>undefined,
    getProfileCallback: async ()=>undefined,
    getAnonProfileSitesCallback: async ()=>undefined,
    getAccountProfileRecommendationsCallback: async ()=>({
            requestInProgress: true,
            data: undefined,
            error: undefined
        }),
    addMatureExampleProjectIdsCallback: async ()=>undefined
});
const $585017e4a8ab972d$export$a5989227294cd90a = ({ children: children })=>{
    const gupsClient = (0, $1oC0p.useMemo)(()=>new (0, $4Ois3.GrowthUnifiedProfileClient)(), []);
    const { accountId: accountId } = (0, $3riD8.useLoggedInUser)();
    const client = (0, $iSeHD.useAnalyticsClient)();
    const anonymousId = (0, $1oC0p.useMemo)(()=>client?.getAnonymousId() ?? undefined, [
        client
    ]);
    const teamTypeFromLocalStorage = (0, $17GU1.useAnchorLocalStorageTeamType)();
    const addTeamTypeCallback = (0, $1oC0p.useCallback)(async (selectedTeamType)=>{
        try {
            const gupsTeamType = $585017e4a8ab972d$export$644da7ba1500a73c(selectedTeamType);
            if (!gupsTeamType) return {
                error: {
                    message: `There is not a GUPS mapping for team type ${selectedTeamType}`
                }
            };
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    unifiedProfile: {
                        onboardingContext: {
                            jira: {
                                teamType: gupsTeamType
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error('Error updating user profile in GUPS', error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const getUserProfileJobFunctionCallback = (0, $1oC0p.useCallback)(async (useCase)=>{
        if (!accountId) return {
            requestInProgress: true,
            data: undefined,
            error: undefined
        };
        const { data: profile, error: error } = await gupsClient.getProfile({
            accountId: accountId
        }, [
            (0, $2hTwF.OptionalFields).USER_PROFILE_JOB_FUNCTION
        ], useCase);
        return {
            requestInProgress: false,
            data: profile?.userProfile,
            error: error
        };
    }, [
        gupsClient,
        accountId
    ]);
    const getFullProfileCallback = (0, $1oC0p.useCallback)(async ()=>{
        const { data: profile, error: error } = await gupsClient.getProfile({
            accountId: accountId
        }, [
            (0, $2hTwF.OptionalFields).USER_PROFILE,
            (0, $2hTwF.OptionalFields).USER_FOOTPRINTS,
            (0, $2hTwF.OptionalFields).SITES,
            (0, $2hTwF.OptionalFields).ONBOARDING_CONTEXT
        ]);
        return {
            data: profile,
            error: error
        };
    }, [
        gupsClient,
        accountId
    ]);
    const addJtbdCallback = (0, $1oC0p.useCallback)(async (jtbd, template)=>{
        try {
            const gupsJtbd = $585017e4a8ab972d$export$a1f86f8a748f57da(jtbd);
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    unifiedProfile: {
                        onboardingContext: {
                            jira: {
                                jobsToBeDone: gupsJtbd,
                                template: template
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error('Error updating user profile in GUPS', error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const addTemplateCallback = (0, $1oC0p.useCallback)(async (template)=>{
        try {
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    unifiedProfile: {
                        onboardingContext: {
                            jira: {
                                template: template
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error('Error updating user profile in GUPS', error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const addTenantIdCallback = (0, $1oC0p.useCallback)(async (tenantId)=>{
        try {
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    tenantId: tenantId,
                    unifiedProfile: {}
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error('Error updating user profile in GUPS', error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId
    ]);
    const getProfileCallback = (0, $1oC0p.useCallback)(async (abortSignal)=>{
        try {
            const { data: profile, error: error } = await gupsClient.getProfile({
                anonymousId: anonymousId
            }, [
                (0, $2hTwF.OptionalFields).PAID_CHANNEL_CONTEXT
            ], undefined, // optionalHeaderUseCase
            abortSignal);
            return {
                data: profile,
                error: error
            };
        } catch (error) {
            // Don't log AbortErrors as they're expected when requests are cancelled
            if (error instanceof Error && error.name !== 'AbortError') console.error('Error getting GUPS profile', error);
            return {
                error: error
            };
        }
    }, [
        anonymousId,
        gupsClient
    ]);
    const getProfileSitesCallback = (0, $1oC0p.useCallback)(async (accountId)=>{
        try {
            const { data: profile, error: error } = await gupsClient.getProfile({
                accountId: accountId
            }, [
                (0, $2hTwF.OptionalFields).SITES
            ]);
            return {
                data: profile,
                error: error
            };
        } catch (error) {
            console.error('Error getting profile sites GUPS', error);
            return {
                error: error
            };
        }
    }, [
        gupsClient
    ]);
    const linkAccountToAnonymousIdCallback = (0, $1oC0p.useCallback)(async ()=>{
        try {
            if (accountId && anonymousId) {
                const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                    profile: {
                        accountId: accountId,
                        anonymousId: anonymousId,
                        unifiedProfile: {}
                    }
                });
                return {
                    updatedProfile: updatedProfile,
                    error: error
                };
            } else {
                console.info(`Account ID or Anonymous ID is missing, ${accountId} ${anonymousId}`);
                return;
            }
        } catch (error) {
            console.error('Error updating user profile in GUPS', error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const getAnonProfileSitesCallback = (0, $1oC0p.useCallback)(async (anonymousId, useCase)=>{
        try {
            const { data: profile, error: error } = await gupsClient.getProfile({
                anonymousId: anonymousId
            }, [
                (0, $2hTwF.OptionalFields).SITES
            ], useCase);
            return {
                data: profile,
                error: error
            };
        } catch (error) {
            console.error('Error getting profile sites GUPS', error);
            return {
                error: error
            };
        }
    }, [
        gupsClient
    ]);
    const addTemplateCardCallback = (0, $1oC0p.useCallback)(async (templateId)=>{
        try {
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    unifiedProfile: {
                        onboardingContext: {
                            confluence: {
                                template: templateId
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const getAccountProfileRecommendationsCallback = (0, $1oC0p.useCallback)(async (accountId, useCase)=>{
        if (!accountId) return {
            requestInProgress: true,
            data: undefined,
            error: undefined
        };
        try {
            const { data: profile, error: error } = await gupsClient.getAccountProfile({
                accountId: accountId
            }, [
                (0, $2hTwF.AccountProfileOptionalFields).RECOMMENDATIONS
            ], useCase);
            return {
                requestInProgress: false,
                data: profile?.recommendations,
                error: error
            };
        } catch (error) {
            console.error('Error getting account profile recommendations GUPS', error);
            return {
                requestInProgress: false,
                data: undefined,
                error: error
            };
        }
    }, [
        gupsClient
    ]);
    const addMatureExampleProjectIdsCallback = (0, $1oC0p.useCallback)(async (matureExampleProjectIds, tenantId)=>{
        try {
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    tenantId: tenantId,
                    unifiedProfile: {
                        onboardingContext: {
                            jira: {
                                matureExampleProjectIds: matureExampleProjectIds ?? []
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error('Error updating user profile in GUPS', error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (teamTypeFromLocalStorage) addTeamTypeCallback(teamTypeFromLocalStorage);
    }, [
        teamTypeFromLocalStorage,
        addTeamTypeCallback
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($585017e4a8ab972d$var$GupsContext.Provider, {
        value: {
            addTeamTypeCallback: addTeamTypeCallback,
            getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback,
            getAccountProfileRecommendationsCallback: getAccountProfileRecommendationsCallback,
            getFullProfileCallback: getFullProfileCallback,
            addJtbdCallback: addJtbdCallback,
            addTemplateCallback: addTemplateCallback,
            getProfileSitesCallback: getProfileSitesCallback,
            addTenantIdCallback: addTenantIdCallback,
            linkAccountToAnonymousIdCallback: linkAccountToAnonymousIdCallback,
            addTemplateCardCallback: addTemplateCardCallback,
            getProfileCallback: getProfileCallback,
            getAnonProfileSitesCallback: getAnonProfileSitesCallback,
            addMatureExampleProjectIdsCallback: addMatureExampleProjectIdsCallback
        },
        children: children
    });
};
const $585017e4a8ab972d$export$f25f416c3b92de8 = ({ mockResponse: mockResponse, children: children })=>{
    const addTeamTypeCallback = async ()=>undefined;
    const getUserProfileJobFunctionCallback = async ()=>({
            requestInProgress: true,
            data: undefined,
            error: undefined
        });
    const getFullProfileCallback = async ()=>({
            data: undefined,
            error: undefined
        });
    const addJtbdCallback = async ()=>undefined;
    const addTemplateCallback = async ()=>undefined;
    const addTenantIdCallback = async ()=>undefined;
    const getProfileSitesCallback = async ()=>undefined;
    const linkAccountToAnonymousIdCallback = async ()=>undefined;
    const addTemplateCardCallback = async ()=>undefined;
    const getProfileCallback = async ()=>undefined;
    const getAnonProfileSitesCallback = async ()=>{
        return Promise.resolve(mockResponse);
    };
    const getAccountProfileRecommendationsCallback = async ()=>({
            requestInProgress: true,
            data: undefined,
            error: undefined
        });
    const addMatureExampleProjectIdsCallback = async ()=>undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($585017e4a8ab972d$var$GupsContext.Provider, {
        value: {
            addTeamTypeCallback: addTeamTypeCallback,
            getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback,
            getFullProfileCallback: getFullProfileCallback,
            addJtbdCallback: addJtbdCallback,
            addTemplateCallback: addTemplateCallback,
            getProfileSitesCallback: getProfileSitesCallback,
            addTenantIdCallback: addTenantIdCallback,
            linkAccountToAnonymousIdCallback: linkAccountToAnonymousIdCallback,
            addTemplateCardCallback: addTemplateCardCallback,
            getProfileCallback: getProfileCallback,
            getAnonProfileSitesCallback: getAnonProfileSitesCallback,
            getAccountProfileRecommendationsCallback: getAccountProfileRecommendationsCallback,
            addMatureExampleProjectIdsCallback: addMatureExampleProjectIdsCallback
        },
        children: children
    });
};

});
parcelRegister("4Ois3", function(module, exports) {
$parcel$export(module.exports, "GrowthUnifiedProfileClient", function () { return $921e51580074e3c0$export$d1ae200e149aadbf; });

var $1dWiR = parcelRequire("1dWiR");

var $1dWiR = parcelRequire("1dWiR");

var $7bBPn = parcelRequire("7bBPn");

var $j4gco = parcelRequire("j4gco");

var $kLCJm = parcelRequire("kLCJm");

var $1HuKf = parcelRequire("1HuKf");

var $bXKtm = parcelRequire("bXKtm");

var $e7nCy = parcelRequire("e7nCy");

var $F18pk = parcelRequire("F18pk");

var $5ihJe = parcelRequire("5ihJe");

var $fp45j = parcelRequire("fp45j");

var $2hTwF = parcelRequire("2hTwF");
// Helper to check if error is an AbortError
const $921e51580074e3c0$var$isAbortError = (error)=>{
    // Check direct Error instances
    if (error instanceof Error && (error.name === 'AbortError' || error.message?.includes('aborted'))) return true;
    // Check for urql CombinedError with wrapped networkError
    if (error && typeof error === 'object' && 'networkError' in error && error.networkError instanceof Error) {
        const networkError = error.networkError;
        return networkError.name === 'AbortError' || networkError.message?.includes('aborted') || networkError.message?.includes('The user aborted a request');
    }
    return false;
};
class $921e51580074e3c0$export$d1ae200e149aadbf {
    constructor(options){
        /**
   * Get a unified profile
   * @param accountId
   * @returns { data, error }
   */ // eslint-disable-next-line complexity
        this.getProfile = async (args, optionalFields, optionalHeaderUseCase, abortSignal)=>{
            const { accountId: accountId, anonymousId: anonymousId, tenantId: tenantId } = args;
            const fragments = this.constructProfileQuery(optionalFields);
            const GET_PROFILE_QUERY = (0, $1dWiR.gql)`
            query getUnifiedProfile($accountId: ID, $tenantId: ID, $anonymousId: ID) {
                growthUnifiedProfile_getUnifiedProfile(
                    accountId: $accountId
                    tenantId: $tenantId
                    anonymousId: $anonymousId
                ) {
                    ${fragments}
                }
            }
            ${optionalFields?.includes((0, $2hTwF.OptionalFields).ONBOARDING_CONTEXT) ? (0, $kLCJm.OnboardingContextFragment) : ''}
            ${optionalFields?.includes((0, $2hTwF.OptionalFields).SITES) ? (0, $e7nCy.SitesFragment) : ''}
            ${optionalFields?.includes((0, $2hTwF.OptionalFields).PAID_CHANNEL_CONTEXT) ? (0, $1HuKf.PaidChannelContextFragment) : ''}
            ${optionalFields?.includes((0, $2hTwF.OptionalFields).USER_FOOTPRINTS) ? (0, $F18pk.UserFootprintsFragment) : ''}
            ${optionalFields?.includes((0, $2hTwF.OptionalFields).USER_PROFILE) ? (0, $5ihJe.UserProfileFragment) : ''}
            ${optionalFields?.includes((0, $2hTwF.OptionalFields).USER_PROFILE_JOB_FUNCTION) ? (0, $fp45j.UserProfileJobFunctionFragment) : ''}
        `;
            const fetchContext = this.buildFetchContext(optionalHeaderUseCase, abortSignal);
            try {
                const { data: data, error: error } = await this.client.query(GET_PROFILE_QUERY, {
                    accountId: accountId,
                    tenantId: tenantId,
                    anonymousId: anonymousId
                }, {
                    fetchOptions: fetchContext
                });
                return {
                    data: data?.growthUnifiedProfile_getUnifiedProfile,
                    error: error
                };
            } catch (error) {
                // Re-throw AbortErrors as they're expected when requests are cancelled
                if ($921e51580074e3c0$var$isAbortError(error)) throw error;
                return {
                    data: undefined,
                    error: error
                };
            }
        };
        /**
   * Create or update a unified profile
   * @param profile
   * @returns { data, error }
   */ this.updateProfile = async ({ profile: profile, abortSignal: abortSignal })=>{
            // Currently accountId is required, once anonymousId support
            // is added to the upstream service, this check can be removed
            if (!profile.accountId) throw new Error('accountId is required');
            const UPDATE_PROFILE_MUTATION = (0, $1dWiR.gql)`
			mutation createUnifiedProfile($profile: GrowthUnifiedProfileCreateProfileInput!) {
				growthUnifiedProfile_createUnifiedProfile(profile: $profile) {
					...OnboardingContextFragment
				}
			}
			${(0, $kLCJm.OnboardingContextFragment)}
		`;
            try {
                const { data: data, error: error } = await this.client.mutation(UPDATE_PROFILE_MUTATION, {
                    profile: profile
                }, {
                    fetchOptions: abortSignal ? {
                        signal: abortSignal
                    } : undefined
                });
                return {
                    data: data?.growthUnifiedProfile_createUnifiedProfile,
                    error: error
                };
            } catch (error) {
                // Re-throw AbortErrors as they're expected when requests are cancelled
                if ($921e51580074e3c0$var$isAbortError(error)) throw error;
                return {
                    data: undefined,
                    error: error
                };
            }
        };
        /**
   * Get an account profile
   * @param args - Account profile arguments including accountId and optional PFU filter
   * @param optionalFields - Optional fields to query (USER_PROFILE, PAID_FEATURE_USAGE, RECOMMENDATIONS)
   * @param optionalHeaderUseCase - Optional header use case
   * @param abortSignal - Optional AbortSignal to cancel the request
   * @returns { data, error }
   * @note If PAID_FEATURE_USAGE is requested but pfuFilter is not provided, a default filter (90 days) will be used.
   *       The GraphQL schema requires a filter for paidFeatureUsage queries.
   */ this.getAccountProfile = async (args, optionalFields, optionalHeaderUseCase, abortSignal)=>{
            const { accountId: accountId, pfuFilter: pfuFilter } = args;
            const fragments = this.constructAccountProfileQuery(optionalFields);
            if (!fragments) return {
                data: undefined,
                error: new Error('At least one optional field must be specified: USER_PROFILE, PAID_FEATURE_USAGE, or RECOMMENDATIONS')
            };
            const includePfuFilter = this.hasAccountProfileField((0, $2hTwF.AccountProfileOptionalFields).PAID_FEATURE_USAGE, optionalFields);
            const filterToUse = this.resolvePFUFilter(optionalFields, pfuFilter);
            const variables = includePfuFilter ? {
                accountId: accountId,
                pfuFilter: filterToUse
            } : {
                accountId: accountId
            };
            try {
                const { data: data, error: error } = await this.client.query(this.buildGetAccountProfileQuery(fragments, includePfuFilter, optionalFields), variables, {
                    fetchOptions: this.buildFetchContext(optionalHeaderUseCase, abortSignal)
                });
                return {
                    data: data?.growthUnifiedProfile_getAccountProfile,
                    error: error
                };
            } catch (error) {
                if ($921e51580074e3c0$var$isAbortError(error)) throw error;
                return {
                    data: undefined,
                    error: error
                };
            }
        };
        this.fetchOptions = options?.slauthToken ? {
            headers: {
                Authorization: `SLAUTH ${options.slauthToken || ''}`
            }
        } : {
            credentials: 'include'
        };
        this.client = new (0, $1dWiR.Client)({
            url: (0, $7bBPn.GATEWAY_URL),
            exchanges: [
                (0, $1dWiR.cacheExchange),
                (0, $1dWiR.fetchExchange)
            ],
            fetchOptions: this.fetchOptions
        });
    }
    constructProfileQuery(optionalFields) {
        const fragments = [
            optionalFields?.includes((0, $2hTwF.OptionalFields).ONBOARDING_CONTEXT) ? '...OnboardingContextFragment' : '',
            optionalFields?.includes((0, $2hTwF.OptionalFields).SITES) ? '...SitesFragment' : '',
            optionalFields?.includes((0, $2hTwF.OptionalFields).PAID_CHANNEL_CONTEXT) ? '...PaidChannelContextFragment' : '',
            optionalFields?.includes((0, $2hTwF.OptionalFields).USER_FOOTPRINTS) ? '...UserFootprintsFragment' : '',
            optionalFields?.includes((0, $2hTwF.OptionalFields).USER_PROFILE) ? '...UserProfileFragment' : '',
            optionalFields?.includes((0, $2hTwF.OptionalFields).USER_PROFILE_JOB_FUNCTION) ? '...UserProfileJobFunctionFragment' : ''
        ].filter(Boolean).join('\n');
        // If no optional fields are provided, default to onboarding context
        return fragments || '...OnboardingContextFragment';
    }
    constructAccountProfileQuery(optionalFields) {
        const fragments = [
            this.hasAccountProfileField((0, $2hTwF.AccountProfileOptionalFields).USER_PROFILE, optionalFields) ? '...AccountUserProfileFragment' : '',
            this.hasAccountProfileField((0, $2hTwF.AccountProfileOptionalFields).PAID_FEATURE_USAGE, optionalFields) ? `paidFeatureUsage(filter: $pfuFilter) {
                    featureType
                    featureName
                    featureSupportedEdition
                    usageSummary {
                        tenants {
                            tenantId
                            tenantType
                        }
                        products
                        entitlementIds
                        featureEngagementLevel
                        usageCount
                    }
                }` : '',
            this.hasAccountProfileField((0, $2hTwF.AccountProfileOptionalFields).RECOMMENDATIONS, optionalFields) ? '...RecommendationsFragment' : ''
        ].filter(Boolean).join('\n');
        return fragments;
    }
    getDefaultPFUFilter() {
        const defaultStartDate = new Date(Date.now() - 7776000000).toISOString().split('T')[0]; // 90 days ago in YYYY-MM-DD format
        return {
            startDate: defaultStartDate
        };
    }
    resolvePFUFilter(optionalFields, pfuFilter) {
        const needsPFUFilter = optionalFields?.includes((0, $2hTwF.AccountProfileOptionalFields).PAID_FEATURE_USAGE) && !pfuFilter;
        if (needsPFUFilter) return this.getDefaultPFUFilter();
        return pfuFilter || null;
    }
    hasAccountProfileField(field, optionalFields) {
        return optionalFields?.includes(field) ?? false;
    }
    buildFetchContext(optionalHeaderUseCase, abortSignal) {
        return {
            ...this.fetchOptions,
            headers: {
                ...this.fetchOptions?.headers || {},
                ...optionalHeaderUseCase ? {
                    'x-use-case': optionalHeaderUseCase
                } : {}
            },
            ...abortSignal ? {
                signal: abortSignal
            } : {}
        };
    }
    buildGetAccountProfileQuery(fragments, includePfuFilter, optionalFields) {
        return (0, $1dWiR.gql)`
            query getAccountProfile(
                $accountId: ID!
                ${includePfuFilter ? '$pfuFilter: GrowthUnifiedProfilePFUFilter' : ''}
            ) {
                growthUnifiedProfile_getAccountProfile(accountId: $accountId) {
                    ${fragments}
                }
            }
            ${this.hasAccountProfileField((0, $2hTwF.AccountProfileOptionalFields).USER_PROFILE, optionalFields) ? (0, $j4gco.AccountUserProfileFragment) : ''}
            ${this.hasAccountProfileField((0, $2hTwF.AccountProfileOptionalFields).RECOMMENDATIONS, optionalFields) ? (0, $bXKtm.RecommendationsFragment) : ''}
        `;
    }
}

});
parcelRegister("1dWiR", function(module, exports) {
$parcel$export(module.exports, "gql", function () { return $0e443b2a5f7b8d9a$export$72e4926bf8358653; });
$parcel$export(module.exports, "cacheExchange", function () { return $0e443b2a5f7b8d9a$export$de01951d82452cab; });
$parcel$export(module.exports, "fetchExchange", function () { return $0e443b2a5f7b8d9a$export$7fed09527e654bc9; });
$parcel$export(module.exports, "Client", function () { return $0e443b2a5f7b8d9a$export$1f2bb630327ac4b6; });

var $5ugyf = parcelRequire("5ugyf");

var $lpb2P = parcelRequire("lpb2P");

var $8gORH = parcelRequire("8gORH");
var $0e443b2a5f7b8d9a$var$collectTypes = (e, r)=>{
    if (Array.isArray(e)) for (var t of e)$0e443b2a5f7b8d9a$var$collectTypes(t, r);
    else if ("object" == typeof e && null !== e) {
        for(var n in e)if ("__typename" === n && "string" == typeof e[n]) r.add(e[n]);
        else $0e443b2a5f7b8d9a$var$collectTypes(e[n], r);
    }
    return r;
};
var $0e443b2a5f7b8d9a$var$formatNode = (r)=>{
    if ("definitions" in r) {
        var t = [];
        for (var n of r.definitions){
            var a = $0e443b2a5f7b8d9a$var$formatNode(n);
            t.push(a);
        }
        return {
            ...r,
            definitions: t
        };
    }
    if ("directives" in r && r.directives && r.directives.length) {
        var o = [];
        var i = {};
        for (var s of r.directives){
            var c = s.name.value;
            if ("_" !== c[0]) o.push(s);
            else c = c.slice(1);
            i[c] = s;
        }
        r = {
            ...r,
            directives: o,
            _directives: i
        };
    }
    if ("selectionSet" in r) {
        var u = [];
        var p = r.kind === (0, $5ugyf.Kind).OPERATION_DEFINITION;
        if (r.selectionSet) {
            for (var d of r.selectionSet.selections || []){
                p = p || d.kind === (0, $5ugyf.Kind).FIELD && "__typename" === d.name.value && !d.alias;
                var v = $0e443b2a5f7b8d9a$var$formatNode(d);
                u.push(v);
            }
            if (!p) u.push({
                kind: (0, $5ugyf.Kind).FIELD,
                name: {
                    kind: (0, $5ugyf.Kind).NAME,
                    value: "__typename"
                },
                _generated: !0
            });
            return {
                ...r,
                selectionSet: {
                    ...r.selectionSet,
                    selections: u
                }
            };
        }
    }
    return r;
};
var $0e443b2a5f7b8d9a$var$I = new Map;
var $0e443b2a5f7b8d9a$export$4d94eb8deda64786 = (e)=>{
    var t = (0, $lpb2P.k)(e);
    var n = $0e443b2a5f7b8d9a$var$I.get(t.__key);
    if (!n) {
        $0e443b2a5f7b8d9a$var$I.set(t.__key, n = $0e443b2a5f7b8d9a$var$formatNode(t));
        Object.defineProperty(n, "__key", {
            value: t.__key,
            enumerable: !1
        });
    }
    return n;
};
function $0e443b2a5f7b8d9a$var$withPromise(e) {
    var source$ = (r)=>e(r);
    source$.toPromise = ()=>(0, $8gORH.toPromise)((0, $8gORH.take)(1)((0, $8gORH.filter)((e)=>!e.stale && !e.hasNext)(source$)));
    source$.then = (e, r)=>source$.toPromise().then(e, r);
    source$.subscribe = (e)=>(0, $8gORH.subscribe)(e)(source$);
    return source$;
}
function $0e443b2a5f7b8d9a$export$dac456ae68957b8f(e, r, t) {
    return {
        ...r,
        kind: e,
        context: r.context ? {
            ...r.context,
            ...t
        } : t || r.context
    };
}
var $0e443b2a5f7b8d9a$var$addMetadata = (e, r)=>$0e443b2a5f7b8d9a$export$dac456ae68957b8f(e.kind, e, {
        meta: {
            ...e.context.meta,
            ...r
        }
    });
var $0e443b2a5f7b8d9a$var$noop = ()=>{};
function $0e443b2a5f7b8d9a$export$72e4926bf8358653(n) {
    var a = new Map;
    var o = [];
    var i = [];
    var s = Array.isArray(n) ? n[0] : n || "";
    for(var c = 1; c < arguments.length; c++){
        var u = arguments[c];
        if (u && u.definitions) i.push(u);
        else s += u;
        s += arguments[0][c];
    }
    i.unshift((0, $lpb2P.k)(s));
    for (var p of i){
        for (var d of p.definitions)if (d.kind === (0, $5ugyf.Kind).FRAGMENT_DEFINITION) {
            var v = d.name.value;
            var f = (0, $lpb2P.s)(d);
            if (!a.has(v)) {
                a.set(v, f);
                o.push(d);
            }
        } else o.push(d);
    }
    return (0, $lpb2P.k)({
        kind: (0, $5ugyf.Kind).DOCUMENT,
        definitions: o
    });
}
var $0e443b2a5f7b8d9a$var$shouldSkip = ({ kind: e })=>"mutation" !== e && "query" !== e;
var $0e443b2a5f7b8d9a$var$mapTypeNames = (e)=>{
    var r = $0e443b2a5f7b8d9a$export$4d94eb8deda64786(e.query);
    if (r !== e.query) {
        var t = $0e443b2a5f7b8d9a$export$dac456ae68957b8f(e.kind, e);
        t.query = r;
        return t;
    } else return e;
};
var $0e443b2a5f7b8d9a$export$de01951d82452cab = ({ forward: e, client: r, dispatchDebug: t })=>{
    var a = new Map;
    var o = new Map;
    var isOperationCached = (e)=>"query" === e.kind && "network-only" !== e.context.requestPolicy && ("cache-only" === e.context.requestPolicy || a.has(e.key));
    return (i)=>{
        var s = (0, $8gORH.map)((e)=>{
            var o = a.get(e.key);
            var i = o || (0, $lpb2P.m)(e, {
                data: null
            });
            i = {
                ...i,
                operation: e
            };
            if ("cache-and-network" === e.context.requestPolicy) {
                i.stale = !0;
                $0e443b2a5f7b8d9a$var$reexecuteOperation(r, e);
            }
            return i;
        })((0, $8gORH.filter)((e)=>!$0e443b2a5f7b8d9a$var$shouldSkip(e) && isOperationCached(e))(i));
        var c = (0, $8gORH.tap)((e)=>{
            var { operation: n } = e;
            if (!n) return;
            var i = n.context.additionalTypenames || [];
            if ("subscription" !== e.operation.kind) i = ((e)=>[
                    ...$0e443b2a5f7b8d9a$var$collectTypes(e, new Set)
                ])(e.data).concat(i);
            if ("mutation" === e.operation.kind || "subscription" === e.operation.kind) {
                var s = new Set;
                for(var c = 0; c < i.length; c++){
                    var u = i[c];
                    var p = o.get(u);
                    if (!p) o.set(u, p = new Set);
                    for (var d of p.values())s.add(d);
                    p.clear();
                }
                for (var v of s.values())if (a.has(v)) {
                    n = a.get(v).operation;
                    a.delete(v);
                    $0e443b2a5f7b8d9a$var$reexecuteOperation(r, n);
                }
            } else if ("query" === n.kind && e.data) {
                a.set(n.key, e);
                for(var f = 0; f < i.length; f++){
                    var l = i[f];
                    var h = o.get(l);
                    if (!h) o.set(l, h = new Set);
                    h.add(n.key);
                }
            }
        })(e((0, $8gORH.filter)((e)=>"query" !== e.kind || "cache-only" !== e.context.requestPolicy)((0, $8gORH.map)((e)=>e)((0, $8gORH.merge)([
            (0, $8gORH.map)($0e443b2a5f7b8d9a$var$mapTypeNames)((0, $8gORH.filter)((e)=>!$0e443b2a5f7b8d9a$var$shouldSkip(e) && !isOperationCached(e))(i)),
            (0, $8gORH.filter)((e)=>$0e443b2a5f7b8d9a$var$shouldSkip(e))(i)
        ])))));
        return (0, $8gORH.merge)([
            s,
            c
        ]);
    };
};
var $0e443b2a5f7b8d9a$var$reexecuteOperation = (e, r)=>e.reexecuteOperation($0e443b2a5f7b8d9a$export$dac456ae68957b8f(r.kind, r, {
        requestPolicy: "network-only"
    }));
var $0e443b2a5f7b8d9a$var$T = new Set;
var $0e443b2a5f7b8d9a$export$5487dac036b20ecc = (e = {})=>{
    var r = !!e.staleWhileRevalidate;
    var t = !!e.includeExtensions;
    var n = {};
    var o = [];
    var invalidate = (e)=>{
        o.push(e.operation.key);
        if (1 === o.length) Promise.resolve().then(()=>{
            var e;
            while(e = o.shift())n[e] = null;
        });
    };
    var ssr = ({ client: o, forward: i })=>(s)=>{
            var c = e && "boolean" == typeof e.isClient ? !!e.isClient : !o.suspense;
            var u = i((0, $8gORH.map)($0e443b2a5f7b8d9a$var$mapTypeNames)((0, $8gORH.filter)((e)=>"teardown" === e.kind || !n[e.key] || !!n[e.key].hasNext || "network-only" === e.context.requestPolicy)(s)));
            var p = (0, $8gORH.map)((e)=>{
                var i = ((e, r, t)=>({
                        operation: e,
                        data: r.data ? JSON.parse(r.data) : void 0,
                        extensions: t && r.extensions ? JSON.parse(r.extensions) : void 0,
                        error: r.error ? new (0, $lpb2P.C)({
                            networkError: r.error.networkError ? new Error(r.error.networkError) : void 0,
                            graphQLErrors: r.error.graphQLErrors
                        }) : void 0,
                        stale: !1,
                        hasNext: !!r.hasNext
                    }))(e, n[e.key], t);
                if (r && !$0e443b2a5f7b8d9a$var$T.has(e.key)) {
                    i.stale = !0;
                    $0e443b2a5f7b8d9a$var$T.add(e.key);
                    $0e443b2a5f7b8d9a$var$reexecuteOperation(o, e);
                }
                return {
                    ...i,
                    operation: e
                };
            })((0, $8gORH.filter)((e)=>"teardown" !== e.kind && !!n[e.key] && "network-only" !== e.context.requestPolicy)(s));
            if (!c) u = (0, $8gORH.tap)((e)=>{
                var { operation: r } = e;
                if ("mutation" !== r.kind) {
                    var a = ((e, r)=>{
                        var t = {
                            data: JSON.stringify(e.data),
                            hasNext: e.hasNext
                        };
                        if (void 0 !== e.data) t.data = JSON.stringify(e.data);
                        if (r && void 0 !== e.extensions) t.extensions = JSON.stringify(e.extensions);
                        if (e.error) {
                            t.error = {
                                graphQLErrors: e.error.graphQLErrors.map((e)=>{
                                    if (!e.path && !e.extensions) return e.message;
                                    return {
                                        message: e.message,
                                        path: e.path,
                                        extensions: e.extensions
                                    };
                                })
                            };
                            if (e.error.networkError) t.error.networkError = "" + e.error.networkError;
                        }
                        return t;
                    })(e, t);
                    n[r.key] = a;
                }
            })(u);
            else p = (0, $8gORH.tap)(invalidate)(p);
            return (0, $8gORH.merge)([
                u,
                p
            ]);
        };
    ssr.restoreData = (e)=>{
        for(var r in e)if (null !== n[r]) n[r] = e[r];
    };
    ssr.extractData = ()=>{
        var e = {};
        for(var r in n)if (null != n[r]) e[r] = n[r];
        return e;
    };
    if (e && e.initialState) ssr.restoreData(e.initialState);
    return ssr;
};
var $0e443b2a5f7b8d9a$export$d2bda267fe4a032e = ({ forwardSubscription: e, enableAllOperations: r, isSubscriptionOperation: t })=>({ client: a, forward: i })=>{
        var u = t || ((e)=>"subscription" === e.kind || !!r && ("query" === e.kind || "mutation" === e.kind));
        return (r)=>{
            var t = (0, $8gORH.mergeMap)((t)=>{
                var { key: i } = t;
                var u = (0, $8gORH.filter)((e)=>"teardown" === e.kind && e.key === i)(r);
                return (0, $8gORH.takeUntil)(u)(((r)=>{
                    var t = e((0, $lpb2P.a)(r), r);
                    return (0, $8gORH.make)((e)=>{
                        var o = !1;
                        var i;
                        var u;
                        function nextResult(t) {
                            e.next(u = u ? (0, $lpb2P.c)(u, t) : (0, $lpb2P.m)(r, t));
                        }
                        Promise.resolve().then(()=>{
                            if (o) return;
                            i = t.subscribe({
                                next: nextResult,
                                error (t) {
                                    if (Array.isArray(t)) nextResult({
                                        errors: t
                                    });
                                    else e.next((0, $lpb2P.b)(r, t));
                                    e.complete();
                                },
                                complete () {
                                    if (!o) {
                                        o = !0;
                                        if ("subscription" === r.kind) a.reexecuteOperation($0e443b2a5f7b8d9a$export$dac456ae68957b8f("teardown", r, r.context));
                                        if (u && u.hasNext) nextResult({
                                            hasNext: !1
                                        });
                                        e.complete();
                                    }
                                }
                            });
                        });
                        return ()=>{
                            o = !0;
                            if (i) i.unsubscribe();
                        };
                    });
                })(t));
            })((0, $8gORH.filter)((e)=>"teardown" !== e.kind && u(e))(r));
            var p = i((0, $8gORH.filter)((e)=>"teardown" === e.kind || !u(e))(r));
            return (0, $8gORH.merge)([
                t,
                p
            ]);
        };
    };
var $0e443b2a5f7b8d9a$export$f088b66ceb324131 = ({ forward: e })=>{
    return (r)=>e(r);
};
var $0e443b2a5f7b8d9a$export$7fed09527e654bc9 = ({ forward: e, dispatchDebug: r })=>(t)=>{
        var n = (0, $8gORH.mergeMap)((e)=>{
            var n = (0, $lpb2P.a)(e);
            var a = (0, $lpb2P.d)(e, n);
            var i = (0, $lpb2P.e)(e, n);
            var s = (0, $8gORH.takeUntil)((0, $8gORH.filter)((r)=>"teardown" === r.kind && r.key === e.key)(t))((0, $lpb2P.f)(e, a, i));
            return s;
        })((0, $8gORH.filter)((e)=>"teardown" !== e.kind && ("subscription" !== e.kind || !!e.context.fetchSubscriptions))(t));
        var a = e((0, $8gORH.filter)((e)=>"teardown" === e.kind || "subscription" === e.kind && !e.context.fetchSubscriptions)(t));
        return (0, $8gORH.merge)([
            n,
            a
        ]);
    };
var $0e443b2a5f7b8d9a$export$1e79974f5647c6ed = (e)=>({ client: r, forward: t, dispatchDebug: n })=>e.reduceRight((e, t)=>{
            var a = !1;
            return t({
                client: r,
                forward (r) {
                    return (0, $8gORH.share)(e((0, $8gORH.share)(r)));
                },
                dispatchDebug (e) {}
            });
        }, t);
var $0e443b2a5f7b8d9a$export$454d06fa782923cb = ({ onOperation: e, onResult: r, onError: t })=>({ forward: n })=>(a)=>(0, $8gORH.mergeMap)((e)=>{
                if (t && e.error) t(e.error, e.operation);
                var n = r && r(e) || e;
                return "then" in n ? (0, $8gORH.fromPromise)(n) : (0, $8gORH.fromValue)(n);
            })(n((0, $8gORH.mergeMap)((r)=>{
                var t = e && e(r) || r;
                return "then" in t ? (0, $8gORH.fromPromise)(t) : (0, $8gORH.fromValue)(t);
            })(a)));
var $0e443b2a5f7b8d9a$var$fallbackExchange = ({ dispatchDebug: e })=>(r)=>{
        return (0, $8gORH.filter)((e)=>!1)(r);
    };
var $0e443b2a5f7b8d9a$export$1f2bb630327ac4b6 = function Client(e) {
    var r = 0;
    var t = new Map;
    var n = new Map;
    var a = new Set;
    var o = [];
    var i = {
        url: e.url,
        fetchSubscriptions: e.fetchSubscriptions,
        fetchOptions: e.fetchOptions,
        fetch: e.fetch,
        preferGetMethod: e.preferGetMethod,
        requestPolicy: e.requestPolicy || "cache-first"
    };
    var s = (0, $8gORH.makeSubject)();
    function nextOperation(e) {
        if ("mutation" === e.kind || "teardown" === e.kind || !a.has(e.key)) {
            if ("teardown" === e.kind) a.delete(e.key);
            else if ("mutation" !== e.kind) a.add(e.key);
            s.next(e);
        }
    }
    var c = !1;
    function dispatchOperation(e) {
        if (e) nextOperation(e);
        if (!c) {
            c = !0;
            while(c && (e = o.shift()))nextOperation(e);
            c = !1;
        }
    }
    var makeResultSource = (e)=>{
        var r = (0, $8gORH.takeUntil)((0, $8gORH.filter)((r)=>"teardown" === r.kind && r.key === e.key)(s.source))((0, $8gORH.filter)((r)=>r.operation.kind === e.kind && r.operation.key === e.key && (!r.operation.context._instance || r.operation.context._instance === e.context._instance))(O));
        if ("query" !== e.kind) r = (0, $8gORH.takeWhile)((e)=>!!e.hasNext, !0)(r);
        else r = (0, $8gORH.switchMap)((r)=>{
            var t = (0, $8gORH.fromValue)(r);
            return r.stale || r.hasNext ? t : (0, $8gORH.merge)([
                t,
                (0, $8gORH.map)(()=>{
                    r.stale = !0;
                    return r;
                })((0, $8gORH.take)(1)((0, $8gORH.filter)((r)=>r.key === e.key)(s.source)))
            ]);
        })(r);
        if ("mutation" !== e.kind) r = (0, $8gORH.onEnd)(()=>{
            a.delete(e.key);
            t.delete(e.key);
            n.delete(e.key);
            c = !1;
            for(var r = o.length - 1; r >= 0; r--)if (o[r].key === e.key) o.splice(r, 1);
            nextOperation($0e443b2a5f7b8d9a$export$dac456ae68957b8f("teardown", e, e.context));
        })((0, $8gORH.onPush)((r)=>{
            if (r.stale) {
                for (var n of o)if (n.key === r.operation.key) {
                    a.delete(n.key);
                    break;
                }
            } else if (!r.hasNext) a.delete(e.key);
            t.set(e.key, r);
        })(r));
        else r = (0, $8gORH.onStart)(()=>{
            nextOperation(e);
        })(r);
        return (0, $8gORH.share)(r);
    };
    var u = this instanceof Client ? this : Object.create(Client.prototype);
    var p = Object.assign(u, {
        suspense: !!e.suspense,
        operations$: s.source,
        reexecuteOperation (e) {
            if ("teardown" === e.kind) dispatchOperation(e);
            else if ("mutation" === e.kind || n.has(e.key)) {
                var r = !1;
                for(var t = 0; t < o.length; t++)r = r || o[t].key === e.key;
                if (!r) a.delete(e.key);
                o.push(e);
                Promise.resolve().then(dispatchOperation);
            }
        },
        createRequestOperation (e, t, n) {
            if (!n) n = {};
            var a;
            return $0e443b2a5f7b8d9a$export$dac456ae68957b8f(e, t, {
                _instance: "mutation" === e ? r = r + 1 | 0 : void 0,
                ...i,
                ...n,
                requestPolicy: n.requestPolicy || i.requestPolicy,
                suspense: n.suspense || !1 !== n.suspense && p.suspense
            });
        },
        executeRequestOperation (e) {
            if ("mutation" === e.kind) return $0e443b2a5f7b8d9a$var$withPromise(makeResultSource(e));
            return $0e443b2a5f7b8d9a$var$withPromise((0, $8gORH.lazy)(()=>{
                var r = n.get(e.key);
                if (!r) n.set(e.key, r = makeResultSource(e));
                r = (0, $8gORH.onStart)(()=>{
                    dispatchOperation(e);
                })(r);
                var a = t.get(e.key);
                if ("query" === e.kind && a && (a.stale || a.hasNext)) return (0, $8gORH.switchMap)((0, $8gORH.fromValue))((0, $8gORH.merge)([
                    r,
                    (0, $8gORH.filter)((r)=>r === t.get(e.key))((0, $8gORH.fromValue)(a))
                ]));
                else return r;
            }));
        },
        executeQuery (e, r) {
            var t = p.createRequestOperation("query", e, r);
            return p.executeRequestOperation(t);
        },
        executeSubscription (e, r) {
            var t = p.createRequestOperation("subscription", e, r);
            return p.executeRequestOperation(t);
        },
        executeMutation (e, r) {
            var t = p.createRequestOperation("mutation", e, r);
            return p.executeRequestOperation(t);
        },
        readQuery (e, r, t) {
            var n = null;
            (0, $8gORH.subscribe)((e)=>{
                n = e;
            })(p.query(e, r, t)).unsubscribe();
            return n;
        },
        query: (e, r, t)=>p.executeQuery((0, $lpb2P.h)(e, r), t),
        subscription: (e, r, t)=>p.executeSubscription((0, $lpb2P.h)(e, r), t),
        mutation: (e, r, t)=>p.executeMutation((0, $lpb2P.h)(e, r), t)
    });
    var d = $0e443b2a5f7b8d9a$var$noop;
    var l, x;
    var w = $0e443b2a5f7b8d9a$export$1e79974f5647c6ed(e.exchanges);
    var O = (0, $8gORH.share)(w({
        client: p,
        dispatchDebug: d,
        forward: $0e443b2a5f7b8d9a$var$fallbackExchange({
            dispatchDebug: d
        })
    })(s.source));
    (0, $8gORH.publish)(O);
    return p;
};
var $0e443b2a5f7b8d9a$export$5d730b7aed1a3eb0 = $0e443b2a5f7b8d9a$export$1f2bb630327ac4b6;

});
parcelRegister("5ugyf", function(module, exports) {
$parcel$export(module.exports, "Kind", function () { return $3fec97db91769700$export$a84bdc57c5122798; });
$parcel$export(module.exports, "GraphQLError", function () { return $3fec97db91769700$export$92d6ed0888e7cb7f; });
$parcel$export(module.exports, "parse", function () { return $3fec97db91769700$export$98e6a39c04603d36; });
$parcel$export(module.exports, "print", function () { return $3fec97db91769700$export$c2d084dc44961371; });
var $3fec97db91769700$export$a84bdc57c5122798 = {
    NAME: "Name",
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    DIRECTIVE: "Directive",
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType"
};
var $3fec97db91769700$export$f58c50edb4aef9d4 = {
    QUERY: "query",
    MUTATION: "mutation",
    SUBSCRIPTION: "subscription"
};
class $3fec97db91769700$export$92d6ed0888e7cb7f extends Error {
    constructor(e, r, i, n, a, t, l){
        super(e);
        this.name = "GraphQLError";
        this.message = e;
        if (a) this.path = a;
        if (r) this.nodes = Array.isArray(r) ? r : [
            r
        ];
        if (i) this.source = i;
        if (n) this.positions = n;
        if (t) this.originalError = t;
        var o = l;
        if (!o && t) {
            var u = t.extensions;
            if (u && "object" == typeof u) o = u;
        }
        this.extensions = o || {};
    }
    toJSON() {
        return {
            ...this,
            message: this.message
        };
    }
    toString() {
        return this.message;
    }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
}
var $3fec97db91769700$var$i;
var $3fec97db91769700$var$n;
function $3fec97db91769700$var$error(e) {
    return new $3fec97db91769700$export$92d6ed0888e7cb7f(`Syntax Error: Unexpected token at ${$3fec97db91769700$var$n} in ${e}`);
}
function $3fec97db91769700$var$advance(e) {
    e.lastIndex = $3fec97db91769700$var$n;
    if (e.test($3fec97db91769700$var$i)) return $3fec97db91769700$var$i.slice($3fec97db91769700$var$n, $3fec97db91769700$var$n = e.lastIndex);
}
var $3fec97db91769700$var$a = / +(?=[^\s])/y;
function $3fec97db91769700$var$blockString(e) {
    var r = e.split("\n");
    var i = "";
    var n = 0;
    var t = 0;
    var l = r.length - 1;
    for(var o = 0; o < r.length; o++){
        $3fec97db91769700$var$a.lastIndex = 0;
        if ($3fec97db91769700$var$a.test(r[o])) {
            if (o && (!n || $3fec97db91769700$var$a.lastIndex < n)) n = $3fec97db91769700$var$a.lastIndex;
            t = t || o;
            l = o;
        }
    }
    for(var u = t; u <= l; u++){
        if (u !== t) i += "\n";
        i += r[u].slice(n).replace(/\\"""/g, '"""');
    }
    return i;
}
function $3fec97db91769700$var$ignored() {
    for(var e = 0 | $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++); 9 === e || 10 === e || 13 === e || 32 === e || 35 === e || 44 === e || 65279 === e; e = 0 | $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++))if (35 === e) {
        while(10 !== (e = $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++)) && 13 !== e);
    }
    $3fec97db91769700$var$n--;
}
var $3fec97db91769700$var$t = /[_A-Za-z]\w*/y;
var $3fec97db91769700$var$l = new RegExp("(?:(null|true|false)|\\$(" + $3fec97db91769700$var$t.source + ')|(-?\\d+)((?:\\.\\d+)?[eE][+-]?\\d+|\\.\\d+)?|("""(?:"""|(?:[\\s\\S]*?[^\\\\])"""))|("(?:"|[^\\r\\n]*?[^\\\\]"))|(' + $3fec97db91769700$var$t.source + "))", "y");
var $3fec97db91769700$var$o = function(e) {
    e[e.Const = 1] = "Const";
    e[e.Var = 2] = "Var";
    e[e.Int = 3] = "Int";
    e[e.Float = 4] = "Float";
    e[e.BlockString = 5] = "BlockString";
    e[e.String = 6] = "String";
    e[e.Enum = 7] = "Enum";
    return e;
}($3fec97db91769700$var$o || {});
var $3fec97db91769700$var$u = /\\/g;
function $3fec97db91769700$var$value(e) {
    var r;
    var a;
    $3fec97db91769700$var$l.lastIndex = $3fec97db91769700$var$n;
    if (91 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
        $3fec97db91769700$var$n++;
        $3fec97db91769700$var$ignored();
        var d = [];
        while(93 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n))d.push($3fec97db91769700$var$value(e));
        $3fec97db91769700$var$n++;
        $3fec97db91769700$var$ignored();
        return {
            kind: "ListValue",
            values: d
        };
    } else if (123 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
        $3fec97db91769700$var$n++;
        $3fec97db91769700$var$ignored();
        var v = [];
        while(125 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)){
            if (null == (r = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("ObjectField");
            $3fec97db91769700$var$ignored();
            if (58 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++)) throw $3fec97db91769700$var$error("ObjectField");
            $3fec97db91769700$var$ignored();
            v.push({
                kind: "ObjectField",
                name: {
                    kind: "Name",
                    value: r
                },
                value: $3fec97db91769700$var$value(e)
            });
        }
        $3fec97db91769700$var$n++;
        $3fec97db91769700$var$ignored();
        return {
            kind: "ObjectValue",
            fields: v
        };
    } else if (null != (a = $3fec97db91769700$var$l.exec($3fec97db91769700$var$i))) {
        $3fec97db91769700$var$n = $3fec97db91769700$var$l.lastIndex;
        $3fec97db91769700$var$ignored();
        if (null != (r = a[$3fec97db91769700$var$o.Const])) return "null" === r ? {
            kind: "NullValue"
        } : {
            kind: "BooleanValue",
            value: "true" === r
        };
        else if (null != (r = a[$3fec97db91769700$var$o.Var])) {
            if (e) throw $3fec97db91769700$var$error("Variable");
            else return {
                kind: "Variable",
                name: {
                    kind: "Name",
                    value: r
                }
            };
        } else if (null != (r = a[$3fec97db91769700$var$o.Int])) {
            var s;
            if (null != (s = a[$3fec97db91769700$var$o.Float])) return {
                kind: "FloatValue",
                value: r + s
            };
            else return {
                kind: "IntValue",
                value: r
            };
        } else if (null != (r = a[$3fec97db91769700$var$o.BlockString])) return {
            kind: "StringValue",
            value: $3fec97db91769700$var$blockString(r.slice(3, -3)),
            block: !0
        };
        else if (null != (r = a[$3fec97db91769700$var$o.String])) return {
            kind: "StringValue",
            value: $3fec97db91769700$var$u.test(r) ? JSON.parse(r) : r.slice(1, -1),
            block: !1
        };
        else if (null != (r = a[$3fec97db91769700$var$o.Enum])) return {
            kind: "EnumValue",
            value: r
        };
    }
    throw $3fec97db91769700$var$error("Value");
}
function $3fec97db91769700$var$arguments_(e) {
    if (40 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
        var r = [];
        $3fec97db91769700$var$n++;
        $3fec97db91769700$var$ignored();
        var a;
        do {
            if (null == (a = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("Argument");
            $3fec97db91769700$var$ignored();
            if (58 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++)) throw $3fec97db91769700$var$error("Argument");
            $3fec97db91769700$var$ignored();
            r.push({
                kind: "Argument",
                name: {
                    kind: "Name",
                    value: a
                },
                value: $3fec97db91769700$var$value(e)
            });
        }while (41 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n));
        $3fec97db91769700$var$n++;
        $3fec97db91769700$var$ignored();
        return r;
    }
}
function $3fec97db91769700$var$directives(e) {
    if (64 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
        var r = [];
        var a;
        do {
            $3fec97db91769700$var$n++;
            if (null == (a = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("Directive");
            $3fec97db91769700$var$ignored();
            r.push({
                kind: "Directive",
                name: {
                    kind: "Name",
                    value: a
                },
                arguments: $3fec97db91769700$var$arguments_(e)
            });
        }while (64 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n));
        return r;
    }
}
function $3fec97db91769700$var$type() {
    var e;
    var r = 0;
    while(91 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)){
        r++;
        $3fec97db91769700$var$n++;
        $3fec97db91769700$var$ignored();
    }
    if (null == (e = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("NamedType");
    $3fec97db91769700$var$ignored();
    var a = {
        kind: "NamedType",
        name: {
            kind: "Name",
            value: e
        }
    };
    do {
        if (33 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
            $3fec97db91769700$var$n++;
            $3fec97db91769700$var$ignored();
            a = {
                kind: "NonNullType",
                type: a
            };
        }
        if (r) {
            if (93 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++)) throw $3fec97db91769700$var$error("NamedType");
            $3fec97db91769700$var$ignored();
            a = {
                kind: "ListType",
                type: a
            };
        }
    }while (r--);
    return a;
}
var $3fec97db91769700$var$d = new RegExp("(?:(\\.{3})|(" + $3fec97db91769700$var$t.source + "))", "y");
var $3fec97db91769700$var$v = function(e) {
    e[e.Spread = 1] = "Spread";
    e[e.Name = 2] = "Name";
    return e;
}($3fec97db91769700$var$v || {});
function $3fec97db91769700$var$selectionSet() {
    var e = [];
    var r;
    var a;
    do {
        $3fec97db91769700$var$d.lastIndex = $3fec97db91769700$var$n;
        if (null != (a = $3fec97db91769700$var$d.exec($3fec97db91769700$var$i))) {
            $3fec97db91769700$var$n = $3fec97db91769700$var$d.lastIndex;
            if (null != a[$3fec97db91769700$var$v.Spread]) {
                $3fec97db91769700$var$ignored();
                var l = $3fec97db91769700$var$advance($3fec97db91769700$var$t);
                if (null != l && "on" !== l) {
                    $3fec97db91769700$var$ignored();
                    e.push({
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: l
                        },
                        directives: $3fec97db91769700$var$directives(!1)
                    });
                } else {
                    $3fec97db91769700$var$ignored();
                    if ("on" === l) {
                        if (null == (l = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("NamedType");
                        $3fec97db91769700$var$ignored();
                    }
                    var o = $3fec97db91769700$var$directives(!1);
                    if (123 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++)) throw $3fec97db91769700$var$error("InlineFragment");
                    $3fec97db91769700$var$ignored();
                    e.push({
                        kind: "InlineFragment",
                        typeCondition: l ? {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: l
                            }
                        } : void 0,
                        directives: o,
                        selectionSet: $3fec97db91769700$var$selectionSet()
                    });
                }
            } else if (null != (r = a[$3fec97db91769700$var$v.Name])) {
                var u = void 0;
                $3fec97db91769700$var$ignored();
                if (58 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
                    $3fec97db91769700$var$n++;
                    $3fec97db91769700$var$ignored();
                    u = r;
                    if (null == (r = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("Field");
                    $3fec97db91769700$var$ignored();
                }
                var s = $3fec97db91769700$var$arguments_(!1);
                $3fec97db91769700$var$ignored();
                var c = $3fec97db91769700$var$directives(!1);
                var f = void 0;
                if (123 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
                    $3fec97db91769700$var$n++;
                    $3fec97db91769700$var$ignored();
                    f = $3fec97db91769700$var$selectionSet();
                }
                e.push({
                    kind: "Field",
                    alias: u ? {
                        kind: "Name",
                        value: u
                    } : void 0,
                    name: {
                        kind: "Name",
                        value: r
                    },
                    arguments: s,
                    directives: c,
                    selectionSet: f
                });
            }
        } else throw $3fec97db91769700$var$error("SelectionSet");
    }while (125 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n));
    $3fec97db91769700$var$n++;
    $3fec97db91769700$var$ignored();
    return {
        kind: "SelectionSet",
        selections: e
    };
}
function $3fec97db91769700$var$fragmentDefinition() {
    var e;
    var r;
    if (null == (e = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("FragmentDefinition");
    $3fec97db91769700$var$ignored();
    if ("on" !== $3fec97db91769700$var$advance($3fec97db91769700$var$t)) throw $3fec97db91769700$var$error("FragmentDefinition");
    $3fec97db91769700$var$ignored();
    if (null == (r = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("FragmentDefinition");
    $3fec97db91769700$var$ignored();
    var a = $3fec97db91769700$var$directives(!1);
    if (123 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++)) throw $3fec97db91769700$var$error("FragmentDefinition");
    $3fec97db91769700$var$ignored();
    return {
        kind: "FragmentDefinition",
        name: {
            kind: "Name",
            value: e
        },
        typeCondition: {
            kind: "NamedType",
            name: {
                kind: "Name",
                value: r
            }
        },
        directives: a,
        selectionSet: $3fec97db91769700$var$selectionSet()
    };
}
var $3fec97db91769700$var$s = /(?:query|mutation|subscription|fragment)/y;
function $3fec97db91769700$var$operationDefinition(e) {
    var r;
    var a;
    var l;
    if (e) {
        $3fec97db91769700$var$ignored();
        r = $3fec97db91769700$var$advance($3fec97db91769700$var$t);
        a = function variableDefinitions() {
            $3fec97db91769700$var$ignored();
            if (40 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
                var e = [];
                $3fec97db91769700$var$n++;
                $3fec97db91769700$var$ignored();
                var r;
                do {
                    if (36 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++)) throw $3fec97db91769700$var$error("Variable");
                    if (null == (r = $3fec97db91769700$var$advance($3fec97db91769700$var$t))) throw $3fec97db91769700$var$error("Variable");
                    $3fec97db91769700$var$ignored();
                    if (58 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n++)) throw $3fec97db91769700$var$error("VariableDefinition");
                    $3fec97db91769700$var$ignored();
                    var a = $3fec97db91769700$var$type();
                    var l = void 0;
                    if (61 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
                        $3fec97db91769700$var$n++;
                        $3fec97db91769700$var$ignored();
                        l = $3fec97db91769700$var$value(!0);
                    }
                    $3fec97db91769700$var$ignored();
                    e.push({
                        kind: "VariableDefinition",
                        variable: {
                            kind: "Variable",
                            name: {
                                kind: "Name",
                                value: r
                            }
                        },
                        type: a,
                        defaultValue: l,
                        directives: $3fec97db91769700$var$directives(!0)
                    });
                }while (41 !== $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n));
                $3fec97db91769700$var$n++;
                $3fec97db91769700$var$ignored();
                return e;
            }
        }();
        l = $3fec97db91769700$var$directives(!1);
    }
    if (123 === $3fec97db91769700$var$i.charCodeAt($3fec97db91769700$var$n)) {
        $3fec97db91769700$var$n++;
        $3fec97db91769700$var$ignored();
        return {
            kind: "OperationDefinition",
            operation: e || "query",
            name: r ? {
                kind: "Name",
                value: r
            } : void 0,
            variableDefinitions: a,
            directives: l,
            selectionSet: $3fec97db91769700$var$selectionSet()
        };
    }
}
function $3fec97db91769700$export$98e6a39c04603d36(e, r) {
    $3fec97db91769700$var$i = "string" == typeof e.body ? e.body : e;
    $3fec97db91769700$var$n = 0;
    return function document() {
        var e;
        var r;
        $3fec97db91769700$var$ignored();
        var a = [];
        do {
            if ("fragment" === (e = $3fec97db91769700$var$advance($3fec97db91769700$var$s))) {
                $3fec97db91769700$var$ignored();
                a.push($3fec97db91769700$var$fragmentDefinition());
            } else if (null != (r = $3fec97db91769700$var$operationDefinition(e))) a.push(r);
            else throw $3fec97db91769700$var$error("Document");
        }while ($3fec97db91769700$var$n < $3fec97db91769700$var$i.length);
        return {
            kind: "Document",
            definitions: a
        };
    }();
}
function $3fec97db91769700$export$5303528d1070ff6f(e, r) {
    $3fec97db91769700$var$i = "string" == typeof e.body ? e.body : e;
    $3fec97db91769700$var$n = 0;
    $3fec97db91769700$var$ignored();
    return $3fec97db91769700$var$value(!1);
}
function $3fec97db91769700$export$28b8f402ccc88182(e, r) {
    $3fec97db91769700$var$i = "string" == typeof e.body ? e.body : e;
    $3fec97db91769700$var$n = 0;
    return $3fec97db91769700$var$type();
}
var $3fec97db91769700$export$a89c95c098ac2a58 = {};
function $3fec97db91769700$export$bf638b60ea8b89b7(e, r) {
    var i = [];
    var n = [];
    try {
        var a = function traverse(e, a, t) {
            var l = !1;
            var o = r[e.kind] && r[e.kind].enter || r[e.kind] || r.enter;
            var u = o && o.call(r, e, a, t, n, i);
            if (!1 === u) return e;
            else if (null === u) return null;
            else if (u === $3fec97db91769700$export$a89c95c098ac2a58) throw $3fec97db91769700$export$a89c95c098ac2a58;
            else if (u && "string" == typeof u.kind) {
                l = u !== e;
                e = u;
            }
            if (t) i.push(t);
            var d;
            var v = {
                ...e
            };
            for(var s in e){
                n.push(s);
                var f = e[s];
                if (Array.isArray(f)) {
                    var m = [];
                    for(var g = 0; g < f.length; g++)if (null != f[g] && "string" == typeof f[g].kind) {
                        i.push(e);
                        n.push(g);
                        d = traverse(f[g], g, f);
                        n.pop();
                        i.pop();
                        if (null == d) l = !0;
                        else {
                            l = l || d !== f[g];
                            m.push(d);
                        }
                    }
                    f = m;
                } else if (null != f && "string" == typeof f.kind) {
                    if (void 0 !== (d = traverse(f, s, e))) {
                        l = l || f !== d;
                        f = d;
                    }
                }
                n.pop();
                if (l) v[s] = f;
            }
            if (t) i.pop();
            var p = r[e.kind] && r[e.kind].leave || r.leave;
            var h = p && p.call(r, e, a, t, n, i);
            if (h === $3fec97db91769700$export$a89c95c098ac2a58) throw $3fec97db91769700$export$a89c95c098ac2a58;
            else if (void 0 !== h) return h;
            else if (void 0 !== u) return l ? v : u;
            else return l ? v : e;
        }(e);
        return void 0 !== a && !1 !== a ? a : e;
    } catch (r) {
        if (r !== $3fec97db91769700$export$a89c95c098ac2a58) throw r;
        return e;
    }
}
function $3fec97db91769700$var$mapJoin(e, r, i) {
    var n = "";
    for(var a = 0; a < e.length; a++){
        if (a) n += r;
        n += i(e[a]);
    }
    return n;
}
function $3fec97db91769700$export$3cdec7cf614a0ecc(e) {
    return JSON.stringify(e);
}
function $3fec97db91769700$export$adb6ca997eeb1f45(e) {
    return '"""\n' + e.replace(/"""/g, '\\"""') + '\n"""';
}
var $3fec97db91769700$var$f = "\n";
var $3fec97db91769700$var$m = {
    OperationDefinition (e) {
        var r = e.operation;
        if (e.name) r += " " + e.name.value;
        if (e.variableDefinitions && e.variableDefinitions.length) {
            if (!e.name) r += " ";
            r += "(" + $3fec97db91769700$var$mapJoin(e.variableDefinitions, ", ", $3fec97db91769700$var$m.VariableDefinition) + ")";
        }
        if (e.directives && e.directives.length) r += " " + $3fec97db91769700$var$mapJoin(e.directives, " ", $3fec97db91769700$var$m.Directive);
        return "query" !== r ? r + " " + $3fec97db91769700$var$m.SelectionSet(e.selectionSet) : $3fec97db91769700$var$m.SelectionSet(e.selectionSet);
    },
    VariableDefinition (e) {
        var r = $3fec97db91769700$var$m.Variable(e.variable) + ": " + $3fec97db91769700$var$_print(e.type);
        if (e.defaultValue) r += " = " + $3fec97db91769700$var$_print(e.defaultValue);
        if (e.directives && e.directives.length) r += " " + $3fec97db91769700$var$mapJoin(e.directives, " ", $3fec97db91769700$var$m.Directive);
        return r;
    },
    Field (e) {
        var r = e.alias ? e.alias.value + ": " + e.name.value : e.name.value;
        if (e.arguments && e.arguments.length) {
            var i = $3fec97db91769700$var$mapJoin(e.arguments, ", ", $3fec97db91769700$var$m.Argument);
            if (r.length + i.length + 2 > 80) r += "(" + ($3fec97db91769700$var$f += "  ") + $3fec97db91769700$var$mapJoin(e.arguments, $3fec97db91769700$var$f, $3fec97db91769700$var$m.Argument) + ($3fec97db91769700$var$f = $3fec97db91769700$var$f.slice(0, -2)) + ")";
            else r += "(" + i + ")";
        }
        if (e.directives && e.directives.length) r += " " + $3fec97db91769700$var$mapJoin(e.directives, " ", $3fec97db91769700$var$m.Directive);
        if (e.selectionSet) r += " " + $3fec97db91769700$var$m.SelectionSet(e.selectionSet);
        return r;
    },
    StringValue (e) {
        if (e.block) return $3fec97db91769700$export$adb6ca997eeb1f45(e.value).replace(/\n/g, $3fec97db91769700$var$f);
        else return $3fec97db91769700$export$3cdec7cf614a0ecc(e.value);
    },
    BooleanValue: (e)=>"" + e.value,
    NullValue: (e)=>"null",
    IntValue: (e)=>e.value,
    FloatValue: (e)=>e.value,
    EnumValue: (e)=>e.value,
    Name: (e)=>e.value,
    Variable: (e)=>"$" + e.name.value,
    ListValue: (e)=>"[" + $3fec97db91769700$var$mapJoin(e.values, ", ", $3fec97db91769700$var$_print) + "]",
    ObjectValue: (e)=>"{" + $3fec97db91769700$var$mapJoin(e.fields, ", ", $3fec97db91769700$var$m.ObjectField) + "}",
    ObjectField: (e)=>e.name.value + ": " + $3fec97db91769700$var$_print(e.value),
    Document (e) {
        if (!e.definitions || !e.definitions.length) return "";
        return $3fec97db91769700$var$mapJoin(e.definitions, "\n\n", $3fec97db91769700$var$_print);
    },
    SelectionSet: (e)=>"{" + ($3fec97db91769700$var$f += "  ") + $3fec97db91769700$var$mapJoin(e.selections, $3fec97db91769700$var$f, $3fec97db91769700$var$_print) + ($3fec97db91769700$var$f = $3fec97db91769700$var$f.slice(0, -2)) + "}",
    Argument: (e)=>e.name.value + ": " + $3fec97db91769700$var$_print(e.value),
    FragmentSpread (e) {
        var r = "..." + e.name.value;
        if (e.directives && e.directives.length) r += " " + $3fec97db91769700$var$mapJoin(e.directives, " ", $3fec97db91769700$var$m.Directive);
        return r;
    },
    InlineFragment (e) {
        var r = "...";
        if (e.typeCondition) r += " on " + e.typeCondition.name.value;
        if (e.directives && e.directives.length) r += " " + $3fec97db91769700$var$mapJoin(e.directives, " ", $3fec97db91769700$var$m.Directive);
        return r += " " + $3fec97db91769700$var$m.SelectionSet(e.selectionSet);
    },
    FragmentDefinition (e) {
        var r = "fragment " + e.name.value;
        r += " on " + e.typeCondition.name.value;
        if (e.directives && e.directives.length) r += " " + $3fec97db91769700$var$mapJoin(e.directives, " ", $3fec97db91769700$var$m.Directive);
        return r + " " + $3fec97db91769700$var$m.SelectionSet(e.selectionSet);
    },
    Directive (e) {
        var r = "@" + e.name.value;
        if (e.arguments && e.arguments.length) r += "(" + $3fec97db91769700$var$mapJoin(e.arguments, ", ", $3fec97db91769700$var$m.Argument) + ")";
        return r;
    },
    NamedType: (e)=>e.name.value,
    ListType: (e)=>"[" + $3fec97db91769700$var$_print(e.type) + "]",
    NonNullType: (e)=>$3fec97db91769700$var$_print(e.type) + "!"
};
var $3fec97db91769700$var$_print = (e)=>$3fec97db91769700$var$m[e.kind](e);
function $3fec97db91769700$export$c2d084dc44961371(e) {
    $3fec97db91769700$var$f = "\n";
    return $3fec97db91769700$var$m[e.kind] ? $3fec97db91769700$var$m[e.kind](e) : "";
}
function $3fec97db91769700$export$448e0963aec9442f(e, r) {
    switch(e.kind){
        case "NullValue":
            return null;
        case "IntValue":
            return parseInt(e.value, 10);
        case "FloatValue":
            return parseFloat(e.value);
        case "StringValue":
        case "EnumValue":
        case "BooleanValue":
            return e.value;
        case "ListValue":
            var i = [];
            for (var n of e.values)i.push($3fec97db91769700$export$448e0963aec9442f(n, r));
            return i;
        case "ObjectValue":
            var a = Object.create(null);
            for (var t of e.fields)a[t.name.value] = $3fec97db91769700$export$448e0963aec9442f(t.value, r);
            return a;
        case "Variable":
            return r && r[e.name.value];
    }
}
function $3fec97db91769700$export$d7c3f1876e7bc864(e, r, i) {
    if ("Variable" === e.kind) return i ? $3fec97db91769700$export$d7c3f1876e7bc864(i[e.name.value], r, i) : void 0;
    else if ("NonNullType" === r.kind) return "NullValue" !== e.kind ? $3fec97db91769700$export$d7c3f1876e7bc864(e, r, i) : void 0;
    else if ("NullValue" === e.kind) return null;
    else if ("ListType" === r.kind) {
        if ("ListValue" === e.kind) {
            var n = [];
            for (var a of e.values){
                var t = $3fec97db91769700$export$d7c3f1876e7bc864(a, r.type, i);
                if (void 0 === t) return;
                else n.push(t);
            }
            return n;
        }
    } else if ("NamedType" === r.kind) switch(r.name.value){
        case "Int":
        case "Float":
        case "String":
        case "Bool":
            return r.name.value + "Value" === e.kind ? $3fec97db91769700$export$448e0963aec9442f(e, i) : void 0;
        default:
            return $3fec97db91769700$export$448e0963aec9442f(e, i);
    }
}

});

parcelRegister("lpb2P", function(module, exports) {
$parcel$export(module.exports, "C", function () { return $f9548002f5accd58$export$e7094788287c5e9b; });
$parcel$export(module.exports, "s", function () { return $f9548002f5accd58$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "k", function () { return $f9548002f5accd58$export$342063e11d6c3cad; });
$parcel$export(module.exports, "h", function () { return $f9548002f5accd58$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "m", function () { return $f9548002f5accd58$export$953cecd6e717a553; });
$parcel$export(module.exports, "c", function () { return $f9548002f5accd58$export$db3b6bfb95261072; });
$parcel$export(module.exports, "b", function () { return $f9548002f5accd58$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "a", function () { return $f9548002f5accd58$export$407448d2b89b1813; });
$parcel$export(module.exports, "d", function () { return $f9548002f5accd58$export$4368d992c4eafac0; });
$parcel$export(module.exports, "e", function () { return $f9548002f5accd58$export$f1e1789686576879; });
$parcel$export(module.exports, "f", function () { return $f9548002f5accd58$export$2d1720544b23b823; });

var $5ugyf = parcelRequire("5ugyf");

var $8gORH = parcelRequire("8gORH");
var $f9548002f5accd58$var$rehydrateGraphQlError = (r)=>{
    if (r && r.message && (r.extensions || "GraphQLError" === r.name)) return r;
    else if ("object" == typeof r && r.message) return new (0, $5ugyf.GraphQLError)(r.message, r.nodes, r.source, r.positions, r.path, r, r.extensions || {});
    else return new (0, $5ugyf.GraphQLError)(r);
};
class $f9548002f5accd58$export$e7094788287c5e9b extends Error {
    constructor(e){
        var r = (e.graphQLErrors || []).map($f9548002f5accd58$var$rehydrateGraphQlError);
        var t = ((e, r)=>{
            var t = "";
            if (e) return `[Network] ${e.message}`;
            if (r) for (var a of r){
                if (t) t += "\n";
                t += `[GraphQL] ${a.message}`;
            }
            return t;
        })(e.networkError, r);
        super(t);
        this.name = "CombinedError";
        this.message = t;
        this.graphQLErrors = r;
        this.networkError = e.networkError;
        this.response = e.response;
    }
    toString() {
        return this.message;
    }
}
var $f9548002f5accd58$var$phash = (e, r)=>{
    var t = 0 | (r || 5381);
    for(var a = 0, o = 0 | e.length; a < o; a++)t = (t << 5) + t + e.charCodeAt(a);
    return t;
};
var $f9548002f5accd58$var$i = new Set;
var $f9548002f5accd58$var$f = new WeakMap;
var $f9548002f5accd58$var$stringify = (e)=>{
    if (null === e || $f9548002f5accd58$var$i.has(e)) return "null";
    else if ("object" != typeof e) return JSON.stringify(e) || "";
    else if (e.toJSON) return $f9548002f5accd58$var$stringify(e.toJSON());
    else if (Array.isArray(e)) {
        var r = "[";
        for (var t of e){
            if (r.length > 1) r += ",";
            r += $f9548002f5accd58$var$stringify(t) || "null";
        }
        return r += "]";
    } else if ($f9548002f5accd58$var$l !== $f9548002f5accd58$var$NoopConstructor && e instanceof $f9548002f5accd58$var$l || $f9548002f5accd58$var$c !== $f9548002f5accd58$var$NoopConstructor && e instanceof $f9548002f5accd58$var$c) return "null";
    var a = Object.keys(e).sort();
    if (!a.length && e.constructor && Object.getPrototypeOf(e).constructor !== Object.prototype.constructor) {
        var o = $f9548002f5accd58$var$f.get(e) || Math.random().toString(36).slice(2);
        $f9548002f5accd58$var$f.set(e, o);
        return $f9548002f5accd58$var$stringify({
            __key: o
        });
    }
    $f9548002f5accd58$var$i.add(e);
    var n = "{";
    for (var s of a){
        var d = $f9548002f5accd58$var$stringify(e[s]);
        if (d) {
            if (n.length > 1) n += ",";
            n += $f9548002f5accd58$var$stringify(s) + ":" + d;
        }
    }
    $f9548002f5accd58$var$i.delete(e);
    return n += "}";
};
var $f9548002f5accd58$var$extract = (e, r, t)=>{
    if (null == t || "object" != typeof t || t.toJSON || $f9548002f5accd58$var$i.has(t)) ;
    else if (Array.isArray(t)) for(var a = 0, o = t.length; a < o; a++)$f9548002f5accd58$var$extract(e, `${r}.${a}`, t[a]);
    else if (t instanceof $f9548002f5accd58$var$l || t instanceof $f9548002f5accd58$var$c) e.set(r, t);
    else {
        $f9548002f5accd58$var$i.add(t);
        for (var n of Object.keys(t))$f9548002f5accd58$var$extract(e, `${r}.${n}`, t[n]);
    }
};
var $f9548002f5accd58$export$23f2a1d2818174ef = (e)=>{
    $f9548002f5accd58$var$i.clear();
    return $f9548002f5accd58$var$stringify(e);
};
class $f9548002f5accd58$var$NoopConstructor {
}
var $f9548002f5accd58$var$l = "undefined" != typeof File ? File : $f9548002f5accd58$var$NoopConstructor;
var $f9548002f5accd58$var$c = "undefined" != typeof Blob ? Blob : $f9548002f5accd58$var$NoopConstructor;
var $f9548002f5accd58$var$d = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;
var $f9548002f5accd58$var$v = /(?:#[^\n\r]+)?(?:[\r\n]+|$)/g;
var $f9548002f5accd58$var$replaceOutsideStrings = (e, r)=>r % 2 == 0 ? e.replace($f9548002f5accd58$var$v, "\n") : e;
var $f9548002f5accd58$var$sanitizeDocument = (e)=>e.split($f9548002f5accd58$var$d).map($f9548002f5accd58$var$replaceOutsideStrings).join("").trim();
var $f9548002f5accd58$var$p = new Map;
var $f9548002f5accd58$var$u = new Map;
var $f9548002f5accd58$export$2408f22a0fab9ae5 = (e)=>{
    var t;
    if ("string" == typeof e) t = $f9548002f5accd58$var$sanitizeDocument(e);
    else if (e.loc && $f9548002f5accd58$var$u.get(e.__key) === e) t = e.loc.source.body;
    else {
        t = $f9548002f5accd58$var$p.get(e) || $f9548002f5accd58$var$sanitizeDocument((0, $5ugyf.print)(e));
        $f9548002f5accd58$var$p.set(e, t);
    }
    if ("string" != typeof e && !e.loc) e.loc = {
        start: 0,
        end: t.length,
        source: {
            body: t,
            name: "gql",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    };
    return t;
};
var $f9548002f5accd58$var$hashDocument = (e)=>{
    var r = $f9548002f5accd58$var$phash($f9548002f5accd58$export$2408f22a0fab9ae5(e));
    if (e.definitions) {
        var t = $f9548002f5accd58$var$getOperationName(e);
        if (t) r = $f9548002f5accd58$var$phash(`\n# ${t}`, r);
    }
    return r;
};
var $f9548002f5accd58$export$342063e11d6c3cad = (e)=>{
    var r;
    var a;
    if ("string" == typeof e) {
        r = $f9548002f5accd58$var$hashDocument(e);
        a = $f9548002f5accd58$var$u.get(r) || (0, $5ugyf.parse)(e, {
            noLocation: !0
        });
    } else {
        r = e.__key || $f9548002f5accd58$var$hashDocument(e);
        a = $f9548002f5accd58$var$u.get(r) || e;
    }
    if (!a.loc) $f9548002f5accd58$export$2408f22a0fab9ae5(a);
    a.__key = r;
    $f9548002f5accd58$var$u.set(r, a);
    return a;
};
var $f9548002f5accd58$export$dda1d9f60106f0e9 = (e, r, t)=>{
    var a = r || {};
    var o = $f9548002f5accd58$export$342063e11d6c3cad(e);
    var n = $f9548002f5accd58$export$23f2a1d2818174ef(a);
    var s = o.__key;
    if ("{}" !== n) s = $f9548002f5accd58$var$phash(n, s);
    return {
        key: s,
        query: o,
        variables: a,
        extensions: t
    };
};
var $f9548002f5accd58$var$getOperationName = (e)=>{
    for (var r of e.definitions){
        if (r.kind === (0, $5ugyf.Kind).OPERATION_DEFINITION) return r.name ? r.name.value : void 0;
    }
};
var $f9548002f5accd58$export$39b482c5e57630a8 = (e)=>{
    for (var r of e.definitions){
        if (r.kind === (0, $5ugyf.Kind).OPERATION_DEFINITION) return r.operation;
    }
};
var $f9548002f5accd58$export$953cecd6e717a553 = (e, r, t)=>{
    if (!("data" in r || "errors" in r && Array.isArray(r.errors))) throw new Error("No Content");
    var a = "subscription" === e.kind;
    return {
        operation: e,
        data: r.data,
        error: Array.isArray(r.errors) ? new $f9548002f5accd58$export$e7094788287c5e9b({
            graphQLErrors: r.errors,
            response: t
        }) : void 0,
        extensions: r.extensions ? {
            ...r.extensions
        } : void 0,
        hasNext: null == r.hasNext ? a : r.hasNext,
        stale: !1
    };
};
var $f9548002f5accd58$var$deepMerge = (e, r)=>{
    if ("object" == typeof e && null != e) {
        if (!e.constructor || e.constructor === Object || Array.isArray(e)) {
            e = Array.isArray(e) ? [
                ...e
            ] : {
                ...e
            };
            for (var t of Object.keys(r))e[t] = $f9548002f5accd58$var$deepMerge(e[t], r[t]);
            return e;
        }
    }
    return r;
};
var $f9548002f5accd58$export$db3b6bfb95261072 = (e, r, t, a)=>{
    var o = e.error ? e.error.graphQLErrors : [];
    var n = !!e.extensions || !!(r.payload || r).extensions;
    var s = {
        ...e.extensions,
        ...(r.payload || r).extensions
    };
    var i = r.incremental;
    if ("path" in r) i = [
        r
    ];
    var f = {
        data: e.data
    };
    if (i) {
        var _loop = function(e) {
            if (Array.isArray(e.errors)) o.push(...e.errors);
            if (e.extensions) {
                Object.assign(s, e.extensions);
                n = !0;
            }
            var r = "data";
            var t = f;
            var i = [];
            if (e.path) i = e.path;
            else if (a) {
                var l = a.find((r)=>r.id === e.id);
                if (e.subPath) i = [
                    ...l.path,
                    ...e.subPath
                ];
                else i = l.path;
            }
            for(var c = 0, d = i.length; c < d; r = i[c++])t = t[r] = Array.isArray(t[r]) ? [
                ...t[r]
            ] : {
                ...t[r]
            };
            if (e.items) {
                var v = +r >= 0 ? r : 0;
                for(var p = 0, u = e.items.length; p < u; p++)t[v + p] = $f9548002f5accd58$var$deepMerge(t[v + p], e.items[p]);
            } else if (void 0 !== e.data) t[r] = $f9548002f5accd58$var$deepMerge(t[r], e.data);
        };
        for (var l of i)_loop(l);
    } else {
        f.data = (r.payload || r).data || e.data;
        o = r.errors || r.payload && r.payload.errors || o;
    }
    return {
        operation: e.operation,
        data: f.data,
        error: o.length ? new $f9548002f5accd58$export$e7094788287c5e9b({
            graphQLErrors: o,
            response: t
        }) : void 0,
        extensions: n ? s : void 0,
        hasNext: null != r.hasNext ? r.hasNext : e.hasNext,
        stale: !1
    };
};
var $f9548002f5accd58$export$8b22cf2602fb60ce = (e, r, t)=>({
        operation: e,
        data: void 0,
        error: new $f9548002f5accd58$export$e7094788287c5e9b({
            networkError: r,
            response: t
        }),
        extensions: void 0,
        hasNext: !1,
        stale: !1
    });
function $f9548002f5accd58$export$407448d2b89b1813(e) {
    var r = {
        query: void 0,
        documentId: void 0,
        operationName: $f9548002f5accd58$var$getOperationName(e.query),
        variables: e.variables || void 0,
        extensions: e.extensions
    };
    if ("documentId" in e.query && e.query.documentId && (!e.query.definitions || !e.query.definitions.length)) r.documentId = e.query.documentId;
    else if (!e.extensions || !e.extensions.persistedQuery || e.extensions.persistedQuery.miss) r.query = $f9548002f5accd58$export$2408f22a0fab9ae5(e.query);
    return r;
}
var $f9548002f5accd58$export$4368d992c4eafac0 = (e, r)=>{
    var t = "query" === e.kind && e.context.preferGetMethod;
    if (!t || !r) return e.context.url;
    var a = $f9548002f5accd58$var$splitOutSearchParams(e.context.url);
    for(var o in r){
        var n = r[o];
        if (n) a[1].set(o, "object" == typeof n ? $f9548002f5accd58$export$23f2a1d2818174ef(n) : n);
    }
    var s = a.join("?");
    if (s.length > 2047 && "force" !== t) {
        e.context.preferGetMethod = !1;
        return e.context.url;
    }
    return s;
};
var $f9548002f5accd58$var$splitOutSearchParams = (e)=>{
    var r = e.indexOf("?");
    return r > -1 ? [
        e.slice(0, r),
        new URLSearchParams(e.slice(r + 1))
    ] : [
        e,
        new URLSearchParams
    ];
};
var $f9548002f5accd58$var$serializeBody = (e, r)=>{
    if (r && !("query" === e.kind && !!e.context.preferGetMethod)) {
        var t = $f9548002f5accd58$export$23f2a1d2818174ef(r);
        var a = ((e)=>{
            var r = new Map;
            if ($f9548002f5accd58$var$l !== $f9548002f5accd58$var$NoopConstructor || $f9548002f5accd58$var$c !== $f9548002f5accd58$var$NoopConstructor) {
                $f9548002f5accd58$var$i.clear();
                $f9548002f5accd58$var$extract(r, "variables", e);
            }
            return r;
        })(r.variables);
        if (a.size) {
            var o = new FormData;
            o.append("operations", t);
            o.append("map", $f9548002f5accd58$export$23f2a1d2818174ef({
                ...[
                    ...a.keys()
                ].map((e)=>[
                        e
                    ])
            }));
            var n = 0;
            for (var s of a.values())o.append("" + n++, s);
            return o;
        }
        return t;
    }
};
var $f9548002f5accd58$export$f1e1789686576879 = (e, r)=>{
    var t = {
        accept: "subscription" === e.kind ? "text/event-stream, multipart/mixed" : "application/graphql-response+json, application/graphql+json, application/json, text/event-stream, multipart/mixed"
    };
    var a = ("function" == typeof e.context.fetchOptions ? e.context.fetchOptions() : e.context.fetchOptions) || {};
    if (a.headers) {
        if (((e)=>"has" in e && !Object.keys(e).length)(a.headers)) a.headers.forEach((e, r)=>{
            t[r] = e;
        });
        else if (Array.isArray(a.headers)) a.headers.forEach((e, r)=>{
            if (Array.isArray(e)) {
                if (t[e[0]]) t[e[0]] = `${t[e[0]]},${e[1]}`;
                else t[e[0]] = e[1];
            } else t[r] = e;
        });
        else for(var o in a.headers)t[o.toLowerCase()] = a.headers[o];
    }
    var n = $f9548002f5accd58$var$serializeBody(e, r);
    if ("string" == typeof n && !t["content-type"]) t["content-type"] = "application/json";
    return {
        ...a,
        method: n ? "POST" : "GET",
        body: n,
        headers: t
    };
};
var $f9548002f5accd58$var$y = "undefined" != typeof TextDecoder ? new TextDecoder : null;
var $f9548002f5accd58$var$h = /boundary="?([^=";]+)"?/i;
var $f9548002f5accd58$var$m = /data: ?([^\n]+)/;
var $f9548002f5accd58$var$toString = (e)=>"Buffer" === e.constructor.name ? e.toString() : $f9548002f5accd58$var$y.decode(e);
async function* $f9548002f5accd58$var$streamBody(e) {
    if (e.body[Symbol.asyncIterator]) for await (var r of e.body)yield $f9548002f5accd58$var$toString(r);
    else {
        var t = e.body.getReader();
        var a;
        try {
            while(!(a = await t.read()).done)yield $f9548002f5accd58$var$toString(a.value);
        } finally{
            t.cancel();
        }
    }
}
async function* $f9548002f5accd58$var$split(e, r) {
    var t = "";
    var a;
    for await (var o of e){
        t += o;
        while((a = t.indexOf(r)) > -1){
            yield t.slice(0, a);
            t = t.slice(a + r.length);
        }
    }
}
async function* $f9548002f5accd58$var$fetchOperation(e, r, t) {
    var a = !0;
    var o = null;
    var n;
    try {
        yield await Promise.resolve();
        var s = (n = await (e.context.fetch || fetch)(r, t)).headers.get("Content-Type") || "";
        var i;
        if (/multipart\/mixed/i.test(s)) i = async function* parseMultipartMixed(e, r) {
            var t = e.match($f9548002f5accd58$var$h);
            var a = "--" + (t ? t[1] : "-");
            var o = !0;
            var n;
            for await (var s of $f9548002f5accd58$var$split($f9548002f5accd58$var$streamBody(r), "\r\n" + a)){
                if (o) {
                    o = !1;
                    var i = s.indexOf(a);
                    if (i > -1) s = s.slice(i + a.length);
                    else continue;
                }
                try {
                    yield n = JSON.parse(s.slice(s.indexOf("\r\n\r\n") + 4));
                } catch (e) {
                    if (!n) throw e;
                }
                if (n && !1 === n.hasNext) break;
            }
            if (n && !1 !== n.hasNext) yield {
                hasNext: !1
            };
        }(s, n);
        else if (/text\/event-stream/i.test(s)) i = async function* parseEventStream(e) {
            var r;
            for await (var t of $f9548002f5accd58$var$split($f9548002f5accd58$var$streamBody(e), "\n\n")){
                var a = t.match($f9548002f5accd58$var$m);
                if (a) {
                    var o = a[1];
                    try {
                        yield r = JSON.parse(o);
                    } catch (e) {
                        if (!r) throw e;
                    }
                    if (r && !1 === r.hasNext) break;
                }
            }
            if (r && !1 !== r.hasNext) yield {
                hasNext: !1
            };
        }(n);
        else if (!/text\//i.test(s)) i = async function* parseJSON(e) {
            yield JSON.parse(await e.text());
        }(n);
        else i = async function* parseMaybeJSON(e) {
            var r = await e.text();
            try {
                var t = JSON.parse(r);
                yield t;
            } catch (e) {
                throw new Error(r);
            }
        }(n);
        var f;
        for await (var l of i){
            if (l.pending && !o) f = l.pending;
            else if (l.pending) f = [
                ...f,
                ...l.pending
            ];
            o = o ? $f9548002f5accd58$export$db3b6bfb95261072(o, l, n, f) : $f9548002f5accd58$export$953cecd6e717a553(e, l, n);
            a = !1;
            yield o;
            a = !0;
        }
        if (!o) yield o = $f9548002f5accd58$export$953cecd6e717a553(e, {}, n);
    } catch (r) {
        if (!a) throw r;
        yield $f9548002f5accd58$export$8b22cf2602fb60ce(e, n && (n.status < 200 || n.status >= 300) && n.statusText ? new Error(n.statusText) : r, n);
    }
}
function $f9548002f5accd58$export$2d1720544b23b823(e, r, t) {
    var a;
    if ("undefined" != typeof AbortController) t.signal = (a = new AbortController).signal;
    return (0, $8gORH.onEnd)(()=>{
        if (a) a.abort();
    })((0, $8gORH.filter)((e)=>!!e)((0, $8gORH.fromAsyncIterable)($f9548002f5accd58$var$fetchOperation(e, r, t))));
}

});
parcelRegister("8gORH", function(module, exports) {
$parcel$export(module.exports, "filter", function () { return $6057461cdef2c7a9$export$3dea766d36a8935f; });
$parcel$export(module.exports, "map", function () { return $6057461cdef2c7a9$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mergeMap", function () { return $6057461cdef2c7a9$export$6b9f6c0d32c093f9; });
$parcel$export(module.exports, "merge", function () { return $6057461cdef2c7a9$export$4950aa0f605343fb; });
$parcel$export(module.exports, "onEnd", function () { return $6057461cdef2c7a9$export$db4d2a4aed77becf; });
$parcel$export(module.exports, "onPush", function () { return $6057461cdef2c7a9$export$fff70a13d53402ec; });
$parcel$export(module.exports, "onStart", function () { return $6057461cdef2c7a9$export$aaa2d21dd8862419; });
$parcel$export(module.exports, "share", function () { return $6057461cdef2c7a9$export$ed80d9de1d9df928; });
$parcel$export(module.exports, "switchMap", function () { return $6057461cdef2c7a9$export$9f6ea8e48bc26eab; });
$parcel$export(module.exports, "take", function () { return $6057461cdef2c7a9$export$b7df5d561049483a; });
$parcel$export(module.exports, "takeUntil", function () { return $6057461cdef2c7a9$export$ac8dfd3a7ad06e80; });
$parcel$export(module.exports, "takeWhile", function () { return $6057461cdef2c7a9$export$9384c7afe4015e42; });
$parcel$export(module.exports, "lazy", function () { return $6057461cdef2c7a9$export$488013bae63b21da; });
$parcel$export(module.exports, "fromAsyncIterable", function () { return $6057461cdef2c7a9$export$e073fccf36d78cc1; });
$parcel$export(module.exports, "fromValue", function () { return $6057461cdef2c7a9$export$5f36b26c3833b3ba; });
$parcel$export(module.exports, "make", function () { return $6057461cdef2c7a9$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "makeSubject", function () { return $6057461cdef2c7a9$export$c4c2a35435b4a722; });
$parcel$export(module.exports, "fromPromise", function () { return $6057461cdef2c7a9$export$60f45028237c39d1; });
$parcel$export(module.exports, "subscribe", function () { return $6057461cdef2c7a9$export$ec068583843480e7; });
$parcel$export(module.exports, "publish", function () { return $6057461cdef2c7a9$export$89b472e03be495df; });
$parcel$export(module.exports, "toPromise", function () { return $6057461cdef2c7a9$export$4dbaaf6c79705e6c; });
$parcel$export(module.exports, "tap", function () { return $6057461cdef2c7a9$export$fff70a13d53402ec; });
var $6057461cdef2c7a9$var$teardownPlaceholder = ()=>{};
var $6057461cdef2c7a9$var$e = $6057461cdef2c7a9$var$teardownPlaceholder;
function $6057461cdef2c7a9$var$start(e) {
    return {
        tag: 0,
        0: e
    };
}
function $6057461cdef2c7a9$var$push(e) {
    return {
        tag: 1,
        0: e
    };
}
var $6057461cdef2c7a9$var$asyncIteratorSymbol = ()=>"function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator";
var $6057461cdef2c7a9$var$observableSymbol = ()=>"function" == typeof Symbol && Symbol.observable || "@@observable";
var $6057461cdef2c7a9$var$identity = (e)=>e;
function $6057461cdef2c7a9$export$ab1029bcae9ddb4a(r) {
    return (t)=>(i)=>{
            var a = [];
            var f = $6057461cdef2c7a9$var$e;
            var n = $6057461cdef2c7a9$var$e;
            var s = !1;
            var l = !1;
            t((e)=>{
                if (l) ;
                else if (0 === e) {
                    l = !0;
                    n(1);
                    if (a.length) i($6057461cdef2c7a9$var$push(a));
                    i(0);
                } else if (0 === e.tag) {
                    f = e[0];
                    r((e)=>{
                        if (l) ;
                        else if (0 === e) {
                            l = !0;
                            f(1);
                            if (a.length) i($6057461cdef2c7a9$var$push(a));
                            i(0);
                        } else if (0 === e.tag) n = e[0];
                        else if (a.length) {
                            var r = $6057461cdef2c7a9$var$push(a);
                            a = [];
                            i(r);
                        }
                    });
                } else {
                    a.push(e[0]);
                    if (!s) {
                        s = !0;
                        f(0);
                        n(0);
                    } else s = !1;
                }
            });
            i($6057461cdef2c7a9$var$start((e)=>{
                if (1 === e && !l) {
                    l = !0;
                    f(1);
                    n(1);
                } else if (!l && !s) {
                    s = !0;
                    f(0);
                    n(0);
                }
            }));
        };
}
function $6057461cdef2c7a9$export$c28c8388be0ab31a(r) {
    return (t)=>(i)=>{
            var a = [];
            var f = $6057461cdef2c7a9$var$e;
            var n = $6057461cdef2c7a9$var$e;
            var s = !1;
            var l = !1;
            var u = !1;
            var o = !1;
            function applyInnerSource(e) {
                u = !0;
                e((e)=>{
                    if (0 === e) {
                        if (u) {
                            u = !1;
                            if (a.length) applyInnerSource(r(a.shift()));
                            else if (o) i(0);
                            else if (!s) {
                                s = !0;
                                f(0);
                            }
                        }
                    } else if (0 === e.tag) {
                        l = !1;
                        (n = e[0])(0);
                    } else if (u) {
                        i(e);
                        if (l) l = !1;
                        else n(0);
                    }
                });
            }
            t((e)=>{
                if (o) ;
                else if (0 === e) {
                    o = !0;
                    if (!u && !a.length) i(0);
                } else if (0 === e.tag) f = e[0];
                else {
                    s = !1;
                    if (u) a.push(e[0]);
                    else applyInnerSource(r(e[0]));
                }
            });
            i($6057461cdef2c7a9$var$start((e)=>{
                if (1 === e) {
                    if (!o) {
                        o = !0;
                        f(1);
                    }
                    if (u) {
                        u = !1;
                        n(1);
                    }
                } else {
                    if (!o && !s) {
                        s = !0;
                        f(0);
                    }
                    if (u && !l) {
                        l = !0;
                        n(0);
                    }
                }
            }));
        };
}
function $6057461cdef2c7a9$export$b314777ae20abca9(e) {
    return $6057461cdef2c7a9$export$c28c8388be0ab31a($6057461cdef2c7a9$var$identity)(e);
}
function $6057461cdef2c7a9$export$ee1b3e54f0441b22(e) {
    return $6057461cdef2c7a9$export$b314777ae20abca9($6057461cdef2c7a9$export$571d59b505e6bb4e(e));
}
function $6057461cdef2c7a9$export$3dea766d36a8935f(r) {
    return (t)=>(i)=>{
            var a = $6057461cdef2c7a9$var$e;
            t((e)=>{
                if (0 === e) i(0);
                else if (0 === e.tag) {
                    a = e[0];
                    i(e);
                } else if (!r(e[0])) a(0);
                else i(e);
            });
        };
}
function $6057461cdef2c7a9$export$871de8747c9eaa88(e) {
    return (r)=>(t)=>r((r)=>{
                if (0 === r || 0 === r.tag) t(r);
                else t($6057461cdef2c7a9$var$push(e(r[0])));
            });
}
function $6057461cdef2c7a9$export$6b9f6c0d32c093f9(r) {
    return (t)=>(i)=>{
            var a = [];
            var f = $6057461cdef2c7a9$var$e;
            var n = !1;
            var s = !1;
            t((t)=>{
                if (s) ;
                else if (0 === t) {
                    s = !0;
                    if (!a.length) i(0);
                } else if (0 === t.tag) f = t[0];
                else {
                    n = !1;
                    !function applyInnerSource(r) {
                        var t = $6057461cdef2c7a9$var$e;
                        r((e)=>{
                            if (0 === e) {
                                if (a.length) {
                                    var r = a.indexOf(t);
                                    if (r > -1) (a = a.slice()).splice(r, 1);
                                    if (!a.length) {
                                        if (s) i(0);
                                        else if (!n) {
                                            n = !0;
                                            f(0);
                                        }
                                    }
                                }
                            } else if (0 === e.tag) {
                                a.push(t = e[0]);
                                t(0);
                            } else if (a.length) {
                                i(e);
                                t(0);
                            }
                        });
                    }(r(t[0]));
                    if (!n) {
                        n = !0;
                        f(0);
                    }
                }
            });
            i($6057461cdef2c7a9$var$start((e)=>{
                if (1 === e) {
                    if (!s) {
                        s = !0;
                        f(1);
                    }
                    for(var r = 0, t = a, i = a.length; r < i; r++)t[r](1);
                    a.length = 0;
                } else {
                    if (!s && !n) {
                        n = !0;
                        f(0);
                    } else n = !1;
                    for(var l = 0, u = a, o = a.length; l < o; l++)u[l](0);
                }
            }));
        };
}
function $6057461cdef2c7a9$export$bffa455ba8c619a6(e) {
    return $6057461cdef2c7a9$export$6b9f6c0d32c093f9($6057461cdef2c7a9$var$identity)(e);
}
function $6057461cdef2c7a9$export$4950aa0f605343fb(e) {
    return $6057461cdef2c7a9$export$bffa455ba8c619a6($6057461cdef2c7a9$export$571d59b505e6bb4e(e));
}
function $6057461cdef2c7a9$export$db4d2a4aed77becf(e) {
    return (r)=>(t)=>{
            var i = !1;
            r((r)=>{
                if (i) ;
                else if (0 === r) {
                    i = !0;
                    t(0);
                    e();
                } else if (0 === r.tag) {
                    var a = r[0];
                    t($6057461cdef2c7a9$var$start((r)=>{
                        if (1 === r) {
                            i = !0;
                            a(1);
                            e();
                        } else a(r);
                    }));
                } else t(r);
            });
        };
}
function $6057461cdef2c7a9$export$fff70a13d53402ec(e) {
    return (r)=>(t)=>{
            var i = !1;
            r((r)=>{
                if (i) ;
                else if (0 === r) {
                    i = !0;
                    t(0);
                } else if (0 === r.tag) {
                    var a = r[0];
                    t($6057461cdef2c7a9$var$start((e)=>{
                        if (1 === e) i = !0;
                        a(e);
                    }));
                } else {
                    e(r[0]);
                    t(r);
                }
            });
        };
}
function $6057461cdef2c7a9$export$aaa2d21dd8862419(e) {
    return (r)=>(t)=>r((r)=>{
                if (0 === r) t(0);
                else if (0 === r.tag) {
                    t(r);
                    e();
                } else t(r);
            });
}
function $6057461cdef2c7a9$export$4812e460280c6ef2(r) {
    return (t)=>(i)=>{
            var a = $6057461cdef2c7a9$var$e;
            var f = $6057461cdef2c7a9$var$e;
            var n;
            var s = !1;
            var l = !1;
            t((e)=>{
                if (l) ;
                else if (0 === e) {
                    l = !0;
                    f(1);
                    i(0);
                } else if (0 === e.tag) a = e[0];
                else {
                    n = e[0];
                    if (!s) {
                        s = !0;
                        f(0);
                        a(0);
                    } else s = !1;
                }
            });
            r((e)=>{
                if (l) ;
                else if (0 === e) {
                    l = !0;
                    a(1);
                    i(0);
                } else if (0 === e.tag) f = e[0];
                else if (void 0 !== n) {
                    var r = $6057461cdef2c7a9$var$push(n);
                    n = void 0;
                    i(r);
                }
            });
            i($6057461cdef2c7a9$var$start((e)=>{
                if (1 === e && !l) {
                    l = !0;
                    a(1);
                    f(1);
                } else if (!l && !s) {
                    s = !0;
                    a(0);
                    f(0);
                }
            }));
        };
}
function $6057461cdef2c7a9$export$c87d910e63d22ed6(e, r) {
    return (t)=>(i)=>{
            var a = r;
            t((r)=>{
                if (0 === r) i(0);
                else if (0 === r.tag) i(r);
                else i($6057461cdef2c7a9$var$push(a = e(a, r[0])));
            });
        };
}
function $6057461cdef2c7a9$export$ed80d9de1d9df928(r) {
    var t = [];
    var i = $6057461cdef2c7a9$var$e;
    var a = !1;
    return (e)=>{
        t.push(e);
        if (1 === t.length) r((e)=>{
            if (0 === e) {
                for(var r = 0, f = t, n = t.length; r < n; r++)f[r](0);
                t.length = 0;
            } else if (0 === e.tag) i = e[0];
            else {
                a = !1;
                for(var s = 0, l = t, u = t.length; s < u; s++)l[s](e);
            }
        });
        e($6057461cdef2c7a9$var$start((r)=>{
            if (1 === r) {
                var f = t.indexOf(e);
                if (f > -1) (t = t.slice()).splice(f, 1);
                if (!t.length) i(1);
            } else if (!a) {
                a = !0;
                i(0);
            }
        }));
    };
}
function $6057461cdef2c7a9$export$955fc4a6c4be454d(r) {
    return (t)=>(i)=>{
            var a = $6057461cdef2c7a9$var$e;
            var f = r;
            t((e)=>{
                if (0 === e) i(0);
                else if (0 === e.tag) {
                    a = e[0];
                    i(e);
                } else if (f-- > 0) a(0);
                else i(e);
            });
        };
}
function $6057461cdef2c7a9$export$facc584867c26fde(r) {
    return (t)=>(i)=>{
            var a = $6057461cdef2c7a9$var$e;
            var f = $6057461cdef2c7a9$var$e;
            var n = !0;
            var s = !1;
            var l = !1;
            t((e)=>{
                if (l) ;
                else if (0 === e) {
                    l = !0;
                    if (n) f(1);
                    i(0);
                } else if (0 === e.tag) {
                    a = e[0];
                    r((e)=>{
                        if (0 === e) {
                            if (n) {
                                l = !0;
                                a(1);
                            }
                        } else if (0 === e.tag) (f = e[0])(0);
                        else {
                            n = !1;
                            f(1);
                        }
                    });
                } else if (!n) {
                    s = !1;
                    i(e);
                } else if (!s) {
                    s = !0;
                    a(0);
                    f(0);
                } else s = !1;
            });
            i($6057461cdef2c7a9$var$start((e)=>{
                if (1 === e && !l) {
                    l = !0;
                    a(1);
                    if (n) f(1);
                } else if (!l && !s) {
                    s = !0;
                    if (n) f(0);
                    a(0);
                }
            }));
        };
}
function $6057461cdef2c7a9$export$175dedd748069215(r) {
    return (t)=>(i)=>{
            var a = $6057461cdef2c7a9$var$e;
            var f = !0;
            t((e)=>{
                if (0 === e) i(0);
                else if (0 === e.tag) {
                    a = e[0];
                    i(e);
                } else if (f) {
                    if (r(e[0])) a(0);
                    else {
                        f = !1;
                        i(e);
                    }
                } else i(e);
            });
        };
}
function $6057461cdef2c7a9$export$9f6ea8e48bc26eab(r) {
    return (t)=>(i)=>{
            var a = $6057461cdef2c7a9$var$e;
            var f = $6057461cdef2c7a9$var$e;
            var n = !1;
            var s = !1;
            var l = !1;
            var u = !1;
            t((t)=>{
                if (u) ;
                else if (0 === t) {
                    u = !0;
                    if (!l) i(0);
                } else if (0 === t.tag) a = t[0];
                else {
                    if (l) {
                        f(1);
                        f = $6057461cdef2c7a9$var$e;
                    }
                    if (!n) {
                        n = !0;
                        a(0);
                    } else n = !1;
                    !function applyInnerSource(e) {
                        l = !0;
                        e((e)=>{
                            if (!l) ;
                            else if (0 === e) {
                                l = !1;
                                if (u) i(0);
                                else if (!n) {
                                    n = !0;
                                    a(0);
                                }
                            } else if (0 === e.tag) {
                                s = !1;
                                (f = e[0])(0);
                            } else {
                                i(e);
                                if (!s) f(0);
                                else s = !1;
                            }
                        });
                    }(r(t[0]));
                }
            });
            i($6057461cdef2c7a9$var$start((e)=>{
                if (1 === e) {
                    if (!u) {
                        u = !0;
                        a(1);
                    }
                    if (l) {
                        l = !1;
                        f(1);
                    }
                } else {
                    if (!u && !n) {
                        n = !0;
                        a(0);
                    }
                    if (l && !s) {
                        s = !0;
                        f(0);
                    }
                }
            }));
        };
}
function $6057461cdef2c7a9$export$6a45284a4b0bf33a(e) {
    return $6057461cdef2c7a9$export$9f6ea8e48bc26eab($6057461cdef2c7a9$var$identity)(e);
}
function $6057461cdef2c7a9$export$b7df5d561049483a(r) {
    return (t)=>(i)=>{
            var a = $6057461cdef2c7a9$var$e;
            var f = !1;
            var n = 0;
            t((e)=>{
                if (f) ;
                else if (0 === e) {
                    f = !0;
                    i(0);
                } else if (0 === e.tag) {
                    if (r <= 0) {
                        f = !0;
                        i(0);
                        e[0](1);
                    } else a = e[0];
                } else if (n++ < r) {
                    i(e);
                    if (!f && n >= r) {
                        f = !0;
                        i(0);
                        a(1);
                    }
                } else i(e);
            });
            i($6057461cdef2c7a9$var$start((e)=>{
                if (1 === e && !f) {
                    f = !0;
                    a(1);
                } else if (0 === e && !f && n < r) a(0);
            }));
        };
}
function $6057461cdef2c7a9$export$1b47ad771ce5af5e(t) {
    return (i)=>(a)=>{
            var f = [];
            var n = $6057461cdef2c7a9$var$e;
            i((e)=>{
                if (0 === e) $6057461cdef2c7a9$export$571d59b505e6bb4e(f)(a);
                else if (0 === e.tag) {
                    if (t <= 0) {
                        e[0](1);
                        $6057461cdef2c7a9$export$571d59b505e6bb4e(f)(a);
                    } else (n = e[0])(0);
                } else {
                    if (f.length >= t && t) f.shift();
                    f.push(e[0]);
                    n(0);
                }
            });
        };
}
function $6057461cdef2c7a9$export$ac8dfd3a7ad06e80(r) {
    return (t)=>(i)=>{
            var a = $6057461cdef2c7a9$var$e;
            var f = $6057461cdef2c7a9$var$e;
            var n = !1;
            t((e)=>{
                if (n) ;
                else if (0 === e) {
                    n = !0;
                    f(1);
                    i(0);
                } else if (0 === e.tag) {
                    a = e[0];
                    r((e)=>{
                        if (0 === e) ;
                        else if (0 === e.tag) (f = e[0])(0);
                        else {
                            n = !0;
                            f(1);
                            a(1);
                            i(0);
                        }
                    });
                } else i(e);
            });
            i($6057461cdef2c7a9$var$start((e)=>{
                if (1 === e && !n) {
                    n = !0;
                    a(1);
                    f(1);
                } else if (!n) a(0);
            }));
        };
}
function $6057461cdef2c7a9$export$9384c7afe4015e42(r, t) {
    return (i)=>(a)=>{
            var f = $6057461cdef2c7a9$var$e;
            var n = !1;
            i((e)=>{
                if (n) ;
                else if (0 === e) {
                    n = !0;
                    a(0);
                } else if (0 === e.tag) {
                    f = e[0];
                    a(e);
                } else if (!r(e[0])) {
                    n = !0;
                    if (t) a(e);
                    a(0);
                    f(1);
                } else a(e);
            });
        };
}
function $6057461cdef2c7a9$export$61fc7d43ac8f84b0(e) {
    return (r)=>(t)=>{
            var i;
            var a = !1;
            var f = !1;
            r((r)=>{
                if (f) ;
                else if (0 === r) {
                    f = !0;
                    if (i) a = !0;
                    else t(0);
                } else if (0 === r.tag) {
                    var n = r[0];
                    t($6057461cdef2c7a9$var$start((e)=>{
                        if (1 === e && !f) {
                            f = !0;
                            a = !1;
                            if (i) clearTimeout(i);
                            n(1);
                        } else if (!f) n(0);
                    }));
                } else {
                    if (i) clearTimeout(i);
                    i = setTimeout(()=>{
                        i = void 0;
                        t(r);
                        if (a) t(0);
                    }, e(r[0]));
                }
            });
        };
}
function $6057461cdef2c7a9$export$1391212d75b2ee65(e) {
    return (r)=>(t)=>{
            var i = 0;
            r((r)=>{
                if (0 !== r && 0 === r.tag) t(r);
                else {
                    i++;
                    setTimeout(()=>{
                        if (i) {
                            i--;
                            t(r);
                        }
                    }, e);
                }
            });
        };
}
function $6057461cdef2c7a9$export$de363e709c412c8a(e) {
    return (r)=>(t)=>{
            var i = !1;
            var a;
            r((r)=>{
                if (0 === r) {
                    if (a) clearTimeout(a);
                    t(0);
                } else if (0 === r.tag) {
                    var f = r[0];
                    t($6057461cdef2c7a9$var$start((e)=>{
                        if (1 === e) {
                            if (a) clearTimeout(a);
                            f(1);
                        } else f(0);
                    }));
                } else if (!i) {
                    i = !0;
                    if (a) clearTimeout(a);
                    a = setTimeout(()=>{
                        a = void 0;
                        i = !1;
                    }, e(r[0]));
                    t(r);
                }
            });
        };
}
function $6057461cdef2c7a9$export$488013bae63b21da(e) {
    return (r)=>e()(r);
}
function $6057461cdef2c7a9$export$e073fccf36d78cc1(e) {
    return (r)=>{
        var t = e[$6057461cdef2c7a9$var$asyncIteratorSymbol()] && e[$6057461cdef2c7a9$var$asyncIteratorSymbol()]() || e;
        var i = !1;
        var a = !1;
        var f = !1;
        var n;
        r($6057461cdef2c7a9$var$start(async (e)=>{
            if (1 === e) {
                i = !0;
                if (t.return) t.return();
            } else if (a) f = !0;
            else {
                for(f = a = !0; f && !i;){
                    if ((n = await t.next()).done) {
                        i = !0;
                        if (t.return) await t.return();
                        r(0);
                    } else try {
                        f = !1;
                        r($6057461cdef2c7a9$var$push(n.value));
                    } catch (e) {
                        if (t.throw) {
                            if (i = !!(await t.throw(e)).done) r(0);
                        } else throw e;
                    }
                }
                a = !1;
            }
        }));
    };
}
function $6057461cdef2c7a9$export$dcccc29c315dd646(e) {
    if (e[Symbol.asyncIterator]) return $6057461cdef2c7a9$export$e073fccf36d78cc1(e);
    return (r)=>{
        var t = e[Symbol.iterator]();
        var i = !1;
        var a = !1;
        var f = !1;
        var n;
        r($6057461cdef2c7a9$var$start((e)=>{
            if (1 === e) {
                i = !0;
                if (t.return) t.return();
            } else if (a) f = !0;
            else {
                for(f = a = !0; f && !i;){
                    if ((n = t.next()).done) {
                        i = !0;
                        if (t.return) t.return();
                        r(0);
                    } else try {
                        f = !1;
                        r($6057461cdef2c7a9$var$push(n.value));
                    } catch (e) {
                        if (t.throw) {
                            if (i = !!t.throw(e).done) r(0);
                        } else throw e;
                    }
                }
                a = !1;
            }
        }));
    };
}
var $6057461cdef2c7a9$export$571d59b505e6bb4e = $6057461cdef2c7a9$export$dcccc29c315dd646;
function $6057461cdef2c7a9$export$5f36b26c3833b3ba(e) {
    return (r)=>{
        var t = !1;
        r($6057461cdef2c7a9$var$start((i)=>{
            if (1 === i) t = !0;
            else if (!t) {
                t = !0;
                r($6057461cdef2c7a9$var$push(e));
                r(0);
            }
        }));
    };
}
function $6057461cdef2c7a9$export$dd44f18ab656f3bb(e) {
    return (r)=>{
        var t = !1;
        var i = e({
            next (e) {
                if (!t) r($6057461cdef2c7a9$var$push(e));
            },
            complete () {
                if (!t) {
                    t = !0;
                    r(0);
                }
            }
        });
        r($6057461cdef2c7a9$var$start((e)=>{
            if (1 === e && !t) {
                t = !0;
                i();
            }
        }));
    };
}
function $6057461cdef2c7a9$export$c4c2a35435b4a722() {
    var e;
    var r;
    return {
        source: $6057461cdef2c7a9$export$ed80d9de1d9df928($6057461cdef2c7a9$export$dd44f18ab656f3bb((t)=>{
            e = t.next;
            r = t.complete;
            return $6057461cdef2c7a9$var$teardownPlaceholder;
        })),
        next (r) {
            if (e) e(r);
        },
        complete () {
            if (r) r();
        }
    };
}
var $6057461cdef2c7a9$export$6e22c362a0406a2c = (e)=>{
    var r = !1;
    e($6057461cdef2c7a9$var$start((t)=>{
        if (1 === t) r = !0;
        else if (!r) {
            r = !0;
            e(0);
        }
    }));
};
var $6057461cdef2c7a9$export$b3e22bcfd64c1022 = (r)=>{
    r($6057461cdef2c7a9$var$start($6057461cdef2c7a9$var$e));
};
function $6057461cdef2c7a9$export$3174cdbf0a0cbc84(e) {
    return $6057461cdef2c7a9$export$dd44f18ab656f3bb((r)=>{
        var t = 0;
        var i = setInterval(()=>r.next(t++), e);
        return ()=>clearInterval(i);
    });
}
function $6057461cdef2c7a9$export$abb8949c8e816a2c(e, r) {
    return $6057461cdef2c7a9$export$dd44f18ab656f3bb((t)=>{
        e.addEventListener(r, t.next);
        return ()=>e.removeEventListener(r, t.next);
    });
}
function $6057461cdef2c7a9$export$60f45028237c39d1(e) {
    return $6057461cdef2c7a9$export$dd44f18ab656f3bb((r)=>{
        e.then((e)=>{
            Promise.resolve(e).then(()=>{
                r.next(e);
                r.complete();
            });
        });
        return $6057461cdef2c7a9$var$teardownPlaceholder;
    });
}
function $6057461cdef2c7a9$export$ec068583843480e7(r) {
    return (t)=>{
        var i = $6057461cdef2c7a9$var$e;
        var a = !1;
        t((e)=>{
            if (0 === e) a = !0;
            else if (0 === e.tag) (i = e[0])(0);
            else if (!a) {
                r(e[0]);
                i(0);
            }
        });
        return {
            unsubscribe () {
                if (!a) {
                    a = !0;
                    i(1);
                }
            }
        };
    };
}
function $6057461cdef2c7a9$export$4b80e395e36b5a56(e) {
    return (r)=>{
        $6057461cdef2c7a9$export$ec068583843480e7(e)(r);
    };
}
function $6057461cdef2c7a9$export$89b472e03be495df(e) {
    $6057461cdef2c7a9$export$ec068583843480e7((e)=>{})(e);
}
var $6057461cdef2c7a9$var$t = {
    done: !0
};
var $6057461cdef2c7a9$export$b08ebdcf177203a0 = (r)=>{
    var i = [];
    var a = !1;
    var f = !1;
    var n = !1;
    var s = $6057461cdef2c7a9$var$e;
    var l;
    return {
        async next () {
            if (!f) {
                f = !0;
                r((e)=>{
                    if (a) ;
                    else if (0 === e) {
                        if (l) l = l($6057461cdef2c7a9$var$t);
                        a = !0;
                    } else if (0 === e.tag) {
                        n = !0;
                        (s = e[0])(0);
                    } else {
                        n = !1;
                        if (l) l = l({
                            value: e[0],
                            done: !1
                        });
                        else i.push(e[0]);
                    }
                });
            }
            if (a && !i.length) return $6057461cdef2c7a9$var$t;
            else if (!a && !n && i.length <= 1) {
                n = !0;
                s(0);
            }
            return i.length ? {
                value: i.shift(),
                done: !1
            } : new Promise((e)=>l = e);
        },
        async return () {
            if (!a) l = s(1);
            a = !0;
            return $6057461cdef2c7a9$var$t;
        },
        [$6057461cdef2c7a9$var$asyncIteratorSymbol()] () {
            return this;
        }
    };
};
function $6057461cdef2c7a9$export$45b10814cc054894(r) {
    var t = [];
    var i = $6057461cdef2c7a9$var$e;
    var a = !1;
    r((e)=>{
        if (0 === e) a = !0;
        else if (0 === e.tag) (i = e[0])(0);
        else {
            t.push(e[0]);
            i(0);
        }
    });
    if (!a) i(1);
    return t;
}
function $6057461cdef2c7a9$export$4dbaaf6c79705e6c(r) {
    return new Promise((t)=>{
        var i = $6057461cdef2c7a9$var$e;
        var a;
        r((e)=>{
            if (0 === e) Promise.resolve(a).then(t);
            else if (0 === e.tag) (i = e[0])(0);
            else {
                a = e[0];
                i(0);
            }
        });
    });
}
function $6057461cdef2c7a9$export$8901015135f2fb22(r) {
    var t = Object.keys(r).length;
    return (i)=>{
        var a = new Set;
        var f = Array.isArray(r) ? new Array(t).fill($6057461cdef2c7a9$var$e) : {};
        var n = Array.isArray(r) ? new Array(t) : {};
        var s = !1;
        var l = !1;
        var u = !1;
        var o = 0;
        var loop = function(v) {
            r[v]((c)=>{
                if (0 === c) {
                    if (o >= t - 1) {
                        u = !0;
                        i(0);
                    } else o++;
                } else if (0 === c.tag) f[v] = c[0];
                else if (!u) {
                    n[v] = c[0];
                    a.add(v);
                    if (!s && a.size < t) {
                        if (!l) {
                            for(var h in r)if (!a.has(h)) (f[h] || $6057461cdef2c7a9$var$e)(0);
                        } else l = !1;
                    } else {
                        s = !0;
                        l = !1;
                        i($6057461cdef2c7a9$var$push(Array.isArray(n) ? n.slice() : {
                            ...n
                        }));
                    }
                }
            });
        };
        for(var v in r)loop(v);
        i($6057461cdef2c7a9$var$start((e)=>{
            if (u) ;
            else if (1 === e) {
                u = !0;
                for(var r in f)f[r](1);
            } else if (!l) {
                l = !0;
                for(var t in f)f[t](0);
            }
        }));
    };
}
function $6057461cdef2c7a9$export$1be1fc439b849fdf(...e) {
    return $6057461cdef2c7a9$export$8901015135f2fb22(e);
}
function $6057461cdef2c7a9$export$4b2432e2d8723823(e) {
    return (r)=>{
        var t = (e[$6057461cdef2c7a9$var$observableSymbol()] ? e[$6057461cdef2c7a9$var$observableSymbol()]() : e).subscribe({
            next (e) {
                r($6057461cdef2c7a9$var$push(e));
            },
            complete () {
                r(0);
            },
            error (e) {
                throw e;
            }
        });
        r($6057461cdef2c7a9$var$start((e)=>{
            if (1 === e) t.unsubscribe();
        }));
    };
}
function $6057461cdef2c7a9$export$b5a21352c348fea9(r) {
    return {
        subscribe (t, i, a) {
            var f = "object" == typeof t ? t : {
                next: t,
                error: i,
                complete: a
            };
            var n = $6057461cdef2c7a9$var$e;
            var s = !1;
            r((e)=>{
                if (s) ;
                else if (0 === e) {
                    s = !0;
                    if (f.complete) f.complete();
                } else if (0 === e.tag) (n = e[0])(0);
                else {
                    f.next(e[0]);
                    n(0);
                }
            });
            var l = {
                closed: !1,
                unsubscribe () {
                    l.closed = !0;
                    s = !0;
                    n(1);
                }
            };
            return l;
        },
        [$6057461cdef2c7a9$var$observableSymbol()] () {
            return this;
        }
    };
}
function $6057461cdef2c7a9$export$24d5d3bb0066f63a(e) {
    return (r)=>{
        e(0, (e, t)=>{
            if (0 === e) r($6057461cdef2c7a9$var$start((e)=>{
                t(e + 1);
            }));
            else if (1 === e) r($6057461cdef2c7a9$var$push(t));
            else r(0);
        });
    };
}
function $6057461cdef2c7a9$export$95003814f91c442(e) {
    return (r, t)=>{
        if (0 === r) e((e)=>{
            if (0 === e) t(2);
            else if (0 === e.tag) t(0, (r)=>{
                if (r < 3) e[0](r - 1);
            });
            else t(1, e[0]);
        });
    };
}
var $6057461cdef2c7a9$export$a4627e546088548d = (...e)=>{
    var r = e[0];
    for(var t = 1, i = e.length; t < i; t++)r = e[t](r);
    return r;
};

});



parcelRegister("7bBPn", function(module, exports) {
$parcel$export(module.exports, "GATEWAY_URL", function () { return $216e69e2f58c48af$export$91e8019c72e4e6d; });
const $216e69e2f58c48af$export$91e8019c72e4e6d = 'https://www.atlassian.com/gateway/api/graphql';

});

parcelRegister("j4gco", function(module, exports) {
$parcel$export(module.exports, "AccountUserProfileFragment", function () { return $8045898816cfafdd$export$402bbe2ae51bef4d; });

var $1dWiR = parcelRequire("1dWiR");
const $8045898816cfafdd$export$402bbe2ae51bef4d = (0, $1dWiR.gql)`
	fragment AccountUserProfileFragment on GrowthUnifiedProfileAccountProfileResult {
		userProfile {
			inferredTimezone
		}
	}
`;

});

parcelRegister("kLCJm", function(module, exports) {
$parcel$export(module.exports, "OnboardingContextFragment", function () { return $fff0cac1d528c63f$export$b6bf1ee6c55f99d9; });

var $1dWiR = parcelRequire("1dWiR");
const $fff0cac1d528c63f$export$b6bf1ee6c55f99d9 = (0, $1dWiR.gql)`
	fragment OnboardingContextFragment on GrowthUnifiedProfileResult {
		onboardingContext {
			jira {
				projectName
				teamType
				jobsToBeDone
				projectLandingSelection
			}
			confluence {
				jobsToBeDone
				template
			}
		}
	}
`;

});

parcelRegister("1HuKf", function(module, exports) {
$parcel$export(module.exports, "PaidChannelContextFragment", function () { return $6cf084c9ca16d515$export$1842a5759f4be5bd; });

var $1dWiR = parcelRequire("1dWiR");
const $6cf084c9ca16d515$export$1842a5759f4be5bd = (0, $1dWiR.gql)`
	fragment PaidChannelContextFragment on GrowthUnifiedProfileResult {
		paidChannelContext {
			jira {
				utm {
					keyword
					source
					channel
				}
				anchor {
					name
					type
				}
				subAnchor
				teamType
				persona
				templates
			}
			confluence {
				utm {
					keyword
					source
					channel
				}
				anchor {
					name
					type
				}
				subAnchor
				teamType
				persona
				templates
			}
			jsm {
				utm {
					keyword
					source
					channel
				}
				anchor {
					name
					type
				}
				subAnchor
				teamType
				persona
				templates
			}
			jwm {
				utm {
					keyword
					source
					channel
				}
				anchor {
					name
					type
				}
				subAnchor
				teamType
				persona
				templates
			}
			trello {
				utm {
					keyword
					source
					channel
				}
				anchor {
					name
					type
				}
				subAnchor
				teamType
				persona
				templates
			}
		}
	}
`;

});

parcelRegister("bXKtm", function(module, exports) {
$parcel$export(module.exports, "RecommendationsFragment", function () { return $6b714eb762c6c3e4$export$bc470c46a2aa5990; });

var $1dWiR = parcelRequire("1dWiR");
const $6b714eb762c6c3e4$export$bc470c46a2aa5990 = (0, $1dWiR.gql)`
	fragment RecommendationsFragment on GrowthUnifiedProfileAccountProfileResult {
		recommendations {
			nbp {
				key
				values
			}
		}
	}
`;

});

parcelRegister("e7nCy", function(module, exports) {
$parcel$export(module.exports, "SitesFragment", function () { return $076a8071d09a3f73$export$e47282782f810d28; });

var $1dWiR = parcelRequire("1dWiR");
const $076a8071d09a3f73$export$e47282782f810d28 = (0, $1dWiR.gql)`
	fragment SitesFragment on GrowthUnifiedProfileResult {
		sites {
			cloudId
			displayName
			hasAdminAccess
			url
			siteCreatedAt
			products {
				d0Eligible
				d1to6Eligible
				d0Active
				d1to6Active
				productEdition
				productKey
				productName
				provisionedAt
			}
		}
	}
`;

});

parcelRegister("F18pk", function(module, exports) {
$parcel$export(module.exports, "UserFootprintsFragment", function () { return $12d0bf6fa94e5272$export$3e6de26f62d6c5b; });

var $1dWiR = parcelRequire("1dWiR");
const $12d0bf6fa94e5272$export$3e6de26f62d6c5b = (0, $1dWiR.gql)`
	fragment UserFootprintsFragment on GrowthUnifiedProfileResult {
		userFootprints {
			products
			hasAtlassianAccount
		}
	}
`;

});

parcelRegister("5ihJe", function(module, exports) {
$parcel$export(module.exports, "UserProfileFragment", function () { return $8e8ee7f40e10a838$export$4647326753384cf0; });

var $1dWiR = parcelRequire("1dWiR");
const $8e8ee7f40e10a838$export$4647326753384cf0 = (0, $1dWiR.gql)`
	fragment UserProfileFragment on GrowthUnifiedProfileResult {
		userProfile {
			userType
			domainType
			teamType
			jobFunction
		}
	}
`;

});

parcelRegister("fp45j", function(module, exports) {
$parcel$export(module.exports, "UserProfileJobFunctionFragment", function () { return $7d4c0dd32c3dd3ab$export$2d7883efb75f7523; });

var $1dWiR = parcelRequire("1dWiR");
const $7d4c0dd32c3dd3ab$export$2d7883efb75f7523 = (0, $1dWiR.gql)`
	fragment UserProfileJobFunctionFragment on GrowthUnifiedProfileResult {
		userProfile {
			jobFunction
		}
	}
`;

});

parcelRegister("2hTwF", function(module, exports) {
$parcel$export(module.exports, "OptionalFields", function () { return $ca1e05340073c580$export$89720e8460cd3d04; });
$parcel$export(module.exports, "AccountProfileOptionalFields", function () { return $ca1e05340073c580$export$c52306273ead3f; });
var $ca1e05340073c580$export$89720e8460cd3d04 = /*#__PURE__*/ function(OptionalFields) {
    OptionalFields["SITES"] = "sites";
    OptionalFields["PAID_CHANNEL_CONTEXT"] = "paidChannelContext";
    OptionalFields["USER_FOOTPRINTS"] = "userFootprints";
    OptionalFields["ONBOARDING_CONTEXT"] = "onboardingContext";
    OptionalFields["USER_PROFILE"] = "userProfile";
    OptionalFields["USER_PROFILE_JOB_FUNCTION"] = "userProfileJobFunction";
    return OptionalFields;
}({});
var $ca1e05340073c580$export$c52306273ead3f = /*#__PURE__*/ function(AccountProfileOptionalFields) {
    AccountProfileOptionalFields["USER_PROFILE"] = "userProfile";
    AccountProfileOptionalFields["PAID_FEATURE_USAGE"] = "paidFeatureUsage";
    AccountProfileOptionalFields["RECOMMENDATIONS"] = "recommendations";
    return AccountProfileOptionalFields;
}({});

});


parcelRegister("3riD8", function(module, exports) {
$parcel$export(module.exports, "useLoggedInUser", function () { return $f97635a3ba98251f$export$aae23f3a65fbe750; });
$parcel$export(module.exports, "LoggedInUserProvider", function () { return $f97635a3ba98251f$export$164e91ee1eedc9fa; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");

var $gx3aw = parcelRequire("gx3aw");
const $f97635a3ba98251f$var$DEFAULT_USER_STATE = {
    isUserLoggedIn: false,
    requestInProgress: true
};
const $f97635a3ba98251f$var$LoggedInUserContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    ...$f97635a3ba98251f$var$DEFAULT_USER_STATE
});
const $f97635a3ba98251f$export$aae23f3a65fbe750 = ()=>{
    const context = (0, $1oC0p.useContext)($f97635a3ba98251f$var$LoggedInUserContext);
    if (!context) throw new Error('calls to useLoggedInUser must be wrapped in <LoggedInUserProvider>');
    return context;
};
const $f97635a3ba98251f$export$164e91ee1eedc9fa = ({ children: children })=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const [loggedInUserInstance, setLoggedInUserInstance] = (0, $1oC0p.useState)({
        ...$f97635a3ba98251f$var$DEFAULT_USER_STATE
    });
    (0, $1oC0p.useEffect)(()=>{
        (0, $1oC0p.startTransition)(()=>{
            // Check for login_user_detected cookie first (set during SSR).
            // As fallback, check for cloud.session.token directly (handles static fallback case).
            const loginUserDetectedCookie = (0, $gx3aw.Cookie).readCookie('login_user_detected') === 'true';
            const cloudSessionToken = (0, $gx3aw.Cookie).readCookie('cloud.session.token') || (0, $gx3aw.Cookie).readCookie('cloud.session.token.stg');
            const isUserLoggedIn = loginUserDetectedCookie || cloudSessionToken !== null;
            if (!isUserLoggedIn) {
                // If logged in user cookie isn't present, then we don't need to make a call to stargate.
                // This cookie is set by bxp-gateway to determine if the user is logged in or not.
                setLoggedInUserInstance({
                    ...$f97635a3ba98251f$var$DEFAULT_USER_STATE,
                    requestInProgress: false
                });
                return;
            }
            const getUserProfile = async ()=>{
                return await stargateClient.me({});
            };
            getUserProfile().then((userProfile)=>{
                setLoggedInUserInstance({
                    requestInProgress: false,
                    isUserLoggedIn: true,
                    ...userProfile
                });
            }).catch((e)=>{
                console.warn('Error getting user profile: ', e);
                setLoggedInUserInstance({
                    ...$f97635a3ba98251f$var$DEFAULT_USER_STATE,
                    requestInProgress: false
                });
            });
        });
    }, [
        stargateClient
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f97635a3ba98251f$var$LoggedInUserContext.Provider, {
        value: loggedInUserInstance,
        children: children
    });
};
const $f97635a3ba98251f$export$baab3d3c6c1ba19c = ({ children: children, loggedInUser: loggedInUser })=>/*#__PURE__*/ (0, $7VQPk.jsx)($f97635a3ba98251f$var$LoggedInUserContext.Provider, {
        value: loggedInUser,
        children: children
    });

});
parcelRegister("5Ntyw", function(module, exports) {
$parcel$export(module.exports, "BxpExpressServiceSupportedRegions", function () { return $3ee851d238fc5aad$export$82617393f6a222b1; });
$parcel$export(module.exports, "BxpWebStargateClient", function () { return $3ee851d238fc5aad$export$963f114b487aad6d; });
$parcel$export(module.exports, "getStargateBaseUrl", function () { return $3ee851d238fc5aad$export$98ec7f86e3388cfc; });
$parcel$export(module.exports, "useBxpWebStargateClient", function () { return $3ee851d238fc5aad$export$ac42303986bb641e; });
$parcel$export(module.exports, "BxpWebStargateClientProvider", function () { return $3ee851d238fc5aad$export$dc976c529d501f0c; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $yagHz = parcelRequire("yagHz");

var $kNE9Z = parcelRequire("kNE9Z");

var $8dzKz = parcelRequire("8dzKz");

var $ZSmFY = parcelRequire("ZSmFY");

var $6Spiu = parcelRequire("6Spiu");

var $lr4yY = parcelRequire("lr4yY");

var $fHaFy = parcelRequire("fHaFy");

var $f998y = parcelRequire("f998y");

var $6EFID = parcelRequire("6EFID");

var $odgKo = parcelRequire("odgKo");

var $7heEc = parcelRequire("7heEc");

var $9tcM4 = parcelRequire("9tcM4");
const $3ee851d238fc5aad$var$BASE_URL = "https://www.atlassian.com/gateway/api";
const $3ee851d238fc5aad$export$82617393f6a222b1 = new Set([
    'ap-southeast-1',
    'ap-southeast-2',
    'us-east-1',
    'us-west-2',
    'eu-west-1',
    'eu-central-1'
]);
const $3ee851d238fc5aad$export$2f6f3c380745077 = new Set([
    'us-east-1',
    'us-west-2'
]);
const $3ee851d238fc5aad$export$436826b9c15fad96 = new Set([
    'us-east-1'
]);
const $3ee851d238fc5aad$var$isObject = (value)=>typeof value === 'object' && value !== null;
class $3ee851d238fc5aad$export$963f114b487aad6d {
    constructor({ baseUrl: baseUrl }){
        this.baseUrl = baseUrl;
    }
    async fetch(urlPath, init, removeBaseUrl) {
        let response;
        try {
            response = fetch(removeBaseUrl ? urlPath : this.baseUrl + urlPath, init);
        } catch (error) {
            console.error('Fetch error:', error);
            return new Response(null, {
                status: 500,
                statusText: 'Error'
            });
        }
        return response.catch((error)=>{
            if ($3ee851d238fc5aad$var$isObject(error)) error['requestPath'] = urlPath;
            throw error;
        });
    }
    async me({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        // note: not de-duping fetches like in asc-stargate
        const response = await this.fetch('/me', {
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) return (0, $f998y.mapMeResponseToUserProfile)(await response.json());
        else throw new (0, $7heEc.UnsuccessfulFetchError)({
            response: response
        });
    }
    // extended_profile defintion: https://bitbucket.org/atlassian/id-public-api-facade/src/b6dbac9d5f1b6951c88d93ebeda0c3b68283aa40/swagger.yaml#lines-2479:2493
    // DAC Docs: https://developer.atlassian.com/cloud/admin/user-management/rest/api-group-profile/#api-group-profile
    async updateIdentityProfile({ aaid: aaid, extendedProfile: extendedProfile }) {
        return (0, $6EFID.errorHandleResponse)(await this.fetch(`/users/${aaid}/manage/profile`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                extended_profile: {
                    ...extendedProfile
                }
            }),
            credentials: 'include'
        }));
    }
    async getSignupServerXsrfToken() {
        return (0, $6EFID.mapResponseToText)(await this.fetch(`/bxp/signup/auth/xsrf`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'web-platform': 'bxp-web-platform',
                accept: 'text/plain'
            }
        }));
    }
    /**
   * Get the authentication methods available to a given user.
   *
   * @see https://bxp-signup-server.us-west-2.prod.atl-paas.net/swagger/#/Identity/post_authentication_methods_available
   */ async checkAuthenticationMethodsAvailable({ email: email, application: application = 'wac', successRedirect: successRedirect }) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $ZSmFY.getAtlCohortIdFromCookie)();
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/authentication/methods-available`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'web-platform': 'bxp-web-platform',
                'X-Atl-Cohort-Id': atlCohortId,
                'x-b3-sampled': '1'
            },
            credentials: 'include',
            body: JSON.stringify({
                email: email,
                application: application,
                continue: successRedirect
            })
        }));
    }
    async availableProducts({ cloudSessionTokenCookie: cloudSessionTokenCookie, removeNonAdminSites: removeNonAdminSites, includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite, makeS2sRequest: makeS2sRequest, userContext: userContext, retryAttempted: retryAttempted }) {
        let baseUrl = this.baseUrl ? `${this.baseUrl}/ais/available-products` : `/ais/available-products`;
        const headers = {
            ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
            'web-platform': 'bxp-web-platform',
            credentials: 'include',
            'x-b3-sampled': '1'
        };
        if (makeS2sRequest && this.isSSR()) {
            // @ts-expect-error ssrContext is provided by the SSR runtime.
            const awsRegion = globalThis.ssrContext.awsRegion;
            // S2S calls only work if the downstream service exists in the same region that our tesseract runtime is in
            const downStreamServiceExistsInSameTesseractRuntimeRegion = $3ee851d238fc5aad$export$82617393f6a222b1.has(awsRegion);
            if (!downStreamServiceExistsInSameTesseractRuntimeRegion) {
                console.log('Downstream service does not exist in the same region as current tesseract region. Current tesseract region: ' + awsRegion);
                // Make non S2S call
                return await this.availableProducts({
                    cloudSessionTokenCookie: cloudSessionTokenCookie,
                    removeNonAdminSites: removeNonAdminSites,
                    includeInvalidSites: includeInvalidSites,
                    includeInvalidBitbucketSite: includeInvalidBitbucketSite,
                    makeS2sRequest: undefined
                });
            }
            headers['x-ssr-service-name'] = 'bxp-express';
            // bxp-express service does not have any dev instances. So if it's dev -> we should point calls to stg
            const environmentType = // @ts-expect-error ssrContext is provided by the SSR runtime.
            globalThis.ssrContext.environmentType;
            if (environmentType === 'dev') {
                // bxp-express service does not have any dev instances so when we're in dev, point to staging
                headers['x-ssr-service-env'] = 'staging';
                headers['x-ssr-service-region'] = 'us-east-1'; // Bxp-express service in staging only lives in us-east-1 or us-west-2
            }
            headers['user-context'] = userContext;
            baseUrl = '/ais/available-products';
        }
        let response;
        try {
            response = await this.fetch(baseUrl, {
                headers: headers
            }, true);
            if (response.ok) {
                const result = await response.json();
                let sites = result && result.sites || [];
                if (removeNonAdminSites) sites = sites.filter((site)=>site.adminAccess);
                if (!includeInvalidSites) sites = sites.filter((site)=>(0, $odgKo.isValidSite)({
                        site: site,
                        includeInvalidBitbucketSite: includeInvalidBitbucketSite
                    }));
                return Promise.resolve({
                    sites: sites,
                    isNewUser: !!(result && result.isNewUser)
                });
            } else return Promise.resolve({
                sites: [],
                isNewUser: false,
                callFailed: true
            });
        } catch (error) {
            if (retryAttempted === false && makeS2sRequest === true) {
                console.log('There was an error making a call to available products for s2s call - retrying with non-s2s call');
                return await this.availableProducts({
                    cloudSessionTokenCookie: cloudSessionTokenCookie,
                    removeNonAdminSites: removeNonAdminSites,
                    includeInvalidSites: includeInvalidSites,
                    includeInvalidBitbucketSite: includeInvalidBitbucketSite,
                    makeS2sRequest: undefined,
                    userContext: undefined,
                    // This will automatically passed in as non-s2s calls will go through edge/stargate,
                    retryAttempted: true
                });
            }
            throw error;
        }
    }
    /**
   * The legacy get availableProducts call from IdentityClient
   */ async availableProductsLegacy({ cloudSessionTokenCookie: cloudSessionTokenCookie, includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite }) {
        const reqUrl = `${this.baseUrl}/available-products/api/available-products`;
        const response = await fetch(reqUrl, {
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) {
            const result = await response.json();
            let sites = result && result.sites || [];
            sites = (0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).remove((0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).map(sites, (site)=>{
                const products = (0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).map(site.availableProducts, (product)=>{
                    return (0, $8dzKz.PRODUCT_KEY_MAP)[product.productType];
                }).filter((product)=>product !== undefined);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).isEmpty(products)) return {
                    adminAccess: site.adminAccess,
                    cloudId: site.cloudId,
                    displayName: site.displayName,
                    url: site.url,
                    products: products
                };
                else return null;
            }), (site)=>site !== undefined && site !== null);
            if (!includeInvalidSites) sites = sites.filter((site)=>(0, $odgKo.isValidSite)({
                    site: site,
                    includeInvalidBitbucketSite: includeInvalidBitbucketSite
                }));
            return Promise.resolve(sites);
        } else throw new (0, $7heEc.UnsuccessfulFetchError)({
            response: response
        });
    }
    async activateProduct(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $ZSmFY.getAtlCohortIdFromCookie)();
        const headers = (0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie);
        Object.assign(headers, {
            'Content-Type': 'application/json',
            'xsrf-token': xsrfToken,
            'X-Atl-Cohort-Id': atlCohortId,
            'web-platform': 'bxp-web-platform',
            'x-b3-sampled': '1',
            'recaptcha-site-key': (0, $kNE9Z.getReCaptchaKey)(),
            ...(0, $fHaFy.mapLocalStorageTraceIdToPayload)()
        });
        const body = {
            ...request,
            ...(0, $fHaFy.mapLocalStorageUserMetaToPayload)()
        };
        const upstreamResponse = await (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/activate-product`, {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            body: JSON.stringify(body)
        }));
        return upstreamResponse;
    }
    /**
   * Get a list of Bitbucket workspaces
   * @param nextUrl - override the request URL for pagination
   * bitbucket/user/permissions/workspaces?sort=workspace.slug
   */ async bitbucketWorkspaces({ nextUrl: nextUrl, cloudSessionTokenCookie: cloudSessionTokenCookie, urlQuery: urlQuery }) {
        let reqUrl = `${this.baseUrl}/bitbucket/user/permissions/workspaces`;
        if (nextUrl) reqUrl = nextUrl;
        if (urlQuery) reqUrl = `${reqUrl}?${urlQuery}`;
        const response = await fetch(reqUrl, {
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) return Promise.resolve(await response.json());
        else throw new (0, $7heEc.UnsuccessfulFetchError)({
            response: response
        });
    }
    async checkCloudNameAvailability({ cloudName: cloudName, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const headers = (0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie);
        Object.assign(headers, {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'web-platform': 'bxp-web-platform'
        });
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/hostname/cloud/availability/check`, {
            method: 'post',
            body: JSON.stringify({
                cloudName: cloudName
            }),
            headers: headers,
            credentials: 'include'
        }));
    }
    async getAvailableSites(request) {
        const { orderId: orderId, transactionAccount: transactionAccount } = request;
        return (0, $6EFID.mapResponseToJson)(await fetch(`${this.baseUrl}/bxp/signup/v1/order/${orderId}/available-sites`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform',
                'X-Transaction-Account': transactionAccount,
                'x-b3-sampled': '1'
            },
            credentials: 'include'
        }));
    }
    async getRecommendedSiteName(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $ZSmFY.getAtlCohortIdFromCookie)();
        const headers = (0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie);
        Object.assign(headers, {
            'Content-Type': 'application/json',
            'xsrf-token': xsrfToken,
            'X-Atl-Cohort-Id': atlCohortId,
            'web-platform': 'bxp-web-platform'
        });
        const response = await (0, $6EFID.mapResponseToJson)(await this.fetch('/bxp/signup/site/recommended-name', {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            body: JSON.stringify(request)
        }));
        return response;
    }
    async getCloudStatus({ cloudId: cloudId, requestId: requestId }) {
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/cofs/${cloudId}/status/${requestId}`, {
            headers: {
                'Content-Type': 'application/json',
                'X-Rate-Limit-Request-Id': requestId,
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        }));
    }
    async getProductActivationStatus(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/activate/status/${request.provisioningRequestId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'web-platform': 'bxp-web-platform',
                'provision-polling-times': `${request.provisionPollingTimes}`,
                'x-b3-sampled': '1'
            },
            credentials: 'include'
        }));
    }
    async getUserPermissionsIsPermitted({ permissionId: permissionId, resourceId: resourceId, dontRequirePrincipalInSite: dontRequirePrincipalInSite }) {
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/permissions/permitted`, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                permissionId: permissionId,
                resourceId: resourceId,
                dontRequirePrincipalInSite: dontRequirePrincipalInSite
            })
        }));
    }
    async getUserProfile({ cloudSessionTokenCookie: cloudSessionTokenCookie, productName: productName, makeS2sRequest: makeS2sRequest, userContext: userContext }) {
        const queryString = productName ? `?${new URLSearchParams({
            productName: productName
        })}` : '';
        let baseUrl = this.baseUrl ? `${this.baseUrl}/bxp/signup/user/profile${queryString}` : `/bxp/signup/user/profile${queryString}`;
        const headers = {
            ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
            'web-platform': 'bxp-web-platform'
        };
        if (makeS2sRequest && this.isSSR()) {
            // @ts-expect-error ssrContext is provided by the SSR runtime.
            const awsRegion = globalThis.ssrContext.awsRegion;
            const environmentType = // @ts-expect-error ssrContext is provided by the SSR runtime.
            globalThis.ssrContext.environmentType;
            if ($3ee851d238fc5aad$export$2f6f3c380745077.has(awsRegion) && environmentType !== 'dev') {
                headers['x-ssr-service-name'] = 'bxp-signup-server';
                headers['x-ssr-service-region'] = awsRegion;
                headers['user-context'] = userContext;
                baseUrl = `/user/profile${queryString}`;
            } else if (environmentType === 'dev') {
                headers['x-ssr-service-name'] = 'bxp-signup-server';
                headers['x-ssr-service-region'] = 'us-west-2';
                headers['user-context'] = userContext;
                baseUrl = `/user/profile${queryString}`;
            }
        }
        return (0, $6EFID.mapResponseToJson)(await this.fetch(baseUrl, {
            headers: headers,
            credentials: 'include',
            method: 'GET'
        }, true));
    }
    async postExpandFreeValidation(request) {
        const { cloudId: cloudId, productKeys: productKeys } = request;
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/cloud/expand-free-validation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include',
            body: JSON.stringify({
                cloudId: cloudId,
                productKeys: productKeys
            })
        }));
    }
    async getActivationAuthorization(request) {
        const { productKeys: productKeys, productEdition: productEdition, cloudId: cloudId, siteName: siteName } = request;
        const atlCohortId = (0, $ZSmFY.getAtlCohortIdFromCookie)();
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/activation-authorization?${new URLSearchParams({
            productKeys: productKeys.join(','),
            productEdition: productEdition,
            cloudId: cloudId ?? '',
            siteName: siteName
        })}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Atl-Cohort-Id': atlCohortId,
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        }));
    }
    async getCcpHamsStatus() {
        return {
            service: 'CCP'
        };
    }
    async getLicenceInformationStatus(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/cloud/${request.cloudId}/license-information`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        }));
    }
    async postProductActivate(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/product/activate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'web-platform': 'bxp-web-platform',
                'x-b3-sampled': '1',
                'recaptcha-site-key': (0, $kNE9Z.getReCaptchaKey)()
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }));
    }
    async postCloudSignUp({ payload: payload }) {
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/cloud/signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform'
            },
            body: JSON.stringify(payload),
            credentials: 'include'
        }));
    }
    /**
   * For attaching a product to an existing site using COFS, xflow worked on the endpoint
   */ async postCOFSProductActivate(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const { cloudId: cloudId } = request;
        return (0, $6EFID.mapResponseToJson)(await fetch(`${this.baseUrl}/xflow/${cloudId}/activate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }));
    }
    async user() {
        const response = await this.fetch('/bxp/signup/user', {
            headers: {
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) {
            const result = await response.json();
            return Promise.resolve(result);
        }
        return Promise.resolve(undefined);
    }
    async userSignup(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $ZSmFY.getAtlCohortIdFromCookie)();
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/identity/user-signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'X-Atl-Cohort-Id': atlCohortId,
                'web-platform': 'bxp-web-platform',
                'x-b3-sampled': '1',
                'recaptcha-site-key': (0, $kNE9Z.getReCaptchaKey)()
            },
            credentials: 'include',
            body: JSON.stringify({
                ...request
            })
        }));
    }
    async getConsentConfig() {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/preferencesV2/consent-config`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform',
                'xsrf-token': xsrfToken
            },
            credentials: 'include'
        }));
    }
    async updateConsentPreferences(postData) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const preferencesV2Update = await this.fetch(`/preferencesV2/update`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken
            },
            credentials: 'include',
            body: JSON.stringify(postData)
        });
        return preferencesV2Update.status;
    }
    async getInviteLink(postData) {
        return this.fetch(`/bxp/signup/experimental/confluence/product/onboarding/invitation_url`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include',
            body: JSON.stringify(postData)
        }).then((response)=>response.json());
    }
    async submitConfluenceOnboardingSelections(postData) {
        return this.fetch(`/bxp/signup/experimental/confluence/product/onboarding`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include',
            body: JSON.stringify(postData)
        }).then((response)=>response.json());
    }
    isSSR() {
        return typeof window === 'undefined';
    }
    async getUserSegmentationRedirectAdvice(params) {
        const response = await this.fetch(`/user-seg-redirector/v1/redirect-advice?${params.userId}&${JSON.stringify(params.continue)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) return await response.json();
        else return {
            redirect: true,
            cloudId: '',
            duration: 0
        };
    }
    async postJiraProjectCreate(request) {
        const response = await this.fetch('/bxp/signup/experimental/jira/project/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(request)
        });
        if (response.ok) {
            const result = await response.json();
            return result;
        }
        let result;
        try {
            result = await response.json();
        } catch  {
            result = {
                error: 'Body Empty'
            };
        }
        switch(response.status){
            case 400:
                if (result.error === '') throw new Error((0, $9tcM4.JiraProjectCreateErrors).noProjectCreateAccess);
                if (result.error.includes('uses this project key')) throw new Error((0, $9tcM4.JiraProjectCreateErrors).projectKeyCollision);
                if (result.error.includes('project with that name already exists')) throw new Error((0, $9tcM4.JiraProjectCreateErrors).projectNameCollision);
                throw new Error((0, $9tcM4.JiraProjectCreateErrors).badRequest);
            case 403:
                throw new Error((0, $9tcM4.JiraProjectCreateErrors).noSiteAccess);
            case 500:
            default:
                throw new Error((0, $9tcM4.JiraProjectCreateErrors).badGateway);
        }
    }
    async postJiraSimplifiedProjectCreate({ cloudId: cloudId, key: key, name: name, templateKey: templateKey }) {
        const response = await this.fetch(`/ex/jira/${cloudId}/rest/simplified/latest/project`, {
            method: 'POST',
            headers: {
                'web-platform': 'bxp-web-platform',
                'X-Atlassian-Token': 'no-check',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                key: key,
                name: name,
                templateKey: templateKey
            })
        });
        if (response.ok) return await response.json();
        throw new (0, $7heEc.ProjectCreateError)(response);
    }
    async postRequestAccessUserResource(params) {
        const response = await this.fetch('/bxp/signup/product/join', {
            method: 'POST',
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(params.cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(params.requestBody)
        });
        return response.json();
    }
    /* istanbul ignore next */ async getAccountOrgs({ cloudSessionTokenCookie: cloudSessionTokenCookie, skipNames: skipNames, getOrgType: getOrgType, includeDefaultDir: includeDefaultDir }) {
        const searchParams = new URLSearchParams({
            skipNames: skipNames ? 'true' : 'false',
            getOrgType: getOrgType ? 'true' : 'false',
            includeDefaultDir: includeDefaultDir ? 'true' : 'false'
        });
        const response = await this.fetch(`/bxp/signup/account/orgs?${searchParams}`, {
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform',
                'x-b3-sampled': '1'
            },
            credentials: 'include'
        });
        if (response.ok) {
            const result = await response.json();
            return {
                success: true,
                accountOrgs: result
            };
        } else return {
            success: false
        };
    }
    async getAdminhubAccountOrgs({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/adminhub/organization/my3`, {
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) {
            const result = await response.json();
            return {
                success: true,
                accountOrgs: result
            };
        } else {
            (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching adminhub account orgs', response.status, response.statusText, response.url);
            return {
                success: false
            };
        }
    }
    async getAdminhubOrgDetails({ cloudSessionTokenCookie: cloudSessionTokenCookie, orgId: orgId }) {
        const response = await this.fetch(`/adminhub/organization/${orgId}`, {
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) {
            const result = await response.json();
            return {
                success: true,
                organization: result
            };
        } else return {
            success: false
        };
    }
    async getSignupAccountOrgDetails({ cloudSessionTokenCookie: cloudSessionTokenCookie, orgId: orgId, offeringIds: offeringIds }) {
        try {
            const response = await this.fetch(`/bxp/signup/v1/account/org?${new URLSearchParams({
                orgId: orgId,
                ...offeringIds && offeringIds.length > 0 ? {
                    offeringIds: offeringIds.join(',')
                } : {}
            })}`, {
                headers: {
                    ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                    'web-platform': 'bxp-web-platform',
                    'x-b3-sampled': '1'
                },
                credentials: 'include'
            });
            if (response.ok) {
                const result = await response.json();
                return {
                    success: true,
                    organization: {
                        id: orgId,
                        ...result
                    }
                };
            } else return {
                success: false
            };
        } catch  {
            return {
                success: false
            };
        }
    }
    async activateDirectBuyOnOrg(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $ZSmFY.getAtlCohortIdFromCookie)();
        const headers = (0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie);
        Object.assign(headers, {
            'Content-Type': 'application/json',
            'xsrf-token': xsrfToken,
            'X-Atl-Cohort-Id': atlCohortId,
            'web-platform': 'bxp-web-platform',
            'x-b3-sampled': '1'
        });
        return (0, $6EFID.mapResponseToJson)(await fetch(`${this.baseUrl}/bxp/signup/activation`, {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            body: JSON.stringify({
                timezone: request.timezone,
                region: request.region,
                orderId: request.orderId,
                orgId: request.orgId,
                transactionAccountId: request.transactionAccountId
            })
        }));
    }
    async getAccountProducts({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch('/bxp/signup/account/products', {
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) {
            const result = await response.json();
            return {
                success: true,
                accountProducts: result
            };
        } else return {
            success: false
        };
    }
    async getActivationType({ orderId: orderId, transactionAccount: transactionAccount }) {
        const response = await this.fetch(`/bxp/signup/activation/type?orderId=${orderId}&transactionAccountId=${transactionAccount}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform',
                'x-b3-sampled': '1'
            },
            credentials: 'include'
        });
        if (response.ok) return response.json();
        else throw new (0, $7heEc.UnsuccessfulFetchError)({
            response: response
        });
    }
    /* istanbul ignore next */ async cofsCreateOrg(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $ZSmFY.getAtlCohortIdFromCookie)();
        return (0, $6EFID.mapResponseToJson)(await fetch(`${this.baseUrl}/bxp/signup/cofs-create-organization`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'X-Atl-Cohort-Id': atlCohortId,
                'web-platform': request.webPlatform || 'no-platform'
            },
            credentials: 'include',
            body: JSON.stringify(request)
        }));
    }
    /* istanbul ignore next */ async bitbucketValidateWorkspaceSlug({ workspaceSlug: workspaceSlug }) {
        return (0, $6EFID.mapResponseToJson)(await fetch(`${this.baseUrl}/bitbucket/api/internal/workspace/slug/validate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                workspace_slug: workspaceSlug
            })
        }));
    }
    async getCloudProductInfo(request) {
        return (0, $6EFID.mapResponseToJson)(await fetch(`${this.baseUrl}/bxp/signup/v1/cloud/${request.cloudId}/product-information`, {
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        }));
    }
    async activateDirectBuyProduct(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $6EFID.mapResponseToJson)(await fetch(`${this.baseUrl}/bxp/signup/v1/order/${request.orderId}/activation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'X-Transaction-Account': request.transactionAccountId,
                'web-platform': request.webPlatform || 'no-platform',
                'x-b3-sampled': '1'
            },
            credentials: 'include',
            body: JSON.stringify({
                timezone: request.timezone,
                region: request.region,
                site: request.site,
                ...request.orgId ? {
                    orgId: request.orgId
                } : {}
            })
        }));
    }
    async putThemePreference({ cloudId: cloudId, product: product, theme: theme }) {
        const updateThemePreference = await this.fetch(`/ex/jira/${cloudId}/rest/api/3/mypreferences?key=${product}.user.theme.preference`, {
            method: 'PUT',
            headers: {
                'web-platform': 'bxp-web-platform',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                value: theme
            })
        });
        if (!updateThemePreference.ok) throw new Error(`Failed to update theme preference: ${updateThemePreference.statusText}`);
        return true;
    }
    async sampleProjectCreate({ cloudId: cloudId, template: template, teamType: teamType, issueTypes: issueTypes, statusNames: statusNames, projectName: projectName, projectKey: projectKey, customDetail: customDetail }) {
        const MAX_RETRIES = 5;
        const BACKOFF_DELAY = 1000; // Start with 1-second delay
        const postRequest = async ()=>{
            const createProjectResponse = await this.fetch(`/ex/jira/${cloudId}/rest/onboarding/v1/projects`, {
                method: 'POST',
                headers: {
                    'web-platform': 'bxp-web-platform',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    issueTypes: issueTypes,
                    statusNames: statusNames,
                    projectName: projectName,
                    projectKey: projectKey,
                    template: template,
                    teamType: teamType,
                    customDetail: customDetail
                })
            });
            if (!createProjectResponse.ok) throw new Error(`Failed to create project: ${createProjectResponse.statusText}`);
            const { taskId: taskId } = await createProjectResponse.json();
            const taskResponse = await this.pollTaskUntilComplete(taskId, cloudId);
            return {
                projectId: taskResponse.result.projectId || ''
            };
        };
        let retryCount = 0;
        while(retryCount < MAX_RETRIES)try {
            return await postRequest();
        } catch (error) {
            // task failures should not attempt a project creation again
            if (error instanceof (0, $9tcM4.TaskError)) {
                console.error(`Task failed with status: ${error.status}, message: ${error.taskMessage}`);
                throw error;
            }
            retryCount++;
            if (retryCount >= MAX_RETRIES) {
                console.error(`Max retries reached. Unable to create the project.`);
                throw new Error(`Failed to create project after ${MAX_RETRIES} attempts.`);
            }
            // Exponential backoff
            const delay = BACKOFF_DELAY * Math.pow(2, retryCount - 1);
            console.warn(`Retrying sample project creation (attempt ${retryCount} of ${MAX_RETRIES}) in ${delay}ms...`);
            // Wait before retrying
            await this.delay(delay);
        }
        // This should never be reached because the loop either succeeds or throws
        throw new Error('Unexpected error in project creation.');
    }
    // Utility function to delay for a specified number of milliseconds
    async delay(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    async wizardProjectCreate(payload) {
        const createProjectResponse = await this.fetch(`/ex/jira/${payload.cloudId}/rest/onboarding/v1/projects`, {
            method: 'POST',
            headers: {
                'web-platform': 'bxp-web-platform',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                issueTypes: payload.issueTypes,
                statusNames: payload.statusNames,
                projectName: payload.projectName,
                projectKey: payload.projectKey,
                template: payload.template,
                teamType: payload.teamType,
                customDetail: payload.customDetail,
                sampleIssues: payload.sampleIssues,
                selectedAgentTools: payload.selectedAgentTools
            })
        });
        if (!createProjectResponse.ok) {
            const errorMessage = await (0, $6EFID.getErrorMessage)(createProjectResponse);
            throw new Error(`Failed to create project: ${createProjectResponse.statusText}, ${createProjectResponse.status}, ${errorMessage}`);
        }
        const { taskId: taskId } = await createProjectResponse.json();
        return {
            taskId: taskId
        };
    }
    async postProjectCreate(payload) {
        const createProjectResponse = await this.fetch(`/ex/jira/${payload.cloudId}/rest/onboarding/v1/projects`, {
            method: 'POST',
            headers: {
                'web-platform': 'bxp-web-platform',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                issueTypes: payload.issueTypes,
                statusNames: payload.statusNames,
                projectName: payload.projectName,
                projectKey: payload.projectKey,
                template: payload.template,
                teamType: payload.teamType,
                customDetail: payload.customDetail,
                sampleIssues: payload.sampleIssues
            })
        });
        if (!createProjectResponse.ok) throw new (0, $7heEc.ProjectCreateError)(createProjectResponse);
        const { taskId: taskId } = await createProjectResponse.json();
        return {
            taskId: taskId
        };
    }
    async putUserProperty({ tenantId: tenantId, propertyKey: propertyKey, data: data }) {
        const accountId = (0, $6GqRO.default).get('__aid_user_id');
        const response = await this.fetch(`/ex/jira/${tenantId}/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error(`Failed to create project: ${response.statusText}`);
        return response.ok;
    }
    async putSampleProjectUserProperties({ projectId: projectId, tenantId: tenantId }) {
        const propertyKey = `jira.onboarding.view.sample.project.cta.tenant.${tenantId}`;
        return this.putUserProperty({
            tenantId: tenantId,
            propertyKey: propertyKey,
            data: {
                status: 'ENABLED',
                timestamp: Date.now(),
                projectIds: [
                    projectId
                ]
            }
        });
    }
    async pollTaskUntilComplete(taskId, cloudId, TIMEOUT = (0, $9tcM4.POLL_TASK_TIMEOUT)) {
        const abortController = new AbortController();
        const timeoutId = setTimeout(()=>abortController.abort(), TIMEOUT);
        const pollTask = async ()=>{
            try {
                const response = await this.fetchTask(taskId, cloudId);
                switch(response.status){
                    case 'CANCEL_REQUESTED':
                    case 'CANCELLED':
                    case 'DEAD':
                    case 'FAILED':
                        throw new (0, $9tcM4.TaskError)('Task failed', {
                            id: taskId,
                            status: response.status,
                            taskMessage: response.message
                        });
                    case 'ENQUEUED':
                    case 'RUNNING':
                        await new Promise((resolve)=>setTimeout(resolve, 1000));
                        return pollTask();
                    case 'COMPLETE':
                        clearTimeout(timeoutId);
                        return response;
                    default:
                        throw new (0, $9tcM4.TaskError)('Unknown task status', {
                            id: taskId,
                            status: response.status,
                            taskMessage: response.message
                        });
                }
            } catch (error) {
                if (abortController.signal.aborted) throw new Error('Task polling timed out');
                throw error;
            }
        };
        return pollTask();
    }
    async fetchTask(taskId, cloudId) {
        return this.fetch(`/ex/jira/${cloudId}/rest/api/3/task/${taskId}`, {
            method: 'GET',
            credentials: 'include'
        }).then((response)=>response.json());
    }
    async fetchProjectRoles(cloudId, projectId) {
        return this.fetch(`/ex/jira/${cloudId}/rest/api/3/project/${projectId}/role`, {
            method: 'GET',
            credentials: 'include'
        }).then((response)=>response.json());
    }
    /* istanbul ignore next */ async asyncNewSiteActivation(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $ZSmFY.getAtlCohortIdFromCookie)();
        const headers = {
            'Content-Type': 'application/json',
            'xsrf-token': xsrfToken,
            'X-Atl-Cohort-Id': atlCohortId,
            'web-platform': 'bxp-web-platform',
            'recaptcha-site-key': (0, $kNE9Z.getReCaptchaKey)()
        };
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/v1/activation-orchestration/new-site`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(request),
            headers: headers
        }));
    }
    /* istanbul ignore next */ async asyncActivationStatus(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const headers = {
            'Content-Type': 'application/json',
            'xsrf-token': xsrfToken,
            'web-platform': 'bxp-web-platform'
        };
        return (0, $6EFID.mapResponseToJson)(await this.fetch(`/bxp/signup/v1/activation-orchestration/status?workflowId=${request.workflowId}`, {
            method: 'GET',
            credentials: 'include',
            headers: headers
        }));
    }
    async getOrgServers({ orgId: orgId, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/migrations/metadata/v1/org/${orgId}/server`, {
            method: 'GET',
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (response.ok) {
            const result = await response.json();
            if (result.data === undefined) return Promise.resolve({
                data: []
            });
            return Promise.resolve({
                data: result.data
            });
        } else {
            (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching org servers', response.status, response.statusText, response.url);
            throw new (0, $7heEc.UnsuccessfulFetchError)({
                message: 'Error fetching org servers',
                response: response
            });
        }
    }
    async getL1Assessments({ orgId: orgId, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/mcc/v2/orgs/${orgId}/l1-assessments/`, {
            method: 'GET',
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching l1 assessments', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getMigrationPlanTotals({ orgId: orgId, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/migrations/planning/v1/org/${orgId}/totals/scope`, {
            method: 'GET',
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching migration plan totals', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getAvailableSitesForFastshift({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/app-switcher/api/available-products?product=WAC`, {
            method: 'GET',
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform'
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching available products', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getCspGraphqlRequest({ request: request, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/customer-support/csp/graphql`, {
            method: 'POST',
            headers: {
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
                'web-platform': 'bxp-web-platform',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: request
        });
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getInstances({ orgId: orgId, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/mcc/v1/orgs/${orgId}/discover/instances`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching MMA instances', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getFastshiftUserAccess(request) {
        const response = await this.fetch(`/fastshift-portal/v1/user/access`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching user access', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getFastshiftCustomerDomains(request) {
        const params = new URLSearchParams({
            page: request.page.toString(),
            size: request.size.toString()
        });
        if (request.sortBy) params.append('sortBy', request.sortBy);
        if (request.sortDirection) params.append('sortDirection', String(request.sortDirection));
        if (request.searchTerm) params.append('queryTerm', request.searchTerm);
        if (request.filters['status']) params.append('status', request.filters['status']);
        const response = await this.fetch(`/fastshift-portal/v1/user/domains?${params.toString()}`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching customer domains list', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getUserBillingAdminTransactionAccounts({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const headers = {
            ...(0, $lr4yY.mapCookieToHeaders)(cloudSessionTokenCookie),
            'web-platform': 'bxp-web-platform'
        };
        const response = await this.fetch('/ccp/api/v1/transaction-accounts', {
            method: 'GET',
            headers: headers,
            credentials: 'include'
        });
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getFastshiftCustomerDomainEngagement(request) {
        const response = await this.fetch(`/fastshift-portal/v1/engagement/${request.customerDomainId}`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) {
            if (response.status === 401) throw new Error((0, $9tcM4.CustomerDomainEngagementExpectedError).NO_ACCESS);
            else if (response.status === 403) throw new Error((0, $9tcM4.CustomerDomainEngagementExpectedError).USER_NOT_PROVISIONED);
            else if (response.status === 404) throw new Error((0, $9tcM4.CustomerDomainEngagementExpectedError).NO_ENGAGEMENT);
            else (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching customer domain engagement details', response.status, response.statusText, response.url);
        }
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getFastshiftCustomerDomain(request) {
        const response = await this.fetch(`/fastshift-portal/v1/user/domain/${request.customerDomainId}`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) {
            if (response.status === 401) throw new Error((0, $9tcM4.CustomerDomainExpectedError).NO_ACCESS);
            else if (response.status === 404) throw new Error((0, $9tcM4.CustomerDomainExpectedError).NOT_FOUND);
            else (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching customer domain details', response.status, response.statusText, response.url);
        }
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getFastshiftSupportRequests(request) {
        const queryString = new URLSearchParams(request.queryParams).toString();
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.customerDomainId}${queryString ? `?${queryString}` : ''}`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching support requests', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getFastshiftTopSupportRequests(request) {
        const queryString = new URLSearchParams(request.queryParams).toString();
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.domainId}/top${queryString ? `?${queryString}` : ''}`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching top support requests', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    // fetch whether the user has consented already
    async fetchFastshiftPortalConsentRequest(request) {
        const response = await this.fetch('/fastshift-portal/v1/consent/portal/fetch', {
            method: 'POST',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie),
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(request.requestBody)
        });
        if (!response.ok) {
            (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching fastshift portal consent status', response.status, response.statusText, response.url);
            throw new Error('Error on fetching fastshift portal consent status');
        }
        return (0, $6EFID.mapResponseToJson)(response);
    }
    // record the user's consent
    async sendFastshiftPortalConsent(request) {
        const response = await this.fetch('/fastshift-portal/v1/consent/portal', {
            method: 'POST',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie),
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(request.requestBody)
        });
        if (!response.ok) {
            (0, $6Spiu.sendFastshiftSentryAlert)('Error on sending fastshift portal consent acceptance', response.status, response.statusText, response.url);
            throw new Error('Error on sending fastshift portal consent acceptance');
        }
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getFastshiftRunbooksBySupportTicketId(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching runbooks by support ticket id', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getFastshiftRunbook(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks/${request.runbookId}`, {
            method: 'GET',
            headers: {
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include'
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on fetching runbook', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async updateFastshiftRunbookStepStatus(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks/${request.runbookId}/steps/${request.stepId}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include',
            body: JSON.stringify({
                status: request.status,
                ...request.note ? {
                    note: request.note
                } : {},
                title: request.title,
                phase: request.phase,
                responsible: request.responsible
            })
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on updating runbook step status', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async updateFastshiftRunbookStepRisk(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks/${request.runbookId}/steps/${request.stepId}/risk`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include',
            body: JSON.stringify({
                risk: request.risk
            })
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on updating runbook step risk', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async updateFastshiftRunbookStepDisabled(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks/${request.runbookId}/steps/${request.stepId}/disabled`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'web-platform': 'bxp-web-platform',
                ...(0, $lr4yY.mapCookieToHeaders)(request.cloudSessionTokenCookie)
            },
            credentials: 'include',
            body: JSON.stringify({
                disabled: request.disabled
            })
        });
        if (!response.ok) (0, $6Spiu.sendFastshiftSentryAlert)('Error on updating runbook step disabled state', response.status, response.statusText, response.url);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async activateProductCrossflowPlan(request) {
        const provisioningApiUrl = `/xflow/provision/cloud/${request.cloudId}/product/${request.productKey}/job/${request.jobName}/plan`;
        const response = await this.fetch(provisioningApiUrl, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request.context)
        });
        const data = await (0, $6EFID.mapResponseToJson)(response);
        return data;
    }
    async activateProductCrossflow(request) {
        const provisioningApiUrl = `/xflow/provision/cloud/${request.cloudId}/product/${request.productKey}/job/${request.jobName}/start`;
        const response = await this.fetch(provisioningApiUrl, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request.context)
        });
        const data = await (0, $6EFID.mapResponseToJson)(response);
        if (!data.started) throw new Error('Provisioning failed');
        return data;
    }
    async waitForActivateProductCrossflow(request) {
        const response = await this.fetch(`/xflow/provision/cloud/${request.cloudId}/product/${request.productKey}/job/${request.jobName}/status`, {
            method: 'GET',
            credentials: 'include'
        });
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async postMadlibContentGeneration(cloudId, request) {
        const headers = {
            'web-platform': 'bxp-web-platform',
            'Content-Type': 'application/json',
            'X-Atlassian-CloudId': cloudId
        };
        const response = await this.fetch('/gcg/api/v1/generate/team_growth/jira_onboarding_madlibs_sample_issues', {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            body: JSON.stringify(request)
        });
        if (!response.ok) throw new (0, $7heEc.MadlibContentGenerationError)(response);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async postContentGenerationForJiraFfl(request) {
        const headers = {
            'web-platform': 'bxp-web-platform',
            'Content-Type': 'application/json',
            // Keep parity with activate-product calls which include recaptcha key as a header.
            'recaptcha-site-key': (0, $kNE9Z.getReCaptchaKey)()
        };
        const response = await this.fetch('/gcg/api/v1/generate/team_growth/jira_ffl_sample_issues', {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            body: JSON.stringify(request)
        });
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async getJiraFFLContentByCgsKey(cgsKey) {
        const headers = {
            'web-platform': 'bxp-web-platform',
            'Content-Type': 'application/json'
        };
        const response = await this.fetch(`/gcg/api/v1/generate/team_growth/jira_ffl_sample_issues/cache/${cgsKey}`, {
            method: 'GET',
            headers: headers,
            credentials: 'include'
        });
        if (!response.ok) throw new (0, $7heEc.MadlibContentGenerationError)(response);
        return (0, $6EFID.mapResponseToJson)(response);
    }
    async postEmailInvite(cloudId, projectId, request) {
        const response = await this.fetch(`/ex/jira/${cloudId}/rest/internal/latest/invite-user/request-access/project/${projectId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(request)
        });
        if (!response.ok) throw new (0, $7heEc.UnsuccessfulFetchError)({
            message: 'Invite was unsuccessful',
            response: response
        });
        return (0, $6EFID.mapResponseToJson)(response);
    }
}
const $3ee851d238fc5aad$export$98ec7f86e3388cfc = ()=>{
    if (typeof window !== 'undefined') return window.location.hostname.includes('fastshift') ? (0, $6Spiu.FASTSHIFT_STARGATE_BASE_URL) : $3ee851d238fc5aad$var$BASE_URL;
    // Add safety check for globalThis.location
    if (globalThis.location) return globalThis.location.hostname.includes('fastshift') ? (0, $6Spiu.FASTSHIFT_STARGATE_BASE_URL) : $3ee851d238fc5aad$var$BASE_URL;
    // Fallback if globalThis.location is not available
    return $3ee851d238fc5aad$var$BASE_URL;
};
const $3ee851d238fc5aad$var$BxpWebStargateClientContext = /*#__PURE__*/ (0, $1oC0p.createContext)(new $3ee851d238fc5aad$export$963f114b487aad6d({
    baseUrl: $3ee851d238fc5aad$export$98ec7f86e3388cfc()
}));
function $3ee851d238fc5aad$export$ac42303986bb641e() {
    return (0, $1oC0p.useContext)($3ee851d238fc5aad$var$BxpWebStargateClientContext);
}
const $3ee851d238fc5aad$export$dc976c529d501f0c = (props)=>{
    const { children: children } = props;
    if ($3ee851d238fc5aad$var$isBaseUrlStargateClientProviderProps(props)) return /*#__PURE__*/ (0, $7VQPk.jsx)($3ee851d238fc5aad$var$BxpWebStargateClientContext.Provider, {
        value: new $3ee851d238fc5aad$export$963f114b487aad6d({
            baseUrl: props.baseUrl
        }),
        children: children
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)($3ee851d238fc5aad$var$BxpWebStargateClientContext.Provider, {
        value: props.client,
        children: children
    });
};
function $3ee851d238fc5aad$var$isBaseUrlStargateClientProviderProps(props) {
    return !!props?.baseUrl;
}

});
parcelRegister("yagHz", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("8dzKz", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_KEY_MAP", function () { return $7e71513a97fcddc2$export$49ebef81048c4e68; });
const $7e71513a97fcddc2$export$92fa52c125cc0e5 = 'identity-platform';
const $7e71513a97fcddc2$export$49ebef81048c4e68 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_BUSINESS: 'jira-core.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    BITBUCKET: 'com.atlassian.bitbucket',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    TRELLO: 'trello'
};

});

parcelRegister("ZSmFY", function(module, exports) {
$parcel$export(module.exports, "getAtlCohortIdFromCookie", function () { return $bc670922ed076bc6$export$a284fd3cd35fac52; });

var $gx3aw = parcelRequire("gx3aw");
function $bc670922ed076bc6$export$a284fd3cd35fac52() {
    let atlCohortId;
    try {
        const cookie = JSON.parse(decodeURIComponent((0, $gx3aw.Cookie).readCookie('atlCohort') || ''));
        atlCohortId = cookie['bucketAll'].index;
    } catch (e) {
        atlCohortId = '';
        console.warn('Cannot parse atlCohort cookie', e);
    }
    return atlCohortId;
}

});

parcelRegister("6Spiu", function(module, exports) {
$parcel$export(module.exports, "FASTSHIFT_STARGATE_BASE_URL", function () { return $1a66353c1d3bee1b$export$bc91eef109fd258b; });
$parcel$export(module.exports, "sendFastshiftSentryAlert", function () { return $1a66353c1d3bee1b$export$cdfb2f8bf93ec458; });

var $5IEWR = parcelRequire("5IEWR");
var $6Ml1x = parcelRequire("6Ml1x");
var $jSg3R = parcelRequire("jSg3R");
var $3sWBL = parcelRequire("3sWBL");
var $jcHfc = parcelRequire("jcHfc");
var $leG8s = parcelRequire("leG8s");
var $fex0p = parcelRequire("fex0p");
var $i7nxO = parcelRequire("i7nxO");
const $1a66353c1d3bee1b$var$FASTSHIFT_BASE_URL_PROD = 'https://fastshift.atlassian.com';
const $1a66353c1d3bee1b$var$FASTSHIFT_BASE_URL_STAGING = 'https://fastshift.stg.internal.atlassian.com';
const $1a66353c1d3bee1b$var$FASTSHIFT_BASE_URL_DEV = 'https://fastshift.dev.internal.atlassian.com';
const $1a66353c1d3bee1b$export$3628946b822aa707 = $1a66353c1d3bee1b$var$FASTSHIFT_BASE_URL_PROD;
const $1a66353c1d3bee1b$export$bc91eef109fd258b = `${$1a66353c1d3bee1b$export$3628946b822aa707}/gateway/api`;
const $1a66353c1d3bee1b$var$SENTRY_PROJECT_NAME = 'FASTSHIFT_PORTAL';
const $1a66353c1d3bee1b$var$getFastshiftSentryClient = ()=>new (0, $5IEWR.BrowserClient)({
        dsn: 'https://7094bf0a2bc1951c62fadea8306b7ca2@o55978.ingest.us.sentry.io/4510151685242880',
        transport: (0, $leG8s.makeFetchTransport),
        stackParser: (0, $jSg3R.defaultStackParser),
        enabled: true,
        environment: "production",
        release: window.BUILD_KEY,
        dist: window.BUILD_KEY,
        integrations: [
            ...(0, $3sWBL.getDefaultIntegrations)({}),
            (0, $jcHfc.httpClientIntegration)(),
            (0, $6Ml1x.browserTracingIntegration)()
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
            'localhost',
            /^https:\/\/atlassian\.com/
        ]
    });
const $1a66353c1d3bee1b$var$getFastshiftSentryScope = ()=>{
    const scope = new (0, $fex0p.Scope)();
    scope.setClient($1a66353c1d3bee1b$var$getFastshiftSentryClient());
    scope.setTag('projectName', $1a66353c1d3bee1b$var$SENTRY_PROJECT_NAME);
    return scope;
};
const $1a66353c1d3bee1b$export$cdfb2f8bf93ec458 = (errorMsg, httpStatus, statusText, url)=>{
    const fastshiftSentryScope = $1a66353c1d3bee1b$var$getFastshiftSentryScope();
    (0, $i7nxO.withScope)(fastshiftSentryScope, ()=>{
        fastshiftSentryScope.setContext('response', {
            status: httpStatus,
            statusText: statusText,
            url: url
        });
        fastshiftSentryScope.captureException(new Error(errorMsg));
    });
};

});
parcelRegister("5IEWR", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", function () { return $42a0d350f1c6b9eb$export$1df9218a526d318d; });

var $3O8Ld = parcelRequire("3O8Ld");
var $n7Tvt = parcelRequire("n7Tvt");
var $ctUCS = parcelRequire("ctUCS");
var $jKtbR = parcelRequire("jKtbR");
var $4iitQ = parcelRequire("4iitQ");

var $44Rfj = parcelRequire("44Rfj");

var $aT7cw = parcelRequire("aT7cw");
const $42a0d350f1c6b9eb$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $42a0d350f1c6b9eb$export$1df9218a526d318d extends (0, $jKtbR.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $aT7cw.WINDOW).SENTRY_SDK_SOURCE || (0, $4iitQ.getSDKSource)();
        (0, $ctUCS.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const client = this;
        const { sendDefaultPii: sendDefaultPii, _experiments: _experiments } = client._options;
        const enableLogs = _experiments?.enableLogs;
        if (opts.sendClientReports && (0, $aT7cw.WINDOW).document) (0, $aT7cw.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $aT7cw.WINDOW).document.visibilityState === 'hidden') {
                this._flushOutcomes();
                if (enableLogs) (0, $3O8Ld._INTERNAL_flushLogsBuffer)(client);
            }
        });
        if (enableLogs) {
            client.on('flush', ()=>{
                (0, $3O8Ld._INTERNAL_flushLogsBuffer)(client);
            });
            client.on('afterCaptureLog', ()=>{
                if (client._logFlushIdleTimeout) clearTimeout(client._logFlushIdleTimeout);
                client._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $3O8Ld._INTERNAL_flushLogsBuffer)(client);
                }, $42a0d350f1c6b9eb$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            client.on('postprocessEvent', (0, $n7Tvt.addAutoIpAddressToUser));
            client.on('beforeSendSession', (0, $n7Tvt.addAutoIpAddressToSession));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $44Rfj.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $44Rfj.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}

});
parcelRegister("3O8Ld", function(module, exports) {
$parcel$export(module.exports, "_INTERNAL_flushLogsBuffer", function () { return $2c5cd64671e5918e$export$f8ed83d3b6a0b504; });

var $jKtbR = parcelRequire("jKtbR");

var $i7nxO = parcelRequire("i7nxO");

var $4YMns = parcelRequire("4YMns");

var $k1akT = parcelRequire("k1akT");

var $86GZW = parcelRequire("86GZW");

var $9sRth = parcelRequire("9sRth");

var $lmQQj = parcelRequire("lmQQj");

var $6C6IT = parcelRequire("6C6IT");
const $2c5cd64671e5918e$var$MAX_LOG_BUFFER_SIZE = 100;
const $2c5cd64671e5918e$var$CLIENT_TO_LOG_BUFFER_MAP = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $2c5cd64671e5918e$export$84cb46f4adfc5d14(key, value) {
    switch(typeof value){
        case 'number':
            return {
                key: key,
                value: {
                    doubleValue: value
                }
            };
        case 'boolean':
            return {
                key: key,
                value: {
                    boolValue: value
                }
            };
        case 'string':
            return {
                key: key,
                value: {
                    stringValue: value
                }
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    key: key,
                    value: {
                        stringValue: stringValue
                    }
                };
            }
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $2c5cd64671e5918e$export$3ab3d16b9eebd986(beforeLog, client = (0, $i7nxO.getClient)(), scope = (0, $i7nxO.getCurrentScope)()) {
    if (!client) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $jKtbR._getTraceInfoFromScope)(client, scope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    if (release) processedLogAttributes['sentry.release'] = release;
    if (environment) processedLogAttributes['sentry.environment'] = environment;
    const { sdk: sdk } = client.getSdkMetadata() ?? {};
    if (sdk) {
        processedLogAttributes['sentry.sdk.name'] = sdk.name;
        processedLogAttributes['sentry.sdk.version'] = sdk.version;
    }
    const beforeLogMessage = beforeLog.message;
    if ((0, $86GZW.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $k1akT._getSpanForScope)(scope);
    if (span) // Add the parent span ID to the log attributes for trace context
    processedLogAttributes['sentry.trace.parent_span_id'] = span.spanContext().spanId;
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        severityText: level,
        body: {
            stringValue: message
        },
        attributes: Object.entries(attributes).map(([key, value])=>$2c5cd64671e5918e$export$84cb46f4adfc5d14(key, value)),
        timeUnixNano: `${new Date().getTime().toString()}000000`,
        traceId: traceContext?.trace_id,
        severityNumber: severityNumber ?? (0, $lmQQj.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level]
    };
    const logBuffer = $2c5cd64671e5918e$var$CLIENT_TO_LOG_BUFFER_MAP.get(client);
    if (logBuffer === undefined) $2c5cd64671e5918e$var$CLIENT_TO_LOG_BUFFER_MAP.set(client, [
        serializedLog
    ]);
    else {
        logBuffer.push(serializedLog);
        if (logBuffer.length > $2c5cd64671e5918e$var$MAX_LOG_BUFFER_SIZE) $2c5cd64671e5918e$export$f8ed83d3b6a0b504(client, logBuffer);
    }
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $2c5cd64671e5918e$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $2c5cd64671e5918e$var$CLIENT_TO_LOG_BUFFER_MAP.get(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $6C6IT.createOtelLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    logBuffer.length = 0;
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

});
parcelRegister("jKtbR", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $e608f4cad7c7da98$export$1f2bb630327ac4b6; });
$parcel$export(module.exports, "_getTraceInfoFromScope", function () { return $e608f4cad7c7da98$export$fb7d833b3fdedf5f; });

var $4taOC = parcelRequire("4taOC");

var $aPJPH = parcelRequire("aPJPH");

var $i7nxO = parcelRequire("i7nxO");

var $4YMns = parcelRequire("4YMns");

var $69U89 = parcelRequire("69U89");

var $9Gtbp = parcelRequire("9Gtbp");

var $cEs1A = parcelRequire("cEs1A");

var $64wec = parcelRequire("64wec");

var $85YNJ = parcelRequire("85YNJ");

var $4xUZv = parcelRequire("4xUZv");

var $en7rT = parcelRequire("en7rT");

var $cXjEa = parcelRequire("cXjEa");

var $k1akT = parcelRequire("k1akT");

var $8j0KV = parcelRequire("8j0KV");

var $lxHXx = parcelRequire("lxHXx");

var $lfwLF = parcelRequire("lfwLF");

var $1ICJv = parcelRequire("1ICJv");

var $bOdRo = parcelRequire("bOdRo");

var $86GZW = parcelRequire("86GZW");

var $9sRth = parcelRequire("9sRth");

var $hqa9f = parcelRequire("hqa9f");

var $deiyZ = parcelRequire("deiyZ");
/* eslint-disable max-lines */ const $e608f4cad7c7da98$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $e608f4cad7c7da98$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $e608f4cad7c7da98$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $e608f4cad7c7da98$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $e608f4cad7c7da98$var$_makeInternalError(message) {
    return {
        message: message,
        [$e608f4cad7c7da98$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $e608f4cad7c7da98$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$e608f4cad7c7da98$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $e608f4cad7c7da98$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $e608f4cad7c7da98$var$INTERNAL_ERROR_SYMBOL in error;
}
function $e608f4cad7c7da98$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $e608f4cad7c7da98$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $e608f4cad7c7da98$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $1ICJv.makeDsn)(options.dsn);
        else (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $4taOC.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $hqa9f.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $hqa9f.checkOrSetAlreadyCaught)(exception)) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log($e608f4cad7c7da98$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $hqa9f.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $86GZW.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $86GZW.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $hqa9f.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $hqa9f.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log($e608f4cad7c7da98$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $cEs1A.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $deiyZ.resolvedSyncPromise)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $9Gtbp.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $9Gtbp.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $69U89.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $bOdRo.addItemToEnvelope)(env, (0, $bOdRo.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $aPJPH.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn($e608f4cad7c7da98$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn($e608f4cad7c7da98$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $69U89.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).error('Transport disabled');
        return (0, $deiyZ.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $9Gtbp.setupIntegrations)(this, integrations);
        (0, $9Gtbp.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $cEs1A.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $deiyZ.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $cXjEa.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $i7nxO.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $64wec.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $i7nxO.getCurrentScope)(), isolationScope = (0, $i7nxO.getIsolationScope)()) {
        if ((0, $4YMns.DEBUG_BUILD) && $e608f4cad7c7da98$var$isErrorEvent(event)) (0, $9sRth.logger).log(`Captured error event \`${(0, $85YNJ.getPossibleEventMessages)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $4YMns.DEBUG_BUILD) {
                if ($e608f4cad7c7da98$var$_isDoNotSendEventError(reason)) (0, $9sRth.logger).log(reason.message);
                else if ($e608f4cad7c7da98$var$_isInternalError(reason)) (0, $9sRth.logger).warn(reason.message);
                else (0, $9sRth.logger).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $e608f4cad7c7da98$var$isTransactionEvent(event);
        const isError = $e608f4cad7c7da98$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $en7rT.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $deiyZ.rejectedSyncPromise)($e608f4cad7c7da98$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $e608f4cad7c7da98$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $e608f4cad7c7da98$var$processBeforeSend(this, options, prepared, hint);
            return $e608f4cad7c7da98$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $e608f4cad7c7da98$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($e608f4cad7c7da98$var$_isDoNotSendEventError(reason) || $e608f4cad7c7da98$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $e608f4cad7c7da98$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $lfwLF.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $1ICJv.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $e608f4cad7c7da98$export$4f22f74eddb7716a = $e608f4cad7c7da98$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $e608f4cad7c7da98$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $86GZW.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $86GZW.isPlainObject)(event) && event !== null) throw $e608f4cad7c7da98$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $e608f4cad7c7da98$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $86GZW.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $e608f4cad7c7da98$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $e608f4cad7c7da98$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($e608f4cad7c7da98$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($e608f4cad7c7da98$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $lxHXx.convertTransactionEventToSpanJson)(processedEvent));
            if (!processedRootSpanJson) (0, $8j0KV.showSpanDropWarning)();
            else // update event with processed root span values
            processedEvent = (0, $4xUZv.merge)(event, (0, $lxHXx.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $8j0KV.showSpanDropWarning)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $e608f4cad7c7da98$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $e608f4cad7c7da98$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $e608f4cad7c7da98$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    const span = (0, $k1akT._getSpanForScope)(scope);
    const traceContext = span ? (0, $8j0KV.spanToTraceContext)(span) : (0, $i7nxO.getTraceContextFromScope)(scope);
    const dynamicSamplingContext = span ? (0, $64wec.getDynamicSamplingContextFromSpan)(span) : (0, $64wec.getDynamicSamplingContextFromScope)(client, scope);
    return [
        dynamicSamplingContext,
        traceContext
    ];
}

});
parcelRegister("4taOC", function(module, exports) {
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $3412429811653b7d$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $3412429811653b7d$export$671c7ed8e40a7a57; });

var $1ICJv = parcelRequire("1ICJv");
const $3412429811653b7d$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $3412429811653b7d$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $3412429811653b7d$var$_getIngestEndpoint(dsn) {
    return `${$3412429811653b7d$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $3412429811653b7d$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $3412429811653b7d$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $3412429811653b7d$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$3412429811653b7d$var$_getIngestEndpoint(dsn)}?${$3412429811653b7d$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $3412429811653b7d$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $1ICJv.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$3412429811653b7d$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $1ICJv.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("1ICJv", function(module, exports) {
$parcel$export(module.exports, "dsnToString", function () { return $1407f20fc3d91459$export$44d472fbb931a776; });
$parcel$export(module.exports, "makeDsn", function () { return $1407f20fc3d91459$export$128827c3562ec0cb; });

var $e6nMd = parcelRequire("e6nMd");

var $9sRth = parcelRequire("9sRth");
/** Regular expression used to parse a Dsn. */ const $1407f20fc3d91459$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $1407f20fc3d91459$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $1407f20fc3d91459$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $1407f20fc3d91459$export$b892860177f70a30(str) {
    const match = $1407f20fc3d91459$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $9sRth.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $1407f20fc3d91459$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $1407f20fc3d91459$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $1407f20fc3d91459$var$validateDsn(dsn) {
    if (!(0, $e6nMd.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $9sRth.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $9sRth.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$1407f20fc3d91459$var$isValidProtocol(protocol)) {
        (0, $9sRth.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $9sRth.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $1407f20fc3d91459$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $1407f20fc3d91459$export$b892860177f70a30(from) : $1407f20fc3d91459$var$dsnFromComponents(from);
    if (!components || !$1407f20fc3d91459$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("69U89", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", function () { return $47bf1fac808e947d$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $47bf1fac808e947d$export$c31057337a18010f; });
$parcel$export(module.exports, "createSpanEnvelope", function () { return $47bf1fac808e947d$export$19a0081d4b39d77; });

var $64wec = parcelRequire("64wec");

var $8j0KV = parcelRequire("8j0KV");

var $1ICJv = parcelRequire("1ICJv");

var $bOdRo = parcelRequire("bOdRo");


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $47bf1fac808e947d$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $47bf1fac808e947d$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $bOdRo.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1ICJv.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $bOdRo.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $47bf1fac808e947d$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $bOdRo.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $47bf1fac808e947d$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $bOdRo.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $bOdRo.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $47bf1fac808e947d$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $64wec.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1ICJv.dsnToString)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $8j0KV.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $8j0KV.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $8j0KV.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $bOdRo.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $bOdRo.createEnvelope)(headers, items);
}

});
parcelRegister("bOdRo", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", function () { return $898f1d8f54338787$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $898f1d8f54338787$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $898f1d8f54338787$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $898f1d8f54338787$export$32f9b428425aac85; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $898f1d8f54338787$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $898f1d8f54338787$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $898f1d8f54338787$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $898f1d8f54338787$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $898f1d8f54338787$export$92b6093782fe661b; });

var $5TFFW = parcelRequire("5TFFW");

var $1ICJv = parcelRequire("1ICJv");

var $lvx9g = parcelRequire("lvx9g");

var $9ishN = parcelRequire("9ishN");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $898f1d8f54338787$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $898f1d8f54338787$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $898f1d8f54338787$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $898f1d8f54338787$export$604a45d95a155e2b(envelope, types) {
    return $898f1d8f54338787$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $898f1d8f54338787$var$encodeUTF8(input) {
    const carrier = (0, $5TFFW.getSentryCarrier)((0, $9ishN.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $898f1d8f54338787$var$decodeUTF8(input) {
    const carrier = (0, $5TFFW.getSentryCarrier)((0, $9ishN.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $898f1d8f54338787$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $898f1d8f54338787$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $898f1d8f54338787$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $lvx9g.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $898f1d8f54338787$var$concatBuffers(parts);
}
function $898f1d8f54338787$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $898f1d8f54338787$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $898f1d8f54338787$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($898f1d8f54338787$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $898f1d8f54338787$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $898f1d8f54338787$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $898f1d8f54338787$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $898f1d8f54338787$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    otel_log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $898f1d8f54338787$export$b11169581eeaf237(type) {
    return $898f1d8f54338787$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $898f1d8f54338787$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $898f1d8f54338787$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1ICJv.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

});


parcelRegister("9Gtbp", function(module, exports) {
$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $70ceac74fc1086ae$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $70ceac74fc1086ae$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $70ceac74fc1086ae$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $70ceac74fc1086ae$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "defineIntegration", function () { return $70ceac74fc1086ae$export$2323046b9414659f; });

var $i7nxO = parcelRequire("i7nxO");

var $4YMns = parcelRequire("4YMns");

var $9sRth = parcelRequire("9sRth");
const $70ceac74fc1086ae$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $70ceac74fc1086ae$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $70ceac74fc1086ae$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $70ceac74fc1086ae$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $70ceac74fc1086ae$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $70ceac74fc1086ae$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $70ceac74fc1086ae$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $70ceac74fc1086ae$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($70ceac74fc1086ae$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $70ceac74fc1086ae$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $70ceac74fc1086ae$export$2d8f5188773bcddd(integration) {
    const client = (0, $i7nxO.getClient)();
    if (!client) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $70ceac74fc1086ae$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("85YNJ", function(module, exports) {
$parcel$export(module.exports, "getPossibleEventMessages", function () { return $5e4df432f80b9cc5$export$d55a97c329cacfcc; });
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $5e4df432f80b9cc5$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}

});

parcelRegister("lxHXx", function(module, exports) {
$parcel$export(module.exports, "convertTransactionEventToSpanJson", function () { return $faeec76c9c32a84b$export$d9c6b2464b0a687e; });
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", function () { return $faeec76c9c32a84b$export$f2d8fce5ae150e92; });

var $dhhBD = parcelRequire("dhhBD");
/**
 * Converts a transaction event to a span JSON object.
 */ function $faeec76c9c32a84b$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $dhhBD.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $dhhBD.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $faeec76c9c32a84b$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $dhhBD.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $dhhBD.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}

});

parcelRegister("lfwLF", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", function () { return $f7846aaf0ca0d45e$export$f3b9ed77c03eeb00; });

var $bOdRo = parcelRequire("bOdRo");

var $2CVVa = parcelRequire("2CVVa");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $f7846aaf0ca0d45e$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $2CVVa.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $bOdRo.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});


parcelRegister("lmQQj", function(module, exports) {
$parcel$export(module.exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", function () { return $f8e4a485ce49392a$export$4fb50c0840d636d1; });
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $f8e4a485ce49392a$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

});

parcelRegister("6C6IT", function(module, exports) {
$parcel$export(module.exports, "createOtelLogEnvelope", function () { return $4d0b81c1aa149a29$export$4324f1d0c59fd57b; });

var $1ICJv = parcelRequire("1ICJv");

var $bOdRo = parcelRequire("bOdRo");
/**
 * Creates OTEL log envelope item for a serialized OTEL log.
 *
 * @param log - The serialized OTEL log to include in the envelope.
 * @returns The created OTEL log envelope item.
 */ function $4d0b81c1aa149a29$export$3fb4f8e4a128d620(log) {
    return [
        {
            type: 'otel_log'
        },
        log
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $4d0b81c1aa149a29$export$4324f1d0c59fd57b(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $1ICJv.dsnToString)(dsn);
    return (0, $bOdRo.createEnvelope)(headers, logs.map($4d0b81c1aa149a29$export$3fb4f8e4a128d620));
}

});


parcelRegister("n7Tvt", function(module, exports) {
$parcel$export(module.exports, "addAutoIpAddressToUser", function () { return $045845bc1c5348b2$export$3e12ad68afa434ac; });
$parcel$export(module.exports, "addAutoIpAddressToSession", function () { return $045845bc1c5348b2$export$e8e2d07ba63e2b6c; });
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $045845bc1c5348b2$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $045845bc1c5348b2$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

});

parcelRegister("ctUCS", function(module, exports) {
$parcel$export(module.exports, "applySdkMetadata", function () { return $91641e33a45fdb85$export$b9f95b027256052c; });

var $gMJ1n = parcelRequire("gMJ1n");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $91641e33a45fdb85$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $gMJ1n.SDK_VERSION)
            })),
        version: (0, $gMJ1n.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("4iitQ", function(module, exports) {
$parcel$export(module.exports, "getSDKSource", function () { return $32072db3a94c1297$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $32072db3a94c1297$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $32072db3a94c1297$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});

parcelRegister("44Rfj", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", function () { return $2f80d6af59db5f98$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $2f80d6af59db5f98$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $2f80d6af59db5f98$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $2f80d6af59db5f98$export$5425b53185d13d6c; });

var $hqa9f = parcelRequire("hqa9f");
var $3eJmu = parcelRequire("3eJmu");
var $i7nxO = parcelRequire("i7nxO");
var $86GZW = parcelRequire("86GZW");
var $lvx9g = parcelRequire("lvx9g");
var $deiyZ = parcelRequire("deiyZ");
/**
 * This function creates an exception from a JavaScript Error
 */ function $2f80d6af59db5f98$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $2f80d6af59db5f98$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $2f80d6af59db5f98$export$2e9ae379995d99e3(ex),
        value: $2f80d6af59db5f98$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $2f80d6af59db5f98$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $i7nxO.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $2f80d6af59db5f98$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $lvx9g.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $2f80d6af59db5f98$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $86GZW.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $2f80d6af59db5f98$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $2f80d6af59db5f98$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $2f80d6af59db5f98$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $2f80d6af59db5f98$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $2f80d6af59db5f98$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $2f80d6af59db5f98$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $2f80d6af59db5f98$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $2f80d6af59db5f98$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $2f80d6af59db5f98$var$getSkipFirstStackStringLines(ex) {
    if (ex && $2f80d6af59db5f98$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $2f80d6af59db5f98$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $2f80d6af59db5f98$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $2f80d6af59db5f98$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $2f80d6af59db5f98$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $2f80d6af59db5f98$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($2f80d6af59db5f98$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $2f80d6af59db5f98$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $2f80d6af59db5f98$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $hqa9f.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $deiyZ.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $2f80d6af59db5f98$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $2f80d6af59db5f98$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $deiyZ.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $2f80d6af59db5f98$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $86GZW.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $2f80d6af59db5f98$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $86GZW.isDOMError)(exception) || (0, $86GZW.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $2f80d6af59db5f98$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $86GZW.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $2f80d6af59db5f98$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $hqa9f.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $86GZW.isError)(exception)) // we have a real Error object, do nothing
    return $2f80d6af59db5f98$var$eventFromError(stackParser, exception);
    if ((0, $86GZW.isPlainObject)(exception) || (0, $86GZW.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $2f80d6af59db5f98$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $hqa9f.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $2f80d6af59db5f98$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $hqa9f.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $hqa9f.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $2f80d6af59db5f98$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $2f80d6af59db5f98$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $hqa9f.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $86GZW.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $2f80d6af59db5f98$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $3eJmu.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $86GZW.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $86GZW.isEvent)(exception)) {
        const className = $2f80d6af59db5f98$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $2f80d6af59db5f98$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $2f80d6af59db5f98$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});

parcelRegister("aT7cw", function(module, exports) {
$parcel$export(module.exports, "WINDOW", function () { return $7ed4a065b6486ccf$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $7ed4a065b6486ccf$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $7ed4a065b6486ccf$export$4997ffc0176396a6; });

var $hqa9f = parcelRequire("hqa9f");
var $3eJmu = parcelRequire("3eJmu");
var $1jDl2 = parcelRequire("1jDl2");
var $9ishN = parcelRequire("9ishN");
var $i7nxO = parcelRequire("i7nxO");
const $7ed4a065b6486ccf$export$56d8a8a25bd48b81 = (0, $9ishN.GLOBAL_OBJ);
let $7ed4a065b6486ccf$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $7ed4a065b6486ccf$export$b79738ab10c590b2() {
    return $7ed4a065b6486ccf$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $7ed4a065b6486ccf$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $7ed4a065b6486ccf$var$ignoreOnError++;
    setTimeout(()=>{
        $7ed4a065b6486ccf$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $7ed4a065b6486ccf$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $3eJmu.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$7ed4a065b6486ccf$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $7ed4a065b6486ccf$export$1265a142ff5ba165();
            (0, $i7nxO.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $hqa9f.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $hqa9f.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $1jDl2.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $3eJmu.markFunctionWrapped)(sentryWrapped, fn);
    (0, $3eJmu.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}

});


parcelRegister("6Ml1x", function(module, exports) {
$parcel$export(module.exports, "browserTracingIntegration", function () { return $4ef788af3448f97e$export$b4109253475213e9; });

var $3eJmu = parcelRequire("3eJmu");
var $2CVVa = parcelRequire("2CVVa");
var $9sRth = parcelRequire("9sRth");
var $gTm65 = parcelRequire("gTm65");
var $i7nxO = parcelRequire("i7nxO");
var $64wec = parcelRequire("64wec");
var $7skVW = parcelRequire("7skVW");
var $8j0KV = parcelRequire("8j0KV");
var $9ishN = parcelRequire("9ishN");
var $6Cwl7 = parcelRequire("6Cwl7");
var $4gjow = parcelRequire("4gjow");
var $dhhBD = parcelRequire("dhhBD");
var $4M7Xc = parcelRequire("4M7Xc");

var $jVGSg = parcelRequire("jVGSg");
var $3EAz0 = parcelRequire("3EAz0");
var $kpbhz = parcelRequire("kpbhz");

var $61ZAj = parcelRequire("61ZAj");

var $aT7cw = parcelRequire("aT7cw");

var $fzkK8 = parcelRequire("fzkK8");

var $5mFTz = parcelRequire("5mFTz");

var $jcAdp = parcelRequire("jcAdp");
const $4ef788af3448f97e$export$bbd2089f30bd3708 = 'BrowserTracing';
const $4ef788af3448f97e$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $4M7Xc.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    linkPreviousTrace: 'in-memory',
    _experiments: {},
    ...(0, $jcAdp.defaultRequestInstrumentationOptions)
};
let $4ef788af3448f97e$var$_hasBeenInitialized = false;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $4ef788af3448f97e$export$b4109253475213e9 = (_options = {})=>{
    if ($4ef788af3448f97e$var$_hasBeenInitialized) (0, $9sRth.consoleSandbox)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Multiple browserTracingIntegration instances are not supported.');
    });
    $4ef788af3448f97e$var$_hasBeenInitialized = true;
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $aT7cw.WINDOW).document;
    (0, $4gjow.registerSpanErrorInstrumentation)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, linkPreviousTrace: linkPreviousTrace, onRequestSpanStart: onRequestSpanStart } = {
        ...$4ef788af3448f97e$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $3EAz0.startTrackingWebVitals)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $kpbhz.startTrackingINP)();
    if (enableLongAnimationFrame && (0, $9ishN.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) (0, $3EAz0.startTrackingLongAnimationFrames)();
    else if (enableLongTask) (0, $3EAz0.startTrackingLongTasks)();
    if (enableInteractions) (0, $3EAz0.startTrackingInteractions)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === 'pageload';
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $4M7Xc.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $3EAz0.addPerformanceEntries)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
                $4ef788af3448f97e$var$setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                const scope = (0, $i7nxO.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $8j0KV.spanIsSampled)(idleSpan),
                    dsc: (0, $64wec.getDynamicSamplingContextFromSpan)(span)
                });
            }
        });
        $4ef788af3448f97e$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                'interactive',
                'complete'
            ].includes(optionalWindowDocument.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        if (isPageloadTransaction && optionalWindowDocument) {
            optionalWindowDocument.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $4ef788af3448f97e$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let startingUrl = (0, $7skVW.getLocationHref)();
            function maybeEndActiveSpan() {
                const activeSpan = $4ef788af3448f97e$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $8j0KV.spanToJSON)(activeSpan).timestamp) {
                    (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).log(`[Tracing] Finishing current active span with op: ${(0, $8j0KV.spanToJSON)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions)=>{
                if ((0, $i7nxO.getClient)() !== client) return;
                maybeEndActiveSpan();
                (0, $i7nxO.getIsolationScope)().setPropagationContext({
                    traceId: (0, $gTm65.generateTraceId)(),
                    sampleRand: Math.random()
                });
                (0, $i7nxO.getCurrentScope)().setPropagationContext({
                    traceId: (0, $gTm65.generateTraceId)(),
                    sampleRand: Math.random()
                });
                _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $i7nxO.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $4ef788af3448f97e$export$f147b32b03c9cf11('sentry-trace');
                const baggage = traceOptions.baggage || $4ef788af3448f97e$export$f147b32b03c9cf11('baggage');
                const propagationContext = (0, $6Cwl7.propagationContextFromHeaders)(sentryTrace, baggage);
                (0, $i7nxO.getCurrentScope)().setPropagationContext(propagationContext);
                _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
            if (linkPreviousTrace !== 'off') {
                let inMemoryPreviousTraceInfo = undefined;
                client.on('spanStart', (span)=>{
                    if ((0, $8j0KV.getRootSpan)(span) !== span) return;
                    if (linkPreviousTrace === 'session-storage') {
                        const updatedPreviousTraceInfo = (0, $5mFTz.addPreviousTraceSpanLink)((0, $5mFTz.getPreviousTraceFromSessionStorage)(), span);
                        (0, $5mFTz.storePreviousTraceInSessionStorage)(updatedPreviousTraceInfo);
                    } else inMemoryPreviousTraceInfo = (0, $5mFTz.addPreviousTraceSpanLink)(inMemoryPreviousTraceInfo, span);
                });
            }
            if ((0, $aT7cw.WINDOW).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $2CVVa.browserPerformanceTimeOrigin)();
                    $4ef788af3448f97e$export$aa44a07f82af519f(client, {
                        name: (0, $aT7cw.WINDOW).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: {
                            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url',
                            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.pageload.browser'
                        }
                    });
                }
                if (instrumentNavigation) (0, $jVGSg.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $4ef788af3448f97e$export$7d159749bd9969ad(client, {
                            name: (0, $aT7cw.WINDOW).location.pathname,
                            attributes: {
                                [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url',
                                [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.navigation.browser'
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $fzkK8.registerBackgroundTabDetection)();
            if (enableInteractions) $4ef788af3448f97e$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $kpbhz.registerInpInteractionListener)();
            (0, $jcAdp.instrumentOutgoingRequests)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $4ef788af3448f97e$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $i7nxO.getCurrentScope)().setTransactionName(spanOptions.name);
    return $4ef788af3448f97e$var$getActiveIdleSpan(client);
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $4ef788af3448f97e$export$7d159749bd9969ad(client, spanOptions) {
    client.emit('startNavigationSpan', spanOptions);
    (0, $i7nxO.getCurrentScope)().setTransactionName(spanOptions.name);
    return $4ef788af3448f97e$var$getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function $4ef788af3448f97e$export$f147b32b03c9cf11(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $aT7cw.WINDOW).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute('content') || undefined;
}
/** Start listener for interaction transactions */ function $4ef788af3448f97e$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $aT7cw.WINDOW).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeIdleSpan = $4ef788af3448f97e$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $8j0KV.spanToJSON)(activeIdleSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $4M7Xc.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener('click', registerInteractionTransaction, {
        once: false,
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
const $4ef788af3448f97e$var$ACTIVE_IDLE_SPAN_PROPERTY = '_sentry_idleSpan';
function $4ef788af3448f97e$var$getActiveIdleSpan(client) {
    return client[$4ef788af3448f97e$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $4ef788af3448f97e$var$setActiveIdleSpan(client, span) {
    (0, $3eJmu.addNonEnumerableProperty)(client, $4ef788af3448f97e$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}

});
parcelRegister("4gjow", function(module, exports) {
$parcel$export(module.exports, "registerSpanErrorInstrumentation", function () { return $31a7b364e41f58d1$export$b0914730ee1f6c80; });

var $4YMns = parcelRequire("4YMns");

var $8j0KV = parcelRequire("8j0KV");

var $eYmRj = parcelRequire("eYmRj");

var $fpjgf = parcelRequire("fpjgf");

var $9sRth = parcelRequire("9sRth");

var $lkPDN = parcelRequire("lkPDN");
let $31a7b364e41f58d1$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $31a7b364e41f58d1$export$b0914730ee1f6c80() {
    if ($31a7b364e41f58d1$var$errorsInstrumented) return;
    $31a7b364e41f58d1$var$errorsInstrumented = true;
    (0, $eYmRj.addGlobalErrorInstrumentationHandler)($31a7b364e41f58d1$var$errorCallback);
    (0, $fpjgf.addGlobalUnhandledRejectionInstrumentationHandler)($31a7b364e41f58d1$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $31a7b364e41f58d1$var$errorCallback() {
    const activeSpan = (0, $8j0KV.getActiveSpan)();
    const rootSpan = activeSpan && (0, $8j0KV.getRootSpan)(activeSpan);
    if (rootSpan) {
        const message = 'internal_error';
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $lkPDN.SPAN_STATUS_ERROR),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$31a7b364e41f58d1$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("eYmRj", function(module, exports) {
$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $ae686694b22d4e3a$export$55b5c3ba2194f0c6; });

var $9ishN = parcelRequire("9ishN");

var $dkXNk = parcelRequire("dkXNk");
let $ae686694b22d4e3a$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ae686694b22d4e3a$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $dkXNk.addHandler)(type, handler);
    (0, $dkXNk.maybeInstrument)(type, $ae686694b22d4e3a$var$instrumentError);
}
function $ae686694b22d4e3a$var$instrumentError() {
    $ae686694b22d4e3a$var$_oldOnErrorHandler = (0, $9ishN.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $9ishN.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $dkXNk.triggerHandlers)('error', handlerData);
        if ($ae686694b22d4e3a$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $ae686694b22d4e3a$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $9ishN.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("dkXNk", function(module, exports) {
$parcel$export(module.exports, "addHandler", function () { return $9b5b86923818ee81$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $9b5b86923818ee81$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $9b5b86923818ee81$export$b18c893e424d3127; });

var $e6nMd = parcelRequire("e6nMd");

var $9sRth = parcelRequire("9sRth");

var $eE5Vk = parcelRequire("eE5Vk");
// We keep the handlers globally
const $9b5b86923818ee81$var$handlers = {};
const $9b5b86923818ee81$var$instrumented = {};
/** Add a handler function. */ function $9b5b86923818ee81$export$a4e09611e30da72e(type, handler) {
    $9b5b86923818ee81$var$handlers[type] = $9b5b86923818ee81$var$handlers[type] || [];
    $9b5b86923818ee81$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $9b5b86923818ee81$export$b17eab759a1cb5fe() {
    Object.keys($9b5b86923818ee81$var$handlers).forEach((key)=>{
        $9b5b86923818ee81$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $9b5b86923818ee81$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$9b5b86923818ee81$var$instrumented[type]) {
        $9b5b86923818ee81$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $e6nMd.DEBUG_BUILD) && (0, $9sRth.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $9b5b86923818ee81$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $9b5b86923818ee81$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e6nMd.DEBUG_BUILD) && (0, $9sRth.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $eE5Vk.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("fpjgf", function(module, exports) {
$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $b37821a38f9de2d6$export$8bf4fc6858821a4e; });

var $9ishN = parcelRequire("9ishN");

var $dkXNk = parcelRequire("dkXNk");
let $b37821a38f9de2d6$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b37821a38f9de2d6$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $dkXNk.addHandler)(type, handler);
    (0, $dkXNk.maybeInstrument)(type, $b37821a38f9de2d6$var$instrumentUnhandledRejection);
}
function $b37821a38f9de2d6$var$instrumentUnhandledRejection() {
    $b37821a38f9de2d6$var$_oldOnUnhandledRejectionHandler = (0, $9ishN.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $9ishN.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $dkXNk.triggerHandlers)('unhandledrejection', handlerData);
        if ($b37821a38f9de2d6$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $b37821a38f9de2d6$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $9ishN.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("4M7Xc", function(module, exports) {
$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $37a1d09a3acf934c$export$809a2b7987fd5306; });
$parcel$export(module.exports, "startIdleSpan", function () { return $37a1d09a3acf934c$export$901bffd97bd52797; });

var $i7nxO = parcelRequire("i7nxO");

var $4YMns = parcelRequire("4YMns");

var $dhhBD = parcelRequire("dhhBD");

var $isIB5 = parcelRequire("isIB5");

var $k1akT = parcelRequire("k1akT");

var $8j0KV = parcelRequire("8j0KV");

var $9sRth = parcelRequire("9sRth");

var $2CVVa = parcelRequire("2CVVa");

var $64wec = parcelRequire("64wec");

var $ls7oW = parcelRequire("ls7oW");

var $lkPDN = parcelRequire("lkPDN");

var $1Yn6D = parcelRequire("1Yn6D");
const $37a1d09a3acf934c$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $37a1d09a3acf934c$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $37a1d09a3acf934c$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $37a1d09a3acf934c$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $37a1d09a3acf934c$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $37a1d09a3acf934c$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $37a1d09a3acf934c$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $37a1d09a3acf934c$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $37a1d09a3acf934c$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $37a1d09a3acf934c$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $i7nxO.getClient)();
    if (!client || !(0, $isIB5.hasSpansEnabled)()) {
        const span = new (0, $ls7oW.SentryNonRecordingSpan)();
        const dsc = {
            sample_rate: '0',
            sampled: 'false',
            ...(0, $64wec.getDynamicSamplingContextFromSpan)(span)
        };
        (0, $64wec.freezeDscOnSpan)(span, dsc);
        return span;
    }
    const scope = (0, $i7nxO.getCurrentScope)();
    const previousActiveSpan = (0, $8j0KV.getActiveSpan)();
    const span = $37a1d09a3acf934c$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof (0, $ls7oW.SentryNonRecordingSpan)) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $2CVVa.timestampInSeconds)();
            const spanEndTimestamp = (0, $8j0KV.spanTimeInputToSeconds)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $8j0KV.getSpanDescendants)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $8j0KV.spanToJSON)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $8j0KV.spanToJSON)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $37a1d09a3acf934c$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $37a1d09a3acf934c$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $2CVVa.timestampInSeconds)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $2CVVa.timestampInSeconds)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $k1akT._setSpanForScope)(scope, previousActiveSpan);
        const spanJSON = (0, $8j0KV.spanToJSON)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute((0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), _finishReason);
        (0, $9sRth.logger).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $8j0KV.getSpanDescendants)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $lkPDN.SPAN_STATUS_ERROR),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $8j0KV.spanToJSON)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $4YMns.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $9sRth.logger).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $9sRth.logger).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $8j0KV.removeChildSpanFromSpan)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $8j0KV.spanToJSON)(startedSpan).timestamp) return;
        const allSpans = (0, $8j0KV.getSpanDescendants)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $lkPDN.SPAN_STATUS_ERROR),
                message: 'deadline_exceeded'
            });
            _finishReason = $37a1d09a3acf934c$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $37a1d09a3acf934c$var$_startIdleSpan(options) {
    const span = (0, $1Yn6D.startInactiveSpan)(options);
    (0, $k1akT._setSpanForScope)((0, $i7nxO.getCurrentScope)(), span);
    (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('[Tracing] Started span is an idle span');
    return span;
}

});
parcelRegister("ls7oW", function(module, exports) {
$parcel$export(module.exports, "SentryNonRecordingSpan", function () { return $f9e1f4428c7a1a23$export$d6636b700b76c516; });

var $8j0KV = parcelRequire("8j0KV");

var $gTm65 = parcelRequire("gTm65");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $f9e1f4428c7a1a23$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $gTm65.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $gTm65.generateSpanId)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $8j0KV.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}

});

parcelRegister("1Yn6D", function(module, exports) {
$parcel$export(module.exports, "startInactiveSpan", function () { return $16fd51646b1de5ae$export$63dbba021a6b4047; });

var $eM6ET = parcelRequire("eM6ET");

var $5TFFW = parcelRequire("5TFFW");

var $i7nxO = parcelRequire("i7nxO");

var $4YMns = parcelRequire("4YMns");

var $dhhBD = parcelRequire("dhhBD");

var $5ONvr = parcelRequire("5ONvr");

var $isIB5 = parcelRequire("isIB5");

var $en7rT = parcelRequire("en7rT");

var $k1akT = parcelRequire("k1akT");

var $8j0KV = parcelRequire("8j0KV");

var $9sRth = parcelRequire("9sRth");

var $gTm65 = parcelRequire("gTm65");

var $6Cwl7 = parcelRequire("6Cwl7");

var $64wec = parcelRequire("64wec");

var $bOZfb = parcelRequire("bOZfb");

var $7fY1X = parcelRequire("7fY1X");

var $ls7oW = parcelRequire("ls7oW");

var $cXofI = parcelRequire("cXofI");

var $lkPDN = parcelRequire("lkPDN");

var $7brnw = parcelRequire("7brnw");
/* eslint-disable max-lines */ const $16fd51646b1de5ae$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $16fd51646b1de5ae$export$a1bd95187356f372(options, callback) {
    const acs = $16fd51646b1de5ae$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $16fd51646b1de5ae$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $i7nxO.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $16fd51646b1de5ae$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $i7nxO.getCurrentScope)();
            const parentSpan = $16fd51646b1de5ae$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $ls7oW.SentryNonRecordingSpan)() : $16fd51646b1de5ae$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $k1akT._setSpanForScope)(scope, activeSpan);
            return (0, $5ONvr.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $8j0KV.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $lkPDN.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $16fd51646b1de5ae$export$c10292ad04b92aea(options, callback) {
    const acs = $16fd51646b1de5ae$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $16fd51646b1de5ae$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $i7nxO.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $16fd51646b1de5ae$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $i7nxO.getCurrentScope)();
            const parentSpan = $16fd51646b1de5ae$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $ls7oW.SentryNonRecordingSpan)() : $16fd51646b1de5ae$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $k1akT._setSpanForScope)(scope, activeSpan);
            return (0, $5ONvr.handleCallbackErrors)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $8j0KV.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $lkPDN.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $16fd51646b1de5ae$export$63dbba021a6b4047(options) {
    const acs = $16fd51646b1de5ae$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $16fd51646b1de5ae$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $i7nxO.withScope)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$16fd51646b1de5ae$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $i7nxO.getCurrentScope)();
        const parentSpan = $16fd51646b1de5ae$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $ls7oW.SentryNonRecordingSpan)();
        return $16fd51646b1de5ae$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $16fd51646b1de5ae$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $5TFFW.getMainCarrier)();
    const acs = (0, $eM6ET.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $i7nxO.withScope)((scope)=>{
        const propagationContext = (0, $6Cwl7.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $16fd51646b1de5ae$export$e57ac09b143d92a2(span, callback) {
    const acs = $16fd51646b1de5ae$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $i7nxO.withScope)((scope)=>{
        (0, $k1akT._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $16fd51646b1de5ae$export$869298f9835abc68(callback) {
    const acs = $16fd51646b1de5ae$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $i7nxO.withScope)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$16fd51646b1de5ae$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $16fd51646b1de5ae$export$f90b03291402f553(callback) {
    return (0, $i7nxO.withScope)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $gTm65.generateTraceId)(),
            sampleRand: Math.random()
        });
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $16fd51646b1de5ae$export$e57ac09b143d92a2(null, callback);
    });
}
function $16fd51646b1de5ae$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $isIB5.hasSpansEnabled)()) {
        const span = new (0, $ls7oW.SentryNonRecordingSpan)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $64wec.getDynamicSamplingContextFromSpan)(span)
            };
            (0, $64wec.freezeDscOnSpan)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $i7nxO.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $16fd51646b1de5ae$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $8j0KV.addChildSpanToSpan)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $64wec.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $8j0KV.spanIsSampled)(parentSpan);
        span = $16fd51646b1de5ae$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $64wec.freezeDscOnSpan)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $16fd51646b1de5ae$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $64wec.freezeDscOnSpan)(span, dsc);
    }
    (0, $bOZfb.logSpanStart)(span);
    (0, $7brnw.setCapturedScopesOnSpan)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $16fd51646b1de5ae$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $8j0KV.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $16fd51646b1de5ae$var$getAcs() {
    const carrier = (0, $5TFFW.getMainCarrier)();
    return (0, $eM6ET.getAsyncContextStrategy)(carrier);
}
function $16fd51646b1de5ae$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $i7nxO.getClient)();
    const options = client?.getOptions() || {};
    const { name: name = '', attributes: attributes } = spanArguments;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$16fd51646b1de5ae$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $7fY1X.sampleSpan)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        parentSampleRate: (0, $en7rT.parseSampleRate)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $cXofI.SentrySpan)({
        ...spanArguments,
        attributes: {
            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $16fd51646b1de5ae$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$16fd51646b1de5ae$var$SUPPRESS_TRACING_KEY] ? false : (0, $8j0KV.spanIsSampled)(parentSpan);
    const childSpan = sampled ? new (0, $cXofI.SentrySpan)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $ls7oW.SentryNonRecordingSpan)({
        traceId: traceId
    });
    (0, $8j0KV.addChildSpanToSpan)(parentSpan, childSpan);
    const client = (0, $i7nxO.getClient)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $16fd51646b1de5ae$var$getParentSpan(scope) {
    const span = (0, $k1akT._getSpanForScope)(scope);
    if (!span) return undefined;
    const client = (0, $i7nxO.getClient)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $8j0KV.getRootSpan)(span);
    return span;
}
function $16fd51646b1de5ae$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $16fd51646b1de5ae$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}

});
parcelRegister("5ONvr", function(module, exports) {
$parcel$export(module.exports, "handleCallbackErrors", function () { return $43c80627374e0aba$export$18ce21a8b7efd7e9; });

var $86GZW = parcelRequire("86GZW");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $43c80627374e0aba$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $43c80627374e0aba$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $43c80627374e0aba$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $86GZW.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("bOZfb", function(module, exports) {
$parcel$export(module.exports, "logSpanStart", function () { return $89b3defe9dfc943a$export$2f3d84e767c9592b; });
$parcel$export(module.exports, "logSpanEnd", function () { return $89b3defe9dfc943a$export$b77c830667a4d630; });

var $4YMns = parcelRequire("4YMns");

var $8j0KV = parcelRequire("8j0KV");

var $9sRth = parcelRequire("9sRth");
/**
 * Print a log message for a started span.
 */ function $89b3defe9dfc943a$export$2f3d84e767c9592b(span) {
    if (!(0, $4YMns.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $8j0KV.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $8j0KV.spanIsSampled)(span);
    const rootSpan = (0, $8j0KV.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $8j0KV.spanToJSON)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $9sRth.logger).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $89b3defe9dfc943a$export$b77c830667a4d630(span) {
    if (!(0, $4YMns.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $8j0KV.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $8j0KV.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $9sRth.logger).log(msg);
}

});

parcelRegister("7fY1X", function(module, exports) {
$parcel$export(module.exports, "sampleSpan", function () { return $54887ff64f30aef5$export$5f833db634b217bb; });

var $4YMns = parcelRequire("4YMns");

var $isIB5 = parcelRequire("isIB5");

var $en7rT = parcelRequire("en7rT");

var $9sRth = parcelRequire("9sRth");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $54887ff64f30aef5$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $isIB5.hasSpansEnabled)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $en7rT.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}

});

parcelRegister("cXofI", function(module, exports) {
$parcel$export(module.exports, "SentrySpan", function () { return $96edcebd78c710e1$export$a92149b045260d9f; });

var $i7nxO = parcelRequire("i7nxO");

var $4YMns = parcelRequire("4YMns");

var $69U89 = parcelRequire("69U89");

var $dhhBD = parcelRequire("dhhBD");

var $8j0KV = parcelRequire("8j0KV");

var $9sRth = parcelRequire("9sRth");

var $gTm65 = parcelRequire("gTm65");

var $2CVVa = parcelRequire("2CVVa");

var $64wec = parcelRequire("64wec");

var $bOZfb = parcelRequire("bOZfb");

var $c3VpY = parcelRequire("c3VpY");

var $7brnw = parcelRequire("7brnw");
const $96edcebd78c710e1$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $96edcebd78c710e1$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $gTm65.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $gTm65.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, $2CVVa.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'manual',
            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $8j0KV.TRACE_FLAG_SAMPLED) : (0, $8j0KV.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $8j0KV.spanTimeInputToSeconds)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $8j0KV.spanTimeInputToSeconds)(endTimestamp);
        (0, $bOZfb.logSpanEnd)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $8j0KV.getStatusMessage)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: (0, $c3VpY.timedEventsToMeasurements)(this._events),
            is_segment: this._isStandaloneSpan && (0, $8j0KV.getRootSpan)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $8j0KV.getRootSpan)(this).spanContext().spanId : undefined,
            links: (0, $8j0KV.convertSpanLinksForEnvelope)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('[Tracing] Adding an event to span:', name);
        const time = $96edcebd78c710e1$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $2CVVa.timestampInSeconds)();
        const attributes = $96edcebd78c710e1$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $8j0KV.spanTimeInputToSeconds)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $i7nxO.getClient)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $8j0KV.getRootSpan)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $96edcebd78c710e1$var$sendSpanEnvelope((0, $69U89.createSpanEnvelope)([
                this
            ], client));
            else {
                (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $7brnw.getCapturedScopesOnSpan)(this).scope || (0, $i7nxO.getCurrentScope)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$96edcebd78c710e1$var$isFullFinishedSpan((0, $8j0KV.spanToJSON)(this))) return undefined;
        if (!this._name) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $7brnw.getCapturedScopesOnSpan)(this);
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $8j0KV.getSpanDescendants)(this).filter((span)=>span !== this && !$96edcebd78c710e1$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $8j0KV.spanToJSON)(span)).filter($96edcebd78c710e1$var$isFullFinishedSpan);
        const source = this._attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        spans.forEach((span)=>{
            delete span.data[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $8j0KV.spanToTransactionTraceContext)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $96edcebd78c710e1$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $96edcebd78c710e1$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $64wec.getDynamicSamplingContextFromSpan)(this)
            },
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $c3VpY.timedEventsToMeasurements)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $96edcebd78c710e1$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $96edcebd78c710e1$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $96edcebd78c710e1$var$isStandaloneSpan(span) {
    return span instanceof $96edcebd78c710e1$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $96edcebd78c710e1$var$sendSpanEnvelope(envelope) {
    const client = (0, $i7nxO.getClient)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

});
parcelRegister("c3VpY", function(module, exports) {
$parcel$export(module.exports, "timedEventsToMeasurements", function () { return $8c824de07454cde0$export$487db6fcdf36893e; });

var $4YMns = parcelRequire("4YMns");

var $dhhBD = parcelRequire("dhhBD");

var $8j0KV = parcelRequire("8j0KV");

var $9sRth = parcelRequire("9sRth");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $8c824de07454cde0$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $8j0KV.getActiveSpan)()) {
    const rootSpan = activeSpan && (0, $8j0KV.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: value,
            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $8c824de07454cde0$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}

});




parcelRegister("jVGSg", function(module, exports) {
$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $e824992125b5ab3f$export$3f18c56c58114e75; });

var $l9iyH = parcelRequire("l9iyH");
var $j7rez = parcelRequire("j7rez");
var $4UAQu = parcelRequire("4UAQu");

var $j6z6N = parcelRequire("j6z6N");
let $e824992125b5ab3f$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e824992125b5ab3f$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $l9iyH.addHandler)(type, handler);
    (0, $l9iyH.maybeInstrument)(type, $e824992125b5ab3f$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $e824992125b5ab3f$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $j6z6N.WINDOW).addEventListener('popstate', ()=>{
        const to = (0, $j6z6N.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $e824992125b5ab3f$var$lastHref;
        $e824992125b5ab3f$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $l9iyH.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $4UAQu.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $e824992125b5ab3f$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $e824992125b5ab3f$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $l9iyH.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $j7rez.fill)((0, $j6z6N.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $j7rez.fill)((0, $j6z6N.WINDOW).history, 'replaceState', historyReplacementFunction);
}

});
parcelRegister("l9iyH", function(module, exports) {
$parcel$export(module.exports, "addHandler", function () { return $f658d598da745d80$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $f658d598da745d80$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $f658d598da745d80$export$b18c893e424d3127; });

var $e27Xs = parcelRequire("e27Xs");

var $kFCRa = parcelRequire("kFCRa");

var $cdBy6 = parcelRequire("cdBy6");
// We keep the handlers globally
const $f658d598da745d80$var$handlers = {};
const $f658d598da745d80$var$instrumented = {};
/** Add a handler function. */ function $f658d598da745d80$export$a4e09611e30da72e(type, handler) {
    $f658d598da745d80$var$handlers[type] = $f658d598da745d80$var$handlers[type] || [];
    $f658d598da745d80$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f658d598da745d80$export$b17eab759a1cb5fe() {
    Object.keys($f658d598da745d80$var$handlers).forEach((key)=>{
        $f658d598da745d80$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f658d598da745d80$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f658d598da745d80$var$instrumented[type]) {
        $f658d598da745d80$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $e27Xs.DEBUG_BUILD) && (0, $kFCRa.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f658d598da745d80$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f658d598da745d80$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e27Xs.DEBUG_BUILD) && (0, $kFCRa.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $cdBy6.getFunctionName)(handler)}\nError:`, e);
    }
}

});
parcelRegister("e27Xs", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", function () { return $a3776ce6491961a1$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a3776ce6491961a1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("kFCRa", function(module, exports) {
$parcel$export(module.exports, "consoleSandbox", function () { return $f0c5c71840d1493b$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $f0c5c71840d1493b$export$af88d00dbe7f521; });

var $10msY = parcelRequire("10msY");

var $e27Xs = parcelRequire("e27Xs");

var $e1Opx = parcelRequire("e1Opx");
/** Prefix for logging strings */ const $f0c5c71840d1493b$var$PREFIX = 'Sentry Logger ';
const $f0c5c71840d1493b$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $f0c5c71840d1493b$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $f0c5c71840d1493b$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $e1Opx.GLOBAL_OBJ))) return callback();
    const console = (0, $e1Opx.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($f0c5c71840d1493b$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $f0c5c71840d1493b$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $f0c5c71840d1493b$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $e27Xs.DEBUG_BUILD) $f0c5c71840d1493b$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $f0c5c71840d1493b$export$cda52e2a8927a2ca(()=>{
                (0, $e1Opx.GLOBAL_OBJ).console[name](`${$f0c5c71840d1493b$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $f0c5c71840d1493b$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $f0c5c71840d1493b$export$af88d00dbe7f521 = (0, $10msY.getGlobalSingleton)('logger', $f0c5c71840d1493b$var$makeLogger);

});
parcelRegister("10msY", function(module, exports) {
$parcel$export(module.exports, "getMainCarrier", function () { return $0bb737e5bfc36256$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $0bb737e5bfc36256$export$c8bfa33e4e8ae492; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $0bb737e5bfc36256$export$7e223ec222791509; });

var $9M4yG = parcelRequire("9M4yG");

var $e1Opx = parcelRequire("e1Opx");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $0bb737e5bfc36256$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $0bb737e5bfc36256$export$c8bfa33e4e8ae492((0, $e1Opx.GLOBAL_OBJ));
    return 0, $e1Opx.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $0bb737e5bfc36256$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $9M4yG.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $9M4yG.SDK_VERSION] = __SENTRY__[0, $9M4yG.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $0bb737e5bfc36256$export$7e223ec222791509(name, creator, obj = (0, $e1Opx.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $9M4yG.SDK_VERSION] = __SENTRY__[0, $9M4yG.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("9M4yG", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", function () { return $71dc21f7dda870a9$export$31499a9cd224b78c; });
// This is a magic string replaced by rollup
const $71dc21f7dda870a9$export$31499a9cd224b78c = "9.15.0";

});

parcelRegister("e1Opx", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $a368433c0aa60e4c$export$f1a6cdb1459e81d1; });
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $a368433c0aa60e4c$export$f1a6cdb1459e81d1 = globalThis;

});



parcelRegister("cdBy6", function(module, exports) {
$parcel$export(module.exports, "getFunctionName", function () { return $8e53d36aab35a8e1$export$aad197c7121a6651; });
const $8e53d36aab35a8e1$var$STACKTRACE_FRAME_LIMIT = 50;
const $8e53d36aab35a8e1$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $8e53d36aab35a8e1$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $8e53d36aab35a8e1$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $8e53d36aab35a8e1$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $8e53d36aab35a8e1$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($8e53d36aab35a8e1$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $8e53d36aab35a8e1$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $8e53d36aab35a8e1$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $8e53d36aab35a8e1$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $8e53d36aab35a8e1$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $8e53d36aab35a8e1$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($8e53d36aab35a8e1$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($8e53d36aab35a8e1$var$STRIP_FRAME_REGEXP.test($8e53d36aab35a8e1$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($8e53d36aab35a8e1$var$STRIP_FRAME_REGEXP.test($8e53d36aab35a8e1$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $8e53d36aab35a8e1$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $8e53d36aab35a8e1$var$getLastStackFrame(localStack).filename,
            function: frame.function || $8e53d36aab35a8e1$export$27c7e15d453fc0ac
        }));
}
function $8e53d36aab35a8e1$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $8e53d36aab35a8e1$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $8e53d36aab35a8e1$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $8e53d36aab35a8e1$var$defaultFunctionName;
        return fn.name || $8e53d36aab35a8e1$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $8e53d36aab35a8e1$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $8e53d36aab35a8e1$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});


parcelRegister("j7rez", function(module, exports) {
$parcel$export(module.exports, "fill", function () { return $deb3cbdafac9c1b6$export$9563e054e6f787fb; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $deb3cbdafac9c1b6$export$e73679ffaf56810e; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $deb3cbdafac9c1b6$export$62ff257738bf57f5; });

var $7JT7M = parcelRequire("7JT7M");

var $e27Xs = parcelRequire("e27Xs");

var $6O5dZ = parcelRequire("6O5dZ");

var $kFCRa = parcelRequire("kFCRa");

var $aWSlW = parcelRequire("aWSlW");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $deb3cbdafac9c1b6$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $deb3cbdafac9c1b6$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $e27Xs.DEBUG_BUILD) && (0, $kFCRa.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $deb3cbdafac9c1b6$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $e27Xs.DEBUG_BUILD) && (0, $kFCRa.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $deb3cbdafac9c1b6$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $deb3cbdafac9c1b6$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $deb3cbdafac9c1b6$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $deb3cbdafac9c1b6$export$62ff257738bf57f5(value) {
    if ((0, $6O5dZ.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$deb3cbdafac9c1b6$var$getOwnProperties(value)
    };
    else if ((0, $6O5dZ.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $deb3cbdafac9c1b6$var$serializeEventTarget(value.target),
            currentTarget: $deb3cbdafac9c1b6$var$serializeEventTarget(value.currentTarget),
            ...$deb3cbdafac9c1b6$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $6O5dZ.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $deb3cbdafac9c1b6$var$serializeEventTarget(target) {
    try {
        return (0, $6O5dZ.isElement)(target) ? (0, $7JT7M.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $deb3cbdafac9c1b6$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $deb3cbdafac9c1b6$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($deb3cbdafac9c1b6$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $aWSlW.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $aWSlW.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $deb3cbdafac9c1b6$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $deb3cbdafac9c1b6$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $deb3cbdafac9c1b6$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($deb3cbdafac9c1b6$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($deb3cbdafac9c1b6$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $deb3cbdafac9c1b6$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $deb3cbdafac9c1b6$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $deb3cbdafac9c1b6$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6O5dZ.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("7JT7M", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", function () { return $5a277ef31d1ae7c7$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getComponentName", function () { return $5a277ef31d1ae7c7$export$26727cfcc4d7e0fc; });

var $6O5dZ = parcelRequire("6O5dZ");

var $e1Opx = parcelRequire("e1Opx");
const $5a277ef31d1ae7c7$var$WINDOW = (0, $e1Opx.GLOBAL_OBJ);
const $5a277ef31d1ae7c7$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $5a277ef31d1ae7c7$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $5a277ef31d1ae7c7$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $5a277ef31d1ae7c7$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $5a277ef31d1ae7c7$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($5a277ef31d1ae7c7$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $6O5dZ.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $5a277ef31d1ae7c7$export$1cfafeee2987818b() {
    try {
        return $5a277ef31d1ae7c7$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $5a277ef31d1ae7c7$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$5a277ef31d1ae7c7$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("6O5dZ", function(module, exports) {
$parcel$export(module.exports, "isError", function () { return $4f4b771b56a531ba$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $4f4b771b56a531ba$export$49034edbe6b62415; });
$parcel$export(module.exports, "isString", function () { return $4f4b771b56a531ba$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $4f4b771b56a531ba$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $4f4b771b56a531ba$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $4f4b771b56a531ba$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $4f4b771b56a531ba$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $4f4b771b56a531ba$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $4f4b771b56a531ba$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $4f4b771b56a531ba$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $4f4b771b56a531ba$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $4f4b771b56a531ba$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$e6127cc7fe7395c3(wat) {
    switch($4f4b771b56a531ba$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $4f4b771b56a531ba$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$var$isBuiltin(wat, className) {
    return $4f4b771b56a531ba$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$9f9636d330b71954(wat) {
    return $4f4b771b56a531ba$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$ef9e2056653f0c8e(wat) {
    return $4f4b771b56a531ba$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$12e869b2a583f783(wat) {
    return $4f4b771b56a531ba$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$844ec244b1367d54(wat) {
    return $4f4b771b56a531ba$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$c3825b437cbdea5c(wat) {
    return wat === null || $4f4b771b56a531ba$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$53b83ca8eaab0383(wat) {
    return $4f4b771b56a531ba$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $4f4b771b56a531ba$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $4f4b771b56a531ba$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$49841c62b9eff15(wat) {
    return $4f4b771b56a531ba$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $4f4b771b56a531ba$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$bc2894c7158efbac(wat) {
    return $4f4b771b56a531ba$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f4b771b56a531ba$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $4f4b771b56a531ba$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $4f4b771b56a531ba$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("aWSlW", function(module, exports) {
$parcel$export(module.exports, "truncate", function () { return $7f897b89e7856ed4$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $7f897b89e7856ed4$export$4215662d762d6f9d; });

var $6O5dZ = parcelRequire("6O5dZ");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $7f897b89e7856ed4$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $7f897b89e7856ed4$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $7f897b89e7856ed4$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $6O5dZ.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $7f897b89e7856ed4$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $6O5dZ.isString)(value)) return false;
    if ((0, $6O5dZ.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $6O5dZ.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $7f897b89e7856ed4$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$7f897b89e7856ed4$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});


parcelRegister("4UAQu", function(module, exports) {
$parcel$export(module.exports, "supportsHistory", function () { return $3938f92d2f67d82e$export$67fc34576016d6ec; });
$parcel$export(module.exports, "isNativeFunction", function () { return $3938f92d2f67d82e$export$d5f608b368e73f38; });

var $e27Xs = parcelRequire("e27Xs");

var $kFCRa = parcelRequire("kFCRa");

var $e1Opx = parcelRequire("e1Opx");
const $3938f92d2f67d82e$var$WINDOW = (0, $e1Opx.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $3938f92d2f67d82e$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $3938f92d2f67d82e$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $3938f92d2f67d82e$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $3938f92d2f67d82e$export$67fc34576016d6ec() {
    return 'history' in $3938f92d2f67d82e$var$WINDOW && !!$3938f92d2f67d82e$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $3938f92d2f67d82e$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $3938f92d2f67d82e$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3938f92d2f67d82e$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $3938f92d2f67d82e$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$3938f92d2f67d82e$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($3938f92d2f67d82e$export$d5f608b368e73f38($3938f92d2f67d82e$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $3938f92d2f67d82e$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $3938f92d2f67d82e$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $e27Xs.DEBUG_BUILD) && (0, $kFCRa.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $3938f92d2f67d82e$export$531055a6c684a70a() {
    return 'ReportingObserver' in $3938f92d2f67d82e$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $3938f92d2f67d82e$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$3938f92d2f67d82e$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("j6z6N", function(module, exports) {
$parcel$export(module.exports, "WINDOW", function () { return $de89cfb6b038ea74$export$56d8a8a25bd48b81; });

var $e1Opx = parcelRequire("e1Opx");
const $de89cfb6b038ea74$export$56d8a8a25bd48b81 = (0, $e1Opx.GLOBAL_OBJ);

});


parcelRegister("3EAz0", function(module, exports) {
$parcel$export(module.exports, "startTrackingWebVitals", function () { return $2a917848a127cf9c$export$7c69f0412d101b88; });
$parcel$export(module.exports, "startTrackingLongTasks", function () { return $2a917848a127cf9c$export$f396d19077034ad2; });
$parcel$export(module.exports, "startTrackingLongAnimationFrames", function () { return $2a917848a127cf9c$export$5b823ab2ccbc801d; });
$parcel$export(module.exports, "startTrackingInteractions", function () { return $2a917848a127cf9c$export$e27543e0976315e4; });
$parcel$export(module.exports, "addPerformanceEntries", function () { return $2a917848a127cf9c$export$5f8fa6b3467a7443; });

var $dCjy6 = parcelRequire("dCjy6");
var $628UB = parcelRequire("628UB");
var $7JT7M = parcelRequire("7JT7M");
var $dnBI6 = parcelRequire("dnBI6");
var $AtCht = parcelRequire("AtCht");
var $edXf6 = parcelRequire("edXf6");

var $j6z6N = parcelRequire("j6z6N");

var $e7tnH = parcelRequire("e7tnH");

var $cLM7V = parcelRequire("cLM7V");

var $9mpDy = parcelRequire("9mpDy");

var $1CbOk = parcelRequire("1CbOk");

var $bfzCw = parcelRequire("bfzCw");

var $iGpKe = parcelRequire("iGpKe");
const $2a917848a127cf9c$var$MAX_INT_AS_BYTES = 2147483647;
let $2a917848a127cf9c$var$_performanceCursor = 0;
let $2a917848a127cf9c$var$_measurements = {};
let $2a917848a127cf9c$var$_lcpEntry;
let $2a917848a127cf9c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $2a917848a127cf9c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $9mpDy.getBrowserPerformanceAPI)();
    if (performance && (0, $dCjy6.browserPerformanceTimeOrigin)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $j6z6N.WINDOW).performance.mark('sentry-tracing-init');
        const fidCleanupCallback = $2a917848a127cf9c$var$_trackFID();
        const lcpCleanupCallback = $2a917848a127cf9c$var$_trackLCP();
        const ttfbCleanupCallback = $2a917848a127cf9c$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $e7tnH.trackClsAsStandaloneSpan)() : $2a917848a127cf9c$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback?.();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $2a917848a127cf9c$export$f396d19077034ad2() {
    (0, $cLM7V.addPerformanceInstrumentationHandler)('longtask', ({ entries: entries })=>{
        const parent = (0, $628UB.getActiveSpan)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $628UB.spanToJSON)(parent);
        for (const entry of entries){
            const startTime = (0, $9mpDy.msToSec)((0, $dCjy6.browserPerformanceTimeOrigin)() + entry.startTime);
            const duration = (0, $9mpDy.msToSec)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $9mpDy.startAndEndSpan)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $2a917848a127cf9c$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $628UB.getActiveSpan)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $9mpDy.msToSec)((0, $dCjy6.browserPerformanceTimeOrigin)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $628UB.spanToJSON)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $9mpDy.msToSec)(entry.duration);
            const attributes = {
                [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $9mpDy.startAndEndSpan)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $2a917848a127cf9c$export$e27543e0976315e4() {
    (0, $cLM7V.addPerformanceInstrumentationHandler)('event', ({ entries: entries })=>{
        const parent = (0, $628UB.getActiveSpan)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $9mpDy.msToSec)((0, $dCjy6.browserPerformanceTimeOrigin)() + entry.startTime);
            const duration = (0, $9mpDy.msToSec)(entry.duration);
            const spanOptions = {
                name: (0, $7JT7M.htmlTreeAsString)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $7JT7M.getComponentName)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $9mpDy.startAndEndSpan)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $2a917848a127cf9c$var$_trackCLS() {
    return (0, $cLM7V.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $2a917848a127cf9c$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $2a917848a127cf9c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $2a917848a127cf9c$var$_trackLCP() {
    return (0, $cLM7V.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $2a917848a127cf9c$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $2a917848a127cf9c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $2a917848a127cf9c$var$_trackFID() {
    return (0, $cLM7V.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $9mpDy.msToSec)((0, $dCjy6.browserPerformanceTimeOrigin)());
        const startTime = (0, $9mpDy.msToSec)(entry.startTime);
        $2a917848a127cf9c$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $2a917848a127cf9c$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $2a917848a127cf9c$var$_trackTtfb() {
    return (0, $cLM7V.addTtfbInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $2a917848a127cf9c$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $2a917848a127cf9c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $9mpDy.getBrowserPerformanceAPI)();
    const origin = (0, $dCjy6.browserPerformanceTimeOrigin)();
    if (!performance?.getEntries || !origin) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $9mpDy.msToSec)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $628UB.spanToJSON)(span);
    performanceEntries.slice($2a917848a127cf9c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $9mpDy.msToSec)(entry.startTime);
        const duration = (0, $9mpDy.msToSec)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $2a917848a127cf9c$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $2a917848a127cf9c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $iGpKe.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $2a917848a127cf9c$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $2a917848a127cf9c$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $2a917848a127cf9c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $2a917848a127cf9c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $2a917848a127cf9c$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $2a917848a127cf9c$var$_addTtfbRequestTimeToMeasurements($2a917848a127cf9c$var$_measurements);
        const fidMark = $2a917848a127cf9c$var$_measurements['mark.fid'];
        if (fidMark && $2a917848a127cf9c$var$_measurements['fid']) {
            // create span for FID
            (0, $9mpDy.startAndEndSpan)(span, fidMark.value, fidMark.value + (0, $9mpDy.msToSec)($2a917848a127cf9c$var$_measurements['fid'].value), {
                name: 'first input delay',
                op: 'ui.action',
                attributes: {
                    [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $2a917848a127cf9c$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!('fcp' in $2a917848a127cf9c$var$_measurements) || !options.recordClsOnPageloadSpan) delete $2a917848a127cf9c$var$_measurements.cls;
        Object.entries($2a917848a127cf9c$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $edXf6.setMeasurement)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, $1CbOk.getActivationStart)());
        $2a917848a127cf9c$var$_setWebVitalAttributes(span);
    }
    $2a917848a127cf9c$var$_lcpEntry = undefined;
    $2a917848a127cf9c$var$_clsEntry = undefined;
    $2a917848a127cf9c$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $2a917848a127cf9c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $bfzCw.getNavigationEntry)(false);
    const requestTime = (0, $9mpDy.msToSec)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $9mpDy.startAndEndSpan)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function $2a917848a127cf9c$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $2a917848a127cf9c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $2a917848a127cf9c$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $2a917848a127cf9c$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $2a917848a127cf9c$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $2a917848a127cf9c$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $2a917848a127cf9c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $2a917848a127cf9c$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $9mpDy.startAndEndSpan)(span, timeOrigin + (0, $9mpDy.msToSec)(start), timeOrigin + (0, $9mpDy.msToSec)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics',
            ...event === 'redirect' && entry.redirectCount != null ? {
                'http.redirect_count': entry.redirectCount
            } : {}
        }
    });
}
function $2a917848a127cf9c$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $2a917848a127cf9c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $9mpDy.msToSec)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $9mpDy.msToSec)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $9mpDy.msToSec)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $9mpDy.startAndEndSpan)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $9mpDy.startAndEndSpan)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $2a917848a127cf9c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $dnBI6.parseUrl)(resourceUrl);
    const attributes = {
        [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.resource.browser.metrics'
    };
    $2a917848a127cf9c$var$setResourceEntrySizeData(attributes, entry, 'transferSize', 'http.response_transfer_size');
    $2a917848a127cf9c$var$setResourceEntrySizeData(attributes, entry, 'encodedBodySize', 'http.response_content_length');
    $2a917848a127cf9c$var$setResourceEntrySizeData(attributes, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes['http.response_delivery_type'] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes['resource.render_blocking_status'] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $j6z6N.WINDOW).location.origin);
    const { name: name, version: version } = (0, $9mpDy.extractNetworkProtocol)(entry.nextHopProtocol);
    attributes['network.protocol.name'] = name;
    attributes['network.protocol.version'] = version;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $9mpDy.startAndEndSpan)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $j6z6N.WINDOW).location.origin, ''),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $2a917848a127cf9c$var$_trackNavigator(span) {
    const navigator = (0, $j6z6N.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $9mpDy.isMeasurementValue)(connection.rtt)) $2a917848a127cf9c$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $9mpDy.isMeasurementValue)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $9mpDy.isMeasurementValue)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $2a917848a127cf9c$var$_setWebVitalAttributes(span) {
    if ($2a917848a127cf9c$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($2a917848a127cf9c$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $7JT7M.htmlTreeAsString)($2a917848a127cf9c$var$_lcpEntry.element));
        if ($2a917848a127cf9c$var$_lcpEntry.id) span.setAttribute('lcp.id', $2a917848a127cf9c$var$_lcpEntry.id);
        if ($2a917848a127cf9c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $2a917848a127cf9c$var$_lcpEntry.url.trim().slice(0, 200));
        if ($2a917848a127cf9c$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $2a917848a127cf9c$var$_lcpEntry.loadTime);
        if ($2a917848a127cf9c$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $2a917848a127cf9c$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $2a917848a127cf9c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($2a917848a127cf9c$var$_clsEntry?.sources) $2a917848a127cf9c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $7JT7M.htmlTreeAsString)(source.node)));
}
function $2a917848a127cf9c$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $2a917848a127cf9c$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $2a917848a127cf9c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $bfzCw.getNavigationEntry)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}

});
parcelRegister("dCjy6", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $9e9dfcfe7c262ee5$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $9e9dfcfe7c262ee5$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $9e9dfcfe7c262ee5$export$baf075a948ffc0bf; });

var $e1Opx = parcelRequire("e1Opx");
const $9e9dfcfe7c262ee5$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $9e9dfcfe7c262ee5$export$7740643b9eeaf0c4() {
    return Date.now() / $9e9dfcfe7c262ee5$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $9e9dfcfe7c262ee5$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $e1Opx.GLOBAL_OBJ);
    if (!performance?.now) return $9e9dfcfe7c262ee5$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $9e9dfcfe7c262ee5$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $9e9dfcfe7c262ee5$export$ee52dced521e3e18 = $9e9dfcfe7c262ee5$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $9e9dfcfe7c262ee5$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $9e9dfcfe7c262ee5$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $e1Opx.GLOBAL_OBJ);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $9e9dfcfe7c262ee5$export$baf075a948ffc0bf() {
    if (!$9e9dfcfe7c262ee5$var$cachedTimeOrigin) $9e9dfcfe7c262ee5$var$cachedTimeOrigin = $9e9dfcfe7c262ee5$var$getBrowserTimeOrigin();
    return $9e9dfcfe7c262ee5$var$cachedTimeOrigin[0];
}

});

parcelRegister("628UB", function(module, exports) {
$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $4649d7b63f405070$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $4649d7b63f405070$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTransactionTraceContext", function () { return $4649d7b63f405070$export$4c3967a8a2f6bbd6; });
$parcel$export(module.exports, "spanToJSON", function () { return $4649d7b63f405070$export$92d8c23565496537; });
$parcel$export(module.exports, "spanIsSampled", function () { return $4649d7b63f405070$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "convertSpanLinksForEnvelope", function () { return $4649d7b63f405070$export$cb3e3a12e0eec16c; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $4649d7b63f405070$export$3f7581298f56c6d7; });
$parcel$export(module.exports, "getStatusMessage", function () { return $4649d7b63f405070$export$e238a77ea3a8cd66; });
$parcel$export(module.exports, "addChildSpanToSpan", function () { return $4649d7b63f405070$export$81397d924722cc65; });
$parcel$export(module.exports, "getSpanDescendants", function () { return $4649d7b63f405070$export$340c5c8a13ffc680; });
$parcel$export(module.exports, "getRootSpan", function () { return $4649d7b63f405070$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $4649d7b63f405070$export$1be426a8e585c83e; });
$parcel$export(module.exports, "showSpanDropWarning", function () { return $4649d7b63f405070$export$d11691ff45a3e535; });

var $6F2Nc = parcelRequire("6F2Nc");

var $10msY = parcelRequire("10msY");

var $35YLB = parcelRequire("35YLB");

var $AtCht = parcelRequire("AtCht");

var $bG7yO = parcelRequire("bG7yO");

var $eT8s4 = parcelRequire("eT8s4");

var $kFCRa = parcelRequire("kFCRa");

var $j7rez = parcelRequire("j7rez");

var $5Rf4F = parcelRequire("5Rf4F");

var $dCjy6 = parcelRequire("dCjy6");

var $kjRRI = parcelRequire("kjRRI");

var $2uud0 = parcelRequire("2uud0");
// These are aligned with OpenTelemetry trace flags
const $4649d7b63f405070$export$208d5b368507fb8b = 0x0;
const $4649d7b63f405070$export$eb571cd9b5d98de8 = 0x1;
let $4649d7b63f405070$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $4649d7b63f405070$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $4649d7b63f405070$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $4649d7b63f405070$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $4649d7b63f405070$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $eT8s4.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $5Rf4F.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $4649d7b63f405070$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $4649d7b63f405070$export$5caecac1caaf3a71(span);
    return (0, $kjRRI.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $4649d7b63f405070$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $4649d7b63f405070$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $4649d7b63f405070$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $4649d7b63f405070$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $4649d7b63f405070$var$ensureTimestampInSeconds(input.getTime());
    return (0, $dCjy6.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $4649d7b63f405070$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $4649d7b63f405070$export$92d8c23565496537(span) {
    if ($4649d7b63f405070$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($4649d7b63f405070$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $4649d7b63f405070$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $4649d7b63f405070$export$3f7581298f56c6d7(endTime) || undefined,
            status: $4649d7b63f405070$export$e238a77ea3a8cd66(status),
            op: attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $4649d7b63f405070$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $4649d7b63f405070$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $4649d7b63f405070$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $4649d7b63f405070$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $4649d7b63f405070$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $4649d7b63f405070$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $bG7yO.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $bG7yO.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $4649d7b63f405070$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $4649d7b63f405070$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $4649d7b63f405070$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$4649d7b63f405070$var$ROOT_SPAN_FIELD] || span;
    (0, $j7rez.addNonEnumerableProperty)(childSpan, $4649d7b63f405070$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$4649d7b63f405070$var$CHILD_SPANS_FIELD]) span[$4649d7b63f405070$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $j7rez.addNonEnumerableProperty)(span, $4649d7b63f405070$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $4649d7b63f405070$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$4649d7b63f405070$var$CHILD_SPANS_FIELD]) span[$4649d7b63f405070$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $4649d7b63f405070$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($4649d7b63f405070$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$4649d7b63f405070$var$CHILD_SPANS_FIELD] ? Array.from(span[$4649d7b63f405070$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $4649d7b63f405070$export$c4c6a79b1260ca1b(span) {
    return span[$4649d7b63f405070$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $4649d7b63f405070$export$1be426a8e585c83e() {
    const carrier = (0, $10msY.getMainCarrier)();
    const acs = (0, $6F2Nc.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $2uud0._getSpanForScope)((0, $35YLB.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $4649d7b63f405070$export$d11691ff45a3e535() {
    if (!$4649d7b63f405070$var$hasShownSpanDropWarning) {
        (0, $kFCRa.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $4649d7b63f405070$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $4649d7b63f405070$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("6F2Nc", function(module, exports) {
$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $4d98bcf5321993f1$export$f639b0c2752203be; });

var $10msY = parcelRequire("10msY");

var $jAGLT = parcelRequire("jAGLT");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $4d98bcf5321993f1$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $10msY.getMainCarrier)();
    const sentry = (0, $10msY.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $4d98bcf5321993f1$export$f639b0c2752203be(carrier) {
    const sentry = (0, $10msY.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $jAGLT.getStackAsyncContextStrategy)();
}

});
parcelRegister("jAGLT", function(module, exports) {
$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $e4328ea5471b7f25$export$329d4d4d54e42710; });

var $etnd1 = parcelRequire("etnd1");

var $5FF2L = parcelRequire("5FF2L");

var $6O5dZ = parcelRequire("6O5dZ");

var $10msY = parcelRequire("10msY");
/**
 * This is an object that holds a stack of scopes.
 */ class $e4328ea5471b7f25$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $5FF2L.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $5FF2L.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $6O5dZ.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $e4328ea5471b7f25$var$getAsyncContextStack() {
    const registry = (0, $10msY.getMainCarrier)();
    const sentry = (0, $10msY.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $e4328ea5471b7f25$export$d36ec451f120cfba((0, $etnd1.getDefaultCurrentScope)(), (0, $etnd1.getDefaultIsolationScope)());
}
function $e4328ea5471b7f25$var$withScope(callback) {
    return $e4328ea5471b7f25$var$getAsyncContextStack().withScope(callback);
}
function $e4328ea5471b7f25$var$withSetScope(scope, callback) {
    const stack = $e4328ea5471b7f25$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $e4328ea5471b7f25$var$withIsolationScope(callback) {
    return $e4328ea5471b7f25$var$getAsyncContextStack().withScope(()=>{
        return callback($e4328ea5471b7f25$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $e4328ea5471b7f25$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $e4328ea5471b7f25$var$withIsolationScope,
        withScope: $e4328ea5471b7f25$var$withScope,
        withSetScope: $e4328ea5471b7f25$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $e4328ea5471b7f25$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$e4328ea5471b7f25$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$e4328ea5471b7f25$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("etnd1", function(module, exports) {
$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $a895c6f47569d39c$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $a895c6f47569d39c$export$de9862929b76bf57; });

var $10msY = parcelRequire("10msY");

var $5FF2L = parcelRequire("5FF2L");
/** Get the default current scope. */ function $a895c6f47569d39c$export$6f1b9191db9c4d5() {
    return (0, $10msY.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $5FF2L.Scope)());
}
/** Get the default isolation scope. */ function $a895c6f47569d39c$export$de9862929b76bf57() {
    return (0, $10msY.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $5FF2L.Scope)());
}

});
parcelRegister("5FF2L", function(module, exports) {
$parcel$export(module.exports, "Scope", function () { return $42109e7c02985c7d$export$775b6bb06e53a214; });

var $4gekh = parcelRequire("4gekh");

var $8FJYL = parcelRequire("8FJYL");

var $2uud0 = parcelRequire("2uud0");

var $6O5dZ = parcelRequire("6O5dZ");

var $kFCRa = parcelRequire("kFCRa");

var $hoRpc = parcelRequire("hoRpc");

var $5Rf4F = parcelRequire("5Rf4F");

var $aWSlW = parcelRequire("aWSlW");

var $dCjy6 = parcelRequire("dCjy6");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $42109e7c02985c7d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $42109e7c02985c7d$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $5Rf4F.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $42109e7c02985c7d$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $2uud0._setSpanForScope)(newScope, (0, $2uud0._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $4gekh.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $42109e7c02985c7d$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $6O5dZ.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $2uud0._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $5Rf4F.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $42109e7c02985c7d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $dCjy6.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $aWSlW.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $2uud0._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $8FJYL.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $hoRpc.uuid4)();
        if (!this._client) {
            (0, $kFCRa.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $hoRpc.uuid4)();
        if (!this._client) {
            (0, $kFCRa.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $hoRpc.uuid4)();
        if (!this._client) {
            (0, $kFCRa.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("4gekh", function(module, exports) {
$parcel$export(module.exports, "updateSession", function () { return $31a3c4e7d3cbd4d3$export$531818e825e774db; });

var $hoRpc = parcelRequire("hoRpc");

var $dCjy6 = parcelRequire("dCjy6");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $31a3c4e7d3cbd4d3$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $dCjy6.timestampInSeconds)();
    const session = {
        sid: (0, $hoRpc.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$31a3c4e7d3cbd4d3$var$sessionToJSON(session)
    };
    if (context) $31a3c4e7d3cbd4d3$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $31a3c4e7d3cbd4d3$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $dCjy6.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $hoRpc.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $31a3c4e7d3cbd4d3$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $31a3c4e7d3cbd4d3$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $31a3c4e7d3cbd4d3$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("hoRpc", function(module, exports) {
$parcel$export(module.exports, "uuid4", function () { return $caae1ac6c2e7e705$export$19f53698e68b2496; });

var $j7rez = parcelRequire("j7rez");

var $aWSlW = parcelRequire("aWSlW");

var $e1Opx = parcelRequire("e1Opx");
function $caae1ac6c2e7e705$var$getCrypto() {
    const gbl = (0, $e1Opx.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $caae1ac6c2e7e705$export$19f53698e68b2496(crypto = $caae1ac6c2e7e705$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $caae1ac6c2e7e705$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $caae1ac6c2e7e705$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $caae1ac6c2e7e705$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $caae1ac6c2e7e705$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $caae1ac6c2e7e705$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $caae1ac6c2e7e705$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $caae1ac6c2e7e705$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $caae1ac6c2e7e705$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $caae1ac6c2e7e705$export$d364f2020ab30578(input) {
    const match = input.match($caae1ac6c2e7e705$var$SEMVER_REGEXP) || [];
    const major = $caae1ac6c2e7e705$var$_parseInt(match[1]);
    const minor = $caae1ac6c2e7e705$var$_parseInt(match[2]);
    const patch = $caae1ac6c2e7e705$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $caae1ac6c2e7e705$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $aWSlW.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $aWSlW.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $aWSlW.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $caae1ac6c2e7e705$export$6de4ffac6a2f1098(exception) {
    if ($caae1ac6c2e7e705$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $j7rez.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $caae1ac6c2e7e705$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});


parcelRegister("8FJYL", function(module, exports) {
$parcel$export(module.exports, "merge", function () { return $6505d18a29799178$export$4950aa0f605343fb; });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $6505d18a29799178$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $6505d18a29799178$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("2uud0", function(module, exports) {
$parcel$export(module.exports, "_setSpanForScope", function () { return $1d05d0eda85cc0cf$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $1d05d0eda85cc0cf$export$91f063ebb8eff307; });

var $j7rez = parcelRequire("j7rez");
const $1d05d0eda85cc0cf$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $1d05d0eda85cc0cf$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $j7rez.addNonEnumerableProperty)(scope, $1d05d0eda85cc0cf$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$1d05d0eda85cc0cf$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $1d05d0eda85cc0cf$export$91f063ebb8eff307(scope) {
    return scope[$1d05d0eda85cc0cf$var$SCOPE_SPAN_FIELD];
}

});

parcelRegister("5Rf4F", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", function () { return $443d98722fd3ea72$export$dc6d7ea554bcce10; });
$parcel$export(module.exports, "generateSpanId", function () { return $443d98722fd3ea72$export$295213bc4d0c54ad; });

var $hoRpc = parcelRequire("hoRpc");
/**
 * Generate a random, valid trace ID.
 */ function $443d98722fd3ea72$export$dc6d7ea554bcce10() {
    return (0, $hoRpc.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $443d98722fd3ea72$export$295213bc4d0c54ad() {
    return (0, $hoRpc.uuid4)().substring(16);
}

});





parcelRegister("35YLB", function(module, exports) {
$parcel$export(module.exports, "getCurrentScope", function () { return $2410f9b85c5cb2a9$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $2410f9b85c5cb2a9$export$68f3af03034c9e90; });
$parcel$export(module.exports, "withScope", function () { return $2410f9b85c5cb2a9$export$ec58d9285c204497; });
$parcel$export(module.exports, "getClient", function () { return $2410f9b85c5cb2a9$export$6bb76d6eba7e258c; });

var $6F2Nc = parcelRequire("6F2Nc");

var $10msY = parcelRequire("10msY");

var $5FF2L = parcelRequire("5FF2L");

var $5Rf4F = parcelRequire("5Rf4F");
/**
 * Get the currently active scope.
 */ function $2410f9b85c5cb2a9$export$c7be4b0125a10cba() {
    const carrier = (0, $10msY.getMainCarrier)();
    const acs = (0, $6F2Nc.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $2410f9b85c5cb2a9$export$68f3af03034c9e90() {
    const carrier = (0, $10msY.getMainCarrier)();
    const acs = (0, $6F2Nc.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $2410f9b85c5cb2a9$export$aa55d5ab8e05984f() {
    return (0, $10msY.getGlobalSingleton)('globalScope', ()=>new (0, $5FF2L.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $2410f9b85c5cb2a9$export$ec58d9285c204497(...rest) {
    const carrier = (0, $10msY.getMainCarrier)();
    const acs = (0, $6F2Nc.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $2410f9b85c5cb2a9$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $10msY.getMainCarrier)();
    const acs = (0, $6F2Nc.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $2410f9b85c5cb2a9$export$6bb76d6eba7e258c() {
    return $2410f9b85c5cb2a9$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $2410f9b85c5cb2a9$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $5Rf4F.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});

parcelRegister("AtCht", function(module, exports) {
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $06da561d3c37ef51$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $06da561d3c37ef51$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $06da561d3c37ef51$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $06da561d3c37ef51$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function () { return $06da561d3c37ef51$export$f5f95cff026507b5; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function () { return $06da561d3c37ef51$export$69cd5c610c7bb96a; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function () { return $06da561d3c37ef51$export$165ce9a229f6f050; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $06da561d3c37ef51$export$1efec95406bbe327; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function () { return $06da561d3c37ef51$export$fea48ba9f4550879; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $06da561d3c37ef51$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $06da561d3c37ef51$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $06da561d3c37ef51$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $06da561d3c37ef51$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $06da561d3c37ef51$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $06da561d3c37ef51$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $06da561d3c37ef51$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $06da561d3c37ef51$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $06da561d3c37ef51$export$1efec95406bbe327 = 'sentry.profile_id';
const $06da561d3c37ef51$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $06da561d3c37ef51$export$b016f89ac1066ec = 'cache.hit';
const $06da561d3c37ef51$export$3110e4c3f4386399 = 'cache.key';
const $06da561d3c37ef51$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $06da561d3c37ef51$export$be7a251980e7e946 = 'http.request.method';
const $06da561d3c37ef51$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $06da561d3c37ef51$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("bG7yO", function(module, exports) {
$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $88097b4b53a7f9c9$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $88097b4b53a7f9c9$export$58f7963109c806fc; });
$parcel$export(module.exports, "SPAN_STATUS_ERROR", function () { return $88097b4b53a7f9c9$export$f966a0446ece71e; });
const $88097b4b53a7f9c9$export$136e25984ba4a383 = 0;
const $88097b4b53a7f9c9$export$58f7963109c806fc = 1;
const $88097b4b53a7f9c9$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $88097b4b53a7f9c9$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $88097b4b53a7f9c9$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $88097b4b53a7f9c9$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $88097b4b53a7f9c9$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $88097b4b53a7f9c9$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $88097b4b53a7f9c9$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("eT8s4", function(module, exports) {
$parcel$export(module.exports, "setCapturedScopesOnSpan", function () { return $ad6cc21b85e2623d$export$cddb4027e3b0dd66; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $ad6cc21b85e2623d$export$c08fbc656a245d03; });

var $j7rez = parcelRequire("j7rez");
const $ad6cc21b85e2623d$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $ad6cc21b85e2623d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $ad6cc21b85e2623d$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $j7rez.addNonEnumerableProperty)(span, $ad6cc21b85e2623d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $j7rez.addNonEnumerableProperty)(span, $ad6cc21b85e2623d$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $ad6cc21b85e2623d$export$c08fbc656a245d03(span) {
    return {
        scope: span[$ad6cc21b85e2623d$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$ad6cc21b85e2623d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("kjRRI", function(module, exports) {
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $ecaf5d8b62adfa3e$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $ecaf5d8b62adfa3e$export$f35d907436da45cf; });

var $gMPye = parcelRequire("gMPye");

var $bpEU3 = parcelRequire("bpEU3");

var $5Rf4F = parcelRequire("5Rf4F");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $ecaf5d8b62adfa3e$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $ecaf5d8b62adfa3e$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($ecaf5d8b62adfa3e$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $ecaf5d8b62adfa3e$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $ecaf5d8b62adfa3e$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $bpEU3.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $5Rf4F.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $ecaf5d8b62adfa3e$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $ecaf5d8b62adfa3e$export$f35d907436da45cf(traceId = (0, $5Rf4F.generateTraceId)(), spanId = (0, $5Rf4F.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $ecaf5d8b62adfa3e$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $gMPye.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $gMPye.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("gMPye", function(module, exports) {
$parcel$export(module.exports, "parseSampleRate", function () { return $c3891e02e7a485d0$export$a5bd2d81656d9546; });
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $c3891e02e7a485d0$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});

parcelRegister("bpEU3", function(module, exports) {
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $84f1c20472f2f9f2$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $84f1c20472f2f9f2$export$56766feef403f365; });

var $e27Xs = parcelRequire("e27Xs");

var $6O5dZ = parcelRequire("6O5dZ");

var $kFCRa = parcelRequire("kFCRa");
const $84f1c20472f2f9f2$export$6e69537d67fa20f = 'sentry-';
const $84f1c20472f2f9f2$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $84f1c20472f2f9f2$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $84f1c20472f2f9f2$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $84f1c20472f2f9f2$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($84f1c20472f2f9f2$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($84f1c20472f2f9f2$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $84f1c20472f2f9f2$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$84f1c20472f2f9f2$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $84f1c20472f2f9f2$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $84f1c20472f2f9f2$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $6O5dZ.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $84f1c20472f2f9f2$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $84f1c20472f2f9f2$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $84f1c20472f2f9f2$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $84f1c20472f2f9f2$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $84f1c20472f2f9f2$export$bdd844ddb2def819) {
            (0, $e27Xs.DEBUG_BUILD) && (0, $kFCRa.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});



parcelRegister("dnBI6", function(module, exports) {
$parcel$export(module.exports, "parseUrl", function () { return $9bdaacd36b2f9c38$export$7a5253c0f62e0150; });
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $9bdaacd36b2f9c38$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $9bdaacd36b2f9c38$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $9bdaacd36b2f9c38$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.startsWith('/');
    const base = urlBase ?? (isRelative ? $9bdaacd36b2f9c38$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $9bdaacd36b2f9c38$export$5339fcdc8e2a427c(url) {
    if ($9bdaacd36b2f9c38$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $9bdaacd36b2f9c38$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $9bdaacd36b2f9c38$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $9bdaacd36b2f9c38$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("edXf6", function(module, exports) {
$parcel$export(module.exports, "setMeasurement", function () { return $a5b03bef442a8d01$export$7cc31b475d33a706; });
$parcel$export(module.exports, "timedEventsToMeasurements", function () { return $a5b03bef442a8d01$export$487db6fcdf36893e; });

var $f6rhz = parcelRequire("f6rhz");

var $AtCht = parcelRequire("AtCht");

var $628UB = parcelRequire("628UB");

var $kFCRa = parcelRequire("kFCRa");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $a5b03bef442a8d01$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $628UB.getActiveSpan)()) {
    const rootSpan = activeSpan && (0, $628UB.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: value,
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $a5b03bef442a8d01$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}

});
parcelRegister("f6rhz", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", function () { return $afec94495e00add6$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $afec94495e00add6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("e7tnH", function(module, exports) {
$parcel$export(module.exports, "trackClsAsStandaloneSpan", function () { return $a47882a5c2101cf7$export$585bab03c6c18c45; });

var $dCjy6 = parcelRequire("dCjy6");
var $628UB = parcelRequire("628UB");
var $35YLB = parcelRequire("35YLB");
var $7JT7M = parcelRequire("7JT7M");
var $kFCRa = parcelRequire("kFCRa");
var $AtCht = parcelRequire("AtCht");

var $7vzTY = parcelRequire("7vzTY");

var $cLM7V = parcelRequire("cLM7V");

var $9mpDy = parcelRequire("9mpDy");

var $bujI1 = parcelRequire("bujI1");
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $a47882a5c2101cf7$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$a47882a5c2101cf7$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $a47882a5c2101cf7$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $cLM7V.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $bujI1.onHidden)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $35YLB.getClient)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on('startNavigationSpan', ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation?.();
        });
        const activeSpan = (0, $628UB.getActiveSpan)();
        if (activeSpan) {
            const rootSpan = (0, $628UB.getRootSpan)(activeSpan);
            const spanJSON = (0, $628UB.spanToJSON)(rootSpan);
            if (spanJSON.op === 'pageload') pageloadSpanId = rootSpan.spanContext().spanId;
        }
    }, 0);
}
function $a47882a5c2101cf7$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $7vzTY.DEBUG_BUILD) && (0, $kFCRa.logger).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $9mpDy.msToSec)(((0, $dCjy6.browserPerformanceTimeOrigin)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $35YLB.getCurrentScope)().getScopeData().transactionName;
    const name = entry ? (0, $7JT7M.htmlTreeAsString)(entry.sources[0]?.node) : 'Layout shift';
    const attributes = {
        [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser.cls',
        [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'ui.webvital.cls',
        [(0, $AtCht.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry?.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId
    };
    const span = (0, $9mpDy.startStandaloneWebVitalSpan)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: '',
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $a47882a5c2101cf7$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes('layout-shift');
    } catch  {
        return false;
    }
}

});
parcelRegister("7vzTY", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", function () { return $57774704b7bc18e1$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $57774704b7bc18e1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("cLM7V", function(module, exports) {
$parcel$export(module.exports, "addClsInstrumentationHandler", function () { return $94bf34c9160ef34e$export$861b82818b37ba5b; });
$parcel$export(module.exports, "addLcpInstrumentationHandler", function () { return $94bf34c9160ef34e$export$3fd4b53331200102; });
$parcel$export(module.exports, "addFidInstrumentationHandler", function () { return $94bf34c9160ef34e$export$2707d7471c0b918f; });
$parcel$export(module.exports, "addTtfbInstrumentationHandler", function () { return $94bf34c9160ef34e$export$699d9529c099a797; });
$parcel$export(module.exports, "addInpInstrumentationHandler", function () { return $94bf34c9160ef34e$export$da3b76aa2022cbd7; });
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", function () { return $94bf34c9160ef34e$export$69816c1a049f8db6; });
$parcel$export(module.exports, "isPerformanceEventTiming", function () { return $94bf34c9160ef34e$export$7affb50b622d8714; });

var $cdBy6 = parcelRequire("cdBy6");
var $kFCRa = parcelRequire("kFCRa");

var $7vzTY = parcelRequire("7vzTY");

var $3nmWj = parcelRequire("3nmWj");

var $bEOut = parcelRequire("bEOut");

var $fGJM2 = parcelRequire("fGJM2");

var $g0G4X = parcelRequire("g0G4X");

var $fH8x4 = parcelRequire("fH8x4");

var $izmWG = parcelRequire("izmWG");
const $94bf34c9160ef34e$var$handlers = {};
const $94bf34c9160ef34e$var$instrumented = {};
let $94bf34c9160ef34e$var$_previousCls;
let $94bf34c9160ef34e$var$_previousFid;
let $94bf34c9160ef34e$var$_previousLcp;
let $94bf34c9160ef34e$var$_previousTtfb;
let $94bf34c9160ef34e$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $94bf34c9160ef34e$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $94bf34c9160ef34e$var$addMetricObserver('cls', callback, $94bf34c9160ef34e$var$instrumentCls, $94bf34c9160ef34e$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $94bf34c9160ef34e$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $94bf34c9160ef34e$var$addMetricObserver('lcp', callback, $94bf34c9160ef34e$var$instrumentLcp, $94bf34c9160ef34e$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $94bf34c9160ef34e$export$2707d7471c0b918f(callback) {
    return $94bf34c9160ef34e$var$addMetricObserver('fid', callback, $94bf34c9160ef34e$var$instrumentFid, $94bf34c9160ef34e$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $94bf34c9160ef34e$export$699d9529c099a797(callback) {
    return $94bf34c9160ef34e$var$addMetricObserver('ttfb', callback, $94bf34c9160ef34e$var$instrumentTtfb, $94bf34c9160ef34e$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $94bf34c9160ef34e$export$da3b76aa2022cbd7(callback) {
    return $94bf34c9160ef34e$var$addMetricObserver('inp', callback, $94bf34c9160ef34e$var$instrumentInp, $94bf34c9160ef34e$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $94bf34c9160ef34e$export$69816c1a049f8db6(type, callback) {
    $94bf34c9160ef34e$var$addHandler(type, callback);
    if (!$94bf34c9160ef34e$var$instrumented[type]) {
        $94bf34c9160ef34e$var$instrumentPerformanceObserver(type);
        $94bf34c9160ef34e$var$instrumented[type] = true;
    }
    return $94bf34c9160ef34e$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $94bf34c9160ef34e$var$triggerHandlers(type, data) {
    const typeHandlers = $94bf34c9160ef34e$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $7vzTY.DEBUG_BUILD) && (0, $kFCRa.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $cdBy6.getFunctionName)(handler)}\nError:`, e);
    }
}
function $94bf34c9160ef34e$var$instrumentCls() {
    return (0, $3nmWj.onCLS)((metric)=>{
        $94bf34c9160ef34e$var$triggerHandlers('cls', {
            metric: metric
        });
        $94bf34c9160ef34e$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $94bf34c9160ef34e$var$instrumentFid() {
    return (0, $bEOut.onFID)((metric)=>{
        $94bf34c9160ef34e$var$triggerHandlers('fid', {
            metric: metric
        });
        $94bf34c9160ef34e$var$_previousFid = metric;
    });
}
function $94bf34c9160ef34e$var$instrumentLcp() {
    return (0, $g0G4X.onLCP)((metric)=>{
        $94bf34c9160ef34e$var$triggerHandlers('lcp', {
            metric: metric
        });
        $94bf34c9160ef34e$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $94bf34c9160ef34e$var$instrumentTtfb() {
    return (0, $izmWG.onTTFB)((metric)=>{
        $94bf34c9160ef34e$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $94bf34c9160ef34e$var$_previousTtfb = metric;
    });
}
function $94bf34c9160ef34e$var$instrumentInp() {
    return (0, $fGJM2.onINP)((metric)=>{
        $94bf34c9160ef34e$var$triggerHandlers('inp', {
            metric: metric
        });
        $94bf34c9160ef34e$var$_previousInp = metric;
    });
}
function $94bf34c9160ef34e$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $94bf34c9160ef34e$var$addHandler(type, callback);
    let stopListening;
    if (!$94bf34c9160ef34e$var$instrumented[type]) {
        stopListening = instrumentFn();
        $94bf34c9160ef34e$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $94bf34c9160ef34e$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $94bf34c9160ef34e$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $fH8x4.observe)(type, (entries)=>{
        $94bf34c9160ef34e$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $94bf34c9160ef34e$var$addHandler(type, handler) {
    $94bf34c9160ef34e$var$handlers[type] = $94bf34c9160ef34e$var$handlers[type] || [];
    $94bf34c9160ef34e$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $94bf34c9160ef34e$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $94bf34c9160ef34e$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $94bf34c9160ef34e$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}

});
parcelRegister("3nmWj", function(module, exports) {
$parcel$export(module.exports, "onCLS", function () { return $2755505eadd1cc67$export$a7873055838e5ad8; });

var $1ZDHO = parcelRequire("1ZDHO");

var $5ECES = parcelRequire("5ECES");

var $fH8x4 = parcelRequire("fH8x4");

var $bujI1 = parcelRequire("bujI1");

var $fs2fF = parcelRequire("fs2fF");

var $7YLGO = parcelRequire("7YLGO");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $2755505eadd1cc67$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $2755505eadd1cc67$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $7YLGO.onFCP)((0, $fs2fF.runOnce)(()=>{
        const metric = (0, $5ECES.initMetric)('CLS', 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $fH8x4.observe)('layout-shift', handleEntries);
        if (po) {
            report = (0, $1ZDHO.bindReporter)(onReport, metric, $2755505eadd1cc67$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $bujI1.onHidden)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};

});
parcelRegister("1ZDHO", function(module, exports) {
$parcel$export(module.exports, "bindReporter", function () { return $173a49a4c76b84a0$export$17679dccdd551979; });
const $173a49a4c76b84a0$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $173a49a4c76b84a0$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $173a49a4c76b84a0$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("5ECES", function(module, exports) {
$parcel$export(module.exports, "initMetric", function () { return $41deace83bf5f9df$export$3c29b44508a0612b; });

var $j6z6N = parcelRequire("j6z6N");

var $aqjFf = parcelRequire("aqjFf");

var $1CbOk = parcelRequire("1CbOk");

var $bfzCw = parcelRequire("bfzCw");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $41deace83bf5f9df$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $bfzCw.getNavigationEntry)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $j6z6N.WINDOW).document?.prerendering || (0, $1CbOk.getActivationStart)() > 0) navigationType = 'prerender';
        else if ((0, $j6z6N.WINDOW).document?.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $aqjFf.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("aqjFf", function(module, exports) {
$parcel$export(module.exports, "generateUniqueID", function () { return $796b95ffd4e1f3f5$export$407ea409d1f3b539; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $796b95ffd4e1f3f5$export$407ea409d1f3b539 = ()=>{
    return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("1CbOk", function(module, exports) {
$parcel$export(module.exports, "getActivationStart", function () { return $12d28069a8b7ac45$export$d3e828b3c7b5b845; });

var $bfzCw = parcelRequire("bfzCw");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $12d28069a8b7ac45$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $bfzCw.getNavigationEntry)();
    return navEntry?.activationStart || 0;
};

});
parcelRegister("bfzCw", function(module, exports) {
$parcel$export(module.exports, "getNavigationEntry", function () { return $830cb9e2281a808a$export$6431553786c94949; });

var $j6z6N = parcelRequire("j6z6N");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $830cb9e2281a808a$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $j6z6N.WINDOW).performance?.getEntriesByType?.('navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases no value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    // https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};

});



parcelRegister("fH8x4", function(module, exports) {
$parcel$export(module.exports, "observe", function () { return $b6d17d8c53b493bf$export$d1203567a167490e; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $b6d17d8c53b493bf$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("bujI1", function(module, exports) {
$parcel$export(module.exports, "onHidden", function () { return $85d1c8d6d2066863$export$91ec2be6fdd8f1b4; });

var $j6z6N = parcelRequire("j6z6N");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $85d1c8d6d2066863$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $j6z6N.WINDOW).document?.visibilityState === 'hidden') cb(event);
    };
    if ((0, $j6z6N.WINDOW).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};

});

parcelRegister("fs2fF", function(module, exports) {
$parcel$export(module.exports, "runOnce", function () { return $b3fb37ab72f413c0$export$b841d51e31c12bab; });
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b3fb37ab72f413c0$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});

parcelRegister("7YLGO", function(module, exports) {
$parcel$export(module.exports, "onFCP", function () { return $5cf321204fb4f440$export$fe3c86b74e15d5de; });

var $1ZDHO = parcelRequire("1ZDHO");

var $1CbOk = parcelRequire("1CbOk");

var $iGpKe = parcelRequire("iGpKe");

var $5ECES = parcelRequire("5ECES");

var $fH8x4 = parcelRequire("fH8x4");

var $6MlMM = parcelRequire("6MlMM");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $5cf321204fb4f440$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $5cf321204fb4f440$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $6MlMM.whenActivated)(()=>{
        const visibilityWatcher = (0, $iGpKe.getVisibilityWatcher)();
        const metric = (0, $5ECES.initMetric)('FCP');
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === 'first-contentful-paint') {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $1CbOk.getActivationStart)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $fH8x4.observe)('paint', handleEntries);
        if (po) report = (0, $1ZDHO.bindReporter)(onReport, metric, $5cf321204fb4f440$export$e610c735b5510cec, opts.reportAllChanges);
    });
};

});
parcelRegister("iGpKe", function(module, exports) {
$parcel$export(module.exports, "getVisibilityWatcher", function () { return $d9a01e94979e70b8$export$443f86b2c77012c4; });

var $j6z6N = parcelRequire("j6z6N");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d9a01e94979e70b8$var$firstHiddenTime = -1;
const $d9a01e94979e70b8$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $j6z6N.WINDOW).document.visibilityState === 'hidden' && !(0, $j6z6N.WINDOW).document.prerendering ? 0 : Infinity;
};
const $d9a01e94979e70b8$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $j6z6N.WINDOW).document.visibilityState === 'hidden' && $d9a01e94979e70b8$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $d9a01e94979e70b8$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $d9a01e94979e70b8$var$removeChangeListeners();
    }
};
const $d9a01e94979e70b8$var$addChangeListeners = ()=>{
    addEventListener('visibilitychange', $d9a01e94979e70b8$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener('prerenderingchange', $d9a01e94979e70b8$var$onVisibilityUpdate, true);
};
const $d9a01e94979e70b8$var$removeChangeListeners = ()=>{
    removeEventListener('visibilitychange', $d9a01e94979e70b8$var$onVisibilityUpdate, true);
    removeEventListener('prerenderingchange', $d9a01e94979e70b8$var$onVisibilityUpdate, true);
};
const $d9a01e94979e70b8$export$443f86b2c77012c4 = ()=>{
    if ((0, $j6z6N.WINDOW).document && $d9a01e94979e70b8$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $d9a01e94979e70b8$var$firstHiddenTime = $d9a01e94979e70b8$var$initHiddenTime();
        $d9a01e94979e70b8$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $d9a01e94979e70b8$var$firstHiddenTime;
        }
    };
};

});

parcelRegister("6MlMM", function(module, exports) {
$parcel$export(module.exports, "whenActivated", function () { return $4ef81ff8ea5d7d71$export$8bdb38a5671b594e; });

var $j6z6N = parcelRequire("j6z6N");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4ef81ff8ea5d7d71$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $j6z6N.WINDOW).document?.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};

});



parcelRegister("bEOut", function(module, exports) {
$parcel$export(module.exports, "onFID", function () { return $87ca988024204da3$export$39705a25c49af873; });

var $1ZDHO = parcelRequire("1ZDHO");

var $iGpKe = parcelRequire("iGpKe");

var $5ECES = parcelRequire("5ECES");

var $fH8x4 = parcelRequire("fH8x4");

var $bujI1 = parcelRequire("bujI1");

var $fs2fF = parcelRequire("fs2fF");

var $6MlMM = parcelRequire("6MlMM");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $87ca988024204da3$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $87ca988024204da3$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $6MlMM.whenActivated)(()=>{
        const visibilityWatcher = (0, $iGpKe.getVisibilityWatcher)();
        const metric = (0, $5ECES.initMetric)('FID');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $fH8x4.observe)('first-input', handleEntries);
        report = (0, $1ZDHO.bindReporter)(onReport, metric, $87ca988024204da3$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $bujI1.onHidden)((0, $fs2fF.runOnce)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};

});

parcelRegister("fGJM2", function(module, exports) {
$parcel$export(module.exports, "onINP", function () { return $b6be48fe82242d52$export$7df4b36ecaed99e1; });

var $j6z6N = parcelRequire("j6z6N");

var $1ZDHO = parcelRequire("1ZDHO");

var $5ECES = parcelRequire("5ECES");

var $5Sk1p = parcelRequire("5Sk1p");

var $fH8x4 = parcelRequire("fH8x4");

var $bujI1 = parcelRequire("bujI1");

var $8CyyT = parcelRequire("8CyyT");

var $6MlMM = parcelRequire("6MlMM");

var $cZQ8g = parcelRequire("cZQ8g");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $b6be48fe82242d52$export$7f4cb060ded9173c = [
    200,
    500
];
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $b6be48fe82242d52$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in (0, $j6z6N.WINDOW) && 'interactionId' in PerformanceEventTiming.prototype)) return;
    (0, $6MlMM.whenActivated)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $8CyyT.initInteractionCountPolyfill)();
        const metric = (0, $5ECES.initMetric)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $cZQ8g.whenIdle)(()=>{
                entries.forEach((0, $5Sk1p.processInteractionEntry));
                const inp = (0, $5Sk1p.estimateP98LongestInteraction)();
                if (inp && inp.latency !== metric.value) {
                    metric.value = inp.latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $fH8x4.observe)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : (0, $5Sk1p.DEFAULT_DURATION_THRESHOLD)
        });
        report = (0, $1ZDHO.bindReporter)(onReport, metric, $b6be48fe82242d52$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            (0, $bujI1.onHidden)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};

});
parcelRegister("5Sk1p", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DURATION_THRESHOLD", function () { return $447186c6b509630b$export$9cebd8cf5d8d3416; });
$parcel$export(module.exports, "estimateP98LongestInteraction", function () { return $447186c6b509630b$export$70cf089971ed4f82; });
$parcel$export(module.exports, "processInteractionEntry", function () { return $447186c6b509630b$export$6a7a48c2c643798f; });

var $8CyyT = parcelRequire("8CyyT");
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const $447186c6b509630b$export$fbb6a65efb09cd7a = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $447186c6b509630b$export$7b86959c9ded44e2 = new Map();
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $447186c6b509630b$export$9cebd8cf5d8d3416 = 40;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $447186c6b509630b$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $447186c6b509630b$var$getInteractionCountForNavigation = ()=>{
    return (0, $8CyyT.getInteractionCount)() - $447186c6b509630b$var$prevInteractionCount;
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $447186c6b509630b$export$70cf089971ed4f82 = ()=>{
    const candidateInteractionIndex = Math.min($447186c6b509630b$export$fbb6a65efb09cd7a.length - 1, Math.floor($447186c6b509630b$var$getInteractionCountForNavigation() / 50));
    return $447186c6b509630b$export$fbb6a65efb09cd7a[candidateInteractionIndex];
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $447186c6b509630b$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */ const $447186c6b509630b$export$1c74e929da1e189d = [];
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $447186c6b509630b$export$6a7a48c2c643798f = (entry)=>{
    $447186c6b509630b$export$1c74e929da1e189d.forEach((cb)=>cb(entry));
    // Skip further processing for entries that cannot be INP candidates.
    if (!(entry.interactionId || entry.entryType === 'first-input')) return;
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $447186c6b509630b$export$fbb6a65efb09cd7a[$447186c6b509630b$export$fbb6a65efb09cd7a.length - 1];
    const existingInteraction = $447186c6b509630b$export$7b86959c9ded44e2.get(entry.interactionId);
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $447186c6b509630b$export$fbb6a65efb09cd7a.length < $447186c6b509630b$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            // If the new entry has a longer duration, replace the old entries,
            // otherwise add to the array.
            if (entry.duration > existingInteraction.latency) {
                existingInteraction.entries = [
                    entry
                ];
                existingInteraction.latency = entry.duration;
            } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0]?.startTime) existingInteraction.entries.push(entry);
        } else {
            const interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $447186c6b509630b$export$7b86959c9ded44e2.set(interaction.id, interaction);
            $447186c6b509630b$export$fbb6a65efb09cd7a.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $447186c6b509630b$export$fbb6a65efb09cd7a.sort((a, b)=>b.latency - a.latency);
        if ($447186c6b509630b$export$fbb6a65efb09cd7a.length > $447186c6b509630b$var$MAX_INTERACTIONS_TO_CONSIDER) $447186c6b509630b$export$fbb6a65efb09cd7a.splice($447186c6b509630b$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>$447186c6b509630b$export$7b86959c9ded44e2.delete(i.id));
    }
};

});
parcelRegister("8CyyT", function(module, exports) {
$parcel$export(module.exports, "getInteractionCount", function () { return $019ea7fa256df04a$export$8a962f2683a476d1; });
$parcel$export(module.exports, "initInteractionCountPolyfill", function () { return $019ea7fa256df04a$export$67d90cda6b78a2eb; });

var $fH8x4 = parcelRequire("fH8x4");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $019ea7fa256df04a$var$interactionCountEstimate = 0;
let $019ea7fa256df04a$var$minKnownInteractionId = Infinity;
let $019ea7fa256df04a$var$maxKnownInteractionId = 0;
const $019ea7fa256df04a$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $019ea7fa256df04a$var$minKnownInteractionId = Math.min($019ea7fa256df04a$var$minKnownInteractionId, e.interactionId);
            $019ea7fa256df04a$var$maxKnownInteractionId = Math.max($019ea7fa256df04a$var$maxKnownInteractionId, e.interactionId);
            $019ea7fa256df04a$var$interactionCountEstimate = $019ea7fa256df04a$var$maxKnownInteractionId ? ($019ea7fa256df04a$var$maxKnownInteractionId - $019ea7fa256df04a$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $019ea7fa256df04a$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $019ea7fa256df04a$export$8a962f2683a476d1 = ()=>{
    return $019ea7fa256df04a$var$po ? $019ea7fa256df04a$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $019ea7fa256df04a$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $019ea7fa256df04a$var$po) return;
    $019ea7fa256df04a$var$po = (0, $fH8x4.observe)('event', $019ea7fa256df04a$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("cZQ8g", function(module, exports) {
$parcel$export(module.exports, "whenIdle", function () { return $97639eec7b06f819$export$4d9952dcbf5b2792; });

var $j6z6N = parcelRequire("j6z6N");

var $bujI1 = parcelRequire("bujI1");

var $fs2fF = parcelRequire("fs2fF");
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $97639eec7b06f819$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = (0, $j6z6N.WINDOW).requestIdleCallback || (0, $j6z6N.WINDOW).setTimeout;
    let handle = -1;
    // eslint-disable-next-line no-param-reassign
    cb = (0, $fs2fF.runOnce)(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $j6z6N.WINDOW).document?.visibilityState === 'hidden') cb();
    else {
        handle = rIC(cb);
        (0, $bujI1.onHidden)(cb);
    }
    return handle;
};

});


parcelRegister("g0G4X", function(module, exports) {
$parcel$export(module.exports, "onLCP", function () { return $ba7d49700894b331$export$947b1626ab8d5632; });

var $j6z6N = parcelRequire("j6z6N");

var $1ZDHO = parcelRequire("1ZDHO");

var $1CbOk = parcelRequire("1CbOk");

var $iGpKe = parcelRequire("iGpKe");

var $5ECES = parcelRequire("5ECES");

var $fH8x4 = parcelRequire("fH8x4");

var $bujI1 = parcelRequire("bujI1");

var $fs2fF = parcelRequire("fs2fF");

var $6MlMM = parcelRequire("6MlMM");

var $cZQ8g = parcelRequire("cZQ8g");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $ba7d49700894b331$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $ba7d49700894b331$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $ba7d49700894b331$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $6MlMM.whenActivated)(()=>{
        const visibilityWatcher = (0, $iGpKe.getVisibilityWatcher)();
        const metric = (0, $5ECES.initMetric)('LCP');
        let report;
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            entries.forEach((entry)=>{
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was pre-rendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $1CbOk.getActivationStart)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            });
        };
        const po = (0, $fH8x4.observe)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $1ZDHO.bindReporter)(onReport, metric, $ba7d49700894b331$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $fs2fF.runOnce)(()=>{
                if (!$ba7d49700894b331$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $ba7d49700894b331$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                'keydown',
                'click'
            ].forEach((type)=>{
                // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                if ((0, $j6z6N.WINDOW).document) addEventListener(type, ()=>(0, $cZQ8g.whenIdle)(stopListening), {
                    once: true,
                    capture: true
                });
            });
            (0, $bujI1.onHidden)(stopListening);
        }
    });
};

});

parcelRegister("izmWG", function(module, exports) {
$parcel$export(module.exports, "onTTFB", function () { return $d84d4b5e761df3c4$export$33a01e6c5f2c7e33; });

var $j6z6N = parcelRequire("j6z6N");

var $1ZDHO = parcelRequire("1ZDHO");

var $1CbOk = parcelRequire("1CbOk");

var $bfzCw = parcelRequire("bfzCw");

var $5ECES = parcelRequire("5ECES");

var $6MlMM = parcelRequire("6MlMM");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $d84d4b5e761df3c4$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $d84d4b5e761df3c4$var$whenReady = (callback)=>{
    if ((0, $j6z6N.WINDOW).document?.prerendering) (0, $6MlMM.whenActivated)(()=>$d84d4b5e761df3c4$var$whenReady(callback));
    else if ((0, $j6z6N.WINDOW).document?.readyState !== 'complete') addEventListener('load', ()=>$d84d4b5e761df3c4$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $d84d4b5e761df3c4$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $5ECES.initMetric)('TTFB');
    const report = (0, $1ZDHO.bindReporter)(onReport, metric, $d84d4b5e761df3c4$export$65c59ea8064668fc, opts.reportAllChanges);
    $d84d4b5e761df3c4$var$whenReady(()=>{
        const navigationEntry = (0, $bfzCw.getNavigationEntry)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $1CbOk.getActivationStart)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};

});


parcelRegister("9mpDy", function(module, exports) {
$parcel$export(module.exports, "isMeasurementValue", function () { return $6d0a0e1d307058b6$export$27169ccae1b439e3; });
$parcel$export(module.exports, "startAndEndSpan", function () { return $6d0a0e1d307058b6$export$7567a67bdb69a23d; });
$parcel$export(module.exports, "startStandaloneWebVitalSpan", function () { return $6d0a0e1d307058b6$export$b71b9c7b60c5a4aa; });
$parcel$export(module.exports, "getBrowserPerformanceAPI", function () { return $6d0a0e1d307058b6$export$f72a13c439a30cab; });
$parcel$export(module.exports, "msToSec", function () { return $6d0a0e1d307058b6$export$b4785dbd4a81b33f; });
$parcel$export(module.exports, "extractNetworkProtocol", function () { return $6d0a0e1d307058b6$export$57c6f824442f9fe1; });

var $35YLB = parcelRequire("35YLB");
var $628UB = parcelRequire("628UB");
var $lWTJq = parcelRequire("lWTJq");

var $j6z6N = parcelRequire("j6z6N");
/**
 * Checks if a given value is a valid measurement value.
 */ function $6d0a0e1d307058b6$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $6d0a0e1d307058b6$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $628UB.spanToJSON)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $lWTJq.withActiveSpan)(parentSpan, ()=>{
        const span = (0, $lWTJq.startInactiveSpan)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $6d0a0e1d307058b6$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $35YLB.getClient)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId();
    const scope = (0, $35YLB.getCurrentScope)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (0, $j6z6N.WINDOW).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        'client.address': sendDefaultPii ? '{{auto}}' : undefined,
        ...passedAttributes
    };
    return (0, $lWTJq.startInactiveSpan)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $6d0a0e1d307058b6$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $j6z6N.WINDOW).addEventListener && (0, $j6z6N.WINDOW).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $6d0a0e1d307058b6$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $6d0a0e1d307058b6$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}

});
parcelRegister("lWTJq", function(module, exports) {
$parcel$export(module.exports, "startInactiveSpan", function () { return $ffaa3ee3e155481c$export$63dbba021a6b4047; });
$parcel$export(module.exports, "withActiveSpan", function () { return $ffaa3ee3e155481c$export$e57ac09b143d92a2; });

var $6F2Nc = parcelRequire("6F2Nc");

var $10msY = parcelRequire("10msY");

var $35YLB = parcelRequire("35YLB");

var $f6rhz = parcelRequire("f6rhz");

var $AtCht = parcelRequire("AtCht");

var $l3xww = parcelRequire("l3xww");

var $layNS = parcelRequire("layNS");

var $gMPye = parcelRequire("gMPye");

var $2uud0 = parcelRequire("2uud0");

var $628UB = parcelRequire("628UB");

var $kFCRa = parcelRequire("kFCRa");

var $5Rf4F = parcelRequire("5Rf4F");

var $kjRRI = parcelRequire("kjRRI");

var $hxiAO = parcelRequire("hxiAO");

var $a5Ozw = parcelRequire("a5Ozw");

var $gHJXo = parcelRequire("gHJXo");

var $3bHnH = parcelRequire("3bHnH");

var $gHWtr = parcelRequire("gHWtr");

var $bG7yO = parcelRequire("bG7yO");

var $eT8s4 = parcelRequire("eT8s4");
/* eslint-disable max-lines */ const $ffaa3ee3e155481c$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $ffaa3ee3e155481c$export$a1bd95187356f372(options, callback) {
    const acs = $ffaa3ee3e155481c$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $ffaa3ee3e155481c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $35YLB.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $ffaa3ee3e155481c$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $35YLB.getCurrentScope)();
            const parentSpan = $ffaa3ee3e155481c$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $3bHnH.SentryNonRecordingSpan)() : $ffaa3ee3e155481c$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $2uud0._setSpanForScope)(scope, activeSpan);
            return (0, $l3xww.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $628UB.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $bG7yO.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $ffaa3ee3e155481c$export$c10292ad04b92aea(options, callback) {
    const acs = $ffaa3ee3e155481c$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $ffaa3ee3e155481c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $35YLB.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $ffaa3ee3e155481c$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $35YLB.getCurrentScope)();
            const parentSpan = $ffaa3ee3e155481c$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $3bHnH.SentryNonRecordingSpan)() : $ffaa3ee3e155481c$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $2uud0._setSpanForScope)(scope, activeSpan);
            return (0, $l3xww.handleCallbackErrors)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $628UB.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $bG7yO.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $ffaa3ee3e155481c$export$63dbba021a6b4047(options) {
    const acs = $ffaa3ee3e155481c$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $ffaa3ee3e155481c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $35YLB.withScope)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$ffaa3ee3e155481c$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $35YLB.getCurrentScope)();
        const parentSpan = $ffaa3ee3e155481c$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $3bHnH.SentryNonRecordingSpan)();
        return $ffaa3ee3e155481c$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $ffaa3ee3e155481c$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $10msY.getMainCarrier)();
    const acs = (0, $6F2Nc.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $35YLB.withScope)((scope)=>{
        const propagationContext = (0, $kjRRI.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $ffaa3ee3e155481c$export$e57ac09b143d92a2(span, callback) {
    const acs = $ffaa3ee3e155481c$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $35YLB.withScope)((scope)=>{
        (0, $2uud0._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $ffaa3ee3e155481c$export$869298f9835abc68(callback) {
    const acs = $ffaa3ee3e155481c$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $35YLB.withScope)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$ffaa3ee3e155481c$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $ffaa3ee3e155481c$export$f90b03291402f553(callback) {
    return (0, $35YLB.withScope)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $5Rf4F.generateTraceId)(),
            sampleRand: Math.random()
        });
        (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $ffaa3ee3e155481c$export$e57ac09b143d92a2(null, callback);
    });
}
function $ffaa3ee3e155481c$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $layNS.hasSpansEnabled)()) {
        const span = new (0, $3bHnH.SentryNonRecordingSpan)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $hxiAO.getDynamicSamplingContextFromSpan)(span)
            };
            (0, $hxiAO.freezeDscOnSpan)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $35YLB.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $ffaa3ee3e155481c$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $628UB.addChildSpanToSpan)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $hxiAO.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $628UB.spanIsSampled)(parentSpan);
        span = $ffaa3ee3e155481c$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $hxiAO.freezeDscOnSpan)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $ffaa3ee3e155481c$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $hxiAO.freezeDscOnSpan)(span, dsc);
    }
    (0, $a5Ozw.logSpanStart)(span);
    (0, $eT8s4.setCapturedScopesOnSpan)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $ffaa3ee3e155481c$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $628UB.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $ffaa3ee3e155481c$var$getAcs() {
    const carrier = (0, $10msY.getMainCarrier)();
    return (0, $6F2Nc.getAsyncContextStrategy)(carrier);
}
function $ffaa3ee3e155481c$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $35YLB.getClient)();
    const options = client?.getOptions() || {};
    const { name: name = '', attributes: attributes } = spanArguments;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$ffaa3ee3e155481c$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $gHJXo.sampleSpan)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        parentSampleRate: (0, $gMPye.parseSampleRate)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $gHWtr.SentrySpan)({
        ...spanArguments,
        attributes: {
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $ffaa3ee3e155481c$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$ffaa3ee3e155481c$var$SUPPRESS_TRACING_KEY] ? false : (0, $628UB.spanIsSampled)(parentSpan);
    const childSpan = sampled ? new (0, $gHWtr.SentrySpan)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $3bHnH.SentryNonRecordingSpan)({
        traceId: traceId
    });
    (0, $628UB.addChildSpanToSpan)(parentSpan, childSpan);
    const client = (0, $35YLB.getClient)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $ffaa3ee3e155481c$var$getParentSpan(scope) {
    const span = (0, $2uud0._getSpanForScope)(scope);
    if (!span) return undefined;
    const client = (0, $35YLB.getClient)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $628UB.getRootSpan)(span);
    return span;
}
function $ffaa3ee3e155481c$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $ffaa3ee3e155481c$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}

});
parcelRegister("l3xww", function(module, exports) {
$parcel$export(module.exports, "handleCallbackErrors", function () { return $f543e1db9ef1ce94$export$18ce21a8b7efd7e9; });

var $6O5dZ = parcelRequire("6O5dZ");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $f543e1db9ef1ce94$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $f543e1db9ef1ce94$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $f543e1db9ef1ce94$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $6O5dZ.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("layNS", function(module, exports) {
$parcel$export(module.exports, "hasSpansEnabled", function () { return $f69587681fb23930$export$1f70765132c3c225; });

var $35YLB = parcelRequire("35YLB");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $f69587681fb23930$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $35YLB.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $f69587681fb23930$export$5008da00b1b6dee6 = $f69587681fb23930$export$1f70765132c3c225;

});

parcelRegister("hxiAO", function(module, exports) {
$parcel$export(module.exports, "freezeDscOnSpan", function () { return $cc43f0df6032d892$export$7398c93e763ca9fd; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $cc43f0df6032d892$export$a117f995597e25df; });

var $7MOUF = parcelRequire("7MOUF");

var $35YLB = parcelRequire("35YLB");

var $AtCht = parcelRequire("AtCht");

var $layNS = parcelRequire("layNS");

var $628UB = parcelRequire("628UB");

var $bpEU3 = parcelRequire("bpEU3");

var $j7rez = parcelRequire("j7rez");

var $eT8s4 = parcelRequire("eT8s4");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $cc43f0df6032d892$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $cc43f0df6032d892$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $j7rez.addNonEnumerableProperty)(spanWithMaybeDsc, $cc43f0df6032d892$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $cc43f0df6032d892$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $7MOUF.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $cc43f0df6032d892$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $cc43f0df6032d892$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $cc43f0df6032d892$export$a117f995597e25df(span) {
    const client = (0, $35YLB.getClient)();
    if (!client) return {};
    const rootSpan = (0, $628UB.getRootSpan)(span);
    const rootSpanJson = (0, $628UB.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$cc43f0df6032d892$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $bpEU3.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $cc43f0df6032d892$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $layNS.hasSpansEnabled)()) {
        dsc.sampled = String((0, $628UB.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $eT8s4.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $cc43f0df6032d892$export$95cf936fdacaff7b(span) {
    const dsc = $cc43f0df6032d892$export$a117f995597e25df(span);
    return (0, $bpEU3.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("7MOUF", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $5ab48255315025ed$export$849dbeeeda01ae98; });
const $5ab48255315025ed$export$849dbeeeda01ae98 = 'production';

});


parcelRegister("a5Ozw", function(module, exports) {
$parcel$export(module.exports, "logSpanStart", function () { return $7591998b849cceda$export$2f3d84e767c9592b; });
$parcel$export(module.exports, "logSpanEnd", function () { return $7591998b849cceda$export$b77c830667a4d630; });

var $f6rhz = parcelRequire("f6rhz");

var $628UB = parcelRequire("628UB");

var $kFCRa = parcelRequire("kFCRa");
/**
 * Print a log message for a started span.
 */ function $7591998b849cceda$export$2f3d84e767c9592b(span) {
    if (!(0, $f6rhz.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $628UB.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $628UB.spanIsSampled)(span);
    const rootSpan = (0, $628UB.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $628UB.spanToJSON)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $kFCRa.logger).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $7591998b849cceda$export$b77c830667a4d630(span) {
    if (!(0, $f6rhz.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $628UB.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $628UB.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $kFCRa.logger).log(msg);
}

});

parcelRegister("gHJXo", function(module, exports) {
$parcel$export(module.exports, "sampleSpan", function () { return $c2944f92737fad0b$export$5f833db634b217bb; });

var $f6rhz = parcelRequire("f6rhz");

var $layNS = parcelRequire("layNS");

var $gMPye = parcelRequire("gMPye");

var $kFCRa = parcelRequire("kFCRa");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $c2944f92737fad0b$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $layNS.hasSpansEnabled)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $gMPye.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}

});

parcelRegister("3bHnH", function(module, exports) {
$parcel$export(module.exports, "SentryNonRecordingSpan", function () { return $25240cc5c2b6ae5a$export$d6636b700b76c516; });

var $628UB = parcelRequire("628UB");

var $5Rf4F = parcelRequire("5Rf4F");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $25240cc5c2b6ae5a$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $5Rf4F.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $5Rf4F.generateSpanId)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $628UB.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}

});

parcelRegister("gHWtr", function(module, exports) {
$parcel$export(module.exports, "SentrySpan", function () { return $c29e052b8d93c724$export$a92149b045260d9f; });

var $35YLB = parcelRequire("35YLB");

var $f6rhz = parcelRequire("f6rhz");

var $33piq = parcelRequire("33piq");

var $AtCht = parcelRequire("AtCht");

var $628UB = parcelRequire("628UB");

var $kFCRa = parcelRequire("kFCRa");

var $5Rf4F = parcelRequire("5Rf4F");

var $dCjy6 = parcelRequire("dCjy6");

var $hxiAO = parcelRequire("hxiAO");

var $a5Ozw = parcelRequire("a5Ozw");

var $edXf6 = parcelRequire("edXf6");

var $eT8s4 = parcelRequire("eT8s4");
const $c29e052b8d93c724$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $c29e052b8d93c724$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $5Rf4F.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $5Rf4F.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, $dCjy6.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'manual',
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $628UB.TRACE_FLAG_SAMPLED) : (0, $628UB.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $628UB.spanTimeInputToSeconds)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $628UB.spanTimeInputToSeconds)(endTimestamp);
        (0, $a5Ozw.logSpanEnd)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $628UB.getStatusMessage)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: (0, $edXf6.timedEventsToMeasurements)(this._events),
            is_segment: this._isStandaloneSpan && (0, $628UB.getRootSpan)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $628UB.getRootSpan)(this).spanContext().spanId : undefined,
            links: (0, $628UB.convertSpanLinksForEnvelope)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).log('[Tracing] Adding an event to span:', name);
        const time = $c29e052b8d93c724$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $dCjy6.timestampInSeconds)();
        const attributes = $c29e052b8d93c724$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $628UB.spanTimeInputToSeconds)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $35YLB.getClient)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $628UB.getRootSpan)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $c29e052b8d93c724$var$sendSpanEnvelope((0, $33piq.createSpanEnvelope)([
                this
            ], client));
            else {
                (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $eT8s4.getCapturedScopesOnSpan)(this).scope || (0, $35YLB.getCurrentScope)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$c29e052b8d93c724$var$isFullFinishedSpan((0, $628UB.spanToJSON)(this))) return undefined;
        if (!this._name) {
            (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $eT8s4.getCapturedScopesOnSpan)(this);
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $628UB.getSpanDescendants)(this).filter((span)=>span !== this && !$c29e052b8d93c724$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $628UB.spanToJSON)(span)).filter($c29e052b8d93c724$var$isFullFinishedSpan);
        const source = this._attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        spans.forEach((span)=>{
            delete span.data[0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $628UB.spanToTransactionTraceContext)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $c29e052b8d93c724$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $c29e052b8d93c724$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $hxiAO.getDynamicSamplingContextFromSpan)(this)
            },
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $edXf6.timedEventsToMeasurements)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $f6rhz.DEBUG_BUILD) && (0, $kFCRa.logger).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $c29e052b8d93c724$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $c29e052b8d93c724$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $c29e052b8d93c724$var$isStandaloneSpan(span) {
    return span instanceof $c29e052b8d93c724$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $c29e052b8d93c724$var$sendSpanEnvelope(envelope) {
    const client = (0, $35YLB.getClient)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

});
parcelRegister("33piq", function(module, exports) {
$parcel$export(module.exports, "createSpanEnvelope", function () { return $239546319e69ab59$export$19a0081d4b39d77; });

var $hxiAO = parcelRequire("hxiAO");

var $628UB = parcelRequire("628UB");

var $hyDm8 = parcelRequire("hyDm8");

var $2Ox7Y = parcelRequire("2Ox7Y");


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $239546319e69ab59$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $239546319e69ab59$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2Ox7Y.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $hyDm8.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $2Ox7Y.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $239546319e69ab59$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2Ox7Y.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $239546319e69ab59$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $2Ox7Y.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2Ox7Y.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $239546319e69ab59$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $hxiAO.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $hyDm8.dsnToString)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $628UB.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $628UB.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $628UB.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $2Ox7Y.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $2Ox7Y.createEnvelope)(headers, items);
}

});
parcelRegister("hyDm8", function(module, exports) {
$parcel$export(module.exports, "dsnToString", function () { return $cc8423e8768c6bc5$export$44d472fbb931a776; });

var $e27Xs = parcelRequire("e27Xs");

var $kFCRa = parcelRequire("kFCRa");
/** Regular expression used to parse a Dsn. */ const $cc8423e8768c6bc5$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $cc8423e8768c6bc5$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $cc8423e8768c6bc5$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $cc8423e8768c6bc5$export$b892860177f70a30(str) {
    const match = $cc8423e8768c6bc5$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $kFCRa.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $cc8423e8768c6bc5$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $cc8423e8768c6bc5$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $cc8423e8768c6bc5$var$validateDsn(dsn) {
    if (!(0, $e27Xs.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $kFCRa.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $kFCRa.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$cc8423e8768c6bc5$var$isValidProtocol(protocol)) {
        (0, $kFCRa.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $kFCRa.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $cc8423e8768c6bc5$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $cc8423e8768c6bc5$export$b892860177f70a30(from) : $cc8423e8768c6bc5$var$dsnFromComponents(from);
    if (!components || !$cc8423e8768c6bc5$var$validateDsn(components)) return undefined;
    return components;
}

});

parcelRegister("2Ox7Y", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", function () { return $20c9f2bf43f570cb$export$f93f7f385160c44e; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $20c9f2bf43f570cb$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $20c9f2bf43f570cb$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $20c9f2bf43f570cb$export$92b6093782fe661b; });

var $10msY = parcelRequire("10msY");

var $hyDm8 = parcelRequire("hyDm8");

var $3Uf5t = parcelRequire("3Uf5t");

var $e1Opx = parcelRequire("e1Opx");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $20c9f2bf43f570cb$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $20c9f2bf43f570cb$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $20c9f2bf43f570cb$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $20c9f2bf43f570cb$export$604a45d95a155e2b(envelope, types) {
    return $20c9f2bf43f570cb$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $20c9f2bf43f570cb$var$encodeUTF8(input) {
    const carrier = (0, $10msY.getSentryCarrier)((0, $e1Opx.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $20c9f2bf43f570cb$var$decodeUTF8(input) {
    const carrier = (0, $10msY.getSentryCarrier)((0, $e1Opx.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $20c9f2bf43f570cb$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $20c9f2bf43f570cb$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $20c9f2bf43f570cb$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $3Uf5t.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $20c9f2bf43f570cb$var$concatBuffers(parts);
}
function $20c9f2bf43f570cb$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $20c9f2bf43f570cb$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $20c9f2bf43f570cb$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($20c9f2bf43f570cb$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $20c9f2bf43f570cb$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $20c9f2bf43f570cb$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $20c9f2bf43f570cb$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $20c9f2bf43f570cb$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    otel_log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $20c9f2bf43f570cb$export$b11169581eeaf237(type) {
    return $20c9f2bf43f570cb$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $20c9f2bf43f570cb$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $20c9f2bf43f570cb$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $hyDm8.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

});
parcelRegister("3Uf5t", function(module, exports) {
$parcel$export(module.exports, "normalize", function () { return $2d824e1946dfffc0$export$a3295358bff77e; });

var $6O5dZ = parcelRequire("6O5dZ");

var $j7rez = parcelRequire("j7rez");

var $cdBy6 = parcelRequire("cdBy6");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d824e1946dfffc0$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $2d824e1946dfffc0$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $2d824e1946dfffc0$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $2d824e1946dfffc0$export$a3295358bff77e(object, depth);
    if ($2d824e1946dfffc0$var$jsonSize(normalized) > maxSize) return $2d824e1946dfffc0$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $2d824e1946dfffc0$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $2d824e1946dfffc0$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $2d824e1946dfffc0$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $2d824e1946dfffc0$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $j7rez.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $2d824e1946dfffc0$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $2d824e1946dfffc0$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $6O5dZ.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $6O5dZ.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $cdBy6.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $2d824e1946dfffc0$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $2d824e1946dfffc0$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $2d824e1946dfffc0$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d824e1946dfffc0$var$jsonSize(value) {
    return $2d824e1946dfffc0$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $2d824e1946dfffc0$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $2d824e1946dfffc0$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});








parcelRegister("kpbhz", function(module, exports) {
$parcel$export(module.exports, "startTrackingINP", function () { return $edaee4df3efb35d1$export$f17d06681a4744a3; });
$parcel$export(module.exports, "registerInpInteractionListener", function () { return $edaee4df3efb35d1$export$e4e04d43e223cce2; });

var $dCjy6 = parcelRequire("dCjy6");
var $628UB = parcelRequire("628UB");
var $35YLB = parcelRequire("35YLB");
var $7JT7M = parcelRequire("7JT7M");
var $AtCht = parcelRequire("AtCht");

var $cLM7V = parcelRequire("cLM7V");

var $9mpDy = parcelRequire("9mpDy");
const $edaee4df3efb35d1$var$LAST_INTERACTIONS = [];
const $edaee4df3efb35d1$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $edaee4df3efb35d1$export$f17d06681a4744a3() {
    const performance = (0, $9mpDy.getBrowserPerformanceAPI)();
    if (performance && (0, $dCjy6.browserPerformanceTimeOrigin)()) {
        const inpCallback = $edaee4df3efb35d1$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $edaee4df3efb35d1$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $edaee4df3efb35d1$var$_trackINP() {
    return (0, $cLM7V.addInpInstrumentationHandler)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $edaee4df3efb35d1$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $edaee4df3efb35d1$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $9mpDy.msToSec)((0, $dCjy6.browserPerformanceTimeOrigin)() + entry.startTime);
        const duration = (0, $9mpDy.msToSec)(metric.value);
        const activeSpan = (0, $628UB.getActiveSpan)();
        const rootSpan = activeSpan ? (0, $628UB.getRootSpan)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $edaee4df3efb35d1$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $628UB.spanToJSON)(spanToUse).description : (0, $35YLB.getCurrentScope)().getScopeData().transactionName;
        const name = (0, $7JT7M.htmlTreeAsString)(entry.target);
        const attributes = {
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser.inp',
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: `ui.interaction.${interactionType}`,
            [(0, $AtCht.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry.duration
        };
        const span = (0, $9mpDy.startStandaloneWebVitalSpan)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        if (span) {
            span.addEvent('inp', {
                [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: 'millisecond',
                [(0, $AtCht.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: metric.value
            });
            span.end(startTime + duration);
        }
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 */ function $edaee4df3efb35d1$export$e4e04d43e223cce2() {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $628UB.getActiveSpan)();
        const activeRootSpan = activeSpan && (0, $628UB.getRootSpan)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $cLM7V.isPerformanceEventTiming)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($edaee4df3efb35d1$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($edaee4df3efb35d1$var$LAST_INTERACTIONS.length > 10) {
                const last = $edaee4df3efb35d1$var$LAST_INTERACTIONS.shift();
                $edaee4df3efb35d1$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $edaee4df3efb35d1$var$LAST_INTERACTIONS.push(interactionId);
            $edaee4df3efb35d1$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $cLM7V.addPerformanceInstrumentationHandler)('event', handleEntries);
    (0, $cLM7V.addPerformanceInstrumentationHandler)('first-input', handleEntries);
}

});

parcelRegister("61ZAj", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", function () { return $46429b8032b0626e$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $46429b8032b0626e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("fzkK8", function(module, exports) {
$parcel$export(module.exports, "registerBackgroundTabDetection", function () { return $b55a370d3a65a914$export$6f18f55521af71a1; });

var $8j0KV = parcelRequire("8j0KV");
var $9sRth = parcelRequire("9sRth");
var $lkPDN = parcelRequire("lkPDN");

var $61ZAj = parcelRequire("61ZAj");

var $aT7cw = parcelRequire("aT7cw");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $b55a370d3a65a914$export$6f18f55521af71a1() {
    if ((0, $aT7cw.WINDOW).document) (0, $aT7cw.WINDOW).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $8j0KV.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $8j0KV.getRootSpan)(activeSpan);
        if ((0, $aT7cw.WINDOW).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $8j0KV.spanToJSON)(rootSpan);
            if (0, $61ZAj.DEBUG_BUILD) (0, $9sRth.logger).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $lkPDN.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

});

parcelRegister("5mFTz", function(module, exports) {
$parcel$export(module.exports, "addPreviousTraceSpanLink", function () { return $3e7f815cdad0a5a2$export$ae31cf84cbfc630e; });
$parcel$export(module.exports, "storePreviousTraceInSessionStorage", function () { return $3e7f815cdad0a5a2$export$e3dcc2666496dd96; });
$parcel$export(module.exports, "getPreviousTraceFromSessionStorage", function () { return $3e7f815cdad0a5a2$export$ef546bba8a402d99; });

var $9sRth = parcelRequire("9sRth");
var $dhhBD = parcelRequire("dhhBD");
var $8j0KV = parcelRequire("8j0KV");

var $61ZAj = parcelRequire("61ZAj");

var $aT7cw = parcelRequire("aT7cw");








// 1h in seconds
const $3e7f815cdad0a5a2$export$c8d616af96ac729f = 3600;
// session storage key
const $3e7f815cdad0a5a2$export$16b6aa13b3c0f075 = 'sentry_previous_trace';
const $3e7f815cdad0a5a2$export$237518aee8726f02 = 'sentry.previous_trace';
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function $3e7f815cdad0a5a2$export$ae31cf84cbfc630e(previousTraceInfo, span) {
    const spanJson = (0, $8j0KV.spanToJSON)(span);
    if (!previousTraceInfo) return {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp
    };
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= $3e7f815cdad0a5a2$export$c8d616af96ac729f) {
        if (0, $61ZAj.DEBUG_BUILD) (0, $9sRth.logger).info(`Adding previous_trace ${previousTraceSpanCtx} link to span ${{
            op: spanJson.op,
            ...span.spanContext()
        }}`);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $dhhBD.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: 'previous_trace'
            }
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v10), to remind us
        // to check this at v10 time :)
        span.setAttribute($3e7f815cdad0a5a2$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${previousTraceSpanCtx.traceFlags === 0x1 ? 1 : 0}`);
    }
    return {
        spanContext: span.spanContext(),
        startTimestamp: (0, $8j0KV.spanToJSON)(span).start_timestamp
    };
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function $3e7f815cdad0a5a2$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $aT7cw.WINDOW).sessionStorage.setItem($3e7f815cdad0a5a2$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).warn('Could not store previous trace in sessionStorage', e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function $3e7f815cdad0a5a2$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $aT7cw.WINDOW).sessionStorage?.getItem($3e7f815cdad0a5a2$export$16b6aa13b3c0f075);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch (e) {
        return undefined;
    }
}

});

parcelRegister("jcAdp", function(module, exports) {
$parcel$export(module.exports, "defaultRequestInstrumentationOptions", function () { return $dfab3aed8f17ebc5$export$cc17fb3c0bc95cd7; });
$parcel$export(module.exports, "instrumentOutgoingRequests", function () { return $dfab3aed8f17ebc5$export$864489cb3478db3e; });

var $aTDFo = parcelRequire("aTDFo");
var $2CVVa = parcelRequire("2CVVa");
var $8j0KV = parcelRequire("8j0KV");
var $i7nxO = parcelRequire("i7nxO");
var $7skVW = parcelRequire("7skVW");
var $1c840 = parcelRequire("1c840");
var $isIB5 = parcelRequire("isIB5");
var $NdIGg = parcelRequire("NdIGg");
var $3m1OO = parcelRequire("3m1OO");
var $dhhBD = parcelRequire("dhhBD");
var $ls7oW = parcelRequire("ls7oW");
var $lkPDN = parcelRequire("lkPDN");
var $1Yn6D = parcelRequire("1Yn6D");
var $gUnvu = parcelRequire("gUnvu");

var $cLM7V = parcelRequire("cLM7V");
var $hPTFb = parcelRequire("hPTFb");
var $9mpDy = parcelRequire("9mpDy");

var $aT7cw = parcelRequire("aT7cw");
/** Options for Request Instrumentation */ const $dfab3aed8f17ebc5$var$responseToSpanId = new WeakMap();
const $dfab3aed8f17ebc5$var$spanIdToEndTimestamp = new Map();
const $dfab3aed8f17ebc5$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $dfab3aed8f17ebc5$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart } = {
        ...$dfab3aed8f17ebc5$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$dfab3aed8f17ebc5$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $dfab3aed8f17ebc5$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $dfab3aed8f17ebc5$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $aTDFo.addFetchEndInstrumentationHandler)((handlerData)=>{
            if (handlerData.response) {
                const span = $dfab3aed8f17ebc5$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $dfab3aed8f17ebc5$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $aTDFo.addFetchInstrumentationHandler)((handlerData)=>{
            const createdSpan = (0, $NdIGg.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $dfab3aed8f17ebc5$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $dfab3aed8f17ebc5$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $3m1OO.parseUrl)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl,
                    'server.address': host
                });
                if (enableHTTPTimings) $dfab3aed8f17ebc5$var$addHTTPTimings(createdSpan);
                onRequestSpanStart?.(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, $hPTFb.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $dfab3aed8f17ebc5$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (createdSpan) {
            if (enableHTTPTimings) $dfab3aed8f17ebc5$var$addHTTPTimings(createdSpan);
            let headers;
            try {
                headers = new Headers(handlerData.xhr.__sentry_xhr_v3__?.request_headers);
            } catch  {
            // noop
            }
            onRequestSpanStart?.(createdSpan, {
                headers: headers
            });
        }
    });
}
function $dfab3aed8f17ebc5$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $dfab3aed8f17ebc5$var$addHTTPTimings(span) {
    const { url: url } = (0, $8j0KV.spanToJSON)(span).data;
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $cLM7V.addPerformanceInstrumentationHandler)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($dfab3aed8f17ebc5$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $dfab3aed8f17ebc5$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
function $dfab3aed8f17ebc5$var$getAbsoluteTime(time = 0) {
    return (((0, $2CVVa.browserPerformanceTimeOrigin)() || performance.timeOrigin) + time) / 1000;
}
function $dfab3aed8f17ebc5$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = (0, $9mpDy.extractNetworkProtocol)(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $2CVVa.browserPerformanceTimeOrigin)()) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $dfab3aed8f17ebc5$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $dfab3aed8f17ebc5$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $7skVW.getLocationHref)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $gUnvu.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $gUnvu.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $gUnvu.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $dfab3aed8f17ebc5$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $hPTFb.SENTRY_XHR_DATA_KEY];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $isIB5.hasSpansEnabled)() && shouldCreateSpan(url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $lkPDN.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $dfab3aed8f17ebc5$var$getFullURL(url);
    const parsedUrl = fullUrl ? (0, $3m1OO.parseUrl)(fullUrl) : (0, $3m1OO.parseUrl)(url);
    const urlForSpanName = (0, $3m1OO.stripUrlQueryAndFragment)(url);
    const hasParent = !!(0, $8j0KV.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $1Yn6D.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: url,
            type: 'xhr',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': parsedUrl?.host,
            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser',
            [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'http.client',
            ...parsedUrl?.search && {
                'http.query': parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                'http.fragment': parsedUrl?.hash
            }
        }
    }) : new (0, $ls7oW.SentryNonRecordingSpan)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(url)) $dfab3aed8f17ebc5$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $isIB5.hasSpansEnabled)() && hasParent ? span : undefined);
    const client = (0, $i7nxO.getClient)();
    if (client) client.emit('beforeOutgoingRequestSpan', span, handlerData);
    return span;
}
function $dfab3aed8f17ebc5$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { 'sentry-trace': sentryTrace, baggage: baggage } = (0, $1c840.getTraceData)({
        span: span
    });
    if (sentryTrace) $dfab3aed8f17ebc5$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $dfab3aed8f17ebc5$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('baggage', sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $dfab3aed8f17ebc5$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $aT7cw.WINDOW).location.origin);
        return parsed.href;
    } catch  {
        return undefined;
    }
}

});
parcelRegister("aTDFo", function(module, exports) {
$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $7eedcf6473a55f44$export$f75d3c772c923df0; });
$parcel$export(module.exports, "addFetchEndInstrumentationHandler", function () { return $7eedcf6473a55f44$export$1a79663eb318fe6a; });

var $86GZW = parcelRequire("86GZW");

var $3eJmu = parcelRequire("3eJmu");

var $iUuih = parcelRequire("iUuih");

var $2CVVa = parcelRequire("2CVVa");

var $9ishN = parcelRequire("9ishN");

var $dkXNk = parcelRequire("dkXNk");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7eedcf6473a55f44$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $dkXNk.addHandler)(type, handler);
    (0, $dkXNk.maybeInstrument)(type, ()=>$7eedcf6473a55f44$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $7eedcf6473a55f44$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $dkXNk.addHandler)(type, handler);
    (0, $dkXNk.maybeInstrument)(type, ()=>$7eedcf6473a55f44$var$instrumentFetch($7eedcf6473a55f44$var$streamHandler));
}
function $7eedcf6473a55f44$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $iUuih.supportsNativeFetch)()) return;
    (0, $3eJmu.fill)((0, $9ishN.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $7eedcf6473a55f44$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $2CVVa.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $7eedcf6473a55f44$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $dkXNk.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $9ishN.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $dkXNk.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $2CVVa.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $dkXNk.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $2CVVa.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $86GZW.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $3eJmu.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $7eedcf6473a55f44$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $7eedcf6473a55f44$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $7eedcf6473a55f44$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $dkXNk.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $2CVVa.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $7eedcf6473a55f44$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $7eedcf6473a55f44$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($7eedcf6473a55f44$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $7eedcf6473a55f44$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $7eedcf6473a55f44$var$getUrlFromResource(url),
            method: $7eedcf6473a55f44$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $7eedcf6473a55f44$var$getUrlFromResource(arg),
        method: $7eedcf6473a55f44$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $7eedcf6473a55f44$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $86GZW.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

});
parcelRegister("iUuih", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", function () { return $dc44f4ac36be6f74$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $dc44f4ac36be6f74$export$c82d238e23c40b21; });

var $e6nMd = parcelRequire("e6nMd");

var $9sRth = parcelRequire("9sRth");

var $9ishN = parcelRequire("9ishN");
const $dc44f4ac36be6f74$var$WINDOW = (0, $9ishN.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $dc44f4ac36be6f74$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $dc44f4ac36be6f74$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $dc44f4ac36be6f74$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $dc44f4ac36be6f74$export$67fc34576016d6ec() {
    return 'history' in $dc44f4ac36be6f74$var$WINDOW && !!$dc44f4ac36be6f74$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $dc44f4ac36be6f74$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $dc44f4ac36be6f74$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $dc44f4ac36be6f74$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $dc44f4ac36be6f74$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$dc44f4ac36be6f74$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($dc44f4ac36be6f74$export$d5f608b368e73f38($dc44f4ac36be6f74$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $dc44f4ac36be6f74$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $dc44f4ac36be6f74$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $e6nMd.DEBUG_BUILD) && (0, $9sRth.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $dc44f4ac36be6f74$export$531055a6c684a70a() {
    return 'ReportingObserver' in $dc44f4ac36be6f74$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $dc44f4ac36be6f74$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$dc44f4ac36be6f74$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("1c840", function(module, exports) {
$parcel$export(module.exports, "getTraceData", function () { return $0ded2aae0c035aca$export$dec8f001b9d982cb; });

var $eM6ET = parcelRequire("eM6ET");

var $5TFFW = parcelRequire("5TFFW");

var $i7nxO = parcelRequire("i7nxO");

var $1jDl2 = parcelRequire("1jDl2");



var $9sRth = parcelRequire("9sRth");


var $8j0KV = parcelRequire("8j0KV");


var $64wec = parcelRequire("64wec");

var $6Cwl7 = parcelRequire("6Cwl7");

var $j8ubf = parcelRequire("j8ubf");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $0ded2aae0c035aca$export$dec8f001b9d982cb(options = {}) {
    const client = (0, $i7nxO.getClient)();
    if (!(0, $1jDl2.isEnabled)() || !client) return {};
    const carrier = (0, $5TFFW.getMainCarrier)();
    const acs = (0, $eM6ET.getAsyncContextStrategy)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = (0, $i7nxO.getCurrentScope)();
    const span = options.span || (0, $8j0KV.getActiveSpan)();
    const sentryTrace = span ? (0, $8j0KV.spanToTraceHeader)(span) : $0ded2aae0c035aca$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $64wec.getDynamicSamplingContextFromSpan)(span) : (0, $64wec.getDynamicSamplingContextFromScope)(client, scope);
    const baggage = (0, $j8ubf.dynamicSamplingContextToSentryBaggageHeader)(dsc);
    const isValidSentryTraceHeader = (0, $6Cwl7.TRACEPARENT_REGEXP).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $9sRth.logger).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    return {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $0ded2aae0c035aca$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $6Cwl7.generateSentryTraceHeader)(traceId, propagationSpanId, sampled);
}

});

parcelRegister("NdIGg", function(module, exports) {
$parcel$export(module.exports, "instrumentFetchRequest", function () { return $093f3827e08b7fc1$export$6d73c62358c655be; });

var $i7nxO = parcelRequire("i7nxO");

var $dhhBD = parcelRequire("dhhBD");


var $86GZW = parcelRequire("86GZW");




var $isIB5 = parcelRequire("isIB5");

var $8j0KV = parcelRequire("8j0KV");


var $j8ubf = parcelRequire("j8ubf");

var $ls7oW = parcelRequire("ls7oW");

var $lkPDN = parcelRequire("lkPDN");

var $1Yn6D = parcelRequire("1Yn6D");

var $1c840 = parcelRequire("1c840");

var $3m1OO = parcelRequire("3m1OO");
/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $093f3827e08b7fc1$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, $isIB5.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $093f3827e08b7fc1$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hasParent = !!(0, $8j0KV.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $1Yn6D.startInactiveSpan)($093f3827e08b7fc1$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $ls7oW.SentryNonRecordingSpan)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $093f3827e08b7fc1$var$_addTracingHeadersToFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $isIB5.hasSpansEnabled)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    const client = (0, $i7nxO.getClient)();
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit('beforeOutgoingRequestSpan', span, fetchHint);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 */ function $093f3827e08b7fc1$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $1c840.getTraceData)({
        span: span
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const headers = fetchOptionsObj.headers || ((0, $86GZW.isRequest)(request) ? request.headers : undefined);
    if (!headers) return {
        ...traceHeaders
    };
    else if ($093f3827e08b7fc1$var$isHeaders(headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.set('sentry-trace', sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (prevBaggageHeader) {
                const prevHeaderStrippedFromSentryBaggage = $093f3827e08b7fc1$var$stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
                newHeaders.set('baggage', // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
                // otherwise just set the sentry baggage header
                prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${baggage}` : baggage);
            } else newHeaders.set('baggage', baggage);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers// Remove any existing sentry-trace headers
            .filter((header)=>{
                return !(Array.isArray(header) && header[0] === 'sentry-trace');
            })// Get rid of previous sentry baggage values in baggage header
            .map((header)=>{
                if (Array.isArray(header) && header[0] === 'baggage' && typeof header[1] === 'string') {
                    const [headerName, headerValue, ...rest] = header;
                    return [
                        headerName,
                        $093f3827e08b7fc1$var$stripBaggageHeaderOfSentryBaggageValues(headerValue),
                        ...rest
                    ];
                } else return header;
            }),
            // Attach the new sentry-trace header
            [
                'sentry-trace',
                sentryTrace
            ]
        ];
        if (baggage) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        let newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders = existingBaggageHeader.map((headerItem)=>typeof headerItem === 'string' ? $093f3827e08b7fc1$var$stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter((headerItem)=>headerItem === '');
        else if (existingBaggageHeader) newBaggageHeaders.push($093f3827e08b7fc1$var$stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
        if (baggage) newBaggageHeaders.push(baggage);
        return {
            ...headers,
            'sentry-trace': sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $093f3827e08b7fc1$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $lkPDN.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $lkPDN.SPAN_STATUS_ERROR),
        message: 'internal_error'
    });
    span.end();
}
function $093f3827e08b7fc1$var$stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',')// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .filter((baggageEntry)=>!baggageEntry.split('=')[0].startsWith((0, $j8ubf.SENTRY_BAGGAGE_KEY_PREFIX))).join(',');
}
function $093f3827e08b7fc1$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, $86GZW.isInstanceOf)(headers, Headers);
}
function $093f3827e08b7fc1$var$getSpanStartOptions(url, method, spanOrigin) {
    const parsedUrl = (0, $3m1OO.parseStringToURLObject)(url);
    return {
        name: parsedUrl ? `${method} ${(0, $3m1OO.getSanitizedUrlStringFromUrlObject)(parsedUrl)}` : method,
        attributes: $093f3827e08b7fc1$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $093f3827e08b7fc1$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: url,
        type: 'fetch',
        'http.method': method,
        [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $dhhBD.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'http.client'
    };
    if (parsedUrl) {
        if (!(0, $3m1OO.isURLObjectRelative)(parsedUrl)) {
            attributes['http.url'] = parsedUrl.href;
            attributes['server.address'] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes['http.query'] = parsedUrl.search;
        if (parsedUrl.hash) attributes['http.fragment'] = parsedUrl.hash;
    }
    return attributes;
}

});
parcelRegister("3m1OO", function(module, exports) {
$parcel$export(module.exports, "isURLObjectRelative", function () { return $2714d64efa35c752$export$e258e13805402ba7; });
$parcel$export(module.exports, "parseStringToURLObject", function () { return $2714d64efa35c752$export$2004d912a9ead694; });
$parcel$export(module.exports, "getSanitizedUrlStringFromUrlObject", function () { return $2714d64efa35c752$export$5339fcdc8e2a427c; });
$parcel$export(module.exports, "parseUrl", function () { return $2714d64efa35c752$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "stripUrlQueryAndFragment", function () { return $2714d64efa35c752$export$ce084c78234bd35; });
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $2714d64efa35c752$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $2714d64efa35c752$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $2714d64efa35c752$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.startsWith('/');
    const base = urlBase ?? (isRelative ? $2714d64efa35c752$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2714d64efa35c752$export$5339fcdc8e2a427c(url) {
    if ($2714d64efa35c752$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2714d64efa35c752$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2714d64efa35c752$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2714d64efa35c752$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});


parcelRegister("hPTFb", function(module, exports) {
$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $cfc260a9ec56d813$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $cfc260a9ec56d813$export$26ace48dd54c9aea; });

var $l9iyH = parcelRequire("l9iyH");
var $6O5dZ = parcelRequire("6O5dZ");
var $dCjy6 = parcelRequire("dCjy6");

var $j6z6N = parcelRequire("j6z6N");
const $cfc260a9ec56d813$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cfc260a9ec56d813$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $l9iyH.addHandler)(type, handler);
    (0, $l9iyH.maybeInstrument)(type, $cfc260a9ec56d813$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $cfc260a9ec56d813$export$c67d533bf77cbf54() {
    if (!(0, $j6z6N.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $dCjy6.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $6O5dZ.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $cfc260a9ec56d813$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$cfc260a9ec56d813$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$cfc260a9ec56d813$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $dCjy6.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $l9iyH.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$cfc260a9ec56d813$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $6O5dZ.isString)(header) && (0, $6O5dZ.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$cfc260a9ec56d813$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $dCjy6.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $l9iyH.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $cfc260a9ec56d813$var$parseXhrUrlArg(url) {
    if ((0, $6O5dZ.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}

});



parcelRegister("jSg3R", function(module, exports) {
$parcel$export(module.exports, "defaultStackParser", function () { return $e77f84e0db33b754$export$2b2b997d81bf3907; });

var $eE5Vk = parcelRequire("eE5Vk");
const $e77f84e0db33b754$var$OPERA10_PRIORITY = 10;
const $e77f84e0db33b754$var$OPERA11_PRIORITY = 20;
const $e77f84e0db33b754$var$CHROME_PRIORITY = 30;
const $e77f84e0db33b754$var$WINJS_PRIORITY = 40;
const $e77f84e0db33b754$var$GECKO_PRIORITY = 50;
function $e77f84e0db33b754$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $eE5Vk.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e77f84e0db33b754$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e77f84e0db33b754$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e77f84e0db33b754$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e77f84e0db33b754$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e77f84e0db33b754$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e77f84e0db33b754$var$createFrame(filename, (0, $eE5Vk.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $e77f84e0db33b754$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e77f84e0db33b754$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e77f84e0db33b754$var$extractSafariExtensionDetails(parts[1] || (0, $eE5Vk.UNKNOWN_FUNCTION), parts[2]);
        return $e77f84e0db33b754$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e77f84e0db33b754$export$263a749fff749872 = [
    $e77f84e0db33b754$var$CHROME_PRIORITY,
    $e77f84e0db33b754$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e77f84e0db33b754$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e77f84e0db33b754$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e77f84e0db33b754$var$gecko = (line)=>{
    const parts = $e77f84e0db33b754$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e77f84e0db33b754$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $eE5Vk.UNKNOWN_FUNCTION);
        [func, filename] = $e77f84e0db33b754$var$extractSafariExtensionDetails(func, filename);
        return $e77f84e0db33b754$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e77f84e0db33b754$export$cdba47a5dd2804d = [
    $e77f84e0db33b754$var$GECKO_PRIORITY,
    $e77f84e0db33b754$var$gecko
];
const $e77f84e0db33b754$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e77f84e0db33b754$var$winjs = (line)=>{
    const parts = $e77f84e0db33b754$var$winjsRegex.exec(line);
    return parts ? $e77f84e0db33b754$var$createFrame(parts[2], parts[1] || (0, $eE5Vk.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e77f84e0db33b754$export$179460296da408e8 = [
    $e77f84e0db33b754$var$WINJS_PRIORITY,
    $e77f84e0db33b754$var$winjs
];
const $e77f84e0db33b754$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e77f84e0db33b754$var$opera10 = (line)=>{
    const parts = $e77f84e0db33b754$var$opera10Regex.exec(line);
    return parts ? $e77f84e0db33b754$var$createFrame(parts[2], parts[3] || (0, $eE5Vk.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $e77f84e0db33b754$export$f892b52c880ffc7a = [
    $e77f84e0db33b754$var$OPERA10_PRIORITY,
    $e77f84e0db33b754$var$opera10
];
const $e77f84e0db33b754$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e77f84e0db33b754$var$opera11 = (line)=>{
    const parts = $e77f84e0db33b754$var$opera11Regex.exec(line);
    return parts ? $e77f84e0db33b754$var$createFrame(parts[5], parts[3] || parts[4] || (0, $eE5Vk.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $e77f84e0db33b754$export$af11af13f09fb0dc = [
    $e77f84e0db33b754$var$OPERA11_PRIORITY,
    $e77f84e0db33b754$var$opera11
];
const $e77f84e0db33b754$export$7197c0fe6554c079 = [
    $e77f84e0db33b754$export$263a749fff749872,
    $e77f84e0db33b754$export$cdba47a5dd2804d
];
const $e77f84e0db33b754$export$2b2b997d81bf3907 = (0, $eE5Vk.createStackParser)(...$e77f84e0db33b754$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e77f84e0db33b754$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $eE5Vk.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("3sWBL", function(module, exports) {
$parcel$export(module.exports, "getDefaultIntegrations", function () { return $286172fc55ab6a9c$export$5783b2920b1d62b9; });
$parcel$export(module.exports, "init", function () { return $286172fc55ab6a9c$export$2cd8252107eb640b; });
$parcel$export(module.exports, "showReportDialog", function () { return $286172fc55ab6a9c$export$3a8fd680da42627b; });

var $9sRth = parcelRequire("9sRth");
var $02aZK = parcelRequire("02aZK");
var $600L8 = parcelRequire("600L8");
var $i7nxO = parcelRequire("i7nxO");
var $9Gtbp = parcelRequire("9Gtbp");
var $7skVW = parcelRequire("7skVW");
var $4taOC = parcelRequire("4taOC");
var $bnZAw = parcelRequire("bnZAw");
var $3jCF2 = parcelRequire("3jCF2");
var $1jDl2 = parcelRequire("1jDl2");
var $eE5Vk = parcelRequire("eE5Vk");
var $iUuih = parcelRequire("iUuih");

var $5IEWR = parcelRequire("5IEWR");

var $61ZAj = parcelRequire("61ZAj");

var $aT7cw = parcelRequire("aT7cw");

var $9jQzz = parcelRequire("9jQzz");

var $92Ens = parcelRequire("92Ens");

var $6qZ2K = parcelRequire("6qZ2K");

var $ch7O6 = parcelRequire("ch7O6");

var $eBixt = parcelRequire("eBixt");

var $3IJL3 = parcelRequire("3IJL3");

var $jSg3R = parcelRequire("jSg3R");

var $leG8s = parcelRequire("leG8s");
/** Get the default integrations for the browser SDK. */ function $286172fc55ab6a9c$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $bnZAw.inboundFiltersIntegration)(),
        (0, $600L8.functionToStringIntegration)(),
        (0, $92Ens.browserApiErrorsIntegration)(),
        (0, $9jQzz.breadcrumbsIntegration)(),
        (0, $ch7O6.globalHandlersIntegration)(),
        (0, $3IJL3.linkedErrorsIntegration)(),
        (0, $02aZK.dedupeIntegration)(),
        (0, $eBixt.httpContextIntegration)(),
        (0, $6qZ2K.browserSessionIntegration)()
    ];
}
/** Exported only for tests. */ function $286172fc55ab6a9c$export$4e107b20a7f977(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $286172fc55ab6a9c$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $aT7cw.WINDOW).SENTRY_RELEASE?.id,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...$286172fc55ab6a9c$var$dropTopLevelUndefinedKeys(optionsArg)
    };
}
/**
 * In contrast to the regular `dropUndefinedKeys` method,
 * this one does not deep-drop keys, but only on the top level.
 */ function $286172fc55ab6a9c$var$dropTopLevelUndefinedKeys(obj) {
    const mutatetedObj = {};
    for (const k of Object.getOwnPropertyNames(obj)){
        const key = k;
        if (obj[key] !== undefined) mutatetedObj[key] = obj[key];
    }
    return mutatetedObj;
}
function $286172fc55ab6a9c$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $aT7cw.WINDOW).window !== 'undefined' && (0, $aT7cw.WINDOW);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject?.runtime?.id;
    const href = (0, $7skVW.getLocationHref)() || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $aT7cw.WINDOW) === (0, $aT7cw.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $286172fc55ab6a9c$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $286172fc55ab6a9c$export$4e107b20a7f977(browserOptions);
    if (!options.skipBrowserExtensionCheck && $286172fc55ab6a9c$var$shouldShowBrowserExtensionError()) {
        if (0, $61ZAj.DEBUG_BUILD) (0, $9sRth.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if ((0, $61ZAj.DEBUG_BUILD) && !(0, $iUuih.supportsFetch)()) (0, $9sRth.logger).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    const clientOptions = {
        ...options,
        stackParser: (0, $eE5Vk.stackParserFromStackParserOptions)(options.stackParser || (0, $jSg3R.defaultStackParser)),
        integrations: (0, $9Gtbp.getIntegrationsToSetup)(options),
        transport: options.transport || (0, $leG8s.makeFetchTransport)
    };
    return (0, $3jCF2.initAndBind)((0, $5IEWR.BrowserClient), clientOptions);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $286172fc55ab6a9c$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $aT7cw.WINDOW).document) {
        (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $i7nxO.getCurrentScope)();
    const client = scope.getClient();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $1jDl2.lastEventId)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $aT7cw.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $4taOC.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $aT7cw.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $aT7cw.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $aT7cw.WINDOW).document.head || (0, $aT7cw.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $286172fc55ab6a9c$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $286172fc55ab6a9c$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("02aZK", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", function () { return $0068b7628ee6c761$export$6d39aa44cd0c7567; });

var $4YMns = parcelRequire("4YMns");

var $9Gtbp = parcelRequire("9Gtbp");

var $9sRth = parcelRequire("9sRth");

var $eE5Vk = parcelRequire("eE5Vk");
const $0068b7628ee6c761$var$INTEGRATION_NAME = 'Dedupe';
const $0068b7628ee6c761$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $0068b7628ee6c761$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($0068b7628ee6c761$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $0068b7628ee6c761$export$6d39aa44cd0c7567 = (0, $9Gtbp.defineIntegration)($0068b7628ee6c761$var$_dedupeIntegration);
/** only exported for tests. */ function $0068b7628ee6c761$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($0068b7628ee6c761$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($0068b7628ee6c761$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $0068b7628ee6c761$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$0068b7628ee6c761$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$0068b7628ee6c761$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $0068b7628ee6c761$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $0068b7628ee6c761$var$_getExceptionFromEvent(previousEvent);
    const currentException = $0068b7628ee6c761$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$0068b7628ee6c761$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$0068b7628ee6c761$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $0068b7628ee6c761$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $eE5Vk.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $eE5Vk.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $0068b7628ee6c761$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $0068b7628ee6c761$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}

});

parcelRegister("600L8", function(module, exports) {
$parcel$export(module.exports, "functionToStringIntegration", function () { return $45e354ed1cafb7a9$export$7918117e9202e4fb; });

var $i7nxO = parcelRequire("i7nxO");

var $9Gtbp = parcelRequire("9Gtbp");

var $3eJmu = parcelRequire("3eJmu");
let $45e354ed1cafb7a9$var$originalFunctionToString;
const $45e354ed1cafb7a9$var$INTEGRATION_NAME = 'FunctionToString';
const $45e354ed1cafb7a9$var$SETUP_CLIENTS = new WeakMap();
const $45e354ed1cafb7a9$var$_functionToStringIntegration = ()=>{
    return {
        name: $45e354ed1cafb7a9$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $45e354ed1cafb7a9$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $3eJmu.getOriginalFunction)(this);
                    const context = $45e354ed1cafb7a9$var$SETUP_CLIENTS.has((0, $i7nxO.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $45e354ed1cafb7a9$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $45e354ed1cafb7a9$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $45e354ed1cafb7a9$export$7918117e9202e4fb = (0, $9Gtbp.defineIntegration)($45e354ed1cafb7a9$var$_functionToStringIntegration);

});

parcelRegister("bnZAw", function(module, exports) {
$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $84a19dcd3d6acbe5$export$cb3c5c2ceb9818ba; });

var $4YMns = parcelRequire("4YMns");

var $9Gtbp = parcelRequire("9Gtbp");

var $85YNJ = parcelRequire("85YNJ");

var $9sRth = parcelRequire("9sRth");

var $hqa9f = parcelRequire("hqa9f");

var $gUnvu = parcelRequire("gUnvu");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $84a19dcd3d6acbe5$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $84a19dcd3d6acbe5$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $84a19dcd3d6acbe5$export$9a84f518c163c552 = (0, $9Gtbp.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: $84a19dcd3d6acbe5$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $84a19dcd3d6acbe5$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $84a19dcd3d6acbe5$var$_mergeOptions(options, clientOptions);
            }
            return $84a19dcd3d6acbe5$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $84a19dcd3d6acbe5$export$cb3c5c2ceb9818ba = (0, $9Gtbp.defineIntegration)((options = {})=>{
    return {
        ...$84a19dcd3d6acbe5$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $84a19dcd3d6acbe5$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $84a19dcd3d6acbe5$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $84a19dcd3d6acbe5$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($84a19dcd3d6acbe5$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $hqa9f.getEventDescription)(event)}`);
            return true;
        }
        if ($84a19dcd3d6acbe5$var$_isUselessError(event)) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $hqa9f.getEventDescription)(event)}`);
            return true;
        }
        if ($84a19dcd3d6acbe5$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $hqa9f.getEventDescription)(event)}.\nUrl: ${$84a19dcd3d6acbe5$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$84a19dcd3d6acbe5$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $hqa9f.getEventDescription)(event)}.\nUrl: ${$84a19dcd3d6acbe5$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($84a19dcd3d6acbe5$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $hqa9f.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $84a19dcd3d6acbe5$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $85YNJ.getPossibleEventMessages)(event).some((message)=>(0, $gUnvu.stringMatchesSomePattern)(message, ignoreErrors));
}
function $84a19dcd3d6acbe5$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $gUnvu.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $84a19dcd3d6acbe5$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $84a19dcd3d6acbe5$var$_getEventFilterUrl(event);
    return !url ? false : (0, $gUnvu.stringMatchesSomePattern)(url, denyUrls);
}
function $84a19dcd3d6acbe5$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $84a19dcd3d6acbe5$var$_getEventFilterUrl(event);
    return !url ? true : (0, $gUnvu.stringMatchesSomePattern)(url, allowUrls);
}
function $84a19dcd3d6acbe5$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $84a19dcd3d6acbe5$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $84a19dcd3d6acbe5$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).error(`Cannot extract url for event ${(0, $hqa9f.getEventDescription)(event)}`);
        return null;
    }
}
function $84a19dcd3d6acbe5$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}

});

parcelRegister("3jCF2", function(module, exports) {
$parcel$export(module.exports, "initAndBind", function () { return $26a122b72dc745d8$export$5333c3f1c58d9bc1; });

var $i7nxO = parcelRequire("i7nxO");

var $4YMns = parcelRequire("4YMns");

var $9sRth = parcelRequire("9sRth");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $26a122b72dc745d8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $4YMns.DEBUG_BUILD) (0, $9sRth.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $9sRth.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $i7nxO.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $26a122b72dc745d8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $26a122b72dc745d8$export$ecb76f41d43c0e43(client) {
    (0, $i7nxO.getCurrentScope)().setClient(client);
}

});

parcelRegister("9jQzz", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $6c8eab4470df05f8$export$c079d904b326663a; });

var $g1HEd = parcelRequire("g1HEd");
var $9AHRw = parcelRequire("9AHRw");
var $aTDFo = parcelRequire("aTDFo");
var $9Gtbp = parcelRequire("9Gtbp");
var $gTESL = parcelRequire("gTESL");
var $i7nxO = parcelRequire("i7nxO");
var $7skVW = parcelRequire("7skVW");
var $hqa9f = parcelRequire("hqa9f");
var $9sRth = parcelRequire("9sRth");
var $3m1OO = parcelRequire("3m1OO");
var $gUnvu = parcelRequire("gUnvu");
var $lQioY = parcelRequire("lQioY");

var $43M99 = parcelRequire("43M99");
var $jVGSg = parcelRequire("jVGSg");
var $hPTFb = parcelRequire("hPTFb");

var $61ZAj = parcelRequire("61ZAj");

var $aT7cw = parcelRequire("aT7cw");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $6c8eab4470df05f8$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $6c8eab4470df05f8$var$INTEGRATION_NAME = 'Breadcrumbs';
const $6c8eab4470df05f8$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $6c8eab4470df05f8$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $9AHRw.addConsoleInstrumentationHandler)($6c8eab4470df05f8$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $43M99.addClickKeypressInstrumentationHandler)($6c8eab4470df05f8$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $hPTFb.addXhrInstrumentationHandler)($6c8eab4470df05f8$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $aTDFo.addFetchInstrumentationHandler)($6c8eab4470df05f8$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $jVGSg.addHistoryInstrumentationHandler)($6c8eab4470df05f8$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $6c8eab4470df05f8$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $6c8eab4470df05f8$export$c079d904b326663a = (0, $9Gtbp.defineIntegration)($6c8eab4470df05f8$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $6c8eab4470df05f8$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $i7nxO.getClient)() !== client) return;
        (0, $g1HEd.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $hqa9f.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $6c8eab4470df05f8$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $i7nxO.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $6c8eab4470df05f8$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$6c8eab4470df05f8$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$6c8eab4470df05f8$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $6c8eab4470df05f8$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $6c8eab4470df05f8$var$_isEvent(event) ? event.target : event;
            target = (0, $7skVW.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $7skVW.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $g1HEd.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $6c8eab4470df05f8$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $i7nxO.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $lQioY.severityLevelFromString)(handlerData.level),
            message: (0, $gUnvu.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $gUnvu.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $g1HEd.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $6c8eab4470df05f8$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $i7nxO.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $hPTFb.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $gTESL.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $g1HEd.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $6c8eab4470df05f8$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $i7nxO.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $g1HEd.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $gTESL.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $g1HEd.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $6c8eab4470df05f8$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $i7nxO.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $3m1OO.parseUrl)((0, $aT7cw.WINDOW).location.href);
        let parsedFrom = from ? (0, $3m1OO.parseUrl)(from) : undefined;
        const parsedTo = (0, $3m1OO.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $g1HEd.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $6c8eab4470df05f8$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("9AHRw", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $6fb97ff8c0c9d58f$export$1d6e0d073f9e6723; });

var $9sRth = parcelRequire("9sRth");

var $3eJmu = parcelRequire("3eJmu");

var $9ishN = parcelRequire("9ishN");

var $dkXNk = parcelRequire("dkXNk");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6fb97ff8c0c9d58f$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $dkXNk.addHandler)(type, handler);
    (0, $dkXNk.maybeInstrument)(type, $6fb97ff8c0c9d58f$var$instrumentConsole);
}
function $6fb97ff8c0c9d58f$var$instrumentConsole() {
    if (!('console' in (0, $9ishN.GLOBAL_OBJ))) return;
    (0, $9sRth.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $9ishN.GLOBAL_OBJ).console)) return;
        (0, $3eJmu.fill)((0, $9ishN.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $9sRth.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $dkXNk.triggerHandlers)('console', handlerData);
                const log = (0, $9sRth.originalConsoleMethods)[level];
                log?.apply((0, $9ishN.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("gTESL", function(module, exports) {
$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", function () { return $c4d17ec4bb67a1f9$export$b8cfcc4175694bcc; });
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $c4d17ec4bb67a1f9$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

});

parcelRegister("lQioY", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", function () { return $fe6cba84f08a7a18$export$d771ef054122c30a; });
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $fe6cba84f08a7a18$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

});

parcelRegister("43M99", function(module, exports) {
$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $2f4cca20c44a69a8$export$5aeffd3db2cf9df7; });

var $l9iyH = parcelRequire("l9iyH");
var $j7rez = parcelRequire("j7rez");
var $hoRpc = parcelRequire("hoRpc");

var $j6z6N = parcelRequire("j6z6N");
const $2f4cca20c44a69a8$var$DEBOUNCE_DURATION = 1000;
let $2f4cca20c44a69a8$var$debounceTimerID;
let $2f4cca20c44a69a8$var$lastCapturedEventType;
let $2f4cca20c44a69a8$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2f4cca20c44a69a8$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $l9iyH.addHandler)(type, handler);
    (0, $l9iyH.maybeInstrument)(type, $2f4cca20c44a69a8$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $2f4cca20c44a69a8$export$3014bbf0af0e1d4a() {
    if (!(0, $j6z6N.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $l9iyH.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $2f4cca20c44a69a8$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $j6z6N.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $j6z6N.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $j6z6N.WINDOW);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $j7rez.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $2f4cca20c44a69a8$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $j7rez.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $2f4cca20c44a69a8$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $2f4cca20c44a69a8$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $2f4cca20c44a69a8$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $2f4cca20c44a69a8$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $2f4cca20c44a69a8$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $2f4cca20c44a69a8$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($2f4cca20c44a69a8$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $j7rez.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $j7rez.addNonEnumerableProperty)(target, '_sentryId', (0, $hoRpc.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$2f4cca20c44a69a8$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $2f4cca20c44a69a8$var$lastCapturedEventType = event.type;
            $2f4cca20c44a69a8$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($2f4cca20c44a69a8$var$debounceTimerID);
        $2f4cca20c44a69a8$var$debounceTimerID = (0, $j6z6N.WINDOW).setTimeout(()=>{
            $2f4cca20c44a69a8$var$lastCapturedEventTargetId = undefined;
            $2f4cca20c44a69a8$var$lastCapturedEventType = undefined;
        }, $2f4cca20c44a69a8$var$DEBOUNCE_DURATION);
    };
}
function $2f4cca20c44a69a8$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});


parcelRegister("92Ens", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $69539f0b7b901732$export$59bfe9f1c76150e; });

var $9Gtbp = parcelRequire("9Gtbp");
var $3eJmu = parcelRequire("3eJmu");
var $eE5Vk = parcelRequire("eE5Vk");

var $aT7cw = parcelRequire("aT7cw");
const $69539f0b7b901732$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $69539f0b7b901732$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $69539f0b7b901732$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $69539f0b7b901732$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $3eJmu.fill)((0, $aT7cw.WINDOW), 'setTimeout', $69539f0b7b901732$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $3eJmu.fill)((0, $aT7cw.WINDOW), 'setInterval', $69539f0b7b901732$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $3eJmu.fill)((0, $aT7cw.WINDOW), 'requestAnimationFrame', $69539f0b7b901732$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $aT7cw.WINDOW)) (0, $3eJmu.fill)(XMLHttpRequest.prototype, 'send', $69539f0b7b901732$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $69539f0b7b901732$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($69539f0b7b901732$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $69539f0b7b901732$export$59bfe9f1c76150e = (0, $9Gtbp.defineIntegration)($69539f0b7b901732$var$_browserApiErrorsIntegration);
function $69539f0b7b901732$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $aT7cw.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $eE5Vk.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $69539f0b7b901732$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $aT7cw.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $eE5Vk.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $69539f0b7b901732$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $3eJmu.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $eE5Vk.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $3eJmu.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $eE5Vk.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $aT7cw.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $69539f0b7b901732$var$_wrapEventTarget(target) {
    const globalObject = (0, $aT7cw.WINDOW);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $3eJmu.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($69539f0b7b901732$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $aT7cw.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $eE5Vk.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $aT7cw.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $eE5Vk.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $3eJmu.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $69539f0b7b901732$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}

});

parcelRegister("6qZ2K", function(module, exports) {
$parcel$export(module.exports, "browserSessionIntegration", function () { return $4af485b74a730c10$export$1baa7880e357371c; });

var $1jDl2 = parcelRequire("1jDl2");
var $9Gtbp = parcelRequire("9Gtbp");
var $9sRth = parcelRequire("9sRth");

var $jVGSg = parcelRequire("jVGSg");

var $61ZAj = parcelRequire("61ZAj");

var $aT7cw = parcelRequire("aT7cw");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $4af485b74a730c10$export$1baa7880e357371c = (0, $9Gtbp.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $aT7cw.WINDOW).document === 'undefined') {
                (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $1jDl2.startSession)({
                ignoreDuration: true
            });
            (0, $1jDl2.captureSession)();
            // We want to create a session for every navigation as well
            (0, $jVGSg.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $1jDl2.startSession)({
                        ignoreDuration: true
                    });
                    (0, $1jDl2.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("ch7O6", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", function () { return $8efd20e95990f9e1$export$66acc70e8cf2b71a; });

var $eYmRj = parcelRequire("eYmRj");
var $fpjgf = parcelRequire("fpjgf");
var $1jDl2 = parcelRequire("1jDl2");
var $9Gtbp = parcelRequire("9Gtbp");
var $i7nxO = parcelRequire("i7nxO");
var $7skVW = parcelRequire("7skVW");
var $86GZW = parcelRequire("86GZW");
var $9sRth = parcelRequire("9sRth");
var $eE5Vk = parcelRequire("eE5Vk");

var $61ZAj = parcelRequire("61ZAj");

var $44Rfj = parcelRequire("44Rfj");

var $aT7cw = parcelRequire("aT7cw");
const $8efd20e95990f9e1$var$INTEGRATION_NAME = 'GlobalHandlers';
const $8efd20e95990f9e1$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $8efd20e95990f9e1$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $8efd20e95990f9e1$var$_installGlobalOnErrorHandler(client);
                $8efd20e95990f9e1$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $8efd20e95990f9e1$var$_installGlobalOnUnhandledRejectionHandler(client);
                $8efd20e95990f9e1$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $8efd20e95990f9e1$export$66acc70e8cf2b71a = (0, $9Gtbp.defineIntegration)($8efd20e95990f9e1$var$_globalHandlersIntegration);
function $8efd20e95990f9e1$var$_installGlobalOnErrorHandler(client) {
    (0, $eYmRj.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $8efd20e95990f9e1$var$getOptions();
        if ((0, $i7nxO.getClient)() !== client || (0, $aT7cw.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $8efd20e95990f9e1$var$_enhanceEventWithInitialFrame((0, $44Rfj.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $1jDl2.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $8efd20e95990f9e1$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $fpjgf.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $8efd20e95990f9e1$var$getOptions();
        if ((0, $i7nxO.getClient)() !== client || (0, $aT7cw.shouldIgnoreOnError)()) return;
        const error = $8efd20e95990f9e1$var$_getUnhandledRejectionError(e);
        const event = (0, $86GZW.isPrimitive)(error) ? $8efd20e95990f9e1$var$_eventFromRejectionWithPrimitive(error) : (0, $44Rfj.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $1jDl2.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $8efd20e95990f9e1$var$_getUnhandledRejectionError(error) {
    if ((0, $86GZW.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $8efd20e95990f9e1$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $8efd20e95990f9e1$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $86GZW.isString)(url) && url.length > 0 ? url : (0, $7skVW.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $eE5Vk.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $8efd20e95990f9e1$var$globalHandlerLog(type) {
    (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).log(`Global Handler attached: ${type}`);
}
function $8efd20e95990f9e1$var$getOptions() {
    const client = (0, $i7nxO.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});

parcelRegister("eBixt", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", function () { return $aa12e6d38a5de2d9$export$1378794447170364; });

var $9Gtbp = parcelRequire("9Gtbp");
var $7skVW = parcelRequire("7skVW");

var $aT7cw = parcelRequire("aT7cw");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $aa12e6d38a5de2d9$export$1378794447170364 = (0, $9Gtbp.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $aT7cw.WINDOW).navigator && !(0, $aT7cw.WINDOW).location && !(0, $aT7cw.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request?.url || (0, $7skVW.getLocationHref)();
            const { referrer: referrer } = (0, $aT7cw.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $aT7cw.WINDOW).navigator || {};
            const headers = {
                ...event.request?.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});

});

parcelRegister("3IJL3", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $2b58f9b6bf176d78$export$ebabb00eb7f3a395; });

var $fUIL2 = parcelRequire("fUIL2");
var $9Gtbp = parcelRequire("9Gtbp");

var $44Rfj = parcelRequire("44Rfj");
const $2b58f9b6bf176d78$var$DEFAULT_KEY = 'cause';
const $2b58f9b6bf176d78$var$DEFAULT_LIMIT = 5;
const $2b58f9b6bf176d78$var$INTEGRATION_NAME = 'LinkedErrors';
const $2b58f9b6bf176d78$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $2b58f9b6bf176d78$var$DEFAULT_LIMIT;
    const key = options.key || $2b58f9b6bf176d78$var$DEFAULT_KEY;
    return {
        name: $2b58f9b6bf176d78$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $fUIL2.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $44Rfj.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $2b58f9b6bf176d78$export$ebabb00eb7f3a395 = (0, $9Gtbp.defineIntegration)($2b58f9b6bf176d78$var$_linkedErrorsIntegration);

});
parcelRegister("fUIL2", function(module, exports) {
$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $b95ecdeced4c196d$export$b91c38ed7d8ae9b2; });

var $86GZW = parcelRequire("86GZW");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $b95ecdeced4c196d$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $86GZW.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $b95ecdeced4c196d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $b95ecdeced4c196d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $86GZW.isInstanceOf)(error[key], Error)) {
        $b95ecdeced4c196d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $b95ecdeced4c196d$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $b95ecdeced4c196d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $86GZW.isInstanceOf)(childError, Error)) {
            $b95ecdeced4c196d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $b95ecdeced4c196d$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $b95ecdeced4c196d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $b95ecdeced4c196d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $b95ecdeced4c196d$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}

});


parcelRegister("leG8s", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", function () { return $f75b96fc02199679$export$b2311068c46d7cc8; });

var $iJWtX = parcelRequire("iJWtX");
var $deiyZ = parcelRequire("deiyZ");

var $aBwXD = parcelRequire("aBwXD");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $f75b96fc02199679$export$b2311068c46d7cc8(options, nativeFetch = (0, $aBwXD.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $aBwXD.clearCachedImplementation)('fetch');
            return (0, $deiyZ.rejectedSyncPromise)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $aBwXD.clearCachedImplementation)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $deiyZ.rejectedSyncPromise)(e);
        }
    }
    return (0, $iJWtX.createTransport)(options, makeRequest);
}

});
parcelRegister("iJWtX", function(module, exports) {
$parcel$export(module.exports, "createTransport", function () { return $da49cb4ccd1fc450$export$d09f50d9ab7f7b69; });

var $4YMns = parcelRequire("4YMns");

var $bOdRo = parcelRequire("bOdRo");

var $9sRth = parcelRequire("9sRth");

var $3gIYu = parcelRequire("3gIYu");

var $c62Zl = parcelRequire("c62Zl");

var $deiyZ = parcelRequire("deiyZ");
const $da49cb4ccd1fc450$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $da49cb4ccd1fc450$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $3gIYu.makePromiseBuffer)(options.bufferSize || $da49cb4ccd1fc450$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $bOdRo.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $bOdRo.envelopeItemTypeToDataCategory)(type);
            if ((0, $c62Zl.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $deiyZ.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $bOdRo.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $bOdRo.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $bOdRo.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $bOdRo.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $c62Zl.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $3gIYu.SENTRY_BUFFER_FULL_ERROR)) {
                (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $deiyZ.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("3gIYu", function(module, exports) {
$parcel$export(module.exports, "SENTRY_BUFFER_FULL_ERROR", function () { return $2615c0c3cbc09e09$export$c8667f1887a128dc; });
$parcel$export(module.exports, "makePromiseBuffer", function () { return $2615c0c3cbc09e09$export$85a4f67f852183e6; });

var $deiyZ = parcelRequire("deiyZ");
const $2615c0c3cbc09e09$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $2615c0c3cbc09e09$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $deiyZ.rejectedSyncPromise)($2615c0c3cbc09e09$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $deiyZ.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $deiyZ.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("c62Zl", function(module, exports) {
$parcel$export(module.exports, "isRateLimited", function () { return $8ce85d077016f766$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $8ce85d077016f766$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $8ce85d077016f766$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $8ce85d077016f766$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $8ce85d077016f766$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $8ce85d077016f766$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $8ce85d077016f766$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $8ce85d077016f766$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $8ce85d077016f766$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $8ce85d077016f766$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});


parcelRegister("aBwXD", function(module, exports) {
$parcel$export(module.exports, "getNativeImplementation", function () { return $7b86ed686bfac044$export$e464f4a514ac28a8; });
$parcel$export(module.exports, "clearCachedImplementation", function () { return $7b86ed686bfac044$export$8aa36702e8c8978; });

var $4UAQu = parcelRequire("4UAQu");
var $kFCRa = parcelRequire("kFCRa");

var $7vzTY = parcelRequire("7vzTY");

var $j6z6N = parcelRequire("j6z6N");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $7b86ed686bfac044$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $7b86ed686bfac044$export$e464f4a514ac28a8(name) {
    const cached = $7b86ed686bfac044$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $j6z6N.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $4UAQu.isNativeFunction)(impl)) return $7b86ed686bfac044$var$cachedImplementations[name] = impl.bind((0, $j6z6N.WINDOW));
    const document = (0, $j6z6N.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $7vzTY.DEBUG_BUILD) && (0, $kFCRa.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $7b86ed686bfac044$var$cachedImplementations[name] = impl.bind((0, $j6z6N.WINDOW));
}
/** Clear a cached implementation. */ function $7b86ed686bfac044$export$8aa36702e8c8978(name) {
    $7b86ed686bfac044$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $7b86ed686bfac044$export$e7aa7bc5c1b3cfb3(...rest) {
    return $7b86ed686bfac044$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $7b86ed686bfac044$export$831dc9f2ab0a617b(...rest) {
    return $7b86ed686bfac044$export$e464f4a514ac28a8('setTimeout')(...rest);
}

});



parcelRegister("jcHfc", function(module, exports) {
$parcel$export(module.exports, "httpClientIntegration", function () { return $dfb0aeb58c0fdf98$export$8a3b7aeb379b3907; });

var $hqa9f = parcelRequire("hqa9f");
var $aTDFo = parcelRequire("aTDFo");
var $1jDl2 = parcelRequire("1jDl2");
var $9Gtbp = parcelRequire("9Gtbp");
var $i7nxO = parcelRequire("i7nxO");
var $9ishN = parcelRequire("9ishN");
var $aIGFm = parcelRequire("aIGFm");
var $9sRth = parcelRequire("9sRth");
var $iUuih = parcelRequire("iUuih");

var $hPTFb = parcelRequire("hPTFb");

var $61ZAj = parcelRequire("61ZAj");
const $dfb0aeb58c0fdf98$var$INTEGRATION_NAME = 'HttpClient';
const $dfb0aeb58c0fdf98$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $dfb0aeb58c0fdf98$var$INTEGRATION_NAME,
        setup (client) {
            $dfb0aeb58c0fdf98$var$_wrapFetch(client, _options);
            $dfb0aeb58c0fdf98$var$_wrapXHR(client, _options);
        }
    };
};
/**
 * Create events for failed client side HTTP requests.
 */ const $dfb0aeb58c0fdf98$export$8a3b7aeb379b3907 = (0, $9Gtbp.defineIntegration)($dfb0aeb58c0fdf98$var$_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $dfb0aeb58c0fdf98$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($dfb0aeb58c0fdf98$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $dfb0aeb58c0fdf98$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($dfb0aeb58c0fdf98$var$_shouldSendDefaultPii()) {
            [requestHeaders, requestCookies] = $dfb0aeb58c0fdf98$var$_parseCookieHeaders('Cookie', request);
            [responseHeaders, responseCookies] = $dfb0aeb58c0fdf98$var$_parseCookieHeaders('Set-Cookie', response);
        }
        const event = $dfb0aeb58c0fdf98$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error
        });
        (0, $1jDl2.captureEvent)(event);
    }
}
function $dfb0aeb58c0fdf98$var$_parseCookieHeaders(cookieHeader, obj) {
    const headers = $dfb0aeb58c0fdf98$var$_extractFetchHeaders(obj.headers);
    let cookies;
    try {
        const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
        if (cookieString) cookies = $dfb0aeb58c0fdf98$var$_parseCookieString(cookieString);
    } catch  {
    // ignore it if parsing fails
    }
    return [
        headers,
        cookies
    ];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $dfb0aeb58c0fdf98$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($dfb0aeb58c0fdf98$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($dfb0aeb58c0fdf98$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = $dfb0aeb58c0fdf98$var$_parseCookieString(cookieString);
            } catch  {
            // ignore it if parsing fails
            }
            try {
                responseHeaders = $dfb0aeb58c0fdf98$var$_getXHRResponseHeaders(xhr);
            } catch  {
            // ignore it if parsing fails
            }
            requestHeaders = headers;
        }
        const event = $dfb0aeb58c0fdf98$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error
        });
        (0, $1jDl2.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $dfb0aeb58c0fdf98$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $dfb0aeb58c0fdf98$var$_parseCookieString(cookieString) {
    return cookieString.split('; ').reduce((acc, cookie)=>{
        const [key, value] = cookie.split('=');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $dfb0aeb58c0fdf98$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $dfb0aeb58c0fdf98$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $dfb0aeb58c0fdf98$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $dfb0aeb58c0fdf98$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $dfb0aeb58c0fdf98$var$_wrapFetch(client, options) {
    if (!(0, $iUuih.supportsNativeFetch)()) return;
    (0, $aTDFo.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $i7nxO.getClient)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $dfb0aeb58c0fdf98$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $dfb0aeb58c0fdf98$var$_wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, $9ishN.GLOBAL_OBJ))) return;
    (0, $hPTFb.addXhrInstrumentationHandler)((handlerData)=>{
        if ((0, $i7nxO.getClient)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $hPTFb.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $dfb0aeb58c0fdf98$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $dfb0aeb58c0fdf98$var$_shouldCaptureResponse(options, status, url) {
    return $dfb0aeb58c0fdf98$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $dfb0aeb58c0fdf98$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $aIGFm.isSentryRequestUrl)(url, (0, $i7nxO.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $dfb0aeb58c0fdf98$var$_createEvent(data) {
    const client = (0, $i7nxO.getClient)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined;
    // Remove the first frame from the stack as it's the HttpClient call
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : undefined
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $dfb0aeb58c0fdf98$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $hqa9f.addExceptionMechanism)(event, {
        type: 'http.client',
        handled: false
    });
    return event;
}
function $dfb0aeb58c0fdf98$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $dfb0aeb58c0fdf98$var$_shouldSendDefaultPii() {
    const client = (0, $i7nxO.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}

});
parcelRegister("aIGFm", function(module, exports) {
$parcel$export(module.exports, "isSentryRequestUrl", function () { return $7cdf1c110657645d$export$d92e61f5600202af; });
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $7cdf1c110657645d$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $7cdf1c110657645d$var$checkDsn(url, dsn) || $7cdf1c110657645d$var$checkTunnel(url, tunnel);
}
function $7cdf1c110657645d$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $7cdf1c110657645d$var$removeTrailingSlash(url) === $7cdf1c110657645d$var$removeTrailingSlash(tunnel);
}
function $7cdf1c110657645d$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $7cdf1c110657645d$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}

});



parcelRegister("lr4yY", function(module, exports) {
$parcel$export(module.exports, "mapCookieToHeaders", function () { return $b6e404f101ed94d4$export$2caf3886cd1c5ca7; });

var $yhhhl = parcelRequire("yhhhl");
function $b6e404f101ed94d4$export$659f3e5265115438({ name: name, value: value }) {
    return (0, $yhhhl.serialize)(name, value);
}
function $b6e404f101ed94d4$export$2caf3886cd1c5ca7(cookie) {
    if (cookie) return {
        cookie: $b6e404f101ed94d4$export$659f3e5265115438(cookie)
    };
    else return {};
}

});

parcelRegister("fHaFy", function(module, exports) {
$parcel$export(module.exports, "mapLocalStorageUserMetaToPayload", function () { return $eb66e246824f0de2$export$1179561ba14bdda9; });
$parcel$export(module.exports, "mapLocalStorageTraceIdToPayload", function () { return $eb66e246824f0de2$export$70e5dd9137813f23; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $2gCne = parcelRequire("2gCne");
function $eb66e246824f0de2$export$1179561ba14bdda9() {
    if (!window || !(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10416DisableNonOperationalAnalyticsGateUip)) return {};
    try {
        const atl_first_visit = (0, $2gCne.getLocalStorage)('atl_first_visit', true);
        const userMeta = atl_first_visit ? {
            userMeta: JSON.stringify({
                firstVisitActivationContext: JSON.parse(atl_first_visit)
            })
        } : {};
        return userMeta;
    } catch (error) {
        console.error('Error mapping local storage user meta to payload', error);
        return {};
    }
}
function $eb66e246824f0de2$export$70e5dd9137813f23() {
    if (!window || !(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).voltronMultiTouchAnalytics)) return {};
    try {
        const trace_id = (0, $2gCne.getLocalStorage)('trace_id', true);
        return trace_id && typeof trace_id === 'string' ? {
            'x-wac-trace-id': trace_id
        } : {};
    } catch (error) {
        console.error('Error mapping local storage trace id to payload', error);
        return {};
    }
}

});

parcelRegister("f998y", function(module, exports) {
$parcel$export(module.exports, "mapMeResponseToUserProfile", function () { return $438b04fc0bdb2836$export$76c6404ebb3f2fbe; });
function $438b04fc0bdb2836$export$76c6404ebb3f2fbe({ account_id: account_id, ...others }) {
    return {
        accountId: account_id,
        ...others
    };
}

});

parcelRegister("6EFID", function(module, exports) {
$parcel$export(module.exports, "mapResponseToText", function () { return $2bf362fcd2fb82d2$export$779c89bcd6b62ed; });
$parcel$export(module.exports, "mapResponseToJson", function () { return $2bf362fcd2fb82d2$export$a1968f52311c9c2e; });
$parcel$export(module.exports, "errorHandleResponse", function () { return $2bf362fcd2fb82d2$export$decf6f2c5b50afb9; });
$parcel$export(module.exports, "getErrorMessage", function () { return $2bf362fcd2fb82d2$export$82f46aa4e6535a45; });

var $7heEc = parcelRequire("7heEc");
async function $2bf362fcd2fb82d2$export$779c89bcd6b62ed(response) {
    if (response.ok) return await response.text();
    else throw new (0, $7heEc.UnsuccessfulFetchError)({
        message: await $2bf362fcd2fb82d2$var$mapResponseToMessage(response),
        response: response
    });
}
async function $2bf362fcd2fb82d2$export$a1968f52311c9c2e(response) {
    if (response.ok) return await response.json();
    else throw new (0, $7heEc.UnsuccessfulFetchError)({
        message: await $2bf362fcd2fb82d2$var$mapResponseToMessage(response),
        response: response
    });
}
async function $2bf362fcd2fb82d2$export$decf6f2c5b50afb9(response) {
    if (response.ok) return;
    throw new (0, $7heEc.UnsuccessfulFetchError)({
        message: await $2bf362fcd2fb82d2$var$mapResponseToMessage(response),
        response: response
    });
}
async function $2bf362fcd2fb82d2$var$mapResponseToMessage(response) {
    const { statusText: statusText } = response;
    const message = await response.text();
    if (message.length > 0) return `${statusText} ${message}`;
    else return statusText;
}
async function $2bf362fcd2fb82d2$export$fb32ca1688c02097(response) {
    try {
        const errorResponse = await response.json();
        if (errorResponse.error) return errorResponse.error;
        return null;
    } catch  {
        return null;
    }
}
async function $2bf362fcd2fb82d2$export$98010428730e71ea(response) {
    try {
        const errorText = await response.text();
        return errorText || null;
    } catch  {
        return null;
    }
}
async function $2bf362fcd2fb82d2$export$82f46aa4e6535a45(response) {
    const errorMessageFromJson = await $2bf362fcd2fb82d2$export$fb32ca1688c02097(response);
    if (errorMessageFromJson) return errorMessageFromJson;
    const errorMessageFromText = await $2bf362fcd2fb82d2$export$98010428730e71ea(response);
    if (errorMessageFromText) return errorMessageFromText;
    return '';
}

});
parcelRegister("7heEc", function(module, exports) {
$parcel$export(module.exports, "UnsuccessfulFetchError", function () { return $6894fbe297179dc1$export$da6dec65957b7041; });
$parcel$export(module.exports, "MadlibContentGenerationError", function () { return $6894fbe297179dc1$export$ef953687cf93d9ab; });
$parcel$export(module.exports, "ProjectCreateError", function () { return $6894fbe297179dc1$export$e8889cc9a6240378; });
class $6894fbe297179dc1$export$da6dec65957b7041 extends Error {
    constructor({ message: message, response: response }){
        super(message ?? response.statusText);
        this.name = $6894fbe297179dc1$export$da6dec65957b7041.name;
        this.response = response;
    }
    get url() {
        return this.response.url;
    }
    get status() {
        return this.response.status;
    }
}
function $6894fbe297179dc1$export$24a0e392ef274e28(value) {
    return value.name === $6894fbe297179dc1$export$da6dec65957b7041.name;
}
class $6894fbe297179dc1$export$ef953687cf93d9ab extends $6894fbe297179dc1$export$da6dec65957b7041 {
    constructor(response){
        super({
            message: 'Madlib content generation request was unsuccessful',
            response: response
        });
        this.name = $6894fbe297179dc1$export$ef953687cf93d9ab.name;
    }
}
class $6894fbe297179dc1$export$e8889cc9a6240378 extends $6894fbe297179dc1$export$da6dec65957b7041 {
    constructor(response){
        super({
            message: 'Project create request was unsuccessful',
            response: response
        });
        this.name = $6894fbe297179dc1$export$e8889cc9a6240378.name;
    }
}

});


parcelRegister("odgKo", function(module, exports) {
$parcel$export(module.exports, "isValidSite", function () { return $e9f844be8a97fb48$export$c7346ed3533fb878; });
const $e9f844be8a97fb48$export$c7346ed3533fb878 = ({ site: site, includeInvalidBitbucketSite: includeInvalidBitbucketSite })=>{
    const ignoreSiteNames = [
        'servicedog',
        'ecosystem',
        'atlassiantraining',
        'Atlassian Stride',
        'volunteerhub',
        'atlassiantraining',
        'hello-staging',
        'ecosystem',
        'riskmanagement',
        'hello-staging3',
        'hello-staging6',
        'hello-staging9',
        'jdog',
        'sre-ehlo',
        'trello',
        'Trello'
    ];
    if (!includeInvalidBitbucketSite) ignoreSiteNames.push('bitbucket', 'Bitbucket');
    if (ignoreSiteNames.includes(site.displayName)) return false;
    if (site.cloudId.startsWith('DUMMY')) return false;
    return true;
};

});

parcelRegister("9tcM4", function(module, exports) {
$parcel$export(module.exports, "AuthenticationMethodsType", function () { return $25ed84543627a8c2$export$5699ee30bc277ff0; });
$parcel$export(module.exports, "SampleDataVersion", function () { return $25ed84543627a8c2$export$ff019c77e16f7f42; });
$parcel$export(module.exports, "GetUserPermissionsIsPermittedRequestPermissionId", function () { return $25ed84543627a8c2$export$13699c771a86789f; });
$parcel$export(module.exports, "AccessRequestCapability", function () { return $25ed84543627a8c2$export$7f151cd797d132bd; });
$parcel$export(module.exports, "JiraProjectCreateErrors", function () { return $25ed84543627a8c2$export$94ef2cab706385a3; });
$parcel$export(module.exports, "POLL_TASK_TIMEOUT", function () { return $25ed84543627a8c2$export$889bc7d00388a53; });
$parcel$export(module.exports, "TaskError", function () { return $25ed84543627a8c2$export$4640a7cbf45425fa; });
$parcel$export(module.exports, "CustomerDomainExpectedError", function () { return $25ed84543627a8c2$export$7428175ef648f8bd; });
$parcel$export(module.exports, "CustomerDomainEngagementExpectedError", function () { return $25ed84543627a8c2$export$14701d34cfd76bf; });
$parcel$export(module.exports, "JobName", function () { return $25ed84543627a8c2$export$37fb66430ebc275; });
var $25ed84543627a8c2$export$5699ee30bc277ff0 = /*#__PURE__*/ function(AuthenticationMethodsType) {
    AuthenticationMethodsType["PASSWORD"] = "password";
    AuthenticationMethodsType["GOOGLE"] = "google";
    AuthenticationMethodsType["SAML"] = "saml";
    AuthenticationMethodsType["MICROSOFT"] = "microsoft";
    AuthenticationMethodsType["APPLE"] = "apple";
    AuthenticationMethodsType["SLACK"] = "slack";
    return AuthenticationMethodsType;
}({});
var $25ed84543627a8c2$export$ff019c77e16f7f42 = /*#__PURE__*/ function(SampleDataVersion) {
    SampleDataVersion["MATURE"] = "MATURE";
    SampleDataVersion["WIZARD"] = "WIZARD";
    SampleDataVersion["GENERIC"] = "GENERIC";
    SampleDataVersion["MATUREV2"] = "MATUREV2";
    SampleDataVersion["SPACE_ONBOARDING"] = "SPACE_ONBOARDING";
    return SampleDataVersion;
}({});
var $25ed84543627a8c2$export$13699c771a86789f = /*#__PURE__*/ function(GetUserPermissionsIsPermittedRequestPermissionId) {
    GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCTS"] = "add-products";
    GetUserPermissionsIsPermittedRequestPermissionId["INVITE_USERS"] = "invite-users";
    GetUserPermissionsIsPermittedRequestPermissionId["MANAGE"] = "manage";
    GetUserPermissionsIsPermittedRequestPermissionId["WRITE"] = "write";
    /**
   * @deprecated ADD_PRODUCT is a legacy permissionId, use ADD_PRODUCTS instead.
   */ GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCT"] = "addProduct";
    return GetUserPermissionsIsPermittedRequestPermissionId;
}({});
var $25ed84543627a8c2$export$7f151cd797d132bd = /*#__PURE__*/ function(AccessRequestCapability) {
    AccessRequestCapability["DIRECT_ACCESS"] = "DIRECT_ACCESS";
    AccessRequestCapability["REQUEST_ACCESS"] = "REQUEST_ACCESS";
    AccessRequestCapability["ACCESS_GRANTED"] = "ACCESS_GRANTED";
    AccessRequestCapability["ACCESS_EXISTS"] = "ACCESS_EXISTS";
    AccessRequestCapability["PENDING_REQUEST_CREATED"] = "PENDING_REQUEST_CREATED";
    AccessRequestCapability["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
    AccessRequestCapability["APPROVED_REQUEST_EXISTS"] = "APPROVED_REQUEST_EXISTS";
    AccessRequestCapability["DENIED_REQUEST_EXISTS"] = "DENIED_REQUEST_EXISTS";
    AccessRequestCapability["FORBIDDEN"] = "FORBIDDEN";
    AccessRequestCapability["VERIFICATION_REQUIRED"] = "VERIFICATION_REQUIRED";
    AccessRequestCapability["ERROR"] = "ERROR";
    return AccessRequestCapability;
}({});
var $25ed84543627a8c2$export$d017131e0710c5ee = /*#__PURE__*/ function(AccessRole) {
    AccessRole["PRODUCT_MEMBER"] = "product/member";
    AccessRole["PRODUCT_HELPSEEKER"] = "product/helpseeker";
    return AccessRole;
}({});
var $25ed84543627a8c2$export$94ef2cab706385a3 = /*#__PURE__*/ function(JiraProjectCreateErrors) {
    JiraProjectCreateErrors["noSiteAccess"] = "noSiteAccess";
    JiraProjectCreateErrors["badRequest"] = "badRequest";
    JiraProjectCreateErrors["badGateway"] = "badGateway";
    JiraProjectCreateErrors["projectNameCollision"] = "projectNamingCollision";
    JiraProjectCreateErrors["projectKeyCollision"] = "projectKeyCollision";
    JiraProjectCreateErrors["noProjectCreateAccess"] = "noProjectCreateAccess";
    return JiraProjectCreateErrors;
}({});
const $25ed84543627a8c2$export$889bc7d00388a53 = 45000;
class $25ed84543627a8c2$export$4640a7cbf45425fa extends Error {
    constructor(message, { status: status, taskMessage: taskMessage, id: id }){
        super(message);
        this.status = status;
        this.id = id;
        this.taskMessage = taskMessage;
    }
}
var $25ed84543627a8c2$export$21de27a5998af787 = /*#__PURE__*/ function(SupportRequestStatusCategory) {
    SupportRequestStatusCategory["Done"] = "DONE";
    SupportRequestStatusCategory["InProgress"] = "IN_PROGRESS";
    SupportRequestStatusCategory["Open"] = "OPEN";
    return SupportRequestStatusCategory;
}({});
const $25ed84543627a8c2$export$e5fd4bbfb733272f = {
    NEEDS_ATTENTION: 'NEEDS_ATTENTION',
    ON_TRACK: 'ON_TRACK',
    COMPLETE: 'COMPLETE'
};
const $25ed84543627a8c2$export$aafef5252493cbb0 = {
    TO_DO: 'TO_DO',
    ON_TRACK: 'ON_TRACK',
    AT_RISK_ATLASSIAN_OWNED: 'AT_RISK_ATLASSIAN_OWNED',
    AT_RISK_PARTNER_OWNED: 'AT_RISK_PARTNER_OWNED',
    NEEDS_CUSTOMER_ATTENTION: 'NEEDS_CUSTOMER_ATTENTION',
    COMPLETE: 'COMPLETE'
};
const $25ed84543627a8c2$export$c8519ead08e3777c = {
    CONSULT: 'CONSULT',
    PLAN: 'PLAN',
    SUPPORT_REQUEST: 'SUPPORT_REQUEST',
    PROBLEM_REPORT: 'PROBLEM_REPORT'
};
const $25ed84543627a8c2$export$5eed94f884a35e8e = {
    JIRA: 'JIRA',
    CONFLUENCE: 'CONFLUENCE'
};
const $25ed84543627a8c2$export$a139c884b248a52a = {
    DONE: 'DONE',
    NOT_DONE: 'NOT DONE'
};
const $25ed84543627a8c2$export$7428175ef648f8bd = {
    NOT_FOUND: 'NOT_FOUND',
    // 404 status
    NO_ACCESS: 'NO_ACCESS' // 401 status
};
const $25ed84543627a8c2$export$14701d34cfd76bf = {
    NO_ENGAGEMENT: 'NO_ENGAGEMENT',
    // 404 status
    NO_ACCESS: 'NO_ACCESS',
    // 401 status
    USER_NOT_PROVISIONED: 'USER_NOT_PROVISIONED' // 403 status
};
const $25ed84543627a8c2$export$37fb66430ebc275 = {
    WAC_SIGNUP: 'wac-signup'
};
const $25ed84543627a8c2$export$30557b1912f2c86a = {
    PROVISIONING_COMPLETED: 'PROVISIONING_COMPLETED',
    PROVISIONING_FAILED: 'PROVISIONING_FAILED',
    PROVISIONING_IN_PROGRESS: 'PROVISIONING_IN_PROGRESS',
    PROVISIONING_ABORTED: 'PROVISIONING_ABORTED',
    PROVISIONING_PROCESS_NOT_FOUND: 'PROVISIONING_PROCESS_NOT_FOUND',
    PROVISIONING_FAILED_COMPLETED: 'PROVISIONING_FAILED_COMPLETED'
};
const $25ed84543627a8c2$export$4e1ad3f3c6e5680c = {
    ACTIVATE: 'activate',
    WAIT_FOR_ACTIVATION: 'wait-for-activation',
    WAIT_FOR_JIRA: 'wait-for-jira',
    CREATE_JIRA_PROJECT: 'create-jira-project',
    ONBOARD_JPD_PROJECT: 'onboard-jpd-project'
};

});



parcelRegister("lcW33", function(module, exports) {
$parcel$export(module.exports, "ALL_ROLES_ELIGIBLE", function () { return $12c4b775d8b33e93$export$390f94ade23c5f40; });
$parcel$export(module.exports, "USER_SEGMENTATION_MAPPING_UNKNOWN", function () { return $12c4b775d8b33e93$export$2f3f9640393bd078; });
$parcel$export(module.exports, "USER_SEGMENTATION_MAPPING_NONE", function () { return $12c4b775d8b33e93$export$4c9a72dac5ce80ae; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE", function () { return $12c4b775d8b33e93$export$572242e58bd07594; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT", function () { return $12c4b775d8b33e93$export$d7de553940261eba; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_HR", function () { return $12c4b775d8b33e93$export$4c29d0d04c15e55d; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_FINANCE", function () { return $12c4b775d8b33e93$export$3950f7f841bf94b6; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_LEGAL", function () { return $12c4b775d8b33e93$export$881249b988b6030f; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", function () { return $12c4b775d8b33e93$export$e4824f74b9879164; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", function () { return $12c4b775d8b33e93$export$4f3cb0844009af52; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_SALES", function () { return $12c4b775d8b33e93$export$1a65d50c4a641bb4; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE", function () { return $12c4b775d8b33e93$export$9ee64e8fbd8b03a2; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_SOFTWARE", function () { return $12c4b775d8b33e93$export$b8b1ac856ba1434b; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT", function () { return $12c4b775d8b33e93$export$4f54a09a24fd1d74; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT", function () { return $12c4b775d8b33e93$export$79685802e8ff1098; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_DESIGN", function () { return $12c4b775d8b33e93$export$e5c438b7501b5a24; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL", function () { return $12c4b775d8b33e93$export$cbc0e551d91a692d; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_SKIP", function () { return $12c4b775d8b33e93$export$53d2a515d824b589; });
$parcel$export(module.exports, "wacToIdentityUserSegMap", function () { return $12c4b775d8b33e93$export$c44124f57672abc9; });
$parcel$export(module.exports, "getWacTeamTypeFromIdentity", function () { return $12c4b775d8b33e93$export$ec1d3db93f52890f; });
$parcel$export(module.exports, "getProductQueryParamTeamType", function () { return $12c4b775d8b33e93$export$e93f47abc92c60f6; });
$parcel$export(module.exports, "getIdentityTeamType", function () { return $12c4b775d8b33e93$export$4d2c8de1ac60304f; });
$parcel$export(module.exports, "getIconForTransparentTemplateV2", function () { return $12c4b775d8b33e93$export$47e4406b75d4e3e6; });
$parcel$export(module.exports, "getTeamTypeForTransparentTemplateV2", function () { return $12c4b775d8b33e93$export$241841e14023c14a; });
$parcel$export(module.exports, "BUSINESS_ROLES_PER_TEAM_TYPE", function () { return $12c4b775d8b33e93$export$9b10a383fdd95886; });
$parcel$export(module.exports, "LANDING_GATE_NON_TECH_TEAM_TYPES", function () { return $12c4b775d8b33e93$export$7b099dc6b5bc8ba7; });
$parcel$export(module.exports, "LANDING_GATE_TECH_TEAM_TYPES", function () { return $12c4b775d8b33e93$export$e762c1129e037c3c; });
$parcel$export(module.exports, "BUSINESS_TEAM_TYPES", function () { return $12c4b775d8b33e93$export$b07956d58f1245f1; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPES", function () { return $12c4b775d8b33e93$export$b33247277ad6a292; });
$parcel$export(module.exports, "USER_SEGMENTATION_CLIENT_MAPPING", function () { return $12c4b775d8b33e93$export$3709503ef3102dbe; });

var $6xbO1 = parcelRequire("6xbO1");
const $12c4b775d8b33e93$export$390f94ade23c5f40 = 'all-roles-eligible';
const $12c4b775d8b33e93$export$2f3f9640393bd078 = 'unknown';
const $12c4b775d8b33e93$export$4c9a72dac5ce80ae = '';
// Roles defined in user segmentation
const $12c4b775d8b33e93$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $12c4b775d8b33e93$export$572242e58bd07594 = 'customer-service';
const $12c4b775d8b33e93$export$d7de553940261eba = 'it-support';
const $12c4b775d8b33e93$export$4c29d0d04c15e55d = 'human-resources';
const $12c4b775d8b33e93$export$3950f7f841bf94b6 = 'finance';
const $12c4b775d8b33e93$export$881249b988b6030f = 'legal';
const $12c4b775d8b33e93$export$e4824f74b9879164 = 'marketing';
const $12c4b775d8b33e93$export$4f3cb0844009af52 = 'operations';
const $12c4b775d8b33e93$export$1a65d50c4a641bb4 = 'sales';
const $12c4b775d8b33e93$export$9ee64e8fbd8b03a2 = 'data-science';
const $12c4b775d8b33e93$export$b8b1ac856ba1434b = 'software-development';
const $12c4b775d8b33e93$export$4f54a09a24fd1d74 = 'product-management';
const $12c4b775d8b33e93$export$79685802e8ff1098 = 'project-management';
const $12c4b775d8b33e93$export$e5c438b7501b5a24 = 'design';
const $12c4b775d8b33e93$export$cbc0e551d91a692d = 'other-personal';
const $12c4b775d8b33e93$export$53d2a515d824b589 = 'skip';
const $12c4b775d8b33e93$export$c44124f57672abc9 = {
    [$12c4b775d8b33e93$export$b8b1ac856ba1434b]: 'Software Development',
    [$12c4b775d8b33e93$export$4f54a09a24fd1d74]: 'Product Management',
    [$12c4b775d8b33e93$export$79685802e8ff1098]: 'Project Management',
    [$12c4b775d8b33e93$export$d7de553940261eba]: 'IT Support',
    [$12c4b775d8b33e93$export$e5c438b7501b5a24]: 'Design',
    [$12c4b775d8b33e93$export$572242e58bd07594]: 'Customer Service',
    [$12c4b775d8b33e93$export$4c29d0d04c15e55d]: 'Human Resources',
    [$12c4b775d8b33e93$export$e4824f74b9879164]: 'Marketing',
    [$12c4b775d8b33e93$export$4f3cb0844009af52]: 'Operations',
    [$12c4b775d8b33e93$export$1a65d50c4a641bb4]: 'Sales',
    [$12c4b775d8b33e93$export$9ee64e8fbd8b03a2]: 'Data Science',
    [$12c4b775d8b33e93$export$3950f7f841bf94b6]: 'Finance',
    [$12c4b775d8b33e93$export$881249b988b6030f]: 'Legal',
    [$12c4b775d8b33e93$export$cbc0e551d91a692d]: 'Other or Personal',
    [$12c4b775d8b33e93$export$53d2a515d824b589]: 'Skip'
};
const $12c4b775d8b33e93$export$ec1d3db93f52890f = (teamType)=>{
    for (const [key, value] of Object.entries($12c4b775d8b33e93$export$c44124f57672abc9)){
        if (value === teamType) return key;
    }
    return undefined;
};
const $12c4b775d8b33e93$export$d9b98775fefed139 = {
    [$12c4b775d8b33e93$export$b8b1ac856ba1434b]: 'DEV',
    [$12c4b775d8b33e93$export$d7de553940261eba]: 'ITS',
    [$12c4b775d8b33e93$export$e5c438b7501b5a24]: 'DES',
    [$12c4b775d8b33e93$export$572242e58bd07594]: 'CS',
    [$12c4b775d8b33e93$export$4c29d0d04c15e55d]: 'HR',
    [$12c4b775d8b33e93$export$e4824f74b9879164]: 'MKT',
    [$12c4b775d8b33e93$export$4f3cb0844009af52]: 'OPS',
    [$12c4b775d8b33e93$export$1a65d50c4a641bb4]: 'SAL',
    [$12c4b775d8b33e93$export$3950f7f841bf94b6]: 'FNC',
    [$12c4b775d8b33e93$export$881249b988b6030f]: 'LGL',
    [$12c4b775d8b33e93$export$cbc0e551d91a692d]: 'OTR',
    [$12c4b775d8b33e93$export$4f54a09a24fd1d74]: 'PDM',
    [$12c4b775d8b33e93$export$79685802e8ff1098]: 'PJM',
    [$12c4b775d8b33e93$export$9ee64e8fbd8b03a2]: 'DS'
};
const $12c4b775d8b33e93$export$e93f47abc92c60f6 = (teamType)=>{
    for (const [key, value] of Object.entries($12c4b775d8b33e93$export$d9b98775fefed139)){
        if (key === teamType) return value;
    }
    return teamType;
};
const $12c4b775d8b33e93$export$4d2c8de1ac60304f = (teamType)=>{
    switch(teamType){
        case $12c4b775d8b33e93$export$b8b1ac856ba1434b:
            return 'Software Development';
        case $12c4b775d8b33e93$export$d7de553940261eba:
            return 'IT Support';
        case $12c4b775d8b33e93$export$e5c438b7501b5a24:
            return 'Design';
        case $12c4b775d8b33e93$export$572242e58bd07594:
            return 'Customer Service';
        case $12c4b775d8b33e93$export$4c29d0d04c15e55d:
            return 'Human Resources';
        case $12c4b775d8b33e93$export$e4824f74b9879164:
            return 'Marketing';
        case $12c4b775d8b33e93$export$4f3cb0844009af52:
            return 'Operations';
        case $12c4b775d8b33e93$export$1a65d50c4a641bb4:
            return 'Sales';
        case $12c4b775d8b33e93$export$3950f7f841bf94b6:
            return 'Finance';
        case $12c4b775d8b33e93$export$881249b988b6030f:
            return 'Legal';
        case $12c4b775d8b33e93$export$cbc0e551d91a692d:
            return 'Other or Personal';
        case $12c4b775d8b33e93$export$4f54a09a24fd1d74:
            return 'Product Management';
        case $12c4b775d8b33e93$export$79685802e8ff1098:
            return 'Project Management';
        case $12c4b775d8b33e93$export$9ee64e8fbd8b03a2:
            return 'Data Science';
        case $12c4b775d8b33e93$export$53d2a515d824b589:
            return 'Skip';
        default:
            return teamType;
    }
};
const $12c4b775d8b33e93$export$47e4406b75d4e3e6 = (teamType)=>{
    switch(teamType){
        case $12c4b775d8b33e93$export$b8b1ac856ba1434b:
            return 0, $6xbO1.SoftwareDevelopmentHeaderIcon;
        case $12c4b775d8b33e93$export$d7de553940261eba:
            return 0, $6xbO1.ITSupportHeaderIcon;
        case $12c4b775d8b33e93$export$e5c438b7501b5a24:
            return 0, $6xbO1.DesignHeaderIcon;
        case $12c4b775d8b33e93$export$572242e58bd07594:
            return 0, $6xbO1.CustomerServiceHeaderIcon;
        case $12c4b775d8b33e93$export$4c29d0d04c15e55d:
            return 0, $6xbO1.HumanResourcesHeaderIcon;
        case $12c4b775d8b33e93$export$e4824f74b9879164:
            return 0, $6xbO1.MarketingHeaderIcon;
        case $12c4b775d8b33e93$export$4f3cb0844009af52:
            return 0, $6xbO1.OperationsHeaderIcon;
        case $12c4b775d8b33e93$export$1a65d50c4a641bb4:
            return 0, $6xbO1.SalesHeaderIcon;
        case $12c4b775d8b33e93$export$3950f7f841bf94b6:
            return 0, $6xbO1.FinanceHeaderIcon;
        case $12c4b775d8b33e93$export$881249b988b6030f:
            return 0, $6xbO1.LegalHeaderIcon;
        case $12c4b775d8b33e93$export$cbc0e551d91a692d:
            return 0, $6xbO1.OtherHeaderIcon;
        case $12c4b775d8b33e93$export$4f54a09a24fd1d74:
            return 0, $6xbO1.ProductManagementHeaderIcon;
        case $12c4b775d8b33e93$export$79685802e8ff1098:
            return 0, $6xbO1.ProjectManagementHeaderIcon;
        case $12c4b775d8b33e93$export$9ee64e8fbd8b03a2:
            return 0, $6xbO1.DataScienceHeaderIcon;
        default:
            return null;
    }
};
const $12c4b775d8b33e93$export$241841e14023c14a = (teamType, formatMessage)=>{
    switch(teamType){
        case $12c4b775d8b33e93$export$b8b1ac856ba1434b:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.softwareDevelopment',
                defaultMessage: 'Software development'
            });
        case $12c4b775d8b33e93$export$d7de553940261eba:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.itSupport',
                defaultMessage: 'IT support'
            });
        case $12c4b775d8b33e93$export$e5c438b7501b5a24:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.design',
                defaultMessage: 'Design'
            });
        case $12c4b775d8b33e93$export$572242e58bd07594:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.customerService',
                defaultMessage: 'Customer service'
            });
        case $12c4b775d8b33e93$export$4c29d0d04c15e55d:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.humanResources',
                defaultMessage: 'Human resources'
            });
        case $12c4b775d8b33e93$export$e4824f74b9879164:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.marketing',
                defaultMessage: 'Marketing'
            });
        case $12c4b775d8b33e93$export$4f3cb0844009af52:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.operations',
                defaultMessage: 'Operations'
            });
        case $12c4b775d8b33e93$export$1a65d50c4a641bb4:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.sales',
                defaultMessage: 'Sales'
            });
        case $12c4b775d8b33e93$export$3950f7f841bf94b6:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.finance',
                defaultMessage: 'Finance'
            });
        case $12c4b775d8b33e93$export$881249b988b6030f:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.legal',
                defaultMessage: 'Legal'
            });
        case $12c4b775d8b33e93$export$cbc0e551d91a692d:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.otherOrPersonal',
                defaultMessage: 'Other'
            });
        case $12c4b775d8b33e93$export$4f54a09a24fd1d74:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.productManagement',
                defaultMessage: 'Product management'
            });
        case $12c4b775d8b33e93$export$79685802e8ff1098:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.projectManagement',
                defaultMessage: 'Project management'
            });
        case $12c4b775d8b33e93$export$9ee64e8fbd8b03a2:
            return formatMessage({
                id: 'UserSeg.teamTypeSelection.dataScience',
                defaultMessage: 'Data science'
            });
        default:
            return teamType;
    }
};
const $12c4b775d8b33e93$export$9b10a383fdd95886 = {
    [$12c4b775d8b33e93$export$4c29d0d04c15e55d]: [
        $12c4b775d8b33e93$export$390f94ade23c5f40
    ],
    [$12c4b775d8b33e93$export$3950f7f841bf94b6]: [
        $12c4b775d8b33e93$export$390f94ade23c5f40
    ],
    [$12c4b775d8b33e93$export$881249b988b6030f]: [
        $12c4b775d8b33e93$export$390f94ade23c5f40
    ],
    [$12c4b775d8b33e93$export$e4824f74b9879164]: [
        $12c4b775d8b33e93$export$390f94ade23c5f40
    ],
    [$12c4b775d8b33e93$export$4f3cb0844009af52]: [
        $12c4b775d8b33e93$export$390f94ade23c5f40
    ],
    [$12c4b775d8b33e93$export$1a65d50c4a641bb4]: [
        $12c4b775d8b33e93$export$390f94ade23c5f40
    ],
    [$12c4b775d8b33e93$export$b8b1ac856ba1434b]: [
        $12c4b775d8b33e93$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $12c4b775d8b33e93$export$7b099dc6b5bc8ba7 = [
    $12c4b775d8b33e93$export$e4824f74b9879164,
    $12c4b775d8b33e93$export$e5c438b7501b5a24,
    $12c4b775d8b33e93$export$4f3cb0844009af52,
    $12c4b775d8b33e93$export$79685802e8ff1098,
    $12c4b775d8b33e93$export$4c29d0d04c15e55d,
    $12c4b775d8b33e93$export$572242e58bd07594,
    $12c4b775d8b33e93$export$881249b988b6030f,
    $12c4b775d8b33e93$export$3950f7f841bf94b6,
    $12c4b775d8b33e93$export$1a65d50c4a641bb4
];
const $12c4b775d8b33e93$export$e762c1129e037c3c = [
    $12c4b775d8b33e93$export$9ee64e8fbd8b03a2,
    $12c4b775d8b33e93$export$cbc0e551d91a692d,
    $12c4b775d8b33e93$export$b8b1ac856ba1434b,
    $12c4b775d8b33e93$export$4f54a09a24fd1d74,
    $12c4b775d8b33e93$export$d7de553940261eba
];
const $12c4b775d8b33e93$export$b07956d58f1245f1 = [
    $12c4b775d8b33e93$export$4c29d0d04c15e55d,
    $12c4b775d8b33e93$export$3950f7f841bf94b6,
    $12c4b775d8b33e93$export$881249b988b6030f,
    $12c4b775d8b33e93$export$e4824f74b9879164,
    $12c4b775d8b33e93$export$4f3cb0844009af52,
    $12c4b775d8b33e93$export$1a65d50c4a641bb4,
    $12c4b775d8b33e93$export$b8b1ac856ba1434b
];
const $12c4b775d8b33e93$export$3c81c899da0f27c0 = [
    $12c4b775d8b33e93$export$b8b1ac856ba1434b,
    $12c4b775d8b33e93$export$4f54a09a24fd1d74,
    $12c4b775d8b33e93$export$d7de553940261eba,
    $12c4b775d8b33e93$export$9ee64e8fbd8b03a2,
    $12c4b775d8b33e93$export$e5c438b7501b5a24,
    $12c4b775d8b33e93$export$79685802e8ff1098,
    $12c4b775d8b33e93$export$572242e58bd07594,
    $12c4b775d8b33e93$export$cbc0e551d91a692d
];
const $12c4b775d8b33e93$export$b33247277ad6a292 = [
    $12c4b775d8b33e93$export$572242e58bd07594,
    $12c4b775d8b33e93$export$d7de553940261eba,
    $12c4b775d8b33e93$export$4c29d0d04c15e55d,
    $12c4b775d8b33e93$export$3950f7f841bf94b6,
    $12c4b775d8b33e93$export$881249b988b6030f,
    $12c4b775d8b33e93$export$e4824f74b9879164,
    $12c4b775d8b33e93$export$4f3cb0844009af52,
    $12c4b775d8b33e93$export$1a65d50c4a641bb4,
    $12c4b775d8b33e93$export$b8b1ac856ba1434b,
    $12c4b775d8b33e93$export$e5c438b7501b5a24,
    $12c4b775d8b33e93$export$4f54a09a24fd1d74,
    $12c4b775d8b33e93$export$79685802e8ff1098,
    $12c4b775d8b33e93$export$9ee64e8fbd8b03a2,
    $12c4b775d8b33e93$export$cbc0e551d91a692d,
    $12c4b775d8b33e93$export$53d2a515d824b589
];
const $12c4b775d8b33e93$export$3709503ef3102dbe = {
    [$12c4b775d8b33e93$export$79685802e8ff1098]: [
        'Project Management'
    ],
    [$12c4b775d8b33e93$export$4f54a09a24fd1d74]: [
        'Product Management'
    ],
    [$12c4b775d8b33e93$export$9ee64e8fbd8b03a2]: [
        'Data Science'
    ],
    [$12c4b775d8b33e93$export$cbc0e551d91a692d]: [
        'Other or Personal'
    ],
    [$12c4b775d8b33e93$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$12c4b775d8b33e93$export$e5c438b7501b5a24]: [
        'Design'
    ],
    [$12c4b775d8b33e93$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$12c4b775d8b33e93$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$12c4b775d8b33e93$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$12c4b775d8b33e93$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        // for Upaas
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$12c4b775d8b33e93$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$12c4b775d8b33e93$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$12c4b775d8b33e93$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$12c4b775d8b33e93$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$12c4b775d8b33e93$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};

});
parcelRegister("6xbO1", function(module, exports) {
$parcel$export(module.exports, "SoftwareDevelopmentIcon2", function () { return $22e783439409d5ca$export$3f7b13292eed3fe1; });
$parcel$export(module.exports, "ProductManagementIcon", function () { return $22e783439409d5ca$export$e142eb117e369c8f; });
$parcel$export(module.exports, "MarketingIcon2", function () { return $22e783439409d5ca$export$a53784039f0a17d0; });
$parcel$export(module.exports, "DesignIcon2", function () { return $22e783439409d5ca$export$d8b6fe79c3f35976; });
$parcel$export(module.exports, "ProjectManagementIcon", function () { return $22e783439409d5ca$export$86f8858d201b0f9e; });
$parcel$export(module.exports, "OperationsIcon2", function () { return $22e783439409d5ca$export$2037b55ec364c78; });
$parcel$export(module.exports, "ITSupportIcon2", function () { return $22e783439409d5ca$export$ddadca1ef61d72f4; });
$parcel$export(module.exports, "HumanResourcesIcon", function () { return $22e783439409d5ca$export$294977ef66033c05; });
$parcel$export(module.exports, "CustomerServiceIcon2", function () { return $22e783439409d5ca$export$f491740eeb057ed5; });
$parcel$export(module.exports, "LegalIcon2", function () { return $22e783439409d5ca$export$8ab8d8da70776293; });
$parcel$export(module.exports, "FinanceIcon2", function () { return $22e783439409d5ca$export$cf4b8a9193cf22e1; });
$parcel$export(module.exports, "SalesIcon2", function () { return $22e783439409d5ca$export$fd9729397ff432bf; });
$parcel$export(module.exports, "DataScienceIcon", function () { return $22e783439409d5ca$export$a2e400cb60027285; });
$parcel$export(module.exports, "OtherIcon", function () { return $22e783439409d5ca$export$bace2d8ac2cf2caa; });
$parcel$export(module.exports, "SoftwareDevelopmentHeaderIcon", function () { return $22e783439409d5ca$export$e11bc36dd8a99125; });
$parcel$export(module.exports, "ProductManagementHeaderIcon", function () { return $22e783439409d5ca$export$72976b44f07f811b; });
$parcel$export(module.exports, "MarketingHeaderIcon", function () { return $22e783439409d5ca$export$bfad4d4e8f73e77e; });
$parcel$export(module.exports, "DesignHeaderIcon", function () { return $22e783439409d5ca$export$d3f781ec209b4fd7; });
$parcel$export(module.exports, "ProjectManagementHeaderIcon", function () { return $22e783439409d5ca$export$bababd42ef961024; });
$parcel$export(module.exports, "OperationsHeaderIcon", function () { return $22e783439409d5ca$export$6efd0fa33b4aa14d; });
$parcel$export(module.exports, "ITSupportHeaderIcon", function () { return $22e783439409d5ca$export$6c12f9ab3896c60b; });
$parcel$export(module.exports, "HumanResourcesHeaderIcon", function () { return $22e783439409d5ca$export$6de851e46e3b87af; });
$parcel$export(module.exports, "CustomerServiceHeaderIcon", function () { return $22e783439409d5ca$export$ab663870e0e1a3cd; });
$parcel$export(module.exports, "LegalHeaderIcon", function () { return $22e783439409d5ca$export$3fb457a290d0178f; });
$parcel$export(module.exports, "FinanceHeaderIcon", function () { return $22e783439409d5ca$export$1b11a71dd9d8f914; });
$parcel$export(module.exports, "SalesHeaderIcon", function () { return $22e783439409d5ca$export$f2bd611053c3be8a; });
$parcel$export(module.exports, "DataScienceHeaderIcon", function () { return $22e783439409d5ca$export$f7c6a6f312b0247; });
$parcel$export(module.exports, "OtherHeaderIcon", function () { return $22e783439409d5ca$export$f8101b6de63ddffb; });
/* custom-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $22e783439409d5ca$var$styles = {
    container: "_1e0c1o8l _1o9zidpf",
    svg: "_p12f1osq _c71l1osq _s7n4yfq0 _lcxvglyw"
};
const $22e783439409d5ca$var$ITSupportGlyph = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "33",
        viewBox: "0 0 31 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.53125 6.25V32.125L8.025 25.7H30.5187V6.25H0.53125Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.8496 7.01855C13.8496 5.1623 15.3309 3.6748 17.1621 3.6748C18.9934 3.6748 20.4746 5.15605 20.4746 7.01855C20.4746 7.9623 20.2496 8.39355 20.0434 8.66855C19.7996 8.9873 19.4934 9.2123 18.9559 9.60605C18.8684 9.6748 18.7684 9.74355 18.6621 9.81855C17.9934 10.3123 17.1434 10.9873 16.5059 12.1061C15.8621 13.2311 15.5059 14.6436 15.5059 16.5123H18.8184C18.8184 15.0623 19.0871 14.2561 19.3746 13.7623C19.6621 13.2561 20.0559 12.9123 20.6309 12.4873C20.6996 12.4373 20.7746 12.3811 20.8559 12.3248C21.3746 11.9498 22.1121 11.4186 22.6684 10.6873C23.3871 9.7498 23.7871 8.5748 23.7871 7.01855C23.7871 3.35605 20.8496 0.362305 17.1621 0.362305C13.4746 0.362305 10.5371 3.35605 10.5371 7.01855V8.67481H13.8496V7.01855Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.1625 19.0063C16.0188 19.0063 15.0938 19.9313 15.0938 21.0751C15.0938 22.2188 16.0188 23.1438 17.1625 23.1438C18.3063 23.1438 19.2313 22.2188 19.2313 21.0751C19.2313 19.9313 18.3063 19.0063 17.1625 19.0063Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.575 6.25H13.9375C13.875 6.49375 13.8437 6.75625 13.8437 7.01875V8.675H10.5312V7.01875C10.5312 6.7625 10.5437 6.50625 10.575 6.25Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.2312 21.0749C19.2312 22.2186 18.3062 23.1499 17.1624 23.1499C16.0187 23.1499 15.0874 22.2186 15.0874 21.0749C15.0874 19.9311 16.0187 19.0061 17.1624 19.0061C18.3062 19.0061 19.2312 19.9311 19.2312 21.0749Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.7871 7.01875C23.7871 8.58125 23.3871 9.75 22.6684 10.6875C22.1121 11.4187 21.3746 11.95 20.8559 12.325C20.7746 12.3875 20.6996 12.4375 20.6309 12.4875C20.0559 12.9187 19.6621 13.2625 19.3746 13.7687C19.0871 14.2687 18.8184 15.075 18.8184 16.5188H15.5059C15.5059 14.65 15.8559 13.2375 16.4996 12.1187C17.1434 11 17.9934 10.325 18.6559 9.825C18.7621 9.75 18.8621 9.68125 18.9496 9.6125C19.4934 9.2125 19.7934 8.99375 20.0371 8.675C20.2496 8.39375 20.4746 7.9625 20.4746 7.01875C20.4746 6.75625 20.4434 6.49375 20.3809 6.25H23.7434C23.7746 6.50625 23.7871 6.7625 23.7871 7.01875Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$var$DesignGlyph = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.6437 19.644C27.7437 19.0877 27.7938 18.4877 27.7938 17.8627C27.7938 17.2377 27.7438 16.6252 27.6375 16.0565C27.0313 12.6877 24.6938 10.6127 21.4062 10.0752C20.8438 9.98149 20.2563 9.93774 19.65 9.93774C19.0438 9.93774 18.4 9.98775 17.8188 10.0877C14.5375 10.6377 12.2 12.7065 11.5938 16.0565C11.4938 16.6252 11.4375 17.2252 11.4375 17.8627C11.4375 18.5002 11.4875 19.0877 11.5875 19.644C12.1875 22.9877 14.525 25.0627 17.8188 25.6127C18.4 25.7127 19.0125 25.7627 19.65 25.7627C20.2875 25.7627 20.85 25.719 21.4062 25.6252C24.6938 25.0877 27.0375 23.0127 27.6375 19.644H27.6437Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.556152 16.9752L10.3062 0.262695L20.0562 16.9752H0.556152Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.2687 10.4875C13.8062 11.35 12.0937 13.2563 11.5937 16.0563C11.5375 16.3563 11.5 16.6563 11.4688 16.975H20.05L16.2687 10.4875Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.3748 19.3252H20.6748V33.0252H34.3748V19.3252Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.6748 19.3311V25.7186C20.9248 25.6936 21.1686 25.6623 21.4123 25.6248C24.6998 25.0936 27.0373 23.0123 27.6436 19.6436C27.6623 19.5436 27.6811 19.4373 27.6936 19.3311H20.6748Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$var$SoftwareDevelopmentGlyph = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "31",
        viewBox: "0 0 35 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.9626 0.581299H0.0375977V23.45H34.9626V0.581299Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.8816 26.5812V30.4687H8.11914V26.5812H14.3691V19.6062H20.6316V26.5812H26.8816Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.6316 19.6062H14.3691V23.4562H20.6316V19.6062Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.4997 17.4438C20.4959 17.4438 22.9247 15.0149 22.9247 12.0188C22.9247 9.02261 20.4959 6.59375 17.4997 6.59375C14.5036 6.59375 12.0747 9.02261 12.0747 12.0188C12.0747 15.0149 14.5036 17.4438 17.4997 17.4438Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$a8475ed0ad467766 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "28",
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.5936 0.362549L14.9561 5.8188V20.3688L28.5936 25.825V0.362549Z",
                fill: "#1868DA"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.45 6.72485V19.4374H11.3187V27.6374H5.8625V19.4374H0.40625V6.72485H18.45Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.4498 6.72485H14.9561V19.4311H18.4498V6.72485Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$7a5074cf88127a64 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "37",
        viewBox: "0 0 42 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3371 0.553483L22.3053 0.585025L24.7811 7.28206L31.8316 6.13992L35.7841 13.0563L31.2273 18.5555L35.7405 24.082L31.7333 30.9669L24.7007 29.769L22.1719 36.4462L14.2037 36.4147L11.7278 29.7176L4.68588 30.8598L0.733372 23.9434L5.29013 18.4528L0.776983 12.9263L4.78412 6.04139L11.8253 7.23932L14.3541 0.562091L14.3371 0.553483ZM18.2193 25.2168C21.9344 25.2315 24.9525 22.2372 24.9672 18.5221C24.9819 14.8071 21.9876 11.7889 18.2726 11.7742C14.5575 11.7595 11.5394 14.7539 11.5247 18.4689C11.5099 22.184 14.5043 25.2021 18.2193 25.2168Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.2269 18.547L35.7836 13.0564L31.8311 6.13999L24.7807 7.28213L22.3048 0.593637L14.3366 0.562095L11.7993 7.23075L4.76661 6.03286L0.759472 12.9177L5.27262 18.4442L0.715827 23.9434L4.66834 30.8598L11.7103 29.7091L14.1947 36.4061L22.1629 36.4377L24.6917 29.7605L28.5665 30.4249L31.7329 30.9669L35.74 24.082L33.9382 21.8714L31.2269 18.547ZM18.2189 25.2169C14.5123 25.2022 11.5095 22.1841 11.5242 18.469C11.5389 14.7539 14.5656 11.7596 18.2721 11.7743C21.9786 11.789 24.9814 14.8157 24.9668 18.5222C24.9521 22.2287 21.9339 25.2316 18.2189 25.2169Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                style: {
                    mixBlendMode: 'multiply'
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M41.3728 26.2112C41.4574 25.7407 41.4997 25.2333 41.4997 24.7047C41.4997 24.1761 41.4574 23.6581 41.3675 23.1771C40.8548 20.328 38.8779 18.5731 36.0975 18.1185C35.6218 18.0392 35.1249 18.0022 34.6122 18.0022C34.0994 18.0022 33.555 18.0445 33.0634 18.1291C30.2883 18.5942 28.3114 20.3438 27.7987 23.1771C27.7141 23.6581 27.6665 24.1655 27.6665 24.7047C27.6665 25.2439 27.7088 25.7407 27.7934 26.2112C28.3008 29.0391 30.2777 30.794 33.0634 31.2592C33.555 31.3438 34.073 31.386 34.6122 31.386C35.1513 31.386 35.627 31.349 36.0975 31.2698C38.8779 30.8152 40.8601 29.0603 41.3675 26.2112H41.3728Z",
                    fill: "#0C66E4"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.4713 18.4998L35.7119 23.6925L35.9706 24.0099L31.9635 30.8948L31.9371 30.8903L31.7897 30.865C29.6821 30.132 28.2195 28.5139 27.7934 26.1389C27.7088 25.6685 27.6665 25.1716 27.6665 24.6325C27.6665 24.0933 27.7141 23.5859 27.7987 23.1048C28.2069 20.8492 29.5431 19.2804 31.4713 18.4998Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.225 22.6846L33.5824 28.0872L30.667 25.2185L31.9257 24.0494L33.6039 25.6975L37.9878 21.5L39.2304 22.6897L39.225 22.6846Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$5a330511b92aac24 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "38",
        viewBox: "0 0 43 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.3876 3.30908C8.50444 3.30908 0.5 11.3214 0.5 21.1967C0.5 28.6407 5.0469 35.0269 11.5199 37.7187V33.4007C11.5199 29.6038 14.5986 26.533 18.3876 26.533C22.1767 26.533 25.2475 29.6116 25.2475 33.4007V37.7187C31.7205 35.0348 36.2753 28.6486 36.2753 21.1967C36.2753 11.3135 28.2629 3.30908 18.3876 3.30908ZM18.3876 24.599C15.1353 24.599 12.4988 21.9624 12.4988 18.7101C12.4988 15.4578 15.1274 12.8213 18.3876 12.8213C21.6478 12.8213 24.2686 15.4499 24.2686 18.7101C24.2686 21.9703 21.6399 24.599 18.3876 24.599Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.447 6.64839L23.1318 9.80597L29.447 12.9635L32.6045 19.2787L35.7621 12.9635L42.0773 9.80597L35.7621 6.64839L32.6045 0.333252L29.447 6.64839Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.9811 14.5266L32.605 19.2787L29.4475 12.9636L23.1323 9.80601L29.0607 6.83789C31.6814 8.79558 33.7497 11.4479 34.9811 14.5266Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.0607 6.83789L23.1323 9.80601L29.4475 12.9636L32.605 19.2787L34.9811 14.5266C33.7497 11.4479 31.6814 8.79558 29.0607 6.83789Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$2a1d70df8da1fa8a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "34",
        viewBox: "0 0 26 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.6161 33.4709H0V0H12.9505L25.6161 12.4757V33.4709Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.9453 0V12.4388H25.5793L12.9453 0Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.0179 16.543H12.9492V20.0773H20.0179V16.543Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.2369 20.6681C9.53918 20.6681 10.5949 19.6124 10.5949 18.3101C10.5949 17.0079 9.53918 15.9521 8.2369 15.9521C6.93462 15.9521 5.87891 17.0079 5.87891 18.3101C5.87891 19.6124 6.93462 20.6681 8.2369 20.6681Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.0179 25.458H12.9492V28.9924H20.0179V25.458Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.2369 29.5832C9.53918 29.5832 10.5949 28.5275 10.5949 27.2252C10.5949 25.9229 9.53918 24.8672 8.2369 24.8672C6.93462 24.8672 5.87891 25.9229 5.87891 27.2252C5.87891 28.5275 6.93462 29.5832 8.2369 29.5832Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$c3c91f9d6f32ce98 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "46",
        height: "28",
        viewBox: "0 0 46 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M45.5573 10.3687H11.3848V27.0656H45.5573V10.3687Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.9362 0H0.763672V16.6969H34.9362V0Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.9358 10.3687H11.3848V16.6966H34.9358V10.3687Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.2535 5.66825L6.8942 13.0275L3.0918 9.11988L4.73342 7.52736L6.92226 9.77232L12.6399 4.05469L14.2605 5.67527L14.2535 5.66825Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M43.4312 16.4021L36.0719 23.7614L32.2695 19.8538L33.9112 18.2612L36.1 20.5062L41.8176 14.7886L43.4382 16.4092L43.4312 16.4021Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$a9941a16640f105a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "30",
        viewBox: "0 0 36 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.9463 18.2911V14.6985C35.9463 13.7694 35.1039 13.0137 34.057 13.0137H12.8853C11.8385 13.0137 10.9961 13.7632 10.9961 14.6985V18.2911H35.9463Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.9463 20.6449H10.9961V28.0408C10.9961 28.9637 11.8385 29.7256 12.8853 29.7256H34.057C35.1039 29.7256 35.9463 28.9699 35.9463 28.0408V20.6449Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.7685 5.27746V1.68482C25.7685 0.75569 24.9261 0 23.8793 0H2.70759C1.66077 0 0.818359 0.749496 0.818359 1.68482V5.27746H25.7685Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.7685 7.63125H0.818359V15.0271C0.818359 15.95 1.66077 16.7119 2.70759 16.7119H23.8793C24.9261 16.7119 25.7685 15.9562 25.7685 15.0271V7.63125Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.7692 13.0078V15.0209C25.7692 15.9501 24.9268 16.7119 23.88 16.7119H10.9961V14.6988C10.9961 13.7635 11.8447 13.0078 12.8853 13.0078H25.7692Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.7692 13.0078V15.0209C25.7692 15.9501 24.9268 16.7119 23.88 16.7119H10.9961V14.6988C10.9961 13.7635 11.8447 13.0078 12.8853 13.0078H25.7692Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$b81d861c2dc0475e = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "33",
        viewBox: "0 0 27 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27 5.5H0V32.9999H27V5.5Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7 27.844C7 25.6275 9.9081 23.833 13.5 23.833C17.0919 23.833 20 25.6275 20 27.844V32.9996H7V27.844Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18 17.875C18 20.1498 15.988 22 13.5 22C11.012 22 9 20.1556 9 17.875C9 15.5943 11.012 13.75 13.5 13.75C15.988 13.75 18 15.5943 18 17.875Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23 3.25947V10.0833H4V3.25947H9.58471C9.58471 1.45789 11.3374 0 13.5033 0C15.6692 0 17.4153 1.45789 17.4153 3.25947H23Z",
                fill: "#0C66E4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23 5.5H4V10.0833H23V5.5Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$f2de52c1920eba82 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 275 275",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M53.72 68.75L43.27 229.76H223.49L229.02 68.75H53.72Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.3799 203.36L31.5199 186.23H200.17L207.6 203.36H31.3799Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.5199 186.23L31.3799 203.36H44.9899L46.0999 186.23H31.5199Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M194.57 146.02L243.17 50.7L229.24 43.79L180.64 139.11L180.66 139.12L177.37 163.2L194.57 146.03V146.02H194.58H194.57Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M129.43 164.74C130.22 166.72 130.29 169.1 130.74 171.52L130.83 172.09C130.91 172.46 130.99 173 131.3 173.68C131.47 174.02 131.68 174.4 132.05 174.74C132.4 175.1 132.92 175.34 133.43 175.48C134.49 175.69 135.48 175.49 136.46 175.17C138.52 174.44 139.95 172.74 141.15 171.38C142.35 169.98 143.45 168.84 144.42 168.25C145.7 167.65 147.21 167.65 148.67 167.89C150.14 168.13 151.6 168.6 153.11 169.01C156.15 169.83 159.36 170.14 162.52 169.85C162.52 169.85 164.5 169.62 166.67 169C168.85 168.41 171.22 167.53 172.28 167.03C173.6 166.39 174.42 165.87 174.55 165.58C174.68 165.28 174.08 165.22 172.56 165.52C171.04 165.8 168.64 166.57 165.14 167.41C165.05 167.4 164.76 167.43 164.72 167.39C161.04 168.32 157.29 168.13 153.72 167.12C151.91 166.62 150.01 165.89 147.75 165.7C146.63 165.61 145.42 165.68 144.21 166.1C142.99 166.52 141.99 167.26 141.17 168.01C141.36 168.04 141.2 168.32 140.97 168.45L140.91 168.25C139.92 169.33 139.16 170.28 138.4 171.05C137.65 171.82 136.92 172.41 136.2 172.76C135.56 173.08 134.52 173.33 134.01 173.27C133.74 173.24 133.63 173.22 133.43 173.06C133.23 172.89 133 172.51 132.8 172.03C132.8 172.05 133.16 172.41 133.16 172.4C132.9 171.66 132.79 170.63 132.69 169.58C132.59 168.51 132.5 167.37 132.31 166.17C132.1 164.97 131.8 163.69 131.1 162.45C130.44 161.2 129.23 160.1 127.89 159.53L126.89 159.18L126.39 159.01L125.86 158.92L124.79 158.77L123.71 158.8C123.53 158.8 123.35 158.81 123.17 158.83L122.65 158.93C122.3 159 121.95 159.07 121.61 159.15C120.97 159.4 120.27 159.58 119.69 159.91C117.24 161.11 115.2 162.81 113.34 164.59C111.48 166.38 109.77 168.28 108.07 170.1L106.8 171.45C106.72 171.51 106.77 171.49 106.67 171.48C106.59 171.42 106.59 171.44 106.59 171.36C106.69 170.78 106.8 170.2 106.9 169.62C107.79 164.8 108.86 160.11 109.85 155.68L109.8 155.76L109.78 155.71C109.49 156.51 108.82 158.84 108.23 160.98C107.65 163.12 107.16 165.07 107.16 165.07C107.35 162.03 108.1 158.89 108.98 155.73C109.87 152.57 110.82 149.39 111.63 146.28L111.85 146.38C111.13 149.07 110.68 151.47 110.54 152.47C110.87 151.27 111.23 149.92 111.63 148.46C112.04 147 112.49 145.42 112.91 143.73C113.74 140.36 114.57 136.59 114.52 132.63C114.48 130.66 114.21 128.61 113.41 126.71C112.64 124.8 111.24 123.11 109.58 122.09C108.77 121.55 107.9 121.19 107.06 120.9C106.65 120.78 106.24 120.66 105.84 120.55C105.44 120.45 105.03 120.38 104.64 120.3C103.06 120.03 101.58 120.01 100.31 120.14C100.45 120.25 101.3 120.09 102.23 120.17C102.69 120.17 103.17 120.24 103.57 120.35C103.97 120.45 104.3 120.58 104.47 120.77C101.94 120.29 99.3202 120.53 97.0202 121.14C96.9702 120.96 97.2902 120.8 97.6602 120.69C98.0302 120.6 98.4502 120.53 98.5802 120.47C98.0602 120.51 96.2302 120.75 93.7202 121.76C91.2202 122.79 88.1202 124.65 85.0802 127.33C78.9702 132.68 72.9602 141 69.1402 149.57C67.2102 153.83 65.7602 158.06 64.6002 161.79C63.4502 165.53 62.5902 168.78 61.9802 171.18C60.7802 175.98 60.6502 177.44 62.3802 172.89L62.4302 173.42C63.9102 168.63 65.1002 164.64 67.1302 159.84C67.3302 159.13 67.4002 159.07 67.2102 159C67.2502 158.81 67.3002 158.48 67.1902 158.53C66.7202 158.45 67.4302 156.97 67.6802 156.29C68.2402 156.95 69.6102 153.17 71.3702 149.12C72.2402 147.09 73.2502 145.01 74.1302 143.32C75.0202 141.64 75.7802 140.35 76.1202 139.89C76.9302 139.9 78.6802 136.25 79.8002 135.38C79.7602 135.47 79.5202 136.05 79.4902 136.13C80.0302 135.78 83.1402 131.48 86.4102 128.46C89.6402 125.39 92.8002 123.68 90.5902 125.5C93.1302 124.07 96.1002 122.77 99.3902 122.43C101.03 122.26 102.73 122.34 104.41 122.74C106.1 123.15 107.76 123.75 108.98 124.88C110.22 125.99 111.05 127.55 111.45 129.35C111.87 131.14 111.9 133.1 111.76 135.08C111.46 139.07 110.44 143.13 109.39 147.25C108.37 151.42 107.42 155.54 106.47 159.66C106 161.72 105.55 163.76 105.12 165.8C104.92 166.82 104.71 167.83 104.51 168.84C104.41 169.34 104.32 169.85 104.22 170.35L104.15 170.73L104.11 170.93L104.08 171.25C104.06 171.68 104.14 172.14 104.35 172.53C104.76 173.33 105.53 173.85 106.38 173.96C106.81 174.02 107.27 173.96 107.68 173.79C107.89 173.72 108.07 173.59 108.25 173.47C108.4 173.35 108.6 173.17 108.66 173.1C109.35 172.38 110.03 171.67 110.71 170.96C112.04 169.55 113.34 168.19 114.65 166.95C117.24 164.48 120.06 162.42 122.72 161.92L122.54 161.87C122.71 161.87 123.22 161.72 123.36 161.79C123.85 161.66 124.57 161.53 125.36 161.63C126.14 161.72 127.06 161.99 127.66 162.4C128.3 162.81 128.74 163.41 129.01 163.89C129.27 164.39 129.4 164.74 129.4 164.74H129.43ZM110.79 145.61C110.79 145.61 110.76 145.57 110.75 145.58C110.83 145.58 111.58 142.38 111.61 142.25L111.84 142.32C111.53 145.68 107.99 152.76 110.51 145.84C110.51 145.59 110.71 145.63 110.8 145.6L110.79 145.61ZM103.79 121.7C103.24 121.6 102.63 121.5 101.95 121.47C103.83 121.36 105.94 121.67 107.93 122.59C109.94 123.49 111.55 125.37 112.29 127.54C113.05 129.71 113.13 132.06 113.01 134.3C112.87 136.55 112.53 138.73 112.19 140.8C111.96 139.3 112.28 136.94 112.43 134.49C112.6 132.05 112.46 129.5 111.88 127.86C111.18 126.28 110.13 124.7 108.61 123.68C107.88 123.14 107.06 122.74 106.22 122.43C105.39 122.11 104.57 121.87 103.79 121.71V121.7ZM69.5802 152.33L69.6902 152.4L69.5902 152.65C69.5902 152.65 69.5402 152.59 69.5402 152.54C69.5402 152.49 69.5502 152.4 69.5802 152.34V152.33ZM127.83 161.64C127.37 161.48 125.5 160.81 126.88 160.87C127.21 161 128.17 161.35 127.83 161.64ZM95.3602 122.35C95.4202 122.53 94.8302 122.9 94.1902 123.16C93.5702 123.45 92.8902 123.64 92.7702 123.42C93.6202 122.98 94.4902 122.64 95.3602 122.35ZM138.7 172.93C138.97 172.13 139.12 172.61 139.48 172.62C139.31 172.72 138.78 173.16 138.76 172.92H138.69L138.7 172.93ZM149.64 167.37C149.87 167.2 150.63 167.25 150.97 167.33C151.81 167.7 150 167.62 149.64 167.37ZM170.7 167.14C170.67 166.91 171.13 166.69 171.33 166.87C171.33 167.05 170.77 167.36 170.61 167.12C170.61 167.12 170.65 167.14 170.7 167.14ZM84.0902 128.88C84.1502 127.83 86.4902 126.49 87.5102 125.51C87.6702 126.22 85.4202 127.42 84.7202 128.26C84.4502 128.51 84.2402 128.72 84.0902 128.88ZM109.97 169.04C109.5 168.65 111.82 166.87 112.4 166.09L112.56 166.27C111.61 167.34 111.14 168.06 110.01 169L109.97 169.04ZM108.64 121.87C109.3 121.92 110.03 122.71 110.49 123.11C110.37 123.24 109.83 122.87 109.32 122.57C108.84 122.23 108.37 121.95 108.64 121.86V121.87ZM112.26 144.9C111.87 144.92 112.33 143.83 112.37 143.49C112.39 143.74 112.51 144.22 112.44 144.49C112.39 144.68 112.34 144.72 112.26 144.9ZM109.43 169.96C109.06 170.36 108.67 170.78 108.28 171.2C107.9 171.58 107.44 172.14 107.16 172.27L107.07 172.05C107.13 172.01 107.19 171.97 107.25 171.92C107.32 171.86 107.44 171.73 107.53 171.63L108.12 171.02C108.51 170.61 108.89 170.19 109.28 169.79L109.43 169.97V169.96ZM106.92 166.91L107.15 166.96C107.05 168.58 106.42 168.64 106.91 166.95V166.91H106.92ZM120.33 160.26C120.17 160.33 119.91 160.44 119.76 160.51C118.68 161.07 118.79 160.78 119.2 160.45C119.61 160.12 120.32 159.77 120.33 160.25V160.26ZM131.49 164.28C131.59 164.51 131.76 164.82 131.81 165.08C132.13 166.79 131.23 165.04 131.49 164.28Z",
                fill: "#333437"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M229.02 68.75H216.51L180.64 139.11L180.66 139.12L177.37 163.2L194.57 146.03V146.02H194.58H194.57L228.66 79.16L229.02 68.75Z",
                fill: "#09326C"
            })
        ]
    });
const $22e783439409d5ca$export$816a17ab71a9c447 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Frame",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                id: "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        id: "Vector",
                        d: "M31.6417 10.6006H8.3584V25.5076H31.6417V10.6006Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        id: "Vector_2",
                        d: "M26.2544 27.5486V30.0827H13.7461V27.5486H17.9128V23.002H22.0878V27.5486H26.2544Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        id: "Vector_3",
                        d: "M22.0881 23.002H17.9131V25.5116H22.0881V23.002Z",
                        fill: "#AE2A19"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        id: "Vector_4",
                        d: "M19.9995 21.5921C21.9969 21.5921 23.6161 20.0089 23.6161 18.0558C23.6161 16.1028 21.9969 14.5195 19.9995 14.5195C18.002 14.5195 16.3828 16.1028 16.3828 18.0558C16.3828 20.0089 18.002 21.5921 19.9995 21.5921Z",
                        fill: "white"
                    })
                ]
            })
        })
    });
const $22e783439409d5ca$export$b6c5d967ad9baf32 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.6757 9.37109H17.5632L18.784 12.6336L22.2215 12.0628L24.1632 15.4294L21.9507 18.1211L24.1632 20.8086L22.2215 24.1753L18.7882 23.6044L17.5673 26.8669H13.6798L12.459 23.6044L9.02565 24.1753L7.08398 20.8086L9.29648 18.1211L7.08398 15.4336L9.02565 12.0669L12.4632 12.6378L13.684 9.37526L13.6757 9.37109ZM15.6173 21.3961C17.4298 21.3961 18.8965 19.9294 18.8965 18.1169C18.8965 16.3044 17.4298 14.8378 15.6173 14.8378C13.8048 14.8378 12.3382 16.3044 12.3382 18.1169C12.3382 19.9294 13.8048 21.3961 15.6173 21.3961Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.629 17.1006H27.8373L28.8456 19.7923L31.6831 19.3214L33.2873 22.1006L31.4581 24.3214L33.2831 26.5423L31.679 29.3214L28.8415 28.8506L27.8331 31.5423H24.6248L23.6165 28.8506L20.779 29.3214L19.1748 26.5423L20.9998 24.3214L19.1748 22.1006L20.779 19.3214L23.6165 19.7923L24.6248 17.1006H24.629ZM26.2331 27.0298C27.729 27.0298 28.9415 25.8173 28.9415 24.3214C28.9415 22.8256 27.729 21.6131 26.2331 21.6131C24.7373 21.6131 23.5248 22.8256 23.5248 24.3214C23.5248 25.8173 24.7373 27.0298 26.2331 27.0298Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.9502 18.1167L24.1627 15.4292L22.221 12.0625L18.7835 12.6333L17.5627 9.375H13.6752L12.4502 12.6333L9.01686 12.0625L7.0752 15.4292L9.2877 18.1167L7.0752 20.8083L9.01686 24.175L12.4502 23.6L13.6752 26.8625H17.5627L18.7835 23.6L20.6752 23.9167L22.221 24.175L24.1627 20.8083L23.2794 19.7333L21.9502 18.1167ZM15.6169 21.3958C13.8085 21.3958 12.3377 19.9292 12.3377 18.1167C12.3377 16.3042 13.8085 14.8375 15.6169 14.8375C17.4252 14.8375 18.896 16.3083 18.896 18.1167C18.896 19.925 17.4294 21.3958 15.6169 21.3958Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.2797 19.7338L20.7839 19.3213L19.1797 22.1005L20.6755 23.9171L22.2214 24.1755L24.163 20.8088L23.2797 19.7338Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$89a8de63b42b4bf7 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.7919 10.4443L19.7002 14.0818V23.7818L28.7919 27.4193V10.4443Z",
                fill: "#1868DA"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.0292 14.6855V23.1605H17.275V28.6272H13.6375V23.1605H10V14.6855H22.0292Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.0294 14.6855H19.7002V23.1564H22.0294V14.6855Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$27ec4a87867305fc = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.4292 21.0958C25.4958 20.725 25.5292 20.325 25.5292 19.9083C25.5292 19.4917 25.4958 19.0833 25.425 18.7042C25.0208 16.4583 23.4625 15.075 21.2708 14.7167C20.8958 14.6542 20.5042 14.625 20.1 14.625C19.6958 14.625 19.2667 14.6583 18.8792 14.725C16.6917 15.0917 15.1333 16.4708 14.7292 18.7042C14.6625 19.0833 14.625 19.4833 14.625 19.9083C14.625 20.3333 14.6583 20.725 14.725 21.0958C15.125 23.325 16.6833 24.7083 18.8792 25.075C19.2667 25.1417 19.675 25.175 20.1 25.175C20.525 25.175 20.9 25.1458 21.2708 25.0833C23.4625 24.725 25.025 23.3417 25.425 21.0958H25.4292Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.37109 19.3165L13.8711 8.1748L20.3711 19.3165H7.37109Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.8465 14.9912C16.2048 15.5662 15.0631 16.837 14.7298 18.7037C14.6923 18.9037 14.6673 19.1037 14.6465 19.3162H20.3673L17.8465 14.9912Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.9165 20.8828H20.7832V30.0161H29.9165V20.8828Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.7832 20.8867V25.1451C20.9499 25.1284 21.1124 25.1076 21.2749 25.0826C23.4665 24.7284 25.0249 23.3409 25.429 21.0951C25.4415 21.0284 25.454 20.9576 25.4624 20.8867H20.7832Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$a9d1d41ede76da88 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.2743 18.1211H12.9785V28.0378H33.2743V18.1211Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.9667 11.9629H6.6709V21.8796H26.9667V11.9629Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.966 18.1211H12.9785V21.8794H26.966V18.1211Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M14.6829 15.3294L10.312 19.7003L8.05371 17.3794L9.02871 16.4336L10.3287 17.7669L13.7245 14.3711L14.687 15.3336L14.6829 15.3294Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.012 21.7044L27.6411 26.0753L25.3828 23.7544L26.3578 22.8086L27.6578 24.1419L31.0536 20.7461L32.0161 21.7086L32.012 21.7044Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$a10f1df78def0898 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.4783 10.0306L21.0316 10.0486L22.4464 13.8755L26.4752 13.2228L28.7338 17.175L26.1299 20.3174L28.7088 23.4754L26.419 27.4096L22.4004 26.7251L20.9553 30.5407L16.4021 30.5227L14.9873 26.6958L10.9634 27.3484L8.70478 23.3962L11.3086 20.2587L8.7297 17.1007L11.0195 13.1665L15.043 13.851L16.4881 10.0355L16.4783 10.0306ZM18.6968 24.1239C20.8197 24.1323 22.5443 22.4213 22.5527 20.2984C22.5611 18.1755 20.8501 16.4508 18.7272 16.4424C16.6043 16.434 14.8796 18.1451 14.8712 20.268C14.8628 22.3909 16.5739 24.1155 18.6968 24.1239Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.1299 20.3126L28.7338 17.1751L26.4752 13.2229L22.4464 13.8755L21.0316 10.0535L16.4783 10.0355L15.0284 13.8461L11.0098 13.1616L8.71998 17.0959L11.2989 20.2539L8.69504 23.3962L10.9536 27.3485L14.9776 26.6909L16.3972 30.5178L20.9505 30.5358L22.3955 26.7203L24.6097 27.0999L26.4191 27.4097L28.7088 23.4754L27.6792 22.2123L26.1299 20.3126ZM18.6968 24.1239C16.5788 24.1156 14.8628 22.3909 14.8712 20.268C14.8796 18.1451 16.6092 16.4341 18.7272 16.4425C20.8452 16.4508 22.5611 18.1804 22.5527 20.2984C22.5443 22.4164 20.8197 24.1323 18.6968 24.1239Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M31.9279 24.6918C31.9762 24.423 32.0004 24.133 32.0004 23.831C32.0004 23.5289 31.9762 23.2329 31.9248 22.958C31.6319 21.33 30.5022 20.3272 28.9134 20.0674C28.6416 20.0221 28.3576 20.001 28.0646 20.001C27.7717 20.001 27.4605 20.0251 27.1796 20.0735C25.5939 20.3393 24.4642 21.3391 24.1712 22.958C24.1229 23.2329 24.0957 23.5229 24.0957 23.831C24.0957 24.1391 24.1199 24.423 24.1682 24.6918C24.4582 26.3078 25.5878 27.3106 27.1796 27.5764C27.4605 27.6247 27.7566 27.6489 28.0646 27.6489C28.3727 27.6489 28.6446 27.6277 28.9134 27.5824C30.5022 27.3227 31.6349 26.3199 31.9248 24.6918H31.9279Z",
                    fill: "#0C66E4"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.2701 20.2856L28.6925 23.252L28.8406 23.4336L26.5508 27.3679L26.5358 27.3653L26.448 27.3503C25.2457 26.9308 24.4115 26.0066 24.1682 24.651C24.1199 24.3822 24.0957 24.0982 24.0957 23.7901C24.0957 23.482 24.1229 23.1921 24.1712 22.9172C24.4045 21.6282 25.1681 20.7317 26.2701 20.2856Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.7008 22.6769L27.4765 25.7641L25.8105 24.1249L26.5298 23.4568L27.4888 24.3986L29.9939 22L30.7039 22.6798L30.7008 22.6769Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$e6598341d5f08715 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.0205 14.166V31.416L15.0163 27.1327H30.0122V14.166H10.0205Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.8997 14.6787C18.8997 13.4412 19.8872 12.4495 21.1081 12.4495C22.3289 12.4495 23.3164 13.437 23.3164 14.6787C23.3164 15.3079 23.1664 15.5954 23.0289 15.7787C22.8664 15.9912 22.6622 16.1412 22.3039 16.4037C22.2456 16.4495 22.1789 16.4954 22.1081 16.5454C21.6622 16.8745 21.0956 17.3245 20.6706 18.0704C20.2414 18.8204 20.0039 19.762 20.0039 21.0079H22.2122C22.2122 20.0412 22.3914 19.5037 22.5831 19.1745C22.7747 18.837 23.0372 18.6079 23.4206 18.3245C23.4664 18.2912 23.5164 18.2537 23.5706 18.2162C23.9164 17.9662 24.4081 17.612 24.7789 17.1245C25.2581 16.4995 25.5247 15.7162 25.5247 14.6787C25.5247 12.237 23.5664 10.2412 21.1081 10.2412C18.6497 10.2412 16.6914 12.237 16.6914 14.6787V15.7829H18.8997V14.6787Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.1087 22.6709C20.3462 22.6709 19.7295 23.2876 19.7295 24.0501C19.7295 24.8126 20.3462 25.4292 21.1087 25.4292C21.8712 25.4292 22.4878 24.8126 22.4878 24.0501C22.4878 23.2876 21.8712 22.6709 21.1087 22.6709Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.7167 14.166H18.9583C18.9167 14.3285 18.8958 14.5035 18.8958 14.6785V15.7827H16.6875V14.6785C16.6875 14.5077 16.6958 14.3368 16.7167 14.166Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.4871 24.0491C22.4871 24.8116 21.8704 25.4324 21.1079 25.4324C20.3454 25.4324 19.7246 24.8116 19.7246 24.0491C19.7246 23.2866 20.3454 22.6699 21.1079 22.6699C21.8704 22.6699 22.4871 23.2866 22.4871 24.0491Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.5247 14.6785C25.5247 15.7202 25.2581 16.4993 24.7789 17.1243C24.4081 17.6118 23.9164 17.966 23.5706 18.216C23.5164 18.2577 23.4664 18.291 23.4206 18.3243C23.0372 18.6118 22.7747 18.841 22.5831 19.1785C22.3914 19.5118 22.2122 20.0493 22.2122 21.0118H20.0039C20.0039 19.766 20.2372 18.8243 20.6664 18.0785C21.0956 17.3327 21.6622 16.8827 22.1039 16.5493C22.1747 16.4993 22.2414 16.4535 22.2997 16.4077C22.6622 16.141 22.8622 15.9952 23.0247 15.7827C23.1664 15.5952 23.3164 15.3077 23.3164 14.6785C23.3164 14.5035 23.2956 14.3285 23.2539 14.166H25.4956C25.5164 14.3368 25.5247 14.5077 25.5247 14.6785Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$10c57db1e3cf8326 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.2374 11.7456H11.7041V33.3456H28.2374V11.7456Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.6831 28.9165C16.6831 27.0124 18.2248 25.4707 20.1289 25.4707C22.0331 25.4707 23.5748 27.0124 23.5748 28.9165V33.3457H16.6831V28.9165Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.0831 21.0416C23.0831 22.6707 21.7623 23.9957 20.129 23.9957C18.4956 23.9957 17.1748 22.6749 17.1748 21.0416C17.1748 19.4082 18.4956 18.0874 20.129 18.0874C21.7623 18.0874 23.0831 19.4082 23.0831 21.0416Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.908 9.95391V15.0831H14.0288V9.95391H17.5205C17.5205 8.59974 18.6163 7.50391 19.9705 7.50391C21.3246 7.50391 22.4163 8.59974 22.4163 9.95391H25.908Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.908 11.7456H14.0288V15.0831H25.908V11.7456Z",
                fill: "#164B35"
            })
        ]
    });
const $22e783439409d5ca$export$925c822e766a0944 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.2917 24.4C22.6583 28.5625 18.7708 31.425 14.6083 30.7917C10.4458 30.1583 7.58333 26.2708 8.21667 22.1083C8.85 17.9458 12.7375 15.0833 16.9 15.7167C21.0625 16.35 23.925 20.2375 23.2917 24.4ZM14.9208 21.475C15.0125 20.8792 14.6042 20.325 14.0083 20.2333C13.4125 20.1417 12.8583 20.55 12.7667 21.1458C12.675 21.7417 13.0833 22.2958 13.6792 22.3875C14.275 22.4792 14.8292 22.0708 14.9208 21.475ZM19.2292 22.1292C19.3208 21.5333 18.9125 20.9792 18.3167 20.8875C17.7208 20.7958 17.1667 21.2042 17.075 21.8C16.9833 22.3958 17.3917 22.95 17.9875 23.0417C18.5833 23.1333 19.1375 22.725 19.2292 22.1292ZM13.3083 25.05L12.825 24.3917L11.5083 25.3583L11.9917 26.0167C13.5208 28.0917 16.4417 28.5375 18.5208 27.0083L19.1792 26.525L18.2125 25.2083L17.5542 25.6917C16.2042 26.6833 14.3042 26.3958 13.3125 25.0458L13.3083 25.05Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.8419 9.2748C18.7044 10.0498 15.9752 14.0331 16.7502 18.1748C17.5252 22.3123 21.5085 25.0415 25.646 24.2665C29.7835 23.4915 32.5169 19.5081 31.7419 15.3706C30.9669 11.2331 26.9794 8.50396 22.8419 9.2748ZM25.8835 13.6915C26.4752 13.579 27.0419 13.9706 27.1544 14.5623C27.2669 15.154 26.8752 15.7206 26.2835 15.8331C25.6919 15.9456 25.1252 15.554 25.0127 14.9623C24.9002 14.3706 25.2919 13.804 25.8835 13.6915ZM21.6002 14.4915C22.1919 14.379 22.7585 14.7706 22.871 15.3623C22.9835 15.954 22.5919 16.5206 22.0002 16.6331C21.4085 16.7456 20.8419 16.354 20.7294 15.7623C20.6169 15.1706 21.0085 14.604 21.6002 14.4915ZM25.2335 22.054C23.1585 22.4415 21.1669 21.079 20.7794 19.0123L28.2752 17.6081C28.6627 19.679 27.296 21.6665 25.2294 22.054H25.2335Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.2626 21.8997C22.021 21.4664 21.0418 20.3997 20.7835 19.0122L21.9418 18.7956C20.7876 17.1914 19.0126 16.0372 16.9043 15.7164C16.8376 15.7081 16.7668 15.6956 16.7001 15.6914C16.5793 16.4956 16.5918 17.3331 16.7501 18.1747C16.9418 19.1872 17.321 20.1122 17.8501 20.9247C17.996 20.8789 18.1585 20.8664 18.321 20.8914C18.9126 20.9831 19.3251 21.5372 19.2335 22.1331C19.2168 22.2414 19.1835 22.3456 19.1418 22.4372C20.2876 23.4706 21.7376 24.1497 23.3043 24.3414C23.4251 23.5081 23.4043 22.6872 23.2626 21.8997Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.2626 21.8997C22.021 21.4664 21.0418 20.3997 20.7835 19.0122L21.9418 18.7956C20.7876 17.1914 19.0126 16.0372 16.9043 15.7164C16.8376 15.7081 16.7668 15.6956 16.7001 15.6914C16.5793 16.4956 16.5918 17.3331 16.7501 18.1747C16.9418 19.1872 17.321 20.1122 17.8501 20.9247C17.996 20.8789 18.1585 20.8664 18.321 20.8914C18.9126 20.9831 19.3251 21.5372 19.2335 22.1331C19.2168 22.2414 19.1835 22.3456 19.1418 22.4372C20.2876 23.4706 21.7376 24.1497 23.3043 24.3414C23.4251 23.5081 23.4043 22.6872 23.2626 21.8997Z",
                fill: "#09326C"
            })
        ]
    });
const $22e783439409d5ca$export$c0094cf6ece486f3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.5832 13.6997H8.4165V16.9455H31.5832V13.6997Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.5832 26.6914H8.4165V29.9372H31.5832V26.6914Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.9248 29.9375V16.9458H10.1331V29.9375H13.9248Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.8955 29.9375V16.9458H18.1038V29.9375H21.8955Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.8291 29.9375V16.9458H26.0374V29.9375H29.8291Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.9998 8.4165L8.4165 16.9457H31.5832L19.9998 8.4165Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.5832 16.9455H8.4165L12.8248 13.6997H27.1748L31.5832 16.9455Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.9206 26.6958H10.1289V29.9375H13.9206V26.6958Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.8959 26.6958H18.1084V29.9375H21.8959V26.6958Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.8249 26.6958H26.0332V29.9375H29.8249V26.6958Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.9206 26.6958H10.1289V29.9375H13.9206V26.6958Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.8959 26.6958H18.1084V29.9375H21.8959V26.6958Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.8249 26.6958H26.0332V29.9375H29.8249V26.6958Z",
                fill: "#09326C"
            })
        ]
    });
const $22e783439409d5ca$export$526fd3870ee3978 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.9459 22.2458V19.8291C31.9459 19.2041 31.3793 18.6958 30.6751 18.6958H16.4334C15.7293 18.6958 15.1626 19.2 15.1626 19.8291V22.2458H31.9459Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.9459 23.8291H15.1626V28.8041C15.1626 29.425 15.7293 29.9375 16.4334 29.9375H30.6751C31.3793 29.9375 31.9459 29.4291 31.9459 28.8041V23.8291Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1002 13.4919V11.0752C25.1002 10.4502 24.5336 9.94189 23.8294 9.94189H9.58773C8.88356 9.94189 8.31689 10.4461 8.31689 11.0752V13.4919H25.1002Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1002 15.0752H8.31689V20.0502C8.31689 20.6711 8.88356 21.1836 9.58773 21.1836H23.8294C24.5336 21.1836 25.1002 20.6752 25.1002 20.0502V15.0752Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1001 18.6919V20.0461C25.1001 20.6711 24.5334 21.1836 23.8293 21.1836H15.1626V19.8294C15.1626 19.2002 15.7334 18.6919 16.4334 18.6919H25.1001Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1001 18.6919V20.0461C25.1001 20.6711 24.5334 21.1836 23.8293 21.1836H15.1626V19.8294C15.1626 19.2002 15.7334 18.6919 16.4334 18.6919H25.1001Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$6361c44213db83a2 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.1166 33.2749H9.8833V6.8374H20.1125L30.1166 16.6916V33.2749Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.1084 6.8374V16.6624H30.0876L20.1084 6.8374Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.6917 19.9043H20.1084V22.696H25.6917V19.9043Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.3874 23.1625C17.416 23.1625 18.2499 22.3286 18.2499 21.3C18.2499 20.2714 17.416 19.4375 16.3874 19.4375C15.3588 19.4375 14.5249 20.2714 14.5249 21.3C14.5249 22.3286 15.3588 23.1625 16.3874 23.1625Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.6917 26.9458H20.1084V29.7375H25.6917V26.9458Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.3874 30.204C17.416 30.204 18.2499 29.3701 18.2499 28.3415C18.2499 27.3129 17.416 26.479 16.3874 26.479C15.3588 26.479 14.5249 27.3129 14.5249 28.3415C14.5249 29.3701 15.3588 30.204 16.3874 30.204Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$b5a9699d43e96f3e = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.1792 9.18311V26.7998H26.7959V9.18311H9.1792ZM16.7292 12.9664H23.0209V14.8539H16.7292V12.9664ZM16.7292 17.0456H23.0209V18.9331H16.7292V17.0456ZM13.5875 12.6414C14.2792 12.6414 14.8459 13.2081 14.8459 13.8998C14.8459 14.5914 14.2792 15.1581 13.5875 15.1581C12.8959 15.1581 12.3292 14.5956 12.3292 13.8998C12.3292 13.2039 12.8917 12.6414 13.5875 12.6414ZM13.5875 16.7331C14.2792 16.7331 14.8459 17.2956 14.8459 17.9914C14.8459 18.6873 14.2792 19.2498 13.5875 19.2498C12.8959 19.2498 12.3292 18.6873 12.3292 17.9914C12.3292 17.2956 12.8917 16.7331 13.5875 16.7331Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.1873 20.0498V22.9706H16.729V28.9081H29.1873V32.4165L35.3665 26.229L29.1873 20.0498Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.729 22.9707V26.7999H26.7957V22.9707H16.729Z",
                fill: "#09326C"
            })
        ]
    });
const $22e783439409d5ca$export$9fe16602583dd125 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.2215 11.0342C12.574 11.0342 8 15.6127 8 21.2557C8 25.5094 10.5982 29.1586 14.2971 30.6968V28.2294C14.2971 26.0597 16.0563 24.305 18.2215 24.305C20.3867 24.305 22.1414 26.0642 22.1414 28.2294V30.6968C25.8403 29.1631 28.443 25.5139 28.443 21.2557C28.443 15.6081 23.8645 11.0342 18.2215 11.0342ZM18.2215 23.1998C16.3631 23.1998 14.8564 21.6932 14.8564 19.8348C14.8564 17.9763 16.3585 16.4697 18.2215 16.4697C20.0845 16.4697 21.5821 17.9718 21.5821 19.8348C21.5821 21.6977 20.08 23.1998 18.2215 23.1998Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.5408 12.9421L20.9321 14.7465L24.5408 16.5508L26.3451 20.1595L28.1494 16.5508L31.7581 14.7465L28.1494 12.9421L26.3451 9.3335L24.5408 12.9421Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.7034 17.4438L26.3456 20.1593L24.5413 16.5507L20.9326 14.7464L24.3202 13.0503C25.8178 14.169 26.9997 15.6846 27.7034 17.4438Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.3202 13.0503L20.9326 14.7464L24.5413 16.5507L26.3456 20.1593L27.7034 17.4438C26.9997 15.6846 25.8178 14.169 24.3202 13.0503Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$6c259bad890ba857 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.4626 15.5811H12.5376V38.4498H47.4626V15.5811Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M39.3811 41.581V45.4685H20.6187V41.581H26.8687V34.606H33.1311V41.581H39.3811Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.1312 34.606H26.8687V38.456H33.1312V34.606Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.0002 32.4438C32.9963 32.4438 35.4252 30.0149 35.4252 27.0188C35.4252 24.0226 32.9963 21.5938 30.0002 21.5938C27.0041 21.5938 24.5752 24.0226 24.5752 27.0188C24.5752 30.0149 27.0041 32.4438 30.0002 32.4438Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$50a598674e46acd6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0125 14.0562H26.8438L28.675 18.9499L33.8313 18.0937L36.7438 23.1437L33.425 27.1812L36.7438 31.2124L33.8313 36.2624L28.6812 35.4062L26.85 40.2999H21.0188L19.1875 35.4062L14.0375 36.2624L11.125 31.2124L14.4437 27.1812L11.125 23.1499L14.0375 18.0999L19.1938 18.9562L21.025 14.0624L21.0125 14.0562ZM23.925 32.0937C26.6437 32.0937 28.8438 29.8937 28.8438 27.1749C28.8438 24.4562 26.6437 22.2562 23.925 22.2562C21.2063 22.2562 19.0063 24.4562 19.0063 27.1749C19.0063 29.8937 21.2063 32.0937 23.925 32.0937Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M37.4435 25.6499H42.256L43.7685 29.6874L48.0247 28.9812L50.431 33.1499L47.6872 36.4812L50.4247 39.8124L48.0185 43.9812L43.7622 43.2749L42.2497 47.3124H37.4372L35.9247 43.2749L31.6685 43.9812L29.2622 39.8124L31.9997 36.4812L29.2622 33.1499L31.6685 28.9812L35.9247 29.6874L37.4372 25.6499H37.4435ZM39.8497 40.5437C42.0935 40.5437 43.9122 38.7249 43.9122 36.4812C43.9122 34.2374 42.0935 32.4187 39.8497 32.4187C37.606 32.4187 35.7872 34.2374 35.7872 36.4812C35.7872 38.7249 37.606 40.5437 39.8497 40.5437Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M33.4248 27.175L36.7436 23.1437L33.8311 18.0938L28.6748 18.95L26.8436 14.0625H21.0123L19.1748 18.95L14.0248 18.0938L11.1123 23.1437L14.4311 27.175L11.1123 31.2125L14.0248 36.2625L19.1748 35.4L21.0123 40.2938H26.8436L28.6748 35.4L31.5123 35.875L33.8311 36.2625L36.7436 31.2125L35.4186 29.6L33.4248 27.175ZM23.9248 32.0938C21.2123 32.0938 19.0061 29.8937 19.0061 27.175C19.0061 24.4563 21.2123 22.2563 23.9248 22.2563C26.6373 22.2563 28.8436 24.4625 28.8436 27.175C28.8436 29.8875 26.6436 32.0938 23.9248 32.0938Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.4186 29.5997L31.6748 28.981L29.2686 33.1497L31.5123 35.8747L33.8311 36.2622L36.7436 31.2122L35.4186 29.5997Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$bc46f4026380149b = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.5936 16.3623L30.9561 21.8186V36.3686L44.5936 41.8248V16.3623Z",
                fill: "#1868DA"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.45 22.7246V35.4371H27.3187V43.6371H21.8625V35.4371H16.4062V22.7246H34.45Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.4498 22.7246H30.9561V35.4309H34.4498V22.7246Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$2d48c6a000b33e3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.1437 31.6438C38.2437 31.0875 38.2938 30.4875 38.2938 29.8625C38.2938 29.2375 38.2438 28.625 38.1375 28.0563C37.5313 24.6875 35.1938 22.6125 31.9062 22.075C31.3438 21.9813 30.7563 21.9375 30.15 21.9375C29.5438 21.9375 28.9 21.9875 28.3188 22.0875C25.0375 22.6375 22.7 24.7063 22.0938 28.0563C21.9938 28.625 21.9375 29.225 21.9375 29.8625C21.9375 30.5 21.9875 31.0875 22.0875 31.6438C22.6875 34.9875 25.025 37.0625 28.3188 37.6125C28.9 37.7125 29.5125 37.7625 30.15 37.7625C30.7875 37.7625 31.35 37.7188 31.9062 37.625C35.1938 37.0875 37.5375 35.0125 38.1375 31.6438H38.1437Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.0562 28.9752L20.8062 12.2627L30.5562 28.9752H11.0562Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.7688 22.4878C24.3063 23.3503 22.5937 25.2565 22.0937 28.0565C22.0375 28.3565 22 28.6565 21.9688 28.9753H30.55L26.7688 22.4878Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.8748 31.3252H31.1748V45.0252H44.8748V31.3252Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.1748 31.3315V37.719C31.4248 37.694 31.6686 37.6628 31.9123 37.6253C35.1998 37.094 37.5373 35.0128 38.1436 31.644C38.1623 31.544 38.1811 31.4378 38.1936 31.3315H31.1748Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$d2da7b6954e156a3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M49.9125 27.1812H19.4688V42.0562H49.9125V27.1812Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.45 17.9438H10.0062V32.8188H40.45V17.9438Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.45 27.1812H19.4688V32.8187H40.45V27.1812Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.0249 22.9937L15.4687 29.5499L12.0812 26.0687L13.5437 24.6499L15.4937 26.6499L20.5874 21.5562L22.0312 22.9999L22.0249 22.9937Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M48.0187 32.5562L41.4625 39.1124L38.075 35.6312L39.5375 34.2124L41.4875 36.2124L46.5812 31.1187L48.025 32.5624L48.0187 32.5562Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$f6faf0bdc0af7562 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.7175 15.0458L31.5474 15.0729L33.6696 20.8132L39.7128 19.8342L43.1007 25.7626L39.1948 30.4761L43.0633 35.2131L39.6286 41.1144L33.6006 40.0877L31.433 45.811L24.6031 45.784L22.481 40.0437L16.445 41.0227L13.0572 35.0943L16.963 30.3881L13.0946 25.6511L16.5292 19.7498L22.5646 20.7766L24.7321 15.0532L24.7175 15.0458ZM28.0451 36.1858C31.2295 36.1985 33.8165 33.6319 33.8291 30.4475C33.8417 27.2632 31.2751 24.6762 28.0908 24.6636C24.9064 24.651 22.3195 27.2176 22.3068 30.4019C22.2942 33.5863 24.8608 36.1732 28.0451 36.1858Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.1945 30.4688L43.1003 25.7626L39.7124 19.8343L33.6691 20.8133L31.5469 15.0803L24.7171 15.0532L22.5422 20.7692L16.5142 19.7424L13.0795 25.6438L16.948 30.3808L13.0421 35.0943L16.43 41.0227L22.466 40.0363L24.5954 45.7767L31.4253 45.8037L33.5929 40.0804L36.9141 40.6499L39.6282 41.1145L43.0628 35.2132L41.5184 33.3184L39.1945 30.4688ZM28.0447 36.1859C24.8677 36.1733 22.2938 33.5863 22.3064 30.402C22.319 27.2176 24.9133 24.6511 28.0904 24.6637C31.2674 24.6763 33.8412 27.2706 33.8287 30.4476C33.8161 33.6246 31.2291 36.1985 28.0447 36.1859Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                style: {
                    mixBlendMode: 'multiply'
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M47.8907 37.0382C47.9632 36.635 47.9995 36.2 47.9995 35.7469C47.9995 35.2939 47.9632 34.8499 47.8862 34.4376C47.4467 31.9955 45.7522 30.4913 43.3691 30.1016C42.9613 30.0337 42.5354 30.002 42.0959 30.002C41.6564 30.002 41.1898 30.0382 40.7684 30.1107C38.3898 30.5094 36.6953 32.0091 36.2558 34.4376C36.1833 34.8499 36.1425 35.2848 36.1425 35.7469C36.1425 36.2091 36.1787 36.635 36.2512 37.0382C36.6862 39.4622 38.3807 40.9664 40.7684 41.3651C41.1898 41.4376 41.6338 41.4738 42.0959 41.4738C42.558 41.4738 42.9658 41.4421 43.3691 41.3741C45.7522 40.9845 47.4513 39.4803 47.8862 37.0382H47.8907Z",
                    fill: "#0C66E4"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.4038 30.4282L43.0336 34.8731L43.2603 35.1511L39.8256 41.0523L39.7036 41.0316L39.6768 41.027C37.8703 40.3987 36.6167 39.0117 36.2514 36.976C36.1789 36.5728 36.1426 36.1469 36.1426 35.6848C36.1426 35.2226 36.1834 34.7877 36.2559 34.3754C36.6058 32.442 37.7511 31.0973 39.4038 30.4282Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M46.0498 34.0153L41.2133 38.6462L38.7144 36.1873L39.7932 35.1852L41.2317 36.5978L44.9894 33L46.0544 34.0198L46.0498 34.0153Z",
                fill: "white"
            })
        ]
    });
const $22e783439409d5ca$export$edf22519467780de = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0312 21.25V47.125L22.525 40.7H45.0187V21.25H15.0312Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.35 22.0186C28.35 20.1623 29.8312 18.6748 31.6625 18.6748C33.4937 18.6748 34.975 20.1561 34.975 22.0186C34.975 22.9623 34.75 23.3936 34.5437 23.6686C34.3 23.9873 33.9937 24.2123 33.4562 24.6061C33.3687 24.6748 33.2687 24.7436 33.1625 24.8186C32.4937 25.3123 31.6437 25.9873 31.0062 27.1061C30.3625 28.2311 30.0062 29.6436 30.0062 31.5123H33.3187C33.3187 30.0623 33.5875 29.2561 33.875 28.7623C34.1625 28.2561 34.5562 27.9123 35.1312 27.4873C35.2 27.4373 35.275 27.3811 35.3562 27.3248C35.875 26.9498 36.6125 26.4186 37.1687 25.6873C37.8875 24.7498 38.2875 23.5748 38.2875 22.0186C38.2875 18.3561 35.35 15.3623 31.6625 15.3623C27.975 15.3623 25.0375 18.3561 25.0375 22.0186V23.6748H28.35V22.0186Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.6625 34.0059C30.5188 34.0059 29.5938 34.9309 29.5938 36.0746C29.5938 37.2184 30.5188 38.1434 31.6625 38.1434C32.8063 38.1434 33.7313 37.2184 33.7313 36.0746C33.7313 34.9309 32.8063 34.0059 31.6625 34.0059Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.075 21.25H28.4375C28.375 21.4937 28.3437 21.7562 28.3437 22.0187V23.675H25.0312V22.0187C25.0312 21.7625 25.0437 21.5062 25.075 21.25Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M33.7313 36.0751C33.7313 37.2188 32.8063 38.1501 31.6625 38.1501C30.5188 38.1501 29.5875 37.2188 29.5875 36.0751C29.5875 34.9313 30.5188 34.0063 31.6625 34.0063C32.8063 34.0063 33.7313 34.9313 33.7313 36.0751Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M38.2875 22.0187C38.2875 23.5812 37.8875 24.75 37.1687 25.6875C36.6125 26.4187 35.875 26.95 35.3562 27.325C35.275 27.3875 35.2 27.4375 35.1312 27.4875C34.5562 27.9187 34.1625 28.2625 33.875 28.7687C33.5875 29.2687 33.3187 30.075 33.3187 31.5188H30.0062C30.0062 29.65 30.3562 28.2375 31 27.1187C31.6437 26 32.4937 25.325 33.1562 24.825C33.2625 24.75 33.3625 24.6813 33.45 24.6125C33.9937 24.2125 34.2937 23.9938 34.5375 23.675C34.75 23.3938 34.975 22.9625 34.975 22.0187C34.975 21.7562 34.9437 21.4937 34.8812 21.25H38.2437C38.275 21.5062 38.2875 21.7625 38.2875 22.0187Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$8c7409f1554738f7 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_1_5039)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M42.8564 17.6187H18.0564V50.0187H42.8564V17.6187Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.5249 43.3753C25.5249 40.519 27.8374 38.2065 30.6937 38.2065C33.5499 38.2065 35.8624 40.519 35.8624 43.3753V50.019H25.5249V43.3753Z",
                        fill: "#164B35"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M35.125 31.5626C35.125 34.0063 33.1437 35.9938 30.6937 35.9938C28.2437 35.9938 26.2625 34.0126 26.2625 31.5626C26.2625 29.1126 28.2437 27.1313 30.6937 27.1313C33.1437 27.1313 35.125 29.1126 35.125 31.5626Z",
                        fill: "#164B35"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M39.3624 14.9313V22.6251H21.5437V14.9313H26.7812C26.7812 12.9001 28.425 11.2563 30.4562 11.2563C32.4875 11.2563 34.1249 12.9001 34.1249 14.9313H39.3624Z",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M39.3624 17.6187H21.5437V22.6249H39.3624V17.6187Z",
                        fill: "#164B35"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_1_5039",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $22e783439409d5ca$export$b20b85b1cb35523d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_1_4707)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.9375 36.6C33.9875 42.8438 28.1563 47.1375 21.9125 46.1875C15.6688 45.2375 11.375 39.4063 12.325 33.1625C13.275 26.9188 19.1063 22.625 25.35 23.575C31.5938 24.525 35.8875 30.3563 34.9375 36.6ZM22.3813 32.2125C22.5188 31.3188 21.9062 30.4875 21.0125 30.35C20.1188 30.2125 19.2875 30.825 19.15 31.7188C19.0125 32.6125 19.625 33.4438 20.5188 33.5813C21.4125 33.7188 22.2438 33.1063 22.3813 32.2125ZM28.8438 33.1938C28.9813 32.3 28.3688 31.4688 27.475 31.3313C26.5813 31.1938 25.75 31.8063 25.6125 32.7C25.475 33.5938 26.0875 34.425 26.9813 34.5625C27.875 34.7 28.7063 34.0875 28.8438 33.1938ZM19.9625 37.575L19.2375 36.5875L17.2625 38.0375L17.9875 39.025C20.2813 42.1375 24.6625 42.8063 27.7813 40.5125L28.7688 39.7875L27.3188 37.8125L26.3313 38.5375C24.3063 40.025 21.4563 39.5938 19.9688 37.5688L19.9625 37.575Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.2625 13.9127C28.0563 15.0752 23.9625 21.0502 25.125 27.2627C26.2875 33.4689 32.2625 37.5627 38.4688 36.4002C44.675 35.2377 48.775 29.2627 47.6125 23.0564C46.45 16.8502 40.4688 12.7564 34.2625 13.9127ZM38.825 20.5377C39.7125 20.3689 40.5625 20.9564 40.7313 21.8439C40.9 22.7314 40.3125 23.5814 39.425 23.7502C38.5375 23.9189 37.6875 23.3314 37.5188 22.4439C37.35 21.5564 37.9375 20.7064 38.825 20.5377ZM32.4 21.7377C33.2875 21.5689 34.1375 22.1564 34.3063 23.0439C34.475 23.9314 33.8875 24.7814 33 24.9502C32.1125 25.1189 31.2625 24.5314 31.0938 23.6439C30.925 22.7564 31.5125 21.9064 32.4 21.7377ZM37.85 33.0814C34.7375 33.6627 31.75 31.6189 31.1688 28.5189L42.4125 26.4127C42.9938 29.5189 40.9438 32.5002 37.8438 33.0814H37.85Z",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.894 32.8501C33.0315 32.2001 31.5627 30.6001 31.1752 28.5188L32.9127 28.1938C31.1815 25.7876 28.519 24.0563 25.3565 23.5751C25.2565 23.5626 25.1502 23.5438 25.0502 23.5376C24.869 24.7438 24.8877 26.0001 25.1252 27.2626C25.4127 28.7813 25.9815 30.1688 26.7752 31.3876C26.994 31.3188 27.2377 31.3001 27.4815 31.3376C28.369 31.4751 28.9877 32.3063 28.8502 33.2001C28.8252 33.3626 28.7752 33.5188 28.7127 33.6563C30.4315 35.2063 32.6065 36.2251 34.9565 36.5126C35.1377 35.2626 35.1065 34.0313 34.894 32.8501Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.894 32.8501C33.0315 32.2001 31.5627 30.6001 31.1752 28.5188L32.9127 28.1938C31.1815 25.7876 28.519 24.0563 25.3565 23.5751C25.2565 23.5626 25.1502 23.5438 25.0502 23.5376C24.869 24.7438 24.8877 26.0001 25.1252 27.2626C25.4127 28.7813 25.9815 30.1688 26.7752 31.3876C26.994 31.3188 27.2377 31.3001 27.4815 31.3376C28.369 31.4751 28.9877 32.3063 28.8502 33.2001C28.8252 33.3626 28.7752 33.5188 28.7127 33.6563C30.4315 35.2063 32.6065 36.2251 34.9565 36.5126C35.1377 35.2626 35.1065 34.0313 34.894 32.8501Z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_1_4707",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $22e783439409d5ca$export$ab9f12136609e96a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_1_5503)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M48.375 20.5498H13.625V25.4186H48.375V20.5498Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M48.375 40.0376H13.625V44.9063H48.375V40.0376Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M21.8877 44.9064V25.4189H16.2002V44.9064H21.8877Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M33.8438 44.9064V25.4189H28.1562V44.9064H33.8438Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M45.7437 44.9064V25.4189H40.0562V44.9064H45.7437Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M31 12.625L13.625 25.4187H48.375L31 12.625Z",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M48.375 25.4186H13.625L20.2375 20.5498H41.7625L48.375 25.4186Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M21.8813 40.0439H16.1938V44.9064H21.8813V40.0439Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M33.8438 40.0439H28.1626V44.9064H33.8438V40.0439Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M45.7373 40.0439H40.0498V44.9064H45.7373V40.0439Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M21.8813 40.0439H16.1938V44.9064H21.8813V40.0439Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M33.8438 40.0439H28.1626V44.9064H33.8438V40.0439Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M45.7373 40.0439H40.0498V44.9064H45.7373V40.0439Z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_1_5503",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
const $22e783439409d5ca$export$8aaa0b75bd31bddc = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_1_6742)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M48.9187 33.369V29.7439C48.9187 28.8064 48.0687 28.0439 47.0124 28.0439H25.6499C24.5937 28.0439 23.7437 28.8002 23.7437 29.7439V33.369H48.9187Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M48.9187 35.744H23.7437V43.2064C23.7437 44.1377 24.5937 44.9064 25.6499 44.9064H47.0124C48.0687 44.9064 48.9187 44.1439 48.9187 43.2064V35.744Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.6501 20.2376V16.6126C38.6501 15.6751 37.8001 14.9126 36.7438 14.9126H15.3813C14.3251 14.9126 13.4751 15.6688 13.4751 16.6126V20.2376H38.6501Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.6501 22.6126H13.4751V30.0751C13.4751 31.0063 14.3251 31.7751 15.3813 31.7751H36.7438C37.8001 31.7751 38.6501 31.0126 38.6501 30.0751V22.6126Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.6499 28.0376V30.0688C38.6499 31.0063 37.7999 31.7751 36.7437 31.7751H23.7437V29.7438C23.7437 28.8001 24.5999 28.0376 25.6499 28.0376H38.6499Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.6499 28.0376V30.0688C38.6499 31.0063 37.7999 31.7751 36.7437 31.7751H23.7437V29.7438C23.7437 28.8001 24.5999 28.0376 25.6499 28.0376H38.6499Z",
                        fill: "#AE2A19"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_1_6742",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
const $22e783439409d5ca$export$b61109ed43b719cd = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_1_5805)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M45.1752 49.9126H14.8252V10.2563H30.1689L45.1752 25.0376V49.9126Z",
                        fill: "#FCA700",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M30.1631 10.2563V24.9938H45.1318L30.1631 10.2563Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.5381 29.8564H30.1631V34.0439H38.5381V29.8564Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M24.5818 34.7438C26.1248 34.7438 27.3756 33.4929 27.3756 31.95C27.3756 30.4071 26.1248 29.1562 24.5818 29.1562C23.0389 29.1562 21.7881 30.4071 21.7881 31.95C21.7881 33.4929 23.0389 34.7438 24.5818 34.7438Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.5381 40.4189H30.1631V44.6064H38.5381V40.4189Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M24.5818 45.3062C26.1248 45.3062 27.3756 44.0554 27.3756 42.5125C27.3756 40.9696 26.1248 39.7188 24.5818 39.7188C23.0389 39.7188 21.7881 40.9696 21.7881 42.5125C21.7881 44.0554 23.0389 45.3062 24.5818 45.3062Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_1_5805",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $22e783439409d5ca$export$89158573528fcad1 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_1_6101)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.2686 13.7749V40.1999H40.6936V13.7749H14.2686ZM25.5936 19.4499H35.0311V22.2812H25.5936V19.4499ZM25.5936 25.5687H35.0311V28.3999H25.5936V25.5687ZM20.8811 18.9624C21.9186 18.9624 22.7686 19.8124 22.7686 20.8499C22.7686 21.8874 21.9186 22.7374 20.8811 22.7374C19.8436 22.7374 18.9936 21.8937 18.9936 20.8499C18.9936 19.8062 19.8373 18.9624 20.8811 18.9624ZM20.8811 25.0999C21.9186 25.0999 22.7686 25.9437 22.7686 26.9874C22.7686 28.0312 21.9186 28.8749 20.8811 28.8749C19.8436 28.8749 18.9936 28.0312 18.9936 26.9874C18.9936 25.9437 19.8373 25.0999 20.8811 25.0999Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M44.2812 30.0747V34.456H25.5938V43.3622H44.2812V48.6247L53.55 39.3435L44.2812 30.0747Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M25.5938 34.4561V40.1998H40.6937V34.4561H25.5938Z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_1_6101",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $22e783439409d5ca$export$2957996a5f53a712 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.8323 16.5508C19.3609 16.5508 12.5 23.4185 12.5 31.883C12.5 38.2636 16.3973 43.7375 21.9456 46.0447V42.3436C21.9456 39.0891 24.5845 36.457 27.8323 36.457C31.08 36.457 33.7121 39.0958 33.7121 42.3436V46.0447C39.2604 43.7442 43.1645 38.2704 43.1645 31.883C43.1645 23.4117 36.2968 16.5508 27.8323 16.5508ZM27.8323 34.7993C25.0446 34.7993 22.7847 32.5394 22.7847 29.7517C22.7847 26.964 25.0378 24.7041 27.8323 24.7041C30.6267 24.7041 32.8731 26.9572 32.8731 29.7517C32.8731 32.5461 30.6199 34.7993 27.8323 34.7993Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.3114 19.413L31.8984 22.1195L37.3114 24.826L40.0179 30.2389L42.7244 24.826L48.1374 22.1195L42.7244 19.413L40.0179 14L37.3114 19.413Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.0555 26.1655L40.0189 30.2388L37.3124 24.8258L31.8994 22.1193L36.9808 19.5752C39.2272 21.2532 41 23.5267 42.0555 26.1655Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.9808 19.5752L31.8994 22.1193L37.3124 24.8258L40.0189 30.2388L42.0555 26.1655C41 23.5267 39.2272 21.2532 36.9808 19.5752Z",
                fill: "#AE2A19"
            })
        ]
    });
const $22e783439409d5ca$export$cb277cd1c06981d4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$var$ITSupportGlyph, {})
    });
};
const $22e783439409d5ca$export$966748bc0ae8d9a2 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$var$DesignGlyph, {})
    });
};
const $22e783439409d5ca$export$ddb421af37c7fad5 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$a8475ed0ad467766, {})
    });
};
const $22e783439409d5ca$export$1c5b0383ec045924 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$var$SoftwareDevelopmentGlyph, {})
    });
};
const $22e783439409d5ca$export$711ab9ba848867b8 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$7a5074cf88127a64, {})
    });
};
const $22e783439409d5ca$export$162047bea11a6282 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$5a330511b92aac24, {})
    });
};
const $22e783439409d5ca$export$982ea2d26785cb86 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$2a1d70df8da1fa8a, {})
    });
};
const $22e783439409d5ca$export$76f950842b166c42 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$c3c91f9d6f32ce98, {})
    });
};
const $22e783439409d5ca$export$a8119f2277c08f44 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$a9941a16640f105a, {})
    });
};
const $22e783439409d5ca$export$ae563fd41f5cca8a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$b81d861c2dc0475e, {})
    });
};
const $22e783439409d5ca$export$e809d817369bee46 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$f2de52c1920eba82, {})
    });
};
const $22e783439409d5ca$export$3f7b13292eed3fe1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$816a17ab71a9c447, {})
    });
};
const $22e783439409d5ca$export$e142eb117e369c8f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$b6c5d967ad9baf32, {})
    });
};
const $22e783439409d5ca$export$a53784039f0a17d0 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$89a8de63b42b4bf7, {})
    });
};
const $22e783439409d5ca$export$d8b6fe79c3f35976 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$27ec4a87867305fc, {})
    });
};
const $22e783439409d5ca$export$86f8858d201b0f9e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$a9d1d41ede76da88, {})
    });
};
const $22e783439409d5ca$export$2037b55ec364c78 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$a10f1df78def0898, {})
    });
};
const $22e783439409d5ca$export$ddadca1ef61d72f4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$e6598341d5f08715, {})
    });
};
const $22e783439409d5ca$export$294977ef66033c05 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$10c57db1e3cf8326, {})
    });
};
const $22e783439409d5ca$export$f491740eeb057ed5 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$925c822e766a0944, {})
    });
};
const $22e783439409d5ca$export$8ab8d8da70776293 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$c0094cf6ece486f3, {})
    });
};
const $22e783439409d5ca$export$cf4b8a9193cf22e1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$526fd3870ee3978, {})
    });
};
const $22e783439409d5ca$export$fd9729397ff432bf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$6361c44213db83a2, {})
    });
};
const $22e783439409d5ca$export$a2e400cb60027285 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$b5a9699d43e96f3e, {})
    });
};
const $22e783439409d5ca$export$bace2d8ac2cf2caa = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$9fe16602583dd125, {})
    });
};
const $22e783439409d5ca$export$e11bc36dd8a99125 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$6c259bad890ba857, {})
    });
};
const $22e783439409d5ca$export$72976b44f07f811b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$50a598674e46acd6, {})
    });
};
const $22e783439409d5ca$export$bfad4d4e8f73e77e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$bc46f4026380149b, {})
    });
};
const $22e783439409d5ca$export$d3f781ec209b4fd7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$2d48c6a000b33e3, {})
    });
};
const $22e783439409d5ca$export$bababd42ef961024 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$d2da7b6954e156a3, {})
    });
};
const $22e783439409d5ca$export$6efd0fa33b4aa14d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$f6faf0bdc0af7562, {})
    });
};
const $22e783439409d5ca$export$6c12f9ab3896c60b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$edf22519467780de, {})
    });
};
const $22e783439409d5ca$export$6de851e46e3b87af = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$8c7409f1554738f7, {})
    });
};
const $22e783439409d5ca$export$ab663870e0e1a3cd = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$b20b85b1cb35523d, {})
    });
};
const $22e783439409d5ca$export$3fb457a290d0178f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$ab9f12136609e96a, {})
    });
};
const $22e783439409d5ca$export$1b11a71dd9d8f914 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$8aaa0b75bd31bddc, {})
    });
};
const $22e783439409d5ca$export$f2bd611053c3be8a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$b61109ed43b719cd, {})
    });
};
const $22e783439409d5ca$export$f7c6a6f312b0247 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$89158573528fcad1, {})
    });
};
const $22e783439409d5ca$export$f8101b6de63ddffb = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            $22e783439409d5ca$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($22e783439409d5ca$export$2957996a5f53a712, {})
    });
};

});


parcelRegister("17GU1", function(module, exports) {
$parcel$export(module.exports, "useAnchorLocalStorageTeamType", function () { return $a3f1d769d309a02f$export$c9702f0bb31ba3c1; });

var $28AH4 = parcelRequire("28AH4");
const $a3f1d769d309a02f$export$c9702f0bb31ba3c1 = ()=>{
    const { getAnchorLocalStorage: getAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    const anchorLocalStorage = getAnchorLocalStorage();
    if (anchorLocalStorage) try {
        const localStorageObj = JSON.parse(anchorLocalStorage);
        return $a3f1d769d309a02f$export$e1cfb7bf8d6e409(localStorageObj.team);
    } catch (e) {
        return undefined;
    }
    return undefined;
};
const $a3f1d769d309a02f$export$e1cfb7bf8d6e409 = (teamType)=>{
    switch(teamType){
        case 'Marketing':
            return 'marketing';
        case 'Operations':
            return 'operations';
        case 'HR':
            return 'human-resources';
        case 'Design':
            return 'design';
        case 'Program Management':
            return undefined;
        case 'Software Engineering':
            return 'software-engineering';
        case 'Customer Service':
            return 'customer-service';
        case 'Legal':
            return 'legal';
        case 'Finance':
            return `finance`;
        case 'Sales':
            return 'sales';
        case 'IT Support':
            return 'it-support';
        case 'Software Development':
            return 'software-development';
        default:
            return undefined;
    }
};

});
parcelRegister("28AH4", function(module, exports) {
$parcel$export(module.exports, "useAnchorLocalStorage", function () { return $3ab72abc0ded2a09$export$4f045d9519647348; });

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $gNr0R = parcelRequire("gNr0R");

var $2gCne = parcelRequire("2gCne");
const $3ab72abc0ded2a09$var$BXP_ANCHOR_COOKIE_NAME = 'bxp_gateway_anchor';
const $3ab72abc0ded2a09$var$GWP_LOCAL_STORAGE_NAME = 'onboarding-journey';
const $3ab72abc0ded2a09$var$COOKIE_EXPIRY = 604800; // 7 days
function $3ab72abc0ded2a09$export$4f045d9519647348(value) {
    (0, $1oC0p.useEffect)(()=>{
        updateLocalStorage(value);
    }, [
        value
    ]);
    return {
        getAnchorLocalStorage: ()=>{
            return (0, $gNr0R.isClient) && (0, $2gCne.getLocalStorage)($3ab72abc0ded2a09$var$GWP_LOCAL_STORAGE_NAME);
        },
        setAnchorLocalStorage: updateLocalStorage
    };
    /* Create or update localstorage.
   * create : Using bxp_anchor_cookie, if present, if not present, create with ampty anchor object {anchor: {}}
   * update : Using existing localstorage, or existing cookie and persona value passed.
   */ function updateLocalStorage(value) {
        if (0, $gNr0R.isClient) {
            const bxpGatewayAnchorCookie = (0, $6GqRO.default).get($3ab72abc0ded2a09$var$BXP_ANCHOR_COOKIE_NAME);
            const journeyLocalStorage = (0, $2gCne.getLocalStorage)($3ab72abc0ded2a09$var$GWP_LOCAL_STORAGE_NAME);
            try {
                const bxpGatewayAnchorObj = JSON.parse(bxpGatewayAnchorCookie || 'null');
                const currentLocalStorageObj = JSON.parse(journeyLocalStorage || 'null');
                const anchorStorage = currentLocalStorageObj ? {
                    ...currentLocalStorageObj,
                    ...value
                } : bxpGatewayAnchorObj ? {
                    anchor: {
                        name: bxpGatewayAnchorObj?.anchor,
                        type: bxpGatewayAnchorObj?.type
                    },
                    ...value
                } : {};
                (0, $2gCne.setLocalStorage)($3ab72abc0ded2a09$var$GWP_LOCAL_STORAGE_NAME, JSON.stringify(anchorStorage), $3ab72abc0ded2a09$var$COOKIE_EXPIRY);
            } catch (err) {
                console.error('Error creating local storage', err);
            }
        }
    }
}

});
parcelRegister("gNr0R", function(module, exports) {
$parcel$export(module.exports, "isClient", function () { return $d4359ad8d1e3f5d3$export$7383f122bf48ec30; });
const $d4359ad8d1e3f5d3$export$7383f122bf48ec30 = typeof window !== 'undefined' && typeof Document !== 'undefined' && typeof HTMLElement !== 'undefined';
function $d4359ad8d1e3f5d3$export$f65ca476c09acec0(node) {
    if (!node && typeof node !== 'undefined') return null;
    if (node) {
        if (node.ownerDocument) return node.ownerDocument;
        else if (typeof node.getRootNode === 'function') {
            const root = node.getRootNode();
            if (root && 'defaultView' in root) return root;
        }
    } else if (typeof document !== 'undefined') return document;
    return null;
}
function $d4359ad8d1e3f5d3$export$38b2d434cce3ea22(node) {
    if (!node && typeof node !== 'undefined') return null;
    if (node) {
        const document1 = $d4359ad8d1e3f5d3$export$f65ca476c09acec0(node);
        if (document1) return document1.defaultView;
    } else if (typeof window !== 'undefined') return window;
    else if (typeof document !== 'undefined') return document.defaultView;
    return null;
}
function $d4359ad8d1e3f5d3$export$b4f920f5692db1b8(node, type = Node) {
    if (node instanceof type) return true;
    const window1 = $d4359ad8d1e3f5d3$export$38b2d434cce3ea22(node);
    if (window1) type = window1[type.name] || type;
    return node instanceof type;
}
function $d4359ad8d1e3f5d3$export$20b9b571b379d631(node, predicate) {
    while(node){
        if (predicate(node)) return node;
        node = node.parentElement;
    }
    return null;
}
function $d4359ad8d1e3f5d3$export$f8c04f9996c8b964(node) {
    if (!$d4359ad8d1e3f5d3$export$7383f122bf48ec30) return null;
    if ($d4359ad8d1e3f5d3$export$b4f920f5692db1b8(node, Document)) node = node.documentElement;
    if (!$d4359ad8d1e3f5d3$export$b4f920f5692db1b8(node, HTMLElement)) return null;
    return $d4359ad8d1e3f5d3$export$20b9b571b379d631(node, (node)=>{
        const { overflowX: overflowX, overflowY: overflowY } = getComputedStyle(node);
        if (overflowX === 'scroll') return true;
        if (overflowY === 'scroll') return true;
        return false;
    });
}

});




parcelRegister("80kL5", function(module, exports) {
$parcel$export(module.exports, "isValidLocale", function () { return $40e2d193f6ccd214$export$b7c662043e31af59; });
$parcel$export(module.exports, "delocalizePathname", function () { return $40e2d193f6ccd214$export$44f112d5a3138d7; });
$parcel$export(module.exports, "isEqualUnlocalizedPathname", function () { return $40e2d193f6ccd214$export$ac1033a4026dfcef; });
const $40e2d193f6ccd214$var$isProductionEnvironment = true;
const $40e2d193f6ccd214$var$commonLocales = [
    'br',
    'de',
    'en',
    'es',
    'fr',
    'it',
    'ja',
    'ko',
    'nl',
    'pl',
    'ru',
    'zh'
];
const $40e2d193f6ccd214$var$nonProdLocales = [
    'xx',
    'zz'
];
const $40e2d193f6ccd214$var$VALID_LOCALES = $40e2d193f6ccd214$var$isProductionEnvironment ? $40e2d193f6ccd214$var$commonLocales : [
    ...$40e2d193f6ccd214$var$commonLocales,
    ...$40e2d193f6ccd214$var$nonProdLocales
];
const $40e2d193f6ccd214$export$b7c662043e31af59 = (locale)=>$40e2d193f6ccd214$var$VALID_LOCALES.includes(locale);
const $40e2d193f6ccd214$export$44f112d5a3138d7 = (pathname)=>{
    const regex = new RegExp(`^/(${$40e2d193f6ccd214$var$VALID_LOCALES.join('|')})`);
    return pathname.replace(regex, '');
};
const $40e2d193f6ccd214$export$ac1033a4026dfcef = (pathname_a, pathname_b)=>{
    if (!pathname_a || !pathname_b) return false;
    const a = $40e2d193f6ccd214$export$44f112d5a3138d7(pathname_a);
    const b = $40e2d193f6ccd214$export$44f112d5a3138d7(pathname_b);
    return a === b;
};

});

parcelRegister("6gQvZ", function(module, exports) {
$parcel$export(module.exports, "useEnglishLocale", function () { return $2a522fbc7fc1f56a$export$48374a0929d11425; });
$parcel$export(module.exports, "SentryIntlProvider", function () { return $2a522fbc7fc1f56a$export$9784340db4c235a8; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6Ml1x = parcelRequire("6Ml1x");
var $ipuAN = parcelRequire("ipuAN");
var $efPEs = parcelRequire("efPEs");
var $h2BNP = parcelRequire("h2BNP");
var $5KOHM = parcelRequire("5KOHM");
var $1jDl2 = parcelRequire("1jDl2");

var $9GLx2 = parcelRequire("9GLx2");
var $8e22h = parcelRequire("8e22h");

var $eV0Hm = parcelRequire("eV0Hm");
function $2a522fbc7fc1f56a$var$getRawCookie(name, allCookies) {
    const value = `; ${allCookies}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2 ? parts.pop() : undefined;
}
function $2a522fbc7fc1f56a$var$getEdgeTraceId(allCookies) {
    const edgeTraceIdValue = $2a522fbc7fc1f56a$var$getRawCookie('X-Experiments-Trace-Id', allCookies);
    if (edgeTraceIdValue) {
        // Get the portion before the next semicolon
        const cookieValue = edgeTraceIdValue.split(';').shift();
        return cookieValue;
    }
    return undefined;
}
function $2a522fbc7fc1f56a$var$getAnonymousId(allCookies) {
    const anonIdValue = $2a522fbc7fc1f56a$var$getRawCookie('ajs_anonymous_id', allCookies);
    if (anonIdValue) {
        // Get the portion before the next semicolon
        let cookieValue = anonIdValue.split(';').shift();
        // Check if cookieValue is not undefined and remove %22 before and 22% after
        if (cookieValue) cookieValue = cookieValue.replace(/%22/g, '');
        else console.log('Unable to retrieve a cookie value');
        return cookieValue;
    }
    return undefined;
}
function $2a522fbc7fc1f56a$export$48374a0929d11425() {
    try {
        const intl = (0, $8e22h.default)();
        return intl.locale === 'en';
    } catch (e) {
        console.error('Failed to determine current locale', e);
        return false;
    }
}
const $2a522fbc7fc1f56a$export$9784340db4c235a8 = (props)=>{
    (0, $1oC0p.useEffect)(()=>{
        $5KOHM.init({
            dsn: 'https://a48c5247caec7a2e0ad0b8ef86376ee1@o55978.ingest.sentry.io/4505919063457792',
            enabled: true,
            environment: "production",
            release: window.BUILD_KEY,
            dist: window.BUILD_KEY,
            integrations: [
                $6Ml1x.browserTracingIntegration(),
                $efPEs.extraErrorDataIntegration(),
                $h2BNP.featureFlagsIntegration()
            ],
            // Performance Monitoring
            tracesSampleRate: 1.0,
            // Capture 100% of the transactions, reduce in production!
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [
                'localhost',
                /^https:\/\/atlassian\.com/
            ],
            // https://github.com/getsentry/sentry-javascript/issues/2514#issuecomment-603971338
            beforeSend: (event, hint)=>{
                if (hint.originalException === 'Timeout') return null;
                // Filter out AbortErrors as they're expected when users navigate away
                // Check direct AbortError
                if (hint.originalException instanceof Error && hint.originalException.name === 'AbortError') return null;
                // Check for AbortError in message
                const errorMessage = String(event.exception?.values?.[0]?.value || '');
                if (errorMessage.includes('AbortError') || errorMessage.includes('The user aborted a request') || errorMessage.includes('user aborted')) return null;
                return event;
            },
            ignoreErrors: [
                /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/
            ]
        });
    }, []);
    try {
        // used to tag back first introduction of errors to a unique deploy / commit
        $1jDl2.setTag('BUILD_KEY', window.BUILD_KEY);
    } catch (e) {
        console.error('Failed to add BUILD KEY');
    }
    try {
        // used to help identify the route, page, and variant that the user is on.
        $1jDl2.setTag('entryName', window.entryName);
        $1jDl2.setTag('cmsPageVariant', window.cmsPageVariant);
    } catch (e) {
        console.error('Failed to add route info');
    }
    // Set the anonymousId tag for Sentry
    try {
        const anonymousId = $2a522fbc7fc1f56a$var$getAnonymousId(props.cookies ?? '');
        $1jDl2.setTag('anonymousId', anonymousId);
    } catch (e) {
        console.error('Failed to add anonymousId tag to Sentry');
    }
    // Set the edgeTraceId tag for Sentry
    try {
        const edgeTraceId = $2a522fbc7fc1f56a$var$getEdgeTraceId(props.cookies ?? '');
        $1jDl2.setTag('edgeTraceId', edgeTraceId);
    } catch (e) {
        console.error('Failed to add edgeTraceId tag to Sentry');
    }
    try {
        // Retrieve anonymousId from cookie
        const anonymousId = $2a522fbc7fc1f56a$var$getAnonymousId(props.cookies ?? '');
        const atlCohortId = (0, $eV0Hm.getAtlCohortId)(props.cookies) || -1;
        $1jDl2.setUser({
            anonymousId: anonymousId,
            atlCohortId: atlCohortId
        });
        $1jDl2.setTag('atlCohortId', atlCohortId);
    } catch (e) {
        console.error('Failed to add anonymousId and atlCohort tags to Sentry');
        console.error(e);
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)($ipuAN.ErrorBoundary, {
        //@ts-ignore
        beforeCapture: (scope)=>{
            scope.setTag('service', 'wac-web-fe');
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9GLx2.default), {
            locale: props.locale,
            messages: props.messages,
            children: props.children
        })
    });
};

});
parcelRegister("ipuAN", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", function () { return $d6724ad5e9d420a5$export$e926676385687eaf; });

var $i7nxO = parcelRequire("i7nxO");
var $3sWBL = parcelRequire("3sWBL");

var $9sRth = parcelRequire("9sRth");

var $1oC0p = parcelRequire("1oC0p");

var $62ZaW = parcelRequire("62ZaW");

var $4b0IP = parcelRequire("4b0IP");

var $3w6QS = parcelRequire("3w6QS");
const $d6724ad5e9d420a5$export$6ef4c0367e27f2d5 = 'unknown';
const $d6724ad5e9d420a5$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $d6724ad5e9d420a5$export$e926676385687eaf extends $1oC0p.Component {
    constructor(props){
        super(props);
        this.state = $d6724ad5e9d420a5$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $i7nxO.getClient)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $3sWBL.showReportDialog)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $i7nxO.withScope)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $4b0IP.captureReactException)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $3sWBL.showReportDialog)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $d6724ad5e9d420a5$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($d6724ad5e9d420a5$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === 'function' ? children() : children;
        const element = typeof fallback === 'function' ? $1oC0p.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($1oC0p.isValidElement(element)) return element;
        if (fallback) (0, $62ZaW.DEBUG_BUILD) && (0, $9sRth.logger).warn('fallback did not produce a valid ReactElement');
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d6724ad5e9d420a5$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $d6724ad5e9d420a5$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$1oC0p.createElement($d6724ad5e9d420a5$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $1oC0p.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $3w6QS.hoistNonReactStatics)(Wrapped, WrappedComponent);
    return Wrapped;
}

});
parcelRegister("62ZaW", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", function () { return $4672622d87f4ed2d$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4672622d87f4ed2d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("4b0IP", function(module, exports) {
$parcel$export(module.exports, "captureReactException", function () { return $30a8bfe7a91f6f41$export$270be4195468cda9; });

var $1jDl2 = parcelRequire("1jDl2");
var $i7nxO = parcelRequire("i7nxO");

var $86GZW = parcelRequire("86GZW");

var $1oC0p = parcelRequire("1oC0p");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $30a8bfe7a91f6f41$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $30a8bfe7a91f6f41$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $30a8bfe7a91f6f41$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($30a8bfe7a91f6f41$export$a87138b73900f5b((0, $1oC0p.version)) && (0, $86GZW.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $30a8bfe7a91f6f41$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $i7nxO.withScope)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $1jDl2.captureException)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $30a8bfe7a91f6f41$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $30a8bfe7a91f6f41$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}

});

parcelRegister("3w6QS", function(module, exports) {
$parcel$export(module.exports, "hoistNonReactStatics", function () { return $28f9acdeb2d7adf6$export$6c1f0397687d8b2; });

var $6PuZm = parcelRequire("6PuZm");
// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
const $28f9acdeb2d7adf6$export$6c1f0397687d8b2 = $6PuZm.default || $6PuZm;

});
parcelRegister("6PuZm", function(module, exports) {
'use strict';

var $eO4J3 = parcelRequire("eO4J3");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4f8f8b32dcac9cd9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4f8f8b32dcac9cd9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4f8f8b32dcac9cd9$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4f8f8b32dcac9cd9$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4f8f8b32dcac9cd9$var$TYPE_STATICS = {};
$4f8f8b32dcac9cd9$var$TYPE_STATICS[$eO4J3.ForwardRef] = $4f8f8b32dcac9cd9$var$FORWARD_REF_STATICS;
$4f8f8b32dcac9cd9$var$TYPE_STATICS[$eO4J3.Memo] = $4f8f8b32dcac9cd9$var$MEMO_STATICS;
function $4f8f8b32dcac9cd9$var$getStatics(component) {
    // React v16.11 and below
    if ($eO4J3.isMemo(component)) return $4f8f8b32dcac9cd9$var$MEMO_STATICS;
     // React v16.12 and above
    return $4f8f8b32dcac9cd9$var$TYPE_STATICS[component['$$typeof']] || $4f8f8b32dcac9cd9$var$REACT_STATICS;
}
var $4f8f8b32dcac9cd9$var$defineProperty = Object.defineProperty;
var $4f8f8b32dcac9cd9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4f8f8b32dcac9cd9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4f8f8b32dcac9cd9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4f8f8b32dcac9cd9$var$getPrototypeOf = Object.getPrototypeOf;
var $4f8f8b32dcac9cd9$var$objectPrototype = Object.prototype;
function $4f8f8b32dcac9cd9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($4f8f8b32dcac9cd9$var$objectPrototype) {
            var inheritedComponent = $4f8f8b32dcac9cd9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4f8f8b32dcac9cd9$var$objectPrototype) $4f8f8b32dcac9cd9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4f8f8b32dcac9cd9$var$getOwnPropertyNames(sourceComponent);
        if ($4f8f8b32dcac9cd9$var$getOwnPropertySymbols) keys = keys.concat($4f8f8b32dcac9cd9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4f8f8b32dcac9cd9$var$getStatics(targetComponent);
        var sourceStatics = $4f8f8b32dcac9cd9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4f8f8b32dcac9cd9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4f8f8b32dcac9cd9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4f8f8b32dcac9cd9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $4f8f8b32dcac9cd9$var$hoistNonReactStatics;

});
parcelRegister("eO4J3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2peoK"));

});
parcelRegister("2peoK", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", function () { return $1c0915c4a0004c08$export$2b8d127b894957b9; }, function (v) { return $1c0915c4a0004c08$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $1c0915c4a0004c08$export$cea3a54a6425200c; }, function (v) { return $1c0915c4a0004c08$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $1c0915c4a0004c08$export$a7c73072b1a182ae; }, function (v) { return $1c0915c4a0004c08$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $1c0915c4a0004c08$export$9f27bc3417b4524d; }, function (v) { return $1c0915c4a0004c08$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $1c0915c4a0004c08$export$db77ccec0bb4ccac; }, function (v) { return $1c0915c4a0004c08$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $1c0915c4a0004c08$export$8392c0c9d3dcbd35; }, function (v) { return $1c0915c4a0004c08$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1c0915c4a0004c08$export$ffb0004e005737fa; }, function (v) { return $1c0915c4a0004c08$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $1c0915c4a0004c08$export$b624eff549462981; }, function (v) { return $1c0915c4a0004c08$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $1c0915c4a0004c08$export$7897aa7841a5380c; }, function (v) { return $1c0915c4a0004c08$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $1c0915c4a0004c08$export$602eac185826482c; }, function (v) { return $1c0915c4a0004c08$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $1c0915c4a0004c08$export$e2c29f18771995cb; }, function (v) { return $1c0915c4a0004c08$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1c0915c4a0004c08$export$5f8d39834fd61797; }, function (v) { return $1c0915c4a0004c08$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1c0915c4a0004c08$export$74bf444e3cd11ea5; }, function (v) { return $1c0915c4a0004c08$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $1c0915c4a0004c08$export$92387174baf9b227; }, function (v) { return $1c0915c4a0004c08$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $1c0915c4a0004c08$export$ec112efeb987d9c6; }, function (v) { return $1c0915c4a0004c08$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $1c0915c4a0004c08$export$b706b080d889d2c9; }, function (v) { return $1c0915c4a0004c08$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $1c0915c4a0004c08$export$5be5a87408f70ddc; }, function (v) { return $1c0915c4a0004c08$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $1c0915c4a0004c08$export$45a5e7f76e0caa8d; }, function (v) { return $1c0915c4a0004c08$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $1c0915c4a0004c08$export$455c2e768291efa6; }, function (v) { return $1c0915c4a0004c08$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $1c0915c4a0004c08$export$9522e17588c12572; }, function (v) { return $1c0915c4a0004c08$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $1c0915c4a0004c08$export$2110ac352bb060b9; }, function (v) { return $1c0915c4a0004c08$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $1c0915c4a0004c08$export$56885ab8b9c456ab; }, function (v) { return $1c0915c4a0004c08$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $1c0915c4a0004c08$export$d927fcb6adf8f9de; }, function (v) { return $1c0915c4a0004c08$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $1c0915c4a0004c08$export$b82d16f27459e05a; }, function (v) { return $1c0915c4a0004c08$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $1c0915c4a0004c08$export$522c17b4f5e123e8; }, function (v) { return $1c0915c4a0004c08$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $1c0915c4a0004c08$export$1aabd8a0274ecfd6; }, function (v) { return $1c0915c4a0004c08$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $1c0915c4a0004c08$export$9b621391a187a31a; }, function (v) { return $1c0915c4a0004c08$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $1c0915c4a0004c08$export$f5bbd400c2f4426f; }, function (v) { return $1c0915c4a0004c08$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c0915c4a0004c08$export$2b8d127b894957b9;
var $1c0915c4a0004c08$export$cea3a54a6425200c;
var $1c0915c4a0004c08$export$a7c73072b1a182ae;
var $1c0915c4a0004c08$export$9f27bc3417b4524d;
var $1c0915c4a0004c08$export$db77ccec0bb4ccac;
var $1c0915c4a0004c08$export$8392c0c9d3dcbd35;
var $1c0915c4a0004c08$export$ffb0004e005737fa;
var $1c0915c4a0004c08$export$b624eff549462981;
var $1c0915c4a0004c08$export$7897aa7841a5380c;
var $1c0915c4a0004c08$export$602eac185826482c;
var $1c0915c4a0004c08$export$e2c29f18771995cb;
var $1c0915c4a0004c08$export$5f8d39834fd61797;
var $1c0915c4a0004c08$export$74bf444e3cd11ea5;
var $1c0915c4a0004c08$export$92387174baf9b227;
var $1c0915c4a0004c08$export$ec112efeb987d9c6;
var $1c0915c4a0004c08$export$b706b080d889d2c9;
var $1c0915c4a0004c08$export$5be5a87408f70ddc;
var $1c0915c4a0004c08$export$45a5e7f76e0caa8d;
var $1c0915c4a0004c08$export$455c2e768291efa6;
var $1c0915c4a0004c08$export$9522e17588c12572;
var $1c0915c4a0004c08$export$2110ac352bb060b9;
var $1c0915c4a0004c08$export$56885ab8b9c456ab;
var $1c0915c4a0004c08$export$d927fcb6adf8f9de;
var $1c0915c4a0004c08$export$b82d16f27459e05a;
var $1c0915c4a0004c08$export$522c17b4f5e123e8;
var $1c0915c4a0004c08$export$1aabd8a0274ecfd6;
var $1c0915c4a0004c08$export$9b621391a187a31a;
var $1c0915c4a0004c08$export$f5bbd400c2f4426f;
'use strict';
var $1c0915c4a0004c08$var$b = "function" === typeof Symbol && Symbol.for, $1c0915c4a0004c08$var$c = $1c0915c4a0004c08$var$b ? Symbol.for("react.element") : 60103, $1c0915c4a0004c08$var$d = $1c0915c4a0004c08$var$b ? Symbol.for("react.portal") : 60106, $1c0915c4a0004c08$var$e = $1c0915c4a0004c08$var$b ? Symbol.for("react.fragment") : 60107, $1c0915c4a0004c08$var$f = $1c0915c4a0004c08$var$b ? Symbol.for("react.strict_mode") : 60108, $1c0915c4a0004c08$var$g = $1c0915c4a0004c08$var$b ? Symbol.for("react.profiler") : 60114, $1c0915c4a0004c08$var$h = $1c0915c4a0004c08$var$b ? Symbol.for("react.provider") : 60109, $1c0915c4a0004c08$var$k = $1c0915c4a0004c08$var$b ? Symbol.for("react.context") : 60110, $1c0915c4a0004c08$var$l = $1c0915c4a0004c08$var$b ? Symbol.for("react.async_mode") : 60111, $1c0915c4a0004c08$var$m = $1c0915c4a0004c08$var$b ? Symbol.for("react.concurrent_mode") : 60111, $1c0915c4a0004c08$var$n = $1c0915c4a0004c08$var$b ? Symbol.for("react.forward_ref") : 60112, $1c0915c4a0004c08$var$p = $1c0915c4a0004c08$var$b ? Symbol.for("react.suspense") : 60113, $1c0915c4a0004c08$var$q = $1c0915c4a0004c08$var$b ? Symbol.for("react.suspense_list") : 60120, $1c0915c4a0004c08$var$r = $1c0915c4a0004c08$var$b ? Symbol.for("react.memo") : 60115, $1c0915c4a0004c08$var$t = $1c0915c4a0004c08$var$b ? Symbol.for("react.lazy") : 60116, $1c0915c4a0004c08$var$v = $1c0915c4a0004c08$var$b ? Symbol.for("react.block") : 60121, $1c0915c4a0004c08$var$w = $1c0915c4a0004c08$var$b ? Symbol.for("react.fundamental") : 60117, $1c0915c4a0004c08$var$x = $1c0915c4a0004c08$var$b ? Symbol.for("react.responder") : 60118, $1c0915c4a0004c08$var$y = $1c0915c4a0004c08$var$b ? Symbol.for("react.scope") : 60119;
function $1c0915c4a0004c08$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $1c0915c4a0004c08$var$c:
                switch(a = a.type, a){
                    case $1c0915c4a0004c08$var$l:
                    case $1c0915c4a0004c08$var$m:
                    case $1c0915c4a0004c08$var$e:
                    case $1c0915c4a0004c08$var$g:
                    case $1c0915c4a0004c08$var$f:
                    case $1c0915c4a0004c08$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1c0915c4a0004c08$var$k:
                            case $1c0915c4a0004c08$var$n:
                            case $1c0915c4a0004c08$var$t:
                            case $1c0915c4a0004c08$var$r:
                            case $1c0915c4a0004c08$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $1c0915c4a0004c08$var$d:
                return u;
        }
    }
}
function $1c0915c4a0004c08$var$A(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$m;
}
$1c0915c4a0004c08$export$2b8d127b894957b9 = $1c0915c4a0004c08$var$l;
$1c0915c4a0004c08$export$cea3a54a6425200c = $1c0915c4a0004c08$var$m;
$1c0915c4a0004c08$export$a7c73072b1a182ae = $1c0915c4a0004c08$var$k;
$1c0915c4a0004c08$export$9f27bc3417b4524d = $1c0915c4a0004c08$var$h;
$1c0915c4a0004c08$export$db77ccec0bb4ccac = $1c0915c4a0004c08$var$c;
$1c0915c4a0004c08$export$8392c0c9d3dcbd35 = $1c0915c4a0004c08$var$n;
$1c0915c4a0004c08$export$ffb0004e005737fa = $1c0915c4a0004c08$var$e;
$1c0915c4a0004c08$export$b624eff549462981 = $1c0915c4a0004c08$var$t;
$1c0915c4a0004c08$export$7897aa7841a5380c = $1c0915c4a0004c08$var$r;
$1c0915c4a0004c08$export$602eac185826482c = $1c0915c4a0004c08$var$d;
$1c0915c4a0004c08$export$e2c29f18771995cb = $1c0915c4a0004c08$var$g;
$1c0915c4a0004c08$export$5f8d39834fd61797 = $1c0915c4a0004c08$var$f;
$1c0915c4a0004c08$export$74bf444e3cd11ea5 = $1c0915c4a0004c08$var$p;
$1c0915c4a0004c08$export$92387174baf9b227 = function(a) {
    return $1c0915c4a0004c08$var$A(a) || $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$l;
};
$1c0915c4a0004c08$export$ec112efeb987d9c6 = $1c0915c4a0004c08$var$A;
$1c0915c4a0004c08$export$b706b080d889d2c9 = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$k;
};
$1c0915c4a0004c08$export$5be5a87408f70ddc = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$h;
};
$1c0915c4a0004c08$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c0915c4a0004c08$var$c;
};
$1c0915c4a0004c08$export$455c2e768291efa6 = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$n;
};
$1c0915c4a0004c08$export$9522e17588c12572 = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$e;
};
$1c0915c4a0004c08$export$2110ac352bb060b9 = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$t;
};
$1c0915c4a0004c08$export$56885ab8b9c456ab = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$r;
};
$1c0915c4a0004c08$export$d927fcb6adf8f9de = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$d;
};
$1c0915c4a0004c08$export$b82d16f27459e05a = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$g;
};
$1c0915c4a0004c08$export$522c17b4f5e123e8 = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$f;
};
$1c0915c4a0004c08$export$1aabd8a0274ecfd6 = function(a) {
    return $1c0915c4a0004c08$var$z(a) === $1c0915c4a0004c08$var$p;
};
$1c0915c4a0004c08$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1c0915c4a0004c08$var$e || a === $1c0915c4a0004c08$var$m || a === $1c0915c4a0004c08$var$g || a === $1c0915c4a0004c08$var$f || a === $1c0915c4a0004c08$var$p || a === $1c0915c4a0004c08$var$q || "object" === typeof a && null !== a && (a.$$typeof === $1c0915c4a0004c08$var$t || a.$$typeof === $1c0915c4a0004c08$var$r || a.$$typeof === $1c0915c4a0004c08$var$h || a.$$typeof === $1c0915c4a0004c08$var$k || a.$$typeof === $1c0915c4a0004c08$var$n || a.$$typeof === $1c0915c4a0004c08$var$w || a.$$typeof === $1c0915c4a0004c08$var$x || a.$$typeof === $1c0915c4a0004c08$var$y || a.$$typeof === $1c0915c4a0004c08$var$v);
};
$1c0915c4a0004c08$export$f5bbd400c2f4426f = $1c0915c4a0004c08$var$z;

});





parcelRegister("efPEs", function(module, exports) {
$parcel$export(module.exports, "extraErrorDataIntegration", function () { return $a60a88524ce0b036$export$6e0872131894301d; });

var $4YMns = parcelRequire("4YMns");

var $9Gtbp = parcelRequire("9Gtbp");

var $86GZW = parcelRequire("86GZW");

var $9sRth = parcelRequire("9sRth");

var $lvx9g = parcelRequire("lvx9g");

var $3eJmu = parcelRequire("3eJmu");

var $gUnvu = parcelRequire("gUnvu");
const $a60a88524ce0b036$var$INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */ const $a60a88524ce0b036$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $a60a88524ce0b036$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength = 250 } = client.getOptions();
            return $a60a88524ce0b036$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $a60a88524ce0b036$export$6e0872131894301d = (0, $9Gtbp.defineIntegration)($a60a88524ce0b036$var$_extraErrorDataIntegration);
function $a60a88524ce0b036$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !(0, $86GZW.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $a60a88524ce0b036$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $lvx9g.normalize)(errorData, depth);
        if ((0, $86GZW.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $3eJmu.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $a60a88524ce0b036$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $86GZW.isError)(value) || typeof value === 'string' ? (0, $gUnvu.truncate)(`${value}`, maxValueLength) : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $86GZW.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $86GZW.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $4YMns.DEBUG_BUILD) && (0, $9sRth.logger).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});

parcelRegister("h2BNP", function(module, exports) {
$parcel$export(module.exports, "featureFlagsIntegration", function () { return $c67ff26a182e8064$export$82a435367bc83944; });

var $9Gtbp = parcelRequire("9Gtbp");

var $f0x8H = parcelRequire("f0x8H");
/**
 * Sentry integration for buffering feature flags manually with an API, and
 * capturing them on error events. We recommend you do this on each flag
 * evaluation. Flags are buffered per Sentry scope and limited to 100 per event.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import { type FeatureFlagsIntegration } from '@sentry/browser';
 *
 * // Setup
 * Sentry.init(..., integrations: [Sentry.featureFlagsIntegration()])
 *
 * // Verify
 * const flagsIntegration = Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>('FeatureFlags');
 * if (flagsIntegration) {
 *   flagsIntegration.addFeatureFlag('my-flag', true);
 * } else {
 *   // check your setup
 * }
 * Sentry.captureException(Exception('broke')); // 'my-flag' should be captured to this Sentry event.
 * ```
 */ const $c67ff26a182e8064$export$82a435367bc83944 = (0, $9Gtbp.defineIntegration)(()=>{
    return {
        name: 'FeatureFlags',
        processEvent (event, _hint, _client) {
            return (0, $f0x8H.copyFlagsFromScopeToEvent)(event);
        },
        addFeatureFlag (name, value) {
            (0, $f0x8H.insertFlagToScope)(name, value);
        }
    };
});

});
parcelRegister("f0x8H", function(module, exports) {
$parcel$export(module.exports, "copyFlagsFromScopeToEvent", function () { return $aed08fe6cd5bc89d$export$3f36d80a1ce833bc; });
$parcel$export(module.exports, "insertFlagToScope", function () { return $aed08fe6cd5bc89d$export$7f29556d51128184; });

var $i7nxO = parcelRequire("i7nxO");
var $9sRth = parcelRequire("9sRth");

var $61ZAj = parcelRequire("61ZAj");
/**
 * Ordered LRU cache for storing feature flags in the scope context. The name
 * of each flag in the buffer is unique, and the output of getAll() is ordered
 * from oldest to newest.
 */ /**
 * Max size of the LRU flag buffer stored in Sentry scope and event contexts.
 */ const $aed08fe6cd5bc89d$export$b05e0452e895457f = 100;
/**
 * Copies feature flags that are in current scope context to the event context
 */ function $aed08fe6cd5bc89d$export$3f36d80a1ce833bc(event) {
    const scope = (0, $i7nxO.getCurrentScope)();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === undefined) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
/**
 * Creates a feature flags values array in current context if it does not exist
 * and inserts the flag into a FeatureFlag array while maintaining ordered LRU
 * properties. Not thread-safe. After inserting:
 * - `flags` is sorted in order of recency, with the newest flag at the end.
 * - No other flags with the same name exist in `flags`.
 * - The length of `flags` does not exceed `maxSize`. The oldest flag is evicted
 *  as needed.
 *
 * @param name     Name of the feature flag to insert.
 * @param value    Value of the feature flag.
 * @param maxSize  Max number of flags the buffer should store. It's recommended
 *   to keep this consistent across insertions. Default is FLAG_BUFFER_SIZE
 */ function $aed08fe6cd5bc89d$export$7f29556d51128184(name, value, maxSize = $aed08fe6cd5bc89d$export$b05e0452e895457f) {
    const scopeContexts = (0, $i7nxO.getCurrentScope)().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $aed08fe6cd5bc89d$export$af975e54ae906042(flags, name, value, maxSize);
}
/**
 * Exported for tests. Currently only accepts boolean values (otherwise no-op).
 */ function $aed08fe6cd5bc89d$export$af975e54ae906042(flags, name, value, maxSize) {
    if (typeof value !== 'boolean') return;
    if (flags.length > maxSize) {
        (0, $61ZAj.DEBUG_BUILD) && (0, $9sRth.logger).error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    // Check if the flag is already in the buffer - O(n)
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) // The flag was found, remove it from its current position - O(n)
    flags.splice(index, 1);
    if (flags.length === maxSize) // If at capacity, pop the earliest flag - O(n)
    flags.shift();
    // Push the flag to the end - O(1)
    flags.push({
        flag: name,
        result: value
    });
}

});


parcelRegister("5KOHM", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $43089496b3b4c091$export$2cd8252107eb640b; });

var $3sWBL = parcelRequire("3sWBL");
var $1jDl2 = parcelRequire("1jDl2");

var $ctUCS = parcelRequire("ctUCS");

var $1oC0p = parcelRequire("1oC0p");
/**
 * Inits the React SDK
 */ function $43089496b3b4c091$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $ctUCS.applySdkMetadata)(opts, 'react');
    (0, $1jDl2.setContext)('react', {
        version: $1oC0p.version
    });
    return (0, $3sWBL.init)(opts);
}

});

parcelRegister("9GLx2", function(module, exports) {
$parcel$export(module.exports, "createIntl", function () { return $70dce822108c0a0f$export$7e4cbedfdd7b4c0d; });
$parcel$export(module.exports, "default", function () { return $70dce822108c0a0f$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $iZHH7 = parcelRequire("iZHH7");

var $4Hf5k = parcelRequire("4Hf5k");

var $ejHIf = parcelRequire("ejHIf");
var $bceAk = parcelRequire("bceAk");
var $8xwAh = parcelRequire("8xwAh");

var $hjTVN = parcelRequire("hjTVN");
function $70dce822108c0a0f$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $70dce822108c0a0f$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $hjTVN.isFormatXMLElementFn)(v) ? (0, $4Hf5k.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $70dce822108c0a0f$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $70dce822108c0a0f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $8xwAh.formatMessage).apply(void 0, (0, $d3IQL.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $1oC0p.Children.toArray(chunks);
    return chunks;
};
var $70dce822108c0a0f$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $d3IQL.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $70dce822108c0a0f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $ejHIf.createIntl)((0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, (0, $4Hf5k.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, coreIntl), {
        // @ts-expect-error fix this
        formatMessage: $70dce822108c0a0f$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $70dce822108c0a0f$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $70dce822108c0a0f$var$IntlProvider = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $bceAk.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $70dce822108c0a0f$export$7e4cbedfdd7b4c0d($70dce822108c0a0f$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $70dce822108c0a0f$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $70dce822108c0a0f$var$processIntlConfig(props);
        if (!(0, $4Hf5k.shallowEqual)(prevConfig, config)) return {
            intl: $70dce822108c0a0f$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $4Hf5k.invariantIntlContext)(this.state.intl);
        return $1oC0p.createElement((0, $iZHH7.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $4Hf5k.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($1oC0p.PureComponent);
var $70dce822108c0a0f$export$2e2bcd8739ae039 = $70dce822108c0a0f$var$IntlProvider;

});
parcelRegister("iZHH7", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return $dd3fd153f8d14950$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $dd3fd153f8d14950$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $dd3fd153f8d14950$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $6PuZm = parcelRequire("6PuZm");

var $4Hf5k = parcelRequire("4Hf5k");
function $dd3fd153f8d14950$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $dd3fd153f8d14950$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $1oC0p.createContext(null)) : $1oC0p.createContext(null);
var $dd3fd153f8d14950$var$IntlConsumer = $dd3fd153f8d14950$var$IntlContext.Consumer, $dd3fd153f8d14950$var$IntlProvider = $dd3fd153f8d14950$var$IntlContext.Provider;
var $dd3fd153f8d14950$export$2881499e37b75b9a = $dd3fd153f8d14950$var$IntlProvider;
var $dd3fd153f8d14950$export$841858b892ce1f4c = $dd3fd153f8d14950$var$IntlContext;
function $dd3fd153f8d14950$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $1oC0p.createElement($dd3fd153f8d14950$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $4Hf5k.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $1oC0p.createElement(WrappedComponent, (0, $d3IQL.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($dd3fd153f8d14950$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))($1oC0p.forwardRef(function(props, ref) {
        return $1oC0p.createElement(WithIntl, (0, $d3IQL.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))(WithIntl, WrappedComponent);
}

});
parcelRegister("4Hf5k", function(module, exports) {
$parcel$export(module.exports, "invariantIntlContext", function () { return $36b6e11c850a850d$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $36b6e11c850a850d$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $36b6e11c850a850d$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $36b6e11c850a850d$export$d36bdfa510afb180; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $jcL53 = parcelRequire("jcL53");

var $bceAk = parcelRequire("bceAk");
function $36b6e11c850a850d$export$45c4bbf6e55bba1f(intl) {
    (0, $jcL53.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $36b6e11c850a850d$export$b52f8d6fc0d47415 = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, (0, $bceAk.DEFAULT_INTL_CONFIG)), {
    textComponent: $1oC0p.Fragment
});
function $36b6e11c850a850d$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($1oC0p.Children.toArray(parts));
    };
}
function $36b6e11c850a850d$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("jcL53", function(module, exports) {
$parcel$export(module.exports, "invariant", function () { return $dfb3a87f180174ae$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $dfb3a87f180174ae$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $dfb3a87f180174ae$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $dfb3a87f180174ae$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $dfb3a87f180174ae$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $dfb3a87f180174ae$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $dfb3a87f180174ae$export$3fae2929ed23c202(map, pl, field) {
    return $dfb3a87f180174ae$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $dfb3a87f180174ae$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $dfb3a87f180174ae$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $dfb3a87f180174ae$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $dfb3a87f180174ae$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $dfb3a87f180174ae$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("bceAk", function(module, exports) {
$parcel$export(module.exports, "filterProps", function () { return $826c20f29749be7d$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $826c20f29749be7d$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $826c20f29749be7d$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $826c20f29749be7d$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $826c20f29749be7d$export$4ee1db8ce44a209b; });

var $d3IQL = parcelRequire("d3IQL");

var $7hwEw = parcelRequire("7hwEw");

var $izmPF = parcelRequire("izmPF");

var $iOyCd = parcelRequire("iOyCd");
function $826c20f29749be7d$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $826c20f29749be7d$var$defaultErrorHandler = function(error) {};
var $826c20f29749be7d$var$defaultWarnHandler = function(warning) {};
var $826c20f29749be7d$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $826c20f29749be7d$var$defaultErrorHandler,
    onWarn: $826c20f29749be7d$var$defaultWarnHandler
};
function $826c20f29749be7d$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $826c20f29749be7d$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $826c20f29749be7d$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $826c20f29749be7d$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $izmPF.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d3IQL.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $izmPF.strategies).variadic
    });
    var getNumberFormat = (0, $izmPF.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d3IQL.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.number),
        strategy: (0, $izmPF.strategies).variadic
    });
    var getPluralRules = (0, $izmPF.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d3IQL.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $izmPF.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $izmPF.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $7hwEw.IntlMessageFormat)(message, locales, overrideFormats, (0, $d3IQL.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.message),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $izmPF.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $izmPF.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.list),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getDisplayNames: (0, $izmPF.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $izmPF.strategies).variadic
        })
    };
}
function $826c20f29749be7d$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $iOyCd.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("7hwEw", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", function () { return $54d37311c36e3b5c$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $d3IQL = parcelRequire("d3IQL");

var $b87z9 = parcelRequire("b87z9");

var $izmPF = parcelRequire("izmPF");

var $hjTVN = parcelRequire("hjTVN");
// -- MessageFormat --------------------------------------------------------
function $54d37311c36e3b5c$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $54d37311c36e3b5c$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $54d37311c36e3b5c$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $d3IQL.__assign)({}, defaultConfig));
}
function $54d37311c36e3b5c$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $54d37311c36e3b5c$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $izmPF.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $54d37311c36e3b5c$var$createFastMemoizeCache(cache.number),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getDateTimeFormat: (0, $izmPF.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $54d37311c36e3b5c$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getPluralRules: (0, $izmPF.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $54d37311c36e3b5c$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $izmPF.strategies).variadic
        })
    };
}
var $54d37311c36e3b5c$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $hjTVN.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $hjTVN.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $d3IQL.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $54d37311c36e3b5c$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $54d37311c36e3b5c$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $b87z9.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("b87z9", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("5oOXy")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("5oOXy")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("5oOXy")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("5oOXy")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("5oOXy")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("5oOXy")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("5oOXy")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("5oOXy")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("5oOXy")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("5oOXy")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("5oOXy")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("5oOXy")).TYPE; });
$parcel$export(module.exports, "parse", function () { return $81a64f7d0df62fc4$export$98e6a39c04603d36; });

var $d3IQL = parcelRequire("d3IQL");

var $esbOz = parcelRequire("esbOz");

var $iMWYU = parcelRequire("iMWYU");

var $5oOXy = parcelRequire("5oOXy");
function $81a64f7d0df62fc4$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $5oOXy.isSelectElement)(el) || (0, $5oOXy.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $81a64f7d0df62fc4$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $5oOXy.isNumberElement)(el) && (0, $5oOXy.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $5oOXy.isDateElement)(el) || (0, $5oOXy.isTimeElement)(el)) && (0, $5oOXy.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $5oOXy.isTagElement)(el)) $81a64f7d0df62fc4$var$pruneLocation(el.children);
    });
}
function $81a64f7d0df62fc4$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $d3IQL.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $iMWYU.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $esbOz.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $81a64f7d0df62fc4$var$pruneLocation(result.val);
    return result.val;
}
var $81a64f7d0df62fc4$export$d3c1bfa0f7d806e9 = (0, $iMWYU.Parser);

});
parcelRegister("esbOz", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", function () { return $a85cd85ea4dbf342$export$896afd8541959ee5; });
var $a85cd85ea4dbf342$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($a85cd85ea4dbf342$export$896afd8541959ee5 || ($a85cd85ea4dbf342$export$896afd8541959ee5 = {}));

});

parcelRegister("iMWYU", function(module, exports) {
$parcel$export(module.exports, "Parser", function () { return $dada76255f2d5a3e$export$7acfa6ed01010e37; });

var $d3IQL = parcelRequire("d3IQL");

var $esbOz = parcelRequire("esbOz");

var $5oOXy = parcelRequire("5oOXy");

var $9h5g7 = parcelRequire("9h5g7");
parcelRequire("2u22g");
var $5SUwH = parcelRequire("5SUwH");
var $hAvEH = parcelRequire("hAvEH");

var $ftRfC = parcelRequire("ftRfC");
var $dada76255f2d5a3e$var$_a;
var $dada76255f2d5a3e$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $9h5g7.SPACE_SEPARATOR_REGEX).source, "*"));
var $dada76255f2d5a3e$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $9h5g7.SPACE_SEPARATOR_REGEX).source, "*$"));
function $dada76255f2d5a3e$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $dada76255f2d5a3e$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $dada76255f2d5a3e$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $dada76255f2d5a3e$var$hasNativeFromEntries = !!Object.fromEntries;
var $dada76255f2d5a3e$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $dada76255f2d5a3e$var$hasTrimStart = !!String.prototype.trimStart;
var $dada76255f2d5a3e$var$hasTrimEnd = !!String.prototype.trimEnd;
var $dada76255f2d5a3e$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $dada76255f2d5a3e$var$isSafeInteger = $dada76255f2d5a3e$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $dada76255f2d5a3e$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $dada76255f2d5a3e$var$re = $dada76255f2d5a3e$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $dada76255f2d5a3e$var$REGEX_SUPPORTS_U_AND_Y = (($dada76255f2d5a3e$var$_a = $dada76255f2d5a3e$var$re.exec('a')) === null || $dada76255f2d5a3e$var$_a === void 0 ? void 0 : $dada76255f2d5a3e$var$_a[0]) === 'a';
} catch (_) {
    $dada76255f2d5a3e$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $dada76255f2d5a3e$var$startsWith = $dada76255f2d5a3e$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $dada76255f2d5a3e$var$fromCodePoint = $dada76255f2d5a3e$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $dada76255f2d5a3e$var$fromEntries = // native
$dada76255f2d5a3e$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $dada76255f2d5a3e$var$codePointAt = $dada76255f2d5a3e$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $dada76255f2d5a3e$var$trimStart = $dada76255f2d5a3e$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($dada76255f2d5a3e$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $dada76255f2d5a3e$var$trimEnd = $dada76255f2d5a3e$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($dada76255f2d5a3e$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $dada76255f2d5a3e$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $dada76255f2d5a3e$var$matchIdentifierAtIndex;
if ($dada76255f2d5a3e$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $dada76255f2d5a3e$var$IDENTIFIER_PREFIX_RE_1 = $dada76255f2d5a3e$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $dada76255f2d5a3e$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $dada76255f2d5a3e$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $dada76255f2d5a3e$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$dada76255f2d5a3e$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $dada76255f2d5a3e$var$codePointAt(s, index);
        if (c === undefined || $dada76255f2d5a3e$var$_isWhiteSpace(c) || $dada76255f2d5a3e$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $dada76255f2d5a3e$var$fromCodePoint.apply(void 0, match);
};
var $dada76255f2d5a3e$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $5oOXy.TYPE).pound,
                    location: $dada76255f2d5a3e$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $esbOz.ErrorKind).UNMATCHED_CLOSING_TAG, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $dada76255f2d5a3e$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $5oOXy.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$dada76255f2d5a3e$var$_isAlpha(this.char())) return this.error((0, $esbOz.ErrorKind).INVALID_TAG, $dada76255f2d5a3e$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $esbOz.ErrorKind).UNMATCHED_CLOSING_TAG, $dada76255f2d5a3e$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $esbOz.ErrorKind).INVALID_TAG, $dada76255f2d5a3e$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $5oOXy.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $esbOz.ErrorKind).UNCLOSED_TAG, $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $esbOz.ErrorKind).INVALID_TAG, $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $dada76255f2d5a3e$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $dada76255f2d5a3e$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $5oOXy.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$dada76255f2d5a3e$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $dada76255f2d5a3e$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $dada76255f2d5a3e$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $esbOz.ErrorKind).EMPTY_ARGUMENT, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $esbOz.ErrorKind).MALFORMED_ARGUMENT, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $5oOXy.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $esbOz.ErrorKind).MALFORMED_ARGUMENT, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $dada76255f2d5a3e$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $dada76255f2d5a3e$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_TYPE, $dada76255f2d5a3e$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $dada76255f2d5a3e$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_STYLE, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $dada76255f2d5a3e$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $dada76255f2d5a3e$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $dada76255f2d5a3e$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $5oOXy.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $esbOz.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $ftRfC.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $5oOXy.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $5SUwH.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $5oOXy.TYPE).date : (0, $5oOXy.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $5oOXy.TYPE).number : argType === 'date' ? (0, $5oOXy.TYPE).date : (0, $5oOXy.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $esbOz.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $dada76255f2d5a3e$var$createLocation(typeEndPosition_1, (0, $d3IQL.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $esbOz.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $5oOXy.TYPE).select,
                        value: value,
                        options: $dada76255f2d5a3e$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $5oOXy.TYPE).plural,
                        value: value,
                        options: $dada76255f2d5a3e$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $esbOz.ErrorKind).INVALID_ARGUMENT_TYPE, $dada76255f2d5a3e$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $esbOz.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $dada76255f2d5a3e$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $hAvEH.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $esbOz.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $5oOXy.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $hAvEH.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $esbOz.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $esbOz.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $esbOz.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $esbOz.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $esbOz.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $esbOz.ErrorKind).MISSING_OTHER_CLAUSE, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $dada76255f2d5a3e$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$dada76255f2d5a3e$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $dada76255f2d5a3e$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($dada76255f2d5a3e$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $dada76255f2d5a3e$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $dada76255f2d5a3e$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $dada76255f2d5a3e$var$_isAlphaOrSlash(codepoint) {
    return $dada76255f2d5a3e$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $dada76255f2d5a3e$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $dada76255f2d5a3e$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $dada76255f2d5a3e$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("5oOXy", function(module, exports) {
$parcel$export(module.exports, "TYPE", function () { return $3ee6b927904aff4a$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $3ee6b927904aff4a$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $3ee6b927904aff4a$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $3ee6b927904aff4a$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $3ee6b927904aff4a$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $3ee6b927904aff4a$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $3ee6b927904aff4a$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $3ee6b927904aff4a$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $3ee6b927904aff4a$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $3ee6b927904aff4a$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $3ee6b927904aff4a$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $3ee6b927904aff4a$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $3ee6b927904aff4a$export$7680c41f1a55f4cf; });
var $3ee6b927904aff4a$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($3ee6b927904aff4a$export$b87f371cbc396fcf || ($3ee6b927904aff4a$export$b87f371cbc396fcf = {}));
var $3ee6b927904aff4a$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($3ee6b927904aff4a$export$906452485466fa53 || ($3ee6b927904aff4a$export$906452485466fa53 = {}));
function $3ee6b927904aff4a$export$cfa10c5697238752(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.literal;
}
function $3ee6b927904aff4a$export$4f55724281bdfaf9(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.argument;
}
function $3ee6b927904aff4a$export$e11187b219e191e1(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.number;
}
function $3ee6b927904aff4a$export$32d811605da75f40(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.date;
}
function $3ee6b927904aff4a$export$34ec46f596b1702f(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.time;
}
function $3ee6b927904aff4a$export$dcfe1c11d168b5a1(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.select;
}
function $3ee6b927904aff4a$export$6c796d116f0a4fbc(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.plural;
}
function $3ee6b927904aff4a$export$c0ece297bdd0c082(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.pound;
}
function $3ee6b927904aff4a$export$5c83de34745812b(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.tag;
}
function $3ee6b927904aff4a$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $3ee6b927904aff4a$export$906452485466fa53.number);
}
function $3ee6b927904aff4a$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $3ee6b927904aff4a$export$906452485466fa53.dateTime);
}
function $3ee6b927904aff4a$export$f0ac572c1121c662(value) {
    return {
        type: $3ee6b927904aff4a$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $3ee6b927904aff4a$export$425e864b0ba114f1(value, style) {
    return {
        type: $3ee6b927904aff4a$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("9h5g7", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $6c09c7ee5265f9bc$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $6c09c7ee5265f9bc$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $6c09c7ee5265f9bc$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("2u22g", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("5SUwH")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("hAvEH")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("hAvEH")).parseNumberSkeletonFromString; });
parcelRequire("5SUwH");
parcelRequire("hAvEH");

});
parcelRegister("5SUwH", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $448dd7dd3835406f$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $448dd7dd3835406f$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $448dd7dd3835406f$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($448dd7dd3835406f$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("hAvEH", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $ccde5a8ea86912ea$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $ccde5a8ea86912ea$export$47c6f8480bda3e11; });

var $d3IQL = parcelRequire("d3IQL");

var $8rStY = parcelRequire("8rStY");
function $ccde5a8ea86912ea$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $8rStY.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $ccde5a8ea86912ea$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $ccde5a8ea86912ea$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $ccde5a8ea86912ea$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $ccde5a8ea86912ea$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $ccde5a8ea86912ea$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $ccde5a8ea86912ea$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($ccde5a8ea86912ea$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $ccde5a8ea86912ea$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $ccde5a8ea86912ea$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$ccde5a8ea86912ea$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $ccde5a8ea86912ea$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $ccde5a8ea86912ea$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $ccde5a8ea86912ea$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $ccde5a8ea86912ea$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, all), $ccde5a8ea86912ea$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, all), $ccde5a8ea86912ea$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($ccde5a8ea86912ea$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($ccde5a8ea86912ea$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($ccde5a8ea86912ea$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($ccde5a8ea86912ea$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), $ccde5a8ea86912ea$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($ccde5a8ea86912ea$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), $ccde5a8ea86912ea$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $ccde5a8ea86912ea$var$parseSign(token.stem);
        if (signOpts) result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $ccde5a8ea86912ea$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("8rStY", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $626b1b6915e59eec$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $626b1b6915e59eec$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("ftRfC", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", function () { return $02e88ffbc49e0d02$export$29c5368be8904d27; });

var $2tWoJ = parcelRequire("2tWoJ");
function $02e88ffbc49e0d02$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $02e88ffbc49e0d02$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $02e88ffbc49e0d02$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $2tWoJ.timeData)[regionTag || ''] || (0, $2tWoJ.timeData)[languageTag || ''] || (0, $2tWoJ.timeData)["".concat(languageTag, "-001")] || (0, $2tWoJ.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("2tWoJ", function(module, exports) {
$parcel$export(module.exports, "timeData", function () { return $1ceb96d4d79f4984$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $1ceb96d4d79f4984$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("izmPF", function(module, exports) {
$parcel$export(module.exports, "memoize", function () { return $d84d34ee5b73486e$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $d84d34ee5b73486e$export$c5491a8691a23b9e; });
//
// Main
//
function $d84d34ee5b73486e$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $d84d34ee5b73486e$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $d84d34ee5b73486e$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $d84d34ee5b73486e$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $d84d34ee5b73486e$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $d84d34ee5b73486e$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $d84d34ee5b73486e$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d84d34ee5b73486e$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d84d34ee5b73486e$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $d84d34ee5b73486e$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $d84d34ee5b73486e$var$monadic : $d84d34ee5b73486e$var$variadic;
    return $d84d34ee5b73486e$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $d84d34ee5b73486e$var$strategyVariadic(fn, options) {
    return $d84d34ee5b73486e$var$assemble(fn, this, $d84d34ee5b73486e$var$variadic, options.cache.create(), options.serializer);
}
function $d84d34ee5b73486e$var$strategyMonadic(fn, options) {
    return $d84d34ee5b73486e$var$assemble(fn, this, $d84d34ee5b73486e$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $d84d34ee5b73486e$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $d84d34ee5b73486e$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$d84d34ee5b73486e$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$d84d34ee5b73486e$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $d84d34ee5b73486e$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $d84d34ee5b73486e$var$ObjectWithoutPrototypeCache();
    }
};
var $d84d34ee5b73486e$export$c5491a8691a23b9e = {
    variadic: $d84d34ee5b73486e$var$strategyVariadic,
    monadic: $d84d34ee5b73486e$var$strategyMonadic
};

});

parcelRegister("hjTVN", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", function () { return $c9bf98cd2eb699a1$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $c9bf98cd2eb699a1$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $c9bf98cd2eb699a1$export$275d4a3bb5f66fda; });
parcelRequire("b87z9");
var $5oOXy = parcelRequire("5oOXy");

var $aVe39 = parcelRequire("aVe39");
var $c9bf98cd2eb699a1$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($c9bf98cd2eb699a1$export$49694c2877b44c57 || ($c9bf98cd2eb699a1$export$49694c2877b44c57 = {}));
function $c9bf98cd2eb699a1$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $c9bf98cd2eb699a1$export$49694c2877b44c57.literal || part.type !== $c9bf98cd2eb699a1$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $c9bf98cd2eb699a1$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $c9bf98cd2eb699a1$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $5oOXy.isLiteralElement)(els[0])) return [
        {
            type: $c9bf98cd2eb699a1$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $5oOXy.isLiteralElement)(el)) {
            result.push({
                type: $c9bf98cd2eb699a1$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $5oOXy.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $c9bf98cd2eb699a1$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $aVe39.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $5oOXy.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $c9bf98cd2eb699a1$export$49694c2877b44c57.literal : $c9bf98cd2eb699a1$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $5oOXy.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $5oOXy.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $c9bf98cd2eb699a1$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $5oOXy.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $c9bf98cd2eb699a1$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $5oOXy.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $c9bf98cd2eb699a1$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$c9bf98cd2eb699a1$export$df0c12a2d414a163(formatFn)) throw new (0, $aVe39.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $c9bf98cd2eb699a1$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $c9bf98cd2eb699a1$export$49694c2877b44c57.literal : $c9bf98cd2eb699a1$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $5oOXy.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $aVe39.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c9bf98cd2eb699a1$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $5oOXy.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $aVe39.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $aVe39.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $aVe39.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c9bf98cd2eb699a1$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $c9bf98cd2eb699a1$var$mergeLiteral(result);
}

});
parcelRegister("aVe39", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", function () { return $7f3a20479b39afcb$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $7f3a20479b39afcb$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $7f3a20479b39afcb$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $7f3a20479b39afcb$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $7f3a20479b39afcb$export$8bfc137e4d23fdf0; });

var $d3IQL = parcelRequire("d3IQL");
var $7f3a20479b39afcb$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($7f3a20479b39afcb$export$d4e71bc0b80dc0fb || ($7f3a20479b39afcb$export$d4e71bc0b80dc0fb = {}));
var $7f3a20479b39afcb$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $7f3a20479b39afcb$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $7f3a20479b39afcb$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($7f3a20479b39afcb$export$7369836851cc1329);
var $7f3a20479b39afcb$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $7f3a20479b39afcb$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($7f3a20479b39afcb$export$7369836851cc1329);
var $7f3a20479b39afcb$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $7f3a20479b39afcb$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($7f3a20479b39afcb$export$7369836851cc1329);

});



parcelRegister("iOyCd", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", function () { return $db27bf64c8264fbb$export$557d6acb76e8a244; });
$parcel$export(module.exports, "IntlError", function () { return $db27bf64c8264fbb$export$c016d36112f6ddf8; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $db27bf64c8264fbb$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $db27bf64c8264fbb$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $db27bf64c8264fbb$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $db27bf64c8264fbb$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $db27bf64c8264fbb$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $db27bf64c8264fbb$export$2ddcb436d0aa3688; });

var $d3IQL = parcelRequire("d3IQL");
var $db27bf64c8264fbb$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($db27bf64c8264fbb$export$557d6acb76e8a244 || ($db27bf64c8264fbb$export$557d6acb76e8a244 = {}));
var $db27bf64c8264fbb$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $db27bf64c8264fbb$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);
var $db27bf64c8264fbb$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);
var $db27bf64c8264fbb$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);
var $db27bf64c8264fbb$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);
var $db27bf64c8264fbb$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($db27bf64c8264fbb$export$e3b7eee1dbc44895);
var $db27bf64c8264fbb$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);

});




parcelRegister("ejHIf", function(module, exports) {
$parcel$export(module.exports, "createIntl", function () { return $a6c4bf779f33db77$export$7e4cbedfdd7b4c0d; });

var $d3IQL = parcelRequire("d3IQL");

var $bceAk = parcelRequire("bceAk");

var $iOyCd = parcelRequire("iOyCd");

var $1hBA4 = parcelRequire("1hBA4");

var $9UY0v = parcelRequire("9UY0v");

var $bqzDh = parcelRequire("bqzDh");

var $4jINt = parcelRequire("4jINt");

var $8xwAh = parcelRequire("8xwAh");

var $byRFS = parcelRequire("byRFS");

var $lFUbz = parcelRequire("lFUbz");
function $a6c4bf779f33db77$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $a6c4bf779f33db77$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $a6c4bf779f33db77$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $a6c4bf779f33db77$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $bceAk.createFormatters)(cache);
    var resolvedConfig = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, (0, $bceAk.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $iOyCd.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iOyCd.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iOyCd.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $a6c4bf779f33db77$var$verifyConfigMessages(resolvedConfig);
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $1hBA4.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $1hBA4.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $9UY0v.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $bqzDh.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $bqzDh.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $bqzDh.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $bqzDh.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $bqzDh.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $4jINt.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $8xwAh.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $8xwAh.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $byRFS.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $byRFS.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $lFUbz.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("1hBA4", function(module, exports) {
$parcel$export(module.exports, "formatNumber", function () { return $0ef487b7adb3469a$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $0ef487b7adb3469a$export$6871080848f10b2f; });

var $bceAk = parcelRequire("bceAk");

var $iOyCd = parcelRequire("iOyCd");
var $0ef487b7adb3469a$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $0ef487b7adb3469a$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $bceAk.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $bceAk.filterProps)(options, $0ef487b7adb3469a$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $0ef487b7adb3469a$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $0ef487b7adb3469a$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $0ef487b7adb3469a$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $0ef487b7adb3469a$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("9UY0v", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", function () { return $7387e42b3d207a7d$export$b4ea3b48dcf921f6; });

var $bceAk = parcelRequire("bceAk");

var $aVe39 = parcelRequire("aVe39");

var $iOyCd = parcelRequire("iOyCd");
var $7387e42b3d207a7d$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $7387e42b3d207a7d$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $bceAk.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $bceAk.filterProps)(options, $7387e42b3d207a7d$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $7387e42b3d207a7d$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $aVe39.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $aVe39.ErrorCode).MISSING_INTL_API));
    try {
        return $7387e42b3d207a7d$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("bqzDh", function(module, exports) {
$parcel$export(module.exports, "formatDate", function () { return $0225a42e9031fb7c$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $0225a42e9031fb7c$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $0225a42e9031fb7c$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $0225a42e9031fb7c$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $0225a42e9031fb7c$export$af6e5d7a5c73edeb; });

var $d3IQL = parcelRequire("d3IQL");

var $bceAk = parcelRequire("bceAk");

var $iOyCd = parcelRequire("iOyCd");
var $0225a42e9031fb7c$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $0225a42e9031fb7c$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $bceAk.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $bceAk.filterProps)(options, $0225a42e9031fb7c$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $0225a42e9031fb7c$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $0225a42e9031fb7c$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $0225a42e9031fb7c$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $0225a42e9031fb7c$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $0225a42e9031fb7c$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $bceAk.filterProps)(options, $0225a42e9031fb7c$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $iOyCd.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $0225a42e9031fb7c$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $0225a42e9031fb7c$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $0225a42e9031fb7c$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $0225a42e9031fb7c$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("4jINt", function(module, exports) {
$parcel$export(module.exports, "formatPlural", function () { return $324baf7f24daad9e$export$bbbd05c900f3568d; });

var $bceAk = parcelRequire("bceAk");

var $iOyCd = parcelRequire("iOyCd");

var $aVe39 = parcelRequire("aVe39");
var $324baf7f24daad9e$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $324baf7f24daad9e$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $aVe39.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $aVe39.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bceAk.filterProps)(options, $324baf7f24daad9e$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $iOyCd.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("8xwAh", function(module, exports) {
$parcel$export(module.exports, "formatMessage", function () { return $637aae58a9d9b0c5$export$25868d1e8e76735f; });

var $d3IQL = parcelRequire("d3IQL");

var $jcL53 = parcelRequire("jcL53");

var $7hwEw = parcelRequire("7hwEw");

var $iOyCd = parcelRequire("iOyCd");
parcelRequire("b87z9");
var $5oOXy = parcelRequire("5oOXy");
function $637aae58a9d9b0c5$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $d3IQL.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $637aae58a9d9b0c5$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $637aae58a9d9b0c5$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $7hwEw.IntlMessageFormat).formats;
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, mfFormats), f1), {
        date: $637aae58a9d9b0c5$var$deepMergeOptions($637aae58a9d9b0c5$var$setTimeZoneInOptions(mfFormats.date, timeZone), $637aae58a9d9b0c5$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $637aae58a9d9b0c5$var$deepMergeOptions($637aae58a9d9b0c5$var$setTimeZoneInOptions(mfFormats.time, timeZone), $637aae58a9d9b0c5$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $637aae58a9d9b0c5$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $jcL53.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $5oOXy.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, defaultRichTextElements), values || {});
    formats = $637aae58a9d9b0c5$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $637aae58a9d9b0c5$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $iOyCd.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $iOyCd.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $d3IQL.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iOyCd.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iOyCd.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("byRFS", function(module, exports) {
$parcel$export(module.exports, "formatList", function () { return $86ac814d64764510$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $86ac814d64764510$export$6f284aad1934db69; });

var $d3IQL = parcelRequire("d3IQL");

var $bceAk = parcelRequire("bceAk");

var $aVe39 = parcelRequire("aVe39");

var $iOyCd = parcelRequire("iOyCd");
var $86ac814d64764510$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $86ac814d64764510$var$now = Date.now();
function $86ac814d64764510$var$generateToken(i) {
    return "".concat($86ac814d64764510$var$now, "_").concat(i, "_").concat($86ac814d64764510$var$now);
}
function $86ac814d64764510$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $86ac814d64764510$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $86ac814d64764510$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $aVe39.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $aVe39.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bceAk.filterProps)(options, $86ac814d64764510$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $86ac814d64764510$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $iOyCd.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("lFUbz", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", function () { return $fc7902a0b5e79427$export$62fe1a4d9e891fa2; });

var $bceAk = parcelRequire("bceAk");

var $aVe39 = parcelRequire("aVe39");

var $iOyCd = parcelRequire("iOyCd");
var $fc7902a0b5e79427$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $fc7902a0b5e79427$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $aVe39.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $aVe39.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bceAk.filterProps)(options, $fc7902a0b5e79427$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $iOyCd.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});



parcelRegister("8e22h", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5fd135cb5b228af8$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $iZHH7 = parcelRequire("iZHH7");

var $4Hf5k = parcelRequire("4Hf5k");
function $5fd135cb5b228af8$export$2e2bcd8739ae039() {
    var intl = $1oC0p.useContext((0, $iZHH7.Context));
    (0, $4Hf5k.invariantIntlContext)(intl);
    return intl;
}

});

parcelRegister("eV0Hm", function(module, exports) {
$parcel$export(module.exports, "getAtlCohortId", function () { return $96a43e7fccbe4d3c$export$6af88e6f54add681; });

var $gx3aw = parcelRequire("gx3aw");
function $96a43e7fccbe4d3c$export$6af88e6f54add681(allCookies) {
    let atlCohortId;
    try {
        const atlCohort = (0, $gx3aw.Cookie).readCookie('atlCohort', allCookies);
        atlCohortId = JSON.parse(atlCohort || '')?.bucketAll?.index;
        if (!atlCohortId) return undefined;
        const atlCohortInit = parseInt(atlCohortId);
        if (isNaN(atlCohortInit) || atlCohortInit < 0) return undefined;
        return atlCohortInit;
    } catch (error) {
        return undefined;
    }
}

});


parcelRegister("5mv0J", function(module, exports) {
$parcel$export(module.exports, "useSSRLoginState", function () { return $7ef28acc908d886a$export$6576c6d702d8a9f7; });
$parcel$export(module.exports, "SSRLoginStateProvider", function () { return $7ef28acc908d886a$export$936443f499340574; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $7ef28acc908d886a$var$SSRLoginStateContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    hasCloudSessionTokenCookie: false
});
const $7ef28acc908d886a$export$6576c6d702d8a9f7 = ()=>{
    const context = (0, $1oC0p.useContext)($7ef28acc908d886a$var$SSRLoginStateContext);
    if (!context) throw new Error('useSSRLoginState must be used within SSRLoginStateProvider');
    return context;
};
const $7ef28acc908d886a$export$936443f499340574 = ({ children: children, hasCloudSessionTokenCookie: hasCloudSessionTokenCookie = false, userAgent: userAgent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($7ef28acc908d886a$var$SSRLoginStateContext.Provider, {
        value: {
            hasCloudSessionTokenCookie: hasCloudSessionTokenCookie,
            userAgent: userAgent
        },
        children: children
    });
};

});

parcelRegister("5yuBp", function(module, exports) {
$parcel$export(module.exports, "useIsMobile", function () { return $3579a65c4b2fa946$export$2b96349243a56116; });

var $1oC0p = parcelRequire("1oC0p");
const $3579a65c4b2fa946$export$2b96349243a56116 = (mobileWidthInPx = 640)=>{
    const [width, setWidth] = (0, $1oC0p.useState)(window.innerWidth);
    const handleWindowSizeChange = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener('resize', handleWindowSizeChange);
        return ()=>{
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    const isMobile = width <= mobileWidthInPx;
    return isMobile;
};

});

parcelRegister("7GVWk", function(module, exports) {
$parcel$export(module.exports, "UserContextProvider", function () { return $367b5e8b588b731f$export$2e7f18b06f26b111; });
$parcel$export(module.exports, "useUserContext", function () { return $367b5e8b588b731f$export$87c54b525b914dab; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $gPKCY = parcelRequire("gPKCY");

var $5Ntyw = parcelRequire("5Ntyw");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $3dtkR = parcelRequire("3dtkR");
const $367b5e8b588b731f$export$38ee920e59704589 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $367b5e8b588b731f$export$2e7f18b06f26b111 = ({ children: children, location: location = 'https://www.atlassian.com/', referrer: referrer, meResponse: meResponse, meRequest: meRequest, userProfileResponse: userProfileResponse, userProfileRequest: userProfileRequest, loggedOutContext: loggedOutContext, loggedOutContextStatus: loggedOutContextStatus, loggedInContext: loggedInContext, loggedInContextStatus: loggedInContextStatus, transactionAccounts: transactionAccounts = [], utmCampaign: utmCampaign = null })=>{
    const meResponseProvided = (0, $1oC0p.useMemo)(()=>meRequest && meRequest.requested && meRequest.success, [
        meRequest
    ]);
    const userProfileProvided = (0, $1oC0p.useMemo)(()=>userProfileRequest && userProfileRequest.requested && userProfileRequest.success, [
        userProfileRequest
    ]);
    const loggedOutProfile = (0, $1oC0p.useMemo)(()=>loggedOutContextStatus?.requested && loggedOutContextStatus?.success ? loggedOutContext : undefined, [
        loggedOutContext,
        loggedOutContextStatus
    ]);
    const loggedInProfile = (0, $1oC0p.useMemo)(()=>loggedInContextStatus?.requested && loggedInContextStatus?.success ? loggedInContext : undefined, [
        loggedInContext,
        loggedInContextStatus
    ]);
    const clientUserProfileRequested = (0, $1oC0p.useRef)(userProfileRequest?.requested && userProfileRequest?.success ? 'complete' : 'notRequested');
    // If logged in user cookie isn't present, then we don't need to make a call to stargate.
    // This cookie is set by bxp-gateway to determine if the user is logged in or not.
    // However, when static fallback is served from edge cache, setHeaders() never runs and login_user_detected is not set.
    // As a fallback, check for cloud.session.token directly (which is the source of truth for login state).
    const loginUserDetectedCookie = (0, $gx3aw.Cookie).readCookie('login_user_detected') === 'true';
    const cloudSessionToken = (0, $gx3aw.Cookie).readCookie('cloud.session.token') || (0, $gx3aw.Cookie).readCookie('cloud.session.token.stg');
    const loginUserDetected = loginUserDetectedCookie || cloudSessionToken !== null;
    const [user, setUser] = (0, $1oC0p.useState)({
        ...meResponse,
        isUserLoggedIn: meResponseProvided ? !!meResponse : undefined,
        requestInProgress: !meResponseProvided
    });
    const [transactionAccountsState] = (0, $1oC0p.useState)(transactionAccounts);
    const [profile, setProfile] = (0, $1oC0p.useState)({
        ...userProfileResponse,
        requestInProgress: !userProfileProvided && !!userProfileRequest && userProfileRequest.requested && loginUserDetected
    });
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const { product: product, edition: edition } = (0, $3dtkR.useProductIntent)(location);
    const clientSideUser = (0, $3riD8.useLoggedInUser)();
    const fetchUserProfile = (0, $1oC0p.useCallback)(()=>{
        if (!loginUserDetected || clientUserProfileRequested.current !== 'notRequested') return;
        clientUserProfileRequested.current = 'inProgress';
        setProfile((profile)=>({
                ...profile,
                requestInProgress: true
            }));
        (0, $gPKCY.ufoEventGetUserProfile).start();
        stargateClient.getUserProfile({
            productName: product?.name
        }) // todo decide if it might be better to always send undefined
        .then((userProfile)=>{
            setProfile({
                ...userProfile,
                requestInProgress: false
            });
            (0, $gPKCY.ufoEventGetUserProfile).success({
                customData: {
                    cohorts: userProfile.cohorts,
                    reactComponent: 'UserContextProvider',
                    analyticsEvent: 'succeeded',
                    productName: product?.name
                }
            });
        }).catch((error)=>{
            console.error('Failed to get user profile', error);
            (0, $gPKCY.ufoEventGetUserProfile).failure({
                customData: {
                    reactComponent: 'UserContextProvider',
                    analyticsEvent: 'errored',
                    productName: product?.name
                },
                error: error
            });
            setProfile({
                requestInProgress: false
            });
        }).finally(()=>{
            clientUserProfileRequested.current = 'complete';
        });
    }, [
        stargateClient,
        product,
        loginUserDetected
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (meResponseProvided || clientSideUser.requestInProgress) return;
        setUser(clientSideUser);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientSideUser.requestInProgress,
        meResponseProvided
    ]); // don't add clientSideUser to the dependency array to avoid infinite loop
    (0, $1oC0p.useEffect)(()=>{
        if (userProfileProvided || !userProfileRequest?.requested) return;
        fetchUserProfile();
    }, [
        userProfileProvided,
        fetchUserProfile,
        userProfileRequest?.requested
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($367b5e8b588b731f$export$38ee920e59704589.Provider, {
        value: {
            edition: edition,
            loggedOutProfile: loggedOutProfile,
            loggedInProfile: loggedInProfile,
            product: product,
            profile: profile,
            referrer: referrer,
            user: user,
            transactionAccounts: transactionAccountsState,
            requestClientUserProfile: ()=>{
                if (clientUserProfileRequested.current === 'notRequested' && !userProfileProvided && !profile.requestInProgress) fetchUserProfile();
            },
            utmCampaign: utmCampaign
        },
        children: children
    });
};
const $367b5e8b588b731f$export$87c54b525b914dab = ()=>{
    const context = (0, $1oC0p.useContext)($367b5e8b588b731f$export$38ee920e59704589);
    if (!context) throw new Error('useUserContext must be used within a UserContextProvider');
    context.requestClientUserProfile();
    return context;
};

});
parcelRegister("gPKCY", function(module, exports) {
$parcel$export(module.exports, "ufoEventAccountSignin", function () { return $e1a6d13a9886934c$export$5fcd84211e1a1b4a; });
$parcel$export(module.exports, "ufoEventLegacyAccountCreation", function () { return $e1a6d13a9886934c$export$b9ea4526e4381282; });
$parcel$export(module.exports, "ufoEventNewSiteN2NSubmit", function () { return $e1a6d13a9886934c$export$6e8b4d41cca771b7; });
$parcel$export(module.exports, "ufoEventExistingSiteN2ESubmit", function () { return $e1a6d13a9886934c$export$21cc61280e75423; });
$parcel$export(module.exports, "ufoEventLegacyNewSiteN2NSubmit", function () { return $e1a6d13a9886934c$export$2f235e71d30c6bb2; });
$parcel$export(module.exports, "ufoEventLegacyNewSiteN2NPaidSubmit", function () { return $e1a6d13a9886934c$export$fee84aabae7803f3; });
$parcel$export(module.exports, "ufoEventLegacyExistingSiteN2ESubmit", function () { return $e1a6d13a9886934c$export$7a6c554b22f876b4; });
$parcel$export(module.exports, "ufoEventLegacyExistingSiteN2EPaidSubmit", function () { return $e1a6d13a9886934c$export$b5bbdb248b2b11c2; });
$parcel$export(module.exports, "ufoEventGetUserProfile", function () { return $e1a6d13a9886934c$export$b164d3383b880fdc; });
$parcel$export(module.exports, "ufoEventConfirmationPageStatusPolling", function () { return $e1a6d13a9886934c$export$40efcfb31ac1efa2; });
$parcel$export(module.exports, "ufoEventConfirmationPageUpdateUserProfile", function () { return $e1a6d13a9886934c$export$f2b36adc7ea3d4fb; });
$parcel$export(module.exports, "ufoEventConfirmationPageTeamTypeSelection", function () { return $e1a6d13a9886934c$export$93670d666aaba770; });
$parcel$export(module.exports, "ufoEventConfirmationPageTemplateSelectionContinue", function () { return $e1a6d13a9886934c$export$15729dc80d1b26cf; });
$parcel$export(module.exports, "ufoEventConfirmationPageTemplateSelectionBack", function () { return $e1a6d13a9886934c$export$b5b50a2ad76a9aa3; });
$parcel$export(module.exports, "ufoEventGraphQLWebhookSetup", function () { return $e1a6d13a9886934c$export$7483953e3b70c45; });
$parcel$export(module.exports, "ufoEventGraphQLSubscriptionSetup", function () { return $e1a6d13a9886934c$export$149824147e381b11; });
$parcel$export(module.exports, "ufoEventGraphQLGetProvisioningStatus", function () { return $e1a6d13a9886934c$export$37cf0a10d749cb69; });
$parcel$export(module.exports, "ufoEventRedirectToProduct", function () { return $e1a6d13a9886934c$export$93808710b9120531; });
$parcel$export(module.exports, "ufoEventGetJiraSitesFromAgg", function () { return $e1a6d13a9886934c$export$8742107465d7ad8f; });
$parcel$export(module.exports, "ufoEventGetRecaptcha", function () { return $e1a6d13a9886934c$export$363d2de92afe8e7; });
$parcel$export(module.exports, "ufoEventTryCloudSignupPageLoad", function () { return $e1a6d13a9886934c$export$f81be27e62354595; });
$parcel$export(module.exports, "ufoEventTryCloudSignupAvailableProducts", function () { return $e1a6d13a9886934c$export$cd2c363597bd0b53; });
$parcel$export(module.exports, "ufoEventTryCloudSignupExpandFreeValidation", function () { return $e1a6d13a9886934c$export$7a7c3f59dea17f9; });
$parcel$export(module.exports, "ufoEventPaidSignupLandingPageLoad", function () { return $e1a6d13a9886934c$export$d6d4aa47db9fc9bf; });
$parcel$export(module.exports, "ufoEventPaidSignupJSWLandingPageLoad", function () { return $e1a6d13a9886934c$export$1b5a141920591df9; });
$parcel$export(module.exports, "ufoEventPaidSignupConfluenceLandingPageLoad", function () { return $e1a6d13a9886934c$export$17da59807f19bcf5; });
$parcel$export(module.exports, "ufoEventPaidSignupJSMLandingPageLoad", function () { return $e1a6d13a9886934c$export$2ade41d8cc00cdd1; });
$parcel$export(module.exports, "ufoEventBxpGatewayAnchorParse", function () { return $e1a6d13a9886934c$export$fb25c6edcfccd1ee; });
$parcel$export(module.exports, "ufoEventSignupFormLoad", function () { return $e1a6d13a9886934c$export$b455e85cb1a670d6; });
$parcel$export(module.exports, "ufoEventSiteNameAvailability", function () { return $e1a6d13a9886934c$export$88a8b1f7795a4755; });
$parcel$export(module.exports, "ufoEventPostOrderGetActivationType", function () { return $e1a6d13a9886934c$export$5efb77ab7d4924a2; });
$parcel$export(module.exports, "ufoEventPostOrderExistingSiteActivation", function () { return $e1a6d13a9886934c$export$d32222d13d2012ed; });
$parcel$export(module.exports, "ufoEventPostOrderNewSiteActivation", function () { return $e1a6d13a9886934c$export$50bc2958e0690914; });
$parcel$export(module.exports, "ufoEventPostOrderOrgActivation", function () { return $e1a6d13a9886934c$export$7d2e3f087e40b0f6; });
$parcel$export(module.exports, "ufoEventPostOrderAccountOrgList", function () { return $e1a6d13a9886934c$export$684c084e8c82e830; });
$parcel$export(module.exports, "ufoEventPostOrderAccountOrgListNextPage", function () { return $e1a6d13a9886934c$export$79d58b2886ef4485; });
$parcel$export(module.exports, "ufoEventProvisioningStatusCloudIdAvailability", function () { return $e1a6d13a9886934c$export$569d81616e2bd8d; });
$parcel$export(module.exports, "ufoEventOnboardingWizardProjectCreation", function () { return $e1a6d13a9886934c$export$dead11e4b6847b1e; });
$parcel$export(module.exports, "ufoEventOnboardingWizardProjectCreationIncludingProvisioning", function () { return $e1a6d13a9886934c$export$be09b4532561475c; });
$parcel$export(module.exports, "ufoEventAsyncArchitectureNewSiteActivation", function () { return $e1a6d13a9886934c$export$22e6232eaf5bb2b6; });
$parcel$export(module.exports, "ufoEventAsyncArchitecturePollingStatus", function () { return $e1a6d13a9886934c$export$74415081c316e26; });
$parcel$export(module.exports, "ufoEventOnboardingAutoSelectThemePreference", function () { return $e1a6d13a9886934c$export$993fa34c764c5b2d; });
$parcel$export(module.exports, "ufoEventOnboardingResolveTenantId", function () { return $e1a6d13a9886934c$export$e21068351502f79; });
$parcel$export(module.exports, "ufoEventOnboardingInviteUsers", function () { return $e1a6d13a9886934c$export$edaa107857ee2d4d; });
$parcel$export(module.exports, "ufoEventMadlibProjectCreation", function () { return $e1a6d13a9886934c$export$6f8fe3fb44db3f2d; });
$parcel$export(module.exports, "ufoEventSkippedMadlibProjectCreation", function () { return $e1a6d13a9886934c$export$31bc284942dbe406; });
$parcel$export(module.exports, "ufoEventProvisioningFunnel", function () { return $e1a6d13a9886934c$export$9f70bbe5ec980f4; });

var $kHXv1 = parcelRequire("kHXv1");
var $cHMqe = parcelRequire("cHMqe");

var $1jg7z = parcelRequire("1jg7z");

var $bOGMu = parcelRequire("bOGMu");

var $lIWv2 = parcelRequire("lIWv2");
const $e1a6d13a9886934c$export$5fcd84211e1a1b4a = new (0, $bOGMu.SignupUFOExperience)('bxpui.account-signin.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).IDENTITY_USER_SIGNUP_API
    ],
    platform: {
        component: `signin`
    }
});
const $e1a6d13a9886934c$export$4fe74aaece98f86 = new (0, $bOGMu.SignupUFOExperience)('bxpui.account-creation.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).IDENTITY_USER_SIGNUP_API
    ]
});
const $e1a6d13a9886934c$export$b9ea4526e4381282 = new (0, $bOGMu.SignupUFOExperience)('bxpkit.account-creation.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).IDENTITY_USER_SIGNUP_API
    ]
});
const $e1a6d13a9886934c$export$6e8b4d41cca771b7 = new (0, $bOGMu.SignupUFOExperience)('bxpui.new-site-n2n-submit.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$9ae44d3cd9212530 = new (0, $bOGMu.SignupUFOExperience)('bxpui.get-sites-n2e.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$cf822340feac4687 = new (0, $bOGMu.SignupUFOExperience)('bxpui.get-user.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$21cc61280e75423 = new (0, $bOGMu.SignupUFOExperience)('bxpui.existing-site-n2e-submit.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$2f235e71d30c6bb2 = new (0, $bOGMu.SignupUFOExperience)('bxpkit.new-site-n2n-submit.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$fee84aabae7803f3 = new (0, $bOGMu.SignupUFOExperience)('bxpkit.new-site-n2n-paid-submit.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$7a6c554b22f876b4 = new (0, $bOGMu.SignupUFOExperience)('bxpkit.existing-site-n2e-submit.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$b5bbdb248b2b11c2 = new (0, $bOGMu.SignupUFOExperience)('bxpkit.existing-site-n2e-paid-submit.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$b164d3383b880fdc = new (0, $bOGMu.SignupUFOExperience)('get-user-profile.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$42d8764622431d53 = new (0, $bOGMu.SignupUFOExperience)('company-expand.join-product.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$b92cb9b78a1af239 = new (0, $bOGMu.SignupUFOExperience)('company-expand.user-segmentation-advice.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$56157be5ba064cfc = new (0, $bOGMu.SignupUFOExperience)('company-expand.create-project.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$40efcfb31ac1efa2 = new (0, $bOGMu.SignupUFOExperience)('bxpui.confirmation-page-status-polling.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$f2b36adc7ea3d4fb = new (0, $bOGMu.SignupUFOExperience)('bxpui.confirmation-page-update-user-profile.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$93670d666aaba770 = new (0, $bOGMu.SignupUFOExperience)('bxpui.confirmation-page-team-type-selection.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$15729dc80d1b26cf = new (0, $bOGMu.SignupUFOExperience)('bxpui.confirmation-page-template-selection-continue.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$b5b50a2ad76a9aa3 = new (0, $bOGMu.SignupUFOExperience)('bxpui.confirmation-page-template-selection-back.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$7483953e3b70c45 = new (0, $bOGMu.SignupUFOExperience)('graphql-webook-setup.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$149824147e381b11 = new (0, $bOGMu.SignupUFOExperience)('graphql-subscription-setup.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$37cf0a10d749cb69 = new (0, $bOGMu.SignupUFOExperience)('graphql-get-provisioning-status.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$93808710b9120531 = new (0, $bOGMu.SignupUFOExperience)('bxpui.redirect-to-product-from-confirmation-page.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).ACTIVATE_STATUS_CCP_POLLING_API,
        (0, $lIWv2.UfoCustomTimingKey).CLOUD_STATUS_HAMS_POLLING_API,
        (0, $lIWv2.UfoCustomTimingKey).ROBOTS_VIEW_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).CONFLUENCE_ONBOARDING_STEPS_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).CONFLUENCE_ONBOARDING_SPINNER_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).CONFLUENCE_DEFAULT_CIRCLE_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).JIRA_ANIMATED_PROVISIONING_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_PROJECT_CREATE_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).JIRA_TEMPLATE_CHOICE_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).JIRA_USER_SEGMENTATION_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).USER_SEGMENTATION_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).TIPS_VIEW_DWELL_TIME,
        (0, $lIWv2.UfoCustomTimingKey).GRAPHQL_WEBHOOK_SETUP,
        (0, $lIWv2.UfoCustomTimingKey).GRAPHQL_SUBSCRIPTION_ACK,
        (0, $lIWv2.UfoCustomTimingKey).GRAPHQL_WEBHOOK_PROVISIONING_LATENCY
    ]
});
const $e1a6d13a9886934c$export$8742107465d7ad8f = new (0, $bOGMu.SignupUFOExperience)('bxpui.get-jira-sites-from-agg.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$363d2de92afe8e7 = new (0, $bOGMu.SignupUFOExperience)('bxpui.get-recaptcha-api.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$f81be27e62354595 = new (0, $bOGMu.SignupUFOExperience)('try-cloud-signup.slo', {
    type: (0, $kHXv1.ExperienceTypes).Load,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e1a6d13a9886934c$export$cd2c363597bd0b53 = new (0, $bOGMu.SignupUFOExperience)('try-cloud-signup.available-products.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$a00b95b8df4c6ff8 = new (0, $bOGMu.SignupUFOExperience)('try-cloud-signup.consent-config.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$7a7c3f59dea17f9 = new (0, $bOGMu.SignupUFOExperience)('try-cloud-signup.expand-free-validation.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$d6d4aa47db9fc9bf = new (0, $cHMqe.UFOExperience)('bxpui.paid-signup-page-load.slo', {
    type: (0, $kHXv1.ExperienceTypes).Load,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e1a6d13a9886934c$export$1b5a141920591df9 = new (0, $bOGMu.SignupUFOExperience)('bxpui.paid-signup-page-load-jsw.slo', {
    type: (0, $kHXv1.ExperienceTypes).Load,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e1a6d13a9886934c$export$17da59807f19bcf5 = new (0, $bOGMu.SignupUFOExperience)('bxpui.paid-signup-page-load-confluence.slo', {
    type: (0, $kHXv1.ExperienceTypes).Load,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e1a6d13a9886934c$export$2ade41d8cc00cdd1 = new (0, $bOGMu.SignupUFOExperience)('bxpui.paid-signup-page-load-jsm.slo', {
    type: (0, $kHXv1.ExperienceTypes).Load,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e1a6d13a9886934c$export$fb25c6edcfccd1ee = new (0, $bOGMu.SignupUFOExperience)('bxpui.bxp-gateway-anchor-parse', {
    type: (0, $kHXv1.ExperienceTypes).Operation,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).Custom
});
const $e1a6d13a9886934c$export$b455e85cb1a670d6 = new (0, $bOGMu.SignupUFOExperience)('bxpui.signup-form-load.slo', {
    type: (0, $kHXv1.ExperienceTypes).Load,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).STARGATE_AVAILABLE_PRODUCTS_API,
        (0, $lIWv2.UfoCustomTimingKey).STARGATE_USER_API
    ]
});
const $e1a6d13a9886934c$export$b668a56466b07df6 = new (0, $bOGMu.SignupUFOExperience)('bxpui.site-name-form-load.slo', {
    type: (0, $kHXv1.ExperienceTypes).Load,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).STARGATE_AVAILABLE_PRODUCTS_API
    ]
});
const $e1a6d13a9886934c$export$88a8b1f7795a4755 = new (0, $bOGMu.SignupUFOExperience)('bxpui.site-name-availability.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$5efb77ab7d4924a2 = new (0, $1jg7z.SignupReactUFO)('post-order.get-activation-type.slo');
const $e1a6d13a9886934c$export$d32222d13d2012ed = new (0, $1jg7z.SignupReactUFO)('post-order.existing-site-activation.slo');
const $e1a6d13a9886934c$export$50bc2958e0690914 = new (0, $1jg7z.SignupReactUFO)('post-order.new-site-activation.slo');
const $e1a6d13a9886934c$export$7d2e3f087e40b0f6 = new (0, $1jg7z.SignupReactUFO)('post-order.org-activation.slo');
const $e1a6d13a9886934c$export$684c084e8c82e830 = new (0, $1jg7z.SignupReactUFO)('post-order.account-org-list.slo');
const $e1a6d13a9886934c$export$79d58b2886ef4485 = new (0, $1jg7z.SignupReactUFO)('post-order.account-org-list-next-page.slo');
const $e1a6d13a9886934c$export$569d81616e2bd8d = new (0, $bOGMu.SignupUFOExperience)('provisioning-status-cloud-id-availability.slo', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$dead11e4b6847b1e = new (0, $bOGMu.SignupUFOExperience)('onboarding-wizard.project-create', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$be09b4532561475c = new (0, $bOGMu.SignupUFOExperience)('onboarding-wizard.project-create-including-provisioning', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).ONBOARDING_WIZARD_PROJECT_CREATE_API_CALL
    ]
});
const $e1a6d13a9886934c$export$22e6232eaf5bb2b6 = new (0, $bOGMu.SignupUFOExperience)('async-architecture.new-site-activation', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$74415081c316e26 = new (0, $bOGMu.SignupUFOExperience)('async-architecture.polling-status', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$993fa34c764c5b2d = new (0, $bOGMu.SignupUFOExperience)('onboarding.auto-select-theme-preference', {
    type: (0, $kHXv1.ExperienceTypes).Operation,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult
});
const $e1a6d13a9886934c$export$e21068351502f79 = new (0, $bOGMu.SignupUFOExperience)('onboarding.resolve-tenant-id', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).RESOLVE_TENANT_ID
    ]
});
const $e1a6d13a9886934c$export$edaa107857ee2d4d = new (0, $bOGMu.SignupUFOExperience)('onboarding.invite-users-step', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK,
        (0, $lIWv2.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_FETCHING_ROLES,
        (0, $lIWv2.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS,
        (0, $lIWv2.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_CHECKING_LICENSE
    ]
});
const $e1a6d13a9886934c$export$6f8fe3fb44db3f2d = new (0, $bOGMu.SignupUFOExperience)('onboarding.madlib-project-create', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).JIRA_ONBOARDING_MADLIB_PROJECT_CREATE
    ]
});
const $e1a6d13a9886934c$export$31bc284942dbe406 = new (0, $bOGMu.SignupUFOExperience)('onboarding.skipped-madlib-project-create', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).JIRA_ONBOARDING_DEFAULT_PROJECT_CREATE
    ]
});
const $e1a6d13a9886934c$export$9f70bbe5ec980f4 = new (0, $bOGMu.SignupUFOExperience)('percieved-provisioning-funnel', {
    type: (0, $kHXv1.ExperienceTypes).Experience,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
    customTimingKeys: [
        (0, $lIWv2.UfoCustomTimingKey).PERCEIVED_PROVISIONING_FUNNEL_TENANT_ID_RESOLUTION,
        (0, $lIWv2.UfoCustomTimingKey).PERCEIVED_PROVISIONING_FUNNEL_PROVISIONING_SUCCESS,
        (0, $lIWv2.UfoCustomTimingKey).PERCEIVED_PROVISIONING_FUNNEL_PROJECT_CREATION_INITIALIZED,
        (0, $lIWv2.UfoCustomTimingKey).PERCIEVED_PROVISIONING_FUNNEL_PROJECT_POLLING,
        (0, $lIWv2.UfoCustomTimingKey).PERCEIVED_PROVISIONING_FUNNEL_INVITE_TEAMMATES
    ]
});

});
parcelRegister("kHXv1", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", function () { return $f135fa262b24d7c9$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $f135fa262b24d7c9$export$cc26007c03242fff; });
var $f135fa262b24d7c9$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $f135fa262b24d7c9$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("cHMqe", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", function () { return $93ff0fcabddb28c7$export$c00d22927c60484a; });

var $iPt0G = parcelRequire("iPt0G");

var $efDqw = parcelRequire("efDqw");

var $9OLIx = parcelRequire("9OLIx");

var $h6zCS = parcelRequire("h6zCS");

var $khvHB = parcelRequire("khvHB");

var $6u3dX = parcelRequire("6u3dX");
function $93ff0fcabddb28c7$var$_callSuper(t, o, e) {
    return o = (0, $h6zCS.default)(o), (0, $9OLIx.default)(t, $93ff0fcabddb28c7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $h6zCS.default)(t).constructor) : o.apply(t, e));
}
function $93ff0fcabddb28c7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($93ff0fcabddb28c7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $93ff0fcabddb28c7$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    function UFOExperience() {
        (0, $efDqw.default)(this, UFOExperience);
        return $93ff0fcabddb28c7$var$_callSuper(this, UFOExperience, arguments);
    }
    (0, $khvHB.default)(UFOExperience, _UFOAbstractExperienc);
    return (0, $iPt0G.default)(UFOExperience);
}((0, $6u3dX.UFOAbstractExperience));

});
parcelRegister("iPt0G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db537e3755f47a5c$export$2e2bcd8739ae039; });

var $jcqTG = parcelRequire("jcqTG");
function $db537e3755f47a5c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $jcqTG.default)(o.key), o);
    }
}
function $db537e3755f47a5c$export$2e2bcd8739ae039(e, r, t) {
    return r && $db537e3755f47a5c$var$_defineProperties(e.prototype, r), t && $db537e3755f47a5c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("jcqTG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dfa400884264e7c4$export$2e2bcd8739ae039; });

var $diFvV = parcelRequire("diFvV");

var $3lwPI = parcelRequire("3lwPI");
function $dfa400884264e7c4$export$2e2bcd8739ae039(t) {
    var i = (0, $3lwPI.default)(t, "string");
    return "symbol" == (0, $diFvV.default)(i) ? i : i + "";
}

});
parcelRegister("diFvV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9aed289c0664741a$export$2e2bcd8739ae039; });
function $9aed289c0664741a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9aed289c0664741a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9aed289c0664741a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3lwPI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26fccd3ab73830a6$export$2e2bcd8739ae039; });

var $diFvV = parcelRequire("diFvV");
function $26fccd3ab73830a6$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $diFvV.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $diFvV.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("efDqw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a6010cbe89a54828$export$2e2bcd8739ae039; });
function $a6010cbe89a54828$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9OLIx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $725dcc3816384dcb$export$2e2bcd8739ae039; });

var $diFvV = parcelRequire("diFvV");

var $e9wEA = parcelRequire("e9wEA");
function $725dcc3816384dcb$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $diFvV.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $e9wEA.default)(t);
}

});
parcelRegister("e9wEA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4db3c4e77defea2$export$2e2bcd8739ae039; });
function $a4db3c4e77defea2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("h6zCS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c73ea1caf3b091b1$export$2e2bcd8739ae039; });
function $c73ea1caf3b091b1$export$2e2bcd8739ae039(t) {
    return $c73ea1caf3b091b1$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c73ea1caf3b091b1$export$2e2bcd8739ae039(t);
}

});

parcelRegister("khvHB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ec3dfc95b92ec0f6$export$2e2bcd8739ae039; });

var $ksMAI = parcelRequire("ksMAI");
function $ec3dfc95b92ec0f6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $ksMAI.default)(t, e);
}

});
parcelRegister("ksMAI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ee5c1d5b0efeabc1$export$2e2bcd8739ae039; });
function $ee5c1d5b0efeabc1$export$2e2bcd8739ae039(t, e) {
    return $ee5c1d5b0efeabc1$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ee5c1d5b0efeabc1$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6u3dX", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", function () { return $4b880bb01ac870da$export$d31c89db257648c; });

var $2Fxeg = parcelRequire("2Fxeg");

var $ciz3I = parcelRequire("ciz3I");

var $efDqw = parcelRequire("efDqw");

var $iPt0G = parcelRequire("iPt0G");

var $390SD = parcelRequire("390SD");

var $f4q6U = parcelRequire("f4q6U");

var $6T2ff = parcelRequire("6T2ff");

var $iluBR = parcelRequire("iluBR");

var $ljPsf = parcelRequire("ljPsf");

var $9sEG2 = parcelRequire("9sEG2");

var $JkpEu = parcelRequire("JkpEu");

var $b7FPt = parcelRequire("b7FPt");

var $agB35 = parcelRequire("agB35");

var $kuLAP = parcelRequire("kuLAP");

var $67CW1 = parcelRequire("67CW1");

var $3beYW = parcelRequire("3beYW");

var $kHXv1 = parcelRequire("kHXv1");
function $4b880bb01ac870da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b880bb01ac870da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b880bb01ac870da$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $390SD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b880bb01ac870da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4b880bb01ac870da$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $ljPsf.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $agB35.PageVisibleState).VISIBLE : (0, $agB35.PageVisibleState).HIDDEN;
};
var $4b880bb01ac870da$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $kuLAP.roundPerfNow)();
};
var $4b880bb01ac870da$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $efDqw.default)(this, UFOAbstractExperience);
        (0, $390SD.default)(this, "state", (0, $67CW1.UFOExperienceState).NOT_STARTED);
        (0, $390SD.default)(this, "instanceId", null);
        // for concurrent
        (0, $390SD.default)(this, "parent", null);
        (0, $390SD.default)(this, "category", null);
        (0, $390SD.default)(this, "metadata", {});
        (0, $390SD.default)(this, "onDoneCallbacks", []);
        (0, $390SD.default)(this, "childExperiences", []);
        (0, $390SD.default)(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, $390SD.default)(this, "isSSROutputAsFMP", false);
        (0, $390SD.default)(this, "uuid", null);
        (0, $390SD.default)(this, "_until", null);
        (0, $390SD.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $390SD.default)(this, "performanceConfig", {});
        (0, $390SD.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $agB35.PageVisibleState).MIXED;
            (0, $b7FPt.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $4b880bb01ac870da$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $kHXv1.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    return (0, $iPt0G.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $ciz3I.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $JkpEu.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $3beYW.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $JkpEu.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $67CW1.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $4b880bb01ac870da$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $6T2ff.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $4b880bb01ac870da$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $9sEG2.getGlobalEventStream)().push((0, $9sEG2.unsubscribeEvent)((0, $agB35.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $JkpEu.ufolog)('this.parent', this.parent);
                                (0, $9sEG2.getGlobalEventStream)().push((0, $9sEG2.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $JkpEu.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $JkpEu.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $ciz3I.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $67CW1.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $4b880bb01ac870da$var$getPageVisibleState();
                                    (0, $b7FPt.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $JkpEu.ufolog)('subscribed', this.id);
                                        (0, $9sEG2.getGlobalEventStream)().push((0, $9sEG2.subscribeEvent)((0, $agB35.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $agB35.FMP_MARK) && name !== (0, $agB35.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $JkpEu.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $4b880bb01ac870da$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $67CW1.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $agB35.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $agB35.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $JkpEu.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $b7FPt.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $ciz3I.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $67CW1.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $ciz3I.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $67CW1.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $ciz3I.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $67CW1.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $JkpEu.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $ciz3I.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $ciz3I.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($f4q6U))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $iluBR.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $4b880bb01ac870da$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $4b880bb01ac870da$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $2Fxeg.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
}();

});
parcelRegister("2Fxeg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f192fb3cac50266$export$2e2bcd8739ae039; });

var $kS1Ay = parcelRequire("kS1Ay");

var $LGoY1 = parcelRequire("LGoY1");

var $jhZxh = parcelRequire("jhZxh");

var $5FBuv = parcelRequire("5FBuv");
function $1f192fb3cac50266$export$2e2bcd8739ae039(r) {
    return (0, $kS1Ay.default)(r) || (0, $LGoY1.default)(r) || (0, $jhZxh.default)(r) || (0, $5FBuv.default)();
}

});
parcelRegister("kS1Ay", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f31a1544cb079682$export$2e2bcd8739ae039; });

var $2a7nP = parcelRequire("2a7nP");
function $f31a1544cb079682$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $2a7nP.default)(r);
}

});
parcelRegister("2a7nP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $19323e21b1865358$export$2e2bcd8739ae039; });
function $19323e21b1865358$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("LGoY1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $08f547fe80db4ead$export$2e2bcd8739ae039; });
function $08f547fe80db4ead$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("jhZxh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e0af56936e87f4d8$export$2e2bcd8739ae039; });

var $2a7nP = parcelRequire("2a7nP");
function $e0af56936e87f4d8$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2a7nP.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2a7nP.default)(r, a) : void 0;
    }
}

});

parcelRegister("5FBuv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $420ddd07d8d112d8$export$2e2bcd8739ae039; });
function $420ddd07d8d112d8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("ciz3I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8f425c72eadc1983$export$2e2bcd8739ae039; });
function $8f425c72eadc1983$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $8f425c72eadc1983$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $8f425c72eadc1983$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $8f425c72eadc1983$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("390SD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24a2e52bffd6f7b2$export$2e2bcd8739ae039; });

var $jcqTG = parcelRequire("jcqTG");
function $24a2e52bffd6f7b2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jcqTG.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("f4q6U", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $af8b7bb7f11b2863$var$runtime = (parcelRequire("hmrxi"))();
module.exports = $af8b7bb7f11b2863$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $af8b7bb7f11b2863$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $af8b7bb7f11b2863$var$runtime;
    else Function("r", "regeneratorRuntime = r")($af8b7bb7f11b2863$var$runtime);
}

});
parcelRegister("hmrxi", function(module, exports) {

var $l2Vo4 = parcelRequire("l2Vo4");

var $j0TvP = parcelRequire("j0TvP");

var $inM4s = parcelRequire("inM4s");

var $7NfbZ = parcelRequire("7NfbZ");

var $1O7lZ = parcelRequire("1O7lZ");

var $f8GBA = parcelRequire("f8GBA");

var $j9YTJ = parcelRequire("j9YTJ");
function $ca39d9d0d1873d2d$var$_regeneratorRuntime() {
    "use strict";
    var r = $j0TvP(), e = r.m($ca39d9d0d1873d2d$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $j9YTJ(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $ca39d9d0d1873d2d$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $l2Vo4(r, e);
            },
            AsyncIterator: $1O7lZ,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $7NfbZ : $inM4s)(a(r), e, t, o, u);
            },
            keys: $f8GBA,
            values: $j9YTJ
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $ca39d9d0d1873d2d$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("l2Vo4", function(module, exports) {
function $f5264cce5283232e$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $f5264cce5283232e$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("j0TvP", function(module, exports) {

var $9yk8I = parcelRequire("9yk8I");
function $dd7914081a7650cb$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $9yk8I(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($9yk8I(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $9yk8I(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $9yk8I(u, "constructor", GeneratorFunctionPrototype), $9yk8I(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $9yk8I(GeneratorFunctionPrototype, o, "GeneratorFunction"), $9yk8I(u), $9yk8I(u, o, "Generator"), $9yk8I(u, n, function() {
        return this;
    }), $9yk8I(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $dd7914081a7650cb$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $dd7914081a7650cb$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9yk8I", function(module, exports) {
function $6f46e9557197119a$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $6f46e9557197119a$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $6f46e9557197119a$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6f46e9557197119a$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $6f46e9557197119a$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("inM4s", function(module, exports) {

var $7NfbZ = parcelRequire("7NfbZ");
function $d61fa9ddd41bc129$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $7NfbZ(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $d61fa9ddd41bc129$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7NfbZ", function(module, exports) {

var $j0TvP = parcelRequire("j0TvP");

var $1O7lZ = parcelRequire("1O7lZ");
function $5ac8e4ebfc0ab2a6$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $1O7lZ($j0TvP().w(r, e, t, o), n || Promise);
}
module.exports = $5ac8e4ebfc0ab2a6$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1O7lZ", function(module, exports) {

var $l2Vo4 = parcelRequire("l2Vo4");

var $9yk8I = parcelRequire("9yk8I");
function $15102a39a6dd0648$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $l2Vo4 ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($9yk8I($15102a39a6dd0648$var$AsyncIterator.prototype), $9yk8I($15102a39a6dd0648$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $9yk8I(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $15102a39a6dd0648$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("f8GBA", function(module, exports) {
function $b058a6dcee4cf84c$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $b058a6dcee4cf84c$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("j9YTJ", function(module, exports) {

var $BSqHH = parcelRequire("BSqHH");
var $df2e189ff5cd6340$var$_typeof = $BSqHH.default;
function $df2e189ff5cd6340$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($df2e189ff5cd6340$var$_typeof(e) + " is not iterable");
}
module.exports = $df2e189ff5cd6340$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("BSqHH", function(module, exports) {
function $071dad6c124e5704$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $071dad6c124e5704$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $071dad6c124e5704$var$_typeof(o);
}
module.exports = $071dad6c124e5704$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("6T2ff", function(module, exports) {

var $dnIsD = parcelRequire("dnIsD");

var $1pZxf = parcelRequire("1pZxf");
var $50399ee881341f12$var$uuid = $1pZxf;
$50399ee881341f12$var$uuid.v1 = $dnIsD;
$50399ee881341f12$var$uuid.v4 = $1pZxf;
module.exports = $50399ee881341f12$var$uuid;

});
parcelRegister("dnIsD", function(module, exports) {

var $h2urt = parcelRequire("h2urt");

var $3GBj8 = parcelRequire("3GBj8");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $9bdfe95718319140$var$_nodeId;
var $9bdfe95718319140$var$_clockseq;
// Previous uuid creation time
var $9bdfe95718319140$var$_lastMSecs = 0;
var $9bdfe95718319140$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $9bdfe95718319140$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $9bdfe95718319140$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $9bdfe95718319140$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $h2urt();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $9bdfe95718319140$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $9bdfe95718319140$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $9bdfe95718319140$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $9bdfe95718319140$var$_lastMSecs + (nsecs - $9bdfe95718319140$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $9bdfe95718319140$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $9bdfe95718319140$var$_lastMSecs = msecs;
    $9bdfe95718319140$var$_lastNSecs = nsecs;
    $9bdfe95718319140$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $3GBj8(b);
}
module.exports = $9bdfe95718319140$var$v1;

});
parcelRegister("h2urt", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $c67a3cbde06d55b2$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($c67a3cbde06d55b2$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $c67a3cbde06d55b2$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $c67a3cbde06d55b2$var$getRandomValues($c67a3cbde06d55b2$var$rnds8);
        return $c67a3cbde06d55b2$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $c67a3cbde06d55b2$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $c67a3cbde06d55b2$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $c67a3cbde06d55b2$var$rnds;
    };
}

});

parcelRegister("3GBj8", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $2af23bdb5455dc89$var$byteToHex = [];
for(var $2af23bdb5455dc89$var$i = 0; $2af23bdb5455dc89$var$i < 256; ++$2af23bdb5455dc89$var$i)$2af23bdb5455dc89$var$byteToHex[$2af23bdb5455dc89$var$i] = ($2af23bdb5455dc89$var$i + 0x100).toString(16).substr(1);
function $2af23bdb5455dc89$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $2af23bdb5455dc89$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $2af23bdb5455dc89$var$bytesToUuid;

});


parcelRegister("1pZxf", function(module, exports) {

var $h2urt = parcelRequire("h2urt");

var $3GBj8 = parcelRequire("3GBj8");
function $1087dbda579c1fe6$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $h2urt)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $3GBj8(rnds);
}
module.exports = $1087dbda579c1fe6$var$v4;

});


parcelRegister("iluBR", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $d5b1ee9c40f55b7e$export$2295b861f318254a; });
// temp solution until we can get it automated
var $d5b1ee9c40f55b7e$export$2295b861f318254a = '0.1.5';

});

parcelRegister("ljPsf", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $f85349271d694c2d$export$15e172712955e18f; });
var $f85349271d694c2d$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});

parcelRegister("9sEG2", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", function () { return $6e364831c123d9bd$export$6123a44dc2384540; });
$parcel$export(module.exports, "setGlobalEventStream", function () { return $6e364831c123d9bd$export$c1522520b417b066; });
$parcel$export(module.exports, "subscribeEvent", function () { return $6e364831c123d9bd$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $6e364831c123d9bd$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $6e364831c123d9bd$export$7c957416596ca127; });

var $JkpEu = parcelRequire("JkpEu");

var $agB35 = parcelRequire("agB35");
var $6e364831c123d9bd$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $6e364831c123d9bd$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $6e364831c123d9bd$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $6e364831c123d9bd$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $JkpEu.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $6e364831c123d9bd$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $agB35.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $6e364831c123d9bd$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $agB35.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $6e364831c123d9bd$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $agB35.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("JkpEu", function(module, exports) {
$parcel$export(module.exports, "ufologger", function () { return $088409a11ba98e89$export$4ab84f6f04f6566d; });
$parcel$export(module.exports, "ufolog", function () { return $088409a11ba98e89$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $088409a11ba98e89$export$d53d07b6034c4560; });

var $efDqw = parcelRequire("efDqw");

var $iPt0G = parcelRequire("iPt0G");

var $390SD = parcelRequire("390SD");
var $088409a11ba98e89$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $efDqw.default)(this, UFOLogger);
        (0, $390SD.default)(this, "enabled", false);
    }
    return (0, $iPt0G.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
}();
(0, $390SD.default)($088409a11ba98e89$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $088409a11ba98e89$export$4ab84f6f04f6566d = new $088409a11ba98e89$var$UFOLogger();
var $088409a11ba98e89$export$b4958caff08a0960 = function ufolog() {
    $088409a11ba98e89$export$4ab84f6f04f6566d.log.apply($088409a11ba98e89$export$4ab84f6f04f6566d, arguments);
};
var $088409a11ba98e89$export$d53d07b6034c4560 = function ufowarn() {
    $088409a11ba98e89$export$4ab84f6f04f6566d.warn.apply($088409a11ba98e89$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("agB35", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $77982324b4ed8a44$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $77982324b4ed8a44$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $77982324b4ed8a44$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $77982324b4ed8a44$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $77982324b4ed8a44$export$837e0f79a8056912; });
var $77982324b4ed8a44$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $77982324b4ed8a44$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $77982324b4ed8a44$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $77982324b4ed8a44$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $77982324b4ed8a44$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $77982324b4ed8a44$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $77982324b4ed8a44$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $77982324b4ed8a44$export$9f2bf58999404c75 = 'fmp';
var $77982324b4ed8a44$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("b7FPt", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", function () { return $8190cb8efebb1cce$export$13e680397ec8f3eb; });

var $efDqw = parcelRequire("efDqw");

var $iPt0G = parcelRequire("iPt0G");

var $390SD = parcelRequire("390SD");

var $ljPsf = parcelRequire("ljPsf");
var $8190cb8efebb1cce$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $efDqw.default)(this, VisibilityChangeObserver);
        (0, $390SD.default)(this, "started", false);
        (0, $390SD.default)(this, "observers", []);
        (0, $390SD.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, $iPt0G.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $ljPsf.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $8190cb8efebb1cce$export$13e680397ec8f3eb = new $8190cb8efebb1cce$var$VisibilityChangeObserver();

});

parcelRegister("kuLAP", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", function () { return $eebb86f365b8f28e$export$5f490af6b2b115cf; });
var $eebb86f365b8f28e$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("67CW1", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", function () { return $4751992f428c6144$export$81b70111112841a0; });
var $4751992f428c6144$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3beYW", function(module, exports) {
$parcel$export(module.exports, "canTransition", function () { return $250e0545a428ecab$export$178881f329fdb81f; });

var $390SD = parcelRequire("390SD");

var $67CW1 = parcelRequire("67CW1");
var $250e0545a428ecab$var$UFOStateAvailableTransitions = (0, $390SD.default)((0, $390SD.default)((0, $390SD.default)((0, $390SD.default)((0, $390SD.default)((0, $390SD.default)((0, $390SD.default)((0, $390SD.default)((0, $390SD.default)({}, (0, $67CW1.UFOExperienceState).NOT_STARTED.id, [
    (0, $67CW1.UFOExperienceState).STARTED.id
]), (0, $67CW1.UFOExperienceState).STARTED.id, [
    (0, $67CW1.UFOExperienceState).IN_PROGRESS.id,
    (0, $67CW1.UFOExperienceState).BLOCKED.id,
    (0, $67CW1.UFOExperienceState).SUCCEEDED.id,
    (0, $67CW1.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $67CW1.UFOExperienceState).FAILED.id,
    (0, $67CW1.UFOExperienceState).ABORTED.id
]), (0, $67CW1.UFOExperienceState).IN_PROGRESS.id, [
    (0, $67CW1.UFOExperienceState).BLOCKED.id,
    (0, $67CW1.UFOExperienceState).SUCCEEDED.id,
    (0, $67CW1.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $67CW1.UFOExperienceState).FAILED.id,
    (0, $67CW1.UFOExperienceState).ABORTED.id
]), (0, $67CW1.UFOExperienceState).BLOCKED.id, [
    (0, $67CW1.UFOExperienceState).RECOVERED.id,
    (0, $67CW1.UFOExperienceState).ABORTED.id
]), (0, $67CW1.UFOExperienceState).RECOVERED.id, [
    (0, $67CW1.UFOExperienceState).STARTED.id,
    (0, $67CW1.UFOExperienceState).SUCCEEDED.id,
    (0, $67CW1.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $67CW1.UFOExperienceState).FAILED.id,
    (0, $67CW1.UFOExperienceState).ABORTED.id
]), (0, $67CW1.UFOExperienceState).SUCCEEDED.id, [
    (0, $67CW1.UFOExperienceState).STARTED.id
]), (0, $67CW1.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $67CW1.UFOExperienceState).SUCCEEDED.id,
    (0, $67CW1.UFOExperienceState).FAILED.id,
    (0, $67CW1.UFOExperienceState).ABORTED.id
]), (0, $67CW1.UFOExperienceState).FAILED.id, [
    (0, $67CW1.UFOExperienceState).STARTED.id
]), (0, $67CW1.UFOExperienceState).ABORTED.id, [
    (0, $67CW1.UFOExperienceState).STARTED.id
]);
var $250e0545a428ecab$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $250e0545a428ecab$var$UFOStateAvailableTransitions[state1.id] && $250e0545a428ecab$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("1jg7z", function(module, exports) {
$parcel$export(module.exports, "SignupReactUFO", function () { return $7d7e9706b8d7c0fd$export$8b22463170bb13fd; });

var $iIrIz = parcelRequire("iIrIz");

var $7bL3I = parcelRequire("7bL3I");

var $fBO1F = parcelRequire("fBO1F");
class $7d7e9706b8d7c0fd$export$8b22463170bb13fd {
    constructor(name){
        this.name = name;
        this.customData = {};
    }
    complete() {
        (0, $fBO1F.default)(this.name);
        (0, $iIrIz.addUFOCustomData)(this.customData);
    }
    addCustomData(data) {
        this.customData = {
            ...this.customData,
            ...data
        };
    }
    error(options) {
        const { errorName: errorName, errorMessage: errorMessage } = options;
        this.complete();
        (0, $7bL3I.setInteractionError)(this.name, {
            errorMessage: errorMessage,
            name: errorName
        });
    }
}

});
parcelRegister("iIrIz", function(module, exports) {
$parcel$export(module.exports, "addUFOCustomData", function () { return $da01d6412315bc4a$export$d12f56a472cdbe6c; });

var $1oC0p = parcelRequire("1oC0p");

var $iqOwP = parcelRequire("iqOwP");

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");
function $da01d6412315bc4a$export$2e2bcd8739ae039(_ref) {
    var data = _ref.data;
    var interactionContext = (0, $1oC0p.useContext)((0, $iqOwP.default));
    (0, $1oC0p.useMemo)(function() {
        if (!interactionContext) return;
        if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $da01d6412315bc4a$export$d12f56a472cdbe6c(data) {
    var interactionId = (0, $1BTY2.getInteractionId)();
    var currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') (0, $a48Mt.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $a48Mt.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("7bL3I", function(module, exports) {
$parcel$export(module.exports, "setInteractionError", function () { return $53be106ec3d54bed$export$5b689ca7b019e89f; });

var $a48Mt = parcelRequire("a48Mt");
function $53be106ec3d54bed$export$5b689ca7b019e89f(interactionName, error) {
    var interaction = (0, $a48Mt.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $a48Mt.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("fBO1F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b5d11dd7360cb914$export$2e2bcd8739ae039; });

var $51YSA = parcelRequire("51YSA");
function $b5d11dd7360cb914$var$traceUFOPress(name, timestamp) {
    return (0, $51YSA.default)(name, 'press', timestamp);
}
var $b5d11dd7360cb914$export$2e2bcd8739ae039 = $b5d11dd7360cb914$var$traceUFOPress;

});
parcelRegister("51YSA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3a9c45242b314a5d$export$2e2bcd8739ae039; });
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $jFqL6 = parcelRequire("jFqL6");

var $as5v9 = parcelRequire("as5v9");

var $03EZb = parcelRequire("03EZb");

var $bMbcH = parcelRequire("bMbcH");

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");

var $kBQuN = parcelRequire("kBQuN");
function $3a9c45242b314a5d$var$traceUFOInteraction(name, interactionType, startTime) {
    var _getMinorInteractions;
    if (!(0, $03EZb.isUFOEnabled)()) return;
    var rate = (0, $03EZb.getInteractionRate)(name, interactionType);
    var pressInteractionsList = (0, $03EZb.getDoNotAbortActivePressInteraction)();
    var minorInteractions = (pressInteractionsList !== null && pressInteractionsList !== void 0 ? pressInteractionsList : []).concat((_getMinorInteractions = (0, $03EZb.getMinorInteractions)()) !== null && _getMinorInteractions !== void 0 ? _getMinorInteractions : []);
    if (minorInteractions.includes(name)) {
        var _activeInteraction$mi;
        var activeInteraction = (0, $a48Mt.getActiveInteraction)();
        activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
            name: name,
            startTime: startTime !== null && startTime !== void 0 ? startTime : performance.now()
        });
        return;
    } else (0, $a48Mt.abortAll)('new_interaction', name);
    if ((0, $as5v9.default)(rate)) {
        var startTimestamp = startTime !== null && startTime !== void 0 ? startTime : performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        var newId = (0, $jFqL6.v4)();
        (0, $1BTY2.DefaultInteractionID).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $bMbcH.setInteractionActiveTrace)(newId, interactionType);
        (0, $a48Mt.addNewInteraction)(newId, name, interactionType === 'hover' ? 'press' : interactionType, // TODO add dedicated type for hover, might change backend though
        startTimestamp, rate, [], (0, $kBQuN.default).current, (0, $bMbcH.getActiveTrace)());
    }
}
var $3a9c45242b314a5d$export$2e2bcd8739ae039 = $3a9c45242b314a5d$var$traceUFOInteraction;

});



parcelRegister("bOGMu", function(module, exports) {
$parcel$export(module.exports, "SignupUFOExperience", function () { return $6af3545b1d0e3b94$export$4f206ee089497514; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $kHXv1 = parcelRequire("kHXv1");
var $cHMqe = parcelRequire("cHMqe");

var $gx3aw = parcelRequire("gx3aw");

var $eMftW = parcelRequire("eMftW");

var $cFAeM = parcelRequire("cFAeM");

var $lIWv2 = parcelRequire("lIWv2");
class $6af3545b1d0e3b94$export$4f206ee089497514 {
    constructor(id, config = {}){
        this._customTimingKeys = [];
        this._customData = {};
        const { customTimingKeys: customTimingKeys = [] } = config;
        const defaultConfig = {
            performanceType: (0, $kHXv1.ExperiencePerformanceTypes).InlineResult,
            type: (0, $kHXv1.ExperienceTypes).Experience,
            platform: {
                component: `signup`
            }
        };
        const ufoConfig = {
            ...defaultConfig,
            ...config
        };
        /*
     * Custom timings are used to measure sub-durations of an experience or page load
     *    eg. latency of API calls, time spent in loading UI, etc
     */ this._customTimingKeys = customTimingKeys;
        const customTimings = customTimingKeys.map((key)=>({
                key: key,
                startMark: `${key}_start`,
                endMark: `${key}_end`
            }));
        const perfPortalCustomTimings = customTimingKeys.map((key)=>({
                key: `${key}_perf`,
                startMark: `${key}_perf_start`,
                endMark: `${key}_perf_end`
            }));
        /*
     * We emit two UFO events:
     *   (1) used to build alerts & SLI/SLOs via SignalFX
     *   (2) used to create aggregated dashboard via Performance Portal
     */ this._signupFunnelUFO = new (0, $cHMqe.UFOExperience)(id, {
            ...ufoConfig,
            timings: customTimings
        });
        this._performancePortalUFO = new (0, $cHMqe.UFOExperience)(`${id}.perf`, {
            ...ufoConfig,
            timings: perfPortalCustomTimings
        });
    }
    setCustomData(customData) {
        try {
            Object.assign(this._customData, customData);
        } catch (message) {
            console.error(message);
        }
    }
    _buildErrorLogs(options) {
        const { error: error, customData: customData = {} } = options;
        const { errorOrigin: errorOrigin = '' } = customData;
        const errorData = {
            atlTraceId: undefined,
            errorName: 'none',
            errorMessage: 'none',
            errorStack: 'none',
            errorStatusCode: 0,
            errorReqPath: 'none',
            errorOrigin: errorOrigin
        };
        // Build error data if error present
        if (error) {
            if (error.name) errorData.errorName = error.name;
            if (error.stack) errorData.errorStack = error.stack;
            if (error.response) {
                if (error.response.status) errorData.errorStatusCode = error.response.status;
                if (error.response.headers) errorData.atlTraceId = error.response.headers.get('atl-traceid');
                errorData.errorOrigin += ', HTTP Error';
            } else errorData.errorOrigin += ', FE Error';
            if (error.url && typeof error.url === 'string') try {
                const errorUrl = new URL(error.url);
                errorData.errorReqPath = errorUrl ? new URL(errorUrl).pathname : 'unknown';
            } catch (err) {
                console.log('error building UFO error custom data: ', err);
            }
            if (error.message) errorData.errorMessage = error.message;
        }
        return errorData;
    }
    _buildHttpLogs(options) {
        const { customData: customData = {} } = options;
        const { atlTraceId: atlTraceId = 'unknown', errorMessage: errorMessage, errorStatusCode: errorStatusCode, errorReqPath: errorReqPath, reqPath: reqPath, statusCode: statusCode, message: message } = customData;
        const httpData = {
            atlTraceId: atlTraceId,
            reqPath: reqPath,
            statusCode: statusCode,
            message: message
        };
        if (!reqPath) httpData.reqPath = errorReqPath;
        if (!statusCode) httpData.statusCode = errorStatusCode;
        if (!message) httpData.message = errorMessage;
        return httpData;
    }
    static BuildCustomBaseData() {
        // We want to use 'analyticsAnonymousId' to link the interaction to the user via Splunk logs
        const analyticsAnonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id');
        // Build base stack for UFO logger
        const browserUrl = new URL(window?.location?.href);
        const browserPath = browserUrl?.pathname;
        const product = browserUrl.searchParams.get('product');
        const bundle = browserUrl.searchParams.get('bundle');
        const edition = browserUrl.searchParams.get('edition');
        const baseData = {
            ...analyticsAnonymousId ? {
                analyticsAnonymousId: analyticsAnonymousId
            } : {},
            ...browserPath ? {
                browserPath: browserPath
            } : {},
            ...product ? {
                product: product
            } : {},
            ...bundle ? {
                bundle: bundle
            } : {},
            ...edition ? {
                edition: edition
            } : {}
        };
        return baseData;
    }
    _buildCustomDataLogs(options) {
        const { customData: customData = {}, isPerformancePortal: isPerformancePortal = false } = options;
        const baseData = $6af3545b1d0e3b94$export$4f206ee089497514.BuildCustomBaseData();
        const productKey = this._customData['productKey'];
        if (productKey) baseData.product = productKey;
        const errorLogs = this._buildErrorLogs(options);
        const errorOrigin = errorLogs.errorOrigin;
        const httpLogs = this._buildHttpLogs({
            ...options,
            customData: {
                ...errorLogs,
                ...customData
            }
        });
        return {
            isPerformancePortal: isPerformancePortal,
            reactComponent: 'unknown',
            ...baseData,
            ...errorLogs,
            ...httpLogs,
            ...this._customData,
            ...customData,
            ...errorOrigin ? {
                errorOrigin: errorOrigin
            } : {}
        };
    }
    _isValidBadEventSLI(error) {
        // Undefined errors are "valid bad events", eg. error UI rendered
        if (!error) return true;
        const isHttpError = Boolean(error.response);
        // Non-http errors are "valid bad events", ie. included in FE SLO/SLI
        if (!isHttpError) return true;
        const errorStatusCode = error.response.status;
        // Rate limit errors are "invalid bad events", ie. scrubbed from FE SLO/SLI
        if (errorStatusCode === 429) return false;
        // Blocked locale errors are "invalid bad events"
        if (errorStatusCode === 422) return false;
        //  "recaptcha and bans throw 400 invalid bad events."
        if (errorStatusCode === 400) return false;
        const isShadowItRedirectError = errorStatusCode === 403 && Boolean((0, $eMftW.getRedirectUrlFromShadowItError)(error));
        // Shadow IT redirect errors are "invalid bad events"
        if (isShadowItRedirectError) return false;
        // Exclude 403s from SLO and mark them as "invalid bad events"
        if (errorStatusCode === 403) return false;
        // Otherwise, all other http errors are "valid bad events"
        return true;
    }
    /*
   * Platform config is used to build `experienceKey` for UFO events,
   *    which is used to query logs, define good/bad events for FE SLOs, etc.
   *
   * Add cohorts to UFO for better observability breakdown (ie. metrics by product, etc.)
   */ setPlatformConfig(options = {}) {
        const { productKey: productKey, bundle: bundle, webPlatform: webPlatform, edition: edition, bundleProductKeys: bundleProductKeys } = options;
        /*
     * Build `experienceKey` with passed-in cohort values
     */ const productCohort = (0, $cFAeM.getProductCohortByKey)(productKey);
        const bundleCohort = (0, $cFAeM.getBundleCohort)(bundle);
        const webPlatformCohort = (0, $cFAeM.getWebPlatformCohort)(webPlatform);
        const editionCohort = (0, $cFAeM.getEdition)(edition);
        // eg. ...[signup].some-event.slo
        let experienceKeyPrefix = `signup`;
        if (bundleProductKeys?.includes(',')) // eg. ...signup.bundle.some-event.slo
        experienceKeyPrefix += `.bundle`;
        else if (productCohort !== (0, $lIWv2.UfoCustomDataProductCohort).NOT_FOUND) // eg. ...signup.[confluence].some-event.slo
        experienceKeyPrefix += `.${productCohort}`;
        else if (bundleCohort !== (0, $lIWv2.UfoCustomDataBundleCohort).NOT_FOUND) // eg. ...signup.[devops].some-event.slo
        experienceKeyPrefix += `.${bundleCohort}`;
        this._signupFunnelUFO.config.platform = {
            component: experienceKeyPrefix
        };
        // Force Perf Event to use `signup` as component to create aggregated dashboard
        this._performancePortalUFO.config.platform = {
            component: `signup`
        };
        // Set custom data
        this.setCustomData({
            productKey: productKey,
            productCohort: productCohort,
            bundle: bundle,
            bundleCohort: bundleCohort,
            webPlatform: webPlatform,
            webPlatformCohort: webPlatformCohort,
            edition: edition,
            editionCohort: editionCohort,
            bundleProductKeys: bundleProductKeys
        });
    }
    setErrorLogs(options) {
        try {
            const errorLogs = this._buildErrorLogs(options);
            const errorOrigin = errorLogs.errorOrigin;
            const httpLogs = this._buildHttpLogs({
                ...options,
                customData: {
                    ...errorLogs,
                    ...options.customData
                }
            });
            const customData = {
                ...options.customData,
                ...errorLogs,
                ...httpLogs,
                ...this._customData,
                ...errorOrigin ? {
                    errorOrigin: errorOrigin
                } : {}
            };
            this.setCustomData(customData);
        } catch (message) {
            console.error(message);
        }
    }
    async startSubstep(key, options = {}) {
        try {
            const { startTimestamp: startTimestamp } = options;
            const startMark = `${key}_start`;
            const perfStartMark = `${key}_perf_start`;
            this._signupFunnelUFO.mark(startMark, startTimestamp);
            this._performancePortalUFO.mark(perfStartMark, startTimestamp);
        } catch (message) {
            console.error(message);
        }
    }
    async endSubstep(key, options = {}) {
        try {
            const { endTimestamp: endTimestamp, error: error, customData: customData } = options;
            if (customData) this.setCustomData(customData);
            // Only update error logs if error present
            if (error) this.setErrorLogs({
                error: error,
                customData: customData
            });
            const endMark = `${key}_end`;
            const perfEndMark = `${key}_perf_end`;
            this._signupFunnelUFO.mark(endMark, endTimestamp);
            this._performancePortalUFO.mark(perfEndMark, endTimestamp);
        } catch (message) {
            console.error(message);
        }
    }
    async _endAllSubsteps() {
        try {
            const promises = this._customTimingKeys.map((key)=>this.endSubstep(key));
            await Promise.all(promises);
        } catch (message) {
            console.error(message);
        }
    }
    /**
   * Returns substep custom timings from the underlying UFO experience marks.
   * Only includes keys that have both start and end marks.
   */ getSubstepTimings() {
        const result = {};
        try {
            const { marks: marks = [] } = this._signupFunnelUFO.metrics ?? {};
            for (const key of this._customTimingKeys){
                const startMark = marks.find((m)=>m.name === `${key}_start`);
                const endMark = marks.find((m)=>m.name === `${key}_end`);
                if (!startMark || !endMark) continue;
                const startTime = startMark.time;
                const duration = endMark.time - startMark.time;
                result[key] = {
                    startTime: startTime,
                    duration: duration
                };
            }
        } catch (message) {
            console.error(message);
        }
        return result;
    }
    async start(options = {}) {
        try {
            // Add cohort to UFO event (ie. metrics by product)
            this.setPlatformConfig(options);
            await Promise.all([
                this._signupFunnelUFO.start(),
                this._performancePortalUFO.start()
            ]);
        } catch (message) {
            console.error(message);
        }
    }
    _setExplicitTiming(timing) {
        if (!this._performancePortalUFO.explicitTimings) this._performancePortalUFO.explicitTimings = {};
        if (!this._signupFunnelUFO.explicitTimings) this._signupFunnelUFO.explicitTimings = {};
        Object.assign(this._performancePortalUFO.explicitTimings, timing);
        Object.assign(this._signupFunnelUFO.explicitTimings, timing);
    }
    _addPageLoadTimings() {
        if (this._performancePortalUFO.config.performanceType === (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad && window?.performance) {
            const navigationPerformanceTime = window.performance?.getEntriesByType('navigation')?.[0];
            const performanceTimeOrigin = Math.round(window.performance.timeOrigin);
            if (performanceTimeOrigin && navigationPerformanceTime) {
                const domContentLoadedEventStart = Math.round(navigationPerformanceTime.domContentLoadedEventStart);
                const requestStart = Math.round(navigationPerformanceTime.requestStart);
                const responseStart = Math.round(navigationPerformanceTime.responseStart);
                const startTimeStamp = performanceTimeOrigin + requestStart;
                const fmpDurationMs = domContentLoadedEventStart;
                const fftbDurationMs = responseStart - requestStart;
                const ttiDuration = Math.round(navigationPerformanceTime.duration);
                this._setExplicitTiming({
                    fmp: {
                        startTime: performanceTimeOrigin,
                        duration: fmpDurationMs
                    }
                });
                this._setExplicitTiming({
                    ttfb: {
                        startTime: startTimeStamp,
                        duration: fftbDurationMs
                    }
                });
                this._setExplicitTiming({
                    tti: {
                        startTime: performanceTimeOrigin,
                        duration: ttiDuration
                    }
                });
            }
        }
    }
    async success(options = {}) {
        try {
            // Before completing the event, we end the sub-duration for all remaining sub-steps that have been started
            await this._endAllSubsteps();
            // Time-to-first-byte (TTFB) timing for page load UFO events.
            this._addPageLoadTimings();
            await Promise.all([
                // `SUCCEEDED` UFO emitted for "good event", ie. included in FE SLO/SLI
                this._signupFunnelUFO.success({
                    metadata: this._buildCustomDataLogs(options)
                }),
                // UFO emitted for Performance Portal to breakdown metrics by cohort
                this._performancePortalUFO.success({
                    metadata: this._buildCustomDataLogs({
                        ...options,
                        isPerformancePortal: true
                    })
                })
            ]);
        } catch (message) {
            console.error(message);
        }
    }
    async failure(options) {
        try {
            // Before completing the event, we end the sub-duration for all remaining sub-steps that have been started
            await this._endAllSubsteps();
            /*
       * Scrub errors that are "invalid bad events" from FE SLI/SLO
       *   eg. 429 rate limit, 422 blocked locale, 400 recaptcha
       */ const isValidBadEventSLI = this._isValidBadEventSLI(options?.error);
            if (isValidBadEventSLI) await Promise.all([
                // `FAILED` UFO emitted for "valid bad event", ie. included in FE SLO/SLI
                this._signupFunnelUFO.failure({
                    metadata: this._buildCustomDataLogs(options)
                }),
                // UFO emitted for Performance Portal to breakdown metrics by cohort
                this._performancePortalUFO.failure({
                    metadata: this._buildCustomDataLogs({
                        ...options,
                        isPerformancePortal: true
                    })
                })
            ]);
            else // "Aborted" UFO emitted for "invalid bad event", ie. scrubbed from FE SLO/SLI
            await this.abort(options);
        } catch (message) {
            console.error(message);
        }
    }
    async abort(options) {
        try {
            // Before completing the event, we end the sub-duration for all remaining sub-steps that have been started
            await this._endAllSubsteps();
            await Promise.all([
                // `ABORTED` UFO emitted for logging, ie. scrubbed from FE SLO/SLI
                this._signupFunnelUFO.abort({
                    metadata: this._buildCustomDataLogs(options)
                }),
                // UFO emitted for Performance Portal to breakdown metrics by cohort
                this._performancePortalUFO.abort({
                    metadata: this._buildCustomDataLogs({
                        ...options,
                        isPerformancePortal: true
                    })
                })
            ]);
        } catch (message) {
            console.error(message);
        }
    }
}

});
parcelRegister("eMftW", function(module, exports) {
$parcel$export(module.exports, "getRedirectUrlFromShadowItError", function () { return $52c2dc4da6f3371a$export$1ca27ad470ab9a4c; });
function $52c2dc4da6f3371a$export$1ca27ad470ab9a4c(error) {
    const errorResponse = error.message?.trim();
    // different browsers may have different error shapes
    const errorBody = errorResponse.startsWith('Forbidden') ? // Firefox, eg.'Forbidden {"redirectUrl":"https://some-url.com"}'
    errorResponse.substring(9).trim() : // Chrome and others, eg.'{"redirectUrl":"https://some-url.com"}'
    errorResponse;
    try {
        // extract redirect url from error body
        return JSON.parse(errorBody)?.redirectUrl;
    } catch (err) {
        console.warn('Shadow IT redirectUrl is not valid JSON');
        return '';
    }
}

});

parcelRegister("cFAeM", function(module, exports) {
$parcel$export(module.exports, "getProductCohortByKey", function () { return $0f8d2cf0333762d3$export$f82411362e5e25ac; });
$parcel$export(module.exports, "getBundleCohort", function () { return $0f8d2cf0333762d3$export$e9e1a9852ee51ca3; });
$parcel$export(module.exports, "getSiteTypeCohort", function () { return $0f8d2cf0333762d3$export$215523adca76f926; });
$parcel$export(module.exports, "getWebPlatformCohort", function () { return $0f8d2cf0333762d3$export$8a62990a303cb185; });
$parcel$export(module.exports, "getEdition", function () { return $0f8d2cf0333762d3$export$acf25cbc735b9b90; });
$parcel$export(module.exports, "getUfoSubstepForPolling", function () { return $0f8d2cf0333762d3$export$3f9ddfc12dcc1171; });

var $fcO7r = parcelRequire("fcO7r");

var $lIWv2 = parcelRequire("lIWv2");
function $0f8d2cf0333762d3$export$f82411362e5e25ac(productKey) {
    if (!productKey) return 'not-found';
    switch(productKey){
        case (0, $fcO7r.ProductKey).CONFLUENCE:
            return 'confluence';
        case (0, $fcO7r.ProductKey).JIRA_SOFTWARE:
            return 'jira-software';
        case (0, $fcO7r.ProductKey).JIRA_WORK_MANAGEMENT:
            return 'jira-work-management';
        case (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT:
            return 'jira-service-management';
        case (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case (0, $fcO7r.ProductKey).OPSGENIE:
            return 'opsgenie';
        case (0, $fcO7r.ProductKey).LOOM:
            return 'loom';
        default:
            return 'other';
    }
}
function $0f8d2cf0333762d3$export$e9e1a9852ee51ca3(bundle) {
    if (!bundle) return 'not-found';
    return bundle;
}
function $0f8d2cf0333762d3$export$215523adca76f926(isNewSite) {
    const siteTypeCohort = isNewSite ? 'new-site-n2n' : 'existing-site-n2e';
    return siteTypeCohort;
}
function $0f8d2cf0333762d3$export$8a62990a303cb185(webPlatform) {
    if (!webPlatform) return 'unknown';
    return webPlatform;
}
function $0f8d2cf0333762d3$export$acf25cbc735b9b90(edition) {
    if (!edition) return 'unknown';
    return edition;
}
function $0f8d2cf0333762d3$export$3f9ddfc12dcc1171(billingPlatform) {
    const timingKey = billingPlatform === 'ccp' ? (0, $lIWv2.UfoCustomTimingKey).ACTIVATE_STATUS_CCP_POLLING_API : (0, $lIWv2.UfoCustomTimingKey).CLOUD_STATUS_HAMS_POLLING_API;
    const requestPath = billingPlatform === 'ccp' ? '/activate/status/:provisioningRequestId' : '/cofs/:cloudId/status/:requestId';
    return {
        timingKey: timingKey,
        requestPath: requestPath
    };
}

});
parcelRegister("lIWv2", function(module, exports) {
$parcel$export(module.exports, "UfoEventName", function () { return $f2f367b286f0e5c0$export$c3292c0ecf9d1ed1; });
$parcel$export(module.exports, "UfoExperienceStatus", function () { return $f2f367b286f0e5c0$export$d79b2e9dc301cf70; });
$parcel$export(module.exports, "UfoInteractionType", function () { return $f2f367b286f0e5c0$export$14a63aec7e354872; });
$parcel$export(module.exports, "UfoCustomTimingKey", function () { return $f2f367b286f0e5c0$export$90a51f9e6068b063; });
$parcel$export(module.exports, "UfoCustomDataProductCohort", function () { return $f2f367b286f0e5c0$export$113d8f1bc5a68886; });
$parcel$export(module.exports, "UfoCustomDataBundleCohort", function () { return $f2f367b286f0e5c0$export$be495791f9336453; });
// https://developer.atlassian.com/platform/ufo/ufo-core/intro-and-basics/taxonomy/
const $f2f367b286f0e5c0$export$c3292c0ecf9d1ed1 = {
    /**
   * Land Step — User can view signup pages
   * - Tome SLOs: https://tome.prod.atl-paas.net/capability/4cba7cce-f259-4957-b071-297d12f2a2e2
   **/ ENTER_SIGNUP_FLOW_SLO_SUCCEEDED: 'enter-signup-flow.slo-succeeded',
    ENTER_SIGNUP_FLOW_SLO_FAILED: 'enter-signup-flow.slo-failed',
    /**
   * Land Step — User can submit to start site and/or product activation
   * - Tome SLOs: https://tome.prod.atl-paas.net/capability/5eb87129-93bf-4299-bb87-647274daab95
   **/ // Default submit captured across bxpui and bxpkit
    DEFAULT_SIGNUP_SUBMIT_SLO_SUCCEEDED: 'default-signup-submit.slo-succeeded',
    DEFAULT_SIGNUP_SUBMIT_SLO_FAILED: 'default-signup-submit.slo-failed',
    BXPUI_SIGNUP_SUBMIT_SLO_SUCCEEDED: 'bxpui-signup-submit.slo-succeeded',
    BXPUI_SIGNUP_SUBMIT_SLO_FAILED: 'bxpui-signup-submit.slo-failed',
    BXPKIT_SIGNUP_SUBMIT_SLO_SUCCEEDED: 'bxpkit-signup-form-submit.slo-succeeded',
    BXPKIT_SIGNUP_SUBMIT_SLO_FAILED: 'bxpkit-signup-form-submit.slo-failed',
    /* Events */ ACTIVATE_PRODUCT_API_SUCCESS: 'activate-product-api.success',
    ACTIVATE_PRODUCT_API_ERROR: 'activate-product-api.error',
    /**
   * Experiment - Confluence set up over provisioning
   * - statsig setup: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/cfind-1054_confluence_set_up_over_provisioning/setup
   */ CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_INVITE_LINK_FETCH_ERROR: 'cfind-1054-confluence-set-up-over-provisioning.invite-link-fetch-error',
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_RECEIVED: 'cfind-1054-confluence-set-up-over-provisioning.onboarding-response-received',
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_MISSING: 'cfind-1054-confluence-set-up-over-provisioning.onboarding-response-missing',
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_ERROR: 'cfind-1054-confluence-set-up-over-provisioning.onboarding-response-error'
};
const $f2f367b286f0e5c0$export$d79b2e9dc301cf70 = {
    SUCCEEDED: 'SUCCEEDED',
    ABORTED: 'ABORTED'
};
const $f2f367b286f0e5c0$export$14a63aec7e354872 = {
    PAGE_LOAD: 'page-load',
    PRESS: 'press',
    TYPING: 'typing',
    TRANSITION: 'transition',
    CUSTOM: 'custom'
};
const $f2f367b286f0e5c0$export$90a51f9e6068b063 = {
    STARGATE_AVAILABLE_PRODUCTS_API: 'stargate_available_products_api',
    STARGATE_CONSENT_CONFIG_API: 'stargate_consent_config_api',
    STARGATE_EXPAND_FREE_VALIDATION_API: 'stargate_expand_free_validation_api',
    STARGATE_USER_API: 'stargate_user_api',
    IDENTITY_USER_SIGNUP_API: 'identity_user_signup_api',
    ACTIVATE_STATUS_CCP_POLLING_API: 'activate_status_ccp_polling_api',
    CLOUD_STATUS_HAMS_POLLING_API: 'cloud_status_hams_polling_api',
    ROBOTS_VIEW_DWELL_TIME: 'robots_view_dwell_time',
    CONFLUENCE_DEFAULT_CIRCLE_DWELL_TIME: 'confluence_default_circle_dwell_time',
    CONFLUENCE_ONBOARDING_SPINNER_DWELL_TIME: 'confluence_onboarding_spinner_dwell_time',
    CONFLUENCE_ONBOARDING_STEPS_DWELL_TIME: 'confluence_onboarding_steps_dwell_time',
    JIRA_ANIMATED_PROVISIONING_DWELL_TIME: 'jira_animated_provisioning_dwell_time',
    JIRA_ONBOARDING_WIZARD_PROJECT_CREATE_DWELL_TIME: 'jira_onboarding_wizard_project_create_dwell_time',
    JIRA_TEMPLATE_CHOICE_DWELL_TIME: 'jira_template_choice_dwell_time',
    JIRA_USER_SEGMENTATION_DWELL_TIME: 'jira_user_segmentation_dwell_time',
    JIRA_PRODUCT_DISCOVERY_ONBOARDING_SPINNER_DWELL_TIME: 'jira_product_discovery_onboarding_spinner_dwell_time',
    USER_SEGMENTATION_DWELL_TIME: 'user_segmentation_dwell_time',
    TIPS_VIEW_DWELL_TIME: 'tips_view_dwell_time',
    GRAPHQL_WEBHOOK_SETUP: 'graphql_webhook_setup',
    GRAPHQL_SUBSCRIPTION_ACK: 'graphql_subscription_ack',
    GRAPHQL_WEBHOOK_PROVISIONING_LATENCY: 'graphql_webhook_provisioning_latency',
    ONBOARDING_WIZARD_PROJECT_CREATE_API_CALL: 'onboarding-wizard.project-create-api',
    SERVICE_COLLECTION_PROVISIONING_VIEW_DWELL_TIME: 'service_collection_provisioning_view_dwell_time',
    TWC_PROVISIONING_DWELL_TIME: 'twc_provisioning_dwell_time',
    JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK: 'JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK',
    JIRA_ONBOARDING_WIZARD_INVITE_FETCHING_ROLES: 'jira_onboarding_wizard_invite_fetching_roles',
    JIRA_ONBOARDING_WIZARD_INVITE_CHECKING_LICENSE: 'jira_onboarding_wizard_invite_checking_license',
    JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS: 'jira_onboarding_wizard_invite_inviting_users',
    RESOLVE_TENANT_ID: 'resolve_tenant_id',
    JIRA_ONBOARDING_MADLIB_PROJECT_CREATE: 'jira_onboarding_madlib_project_create',
    JIRA_ONBOARDING_DEFAULT_PROJECT_CREATE: 'jira_onboarding_default_project_create',
    // Perceived provisioning funnel timings
    PERCEIVED_PROVISIONING_FUNNEL_TENANT_ID_RESOLUTION: 'perceived_provisioning_funnel_tenant_id_resolution',
    PERCEIVED_PROVISIONING_FUNNEL_PROVISIONING_SUCCESS: 'perceived_provisioning_funnel_provisioning_success',
    PERCEIVED_PROVISIONING_FUNNEL_PROJECT_CREATION_INITIALIZED: 'perceived_provisioning_funnel_project_creation_initialized',
    PERCIEVED_PROVISIONING_FUNNEL_PROJECT_POLLING: 'perceived_provisioning_funnel_project_polling',
    PERCEIVED_PROVISIONING_FUNNEL_INVITE_TEAMMATES: 'perceived_provisioning_funnel_invite_teammates',
    PERCEIVED_PROVISIONING_FUNNEL_LAND_IN_PRODUCT: 'perceived_provisioning_funnel_land_in_product'
};
const $f2f367b286f0e5c0$export$113d8f1bc5a68886 = {
    JIRA_SOFTWARE: 'jira-software',
    CONFLUENCE: 'confluence',
    JIRA_WORK_MANAGEMENT: 'jira-work-management',
    JIRA_SERVICE_MANAGEMENT: 'jira-service-management',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    OPSGENIE: 'opsgenie',
    LOOM: 'loom',
    OTHER: 'other',
    NOT_FOUND: 'not-found'
};
const $f2f367b286f0e5c0$export$92f8fdd7327872bb = {
    NEW_SITE_N2N: 'new-site-n2n',
    EXISTING_SITE_N2E: 'existing-site-n2e',
    NOT_FOUND: 'not-found'
};
const $f2f367b286f0e5c0$export$be495791f9336453 = {
    DEVOPS: 'devops',
    LOOM: 'loom',
    JIRA_SERVICE_MANAGEMENT: 'jira-service-management',
    NOT_FOUND: 'not-found'
};
const $f2f367b286f0e5c0$export$8aac3a3734ca3f6 = {
    BXP_UI: 'bxp-ui',
    BXPKIT: 'bxpkit',
    UNKNOWN: 'unknown'
};
const $f2f367b286f0e5c0$export$6e7cbf29070a70c4 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    UNKNOWN: 'unknown'
};

});




parcelRegister("3dtkR", function(module, exports) {
$parcel$export(module.exports, "useProductIntent", function () { return $4bc8de647b9f3997$export$93cccec4b411f62; });

var $1oC0p = parcelRequire("1oC0p");

var $fcO7r = parcelRequire("fcO7r");

var $22G6d = parcelRequire("22G6d");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $8uO0X = parcelRequire("8uO0X");
const $4bc8de647b9f3997$export$93cccec4b411f62 = (location)=>(0, $1oC0p.useMemo)(()=>$4bc8de647b9f3997$export$d72c7d8040ef3582(location), [
        location
    ]);
const $4bc8de647b9f3997$export$d72c7d8040ef3582 = (location)=>{
    let edition;
    let product;
    let bundle;
    let url;
    try {
        url = new URL(location);
    } catch (e) {
        return {
            edition: edition,
            product: product
        };
    }
    if (url.pathname.includes('/software/jira/product-discovery')) {
        product = {
            bundle: 'jira-product-discovery',
            description: 'Jira Product Discovery',
            key: (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY,
            name: 'jira-product-discovery'
        };
        edition = 'free';
    } else if (url.pathname.includes('/software/jira/service-management')) {
        product = {
            bundle: 'service-collection',
            description: 'Service Collection',
            key: (0, $fcO7r.ProductKey).SERVICE_COLLECTION,
            name: 'service-collection'
        };
        edition = 'free';
    } else if (url.pathname.includes('/software/jira')) {
        product = {
            bundle: 'jira-software',
            description: 'Jira',
            key: (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
            name: 'jira'
        };
        edition = 'free';
    }
    if (url.pathname.includes('/software/confluence')) {
        product = {
            bundle: 'confluence',
            description: 'Confluence',
            key: (0, $fcO7r.ProductKey).CONFLUENCE,
            name: 'confluence'
        };
        edition = 'free';
    }
    if (url.pathname.includes('/collections/teamwork')) {
        product = {
            bundle: 'teamwork-collection',
            description: 'Teamwork Collection',
            key: (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION,
            name: 'teamwork-collection'
        };
        edition = 'premium';
    }
    const isSignupPage = url.pathname.endsWith('/try/cloud/signup');
    const isConfirmationPage = url.pathname.endsWith('/ondemand/signup/confirmation');
    // @ts-ignore
    if (isSignupPage || isConfirmationPage || window.IS_STORYBOOK) {
        // defaults for the signup page
        if (isSignupPage) {
            edition = 'free';
            product = (0, $8uO0X.defaultProduct);
            bundle = (0, $8uO0X.defaultProduct).bundle;
        }
        // determine product
        if (url.searchParams.has('product')) {
            const foundProduct = (0, $8uO0X.products).find((product)=>product.key === url.searchParams.get('product'));
            if (foundProduct) {
                product = foundProduct;
                if (foundProduct.bundle) bundle = foundProduct.bundle;
            }
        } else if (url.searchParams.has('bundle')) {
            const bundleParam = url.searchParams.get('bundle');
            // validate bundle
            const collections = [
                'service-collection',
                'teamwork-collection'
            ];
            const isValidBundle = (0, $22G6d.defaultProductData)[bundleParam] !== undefined || collections.includes(bundleParam);
            // only set bundle = param if valid param; this affects how we define product
            if (isValidBundle) bundle = bundleParam;
            product = (0, $8uO0X.products).find((product)=>product.bundle === bundle);
        } else if (url.searchParams.has('products')) product = (0, $8uO0X.products).find((product)=>product.key === url.searchParams.get('products')?.split(',')[0]);
        // bxpkit developer signup bundle
        if (url.searchParams.get('developer')) {
            product = undefined;
            bundle = 'developer';
        }
        // opsgenie EOL
        if (bundle === 'opsgenie' && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp6524OpsgenieSignupEol)) bundle = 'jira-service-management';
        // determine edition
        const editionParam = url.searchParams.get('edition');
        if (editionParam === 'free') edition = 'free';
        else if (editionParam === 'standard') edition = 'standard';
        else if (editionParam === 'premium') edition = 'premium';
        /**
     * Handle rovo dev standard signup experience
     */ if (bundle === 'devai' && edition === 'standard') product = {
            ...product,
            description: 'Rovo Dev'
        };
    }
    return {
        edition: edition,
        product: product,
        bundle: bundle
    };
};

});
parcelRegister("22G6d", function(module, exports) {
$parcel$export(module.exports, "defaultProductData", function () { return $442d86fe90559b3d$export$a6f45672c1b02b97; });
$parcel$export(module.exports, "defaultFeatureFlags", function () { return $442d86fe90559b3d$export$c9799c6be3cce220; });
$parcel$export(module.exports, "defaultLabels", function () { return $442d86fe90559b3d$export$ab4f92552796fc83; });
$parcel$export(module.exports, "firstImpressionsImageUrls", function () { return $442d86fe90559b3d$export$624566d9bd207474; });
const $442d86fe90559b3d$export$a6f45672c1b02b97 = {
    default: {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand',
        bundleContent: {
            default: {
                heroImage: 'https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg',
                headline: 'Bundle Headline',
                socialProofImage: 'https://atlassian.com/dam/jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd/Jira%20Logo.svg',
                featureList: '<ul> <li>Access all features</li> <li>Scale agile practices</li> <li>Consolidate workflows</li> <li>Plan, track, and release</li> </ul> '
            }
        }
    },
    'jira-software-confluence': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand,confluence.ondemand'
    },
    'jira-software-confluence-compass': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            },
            {
                productKey: 'compass',
                productName: 'Compass',
                productLogoUrl: 'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand,confluence.ondemand,compass'
    },
    'jira-software-jira-service-desk-confluence': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand,jira-servicedesk.ondemand,confluence.ondemand'
    },
    'jira-software-jira-service-management-confluence': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand,jira-servicedesk.ondemand,confluence.ondemand'
    },
    'jira-software-jira-service-desk': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand,jira-servicedesk.ondemand'
    },
    'jira-service-desk-jira-software': {
        products: [
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            },
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            }
        ],
        bundleProductKeys: 'jira-servicedesk.ondemand,jira-software.ondemand'
    },
    'jira-service-management-jira-software': {
        products: [
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            },
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            }
        ],
        bundleProductKeys: 'jira-servicedesk.ondemand,jira-software.ondemand'
    },
    'jira-software-jira-service-management': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand,jira-servicedesk.ondemand'
    },
    'jira-service-desk-jira-software-confluence': {
        products: [
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            },
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-servicedesk.ondemand,jira-software.ondemand,confluence.ondemand'
    },
    'jira-service-management-jira-software-confluence': {
        products: [
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            },
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-servicedesk.ondemand,jira-software.ondemand,confluence.ondemand'
    },
    'jira-software': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand',
        bundleContent: {
            default: {
                heroImage: 'https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg',
                headline: 'Bundle Headline',
                socialProofImage: 'https://atlassian.com/dam/jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd/Jira%20Logo.svg',
                featureList: '<ul> <li>Access all features</li> <li>Scale agile practices</li> <li>Consolidate workflows</li> <li>Plan, track, and release</li> </ul> '
            }
        }
    },
    'jira-service-desk': {
        products: [
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            }
        ],
        bundleProductKeys: 'jira-servicedesk.ondemand'
    },
    'jira-service-management': {
        products: [
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            }
        ],
        bundleProductKeys: 'jira-servicedesk.ondemand'
    },
    'jira-service-desk-confluence': {
        products: [
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-servicedesk.ondemand,confluence.ondemand'
    },
    'jira-service-management-confluence': {
        products: [
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-servicedesk.ondemand,confluence.ondemand'
    },
    'jira-core-confluence': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand,confluence.ondemand'
    },
    confluence: {
        products: [
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'confluence.ondemand'
    },
    'confluence-jira-service-desk': {
        products: [
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            },
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            }
        ],
        bundleProductKeys: 'confluence.ondemand,jira-servicedesk.ondemand'
    },
    'confluence-jira-service-management': {
        products: [
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            },
            {
                productKey: 'jira-servicedesk.ondemand',
                productName: 'Jira Service Management',
                productLogoUrl: 'https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg'
            }
        ],
        bundleProductKeys: 'confluence.ondemand,jira-servicedesk.ondemand'
    },
    developer: {
        products: [
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            },
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'com.atlassian.service-collection',
                productName: 'Service Collection',
                productLogoUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/171f20t4om07135ujka42le40wvkp613.svg'
            }
        ],
        bundleProductKeys: 'confluence.ondemand,jira-software.ondemand,com.atlassian.service-collection'
    },
    'confluence-jira-software': {
        products: [
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            },
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            }
        ],
        bundleProductKeys: 'confluence.ondemand,jira-software.ondemand'
    },
    'jira-software-bitbucket': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand'
    },
    'bitbucket-jira-software': {
        products: [
            {
                productKey: 'com.atlassian.bitbucket',
                productName: 'Bitbucket',
                productLogoUrl: 'https://atlassian.com/dam/jcr:bd56917e-e361-4f03-b672-9f5ef5b06e80/Bitbucket-blue.svg'
            }
        ],
        bundleProductKeys: 'com.atlassian.bitbucket'
    },
    opsgenie: {
        products: [
            {
                productKey: 'opsgenie',
                productName: 'Opsgenie',
                productLogoUrl: 'https://atlassian.com/dam/jcr:5b512ce6-164b-42c2-a615-00ea3c38f132/Opsgenie-blue-rgb.svg'
            }
        ],
        bundleProductKeys: 'opsgenie'
    },
    bitbucket: {
        products: [
            {
                productKey: 'com.atlassian.bitbucket',
                productName: 'Bitbucket',
                productLogoUrl: 'https://atlassian.com/dam/jcr:bd56917e-e361-4f03-b672-9f5ef5b06e80/Bitbucket-blue.svg'
            }
        ],
        bundleProductKeys: 'com.atlassian.bitbucket'
    },
    statuspage: {
        products: [
            {
                productKey: 'statuspage',
                productName: 'Statuspage',
                productLogoUrl: 'https://atlassian.com/dam/jcr:d909aeb4-b62e-4f59-8cf3-dc611bed6564/Statuspage-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:442a5960-4c84-4874-979e-3201b65f7e61/Statuspage-white.svg'
            }
        ],
        bundleProductKeys: 'statuspage'
    },
    'team-central': {
        products: [
            {
                productKey: 'townsquare',
                productName: 'Team Central',
                productLogoUrl: 'https://atlassian.com/dam/jcr:3a87ab6e-771b-41ae-93fc-e7230641430c/atlas-beta-color.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:9c6be750-6612-4b30-acb2-1e2d6c1cea8f/atlas-logo-white.svg'
            }
        ],
        bundleProductKeys: 'townsquare'
    },
    atlas: {
        products: [
            {
                productKey: 'townsquare',
                productName: 'Team Central',
                productLogoUrl: 'https://atlassian.com/dam/jcr:3a87ab6e-771b-41ae-93fc-e7230641430c/atlas-beta-color.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:9c6be750-6612-4b30-acb2-1e2d6c1cea8f/atlas-logo-white.svg'
            }
        ],
        bundleProductKeys: 'townsquare'
    },
    beacon: {
        products: [
            {
                productKey: 'beacon',
                productName: 'Beacon',
                productLogoUrl: 'https://atlassian.com/dam/jcr:ab20c8a3-0ba6-436a-9a00-42873c776738/beacon-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:563c3ec0-574d-4384-b60d-59987e5d83ee/beacon-white.svg'
            }
        ],
        bundleProductKeys: 'beacon'
    },
    fabric: {
        products: [
            {
                productKey: 'atlassian-whiteboard',
                productName: 'Fabric',
                productLogoUrl: 'https://atlassian.com/dam/jcr:4fc54485-e365-4549-af5f-3610a970e5d2/Confluence_Whiteboards_logo_lockup_blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:13abb206-c43f-4d9e-9b76-631bcf9ae692/Confluence_Whiteboards_logo_lockup.svg'
            }
        ],
        bundleProductKeys: 'atlassian-whiteboard'
    },
    compass: {
        products: [
            {
                productKey: 'compass',
                productName: 'Compass',
                productLogoUrl: 'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg'
            }
        ],
        bundleProductKeys: 'compass'
    },
    'jira-software-compass-confluence-test': {
        products: [
            {
                productKey: 'jira-software.ondemand',
                productName: 'Jira Software',
                productLogoUrl: 'https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg'
            },
            {
                productKey: 'compass',
                productName: 'Compass',
                productLogoUrl: 'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg'
            },
            {
                productKey: 'confluence.ondemand',
                productName: 'Confluence',
                productLogoUrl: 'https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg'
            }
        ],
        bundleProductKeys: 'jira-software.ondemand,compass,confluence.ondemand'
    },
    'jira-product-discovery': {
        products: [
            {
                productKey: 'jira-product-discovery',
                productName: 'Jira Product Discovery',
                productLogoUrl: 'https://atlassian.com/dam/jcr:47be17fd-8047-4a14-bc38-c1ebbb80e037/Jira%20Product%20Discovery-logo-blue.svg',
                productLogoWhiteUrl: 'https://atlassian.com/dam/jcr:2d01e092-097f-4417-875b-8997fecb2318/jpd-white.svg'
            }
        ],
        bundleProductKeys: 'jira-product-discovery'
    },
    loom: {
        products: [
            {
                productKey: 'loom',
                productName: 'loom',
                productLogoUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4o2u5s554348i6h5645mq8ar7ntw5450.svg'
            }
        ],
        bundleProductKeys: 'loom'
    },
    devai: {
        products: [
            {
                productKey: 'devai.ondemand',
                productName: 'Rovo Dev Agents',
                productLogoUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/417u1uw47033q7c71d0377515lniksis.svg',
                productLogoWhiteUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/027p7mh4up3fs845s7s5ac544n4q4dfy.svg'
            }
        ],
        bundleProductKeys: 'devai'
    }
};
const $442d86fe90559b3d$export$c9799c6be3cce220 = {
    enableTintinMvp: true,
    provisionSecondPartyApps: false,
    enableBundlesAfterSignup: false,
    enableUseCodeAWSContent: false,
    enableDeferredSiteName: false,
    enableDeferredFullName: false,
    enableDefaultExpandedEmail: true,
    enableCutSignUpStepsInHalf: false,
    enableReverseTrial: 'not_enrolled'
};
const $442d86fe90559b3d$export$ab4f92552796fc83 = {
    'WacSignupForm.migrationFeatureList': '<h4>Free cloud migration trial for our self-managed customers</h4>\n\n<ul>\n\t<li>Try {productName} cloud at no cost</li>\n\t<li>Up to {usageLimit} {userType}</li>\n\t<li>No impact to your existing self-managed products</li>\n</ul>\n\n<p><a href="/migration/assess/cloud-migration-trial">Learn more</a></p>',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFree': 'Get started',
    'WacSignupForm.sideInfoHeaderBundleJSWBitbucket': 'Automate your way to faster releases',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImage': 'jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd',
    'WacSignupForm.customizeYourFreePlan': 'Customize your free plan',
    'WacSignupForm.errorDomainLengthMinMsgDevops': "Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they\u2019re in the middle.",
    'WacSignupForm.signupFormPostContent': 'NO CREDIT CARD REQUIRED',
    'WacSignupForm.loginChooseSignup': "<p>Trying to access Confluence? <a href='https://id.atlassian.com/login'>Log in</a></p>",
    'WacSignupForm.cloudEulaText': '<p>By clicking below, you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service" rel="noopener noreferrer" target="_blank">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a>.</p>',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBeacon': 'Unlimited free user invites',
    'WacSignupForm.sideInfoHeaderBundleDeveloperMode': 'Cloud Developer Bundle',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeCanvas': 'Express thoughts and ideas in more ways than ever before\nVisualize how ideas and work fits together throughout workflows\nSpend less time moving ideas to action with integrations\nEnjoy all features and give feedback with free early access',
    'WacSignupForm.existingSite': 'Use an existing site',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeJSD': 'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
    'WacSignupForm.socialSignUpButtonContinueWithMicrosoft': 'Continue with Microsoft',
    'WacSignupForm.submitInitialLabel': 'Start free trial now',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeAlpha': 'Get started',
    'WacSignupForm.passwordWeak': 'Password Strength: Weak',
    'WacSignupForm.informMessageStartNewSiteSimplified': 'Start a new site',
    'WacSignupForm.socialSignUpOr': 'OR',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardBundleJSWBitbucket': 'Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBeta': 'Get started',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeAlpha': 'Free during alpha',
    'WacSignupForm.submitInitialN2ELabel': 'Start now',
    'WacSignupForm.infoBoxModal': '<p>A site is the unique URL where you access your Atlassian products&ndash;Confluence, Jira Software, Jira Service Management, or Jira Work Management.<br /><br />You access Bitbucket Cloud account on <a href="https://bitbucket.org/">bitbucket.org</a>.</p>',
    'WacSignupForm.infoBoxSiteJsw': "Select an existing site below and we\u2019ll create a new Bitbucket Cloud account for you using the same name.",
    'WacSignupForm.errorFirstNameMsg': 'Please enter your first name.',
    'WacSignupForm.localeErrorButton': 'Learn more',
    'WacSignupForm.errorDomainTakenMsg': 'This site is already taken.',
    'WacSignupForm.errorName': "Full name can\u2019t use special characters.",
    'WacSignupForm.dropdownWithoutJiraSoftware': 'Sites without Jira Software:',
    'WacSignupForm.signupOfferingTrialLengthTextExistingSite': '1-month free cloud trial',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTeamCentral': 'Simplify your status reporting',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTownsquare': 'Simplify your status reporting',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeConfluence': 'Free for up to 10 users',
    'WacSignupForm.opsgenieDataStorageInfoBoxCopy': '<p>Some of your data is automatically stored in the US. <a href="/software/opsgenie/tos">Learn more</a></p>',
    'WacSignupForm.premiumUpgradeHelpTooltipTrigger': 'Site not listed?',
    'WacSignupForm.informMessageCouponError': '<p>The coupon you requested is {{couponStatus}}, please <a href="/company/contact">contact us</a> for additional support.</p>',
    'WacSignupForm.freeBreachInfoBoxCopy': '<p><strong>Sorry, Cloud Free is limited to 10 users or 3 agents</strong><br />\nIt looks like this site has more than the allowed limit of users (or agents) for our Cloud Free plans. Please choose our Cloud Standard or Premium plans to accommodate the number of users (or agents) on this site.</p>',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardBundleDeveloperMode': '<p>You are signing up for free development sites&nbsp;of Atlassian cloud products. This gives you&nbsp;access to the standard versions of Jira Software, Service Collection, and Confluence, which are free forever.</p>\n\n<p>Free development sites are intended to be used for development and testing purposes only and have&nbsp;the usage limits noted below. Atlassian does not offer support for free development sites and reserves the right to delete such sites at any time without notice. Atlassian monitors the usage of such development sites and may cancel any site being used in an unauthorized or unintended manner.</p>\n\n<ul>\n\t<li>Confluence: 5 users free</li>\n\t<li>Jira Software: 5 users free</li>\n\t<li>Service Collection: 1 agent free</li>\n\t<li>All products: Up to 250 GB of file storage</li>\n\t<li>All products: Advanced permissions</li>\n</ul>',
    'WacSignupForm.infoBoxBb': "You already have a Bitbucket Cloud account. Create a new site for Jira Software and they'll be automatically integrated.",
    'WacSignupForm.eulaCompassTooltip': '<p>The EAP products are considered &ldquo;Beta Versions&rdquo;, as set forth in Section 14 of the TOS and are subject to applicable terms, conditions, and disclaimers. Atlassian will use the information you provide on this sign-up form to contact you about the EAP program, including updates to the program, feedback requests, and offers.</p>',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextCompass': 'Create a better developer experience with Compass',
    'WacSignupForm.signupOfferingIncludesFeaturesStandard': 'Full access to all features\nZero obligation, no credit card needed\nAdd up to 10,000 users\nAccess to sales and technical support',
    'WacSignupForm.errorPasswordMinMsg': 'Password must be at least 8 characters long.',
    'WacSignupForm.socialSignUpLoadingText': 'checking a few things...',
    'WacSignupForm.localeError': 'We stand with Ukraine',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardJSD': '7-day free trial for up to 5,000 agents',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingIncentiveJSD': '10 free agents for 12 months',
    'WacSignupForm.signupFormPersonalizedGreeting': 'Welcome back, {username}',
    'WacSignupForm.freeAndNoCreditCardNeeded': 'Free for up to 10 users. No credit card needed.',
    'WacSignupForm.freeToGetStarted': 'Free to get started, no credit card needed.',
    'WacSignupForm.passwordModerate': 'Password Strength: Moderate',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumBitbucket': '<h4>Free cloud migration trials for our self-managed customers</h4>\n\n<ul>\n\t<li>Unlimited users</li>\n\t<li>CI/CD built-in</li>\n\t<li>No impact to self-managed product</li>\n</ul>',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSWBitbucket': 'Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeBeacon': 'Increase your visibility and understanding of risks\nBridge the gap between technology and security experts\nExpedite detection, alerting, and response workflows',
    'WacSignupForm.signupOfferingIncludesFeaturesLoom': 'Record your screen and camera. Create video messages for your coworkers or customers.\nPolish your videos without lifting a finger. Use Loom AI to generate video titles, summaries, and transcripts.\nEngage viewers easily. Add comments, react with emojis, and include CTA buttons to share relevant resources.\nUse Loom for feedback, onboarding, announcements, and presentation videos.',
    'WacSignupForm.socialSignUpButtonSignUpWithGoogle': 'Sign up with Google',
    'WacSignupForm.freeBreachInfoBoxCopyJsmIncentive': '<p>Sorry, the number of agents on this site exceeds the total number allowed for the limited-time offer to get 10 free agents. Click <a href="https://atlassian.com/try/cloud/signup?bundle=jira-service-management&amp;edition=standard">here</a> to signup for a paid Standard plan instead.</p>',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeJSD': 'Free for up to 3 agents',
    'WacSignupForm.devopsButtonText': 'Sign up',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluence': 'Access all features\nKickstart team collaboration\nCapture all the knowledge\nBuild admirable content',
    'WacSignupForm.noCreditCardNeeded': 'No credit card needed.',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD': 'Powering high-velocity service teams',
    'WacSignupForm.errorEmailInUseMsg': "Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.",
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBundlesLayout': 'For up to 10 users',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeJSDFI': 'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandardConfluence': 'Start now',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJSD': 'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumBundleJSWBitbucket': 'Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users',
    'WacSignupForm.reCaptchaLegal': 'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
    'WacSignupForm.premiumUpgradeHelpTooltipText': '<p>To upgrade to Premium you must log in to your site as a site adminstrator and switch your plan from within billing administration. More information <a href="https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans" target="_blank">here</a>.</p>',
    'WacSignupForm.informMessageSwitchSiteSimplified': 'Switch to a different site',
    'WacSignupForm.showPasswordLabel': 'Show password',
    'WacSignupForm.claimedMigrationSource': '<h4>Your extended trial has already been activated</h4>\n\n<p>It looks like someone has already activated this trial.</p>\n\n<p>Log in to <a href="https://my.atlassian.com">my.atlassian.com</a> or contact your site administrator for more information.</p>',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardConfluence': '7-day free trial for up to 50,000 users',
    'WacSignupForm.errorDomainIsAnnualMsg': 'The Free plan is not yet available for annual subscriptions. Please select a site on a monthly subscription.',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofText': 'Trusted by over 65,000 teams worldwide',
    'WacSignupForm.siteNameLabel': 'Site name',
    'WacSignupForm.siteNameSuiteLabel': 'Name your suite',
    'WacSignupForm.warningTimeoutPending': 'Something went wrong. Wait a few minutes, then try again.',
    'WacSignupForm.freeBreachInfoBoxConsiderTrial': 'Consider a Standard trial',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeOpsgenie': 'Alerting and on-call management\nAdd unlimited users\nStart with Essentials features\nUpgrade to another plan at any time',
    'WacSignupForm.errorNameLength': 'Full name must not be greater than 255 characters.',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeJira': 'Acheive goals faster with project templates\nShare data, workflows, and automate tasks to stay connected\nCentralize reporting and roadmaps across teams\nCustomize Jira with integrations from the Atlassian Marketplace',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageJiraCore': 'jcr:f00e5006-4d17-4565-bf8b-89a0867d4388',
    'WacSignupForm.infoBoxSite': "You already have a site with other Atlassian products in which Jira Software will be added to. We'll create a new Bitbucket Cloud account for you using the same name.",
    'WacSignupForm.bitbucketAccountDuplicate': 'Create a new Bitbucket Cloud account using the same name as the site above.',
    'WacSignupForm.emailPlaceholder': 'sallysmith@email.com',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJSDFI': 'Access all features\nResolve issues as a team\nQuickly answer common questions\nAutomate incident management',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageJiraCore': 'jcr:be8dde61-ffff-4cb6-85a7-a0ec682c77de',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageBitbucket': 'jcr:28ba5f01-4096-429e-887f-3d9fc016b65a',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket': 'Source code management & CI/CD',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageBitbucket': 'jcr:32afaf4e-4665-4087-9a16-29b429a94336',
    'WacSignupForm.errorDomainLengthMinMsgDeferredSiteName': "Must be at least three characters (numerals or lowercase letters only). Can\u2019t start or end with a hyphen (-).",
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBundlesLayout': 'Get started for free',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeJiraProductDiscovery': 'Capture ideas and data from anywhere\nPrioritize the work that will make an impact\nKeep stakeholders informed and engaged\nFully integrated with Jira Software for delivery',
    'WacSignupForm.dropdownWithoutRecommended': 'OTHER SITES',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBeacon': 'Threat detection for secure collaboration!',
    'WacSignupForm.freeBreachLimitExceededErrorJsmIncentive': 'This site exceeds the number of agents eligible for the offer.',
    'WacSignupForm.signupOfferingTrialLengthTextNewSite': '7-day free cloud trial',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBeacon': 'Start Now',
    'WacSignupForm.siteNameOptional': 'Site name (optional)',
    'WacSignupForm.errorDomainLengthMaxMsg': "That's a bit too long \u2014 try something 50 characters or less.",
    'WacSignupForm.passwordLabel': 'Password',
    'WacSignupForm.jsmConfluenceNotice': "For the seamless setup of your knowledge base, we suggest adding Jira Service Management to a site that already has Confluence. You won\u2019t be able to link these sites later.",
    'WacSignupForm.errorValidationMessage': 'Please review the highlighted fields below and try again.',
    'WacSignupForm.dropdownWithRecommended': 'RECOMMENDED SITES',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeStatuspage': 'Free to set up. Launch it when you&rsquo;re ready.\nAccess to all features and capabilities\nZero obligation, no credit card required\nAdd up to 25 team members\nTechnical and sales support available',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeJiraProductDiscovery': 'Free for up to 3 creators and unlimited contributors',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImage': 'jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageConfluence': 'jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97',
    'WacSignupForm.helpTooltipText': 'Must be at least 3 lowercase characters, numbers and letters only.',
    'WacSignupForm.localeErrorMessage': 'Following the Russian invasion of Ukraine, we are pausing the sale of new software in Russia and Belarus.',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading': 'Start now',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI': 'Scale agile practices\nConsolidate workflows\nExpand visibility\nPlan, track, and release',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageJSD': 'jcr:afd73b6a-2ece-4fa3-bfbd-ada0ba2bc2c1',
    'WacSignupForm.informMessageCouponSuccess': '<p>The coupon you requested is {{couponStatus}}, please <a href="/company/contact">contact us</a> for additional support.</p>',
    'WacSignupForm.siteNameSuiteDescriptionDevops': "* We\u2019ll use this to name your sites and workspaces",
    'WacSignupForm.eulaJsmIncentive': '<p>By clicking below, you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy">Privacy Policy</a> and <a href="https://atlassian.com/end-bsm-now/terms-and-conditions">Terms &amp; Conditions</a> of the offer.</p>',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingIncentiveJSD': 'Start now',
    'WacSignupForm.alwaysFreeForUpto': 'Always free for up to 10 users.',
    'WacSignupForm.signupFormGreeting': 'Create your account',
    'WacSignupForm.signupOfferingIncludesHeading': 'Trial includes',
    'WacSignupForm.emailLabel': 'Work email',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSDFI': 'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
    'WacSignupForm.firstNameLabel': 'First name',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraCore': 'Connected teams work better together',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeConfluence': 'Get started',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumStatuspage': 'Free to set up. Launch it when you&rsquo;re ready.\nAccess to all features and capabilities\nZero obligation, no credit card required\nAdd up to 25 team members\nTechnical and sales support available',
    'WacSignupForm.siteNameInstructionsExperimentB': 'This site name is just a suggestion. Feel free to change to something your team will recognize.',
    'WacSignupForm.yourBitbucketAccount': 'Your Bitbucket Cloud account',
    'WacSignupForm.inputSiteNameMessage': 'Your site name appears in the URL for your Atlassian products. Most people use their team or company name. You can change your site name later.',
    'WacSignupForm.marketingCommunicationsCheckboxSignupText': 'Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJiraCore': 'Access all features\nCustomize project templates\nTrack and automate every detail\nAnalyze team progress',
    'WacSignupForm.passwordVeryStrong': 'Password Strength: Very strong',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD': 'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
    'WacSignupForm.socialSignUpErrorTextContactUs': '<div>If the problem persists, <a href="{contactUsUrl}">contact us</a>.</div>',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeTeamCentral': 'Connect work to outcomes\nGet updates with just enough context\nLet Atlas know everyone, so you can too\nLearn without knowing who to ask',
    'WacSignupForm.devopsCarouselButton': 'Get started in {product}',
    'WacSignupForm.invalidMigrationSource': '<h4>Invalid trial activation</h4>\n\n<p>It looks like we weren&#39;t able to activate your cloud migration trial.</p>\n\n<p>Check with the site administrator, or login to <a href="https://my.atlassian.com">my.atlassian.com</a> to confirm your activation link is complete and correct, and that you have an eligible server or Data Center license.</p>',
    'WacSignupForm.infoBoxModalCta': 'Understand site and Bitbucket Cloud account',
    'WacSignupForm.dropdownWithJiraSoftware': 'Sites with Jira Software:',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandard': 'Start now',
    'WacSignupForm.opsgenieDataRegionLabel': 'Select the data center region to store your Opsgenie specific product data',
    'WacSignupForm.informDomainEmptyMsg': 'Looking to add products to an existing site?',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeCompass': 'Reduce context switching with a comprehensive software catalog\nKeep your architecture reliable, performant, and secure with scorecards and metrics\nConnect your existing tools and data and create custom integrations for a bespoke developer experience',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardAtlas': '14-day free trial for up to 35,000 users',
    'WacSignupForm.errorTimeout': '<p>It&#39;s taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <a href="/company/contact">contact us</a>.</p>',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJiraCore': 'Let teams collaborate at scale\nCustomize how work is tracked\nExpand visibility\nSave time with automation',
    'WacSignupForm.infoBoxDefault': '',
    'WacSignupForm.infoBoxSiteBb': 'You already have a site with other Atlassian products in which Jira Software will be added to. You also have a Bitbucket Cloud account. They will be automatically integrated.',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraProductDiscovery': 'Transform product ideas into business impact',
    'WacSignupForm.deferredSiteNameTooltipText': 'Your site name is the URL used to find your site, so try something your team will easily recognize.',
    'WacSignupForm.siteNameSuiteDescriptionLabel': "* We\u2019ll use this to name your site and workspaces",
    'WacSignupForm.socialSignUpOrSignUpWith': 'Or sign up with',
    'WacSignupForm.submitN2ELabel': 'Agree and start now',
    'WacSignupForm.socialSignUpButtonContinueWithGoogle': 'Continue with Google',
    'WacSignupForm.eulaCutSignupInHalf': "<p>By clicking \"Sign up\" below, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a>.</p>",
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSDIncentive': 'Get started with 10 agents for free for 12 months!*',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket': 'Included build minutes and Git LFS\nNative Jira integration\nEasily extensible\nSecure & reliable',
    'WacSignupForm.signupOfferingIncludesHeadingFree': 'Subscription includes',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJSWFI': '\nAccess all features\nScale agile practices\nConsolidate workflows\nPlan, track, and release',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence': 'Trusted by over 75,000 teams worldwide',
    'WacSignupForm.eulaCompass': '<p>By signing up for this Early Access Program (&ldquo;EAP&rdquo;), you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service" rel="noopener noreferrer" target="_blank">Cloud Terms of Service</a> (&ldquo;TOS&rdquo;) and acknowledge the Atlassian <a href="https://www.atlassian.com/legal/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a></p>',
    'WacSignupForm.informDomainIsUsersMsg': 'Is it yours?',
    'WacSignupForm.errorDomainTakenMsgDeferredSiteName': 'This site name is already taken.',
    'WacSignupForm.passwordPlaceholder': 'Combine letters, numbers and symbols',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeAtlas': 'Start Now',
    'WacSignupForm.fullNameLabel': 'Full name',
    'WacSignupForm.passwordStrong': 'Password Strength: Strong',
    'WacSignupForm.userTypeUsersLabel': 'users',
    'WacSignupForm.socialSignUpSomethingWentWrong': '<h3>Something went wrong</h3>',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeJSD': 'Start now',
    'WacSignupForm.siteNameN2ELabel': 'Your site',
    'WacSignupForm.errorLastNameMsg': 'Please enter your last name.',
    'WacSignupForm.personalizedNameSiteMessage': "Let\u2019s name your site, {username}",
    'WacSignupForm.siteNamePlaceholder': 'yoursite',
    'WacSignupForm.eulaChooseSignup': "<p>By clicking \u201CContinue\u201D below, you agree to the Atlassian Cloud <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Terms of Service</a> and acknowledge the Atlassian <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a>.</p>",
    'WacSignupForm.socialSignUpButtonSignUpWithEmail': 'Sign up with email',
    'WacSignupForm.helpTooltipTextDevops': 'Choose a name for the sites and workspaces that will make up your suite. Most teams use their company or organization.',
    'WacSignupForm.informEmailLoggedInMsg.link': '<a href="{switchAccountUrl}">Sign in with a different Atlassian account</a>',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageConfluence': 'jcr:53e25eff-e025-41d0-88ec-2f1420f89131',
    'WacSignupForm.errorCaptchaMsg': 'Error with captcha verification.',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageJSD': 'jcr:45864a30-5470-4cbe-be59-9aae63492229',
    'WacSignupForm.freeBreachLimitExceededError': 'This site has more users than Free allows.',
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextCanvas': 'A collaborative whiteboard for teams',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBeta': 'Free during beta',
    'WacSignupForm.errorDomainLengthMinMsg': "Your site name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they\u2019re in the middle.",
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeFabric': 'Unlimited free users',
    'WacSignupForm.lastNameLabel': 'Last name',
    'WacSignupForm.jswTrialNotice': "You'll get a 1-month free trial of Jira Software for this site.",
    'WacSignupForm.errorEmailInvalidMsg': 'Please enter a valid email address.',
    'WacSignupForm.lastNamePlaceholder': 'Last',
    'WacSignupForm.accountIdMisMatch': '<span>Something went wrong. Please refresh your page, then try again.</span>',
    'WacSignupForm.startButtonTextChooseSignup': 'Continue',
    'WacSignupForm.selectOrganization': 'Select your Atlassian organization',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSWFI': 'Access all features\nScale agile practices\nConsolidate workflows\nPlan, track, and release',
    'WacSignupForm.signupOfferingIncludesFeaturesPremium': 'Full access to all features\nZero obligation, no credit card needed\nAdd up to 10,000 users\nAccess to sales and technical support',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeJiraProductDiscovery': 'Get started',
    'WacSignupForm.signupOfferingTrialLengthTextNewSiteOpsgenie': '14-day free Essentials trial',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluence': 'Access all features\nKickstart team collaboration\nCapture all the knowledge\nBuild admirable content',
    'WacSignupForm.socialSignUpSorryForTheInconvenience': '<div>Sorry for the inconvenience</div>',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeAtlas': 'Free up to 35,000 users',
    'WacSignupForm.freeBreachInfoBoxStartTrialCta': 'Start a 30-day trial',
    'WacSignupForm.siteNameOptionalMessageN2E': 'Choose an existing site below, or create a new one.',
    'WacSignupForm.siteNameInstructions': "Must be at least three characters (numbers or lowercase letters only) and can\u2019t start or end with a hyphen (-).",
    'WacSignupForm.siteNameOptionalMessageN2N': "Don't worry, you can change this later.",
    'WacSignupForm.firstNamePlaceholder': 'First',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeJiraCore': 'Calendar, list, timeline, and board views to track work\nQuickly create forms with a drag-and-drop builder\nSave your team&#39;s time with our automation library\nHelp teams stay in sync with customizable workflows',
    'WacSignupForm.submitCouponLabel': 'Agree',
    'WacSignupForm.warningNetworkError': 'Something went wrong. Please try again.',
    'WacSignupForm.userTypeAgentsLabel': 'agents',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSD': 'Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardBeacon': 'Unlimited free users',
    'WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence': 'Kickstart team collaboration\nIncrease transparency\nCapture all the knowledge\nBuild admirable content',
    'WacSignupForm.errorEmailInUseLoginToContinueMsg': 'Log in to continue.',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandard': '7-day free trial for up to 35,000 users',
    'WacSignupForm.signupOfferingIncludesFeaturesFree': 'Access to Free features\n2 GB storage\nFor up to 10 users\nCommunity Support',
    'WacSignupForm.useDifferentAccountSignin.link': '<a href="{switchAccountUrl}">Use a different Atlassian account</a>',
    'WacSignupForm.informMessageDeveloperWarning': '<h4>You are signing up for a free development instance of Atlassian Cloud.</h4>\n\n<p>Free development instances are intended to be used for development and testing purposes only and has the usage limits noted below.Atlassian does not offer support for free development instances and reserves the right to delete such instances at any time without notice.Atlassian monitors the usage of such development instances and may cancel any instance being used in an unauthorized or unintended manner.</p>\n\nJira Software, Jira Core: 5 users free\nJira Service Desk: 1 agent free\nConfluence: 5 users free',
    'WacSignupForm.submitProcessingLabel': 'Starting...',
    'WacSignupForm.signupOfferingIncludesFeaturesIncentiveJSD': 'Access all features of our Standard plan\nConnect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly\n\n<p>* After one year, convert to a paid plan or keep using Jira Service Management on the Free plan with up to 3 agents.</p>',
    'WacSignupForm.informDomainAddToExistingsMsg': 'Add products to existing site',
    'WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFree': "Free for up to 10 users \u2014 no credit card needed.",
    'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJira': 'Trusted by over 65,000 teams worldwide',
    'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageTeamCentral': 'jcr:80e875ca-274f-44fd-b1d3-50e47c43a73b',
    'WacSignupForm.FirstImpressions.socialSignUpButtonSignUpWithEmail': 'Sign up with email',
    'WacSignupForm.FirstImpressions.inputLabelFullName': 'Full name',
    'WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonProductName': 'Confluence',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImage': 'jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674',
    'WacSignupForm.FirstImpressions.errorSsoInUse': "You must use single sign-on to access your account and continue signing up for your product. <a href='{redirectUrl}'>Login to continue</a>.",
    'WacSignupForm.FirstImpressions.inputLabelRequired': 'Required',
    'WacSignupForm.FirstImpressions.firstImpressionsLoggedOutFormHeader': 'Let get it started!',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageJSD': 'jcr:45864a30-5470-4cbe-be59-9aae63492229',
    'WacSignupForm.FirstImpressions.firstImpressionsLoggedInFormHeader': 'Welcome back, {userName}',
    'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageConfluence': 'jcr:ed997381-ade2-440b-8374-7d2095bd7b38',
    'WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonProductName': 'Jira Software',
    'WacSignupForm.FirstImpressions.teamCentralLoggedOutViewFormHeader': 'Hi there',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageJira': 'jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageFabric': 'jcr:978c45e6-3cf7-40d1-9a42-172cc8e77e60',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageBeacon': 'jcr:f82f862b-5d6b-49ec-9d95-886664208834',
    'WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonTitle': 'Get it free',
    'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJSD': 'jcr:4bacc2d6-c0ff-4949-955e-50cde04a3898',
    'WacSignupForm.FirstImpressions.inputLabelWorkEmail': 'Work email',
    'WacSignupForm.FirstImpressions.submitButtonLabel': 'Agree',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageTeamCentral': 'jcr:9991958d-3d80-45fd-9af0-c53d15270ec8',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageJiraProductDiscovery': 'jcr:7cfe6bed-77da-410b-8fcc-2c3f3f78cef5',
    'WacSignupForm.FirstImpressions.teamCentralIneligibleViewSwitchAccountLink': 'Sign in with a different Atlassian account',
    'WacSignupForm.FirstImpressions.noCreditCardRequiredFooter': 'No credit card required',
    'BxpSignup.PaymentDetailsHeading': 'Add your payment details',
    'BxpSignup.PaymentDetailsSubtitle': 'to start a Rovo Dev 30 day free trial',
    'BxpSignup.PaymentDetailsBack': 'Back',
    'BxpSignup.PaymentDetailsSubmit': "I've added my payment details",
    'BxpSignup.AddPaymentMethod.Title': 'Add a payment method to start your trial',
    'BxpSignup.AddPaymentMethod.Intro': "We couldn't find a payment method for your site, a billing admin must add one before you start a trial.",
    'BxpSignup.AddPaymentMethod.NoChargeTitle': 'No charge until trial ends',
    'BxpSignup.AddPaymentMethod.NoChargeBody': "There's no charge today, billing doesn't begin until the end of your trial.",
    'BxpSignup.AddPaymentMethod.CancelAnytimeTitle': 'Cancel anytime',
    'BxpSignup.AddPaymentMethod.CancelAnytimeBody': 'If you want to end your trial, cancel anytime in Atlassian Administration.',
    'BxpSignup.AddPaymentMethod.HowToTitle': 'How to add a payment method',
    'BxpSignup.AddPaymentMethod.Step1Title': 'Go to payment methods in Atlassian Administration',
    'BxpSignup.AddPaymentMethod.Step1Body': 'Billing admin role required to add payment methods.',
    'BxpSignup.AddPaymentMethod.ReadAboutPermissions': 'Read about permissions',
    'BxpSignup.AddPaymentMethod.OpenPaymentMethods': 'Open payment methods',
    'BxpSignup.AddPaymentMethod.Step2Title': 'Enter your billing details',
    'BxpSignup.AddPaymentMethod.Step2Body': 'Add a billing address and payment method. We accept credit cards and PayPal.',
    'BxpSignup.AddPaymentMethod.Step3Title': 'Close the payment methods tab',
    'BxpSignup.AddPaymentMethod.Step3Body': "When you're done, close the payment methods window and return here.",
    'BxpSignup.AddPaymentMethod.Step4Title': 'Return and set up your trial',
    'BxpSignup.AddPaymentMethod.Step4Body': 'After adding a payment method, return to where you started and set up your trial again.',
    'BxpSignup.AddPaymentMethod.CloseAndGoBack': 'Close and go back',
    'WacSignupForm.FirstImpressions.socialSignUpButtonContinueWithGoogle': 'Continue with Google',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageJiraCore': 'jcr:f00e5006-4d17-4565-bf8b-89a0867d4388',
    'WacSignupForm.FirstImpressions.teamCentralIneligibleViewFormHeader': 'Welcome back, {userName}',
    'WacSignupForm.FirstImpressions.firstImpressionsLoggedOutFormSubHeader': 'Free for up to 10 users',
    'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJira': 'jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1',
    'WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonProductDescription': 'Project and issue tracking',
    'WacSignupForm.FirstImpressions.teamCentralLoggedOutViewAlreadyHaveAccount': 'if you already have an Atlassian account',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageCompass': 'jcr:ddb40094-3568-4eee-84fb-adfd5b20ca96',
    'WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonTitle': 'Get it free',
    'WacSignupForm.FirstImpressions.inputLabelFullNameLengthError': 'Must be 255 characters or less',
    'WacSignupForm.FirstImpressions.inputLabelWorkEmailError': 'Invalid email address',
    'WacSignupForm.FirstImpressions.firstImpressionBackgroundImage': 'jcr:fa398d64-ddab-4e01-b3bf-90042efc7638',
    'WacSignupForm.FirstImpressions.firstImpressionsHeroImageConfluence': 'jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97',
    'WacSignupForm.FirstImpressions.teamCentralLoggedOutViewLogIn': 'Log in',
    'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJiraProductDiscovery': 'jcr:a8911809-1897-4fbc-9a7e-086e07e07199',
    'WacSignupForm.FirstImpressions.teamCentralSignUpForOtherProductsFirst': 'Sign up for Jira or Confluence to coordinate and collaborate on Team Central',
    'WacSignupForm.FirstImpressions.firstImpressionsEula': "<p>By signing up, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>",
    'WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonProductDescription': 'Document collaboration',
    'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImage': 'jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1',
    'WacSignupForm.FirstImpressions.firstImpressionsRecaptcha': 'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
    'WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJiraCore': 'jcr:f2b4976d-a53a-42a0-93ec-def9b87fe654',
    'WacSignupForm.SimpleSignup.noCreditCardRequiredFooter': 'Always free, no credit card needed.',
    'WacSignupForm.SimpleSignup.slideProductConfirmationProductsNew': 'New Products',
    'WacSignupForm.SimpleSignup.jswMobileNavImage': 'jcr:75a99fa9-2d9f-4eb6-b856-cb450b77f656',
    'WacSignupForm.SimpleSignup.productListBitbucketDescription': 'Ship quality code as a team',
    'WacSignupForm.SimpleSignup.slideProductConfirmationHeader': 'Review your toolchain',
    'WacSignupForm.SimpleSignup.inputLabelSitenameNew': 'Name your suite',
    'WacSignupForm.SimpleSignup.socialSignUpButtonContinueWithGoogle': 'Continue with Google',
    'WacSignupForm.SimpleSignup.slideExistingSiteSubHeader': 'Start building your toolchain with our flagship products for free, then upgrade or add more third-party tools later.',
    'WacSignupForm.SimpleSignup.socialSignUpButtonSignUpWithEmail': 'Sign up with email',
    'WacSignupForm.SimpleSignup.errorName': 'Invalid name pattern.',
    'WacSignupForm.SimpleSignup.inputLabelFullName': 'Full name',
    'WacSignupForm.SimpleSignup.errorEmailInUse': "Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.",
    'WacSignupForm.SimpleSignup.passwordWeak': 'Weak',
    'WacSignupForm.SimpleSignup.inputDescriptionSitenameExisting': 'The address your team will use to access Jira Software',
    'WacSignupForm.SimpleSignup.simpleSignupEula': 'By clicking "Sign up", you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy">Privacy Policy</a>.',
    'WacSignupForm.SimpleSignup.atlassianLogoImage': 'jcr:fbe85a9f-3381-4a48-afbc-074287bc4ba9',
    'WacSignupForm.SimpleSignup.errorSsoInUse': "You must use single sign-on to access your account and continue signing up for your product. <a href='{signInAccountUrl}'>Login to continue.</a>",
    'WacSignupForm.SimpleSignup.productListOpsgenieDescription': 'Streamline incident management',
    'WacSignupForm.SimpleSignup.submitButtonLoggedOut': 'Sign up',
    'WacSignupForm.SimpleSignup.openDevOps': 'Open DevOps',
    'WacSignupForm.SimpleSignup.slideConfirmationHeader': "You're almost there!",
    'WacSignupForm.SimpleSignup.errorSitenameUnavailable': 'This suite is already taken.',
    'WacSignupForm.SimpleSignup.inputDescriptionSitenameNew': '',
    'WacSignupForm.SimpleSignup.inputLabelRequired': 'Enter your email',
    'WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormSubmitError': 'Something went wrong, please try again.',
    'WacSignupForm.SimpleSignup.slideExistingSiteSubHeaderTooltip': "If your chosen site does not include Jira software, we\u2019ll add and integrate it with your suite.",
    'WacSignupForm.SimpleSignup.slideConfirmationSubHeaderText': 'Your new products are now connected to your site.',
    'WacSignupForm.SimpleSignup.noCard': 'No Credit Card Required',
    'WacSignupForm.SimpleSignup.inputToggleSitenameExisting': 'Use an existing site',
    'WacSignupForm.SimpleSignup.socialSignUpButtonSignupWithGoogle': 'Sign up with Google',
    'WacSignupForm.SimpleSignup.socialSignUpOr': 'OR',
    'WacSignupForm.SimpleSignup.welcomeMessageLoggedOut': 'Create your account',
    'WacSignupForm.SimpleSignup.passwordStrength': 'Password strength:',
    'WacSignupForm.SimpleSignup.slideProductConfirmationSubHeader': "You\u2019ll connect these products to your site. Remember, new products are free!",
    'WacSignupForm.SimpleSignup.errorSitenameInvalid': "Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they\u2019re in the middle.",
    'WacSignupForm.SimpleSignup.siteNameFormHeader': 'Your site name will be in the URL to access your site, so pick a name that your team will recognize.',
    'WacSignupForm.SimpleSignup.slideExistingWorkspaceSubHeader': 'Integrate Jira, Confluence and Opsgenie with Bitbucket for free, then upgrade or add more third-party tools later.',
    'WacSignupForm.SimpleSignup.slideConfirmationGetStarted': 'Get started in {product}',
    'WacSignupForm.SimpleSignup.inputLabelWorkEmailError': 'Invalid email address',
    'WacSignupForm.SimpleSignup.submitButtonLoggedIn': 'Sign up',
    'WacSignupForm.SimpleSignup.inputLabelFirstName': 'First name',
    'WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormSubHeader': 'Your Free cloud plan supports up to 10 users and 2 GB of file storage.',
    'WacSignupForm.SimpleSignup.inputLabelEmail': 'Work email',
    'WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormHeader': "Let's get started",
    'WacSignupForm.SimpleSignup.passwordModerate': 'Moderate',
    'WacSignupForm.SimpleSignup.productListConfluenceName': 'Confluence Cloud',
    'WacSignupForm.SimpleSignup.slideExistingSiteHeader': "Let\u2019s get started",
    'WacSignupForm.SimpleSignup.productListOpsgenieName': 'Opsgenie Cloud',
    'WacSignupForm.SimpleSignup.inputLabelSitenameExisting': 'Select a site (or type a name to create a new one)',
    'WacSignupForm.SimpleSignup.errorTimeoutN2N': "<span>It's taking longer than expected to get you started. Please check your inbox to see if the request has completed successfully, or <a href='https://www.atlassian.com/company/contact'>contact us</a>.</span>",
    'WacSignupForm.SimpleSignup.simpleSignupSamlRequired': 'You must use single sign-on to access your account and continue signing up for your product. <a href="{loginUrl}">Login to continue</a>',
    'WacSignupForm.SimpleSignup.errorTimeoutN2E': "<span>It\u2019s taking longer than expected to get you started. Please refresh and try again or <a href='https://www.atlassian.com/company/contact' track-link-ga='error-contact-us'>contact us</a>.</span>",
    'WacSignupForm.SimpleSignup.inputLabelWorkspaceExisting': 'Select a workspace (or type a name to create a new one)',
    'WacSignupForm.SimpleSignup.nextButton': 'Next',
    'WacSignupForm.SimpleSignup.slideProductConfirmationProductsExisting': 'Existing Products',
    'WacSignupForm.SimpleSignup.inputLabelWorkEmail': 'Work email',
    'WacSignupForm.SimpleSignup.marketingConsent': 'Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.',
    'WacSignupForm.SimpleSignup.inputLabelLastName': 'Last name',
    'WacSignupForm.SimpleSignup.provisioningTakesTime': 'Please wait a moment, this can take up to a minute...',
    'WacSignupForm.SimpleSignup.productListJiraSoftwareName': 'Jira Software',
    'WacSignupForm.SimpleSignup.slideConfirmationCardText': 'You can access your connected work in the <b>Pages</b>, <b>Code</b>, or <b>On-call</b> tabs of your project.',
    'WacSignupForm.SimpleSignup.inputLabelPassword': 'Password',
    'WacSignupForm.SimpleSignup.submitButtonLabel': 'Sign up',
    'WacSignupForm.SimpleSignup.productListConfluenceDescription': 'Collaborate on important documents',
    'WacSignupForm.SimpleSignup.passwordStrong': 'Strong',
    'WacSignupForm.SimpleSignup.simpleSignupRecaptcha': 'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
    'WacSignupForm.SimpleSignup.errorEmailInvalid': 'Please enter a valid email address',
    'WacSignupForm.SimpleSignup.productListJiraSoftwareDescription': 'Mission control for your entire team',
    'WacSignupForm.SimpleSignup.socialSignUpDividerLabel': 'OR',
    'WacSignupForm.SimpleSignup.previousButton': 'Prev',
    'WacSignupForm.SimpleSignup.productListBitbucketName': 'Bitbucket Cloud',
    'WacSignupForm.SimpleSignup.inputSitenameExistingPlaceholder': 'Select or create a new site',
    'WacSignupForm.SimpleSignup.inputToggleSitenameNew': 'Start a new site',
    'WacSignupForm.SimpleSignup.passwordVeryStrong': 'Very strong',
    'WacSignupForm.SimpleSignup.inputPlaceholderWorkEmail': 'Eg: you@company.com',
    'WacSignupForm.SimpleSignup.slideConfirmationFooterText': 'Next, dive into a project to start exploring Atlassian Open DevOps.',
    'WacSignupForm.SimpleSignup.errorPasswordMinMsg': 'Password must be at least 8 characters long',
    'PasswordStrength.passwordWeak': 'Password Strength: Weak',
    'PasswordStrength.passwordModerate': 'Password Strength: Moderate',
    'PasswordStrength.passwordStrong': 'Password Strength: Strong',
    'PasswordStrength.passwordVeryStrong': 'Password Strength: Very strong',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeTitle': 'Upgrade to the Standard plan',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardBulletIntro': 'The Standard plan also includes:',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceUpgradeBody': 'Get a free 14-day trial of Confluence Standard for unlimited users, additional storage, and much more. Cancel anytime.',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet1Title': 'Page & user permissions',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet1Body': 'Control space and page access',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet2Title': 'Page insights',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet2Body': 'Give content creators insights on page views and comments',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet3Title': 'Business hour support',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet3Body': "Get support from Atlassian\u2019s team of experts",
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmUpgradeBody': 'Get a free 14-day trial of Jira Service Management Standard for unlimited agents, additional storage, and much more. Cancel anytime.',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet1Title': 'On-call management',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet1Body': 'Create custom routing rules and escalation policies',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet2Title': 'Unlimited email notifications',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet2Body': 'Update everyone about activity on requests',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet3Title': 'Business hour support',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet3Body': "Get support from Atlassian\u2019s team of experts",
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJswUpgradeBody': 'Get a free 14-day trial of Jira Standard for unlimited users, additional storage, and much more. Cancel anytime.',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Title': 'User roles & permissions',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Body': 'Have more control over which users have access to different projects and actions.',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Title': 'Anonymous access',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Body': 'Give secure access to people outside your team.',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Title': 'Business hour support',
    'WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Body': "Get support from Atlassian\u2019s team of experts",
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumUpgradeTitle': 'Upgrade to the Premium plan',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumBulletIntro': 'The Premium plan also includes:',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceUpgradeBody': 'Get a free 30-day trial of Confluence Premium for unlimited users, unlimited storage, and much more. Cancel anytime.',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet1Title': 'Atlassian Intelligence (AI)',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet1Body': 'AI to create value faster, turn insights into action, and communicate efficiently',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet2Title': 'Unlimited whiteboards',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet2Body': 'A digital whiteboard to brainstorm, plan, and action work like never before',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet3Title': 'Premium support',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet3Body': "Get 24/7 support from Atlassian\u2019s team of experts",
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmUpgradeBody': 'Get a free 30-day trial of Jira Service Management Premium for unlimited agents, unlimited storage, and much more. Cancel anytime.',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet1Title': 'Atlassian Intelligence (AI)',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet1Body': 'Deliver exceptional service experiences with AI-powered ITSM capabilities',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet2Title': 'Advanced incident management',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet2Body': 'Automate your major incident creation process',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet3Title': 'Premium support',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet3Body': "Get 24/7 support from Atlassian\u2019s team of experts",
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswUpgradeBody': 'Get a free 30-day trial of Jira Premium for unlimited users, unlimited storage, and much more. Cancel anytime.',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Title': 'Atlassian Intelligence (AI)',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Body': 'AI-powered features to help teams create value faster',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Title': 'Advanced planning',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Body': 'Plan work and track progress across multiple teams and projects',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Title': 'Premium support',
    'WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Body': "Get 24/7 support from Atlassian\u2019s team of experts",
    'WacSignupForm.bitbucketWorkspaceIdFieldLabelMessage': 'Your new workspace',
    'WacSignupForm.bitbucketOrganizationIdFieldLabelMessage': "We'll create your workspace in this organization",
    'WacSignupForm.bitbucketWorkspaceIdFieldHelperMessage': 'The workspace ID can only contain lowercase letters, numbers, dashes, and underscores.',
    'WacSignupForm.bitbucketSubmitButtonTextMessage': 'Agree and create workspace',
    'WacSignupForm.bitbucketWorkspaceIdFieldErrorMessageCMT': 'The workspace ID is invalid. Workspace IDs can only contain lowercase letters, numbers, dashes, and underscores.',
    'WacSignupForm.bitbucketWorkspaceIdTakenErrorMessageCMT': 'This workspace ID is taken. Try another ID.',
    'WacSignupForm.bitbucketMissingOrgsInfoMessage': 'If an organization is not listed in the dropdown menu, <a href="{supportUrl}" target="_blank">contact our Support team for assistance</a>.',
    'WacSignupForm.bitbucketCreateNewOrgInfoMessage': 'We need to create a new Atlassian organization, because you currently do not have an organization in Atlassian\'s centralized user management. If you have any questions, <a href="{supportUrl}" target="_blank">contact our Support team for assistance</a>.',
    'WacSignupForm.bitbucketOrgCreationPreparingProductMessage': "We're preparing your product.",
    'WacSignupForm.bitbucketOrgCreationEstimatedTimeMessage': "This won't take more than a minute or two.",
    'WacSignupForm.productActivationFailureMessage': '<p>Something went wrong on our end. Please try again. If this keeps happening, <a href="https://support.atlassian.com/contact/">contact support</a>.</p>'
};
const $442d86fe90559b3d$export$624566d9bd207474 = {
    backgroundImage: 'https://atlassian.com/dam/jcr:fa398d64-ddab-4e01-b3bf-90042efc7638/blue_wave_background.svg',
    jiraSoftware: {
        heroImage: 'https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg',
        socialProofImage: 'https://atlassian.com/dam/jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1/jsw-social-proof-reel.svg'
    },
    jiraServiceDesk: {
        heroImage: 'https://atlassian.com/dam/jcr:45864a30-5470-4cbe-be59-9aae63492229/JSD%20Hero.svg',
        socialProofImage: 'https://atlassian.com/dam/jcr:4bacc2d6-c0ff-4949-955e-50cde04a3898/jsm-social-proof-reel.svg'
    },
    confluence: {
        heroImage: 'https://atlassian.com/dam/jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97/Confluence%20Hero.svg',
        socialProofImage: 'https://atlassian.com/dam/jcr:ed997381-ade2-440b-8374-7d2095bd7b38/confluence-social-proof-reel.svg'
    },
    jiraCore: {
        heroImage: 'https://atlassian.com/dam/jcr:f00e5006-4d17-4565-bf8b-89a0867d4388/Jira%20Core%20Hero.svg',
        socialProofImage: 'https://atlassian.com/dam/jcr:f2b4976d-a53a-42a0-93ec-def9b87fe654/jwm-social-proof-reel.svg'
    },
    teamCentral: {
        heroImage: 'https://atlassian.com/dam/jcr:9991958d-3d80-45fd-9af0-c53d15270ec8/atlas-signup-hero.svg',
        socialProofImage: 'https://atlassian.com/dam/jcr:80e875ca-274f-44fd-b1d3-50e47c43a73b/atlas-logo-real-448x60-N50.png'
    },
    jiraProductDiscovery: {
        heroImage: 'https://atlassian.com/dam/jcr:7cfe6bed-77da-410b-8fcc-2c3f3f78cef5/jpd-hero-image-v3.svg',
        socialProofImage: 'https://atlassian.com/dam/jcr:a8911809-1897-4fbc-9a7e-086e07e07199/jpd-social-proof-reel.svg'
    },
    compass: {
        heroImage: 'https://atlassian.com/dam/jcr:ddb40094-3568-4eee-84fb-adfd5b20ca96/Compass_SignUpPage_Illo%20(5).svg',
        socialProofImage: ''
    },
    fabric: {
        heroImage: 'https://atlassian.com/dam/jcr:978c45e6-3cf7-40d1-9a42-172cc8e77e60/fabric-sign-up-hero-rev@2x.png',
        socialProofImage: ''
    },
    beacon: {
        heroImage: 'https://atlassian.com/dam/jcr:f82f862b-5d6b-49ec-9d95-886664208834/beacon-hero.svg',
        socialProofImage: ''
    },
    jira: {
        heroImage: 'https://atlassian.com/dam/jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83/jira-family-hero.png',
        socialProofImage: 'https://atlassian.com/dam/jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1/jsw-social-proof-reel.svg'
    },
    bitbucket: {
        heroImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j6ow7g6d0b514p5fa2265brhf5hyn43l.webp',
        socialProofImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/f21tl4w4krcqx1j1n5b100x1h176wy64.svg'
    }
};

});

parcelRegister("8uO0X", function(module, exports) {
$parcel$export(module.exports, "defaultProduct", function () { return $2e2d9d193f818cad$export$ff7fa7230197689e; });
$parcel$export(module.exports, "products", function () { return $2e2d9d193f818cad$export$b6aad051bad07f12; });

var $fcO7r = parcelRequire("fcO7r");
const $2e2d9d193f818cad$export$ff7fa7230197689e = {
    bundle: 'jira-software',
    description: 'Jira',
    key: (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
    name: 'jira'
};
const $2e2d9d193f818cad$export$b6aad051bad07f12 = [
    {
        bundle: 'jira-software',
        description: 'Jira',
        key: (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
        name: 'jira'
    },
    {
        bundle: 'confluence',
        description: 'Confluence',
        key: (0, $fcO7r.ProductKey).CONFLUENCE,
        name: 'confluence'
    },
    {
        bundle: 'jira-service-management',
        description: 'Jira Service Management',
        key: (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT,
        name: 'jira-servicedesk'
    },
    {
        bundle: 'jira-service-desk',
        description: 'Jira Service Management',
        key: (0, $fcO7r.ProductKey).JIRA_SERVICE_DESK,
        name: 'jira-servicedesk'
    },
    {
        bundle: 'jira-product-discovery',
        description: 'Jira Product Discovery',
        key: (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY,
        name: 'jira-product-discovery'
    },
    {
        bundle: 'beacon',
        description: 'Beacon',
        key: (0, $fcO7r.ProductKey).BEACON,
        name: 'beacon'
    },
    {
        bundle: 'bitbucket',
        description: 'Bitbucket',
        key: (0, $fcO7r.ProductKey).BITBUCKET,
        name: 'bitbucket'
    },
    {
        bundle: 'compass',
        description: 'Compass',
        key: (0, $fcO7r.ProductKey).COMPASS,
        name: 'compass'
    },
    {
        bundle: 'fabric',
        description: 'Fabric',
        key: (0, $fcO7r.ProductKey).FABRIC,
        name: 'fabric'
    },
    {
        bundle: 'loom',
        description: 'Loom',
        key: (0, $fcO7r.ProductKey).LOOM,
        name: 'loom'
    },
    {
        bundle: 'opsgenie',
        description: 'Opsgenie',
        key: (0, $fcO7r.ProductKey).OPSGENIE,
        name: 'opsgenie'
    },
    {
        bundle: 'statuspage',
        description: 'Statuspage',
        key: (0, $fcO7r.ProductKey).STATUSPAGE,
        name: 'statuspage'
    },
    {
        bundle: 'devai',
        description: 'Rovo Dev Agents',
        key: (0, $fcO7r.ProductKey).DEVAI,
        name: 'devai'
    },
    {
        bundle: 'rovo',
        description: 'Rovo',
        key: (0, $fcO7r.ProductKey).ROVO,
        name: 'rovo'
    },
    {
        bundle: 'service-collection',
        description: 'Service Collection',
        key: (0, $fcO7r.ProductKey).SERVICE_COLLECTION,
        name: 'service-collection'
    },
    {
        bundle: 'teamwork-collection',
        description: 'Teamwork Collection',
        key: (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION,
        name: 'teamwork-collection'
    }
];

});



parcelRegister("aXBsz", function(module, exports) {
$parcel$export(module.exports, "daysAgo", function () { return $bbc68342f89966b5$export$298b083a523e0c9c; });
const $bbc68342f89966b5$export$298b083a523e0c9c = (days)=>Date.now() - days * 86400000;

});



parcelRegister("9JVlg", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_ANONYMOUS_ID_COOKIE_KEY", function () { return $ff4a0cf3eee98bef$export$121746a5cf7765d2; });
$parcel$export(module.exports, "ATLASSIAN_ACCOUNT_ID_COOKIE_KEY", function () { return $ff4a0cf3eee98bef$export$e2b09c9608af1474; });
$parcel$export(module.exports, "getCustomAttributes", function () { return $ff4a0cf3eee98bef$export$1ef2b1f78c9e40d9; });

var $yhhhl = parcelRequire("yhhhl");

var $kS3iu = parcelRequire("kS3iu");

var $fuLgT = parcelRequire("fuLgT");

var $2z2pq = parcelRequire("2z2pq");

var $fKfE1 = parcelRequire("fKfE1");

var $6wkgu = parcelRequire("6wkgu");

var $cuuGB = parcelRequire("cuuGB");

var $5b6JC = parcelRequire("5b6JC");

var $hu7gH = parcelRequire("hu7gH");

var $hgaI1 = parcelRequire("hgaI1");
const $ff4a0cf3eee98bef$export$121746a5cf7765d2 = 'ajs_anonymous_id';
const $ff4a0cf3eee98bef$export$e2b09c9608af1474 = '__aid_user_id';
let $ff4a0cf3eee98bef$var$ATL_COHORT_COOKIE_VALUE = undefined;
let $ff4a0cf3eee98bef$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE = undefined;
const $ff4a0cf3eee98bef$var$DEVICE_TYPE = 'deviceType';
const $ff4a0cf3eee98bef$var$FETCH_TIMEOUT_MS = 5000;
// @ts-ignore
const $ff4a0cf3eee98bef$var$clientOptions = {
    apiKey: String("4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f"),
    products: []
};
const $ff4a0cf3eee98bef$export$c2257a35df1efe44 = async (request)=>{
    const requestHeaders = request.headers;
    const identifiers = $ff4a0cf3eee98bef$export$1a39186c5d79b4fa(requestHeaders);
    const customAttributes = $ff4a0cf3eee98bef$export$1ef2b1f78c9e40d9(request, identifiers.analyticsAnonymousId);
    // The Tesseract/snapvm SSR runtime exposes AbortSignal.timeout but does not
    // provide the `scheduler` global it depends on internally. The upstream
    // feature-gate-node-client-bootstrapper library checks for the method's
    // existence but not whether it works, so calling it throws. Remove the
    // broken method to force the library's AbortController-based fallback.
    if (typeof AbortSignal !== 'undefined' && 'timeout' in AbortSignal) try {
        AbortSignal.timeout(1);
    } catch  {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete AbortSignal.timeout;
    }
    let response;
    try {
        // The timeout inside getClientInitializationValues relies on the AbortSignal.timeout
        // and AbortController APIs, neither of which are currently supported during SSR.
        // This custom timeout can be replaced once it is supported.
        let timeoutId;
        const timeoutPromise = new Promise((_resolve, reject)=>{
            timeoutId = setTimeout(()=>reject(new Error(`getClientInitializationValues failed to complete within the ${$ff4a0cf3eee98bef$var$FETCH_TIMEOUT_MS}ms timeout`)), $ff4a0cf3eee98bef$var$FETCH_TIMEOUT_MS);
        });
        const fetchPromise = (0, $2z2pq.getClientInitializationValues)($ff4a0cf3eee98bef$var$clientOptions, (0, $hgaI1.TARGET_APP), identifiers, customAttributes).then((featureGateValues)=>{
            // Clean up server-only infrastructure attributes that client can't verify
            // These cause bootstrap mismatch warnings in Statsig because the client
            // has no way to compute/verify them
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const expValues = featureGateValues.experimentValues;
            if (expValues?.['user']?.['custom']) {
                const cleanedCustom = {
                    ...expValues['user']['custom']
                };
                // Remove infrastructure-specific attributes
                delete cleanedCustom.microsEnv;
                delete cleanedCustom.microsAwsAvailabilityZone;
                delete cleanedCustom.userAgent;
                delete cleanedCustom.appVersion;
                expValues['user']['custom'] = cleanedCustom;
            }
            return {
                ...featureGateValues,
                identifiers: identifiers
            };
        }).finally(()=>{
            if (timeoutId) clearTimeout(timeoutId);
        });
        response = await Promise.race([
            fetchPromise,
            timeoutPromise
        ]);
    } catch (e) {
        const reason = e instanceof Error ? e.message : JSON.stringify(e);
        console.warn(`Could not fetch feature gate values, falling back to defaults. Reason: ${reason}`);
        response = {
            identifiers: identifiers
        };
    }
    return response;
};
const $ff4a0cf3eee98bef$export$1a39186c5d79b4fa = (headers)=>{
    // @ts-ignore
    const cookieHeader = headers['cookie'];
    const parsedCookies = cookieHeader ? (0, $yhhhl.parse)(cookieHeader) : {};
    const rawCloudId = new URLSearchParams(window?.location?.search).get('cloudId');
    const tenantId = (0, $6wkgu.enforceSafeCloudId)(rawCloudId) || undefined;
    return {
        // @ts-ignore
        analyticsAnonymousId: $ff4a0cf3eee98bef$var$getOrGenerateAnalyticsAnonymousId(parsedCookies),
        // @ts-ignore
        atlassianAccountId: $ff4a0cf3eee98bef$var$getAtlassianAccountId(parsedCookies),
        tenantId: tenantId
    };
};
const $ff4a0cf3eee98bef$export$74de76ff8df79f92 = ()=>$ff4a0cf3eee98bef$var$ATL_COHORT_COOKIE_VALUE;
const $ff4a0cf3eee98bef$export$30a84b3e63884abd = ()=>$ff4a0cf3eee98bef$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE;
const $ff4a0cf3eee98bef$var$getOrGenerateAnalyticsAnonymousId = (parsedCookies)=>{
    const anonymousIdCookieValue = parsedCookies[$ff4a0cf3eee98bef$export$121746a5cf7765d2];
    if (anonymousIdCookieValue) {
        // The cookie value is wrapped in quotes, so we need to remove those.
        $ff4a0cf3eee98bef$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE = decodeURIComponent(anonymousIdCookieValue).replace(/['"]+/g, '');
        return $ff4a0cf3eee98bef$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE;
    }
    (0, $cuuGB.polyfillGetRandomValuesIfNecessary)();
    $ff4a0cf3eee98bef$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE = (0, $fuLgT.default)();
    // Check for presence of lambda edge - check key
    if (parsedCookies['X-Experiments-Key']) {
        const experimentsKey = parsedCookies['X-Experiments-Key'];
        if (window.location.pathname === // @ts-ignore
        experimentsKey.split('~')[0].split('=')[1]) // This console.log should never occur when request is through lambda edge.
        // Edge should be passing in the cookie
        console.log('Generating new anonymous id cookie value ' + $ff4a0cf3eee98bef$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE);
    }
    return $ff4a0cf3eee98bef$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE;
};
/**
 * Get AtlCohort from cookie, if it doesn't exist, generate a new one
 * @param parsedCookies
 * @returns {"bucketAll":{"bucketedAtUTC":"2024-04-24T19:26:55.734Z","version":"2","index":74,"bucketId":0}}
 */ const $ff4a0cf3eee98bef$var$getOrGenerateAtlCohort = (parsedCookies, anonymousId)=>{
    const atlCohortCookieValue = parsedCookies[0, $fKfE1.ATL_COHORT];
    if (atlCohortCookieValue) try {
        $ff4a0cf3eee98bef$var$ATL_COHORT_COOKIE_VALUE = JSON.parse(decodeURIComponent(atlCohortCookieValue));
        return $ff4a0cf3eee98bef$var$ATL_COHORT_COOKIE_VALUE;
    } catch (e) {
        console.warn(`Could not parse ATL_COHORT cookie value: ${atlCohortCookieValue}, creating a new one.`, e);
    }
    const bucketAttribute = (0, $fKfE1.Cohort).createBucket('bucketAll', anonymousId);
    $ff4a0cf3eee98bef$var$ATL_COHORT_COOKIE_VALUE = {
        bucketAll: bucketAttribute
    };
    return $ff4a0cf3eee98bef$var$ATL_COHORT_COOKIE_VALUE;
};
const $ff4a0cf3eee98bef$var$getAtlassianAccountId = (parsedCookies)=>{
    const atlassianAccountIdCookieValue = parsedCookies[$ff4a0cf3eee98bef$export$e2b09c9608af1474];
    if (atlassianAccountIdCookieValue) return decodeURIComponent(atlassianAccountIdCookieValue);
    return undefined;
};
const $ff4a0cf3eee98bef$export$1ef2b1f78c9e40d9 = (request, anonymousId)=>{
    const data = {};
    const headers = request.headers;
    // @ts-ignore
    const cookieHeader = headers['cookie'];
    // @ts-ignore
    const cookieOverrideHeader = headers['cookieOverride'];
    // @ts-ignore
    const userAgent = headers['user-agent'] || '';
    const parsedCookies = cookieHeader ? (0, $yhhhl.parse)(cookieHeader) : cookieOverrideHeader ? JSON.parse(cookieOverrideHeader) : {};
    const atlCohort = $ff4a0cf3eee98bef$var$getOrGenerateAtlCohort(parsedCookies, anonymousId);
    if (atlCohort) data[0, $fKfE1.ATL_COHORT] = atlCohort.bucketAll.index;
    const { isTablet: isTablet, isMobile: isMobile, isDesktop: isDesktop, browserName: browserName, browserVersion: browserVersion, osName: osName } = (0, $kS3iu.getSelectorsByUserAgent)(userAgent) ?? {};
    if (isTablet) data[$ff4a0cf3eee98bef$var$DEVICE_TYPE] = 'tablet';
    else if (isMobile) data[$ff4a0cf3eee98bef$var$DEVICE_TYPE] = 'mobile';
    else if (isDesktop) data[$ff4a0cf3eee98bef$var$DEVICE_TYPE] = 'desktop';
    else data[$ff4a0cf3eee98bef$var$DEVICE_TYPE] = 'other';
    data.platform = 'uip';
    data.browserName = browserName;
    data.browserVersion = browserVersion;
    data.browserOS = osName;
    // Scrub Personal Data from the query string before exposing it to Statsig
    // as a user attribute. See utils/sanitize-query-params.ts and the PD
    // standard at https://hello.atlassian.net/wiki/spaces/PMP/pages/139161617.
    data.queryParams = (0, $5b6JC.sanitizeQueryParams)(location.search);
    data.requestPath = location.pathname;
    // @ts-expect-error - Tesseract Request type does not have referrer
    data.referer = request.referrer;
    data.locale = (0, $hu7gH.parseRoute)(globalThis.location).locale;
    data.anchor = (0, $hu7gH.parseRoute)(globalThis.location).anchor;
    data.subAnchor = (0, $hu7gH.parseRoute)(globalThis.location).subAnchor;
    const cloudSessionToken = parsedCookies['cloud.session.token'] || parsedCookies['cloud.session.token.stg'];
    data.loginUserDetected = cloudSessionToken !== undefined;
    // @ts-ignore
    data.edgeTraceId = parsedCookies['X-Experiments-Trace-Id'];
    return data;
};

});
parcelRegister("2z2pq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResponseError = module.exports.ClientError = module.exports.RequestErrorKind = module.exports.getClientInitializationValues = void 0;

var $fUUzM = parcelRequire("fUUzM");
Object.defineProperty(module.exports, "RequestErrorKind", {
    enumerable: true,
    get: function() {
        return $fUUzM.RequestErrorKind;
    }
});

var $eFv0e = parcelRequire("eFv0e");
Object.defineProperty(module.exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $eFv0e.ClientError;
    }
});

var $27fgl = parcelRequire("27fgl");
Object.defineProperty(module.exports, "ResponseError", {
    enumerable: true,
    get: function() {
        return $27fgl.ResponseError;
    }
});

var $hYdJ5 = parcelRequire("hYdJ5");
Object.defineProperty(module.exports, "getClientInitializationValues", {
    enumerable: true,
    get: function() {
        return $hYdJ5.getClientInitializationValues;
    }
});

});
parcelRegister("fUUzM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RequestErrorKind = module.exports.FeatureGateProducts = void 0;
/**
 * @enum {FeatureGateProducts}
 * The union of Products will be used to filter appropriate feature gates and experiments
 */ var $b967f8d5e1756880$var$FeatureGateProducts;
(function(FeatureGateProducts) {
    FeatureGateProducts["Jira"] = "jira";
    FeatureGateProducts["Confluence"] = "confluence";
    FeatureGateProducts["AdminHub"] = "adminhub";
    FeatureGateProducts["Platform"] = "platform";
})($b967f8d5e1756880$var$FeatureGateProducts || (module.exports.FeatureGateProducts = $b967f8d5e1756880$var$FeatureGateProducts = {}));
/**
 * @enum {string}
 * @property {BadRequestException} - The server request responds with 400, likely due to an invalid parameters.
 * @property {UnauthorisedRequestException} - The server request responds with 401, likely due to an invalid API key.
 * @property {UnknownException} - General exception thrown for all other non 200 request responses.
 * @property {IllegalStateException} - The client was unable to retrieve the `feature-flag-service` service proxy url upon instantiation
 * @property {NoContentException} - The server request responds with 204 due to empty response body.
 * @property {RateLimitedException} - The server request responds with 429 due to rate limiting.
 * @property {BadResponseException} - The server request responded with an unexpected type that could not be parsed.
 * @property {NotFoundException} - The server request responded with a 404, most likely due to a bad request url.
 * @property {ClientNotInitializedException} - The FeatureGates client was not initialized.
 */ var $b967f8d5e1756880$var$RequestErrorKind;
(function(RequestErrorKind) {
    RequestErrorKind["BadRequestException"] = "BadRequestException";
    RequestErrorKind["UnauthorisedRequestException"] = "UnauthorisedRequestException";
    RequestErrorKind["IllegalStateException"] = "IllegalStateException";
    RequestErrorKind["UnknownException"] = "UnknownException";
    RequestErrorKind["NoContentException"] = "NoContentException";
    RequestErrorKind["RateLimitedException"] = "RateLimitedException";
    RequestErrorKind["BadResponseException"] = "BadResponseException";
    RequestErrorKind["NotFoundException"] = "NotFoundException";
    RequestErrorKind["ClientNotInitializedException"] = "ClientNotInitializedException";
})($b967f8d5e1756880$var$RequestErrorKind || (module.exports.RequestErrorKind = $b967f8d5e1756880$var$RequestErrorKind = {}));

});

parcelRegister("eFv0e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientError = void 0;
/**
 * @class ClientError - Thrown when a client error occurred.
 * @extends Error
 * @param {string} message - The error message.
 * @param {RequestErrorKind} kind - The error kind.
 */ class $aadcf188734eeb7f$var$ClientError extends Error {
    constructor(message, kind){
        super(message);
        this.kind = kind;
    }
}
module.exports.ClientError = $aadcf188734eeb7f$var$ClientError;

});

parcelRegister("27fgl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResponseError = void 0;

var $fUUzM = parcelRequire("fUUzM");
/**
 * @class ResponseError - Thrown when a non 200 response was received from a fetch request.
 * @extends Error
 * @param {number} status - The status code of the response.
 * @param {string} message - The error message.
 * @param {RequestErrorKind} kind - The error kind.
 * @param {string} body - The response body.
 */ class $18a8130d43a83240$var$ResponseError extends Error {
    constructor(status, message, kind = $fUUzM.RequestErrorKind.UnknownException, body){
        super(message);
        this.status = status;
        this.kind = kind;
        this.body = body;
    }
}
module.exports.ResponseError = $18a8130d43a83240$var$ResponseError;

});

parcelRegister("hYdJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getClientInitializationValues = void 0;

var $fUUzM = parcelRequire("fUUzM");

var $9pyZI = parcelRequire("9pyZI");

var $eFv0e = parcelRequire("eFv0e");

var $27fgl = parcelRequire("27fgl");
/**
* @since 1.0.0
* @async
* @static
* @param {ClientOptions} clientOptions
* @param {String} targetApp
* @param {Identifiers} identifiers
* @param {CustomAttributes} customAttributes
* @returns {FrontendExperimentsResponse | undefined}
* @throws {ClientError} {@link RequestErrorKind.BadRequestException}
* @throws {ClientError} {@link RequestErrorKind.UnknownException}
* @throws {ClientError} {@link RequestErrorKind.IllegalStateException}
* @throws {ResponseError} {@link RequestErrorKind.UnauthorisedRequestException}
* @throws {ResponseError} {@link RequestErrorKind.NotFoundException}
* @throws {ResponseError} {@link RequestErrorKind.NoContentException}
* @throws {ResponseError} {@link RequestErrorKind.BadResponseException}
* @throws {ResponseError} {@link RequestErrorKind.RateLimitedException}
* @summary This will fetch experiment values by calling out to feature-flag-service [fx3]{@link https://go.atlassian.com/fx3}
* @example
await FeatureGates.getClientInitializationValues(
{
            // This is an fx3 api key used to fetch the feature flag values.
            // Supported keys found at go/fx3/resources/api-keys
            apiKey: 'client-test',
            // This will be used to filter data to only a specific target app
            targetApp: 'jira_web',
       },
{
            // These are expected identifiers, you must provide them if they are relevant to your product and will be added to exposures events
            // At least one identifier must be provided
            analyticsAnonymousId: '<analyticsAnonymousId>',
            atlassianAccountId: '<aaid>',
            atlassianOrgId: '<orgid>',
            tenantId: '<tenantid>',
            transactionAccountId: '<transactionAccountId'>,
            trelloUserId: '<trelloUserId'>,
            trelloWorkspaceId: '<trelloWorkspaceId'>,
       },
{
            // These are additional custom attributes that can be used for targeting and will be added to exposure events
             exampleCustomAttribute: '<attributeValue>',
       }
);
* @example
A successful request will return a [FrontendExperimentsRequestResponse]{@link FrontendExperimentsRequestResponse}
{
        // The client sdk key
        clientSdkKey: string;
        // Experiment values
        experimentValues: Record<string, value>;
        // Custom attributes used to fetch experiment values. Includes Targeting + User Dimension TAP traits.
        customAttributes: Record<string, value>;
   }
*/ const $d152afff1b3626cb$var$getClientInitializationValues = async (clientOptions, targetApp, identifiers, customAttributes)=>{
    const { apiKey: apiKey } = clientOptions;
    try {
        $d152afff1b3626cb$var$validateRequest(identifiers);
        return await (0, $9pyZI.fetchExperimentValues)(apiKey, targetApp, identifiers, customAttributes);
    } catch (error) {
        throw $d152afff1b3626cb$var$handleError(error);
    }
};
module.exports.getClientInitializationValues = $d152afff1b3626cb$var$getClientInitializationValues;
const $d152afff1b3626cb$var$validateRequest = (identifiers)=>{
    const noIdentifiers = Object.keys(identifiers).length == 0;
    if (noIdentifiers) throw new $eFv0e.ClientError('No request identifiers supplied.', $fUUzM.RequestErrorKind.BadRequestException);
};
const $d152afff1b3626cb$var$handleError = (error)=>{
    const isResponseError = error instanceof $27fgl.ResponseError;
    const isClientError = error instanceof $eFv0e.ClientError;
    if (isResponseError || isClientError) return error;
    const errMessage = error instanceof Error ? error.message : JSON.stringify(error);
    throw new $eFv0e.ClientError(`An error occurred while trying to get initialization values for client: ${errMessage}`, $fUUzM.RequestErrorKind.UnknownException);
};

});
parcelRegister("9pyZI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchExperimentValues = void 0;

var $6pozx = parcelRequire("6pozx");
Object.defineProperty(module.exports, "fetchExperimentValues", {
    enumerable: true,
    get: function() {
        return $6pozx.fetchExperimentValues;
    }
});

});
parcelRegister("6pozx", function(module, exports) {
"use strict";
var $4aa82369b3187126$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4aa82369b3187126$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4aa82369b3187126$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4aa82369b3187126$var$__createBinding(result, mod, k);
    }
    $4aa82369b3187126$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRequestUrl = module.exports.fetchExperimentValues = void 0;

var $eWOn5 = parcelRequire("eWOn5");

var $eFv0e = parcelRequire("eFv0e");

var $8AASy = parcelRequire("8AASy");

const $4aa82369b3187126$var$FetchRequest = $4aa82369b3187126$var$__importStar((parcelRequire("2iTlt")));

var $fUUzM = parcelRequire("fUUzM");

var $cGhO9 = parcelRequire("cGhO9");
const $4aa82369b3187126$var$REQUEST_TIMEOUT_MS = 2000;
async function $4aa82369b3187126$var$fetchExperimentValues(apiKey, targetApp, identifiers, customAttributes) {
    const requestBody = {
        targetApp: targetApp,
        identifiers: identifiers,
        customAttributes: customAttributes
    };
    const response = await fetch($4aa82369b3187126$var$getRequestUrl(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Client-Name': 'feature-gate-node-client',
            'X-Client-Version': $8AASy.CLIENT_VERSION,
            'X-API-KEY': apiKey
        },
        body: JSON.stringify(requestBody),
        signal: (0, $cGhO9.safeTimeoutSignal)($4aa82369b3187126$var$REQUEST_TIMEOUT_MS)
    });
    const bodyString = await $4aa82369b3187126$var$FetchRequest.handleResponse($4aa82369b3187126$var$getRequestUrl(), response);
    return $4aa82369b3187126$var$extractResponseBody(bodyString);
}
module.exports.fetchExperimentValues = $4aa82369b3187126$var$fetchExperimentValues;
function $4aa82369b3187126$var$getRequestUrl() {
    const baseUrl = "https://feature-flag-service.prod.atl-paas.net";
    if (!baseUrl) throw new $eFv0e.ClientError('Service proxy base url MESH_DEPENDENCY_FEATURE_FLAG_SERVICE_BASE_URL environment variable is not configured for your environment.', $fUUzM.RequestErrorKind.IllegalStateException);
    /*
     * Need to ensure that baseUrl ends with a '/' so that the URL constructor does not strip out `/flags` from
     * the MESH_DEPENDENCY_FEATURE_FLAG_SERVICE_BASE_URL env variable set by
     */ const parsedBaseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';
    return new URL('./api/v2/frontend/experimentValues', parsedBaseUrl).href;
}
module.exports.getRequestUrl = $4aa82369b3187126$var$getRequestUrl;
function $4aa82369b3187126$var$extractResponseBody(body) {
    const result = $eWOn5.FetcherExperimentsResponseSchema.safeParse(JSON.parse(body));
    if (!result.success) throw new $eFv0e.ClientError(`Could not parse request response.`, $fUUzM.RequestErrorKind.BadResponseException);
    return result.data;
}

});
parcelRegister("eWOn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetcherExperimentsResponseSchema = void 0;

var $fZWr1 = parcelRequire("fZWr1");
module.exports.FetcherExperimentsResponseSchema = $fZWr1.z.object({
    clientSdkKey: $fZWr1.z.string(),
    experimentValues: $fZWr1.z.record($fZWr1.z.string(), $fZWr1.z.unknown()),
    customAttributes: $fZWr1.z.record($fZWr1.z.string(), $fZWr1.z.unknown())
});

});
parcelRegister("fZWr1", function(module, exports) {
"use strict";
var $ba59e179337c9c96$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba59e179337c9c96$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ba59e179337c9c96$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ba59e179337c9c96$var$__createBinding(result, mod, k);
    }
    $ba59e179337c9c96$var$__setModuleDefault(result, mod);
    return result;
};
var $ba59e179337c9c96$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ba59e179337c9c96$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.z = void 0;

const $ba59e179337c9c96$var$z = $ba59e179337c9c96$var$__importStar((parcelRequire("4DzBM")));
module.exports.z = $ba59e179337c9c96$var$z;

$ba59e179337c9c96$var$__exportStar((parcelRequire("4DzBM")), module.exports);
module.exports.default = $ba59e179337c9c96$var$z;

});
parcelRegister("4DzBM", function(module, exports) {
"use strict";
var $36066d04e111f17a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $36066d04e111f17a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $36066d04e111f17a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$36066d04e111f17a$var$__exportStar((parcelRequire("fgl3L")), module.exports);

$36066d04e111f17a$var$__exportStar((parcelRequire("kqgeE")), module.exports);

$36066d04e111f17a$var$__exportStar((parcelRequire("ccMTR")), module.exports);

$36066d04e111f17a$var$__exportStar((parcelRequire("56P3D")), module.exports);

$36066d04e111f17a$var$__exportStar((parcelRequire("bkgmt")), module.exports);

$36066d04e111f17a$var$__exportStar((parcelRequire("jAX4n")), module.exports);

});
parcelRegister("fgl3L", function(module, exports) {
"use strict";
var $b1c8afaaea7d491e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getErrorMap = module.exports.setErrorMap = module.exports.defaultErrorMap = void 0;

const $b1c8afaaea7d491e$var$en_1 = $b1c8afaaea7d491e$var$__importDefault((parcelRequire("FXnpm")));
module.exports.defaultErrorMap = $b1c8afaaea7d491e$var$en_1.default;
let $b1c8afaaea7d491e$var$overrideErrorMap = $b1c8afaaea7d491e$var$en_1.default;
function $b1c8afaaea7d491e$var$setErrorMap(map) {
    $b1c8afaaea7d491e$var$overrideErrorMap = map;
}
module.exports.setErrorMap = $b1c8afaaea7d491e$var$setErrorMap;
function $b1c8afaaea7d491e$var$getErrorMap() {
    return $b1c8afaaea7d491e$var$overrideErrorMap;
}
module.exports.getErrorMap = $b1c8afaaea7d491e$var$getErrorMap;

});
parcelRegister("FXnpm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $56P3D = parcelRequire("56P3D");

var $jAX4n = parcelRequire("jAX4n");
const $07e1e36555cc7d18$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $jAX4n.ZodIssueCode.invalid_type:
            if (issue.received === $56P3D.ZodParsedType.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $jAX4n.ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $56P3D.util.jsonStringifyReplacer)}`;
            break;
        case $jAX4n.ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$56P3D.util.joinValues(issue.keys, ", ")}`;
            break;
        case $jAX4n.ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case $jAX4n.ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$56P3D.util.joinValues(issue.options)}`;
            break;
        case $jAX4n.ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${$56P3D.util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $jAX4n.ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $jAX4n.ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $jAX4n.ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case $jAX4n.ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $56P3D.util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $jAX4n.ZodIssueCode.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $jAX4n.ZodIssueCode.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $jAX4n.ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case $jAX4n.ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $jAX4n.ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $jAX4n.ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $56P3D.util.assertNever(issue);
    }
    return {
        message: message
    };
};
module.exports.default = $07e1e36555cc7d18$var$errorMap;

});
parcelRegister("56P3D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getParsedType = module.exports.ZodParsedType = module.exports.objectUtil = module.exports.util = void 0;
var $3b851e48a6590df7$var$util;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($3b851e48a6590df7$var$util = module.exports.util || (module.exports.util = {}));
var $3b851e48a6590df7$var$objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($3b851e48a6590df7$var$objectUtil = module.exports.objectUtil || (module.exports.objectUtil = {}));
module.exports.ZodParsedType = $3b851e48a6590df7$var$util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $3b851e48a6590df7$var$getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return module.exports.ZodParsedType.undefined;
        case "string":
            return module.exports.ZodParsedType.string;
        case "number":
            return isNaN(data) ? module.exports.ZodParsedType.nan : module.exports.ZodParsedType.number;
        case "boolean":
            return module.exports.ZodParsedType.boolean;
        case "function":
            return module.exports.ZodParsedType.function;
        case "bigint":
            return module.exports.ZodParsedType.bigint;
        case "symbol":
            return module.exports.ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return module.exports.ZodParsedType.array;
            if (data === null) return module.exports.ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return module.exports.ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return module.exports.ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return module.exports.ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return module.exports.ZodParsedType.date;
            return module.exports.ZodParsedType.object;
        default:
            return module.exports.ZodParsedType.unknown;
    }
};
module.exports.getParsedType = $3b851e48a6590df7$var$getParsedType;

});

parcelRegister("jAX4n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ZodError = module.exports.quotelessJson = module.exports.ZodIssueCode = void 0;

var $56P3D = parcelRequire("56P3D");
module.exports.ZodIssueCode = $56P3D.util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $e43f331c357182f9$var$quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
module.exports.quotelessJson = $e43f331c357182f9$var$quotelessJson;
class $e43f331c357182f9$var$ZodError extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $56P3D.util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
module.exports.ZodError = $e43f331c357182f9$var$ZodError;
$e43f331c357182f9$var$ZodError.create = (issues)=>{
    const error = new $e43f331c357182f9$var$ZodError(issues);
    return error;
};

});



parcelRegister("kqgeE", function(module, exports) {
"use strict";
var $ede2d459bf3a8a39$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAsync = module.exports.isValid = module.exports.isDirty = module.exports.isAborted = module.exports.OK = module.exports.DIRTY = module.exports.INVALID = module.exports.ParseStatus = module.exports.addIssueToContext = module.exports.EMPTY_PATH = module.exports.makeIssue = void 0;

var $fgl3L = parcelRequire("fgl3L");

const $ede2d459bf3a8a39$var$en_1 = $ede2d459bf3a8a39$var$__importDefault((parcelRequire("FXnpm")));
const $ede2d459bf3a8a39$var$makeIssue = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
module.exports.makeIssue = $ede2d459bf3a8a39$var$makeIssue;
module.exports.EMPTY_PATH = [];
function $ede2d459bf3a8a39$var$addIssueToContext(ctx, issueData) {
    const issue = (0, module.exports.makeIssue)({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            (0, $fgl3L.getErrorMap)(),
            $ede2d459bf3a8a39$var$en_1.default
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
module.exports.addIssueToContext = $ede2d459bf3a8a39$var$addIssueToContext;
class $ede2d459bf3a8a39$var$ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return module.exports.INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $ede2d459bf3a8a39$var$ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return module.exports.INVALID;
            if (value.status === "aborted") return module.exports.INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
module.exports.ParseStatus = $ede2d459bf3a8a39$var$ParseStatus;
module.exports.INVALID = Object.freeze({
    status: "aborted"
});
const $ede2d459bf3a8a39$var$DIRTY = (value)=>({
        status: "dirty",
        value: value
    });
module.exports.DIRTY = $ede2d459bf3a8a39$var$DIRTY;
const $ede2d459bf3a8a39$var$OK = (value)=>({
        status: "valid",
        value: value
    });
module.exports.OK = $ede2d459bf3a8a39$var$OK;
const $ede2d459bf3a8a39$var$isAborted = (x)=>x.status === "aborted";
module.exports.isAborted = $ede2d459bf3a8a39$var$isAborted;
const $ede2d459bf3a8a39$var$isDirty = (x)=>x.status === "dirty";
module.exports.isDirty = $ede2d459bf3a8a39$var$isDirty;
const $ede2d459bf3a8a39$var$isValid = (x)=>x.status === "valid";
module.exports.isValid = $ede2d459bf3a8a39$var$isValid;
const $ede2d459bf3a8a39$var$isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
module.exports.isAsync = $ede2d459bf3a8a39$var$isAsync;

});

parcelRegister("ccMTR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bkgmt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.date = module.exports.boolean = module.exports.bigint = module.exports.array = module.exports.any = module.exports.coerce = module.exports.ZodFirstPartyTypeKind = module.exports.late = module.exports.ZodSchema = module.exports.Schema = module.exports.custom = module.exports.ZodReadonly = module.exports.ZodPipeline = module.exports.ZodBranded = module.exports.BRAND = module.exports.ZodNaN = module.exports.ZodCatch = module.exports.ZodDefault = module.exports.ZodNullable = module.exports.ZodOptional = module.exports.ZodTransformer = module.exports.ZodEffects = module.exports.ZodPromise = module.exports.ZodNativeEnum = module.exports.ZodEnum = module.exports.ZodLiteral = module.exports.ZodLazy = module.exports.ZodFunction = module.exports.ZodSet = module.exports.ZodMap = module.exports.ZodRecord = module.exports.ZodTuple = module.exports.ZodIntersection = module.exports.ZodDiscriminatedUnion = module.exports.ZodUnion = module.exports.ZodObject = module.exports.ZodArray = module.exports.ZodVoid = module.exports.ZodNever = module.exports.ZodUnknown = module.exports.ZodAny = module.exports.ZodNull = module.exports.ZodUndefined = module.exports.ZodSymbol = module.exports.ZodDate = module.exports.ZodBoolean = module.exports.ZodBigInt = module.exports.ZodNumber = module.exports.ZodString = module.exports.ZodType = void 0;
module.exports.NEVER = module.exports.void = module.exports.unknown = module.exports.union = module.exports.undefined = module.exports.tuple = module.exports.transformer = module.exports.symbol = module.exports.string = module.exports.strictObject = module.exports.set = module.exports.record = module.exports.promise = module.exports.preprocess = module.exports.pipeline = module.exports.ostring = module.exports.optional = module.exports.onumber = module.exports.oboolean = module.exports.object = module.exports.number = module.exports.nullable = module.exports.null = module.exports.never = module.exports.nativeEnum = module.exports.nan = module.exports.map = module.exports.literal = module.exports.lazy = module.exports.intersection = module.exports.instanceof = module.exports.function = module.exports.enum = module.exports.effect = module.exports.discriminatedUnion = void 0;

var $fgl3L = parcelRequire("fgl3L");

var $aaMJx = parcelRequire("aaMJx");

var $kqgeE = parcelRequire("kqgeE");

var $56P3D = parcelRequire("56P3D");

var $jAX4n = parcelRequire("jAX4n");
class $83ee40fddbcf2af2$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $83ee40fddbcf2af2$var$handleResult = (ctx, result)=>{
    if ((0, $kqgeE.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $jAX4n.ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $83ee40fddbcf2af2$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $83ee40fddbcf2af2$var$ZodType {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $56P3D.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $56P3D.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $kqgeE.ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $56P3D.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $kqgeE.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $56P3D.getParsedType)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $83ee40fddbcf2af2$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $56P3D.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $kqgeE.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $83ee40fddbcf2af2$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $jAX4n.ZodIssueCode.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $83ee40fddbcf2af2$var$ZodEffects({
            schema: this,
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $83ee40fddbcf2af2$var$ZodOptional.create(this, this._def);
    }
    nullable() {
        return $83ee40fddbcf2af2$var$ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $83ee40fddbcf2af2$var$ZodArray.create(this, this._def);
    }
    promise() {
        return $83ee40fddbcf2af2$var$ZodPromise.create(this, this._def);
    }
    or(option) {
        return $83ee40fddbcf2af2$var$ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $83ee40fddbcf2af2$var$ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $83ee40fddbcf2af2$var$ZodEffects({
            ...$83ee40fddbcf2af2$var$processCreateParams(this._def),
            schema: this,
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $83ee40fddbcf2af2$var$ZodDefault({
            ...$83ee40fddbcf2af2$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new $83ee40fddbcf2af2$var$ZodBranded({
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...$83ee40fddbcf2af2$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $83ee40fddbcf2af2$var$ZodCatch({
            ...$83ee40fddbcf2af2$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $83ee40fddbcf2af2$var$ZodPipeline.create(this, target);
    }
    readonly() {
        return $83ee40fddbcf2af2$var$ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
module.exports.ZodType = $83ee40fddbcf2af2$var$ZodType;
module.exports.Schema = $83ee40fddbcf2af2$var$ZodType;
module.exports.ZodSchema = $83ee40fddbcf2af2$var$ZodType;
const $83ee40fddbcf2af2$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $83ee40fddbcf2af2$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $83ee40fddbcf2af2$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $83ee40fddbcf2af2$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $83ee40fddbcf2af2$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $83ee40fddbcf2af2$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $83ee40fddbcf2af2$var$emojiRegex;
const $83ee40fddbcf2af2$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $83ee40fddbcf2af2$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $83ee40fddbcf2af2$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $83ee40fddbcf2af2$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $83ee40fddbcf2af2$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $83ee40fddbcf2af2$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $83ee40fddbcf2af2$var$ZodString extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.string,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        const status = new $kqgeE.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$83ee40fddbcf2af2$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        validation: "email",
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$83ee40fddbcf2af2$var$emojiRegex) $83ee40fddbcf2af2$var$emojiRegex = new RegExp($83ee40fddbcf2af2$var$_emojiRegex, "u");
                if (!$83ee40fddbcf2af2$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$83ee40fddbcf2af2$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$83ee40fddbcf2af2$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$83ee40fddbcf2af2$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$83ee40fddbcf2af2$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $kqgeE.addIssueToContext)(ctx, {
                    validation: "url",
                    code: $jAX4n.ZodIssueCode.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $83ee40fddbcf2af2$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$83ee40fddbcf2af2$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: $jAX4n.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $56P3D.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $jAX4n.ZodIssueCode.invalid_string,
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $83ee40fddbcf2af2$var$ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$aaMJx.errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$aaMJx.errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$aaMJx.errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$aaMJx.errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $aaMJx.errorUtil.errToObj(message));
    }
    trim() {
        return new $83ee40fddbcf2af2$var$ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $83ee40fddbcf2af2$var$ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $83ee40fddbcf2af2$var$ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
module.exports.ZodString = $83ee40fddbcf2af2$var$ZodString;
$83ee40fddbcf2af2$var$ZodString.create = (params)=>{
    var _a;
    return new $83ee40fddbcf2af2$var$ZodString({
        checks: [],
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $83ee40fddbcf2af2$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $83ee40fddbcf2af2$var$ZodNumber extends $83ee40fddbcf2af2$var$ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.number,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        let ctx = undefined;
        const status = new $kqgeE.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$56P3D.util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($83ee40fddbcf2af2$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $56P3D.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $aaMJx.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $aaMJx.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $aaMJx.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $aaMJx.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $83ee40fddbcf2af2$var$ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $aaMJx.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $83ee40fddbcf2af2$var$ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $aaMJx.errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $56P3D.util.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
module.exports.ZodNumber = $83ee40fddbcf2af2$var$ZodNumber;
$83ee40fddbcf2af2$var$ZodNumber.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodNumber({
        checks: [],
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodBigInt extends $83ee40fddbcf2af2$var$ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.bigint,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        let ctx = undefined;
        const status = new $kqgeE.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $56P3D.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $aaMJx.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $aaMJx.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $aaMJx.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $aaMJx.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $83ee40fddbcf2af2$var$ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $aaMJx.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $83ee40fddbcf2af2$var$ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
module.exports.ZodBigInt = $83ee40fddbcf2af2$var$ZodBigInt;
$83ee40fddbcf2af2$var$ZodBigInt.create = (params)=>{
    var _a;
    return new $83ee40fddbcf2af2$var$ZodBigInt({
        checks: [],
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodBoolean extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.boolean,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        return (0, $kqgeE.OK)(input.data);
    }
}
module.exports.ZodBoolean = $83ee40fddbcf2af2$var$ZodBoolean;
$83ee40fddbcf2af2$var$ZodBoolean.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodBoolean({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodDate extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.date,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_date
            });
            return $kqgeE.INVALID;
        }
        const status = new $kqgeE.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $56P3D.util.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $83ee40fddbcf2af2$var$ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $aaMJx.errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
module.exports.ZodDate = $83ee40fddbcf2af2$var$ZodDate;
$83ee40fddbcf2af2$var$ZodDate.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodDate,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodSymbol extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.symbol,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        return (0, $kqgeE.OK)(input.data);
    }
}
module.exports.ZodSymbol = $83ee40fddbcf2af2$var$ZodSymbol;
$83ee40fddbcf2af2$var$ZodSymbol.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodSymbol({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodSymbol,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodUndefined extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.undefined,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        return (0, $kqgeE.OK)(input.data);
    }
}
module.exports.ZodUndefined = $83ee40fddbcf2af2$var$ZodUndefined;
$83ee40fddbcf2af2$var$ZodUndefined.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodUndefined({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodUndefined,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodNull extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.null,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        return (0, $kqgeE.OK)(input.data);
    }
}
module.exports.ZodNull = $83ee40fddbcf2af2$var$ZodNull;
$83ee40fddbcf2af2$var$ZodNull.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodNull({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodNull,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodAny extends $83ee40fddbcf2af2$var$ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $kqgeE.OK)(input.data);
    }
}
module.exports.ZodAny = $83ee40fddbcf2af2$var$ZodAny;
$83ee40fddbcf2af2$var$ZodAny.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodAny({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodAny,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodUnknown extends $83ee40fddbcf2af2$var$ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $kqgeE.OK)(input.data);
    }
}
module.exports.ZodUnknown = $83ee40fddbcf2af2$var$ZodUnknown;
$83ee40fddbcf2af2$var$ZodUnknown.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodUnknown({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodUnknown,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodNever extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $kqgeE.addIssueToContext)(ctx, {
            code: $jAX4n.ZodIssueCode.invalid_type,
            expected: $56P3D.ZodParsedType.never,
            received: ctx.parsedType
        });
        return $kqgeE.INVALID;
    }
}
module.exports.ZodNever = $83ee40fddbcf2af2$var$ZodNever;
$83ee40fddbcf2af2$var$ZodNever.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodNever({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodNever,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodVoid extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.void,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        return (0, $kqgeE.OK)(input.data);
    }
}
module.exports.ZodVoid = $83ee40fddbcf2af2$var$ZodVoid;
$83ee40fddbcf2af2$var$ZodVoid.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodVoid({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodVoid,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodArray extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $56P3D.ZodParsedType.array) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.array,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $kqgeE.addIssueToContext)(ctx, {
                    code: tooBig ? $jAX4n.ZodIssueCode.too_big : $jAX4n.ZodIssueCode.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $kqgeE.addIssueToContext)(ctx, {
                    code: $jAX4n.ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $kqgeE.addIssueToContext)(ctx, {
                    code: $jAX4n.ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $kqgeE.ParseStatus.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $kqgeE.ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $83ee40fddbcf2af2$var$ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: $aaMJx.errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $83ee40fddbcf2af2$var$ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $aaMJx.errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $83ee40fddbcf2af2$var$ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: $aaMJx.errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
module.exports.ZodArray = $83ee40fddbcf2af2$var$ZodArray;
$83ee40fddbcf2af2$var$ZodArray.create = (schema, params)=>{
    return new $83ee40fddbcf2af2$var$ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodArray,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
function $83ee40fddbcf2af2$var$deepPartialify(schema) {
    if (schema instanceof $83ee40fddbcf2af2$var$ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $83ee40fddbcf2af2$var$ZodOptional.create($83ee40fddbcf2af2$var$deepPartialify(fieldSchema));
        }
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $83ee40fddbcf2af2$var$ZodArray) return new $83ee40fddbcf2af2$var$ZodArray({
        ...schema._def,
        type: $83ee40fddbcf2af2$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $83ee40fddbcf2af2$var$ZodOptional) return $83ee40fddbcf2af2$var$ZodOptional.create($83ee40fddbcf2af2$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $83ee40fddbcf2af2$var$ZodNullable) return $83ee40fddbcf2af2$var$ZodNullable.create($83ee40fddbcf2af2$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $83ee40fddbcf2af2$var$ZodTuple) return $83ee40fddbcf2af2$var$ZodTuple.create(schema.items.map((item)=>$83ee40fddbcf2af2$var$deepPartialify(item)));
    else return schema;
}
class $83ee40fddbcf2af2$var$ZodObject extends $83ee40fddbcf2af2$var$ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $56P3D.util.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.object,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $83ee40fddbcf2af2$var$ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $83ee40fddbcf2af2$var$ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $kqgeE.addIssueToContext)(ctx, {
                        code: $jAX4n.ZodIssueCode.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $kqgeE.ParseStatus.mergeObjectSync(status, syncPairs);
        });
        else return $kqgeE.ParseStatus.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $aaMJx.errorUtil.errToObj;
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $aaMJx.errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $83ee40fddbcf2af2$var$ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $56P3D.util.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $56P3D.util.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $83ee40fddbcf2af2$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $56P3D.util.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $56P3D.util.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $83ee40fddbcf2af2$var$ZodOptional)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $83ee40fddbcf2af2$var$ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $83ee40fddbcf2af2$var$createZodEnum($56P3D.util.objectKeys(this.shape));
    }
}
module.exports.ZodObject = $83ee40fddbcf2af2$var$ZodObject;
$83ee40fddbcf2af2$var$ZodObject.create = (shape, params)=>{
    return new $83ee40fddbcf2af2$var$ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $83ee40fddbcf2af2$var$ZodNever.create(),
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodObject,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
$83ee40fddbcf2af2$var$ZodObject.strictCreate = (shape, params)=>{
    return new $83ee40fddbcf2af2$var$ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $83ee40fddbcf2af2$var$ZodNever.create(),
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodObject,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
$83ee40fddbcf2af2$var$ZodObject.lazycreate = (shape, params)=>{
    return new $83ee40fddbcf2af2$var$ZodObject({
        shape: shape,
        unknownKeys: "strip",
        catchall: $83ee40fddbcf2af2$var$ZodNever.create(),
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodObject,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodUnion extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $jAX4n.ZodError(result.ctx.common.issues));
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_union,
                unionErrors: unionErrors
            });
            return $kqgeE.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $jAX4n.ZodError(issues));
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_union,
                unionErrors: unionErrors
            });
            return $kqgeE.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
module.exports.ZodUnion = $83ee40fddbcf2af2$var$ZodUnion;
$83ee40fddbcf2af2$var$ZodUnion.create = (types, params)=>{
    return new $83ee40fddbcf2af2$var$ZodUnion({
        options: types,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodUnion,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $83ee40fddbcf2af2$var$getDiscriminator = (type)=>{
    if (type instanceof $83ee40fddbcf2af2$var$ZodLazy) return $83ee40fddbcf2af2$var$getDiscriminator(type.schema);
    else if (type instanceof $83ee40fddbcf2af2$var$ZodEffects) return $83ee40fddbcf2af2$var$getDiscriminator(type.innerType());
    else if (type instanceof $83ee40fddbcf2af2$var$ZodLiteral) return [
        type.value
    ];
    else if (type instanceof $83ee40fddbcf2af2$var$ZodEnum) return type.options;
    else if (type instanceof $83ee40fddbcf2af2$var$ZodNativeEnum) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $83ee40fddbcf2af2$var$ZodDefault) return $83ee40fddbcf2af2$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $83ee40fddbcf2af2$var$ZodUndefined) return [
        undefined
    ];
    else if (type instanceof $83ee40fddbcf2af2$var$ZodNull) return [
        null
    ];
    else return null;
};
class $83ee40fddbcf2af2$var$ZodDiscriminatedUnion extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $56P3D.ZodParsedType.object) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.object,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $kqgeE.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $83ee40fddbcf2af2$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $83ee40fddbcf2af2$var$ZodDiscriminatedUnion({
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$83ee40fddbcf2af2$var$processCreateParams(params)
        });
    }
}
module.exports.ZodDiscriminatedUnion = $83ee40fddbcf2af2$var$ZodDiscriminatedUnion;
function $83ee40fddbcf2af2$var$mergeValues(a, b) {
    const aType = (0, $56P3D.getParsedType)(a);
    const bType = (0, $56P3D.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $56P3D.ZodParsedType.object && bType === $56P3D.ZodParsedType.object) {
        const bKeys = $56P3D.util.objectKeys(b);
        const sharedKeys = $56P3D.util.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $83ee40fddbcf2af2$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $56P3D.ZodParsedType.array && bType === $56P3D.ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $83ee40fddbcf2af2$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $56P3D.ZodParsedType.date && bType === $56P3D.ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $83ee40fddbcf2af2$var$ZodIntersection extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $kqgeE.isAborted)(parsedLeft) || (0, $kqgeE.isAborted)(parsedRight)) return $kqgeE.INVALID;
            const merged = $83ee40fddbcf2af2$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $kqgeE.addIssueToContext)(ctx, {
                    code: $jAX4n.ZodIssueCode.invalid_intersection_types
                });
                return $kqgeE.INVALID;
            }
            if ((0, $kqgeE.isDirty)(parsedLeft) || (0, $kqgeE.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
module.exports.ZodIntersection = $83ee40fddbcf2af2$var$ZodIntersection;
$83ee40fddbcf2af2$var$ZodIntersection.create = (left, right, params)=>{
    return new $83ee40fddbcf2af2$var$ZodIntersection({
        left: left,
        right: right,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodIntersection,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodTuple extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $56P3D.ZodParsedType.array) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.array,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $kqgeE.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $kqgeE.ParseStatus.mergeArray(status, results);
        });
        else return $kqgeE.ParseStatus.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $83ee40fddbcf2af2$var$ZodTuple({
            ...this._def,
            rest: rest
        });
    }
}
module.exports.ZodTuple = $83ee40fddbcf2af2$var$ZodTuple;
$83ee40fddbcf2af2$var$ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $83ee40fddbcf2af2$var$ZodTuple({
        items: schemas,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodRecord extends $83ee40fddbcf2af2$var$ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $56P3D.ZodParsedType.object) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.object,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $kqgeE.ParseStatus.mergeObjectAsync(status, pairs);
        else return $kqgeE.ParseStatus.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $83ee40fddbcf2af2$var$ZodType) return new $83ee40fddbcf2af2$var$ZodRecord({
            keyType: first,
            valueType: second,
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodRecord,
            ...$83ee40fddbcf2af2$var$processCreateParams(third)
        });
        return new $83ee40fddbcf2af2$var$ZodRecord({
            keyType: $83ee40fddbcf2af2$var$ZodString.create(),
            valueType: first,
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodRecord,
            ...$83ee40fddbcf2af2$var$processCreateParams(second)
        });
    }
}
module.exports.ZodRecord = $83ee40fddbcf2af2$var$ZodRecord;
class $83ee40fddbcf2af2$var$ZodMap extends $83ee40fddbcf2af2$var$ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $56P3D.ZodParsedType.map) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.map,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $kqgeE.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $kqgeE.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
module.exports.ZodMap = $83ee40fddbcf2af2$var$ZodMap;
$83ee40fddbcf2af2$var$ZodMap.create = (keyType, valueType, params)=>{
    return new $83ee40fddbcf2af2$var$ZodMap({
        valueType: valueType,
        keyType: keyType,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodMap,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodSet extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $56P3D.ZodParsedType.set) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.set,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $kqgeE.addIssueToContext)(ctx, {
                    code: $jAX4n.ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $kqgeE.addIssueToContext)(ctx, {
                    code: $jAX4n.ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $kqgeE.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $83ee40fddbcf2af2$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $83ee40fddbcf2af2$var$ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: $aaMJx.errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $83ee40fddbcf2af2$var$ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $aaMJx.errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
module.exports.ZodSet = $83ee40fddbcf2af2$var$ZodSet;
$83ee40fddbcf2af2$var$ZodSet.create = (valueType, params)=>{
    return new $83ee40fddbcf2af2$var$ZodSet({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodSet,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodFunction extends $83ee40fddbcf2af2$var$ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $56P3D.ZodParsedType.function) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.function,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, $kqgeE.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $fgl3L.getErrorMap)(),
                    $fgl3L.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: $jAX4n.ZodIssueCode.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $kqgeE.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $fgl3L.getErrorMap)(),
                    $fgl3L.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: $jAX4n.ZodIssueCode.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $83ee40fddbcf2af2$var$ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $kqgeE.OK)(async function(...args) {
                const error = new $jAX4n.ZodError([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $kqgeE.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $jAX4n.ZodError([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $jAX4n.ZodError([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $83ee40fddbcf2af2$var$ZodFunction({
            ...this._def,
            args: $83ee40fddbcf2af2$var$ZodTuple.create(items).rest($83ee40fddbcf2af2$var$ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new $83ee40fddbcf2af2$var$ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $83ee40fddbcf2af2$var$ZodFunction({
            args: args ? args : $83ee40fddbcf2af2$var$ZodTuple.create([]).rest($83ee40fddbcf2af2$var$ZodUnknown.create()),
            returns: returns || $83ee40fddbcf2af2$var$ZodUnknown.create(),
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodFunction,
            ...$83ee40fddbcf2af2$var$processCreateParams(params)
        });
    }
}
module.exports.ZodFunction = $83ee40fddbcf2af2$var$ZodFunction;
class $83ee40fddbcf2af2$var$ZodLazy extends $83ee40fddbcf2af2$var$ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
module.exports.ZodLazy = $83ee40fddbcf2af2$var$ZodLazy;
$83ee40fddbcf2af2$var$ZodLazy.create = (getter, params)=>{
    return new $83ee40fddbcf2af2$var$ZodLazy({
        getter: getter,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodLazy,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodLiteral extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                received: ctx.data,
                code: $jAX4n.ZodIssueCode.invalid_literal,
                expected: this._def.value
            });
            return $kqgeE.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
module.exports.ZodLiteral = $83ee40fddbcf2af2$var$ZodLiteral;
$83ee40fddbcf2af2$var$ZodLiteral.create = (value, params)=>{
    return new $83ee40fddbcf2af2$var$ZodLiteral({
        value: value,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodLiteral,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
function $83ee40fddbcf2af2$var$createZodEnum(values, params) {
    return new $83ee40fddbcf2af2$var$ZodEnum({
        values: values,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodEnum,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
}
class $83ee40fddbcf2af2$var$ZodEnum extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $kqgeE.addIssueToContext)(ctx, {
                expected: $56P3D.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $jAX4n.ZodIssueCode.invalid_type
            });
            return $kqgeE.INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $kqgeE.addIssueToContext)(ctx, {
                received: ctx.data,
                code: $jAX4n.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return $kqgeE.INVALID;
        }
        return (0, $kqgeE.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $83ee40fddbcf2af2$var$ZodEnum.create(values);
    }
    exclude(values) {
        return $83ee40fddbcf2af2$var$ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
module.exports.ZodEnum = $83ee40fddbcf2af2$var$ZodEnum;
$83ee40fddbcf2af2$var$ZodEnum.create = $83ee40fddbcf2af2$var$createZodEnum;
class $83ee40fddbcf2af2$var$ZodNativeEnum extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const nativeEnumValues = $56P3D.util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $56P3D.ZodParsedType.string && ctx.parsedType !== $56P3D.ZodParsedType.number) {
            const expectedValues = $56P3D.util.objectValues(nativeEnumValues);
            (0, $kqgeE.addIssueToContext)(ctx, {
                expected: $56P3D.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $jAX4n.ZodIssueCode.invalid_type
            });
            return $kqgeE.INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $56P3D.util.objectValues(nativeEnumValues);
            (0, $kqgeE.addIssueToContext)(ctx, {
                received: ctx.data,
                code: $jAX4n.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return $kqgeE.INVALID;
        }
        return (0, $kqgeE.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
module.exports.ZodNativeEnum = $83ee40fddbcf2af2$var$ZodNativeEnum;
$83ee40fddbcf2af2$var$ZodNativeEnum.create = (values, params)=>{
    return new $83ee40fddbcf2af2$var$ZodNativeEnum({
        values: values,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodNativeEnum,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodPromise extends $83ee40fddbcf2af2$var$ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $56P3D.ZodParsedType.promise && ctx.common.async === false) {
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.promise,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        const promisified = ctx.parsedType === $56P3D.ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $kqgeE.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
module.exports.ZodPromise = $83ee40fddbcf2af2$var$ZodPromise;
$83ee40fddbcf2af2$var$ZodPromise.create = (schema, params)=>{
    return new $83ee40fddbcf2af2$var$ZodPromise({
        type: schema,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodPromise,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodEffects extends $83ee40fddbcf2af2$var$ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $kqgeE.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $kqgeE.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $kqgeE.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $kqgeE.isValid)(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $kqgeE.isValid)(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $56P3D.util.assertNever(effect);
    }
}
module.exports.ZodEffects = $83ee40fddbcf2af2$var$ZodEffects;
module.exports.ZodTransformer = $83ee40fddbcf2af2$var$ZodEffects;
$83ee40fddbcf2af2$var$ZodEffects.create = (schema, effect, params)=>{
    return new $83ee40fddbcf2af2$var$ZodEffects({
        schema: schema,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodEffects,
        effect: effect,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
$83ee40fddbcf2af2$var$ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new $83ee40fddbcf2af2$var$ZodEffects({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodEffects,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodOptional extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $56P3D.ZodParsedType.undefined) return (0, $kqgeE.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
module.exports.ZodOptional = $83ee40fddbcf2af2$var$ZodOptional;
$83ee40fddbcf2af2$var$ZodOptional.create = (type, params)=>{
    return new $83ee40fddbcf2af2$var$ZodOptional({
        innerType: type,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodOptional,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodNullable extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $56P3D.ZodParsedType.null) return (0, $kqgeE.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
module.exports.ZodNullable = $83ee40fddbcf2af2$var$ZodNullable;
$83ee40fddbcf2af2$var$ZodNullable.create = (type, params)=>{
    return new $83ee40fddbcf2af2$var$ZodNullable({
        innerType: type,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodNullable,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodDefault extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $56P3D.ZodParsedType.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
module.exports.ZodDefault = $83ee40fddbcf2af2$var$ZodDefault;
$83ee40fddbcf2af2$var$ZodDefault.create = (type, params)=>{
    return new $83ee40fddbcf2af2$var$ZodDefault({
        innerType: type,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodCatch extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $kqgeE.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $jAX4n.ZodError(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $jAX4n.ZodError(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
module.exports.ZodCatch = $83ee40fddbcf2af2$var$ZodCatch;
$83ee40fddbcf2af2$var$ZodCatch.create = (type, params)=>{
    return new $83ee40fddbcf2af2$var$ZodCatch({
        innerType: type,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
class $83ee40fddbcf2af2$var$ZodNaN extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $56P3D.ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $kqgeE.addIssueToContext)(ctx, {
                code: $jAX4n.ZodIssueCode.invalid_type,
                expected: $56P3D.ZodParsedType.nan,
                received: ctx.parsedType
            });
            return $kqgeE.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
module.exports.ZodNaN = $83ee40fddbcf2af2$var$ZodNaN;
$83ee40fddbcf2af2$var$ZodNaN.create = (params)=>{
    return new $83ee40fddbcf2af2$var$ZodNaN({
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodNaN,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
module.exports.BRAND = Symbol("zod_brand");
class $83ee40fddbcf2af2$var$ZodBranded extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
module.exports.ZodBranded = $83ee40fddbcf2af2$var$ZodBranded;
class $83ee40fddbcf2af2$var$ZodPipeline extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $kqgeE.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $kqgeE.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $kqgeE.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $83ee40fddbcf2af2$var$ZodPipeline({
            in: a,
            out: b,
            typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
module.exports.ZodPipeline = $83ee40fddbcf2af2$var$ZodPipeline;
class $83ee40fddbcf2af2$var$ZodReadonly extends $83ee40fddbcf2af2$var$ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ((0, $kqgeE.isValid)(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
module.exports.ZodReadonly = $83ee40fddbcf2af2$var$ZodReadonly;
$83ee40fddbcf2af2$var$ZodReadonly.create = (type, params)=>{
    return new $83ee40fddbcf2af2$var$ZodReadonly({
        innerType: type,
        typeName: $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind.ZodReadonly,
        ...$83ee40fddbcf2af2$var$processCreateParams(params)
    });
};
const $83ee40fddbcf2af2$var$custom = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $83ee40fddbcf2af2$var$ZodAny.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $83ee40fddbcf2af2$var$ZodAny.create();
};
module.exports.custom = $83ee40fddbcf2af2$var$custom;
module.exports.late = {
    object: $83ee40fddbcf2af2$var$ZodObject.lazycreate
};
var $83ee40fddbcf2af2$var$ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($83ee40fddbcf2af2$var$ZodFirstPartyTypeKind = module.exports.ZodFirstPartyTypeKind || (module.exports.ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class $83ee40fddbcf2af2$var$Class {
    constructor(..._){}
}
const $83ee40fddbcf2af2$var$instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>(0, module.exports.custom)((data)=>data instanceof cls, params);
module.exports.instanceof = $83ee40fddbcf2af2$var$instanceOfType;
const $83ee40fddbcf2af2$var$stringType = $83ee40fddbcf2af2$var$ZodString.create;
module.exports.string = $83ee40fddbcf2af2$var$stringType;
const $83ee40fddbcf2af2$var$numberType = $83ee40fddbcf2af2$var$ZodNumber.create;
module.exports.number = $83ee40fddbcf2af2$var$numberType;
const $83ee40fddbcf2af2$var$nanType = $83ee40fddbcf2af2$var$ZodNaN.create;
module.exports.nan = $83ee40fddbcf2af2$var$nanType;
const $83ee40fddbcf2af2$var$bigIntType = $83ee40fddbcf2af2$var$ZodBigInt.create;
module.exports.bigint = $83ee40fddbcf2af2$var$bigIntType;
const $83ee40fddbcf2af2$var$booleanType = $83ee40fddbcf2af2$var$ZodBoolean.create;
module.exports.boolean = $83ee40fddbcf2af2$var$booleanType;
const $83ee40fddbcf2af2$var$dateType = $83ee40fddbcf2af2$var$ZodDate.create;
module.exports.date = $83ee40fddbcf2af2$var$dateType;
const $83ee40fddbcf2af2$var$symbolType = $83ee40fddbcf2af2$var$ZodSymbol.create;
module.exports.symbol = $83ee40fddbcf2af2$var$symbolType;
const $83ee40fddbcf2af2$var$undefinedType = $83ee40fddbcf2af2$var$ZodUndefined.create;
module.exports.undefined = $83ee40fddbcf2af2$var$undefinedType;
const $83ee40fddbcf2af2$var$nullType = $83ee40fddbcf2af2$var$ZodNull.create;
module.exports.null = $83ee40fddbcf2af2$var$nullType;
const $83ee40fddbcf2af2$var$anyType = $83ee40fddbcf2af2$var$ZodAny.create;
module.exports.any = $83ee40fddbcf2af2$var$anyType;
const $83ee40fddbcf2af2$var$unknownType = $83ee40fddbcf2af2$var$ZodUnknown.create;
module.exports.unknown = $83ee40fddbcf2af2$var$unknownType;
const $83ee40fddbcf2af2$var$neverType = $83ee40fddbcf2af2$var$ZodNever.create;
module.exports.never = $83ee40fddbcf2af2$var$neverType;
const $83ee40fddbcf2af2$var$voidType = $83ee40fddbcf2af2$var$ZodVoid.create;
module.exports.void = $83ee40fddbcf2af2$var$voidType;
const $83ee40fddbcf2af2$var$arrayType = $83ee40fddbcf2af2$var$ZodArray.create;
module.exports.array = $83ee40fddbcf2af2$var$arrayType;
const $83ee40fddbcf2af2$var$objectType = $83ee40fddbcf2af2$var$ZodObject.create;
module.exports.object = $83ee40fddbcf2af2$var$objectType;
const $83ee40fddbcf2af2$var$strictObjectType = $83ee40fddbcf2af2$var$ZodObject.strictCreate;
module.exports.strictObject = $83ee40fddbcf2af2$var$strictObjectType;
const $83ee40fddbcf2af2$var$unionType = $83ee40fddbcf2af2$var$ZodUnion.create;
module.exports.union = $83ee40fddbcf2af2$var$unionType;
const $83ee40fddbcf2af2$var$discriminatedUnionType = $83ee40fddbcf2af2$var$ZodDiscriminatedUnion.create;
module.exports.discriminatedUnion = $83ee40fddbcf2af2$var$discriminatedUnionType;
const $83ee40fddbcf2af2$var$intersectionType = $83ee40fddbcf2af2$var$ZodIntersection.create;
module.exports.intersection = $83ee40fddbcf2af2$var$intersectionType;
const $83ee40fddbcf2af2$var$tupleType = $83ee40fddbcf2af2$var$ZodTuple.create;
module.exports.tuple = $83ee40fddbcf2af2$var$tupleType;
const $83ee40fddbcf2af2$var$recordType = $83ee40fddbcf2af2$var$ZodRecord.create;
module.exports.record = $83ee40fddbcf2af2$var$recordType;
const $83ee40fddbcf2af2$var$mapType = $83ee40fddbcf2af2$var$ZodMap.create;
module.exports.map = $83ee40fddbcf2af2$var$mapType;
const $83ee40fddbcf2af2$var$setType = $83ee40fddbcf2af2$var$ZodSet.create;
module.exports.set = $83ee40fddbcf2af2$var$setType;
const $83ee40fddbcf2af2$var$functionType = $83ee40fddbcf2af2$var$ZodFunction.create;
module.exports.function = $83ee40fddbcf2af2$var$functionType;
const $83ee40fddbcf2af2$var$lazyType = $83ee40fddbcf2af2$var$ZodLazy.create;
module.exports.lazy = $83ee40fddbcf2af2$var$lazyType;
const $83ee40fddbcf2af2$var$literalType = $83ee40fddbcf2af2$var$ZodLiteral.create;
module.exports.literal = $83ee40fddbcf2af2$var$literalType;
const $83ee40fddbcf2af2$var$enumType = $83ee40fddbcf2af2$var$ZodEnum.create;
module.exports.enum = $83ee40fddbcf2af2$var$enumType;
const $83ee40fddbcf2af2$var$nativeEnumType = $83ee40fddbcf2af2$var$ZodNativeEnum.create;
module.exports.nativeEnum = $83ee40fddbcf2af2$var$nativeEnumType;
const $83ee40fddbcf2af2$var$promiseType = $83ee40fddbcf2af2$var$ZodPromise.create;
module.exports.promise = $83ee40fddbcf2af2$var$promiseType;
const $83ee40fddbcf2af2$var$effectsType = $83ee40fddbcf2af2$var$ZodEffects.create;
module.exports.effect = $83ee40fddbcf2af2$var$effectsType;
module.exports.transformer = $83ee40fddbcf2af2$var$effectsType;
const $83ee40fddbcf2af2$var$optionalType = $83ee40fddbcf2af2$var$ZodOptional.create;
module.exports.optional = $83ee40fddbcf2af2$var$optionalType;
const $83ee40fddbcf2af2$var$nullableType = $83ee40fddbcf2af2$var$ZodNullable.create;
module.exports.nullable = $83ee40fddbcf2af2$var$nullableType;
const $83ee40fddbcf2af2$var$preprocessType = $83ee40fddbcf2af2$var$ZodEffects.createWithPreprocess;
module.exports.preprocess = $83ee40fddbcf2af2$var$preprocessType;
const $83ee40fddbcf2af2$var$pipelineType = $83ee40fddbcf2af2$var$ZodPipeline.create;
module.exports.pipeline = $83ee40fddbcf2af2$var$pipelineType;
const $83ee40fddbcf2af2$var$ostring = ()=>$83ee40fddbcf2af2$var$stringType().optional();
module.exports.ostring = $83ee40fddbcf2af2$var$ostring;
const $83ee40fddbcf2af2$var$onumber = ()=>$83ee40fddbcf2af2$var$numberType().optional();
module.exports.onumber = $83ee40fddbcf2af2$var$onumber;
const $83ee40fddbcf2af2$var$oboolean = ()=>$83ee40fddbcf2af2$var$booleanType().optional();
module.exports.oboolean = $83ee40fddbcf2af2$var$oboolean;
module.exports.coerce = {
    string: (arg)=>$83ee40fddbcf2af2$var$ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$83ee40fddbcf2af2$var$ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$83ee40fddbcf2af2$var$ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$83ee40fddbcf2af2$var$ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$83ee40fddbcf2af2$var$ZodDate.create({
            ...arg,
            coerce: true
        })
};
module.exports.NEVER = $kqgeE.INVALID;

});
parcelRegister("aaMJx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorUtil = void 0;
var $7680a402e90fab3e$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($7680a402e90fab3e$var$errorUtil = module.exports.errorUtil || (module.exports.errorUtil = {}));

});





parcelRegister("8AASy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CLIENT_VERSION = void 0;
module.exports.CLIENT_VERSION = "3.10.1";

});

parcelRegister("2iTlt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.handleResponse = void 0;

var $27fgl = parcelRequire("27fgl");

var $fUUzM = parcelRequire("fUUzM");
async function $1ad831a955695c6f$var$handleResponse(requestUrl, response) {
    // Use text() instead of json() as the error body might not be json data
    const body = await response.text();
    if (body.length === 0) throw new $27fgl.ResponseError(204, 'Unexpected 204 response.', $fUUzM.RequestErrorKind.NoContentException, '');
    if (!response.ok) {
        const status = response.status;
        switch(status){
            case 401:
                throw new $27fgl.ResponseError(response.status, 'Unauthorised request, likely due to an invalid API key.', $fUUzM.RequestErrorKind.UnauthorisedRequestException, JSON.stringify(body));
            case 400:
                throw new $27fgl.ResponseError(response.status, 'Bad request, likely due to invalid parameters.', $fUUzM.RequestErrorKind.BadRequestException, JSON.stringify(body));
            case 404:
                throw new $27fgl.ResponseError(response.status, `Request to ${requestUrl} gave 404 resource not found exception.`, $fUUzM.RequestErrorKind.NotFoundException, JSON.stringify(body));
            case 429:
                throw new $27fgl.ResponseError(response.status, 'Rate limiting exception occurred.', $fUUzM.RequestErrorKind.RateLimitedException, JSON.stringify(body));
            default:
                throw new $27fgl.ResponseError(response.status, `Non 2xx response status received.`, $fUUzM.RequestErrorKind.UnknownException, JSON.stringify(body));
        }
    }
    return body;
}
module.exports.handleResponse = $1ad831a955695c6f$var$handleResponse;

});

parcelRegister("cGhO9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.safeTimeoutSignal = void 0;
/**
 * This method generates an AbortSignal to attach to a request.
 * It does some extremely cautious checks to determine what is supported
 * @todo replace this with an AbortSignal.timeout polyfill
 *
 * @param timeoutMillis - the number of millis to wait before timing out
 * @returns an instance of AbortSignal if it can find a supported way to do it, otherwise undefined
 */ const $93b73887a5ee5253$var$safeTimeoutSignal = (timeoutMillis)=>{
    if ('AbortSignal' in $parcel$global && 'timeout' in AbortSignal) return AbortSignal.timeout(timeoutMillis);
    if ('AbortController' in $parcel$global) {
        const abortController = new AbortController();
        setTimeout(()=>abortController.abort(), timeoutMillis);
        return abortController.signal;
    }
    return undefined;
};
module.exports.safeTimeoutSignal = $93b73887a5ee5253$var$safeTimeoutSignal;

});





parcelRegister("6wkgu", function(module, exports) {
$parcel$export(module.exports, "enforceSafeCloudId", function () { return $f5710ea7e81daf03$export$a8ae1dc2f01c9aeb; });
/**
 * Validates a cloudId value read from URL query parameters to prevent Reflected XSS.
 */ const $f5710ea7e81daf03$var$CLOUD_ID_SAFE_PATTERN = /^[a-zA-Z0-9-]{1,128}$/;
function $f5710ea7e81daf03$export$a8ae1dc2f01c9aeb(raw) {
    if (raw == null || typeof raw !== 'string') return '';
    const trimmed = raw.trim();
    return $f5710ea7e81daf03$var$CLOUD_ID_SAFE_PATTERN.test(trimmed) ? trimmed : '';
}

});

parcelRegister("5b6JC", function(module, exports) {
$parcel$export(module.exports, "sanitizeQueryParams", function () { return $6f7446cb2dda7e54$export$e24e095133c579b3; });
/**
 * Removes Personal Data (PD) from a URL query string before it is forwarded
 * to third-party systems such as Statsig as a user attribute.
 *
 * Atlassian's PD Standard
 * (https://hello.atlassian.net/wiki/spaces/PMP/pages/139161617) classifies a
 * number of fields as Restricted/Confidential PD. Several of those fields are
 * frequently appended to wac.atlassian.com URLs by marketing campaigns,
 * onboarding redirects, sign-up flows, etc. (`?email=...`, `?firstName=...`,
 * `?phone=...`, ...), and were being sent verbatim to Statsig via the
 * `queryParams` user attribute.
 *
 * This utility scrubs the query string in two passes:
 *
 *   1. Drops any parameter whose **name** matches a known PD field name
 *      (case-insensitive, supports common separator variants such as
 *      `firstname`, `first_name`, `first-name`, `firstName`).
 *   2. Redacts any parameter whose **value** clearly looks like a PD value
 *      (currently: anything containing an `@` is treated as an email-shaped
 *      value, regardless of the key).
 *
 * The result preserves param ordering and is safe to use as a Statsig user
 * attribute. The function is intentionally pure and side-effect free so it can
 * be exercised on both server and client code paths
 * (see `feature-gates/bootstrapper.ts` and
 * `utils/fg-bootstrap-values-override-utils.ts`).
 */ /**
 * PD field names sourced from the "Atlassian PD Elements" table on
 * https://hello.atlassian.net/wiki/spaces/PMP/pages/139161617#Atlassian-PD-Elements.
 *
 * Names are stored in a normalized form (lowercase, with `_` and `-` removed)
 * so that the lookup matches `firstName`, `first_name`, `first-name`, and
 * `firstname` without having to enumerate every variant.
 *
 * NOTE: this list is deliberately conservative — when in doubt, drop the
 * parameter. Adding a brand-new query param is cheap; leaking a PD value to a
 * third party is not.
 */ const $6f7446cb2dda7e54$var$PD_PARAM_NAMES = new Set([
    // --- Direct identifiers ---
    'email',
    'emailaddress',
    'useremail',
    'personalemail',
    'workemail',
    'name',
    'fullname',
    'firstname',
    'lastname',
    'givenname',
    'familyname',
    'surname',
    'middlename',
    'displayname',
    'nickname',
    'username',
    'user',
    'userid',
    // Atlassian account IDs are PD; cloud identifiers come in
    //         on their own dedicated, validated `cloudId` param which
    //         is intentionally NOT scrubbed.
    'login',
    'loginid',
    'phone',
    'phonenumber',
    'mobile',
    'mobilenumber',
    'telephone',
    'tel',
    'fax',
    'address',
    'address1',
    'address2',
    'streetaddress',
    'street',
    'city',
    'state',
    'province',
    'postalcode',
    'postcode',
    'zip',
    'zipcode',
    'country',
    // request-derived geo is allowed via the dedicated
    //            `country`/`region` user attributes; we do NOT want
    //            user-supplied country values from the URL.
    'billingaddress',
    'shippingaddress',
    'passport',
    'passportnumber',
    'ssn',
    'taxid',
    'nationalid',
    'governmentid',
    'creditcard',
    'cardnumber',
    'ccnumber',
    'cvv',
    'cvc',
    'bankaccount',
    'iban',
    'profilephoto',
    'avatar',
    'avatarurl',
    'photo',
    'photourl',
    'biography',
    'bio',
    'aboutme',
    // --- Indirect identifiers (Restricted) ---
    'jobtitle',
    'title',
    'role',
    'dob',
    'dateofbirth',
    'birthday',
    'birthdate',
    'age',
    'gender',
    'genderidentity',
    'pronouns',
    'preferredpronouns',
    'race',
    'ethnicity',
    'sexualorientation',
    'disability',
    'disabilitystatus',
    'education',
    'educationlevel',
    'ip',
    'ipaddress',
    'ccexp',
    'ccexpiration',
    'creditcardexpiration',
    'creditcardtype',
    // --- Atlassian-specific PD ---
    'aaid',
    'atlassianaccountid',
    'accountid',
    'sen',
    'supportentitlementnumber'
].map($6f7446cb2dda7e54$var$normalizeParamName));
/** Placeholder value substituted in for parameters whose value shape looks
 *  like PD (e.g. an email). The key is preserved so that downstream
 *  experiment targeting that already inspects "did this URL have an `x`
 *  param?" continues to work, but the actual PD value never leaves the
 *  process. */ const $6f7446cb2dda7e54$var$REDACTED = '[REDACTED]';
/**
 * Normalizes a query-param name for deny-list comparison: lowercases, and
 * strips common separators so `first_name`, `first-name`, `firstName`, and
 * `firstname` all collapse to the same key.
 */ function $6f7446cb2dda7e54$var$normalizeParamName(name) {
    return name.toLowerCase().replace(/[_\-\s]/g, '');
}
/** Returns true if a value looks like an email address. Intentionally cheap
 *  and conservative — we only need to catch obvious leakage, not validate
 *  RFC 5322. */ function $6f7446cb2dda7e54$var$looksLikeEmail(value) {
    // Any "x@y" with no whitespace is treated as an email-shaped value.
    return /[^\s@]+@[^\s@]+/.test(value);
}
function $6f7446cb2dda7e54$export$e24e095133c579b3(search) {
    if (!search) return '';
    const hasLeadingQuestionMark = search.startsWith('?');
    const raw = hasLeadingQuestionMark ? search.slice(1) : search;
    if (raw.length === 0) return hasLeadingQuestionMark ? '?' : '';
    // URLSearchParams handles decoding and re-encoding for us, and preserves
    // insertion order, which keeps the sanitized string stable for any
    // downstream targeting that hashes the value.
    let params;
    try {
        params = new URLSearchParams(raw);
    } catch  {
        // If the query string is malformed, the safest behaviour is to drop
        // it entirely rather than risk forwarding PD.
        return hasLeadingQuestionMark ? '?' : '';
    }
    const sanitized = new URLSearchParams();
    for (const [key, value] of params){
        if ($6f7446cb2dda7e54$var$PD_PARAM_NAMES.has($6f7446cb2dda7e54$var$normalizeParamName(key))) continue;
        if ($6f7446cb2dda7e54$var$looksLikeEmail(value)) {
            sanitized.append(key, $6f7446cb2dda7e54$var$REDACTED);
            continue;
        }
        sanitized.append(key, value);
    }
    const result = sanitized.toString();
    if (result.length === 0) return hasLeadingQuestionMark ? '?' : '';
    return hasLeadingQuestionMark ? `?${result}` : result;
}

});

parcelRegister("hu7gH", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagValues", function () { return $4ec934b9396109da$export$e65c18714c4363a3; });
$parcel$export(module.exports, "parseRoute", function () { return $4ec934b9396109da$export$9bf1c8c94a38f6fb; });

var $a0utR = parcelRequire("a0utR");

var $80kL5 = parcelRequire("80kL5");

var $eRzlV = parcelRequire("eRzlV");
/**
 * Removes trailing slashes from a route path for consistent matching
 * Preserves empty paths (root route)
 * @param path - The path to normalize
 * @returns The path without trailing slashes
 */ const $4ec934b9396109da$var$removeTrailingSlash = (path)=>{
    // Don't remove slash from empty paths (root "/")
    if (path.length <= 1) return path;
    // Remove single trailing slash
    return path.endsWith('/') ? path.slice(0, -1) : path;
};
const $4ec934b9396109da$export$e65c18714c4363a3 = (params)=>{
    // set defaults for feature flags
    const featureFlags = {
        enableBundlesAfterSignup: false,
        enableCutSignUpStepsInHalf: false,
        provisionSecondPartyApps: false
    };
    if (params[0]) params[0] = params[0].replace(/^\?(.+)/, '$1');
    params.forEach((param)=>{
        const [key, value] = param.split('=');
        switch(key){
            case 'provisionSecondPartyApps':
                if (value === 'enableProvisionSecondPartyApps') featureFlags.provisionSecondPartyApps = true;
                break;
        }
    });
    return featureFlags;
};
const $4ec934b9396109da$export$9bf1c8c94a38f6fb = (location)=>{
    // remove all leading slashes (server had 2 leading slashes, client has 1)
    const noSlashPrefixPath = location.pathname.replace(/^\/+/, '');
    if (noSlashPrefixPath === 'index.html') // case for the unlocalized home page
    return {
        locale: 'en',
        path: '',
        variant: undefined,
        search: '',
        featureFlags: {}
    };
    // check if the route has a locale prefix
    const potentialLocale = noSlashPrefixPath.split('/')[0] || '';
    const localeIsValid = (0, $80kL5.isValidLocale)(potentialLocale);
    // if there is a locale prefix, set the locale variable and remove the prefix from the path
    // otherwise, set the locale to the default (en) and leave the path as is
    const locale = localeIsValid ? potentialLocale : 'en';
    const pathWithoutLocale = localeIsValid ? noSlashPrefixPath.slice(locale.length + 1) : noSlashPrefixPath;
    // Remove trailing slashes for consistent route matching
    // This ensures /software/jira/ matches the same route as /software/jira
    const cleanedPath = $4ec934b9396109da$var$removeTrailingSlash(pathWithoutLocale);
    const params = (location.search ?? '').split('&');
    let cmsVariantValue = params.filter((param)=>param.includes('cmsVariant'))[0]?.split('=')[1];
    const rawPersona = params.filter((param)=>param.includes('persona'))[0]?.split('=')[1];
    const isUniformCanary = params.filter((param)=>param.includes('canary'))[0]?.split('=')[1];
    const keyword = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('keyword'))[0]?.split('=')[1] || ''));
    const channel = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('channel'))[0]?.split('=')[1] || ''));
    const anchor = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('anchor'))[0]?.split('=')[1] || ''));
    const subAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('subAnchor'))[0]?.split('=')[1] || ''));
    const mlTemplateIds = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('mlTemplateIds'))[0]?.split('=')[1] || '')).split(',').filter((i)=>i !== '');
    //if they were redirected from jira.com, set referrer to jira.com
    const referrer = params.filter((param)=>param.includes('referer'))[0]?.split('=')[1] === 'jira.com' ? 'jira.com' : '';
    const referralSource = decodeURIComponent(params.filter((param)=>param.includes('referralSource'))[0]?.split('=')[1] || '');
    // publicQueryParams is double encoded
    const publicQueryParams = decodeURIComponent(decodeURIComponent(params.filter((param)=>param.includes('publicQueryParams'))[0]?.split('=')[1] || ''));
    const clusterTag = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('anchor='))[0]?.split('=')[1] || ''));
    const utmMedium = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('utm_medium'))[0]?.split('=')[1] || ''));
    const utmContent = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('utm_content'))[0]?.split('=')[1] || ''));
    const utmCampaign = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('utm_campaign'))[0]?.split('=')[1] || ''));
    let persona = undefined;
    try {
        // if rawPersona is malformed or incidentally a unicode sequence, decodeURIComponent will throw an error
        persona = rawPersona ? decodeURIComponent(rawPersona) : undefined;
    } catch (e) {
        console.error('Error decoding persona parameter', e, rawPersona);
    }
    const teamType = (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(decodeURIComponent(params.filter((param)=>param.includes('team_type'))[0]?.split('=')[1] || ''));
    if (cleanedPath.includes('enterprise')) // Use formType parameter if cleanedPath contains 'enterprise'
    cmsVariantValue = params.filter((param)=>param.includes('formType'))[0]?.split('=')[1];
    const featureFlags = $4ec934b9396109da$export$e65c18714c4363a3(params);
    const bundleParam = decodeURIComponent(params.filter((param)=>param.includes('bundle'))[0]?.split('=')[1] || '');
    const productParam = decodeURIComponent(params.filter((param)=>param.includes('product'))[0]?.split('=')[1] || '');
    const product = (0, $eRzlV.getProductNameFromBundle)(bundleParam, productParam);
    return {
        path: cleanedPath,
        variant: cmsVariantValue,
        locale: locale,
        search: location.search,
        featureFlags: featureFlags,
        persona: persona,
        teamType: teamType,
        keyword: keyword,
        mlTemplateIds: mlTemplateIds,
        referrer: referrer,
        isUniformCanary: isUniformCanary,
        product: product,
        channel: channel,
        anchor: anchor,
        subAnchor: subAnchor,
        referralSource: referralSource,
        publicQueryParams: publicQueryParams,
        clusterTag: clusterTag,
        utmMedium: utmMedium,
        utmContent: utmContent,
        utmCampaign: utmCampaign
    };
};

});



parcelRegister("7mHQv", function(module, exports) {
$parcel$export(module.exports, "PageWrapper", function () { return $d1c5b3b8d51c009c$export$3a31c848ced7e406; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $g57Lc = parcelRequire("g57Lc");

var $bQjAr = parcelRequire("bQjAr");

var $iSeHD = parcelRequire("iSeHD");

var $4t4Fg = parcelRequire("4t4Fg");

var $bv77X = parcelRequire("bv77X");

var $7GVWk = parcelRequire("7GVWk");

var $dqd4k = parcelRequire("dqd4k");

var $ieoZa = parcelRequire("ieoZa");

var $eXdIx = parcelRequire("eXdIx");

var $6yEAO = parcelRequire("6yEAO");

var $gMME0 = parcelRequire("gMME0");

var $5Ntyw = parcelRequire("5Ntyw");

var $kZYAp = parcelRequire("kZYAp");

var $4u4go = parcelRequire("4u4go");

var $3o1l4 = parcelRequire("3o1l4");

var $e5xHH = parcelRequire("e5xHH");

var $jWxnl = parcelRequire("jWxnl");

var $9rnwe = parcelRequire("9rnwe");

var $gx3aw = parcelRequire("gx3aw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
parcelRequire("kfEUh");

var $28AH4 = parcelRequire("28AH4");

var $1ka2O = parcelRequire("1ka2O");

var $3riD8 = parcelRequire("3riD8");

var $gLm0b = parcelRequire("gLm0b");

var $9oWEq = parcelRequire("9oWEq");

var $5mv0J = parcelRequire("5mv0J");

var $eRzlV = parcelRequire("eRzlV");

var $aGbDs = parcelRequire("aGbDs");

var $i4BST = parcelRequire("i4BST");

var $hu7gH = parcelRequire("hu7gH");
/* Temporary code for debugging purposes - will be removed */ function $d1c5b3b8d51c009c$var$getExperimentKeyValue(query, key) {
    if (!query.startsWith('?')) query = '?' + query;
    const params = new URLSearchParams(query);
    return params.get(key);
}
const $d1c5b3b8d51c009c$var$X_EXPERIMENTS_KEY = 'X-Experiments-Key';
const $d1c5b3b8d51c009c$var$checkEdgeCacheKeyMismatch = (analyticsWebClient, wacWebTrafficAAGateValue)=>{
    if (analyticsWebClient) {
        const xExperimentsKey = (0, $gx3aw.Cookie).readCookie($d1c5b3b8d51c009c$var$X_EXPERIMENTS_KEY);
        if (xExperimentsKey) {
            const splitKey = xExperimentsKey.split('~')[1];
            if (!splitKey) return;
            const decodedExperimentsKey = (0, (/*@__PURE__*/$parcel$interopDefault($g57Lc))).decompressFromBase64(splitKey);
            const evaluatedValueInExpKey = $d1c5b3b8d51c009c$var$getExperimentKeyValue(decodedExperimentsKey, (0, $ai3ZP.featureFlags).wacWebTrafficAAGate.featureFlagName);
            const featureGatesAnonIdUsedInSSR = window?.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
            if (evaluatedValueInExpKey !== null && evaluatedValueInExpKey !== undefined && String(wacWebTrafficAAGateValue) !== evaluatedValueInExpKey) analyticsWebClient.sendOperationalEvent({
                action: 'mismatched',
                actionSubject: 'featureGate',
                source: 'layout',
                attributes: {
                    featureGateName: (0, $ai3ZP.featureFlags).wacWebTrafficAAGate.featureFlagName,
                    route: window.location.pathname,
                    anonIdUsedInSSR: featureGatesAnonIdUsedInSSR,
                    anonIdInAnalyticsClient: analyticsWebClient.getAnonymousId(),
                    experimentKeyValue: evaluatedValueInExpKey,
                    featureGateValue: String(wacWebTrafficAAGateValue),
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore - is static param
                    fallback: window.IS_STATIC ? 'true' : 'false'
                }
            });
        }
    }
};
const $d1c5b3b8d51c009c$export$3a31c848ced7e406 = (props)=>{
    const hasAutoAtlAnalytics = true;
    const pageViewProperties = {};
    const { locale: locale, path: path, utmMedium: utmMedium, utmContent: utmContent, utmCampaign: utmCampaign, variant: variant, subAnchor: subAnchor } = (0, $hu7gH.parseRoute)(props.location);
    const atlassianUserId = (0, $ieoZa.Identity).getAtlassianUserId();
    (0, $28AH4.useAnchorLocalStorage)();
    // Hook to update title and description dynamically on client side
    (0, $aGbDs.useDynamicTitleDescription)(props.location, props.queryRef);
    const isBrowser = ()=>typeof window !== 'undefined';
    if (isBrowser()) {
        (0, $kZYAp.trackRouteUFOV1PageLoad)(path);
        pageViewProperties.originProduct = 'wac' + (window.location.pathname === '/' ? '' : window.location.pathname.replace(new RegExp('/', 'g'), '-'));
        (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacWebUseEsModulesScripts);
        // Trigger exposure for the edge lambda cache product discovery feature flag that is checked server side
        (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).edgeLambdaCacheProductDiscovery);
        // AA gate, purely to observe the traffic volume in Statsig for logged in users
        //eslint-disable-next-line @typescript-eslint/no-unused-expressions
        atlassianUserId && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacWebLoggedInTrafficAAGate);
    }
    const uniformContext = (0, $jWxnl.createUniformContext)();
    uniformContext.update({
        quirks: {
            name: props.userProfile?.name ?? ''
        }
    });
    const personalizationValues = {};
    const clusterTagValue = variant || window.cmsPageVariant;
    const subAnchorValue = subAnchor || window.subAnchor;
    if (clusterTagValue) personalizationValues[(0, $3o1l4.UserSegmentTypes).CLUSTER_TAG] = clusterTagValue;
    if (subAnchorValue) personalizationValues[(0, $3o1l4.UserSegmentTypes).SUB_ANCHOR] = subAnchorValue;
    if (props.channel) personalizationValues[(0, $3o1l4.UserSegmentTypes).CHANNEL] = props.channel;
    if (utmContent) personalizationValues[(0, $3o1l4.UserSegmentTypes).UTM_CONTENT] = utmContent;
    if (!(0, $eRzlV.isProduction)() && isBrowser()) {
        const queryParams = new URLSearchParams(window.location.search);
        const wacPersonaParam = queryParams.get((0, $4u4go.WAC_PERSONA_PARAM));
        if (wacPersonaParam) {
            const parsed = (0, $4u4go.parseWacPersonaParam)(decodeURIComponent(wacPersonaParam));
            Object.assign(personalizationValues, parsed, {
                useOverrides: true
            });
        }
    }
    /* Use Effect below is temporary code for debugging purposes - will be removed */ // useEdgeKeyMismatchHook(props.analyticsWebClient, wacWebTrafficAAGateValue);
    (0, $1oC0p.useEffect)(()=>{
        // AA gate, purely to observe the traffic volume in Statsig
        const wacWebTrafficAAGateValue = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacWebTrafficAAGate);
        $d1c5b3b8d51c009c$var$checkEdgeCacheKeyMismatch(props.analyticsWebClient, wacWebTrafficAAGateValue);
        // Send operational event when static fallback is detected
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - parameters
        if (window.IS_STATIC && props.analyticsWebClient) props.analyticsWebClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'staticWACFallback',
            source: 'page-wrapper-streaming',
            attributes: {
                route: window.location.pathname,
                userAgent: props.userAgent,
                anonymousId: props.analyticsWebClient.getAnonymousId()
            }
        });
    }, [
        props.analyticsWebClient,
        props.userAgent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gLm0b.OneTrustProvider), {
        isUniformPlayground: props.isUniformPlayground,
        children: [
            false,
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iSeHD.WacAnalyticsClientProvider), {
                analyticsWebClient: props.analyticsWebClient ?? null,
                location: props.location,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6yEAO.InitUFOV1), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1ka2O.LocationProvider), {
                        location: props.location,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
                            name: "wac",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9oWEq.SmartReCaptcha), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Ntyw.BxpWebStargateClientProvider), {
                                    baseUrl: (0, $5Ntyw.getStargateBaseUrl)(),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5mv0J.SSRLoginStateProvider), {
                                        hasCloudSessionTokenCookie: props.hasCloudSessionTokenCookie ?? false,
                                        userAgent: props.userAgent,
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3riD8.LoggedInUserProvider), {
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dqd4k.GupsProvider), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i4BST.WacRefreshProvider), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9rnwe.WAEContextProvider), {
                                                        wacEnvironment: "production",
                                                        uniformEnvironment: (0, $e5xHH.getUniformEnvironment)(typeof window !== 'undefined' ? window.location.href : ''),
                                                        uniformProjectId: undefined,
                                                        isCanvas: props.isUniformPlayground,
                                                        isAllowPostMessage: props.isAllowPostMessage,
                                                        composition: props.composition,
                                                        contentfulEnvironment: undefined,
                                                        personalizationValues: personalizationValues,
                                                        uniformContext: uniformContext,
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4t4Fg.WacAnalyticsListener), {
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gMME0.CrossFlowProvider), {
                                                                locale: locale,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
                                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7GVWk.UserContextProvider), {
                                                                            location: props.location.href,
                                                                            referrer: props.referrer,
                                                                            meResponse: props.userProfile,
                                                                            meRequest: props.userProfileStatus,
                                                                            userProfileResponse: props.userContext,
                                                                            userProfileRequest: props.userContextStatus,
                                                                            loggedOutContext: props.loggedOutContext,
                                                                            loggedOutContextStatus: props.loggedOutContextStatus,
                                                                            loggedInContext: props.loggedInContext,
                                                                            loggedInContextStatus: props.loggedInContextStatus,
                                                                            transactionAccounts: props.transactionAccounts,
                                                                            utmCampaign: utmCampaign,
                                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)(props.PageComponent, {
                                                                                ...props,
                                                                                utmMedium: utmMedium,
                                                                                utmContent: utmContent,
                                                                                utmCampaign: utmCampaign
                                                                            })
                                                                        })
                                                                    }),
                                                                    hasAutoAtlAnalytics && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eXdIx.InitializeAutoAtlAnalytics), {
                                                                        pageViewProperties: pageViewProperties
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("bQjAr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $89f3be9484d39087$export$2e2bcd8739ae039; });

var $8oIst = parcelRequire("8oIst");


var $89f3be9484d39087$export$2e2bcd8739ae039 = (0, $8oIst.default);

});
parcelRegister("8oIst", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61d30d1d91815a08$export$2e2bcd8739ae039; });

var $gNkVH = parcelRequire("gNkVH");

var $kOzMB = parcelRequire("kOzMB");

var $1oC0p = parcelRequire("1oC0p");

var $8OZ01 = parcelRequire("8OZ01");

var $jFqL6 = parcelRequire("jFqL6");

var $as5v9 = parcelRequire("as5v9");

var $03EZb = parcelRequire("03EZb");

var $bMbcH = parcelRequire("bMbcH");

var $iqOwP = parcelRequire("iqOwP");

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");

var $kBQuN = parcelRequire("kBQuN");

var $chCdD = parcelRequire("chCdD");

var $9buZV = parcelRequire("9buZV");

var $88sSl = parcelRequire("88sSl");
function $61d30d1d91815a08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61d30d1d91815a08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61d30d1d91815a08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61d30d1d91815a08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $61d30d1d91815a08$var$tryCompleteHandle;
var $61d30d1d91815a08$var$hasMarkedFirstSegmentLoad = false;
/** A portion of the page we apply measurement to */ var $61d30d1d91815a08$var$UFOSegment = function UFOSegment(_ref) {
    var segmentName = _ref.name, children = _ref.children, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'single' : _ref$mode, _ref$type = _ref.type, type = _ref$type === void 0 ? 'first-party' : _ref$type;
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    var ufoEnabled = (0, $03EZb.isUFOEnabled)();
    var parentContext = (0, $1oC0p.useContext)((0, $iqOwP.default));
    var segmentIdMap = (0, $1oC0p.useMemo)(function() {
        if (!(parentContext !== null && parentContext !== void 0 && parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    var segmentId = (0, $1oC0p.useMemo)(function() {
        if (mode === 'single') return (0, $chCdD.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        var newSegmentId = (0, $chCdD.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    var labelStack = (0, $1oC0p.useMemo)(function() {
        return parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [].concat((0, $kOzMB.default)(parentContext.labelStack), [
            $61d30d1d91815a08$var$_objectSpread({
                name: segmentName,
                segmentId: segmentId
            }, type !== 'first-party' ? {
                type: type
            } : {}) // Only pass non-default types (not 'first-party') in payload to reduce size
        ]) : [
            $61d30d1d91815a08$var$_objectSpread({
                name: segmentName,
                segmentId: segmentId
            }, type !== 'first-party' ? {
                type: type
            } : {})
        ];
    }, [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    var interactionId = (0, $1oC0p.useContext)((0, $1BTY2.default));
    if (interactionId.current != null && !$61d30d1d91815a08$var$hasMarkedFirstSegmentLoad) {
        (0, $a48Mt.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        $61d30d1d91815a08$var$hasMarkedFirstSegmentLoad = true;
    }
    var interactionContext = (0, $1oC0p.useMemo)(function() {
        var lastCompleteEndTime = 0;
        function complete() {
            var endTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    var capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($61d30d1d91815a08$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($61d30d1d91815a08$var$tryCompleteHandle);
                    }
                    var onComplete = function onComplete() {
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis$document;
                            var isPageVisible = (globalThis === null || globalThis === void 0 || (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) === 'visible';
                            var canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $61d30d1d91815a08$var$tryCompleteHandle = requestAnimationFrame(function() {
                                $61d30d1d91815a08$var$tryCompleteHandle = requestAnimationFrame(function() {
                                    if (capturedInteractionId === interactionId.current) (0, $a48Mt.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $a48Mt.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $8OZ01.unstable_scheduleCallback)((0, $8OZ01.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            var experimental = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    var capturedInteractionId = interactionId.current;
                    var disposeHold = (0, $a48Mt.addHold)(interactionId.current, labelStack, name, experimental);
                    return function() {
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $a48Mt.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $a48Mt.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return $61d30d1d91815a08$var$_objectSpread($61d30d1d91815a08$var$_objectSpread({}, parentContext), {}, {
            labelStack: labelStack,
            complete: complete
        });
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold: function hold() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental: function holdExperimental() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID: function addHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID: function removeHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress: function tracePress() {
                var _getDoNotAbortActiveP, _getMinorInteractions;
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
                var timestamp = arguments.length > 1 ? arguments[1] : undefined;
                var minorInteractions = [].concat((0, $kOzMB.default)((_getDoNotAbortActiveP = (0, $03EZb.getDoNotAbortActivePressInteraction)()) !== null && _getDoNotAbortActiveP !== void 0 ? _getDoNotAbortActiveP : []), (0, $kOzMB.default)((_getMinorInteractions = (0, $03EZb.getMinorInteractions)()) !== null && _getMinorInteractions !== void 0 ? _getMinorInteractions : []));
                if (minorInteractions.includes(name)) {
                    var _activeInteraction$mi;
                    var activeInteraction = (0, $a48Mt.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
                        name: name,
                        startTime: timestamp !== null && timestamp !== void 0 ? timestamp : performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $a48Mt.abortByNewInteraction)(interactionId.current, name);
                var rate = (0, $03EZb.getInteractionRate)(name, 'press');
                if ((0, $as5v9.default)(rate)) {
                    var startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    var newId = (0, $jFqL6.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $bMbcH.setInteractionActiveTrace)(newId, 'press');
                    (0, $a48Mt.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $kBQuN.default).current, (0, $bMbcH.getActiveTrace)());
                }
            },
            retainQuery: function retainQuery(info) {
                if (interactionId.current != null) (0, $a48Mt.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload: function addPreload(moduleId, timestamp) {
                if (interactionId.current != null) (0, $a48Mt.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad: function addLoad(identifier, start, end) {
                if (interactionId.current != null) {
                    var _this$labelStack = this.labelStack, _labelStack = _this$labelStack === void 0 ? [] : _this$labelStack;
                    (0, $a48Mt.addSpan)(interactionId.current, 'bundle_load', identifier, _labelStack, start, end);
                }
            },
            addMark: function addMark(name, timestamp) {
                if (interactionId.current != null) {
                    var time = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    (0, $a48Mt.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData: function addCustomData(customData) {
                if (interactionId.current != null) (0, $a48Mt.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings: function addCustomTimings(customTimings) {
                if (interactionId.current != null) (0, $a48Mt.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex: function addApdex(apdexInfo) {
                if (interactionId.current != null) {
                    var key = apdexInfo.key, stopTime = apdexInfo.stopTime, startTime = apdexInfo.startTime;
                    (0, $a48Mt.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender: function onRender(phase, actualDuration, baseDuration, startTime, commitTime) {
                var _this = this;
                if (interactionId.current !== null) {
                    (0, $a48Mt.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $9buZV.default)(function() {
                        var paintedTime = performance.now();
                        _this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    var hasMounted = (0, $1oC0p.useRef)(false);
    var onRender = (0, $1oC0p.useCallback)(function(_id, phase, actualDuration, baseDuration, startTime, commitTime) {
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((_getConfig = (0, $03EZb.getConfig)()) !== null && _getConfig !== void 0 && _getConfig.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $1oC0p.useEffect)(function() {
        (0, $a48Mt.addSegment)(labelStack);
        return function() {
            (0, $a48Mt.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    var reactProfilerId = (0, $1oC0p.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join('/');
    }, [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iqOwP.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $88sSl.default), {
        labelStack: labelStack,
        onRender: function onRender() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return interactionContext.onRender.apply(interactionContext, args);
        }
    }, ufoSegment);
};
$61d30d1d91815a08$var$UFOSegment.displayName = 'UFOSegment';
var $61d30d1d91815a08$export$2e2bcd8739ae039 = $61d30d1d91815a08$var$UFOSegment;

});
parcelRegister("chCdD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8f14b80aa6815008$export$2e2bcd8739ae039; });
function $8f14b80aa6815008$var$generateId() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for(var i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $8f14b80aa6815008$export$2e2bcd8739ae039 = $8f14b80aa6815008$var$generateId;

});

parcelRegister("9buZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6afd2faa7582c802$export$2e2bcd8739ae039; });

var $7t0tI = parcelRequire("7t0tI");
function $6afd2faa7582c802$var$scheduleOnPaint(callback) {
    var _process, _globalThis$document;
    var isSSR = typeof window === 'undefined' || Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__) || typeof $7t0tI !== 'undefined' && Boolean((_process = $7t0tI) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(function() {
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(function() {
        requestAnimationFrame(function() {
            callback();
        });
    });
}
var $6afd2faa7582c802$export$2e2bcd8739ae039 = $6afd2faa7582c802$var$scheduleOnPaint;

});



parcelRegister("4t4Fg", function(module, exports) {
$parcel$export(module.exports, "WacAnalyticsListener", function () { return $f8aaf13a14780956$export$cc11fd4b7198f590; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fuLgT = parcelRequire("fuLgT");

var $kL3Tm = parcelRequire("kL3Tm");

var $gx3aw = parcelRequire("gx3aw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $gLm0b = parcelRequire("gLm0b");

var $92PV0 = parcelRequire("92PV0");

var $iSeHD = parcelRequire("iSeHD");
const $f8aaf13a14780956$export$cc11fd4b7198f590 = ({ children: children })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { analyticsOptOut: analyticsOptOut, isConsentLoaded: isConsentLoaded } = (0, $gLm0b.useOneTrustContext)();
    const [loginUserDetected, setLoginUserDetected] = (0, $1oC0p.useState)('false');
    const queueRef = (0, $1oC0p.useRef)([]);
    const traceIdRef = (0, $1oC0p.useRef)(null);
    const isEnableOperationalEventWhenOptedOut = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10416DisableNonOperationalAnalyticsGateUip);
    const isReady = isEnableOperationalEventWhenOptedOut ? Boolean(analyticsClient && isConsentLoaded) : Boolean(analyticsClient);
    (0, $1oC0p.useEffect)(()=>{
        const isVoltronMultiTouchEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).voltronMultiTouchAnalytics);
        if (isVoltronMultiTouchEnabled) {
            const generatedTraceId = (0, $fuLgT.default)();
            traceIdRef.current = generatedTraceId;
            localStorage.setItem('trace_id', generatedTraceId);
        }
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const cookieValue = (0, $gx3aw.Cookie).readCookie('login_user_detected');
        if (cookieValue) setLoginUserDetected(cookieValue);
    }, []);
    const flush = (0, $1oC0p.useCallback)((payload, context, channel)=>{
        if (!analyticsClient) return;
        if (isEnableOperationalEventWhenOptedOut && analyticsOptOut && payload?.['eventType'] !== 'operational') return;
        const traceid = traceIdRef.current;
        if (channel === 'signup') {
            const analyticsDataList = [
                ...context,
                payload
            ];
            const analyticsEventMagnolia = analyticsDataList.reduce((mergedAnalyticsEvent, currentAnalyicsEvent)=>{
                return {
                    ...mergedAnalyticsEvent,
                    ...currentAnalyicsEvent,
                    ...traceid ? {
                        trace_id: traceid
                    } : {}
                };
            }, {});
            (0, $92PV0.Tracking).trackEvent(analyticsEventMagnolia['eventName'], analyticsEventMagnolia);
            return;
        }
        const processedEventPayload = {
            actionSubject: 'component',
            eventType: 'ui',
            source: 'default',
            ...payload,
            attributes: {
                ...payload?.['attributes'] || {},
                loginUserDetected: loginUserDetected,
                ...traceid ? {
                    trace_id: traceid
                } : {}
            }
        };
        if (!!window?.cmsPageVariant) processedEventPayload['attributes'].cmsPageVariant = window.cmsPageVariant;
        const ANALYTICS_TYPE = "gasv3";
        if (ANALYTICS_TYPE === 'console') console.log({
            event: processedEventPayload
        });
        analyticsClient.onEvent(null, processedEventPayload);
    }, [
        analyticsClient,
        analyticsOptOut,
        loginUserDetected
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!isReady || queueRef.current.length === 0) return;
        const q = queueRef.current;
        queueRef.current = [];
        q.forEach(({ payload: payload, context: context, channel: channel })=>flush(payload, context, channel));
    }, [
        isReady,
        flush
    ]);
    const onEvent = (0, $1oC0p.useCallback)((event, channel)=>{
        if (!isReady) {
            queueRef.current.push({
                payload: event.payload,
                context: event.context,
                channel: channel
            });
            return;
        }
        flush(event.payload, event.context, channel);
    }, [
        isReady,
        flush
    ]);
    return(/**
     * Current channels are:
     * - atl-global: For all auto-generated events from InitializeAutoAtlAnalytics
     * - marketing: For events generated via the React components themselves
     *
     * TODO - can add in the FabricEventsListeners to catch atlasKit and fabric components etc.
     */ /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kL3Tm.default), {
        channel: '*',
        onEvent: onEvent,
        children: children
    }));
};

});
parcelRegister("kL3Tm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f1cb3748653077fe$export$2e2bcd8739ae039; });

var $5ff76 = parcelRequire("5ff76");

var $hEFtg = parcelRequire("hEFtg");

var $7t0tI = parcelRequire("7t0tI");
var $f1cb3748653077fe$var$_process$env;
var $f1cb3748653077fe$var$ExportedAnalyticsListener;
if (typeof $7t0tI !== 'undefined' && $7t0tI !== null && ($f1cb3748653077fe$var$_process$env = {}, true) && $f1cb3748653077fe$var$_process$env !== void 0 && $f1cb3748653077fe$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']) $f1cb3748653077fe$var$ExportedAnalyticsListener = (0, $hEFtg.default);
else $f1cb3748653077fe$var$ExportedAnalyticsListener = (0, $5ff76.default);
var $f1cb3748653077fe$export$2e2bcd8739ae039 = $f1cb3748653077fe$var$ExportedAnalyticsListener;

});
parcelRegister("5ff76", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d1a13afc194e6cc$export$2e2bcd8739ae039; });

var $9GFoj = parcelRequire("9GFoj");

var $1itsa = parcelRequire("1itsa");

var $4A0Tr = parcelRequire("4A0Tr");

var $i1kpm = parcelRequire("i1kpm");

var $jfDAi = parcelRequire("jfDAi");

var $djanu = parcelRequire("djanu");

var $gc1Dl = parcelRequire("gc1Dl");

var $9c1Qf = parcelRequire("9c1Qf");

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $bEiDG = parcelRequire("bEiDG");
function $3d1a13afc194e6cc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3d1a13afc194e6cc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $gc1Dl.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gc1Dl.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $djanu.default)(this, result);
    };
}
function $3d1a13afc194e6cc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $3d1a13afc194e6cc$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func
};
var $3d1a13afc194e6cc$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $3d1a13afc194e6cc$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    (0, $jfDAi.default)(AnalyticsListener, _Component);
    var _super = $3d1a13afc194e6cc$var$_createSuper(AnalyticsListener);
    function AnalyticsListener(props) {
        var _this;
        (0, $1itsa.default)(this, AnalyticsListener);
        _this = _super.call(this, props);
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $3d1a13afc194e6cc$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, $9GFoj.default)(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $3d1a13afc194e6cc$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $4A0Tr.default)(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsListener;
}((0, $1oC0p.Component));
(0, $9c1Qf.default)($3d1a13afc194e6cc$var$AnalyticsListener, "contextTypes", $3d1a13afc194e6cc$var$ContextTypes);
(0, $9c1Qf.default)($3d1a13afc194e6cc$var$AnalyticsListener, "childContextTypes", $3d1a13afc194e6cc$var$ContextTypes);
var $3d1a13afc194e6cc$export$2e2bcd8739ae039 = $3d1a13afc194e6cc$var$AnalyticsListener;

});
parcelRegister("4OgEb", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3808bebb1b9e27cd$var$ReactIs, $3808bebb1b9e27cd$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("j7YoM"))();

});
parcelRegister("j7YoM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $li7Re = parcelRequire("li7Re");
function $decd85afdbeb0f36$var$emptyFunction() {}
function $decd85afdbeb0f36$var$emptyFunctionWithReset() {}
$decd85afdbeb0f36$var$emptyFunctionWithReset.resetWarningCache = $decd85afdbeb0f36$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $li7Re) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $decd85afdbeb0f36$var$emptyFunctionWithReset,
        resetWarningCache: $decd85afdbeb0f36$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("li7Re", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f8015fc6b3eedeb9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f8015fc6b3eedeb9$var$ReactPropTypesSecret;

});




parcelRegister("hEFtg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cda65760fd78e724$export$2e2bcd8739ae039; });

var $9GFoj = parcelRequire("9GFoj");

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");

var $e1T86 = parcelRequire("e1T86");

var $j10Ql = parcelRequire("j10Ql");
var $cda65760fd78e724$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var analyticsContext = (0, $e1T86.useAnalyticsContext)();
    var onEventRef = (0, $j10Ql.useTrackedRef)(onEvent);
    var channelRef = (0, $j10Ql.useTrackedRef)(channel);
    var getAtlaskitAnalyticsEventHandlers = (0, $1oC0p.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [].concat((0, $9GFoj.default)(analyticsContext.getAtlaskitAnalyticsEventHandlers()), [
            thisHandler
        ]);
    }, [
        analyticsContext,
        channelRef,
        onEventRef
    ]);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers,
            getAtlaskitAnalyticsContext: analyticsContext.getAtlaskitAnalyticsContext
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
        value: value
    }, children);
};
var $cda65760fd78e724$export$2e2bcd8739ae039 = $cda65760fd78e724$var$AnalyticsListener;

});
parcelRegister("j10Ql", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $dd7ec3bfd9df90e0$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $dd7ec3bfd9df90e0$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};

});




parcelRegister("bv77X", function(module, exports) {
$parcel$export(module.exports, "useSitesContext", function () { return $f61c5195cd8a5eba$export$3b4b23553295d0ad; });
$parcel$export(module.exports, "SitesContextProvider", function () { return $f61c5195cd8a5eba$export$d6c39dfd40fa7ff8; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $chzua = parcelRequire("chzua");

var $glBJg = parcelRequire("glBJg");
const $f61c5195cd8a5eba$export$a35464c11db06d9a = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $f61c5195cd8a5eba$export$3b4b23553295d0ad = ()=>{
    const context = (0, $1oC0p.useContext)($f61c5195cd8a5eba$export$a35464c11db06d9a);
    if (!context) throw new Error('useSitesContext must be used within a SitesContextProvider');
    return context;
};
const $f61c5195cd8a5eba$export$d6c39dfd40fa7ff8 = ({ children: children })=>{
    const [sites, setSites] = (0, $1oC0p.useState)(undefined);
    const response = (0, $glBJg.useAISAvailableProducts)({});
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $chzua.AsyncResult).isComplete(response)) setSites(response.value?.sites);
        else if ((0, $chzua.AsyncResult).isError(response)) setSites([]);
    }, [
        response
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f61c5195cd8a5eba$export$a35464c11db06d9a.Provider, {
        value: {
            sites: sites
        },
        children: children
    });
};

});
parcelRegister("chzua", function(module, exports) {
$parcel$export(module.exports, "useAsync", function () { return $d181fb8f2b7ee6a7$export$cdf1dc76b55502e3; });
$parcel$export(module.exports, "AsyncResult", function () { return $d181fb8f2b7ee6a7$export$3b98ae54dec9c881; });
/* eslint-disable @typescript-eslint/explicit-member-accessibility */ 
var $1oC0p = parcelRequire("1oC0p");
function $d181fb8f2b7ee6a7$export$cdf1dc76b55502e3(task, dependencies) {
    const [result, setResult] = (0, $1oC0p.useState)($d181fb8f2b7ee6a7$export$3b98ae54dec9c881.pending());
    (0, $1oC0p.useEffect)(()=>{
        let inEffect = true;
        task().then((value)=>{
            if (inEffect) setResult($d181fb8f2b7ee6a7$export$3b98ae54dec9c881.complete(value));
        }).catch((error)=>{
            if (inEffect) setResult($d181fb8f2b7ee6a7$export$3b98ae54dec9c881.error(error));
        });
        return ()=>{
            inEffect = false;
        };
    }, dependencies);
    return result;
}
class $d181fb8f2b7ee6a7$export$3b98ae54dec9c881 {
    static pending() {
        return new $d181fb8f2b7ee6a7$var$PendingAsyncResult();
    }
    static complete(value) {
        return new $d181fb8f2b7ee6a7$var$CompleteAsyncResult(value);
    }
    static error(error) {
        return new $d181fb8f2b7ee6a7$var$ErrorAsyncResult(error);
    }
    static isPending(result) {
        return result.isPending === true;
    }
    static isComplete(result) {
        return result.isPending === false && result.error === undefined;
    }
    static isError(result) {
        return result.isPending === false && result.error !== undefined;
    }
    constructor(isPending){
        this.isPending = isPending;
    }
}
class $d181fb8f2b7ee6a7$var$PendingAsyncResult extends $d181fb8f2b7ee6a7$export$3b98ae54dec9c881 {
    constructor(){
        super(true);
    }
    map() {
        return new $d181fb8f2b7ee6a7$var$PendingAsyncResult();
    }
    catch() {
        return this;
    }
    get value() {
        throw new Error('AsyncResult is pending...');
    }
}
class $d181fb8f2b7ee6a7$var$CompleteAsyncResult extends $d181fb8f2b7ee6a7$export$3b98ae54dec9c881 {
    constructor(value){
        super(false), this.value = value;
    }
    map(mapper) {
        return new $d181fb8f2b7ee6a7$var$CompleteAsyncResult(mapper(this.value));
    }
    catch() {
        return this;
    }
}
class $d181fb8f2b7ee6a7$var$ErrorAsyncResult extends $d181fb8f2b7ee6a7$export$3b98ae54dec9c881 {
    constructor(error){
        super(false), this.error = error;
    }
    map() {
        return new $d181fb8f2b7ee6a7$var$ErrorAsyncResult(this.error);
    }
    catch(catcher) {
        return new $d181fb8f2b7ee6a7$var$CompleteAsyncResult(catcher(this.error));
    }
    get value() {
        throw new $d181fb8f2b7ee6a7$export$36212ba89a98b1ce(this.error);
    }
}
class $d181fb8f2b7ee6a7$export$36212ba89a98b1ce extends Error {
    constructor(cause){
        super(cause.message), this.cause = cause;
        this.name = $d181fb8f2b7ee6a7$export$36212ba89a98b1ce.name;
    }
}

});

parcelRegister("glBJg", function(module, exports) {
$parcel$export(module.exports, "useAISAvailableProducts", function () { return $e7e07ff7e5369730$export$3691a5908e1c8031; });

var $5Ntyw = parcelRequire("5Ntyw");

var $chzua = parcelRequire("chzua");
function $e7e07ff7e5369730$export$5afbfe6edea8e998({ includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite }) {
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    return (0, $chzua.useAsync)(()=>stargateClient.availableProductsLegacy({
            includeInvalidSites: includeInvalidSites,
            includeInvalidBitbucketSite: includeInvalidBitbucketSite
        }), []);
}
function $e7e07ff7e5369730$export$3691a5908e1c8031({ includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite, removeNonAdminSites: removeNonAdminSites }) {
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    return (0, $chzua.useAsync)(()=>stargateClient.availableProducts({
            includeInvalidSites: includeInvalidSites,
            includeInvalidBitbucketSite: includeInvalidBitbucketSite,
            removeNonAdminSites: removeNonAdminSites
        }), []);
}

});


parcelRegister("eXdIx", function(module, exports) {
$parcel$export(module.exports, "InitializeAutoAtlAnalytics", function () { return $4975a543f793eb5e$export$81535e9b19050d04; });

var $1oC0p = parcelRequire("1oC0p");

var $3qZOw = parcelRequire("3qZOw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $gLm0b = parcelRequire("gLm0b");

var $iSeHD = parcelRequire("iSeHD");

var $aHkxS = parcelRequire("aHkxS");
const $4975a543f793eb5e$var$getBootstrapAnonymousId = ()=>typeof window !== 'undefined' && window.featureGateBootstrapValues?.identifiers?.analyticsAnonymousId || '';
const $4975a543f793eb5e$var$deepClone = (obj)=>{
    return JSON.parse(JSON.stringify(obj));
};
const $4975a543f793eb5e$var$InitializeAutoAtlAnalyticsImpl = ({ pageViewProperties: pageViewProperties = {}, createAnalyticsEvent: createAnalyticsEvent })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { analyticsOptOut: analyticsOptOut, isConsentLoaded: isConsentLoaded } = (0, $gLm0b.useOneTrustContext)();
    const ANALYTICS_WRITE_KEY = typeof window !== 'undefined' && window.ANALYTICS_SOURCE_ID || "kiv6wyh2nw";
    const isEnableOperationalEventWhenOptedOut = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10416DisableNonOperationalAnalyticsGateUip);
    (0, $1oC0p.useEffect)(()=>{
        if (isEnableOperationalEventWhenOptedOut) {
            if (!isConsentLoaded) return;
        } else {
            if (!analyticsClient || analyticsOptOut || !isConsentLoaded) return;
        }
        (0, $aHkxS.Initializer).initWithPageAnalytics(ANALYTICS_WRITE_KEY, $4975a543f793eb5e$var$deepClone(pageViewProperties), {}, Date.now(), analyticsClient?.getAnonymousId() ?? $4975a543f793eb5e$var$getBootstrapAnonymousId(), createAnalyticsEvent || null, analyticsOptOut ?? true);
    }, [
        analyticsClient,
        analyticsOptOut,
        isConsentLoaded,
        ANALYTICS_WRITE_KEY,
        createAnalyticsEvent,
        pageViewProperties,
        isEnableOperationalEventWhenOptedOut
    ]);
    return null;
};
const $4975a543f793eb5e$export$81535e9b19050d04 = (0, $3qZOw.default)()($4975a543f793eb5e$var$InitializeAutoAtlAnalyticsImpl);

});
parcelRegister("3qZOw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2803bfbf3c70ca99$export$2e2bcd8739ae039; });

var $2nnZC = parcelRequire("2nnZC");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $67PbI = parcelRequire("67PbI");
var $2803bfbf3c70ca99$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $67PbI.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $eY3N6.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $2nnZC.default)({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        // @ts-ignore
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(// @ts-ignore disneyName doesn't exist on type
        WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $2803bfbf3c70ca99$export$2e2bcd8739ae039 = $2803bfbf3c70ca99$var$withAnalyticsEvents;

});
parcelRegister("2nnZC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1bb0573c48b48972$export$2e2bcd8739ae039; });
function $1bb0573c48b48972$export$2e2bcd8739ae039() {
    return $1bb0573c48b48972$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1bb0573c48b48972$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("67PbI", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", function () { return $475b1a626adfcb09$export$9ebb5a84d17e5d18; });

var $9c1Qf = parcelRequire("9c1Qf");

var $6vNM7 = parcelRequire("6vNM7");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $475b1a626adfcb09$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $475b1a626adfcb09$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $475b1a626adfcb09$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $9c1Qf.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $475b1a626adfcb09$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $475b1a626adfcb09$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $eY3N6.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $1oC0p.useRef)({});
    var patchedProps = (0, $1oC0p.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, $6vNM7.default)(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $475b1a626adfcb09$var$_objectSpread($475b1a626adfcb09$var$_objectSpread({}, p), {}, (0, $9c1Qf.default)({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $475b1a626adfcb09$var$_objectSpread($475b1a626adfcb09$var$_objectSpread({}, p), {}, (0, $9c1Qf.default)({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});



parcelRegister("6yEAO", function(module, exports) {
$parcel$export(module.exports, "InitUFOV1", function () { return $192a6bd58e6c0922$export$8424fe85a0f0b645; });

var $1oC0p = parcelRequire("1oC0p");

var $kHXv1 = parcelRequire("kHXv1");
var $hJNxx = parcelRequire("hJNxx");
var $62N4C = parcelRequire("62N4C");

var $dSyvH = parcelRequire("dSyvH");

var $iSeHD = parcelRequire("iSeHD");
const $192a6bd58e6c0922$export$8424fe85a0f0b645 = /*#__PURE__*/ (0, $1oC0p.memo)(()=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    if (analyticsClient) (0, $hJNxx.payloadPublisher).setup({
        featureFlagClient: {
            getValue: ()=>true
        },
        product: 'marketing',
        gasv3: analyticsClient,
        app: {
            version: {
                web: '1.0.0'
            },
            framework: {
                name: 'react',
                version: $1oC0p.version
            }
        },
        tenantType: (0, $62N4C.TenantType).RealUser,
        resourceTimings: (0, $dSyvH.resourceTimingsConfig),
        performanceConfig: {
            histogram: {
                [(0, $kHXv1.ExperiencePerformanceTypes).PageLoad]: {
                    initial: {
                        fmp: '1000_2000_3000_4000',
                        tti: '1000_2000_3000_4000'
                    },
                    transition: {
                        fmp: '1000_2000',
                        tti: '1000_2000'
                    }
                },
                [(0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad]: {
                    initial: {
                        fmp: '1000_2000',
                        tti: '1000_2000'
                    },
                    transition: {
                        fmp: '1000_2000',
                        tti: '1000_2000'
                    }
                },
                [(0, $kHXv1.ExperiencePerformanceTypes).InlineResult]: {
                    result: '1000_2000',
                    response: '1000_2000'
                },
                [(0, $kHXv1.ExperiencePerformanceTypes).Custom]: {
                    duration: '1000_2000'
                }
            }
        }
    });
    return null;
});

});
parcelRegister("hJNxx", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", function () { return $ce9d11370cdb6d0b$export$edb879ae55bb9be3; });

var $a4ZV4 = parcelRequire("a4ZV4");

var $97Zwb = parcelRequire("97Zwb");

var $kTb36 = parcelRequire("kTb36");

var $bNrru = parcelRequire("bNrru");

var $gVCrN = parcelRequire("gVCrN");

var $kHXv1 = parcelRequire("kHXv1");
var $b7FPt = parcelRequire("b7FPt");

var $9sEG2 = parcelRequire("9sEG2");

var $JkpEu = parcelRequire("JkpEu");

var $agB35 = parcelRequire("agB35");

var $4iCHf = parcelRequire("4iCHf");

var $62N4C = parcelRequire("62N4C");

var $1n2G9 = parcelRequire("1n2G9");

var $kCvNA = parcelRequire("kCvNA");

var $3UR6q = parcelRequire("3UR6q");

var $f4mum = parcelRequire("f4mum");

var $f8k9V = parcelRequire("f8k9V");

var $2DbFy = parcelRequire("2DbFy");

var $cuznV = parcelRequire("cuznV");

var $e3Lzs = parcelRequire("e3Lzs");

var $fvgmK = parcelRequire("fvgmK");

var $blhx1 = parcelRequire("blhx1");

var $65Utu = parcelRequire("65Utu");

var $asz1K = parcelRequire("asz1K");

var $5YN6n = parcelRequire("5YN6n");

var $icbSh = parcelRequire("icbSh");

var $7aUpS = parcelRequire("7aUpS");

var $dPxPR = parcelRequire("dPxPR");
function $ce9d11370cdb6d0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce9d11370cdb6d0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce9d11370cdb6d0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gVCrN.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce9d11370cdb6d0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ce9d11370cdb6d0b$var$UNKNOWN_VALUE = 'unknown';
var $ce9d11370cdb6d0b$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $ce9d11370cdb6d0b$var$UNKNOWN_VALUE,
    id: $ce9d11370cdb6d0b$var$UNKNOWN_VALUE,
    uuid: $ce9d11370cdb6d0b$var$UNKNOWN_VALUE,
    state: {
        id: $ce9d11370cdb6d0b$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $kHXv1.ExperienceTypes).Experience,
    category: $ce9d11370cdb6d0b$var$UNKNOWN_VALUE,
    performanceType: (0, $kHXv1.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $agB35.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
var $ce9d11370cdb6d0b$var$Publisher = /*#__PURE__*/ function() {
    function Publisher() {
        var _getWindowObject, _this = this;
        (0, $kTb36.default)(this, Publisher);
        (0, $gVCrN.default)(this, "gasv3", null);
        (0, $gVCrN.default)(this, "product", '');
        (0, $gVCrN.default)(this, "region", $ce9d11370cdb6d0b$var$UNKNOWN_VALUE);
        (0, $gVCrN.default)(this, "hostname", ((_getWindowObject = (0, $dPxPR.getWindowObject)()) === null || _getWindowObject === void 0 || (_getWindowObject = _getWindowObject.location) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.hostname) || '');
        (0, $gVCrN.default)(this, "tenantType", (0, $62N4C.TenantType).RealUser);
        (0, $gVCrN.default)(this, "app", {
            version: {
                web: $ce9d11370cdb6d0b$var$UNKNOWN_VALUE
            }
        });
        (0, $gVCrN.default)(this, "performanceConfig", {});
        (0, $gVCrN.default)(this, "buffer", []);
        (0, $gVCrN.default)(this, "featureFlagClient", null);
        (0, $gVCrN.default)(this, "featureFlags", []);
        (0, $gVCrN.default)(this, "ssr", null);
        (0, $gVCrN.default)(this, "resourceTimings", null);
        (0, $gVCrN.default)(this, "bundleEvalTimings", null);
        (0, $gVCrN.default)(this, "route", (0, $icbSh.Route));
        (0, $gVCrN.default)(this, "plugins", null);
        (0, $gVCrN.default)(this, "allowlist", function() {
            return true;
        });
        (0, $gVCrN.default)(this, "getPluginsMetrics", function(data) {
            var result = {};
            if (_this.plugins) _this.plugins.forEach(function(plugin) {
                var pluginOutput = plugin($ce9d11370cdb6d0b$var$_objectSpread({}, data));
                if (pluginOutput === null || (0, $97Zwb.default)(pluginOutput) !== 'object') return;
                Object.entries(pluginOutput).forEach(function(_ref) {
                    var _ref2 = (0, $a4ZV4.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    result["".concat(_this.product, ":").concat(key)] = value;
                });
            });
            return result;
        });
    }
    return (0, $bNrru.default)(Publisher, [
        {
            key: "publish",
            value: function publish(data) {
                var _getPerformanceObject, _getPerformanceObject2;
                var payloadStart = ((_getPerformanceObject = (0, $dPxPR.getPerformanceObject)()) === null || _getPerformanceObject === void 0 ? void 0 : _getPerformanceObject.now()) || 0;
                var experienceKey = this.getExperienceKey(data);
                if (!this.allowlist(experienceKey, data)) {
                    (0, $JkpEu.ufowarn)("experience ".concat(experienceKey, " does not meet requirements of allowlist"));
                    return;
                }
                // it is used to setup default properties on the data to prevent errors
                var supportedData = $ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread({}, $ce9d11370cdb6d0b$var$DEFAULT_PAYLOAD_DATA), data);
                var payload = {
                    actionSubject: 'experience',
                    action: 'measured',
                    source: 'measured',
                    tags: [
                        'observability'
                    ],
                    attributes: {
                        properties: $ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread({
                            'event:source': {
                                name: 'ufo/web',
                                version: supportedData.schemaVersion
                            },
                            'event:schema': (0, $4iCHf.UFO_BUILD_VERSION) || $ce9d11370cdb6d0b$var$UNKNOWN_VALUE,
                            'event:product': this.product,
                            'event:region': this.region,
                            'event:hostname': this.hostname,
                            'event:route': this.route.getRoute()
                        }, (0, $cuznV.eventBrowserPlugin)()), (0, $e3Lzs.eventCpusPlugin)()), (0, $blhx1.eventMemoryPlugin)()), (0, $65Utu.eventNetworkPlugin)()), (0, $f8k9V.appFramework)(this.app)), (0, $2DbFy.appVersion)(this.app)), {}, {
                            'experience:name': supportedData.id,
                            // platform.fe.page-load|interaction|custom|page-segment.editor
                            'experience:key': experienceKey,
                            'experience:status': supportedData.state.id,
                            'experience:duration': supportedData.result.duration
                        }, supportedData.result.startTime !== null ? {
                            'experience:startTime': supportedData.result.startTime
                        } : null), supportedData.uuid ? {
                            'experience:spanId': supportedData.uuid
                        } : null), this.tenantType !== (0, $62N4C.TenantType).RealUser ? {
                            'event:tenantType': this.tenantType
                        } : null), this.mapMetadataToPayload(supportedData.metadata)), this.extractPageLoadData(supportedData)), (0, $3UR6q.pageVisibleState)(supportedData)), (0, $7aUpS.isInitialPageLoad)(supportedData) && (0, $5YN6n.ssrSuccess)(this.ssr)), (0, $7aUpS.isInitialPageLoad)(supportedData) && (0, $asz1K.ssrFeatureFlags)(this.ssr)), this.featureFlagClient && (0, $fvgmK.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)),
                        performance: this.getPerformanceMetrics(supportedData),
                        task: supportedData.id
                    }
                };
                var payloadEnd = ((_getPerformanceObject2 = (0, $dPxPR.getPerformanceObject)()) === null || _getPerformanceObject2 === void 0 ? void 0 : _getPerformanceObject2.now()) || 0;
                payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
                if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
                else this.buffer.push(payload);
                (0, $JkpEu.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
            }
        },
        {
            key: "setGlobalEventStream",
            value: function setGlobalEventStream() {
                if (!((0, $9sEG2.getGlobalEventStream)() instanceof (0, $1n2G9.UFOGlobalEventStream))) {
                    var eventStream = new (0, $1n2G9.UFOGlobalEventStream)();
                    eventStream.push({
                        type: (0, $agB35.UFOGlobalEventStreamEventType).SUBSCRIBE,
                        payload: {
                            experienceId: '__SUBSCRIBE_ALL__',
                            callback: this.publish.bind(this)
                        }
                    });
                    (0, $9sEG2.setGlobalEventStream)(eventStream);
                }
            }
        },
        {
            key: "setRoute",
            value: function setRoute(newRoute) {
                this.route.setRoute(newRoute);
            }
        },
        {
            key: "setup",
            value: function setup(config) {
                (0, $b7FPt.visibilityChangeObserver).start();
                (0, $f4mum.resourceTimingBuffer).start();
                if (!this.product) this.product = config.product || '';
                if (config.allowlist) this.allowlist = config.allowlist;
                if (config.tenantType) this.tenantType = config.tenantType;
                if (config.hostname) this.hostname = config.hostname;
                if (config.region) this.region = config.region;
                if (config.app) this.app = config.app;
                if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
                if (config.featureFlags) this.featureFlags = config.featureFlags;
                if (config.ssr) this.ssr = config.ssr;
                if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
                if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
                if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
                if (config.plugins) this.plugins = config.plugins;
                this.setGlobalEventStream();
                if (!this.gasv3) {
                    this.gasv3 = config.gasv3;
                    this.buffer.forEach(this.gasv3.sendOperationalEvent);
                }
            }
        },
        {
            key: "mapMetadataToPayload",
            value: function mapMetadataToPayload(metadata) {
                var payload = {};
                Object.entries(metadata).forEach(function(_ref3) {
                    var _ref4 = (0, $a4ZV4.default)(_ref3, 2), key = _ref4[0], value = _ref4[1];
                    if (value !== undefined) payload["custom:".concat(key)] = value;
                });
                return payload;
            }
        },
        {
            key: "extractPageLoadData",
            value: function extractPageLoadData(data) {
                if ('initial' in data) return {
                    'experience:pageLoadType': data.initial ? 'initial' : 'transition'
                };
                return {};
            }
        },
        {
            key: "getPrefix",
            value: function getPrefix(data) {
                if (data.platform !== null) return 'platform';
                return this.product;
            }
        },
        {
            key: "getExperienceKey",
            value: function getExperienceKey(data) {
                var keyParts = [
                    this.getPrefix(data),
                    'fe',
                    data.type
                ];
                if (data.platform) keyParts.push(data.platform.component);
                keyParts.push(data.id);
                return keyParts.join('.');
            }
        },
        {
            key: "getExperiencePerformanceKey",
            value: function getExperiencePerformanceKey(data) {
                var keyParts = [
                    this.getPrefix(data),
                    'fe',
                    data.performanceType
                ];
                if (data.platform) keyParts.push(data.platform.component);
                keyParts.push(data.id);
                return keyParts.join('.');
            }
        },
        {
            key: "getExperiencePerformanceType",
            value: function getExperiencePerformanceType(data) {
                return data.performanceType;
            }
        },
        {
            key: "getPerformanceMetrics",
            value: function getPerformanceMetrics(data) {
                return $ce9d11370cdb6d0b$var$_objectSpread($ce9d11370cdb6d0b$var$_objectSpread({
                    'event:key': this.getExperiencePerformanceKey(data),
                    'event:type': this.getExperiencePerformanceType(data)
                }, (0, $kCvNA.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig)), this.getPluginsMetrics(data));
            }
        }
    ]);
}();
var $ce9d11370cdb6d0b$export$edb879ae55bb9be3 = new $ce9d11370cdb6d0b$var$Publisher();

});
parcelRegister("a4ZV4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $756a4f0943782793$export$2e2bcd8739ae039; });

var $4IjLs = parcelRequire("4IjLs");

var $QbWoQ = parcelRequire("QbWoQ");

var $1jxl6 = parcelRequire("1jxl6");

var $PrhOX = parcelRequire("PrhOX");
function $756a4f0943782793$export$2e2bcd8739ae039(r, e) {
    return (0, $4IjLs.default)(r) || (0, $QbWoQ.default)(r, e) || (0, $1jxl6.default)(r, e) || (0, $PrhOX.default)();
}

});
parcelRegister("4IjLs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $36ea9a4a056b3cf8$export$2e2bcd8739ae039; });
function $36ea9a4a056b3cf8$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("QbWoQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $09ce1ea9f919a0a6$export$2e2bcd8739ae039; });
function $09ce1ea9f919a0a6$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("1jxl6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f516d4f144f79eb$export$2e2bcd8739ae039; });

var $2BCog = parcelRequire("2BCog");
function $0f516d4f144f79eb$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2BCog.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2BCog.default)(r, a) : void 0;
    }
}

});
parcelRegister("2BCog", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1e5cd0fe8593581a$export$2e2bcd8739ae039; });
function $1e5cd0fe8593581a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("PrhOX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $09a9ee0d6efeab47$export$2e2bcd8739ae039; });
function $09a9ee0d6efeab47$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("97Zwb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6a547cb5fbc9c03a$export$2e2bcd8739ae039; });
function $6a547cb5fbc9c03a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $6a547cb5fbc9c03a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6a547cb5fbc9c03a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kTb36", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f35183ca1a945399$export$2e2bcd8739ae039; });
function $f35183ca1a945399$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("bNrru", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $89698ececbd8fa67$export$2e2bcd8739ae039; });

var $lyyK4 = parcelRequire("lyyK4");
function $89698ececbd8fa67$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $lyyK4.default)(o.key), o);
    }
}
function $89698ececbd8fa67$export$2e2bcd8739ae039(e, r, t) {
    return r && $89698ececbd8fa67$var$_defineProperties(e.prototype, r), t && $89698ececbd8fa67$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("lyyK4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fb17b901ac199589$export$2e2bcd8739ae039; });

var $97Zwb = parcelRequire("97Zwb");

var $cClE5 = parcelRequire("cClE5");
function $fb17b901ac199589$export$2e2bcd8739ae039(t) {
    var i = (0, $cClE5.default)(t, "string");
    return "symbol" == (0, $97Zwb.default)(i) ? i : i + "";
}

});
parcelRegister("cClE5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92f9d2fcb09a4b50$export$2e2bcd8739ae039; });

var $97Zwb = parcelRequire("97Zwb");
function $92f9d2fcb09a4b50$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $97Zwb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $97Zwb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("gVCrN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c52fcb0a34fb1d44$export$2e2bcd8739ae039; });

var $lyyK4 = parcelRequire("lyyK4");
function $c52fcb0a34fb1d44$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $lyyK4.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("4iCHf", function(module, exports) {
$parcel$export(module.exports, "UFO_BUILD_VERSION", function () { return $3216dc2d07a6472b$export$93809551debf385f; });
// temp solution until a proper versioning
var $3216dc2d07a6472b$export$93809551debf385f = '0.1.7';

});

parcelRegister("62N4C", function(module, exports) {
$parcel$export(module.exports, "TenantType", function () { return $4668fef7e1c63b67$export$92a757ac1398962f; });

var $4668fef7e1c63b67$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("1n2G9", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", function () { return $0ffa0469199458b5$export$faf4c91b80fc830e; });

var $kTb36 = parcelRequire("kTb36");

var $bNrru = parcelRequire("bNrru");

var $gVCrN = parcelRequire("gVCrN");

var $JkpEu = parcelRequire("JkpEu");

var $agB35 = parcelRequire("agB35");
var $0ffa0469199458b5$export$faf4c91b80fc830e = /*#__PURE__*/ function() {
    function UFOGlobalEventStream() {
        (0, $kTb36.default)(this, UFOGlobalEventStream);
        (0, $gVCrN.default)(this, "__buffer_only__", false);
        (0, $gVCrN.default)(this, "subscribers", {});
    }
    return (0, $bNrru.default)(UFOGlobalEventStream, [
        {
            key: "push",
            value: function push(event) {
                (0, $JkpEu.ufolog)('EVENT STREAM push', event.type, event.payload);
                if (event.type === (0, $agB35.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
                if (event.type === (0, $agB35.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
                if (event.type === (0, $agB35.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
            }
        },
        {
            key: "publish",
            value: function publish(eventPayload) {
                var _this$subscribers$eve;
                if (this.subscribers[0, $agB35.SUBSCRIBE_ALL]) this.subscribers[0, $agB35.SUBSCRIBE_ALL].forEach(function(fn) {
                    fn(eventPayload);
                });
                (_this$subscribers$eve = this.subscribers[eventPayload.id]) === null || _this$subscribers$eve === void 0 || _this$subscribers$eve.forEach(function(fn) {
                    fn(eventPayload);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(experienceId, fn) {
                (0, $JkpEu.ufolog)('EVENT STREAM subscribe', experienceId);
                if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
                this.subscribers[experienceId].push(fn);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(experienceId, fn) {
                var index = this.subscribers[experienceId].findIndex(function(entry) {
                    return entry === fn;
                });
                if (index !== -1) this.subscribers[experienceId].splice(index, 1);
            }
        }
    ]);
}();

});

parcelRegister("kCvNA", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", function () { return $f03005dac3fb68db$export$738d24377baf6a5e; });

var $gVCrN = parcelRequire("gVCrN");

var $kHXv1 = parcelRequire("kHXv1");

var $agB35 = parcelRequire("agB35");

var $7aUpS = parcelRequire("7aUpS");

var $hjodT = parcelRequire("hjodT");

var $3Wvil = parcelRequire("3Wvil");

var $1YNQi = parcelRequire("1YNQi");

var $7JG0g = parcelRequire("7JG0g");
function $f03005dac3fb68db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f03005dac3fb68db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f03005dac3fb68db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gVCrN.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f03005dac3fb68db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f03005dac3fb68db$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
var $f03005dac3fb68db$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
var $f03005dac3fb68db$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
var $f03005dac3fb68db$var$getHistogram = function getHistogram(data, performanceConfig, isInitial) {
    var _data$performanceConf;
    var histogram = {};
    if ((_data$performanceConf = data.performanceConfig) !== null && _data$performanceConf !== void 0 && _data$performanceConf.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig !== null && performanceConfig !== void 0 && performanceConfig.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        var histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $kHXv1.ExperiencePerformanceTypes).PageLoad:
            case (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad:
                var histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? (0, $gVCrN.default)((0, $gVCrN.default)({}, $f03005dac3fb68db$var$LoadMetricKeys.ttiHistograms, histograms[histogramType].tti), $f03005dac3fb68db$var$LoadMetricKeys.fmpHistograms, histograms[histogramType].fmp) : {};
            case (0, $kHXv1.ExperiencePerformanceTypes).InlineResult:
                return histograms ? (0, $gVCrN.default)((0, $gVCrN.default)({}, $f03005dac3fb68db$var$InlineResultMetricKeys.resultHistograms, histograms.result), $f03005dac3fb68db$var$InlineResultMetricKeys.responseHistograms, histograms.response) : {};
            case (0, $kHXv1.ExperiencePerformanceTypes).Custom:
                return histograms ? (0, $gVCrN.default)({}, $f03005dac3fb68db$var$CustomMetricKeys.durationHistograms, histograms.duration) : {};
        }
    }
};
var $f03005dac3fb68db$export$bd4e6d81a822ece6 = function getLoadMetrics(data, ssr, performanceConfig) {
    var _data$metrics$marks$f;
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    var fmpMark = ((_data$metrics$marks$f = data.metrics.marks.find(function(mark) {
        return mark.name === (0, $agB35.FMP_MARK);
    })) === null || _data$metrics$marks$f === void 0 ? void 0 : _data$metrics$marks$f.time) || (0, $7aUpS.isInitialPageLoad)(data) && (ssr === null || ssr === void 0 ? void 0 : ssr.getDoneMark());
    var tti = data.metrics.endTime - data.metrics.startTime;
    var fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return $f03005dac3fb68db$var$_objectSpread((0, $gVCrN.default)((0, $gVCrN.default)({}, $f03005dac3fb68db$var$LoadMetricKeys.tti, Math.round(tti)), $f03005dac3fb68db$var$LoadMetricKeys.fmp, Math.round(fmp)), $f03005dac3fb68db$var$getHistogram(data, performanceConfig));
};
var $f03005dac3fb68db$export$47f0208fd62dffce = function getInlineResultMetrics(data, performanceConfig) {
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    var responseMark = data.metrics.marks.find(function(mark) {
        return mark.name === (0, $agB35.INLINE_RESPONSE_MARK);
    });
    var result = data.metrics.endTime - data.metrics.startTime;
    var response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return $f03005dac3fb68db$var$_objectSpread((0, $gVCrN.default)((0, $gVCrN.default)({}, $f03005dac3fb68db$var$InlineResultMetricKeys.result, Math.round(result)), $f03005dac3fb68db$var$InlineResultMetricKeys.response, Math.round(response)), $f03005dac3fb68db$var$getHistogram(data, performanceConfig));
};
var $f03005dac3fb68db$export$c25c1b3ff2ce92cf = function getCustomMetrics(data, performanceConfig) {
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    var duration = data.metrics.endTime - data.metrics.startTime;
    return $f03005dac3fb68db$var$_objectSpread((0, $gVCrN.default)({}, $f03005dac3fb68db$var$CustomMetricKeys.duration, Math.round(duration)), $f03005dac3fb68db$var$getHistogram(data, performanceConfig));
};
var $f03005dac3fb68db$var$getPerformanceMetrics = function getPerformanceMetrics(data, ssr, performanceConfig) {
    switch(data.performanceType){
        case (0, $kHXv1.ExperiencePerformanceTypes).PageLoad:
        case (0, $kHXv1.ExperiencePerformanceTypes).PageSegmentLoad:
            return $f03005dac3fb68db$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $kHXv1.ExperiencePerformanceTypes).InlineResult:
            return $f03005dac3fb68db$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $kHXv1.ExperiencePerformanceTypes).Custom:
            return $f03005dac3fb68db$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
var $f03005dac3fb68db$export$738d24377baf6a5e = function getPerformancePayload(data, ssr, bundleEvalConfig, resourceConfig, performanceConfig) {
    return $f03005dac3fb68db$var$_objectSpread($f03005dac3fb68db$var$_objectSpread($f03005dac3fb68db$var$_objectSpread($f03005dac3fb68db$var$_objectSpread($f03005dac3fb68db$var$_objectSpread({}, $f03005dac3fb68db$var$getPerformanceMetrics(data, ssr, performanceConfig)), (0, $7JG0g.resourceTimings)(data, resourceConfig)), (0, $1YNQi.bundleEvalTimings)(data, bundleEvalConfig)), (0, $3Wvil.appTimings)(data, ssr)), (0, $7aUpS.isInitialPageLoad)(data) ? (0, $hjodT.navigationMetrics)() : null);
};

});
parcelRegister("7aUpS", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", function () { return $53953aadfbd8efc8$export$7167d96e9881d500; });

var $kHXv1 = parcelRequire("kHXv1");
var $53953aadfbd8efc8$export$7167d96e9881d500 = function isInitialPageLoad(data) {
    return data.performanceType === (0, $kHXv1.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("hjodT", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", function () { return $c9a7003556675e93$export$b88d990436be0f8a; });
var $c9a7003556675e93$export$b88d990436be0f8a = function navigationMetrics() {
    var entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("3Wvil", function(module, exports) {
$parcel$export(module.exports, "appTimings", function () { return $2def1069ea26163d$export$e952f50a4f2d02da; });

var $gVCrN = parcelRequire("gVCrN");

var $kHXv1 = parcelRequire("kHXv1");

var $7aUpS = parcelRequire("7aUpS");

var $4boJX = parcelRequire("4boJX");

var $3RR3W = parcelRequire("3RR3W");
function $2def1069ea26163d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2def1069ea26163d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2def1069ea26163d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gVCrN.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2def1069ea26163d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2def1069ea26163d$export$e952f50a4f2d02da = function appTimings(data, ssrConfig) {
    var explicitTimings = data.performanceType === (0, $kHXv1.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    var timings = (0, $4boJX.customTimings)(data);
    var ssr = (0, $7aUpS.isInitialPageLoad)(data) ? (0, $3RR3W.ssrTimings)(ssrConfig) : null;
    var timingsApp = (explicitTimings || timings || ssr) && $2def1069ea26163d$var$_objectSpread($2def1069ea26163d$var$_objectSpread($2def1069ea26163d$var$_objectSpread({}, explicitTimings), timings), ssr);
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("4boJX", function(module, exports) {
$parcel$export(module.exports, "customTimings", function () { return $30bb616bb1208673$export$6126f85083a72c6e; });
var $30bb616bb1208673$var$retrieveTimings = function retrieveTimings(data) {
    var configTimings = data.timings || [];
    var timings = configTimings.reduce(function(entries, timing) {
        var startMark = data.metrics.marks.find(function(mark) {
            return mark.name === timing.startMark;
        });
        if (timing.startMark && !startMark) return entries;
        var endMark = data.metrics.marks.find(function(mark) {
            return mark.name === timing.endMark;
        });
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        var startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        var duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries["".concat(timing.key)] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
var $30bb616bb1208673$export$6126f85083a72c6e = function customTimings(data) {
    if (!data.timings) return null;
    var timings = $30bb616bb1208673$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("3RR3W", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", function () { return $2d0f7b745e52a30d$export$130f411261a599c5; });

var $97Zwb = parcelRequire("97Zwb");

var $ccB1b = parcelRequire("ccB1b");
var $2d0f7b745e52a30d$var$filterEntry = function filterEntry(entry) {
    return !(!entry || (0, $97Zwb.default)(entry) !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
var $2d0f7b745e52a30d$var$mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var $2d0f7b745e52a30d$var$SSR_PREFIX = 'ssr';
var $2d0f7b745e52a30d$var$mapKey = function mapKey(key) {
    if (key === 'total') return $2d0f7b745e52a30d$var$SSR_PREFIX;
    return "".concat($2d0f7b745e52a30d$var$SSR_PREFIX).concat((0, $ccB1b.NESTED_METRIC_SEPARATOR)).concat(key);
};
var $2d0f7b745e52a30d$export$130f411261a599c5 = function ssrTimings(ssr) {
    if (!(ssr !== null && ssr !== void 0 && ssr.getTimings)) return null;
    var timings = ssr.getTimings();
    if (!timings) return null;
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if ($2d0f7b745e52a30d$var$filterEntry(entry[1])) acc[$2d0f7b745e52a30d$var$mapKey(entry[0])] = $2d0f7b745e52a30d$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
parcelRegister("ccB1b", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", function () { return $8e235208a3bd1099$export$b98e411ae80c806f; });
var $8e235208a3bd1099$export$b98e411ae80c806f = '/';

});



parcelRegister("1YNQi", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", function () { return $17120eb253c92546$export$1a2bb347935fc536; });

var $a4ZV4 = parcelRequire("a4ZV4");

var $dPxPR = parcelRequire("dPxPR");
var $17120eb253c92546$export$1a2bb347935fc536 = function bundleEvalTimings(data, _bundleEvalTimings) {
    var performance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $dPxPR.getPerformanceObject)() || undefined;
    if (!_bundleEvalTimings) return null;
    var started = {};
    var timings = {};
    performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach(function(mark) {
        var result = _bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        var type = result.type, name = result.name;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (_bundleEvalTimings !== null && _bundleEvalTimings !== void 0 && _bundleEvalTimings.additionalTimings && data.result.startTime !== null) {
        var result = _bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(function(_ref) {
            var _ref2 = (0, $a4ZV4.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("dPxPR", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", function () { return $a11a48cd85dec7d1$export$9aa44f85591248d9; });
$parcel$export(module.exports, "getPerformanceObject", function () { return $a11a48cd85dec7d1$export$8cd0c777b0eb66a0; });
$parcel$export(module.exports, "getPerformanceObserverObject", function () { return $a11a48cd85dec7d1$export$74560fd4e61fd440; });
var $a11a48cd85dec7d1$export$9aa44f85591248d9 = function getWindowObject() {
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
var $a11a48cd85dec7d1$export$8cd0c777b0eb66a0 = function getPerformanceObject() {
    var _ref = $a11a48cd85dec7d1$export$9aa44f85591248d9() || {}, performance = _ref.performance;
    return performance;
};
var $a11a48cd85dec7d1$export$74560fd4e61fd440 = function getPerformanceObserverObject() {
    var _ref2 = $a11a48cd85dec7d1$export$9aa44f85591248d9() || {}, PerformanceObserver = _ref2.PerformanceObserver;
    return PerformanceObserver;
};

});


parcelRegister("7JG0g", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", function () { return $5a1d51584e898bae$export$81a7d52441a06b50; });

var $gVCrN = parcelRequire("gVCrN");

var $dPxPR = parcelRequire("dPxPR");

var $f4mum = parcelRequire("f4mum");
function $5a1d51584e898bae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a1d51584e898bae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a1d51584e898bae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gVCrN.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a1d51584e898bae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5a1d51584e898bae$var$cacheableTypes = [
    'script',
    'link'
];
var $5a1d51584e898bae$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
var $5a1d51584e898bae$var$CACHE_NETWORK = 'network';
var $5a1d51584e898bae$var$CACHE_MEMORY = 'memory';
var $5a1d51584e898bae$var$CACHE_DISK = 'disk';
var $5a1d51584e898bae$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$5a1d51584e898bae$var$cacheableTypes.includes(type)) return $5a1d51584e898bae$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $5a1d51584e898bae$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $5a1d51584e898bae$var$CACHE_DISK;
    if (size === undefined) return null;
    return $5a1d51584e898bae$var$CACHE_NETWORK;
};
var $5a1d51584e898bae$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !$5a1d51584e898bae$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $dPxPR.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
var $5a1d51584e898bae$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
var $5a1d51584e898bae$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(_url, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
var $5a1d51584e898bae$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $5a1d51584e898bae$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $5a1d51584e898bae$var$evaluateAccessToResourceTimings;
    var name = item.name, duration = item.duration, transferSize = item.transferSize, initiatorType = item.initiatorType, responseStart = item.responseStart;
    var ttfb = Math.round(responseStart - eventStart);
    if (!$5a1d51584e898bae$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($5a1d51584e898bae$var$cacheableTypes.includes(initiatorType)) {
        var transferType = $5a1d51584e898bae$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return $5a1d51584e898bae$var$_objectSpread({
            ttfb: ttfb
        }, $5a1d51584e898bae$var$getSizeObject(transferSize));
        if (transferType !== $5a1d51584e898bae$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return $5a1d51584e898bae$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType
        }, $5a1d51584e898bae$var$getSizeObject(transferSize));
    }
    return $5a1d51584e898bae$var$_objectSpread({
        ttfb: ttfb
    }, $5a1d51584e898bae$var$getSizeObject(transferSize));
};
var $5a1d51584e898bae$export$81a7d52441a06b50 = function resourceTimings(data, _resourceTimings) {
    var performance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $dPxPR.getPerformanceObject)() || undefined;
    if (data.result.startTime === null || !(_resourceTimings !== null && _resourceTimings !== void 0 && _resourceTimings.sanitiseEndpoints)) return null;
    var resources = (0, $f4mum.getResourceTimings)(data.result.startTime, performance);
    if (!(resources !== null && resources !== void 0 && resources.length)) return null;
    var resourceTiming = {};
    var xhrFilter = _resourceTimings.xhrFilter;
    var reportedInitiatorTypes = $5a1d51584e898bae$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, initiatorType = item.initiatorType;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $5a1d51584e898bae$var$resourceTypes.includes(initiatorType) ? _resourceTimings.sanitiseEndpoints(name) : _resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = $5a1d51584e898bae$var$_objectSpread({
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType
        }, $5a1d51584e898bae$var$getNetworkData(item, data.result.startTime, _resourceTimings.hasTimingHeaders));
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("f4mum", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", function () { return $af88ac83edec5bf6$export$bea963256235a63e; });
$parcel$export(module.exports, "getResourceTimings", function () { return $af88ac83edec5bf6$export$9eebb59359c2e9e5; });

var $68SCQ = parcelRequire("68SCQ");

var $JkpEu = parcelRequire("JkpEu");

var $dPxPR = parcelRequire("dPxPR");
var $af88ac83edec5bf6$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: function transformResource(entry) {
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        };
    },
    start: function start() {
        var _performance$getEntri;
        var performance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $dPxPR.getPerformanceObject)();
        var PerformanceObserver1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $dPxPR.getPerformanceObserverObject)();
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($af88ac83edec5bf6$export$bea963256235a63e.observer) {
            (0, $JkpEu.ufologger).warn('Observer is already running');
            return;
        }
        var resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $af88ac83edec5bf6$export$bea963256235a63e.timings = resources.map(function(resource) {
            return $af88ac83edec5bf6$export$bea963256235a63e.transformResource(resource);
        });
        $af88ac83edec5bf6$export$bea963256235a63e.observer = new PerformanceObserver1($af88ac83edec5bf6$export$bea963256235a63e.addTimings);
        $af88ac83edec5bf6$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: function stop() {
        if ($af88ac83edec5bf6$export$bea963256235a63e.observer) {
            $af88ac83edec5bf6$export$bea963256235a63e.observer.disconnect();
            $af88ac83edec5bf6$export$bea963256235a63e.observer = null;
        }
        $af88ac83edec5bf6$export$bea963256235a63e.timings = [];
    },
    addTimings: function addTimings(list) {
        var _resourceTimingBuffer;
        var entries = list.getEntries().map(function(entry) {
            return $af88ac83edec5bf6$export$bea963256235a63e.transformResource(entry);
        });
        var overflow = $af88ac83edec5bf6$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $af88ac83edec5bf6$export$bea963256235a63e.maxSize) {
            var fieldsToRemove = overflow - $af88ac83edec5bf6$export$bea963256235a63e.maxSize;
            $af88ac83edec5bf6$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        (_resourceTimingBuffer = $af88ac83edec5bf6$export$bea963256235a63e.timings).push.apply(_resourceTimingBuffer, (0, $68SCQ.default)(entries));
    }
};
var $af88ac83edec5bf6$export$9eebb59359c2e9e5 = function getResourceTimings(startTime) {
    var performance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $dPxPR.getPerformanceObject)();
    if (!PerformanceObserver || !$af88ac83edec5bf6$export$bea963256235a63e.observer) {
        var resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter(function(timing) {
            return timing.startTime >= startTime;
        });
        return null;
    }
    return $af88ac83edec5bf6$export$bea963256235a63e.timings.filter(function(timing) {
        return timing.startTime >= startTime;
    });
};

});
parcelRegister("68SCQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0127730c17a5a072$export$2e2bcd8739ae039; });

var $hF2pG = parcelRequire("hF2pG");

var $eS2At = parcelRequire("eS2At");

var $1jxl6 = parcelRequire("1jxl6");

var $6Xkt2 = parcelRequire("6Xkt2");
function $0127730c17a5a072$export$2e2bcd8739ae039(r) {
    return (0, $hF2pG.default)(r) || (0, $eS2At.default)(r) || (0, $1jxl6.default)(r) || (0, $6Xkt2.default)();
}

});
parcelRegister("hF2pG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cdb82338855dab02$export$2e2bcd8739ae039; });

var $2BCog = parcelRequire("2BCog");
function $cdb82338855dab02$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $2BCog.default)(r);
}

});

parcelRegister("eS2At", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad381d9e97b6d424$export$2e2bcd8739ae039; });
function $ad381d9e97b6d424$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6Xkt2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5108212e46c1ff6a$export$2e2bcd8739ae039; });
function $5108212e46c1ff6a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});





parcelRegister("3UR6q", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", function () { return $2d9fcb257474e1d2$export$723b4c298aca63af; });

var $agB35 = parcelRequire("agB35");
var $2d9fcb257474e1d2$export$723b4c298aca63af = function pageVisibleState(data) {
    var _data$pageVisibleStat;
    return {
        'experience:pageVisible': (_data$pageVisibleStat = data.pageVisibleState) !== null && _data$pageVisibleStat !== void 0 ? _data$pageVisibleStat : document.hidden ? (0, $agB35.PageVisibleState).HIDDEN : (0, $agB35.PageVisibleState).VISIBLE
    };
};

});

parcelRegister("f8k9V", function(module, exports) {
$parcel$export(module.exports, "appFramework", function () { return $b0473d911be3bd18$export$e34e4529b979f74c; });
var $b0473d911be3bd18$export$e34e4529b979f74c = function appFramework(config) {
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("2DbFy", function(module, exports) {
$parcel$export(module.exports, "appVersion", function () { return $1ea8468edc8a2b99$export$82ae485178b37419; });
var $1ea8468edc8a2b99$export$82ae485178b37419 = function appVersion(config) {
    var pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("cuznV", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", function () { return $9183bc1281cf91a1$export$f435c2789ca334a7; });

var $8oqW7 = parcelRequire("8oqW7");

var $dWJ7u = parcelRequire("dWJ7u");

var $dPxPR = parcelRequire("dPxPR");
var $9183bc1281cf91a1$export$f435c2789ca334a7 = (0, $dWJ7u.default)(function() {
    var _getWindowObject;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8oqW7))).getParser) return null;
    var browser = (0, (/*@__PURE__*/$parcel$interopDefault($8oqW7))).getParser(((_getWindowObject = (0, $dPxPR.getWindowObject)()) === null || _getWindowObject === void 0 || (_getWindowObject = _getWindowObject.navigator) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.userAgent) || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("e3Lzs", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", function () { return $a3c63f11b2937b1d$export$db7649b8854107ad; });

var $dWJ7u = parcelRequire("dWJ7u");
var $a3c63f11b2937b1d$export$db7649b8854107ad = (0, $dWJ7u.default)(function() {
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("fvgmK", function(module, exports) {
$parcel$export(module.exports, "featureFlags", function () { return $b4967236dbeef52d$export$e62953d023125748; });

var $68SCQ = parcelRequire("68SCQ");
var $b4967236dbeef52d$export$e62953d023125748 = function featureFlags(featureFlagClient, _featureFlags, data) {
    var allFeatureFlags = [].concat((0, $68SCQ.default)(_featureFlags), (0, $68SCQ.default)(data.featureFlags || []));
    if (allFeatureFlags.length === 0) return null;
    var initialMemo = [];
    allFeatureFlags.reduce(function(memo, featureFlagKey) {
        var ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    var mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("blhx1", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", function () { return $841f4148ff0d9af5$export$81efaf8414879a1a; });

var $dWJ7u = parcelRequire("dWJ7u");
var $841f4148ff0d9af5$export$81efaf8414879a1a = (0, $dWJ7u.default)(function() {
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("65Utu", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", function () { return $46ff0464e09d2594$export$ce1cf816dce1da56; });
var $46ff0464e09d2594$export$ce1cf816dce1da56 = function eventNetworkPlugin() {
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("asz1K", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", function () { return $79d7b095a221053d$export$fdbea518c19dfa8; });
var $79d7b095a221053d$export$fdbea518c19dfa8 = function ssrFeatureFlags(ssr) {
    if (!(ssr !== null && ssr !== void 0 && ssr.getFeatureFlags)) return null;
    try {
        var featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("5YN6n", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", function () { return $45a8a4fa4365a77b$export$a3dc8251cf55b2e0; });
var $45a8a4fa4365a77b$export$a3dc8251cf55b2e0 = function ssrSuccess(ssr) {
    if (ssr !== null && ssr !== void 0 && ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("icbSh", function(module, exports) {
$parcel$export(module.exports, "Route", function () { return $d3f28f00ce95f167$export$e7b0ac011bb776c6; });
var $d3f28f00ce95f167$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute: function setRoute(newRoute) {
        this.route = newRoute;
    },
    getRoute: function getRoute() {
        return this.route;
    }
};

});



parcelRegister("gMME0", function(module, exports) {
$parcel$export(module.exports, "CrossFlowProvider", function () { return $5e5863577cfefa91$export$d900e4062895cd7c; });

var $7VQPk = parcelRequire("7VQPk");

var $gFflM = parcelRequire("gFflM");

var $hsKFk = parcelRequire("hsKFk");

var $iSeHD = parcelRequire("iSeHD");
const $5e5863577cfefa91$export$d900e4062895cd7c = ({ children: children, cloudId: cloudId, locale: locale = 'en' })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hsKFk.default), {
        cloudId: cloudId,
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
        analyticsClient: analyticsClient,
        locale: locale,
        plugins: [
            (0, $gFflM.getUsersPlugin)
        ],
        children: children
    });
};

});
parcelRegister("gFflM", function(module, exports) {
$parcel$export(module.exports, "getUsersPlugin", function () { return $6f86386baa8ecabe$export$7c44908d2777db01; });

var $g6n0j = parcelRequire("g6n0j");
var $32R0X = parcelRequire("32R0X");
const $6f86386baa8ecabe$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $32R0X.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $6f86386baa8ecabe$export$7c44908d2777db01 = (0, $g6n0j.createGetUsersPlugin)($6f86386baa8ecabe$var$getUsers);

});
parcelRegister("g6n0j", function(module, exports) {
$parcel$export(module.exports, "createGetUsersPlugin", function () { return $bb8f0cfb8c370683$export$8feb7eae83cf8cd5; });
$parcel$export(module.exports, "UserIdTypes", function () { return (parcelRequire("32R0X")).UserIdTypes; });

var $32R0X = parcelRequire("32R0X");
var $bb8f0cfb8c370683$export$76378b0f825c024c = function createGetContainersPlugin(fetch) {
    return [
        (0, $32R0X.PluginTypes).GetContainers,
        fetch
    ];
};
var $bb8f0cfb8c370683$export$8feb7eae83cf8cd5 = function createGetUsersPlugin(fetch) {
    return [
        (0, $32R0X.PluginTypes).GetUsers,
        fetch
    ];
};
var $bb8f0cfb8c370683$export$21d120847be2aff4 = function createGetSuggestedSiteNamesPlugin(fetch) {
    return [
        (0, $32R0X.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
var $bb8f0cfb8c370683$export$d7c1699c6a2ca18a = function createGetAvailableSitesPlugin(fetch) {
    return [
        (0, $32R0X.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("32R0X", function(module, exports) {
$parcel$export(module.exports, "PluginTypes", function () { return $237aae92d442ce02$export$a235a73f7b906dce; });
$parcel$export(module.exports, "UserIdTypes", function () { return $237aae92d442ce02$export$e391bab95adb8396; });
// Data Plugin definition and utility types
var $237aae92d442ce02$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
var $237aae92d442ce02$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
var $237aae92d442ce02$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
var $237aae92d442ce02$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("hsKFk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb694003336a3cc4$export$2e2bcd8739ae039; });

var $5Nr87 = parcelRequire("5Nr87");

var $1oC0p = parcelRequire("1oC0p");

var $8fn1U = parcelRequire("8fn1U");

var $cb694003336a3cc4$export$a9d7aac09de99b5 = function WacProvider(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8fn1U.CrossFlowProvider), (0, $5Nr87.default)({}, props, {
        originProduct: "wac"
    }));
};
var $cb694003336a3cc4$export$2e2bcd8739ae039 = $cb694003336a3cc4$export$a9d7aac09de99b5;

});
parcelRegister("5Nr87", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $438692cdd11dd166$export$2e2bcd8739ae039; });
function $438692cdd11dd166$export$2e2bcd8739ae039() {
    return $438692cdd11dd166$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $438692cdd11dd166$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8fn1U", function(module, exports) {
$parcel$export(module.exports, "CrossFlowProvider", function () { return $601196af44fddd1a$export$d900e4062895cd7c; });

var $5Nr87 = parcelRequire("5Nr87");

var $aAQkT = parcelRequire("aAQkT");

var $1TanD = parcelRequire("1TanD");

var $2nSjF = parcelRequire("2nSjF");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("6xsdo");
var $2Hvh6 = parcelRequire("2Hvh6");
var $aGE0q = parcelRequire("aGE0q");

var $bpQFV = parcelRequire("bpQFV");

var $3X2sJ = parcelRequire("3X2sJ");

var $eMPU8 = parcelRequire("eMPU8");

var $3wE9j = parcelRequire("3wE9j");

var $20yd8 = parcelRequire("20yd8");

var $irPBs = parcelRequire("irPBs");

var $g2X0M = parcelRequire("g2X0M");

var $87t4W = parcelRequire("87t4W");
var $cZxXo = parcelRequire("cZxXo");
var $601196af44fddd1a$var$_excluded = [
    "children",
    "analyticsClient",
    "originProduct",
    "redirectToWac",
    "env",
    "plugins",
    "globalExperimentalOptions",
    "onError"
];
function $601196af44fddd1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $601196af44fddd1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $601196af44fddd1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aAQkT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $601196af44fddd1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

var $601196af44fddd1a$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(function() {
    return (parcelRequire("feVpc"));
});
var $601196af44fddd1a$export$79d79d8dd8574306 = function createCrossFlowProvider(IntegrationView) {
    return function(props) {
        var _requestOptions$zInde;
        var children = props.children, analyticsClient = props.analyticsClient, originProduct = props.originProduct, redirectToWac = props.redirectToWac, env = props.env, _props$plugins = props.plugins, plugins = _props$plugins === void 0 ? [] : _props$plugins, globalExperimentalOptions = props.globalExperimentalOptions, onError = props.onError, baseProviderProps = (0, $2nSjF.default)(props, $601196af44fddd1a$var$_excluded);
        var onCloseResolver = (0, $1oC0p.useRef)();
        var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $1TanD.default)(_useState, 2), firstHandshakeReceived = _useState2[0], setFirstHandshakeReceived = _useState2[1];
        var fireEvent = (0, $1oC0p.useMemo)(function() {
            return (0, $3X2sJ.analyticsWrapper)(analyticsClient);
        }, [
            analyticsClient
        ]);
        var _useState3 = (0, $1oC0p.useState)(), _useState4 = (0, $1TanD.default)(_useState3, 2), requestOptions = _useState4[0], setRequestOptions = _useState4[1];
        var onAnalyticsEvent = (0, $1oC0p.useCallback)(function(payload) {
            var gasV3Event = (0, $eMPU8.transformEvent)(payload);
            if (gasV3Event) {
                var enrichedEvent = (0, $g2X0M.enrichWithRequestOptions)((0, $irPBs.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        var onHandShake = (0, $1oC0p.useCallback)(function(appName) {
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $cZxXo.OPERATIONAL_EVENT_TYPE),
                        action: (0, $87t4W.uiInitialized),
                        actionSubject: (0, $87t4W.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: (0, $87t4W.source)
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        var onOpen = (0, $1oC0p.useCallback)(function(options) {
            /**
       * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
       * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
       */ setFirstHandshakeReceived(false);
            var analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $g2X0M.enrichWithRequestOptions)({
                    eventType: (0, $cZxXo.OPERATIONAL_EVENT_TYPE),
                    action: (0, $87t4W.openInvoked),
                    actionSubject: (0, $87t4W.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: (0, $87t4W.source)
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $aGE0q.Journeys).GET_STARTED && redirectToWac) {
                (0, $3wE9j.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                var _completionStatus = {};
                return Promise.resolve(_completionStatus);
            }
            var updatedExperimentalOptions = $601196af44fddd1a$var$_objectSpread($601196af44fddd1a$var$_objectSpread({}, globalExperimentalOptions || {}), options.experimentalOptions || {});
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise(function(resolve) {
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        var onClose = (0, $1oC0p.useCallback)(function(completionStatus) {
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        var _getGlobalTheme = (0, $bpQFV.default)(), colorMode = _getGlobalTheme.colorMode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2Hvh6.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $20yd8.ErrorBoundary), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(IntegrationView, (0, $5Nr87.default)({}, baseProviderProps, requestOptions, {
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            zIndex: (_requestOptions$zInde = requestOptions.zIndex) !== null && _requestOptions$zInde !== void 0 ? _requestOptions$zInde : 1000
        })))));
    };
};
var $601196af44fddd1a$export$d900e4062895cd7c = $601196af44fddd1a$export$79d79d8dd8574306($601196af44fddd1a$var$IntegrationView);

});
parcelRegister("aAQkT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b65dcff0738932c$export$2e2bcd8739ae039; });

var $bzerr = parcelRequire("bzerr");
function $7b65dcff0738932c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bzerr.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("bzerr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $86be2a65bcd8d5cb$export$2e2bcd8739ae039; });

var $7Fi1m = parcelRequire("7Fi1m");

var $ckXnZ = parcelRequire("ckXnZ");
function $86be2a65bcd8d5cb$export$2e2bcd8739ae039(t) {
    var i = (0, $ckXnZ.default)(t, "string");
    return "symbol" == (0, $7Fi1m.default)(i) ? i : i + "";
}

});
parcelRegister("7Fi1m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $594a575616608638$export$2e2bcd8739ae039; });
function $594a575616608638$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $594a575616608638$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $594a575616608638$export$2e2bcd8739ae039(o);
}

});

parcelRegister("ckXnZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8fb56b1d997d097d$export$2e2bcd8739ae039; });

var $7Fi1m = parcelRequire("7Fi1m");
function $8fb56b1d997d097d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7Fi1m.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7Fi1m.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("1TanD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1602fac96cbb7419$export$2e2bcd8739ae039; });

var $3ZGrM = parcelRequire("3ZGrM");

var $dOPPc = parcelRequire("dOPPc");

var $9HpmM = parcelRequire("9HpmM");

var $jH8Xd = parcelRequire("jH8Xd");
function $1602fac96cbb7419$export$2e2bcd8739ae039(r, e) {
    return (0, $3ZGrM.default)(r) || (0, $dOPPc.default)(r, e) || (0, $9HpmM.default)(r, e) || (0, $jH8Xd.default)();
}

});
parcelRegister("3ZGrM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e87feae764717f9$export$2e2bcd8739ae039; });
function $2e87feae764717f9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("dOPPc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a0f8252ef17fb7af$export$2e2bcd8739ae039; });
function $a0f8252ef17fb7af$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9HpmM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70fbce76eda81550$export$2e2bcd8739ae039; });

var $cBHgF = parcelRequire("cBHgF");
function $70fbce76eda81550$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cBHgF.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cBHgF.default)(r, a) : void 0;
    }
}

});
parcelRegister("cBHgF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92da80cda9512df7$export$2e2bcd8739ae039; });
function $92da80cda9512df7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("jH8Xd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e568fa90da0ee944$export$2e2bcd8739ae039; });
function $e568fa90da0ee944$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2nSjF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1bc7dcd82f8caebc$export$2e2bcd8739ae039; });

var $3q2xO = parcelRequire("3q2xO");
function $1bc7dcd82f8caebc$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3q2xO.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("3q2xO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $27d5c61508209437$export$2e2bcd8739ae039; });
function $27d5c61508209437$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("6xsdo", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", function () { return (parcelRequire("2Hvh6")).BaseCrossFlowApiProvider; });
$parcel$export(module.exports, "useCrossFlow", function () { return (parcelRequire("2Hvh6")).useCrossFlow; });
$parcel$export(module.exports, "withCrossFlow", function () { return (parcelRequire("2Hvh6")).withCrossFlow; });
$parcel$export(module.exports, "Journeys", function () { return (parcelRequire("aGE0q")).Journeys; });
$parcel$export(module.exports, "Reasons", function () { return (parcelRequire("aGE0q")).Reasons; });

var $2Hvh6 = parcelRequire("2Hvh6");

var $aGE0q = parcelRequire("aGE0q");

});
parcelRegister("2Hvh6", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", function () { return $1f77db75ac745ad6$export$c0ddec072762f62a; });
$parcel$export(module.exports, "useCrossFlow", function () { return $1f77db75ac745ad6$export$6e7a10fe635a0dfc; });
$parcel$export(module.exports, "withCrossFlow", function () { return $1f77db75ac745ad6$export$655b6c19a0daddb8; });

var $gC2Yk = parcelRequire("gC2Yk");

var $1oC0p = parcelRequire("1oC0p");

var $io5jO = parcelRequire("io5jO");

var $Zr7GQ = parcelRequire("Zr7GQ");

var $aGE0q = parcelRequire("aGE0q");
var $1f77db75ac745ad6$var$LATEST_VERSION = (0, $Zr7GQ.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ var $1f77db75ac745ad6$var$CrossFlowContext = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isEnabled: false,
        reason: (0, $aGE0q.Reasons).NO_PROVIDER
    };
});
var $1f77db75ac745ad6$export$59ce2d27e6cd8c9 = function createNegotiateApi(onOpen) {
    return function(version) {
        switch(version){
            case 0, $Zr7GQ.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $io5jO.createAPIv0)(onOpen),
                    apiV1: (0, $Zr7GQ.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $aGE0q.Reasons).NO_API_SUPPORT
                };
        }
    };
};
var $1f77db75ac745ad6$export$c0ddec072762f62a = function BaseCrossFlowApiProvider(_ref) {
    var onOpen = _ref.onOpen, children = _ref.children;
    var negotiateApi = (0, $1oC0p.useMemo)(function() {
        return $1f77db75ac745ad6$export$59ce2d27e6cd8c9(onOpen);
    }, [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($1f77db75ac745ad6$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
var $1f77db75ac745ad6$export$6e7a10fe635a0dfc = function useCrossFlow() {
    var negotiateApi = (0, $1oC0p.useContext)($1f77db75ac745ad6$var$CrossFlowContext);
    return (0, $1oC0p.useMemo)(function() {
        return negotiateApi($1f77db75ac745ad6$var$LATEST_VERSION);
    }, [
        negotiateApi
    ]);
};
function $1f77db75ac745ad6$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    var ComponentWithCrossFlow = function ComponentWithCrossFlow(props) {
        var crossFlow = $1f77db75ac745ad6$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $gC2Yk.default)({}, props, {
            crossFlow: crossFlow
        }));
    };
    ComponentWithCrossFlow.displayName = "withCrossFlow(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
    return ComponentWithCrossFlow;
}

});
parcelRegister("gC2Yk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c18280202893b0bd$export$2e2bcd8739ae039; });
function $c18280202893b0bd$export$2e2bcd8739ae039() {
    return $c18280202893b0bd$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c18280202893b0bd$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("io5jO", function(module, exports) {
$parcel$export(module.exports, "createAPIv0", function () { return $d62e98040913e5ba$export$9ff7368ac93fcf2d; });
/**
 * Version 0 of public Cross Flow API
 */ var $d62e98040913e5ba$export$a4ad2735b021c132 = 0;
var $d62e98040913e5ba$export$9ff7368ac93fcf2d = function createAPIv0(onOpen) {
    return {
        open: function open(options) {
            return onOpen(options);
        }
    };
};

});

parcelRegister("Zr7GQ", function(module, exports) {
$parcel$export(module.exports, "VERSION", function () { return $0b8abcb074d170ac$export$a4ad2735b021c132; });
$parcel$export(module.exports, "createAPIv1", function () { return $0b8abcb074d170ac$export$8fd5792fc468459f; });
/**
 * Version 1 of public Cross Flow API
 */ var $0b8abcb074d170ac$export$a4ad2735b021c132 = 1;
var $0b8abcb074d170ac$export$8fd5792fc468459f = function createAPIv1(onOpen) {
    return {
        open: function open(options) {
            return onOpen(options);
        }
    };
};

});

parcelRegister("aGE0q", function(module, exports) {
$parcel$export(module.exports, "Journeys", function () { return $7c7cdbf6e7f9d911$export$3411873bfd520bb6; });
$parcel$export(module.exports, "Reasons", function () { return $7c7cdbf6e7f9d911$export$da2d4f2f250d6f84; });
var $7c7cdbf6e7f9d911$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
var $7c7cdbf6e7f9d911$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
}; // equivalent of `typeof Reason.NO_API_SUPPORT | typeof Reason.NO_PROVIDER | ...`

});



parcelRegister("bpQFV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $84fae3bb6277e042$export$2e2bcd8739ae039; });

var $aAQkT = parcelRequire("aAQkT");

var $dMZH0 = parcelRequire("dMZH0");

var $cxkhn = parcelRequire("cxkhn");

var $jVh6V = parcelRequire("jVh6V");
function $84fae3bb6277e042$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $84fae3bb6277e042$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $84fae3bb6277e042$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aAQkT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $84fae3bb6277e042$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $84fae3bb6277e042$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $cxkhn.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $84fae3bb6277e042$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $dMZH0.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $dMZH0.THEME_DATA_ATTRIBUTE)) || '';
    return $84fae3bb6277e042$var$_objectSpread($84fae3bb6277e042$var$_objectSpread({}, (0, $jVh6V.themeStringToObject)(theme)), $84fae3bb6277e042$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $84fae3bb6277e042$export$2e2bcd8739ae039 = $84fae3bb6277e042$var$getGlobalTheme;

});
parcelRegister("dMZH0", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $a09f9cf1946b20d8$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $a09f9cf1946b20d8$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $a09f9cf1946b20d8$export$9d7b58831ae93caa; });
var $a09f9cf1946b20d8$export$4ef52930e33717cd = 'data-theme';
var $a09f9cf1946b20d8$export$a00eac3f8684bcd0 = 'data-color-mode';
var $a09f9cf1946b20d8$export$2112803007239c61 = 'data-contrast-mode';
var $a09f9cf1946b20d8$export$352e418ed5b6193a = 'data-custom-theme';
var $a09f9cf1946b20d8$export$6f0c6fb8c80fcc92 = 'ds';
var $a09f9cf1946b20d8$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $a09f9cf1946b20d8$export$dddac1532e822863 = "--".concat($a09f9cf1946b20d8$export$6f0c6fb8c80fcc92, "-token-not-found");
var $a09f9cf1946b20d8$export$9d7b58831ae93caa = "--".concat($a09f9cf1946b20d8$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("cxkhn", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $92084c26faa090b1$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $92084c26faa090b1$export$7d43e72a58e3283f; });

var $39c3M = parcelRequire("39c3M");
var $92084c26faa090b1$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $92084c26faa090b1$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $92084c26faa090b1$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $92084c26faa090b1$var$themeOverrideIds = [];
var $92084c26faa090b1$export$92ba366331403db2 = [].concat($92084c26faa090b1$export$7d43e72a58e3283f, $92084c26faa090b1$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $92084c26faa090b1$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
var $92084c26faa090b1$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: function typography() {
        if ((0, $39c3M.fg)('platform-default-typography-modernized')) return 'typography-modernized';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $92084c26faa090b1$export$2e2bcd8739ae039 = $92084c26faa090b1$var$themeConfig;

});

parcelRegister("jVh6V", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $e8109d0364ed27d3$export$f19b488f7c0547ee; });

var $7Fi1m = parcelRequire("7Fi1m");

var $1TanD = parcelRequire("1TanD");

var $cxkhn = parcelRequire("cxkhn");
var $e8109d0364ed27d3$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $e8109d0364ed27d3$var$customThemeOptions = 'UNSAFE_themeOptions';
var $e8109d0364ed27d3$var$isThemeKind = function isThemeKind(themeKind) {
    return $e8109d0364ed27d3$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $e8109d0364ed27d3$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $cxkhn.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $e8109d0364ed27d3$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $e8109d0364ed27d3$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $1TanD.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $e8109d0364ed27d3$var$isColorMode(id)) themeObject[kind] = id;
        if ($e8109d0364ed27d3$var$isThemeKind(kind) && $e8109d0364ed27d3$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $e8109d0364ed27d3$var$customThemeOptions) try {
            themeObject[$e8109d0364ed27d3$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $e8109d0364ed27d3$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $1TanD.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $e8109d0364ed27d3$var$isColorMode(id) || // custom theme state
        kind === $e8109d0364ed27d3$var$customThemeOptions && (0, $7Fi1m.default)(id) === 'object' || // other theme states
        $e8109d0364ed27d3$var$isThemeKind(kind) && typeof id === 'string' && $e8109d0364ed27d3$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $7Fi1m.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("3X2sJ", function(module, exports) {
$parcel$export(module.exports, "analyticsWrapper", function () { return $2e08cac572d47721$export$91b4dd3bfc301325; });

var $cZxXo = parcelRequire("cZxXo");
var $2e08cac572d47721$export$91b4dd3bfc301325 = function analyticsWrapper(analyticsClient) {
    return function(event) {
        return Promise.resolve(analyticsClient).then(function(client) {
            switch(event.eventType){
                case 0, $cZxXo.UI_EVENT_TYPE:
                    client.sendUIEvent(event);
                    break;
                case 0, $cZxXo.TRACK_EVENT_TYPE:
                    client.sendTrackEvent(event);
                    break;
                case 0, $cZxXo.OPERATIONAL_EVENT_TYPE:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $cZxXo.SCREEN_EVENT_TYPE:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});
parcelRegister("cZxXo", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return $975585adb47d5cb4$export$a1562d08625f5d7e; });
$parcel$export(module.exports, "TRACK_EVENT_TYPE", function () { return $975585adb47d5cb4$export$947dac6c72b26f81; });
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", function () { return $975585adb47d5cb4$export$f1d537d508d2945a; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return $975585adb47d5cb4$export$12346a674644c156; });
$parcel$export(module.exports, "DEFAULT_SOURCE", function () { return $975585adb47d5cb4$export$b055de0e665cb20c; });
// same types defined in analytics-web-client but avoid creating dependency with that
var $975585adb47d5cb4$export$a1562d08625f5d7e = 'ui';
var $975585adb47d5cb4$export$947dac6c72b26f81 = 'track';
var $975585adb47d5cb4$export$f1d537d508d2945a = 'screen';
var $975585adb47d5cb4$export$12346a674644c156 = 'operational';
var $975585adb47d5cb4$export$b055de0e665cb20c = 'unknown';

});


parcelRegister("eMPU8", function(module, exports) {
$parcel$export(module.exports, "transformEvent", function () { return $ac3dcf8363cbca79$export$3f40e8c44448be30; });

var $aAQkT = parcelRequire("aAQkT");

var $2nSjF = parcelRequire("2nSjF");

var $cZxXo = parcelRequire("cZxXo");
var $ac3dcf8363cbca79$var$_excluded = [
    "attributes"
];
function $ac3dcf8363cbca79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac3dcf8363cbca79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac3dcf8363cbca79$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aAQkT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac3dcf8363cbca79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ac3dcf8363cbca79$var$GROWTH_TAG = 'growth';
var $ac3dcf8363cbca79$var$extractFromEventContext = function extractFromEventContext(propertyNames, context) {
    return context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            var navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
};
var $ac3dcf8363cbca79$var$getSources = function getSources(context) {
    return $ac3dcf8363cbca79$var$extractFromEventContext([
        'source'
    ], context);
};
var $ac3dcf8363cbca79$var$getExtraAttributes = function getExtraAttributes(context) {
    return context.reduce(function(ans, _ref) {
        var attributes = _ref.attributes, contextProps = (0, $2nSjF.default)(_ref, $ac3dcf8363cbca79$var$_excluded);
        var newAttributes = $ac3dcf8363cbca79$var$_objectSpread($ac3dcf8363cbca79$var$_objectSpread({}, ans), contextProps);
        return attributes ? $ac3dcf8363cbca79$var$_objectSpread($ac3dcf8363cbca79$var$_objectSpread({}, newAttributes), attributes) : newAttributes;
    }, {});
};
var $ac3dcf8363cbca79$var$getPackageInfo = function getPackageInfo(context) {
    return context.map(function(contextItem) {
        return {
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var $ac3dcf8363cbca79$var$last = function last(values) {
    return values[values.length - 1];
};
var $ac3dcf8363cbca79$export$3f40e8c44448be30 = function transformEvent(event) {
    var context = event.context, payload = event.payload;
    if (!payload) return null;
    var sources = $ac3dcf8363cbca79$var$getSources(context);
    var source = $ac3dcf8363cbca79$var$last(sources) || (0, $cZxXo.DEFAULT_SOURCE);
    var extraAttributes = $ac3dcf8363cbca79$var$getExtraAttributes(context);
    var _ref2 = $ac3dcf8363cbca79$var$last($ac3dcf8363cbca79$var$getPackageInfo(context)) || {}, _ref2$packageName = _ref2.packageName, packageName = _ref2$packageName === void 0 ? undefined : _ref2$packageName, _ref2$packageVersion = _ref2.packageVersion, packageVersion = _ref2$packageVersion === void 0 ? undefined : _ref2$packageVersion;
    var _payload$eventType = payload.eventType, eventType = _payload$eventType === void 0 ? (0, $cZxXo.UI_EVENT_TYPE) : _payload$eventType, action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId, payloadAttributes = payload.attributes, name = payload.name;
    var attributes = $ac3dcf8363cbca79$var$_objectSpread($ac3dcf8363cbca79$var$_objectSpread({
        packageName: packageName,
        packageVersion: packageVersion
    }, extraAttributes), payloadAttributes);
    var tags = payload.tags || [];
    tags.push($ac3dcf8363cbca79$var$GROWTH_TAG);
    switch(eventType){
        case 0, $cZxXo.UI_EVENT_TYPE:
        case 0, $cZxXo.OPERATIONAL_EVENT_TYPE:
        case 0, $cZxXo.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $cZxXo.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("3wE9j", function(module, exports) {
$parcel$export(module.exports, "setProductSignUpLocation", function () { return $291381108c1db653$export$2827e2473cb9a346; });

var $aAQkT = parcelRequire("aAQkT");
parcelRequire("hpKoh");
var $1qYP0 = parcelRequire("1qYP0");

var $bJyeK = parcelRequire("bJyeK");

var $8YXfX = parcelRequire("8YXfX");
var $291381108c1db653$var$utmCampaignMap = {
    'atlassian-switcher': (0, $8YXfX.UtmCampaign)['atlassian-switcher']
};
var $291381108c1db653$var$isBundledProduct = function isBundledProduct(productKey) {
    return [
        (0, $1qYP0.Targets).JIRA_SOFTWARE,
        (0, $1qYP0.Targets).JIRA_SERVICE_DESK,
        (0, $1qYP0.Targets).JIRA_CORE,
        (0, $1qYP0.Targets).CONFLUENCE
    ].includes(productKey);
};
var $291381108c1db653$var$getBundleSignUpParams = function getBundleSignUpParams(productKey) {
    var bundles = (0, $aAQkT.default)((0, $aAQkT.default)((0, $aAQkT.default)((0, $aAQkT.default)({}, (0, $1qYP0.Targets).JIRA_SOFTWARE, 'jira-software'), (0, $1qYP0.Targets).JIRA_SERVICE_DESK, 'jira-service-desk'), (0, $1qYP0.Targets).JIRA_CORE, 'jira-core'), (0, $1qYP0.Targets).CONFLUENCE, 'confluence');
    // Bundles default to free
    return "bundle=".concat(bundles[productKey], "&edition=free");
};
var $291381108c1db653$var$isProductWithCustomSignUpPath = function isProductWithCustomSignUpPath(productKey) {
    return [
        (0, $1qYP0.Targets).OPSGENIE
    ].includes(productKey);
};
var $291381108c1db653$var$getProductCustomSignUpPath = function getProductCustomSignUpPath(productKey) {
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    var links = (0, $aAQkT.default)({}, (0, $1qYP0.Targets).OPSGENIE, (0, $bJyeK.OPSGENIE_SIGNUP_PATH));
    return links[productKey];
};
var $291381108c1db653$var$isSourceComponentWithUtmParams = function isSourceComponentWithUtmParams(sourceComponent) {
    return Boolean($291381108c1db653$var$utmCampaignMap[sourceComponent]);
};
var $291381108c1db653$var$getUtmParams = function getUtmParams(sourceComponent, sourceContext) {
    var utmParams = '';
    if (sourceComponent && $291381108c1db653$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + "utm_campaign=".concat($291381108c1db653$var$utmCampaignMap[sourceComponent], "&utm_medium=in_product_ad");
        if (sourceContext) utmParams = utmParams + "&utm_source=".concat(sourceContext);
    }
    return utmParams;
};
var $291381108c1db653$export$39eab502fc96327d = function getProductSignUpLink(productKey, env, sourceComponent, sourceContext) {
    var wacUrl = env === 'staging' ? (0, $bJyeK.WAC_STAGING_URL) : (0, $bJyeK.WAC_PROD_URL);
    var utmParams = $291381108c1db653$var$getUtmParams(sourceComponent, sourceContext);
    var queryParams = '';
    var bundleParams = '';
    var path = (0, $bJyeK.WAC_SIGNUP_PATH);
    if ($291381108c1db653$var$isBundledProduct(productKey)) {
        path = (0, $bJyeK.WAC_BUNDLE_SIGNUP_PATH);
        bundleParams = $291381108c1db653$var$getBundleSignUpParams(productKey);
    } else if ($291381108c1db653$var$isProductWithCustomSignUpPath(productKey)) path = $291381108c1db653$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + "?".concat(bundleParams);
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
var $291381108c1db653$export$2827e2473cb9a346 = function setProductSignUpLocation(productKey) {
    var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'production';
    var sourceComponent = arguments.length > 2 ? arguments[2] : undefined;
    var sourceContext = arguments.length > 3 ? arguments[3] : undefined;
    var url = $291381108c1db653$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
parcelRegister("hpKoh", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", function () { return (parcelRequire("9KjMH")).CrossFlowExtensions; });
$parcel$export(module.exports, "Targets", function () { return (parcelRequire("1qYP0")).Targets; });

var $9KjMH = parcelRequire("9KjMH");

var $1qYP0 = parcelRequire("1qYP0");

});
parcelRegister("9KjMH", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", function () { return $7187c1b32b7c6a01$export$a5e53d1dcbd6eb61; });

var $2JO4R = parcelRequire("2JO4R");

var $8F5PH = parcelRequire("8F5PH");
var $7187c1b32b7c6a01$export$a5e53d1dcbd6eb61 = /*#__PURE__*/ (0, $2JO4R.default)(function CrossFlowExtensions(options) {
    (0, $8F5PH.default)(this, CrossFlowExtensions);
    Object.assign(this, options);
    Object.freeze(this);
});

});
parcelRegister("2JO4R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1fe6a112a6bd1614$export$2e2bcd8739ae039; });

var $h8qHV = parcelRequire("h8qHV");
function $1fe6a112a6bd1614$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $h8qHV.default)(o.key), o);
    }
}
function $1fe6a112a6bd1614$export$2e2bcd8739ae039(e, r, t) {
    return r && $1fe6a112a6bd1614$var$_defineProperties(e.prototype, r), t && $1fe6a112a6bd1614$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("h8qHV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c797e694a3a65629$export$2e2bcd8739ae039; });

var $kKyke = parcelRequire("kKyke");

var $fLYIJ = parcelRequire("fLYIJ");
function $c797e694a3a65629$export$2e2bcd8739ae039(t) {
    var i = (0, $fLYIJ.default)(t, "string");
    return "symbol" == (0, $kKyke.default)(i) ? i : i + "";
}

});
parcelRegister("kKyke", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f1b2bacc2fe498be$export$2e2bcd8739ae039; });
function $f1b2bacc2fe498be$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f1b2bacc2fe498be$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1b2bacc2fe498be$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fLYIJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b7ba589a7880cac7$export$2e2bcd8739ae039; });

var $kKyke = parcelRequire("kKyke");
function $b7ba589a7880cac7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $kKyke.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $kKyke.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("8F5PH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $64e6ad5fd4f18873$export$2e2bcd8739ae039; });
function $64e6ad5fd4f18873$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});


parcelRegister("1qYP0", function(module, exports) {
$parcel$export(module.exports, "Targets", function () { return $10b76617d8efae73$export$59a8eb9cff113544; });
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ var $10b76617d8efae73$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
   * @private
   * @deprecated Use ATLAS instead
   */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
   * @private
   * @deprecated
   */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom'
}; /**
 * The list of supported targets in Cross-flow.
 *
 * While TypeScript does match this to the list of Targets provided in this library,
 * in essence any string value can be used to accomodate this type through the use of
 * type casting.
 */ 

});


parcelRegister("bJyeK", function(module, exports) {
$parcel$export(module.exports, "WAC_STAGING_URL", function () { return $88ae746768ed3167$export$c37558e5c67d2b01; });
$parcel$export(module.exports, "WAC_PROD_URL", function () { return $88ae746768ed3167$export$f199baf8dfc7621e; });
$parcel$export(module.exports, "OPSGENIE_SIGNUP_PATH", function () { return $88ae746768ed3167$export$fb1e43fdafe12e9b; });
$parcel$export(module.exports, "WAC_BUNDLE_SIGNUP_PATH", function () { return $88ae746768ed3167$export$e6c04a1dd86d1c14; });
$parcel$export(module.exports, "WAC_SIGNUP_PATH", function () { return $88ae746768ed3167$export$2a45a00073911255; });
var $88ae746768ed3167$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
var $88ae746768ed3167$export$f199baf8dfc7621e = 'https://www.atlassian.com';
var $88ae746768ed3167$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
var $88ae746768ed3167$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
var $88ae746768ed3167$export$2a45a00073911255 = '/software';

});

parcelRegister("8YXfX", function(module, exports) {
$parcel$export(module.exports, "UtmCampaign", function () { return $68a1e4690d01e058$export$fc604aa353a97e10; });
var $68a1e4690d01e058$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});

});


parcelRegister("20yd8", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", function () { return $17661e65c703bf7d$export$e926676385687eaf; });

var $7keQv = parcelRequire("7keQv");

var $l55ww = parcelRequire("l55ww");

var $jXchi = parcelRequire("jXchi");

var $04SX6 = parcelRequire("04SX6");

var $ldjYN = parcelRequire("ldjYN");

var $aAQkT = parcelRequire("aAQkT");

var $1oC0p = parcelRequire("1oC0p");

var $87t4W = parcelRequire("87t4W");
var $cZxXo = parcelRequire("cZxXo");
function $17661e65c703bf7d$var$_callSuper(t, o, e) {
    return o = (0, $04SX6.default)(o), (0, $jXchi.default)(t, $17661e65c703bf7d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $04SX6.default)(t).constructor) : o.apply(t, e));
}
function $17661e65c703bf7d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($17661e65c703bf7d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $17661e65c703bf7d$var$name = "@atlassiansox/cross-flow-support";
var $17661e65c703bf7d$var$version = "5.1.3";
var $17661e65c703bf7d$var$payload = {
    eventType: (0, $cZxXo.OPERATIONAL_EVENT_TYPE),
    action: (0, $87t4W.errorBoundaryAction),
    actionSubject: (0, $87t4W.errorBoundaryActionSubject)
};
var $17661e65c703bf7d$var$context = [
    {
        source: (0, $87t4W.source)
    },
    {
        packageName: $17661e65c703bf7d$var$name,
        packageVersion: $17661e65c703bf7d$var$version
    }
];
var $17661e65c703bf7d$export$e926676385687eaf = /*#__PURE__*/ function(_Component) {
    function ErrorBoundary() {
        var _this;
        (0, $7keQv.default)(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $17661e65c703bf7d$var$_callSuper(this, ErrorBoundary, [].concat(args));
        (0, $aAQkT.default)(_this, "state", {
            hasError: false
        });
        return _this;
    }
    (0, $ldjYN.default)(ErrorBoundary, _Component);
    return (0, $l55ww.default)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                this.props.onAnalyticsEvent({
                    payload: $17661e65c703bf7d$var$payload,
                    context: $17661e65c703bf7d$var$context
                });
                if (this.props.onError) this.props.onError(error);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return null;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
}((0, $1oC0p.Component));

});
parcelRegister("7keQv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5555eac41c5566ff$export$2e2bcd8739ae039; });
function $5555eac41c5566ff$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("l55ww", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f58e597a868d467b$export$2e2bcd8739ae039; });

var $bzerr = parcelRequire("bzerr");
function $f58e597a868d467b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $bzerr.default)(o.key), o);
    }
}
function $f58e597a868d467b$export$2e2bcd8739ae039(e, r, t) {
    return r && $f58e597a868d467b$var$_defineProperties(e.prototype, r), t && $f58e597a868d467b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("jXchi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e86d0d227332c5a8$export$2e2bcd8739ae039; });

var $7Fi1m = parcelRequire("7Fi1m");

var $29KRL = parcelRequire("29KRL");
function $e86d0d227332c5a8$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7Fi1m.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $29KRL.default)(t);
}

});
parcelRegister("29KRL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1920c6a9a9ae3238$export$2e2bcd8739ae039; });
function $1920c6a9a9ae3238$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("04SX6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00eb0035e283b518$export$2e2bcd8739ae039; });
function $00eb0035e283b518$export$2e2bcd8739ae039(t) {
    return $00eb0035e283b518$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $00eb0035e283b518$export$2e2bcd8739ae039(t);
}

});

parcelRegister("ldjYN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f71a4f63ef339889$export$2e2bcd8739ae039; });

var $6JFHt = parcelRequire("6JFHt");
function $f71a4f63ef339889$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6JFHt.default)(t, e);
}

});
parcelRegister("6JFHt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4e774adbd00f3b46$export$2e2bcd8739ae039; });
function $4e774adbd00f3b46$export$2e2bcd8739ae039(t, e) {
    return $4e774adbd00f3b46$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4e774adbd00f3b46$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("87t4W", function(module, exports) {
$parcel$export(module.exports, "source", function () { return $5e9588934d59c05e$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "errorBoundaryAction", function () { return $5e9588934d59c05e$export$9d8252a268f4fa72; });
$parcel$export(module.exports, "errorBoundaryActionSubject", function () { return $5e9588934d59c05e$export$1045419caf49b395; });
$parcel$export(module.exports, "crossFlowActionSubject", function () { return $5e9588934d59c05e$export$d54c183f56e39aa5; });
$parcel$export(module.exports, "uiInitialized", function () { return $5e9588934d59c05e$export$e5c2c058fa8068a6; });
$parcel$export(module.exports, "openInvoked", function () { return $5e9588934d59c05e$export$e67cdcb8867a3bd0; });

var $cZxXo = parcelRequire("cZxXo");
var $5e9588934d59c05e$export$b4d5da5f34fb77ad = 'crossFlowProvider';
var $5e9588934d59c05e$export$9d8252a268f4fa72 = 'errorCaught';
var $5e9588934d59c05e$export$1045419caf49b395 = 'errorBoundary';
var $5e9588934d59c05e$export$d54c183f56e39aa5 = 'crossFlowSupport';
var $5e9588934d59c05e$export$e5c2c058fa8068a6 = 'uiInitialized';
var $5e9588934d59c05e$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("irPBs", function(module, exports) {
$parcel$export(module.exports, "enrichWithPackageDetails", function () { return $d6e2c6e71365e6b6$export$59518efab336a8b5; });

var $aAQkT = parcelRequire("aAQkT");
function $d6e2c6e71365e6b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6e2c6e71365e6b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6e2c6e71365e6b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aAQkT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6e2c6e71365e6b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d6e2c6e71365e6b6$var$version = "5.1.3";
var $d6e2c6e71365e6b6$export$84f9cf7ef89d4c26 = {
    version: $d6e2c6e71365e6b6$var$version
};
var $d6e2c6e71365e6b6$export$59518efab336a8b5 = function enrichWithPackageDetails(event) {
    var attributes = $d6e2c6e71365e6b6$var$_objectSpread($d6e2c6e71365e6b6$var$_objectSpread({}, event.attributes || {}), {}, {
        crossFlowSupport: $d6e2c6e71365e6b6$export$84f9cf7ef89d4c26
    });
    return $d6e2c6e71365e6b6$var$_objectSpread($d6e2c6e71365e6b6$var$_objectSpread({}, event), {}, {
        attributes: attributes
    });
};

});

parcelRegister("g2X0M", function(module, exports) {
$parcel$export(module.exports, "enrichWithRequestOptions", function () { return $baea9bb248a5c9b9$export$a5a156dc5df42f0; });

var $aAQkT = parcelRequire("aAQkT");
function $baea9bb248a5c9b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $baea9bb248a5c9b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $baea9bb248a5c9b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aAQkT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $baea9bb248a5c9b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $baea9bb248a5c9b9$export$a5a156dc5df42f0 = function enrichWithRequestOptions(event, requestOptions) {
    if (!requestOptions) return event;
    var attributes = $baea9bb248a5c9b9$var$_objectSpread($baea9bb248a5c9b9$var$_objectSpread($baea9bb248a5c9b9$var$_objectSpread({}, requestOptions.extraAnalyticsAttributes || {}), event.attributes || {}), {}, {
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    });
    return $baea9bb248a5c9b9$var$_objectSpread($baea9bb248a5c9b9$var$_objectSpread({}, event), {}, {
        attributes: attributes
    });
};

});

parcelRegister("feVpc", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("ch50F"),
    $eao4m("96JU0"),
    $eao4m("7Q4ht"),
    $eao4m("fAzFn"),
    $eao4m("1UKEw")
]).then(()=>parcelRequire('iHXcN'));

});




parcelRegister("kZYAp", function(module, exports) {
$parcel$export(module.exports, "trackRouteUFOV1PageLoad", function () { return $d11395a544aadbe6$export$46d8b4a9481faaae; });

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");

var $bOGMu = parcelRequire("bOGMu");

var $gPKCY = parcelRequire("gPKCY");
const $d11395a544aadbe6$var$getProductKeyBundle = ()=>{
    let productKey = undefined;
    let bundle = undefined;
    try {
        const queryParams = new URLSearchParams(window.location.search);
        productKey = queryParams.get('product');
        bundle = queryParams.get('bundle');
    } catch (error) {
        console.log(error);
    }
    return {
        productKey: productKey,
        bundle: bundle
    };
};
const $d11395a544aadbe6$export$46d8b4a9481faaae = (path)=>{
    const { productKey: productKey, bundle: bundle } = $d11395a544aadbe6$var$getProductKeyBundle();
    // Experimental: Route specific UFO V1 page load events
    switch(path){
        case 'try/cloud/signup':
            try {
                const baseData = (0, $bOGMu.SignupUFOExperience).BuildCustomBaseData();
                const interactionId = (0, $1BTY2.getInteractionId)().current;
                if (interactionId) (0, $a48Mt.addCustomData)(interactionId, [], baseData);
                // @ts-ignore
                (0, $gPKCY.ufoEventTryCloudSignupPageLoad).start({
                    bundle: bundle,
                    productKey: productKey
                });
            } catch (error) {
                console.error(error);
            }
            break;
        case 'software/jira':
            try {
                (0, $gPKCY.ufoEventPaidSignupJSWLandingPageLoad).start({
                    productKey: // @ts-ignore
                    productKey,
                    bundle: bundle
                });
            } catch (error) {
                console.error(error);
            }
            break;
        case 'software/confluence':
            try {
                (0, $gPKCY.ufoEventPaidSignupConfluenceLandingPageLoad).start({
                    productKey: // @ts-ignore
                    productKey,
                    bundle: bundle
                });
            } catch (error) {
                console.error(error);
            }
            break;
        case 'software/jira/service-management':
            try {
                (0, $gPKCY.ufoEventPaidSignupJSMLandingPageLoad).start({
                    productKey: // @ts-ignore
                    productKey,
                    bundle: bundle
                });
            } catch (error) {
                console.error(error);
            }
            break;
        default:
            break;
    }
};

});

parcelRegister("4u4go", function(module, exports) {
$parcel$export(module.exports, "WAC_PERSONA_PARAM", function () { return $e2def1d2f7939175$export$d4de1d0a1ad871af; });
$parcel$export(module.exports, "parseWacPersonaParam", function () { return $e2def1d2f7939175$export$ef78bf1adf1da634; });
$parcel$export(module.exports, "getShareableUrl", function () { return $e2def1d2f7939175$export$d151b340b7c4c508; });

var $3o1l4 = parcelRequire("3o1l4");
const $e2def1d2f7939175$export$d4de1d0a1ad871af = 'wac_persona';
const $e2def1d2f7939175$export$d878ff729811a8bb = new Set([
    (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS,
    (0, $3o1l4.UserSegmentTypes).COLLECTION_OPTIONS
]);
const $e2def1d2f7939175$export$9e1110387a4d07f3 = (values)=>{
    const parts = [];
    Object.values((0, $3o1l4.UserSegmentTypes)).forEach((segmentType)=>{
        const raw = values[segmentType];
        if (raw === undefined || raw === null || raw === '') return;
        if (Array.isArray(raw)) {
            if (raw.length === 0) return;
            parts.push(`${segmentType}:${raw.join('|')}`);
        } else parts.push(`${segmentType}:${raw}`);
    });
    return parts.join(',');
};
const $e2def1d2f7939175$export$ef78bf1adf1da634 = (paramValue)=>{
    const result = {};
    if (!paramValue) return result;
    paramValue.split(',').forEach((part)=>{
        const colonIdx = part.indexOf(':');
        if (colonIdx === -1) return;
        const segmentType = part.slice(0, colonIdx);
        const value = part.slice(colonIdx + 1);
        if (!Object.values((0, $3o1l4.UserSegmentTypes)).includes(segmentType)) return;
        if ($e2def1d2f7939175$export$d878ff729811a8bb.has(segmentType)) result[segmentType] = value ? value.split('|') : [];
        else result[segmentType] = value;
    });
    return result;
};
const $e2def1d2f7939175$export$d151b340b7c4c508 = (values, compositionSlug)=>{
    const personaValue = $e2def1d2f7939175$export$9e1110387a4d07f3(values);
    if (!personaValue) return '';
    let pagePath;
    if (window.location.pathname.includes('/uniform-preview')) {
        const previewPath = new URLSearchParams(window.location.search).get('path');
        if (previewPath) pagePath = previewPath;
        else {
            const rawPath = compositionSlug ?? window.location.pathname;
            pagePath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
        }
    } else {
        const rawPath = compositionSlug ?? window.location.pathname;
        pagePath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
    }
    return `${window.location.origin}${pagePath}?${$e2def1d2f7939175$export$d4de1d0a1ad871af}=${encodeURIComponent(personaValue)}`;
};

});
parcelRegister("3o1l4", function(module, exports) {
$parcel$export(module.exports, "UserSegmentTypes", function () { return $e68eab8314ff9c96$export$a8dc2296828ba3fa; });
$parcel$export(module.exports, "useUserSegments", function () { return $e68eab8314ff9c96$export$cb9d3ee4b5fdaafe; });

var $1oC0p = parcelRequire("1oC0p");

var $dqd4k = parcelRequire("dqd4k");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $hu3Tl = parcelRequire("hu3Tl");

var $9rnwe = parcelRequire("9rnwe");

var $baQEe = parcelRequire("baQEe");
var $e68eab8314ff9c96$export$a8dc2296828ba3fa = /*#__PURE__*/ function(UserSegmentTypes) {
    UserSegmentTypes["LOGIN_STATUS"] = "login-status";
    UserSegmentTypes["GEOLOCATION"] = "geolocation";
    UserSegmentTypes["JOB_FUNCTION"] = "job-function";
    UserSegmentTypes["DOMAIN_TYPE"] = "domain-type";
    UserSegmentTypes["OWNED_PRODUCTS"] = "owned-products";
    UserSegmentTypes["CLUSTER_TAG"] = "cluster-tag";
    UserSegmentTypes["SUB_ANCHOR"] = "sub-anchor";
    UserSegmentTypes["CHANNEL"] = "channel";
    UserSegmentTypes["UTM_CONTENT"] = "utm-content";
    UserSegmentTypes["FIRST_RECOMMENDATION"] = "first-recommendation";
    UserSegmentTypes["SECOND_RECOMMENDATION"] = "second-recommendation";
    UserSegmentTypes["THIRD_RECOMMENDATION"] = "third-recommendation";
    UserSegmentTypes["FOURTH_RECOMMENDATION"] = "fourth-recommendation";
    UserSegmentTypes["COLLECTION_OPTIONS"] = "collection-options";
    return UserSegmentTypes;
}({});
const $e68eab8314ff9c96$export$cb9d3ee4b5fdaafe = ()=>{
    const { personalizationValues: personalizationValues } = (0, $9rnwe.useWAEContext)();
    const { loggedOutProfile: loggedOutProfile, loggedInProfile: loggedInProfile, profile: userContextProfile } = (0, $7GVWk.useUserContext)();
    const [profileStatus, setProfileStatus] = (0, $1oC0p.useState)(loggedInProfile ? 'complete' : 'idle');
    const [profile, setProfile] = (0, $1oC0p.useState)(loggedInProfile);
    const [profileError, setProfileError] = (0, $1oC0p.useState)(null);
    const [segmentFetchErrors, setSegmentFetchErrors] = (0, $1oC0p.useState)([]);
    // works on SSR and client
    const isLoggedOut = (0, $2WL8B.useLoggedOut)();
    // Memoize the client to prevent recreation on every render
    const { getFullProfileCallback: getFullProfileCallback } = (0, $dqd4k.useGupsStatus)();
    const productCatalogLocationBaseUrl = typeof window !== 'undefined' ? window.PRODUCT_CATALOG_LOCATION_BASE_URL : "https://www.atlassian.com/endpoint";
    const { countryCode: countryCode, status: locationStatus } = (0, $hu3Tl.useGeoLocation)(productCatalogLocationBaseUrl ?? '');
    (0, $1oC0p.useEffect)(()=>{
        if (loggedInProfile) {
            setProfile(loggedInProfile);
            setSegmentFetchErrors([]);
            setProfileStatus('complete');
            return;
        }
        let isCancelled = false;
        const getFullProfile = async ()=>{
            setProfileStatus('fetching');
            const { data: data, error: error } = await getFullProfileCallback();
            // Add this to prevent Race Condition when the component is unmounted before the request is complete
            if (isCancelled) return;
            setProfileError(error);
            setProfile(data);
            setSegmentFetchErrors(error ? [
                "job-function",
                "domain-type"
            ] : []);
            setProfileStatus(error ? 'error' : 'complete');
        };
        getFullProfile();
        return ()=>{
            isCancelled = true;
        };
    }, [
        getFullProfileCallback,
        loggedInProfile
    ]);
    // Helper function to extract product names from sites
    const extractProductNames = (sites)=>{
        if (!sites) return [];
        return sites.flatMap((site)=>site.products?.map((product)=>product.productName || product.productKey || '').filter(Boolean) || []);
    };
    const userContextSites = userContextProfile.attributes?.existingSites;
    const hasUserContextProducts = !userContextProfile.requestInProgress && userContextSites !== undefined;
    // Memoize the personalization values to prevent unnecessary recalculations
    return (0, $1oC0p.useMemo)(()=>{
        // Collect products from both logged-in and logged-out profiles
        const loggedInProducts = extractProductNames(profile?.sites);
        const userContextProducts = extractProductNames(userContextSites);
        const loggedOutProducts = extractProductNames(loggedOutProfile?.sites);
        const allProducts = [
            ...loggedInProducts,
            ...userContextProducts,
            ...loggedOutProducts
        ];
        const uniqueProducts = [
            ...new Set(allProducts)
        ];
        const productRecommendation = (0, $baQEe.getSoftwarePageProductRecommendation)({
            jobFunction: profile?.userProfile?.jobFunction,
            loggedInProducts: loggedInProducts
        });
        // Build the user segment values
        const userSegmentData = {
            ...personalizationValues,
            ["login-status"]: isLoggedOut ? 'loggedOut' : 'loggedIn',
            ["geolocation"]: locationStatus === 'complete' ? countryCode : undefined,
            ["job-function"]: profile?.userProfile?.jobFunction,
            ["domain-type"]: profile?.userProfile?.domainType,
            ["owned-products"]: uniqueProducts,
            ["first-recommendation"]: productRecommendation.FIRST_Recommendation,
            ["second-recommendation"]: productRecommendation.SECOND_Recommendation,
            ["third-recommendation"]: productRecommendation.THIRD_Recommendation,
            ["fourth-recommendation"]: productRecommendation.FOURTH_Recommendation,
            // Stubbed: downstream data source for collection eligibility not yet available.
            // Will be populated (e.g. with "TWC") once the upstream API is ready.
            ["collection-options"]: undefined
        };
        const ownedProductsStatus = hasUserContextProducts || loggedInProfile || loggedOutProfile ? 'complete' : profileStatus;
        const statuses = {
            // always available on SSR, synchronously
            ["login-status"]: 'complete',
            ["cluster-tag"]: 'complete',
            ["sub-anchor"]: 'complete',
            ["channel"]: 'complete',
            ["utm-content"]: 'complete',
            // depends on the location check
            ["geolocation"]: locationStatus,
            // depends on the profile
            ["job-function"]: profileStatus,
            ["domain-type"]: profileStatus,
            ["owned-products"]: ownedProductsStatus,
            ["first-recommendation"]: profileStatus,
            ["second-recommendation"]: profileStatus,
            ["third-recommendation"]: profileStatus,
            ["fourth-recommendation"]: profileStatus,
            // Stubbed: always complete since it's not fetched from downstream yet
            ["collection-options"]: 'complete'
        };
        return {
            data: userSegmentData,
            error: profileError,
            segmentFetchErrors: segmentFetchErrors,
            statuses: statuses
        };
    }, [
        profile?.sites,
        userContextSites,
        profile?.userProfile?.domainType,
        profile?.userProfile?.jobFunction,
        loggedOutProfile?.sites,
        profileError,
        segmentFetchErrors,
        countryCode,
        profileStatus,
        locationStatus,
        loggedInProfile,
        personalizationValues,
        isLoggedOut
    ]);
};

});
parcelRegister("hu3Tl", function(module, exports) {
$parcel$export(module.exports, "COUNTRY_CODE_TO_CURRENCY", function () { return $5afb1e2e246ccd83$export$5eecc1bf68a424bd; });
$parcel$export(module.exports, "getCurrencyFromUserLocale", function () { return $5afb1e2e246ccd83$export$d308c60568c90469; });
$parcel$export(module.exports, "useGeoLocation", function () { return $5afb1e2e246ccd83$export$f0ecc6cfe1a5d26a; });

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");
const $5afb1e2e246ccd83$export$7baaffefa21dec1 = 'US';
const $5afb1e2e246ccd83$export$496c65882823a55b = 'bxp.currentLocale';
const $5afb1e2e246ccd83$export$5eecc1bf68a424bd = {
    US: 'USD',
    JP: 'JPY',
    ja: 'JPY'
};
const $5afb1e2e246ccd83$export$d308c60568c90469 = (userLocale)=>{
    // @ts-ignore
    return $5afb1e2e246ccd83$export$5eecc1bf68a424bd[userLocale] ?? $5afb1e2e246ccd83$export$5eecc1bf68a424bd[$5afb1e2e246ccd83$export$7baaffefa21dec1];
};
async function $5afb1e2e246ccd83$export$f5c42400285872e7(baseUrl, request) {
    if (typeof window === 'undefined') {
        // @ts-ignore
        const environmentType = globalThis.ssrContext?.environmentType;
        const modeEnv = "build";
        const version = "p-df99072e01";
        const isCI = true;
        const nodeEnv = "production";
        // Call location API in:
        // - Deployed environments (staging, production)
        // - Tests (to use spies/mocks)
        // Skip in all other cases (local dev, CI non-test builds)
        const shouldCallAPI = nodeEnv && [
            'staging',
            'production',
            'test'
        ].includes(nodeEnv);
        if (!shouldCallAPI) {
            console.log('[LOCATION API] Local dev mode detected - Skipping /endpoint/location call', {
                environmentType: environmentType,
                MODE: modeEnv,
                returning: {
                    countryIsoCode: $5afb1e2e246ccd83$export$7baaffefa21dec1,
                    regionIsoCode: ''
                }
            });
            return {
                countryIsoCode: $5afb1e2e246ccd83$export$7baaffefa21dec1,
                regionIsoCode: ''
            };
        }
        console.log('[LOCATION API] Not in dev mode - Will make /endpoint/location call', {
            environmentType: environmentType,
            MODE: modeEnv,
            VERSION: version,
            CI: isCI
        });
        const headers = {};
        //@ts-ignore
        const awsRegion = globalThis.ssrContext.awsRegion;
        // S2S calls only work if the downstream service exists in the same region that our tesseract runtime is in
        const downStreamServiceExistsInSameTesseractRuntimeRegion = (0, $5Ntyw.BxpExpressServiceSupportedRegions).has(awsRegion);
        if (!downStreamServiceExistsInSameTesseractRuntimeRegion) {
            console.log('Downstream service does not exist in the same region as current tesseract region. Current tesseract region: ' + awsRegion);
            const fallbackLocale = await $5afb1e2e246ccd83$export$3fa76d5e19089da0(baseUrl);
            return {
                countryIsoCode: fallbackLocale,
                regionIsoCode: ''
            };
        }
        headers['x-ssr-service-name'] = 'bxp-express';
        // bxp-express service does not have any dev instances so when we're in dev, point to staging
        // Note: This code path should not be reached in dev mode due to early return above
        if (environmentType === 'dev') {
            headers['x-ssr-service-env'] = 'staging';
            headers['x-ssr-service-region'] = 'us-east-1'; // Bxp-express service in staging only lives in us-east-1 or us-west-2
        }
        //@ts-ignore
        headers['X-Forwarded-For'] = request?.headers['x-forwarded-for'];
        console.log('[LOCATION API] Making fetch call to /location (routes to /endpoint/location)', {
            url: '/location',
            headers: Object.keys(headers)
        });
        return await fetch(`/location`, {
            headers: headers
        }).then((response)=>{
            return response.json();
        }).then((json)=>{
            return {
                countryIsoCode: json.countryIsoCode || $5afb1e2e246ccd83$export$7baaffefa21dec1,
                regionIsoCode: json.regionIsoCode || ''
            };
        }).catch(async ()=>{
            // If there's an error with s2s call - fall back to original fetchUserLocale
            const fallbackLocale = await $5afb1e2e246ccd83$export$3fa76d5e19089da0(baseUrl);
            return {
                countryIsoCode: fallbackLocale,
                regionIsoCode: ''
            };
        });
    } else {
        const fallbackLocale = await $5afb1e2e246ccd83$export$3fa76d5e19089da0(baseUrl);
        return {
            countryIsoCode: fallbackLocale,
            regionIsoCode: ''
        };
    }
}
async function $5afb1e2e246ccd83$export$b6ae37355b3e5433(baseUrl, request) {
    let localeFromStorage;
    if (typeof window !== 'undefined') localeFromStorage = sessionStorage.getItem($5afb1e2e246ccd83$export$496c65882823a55b);
    if (localeFromStorage) return Promise.resolve(localeFromStorage);
    const locationData = await $5afb1e2e246ccd83$export$f5c42400285872e7(baseUrl, request);
    return locationData.countryIsoCode;
}
async function $5afb1e2e246ccd83$export$3fa76d5e19089da0(baseUrl) {
    let localeFromStorage;
    if (typeof window !== 'undefined') localeFromStorage = sessionStorage.getItem($5afb1e2e246ccd83$export$496c65882823a55b);
    if (localeFromStorage) return Promise.resolve(localeFromStorage);
    const locationData = await $5afb1e2e246ccd83$export$284826310e51ae98(baseUrl);
    return locationData.countryIsoCode;
}
async function $5afb1e2e246ccd83$export$284826310e51ae98(baseUrl) {
    return await fetch(`${baseUrl}/location`).then((response)=>{
        return response.json();
    }).then((json)=>{
        return {
            countryIsoCode: json.countryIsoCode || $5afb1e2e246ccd83$export$7baaffefa21dec1,
            regionIsoCode: json.regionIsoCode || ''
        };
    }).catch(()=>{
        return {
            countryIsoCode: $5afb1e2e246ccd83$export$7baaffefa21dec1,
            regionIsoCode: ''
        };
    });
}
function $5afb1e2e246ccd83$export$f0ecc6cfe1a5d26a(baseUrl) {
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [countryCode, setCountryCode] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus('fetching');
            const locale = await $5afb1e2e246ccd83$export$3fa76d5e19089da0(baseUrl);
            setStatus('complete');
            setCountryCode(locale);
        };
        fetchData();
    }, []);
    return {
        status: status,
        countryCode: countryCode
    };
}

});

parcelRegister("9rnwe", function(module, exports) {
$parcel$export(module.exports, "useWAEContext", function () { return $bff3c4c0a6d62374$export$30d39dce252f6463; });
$parcel$export(module.exports, "useWAEContextSafe", function () { return $bff3c4c0a6d62374$export$ddd740d3988c141b; });
$parcel$export(module.exports, "useEnvironmentInfo", function () { return $bff3c4c0a6d62374$export$dd7563e37524312; });
$parcel$export(module.exports, "WAEContextProvider", function () { return $bff3c4c0a6d62374$export$57f16d059dbbcf81; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jWxnl = parcelRequire("jWxnl");
// Default values for WAE context
const $bff3c4c0a6d62374$var$DEFAULT_VALUES = {
    wacEnvironment: 'development',
    uniformEnvironment: 'production',
    uniformProjectId: '',
    isCanvas: false,
    isAllowPostMessage: false,
    composition: undefined,
    contentfulEnvironment: 'master',
    personalizationValues: {},
    uniformContext: (0, $jWxnl.createUniformContext)(),
    locale: undefined
};
const $bff3c4c0a6d62374$var$UNIFORM_PREVIEW_PATH = '/uniform-preview';
const $bff3c4c0a6d62374$var$getPreviewLocaleFromUrl = ()=>{
    if (typeof window === 'undefined' || !window.location?.pathname) return undefined;
    if (!window.location.pathname.includes($bff3c4c0a6d62374$var$UNIFORM_PREVIEW_PATH)) return undefined;
    const locale = new URLSearchParams(window.location.search ?? '').get('locale');
    return locale ?? undefined;
};
/**
 * Get the WAC environment from environment variables with fallback
 */ const $bff3c4c0a6d62374$var$getWACEnvironment = ()=>{
    const env = "production";
    switch(env){
        case 'development':
        case 'dev':
        case 'test':
            // Handle Jest test environment
            return 'development';
        case 'staging':
        case 'stg':
            return 'staging';
        case 'production':
        case 'prod':
            return 'production';
        default:
            // Use development as default for testing and local development
            return 'development';
    }
};
const $bff3c4c0a6d62374$var$WAEContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $bff3c4c0a6d62374$export$30d39dce252f6463 = ()=>{
    const context = (0, $1oC0p.useContext)($bff3c4c0a6d62374$var$WAEContext);
    if (!context) throw new Error("useWAEContext must be used within a WAEContextProvider. Make sure your component is wrapped with <WAEContextProvider>.");
    return context;
};
const $bff3c4c0a6d62374$export$ddd740d3988c141b = ()=>{
    return (0, $1oC0p.useContext)($bff3c4c0a6d62374$var$WAEContext);
};
const $bff3c4c0a6d62374$export$786f94d9d302d2d6 = ()=>{
    const context = $bff3c4c0a6d62374$export$30d39dce252f6463();
    return context.isCanvas;
};
const $bff3c4c0a6d62374$export$dd7563e37524312 = ()=>{
    const context = $bff3c4c0a6d62374$export$30d39dce252f6463();
    return {
        wacEnvironment: context.wacEnvironment,
        uniformEnvironment: context.uniformEnvironment,
        contentfulEnvironment: context.contentfulEnvironment,
        isProduction: context.wacEnvironment === 'production',
        isDevelopment: context.wacEnvironment === 'development',
        isStaging: context.wacEnvironment === 'staging'
    };
};
const $bff3c4c0a6d62374$export$57f16d059dbbcf81 = ({ children: children, wacEnvironment: wacEnvironment, uniformEnvironment: uniformEnvironment = $bff3c4c0a6d62374$var$DEFAULT_VALUES.uniformEnvironment, uniformProjectId: uniformProjectId = $bff3c4c0a6d62374$var$DEFAULT_VALUES.uniformProjectId, isCanvas: isCanvas = $bff3c4c0a6d62374$var$DEFAULT_VALUES.isCanvas, composition: composition = $bff3c4c0a6d62374$var$DEFAULT_VALUES.composition, contentfulEnvironment: contentfulEnvironment = $bff3c4c0a6d62374$var$DEFAULT_VALUES.contentfulEnvironment, personalizationValues: personalizationValues = $bff3c4c0a6d62374$var$DEFAULT_VALUES.personalizationValues, isAllowPostMessage: isAllowPostMessage = $bff3c4c0a6d62374$var$DEFAULT_VALUES.isAllowPostMessage, uniformContext: uniformContext = $bff3c4c0a6d62374$var$DEFAULT_VALUES.uniformContext, locale: locale })=>{
    // Auto-detect WAC environment if not provided
    const resolvedWacEnvironment = wacEnvironment || $bff3c4c0a6d62374$var$getWACEnvironment();
    const resolvedLocale = locale ?? $bff3c4c0a6d62374$var$getPreviewLocaleFromUrl();
    const contextValue = {
        wacEnvironment: resolvedWacEnvironment,
        uniformEnvironment: uniformEnvironment,
        uniformProjectId: uniformProjectId,
        isCanvas: isCanvas,
        isAllowPostMessage: isAllowPostMessage,
        composition: composition,
        contentfulEnvironment: contentfulEnvironment,
        personalizationValues: personalizationValues,
        uniformContext: uniformContext,
        locale: resolvedLocale
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($bff3c4c0a6d62374$var$WAEContext.Provider, {
        value: contextValue,
        children: children
    });
};

});
parcelRegister("jWxnl", function(module, exports) {
$parcel$export(module.exports, "createUniformContext", function () { return $fe4ec44854742152$export$f93d264ea709396d; });

var $ajzpT = parcelRequire("ajzpT");
const $fe4ec44854742152$export$f93d264ea709396d = ()=>{
    return new (0, $ajzpT.Context)({
        defaultConsent: true,
        // for using quirks, we don't need any specific config aside from this.
        // If we were to use other Uniform personalization features, we would need to query the Uniform Optimization Manifest API here.
        manifest: {
            project: {
                pz: {},
                test: {}
            }
        }
    });
};

});
parcelRegister("ajzpT", function(module, exports) {
$parcel$export(module.exports, "SERVER_STATE_ID", function () { return $782726c034562d46$export$8c2d769a752fe753; });
$parcel$export(module.exports, "Context", function () { return $782726c034562d46$export$841858b892ce1f4c; });
$parcel$export(module.exports, "ScriptType", function () { return $782726c034562d46$export$e8f788122ce44497; });
$parcel$export(module.exports, "EdgeNodeTagName", function () { return $782726c034562d46$export$56c1ae559875bab5; });

var $hT7VS = parcelRequire("hT7VS");

var $6GqRO = parcelRequire("6GqRO");

var $fRyfD = parcelRequire("fRyfD");

var $kH2vB = parcelRequire("kH2vB");
var $782726c034562d46$var$__defProp = Object.defineProperty;
var $782726c034562d46$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $782726c034562d46$var$__defNormalProp = (obj, key, value)=>key in obj ? $782726c034562d46$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $782726c034562d46$var$__publicField = (obj, key, value)=>$782726c034562d46$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $782726c034562d46$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $782726c034562d46$var$__typeError("Cannot " + msg);
var $782726c034562d46$var$__privateGet = (obj, member, getter)=>($782726c034562d46$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $782726c034562d46$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $782726c034562d46$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $782726c034562d46$var$__privateSet = (obj, member, value, setter)=>($782726c034562d46$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $782726c034562d46$var$__privateMethod = (obj, member, method)=>($782726c034562d46$var$__accessCheck(obj, member, "access private method"), method);
// src/manifest/aggregates/computeAggregateDimensions.ts
function $782726c034562d46$export$1398e1ad65dc57ad(primitiveScores, aggregates) {
    const result = {
        ...primitiveScores
    };
    for(const aggregateDimension in aggregates){
        const aggregateScore = $782726c034562d46$var$computeAggregateDimension(primitiveScores, aggregateDimension, aggregates, /* @__PURE__ */ new Set([
            aggregateDimension
        ]));
        if (aggregateScore !== 0) result[aggregateDimension] = aggregateScore;
    }
    return result;
}
function $782726c034562d46$var$computeAggregateDimension(primitiveScores, aggregateDimension, allAggregates, visitedDimensions) {
    var _a;
    let aggregateScore = 0;
    for (const input of allAggregates[aggregateDimension].inputs){
        let currentScore = (_a = primitiveScores[input.dim]) != null ? _a : 0;
        if (!currentScore) {
            const aggRef = allAggregates[input.dim];
            if (aggRef) {
                if (visitedDimensions.has(input.dim)) continue;
                const newVisited = new Set(visitedDimensions);
                newVisited.add(input.dim);
                currentScore = $782726c034562d46$var$computeAggregateDimension(primitiveScores, input.dim, allAggregates, newVisited);
            }
        }
        if (currentScore !== 0) {
            if (input.sign === "c") {
                aggregateScore = 0;
                break;
            } else if (input.sign === "-") aggregateScore -= currentScore;
            else aggregateScore += currentScore;
        }
    }
    return aggregateScore;
}
// src/manifest/constants.ts
var $782726c034562d46$export$2a02cc17eba86e08 = "_";
// src/manifest/goals/evaluators/SignalGoalEvaluator.ts
var $782726c034562d46$var$_id;
var $782726c034562d46$var$SignalGoalEvaluator = class {
    constructor(options){
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_id);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_id, options.id);
    }
    get id() {
        return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_id);
    }
    evaluate({ scores: scores, quirks: quirks }) {
        const score = scores == null ? void 0 : scores[$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_id)];
        const key = `goal_${$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_id)}_triggered`;
        const hasGoalTriggered = (quirks == null ? void 0 : quirks[key]) === "1";
        return {
            key: key,
            triggered: typeof score === "number" && !hasGoalTriggered
        };
    }
};
$782726c034562d46$var$_id = new WeakMap();
// src/manifest/signals/SignalInstance.ts
var $782726c034562d46$var$_evaluator, $782726c034562d46$var$_onLogMessage;
var $782726c034562d46$var$SignalInstance = class {
    constructor(data, evaluator, onLogMessage){
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_evaluator);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_onLogMessage);
        $782726c034562d46$var$__publicField(this, "signal");
        this.signal = data;
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_evaluator, evaluator);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_onLogMessage, onLogMessage);
    }
    /** Computes storage update commands to take based on a state update and the signal's criteria */ computeSignal(update, commands) {
        const isAtCap = update.scores[this.signal.id] >= this.signal.cap;
        if (isAtCap && this.signal.dur !== "t") return;
        const criteriaMatchUpdate = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_evaluator).evaluate(update, this.signal.crit, commands, this.signal, $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_onLogMessage));
        const scoreCommand = this.signal.dur === "s" || this.signal.dur === "t" ? "modscoreS" : "modscore";
        if (!criteriaMatchUpdate.changed) return;
        if (criteriaMatchUpdate.result) commands.push({
            type: scoreCommand,
            data: {
                dimension: this.signal.id,
                delta: this.signal.str
            }
        });
        else if (this.signal.dur === "t") {
            const sessionScore = update.visitor.sessionScores[this.signal.id];
            if (sessionScore) commands.push({
                type: scoreCommand,
                data: {
                    dimension: this.signal.id,
                    delta: -sessionScore
                }
            });
        }
    }
};
$782726c034562d46$var$_evaluator = new WeakMap();
$782726c034562d46$var$_onLogMessage = new WeakMap();
// src/manifest/utils/control.ts
var $782726c034562d46$var$rollForControlGroup = (value)=>{
    let control = value;
    if (control >= 1) control = control / 100;
    return Math.random() < control;
};
// src/manifest/ManifestInstance.ts
var $782726c034562d46$var$_mf, $782726c034562d46$var$_signalInstances, $782726c034562d46$var$_goalEvaluators, $782726c034562d46$var$_onLogMessage2;
var $782726c034562d46$export$81c30d905c4c020a = class {
    constructor({ manifest: manifest, evaluator: evaluator = new $782726c034562d46$export$6bde52a42da7459e({}), onLogMessage: // eslint-disable-next-line @typescript-eslint/no-empty-function
    onLogMessage = ()=>{} }){
        $782726c034562d46$var$__publicField(this, "data");
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_mf);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_signalInstances);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_goalEvaluators, []);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_onLogMessage2);
        var _a, _b, _c, _d, _e;
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_mf, (_a = manifest.project) != null ? _a : {});
        this.data = manifest;
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_signalInstances, Object.entries((_c = (_b = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mf).pz) == null ? void 0 : _b.sig) != null ? _c : []).map(([id, signal])=>new $782726c034562d46$var$SignalInstance({
                ...signal,
                id: id
            }, evaluator, onLogMessage)));
        Object.entries((_e = (_d = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mf).pz) == null ? void 0 : _d.sig) != null ? _e : []).forEach(([id, signal])=>{
            if (signal.conversion) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_goalEvaluators).push(new $782726c034562d46$var$SignalGoalEvaluator({
                id: id,
                signal: signal
            }));
        });
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_onLogMessage2, onLogMessage);
    }
    rollForControlGroup() {
        var _a;
        return $782726c034562d46$var$rollForControlGroup(((_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mf).pz) == null ? void 0 : _a.control) || 0);
    }
    getTest(name) {
        var _a;
        return (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mf).test) == null ? void 0 : _a[name];
    }
    computeSignals(update) {
        const commands = [];
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_onLogMessage2).call(this, [
            "debug",
            200,
            "GROUP"
        ]);
        try {
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_signalInstances).forEach((signal)=>{
                $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_onLogMessage2).call(this, [
                    "debug",
                    201,
                    "GROUP",
                    signal.signal
                ]);
                try {
                    signal.computeSignal(update, commands);
                } finally{
                    $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_onLogMessage2).call(this, [
                        "debug",
                        201,
                        "ENDGROUP"
                    ]);
                }
            });
        } finally{
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_onLogMessage2).call(this, [
                "debug",
                200,
                "ENDGROUP"
            ]);
        }
        return commands;
    }
    computeGoals(data) {
        const commands = [];
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_goalEvaluators).forEach((evaluator)=>{
            const { triggered: triggered, key: key } = evaluator.evaluate(data);
            if (triggered) {
                commands.push({
                    type: "setgoal",
                    data: {
                        goal: evaluator.id
                    }
                });
                commands.push({
                    type: "setquirk",
                    data: {
                        key: key,
                        value: "1"
                    }
                });
            }
        });
        return commands;
    }
    /**
   * Computes aggregated scores based on other dimensions
   */ computeAggregateDimensions(primitiveScores) {
        var _a, _b;
        return $782726c034562d46$export$1398e1ad65dc57ad(primitiveScores, (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mf).pz) == null ? void 0 : _a.agg) != null ? _b : {});
    }
    getDimensionByKey(scoreKey) {
        var _a, _b, _c, _d;
        const enrichmentIndex = scoreKey.indexOf($782726c034562d46$export$2a02cc17eba86e08);
        if (enrichmentIndex <= 0) return (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mf).pz) == null ? void 0 : _a.sig) == null ? void 0 : _b[scoreKey];
        return (_d = (_c = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mf).pz) == null ? void 0 : _c.enr) == null ? void 0 : _d[scoreKey.substring(0, enrichmentIndex)];
    }
    getAggregateDimensionByKey(scoreKey) {
        var _a, _b;
        return (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mf).pz) == null ? void 0 : _a.agg) == null ? void 0 : _b[scoreKey];
    }
};
$782726c034562d46$var$_mf = new WeakMap();
$782726c034562d46$var$_signalInstances = new WeakMap();
$782726c034562d46$var$_goalEvaluators = new WeakMap();
$782726c034562d46$var$_onLogMessage2 = new WeakMap();
// src/manifest/signals/criteria/util/isStringMatch.ts
function $782726c034562d46$export$46015a7088cba607(lhs, match) {
    var _a, _b, _c, _d, _e, _f;
    const type = (_a = match == null ? void 0 : match.op) != null ? _a : "=";
    if (match.op === "*") return lhs !== null && typeof lhs !== "undefined";
    if (match.op === "!*") return lhs === null || typeof lhs === "undefined";
    if (!("rhs" in match)) throw new Error(`Match expression is required for match type ${type}`);
    const caseSensitive = (_b = match.cs) != null ? _b : false;
    const localRhs = (caseSensitive ? lhs != null ? lhs : "" : $782726c034562d46$var$caseDesensitize(lhs)).toString();
    const localLhs = (caseSensitive ? match.rhs : $782726c034562d46$var$caseDesensitize(match.rhs)).toString();
    switch(type){
        case "=":
            return localRhs === localLhs;
        case "!=":
            return localRhs !== localLhs;
        case "~":
            return (_c = localRhs.includes(localLhs)) != null ? _c : false;
        case "!~":
            return !((_d = localRhs.includes(localLhs)) != null ? _d : true);
        case "//":
            return new RegExp(match.rhs.toString(), caseSensitive ? "" : "i").test((_e = lhs == null ? void 0 : lhs.toString()) != null ? _e : "");
        case "!//":
            return !new RegExp(match.rhs.toString(), caseSensitive ? "" : "i").test((_f = lhs == null ? void 0 : lhs.toString()) != null ? _f : "");
        default:
            throw new Error(`Unknown match type ${type}.`);
    }
}
function $782726c034562d46$export$2eedca80c212fa2a(lhs, match) {
    const cs = "cs" in match ? match.cs : false;
    return `'${cs ? lhs : lhs == null ? void 0 : lhs.toString().toUpperCase()}' ${$782726c034562d46$export$ee95a773008d6293(match)}`;
}
function $782726c034562d46$export$ee95a773008d6293(match) {
    if ("rhs" in match) return `${match.op} '${match.cs ? match.rhs : match.rhs.toString().toUpperCase()}'`;
    return `${match.op === "*" ? "exists" : "does not exist"}`;
}
function $782726c034562d46$var$caseDesensitize(value) {
    var _a, _b;
    return (_b = (_a = value == null ? void 0 : value.toString()) == null ? void 0 : _a.toUpperCase()) != null ? _b : "";
}
// src/manifest/signals/criteria/evaluators/cookieEvaluator.ts
var $782726c034562d46$export$553ac20321cc9418 = ({ update: update, criteria: criteria, onLogMessage: onLogMessage })=>{
    var _a, _b;
    if (criteria.type !== "CK") return {
        result: false,
        changed: false
    };
    const changed = !(0, $hT7VS.dequal)($782726c034562d46$var$cleanCookies(update.state.cookies), $782726c034562d46$var$cleanCookies((_a = update.previousState) == null ? void 0 : _a.cookies));
    const value = (_b = update.state.cookies) == null ? void 0 : _b[criteria.cookieName];
    const result = $782726c034562d46$export$46015a7088cba607(value, criteria.match);
    const finalResult = {
        result: result,
        changed: changed
    };
    onLogMessage == null || onLogMessage([
        "debug",
        203,
        {
            criteria: criteria,
            result: finalResult,
            explanation: $782726c034562d46$export$2eedca80c212fa2a(value, criteria.match)
        }
    ]);
    return finalResult;
};
function $782726c034562d46$var$cleanCookies(cookie) {
    if (!cookie) return void 0;
    if (!cookie.ufvd) return cookie;
    const { ufvd: ufvd, ...rest } = cookie;
    return rest;
}
// src/manifest/signals/criteria/evaluators/currentPageEvaluator.ts
var $782726c034562d46$export$67422e249549a799 = ({ update: update, criteria: criteria, onLogMessage: onLogMessage })=>{
    var _a, _b, _c;
    if (criteria.type !== "PV") return {
        result: false,
        changed: false
    };
    const value = (_a = update.state.url) == null ? void 0 : _a.pathname;
    const hasUrlChanged = !update.previousState || (value == null ? void 0 : value.toString()) !== ((_c = (_b = update.previousState.url) == null ? void 0 : _b.pathname) == null ? void 0 : _c.toString());
    const result = $782726c034562d46$export$46015a7088cba607(value, criteria.path);
    const finalResult = {
        result: result,
        changed: hasUrlChanged
    };
    onLogMessage == null || onLogMessage([
        "debug",
        203,
        {
            criteria: criteria,
            result: finalResult,
            explanation: $782726c034562d46$export$2eedca80c212fa2a(value, criteria.path)
        }
    ]);
    return finalResult;
};
// src/manifest/signals/criteria/evaluators/eventEvaluator.ts
var $782726c034562d46$export$879d92bf88c68af3 = ({ update: update, criteria: criteria, onLogMessage: onLogMessage })=>{
    var _a, _b, _c;
    if (criteria.type !== "EVT") return {
        result: false,
        changed: false
    };
    const result = (_b = (_a = update.state.events) == null ? void 0 : _a.some((event)=>$782726c034562d46$export$46015a7088cba607(event.event, criteria.event))) != null ? _b : false;
    const finalResult = {
        result: result,
        changed: result
    };
    onLogMessage == null || onLogMessage([
        "debug",
        203,
        {
            criteria: criteria,
            result: finalResult,
            explanation: `'${(_c = update.state.events) == null ? void 0 : _c.join("', '")}' ${$782726c034562d46$export$ee95a773008d6293(criteria.event)}`
        }
    ]);
    return finalResult;
};
// src/manifest/utils/getEnrichmentVectorKey.ts
function $782726c034562d46$export$2c42873b49b6d99e(category, value) {
    return `${category}${$782726c034562d46$export$2a02cc17eba86e08}${value}`;
}
// src/manifest/signals/criteria/util/isNumberMatch.ts
function $782726c034562d46$var$isNumberMatch(lhs, match) {
    var _a;
    if (typeof lhs === "undefined" || lhs === null) return false;
    const lhsValue = Number(lhs);
    if (isNaN(lhsValue)) return false;
    switch((_a = match == null ? void 0 : match.op) != null ? _a : "="){
        case "=":
            return lhsValue === match.rhs;
        case "!=":
            return lhsValue !== match.rhs;
        case ">":
            return lhsValue > match.rhs;
        case "<":
            return lhsValue < match.rhs;
        default:
            console.warn(`Unknown match type ${match.op} is false.`);
            return false;
    }
}
function $782726c034562d46$var$explainNumberMatch(lhs, match) {
    return `${lhs} ${$782726c034562d46$var$explainNumberMatchCriteria(match)}`;
}
function $782726c034562d46$var$explainNumberMatchCriteria(match) {
    return `${match.op} ${match.rhs}`;
}
// src/manifest/signals/criteria/evaluators/pageViewCountEvaluator.ts
var $782726c034562d46$export$e902828621d5c4e0 = $782726c034562d46$export$2c42873b49b6d99e("$pvc", "v");
var $782726c034562d46$export$1a758c98b73fe710 = ({ update: update, criteria: criteria, commands: commands, onLogMessage: onLogMessage })=>{
    var _a, _b;
    if (criteria.type !== "PVC") return {
        result: false,
        changed: false
    };
    const hasUrlChanged = Boolean(update.state.url && (!update.previousState || ((_a = update.state.url) == null ? void 0 : _a.toString()) !== ((_b = update.previousState.url) == null ? void 0 : _b.toString())));
    const existingValueNumber = update.visitor.sessionScores[$782726c034562d46$export$e902828621d5c4e0] || 0;
    const updatedCount = existingValueNumber + 1;
    const finalResult = {
        result: false,
        changed: hasUrlChanged
    };
    const hasExistingPageViewIncrementCommand = commands.some((c)=>c.type === "modscoreS" && c.data.dimension === $782726c034562d46$export$e902828621d5c4e0);
    if (hasUrlChanged && !hasExistingPageViewIncrementCommand) commands.push({
        type: "modscoreS",
        data: {
            dimension: $782726c034562d46$export$e902828621d5c4e0,
            delta: 1
        }
    });
    if ($782726c034562d46$var$isNumberMatch(updatedCount, criteria.match)) finalResult.result = true;
    onLogMessage == null || onLogMessage([
        "debug",
        203,
        {
            criteria: criteria,
            result: finalResult,
            explanation: $782726c034562d46$var$explainNumberMatch(updatedCount, criteria.match)
        }
    ]);
    return finalResult;
};
$782726c034562d46$export$1a758c98b73fe710.alwaysExecute = true;
// src/manifest/signals/criteria/evaluators/queryStringEvaluator.ts
var $782726c034562d46$export$64a97b0a16f13000 = ({ update: update, criteria: criteria, onLogMessage: onLogMessage })=>{
    var _a, _b, _c, _d, _e;
    if (criteria.type !== "QS") return {
        result: false,
        changed: false
    };
    const hasQueryChanged = !update.previousState || ((_b = (_a = update.state.url) == null ? void 0 : _a.searchParams) == null ? void 0 : _b.toString()) !== ((_d = (_c = update.previousState.url) == null ? void 0 : _c.searchParams) == null ? void 0 : _d.toString());
    const value = (_e = update.state.url) == null ? void 0 : _e.searchParams.get(criteria.queryName);
    const result = $782726c034562d46$export$46015a7088cba607(value, criteria.match);
    const finalResult = {
        result: result,
        changed: hasQueryChanged
    };
    onLogMessage == null || onLogMessage([
        "debug",
        203,
        {
            criteria: criteria,
            result: finalResult,
            explanation: $782726c034562d46$export$2eedca80c212fa2a(value, criteria.match)
        }
    ]);
    return finalResult;
};
// src/manifest/signals/criteria/evaluators/quirkEvaluator.ts
var $782726c034562d46$export$dff13ab74686b498 = ({ update: update, criteria: criteria, signal: signal, onLogMessage: onLogMessage })=>{
    var _a;
    if (criteria.type !== "QK") return {
        result: false,
        changed: false
    };
    if (typeof document === "undefined" && update.scores[signal.id] > 0) return {
        result: true,
        changed: false
    };
    const visitorValue = update.visitor.quirks[criteria.key];
    const updateValue = (_a = update.state.quirks) == null ? void 0 : _a[criteria.key];
    const value = updateValue != null ? updateValue : visitorValue;
    const changed = Boolean(updateValue !== void 0 && visitorValue !== updateValue);
    const result = $782726c034562d46$export$46015a7088cba607(value, criteria.match);
    const finalResult = {
        result: result,
        changed: changed
    };
    onLogMessage == null || onLogMessage([
        "debug",
        203,
        {
            criteria: criteria,
            result: finalResult,
            explanation: $782726c034562d46$export$2eedca80c212fa2a(value, criteria.match)
        }
    ]);
    return finalResult;
};
// src/manifest/signals/criteria/GroupCriteriaEvaluator.ts
var $782726c034562d46$var$_evaluators;
var $782726c034562d46$export$6bde52a42da7459e = class {
    constructor(criteriaEvaluators){
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_evaluators);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_evaluators, criteriaEvaluators);
    }
    evaluate(update, crit, commands, signal, onLogMessage) {
        const hasMultipleClauses = crit.clauses.length > 1;
        if (hasMultipleClauses) onLogMessage == null || onLogMessage([
            "debug",
            202,
            "GROUP",
            crit
        ]);
        try {
            const earlyExitEvaluatorResult = crit.op === "&" || !crit.op ? false : true;
            let earlyExitResult = null;
            let isAnyChanged = false;
            for (const criteria of crit.clauses){
                let result;
                if (criteria.type === "G") result = this.evaluate(update, criteria, commands, signal, onLogMessage);
                else {
                    const evaluator = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_evaluators)[criteria.type];
                    if (earlyExitResult && !evaluator.alwaysExecute) continue;
                    if (!evaluator) throw new Error(`${criteria.type} signal criteria not registered`);
                    result = evaluator({
                        update: update,
                        criteria: criteria,
                        commands: commands,
                        signal: signal,
                        onLogMessage: onLogMessage
                    });
                }
                if (result.changed) isAnyChanged = true;
                if (!earlyExitResult && result.result === earlyExitEvaluatorResult) earlyExitResult = {
                    result: earlyExitEvaluatorResult,
                    changed: isAnyChanged
                };
            }
            const finalResult = earlyExitResult != null ? earlyExitResult : {
                result: !earlyExitEvaluatorResult,
                changed: isAnyChanged
            };
            if (hasMultipleClauses) onLogMessage == null || onLogMessage([
                "debug",
                204,
                finalResult
            ]);
            return finalResult;
        } finally{
            if (hasMultipleClauses) onLogMessage == null || onLogMessage([
                "debug",
                202,
                "ENDGROUP"
            ]);
        }
    }
};
$782726c034562d46$var$_evaluators = new WeakMap();
// src/placement/criteria/evaluateVariantMatch.ts
function $782726c034562d46$export$d60b108e46120751(variantId, match, vec, onLogMessage, quirks) {
    onLogMessage == null || onLogMessage([
        "info",
        301,
        "GROUP",
        {
            id: variantId,
            op: match == null ? void 0 : match.op
        }
    ]);
    let result;
    try {
        if (!(match == null ? void 0 : match.crit)) {
            onLogMessage == null || onLogMessage([
                "info",
                302,
                {
                    matched: true,
                    description: "default variation"
                }
            ]);
            result = true;
        } else if (!match.op || match.op === "&") result = match.crit.every((c)=>$782726c034562d46$var$evaluateMatch(c, vec, quirks != null ? quirks : {}, onLogMessage));
        else result = match.crit.some((c)=>$782726c034562d46$var$evaluateMatch(c, vec, quirks != null ? quirks : {}, onLogMessage));
        onLogMessage == null || onLogMessage([
            "info",
            303,
            result
        ]);
    } finally{
        onLogMessage == null || onLogMessage([
            "info",
            301,
            "ENDGROUP"
        ]);
    }
    return result;
}
function $782726c034562d46$var$evaluateMatch(crit, vec, quirks, onLogMessage) {
    if ("t" in crit && crit.t === "q") return $782726c034562d46$var$evaluateQuirkMatch(crit, quirks, onLogMessage);
    else return $782726c034562d46$var$evaluateDimensionMatch(crit, vec, onLogMessage);
}
function $782726c034562d46$var$evaluateDimensionMatch(crit, vec, onLogMessage) {
    var _a, _b;
    const { l: lhs, op: op } = crit;
    const lhsScore = (_a = vec[lhs]) != null ? _a : 0;
    if (op === "^") {
        const [cat] = lhs.split($782726c034562d46$export$2a02cc17eba86e08);
        let topVectorName = void 0;
        let topScore = 0;
        Object.keys(vec).forEach((vectorName)=>{
            if (vectorName.startsWith(`${cat}${$782726c034562d46$export$2a02cc17eba86e08}`)) {
                const score = vec[vectorName];
                if (score > topScore) {
                    topVectorName = vectorName;
                    topScore = score;
                }
            }
        });
        const result = topVectorName === lhs;
        onLogMessage == null || onLogMessage([
            "info",
            302,
            {
                matched: result,
                description: `${crit.l} has the highest score in the category`
            }
        ]);
        return result;
    } else if (op === "+") {
        const result = Math.max(...Object.values(vec)) === lhsScore && lhsScore > 0;
        onLogMessage == null || onLogMessage([
            "info",
            302,
            {
                matched: result,
                description: `${crit.l} has the highest score`
            }
        ]);
        return result;
    } else if (op === "-") {
        const result = Math.min(...Object.values(vec)) === lhsScore && lhsScore > 0;
        onLogMessage == null || onLogMessage([
            "info",
            302,
            {
                matched: result,
                description: `${crit.l} has the lowest non-zero score`
            }
        ]);
        return result;
    }
    let rhsScore;
    if (crit.rDim) rhsScore = vec[crit.rDim] || 0;
    else rhsScore = parseInt(crit.r, 10);
    if (isNaN(rhsScore)) {
        onLogMessage == null || onLogMessage([
            "info",
            302,
            {
                matched: false,
                description: `${(_b = crit.rDim) != null ? _b : crit.r} has no score value`
            }
        ]);
        return false;
    }
    if (op === ">") {
        const result = lhsScore > rhsScore;
        $782726c034562d46$var$explainScore(onLogMessage, result, crit, lhsScore, rhsScore);
        return result;
    } else if (op === ">=") {
        const result = lhsScore >= rhsScore;
        $782726c034562d46$var$explainScore(onLogMessage, result, crit, lhsScore, rhsScore);
        return result;
    } else if (op === "<") {
        const result = lhsScore < rhsScore;
        $782726c034562d46$var$explainScore(onLogMessage, result, crit, lhsScore, rhsScore);
        return result;
    } else if (op === "<=") {
        const result = lhsScore <= rhsScore;
        $782726c034562d46$var$explainScore(onLogMessage, result, crit, lhsScore, rhsScore);
        return result;
    } else if (op === "=") {
        const result = lhsScore === rhsScore;
        $782726c034562d46$var$explainScore(onLogMessage, result, crit, lhsScore, rhsScore);
        return result;
    } else if (op === "!=") {
        const result = lhsScore !== rhsScore;
        $782726c034562d46$var$explainScore(onLogMessage, result, crit, lhsScore, rhsScore);
        return result;
    } else {
        onLogMessage == null || onLogMessage([
            "error",
            302,
            {
                matched: false,
                description: `${crit.l} ${crit.op} ${crit.rDim ? `${crit.rDim}` : crit.r}: Unknown op ${crit.op}.`
            }
        ]);
        return false;
    }
}
function $782726c034562d46$var$evaluateQuirkMatch(crit, quirks, onLogMessage) {
    var _a;
    const { l: targetQuirk, op: op, r: targetValue } = crit;
    const targetQuirkValue = (_a = quirks[targetQuirk]) != null ? _a : "";
    if (op === "=") {
        const result = targetQuirkValue === targetValue;
        $782726c034562d46$var$explainQuirk(onLogMessage, result, crit, targetQuirkValue);
        return result;
    } else if (op === "!=") {
        const result = targetQuirkValue !== targetValue;
        $782726c034562d46$var$explainQuirk(onLogMessage, result, crit, targetQuirkValue);
        return result;
    } else {
        onLogMessage == null || onLogMessage([
            "error",
            302,
            {
                matched: false,
                description: `Quirk ${crit.l} ${crit.op} ${crit.r}: Unknown quirk op ${crit.op}.`
            }
        ]);
        return false;
    }
}
function $782726c034562d46$var$explainScore(onLogMessage, result, crit, lhsScore, rhsScore) {
    onLogMessage == null || onLogMessage([
        "info",
        302,
        {
            matched: result,
            description: `${crit.l}[${lhsScore}] ${crit.op} ${crit.rDim ? `${crit.rDim}[${rhsScore}]` : crit.r}`
        }
    ]);
}
function $782726c034562d46$var$explainQuirk(onLogMessage, result, crit, lhs) {
    onLogMessage == null || onLogMessage([
        "info",
        302,
        {
            matched: result,
            description: `Quirk ${crit.l}[${lhs}] ${crit.op} ${crit.r}`
        }
    ]);
}
// src/placement/topDownCriteriaPersonalizationSelectionAlgorithm.ts
var $782726c034562d46$export$efd6c1637cd82656 = "default";
function $782726c034562d46$export$f13d97b099918517({ name: name, context: context, variations: variations, take: take = 1, onLogMessage: onLogMessage }) {
    var _a, _b, _c;
    onLogMessage == null || onLogMessage([
        "info",
        300,
        "GROUP",
        {
            name: name,
            take: take
        }
    ]);
    try {
        const variationMatches = [];
        const defaultVariations = [];
        const needsConsentToPersonalize = context.requireConsentForPersonalization;
        const personalizationAllowed = !needsConsentToPersonalize || context.storage.data.consent;
        for (const variation of variations){
            const isInvalidFormat = variation.pz && (typeof variation.pz !== "object" || variation.pz === null || !("crit" in variation.pz && Array.isArray(variation.pz.crit)));
            let validVariation;
            if (isInvalidFormat) {
                const { pz: pz, ...validParts } = variation;
                validVariation = validParts;
            } else validVariation = variation;
            if ((_a = validVariation.pz) == null ? void 0 : _a.crit.length) {
                if (personalizationAllowed && variationMatches.length !== take && $782726c034562d46$export$d60b108e46120751(variation.id, validVariation.pz, context.scores, onLogMessage, context.quirks)) variationMatches.push(validVariation);
            } else defaultVariations.push(validVariation);
        }
        const result = [];
        for(let i = 0; i < variationMatches.length; i++){
            let isControl = (_b = context.storage.data.controlGroup) != null ? _b : false;
            const variation = variationMatches[i];
            if (!isControl && typeof ((_c = variation.pz) == null ? void 0 : _c.control) === "number") {
                isControl = context.getPersonalizeVariantControl(name, i);
                if (typeof isControl === "undefined") {
                    isControl = $782726c034562d46$var$rollForControlGroup(variation.pz.control);
                    context.storage.updateData([
                        {
                            type: "setpersonalizecontrol",
                            data: {
                                personlizationName: name,
                                index: i,
                                control: isControl
                            }
                        }
                    ]);
                }
            }
            let variantToAdd = variation;
            if (isControl) {
                const defaultReplacement = defaultVariations.shift();
                if (defaultReplacement) variantToAdd = {
                    ...defaultReplacement,
                    id: variation.id
                };
                else variantToAdd = void 0;
            }
            if (variantToAdd) result.push({
                ...variantToAdd,
                control: isControl
            });
        }
        while(result.length < take && defaultVariations.length)result.push({
            ...defaultVariations.shift(),
            control: false
        });
        const personalized = result.some((v)=>{
            var _a2;
            return (_a2 = v.pz) == null ? void 0 : _a2.crit.length;
        });
        return {
            personalized: personalized,
            variations: result
        };
    } finally{
        onLogMessage == null || onLogMessage([
            "info",
            300,
            "ENDGROUP"
        ]);
    }
}
// src/placement/personalizeVariations.ts
function $782726c034562d46$export$1a766d0349c575f3(options) {
    return $782726c034562d46$export$f13d97b099918517(options);
}
// src/placement/strongestScorePersonalizationSelectionAlgorithm.ts
var $782726c034562d46$export$ce3f85c28255a924 = "ssc";
function $782726c034562d46$export$8fe83c41c03855ce({ name: name, context: context, variations: variations, take: take = 1, onLogMessage: onLogMessage }) {
    var _a, _b;
    onLogMessage == null || onLogMessage([
        "info",
        300,
        "GROUP",
        {
            name: name,
            take: take
        }
    ]);
    try {
        const variationMatches = [];
        const defaultVariations = [];
        const needsConsentToPersonalize = context.requireConsentForPersonalization;
        const isInGlobalControlGroup = (_a = context.storage.data.controlGroup) != null ? _a : false;
        const personalizationAllowed = !needsConsentToPersonalize || context.storage.data.consent;
        let originalIndex = 0;
        for (const variation of variations){
            const isInvalidFormat = variation.pz && typeof variation.pz !== "object";
            let validVariation;
            if (isInvalidFormat) {
                const { pz: pz, ...validParts } = variation;
                validVariation = validParts;
            } else validVariation = variation;
            if ((_b = validVariation.pz) == null ? void 0 : _b.dim) {
                if (!personalizationAllowed) continue;
                const score = context.scores[validVariation.pz.dim];
                if (score === void 0 || score <= 0) continue;
                variationMatches.push({
                    variation: validVariation,
                    score: score,
                    originalIndex: originalIndex
                });
                originalIndex++;
            } else defaultVariations.push(validVariation);
        }
        variationMatches.sort((a, b)=>{
            const scoreComparison = b.score - a.score;
            if (scoreComparison === 0) return a.originalIndex - b.originalIndex;
            return scoreComparison;
        });
        const result = [];
        for(let i = 0; i < variationMatches.length; i++){
            const variationMatch = variationMatches[i];
            let variantToAdd = variationMatch.variation;
            if (i >= take) continue;
            if (isInGlobalControlGroup) {
                const defaultReplacement = defaultVariations.shift();
                if (defaultReplacement) variantToAdd = {
                    ...defaultReplacement,
                    id: variationMatch.variation.id
                };
                else variantToAdd = void 0;
            }
            if (variantToAdd) result.push({
                ...variantToAdd,
                control: isInGlobalControlGroup
            });
        }
        while(result.length < take && defaultVariations.length)result.push({
            ...defaultVariations.shift(),
            control: false
        });
        return {
            personalized: variationMatches.length > 0 && !isInGlobalControlGroup,
            variations: result
        };
    } finally{
        onLogMessage == null || onLogMessage([
            "info",
            300,
            "ENDGROUP"
        ]);
    }
}
// src/placement/normalizeVariationDistributions.ts
var $782726c034562d46$var$normalizeVariationDistributions = (variations)=>{
    const { values: values, total: total, missingDistribution: missingDistribution } = variations.reduce((previous, current)=>{
        if (current.testDistribution) previous.total += current.testDistribution;
        else ++previous.missingDistribution;
        previous.values.push(current.testDistribution);
        return previous;
    }, {
        values: [],
        total: 0,
        missingDistribution: 0
    });
    if (total > 100) {
        const autoScaleFactor = 100 / total;
        values.forEach((value, index)=>{
            if (typeof value === "number") values[index] = value * autoScaleFactor;
        });
    } else if (total < 100) {
        const remainder = 100 - total;
        const missingSlice = remainder / missingDistribution;
        values.forEach((value, index)=>{
            if (typeof value === "undefined") values[index] = missingSlice;
        });
    }
    return values;
};
// src/placement/testVariations.ts
var $782726c034562d46$export$9a62a55bdb8657f2 = ({ name: name, context: context, variations: variations, onLogMessage: onLogMessage })=>{
    onLogMessage == null || onLogMessage([
        "info",
        400,
        "GROUP",
        name
    ]);
    try {
        let selectedVariant;
        const selectedVariantId = context.getTestVariantId(name);
        if (selectedVariantId === null) {
            onLogMessage == null || onLogMessage([
                "error",
                401,
                name
            ]);
            return {
                result: void 0,
                variantAssigned: false
            };
        }
        if (selectedVariantId) {
            selectedVariant = variations.find((variation)=>variation.id === selectedVariantId);
            if (!selectedVariant) onLogMessage == null || onLogMessage([
                "warn",
                402,
                {
                    missingVariant: selectedVariantId,
                    variants: variations.map((v)=>v.id)
                }
            ]);
        }
        if (!selectedVariant) {
            const distributions = $782726c034562d46$var$normalizeVariationDistributions(variations);
            const random = Math.random() * 100;
            let distributionOffset = 0;
            selectedVariant = variations.find((variant, index)=>{
                const distribution = distributions[index];
                if (random >= distributionOffset && random < distributionOffset + distribution) return variant;
                distributionOffset += distribution;
            });
            if (selectedVariant) {
                onLogMessage == null || onLogMessage([
                    "info",
                    403,
                    selectedVariant.id
                ]);
                context.setTestVariantId(name, selectedVariant.id);
            }
        }
        if (selectedVariant) {
            onLogMessage == null || onLogMessage([
                "info",
                404,
                selectedVariant.id
            ]);
            if (selectedVariant.control === void 0) selectedVariant.control = variations.findIndex((variation)=>variation.id === selectedVariantId) === 0;
        }
        return {
            result: selectedVariant,
            variantAssigned: !selectedVariantId
        };
    } finally{
        onLogMessage == null || onLogMessage([
            "info",
            400,
            "ENDGROUP"
        ]);
    }
};
var $782726c034562d46$export$5b2e75712457a278 = (a, b)=>{
    if (a.type !== b.type) return false;
    return (0, $hT7VS.dequal)(a, b);
};
var $782726c034562d46$export$8c2d769a752fe753 = "__UNIFORM_DATA__";
var $782726c034562d46$var$_data, $782726c034562d46$var$_initialData, $782726c034562d46$var$_mitt;
var $782726c034562d46$export$c59ea90adbf96388 = class {
    constructor({ initialData: initialData }){
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_data);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_initialData);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_mitt, (0, $fRyfD.default)());
        /**
     * Subscribe to events from the transition storage
     */ $782726c034562d46$var$__publicField(this, "events", {
            on: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt).on,
            off: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt).off
        });
        if (initialData) {
            $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_data, initialData);
            $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_initialData, initialData);
        }
    }
    get data() {
        return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_data);
    }
    get initialData() {
        return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_initialData);
    }
    /**
   * Updates data in the transition storage.
   * @param commands Commands to execute against existing stored value (event based stores)
   * @param computedValue Pre-computed new value against existing value (object based stores)
   * @returns Resolved promise when the data has been updated
   */ updateData(commands, computedValue) {
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_data, computedValue);
        return this.handleUpdateData(commands, computedValue);
    }
    /**
   * Deletes a visitor's stored data, forgetting them.
   * @param fromAllDevices - false: logout from this device ID. true: forget all data about the visitor and their identity.
   */ async delete(fromAllDevices) {
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_data, void 0);
        await this.handleDelete(fromAllDevices);
    }
    signalAsyncDataUpdate(newScores) {
        if ((0, $hT7VS.dequal)(this.data, newScores)) return;
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_data, newScores);
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt).emit("dataUpdatedAsync", newScores);
    }
    /**
   * When we load on the client side after a server side rendering has occurred (server to client transition),
   * we can have a page script (ID: __UNIFORM_DATA__) that contains the computed visitor data from the SSR/edge render.
   * This data is injected into the first render to allow score syncing and the server to request commands be applied
   * to the client side data store.
   */ getClientTransitionState() {
        if (typeof document === "undefined") return;
        const matchesElement = document.getElementById($782726c034562d46$export$8c2d769a752fe753);
        return (matchesElement == null ? void 0 : matchesElement.textContent) ? JSON.parse(matchesElement.textContent) : void 0;
    }
};
$782726c034562d46$var$_data = new WeakMap();
$782726c034562d46$var$_initialData = new WeakMap();
$782726c034562d46$var$_mitt = new WeakMap();
// src/storage/util/numberToBase64.ts
var $782726c034562d46$var$alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $782726c034562d46$var$b2s = $782726c034562d46$var$alphabet.split("");
var $782726c034562d46$var$s2b = new Array(123);
for(let i = 0; i < $782726c034562d46$var$alphabet.length; i++)$782726c034562d46$var$s2b[$782726c034562d46$var$alphabet.charCodeAt(i)] = i;
var $782726c034562d46$var$ntob = (number)=>{
    if (number < 0) return `-${$782726c034562d46$var$ntob(-number)}`;
    let lo = number >>> 0;
    let hi = number / 4294967296 >>> 0;
    let right = "";
    while(hi > 0){
        right = $782726c034562d46$var$b2s[63 & lo] + right;
        lo >>>= 6;
        lo |= (63 & hi) << 26;
        hi >>>= 6;
    }
    let left = "";
    do {
        left = $782726c034562d46$var$b2s[63 & lo] + left;
        lo >>>= 6;
    }while (lo > 0);
    return left + right;
};
var $782726c034562d46$var$bton = (base64)=>{
    let number = 0;
    const sign = base64.charAt(0) === "-" ? 1 : 0;
    for(let i = sign; i < base64.length; i++)number = number * 64 + $782726c034562d46$var$s2b[base64.charCodeAt(i)];
    return sign ? -number : number;
};
// src/storage/CookieTransitionDataStore.ts
var $782726c034562d46$var$ssr = typeof document === "undefined";
var $782726c034562d46$export$e75fcb9dce2f8695 = "ufvd";
var $782726c034562d46$export$ecd5b4a5d9c2e6dd = `ufvdqk`;
var $782726c034562d46$var$_cookieName, $782726c034562d46$var$_quirkCookieName, $782726c034562d46$var$_cookieAttributes, $782726c034562d46$var$_quirksEnabled;
var $782726c034562d46$export$de89f5a59ea40513 = class extends $782726c034562d46$export$c59ea90adbf96388 {
    constructor({ serverCookieValue: serverCookieValue, experimental_quirksEnabled: experimental_quirksEnabled, quirkCookieValue: quirkCookieValue, quirkCookieName: quirkCookieName = $782726c034562d46$export$ecd5b4a5d9c2e6dd, cookieName: cookieName = $782726c034562d46$export$e75fcb9dce2f8695, cookieAttributes: cookieAttributes = {
        sameSite: "lax"
    } }){
        super({
            initialData: $782726c034562d46$var$ssr ? $782726c034562d46$export$504cf22759d243dc(serverCookieValue, experimental_quirksEnabled ? quirkCookieValue : void 0) : void 0
        });
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_cookieName);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_quirkCookieName);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_cookieAttributes);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_quirksEnabled);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_cookieName, cookieName);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_cookieAttributes, cookieAttributes);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_quirkCookieName, quirkCookieName);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_quirksEnabled, experimental_quirksEnabled || false);
    }
    handleDelete() {
        if ($782726c034562d46$var$ssr) return Promise.resolve();
        (0, $6GqRO.default).remove($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_cookieName));
        return Promise.resolve();
    }
    async handleUpdateData(_, computedValue) {
        if ($782726c034562d46$var$ssr) return;
        if (computedValue.consent) {
            (0, $6GqRO.default).set($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_cookieName), $782726c034562d46$export$659f3e5265115438(computedValue), $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_cookieAttributes));
            if ($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_quirksEnabled) && Object.keys(computedValue.quirks || {}).length) {
                const quirkCookieValue = $782726c034562d46$export$d64898e25ef5f65b(computedValue.quirks || {});
                (0, $6GqRO.default).set($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_quirkCookieName), quirkCookieValue, $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_cookieAttributes));
            }
        } else {
            (0, $6GqRO.default).remove($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_cookieName));
            if ($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_quirksEnabled)) (0, $6GqRO.default).remove($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_quirkCookieName));
        }
    }
};
$782726c034562d46$var$_cookieName = new WeakMap();
$782726c034562d46$var$_quirkCookieName = new WeakMap();
$782726c034562d46$var$_cookieAttributes = new WeakMap();
$782726c034562d46$var$_quirksEnabled = new WeakMap();
var $782726c034562d46$export$8e3a0093c3c67c1f = "~";
var $782726c034562d46$export$6d34e8fa9864ca77 = "!";
var $782726c034562d46$export$4b2d70615af96850 = "-";
var $782726c034562d46$export$bd57de0c56306df0 = "!!";
function $782726c034562d46$export$504cf22759d243dc(cookieValue, quirkCookieValue) {
    if (!cookieValue) return;
    const types = cookieValue.split($782726c034562d46$export$8e3a0093c3c67c1f);
    if (types.length > 5) return;
    const [abTestData, sessionScores, visitorScores, controlGroup, personalizeVariants] = types;
    const data = {
        // this is true since we're reading a cookie, which wouldn't exist if consent wasn't given
        consent: true,
        sessionScores: $782726c034562d46$export$5d03e0f24572dbe7($782726c034562d46$export$8c001b50ee1a13ed(sessionScores)),
        scores: $782726c034562d46$export$5d03e0f24572dbe7($782726c034562d46$export$8c001b50ee1a13ed(visitorScores)),
        tests: $782726c034562d46$export$aafdb0e0557e46ef(abTestData),
        controlGroup: controlGroup === "1",
        personalizeVariants: $782726c034562d46$export$abfaf7f53bb0eacf(personalizeVariants)
    };
    if (quirkCookieValue) data.quirks = $782726c034562d46$export$30c101981a64bb73(quirkCookieValue);
    return data;
}
function $782726c034562d46$export$30c101981a64bb73(quirkCookieValue) {
    const pairs = quirkCookieValue.split($782726c034562d46$export$bd57de0c56306df0);
    const splitPairs = pairs.map((pair)=>{
        const sep = pair.indexOf($782726c034562d46$export$4b2d70615af96850);
        if (sep === -1) return void 0;
        return [
            pair.slice(0, sep),
            pair.slice(sep + 1)
        ];
    });
    const areAllPairsValid = splitPairs.every((pair)=>pair !== void 0);
    if (!areAllPairsValid) return {};
    return splitPairs.reduce((acc, cur)=>{
        const [key, value] = cur;
        acc[key] = value;
        return acc;
    }, {});
}
function $782726c034562d46$export$8c001b50ee1a13ed(type) {
    if (!type) return {};
    const pairs = type.split($782726c034562d46$export$6d34e8fa9864ca77).map((pair)=>pair.split($782726c034562d46$export$4b2d70615af96850));
    return pairs.reduce((acc, cur)=>{
        if (cur.length < 2) return acc;
        const key = cur.slice(0, -1).join($782726c034562d46$export$4b2d70615af96850);
        acc[key] = cur[cur.length - 1];
        return acc;
    }, {});
}
function $782726c034562d46$export$aafdb0e0557e46ef(type) {
    if (!type) return {};
    const pairs = type.split($782726c034562d46$export$6d34e8fa9864ca77).map((pair)=>pair.split($782726c034562d46$export$4b2d70615af96850));
    return pairs.reduce((acc, cur)=>{
        if (cur.length < 2) return acc;
        acc[cur[0]] = cur.slice(1).join("-");
        return acc;
    }, {});
}
function $782726c034562d46$export$5d03e0f24572dbe7(type) {
    return Object.entries(type).reduce((acc, [key, value])=>{
        acc[key] = $782726c034562d46$var$bton(value);
        return acc;
    }, {});
}
function $782726c034562d46$export$659f3e5265115438(data) {
    return [
        $782726c034562d46$export$34540491a35905a1(data.tests),
        $782726c034562d46$export$34540491a35905a1($782726c034562d46$export$218a32ffd75e3d7(data.sessionScores)),
        $782726c034562d46$export$34540491a35905a1($782726c034562d46$export$218a32ffd75e3d7(data.scores)),
        data.controlGroup ? "1" : "0",
        $782726c034562d46$export$72fd2f0ddd73b63f(data)
    ].join($782726c034562d46$export$8e3a0093c3c67c1f);
}
function $782726c034562d46$export$72fd2f0ddd73b63f({ personalizeVariants: personalizeVariants }) {
    const data = {};
    if (typeof personalizeVariants === "object") Object.keys(personalizeVariants).forEach((personalizationName)=>{
        const results = [];
        const variants = personalizeVariants[personalizationName];
        variants.forEach((variant)=>{
            results.push(`${variant.index}:${variant.control ? "1" : "0"}`);
        });
        data[personalizationName] = results.join(",");
    });
    const serialized = $782726c034562d46$export$34540491a35905a1(data);
    return serialized;
}
function $782726c034562d46$export$abfaf7f53bb0eacf(data) {
    const parsed = $782726c034562d46$export$aafdb0e0557e46ef(data);
    const keys = Object.keys(parsed);
    if (!keys.length) return void 0;
    const results = {};
    Object.keys(parsed).forEach((k)=>{
        const variants = parsed[k].split(",");
        const key = decodeURIComponent(k);
        results[key] = variants.map((variant)=>{
            const [index, control] = variant.split(":");
            return {
                index: parseInt(index, 10),
                control: control === "1"
            };
        });
    });
    return results;
}
function $782726c034562d46$export$218a32ffd75e3d7(type) {
    return Object.entries(type).reduce((acc, [key, value])=>{
        acc[key] = $782726c034562d46$var$ntob(value);
        return acc;
    }, {});
}
function $782726c034562d46$export$34540491a35905a1(type) {
    return Object.entries(type).map((kv)=>kv.join($782726c034562d46$export$4b2d70615af96850)).join($782726c034562d46$export$6d34e8fa9864ca77);
}
function $782726c034562d46$export$d64898e25ef5f65b(quirks) {
    return Object.entries(quirks).map((kv)=>kv.join($782726c034562d46$export$4b2d70615af96850)).join($782726c034562d46$export$bd57de0c56306df0);
}
// src/storage/EdgeTransitionDataStore.ts
var $782726c034562d46$var$_EdgeTransitionDataStore_instances, $782726c034562d46$var$fetchData_fn;
var $782726c034562d46$export$62517e891b6568ca = class extends $782726c034562d46$export$c59ea90adbf96388 {
    constructor({ serverCookieValue: serverCookieValue, visitorIdCookieName: visitorIdCookieName = "ufvi", ...base }){
        super(base);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_EdgeTransitionDataStore_instances);
        if (!base.initialData) $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_EdgeTransitionDataStore_instances, $782726c034562d46$var$fetchData_fn).call(this).catch((err)=>{
            console.error(err);
        });
    }
    handleDelete(fromAllDevices) {
        throw new Error("Method not implemented.");
    }
    async handleUpdateData(commands) {
        const commandResults = await new Promise((resolve)=>{
            setTimeout(()=>{
                resolve(void 0);
            }, 2e3);
        });
        if (commandResults) this.signalAsyncDataUpdate(commandResults);
    }
};
$782726c034562d46$var$_EdgeTransitionDataStore_instances = new WeakSet();
$782726c034562d46$var$fetchData_fn = async function() {
    const serviceData = await new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(void 0);
        }, 2e3);
    });
    if (serviceData) this.signalAsyncDataUpdate(serviceData);
};
// src/storage/linearDecay.ts
function $782726c034562d46$export$97b7f16f535f4efd(options) {
    const { gracePeriod: gracePeriod = 864e5, decayRate: decayRate = 1 / 30, decayCap: decayCap = 0.95 } = options != null ? options : {};
    return function linearDecay({ now: now, lastUpd: lastUpd, scores: scores, sessionScores: sessionScores, onLogMessage: onLogMessage }) {
        if (typeof lastUpd !== "number") return false;
        const timeSinceLastUpdate = now - lastUpd;
        const timeSinceGracePeriod = timeSinceLastUpdate - gracePeriod;
        if (timeSinceGracePeriod <= 0) return false;
        const timeSinceGracePeriodInDays = timeSinceGracePeriod / 864e5;
        const decayFactor = 1 - Math.min(decayCap, timeSinceGracePeriodInDays * decayRate);
        if (decayFactor <= 0) return false;
        $782726c034562d46$var$decayVector(scores, decayFactor);
        $782726c034562d46$var$decayVector(sessionScores, decayFactor);
        onLogMessage == null || onLogMessage([
            "info",
            140,
            `linear decay factor ${decayFactor.toPrecision(6)}`
        ]);
        return true;
    };
}
function $782726c034562d46$var$decayVector(vector, decay) {
    for(const key in vector){
        if (key.startsWith("$")) continue;
        vector[key] *= decay;
    }
}
// src/types.ts
var $782726c034562d46$export$f72cdce017763061 = ()=>({
        quirks: {},
        scores: {},
        sessionScores: {},
        tests: {},
        goals: {},
        consent: false,
        controlGroup: false,
        personalizeVariants: {}
    });
var $782726c034562d46$var$clone = (0, (/*@__PURE__*/$parcel$interopDefault($kH2vB)))();
function $782726c034562d46$var$applyCommandsToData(commands, state) {
    const newData = state ? $782726c034562d46$var$clone(state) : $782726c034562d46$export$f72cdce017763061();
    commands.forEach((command)=>{
        var _a, _b, _c;
        switch(command.type){
            case "consent":
                newData.consent = command.data;
                break;
            case "setquirk":
                newData.quirks[command.data.key] = command.data.value;
                break;
            case "settest":
                newData.tests[command.data.test] = command.data.variant;
                break;
            case "modscore":
                const delta = Number(command.data.delta);
                if (isNaN(delta)) throw new Error("Non-number delta received");
                const existing = (_a = newData.scores[command.data.dimension]) != null ? _a : 0;
                newData.scores[command.data.dimension] = existing + delta;
                break;
            case "modscoreS":
                const deltaS = Number(command.data.delta);
                if (isNaN(deltaS)) throw new Error("Non-number delta received");
                const existingS = (_b = newData.sessionScores[command.data.dimension]) != null ? _b : 0;
                newData.sessionScores[command.data.dimension] = existingS + deltaS;
                break;
            case "identify":
                break;
            case "setcontrol":
                newData.controlGroup = command.data;
                break;
            case "setpersonalizecontrol":
                if (!newData.personalizeVariants) newData.personalizeVariants = {};
                if (!newData.personalizeVariants[command.data.personlizationName]) newData.personalizeVariants[command.data.personlizationName] = [];
                const existingDef = newData.personalizeVariants[command.data.personlizationName].find((i)=>i.index === command.data.index);
                if (!existingDef) newData.personalizeVariants[command.data.personlizationName].push({
                    index: command.data.index,
                    control: command.data.control
                });
                else console.warn("Overwriting existing control group definition is not allowed");
                break;
            case "setgoal":
                newData.goals = (_c = newData.goals) != null ? _c : {};
                newData.goals[command.data.goal] = true;
                break;
            default:
                throw new Error(`Unknown command`);
        }
    });
    return newData;
}
// src/storage/util/LocalStorage.ts
var $782726c034562d46$var$_LocalStorage_instances, $782726c034562d46$var$key_fn;
var $782726c034562d46$var$LocalStorage = class {
    constructor(partitionKey){
        this.partitionKey = partitionKey;
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_LocalStorage_instances);
        $782726c034562d46$var$__publicField(this, "inMemoryFallback", {});
        // deno implements localStorage in netlify edge workers, must also check if document is present.
        $782726c034562d46$var$__publicField(this, "hasLocalStorageObject", typeof document !== "undefined" && typeof localStorage !== "undefined");
    }
    get(key) {
        const keyValue = $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_LocalStorage_instances, $782726c034562d46$var$key_fn).call(this, key);
        const fallbackValue = this.inMemoryFallback[keyValue];
        if (!this.hasLocalStorageObject || fallbackValue) return fallbackValue;
        try {
            const value = localStorage.getItem(keyValue);
            return value ? JSON.parse(value) : void 0;
        } catch (e) {
            return fallbackValue;
        }
    }
    set(key, value, storageConsent) {
        const keyValue = $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_LocalStorage_instances, $782726c034562d46$var$key_fn).call(this, key);
        this.inMemoryFallback[keyValue] = value;
        if (!this.hasLocalStorageObject || !storageConsent) return;
        try {
            localStorage.setItem(keyValue, JSON.stringify(value));
        } catch (e) {
            console.warn(e);
        }
    }
    delete(key, leaveInMemory) {
        const keyValue = $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_LocalStorage_instances, $782726c034562d46$var$key_fn).call(this, key);
        if (!leaveInMemory) delete this.inMemoryFallback[keyValue];
        try {
            localStorage.removeItem(keyValue);
        } catch (e) {}
    }
};
$782726c034562d46$var$_LocalStorage_instances = new WeakSet();
$782726c034562d46$var$key_fn = function(key) {
    return this.partitionKey ? `${this.partitionKey}.${key}` : key;
};
// src/storage/VisitorDataStore.ts
var $782726c034562d46$var$STORAGE_KEY = "ufvisitor";
var $782726c034562d46$var$_mitt2, $782726c034562d46$var$_persist, $782726c034562d46$var$_visitTimeout, $782726c034562d46$var$_options, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$currentData_get, $782726c034562d46$var$replaceData_fn, $782726c034562d46$var$setVisitTimeout_fn, $782726c034562d46$var$isExpired_fn, $782726c034562d46$var$handleCaps_fn, $782726c034562d46$var$defaultData_fn;
var $782726c034562d46$export$c5f10ecc4ea3df13 = class {
    constructor(options){
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_VisitorDataStore_instances);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_mitt2, (0, $fRyfD.default)());
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_persist);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_visitTimeout);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_options);
        /**
     * Subscribe to events from storage
     */ $782726c034562d46$var$__publicField(this, "events", {
            on: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).on,
            off: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).off
        });
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_options, options);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_persist, new $782726c034562d46$var$LocalStorage(options.partitionKey));
        if (!$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$currentData_get)) $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$replaceData_fn).call(this, $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$defaultData_fn).call(this), true);
        if (options.transitionStore) {
            const serverToClientTransitionState = options.transitionStore.getClientTransitionState();
            if (serverToClientTransitionState && options.onServerTransitionReceived) options.onServerTransitionReceived(serverToClientTransitionState);
            options.transitionStore.events.on("dataUpdatedAsync", (data)=>{
                $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$replaceData_fn).call(this, {
                    ...$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$currentData_get).visitorData,
                    ...data
                });
            });
            const transitionData = options.transitionStore.data;
            if (transitionData) $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$replaceData_fn).call(this, // we know _currentData is not empty because we inited it above if it was
            {
                ...$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$currentData_get).visitorData,
                ...transitionData
            }, true);
        }
    }
    /** Gets the current visitor data. This property is always up to date. */ get data() {
        var _a, _b, _c;
        const data = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$currentData_get)) != null ? _a : {
            visitorData: $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$defaultData_fn).call(this),
            updated: /* @__PURE__ */ new Date().getTime()
        };
        if ($782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$isExpired_fn).call(this, data)) {
            const { sessionScores: sessionScores, ...newData } = data.visitorData;
            $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$replaceData_fn).call(this, {
                ...newData,
                sessionScores: {}
            });
            (_c = (_b = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options)).onLogMessage) == null || _c.call(_b, [
                "info",
                120
            ]);
            return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$currentData_get).visitorData;
        }
        return data.visitorData;
    }
    get decayEnabled() {
        return !!$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).decay;
    }
    get options() {
        return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options);
    }
    /** Push data update command(s) into the visitor data */ async updateData(commands) {
        var _a, _b, _c;
        if (commands.length === 0) return;
        (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options)).onLogMessage) == null || _b.call(_a, [
            "debug",
            101,
            commands
        ]);
        const newData = $782726c034562d46$var$applyCommandsToData(commands, this.data);
        if (commands.some((c)=>c.type === "consent" && !c.data)) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_persist).delete($782726c034562d46$var$STORAGE_KEY, true);
        $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$replaceData_fn).call(this, newData);
        await ((_c = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).transitionStore) == null ? void 0 : _c.updateData(commands, $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$currentData_get).visitorData));
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).emit("commandsExecuted", commands);
    }
    /**
   * Deletes visitor data (forgetting them)
   * In most cases you should use forget() on the Context instead of this function, which also clears the Context state.
   * @param fromAllDevices for an identified user, whether to delete all their data (for the entire account) - true, or data for this device (sign out) - false
   */ async delete(fromAllDevices) {
        var _a, _b, _c, _d, _e;
        (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options)).onLogMessage) == null || _b.call(_a, [
            "info",
            103,
            "GROUP",
            fromAllDevices
        ]);
        try {
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_persist).delete($782726c034562d46$var$STORAGE_KEY, false);
            await ((_c = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).transitionStore) == null ? void 0 : _c.delete(fromAllDevices));
            $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$replaceData_fn).call(this, $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$defaultData_fn).call(this));
        } finally{
            (_e = (_d = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options)).onLogMessage) == null || _e.call(_d, [
                "info",
                103,
                "ENDGROUP"
            ]);
        }
    }
};
$782726c034562d46$var$_mitt2 = new WeakMap();
$782726c034562d46$var$_persist = new WeakMap();
$782726c034562d46$var$_visitTimeout = new WeakMap();
$782726c034562d46$var$_options = new WeakMap();
$782726c034562d46$var$_VisitorDataStore_instances = new WeakSet();
$782726c034562d46$var$currentData_get = function() {
    return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_persist).get($782726c034562d46$var$STORAGE_KEY);
};
/**
 * IMPORTANT: This function mutates the input data. This is done,
 * because all the sources that call it have either already spread or cloned
 * the data, so we can safely mutate it for better perf.
 */ $782726c034562d46$var$replaceData_fn = function(data, quiet = false) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    const oldData = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$currentData_get);
    const now = Date.now();
    $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$handleCaps_fn).call(this, data.scores);
    $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$handleCaps_fn).call(this, data.sessionScores);
    (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options)).decay) == null || _b.call(_a, {
        now: now,
        lastUpd: oldData == null ? void 0 : oldData.updated,
        scores: data.scores,
        sessionScores: data.sessionScores,
        onLogMessage: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).onLogMessage
    });
    const haveScoresChanged = !(0, $hT7VS.dequal)(oldData == null ? void 0 : oldData.visitorData.scores, data.scores);
    const haveSessionScoresChanged = !(0, $hT7VS.dequal)(oldData == null ? void 0 : oldData.visitorData.sessionScores, data.sessionScores);
    const haveQuirksChanged = !(0, $hT7VS.dequal)(oldData == null ? void 0 : oldData.visitorData.quirks, data.quirks);
    const haveTestsChanged = !(0, $hT7VS.dequal)(oldData == null ? void 0 : oldData.visitorData.tests, data.tests);
    const haveGoalsChanged = !(0, $hT7VS.dequal)(oldData == null ? void 0 : oldData.visitorData.goals, data.goals);
    const updatedData = {
        updated: now,
        visitorData: data
    };
    $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_VisitorDataStore_instances, $782726c034562d46$var$setVisitTimeout_fn).call(this);
    $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_persist).set($782726c034562d46$var$STORAGE_KEY, updatedData, !!data.consent);
    (_d = (_c = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options)).onLogMessage) == null || _d.call(_c, [
        "debug",
        102,
        data
    ]);
    if (!quiet) {
        if (haveScoresChanged || haveSessionScoresChanged) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).emit("scoresUpdated", data);
        if (haveQuirksChanged) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).emit("quirksUpdated", data);
        if (haveTestsChanged) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).emit("testsUpdated", data);
        if (((_e = oldData == null ? void 0 : oldData.visitorData) == null ? void 0 : _e.consent) !== data.consent) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).emit("consentUpdated", data);
        if (((_f = oldData == null ? void 0 : oldData.visitorData) == null ? void 0 : _f.controlGroup) !== data.controlGroup) {
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).emit("controlGroupUpdated", data);
            (_i = (_h = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options)).onLogMessage) == null || _i.call(_h, [
                "debug",
                104,
                (_g = data.controlGroup) != null ? _g : false
            ]);
        }
        if (haveGoalsChanged) {
            const newGoalKeys = Object.keys((_j = data.goals) != null ? _j : {});
            for(let i = 0; i < newGoalKeys.length; i++){
                const key = newGoalKeys[i];
                if (!((_k = oldData == null ? void 0 : oldData.visitorData.goals) == null ? void 0 : _k[key])) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt2).emit("goalConverted", {
                    goalId: key
                });
            }
        }
    }
};
$782726c034562d46$var$setVisitTimeout_fn = function() {
    if (typeof document === "undefined" || !$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).visitLifespan) return;
    if ($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_visitTimeout)) window.clearTimeout($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_visitTimeout));
    $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_visitTimeout, window.setTimeout(()=>{
        this.data;
    }, $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).visitLifespan + 50));
};
$782726c034562d46$var$isExpired_fn = function(data) {
    const expires = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).visitLifespan;
    return expires ? data.updated + expires < Date.now() : false;
};
/**
 * IMPORTANT: This function mutates the input data. This is done,
 * because all the sources that call it have either already spread or cloned
 * the data, so we can safely mutate it for better perf.
 */ $782726c034562d46$var$handleCaps_fn = function(scores) {
    var _a, _b;
    if (!$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).manifest) return;
    for(const dim in scores){
        const score = scores[dim];
        const dimDef = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).manifest.getDimensionByKey(dim);
        if (!dimDef) continue;
        if (score > dimDef.cap) {
            (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options)).onLogMessage) == null || _b.call(_a, [
                "debug",
                110,
                {
                    dim: dim,
                    score: score,
                    cap: dimDef.cap
                }
            ]);
            scores[dim] = dimDef.cap;
        }
    }
};
$782726c034562d46$var$defaultData_fn = function() {
    var _a, _b, _c;
    return {
        ...$782726c034562d46$export$f72cdce017763061(),
        consent: (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).defaultConsent) != null ? _a : false,
        controlGroup: (_c = (_b = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_options).manifest) == null ? void 0 : _b.rollForControlGroup()) != null ? _c : false
    };
};
var $782726c034562d46$export$b15e673925ba7c38 = "contextual_editing_test";
var $782726c034562d46$export$44a1eab28c32d319 = "contextual_editing_test_selected_variant";
var $782726c034562d46$var$_personalizationSelectionAlgorithms, $782726c034562d46$var$_serverTransitionState, $782726c034562d46$var$_scores, $782726c034562d46$var$_state, $782726c034562d46$var$_pzCache, $782726c034562d46$var$_plugins, $782726c034562d46$var$_commands, $782726c034562d46$var$_requireConsentForPersonalization, $782726c034562d46$var$_mitt3, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$emitTest_fn, $782726c034562d46$var$updateGoals_fn, $782726c034562d46$var$updateComputedScores_fn, $782726c034562d46$var$calculateScores_fn;
var $782726c034562d46$export$841858b892ce1f4c = class {
    constructor(options){
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_Context_instances);
        $782726c034562d46$var$__publicField(this, "manifest");
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_personalizationSelectionAlgorithms);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_serverTransitionState);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_scores, {});
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_state);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_pzCache, {});
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_plugins);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_commands);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_requireConsentForPersonalization);
        $782726c034562d46$var$__privateAdd(this, $782726c034562d46$var$_mitt3, (0, $fRyfD.default)());
        /**
     * Subscribe to events
     */ $782726c034562d46$var$__publicField(this, "events", {
            on: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).on,
            off: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).off
        });
        $782726c034562d46$var$__publicField(this, "storage");
        var _a, _b, _c;
        const { manifest: manifest, ...storageOptions } = options;
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_state, {});
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_plugins, options.plugins);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_requireConsentForPersonalization, options.requireConsentForPersonalization);
        if (typeof options.transitionStore !== "undefined") $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_commands, []);
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_personalizationSelectionAlgorithms, {
            [$782726c034562d46$export$efd6c1637cd82656]: $782726c034562d46$export$f13d97b099918517,
            [$782726c034562d46$export$ce3f85c28255a924]: $782726c034562d46$export$8fe83c41c03855ce
        });
        (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins)) == null || _a.forEach((plugin)=>{
            if (!plugin.personalizationSelectionAlgorithms) return;
            $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_personalizationSelectionAlgorithms, {
                ...$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_personalizationSelectionAlgorithms),
                ...plugin.personalizationSelectionAlgorithms
            });
        });
        (_b = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins)) == null || _b.forEach((plugin)=>{
            if (!plugin.logDrain) return;
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).on("log", plugin.logDrain);
        });
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
            "info",
            1,
            "GROUP"
        ]);
        try {
            this.manifest = new $782726c034562d46$export$81c30d905c4c020a({
                onLogMessage: (message)=>$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", message),
                manifest: manifest,
                evaluator: new $782726c034562d46$export$6bde52a42da7459e({
                    CK: $782726c034562d46$export$553ac20321cc9418,
                    QS: $782726c034562d46$export$64a97b0a16f13000,
                    QK: $782726c034562d46$export$dff13ab74686b498,
                    PVC: $782726c034562d46$export$1a758c98b73fe710,
                    EVT: $782726c034562d46$export$879d92bf88c68af3,
                    PV: $782726c034562d46$export$67422e249549a799
                })
            });
            this.storage = new $782726c034562d46$export$c5f10ecc4ea3df13({
                ...storageOptions,
                manifest: this.manifest,
                onServerTransitionReceived: (state)=>{
                    $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_serverTransitionState, state);
                    if (state.ssv) {
                        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_scores, state.ssv);
                        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                            "debug",
                            130,
                            state
                        ]);
                    }
                    if (state.compositionMetadata) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata = state.compositionMetadata;
                },
                onLogMessage: (message)=>$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", message)
            });
            this.storage.events.on("scoresUpdated", $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$updateComputedScores_fn).bind(this));
            if (!$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState)) $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$updateComputedScores_fn).call(this, this.storage.data);
            this.storage.events.on("quirksUpdated", (quirks)=>{
                const updates = this.manifest.computeSignals({
                    scores: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_scores),
                    state: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state),
                    previousState: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state),
                    visitor: this.storage.data
                });
                $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$updateGoals_fn).call(this, {
                    quirks: quirks.quirks,
                    scores: void 0
                });
                this.storage.updateData(updates);
                $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("quirksUpdated", quirks.quirks);
                $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                    "info",
                    4,
                    quirks.quirks
                ]);
            });
            (_c = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins)) == null || _c.forEach((plugin)=>{
                if (!plugin.init) return;
                plugin.init(this);
            });
        } finally{
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                "info",
                1,
                "ENDGROUP"
            ]);
        }
        if (typeof window !== "undefined") window.__UNIFORM_CONTEXTUAL_EDITING_CONTEXT__ = this;
    }
    /** Gets the current visitor's dimension score vector. */ get scores() {
        return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_scores);
    }
    /** Gets the current visitor's quirks values. */ get quirks() {
        var _a, _b;
        return (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState)) == null ? void 0 : _a.quirks) != null ? _b : this.storage.data.quirks;
    }
    get requireConsentForPersonalization() {
        return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_requireConsentForPersonalization);
    }
    /**
   * Updates the Context with new data of any sort, such as
   * new URLs, cookies, quirks, and enrichments.
   *
   * Only properties that are set in the data parameter will be updated,
   * for example if passing `url` but not `cookies`, the last known state of cookies will be preserved.
   *
   * Properties that do not result in a changed state,
   * i.e. pushing the same URL or cookies as before,
   * will NOT result in a recomputation of signal state.
   */ async update(newData) {
        var _a, _b, _c, _d, _e;
        const commands = [];
        const newServerSideTests = {};
        if ((_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState)) == null ? void 0 : _a.quirks) newData = {
            ...newData,
            quirks: {
                ...$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState).quirks,
                ...newData.quirks || {}
            }
        };
        if ((_b = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState)) == null ? void 0 : _b.tests) {
            const testEntries = Object.entries($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState).tests);
            if (testEntries.length > 0) {
                const validTests = [];
                testEntries.forEach(([testName, testVariantId])=>{
                    if (!this.storage.data.tests[testName]) {
                        validTests.push([
                            testName,
                            testVariantId
                        ]);
                        newServerSideTests[testName] = testVariantId;
                    }
                });
                commands.push(...validTests.map(([key, value])=>({
                        type: "settest",
                        data: {
                            test: key,
                            variant: value
                        }
                    })));
            }
        }
        if ((_c = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState)) == null ? void 0 : _c.personalizeVariants) Object.keys($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState).personalizeVariants).forEach((personalizationName)=>{
            const variants = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState).personalizeVariants[personalizationName];
            variants.forEach((e)=>{
                commands.push({
                    type: "setpersonalizecontrol",
                    data: {
                        personlizationName: personalizationName,
                        index: e.index,
                        control: e.control
                    }
                });
            });
        });
        try {
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                "info",
                2,
                "GROUP",
                {
                    ...newData,
                    // need to convert url to string so it can be json serialized
                    // to go over postMessage to chrome extension
                    url: (_d = newData.url) == null ? void 0 : _d.toString()
                }
            ]);
            if (newData.quirks) commands.push(...Object.entries(newData.quirks).map(([key, value])=>({
                    type: "setquirk",
                    data: {
                        key: key,
                        value: value
                    }
                })));
            if (newData.enrichments) newData.enrichments.forEach((enrichment)=>{
                const dimension = $782726c034562d46$export$2c42873b49b6d99e(enrichment.cat, enrichment.key);
                const dimData = this.manifest.getDimensionByKey(dimension);
                if (dimData) commands.push({
                    type: "modscore",
                    data: {
                        dimension: dimension,
                        delta: enrichment.str
                    }
                });
                else $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                    "warn",
                    5,
                    enrichment
                ]);
            });
            const effectiveNewStateForSignalComputation = {
                ...$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state),
                ...newData
            };
            commands.push(...this.manifest.computeSignals({
                state: effectiveNewStateForSignalComputation,
                previousState: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state),
                visitor: this.storage.data,
                // re-compute using scores from storage instead of the current scores since
                // server transition scores might have adjusted values already integrated into them,
                // which causes issues when you are near limits.
                scores: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState) ? $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$calculateScores_fn).call(this, this.storage.data) : $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_scores)
            }));
            const previousCompositionMetadata = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata;
            $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_state, {
                ...$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state),
                ...newData
            });
            if (newData.compositionMetadata && // deep equal is not too bad, as we only have 1 level of depth in dynamic inputs
            !(0, $hT7VS.dequal)(previousCompositionMetadata, $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata)) {
                $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("canvasDataUpdated", $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata);
                $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata = newData.compositionMetadata;
            }
            await this.storage.updateData(commands);
            if ($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState)) {
                await this.processServerCommands({
                    serverCommands: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState).commands,
                    commands: commands
                });
                $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$updateComputedScores_fn).call(this, this.storage.data);
                Object.entries(newServerSideTests).forEach(([testName, testVariantId])=>{
                    $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$emitTest_fn).call(this, {
                        name: testName,
                        variantId: testVariantId,
                        variantAssigned: true,
                        control: false,
                        compositionMetadata: void 0
                    });
                });
                const haveQuirksChanged = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState) && !(0, $hT7VS.dequal)($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState).quirks, this.storage.data.quirks);
                $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_serverTransitionState, void 0);
                if (haveQuirksChanged) $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("quirksUpdated", this.storage.data.quirks);
                $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                    "debug",
                    131
                ]);
            }
            if ($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins)) for(let i = 0; i < $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins).length; i++){
                const plugin = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins)[i];
                if (!plugin.update) continue;
                await plugin.update(newData, $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_scores));
            }
            (_e = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_commands)) == null || _e.push(...commands);
        } finally{
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                "info",
                2,
                "ENDGROUP"
            ]);
        }
    }
    async processServerCommands({ serverCommands: serverCommands, commands: commands }) {
        if (!(serverCommands == null ? void 0 : serverCommands.length)) return;
        const notExecutedCommands = [];
        serverCommands.forEach((serverCommand)=>{
            const found = commands.find((command)=>{
                return $782726c034562d46$export$5b2e75712457a278(command, serverCommand);
            });
            if (!found) notExecutedCommands.push(serverCommand);
        });
        if (notExecutedCommands.length > 0) await this.storage.updateData(notExecutedCommands);
    }
    /** use test() instead */ getTestVariantId(testName) {
        var _a, _b, _c, _d;
        const definition = this.manifest.getTest(testName);
        if (!definition) {
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                "warn",
                401,
                testName
            ]);
            return null;
        }
        return (_d = (_c = definition.wv) != null ? _c : (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState)) == null ? void 0 : _a.tests) == null ? void 0 : _b[testName]) != null ? _d : this.storage.data.tests[testName];
    }
    /** use test() instead */ setTestVariantId(testName, variantId) {
        this.storage.updateData([
            {
                type: "settest",
                data: {
                    test: testName,
                    variant: variantId
                }
            }
        ]);
    }
    getPersonalizeVariantControl(name, index) {
        var _a, _b, _c;
        const source = (_b = (_a = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_serverTransitionState)) == null ? void 0 : _a.personalizeVariants) != null ? _b : this.storage.data.personalizeVariants;
        const variants = (_c = source == null ? void 0 : source[name]) != null ? _c : [];
        const variant = variants.find((v)=>v.index === index);
        return variant == null ? void 0 : variant.control;
    }
    /**
   * Writes a message to the Context log sink.
   * Used by Uniform internal SDK; not intended for public use.
   */ log(...message) {
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", message);
    }
    /** Executes an A/B test with a given set of variants, showing the visitor's assigned variant (or selecting one to assign, if none is set yet) */ test(options) {
        var _a, _b, _c, _d, _e;
        if (options.name === $782726c034562d46$export$b15e673925ba7c38) {
            const selectedVariant = (_a = options.variations.find((variant)=>variant.id === $782726c034562d46$export$44a1eab28c32d319)) != null ? _a : options.variations.at(-1);
            const value2 = {
                result: selectedVariant,
                variantAssigned: false
            };
            return value2;
        }
        const value = $782726c034562d46$export$9a62a55bdb8657f2({
            ...options,
            context: this,
            onLogMessage: (message)=>$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", message)
        });
        $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$emitTest_fn).call(this, {
            name: options.name,
            variantId: (_c = (_b = value.result) == null ? void 0 : _b.id) != null ? _c : void 0,
            variantAssigned: value.variantAssigned,
            control: (_e = (_d = value.result) == null ? void 0 : _d.control) != null ? _e : false,
            compositionMetadata: options.compositionMetadata
        });
        return value;
    }
    /** Executes a personalized placement with a given set of variants */ personalize(options) {
        var _a;
        const algorithmName = (_a = options.algorithm) != null ? _a : $782726c034562d46$export$efd6c1637cd82656;
        const algorithm = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_personalizationSelectionAlgorithms)[algorithmName];
        if (!algorithm) {
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                "warn",
                304,
                {
                    algorithm: algorithmName
                }
            ]);
            return {
                personalized: false,
                variations: []
            };
        }
        const value = algorithm({
            ...options,
            context: this,
            onLogMessage: (message)=>$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", message)
        });
        const previousPlacement = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_pzCache)[options.name];
        const eventData = {
            name: options.name,
            variantIds: value.variations.map((variation)=>({
                    id: variation.id || "Unknown",
                    control: variation.control
                })),
            control: this.storage.data.controlGroup,
            changed: true,
            compositionMetadata: options.compositionMetadata
        };
        if (previousPlacement && (0, $hT7VS.dequal)(eventData.variantIds, previousPlacement)) eventData.changed = false;
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("personalizationResult", eventData);
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_pzCache)[options.name] = eventData.variantIds;
        return value;
    }
    /**
   * Forgets the visitor's data and resets the Context to its initial state.
   * @param fromAllDevices for an identified user, whether to delete all their data (for the entire account) - true, or data for this device (sign out) - false
   */ async forget(fromAllDevices) {
        const previousCompositionMetadata = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata;
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_state, {
            compositionMetadata: previousCompositionMetadata
        });
        if ($782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins)) for(let i = 0; i < $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins).length; i++){
            const plugin = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_plugins)[i];
            if (!plugin.forget) continue;
            await plugin.forget();
        }
        await this.storage.delete(fromAllDevices);
    }
    /**
   * Computes server to client transition state.
   *
   * Removes state from server-to-client if it came in initial state (cookies) to avoid double tracking on the client.
   */ getServerToClientTransitionState() {
        const transitionState = {
            quirks: this.storage.data.quirks,
            ssv: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_scores),
            tests: {},
            personalizeVariants: this.storage.data.personalizeVariants,
            commands: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_commands),
            compositionMetadata: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata
        };
        const allTests = this.storage.data.tests;
        Object.entries(allTests).map(([testName, testValue])=>{
            var _a, _b, _c;
            if (((_c = (_b = (_a = this.storage.options.transitionStore) == null ? void 0 : _a.initialData) == null ? void 0 : _b.tests) == null ? void 0 : _c[testName]) !== allTests[testName] && transitionState.tests) transitionState.tests[testName] = testValue;
        });
        return transitionState;
    }
    /** @deprecated */ internal_processTestEvent(event) {
        if (event.variantId) {
            this.setTestVariantId(event.name, event.variantId);
            $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$emitTest_fn).call(this, event);
        }
    }
    /** @deprecated */ internal_processPersonalizationEvent(event) {
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_pzCache)[event.name] = event.variantIds;
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("personalizationResult", event);
    }
    /**
   * Gets the current canvas data
   */ getCompositionMetadata() {
        return $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata;
    }
    /**
   * Updates the canvas data and emits a canvasDataUpdated event
   */ async updateCompositionMetadata(newData) {
        const currentCanvas = $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state).compositionMetadata || {};
        const updatedCanvas = {
            ...currentCanvas,
            ...newData
        };
        if (!(0, $hT7VS.dequal)(currentCanvas, updatedCanvas)) {
            $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_state, {
                ...$782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_state),
                compositionMetadata: updatedCanvas
            });
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("canvasDataUpdated", updatedCanvas);
            $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
                "info",
                4,
                "Canvas data updated"
            ]);
        }
    }
};
$782726c034562d46$var$_personalizationSelectionAlgorithms = new WeakMap();
$782726c034562d46$var$_serverTransitionState = new WeakMap();
$782726c034562d46$var$_scores = new WeakMap();
$782726c034562d46$var$_state = new WeakMap();
$782726c034562d46$var$_pzCache = new WeakMap();
$782726c034562d46$var$_plugins = new WeakMap();
$782726c034562d46$var$_commands = new WeakMap();
$782726c034562d46$var$_requireConsentForPersonalization = new WeakMap();
$782726c034562d46$var$_mitt3 = new WeakMap();
$782726c034562d46$var$_Context_instances = new WeakSet();
$782726c034562d46$var$emitTest_fn = function(event) {
    $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("testResult", event);
};
$782726c034562d46$var$updateGoals_fn = async function(data) {
    const goalCommands = this.manifest.computeGoals(data);
    if (goalCommands.length !== 0) await this.storage.updateData(goalCommands);
};
$782726c034562d46$var$updateComputedScores_fn = function(newData) {
    const newScores = $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$calculateScores_fn).call(this, newData);
    const newScoresHaveChanged = !(0, $hT7VS.dequal)(newScores, $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_scores));
    if (newScoresHaveChanged) {
        $782726c034562d46$var$__privateSet(this, $782726c034562d46$var$_scores, newScores);
        $782726c034562d46$var$__privateMethod(this, $782726c034562d46$var$_Context_instances, $782726c034562d46$var$updateGoals_fn).call(this, {
            scores: $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_scores),
            quirks: void 0
        });
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("scoresUpdated", newScores);
        $782726c034562d46$var$__privateGet(this, $782726c034562d46$var$_mitt3).emit("log", [
            "info",
            3,
            newScores
        ]);
    }
};
$782726c034562d46$var$calculateScores_fn = function(newData) {
    var _a;
    let newScores = {
        ...newData.scores
    };
    for(const session in newData.sessionScores)newScores[session] = ((_a = newScores[session]) != null ? _a : 0) + newData.sessionScores[session];
    newScores = this.manifest.computeAggregateDimensions(newScores);
    return newScores;
};
// src/devTools/enableContextDevTools.ts
var $782726c034562d46$var$isBrowser = typeof top !== "undefined";
function $782726c034562d46$export$112124b73aff4465(options) {
    return {
        logDrain: (message)=>{
            if (!$782726c034562d46$var$isBrowser) return;
            top == null || top.postMessage({
                type: "uniform:context:log",
                message: message
            }, window.location.origin);
        },
        init: (context)=>{
            const personalizations = [];
            const tests = [];
            const onContextDataUpdated = ()=>{
                if (!$782726c034562d46$var$isBrowser) return;
                top == null || top.postMessage({
                    type: "uniform:context:data",
                    data: {
                        scores: context.scores,
                        data: context.storage.data,
                        manifest: context.manifest.data,
                        personalizations: personalizations,
                        tests: tests
                    }
                }, window.location.origin);
            };
            const onPersonalizationResult = (e)=>{
                if (!e.changed) return;
                personalizations.push(e);
            };
            const onTestResult = (e)=>{
                if (!e.variantAssigned) return;
                tests.push(e);
            };
            if ($782726c034562d46$var$isBrowser) {
                window.__UNIFORM_DEVTOOLS_CONTEXT_INSTANCE__ = context;
                try {
                    top == null || top.addEventListener("message", async (event)=>{
                        if (!event.data) return;
                        const message = event.data;
                        await $782726c034562d46$var$handleMessageFromDevTools({
                            message: message,
                            context: context,
                            afterMessageReceived: options == null ? void 0 : options.onAfterMessageReceived
                        });
                    });
                } catch (e) {
                    console.warn("Unable to initialize Uniform Context DevTools because it is in a cross-domain iframe.", e);
                }
                top == null || top.postMessage({
                    type: "uniform:context:hello",
                    uiVersion: 2
                }, window.location.origin);
                onContextDataUpdated();
            }
            context.events.on("personalizationResult", onPersonalizationResult);
            context.events.on("testResult", onTestResult);
            context.events.on("scoresUpdated", onContextDataUpdated);
            return ()=>{
                context.events.off("scoresUpdated", onContextDataUpdated);
                context.events.off("personalizationResult", onPersonalizationResult);
                context.events.off("testResult", onTestResult);
            };
        }
    };
}
async function $782726c034562d46$var$handleMessageFromDevTools({ message: message, context: context, afterMessageReceived: afterMessageReceived }) {
    let receivedUniformMessage = false;
    if (message.type === "uniform-in:context:update" && message.newData) {
        receivedUniformMessage = true;
        await context.update(message.newData);
    }
    if (message.type === "uniform-in:context:commands" && message.commands && Array.isArray(message.commands)) {
        receivedUniformMessage = true;
        await context.storage.updateData(message.commands);
    }
    if (message.type === "uniform-in:context:forget") {
        receivedUniformMessage = true;
        await context.forget(false);
    }
    if (receivedUniformMessage && typeof afterMessageReceived === "function") afterMessageReceived(message);
}
// src/edge/index.ts
var $782726c034562d46$export$e8f788122ce44497 = /* @__PURE__ */ ((ScriptType2)=>{
    ScriptType2["ListStart"] = "nesi-list-start";
    ScriptType2["ListEnd"] = "nesi-list-end";
    ScriptType2["ListItem"] = "nesi-list-item-html";
    ScriptType2["ListItemSettings"] = "nesi-list-item-settings";
    ScriptType2["TestStart"] = "nesi-test-start";
    ScriptType2["TestEnd"] = "nesi-test-end";
    ScriptType2["Unknown"] = "unknown";
    return ScriptType2;
})($782726c034562d46$export$e8f788122ce44497 || {});
var $782726c034562d46$export$56c1ae559875bab5 = "nesitag";
// src/insights/storage.ts
var $782726c034562d46$var$createInsightsStorage = ()=>{
    const STORAGE_KEY2 = "ufin";
    return {
        get: ()=>{
            const data = localStorage.getItem(STORAGE_KEY2);
            if (!data) return;
            return JSON.parse(data);
        },
        set: (data)=>{
            const toSet = {
                ...data,
                updated: Date.now()
            };
            localStorage.setItem(STORAGE_KEY2, JSON.stringify(toSet));
        },
        clear: ()=>{
            localStorage.removeItem(STORAGE_KEY2);
        }
    };
};
// src/insights/types.ts
var $782726c034562d46$var$getBasePayload = ()=>{
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locale = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || "en";
    return {
        "user-agent": window.navigator.userAgent,
        locale: locale,
        location: timeZone,
        referrer: document.referrer,
        pathname: window.location.pathname,
        href: window.location.href
    };
};
var $782726c034562d46$var$generateVisitorId = ()=>{
    return `visitor_${$782726c034562d46$var$generalRandomId()}`;
};
var $782726c034562d46$var$generateSessionId = ()=>{
    return `session_${$782726c034562d46$var$generalRandomId()}`;
};
var $782726c034562d46$var$generatePageId = ()=>{
    return `page_${$782726c034562d46$var$generalRandomId()}`;
};
var $782726c034562d46$var$generalRandomId = ()=>{
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        const id = crypto.randomUUID();
        return id.replaceAll("-", "").toLowerCase();
    }
    return Math.random().toString(32).substring(2);
};
// src/insights/v1.ts
var $782726c034562d46$var$createInsightsClient = ({ endpoint: endpoint })=>{
    let endpointUrl;
    const apiKey = endpoint.apiKey;
    const projectId = endpoint.projectId;
    if (endpoint.type === "api") {
        const url = new URL(endpoint.host);
        url.pathname = `/v0/events`;
        if (endpoint.host.includes("tinybird.co")) url.pathname = "/v0/events";
        url.searchParams.set("name", "analytics_events");
        endpointUrl = url.toString();
    } else endpointUrl = endpoint.path;
    const sendMessage = async (message)=>{
        if (typeof window.__UNIFORM_CONTEXTUAL_EDITING__ !== "undefined") return;
        const converted = {
            ...message,
            payload: JSON.stringify(message.payload)
        };
        const headers = {
            "Content-Type": "application/json"
        };
        if (apiKey) headers.Authorization = `Bearer ${apiKey}`;
        const response = await fetch(endpointUrl, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(converted)
        });
        const json = await response.json();
        return json;
    };
    return {
        sessionStart: (options)=>{
            const message = {
                action: "session_start",
                version: "1",
                session_id: options.sessionId,
                visitor_id: options.visitorId,
                page_view_id: options.pageId,
                timestamp: /* @__PURE__ */ new Date().toISOString(),
                project_id: projectId,
                payload: {
                    ...$782726c034562d46$var$getBasePayload(),
                    previous_session_id: options.previousSessionId
                }
            };
            return sendMessage(message);
        },
        pageHit: (options)=>{
            const message = {
                action: "page_hit",
                version: "1",
                session_id: options.sessionId,
                visitor_id: options.visitorId,
                page_view_id: options.pageId,
                timestamp: /* @__PURE__ */ new Date().toISOString(),
                project_id: projectId,
                payload: $782726c034562d46$var$getBasePayload()
            };
            return sendMessage(message);
        },
        testResult: async (options)=>{
            const message = {
                action: "test_result",
                version: "1",
                session_id: options.sessionId,
                visitor_id: options.visitorId,
                page_view_id: options.pageId,
                timestamp: /* @__PURE__ */ new Date().toISOString(),
                project_id: projectId,
                payload: {
                    ...$782726c034562d46$var$getBasePayload(),
                    ...options
                }
            };
            return sendMessage(message);
        },
        personalizationResult: async (options)=>{
            const messages = options.variantIds.map((variant)=>{
                const message = {
                    action: "personalization_result",
                    version: "1",
                    session_id: options.sessionId,
                    visitor_id: options.visitorId,
                    page_view_id: options.pageId,
                    timestamp: /* @__PURE__ */ new Date().toISOString(),
                    project_id: projectId,
                    payload: {
                        ...$782726c034562d46$var$getBasePayload(),
                        name: options.name,
                        variantId: variant.id,
                        control: variant.control || options.control,
                        changed: options.changed
                    }
                };
                return message;
            });
            await Promise.all(messages.map((message)=>sendMessage(message)));
        },
        goalConvert: (options)=>{
            const message = {
                action: "goal_convert",
                version: "1",
                session_id: options.sessionId,
                visitor_id: options.visitorId,
                page_view_id: options.pageId,
                timestamp: /* @__PURE__ */ new Date().toISOString(),
                project_id: projectId,
                payload: {
                    ...$782726c034562d46$var$getBasePayload(),
                    goalId: options.goalId
                }
            };
            return sendMessage(message);
        },
        scoresChange: async (options)=>{
            const message = {
                action: "scores_change",
                version: "1",
                session_id: options.sessionId,
                visitor_id: options.visitorId,
                page_view_id: options.pageId,
                timestamp: /* @__PURE__ */ new Date().toISOString(),
                project_id: projectId,
                payload: {
                    ...$782726c034562d46$var$getBasePayload(),
                    scores: options.scores
                }
            };
            return sendMessage(message);
        }
    };
};
var $782726c034562d46$var$createInsightsV1 = ({ endpoint: endpoint, sessionDurationSeconds: sessionDurationSeconds = 1800 })=>{
    const client = $782726c034562d46$var$createInsightsClient({
        endpoint: endpoint
    });
    const storage = $782726c034562d46$var$createInsightsStorage();
    let storageData = void 0;
    let pageId = $782726c034562d46$var$generatePageId();
    let previousUrl = void 0;
    return {
        init: ()=>{
            storageData = storage.get();
            if (!storageData || Date.now() - storageData.updated > sessionDurationSeconds * 1e3) {
                const previousSessionId = storageData == null ? void 0 : storageData.sessionId;
                storageData = {
                    visitorId: (storageData == null ? void 0 : storageData.visitorId) || $782726c034562d46$var$generateVisitorId(),
                    sessionId: $782726c034562d46$var$generateSessionId(),
                    updated: Date.now()
                };
                storage.set(storageData);
                client.sessionStart({
                    visitorId: storageData.visitorId,
                    sessionId: storageData.sessionId,
                    previousSessionId: previousSessionId,
                    maxAgeSeconds: sessionDurationSeconds,
                    pageId: pageId
                });
            } else if (storageData) storage.set(storageData);
        },
        pageHit: ()=>{
            if (!storageData) return;
            if (previousUrl === window.location.href) return;
            previousUrl = window.location.href;
            pageId = $782726c034562d46$var$generatePageId();
            client.pageHit({
                visitorId: storageData.visitorId,
                sessionId: storageData.sessionId,
                pageId: pageId
            });
        },
        testResult: (result)=>{
            if (!storageData) return;
            client.testResult({
                ...result,
                visitorId: storageData.visitorId,
                sessionId: storageData.sessionId,
                pageId: pageId
            });
        },
        personalizationResult: (result)=>{
            if (!storageData) return;
            client.personalizationResult({
                ...result,
                visitorId: storageData.visitorId,
                sessionId: storageData.sessionId,
                pageId: pageId
            });
        },
        goalConvert: (goalId)=>{
            if (!storageData) return;
            client.goalConvert({
                visitorId: storageData.visitorId,
                sessionId: storageData.sessionId,
                goalId: goalId,
                pageId: pageId
            });
        },
        scoresChange: (scores)=>{
            if (!storageData) return;
            client.scoresChange({
                visitorId: storageData.visitorId,
                sessionId: storageData.sessionId,
                scores: scores,
                pageId: pageId
            });
        },
        forget: ()=>{
            storage.clear();
            storageData = void 0;
        },
        get sessionId () {
            return storageData == null ? void 0 : storageData.sessionId;
        }
    };
};
// src/insights/index.ts
var $782726c034562d46$export$b01ab7abe346520c = (options)=>{
    const insights = $782726c034562d46$var$createInsightsV1({
        endpoint: options.endpoint
    });
    let previousUrl = void 0;
    return {
        init: (context)=>{
            if (typeof window === "undefined") return ()=>{};
            const consentChanged = ()=>{
                if (context.storage.data.consent) insights.init();
                else insights.forget();
            };
            const handlePersonalizationResult = (data)=>{
                insights.personalizationResult(data);
            };
            const handleTestResult = (result)=>{
                insights.testResult(result);
            };
            const handleGoalConvert = (result)=>{
                insights.goalConvert(result.goalId);
            };
            const handleScoreChange = (scores)=>{
                insights.scoresChange(scores);
            };
            context.storage.events.on("goalConverted", handleGoalConvert);
            context.storage.events.on("consentUpdated", consentChanged);
            context.events.on("personalizationResult", handlePersonalizationResult);
            context.events.on("testResult", handleTestResult);
            context.events.on("scoresUpdated", handleScoreChange);
            if (context.storage.data.consent) consentChanged();
            return ()=>{
                context.storage.events.off("consentUpdated", consentChanged);
                context.storage.events.off("goalConverted", handleGoalConvert);
                context.events.off("personalizationResult", handlePersonalizationResult);
                context.events.off("testResult", handleTestResult);
                context.events.off("scoresUpdated", handleScoreChange);
            };
        },
        update: (context)=>{
            if (context.url && context.url.toString() !== previousUrl) {
                previousUrl = context.url.toString();
                insights.pageHit();
            }
        },
        forget: ()=>{
            insights.forget();
        }
    };
};
// src/logging/isEnabled.ts
function $782726c034562d46$var$isEnabled(level, severity) {
    if (level === "none") return false;
    switch(severity){
        case "debug":
            return level === "debug";
        case "info":
            return level === "info" || level === "debug";
        case "warn":
            return level === "warn" || level === "info" || level === "debug";
        case "error":
            return level === "debug" || "info";
        default:
            return false;
    }
}
// src/logging/enableConsoleLogDrain.ts
var $782726c034562d46$var$dc = (0, (/*@__PURE__*/$parcel$interopDefault($kH2vB)))();
function $782726c034562d46$export$57af89bbc18f3a00(level) {
    return ([severity, ...other])=>{
        if (!$782726c034562d46$var$isEnabled(level, severity)) return;
        const [id, ...params] = other;
        console[severity](`\u{1F94B} [${severity}] Uniform event ID ${id}
`, ...params.map($782726c034562d46$var$dc));
    };
}
function $782726c034562d46$export$bbc876cc2a256925(level) {
    const consoleLogDrain = $782726c034562d46$export$57af89bbc18f3a00(level);
    return {
        logDrain: consoleLogDrain
    };
}
// src/logging/messageContent.ts
var $782726c034562d46$var$messageContent = {
    // CONTEXT
    1: ()=>[
            "context",
            "initializing Uniform Context"
        ],
    2: (update)=>[
            "context",
            "received update()",
            update
        ],
    3: (scores)=>[
            "context",
            "new score vector",
            scores
        ],
    4: (quirks)=>[
            "context",
            "updated quirks",
            quirks
        ],
    5: (enrichment)=>[
            "context",
            "ignored enrichment update for unknown enrichment category",
            enrichment.cat
        ],
    // STORAGE
    101: (commands)=>[
            "storage",
            "received update commands",
            commands
        ],
    102: (data)=>[
            "storage",
            "data was updated",
            data
        ],
    103: (fromAllDevices)=>[
            "storage",
            `deleting visitor data ${fromAllDevices ? "from all devices" : "from this device"}`
        ],
    104: (isControl)=>[
            "context",
            isControl ? "Visitor assigned to personalization control group" : "Visitor assigned to personalization experiment group"
        ],
    110: ({ dim: dim, cap: cap, score: score })=>[
            "storage",
            `${dim} score ${score} exceeded cap ${cap}. Rounded down.`
        ],
    120: ()=>[
            "storage",
            "visitor data expired and was cleared"
        ],
    130: (data)=>[
            "storage",
            "server to client transition score data was loaded; it will persist until the next update event occurs",
            data
        ],
    131: ()=>[
            "storage",
            "server to client transition data was discarded"
        ],
    140: (decayMessage)=>[
            "storage",
            `score decay was applied: ${decayMessage}`
        ],
    // SIGNAL EVAL
    200: ()=>[
            "signals",
            "evaluating signals"
        ],
    201: (signal)=>[
            "signals",
            `evaluating signal ${signal.id} (${signal.dur})`
        ],
    202: (group)=>[
            "signals",
            group.op === "|" ? "OR" : "AND"
        ],
    203: ({ criteria: criteria, result: result, explanation: explanation })=>[
            "signals",
            `${criteria.type}: ${explanation} is ${result.result} [${result.changed ? "CHANGED" : "unchanged"}]`
        ],
    204: (result)=>[
            "signals",
            `group result: ${result.result} [${result.changed ? "CHANGED" : "unchanged"}]`
        ],
    // PERSONALIZATION
    300: (placement)=>[
            "personalization",
            `executing personalization '${placement.name}'`
        ],
    301: ({ id: id, op: op })=>[
            "personalization",
            `testing variation ${id} (${op === "|" ? "OR" : "AND"})`
        ],
    302: ({ matched: matched, description: description })=>[
            "personalization",
            `${description} is ${matched}`
        ],
    303: (selected)=>[
            "personalization",
            selected ? "selected variation" : "did not select variation"
        ],
    304: ({ algorithm: algorithm })=>[
            "personalization",
            `personalization selection algorithm '${algorithm}' not found. Hiding placement.`
        ],
    // TESTING
    400: (name)=>[
            "testing",
            `executing A/B test '${name}'`
        ],
    401: (testName)=>[
            "testing",
            `${testName} is not registered in the manifest; it will not be run.`
        ],
    402: ({ missingVariant: missingVariant, variants: variants })=>[
            "testing",
            `test variation '${missingVariant}' previously assigned to the visitor for this test no longer exists as a variant. It will be removed. This may indicate changing test variations after publishing a test, which will make results invalid. Known variants: ${variants.join(", ")}`
        ],
    403: (variant)=>[
            "testing",
            `assigned new test variant '${variant}'`
        ],
    404: (variant)=>[
            "testing",
            `displaying variation '${variant}'`
        ],
    // GTAG
    700: ()=>[
            "gtag",
            "gtag is not defined, skipping analytics event emission. Ensure you have added the gtag script to your page."
        ],
    701: ()=>[
            "gtag",
            "enabled gtag event signal redirection"
        ]
};
// src/logging/enableDebugConsoleLogDrain.ts
var $782726c034562d46$var$dc2 = (0, (/*@__PURE__*/$parcel$interopDefault($kH2vB)))();
function $782726c034562d46$export$730ec0c8d15f768d(level, options) {
    const isServer = typeof document === "undefined";
    const { enableOnServer: enableOnServer = false } = options != null ? options : {};
    return ([severity, ...other])=>{
        if (!$782726c034562d46$var$isEnabled(level, severity) || isServer && !enableOnServer) return;
        const [id, ...params] = other;
        let consoleFunc = console[severity];
        if (params[0] === "GROUP") {
            params.shift();
            consoleFunc = console.groupCollapsed;
        }
        if (params[0] === "ENDGROUP") {
            console.groupEnd();
            return;
        }
        const messageFunc = $782726c034562d46$var$messageContent[id];
        let icon = "";
        switch(severity){
            case "debug":
                icon = "\uD83D\uDC1E";
                break;
            case "info":
                icon = "\uD83D\uDCAC";
                break;
            case "warn":
                icon = "\u26A0\uFE0F";
                break;
            case "error":
                icon = "\uD83D\uDCA5";
                break;
        }
        const messagePrefix = icon;
        if (!messageFunc) {
            consoleFunc(`${messagePrefix} unknown event ID ${id}. Log messages data may be older than Uniform Context package.`, ...params);
            return;
        }
        const [category, messageBody, ...outParams] = messageFunc(...params);
        consoleFunc(`${messagePrefix}[${category}] ${messageBody}
`, ...outParams.map($782726c034562d46$var$dc2));
    };
}
function $782726c034562d46$export$cae879b97e37c0b1(level, options) {
    const debugConsoleLogDrain = $782726c034562d46$export$730ec0c8d15f768d(level, options);
    return {
        logDrain: debugConsoleLogDrain
    };
}
// src/quickconnect/quickconnect.ts
function $782726c034562d46$export$70c49583f4429a8f(config) {
    return `${config.apiKey}|${config.projectId}${config.apiHost ? `|${config.apiHost}` : ""}`;
}
function $782726c034562d46$export$f8700d487c9c4d9e(serialized) {
    const [apiKey, projectId, apiHost] = serialized.split("|");
    if (!apiKey.startsWith("uf")) throw new Error("Invalid API key");
    if (!/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i.test(projectId)) throw new Error("Invalid project ID");
    return {
        apiKey: apiKey,
        projectId: projectId,
        apiHost: apiHost || "https://uniform.app"
    };
}

});
parcelRegister("hT7VS", function(module, exports) {
$parcel$export(module.exports, "dequal", function () { return $d05db9ee8365f3ed$export$de8294bb3be0322f; });
var $d05db9ee8365f3ed$var$has = Object.prototype.hasOwnProperty;
function $d05db9ee8365f3ed$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $d05db9ee8365f3ed$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($d05db9ee8365f3ed$var$has.call(foo, ctor) && ++len && !$d05db9ee8365f3ed$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$d05db9ee8365f3ed$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});

parcelRegister("fRyfD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8c65fd29c6c043f$export$2e2bcd8739ae039; });
function $b8c65fd29c6c043f$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}

});

parcelRegister("kH2vB", function(module, exports) {

var $567QU = parcelRequire("567QU");
var $f109c4f73577f1de$require$Buffer = $567QU.Buffer;
'use strict';
module.exports = $f109c4f73577f1de$var$rfdc;
function $f109c4f73577f1de$var$copyBuffer(cur) {
    if (cur instanceof $f109c4f73577f1de$require$Buffer) return $f109c4f73577f1de$require$Buffer.from(cur);
    return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
}
function $f109c4f73577f1de$var$rfdc(opts) {
    opts = opts || {};
    if (opts.circles) return $f109c4f73577f1de$var$rfdcCircles(opts);
    const constructorHandlers = new Map();
    constructorHandlers.set(Date, (o)=>new Date(o));
    constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
    constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
    if (opts.constructorHandlers) for (const handler of opts.constructorHandlers)constructorHandlers.set(handler[0], handler[1]);
    let handler = null;
    return opts.proto ? cloneProto : clone;
    function cloneArray(a, fn) {
        const keys = Object.keys(a);
        const a2 = new Array(keys.length);
        for(let i = 0; i < keys.length; i++){
            const k = keys[i];
            const cur = a[k];
            if (typeof cur !== 'object' || cur === null) a2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
            else if (ArrayBuffer.isView(cur)) a2[k] = $f109c4f73577f1de$var$copyBuffer(cur);
            else a2[k] = fn(cur);
        }
        return a2;
    }
    function clone(o) {
        if (typeof o !== 'object' || o === null) return o;
        if (Array.isArray(o)) return cloneArray(o, clone);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
        const o2 = {};
        for(const k in o){
            if (Object.hasOwnProperty.call(o, k) === false) continue;
            const cur = o[k];
            if (typeof cur !== 'object' || cur === null) o2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
            else if (ArrayBuffer.isView(cur)) o2[k] = $f109c4f73577f1de$var$copyBuffer(cur);
            else o2[k] = clone(cur);
        }
        return o2;
    }
    function cloneProto(o) {
        if (typeof o !== 'object' || o === null) return o;
        if (Array.isArray(o)) return cloneArray(o, cloneProto);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
        const o2 = {};
        for(const k in o){
            const cur = o[k];
            if (typeof cur !== 'object' || cur === null) o2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
            else if (ArrayBuffer.isView(cur)) o2[k] = $f109c4f73577f1de$var$copyBuffer(cur);
            else o2[k] = cloneProto(cur);
        }
        return o2;
    }
}
function $f109c4f73577f1de$var$rfdcCircles(opts) {
    const refs = [];
    const refsNew = [];
    const constructorHandlers = new Map();
    constructorHandlers.set(Date, (o)=>new Date(o));
    constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
    constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
    if (opts.constructorHandlers) for (const handler of opts.constructorHandlers)constructorHandlers.set(handler[0], handler[1]);
    let handler = null;
    return opts.proto ? cloneProto : clone;
    function cloneArray(a, fn) {
        const keys = Object.keys(a);
        const a2 = new Array(keys.length);
        for(let i = 0; i < keys.length; i++){
            const k = keys[i];
            const cur = a[k];
            if (typeof cur !== 'object' || cur === null) a2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
            else if (ArrayBuffer.isView(cur)) a2[k] = $f109c4f73577f1de$var$copyBuffer(cur);
            else {
                const index = refs.indexOf(cur);
                if (index !== -1) a2[k] = refsNew[index];
                else a2[k] = fn(cur);
            }
        }
        return a2;
    }
    function clone(o) {
        if (typeof o !== 'object' || o === null) return o;
        if (Array.isArray(o)) return cloneArray(o, clone);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
        const o2 = {};
        refs.push(o);
        refsNew.push(o2);
        for(const k in o){
            if (Object.hasOwnProperty.call(o, k) === false) continue;
            const cur = o[k];
            if (typeof cur !== 'object' || cur === null) o2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
            else if (ArrayBuffer.isView(cur)) o2[k] = $f109c4f73577f1de$var$copyBuffer(cur);
            else {
                const i = refs.indexOf(cur);
                if (i !== -1) o2[k] = refsNew[i];
                else o2[k] = clone(cur);
            }
        }
        refs.pop();
        refsNew.pop();
        return o2;
    }
    function cloneProto(o) {
        if (typeof o !== 'object' || o === null) return o;
        if (Array.isArray(o)) return cloneArray(o, cloneProto);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
        const o2 = {};
        refs.push(o);
        refsNew.push(o2);
        for(const k in o){
            const cur = o[k];
            if (typeof cur !== 'object' || cur === null) o2[k] = cur;
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
            else if (ArrayBuffer.isView(cur)) o2[k] = $f109c4f73577f1de$var$copyBuffer(cur);
            else {
                const i = refs.indexOf(cur);
                if (i !== -1) o2[k] = refsNew[i];
                else o2[k] = cloneProto(cur);
            }
        }
        refs.pop();
        refsNew.pop();
        return o2;
    }
}

});




parcelRegister("baQEe", function(module, exports) {
$parcel$export(module.exports, "getSoftwarePageProductRecommendation", function () { return $3446645dad0a2ccf$export$65d94be098bf0cc9; });
const $3446645dad0a2ccf$var$categoryOneJobFunctions = [
    'engineering',
    'information technology',
    'customer service',
    'human resources',
    'data science',
    'operations',
    'finance',
    'legal'
];
const $3446645dad0a2ccf$var$categoryTwoJobFunctions = [
    'product management'
];
const $3446645dad0a2ccf$var$categoryThreeJobFunctions = [
    'program management',
    'c-suite',
    'sales',
    'marketing',
    'design',
    'other'
];
// Helper functions for product recommendation logic ========================================================
/**
 * Determines the product ranking order based on job function category
 */ const $3446645dad0a2ccf$var$getRankedProducts = (PRODUCT_LIST, jobFunction)=>{
    if (!jobFunction) // Default: use PRODUCT_LIST order when jobFunction is null
    return [
        ...PRODUCT_LIST
    ];
    if ($3446645dad0a2ccf$var$categoryOneJobFunctions.includes(jobFunction)) // Category One: jira, confluence, jsm, loom, jpd, rovo
    return [
        'jira-software',
        'confluence',
        'jira-servicedesk',
        'loom',
        'jira-product-discovery',
        'rovo.ondemand'
    ];
    if ($3446645dad0a2ccf$var$categoryTwoJobFunctions.includes(jobFunction)) // Category Two: jira, confluence, jpd, loom, rovo, jsm
    return [
        'jira-software',
        'confluence',
        'jira-product-discovery',
        'loom',
        'rovo.ondemand',
        'jira-servicedesk'
    ];
    if ($3446645dad0a2ccf$var$categoryThreeJobFunctions.includes(jobFunction)) // Category Three: jira, confluence, loom, rovo, jpd, jsm
    return [
        'jira-software',
        'confluence',
        'loom',
        'rovo.ondemand',
        'jira-product-discovery',
        'jira-servicedesk'
    ];
    // Fallback: use PRODUCT_LIST order for unknown job functions
    return [
        ...PRODUCT_LIST
    ];
};
/**
 * Applies special handling for Category One: when 1 product is owned,
 * prioritizes rovo over jpd by swapping their positions
 */ const $3446645dad0a2ccf$var$applyCategoryOneSwap = (filteredProductData, jobFunction, normalizedLoggedInProducts)=>{
    const shouldApplySwap = $3446645dad0a2ccf$var$categoryOneJobFunctions.includes(jobFunction || '') && normalizedLoggedInProducts.length === 1 && filteredProductData.length >= 4;
    if (!shouldApplySwap) return;
    const jpdIndex = filteredProductData.indexOf('jira-product-discovery');
    const rovoIndex = filteredProductData.indexOf('rovo.ondemand');
    if (jpdIndex !== -1 && rovoIndex !== -1 && jpdIndex < rovoIndex) {
        // Swap jpd and rovo positions so rovo comes before jpd
        const jpdValue = filteredProductData[jpdIndex];
        const rovoValue = filteredProductData[rovoIndex];
        if (jpdValue && rovoValue) {
            filteredProductData[jpdIndex] = rovoValue;
            filteredProductData[rovoIndex] = jpdValue;
        }
    }
};
/**
 * Determines the fill order when adding owned products back
 * For Category Two and Three, prioritizes jsm and loom
 */ const $3446645dad0a2ccf$var$getFillOrder = (jobFunction, rankedProducts)=>{
    const shouldUsePrioritizedFill = $3446645dad0a2ccf$var$categoryTwoJobFunctions.includes(jobFunction || '') || $3446645dad0a2ccf$var$categoryThreeJobFunctions.includes(jobFunction || '');
    if (shouldUsePrioritizedFill) // Prioritize jsm and loom when filling for Category Two and Three
    return [
        'jira-software',
        'confluence',
        'jira-servicedesk',
        'loom',
        'jira-product-discovery',
        'rovo.ondemand'
    ];
    return rankedProducts;
};
/**
 * Fills the filtered product data with owned products if needed
 * to reach the target of 4 products
 */ const $3446645dad0a2ccf$var$fillWithOwnedProducts = (filteredProductData, normalizedLoggedInProducts, fillOrder)=>{
    while(filteredProductData.length < 4){
        const currProduct = fillOrder.find((product)=>normalizedLoggedInProducts.includes(product.toLowerCase()) && !filteredProductData.includes(product));
        if (currProduct) filteredProductData.push(currProduct);
        else break;
    }
};
const $3446645dad0a2ccf$export$62df9bdd72f7e904 = (PRODUCT_LIST, jobFunction, loggedInProducts)=>{
    const normalizedLoggedInProducts = loggedInProducts.map((product)=>product.toLowerCase());
    const rankedProducts = $3446645dad0a2ccf$var$getRankedProducts(PRODUCT_LIST, jobFunction);
    // Get products NOT in listed products for logged in user
    const filteredProductData = rankedProducts.filter((product)=>!normalizedLoggedInProducts.includes(product.toLowerCase()));
    // Apply Category One special swap if applicable
    $3446645dad0a2ccf$var$applyCategoryOneSwap(filteredProductData, jobFunction, normalizedLoggedInProducts);
    // If we have 4 or more products not owned, return first 4
    if (filteredProductData.length >= 4) return filteredProductData.slice(0, 4);
    // Fill with owned products if needed
    const fillOrder = $3446645dad0a2ccf$var$getFillOrder(jobFunction, rankedProducts);
    $3446645dad0a2ccf$var$fillWithOwnedProducts(filteredProductData, normalizedLoggedInProducts, fillOrder);
    return filteredProductData;
};
const $3446645dad0a2ccf$export$65d94be098bf0cc9 = ({ jobFunction: jobFunction = null, loggedInProducts: loggedInProducts = [] })=>{
    const PRODUCT_LIST = [
        'jira-software',
        'confluence',
        'jira-servicedesk',
        'loom',
        'jira-product-discovery',
        'rovo.ondemand'
    ];
    // Convert empty string to null to match getFilteredProductData's expected type
    const normalizedJobFunction = jobFunction?.toLowerCase() || null;
    const recommendedProducts = $3446645dad0a2ccf$export$62df9bdd72f7e904(PRODUCT_LIST, normalizedJobFunction, loggedInProducts);
    return {
        FIRST_Recommendation: recommendedProducts[0],
        SECOND_Recommendation: recommendedProducts[1],
        THIRD_Recommendation: recommendedProducts[2],
        FOURTH_Recommendation: recommendedProducts[3]
    };
};
var $3446645dad0a2ccf$export$2e2bcd8739ae039 = $3446645dad0a2ccf$export$65d94be098bf0cc9;

});



parcelRegister("e5xHH", function(module, exports) {
$parcel$export(module.exports, "getUniformEnvironment", function () { return $d5858fa73f7c4849$export$8ac19b48ba41035d; });
const $d5858fa73f7c4849$export$b2b140a53aad1e9f = (env)=>{
    return [
        'preview',
        'staging',
        'production'
    ].includes(env);
};
const $d5858fa73f7c4849$export$8ac19b48ba41035d = (urlSearch)=>{
    let uniformEnvironment = "production" ?? '';
    // Handle empty or invalid URL search params (e.g., during SSR)
    let searchParams;
    try {
        searchParams = new URLSearchParams(new URL(urlSearch).search);
    } catch  {
        searchParams = new URLSearchParams();
    }
    if (searchParams.get('wacae-preview') && uniformEnvironment !== 'production') return 'preview';
    if (uniformEnvironment === 'local') return 'staging';
    if (!$d5858fa73f7c4849$export$b2b140a53aad1e9f(uniformEnvironment)) uniformEnvironment = 'preview';
    return uniformEnvironment;
};

});

parcelRegister("kfEUh", function(module, exports) {
/* grid-overlay.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("kbpa7");
var $wjvXx = parcelRequire("wjvXx");

var $2gCne = parcelRequire("2gCne");
const $825e3194ddda87dd$export$e9c94d54c23374cb = ()=>{
    // this grid is rendered client side only and should wait until after hydration
    const [hasHydrated, setHasHydrated] = (0, $1oC0p.useState)(false);
    const [shouldShowGrid, setShouldShowGrid] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        setHasHydrated(true);
        setShouldShowGrid(!!(0, $2gCne.getLocalStorage)('shouldShowGridOverlay', true));
    }, []);
    if (typeof window !== 'undefined') // @ts-ignore
    window.toggleGrid = ()=>{
        if (!(0, $2gCne.getLocalStorage)('shouldShowGridOverlay', true)) {
            (0, $2gCne.setLocalStorage)('shouldShowGridOverlay', 'true');
            setShouldShowGrid(true);
        } else {
            (0, $2gCne.removeLocalStorage)('shouldShowGridOverlay');
            setShouldShowGrid(false);
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: hasHydrated && shouldShowGrid && /*#__PURE__*/ (0, $7VQPk.jsx)($825e3194ddda87dd$export$1c41ff9dbe11e487, {})
    });
};
const $825e3194ddda87dd$export$1c41ff9dbe11e487 = ()=>{
    const gridOverlayStyle = null;
    const columnStyle = null;
    const columns = new Array(12).fill('').map((_, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1a6z _4t3i1kxc"
            ])
        }, `column-${index}`));
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1bsb1osq _1e021ssb _t9eczr6s _4t3i1kxc _1pbyhac1 _lcxvglyw _bfhk6ars _1gze1tkq _lkmrsxj9 _be1q1u8q _bp7od768 _1rsua5c7"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $wjvXx.ColumnLayout), {
            layout: "overlay",
            children: columns
        })
    });
};

});

parcelRegister("9oWEq", function(module, exports) {
$parcel$export(module.exports, "SmartReCaptcha", function () { return $04ee4618bfdc6f60$export$93022c77e9af74dd; });

var $7VQPk = parcelRequire("7VQPk");

var $eLTTO = parcelRequire("eLTTO");

var $kNE9Z = parcelRequire("kNE9Z");
const $04ee4618bfdc6f60$export$93022c77e9af74dd = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eLTTO.GoogleReCaptchaProvider), {
        reCaptchaKey: (0, $kNE9Z.getReCaptchaKey)(),
        useEnterprise: true,
        useRecaptchaNet: true,
        scriptProps: {
            async: true
        },
        children: children
    });
};

});
parcelRegister("eLTTO", function(module, exports) {
$parcel$export(module.exports, "GoogleReCaptchaProvider", function () { return $ac10d0e9745a177b$export$3d3872bfc53fd642; });
$parcel$export(module.exports, "useGoogleReCaptcha", function () { return $ac10d0e9745a177b$export$7f8feffd50fb5144; });

var $1oC0p = parcelRequire("1oC0p");

var $7t0tI = parcelRequire("7t0tI");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $ac10d0e9745a177b$var$s = function() {
    return $ac10d0e9745a177b$var$s = Object.assign || function(e) {
        for(var t, r = 1, o = arguments.length; r < o; r++)for(var n in t = arguments[r])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        return e;
    }, $ac10d0e9745a177b$var$s.apply(this, arguments);
};
function $ac10d0e9745a177b$var$u(e, t, r, o) {
    return new (r || (r = Promise))(function(n, a) {
        function c(e) {
            try {
                s(o.next(e));
            } catch (e) {
                a(e);
            }
        }
        function i(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function s(e) {
            var t;
            e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(c, i);
        }
        s((o = o.apply(e, t || [])).next());
    });
}
function $ac10d0e9745a177b$var$l(e, t) {
    var r, o, n, a, c = {
        label: 0,
        sent: function() {
            if (1 & n[0]) throw n[1];
            return n[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: i(0),
        throw: i(1),
        return: i(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function i(a) {
        return function(i) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; c;)try {
                    if (r = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                    switch(o = 0, n && (a = [
                        2 & a[0],
                        n.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            n = a;
                            break;
                        case 4:
                            return c.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            c.label++, o = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = c.ops.pop(), c.trys.pop();
                            continue;
                        default:
                            if (!(n = c.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                c = 0;
                                continue;
                            }
                            if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                c.label = a[1];
                                break;
                            }
                            if (6 === a[0] && c.label < n[1]) {
                                c.label = n[1], n = a;
                                break;
                            }
                            if (n && c.label < n[2]) {
                                c.label = n[2], c.ops.push(a);
                                break;
                            }
                            n[2] && c.ops.pop(), c.trys.pop();
                            continue;
                    }
                    a = t.call(e, c);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    r = n = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                i
            ]);
        };
    }
}
var $ac10d0e9745a177b$var$f, $ac10d0e9745a177b$var$p = function(e) {
    var t;
    e ? function(e) {
        if (e) for(; e.lastChild;)e.lastChild.remove();
    }("string" == typeof e ? document.getElementById(e) : e) : (t = document.querySelector(".grecaptcha-badge")) && t.parentNode && document.body.removeChild(t.parentNode);
}, $ac10d0e9745a177b$var$d = function(e, t) {
    $ac10d0e9745a177b$var$p(t), window.___grecaptcha_cfg = void 0;
    var r = document.querySelector("#" + e);
    r && r.remove(), function() {
        var e = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
        e && e.remove();
    }();
}, $ac10d0e9745a177b$var$y = function(e) {
    var t = e.render, r = e.onLoadCallbackName, o = e.language, n = e.onLoad, a = e.useRecaptchaNet, c = e.useEnterprise, i = e.scriptProps, s = void 0 === i ? {} : i, u = s.nonce, l = void 0 === u ? "" : u, f = s.defer, p = void 0 !== f && f, d = s.async, y = void 0 !== d && d, m = s.id, v = void 0 === m ? "" : m, b = s.appendTo, h = v || "google-recaptcha-v3";
    if (function(e) {
        return !!document.querySelector("#" + e);
    }(h)) n();
    else {
        var g = function(e) {
            return "https://www." + (e.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (e.useEnterprise ? "enterprise.js" : "api.js");
        }({
            useEnterprise: c,
            useRecaptchaNet: a
        }), S = document.createElement("script");
        S.id = h, S.src = g + "?render=" + t + ("explicit" === t ? "&onload=" + r : "") + (o ? "&hl=" + o : ""), l && (S.nonce = l), S.defer = !!p, S.async = !!y, S.onload = n, ("body" === b ? document.body : document.getElementsByTagName("head")[0]).appendChild(S);
    }
}, $ac10d0e9745a177b$var$m = function(e) {
    "undefined" != typeof $7t0tI && $7t0tI.env, console.warn(e);
};
!function(e) {
    e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
}($ac10d0e9745a177b$var$f || ($ac10d0e9745a177b$var$f = {}));
var $ac10d0e9745a177b$export$dd93270ab0cf623c = (0, $1oC0p.createContext)({
    executeRecaptcha: function() {
        throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
    }
}), $ac10d0e9745a177b$export$14d6311c3d83742b = $ac10d0e9745a177b$export$dd93270ab0cf623c.Consumer;
function $ac10d0e9745a177b$export$3d3872bfc53fd642(t) {
    var i = t.reCaptchaKey, u = t.useEnterprise, l = void 0 !== u && u, p = t.useRecaptchaNet, b = void 0 !== p && p, h = t.scriptProps, g = t.language, S = t.container, w = t.children, $ = (0, $1oC0p.useState)(null), C = $[0], P = $[1], x = (0, $1oC0p.useRef)(i), E = JSON.stringify(h), R = JSON.stringify(null == S ? void 0 : S.parameters);
    (0, $1oC0p.useEffect)(function() {
        if (i) {
            var e = (null == h ? void 0 : h.id) || "google-recaptcha-v3", t = (null == h ? void 0 : h.onLoadCallbackName) || "onRecaptchaLoadCallback";
            window[t] = function() {
                var e = l ? window.grecaptcha.enterprise : window.grecaptcha, t = $ac10d0e9745a177b$var$s({
                    badge: "inline",
                    size: "invisible",
                    sitekey: i
                }, (null == S ? void 0 : S.parameters) || {});
                x.current = e.render(null == S ? void 0 : S.element, t);
            };
            return $ac10d0e9745a177b$var$y({
                render: (null == S ? void 0 : S.element) ? "explicit" : i,
                onLoadCallbackName: t,
                useEnterprise: l,
                useRecaptchaNet: b,
                scriptProps: h,
                language: g,
                onLoad: function() {
                    if (window && window.grecaptcha) {
                        var e = l ? window.grecaptcha.enterprise : window.grecaptcha;
                        e.ready(function() {
                            P(e);
                        });
                    } else $ac10d0e9745a177b$var$m("<GoogleRecaptchaProvider /> " + $ac10d0e9745a177b$var$f.SCRIPT_NOT_AVAILABLE);
                },
                onError: function() {
                    $ac10d0e9745a177b$var$m("Error loading google recaptcha script");
                }
            }), function() {
                $ac10d0e9745a177b$var$d(e, null == S ? void 0 : S.element);
            };
        }
        $ac10d0e9745a177b$var$m("<GoogleReCaptchaProvider /> recaptcha key not provided");
    }, [
        l,
        b,
        E,
        R,
        g,
        i,
        null == S ? void 0 : S.element
    ]);
    var M = (0, $1oC0p.useCallback)(function(e) {
        if (!C || !C.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
        return C.execute(x.current, {
            action: e
        });
    }, [
        C,
        x
    ]), N = (0, $1oC0p.useMemo)(function() {
        return {
            executeRecaptcha: C ? M : void 0,
            container: null == S ? void 0 : S.element
        };
    }, [
        M,
        C,
        null == S ? void 0 : S.element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($ac10d0e9745a177b$export$dd93270ab0cf623c.Provider, {
        value: N
    }, w);
}
var $ac10d0e9745a177b$export$7f8feffd50fb5144 = function() {
    return (0, $1oC0p.useContext)($ac10d0e9745a177b$export$dd93270ab0cf623c);
};
function $ac10d0e9745a177b$export$d5aa16f6da947fbf(t) {
    var r = this, o = t.action, a = t.onVerify, c = t.refreshReCaptcha, i = $ac10d0e9745a177b$export$7f8feffd50fb5144();
    (0, $1oC0p.useEffect)(function() {
        var e = i.executeRecaptcha;
        if (e) $ac10d0e9745a177b$var$u(r, void 0, void 0, function() {
            var t;
            return $ac10d0e9745a177b$var$l(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            e(o)
                        ];
                    case 1:
                        return t = r.sent(), a ? (a(t), [
                            2
                        ]) : ($ac10d0e9745a177b$var$m("Please define an onVerify function"), [
                            2
                        ]);
                }
            });
        });
    }, [
        o,
        a,
        c,
        i
    ]);
    var s = i.container;
    return "string" == typeof s ? (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        id: s
    }) : null;
}
function $ac10d0e9745a177b$var$w(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ }
var $ac10d0e9745a177b$var$$ = "function" == typeof Symbol && Symbol.for, $ac10d0e9745a177b$var$C = $ac10d0e9745a177b$var$$ ? Symbol.for("react.element") : 60103, $ac10d0e9745a177b$var$P = $ac10d0e9745a177b$var$$ ? Symbol.for("react.portal") : 60106, $ac10d0e9745a177b$var$x = $ac10d0e9745a177b$var$$ ? Symbol.for("react.fragment") : 60107, $ac10d0e9745a177b$var$E = $ac10d0e9745a177b$var$$ ? Symbol.for("react.strict_mode") : 60108, $ac10d0e9745a177b$var$R = $ac10d0e9745a177b$var$$ ? Symbol.for("react.profiler") : 60114, $ac10d0e9745a177b$var$M = $ac10d0e9745a177b$var$$ ? Symbol.for("react.provider") : 60109, $ac10d0e9745a177b$var$N = $ac10d0e9745a177b$var$$ ? Symbol.for("react.context") : 60110, $ac10d0e9745a177b$var$O = $ac10d0e9745a177b$var$$ ? Symbol.for("react.async_mode") : 60111, $ac10d0e9745a177b$var$_ = $ac10d0e9745a177b$var$$ ? Symbol.for("react.concurrent_mode") : 60111, $ac10d0e9745a177b$var$T = $ac10d0e9745a177b$var$$ ? Symbol.for("react.forward_ref") : 60112, $ac10d0e9745a177b$var$j = $ac10d0e9745a177b$var$$ ? Symbol.for("react.suspense") : 60113, $ac10d0e9745a177b$var$L = $ac10d0e9745a177b$var$$ ? Symbol.for("react.suspense_list") : 60120, $ac10d0e9745a177b$var$k = $ac10d0e9745a177b$var$$ ? Symbol.for("react.memo") : 60115, $ac10d0e9745a177b$var$F = $ac10d0e9745a177b$var$$ ? Symbol.for("react.lazy") : 60116, $ac10d0e9745a177b$var$A = $ac10d0e9745a177b$var$$ ? Symbol.for("react.block") : 60121, $ac10d0e9745a177b$var$V = $ac10d0e9745a177b$var$$ ? Symbol.for("react.fundamental") : 60117, $ac10d0e9745a177b$var$z = $ac10d0e9745a177b$var$$ ? Symbol.for("react.responder") : 60118, $ac10d0e9745a177b$var$G = $ac10d0e9745a177b$var$$ ? Symbol.for("react.scope") : 60119;
function $ac10d0e9745a177b$var$I(e) {
    if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch(t){
            case $ac10d0e9745a177b$var$C:
                switch(e = e.type){
                    case $ac10d0e9745a177b$var$O:
                    case $ac10d0e9745a177b$var$_:
                    case $ac10d0e9745a177b$var$x:
                    case $ac10d0e9745a177b$var$R:
                    case $ac10d0e9745a177b$var$E:
                    case $ac10d0e9745a177b$var$j:
                        return e;
                    default:
                        switch(e = e && e.$$typeof){
                            case $ac10d0e9745a177b$var$N:
                            case $ac10d0e9745a177b$var$T:
                            case $ac10d0e9745a177b$var$F:
                            case $ac10d0e9745a177b$var$k:
                            case $ac10d0e9745a177b$var$M:
                                return e;
                            default:
                                return t;
                        }
                }
            case $ac10d0e9745a177b$var$P:
                return t;
        }
    }
}
function $ac10d0e9745a177b$var$D(e) {
    return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$_;
}
var $ac10d0e9745a177b$var$q = {
    AsyncMode: $ac10d0e9745a177b$var$O,
    ConcurrentMode: $ac10d0e9745a177b$var$_,
    ContextConsumer: $ac10d0e9745a177b$var$N,
    ContextProvider: $ac10d0e9745a177b$var$M,
    Element: $ac10d0e9745a177b$var$C,
    ForwardRef: $ac10d0e9745a177b$var$T,
    Fragment: $ac10d0e9745a177b$var$x,
    Lazy: $ac10d0e9745a177b$var$F,
    Memo: $ac10d0e9745a177b$var$k,
    Portal: $ac10d0e9745a177b$var$P,
    Profiler: $ac10d0e9745a177b$var$R,
    StrictMode: $ac10d0e9745a177b$var$E,
    Suspense: $ac10d0e9745a177b$var$j,
    isAsyncMode: function(e) {
        return $ac10d0e9745a177b$var$D(e) || $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$O;
    },
    isConcurrentMode: $ac10d0e9745a177b$var$D,
    isContextConsumer: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$N;
    },
    isContextProvider: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$M;
    },
    isElement: function(e) {
        return "object" == typeof e && null !== e && e.$$typeof === $ac10d0e9745a177b$var$C;
    },
    isForwardRef: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$T;
    },
    isFragment: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$x;
    },
    isLazy: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$F;
    },
    isMemo: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$k;
    },
    isPortal: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$P;
    },
    isProfiler: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$R;
    },
    isStrictMode: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$E;
    },
    isSuspense: function(e) {
        return $ac10d0e9745a177b$var$I(e) === $ac10d0e9745a177b$var$j;
    },
    isValidElementType: function(e) {
        return "string" == typeof e || "function" == typeof e || e === $ac10d0e9745a177b$var$x || e === $ac10d0e9745a177b$var$_ || e === $ac10d0e9745a177b$var$R || e === $ac10d0e9745a177b$var$E || e === $ac10d0e9745a177b$var$j || e === $ac10d0e9745a177b$var$L || "object" == typeof e && null !== e && (e.$$typeof === $ac10d0e9745a177b$var$F || e.$$typeof === $ac10d0e9745a177b$var$k || e.$$typeof === $ac10d0e9745a177b$var$M || e.$$typeof === $ac10d0e9745a177b$var$N || e.$$typeof === $ac10d0e9745a177b$var$T || e.$$typeof === $ac10d0e9745a177b$var$V || e.$$typeof === $ac10d0e9745a177b$var$z || e.$$typeof === $ac10d0e9745a177b$var$G || e.$$typeof === $ac10d0e9745a177b$var$A);
    },
    typeOf: $ac10d0e9745a177b$var$I
}, $ac10d0e9745a177b$var$B = $ac10d0e9745a177b$var$w(function(e, t) {}), $ac10d0e9745a177b$var$J = ($ac10d0e9745a177b$var$B.AsyncMode, $ac10d0e9745a177b$var$B.ConcurrentMode, $ac10d0e9745a177b$var$B.ContextConsumer, $ac10d0e9745a177b$var$B.ContextProvider, $ac10d0e9745a177b$var$B.Element, $ac10d0e9745a177b$var$B.ForwardRef, $ac10d0e9745a177b$var$B.Fragment, $ac10d0e9745a177b$var$B.Lazy, $ac10d0e9745a177b$var$B.Memo, $ac10d0e9745a177b$var$B.Portal, $ac10d0e9745a177b$var$B.Profiler, $ac10d0e9745a177b$var$B.StrictMode, $ac10d0e9745a177b$var$B.Suspense, $ac10d0e9745a177b$var$B.isAsyncMode, $ac10d0e9745a177b$var$B.isConcurrentMode, $ac10d0e9745a177b$var$B.isContextConsumer, $ac10d0e9745a177b$var$B.isContextProvider, $ac10d0e9745a177b$var$B.isElement, $ac10d0e9745a177b$var$B.isForwardRef, $ac10d0e9745a177b$var$B.isFragment, $ac10d0e9745a177b$var$B.isLazy, $ac10d0e9745a177b$var$B.isMemo, $ac10d0e9745a177b$var$B.isPortal, $ac10d0e9745a177b$var$B.isProfiler, $ac10d0e9745a177b$var$B.isStrictMode, $ac10d0e9745a177b$var$B.isSuspense, $ac10d0e9745a177b$var$B.isValidElementType, $ac10d0e9745a177b$var$B.typeOf, $ac10d0e9745a177b$var$w(function(e) {
    e.exports = $ac10d0e9745a177b$var$q;
})), $ac10d0e9745a177b$var$K = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $ac10d0e9745a177b$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $ac10d0e9745a177b$var$H = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $ac10d0e9745a177b$var$Q = {};
function $ac10d0e9745a177b$var$W(e) {
    return $ac10d0e9745a177b$var$J.isMemo(e) ? $ac10d0e9745a177b$var$H : $ac10d0e9745a177b$var$Q[e.$$typeof] || $ac10d0e9745a177b$var$K;
}
$ac10d0e9745a177b$var$Q[$ac10d0e9745a177b$var$J.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $ac10d0e9745a177b$var$Q[$ac10d0e9745a177b$var$J.Memo] = $ac10d0e9745a177b$var$H;
var $ac10d0e9745a177b$var$X = Object.defineProperty, $ac10d0e9745a177b$var$Y = Object.getOwnPropertyNames, $ac10d0e9745a177b$var$Z = Object.getOwnPropertySymbols, $ac10d0e9745a177b$var$ee = Object.getOwnPropertyDescriptor, $ac10d0e9745a177b$var$te = Object.getPrototypeOf, $ac10d0e9745a177b$var$re = Object.prototype;
var $ac10d0e9745a177b$var$oe = function e(t, r, o) {
    if ("string" != typeof r) {
        if ($ac10d0e9745a177b$var$re) {
            var n = $ac10d0e9745a177b$var$te(r);
            n && n !== $ac10d0e9745a177b$var$re && e(t, n, o);
        }
        var a = $ac10d0e9745a177b$var$Y(r);
        $ac10d0e9745a177b$var$Z && (a = a.concat($ac10d0e9745a177b$var$Z(r)));
        for(var c = $ac10d0e9745a177b$var$W(t), i = $ac10d0e9745a177b$var$W(r), s = 0; s < a.length; ++s){
            var u = a[s];
            if (!($ac10d0e9745a177b$var$U[u] || o && o[u] || i && i[u] || c && c[u])) {
                var l = $ac10d0e9745a177b$var$ee(r, u);
                try {
                    $ac10d0e9745a177b$var$X(t, u, l);
                } catch (e) {}
            }
        }
    }
    return t;
}, $ac10d0e9745a177b$export$b641f6dbb7005cb7 = function(t) {
    var r = function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($ac10d0e9745a177b$export$14d6311c3d83742b, null, function(o) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(t, $ac10d0e9745a177b$var$s({}, r, {
                googleReCaptchaProps: o
            }));
        });
    };
    return r.displayName = "withGoogleReCaptcha(" + (t.displayName || t.name || "Component") + ")", $ac10d0e9745a177b$var$oe(r, t), r;
};

});


parcelRegister("aGbDs", function(module, exports) {
$parcel$export(module.exports, "useDynamicTitleDescription", function () { return $a3d5b010ef3abbec$export$9628d354040e7e6b; });

var $8e22h = parcelRequire("8e22h");

var $1Zyu2 = parcelRequire("1Zyu2");
// Extract title/description for Confluence template routes
function $a3d5b010ef3abbec$var$getConfluenceTemplateTitleDescription(routePath, queryRef, intl) {
    const result = {
        title: null,
        description: null
    };
    if (routePath.startsWith('/software/confluence/templates/collections/')) {
        const urlSlug = routePath.split('/').pop() ?? '';
        const response = (0, $1Zyu2.GetConfluenceTemplateCollectionDetailsTitleDescription)(urlSlug, queryRef);
        if (response?.title) {
            let title = response.title;
            // Apply title formatting for English locale
            if (intl.locale === 'en') title = intl.formatMessage({
                id: 'ConfluenceTemplatesCollectionDetailPage.pageTitle',
                defaultMessage: 'Free {title} collection | Confluence'
            }, {
                title: title
            });
            else title += ' ' + intl.formatMessage({
                id: 'ConfluenceTemplatesCollectionDetailPage.title-suffix',
                defaultMessage: 'Collection | Atlassian'
            });
            result.title = title;
            result.description = response.description;
        }
    } else if (routePath.startsWith('/software/confluence/templates/categories/')) {
        const urlSlug = routePath.split('/').pop() ?? '';
        const response = (0, $1Zyu2.GetConfluenceTemplateCategoryTitleDescription)(urlSlug, queryRef);
        if (response?.title) {
            let title = response.title;
            // Apply title formatting for English locale
            if (intl.locale === 'en') title = intl.formatMessage({
                id: 'ConfluenceTemplatesCategoryDetailPage.pageTitle',
                defaultMessage: 'Free {title} templates | Confluence'
            }, {
                title: title
            });
            else title += ' | Atlassian';
            result.title = title;
            result.description = response.description;
        }
    }
    return result;
}
// Update DOM with title and description
function $a3d5b010ef3abbec$var$updateDocumentMetadata(title, description) {
    if (title && title !== document.title) document.title = title;
    if (description) {
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) metaDescription.setAttribute('content', description);
        else {
            // Create meta description if it doesn't exist
            const meta = document.createElement('meta');
            meta.name = 'description';
            meta.content = description;
            document.head.appendChild(meta);
        }
    }
}
function $a3d5b010ef3abbec$export$9628d354040e7e6b(location, queryRef) {
    try {
        // Must call hooks unconditionally
        const intl = (0, $8e22h.default)();
        // Only run on client side and when we have queryRef
        if (typeof window === 'undefined' || !queryRef) return;
        const routePath = location.pathname;
        let result = {
            title: null,
            description: null
        };
        // Handle Confluence template routes
        if (routePath.startsWith('/software/confluence/templates/')) result = $a3d5b010ef3abbec$var$getConfluenceTemplateTitleDescription(routePath, queryRef, intl);
        // Update document metadata
        $a3d5b010ef3abbec$var$updateDocumentMetadata(result.title, result.description);
    } catch (error) {
        // Silently handle any errors in title/description extraction
        console.warn('Error updating dynamic title/description:', error);
    }
}

});
parcelRegister("1Zyu2", function(module, exports) {
$parcel$export(module.exports, "GetConfluenceTemplateCollectionDetailsTitleDescription", function () { return $3ffaee9fe533fbb7$export$8bf46073a9167ad8; });
$parcel$export(module.exports, "GetConfluenceTemplateCategoryTitleDescription", function () { return $3ffaee9fe533fbb7$export$fa5f0dd04a98c02d; });

var $f3gS9 = parcelRequire("f3gS9");

var $gbUpX = parcelRequire("gbUpX");

var $1YXN8 = parcelRequire("1YXN8");
const $3ffaee9fe533fbb7$export$8bf46073a9167ad8 = (urlSlug, queryRef)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $gbUpX.ConfluenceTemplateCollectionDetailsRelayPageQuery), queryRef);
    const collection = data.collections?.items.find((collection)=>collection?.urlSlug === urlSlug);
    return {
        title: collection?.collectionNameExternal ?? '',
        description: collection?.oneLinerHeadline ?? ''
    };
};
const $3ffaee9fe533fbb7$export$fa5f0dd04a98c02d = (urlSlug, queryRef)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageQuery), queryRef);
    const category = data.categories?.items.find((category)=>category?.categoryCollection?.items.find((item)=>item?.urlSlug === urlSlug));
    const matchingItem = category?.categoryCollection?.items.find((item)=>item?.urlSlug === urlSlug);
    return {
        title: matchingItem?.categoryNameExternal ?? '',
        description: matchingItem?.shortDescriptionOneLiner ?? ''
    };
};

});
parcelRegister("f3gS9", function(module, exports) {
/**
 * Relay v18.1.0
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("jGv0H"));

});
parcelRegister("jGv0H", function(module, exports) {
'use strict';

var $cAnja = parcelRequire("cAnja");

var $jwKHU = parcelRequire("jwKHU");

var $32yQF = parcelRequire("32yQF");

var $axu15 = parcelRequire("axu15");

var $7YNW6 = parcelRequire("7YNW6");

var $9jeIJ = parcelRequire("9jeIJ");

var $6njMj = parcelRequire("6njMj");

var $9JReD = parcelRequire("9JReD");

var $kT5XY = parcelRequire("kT5XY");
var $e549fe946b097446$var$loadQuery = $kT5XY.loadQuery;

var $lNbDu = parcelRequire("lNbDu");

var $1fX9m = parcelRequire("1fX9m");

var $l5cr1 = parcelRequire("l5cr1");

var $63pIx = parcelRequire("63pIx");

var $im8b7 = parcelRequire("im8b7");

var $h83sS = parcelRequire("h83sS");

var $gT29l = parcelRequire("gT29l");

var $8EgSy = parcelRequire("8EgSy");

var $gbxKl = parcelRequire("gbxKl");

var $hfU7v = parcelRequire("hfU7v");

var $iQ9TL = parcelRequire("iQ9TL");

var $9Z8K4 = parcelRequire("9Z8K4");

var $86alb = parcelRequire("86alb");

var $af6Xx = parcelRequire("af6Xx");

var $gRpMo = parcelRequire("gRpMo");
module.exports = {
    ConnectionHandler: $gRpMo.ConnectionHandler,
    QueryRenderer: $7YNW6,
    LocalQueryRenderer: $32yQF,
    MutationTypes: $gRpMo.MutationTypes,
    RangeOperations: $gRpMo.RangeOperations,
    ReactRelayContext: $cAnja,
    applyOptimisticMutation: $gRpMo.applyOptimisticMutation,
    commitLocalUpdate: $gRpMo.commitLocalUpdate,
    commitMutation: $gRpMo.commitMutation,
    createFragmentContainer: $jwKHU.createContainer,
    createPaginationContainer: $axu15.createContainer,
    createRefetchContainer: $9jeIJ.createContainer,
    fetchQuery_DEPRECATED: $gRpMo.fetchQuery_DEPRECATED,
    graphql: $gRpMo.graphql,
    readInlineData: $gRpMo.readInlineData,
    requestSubscription: $gRpMo.requestSubscription,
    EntryPointContainer: $6njMj,
    RelayEnvironmentProvider: $1fX9m,
    ProfilerContext: $lNbDu,
    fetchQuery: $gRpMo.fetchQuery,
    loadQuery: $e549fe946b097446$var$loadQuery,
    loadEntryPoint: $9JReD,
    useClientQuery: $l5cr1,
    useFragment: $im8b7,
    useLazyLoadQuery: $h83sS,
    useEntryPointLoader: $63pIx,
    useQueryLoader: $hfU7v,
    useMutation: $gT29l,
    usePaginationFragment: $8EgSy,
    usePreloadedQuery: $gbxKl,
    useRefetchableFragment: $iQ9TL,
    useRelayEnvironment: $9Z8K4,
    useSubscribeToInvalidationState: $86alb,
    useSubscription: $af6Xx
};

});
parcelRegister("cAnja", function(module, exports) {
'use strict';

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $929aed5293032485$var$createRelayContext = $gRpMo.__internal.createRelayContext;
module.exports = $929aed5293032485$var$createRelayContext($1oC0p);

});
parcelRegister("gRpMo", function(module, exports) {
/**
 * Relay v18.2.0
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("aqtrP"));

});
parcelRegister("aqtrP", function(module, exports) {
'use strict';

var $AN1NZ = parcelRequire("AN1NZ");
var $79732cd39f4ec60d$var$isErrorResult = $AN1NZ.isErrorResult, $79732cd39f4ec60d$var$isValueResult = $AN1NZ.isValueResult;

var $37gfZ = parcelRequire("37gfZ");

var $6UbhT = parcelRequire("6UbhT");

var $355Gt = parcelRequire("355Gt");

var $9WnVe = parcelRequire("9WnVe");

var $8zo3A = parcelRequire("8zo3A");

var $751gT = parcelRequire("751gT");

var $e1hCo = parcelRequire("e1hCo");

var $j0ahn = parcelRequire("j0ahn");

var $gh6XJ = parcelRequire("gh6XJ");

var $7ywyT = parcelRequire("7ywyT");

var $knDbo = parcelRequire("knDbo");

var $2yhSZ = parcelRequire("2yhSZ");

var $5uAix = parcelRequire("5uAix");

var $i7bEi = parcelRequire("i7bEi");

var $jiIlE = parcelRequire("jiIlE");

var $e6fBl = parcelRequire("e6fBl");

var $5QHdJ = parcelRequire("5QHdJ");
var $79732cd39f4ec60d$var$generateClientID = $5QHdJ.generateClientID, $79732cd39f4ec60d$var$generateUniqueClientID = $5QHdJ.generateUniqueClientID, $79732cd39f4ec60d$var$isClientID = $5QHdJ.isClientID;

var $9PHRB = parcelRequire("9PHRB");

var $7xbXR = parcelRequire("7xbXR");

var $krdyK = parcelRequire("krdyK");

var $dF0B1 = parcelRequire("dF0B1");
var $79732cd39f4ec60d$var$isSuspenseSentinel = $dF0B1.isSuspenseSentinel, $79732cd39f4ec60d$var$suspenseSentinel = $dF0B1.suspenseSentinel;

var $DjzS4 = parcelRequire("DjzS4");

var $5VmhP = parcelRequire("5VmhP");

var $2iDV0 = parcelRequire("2iDV0");

var $gb6oL = parcelRequire("gb6oL");

var $lsmhe = parcelRequire("lsmhe");

var $iCsmr = parcelRequire("iCsmr");

var $gEyA1 = parcelRequire("gEyA1");

var $ZvEpi = parcelRequire("ZvEpi");

var $NuDVT = parcelRequire("NuDVT");

var $bqOEh = parcelRequire("bqOEh");

var $hwgET = parcelRequire("hwgET");

var $g6lig = parcelRequire("g6lig");

var $daAft = parcelRequire("daAft");

var $6q9UY = parcelRequire("6q9UY");

var $2IDft = parcelRequire("2IDft");

var $3N1K4 = parcelRequire("3N1K4");

var $83IvQ = parcelRequire("83IvQ");

var $7Xg4a = parcelRequire("7Xg4a");

var $cJXVv = parcelRequire("cJXVv");

var $89jkG = parcelRequire("89jkG");

var $iDxFS = parcelRequire("iDxFS");

var $3KHtS = parcelRequire("3KHtS");

var $5MQRa = parcelRequire("5MQRa");

var $88zFl = parcelRequire("88zFl");

var $R5hJz = parcelRequire("R5hJz");
var $79732cd39f4ec60d$var$handlePotentialSnapshotErrors = $R5hJz.handlePotentialSnapshotErrors;

var $3690f = parcelRequire("3690f");

var $9MFqn = parcelRequire("9MFqn");

var $c5kEx = parcelRequire("c5kEx");

var $6E9zJ = parcelRequire("6E9zJ");

var $aS9r6 = parcelRequire("aS9r6");

var $lqHkM = parcelRequire("lqHkM");

var $4mzHE = parcelRequire("4mzHE");

var $8zPeX = parcelRequire("8zPeX");

var $c6Ffp = parcelRequire("c6Ffp");

var $i7r8N = parcelRequire("i7r8N");
var $79732cd39f4ec60d$var$hasCycle = $i7r8N.hasCycle, $79732cd39f4ec60d$var$stableCopy = $i7r8N.stableCopy;

var $bLamk = parcelRequire("bLamk");
var $79732cd39f4ec60d$var$mapStr, $79732cd39f4ec60d$var$setStr, $79732cd39f4ec60d$var$promiseStr, $79732cd39f4ec60d$var$objStr;
module.exports = {
    Environment: $gb6oL,
    Network: $gh6XJ,
    Observable: $7ywyT,
    QueryResponseCache: $knDbo,
    RecordSource: $bqOEh,
    Record: $iCsmr,
    ReplaySubject: $c6Ffp,
    Store: $ZvEpi,
    areEqualSelectors: $gEyA1.areEqualSelectors,
    createFragmentSpecResolver: $9PHRB,
    createNormalizationSelector: $gEyA1.createNormalizationSelector,
    createOperationDescriptor: $lsmhe.createOperationDescriptor,
    createReaderSelector: $gEyA1.createReaderSelector,
    createRequestDescriptor: $lsmhe.createRequestDescriptor,
    getArgumentValues: $hwgET.getArgumentValues,
    getDataIDsFromFragment: $gEyA1.getDataIDsFromFragment,
    getDataIDsFromObject: $gEyA1.getDataIDsFromObject,
    getNode: $jiIlE.getNode,
    getFragment: $jiIlE.getFragment,
    getInlineDataFragment: $jiIlE.getInlineDataFragment,
    getModuleComponentKey: $hwgET.getModuleComponentKey,
    getModuleOperationKey: $hwgET.getModuleOperationKey,
    getPaginationFragment: $jiIlE.getPaginationFragment,
    getPluralSelector: $gEyA1.getPluralSelector,
    getRefetchableFragment: $jiIlE.getRefetchableFragment,
    getRequest: $jiIlE.getRequest,
    getRequestIdentifier: $5MQRa,
    getSelector: $gEyA1.getSelector,
    getSelectorsFromObject: $gEyA1.getSelectorsFromObject,
    getSingularSelector: $gEyA1.getSingularSelector,
    getStorageKey: $hwgET.getStorageKey,
    getVariablesFromFragment: $gEyA1.getVariablesFromFragment,
    getVariablesFromObject: $gEyA1.getVariablesFromObject,
    getVariablesFromPluralFragment: $gEyA1.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $gEyA1.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $79732cd39f4ec60d$var$handlePotentialSnapshotErrors,
    graphql: $jiIlE.graphql,
    isErrorResult: $79732cd39f4ec60d$var$isErrorResult,
    isValueResult: $79732cd39f4ec60d$var$isValueResult,
    isFragment: $jiIlE.isFragment,
    isInlineDataFragment: $jiIlE.isInlineDataFragment,
    isSuspenseSentinel: $79732cd39f4ec60d$var$isSuspenseSentinel,
    suspenseSentinel: $79732cd39f4ec60d$var$suspenseSentinel,
    isRequest: $jiIlE.isRequest,
    readInlineData: $5VmhP,
    MutationTypes: $j0ahn.MutationTypes,
    RangeOperations: $j0ahn.RangeOperations,
    DefaultHandlerProvider: $9WnVe,
    ConnectionHandler: $37gfZ,
    MutationHandlers: $355Gt,
    VIEWER_ID: $daAft.VIEWER_ID,
    VIEWER_TYPE: $daAft.VIEWER_TYPE,
    applyOptimisticMutation: $8zo3A,
    commitLocalUpdate: $751gT,
    commitMutation: $e1hCo,
    fetchQuery: $2yhSZ,
    fetchQuery_DEPRECATED: $5uAix,
    isRelayModernEnvironment: $krdyK,
    requestSubscription: $6q9UY,
    ConnectionInterface: $6UbhT,
    PreloadableQueryRegistry: $e6fBl,
    RelayProfiler: $8zPeX,
    createPayloadFor3DField: $2IDft,
    RelayConcreteNode: $6E9zJ,
    RelayError: $lqHkM,
    RelayFeatureFlags: $4mzHE,
    DEFAULT_HANDLE_KEY: $aS9r6.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $hwgET.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $hwgET.FRAGMENT_OWNER_KEY,
    ID_KEY: $hwgET.ID_KEY,
    REF_KEY: $hwgET.REF_KEY,
    REFS_KEY: $hwgET.REFS_KEY,
    ROOT_ID: $hwgET.ROOT_ID,
    ROOT_TYPE: $hwgET.ROOT_TYPE,
    TYPENAME_KEY: $hwgET.TYPENAME_KEY,
    deepFreeze: $3N1K4,
    generateClientID: $79732cd39f4ec60d$var$generateClientID,
    generateUniqueClientID: $79732cd39f4ec60d$var$generateUniqueClientID,
    getRelayHandleKey: $3KHtS,
    isClientID: $79732cd39f4ec60d$var$isClientID,
    isPromise: $3690f,
    isScalarAndEqual: $9MFqn,
    recycleNodesInto: $c5kEx,
    stableCopy: $79732cd39f4ec60d$var$stableCopy,
    hasCycle: $79732cd39f4ec60d$var$hasCycle,
    getFragmentIdentifier: $83IvQ,
    getRefetchMetadata: $iDxFS,
    getPaginationMetadata: $7Xg4a,
    getPaginationVariables: $cJXVv,
    getPendingOperationsForFragment: $89jkG,
    getValueAtPath: $88zFl,
    __internal: {
        ResolverFragments: $g6lig,
        OperationTracker: $NuDVT,
        createRelayContext: $7xbXR,
        getOperationVariables: $2iDV0.getOperationVariables,
        getLocalVariables: $2iDV0.getLocalVariables,
        fetchQuery: $i7bEi.fetchQuery,
        fetchQueryDeduped: $i7bEi.fetchQueryDeduped,
        getPromiseForActiveRequest: $i7bEi.getPromiseForActiveRequest,
        getObservableForActiveRequest: $i7bEi.getObservableForActiveRequest,
        normalizeResponse: $DjzS4,
        withProvidedVariables: $bLamk
    }
};

});
parcelRegister("AN1NZ", function(module, exports) {
'use strict';

var $VeWHw = parcelRequire("VeWHw");

var $h3TMN = parcelRequire("h3TMN");
var $06e964debb2c82b6$var$observeFragment = $h3TMN.observeFragment;

var $jTSZf = parcelRequire("jTSZf");
var $06e964debb2c82b6$var$waitForFragmentData = $jTSZf.waitForFragmentData;
function $06e964debb2c82b6$var$isValueResult(input) {
    return input.ok === true;
}
function $06e964debb2c82b6$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: $VeWHw,
    isValueResult: $06e964debb2c82b6$var$isValueResult,
    isErrorResult: $06e964debb2c82b6$var$isErrorResult,
    observeFragment: $06e964debb2c82b6$var$observeFragment,
    waitForFragmentData: $06e964debb2c82b6$var$waitForFragmentData
};

});
parcelRegister("VeWHw", function(module, exports) {
'use strict';

var $g6lig = parcelRequire("g6lig");
var $0ac0eae88d43f859$var$readFragment = $g6lig.readFragment;

var $3lJ1W = parcelRequire("3lJ1W");
function $0ac0eae88d43f859$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args) {
        var data = $0ac0eae88d43f859$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $3lJ1W(false);
                else return resolverFn(null, args);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $3lJ1W(false);
                return resolverFn(data[fieldName], args);
            } else $3lJ1W(false);
        } else return resolverFn(data, args);
    };
}
module.exports = $0ac0eae88d43f859$var$resolverDataInjector;

});
parcelRegister("g6lig", function(module, exports) {
'use strict';

var $jiIlE = parcelRequire("jiIlE");
var $bb8db959114a251b$var$getFragment = $jiIlE.getFragment;

var $R5hJz = parcelRequire("R5hJz");
var $bb8db959114a251b$var$eventShouldThrow = $R5hJz.eventShouldThrow;

var $gEyA1 = parcelRequire("gEyA1");
var $bb8db959114a251b$var$getSelector = $gEyA1.getSelector;

var $3lJ1W = parcelRequire("3lJ1W");
var $bb8db959114a251b$var$contextStack = [];
function $bb8db959114a251b$var$withResolverContext(context, cb) {
    $bb8db959114a251b$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $bb8db959114a251b$var$contextStack.pop();
    }
}
function $bb8db959114a251b$var$readFragment(fragmentInput, fragmentKey) {
    if (!$bb8db959114a251b$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $bb8db959114a251b$var$contextStack[$bb8db959114a251b$var$contextStack.length - 1];
    var fragmentNode = $bb8db959114a251b$var$getFragment(fragmentInput);
    var fragmentSelector = $bb8db959114a251b$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $3lJ1W(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $3lJ1W(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, errorResponseFields = _context$getDataForRe.errorResponseFields;
    if (isMissingData || errorResponseFields != null && errorResponseFields.some($bb8db959114a251b$var$eventShouldThrow)) throw $bb8db959114a251b$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $bb8db959114a251b$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: $bb8db959114a251b$var$readFragment,
    withResolverContext: $bb8db959114a251b$var$withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $bb8db959114a251b$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

});
parcelRegister("jiIlE", function(module, exports) {
'use strict';

var $6E9zJ = parcelRequire("6E9zJ");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
function $e0d21966c4ee5c97$var$graphql(strings) {
    $3lJ1W(false);
}
function $e0d21966c4ee5c97$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $e0d21966c4ee5c97$var$isFragment(node) {
    var fragment = $e0d21966c4ee5c97$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $6E9zJ.FRAGMENT;
}
function $e0d21966c4ee5c97$var$isRequest(node) {
    var request = $e0d21966c4ee5c97$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $6E9zJ.REQUEST;
}
function $e0d21966c4ee5c97$var$isUpdatableQuery(node) {
    var updatableQuery = $e0d21966c4ee5c97$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $6E9zJ.UPDATABLE_QUERY;
}
function $e0d21966c4ee5c97$var$isInlineDataFragment(node) {
    var fragment = $e0d21966c4ee5c97$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $6E9zJ.INLINE_DATA_FRAGMENT;
}
function $e0d21966c4ee5c97$var$getFragment(taggedNode) {
    var fragment = $e0d21966c4ee5c97$var$getNode(taggedNode);
    !$e0d21966c4ee5c97$var$isFragment(fragment) && $3lJ1W(false);
    return fragment;
}
function $e0d21966c4ee5c97$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $e0d21966c4ee5c97$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $e0d21966c4ee5c97$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $e0d21966c4ee5c97$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $e0d21966c4ee5c97$var$getRequest(taggedNode) {
    var request = $e0d21966c4ee5c97$var$getNode(taggedNode);
    !$e0d21966c4ee5c97$var$isRequest(request) && $3lJ1W(false);
    return request;
}
function $e0d21966c4ee5c97$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $e0d21966c4ee5c97$var$getNode(taggedNode);
    !$e0d21966c4ee5c97$var$isUpdatableQuery(updatableQuery) && $3lJ1W(false);
    return updatableQuery;
}
function $e0d21966c4ee5c97$var$getInlineDataFragment(taggedNode) {
    var fragment = $e0d21966c4ee5c97$var$getNode(taggedNode);
    !$e0d21966c4ee5c97$var$isInlineDataFragment(fragment) && $3lJ1W(false);
    return fragment;
}
module.exports = {
    getFragment: $e0d21966c4ee5c97$var$getFragment,
    getNode: $e0d21966c4ee5c97$var$getNode,
    getPaginationFragment: $e0d21966c4ee5c97$var$getPaginationFragment,
    getRefetchableFragment: $e0d21966c4ee5c97$var$getRefetchableFragment,
    getRequest: $e0d21966c4ee5c97$var$getRequest,
    getUpdatableQuery: $e0d21966c4ee5c97$var$getUpdatableQuery,
    getInlineDataFragment: $e0d21966c4ee5c97$var$getInlineDataFragment,
    graphql: $e0d21966c4ee5c97$var$graphql,
    isFragment: $e0d21966c4ee5c97$var$isFragment,
    isRequest: $e0d21966c4ee5c97$var$isRequest,
    isUpdatableQuery: $e0d21966c4ee5c97$var$isUpdatableQuery,
    isInlineDataFragment: $e0d21966c4ee5c97$var$isInlineDataFragment
};

});
parcelRegister("6E9zJ", function(module, exports) {
'use strict';
var $4d6de7faf84ad670$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $4d6de7faf84ad670$var$RelayConcreteNode;

});

parcelRegister("3lJ1W", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $270643530e02f96f$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $270643530e02f96f$var$invariant;

});

parcelRegister("UJI01", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $gyjfx = parcelRequire("gyjfx");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $0aa8afddcd781ccf$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $0aa8afddcd781ccf$var$warning = $gyjfx;
module.exports = $0aa8afddcd781ccf$var$warning;

});
parcelRegister("gyjfx", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $c0cec0e5f560096f$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $c0cec0e5f560096f$var$emptyFunction = function emptyFunction() {};
$c0cec0e5f560096f$var$emptyFunction.thatReturns = $c0cec0e5f560096f$var$makeEmptyFunction;
$c0cec0e5f560096f$var$emptyFunction.thatReturnsFalse = $c0cec0e5f560096f$var$makeEmptyFunction(false);
$c0cec0e5f560096f$var$emptyFunction.thatReturnsTrue = $c0cec0e5f560096f$var$makeEmptyFunction(true);
$c0cec0e5f560096f$var$emptyFunction.thatReturnsNull = $c0cec0e5f560096f$var$makeEmptyFunction(null);
$c0cec0e5f560096f$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$c0cec0e5f560096f$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $c0cec0e5f560096f$var$emptyFunction;

});



parcelRegister("R5hJz", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $09f90cd976323d73$var$_interopRequireDefault = $eAxMI.default;

var $09f90cd976323d73$var$_createForOfIteratorHelper2 = $09f90cd976323d73$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $3lJ1W = parcelRequire("3lJ1W");
function $09f90cd976323d73$var$handleFieldErrors(environment, errorResponseFields) {
    var _iterator = (0, $09f90cd976323d73$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger(fieldError);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $09f90cd976323d73$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($09f90cd976323d73$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    $3lJ1W(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $09f90cd976323d73$var$eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function $09f90cd976323d73$var$handlePotentialSnapshotErrors(environment, errorResponseFields) {
    if (errorResponseFields != null) $09f90cd976323d73$var$handleFieldErrors(environment, errorResponseFields);
}
module.exports = {
    handlePotentialSnapshotErrors: $09f90cd976323d73$var$handlePotentialSnapshotErrors,
    eventShouldThrow: $09f90cd976323d73$var$eventShouldThrow
};

});
parcelRegister("eAxMI", function(module, exports) {
function $a9eea272c703cb55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $a9eea272c703cb55$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cS9yJ", function(module, exports) {

var $cdoni = parcelRequire("cdoni");
function $95f1f1734dfe10eb$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cdoni(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $95f1f1734dfe10eb$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cdoni", function(module, exports) {

var $2iyaW = parcelRequire("2iyaW");
function $8e499b3bad66987c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2iyaW(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2iyaW(r, a) : void 0;
    }
}
module.exports = $8e499b3bad66987c$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2iyaW", function(module, exports) {
function $1ac7c5c5545e63b9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1ac7c5c5545e63b9$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("gEyA1", function(module, exports) {
'use strict';

var $2iDV0 = parcelRequire("2iDV0");
var $c1fb349ca495a827$var$getFragmentVariables = $2iDV0.getFragmentVariables;

var $hwgET = parcelRequire("hwgET");
var $c1fb349ca495a827$var$CLIENT_EDGE_TRAVERSAL_PATH = $hwgET.CLIENT_EDGE_TRAVERSAL_PATH, $c1fb349ca495a827$var$FRAGMENT_OWNER_KEY = $hwgET.FRAGMENT_OWNER_KEY, $c1fb349ca495a827$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $hwgET.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $c1fb349ca495a827$var$FRAGMENTS_KEY = $hwgET.FRAGMENTS_KEY, $c1fb349ca495a827$var$ID_KEY = $hwgET.ID_KEY;

var $fJesj = parcelRequire("fJesj");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
function $c1fb349ca495a827$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $3lJ1W(false);
    var dataID = item[$c1fb349ca495a827$var$ID_KEY];
    var fragments = item[$c1fb349ca495a827$var$FRAGMENTS_KEY];
    var mixedOwner = item[$c1fb349ca495a827$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$c1fb349ca495a827$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $c1fb349ca495a827$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$c1fb349ca495a827$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $c1fb349ca495a827$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $c1fb349ca495a827$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $c1fb349ca495a827$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $c1fb349ca495a827$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $3lJ1W(false);
        return $c1fb349ca495a827$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $3lJ1W(false);
        return $c1fb349ca495a827$var$getSingularSelector(fragment, item);
    }
}
function $c1fb349ca495a827$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $c1fb349ca495a827$var$getSelector(fragment, item);
    }
    return selectors;
}
function $c1fb349ca495a827$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $c1fb349ca495a827$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $c1fb349ca495a827$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $3lJ1W(false);
        return $c1fb349ca495a827$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $3lJ1W(false);
        return $c1fb349ca495a827$var$getDataID(fragment, item);
    }
}
function $c1fb349ca495a827$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $c1fb349ca495a827$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $c1fb349ca495a827$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $3lJ1W(false);
    var dataID = item[$c1fb349ca495a827$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $c1fb349ca495a827$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $c1fb349ca495a827$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $c1fb349ca495a827$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $3lJ1W(false);
        return $c1fb349ca495a827$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $3lJ1W(false);
        return $c1fb349ca495a827$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $c1fb349ca495a827$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $c1fb349ca495a827$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $c1fb349ca495a827$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $c1fb349ca495a827$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $c1fb349ca495a827$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $fJesj(thisSelector.variables, thatSelector.variables) && $c1fb349ca495a827$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $c1fb349ca495a827$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $c1fb349ca495a827$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $fJesj(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $c1fb349ca495a827$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $c1fb349ca495a827$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $c1fb349ca495a827$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $c1fb349ca495a827$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $c1fb349ca495a827$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $c1fb349ca495a827$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $c1fb349ca495a827$var$areEqualSelectors,
    createReaderSelector: $c1fb349ca495a827$var$createReaderSelector,
    createNormalizationSelector: $c1fb349ca495a827$var$createNormalizationSelector,
    getDataIDsFromFragment: $c1fb349ca495a827$var$getDataIDsFromFragment,
    getDataIDsFromObject: $c1fb349ca495a827$var$getDataIDsFromObject,
    getSingularSelector: $c1fb349ca495a827$var$getSingularSelector,
    getPluralSelector: $c1fb349ca495a827$var$getPluralSelector,
    getSelector: $c1fb349ca495a827$var$getSelector,
    getSelectorsFromObject: $c1fb349ca495a827$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $c1fb349ca495a827$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $c1fb349ca495a827$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $c1fb349ca495a827$var$getVariablesFromFragment,
    getVariablesFromObject: $c1fb349ca495a827$var$getVariablesFromObject
};

});
parcelRegister("2iDV0", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $1acc3a2e38d982b3$var$_interopRequireDefault = $eAxMI.default;

var $1acc3a2e38d982b3$var$_objectSpread2 = $1acc3a2e38d982b3$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $hwgET = parcelRequire("hwgET");
var $1acc3a2e38d982b3$var$getArgumentValues = $hwgET.getArgumentValues;

var $3lJ1W = parcelRequire("3lJ1W");
function $1acc3a2e38d982b3$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $1acc3a2e38d982b3$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $3lJ1W(false);
        }
    });
    return variables || argumentVariables;
}
function $1acc3a2e38d982b3$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $1acc3a2e38d982b3$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $1acc3a2e38d982b3$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $1acc3a2e38d982b3$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $1acc3a2e38d982b3$var$getLocalVariables,
    getFragmentVariables: $1acc3a2e38d982b3$var$getFragmentVariables,
    getOperationVariables: $1acc3a2e38d982b3$var$getOperationVariables
};

});
parcelRegister("ltNVC", function(module, exports) {

var $2UCNB = parcelRequire("2UCNB");
function $fa330921098c28b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa330921098c28b8$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa330921098c28b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2UCNB(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa330921098c28b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $fa330921098c28b8$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2UCNB", function(module, exports) {

var $glrNX = parcelRequire("glrNX");
function $21eee864bc418b6e$var$_defineProperty(e, r, t) {
    return (r = $glrNX(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $21eee864bc418b6e$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("glrNX", function(module, exports) {

var $anIBx = parcelRequire("anIBx");
var $be642cee3a3c59f7$var$_typeof = $anIBx.default;

var $2hTIY = parcelRequire("2hTIY");
function $be642cee3a3c59f7$var$toPropertyKey(t) {
    var i = $2hTIY(t, "string");
    return "symbol" == $be642cee3a3c59f7$var$_typeof(i) ? i : i + "";
}
module.exports = $be642cee3a3c59f7$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("anIBx", function(module, exports) {
function $78eea6e70f62ebe7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $78eea6e70f62ebe7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $78eea6e70f62ebe7$var$_typeof(o);
}
module.exports = $78eea6e70f62ebe7$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2hTIY", function(module, exports) {

var $anIBx = parcelRequire("anIBx");
var $1aa864fff9671af4$var$_typeof = $anIBx.default;
function $1aa864fff9671af4$var$toPrimitive(t, r) {
    if ("object" != $1aa864fff9671af4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1aa864fff9671af4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $1aa864fff9671af4$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("hwgET", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $cc1258de65a18294$var$_interopRequireDefault = $eAxMI.default;

var $cc1258de65a18294$var$_toConsumableArray2 = $cc1258de65a18294$var$_interopRequireDefault((parcelRequire("6Szcd")));

var $3KHtS = parcelRequire("3KHtS");

var $6E9zJ = parcelRequire("6E9zJ");

var $i7r8N = parcelRequire("i7r8N");
var $cc1258de65a18294$var$stableCopy = $i7r8N.stableCopy;

var $3lJ1W = parcelRequire("3lJ1W");
var $cc1258de65a18294$var$VARIABLE = $6E9zJ.VARIABLE, $cc1258de65a18294$var$LITERAL = $6E9zJ.LITERAL, $cc1258de65a18294$var$OBJECT_VALUE = $6E9zJ.OBJECT_VALUE, $cc1258de65a18294$var$LIST_VALUE = $6E9zJ.LIST_VALUE;
var $cc1258de65a18294$var$ERRORS_KEY = '__errors';
var $cc1258de65a18294$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $cc1258de65a18294$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
function $cc1258de65a18294$var$getArgumentValue(arg, variables) {
    if (arg.kind === $cc1258de65a18294$var$VARIABLE) return $cc1258de65a18294$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $cc1258de65a18294$var$LITERAL) return arg.value;
    else if (arg.kind === $cc1258de65a18294$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $cc1258de65a18294$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $cc1258de65a18294$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($cc1258de65a18294$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $cc1258de65a18294$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$cc1258de65a18294$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $cc1258de65a18294$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $cc1258de65a18294$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $3KHtS(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $cc1258de65a18294$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $cc1258de65a18294$var$formatStorageKey(handleName, $cc1258de65a18294$var$getArgumentValues(filterArgs, variables));
}
function $cc1258de65a18294$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $cc1258de65a18294$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $cc1258de65a18294$var$formatStorageKey(name, $cc1258de65a18294$var$getArgumentValues(args, variables)) : name;
}
function $cc1258de65a18294$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $cc1258de65a18294$var$getStableStorageKey(name, args) {
    return $cc1258de65a18294$var$formatStorageKey(name, $cc1258de65a18294$var$stableCopy(args));
}
function $cc1258de65a18294$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $cc1258de65a18294$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $3lJ1W(false);
    return $cc1258de65a18294$var$stableCopy(variables[name]);
}
function $cc1258de65a18294$var$getModuleComponentKey(documentName) {
    return "".concat($cc1258de65a18294$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $cc1258de65a18294$var$getModuleOperationKey(documentName) {
    return "".concat($cc1258de65a18294$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $cc1258de65a18294$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $cc1258de65a18294$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    formatStorageKey: $cc1258de65a18294$var$formatStorageKey,
    getArgumentValue: $cc1258de65a18294$var$getArgumentValue,
    getArgumentValues: $cc1258de65a18294$var$getArgumentValues,
    getHandleStorageKey: $cc1258de65a18294$var$getHandleStorageKey,
    getStorageKey: $cc1258de65a18294$var$getStorageKey,
    getStableStorageKey: $cc1258de65a18294$var$getStableStorageKey,
    getModuleComponentKey: $cc1258de65a18294$var$getModuleComponentKey,
    getModuleOperationKey: $cc1258de65a18294$var$getModuleOperationKey
};
module.exports = $cc1258de65a18294$var$RelayStoreUtils;

});
parcelRegister("6Szcd", function(module, exports) {

var $8e8ij = parcelRequire("8e8ij");

var $lIwWT = parcelRequire("lIwWT");

var $cdoni = parcelRequire("cdoni");

var $48Cvg = parcelRequire("48Cvg");
function $50231669ac82e737$var$_toConsumableArray(r) {
    return $8e8ij(r) || $lIwWT(r) || $cdoni(r) || $48Cvg();
}
module.exports = $50231669ac82e737$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8e8ij", function(module, exports) {

var $2iyaW = parcelRequire("2iyaW");
function $5fd6109b6018e411$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2iyaW(r);
}
module.exports = $5fd6109b6018e411$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lIwWT", function(module, exports) {
function $fcf743fad1381e8e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $fcf743fad1381e8e$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("48Cvg", function(module, exports) {
function $3035c6b91e2dfcc4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $3035c6b91e2dfcc4$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3KHtS", function(module, exports) {
'use strict';

var $aS9r6 = parcelRequire("aS9r6");
var $2bb76561380126b4$var$DEFAULT_HANDLE_KEY = $aS9r6.DEFAULT_HANDLE_KEY;

var $3lJ1W = parcelRequire("3lJ1W");
function $2bb76561380126b4$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $2bb76561380126b4$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $3lJ1W(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $2bb76561380126b4$var$getRelayHandleKey;

});
parcelRegister("aS9r6", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("i7r8N", function(module, exports) {
'use strict';
function $d30def0b16639f3b$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($d30def0b16639f3b$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $d30def0b16639f3b$var$stableCopy(value[keys[i]]);
    return stable;
}
function $d30def0b16639f3b$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $d30def0b16639f3b$var$hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: $d30def0b16639f3b$var$stableCopy,
    hasCycle: $d30def0b16639f3b$var$hasCycle
};

});



parcelRegister("fJesj", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $b736458d8e79dfbc$var$aStackPool = [];
var $b736458d8e79dfbc$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $b736458d8e79dfbc$var$areEqual(a, b) {
    var aStack = $b736458d8e79dfbc$var$aStackPool.length ? $b736458d8e79dfbc$var$aStackPool.pop() : [];
    var bStack = $b736458d8e79dfbc$var$bStackPool.length ? $b736458d8e79dfbc$var$bStackPool.pop() : [];
    var result = $b736458d8e79dfbc$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $b736458d8e79dfbc$var$aStackPool.push(aStack);
    $b736458d8e79dfbc$var$bStackPool.push(bStack);
    return result;
}
function $b736458d8e79dfbc$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$b736458d8e79dfbc$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$b736458d8e79dfbc$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $b736458d8e79dfbc$var$areEqual;

});




parcelRegister("h3TMN", function(module, exports) {
"use strict";

var $7e1sY = parcelRequire("7e1sY");
var $c6bdfd6b36a9aed6$require$_asyncToGenerator = $7e1sY.default;

var $7ywyT = parcelRequire("7ywyT");

var $jiIlE = parcelRequire("jiIlE");
var $c6bdfd6b36a9aed6$var$getFragment = $jiIlE.getFragment;

var $89jkG = parcelRequire("89jkG");

var $R5hJz = parcelRequire("R5hJz");
var $c6bdfd6b36a9aed6$var$handlePotentialSnapshotErrors = $R5hJz.handlePotentialSnapshotErrors;

var $gEyA1 = parcelRequire("gEyA1");
var $c6bdfd6b36a9aed6$var$getSelector = $gEyA1.getSelector;

var $3lJ1W = parcelRequire("3lJ1W");
function $c6bdfd6b36a9aed6$var$waitForFragmentData(_x, _x2, _x3) {
    return $c6bdfd6b36a9aed6$var$_waitForFragmentData.apply(this, arguments);
}
function $c6bdfd6b36a9aed6$var$_waitForFragmentData() {
    $c6bdfd6b36a9aed6$var$_waitForFragmentData = $c6bdfd6b36a9aed6$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $c6bdfd6b36a9aed6$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $c6bdfd6b36a9aed6$var$_waitForFragmentData.apply(this, arguments);
}
function $c6bdfd6b36a9aed6$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $c6bdfd6b36a9aed6$var$getFragment(fragment);
    var fragmentSelector = $c6bdfd6b36a9aed6$var$getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && $3lJ1W(false);
    !(fragmentSelector != null) && $3lJ1W(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return $c6bdfd6b36a9aed6$var$observeSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            $3lJ1W(false);
    }
    $3lJ1W(false);
}
function $c6bdfd6b36a9aed6$var$observeSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $7ywyT.create(function(sink) {
        sink.next($c6bdfd6b36a9aed6$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($c6bdfd6b36a9aed6$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $c6bdfd6b36a9aed6$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        var pendingOperations = $89jkG(environment, fragmentNode, owner);
        if (pendingOperations != null) return {
            state: 'loading'
        };
    }
    try {
        $c6bdfd6b36a9aed6$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && $3lJ1W(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
module.exports = {
    observeFragment: $c6bdfd6b36a9aed6$var$observeFragment,
    waitForFragmentData: $c6bdfd6b36a9aed6$var$waitForFragmentData
};

});
parcelRegister("7e1sY", function(module, exports) {
function $542afa67e2a955cc$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $542afa67e2a955cc$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $542afa67e2a955cc$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $542afa67e2a955cc$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $542afa67e2a955cc$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7ywyT", function(module, exports) {
'use strict';

var $3690f = parcelRequire("3690f");
var $5804f77e42310212$var$hostReportError = $5804f77e42310212$var$swallowError;
var $5804f77e42310212$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $5804f77e42310212$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $5804f77e42310212$var$isObservable(obj) ? $5804f77e42310212$var$fromObservable(obj) : $3690f(obj) ? $5804f77e42310212$var$fromPromise(obj) : $5804f77e42310212$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $5804f77e42310212$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $5804f77e42310212$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $5804f77e42310212$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $5804f77e42310212$var$fromObservable(obj) {
    return obj instanceof $5804f77e42310212$var$RelayObservable ? obj : $5804f77e42310212$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $5804f77e42310212$var$fromPromise(promise) {
    return $5804f77e42310212$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $5804f77e42310212$var$fromValue(value) {
    return $5804f77e42310212$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $5804f77e42310212$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $5804f77e42310212$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $5804f77e42310212$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $5804f77e42310212$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $5804f77e42310212$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $5804f77e42310212$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $5804f77e42310212$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $5804f77e42310212$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $5804f77e42310212$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $5804f77e42310212$var$RelayObservable;

});
parcelRegister("3690f", function(module, exports) {
'use strict';
function $2418ea6d514e21b7$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $2418ea6d514e21b7$var$isPromise;

});


parcelRegister("89jkG", function(module, exports) {
'use strict';

var $i7bEi = parcelRequire("i7bEi");
var $5eee290567246fc9$var$getPromiseForActiveRequest = $i7bEi.getPromiseForActiveRequest;
function $5eee290567246fc9$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $5eee290567246fc9$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $5eee290567246fc9$var$getPendingOperationsForFragment;

});
parcelRegister("i7bEi", function(module, exports) {
'use strict';

var $7ywyT = parcelRequire("7ywyT");

var $c6Ffp = parcelRequire("c6Ffp");

var $3lJ1W = parcelRequire("3lJ1W");
var $d301eaa92b4d4388$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $d301eaa92b4d4388$var$requestCachesByEnvironment = $d301eaa92b4d4388$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $d301eaa92b4d4388$var$fetchQuery(environment, operation) {
    return $d301eaa92b4d4388$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $d301eaa92b4d4388$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $7ywyT.create(function(sink) {
        var requestCache = $d301eaa92b4d4388$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $c6Ffp(),
                    subjectForInFlightStatus: new $c6Ffp(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $d301eaa92b4d4388$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $d301eaa92b4d4388$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $d301eaa92b4d4388$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $d301eaa92b4d4388$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $3lJ1W(false);
        return $d301eaa92b4d4388$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $d301eaa92b4d4388$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $7ywyT.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $d301eaa92b4d4388$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $7ywyT.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $d301eaa92b4d4388$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $d301eaa92b4d4388$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $d301eaa92b4d4388$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $d301eaa92b4d4388$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $d301eaa92b4d4388$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $d301eaa92b4d4388$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $d301eaa92b4d4388$var$getRequestCache(environment) {
    var cached = $d301eaa92b4d4388$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $d301eaa92b4d4388$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $d301eaa92b4d4388$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $3lJ1W(false);
    return cached;
}
module.exports = {
    fetchQuery: $d301eaa92b4d4388$var$fetchQuery,
    fetchQueryDeduped: $d301eaa92b4d4388$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $d301eaa92b4d4388$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $d301eaa92b4d4388$var$getObservableForActiveRequest
};

});
parcelRegister("c6Ffp", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $8d060a7a8cdd4c6d$var$_interopRequireDefault = $eAxMI.default;

var $8d060a7a8cdd4c6d$var$_createForOfIteratorHelper2 = $8d060a7a8cdd4c6d$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $8d060a7a8cdd4c6d$var$_defineProperty2 = $8d060a7a8cdd4c6d$var$_interopRequireDefault((parcelRequire("2UCNB")));

var $7ywyT = parcelRequire("7ywyT");

var $3lJ1W = parcelRequire("3lJ1W");
var $8d060a7a8cdd4c6d$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $8d060a7a8cdd4c6d$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $8d060a7a8cdd4c6d$var$_defineProperty2["default"])(this, "_events", []);
        (0, $8d060a7a8cdd4c6d$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $8d060a7a8cdd4c6d$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $7ywyT.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $3lJ1W(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $8d060a7a8cdd4c6d$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $8d060a7a8cdd4c6d$var$RelayReplaySubject;

});




parcelRegister("jTSZf", function(module, exports) {
"use strict";

var $7e1sY = parcelRequire("7e1sY");
var $e7cdce9a3f5287d0$require$_asyncToGenerator = $7e1sY.default;

var $h3TMN = parcelRequire("h3TMN");
var $e7cdce9a3f5287d0$var$observeFragment = $h3TMN.observeFragment;
function $e7cdce9a3f5287d0$var$waitForFragmentData(_x, _x2, _x3) {
    return $e7cdce9a3f5287d0$var$_waitForFragmentData.apply(this, arguments);
}
function $e7cdce9a3f5287d0$var$_waitForFragmentData() {
    $e7cdce9a3f5287d0$var$_waitForFragmentData = $e7cdce9a3f5287d0$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $e7cdce9a3f5287d0$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $e7cdce9a3f5287d0$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $e7cdce9a3f5287d0$var$waitForFragmentData
};

});


parcelRegister("37gfZ", function(module, exports) {
'use strict';

var $5QHdJ = parcelRequire("5QHdJ");
var $244ea2d816004f5b$var$generateClientID = $5QHdJ.generateClientID;

var $hwgET = parcelRequire("hwgET");
var $244ea2d816004f5b$var$getStableStorageKey = $hwgET.getStableStorageKey;

var $3KHtS = parcelRequire("3KHtS");

var $6UbhT = parcelRequire("6UbhT");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
var $244ea2d816004f5b$var$CONNECTION = 'connection';
var $244ea2d816004f5b$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $244ea2d816004f5b$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $6UbhT.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $244ea2d816004f5b$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $244ea2d816004f5b$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $244ea2d816004f5b$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($244ea2d816004f5b$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $244ea2d816004f5b$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $244ea2d816004f5b$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $244ea2d816004f5b$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $244ea2d816004f5b$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $244ea2d816004f5b$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $244ea2d816004f5b$var$getConnection(record, key, filters) {
    var handleKey = $3KHtS($244ea2d816004f5b$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $244ea2d816004f5b$var$getConnectionID(recordID, key, filters) {
    var handleKey = $3KHtS($244ea2d816004f5b$var$CONNECTION, key, null);
    var storageKey = $244ea2d816004f5b$var$getStableStorageKey(handleKey, filters);
    return $244ea2d816004f5b$var$generateClientID(recordID, storageKey);
}
function $244ea2d816004f5b$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $6UbhT.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $244ea2d816004f5b$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $6UbhT.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $244ea2d816004f5b$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $244ea2d816004f5b$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $6UbhT.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $244ea2d816004f5b$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $6UbhT.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $244ea2d816004f5b$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $6UbhT.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($244ea2d816004f5b$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $3lJ1W(false);
    var edgeID = $244ea2d816004f5b$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $244ea2d816004f5b$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $244ea2d816004f5b$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $6UbhT.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $244ea2d816004f5b$var$buildConnectionEdge,
    createEdge: $244ea2d816004f5b$var$createEdge,
    deleteNode: $244ea2d816004f5b$var$deleteNode,
    getConnection: $244ea2d816004f5b$var$getConnection,
    getConnectionID: $244ea2d816004f5b$var$getConnectionID,
    insertEdgeAfter: $244ea2d816004f5b$var$insertEdgeAfter,
    insertEdgeBefore: $244ea2d816004f5b$var$insertEdgeBefore,
    update: $244ea2d816004f5b$var$update
};

});
parcelRegister("5QHdJ", function(module, exports) {
'use strict';

var $4mzHE = parcelRequire("4mzHE");

var $ahYK4 = parcelRequire("ahYK4");
var $442355c61366e2c2$var$intern = $ahYK4.intern;
var $442355c61366e2c2$var$PREFIX = 'client:';
function $442355c61366e2c2$var$generateClientID(id, storageKey, index) {
    var internedId = $4mzHE.STRING_INTERN_LEVEL <= 0 ? id : $442355c61366e2c2$var$intern(id, $4mzHE.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($442355c61366e2c2$var$PREFIX) !== 0) key = $442355c61366e2c2$var$PREFIX + key;
    return key;
}
function $442355c61366e2c2$var$isClientID(id) {
    return id.indexOf($442355c61366e2c2$var$PREFIX) === 0;
}
var $442355c61366e2c2$var$localID = 0;
function $442355c61366e2c2$var$generateUniqueClientID() {
    return "".concat($442355c61366e2c2$var$PREFIX, "local:").concat($442355c61366e2c2$var$localID++);
}
function $442355c61366e2c2$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($442355c61366e2c2$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $442355c61366e2c2$var$generateClientID,
    generateClientObjectClientID: $442355c61366e2c2$var$generateClientObjectClientID,
    generateUniqueClientID: $442355c61366e2c2$var$generateUniqueClientID,
    isClientID: $442355c61366e2c2$var$isClientID
};

});
parcelRegister("4mzHE", function(module, exports) {
'use strict';
var $32d4e967520ba13b$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true
};
module.exports = $32d4e967520ba13b$var$RelayFeatureFlags;

});

parcelRegister("ahYK4", function(module, exports) {
'use strict';
var $77da9c0625b25012$var$internTable = new Map();
var $77da9c0625b25012$var$nextIndex = 1;
var $77da9c0625b25012$var$digits = $77da9c0625b25012$var$initDigitTable();
var $77da9c0625b25012$var$INTERN_PREFIX = '\t';
var $77da9c0625b25012$var$ESCAPE_PREFIX = '\v';
function $77da9c0625b25012$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $77da9c0625b25012$var$escape(str) {
    if (str[0] === $77da9c0625b25012$var$INTERN_PREFIX && $77da9c0625b25012$var$digits.has(str[1]) || str[0] === $77da9c0625b25012$var$ESCAPE_PREFIX) return $77da9c0625b25012$var$ESCAPE_PREFIX + str;
    return str;
}
function $77da9c0625b25012$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $77da9c0625b25012$var$escape(str);
    var internedString = $77da9c0625b25012$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $77da9c0625b25012$var$INTERN_PREFIX + $77da9c0625b25012$var$nextIndex++;
    $77da9c0625b25012$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $77da9c0625b25012$var$intern
};

});


parcelRegister("6UbhT", function(module, exports) {
'use strict';
var $5070ba877dc45164$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $5070ba877dc45164$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $5070ba877dc45164$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $5070ba877dc45164$var$config = newConfig;
    },
    get: function get() {
        return $5070ba877dc45164$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $5070ba877dc45164$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $5070ba877dc45164$var$ConnectionInterface;

});


parcelRegister("355Gt", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $23e63f734afeb8f7$var$_interopRequireDefault = $eAxMI.default;

var $23e63f734afeb8f7$var$_createForOfIteratorHelper2 = $23e63f734afeb8f7$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $37gfZ = parcelRequire("37gfZ");

var $6UbhT = parcelRequire("6UbhT");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
var $23e63f734afeb8f7$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $23e63f734afeb8f7$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $3lJ1W(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $23e63f734afeb8f7$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $37gfZ.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $23e63f734afeb8f7$var$AppendEdgeHandler = {
    update: $23e63f734afeb8f7$var$edgeUpdater($37gfZ.insertEdgeAfter)
};
var $23e63f734afeb8f7$var$PrependEdgeHandler = {
    update: $23e63f734afeb8f7$var$edgeUpdater($37gfZ.insertEdgeBefore)
};
var $23e63f734afeb8f7$var$AppendNodeHandler = {
    update: $23e63f734afeb8f7$var$nodeUpdater($37gfZ.insertEdgeAfter)
};
var $23e63f734afeb8f7$var$PrependNodeHandler = {
    update: $23e63f734afeb8f7$var$nodeUpdater($37gfZ.insertEdgeBefore)
};
function $23e63f734afeb8f7$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $3lJ1W(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $6UbhT.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $23e63f734afeb8f7$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $23e63f734afeb8f7$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $37gfZ.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $3lJ1W(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $23e63f734afeb8f7$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $3lJ1W(false);
        !(edgeTypeName != null) && $3lJ1W(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $6UbhT.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $23e63f734afeb8f7$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $23e63f734afeb8f7$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $37gfZ.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $3lJ1W(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $23e63f734afeb8f7$var$AppendEdgeHandler,
    DeleteRecordHandler: $23e63f734afeb8f7$var$DeleteRecordHandler,
    PrependEdgeHandler: $23e63f734afeb8f7$var$PrependEdgeHandler,
    AppendNodeHandler: $23e63f734afeb8f7$var$AppendNodeHandler,
    PrependNodeHandler: $23e63f734afeb8f7$var$PrependNodeHandler,
    DeleteEdgeHandler: $23e63f734afeb8f7$var$DeleteEdgeHandler
};

});

parcelRegister("9WnVe", function(module, exports) {
'use strict';

var $37gfZ = parcelRequire("37gfZ");

var $355Gt = parcelRequire("355Gt");

var $3lJ1W = parcelRequire("3lJ1W");
function $73cc16473b907d6d$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $37gfZ;
        case 'deleteRecord':
            return $355Gt.DeleteRecordHandler;
        case 'deleteEdge':
            return $355Gt.DeleteEdgeHandler;
        case 'appendEdge':
            return $355Gt.AppendEdgeHandler;
        case 'prependEdge':
            return $355Gt.PrependEdgeHandler;
        case 'appendNode':
            return $355Gt.AppendNodeHandler;
        case 'prependNode':
            return $355Gt.PrependNodeHandler;
    }
    $3lJ1W(false);
}
module.exports = $73cc16473b907d6d$var$RelayDefaultHandlerProvider;

});

parcelRegister("8zo3A", function(module, exports) {
'use strict';

var $jiIlE = parcelRequire("jiIlE");
var $63d440c8f0698b13$var$getRequest = $jiIlE.getRequest;

var $krdyK = parcelRequire("krdyK");

var $lsmhe = parcelRequire("lsmhe");
var $63d440c8f0698b13$var$createOperationDescriptor = $lsmhe.createOperationDescriptor;

var $j0ahn = parcelRequire("j0ahn");

var $3lJ1W = parcelRequire("3lJ1W");
function $63d440c8f0698b13$var$applyOptimisticMutation(environment, config) {
    !$krdyK(environment) && $3lJ1W(false);
    var mutation = $63d440c8f0698b13$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $63d440c8f0698b13$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $j0ahn.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $63d440c8f0698b13$var$applyOptimisticMutation;

});
parcelRegister("krdyK", function(module, exports) {
'use strict';
function $ee10d8e026399c50$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $ee10d8e026399c50$var$isRelayModernEnvironment;

});

parcelRegister("lsmhe", function(module, exports) {
'use strict';
parcelRequire("3N1K4");

var $5MQRa = parcelRequire("5MQRa");

var $4mzHE = parcelRequire("4mzHE");

var $i7r8N = parcelRequire("i7r8N");
var $f9ed7e3ae6702ec8$var$hasCycle = $i7r8N.hasCycle;

var $2iDV0 = parcelRequire("2iDV0");
var $f9ed7e3ae6702ec8$var$getOperationVariables = $2iDV0.getOperationVariables;

var $gEyA1 = parcelRequire("gEyA1");
var $f9ed7e3ae6702ec8$var$createNormalizationSelector = $gEyA1.createNormalizationSelector, $f9ed7e3ae6702ec8$var$createReaderSelector = $gEyA1.createReaderSelector;

var $hwgET = parcelRequire("hwgET");
var $f9ed7e3ae6702ec8$var$ROOT_ID = $hwgET.ROOT_ID;

var $3lJ1W = parcelRequire("3lJ1W");
function $f9ed7e3ae6702ec8$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $f9ed7e3ae6702ec8$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $f9ed7e3ae6702ec8$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($4mzHE.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$f9ed7e3ae6702ec8$var$hasCycle(operationVariables) && $3lJ1W(false);
    var requestDescriptor = $f9ed7e3ae6702ec8$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $f9ed7e3ae6702ec8$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $f9ed7e3ae6702ec8$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $f9ed7e3ae6702ec8$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $5MQRa(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $f9ed7e3ae6702ec8$var$createOperationDescriptor,
    createRequestDescriptor: $f9ed7e3ae6702ec8$var$createRequestDescriptor
};

});
parcelRegister("3N1K4", function(module, exports) {
'use strict';
function $2c274ca126102543$var$deepFreeze(object) {
    if (!$2c274ca126102543$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $2c274ca126102543$var$deepFreeze(property);
    });
    return object;
}
function $2c274ca126102543$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $2c274ca126102543$var$deepFreeze;

});

parcelRegister("5MQRa", function(module, exports) {
'use strict';

var $i7r8N = parcelRequire("i7r8N");
var $436a6fa193afcdf3$var$stableCopy = $i7r8N.stableCopy;

var $3lJ1W = parcelRequire("3lJ1W");
function $436a6fa193afcdf3$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $3lJ1W(false);
    return requestID + JSON.stringify($436a6fa193afcdf3$var$stableCopy(variables));
}
module.exports = $436a6fa193afcdf3$var$getRequestIdentifier;

});


parcelRegister("j0ahn", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $0391e73018f16ec3$var$_interopRequireDefault = $eAxMI.default;

var $0391e73018f16ec3$var$_createForOfIteratorHelper2 = $0391e73018f16ec3$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $37gfZ = parcelRequire("37gfZ");
parcelRequire("UJI01");
var $0391e73018f16ec3$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $0391e73018f16ec3$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $0391e73018f16ec3$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $0391e73018f16ec3$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $0391e73018f16ec3$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $0391e73018f16ec3$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $0391e73018f16ec3$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $0391e73018f16ec3$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $0391e73018f16ec3$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $0391e73018f16ec3$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $0391e73018f16ec3$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $37gfZ.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $37gfZ.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $37gfZ.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $37gfZ.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $0391e73018f16ec3$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $0391e73018f16ec3$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $0391e73018f16ec3$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $0391e73018f16ec3$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $0391e73018f16ec3$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $0391e73018f16ec3$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $37gfZ.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $37gfZ.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $0391e73018f16ec3$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $0391e73018f16ec3$var$MutationTypes,
    RangeOperations: $0391e73018f16ec3$var$RangeOperations,
    convert: $0391e73018f16ec3$var$convert
};

});


parcelRegister("751gT", function(module, exports) {
'use strict';
function $5279fc8b0a3fbe8e$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $5279fc8b0a3fbe8e$var$commitLocalUpdate;

});

parcelRegister("e1hCo", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $a34ed34964bf3806$var$_interopRequireDefault = $eAxMI.default;

var $a34ed34964bf3806$var$_toConsumableArray2 = $a34ed34964bf3806$var$_interopRequireDefault((parcelRequire("6Szcd")));

var $jiIlE = parcelRequire("jiIlE");
var $a34ed34964bf3806$var$getRequest = $jiIlE.getRequest;

var $5QHdJ = parcelRequire("5QHdJ");
var $a34ed34964bf3806$var$generateUniqueClientID = $5QHdJ.generateUniqueClientID;

var $krdyK = parcelRequire("krdyK");

var $lsmhe = parcelRequire("lsmhe");
var $a34ed34964bf3806$var$createOperationDescriptor = $lsmhe.createOperationDescriptor;

var $j0ahn = parcelRequire("j0ahn");
parcelRequire("6oLWJ");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
function $a34ed34964bf3806$var$commitMutation(environment, config) {
    !$krdyK(environment) && $3lJ1W(false);
    var mutation = $a34ed34964bf3806$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $a34ed34964bf3806$var$createOperationDescriptor(mutation, variables, cacheConfig, $a34ed34964bf3806$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $j0ahn.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $a34ed34964bf3806$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $a34ed34964bf3806$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $a34ed34964bf3806$var$commitMutation;

});
parcelRegister("6oLWJ", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $4a8a2d136e6b9fb0$var$_interopRequireDefault = $eAxMI.default;

var $4a8a2d136e6b9fb0$var$_objectSpread2 = $4a8a2d136e6b9fb0$var$_interopRequireDefault((parcelRequire("ltNVC")));
parcelRequire("UJI01");
var $4a8a2d136e6b9fb0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $4a8a2d136e6b9fb0$var$validateMutation = function validateMutation() {};
var $4a8a2d136e6b9fb0$var$addFieldToDiff, $4a8a2d136e6b9fb0$var$validateSelections, $4a8a2d136e6b9fb0$var$validateSelection, $4a8a2d136e6b9fb0$var$validateModuleImport, $4a8a2d136e6b9fb0$var$validateAbstractKey, $4a8a2d136e6b9fb0$var$validateField, $4a8a2d136e6b9fb0$var$validateOptimisticResponse;
module.exports = $4a8a2d136e6b9fb0$var$validateMutation;

});


parcelRegister("gh6XJ", function(module, exports) {
'use strict';

var $bLamk = parcelRequire("bLamk");

var $cFJIS = parcelRequire("cFJIS");
var $bd93a270da921b79$var$convertFetch = $cFJIS.convertFetch;

var $3lJ1W = parcelRequire("3lJ1W");
function $bd93a270da921b79$var$create(fetchFn, subscribe) {
    var observeFetch = $bd93a270da921b79$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $bLamk(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $3lJ1W(false);
            !!uploadables && $3lJ1W(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $3lJ1W(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $bd93a270da921b79$var$create
};

});
parcelRegister("bLamk", function(module, exports) {
'use strict';
parcelRequire("fJesj");
parcelRequire("UJI01");
var $88fc1e9e90ae31c5$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $88fc1e9e90ae31c5$var$debugCache = $88fc1e9e90ae31c5$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $88fc1e9e90ae31c5$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$88fc1e9e90ae31c5$var$debugCache.has(providerFunction)) {
                $88fc1e9e90ae31c5$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $88fc1e9e90ae31c5$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$88fc1e9e90ae31c5$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $88fc1e9e90ae31c5$var$withProvidedVariables;

});

parcelRegister("cFJIS", function(module, exports) {
'use strict';

var $7ywyT = parcelRequire("7ywyT");
function $939cc7f26a9e19d7$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $7ywyT.create(function(sink) {
            return sink.error(result);
        });
        return $7ywyT.from(result);
    };
}
module.exports = {
    convertFetch: $939cc7f26a9e19d7$var$convertFetch
};

});


parcelRegister("knDbo", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $ed64598787e9b7f4$var$_interopRequireDefault = $eAxMI.default;

var $ed64598787e9b7f4$var$_objectSpread2 = $ed64598787e9b7f4$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $i7r8N = parcelRequire("i7r8N");
var $ed64598787e9b7f4$var$stableCopy = $i7r8N.stableCopy;

var $3lJ1W = parcelRequire("3lJ1W");
var $ed64598787e9b7f4$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $3lJ1W(false);
        !(ttl > 0) && $3lJ1W(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $ed64598787e9b7f4$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$ed64598787e9b7f4$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $ed64598787e9b7f4$var$_objectSpread2["default"])((0, $ed64598787e9b7f4$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $ed64598787e9b7f4$var$_objectSpread2["default"])((0, $ed64598787e9b7f4$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $ed64598787e9b7f4$var$_objectSpread2["default"])((0, $ed64598787e9b7f4$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $ed64598787e9b7f4$var$_objectSpread2["default"])((0, $ed64598787e9b7f4$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $ed64598787e9b7f4$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $ed64598787e9b7f4$var$getCacheKey(queryID, variables) {
    return JSON.stringify($ed64598787e9b7f4$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $ed64598787e9b7f4$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $ed64598787e9b7f4$var$RelayQueryResponseCache;

});

parcelRegister("2yhSZ", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $1dbca187654a8ef8$var$_interopRequireDefault = $eAxMI.default;

var $1dbca187654a8ef8$var$_objectSpread2 = $1dbca187654a8ef8$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $7ywyT = parcelRequire("7ywyT");

var $lsmhe = parcelRequire("lsmhe");
var $1dbca187654a8ef8$var$createOperationDescriptor = $lsmhe.createOperationDescriptor;

var $R5hJz = parcelRequire("R5hJz");
var $1dbca187654a8ef8$var$handlePotentialSnapshotErrors = $R5hJz.handlePotentialSnapshotErrors;

var $i7bEi = parcelRequire("i7bEi");

var $jiIlE = parcelRequire("jiIlE");
var $1dbca187654a8ef8$var$getRequest = $jiIlE.getRequest;

var $3lJ1W = parcelRequire("3lJ1W");
function $1dbca187654a8ef8$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $1dbca187654a8ef8$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $3lJ1W(false);
    var networkCacheConfig = (0, $1dbca187654a8ef8$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $1dbca187654a8ef8$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        $1dbca187654a8ef8$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $1dbca187654a8ef8$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $7ywyT.from(environment.lookup(operation.fragment)).map(readData);
            return $1dbca187654a8ef8$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $1dbca187654a8ef8$var$getNetworkObservable(environment, operation) {
    return $i7bEi.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $1dbca187654a8ef8$var$fetchQuery;

});

parcelRegister("5uAix", function(module, exports) {
'use strict';

var $lsmhe = parcelRequire("lsmhe");
var $3ffbe9213e8ffe7c$var$createOperationDescriptor = $lsmhe.createOperationDescriptor;

var $jiIlE = parcelRequire("jiIlE");
var $3ffbe9213e8ffe7c$var$getRequest = $jiIlE.getRequest;
function $3ffbe9213e8ffe7c$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $3ffbe9213e8ffe7c$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $3ffbe9213e8ffe7c$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $3ffbe9213e8ffe7c$var$fetchQuery_DEPRECATED;

});

parcelRegister("e6fBl", function(module, exports) {
'use strict';
var $a43dba51e9d9e252$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $a43dba51e9d9e252$var$preloadableQueryRegistry = new $a43dba51e9d9e252$var$PreloadableQueryRegistry();
module.exports = $a43dba51e9d9e252$var$preloadableQueryRegistry;

});

parcelRegister("9PHRB", function(module, exports) {
'use strict';

var $7ws7T = parcelRequire("7ws7T");
parcelRequire("UJI01");
function $728ae6d9774a767d$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $7ws7T(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $728ae6d9774a767d$var$createFragmentSpecResolver;

});
parcelRegister("7ws7T", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $57a156d5d8c63300$var$_interopRequireDefault = $eAxMI.default;

var $57a156d5d8c63300$var$_objectSpread2 = $57a156d5d8c63300$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $57a156d5d8c63300$var$_defineProperty2 = $57a156d5d8c63300$var$_interopRequireDefault((parcelRequire("2UCNB")));

var $89jkG = parcelRequire("89jkG");

var $R5hJz = parcelRequire("R5hJz");
var $57a156d5d8c63300$var$handlePotentialSnapshotErrors = $R5hJz.handlePotentialSnapshotErrors;

var $9MFqn = parcelRequire("9MFqn");

var $c5kEx = parcelRequire("c5kEx");

var $4mzHE = parcelRequire("4mzHE");

var $lsmhe = parcelRequire("lsmhe");
var $57a156d5d8c63300$var$createRequestDescriptor = $lsmhe.createRequestDescriptor;

var $gEyA1 = parcelRequire("gEyA1");
var $57a156d5d8c63300$var$areEqualSelectors = $gEyA1.areEqualSelectors, $57a156d5d8c63300$var$createReaderSelector = $gEyA1.createReaderSelector, $57a156d5d8c63300$var$getSelectorsFromObject = $gEyA1.getSelectorsFromObject;

var $fJesj = parcelRequire("fJesj");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
var $57a156d5d8c63300$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $57a156d5d8c63300$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $57a156d5d8c63300$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $57a156d5d8c63300$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$9MFqn(_nextItem, prevItem)) {
                        nextData = nextData || (0, $57a156d5d8c63300$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($4mzHE.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $57a156d5d8c63300$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $57a156d5d8c63300$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $57a156d5d8c63300$var$SelectorListResolver) && $3lJ1W(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $57a156d5d8c63300$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $57a156d5d8c63300$var$SelectorResolver) && $3lJ1W(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $57a156d5d8c63300$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $57a156d5d8c63300$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._errorResponseFields = snapshot.errorResponseFields;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._errorResponseFields = _snapshot.errorResponseFields;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($4mzHE.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $89jkG(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $57a156d5d8c63300$var$handlePotentialSnapshotErrors(this._environment, this._errorResponseFields);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $57a156d5d8c63300$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $c5kEx(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._errorResponseFields = snapshot.errorResponseFields;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($fJesj(variables, this._selector.variables)) return;
        var requestDescriptor = $57a156d5d8c63300$var$createRequestDescriptor(request, variables);
        var selector = $57a156d5d8c63300$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $57a156d5d8c63300$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $57a156d5d8c63300$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($57a156d5d8c63300$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $57a156d5d8c63300$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $57a156d5d8c63300$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $57a156d5d8c63300$var$RelayModernFragmentSpecResolver;

});
parcelRegister("9MFqn", function(module, exports) {
'use strict';
function $71f8bacde0f2ddb6$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $71f8bacde0f2ddb6$var$isScalarAndEqual;

});

parcelRegister("c5kEx", function(module, exports) {
'use strict';
function $8cc5f8e400b67ed5$var$recycleNodesInto(prevData, nextData) {
    return $8cc5f8e400b67ed5$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $8cc5f8e400b67ed5$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $8cc5f8e400b67ed5$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $8cc5f8e400b67ed5$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $8cc5f8e400b67ed5$var$recycleNodesInto;

});



parcelRegister("7xbXR", function(module, exports) {
'use strict';

var $3lJ1W = parcelRequire("3lJ1W");
var $57c4e5633528142c$var$relayContext;
var $57c4e5633528142c$var$firstReact;
function $57c4e5633528142c$var$createRelayContext(react) {
    if (!$57c4e5633528142c$var$relayContext) {
        $57c4e5633528142c$var$relayContext = react.createContext(null);
        $57c4e5633528142c$var$firstReact = react;
    }
    !(react === $57c4e5633528142c$var$firstReact) && $3lJ1W(false);
    return $57c4e5633528142c$var$relayContext;
}
module.exports = $57c4e5633528142c$var$createRelayContext;

});

parcelRegister("dF0B1", function(module, exports) {
'use strict';
var $9f1f911712080a5e$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $9f1f911712080a5e$var$suspenseSentinel() {
    return $9f1f911712080a5e$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $9f1f911712080a5e$var$isSuspenseSentinel(value) {
    return value === $9f1f911712080a5e$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $9f1f911712080a5e$var$isSuspenseSentinel,
    suspenseSentinel: $9f1f911712080a5e$var$suspenseSentinel
};

});

parcelRegister("DjzS4", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $0762d45470de30c1$var$_interopRequireDefault = $eAxMI.default;

var $0762d45470de30c1$var$_objectSpread2 = $0762d45470de30c1$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $0762d45470de30c1$var$_RelayModernRecord = $0762d45470de30c1$var$_interopRequireDefault((parcelRequire("iCsmr")));

var $0762d45470de30c1$var$_RelayRecordSource = $0762d45470de30c1$var$_interopRequireDefault((parcelRequire("bqOEh")));

var $0762d45470de30c1$var$_RelayResponseNormalizer = $0762d45470de30c1$var$_interopRequireDefault((parcelRequire("dd7Li")));
function $0762d45470de30c1$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $0762d45470de30c1$var$_RelayRecordSource["default"].create();
    var record = $0762d45470de30c1$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $0762d45470de30c1$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors);
    return (0, $0762d45470de30c1$var$_objectSpread2["default"])((0, $0762d45470de30c1$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $0762d45470de30c1$var$normalizeResponse;

});
parcelRegister("iCsmr", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $d8e1c67ee4b4a325$var$_interopRequireDefault = $eAxMI.default;

var $d8e1c67ee4b4a325$var$_defineProperty2 = $d8e1c67ee4b4a325$var$_interopRequireDefault((parcelRequire("2UCNB")));

var $d8e1c67ee4b4a325$var$_objectWithoutPropertiesLoose2 = $d8e1c67ee4b4a325$var$_interopRequireDefault((parcelRequire("fancA")));

var $d8e1c67ee4b4a325$var$_toPropertyKey2 = $d8e1c67ee4b4a325$var$_interopRequireDefault((parcelRequire("glrNX")));

var $d8e1c67ee4b4a325$var$_objectSpread2 = $d8e1c67ee4b4a325$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $3N1K4 = parcelRequire("3N1K4");

var $5QHdJ = parcelRequire("5QHdJ");
var $d8e1c67ee4b4a325$var$generateClientObjectClientID = $5QHdJ.generateClientObjectClientID, $d8e1c67ee4b4a325$var$isClientID = $5QHdJ.isClientID;

var $dF0B1 = parcelRequire("dF0B1");
var $d8e1c67ee4b4a325$var$isSuspenseSentinel = $dF0B1.isSuspenseSentinel;

var $hwgET = parcelRequire("hwgET");
var $d8e1c67ee4b4a325$var$ACTOR_IDENTIFIER_KEY = $hwgET.ACTOR_IDENTIFIER_KEY, $d8e1c67ee4b4a325$var$ERRORS_KEY = $hwgET.ERRORS_KEY, $d8e1c67ee4b4a325$var$ID_KEY = $hwgET.ID_KEY, $d8e1c67ee4b4a325$var$INVALIDATED_AT_KEY = $hwgET.INVALIDATED_AT_KEY, $d8e1c67ee4b4a325$var$REF_KEY = $hwgET.REF_KEY, $d8e1c67ee4b4a325$var$REFS_KEY = $hwgET.REFS_KEY, $d8e1c67ee4b4a325$var$RELAY_RESOLVER_VALUE_KEY = $hwgET.RELAY_RESOLVER_VALUE_KEY, $d8e1c67ee4b4a325$var$ROOT_ID = $hwgET.ROOT_ID, $d8e1c67ee4b4a325$var$TYPENAME_KEY = $hwgET.TYPENAME_KEY;

var $fJesj = parcelRequire("fJesj");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
function $d8e1c67ee4b4a325$var$clone(record) {
    return (0, $d8e1c67ee4b4a325$var$_objectSpread2["default"])({}, record);
}
function $d8e1c67ee4b4a325$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $d8e1c67ee4b4a325$var$ID_KEY && key !== $d8e1c67ee4b4a325$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $d8e1c67ee4b4a325$var$create(dataID, typeName) {
    var record = {};
    record[$d8e1c67ee4b4a325$var$ID_KEY] = dataID;
    record[$d8e1c67ee4b4a325$var$TYPENAME_KEY] = typeName;
    return record;
}
function $d8e1c67ee4b4a325$var$fromObject(json) {
    return json;
}
function $d8e1c67ee4b4a325$var$getDataID(record) {
    return record[$d8e1c67ee4b4a325$var$ID_KEY];
}
function $d8e1c67ee4b4a325$var$getFields(record) {
    if ($d8e1c67ee4b4a325$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $d8e1c67ee4b4a325$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $d8e1c67ee4b4a325$var$getType(record) {
    return record[$d8e1c67ee4b4a325$var$TYPENAME_KEY];
}
function $d8e1c67ee4b4a325$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$d8e1c67ee4b4a325$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $d8e1c67ee4b4a325$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($d8e1c67ee4b4a325$var$REF_KEY) && !value.hasOwnProperty($d8e1c67ee4b4a325$var$REFS_KEY)) && $3lJ1W(false);
    return value;
}
function $d8e1c67ee4b4a325$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $d8e1c67ee4b4a325$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$d8e1c67ee4b4a325$var$REF_KEY] === 'string') && $3lJ1W(false);
    return link[$d8e1c67ee4b4a325$var$REF_KEY];
}
function $d8e1c67ee4b4a325$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$d8e1c67ee4b4a325$var$REF_KEY] === 'string';
}
function $d8e1c67ee4b4a325$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$d8e1c67ee4b4a325$var$REFS_KEY])) && $3lJ1W(false);
    return links[$d8e1c67ee4b4a325$var$REFS_KEY];
}
function $d8e1c67ee4b4a325$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$d8e1c67ee4b4a325$var$REFS_KEY]) && links[$d8e1c67ee4b4a325$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $d8e1c67ee4b4a325$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$d8e1c67ee4b4a325$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $d8e1c67ee4b4a325$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$d8e1c67ee4b4a325$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$d8e1c67ee4b4a325$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$fJesj(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $d8e1c67ee4b4a325$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $d8e1c67ee4b4a325$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($fJesj(prevValue, nextValue) && $fJesj(prevErrors, nextErrors)) continue;
            updated = (0, $d8e1c67ee4b4a325$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$d8e1c67ee4b4a325$var$ERRORS_KEY] = (0, $d8e1c67ee4b4a325$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $d8e1c67ee4b4a325$var$setValue(updated, _storageKey2, nextValue);
        $d8e1c67ee4b4a325$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $d8e1c67ee4b4a325$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($d8e1c67ee4b4a325$var$ERRORS_KEY in record1 || $d8e1c67ee4b4a325$var$ERRORS_KEY in record2) {
        var errors1 = record1[$d8e1c67ee4b4a325$var$ERRORS_KEY], fields1 = (0, $d8e1c67ee4b4a325$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $d8e1c67ee4b4a325$var$ERRORS_KEY
        ].map($d8e1c67ee4b4a325$var$_toPropertyKey2["default"]));
        var errors2 = record2[$d8e1c67ee4b4a325$var$ERRORS_KEY], fields2 = (0, $d8e1c67ee4b4a325$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $d8e1c67ee4b4a325$var$ERRORS_KEY
        ].map($d8e1c67ee4b4a325$var$_toPropertyKey2["default"]));
        var updated = (0, $d8e1c67ee4b4a325$var$_objectSpread2["default"])((0, $d8e1c67ee4b4a325$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$d8e1c67ee4b4a325$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $d8e1c67ee4b4a325$var$_objectSpread2["default"])((0, $d8e1c67ee4b4a325$var$_objectSpread2["default"])({}, record1), record2);
}
function $d8e1c67ee4b4a325$var$freeze(record) {
    $3N1K4(record);
}
function $d8e1c67ee4b4a325$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$d8e1c67ee4b4a325$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$d8e1c67ee4b4a325$var$ERRORS_KEY] = (0, $d8e1c67ee4b4a325$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$d8e1c67ee4b4a325$var$ERRORS_KEY];
        }
    }
}
function $d8e1c67ee4b4a325$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $d8e1c67ee4b4a325$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$d8e1c67ee4b4a325$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $d8e1c67ee4b4a325$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$d8e1c67ee4b4a325$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $d8e1c67ee4b4a325$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$d8e1c67ee4b4a325$var$REF_KEY] = linkedID;
    link[$d8e1c67ee4b4a325$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $d8e1c67ee4b4a325$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$d8e1c67ee4b4a325$var$REF_KEY] === 'string' && link[$d8e1c67ee4b4a325$var$ACTOR_IDENTIFIER_KEY] != null) && $3lJ1W(false);
    return [
        link[$d8e1c67ee4b4a325$var$ACTOR_IDENTIFIER_KEY],
        link[$d8e1c67ee4b4a325$var$REF_KEY]
    ];
}
function $d8e1c67ee4b4a325$var$getResolverLinkedRecordID(record, typeName) {
    var id = $d8e1c67ee4b4a325$var$getValue(record, $d8e1c67ee4b4a325$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $d8e1c67ee4b4a325$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $3lJ1W(false);
    return $d8e1c67ee4b4a325$var$generateClientObjectClientID(typeName, id);
}
function $d8e1c67ee4b4a325$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $d8e1c67ee4b4a325$var$getValue(record, $d8e1c67ee4b4a325$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $d8e1c67ee4b4a325$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $3lJ1W(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $3lJ1W(false);
        return $d8e1c67ee4b4a325$var$generateClientObjectClientID(typeName, id);
    });
}
function $d8e1c67ee4b4a325$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $d8e1c67ee4b4a325$var$clone,
    copyFields: $d8e1c67ee4b4a325$var$copyFields,
    create: $d8e1c67ee4b4a325$var$create,
    freeze: $d8e1c67ee4b4a325$var$freeze,
    fromObject: $d8e1c67ee4b4a325$var$fromObject,
    getDataID: $d8e1c67ee4b4a325$var$getDataID,
    getErrors: $d8e1c67ee4b4a325$var$getErrors,
    getFields: $d8e1c67ee4b4a325$var$getFields,
    getInvalidationEpoch: $d8e1c67ee4b4a325$var$getInvalidationEpoch,
    getLinkedRecordID: $d8e1c67ee4b4a325$var$getLinkedRecordID,
    getLinkedRecordIDs: $d8e1c67ee4b4a325$var$getLinkedRecordIDs,
    getType: $d8e1c67ee4b4a325$var$getType,
    getValue: $d8e1c67ee4b4a325$var$getValue,
    hasValue: $d8e1c67ee4b4a325$var$hasValue,
    hasLinkedRecordID: $d8e1c67ee4b4a325$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $d8e1c67ee4b4a325$var$hasLinkedRecordIDs,
    merge: $d8e1c67ee4b4a325$var$merge,
    setErrors: $d8e1c67ee4b4a325$var$setErrors,
    setValue: $d8e1c67ee4b4a325$var$setValue,
    setLinkedRecordID: $d8e1c67ee4b4a325$var$setLinkedRecordID,
    setLinkedRecordIDs: $d8e1c67ee4b4a325$var$setLinkedRecordIDs,
    update: $d8e1c67ee4b4a325$var$update,
    getActorLinkedRecordID: $d8e1c67ee4b4a325$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $d8e1c67ee4b4a325$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $d8e1c67ee4b4a325$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $d8e1c67ee4b4a325$var$getResolverLinkedRecordIDs,
    toJSON: $d8e1c67ee4b4a325$var$toJSON
};

});
parcelRegister("fancA", function(module, exports) {
function $b0a9c99e537a2450$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $b0a9c99e537a2450$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bqOEh", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $8529692ac85bb754$var$_interopRequireDefault = $eAxMI.default;

var $8529692ac85bb754$var$_createForOfIteratorHelper2 = $8529692ac85bb754$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $iCsmr = parcelRequire("iCsmr");

var $dzrIE = parcelRequire("dzrIE");
var $8529692ac85bb754$var$EXISTENT = $dzrIE.EXISTENT, $8529692ac85bb754$var$NONEXISTENT = $dzrIE.NONEXISTENT, $8529692ac85bb754$var$UNKNOWN = $dzrIE.UNKNOWN;
var $8529692ac85bb754$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $iCsmr.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $8529692ac85bb754$var$UNKNOWN;
        return this._records.get(dataID) == null ? $8529692ac85bb754$var$NONEXISTENT : $8529692ac85bb754$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $8529692ac85bb754$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $iCsmr.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $8529692ac85bb754$var$RelayRecordSource;

});
parcelRegister("dzrIE", function(module, exports) {
'use strict';
var $9e140bb6328f4ff6$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $9e140bb6328f4ff6$var$RelayRecordState;

});


parcelRegister("dd7Li", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $99e2829a91e91ae3$var$_interopRequireDefault = $eAxMI.default;

var $99e2829a91e91ae3$var$_createForOfIteratorHelper2 = $99e2829a91e91ae3$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $99e2829a91e91ae3$var$_toConsumableArray2 = $99e2829a91e91ae3$var$_interopRequireDefault((parcelRequire("6Szcd")));

var $hz6t1 = parcelRequire("hz6t1");
var $99e2829a91e91ae3$var$ACTOR_IDENTIFIER_FIELD_NAME = $hz6t1.ACTOR_IDENTIFIER_FIELD_NAME, $99e2829a91e91ae3$var$getActorIdentifierFromPayload = $hz6t1.getActorIdentifierFromPayload;

var $4mzHE = parcelRequire("4mzHE");

var $5QHdJ = parcelRequire("5QHdJ");
var $99e2829a91e91ae3$var$generateClientID = $5QHdJ.generateClientID, $99e2829a91e91ae3$var$isClientID = $5QHdJ.isClientID;

var $2iDV0 = parcelRequire("2iDV0");
var $99e2829a91e91ae3$var$getLocalVariables = $2iDV0.getLocalVariables;

var $gdmm9 = parcelRequire("gdmm9");
var $99e2829a91e91ae3$var$buildErrorTrie = $gdmm9.buildErrorTrie, $99e2829a91e91ae3$var$getErrorsByKey = $gdmm9.getErrorsByKey, $99e2829a91e91ae3$var$getNestedErrorTrieByKey = $gdmm9.getNestedErrorTrieByKey;

var $iCsmr = parcelRequire("iCsmr");

var $gEyA1 = parcelRequire("gEyA1");
var $99e2829a91e91ae3$var$createNormalizationSelector = $gEyA1.createNormalizationSelector;

var $hwgET = parcelRequire("hwgET");
var $99e2829a91e91ae3$var$ROOT_ID = $hwgET.ROOT_ID, $99e2829a91e91ae3$var$TYPENAME_KEY = $hwgET.TYPENAME_KEY, $99e2829a91e91ae3$var$getArgumentValues = $hwgET.getArgumentValues, $99e2829a91e91ae3$var$getHandleStorageKey = $hwgET.getHandleStorageKey, $99e2829a91e91ae3$var$getModuleComponentKey = $hwgET.getModuleComponentKey, $99e2829a91e91ae3$var$getModuleOperationKey = $hwgET.getModuleOperationKey, $99e2829a91e91ae3$var$getStorageKey = $hwgET.getStorageKey;

var $fDFmX = parcelRequire("fDFmX");
var $99e2829a91e91ae3$var$TYPE_SCHEMA_TYPE = $fDFmX.TYPE_SCHEMA_TYPE, $99e2829a91e91ae3$var$generateTypeID = $fDFmX.generateTypeID;
parcelRequire("fJesj");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
function $99e2829a91e91ae3$var$normalize(recordSource, selector, response, options, errors) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $99e2829a91e91ae3$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $99e2829a91e91ae3$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $99e2829a91e91ae3$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $3lJ1W(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $99e2829a91e91ae3$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $99e2829a91e91ae3$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $99e2829a91e91ae3$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $iCsmr.create(typeID, $99e2829a91e91ae3$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $iCsmr.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $3lJ1W(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$99e2829a91e91ae3$var$TYPENAME_KEY];
        !(typeName != null) && $3lJ1W(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = $99e2829a91e91ae3$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $iCsmr.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $iCsmr.getType(record);
                        var typeID = $99e2829a91e91ae3$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $iCsmr.create(typeID, $99e2829a91e91ae3$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $iCsmr.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case 'TypeDiscriminator':
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $iCsmr.getType(record);
                    var _typeID = $99e2829a91e91ae3$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $iCsmr.create(_typeID, $99e2829a91e91ae3$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $iCsmr.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? $99e2829a91e91ae3$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $99e2829a91e91ae3$var$getStorageKey(selection, this._variables);
                    var handleKey = $99e2829a91e91ae3$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $iCsmr.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $99e2829a91e91ae3$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                    this._normalizeResolver(selection, record, data);
                    break;
                case 'RelayLiveResolver':
                    this._normalizeResolver(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $3lJ1W(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $99e2829a91e91ae3$var$_toConsumableArray2["default"])(this._path),
            selector: $99e2829a91e91ae3$var$createNormalizationSelector(defer, $iCsmr.getDataID(record), this._variables),
            typeName: $iCsmr.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $99e2829a91e91ae3$var$_toConsumableArray2["default"])(this._path),
            parentID: $iCsmr.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $3lJ1W(false);
        var typeName = $iCsmr.getType(record);
        var componentKey = $99e2829a91e91ae3$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $iCsmr.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $99e2829a91e91ae3$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $iCsmr.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $iCsmr.getDataID(record),
            operationReference: operationReference,
            path: (0, $99e2829a91e91ae3$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $3lJ1W(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $99e2829a91e91ae3$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null || $4mzHE.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $iCsmr.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $99e2829a91e91ae3$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $iCsmr.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') $iCsmr.setValue(record, storageKey, fieldValue);
        else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $99e2829a91e91ae3$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $3lJ1W(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $3lJ1W(false);
        var responseKey = field.alias || field.name;
        var storageKey = $99e2829a91e91ae3$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $iCsmr.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $99e2829a91e91ae3$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $iCsmr.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $iCsmr.getLinkedRecordID(record, storageKey) || $99e2829a91e91ae3$var$generateClientID($iCsmr.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $3lJ1W(false);
        $iCsmr.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $99e2829a91e91ae3$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $3lJ1W(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $iCsmr.getLinkedRecordID(record, storageKey) || $99e2829a91e91ae3$var$generateClientID($iCsmr.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $3lJ1W(false);
        $iCsmr.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $iCsmr.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $3lJ1W(false);
        var prevIDs = $iCsmr.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $99e2829a91e91ae3$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $3lJ1W(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $99e2829a91e91ae3$var$generateClientID($iCsmr.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $3lJ1W(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $iCsmr.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $iCsmr.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $iCsmr.getDataID(record);
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $99e2829a91e91ae3$var$normalize
};

});
parcelRegister("hz6t1", function(module, exports) {
'use strict';
var $cc9ab8cba0cf1ad9$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $2ziBa = parcelRequire("2ziBa");
var $cc9ab8cba0cf1ad9$var$getActorIdentifier = $2ziBa.getActorIdentifier;
function $cc9ab8cba0cf1ad9$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$cc9ab8cba0cf1ad9$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $cc9ab8cba0cf1ad9$var$getActorIdentifier(payload[$cc9ab8cba0cf1ad9$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $cc9ab8cba0cf1ad9$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $cc9ab8cba0cf1ad9$var$getActorIdentifierFromPayload
};

});
parcelRegister("2ziBa", function(module, exports) {
'use strict';

var $3lJ1W = parcelRequire("3lJ1W");
var $1ded46e849a53776$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $1ded46e849a53776$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $1ded46e849a53776$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $3lJ1W(false);
}
module.exports = {
    assertInternalActorIdentifier: $1ded46e849a53776$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $1ded46e849a53776$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("gdmm9", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $bcdf33bc31f8c764$var$_interopRequireDefault = $eAxMI.default;

var $bcdf33bc31f8c764$var$_objectSpread2 = $bcdf33bc31f8c764$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $bcdf33bc31f8c764$var$_objectWithoutPropertiesLoose2 = $bcdf33bc31f8c764$var$_interopRequireDefault((parcelRequire("fancA")));

var $bcdf33bc31f8c764$var$_createForOfIteratorHelper2 = $bcdf33bc31f8c764$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $bcdf33bc31f8c764$var$_toConsumableArray2 = $bcdf33bc31f8c764$var$_interopRequireDefault((parcelRequire("6Szcd")));
var $bcdf33bc31f8c764$var$_excluded = [
    "path",
    "locations"
];
var $bcdf33bc31f8c764$var$SELF = Symbol('$SELF');
function $bcdf33bc31f8c764$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $bcdf33bc31f8c764$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $bcdf33bc31f8c764$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $bcdf33bc31f8c764$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($bcdf33bc31f8c764$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $bcdf33bc31f8c764$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $bcdf33bc31f8c764$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $bcdf33bc31f8c764$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $bcdf33bc31f8c764$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $bcdf33bc31f8c764$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $bcdf33bc31f8c764$var$_toConsumableArray2["default"])(value));
            else $bcdf33bc31f8c764$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $bcdf33bc31f8c764$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $bcdf33bc31f8c764$var$_objectSpread2["default"])((0, $bcdf33bc31f8c764$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $bcdf33bc31f8c764$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $bcdf33bc31f8c764$var$SELF,
    buildErrorTrie: $bcdf33bc31f8c764$var$buildErrorTrie,
    getNestedErrorTrieByKey: $bcdf33bc31f8c764$var$getNestedErrorTrieByKey,
    getErrorsByKey: $bcdf33bc31f8c764$var$getErrorsByKey
};

});

parcelRegister("fDFmX", function(module, exports) {
'use strict';
var $b62a969b08b1d67c$var$PREFIX = 'client:__type:';
var $b62a969b08b1d67c$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $b62a969b08b1d67c$var$generateTypeID(typeName) {
    return $b62a969b08b1d67c$var$PREFIX + typeName;
}
function $b62a969b08b1d67c$var$isTypeID(id) {
    return id.indexOf($b62a969b08b1d67c$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $b62a969b08b1d67c$var$generateTypeID,
    isTypeID: $b62a969b08b1d67c$var$isTypeID,
    TYPE_SCHEMA_TYPE: $b62a969b08b1d67c$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("5VmhP", function(module, exports) {
'use strict';

var $jiIlE = parcelRequire("jiIlE");
var $4503904534e39f71$var$getInlineDataFragment = $jiIlE.getInlineDataFragment;

var $hwgET = parcelRequire("hwgET");
var $4503904534e39f71$var$FRAGMENTS_KEY = $hwgET.FRAGMENTS_KEY;

var $3lJ1W = parcelRequire("3lJ1W");
function $4503904534e39f71$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $4503904534e39f71$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $3lJ1W(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$4503904534e39f71$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $3lJ1W(false);
    return inlineData;
}
module.exports = $4503904534e39f71$var$readInlineData;

});

parcelRegister("gb6oL", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $bc72a309f842208a$var$_interopRequireDefault = $eAxMI.default;

var $bc72a309f842208a$var$_objectSpread2 = $bc72a309f842208a$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $9WnVe = parcelRequire("9WnVe");

var $2ziBa = parcelRequire("2ziBa");
var $bc72a309f842208a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $2ziBa.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $bc72a309f842208a$var$assertInternalActorIdentifier = $2ziBa.assertInternalActorIdentifier;

var $7ywyT = parcelRequire("7ywyT");

var $7jYp7 = parcelRequire("7jYp7");

var $NuDVT = parcelRequire("NuDVT");

var $kgZ8u = parcelRequire("kgZ8u");

var $o1Oba = parcelRequire("o1Oba");

var $5Djbq = parcelRequire("5Djbq");

var $DjzS4 = parcelRequire("DjzS4");

var $1dPM2 = parcelRequire("1dPM2");

var $knHW9 = parcelRequire("knHW9");

var $bqOEh = parcelRequire("bqOEh");
parcelRequire("3lJ1W");
var $bc72a309f842208a$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $bc72a309f842208a$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $5Djbq;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $7jYp7(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $o1Oba;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $knHW9(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $9WnVe, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $DjzS4;
        this.__setNet = function(newNet) {
            return _this._network = $7jYp7(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $NuDVT();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $kgZ8u(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $7ywyT.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$bc72a309f842208a$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $7ywyT.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $bqOEh.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $bc72a309f842208a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $bc72a309f842208a$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $bc72a309f842208a$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $bc72a309f842208a$var$_objectSpread2["default"])((0, $bc72a309f842208a$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $7ywyT.create(function(sink) {
            var executor = $1dPM2.execute({
                actorIdentifier: $bc72a309f842208a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $bc72a309f842208a$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $bc72a309f842208a$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $bc72a309f842208a$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$bc72a309f842208a$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $bc72a309f842208a$var$emptyFunction() {}
module.exports = $bc72a309f842208a$var$RelayModernEnvironment;

});
parcelRegister("7jYp7", function(module, exports) {
'use strict';

var $dfL9Y = parcelRequire("dfL9Y");
function $554929bd20d94937$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $dfL9Y();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = $554929bd20d94937$var$wrapNetworkWithLogObserver;

});
parcelRegister("dfL9Y", function(module, exports) {
'use strict';
var $9a61420a21bffe91$var$id = 100000;
function $9a61420a21bffe91$var$generateID() {
    return $9a61420a21bffe91$var$id++;
}
module.exports = $9a61420a21bffe91$var$generateID;

});


parcelRegister("NuDVT", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $094c58cb6101c632$var$_interopRequireDefault = $eAxMI.default;

var $094c58cb6101c632$var$_createForOfIteratorHelper2 = $094c58cb6101c632$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $3lJ1W = parcelRequire("3lJ1W");
var $094c58cb6101c632$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $094c58cb6101c632$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $094c58cb6101c632$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $094c58cb6101c632$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $094c58cb6101c632$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $094c58cb6101c632$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $3lJ1W(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $094c58cb6101c632$var$RelayOperationTracker;

});

parcelRegister("kgZ8u", function(module, exports) {
'use strict';
function $ec24b9927052eb19$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $ec24b9927052eb19$var$registerEnvironmentWithDevTools;

});

parcelRegister("o1Oba", function(module, exports) {
'use strict';

var $daAft = parcelRequire("daAft");
var $0483a51ab2db6d93$var$VIEWER_ID = $daAft.VIEWER_ID, $0483a51ab2db6d93$var$VIEWER_TYPE = $daAft.VIEWER_TYPE;
function $0483a51ab2db6d93$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $0483a51ab2db6d93$var$VIEWER_TYPE) return fieldValue.id == null ? $0483a51ab2db6d93$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $0483a51ab2db6d93$var$defaultGetDataID;

});
parcelRegister("daAft", function(module, exports) {
'use strict';

var $5QHdJ = parcelRequire("5QHdJ");
var $996853b8fa77eac1$var$generateClientID = $5QHdJ.generateClientID;

var $hwgET = parcelRequire("hwgET");
var $996853b8fa77eac1$var$ROOT_ID = $hwgET.ROOT_ID;
var $996853b8fa77eac1$var$VIEWER_ID = $996853b8fa77eac1$var$generateClientID($996853b8fa77eac1$var$ROOT_ID, 'viewer');
var $996853b8fa77eac1$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $996853b8fa77eac1$var$VIEWER_ID,
    VIEWER_TYPE: $996853b8fa77eac1$var$VIEWER_TYPE
};

});


parcelRegister("5Djbq", function(module, exports) {
'use strict';
var $419f79add85fd6fa$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $419f79add85fd6fa$var$defaultRelayFieldLogger;

});

parcelRegister("1dPM2", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $0e3f2a877214e285$var$_interopRequireDefault = $eAxMI.default;

var $0e3f2a877214e285$var$_createForOfIteratorHelper2 = $0e3f2a877214e285$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $0e3f2a877214e285$var$_toConsumableArray2 = $0e3f2a877214e285$var$_interopRequireDefault((parcelRequire("6Szcd")));

var $7ywyT = parcelRequire("7ywyT");

var $dfL9Y = parcelRequire("dfL9Y");

var $coCG3 = parcelRequire("coCG3");

var $lqHkM = parcelRequire("lqHkM");

var $4mzHE = parcelRequire("4mzHE");

var $i7r8N = parcelRequire("i7r8N");
var $0e3f2a877214e285$var$stableCopy = $i7r8N.stableCopy;

var $3LnXc = parcelRequire("3LnXc");

var $5QHdJ = parcelRequire("5QHdJ");
var $0e3f2a877214e285$var$generateClientID = $5QHdJ.generateClientID, $0e3f2a877214e285$var$generateUniqueClientID = $5QHdJ.generateUniqueClientID;

var $2iDV0 = parcelRequire("2iDV0");
var $0e3f2a877214e285$var$getLocalVariables = $2iDV0.getLocalVariables;

var $iCsmr = parcelRequire("iCsmr");

var $gEyA1 = parcelRequire("gEyA1");
var $0e3f2a877214e285$var$createNormalizationSelector = $gEyA1.createNormalizationSelector, $0e3f2a877214e285$var$createReaderSelector = $gEyA1.createReaderSelector;

var $bqOEh = parcelRequire("bqOEh");

var $hwgET = parcelRequire("hwgET");
var $0e3f2a877214e285$var$ROOT_TYPE = $hwgET.ROOT_TYPE, $0e3f2a877214e285$var$TYPENAME_KEY = $hwgET.TYPENAME_KEY, $0e3f2a877214e285$var$getStorageKey = $hwgET.getStorageKey;

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
function $0e3f2a877214e285$var$execute(config) {
    return new $0e3f2a877214e285$var$Executor(config);
}
var $0e3f2a877214e285$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log, normalizeResponse = _ref2.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $dfL9Y();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($4mzHE.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (!$4mzHE.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $3lJ1W(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $7ywyT.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            _this4._log({
                name: 'execute.next.start',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: 'execute.next.end',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $lqHkM.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $3lJ1W(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $3lJ1W(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $0e3f2a877214e285$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $0e3f2a877214e285$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $0e3f2a877214e285$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $0e3f2a877214e285$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $3lJ1W(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $0e3f2a877214e285$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $0e3f2a877214e285$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $bqOEh.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($4mzHE.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $0e3f2a877214e285$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $0e3f2a877214e285$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $3lJ1W(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $0e3f2a877214e285$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $0e3f2a877214e285$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return this._normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $coCG3(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $0e3f2a877214e285$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $0e3f2a877214e285$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $0e3f2a877214e285$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: 'execute.normalize.end',
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $coCG3(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $7ywyT.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $7ywyT.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $coCG3(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $4mzHE.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $3LnXc(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $3lJ1W(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $3lJ1W(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $0e3f2a877214e285$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $3lJ1W(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $iCsmr.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $0e3f2a877214e285$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $3lJ1W(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $3lJ1W(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $3lJ1W(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $bqOEh.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $3lJ1W(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $0e3f2a877214e285$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $bqOEh.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $3lJ1W(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $0e3f2a877214e285$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $3lJ1W(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $iCsmr.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $3lJ1W(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $3lJ1W(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$0e3f2a877214e285$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $3lJ1W(false);
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : $0e3f2a877214e285$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $3lJ1W(false);
        var selector = $0e3f2a877214e285$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $iCsmr.clone(parentRecord);
        var nextIDs = (0, $0e3f2a877214e285$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $iCsmr.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $0e3f2a877214e285$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $0e3f2a877214e285$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $0e3f2a877214e285$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $0e3f2a877214e285$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $0e3f2a877214e285$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $3lJ1W(false);
        return operationLoader;
    };
    return Executor;
}();
function $0e3f2a877214e285$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $3lJ1W(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $0e3f2a877214e285$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($0e3f2a877214e285$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $0e3f2a877214e285$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $3lJ1W(false);
}
module.exports = {
    execute: $0e3f2a877214e285$var$execute
};

});
parcelRegister("coCG3", function(module, exports) {
'use strict';

var $6E9zJ = parcelRequire("6E9zJ");
var $9065ba70a73de18e$var$REQUEST = $6E9zJ.REQUEST, $9065ba70a73de18e$var$SPLIT_OPERATION = $6E9zJ.SPLIT_OPERATION;
function $9065ba70a73de18e$var$getOperation(node) {
    switch(node.kind){
        case $9065ba70a73de18e$var$REQUEST:
            return node.operation;
        case $9065ba70a73de18e$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $9065ba70a73de18e$var$getOperation;

});

parcelRegister("lqHkM", function(module, exports) {
'use strict';
function $f99da3f3a33e98d1$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $f99da3f3a33e98d1$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $f99da3f3a33e98d1$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("3LnXc", function(module, exports) {
'use strict';
var $2bd85797d91c993d$var$_window, $2bd85797d91c993d$var$_window$performance;
var $2bd85797d91c993d$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($2bd85797d91c993d$var$_window = window) === null || $2bd85797d91c993d$var$_window === void 0 ? void 0 : ($2bd85797d91c993d$var$_window$performance = $2bd85797d91c993d$var$_window.performance) === null || $2bd85797d91c993d$var$_window$performance === void 0 ? void 0 : $2bd85797d91c993d$var$_window$performance.now) === 'function';
function $2bd85797d91c993d$var$currentTimestamp() {
    if ($2bd85797d91c993d$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $2bd85797d91c993d$var$withStartAndDuration(cb) {
    var startTime = $2bd85797d91c993d$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $2bd85797d91c993d$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $2bd85797d91c993d$var$withStartAndDuration;

});


parcelRegister("knHW9", function(module, exports) {
'use strict';
var $ed680993768cea7b$var$_global$ErrorUtils$ap, $ed680993768cea7b$var$_global$ErrorUtils;

var $6YRUL = parcelRequire("6YRUL");

var $1mftR = parcelRequire("1mftR");

var $dp56l = parcelRequire("dp56l");

var $lGf9H = parcelRequire("lGf9H");

var $bqOEh = parcelRequire("bqOEh");

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
var $ed680993768cea7b$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $ed680993768cea7b$var$applyWithGuard = ($ed680993768cea7b$var$_global$ErrorUtils$ap = $ed680993768cea7b$var$_global === null || $ed680993768cea7b$var$_global === void 0 ? void 0 : ($ed680993768cea7b$var$_global$ErrorUtils = $ed680993768cea7b$var$_global.ErrorUtils) === null || $ed680993768cea7b$var$_global$ErrorUtils === void 0 ? void 0 : $ed680993768cea7b$var$_global$ErrorUtils.applyWithGuard) !== null && $ed680993768cea7b$var$_global$ErrorUtils$ap !== void 0 ? $ed680993768cea7b$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $ed680993768cea7b$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $3lJ1W(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $6YRUL(this._store.getSource(), source);
        var recordSourceProxy = new $1mftR(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $3lJ1W(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $3lJ1W(false);
            var recordSourceSelectorProxy = new $dp56l(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $ed680993768cea7b$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $bqOEh.create();
                var mutator = new $6YRUL(_this2._store.getSource(), sink);
                var recordSourceProxy = new $1mftR(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $ed680993768cea7b$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $bqOEh.create();
        var mutator = new $6YRUL(this._store.getSource(), sink);
        var recordSourceProxy = new $1mftR(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $ed680993768cea7b$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $ed680993768cea7b$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $dp56l(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $ed680993768cea7b$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $ed680993768cea7b$var$lookupSelector(source, selector) {
    var selectorData = $lGf9H.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $ed680993768cea7b$var$RelayPublishQueue;

});
parcelRegister("6YRUL", function(module, exports) {
'use strict';

var $iCsmr = parcelRequire("iCsmr");

var $dzrIE = parcelRequire("dzrIE");
var $51522b015baf938c$var$EXISTENT = $dzrIE.EXISTENT;

var $3lJ1W = parcelRequire("3lJ1W");
var $51522b015baf938c$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $iCsmr.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $iCsmr.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $iCsmr.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $3lJ1W(false);
            sinkRecord = $iCsmr.create(dataID, $iCsmr.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $3lJ1W(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $iCsmr.copyFields(baseSource, sink);
        if (sinkSource) $iCsmr.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $iCsmr.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $51522b015baf938c$var$EXISTENT && this._sink.getStatus(dataID) !== $51522b015baf938c$var$EXISTENT) && $3lJ1W(false);
        var record = $iCsmr.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $iCsmr.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $iCsmr.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iCsmr.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $iCsmr.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iCsmr.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $iCsmr.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iCsmr.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $iCsmr.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $iCsmr.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $51522b015baf938c$var$RelayRecordSourceMutator;

});

parcelRegister("1mftR", function(module, exports) {
'use strict';

var $iCsmr = parcelRequire("iCsmr");

var $dzrIE = parcelRequire("dzrIE");
var $0fd3daa6613f8486$var$EXISTENT = $dzrIE.EXISTENT, $0fd3daa6613f8486$var$NONEXISTENT = $dzrIE.NONEXISTENT;

var $hwgET = parcelRequire("hwgET");
var $0fd3daa6613f8486$var$ROOT_ID = $hwgET.ROOT_ID, $0fd3daa6613f8486$var$ROOT_TYPE = $hwgET.ROOT_TYPE;

var $7WzOt = parcelRequire("7WzOt");
var $0fd3daa6613f8486$var$_readUpdatableFragment = $7WzOt.readUpdatableFragment;

var $2btT3 = parcelRequire("2btT3");
var $0fd3daa6613f8486$var$_readUpdatableQuery = $2btT3.readUpdatableQuery;

var $86itV = parcelRequire("86itV");

var $3lJ1W = parcelRequire("3lJ1W");
var $0fd3daa6613f8486$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $0fd3daa6613f8486$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $0fd3daa6613f8486$var$EXISTENT) _this.create(dataID, $iCsmr.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $0fd3daa6613f8486$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $3lJ1W(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $3lJ1W(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $0fd3daa6613f8486$var$ROOT_ID) && $3lJ1W(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $0fd3daa6613f8486$var$EXISTENT) this._proxies[dataID] = new $86itV(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $0fd3daa6613f8486$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($0fd3daa6613f8486$var$ROOT_ID);
        if (!root) root = this.create($0fd3daa6613f8486$var$ROOT_ID, $0fd3daa6613f8486$var$ROOT_TYPE);
        !(root && root.getType() === $0fd3daa6613f8486$var$ROOT_TYPE) && $3lJ1W(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $0fd3daa6613f8486$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $0fd3daa6613f8486$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $0fd3daa6613f8486$var$RelayRecordSourceProxy;

});
parcelRegister("7WzOt", function(module, exports) {
'use strict';

var $jiIlE = parcelRequire("jiIlE");
var $5c89baee3b25ae2b$var$getFragment = $jiIlE.getFragment;

var $gEyA1 = parcelRequire("gEyA1");
var $5c89baee3b25ae2b$var$getVariablesFromFragment = $gEyA1.getVariablesFromFragment;

var $hwgET = parcelRequire("hwgET");
var $5c89baee3b25ae2b$var$ID_KEY = $hwgET.ID_KEY;

var $53L9q = parcelRequire("53L9q");
var $5c89baee3b25ae2b$var$createUpdatableProxy = $53L9q.createUpdatableProxy;

var $3lJ1W = parcelRequire("3lJ1W");
function $5c89baee3b25ae2b$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $5c89baee3b25ae2b$var$getFragment(fragment);
    var fragmentVariables = $5c89baee3b25ae2b$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$5c89baee3b25ae2b$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $3lJ1W(false);
    return {
        updatableData: $5c89baee3b25ae2b$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $5c89baee3b25ae2b$var$readUpdatableFragment
};

});
parcelRegister("53L9q", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $3af1cebf75152469$var$_interopRequireDefault = $eAxMI.default;

var $3af1cebf75152469$var$_createForOfIteratorHelper2 = $3af1cebf75152469$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $hwgET = parcelRequire("hwgET");
var $3af1cebf75152469$var$getArgumentValues = $hwgET.getArgumentValues;
var $3af1cebf75152469$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $3af1cebf75152469$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $3af1cebf75152469$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $3af1cebf75152469$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $3af1cebf75152469$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $3af1cebf75152469$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $3af1cebf75152469$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $3af1cebf75152469$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $3af1cebf75152469$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $3af1cebf75152469$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $3af1cebf75152469$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $3af1cebf75152469$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $3af1cebf75152469$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) $3af1cebf75152469$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    $3af1cebf75152469$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RelayLiveResolver':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $3af1cebf75152469$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $3af1cebf75152469$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $3af1cebf75152469$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $3af1cebf75152469$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $3af1cebf75152469$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $3af1cebf75152469$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $3af1cebf75152469$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $3af1cebf75152469$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $3af1cebf75152469$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $3af1cebf75152469$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $3af1cebf75152469$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $3af1cebf75152469$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $3af1cebf75152469$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $3af1cebf75152469$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $3af1cebf75152469$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $3af1cebf75152469$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $3af1cebf75152469$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $3af1cebf75152469$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $3af1cebf75152469$var$createUpdatableProxy
};

});


parcelRegister("2btT3", function(module, exports) {
'use strict';

var $jiIlE = parcelRequire("jiIlE");
var $1973cac98e8daab4$var$getUpdatableQuery = $jiIlE.getUpdatableQuery;

var $53L9q = parcelRequire("53L9q");
var $1973cac98e8daab4$var$createUpdatableProxy = $53L9q.createUpdatableProxy;
function $1973cac98e8daab4$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $1973cac98e8daab4$var$getUpdatableQuery(query);
    return {
        updatableData: $1973cac98e8daab4$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $1973cac98e8daab4$var$readUpdatableQuery
};

});

parcelRegister("86itV", function(module, exports) {
'use strict';

var $5QHdJ = parcelRequire("5QHdJ");
var $5e5d385bac95fed8$var$generateClientID = $5QHdJ.generateClientID;

var $hwgET = parcelRequire("hwgET");
var $5e5d385bac95fed8$var$getStableStorageKey = $hwgET.getStableStorageKey;

var $3lJ1W = parcelRequire("3lJ1W");
var $5e5d385bac95fed8$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $3lJ1W(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $5e5d385bac95fed8$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$5e5d385bac95fed8$var$isValidLeafValue(value) && $3lJ1W(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $5e5d385bac95fed8$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $5e5d385bac95fed8$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $5e5d385bac95fed8$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $3lJ1W(false);
        var storageKey = $5e5d385bac95fed8$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $5e5d385bac95fed8$var$getStableStorageKey(name, args);
            var clientID = $5e5d385bac95fed8$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $5e5d385bac95fed8$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $3lJ1W(false);
        var storageKey = $5e5d385bac95fed8$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $5e5d385bac95fed8$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($5e5d385bac95fed8$var$isValidLeafValue);
}
module.exports = $5e5d385bac95fed8$var$RelayRecordProxy;

});


parcelRegister("dp56l", function(module, exports) {
'use strict';

var $hwgET = parcelRequire("hwgET");
var $9c21912eca971e68$var$ROOT_TYPE = $hwgET.ROOT_TYPE, $9c21912eca971e68$var$getStorageKey = $hwgET.getStorageKey;

var $7WzOt = parcelRequire("7WzOt");
var $9c21912eca971e68$var$_readUpdatableFragment = $7WzOt.readUpdatableFragment;

var $2btT3 = parcelRequire("2btT3");
var $9c21912eca971e68$var$_readUpdatableQuery = $2btT3.readUpdatableQuery;

var $3lJ1W = parcelRequire("3lJ1W");
var $9c21912eca971e68$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $9c21912eca971e68$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $3lJ1W(false);
        !(field.plural === plural) && $3lJ1W(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $9c21912eca971e68$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $9c21912eca971e68$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $9c21912eca971e68$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $9c21912eca971e68$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $9c21912eca971e68$var$RelayRecordSourceSelectorProxy;

});

parcelRegister("lGf9H", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $fc8946c1a3a45ed0$var$_interopRequireDefault = $eAxMI.default;

var $fc8946c1a3a45ed0$var$_objectSpread2 = $fc8946c1a3a45ed0$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $fc8946c1a3a45ed0$var$_defineProperty2 = $fc8946c1a3a45ed0$var$_interopRequireDefault((parcelRequire("2UCNB")));

var $fc8946c1a3a45ed0$var$_objectWithoutPropertiesLoose2 = $fc8946c1a3a45ed0$var$_interopRequireDefault((parcelRequire("fancA")));

var $fc8946c1a3a45ed0$var$_createForOfIteratorHelper2 = $fc8946c1a3a45ed0$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $fc8946c1a3a45ed0$var$_toConsumableArray2 = $fc8946c1a3a45ed0$var$_interopRequireDefault((parcelRequire("6Szcd")));
var $fc8946c1a3a45ed0$var$_excluded = [
    "message"
];

var $dF0B1 = parcelRequire("dF0B1");
var $fc8946c1a3a45ed0$var$isSuspenseSentinel = $dF0B1.isSuspenseSentinel;

var $2iDV0 = parcelRequire("2iDV0");

var $iCsmr = parcelRequire("iCsmr");

var $hwgET = parcelRequire("hwgET");
var $fc8946c1a3a45ed0$var$CLIENT_EDGE_TRAVERSAL_PATH = $hwgET.CLIENT_EDGE_TRAVERSAL_PATH, $fc8946c1a3a45ed0$var$FRAGMENT_OWNER_KEY = $hwgET.FRAGMENT_OWNER_KEY, $fc8946c1a3a45ed0$var$FRAGMENT_PROP_NAME_KEY = $hwgET.FRAGMENT_PROP_NAME_KEY, $fc8946c1a3a45ed0$var$FRAGMENTS_KEY = $hwgET.FRAGMENTS_KEY, $fc8946c1a3a45ed0$var$ID_KEY = $hwgET.ID_KEY, $fc8946c1a3a45ed0$var$MODULE_COMPONENT_KEY = $hwgET.MODULE_COMPONENT_KEY, $fc8946c1a3a45ed0$var$ROOT_ID = $hwgET.ROOT_ID, $fc8946c1a3a45ed0$var$getArgumentValues = $hwgET.getArgumentValues, $fc8946c1a3a45ed0$var$getModuleComponentKey = $hwgET.getModuleComponentKey, $fc8946c1a3a45ed0$var$getStorageKey = $hwgET.getStorageKey;

var $fKu63 = parcelRequire("fKu63");
var $fc8946c1a3a45ed0$var$NoopResolverCache = $fKu63.NoopResolverCache;

var $g6lig = parcelRequire("g6lig");
var $fc8946c1a3a45ed0$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $g6lig.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $fc8946c1a3a45ed0$var$withResolverContext = $g6lig.withResolverContext;

var $fDFmX = parcelRequire("fDFmX");
var $fc8946c1a3a45ed0$var$generateTypeID = $fDFmX.generateTypeID;

var $3lJ1W = parcelRequire("3lJ1W");
function $fc8946c1a3a45ed0$var$read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new $fc8946c1a3a45ed0$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $fc8946c1a3a45ed0$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $fc8946c1a3a45ed0$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _this$_owner$node$ope;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $fc8946c1a3a45ed0$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._errorResponseFields = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            errorResponseFields: this._errorResponseFields
        };
    };
    _proto._maybeAddErrorResponseFields = function _maybeAddErrorResponseFields(record, storageKey) {
        var errors = $iCsmr.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var _iterator = (0, $fc8946c1a3a45ed0$var$_createForOfIteratorHelper2["default"])(errors), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _error$path, _this$_selector$node$2, _this$_selector$node$3;
                var error = _step.value;
                this._errorResponseFields.push({
                    kind: 'relay_field_payload.error',
                    owner: owner,
                    fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                    error: error,
                    shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                    handled: false
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var owner = this._fragmentName;
        this._errorResponseFields.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: 'missing_expected_data.throw',
            owner: owner,
            fieldPath: fieldName,
            handled: false
        } : {
            kind: 'missing_expected_data.log',
            owner: owner,
            fieldPath: fieldName
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $3lJ1W(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._errorResponseFields.push({
                    kind: 'missing_required_field.throw',
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false
                });
                return;
            case 'LOG':
                this._errorResponseFields.push({
                    kind: 'missing_required_field.log',
                    fieldPath: fieldName,
                    owner: owner
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._errorResponseFields != null && this._errorResponseFields.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenErrorResponseFields = this._errorResponseFields;
        this._errorResponseFields = previousResponseFields;
        if (childrenErrorResponseFields != null) {
            if (this._errorResponseFields == null) this._errorResponseFields = [];
            for(var i = 0; i < childrenErrorResponseFields.length; i++)this._errorResponseFields.push($fc8946c1a3a45ed0$var$markFieldErrorHasHandled(childrenErrorResponseFields[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._errorResponseFields == null || this._errorResponseFields.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._errorResponseFields.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $fc8946c1a3a45ed0$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $fc8946c1a3a45ed0$var$_excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    $3lJ1W(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._errorResponseFields;
                    this._errorResponseFields = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $3lJ1W(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $3lJ1W(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
                return this._readResolverField(selection.field, record, data);
            case 'RelayLiveResolver':
                return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $3lJ1W(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $iCsmr.getDataID(record);
        var prevErrors = this._errorResponseFields;
        this._errorResponseFields = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                errorResponseFields: snapshot.errorResponseFields
            };
            snapshot = $fc8946c1a3a45ed0$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                errorResponseFields: snapshot.errorResponseFields
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $fc8946c1a3a45ed0$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $fc8946c1a3a45ed0$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $fc8946c1a3a45ed0$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $fc8946c1a3a45ed0$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $fc8946c1a3a45ed0$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator2 = (0, $fc8946c1a3a45ed0$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missing = _step2.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator3 = (0, $fc8946c1a3a45ed0$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var missingResolverField = _step3.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
            if (cachedSnapshot.errorResponseFields != null) {
                if (this._errorResponseFields == null) this._errorResponseFields = [];
                var _iterator4 = (0, $fc8946c1a3a45ed0$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.errorResponseFields), _step4;
                try {
                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                        var _this$_selector$node$6;
                        var error = _step4.value;
                        if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._errorResponseFields.push(error);
                        else this._errorResponseFields.push($fc8946c1a3a45ed0$var$markFieldErrorHasHandled(error));
                    }
                } catch (err) {
                    _iterator4.e(err);
                } finally{
                    _iterator4.f();
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: 'relay_resolver.error',
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false
            };
            if (this._errorResponseFields == null) this._errorResponseFields = [
                errorEvent
            ];
            else this._errorResponseFields.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) {
            var _iterator5 = (0, $fc8946c1a3a45ed0$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var recordID = _step5.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this2 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $3lJ1W(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $fc8946c1a3a45ed0$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $3lJ1W(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && $3lJ1W(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $3lJ1W(false);
                var localId = $fc8946c1a3a45ed0$var$extractIdFromResponse(itemResponse, backingField.path, _this2._owner.identifier);
                var id = _this2._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $3lJ1W(false);
                    var model = _this2._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $fc8946c1a3a45ed0$var$extractIdFromResponse(obj, backingField.path, _this2._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $fc8946c1a3a45ed0$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $3lJ1W(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $3lJ1W(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $3lJ1W(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $3lJ1W(false);
            var prevErrors = this._errorResponseFields;
            this._errorResponseFields = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $fc8946c1a3a45ed0$var$getStorageKey(field, this._variables);
        var value = $iCsmr.getValue(record, storageKey);
        if (value === null) this._maybeAddErrorResponseFields(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $fc8946c1a3a45ed0$var$getStorageKey(field, this._variables);
        var linkedID = $iCsmr.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddErrorResponseFields(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $3lJ1W(false);
        var prevErrors = this._errorResponseFields;
        this._errorResponseFields = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._errorResponseFields != null) {
            for(var i = 0; i < this._errorResponseFields.length; i++){
                var event = this._errorResponseFields[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i = this._errorResponseFields.length - 1; _i >= 0; _i--)prevErrors.push(this._errorResponseFields[_i]);
                this._errorResponseFields = prevErrors;
            }
        } else this._errorResponseFields = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $fc8946c1a3a45ed0$var$getStorageKey(field, this._variables);
        var externalRef = $iCsmr.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddErrorResponseFields(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $iCsmr.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $fc8946c1a3a45ed0$var$getStorageKey(field, this._variables);
        var linkedIDs = $iCsmr.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null) this._maybeAddErrorResponseFields(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this3 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $3lJ1W(false);
        var prevErrors = this._errorResponseFields;
        this._errorResponseFields = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this3._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $3lJ1W(false);
            var prevErrors = _this3._errorResponseFields;
            _this3._errorResponseFields = null;
            linkedArray[nextIndex] = _this3._traverse(field, linkedID, prevItem);
            _this3._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var _moduleImport$compone;
        var componentKey = $fc8946c1a3a45ed0$var$getModuleComponentKey(moduleImport.documentName);
        var component = (_moduleImport$compone = moduleImport.componentModuleProvider) !== null && _moduleImport$compone !== void 0 ? _moduleImport$compone : $iCsmr.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$fc8946c1a3a45ed0$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$fc8946c1a3a45ed0$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._errorResponseFields;
        this._errorResponseFields = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $iCsmr.getType(record);
        return typeName != null && typeName === type || $iCsmr.getDataID(record) === $fc8946c1a3a45ed0$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$fc8946c1a3a45ed0$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$fc8946c1a3a45ed0$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $3lJ1W(false);
        if (data[$fc8946c1a3a45ed0$var$ID_KEY] == null) data[$fc8946c1a3a45ed0$var$ID_KEY] = $iCsmr.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $fc8946c1a3a45ed0$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$fc8946c1a3a45ed0$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$fc8946c1a3a45ed0$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $fc8946c1a3a45ed0$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$fc8946c1a3a45ed0$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$fc8946c1a3a45ed0$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $3lJ1W(false);
        if (data[$fc8946c1a3a45ed0$var$ID_KEY] == null) data[$fc8946c1a3a45ed0$var$ID_KEY] = $iCsmr.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $fc8946c1a3a45ed0$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $2iDV0.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $iCsmr.getType(record);
        var typeRecord = this._recordSource.get($fc8946c1a3a45ed0$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $iCsmr.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function $fc8946c1a3a45ed0$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, $fc8946c1a3a45ed0$var$_objectSpread2["default"])((0, $fc8946c1a3a45ed0$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            $3lJ1W(false);
    }
}
function $fc8946c1a3a45ed0$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $fc8946c1a3a45ed0$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $fc8946c1a3a45ed0$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $fc8946c1a3a45ed0$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $3lJ1W(false);
}
module.exports = {
    read: $fc8946c1a3a45ed0$var$read
};

});
parcelRegister("fKu63", function(module, exports) {
'use strict';

var $6E9zJ = parcelRequire("6E9zJ");
var $b7727f749959ef42$var$RELAY_LIVE_RESOLVER = $6E9zJ.RELAY_LIVE_RESOLVER;

var $3lJ1W = parcelRequire("3lJ1W");
var $b7727f749959ef42$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $b7727f749959ef42$var$RELAY_LIVE_RESOLVER) && $3lJ1W(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $3lJ1W(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $b7727f749959ef42$var$NoopResolverCache
};

});




parcelRegister("ZvEpi", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $0b8e3fcb61ab73ce$var$_interopRequireDefault = $eAxMI.default;

var $0b8e3fcb61ab73ce$var$_createForOfIteratorHelper2 = $0b8e3fcb61ab73ce$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $0b8e3fcb61ab73ce$var$_defineProperty2 = $0b8e3fcb61ab73ce$var$_interopRequireDefault((parcelRequire("2UCNB")));

var $2ziBa = parcelRequire("2ziBa");
var $0b8e3fcb61ab73ce$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $2ziBa.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $0b8e3fcb61ab73ce$var$assertInternalActorIdentifier = $2ziBa.assertInternalActorIdentifier;
parcelRequire("3N1K4");

var $5rBzr = parcelRequire("5rBzr");

var $3lLP7 = parcelRequire("3lLP7");

var $o1Oba = parcelRequire("o1Oba");

var $i3RUg = parcelRequire("i3RUg");
var $0b8e3fcb61ab73ce$var$LiveResolverCache = $i3RUg.LiveResolverCache, $0b8e3fcb61ab73ce$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $i3RUg.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $0b8e3fcb61ab73ce$var$getUpdatedDataIDs = $i3RUg.getUpdatedDataIDs;

var $iCsmr = parcelRequire("iCsmr");

var $2Nwi4 = parcelRequire("2Nwi4");

var $lGf9H = parcelRequire("lGf9H");

var $c9Fnk = parcelRequire("c9Fnk");

var $jZ0pc = parcelRequire("jZ0pc");

var $hwgET = parcelRequire("hwgET");

var $hwgET = parcelRequire("hwgET");
var $0b8e3fcb61ab73ce$var$ROOT_ID = $hwgET.ROOT_ID, $0b8e3fcb61ab73ce$var$ROOT_TYPE = $hwgET.ROOT_TYPE;

var $3lJ1W = parcelRequire("3lJ1W");
var $0b8e3fcb61ab73ce$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $0b8e3fcb61ab73ce$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, $0b8e3fcb61ab73ce$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $0b8e3fcb61ab73ce$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $5rBzr;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $o1Oba;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $0b8e3fcb61ab73ce$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $jZ0pc(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        $0b8e3fcb61ab73ce$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $0b8e3fcb61ab73ce$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $0b8e3fcb61ab73ce$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $3lLP7.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $0b8e3fcb61ab73ce$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log);
        return $0b8e3fcb61ab73ce$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $lGf9H.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $0b8e3fcb61ab73ce$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $iCsmr.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $0b8e3fcb61ab73ce$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $3lJ1W(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $2Nwi4.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $3lJ1W(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $2Nwi4.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $0b8e3fcb61ab73ce$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $c9Fnk.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $iCsmr.getValue(record, $0b8e3fcb61ab73ce$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $0b8e3fcb61ab73ce$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $0b8e3fcb61ab73ce$var$initializeRecordSource(target) {
    if (!target.has($0b8e3fcb61ab73ce$var$ROOT_ID)) {
        var rootRecord = $iCsmr.create($0b8e3fcb61ab73ce$var$ROOT_ID, $0b8e3fcb61ab73ce$var$ROOT_TYPE);
        target.set($0b8e3fcb61ab73ce$var$ROOT_ID, rootRecord);
    }
}
function $0b8e3fcb61ab73ce$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $iCsmr.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $iCsmr.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $iCsmr.setValue(nextRecord, $hwgET.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $iCsmr.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $0b8e3fcb61ab73ce$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $0b8e3fcb61ab73ce$var$RelayModernStore;

});
parcelRegister("5rBzr", function(module, exports) {
'use strict';
var $3f6c9e20dcdb2f70$var$resolvedPromise = Promise.resolve();
function $3f6c9e20dcdb2f70$var$resolveImmediate(callback) {
    $3f6c9e20dcdb2f70$var$resolvedPromise.then(callback)["catch"]($3f6c9e20dcdb2f70$var$throwNext);
}
function $3f6c9e20dcdb2f70$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $3f6c9e20dcdb2f70$var$resolveImmediate;

});

parcelRegister("3lLP7", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $27086dff8bd06159$var$_interopRequireDefault = $eAxMI.default;

var $27086dff8bd06159$var$_createForOfIteratorHelper2 = $27086dff8bd06159$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $6YRUL = parcelRequire("6YRUL");

var $1mftR = parcelRequire("1mftR");

var $coCG3 = parcelRequire("coCG3");

var $5QHdJ = parcelRequire("5QHdJ");
var $27086dff8bd06159$var$isClientID = $5QHdJ.isClientID;

var $7wIlD = parcelRequire("7wIlD");

var $5RGOS = parcelRequire("5RGOS");

var $2iDV0 = parcelRequire("2iDV0");
var $27086dff8bd06159$var$getLocalVariables = $2iDV0.getLocalVariables;

var $iCsmr = parcelRequire("iCsmr");

var $dzrIE = parcelRequire("dzrIE");
var $27086dff8bd06159$var$EXISTENT = $dzrIE.EXISTENT, $27086dff8bd06159$var$UNKNOWN = $dzrIE.UNKNOWN;

var $hwgET = parcelRequire("hwgET");

var $fDFmX = parcelRequire("fDFmX");
var $27086dff8bd06159$var$TYPE_SCHEMA_TYPE = $fDFmX.TYPE_SCHEMA_TYPE, $27086dff8bd06159$var$generateTypeID = $fDFmX.generateTypeID;

var $3lJ1W = parcelRequire("3lJ1W");
var $27086dff8bd06159$var$getModuleOperationKey = $hwgET.getModuleOperationKey, $27086dff8bd06159$var$getStorageKey = $hwgET.getStorageKey, $27086dff8bd06159$var$getArgumentValues = $hwgET.getArgumentValues;
function $27086dff8bd06159$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $27086dff8bd06159$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var $27086dff8bd06159$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $6YRUL(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $1mftR(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $3lJ1W(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $27086dff8bd06159$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $27086dff8bd06159$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $27086dff8bd06159$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $27086dff8bd06159$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $27086dff8bd06159$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $27086dff8bd06159$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $27086dff8bd06159$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $27086dff8bd06159$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $27086dff8bd06159$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $27086dff8bd06159$var$UNKNOWN) this._handleMissing();
        if (status === $27086dff8bd06159$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $iCsmr.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $3lJ1W(false);
                        var _typeID = $27086dff8bd06159$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = $7wIlD(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = $5RGOS(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = $27086dff8bd06159$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $3lJ1W(false);
                    var typeID = $27086dff8bd06159$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                    _this2._checkResolver(selection, dataID);
                    break;
                case 'RelayLiveResolver':
                    _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $3lJ1W(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $3lJ1W(false);
        var operationKey = $27086dff8bd06159$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $coCG3(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $27086dff8bd06159$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $27086dff8bd06159$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $27086dff8bd06159$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $27086dff8bd06159$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $27086dff8bd06159$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $iCsmr.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $27086dff8bd06159$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $27086dff8bd06159$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $27086dff8bd06159$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $27086dff8bd06159$var$check
};

});
parcelRegister("7wIlD", function(module, exports) {
'use strict';

var $6E9zJ = parcelRequire("6E9zJ");
var $57adec1e1f2ae03e$var$LINKED_FIELD = $6E9zJ.LINKED_FIELD;

var $hwgET = parcelRequire("hwgET");
var $57adec1e1f2ae03e$var$getHandleStorageKey = $hwgET.getHandleStorageKey;

var $fJesj = parcelRequire("fJesj");

var $3lJ1W = parcelRequire("3lJ1W");
function $57adec1e1f2ae03e$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $57adec1e1f2ae03e$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $fJesj(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $57adec1e1f2ae03e$var$LINKED_FIELD) && $3lJ1W(false);
    var handleKey = $57adec1e1f2ae03e$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $57adec1e1f2ae03e$var$cloneRelayHandleSourceField;

});

parcelRegister("5RGOS", function(module, exports) {
'use strict';

var $6E9zJ = parcelRequire("6E9zJ");
var $44531e0f7cb7449c$var$SCALAR_FIELD = $6E9zJ.SCALAR_FIELD;

var $hwgET = parcelRequire("hwgET");
var $44531e0f7cb7449c$var$getHandleStorageKey = $hwgET.getHandleStorageKey;

var $fJesj = parcelRequire("fJesj");

var $3lJ1W = parcelRequire("3lJ1W");
function $44531e0f7cb7449c$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $44531e0f7cb7449c$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $fJesj(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $44531e0f7cb7449c$var$SCALAR_FIELD) && $3lJ1W(false);
    var handleKey = $44531e0f7cb7449c$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $44531e0f7cb7449c$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("i3RUg", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $d26252871223be1b$var$_interopRequireDefault = $eAxMI.default;

var $d26252871223be1b$var$_createForOfIteratorHelper2 = $d26252871223be1b$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $c5kEx = parcelRequire("c5kEx");

var $6E9zJ = parcelRequire("6E9zJ");
var $d26252871223be1b$var$RELAY_LIVE_RESOLVER = $6E9zJ.RELAY_LIVE_RESOLVER;

var $4mzHE = parcelRequire("4mzHE");

var $9mESH = parcelRequire("9mESH");

var $5QHdJ = parcelRequire("5QHdJ");
var $d26252871223be1b$var$generateClientID = $5QHdJ.generateClientID, $d26252871223be1b$var$generateClientObjectClientID = $5QHdJ.generateClientObjectClientID;

var $iCsmr = parcelRequire("iCsmr");

var $gEyA1 = parcelRequire("gEyA1");
var $d26252871223be1b$var$createNormalizationSelector = $gEyA1.createNormalizationSelector;

var $bqOEh = parcelRequire("bqOEh");

var $dd7Li = parcelRequire("dd7Li");
var $d26252871223be1b$var$normalize = $dd7Li.normalize;

var $hwgET = parcelRequire("hwgET");
var $d26252871223be1b$var$RELAY_RESOLVER_ERROR_KEY = $hwgET.RELAY_RESOLVER_ERROR_KEY, $d26252871223be1b$var$RELAY_RESOLVER_INVALIDATION_KEY = $hwgET.RELAY_RESOLVER_INVALIDATION_KEY, $d26252871223be1b$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $hwgET.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $d26252871223be1b$var$RELAY_RESOLVER_SNAPSHOT_KEY = $hwgET.RELAY_RESOLVER_SNAPSHOT_KEY, $d26252871223be1b$var$RELAY_RESOLVER_VALUE_KEY = $hwgET.RELAY_RESOLVER_VALUE_KEY, $d26252871223be1b$var$getStorageKey = $hwgET.getStorageKey;

var $k4szZ = parcelRequire("k4szZ");

var $3jh8v = parcelRequire("3jh8v");

var $dF0B1 = parcelRequire("dF0B1");
var $d26252871223be1b$var$isSuspenseSentinel = $dF0B1.isSuspenseSentinel;

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
var $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $d26252871223be1b$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $d26252871223be1b$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $d26252871223be1b$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $d26252871223be1b$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $d26252871223be1b$var$expectRecord(recordSource, recordID);
        var storageKey = $d26252871223be1b$var$getStorageKey(field, variables);
        var linkedID = $iCsmr.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $d26252871223be1b$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $d26252871223be1b$var$generateClientID(recordID, storageKey);
            linkedRecord = $iCsmr.create(linkedID, $d26252871223be1b$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $iCsmr.setValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $iCsmr.setValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $d26252871223be1b$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $3lJ1W(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $d26252871223be1b$var$expectRecord(recordSource, recordID);
            var nextRecord = $iCsmr.clone(currentRecord);
            $iCsmr.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $d26252871223be1b$var$getStorageKey(field.fragment, variables);
                var resolverID = $d26252871223be1b$var$generateClientID(recordID, fragmentStorageKey);
                $d26252871223be1b$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $d26252871223be1b$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $d26252871223be1b$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $d26252871223be1b$var$RELAY_LIVE_RESOLVER && $iCsmr.getValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $d26252871223be1b$var$generateClientID(recordID, storageKey);
            linkedRecord = $iCsmr.clone(linkedRecord);
            var _liveState = $iCsmr.getValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$3jh8v(_liveState)) $3lJ1W(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $iCsmr.setValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $iCsmr.getValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $iCsmr.getValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($d26252871223be1b$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $d26252871223be1b$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $3lJ1W(false);
        var liveState = $iCsmr.getValue(liveStateRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $iCsmr.setValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $iCsmr.setValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $iCsmr.setValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$iCsmr.hasValue(currentRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $iCsmr.clone(currentRecord);
            $iCsmr.setValue(nextRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $bqOEh.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $bqOEh.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $3lJ1W(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $iCsmr.setValue(resolverRecord, $d26252871223be1b$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$d26252871223be1b$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $k4szZ(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $3lJ1W(false);
                resolverValue = [];
                var nextSource = $bqOEh.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $3lJ1W(false);
                    var typename = $d26252871223be1b$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $d26252871223be1b$var$generateClientObjectClientID(typename, $iCsmr.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $d26252871223be1b$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $d26252871223be1b$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $3lJ1W(false);
                var _typename = $d26252871223be1b$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $d26252871223be1b$var$generateClientObjectClientID(_typename, $iCsmr.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $d26252871223be1b$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $iCsmr.setValue(resolverRecord, $d26252871223be1b$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $9mESH(resolverValue);
            $iCsmr.setValue(resolverRecord, $d26252871223be1b$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $9mESH(value);
            $iCsmr.setValue(resolverRecord, $d26252871223be1b$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $iCsmr.getValue(resolverRecord, $d26252871223be1b$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $d26252871223be1b$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$iCsmr.getValue(record, $d26252871223be1b$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $iCsmr.getValue(record, $d26252871223be1b$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $c5kEx(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($4mzHE.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $iCsmr.clone(record);
            $iCsmr.setValue(nextRecord, $d26252871223be1b$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($iCsmr.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $bqOEh.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $iCsmr.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $d26252871223be1b$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $d26252871223be1b$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $iCsmr.create(outputTypeDataID, typename);
                $iCsmr.setValue(_record, $d26252871223be1b$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $3lJ1W(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $d26252871223be1b$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $iCsmr.create(key, typeName);
            $iCsmr.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $d26252871223be1b$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $d26252871223be1b$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $d26252871223be1b$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $d26252871223be1b$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $d26252871223be1b$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $iCsmr.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $d26252871223be1b$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $d26252871223be1b$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $iCsmr.getFields(record).forEach(function(field) {
        if ($iCsmr.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $iCsmr.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($iCsmr.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $iCsmr.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $d26252871223be1b$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $iCsmr.clone(record);
    $iCsmr.setValue(nextRecord, $d26252871223be1b$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $d26252871223be1b$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $d26252871223be1b$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $d26252871223be1b$var$isResolverRecord(_record2)) $d26252871223be1b$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $d26252871223be1b$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $d26252871223be1b$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $d26252871223be1b$var$isResolverRecord(record)) $d26252871223be1b$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $d26252871223be1b$var$isResolverRecord(record) {
    return $iCsmr.getType(record) === $d26252871223be1b$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $d26252871223be1b$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $iCsmr.getValue(linkedRecord, $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $d26252871223be1b$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $3lJ1W(false);
    return record;
}
function $d26252871223be1b$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $d26252871223be1b$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $3lJ1W(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $d26252871223be1b$var$LiveResolverCache,
    getUpdatedDataIDs: $d26252871223be1b$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $d26252871223be1b$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("9mESH", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("k4szZ", function(module, exports) {
'use strict';

var $iCsmr = parcelRequire("iCsmr");

var $hwgET = parcelRequire("hwgET");
var $e9ca59aca5c15ee9$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $hwgET.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $3lJ1W = parcelRequire("3lJ1W");
function $e9ca59aca5c15ee9$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $iCsmr.getValue(record, $e9ca59aca5c15ee9$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $3lJ1W(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $e9ca59aca5c15ee9$var$getOutputTypeRecordIDs;

});

parcelRegister("3jh8v", function(module, exports) {
'use strict';
function $2690705528f18758$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $2690705528f18758$var$isLiveStateValue;

});


parcelRegister("2Nwi4", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $20993496db118612$var$_interopRequireDefault = $eAxMI.default;

var $20993496db118612$var$_objectSpread2 = $20993496db118612$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $iCsmr = parcelRequire("iCsmr");

var $bqOEh = parcelRequire("bqOEh");

var $3lJ1W = parcelRequire("3lJ1W");
var $20993496db118612$var$UNPUBLISH_RECORD_SENTINEL = $iCsmr.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $20993496db118612$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $bqOEh.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $20993496db118612$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $20993496db118612$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $bqOEh.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $20993496db118612$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $20993496db118612$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $iCsmr.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $20993496db118612$var$create(base) {
    return new $20993496db118612$var$RelayOptimisticRecordSource(base);
}
function $20993496db118612$var$getOptimisticRecordIDs(source) {
    !(source instanceof $20993496db118612$var$RelayOptimisticRecordSource) && $3lJ1W(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $20993496db118612$var$create,
    getOptimisticRecordIDs: $20993496db118612$var$getOptimisticRecordIDs
};

});

parcelRegister("c9Fnk", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $8d966b8a635785d6$var$_interopRequireDefault = $eAxMI.default;

var $8d966b8a635785d6$var$_createForOfIteratorHelper2 = $8d966b8a635785d6$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $coCG3 = parcelRequire("coCG3");

var $7wIlD = parcelRequire("7wIlD");

var $k4szZ = parcelRequire("k4szZ");

var $2iDV0 = parcelRequire("2iDV0");
var $8d966b8a635785d6$var$getLocalVariables = $2iDV0.getLocalVariables;

var $iCsmr = parcelRequire("iCsmr");

var $hwgET = parcelRequire("hwgET");

var $fDFmX = parcelRequire("fDFmX");
var $8d966b8a635785d6$var$generateTypeID = $fDFmX.generateTypeID;

var $3lJ1W = parcelRequire("3lJ1W");
var $8d966b8a635785d6$var$getStorageKey = $hwgET.getStorageKey, $8d966b8a635785d6$var$getModuleOperationKey = $hwgET.getModuleOperationKey;
function $8d966b8a635785d6$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $8d966b8a635785d6$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
var $8d966b8a635785d6$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $3lJ1W(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = $iCsmr.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $hwgET.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $iCsmr.getType(record);
                        var typeID = $8d966b8a635785d6$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = $8d966b8a635785d6$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = $7wIlD(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = $iCsmr.getType(record);
                    var _typeID = $8d966b8a635785d6$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $3lJ1W(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $k4szZ(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $8d966b8a635785d6$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $iCsmr.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $8d966b8a635785d6$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $iCsmr.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $8d966b8a635785d6$var$getStorageKey(field, this._variables);
        var dataID = $iCsmr.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $3lJ1W(false);
        var operationKey = $8d966b8a635785d6$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $iCsmr.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $coCG3(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $8d966b8a635785d6$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $8d966b8a635785d6$var$getStorageKey(field, this._variables);
        var linkedID = $iCsmr.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $8d966b8a635785d6$var$getStorageKey(field, this._variables);
        var linkedIDs = $iCsmr.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $8d966b8a635785d6$var$mark
};

});

parcelRegister("jZ0pc", function(module, exports) {
'use strict';
parcelRequire("3N1K4");

var $c5kEx = parcelRequire("c5kEx");

var $4mzHE = parcelRequire("4mzHE");

var $kYUlZ = parcelRequire("kYUlZ");

var $kyrkX = parcelRequire("kyrkX");

var $lGf9H = parcelRequire("lGf9H");
var $e8c4075113b32767$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $lGf9H.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = $c5kEx(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    errorResponseFields: backup.errorResponseFields
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $kYUlZ(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $lGf9H.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = $c5kEx(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            errorResponseFields: nextSnapshot.errorResponseFields
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $4mzHE.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($4mzHE.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $kyrkX(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $e8c4075113b32767$var$RelayStoreSubscriptions;

});
parcelRegister("kYUlZ", function(module, exports) {
'use strict';
var $f4651feee3e7c637$var$ITERATOR_KEY = Symbol.iterator;
function $f4651feee3e7c637$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$f4651feee3e7c637$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $f4651feee3e7c637$var$hasOverlappingIDs;

});

parcelRegister("kyrkX", function(module, exports) {
'use strict';

var $hwgET = parcelRequire("hwgET");
var $ef6c302f720a1540$var$ROOT_ID = $hwgET.ROOT_ID;

var $daAft = parcelRequire("daAft");
var $ef6c302f720a1540$var$VIEWER_ID = $daAft.VIEWER_ID;
var $ef6c302f720a1540$var$ITERATOR_KEY = Symbol.iterator;
function $ef6c302f720a1540$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$ef6c302f720a1540$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $ef6c302f720a1540$var$ROOT_ID && key !== $ef6c302f720a1540$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $ef6c302f720a1540$var$hasSignificantOverlappingIDs;

});



parcelRegister("6q9UY", function(module, exports) {
'use strict';

var $j0ahn = parcelRequire("j0ahn");

var $jiIlE = parcelRequire("jiIlE");
var $4accdd4a19c1fedf$var$getRequest = $jiIlE.getRequest;

var $lsmhe = parcelRequire("lsmhe");
var $4accdd4a19c1fedf$var$createOperationDescriptor = $lsmhe.createOperationDescriptor;

var $gEyA1 = parcelRequire("gEyA1");
var $4accdd4a19c1fedf$var$createReaderSelector = $gEyA1.createReaderSelector;
parcelRequire("UJI01");
function $4accdd4a19c1fedf$var$requestSubscription(environment, config) {
    var subscription = $4accdd4a19c1fedf$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $4accdd4a19c1fedf$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $j0ahn.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $4accdd4a19c1fedf$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $4accdd4a19c1fedf$var$requestSubscription;

});

parcelRegister("2IDft", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $1fae22cd29b336fe$var$_interopRequireDefault = $eAxMI.default;

var $1fae22cd29b336fe$var$_objectSpread2 = $1fae22cd29b336fe$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $hwgET = parcelRequire("hwgET");
var $1fae22cd29b336fe$var$getModuleComponentKey = $hwgET.getModuleComponentKey, $1fae22cd29b336fe$var$getModuleOperationKey = $hwgET.getModuleOperationKey;
function $1fae22cd29b336fe$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $1fae22cd29b336fe$var$_objectSpread2["default"])({}, response);
    data[$1fae22cd29b336fe$var$getModuleComponentKey(name)] = component;
    data[$1fae22cd29b336fe$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $1fae22cd29b336fe$var$createPayloadFor3DField;

});

parcelRegister("83IvQ", function(module, exports) {
'use strict';

var $gEyA1 = parcelRequire("gEyA1");
var $5de121d613fae96e$var$getDataIDsFromFragment = $gEyA1.getDataIDsFromFragment, $5de121d613fae96e$var$getSelector = $gEyA1.getSelector, $5de121d613fae96e$var$getVariablesFromFragment = $gEyA1.getVariablesFromFragment;

var $fe0nT = parcelRequire("fe0nT");

var $4mzHE = parcelRequire("4mzHE");

var $i7r8N = parcelRequire("i7r8N");
var $5de121d613fae96e$var$stableCopy = $i7r8N.stableCopy;

var $ahYK4 = parcelRequire("ahYK4");
var $5de121d613fae96e$var$intern = $ahYK4.intern;
function $5de121d613fae96e$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $5de121d613fae96e$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $5de121d613fae96e$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $5de121d613fae96e$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($4mzHE.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $4mzHE.STRING_INTERN_LEVEL <= 1 ? ids : $5de121d613fae96e$var$intern(ids, $4mzHE.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $fe0nT(fragmentVariables) ? '{}' : JSON.stringify($5de121d613fae96e$var$stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $4mzHE.STRING_INTERN_LEVEL <= 1 ? _ids : $5de121d613fae96e$var$intern(_ids, $4mzHE.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($5de121d613fae96e$var$stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $5de121d613fae96e$var$getFragmentIdentifier;

});
parcelRegister("fe0nT", function(module, exports) {
'use strict';
var $b158762022769551$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $b158762022769551$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($b158762022769551$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $b158762022769551$var$isEmptyObject;

});


parcelRegister("7Xg4a", function(module, exports) {
'use strict';

var $iDxFS = parcelRequire("iDxFS");

var $3lJ1W = parcelRequire("3lJ1W");
function $5caa817b69341e08$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $iDxFS(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $3lJ1W(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $3lJ1W(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $3lJ1W(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $5caa817b69341e08$var$getPaginationMetadata;

});
parcelRegister("iDxFS", function(module, exports) {
'use strict';

var $3lJ1W = parcelRequire("3lJ1W");
function $d915fd8b3fd74583$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $3lJ1W(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $3lJ1W(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $3lJ1W(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $3lJ1W(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $3lJ1W(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $d915fd8b3fd74583$var$getRefetchMetadata;

});


parcelRegister("cJXVv", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $94682c241bb1b912$var$_interopRequireDefault = $eAxMI.default;

var $94682c241bb1b912$var$_defineProperty2 = $94682c241bb1b912$var$_interopRequireDefault((parcelRequire("2UCNB")));

var $94682c241bb1b912$var$_objectSpread4 = $94682c241bb1b912$var$_interopRequireDefault((parcelRequire("ltNVC")));

var $3lJ1W = parcelRequire("3lJ1W");
parcelRequire("UJI01");
function $94682c241bb1b912$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $3lJ1W(false);
        var _paginationVariables = (0, $94682c241bb1b912$var$_objectSpread4["default"])((0, $94682c241bb1b912$var$_objectSpread4["default"])((0, $94682c241bb1b912$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $94682c241bb1b912$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $94682c241bb1b912$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $3lJ1W(false);
    var paginationVariables = (0, $94682c241bb1b912$var$_objectSpread4["default"])((0, $94682c241bb1b912$var$_objectSpread4["default"])((0, $94682c241bb1b912$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $94682c241bb1b912$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $94682c241bb1b912$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $94682c241bb1b912$var$getPaginationVariables;

});

parcelRegister("88zFl", function(module, exports) {
'use strict';

var $eAxMI = parcelRequire("eAxMI");
var $5ecabc8ef92a41b5$var$_interopRequireDefault = $eAxMI.default;

var $5ecabc8ef92a41b5$var$_createForOfIteratorHelper2 = $5ecabc8ef92a41b5$var$_interopRequireDefault((parcelRequire("cS9yJ")));

var $3lJ1W = parcelRequire("3lJ1W");
function $5ecabc8ef92a41b5$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $5ecabc8ef92a41b5$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $3lJ1W(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $3lJ1W(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $5ecabc8ef92a41b5$var$getValueAtPath;

});

parcelRegister("8zPeX", function(module, exports) {
'use strict';
var $63e956dac1471916$var$profileHandlersByName = {};
var $63e956dac1471916$var$defaultProfiler = {
    stop: function stop() {}
};
var $63e956dac1471916$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $63e956dac1471916$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $63e956dac1471916$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$63e956dac1471916$var$profileHandlersByName.hasOwnProperty(name)) $63e956dac1471916$var$profileHandlersByName[name] = [];
        $63e956dac1471916$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($63e956dac1471916$var$profileHandlersByName.hasOwnProperty(name)) $63e956dac1471916$var$removeFromArray($63e956dac1471916$var$profileHandlersByName[name], handler);
    }
};
function $63e956dac1471916$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $63e956dac1471916$var$RelayProfiler;

});




parcelRegister("jwKHU", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $e3753c9391812a92$var$_interopRequireDefault = $k1phe.default;

var $e3753c9391812a92$var$_extends2 = $e3753c9391812a92$var$_interopRequireDefault((parcelRequire("3plDs")));

var $e3753c9391812a92$var$_objectWithoutPropertiesLoose2 = $e3753c9391812a92$var$_interopRequireDefault((parcelRequire("ckShT")));

var $e3753c9391812a92$var$_assertThisInitialized2 = $e3753c9391812a92$var$_interopRequireDefault((parcelRequire("e7DRe")));

var $e3753c9391812a92$var$_inheritsLoose2 = $e3753c9391812a92$var$_interopRequireDefault((parcelRequire("hOgyJ")));

var $e3753c9391812a92$var$_defineProperty2 = $e3753c9391812a92$var$_interopRequireDefault((parcelRequire("fSTtW")));
var $e3753c9391812a92$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $8JMjY = parcelRequire("8JMjY");

var $3kbLN = parcelRequire("3kbLN");
var $e3753c9391812a92$var$getContainerName = $3kbLN.getContainerName;

var $jkuga = parcelRequire("jkuga");
var $e3753c9391812a92$var$assertRelayContext = $jkuga.assertRelayContext;

var $fJesj = parcelRequire("fJesj");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $e3753c9391812a92$var$createFragmentSpecResolver = $gRpMo.createFragmentSpecResolver, $e3753c9391812a92$var$getDataIDsFromObject = $gRpMo.getDataIDsFromObject, $e3753c9391812a92$var$isScalarAndEqual = $gRpMo.isScalarAndEqual;
function $e3753c9391812a92$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $e3753c9391812a92$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $e3753c9391812a92$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $e3753c9391812a92$var$_defineProperty2["default"])((0, $e3753c9391812a92$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $e3753c9391812a92$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $e3753c9391812a92$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $e3753c9391812a92$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $e3753c9391812a92$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $e3753c9391812a92$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $e3753c9391812a92$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $e3753c9391812a92$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$fJesj(prevIDs, nextIDs)) {
                resolver = $e3753c9391812a92$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $e3753c9391812a92$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $e3753c9391812a92$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$e3753c9391812a92$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $e3753c9391812a92$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $e3753c9391812a92$var$_excluded);
            return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $e3753c9391812a92$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($1oC0p.Component), (0, $e3753c9391812a92$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $e3753c9391812a92$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $e3753c9391812a92$var$createContainer(Component, fragmentSpec) {
    return $8JMjY(Component, fragmentSpec, $e3753c9391812a92$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $e3753c9391812a92$var$createContainer
};

});
parcelRegister("k1phe", function(module, exports) {
function $e937822330f75a7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $e937822330f75a7d$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3plDs", function(module, exports) {
function $27b47d375f6b6316$var$_extends() {
    return module.exports = $27b47d375f6b6316$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27b47d375f6b6316$var$_extends.apply(null, arguments);
}
module.exports = $27b47d375f6b6316$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ckShT", function(module, exports) {
function $8fb176ad25d32725$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8fb176ad25d32725$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e7DRe", function(module, exports) {
function $a480a30abe4cb4cc$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $a480a30abe4cb4cc$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hOgyJ", function(module, exports) {

var $3spaV = parcelRequire("3spaV");
function $cf73f37a45e94ff5$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $3spaV(t, o);
}
module.exports = $cf73f37a45e94ff5$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3spaV", function(module, exports) {
function $284783ded363f99c$var$_setPrototypeOf(t, e) {
    return module.exports = $284783ded363f99c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $284783ded363f99c$var$_setPrototypeOf(t, e);
}
module.exports = $284783ded363f99c$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fSTtW", function(module, exports) {

var $4XCWw = parcelRequire("4XCWw");
function $b906efb7deef3e5b$var$_defineProperty(e, r, t) {
    return (r = $4XCWw(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $b906efb7deef3e5b$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4XCWw", function(module, exports) {

var $52gpD = parcelRequire("52gpD");
var $39cae15c725408f1$var$_typeof = $52gpD.default;

var $fCLNX = parcelRequire("fCLNX");
function $39cae15c725408f1$var$toPropertyKey(t) {
    var i = $fCLNX(t, "string");
    return "symbol" == $39cae15c725408f1$var$_typeof(i) ? i : i + "";
}
module.exports = $39cae15c725408f1$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("52gpD", function(module, exports) {
function $3aa9ded37e809837$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $3aa9ded37e809837$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3aa9ded37e809837$var$_typeof(o);
}
module.exports = $3aa9ded37e809837$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fCLNX", function(module, exports) {

var $52gpD = parcelRequire("52gpD");
var $b5ff7caa9d8249fc$var$_typeof = $52gpD.default;
function $b5ff7caa9d8249fc$var$toPrimitive(t, r) {
    if ("object" != $b5ff7caa9d8249fc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b5ff7caa9d8249fc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b5ff7caa9d8249fc$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("8JMjY", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $65c802407f273141$var$_interopRequireDefault = $k1phe.default;

var $65c802407f273141$var$_extends2 = $65c802407f273141$var$_interopRequireDefault((parcelRequire("3plDs")));

var $4eTYz = parcelRequire("4eTYz");

var $3kbLN = parcelRequire("3kbLN");
var $65c802407f273141$var$getComponentName = $3kbLN.getComponentName, $65c802407f273141$var$getContainerName = $3kbLN.getContainerName;

var $cAnja = parcelRequire("cAnja");

var $i52nX = parcelRequire("i52nX");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $65c802407f273141$var$getFragment = $gRpMo.getFragment;
var $65c802407f273141$var$useContext = $1oC0p.useContext;
function $65c802407f273141$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $65c802407f273141$var$getContainerName(ComponentClass);
    $4eTYz($65c802407f273141$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $65c802407f273141$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $65c802407f273141$var$useContext($cAnja);
        !(context != null) && $3lJ1W(false);
        var queryRendererContext = $65c802407f273141$var$useContext($i52nX);
        return /*#__PURE__*/ $1oC0p.createElement(Container, (0, $65c802407f273141$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $1oC0p.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $65c802407f273141$var$buildReactRelayContainer;

});
parcelRegister("4eTYz", function(module, exports) {
'use strict';

var $3lJ1W = parcelRequire("3lJ1W");
function $3163e3deffb8eba7$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $3lJ1W(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $3lJ1W(false);
    }
}
module.exports = $3163e3deffb8eba7$var$assertFragmentMap;

});

parcelRegister("3kbLN", function(module, exports) {
'use strict';
function $26bc5e9b963d491f$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $26bc5e9b963d491f$var$getContainerName(Component) {
    return 'Relay(' + $26bc5e9b963d491f$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $26bc5e9b963d491f$var$getComponentName,
    getContainerName: $26bc5e9b963d491f$var$getContainerName
};

});

parcelRegister("i52nX", function(module, exports) {
'use strict';

var $1oC0p = parcelRequire("1oC0p");
module.exports = $1oC0p.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("jkuga", function(module, exports) {
'use strict';

var $6O8hn = parcelRequire("6O8hn");

var $3lJ1W = parcelRequire("3lJ1W");
function $e1275b8fb6e58802$var$assertRelayContext(relay) {
    !$e1275b8fb6e58802$var$isRelayContext(relay) && $3lJ1W(false);
    return relay;
}
function $e1275b8fb6e58802$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $6O8hn(context.environment);
}
module.exports = {
    assertRelayContext: $e1275b8fb6e58802$var$assertRelayContext,
    isRelayContext: $e1275b8fb6e58802$var$isRelayContext
};

});
parcelRegister("6O8hn", function(module, exports) {
'use strict';
function $4f4dd5b35875fa03$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $4f4dd5b35875fa03$var$isRelayEnvironment;

});



parcelRegister("32yQF", function(module, exports) {
'use strict';

var $cAnja = parcelRequire("cAnja");

var $i52nX = parcelRequire("i52nX");

var $fJesj = parcelRequire("fJesj");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $236c97284aae468f$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $236c97284aae468f$var$deepFreeze = $gRpMo.deepFreeze, $236c97284aae468f$var$getRequest = $gRpMo.getRequest;
var $236c97284aae468f$var$useLayoutEffect = $1oC0p.useLayoutEffect, $236c97284aae468f$var$useState = $1oC0p.useState, $236c97284aae468f$var$useRef = $1oC0p.useRef, $236c97284aae468f$var$useMemo = $1oC0p.useMemo;
var $236c97284aae468f$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $236c97284aae468f$var$useDeepCompare(value) {
    var latestValue = $1oC0p.useRef(value);
    if (!$fJesj(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $236c97284aae468f$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $236c97284aae468f$var$useDeepCompare(variables);
    var operation = $236c97284aae468f$var$useMemo(function() {
        var request = $236c97284aae468f$var$getRequest(query);
        return $236c97284aae468f$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $236c97284aae468f$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $236c97284aae468f$var$useRef(null);
    var _useState = $236c97284aae468f$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $236c97284aae468f$var$useRef(null);
    var snapshot = $236c97284aae468f$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $236c97284aae468f$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $1oC0p.createElement($cAnja.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $1oC0p.createElement($i52nX.Provider, {
        value: $236c97284aae468f$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $236c97284aae468f$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("axu15", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $7ac4451f993b38fa$var$_interopRequireDefault = $k1phe.default;

var $7ac4451f993b38fa$var$_extends2 = $7ac4451f993b38fa$var$_interopRequireDefault((parcelRequire("3plDs")));

var $7ac4451f993b38fa$var$_objectWithoutPropertiesLoose2 = $7ac4451f993b38fa$var$_interopRequireDefault((parcelRequire("ckShT")));

var $7ac4451f993b38fa$var$_assertThisInitialized2 = $7ac4451f993b38fa$var$_interopRequireDefault((parcelRequire("e7DRe")));

var $7ac4451f993b38fa$var$_inheritsLoose2 = $7ac4451f993b38fa$var$_interopRequireDefault((parcelRequire("hOgyJ")));

var $7ac4451f993b38fa$var$_defineProperty2 = $7ac4451f993b38fa$var$_interopRequireDefault((parcelRequire("fSTtW")));

var $7ac4451f993b38fa$var$_objectSpread3 = $7ac4451f993b38fa$var$_interopRequireDefault((parcelRequire("4BrRr")));
var $7ac4451f993b38fa$var$_excluded = [
    "componentRef"
], $7ac4451f993b38fa$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $7ac4451f993b38fa$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $8JMjY = parcelRequire("8JMjY");

var $KRfwx = parcelRequire("KRfwx");

var $3kbLN = parcelRequire("3kbLN");
var $7ac4451f993b38fa$var$getComponentName = $3kbLN.getComponentName, $7ac4451f993b38fa$var$getContainerName = $3kbLN.getContainerName;

var $cAnja = parcelRequire("cAnja");

var $fr8SQ = parcelRequire("fr8SQ");

var $jkuga = parcelRequire("jkuga");
var $7ac4451f993b38fa$var$assertRelayContext = $jkuga.assertRelayContext;

var $fJesj = parcelRequire("fJesj");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $7ac4451f993b38fa$var$ConnectionInterface = $gRpMo.ConnectionInterface, $7ac4451f993b38fa$var$Observable = $gRpMo.Observable, $7ac4451f993b38fa$var$RelayFeatureFlags = $gRpMo.RelayFeatureFlags, $7ac4451f993b38fa$var$createFragmentSpecResolver = $gRpMo.createFragmentSpecResolver, $7ac4451f993b38fa$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $7ac4451f993b38fa$var$getDataIDsFromObject = $gRpMo.getDataIDsFromObject, $7ac4451f993b38fa$var$getRequest = $gRpMo.getRequest, $7ac4451f993b38fa$var$getVariablesFromObject = $gRpMo.getVariablesFromObject, $7ac4451f993b38fa$var$isScalarAndEqual = $gRpMo.isScalarAndEqual;
parcelRequire("UJI01");
var $7ac4451f993b38fa$var$FORWARD = 'forward';
function $7ac4451f993b38fa$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $3lJ1W(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $7ac4451f993b38fa$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $3lJ1W(false);
    return function(prevVars, totalCount) {
        return (0, $7ac4451f993b38fa$var$_objectSpread3["default"])((0, $7ac4451f993b38fa$var$_objectSpread3["default"])({}, prevVars), {}, (0, $7ac4451f993b38fa$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $7ac4451f993b38fa$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $3lJ1W(false);
            !!foundConnectionMetadata && $3lJ1W(false);
            foundConnectionMetadata = (0, $7ac4451f993b38fa$var$_objectSpread3["default"])((0, $7ac4451f993b38fa$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $3lJ1W(false);
    return foundConnectionMetadata || {};
}
function $7ac4451f993b38fa$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $7ac4451f993b38fa$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $7ac4451f993b38fa$var$getComponentName(Component);
    var containerName = $7ac4451f993b38fa$var$getContainerName(Component);
    var metadata = $7ac4451f993b38fa$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $7ac4451f993b38fa$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $3lJ1W(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $7ac4451f993b38fa$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $7ac4451f993b38fa$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $7ac4451f993b38fa$var$_defineProperty2["default"])((0, $7ac4451f993b38fa$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $7ac4451f993b38fa$var$_defineProperty2["default"])((0, $7ac4451f993b38fa$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $7ac4451f993b38fa$var$_defineProperty2["default"])((0, $7ac4451f993b38fa$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $7ac4451f993b38fa$var$_defineProperty2["default"])((0, $7ac4451f993b38fa$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $7ac4451f993b38fa$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $7ac4451f993b38fa$var$_defineProperty2["default"])((0, $7ac4451f993b38fa$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $7ac4451f993b38fa$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $7ac4451f993b38fa$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $7ac4451f993b38fa$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $7ac4451f993b38fa$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($7ac4451f993b38fa$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $7ac4451f993b38fa$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $7ac4451f993b38fa$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($7ac4451f993b38fa$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($7ac4451f993b38fa$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $7ac4451f993b38fa$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $7ac4451f993b38fa$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $7ac4451f993b38fa$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $KRfwx(fragments, this.props);
            var nextRootVariables = $KRfwx(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$fJesj(prevRootVariables, nextRootVariables) || !$fJesj(prevIDs, nextIDs)) {
                this._cleanup();
                if ($7ac4451f993b38fa$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $7ac4451f993b38fa$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $7ac4451f993b38fa$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$7ac4451f993b38fa$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $7ac4451f993b38fa$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $7ac4451f993b38fa$var$_excluded);
            var props = (0, $7ac4451f993b38fa$var$_objectSpread3["default"])((0, $7ac4451f993b38fa$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $7ac4451f993b38fa$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $3lJ1W(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $3lJ1W(false);
            !(typeof pageInfo === 'object') && $3lJ1W(false);
            var hasMore = direction === $7ac4451f993b38fa$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $7ac4451f993b38fa$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $fr8SQ();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $7ac4451f993b38fa$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $7ac4451f993b38fa$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $7ac4451f993b38fa$var$_excluded2);
            var props = (0, $7ac4451f993b38fa$var$_objectSpread3["default"])((0, $7ac4451f993b38fa$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $KRfwx(fragments, restProps);
            fragmentVariables = $7ac4451f993b38fa$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $7ac4451f993b38fa$var$_objectSpread3["default"])((0, $7ac4451f993b38fa$var$_objectSpread3["default"])((0, $7ac4451f993b38fa$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $3lJ1W(false);
            fetchVariables = (0, $7ac4451f993b38fa$var$_objectSpread3["default"])((0, $7ac4451f993b38fa$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $7ac4451f993b38fa$var$_objectSpread3["default"])((0, $7ac4451f993b38fa$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $7ac4451f993b38fa$var$getRequest(connectionConfig.query);
            var operation = $7ac4451f993b38fa$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$fJesj(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $7ac4451f993b38fa$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $7ac4451f993b38fa$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $7ac4451f993b38fa$var$_excluded3);
            return /*#__PURE__*/ $1oC0p.createElement($cAnja.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $1oC0p.createElement(Component, (0, $7ac4451f993b38fa$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($1oC0p.Component), (0, $7ac4451f993b38fa$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $7ac4451f993b38fa$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $8JMjY(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $7ac4451f993b38fa$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $7ac4451f993b38fa$var$createContainer
};

});
parcelRegister("4BrRr", function(module, exports) {

var $fSTtW = parcelRequire("fSTtW");
function $35a03abc8cf73254$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35a03abc8cf73254$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35a03abc8cf73254$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fSTtW(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35a03abc8cf73254$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $35a03abc8cf73254$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("KRfwx", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $08cd9a3602ccd860$var$_interopRequireDefault = $k1phe.default;

var $08cd9a3602ccd860$var$_objectSpread2 = $08cd9a3602ccd860$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $gRpMo = parcelRequire("gRpMo");
var $08cd9a3602ccd860$var$getSelector = $gRpMo.getSelector;
function $08cd9a3602ccd860$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $08cd9a3602ccd860$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $08cd9a3602ccd860$var$_objectSpread2["default"])((0, $08cd9a3602ccd860$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $08cd9a3602ccd860$var$getRootVariablesForFragments;

});

parcelRegister("fr8SQ", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $b3d044bb39135b10$var$_interopRequireDefault = $k1phe.default;

var $b3d044bb39135b10$var$_defineProperty2 = $b3d044bb39135b10$var$_interopRequireDefault((parcelRequire("fSTtW")));

var $3lJ1W = parcelRequire("3lJ1W");

var $gRpMo = parcelRequire("gRpMo");
var $b3d044bb39135b10$var$fetchQuery = $gRpMo.__internal.fetchQuery, $b3d044bb39135b10$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $b3d044bb39135b10$var$isRelayModernEnvironment = $gRpMo.isRelayModernEnvironment;
var $b3d044bb39135b10$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $b3d044bb39135b10$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $b3d044bb39135b10$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$b3d044bb39135b10$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $b3d044bb39135b10$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $3lJ1W(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $b3d044bb39135b10$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $3lJ1W(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $3lJ1W(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $b3d044bb39135b10$var$ReactRelayQueryFetcher;

});


parcelRegister("7YNW6", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $5cf4df42dc0bcfe2$var$_interopRequireDefault = $k1phe.default;

var $5cf4df42dc0bcfe2$var$_objectSpread2 = $5cf4df42dc0bcfe2$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $5cf4df42dc0bcfe2$var$_assertThisInitialized2 = $5cf4df42dc0bcfe2$var$_interopRequireDefault((parcelRequire("e7DRe")));

var $5cf4df42dc0bcfe2$var$_inheritsLoose2 = $5cf4df42dc0bcfe2$var$_interopRequireDefault((parcelRequire("hOgyJ")));

var $5cf4df42dc0bcfe2$var$_defineProperty2 = $5cf4df42dc0bcfe2$var$_interopRequireDefault((parcelRequire("fSTtW")));

var $cAnja = parcelRequire("cAnja");

var $fr8SQ = parcelRequire("fr8SQ");

var $i52nX = parcelRequire("i52nX");

var $fJesj = parcelRequire("fJesj");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $5cf4df42dc0bcfe2$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $5cf4df42dc0bcfe2$var$deepFreeze = $gRpMo.deepFreeze, $5cf4df42dc0bcfe2$var$getRequest = $gRpMo.getRequest;
var $5cf4df42dc0bcfe2$var$requestCache = {};
var $5cf4df42dc0bcfe2$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $5cf4df42dc0bcfe2$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $5cf4df42dc0bcfe2$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $5cf4df42dc0bcfe2$var$_defineProperty2["default"])((0, $5cf4df42dc0bcfe2$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $5cf4df42dc0bcfe2$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $5cf4df42dc0bcfe2$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $5cf4df42dc0bcfe2$var$getRequest(query);
            requestCacheKey = $5cf4df42dc0bcfe2$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey] ? $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey].queryFetcher : new $fr8SQ();
        } else queryFetcher = new $fr8SQ();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $5cf4df42dc0bcfe2$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $5cf4df42dc0bcfe2$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$fJesj(prevState.prevPropsVariables, nextProps.variables)) return $5cf4df42dc0bcfe2$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $5cf4df42dc0bcfe2$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $5cf4df42dc0bcfe2$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $5cf4df42dc0bcfe2$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $1oC0p.createElement($cAnja.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $1oC0p.createElement($i52nX.Provider, {
            value: $5cf4df42dc0bcfe2$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($1oC0p.Component);
function $5cf4df42dc0bcfe2$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $5cf4df42dc0bcfe2$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $5cf4df42dc0bcfe2$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $5cf4df42dc0bcfe2$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $5cf4df42dc0bcfe2$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $5cf4df42dc0bcfe2$var$getRequest(query);
        var requestCacheKey = $5cf4df42dc0bcfe2$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey] ? $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey].queryFetcher : new $fr8SQ(prevSelectionReferences);
    } else queryFetcher = new $fr8SQ(prevSelectionReferences);
    return (0, $5cf4df42dc0bcfe2$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $5cf4df42dc0bcfe2$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $5cf4df42dc0bcfe2$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $5cf4df42dc0bcfe2$var$getRequest(query);
        var operation = $5cf4df42dc0bcfe2$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey]) {
            var snapshot = $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $5cf4df42dc0bcfe2$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $5cf4df42dc0bcfe2$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $5cf4df42dc0bcfe2$var$getRequestCacheKey(request.params, props.variables);
            $5cf4df42dc0bcfe2$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $5cf4df42dc0bcfe2$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $5cf4df42dc0bcfe2$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $5cf4df42dc0bcfe2$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $5cf4df42dc0bcfe2$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $5cf4df42dc0bcfe2$var$ReactRelayQueryRenderer;

});

parcelRegister("9jeIJ", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $6c714e99de6d7f25$var$_interopRequireDefault = $k1phe.default;

var $6c714e99de6d7f25$var$_extends2 = $6c714e99de6d7f25$var$_interopRequireDefault((parcelRequire("3plDs")));

var $6c714e99de6d7f25$var$_objectWithoutPropertiesLoose2 = $6c714e99de6d7f25$var$_interopRequireDefault((parcelRequire("ckShT")));

var $6c714e99de6d7f25$var$_objectSpread2 = $6c714e99de6d7f25$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $6c714e99de6d7f25$var$_assertThisInitialized2 = $6c714e99de6d7f25$var$_interopRequireDefault((parcelRequire("e7DRe")));

var $6c714e99de6d7f25$var$_inheritsLoose2 = $6c714e99de6d7f25$var$_interopRequireDefault((parcelRequire("hOgyJ")));

var $6c714e99de6d7f25$var$_defineProperty2 = $6c714e99de6d7f25$var$_interopRequireDefault((parcelRequire("fSTtW")));
var $6c714e99de6d7f25$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $8JMjY = parcelRequire("8JMjY");

var $KRfwx = parcelRequire("KRfwx");

var $3kbLN = parcelRequire("3kbLN");
var $6c714e99de6d7f25$var$getContainerName = $3kbLN.getContainerName;

var $cAnja = parcelRequire("cAnja");

var $fr8SQ = parcelRequire("fr8SQ");

var $jkuga = parcelRequire("jkuga");
var $6c714e99de6d7f25$var$assertRelayContext = $jkuga.assertRelayContext;

var $fJesj = parcelRequire("fJesj");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $6c714e99de6d7f25$var$Observable = $gRpMo.Observable, $6c714e99de6d7f25$var$createFragmentSpecResolver = $gRpMo.createFragmentSpecResolver, $6c714e99de6d7f25$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $6c714e99de6d7f25$var$getDataIDsFromObject = $gRpMo.getDataIDsFromObject, $6c714e99de6d7f25$var$getRequest = $gRpMo.getRequest, $6c714e99de6d7f25$var$getVariablesFromObject = $gRpMo.getVariablesFromObject, $6c714e99de6d7f25$var$isScalarAndEqual = $gRpMo.isScalarAndEqual;
parcelRequire("UJI01");
function $6c714e99de6d7f25$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $6c714e99de6d7f25$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $6c714e99de6d7f25$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $6c714e99de6d7f25$var$_defineProperty2["default"])((0, $6c714e99de6d7f25$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $6c714e99de6d7f25$var$_defineProperty2["default"])((0, $6c714e99de6d7f25$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $6c714e99de6d7f25$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $KRfwx(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $6c714e99de6d7f25$var$_objectSpread2["default"])((0, $6c714e99de6d7f25$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $6c714e99de6d7f25$var$_objectSpread2["default"])((0, $6c714e99de6d7f25$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $6c714e99de6d7f25$var$getRequest(taggedNode);
                var operation = $6c714e99de6d7f25$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $6c714e99de6d7f25$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $6c714e99de6d7f25$var$_objectSpread2["default"])((0, $6c714e99de6d7f25$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $6c714e99de6d7f25$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $6c714e99de6d7f25$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $6c714e99de6d7f25$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $6c714e99de6d7f25$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $6c714e99de6d7f25$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $6c714e99de6d7f25$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $KRfwx(fragments, prevProps);
            var nextRootVariables = $KRfwx(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$fJesj(prevRootVariables, nextRootVariables) || !$fJesj(prevIDs, nextIDs)) {
                resolver = $6c714e99de6d7f25$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $6c714e99de6d7f25$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$6c714e99de6d7f25$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $6c714e99de6d7f25$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $fr8SQ();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $6c714e99de6d7f25$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $6c714e99de6d7f25$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $1oC0p.createElement($cAnja.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $1oC0p.createElement(Component, (0, $6c714e99de6d7f25$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($1oC0p.Component), (0, $6c714e99de6d7f25$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $6c714e99de6d7f25$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $6c714e99de6d7f25$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $8JMjY(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $6c714e99de6d7f25$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $6c714e99de6d7f25$var$createContainer
};

});

parcelRegister("6njMj", function(module, exports) {
'use strict';

var $lNbDu = parcelRequire("lNbDu");

var $9Z8K4 = parcelRequire("9Z8K4");

var $1oC0p = parcelRequire("1oC0p");

var $1oC0p = parcelRequire("1oC0p");
var $4a443b9e5b4e149a$var$useContext = $1oC0p.useContext, $4a443b9e5b4e149a$var$useEffect = $1oC0p.useEffect;
parcelRequire("UJI01");
function $4a443b9e5b4e149a$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $4a443b9e5b4e149a$var$useContext($lNbDu);
    var environment = $9Z8K4();
    $4a443b9e5b4e149a$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $1oC0p.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $4a443b9e5b4e149a$var$EntryPointContainer;

});
parcelRegister("lNbDu", function(module, exports) {
'use strict';

var $1oC0p = parcelRequire("1oC0p");
var $fdd733354fa75adf$var$ProfilerContext = $1oC0p.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $fdd733354fa75adf$var$ProfilerContext;

});

parcelRegister("9Z8K4", function(module, exports) {
'use strict';

var $cAnja = parcelRequire("cAnja");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");
var $7450978de56dec72$var$useContext = $1oC0p.useContext;
function $7450978de56dec72$var$useRelayEnvironment() {
    var context = $7450978de56dec72$var$useContext($cAnja);
    !(context != null) && $3lJ1W(false);
    return context.environment;
}
module.exports = $7450978de56dec72$var$useRelayEnvironment;

});


parcelRegister("9JReD", function(module, exports) {
'use strict';

var $kT5XY = parcelRequire("kT5XY");
var $71719c5f599c16e5$var$loadQuery = $kT5XY.loadQuery;
function $71719c5f599c16e5$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $71719c5f599c16e5$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $71719c5f599c16e5$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $71719c5f599c16e5$var$loadEntryPoint;

});
parcelRegister("kT5XY", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $f34d9276e3edadab$var$_interopRequireDefault = $k1phe.default;

var $f34d9276e3edadab$var$_objectSpread2 = $f34d9276e3edadab$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $3lJ1W = parcelRequire("3lJ1W");

var $gRpMo = parcelRequire("gRpMo");
var $f34d9276e3edadab$var$fetchQueryDeduped = $gRpMo.__internal.fetchQueryDeduped, $f34d9276e3edadab$var$Observable = $gRpMo.Observable, $f34d9276e3edadab$var$PreloadableQueryRegistry = $gRpMo.PreloadableQueryRegistry, $f34d9276e3edadab$var$RelayFeatureFlags = $gRpMo.RelayFeatureFlags, $f34d9276e3edadab$var$ReplaySubject = $gRpMo.ReplaySubject, $f34d9276e3edadab$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $f34d9276e3edadab$var$getRequest = $gRpMo.getRequest, $f34d9276e3edadab$var$getRequestIdentifier = $gRpMo.getRequestIdentifier;
var $f34d9276e3edadab$var$fetchKey = 100001;
function $f34d9276e3edadab$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $f34d9276e3edadab$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $f34d9276e3edadab$var$_objectSpread2["default"])((0, $f34d9276e3edadab$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $f34d9276e3edadab$var$ReplaySubject();
    var returnedObservable = $f34d9276e3edadab$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        didMakeNetworkRequest = true;
        var observable;
        var subject = new $f34d9276e3edadab$var$ReplaySubject();
        if ($f34d9276e3edadab$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
            var identifier = 'raw-network-request-' + $f34d9276e3edadab$var$getRequestIdentifier(params, variables);
            observable = $f34d9276e3edadab$var$fetchQueryDeduped(environment, identifier, function() {
                var network = environment.getNetwork();
                return network.execute(params, variables, networkCacheConfig);
            });
        } else {
            var network = environment.getNetwork();
            observable = network.execute(params, variables, networkCacheConfig);
        }
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $f34d9276e3edadab$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        if ($f34d9276e3edadab$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $f34d9276e3edadab$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $f34d9276e3edadab$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $3lJ1W(false);
        var _module = $f34d9276e3edadab$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $f34d9276e3edadab$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $f34d9276e3edadab$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $f34d9276e3edadab$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $f34d9276e3edadab$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $f34d9276e3edadab$var$loadQuery
};

});


parcelRegister("1fX9m", function(module, exports) {
'use strict';

var $cAnja = parcelRequire("cAnja");

var $1oC0p = parcelRequire("1oC0p");
var $0ea513216b1852a8$var$useMemo = $1oC0p.useMemo;
function $0ea513216b1852a8$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $0ea513216b1852a8$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $1oC0p.createElement($cAnja.Provider, {
        value: context
    }, children);
}
module.exports = $0ea513216b1852a8$var$RelayEnvironmentProvider;

});

parcelRegister("l5cr1", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $f593b5e3c9b4ebae$var$_interopRequireDefault = $k1phe.default;

var $f593b5e3c9b4ebae$var$_objectSpread2 = $f593b5e3c9b4ebae$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $h83sS = parcelRequire("h83sS");
function $f593b5e3c9b4ebae$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $h83sS(query, variables, (0, $f593b5e3c9b4ebae$var$_objectSpread2["default"])((0, $f593b5e3c9b4ebae$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $f593b5e3c9b4ebae$var$useClientQuery;

});
parcelRegister("h83sS", function(module, exports) {
'use strict';

var $lg4JJ = parcelRequire("lg4JJ");

var $1RbyQ = parcelRequire("1RbyQ");

var $9Z8K4 = parcelRequire("9Z8K4");

var $gRpMo = parcelRequire("gRpMo");
var $c785df0b1fdefd5e$var$fetchQuery = $gRpMo.__internal.fetchQuery;
function $c785df0b1fdefd5e$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $9Z8K4();
    var query = $1RbyQ(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $lg4JJ({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $c785df0b1fdefd5e$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $c785df0b1fdefd5e$var$useLazyLoadQuery;

});
parcelRegister("lg4JJ", function(module, exports) {
'use strict';

var $lNbDu = parcelRequire("lNbDu");

var $bFUpt = parcelRequire("bFUpt");
var $f79ec43251c9385d$var$getQueryCacheIdentifier = $bFUpt.getQueryCacheIdentifier, $f79ec43251c9385d$var$getQueryResourceForEnvironment = $bFUpt.getQueryResourceForEnvironment;

var $3yYoL = parcelRequire("3yYoL");

var $4fCQk = parcelRequire("4fCQk");

var $9Z8K4 = parcelRequire("9Z8K4");

var $1oC0p = parcelRequire("1oC0p");
var $f79ec43251c9385d$var$useContext = $1oC0p.useContext, $f79ec43251c9385d$var$useEffect = $1oC0p.useEffect, $f79ec43251c9385d$var$useState = $1oC0p.useState, $f79ec43251c9385d$var$useRef = $1oC0p.useRef;
function $f79ec43251c9385d$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $9Z8K4();
    var profilerContext = $f79ec43251c9385d$var$useContext($lNbDu);
    var QueryResource = $f79ec43251c9385d$var$getQueryResourceForEnvironment(environment);
    var _useState = $f79ec43251c9385d$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $3yYoL(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $f79ec43251c9385d$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $f79ec43251c9385d$var$useRef(false);
    $f79ec43251c9385d$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $f79ec43251c9385d$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $f79ec43251c9385d$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $4fCQk(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $f79ec43251c9385d$var$useLazyLoadQueryNode;

});
parcelRegister("bFUpt", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $87ff47e23213537c$var$_interopRequireDefault = $k1phe.default;

var $87ff47e23213537c$var$_objectSpread2 = $87ff47e23213537c$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $87ff47e23213537c$var$_defineProperty2 = $87ff47e23213537c$var$_interopRequireDefault((parcelRequire("fSTtW")));

var $4hDPs = parcelRequire("4hDPs");

var $jBGii = parcelRequire("jBGii");

var $3lJ1W = parcelRequire("3lJ1W");

var $gRpMo = parcelRequire("gRpMo");
var $87ff47e23213537c$var$isPromise = $gRpMo.isPromise;
parcelRequire("UJI01");
var $87ff47e23213537c$var$CACHE_CAPACITY = 1000;
var $87ff47e23213537c$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $87ff47e23213537c$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $87ff47e23213537c$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $87ff47e23213537c$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $87ff47e23213537c$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $87ff47e23213537c$var$operationIsLiveQuery(operation) ? $87ff47e23213537c$var$DEFAULT_LIVE_FETCH_POLICY : $87ff47e23213537c$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $87ff47e23213537c$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $87ff47e23213537c$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $87ff47e23213537c$var$nextID = 200000;
function $87ff47e23213537c$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $87ff47e23213537c$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $jBGii(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $87ff47e23213537c$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $87ff47e23213537c$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $87ff47e23213537c$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $4hDPs.create($87ff47e23213537c$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $87ff47e23213537c$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $87ff47e23213537c$var$operationIsLiveQuery(operation) ? $87ff47e23213537c$var$DEFAULT_LIVE_FETCH_POLICY : $87ff47e23213537c$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $87ff47e23213537c$var$_objectSpread2["default"])((0, $87ff47e23213537c$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($87ff47e23213537c$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $87ff47e23213537c$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $87ff47e23213537c$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $87ff47e23213537c$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $87ff47e23213537c$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $87ff47e23213537c$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $87ff47e23213537c$var$_objectSpread2["default"])((0, $87ff47e23213537c$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($87ff47e23213537c$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $87ff47e23213537c$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $3lJ1W(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $87ff47e23213537c$var$createQueryResource(environment) {
    return new $87ff47e23213537c$var$QueryResourceImpl(environment);
}
var $87ff47e23213537c$var$dataResources = $87ff47e23213537c$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $87ff47e23213537c$var$getQueryResourceForEnvironment(environment) {
    var cached = $87ff47e23213537c$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $87ff47e23213537c$var$createQueryResource(environment);
    $87ff47e23213537c$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $87ff47e23213537c$var$createQueryResource,
    getQueryResourceForEnvironment: $87ff47e23213537c$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $87ff47e23213537c$var$getQueryCacheIdentifier
};

});
parcelRegister("4hDPs", function(module, exports) {
'use strict';

var $3lJ1W = parcelRequire("3lJ1W");
var $31e7a521f6c40fb2$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $3lJ1W(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $31e7a521f6c40fb2$var$create(capacity) {
    return new $31e7a521f6c40fb2$var$LRUCache(capacity);
}
module.exports = {
    create: $31e7a521f6c40fb2$var$create
};

});

parcelRegister("jBGii", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $e46247b9d51768d3$var$_interopRequireDefault = $k1phe.default;

var $e46247b9d51768d3$var$_defineProperty2 = $e46247b9d51768d3$var$_interopRequireDefault((parcelRequire("fSTtW")));
parcelRequire("UJI01");
var $e46247b9d51768d3$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $e46247b9d51768d3$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $e46247b9d51768d3$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $e46247b9d51768d3$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $e46247b9d51768d3$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $e46247b9d51768d3$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $e46247b9d51768d3$var$SuspenseResource;

});


parcelRegister("3yYoL", function(module, exports) {
'use strict';

var $9izfK = parcelRequire("9izfK");

var $1oC0p = parcelRequire("1oC0p");
var $298365f62ae57fab$var$useCallback = $1oC0p.useCallback, $298365f62ae57fab$var$useEffect = $1oC0p.useEffect;
function $298365f62ae57fab$var$useFetchTrackingRef() {
    var subscriptionRef = $9izfK(null);
    var isFetchingRef = $9izfK(false);
    var disposeFetch = $298365f62ae57fab$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $298365f62ae57fab$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $298365f62ae57fab$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $298365f62ae57fab$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $298365f62ae57fab$var$useFetchTrackingRef;

});
parcelRegister("9izfK", function(module, exports) {
'use strict';

var $1oC0p = parcelRequire("1oC0p");
var $6c5124029a6b90f4$var$useMemo = $1oC0p.useMemo;
function $6c5124029a6b90f4$var$useUnsafeRef_DEPRECATED(init) {
    return $6c5124029a6b90f4$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $6c5124029a6b90f4$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("4fCQk", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $3186b1930c64eee6$var$_interopRequireDefault = $k1phe.default;

var $3186b1930c64eee6$var$_useFragmentInternal_CURRENT = $3186b1930c64eee6$var$_interopRequireDefault((parcelRequire("4NywT")));

var $3186b1930c64eee6$var$_useFragmentInternal_EXPERIMENTAL = $3186b1930c64eee6$var$_interopRequireDefault((parcelRequire("bG2jK")));

var $gRpMo = parcelRequire("gRpMo");
function $3186b1930c64eee6$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($gRpMo.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $3186b1930c64eee6$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $3186b1930c64eee6$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $3186b1930c64eee6$var$useFragmentInternal;

});
parcelRegister("4NywT", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $37e685d955bc3201$var$_interopRequireDefault = $k1phe.default;

var $37e685d955bc3201$var$_objectSpread2 = $37e685d955bc3201$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $37e685d955bc3201$var$_createForOfIteratorHelper2 = $37e685d955bc3201$var$_interopRequireDefault((parcelRequire("cv6F1")));

var $37e685d955bc3201$var$_toConsumableArray2 = $37e685d955bc3201$var$_interopRequireDefault((parcelRequire("3wDmv")));

var $bFUpt = parcelRequire("bFUpt");
var $37e685d955bc3201$var$getQueryResourceForEnvironment = $bFUpt.getQueryResourceForEnvironment;

var $9Z8K4 = parcelRequire("9Z8K4");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");
var $37e685d955bc3201$var$useDebugValue = $1oC0p.useDebugValue, $37e685d955bc3201$var$useEffect = $1oC0p.useEffect, $37e685d955bc3201$var$useMemo = $1oC0p.useMemo, $37e685d955bc3201$var$useRef = $1oC0p.useRef, $37e685d955bc3201$var$useState = $1oC0p.useState;

var $gRpMo = parcelRequire("gRpMo");
var $37e685d955bc3201$var$_require3$__internal = $gRpMo.__internal, $37e685d955bc3201$var$fetchQueryInternal = $37e685d955bc3201$var$_require3$__internal.fetchQuery, $37e685d955bc3201$var$getPromiseForActiveRequest = $37e685d955bc3201$var$_require3$__internal.getPromiseForActiveRequest, $37e685d955bc3201$var$RelayFeatureFlags = $gRpMo.RelayFeatureFlags, $37e685d955bc3201$var$areEqualSelectors = $gRpMo.areEqualSelectors, $37e685d955bc3201$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $37e685d955bc3201$var$getPendingOperationsForFragment = $gRpMo.getPendingOperationsForFragment, $37e685d955bc3201$var$getSelector = $gRpMo.getSelector, $37e685d955bc3201$var$getVariablesFromFragment = $gRpMo.getVariablesFromFragment, $37e685d955bc3201$var$handlePotentialSnapshotErrors = $gRpMo.handlePotentialSnapshotErrors, $37e685d955bc3201$var$recycleNodesInto = $gRpMo.recycleNodesInto;
parcelRequire("UJI01");
function $37e685d955bc3201$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $37e685d955bc3201$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $37e685d955bc3201$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $37e685d955bc3201$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $37e685d955bc3201$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $37e685d955bc3201$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $37e685d955bc3201$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $37e685d955bc3201$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $37e685d955bc3201$var$handlePotentialSnapshotErrors(environment, state.snapshot.errorResponseFields);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $37e685d955bc3201$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $37e685d955bc3201$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $37e685d955bc3201$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $37e685d955bc3201$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $37e685d955bc3201$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $3lJ1W(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $37e685d955bc3201$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $37e685d955bc3201$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $37e685d955bc3201$var$_objectSpread2["default"])((0, $37e685d955bc3201$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $37e685d955bc3201$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $37e685d955bc3201$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $37e685d955bc3201$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $37e685d955bc3201$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $37e685d955bc3201$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $37e685d955bc3201$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $37e685d955bc3201$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $37e685d955bc3201$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $37e685d955bc3201$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $37e685d955bc3201$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $37e685d955bc3201$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $37e685d955bc3201$var$useMemo(function() {
        return $37e685d955bc3201$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $3lJ1W(false);
    else !!Array.isArray(fragmentRef) && $3lJ1W(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $3lJ1W(false);
    var environment = $9Z8K4();
    var _useState = $37e685d955bc3201$var$useState(function() {
        return $37e685d955bc3201$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $37e685d955bc3201$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $37e685d955bc3201$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $37e685d955bc3201$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$37e685d955bc3201$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $37e685d955bc3201$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $37e685d955bc3201$var$useRef(false);
    $37e685d955bc3201$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $37e685d955bc3201$var$useMemo(function() {
            var missingClientEdges = $37e685d955bc3201$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $37e685d955bc3201$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $37e685d955bc3201$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $37e685d955bc3201$var$useEffect(function() {
            var QueryResource = $37e685d955bc3201$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $37e685d955bc3201$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($37e685d955bc3201$var$isMissingData(state)) {
        var suspendingLiveResolvers = $37e685d955bc3201$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
            var liveStateID = _ref.liveStateID;
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($37e685d955bc3201$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$37e685d955bc3201$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $3lJ1W(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $37e685d955bc3201$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $37e685d955bc3201$var$handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = $37e685d955bc3201$var$useRef(false);
    $37e685d955bc3201$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $37e685d955bc3201$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $37e685d955bc3201$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $37e685d955bc3201$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $37e685d955bc3201$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $3lJ1W(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $3lJ1W(false);
        data = state.snapshot.data;
    }
    if ($37e685d955bc3201$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $37e685d955bc3201$var$useFragmentInternal;

});
parcelRegister("cv6F1", function(module, exports) {

var $6MrxF = parcelRequire("6MrxF");
function $919d8bed2799ca01$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6MrxF(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $919d8bed2799ca01$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6MrxF", function(module, exports) {

var $fINLy = parcelRequire("fINLy");
function $4efc970cb75bf050$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fINLy(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fINLy(r, a) : void 0;
    }
}
module.exports = $4efc970cb75bf050$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fINLy", function(module, exports) {
function $b7219192b40b7df4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $b7219192b40b7df4$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("3wDmv", function(module, exports) {

var $jmFhw = parcelRequire("jmFhw");

var $fdiWe = parcelRequire("fdiWe");

var $6MrxF = parcelRequire("6MrxF");

var $lTsGk = parcelRequire("lTsGk");
function $2912e4b938a28ae4$var$_toConsumableArray(r) {
    return $jmFhw(r) || $fdiWe(r) || $6MrxF(r) || $lTsGk();
}
module.exports = $2912e4b938a28ae4$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jmFhw", function(module, exports) {

var $fINLy = parcelRequire("fINLy");
function $e19018121ca4c3ad$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $fINLy(r);
}
module.exports = $e19018121ca4c3ad$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fdiWe", function(module, exports) {
function $b136c2ab2e8539c9$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $b136c2ab2e8539c9$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lTsGk", function(module, exports) {
function $ff04fba167245cfb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $ff04fba167245cfb$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bG2jK", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $88056a2a60b78ab0$var$_interopRequireDefault = $k1phe.default;

var $88056a2a60b78ab0$var$_objectSpread2 = $88056a2a60b78ab0$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $88056a2a60b78ab0$var$_createForOfIteratorHelper2 = $88056a2a60b78ab0$var$_interopRequireDefault((parcelRequire("cv6F1")));

var $88056a2a60b78ab0$var$_toConsumableArray2 = $88056a2a60b78ab0$var$_interopRequireDefault((parcelRequire("3wDmv")));

var $bFUpt = parcelRequire("bFUpt");
var $88056a2a60b78ab0$var$getQueryResourceForEnvironment = $bFUpt.getQueryResourceForEnvironment;

var $9Z8K4 = parcelRequire("9Z8K4");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");
var $88056a2a60b78ab0$var$useDebugValue = $1oC0p.useDebugValue, $88056a2a60b78ab0$var$useEffect = $1oC0p.useEffect, $88056a2a60b78ab0$var$useMemo = $1oC0p.useMemo, $88056a2a60b78ab0$var$useRef = $1oC0p.useRef, $88056a2a60b78ab0$var$useState = $1oC0p.useState;

var $gRpMo = parcelRequire("gRpMo");
var $88056a2a60b78ab0$var$_require3$__internal = $gRpMo.__internal, $88056a2a60b78ab0$var$fetchQueryInternal = $88056a2a60b78ab0$var$_require3$__internal.fetchQuery, $88056a2a60b78ab0$var$getPromiseForActiveRequest = $88056a2a60b78ab0$var$_require3$__internal.getPromiseForActiveRequest, $88056a2a60b78ab0$var$RelayFeatureFlags = $gRpMo.RelayFeatureFlags, $88056a2a60b78ab0$var$areEqualSelectors = $gRpMo.areEqualSelectors, $88056a2a60b78ab0$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $88056a2a60b78ab0$var$getPendingOperationsForFragment = $gRpMo.getPendingOperationsForFragment, $88056a2a60b78ab0$var$getSelector = $gRpMo.getSelector, $88056a2a60b78ab0$var$getVariablesFromFragment = $gRpMo.getVariablesFromFragment, $88056a2a60b78ab0$var$handlePotentialSnapshotErrors = $gRpMo.handlePotentialSnapshotErrors, $88056a2a60b78ab0$var$recycleNodesInto = $gRpMo.recycleNodesInto;
parcelRequire("UJI01");
function $88056a2a60b78ab0$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $88056a2a60b78ab0$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $88056a2a60b78ab0$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $88056a2a60b78ab0$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $88056a2a60b78ab0$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $88056a2a60b78ab0$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $88056a2a60b78ab0$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $88056a2a60b78ab0$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $88056a2a60b78ab0$var$handlePotentialSnapshotErrors(environment, state.snapshot.errorResponseFields);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $88056a2a60b78ab0$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $88056a2a60b78ab0$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $88056a2a60b78ab0$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $88056a2a60b78ab0$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $88056a2a60b78ab0$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $3lJ1W(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function $88056a2a60b78ab0$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $88056a2a60b78ab0$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $88056a2a60b78ab0$var$_objectSpread2["default"])((0, $88056a2a60b78ab0$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $88056a2a60b78ab0$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $88056a2a60b78ab0$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $88056a2a60b78ab0$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $88056a2a60b78ab0$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $88056a2a60b78ab0$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $88056a2a60b78ab0$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $88056a2a60b78ab0$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $88056a2a60b78ab0$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: 'plural',
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $88056a2a60b78ab0$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $88056a2a60b78ab0$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout',
        environment: environment
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function $88056a2a60b78ab0$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $88056a2a60b78ab0$var$useMemo(function() {
        return $88056a2a60b78ab0$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $3lJ1W(false);
    else !!Array.isArray(fragmentRef) && $3lJ1W(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $3lJ1W(false);
    var environment = $9Z8K4();
    var _useState = $88056a2a60b78ab0$var$useState(function() {
        return $88056a2a60b78ab0$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$88056a2a60b78ab0$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $88056a2a60b78ab0$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $88056a2a60b78ab0$var$useRef(false);
    $88056a2a60b78ab0$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $88056a2a60b78ab0$var$useMemo(function() {
            var missingClientEdges = $88056a2a60b78ab0$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $88056a2a60b78ab0$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $88056a2a60b78ab0$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $88056a2a60b78ab0$var$useEffect(function() {
            var QueryResource = $88056a2a60b78ab0$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $88056a2a60b78ab0$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($88056a2a60b78ab0$var$isMissingData(state)) {
        var suspendingLiveResolvers = $88056a2a60b78ab0$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
            var liveStateID = _ref.liveStateID;
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($88056a2a60b78ab0$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$88056a2a60b78ab0$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $3lJ1W(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $88056a2a60b78ab0$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $88056a2a60b78ab0$var$handlePotentialSnapshotErrorsForState(environment, state);
    var storeSubscriptionRef = $88056a2a60b78ab0$var$useRef(null);
    $88056a2a60b78ab0$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = $88056a2a60b78ab0$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $88056a2a60b78ab0$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    $88056a2a60b78ab0$var$useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== 'bailout') {
            var dispose = $88056a2a60b78ab0$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $88056a2a60b78ab0$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $3lJ1W(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $3lJ1W(false);
        data = state.snapshot.data;
    }
    if ($88056a2a60b78ab0$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $88056a2a60b78ab0$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("1RbyQ", function(module, exports) {
'use strict';

var $d1I5r = parcelRequire("d1I5r");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $15a3b5710a7bc81a$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $15a3b5710a7bc81a$var$getRequest = $gRpMo.getRequest;
var $15a3b5710a7bc81a$var$useMemo = $1oC0p.useMemo;
function $15a3b5710a7bc81a$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $d1I5r(variables);
    var memoCacheConfig = $d1I5r(cacheConfig || {});
    return $15a3b5710a7bc81a$var$useMemo(function() {
        return $15a3b5710a7bc81a$var$createOperationDescriptor($15a3b5710a7bc81a$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $15a3b5710a7bc81a$var$useMemoOperationDescriptor;

});
parcelRegister("d1I5r", function(module, exports) {
'use strict';

var $fJesj = parcelRequire("fJesj");

var $1oC0p = parcelRequire("1oC0p");
var $97bd91181137f80c$var$useState = $1oC0p.useState;
function $97bd91181137f80c$var$useMemoVariables(variables) {
    var _useState = $97bd91181137f80c$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($fJesj(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $97bd91181137f80c$var$useMemoVariables;

});




parcelRegister("63pIx", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $4686f8ce5ed97e49$var$_interopRequireDefault = $k1phe.default;

var $4686f8ce5ed97e49$var$_createForOfIteratorHelper2 = $4686f8ce5ed97e49$var$_interopRequireDefault((parcelRequire("cv6F1")));

var $9JReD = parcelRequire("9JReD");

var $6Zak5 = parcelRequire("6Zak5");

var $1oC0p = parcelRequire("1oC0p");
var $4686f8ce5ed97e49$var$useCallback = $1oC0p.useCallback, $4686f8ce5ed97e49$var$useEffect = $1oC0p.useEffect, $4686f8ce5ed97e49$var$useRef = $1oC0p.useRef, $4686f8ce5ed97e49$var$useState = $1oC0p.useState;
var $4686f8ce5ed97e49$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $4686f8ce5ed97e49$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $4686f8ce5ed97e49$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $6Zak5();
    var undisposedEntryPointReferencesRef = $4686f8ce5ed97e49$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $4686f8ce5ed97e49$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $4686f8ce5ed97e49$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $4686f8ce5ed97e49$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $4686f8ce5ed97e49$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $9JReD(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $4686f8ce5ed97e49$var$useRef(false);
    $4686f8ce5ed97e49$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $4686f8ce5ed97e49$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $4686f8ce5ed97e49$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $4686f8ce5ed97e49$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $4686f8ce5ed97e49$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $4686f8ce5ed97e49$var$useLoadEntryPoint;

});
parcelRegister("6Zak5", function(module, exports) {
'use strict';

var $1oC0p = parcelRequire("1oC0p");
var $5160727f56b203ab$var$useEffect = $1oC0p.useEffect, $5160727f56b203ab$var$useRef = $1oC0p.useRef;
function $5160727f56b203ab$var$useIsMountedRef() {
    var isMountedRef = $5160727f56b203ab$var$useRef(true);
    $5160727f56b203ab$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $5160727f56b203ab$var$useIsMountedRef;

});


parcelRegister("im8b7", function(module, exports) {
'use strict';

var $4fCQk = parcelRequire("4fCQk");

var $1BFSt = parcelRequire("1BFSt");

var $1oC0p = parcelRequire("1oC0p");
var $d5d0a01785e8bf22$var$useDebugValue = $1oC0p.useDebugValue;

var $gRpMo = parcelRequire("gRpMo");
var $d5d0a01785e8bf22$var$getFragment = $gRpMo.getFragment;
function $d5d0a01785e8bf22$var$useFragment(fragment, key) {
    var fragmentNode = $d5d0a01785e8bf22$var$getFragment(fragment);
    $1BFSt(fragmentNode, 'first argument of useFragment()');
    var data = $4fCQk(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $d5d0a01785e8bf22$var$useFragment;

});
parcelRegister("1BFSt", function(module, exports) {
'use strict';
parcelRequire("9izfK");
parcelRequire("UJI01");
function $12b9bb2986b031bf$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $12b9bb2986b031bf$var$useStaticFragmentNodeWarning;

});


parcelRegister("gT29l", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $c4b3734972fc1121$var$_interopRequireDefault = $k1phe.default;

var $c4b3734972fc1121$var$_objectSpread2 = $c4b3734972fc1121$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $6Zak5 = parcelRequire("6Zak5");

var $9Z8K4 = parcelRequire("9Z8K4");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $c4b3734972fc1121$var$defaultCommitMutation = $gRpMo.commitMutation;
var $c4b3734972fc1121$var$useState = $1oC0p.useState, $c4b3734972fc1121$var$useEffect = $1oC0p.useEffect, $c4b3734972fc1121$var$useRef = $1oC0p.useRef, $c4b3734972fc1121$var$useCallback = $1oC0p.useCallback;
function $c4b3734972fc1121$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c4b3734972fc1121$var$defaultCommitMutation;
    var environment = $9Z8K4();
    var isMountedRef = $6Zak5();
    var environmentRef = $c4b3734972fc1121$var$useRef(environment);
    var mutationRef = $c4b3734972fc1121$var$useRef(mutation);
    var inFlightMutationsRef = $c4b3734972fc1121$var$useRef(new Set());
    var _useState = $c4b3734972fc1121$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $c4b3734972fc1121$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $c4b3734972fc1121$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $c4b3734972fc1121$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $c4b3734972fc1121$var$_objectSpread2["default"])((0, $c4b3734972fc1121$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $c4b3734972fc1121$var$useMutation;

});

parcelRegister("8EgSy", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $64bf26f98e9cb47f$var$_interopRequireDefault = $k1phe.default;

var $64bf26f98e9cb47f$var$_objectSpread2 = $64bf26f98e9cb47f$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $9Xt72 = parcelRequire("9Xt72");

var $jgiMh = parcelRequire("jgiMh");

var $9Z8K4 = parcelRequire("9Z8K4");

var $1BFSt = parcelRequire("1BFSt");

var $1oC0p = parcelRequire("1oC0p");
var $64bf26f98e9cb47f$var$useCallback = $1oC0p.useCallback, $64bf26f98e9cb47f$var$useDebugValue = $1oC0p.useDebugValue, $64bf26f98e9cb47f$var$useState = $1oC0p.useState;

var $gRpMo = parcelRequire("gRpMo");
var $64bf26f98e9cb47f$var$getFragment = $gRpMo.getFragment, $64bf26f98e9cb47f$var$getFragmentIdentifier = $gRpMo.getFragmentIdentifier, $64bf26f98e9cb47f$var$getPaginationMetadata = $gRpMo.getPaginationMetadata;
function $64bf26f98e9cb47f$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $64bf26f98e9cb47f$var$getFragment(fragmentInput);
    $1BFSt(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $64bf26f98e9cb47f$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $jgiMh(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $64bf26f98e9cb47f$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $64bf26f98e9cb47f$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $64bf26f98e9cb47f$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $64bf26f98e9cb47f$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $64bf26f98e9cb47f$var$_objectSpread2["default"])((0, $64bf26f98e9cb47f$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $64bf26f98e9cb47f$var$useLoadMore(args) {
    var environment = $9Z8K4();
    var _useState = $64bf26f98e9cb47f$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $9Xt72((0, $64bf26f98e9cb47f$var$_objectSpread2["default"])((0, $64bf26f98e9cb47f$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $64bf26f98e9cb47f$var$usePaginationFragment;

});
parcelRegister("9Xt72", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $740034e0ef71dc92$var$_interopRequireDefault = $k1phe.default;

var $740034e0ef71dc92$var$_objectSpread2 = $740034e0ef71dc92$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $1JUqu = parcelRequire("1JUqu");

var $3yYoL = parcelRequire("3yYoL");

var $6Zak5 = parcelRequire("6Zak5");

var $5SivY = parcelRequire("5SivY");

var $iDDYg = parcelRequire("iDDYg");

var $9Z8K4 = parcelRequire("9Z8K4");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");
var $740034e0ef71dc92$var$useCallback = $1oC0p.useCallback, $740034e0ef71dc92$var$useEffect = $1oC0p.useEffect, $740034e0ef71dc92$var$useState = $1oC0p.useState;

var $gRpMo = parcelRequire("gRpMo");
var $740034e0ef71dc92$var$fetchQuery = $gRpMo.__internal.fetchQuery, $740034e0ef71dc92$var$RelayFeatureFlags = $gRpMo.RelayFeatureFlags, $740034e0ef71dc92$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $740034e0ef71dc92$var$getPaginationVariables = $gRpMo.getPaginationVariables, $740034e0ef71dc92$var$getRefetchMetadata = $gRpMo.getRefetchMetadata, $740034e0ef71dc92$var$getSelector = $gRpMo.getSelector;
parcelRequire("UJI01");
function $740034e0ef71dc92$var$useLoadMoreFunction(args) {
    if ($740034e0ef71dc92$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $iDDYg(args);
    return $740034e0ef71dc92$var$useLoadMoreFunction_CURRENT(args);
}
function $740034e0ef71dc92$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $9Z8K4();
    var _useFetchTrackingRef = $3yYoL(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $740034e0ef71dc92$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $6Zak5();
    var _useState = $740034e0ef71dc92$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $740034e0ef71dc92$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $5SivY(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $1JUqu(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $740034e0ef71dc92$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = $740034e0ef71dc92$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $740034e0ef71dc92$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $3lJ1W(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $740034e0ef71dc92$var$_objectSpread2["default"])((0, $740034e0ef71dc92$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $740034e0ef71dc92$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $740034e0ef71dc92$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $740034e0ef71dc92$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $740034e0ef71dc92$var$fetchQuery(environment, paginationQuery).subscribe((0, $740034e0ef71dc92$var$_objectSpread2["default"])((0, $740034e0ef71dc92$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $740034e0ef71dc92$var$useLoadMoreFunction;

});
parcelRegister("1JUqu", function(module, exports) {
'use strict';

var $3lJ1W = parcelRequire("3lJ1W");

var $gRpMo = parcelRequire("gRpMo");
var $1445c383fc20aeae$var$ConnectionInterface = $gRpMo.ConnectionInterface, $1445c383fc20aeae$var$getValueAtPath = $gRpMo.getValueAtPath;
function $1445c383fc20aeae$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $1445c383fc20aeae$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $1445c383fc20aeae$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $3lJ1W(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $3lJ1W(false);
    !(typeof pageInfo === 'object') && $3lJ1W(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $3lJ1W(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $1445c383fc20aeae$var$getConnectionState;

});

parcelRegister("5SivY", function(module, exports) {
'use strict';

var $9Z8K4 = parcelRequire("9Z8K4");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");

var $gRpMo = parcelRequire("gRpMo");
var $44705b820ca8df79$var$getObservableForActiveRequest = $gRpMo.__internal.getObservableForActiveRequest, $44705b820ca8df79$var$getSelector = $gRpMo.getSelector;
var $44705b820ca8df79$var$useEffect = $1oC0p.useEffect, $44705b820ca8df79$var$useState = $1oC0p.useState, $44705b820ca8df79$var$useMemo = $1oC0p.useMemo;
function $44705b820ca8df79$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $9Z8K4();
    var observable = $44705b820ca8df79$var$useMemo(function() {
        var selector = $44705b820ca8df79$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $3lJ1W(false);
        return $44705b820ca8df79$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $44705b820ca8df79$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $44705b820ca8df79$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $44705b820ca8df79$var$useIsOperationNodeActive;

});

parcelRegister("iDDYg", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $d91adfeb0c219141$var$_interopRequireDefault = $k1phe.default;

var $d91adfeb0c219141$var$_objectSpread2 = $d91adfeb0c219141$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $1JUqu = parcelRequire("1JUqu");

var $6Zak5 = parcelRequire("6Zak5");

var $5SivY = parcelRequire("5SivY");

var $9Z8K4 = parcelRequire("9Z8K4");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");
var $d91adfeb0c219141$var$useCallback = $1oC0p.useCallback, $d91adfeb0c219141$var$useRef = $1oC0p.useRef, $d91adfeb0c219141$var$useState = $1oC0p.useState;

var $gRpMo = parcelRequire("gRpMo");
var $d91adfeb0c219141$var$fetchQuery = $gRpMo.__internal.fetchQuery, $d91adfeb0c219141$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $d91adfeb0c219141$var$getPaginationVariables = $gRpMo.getPaginationVariables, $d91adfeb0c219141$var$getRefetchMetadata = $gRpMo.getRefetchMetadata, $d91adfeb0c219141$var$getSelector = $gRpMo.getSelector;
parcelRequire("UJI01");
function $d91adfeb0c219141$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $9Z8K4();
    var _getRefetchMetadata = $d91adfeb0c219141$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $d91adfeb0c219141$var$useRef({
        kind: 'none'
    });
    var _useState = $d91adfeb0c219141$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $d91adfeb0c219141$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $5SivY(fragmentNode, fragmentRef);
    var forceDisposeFn = $d91adfeb0c219141$var$useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $1JUqu(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isMountedRef = $6Zak5();
    var loadMore = $d91adfeb0c219141$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $d91adfeb0c219141$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $3lJ1W(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $d91adfeb0c219141$var$_objectSpread2["default"])((0, $d91adfeb0c219141$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $d91adfeb0c219141$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $d91adfeb0c219141$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $d91adfeb0c219141$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $d91adfeb0c219141$var$fetchQuery(environment, paginationQuery).subscribe((0, $d91adfeb0c219141$var$_objectSpread2["default"])((0, $d91adfeb0c219141$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $d91adfeb0c219141$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("jgiMh", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $e05e13d4bd2e1c5f$var$_interopRequireDefault = $k1phe.default;

var $e05e13d4bd2e1c5f$var$_objectSpread2 = $e05e13d4bd2e1c5f$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $lNbDu = parcelRequire("lNbDu");

var $bFUpt = parcelRequire("bFUpt");
var $e05e13d4bd2e1c5f$var$getQueryResourceForEnvironment = $bFUpt.getQueryResourceForEnvironment;

var $5DZ9D = parcelRequire("5DZ9D");

var $4fCQk = parcelRequire("4fCQk");

var $6Zak5 = parcelRequire("6Zak5");

var $hfU7v = parcelRequire("hfU7v");

var $9Z8K4 = parcelRequire("9Z8K4");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");
var $e05e13d4bd2e1c5f$var$useCallback = $1oC0p.useCallback, $e05e13d4bd2e1c5f$var$useContext = $1oC0p.useContext, $e05e13d4bd2e1c5f$var$useReducer = $1oC0p.useReducer;

var $gRpMo = parcelRequire("gRpMo");
var $e05e13d4bd2e1c5f$var$fetchQuery = $gRpMo.__internal.fetchQuery, $e05e13d4bd2e1c5f$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $e05e13d4bd2e1c5f$var$getFragmentIdentifier = $gRpMo.getFragmentIdentifier, $e05e13d4bd2e1c5f$var$getRefetchMetadata = $gRpMo.getRefetchMetadata, $e05e13d4bd2e1c5f$var$getSelector = $gRpMo.getSelector, $e05e13d4bd2e1c5f$var$getValueAtPath = $gRpMo.getValueAtPath;
parcelRequire("UJI01");
function $e05e13d4bd2e1c5f$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $e05e13d4bd2e1c5f$var$_objectSpread2["default"])((0, $e05e13d4bd2e1c5f$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $e05e13d4bd2e1c5f$var$useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $9Z8K4();
    var _getRefetchMetadata = $e05e13d4bd2e1c5f$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $e05e13d4bd2e1c5f$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $e05e13d4bd2e1c5f$var$useReducer($e05e13d4bd2e1c5f$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $e05e13d4bd2e1c5f$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $e05e13d4bd2e1c5f$var$useContext($lNbDu);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $hfU7v(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $e05e13d4bd2e1c5f$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $5DZ9D(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $3lJ1W(false);
        var refetchedFragmentRef = $e05e13d4bd2e1c5f$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $4fCQk(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $e05e13d4bd2e1c5f$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $e05e13d4bd2e1c5f$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $6Zak5();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $e05e13d4bd2e1c5f$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $e05e13d4bd2e1c5f$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $e05e13d4bd2e1c5f$var$_objectSpread2["default"])((0, $e05e13d4bd2e1c5f$var$_objectSpread2["default"])((0, $e05e13d4bd2e1c5f$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $e05e13d4bd2e1c5f$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $e05e13d4bd2e1c5f$var$debugFunctions;
module.exports = $e05e13d4bd2e1c5f$var$useRefetchableFragmentNode;

});
parcelRegister("5DZ9D", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $41c00842a7729d5f$var$_interopRequireDefault = $k1phe.default;

var $41c00842a7729d5f$var$_objectSpread2 = $41c00842a7729d5f$var$_interopRequireDefault((parcelRequire("4BrRr")));

var $41c00842a7729d5f$var$_createForOfIteratorHelper2 = $41c00842a7729d5f$var$_interopRequireDefault((parcelRequire("cv6F1")));

var $bFUpt = parcelRequire("bFUpt");
var $41c00842a7729d5f$var$getQueryResourceForEnvironment = $bFUpt.getQueryResourceForEnvironment;

var $3lJ1W = parcelRequire("3lJ1W");

var $gRpMo = parcelRequire("gRpMo");
var $41c00842a7729d5f$var$fetchQueryInternal = $gRpMo.__internal.fetchQuery, $41c00842a7729d5f$var$RelayFeatureFlags = $gRpMo.RelayFeatureFlags, $41c00842a7729d5f$var$createOperationDescriptor = $gRpMo.createOperationDescriptor, $41c00842a7729d5f$var$getPendingOperationsForFragment = $gRpMo.getPendingOperationsForFragment, $41c00842a7729d5f$var$getSelector = $gRpMo.getSelector, $41c00842a7729d5f$var$getVariablesFromFragment = $gRpMo.getVariablesFromFragment, $41c00842a7729d5f$var$handlePotentialSnapshotErrors = $gRpMo.handlePotentialSnapshotErrors;
parcelRequire("UJI01");
function $41c00842a7729d5f$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $41c00842a7729d5f$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $41c00842a7729d5f$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $41c00842a7729d5f$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $41c00842a7729d5f$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $41c00842a7729d5f$var$handlePotentialSnapshotErrors(environment, state.snapshot.errorResponseFields);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, $41c00842a7729d5f$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $41c00842a7729d5f$var$handlePotentialSnapshotErrors(environment, snapshot.errorResponseFields);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $41c00842a7729d5f$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $41c00842a7729d5f$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $41c00842a7729d5f$var$_objectSpread2["default"])((0, $41c00842a7729d5f$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $41c00842a7729d5f$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $41c00842a7729d5f$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $41c00842a7729d5f$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $41c00842a7729d5f$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $41c00842a7729d5f$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $41c00842a7729d5f$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $3lJ1W(false);
    else !!Array.isArray(fragmentRef) && $3lJ1W(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $3lJ1W(false);
    var state = $41c00842a7729d5f$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var missingClientEdges = $41c00842a7729d5f$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $41c00842a7729d5f$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($41c00842a7729d5f$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($41c00842a7729d5f$var$isMissingData(state)) {
        !(fragmentSelector != null) && $3lJ1W(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $41c00842a7729d5f$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $41c00842a7729d5f$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($41c00842a7729d5f$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $41c00842a7729d5f$var$readFragmentInternal;

});

parcelRegister("hfU7v", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $c8ff5eaa9d089161$var$_interopRequireDefault = $k1phe.default;

var $c8ff5eaa9d089161$var$_createForOfIteratorHelper2 = $c8ff5eaa9d089161$var$_interopRequireDefault((parcelRequire("cv6F1")));

var $kT5XY = parcelRequire("kT5XY");
var $c8ff5eaa9d089161$var$loadQuery = $kT5XY.loadQuery;

var $6Zak5 = parcelRequire("6Zak5");

var $hY9yQ = parcelRequire("hY9yQ");

var $9Z8K4 = parcelRequire("9Z8K4");

var $1oC0p = parcelRequire("1oC0p");
var $c8ff5eaa9d089161$var$useCallback = $1oC0p.useCallback, $c8ff5eaa9d089161$var$useEffect = $1oC0p.useEffect, $c8ff5eaa9d089161$var$useRef = $1oC0p.useRef, $c8ff5eaa9d089161$var$useState = $1oC0p.useState;

var $gRpMo = parcelRequire("gRpMo");
var $c8ff5eaa9d089161$var$RelayFeatureFlags = $gRpMo.RelayFeatureFlags, $c8ff5eaa9d089161$var$getRequest = $gRpMo.getRequest;
var $c8ff5eaa9d089161$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $c8ff5eaa9d089161$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $c8ff5eaa9d089161$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $c8ff5eaa9d089161$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($c8ff5eaa9d089161$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $hY9yQ(preloadableRequest, initialQueryReference);
    return $c8ff5eaa9d089161$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $c8ff5eaa9d089161$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $c8ff5eaa9d089161$var$initialNullQueryReferenceState;
    var environment = $9Z8K4();
    var isMountedRef = $6Zak5();
    var undisposedQueryReferencesRef = $c8ff5eaa9d089161$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $c8ff5eaa9d089161$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $c8ff5eaa9d089161$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $c8ff5eaa9d089161$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($c8ff5eaa9d089161$var$initialNullQueryReferenceState);
            setQueryReference($c8ff5eaa9d089161$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $c8ff5eaa9d089161$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $c8ff5eaa9d089161$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $c8ff5eaa9d089161$var$useRef(false);
    $c8ff5eaa9d089161$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $c8ff5eaa9d089161$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $c8ff5eaa9d089161$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($c8ff5eaa9d089161$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $c8ff5eaa9d089161$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $c8ff5eaa9d089161$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($c8ff5eaa9d089161$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $c8ff5eaa9d089161$var$useQueryLoader;

});
parcelRegister("hY9yQ", function(module, exports) {
'use strict';

var $k1phe = parcelRequire("k1phe");
var $d14f74de373f7d0a$var$_interopRequireDefault = $k1phe.default;

var $d14f74de373f7d0a$var$_createForOfIteratorHelper2 = $d14f74de373f7d0a$var$_interopRequireDefault((parcelRequire("cv6F1")));

var $kT5XY = parcelRequire("kT5XY");
var $d14f74de373f7d0a$var$loadQuery = $kT5XY.loadQuery;

var $6Zak5 = parcelRequire("6Zak5");

var $9Z8K4 = parcelRequire("9Z8K4");

var $1oC0p = parcelRequire("1oC0p");
var $d14f74de373f7d0a$var$useCallback = $1oC0p.useCallback, $d14f74de373f7d0a$var$useEffect = $1oC0p.useEffect, $d14f74de373f7d0a$var$useInsertionEffect = $1oC0p.useInsertionEffect, $d14f74de373f7d0a$var$useRef = $1oC0p.useRef, $d14f74de373f7d0a$var$useState = $1oC0p.useState;

var $gRpMo = parcelRequire("gRpMo");
var $d14f74de373f7d0a$var$getRequest = $gRpMo.getRequest;
var $d14f74de373f7d0a$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $d14f74de373f7d0a$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $d14f74de373f7d0a$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $d14f74de373f7d0a$var$CLEANUP_TIMEOUT = 300000;
function $d14f74de373f7d0a$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $d14f74de373f7d0a$var$initialNullQueryReferenceState;
    var environment = $9Z8K4();
    var isMountedRef = $6Zak5();
    var undisposedQueryReferencesRef = $d14f74de373f7d0a$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $d14f74de373f7d0a$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $d14f74de373f7d0a$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $d14f74de373f7d0a$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($d14f74de373f7d0a$var$initialNullQueryReferenceState);
            setQueryReference($d14f74de373f7d0a$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $d14f74de373f7d0a$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = $d14f74de373f7d0a$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $d14f74de373f7d0a$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $d14f74de373f7d0a$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if ($d14f74de373f7d0a$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $d14f74de373f7d0a$var$useRef(null);
    $d14f74de373f7d0a$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $d14f74de373f7d0a$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $d14f74de373f7d0a$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $d14f74de373f7d0a$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("gbxKl", function(module, exports) {
'use strict';

var $lg4JJ = parcelRequire("lg4JJ");

var $1RbyQ = parcelRequire("1RbyQ");

var $9Z8K4 = parcelRequire("9Z8K4");

var $3lJ1W = parcelRequire("3lJ1W");

var $1oC0p = parcelRequire("1oC0p");
var $bc87d9c9e97f992e$var$useDebugValue = $1oC0p.useDebugValue;

var $gRpMo = parcelRequire("gRpMo");
var $bc87d9c9e97f992e$var$_require2$__internal = $gRpMo.__internal, $bc87d9c9e97f992e$var$fetchQueryDeduped = $bc87d9c9e97f992e$var$_require2$__internal.fetchQueryDeduped, $bc87d9c9e97f992e$var$fetchQuery = $bc87d9c9e97f992e$var$_require2$__internal.fetchQuery;
parcelRequire("UJI01");
function $bc87d9c9e97f992e$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $9Z8K4();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $1RbyQ(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $3lJ1W(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $bc87d9c9e97f992e$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $bc87d9c9e97f992e$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $lg4JJ(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $bc87d9c9e97f992e$var$usePreloadedQuery;

});

parcelRegister("iQ9TL", function(module, exports) {
'use strict';

var $jgiMh = parcelRequire("jgiMh");

var $1BFSt = parcelRequire("1BFSt");

var $1oC0p = parcelRequire("1oC0p");
var $db74c2f559685420$var$useDebugValue = $1oC0p.useDebugValue;

var $gRpMo = parcelRequire("gRpMo");
var $db74c2f559685420$var$getFragment = $gRpMo.getFragment;
function $db74c2f559685420$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $db74c2f559685420$var$getFragment(fragmentInput);
    $1BFSt(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $jgiMh(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $db74c2f559685420$var$useRefetchableFragment;

});

parcelRegister("86alb", function(module, exports) {
'use strict';

var $9Z8K4 = parcelRequire("9Z8K4");

var $1oC0p = parcelRequire("1oC0p");
var $5e56e7b67d21c7e7$var$useEffect = $1oC0p.useEffect, $5e56e7b67d21c7e7$var$useRef = $1oC0p.useRef;
function $5e56e7b67d21c7e7$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $9Z8K4();
    var disposableRef = $5e56e7b67d21c7e7$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $5e56e7b67d21c7e7$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $5e56e7b67d21c7e7$var$useSubscribeToInvalidationState;

});

parcelRegister("af6Xx", function(module, exports) {
'use strict';

var $9Z8K4 = parcelRequire("9Z8K4");

var $1oC0p = parcelRequire("1oC0p");
var $7750b41052c7671f$var$useEffect = $1oC0p.useEffect;

var $gRpMo = parcelRequire("gRpMo");
var $7750b41052c7671f$var$requestSubscription = $gRpMo.requestSubscription;
function $7750b41052c7671f$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $7750b41052c7671f$var$requestSubscription;
    var environment = $9Z8K4();
    $7750b41052c7671f$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $7750b41052c7671f$var$useSubscription;

});



parcelRegister("gbUpX", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateCollectionDetailsRelayPageQuery", function () { return $78ed8104fcad4235$export$98e1975bc3089d34; });
$parcel$export(module.exports, "getConfluenceTemplateCollectionDetailsRelayPageQueryVars", function () { return $78ed8104fcad4235$export$fcca656ba7c9c75a; });
$parcel$export(module.exports, "ConfluenceTemplateCollectionDetailsRelayPageTemplate", function () { return $78ed8104fcad4235$export$b6f88ef369f9fcd; });
/* confluence-template-collection-details-contentful-relay-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $f3gS9 = parcelRequire("f3gS9");

var $hCc2m = parcelRequire("hCc2m");

var $4EfnG = parcelRequire("4EfnG");

var $5HK05 = parcelRequire("5HK05");

var $1iUL9 = parcelRequire("1iUL9");

var $3dnVb = parcelRequire("3dnVb");

var $Cepma = parcelRequire("Cepma");

var $bbAhH = parcelRequire("bbAhH");

var $lkdtg = parcelRequire("lkdtg");

var $iERy6 = parcelRequire("iERy6");
var $78ed8104fcad4235$var$_confluenceTemplateCollectionDetailsContentfulRelayPageQuery;
const $78ed8104fcad4235$var$contentWrapper = null;
const $78ed8104fcad4235$var$parseCollectionUrlSlug = (pathname)=>{
    const [urlSlug, maybeCollectionsSlug] = pathname.split('/').reverse();
    return urlSlug && maybeCollectionsSlug === 'collections' ? urlSlug : '';
};
const $78ed8104fcad4235$var$RELATED_COLLECTION_URL_SLUGS = {
    ['project-management']: [
        'product-managers',
        'strategic-planning'
    ],
    ['strategic-planning']: [
        'project-management',
        'product-managers'
    ]
};
const $78ed8104fcad4235$var$DEFAULT_RELATED_COLLECTION_URL_SLUGS = [
    'project-management',
    'strategic-planning'
];

const $78ed8104fcad4235$export$98e1975bc3089d34 = $78ed8104fcad4235$var$_confluenceTemplateCollectionDetailsContentfulRelayPageQuery !== void 0 ? $78ed8104fcad4235$var$_confluenceTemplateCollectionDetailsContentfulRelayPageQuery : ($78ed8104fcad4235$var$_confluenceTemplateCollectionDetailsContentfulRelayPageQuery = (parcelRequire("hfq9I")), $78ed8104fcad4235$var$_confluenceTemplateCollectionDetailsContentfulRelayPageQuery.hash && $78ed8104fcad4235$var$_confluenceTemplateCollectionDetailsContentfulRelayPageQuery.hash !== "8adafe8a7c1234e7e0232bb6cf9f2458" && console.error("The definition of 'confluenceTemplateCollectionDetailsContentfulRelayPageQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $78ed8104fcad4235$var$_confluenceTemplateCollectionDetailsContentfulRelayPageQuery);
const $78ed8104fcad4235$export$fcca656ba7c9c75a = (location, partialVars)=>{
    const locale = partialVars?.locale ?? (0, $3dnVb.parseQueryLocale)(location);
    const urlSlug = partialVars?.urlSlug ?? $78ed8104fcad4235$var$parseCollectionUrlSlug(location.pathname);
    const relatedCollectionUrlSlugs = partialVars?.relatedCollectionUrlSlugs ?? $78ed8104fcad4235$var$RELATED_COLLECTION_URL_SLUGS[urlSlug] ?? $78ed8104fcad4235$var$DEFAULT_RELATED_COLLECTION_URL_SLUGS;
    return {
        locale: locale,
        urlSlug: urlSlug,
        relatedCollectionUrlSlugs: relatedCollectionUrlSlugs
    };
};
const $78ed8104fcad4235$var$CollectionDetailsContentRelay = ({ queryRef: queryRef })=>{
    const { collections: collections, relatedCollections: relatedCollections } = (0, $f3gS9.usePreloadedQuery)($78ed8104fcad4235$export$98e1975bc3089d34, queryRef);
    const collection = (0, $5HK05.expectContent)(collections?.items[0]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "confluence-template-collection-details-content",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lkdtg.CollectionHeaderSection), {
                collection: collection
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12fyl33 _19pkidpf _2hwx1wug _otyridpf _18u01wug _q9tovbgk _17arvbgk _1tbzzwfg _6881zwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Cepma.CollectionAboutSection), {
                        collection: collection
                    }),
                    collection.howToUseThisCollection && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bbAhH.CollectionGuideSection), {
                        collectionGuide: collection.howToUseThisCollection
                    }),
                    relatedCollections?.items && relatedCollections?.items.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iERy6.CollectionRelatedSection), {
                        collections: relatedCollections.items
                    })
                ]
            })
        ]
    });
};
const $78ed8104fcad4235$export$b6f88ef369f9fcd = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1iUL9.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
                fallback: '',
                interactionName: 'conf-template-coll-details-contentful-relay',
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($78ed8104fcad4235$var$CollectionDetailsContentRelay, {
                    queryRef: queryRef
                })
            })
        })
    });
};

});
parcelRegister("hCc2m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd2f529bac5c7b23$export$2e2bcd8739ae039; });

var $fOcms = parcelRequire("fOcms");
var $cd2f529bac5c7b23$export$2e2bcd8739ae039 = (0, $fOcms.default);

});
parcelRegister("fOcms", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8251d345bb1e42c$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $3Ccrv = parcelRequire("3Ccrv");
var $b8251d345bb1e42c$var$Suspense = function Suspense(_ref) {
    var children = _ref.children, fallback = _ref.fallback, interactionName = _ref.interactionName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3Ccrv.default), {
            name: interactionName
        }, fallback)
    }, children);
};
var $b8251d345bb1e42c$export$2e2bcd8739ae039 = $b8251d345bb1e42c$var$Suspense;

});
parcelRegister("3Ccrv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2a1e9289130d80a4$export$2e2bcd8739ae039; });

var $5KOug = parcelRequire("5KOug");
var $2a1e9289130d80a4$export$2e2bcd8739ae039 = (0, $5KOug.default);

});
parcelRegister("5KOug", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4308694c5645565f$export$2e2bcd8739ae039; });

var $6HNZJ = parcelRequire("6HNZJ");

var $1oC0p = parcelRequire("1oC0p");

var $03EZb = parcelRequire("03EZb");

var $iqOwP = parcelRequire("iqOwP");

var $1BTY2 = parcelRequire("1BTY2");
var $4308694c5645565f$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $4308694c5645565f$var$useInteractionIdValue() {
    var interactionId = (0, $1oC0p.useContext)((0, $1BTY2.default));
    var _useState = (0, $1oC0p.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null), _useState2 = (0, $6HNZJ.default)(_useState, 2), currentId = _useState2[0], setCurrentId = _useState2[1];
    $4308694c5645565f$var$useLayoutEffectSAFE(function() {
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        var unsubscribe = (0, $1BTY2.subscribeToInteractionIdChanges)(function(newId) {
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $4308694c5645565f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, name = _ref.name, _ref$hold = _ref.hold, hold = _ref$hold === void 0 ? true : _ref$hold, _ref$experimental = _ref.experimental, experimental = _ref$experimental === void 0 ? false : _ref$experimental;
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    var ufoEnabled = (0, $03EZb.isUFOEnabled)();
    var currentInteractionId = $4308694c5645565f$var$useInteractionIdValue();
    // react-18: useId instead
    var context = (0, $1oC0p.useContext)((0, $iqOwP.default));
    $4308694c5645565f$var$useLayoutEffectSAFE(function() {
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children) : null;
}

});




parcelRegister("4EfnG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $825bee1e9ca8422a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $4d61Q = parcelRequire("4d61Q");

var $bZeFo = parcelRequire("bZeFo");
const $825bee1e9ca8422a$var$shouldShowFallback = (error)=>{
    return (0, $bZeFo.isContentNotFoundError)(error) || (0, $bZeFo.isRelayError)(error) || (0, $bZeFo.isContentFetchError)(error);
};
class $825bee1e9ca8422a$export$e62176212447c990 extends (0, $1oC0p.Component) {
    static #_ = this.defaultProps = {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4d61Q.MainSection), {})
    };
    constructor(props){
        super(props);
        this.state = {};
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error: error
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const hasError = this.state.error != null;
        const shouldRenderFallback = hasError && $825bee1e9ca8422a$var$shouldShowFallback(this.state.error);
        if (shouldRenderFallback) return fallback;
        else if (hasError) // Throw the unhandled error.
        throw this.state.error;
        else return children;
    }
}
var $825bee1e9ca8422a$export$2e2bcd8739ae039 = $825bee1e9ca8422a$export$e62176212447c990;

});
parcelRegister("4d61Q", function(module, exports) {
$parcel$export(module.exports, "MainSection", function () { return $5a15110db0cc0b9a$export$b3b6941b6cf0f30; });
/* main.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $ldrV1 = parcelRequire("ldrV1");

var $eC3qs = parcelRequire("eC3qs");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");

var $1rGpC = parcelRequire("1rGpC");
const $5a15110db0cc0b9a$var$contentSectionCss = null;
const $5a15110db0cc0b9a$var$headerStyle = null;
const $5a15110db0cc0b9a$var$textStyle = null;
const $5a15110db0cc0b9a$var$linkTextStyle = null;
const $5a15110db0cc0b9a$var$searchMainContainerStyle = null;
const $5a15110db0cc0b9a$var$searchFormStyle = null;
const $5a15110db0cc0b9a$var$searchContainerStyle = null;
const $5a15110db0cc0b9a$var$searchInputContainerStyle = null;
const $5a15110db0cc0b9a$var$divStyle = null;
const $5a15110db0cc0b9a$var$searchIconButtonStyle = null;
const $5a15110db0cc0b9a$export$b3b6941b6cf0f30 = ()=>{
    const intl = (0, $8e22h.default)();
    const inputRef = (0, $1oC0p.useRef)(null);
    const [searchText, setSearchText] = (0, $1oC0p.useState)('');
    const sorry = intl.formatMessage({
        id: '404.sorry',
        defaultMessage: "Sorry, the page you're looking for cannot be found"
    }, {
        ...(0, $iRMRa.DEFAULT_VALUES)
    });
    const visitHomepage = intl.formatMessage({
        id: '404.visitHomepage',
        defaultMessage: 'Visit our <HomepageLink>homepage</HomepageLink>, get <HelpLink>help</HelpLink>, or try searching'
    }, {
        ...(0, $iRMRa.DEFAULT_VALUES),
        HomepageLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                text: text,
                "aria-label": text,
                href: (0, $jQ0cd.useLocalizedHref)('/'),
                type: 'inline'
            }),
        HelpLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                text: text,
                "aria-label": text,
                href: (0, $jQ0cd.useLocalizedHref)('/resources/support'),
                type: 'inline'
            })
    });
    const search = intl.formatMessage({
        id: '404.search',
        defaultMessage: 'Search'
    });
    const mainCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1q5112bs _85i5mxpn _1mt1idpf _oqic1crf _1rmjidpf _cjbt1qr7 _pnmbidpf _1kmxgktf _1ggmidpf _1ykz16xz _1maeidpf _i6jxckbl _1lh7idpf _z3nc11ux _wpaiidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _bozgidpf _y4tiidpf _1e0c1txw _2lx21bp4 _y3gn1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                        className: (0, $2jatx.default)([
                            "_1wybhew6 _ect41jfk _k48pbfng _syaz1bqd _1po4webb _1egl1k7u _4t3i1k7u"
                        ]),
                        children: "404"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect418gv _k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _syaz1mpp _s7n41q9y _vwz4bs82"
                        ]),
                        children: sorry
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect418gv _k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1mpp _s7n41q9y _vwz4bs82"
                        ]),
                        children: visitHomepage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mt1idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        id: "wac-search",
                        "data-testid": "search-container",
                        className: (0, $2jatx.default)([
                            "_152t1osq _1e02ze3t _vwz41ejb"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("form", {
                            action: (0, $jQ0cd.useLocalizedHref)(`/search`),
                            method: "GET",
                            id: "wac-search-form",
                            "data-testid": "search-form",
                            className: (0, $2jatx.default)([
                                "_vwz41ejb _p12f1fra _19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswh2mm _1akoidpf _c7s7gktf _4puv1tcg _1r3vgktf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                id: "wac-search-container",
                                className: (0, $2jatx.default)([
                                    "_y3gn1h6o _18s85ogf _xc2iidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        id: "wac-search-input-container",
                                        className: (0, $2jatx.default)([
                                            "_1e0c1o8l _12l2u2gc _y3gn1e5h _1bsbr0r7"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eC3qs.TextInput), {
                                            ref: inputRef,
                                            className: "fullWidth",
                                            placeholder: '',
                                            label: '',
                                            name: "q",
                                            id: "search-input",
                                            value: searchText,
                                            onChangeHandler: setSearchText,
                                            "data-testid": "search-input",
                                            "aria-label": "Search Input"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: search,
                                        type: 'primary',
                                        size: 'small',
                                        className: (0, $2jatx.default)([
                                            "_bfhkrbzz _1lrwpxbi _19it36id _2rko1b66 _80omtlke _s7n4yfq0 _syazu67f _1yt416r1 _6rth12x7 _10531hxd _1di6u7gi _irr3u7gi _n7dw181d _bfw7181d"
                                        ])
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};

});
parcelRegister("ldrV1", function(module, exports) {
$parcel$export(module.exports, "Button", function () { return $f2a07ad59f7f3627$export$353f5b6fc5456de1; });
/* button.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
const $f2a07ad59f7f3627$var$buttonStyles = {
    primary: {
        // default styles
        darkblue: {
            textColor: '#ffffff',
            buttonBackgroundColor: '#0052cc',
            buttonHoverColor: '#0047B3',
            buttonFocusColor: '#004099',
            border: 'none'
        },
        blueprimary700: {
            textColor: '#ffffff',
            buttonBackgroundColor: '#1868DB',
            buttonHoverColor: '#0047B3',
            buttonFocusColor: '#004099',
            border: 'none'
        },
        yellow: {
            textColor: '#172b4d',
            buttonBackgroundColor: '#ffab00',
            buttonHoverColor: '#ff991f',
            buttonFocusColor: '#ff8b00',
            border: 'none'
        },
        green: {
            textColor: '#172b4d',
            buttonBackgroundColor: '#79f2c0',
            buttonHoverColor: '#57d9a3',
            buttonFocusColor: '#36b37e',
            border: 'none'
        },
        lightblue: {
            textColor: '#0052cc',
            buttonBackgroundColor: '#deebff',
            buttonHoverColor: '#B3D4FF',
            buttonFocusColor: '#4c9aff',
            border: 'none'
        },
        gray: {
            textColor: '#172b4d',
            buttonBackgroundColor: '#ebecf0',
            buttonHoverColor: '#DFE1E6',
            buttonFocusColor: '#c1c7d0',
            border: 'none'
        },
        disabled: {
            textColor: '#97a0af',
            buttonBackgroundColor: '#ebecf0',
            buttonHoverColor: '',
            buttonFocusColor: '',
            border: 'none'
        }
    },
    secondary: {
        darkblue: {
            textColor: '#0052cc',
            buttonBackgroundColor: 'transparent',
            buttonHoverColor: '#ebecf0',
            buttonFocusColor: '#deebff',
            border: `0.063rem solid #0052cc`
        },
        blueprimary700: {
            textColor: '#1868DB',
            buttonBackgroundColor: 'transparent',
            buttonHoverColor: '#ebecf0',
            buttonFocusColor: '#deebff',
            border: `0.063rem solid #1868DB`
        },
        yellow: {
            textColor: '#172b4d',
            buttonBackgroundColor: 'transparent',
            buttonHoverColor: '#f4f5f7',
            buttonFocusColor: '#FFF0B3',
            border: `0.063rem solid #ffab00`
        },
        green: {
            textColor: '#172b4d',
            buttonBackgroundColor: 'transparent',
            buttonHoverColor: '#f4f5f7',
            buttonFocusColor: '#e3fcef',
            border: `0.063rem solid #79f2c0`
        },
        white: {
            textColor: '#ffffff',
            buttonBackgroundColor: 'transparent',
            buttonHoverColor: 'rgba(255, 255, 255, 0.10)',
            buttonFocusColor: 'rgba(255, 255, 255, 0.20)',
            border: `0.063rem solid #ffffff`
        },
        disabled: {
            textColor: '#97a0af',
            buttonBackgroundColor: '#ebecf0',
            buttonHoverColor: '',
            buttonFocusColor: '',
            border: 'none'
        },
        whiteblue: {
            textColor: '#ffffff',
            buttonBackgroundColor: 'transparent',
            buttonHoverColor: 'rgba(255, 255, 255, 0.10)',
            buttonFocusColor: 'rgba(255, 255, 255, 0.20)',
            border: `0.063rem solid #0052cc`
        }
    }
};
const $f2a07ad59f7f3627$var$getButtonSize = (size)=>{
    const buttonSize = size?.toLowerCase();
    if (buttonSize && buttonSize === 'small') return 'small';
    return 'large';
};
const $f2a07ad59f7f3627$var$getButtonType = (type)=>{
    const buttonType = type?.toLowerCase();
    if (buttonType === 'secondary') return 'secondary';
    return 'primary';
};
const $f2a07ad59f7f3627$var$isButtonColor = (color)=>{
    return color === 'darkblue' || color === 'blueprimary700' || color === 'yellow' || color === 'green' || color === 'lightblue' || color === 'white' || color === 'gray' || color === 'disabled';
};
const $f2a07ad59f7f3627$var$getButtonColor = (color, disabled)=>{
    if (disabled) return 'disabled';
    const buttonColor = color?.toLowerCase();
    if (buttonColor && $f2a07ad59f7f3627$var$isButtonColor(buttonColor)) return buttonColor;
    return 'darkblue';
};
const $f2a07ad59f7f3627$var$getButtonStyles = (type, color)=>{
    const styles = $f2a07ad59f7f3627$var$buttonStyles[type][color];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return styles ? styles : $f2a07ad59f7f3627$var$buttonStyles.primary.darkblue;
};
const $f2a07ad59f7f3627$export$353f5b6fc5456de1 = ({ text: text, type: type, color: color = 'darkblue', size: size, onClick: onClick, url: url, externalLink: externalLink, inputType: inputType, disabled: disabled, className: className, dataEventProps: dataEventProps })=>{
    const buttonType = $f2a07ad59f7f3627$var$getButtonType(type);
    const buttonColor = $f2a07ad59f7f3627$var$getButtonColor(color, disabled);
    const { textColor: textColor, buttonBackgroundColor: buttonBackgroundColor, buttonHoverColor: buttonHoverColor, buttonFocusColor: buttonFocusColor, border: border } = $f2a07ad59f7f3627$var$getButtonStyles(buttonType, buttonColor);
    const buttonSize = $f2a07ad59f7f3627$var$getButtonSize(size);
    const fontSize = buttonSize === 'large' ? '1rem' : '0.875rem';
    const height = buttonSize === 'large' ? '2.5rem' : '2rem';
    const cursor = disabled ? 'not-allowed' : 'pointer';
    const styles = null;
    const handleOnClick = (e)=>{
        if (disabled) e.preventDefault();
        else onClick?.(e);
    };
    if ((onClick || inputType) && !url) return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        disabled: disabled,
        type: inputType,
        ...dataEventProps,
        style: {
            "--_1yb8o8o": (0, $6ZVlx.default)(buttonBackgroundColor),
            "--_pruigo": (0, $6ZVlx.default)(border),
            "--_srel9g": (0, $6ZVlx.default)(textColor),
            "--_1hkmuwx": (0, $6ZVlx.default)(buttonHoverColor),
            "--_15riry1": (0, $6ZVlx.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $6ZVlx.default)(fontSize),
            "--_roksyz": (0, $6ZVlx.default)(height),
            "--_15yp1he": (0, $6ZVlx.default)(cursor)
        },
        children: text
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1bah1h6o _11q71otn _2rko6mu8 _vchhusvi _19it145r _syaz1u00 _1e0c116y _k48pbfng _ect4lnmy _vwz41k92 _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1du2y4cq _19lcy4cq _j6xt4hdl _1wyb25dk _4t3imry4 _80om1q22",
            className
        ]),
        onClick: handleOnClick,
        href: url,
        target: externalLink ? '_blank' : undefined,
        rel: externalLink ? 'noreferrer' : undefined,
        role: "button",
        ...dataEventProps,
        style: {
            "--_1yb8o8o": (0, $6ZVlx.default)(buttonBackgroundColor),
            "--_pruigo": (0, $6ZVlx.default)(border),
            "--_srel9g": (0, $6ZVlx.default)(textColor),
            "--_1hkmuwx": (0, $6ZVlx.default)(buttonHoverColor),
            "--_15riry1": (0, $6ZVlx.default)(buttonFocusColor),
            "--_1j2e0s2": (0, $6ZVlx.default)(fontSize),
            "--_roksyz": (0, $6ZVlx.default)(height),
            "--_15yp1he": (0, $6ZVlx.default)(cursor)
        },
        children: text
    });
};

});

parcelRegister("eC3qs", function(module, exports) {
$parcel$export(module.exports, "TextInput", function () { return $29b96b158a3cb27a$export$c86715117507e8e5; });
/* text-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");
const $29b96b158a3cb27a$var$containerStyles = null;
const $29b96b158a3cb27a$var$labelStyles = null;
const $29b96b158a3cb27a$var$inputContainerStyles = null;
const $29b96b158a3cb27a$var$inputStyles = null;
const $29b96b158a3cb27a$var$errorStyles = null;
const $29b96b158a3cb27a$var$iconStyles = null;
const $29b96b158a3cb27a$export$c86715117507e8e5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef((props, ref)=>{
    const { name: name, value: value, id: id, testId: testId, label: label, placeholder: placeholder, disabled: disabled, validation: validation, Icon: Icon, onChangeHandler: onChangeHandler, className: className, autocomplete: autocomplete } = props;
    const [text, setText] = (0, $1oC0p.useState)('');
    const [isValid, setValid] = (0, $1oC0p.useState)(true);
    const [error, setError] = (0, $1oC0p.useState)('');
    (0, $1oC0p.useEffect)(()=>{
        if (text && validation) {
            const { 0: valid, 1: error } = validation(text);
            if (valid) setError('');
            else setError(error);
            setValid(valid);
        }
        if (!text) setError('');
    }, [
        text
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _1cxkb0wy _gl1i1du8",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: name,
                className: (0, $2jatx.default)([
                    "_syaz1bqd _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm",
                    "input-container"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                        className: (0, $2jatx.default)([
                            "_vchhusvi _bfhki0pe _189eyh40 _1dqonqa1 _1h6d3739 _2rko1y44 _1o9zidpf _4t3i1jvk _bozgftgi _1bsb1osq _1wyb1j6v _vwz4cjiy _y3gn1e5h _syaz1mpp _1idrq25q _4cvx3739 _irr34m1f _27uw3739 _cun91hxd _vbqbq25q _nt751j28 _49pcnqa1 _1hvwt94y",
                            isValid ? 'valid-inp' : 'invalid-inp'
                        ]),
                        onChange: (e)=>{
                            setText(e.target.value);
                            onChangeHandler && onChangeHandler(e.target.value);
                        },
                        type: "text",
                        ref: ref,
                        name: name,
                        id: id,
                        "data-testid": testId ? testId : id,
                        value: value,
                        placeholder: placeholder,
                        disabled: disabled || false,
                        "aria-invalid": !!error,
                        "aria-errormessage": !!error ? `err${id}` : '',
                        autoComplete: autocomplete
                    }),
                    Icon && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152tidpf _u7coidpf _rjxp19bv _1bsb1tcg _4t3i1tcg _lcxvglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {})
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                id: `err${id}`,
                className: (0, $2jatx.default)([
                    "_syaz1du8 _1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfh1y44"
                ]),
                children: error
            })
        ]
    });
});
$29b96b158a3cb27a$export$c86715117507e8e5.displayName = 'TextInput';

});

parcelRegister("iPPTB", function(module, exports) {
$parcel$export(module.exports, "linkColors", function () { return $f48ada4cb493764e$export$fd6700402f766300; });
$parcel$export(module.exports, "Link", function () { return $f48ada4cb493764e$export$a6c7ac8248d6e38a; });
/* link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $7IesZ = parcelRequire("7IesZ");

var $jQ0cd = parcelRequire("jQ0cd");

var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");
const $f48ada4cb493764e$export$fd6700402f766300 = {
    bgWhite: {
        defaultColor: (0, $bNzAT.default)('color.extended.blue700'),
        hoverColor: (0, $bNzAT.default)('color.extended.blue800'),
        visitedColor: (0, $bNzAT.default)('color.extended.purple800'),
        visitedHoverColor: (0, $bNzAT.default)('color.extended.purple900')
    },
    bgBlackBlue: {
        defaultColor: (0, $bNzAT.default)('color.neutral.light0'),
        hoverColor: (0, $bNzAT.default)('color.extended.blue300'),
        visitedColor: (0, $bNzAT.default)('color.extended.purple300'),
        visitedHoverColor: (0, $bNzAT.default)('color.extended.purple600')
    },
    bgColored: {
        defaultColor: (0, $bNzAT.default)('color.primary.black'),
        hoverColor: (0, $bNzAT.default)('color.primary.black'),
        visitedColor: (0, $bNzAT.default)('color.primary.black'),
        visitedHoverColor: (0, $bNzAT.default)('color.primary.black')
    },
    bgDarkTheme: {
        defaultColor: (0, $bNzAT.default)('color.extended.blue300'),
        hoverColor: (0, $bNzAT.default)('color.extended.blue100'),
        visitedColor: (0, $bNzAT.default)('color.extended.purple300'),
        visitedHoverColor: (0, $bNzAT.default)('color.extended.purple200')
    }
};
//Functions
const $f48ada4cb493764e$var$Icon = (type)=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    if (type === 'primary') {
        const arrowIconTransitionStyles = null;
        if (isDarkTheme) return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: "17",
            height: "14",
            viewBox: "0 0 17 14",
            fill: "none",
            "aria-hidden": true,
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $2jatx.default)([
                "_ahbq12x7",
                "_v564x7w3"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "9",
                    y: "12",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "12",
                    y: "9",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "15",
                    y: "6",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "12",
                    y: "6",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "9",
                    y: "6",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "6",
                    y: "6",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "3",
                    y: "6",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    y: "6",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "12",
                    y: "3",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: "9",
                    width: "2",
                    height: "2",
                    fill: "currentColor"
                })
            ]
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
            width: "11",
            height: "8",
            viewBox: "0 0 11 8",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            className: (0, $2jatx.default)([
                "_18s81mju",
                "_v564x7w3"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
            })
        });
    }
    if (type === 'external') return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "7",
        height: "8",
        viewBox: "0 0 7 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_18s8clbo"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.04815 0.5V1.98788H4.46059L0.217983 6.22935C-0.0726609 6.51998 -0.0726609 6.99114 0.217983 7.28178C0.363801 7.4266 0.553265 7.5 0.744713 7.5C0.935169 7.5 1.12463 7.4266 1.27045 7.28178L5.51206 3.04031V5.45168H7V0.5H2.04815Z"
        })
    });
    if (type === 'video') return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_12l21b66"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.3561 7.10299L4.79449 4.21918V9.78082L10.3561 7.10299Z"
        })
    });
    if (type === 'download') return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_ahbq1b66"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M48.5,31h-3c-0.8,0-1.5,0.7-1.5,1.5v10c0,0.8-0.7,1.5-1.5,1.5h-33C8.7,44,8,43.3,8,42.5v-10   C8,31.7,7.3,31,6.5,31h-3C2.7,31,2,31.7,2,32.5V46c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V32.5C50,31.7,49.3,31,48.5,31z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                className: "download-arrow",
                d: "M25,37.6c0.6,0.6,1.5,0.6,2.1,0l13.5-13.5c0.6-0.6,0.6-1.5,0-2.1l-2.1-2.1c-0.6-0.6-1.5-0.6-2.1,0l-5.6,5.6 c-0.6,0.6-1.7,0.2-1.7-0.7V3.5C29,2.7,28.2,2,27.5,2h-3C23.7,2,23,2.7,23,3.5v21.2c0,0.9-1.1,1.3-1.7,0.7l-5.6-5.6 c-0.6-0.6-1.5-0.6-2.1,0L11.5,22c-0.6,0.6-0.6,1.5,0,2.1L25,37.6z"
            })
        ]
    });
    if (type === 'backlink') return /*#__PURE__*/ (0, $7VQPk.jsx)("i", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zg8l4jg8 _ahbq8ily _y4tiu2gc"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
            label: "",
            spacing: "none"
        })
    });
    return;
};
const $f48ada4cb493764e$var$formatLinkText = (text, type, showArrow = true)=>{
    if (type === 'video' || type === 'backlink') return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: [
            $f48ada4cb493764e$var$Icon(type),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: text
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            children: [
                text,
                showArrow && $f48ada4cb493764e$var$Icon(type)
            ]
        })
    });
};
const $f48ada4cb493764e$var$isSignInUrl = (href)=>{
    const baseUrl = "https://id.atlassian.com";
    const stargateBaseUrl = "https://www.atlassian.com/gateway/api";
    const continueUrl = stargateBaseUrl + '/start/authredirect';
    const signInUrl = `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}`;
    // Check if href matches sign-in URL with or without application parameter
    return href === signInUrl || href.startsWith(signInUrl + '&application=');
};
const $f48ada4cb493764e$var$isHyperlinkRef = (href)=>{
    return href.startsWith('#');
};
const $f48ada4cb493764e$var$isNonSigninOrWacUrl = (href)=>{
    return !(0, $jQ0cd.isLocalizableHref)(href) && !$f48ada4cb493764e$var$isSignInUrl(href) && !$f48ada4cb493764e$var$isHyperlinkRef(href);
};
const $f48ada4cb493764e$export$39aecc95f0365819 = (props)=>{
    const children = (0, $1oC0p.Children).toArray(props.children);
    if (props.type === 'inline') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: children.map((child)=>child)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "link-wrapper",
        children: children.map((child)=>child)
    });
};
const $f48ada4cb493764e$export$a6c7ac8248d6e38a = ({ text: text, href: href, type: type = 'primary', size: size, bgColor: bgColor, onClick: onClick, className: className, id: id, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, dataEventProps: dataEventProps, isStyleOnly: isStyleOnly, anchorProps: anchorProps = {}, ignoreHref: ignoreHref, showArrow: showArrow = true, showUnderline: showUnderline = true })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const bg = bgColor ? bgColor : isDarkTheme ? 'bgDarkTheme' : 'bgWhite';
    const colorDefault = $f48ada4cb493764e$export$fd6700402f766300[bg].defaultColor;
    const colorHover = $f48ada4cb493764e$export$fd6700402f766300[bg].hoverColor;
    const colorVisited = $f48ada4cb493764e$export$fd6700402f766300[bg].visitedColor;
    const colorVisitedHover = $f48ada4cb493764e$export$fd6700402f766300[bg].visitedHoverColor;
    const linkStyles = [
        type === 'modal' && null,
        type === 'inline' && showUnderline && null,
        type === 'inline' && !showUnderline && null,
        type !== 'modal' && type !== 'inline' && null,
        type === 'primary' && null,
        type === 'primary' && size === 'lg' && null,
        type === 'external' && null,
        type === 'download' && null,
        type === 'backlink' && null,
        bg === 'bgColored' && null,
        null
    ];
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(href);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)($f48ada4cb493764e$export$39aecc95f0365819, {
        type: type,
        text: text,
        href: href,
        children: [
            !isStyleOnly && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                className: (0, $2jatx.default)([
                    type === 'modal' && "_1hms8stv _ajmmgq9o _1kegt94y _l7edv77o",
                    type === 'inline' && showUnderline && "_4bfu1r31 _1hms8stv _ajmmnqa1 _l7edv77o",
                    type === 'inline' && !showUnderline && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                    type !== 'modal' && type !== 'inline' && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                    type === 'primary' && "_1up4glyw _12svdejf",
                    type === 'primary' && size === 'lg' && "_175219bv _w8l51wug",
                    type === 'external' && "_1up4glyw _12sv2vbv",
                    type === 'download' && "_1up4glyw _cxmaglyw _15k917i0 _mb8gx7w3",
                    type === 'backlink' && "_1up4glyw",
                    bg === 'bgColored' && "_1iw7txnc _18hctxnc _lgr21n0t _vq0t1n0t _svxh1ck0 _1xzs1ck0 _h4221n0t _xtd11n0t _uci7105o _bt4m105o _rd6c1n0t _dxq21n0t",
                    "_4cvr1h6o _1e0c116y _1wyb1kw7 _syazaexi _10531pdu _30l3i0o6 _n0fx1c5i _1axp1r31 _aely1r31 _l8kux7w3 _1lwiglyw _1basftgi _ra3xnqa1 _1ah3yh40 _128myh40 _mizu90cx _b933aexi",
                    className + (size ? ` link-${size}` : '')
                ]),
                href: ignoreHref ? undefined : localizedHref,
                download: type === 'download' ? '' : undefined,
                target: type === 'external' || /* redirecting to new tab if the href is not on WAC and not a Signin link */ $f48ada4cb493764e$var$isNonSigninOrWacUrl(href) ? '_blank' : '',
                rel: type === 'external' || $f48ada4cb493764e$var$isNonSigninOrWacUrl(href) ? 'noreferrer' : '',
                id: id,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledby,
                onClick: onClick,
                ...dataEventProps,
                ...anchorProps,
                style: {
                    "--_1bmh097": (0, $6ZVlx.default)(colorDefault),
                    "--_d4pjwz": (0, $6ZVlx.default)(colorVisited),
                    "--_amadh5": (0, $6ZVlx.default)(colorHover),
                    "--_1k7apmj": (0, $6ZVlx.default)(colorVisitedHover),
                    "--_d189ym": (0, $6ZVlx.default)(bg === 'bgWhite' ? (0, $bNzAT.default)('color.primary.blue') : (0, $bNzAT.default)('color.neutral.light0'))
                },
                children: $f48ada4cb493764e$var$formatLinkText(text, type, showArrow)
            }),
            isStyleOnly && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    type === 'modal' && "_1hms8stv _ajmmgq9o _1kegt94y _l7edv77o",
                    type === 'inline' && showUnderline && "_4bfu1r31 _1hms8stv _ajmmnqa1 _l7edv77o",
                    type === 'inline' && !showUnderline && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                    type !== 'modal' && type !== 'inline' && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                    type === 'primary' && "_1up4glyw _12svdejf",
                    type === 'primary' && size === 'lg' && "_175219bv _w8l51wug",
                    type === 'external' && "_1up4glyw _12sv2vbv",
                    type === 'download' && "_1up4glyw _cxmaglyw _15k917i0 _mb8gx7w3",
                    type === 'backlink' && "_1up4glyw",
                    bg === 'bgColored' && "_1iw7txnc _18hctxnc _lgr21n0t _vq0t1n0t _svxh1ck0 _1xzs1ck0 _h4221n0t _xtd11n0t _uci7105o _bt4m105o _rd6c1n0t _dxq21n0t",
                    "_4cvr1h6o _1e0c116y _1wyb1kw7 _syazaexi _10531pdu _30l3i0o6 _n0fx1c5i _1axp1r31 _aely1r31 _l8kux7w3 _1lwiglyw _1basftgi _ra3xnqa1 _1ah3yh40 _128myh40 _mizu90cx _b933aexi",
                    className
                ]),
                style: {
                    "--_1bmh097": (0, $6ZVlx.default)(colorDefault),
                    "--_d4pjwz": (0, $6ZVlx.default)(colorVisited),
                    "--_amadh5": (0, $6ZVlx.default)(colorHover),
                    "--_1k7apmj": (0, $6ZVlx.default)(colorVisitedHover),
                    "--_d189ym": (0, $6ZVlx.default)(bg === 'bgWhite' ? (0, $bNzAT.default)('color.primary.blue') : (0, $bNzAT.default)('color.neutral.light0'))
                },
                children: $f48ada4cb493764e$var$formatLinkText(text, type, showArrow)
            })
        ]
    });
};

});
parcelRegister("7IesZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59d7dd4027d6488d$var$_react = $59d7dd4027d6488d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $59d7dd4027d6488d$var$_baseNew = $59d7dd4027d6488d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $59d7dd4027d6488d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59d7dd4027d6488d$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $59d7dd4027d6488d$var$_react.default.createElement($59d7dd4027d6488d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$59d7dd4027d6488d$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $59d7dd4027d6488d$var$_default = module.exports.default = $59d7dd4027d6488d$var$ChevronLeftIcon;

});
parcelRegister("f9BpS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("fBroF")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("fBroF")).Icon; });

var $fBroF = parcelRequire("fBroF");

});
parcelRegister("fBroF", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $b5bf902dfe1a315b$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $b5bf902dfe1a315b$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $liJ1d = parcelRequire("liJ1d");

var $39c3M = parcelRequire("39c3M");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $b5bf902dfe1a315b$var$svgStyles = null;
var $b5bf902dfe1a315b$var$iconStyles = null;
var $b5bf902dfe1a315b$var$utilityIconStyles = null;
var $b5bf902dfe1a315b$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $b5bf902dfe1a315b$var$baseHcmStyles = null;
var $b5bf902dfe1a315b$var$scaleSize = null;
var $b5bf902dfe1a315b$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $b5bf902dfe1a315b$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $b5bf902dfe1a315b$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $b5bf902dfe1a315b$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $b5bf902dfe1a315b$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $b5bf902dfe1a315b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $39c3M.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $1oC0p.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $b5bf902dfe1a315b$var$baseSizeMap[type];
    var viewBoxPadding = $b5bf902dfe1a315b$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $liJ1d.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $liJ1d.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $b5bf902dfe1a315b$var$utilSizes[spacing] : size === 'small' ? $b5bf902dfe1a315b$var$coreSizeSmall[spacing] : $b5bf902dfe1a315b$var$coreSizeMedium[spacing]
        ])
    }));
});
var $b5bf902dfe1a315b$export$2e2bcd8739ae039 = $b5bf902dfe1a315b$export$f04a61298a47a40f;

});
parcelRegister("liJ1d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f81e332b8edd158e$export$2e2bcd8739ae039; });
const $f81e332b8edd158e$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f81e332b8edd158e$var$ATOMIC_GROUP_LENGTH = 5;
function $f81e332b8edd158e$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $f81e332b8edd158e$var$UNDERSCORE_UNICODE ? $f81e332b8edd158e$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});




parcelRegister("jQ0cd", function(module, exports) {
$parcel$export(module.exports, "isLocalizableHref", function () { return $88e4e59c78da1ed8$export$d83233efd38d26c1; });
$parcel$export(module.exports, "useLocalizedHref", function () { return $88e4e59c78da1ed8$export$a5c4c45429ec5d04; });
$parcel$export(module.exports, "getLocalizedHref", function () { return $88e4e59c78da1ed8$export$b586a47fa6a3b681; });
$parcel$export(module.exports, "getLocalizedHrefForPathSlug", function () { return $88e4e59c78da1ed8$export$176497dc45340bf2; });
$parcel$export(module.exports, "useLocalizedHrefTrello", function () { return $88e4e59c78da1ed8$export$fd6a1e15ffd973c5; });

var $1ka2O = parcelRequire("1ka2O");

var $3fFrT = parcelRequire("3fFrT");

var $17RBn = parcelRequire("17RBn");
function $88e4e59c78da1ed8$export$d83233efd38d26c1(href) {
    // only paths starting with a single slash to prevent localizing URLs
    // starts with a slash, followed by the end of the string or anything that's not a slash, excludes /blog/* urls
    return /^(?!\/\/)\/(blog$|$|(?!blog\/).+)/.test(href);
}
function $88e4e59c78da1ed8$export$de5a81da1eb419cc(href) {
    return (0, $3fFrT.LOCALES).some((locale)=>href.startsWith(`/${locale}/`)) || (0, $3fFrT.LOCALES).some((locale)=>href === `/${locale}`);
}
// Functions to check if known domain -  treat localhost as matching all domains for testing purposes
function $88e4e59c78da1ed8$var$isWacPage(hostname) {
    if (!hostname) return true;
    const lower = hostname.toLowerCase();
    return lower === 'www.atlassian.com' || lower.startsWith('wac.') || lower === 'localhost' || lower === '127.0.0.1';
}
function $88e4e59c78da1ed8$var$isJacPage(hostname) {
    if (!hostname) return true;
    const lower = hostname.toLowerCase();
    return lower === 'localhost' || lower === '127.0.0.1' || lower.startsWith('jira.') && lower.endsWith('.atlassian.com');
}
function $88e4e59c78da1ed8$var$getWacBaseUrl(hostname) {
    if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:9000';
    if (hostname.includes('dev')) return 'https://wac.dev.internal.atlassian.com';
    if (hostname.includes('stg')) return 'https://wac.stg.internal.atlassian.com';
    return 'https://www.atlassian.com';
}
/**
 * Hostname from the last useLocalizedHref (or useLocation) run in the tree.
 * Used by absoluteToRelativeHref so it can stay a plain function (no hooks).
 */ let $88e4e59c78da1ed8$var$currentHostname;
function $88e4e59c78da1ed8$var$getCurrentHostname() {
    if ($88e4e59c78da1ed8$var$currentHostname !== undefined) return $88e4e59c78da1ed8$var$currentHostname;
    if (typeof window !== 'undefined') return window.location?.hostname ?? '';
    return '';
}
function $88e4e59c78da1ed8$export$a5c4c45429ec5d04(href, opts = {}) {
    const { supportedLocales: supportedLocales } = opts;
    const locale = (0, $17RBn.useLocale)();
    const localizedRelativePath = $88e4e59c78da1ed8$export$b586a47fa6a3b681({
        locale: locale,
        href: href,
        supportedLocales: supportedLocales
    });
    const location = (0, $1ka2O.useLocation)();
    $88e4e59c78da1ed8$var$currentHostname = location.hostname;
    const onWacPage = $88e4e59c78da1ed8$var$isWacPage(location.hostname);
    // Absolute URLs must be handled before the WAC early return: same-origin WAC
    // links from CMS (https://www.atlassian.com/...) should strip and locale-prefix
    // like relative paths, not stay as full non-localizable strings.
    if (localizedRelativePath.startsWith('http://') || localizedRelativePath.startsWith('https://')) {
        const transformedHref = $88e4e59c78da1ed8$var$absoluteToRelativeHref(localizedRelativePath);
        return $88e4e59c78da1ed8$export$b586a47fa6a3b681({
            locale: locale,
            href: transformedHref,
            supportedLocales: supportedLocales
        });
    }
    if (onWacPage) return localizedRelativePath;
    return $88e4e59c78da1ed8$var$relativeToAbsoluteHref(localizedRelativePath, location.hostname);
}
function $88e4e59c78da1ed8$export$e7e8bdb349169587(slug) {
    return /^blog\/.+/.test(slug.replace(/^\//, ''));
}
function $88e4e59c78da1ed8$export$b586a47fa6a3b681({ locale: locale, href: href, supportedLocales: supportedLocales }) {
    if (locale === (0, $3fFrT.DEFAULT_LOCALE) || $88e4e59c78da1ed8$export$de5a81da1eb419cc(href) || !$88e4e59c78da1ed8$export$d83233efd38d26c1(href)) return href;
    if (supportedLocales) return supportedLocales.includes(locale) ? `/${locale}${href}` : href;
    return `/${locale}${href}`;
}
function $88e4e59c78da1ed8$export$176497dc45340bf2(slug, locale, supportedLocales) {
    const slugNoLeadingSlash = slug.replace(/^\//, '');
    if ($88e4e59c78da1ed8$export$e7e8bdb349169587(slugNoLeadingSlash)) return slugNoLeadingSlash;
    const href = slug.startsWith('/') ? slug : `/${slug}`;
    const localized = $88e4e59c78da1ed8$export$b586a47fa6a3b681({
        locale: locale,
        href: href,
        supportedLocales: supportedLocales
    });
    return localized.replace(/^\//, '');
}
// Continue to add domains to rules as needed
const $88e4e59c78da1ed8$var$ABSOLUTE_TO_RELATIVE_HREF_RULES = [
    {
        pattern: /^https?:\/\/jira\.atlassian\.com/,
        isApplicableHostname: $88e4e59c78da1ed8$var$isJacPage
    },
    {
        pattern: /^https?:\/\/(www\.)?atlassian\.com/,
        isApplicableHostname: $88e4e59c78da1ed8$var$isWacPage
    }
];
/**
 * Converts an absolute URL to a relative path when the current
 * page is a known domain, and the url and page domains match.
 */ function $88e4e59c78da1ed8$var$absoluteToRelativeHref(href) {
    const hostname = $88e4e59c78da1ed8$var$getCurrentHostname();
    for (const rule of $88e4e59c78da1ed8$var$ABSOLUTE_TO_RELATIVE_HREF_RULES){
        if (!rule.isApplicableHostname(hostname)) continue;
        if (!rule.pattern.test(href)) continue;
        return href.replace(rule.pattern, '');
    }
    return href; // add locale if transformed href is relevant to this transformation
}
function $88e4e59c78da1ed8$var$relativeToAbsoluteHref(localizedHref, hostname) {
    if (localizedHref.startsWith('http://') || localizedHref.startsWith('https://') // only pre-pend WAC base URL for relative paths
    ) return localizedHref;
    const baseUrl = $88e4e59c78da1ed8$var$getWacBaseUrl(hostname);
    return `${baseUrl}${localizedHref}`;
}
function $88e4e59c78da1ed8$var$getTrelloPath(trelloRoute) {
    if (trelloRoute === '/') return '';
    return trelloRoute;
}
function $88e4e59c78da1ed8$export$fd6a1e15ffd973c5(trelloRoute) {
    const trelloBaseUrl = 'https://trello.com';
    const locale = (0, $17RBn.useLocale)();
    const trelloPath = $88e4e59c78da1ed8$var$getTrelloPath(trelloRoute);
    if (locale === (0, $3fFrT.DEFAULT_LOCALE)) return `${trelloBaseUrl}${trelloPath}`;
    return `${trelloBaseUrl}/${locale}${trelloPath}`;
}

});
parcelRegister("3fFrT", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", function () { return $275440118f98c1ca$export$1af4c7e47ad72f44; });
$parcel$export(module.exports, "LOCALES", function () { return $275440118f98c1ca$export$e49c1078bc46f17; });
$parcel$export(module.exports, "ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES", function () { return $275440118f98c1ca$export$a908ba235b6ff62e; });
const $275440118f98c1ca$export$1af4c7e47ad72f44 = 'en';
const $275440118f98c1ca$export$75c094d97cea9594 = Object.freeze({
    [$275440118f98c1ca$export$1af4c7e47ad72f44]: {
        label: 'English'
    },
    de: {
        label: 'Deutsch'
    },
    es: {
        label: "Espa\xf1ol"
    },
    fr: {
        label: "Fran\xe7ais"
    },
    it: {
        label: 'Italiano'
    },
    ko: {
        label: "\uD55C\uAD6D\uC5B4"
    },
    nl: {
        label: 'Nederlands'
    },
    ja: {
        label: "\u65E5\u672C\u8A9E"
    },
    pl: {
        label: 'Polski'
    },
    br: {
        label: "Portugu\xeas"
    },
    ru: {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    zh: {
        label: "\u4E2D\u6587"
    },
    xx: {
        label: 'Pseudo-Translation'
    },
    zz: {
        label: 'Instrumented Language Pack'
    }
});
const $275440118f98c1ca$export$e49c1078bc46f17 = Object.keys($275440118f98c1ca$export$75c094d97cea9594);
const $275440118f98c1ca$export$a908ba235b6ff62e = [
    'ja'
];

});

parcelRegister("17RBn", function(module, exports) {
$parcel$export(module.exports, "useLocale", function () { return $cf74730a7219fe1c$export$43bb16f9c6d9e3f7; });

var $8e22h = parcelRequire("8e22h");
function $cf74730a7219fe1c$export$43bb16f9c6d9e3f7() {
    const intl = (0, $8e22h.default)();
    return intl.locale;
}

});


parcelRegister("eOIix", function(module, exports) {
$parcel$export(module.exports, "useDarkTheme", function () { return $98a2e82d8874c2c6$export$32877abefa39f365; });
$parcel$export(module.exports, "DarkThemeProvider", function () { return $98a2e82d8874c2c6$export$dc5a7624741be003; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $98a2e82d8874c2c6$var$DarkThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    isDarkTheme: false
});
const $98a2e82d8874c2c6$export$32877abefa39f365 = ()=>(0, $1oC0p.useContext)($98a2e82d8874c2c6$var$DarkThemeContext);
const $98a2e82d8874c2c6$var$darkThemeStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    ['--wac-color-heading']: (0, $bNzAT.default)('color.neutral.light0'),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    ['--wac-color-body']: (0, $bNzAT.default)('color.neutral.light0'),
    backgroundColor: (0, $bNzAT.default)('color.neutral.dark100')
};
const $98a2e82d8874c2c6$export$dc5a7624741be003 = ({ enabled: enabled, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($98a2e82d8874c2c6$var$DarkThemeContext.Provider, {
        value: {
            isDarkTheme: enabled
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            style: enabled ? $98a2e82d8874c2c6$var$darkThemeStyles : undefined,
            children: children
        })
    });
};

});


parcelRegister("iRMRa", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_VALUES", function () { return $196a08136dab40ed$export$d7e66ef6999696cf; });

var $7VQPk = parcelRequire("7VQPk");
const $196a08136dab40ed$export$d7e66ef6999696cf = Object.freeze({
    /* Must be a function: @formatjs/intl rich-text tags reject non-function values */ br: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
    p: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: chunks
        }),
    strong: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
            children: chunks
        }),
    span: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            children: chunks
        }),
    ul: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            children: chunks
        }),
    ol: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("ol", {
            children: chunks
        }),
    li: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            children: chunks
        })
});

});

parcelRegister("1rGpC", function(module, exports) {
$parcel$export(module.exports, "Row", function () { return $3fabe4e603d968c0$export$b59bdbef9ce70de2; });
/* grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8U8MO = parcelRequire("8U8MO");
const $3fabe4e603d968c0$export$646318bfa978508f = 32;
const $3fabe4e603d968c0$export$b50d6c5b7d4ed95f = 60;
const $3fabe4e603d968c0$var$MAX_CONTENT_WIDTH = 1152;
/**
 * key: layout
 * value: number of children
 */ const $3fabe4e603d968c0$var$layoutCounts = {
    '12': 1,
    '6-6': 2,
    '4-4-4': 3,
    '3-3-3-3': 4,
    '2-2-2-2-2-2': 6,
    '4-8': 2,
    '7-5': 2,
    '5-7': 2,
    '3-9': 2,
    '8-4': 2,
    '9-3': 2,
    '3-3-6': 3,
    '6-3-3': 3,
    '8': 1,
    '10': 1,
    overlay: 12
};
/**
 * key: number of children
 * value: default layout style for that number of children
 */ const $3fabe4e603d968c0$var$defaultLayouts = {
    '1': '12',
    '2': '6-6',
    '3': '4-4-4',
    '4': '3-3-3-3',
    '6': '2-2-2-2-2-2'
};
Object.freeze($3fabe4e603d968c0$var$defaultLayouts);
const $3fabe4e603d968c0$export$b59bdbef9ce70de2 = (props)=>{
    let { layout: layout } = props;
    const { alignItems: alignItems, containerType: Container = 'div' } = props;
    const children = (0, $1oC0p.Children).toArray(props.children);
    if (layout === undefined) {
        layout = $3fabe4e603d968c0$var$defaultLayouts[children.length];
        if (layout === undefined) throw new Error(`${children.length} is an invalid number of children`);
    } else {
        // @ts-ignore
        if (children.length !== $3fabe4e603d968c0$var$layoutCounts[layout]) throw new Error(// @ts-ignore
        `Row with layout "${layout}" should have ${$3fabe4e603d968c0$var$layoutCounts[layout]} children`);
    }
    const alignItemStyles = {
        ...(!alignItems || alignItems === 'default') && {
            alignItems: 'stretch'
        },
        ...alignItems === 'top' && {
            alignItems: 'start'
        },
        ...alignItems === 'bottom' && {
            alignItems: 'end'
        },
        ...alignItems === 'center' && {
            alignItems: 'center'
        }
    };
    const commonLayoutStyles = {
        display: 'grid',
        justifyContent: 'space-between',
        margin: 'auto',
        maxWidth: '100%',
        boxSizing: 'border-box',
        paddingInlineStart: `${$3fabe4e603d968c0$export$646318bfa978508f}px`,
        paddingInlineEnd: `${$3fabe4e603d968c0$export$646318bfa978508f}px`,
        gap: '24px',
        width: '100%',
        [(0, $8U8MO.media).only.sm]: {
            paddingInlineStart: `${$3fabe4e603d968c0$export$b50d6c5b7d4ed95f}px`,
            paddingInlineEnd: `${$3fabe4e603d968c0$export$b50d6c5b7d4ed95f}px`
        },
        [(0, $8U8MO.media).above.md]: {
            paddingInlineStart: `${$3fabe4e603d968c0$export$b50d6c5b7d4ed95f}px`,
            paddingInlineEnd: `${$3fabe4e603d968c0$export$b50d6c5b7d4ed95f}px`,
            width: `${$3fabe4e603d968c0$var$MAX_CONTENT_WIDTH + $3fabe4e603d968c0$export$b50d6c5b7d4ed95f * 2}px`,
            gap: '32px'
        },
        // rows nested inside rows have no padding added
        '.row-layout': {
            padding: 0
        },
        // top margin for rows that come directly after another row
        ['+ .row-layout']: {
            marginBlockStart: '24px',
            [(0, $8U8MO.media).above.sm]: {
                marginBlockStart: '32px'
            }
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)(Container, {
        className: (0, $2jatx.default)([
            layout === '12' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '12' && alignItems === 'top' && "_4cvrv2br",
            layout === '12' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '12' && alignItems === 'center' && "_4cvr1h6o",
            layout === '12' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z",
            layout === '6-6' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '6-6' && alignItems === 'top' && "_4cvrv2br",
            layout === '6-6' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '6-6' && alignItems === 'center' && "_4cvr1h6o",
            layout === '6-6' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1da7f9jr _1rqtf9jr",
            layout === '4-4-4' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '4-4-4' && alignItems === 'top' && "_4cvrv2br",
            layout === '4-4-4' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '4-4-4' && alignItems === 'center' && "_4cvr1h6o",
            layout === '4-4-4' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1da713mt _1rqt13mt",
            layout === '3-3-3-3' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '3-3-3-3' && alignItems === 'top' && "_4cvrv2br",
            layout === '3-3-3-3' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '3-3-3-3' && alignItems === 'center' && "_4cvr1h6o",
            layout === '3-3-3-3' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1da714vn _1rqtorlc",
            layout === '2-2-2-2-2-2' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '2-2-2-2-2-2' && alignItems === 'top' && "_4cvrv2br",
            layout === '2-2-2-2-2-2' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '2-2-2-2-2-2' && alignItems === 'center' && "_4cvr1h6o",
            layout === '2-2-2-2-2-2' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ef9jr _1da79sye _1rqt14bh",
            layout === '4-8' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '4-8' && alignItems === 'top' && "_4cvrv2br",
            layout === '4-8' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '4-8' && alignItems === 'center' && "_4cvr1h6o",
            layout === '4-8' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1j8baigu _mym5kb7n _13ilqfx8 _1ptbqfx8 _5h3x1mrw",
            layout === '3-9' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '3-9' && alignItems === 'top' && "_4cvrv2br",
            layout === '3-9' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '3-9' && alignItems === 'center' && "_4cvr1h6o",
            layout === '3-9' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1rqtaigu _17tnkb7n _1fujegat _17o0egat _14hn1mrw",
            layout === '7-5' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '7-5' && alignItems === 'top' && "_4cvrv2br",
            layout === '7-5' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '7-5' && alignItems === 'center' && "_4cvr1h6o",
            layout === '7-5' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1j8baigu _mym5kb7n _13il37uc _1ptb37uc _5h3x1mrw",
            layout === '5-7' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '5-7' && alignItems === 'top' && "_4cvrv2br",
            layout === '5-7' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '5-7' && alignItems === 'center' && "_4cvr1h6o",
            layout === '5-7' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1j8baigu _mym5kb7n _13ilouyt _1ptbouyt _5h3x1mrw",
            layout === '8-4' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '8-4' && alignItems === 'top' && "_4cvrv2br",
            layout === '8-4' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '8-4' && alignItems === 'center' && "_4cvr1h6o",
            layout === '8-4' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1j8baigu _mym5kb7n _13il1406 _1ptb1406 _5h3x1mrw",
            layout === '9-3' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '9-3' && alignItems === 'top' && "_4cvrv2br",
            layout === '9-3' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '9-3' && alignItems === 'center' && "_4cvr1h6o",
            layout === '9-3' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0ei47z _1rqtaigu _17tnkb7n _1fujzo7u _17o0zo7u _14hn1mrw",
            layout === '3-3-6' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '3-3-6' && alignItems === 'top' && "_4cvrv2br",
            layout === '3-3-6' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '3-3-6' && alignItems === 'center' && "_4cvr1h6o",
            layout === '3-3-6' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0eaigu _2z05f5ih _ie8e1k3i _1x2yrc5h _1s3sshur _1s8mi47z _kw9nzhk0 _fuuvirhf _f95ishur _ye8si9zr _1rqtaigu _12qz1wug _1ef51p06 _1h0e1oot _6k40rc5h",
            layout === '6-3-3' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '6-3-3' && alignItems === 'top' && "_4cvrv2br",
            layout === '6-3-3' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '6-3-3' && alignItems === 'center' && "_4cvr1h6o",
            layout === '6-3-3' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0eaigu _2z05155w _ie8eirhf _1x2yze3z _1s3sfcmy _1s8mi47z _kw9nzhk0 _fuuvirhf _f95ishur _ye8si9zr _1rqtaigu _17tnkb7n _1fuj1ohn _1l861ohn _1g7pzo7u _17sykb7n _17o0zo7u _14hn1mrw _17imkb7n",
            layout === '8' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '8' && alignItems === 'top' && "_4cvrv2br",
            layout === '8' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '8' && alignItems === 'center' && "_4cvr1h6o",
            layout === '8' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0eaigu _1yuzkb7n _kg471mrw _x6ovcs5v _1gic1ial _19d7i47z _1nrm11wp _1ctxibnn",
            layout === '10' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === '10' && alignItems === 'top' && "_4cvrv2br",
            layout === '10' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === '10' && alignItems === 'center' && "_4cvr1h6o",
            layout === '10' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0eaigu _1yuzkb7n _kg471mrw _19d7i47z _1nrmcs5v _1ctx1ial",
            layout === 'overlay' && (!alignItems || alignItems === 'default') && "_4cvr1fhb",
            layout === 'overlay' && alignItems === 'top' && "_4cvrv2br",
            layout === 'overlay' && alignItems === 'bottom' && "_4cvrh9n0",
            layout === 'overlay' && alignItems === 'center' && "_4cvr1h6o",
            layout === 'overlay' && "_1e0c11p5 _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _gltezqdx _pdlmzwfg _3intidpf _4fugidpf _1ynqidpf _1j3nidpf _1mcm1tcg _pnnxzwfg _yv0eaigu",
            `row-layout`
        ]),
        children: children.map((child)=>child)
    });
};

});
parcelRegister("8U8MO", function(module, exports) {
$parcel$export(module.exports, "media", function () { return $67ba5e74022331f3$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see https://compiledcssinjs.com/docs/atomic-css#selector-specificity
 */ var $67ba5e74022331f3$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
var $67ba5e74022331f3$export$c881183ca713c214 = $67ba5e74022331f3$export$987d49ffe1b0900f;

});



parcelRegister("bZeFo", function(module, exports) {
$parcel$export(module.exports, "ContentNotFoundError", function () { return $17008bd4e0b1b1e6$export$a3e68d1507452712; });
$parcel$export(module.exports, "isContentNotFoundError", function () { return $17008bd4e0b1b1e6$export$c572523773a0cf86; });
$parcel$export(module.exports, "isRelayError", function () { return $17008bd4e0b1b1e6$export$73091806b58ee969; });
$parcel$export(module.exports, "isContentFetchError", function () { return $17008bd4e0b1b1e6$export$a2ad256522850238; });
class $17008bd4e0b1b1e6$export$a3e68d1507452712 extends Error {
    constructor({ message: message }){
        super(message ?? 'Content not found');
        this.name = $17008bd4e0b1b1e6$export$a3e68d1507452712.name;
    }
}
const $17008bd4e0b1b1e6$export$c572523773a0cf86 = (error)=>{
    return error instanceof $17008bd4e0b1b1e6$export$a3e68d1507452712;
};
const $17008bd4e0b1b1e6$export$73091806b58ee969 = (error)=>{
    if (!error) return false;
    const errorObj = error;
    return !!(errorObj.name && errorObj.name.includes('RelayNetwork') || errorObj.message && errorObj.message.includes('Relay'));
};
// Function names that indicate content/GraphQL operations.
const $17008bd4e0b1b1e6$var$CONTENT_FUNCTION_PATTERNS = [
    'fetchResponse',
    // Relay environment fetches
    'fetchOperation',
    // urql fetches
    'AGGClient.query' // AGG client fetches
];
const $17008bd4e0b1b1e6$export$a2ad256522850238 = (error)=>{
    if (!(error instanceof Error)) return false;
    // Check if it's a fetch error
    const hasFetchErrorMessage = error.message.includes('Failed to fetch') || error.message.includes('Load failed') || error.message.includes('[Network]'); // urql network error.
    if (!hasFetchErrorMessage) return false;
    // If there's no stack trace, we can't verify the context
    if (!error.stack) return false;
    // Check if the stack trace contains content-related function calls
    return $17008bd4e0b1b1e6$var$CONTENT_FUNCTION_PATTERNS.some((pattern)=>error.stack?.includes(pattern));
};

});


parcelRegister("5HK05", function(module, exports) {
$parcel$export(module.exports, "expectContent", function () { return $dfddc83eb8cca398$export$50455c11b3b28590; });

var $bZeFo = parcelRequire("bZeFo");
function $dfddc83eb8cca398$export$50455c11b3b28590(value, message) {
    if (value === null || value === undefined) throw new (0, $bZeFo.ContentNotFoundError)({
        message: message ?? 'Content not found'
    });
    return value;
}

});

parcelRegister("1iUL9", function(module, exports) {
$parcel$export(module.exports, "SharedHeaderFooterContainer", function () { return $93f54770d715b743$export$93790172861f3d8b; });
$parcel$export(module.exports, "ConfluenceTemplateHeaderContainer", function () { return $93f54770d715b743$export$715c042529a2f5fe; });
/* shared-header-footer-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("20OkY");
var $7gFRR = parcelRequire("7gFRR");

var $1rObi = parcelRequire("1rObi");

var $iHYHa = parcelRequire("iHYHa");

var $bv77X = parcelRequire("bv77X");

var $iLjCW = parcelRequire("iLjCW");

var $hCHU3 = parcelRequire("hCHU3");
const $93f54770d715b743$var$minHeight = null;
const $93f54770d715b743$export$93790172861f3d8b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1tke8stt"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rObi.CrossFlowTouchpointProvider), {
            productKeys: [
                (0, $7gFRR.ProductKeys).CONFLUENCE
            ],
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCHU3.default), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHYHa.SiteSelectorContextProvider), {
                        productKey: (0, $7gFRR.ProductKeys).CONFLUENCE,
                        analyticsPrefix: "wac.showroom",
                        internalLinkAfterIdentity: "/team-playbook/plays/choose-your-site",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                            id: "content",
                            children: children
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
            ]
        })
    });
};
const $93f54770d715b743$export$715c042529a2f5fe = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
        productKeys: [
            (0, $7gFRR.ProductKeys).CONFLUENCE
        ],
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHYHa.SiteSelectorContextProvider), {
                productKey: (0, $7gFRR.ProductKeys).CONFLUENCE,
                analyticsPrefix: "wac.showroom",
                internalLinkAfterIdentity: "/team-playbook/plays/choose-your-site",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCHU3.default), {})
            })
        })
    });
};

});
parcelRegister("20OkY", function(module, exports) {
$parcel$export(module.exports, "Editions", function () { return (parcelRequire("7gFRR")).Editions; });
$parcel$export(module.exports, "ProductKeys", function () { return (parcelRequire("7gFRR")).ProductKeys; });
parcelRequire("3cg1Z");
parcelRequire("7gFRR");
parcelRequire("yTps3");

});
parcelRegister("3cg1Z", function(module, exports) {
parcelRequire("6EbjO");
var $iHAYP = parcelRequire("iHAYP");

var $yagHz = parcelRequire("yagHz");
parcelRequire("bVDCn");
var $jaDjo = parcelRequire("jaDjo");
var $7IOsL = parcelRequire("7IOsL");
var $65S3s = parcelRequire("65S3s");

var $2fcu1 = parcelRequire("2fcu1");

var $eO0KE = parcelRequire("eO0KE");

var $7gFRR = parcelRequire("7gFRR");

var $oJ9ed = parcelRequire("oJ9ed");
parcelRequire("5Te4K");
var $LDEj3 = parcelRequire("LDEj3");
var $iw2YK = parcelRequire("iw2YK");
var $4gpJS = parcelRequire("4gpJS");
var $253eed8bf59f59c3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $253eed8bf59f59c3$export$d7d36d558022b438 = 'https://wac.stg.internal.atlassian.com/gateway/api';
const $253eed8bf59f59c3$export$c039d0ad0b34bf5 = 'https://id.staging.atl-paas.net';
const $253eed8bf59f59c3$var$openRequestCache = new Map();
class $253eed8bf59f59c3$export$c66ca190f89caaac {
    constructor({ baseUrl: baseUrl, disableRequestDeduplication: disableRequestDeduplication }){
        this.baseUrl = baseUrl;
        this.disableRequestDeduplication = disableRequestDeduplication;
    }
    /**
     * Deduplicate fetch requests made while there is an open request with the same cacheKey
     * @param cacheKey
     * @param input
     * @param init
     * @private
     */ dedupeFetch(cacheKey, input, init) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableRequestDeduplication) return (0, $2fcu1.fetch)(input, init);
            // Check for an open request
            const cachedResult = $253eed8bf59f59c3$var$openRequestCache.get(cacheKey);
            if (cachedResult) return cachedResult.then((res)=>res.clone());
            // Create a new request based on the input
            const request = (0, $2fcu1.fetch)(input, init);
            $253eed8bf59f59c3$var$openRequestCache.set(cacheKey, request);
            // Return the request and clear it from cache when it completes
            return request.finally(()=>{
                $253eed8bf59f59c3$var$openRequestCache.delete(cacheKey);
            });
        });
    }
    /**
     * Get the xsrf token required to make calls to the signup server
     *
     * @see https://bxp-signup-server.staging.atl-paas.net/swagger/#/Authentication/get_auth_xsrf
     */ getSignupServerXsrfToken(webPlatform) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToText)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/auth/xsrf`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'accept': 'text/plain',
                    'web-platform': webPlatform || 'no-platform'
                }
            })));
        });
    }
    /**
     * Get the authentication methods available to a given user.
     *
     * @see https://bxp-signup-server.us-west-2.prod.atl-paas.net/swagger/#/Identity/post_authentication_methods_available
     */ checkAuthenticationMethodsAvailable({ email: email, application: application = 'wac', successRedirect: successRedirect, webPlatform: webPlatform }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $LDEj3.getAtlCohortIdFromCookie)();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/authentication/methods-available`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'X-Atl-Cohort-Id': atlCohortId,
                    'web-platform': webPlatform || 'no-platform'
                },
                credentials: 'include',
                body: JSON.stringify({
                    email: email,
                    application: application,
                    continue: successRedirect
                })
            })));
        });
    }
    /**
     * Get whether a user has a permission for a particular resource.
     *
     * @see https://id-public-api-facade.prod.atl-paas.net/swagger.json
     */ getUserPermissionsIsPermitted({ permissionId: permissionId, resourceId: resourceId, dontRequirePrincipalInSite: dontRequirePrincipalInSite, webPlatform: webPlatform }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/permissions/permitted`, {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'web-platform': webPlatform || 'no-platform'
                },
                body: JSON.stringify({
                    permissionId: permissionId,
                    resourceId: resourceId,
                    dontRequirePrincipalInSite: dontRequirePrincipalInSite
                })
            })));
        });
    }
    /**
     * Returns details about the current authenticated user.
     * This is expected to be consistent with Atlassian account.
     *
     * @see https://id-public-api-facade.prod.atl-paas.net/swagger.json
     */ getCurrentAuthenticatedUser() {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/me`, {
                credentials: 'include'
            })));
        });
    }
    /**
     * Gets trial information for Atlassian products. Currently only supports
     *   JSW.
     *
     * @returns
     */ getProductHubInfo() {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/producthub/info`, {
                credentials: 'include'
            })));
        });
    }
    postCloudSignUp({ payload: payload, webPlatform: webPlatform }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/cloud/signup`, {
                method: 'POST',
                headers: {
                    'web-platform': webPlatform || 'no-platform',
                    'Content-Type': 'application/json',
                    'atl-cookies': JSON.stringify({
                        _ga: (0, (/*@__PURE__*/$parcel$interopDefault($eO0KE))).get('_ga') || '',
                        seg_xid: localStorage.getItem('seg_xid') || '',
                        __atl_path: (0, (/*@__PURE__*/$parcel$interopDefault($eO0KE))).get('__atl_path') || '',
                        ajs_anonymous_id: (0, (/*@__PURE__*/$parcel$interopDefault($eO0KE))).get('ajs_anonymous_id') || ''
                    })
                },
                body: JSON.stringify(payload),
                credentials: 'include'
            })));
        });
    }
    /**
     * Rename a Cloud
     * @see https://cofs.dev.public.atl-paas.net/api.html#external__cloudId__rename_put
     */ renameCloud({ cloudId: cloudId, cloudName: cloudName, webPlatform: webPlatform }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/cofs/${cloudId}/rename`, {
                method: 'put',
                body: JSON.stringify({
                    cloudName: cloudName
                }),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'web-platform': webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    /**
     * @see https://cloud-name-availability.prod.atl-paas.net/swagger-ui/index.html#/name-availability-stargate-controller/checkAvailabilityUsingPOST
     */ checkCloudNameAvailability({ cloudName: cloudName, webPlatform: webPlatform }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/hostname/cloud/availability/check`, {
                method: 'post',
                body: JSON.stringify({
                    cloudName: cloudName
                }),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'web-platform': webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    getUserCloudSites({ product: product, editions: editions, adminAccess: adminAccess, licenseLevels: licenseLevels, billingFrequency: billingFrequency }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/cloud/users/cloudsites`, {
                method: 'post',
                body: JSON.stringify({
                    product: product,
                    editions: editions,
                    adminAccess: adminAccess,
                    licenseLevels: licenseLevels,
                    billingFrequency: billingFrequency
                }),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })));
        });
    }
    /**
     * Get the new ais/available-products
     */ availableProducts({ includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite, removeNonAdminSites: removeNonAdminSites }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const reqUrl = `${this.baseUrl}/ais/available-products`;
            const response = yield this.dedupeFetch(reqUrl, reqUrl, {
                method: 'GET',
                credentials: 'include'
            });
            if (response.ok) {
                const result = yield response.json();
                let sites = result && result.sites || [];
                if (removeNonAdminSites) sites = sites.filter((site)=>site.adminAccess);
                if (!includeInvalidSites) sites = sites.filter((site)=>(0, $4gpJS.isValidSite)({
                        site: site,
                        includeInvalidBitbucketSite: includeInvalidBitbucketSite
                    }));
                return Promise.resolve({
                    sites: sites,
                    isNewUser: !!(result && result.isNewUser)
                });
            } else throw new (0, $65S3s.UnsucessfulFetchError)({
                response: response
            });
        });
    }
    userSignup(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $LDEj3.getAtlCohortIdFromCookie)();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/identity/user-signup`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'X-Atl-Cohort-Id': atlCohortId,
                    'web-platform': request.webPlatform || 'no-platform',
                    'recaptcha-site-key': (0, $iw2YK.getReCaptchaKey)()
                },
                credentials: 'include',
                body: JSON.stringify(Object.assign({}, request))
            })));
        });
    }
    activateProduct(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $LDEj3.getAtlCohortIdFromCookie)();
            const upstreamResponse = yield (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/activate-product`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'X-Atl-Cohort-Id': atlCohortId,
                    'web-platform': request.webPlatform || 'no-platform',
                    'x-b3-sampled': '1',
                    'recaptcha-site-key': (0, $iw2YK.getReCaptchaKey)()
                },
                credentials: 'include',
                body: JSON.stringify(request)
            })));
            return upstreamResponse;
        });
    }
    getProductActivationStatus(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/activate/status/${request.provisioningRequestId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    getLicenceInformationStatus(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/cloud/${request.cloudId}/license-information`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    // for attaching a product to an existing site, xflow worked on the endpoint
    postProductActivate(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/product/activate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'web-platform': request.webPlatform || 'no-platform',
                    'recaptcha-site-key': (0, $iw2YK.getReCaptchaKey)()
                },
                credentials: 'include',
                body: JSON.stringify(request)
            })));
        });
    }
    // for attaching a product to an existing site using COFS, xflow worked on the endpoint
    postCOFSProductActivate(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const { cloudId: cloudId } = request;
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/xflow/${cloudId}/activate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include',
                body: JSON.stringify(request)
            })));
        });
    }
    /**
     * Indentity calls
     */ me({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const url = `${this.baseUrl}/me`;
            const response = yield this.dedupeFetch(`${url}-${cloudSessionTokenCookie}`, url, {
                headers: (0, $jaDjo.mapCookieToHeaders)(cloudSessionTokenCookie),
                credentials: 'include'
            });
            if (response.ok) return (0, $7gFRR.mapMeResponseToUserProfile)((yield response.json()));
            else throw new (0, $65S3s.UnsucessfulFetchError)({
                response: response
            });
        });
    }
    /**
     * Get a list of Bitbucket workspaces
     * @param nextUrl - override the request URL for pagination
     * bitbucket/user/permissions/workspaces?sort=workspace.slug
     */ bitbucketWorkspaces({ nextUrl: nextUrl, cloudSessionTokenCookie: cloudSessionTokenCookie, urlQuery: urlQuery }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            let reqUrl = `${this.baseUrl}/bitbucket/user/permissions/workspaces`;
            if (nextUrl) reqUrl = nextUrl;
            if (urlQuery) reqUrl = `${reqUrl}?${urlQuery}`;
            const response = yield (0, $2fcu1.fetch)(reqUrl, {
                headers: (0, $jaDjo.mapCookieToHeaders)(cloudSessionTokenCookie),
                credentials: 'include'
            });
            if (response.ok) return Promise.resolve((yield response.json()));
            else throw new (0, $65S3s.UnsucessfulFetchError)({
                response: response
            });
        });
    }
    /**
     * The legacy get availableProducts call from IdentityClient
     */ availableProductsLegacy({ cloudSessionTokenCookie: cloudSessionTokenCookie, includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const reqUrl = `${this.baseUrl}/available-products/api/available-products`;
            const response = yield (0, $2fcu1.fetch)(reqUrl, {
                headers: (0, $jaDjo.mapCookieToHeaders)(cloudSessionTokenCookie),
                credentials: 'include'
            });
            if (response.ok) {
                const result = yield response.json();
                let sites = result && result.sites || [];
                sites = (0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).remove((0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).map(sites, (site)=>{
                    const products = (0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).map(site.availableProducts, (product)=>{
                        return (0, $oJ9ed.PRODUCT_KEY_MAP)[product.productType];
                    }).filter((product)=>product !== undefined);
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).isEmpty(products)) return {
                        adminAccess: site.adminAccess,
                        cloudId: site.cloudId,
                        displayName: site.displayName,
                        url: site.url,
                        products: products
                    };
                    else return null;
                }), (site)=>site !== undefined && site !== null);
                if (!includeInvalidSites) sites = sites.filter((site)=>(0, $4gpJS.isValidSite)({
                        site: site,
                        includeInvalidBitbucketSite: includeInvalidBitbucketSite
                    }));
                return Promise.resolve(sites);
            } else throw new (0, $65S3s.UnsucessfulFetchError)({
                response: response
            });
        });
    }
    patchUserProfile(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const { body: body, userId: userId, cloudSessionTokenCookie: cloudSessionTokenCookie } = request;
            const options = {
                headers: {
                    'content-type': 'application/json',
                    'Cookie': (0, $jaDjo.serializeCookie)(cloudSessionTokenCookie)
                }
            };
            return new Promise((resolve, reject)=>{
                (0, $iHAYP.default).patch(`${this.baseUrl}/users/${userId}/manage/profile`, body, options).then((response)=>{
                    resolve(response.data);
                }).catch((err)=>{
                    reject(err.toString());
                });
            });
        });
    }
    getCcpHamsStatus(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const { cloudId: cloudId, offeringKeys: offeringKeys } = request;
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bag/rollout/service?cloudId=${cloudId}&offeringKeys=${offeringKeys}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })));
        });
    }
    getAvailableSites(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const { orderId: orderId, transactionAccount: transactionAccount } = request;
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/v1/order/${orderId}/available-sites`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Transaction-Account': transactionAccount,
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    activateDirectBuyProduct(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/v1/order/${request.orderId}/activation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'X-Transaction-Account': request.transactionAccountId,
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include',
                body: JSON.stringify({
                    timezone: request.timezone,
                    region: request.region,
                    site: request.site
                })
            })));
        });
    }
    getCloudProductInfo(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/v1/cloud/${request.cloudId}/product-information`, {
                headers: {
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    getProductEdition(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const { cloudId: cloudId, productKey: productKey } = request;
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/cloud/edition/${cloudId}/${productKey}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })));
        });
    }
    getConsentConfig() {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/preferencesV2/consent-config`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })));
        });
    }
    postConsentConfig() {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/preferencesV2/consent-config`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            })));
        });
    }
    postExpandFreeValidation(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const { cloudId: cloudId, productKeys: productKeys } = request;
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/cloud/expand-free-validation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    cloudId: cloudId,
                    productKeys: productKeys
                })
            })));
        });
    }
    getActivationAuthorization(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const { productKeys: productKeys, productEdition: productEdition, cloudId: cloudId, siteName: siteName } = request;
            const atlCohortId = (0, $LDEj3.getAtlCohortIdFromCookie)();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/activation-authorization?${new URLSearchParams({
                productKeys: productKeys.join(','),
                productEdition: productEdition,
                cloudId: cloudId !== null && cloudId !== void 0 ? cloudId : '',
                siteName: siteName
            })}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Atl-Cohort-Id': atlCohortId,
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    getFeatureFlag(request, webPlatform) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const flag = request;
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/feature-flag/${flag}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'web-platform': webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    getFeatureFlagSync(request, webPlatform) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const flag = request;
            const atlCohortId = (0, $LDEj3.getAtlCohortIdFromCookie)();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/feature-flag/sync/${flag}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Atl-Cohort-Id': atlCohortId,
                    'web-platform': webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    getRecommendedSiteName(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $LDEj3.getAtlCohortIdFromCookie)();
            const headers = (0, $jaDjo.mapCookieToHeaders)(request.cloudSessionTokenCookie);
            Object.assign(headers, {
                'Content-Type': 'application/json',
                'xsrf-token': xsrfToken,
                'X-Atl-Cohort-Id': atlCohortId,
                'web-platform': request.webPlatform || 'no-platform'
            });
            const response = yield (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/site/recommended-name`, {
                method: 'POST',
                headers: headers,
                credentials: 'include',
                body: JSON.stringify(request)
            })));
            return response;
        });
    }
    getAccountOrgs({ includeVortexMode: includeVortexMode, webPlatform: webPlatform }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const params = includeVortexMode === true ? `?includeVortexMode=true` : '';
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/account/orgs${params}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'web-platform': webPlatform || 'no-platform'
                },
                credentials: 'include'
            })));
        });
    }
    cofsCreateOrg(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $LDEj3.getAtlCohortIdFromCookie)();
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/cofs-create-organization`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'X-Atl-Cohort-Id': atlCohortId,
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include',
                body: JSON.stringify(request)
            })));
        });
    }
    cofsActivateProductExisting(request) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            const xsrfToken = yield this.getSignupServerXsrfToken();
            const atlCohortId = (0, $LDEj3.getAtlCohortIdFromCookie)();
            const upstreamResponse = yield (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bxp/signup/cofs-activate-product-existing`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken,
                    'X-Atl-Cohort-Id': atlCohortId,
                    'web-platform': request.webPlatform || 'no-platform'
                },
                credentials: 'include',
                body: JSON.stringify(request)
            })));
            return upstreamResponse;
        });
    }
    bitbucketValidateWorkspaceSlug({ workspaceSlug: workspaceSlug }) {
        return $253eed8bf59f59c3$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7IOsL.mapResponseToJson)((yield (0, $2fcu1.fetch)(`${this.baseUrl}/bitbucket/api/internal/workspace/slug/validate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    workspace_slug: workspaceSlug
                })
            })));
        });
    }
}

});
parcelRegister("6EbjO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("iHAYP")).default; });

var $iHAYP = parcelRequire("iHAYP");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $4d6f4227cbec4fcf$export$1c00760e9e5a4e95, AxiosError: $4d6f4227cbec4fcf$export$c1fbed17c2f6a328, CanceledError: $4d6f4227cbec4fcf$export$1ab0c6b20d94fa14, isCancel: $4d6f4227cbec4fcf$export$3b22524397b493c6, CancelToken: $4d6f4227cbec4fcf$export$fd08e3cb425f0d61, VERSION: $4d6f4227cbec4fcf$export$a4ad2735b021c132, all: $4d6f4227cbec4fcf$export$84bf76cd7afc7469, Cancel: $4d6f4227cbec4fcf$export$848c9b7ead0df967, isAxiosError: $4d6f4227cbec4fcf$export$fbafdbe06a5b5a9a, spread: $4d6f4227cbec4fcf$export$3ae0fd4797ed47c8, toFormData: $4d6f4227cbec4fcf$export$10ae0d317ea97f8b, AxiosHeaders: $4d6f4227cbec4fcf$export$4e7d6ff0f3e6520, HttpStatusCode: $4d6f4227cbec4fcf$export$a972f69c851492b3, formToJSON: $4d6f4227cbec4fcf$export$86d7c59254d6a2c9, getAdapter: $4d6f4227cbec4fcf$export$17ddc20a97d669e2, mergeConfig: $4d6f4227cbec4fcf$export$7ec1ebcfa9d8bd6a } = (0, $iHAYP.default);

});
parcelRegister("iHAYP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9d8eda2c37aae23$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $kjXsO = parcelRequire("kjXsO");

var $8BTYv = parcelRequire("8BTYv");

var $b5Jb3 = parcelRequire("b5Jb3");

var $923YE = parcelRequire("923YE");

var $dTtlQ = parcelRequire("dTtlQ");

var $btf5G = parcelRequire("btf5G");

var $4kO57 = parcelRequire("4kO57");

var $cGKWs = parcelRequire("cGKWs");

var $fPqQR = parcelRequire("fPqQR");

var $b1RGd = parcelRequire("b1RGd");

var $jKTMl = parcelRequire("jKTMl");

var $dFt4h = parcelRequire("dFt4h");

var $7BvpI = parcelRequire("7BvpI");

var $dO5L3 = parcelRequire("dO5L3");

var $duJ6N = parcelRequire("duJ6N");

var $hesDl = parcelRequire("hesDl");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $d9d8eda2c37aae23$var$createInstance(defaultConfig) {
    const context = new (0, $8BTYv.default)(defaultConfig);
    const instance = (0, $kjXsO.default)((0, $8BTYv.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $6VlRc.default).extend(instance, (0, $8BTYv.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $6VlRc.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $d9d8eda2c37aae23$var$createInstance((0, $b5Jb3.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $d9d8eda2c37aae23$var$axios = $d9d8eda2c37aae23$var$createInstance((0, $923YE.default));
// Expose Axios class to allow class inheritance
$d9d8eda2c37aae23$var$axios.Axios = (0, $8BTYv.default);
// Expose Cancel & CancelToken
$d9d8eda2c37aae23$var$axios.CanceledError = (0, $btf5G.default);
$d9d8eda2c37aae23$var$axios.CancelToken = (0, $4kO57.default);
$d9d8eda2c37aae23$var$axios.isCancel = (0, $cGKWs.default);
$d9d8eda2c37aae23$var$axios.VERSION = (0, $fPqQR.VERSION);
$d9d8eda2c37aae23$var$axios.toFormData = (0, $b1RGd.default);
// Expose AxiosError class
$d9d8eda2c37aae23$var$axios.AxiosError = (0, $jKTMl.default);
// alias for CanceledError for backward compatibility
$d9d8eda2c37aae23$var$axios.Cancel = $d9d8eda2c37aae23$var$axios.CanceledError;
// Expose all/spread
$d9d8eda2c37aae23$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$d9d8eda2c37aae23$var$axios.spread = (0, $dFt4h.default);
// Expose isAxiosError
$d9d8eda2c37aae23$var$axios.isAxiosError = (0, $7BvpI.default);
// Expose mergeConfig
$d9d8eda2c37aae23$var$axios.mergeConfig = (0, $b5Jb3.default);
$d9d8eda2c37aae23$var$axios.AxiosHeaders = (0, $dO5L3.default);
$d9d8eda2c37aae23$var$axios.formToJSON = (thing)=>(0, $dTtlQ.default)((0, $6VlRc.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$d9d8eda2c37aae23$var$axios.getAdapter = (0, $duJ6N.default).getAdapter;
$d9d8eda2c37aae23$var$axios.HttpStatusCode = (0, $hesDl.default);
$d9d8eda2c37aae23$var$axios.default = $d9d8eda2c37aae23$var$axios;
var // this module should only have a default export
$d9d8eda2c37aae23$export$2e2bcd8739ae039 = $d9d8eda2c37aae23$var$axios;

});
parcelRegister("6VlRc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $50a9054cac8b89c0$export$2e2bcd8739ae039; });

var $kjXsO = parcelRequire("kjXsO");

var $7t0tI = parcelRequire("7t0tI");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $50a9054cac8b89c0$var$toString } = Object.prototype;
const { getPrototypeOf: $50a9054cac8b89c0$var$getPrototypeOf } = Object;
const { iterator: $50a9054cac8b89c0$var$iterator, toStringTag: $50a9054cac8b89c0$var$toStringTag } = Symbol;
const $50a9054cac8b89c0$var$kindOf = ((cache)=>(thing)=>{
        const str = $50a9054cac8b89c0$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $50a9054cac8b89c0$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$50a9054cac8b89c0$var$kindOf(thing) === type;
};
const $50a9054cac8b89c0$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $50a9054cac8b89c0$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $50a9054cac8b89c0$var$isUndefined = $50a9054cac8b89c0$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $50a9054cac8b89c0$var$isBuffer(val) {
    return val !== null && !$50a9054cac8b89c0$var$isUndefined(val) && val.constructor !== null && !$50a9054cac8b89c0$var$isUndefined(val.constructor) && $50a9054cac8b89c0$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $50a9054cac8b89c0$var$isArrayBuffer = $50a9054cac8b89c0$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $50a9054cac8b89c0$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $50a9054cac8b89c0$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $50a9054cac8b89c0$var$isString = $50a9054cac8b89c0$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $50a9054cac8b89c0$var$isFunction = $50a9054cac8b89c0$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $50a9054cac8b89c0$var$isNumber = $50a9054cac8b89c0$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $50a9054cac8b89c0$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $50a9054cac8b89c0$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $50a9054cac8b89c0$var$isPlainObject = (val)=>{
    if ($50a9054cac8b89c0$var$kindOf(val) !== 'object') return false;
    const prototype = $50a9054cac8b89c0$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($50a9054cac8b89c0$var$toStringTag in val) && !($50a9054cac8b89c0$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $50a9054cac8b89c0$var$isDate = $50a9054cac8b89c0$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $50a9054cac8b89c0$var$isFile = $50a9054cac8b89c0$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $50a9054cac8b89c0$var$isBlob = $50a9054cac8b89c0$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $50a9054cac8b89c0$var$isFileList = $50a9054cac8b89c0$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $50a9054cac8b89c0$var$isStream = (val)=>$50a9054cac8b89c0$var$isObject(val) && $50a9054cac8b89c0$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $50a9054cac8b89c0$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $50a9054cac8b89c0$var$isFunction(thing.append) && ((kind = $50a9054cac8b89c0$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $50a9054cac8b89c0$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $50a9054cac8b89c0$var$isURLSearchParams = $50a9054cac8b89c0$var$kindOfTest('URLSearchParams');
const [$50a9054cac8b89c0$var$isReadableStream, $50a9054cac8b89c0$var$isRequest, $50a9054cac8b89c0$var$isResponse, $50a9054cac8b89c0$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($50a9054cac8b89c0$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $50a9054cac8b89c0$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $50a9054cac8b89c0$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($50a9054cac8b89c0$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $50a9054cac8b89c0$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $50a9054cac8b89c0$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $50a9054cac8b89c0$var$isContextDefined = (context)=>!$50a9054cac8b89c0$var$isUndefined(context) && context !== $50a9054cac8b89c0$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $50a9054cac8b89c0$var$merge() {
    const { caseless: caseless } = $50a9054cac8b89c0$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $50a9054cac8b89c0$var$findKey(result, key) || key;
        if ($50a9054cac8b89c0$var$isPlainObject(result[targetKey]) && $50a9054cac8b89c0$var$isPlainObject(val)) result[targetKey] = $50a9054cac8b89c0$var$merge(result[targetKey], val);
        else if ($50a9054cac8b89c0$var$isPlainObject(val)) result[targetKey] = $50a9054cac8b89c0$var$merge({}, val);
        else if ($50a9054cac8b89c0$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $50a9054cac8b89c0$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $50a9054cac8b89c0$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $50a9054cac8b89c0$var$forEach(b, (val, key)=>{
        if (thisArg && $50a9054cac8b89c0$var$isFunction(val)) a[key] = (0, $kjXsO.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $50a9054cac8b89c0$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $50a9054cac8b89c0$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $50a9054cac8b89c0$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $50a9054cac8b89c0$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $50a9054cac8b89c0$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $50a9054cac8b89c0$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($50a9054cac8b89c0$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$50a9054cac8b89c0$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $50a9054cac8b89c0$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $50a9054cac8b89c0$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $50a9054cac8b89c0$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$50a9054cac8b89c0$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $50a9054cac8b89c0$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $50a9054cac8b89c0$var$isHTMLForm = $50a9054cac8b89c0$var$kindOfTest('HTMLFormElement');
const $50a9054cac8b89c0$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $50a9054cac8b89c0$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $50a9054cac8b89c0$var$isRegExp = $50a9054cac8b89c0$var$kindOfTest('RegExp');
const $50a9054cac8b89c0$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $50a9054cac8b89c0$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $50a9054cac8b89c0$var$freezeMethods = (obj)=>{
    $50a9054cac8b89c0$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($50a9054cac8b89c0$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$50a9054cac8b89c0$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $50a9054cac8b89c0$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $50a9054cac8b89c0$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $50a9054cac8b89c0$var$noop = ()=>{};
const $50a9054cac8b89c0$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $50a9054cac8b89c0$var$isSpecCompliantForm(thing) {
    return !!(thing && $50a9054cac8b89c0$var$isFunction(thing.append) && thing[$50a9054cac8b89c0$var$toStringTag] === 'FormData' && thing[$50a9054cac8b89c0$var$iterator]);
}
const $50a9054cac8b89c0$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($50a9054cac8b89c0$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $50a9054cac8b89c0$var$isArray(source) ? [] : {};
                $50a9054cac8b89c0$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$50a9054cac8b89c0$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $50a9054cac8b89c0$var$isAsyncFn = $50a9054cac8b89c0$var$kindOfTest('AsyncFunction');
const $50a9054cac8b89c0$var$isThenable = (thing)=>thing && ($50a9054cac8b89c0$var$isObject(thing) || $50a9054cac8b89c0$var$isFunction(thing)) && $50a9054cac8b89c0$var$isFunction(thing.then) && $50a9054cac8b89c0$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $50a9054cac8b89c0$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $50a9054cac8b89c0$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $50a9054cac8b89c0$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $50a9054cac8b89c0$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $50a9054cac8b89c0$var$isFunction($50a9054cac8b89c0$var$_global.postMessage));
const $50a9054cac8b89c0$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($50a9054cac8b89c0$var$_global) : typeof $7t0tI !== 'undefined' && $7t0tI.nextTick || $50a9054cac8b89c0$var$_setImmediate;
// *********************
const $50a9054cac8b89c0$var$isIterable = (thing)=>thing != null && $50a9054cac8b89c0$var$isFunction(thing[$50a9054cac8b89c0$var$iterator]);
var $50a9054cac8b89c0$export$2e2bcd8739ae039 = {
    isArray: $50a9054cac8b89c0$var$isArray,
    isArrayBuffer: $50a9054cac8b89c0$var$isArrayBuffer,
    isBuffer: $50a9054cac8b89c0$var$isBuffer,
    isFormData: $50a9054cac8b89c0$var$isFormData,
    isArrayBufferView: $50a9054cac8b89c0$var$isArrayBufferView,
    isString: $50a9054cac8b89c0$var$isString,
    isNumber: $50a9054cac8b89c0$var$isNumber,
    isBoolean: $50a9054cac8b89c0$var$isBoolean,
    isObject: $50a9054cac8b89c0$var$isObject,
    isPlainObject: $50a9054cac8b89c0$var$isPlainObject,
    isReadableStream: $50a9054cac8b89c0$var$isReadableStream,
    isRequest: $50a9054cac8b89c0$var$isRequest,
    isResponse: $50a9054cac8b89c0$var$isResponse,
    isHeaders: $50a9054cac8b89c0$var$isHeaders,
    isUndefined: $50a9054cac8b89c0$var$isUndefined,
    isDate: $50a9054cac8b89c0$var$isDate,
    isFile: $50a9054cac8b89c0$var$isFile,
    isBlob: $50a9054cac8b89c0$var$isBlob,
    isRegExp: $50a9054cac8b89c0$var$isRegExp,
    isFunction: $50a9054cac8b89c0$var$isFunction,
    isStream: $50a9054cac8b89c0$var$isStream,
    isURLSearchParams: $50a9054cac8b89c0$var$isURLSearchParams,
    isTypedArray: $50a9054cac8b89c0$var$isTypedArray,
    isFileList: $50a9054cac8b89c0$var$isFileList,
    forEach: $50a9054cac8b89c0$var$forEach,
    merge: $50a9054cac8b89c0$var$merge,
    extend: $50a9054cac8b89c0$var$extend,
    trim: $50a9054cac8b89c0$var$trim,
    stripBOM: $50a9054cac8b89c0$var$stripBOM,
    inherits: $50a9054cac8b89c0$var$inherits,
    toFlatObject: $50a9054cac8b89c0$var$toFlatObject,
    kindOf: $50a9054cac8b89c0$var$kindOf,
    kindOfTest: $50a9054cac8b89c0$var$kindOfTest,
    endsWith: $50a9054cac8b89c0$var$endsWith,
    toArray: $50a9054cac8b89c0$var$toArray,
    forEachEntry: $50a9054cac8b89c0$var$forEachEntry,
    matchAll: $50a9054cac8b89c0$var$matchAll,
    isHTMLForm: $50a9054cac8b89c0$var$isHTMLForm,
    hasOwnProperty: $50a9054cac8b89c0$var$hasOwnProperty,
    hasOwnProp: $50a9054cac8b89c0$var$hasOwnProperty,
    reduceDescriptors: $50a9054cac8b89c0$var$reduceDescriptors,
    freezeMethods: $50a9054cac8b89c0$var$freezeMethods,
    toObjectSet: $50a9054cac8b89c0$var$toObjectSet,
    toCamelCase: $50a9054cac8b89c0$var$toCamelCase,
    noop: $50a9054cac8b89c0$var$noop,
    toFiniteNumber: $50a9054cac8b89c0$var$toFiniteNumber,
    findKey: $50a9054cac8b89c0$var$findKey,
    global: $50a9054cac8b89c0$var$_global,
    isContextDefined: $50a9054cac8b89c0$var$isContextDefined,
    isSpecCompliantForm: $50a9054cac8b89c0$var$isSpecCompliantForm,
    toJSONObject: $50a9054cac8b89c0$var$toJSONObject,
    isAsyncFn: $50a9054cac8b89c0$var$isAsyncFn,
    isThenable: $50a9054cac8b89c0$var$isThenable,
    setImmediate: $50a9054cac8b89c0$var$_setImmediate,
    asap: $50a9054cac8b89c0$var$asap,
    isIterable: $50a9054cac8b89c0$var$isIterable
};

});
parcelRegister("kjXsO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ecb3b53ce6ac35e3$export$2e2bcd8739ae039; });
'use strict';
function $ecb3b53ce6ac35e3$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("8BTYv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $644d32db4fd821c0$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $5bpGt = parcelRequire("5bpGt");

var $3la4Y = parcelRequire("3la4Y");

var $bhAHR = parcelRequire("bhAHR");

var $b5Jb3 = parcelRequire("b5Jb3");

var $gZgEM = parcelRequire("gZgEM");

var $dzxJs = parcelRequire("dzxJs");

var $dO5L3 = parcelRequire("dO5L3");
'use strict';
const $644d32db4fd821c0$var$validators = (0, $dzxJs.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $644d32db4fd821c0$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $3la4Y.default)(),
            response: new (0, $3la4Y.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $b5Jb3.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $dzxJs.default).assertOptions(transitional, {
            silentJSONParsing: $644d32db4fd821c0$var$validators.transitional($644d32db4fd821c0$var$validators.boolean),
            forcedJSONParsing: $644d32db4fd821c0$var$validators.transitional($644d32db4fd821c0$var$validators.boolean),
            clarifyTimeoutError: $644d32db4fd821c0$var$validators.transitional($644d32db4fd821c0$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $6VlRc.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $dzxJs.default).assertOptions(paramsSerializer, {
                encode: $644d32db4fd821c0$var$validators.function,
                serialize: $644d32db4fd821c0$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $dzxJs.default).assertOptions(config, {
            baseUrl: $644d32db4fd821c0$var$validators.spelling('baseURL'),
            withXsrfToken: $644d32db4fd821c0$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $6VlRc.default).merge(headers.common, headers[config.method]);
        headers && (0, $6VlRc.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $dO5L3.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $bhAHR.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $bhAHR.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $b5Jb3.default)(this.defaults, config);
        const fullPath = (0, $gZgEM.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $5bpGt.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $6VlRc.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $644d32db4fd821c0$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $b5Jb3.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $6VlRc.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $b5Jb3.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $644d32db4fd821c0$var$Axios.prototype[method] = generateHTTPMethod();
    $644d32db4fd821c0$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $644d32db4fd821c0$export$2e2bcd8739ae039 = $644d32db4fd821c0$var$Axios;

});
parcelRegister("5bpGt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3c61e72c30e5e940$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $dAnbO = parcelRequire("dAnbO");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $3c61e72c30e5e940$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $3c61e72c30e5e940$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $3c61e72c30e5e940$var$encode;
    if ((0, $6VlRc.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $6VlRc.default).isURLSearchParams(params) ? params.toString() : new (0, $dAnbO.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("dAnbO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9e40a01b1d5cec49$export$2e2bcd8739ae039; });

var $b1RGd = parcelRequire("b1RGd");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $9e40a01b1d5cec49$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $9e40a01b1d5cec49$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $b1RGd.default)(params, this, options);
}
const $9e40a01b1d5cec49$var$prototype = $9e40a01b1d5cec49$var$AxiosURLSearchParams.prototype;
$9e40a01b1d5cec49$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$9e40a01b1d5cec49$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $9e40a01b1d5cec49$var$encode);
    } : $9e40a01b1d5cec49$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $9e40a01b1d5cec49$export$2e2bcd8739ae039 = $9e40a01b1d5cec49$var$AxiosURLSearchParams;

});
parcelRegister("b1RGd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80796d67adfbd0c3$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $jKTMl = parcelRequire("jKTMl");

var $fgD3D = parcelRequire("fgD3D");

var $567QU = parcelRequire("567QU");
var $80796d67adfbd0c3$require$Buffer = $567QU.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $80796d67adfbd0c3$var$isVisitable(thing) {
    return (0, $6VlRc.default).isPlainObject(thing) || (0, $6VlRc.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $80796d67adfbd0c3$var$removeBrackets(key) {
    return (0, $6VlRc.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $80796d67adfbd0c3$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $80796d67adfbd0c3$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $80796d67adfbd0c3$var$isFlatArray(arr) {
    return (0, $6VlRc.default).isArray(arr) && !arr.some($80796d67adfbd0c3$var$isVisitable);
}
const $80796d67adfbd0c3$var$predicates = (0, $6VlRc.default).toFlatObject((0, $6VlRc.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $80796d67adfbd0c3$var$toFormData(obj, formData, options) {
    if (!(0, $6VlRc.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $fgD3D.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $6VlRc.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $6VlRc.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $6VlRc.default).isSpecCompliantForm(formData);
    if (!(0, $6VlRc.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $6VlRc.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $6VlRc.default).isBlob(value)) throw new (0, $jKTMl.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $6VlRc.default).isArrayBuffer(value) || (0, $6VlRc.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $80796d67adfbd0c3$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $6VlRc.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $6VlRc.default).isArray(value) && $80796d67adfbd0c3$var$isFlatArray(value) || ((0, $6VlRc.default).isFileList(value) || (0, $6VlRc.default).endsWith(key, '[]')) && (arr = (0, $6VlRc.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $80796d67adfbd0c3$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $6VlRc.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $80796d67adfbd0c3$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($80796d67adfbd0c3$var$isVisitable(value)) return true;
        formData.append($80796d67adfbd0c3$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($80796d67adfbd0c3$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $80796d67adfbd0c3$var$isVisitable
    });
    function build(value, path) {
        if ((0, $6VlRc.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $6VlRc.default).forEach(value, function each(el, key) {
            const result = !((0, $6VlRc.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $6VlRc.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $6VlRc.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $80796d67adfbd0c3$export$2e2bcd8739ae039 = $80796d67adfbd0c3$var$toFormData;

});
parcelRegister("jKTMl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e61d94b420117ab5$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $e61d94b420117ab5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $6VlRc.default).inherits($e61d94b420117ab5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $6VlRc.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $e61d94b420117ab5$var$prototype = $e61d94b420117ab5$var$AxiosError.prototype;
const $e61d94b420117ab5$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $e61d94b420117ab5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($e61d94b420117ab5$var$AxiosError, $e61d94b420117ab5$var$descriptors);
Object.defineProperty($e61d94b420117ab5$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$e61d94b420117ab5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($e61d94b420117ab5$var$prototype);
    (0, $6VlRc.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $e61d94b420117ab5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $e61d94b420117ab5$export$2e2bcd8739ae039 = $e61d94b420117ab5$var$AxiosError;

});

parcelRegister("fgD3D", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b1d6a5b13f9485c2$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $b1d6a5b13f9485c2$export$2e2bcd8739ae039 = null;

});




parcelRegister("3la4Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26eb26ca0e20f4ce$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");
'use strict';
class $26eb26ca0e20f4ce$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $6VlRc.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $26eb26ca0e20f4ce$export$2e2bcd8739ae039 = $26eb26ca0e20f4ce$var$InterceptorManager;

});

parcelRegister("bhAHR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $836dc15c7c4f0730$export$2e2bcd8739ae039; });

var $1L8bH = parcelRequire("1L8bH");

var $cGKWs = parcelRequire("cGKWs");

var $923YE = parcelRequire("923YE");

var $btf5G = parcelRequire("btf5G");

var $dO5L3 = parcelRequire("dO5L3");

var $duJ6N = parcelRequire("duJ6N");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $836dc15c7c4f0730$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $btf5G.default)(null, config);
}
function $836dc15c7c4f0730$export$2e2bcd8739ae039(config) {
    $836dc15c7c4f0730$var$throwIfCancellationRequested(config);
    config.headers = (0, $dO5L3.default).from(config.headers);
    // Transform request data
    config.data = (0, $1L8bH.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $duJ6N.default).getAdapter(config.adapter || (0, $923YE.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $836dc15c7c4f0730$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $1L8bH.default).call(config, config.transformResponse, response);
        response.headers = (0, $dO5L3.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $cGKWs.default)(reason)) {
            $836dc15c7c4f0730$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $1L8bH.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $dO5L3.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("1L8bH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1480881fe56e3bc6$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $923YE = parcelRequire("923YE");

var $dO5L3 = parcelRequire("dO5L3");
'use strict';
function $1480881fe56e3bc6$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $923YE.default);
    const context = response || config;
    const headers = (0, $dO5L3.default).from(context.headers);
    let data = context.data;
    (0, $6VlRc.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("923YE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $693762bf197660ac$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $jKTMl = parcelRequire("jKTMl");

var $gvguD = parcelRequire("gvguD");

var $b1RGd = parcelRequire("b1RGd");

var $7KEct = parcelRequire("7KEct");

var $9FmKe = parcelRequire("9FmKe");

var $dTtlQ = parcelRequire("dTtlQ");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $693762bf197660ac$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $6VlRc.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $6VlRc.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $693762bf197660ac$var$defaults = {
    transitional: (0, $gvguD.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $6VlRc.default).isObject(data);
            if (isObjectPayload && (0, $6VlRc.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $6VlRc.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $dTtlQ.default)(data)) : data;
            if ((0, $6VlRc.default).isArrayBuffer(data) || (0, $6VlRc.default).isBuffer(data) || (0, $6VlRc.default).isStream(data) || (0, $6VlRc.default).isFile(data) || (0, $6VlRc.default).isBlob(data) || (0, $6VlRc.default).isReadableStream(data)) return data;
            if ((0, $6VlRc.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $6VlRc.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $7KEct.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $6VlRc.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $b1RGd.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $693762bf197660ac$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $693762bf197660ac$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $6VlRc.default).isResponse(data) || (0, $6VlRc.default).isReadableStream(data)) return data;
            if (data && (0, $6VlRc.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $jKTMl.default).from(e, (0, $jKTMl.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $9FmKe.default).classes.FormData,
        Blob: (0, $9FmKe.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $6VlRc.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $693762bf197660ac$var$defaults.headers[method] = {};
});
var $693762bf197660ac$export$2e2bcd8739ae039 = $693762bf197660ac$var$defaults;

});
parcelRegister("gvguD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c03c55c18363c7f0$export$2e2bcd8739ae039; });
'use strict';
var $c03c55c18363c7f0$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("7KEct", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5a4c03349b845525$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $b1RGd = parcelRequire("b1RGd");

var $9FmKe = parcelRequire("9FmKe");
'use strict';
function $5a4c03349b845525$export$2e2bcd8739ae039(data, options) {
    return (0, $b1RGd.default)(data, new (0, $9FmKe.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $9FmKe.default).isNode && (0, $6VlRc.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("9FmKe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70999607a7af15e8$export$2e2bcd8739ae039; });

var $6t3Pd = parcelRequire("6t3Pd");

var $e66NJ = parcelRequire("e66NJ");
var $70999607a7af15e8$export$2e2bcd8739ae039 = {
    ...$e66NJ,
    ...(0, $6t3Pd.default)
};

});
parcelRegister("6t3Pd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b586b100a005d1a$export$2e2bcd8739ae039; });

var $lv1Ku = parcelRequire("lv1Ku");

var $4kyNg = parcelRequire("4kyNg");

var $iF3Gn = parcelRequire("iF3Gn");
var $4b586b100a005d1a$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $lv1Ku.default,
        FormData: $4kyNg.default,
        Blob: $iF3Gn.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("lv1Ku", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa6dd97d54ca7e17$export$2e2bcd8739ae039; });

var $dAnbO = parcelRequire("dAnbO");
'use strict';
var $fa6dd97d54ca7e17$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $dAnbO.default);

});

parcelRegister("4kyNg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $327404fc4f0f02a4$export$2e2bcd8739ae039; });
'use strict';
var $327404fc4f0f02a4$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("iF3Gn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d95ee993fda119d4$export$2e2bcd8739ae039; });
'use strict';
var $d95ee993fda119d4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("e66NJ", function(module, exports) {
$parcel$export(module.exports, "hasBrowserEnv", function () { return $a436e6cd37bb162b$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $a436e6cd37bb162b$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $a436e6cd37bb162b$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $a436e6cd37bb162b$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $a436e6cd37bb162b$export$f710a83a91838a36; });
const $a436e6cd37bb162b$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $a436e6cd37bb162b$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $a436e6cd37bb162b$export$c0bcc9250309d66 = $a436e6cd37bb162b$export$c4996c4b7b93b0bf && (!$a436e6cd37bb162b$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($a436e6cd37bb162b$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $a436e6cd37bb162b$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $a436e6cd37bb162b$export$f710a83a91838a36 = $a436e6cd37bb162b$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("dTtlQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1d72df885e24c11$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a1d72df885e24c11$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $6VlRc.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a1d72df885e24c11$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a1d72df885e24c11$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $6VlRc.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $6VlRc.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $6VlRc.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $6VlRc.default).isArray(target[name])) target[name] = $a1d72df885e24c11$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $6VlRc.default).isFormData(formData) && (0, $6VlRc.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $6VlRc.default).forEachEntry(formData, (name, value)=>{
            buildPath($a1d72df885e24c11$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a1d72df885e24c11$export$2e2bcd8739ae039 = $a1d72df885e24c11$var$formDataToJSON;

});


parcelRegister("dO5L3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a0d4694299152a0b$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $1zeZJ = parcelRequire("1zeZJ");
'use strict';
const $a0d4694299152a0b$var$$internals = Symbol('internals');
function $a0d4694299152a0b$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $a0d4694299152a0b$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $6VlRc.default).isArray(value) ? value.map($a0d4694299152a0b$var$normalizeValue) : String(value);
}
function $a0d4694299152a0b$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $a0d4694299152a0b$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $a0d4694299152a0b$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $6VlRc.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $6VlRc.default).isString(value)) return;
    if ((0, $6VlRc.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $6VlRc.default).isRegExp(filter)) return filter.test(value);
}
function $a0d4694299152a0b$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $a0d4694299152a0b$var$buildAccessors(obj, header) {
    const accessorName = (0, $6VlRc.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $a0d4694299152a0b$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $a0d4694299152a0b$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $6VlRc.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $a0d4694299152a0b$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $6VlRc.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $6VlRc.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $6VlRc.default).isString(header) && (header = header.trim()) && !$a0d4694299152a0b$var$isValidHeaderName(header)) setHeaders((0, $1zeZJ.default)(header), valueOrRewrite);
        else if ((0, $6VlRc.default).isObject(header) && (0, $6VlRc.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $6VlRc.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $6VlRc.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $a0d4694299152a0b$var$normalizeHeader(header);
        if (header) {
            const key = (0, $6VlRc.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $a0d4694299152a0b$var$parseTokens(value);
                if ((0, $6VlRc.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $6VlRc.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $a0d4694299152a0b$var$normalizeHeader(header);
        if (header) {
            const key = (0, $6VlRc.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $a0d4694299152a0b$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $a0d4694299152a0b$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $6VlRc.default).findKey(self, _header);
                if (key && (!matcher || $a0d4694299152a0b$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $6VlRc.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $a0d4694299152a0b$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $6VlRc.default).forEach(this, (value, header)=>{
            const key = (0, $6VlRc.default).findKey(headers, header);
            if (key) {
                self[key] = $a0d4694299152a0b$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $a0d4694299152a0b$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $a0d4694299152a0b$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $6VlRc.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $6VlRc.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$a0d4694299152a0b$var$$internals] = this[$a0d4694299152a0b$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $a0d4694299152a0b$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $a0d4694299152a0b$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $6VlRc.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$a0d4694299152a0b$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $6VlRc.default).reduceDescriptors($a0d4694299152a0b$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $6VlRc.default).freezeMethods($a0d4694299152a0b$var$AxiosHeaders);
var $a0d4694299152a0b$export$2e2bcd8739ae039 = $a0d4694299152a0b$var$AxiosHeaders;

});
parcelRegister("1zeZJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1244b0f8d94ec6de$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $1244b0f8d94ec6de$var$ignoreDuplicateOf = (0, $6VlRc.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $1244b0f8d94ec6de$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $1244b0f8d94ec6de$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("cGKWs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $93cdd1efa9381224$export$2e2bcd8739ae039; });
'use strict';
function $93cdd1efa9381224$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("btf5G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $859e1bd9049af19a$export$2e2bcd8739ae039; });

var $jKTMl = parcelRequire("jKTMl");

var $6VlRc = parcelRequire("6VlRc");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $859e1bd9049af19a$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $jKTMl.default).call(this, message == null ? 'canceled' : message, (0, $jKTMl.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $6VlRc.default).inherits($859e1bd9049af19a$var$CanceledError, (0, $jKTMl.default), {
    __CANCEL__: true
});
var $859e1bd9049af19a$export$2e2bcd8739ae039 = $859e1bd9049af19a$var$CanceledError;

});

parcelRegister("duJ6N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d311151b553f250$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $fgD3D = parcelRequire("fgD3D");

var $a5hC6 = parcelRequire("a5hC6");

var $1jCGW = parcelRequire("1jCGW");

var $jKTMl = parcelRequire("jKTMl");
const $9d311151b553f250$var$knownAdapters = {
    http: (0, $fgD3D.default),
    xhr: (0, $a5hC6.default),
    fetch: (0, $1jCGW.default)
};
(0, $6VlRc.default).forEach($9d311151b553f250$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $9d311151b553f250$var$renderReason = (reason)=>`- ${reason}`;
const $9d311151b553f250$var$isResolvedHandle = (adapter)=>(0, $6VlRc.default).isFunction(adapter) || adapter === null || adapter === false;
var $9d311151b553f250$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $6VlRc.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$9d311151b553f250$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $9d311151b553f250$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $jKTMl.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($9d311151b553f250$var$renderReason).join('\n') : ' ' + $9d311151b553f250$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $jKTMl.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $9d311151b553f250$var$knownAdapters
};

});
parcelRegister("a5hC6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $757808b386f3e8c7$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $9s52i = parcelRequire("9s52i");

var $gvguD = parcelRequire("gvguD");

var $jKTMl = parcelRequire("jKTMl");

var $btf5G = parcelRequire("btf5G");

var $Kz4aS = parcelRequire("Kz4aS");

var $9FmKe = parcelRequire("9FmKe");

var $dO5L3 = parcelRequire("dO5L3");

var $jJzDQ = parcelRequire("jJzDQ");

var $fi15f = parcelRequire("fi15f");
const $757808b386f3e8c7$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $757808b386f3e8c7$export$2e2bcd8739ae039 = $757808b386f3e8c7$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $fi15f.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $dO5L3.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $dO5L3.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $9s52i.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $jKTMl.default)('Request aborted', (0, $jKTMl.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $jKTMl.default)('Network Error', (0, $jKTMl.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $gvguD.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $jKTMl.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $jKTMl.default).ETIMEDOUT : (0, $jKTMl.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $6VlRc.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $6VlRc.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $jJzDQ.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $jJzDQ.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $btf5G.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $Kz4aS.default)(_config.url);
        if (protocol && (0, $9FmKe.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $jKTMl.default)('Unsupported protocol ' + protocol + ':', (0, $jKTMl.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("9s52i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6e1aa2a64d7f2f37$export$2e2bcd8739ae039; });

var $jKTMl = parcelRequire("jKTMl");
'use strict';
function $6e1aa2a64d7f2f37$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $jKTMl.default)('Request failed with status code ' + response.status, [
        (0, $jKTMl.default).ERR_BAD_REQUEST,
        (0, $jKTMl.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("Kz4aS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $08bf7f6f6e3caf2a$export$2e2bcd8739ae039; });
'use strict';
function $08bf7f6f6e3caf2a$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("jJzDQ", function(module, exports) {
$parcel$export(module.exports, "progressEventReducer", function () { return $e5ddddf655c83539$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $e5ddddf655c83539$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $e5ddddf655c83539$export$5d35863c355a22a9; });

var $k4vD3 = parcelRequire("k4vD3");

var $9N6bC = parcelRequire("9N6bC");

var $6VlRc = parcelRequire("6VlRc");
const $e5ddddf655c83539$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $k4vD3.default)(50, 250);
    return (0, $9N6bC.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $e5ddddf655c83539$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $e5ddddf655c83539$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $6VlRc.default).asap(()=>fn(...args));

});
parcelRegister("k4vD3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9ccb73691939f3f$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $e9ccb73691939f3f$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $e9ccb73691939f3f$export$2e2bcd8739ae039 = $e9ccb73691939f3f$var$speedometer;

});

parcelRegister("9N6bC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $720d7d213e92016d$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $720d7d213e92016d$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $720d7d213e92016d$export$2e2bcd8739ae039 = $720d7d213e92016d$var$throttle;

});


parcelRegister("fi15f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b219609f113f125b$export$2e2bcd8739ae039; });

var $9FmKe = parcelRequire("9FmKe");

var $6VlRc = parcelRequire("6VlRc");

var $eJR0H = parcelRequire("eJR0H");

var $5Dvoh = parcelRequire("5Dvoh");

var $gZgEM = parcelRequire("gZgEM");

var $b5Jb3 = parcelRequire("b5Jb3");

var $dO5L3 = parcelRequire("dO5L3");

var $5bpGt = parcelRequire("5bpGt");
var $b219609f113f125b$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $b5Jb3.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $dO5L3.default).from(headers);
    newConfig.url = (0, $5bpGt.default)((0, $gZgEM.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $6VlRc.default).isFormData(data)) {
        if ((0, $9FmKe.default).hasStandardBrowserEnv || (0, $9FmKe.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $9FmKe.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $6VlRc.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $eJR0H.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $5Dvoh.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("eJR0H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $abae63696c228974$export$2e2bcd8739ae039; });

var $9FmKe = parcelRequire("9FmKe");
var $abae63696c228974$export$2e2bcd8739ae039 = (0, $9FmKe.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $9FmKe.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $9FmKe.default).origin), (0, $9FmKe.default).navigator && /(msie|trident)/i.test((0, $9FmKe.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("5Dvoh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $41a8f1c81f11557d$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $9FmKe = parcelRequire("9FmKe");
var $41a8f1c81f11557d$export$2e2bcd8739ae039 = (0, $9FmKe.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $6VlRc.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $6VlRc.default).isString(path) && cookie.push('path=' + path);
        (0, $6VlRc.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("gZgEM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c5df438a4653cf77$export$2e2bcd8739ae039; });

var $32E0f = parcelRequire("32E0f");

var $9AyhI = parcelRequire("9AyhI");
'use strict';
function $c5df438a4653cf77$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $32E0f.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $9AyhI.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("32E0f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $237096bfdfadbfda$export$2e2bcd8739ae039; });
'use strict';
function $237096bfdfadbfda$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("9AyhI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6fb21212b1565315$export$2e2bcd8739ae039; });
'use strict';
function $6fb21212b1565315$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("b5Jb3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8133349ac6541666$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");

var $dO5L3 = parcelRequire("dO5L3");
'use strict';
const $8133349ac6541666$var$headersToObject = (thing)=>thing instanceof (0, $dO5L3.default) ? {
        ...thing
    } : thing;
function $8133349ac6541666$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $6VlRc.default).isPlainObject(target) && (0, $6VlRc.default).isPlainObject(source)) return (0, $6VlRc.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $6VlRc.default).isPlainObject(source)) return (0, $6VlRc.default).merge({}, source);
        else if ((0, $6VlRc.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $6VlRc.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $6VlRc.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $6VlRc.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $6VlRc.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $6VlRc.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($8133349ac6541666$var$headersToObject(a), $8133349ac6541666$var$headersToObject(b), prop, true)
    };
    (0, $6VlRc.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $6VlRc.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("1jCGW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f5594217a60c0ab$export$2e2bcd8739ae039; });

var $9FmKe = parcelRequire("9FmKe");

var $6VlRc = parcelRequire("6VlRc");

var $jKTMl = parcelRequire("jKTMl");

var $bfyQD = parcelRequire("bfyQD");

var $kNuvU = parcelRequire("kNuvU");

var $dO5L3 = parcelRequire("dO5L3");

var $jJzDQ = parcelRequire("jJzDQ");

var $fi15f = parcelRequire("fi15f");

var $9s52i = parcelRequire("9s52i");
const $0f5594217a60c0ab$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $0f5594217a60c0ab$var$isReadableStreamSupported = $0f5594217a60c0ab$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $0f5594217a60c0ab$var$encodeText = $0f5594217a60c0ab$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $0f5594217a60c0ab$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $0f5594217a60c0ab$var$supportsRequestStream = $0f5594217a60c0ab$var$isReadableStreamSupported && $0f5594217a60c0ab$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $9FmKe.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $0f5594217a60c0ab$var$DEFAULT_CHUNK_SIZE = 65536;
const $0f5594217a60c0ab$var$supportsResponseStream = $0f5594217a60c0ab$var$isReadableStreamSupported && $0f5594217a60c0ab$var$test(()=>(0, $6VlRc.default).isReadableStream(new Response('').body));
const $0f5594217a60c0ab$var$resolvers = {
    stream: $0f5594217a60c0ab$var$supportsResponseStream && ((res)=>res.body)
};
$0f5594217a60c0ab$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$0f5594217a60c0ab$var$resolvers[type] && ($0f5594217a60c0ab$var$resolvers[type] = (0, $6VlRc.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $jKTMl.default)(`Response type '${type}' is not supported`, (0, $jKTMl.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $0f5594217a60c0ab$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $6VlRc.default).isBlob(body)) return body.size;
    if ((0, $6VlRc.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $9FmKe.default).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $6VlRc.default).isArrayBufferView(body) || (0, $6VlRc.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $6VlRc.default).isURLSearchParams(body)) body = body + '';
    if ((0, $6VlRc.default).isString(body)) return (await $0f5594217a60c0ab$var$encodeText(body)).byteLength;
};
const $0f5594217a60c0ab$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $6VlRc.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $0f5594217a60c0ab$var$getBodyLength(body) : length;
};
var $0f5594217a60c0ab$export$2e2bcd8739ae039 = $0f5594217a60c0ab$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $fi15f.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $bfyQD.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $0f5594217a60c0ab$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $0f5594217a60c0ab$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $6VlRc.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $jJzDQ.progressEventDecorator)(requestContentLength, (0, $jJzDQ.progressEventReducer)((0, $jJzDQ.asyncDecorator)(onUploadProgress)));
                data = (0, $kNuvU.trackStream)(_request.body, $0f5594217a60c0ab$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $6VlRc.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $0f5594217a60c0ab$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($0f5594217a60c0ab$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $6VlRc.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $jJzDQ.progressEventDecorator)(responseContentLength, (0, $jJzDQ.progressEventReducer)((0, $jJzDQ.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $kNuvU.trackStream)(response.body, $0f5594217a60c0ab$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $0f5594217a60c0ab$var$resolvers[(0, $6VlRc.default).findKey($0f5594217a60c0ab$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $9s52i.default)(resolve, reject, {
                data: responseData,
                headers: (0, $dO5L3.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $jKTMl.default)('Network Error', (0, $jKTMl.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $jKTMl.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("bfyQD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $830c207e576e0e77$export$2e2bcd8739ae039; });

var $btf5G = parcelRequire("btf5G");

var $jKTMl = parcelRequire("jKTMl");

var $6VlRc = parcelRequire("6VlRc");
const $830c207e576e0e77$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $jKTMl.default) ? err : new (0, $btf5G.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $jKTMl.default)(`timeout ${timeout} of ms exceeded`, (0, $jKTMl.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $6VlRc.default).asap(unsubscribe);
        return signal;
    }
};
var $830c207e576e0e77$export$2e2bcd8739ae039 = $830c207e576e0e77$var$composeSignals;

});

parcelRegister("kNuvU", function(module, exports) {
$parcel$export(module.exports, "trackStream", function () { return $f2400d9c53ceffb3$export$b0119225647bd83; });
const $f2400d9c53ceffb3$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $f2400d9c53ceffb3$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $f2400d9c53ceffb3$var$readStream(iterable))yield* $f2400d9c53ceffb3$export$71b051935044bd5d(chunk, chunkSize);
};
const $f2400d9c53ceffb3$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $f2400d9c53ceffb3$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $f2400d9c53ceffb3$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("dzxJs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9e18b5c2101e1763$export$2e2bcd8739ae039; });

var $fPqQR = parcelRequire("fPqQR");

var $jKTMl = parcelRequire("jKTMl");
'use strict';
const $9e18b5c2101e1763$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $9e18b5c2101e1763$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $9e18b5c2101e1763$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $9e18b5c2101e1763$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $fPqQR.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $jKTMl.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $jKTMl.default).ERR_DEPRECATED);
        if (version && !$9e18b5c2101e1763$var$deprecatedWarnings[opt]) {
            $9e18b5c2101e1763$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$9e18b5c2101e1763$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $9e18b5c2101e1763$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $jKTMl.default)('options must be an object', (0, $jKTMl.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $jKTMl.default)('option ' + opt + ' must be ' + result, (0, $jKTMl.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $jKTMl.default)('Unknown option ' + opt, (0, $jKTMl.default).ERR_BAD_OPTION);
    }
}
var $9e18b5c2101e1763$export$2e2bcd8739ae039 = {
    assertOptions: $9e18b5c2101e1763$var$assertOptions,
    validators: $9e18b5c2101e1763$var$validators
};

});
parcelRegister("fPqQR", function(module, exports) {
$parcel$export(module.exports, "VERSION", function () { return $b860729e67a1b5e7$export$a4ad2735b021c132; });
const $b860729e67a1b5e7$export$a4ad2735b021c132 = "1.9.0";

});



parcelRegister("4kO57", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $327fe0d681a4cdb1$export$2e2bcd8739ae039; });

var $btf5G = parcelRequire("btf5G");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $327fe0d681a4cdb1$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $btf5G.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $327fe0d681a4cdb1$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $327fe0d681a4cdb1$export$2e2bcd8739ae039 = $327fe0d681a4cdb1$var$CancelToken;

});

parcelRegister("dFt4h", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f35a6ffbad3dc13$export$2e2bcd8739ae039; });
'use strict';
function $9f35a6ffbad3dc13$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("7BvpI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58945b3a64b516bc$export$2e2bcd8739ae039; });

var $6VlRc = parcelRequire("6VlRc");
'use strict';
function $58945b3a64b516bc$export$2e2bcd8739ae039(payload) {
    return (0, $6VlRc.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("hesDl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8b9f4844af534af$export$2e2bcd8739ae039; });
const $c8b9f4844af534af$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($c8b9f4844af534af$var$HttpStatusCode).forEach(([key, value])=>{
    $c8b9f4844af534af$var$HttpStatusCode[value] = key;
});
var $c8b9f4844af534af$export$2e2bcd8739ae039 = $c8b9f4844af534af$var$HttpStatusCode;

});



parcelRegister("bVDCn", function(module, exports) {
$parcel$export(module.exports, "UnsucessfulFetchError", function () { return (parcelRequire("65S3s")).UnsucessfulFetchError; });
$parcel$export(module.exports, "createHeaders", function () { return (parcelRequire("6VW4z")).createHeaders; });
$parcel$export(module.exports, "mapCookieToHeaders", function () { return (parcelRequire("jaDjo")).mapCookieToHeaders; });
$parcel$export(module.exports, "mapResponseToJson", function () { return (parcelRequire("7IOsL")).mapResponseToJson; });
$parcel$export(module.exports, "mapResponseToText", function () { return (parcelRequire("7IOsL")).mapResponseToText; });
$parcel$export(module.exports, "serializeCookie", function () { return (parcelRequire("jaDjo")).serializeCookie; });
parcelRequire("gFUQ6");
parcelRequire("1feC1");
parcelRequire("a1Lgy");

});
parcelRegister("gFUQ6", function(module, exports) {
$parcel$export(module.exports, "UnsucessfulFetchError", function () { return (parcelRequire("65S3s")).UnsucessfulFetchError; });
parcelRequire("65S3s");

});
parcelRegister("65S3s", function(module, exports) {
$parcel$export(module.exports, "UnsucessfulFetchError", function () { return $46fd23da184e21a9$export$cb3dedb538046409; });
class $46fd23da184e21a9$export$cb3dedb538046409 extends Error {
    constructor({ message: message, response: response }){
        super(message !== null && message !== void 0 ? message : response.statusText);
        this.name = $46fd23da184e21a9$export$cb3dedb538046409.name;
        this.response = response;
    }
    get url() {
        return this.response.url;
    }
    get status() {
        return this.response.status;
    }
}
function $46fd23da184e21a9$export$86741fdf20922685(value) {
    return value.name === $46fd23da184e21a9$export$cb3dedb538046409.name;
}

});


parcelRegister("1feC1", function(module, exports) {
parcelRequire("bTiT0");

});
parcelRegister("bTiT0", function(module, exports) {

});


parcelRegister("a1Lgy", function(module, exports) {
$parcel$export(module.exports, "mapCookieToHeaders", function () { return (parcelRequire("jaDjo")).mapCookieToHeaders; });
$parcel$export(module.exports, "serializeCookie", function () { return (parcelRequire("jaDjo")).serializeCookie; });
$parcel$export(module.exports, "createHeaders", function () { return (parcelRequire("6VW4z")).createHeaders; });
$parcel$export(module.exports, "mapResponseToJson", function () { return (parcelRequire("7IOsL")).mapResponseToJson; });
$parcel$export(module.exports, "mapResponseToText", function () { return (parcelRequire("7IOsL")).mapResponseToText; });
parcelRequire("jaDjo");
parcelRequire("6VW4z");
parcelRequire("7IOsL");
parcelRequire("kk3B3");

});
parcelRegister("jaDjo", function(module, exports) {
$parcel$export(module.exports, "serializeCookie", function () { return $df4d7203c5af9238$export$659f3e5265115438; });
$parcel$export(module.exports, "mapCookieToHeaders", function () { return $df4d7203c5af9238$export$2caf3886cd1c5ca7; });

var $YzATR = parcelRequire("YzATR");
function $df4d7203c5af9238$export$659f3e5265115438({ name: name, value: value }) {
    return (0, $YzATR.serialize)(name, value);
}
function $df4d7203c5af9238$export$2caf3886cd1c5ca7(cookie) {
    if (cookie) return {
        cookie: $df4d7203c5af9238$export$659f3e5265115438(cookie)
    };
    else return {};
}

});
parcelRegister("YzATR", function(module, exports) {
$parcel$export(module.exports, "serialize", function () { return $0b6136f878dc340b$export$dfdc1655ccc5b9cb; }, function (v) { return $0b6136f878dc340b$export$dfdc1655ccc5b9cb = v; });
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $0b6136f878dc340b$export$98e6a39c04603d36;
var $0b6136f878dc340b$export$dfdc1655ccc5b9cb;
'use strict';
$0b6136f878dc340b$export$98e6a39c04603d36 = $0b6136f878dc340b$var$parse;
$0b6136f878dc340b$export$dfdc1655ccc5b9cb = $0b6136f878dc340b$var$serialize;
/**
 * Module variables.
 * @private
 */ var $0b6136f878dc340b$var$decode = decodeURIComponent;
var $0b6136f878dc340b$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $0b6136f878dc340b$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $0b6136f878dc340b$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $0b6136f878dc340b$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $0b6136f878dc340b$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $0b6136f878dc340b$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $0b6136f878dc340b$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$0b6136f878dc340b$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$0b6136f878dc340b$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$0b6136f878dc340b$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$0b6136f878dc340b$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $0b6136f878dc340b$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

});


parcelRegister("6VW4z", function(module, exports) {
$parcel$export(module.exports, "createHeaders", function () { return $50c51cf6f70e9bcb$export$197579c449ddabf4; });
parcelRequire("a1y9f");
var $iHFQJ = parcelRequire("iHFQJ");
function $50c51cf6f70e9bcb$export$197579c449ddabf4(headers) {
    return Object.keys(headers).reduce((result, name)=>{
        const value = headers[name];
        if (!(0, $iHFQJ.isUndefined)(value)) return Object.assign(Object.assign({}, result), {
            [name]: value.toString()
        });
        else return result;
    }, {});
}

});
parcelRegister("a1y9f", function(module, exports) {
$parcel$export(module.exports, "isNotUndefined", function () { return (parcelRequire("iHFQJ")).isNotUndefined; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("iHFQJ")).isUndefined; });
parcelRequire("k5bEP");
parcelRequire("1R0hi");
parcelRequire("fFOyD");
parcelRequire("7bZWq");
parcelRequire("1s1qc");
parcelRequire("cjMGr");
parcelRequire("6fLhc");
parcelRequire("iHFQJ");

});
parcelRegister("k5bEP", function(module, exports) {
$parcel$export(module.exports, "isArray", function () { return $e9ed513b614235b3$export$43bee75e5e14138e; });
function $e9ed513b614235b3$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $e9ed513b614235b3$export$3c63dcefc1d74c49(value) {
    if (!$e9ed513b614235b3$export$43bee75e5e14138e(value)) throw new TypeError(`Value is not of type array.`);
}

});

parcelRegister("1R0hi", function(module, exports) {
function $159af4e04c4423bb$export$630801d484da15df(value) {
    return value === null;
}
function $159af4e04c4423bb$export$31947e1aefef4655(value) {
    if ($159af4e04c4423bb$export$7909a8efff3699c9(value)) throw new TypeError(`Value is not null.`);
}
function $159af4e04c4423bb$export$7909a8efff3699c9(value) {
    return value !== null;
}
function $159af4e04c4423bb$export$9c14e1a1fcf1d102(value) {
    if ($159af4e04c4423bb$export$630801d484da15df(value)) throw new TypeError(`Value is null.`);
}

});

parcelRegister("fFOyD", function(module, exports) {
function $b691e70e752bde06$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $b691e70e752bde06$export$98639c528a8f7f90(value) {
    if (!$b691e70e752bde06$export$7e4aa119212bc614(value)) throw new TypeError(`Value is not of type number.`);
}
function $b691e70e752bde06$export$9240adf59a14d18b(value) {
    return value;
}

});

parcelRegister("7bZWq", function(module, exports) {
$parcel$export(module.exports, "isObject", function () { return $53c99bbb5a0f4b36$export$a6cdc56e425d0d0a; });
/* eslint-disable @typescript-eslint/ban-types */ function $53c99bbb5a0f4b36$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === 'object';
}
function $53c99bbb5a0f4b36$export$28450c73da0c0cec(value) {
    if (!$53c99bbb5a0f4b36$export$a6cdc56e425d0d0a(value)) throw new TypeError(`Value is not of type object.`);
}

});

parcelRegister("1s1qc", function(module, exports) {
function $10e9824339162e38$export$6003a5f097c73977(predicate) {
    return (value)=>!predicate(value);
}

});

parcelRegister("cjMGr", function(module, exports) {

var $k5bEP = parcelRequire("k5bEP");

var $7bZWq = parcelRequire("7bZWq");
function $8f7d05e5a5aae606$export$6ba840931da50680(value) {
    return (0, $7bZWq.isObject)(value) && !(0, $k5bEP.isArray)(value);
}
function $8f7d05e5a5aae606$export$3372e6121710b67c(value) {
    if (!$8f7d05e5a5aae606$export$6ba840931da50680(value)) throw TypeError(`Value is not of type Record<string | number | symbol, unknown>`);
}
function $8f7d05e5a5aae606$export$5bf60f6fb0235abd(record) {
    return Object.keys(record);
}

});

parcelRegister("6fLhc", function(module, exports) {
function $48d8d0e69d007f16$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $48d8d0e69d007f16$export$7ff2c3a8f780f104(value) {
    if (!$48d8d0e69d007f16$export$844ec244b1367d54(value)) throw new TypeError(`Value is not of type string.`);
}
function $48d8d0e69d007f16$export$25e58f6be9d2ebe5(value) {
    return value;
}

});

parcelRegister("iHFQJ", function(module, exports) {
$parcel$export(module.exports, "isUndefined", function () { return $d9dcb49b8df15e75$export$fce6876652108ab; });
$parcel$export(module.exports, "isNotUndefined", function () { return $d9dcb49b8df15e75$export$e7321bf46d18757f; });
function $d9dcb49b8df15e75$export$fce6876652108ab(value) {
    return value === undefined;
}
function $d9dcb49b8df15e75$export$53402e64a64c3f87(value) {
    if (!$d9dcb49b8df15e75$export$fce6876652108ab(value)) throw new TypeError(`Value is not undefined.`);
}
function $d9dcb49b8df15e75$export$e7321bf46d18757f(value) {
    return value !== undefined;
}
function $d9dcb49b8df15e75$export$f232a18cc1f66d93(value) {
    if (!$d9dcb49b8df15e75$export$e7321bf46d18757f(value)) throw new TypeError(`Value is undefined.`);
}

});



parcelRegister("7IOsL", function(module, exports) {
$parcel$export(module.exports, "mapResponseToText", function () { return $59f3c95f8e8d5ec0$export$779c89bcd6b62ed; });
$parcel$export(module.exports, "mapResponseToJson", function () { return $59f3c95f8e8d5ec0$export$a1968f52311c9c2e; });
parcelRequire("gFUQ6");
var $65S3s = parcelRequire("65S3s");
var $59f3c95f8e8d5ec0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $59f3c95f8e8d5ec0$export$779c89bcd6b62ed(response) {
    return $59f3c95f8e8d5ec0$var$__awaiter(this, void 0, void 0, function*() {
        if (response.ok) return yield response.text();
        else throw new (0, $65S3s.UnsucessfulFetchError)({
            message: yield $59f3c95f8e8d5ec0$var$mapResponseToMessage(response),
            response: response
        });
    });
}
function $59f3c95f8e8d5ec0$export$a1968f52311c9c2e(response) {
    return $59f3c95f8e8d5ec0$var$__awaiter(this, void 0, void 0, function*() {
        if (response.ok) return yield response.json();
        else throw new (0, $65S3s.UnsucessfulFetchError)({
            message: yield $59f3c95f8e8d5ec0$var$mapResponseToMessage(response),
            response: response
        });
    });
}
function $59f3c95f8e8d5ec0$var$mapResponseToMessage(response) {
    return $59f3c95f8e8d5ec0$var$__awaiter(this, void 0, void 0, function*() {
        const { statusText: statusText } = response;
        const message = yield response.text();
        if (message.length > 0) return `${statusText} ${message}`;
        else return statusText;
    });
}

});

parcelRegister("kk3B3", function(module, exports) {
parcelRequire("a1y9f");
var $iHFQJ = parcelRequire("iHFQJ");
function $ecb8771c787ae9ba$export$7138c24907de3954({ baseUrl: baseUrl = '', path: path = '', query: query } = {}) {
    const queryString = $ecb8771c787ae9ba$var$mapQueryToQueryString(query);
    if (queryString) return `${baseUrl}${path}?${queryString}`;
    else return `${baseUrl}${path}`;
}
function $ecb8771c787ae9ba$var$mapQueryToQueryString(query = {}) {
    const queryString = Object.keys(query).reduce((pairs, name)=>{
        const value = query[name];
        if ((0, $iHFQJ.isUndefined)(value)) return pairs;
        else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return [
            ...pairs,
            `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
        ];
        else return [
            ...pairs,
            value.map((item)=>$ecb8771c787ae9ba$var$mapQueryToQueryString({
                    [name]: item
                })).join('&')
        ];
    }, []).join('&');
    if (queryString.length > 0) return queryString;
    else return null;
}

});



parcelRegister("2fcu1", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        var global1 = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || typeof global1 !== 'undefined' && global1;
        var support = {
            searchParams: 'URLSearchParams' in global1,
            iterable: 'Symbol' in global1 && 'iterator' in Symbol,
            blob: 'FileReader' in global1 && 'Blob' in global1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in global1,
            arrayBuffer: 'ArrayBuffer' in global1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) {
                        var isConsumed = consumed(this);
                        if (isConsumed) return isConsumed;
                        if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                        else return Promise.resolve(this._bodyArrayBuffer);
                    } else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = global1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && global1.location.href ? global1.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer && request.headers.get('Content-Type') && request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                });
                else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!global1.fetch) {
            global1.fetch = fetch;
            global1.Headers = Headers;
            global1.Request = Request;
            global1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("eO0KE", function(module, exports) {
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("7gFRR", function(module, exports) {
$parcel$export(module.exports, "mapMeResponseToUserProfile", function () { return $54aa811438a563bf$export$76c6404ebb3f2fbe; });
$parcel$export(module.exports, "Editions", function () { return $54aa811438a563bf$export$696c71818ae3f184; });
$parcel$export(module.exports, "ProductKeys", function () { return $54aa811438a563bf$export$ef2c0ffddaaaf76c; });
var $54aa811438a563bf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $54aa811438a563bf$export$5699ee30bc277ff0;
(function(AuthenticationMethodsType) {
    AuthenticationMethodsType["PASSWORD"] = "password";
    AuthenticationMethodsType["GOOGLE"] = "google";
    AuthenticationMethodsType["SAML"] = "saml";
    AuthenticationMethodsType["MICROSOFT"] = "microsoft";
    AuthenticationMethodsType["APPLE"] = "apple";
    AuthenticationMethodsType["SLACK"] = "slack";
})($54aa811438a563bf$export$5699ee30bc277ff0 || ($54aa811438a563bf$export$5699ee30bc277ff0 = {}));
var $54aa811438a563bf$export$13699c771a86789f;
(function(GetUserPermissionsIsPermittedRequestPermissionId) {
    GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCTS"] = "add-products";
    GetUserPermissionsIsPermittedRequestPermissionId["INVITE_USERS"] = "invite-users";
    GetUserPermissionsIsPermittedRequestPermissionId["MANAGE"] = "manage";
    GetUserPermissionsIsPermittedRequestPermissionId["WRITE"] = "write";
    /**
     * @deprecated ADD_PRODUCT is a legacy permissionId, use ADD_PRODUCTS instead.
     */ GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCT"] = "addProduct";
})($54aa811438a563bf$export$13699c771a86789f || ($54aa811438a563bf$export$13699c771a86789f = {}));
function $54aa811438a563bf$export$bdffa12efde3d762(auth) {
    return !!auth.asap;
}
function $54aa811438a563bf$export$76c6404ebb3f2fbe(_a) {
    var { account_id: account_id } = _a, others = $54aa811438a563bf$var$__rest(_a, [
        "account_id"
    ]);
    return Object.assign({
        accountId: account_id
    }, others);
}
var $54aa811438a563bf$export$696c71818ae3f184;
(function(Editions) {
    Editions["FREE"] = "free";
    Editions["STANDARD"] = "standard";
    Editions["PREMIUM"] = "premium";
})($54aa811438a563bf$export$696c71818ae3f184 || ($54aa811438a563bf$export$696c71818ae3f184 = {}));
var $54aa811438a563bf$export$ef2c0ffddaaaf76c;
(function(ProductKeys) {
    ProductKeys["CONFLUENCE"] = "confluence.ondemand";
    ProductKeys["JIRA_CORE"] = "jira-core.ondemand";
    ProductKeys["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKeys["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKeys["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    ProductKeys["TRELLO"] = "trello";
    ProductKeys["OPSGENIE"] = "opsgenie";
    ProductKeys["BITBUCKET"] = "bitbucket.ondemand";
    ProductKeys["BITBUCKET_COFS"] = "com.atlassian.bitbucket";
    ProductKeys["STATUSPAGE"] = "statuspage";
    ProductKeys["TEAM_CENTRAL"] = "townsquare";
    ProductKeys["AVOCADO"] = "avocado";
    ProductKeys["COMPASS"] = "compass";
    ProductKeys["ANALYTICS"] = "atlassian-analytics-free";
    ProductKeys["WHITEBOARD"] = "atlassian-whiteboard";
    ProductKeys["GUARD"] = "guard";
    ProductKeys["ROVO"] = "rovo";
})($54aa811438a563bf$export$ef2c0ffddaaaf76c || ($54aa811438a563bf$export$ef2c0ffddaaaf76c = {}));

});

parcelRegister("oJ9ed", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_KEY_MAP", function () { return $04a5436d59adc392$export$49ebef81048c4e68; });
$parcel$export(module.exports, "IDENTITY_RECAPTCHA_KEY", function () { return $04a5436d59adc392$export$ba007ad7a8d56c3d; });
$parcel$export(module.exports, "IDENTITY_RECAPTCHA_KEY_TEST", function () { return $04a5436d59adc392$export$901430629348d0a1; });
const $04a5436d59adc392$export$92fa52c125cc0e5 = 'identity-platform';
const $04a5436d59adc392$export$49ebef81048c4e68 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_BUSINESS: 'jira-core.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    BITBUCKET: 'com.atlassian.bitbucket',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    TRELLO: 'trello'
};
const $04a5436d59adc392$export$ba007ad7a8d56c3d = '6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD';
const $04a5436d59adc392$export$901430629348d0a1 = '6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN';

});

parcelRegister("5Te4K", function(module, exports) {
$parcel$export(module.exports, "getAtlCohortIdFromCookie", function () { return (parcelRequire("LDEj3")).getAtlCohortIdFromCookie; });
$parcel$export(module.exports, "isValidSite", function () { return (parcelRequire("4gpJS")).isValidSite; });
$parcel$export(module.exports, "getReCaptchaKey", function () { return (parcelRequire("iw2YK")).getReCaptchaKey; });
parcelRequire("LDEj3");
parcelRequire("4gpJS");
parcelRequire("b7Oal");
parcelRequire("iw2YK");

});
parcelRegister("LDEj3", function(module, exports) {
$parcel$export(module.exports, "getAtlCohortIdFromCookie", function () { return $08f3256318839c4a$export$a284fd3cd35fac52; });

var $eO0KE = parcelRequire("eO0KE");
function $08f3256318839c4a$export$a284fd3cd35fac52() {
    let atlCohortId;
    try {
        const cookie = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($eO0KE))).get('atlCohort') || '');
        atlCohortId = cookie['bucketAll'].index;
    } catch (e) {
        atlCohortId = '';
        console.warn('Cannot parse atlCohort cookie', e);
    }
    return atlCohortId;
}

});

parcelRegister("4gpJS", function(module, exports) {
$parcel$export(module.exports, "isValidSite", function () { return $31ac9f4572df17fc$export$c7346ed3533fb878; });
const $31ac9f4572df17fc$export$c7346ed3533fb878 = ({ site: site, includeInvalidBitbucketSite: includeInvalidBitbucketSite })=>{
    const ignoreSiteNames = [
        'servicedog',
        'ecosystem',
        'atlassiantraining',
        'Atlassian Stride',
        'volunteerhub',
        'atlassiantraining',
        'hello-staging',
        'ecosystem',
        'riskmanagement',
        'hello-staging3',
        'hello-staging6',
        'hello-staging9',
        'jdog',
        'sre-ehlo',
        'trello',
        'Trello'
    ];
    if (!includeInvalidBitbucketSite) ignoreSiteNames.push('bitbucket', 'Bitbucket');
    if (ignoreSiteNames.includes(site.displayName)) return false;
    if (site.cloudId.startsWith('DUMMY')) return false;
    return true;
};

});

parcelRegister("b7Oal", function(module, exports) {

});

parcelRegister("iw2YK", function(module, exports) {
$parcel$export(module.exports, "getReCaptchaKey", function () { return $d7ad86ac666e0403$export$4682c216c5c4d5d7; });

var $oJ9ed = parcelRequire("oJ9ed");
const $d7ad86ac666e0403$export$4682c216c5c4d5d7 = ()=>{
    return $d7ad86ac666e0403$var$isProduction() ? (0, $oJ9ed.IDENTITY_RECAPTCHA_KEY) : (0, $oJ9ed.IDENTITY_RECAPTCHA_KEY_TEST);
};
const $d7ad86ac666e0403$var$isProduction = ()=>{
    const urlParts = window.location.hostname.split('.');
    if (urlParts[1] === 'dev') return false;
    switch(urlParts[0]){
        case 'wac':
        case 'qa-wac':
        case 'author':
        case 'proof':
        case 'localhost':
        case 'local':
            return false;
        case 'truth':
        case 'www':
        case 'atlassian':
        case 'bitbucket':
        case 'sourcetreeapp':
        case 'agile':
        case 'git':
        case 'software':
            return true;
        default:
            /* for omlet instances */ return false;
    }
};

});



parcelRegister("yTps3", function(module, exports) {
parcelRequire("ihrla");
parcelRequire("jLSpO");

});
parcelRegister("ihrla", function(module, exports) {

});

parcelRegister("jLSpO", function(module, exports) {

});



parcelRegister("1rObi", function(module, exports) {
$parcel$export(module.exports, "CrossFlowTouchpointProvider", function () { return $46c9d67ef4db7b49$export$e2f4f4c41dccbd79; });
$parcel$export(module.exports, "useCrossFlowTouchpointContext", function () { return $46c9d67ef4db7b49$export$411afe878b9f0326; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("6xsdo");
var $2Hvh6 = parcelRequire("2Hvh6");

var $3riD8 = parcelRequire("3riD8");

var $b31tm = parcelRequire("b31tm");
const $46c9d67ef4db7b49$export$1b5d8f0c33515521 = {
    isCrossFlowEnabled: false,
    productKeys: []
};
const $46c9d67ef4db7b49$export$a4b3fa3db11b6b5d = /*#__PURE__*/ (0, $1oC0p.createContext)($46c9d67ef4db7b49$export$1b5d8f0c33515521);
const $46c9d67ef4db7b49$export$78e295e9b9464346 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($46c9d67ef4db7b49$export$a4b3fa3db11b6b5d.Provider, {
        value: $46c9d67ef4db7b49$export$1b5d8f0c33515521,
        children: children
    });
};
const $46c9d67ef4db7b49$export$c2fcf9e694782042 = ({ children: children, productKeys: productKeys, screenName: screenName, viewedOnMount: viewedOnMount = true })=>{
    const { fireCrossFlowScreenEvent: fireCrossFlowScreenEvent, fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)({
        productCohorts: (0, $b31tm.getProductCohorts)(productKeys),
        screenName: screenName
    });
    const onViewTouchpoint = (0, $1oC0p.useCallback)(()=>{
        if (screenName) {
            fireCrossFlowScreenEvent(screenName, {
                recommendedProductIds: productKeys
            });
            return;
        }
        fireUIEvent({
            action: 'viewed',
            actionSubject: (0, $b31tm.WAC_GENERIC_TOUCHPOINT_NAME)
        });
    }, [
        screenName,
        fireUIEvent,
        fireCrossFlowScreenEvent,
        productKeys
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (viewedOnMount) onViewTouchpoint();
    }, [
        onViewTouchpoint,
        viewedOnMount
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($46c9d67ef4db7b49$export$a4b3fa3db11b6b5d.Provider, {
        value: {
            isCrossFlowEnabled: true,
            productKeys: productKeys,
            screenName: screenName,
            onViewTouchpoint: onViewTouchpoint
        },
        children: children
    });
};
const $46c9d67ef4db7b49$export$e2f4f4c41dccbd79 = ({ children: children, productKeys: productKeys, screenName: screenName, viewedOnMount: viewedOnMount = true })=>{
    const { isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const crossFlow = (0, $2Hvh6.useCrossFlow)();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $b31tm.useFireEvent)({
        isUserLoggedIn: isUserLoggedIn,
        isCrossFlowEnabled: crossFlow?.isEnabled
    });
    if (!isUserLoggedIn || !crossFlow?.isEnabled) {
        fireOperationalEvent({
            action: 'disabled',
            actionSubject: 'crossFlowFrontend',
            eventType: 'operational'
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)($46c9d67ef4db7b49$export$78e295e9b9464346, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)($46c9d67ef4db7b49$export$c2fcf9e694782042, {
        productKeys: productKeys,
        screenName: screenName,
        viewedOnMount: viewedOnMount,
        children: children
    });
};
const $46c9d67ef4db7b49$export$411afe878b9f0326 = ()=>(0, $1oC0p.useContext)($46c9d67ef4db7b49$export$a4b3fa3db11b6b5d);

});
parcelRegister("b31tm", function(module, exports) {
$parcel$export(module.exports, "getRolloutFlagValue", function () { return $56cddecc5597111f$export$697caa2c041f95d9; });
$parcel$export(module.exports, "getProductCohorts", function () { return $56cddecc5597111f$export$79c54cec4f0a656b; });
$parcel$export(module.exports, "useFireEvent", function () { return $56cddecc5597111f$export$5e1559072ecb0787; });
$parcel$export(module.exports, "WAC_GENERIC_TOUCHPOINT_NAME", function () { return $56cddecc5597111f$export$d64a4fd19c447036; });
$parcel$export(module.exports, "WAC_GENERIC_TOUCHPOINT_COMPONENT_NAME", function () { return $56cddecc5597111f$export$b772174460988b88; });
$parcel$export(module.exports, "redirectToDefaultUrl", function () { return $56cddecc5597111f$export$15376d3104f6357b; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $3L8ZR = parcelRequire("3L8ZR");

var $5XmQI = parcelRequire("5XmQI");
parcelRequire("20OkY");
var $7gFRR = parcelRequire("7gFRR");

var $iSeHD = parcelRequire("iSeHD");
const $56cddecc5597111f$export$9d0aa203dcbcf3a9 = {};
const $56cddecc5597111f$var$productRolloutKeys = [
    // ProductKeys.JIRA_SOFTWARE,
    (0, $7gFRR.ProductKeys).JIRA_SERVICE_DESK
];
const $56cddecc5597111f$export$697caa2c041f95d9 = (productKey, fireExperimentExposure)=>{
    if (!productKey) return 'not-enrolled';
    if ($56cddecc5597111f$var$productRolloutKeys.includes(productKey)) return 'variation';
    const experimentKey = $56cddecc5597111f$export$9d0aa203dcbcf3a9[productKey];
    if (!experimentKey) return 'not-enrolled';
    return (0, $3L8ZR.default).getExperimentValue(experimentKey, 'cohort', 'not-enrolled', {
        fireExperimentExposure: fireExperimentExposure
    });
};
const $56cddecc5597111f$export$79c54cec4f0a656b = (productKeys)=>{
    const productCohorts = {};
    productKeys.forEach((productKey)=>{
        productCohorts[productKey] = $56cddecc5597111f$export$697caa2c041f95d9(productKey);
    });
    return productCohorts;
};
const $56cddecc5597111f$export$5e1559072ecb0787 = (initialAttributes = {})=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const crossFlowEvents = (0, $5XmQI.useFireCrossFlowAnalyticsEvents)();
    const fireEvent = (0, $1oC0p.useCallback)((eventPayload, attributes = {})=>{
        analyticsClient && createAnalyticsEvent({
            ...eventPayload,
            attributes: {
                ...eventPayload['attributes'] || {},
                ...attributes,
                ...initialAttributes
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent,
        initialAttributes
    ]);
    const fireUIEvent = (0, $1oC0p.useCallback)((eventPayload, attributes = {})=>{
        fireEvent({
            ...eventPayload,
            attributes: {
                ...attributes,
                ...eventPayload['attributes']
            },
            eventType: 'ui'
        });
    }, [
        fireEvent
    ]);
    const fireTrackEvent = (0, $1oC0p.useCallback)((eventPayload, attributes = {})=>{
        fireEvent({
            ...eventPayload,
            attributes: {
                ...attributes,
                ...eventPayload['attributes']
            },
            eventType: 'track'
        });
    }, [
        fireEvent
    ]);
    const fireScreenEvent = (0, $1oC0p.useCallback)((eventPayload, attributes = {})=>{
        fireEvent({
            ...eventPayload,
            attributes: {
                ...attributes,
                ...eventPayload['attributes']
            },
            eventType: 'screen'
        });
    }, [
        fireEvent
    ]);
    const fireOperationalEvent = (0, $1oC0p.useCallback)((eventPayload, attributes = {})=>{
        fireEvent({
            ...eventPayload,
            attributes: {
                ...attributes,
                ...eventPayload['attributes']
            },
            eventType: 'operational'
        });
    }, [
        fireEvent
    ]);
    const fireCrossFlowScreenEvent = (0, $1oC0p.useCallback)((screenName, commonAttributes, attributes = {})=>{
        if (!analyticsClient) return;
        crossFlowEvents.fireViewedScreenEvent(screenName, commonAttributes, {
            ...initialAttributes,
            ...attributes
        });
    }, [
        analyticsClient,
        crossFlowEvents,
        initialAttributes
    ]);
    const fireCrossFlowViewedUIEvent = (0, $1oC0p.useCallback)((eventPayload, commonAttributes, attributes = {})=>{
        if (!analyticsClient) return;
        crossFlowEvents.fireViewedUIEvent(eventPayload, commonAttributes, {
            ...initialAttributes,
            ...attributes
        });
    }, [
        analyticsClient,
        crossFlowEvents,
        initialAttributes
    ]);
    const fireCrossFlowInteractedUIEvent = (0, $1oC0p.useCallback)((eventPayload, commonAttributes, attributes = {})=>{
        if (!analyticsClient) return;
        crossFlowEvents.fireInteractedUIEvent(eventPayload, commonAttributes, {
            ...initialAttributes,
            ...attributes
        });
    }, [
        analyticsClient,
        crossFlowEvents,
        initialAttributes
    ]);
    return {
        fireUIEvent: fireUIEvent,
        fireTrackEvent: fireTrackEvent,
        fireScreenEvent: fireScreenEvent,
        fireOperationalEvent: fireOperationalEvent,
        fireCrossFlowScreenEvent: fireCrossFlowScreenEvent,
        fireCrossFlowViewedUIEvent: fireCrossFlowViewedUIEvent,
        fireCrossFlowInteractedUIEvent: fireCrossFlowInteractedUIEvent
    };
};
const $56cddecc5597111f$export$d64a4fd19c447036 = 'wacGenericCrossFlowTouchpoint';
const $56cddecc5597111f$export$b772174460988b88 = 'wacGenericCrossFlowComponent';
const $56cddecc5597111f$export$15376d3104f6357b = (redirectUrl, onSuccess, onError)=>{
    if (typeof redirectUrl !== 'string' || redirectUrl === '') {
        onError(`Fallback href ${redirectUrl} is not a string or empty`);
        return;
    }
    try {
        const url = new URL(redirectUrl, window.location.origin);
        onSuccess();
        window.location.assign(url);
    } catch (error) {
        onError(error instanceof Error ? error.message : `Invalid URL: ${redirectUrl}`);
    }
};

});
parcelRegister("5XmQI", function(module, exports) {
$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", function () { return $45642fd19e3c473e$export$c2095165ae2bdcda; });

var $ipzFw = parcelRequire("ipzFw");

var $34TUP = parcelRequire("34TUP");

var $1oC0p = parcelRequire("1oC0p");

var $5GhNf = parcelRequire("5GhNf");

var $2cJEf = parcelRequire("2cJEf");

var $dAI8e = parcelRequire("dAI8e");
var $45642fd19e3c473e$var$_excluded = [
    "recommendedProductIds"
], $45642fd19e3c473e$var$_excluded2 = [
    "source",
    "recommendedProductIds"
], $45642fd19e3c473e$var$_excluded3 = [
    "source",
    "recommendedProductIds",
    "targetProductId"
];
function $45642fd19e3c473e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45642fd19e3c473e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45642fd19e3c473e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ipzFw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45642fd19e3c473e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $45642fd19e3c473e$export$c2095165ae2bdcda() {
    var _useAnalyticsEvents = (0, $5GhNf.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var firedViewedScreenEventName = (0, $1oC0p.useRef)();
    var firedViewedUIEventId = (0, $1oC0p.useRef)();
    var mapToCcpProductKeys = (0, $1oC0p.useCallback)(function(recommendedProductIds, targetProductId) {
        var ccpProductIds = recommendedProductIds.reduce(function(acc, curr) {
            var _SURFACE_ANALYTICS_PR;
            acc.push((_SURFACE_ANALYTICS_PR = (0, $2cJEf.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr]) !== null && _SURFACE_ANALYTICS_PR !== void 0 ? _SURFACE_ANALYTICS_PR : curr);
            return acc;
        }, []);
        var ccpTargetProductId = targetProductId && (0, $2cJEf.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId !== null && ccpTargetProductId !== void 0 ? ccpTargetProductId : targetProductId
        };
    }, []);
    var fireViewedScreenEvent = (0, $1oC0p.useCallback)(function(name, commonAttributes, attributes) {
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        var recommendedProductIds = commonAttributes.recommendedProductIds, rest = (0, $34TUP.default)(commonAttributes, $45642fd19e3c473e$var$_excluded);
        var _mapToCcpProductKeys = mapToCcpProductKeys(recommendedProductIds), ccpProductIds = _mapToCcpProductKeys.recommendedProductIds;
        createAnalyticsEvent({
            eventType: (0, $dAI8e.eventTypes).SCREEN,
            name: name,
            attributes: $45642fd19e3c473e$var$_objectSpread($45642fd19e3c473e$var$_objectSpread({
                recommendedProductIds: ccpProductIds
            }, rest), attributes)
        }).fire((0, $dAI8e.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    var fireViewedUIEvent = (0, $1oC0p.useCallback)(function(event, commonAttributes, attributes) {
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        var source = commonAttributes.source, recommendedProductIds = commonAttributes.recommendedProductIds, rest = (0, $34TUP.default)(commonAttributes, $45642fd19e3c473e$var$_excluded2);
        var _mapToCcpProductKeys2 = mapToCcpProductKeys(recommendedProductIds), ccpProductIds = _mapToCcpProductKeys2.recommendedProductIds;
        createAnalyticsEvent($45642fd19e3c473e$var$_objectSpread($45642fd19e3c473e$var$_objectSpread({
            eventType: (0, $dAI8e.eventTypes).UI
        }, event), {}, {
            source: source,
            attributes: $45642fd19e3c473e$var$_objectSpread($45642fd19e3c473e$var$_objectSpread({
                recommendedProductIds: ccpProductIds
            }, rest), attributes)
        })).fire((0, $dAI8e.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    var fireInteractedUIEvent = (0, $1oC0p.useCallback)(function(event, commonAttributes, attributes) {
        var source = commonAttributes.source, recommendedProductIds = commonAttributes.recommendedProductIds, targetProductId = commonAttributes.targetProductId, rest = (0, $34TUP.default)(commonAttributes, $45642fd19e3c473e$var$_excluded3);
        var _mapToCcpProductKeys3 = mapToCcpProductKeys(recommendedProductIds !== null && recommendedProductIds !== void 0 ? recommendedProductIds : [], targetProductId), ccpProductIds = _mapToCcpProductKeys3.recommendedProductIds, ccpTargetProductId = _mapToCcpProductKeys3.targetProductId;
        createAnalyticsEvent($45642fd19e3c473e$var$_objectSpread($45642fd19e3c473e$var$_objectSpread({
            eventType: (0, $dAI8e.eventTypes).UI
        }, event), {}, {
            source: source,
            attributes: $45642fd19e3c473e$var$_objectSpread($45642fd19e3c473e$var$_objectSpread({
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId
            }, rest), attributes)
        })).fire((0, $dAI8e.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("ipzFw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d6763adc41badeef$export$2e2bcd8739ae039; });

var $inUF3 = parcelRequire("inUF3");
function $d6763adc41badeef$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $inUF3.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("inUF3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d62653ae686abd79$export$2e2bcd8739ae039; });

var $4fjDj = parcelRequire("4fjDj");

var $2qCtP = parcelRequire("2qCtP");
function $d62653ae686abd79$export$2e2bcd8739ae039(t) {
    var i = (0, $2qCtP.default)(t, "string");
    return "symbol" == (0, $4fjDj.default)(i) ? i : i + "";
}

});
parcelRegister("4fjDj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3177cadec7c2c16e$export$2e2bcd8739ae039; });
function $3177cadec7c2c16e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3177cadec7c2c16e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3177cadec7c2c16e$export$2e2bcd8739ae039(o);
}

});

parcelRegister("2qCtP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1c4bdbcefdcadf5e$export$2e2bcd8739ae039; });

var $4fjDj = parcelRequire("4fjDj");
function $1c4bdbcefdcadf5e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4fjDj.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4fjDj.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("34TUP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23dd1e7b50afae09$export$2e2bcd8739ae039; });

var $lMp7Z = parcelRequire("lMp7Z");
function $23dd1e7b50afae09$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $lMp7Z.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("lMp7Z", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fdb192869eb2a489$export$2e2bcd8739ae039; });
function $fdb192869eb2a489$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("5GhNf", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $422ead5f788f7025$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $537gQ = parcelRequire("537gQ");

var $8FWF0 = parcelRequire("8FWF0");
function $422ead5f788f7025$export$5bf35293e545f20c() {
    var analyticsContext = (0, $8FWF0.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $537gQ.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("537gQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ad2df5a9fd572ed$export$2e2bcd8739ae039; });

var $gsNte = parcelRequire("gsNte");

var $9KUGa = parcelRequire("9KUGa");

var $17tmy = parcelRequire("17tmy");

var $eO0VE = parcelRequire("eO0VE");

var $kzmGb = parcelRequire("kzmGb");

var $gorm5 = parcelRequire("gorm5");

var $gZm2W = parcelRequire("gZm2W");

var $ipzFw = parcelRequire("ipzFw");

var $b4bRf = parcelRequire("b4bRf");
function $3ad2df5a9fd572ed$var$_callSuper(t, o, e) {
    return o = (0, $kzmGb.default)(o), (0, $eO0VE.default)(t, $3ad2df5a9fd572ed$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $kzmGb.default)(t).constructor) : o.apply(t, e));
}
function $3ad2df5a9fd572ed$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3ad2df5a9fd572ed$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3ad2df5a9fd572ed$var$_superPropGet(t, o, e, r) {
    var p = (0, $gorm5.default)((0, $kzmGb.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $3ad2df5a9fd572ed$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $3ad2df5a9fd572ed$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $3ad2df5a9fd572ed$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $9KUGa.default)(this, UIAnalyticsEvent);
        _this = $3ad2df5a9fd572ed$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $ipzFw.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $ipzFw.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $gsNte.default)(_this.context);
            var handlers = (0, $gsNte.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $ipzFw.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $gZm2W.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $17tmy.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $3ad2df5a9fd572ed$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $b4bRf.default));

});
parcelRegister("gsNte", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bfc5a2ae70ca4678$export$2e2bcd8739ae039; });

var $cK5TZ = parcelRequire("cK5TZ");

var $68Ktu = parcelRequire("68Ktu");

var $iURd0 = parcelRequire("iURd0");

var $al7Pm = parcelRequire("al7Pm");
function $bfc5a2ae70ca4678$export$2e2bcd8739ae039(r) {
    return (0, $cK5TZ.default)(r) || (0, $68Ktu.default)(r) || (0, $iURd0.default)(r) || (0, $al7Pm.default)();
}

});
parcelRegister("cK5TZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $946e5bf16878e5f1$export$2e2bcd8739ae039; });

var $dmIpy = parcelRequire("dmIpy");
function $946e5bf16878e5f1$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dmIpy.default)(r);
}

});
parcelRegister("dmIpy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9bafc794a17bcc95$export$2e2bcd8739ae039; });
function $9bafc794a17bcc95$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("68Ktu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $47878a54b4dfdcb8$export$2e2bcd8739ae039; });
function $47878a54b4dfdcb8$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("iURd0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dc56bb19a76be448$export$2e2bcd8739ae039; });

var $dmIpy = parcelRequire("dmIpy");
function $dc56bb19a76be448$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dmIpy.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dmIpy.default)(r, a) : void 0;
    }
}

});

parcelRegister("al7Pm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7871efe6346513ad$export$2e2bcd8739ae039; });
function $7871efe6346513ad$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9KUGa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $71a4603dc57f48ab$export$2e2bcd8739ae039; });
function $71a4603dc57f48ab$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("17tmy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0d0d38b8b1a74b75$export$2e2bcd8739ae039; });

var $inUF3 = parcelRequire("inUF3");
function $0d0d38b8b1a74b75$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $inUF3.default)(o.key), o);
    }
}
function $0d0d38b8b1a74b75$export$2e2bcd8739ae039(e, r, t) {
    return r && $0d0d38b8b1a74b75$var$_defineProperties(e.prototype, r), t && $0d0d38b8b1a74b75$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eO0VE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ac7674a1049baf98$export$2e2bcd8739ae039; });

var $4fjDj = parcelRequire("4fjDj");

var $jEbMs = parcelRequire("jEbMs");
function $ac7674a1049baf98$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $4fjDj.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $jEbMs.default)(t);
}

});
parcelRegister("jEbMs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e4dae41e0ae5adaf$export$2e2bcd8739ae039; });
function $e4dae41e0ae5adaf$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("kzmGb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef98ab2c1d0b428c$export$2e2bcd8739ae039; });
function $ef98ab2c1d0b428c$export$2e2bcd8739ae039(t) {
    return $ef98ab2c1d0b428c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ef98ab2c1d0b428c$export$2e2bcd8739ae039(t);
}

});

parcelRegister("gorm5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bef41b7009f0a9cd$export$2e2bcd8739ae039; });

var $fHcHL = parcelRequire("fHcHL");
function $bef41b7009f0a9cd$export$2e2bcd8739ae039() {
    return $bef41b7009f0a9cd$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $fHcHL.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $bef41b7009f0a9cd$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("fHcHL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b6d4ba14502afe26$export$2e2bcd8739ae039; });

var $kzmGb = parcelRequire("kzmGb");
function $b6d4ba14502afe26$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $kzmGb.default)(t)););
    return t;
}

});


parcelRegister("gZm2W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c5e371ce60c2e707$export$2e2bcd8739ae039; });

var $jnkiA = parcelRequire("jnkiA");
function $c5e371ce60c2e707$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $jnkiA.default)(t, e);
}

});
parcelRegister("jnkiA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1afe932f32e7aed$export$2e2bcd8739ae039; });
function $e1afe932f32e7aed$export$2e2bcd8739ae039(t, e) {
    return $e1afe932f32e7aed$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e1afe932f32e7aed$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("b4bRf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80e94422719b5897$export$2e2bcd8739ae039; });

var $4fjDj = parcelRequire("4fjDj");

var $9KUGa = parcelRequire("9KUGa");

var $17tmy = parcelRequire("17tmy");

var $ipzFw = parcelRequire("ipzFw");
function $80e94422719b5897$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $80e94422719b5897$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $80e94422719b5897$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ipzFw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $80e94422719b5897$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $80e94422719b5897$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $80e94422719b5897$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $80e94422719b5897$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $9KUGa.default)(this, AnalyticsEvent);
        (0, $ipzFw.default)(this, "_isAnalyticsEvent", true);
        (0, $ipzFw.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $80e94422719b5897$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $17tmy.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $4fjDj.default)(updater) === 'object') this.payload = $80e94422719b5897$var$_objectSpread($80e94422719b5897$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("8FWF0", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $650fa7c6a189b0ad$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $650fa7c6a189b0ad$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("2cJEf", function(module, exports) {
$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", function () { return $19b01c8d1a282652$export$54e3fc09a2a3347a; });
/**
 * Product names, convention of CCP product names
 */ var $19b01c8d1a282652$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
var $19b01c8d1a282652$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
var $19b01c8d1a282652$export$6c053e1694ef181c = {
    prod: $19b01c8d1a282652$export$31048cb2a0753b12,
    staging: $19b01c8d1a282652$export$9d8f18312db80469
};
var $19b01c8d1a282652$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905'
    }
};

});

parcelRegister("dAI8e", function(module, exports) {
$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", function () { return $9e50decc6551cee0$export$c536a7e29a0739b8; });
$parcel$export(module.exports, "eventTypes", function () { return $9e50decc6551cee0$export$285f3d0989f9023f; });
var $9e50decc6551cee0$export$c536a7e29a0739b8 = 'crossFlow';
var $9e50decc6551cee0$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});

});




parcelRegister("iHYHa", function(module, exports) {
$parcel$export(module.exports, "useSiteSelectorContext", function () { return $44d3dbc91672ca3c$export$dbbe4555f7289739; });
$parcel$export(module.exports, "SiteSelectorContextProvider", function () { return $44d3dbc91672ca3c$export$a22f7f4f54f972b1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
parcelRequire("20OkY");
var $7gFRR = parcelRequire("7gFRR");

var $iSeHD = parcelRequire("iSeHD");

var $E9So2 = parcelRequire("E9So2");

var $lact3 = parcelRequire("lact3");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $3riD8 = parcelRequire("3riD8");

var $bv77X = parcelRequire("bv77X");

var $UNB5T = parcelRequire("UNB5T");

var $7BlSS = parcelRequire("7BlSS");
const $44d3dbc91672ca3c$export$c8b55b9bec89387e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext(null);
const $44d3dbc91672ca3c$export$dbbe4555f7289739 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useContext($44d3dbc91672ca3c$export$c8b55b9bec89387e);
    if (!context) throw new Error('useSiteSelectorContext must be used within a SiteSelectorContextProvider');
    return context;
};
const $44d3dbc91672ca3c$export$a22f7f4f54f972b1 = ({ productKey: productKey, children: children, internalLinkAfterIdentity: internalLinkAfterIdentity, redirectToIdentity: redirectToIdentity = false, selectedTemplateLabel: selectedTemplateLabel, analyticsPrefix: analyticsPrefix, referer: referer = 'wacdirect' })=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const selectedTemplate = (0, $1oC0p.useRef)(null);
    const userProfile = (0, $3riD8.useLoggedInUser)();
    const { sites: aisSites } = (0, $bv77X.useSitesContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedSignupHref = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup');
    const siteUrls = (0, $1oC0p.useMemo)(()=>aisSites?.filter((site)=>site.products.includes(productKey)).map((site)=>site.url) ?? [], [
        aisSites,
        productKey
    ]);
    const isJiraProduct = (productKey)=>{
        return [
            (0, $7gFRR.ProductKeys).JIRA_CORE,
            (0, $7gFRR.ProductKeys).JIRA_SERVICE_DESK,
            (0, $7gFRR.ProductKeys).JIRA_SOFTWARE,
            (0, $7gFRR.ProductKeys).JIRA_PRODUCT_DISCOVERY
        ].includes(productKey);
    };
    const getEventName = (eventName)=>{
        return `${analyticsPrefix}.${eventName}`;
    };
    const getCloudSignupUrl = (0, $1oC0p.useCallback)(()=>{
        if (!selectedTemplate.current) return '';
        const { templateId: templateId, templateName: templateName, productKey: productKey } = selectedTemplate.current;
        let url = `${localizedSignupHref}?product=${productKey}&templateId=${templateId}&edition=free`;
        if (templateId === 'jsw.agentic-development-with-cmp') {
            const jiraAiSignupUrl = new URL(localizedSignupHref, location.origin);
            jiraAiSignupUrl.searchParams.append('signupSource', 'jira-ai-native');
            return jiraAiSignupUrl.toString();
        }
        if (isJiraProduct(productKey)) {
            const urlParams = new URLSearchParams(location.search);
            if (!urlParams.has('p')) urlParams.append('templateModal', templateId);
            url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
        } else if (productKey === (0, $7gFRR.ProductKeys).CONFLUENCE) {
            const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity ?? ''}?templateId=${templateId + encodeURIComponent('&templateName=' + encodeURIComponent(templateName))}`;
            url = `${url}&continue=${encodeURIComponent(continueUrl)}`;
        }
        return url;
    }, [
        localizedSignupHref,
        internalLinkAfterIdentity
    ]);
    const getIdentityUrl = (0, $1oC0p.useCallback)((templateId, templateName)=>{
        const loginUrl = `${(0, $lact3.getIdentityBaseUrl)()}/login?`;
        const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity ?? ''}?templateName=${encodeURIComponent(templateName)}&templateId=${templateId}`;
        const isWacIcLoginEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacIcLogin);
        const applicationParam = isWacIcLoginEnabled ? '&application=wac--ic' : '';
        const finalLoginUrl = `${loginUrl}&continue=${encodeURIComponent(continueUrl)}${applicationParam}`;
        return finalLoginUrl;
    }, [
        internalLinkAfterIdentity
    ]);
    const getCloudExistingUrl = (siteUrl, templateId)=>{
        if (productKey !== (0, $7gFRR.ProductKeys).CONFLUENCE) return `${siteUrl}/jira/create-project?templateId=${templateId}`;
        const templateSplit = templateId.split(':');
        if (templateSplit[0] === 'whiteboard') return `${siteUrl}/wiki/login.action?os_destination=${encodeURIComponent(`/create-content/whiteboard?insertTemplateWithKey=${templateSplit[1]}&redirect=true&referer=${referer}`)}`;
        return `${siteUrl}/wiki/login.action?os_destination=%2Frest%2Fcreate-dialog%2F1.0%2Fcontent%2Fblueprint%2FgetGlobalFabricBlueprintDraft%3Fredirect%3Dtrue%26blueprintModule%3D${templateId}%26referer%3D${referer}`;
    };
    const tryToUseTemplate = (0, $1oC0p.useCallback)(()=>{
        if (!selectedTemplate.current) return;
        const { templateId: templateId, templateName: templateName } = selectedTemplate.current;
        if (siteUrls.length > 0) setIsOpen(true);
        else if (redirectToIdentity && internalLinkAfterIdentity) location.href = getIdentityUrl(templateId, templateName);
        else location.href = getCloudSignupUrl();
    }, [
        siteUrls,
        redirectToIdentity,
        internalLinkAfterIdentity,
        getIdentityUrl,
        getCloudSignupUrl
    ]);
    const openModalForTemplate = (0, $1oC0p.useCallback)((template, isCallOnProductNav)=>{
        selectedTemplate.current = template;
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'linkButton',
            attributes: {
                templateName: template.templateName,
                label: template.templateName,
                path: location.pathname,
                event_type: 'ui',
                url: location.href,
                product: template.productKey ?? productKey,
                templateId: template.templateId,
                loginUserDetected: userProfile.isUserLoggedIn,
                trackEventName: getEventName('clicked-use-template'),
                eventContainer: isCallOnProductNav ? 'product-nav' : ''
            }
        }).fire();
        tryToUseTemplate();
    }, [
        createAnalyticsEvent,
        userProfile.isUserLoggedIn,
        tryToUseTemplate,
        productKey
    ]);
    const switchAccount = ()=>{
        if (!selectedTemplate.current) return;
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'linkButton',
            attributes: {
                trackEventName: getEventName('clicked-switch-account')
            }
        }).fire();
        const { templateId: templateId, templateName: templateName } = selectedTemplate.current;
        if (productKey === (0, $7gFRR.ProductKeys).CONFLUENCE) {
            const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity}?templateId=${templateId}&templateName=${encodeURIComponent(templateName)}`;
            location.href = (0, $lact3.getIdSwitchUserUrl)(continueUrl);
        } else location.href = (0, $lact3.getIdSwitchUserUrl)();
    };
    const siteSelected = (site)=>{
        createAnalyticsEvent({
            actionSubject: 'linkButton',
            action: 'clicked',
            attributes: {
                site: site,
                bluePrintModule: selectedTemplate.current?.templateId,
                eventName: 'project-created-(client)',
                createdUsing: 'templateWac',
                userId: userProfile.accountId,
                product: productKey,
                learnMore: referer === 'learnMore',
                trackEventName: getEventName('submitted-existing-site')
            }
        }).fire();
        const aiSdlcTemplateId = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacAiSdlcTemplateId) ? 'jsw.agentic-development' : 'jsw.agentic-development-with-cmp';
        const cloudId = aisSites?.find((s)=>s.url === site)?.cloudId;
        if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraFY27H1HoldoutExclusion) && selectedTemplate.current?.templateId === aiSdlcTemplateId && analyticsClient && cloudId) (0, $E9So2.fireHoldoutExclusionAnalytics)({
            analyticsClient: analyticsClient,
            createAnalyticsEvent: createAnalyticsEvent,
            cloudId: cloudId
        });
        if (selectedTemplate.current) location.href = getCloudExistingUrl(site, selectedTemplate.current?.templateId);
    };
    const newSiteSelected = ()=>{
        createAnalyticsEvent({
            actionSubject: 'linkButton',
            action: 'clicked',
            attributes: {
                bluePrintModule: selectedTemplate.current?.templateId,
                createdUsing: 'templateWac',
                userId: userProfile.accountId,
                product: productKey,
                learnMore: referer === 'learnMore',
                trackEventName: getEventName('submitted-new-site')
            }
        }).fire();
        location.href = getCloudSignupUrl();
    };
    const closeModal = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'linkButton',
            attributes: {
                trackEventName: getEventName('clicked-modal-closed')
            }
        }).fire();
        selectedTemplate.current = null;
        setIsOpen(false);
    };
    const siteChanged = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'linkButton',
            attributes: {
                trackEventName: getEventName('changed-selected-site')
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)($44d3dbc91672ca3c$export$c8b55b9bec89387e.Provider, {
        value: {
            openModalForTemplate: openModalForTemplate
        },
        children: [
            children,
            isOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7BlSS.default), {
                isOpen: isOpen,
                header: selectedTemplate.current ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UNB5T.default), {
                    productKey: selectedTemplate.current.productKey,
                    templateName: selectedTemplate.current.templateName,
                    selectedLabel: selectedTemplateLabel
                }) : null,
                onSwitchAccountClick: switchAccount,
                onSiteSelected: siteSelected,
                onSiteChanged: siteChanged,
                onNewSiteSelected: newSiteSelected,
                onModalClose: closeModal,
                userEmail: userProfile.email || '',
                sites: siteUrls,
                userName: userProfile.name || '',
                avatarSrc: userProfile.picture
            })
        ]
    });
};

});
parcelRegister("E9So2", function(module, exports) {
$parcel$export(module.exports, "fireHoldoutExclusionAnalytics", function () { return $0146f01951e6a551$export$fdd0f53c338990ad; });

var $wetcE = parcelRequire("wetcE");
const $0146f01951e6a551$export$bd3eedecef7f7366 = 'jiraFY27H1HoldoutExclusion';
const $0146f01951e6a551$export$fdd0f53c338990ad = ({ analyticsClient: analyticsClient, createAnalyticsEvent: createAnalyticsEvent, cloudId: cloudId })=>{
    analyticsClient.setTenantInfo((0, $wetcE.tenantType).CLOUD_ID, cloudId);
    createAnalyticsEvent({
        eventType: 'track',
        actionSubject: $0146f01951e6a551$export$bd3eedecef7f7366,
        action: 'triggered'
    }).fire();
};

});

parcelRegister("lact3", function(module, exports) {
$parcel$export(module.exports, "isProduction", function () { return $6a01a6c8d92ed40b$export$f15d00aa73aafac4; });
$parcel$export(module.exports, "isStaging", function () { return $6a01a6c8d92ed40b$export$23da1d24a38b0bde; });
$parcel$export(module.exports, "getIdentityBaseUrl", function () { return $6a01a6c8d92ed40b$export$752967ea6498a4b5; });
$parcel$export(module.exports, "getWacIntegrationUrl", function () { return $6a01a6c8d92ed40b$export$e844e0b5527ae7a6; });
$parcel$export(module.exports, "getApiPrivateUrl", function () { return $6a01a6c8d92ed40b$export$3ee5b2e8c5214994; });
$parcel$export(module.exports, "getHamletUrl", function () { return $6a01a6c8d92ed40b$export$dba83c144d8ba693; });
$parcel$export(module.exports, "getSocialSignUpUrl", function () { return $6a01a6c8d92ed40b$export$c3a6c95dc500a15e; });
$parcel$export(module.exports, "getIdSigninUrl", function () { return $6a01a6c8d92ed40b$export$337829db9c7199f7; });
$parcel$export(module.exports, "getIdSwitchUserUrl", function () { return $6a01a6c8d92ed40b$export$4f614dd379f7ad98; });

var $7gZ4V = parcelRequire("7gZ4V");

var $3oGMd = parcelRequire("3oGMd");
const $6a01a6c8d92ed40b$var$VALID_LOCALES = [
    'cn',
    'cs',
    'de',
    'es',
    'fr',
    'it',
    'ko',
    'nl',
    'ja',
    'pl',
    'br',
    'ro',
    'fi',
    'ru',
    'zh',
    'xx',
    'zz'
];
const $6a01a6c8d92ed40b$var$BXP_TO_GROWTH_LOCALE_MAP = {
    de: 'de',
    es: 'es',
    fr: 'fr',
    it: 'it',
    ko: 'ko',
    nl: 'nl',
    ja: 'ja',
    pl: 'pl',
    br: 'pt-BR',
    ru: 'ru',
    zh: 'zh',
    xx: 'xx',
    zz: 'zz'
};
function $6a01a6c8d92ed40b$export$9aecd33d3f363b37() {
    const urlParts = (0, $3oGMd.getLocation)()?.hostname?.split('.');
    if (urlParts?.[1] === 'dev') return 'localhost';
    return urlParts?.[0];
}
function $6a01a6c8d92ed40b$export$57570b1603cf6adb() {
    switch($6a01a6c8d92ed40b$export$9aecd33d3f363b37()){
        case 'wac':
        case 'qa-wac':
        case 'author':
        case 'proof':
        case 'statlas':
        case 'truth':
            return 0, $7gZ4V.ENV_STAGING;
        case 'localhost':
        case 'local':
            return 0, $7gZ4V.ENV_DEV;
        case 'www':
        case 'atlassian':
        case 'bitbucket':
        case 'sourcetreeapp':
        case 'agile':
        case 'git':
        case 'software':
            return 0, $7gZ4V.ENV_PRODUCTION;
        default:
            /* for omlet instances */ return 0, $7gZ4V.ENV_STAGING;
    }
}
function $6a01a6c8d92ed40b$export$f15d00aa73aafac4() {
    return $6a01a6c8d92ed40b$export$57570b1603cf6adb() === (0, $7gZ4V.ENV_PRODUCTION);
}
function $6a01a6c8d92ed40b$export$40edfb7eeb78c4e8() {
    return $6a01a6c8d92ed40b$export$57570b1603cf6adb() === (0, $7gZ4V.ENV_DEV);
}
function $6a01a6c8d92ed40b$export$23da1d24a38b0bde() {
    return $6a01a6c8d92ed40b$export$57570b1603cf6adb() === (0, $7gZ4V.ENV_STAGING);
}
function $6a01a6c8d92ed40b$export$752967ea6498a4b5() {
    if (!$6a01a6c8d92ed40b$export$f15d00aa73aafac4()) return 0, $7gZ4V.URL_STAGING_IDENTITY;
    else return 0, $7gZ4V.URL_PRODUCTION_IDENTITY;
}
function $6a01a6c8d92ed40b$export$e844e0b5527ae7a6() {
    if (!$6a01a6c8d92ed40b$export$f15d00aa73aafac4()) {
        const useQaWAC = window.location.hostname.includes('qa-wac') || window.location.hostname.includes('author');
        return useQaWAC ? (0, $7gZ4V.URL_STAGING_WAC_DEPRECATED) : (0, $7gZ4V.URL_STAGING_WAC);
    } else return 0, $7gZ4V.URL_PRODUCTION_WAC;
}
function $6a01a6c8d92ed40b$export$3ee5b2e8c5214994() {
    if (!$6a01a6c8d92ed40b$export$f15d00aa73aafac4()) return 0, $7gZ4V.URL_STAGING_API_PRIVATE;
    else return 0, $7gZ4V.URL_PRODUCTION_API_PRIVATE;
}
function $6a01a6c8d92ed40b$export$dba83c144d8ba693() {
    if (!$6a01a6c8d92ed40b$export$f15d00aa73aafac4()) return `${$6a01a6c8d92ed40b$export$e844e0b5527ae7a6()}/apis/stg/hamlet`;
    else return `${$6a01a6c8d92ed40b$export$e844e0b5527ae7a6()}/hamlet`;
}
function $6a01a6c8d92ed40b$export$c9fcd2e3c293a247() {
    const hostnameSubdomain = $6a01a6c8d92ed40b$export$9aecd33d3f363b37() || '';
    if (!$6a01a6c8d92ed40b$var$VALID_LOCALES.includes(hostnameSubdomain)) return false;
    return hostnameSubdomain;
}
function $6a01a6c8d92ed40b$export$8ec91dc709ca0e43() {
    const pathParts = window.location.pathname.split('/');
    // check for https://author.marketing.internal.atlassian.com/wac/ja
    const localeIndex = pathParts.length > 2 && pathParts[1] === 'wac' ? 2 : 1;
    return pathParts.length > 1 && $6a01a6c8d92ed40b$var$VALID_LOCALES.includes(pathParts[localeIndex] || '') ? `/${pathParts[localeIndex]}` : '';
}
function $6a01a6c8d92ed40b$export$6e8d225f896bccce() {
    const currentLocale = $6a01a6c8d92ed40b$export$8ec91dc709ca0e43().substring(1);
    const growthKitLocale = $6a01a6c8d92ed40b$var$BXP_TO_GROWTH_LOCALE_MAP[currentLocale];
    if (growthKitLocale !== undefined) return growthKitLocale;
    return '';
}
function $6a01a6c8d92ed40b$export$ac45197f039addcd({ bundle: bundle, product: product, edition: edition, templateId: templateId, migrationSourceUuid: migrationSourceUuid, developer: developer, src: src }) {
    const location1 = (0, $3oGMd.getLocation)();
    const internationalSubdomain = $6a01a6c8d92ed40b$export$c9fcd2e3c293a247();
    const params = new URLSearchParams(location1.search.slice(1));
    if (internationalSubdomain) params.set('lang', internationalSubdomain);
    if (bundle) params.set('bundle', bundle);
    if (product) params.set('product', product);
    if (edition) params.set('edition', edition);
    if (templateId) params.set('templateId', templateId);
    if (migrationSourceUuid) params.set('migrationSourceUuid', migrationSourceUuid);
    if (developer) params.set('developer', developer);
    if (src) params.set('src', src);
    return '?' + params.toString();
}
function $6a01a6c8d92ed40b$export$ecf541e09a511845(param) {
    const params = new URLSearchParams(location.search.slice(1));
    return params.get(param);
}
function $6a01a6c8d92ed40b$export$c3a6c95dc500a15e({ loginGoogleOrigin: loginGoogleOrigin, socialContinueUrl: socialContinueUrl, bundle: bundle, product: product, edition: edition, templateId: templateId, migrationSourceUuid: migrationSourceUuid, developer: developer, src: src, continueUrlOverride: continueUrlOverride }) {
    const splitPath = socialContinueUrl.split('/');
    if (splitPath.length >= 2 && splitPath[1]?.includes('wac')) {
        // remove contextual path if applicable
        splitPath.splice(0, 2);
        socialContinueUrl = `/${splitPath.join('/')}`;
    }
    socialContinueUrl = `${$6a01a6c8d92ed40b$export$e844e0b5527ae7a6()}${socialContinueUrl}`;
    const signupSocialUrl = `${socialContinueUrl}${$6a01a6c8d92ed40b$export$ac45197f039addcd({
        bundle: bundle,
        product: product,
        edition: edition,
        templateId: templateId,
        migrationSourceUuid: migrationSourceUuid,
        developer: developer,
        src: src
    })}`;
    const cobranding = `application=wac`;
    const socialSignup = `&social-signup-login=true`;
    const atlOrigin = `&atlOrigin=${encodeURIComponent(loginGoogleOrigin)}`;
    let continueUrl = `&continue=${encodeURIComponent(`${signupSocialUrl}${socialSignup}`)}`;
    const accountPrompt = `&prompt=select_account`;
    if (templateId && continueUrlOverride) continueUrl = `&continue=${encodeURIComponent(continueUrlOverride)}`;
    return `${$6a01a6c8d92ed40b$export$752967ea6498a4b5()}/login/initiate/google?${cobranding}${atlOrigin}${continueUrl}${accountPrompt}`;
}
function $6a01a6c8d92ed40b$export$337829db9c7199f7(atlOriginId, skipEncoding, continueUrlOverride) {
    let currentUrl = skipEncoding ? (0, $3oGMd.getUrl)() : encodeURIComponent((0, $3oGMd.getUrl)());
    if (continueUrlOverride) currentUrl = skipEncoding ? continueUrlOverride : encodeURIComponent(continueUrlOverride);
    const returnUrl = atlOriginId ? `${$6a01a6c8d92ed40b$export$752967ea6498a4b5()}/login?atlOrigin=${atlOriginId}&continue=${currentUrl}` : `${$6a01a6c8d92ed40b$export$752967ea6498a4b5()}/login?continue=${currentUrl}`;
    return returnUrl;
}
function $6a01a6c8d92ed40b$export$4f614dd379f7ad98(atlOriginId) {
    const idSigninUrl = new URL($6a01a6c8d92ed40b$export$337829db9c7199f7(atlOriginId, false));
    idSigninUrl.searchParams.set('application', 'wac');
    idSigninUrl.searchParams.set('prompt', 'select_account');
    return idSigninUrl.toString();
}
const $6a01a6c8d92ed40b$export$9251b2b81dd839a6 = $6a01a6c8d92ed40b$export$f15d00aa73aafac4() ? (0, $7gZ4V.RECAPTCHA_KEY) : (0, $7gZ4V.RECAPTCHA_KEY_TEST);

});
parcelRegister("7gZ4V", function(module, exports) {
$parcel$export(module.exports, "ENV_DEV", function () { return $15809ce112a69b74$export$395710bce26e0bbe; });
$parcel$export(module.exports, "ENV_STAGING", function () { return $15809ce112a69b74$export$c0ff33dc19b9700c; });
$parcel$export(module.exports, "ENV_PRODUCTION", function () { return $15809ce112a69b74$export$4342d8832354880f; });
$parcel$export(module.exports, "URL_STAGING_IDENTITY", function () { return $15809ce112a69b74$export$5e856692c0a3368e; });
$parcel$export(module.exports, "URL_PRODUCTION_IDENTITY", function () { return $15809ce112a69b74$export$b74fe7f72ce73c14; });
$parcel$export(module.exports, "URL_STAGING_WAC_DEPRECATED", function () { return $15809ce112a69b74$export$3b3310a1a582f0c6; });
$parcel$export(module.exports, "URL_STAGING_WAC", function () { return $15809ce112a69b74$export$209563a60562fbdb; });
$parcel$export(module.exports, "URL_PRODUCTION_WAC", function () { return $15809ce112a69b74$export$80425ef5138cf2f0; });
$parcel$export(module.exports, "URL_STAGING_API_PRIVATE", function () { return $15809ce112a69b74$export$2fd2486655328842; });
$parcel$export(module.exports, "URL_PRODUCTION_API_PRIVATE", function () { return $15809ce112a69b74$export$89e6da4dd8bae962; });
$parcel$export(module.exports, "RECAPTCHA_KEY", function () { return $15809ce112a69b74$export$3c733ac79bd72e45; });
$parcel$export(module.exports, "RECAPTCHA_KEY_TEST", function () { return $15809ce112a69b74$export$f8fc2e45c8a667fe; });
$parcel$export(module.exports, "ProductKey", function () { return $15809ce112a69b74$export$f3a53bd43617a593; });
$parcel$export(module.exports, "AppKey", function () { return $15809ce112a69b74$export$e50fec5b87d6cd71; });
/**
 * Commonly-used constants, enums/mappings
 */ const $15809ce112a69b74$export$b1f75679747bdf24 = 'US';
const $15809ce112a69b74$export$427ae666c2c86a64 = 'USD';
const $15809ce112a69b74$export$395710bce26e0bbe = 'dev';
const $15809ce112a69b74$export$c0ff33dc19b9700c = 'staging';
const $15809ce112a69b74$export$4342d8832354880f = 'production';
const $15809ce112a69b74$export$5e856692c0a3368e = 'https://id.stg.internal.atlassian.com';
const $15809ce112a69b74$export$b74fe7f72ce73c14 = 'https://id.atlassian.com';
const $15809ce112a69b74$export$3b3310a1a582f0c6 = 'https://qa-wac.internal.atlassian.com';
const $15809ce112a69b74$export$209563a60562fbdb = 'https://wac.stg.internal.atlassian.com';
const $15809ce112a69b74$export$80425ef5138cf2f0 = 'https://www.atlassian.com';
const $15809ce112a69b74$export$2fd2486655328842 = 'https://wac.stg.internal.atlassian.com/gateway/api';
const $15809ce112a69b74$export$89e6da4dd8bae962 = 'https://www.atlassian.com/gateway/api';
const $15809ce112a69b74$export$3c733ac79bd72e45 = '6LeTa5ocAAAAAJefQaFL-1ENlPNY3Wq2j-GhcZ6n';
const $15809ce112a69b74$export$f8fc2e45c8a667fe = '6Lf0JekdAAAAAAWT2kBc89gFVKhxkwTPxa-e9tvx';
var $15809ce112a69b74$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["BITBUCKET"] = "com.atlassian.bitbucket";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_WORK_MANAGEMENT"] = "jira-core.ondemand";
    ProductKey["ACCESS"] = "com.atlassian.identity-manager";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["CONFLUENCE_PLUGIN_QUESTIONS"] = "com.atlassian.confluence.plugins.confluence-questions.ondemand";
    ProductKey["CONFLUENCE_TEAM_CALENDARS"] = "team.calendars.confluence.ondemand";
    ProductKey["JIRA_ROADMAPS"] = "com.radiantminds.roadmaps-jira.ondemand";
    ProductKey["JIRA_BONFIRE"] = "bonfire.jira.ondemand";
    ProductKey["JIRA_REFAPP"] = "refapp";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    ProductKey["COMPASS"] = "compass";
    ProductKey["ATLAS"] = "townsquare";
    ProductKey["FABRIC"] = "atlassian-whiteboard";
    ProductKey["BEACON"] = "beacon";
    ProductKey["LOOM"] = "loom";
    ProductKey["ROVO"] = "rovo";
    ProductKey["SERVICE_COLLECTION"] = "com.atlassian.service-collection";
    return ProductKey;
}({});
var $15809ce112a69b74$export$e50fec5b87d6cd71 = /*#__PURE__*/ function(AppKey) {
    AppKey["TEMPO"] = "is.origo.jira.tempo-plugin";
    AppKey["ZEPHYR"] = "com.thed.zephyr.je";
    AppKey["BIGPICTURE"] = "eu.softwareplant.bigpicture";
    return AppKey;
}({});

});

parcelRegister("3oGMd", function(module, exports) {
$parcel$export(module.exports, "getLocation", function () { return $13033ae939e39f26$export$e7fd20fad3cf4b5f; });
$parcel$export(module.exports, "getUrl", function () { return $13033ae939e39f26$export$94df0e59ebebf4a7; });
$parcel$export(module.exports, "getParameterByName", function () { return $13033ae939e39f26$export$7a5418d73bdac342; });
$parcel$export(module.exports, "getUrlParams", function () { return $13033ae939e39f26$export$1061071041ba84d4; });
function $13033ae939e39f26$export$e7fd20fad3cf4b5f() {
    return window.location;
}
function $13033ae939e39f26$export$94df0e59ebebf4a7() {
    return $13033ae939e39f26$export$e7fd20fad3cf4b5f().href;
}
function $13033ae939e39f26$export$9a19c1c380185e62(url = $13033ae939e39f26$export$94df0e59ebebf4a7()) {
    url = url || window.location.href;
    const hashIndex = url.indexOf('#');
    return url.substring(0, hashIndex > -1 ? hashIndex : url.length);
}
function $13033ae939e39f26$export$cbc81e31c72048c8(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $13033ae939e39f26$export$7a5418d73bdac342(name, url = $13033ae939e39f26$export$94df0e59ebebf4a7()) {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results || !results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function $13033ae939e39f26$export$18380b9f669996bd(url = $13033ae939e39f26$export$94df0e59ebebf4a7()) {
    let questionIndex;
    let r = window.location?.search?.substring(1, window.location.search.length);
    if (url) {
        url = $13033ae939e39f26$export$9a19c1c380185e62(url);
        questionIndex = url.indexOf('?');
        r = questionIndex > -1 ? url.substring(questionIndex + 1) : '';
    }
    return r;
}
function $13033ae939e39f26$export$1061071041ba84d4(url = $13033ae939e39f26$export$94df0e59ebebf4a7()) {
    const qs = $13033ae939e39f26$export$18380b9f669996bd(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let r = null;
    let paramPairs;
    let keyValuePair;
    if (qs) {
        paramPairs = decodeURIComponent(qs).split('&');
        for(let i = 0, iLen = paramPairs.length; i < iLen; i++){
            if (!r) r = {};
            keyValuePair = paramPairs[i]?.split('=') || [];
            if (keyValuePair.length > 2) keyValuePair[1] = paramPairs[i]?.split('=').slice(1).join('=');
            r[keyValuePair[0]] = keyValuePair.length > 1 ? decodeURIComponent(keyValuePair[1] || '') : undefined;
        }
    }
    return r;
}

});


parcelRegister("UNB5T", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $72d4444b459c1c1a$export$2e2bcd8739ae039; });
/* product-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("20OkY");
var $7gFRR = parcelRequire("7gFRR");

var $5uYpV = parcelRequire("5uYpV");
const $72d4444b459c1c1a$var$ProductHeader = ({ productKey: productKey, templateName: templateName, selectedLabel: selectedLabel })=>{
    const intl = (0, $8e22h.default)();
    const getBrand = (productKey)=>{
        switch(productKey){
            case (0, $7gFRR.ProductKeys).JIRA_SOFTWARE:
                return 'jirasoftware';
            case (0, $7gFRR.ProductKeys).JIRA_SERVICE_DESK:
                return 'jiraservicemanagement';
            case (0, $7gFRR.ProductKeys).JIRA_CORE:
                return 'jiraworkmanagement';
            case (0, $7gFRR.ProductKeys).CONFLUENCE:
            default:
                return 'confluence';
        }
    };
    const youSelectedLabel = intl.formatMessage({
        id: 'SiteSelectorModal.modalHeader.youSelected',
        defaultMessage: 'You selected'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4x201mjv"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
                type: 'logo',
                appearance: 'brand',
                brand: getBrand(productKey)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz"
                ]),
                children: [
                    selectedLabel ?? youSelectedLabel,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_k48p8n31 _bozg14y2"
                        ]),
                        children: templateName
                    })
                ]
            })
        ]
    });
};
const $72d4444b459c1c1a$var$subHeadlineStyle = null;
const $72d4444b459c1c1a$var$selectedTemplateStyle = null;
const $72d4444b459c1c1a$var$logoWrapperStyle = null;
var $72d4444b459c1c1a$export$2e2bcd8739ae039 = $72d4444b459c1c1a$var$ProductHeader;

});
parcelRegister("5uYpV", function(module, exports) {
$parcel$export(module.exports, "Logo", function () { return $2b139601b22d9c87$export$e6ff31bff12b7ff4; });

var $7VQPk = parcelRequire("7VQPk");

var $6A2DX = parcelRequire("6A2DX");

var $888KO = parcelRequire("888KO");

var $fg0qm = parcelRequire("fg0qm");

var $cusIg = parcelRequire("cusIg");

var $3Dz6G = parcelRequire("3Dz6G");

var $hktDW = parcelRequire("hktDW");

var $3RGc0 = parcelRequire("3RGc0");

var $d3z6K = parcelRequire("d3z6K");

var $a9CD6 = parcelRequire("a9CD6");

var $aBawz = parcelRequire("aBawz");

var $eCQc3 = parcelRequire("eCQc3");

var $4IHFR = parcelRequire("4IHFR");

var $1OyVz = parcelRequire("1OyVz");

var $a0AEy = parcelRequire("a0AEy");

var $cH95H = parcelRequire("cH95H");

var $5xYFE = parcelRequire("5xYFE");

var $bEzzt = parcelRequire("bEzzt");

var $9YpGW = parcelRequire("9YpGW");

var $ldaRP = parcelRequire("ldaRP");

var $dmDFX = parcelRequire("dmDFX");

var $bogCj = parcelRequire("bogCj");

var $98rQm = parcelRequire("98rQm");
const $2b139601b22d9c87$var$Logos = {
    atlas: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fg0qm.AtlasMarkBrand), {})
        }
    },
    atlassian: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cusIg.AtlassianLogoBrand), {}),
            neutral: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Dz6G.AtlassianLogoNeutral), {})
        }
    },
    bitbucket: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hktDW.BitbucketMarkBrand), {})
        }
    },
    compass: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RGc0.CompassMarkBrand), {})
        }
    },
    confluence: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $d3z6K.ConfluenceLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9CD6.ConfluenceMarkBrand), {})
        }
    },
    customerservicemanagement: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aBawz.CustomerServiceManagementLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCQc3.CustomerServiceManagementMarkBrand), {})
        }
    },
    enterprise: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $888KO.EnterpriseLogo), {})
        }
    },
    halp: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4IHFR.HalpLogoBrand), {})
        }
    },
    jira: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraLogo), {
                appearance: "brand"
            })
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {})
        }
    },
    jiraalign: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a0AEy.JiraAlignMarkBrand), {})
        }
    },
    jiraservicemanagement: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bEzzt.JiraServiceManagementLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9YpGW.JiraServiceManagementMarkBrand), {})
        }
    },
    jiraproductdiscovery: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cH95H.JiraProductDiscoveryLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xYFE.JiraProductDiscoveryMarkBrand), {})
        }
    },
    jirasoftware: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldaRP.JiraSoftwareLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dmDFX.JiraSoftwareMarkBrand), {})
        }
    },
    jiraworkmanagement: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bogCj.JiraWorkManagementMarkBrand), {})
        }
    },
    softwaredevelopment: {},
    trello: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $98rQm.TrelloMarkBrand), {})
        }
    }
};
const $2b139601b22d9c87$export$e6ff31bff12b7ff4 = ({ brand: brand, type: type, appearance: appearance })=>{
    return $2b139601b22d9c87$var$Logos[brand]?.[type]?.[appearance];
};

});
parcelRegister("888KO", function(module, exports) {
$parcel$export(module.exports, "EnterpriseLogo", function () { return $70f66111dc830150$export$854b8d8f612d0fbb; });

var $7VQPk = parcelRequire("7VQPk");
const $70f66111dc830150$export$854b8d8f612d0fbb = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "98",
        height: "28",
        viewBox: "0 0 98 28",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: "Enterprise"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 4H0.375V28H0V4Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.4455 11.3375C91.0255 11.3375 90.3055 12.3175 90.1455 13.6175C91.1255 13.4175 92.4855 13.3375 93.4055 13.3375H94.4656C94.3256 12.0575 93.6855 11.3375 92.4455 11.3375ZM97.0055 18.7775C96.1255 19.1775 94.8856 19.3775 93.1656 19.3775C89.2255 19.3775 87.1855 17.2575 87.1855 14.2575C87.1855 11.2975 89.0856 9.15747 92.5256 9.15747C96.0456 9.15747 97.4655 11.2775 97.4655 14.2575V14.9175H94.9656C93.3256 14.9175 91.6455 14.8775 90.1455 14.7775C90.3655 15.9775 91.3655 16.7375 93.4655 16.7375C94.7855 16.7375 95.8655 16.5975 97.0055 16.2975V18.7775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.6294 16.1975C85.6294 17.9375 84.4894 19.3975 81.3294 19.3975C79.5294 19.3975 78.0094 19.1575 77.1494 18.6975V16.2175C78.0694 16.6375 79.6894 17.0575 81.3294 17.0575C82.3094 17.0575 82.8694 16.8175 82.8694 16.3375C82.8694 15.8175 82.5094 15.5775 80.6494 15.3175C78.1494 14.9775 77.1094 14.0175 77.1094 12.2375C77.1094 10.3375 78.6894 9.15747 81.3494 9.15747C82.8894 9.15747 84.3094 9.41747 85.1694 9.81747V12.3375C83.8494 11.7175 82.4894 11.4575 81.1694 11.4575C80.2294 11.4575 79.8094 11.7375 79.8094 12.1975C79.8094 12.6975 80.2694 12.9175 82.0894 13.1575C84.4694 13.4975 85.6294 14.3975 85.6294 16.1975Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M71.4473 6.3175C71.4473 5.0575 72.2473 4.4375 73.4073 4.4375C74.5473 4.4375 75.3473 5.0575 75.3473 6.3175C75.3473 7.5775 74.5473 8.1975 73.4073 8.1975C72.2473 8.1975 71.4473 7.5775 71.4473 6.3175ZM71.8873 19.1775V9.3575H74.8473V19.1775H71.8873Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M67.4854 14.6774V19.1774H64.5254V9.35741H67.4854V11.8374C67.9254 10.2574 68.6054 9.13741 70.2054 9.21741V12.3974C68.4454 12.2574 67.4854 12.7974 67.4854 14.6774Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.2491 14.2775C59.2491 12.7375 58.4691 11.7975 57.0891 11.7975C55.8091 11.7975 54.8291 12.7775 54.8291 14.1975V14.3775C54.8291 15.9375 55.8091 16.7375 57.0891 16.7375C58.4091 16.7375 59.2491 15.8975 59.2491 14.2775ZM57.9291 19.3775C56.4891 19.3775 55.4091 18.6775 54.8291 17.2975V23.5775H51.8691V9.35747H54.8291V11.2775C55.4491 9.87747 56.6291 9.15747 58.1691 9.15747C60.7891 9.15747 62.2091 11.3775 62.2091 14.2775C62.2091 17.0375 60.7691 19.3775 57.9291 19.3775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.4659 14.6774V19.1774H44.5059V9.35741H47.4659V11.8374C47.9059 10.2574 48.5859 9.13741 50.1859 9.21741V12.3974C48.4259 12.2574 47.4659 12.7974 47.4659 14.6774Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.2698 11.3375C35.8498 11.3375 35.1298 12.3175 34.9698 13.6175C35.9498 13.4175 37.3098 13.3375 38.2298 13.3375H39.2898C39.1498 12.0575 38.5098 11.3375 37.2698 11.3375ZM41.8298 18.7775C40.9498 19.1775 39.7098 19.3775 37.9898 19.3775C34.0498 19.3775 32.0098 17.2575 32.0098 14.2575C32.0098 11.2975 33.9098 9.15747 37.3498 9.15747C40.8698 9.15747 42.2898 11.2775 42.2898 14.2575V14.9175H39.7898C38.1498 14.9175 36.4698 14.8775 34.9698 14.7775C35.1898 15.9775 36.1898 16.7375 38.2898 16.7375C39.6098 16.7375 40.6898 16.5975 41.8298 16.2975V18.7775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.7716 15.4574C27.7716 16.1574 28.2316 16.6174 29.1516 16.6174C29.6316 16.6174 30.1516 16.5374 30.5116 16.4774V19.1574C30.0316 19.2974 29.4516 19.3974 28.6316 19.3974C26.0716 19.3974 24.8116 17.8974 24.8116 15.6974V12.0174H23.3516V9.3574H24.8116V6.8374H27.7716V9.3574H30.4916V12.0174H27.7716V15.4574Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.6467 13.6775V19.1775H18.6667V13.8975C18.6667 12.4375 18.1467 11.7575 16.9467 11.7575C15.7067 11.7575 14.8667 12.4975 14.8667 13.8975V19.1775H11.8867V9.35747H14.8667V11.2575C15.4667 9.91747 16.6467 9.15747 18.1667 9.15747C20.5667 9.15747 21.6467 10.8775 21.6467 13.6775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 19.1776V6.0376H9.44V8.7976H3.04V11.3976H8.76V13.8976H3.04V16.4176H9.56V19.1776H0Z",
                fill: "black"
            })
        ]
    });

});

parcelRegister("fg0qm", function(module, exports) {
$parcel$export(module.exports, "AtlasMarkBrand", function () { return $004c01aa738aa03a$export$41a3624cc2b0f936; });

var $7VQPk = parcelRequire("7VQPk");
const $004c01aa738aa03a$export$41a3624cc2b0f936 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 42.7982C14.016 42.7982 5.89795 34.6802 5.89795 24.6962C5.89795 14.7122 14.016 6.59424 24 6.59424V9.47624C15.604 9.47624 8.78095 16.2992 8.78095 24.6952C8.78095 33.0912 15.604 39.9142 24 39.9142V42.7962V42.7982Z",
                fill: "url(#paint0_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.9999 42.7983V39.9163C32.3959 39.9163 39.2189 33.0933 39.2189 24.6973H42.1009C42.1009 34.6813 33.9829 42.7993 23.9989 42.7993L23.9999 42.7983Z",
                fill: "url(#paint1_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.102 24.6962H39.22C39.22 16.3002 32.397 9.47722 24.001 9.47722V6.59521C33.985 6.59521 42.103 14.7132 42.103 24.6972L42.102 24.6962Z",
                fill: "url(#paint2_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.711 30.238C29.7889 29.862 28.2719 29.18 25.7509 28.038C25.055 27.732 24.289 27.384 23.412 26.994C22.883 26.757 22.396 26.548 21.908 26.34C18.107 24.655 16.018 23.736 13.4559 23.736C11.6599 23.736 10.3089 24.223 9.55695 25.142C9.04195 25.755 8.83295 26.548 8.98595 27.314L6.15895 27.857C5.85295 26.242 6.26995 24.585 7.32895 23.304C8.24795 22.19 10.0579 20.853 13.4559 20.853C16.6309 20.853 19.1929 21.995 23.0779 23.708C23.5509 23.917 24.039 24.14 24.568 24.362C25.459 24.752 26.239 25.1 26.9349 25.42C29.344 26.506 30.667 27.105 32.268 27.411L31.711 30.238Z",
                fill: "url(#paint3_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.5259 30.516C33.5649 30.516 32.6459 30.432 31.7129 30.238L32.2699 27.411C33.0219 27.564 33.7599 27.634 34.5259 27.634C36.3079 27.634 37.6589 27.188 38.4389 26.339C39.2189 25.49 39.2469 24.459 39.2049 23.916L42.0729 23.665C42.2259 25.419 41.6969 27.063 40.5689 28.288C39.6359 29.304 37.8399 30.516 34.5259 30.516Z",
                fill: "url(#paint4_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.9999 42.798V39.916C28.1359 39.916 30.5999 35.697 30.5999 28.637C30.5999 21.577 28.0939 15.659 22.9559 10.187L25.0589 8.20996C30.7259 14.239 33.4829 20.923 33.4829 28.637C33.4829 37.368 29.8489 42.798 23.9999 42.798Z",
                fill: "url(#paint5_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.998 42.7981C17.774 42.7981 14.209 37.7301 14.209 28.8881C14.209 18.5701 18.721 12.8051 22.94 8.22412L25.057 10.1731C20.142 15.5201 17.092 20.5051 17.092 28.8871C17.092 38.0071 20.852 39.9151 23.999 39.9151V42.7971L23.998 42.7981Z",
                fill: "url(#paint6_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.2849 26.2C18.1459 26.2 19.6549 24.691 19.6549 22.83C19.6549 20.969 18.1459 19.46 16.2849 19.46C14.4239 19.46 12.9149 20.969 12.9149 22.83C12.9149 24.691 14.4239 26.2 16.2849 26.2Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.8629 32.0071C33.7239 32.0071 35.2329 30.4981 35.2329 28.6371C35.2329 26.7761 33.7239 25.2671 31.8629 25.2671C30.0019 25.2671 28.4929 26.7761 28.4929 28.6371C28.4929 30.4981 30.0019 32.0071 31.8629 32.0071Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.997 11.9412C25.858 11.9412 27.367 10.4322 27.367 8.57117C27.367 6.71017 25.858 5.20117 23.997 5.20117C22.136 5.20117 20.627 6.71017 20.627 8.57117C20.627 10.4322 22.136 11.9412 23.997 11.9412Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_466",
                        x1: "15.989",
                        y1: "43.1032",
                        x2: "14.6109",
                        y2: "6.93924",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_466",
                        x1: "42.4099",
                        y1: "26.2853",
                        x2: "26.3829",
                        y2: "42.8553",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint2_linear_818_466",
                        x1: "33.051",
                        y1: "6.59421",
                        x2: "33.051",
                        y2: "24.6962",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.59",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint3_linear_818_466",
                        x1: "6.06095",
                        y1: "25.546",
                        x2: "32.268",
                        y2: "25.546",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.26",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint4_linear_818_466",
                        x1: "34.6069",
                        y1: "29.777",
                        x2: "40.3299",
                        y2: "23.692",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint5_linear_818_466",
                        x1: "28.2189",
                        y1: "42.798",
                        x2: "28.2189",
                        y2: "8.20996",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.36",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint6_linear_818_466",
                        x1: "19.633",
                        y1: "42.7981",
                        x2: "19.633",
                        y2: "8.22312",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.06",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.58",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("cusIg", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogoBrand", function () { return $8d6f9462c955fddb$export$be4b880845d08afc; });

var $7VQPk = parcelRequire("7VQPk");
const $8d6f9462c955fddb$export$be4b880845d08afc = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "282",
        height: "48",
        viewBox: "0 0 282 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: "Atlassian logo"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_994_4077)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M10.3 19.9003C9.80005 19.3003 9.00005 19.4003 8.60005 20.1003L0.100048 37.1003C-0.199952 37.8003 0.300048 38.6003 1.00005 38.6003H12.8C13.2 38.6003 13.5 38.4003 13.7 38.0003C16.3 32.7003 14.7 24.7003 10.3 19.9003Z",
                        fill: "url(#paint0_linear_994_4077)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M16.5001 4.5001C11.8001 12.0001 12.1001 20.3001 15.2001 26.6001C18.3001 32.9001 20.7001 37.6001 20.9001 38.0001C21.1001 38.4001 21.4001 38.6001 21.8001 38.6001H33.6001C34.4001 38.6001 34.8001 37.8001 34.5001 37.1001C34.5001 37.1001 18.6001 5.3001 18.2001 4.5001C17.9001 3.8001 16.9001 3.8001 16.5001 4.5001Z",
                        fill: "#0082FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M155 18.1004C155 22.3004 156.9 25.6004 164.6 27.1004C169.1 28.1004 170.1 28.8004 170.1 30.3004C170.1 31.8004 169.1 32.7004 165.9 32.7004C162.2 32.7004 157.8 31.4004 154.9 29.7004V36.5004C157.2 37.6004 160.2 38.9004 165.9 38.9004C173.9 38.9004 177 35.3004 177 30.1004M177 30.2004C177 25.2004 174.4 22.9004 166.9 21.3004C162.8 20.4004 161.8 19.5004 161.8 18.2004C161.8 16.6004 163.3 15.9004 166 15.9004C169.3 15.9004 172.5 16.9004 175.6 18.3004V11.8004C173.4 10.7004 170.1 9.90039 166.2 9.90039C158.8 9.90039 155 13.1004 155 18.3004",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M257.4 10.1001V38.6001H263.5V16.9001L266 22.6001L274.6 38.6001H282.2V10.1001H276.2V28.5001L273.9 23.1001L267 10.1001H257.4Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M218.8 10.1001H212.2V38.6001H218.8V10.1001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M204.6 30.1003C204.6 25.1003 202 22.8003 194.5 21.2003C190.4 20.3003 189.4 19.4003 189.4 18.1003C189.4 16.5003 190.9 15.8003 193.6 15.8003C196.9 15.8003 200.1 16.8003 203.2 18.2003V11.7003C201 10.6003 197.7 9.80029 193.8 9.80029C186.4 9.80029 182.6 13.0003 182.6 18.2003C182.6 22.4003 184.5 25.7003 192.2 27.2003C196.7 28.2003 197.7 28.9003 197.7 30.4003C197.7 31.9003 196.7 32.8003 193.5 32.8003C189.8 32.8003 185.4 31.5003 182.5 29.8003V36.6003C184.8 37.7003 187.8 39.0003 193.5 39.0003C201.4 39.0003 204.6 35.4003 204.6 30.1003Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M103.6 10.1001V38.6001H117.2L119.3 32.4001H110.2V10.1001H103.6Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M76.7001 10.1001V16.2001H84.0001V38.6001H90.7001V16.2001H98.6001V10.1001H76.7001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M67 10.1001H58.3L48.4 38.6001H56L57.4 33.8001C59.1 34.3001 60.9 34.6001 62.7 34.6001C64.5 34.6001 66.3 34.3001 68 33.8001L69.4 38.6001H77C76.9 38.6001 67 10.1001 67 10.1001ZM62.6 28.6001C61.3 28.6001 60.1 28.4001 59 28.1001L62.6 15.7001L66.2 28.1001C65.1 28.4001 63.9 28.6001 62.6 28.6001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M140.7 10.1001H132L122 38.6001H129.6L131 33.8001C132.7 34.3001 134.5 34.6001 136.3 34.6001C138.1 34.6001 139.9 34.3001 141.6 33.8001L143 38.6001H150.6L140.7 10.1001ZM136.3 28.6001C135 28.6001 133.8 28.4001 132.7 28.1001L136.3 15.7001L139.9 28.1001C138.8 28.4001 137.6 28.6001 136.3 28.6001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M242.7 10.1001H234L224.1 38.6001H231.7L233.1 33.8001C234.8 34.3001 236.6 34.6001 238.4 34.6001C240.2 34.6001 242 34.3001 243.7 33.8001L245.1 38.6001H252.7L242.7 10.1001ZM238.4 28.6001C237.1 28.6001 235.9 28.4001 234.8 28.1001L238.4 15.7001L242 28.1001C240.9 28.4001 239.6 28.6001 238.4 28.6001Z",
                        fill: "#0050D3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_994_4077",
                        x1: "14.9161",
                        y1: "22.5557",
                        x2: "5.96115",
                        y2: "38.0657",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0050D3"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.923",
                                stopColor: "#0082FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_994_4077",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "282",
                            height: "48",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("3Dz6G", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogoNeutral", function () { return $f1f3119cac8bd602$export$2146dec71e451533; });

var $7VQPk = parcelRequire("7VQPk");
const $f1f3119cac8bd602$export$2146dec71e451533 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "282",
        height: "48",
        viewBox: "0 0 282 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: "Atlassian logo"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_994_3735)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M10.3 19.9003C9.79999 19.3003 8.99999 19.4003 8.59999 20.1003L0.0999871 37.1003C-0.200013 37.8003 0.299987 38.6003 0.999987 38.6003H12.8C13.2 38.6003 13.5 38.4003 13.7 38.0003C16.3 32.7003 14.7 24.7003 10.3 19.9003Z",
                        fill: "url(#paint0_linear_994_3735)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M16.5 4.5001C11.8 12.0001 12.1 20.3001 15.2 26.6001C18.3 32.9001 20.7 37.6001 20.9 38.0001C21.1 38.4001 21.4 38.6001 21.8 38.6001H33.6C34.4 38.6001 34.8 37.8001 34.5 37.1001C34.5 37.1001 18.6 5.3001 18.2 4.5001C17.9 3.8001 16.9 3.8001 16.5 4.5001Z",
                        fill: "#77859B"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M155 18.1004C155 22.3004 156.9 25.6004 164.6 27.1004C169.1 28.1004 170.1 28.8004 170.1 30.3004C170.1 31.8004 169.1 32.7004 165.9 32.7004C162.2 32.7004 157.8 31.4004 154.9 29.7004V36.5004C157.2 37.6004 160.2 38.9004 165.9 38.9004C173.9 38.9004 177 35.3004 177 30.1004M177 30.2004C177 25.2004 174.4 22.9004 166.9 21.3004C162.8 20.4004 161.8 19.5004 161.8 18.2004C161.8 16.6004 163.3 15.9004 166 15.9004C169.3 15.9004 172.5 16.9004 175.6 18.3004V11.8004C173.4 10.7004 170.1 9.90039 166.2 9.90039C158.8 9.90039 155 13.1004 155 18.3004",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M257.4 10.1001V38.6001H263.5V16.9001L266 22.6001L274.6 38.6001H282.2V10.1001H276.2V28.5001L273.9 23.1001L267 10.1001H257.4Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M218.8 10.1001H212.2V38.6001H218.8V10.1001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M204.6 30.1003C204.6 25.1003 202 22.8003 194.5 21.2003C190.4 20.3003 189.4 19.4003 189.4 18.1003C189.4 16.5003 190.9 15.8003 193.6 15.8003C196.9 15.8003 200.1 16.8003 203.2 18.2003V11.7003C201 10.6003 197.7 9.80029 193.8 9.80029C186.4 9.80029 182.6 13.0003 182.6 18.2003C182.6 22.4003 184.5 25.7003 192.2 27.2003C196.7 28.2003 197.7 28.9003 197.7 30.4003C197.7 31.9003 196.7 32.8003 193.5 32.8003C189.8 32.8003 185.4 31.5003 182.5 29.8003V36.6003C184.8 37.7003 187.8 39.0003 193.5 39.0003C201.4 39.0003 204.6 35.4003 204.6 30.1003Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M103.6 10.1001V38.6001H117.2L119.3 32.4001H110.2V10.1001H103.6Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M76.7 10.1001V16.2001H84V38.6001H90.7V16.2001H98.6V10.1001H76.7Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M67 10.1001H58.3L48.4 38.6001H56L57.4 33.8001C59.1 34.3001 60.9 34.6001 62.7 34.6001C64.5 34.6001 66.3 34.3001 68 33.8001L69.4 38.6001H77C76.9 38.6001 67 10.1001 67 10.1001ZM62.6 28.6001C61.3 28.6001 60.1 28.4001 59 28.1001L62.6 15.7001L66.2 28.1001C65.1 28.4001 63.9 28.6001 62.6 28.6001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M140.7 10.1001H132L122 38.6001H129.6L131 33.8001C132.7 34.3001 134.5 34.6001 136.3 34.6001C138.1 34.6001 139.9 34.3001 141.6 33.8001L143 38.6001H150.6L140.7 10.1001ZM136.3 28.6001C135 28.6001 133.8 28.4001 132.7 28.1001L136.3 15.7001L139.9 28.1001C138.8 28.4001 137.6 28.6001 136.3 28.6001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M242.7 10.1001H234L224.1 38.6001H231.7L233.1 33.8001C234.8 34.3001 236.6 34.6001 238.4 34.6001C240.2 34.6001 242 34.3001 243.7 33.8001L245.1 38.6001H252.7L242.7 10.1001ZM238.4 28.6001C237.1 28.6001 235.9 28.4001 234.8 28.1001L238.4 15.7001L242 28.1001C240.9 28.4001 239.6 28.6001 238.4 28.6001Z",
                        fill: "#44546F"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_994_3735",
                        x1: "14.9161",
                        y1: "22.5567",
                        x2: "5.96109",
                        y2: "38.0667",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#304566"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.923",
                                stopColor: "#77859B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_994_3735",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "282",
                            height: "48",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("hktDW", function(module, exports) {
$parcel$export(module.exports, "BitbucketMarkBrand", function () { return $97e6614f325f2af3$export$51dbe3f91062dd43; });

var $7VQPk = parcelRequire("7VQPk");
const $97e6614f325f2af3$export$51dbe3f91062dd43 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.73796 10.3291C8.09296 10.3291 7.60196 10.9071 7.70596 11.5441L12.13 38.4841C12.242 39.1661 12.831 39.6661 13.521 39.6721L34.812 39.6681C35.325 39.6681 35.763 39.2961 35.845 38.7901L40.294 11.5491C40.398 10.9131 39.907 10.3351 39.262 10.3351L8.73696 10.3281L8.73796 10.3291ZM27.427 29.8001H20.606L18.79 20.1901H29.072L27.427 29.8001Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.883 20.1899H29.072L27.427 29.7999H20.606L12.605 39.3269C12.605 39.3269 12.964 39.6709 13.521 39.6709L34.813 39.6669C35.325 39.6669 35.762 39.2949 35.844 38.7899L38.882 20.1899H38.883Z",
                fill: "url(#paint0_linear_818_495)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_495",
                    x1: "41.152",
                    y1: "22.8799",
                    x2: "24.937",
                    y2: "35.5379",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.176",
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("3RGc0", function(module, exports) {
$parcel$export(module.exports, "CompassMarkBrand", function () { return $15fbc70d0710051b$export$95ba070e064f69d4; });

var $7VQPk = parcelRequire("7VQPk");
const $15fbc70d0710051b$export$95ba070e064f69d4 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.5 23.179V32.092H14.57V23.179H23.5V14.272H7.20997C6.33997 14.278 5.63997 14.976 5.64597 15.832C5.64597 15.839 5.64597 15.846 5.64597 15.853V39.465C5.62797 40.321 6.31897 41.028 7.18797 41.046C7.19497 41.046 7.20297 41.046 7.20997 41.046H30.844C31.714 41.04 32.414 40.342 32.408 39.486C32.408 39.479 32.408 39.472 32.408 39.465V23.179H23.5Z",
                fill: "url(#paint0_linear_2304_2419)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.5 5.35987V14.2719H32.451V23.1789H41.354V6.91987C41.372 6.06387 40.681 5.35687 39.812 5.33887C39.805 5.33887 39.797 5.33887 39.79 5.33887L23.5 5.35987Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_2304_2419",
                    x1: "30.859",
                    y1: "15.827",
                    x2: "15.688",
                    y2: "30.998",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.2",
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("d3z6K", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoBrand", function () { return $6057a35e6ecd0681$export$688c79db1f7ed58e; });

var $7VQPk = parcelRequire("7VQPk");
const $6057a35e6ecd0681$export$688c79db1f7ed58e = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "267",
        height: "48",
        viewBox: "0 0 267 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M70.2961 37.4057C68.4101 38.6477 65.4201 39.1997 62.2911 39.1997C52.3541 39.1997 46.7411 33.2197 46.7411 23.6957C46.7411 14.4957 52.3541 8.05371 62.1991 8.05371C65.1431 8.05371 68.0881 8.60671 70.2501 10.1697V14.1727C68.0881 12.7927 65.6951 12.0567 62.1991 12.0567C55.1141 12.0567 50.8821 16.7487 50.8821 23.6957C50.8821 30.6427 55.2531 35.2437 62.4301 35.2437C65.6041 35.2437 68.0881 34.5077 70.2961 33.4037V37.4057Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.1921 27.1929C73.1921 20.2919 77.2401 15.2769 84.1411 15.2769C90.9951 15.2769 94.9981 20.2919 94.9981 27.1929C94.9981 34.0939 90.9951 39.1999 84.1411 39.1999C77.2401 39.1999 73.1921 34.0939 73.1921 27.1929ZM77.0561 27.1929C77.0561 31.5629 79.2181 35.5199 84.1411 35.5199C89.0171 35.5199 91.1331 31.5629 91.1331 27.1929C91.1331 22.8229 89.0171 18.9579 84.1411 18.9579C79.2181 18.9579 77.0561 22.8219 77.0561 27.1929Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M119.148 38.7399H115.191V24.8459C115.191 20.7049 113.535 18.8659 109.762 18.8659C106.082 18.8659 103.552 21.3039 103.552 25.9509V38.7399H99.5951V15.7379H103.552V19.5099C105.024 16.7949 107.738 15.2769 110.821 15.2769C116.111 15.2769 119.148 18.9119 119.148 25.2599V38.7389V38.7399Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M130.139 15.7378H136.073V19.4178H130.139V38.7398H126.275V19.4178H122.548V15.7378H126.275V13.2078C126.275 8.92879 128.668 6.02979 133.589 6.02979C134.785 6.02979 135.568 6.21478 136.258 6.39778V10.0328C135.568 9.89478 134.694 9.80279 133.774 9.80279C131.336 9.80279 130.14 11.2298 130.14 13.2998V15.7378H130.139Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M146.515 38.8786C142.743 38.8786 140.35 37.0836 140.35 32.8516V6.12256H144.307V32.3916C144.307 34.4616 145.687 35.1986 147.389 35.1986C147.803 35.1986 148.078 35.1986 148.539 35.1526V38.6946C148.217 38.7866 147.526 38.8796 146.515 38.8796V38.8786Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M151.896 15.7378H155.852V29.6318C155.852 33.7718 157.508 35.6118 161.281 35.6118C164.962 35.6118 167.492 33.1738 167.492 28.5268V15.7378H171.449V38.7398H167.492V34.9678C166.02 37.6828 163.305 39.1998 160.223 39.1998C154.932 39.1998 151.896 35.5658 151.896 29.2178V15.7378Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M188.42 39.1999C179.817 39.1999 176.045 34.2319 176.045 27.1929C176.045 20.2459 179.909 15.2769 186.902 15.2769C193.986 15.2769 196.839 20.1999 196.839 27.1929V28.9869H180.047C180.6 32.8969 183.13 35.4269 188.559 35.4269C191.227 35.4269 193.481 34.9209 195.551 34.1849V37.8199C193.665 38.8319 190.767 39.1999 188.42 39.1999ZM180.001 25.5829H192.837C192.607 21.3049 190.675 18.8659 186.718 18.8659C182.531 18.8659 180.415 21.5799 180.001 25.5829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M221.081 38.7399H217.124V24.8459C217.124 20.7049 215.468 18.8659 211.695 18.8659C208.015 18.8659 205.485 21.3039 205.485 25.9509V38.7399H201.528V15.7379H205.485V19.5099C206.957 16.7949 209.671 15.2769 212.754 15.2769C218.044 15.2769 221.081 18.9119 221.081 25.2599V38.7389V38.7399Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M242.839 38.1419C241.458 38.8779 239.342 39.1999 237.226 39.1999C229.038 39.1999 225.219 34.2319 225.219 27.1929C225.219 20.2459 229.037 15.2769 237.226 15.2769C239.296 15.2769 240.907 15.5529 242.701 16.3809V20.0619C241.229 19.3719 239.665 18.9579 237.503 18.9579C231.523 18.9579 229.084 22.7299 229.084 27.1929C229.084 31.6559 231.568 35.4269 237.595 35.4269C239.942 35.4269 241.413 35.1059 242.84 34.5989V38.1419H242.839Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M258.339 39.1999C249.736 39.1999 245.964 34.2319 245.964 27.1929C245.964 20.2459 249.828 15.2769 256.821 15.2769C263.905 15.2769 266.758 20.1999 266.758 27.1929V28.9869H249.966C250.519 32.8969 253.049 35.4269 258.478 35.4269C261.146 35.4269 263.4 34.9209 265.47 34.1849V37.8199C263.584 38.8319 260.686 39.1999 258.339 39.1999ZM249.92 25.5829H262.756C262.526 21.3049 260.594 18.8659 256.637 18.8659C252.45 18.8659 250.334 21.5799 249.92 25.5829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1.16806 31.3314C0.829057 31.8834 0.444057 32.5304 0.145057 33.0394C-0.142943 33.5304 0.0120573 34.1614 0.497057 34.4604L7.29106 38.6534C7.78906 38.9604 8.44106 38.8024 8.73806 38.2984C9.00806 37.8414 9.35806 37.2534 9.74006 36.6214C12.4331 32.1774 15.1411 32.7194 20.0201 35.0384L26.7581 38.2414C27.2891 38.4944 27.9241 38.2584 28.1631 37.7204L31.3991 30.4144C31.6291 29.8944 31.4031 29.2874 30.8891 29.0454C29.4661 28.3764 26.6381 27.0414 24.1061 25.8154C14.9051 21.3604 7.12006 21.6554 1.16806 31.3314Z",
                fill: "url(#paint0_linear_818_483)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.6351 14.7276C31.9741 14.1756 32.3591 13.5286 32.6581 13.0196C32.9461 12.5286 32.7911 11.8976 32.3061 11.5986L25.5121 7.40562C25.0141 7.09862 24.3621 7.25662 24.0651 7.76062C23.7951 8.21762 23.4451 8.80561 23.0631 9.43761C20.3701 13.8816 17.6621 13.3396 12.7831 11.0206L6.04512 7.81762C5.51412 7.56462 4.87912 7.80061 4.64012 8.33861L1.40412 15.6446C1.17412 16.1646 1.40012 16.7716 1.91412 17.0136C3.33712 17.6826 6.16512 19.0176 8.69712 20.2436C17.8971 24.6986 25.6821 24.4046 31.6341 14.7276H31.6351Z",
                fill: "url(#paint1_linear_818_483)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_483",
                        x1: "31.1981",
                        y1: "40.8054",
                        x2: "10.6381",
                        y2: "28.9914",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_483",
                        x1: "1.60412",
                        y1: "5.25362",
                        x2: "22.1641",
                        y2: "17.0676",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("a9CD6", function(module, exports) {
$parcel$export(module.exports, "ConfluenceMarkBrand", function () { return $2ce451c25fbd45ca$export$c3c079c94b97bdde; });

var $7VQPk = parcelRequire("7VQPk");
const $2ce451c25fbd45ca$export$c3c079c94b97bdde = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.76706 32.3019C8.42806 32.8539 8.04306 33.5009 7.74406 34.0099C7.45606 34.5009 7.61106 35.1319 8.09606 35.4309L14.8901 39.6239C15.3881 39.9309 16.0401 39.7729 16.3371 39.2689C16.6071 38.8119 16.9571 38.2239 17.3391 37.5919C20.0321 33.1479 22.7401 33.6899 27.6191 36.0089L34.3571 39.2119C34.8881 39.4649 35.5231 39.2289 35.7621 38.6909L38.9981 31.3849C39.2281 30.8649 39.0021 30.2579 38.4881 30.0159C37.0651 29.3469 34.2371 28.0119 31.7051 26.7859C22.5051 22.3309 14.7201 22.6249 8.76806 32.3019H8.76706Z",
                fill: "url(#paint0_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M39.233 15.6978C39.572 15.1458 39.957 14.4988 40.256 13.9898C40.544 13.4988 40.389 12.8678 39.904 12.5688L33.11 8.37583C32.612 8.06883 31.96 8.22683 31.663 8.73083C31.393 9.18783 31.043 9.77583 30.661 10.4078C27.968 14.8518 25.26 14.3098 20.381 11.9908L13.643 8.78783C13.112 8.53483 12.477 8.77083 12.238 9.30883L9.00202 16.6148C8.77202 17.1348 8.99802 17.7418 9.51202 17.9838C10.935 18.6528 13.763 19.9878 16.295 21.2138C25.495 25.6688 33.28 25.3748 39.232 15.6978H39.233Z",
                fill: "url(#paint1_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_553",
                        x1: "38.7961",
                        y1: "41.7759",
                        x2: "18.2371",
                        y2: "29.9619",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_553",
                        x1: "9.20302",
                        y1: "6.22383",
                        x2: "29.763",
                        y2: "18.0378",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("aBawz", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoBrand", function () { return $0bdf50abe1266280$export$77109fd0b35bd237; });

var $7VQPk = parcelRequire("7VQPk");
const $0bdf50abe1266280$export$77109fd0b35bd237 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "684",
        height: "48",
        viewBox: "0 0 684 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.392 32.664V36.666C83.506 37.908 80.516 38.46 77.388 38.46C67.452 38.46 61.84 32.48 61.84 22.958C61.84 13.758 67.452 7.318 77.296 7.318C80.24 7.318 83.184 7.87 85.346 9.434V13.436C83.184 12.056 80.792 11.32 77.296 11.32C70.212 11.32 65.98 16.012 65.98 22.958C65.98 29.904 70.35 34.504 77.526 34.504C80.7 34.504 83.184 33.768 85.392 32.664ZM89.7077 28.478V15H93.6637V28.892C93.6637 33.032 95.3197 34.872 99.0917 34.872C102.772 34.872 105.302 32.434 105.302 27.788V15H109.258V38H105.302V34.228C103.83 36.942 101.116 38.46 98.0337 38.46C92.7437 38.46 89.7077 34.826 89.7077 28.478ZM131.104 31.744C131.104 35.562 128.62 38.46 122.456 38.46C119.006 38.46 116.2 37.678 114.452 36.758V32.572C116.43 33.722 119.742 34.826 122.64 34.826C125.676 34.826 127.24 33.584 127.24 31.79C127.24 30.042 125.906 29.03 121.536 27.972C116.43 26.73 114.268 24.752 114.268 20.98C114.268 16.978 117.35 14.54 122.594 14.54C125.584 14.54 128.298 15.276 130 16.196V20.29C127.24 18.91 124.986 18.174 122.548 18.174C119.65 18.174 118.086 19.186 118.086 20.98C118.086 22.59 119.19 23.602 123.422 24.614C128.528 25.856 131.104 27.742 131.104 31.744ZM141.148 30.87C141.148 32.894 142.344 34.274 144.782 34.274C145.702 34.274 146.576 34.09 147.266 33.952V37.77C146.576 37.954 145.794 38.138 144.598 38.138C139.676 38.138 137.284 35.24 137.284 30.962V18.68H133.558V15H137.284V10.124H141.148V15H147.266V18.68H141.148V30.87ZM161.009 38.46C154.109 38.46 150.061 33.354 150.061 26.454C150.061 19.554 154.109 14.54 161.009 14.54C167.863 14.54 171.865 19.554 171.865 26.454C171.865 33.354 167.863 38.46 161.009 38.46ZM161.009 18.22C156.087 18.22 153.925 22.084 153.925 26.454C153.925 30.824 156.087 34.78 161.009 34.78C165.885 34.78 168.001 30.824 168.001 26.454C168.001 22.084 165.885 18.22 161.009 18.22ZM196.013 25.212V38H192.057V24.108C192.057 19.968 190.401 18.128 186.629 18.128C182.949 18.128 180.419 20.566 180.419 25.212V38H176.463V15H180.419V18.772C181.891 16.058 184.605 14.54 187.687 14.54C191.597 14.54 194.265 16.518 195.415 20.152C196.703 16.61 199.785 14.54 203.603 14.54C208.755 14.54 211.607 18.036 211.607 24.522V38H207.651V25.212C207.651 20.474 205.995 18.128 202.223 18.128C198.543 18.128 196.013 20.566 196.013 25.212ZM226.409 18.128C222.223 18.128 220.107 20.842 219.693 24.844H232.527C232.297 20.566 230.365 18.128 226.409 18.128ZM235.241 37.08C233.355 38.092 230.457 38.46 228.111 38.46C219.509 38.46 215.737 33.492 215.737 26.454C215.737 19.508 219.601 14.54 226.593 14.54C233.677 14.54 236.529 19.462 236.529 26.454V28.248H219.739C220.291 32.158 222.821 34.688 228.249 34.688C230.917 34.688 233.171 34.182 235.241 33.446V37.08ZM245.104 24.43V38H241.24V15H245.104V19.048C246.438 16.334 248.738 14.402 253.246 14.678V18.542C248.186 18.036 245.104 19.554 245.104 24.43ZM284.71 29.674C284.71 34.918 281.582 38.46 274.084 38.46C268.242 38.46 265.528 37.31 263.182 36.114V31.882C265.988 33.354 270.312 34.412 274.314 34.412C278.868 34.412 280.57 32.618 280.57 29.95C280.57 27.282 278.914 25.856 273.164 24.476C266.356 22.82 263.32 20.474 263.32 15.506C263.32 10.814 266.908 7.318 273.946 7.318C278.316 7.318 281.122 8.376 283.192 9.526V13.666C280.156 11.918 276.89 11.366 273.762 11.366C269.806 11.366 267.46 12.746 267.46 15.506C267.46 17.99 269.392 19.232 274.728 20.566C281.122 22.176 284.71 24.246 284.71 29.674ZM298.868 18.128C294.682 18.128 292.566 20.842 292.152 24.844H304.986C304.756 20.566 302.824 18.128 298.868 18.128ZM307.7 37.08C305.814 38.092 302.916 38.46 300.57 38.46C291.968 38.46 288.196 33.492 288.196 26.454C288.196 19.508 292.06 14.54 299.052 14.54C306.136 14.54 308.988 19.462 308.988 26.454V28.248H292.198C292.75 32.158 295.28 34.688 300.708 34.688C303.376 34.688 305.63 34.182 307.7 33.446V37.08ZM317.563 24.43V38H313.699V15H317.563V19.048C318.897 16.334 321.197 14.402 325.705 14.678V18.542C320.645 18.036 317.563 19.554 317.563 24.43ZM340.745 38H335.455L326.531 15H330.671L338.123 34.642L345.529 15H349.669L340.745 38ZM352.359 8.928C352.359 7.18 353.509 6.168 355.119 6.168C356.729 6.168 357.879 7.18 357.879 8.928C357.879 10.676 356.729 11.688 355.119 11.688C353.509 11.688 352.359 10.676 352.359 8.928ZM353.095 38V15H357.051V38H353.095ZM379.261 33.86V37.402C377.881 38.138 375.765 38.46 373.649 38.46C365.461 38.46 361.643 33.492 361.643 26.454C361.643 19.508 365.461 14.54 373.649 14.54C375.719 14.54 377.329 14.816 379.123 15.644V19.324C377.651 18.634 376.087 18.22 373.925 18.22C367.945 18.22 365.507 21.992 365.507 26.454C365.507 30.916 367.991 34.688 374.017 34.688C376.363 34.688 377.835 34.366 379.261 33.86ZM393.069 18.128C388.883 18.128 386.767 20.842 386.353 24.844H399.187C398.957 20.566 397.025 18.128 393.069 18.128ZM401.901 37.08C400.015 38.092 397.117 38.46 394.771 38.46C386.169 38.46 382.397 33.492 382.397 26.454C382.397 19.508 386.261 14.54 393.253 14.54C400.337 14.54 403.189 19.462 403.189 26.454V28.248H386.399C386.951 32.158 389.481 34.688 394.909 34.688C397.577 34.688 399.831 34.182 401.901 33.446V37.08ZM425.336 21.486L421.196 10.262V38H417.056V7.778H424.232L431.086 25.12L433.892 33.446L436.698 25.12L443.598 7.778H450.268V38H446.128V10.584L442.586 21.486L435.916 38H431.914L425.336 21.486ZM459.486 26.5C459.486 32.02 461.694 34.78 465.788 34.78C469.33 34.78 472.504 32.526 472.504 27.42V25.58C472.504 20.474 469.606 18.22 466.248 18.22C461.786 18.22 459.486 21.164 459.486 26.5ZM472.504 38V33.86C471.032 36.896 468.272 38.46 464.73 38.46C458.612 38.46 455.53 33.262 455.53 26.5C455.53 20.014 458.75 14.54 465.19 14.54C468.548 14.54 471.124 16.058 472.504 19.048V15H476.46V38H472.504ZM501.976 24.522V38H498.02V24.108C498.02 19.968 496.364 18.128 492.592 18.128C488.912 18.128 486.382 20.566 486.382 25.212V38H482.426V15H486.382V18.772C487.854 16.058 490.568 14.54 493.65 14.54C498.94 14.54 501.976 18.174 501.976 24.522ZM510.068 26.5C510.068 32.02 512.276 34.78 516.37 34.78C519.912 34.78 523.086 32.526 523.086 27.42V25.58C523.086 20.474 520.188 18.22 516.83 18.22C512.368 18.22 510.068 21.164 510.068 26.5ZM523.086 38V33.86C521.614 36.896 518.854 38.46 515.312 38.46C509.194 38.46 506.112 33.262 506.112 26.5C506.112 20.014 509.332 14.54 515.772 14.54C519.13 14.54 521.706 16.058 523.086 19.048V15H527.042V38H523.086ZM548.51 36.16V33.86C547.038 36.896 544.278 38.46 540.736 38.46C534.664 38.46 531.628 33.262 531.628 26.5C531.628 20.014 534.802 14.54 541.196 14.54C544.554 14.54 547.13 16.058 548.51 19.048V15H552.374V35.93C552.374 42.692 549.2 47.246 540.966 47.246C537.102 47.246 534.986 46.74 532.778 46.004V42.14C535.308 42.968 537.93 43.52 540.782 43.52C546.532 43.52 548.51 40.438 548.51 36.16ZM535.492 26.5C535.492 32.02 537.7 34.78 541.794 34.78C545.336 34.78 548.51 32.526 548.51 27.42V25.58C548.51 20.474 545.612 18.22 542.254 18.22C537.792 18.22 535.492 21.164 535.492 26.5ZM567.636 18.128C563.45 18.128 561.334 20.842 560.92 24.844H573.754C573.524 20.566 571.592 18.128 567.636 18.128ZM576.468 37.08C574.582 38.092 571.684 38.46 569.338 38.46C560.736 38.46 556.964 33.492 556.964 26.454C556.964 19.508 560.828 14.54 567.82 14.54C574.904 14.54 577.756 19.462 577.756 26.454V28.248H560.966C561.518 32.158 564.048 34.688 569.476 34.688C572.144 34.688 574.398 34.182 576.468 33.446V37.08ZM602.017 25.212V38H598.061V24.108C598.061 19.968 596.405 18.128 592.633 18.128C588.953 18.128 586.423 20.566 586.423 25.212V38H582.467V15H586.423V18.772C587.895 16.058 590.609 14.54 593.691 14.54C597.601 14.54 600.269 16.518 601.419 20.152C602.707 16.61 605.789 14.54 609.607 14.54C614.759 14.54 617.611 18.036 617.611 24.522V38H613.655V25.212C613.655 20.474 611.999 18.128 608.227 18.128C604.547 18.128 602.017 20.566 602.017 25.212ZM632.413 18.128C628.227 18.128 626.111 20.842 625.697 24.844H638.531C638.301 20.566 636.369 18.128 632.413 18.128ZM641.245 37.08C639.359 38.092 636.461 38.46 634.115 38.46C625.513 38.46 621.741 33.492 621.741 26.454C621.741 19.508 625.605 14.54 632.597 14.54C639.681 14.54 642.533 19.462 642.533 26.454V28.248H625.743C626.295 32.158 628.825 34.688 634.253 34.688C636.921 34.688 639.175 34.182 641.245 33.446V37.08ZM666.794 24.522V38H662.838V24.108C662.838 19.968 661.182 18.128 657.41 18.128C653.73 18.128 651.2 20.566 651.2 25.212V38H647.244V15H651.2V18.772C652.672 16.058 655.386 14.54 658.468 14.54C663.758 14.54 666.794 18.174 666.794 24.522ZM677.784 30.87C677.784 32.894 678.98 34.274 681.418 34.274C682.338 34.274 683.212 34.09 683.902 33.952V37.77C683.212 37.954 682.43 38.138 681.234 38.138C676.312 38.138 673.92 35.24 673.92 30.962V18.68H670.194V15H673.92V10.124H677.784V15H683.902V18.68H677.784V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_793_39516)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                        fill: "#FFC716"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                        clipPath: "url(#clip1_793_39516)",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M34.4932 35.6143C31.9074 37.7304 28.602 39 25 39C21.3982 39 18.0928 37.7305 15.507 35.6145L21.2254 29.8961C22.3145 30.5948 23.61 31 25 31C26.3902 31 27.6857 30.5948 28.7749 29.896L34.4932 35.6143Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M36.6145 33.493C38.7305 30.9072 40 27.6018 40 24C40 20.3982 38.7305 17.0928 36.6145 14.507L30.8961 20.2254C31.5948 21.3145 32 22.61 32 24C32 25.39 31.5948 26.6855 30.8961 27.7746L36.6145 33.493Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M34.4932 12.3857L28.7749 18.104C27.6857 17.4052 26.3902 17 25 17C23.61 17 22.3145 17.4052 21.2254 18.1039L15.507 12.3855C18.0928 10.2695 21.3982 9 25 9C28.602 9 31.9074 10.2696 34.4932 12.3857Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M13.3857 14.5068C11.2696 17.0926 10 20.398 10 24C10 27.602 11.2696 30.9074 13.3857 33.4932L19.104 27.7749C18.4052 26.6857 18 25.3902 18 24C18 22.6098 18.4052 21.3143 19.104 20.2251L13.3857 14.5068Z",
                                fill: "#101214"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M11.7588 38.957H24.2588L21.2588 29.957L11.7588 38.957Z",
                        fill: "#101214"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_793_39516",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip1_793_39516",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: "white",
                            transform: "translate(1)"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("eCQc3", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementMarkBrand", function () { return $e32d5fec259868ca$export$e68ebff4d1a373dc; });

var $7VQPk = parcelRequire("7VQPk");
const $e32d5fec259868ca$export$e68ebff4d1a373dc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_793_43052)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                        fill: "#FFC716"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                        clipPath: "url(#clip1_793_43052)",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M34.4932 35.6143C31.9074 37.7304 28.602 39 25 39C21.3982 39 18.0928 37.7305 15.507 35.6145L21.2254 29.8961C22.3145 30.5948 23.61 31 25 31C26.3902 31 27.6857 30.5948 28.7749 29.896L34.4932 35.6143Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M36.6145 33.493C38.7305 30.9072 40 27.6018 40 24C40 20.3982 38.7305 17.0928 36.6145 14.507L30.8961 20.2254C31.5948 21.3145 32 22.61 32 24C32 25.39 31.5948 26.6855 30.8961 27.7746L36.6145 33.493Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M34.4932 12.3857L28.7749 18.104C27.6857 17.4052 26.3902 17 25 17C23.61 17 22.3145 17.4052 21.2254 18.1039L15.507 12.3855C18.0928 10.2695 21.3982 9 25 9C28.602 9 31.9074 10.2696 34.4932 12.3857Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M13.3857 14.5068C11.2696 17.0926 10 20.398 10 24C10 27.602 11.2696 30.9074 13.3857 33.4932L19.104 27.7749C18.4052 26.6857 18 25.3902 18 24C18 22.6098 18.4052 21.3143 19.104 20.2251L13.3857 14.5068Z",
                                fill: "#101214"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M11.7588 38.957H24.2588L21.2588 29.957L11.7588 38.957Z",
                        fill: "#101214"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_793_43052",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip1_793_43052",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: "white",
                            transform: "translate(1)"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("4IHFR", function(module, exports) {
$parcel$export(module.exports, "HalpLogoBrand", function () { return $5254d3c1fdd35f3d$export$528edb2ffd8d250d; });

var $7VQPk = parcelRequire("7VQPk");
const $5254d3c1fdd35f3d$export$528edb2ffd8d250d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "95",
        height: "32",
        viewBox: "0 0 95 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.8924 1.68506V22.1372H48.0904V13.2927H37.3177V22.1372H34.5157V1.68506H37.3177V10.6181H48.0904V1.68506H50.8924Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M65.928 19.3352C64.9339 21.3907 63.0659 22.4485 60.6673 22.4485C56.528 22.4485 54.4407 18.9319 54.4407 14.3539C54.4407 9.96704 56.62 6.2594 60.9786 6.2594C63.2534 6.2594 64.994 7.28891 65.9315 9.31254V6.57073H68.6097V22.1372H65.9315L65.928 19.3352ZM61.3854 19.9579C63.7805 19.9579 65.928 18.4331 65.928 14.9766V13.7313C65.928 10.2784 63.968 8.75003 61.6826 8.75003C58.6613 8.75003 57.1047 10.7454 57.1047 14.3539C57.1047 18.0899 58.6118 19.9579 61.3854 19.9579Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.8245 22.2327C74.2738 22.2327 72.6534 21.0157 72.6534 18.1536V0.0646973H75.3316V17.8423C75.3316 19.2574 76.2656 19.7421 77.4189 19.7421C77.6787 19.7467 77.9386 19.736 78.1972 19.7103V22.1054C77.7467 22.2042 77.2856 22.247 76.8245 22.2327Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.458 19.3989V28.2081H80.7799V6.57073H83.458V9.37269C84.4522 7.32075 86.3201 6.2594 88.7188 6.2594C92.858 6.2594 94.9454 9.79723 94.9454 14.3539C94.9454 18.7444 92.7661 22.4485 88.4075 22.4485C86.1326 22.4485 84.392 21.4225 83.458 19.3989ZM88.0006 8.75003C85.6055 8.75003 83.458 10.2784 83.458 13.7313V14.9766C83.458 18.4331 85.418 19.9579 87.7034 19.9579C90.7247 19.9579 92.2814 17.9661 92.2814 14.3539C92.2672 10.618 90.7743 8.75003 88.0006 8.75003Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2901 3.87848C21.8726 5.46206 22.9501 7.47929 23.3863 9.67515C23.8225 11.871 23.5979 14.1469 22.7408 16.2151C21.8837 18.2833 20.4327 20.051 18.5711 21.2946C16.7095 22.5382 14.521 23.202 12.2822 23.202C10.0435 23.202 7.85496 22.5382 5.99339 21.2946C4.13181 20.051 2.68076 18.2833 1.82368 16.2151C0.96659 14.1469 0.741953 11.871 1.17816 9.67515C1.61437 7.47929 2.69184 5.46206 4.27436 3.87848C5.32572 2.82642 6.57408 1.99184 7.9481 1.42243C9.32213 0.853016 10.7949 0.559937 12.2822 0.559937C13.7696 0.559937 15.2423 0.853016 16.6164 1.42243C17.9904 1.99184 19.2388 2.82642 20.2901 3.87848ZM6.19186 17.9909L6.16002 17.959L6.18125 17.9803L6.19186 17.9909ZM15.3124 7.10144L17.4351 4.97874C15.9436 3.86422 14.1317 3.262 12.2699 3.262C10.408 3.262 8.59606 3.86422 7.10462 4.97874L9.22732 7.10144L7.48671 8.84205L5.36401 6.71935C4.24949 8.21079 3.64727 10.0227 3.64727 11.8846C3.64727 13.7464 4.24949 15.5584 5.36401 17.0498L7.48671 14.9271L9.22732 16.6748L7.10462 18.7975C8.59606 19.912 10.408 20.5142 12.2699 20.5142C14.1317 20.5142 15.9436 19.912 17.4351 18.7975L15.3124 16.6748L17.053 14.9271L19.1757 17.0498C20.2902 15.5584 20.8924 13.7464 20.8924 11.8846C20.8924 10.0227 20.2902 8.21079 19.1757 6.71935L17.053 8.84205L15.3124 7.10144Z",
                fill: "url(#paint0_radial_1486_1400)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2805 6.21692C11.161 6.21692 10.0666 6.5489 9.1357 7.17089C8.20483 7.79288 7.47931 8.67693 7.05088 9.71125C6.62245 10.7456 6.51035 11.8837 6.72876 12.9818C6.94718 14.0798 7.48629 15.0884 8.27793 15.88C9.06957 16.6717 10.0782 17.2108 11.1762 17.4292C12.2742 17.6476 13.4124 17.5355 14.4467 17.1071C15.481 16.6787 16.3651 15.9531 16.9871 15.0223C17.6091 14.0914 17.941 12.997 17.941 11.8774C17.941 10.3762 17.3447 8.9364 16.2831 7.87485C15.2216 6.81329 13.7818 6.21692 12.2805 6.21692ZM12.2805 15.0615C11.6508 15.0615 11.0352 14.8747 10.5116 14.5249C9.98795 14.175 9.57984 13.6777 9.33885 13.0959C9.09786 12.5141 9.0348 11.8739 9.15766 11.2563C9.28051 10.6386 9.58377 10.0713 10.0291 9.62598C10.4744 9.18069 11.0417 8.87744 11.6593 8.75458C12.277 8.63172 12.9172 8.69477 13.499 8.93577C14.0808 9.17676 14.5781 9.58487 14.928 10.1085C15.2778 10.6321 15.4646 11.2477 15.4646 11.8774C15.465 12.2959 15.383 12.7103 15.2232 13.097C15.0634 13.4837 14.8289 13.8351 14.5332 14.1312C14.2375 14.4272 13.8864 14.6621 13.4998 14.8223C13.1133 14.9825 12.699 15.065 12.2805 15.065V15.0615Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("radialGradient", {
                    id: "paint0_radial_1486_1400",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(12.2805 11.8775) scale(11.321 11.321)",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.43",
                            stopColor: "#0052CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.84",
                            stopColor: "#1B75F0"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#2684FF"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("1OyVz", function(module, exports) {
$parcel$export(module.exports, "JiraMarkBrand", function () { return $ac492e84be2f5dcc$export$2c53bf5b8775580d; });

var $7VQPk = parcelRequire("7VQPk");
const $ac492e84be2f5dcc$export$2c53bf5b8775580d = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.202 7.22998H22.124C22.124 11.736 25.777 15.388 30.282 15.388H33.611V18.601C33.611 23.107 37.264 26.759 41.769 26.759V8.79798C41.769 7.93198 41.067 7.22998 40.201 7.22998H40.202Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.255 16.2358H13.177C13.177 20.7418 16.83 24.3938 21.335 24.3938H24.664V27.6068C24.664 32.1128 28.317 35.7648 32.822 35.7648V17.8038C32.822 16.9378 32.12 16.2358 31.254 16.2358H31.255Z",
                fill: "url(#paint0_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.308 25.2412H4.22998C4.22998 29.7472 7.88298 33.3992 12.388 33.3992H15.717V36.6122C15.717 41.1182 19.37 44.7702 23.875 44.7702V26.8092C23.875 25.9432 23.173 25.2412 22.307 25.2412H22.308Z",
                fill: "url(#paint1_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_567",
                        x1: "32.439",
                        y1: "16.2658",
                        x2: "24.749",
                        y2: "24.1958",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_567",
                        x1: "24.003",
                        y1: "25.3252",
                        x2: "15.112",
                        y2: "33.9752",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("a0AEy", function(module, exports) {
$parcel$export(module.exports, "JiraAlignMarkBrand", function () { return $cd996cc87b3f94c2$export$3a24b449db907a8d; });

var $7VQPk = parcelRequire("7VQPk");
const $cd996cc87b3f94c2$export$3a24b449db907a8d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.71802 9.71777C9.71802 15.1008 14.101 19.4648 19.479 19.4648H28.52V28.5348H38.281V11.2608C38.281 10.4088 37.591 9.71777 36.74 9.71777H9.71802Z",
                fill: "url(#paint0_linear_818_552)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.282 38.2818C38.282 32.8988 33.899 28.5348 28.521 28.5348H19.48V19.4648H9.71802V36.7388C9.71802 37.5908 10.408 38.2818 11.259 38.2818H38.282Z",
                fill: "url(#paint1_linear_818_552)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_552",
                        x1: "21.692",
                        y1: "31.0018",
                        x2: "23.912",
                        y2: "19.5788",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.15",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.522",
                                stopColor: "#0B63DE"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_552",
                        x1: "26.308",
                        y1: "16.9978",
                        x2: "24.088",
                        y2: "28.4208",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.15",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.522",
                                stopColor: "#0B63DE"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("cH95H", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoBrand", function () { return $d7cd8014b1bfee73$export$dbd49e0788c3653b; });

var $7VQPk = parcelRequire("7VQPk");
const $d7cd8014b1bfee73$export$dbd49e0788c3653b = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "475",
        height: "48",
        viewBox: "0 0 475 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M54.471 8.479H58.612V29.503C58.612 35.069 56.174 38.888 50.469 38.888C48.307 38.888 46.651 38.521 45.5 38.107V34.104C46.742 34.61 48.261 34.886 49.778 34.886C53.275 34.886 54.47 32.77 54.47 29.78V8.479H54.471Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.155 6.86816C67.765 6.86816 68.915 7.88116 68.915 9.62916C68.915 11.3772 67.766 12.3892 66.155 12.3892C64.544 12.3892 63.394 11.3772 63.394 9.62916C63.394 7.88116 64.544 6.86816 66.155 6.86816ZM64.131 15.7012H68.088V38.7042H64.131V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M77.93 38.7038H74.066V15.7008H77.93V19.7498C79.264 17.0348 81.565 15.1038 86.074 15.3798V19.2438C81.013 18.7378 77.93 20.2558 77.93 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M104.612 34.5627C103.14 37.5987 100.38 39.1637 96.838 39.1637C90.719 39.1637 87.637 33.9657 87.637 27.2027C87.637 20.7157 90.857 15.2407 97.298 15.2407C100.656 15.2407 103.233 16.7597 104.612 19.7497V15.7007H108.569V38.7037H104.612V34.5627ZM97.895 35.4827C101.438 35.4827 104.612 33.2287 104.612 28.1227V26.2817C104.612 21.1757 101.714 18.9217 98.355 18.9217C93.893 18.9217 91.592 21.8657 91.592 27.2027C91.592 32.7237 93.8 35.4827 97.895 35.4827Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M133.867 28.812H127.841V38.704H123.7V8.479H133.867C141.412 8.479 145.093 12.343 145.093 18.554C145.093 25.133 141.412 28.813 133.867 28.813V28.812ZM140.814 18.645C140.814 14.965 138.744 12.435 133.407 12.435H127.841V24.856H133.407C138.744 25.041 140.814 22.51 140.814 18.645Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M152.587 38.7038H148.723V15.7008H152.587V19.7498C153.921 17.0348 156.222 15.1038 160.731 15.3798V19.2438C155.67 18.7378 152.587 20.2558 152.587 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M162.293 27.1567C162.293 20.2557 166.341 15.2407 173.242 15.2407C180.096 15.2407 184.099 20.2557 184.099 27.1567C184.099 34.0577 180.096 39.1637 173.242 39.1637C166.341 39.1637 162.293 34.0577 162.293 27.1567ZM166.157 27.1567C166.157 31.5267 168.319 35.4827 173.242 35.4827C178.118 35.4827 180.234 31.5267 180.234 27.1567C180.234 22.7867 178.118 18.9217 173.242 18.9217C168.319 18.9217 166.157 22.7857 166.157 27.1567Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M204.292 34.5629C202.82 37.5989 200.06 39.1639 196.518 39.1639C190.399 39.1639 187.317 33.9659 187.317 27.2029C187.317 20.7159 190.537 15.2409 196.978 15.2409C200.336 15.2409 202.913 16.7599 204.292 19.7499V6.08594H208.249V38.7039H204.292V34.5629ZM197.575 35.4829C201.118 35.4829 204.292 33.2289 204.292 28.1229V26.2819C204.292 21.1759 201.394 18.9219 198.035 18.9219C193.573 18.9219 191.272 21.8659 191.272 27.2029C191.272 32.7239 193.48 35.4829 197.575 35.4829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M213.766 15.7012H217.722V29.5952C217.722 33.7362 219.378 35.5762 223.151 35.5762C226.832 35.5762 229.362 33.1382 229.362 28.4912V15.7012H233.318V38.7042H229.362V34.9322C227.89 37.6462 225.175 39.1642 222.093 39.1642C216.802 39.1642 213.766 35.5292 213.766 29.1812V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M255.537 38.1057C254.156 38.8407 252.04 39.1637 249.924 39.1637C241.736 39.1637 237.917 34.1947 237.917 27.1567C237.917 20.2097 241.735 15.2407 249.924 15.2407C251.994 15.2407 253.605 15.5167 255.399 16.3447V20.0257C253.927 19.3357 252.363 18.9217 250.201 18.9217C244.221 18.9217 241.782 22.6937 241.782 27.1567C241.782 31.6197 244.266 35.3907 250.293 35.3907C252.64 35.3907 254.111 35.0687 255.538 34.5627V38.1057H255.537Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M269.151 34.9777C270.071 34.9777 270.945 34.7937 271.635 34.6557V38.4737C270.945 38.6587 270.162 38.8417 268.966 38.8417C264.044 38.8417 261.652 35.9437 261.652 31.6647V19.3817H257.925V15.7007H261.652V10.8247H265.516V15.7007H271.635V19.3817H265.516V31.5727C265.516 33.5967 266.712 34.9767 269.151 34.9767V34.9777Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M285.618 8.479H296.752C306.551 8.479 311.289 14.598 311.289 23.661C311.289 32.816 306.505 38.705 296.752 38.705H285.618V8.479ZM289.759 12.436V34.748H296.798C303.698 34.748 307.149 31.113 307.149 23.799C307.149 16.438 303.883 12.436 296.568 12.436H289.759Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M317.679 6.86816C319.289 6.86816 320.439 7.88116 320.439 9.62916C320.439 11.3772 319.29 12.3892 317.679 12.3892C316.068 12.3892 314.918 11.3772 314.918 9.62916C314.918 7.88116 316.068 6.86816 317.679 6.86816ZM315.655 15.7012H319.612V38.7042H315.655V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M332.813 39.1637C329.363 39.1637 326.556 38.3817 324.808 37.4617V33.2747C326.787 34.4247 330.099 35.5287 332.997 35.5287C336.033 35.5287 337.598 34.2877 337.598 32.4927C337.598 30.7447 336.263 29.7327 331.893 28.6747C326.787 27.4327 324.624 25.4537 324.624 21.6827C324.624 17.6797 327.706 15.2417 332.951 15.2417C335.941 15.2417 338.655 15.9777 340.357 16.8977V20.9927C337.597 19.6127 335.342 18.8767 332.905 18.8767C330.007 18.8767 328.442 19.8887 328.442 21.6837C328.442 23.2927 329.546 24.3057 333.779 25.3177C338.885 26.5597 341.462 28.4467 341.462 32.4487C341.462 36.2667 338.978 39.1657 332.813 39.1657V39.1637Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M362.254 38.1057C360.873 38.8407 358.757 39.1637 356.641 39.1637C348.453 39.1637 344.634 34.1947 344.634 27.1567C344.634 20.2097 348.452 15.2407 356.641 15.2407C358.711 15.2407 360.322 15.5167 362.116 16.3447V20.0257C360.644 19.3357 359.08 18.9217 356.918 18.9217C350.938 18.9217 348.499 22.6937 348.499 27.1567C348.499 31.6197 350.983 35.3907 357.01 35.3907C359.357 35.3907 360.828 35.0687 362.255 34.5627V38.1057H362.254Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M365.379 27.1567C365.379 20.2557 369.427 15.2407 376.328 15.2407C383.182 15.2407 387.185 20.2557 387.185 27.1567C387.185 34.0577 383.182 39.1637 376.328 39.1637C369.427 39.1637 365.379 34.0577 365.379 27.1567ZM369.243 27.1567C369.243 31.5267 371.405 35.4827 376.328 35.4827C381.204 35.4827 383.32 31.5267 383.32 27.1567C383.32 22.7867 381.204 18.9217 376.328 18.9217C371.405 18.9217 369.243 22.7857 369.243 27.1567Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M397.211 38.7042L388.286 15.7012H392.427L399.88 35.3462L407.286 15.7012H411.427L402.502 38.7042H397.211Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M424.905 39.1637C416.302 39.1637 412.53 34.1947 412.53 27.1567C412.53 20.2097 416.394 15.2407 423.387 15.2407C430.471 15.2407 433.324 20.1637 433.324 27.1567V28.9507H416.532C417.085 32.8607 419.615 35.3907 425.044 35.3907C427.712 35.3907 429.966 34.8847 432.036 34.1487V37.7837C430.15 38.7957 427.252 39.1637 424.905 39.1637ZM416.486 25.5467H429.322C429.092 21.2687 427.16 18.8297 423.203 18.8297C419.016 18.8297 416.9 21.5437 416.486 25.5467Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M441.877 38.7038H438.013V15.7008H441.877V19.7498C443.211 17.0348 445.512 15.1038 450.021 15.3798V19.2438C444.96 18.7378 441.877 20.2558 441.877 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M459.173 37.2312L450.846 15.7012H455.078L462.439 35.3912L469.799 15.7012H474.031L465.336 37.9682C462.76 44.5472 461.288 47.9512 455.445 47.9512C453.466 47.9512 452.363 47.7672 451.213 47.3062V43.9022C452.547 44.3162 454.066 44.4552 455.215 44.4552C458.436 44.4552 459.861 42.2462 461.748 37.2312H459.172H459.173Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.998 22.8301C20.998 22.8301 21.027 23.4001 21.027 24.1871C21.027 27.1191 18.65 29.4961 15.718 29.4961C12.786 29.4961 10.409 27.1191 10.409 24.1871C10.409 21.2551 12.786 18.8781 15.718 18.8781C16.505 18.8781 16.988 18.9071 16.988 18.9071V8.53107C16.569 8.49707 16.146 8.47607 15.718 8.47607C7.037 8.47507 0 15.5121 0 24.1931C0 32.8741 7.037 39.9101 15.717 39.9101C24.397 39.9101 31.434 32.8731 31.434 24.1931C31.434 23.6931 31.425 23.3461 31.384 22.8311H20.997L20.998 22.8301Z",
                fill: "url(#paint0_linear_818_529)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.385 6.92496C23.747 8.10396 28.109 8.10396 32.471 6.92496C32.786 6.83996 33.069 7.12296 32.984 7.43796C31.805 11.8 31.805 16.162 32.984 20.524C33.069 20.839 32.786 21.122 32.471 21.037C28.109 19.858 23.747 19.858 19.385 21.037C19.07 21.122 18.787 20.839 18.872 20.524C20.051 16.162 20.051 11.8 18.872 7.43796C18.787 7.12296 19.07 6.83996 19.385 6.92496Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_529",
                    x1: "13.767",
                    y1: "26.1431",
                    x2: "24.658",
                    y2: "15.2531",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#1D7AFC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0055CC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("5xYFE", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryMarkBrand", function () { return $e3d82782a56c17ec$export$1b2ff0e46e1f1569; });

var $7VQPk = parcelRequire("7VQPk");
const $e3d82782a56c17ec$export$1b2ff0e46e1f1569 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.498 24.4199C28.498 24.4199 28.527 24.9899 28.527 25.7769C28.527 28.7089 26.15 31.0859 23.218 31.0859C20.286 31.0859 17.909 28.7089 17.909 25.7769C17.909 22.8449 20.286 20.4679 23.218 20.4679C24.005 20.4679 24.488 20.4969 24.488 20.4969V10.1209C24.069 10.0869 23.646 10.0659 23.218 10.0659C14.538 10.0659 7.50098 17.1029 7.50098 25.7829C7.50098 34.4629 14.538 41.4999 23.218 41.4999C31.898 41.4999 38.935 34.4629 38.935 25.7829C38.935 25.2829 38.926 24.9359 38.885 24.4209H28.498V24.4199Z",
                fill: "url(#paint0_linear_818_557)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.885 8.5148C31.247 9.6938 35.609 9.6938 39.971 8.5148C40.286 8.4298 40.569 8.7128 40.484 9.0278C39.305 13.3898 39.305 17.7518 40.484 22.1138C40.569 22.4288 40.286 22.7118 39.971 22.6268C35.609 21.4478 31.247 21.4478 26.885 22.6268C26.57 22.7118 26.287 22.4288 26.372 22.1138C27.551 17.7518 27.551 13.3898 26.372 9.0278C26.287 8.7128 26.57 8.4298 26.885 8.5148Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_557",
                    x1: "21.267",
                    y1: "27.7329",
                    x2: "32.158",
                    y2: "16.8419",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#1D7AFC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0055CC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("bEzzt", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoBrand", function () { return $0fa0cae32ebe1442$export$962842ccd0a7c0b9; });

var $7VQPk = parcelRequire("7VQPk");
const $0fa0cae32ebe1442$export$962842ccd0a7c0b9 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "542",
        height: "48",
        viewBox: "0 0 542 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M53.655 8.47705H57.796V29.5021C57.796 35.0681 55.358 38.8871 49.653 38.8871C47.491 38.8871 45.835 38.519 44.684 38.105V34.1031C45.926 34.6091 47.445 34.885 48.962 34.885C52.459 34.885 53.654 32.769 53.654 29.779V8.47705H53.655Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M65.3379 6.86719C66.9479 6.86719 68.0979 7.87919 68.0979 9.62819C68.0979 11.3772 66.9489 12.3882 65.3379 12.3882C63.7269 12.3882 62.5769 11.3762 62.5769 9.62819C62.5769 7.88019 63.7269 6.86719 65.3379 6.86719ZM63.3139 15.7002H67.2709V38.7032H63.3139V15.7002Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M77.114 38.7031H73.25V15.7001H77.114V19.7491C78.448 17.0341 80.749 15.1031 85.258 15.3781V19.2421C80.197 18.7361 77.114 20.2551 77.114 25.1311V38.7031Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M103.795 34.5622C102.323 37.5982 99.563 39.1632 96.021 39.1632C89.902 39.1632 86.8199 33.9642 86.8199 27.2012C86.8199 20.7152 90.0399 15.2402 96.4809 15.2402C99.8389 15.2402 102.416 16.7592 103.795 19.7492V15.7002H107.752V38.7032H103.795V34.5622ZM97.0779 35.4822C100.621 35.4822 103.795 33.2282 103.795 28.1222V26.2812C103.795 21.1752 100.897 18.9212 97.5379 18.9212C93.0759 18.9212 90.7749 21.8652 90.7749 27.2012C90.7749 32.7222 92.9829 35.4822 97.0779 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M131.164 39.1631C125.322 39.1631 122.607 38.0131 120.261 36.8161V32.5841C123.067 34.0571 127.392 35.1141 131.394 35.1141C135.949 35.1141 137.65 33.3201 137.65 30.6521C137.65 27.9841 135.994 26.5571 130.243 25.1771C123.434 23.5211 120.398 21.1741 120.398 16.2051C120.398 11.5131 123.986 8.01709 131.024 8.01709C135.395 8.01709 138.202 9.07509 140.272 10.2251V14.3661C137.235 12.6181 133.969 12.0651 130.841 12.0651C126.884 12.0651 124.538 13.4461 124.538 16.2061C124.538 18.6901 126.47 19.9331 131.807 21.2671C138.202 22.8771 141.789 24.9481 141.789 30.3761C141.789 35.6201 138.66 39.1631 131.162 39.1631H131.164Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M157.66 39.1632C149.056 39.1632 145.285 34.1942 145.285 27.1552C145.285 20.2092 149.148 15.2402 156.142 15.2402C163.226 15.2402 166.078 20.1632 166.078 27.1552V28.9502H149.287C149.84 32.8602 152.369 35.3902 157.799 35.3902C160.467 35.3902 162.721 34.8842 164.791 34.1482V37.7832C162.904 38.7952 160.006 39.1632 157.66 39.1632ZM149.24 25.5452H162.076C161.846 21.2672 159.914 18.8292 155.957 18.8292C151.771 18.8292 149.654 21.5432 149.24 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M174.633 38.7031H170.768V15.7001H174.633V19.7491C175.967 17.0341 178.268 15.1031 182.776 15.3781V19.2421C177.715 18.7361 174.633 20.2551 174.633 25.1311V38.7031Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M192.525 38.7032L183.601 15.7002H187.742L195.195 35.3452L202.601 15.7002H206.742L197.816 38.7032H192.525Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M212.168 6.86719C213.777 6.86719 214.928 7.87919 214.928 9.62819C214.928 11.3772 213.778 12.3882 212.168 12.3882C210.558 12.3882 209.406 11.3762 209.406 9.62819C209.406 7.88019 210.556 6.86719 212.168 6.86719ZM210.143 15.7002H214.1V38.7032H210.143V15.7002Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M236.318 38.1042C234.937 38.8402 232.822 39.1632 230.705 39.1632C222.517 39.1632 218.699 34.1942 218.699 27.1552C218.699 20.2092 222.517 15.2402 230.705 15.2402C232.775 15.2402 234.387 15.5162 236.18 16.3442V20.0242C234.709 19.3352 233.145 18.9202 230.983 18.9202C225.003 18.9202 222.563 22.6922 222.563 27.1542C222.563 31.6162 225.047 35.3892 231.075 35.3892C233.421 35.3892 234.893 35.0672 236.319 34.5612V38.1032L236.318 38.1042Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M251.818 39.1632C243.216 39.1632 239.443 34.1942 239.443 27.1552C239.443 20.2092 243.308 15.2402 250.3 15.2402C257.384 15.2402 260.238 20.1632 260.238 27.1552V28.9502H243.445C243.998 32.8602 246.529 35.3902 251.957 35.3902C254.625 35.3902 256.879 34.8842 258.949 34.1482V37.7832C257.064 38.7952 254.166 39.1632 251.818 39.1632ZM243.4 25.5452H256.236C256.006 21.2672 254.074 18.8292 250.117 18.8292C245.929 18.8292 243.814 21.5432 243.4 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M278.223 10.9621V38.703H274.082V8.47705H281.258L288.113 25.821L290.92 34.148L293.727 25.821L300.627 8.47705H307.297V38.703H303.156V11.2841L299.615 22.1861L292.943 38.703H288.941L282.363 22.1861L278.222 10.9611L278.223 10.9621Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M329.514 34.5622C328.041 37.5982 325.282 39.1632 321.739 39.1632C315.62 39.1632 312.538 33.9642 312.538 27.2012C312.538 20.7152 315.759 15.2402 322.2 15.2402C325.557 15.2402 328.134 16.7592 329.514 19.7492V15.7002H333.471V38.7032H329.514V34.5622ZM322.797 35.4822C326.34 35.4822 329.514 33.2282 329.514 28.1222V26.2812C329.514 21.1752 326.616 18.9212 323.256 18.9212C318.795 18.9212 316.494 21.8652 316.494 27.2012C316.494 32.7222 318.701 35.4822 322.797 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M359 38.7032H355.043V24.8092C355.043 20.6682 353.387 18.8292 349.615 18.8292C345.935 18.8292 343.404 21.2672 343.404 25.9132V38.7032H339.447V15.7002H343.404V19.4722C344.877 16.7582 347.59 15.2402 350.674 15.2402C355.963 15.2402 359 18.8752 359 25.2232V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M380.113 34.5622C378.64 37.5982 375.881 39.1632 372.338 39.1632C366.219 39.1632 363.137 33.9642 363.137 27.2012C363.137 20.7152 366.358 15.2402 372.799 15.2402C376.156 15.2402 378.733 16.7592 380.113 19.7492V15.7002H384.07V38.7032H380.113V34.5622ZM373.396 35.4822C376.939 35.4822 380.113 33.2282 380.113 28.1222V26.2812C380.113 21.1752 377.215 18.9212 373.855 18.9212C369.394 18.9212 367.093 21.8652 367.093 27.2012C367.093 32.7222 369.3 35.4822 373.396 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M405.551 34.5622C404.078 37.5982 401.319 39.1632 397.776 39.1632C391.704 39.1632 388.667 33.9642 388.667 27.2012C388.667 20.7152 391.841 15.2402 398.237 15.2402C401.594 15.2402 404.171 16.7592 405.551 19.7492V15.7002H409.414V36.6332C409.414 43.3962 406.24 47.9502 398.006 47.9502C394.141 47.9502 392.026 47.4442 389.817 46.7082V42.8442C392.348 43.6722 394.969 44.2242 397.823 44.2242C403.573 44.2242 405.552 41.1422 405.552 36.8632V34.5632L405.551 34.5622ZM398.834 35.4822C402.375 35.4822 405.551 33.2282 405.551 28.1222V26.2812C405.551 21.1752 402.653 18.9212 399.293 18.9212C394.83 18.9212 392.531 21.8652 392.531 27.2012C392.531 32.7222 394.738 35.4822 398.834 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M426.389 39.1632C417.785 39.1632 414.014 34.1942 414.014 27.1552C414.014 20.2092 417.877 15.2402 424.871 15.2402C431.955 15.2402 434.807 20.1632 434.807 27.1552V28.9502H418.016C418.569 32.8602 421.098 35.3902 426.528 35.3902C429.196 35.3902 431.45 34.8842 433.52 34.1482V37.7832C431.633 38.7952 428.735 39.1632 426.389 39.1632ZM417.969 25.5452H430.805C430.575 21.2672 428.643 18.8292 424.686 18.8292C420.5 18.8292 418.383 21.5432 417.969 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M459.049 38.7032H455.092V24.8092C455.092 20.6682 453.436 18.8292 449.662 18.8292C445.982 18.8292 443.453 21.2672 443.453 25.9132V38.7032H439.496V15.7002H443.453V19.4722C444.924 16.7582 447.639 15.2402 450.721 15.2402C454.631 15.2402 457.299 17.2192 458.45 20.8522C459.739 17.3102 462.821 15.2402 466.639 15.2402C471.791 15.2402 474.645 18.7362 474.645 25.2232V38.7022H470.688V25.9122C470.688 21.1742 469.032 18.8282 465.258 18.8282C461.578 18.8282 459.049 21.2662 459.049 25.9122V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M491.154 39.1632C482.552 39.1632 478.779 34.1942 478.779 27.1552C478.779 20.2092 482.644 15.2402 489.636 15.2402C496.72 15.2402 499.574 20.1632 499.574 27.1552V28.9502H482.781C483.334 32.8602 485.865 35.3902 491.293 35.3902C493.961 35.3902 496.215 34.8842 498.285 34.1482V37.7832C496.4 38.7952 493.502 39.1632 491.154 39.1632ZM482.736 25.5452H495.572C495.342 21.2672 493.41 18.8292 489.453 18.8292C485.265 18.8292 483.15 21.5432 482.736 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M523.816 38.7032H519.859V24.8092C519.859 20.6682 518.203 18.8292 514.429 18.8292C510.749 18.8292 508.22 21.2672 508.22 25.9132V38.7032H504.263V15.7002H508.22V19.4722C509.691 16.7582 512.406 15.2402 515.488 15.2402C520.779 15.2402 523.816 18.8752 523.816 25.2232V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M538.541 34.9763C539.461 34.9763 540.336 34.7913 541.025 34.6543V38.4723C540.336 38.6573 539.552 38.8403 538.357 38.8403C533.435 38.8403 531.043 35.9423 531.043 31.6633V19.3803H527.316V15.6993H531.043V10.8223H534.906V15.6993H541.025V19.3803H534.906V31.5713C534.906 33.5953 536.103 34.9753 538.541 34.9753V34.9763Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.7379 19.3652L29.6659 19.4322C31.0659 19.4412 31.8589 21.0402 31.0189 22.1602L14.8909 43.6712C9.82089 39.8822 8.78189 32.7002 12.5709 27.6302L18.7379 19.3652Z",
                fill: "url(#paint0_linear_818_526)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.5619 27.63L1.69695 27.563C0.29795 27.554 -0.49505 25.958 0.34195 24.838L16.316 3.5C21.386 7.289 22.4249 14.471 18.636 19.541L12.5619 27.63Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_526",
                    x1: "18.3052",
                    y1: "20.9799",
                    x2: "22.8997",
                    y2: "34.8695",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("9YpGW", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementMarkBrand", function () { return $d634a61ef71547af$export$366b2081a44f303c; });

var $7VQPk = parcelRequire("7VQPk");
const $d634a61ef71547af$export$366b2081a44f303c = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.057 19.7803L37.985 19.8473C39.385 19.8563 40.178 21.4553 39.338 22.5753L23.21 44.0863C18.14 40.2973 17.101 33.1153 20.89 28.0453L27.057 19.7803Z",
                fill: "url(#paint0_linear_818_533)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.8799 28.0451L10.0149 27.9781C8.61594 27.9691 7.82294 26.3731 8.65994 25.2531L24.6339 3.91406C29.7039 7.70306 30.7429 14.8851 26.9539 19.9551L20.8799 28.0441V28.0451Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_533",
                    x1: "26.6233",
                    y1: "21.3952",
                    x2: "31.2178",
                    y2: "35.2838",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("ldaRP", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareLogoBrand", function () { return $96e5f66704f42f3c$export$eb01765c5894c7d3; });

var $7VQPk = parcelRequire("7VQPk");
const $96e5f66704f42f3c$export$eb01765c5894c7d3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "306",
        height: "48",
        viewBox: "0 0 306 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.123 8.48291H61.264V29.5079C61.264 35.0749 58.826 38.8939 53.121 38.8939C50.959 38.8939 49.303 38.5259 48.152 38.1119V34.1089C49.394 34.6159 50.913 34.8909 52.43 34.8909C55.927 34.8909 57.122 32.7749 57.122 29.7849V8.48291H57.123Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M68.807 6.87402C70.417 6.87402 71.567 7.88602 71.567 9.63402C71.567 11.382 70.418 12.395 68.807 12.395C67.196 12.395 66.046 11.382 66.046 9.63402C66.046 7.88602 67.196 6.87402 68.807 6.87402ZM66.783 15.707H70.74V38.709H66.783V15.707Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M80.582 38.7091H76.718V15.7071H80.582V19.7551C81.916 17.0411 84.217 15.1091 88.726 15.3851V19.2491C83.665 18.7431 80.582 20.2611 80.582 25.1381V38.7091Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M107.264 34.5681C105.792 37.6051 103.032 39.1691 99.4899 39.1691C93.3709 39.1691 90.2889 33.9711 90.2889 27.2081C90.2889 20.7211 93.5089 15.2461 99.9499 15.2461C103.308 15.2461 105.885 16.7651 107.264 19.7551V15.7071H111.221V38.7091H107.264V34.5681ZM100.547 35.4891C104.09 35.4891 107.264 33.2341 107.264 28.1281V26.2881C107.264 21.1821 104.366 18.9271 101.007 18.9271C96.5449 18.9271 94.2439 21.8711 94.2439 27.2081C94.2439 32.7291 96.4519 35.4891 100.547 35.4891Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M134.633 39.1689C128.79 39.1689 126.075 38.02 123.73 36.823V32.591C126.536 34.063 130.861 35.1209 134.863 35.1209C139.418 35.1209 141.12 33.326 141.12 30.658C141.12 27.99 139.464 26.5629 133.713 25.1829C126.904 23.5269 123.868 21.1809 123.868 16.2119C123.868 11.5199 127.456 8.02295 134.495 8.02295C138.866 8.02295 141.672 9.08195 143.742 10.2319V14.3719C140.706 12.6239 137.439 12.0719 134.311 12.0719C130.354 12.0719 128.008 13.4519 128.008 16.2129C128.008 18.6969 129.94 19.9399 135.277 21.2739C141.672 22.8839 145.26 24.955 145.26 30.382C145.26 35.6269 142.131 39.1689 134.633 39.1689Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M148.753 27.1621C148.753 20.2611 152.801 15.2461 159.702 15.2461C166.556 15.2461 170.559 20.2611 170.559 27.1621C170.559 34.0631 166.556 39.1691 159.702 39.1691C152.801 39.1691 148.753 34.0631 148.753 27.1621ZM152.617 27.1621C152.617 31.5321 154.779 35.4891 159.702 35.4891C164.578 35.4891 166.694 31.5321 166.694 27.1621C166.694 22.7921 164.578 18.9271 159.702 18.9271C154.779 18.9271 152.617 22.7911 152.617 27.1621Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.631 15.707H186.566V19.387H180.631V38.709H176.767V19.387H173.04V15.707H176.767V13.177C176.767 8.89802 179.16 5.99902 184.081 5.99902C185.277 5.99902 186.06 6.18402 186.75 6.36702V10.002C186.06 9.86402 185.186 9.77202 184.266 9.77202C181.828 9.77202 180.631 11.199 180.631 13.269V15.707Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M199.951 34.9821C200.871 34.9821 201.745 34.7981 202.435 34.6611V38.4791C201.745 38.6631 200.962 38.8471 199.766 38.8471C194.844 38.8471 192.452 35.9491 192.452 31.6701V19.3861H188.725V15.7061H192.452V10.8291H196.316V15.7061H202.435V19.3861H196.316V31.5771C196.316 33.6011 197.512 34.9811 199.951 34.9811V34.9821Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M229.208 38.709L225.252 27.576L223.136 20.491L221.02 27.576L217.063 38.709H212.002L203.537 15.707H207.907L214.532 35.213L221.249 15.707H225.021L231.738 35.213L238.363 15.707H242.733L234.268 38.709H229.207H229.208Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M260.81 34.5681C259.338 37.6051 256.578 39.1691 253.036 39.1691C246.917 39.1691 243.835 33.9711 243.835 27.2081C243.835 20.7211 247.055 15.2461 253.496 15.2461C256.854 15.2461 259.431 16.7651 260.81 19.7551V15.7071H264.767V38.7091H260.81V34.5681ZM254.093 35.4891C257.636 35.4891 260.81 33.2341 260.81 28.1281V26.2881C260.81 21.1821 257.912 18.9271 254.553 18.9271C250.091 18.9271 247.79 21.8711 247.79 27.2081C247.79 32.7291 249.998 35.4891 254.093 35.4891Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M274.607 38.7091H270.743V15.7071H274.607V19.7551C275.941 17.0411 278.242 15.1091 282.751 15.3851V19.2491C277.69 18.7431 274.607 20.2611 274.607 25.1381V38.7091Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M296.688 39.1691C288.085 39.1691 284.313 34.2011 284.313 27.1621C284.313 20.2151 288.177 15.2461 295.17 15.2461C302.254 15.2461 305.107 20.1691 305.107 27.1621V28.9561H288.315C288.868 32.8661 291.398 35.3961 296.827 35.3961C299.495 35.3961 301.749 34.8901 303.819 34.1541V37.7891C301.933 38.8011 299.035 39.1691 296.688 39.1691ZM288.269 25.5521H301.105C300.875 21.2741 298.943 18.8351 294.986 18.8351C290.799 18.8351 288.683 21.5491 288.269 25.5521Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.843 22.2901L20.803 5.25014L19.151 3.59814L6.323 16.4271L0.459 22.2901C-0.153 22.9021 -0.153 23.8951 0.459 24.5081L12.178 36.2271L19.151 43.2001L31.979 30.3721L32.178 30.1731L37.842 24.5091C38.454 23.8971 38.454 22.9041 37.842 22.2911L37.843 22.2901ZM19.151 29.2541L13.296 23.3991L19.152 17.5431L25.007 23.3981L19.151 29.2541Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.151 17.5441C15.314 13.7071 15.303 7.49707 19.111 3.64307L6.30103 16.4531L13.274 23.4261L19.153 17.5471L19.151 17.5451V17.5441Z",
                fill: "url(#paint0_linear_818_478)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.023 23.3843L19.151 29.2563C23.001 33.1073 23.001 39.3503 19.151 43.2003L31.995 30.3573L25.022 23.3843H25.023Z",
                fill: "url(#paint1_linear_818_478)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_478",
                        x1: "18.107",
                        y1: "11.6201",
                        x2: "9.93002",
                        y2: "19.7961",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_478",
                        x1: "20.271",
                        y1: "35.1083",
                        x2: "28.431",
                        y2: "26.9483",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("dmDFX", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareMarkBrand", function () { return $ce05d781735f7987$export$9b971ecc437a809; });

var $7VQPk = parcelRequire("7VQPk");
const $ce05d781735f7987$export$9b971ecc437a809 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.692 22.8912L25.652 5.85122L24 4.19922L11.172 17.0272L5.308 22.8912C4.696 23.5032 4.696 24.4962 5.308 25.1092L17.027 36.8282L24 43.8012L36.828 30.9732L37.027 30.7742L42.691 25.1102C43.303 24.4982 43.303 23.5052 42.691 22.8922L42.692 22.8912ZM24 29.8552L18.145 24.0002L24.001 18.1442L29.856 23.9992L24 29.8552Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 18.1442C20.163 14.3072 20.152 8.09716 23.96 4.24316L11.15 17.0532L18.123 24.0262L24.002 18.1472L24 18.1452V18.1442Z",
                fill: "url(#paint0_linear_818_577)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.872 23.9844L24 29.8564C27.85 33.7074 27.85 39.9504 24 43.8004L36.844 30.9574L29.871 23.9844H29.872Z",
                fill: "url(#paint1_linear_818_577)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_577",
                        x1: "22.956",
                        y1: "12.2212",
                        x2: "14.779",
                        y2: "20.3972",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_577",
                        x1: "25.12",
                        y1: "35.7094",
                        x2: "33.28",
                        y2: "27.5494",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("bogCj", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementMarkBrand", function () { return $4ff31055649af0b4$export$5a8caf8da5dd1ba6; });

var $7VQPk = parcelRequire("7VQPk");
const $4ff31055649af0b4$export$5a8caf8da5dd1ba6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.852 9.79885L22.156 32.2829C29.408 34.3319 35.191 31.6679 37.407 22.9199L40.731 9.79785H27.852V9.79885Z",
                fill: "url(#paint0_linear_818_510)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.148 40.2007L25.844 17.7167C18.592 15.6677 12.809 18.3317 10.593 27.0797L7.26904 40.2017H20.148V40.2007Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_510",
                    x1: "20.469",
                    y1: "32.3659",
                    x2: "32.167",
                    y2: "18.3079",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("98rQm", function(module, exports) {
$parcel$export(module.exports, "TrelloMarkBrand", function () { return $af693e7b669a0669$export$f4e51c099e77aab7; });

var $7VQPk = parcelRequire("7VQPk");
const $af693e7b669a0669$export$f4e51c099e77aab7 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.429 7.69385H11.571C9.42997 7.69385 7.69397 9.42985 7.69397 11.5708V36.4288C7.69397 38.5698 9.42997 40.3058 11.571 40.3058H36.429C38.57 40.3058 40.306 38.5698 40.306 36.4288V11.5708C40.306 9.42985 38.57 7.69385 36.429 7.69385ZM21.742 31.1828C21.742 31.8948 21.165 32.4708 20.454 32.4708H15.003C14.291 32.4708 13.715 31.8938 13.715 31.1828V15.0028C13.715 14.2908 14.292 13.7148 15.003 13.7148H20.454C21.166 13.7148 21.742 14.2918 21.742 15.0028V31.1828ZM34.285 23.7548C34.285 24.4668 33.708 25.0428 32.997 25.0428H27.546C26.834 25.0428 26.258 24.4658 26.258 23.7548V15.0028C26.258 14.2908 26.835 13.7148 27.546 13.7148H32.997C33.709 13.7148 34.285 14.2918 34.285 15.0028V23.7548Z",
                fill: "url(#paint0_linear_818_512)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_512",
                    x1: "24",
                    y1: "40.3058",
                    x2: "24",
                    y2: "7.69385",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});



parcelRegister("7BlSS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $28224a8e45b9fe5e$export$2e2bcd8739ae039; });
/* site-selector-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $4kArV = parcelRequire("4kArV");
var $izxiU = parcelRequire("izxiU");

var $5elx1 = parcelRequire("5elx1");
const $28224a8e45b9fe5e$var$SiteSelectorModal = ({ isOpen: isOpen, userName: userName, userEmail: userEmail, avatarSrc: avatarSrc, sites: sites, header: header, onNewSiteSelected: onNewSiteSelected, onSiteSelected: onSiteSelected, onSwitchAccountClick: onSwitchAccountClick, onSiteChanged: onSiteChanged, onModalClose: onModalClose })=>{
    const onClose = ()=>{
        if (onModalClose) onModalClose();
    };
    const onChange = ()=>{
        if (onSiteChanged) onSiteChanged();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izxiU.default), {
        children: isOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4kArV.default), {
            onClose: onClose,
            label: "Site Selector Modal",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_19pkqslr _2hwxqslr _otyrqslr _18u0qslr"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5elx1.default), {
                    userName: userName,
                    userEmail: userEmail,
                    avatarSrc: avatarSrc,
                    sites: sites,
                    header: header,
                    onNewSiteSelected: onNewSiteSelected,
                    onSiteSelected: onSiteSelected,
                    onSwitchAccountClick: onSwitchAccountClick,
                    onCancelClick: onClose,
                    onSiteChanged: onChange
                })
            })
        })
    });
};
var $28224a8e45b9fe5e$export$2e2bcd8739ae039 = $28224a8e45b9fe5e$var$SiteSelectorModal;
const $28224a8e45b9fe5e$var$containerStyle = null;

});
parcelRegister("4kArV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32754dc453d07598$export$2e2bcd8739ae039; });

var $ij7Z2 = parcelRequire("ij7Z2");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $vfAhM = parcelRequire("vfAhM");

var $4cgdq = parcelRequire("4cgdq");

var $FcSvA = parcelRequire("FcSvA");

var $d4hXj = parcelRequire("d4hXj");

var $9qszB = parcelRequire("9qszB");

var $jFq2q = parcelRequire("jFq2q");

var $lAmgM = parcelRequire("lAmgM");

var $3mOff = parcelRequire("3mOff");

var $bGp1c = parcelRequire("bGp1c");

var $jwsvk = parcelRequire("jwsvk");

var $k5zVc = parcelRequire("k5zVc");

var $cYLeP = parcelRequire("cYLeP");

var $luDIz = parcelRequire("luDIz");
var $32754dc453d07598$var$fillScreenStyles = (0, $3dJ4i.css)({
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
});
var $32754dc453d07598$var$allowlistElements = function allowlistElements(element, callback) {
    var isAuiDialogAllowlisted = (0, $3mOff.fg)('platform_dst_allowlist-aui-dialog-for-ak-modal');
    // Allow focus to reach elements outside the modal:
    //  if those contain the data-atlas-extension attribute
    if (element.hasAttribute('data-atlas-extension')) return false;
    // if AUI dialog is allowListed and visible
    if (isAuiDialogAllowlisted && !!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $32754dc453d07598$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $9qszB.default) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $9qszB.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $cYLeP.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $FcSvA.usePlatformLeafEventHandler)({
        fn: onClose,
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "12.18.5"
    });
    var onBlanketClicked = (0, $1oC0p.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $1oC0p.useCallback)(function(element) {
        return $32754dc453d07598$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $luDIz.default)();
    var modalDialogWithBlanket = (0, $3dJ4i.jsx)((0, $d4hXj.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $3dJ4i.jsx)((0, $k5zVc.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $3dJ4i.jsx)((0, $jFq2q.Layering), {
        isDisabled: false
    }, (0, $3dJ4i.jsx)((0, $bGp1c.default), {
        zIndex: (0, $jwsvk.layers).modal()
    }, (0, $3dJ4i.jsx)((0, $lAmgM.default), null, function(fadeInProps) {
        return (0, $3dJ4i.jsx)("div", (0, $ij7Z2.default)({}, fadeInProps, {
            css: $32754dc453d07598$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $3dJ4i.jsx)((0, $vfAhM.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4cgdq))), null), shouldScrollInViewport ? (0, $3dJ4i.jsx)((0, $4cgdq.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $32754dc453d07598$export$2e2bcd8739ae039 = $32754dc453d07598$var$ModalWrapper;

});
parcelRegister("ij7Z2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d54031ae4977caad$export$2e2bcd8739ae039; });
function $d54031ae4977caad$export$2e2bcd8739ae039() {
    return $d54031ae4977caad$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d54031ae4977caad$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3dJ4i", function(module, exports) {
$parcel$export(module.exports, "createElement", function () { return $25858ba38fdf0d3e$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Global", function () { return $25858ba38fdf0d3e$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $25858ba38fdf0d3e$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $25858ba38fdf0d3e$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $25858ba38fdf0d3e$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $25858ba38fdf0d3e$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "CacheProvider", function () { return (parcelRequire("9dorK")).C; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("9dorK")).T; });
$parcel$export(module.exports, "ThemeProvider", function () { return (parcelRequire("9dorK")).a; });
$parcel$export(module.exports, "__unsafe_useEmotionCache", function () { return (parcelRequire("9dorK"))._; });
$parcel$export(module.exports, "useTheme", function () { return (parcelRequire("9dorK")).u; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("9dorK")).w; });
$parcel$export(module.exports, "withTheme", function () { return (parcelRequire("9dorK")).b; });

var $9dorK = parcelRequire("9dorK");

var $1oC0p = parcelRequire("1oC0p");

var $93m7L = parcelRequire("93m7L");

var $eL87r = parcelRequire("eL87r");

var $18ZMs = parcelRequire("18ZMs");
parcelRequire("6g5L6");
parcelRequire("4zM3K");
parcelRequire("2CiSq");

parcelRequire("6PuZm");
var $25858ba38fdf0d3e$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $25858ba38fdf0d3e$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $9dorK.h).call(props, 'css')) // $FlowFixMe
    return $1oC0p.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $9dorK.E);
    createElementArgArray[1] = (0, $9dorK.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $1oC0p.createElement.apply(null, createElementArgArray);
};
var $25858ba38fdf0d3e$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $25858ba38fdf0d3e$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $9dorK.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $18ZMs.serializeStyles)([
        styles
    ], undefined, $1oC0p.useContext((0, $9dorK.T)));
    if (!(0, $9dorK.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $1oC0p.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1oC0p.useRef();
    (0, $eL87r.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $eL87r.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $93m7L.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $25858ba38fdf0d3e$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $18ZMs.serializeStyles)(args);
}
var $25858ba38fdf0d3e$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $25858ba38fdf0d3e$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $25858ba38fdf0d3e$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $25858ba38fdf0d3e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $93m7L.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $25858ba38fdf0d3e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $eL87r.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $93m7L.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $25858ba38fdf0d3e$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $9dorK.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $18ZMs.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $93m7L.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $25858ba38fdf0d3e$var$merge(cache.registered, css, $25858ba38fdf0d3e$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1oC0p.useContext((0, $9dorK.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1oC0p.createElement($1oC0p.Fragment, null, /*#__PURE__*/ $1oC0p.createElement($25858ba38fdf0d3e$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $25858ba38fdf0d3e$var$isBrowser, $25858ba38fdf0d3e$var$isTestEnv, $25858ba38fdf0d3e$var$globalContext, $25858ba38fdf0d3e$var$globalKey;

});
parcelRegister("9dorK", function(module, exports) {
$parcel$export(module.exports, "i", function () { return $6b584a829b05ea07$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $6b584a829b05ea07$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $6b584a829b05ea07$export$e7094788287c5e9b; });
$parcel$export(module.exports, "_", function () { return $6b584a829b05ea07$export$71511d61b312f219; });
$parcel$export(module.exports, "w", function () { return $6b584a829b05ea07$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $6b584a829b05ea07$export$971d5caa766a69d7; });
$parcel$export(module.exports, "u", function () { return $6b584a829b05ea07$export$3b14a55fb2447963; });
$parcel$export(module.exports, "a", function () { return $6b584a829b05ea07$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $6b584a829b05ea07$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "c", function () { return $6b584a829b05ea07$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $6b584a829b05ea07$export$a9c23c6ac3fc3eca; });

var $1oC0p = parcelRequire("1oC0p");

var $6g5L6 = parcelRequire("6g5L6");

var $4zM3K = parcelRequire("4zM3K");

var $2CiSq = parcelRequire("2CiSq");

var $jBDRd = parcelRequire("jBDRd");

var $93m7L = parcelRequire("93m7L");

var $18ZMs = parcelRequire("18ZMs");

var $eL87r = parcelRequire("eL87r");
var $6b584a829b05ea07$export$23f2a1d2818174ef = true;
var $6b584a829b05ea07$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $6b584a829b05ea07$var$EmotionCacheContext = /* #__PURE__ */ $1oC0p.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $6g5L6.default)({
    key: 'css'
}) : null);
var $6b584a829b05ea07$export$e7094788287c5e9b = $6b584a829b05ea07$var$EmotionCacheContext.Provider;
var $6b584a829b05ea07$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $1oC0p.useContext)($6b584a829b05ea07$var$EmotionCacheContext);
};
var $6b584a829b05ea07$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1oC0p.useContext)($6b584a829b05ea07$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$6b584a829b05ea07$export$23f2a1d2818174ef) $6b584a829b05ea07$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $1oC0p.useContext)($6b584a829b05ea07$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $6g5L6.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $1oC0p.createElement($6b584a829b05ea07$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $6b584a829b05ea07$export$971d5caa766a69d7 = /* #__PURE__ */ $1oC0p.createContext({});
var $6b584a829b05ea07$export$3b14a55fb2447963 = function useTheme() {
    return $1oC0p.useContext($6b584a829b05ea07$export$971d5caa766a69d7);
};
var $6b584a829b05ea07$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4zM3K.default)({}, outerTheme, theme);
};
var $6b584a829b05ea07$var$createCacheWithTheme = /* #__PURE__ */ (0, $2CiSq.default)(function(outerTheme) {
    return (0, $2CiSq.default)(function(theme) {
        return $6b584a829b05ea07$var$getTheme(outerTheme, theme);
    });
});
var $6b584a829b05ea07$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $1oC0p.useContext($6b584a829b05ea07$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $6b584a829b05ea07$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1oC0p.createElement($6b584a829b05ea07$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $6b584a829b05ea07$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $1oC0p.useContext($6b584a829b05ea07$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $4zM3K.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $1oC0p.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $jBDRd.default)(WithTheme, Component);
}
var $6b584a829b05ea07$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $6b584a829b05ea07$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $6b584a829b05ea07$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $6b584a829b05ea07$var$getLastPart(match[1]);
    return undefined;
};
var $6b584a829b05ea07$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $6b584a829b05ea07$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $6b584a829b05ea07$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $6b584a829b05ea07$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($6b584a829b05ea07$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $6b584a829b05ea07$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $6b584a829b05ea07$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $6b584a829b05ea07$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $6b584a829b05ea07$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($6b584a829b05ea07$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$6b584a829b05ea07$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $6b584a829b05ea07$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $93m7L.registerStyles)(cache, serialized, isStringTag);
    (0, $eL87r.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $93m7L.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $6b584a829b05ea07$var$Emotion = /* #__PURE__ */ $6b584a829b05ea07$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$6b584a829b05ea07$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $93m7L.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $18ZMs.serializeStyles)(registeredStyles, undefined, $1oC0p.useContext($6b584a829b05ea07$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($6b584a829b05ea07$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $6b584a829b05ea07$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $1oC0p.createElement($1oC0p.Fragment, null, /*#__PURE__*/ $1oC0p.createElement($6b584a829b05ea07$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $1oC0p.createElement(WrappedComponent, newProps));
});
var $6b584a829b05ea07$export$a9c23c6ac3fc3eca = $6b584a829b05ea07$var$Emotion;

});
parcelRegister("6g5L6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $48e8b441155c2f72$export$2e2bcd8739ae039; });

var $5aFz9 = parcelRequire("5aFz9");

var $lmueU = parcelRequire("lmueU");
var $ai5Wb = parcelRequire("ai5Wb");
var $3ytWu = parcelRequire("3ytWu");
var $a2Lgz = parcelRequire("a2Lgz");
var $iWoqF = parcelRequire("iWoqF");
var $a5wWl = parcelRequire("a5wWl");
parcelRequire("2CiSq");
parcelRequire("j6pHa");
var $48e8b441155c2f72$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $lmueU.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $lmueU.token)(character)) break;
        (0, $lmueU.next)();
    }
    return (0, $lmueU.slice)(begin, (0, $lmueU.position));
};
var $48e8b441155c2f72$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $lmueU.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $lmueU.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $48e8b441155c2f72$var$identifierWithPointTracking((0, $lmueU.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $lmueU.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $lmueU.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $ai5Wb.from)(character);
    }
    while (character = (0, $lmueU.next)());
    return parsed;
};
var $48e8b441155c2f72$var$getRules = function getRules(value, points) {
    return (0, $lmueU.dealloc)($48e8b441155c2f72$var$toRules((0, $lmueU.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $48e8b441155c2f72$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $48e8b441155c2f72$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$48e8b441155c2f72$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $48e8b441155c2f72$var$fixedElements.set(element, true);
    var points = [];
    var rules = $48e8b441155c2f72$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $48e8b441155c2f72$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $48e8b441155c2f72$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $48e8b441155c2f72$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($48e8b441155c2f72$var$ignoreFlag) > -1;
};
var $48e8b441155c2f72$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($48e8b441155c2f72$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $48e8b441155c2f72$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $48e8b441155c2f72$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$48e8b441155c2f72$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $48e8b441155c2f72$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $48e8b441155c2f72$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$48e8b441155c2f72$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $48e8b441155c2f72$var$nullifyElement(element);
    } else if ($48e8b441155c2f72$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $48e8b441155c2f72$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $48e8b441155c2f72$var$prefix(value, length) {
    switch((0, $ai5Wb.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $a2Lgz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $a2Lgz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MOZ) + value + (0, $a2Lgz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + value + value;
        // order
        case 6165:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $a2Lgz.WEBKIT) + value + (0, $ai5Wb.replace)(value, /(\w+).+(:[^]+)/, (0, $a2Lgz.WEBKIT) + 'box-$1$2' + (0, $a2Lgz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + 'flex-item-' + (0, $ai5Wb.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + 'flex-line-pack' + (0, $ai5Wb.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $a2Lgz.WEBKIT) + 'box-' + (0, $ai5Wb.replace)(value, '-grow', '') + (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $a2Lgz.WEBKIT) + (0, $ai5Wb.replace)(value, /([^-])(transform)/g, '$1' + (0, $a2Lgz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $ai5Wb.replace)((0, $ai5Wb.replace)((0, $ai5Wb.replace)(value, /(zoom-|grab)/, (0, $a2Lgz.WEBKIT) + '$1'), /(image-set)/, (0, $a2Lgz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $ai5Wb.replace)(value, /(image-set\([^]*)/, (0, $a2Lgz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $ai5Wb.replace)((0, $ai5Wb.replace)(value, /(.+:)(flex-)?(.*)/, (0, $a2Lgz.WEBKIT) + 'box-pack:$3' + (0, $a2Lgz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $a2Lgz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $ai5Wb.replace)(value, /(.+)-inline(.+)/, (0, $a2Lgz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $ai5Wb.strlen)(value) - 1 - length > 6) switch((0, $ai5Wb.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $ai5Wb.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $ai5Wb.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $a2Lgz.WEBKIT) + '$2-$3' + '$1' + (0, $a2Lgz.MOZ) + ((0, $ai5Wb.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $ai5Wb.indexof)(value, 'stretch') ? $48e8b441155c2f72$var$prefix((0, $ai5Wb.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $ai5Wb.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $ai5Wb.charat)(value, (0, $ai5Wb.strlen)(value) - 3 - (~(0, $ai5Wb.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $ai5Wb.replace)(value, ':', ':' + (0, $a2Lgz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $ai5Wb.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $a2Lgz.WEBKIT) + ((0, $ai5Wb.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $a2Lgz.WEBKIT) + '$2$3' + '$1' + (0, $a2Lgz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $ai5Wb.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + value + value;
    }
    return value;
}
var $48e8b441155c2f72$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $a2Lgz.DECLARATION:
                element["return"] = $48e8b441155c2f72$var$prefix(element.value, element.length);
                break;
            case 0, $a2Lgz.KEYFRAMES:
                return (0, $a5wWl.serialize)([
                    (0, $lmueU.copy)(element, {
                        value: (0, $ai5Wb.replace)(element.value, '@', '@' + (0, $a2Lgz.WEBKIT))
                    })
                ], callback);
            case 0, $a2Lgz.RULESET:
                if (element.length) return (0, $ai5Wb.combine)(element.props, function(value) {
                    switch((0, $ai5Wb.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $a5wWl.serialize)([
                                (0, $lmueU.copy)(element, {
                                    props: [
                                        (0, $ai5Wb.replace)(value, /:(read-\w+)/, ':' + (0, $a2Lgz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $a5wWl.serialize)([
                                (0, $lmueU.copy)(element, {
                                    props: [
                                        (0, $ai5Wb.replace)(value, /:(plac\w+)/, ':' + (0, $a2Lgz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $lmueU.copy)(element, {
                                    props: [
                                        (0, $ai5Wb.replace)(value, /:(plac\w+)/, ':' + (0, $a2Lgz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $lmueU.copy)(element, {
                                    props: [
                                        (0, $ai5Wb.replace)(value, /:(plac\w+)/, (0, $a2Lgz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $48e8b441155c2f72$var$defaultStylisPlugins = [
    $48e8b441155c2f72$var$prefixer
];
var $48e8b441155c2f72$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $48e8b441155c2f72$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $48e8b441155c2f72$var$compat,
        $48e8b441155c2f72$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $a5wWl.stringify),
        (0, $iWoqF.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $iWoqF.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $a5wWl.serialize)((0, $3ytWu.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $5aFz9.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("5aFz9", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", function () { return $3c3e21121b131495$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $3c3e21121b131495$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $3c3e21121b131495$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3c3e21121b131495$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3c3e21121b131495$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $3c3e21121b131495$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("lmueU", function(module, exports) {
$parcel$export(module.exports, "position", function () { return $f8d31bf568590474$export$5880b8b5730aff45; });
$parcel$export(module.exports, "node", function () { return $f8d31bf568590474$export$35059013cd4a06db; });
$parcel$export(module.exports, "copy", function () { return $f8d31bf568590474$export$784d13d8ee351f07; });
$parcel$export(module.exports, "char", function () { return $f8d31bf568590474$export$eba6f6f03b0a92e7; });
$parcel$export(module.exports, "prev", function () { return $f8d31bf568590474$export$232faf9add678146; });
$parcel$export(module.exports, "next", function () { return $f8d31bf568590474$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $f8d31bf568590474$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "caret", function () { return $f8d31bf568590474$export$e88cb2efb12ae807; });
$parcel$export(module.exports, "slice", function () { return $f8d31bf568590474$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $f8d31bf568590474$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $f8d31bf568590474$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $f8d31bf568590474$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $f8d31bf568590474$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "tokenize", function () { return $f8d31bf568590474$export$660b2ee2d4fb4eff; });
$parcel$export(module.exports, "whitespace", function () { return $f8d31bf568590474$export$7af1228ff777d175; });
$parcel$export(module.exports, "identifier", function () { return $f8d31bf568590474$export$c2ab62c7bf24634; });
$parcel$export(module.exports, "escaping", function () { return $f8d31bf568590474$export$955ba06d119e085e; });
$parcel$export(module.exports, "commenter", function () { return $f8d31bf568590474$export$4254d4e2b3745c4c; });

var $ai5Wb = parcelRequire("ai5Wb");
var $f8d31bf568590474$export$53f1d5ea8de3d7c = 1;
var $f8d31bf568590474$export$4e0c71f277ca26b3 = 1;
var $f8d31bf568590474$export$f24224f1c91d8156 = 0;
var $f8d31bf568590474$export$5880b8b5730aff45 = 0;
var $f8d31bf568590474$export$c0306caf338ac095 = 0;
var $f8d31bf568590474$export$30a86d91af8ff6e6 = '';
function $f8d31bf568590474$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f8d31bf568590474$export$53f1d5ea8de3d7c,
        column: $f8d31bf568590474$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $f8d31bf568590474$export$784d13d8ee351f07(root, props) {
    return (0, $ai5Wb.assign)($f8d31bf568590474$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f8d31bf568590474$export$eba6f6f03b0a92e7() {
    return $f8d31bf568590474$export$c0306caf338ac095;
}
function $f8d31bf568590474$export$232faf9add678146() {
    $f8d31bf568590474$export$c0306caf338ac095 = $f8d31bf568590474$export$5880b8b5730aff45 > 0 ? (0, $ai5Wb.charat)($f8d31bf568590474$export$30a86d91af8ff6e6, --$f8d31bf568590474$export$5880b8b5730aff45) : 0;
    if ($f8d31bf568590474$export$4e0c71f277ca26b3--, $f8d31bf568590474$export$c0306caf338ac095 === 10) $f8d31bf568590474$export$4e0c71f277ca26b3 = 1, $f8d31bf568590474$export$53f1d5ea8de3d7c--;
    return $f8d31bf568590474$export$c0306caf338ac095;
}
function $f8d31bf568590474$export$48cfd1e771a65c4f() {
    $f8d31bf568590474$export$c0306caf338ac095 = $f8d31bf568590474$export$5880b8b5730aff45 < $f8d31bf568590474$export$f24224f1c91d8156 ? (0, $ai5Wb.charat)($f8d31bf568590474$export$30a86d91af8ff6e6, $f8d31bf568590474$export$5880b8b5730aff45++) : 0;
    if ($f8d31bf568590474$export$4e0c71f277ca26b3++, $f8d31bf568590474$export$c0306caf338ac095 === 10) $f8d31bf568590474$export$4e0c71f277ca26b3 = 1, $f8d31bf568590474$export$53f1d5ea8de3d7c++;
    return $f8d31bf568590474$export$c0306caf338ac095;
}
function $f8d31bf568590474$export$4d3fb11e950abb9e() {
    return (0, $ai5Wb.charat)($f8d31bf568590474$export$30a86d91af8ff6e6, $f8d31bf568590474$export$5880b8b5730aff45);
}
function $f8d31bf568590474$export$e88cb2efb12ae807() {
    return $f8d31bf568590474$export$5880b8b5730aff45;
}
function $f8d31bf568590474$export$58adb3bec8346d0f(begin, end) {
    return (0, $ai5Wb.substr)($f8d31bf568590474$export$30a86d91af8ff6e6, begin, end);
}
function $f8d31bf568590474$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f8d31bf568590474$export$2de70f21292aac9e(value) {
    return $f8d31bf568590474$export$53f1d5ea8de3d7c = $f8d31bf568590474$export$4e0c71f277ca26b3 = 1, $f8d31bf568590474$export$f24224f1c91d8156 = (0, $ai5Wb.strlen)($f8d31bf568590474$export$30a86d91af8ff6e6 = value), $f8d31bf568590474$export$5880b8b5730aff45 = 0, [];
}
function $f8d31bf568590474$export$45918ac1574455b1(value) {
    return $f8d31bf568590474$export$30a86d91af8ff6e6 = '', value;
}
function $f8d31bf568590474$export$410ac95b9ec204b8(type) {
    return (0, $ai5Wb.trim)($f8d31bf568590474$export$58adb3bec8346d0f($f8d31bf568590474$export$5880b8b5730aff45 - 1, $f8d31bf568590474$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f8d31bf568590474$export$660b2ee2d4fb4eff(value) {
    return $f8d31bf568590474$export$45918ac1574455b1($f8d31bf568590474$export$5f8c09e3ae6f64e1($f8d31bf568590474$export$2de70f21292aac9e(value)));
}
function $f8d31bf568590474$export$7af1228ff777d175(type) {
    while($f8d31bf568590474$export$c0306caf338ac095 = $f8d31bf568590474$export$4d3fb11e950abb9e())if ($f8d31bf568590474$export$c0306caf338ac095 < 33) $f8d31bf568590474$export$48cfd1e771a65c4f();
    else break;
    return $f8d31bf568590474$export$9e1725a4cfeada27(type) > 2 || $f8d31bf568590474$export$9e1725a4cfeada27($f8d31bf568590474$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f8d31bf568590474$export$5f8c09e3ae6f64e1(children) {
    while($f8d31bf568590474$export$48cfd1e771a65c4f())switch($f8d31bf568590474$export$9e1725a4cfeada27($f8d31bf568590474$export$c0306caf338ac095)){
        case 0:
            (0, $ai5Wb.append)($f8d31bf568590474$export$c2ab62c7bf24634($f8d31bf568590474$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $ai5Wb.append)($f8d31bf568590474$export$410ac95b9ec204b8($f8d31bf568590474$export$c0306caf338ac095), children);
            break;
        default:
            (0, $ai5Wb.append)((0, $ai5Wb.from)($f8d31bf568590474$export$c0306caf338ac095), children);
    }
    return children;
}
function $f8d31bf568590474$export$955ba06d119e085e(index, count) {
    while(--count && $f8d31bf568590474$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f8d31bf568590474$export$c0306caf338ac095 < 48 || $f8d31bf568590474$export$c0306caf338ac095 > 102 || $f8d31bf568590474$export$c0306caf338ac095 > 57 && $f8d31bf568590474$export$c0306caf338ac095 < 65 || $f8d31bf568590474$export$c0306caf338ac095 > 70 && $f8d31bf568590474$export$c0306caf338ac095 < 97) break;
    return $f8d31bf568590474$export$58adb3bec8346d0f(index, $f8d31bf568590474$export$e88cb2efb12ae807() + (count < 6 && $f8d31bf568590474$export$4d3fb11e950abb9e() == 32 && $f8d31bf568590474$export$48cfd1e771a65c4f() == 32));
}
function $f8d31bf568590474$export$c889f2fcc19dbf12(type) {
    while($f8d31bf568590474$export$48cfd1e771a65c4f())switch($f8d31bf568590474$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f8d31bf568590474$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f8d31bf568590474$export$c889f2fcc19dbf12($f8d31bf568590474$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f8d31bf568590474$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f8d31bf568590474$export$48cfd1e771a65c4f();
            break;
    }
    return $f8d31bf568590474$export$5880b8b5730aff45;
}
function $f8d31bf568590474$export$4254d4e2b3745c4c(type, index) {
    while($f8d31bf568590474$export$48cfd1e771a65c4f())// //
    if (type + $f8d31bf568590474$export$c0306caf338ac095 === 57) break;
    else if (type + $f8d31bf568590474$export$c0306caf338ac095 === 84 && $f8d31bf568590474$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f8d31bf568590474$export$58adb3bec8346d0f(index, $f8d31bf568590474$export$5880b8b5730aff45 - 1) + '*' + (0, $ai5Wb.from)(type === 47 ? type : $f8d31bf568590474$export$48cfd1e771a65c4f());
}
function $f8d31bf568590474$export$c2ab62c7bf24634(index) {
    while(!$f8d31bf568590474$export$9e1725a4cfeada27($f8d31bf568590474$export$4d3fb11e950abb9e()))$f8d31bf568590474$export$48cfd1e771a65c4f();
    return $f8d31bf568590474$export$58adb3bec8346d0f(index, $f8d31bf568590474$export$5880b8b5730aff45);
}

});
parcelRegister("ai5Wb", function(module, exports) {
$parcel$export(module.exports, "abs", function () { return $77e030e110985ce7$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "from", function () { return $77e030e110985ce7$export$6788812c4e6611e6; });
$parcel$export(module.exports, "assign", function () { return $77e030e110985ce7$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "hash", function () { return $77e030e110985ce7$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $77e030e110985ce7$export$a9db5e087081082d; });
$parcel$export(module.exports, "trim", function () { return $77e030e110985ce7$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "match", function () { return $77e030e110985ce7$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $77e030e110985ce7$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $77e030e110985ce7$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "substr", function () { return $77e030e110985ce7$export$2f35ab04d2335697; });
$parcel$export(module.exports, "strlen", function () { return $77e030e110985ce7$export$36776f635604f274; });
$parcel$export(module.exports, "sizeof", function () { return $77e030e110985ce7$export$f9084667e487ed46; });
$parcel$export(module.exports, "append", function () { return $77e030e110985ce7$export$10d8903dec122b9d; });
$parcel$export(module.exports, "combine", function () { return $77e030e110985ce7$export$1be1fc439b849fdf; });
/**
 * @param {number}
 * @return {number}
 */ var $77e030e110985ce7$export$2335f513bbd82c6d = Math.abs;
var $77e030e110985ce7$export$6788812c4e6611e6 = String.fromCharCode;
var $77e030e110985ce7$export$e6e34fd1f2686227 = Object.assign;
function $77e030e110985ce7$export$d6af199866bfb566(value, length) {
    return $77e030e110985ce7$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $77e030e110985ce7$export$a9db5e087081082d(value, 0)) << 2 ^ $77e030e110985ce7$export$a9db5e087081082d(value, 1)) << 2 ^ $77e030e110985ce7$export$a9db5e087081082d(value, 2)) << 2 ^ $77e030e110985ce7$export$a9db5e087081082d(value, 3) : 0;
}
function $77e030e110985ce7$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $77e030e110985ce7$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $77e030e110985ce7$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $77e030e110985ce7$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $77e030e110985ce7$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $77e030e110985ce7$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $77e030e110985ce7$export$36776f635604f274(value) {
    return value.length;
}
function $77e030e110985ce7$export$f9084667e487ed46(value) {
    return value.length;
}
function $77e030e110985ce7$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $77e030e110985ce7$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("3ytWu", function(module, exports) {
$parcel$export(module.exports, "compile", function () { return $296bc6055e1bf8d8$export$ef7acd7185315e22; });

var $a2Lgz = parcelRequire("a2Lgz");

var $ai5Wb = parcelRequire("ai5Wb");

var $lmueU = parcelRequire("lmueU");
function $296bc6055e1bf8d8$export$ef7acd7185315e22(value) {
    return (0, $lmueU.dealloc)($296bc6055e1bf8d8$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $lmueU.alloc)(value), 0, [
        0
    ], value));
}
function $296bc6055e1bf8d8$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $lmueU.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $ai5Wb.charat)(characters, length - 1) == 58) {
                if ((0, $ai5Wb.indexof)(characters += (0, $ai5Wb.replace)((0, $lmueU.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $lmueU.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $lmueU.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $lmueU.escaping)((0, $lmueU.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $lmueU.peek)()){
                case 42:
                case 47:
                    (0, $ai5Wb.append)($296bc6055e1bf8d8$export$4a34f930e789283c((0, $lmueU.commenter)((0, $lmueU.next)(), (0, $lmueU.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $ai5Wb.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $ai5Wb.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $ai5Wb.strlen)(characters) - length) (0, $ai5Wb.append)(property > 32 ? $296bc6055e1bf8d8$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $296bc6055e1bf8d8$export$f8483753829ec8f3((0, $ai5Wb.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $ai5Wb.append)(reference = $296bc6055e1bf8d8$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $296bc6055e1bf8d8$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $ai5Wb.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $296bc6055e1bf8d8$export$98e6a39c04603d36(value, reference, reference, rule && (0, $ai5Wb.append)($296bc6055e1bf8d8$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $296bc6055e1bf8d8$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $ai5Wb.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $lmueU.prev)() == 125) continue;
            }
            switch(characters += (0, $ai5Wb.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $ai5Wb.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $lmueU.peek)() === 45) characters += (0, $lmueU.delimit)((0, $lmueU.next)());
                    atrule = (0, $lmueU.peek)(), offset = length = (0, $ai5Wb.strlen)(type = characters += (0, $lmueU.identifier)((0, $lmueU.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $ai5Wb.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $296bc6055e1bf8d8$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $ai5Wb.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $ai5Wb.substr)(value, post + 1, post = (0, $ai5Wb.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $ai5Wb.trim)(j > 0 ? rule[x] + ' ' + y : (0, $ai5Wb.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $lmueU.node)(value, root, parent, offset === 0 ? (0, $a2Lgz.RULESET) : type, props, children, length);
}
function $296bc6055e1bf8d8$export$4a34f930e789283c(value, root, parent) {
    return (0, $lmueU.node)(value, root, parent, (0, $a2Lgz.COMMENT), (0, $ai5Wb.from)((0, $lmueU.char)()), (0, $ai5Wb.substr)(value, 2, -2), 0);
}
function $296bc6055e1bf8d8$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $lmueU.node)(value, root, parent, (0, $a2Lgz.DECLARATION), (0, $ai5Wb.substr)(value, 0, length), (0, $ai5Wb.substr)(value, length + 1, -1), length);
}

});
parcelRegister("a2Lgz", function(module, exports) {
$parcel$export(module.exports, "MS", function () { return $74fec1626785cefe$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $74fec1626785cefe$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $74fec1626785cefe$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "COMMENT", function () { return $74fec1626785cefe$export$a29989082612d0d9; });
$parcel$export(module.exports, "RULESET", function () { return $74fec1626785cefe$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $74fec1626785cefe$export$527d108ccf083c2b; });
$parcel$export(module.exports, "IMPORT", function () { return $74fec1626785cefe$export$a763edbf796b780a; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $74fec1626785cefe$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "LAYER", function () { return $74fec1626785cefe$export$d773506282b3cfe6; });
var $74fec1626785cefe$export$71ad59f2e432cfe8 = '-ms-';
var $74fec1626785cefe$export$2c0f367103c8d01c = '-moz-';
var $74fec1626785cefe$export$39dfd62a25e0fe93 = '-webkit-';
var $74fec1626785cefe$export$a29989082612d0d9 = 'comm';
var $74fec1626785cefe$export$aa3a2e812ca8570d = 'rule';
var $74fec1626785cefe$export$527d108ccf083c2b = 'decl';
var $74fec1626785cefe$export$d3d35020fa5b54f0 = '@page';
var $74fec1626785cefe$export$500415a86c544f73 = '@media';
var $74fec1626785cefe$export$a763edbf796b780a = '@import';
var $74fec1626785cefe$export$2790aeb8b4e5c826 = '@charset';
var $74fec1626785cefe$export$1cc683e23b84b133 = '@viewport';
var $74fec1626785cefe$export$9447a5efea57e862 = '@supports';
var $74fec1626785cefe$export$ef011b4e114b1fba = '@document';
var $74fec1626785cefe$export$6aad947bda0f3f46 = '@namespace';
var $74fec1626785cefe$export$b44a8529a35fcb60 = '@keyframes';
var $74fec1626785cefe$export$2c16de31893252e6 = '@font-face';
var $74fec1626785cefe$export$3d846dd52e150c6f = '@counter-style';
var $74fec1626785cefe$export$22314bfbb57653fe = '@font-feature-values';
var $74fec1626785cefe$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("iWoqF", function(module, exports) {
$parcel$export(module.exports, "middleware", function () { return $dca097de411df4fa$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $dca097de411df4fa$export$38bcb760f1d4871c; });

var $a2Lgz = parcelRequire("a2Lgz");

var $ai5Wb = parcelRequire("ai5Wb");

var $lmueU = parcelRequire("lmueU");

var $a5wWl = parcelRequire("a5wWl");

var $ruOUs = parcelRequire("ruOUs");
function $dca097de411df4fa$export$5a7767152ae0305f(collection) {
    var length = (0, $ai5Wb.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $dca097de411df4fa$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $dca097de411df4fa$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $a2Lgz.DECLARATION:
                element.return = (0, $ruOUs.prefix)(element.value, element.length, children);
                return;
            case 0, $a2Lgz.KEYFRAMES:
                return (0, $a5wWl.serialize)([
                    (0, $lmueU.copy)(element, {
                        value: (0, $ai5Wb.replace)(element.value, '@', '@' + (0, $a2Lgz.WEBKIT))
                    })
                ], callback);
            case 0, $a2Lgz.RULESET:
                if (element.length) return (0, $ai5Wb.combine)(element.props, function(value) {
                    switch((0, $ai5Wb.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $a5wWl.serialize)([
                                (0, $lmueU.copy)(element, {
                                    props: [
                                        (0, $ai5Wb.replace)(value, /:(read-\w+)/, ':' + (0, $a2Lgz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $a5wWl.serialize)([
                                (0, $lmueU.copy)(element, {
                                    props: [
                                        (0, $ai5Wb.replace)(value, /:(plac\w+)/, ':' + (0, $a2Lgz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $lmueU.copy)(element, {
                                    props: [
                                        (0, $ai5Wb.replace)(value, /:(plac\w+)/, ':' + (0, $a2Lgz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $lmueU.copy)(element, {
                                    props: [
                                        (0, $ai5Wb.replace)(value, /:(plac\w+)/, (0, $a2Lgz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $dca097de411df4fa$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $a2Lgz.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $ai5Wb.combine)((0, $lmueU.tokenize)(value), function(value, index, children) {
                    switch((0, $ai5Wb.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $ai5Wb.substr)(value, 1, (0, $ai5Wb.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $ai5Wb.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $ai5Wb.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $ai5Wb.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("a5wWl", function(module, exports) {
$parcel$export(module.exports, "serialize", function () { return $7583ec34285e0467$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $7583ec34285e0467$export$fac44ee5b035f737; });

var $a2Lgz = parcelRequire("a2Lgz");

var $ai5Wb = parcelRequire("ai5Wb");
function $7583ec34285e0467$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $ai5Wb.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $7583ec34285e0467$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $a2Lgz.LAYER:
            if (element.children.length) break;
        case 0, $a2Lgz.IMPORT:
        case 0, $a2Lgz.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $a2Lgz.COMMENT:
            return '';
        case 0, $a2Lgz.KEYFRAMES:
            return element.return = element.value + '{' + $7583ec34285e0467$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $a2Lgz.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $ai5Wb.strlen)(children = $7583ec34285e0467$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("ruOUs", function(module, exports) {
$parcel$export(module.exports, "prefix", function () { return $052a6df738898e31$export$82e9f45cca5ba907; });

var $a2Lgz = parcelRequire("a2Lgz");

var $ai5Wb = parcelRequire("ai5Wb");
function $052a6df738898e31$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $ai5Wb.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $a2Lgz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $a2Lgz.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $a2Lgz.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MOZ) + value + (0, $a2Lgz.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $ai5Wb.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + value + value;
        // order
        case 6165:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $a2Lgz.WEBKIT) + value + (0, $ai5Wb.replace)(value, /(\w+).+(:[^]+)/, (0, $a2Lgz.WEBKIT) + 'box-$1$2' + (0, $a2Lgz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + 'flex-item-' + (0, $ai5Wb.replace)(value, /flex-|-self/g, '') + (!(0, $ai5Wb.match)(value, /flex-|baseline/) ? (0, $a2Lgz.MS) + 'grid-row-' + (0, $ai5Wb.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + 'flex-line-pack' + (0, $ai5Wb.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $a2Lgz.WEBKIT) + 'box-' + (0, $ai5Wb.replace)(value, '-grow', '') + (0, $a2Lgz.WEBKIT) + value + (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $a2Lgz.WEBKIT) + (0, $ai5Wb.replace)(value, /([^-])(transform)/g, '$1' + (0, $a2Lgz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $ai5Wb.replace)((0, $ai5Wb.replace)((0, $ai5Wb.replace)(value, /(zoom-|grab)/, (0, $a2Lgz.WEBKIT) + '$1'), /(image-set)/, (0, $a2Lgz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $ai5Wb.replace)(value, /(image-set\([^]*)/, (0, $a2Lgz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $ai5Wb.replace)((0, $ai5Wb.replace)(value, /(.+:)(flex-)?(.*)/, (0, $a2Lgz.WEBKIT) + 'box-pack:$3' + (0, $a2Lgz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $a2Lgz.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $ai5Wb.match)(value, /flex-|baseline/)) return (0, $a2Lgz.MS) + 'grid-column-align' + (0, $ai5Wb.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $ai5Wb.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $ai5Wb.indexof)(value + (children = children[length].value), 'span') ? value : (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, '-start', '') + value + (0, $a2Lgz.MS) + 'grid-row-span:' + (~(0, $ai5Wb.indexof)(children, 'span') ? (0, $ai5Wb.match)(children, /\d+/) : +(0, $ai5Wb.match)(children, /\d+/) - +(0, $ai5Wb.match)(value, /\d+/)) + ';';
            return (0, $a2Lgz.MS) + (0, $ai5Wb.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $ai5Wb.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $a2Lgz.MS) + (0, $ai5Wb.replace)((0, $ai5Wb.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $ai5Wb.replace)(value, /(.+)-inline(.+)/, (0, $a2Lgz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $ai5Wb.strlen)(value) - 1 - length > 6) switch((0, $ai5Wb.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $ai5Wb.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $ai5Wb.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $a2Lgz.WEBKIT) + '$2-$3' + '$1' + (0, $a2Lgz.MOZ) + ((0, $ai5Wb.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $ai5Wb.indexof)(value, 'stretch') ? $052a6df738898e31$export$82e9f45cca5ba907((0, $ai5Wb.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $ai5Wb.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $a2Lgz.MS) + a + ':' + b + f + (c ? (0, $a2Lgz.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $ai5Wb.charat)(value, length + 6) === 121) return (0, $ai5Wb.replace)(value, ':', ':' + (0, $a2Lgz.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $ai5Wb.charat)(value, (0, $ai5Wb.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $ai5Wb.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $a2Lgz.WEBKIT) + ((0, $ai5Wb.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $a2Lgz.WEBKIT) + '$2$3' + '$1' + (0, $a2Lgz.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $ai5Wb.replace)(value, ':', ':' + (0, $a2Lgz.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $ai5Wb.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("2CiSq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1e7dc5eba1396d79$export$2e2bcd8739ae039; });
var $1e7dc5eba1396d79$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("j6pHa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de8282696e88a420$export$2e2bcd8739ae039; });
function $de8282696e88a420$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4zM3K", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $354fb5eca86bdcdb$export$2e2bcd8739ae039; });
function $354fb5eca86bdcdb$export$2e2bcd8739ae039() {
    return $354fb5eca86bdcdb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $354fb5eca86bdcdb$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jBDRd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e46063e070cadfdd$export$2e2bcd8739ae039; });

var $6PuZm = parcelRequire("6PuZm");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $e46063e070cadfdd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))(targetComponent, sourceComponent);
};

});

parcelRegister("93m7L", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", function () { return $69758e4de080153b$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $69758e4de080153b$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $69758e4de080153b$export$6f077d94b33a01aa; });
var $69758e4de080153b$var$isBrowser = true;
function $69758e4de080153b$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $69758e4de080153b$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $69758e4de080153b$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $69758e4de080153b$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $69758e4de080153b$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("18ZMs", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", function () { return $0d56761c78a489d9$export$6321afa313b251b5; });

var $9ybHj = parcelRequire("9ybHj");

var $6eUqL = parcelRequire("6eUqL");

var $j6pHa = parcelRequire("j6pHa");
var $0d56761c78a489d9$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $0d56761c78a489d9$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $0d56761c78a489d9$var$hyphenateRegex = /[A-Z]|^ms/g;
var $0d56761c78a489d9$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $0d56761c78a489d9$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $0d56761c78a489d9$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $0d56761c78a489d9$var$processStyleName = /* #__PURE__ */ (0, $j6pHa.default)(function(styleName) {
    return $0d56761c78a489d9$var$isCustomProperty(styleName) ? styleName : styleName.replace($0d56761c78a489d9$var$hyphenateRegex, '-$&').toLowerCase();
});
var $0d56761c78a489d9$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($0d56761c78a489d9$var$animationRegex, function(match, p1, p2) {
                $0d56761c78a489d9$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $0d56761c78a489d9$var$cursor
                };
                return p1;
            });
    }
    if ((0, $6eUqL.default)[key] !== 1 && !$0d56761c78a489d9$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $0d56761c78a489d9$var$contentValuePattern, $0d56761c78a489d9$var$contentValues, $0d56761c78a489d9$var$oldProcessStyleValue, $0d56761c78a489d9$var$msPattern, $0d56761c78a489d9$var$hyphenPattern, $0d56761c78a489d9$var$hyphenatedCache;
var $0d56761c78a489d9$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $0d56761c78a489d9$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $0d56761c78a489d9$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $0d56761c78a489d9$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $0d56761c78a489d9$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $0d56761c78a489d9$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $0d56761c78a489d9$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $0d56761c78a489d9$var$cursor;
                var result = interpolation(mergedProps);
                $0d56761c78a489d9$var$cursor = previousCursor;
                return $0d56761c78a489d9$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $0d56761c78a489d9$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $0d56761c78a489d9$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($0d56761c78a489d9$var$isProcessableValue(value)) string += $0d56761c78a489d9$var$processStyleName(_key) + ":" + $0d56761c78a489d9$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($0d56761c78a489d9$var$isProcessableValue(value[_i])) string += $0d56761c78a489d9$var$processStyleName(_key) + ":" + $0d56761c78a489d9$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $0d56761c78a489d9$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $0d56761c78a489d9$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $0d56761c78a489d9$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $0d56761c78a489d9$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $0d56761c78a489d9$var$cursor;
var $0d56761c78a489d9$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $0d56761c78a489d9$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $0d56761c78a489d9$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $0d56761c78a489d9$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $0d56761c78a489d9$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $0d56761c78a489d9$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $9ybHj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $0d56761c78a489d9$var$cursor
    };
};

});
parcelRegister("9ybHj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6f405ce939808798$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $6f405ce939808798$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("6eUqL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $48afd2d298ad89c6$export$2e2bcd8739ae039; });
var $48afd2d298ad89c6$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("eL87r", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $abebc0c3b7524f84$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $abebc0c3b7524f84$export$811a713a7276cb9d; });

var $1oC0p = parcelRequire("1oC0p");
var $abebc0c3b7524f84$var$syncFallback = function syncFallback(create) {
    return create();
};
var $abebc0c3b7524f84$var$useInsertionEffect = $1oC0p.useInsertionEffect ? $1oC0p.useInsertionEffect : false;
var $abebc0c3b7524f84$export$db21c7ffa21794e7 = $abebc0c3b7524f84$var$useInsertionEffect || $abebc0c3b7524f84$var$syncFallback;
var $abebc0c3b7524f84$export$811a713a7276cb9d = $abebc0c3b7524f84$var$useInsertionEffect || $1oC0p.useLayoutEffect;

});



parcelRegister("vfAhM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $05defc12daff54c2$export$2e2bcd8739ae039; });

var $a2ulB = parcelRequire("a2ulB");

var $05defc12daff54c2$export$2e2bcd8739ae039 = (0, $a2ulB.default);

});
parcelRegister("a2ulB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74f1a1a8387ef80a$export$2e2bcd8739ae039; });

var $5hmEg = parcelRequire("5hmEg");

var $ij7Z2 = parcelRequire("ij7Z2");

var $1oC0p = parcelRequire("1oC0p");

var $5ijdG = parcelRequire("5ijdG");

var $ay4JZ = parcelRequire("ay4JZ");
/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $74f1a1a8387ef80a$var$FocusLockCombination = /*#__PURE__*/ $1oC0p.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $1oC0p.createElement((0, $5ijdG.default), (0, $ij7Z2.default)({
        sideCar: (0, $ay4JZ.default),
        ref: ref
    }, props));
});
var $74f1a1a8387ef80a$var$_ref = (0, $5ijdG.default).propTypes || {}, $74f1a1a8387ef80a$var$sideCar = $74f1a1a8387ef80a$var$_ref.sideCar, $74f1a1a8387ef80a$var$propTypes = (0, $5hmEg.default)($74f1a1a8387ef80a$var$_ref, [
    "sideCar"
]);
$74f1a1a8387ef80a$var$FocusLockCombination.propTypes = {};
var $74f1a1a8387ef80a$export$2e2bcd8739ae039 = $74f1a1a8387ef80a$var$FocusLockCombination;

});
parcelRegister("5hmEg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d801bca0e78da02$export$2e2bcd8739ae039; });
function $3d801bca0e78da02$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("5ijdG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3dad8aceecd6ba44$export$2e2bcd8739ae039; });

var $ij7Z2 = parcelRequire("ij7Z2");

var $1oC0p = parcelRequire("1oC0p");


var $9d7xu = parcelRequire("9d7xu");

var $loylR = parcelRequire("loylR");

var $lmjSU = parcelRequire("lmjSU");

var $6qMbq = parcelRequire("6qMbq");
var $3dad8aceecd6ba44$var$emptyArray = [];
var $3dad8aceecd6ba44$var$FocusLock = /*#__PURE__*/ $1oC0p.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $1oC0p.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $1oC0p.useRef();
    var isActive = $1oC0p.useRef(false);
    var originalFocusedElement = $1oC0p.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $3dad8aceecd6ba44$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $1oC0p.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $1oC0p.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $1oC0p.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $1oC0p.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $1oC0p.useCallback(function(event) {
        if (isActive.current) (0, $6qMbq.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $6qMbq.mediumBlur).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $1oC0p.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $ij7Z2.default)((_extends2 = {}, _extends2[$9d7xu.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$9d7xu.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $loylR.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $1oC0p.createElement($1oC0p.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $1oC0p.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $lmjSU.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $1oC0p.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $lmjSU.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $1oC0p.createElement(SideCar, {
        id: id,
        sideCar: (0, $6qMbq.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $1oC0p.createElement(Container, (0, $ij7Z2.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $lmjSU.hiddenGuard)
    }));
});
$3dad8aceecd6ba44$var$FocusLock.propTypes = {};
$3dad8aceecd6ba44$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: 'div',
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $3dad8aceecd6ba44$export$2e2bcd8739ae039 = $3dad8aceecd6ba44$var$FocusLock;

});
parcelRegister("9d7xu", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", function () { return $6b4b2d18b0b30864$export$4f9a06cb7441a087; });
$parcel$export(module.exports, "FOCUS_DISABLED", function () { return $6b4b2d18b0b30864$export$aeda8252e54b50f7; });
$parcel$export(module.exports, "FOCUS_ALLOW", function () { return $6b4b2d18b0b30864$export$54ecf528c58f9ef6; });
$parcel$export(module.exports, "FOCUS_AUTO", function () { return $6b4b2d18b0b30864$export$70e9b4a1820af101; });
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", function () { return $6b4b2d18b0b30864$export$134ebef29fd94853; });
/**
 * defines a focus group
 */ var $6b4b2d18b0b30864$export$4f9a06cb7441a087 = 'data-focus-lock';
var $6b4b2d18b0b30864$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $6b4b2d18b0b30864$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $6b4b2d18b0b30864$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $6b4b2d18b0b30864$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("loylR", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", function () { return $f9367c5f5a4b7916$export$74665b213cb5c4cf; });

var $4pMyl = parcelRequire("4pMyl");

var $cdMII = parcelRequire("cdMII");
function $f9367c5f5a4b7916$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $cdMII.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $4pMyl.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("4pMyl", function(module, exports) {
$parcel$export(module.exports, "assignRef", function () { return $336f28d9d94202ed$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $336f28d9d94202ed$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("cdMII", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", function () { return $8e5c7dbfa8d13271$export$25bec8c6f54ee79a; });

var $1oC0p = parcelRequire("1oC0p");
function $8e5c7dbfa8d13271$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $1oC0p.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("lmjSU", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", function () { return $f8cb13b579c75829$export$b8c7b07253306600; });

var $1oC0p = parcelRequire("1oC0p");

var $f8cb13b579c75829$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $f8cb13b579c75829$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement($1oC0p.Fragment, null, /*#__PURE__*/ $1oC0p.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f8cb13b579c75829$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $1oC0p.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f8cb13b579c75829$export$b8c7b07253306600
    }));
};
$f8cb13b579c75829$var$InFocusGuard.propTypes = {};
$f8cb13b579c75829$var$InFocusGuard.defaultProps = {
    children: null
};
var $f8cb13b579c75829$export$2e2bcd8739ae039 = $f8cb13b579c75829$var$InFocusGuard;

});

parcelRegister("6qMbq", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", function () { return $4aea8bf7620ca5ca$export$5733e022b1d538cb; });
$parcel$export(module.exports, "mediumBlur", function () { return $4aea8bf7620ca5ca$export$b3e9a9312f73723c; });
$parcel$export(module.exports, "mediumEffect", function () { return $4aea8bf7620ca5ca$export$3a1d52767cbc07b8; });
$parcel$export(module.exports, "mediumSidecar", function () { return $4aea8bf7620ca5ca$export$892cbf28e5518020; });

var $f1gJI = parcelRequire("f1gJI");
var $4aea8bf7620ca5ca$export$5733e022b1d538cb = (0, $f1gJI.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $4aea8bf7620ca5ca$export$b3e9a9312f73723c = (0, $f1gJI.createMedium)();
var $4aea8bf7620ca5ca$export$3a1d52767cbc07b8 = (0, $f1gJI.createMedium)();
var $4aea8bf7620ca5ca$export$892cbf28e5518020 = (0, $f1gJI.createSidecarMedium)({
    async: true // focus-lock sidecar is not required on the server
});

});
parcelRegister("f1gJI", function(module, exports) {
$parcel$export(module.exports, "createMedium", function () { return $aef3ee82fa564439$export$9ffbfcaf067b02c6; });
$parcel$export(module.exports, "createSidecarMedium", function () { return $aef3ee82fa564439$export$e13ec7dd7a14088d; });

var $d3IQL = parcelRequire("d3IQL");
function $aef3ee82fa564439$var$ItoI(a) {
    return a;
}
function $aef3ee82fa564439$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $aef3ee82fa564439$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $aef3ee82fa564439$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $aef3ee82fa564439$var$ItoI;
    return $aef3ee82fa564439$var$innerCreateMedium(defaults, middleware);
}
function $aef3ee82fa564439$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $aef3ee82fa564439$var$innerCreateMedium(null);
    medium.options = (0, $d3IQL.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("ay4JZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7ae0c1c18d13e370$export$2e2bcd8739ae039; });
/* eslint-disable no-mixed-operators */ 
var $1oC0p = parcelRequire("1oC0p");


var $6P2F1 = parcelRequire("6P2F1");

var $7IutG = parcelRequire("7IutG");
var $azUCw = parcelRequire("azUCw");
var $9gZ1p = parcelRequire("9gZ1p");parcelRequire("5uZTH");
var $7pPse = parcelRequire("7pPse");

var $5lEmx = parcelRequire("5lEmx");

var $6qMbq = parcelRequire("6qMbq");
var $7ae0c1c18d13e370$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $7ae0c1c18d13e370$var$isFreeFocus = function isFreeFocus() {
    return $7ae0c1c18d13e370$var$focusOnBody() || (0, $9gZ1p.focusIsHidden)();
};
var $7ae0c1c18d13e370$var$lastActiveTrap = null;
var $7ae0c1c18d13e370$var$lastActiveFocus = null;
var $7ae0c1c18d13e370$var$lastPortaledElement = null;
var $7ae0c1c18d13e370$var$focusWasOutsideWindow = false;
var $7ae0c1c18d13e370$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $7ae0c1c18d13e370$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($7ae0c1c18d13e370$var$lastActiveTrap.whiteList || $7ae0c1c18d13e370$var$defaultWhitelist)(activeElement);
};
var $7ae0c1c18d13e370$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $7ae0c1c18d13e370$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $7ae0c1c18d13e370$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $7ae0c1c18d13e370$var$lastPortaledElement && $7ae0c1c18d13e370$var$lastPortaledElement.portaledElement === element;
};
function $7ae0c1c18d13e370$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $7ae0c1c18d13e370$var$extractRef = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $7ae0c1c18d13e370$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($7ae0c1c18d13e370$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $7ae0c1c18d13e370$var$focusWasOutsideWindow === 'meanwhile';
};
var $7ae0c1c18d13e370$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $7ae0c1c18d13e370$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $7ae0c1c18d13e370$var$checkInHost(activeElement, area, area);
    });
};
var $7ae0c1c18d13e370$var$activateTrap = function activateTrap() {
    var result = false;
    if ($7ae0c1c18d13e370$var$lastActiveTrap) {
        var _lastActiveTrap = $7ae0c1c18d13e370$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $7ae0c1c18d13e370$var$lastPortaledElement && $7ae0c1c18d13e370$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($7ae0c1c18d13e370$var$extractRef).filter(Boolean));
            if (!activeElement || $7ae0c1c18d13e370$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $7ae0c1c18d13e370$var$focusWasOutside(crossFrame) || !$7ae0c1c18d13e370$var$isFreeFocus() || !$7ae0c1c18d13e370$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $azUCw.focusInside)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $7ae0c1c18d13e370$var$withinHost(activeElement, workingArea) || $7ae0c1c18d13e370$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$7ae0c1c18d13e370$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $7pPse.moveFocusInside)(workingArea, $7ae0c1c18d13e370$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $7ae0c1c18d13e370$var$lastPortaledElement = {};
                        }
                    }
                    $7ae0c1c18d13e370$var$focusWasOutsideWindow = false;
                    $7ae0c1c18d13e370$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $7IutG.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $7ae0c1c18d13e370$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $7ae0c1c18d13e370$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $7ae0c1c18d13e370$var$onTrap = function onTrap(event) {
    if ($7ae0c1c18d13e370$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $7ae0c1c18d13e370$var$onBlur = function onBlur() {
    return (0, $5lEmx.deferAction)($7ae0c1c18d13e370$var$activateTrap);
};
var $7ae0c1c18d13e370$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $7ae0c1c18d13e370$var$recordPortal(currentNode, source);
};
var $7ae0c1c18d13e370$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $7ae0c1c18d13e370$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        onBlur: $7ae0c1c18d13e370$var$onBlur,
        onFocus: $7ae0c1c18d13e370$var$onFocus
    }, children);
};
$7ae0c1c18d13e370$var$FocusTrap.propTypes = {};
var $7ae0c1c18d13e370$var$onWindowBlur = function onWindowBlur() {
    $7ae0c1c18d13e370$var$focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction
    (0, $5lEmx.deferAction)(function() {
        $7ae0c1c18d13e370$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $7ae0c1c18d13e370$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $7ae0c1c18d13e370$var$onTrap);
    document.addEventListener('focusout', $7ae0c1c18d13e370$var$onBlur);
    window.addEventListener('blur', $7ae0c1c18d13e370$var$onWindowBlur);
};
var $7ae0c1c18d13e370$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $7ae0c1c18d13e370$var$onTrap);
    document.removeEventListener('focusout', $7ae0c1c18d13e370$var$onBlur);
    window.removeEventListener('blur', $7ae0c1c18d13e370$var$onWindowBlur);
};
function $7ae0c1c18d13e370$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $7ae0c1c18d13e370$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$7ae0c1c18d13e370$var$lastActiveTrap) $7ae0c1c18d13e370$var$attachHandler();
    var lastTrap = $7ae0c1c18d13e370$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $7ae0c1c18d13e370$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $7ae0c1c18d13e370$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $7ae0c1c18d13e370$var$activateTrap(true);
        (0, $5lEmx.deferAction)($7ae0c1c18d13e370$var$activateTrap);
    } else {
        $7ae0c1c18d13e370$var$detachHandler();
        $7ae0c1c18d13e370$var$lastActiveFocus = null;
    }
} // bind medium
(0, $6qMbq.mediumFocus).assignSyncMedium($7ae0c1c18d13e370$var$onFocus);
(0, $6qMbq.mediumBlur).assignMedium($7ae0c1c18d13e370$var$onBlur);
(0, $6qMbq.mediumEffect).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $7pPse.moveFocusInside),
        focusInside: (0, $azUCw.focusInside)
    });
});
var $7ae0c1c18d13e370$export$2e2bcd8739ae039 = (0, $6P2F1.default)($7ae0c1c18d13e370$var$reducePropsToState, $7ae0c1c18d13e370$var$handleStateChangeOnClient)($7ae0c1c18d13e370$var$FocusWatcher);

});
parcelRegister("6P2F1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f7991d9150fb33c$export$2e2bcd8739ae039; });

var $6gBoh = parcelRequire("6gBoh");

var $hqMui = parcelRequire("hqMui");

var $1oC0p = parcelRequire("1oC0p");
function $4f7991d9150fb33c$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $6gBoh.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $1oC0p.PureComponent));
        (0, $hqMui.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $4f7991d9150fb33c$export$2e2bcd8739ae039 = $4f7991d9150fb33c$var$withSideEffect;

});
parcelRegister("6gBoh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $49013db2337cd77a$export$2e2bcd8739ae039; });

var $ettuv = parcelRequire("ettuv");
function $49013db2337cd77a$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $ettuv.default)(t, o);
}

});
parcelRegister("ettuv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $02b82bf98f4a43d4$export$2e2bcd8739ae039; });
function $02b82bf98f4a43d4$export$2e2bcd8739ae039(t, e) {
    return $02b82bf98f4a43d4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $02b82bf98f4a43d4$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("hqMui", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb0a7a07e85d85b2$export$2e2bcd8739ae039; });

var $8gKg9 = parcelRequire("8gKg9");
function $cb0a7a07e85d85b2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $8gKg9.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("8gKg9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6053b3811aff3234$export$2e2bcd8739ae039; });

var $eENc4 = parcelRequire("eENc4");

var $9vkSf = parcelRequire("9vkSf");
function $6053b3811aff3234$export$2e2bcd8739ae039(t) {
    var i = (0, $9vkSf.default)(t, "string");
    return "symbol" == (0, $eENc4.default)(i) ? i : i + "";
}

});
parcelRegister("eENc4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aabaf5f1a1be5273$export$2e2bcd8739ae039; });
function $aabaf5f1a1be5273$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $aabaf5f1a1be5273$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aabaf5f1a1be5273$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9vkSf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6eb733724f8f021f$export$2e2bcd8739ae039; });

var $eENc4 = parcelRequire("eENc4");
function $6eb733724f8f021f$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $eENc4.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $eENc4.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("7IutG", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", function () { return $59e448b113fd5f9d$export$f89ac71e91767111; });

var $ihusC = parcelRequire("ihusC");

var $swPek = parcelRequire("swPek");

var $hGJxh = parcelRequire("hGJxh");

var $bzYdB = parcelRequire("bzYdB");
var $59e448b113fd5f9d$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $swPek.getAllAffectedNodes)(topNode).filter((0, $hGJxh.isNotAGuard));
    var commonParent = (0, $bzYdB.getTopCommonParent)(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = (0, $ihusC.getTabbableNodes)([
        commonParent
    ], visibilityCache, true);
    var innerElements = (0, $ihusC.getTabbableNodes)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $hGJxh.isNotAGuard)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $hGJxh.isGuard)(node)
        };
    });
};

});
parcelRegister("ihusC", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", function () { return $d4f1716050febae9$export$2f70373d403a5d2b; });
$parcel$export(module.exports, "getTabbableNodes", function () { return $d4f1716050febae9$export$3738e313571e2ad2; });
$parcel$export(module.exports, "getFocusableNodes", function () { return $d4f1716050febae9$export$493d05a3a8e6532d; });
$parcel$export(module.exports, "parentAutofocusables", function () { return $d4f1716050febae9$export$dc26309a71d1ce47; });
$parcel$export(module.exports, "contains", function () { return $d4f1716050febae9$export$2344b14b097df817; });

var $7gG5g = parcelRequire("7gG5g");

var $hGJxh = parcelRequire("hGJxh");

var $30P9V = parcelRequire("30P9V");

var $CBsca = parcelRequire("CBsca");
var $d4f1716050febae9$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $7gG5g.toArray)(nodes).filter(function(node) {
        return (0, $hGJxh.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $hGJxh.notHiddenInput)(node);
    });
};
var $d4f1716050febae9$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $7gG5g.toArray)(nodes).filter(function(node) {
        return (0, $hGJxh.isAutoFocusAllowedCached)(cache, node);
    });
};
var $d4f1716050febae9$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $30P9V.orderByTabIndex)($d4f1716050febae9$export$6266a5cd5915dc33((0, $CBsca.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $d4f1716050febae9$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $30P9V.orderByTabIndex)($d4f1716050febae9$export$6266a5cd5915dc33((0, $CBsca.getFocusables)(topNodes), visibilityCache), false);
};
var $d4f1716050febae9$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $d4f1716050febae9$export$6266a5cd5915dc33((0, $CBsca.getParentAutofocusables)(topNode), visibilityCache);
};
var $d4f1716050febae9$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $d4f1716050febae9$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $7gG5g.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $d4f1716050febae9$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $d4f1716050febae9$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("7gG5g", function(module, exports) {
$parcel$export(module.exports, "toArray", function () { return $54aaabfdfe5b98f1$export$45b10814cc054894; });
$parcel$export(module.exports, "asArray", function () { return $54aaabfdfe5b98f1$export$75093a47a9fa838d; });
$parcel$export(module.exports, "getFirst", function () { return $54aaabfdfe5b98f1$export$bcd7afcd904dce14; });
/*
IE11 support
 */ var $54aaabfdfe5b98f1$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $54aaabfdfe5b98f1$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $54aaabfdfe5b98f1$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("hGJxh", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", function () { return $ce09ae5d0d92bfbe$export$3c9dc299685ad160; });
$parcel$export(module.exports, "isAutoFocusAllowedCached", function () { return $ce09ae5d0d92bfbe$export$bcaa50628f6a736e; });
$parcel$export(module.exports, "getDataset", function () { return $ce09ae5d0d92bfbe$export$698b339b0c8edae3; });
$parcel$export(module.exports, "isRadioElement", function () { return $ce09ae5d0d92bfbe$export$9d74f6fbc6f469d0; });
$parcel$export(module.exports, "notHiddenInput", function () { return $ce09ae5d0d92bfbe$export$8197b0ea56b3b055; });
$parcel$export(module.exports, "isGuard", function () { return $ce09ae5d0d92bfbe$export$d94b8b58ec2f30eb; });
$parcel$export(module.exports, "isNotAGuard", function () { return $ce09ae5d0d92bfbe$export$602e5a0d338d7750; });
$parcel$export(module.exports, "isDefined", function () { return $ce09ae5d0d92bfbe$export$4e62c701997796c1; });

var $9d7xu = parcelRequire("9d7xu");
var $ce09ae5d0d92bfbe$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $ce09ae5d0d92bfbe$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $ce09ae5d0d92bfbe$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $ce09ae5d0d92bfbe$var$isVisibleUncached = function(node, checkParent) {
    return !node || $ce09ae5d0d92bfbe$var$isTopNode(node) || !$ce09ae5d0d92bfbe$var$isElementHidden(node) && checkParent($ce09ae5d0d92bfbe$var$getParentNode(node));
};
var $ce09ae5d0d92bfbe$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $ce09ae5d0d92bfbe$var$isVisibleUncached(node, $ce09ae5d0d92bfbe$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $ce09ae5d0d92bfbe$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$ce09ae5d0d92bfbe$var$isTopNode(node) ? $ce09ae5d0d92bfbe$export$b8550e27de209d85(node) ? checkParent($ce09ae5d0d92bfbe$var$getParentNode(node)) : false : true;
};
var $ce09ae5d0d92bfbe$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $ce09ae5d0d92bfbe$var$isAutoFocusAllowedUncached(node, $ce09ae5d0d92bfbe$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $ce09ae5d0d92bfbe$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $ce09ae5d0d92bfbe$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $ce09ae5d0d92bfbe$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $ce09ae5d0d92bfbe$export$9d74f6fbc6f469d0 = function(node) {
    return $ce09ae5d0d92bfbe$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $ce09ae5d0d92bfbe$export$8197b0ea56b3b055 = function(node) {
    return !(($ce09ae5d0d92bfbe$export$88a6ceeed5737ba3(node) || $ce09ae5d0d92bfbe$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $ce09ae5d0d92bfbe$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $9d7xu.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $ce09ae5d0d92bfbe$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $ce09ae5d0d92bfbe$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $ce09ae5d0d92bfbe$export$602e5a0d338d7750 = function(node) {
    return !$ce09ae5d0d92bfbe$export$d94b8b58ec2f30eb(node);
};
var $ce09ae5d0d92bfbe$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("30P9V", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", function () { return $23190e518d614f62$export$cb40ee071f0d5226; });

var $7gG5g = parcelRequire("7gG5g");
var $23190e518d614f62$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $23190e518d614f62$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $7gG5g.toArray)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($23190e518d614f62$export$350ee6c095d98996);
};

});

parcelRegister("CBsca", function(module, exports) {
$parcel$export(module.exports, "getFocusables", function () { return $07409a4307f015b3$export$f6768025e418420e; });
$parcel$export(module.exports, "getParentAutofocusables", function () { return $07409a4307f015b3$export$853fa94d922e78b9; });

var $9d7xu = parcelRequire("9d7xu");

var $7gG5g = parcelRequire("7gG5g");

var $dXN4M = parcelRequire("dXN4M");
var $07409a4307f015b3$var$queryTabbables = (0, $dXN4M.tabbables).join(',');
var $07409a4307f015b3$var$queryGuardTabbables = "".concat($07409a4307f015b3$var$queryTabbables, ", [data-focus-guard]");
var $07409a4307f015b3$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $7gG5g.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $07409a4307f015b3$var$queryGuardTabbables : $07409a4307f015b3$var$queryTabbables) ? [
            child
        ] : [], $07409a4307f015b3$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $07409a4307f015b3$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $07409a4307f015b3$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $07409a4307f015b3$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $07409a4307f015b3$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $07409a4307f015b3$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $7gG5g.toArray)(parent.parentNode.querySelectorAll($07409a4307f015b3$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $07409a4307f015b3$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $9d7xu.FOCUS_AUTO), "]"));
    return (0, $7gG5g.toArray)(parentFocus).map(function(node) {
        return $07409a4307f015b3$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("dXN4M", function(module, exports) {
$parcel$export(module.exports, "tabbables", function () { return $a2a6da8fbd2b9e1f$export$8555f4622e95784; });
/**
 * list of the object to be considered as focusable
 */ var $a2a6da8fbd2b9e1f$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});



parcelRegister("swPek", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", function () { return $055c140efd238da8$export$7e87c4720b9b279b; });

var $9d7xu = parcelRequire("9d7xu");

var $7gG5g = parcelRequire("7gG5g");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $055c140efd238da8$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $055c140efd238da8$var$getTopParent = function(node) {
    return node.parentNode ? $055c140efd238da8$var$getTopParent(node.parentNode) : node;
};
var $055c140efd238da8$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $7gG5g.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $9d7xu.FOCUS_GROUP));
        acc.push.apply(acc, group ? $055c140efd238da8$var$filterNested((0, $7gG5g.toArray)($055c140efd238da8$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $9d7xu.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $9d7xu.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("bzYdB", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", function () { return $86e1acb519019e6f$export$a9a7252b5f2e280e; });
$parcel$export(module.exports, "allParentAutofocusables", function () { return $86e1acb519019e6f$export$8f99714c70a37db1; });

var $ihusC = parcelRequire("ihusC");

var $7gG5g = parcelRequire("7gG5g");
var $86e1acb519019e6f$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $86e1acb519019e6f$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $86e1acb519019e6f$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $86e1acb519019e6f$var$getParents(nodeA);
    var parentsB = $86e1acb519019e6f$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $86e1acb519019e6f$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $7gG5g.asArray)(baseActiveElement);
    var leftEntries = (0, $7gG5g.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $86e1acb519019e6f$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $86e1acb519019e6f$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $ihusC.contains)(common, topCommon)) topCommon = common;
                else topCommon = $86e1acb519019e6f$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $86e1acb519019e6f$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $ihusC.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("azUCw", function(module, exports) {
$parcel$export(module.exports, "focusInside", function () { return $7b3917dd5aa16a4b$export$20115f8da7baa6fa; });

var $ihusC = parcelRequire("ihusC");

var $swPek = parcelRequire("swPek");

var $7gG5g = parcelRequire("7gG5g");

var $gk8w8 = parcelRequire("gk8w8");
var $7b3917dd5aa16a4b$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $7b3917dd5aa16a4b$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $7gG5g.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $7b3917dd5aa16a4b$var$focusInFrame(node, activeElement);
    }));
};
var $7b3917dd5aa16a4b$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $gk8w8.getActiveElement)((0, $7gG5g.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $swPek.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $ihusC.contains)(node, activeElement) || $7b3917dd5aa16a4b$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("gk8w8", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", function () { return $be251ef3a5de468f$export$cd4e5573fbe2b576; });
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $h5u8x = parcelRequire("h5u8x");
var $be251ef3a5de468f$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $be251ef3a5de468f$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $h5u8x.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $be251ef3a5de468f$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("h5u8x", function(module, exports) {
$parcel$export(module.exports, "safeProbe", function () { return $c70a47d6a2364e8f$export$78d20aae35adef88; });
var $c70a47d6a2364e8f$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("9gZ1p", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", function () { return $6c04f1513093c8bf$export$be6b21806d3fd485; });

var $9d7xu = parcelRequire("9d7xu");

var $ihusC = parcelRequire("ihusC");

var $7gG5g = parcelRequire("7gG5g");

var $gk8w8 = parcelRequire("gk8w8");
var $6c04f1513093c8bf$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $gk8w8.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $7gG5g.toArray)(inDocument.querySelectorAll("[".concat((0, $9d7xu.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $ihusC.contains)(node, activeElement);
    });
};

});

parcelRegister("5uZTH", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", function () { return (parcelRequire("7pPse")).moveFocusInside; });

var $9d7xu = parcelRequire("9d7xu");

var $azUCw = parcelRequire("azUCw");

var $9gZ1p = parcelRequire("9gZ1p");


var $7IutG = parcelRequire("7IutG");

var $7pPse = parcelRequire("7pPse");


/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $400fc4a18df52aa0$export$1a988e7317c65621 = $9d7xu;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $400fc4a18df52aa0$var$deprecated_default_moveFocusInside = (0, $7pPse.moveFocusInside);
var $400fc4a18df52aa0$export$2e2bcd8739ae039 //
 = $400fc4a18df52aa0$var$deprecated_default_moveFocusInside;

});
parcelRegister("7pPse", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", function () { return $5662c7f0c9e58918$export$cd599851e879a025; });

var $46UVV = parcelRequire("46UVV");

var $2B6dD = parcelRequire("2B6dD");
var $5662c7f0c9e58918$var$guardCount = 0;
var $5662c7f0c9e58918$var$lockDisabled = false;
var $5662c7f0c9e58918$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $2B6dD.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($5662c7f0c9e58918$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($5662c7f0c9e58918$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $5662c7f0c9e58918$var$lockDisabled = true;
            setTimeout(function() {
                $5662c7f0c9e58918$var$lockDisabled = false;
            }, 1);
            return;
        }
        $5662c7f0c9e58918$var$guardCount++;
        (0, $46UVV.focusOn)(focusable.node, options.focusOptions);
        $5662c7f0c9e58918$var$guardCount--;
    }
};

});
parcelRegister("46UVV", function(module, exports) {
$parcel$export(module.exports, "focusOn", function () { return $2fe3e2b47ad41420$export$c12b3da842c43a8; });
var $2fe3e2b47ad41420$export$c12b3da842c43a8 = function(target, focusOptions) {
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});

parcelRegister("2B6dD", function(module, exports) {
$parcel$export(module.exports, "focusSolver", function () { return $1e43dc65a812190c$export$305758c744b57f6f; });

var $bj0OW = parcelRequire("bj0OW");

var $ihusC = parcelRequire("ihusC");

var $swPek = parcelRequire("swPek");

var $7gG5g = parcelRequire("7gG5g");

var $l21Se = parcelRequire("l21Se");

var $gk8w8 = parcelRequire("gk8w8");

var $hGJxh = parcelRequire("hGJxh");

var $bzYdB = parcelRequire("bzYdB");
var $1e43dc65a812190c$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $hGJxh.isDefined));
};
var $1e43dc65a812190c$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $gk8w8.getActiveElement)((0, $7gG5g.asArray)(topNode).length > 0 ? document : (0, $7gG5g.getFirst)(topNode).ownerDocument);
    var entries = (0, $swPek.getAllAffectedNodes)(topNode).filter((0, $hGJxh.isNotAGuard));
    var commonParent = (0, $bzYdB.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $ihusC.getFocusableNodes)(entries, visibilityCache);
    var innerElements = (0, $ihusC.getTabbableNodes)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $hGJxh.isNotAGuard)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $ihusC.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $1e43dc65a812190c$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $bj0OW.newFocus)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $bj0OW.NEW_FOCUS)) {
        var focusNode = (0, $l21Se.pickAutofocus)(anyFocusable, innerNodes, (0, $bzYdB.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("bj0OW", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", function () { return $83b21b01ce0ace0e$export$85710b12cf912438; });
$parcel$export(module.exports, "newFocus", function () { return $83b21b01ce0ace0e$export$65842178e9bb4205; });

var $k45Aj = parcelRequire("k45Aj");

var $5s83B = parcelRequire("5s83B");

var $hGJxh = parcelRequire("hGJxh");
var $83b21b01ce0ace0e$export$85710b12cf912438 = 'NEW_FOCUS';
var $83b21b01ce0ace0e$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $hGJxh.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $k45Aj.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $5s83B.pickFocusable)(innerNodes, 0);
    var returnLastNode = (0, $5s83B.pickFocusable)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return $83b21b01ce0ace0e$export$85710b12cf912438;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("k45Aj", function(module, exports) {
$parcel$export(module.exports, "correctNode", function () { return $e9b883636b268d28$export$5261662167ad7ced; });
$parcel$export(module.exports, "correctNodes", function () { return $e9b883636b268d28$export$4a5a72a7124e45f9; });

var $hGJxh = parcelRequire("hGJxh");
var $e9b883636b268d28$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $hGJxh.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $e9b883636b268d28$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $hGJxh.isRadioElement)(node) && node.name) return $e9b883636b268d28$var$findSelectedRadio(node, nodes);
    return node;
};
var $e9b883636b268d28$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($e9b883636b268d28$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("5s83B", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", function () { return $3f85d1444be2e558$export$f4e86cfa0679b9cc; });
$parcel$export(module.exports, "pickFocusable", function () { return $3f85d1444be2e558$export$e06728ee87c96122; });

var $k45Aj = parcelRequire("k45Aj");
var $3f85d1444be2e558$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $k45Aj.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $3f85d1444be2e558$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $k45Aj.correctNode)(nodes[index], nodes));
    return index;
};

});


parcelRegister("l21Se", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", function () { return $f4fb3cf79b9ee503$export$cfb742983e257555; });

var $ihusC = parcelRequire("ihusC");

var $5s83B = parcelRequire("5s83B");

var $hGJxh = parcelRequire("hGJxh");
var $f4fb3cf79b9ee503$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $hGJxh.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $f4fb3cf79b9ee503$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $ihusC.filterAutoFocusable)(nodes.filter($f4fb3cf79b9ee503$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $5s83B.pickFirstFocus)(autoFocusable);
    return (0, $5s83B.pickFirstFocus)((0, $ihusC.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("5lEmx", function(module, exports) {
$parcel$export(module.exports, "deferAction", function () { return $3e4e39113cf2eef1$export$6523025722806278; });
function $3e4e39113cf2eef1$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $3e4e39113cf2eef1$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};

});




parcelRegister("4cgdq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j0iWu = parcelRequire("j0iWu");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $30e4dc74b17c59d4$var$_interopRequireDefault($j0iWu).default;
    }
});

var $6SYMg = parcelRequire("6SYMg");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $6SYMg.TouchScrollable;
    }
});
function $30e4dc74b17c59d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("j0iWu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dd5cb5f261987dfc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1oC0p = parcelRequire("1oC0p");
var $dd5cb5f261987dfc$var$_react2 = $dd5cb5f261987dfc$var$_interopRequireDefault($1oC0p);

var $eiRlr = parcelRequire("eiRlr");

var $6SYMg = parcelRequire("6SYMg");

var $iPBPe = parcelRequire("iPBPe");
var $dd5cb5f261987dfc$var$_withLockSheet2 = $dd5cb5f261987dfc$var$_interopRequireDefault($iPBPe);

var $cgSqI = parcelRequire("cgSqI");
var $dd5cb5f261987dfc$var$_withTouchListeners2 = $dd5cb5f261987dfc$var$_interopRequireDefault($cgSqI);

var $c6JC4 = parcelRequire("c6JC4");
function $dd5cb5f261987dfc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dd5cb5f261987dfc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dd5cb5f261987dfc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $dd5cb5f261987dfc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $dd5cb5f261987dfc$var$ScrollLock = function(_PureComponent) {
    $dd5cb5f261987dfc$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $dd5cb5f261987dfc$var$_classCallCheck(this, ScrollLock);
        return $dd5cb5f261987dfc$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $dd5cb5f261987dfc$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$eiRlr.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $dd5cb5f261987dfc$var$_react2.default.createElement($6SYMg.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($1oC0p.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $dd5cb5f261987dfc$var$compose = (0, $c6JC4.pipe)($dd5cb5f261987dfc$var$_withTouchListeners2.default, $dd5cb5f261987dfc$var$_withLockSheet2.default);
var $dd5cb5f261987dfc$var$SheetLock = $dd5cb5f261987dfc$var$compose($dd5cb5f261987dfc$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $dd5cb5f261987dfc$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $dd5cb5f261987dfc$var$_react2.default.createElement($dd5cb5f261987dfc$var$SheetLock, props) : props.children;
};
$dd5cb5f261987dfc$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $dd5cb5f261987dfc$var$LockToggle;

});
parcelRegister("eiRlr", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("6SYMg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $5036ee5f0630f3b6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5036ee5f0630f3b6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1oC0p = parcelRequire("1oC0p");

var $eiRlr = parcelRequire("eiRlr");

var $c6JC4 = parcelRequire("c6JC4");
function $5036ee5f0630f3b6$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5036ee5f0630f3b6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5036ee5f0630f3b6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5036ee5f0630f3b6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5036ee5f0630f3b6$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $5036ee5f0630f3b6$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $5036ee5f0630f3b6$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $5036ee5f0630f3b6$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $5036ee5f0630f3b6$var$_possibleConstructorReturn(_this, _ret);
    }
    $5036ee5f0630f3b6$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$eiRlr.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $c6JC4.preventInertiaScroll, $c6JC4.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $c6JC4.allowTouchMove, $c6JC4.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$eiRlr.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $c6JC4.preventInertiaScroll, $c6JC4.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $c6JC4.allowTouchMove, $c6JC4.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $5036ee5f0630f3b6$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $1oC0p.cloneElement)(children, $5036ee5f0630f3b6$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($1oC0p.PureComponent);

});
parcelRegister("c6JC4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $8d096d6415d8fd2a$var$preventTouchMove;
module.exports.allowTouchMove = $8d096d6415d8fd2a$var$allowTouchMove;
module.exports.preventInertiaScroll = $8d096d6415d8fd2a$var$preventInertiaScroll;
module.exports.isTouchDevice = $8d096d6415d8fd2a$var$isTouchDevice;
module.exports.camelToKebab = $8d096d6415d8fd2a$var$camelToKebab;
module.exports.parse = $8d096d6415d8fd2a$var$parse;
module.exports.getPadding = $8d096d6415d8fd2a$var$getPadding;
module.exports.getWindowHeight = $8d096d6415d8fd2a$var$getWindowHeight;
module.exports.getDocumentHeight = $8d096d6415d8fd2a$var$getDocumentHeight;
module.exports.makeStyleTag = $8d096d6415d8fd2a$var$makeStyleTag;
module.exports.injectStyles = $8d096d6415d8fd2a$var$injectStyles;
module.exports.insertStyleTag = $8d096d6415d8fd2a$var$insertStyleTag;

var $eiRlr = parcelRequire("eiRlr");
var $8d096d6415d8fd2a$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $8d096d6415d8fd2a$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $8d096d6415d8fd2a$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $8d096d6415d8fd2a$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $8d096d6415d8fd2a$var$isTouchDevice() {
    if (!$eiRlr.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $8d096d6415d8fd2a$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $8d096d6415d8fd2a$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $8d096d6415d8fd2a$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $8d096d6415d8fd2a$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($8d096d6415d8fd2a$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $8d096d6415d8fd2a$var$getPadding() {
    if (!$eiRlr.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $8d096d6415d8fd2a$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($eiRlr.canUseDOM) return window.innerHeight * multiplier;
}
function $8d096d6415d8fd2a$var$getDocumentHeight() {
    if ($eiRlr.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $8d096d6415d8fd2a$var$makeStyleTag() {
    if (!$eiRlr.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $8d096d6415d8fd2a$var$injectStyles(tag, css) {
    if (!$eiRlr.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $8d096d6415d8fd2a$var$insertStyleTag(tag) {
    if (!$eiRlr.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("iPBPe", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $db5a54b601536da4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $db5a54b601536da4$var$withLockSheet;

var $1oC0p = parcelRequire("1oC0p");
var $db5a54b601536da4$var$_react2 = $db5a54b601536da4$var$_interopRequireDefault($1oC0p);

var $c6JC4 = parcelRequire("c6JC4");
function $db5a54b601536da4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $db5a54b601536da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $db5a54b601536da4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $db5a54b601536da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $db5a54b601536da4$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $db5a54b601536da4$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $db5a54b601536da4$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $db5a54b601536da4$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $c6JC4.makeStyleTag)();
                if (!sheet) return;
                (0, $c6JC4.injectStyles)(sheet, styles);
                (0, $c6JC4.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $c6JC4.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $c6JC4.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $db5a54b601536da4$var$_possibleConstructorReturn(_this, _ret);
        }
        $db5a54b601536da4$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $db5a54b601536da4$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($1oC0p.PureComponent);
}

});

parcelRegister("cgSqI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8ef13353166c4dcb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $8ef13353166c4dcb$var$withTouchListeners;

var $1oC0p = parcelRequire("1oC0p");
var $8ef13353166c4dcb$var$_react2 = $8ef13353166c4dcb$var$_interopRequireDefault($1oC0p);

var $eiRlr = parcelRequire("eiRlr");

var $c6JC4 = parcelRequire("c6JC4");
function $8ef13353166c4dcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ef13353166c4dcb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ef13353166c4dcb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8ef13353166c4dcb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $8ef13353166c4dcb$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $8ef13353166c4dcb$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $8ef13353166c4dcb$var$_classCallCheck(this, TouchProvider);
            return $8ef13353166c4dcb$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $8ef13353166c4dcb$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$eiRlr.canUseDOM || !(0, $c6JC4.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $c6JC4.preventTouchMove, $c6JC4.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$eiRlr.canUseDOM || !(0, $c6JC4.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $c6JC4.preventTouchMove, $c6JC4.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $8ef13353166c4dcb$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($1oC0p.PureComponent);
}

});



parcelRegister("FcSvA", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $07bdd1c92fd5165e$export$a4687b0234b40e28; });

var $4Lw69 = parcelRequire("4Lw69");

var $1oC0p = parcelRequire("1oC0p");

var $dKI6C = parcelRequire("dKI6C");

var $3DG3U = parcelRequire("3DG3U");
function $07bdd1c92fd5165e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07bdd1c92fd5165e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07bdd1c92fd5165e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4Lw69.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07bdd1c92fd5165e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $07bdd1c92fd5165e$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $dKI6C.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $3DG3U.useTrackedRef)(analyticsData);
    var fnRef = (0, $3DG3U.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $07bdd1c92fd5165e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("4Lw69", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $37847341439f35d2$export$2e2bcd8739ae039; });

var $1PbIF = parcelRequire("1PbIF");
function $37847341439f35d2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $1PbIF.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("1PbIF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1543a51eabdc26fa$export$2e2bcd8739ae039; });

var $judOO = parcelRequire("judOO");

var $6Z90c = parcelRequire("6Z90c");
function $1543a51eabdc26fa$export$2e2bcd8739ae039(t) {
    var i = (0, $6Z90c.default)(t, "string");
    return "symbol" == (0, $judOO.default)(i) ? i : i + "";
}

});
parcelRegister("judOO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e2fb89c362c076f8$export$2e2bcd8739ae039; });
function $e2fb89c362c076f8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e2fb89c362c076f8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e2fb89c362c076f8$export$2e2bcd8739ae039(o);
}

});

parcelRegister("6Z90c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $515f6c420bd3878d$export$2e2bcd8739ae039; });

var $judOO = parcelRequire("judOO");
function $515f6c420bd3878d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $judOO.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $judOO.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("dKI6C", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $a031c8bcc4ac088e$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $49CSm = parcelRequire("49CSm");

var $g2ynq = parcelRequire("g2ynq");
function $a031c8bcc4ac088e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $g2ynq.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $49CSm.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("49CSm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3066289ac7d9c63f$export$2e2bcd8739ae039; });

var $2YC7S = parcelRequire("2YC7S");

var $jubW3 = parcelRequire("jubW3");

var $4FpAx = parcelRequire("4FpAx");

var $k5l8k = parcelRequire("k5l8k");

var $5k9PF = parcelRequire("5k9PF");

var $l4jBH = parcelRequire("l4jBH");

var $ghq8T = parcelRequire("ghq8T");

var $4Lw69 = parcelRequire("4Lw69");

var $6g5id = parcelRequire("6g5id");
function $3066289ac7d9c63f$var$_callSuper(t, o, e) {
    return o = (0, $5k9PF.default)(o), (0, $k5l8k.default)(t, $3066289ac7d9c63f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $5k9PF.default)(t).constructor) : o.apply(t, e));
}
function $3066289ac7d9c63f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3066289ac7d9c63f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3066289ac7d9c63f$var$_superPropGet(t, o, e, r) {
    var p = (0, $l4jBH.default)((0, $5k9PF.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $3066289ac7d9c63f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $3066289ac7d9c63f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $3066289ac7d9c63f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $jubW3.default)(this, UIAnalyticsEvent);
        _this = $3066289ac7d9c63f$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $4Lw69.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $4Lw69.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $2YC7S.default)(_this.context);
            var handlers = (0, $2YC7S.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $4Lw69.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $ghq8T.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $4FpAx.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $3066289ac7d9c63f$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $6g5id.default));

});
parcelRegister("2YC7S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $22aec269e7aef7d5$export$2e2bcd8739ae039; });

var $bKJQa = parcelRequire("bKJQa");

var $c5xj3 = parcelRequire("c5xj3");

var $hxRB7 = parcelRequire("hxRB7");

var $4G5tP = parcelRequire("4G5tP");
function $22aec269e7aef7d5$export$2e2bcd8739ae039(r) {
    return (0, $bKJQa.default)(r) || (0, $c5xj3.default)(r) || (0, $hxRB7.default)(r) || (0, $4G5tP.default)();
}

});
parcelRegister("bKJQa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $88e78c8bd0bed87b$export$2e2bcd8739ae039; });

var $fhb6h = parcelRequire("fhb6h");
function $88e78c8bd0bed87b$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $fhb6h.default)(r);
}

});
parcelRegister("fhb6h", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b1f10dd31f621613$export$2e2bcd8739ae039; });
function $b1f10dd31f621613$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("c5xj3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8ccfc99f6c179ea1$export$2e2bcd8739ae039; });
function $8ccfc99f6c179ea1$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("hxRB7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc5f181fc3792d3c$export$2e2bcd8739ae039; });

var $fhb6h = parcelRequire("fhb6h");
function $cc5f181fc3792d3c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fhb6h.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fhb6h.default)(r, a) : void 0;
    }
}

});

parcelRegister("4G5tP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $367f55ed7bdef8fb$export$2e2bcd8739ae039; });
function $367f55ed7bdef8fb$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jubW3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e2fa13c3135ca5b9$export$2e2bcd8739ae039; });
function $e2fa13c3135ca5b9$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("4FpAx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $365ed7125305e312$export$2e2bcd8739ae039; });

var $1PbIF = parcelRequire("1PbIF");
function $365ed7125305e312$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $1PbIF.default)(o.key), o);
    }
}
function $365ed7125305e312$export$2e2bcd8739ae039(e, r, t) {
    return r && $365ed7125305e312$var$_defineProperties(e.prototype, r), t && $365ed7125305e312$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("k5l8k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9f4aae6dbbe6ced$export$2e2bcd8739ae039; });

var $judOO = parcelRequire("judOO");

var $lzoi3 = parcelRequire("lzoi3");
function $e9f4aae6dbbe6ced$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $judOO.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $lzoi3.default)(t);
}

});
parcelRegister("lzoi3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fb3fb565a4303e88$export$2e2bcd8739ae039; });
function $fb3fb565a4303e88$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("5k9PF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e067285f88597a8$export$2e2bcd8739ae039; });
function $3e067285f88597a8$export$2e2bcd8739ae039(t) {
    return $3e067285f88597a8$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $3e067285f88597a8$export$2e2bcd8739ae039(t);
}

});

parcelRegister("l4jBH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f5692e442ad2551c$export$2e2bcd8739ae039; });

var $8xglT = parcelRequire("8xglT");
function $f5692e442ad2551c$export$2e2bcd8739ae039() {
    return $f5692e442ad2551c$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $8xglT.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $f5692e442ad2551c$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("8xglT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $019a8cc1eb293174$export$2e2bcd8739ae039; });

var $5k9PF = parcelRequire("5k9PF");
function $019a8cc1eb293174$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $5k9PF.default)(t)););
    return t;
}

});


parcelRegister("ghq8T", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bda28338b0ab8409$export$2e2bcd8739ae039; });

var $cWOFc = parcelRequire("cWOFc");
function $bda28338b0ab8409$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $cWOFc.default)(t, e);
}

});
parcelRegister("cWOFc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $96d2338bfc8e9b1a$export$2e2bcd8739ae039; });
function $96d2338bfc8e9b1a$export$2e2bcd8739ae039(t, e) {
    return $96d2338bfc8e9b1a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $96d2338bfc8e9b1a$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6g5id", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $48e857b81b4214ef$export$2e2bcd8739ae039; });

var $judOO = parcelRequire("judOO");

var $jubW3 = parcelRequire("jubW3");

var $4FpAx = parcelRequire("4FpAx");

var $4Lw69 = parcelRequire("4Lw69");
function $48e857b81b4214ef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48e857b81b4214ef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48e857b81b4214ef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4Lw69.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48e857b81b4214ef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $48e857b81b4214ef$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $48e857b81b4214ef$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $48e857b81b4214ef$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $jubW3.default)(this, AnalyticsEvent);
        (0, $4Lw69.default)(this, "_isAnalyticsEvent", true);
        (0, $4Lw69.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $48e857b81b4214ef$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $4FpAx.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $judOO.default)(updater) === 'object') this.payload = $48e857b81b4214ef$var$_objectSpread($48e857b81b4214ef$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("g2ynq", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $bad77fc3269dc3ba$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $bad77fc3269dc3ba$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("3DG3U", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $2a65a449be554a9e$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $2a65a449be554a9e$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("d4hXj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $983993ad21dfe630$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.32.2 */ 
var $4Lw69 = parcelRequire("4Lw69");

var $1oC0p = parcelRequire("1oC0p");

var $iSQdw = parcelRequire("iSQdw");
var $4c5A8 = parcelRequire("4c5A8");

var $FcSvA = parcelRequire("FcSvA");

var $9qszB = parcelRequire("9qszB");

var $lK8iO = parcelRequire("lK8iO");

function $983993ad21dfe630$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983993ad21dfe630$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983993ad21dfe630$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4Lw69.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983993ad21dfe630$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $983993ad21dfe630$var$packageName = "@atlaskit/blanket";
var $983993ad21dfe630$var$packageVersion = "14.0.0";
var $983993ad21dfe630$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $983993ad21dfe630$var$packageName,
    packageVersion: $983993ad21dfe630$var$packageVersion
};
var $983993ad21dfe630$var$baseStyles = null;
var $983993ad21dfe630$var$shouldAllowClickThroughStyles = null;
var $983993ad21dfe630$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $983993ad21dfe630$var$Blanket = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $9qszB.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $1oC0p.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $FcSvA.usePlatformLeafEventHandler)($983993ad21dfe630$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $983993ad21dfe630$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $1oC0p.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $1oC0p.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $iSQdw.default)([
            "_kqsw1n9t _1pbybfng _1r04idpf _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk18uv"
        ]),
        style: {
            "--_10avjlk": (0, $4c5A8.default)("var(--ds-blanket, ".concat((0, $lK8iO.N100A), ")"))
        }
    }, children);
}));
$983993ad21dfe630$var$Blanket.displayName = 'Blanket';
var $983993ad21dfe630$export$2e2bcd8739ae039 = $983993ad21dfe630$var$Blanket;

});
parcelRegister("iSQdw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dbf5c65d81208c45$export$2e2bcd8739ae039; });
const $dbf5c65d81208c45$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $dbf5c65d81208c45$var$ATOMIC_GROUP_LENGTH = 5;
function $dbf5c65d81208c45$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $dbf5c65d81208c45$var$UNDERSCORE_UNICODE ? $dbf5c65d81208c45$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("4c5A8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $30dc9cdcc031a599$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $30dc9cdcc031a599$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("9qszB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6dccb4d3986d7a15$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $6dccb4d3986d7a15$export$2e2bcd8739ae039() {}

});

parcelRegister("lK8iO", function(module, exports) {
$parcel$export(module.exports, "R400", function () { return $0415bf5099215c8f$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B200", function () { return $0415bf5099215c8f$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $0415bf5099215c8f$export$29a4f05edc054374; });
$parcel$export(module.exports, "N30", function () { return $0415bf5099215c8f$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N900", function () { return $0415bf5099215c8f$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N20A", function () { return $0415bf5099215c8f$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $0415bf5099215c8f$export$920c0d5c49070351; });
$parcel$export(module.exports, "N60A", function () { return $0415bf5099215c8f$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N100A", function () { return $0415bf5099215c8f$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $0415bf5099215c8f$export$4b84fd0e2c617bd = '#FFEBE6';
var $0415bf5099215c8f$export$b34b069eff244586 = '#FFBDAD';
var $0415bf5099215c8f$export$be802dd0d8b57f35 = '#FF8F73';
var $0415bf5099215c8f$export$60847d42f9da92a6 = '#FF7452';
var $0415bf5099215c8f$export$4a7404f376229999 = '#FF5630';
var $0415bf5099215c8f$export$2010d0fb4295b346 = '#DE350B';
var $0415bf5099215c8f$export$2837b5a1a71d5c02 = '#BF2600';
var $0415bf5099215c8f$export$8d9596b529bbb9cf = '#FFFAE6';
var $0415bf5099215c8f$export$41060a744ab0b7ae = '#FFF0B3';
var $0415bf5099215c8f$export$1cc05bbbf340e559 = '#FFE380';
var $0415bf5099215c8f$export$5aae31392d72caaa = '#FFC400';
var $0415bf5099215c8f$export$c6930421db9fa514 = '#FFAB00';
var $0415bf5099215c8f$export$59619663aa6500fb = '#FF991F';
var $0415bf5099215c8f$export$874739ea9e379ab6 = '#FF8B00';
var $0415bf5099215c8f$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $0415bf5099215c8f$export$69a3bf21b9686c2b = '#ABF5D1';
var $0415bf5099215c8f$export$afbce1382ec95f73 = '#79F2C0';
var $0415bf5099215c8f$export$747d86715d4175de = '#57D9A3';
var $0415bf5099215c8f$export$940e1f69e873f202 = '#36B37E';
var $0415bf5099215c8f$export$a49394138f7b8e85 = '#00875A';
var $0415bf5099215c8f$export$6fa04827ac68a4fb = '#006644';
var $0415bf5099215c8f$export$226de0355ed012f8 = '#DEEBFF';
var $0415bf5099215c8f$export$8c13c2ee36917869 = '#B3D4FF';
var $0415bf5099215c8f$export$ecfc1dff386a3e7a = '#4C9AFF';
var $0415bf5099215c8f$export$215b7063051591f1 = '#2684FF';
var $0415bf5099215c8f$export$e62e8919cca44969 = '#0065FF';
var $0415bf5099215c8f$export$b3de0ae08da2ce64 = '#0052CC';
var $0415bf5099215c8f$export$a6ee3d71bc067634 = '#0747A6';
var $0415bf5099215c8f$export$67f15409e87642a1 = '#669DF1';
var $0415bf5099215c8f$export$f0539dbc42dbb067 = '#8FB8F6';
var $0415bf5099215c8f$export$363e4475840015bb = '#EAE6FF';
var $0415bf5099215c8f$export$4b0a4417ed59760f = '#C0B6F2';
var $0415bf5099215c8f$export$6011520a64d9a187 = '#998DD9';
var $0415bf5099215c8f$export$a7175d4e9206bc80 = '#8777D9';
var $0415bf5099215c8f$export$b48405b95304b5a1 = '#6554C0';
var $0415bf5099215c8f$export$c71e4279dd54a18d = '#5243AA';
var $0415bf5099215c8f$export$147899de772240ec = '#403294';
var $0415bf5099215c8f$export$2cf711fe14c66f06 = '#E6FCFF';
var $0415bf5099215c8f$export$7a8f4d33f6f9772c = '#B3F5FF';
var $0415bf5099215c8f$export$776c9c497ef08533 = '#79E2F2';
var $0415bf5099215c8f$export$69cb3ca10c1e330e = '#00C7E6';
var $0415bf5099215c8f$export$9dc1ef0f3f48059b = '#00B8D9';
var $0415bf5099215c8f$export$7c835c78b6fcdef8 = '#00A3BF';
var $0415bf5099215c8f$export$6036577f95c3877e = '#008DA6';
var $0415bf5099215c8f$export$29a4f05edc054374 = '#FFFFFF';
var $0415bf5099215c8f$export$e655ef011c4aa1a2 = '#FAFBFC';
var $0415bf5099215c8f$export$9fdfb749e33cdf97 = '#F4F5F7';
var $0415bf5099215c8f$export$3e51e8f1440314ba = '#EBECF0';
var $0415bf5099215c8f$export$1ce2d1575d444ceb = '#DFE1E6';
var $0415bf5099215c8f$export$8754fc7e6d8b3000 = '#C1C7D0';
var $0415bf5099215c8f$export$c2e91cbeada39b8b = '#B3BAC5';
var $0415bf5099215c8f$export$5f71e19f3a7ad9de = '#A5ADBA';
var $0415bf5099215c8f$export$eaa8c8a70ac22806 = '#97A0AF';
var $0415bf5099215c8f$export$7c87d337fb91a97d = '#8993A4';
var $0415bf5099215c8f$export$d6447c357493214f = '#7A869A';
var $0415bf5099215c8f$export$f563ee71e9ee74cd = '#6B778C';
var $0415bf5099215c8f$export$e2ef2124cf4024b1 = '#5E6C84';
var $0415bf5099215c8f$export$eece5f492e429f08 = '#505F79';
var $0415bf5099215c8f$export$c39c0fe0f26207ae = '#42526E';
var $0415bf5099215c8f$export$7090862dc3038a9f = '#344563';
var $0415bf5099215c8f$export$ad0bacf983b7ddaa = '#253858';
var $0415bf5099215c8f$export$7d61b15e0da132af = '#172B4D';
var $0415bf5099215c8f$export$fbda843f0a27fe96 = '#091E42';
var $0415bf5099215c8f$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $0415bf5099215c8f$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $0415bf5099215c8f$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $0415bf5099215c8f$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $0415bf5099215c8f$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $0415bf5099215c8f$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $0415bf5099215c8f$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $0415bf5099215c8f$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $0415bf5099215c8f$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $0415bf5099215c8f$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $0415bf5099215c8f$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $0415bf5099215c8f$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $0415bf5099215c8f$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $0415bf5099215c8f$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $0415bf5099215c8f$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $0415bf5099215c8f$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $0415bf5099215c8f$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $0415bf5099215c8f$export$2f6319cf7d736c2a = '#E6EDFA';
var $0415bf5099215c8f$export$95126bc8884d6634 = '#DCE5F5';
var $0415bf5099215c8f$export$8338d8c35d44ff1 = '#CED9EB';
var $0415bf5099215c8f$export$5368d76ae4fbbda7 = '#B8C7E0';
var $0415bf5099215c8f$export$9f0a771d16ec8d36 = '#ABBBD6';
var $0415bf5099215c8f$export$abcf8c38338b4aa5 = '#9FB0CC';
var $0415bf5099215c8f$export$97e81faa16a182c7 = '#8C9CB8';
var $0415bf5099215c8f$export$bfe21c59123ecf33 = '#7988A3';
var $0415bf5099215c8f$export$ee82aa2ea6a1558 = '#67758F';
var $0415bf5099215c8f$export$682927c6ed76be02 = '#56637A';
var $0415bf5099215c8f$export$91fd9994c5be9757 = '#455166';
var $0415bf5099215c8f$export$d281fbfe3cff2df6 = '#3B475C';
var $0415bf5099215c8f$export$3902c91d8b98a753 = '#313D52';
var $0415bf5099215c8f$export$8e8133c1ba5845b5 = '#283447';
var $0415bf5099215c8f$export$33ff357f6620b39 = '#202B3D';
var $0415bf5099215c8f$export$633847cf062b69e0 = '#1B2638';
var $0415bf5099215c8f$export$9776a6e503bdbf76 = '#121A29';
var $0415bf5099215c8f$export$6c813d5160dff5db = '#0E1624';
var $0415bf5099215c8f$export$3d4f271a500072a = '#0D1424';
var $0415bf5099215c8f$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $0415bf5099215c8f$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $0415bf5099215c8f$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $0415bf5099215c8f$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $0415bf5099215c8f$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $0415bf5099215c8f$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $0415bf5099215c8f$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $0415bf5099215c8f$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $0415bf5099215c8f$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $0415bf5099215c8f$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $0415bf5099215c8f$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $0415bf5099215c8f$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $0415bf5099215c8f$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $0415bf5099215c8f$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $0415bf5099215c8f$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $0415bf5099215c8f$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $0415bf5099215c8f$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $0415bf5099215c8f$export$d2adc5dedf09fced = '#292A2E';
var $0415bf5099215c8f$export$f51762073d2bb381 = '#94C748';
var $0415bf5099215c8f$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("jFq2q", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $e5160b4a9d0de0d0$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $e5160b4a9d0de0d0$export$48b383b280e20440; });
$parcel$export(module.exports, "Layering", function () { return $e5160b4a9d0de0d0$export$7c885f891c940977; });

var $1oC0p = parcelRequire("1oC0p");

var $9qszB = parcelRequire("9qszB");
var $e5160b4a9d0de0d0$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $e5160b4a9d0de0d0$export$48b383b280e20440 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $9qszB.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $e5160b4a9d0de0d0$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $1oC0p.useContext)($e5160b4a9d0de0d0$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            setTopLevel(currentLevel - 1);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e5160b4a9d0de0d0$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $e5160b4a9d0de0d0$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $1oC0p.useRef)(0);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e5160b4a9d0de0d0$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $e5160b4a9d0de0d0$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $1oC0p.useContext)($e5160b4a9d0de0d0$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e5160b4a9d0de0d0$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e5160b4a9d0de0d0$var$LayeringProvider, null, content);
};

});

parcelRegister("lAmgM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fb6e3c0d01955528$export$2e2bcd8739ae039; });

var $4Lw69 = parcelRequire("4Lw69");

var $1oC0p = parcelRequire("1oC0p");

var $ds4sp = parcelRequire("ds4sp");

var $hNa1l = parcelRequire("hNa1l");

var $7iEAy = parcelRequire("7iEAy");
function $fb6e3c0d01955528$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb6e3c0d01955528$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb6e3c0d01955528$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4Lw69.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb6e3c0d01955528$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fb6e3c0d01955528$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
var $fb6e3c0d01955528$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $fb6e3c0d01955528$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: $fb6e3c0d01955528$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $fb6e3c0d01955528$var$directionMotions[distance][direction]
        }),
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
var $fb6e3c0d01955528$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: $fb6e3c0d01955528$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $fb6e3c0d01955528$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $fb6e3c0d01955528$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $hNa1l.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $fb6e3c0d01955528$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7iEAy.default), {
        duration: duration,
        enteringAnimation: $fb6e3c0d01955528$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $fb6e3c0d01955528$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $ds4sp.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $fb6e3c0d01955528$export$2e2bcd8739ae039 = $fb6e3c0d01955528$var$FadeIn;

});
parcelRegister("ds4sp", function(module, exports) {
$parcel$export(module.exports, "easeInOut", function () { return $9cb15900aa9b7059$export$c07234257a03d5e9; });
var $9cb15900aa9b7059$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $9cb15900aa9b7059$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $9cb15900aa9b7059$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

});

parcelRegister("hNa1l", function(module, exports) {
$parcel$export(module.exports, "mediumDurationMs", function () { return $cf3ec92fa3556561$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $cf3ec92fa3556561$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $cf3ec92fa3556561$export$368bacef0dacbe05 = 25;
var $cf3ec92fa3556561$export$2023a81c8547415f = $cf3ec92fa3556561$export$368bacef0dacbe05 * 4;
var $cf3ec92fa3556561$export$6fa259be09e118a7 = $cf3ec92fa3556561$export$368bacef0dacbe05 * 14;
var $cf3ec92fa3556561$export$9424640c29bc466d = $cf3ec92fa3556561$export$368bacef0dacbe05 * 28;

});

parcelRegister("7iEAy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5509b2e536b1f344$export$2e2bcd8739ae039; });

var $4Lw69 = parcelRequire("4Lw69");

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $8JsjR = parcelRequire("8JsjR");

var $hNa1l = parcelRequire("hNa1l");

var $arQBp = parcelRequire("arQBp");

var $iFTR1 = parcelRequire("iFTR1");

var $2UEg6 = parcelRequire("2UEg6");
function $5509b2e536b1f344$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5509b2e536b1f344$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5509b2e536b1f344$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4Lw69.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5509b2e536b1f344$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $5509b2e536b1f344$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $5509b2e536b1f344$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $hNa1l.largeDurationMs) : _ref$duration;
    var staggered = (0, $2UEg6.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $iFTR1.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $arQBp.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $1oC0p.useState)(appear), _useState2 = (0, $py6Rq.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $5509b2e536b1f344$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($5509b2e536b1f344$var$_objectSpread($5509b2e536b1f344$var$_objectSpread({}, (0, $8JsjR.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $5509b2e536b1f344$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? 'forwards' : 'backwards',
                animationName: "".concat((0, $3dJ4i.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? 'paused' : 'running',
                animationTimingFunction: animationTimingFunction(state)
            })) : ''
        }, state);
    });
};
var $5509b2e536b1f344$export$2e2bcd8739ae039 = $5509b2e536b1f344$var$EnteringMotion;

});
parcelRegister("py6Rq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $04cccb61aa338721$export$2e2bcd8739ae039; });

var $49jGG = parcelRequire("49jGG");

var $4Cmid = parcelRequire("4Cmid");

var $hxRB7 = parcelRequire("hxRB7");

var $8JhR5 = parcelRequire("8JhR5");
function $04cccb61aa338721$export$2e2bcd8739ae039(r, e) {
    return (0, $49jGG.default)(r) || (0, $4Cmid.default)(r, e) || (0, $hxRB7.default)(r, e) || (0, $8JhR5.default)();
}

});
parcelRegister("49jGG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3057463107a46778$export$2e2bcd8739ae039; });
function $3057463107a46778$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("4Cmid", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35cc00ef220911d0$export$2e2bcd8739ae039; });
function $35cc00ef220911d0$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("8JhR5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $65b06065e4cf113a$export$2e2bcd8739ae039; });
function $65b06065e4cf113a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8JsjR", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $65b87e5728125970$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $65b87e5728125970$export$f0f789643ba5a83c; });

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");
var $65b87e5728125970$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $65b87e5728125970$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$65b87e5728125970$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $65b87e5728125970$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $1oC0p.useState)($65b87e5728125970$export$b7baf7667a68d87c), _useState2 = (0, $py6Rq.default)(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        if (!$65b87e5728125970$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dH1HR.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $65b87e5728125970$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $65b87e5728125970$export$ff7706047246b98b = function prefersReducedMotion() {
    return $65b87e5728125970$export$f0f789643ba5a83c;
};

});

parcelRegister("arQBp", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", function () { return $79b53ab6a67af43d$export$4f34107a2b00f39c; });

var $1oC0p = parcelRequire("1oC0p");
var $79b53ab6a67af43d$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $79b53ab6a67af43d$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $79b53ab6a67af43d$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $79b53ab6a67af43d$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $79b53ab6a67af43d$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("iFTR1", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $d98761cf9ff2828a$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $d98761cf9ff2828a$export$2e2bcd8739ae039; });

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");

var $8JsjR = parcelRequire("8JsjR");
var $d98761cf9ff2828a$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $d98761cf9ff2828a$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $1oC0p.createContext)($d98761cf9ff2828a$export$d1e013d71d2e2121);
var $d98761cf9ff2828a$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d98761cf9ff2828a$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($d98761cf9ff2828a$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $d98761cf9ff2828a$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $d98761cf9ff2828a$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $d98761cf9ff2828a$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $d98761cf9ff2828a$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $d98761cf9ff2828a$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $d98761cf9ff2828a$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $1oC0p.useState)([
        null,
        children
    ]), _useState2 = (0, $py6Rq.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)([]), _useState4 = (0, $py6Rq.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $py6Rq.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $1oC0p.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $8JsjR.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $py6Rq.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $d98761cf9ff2828a$export$7032ae6d9d98bedd(previousChildren);
    var current = $d98761cf9ff2828a$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $d98761cf9ff2828a$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $d98761cf9ff2828a$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $d98761cf9ff2828a$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $d98761cf9ff2828a$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $d98761cf9ff2828a$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)($d98761cf9ff2828a$export$b9c4904d7a6929e6);
};
$d98761cf9ff2828a$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $d98761cf9ff2828a$export$2e2bcd8739ae039 = $d98761cf9ff2828a$var$ExitingPersistence;

});

parcelRegister("2UEg6", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $21f00a470f40ab8d$export$25c7213fc07ec080; });

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");

var $f1euX = parcelRequire("f1euX");

var $djAJq = parcelRequire("djAJq");

var $epMIu = parcelRequire("epMIu");
var $21f00a470f40ab8d$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $f1euX.default)
    };
});
var $21f00a470f40ab8d$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $epMIu.useUniqueId)();
    var context = (0, $1oC0p.useContext)($21f00a470f40ab8d$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $21f00a470f40ab8d$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $py6Rq.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $djAJq.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($21f00a470f40ab8d$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $21f00a470f40ab8d$export$2e2bcd8739ae039 = $21f00a470f40ab8d$var$StaggeredEntrance;

});
parcelRegister("f1euX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aef23218f4bb78d4$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $aef23218f4bb78d4$export$2e2bcd8739ae039() {}

});

parcelRegister("djAJq", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $9b198adfde6f8ffa$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $9b198adfde6f8ffa$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("epMIu", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $a7e9308f70f02033$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $a7e9308f70f02033$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("3mOff", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $273a66c3da80ab0e$export$b40ec24ac8275656; });

var $7bNCB = parcelRequire("7bNCB");
function $273a66c3da80ab0e$export$ba05d765b8392e5e(flagResolver) {
    (0, $7bNCB.setBooleanResolver)(flagResolver);
}
function $273a66c3da80ab0e$export$470e5c2be1411c89(name) {
    return (0, $7bNCB.resolveBooleanFlag)(name);
}
function $273a66c3da80ab0e$export$b40ec24ac8275656(name) {
    return (0, $7bNCB.resolveBooleanFlag)(name);
}

});
parcelRegister("7bNCB", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $53c00d4ab344cdeb$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $53c00d4ab344cdeb$export$6333b6aff9fc6275; });

var $cSnaf = parcelRequire("cSnaf");

var $7t0tI = parcelRequire("7t0tI");
var $53c00d4ab344cdeb$var$pkgName = '@atlaskit/platform-feature-flags';
var $53c00d4ab344cdeb$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $53c00d4ab344cdeb$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $53c00d4ab344cdeb$var$ENV_ENABLE_PLATFORM_FF = $53c00d4ab344cdeb$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $53c00d4ab344cdeb$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $53c00d4ab344cdeb$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $53c00d4ab344cdeb$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $53c00d4ab344cdeb$var$ENV_ENABLE_PLATFORM_FF || $53c00d4ab344cdeb$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $53c00d4ab344cdeb$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $53c00d4ab344cdeb$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$53c00d4ab344cdeb$var$globalVar[$53c00d4ab344cdeb$export$7e41b1b2bdee3f98] = $53c00d4ab344cdeb$var$globalVar[$53c00d4ab344cdeb$export$7e41b1b2bdee3f98] || $53c00d4ab344cdeb$var$DEFAULT_PFF_GLOBAL;
function $53c00d4ab344cdeb$export$f2b591175b3e424c(resolver) {
    $53c00d4ab344cdeb$var$globalVar[$53c00d4ab344cdeb$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $53c00d4ab344cdeb$export$6333b6aff9fc6275(flagKey) {
    if ($53c00d4ab344cdeb$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cSnaf.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $53c00d4ab344cdeb$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $53c00d4ab344cdeb$var$globalVar[$53c00d4ab344cdeb$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("cSnaf", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $95fc7f2170a6aa41$export$1c9f709888824e05; });
var $95fc7f2170a6aa41$var$_ref, $95fc7f2170a6aa41$var$_process, $95fc7f2170a6aa41$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $95fc7f2170a6aa41$var$TESTS_MODE = ($95fc7f2170a6aa41$var$_ref = (globalThis === null || globalThis === void 0 || ($95fc7f2170a6aa41$var$_process = globalThis.process) === null || $95fc7f2170a6aa41$var$_process === void 0 || ($95fc7f2170a6aa41$var$_process = $95fc7f2170a6aa41$var$_process.env) === null || $95fc7f2170a6aa41$var$_process === void 0 ? void 0 : $95fc7f2170a6aa41$var$_process.JEST_WORKER_ID) !== undefined, $95fc7f2170a6aa41$var$_ref !== void 0) ? $95fc7f2170a6aa41$var$_ref : false;
var $95fc7f2170a6aa41$var$DEBUG_MODE = !$95fc7f2170a6aa41$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($95fc7f2170a6aa41$var$_process2 = globalThis.process) === null || $95fc7f2170a6aa41$var$_process2 === void 0 || ($95fc7f2170a6aa41$var$_process2 = $95fc7f2170a6aa41$var$_process2.env) === null || $95fc7f2170a6aa41$var$_process2 === void 0 ? void 0 : $95fc7f2170a6aa41$var$_process2.NODE_ENV) !== 'production';
var $95fc7f2170a6aa41$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$95fc7f2170a6aa41$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("bGp1c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $88170617e084c207$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $3mOff = parcelRequire("3mOff");

var $7sGpu = parcelRequire("7sGpu");

var $2A3iM = parcelRequire("2A3iM");

var $hf2ZC = parcelRequire("hf2ZC");

var $eQ441 = parcelRequire("eQ441");
function $88170617e084c207$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $hf2ZC.default)(mountStrategy);
    (0, $eQ441.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $3mOff.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7sGpu.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2A3iM.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("7sGpu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $56ec0bb8b6e02174$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $k6fAO = parcelRequire("k6fAO");
function $56ec0bb8b6e02174$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $k6fAO.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $k6fAO.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $k6fAO.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(children, container);
}

});
parcelRegister("k6fAO", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $ea207698b6c96f3e$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $ea207698b6c96f3e$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $ea207698b6c96f3e$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $ea207698b6c96f3e$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $ea207698b6c96f3e$export$95029ca7aca2989e; });

var $lCTb8 = parcelRequire("lCTb8");
var $ea207698b6c96f3e$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $lCTb8.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $ea207698b6c96f3e$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $ea207698b6c96f3e$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $lCTb8.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $lCTb8.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $ea207698b6c96f3e$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $ea207698b6c96f3e$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $ea207698b6c96f3e$var$getPortalParent().removeChild(container);
};
var $ea207698b6c96f3e$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $ea207698b6c96f3e$var$getPortalParent().appendChild(container);
};
var $ea207698b6c96f3e$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $ea207698b6c96f3e$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($ea207698b6c96f3e$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $lCTb8.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $ea207698b6c96f3e$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($ea207698b6c96f3e$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $lCTb8.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $lCTb8.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $ea207698b6c96f3e$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("lCTb8", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $fbe7f2ed1b261e9a$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $fbe7f2ed1b261e9a$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $fbe7f2ed1b261e9a$export$13f57c02915787b3; });
var $fbe7f2ed1b261e9a$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $fbe7f2ed1b261e9a$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $fbe7f2ed1b261e9a$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("2A3iM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1e11814473a72472$export$2e2bcd8739ae039; });

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $6bfJL = parcelRequire("6bfJL");

var $k6fAO = parcelRequire("k6fAO");
function $1e11814473a72472$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $py6Rq.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $6bfJL.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $k6fAO.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $k6fAO.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    return atlaskitPortal ? /*#__PURE__*/ (0, $gUjjH.createPortal)(children, atlaskitPortal) : null;
}

});
parcelRegister("6bfJL", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $47fffa3ea5eb0da4$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $47fffa3ea5eb0da4$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});


parcelRegister("hf2ZC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8d628aed8f3e9c8$export$2e2bcd8739ae039; });

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");

var $6bfJL = parcelRequire("6bfJL");
var $c8d628aed8f3e9c8$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $py6Rq.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $6bfJL.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $py6Rq.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $c8d628aed8f3e9c8$export$2e2bcd8739ae039 = $c8d628aed8f3e9c8$var$useIsSubsequentRender;

});

parcelRegister("eQ441", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $acd91303e5bfe6fc$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $lfcah = parcelRequire("lfcah");

var $kXqb1 = parcelRequire("kXqb1");
var $acd91303e5bfe6fc$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $kXqb1.default)((0, $lfcah.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $kXqb1.default)((0, $lfcah.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $acd91303e5bfe6fc$export$2e2bcd8739ae039 = $acd91303e5bfe6fc$var$useFirePortalEvent;

});
parcelRegister("lfcah", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $f7746f6217b98a79$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $f7746f6217b98a79$export$80816bd900e5bd00; });
var $f7746f6217b98a79$export$ed5835cc67e87f72 = 'akPortalMount';
var $f7746f6217b98a79$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("kXqb1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f41d9f83d6d316db$export$2e2bcd8739ae039; });
var $f41d9f83d6d316db$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $f41d9f83d6d316db$var$getLayerName = function getLayerName(zIndex) {
    return $f41d9f83d6d316db$var$zIndexToName.hasOwnProperty(zIndex) ? $f41d9f83d6d316db$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $f41d9f83d6d316db$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $f41d9f83d6d316db$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $f41d9f83d6d316db$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $f41d9f83d6d316db$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("jwsvk", function(module, exports) {
$parcel$export(module.exports, "borderRadius", function () { return $e3671ddd4ead0be9$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $e3671ddd4ead0be9$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $e3671ddd4ead0be9$export$7be255094ccdc533; });

var $4P31q = parcelRequire("4P31q");

var $lK8iO = parcelRequire("lK8iO");
var $e3671ddd4ead0be9$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $e3671ddd4ead0be9$export$c93026a968943f95 = 'light';
var $e3671ddd4ead0be9$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $e3671ddd4ead0be9$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $e3671ddd4ead0be9$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $e3671ddd4ead0be9$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $e3671ddd4ead0be9$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $e3671ddd4ead0be9$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $e3671ddd4ead0be9$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $e3671ddd4ead0be9$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $lK8iO.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e3671ddd4ead0be9$export$6d8204c2cb2e06b8() / 4;
    (0, $4P31q.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $e3671ddd4ead0be9$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $e3671ddd4ead0be9$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $e3671ddd4ead0be9$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $4P31q.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $e3671ddd4ead0be9$export$ba1d834b86d72a09 = $e3671ddd4ead0be9$export$a1b3edb637fb4f35;
var $e3671ddd4ead0be9$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $lK8iO.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $lK8iO.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $lK8iO.N30A), ")")
            }
        }
    };
};

});
parcelRegister("4P31q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $382e44f90409bec9$export$2e2bcd8739ae039; });

var $lK0lV = parcelRequire("lK0lV");

var $7t0tI = parcelRequire("7t0tI");
function $382e44f90409bec9$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $lK0lV.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $382e44f90409bec9$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("lK0lV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd3e2adb4e95fc79$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $fd3e2adb4e95fc79$var$printed = {};
function $fd3e2adb4e95fc79$export$2e2bcd8739ae039(message) {
    if ($fd3e2adb4e95fc79$var$printed[message]) return;
    $fd3e2adb4e95fc79$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});



parcelRegister("k5zVc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea00238acdb4a0cc$export$2e2bcd8739ae039; });

var $ij7Z2 = parcelRequire("ij7Z2");

var $py6Rq = parcelRequire("py6Rq");

var $judOO = parcelRequire("judOO");

var $4Lw69 = parcelRequire("4Lw69");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $aUzEK = parcelRequire("aUzEK");

var $ehBVC = parcelRequire("ehBVC");

var $8Zjhr = parcelRequire("8Zjhr");

var $lL5vi = parcelRequire("lL5vi");

var $f1Ad5 = parcelRequire("f1Ad5");

var $lAmgM = parcelRequire("lAmgM");
parcelRequire("2PdkP");
var $5MWZy = parcelRequire("5MWZy");

var $cAeoO = parcelRequire("cAeoO");

var $lK8iO = parcelRequire("lK8iO");

var $jZAJv = parcelRequire("jZAJv");

var $3J1Qg = parcelRequire("3J1Qg");

var $9XJwS = parcelRequire("9XJwS");

var $2HATk = parcelRequire("2HATk");

var $i8SU6 = parcelRequire("i8SU6");

var $5sDfw = parcelRequire("5sDfw");

var $2l4oN = parcelRequire("2l4oN");

var $5DuyD = parcelRequire("5DuyD");

var $aCwnd = parcelRequire("aCwnd");
var $ea00238acdb4a0cc$var$dialogStyles = (0, $3dJ4i.css)((0, $4Lw69.default)((0, $4Lw69.default)((0, $4Lw69.default)((0, $4Lw69.default)({
    display: 'flex',
    width: '100%',
    maxWidth: '100vw',
    height: '100%',
    minHeight: 0,
    maxHeight: '100vh',
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: '0 1 auto',
    flexDirection: 'column',
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $lK8iO.N0), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $3J1Qg.textColor)
}, (0, $jZAJv.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $lK8iO.N0), ")")), "pointerEvents", 'auto'), (0, $cAeoO.media).above.xs, {
    width: 'var(--modal-dialog-width)',
    maxWidth: 'inherit',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $3J1Qg.borderRadius),
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $lK8iO.N30A), ", 0 2px 1px ").concat((0, $lK8iO.N30A), ", 0 0 20px -6px ").concat((0, $lK8iO.N60A)), ")"),
    marginInlineEnd: 'inherit',
    marginInlineStart: 'inherit'
}), '& > form:only-child', {
    display: 'inherit',
    maxHeight: 'inherit',
    flexDirection: 'inherit'
}));
var $ea00238acdb4a0cc$var$viewportScrollStyles = (0, $3dJ4i.css)((0, $4Lw69.default)({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: '100vh',
    maxHeight: 'none'
}, (0, $cAeoO.media).above.xs, {
    minHeight: 'var(--modal-dialog-height)'
}));
var $ea00238acdb4a0cc$var$bodyScrollStyles = (0, $3dJ4i.css)((0, $4Lw69.default)({}, (0, $cAeoO.media).above.xs, {
    height: 'var(--modal-dialog-height)',
    maxHeight: 'inherit'
}));
var $ea00238acdb4a0cc$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $8Zjhr.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $1oC0p.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $5MWZy.combine)((0, $i8SU6.disableDraggingToCrossOriginIFramesForElement)(), (0, $2l4oN.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $5sDfw.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $ehBVC.default)((0, $judOO.default)(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, $judOO.default)(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $2HATk.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, $py6Rq.default)(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $1oC0p.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $f1Ad5.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $f1Ad5.useLayering)(), currentLevel = _useLayering.currentLevel;
    return (0, $3dJ4i.jsx)((0, $aCwnd.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $3dJ4i.jsx)((0, $9XJwS.ModalContext).Provider, {
        value: modalDialogContext
    }, (0, $3dJ4i.jsx)((0, $9XJwS.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, (0, $3dJ4i.jsx)((0, $lAmgM.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $3dJ4i.jsx)((0, $lL5vi.default), null, (0, $3dJ4i.jsx)("section", (0, $ij7Z2.default)({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $aUzEK.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $5DuyD.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $5DuyD.dialogHeight)(height)
            },
            css: [
                $ea00238acdb4a0cc$var$dialogStyles,
                shouldScrollInViewport ? $ea00238acdb4a0cc$var$viewportScrollStyles : $ea00238acdb4a0cc$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ea00238acdb4a0cc$export$2e2bcd8739ae039 = $ea00238acdb4a0cc$var$ModalDialog;

});
parcelRegister("aUzEK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7f1acaf4074e0578$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $7f1acaf4074e0578$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("ehBVC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a66012fa4ee0d2bb$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $a66012fa4ee0d2bb$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("8Zjhr", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $68b2f9e4a654ab9c$export$f680877a34711e37; });

var $judOO = parcelRequire("judOO");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $3mOff = parcelRequire("3mOff");
var $68b2f9e4a654ab9c$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $68b2f9e4a654ab9c$var$react18UseId = ($68b2f9e4a654ab9c$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $68b2f9e4a654ab9c$var$_React$useId !== void 0 ? $68b2f9e4a654ab9c$var$_React$useId : undefined;
function $68b2f9e4a654ab9c$export$f680877a34711e37() {
    if ($68b2f9e4a654ab9c$var$react18UseId && (0, $3mOff.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $68b2f9e4a654ab9c$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $6JmtO.useUID)());
}
var $68b2f9e4a654ab9c$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($68b2f9e4a654ab9c$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $judOO.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $judOO.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $68b2f9e4a654ab9c$export$6ee17796e3d70de2() {
    if ($68b2f9e4a654ab9c$var$react18UseId && (0, $3mOff.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $68b2f9e4a654ab9c$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6JmtO.useUIDSeed)();
}

});
parcelRegister("6JmtO", function(module, exports) {
$parcel$export(module.exports, "useUID", function () { return $4e68620fcec973cc$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $4e68620fcec973cc$export$bb5ca5fba6fb4f1f; });

var $1oC0p = parcelRequire("1oC0p");

var $5zcCc = parcelRequire("5zcCc");
var $4e68620fcec973cc$var$generateUID = function(context) {
    var quartz = context || (0, $5zcCc.counter);
    var prefix = (0, $5zcCc.getPrefix)(quartz);
    var id = (0, $5zcCc.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $4e68620fcec973cc$var$useUIDState = function() {
    var context = (0, $1oC0p.useContext)((0, $5zcCc.source));
    var uid = (0, $1oC0p.useState)(function() {
        return $4e68620fcec973cc$var$generateUID(context);
    })[0];
    return uid;
};
var $4e68620fcec973cc$export$87d05f07e65211f1 = function() {
    var uid = $4e68620fcec973cc$var$useUIDState().uid;
    return uid;
};
var $4e68620fcec973cc$export$bb5ca5fba6fb4f1f = function() {
    var gen = $4e68620fcec973cc$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("5zcCc", function(module, exports) {
$parcel$export(module.exports, "counter", function () { return $40da01bbf4d0b6eb$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $40da01bbf4d0b6eb$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $40da01bbf4d0b6eb$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $40da01bbf4d0b6eb$export$36e24695f02d4503; });

var $1oC0p = parcelRequire("1oC0p");

var $bLlgH = parcelRequire("bLlgH");
var $40da01bbf4d0b6eb$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $bLlgH.generateUID)()
    };
};
var $40da01bbf4d0b6eb$export$e575061ef2a070eb = $40da01bbf4d0b6eb$export$1921362e86c73c88();
var $40da01bbf4d0b6eb$export$b4d5da5f34fb77ad = $1oC0p.createContext($40da01bbf4d0b6eb$export$1921362e86c73c88());
var $40da01bbf4d0b6eb$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $40da01bbf4d0b6eb$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("bLlgH", function(module, exports) {
$parcel$export(module.exports, "generateUID", function () { return $890494f86d14cdba$export$bdbb4cbb3078e58d; });
$parcel$export(module.exports, "uid", function () { return $890494f86d14cdba$export$e2a22331486dcca0; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $890494f86d14cdba$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $890494f86d14cdba$export$e2a22331486dcca0 = $890494f86d14cdba$export$bdbb4cbb3078e58d();

});




parcelRegister("lL5vi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd7241b15ffac313$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $fd7241b15ffac313$var$BORDER_WIDTH = 2;
var $fd7241b15ffac313$var$baseFocusOutsideStyles = (0, $3dJ4i.css)({
    outline: "".concat($fd7241b15ffac313$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $fd7241b15ffac313$var$BORDER_WIDTH
});
var $fd7241b15ffac313$var$baseInsetStyles = (0, $3dJ4i.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$fd7241b15ffac313$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $fd7241b15ffac313$var$focusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $fd7241b15ffac313$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $fd7241b15ffac313$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $fd7241b15ffac313$var$insetFocusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $fd7241b15ffac313$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $fd7241b15ffac313$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $fd7241b15ffac313$var$FocusRing = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $fd7241b15ffac313$var$baseInsetStyles : $fd7241b15ffac313$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $fd7241b15ffac313$var$insetFocusRingStyles : $fd7241b15ffac313$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $1oC0p.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1oC0p.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$fd7241b15ffac313$var$FocusRing.displayName = 'FocusRing';
var $fd7241b15ffac313$export$2e2bcd8739ae039 = $fd7241b15ffac313$var$FocusRing;

});

parcelRegister("f1Ad5", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $af03098faa1464ae$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $af03098faa1464ae$export$c8b4d54e03dee6ed; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $jFq2q = parcelRequire("jFq2q");
var $af03098faa1464ae$var$ESCAPE = 'Escape';
function $af03098faa1464ae$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var _useLayering = $af03098faa1464ae$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $af03098faa1464ae$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $af03098faa1464ae$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $1oC0p.useContext)((0, $jFq2q.LevelContext));
    var _useContext = (0, $1oC0p.useContext)((0, $jFq2q.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("2PdkP", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return (parcelRequire("5MWZy")).combine; });

var $5MWZy = parcelRequire("5MWZy");

});
parcelRegister("5MWZy", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return $436f31fafdc81520$export$1be1fc439b849fdf; });
/** Create a new combined function that will call all the provided functions */ function $436f31fafdc81520$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("cAeoO", function(module, exports) {
$parcel$export(module.exports, "media", function () { return $9294043421737f8e$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $9294043421737f8e$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $9294043421737f8e$export$c881183ca713c214 = $9294043421737f8e$export$987d49ffe1b0900f;

});

parcelRegister("jZAJv", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $e8e0353ad8a6cb01$export$9d7b58831ae93caa; });
var $e8e0353ad8a6cb01$export$4ef52930e33717cd = 'data-theme';
var $e8e0353ad8a6cb01$export$a00eac3f8684bcd0 = 'data-color-mode';
var $e8e0353ad8a6cb01$export$2112803007239c61 = 'data-contrast-mode';
var $e8e0353ad8a6cb01$export$352e418ed5b6193a = 'data-custom-theme';
var $e8e0353ad8a6cb01$export$2faeed762aac6741 = 'light';
var $e8e0353ad8a6cb01$export$6f0c6fb8c80fcc92 = 'ds';
var $e8e0353ad8a6cb01$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $e8e0353ad8a6cb01$export$dddac1532e822863 = "--".concat($e8e0353ad8a6cb01$export$6f0c6fb8c80fcc92, "-token-not-found");
var $e8e0353ad8a6cb01$export$9d7b58831ae93caa = "--".concat($e8e0353ad8a6cb01$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("3J1Qg", function(module, exports) {
$parcel$export(module.exports, "width", function () { return $2b6700dcf0aa7f70$export$7e3df82ee760448c; });
$parcel$export(module.exports, "gutter", function () { return $2b6700dcf0aa7f70$export$f2b922cb4a245974; });
$parcel$export(module.exports, "borderRadius", function () { return $2b6700dcf0aa7f70$export$7a57f79000377ca2; });
$parcel$export(module.exports, "verticalOffset", function () { return $2b6700dcf0aa7f70$export$9212741279b5f103; });
$parcel$export(module.exports, "keylineHeight", function () { return $2b6700dcf0aa7f70$export$4c317248f944c2a9; });
$parcel$export(module.exports, "textColor", function () { return $2b6700dcf0aa7f70$export$32f78bffcd82ff28; });

var $lK8iO = parcelRequire("lK8iO");

var $jwsvk = parcelRequire("jwsvk");
var $2b6700dcf0aa7f70$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $2b6700dcf0aa7f70$export$f2b922cb4a245974 = 60;
var $2b6700dcf0aa7f70$var$gridSize = (0, $jwsvk.gridSize)();
var $2b6700dcf0aa7f70$export$7a57f79000377ca2 = (0, $jwsvk.borderRadius)();
var $2b6700dcf0aa7f70$export$9212741279b5f103 = $2b6700dcf0aa7f70$var$gridSize * 2;
var $2b6700dcf0aa7f70$export$4c317248f944c2a9 = 2;
var $2b6700dcf0aa7f70$export$d901150a4cc83165 = "var(--ds-border, ".concat((0, $lK8iO.N30), ")");
var $2b6700dcf0aa7f70$export$32f78bffcd82ff28 = "var(--ds-text, ".concat((0, $lK8iO.N900), ")");
var $2b6700dcf0aa7f70$export$3797a580396e3639 = {
    danger: "var(--ds-icon-danger, ".concat((0, $lK8iO.R400), ")"),
    warning: "var(--ds-icon-warning, #D97008)"
};

});

parcelRegister("9XJwS", function(module, exports) {
$parcel$export(module.exports, "ModalContext", function () { return $740cf0e893458f99$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ScrollContext", function () { return $740cf0e893458f99$export$dece24112a937f92; });

var $1oC0p = parcelRequire("1oC0p");
var $740cf0e893458f99$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $740cf0e893458f99$export$dece24112a937f92 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("2HATk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f7c36ce02015c11$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $1f7c36ce02015c11$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $1oC0p.useRef)(null);
    var onMotionFinish = (0, $1oC0p.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("i8SU6", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", function () { return $d35390184dbcc645$export$ec28e97c7d8b1b35; });

var $dH1HR = parcelRequire("dH1HR");
parcelRequire("2PdkP");
var $5MWZy = parcelRequire("5MWZy");
parcelRequire("8Rief");
var $bSaKx = parcelRequire("bSaKx");

var $fu24Y = parcelRequire("fu24Y");
function $d35390184dbcc645$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $dH1HR.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $bSaKx.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $5MWZy.combine)(unbindEvents, unbindMonitor);
}
function $d35390184dbcc645$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $dH1HR.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $d35390184dbcc645$var$api = (0, $fu24Y.makeFixForAdapter)({
    watchForInteractionStart: $d35390184dbcc645$var$watchForInteractionStart,
    watchForInteractionEnd: $d35390184dbcc645$var$watchForInteractionEnd
});
function $d35390184dbcc645$export$ec28e97c7d8b1b35() {
    return $d35390184dbcc645$var$api.registerUsage();
}

});
parcelRegister("8Rief", function(module, exports) {
$parcel$export(module.exports, "monitorForElements", function () { return (parcelRequire("bSaKx")).monitorForElements; });

var $bSaKx = parcelRequire("bSaKx");
 // Payload for the draggable being dragged

});
parcelRegister("bSaKx", function(module, exports) {
$parcel$export(module.exports, "monitorForElements", function () { return $8a4d1380300cd469$export$59a074bac4c54f54; });

var $py6Rq = parcelRequire("py6Rq");

var $dH1HR = parcelRequire("dH1HR");

var $6UCXW = parcelRequire("6UCXW");

var $1FfUa = parcelRequire("1FfUa");

var $5NK67 = parcelRequire("5NK67");

var $5MWZy = parcelRequire("5MWZy");

var $2RfrO = parcelRequire("2RfrO");

var $dBH5d = parcelRequire("dBH5d");

var $8c7xe = parcelRequire("8c7xe");

var $jpD7X = parcelRequire("jpD7X");

var $a0yyg = parcelRequire("a0yyg");

var $3mIgn = parcelRequire("3mIgn");
var $8a4d1380300cd469$var$draggableRegistry = new WeakMap();
function $8a4d1380300cd469$var$addToRegistry(args) {
    $8a4d1380300cd469$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $8a4d1380300cd469$var$draggableRegistry.delete(args.element);
    };
}
var $8a4d1380300cd469$var$honeyPotFix = (0, $1FfUa.makeHoneyPotFix)();
var $8a4d1380300cd469$var$adapter = (0, $5NK67.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $5MWZy.combine)($8a4d1380300cd469$var$honeyPotFix.bindEvents(), (0, $dH1HR.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $8a4d1380300cd469$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $8c7xe.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $6UCXW.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, $py6Rq.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $dBH5d.isAndroid)() && !event.dataTransfer.types.includes((0, $jpD7X.textMediaType)) && !event.dataTransfer.types.includes((0, $a0yyg.URLMediaType))) event.dataTransfer.setData((0, $jpD7X.textMediaType), (0, $dBH5d.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $3mIgn.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $8a4d1380300cd469$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $8a4d1380300cd469$var$honeyPotFix.getOnPostDispatch()
});
var $8a4d1380300cd469$export$e7140b68045b5036 = $8a4d1380300cd469$var$adapter.dropTarget;
var $8a4d1380300cd469$export$59a074bac4c54f54 = $8a4d1380300cd469$var$adapter.monitor;
function $8a4d1380300cd469$export$c746a5152d4ba26c(args) {
    var existing;
    return (0, $5MWZy.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $8a4d1380300cd469$var$adapter.registerUsage(), $8a4d1380300cd469$var$addToRegistry(args), (0, $2RfrO.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("6UCXW", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", function () { return $508632db3e7d099a$export$81d0353f25f5dd; });

var $py6Rq = parcelRequire("py6Rq");

var $4ltWC = parcelRequire("4ltWC");
function $508632db3e7d099a$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, $py6Rq.default)(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $4ltWC.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("4ltWC", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", function () { return $32a059ee8790f6bf$export$821bdcd739a2706b; });

var $lHYOa = parcelRequire("lHYOa");
function $32a059ee8790f6bf$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $lHYOa.honeyPotDataAttribute));
}

});
parcelRegister("lHYOa", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", function () { return $fcdcc85a7d5a08b9$export$6eafea55f7947469; });
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $fcdcc85a7d5a08b9$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("1FfUa", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", function () { return $1365f52cdaf93f99$export$8ecad27c959e89e0; });

var $4Lw69 = parcelRequire("4Lw69");

var $dH1HR = parcelRequire("dH1HR");

var $hKi3E = parcelRequire("hKi3E");

var $lHYOa = parcelRequire("lHYOa");
function $1365f52cdaf93f99$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1365f52cdaf93f99$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1365f52cdaf93f99$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4Lw69.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1365f52cdaf93f99$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1365f52cdaf93f99$var$honeyPotSize = 2;
var $1365f52cdaf93f99$var$halfHoneyPotSize = $1365f52cdaf93f99$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $1365f52cdaf93f99$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $1365f52cdaf93f99$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $1365f52cdaf93f99$var$halfHoneyPotSize,
        y: point.y - $1365f52cdaf93f99$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $1365f52cdaf93f99$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $1365f52cdaf93f99$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $1365f52cdaf93f99$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $1365f52cdaf93f99$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $1365f52cdaf93f99$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $1365f52cdaf93f99$var$preventGoingForwardsOffScreen($1365f52cdaf93f99$var$preventGoingBackwardsOffScreen($1365f52cdaf93f99$var$pullBackByHalfHoneyPotSize($1365f52cdaf93f99$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $1365f52cdaf93f99$var$honeyPotSize,
        height: $1365f52cdaf93f99$var$honeyPotSize
    });
}
function $1365f52cdaf93f99$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $1365f52cdaf93f99$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $1365f52cdaf93f99$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $lHYOa.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $1365f52cdaf93f99$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $1365f52cdaf93f99$var$_objectSpread($1365f52cdaf93f99$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $1365f52cdaf93f99$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $hKi3E.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $dH1HR.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $1365f52cdaf93f99$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $1365f52cdaf93f99$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($1365f52cdaf93f99$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $dH1HR.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $1365f52cdaf93f99$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $dH1HR.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var _latestPointerMove;
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = (_latestPointerMove = latestPointerMove) !== null && _latestPointerMove !== void 0 ? _latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $1365f52cdaf93f99$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("hKi3E", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", function () { return $ceb4bd72747d8a42$export$7d0a15ee70427305; });
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $ceb4bd72747d8a42$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("5NK67", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", function () { return $439549660f61373f$export$2aa3a33160990d96; });

var $asEUS = parcelRequire("asEUS");

var $cLLzE = parcelRequire("cLLzE");

var $4GBrK = parcelRequire("4GBrK");

var $iUHSg = parcelRequire("iUHSg");
function $439549660f61373f$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $iUHSg.makeMonitor)();
    var dropTargetAPI = (0, $4GBrK.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $asEUS.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $asEUS.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $cLLzE.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("asEUS", function(module, exports) {
$parcel$export(module.exports, "lifecycle", function () { return $79dc420719ceb7a0$export$3efdceeb8ca25c51; });

var $2YC7S = parcelRequire("2YC7S");

var $dH1HR = parcelRequire("dH1HR");

var $6UCXW = parcelRequire("6UCXW");

var $4ltWC = parcelRequire("4ltWC");

var $gtdgG = parcelRequire("gtdgG");

var $6bw5F = parcelRequire("6bw5F");

var $8c7xe = parcelRequire("8c7xe");

var $jdHu5 = parcelRequire("jdHu5");
var $79dc420719ceb7a0$var$globalState = {
    isActive: false
};
function $79dc420719ceb7a0$var$canStart() {
    return !$79dc420719ceb7a0$var$globalState.isActive;
}
function $79dc420719ceb7a0$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $79dc420719ceb7a0$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $79dc420719ceb7a0$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$79dc420719ceb7a0$var$canStart()) return;
    var initial = $79dc420719ceb7a0$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $79dc420719ceb7a0$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $79dc420719ceb7a0$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $jdHu5.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $79dc420719ceb7a0$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $8c7xe.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $4ltWC.isHoneyPotElement)(event.target) ? (0, $6UCXW.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $79dc420719ceb7a0$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $79dc420719ceb7a0$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $dH1HR.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $gtdgG.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $8c7xe.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $79dc420719ceb7a0$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $8c7xe.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, $2YC7S.default)((0, $6bw5F.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $79dc420719ceb7a0$var$getNativeSetDragImage(event)
    });
}
function $79dc420719ceb7a0$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $79dc420719ceb7a0$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $8c7xe.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $79dc420719ceb7a0$export$3efdceeb8ca25c51 = {
    canStart: $79dc420719ceb7a0$var$canStart,
    start: $79dc420719ceb7a0$var$start
};

});
parcelRegister("gtdgG", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", function () { return $bfd9a58c8dd959a0$export$57d220c74e84a273; });

var $buizf = parcelRequire("buizf");

var $eDKm5 = parcelRequire("eDKm5");

var $lS9r5 = parcelRequire("lS9r5");

var $bLHDm = parcelRequire("bLHDm");
function $bfd9a58c8dd959a0$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $eDKm5.isSafari)()) return (0, $lS9r5.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $buizf.isFirefox)()) return (0, $bLHDm.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("buizf", function(module, exports) {
$parcel$export(module.exports, "isFirefox", function () { return $85d0e62d49dcc557$export$b7d78993b74f766d; });

var $7hpK0 = parcelRequire("7hpK0");
var $85d0e62d49dcc557$export$b7d78993b74f766d = (0, $7hpK0.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("7hpK0", function(module, exports) {
$parcel$export(module.exports, "once", function () { return $54ce1695d7f29ad4$export$d2de3aaeafa91619; });
/** Provide a function that you only ever want to be called a single time */ function $54ce1695d7f29ad4$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("eDKm5", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $aa88aa64d415a2c7$export$95df08bae54cb4df; });

var $7hpK0 = parcelRequire("7hpK0");
var $aa88aa64d415a2c7$export$95df08bae54cb4df = (0, $7hpK0.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("lS9r5", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", function () { return $fec5f5de6ddc2443$export$de68634bd94ed596; });
$parcel$export(module.exports, "isLeavingWindowInSafari", function () { return $fec5f5de6ddc2443$export$f21837c338005454; });

var $dH1HR = parcelRequire("dH1HR");

var $eDKm5 = parcelRequire("eDKm5");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $fec5f5de6ddc2443$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $fec5f5de6ddc2443$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $eDKm5.isSafari)()) return false;
    return dragEnter.hasOwnProperty($fec5f5de6ddc2443$var$symbols.isEnteringWindow);
}
function $fec5f5de6ddc2443$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $eDKm5.isSafari)()) return false;
    return dragLeave.hasOwnProperty($fec5f5de6ddc2443$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $eDKm5.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$fec5f5de6ddc2443$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$fec5f5de6ddc2443$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("bLHDm", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", function () { return $8915ee47147cbaf6$export$e46810fef53b5b0e; });
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $8915ee47147cbaf6$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $8915ee47147cbaf6$export$e46810fef53b5b0e(eventTarget) {
    return $8915ee47147cbaf6$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("6bw5F", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", function () { return $480ca9a010cd1da4$export$ac5e5b0daf997b2; });
function $480ca9a010cd1da4$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("8c7xe", function(module, exports) {
$parcel$export(module.exports, "getInput", function () { return $5f7549fdeabe5c18$export$7c112ceec8941e67; });
function $5f7549fdeabe5c18$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("jdHu5", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", function () { return $dfe0f645ca168701$export$9f13ecc44e83d682; });

var $FcGYz = parcelRequire("FcGYz");
var $dfe0f645ca168701$var$scheduleOnDrag = (0, $FcGYz.default)(function(fn) {
    return fn();
});
var $dfe0f645ca168701$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $dfe0f645ca168701$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $dfe0f645ca168701$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $dfe0f645ca168701$var$dragStart.flush();
            $dfe0f645ca168701$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $dfe0f645ca168701$var$scheduleOnDrag(function() {
                $dfe0f645ca168701$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $dfe0f645ca168701$var$dragStart.flush();
            $dfe0f645ca168701$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("FcGYz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $07bdacd940085446$export$2e2bcd8739ae039; });
var $07bdacd940085446$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $07bdacd940085446$export$2e2bcd8739ae039 = $07bdacd940085446$var$rafSchd;

});



parcelRegister("cLLzE", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $94bec706bd1376c6$export$6503ec6e8aabbaf; });
// Extending `Map` to allow us to link Key and Values together
var $94bec706bd1376c6$var$ledger = new Map();
function $94bec706bd1376c6$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $94bec706bd1376c6$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $94bec706bd1376c6$var$ledger.set(typeKey, initial);
    return initial;
}
function $94bec706bd1376c6$export$6503ec6e8aabbaf(args) {
    var entry = $94bec706bd1376c6$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $94bec706bd1376c6$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("4GBrK", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", function () { return $369821c26798cc95$export$47d10e7bd9c81890; });

var $4Lw69 = parcelRequire("4Lw69");

var $2YC7S = parcelRequire("2YC7S");

var $5MWZy = parcelRequire("5MWZy");

var $2RfrO = parcelRequire("2RfrO");
function $369821c26798cc95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $369821c26798cc95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $369821c26798cc95$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4Lw69.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $369821c26798cc95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $369821c26798cc95$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $369821c26798cc95$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $369821c26798cc95$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $369821c26798cc95$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $369821c26798cc95$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $369821c26798cc95$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $369821c26798cc95$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $369821c26798cc95$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        return (0, $5MWZy.combine)((0, $2RfrO.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, $2YC7S.default)(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $369821c26798cc95$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $369821c26798cc95$var$_objectSpread($369821c26798cc95$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $369821c26798cc95$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $369821c26798cc95$var$_objectSpread($369821c26798cc95$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $369821c26798cc95$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $369821c26798cc95$var$_objectSpread($369821c26798cc95$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $369821c26798cc95$var$copyReverse(current);
        var actualCaptureOrdered = $369821c26798cc95$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($369821c26798cc95$var$_objectSpread($369821c26798cc95$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $369821c26798cc95$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("2RfrO", function(module, exports) {
$parcel$export(module.exports, "addAttribute", function () { return $214c8392f93d7bf0$export$5dcb5c23b6ba980a; });
function $214c8392f93d7bf0$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("iUHSg", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", function () { return $dc4f7d754967ed6a$export$5dd4ed888d5b12ca; });

var $4Lw69 = parcelRequire("4Lw69");
function $dc4f7d754967ed6a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $dc4f7d754967ed6a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $dc4f7d754967ed6a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dc4f7d754967ed6a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dc4f7d754967ed6a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dc4f7d754967ed6a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $dc4f7d754967ed6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc4f7d754967ed6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc4f7d754967ed6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4Lw69.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc4f7d754967ed6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dc4f7d754967ed6a$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $dc4f7d754967ed6a$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $dc4f7d754967ed6a$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("dBH5d", function(module, exports) {
$parcel$export(module.exports, "isAndroid", function () { return $9e80267d0e23472d$export$a11b0059900ceec8; });
$parcel$export(module.exports, "androidFallbackText", function () { return $9e80267d0e23472d$export$aceb3ed8b7f7bd2c; });

var $7hpK0 = parcelRequire("7hpK0");
var $9e80267d0e23472d$export$a11b0059900ceec8 = (0, $7hpK0.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $9e80267d0e23472d$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("jpD7X", function(module, exports) {
$parcel$export(module.exports, "textMediaType", function () { return $e21eb3f9eddd4b8a$export$fd3d00026297c0ad; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $e21eb3f9eddd4b8a$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("a0yyg", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", function () { return $7494b4b00931560f$export$4c44a460f123106; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $7494b4b00931560f$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("3mIgn", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", function () { return $2735c2e861e03af3$export$c9c4cc54e73b125d; });
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $2735c2e861e03af3$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("fu24Y", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", function () { return $b45b45455fb104af$export$a74bff2507e6126b; });

var $2YC7S = parcelRequire("2YC7S");
parcelRequire("2PdkP");
var $5MWZy = parcelRequire("5MWZy");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $b45b45455fb104af$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $b45b45455fb104af$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $b45b45455fb104af$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$b45b45455fb104af$var$hasSameOrigin(window.location.href, iframe.src);
}
var $b45b45455fb104af$var$registry = new Map();
function $b45b45455fb104af$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($b45b45455fb104af$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $b45b45455fb104af$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $b45b45455fb104af$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $b45b45455fb104af$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $b45b45455fb104af$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $5MWZy.combine).apply(void 0, (0, $2YC7S.default)(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $b45b45455fb104af$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $b45b45455fb104af$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("5sDfw", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", function () { return $3f9e0364117eb189$export$27d79116d3a4e7d5; });
parcelRequire("7rfJx");
var $ac2UW = parcelRequire("ac2UW");

var $fu24Y = parcelRequire("fu24Y");
function $3f9e0364117eb189$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $ac2UW.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $3f9e0364117eb189$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $ac2UW.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $3f9e0364117eb189$var$api = (0, $fu24Y.makeFixForAdapter)({
    watchForInteractionStart: $3f9e0364117eb189$var$watchForInteractionStart,
    watchForInteractionEnd: $3f9e0364117eb189$var$watchForInteractionEnd
});
function $3f9e0364117eb189$export$27d79116d3a4e7d5() {
    return $3f9e0364117eb189$var$api.registerUsage();
}

});
parcelRegister("7rfJx", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", function () { return (parcelRequire("ac2UW")).monitorForExternal; });

var $ac2UW = parcelRequire("ac2UW");
 // The data that is being dragged

});
parcelRegister("ac2UW", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", function () { return $76bd49b463920dc9$export$bb1740f3194979c1; });

var $2YC7S = parcelRequire("2YC7S");

var $dH1HR = parcelRequire("dH1HR");

var $5NK67 = parcelRequire("5NK67");

var $dBH5d = parcelRequire("dBH5d");

var $lG89z = parcelRequire("lG89z");

var $6bw5F = parcelRequire("6bw5F");

var $jpD7X = parcelRequire("jpD7X");

var $3mIgn = parcelRequire("3mIgn");
function $76bd49b463920dc9$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $3mIgn.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $jpD7X.textMediaType) && value === (0, $dBH5d.androidFallbackText)) return false;
    return true;
}
function $76bd49b463920dc9$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $76bd49b463920dc9$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $76bd49b463920dc9$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $76bd49b463920dc9$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $76bd49b463920dc9$var$didDragStartLocally = false;
var $76bd49b463920dc9$var$adapter = (0, $5NK67.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $dH1HR.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($76bd49b463920dc9$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $lG89z.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $76bd49b463920dc9$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $76bd49b463920dc9$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$76bd49b463920dc9$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $76bd49b463920dc9$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $76bd49b463920dc9$var$adapter.dropTarget(args);
}
function $76bd49b463920dc9$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $76bd49b463920dc9$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $76bd49b463920dc9$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $76bd49b463920dc9$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $dH1HR.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, $2YC7S.default)((0, $6bw5F.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $dH1HR.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $76bd49b463920dc9$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("lG89z", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", function () { return $fc83d84f860f3aa1$export$d1c6f249e893cdf4; });

var $buizf = parcelRequire("buizf");

var $eDKm5 = parcelRequire("eDKm5");

var $lS9r5 = parcelRequire("lS9r5");

var $bLHDm = parcelRequire("bLHDm");
function $fc83d84f860f3aa1$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $eDKm5.isSafari)()) return (0, $lS9r5.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $buizf.isFirefox)()) return (0, $bLHDm.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("2l4oN", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", function () { return $1b40f4778b8d80bc$export$9c0606fcefb5d1e2; });

var $dH1HR = parcelRequire("dH1HR");
parcelRequire("2PdkP");
var $5MWZy = parcelRequire("5MWZy");
parcelRequire("5Y2uj");
var $it899 = parcelRequire("it899");

var $fu24Y = parcelRequire("fu24Y");
function $1b40f4778b8d80bc$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $dH1HR.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $it899.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $5MWZy.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $1b40f4778b8d80bc$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $dH1HR.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $1b40f4778b8d80bc$var$api = (0, $fu24Y.makeFixForAdapter)({
    watchForInteractionStart: $1b40f4778b8d80bc$var$watchForInteractionStart,
    watchForInteractionEnd: $1b40f4778b8d80bc$var$watchForInteractionEnd
});
function $1b40f4778b8d80bc$export$9c0606fcefb5d1e2() {
    return $1b40f4778b8d80bc$var$api.registerUsage();
}

});
parcelRegister("5Y2uj", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", function () { return (parcelRequire("it899")).monitorForTextSelection; });

var $it899 = parcelRequire("it899");
 // Payload for the text selection being dragged

});
parcelRegister("it899", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", function () { return $d7214130f71ef9ca$export$2e178e3647f5e6e9; });

var $dH1HR = parcelRequire("dH1HR");

var $1FfUa = parcelRequire("1FfUa");

var $5NK67 = parcelRequire("5NK67");

var $5MWZy = parcelRequire("5MWZy");

var $eDKm5 = parcelRequire("eDKm5");

var $11nqE = parcelRequire("11nqE");

var $jpD7X = parcelRequire("jpD7X");

var $3mIgn = parcelRequire("3mIgn");
function $d7214130f71ef9ca$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $eDKm5.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $jpD7X.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $d7214130f71ef9ca$var$honeyPotFix = (0, $1FfUa.makeHoneyPotFix)();
var $d7214130f71ef9ca$var$adapter = (0, $5NK67.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $5MWZy.combine)($d7214130f71ef9ca$var$honeyPotFix.bindEvents(), (0, $dH1HR.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $3mIgn.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $jpD7X.textMediaType))) return;
                var target = $d7214130f71ef9ca$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $jpD7X.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $11nqE.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $d7214130f71ef9ca$var$honeyPotFix.getOnPostDispatch()
});
function $d7214130f71ef9ca$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $d7214130f71ef9ca$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $d7214130f71ef9ca$var$adapter.registerUsage();
})();
function $d7214130f71ef9ca$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $d7214130f71ef9ca$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("11nqE", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", function () { return $0be80eeb24e6b8da$export$338a9f6c7a1f02b0; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $0be80eeb24e6b8da$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("5DuyD", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", function () { return $41a84c5a70cdfc96$export$a3da89b899389ed8; });
$parcel$export(module.exports, "dialogHeight", function () { return $41a84c5a70cdfc96$export$ceba93bf0bdd16f2; });

var $3J1Qg = parcelRequire("3J1Qg");
var $41a84c5a70cdfc96$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = (0, $3J1Qg.width).values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat((0, $3J1Qg.width).widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $41a84c5a70cdfc96$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("aCwnd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7bb690b4b5e0bc00$export$2e2bcd8739ae039; });

var $4Lw69 = parcelRequire("4Lw69");

var $3dJ4i = parcelRequire("3dJ4i");

var $ds4sp = parcelRequire("ds4sp");

var $hNa1l = parcelRequire("hNa1l");

var $cAeoO = parcelRequire("cAeoO");

var $jwsvk = parcelRequire("jwsvk");

var $3J1Qg = parcelRequire("3J1Qg");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7bb690b4b5e0bc00$var$maxWidthDimensions = "calc(100vw - ".concat((0, $3J1Qg.gutter) * 2, "px)");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7bb690b4b5e0bc00$var$maxHeightDimensions = "calc(100vh - ".concat((0, $3J1Qg.gutter) * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $7bb690b4b5e0bc00$var$positionerStyles = (0, $3dJ4i.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: (0, $jwsvk.layers).modal(),
    flexDirection: 'column',
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $7bb690b4b5e0bc00$var$viewportScrollStyles = (0, $3dJ4i.css)((0, $4Lw69.default)({
    height: 'auto',
    position: 'relative'
}, (0, $cAeoO.media).above.xs, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "".concat((0, $3J1Qg.gutter), "px auto"),
    pointerEvents: 'none'
}));
var $7bb690b4b5e0bc00$var$bodyScrollStyles = (0, $3dJ4i.css)((0, $4Lw69.default)({}, (0, $cAeoO.media).above.xs, {
    maxWidth: $7bb690b4b5e0bc00$var$maxWidthDimensions,
    maxHeight: $7bb690b4b5e0bc00$var$maxHeightDimensions,
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: "".concat((0, $3J1Qg.gutter), "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: 'auto',
    marginInlineStart: 'auto',
    pointerEvents: 'none'
}));
var $7bb690b4b5e0bc00$var$stackTransitionStyles = (0, $3dJ4i.css)({
    transitionDuration: "".concat((0, $hNa1l.mediumDurationMs), "ms"),
    transitionProperty: 'transform',
    transitionTimingFunction: (0, $ds4sp.easeInOut),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
});
var $7bb690b4b5e0bc00$var$stackTransformStyles = (0, $3dJ4i.css)({
    transform: 'translateY(var(--modal-dialog-translate-y))'
});
var $7bb690b4b5e0bc00$var$stackIdleStyles = (0, $3dJ4i.css)({
    transform: 'none'
});
var $7bb690b4b5e0bc00$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $3dJ4i.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-translate-y': "".concat(stackIndex * ((0, $3J1Qg.verticalOffset) / 2), "px")
        },
        css: [
            $7bb690b4b5e0bc00$var$positionerStyles,
            $7bb690b4b5e0bc00$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $7bb690b4b5e0bc00$var$stackTransformStyles : $7bb690b4b5e0bc00$var$stackIdleStyles,
            shouldScrollInViewport ? $7bb690b4b5e0bc00$var$viewportScrollStyles : $7bb690b4b5e0bc00$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7bb690b4b5e0bc00$export$2e2bcd8739ae039 = $7bb690b4b5e0bc00$var$Positioner;

});


parcelRegister("cYLeP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $972fbb2543ae7417$export$2e2bcd8739ae039; });

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");

var $kXeye = parcelRequire("kXeye");

var $7mgaa = parcelRequire("7mgaa");

var $lECXY = parcelRequire("lECXY");

var $iFTR1 = parcelRequire("iFTR1");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $972fbb2543ae7417$var$modalStackRegister = [];
function $972fbb2543ae7417$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $iFTR1.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $lECXY.default)(0), _useStateRef2 = (0, $py6Rq.default)(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $7mgaa.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $kXeye.default)(function() {
        var newStackIndex = $972fbb2543ae7417$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $1oC0p.useEffect)(function() {
        var currentStackIndex = $972fbb2543ae7417$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $972fbb2543ae7417$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $972fbb2543ae7417$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $972fbb2543ae7417$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $972fbb2543ae7417$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $972fbb2543ae7417$var$modalStackRegister.splice(currentStackIndex, 1);
                $972fbb2543ae7417$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("kXeye", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f4149adc3ffc796b$export$2e2bcd8739ae039; });

var $25efB = parcelRequire("25efB");
function $f4149adc3ffc796b$export$2e2bcd8739ae039(callback) {
    var ref = (0, $25efB.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("25efB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $18471a4f0cf9d428$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $18471a4f0cf9d428$var$uniqueReferencedValue = {};
function $18471a4f0cf9d428$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $1oC0p.useRef)($18471a4f0cf9d428$var$uniqueReferencedValue);
    if (ref.current === $18471a4f0cf9d428$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("7mgaa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $55b720160a52bcf0$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $55b720160a52bcf0$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)();
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("lECXY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc3b8f4e1c046515$export$2e2bcd8739ae039; });

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");
function $fc3b8f4e1c046515$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $1oC0p.useState)(initialState), _useState2 = (0, $py6Rq.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $1oC0p.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("luDIz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa5b357629860409$export$2e2bcd8739ae039; });

var $py6Rq = parcelRequire("py6Rq");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $fa5b357629860409$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $fa5b357629860409$export$2e2bcd8739ae039() {
    var _useState = (0, $1oC0p.useState)(0), _useState2 = (0, $py6Rq.default)(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $1oC0p.useLayoutEffect)(function() {
        setScrollTopOffset($fa5b357629860409$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $1oC0p.useCallback)(function() {
        if ($fa5b357629860409$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("izxiU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8555459e046abe9$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $iFTR1 = parcelRequire("iFTR1");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d8555459e046abe9$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iFTR1.default), {
        appear: true
    }, props.children);
};
var $d8555459e046abe9$export$2e2bcd8739ae039 = $d8555459e046abe9$var$ModalTransition;

});

parcelRegister("5elx1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7e66589224ee5bc2$export$2e2bcd8739ae039; });
/* site-selector-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $2w1VK = parcelRequire("2w1VK");

var $2HpGy = parcelRequire("2HpGy");

var $75T6S = parcelRequire("75T6S");
const $7e66589224ee5bc2$var$SiteSelectorView = ({ userName: userName, userEmail: userEmail, sites: sites, avatarSrc: avatarSrc, header: header, onNewSiteSelected: onNewSiteSelected, onSiteSelected: onSiteSelected, onSwitchAccountClick: onSwitchAccountClick, onCancelClick: onCancelClick, onSiteChanged: onSiteChanged, fullScreenView: fullScreenView })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ect41wi2"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect4q6fz"
                ]),
                children: header !== undefined ? header : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HpGy.default), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_19pkgktf _2hwxidpf _otyrgktf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2w1VK.default), {
                    userName: userName,
                    userEmail: userEmail,
                    avatarSrc: avatarSrc
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $75T6S.default), {
                    sites: sites,
                    onNewSiteSelected: onNewSiteSelected,
                    onSiteSelected: onSiteSelected,
                    onSwitchAccountClick: onSwitchAccountClick,
                    onCancelClick: onCancelClick,
                    onSiteChanged: onSiteChanged,
                    fullScreenView: fullScreenView
                })
            })
        ]
    });
};
const $7e66589224ee5bc2$var$rootContainerStyle = null;
const $7e66589224ee5bc2$var$headerStyle = null;
const $7e66589224ee5bc2$var$avatarContainerStyle = null;
var $7e66589224ee5bc2$export$2e2bcd8739ae039 = $7e66589224ee5bc2$var$SiteSelectorView;

});
parcelRegister("2w1VK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $089154bfb426b91c$export$2e2bcd8739ae039; });
/* account-details.tsx generated by @compiled/babel-plugin v0.28.8 */ //@ts-nocheck

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $iel97 = parcelRequire("iel97");
var $4SA4u = parcelRequire("4SA4u");

var $5KKfP = parcelRequire("5KKfP");
const $089154bfb426b91c$var$AccountDetails = ({ userName: userName, userEmail: userEmail, avatarSrc: avatarSrc })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iel97.default), {
        avatar: avatarSrc !== undefined ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
            src: avatarSrc
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsbzwfg _4t3izwfg _2rko1ssb _bfhkj1oc"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _ect41wi2 _1wyb19bv _vwz419bv _syazvwuj _1bsb1osq _4t3i1osq _bfhkj1oc _2rko1ssb"
                ]),
                children: (0, $5KKfP.getInitials)(userName)
            })
        }),
        primaryText: userName,
        secondaryText: userEmail
    }, userEmail);
const $089154bfb426b91c$var$initialsStyle = null;
const $089154bfb426b91c$var$initialsContainerStyle = null;
var $089154bfb426b91c$export$2e2bcd8739ae039 = $089154bfb426b91c$var$AccountDetails;

});
parcelRegister("iel97", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d459effde292a54b$export$2e2bcd8739ae039; });

var $duejz = parcelRequire("duejz");

var $catgr = parcelRequire("catgr");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $f3FjI = parcelRequire("f3FjI");

var $7O6y4 = parcelRequire("7O6y4");

var $h79Bo = parcelRequire("h79Bo");

var $eZJFw = parcelRequire("eZJFw");

var $8Zbm4 = parcelRequire("8Zbm4");
var $d459effde292a54b$var$_templateObject;
function $d459effde292a54b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d459effde292a54b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d459effde292a54b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $duejz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d459effde292a54b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d459effde292a54b$var$avatarItemStyles = (0, $3dJ4i.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 1 100%',
    lineHeight: '1.4',
    paddingInlineStart: "var(--ds-space-100, 8px)"
});
var $d459effde292a54b$var$getStyles = function getStyles(css, _ref) {
    var backgroundColor = _ref.backgroundColor, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($d459effde292a54b$var$_templateObject || ($d459effde292a54b$var$_templateObject = (0, $catgr.default)([
        "\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    border: ",
        "px solid transparent;\n    box-sizing: border-box;\n    color: inherit;\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    outline: none;\n    margin: ",
        ";\n    padding: ",
        ";\n    text-align: left;\n    text-decoration: none;\n    width: 100%;\n\n    ",
        "\n\n    ",
        "\n  "
    ])), backgroundColor, (0, $7O6y4.borderRadius)(), (0, $h79Bo.BORDER_WIDTH), "var(--ds-space-0, 0px)", "var(--ds-space-050, 4px)", isInteractive && "\n        :hover {\n          background-color: ".concat("var(--ds-background-neutral-subtle-hovered, ".concat((0, $f3FjI.N30), ")"), ";\n          cursor: pointer;\n          text-decoration: none;\n        }\n\n        :focus {\n          outline: none;\n          border-color: ", "var(--ds-border-focused, ".concat((0, $f3FjI.B200), ")"), ";\n        }\n\n        :active {\n          background-color: ", "var(--ds-background-neutral-subtle-pressed, ".concat((0, $f3FjI.B50), ")"), ";\n        }\n      "), isDisabled && "\n        cursor: not-allowed;\n        opacity: ".concat("var(--ds-opacity-disabled, 0.5)", ";\n        pointer-events: none;\n      "));
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ var $d459effde292a54b$var$AvatarItem = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var avatar = _ref2.avatar, _ref2$backgroundColor = _ref2.backgroundColor, backgroundColor = _ref2$backgroundColor === void 0 ? 'transparent' : _ref2$backgroundColor, children = _ref2.children, isTruncationDisabled = _ref2.isTruncationDisabled, href = _ref2.href, isDisabled = _ref2.isDisabled, onClick = _ref2.onClick, primaryText = _ref2.primaryText, secondaryText = _ref2.secondaryText, target = _ref2.target, testId = _ref2.testId, label = _ref2.label;
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            'data-testid': "".concat(testId, "--itemInner")
        } : {
            testId: "".concat(testId, "--itemInner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $d459effde292a54b$var$_objectSpread($d459effde292a54b$var$_objectSpread({}, href && (0, $8Zbm4.getLinkProps)(href, target)), onClick && !href ? (0, $8Zbm4.getButtonProps)(onClick) : {
            onClick: onClick
        });
    };
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref3) {
        var css = _ref3.css;
        var props = $d459effde292a54b$var$_objectSpread($d459effde292a54b$var$_objectSpread($d459effde292a54b$var$_objectSpread($d459effde292a54b$var$_objectSpread({
            ref: ref,
            className: $d459effde292a54b$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (onClick || href) && {
            'aria-label': label
        }), {}, {
            children: (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, avatar, (0, $3dJ4i.jsx)("div", {
                css: $d459effde292a54b$var$avatarItemStyles
            }, (0, $3dJ4i.jsx)((0, $eZJFw.default), {
                shouldTruncate: !isTruncationDisabled
            }, primaryText), (0, $3dJ4i.jsx)((0, $eZJFw.default), {
                isSecondary: true,
                shouldTruncate: !isTruncationDisabled
            }, secondaryText)))
        });
        return children ? children(props) : /*#__PURE__*/ (0, $1oC0p.createElement)((0, $8Zbm4.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$d459effde292a54b$var$AvatarItem.displayName = 'AvatarItem';
var $d459effde292a54b$export$2e2bcd8739ae039 = $d459effde292a54b$var$AvatarItem;

});
parcelRegister("duejz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d192e4c90b4d507$export$2e2bcd8739ae039; });

var $7LpmY = parcelRequire("7LpmY");
function $9d192e4c90b4d507$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7LpmY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("7LpmY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5a709a0f8fc65e35$export$2e2bcd8739ae039; });

var $biZk3 = parcelRequire("biZk3");

var $fOwfr = parcelRequire("fOwfr");
function $5a709a0f8fc65e35$export$2e2bcd8739ae039(t) {
    var i = (0, $fOwfr.default)(t, "string");
    return "symbol" == (0, $biZk3.default)(i) ? i : i + "";
}

});
parcelRegister("biZk3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $83b0f1855a103287$export$2e2bcd8739ae039; });
function $83b0f1855a103287$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $83b0f1855a103287$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $83b0f1855a103287$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fOwfr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8348a4d3df2ea11$export$2e2bcd8739ae039; });

var $biZk3 = parcelRequire("biZk3");
function $b8348a4d3df2ea11$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $biZk3.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $biZk3.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("catgr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8dbd1e773b793aea$export$2e2bcd8739ae039; });
function $8dbd1e773b793aea$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("f3FjI", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $af672f81f463e846$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $af672f81f463e846$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G300", function () { return $af672f81f463e846$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $af672f81f463e846$export$a49394138f7b8e85; });
$parcel$export(module.exports, "B50", function () { return $af672f81f463e846$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $af672f81f463e846$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $af672f81f463e846$export$e62e8919cca44969; });
$parcel$export(module.exports, "P300", function () { return $af672f81f463e846$export$b48405b95304b5a1; });
$parcel$export(module.exports, "N0", function () { return $af672f81f463e846$export$29a4f05edc054374; });
$parcel$export(module.exports, "N30", function () { return $af672f81f463e846$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $af672f81f463e846$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N90", function () { return $af672f81f463e846$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $af672f81f463e846$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $af672f81f463e846$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N900", function () { return $af672f81f463e846$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $af672f81f463e846$export$920c0d5c49070351; });
$parcel$export(module.exports, "N70A", function () { return $af672f81f463e846$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "skeleton", function () { return $af672f81f463e846$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eMA0c = parcelRequire("eMA0c");
var $af672f81f463e846$export$4b84fd0e2c617bd = '#FFEBE6';
var $af672f81f463e846$export$b34b069eff244586 = '#FFBDAD';
var $af672f81f463e846$export$be802dd0d8b57f35 = '#FF8F73';
var $af672f81f463e846$export$60847d42f9da92a6 = '#FF7452';
var $af672f81f463e846$export$4a7404f376229999 = '#FF5630';
var $af672f81f463e846$export$2010d0fb4295b346 = '#DE350B';
var $af672f81f463e846$export$2837b5a1a71d5c02 = '#BF2600';
var $af672f81f463e846$export$8d9596b529bbb9cf = '#FFFAE6';
var $af672f81f463e846$export$41060a744ab0b7ae = '#FFF0B3';
var $af672f81f463e846$export$1cc05bbbf340e559 = '#FFE380';
var $af672f81f463e846$export$5aae31392d72caaa = '#FFC400';
var $af672f81f463e846$export$c6930421db9fa514 = '#FFAB00';
var $af672f81f463e846$export$59619663aa6500fb = '#FF991F';
var $af672f81f463e846$export$874739ea9e379ab6 = '#FF8B00';
var $af672f81f463e846$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $af672f81f463e846$export$69a3bf21b9686c2b = '#ABF5D1';
var $af672f81f463e846$export$afbce1382ec95f73 = '#79F2C0';
var $af672f81f463e846$export$747d86715d4175de = '#57D9A3';
var $af672f81f463e846$export$940e1f69e873f202 = '#36B37E';
var $af672f81f463e846$export$a49394138f7b8e85 = '#00875A';
var $af672f81f463e846$export$6fa04827ac68a4fb = '#006644';
var $af672f81f463e846$export$226de0355ed012f8 = '#DEEBFF';
var $af672f81f463e846$export$8c13c2ee36917869 = '#B3D4FF';
var $af672f81f463e846$export$ecfc1dff386a3e7a = '#4C9AFF';
var $af672f81f463e846$export$215b7063051591f1 = '#2684FF';
var $af672f81f463e846$export$e62e8919cca44969 = '#0065FF';
var $af672f81f463e846$export$b3de0ae08da2ce64 = '#0052CC';
var $af672f81f463e846$export$a6ee3d71bc067634 = '#0747A6';
var $af672f81f463e846$export$363e4475840015bb = '#EAE6FF';
var $af672f81f463e846$export$4b0a4417ed59760f = '#C0B6F2';
var $af672f81f463e846$export$6011520a64d9a187 = '#998DD9';
var $af672f81f463e846$export$a7175d4e9206bc80 = '#8777D9';
var $af672f81f463e846$export$b48405b95304b5a1 = '#6554C0';
var $af672f81f463e846$export$c71e4279dd54a18d = '#5243AA';
var $af672f81f463e846$export$147899de772240ec = '#403294';
var $af672f81f463e846$export$2cf711fe14c66f06 = '#E6FCFF';
var $af672f81f463e846$export$7a8f4d33f6f9772c = '#B3F5FF';
var $af672f81f463e846$export$776c9c497ef08533 = '#79E2F2';
var $af672f81f463e846$export$69cb3ca10c1e330e = '#00C7E6';
var $af672f81f463e846$export$9dc1ef0f3f48059b = '#00B8D9';
var $af672f81f463e846$export$7c835c78b6fcdef8 = '#00A3BF';
var $af672f81f463e846$export$6036577f95c3877e = '#008DA6';
var $af672f81f463e846$export$29a4f05edc054374 = '#FFFFFF';
var $af672f81f463e846$export$e655ef011c4aa1a2 = '#FAFBFC';
var $af672f81f463e846$export$9fdfb749e33cdf97 = '#F4F5F7';
var $af672f81f463e846$export$3e51e8f1440314ba = '#EBECF0';
var $af672f81f463e846$export$1ce2d1575d444ceb = '#DFE1E6';
var $af672f81f463e846$export$8754fc7e6d8b3000 = '#C1C7D0';
var $af672f81f463e846$export$c2e91cbeada39b8b = '#B3BAC5';
var $af672f81f463e846$export$5f71e19f3a7ad9de = '#A5ADBA';
var $af672f81f463e846$export$eaa8c8a70ac22806 = '#97A0AF';
var $af672f81f463e846$export$7c87d337fb91a97d = '#8993A4';
var $af672f81f463e846$export$d6447c357493214f = '#7A869A';
var $af672f81f463e846$export$f563ee71e9ee74cd = '#6B778C';
var $af672f81f463e846$export$e2ef2124cf4024b1 = '#5E6C84';
var $af672f81f463e846$export$eece5f492e429f08 = '#505F79';
var $af672f81f463e846$export$c39c0fe0f26207ae = '#42526E';
var $af672f81f463e846$export$7090862dc3038a9f = '#344563';
var $af672f81f463e846$export$ad0bacf983b7ddaa = '#253858';
var $af672f81f463e846$export$7d61b15e0da132af = '#172B4D';
var $af672f81f463e846$export$fbda843f0a27fe96 = '#091E42';
var $af672f81f463e846$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $af672f81f463e846$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $af672f81f463e846$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $af672f81f463e846$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $af672f81f463e846$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $af672f81f463e846$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $af672f81f463e846$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $af672f81f463e846$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $af672f81f463e846$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $af672f81f463e846$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $af672f81f463e846$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $af672f81f463e846$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $af672f81f463e846$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $af672f81f463e846$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $af672f81f463e846$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $af672f81f463e846$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $af672f81f463e846$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $af672f81f463e846$export$2f6319cf7d736c2a = '#E6EDFA';
var $af672f81f463e846$export$95126bc8884d6634 = '#DCE5F5';
var $af672f81f463e846$export$8338d8c35d44ff1 = '#CED9EB';
var $af672f81f463e846$export$5368d76ae4fbbda7 = '#B8C7E0';
var $af672f81f463e846$export$9f0a771d16ec8d36 = '#ABBBD6';
var $af672f81f463e846$export$abcf8c38338b4aa5 = '#9FB0CC';
var $af672f81f463e846$export$97e81faa16a182c7 = '#8C9CB8';
var $af672f81f463e846$export$bfe21c59123ecf33 = '#7988A3';
var $af672f81f463e846$export$ee82aa2ea6a1558 = '#67758F';
var $af672f81f463e846$export$682927c6ed76be02 = '#56637A';
var $af672f81f463e846$export$91fd9994c5be9757 = '#455166';
var $af672f81f463e846$export$d281fbfe3cff2df6 = '#3B475C';
var $af672f81f463e846$export$3902c91d8b98a753 = '#313D52';
var $af672f81f463e846$export$8e8133c1ba5845b5 = '#283447';
var $af672f81f463e846$export$33ff357f6620b39 = '#202B3D';
var $af672f81f463e846$export$633847cf062b69e0 = '#1B2638';
var $af672f81f463e846$export$9776a6e503bdbf76 = '#121A29';
var $af672f81f463e846$export$6c813d5160dff5db = '#0E1624';
var $af672f81f463e846$export$3d4f271a500072a = '#0D1424';
var $af672f81f463e846$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $af672f81f463e846$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $af672f81f463e846$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $af672f81f463e846$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $af672f81f463e846$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $af672f81f463e846$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $af672f81f463e846$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $af672f81f463e846$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $af672f81f463e846$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $af672f81f463e846$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $af672f81f463e846$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $af672f81f463e846$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $af672f81f463e846$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $af672f81f463e846$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $af672f81f463e846$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $af672f81f463e846$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $af672f81f463e846$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $af672f81f463e846$export$8ce1fd94bee2f412 = (0, $eMA0c.default)({
    light: "var(--ds-surface, ".concat($af672f81f463e846$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($af672f81f463e846$export$633847cf062b69e0, ")")
});
var $af672f81f463e846$export$b861914ea877b580 = (0, $eMA0c.default)({
    light: "var(--ds-background-selected, ".concat($af672f81f463e846$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($af672f81f463e846$export$8c13c2ee36917869, ")")
});
var $af672f81f463e846$export$3f1b020df94387af = (0, $eMA0c.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($af672f81f463e846$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($af672f81f463e846$export$d281fbfe3cff2df6, ")")
});
var $af672f81f463e846$export$c0183dbab98ca63e = (0, $eMA0c.default)({
    light: "var(--ds-surface-overlay, ".concat($af672f81f463e846$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($af672f81f463e846$export$8e8133c1ba5845b5, ")")
});
var $af672f81f463e846$export$6f093cfa640b7166 = (0, $eMA0c.default)({
    light: "var(--ds-text, ".concat($af672f81f463e846$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($af672f81f463e846$export$5368d76ae4fbbda7, ")")
});
var $af672f81f463e846$export$42f8e9c698766e7a = (0, $eMA0c.default)({
    light: "var(--ds-text, ".concat($af672f81f463e846$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($af672f81f463e846$export$5368d76ae4fbbda7, ")")
});
var $af672f81f463e846$export$c2d157ca1c34b6e3 = (0, $eMA0c.default)({
    light: "var(--ds-text-selected, ".concat($af672f81f463e846$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($af672f81f463e846$export$b3de0ae08da2ce64, ")")
});
var $af672f81f463e846$export$1905ba28d7cf066f = (0, $eMA0c.default)({
    light: "var(--ds-text-subtlest, ".concat($af672f81f463e846$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($af672f81f463e846$export$97e81faa16a182c7, ")")
});
var $af672f81f463e846$export$bd9002130d306d39 = (0, $eMA0c.default)({
    light: "var(--ds-text-subtlest, ".concat($af672f81f463e846$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($af672f81f463e846$export$bfe21c59123ecf33, ")")
});
var $af672f81f463e846$export$46e4a324ac90507f = (0, $eMA0c.default)({
    light: "var(--ds-text, ".concat($af672f81f463e846$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($af672f81f463e846$export$5368d76ae4fbbda7, ")")
});
var $af672f81f463e846$export$79f3f2b82beb0d36 = (0, $eMA0c.default)({
    light: "var(--ds-text-subtlest, ".concat($af672f81f463e846$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($af672f81f463e846$export$97e81faa16a182c7, ")")
});
var $af672f81f463e846$export$7bb0d5c671655cc4 = (0, $eMA0c.default)({
    light: $af672f81f463e846$export$9fdfb749e33cdf97,
    dark: $af672f81f463e846$export$8e8133c1ba5845b5
});
var $af672f81f463e846$export$9c30223ca0a664fb = (0, $eMA0c.default)({
    light: "var(--ds-link, ".concat($af672f81f463e846$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($af672f81f463e846$export$ecfc1dff386a3e7a, ")")
});
var $af672f81f463e846$export$7ed258b0728b004b = (0, $eMA0c.default)({
    light: "var(--ds-link-pressed, ".concat($af672f81f463e846$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($af672f81f463e846$export$215b7063051591f1, ")")
});
var $af672f81f463e846$export$dfa920d8decc8a59 = (0, $eMA0c.default)({
    light: "var(--ds-link-pressed, ".concat($af672f81f463e846$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($af672f81f463e846$export$ecfc1dff386a3e7a, ")")
});
var $af672f81f463e846$export$6069e6ad5c78f632 = (0, $eMA0c.default)({
    light: "var(--ds-border-focused, ".concat($af672f81f463e846$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($af672f81f463e846$export$215b7063051591f1, ")")
});
var $af672f81f463e846$export$9ad721cf3b3debe0 = (0, $eMA0c.default)({
    light: "var(--ds-background-brand-bold, ".concat($af672f81f463e846$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($af672f81f463e846$export$ecfc1dff386a3e7a, ")")
});
var $af672f81f463e846$export$2aa0182783e7e9de = (0, $eMA0c.default)({
    light: $af672f81f463e846$export$b3de0ae08da2ce64,
    dark: $af672f81f463e846$export$ecfc1dff386a3e7a
});
var $af672f81f463e846$export$8bf7dff220b82b4a = (0, $eMA0c.default)({
    light: $af672f81f463e846$export$9dc1ef0f3f48059b,
    dark: $af672f81f463e846$export$69cb3ca10c1e330e
});
var $af672f81f463e846$export$e13cce2a2d16a9d4 = (0, $eMA0c.default)({
    light: $af672f81f463e846$export$b48405b95304b5a1,
    dark: $af672f81f463e846$export$6011520a64d9a187
});
var $af672f81f463e846$export$a90204d1394caf30 = (0, $eMA0c.default)({
    light: $af672f81f463e846$export$4a7404f376229999,
    dark: $af672f81f463e846$export$4a7404f376229999
});
var $af672f81f463e846$export$594c5a8758200c32 = (0, $eMA0c.default)({
    light: $af672f81f463e846$export$c6930421db9fa514,
    dark: $af672f81f463e846$export$c6930421db9fa514
});
var $af672f81f463e846$export$955a2ebd2fb142ae = (0, $eMA0c.default)({
    light: $af672f81f463e846$export$940e1f69e873f202,
    dark: $af672f81f463e846$export$940e1f69e873f202
});
var $af672f81f463e846$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($af672f81f463e846$export$8d43898f60b96a82, ")");
};

});
parcelRegister("eMA0c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ac3179a9ca8016f0$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $2QqWa = parcelRequire("2QqWa");
// Unpack custom variants, and get correct value for the current theme
function $ac3179a9ca8016f0$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $2QqWa.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $ac3179a9ca8016f0$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $ac3179a9ca8016f0$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $2QqWa.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("2QqWa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $212555469819ff74$export$2e2bcd8739ae039; });

var $7O6y4 = parcelRequire("7O6y4");
function $212555469819ff74$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $7O6y4.CHANNEL) in props.theme) return props.theme[0, $7O6y4.CHANNEL];
        else if ('mode' in props.theme && (0, $7O6y4.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $7O6y4.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("7O6y4", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $5af248541c30f490$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $5af248541c30f490$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $5af248541c30f490$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "borderRadius", function () { return $5af248541c30f490$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $5af248541c30f490$export$6d8204c2cb2e06b8; });

var $1Aess = parcelRequire("1Aess");

var $f3FjI = parcelRequire("f3FjI");
var $5af248541c30f490$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $5af248541c30f490$export$c93026a968943f95 = 'light';
var $5af248541c30f490$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $5af248541c30f490$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $5af248541c30f490$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $5af248541c30f490$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $5af248541c30f490$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $5af248541c30f490$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $5af248541c30f490$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $5af248541c30f490$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $f3FjI.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5af248541c30f490$export$6d8204c2cb2e06b8() / 4;
    (0, $1Aess.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $5af248541c30f490$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $5af248541c30f490$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $5af248541c30f490$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1Aess.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $5af248541c30f490$export$ba1d834b86d72a09 = $5af248541c30f490$export$a1b3edb637fb4f35;
var $5af248541c30f490$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $f3FjI.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $f3FjI.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $f3FjI.N30A), ")")
            }
        }
    };
};

});
parcelRegister("1Aess", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $12745e4537c6afba$export$2e2bcd8739ae039; });

var $chSUZ = parcelRequire("chSUZ");

var $7t0tI = parcelRequire("7t0tI");
function $12745e4537c6afba$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $chSUZ.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $12745e4537c6afba$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("chSUZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8f21ac3181492347$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $8f21ac3181492347$var$printed = {};
function $8f21ac3181492347$export$2e2bcd8739ae039(message) {
    if ($8f21ac3181492347$var$printed[message]) return;
    $8f21ac3181492347$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("h79Bo", function(module, exports) {
$parcel$export(module.exports, "AVATAR_SIZES", function () { return $c75a89de8799d341$export$9a270941bcff7e77; });
$parcel$export(module.exports, "AVATAR_RADIUS", function () { return $c75a89de8799d341$export$e6da6efe4d1a5c9b; });
$parcel$export(module.exports, "BORDER_WIDTH", function () { return $c75a89de8799d341$export$e2bd4c1faded7921; });
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", function () { return $c75a89de8799d341$export$89a980dfdf90df51; });
$parcel$export(module.exports, "ICON_SIZES", function () { return $c75a89de8799d341$export$fdc820179f1f9be4; });
$parcel$export(module.exports, "ICON_OFFSET", function () { return $c75a89de8799d341$export$382610e783aa2ae8; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $7O6y4 = parcelRequire("7O6y4");
var $c75a89de8799d341$export$9a270941bcff7e77 = {
    xsmall: (0, $7O6y4.gridSize)() * 2,
    small: (0, $7O6y4.gridSize)() * 3,
    medium: (0, $7O6y4.gridSize)() * 4,
    large: (0, $7O6y4.gridSize)() * 5,
    xlarge: (0, $7O6y4.gridSize)() * 12,
    xxlarge: (0, $7O6y4.gridSize)() * 16
};
var $c75a89de8799d341$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $c75a89de8799d341$export$e2bd4c1faded7921 = 2;
var $c75a89de8799d341$export$89a980dfdf90df51 = 0.9;
var $c75a89de8799d341$export$3c061e31594ebabe = '--avatar-background-color';
var $c75a89de8799d341$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $c75a89de8799d341$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("eZJFw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aeaa300b028fb12c$export$2e2bcd8739ae039; });
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $3dJ4i = parcelRequire("3dJ4i");

var $f3FjI = parcelRequire("f3FjI");
var $aeaa300b028fb12c$var$baseStyles = (0, $3dJ4i.css)({
    display: 'block',
    margin: "var(--ds-space-0, 0px)",
    color: "var(--ds-text, ".concat((0, $f3FjI.N900), ")")
});
var $aeaa300b028fb12c$var$truncateStyles = (0, $3dJ4i.css)({
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $aeaa300b028fb12c$var$secondaryStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $f3FjI.N200), ")"),
    fontSize: '0.85em'
});
/**
 * __Text__
 *
 * Text is used internally only.
 */ var $aeaa300b028fb12c$var$Text = function Text(_ref) {
    var isSecondary = _ref.isSecondary, children = _ref.children, shouldTruncate = _ref.shouldTruncate;
    return (0, $3dJ4i.jsx)("span", {
        css: [
            $aeaa300b028fb12c$var$baseStyles,
            isSecondary && $aeaa300b028fb12c$var$secondaryStyles,
            shouldTruncate && $aeaa300b028fb12c$var$truncateStyles
        ]
    }, children);
};
var $aeaa300b028fb12c$export$2e2bcd8739ae039 = $aeaa300b028fb12c$var$Text;

});

parcelRegister("8Zbm4", function(module, exports) {
$parcel$export(module.exports, "getLinkProps", function () { return $68acd41d81aa759c$export$60113ebe1cf0ecf; });
$parcel$export(module.exports, "getButtonProps", function () { return $68acd41d81aa759c$export$cca6f1bef43616d3; });
$parcel$export(module.exports, "getCustomElement", function () { return $68acd41d81aa759c$export$83ee468102cdf04c; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
var $68acd41d81aa759c$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === '_blank' ? 'noopener noreferrer' : null,
        target: target
    };
};
var $68acd41d81aa759c$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: 'button',
        onClick: onClick
    };
};
var $68acd41d81aa759c$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});


parcelRegister("4SA4u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $38d82f98a1d789f2$export$2e2bcd8739ae039; });

var $duejz = parcelRequire("duejz");

var $catgr = parcelRequire("catgr");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $6JmtO = parcelRequire("6JmtO");

var $eY3N6 = parcelRequire("eY3N6");

var $f3FjI = parcelRequire("f3FjI");

var $2pxTC = parcelRequire("2pxTC");

var $h79Bo = parcelRequire("h79Bo");

var $c1ZA3 = parcelRequire("c1ZA3");

var $bxzu1 = parcelRequire("bxzu1");

var $8Zbm4 = parcelRequire("8Zbm4");
var $38d82f98a1d789f2$var$_templateObject;
function $38d82f98a1d789f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $38d82f98a1d789f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $38d82f98a1d789f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $duejz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $38d82f98a1d789f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $38d82f98a1d789f2$var$packageName = "@atlaskit/avatar";
var $38d82f98a1d789f2$var$packageVersion = "21.4.6";
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $38d82f98a1d789f2$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $f3FjI.N0), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($38d82f98a1d789f2$var$_templateObject || ($38d82f98a1d789f2$var$_templateObject = (0, $catgr.default)([
        "\n    height: ",
        "px;\n    width: ",
        "px;\n    align-items: stretch;\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0);\n    transition: transform 200ms, opacity 200ms;\n    box-shadow: 0 0 0 ",
        "px ",
        ";\n    border: none;\n    margin: ",
        ";\n    padding: ",
        ";\n\n    /* Added font-size and font-family styles to fix alignment issue in firefox for interactive button avatar */\n    font-size: inherit;\n    font-family: inherit;\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: ",
        ";\n      padding: ",
        ";\n    }\n\n    &::after {\n      background-color: transparent;\n      inset: 0px;\n\n      /* Added border-radius style to fix hover issue in safari */\n      border-radius: ",
        ";\n      content: ' ';\n      opacity: 0;\n      pointer-events: none;\n      position: absolute;\n      transition: opacity 200ms;\n      width: 100%;\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ])), size, size, borderColor, appearance === 'circle' ? '50%' : "".concat(radius, "px"), (0, $h79Bo.BORDER_WIDTH), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === 'circle' ? '50%' : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :focus {\n        outline: none;\n        box-shadow: 0 0 0 ".concat((0, $h79Bo.BORDER_WIDTH), "px ", "var(--ds-border-focused, ".concat((0, $f3FjI.B300), ")"), "\n      }\n\n      :hover {\n        &::after {\n          background-color: ", "var(--ds-interaction-hovered, ".concat((0, $f3FjI.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $f3FjI.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(").concat((0, $h79Bo.ACTIVE_SCALE_FACTOR), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $f3FjI.N0), ")"), ";\n        }\n      "));
};
/**
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage).
 */ var $38d82f98a1d789f2$var$Avatar = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'circle' : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? 'medium' : _ref2$size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? 'div' : _ref2$as;
    var _useAnalyticsEvents = (0, $eY3N6.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var customPresenceNode = /*#__PURE__*/ (0, $1oC0p.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $1oC0p.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $1oC0p.useRef)(analyticsContext);
    var uuid = (0, $6JmtO.useUIDSeed)()('avatar');
    (0, $1oC0p.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $1oC0p.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $38d82f98a1d789f2$var$packageName,
                packageVersion: $38d82f98a1d789f2$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $38d82f98a1d789f2$var$_objectSpread({
            componentName: 'avatar',
            packageName: $38d82f98a1d789f2$var$packageName,
            packageVersion: $38d82f98a1d789f2$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            'data-testid': "".concat(testId, "--inner")
        } : {
            testId: "".concat(testId, "--inner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $38d82f98a1d789f2$var$_objectSpread($38d82f98a1d789f2$var$_objectSpread({}, href && (0, $8Zbm4.getLinkProps)(href, target)), onClick && !href ? (0, $8Zbm4.getButtonProps)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $3dJ4i.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? "".concat(uuid, "-label") : undefined,
        style: {
            display: 'inline-block',
            position: 'relative',
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref3) {
        var css = _ref3.css;
        var props = $38d82f98a1d789f2$var$_objectSpread($38d82f98a1d789f2$var$_objectSpread($38d82f98a1d789f2$var$_objectSpread($38d82f98a1d789f2$var$_objectSpread({
            className: $38d82f98a1d789f2$var$getStyles(css, {
                size: (0, $h79Bo.AVATAR_SIZES)[size],
                radius: (0, $h79Bo.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (isInteractive || children) && {
            'aria-label': label || defaultLabel
        }), {}, {
            children: (0, $3dJ4i.jsx)((0, $2pxTC.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        return children ? children(props) : /*#__PURE__*/ (0, $1oC0p.createElement)((0, $8Zbm4.getCustomElement)(isDisabled, href, onClick), props);
    }), isPresence && (0, $3dJ4i.jsx)((0, $c1ZA3.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $3dJ4i.jsx)((0, $bxzu1.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $3dJ4i.jsx)("span", {
        id: "".concat(uuid, "-label"),
        hidden: true
    }, defaultLabel) : undefined);
});
$38d82f98a1d789f2$var$Avatar.displayName = 'Avatar';
var $38d82f98a1d789f2$export$2e2bcd8739ae039 = $38d82f98a1d789f2$var$Avatar;

});
parcelRegister("2pxTC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1c18359a897fde52$export$2e2bcd8739ae039; });

var $duejz = parcelRequire("duejz");

var $jq2eH = parcelRequire("jq2eH");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $50U23 = parcelRequire("50U23");

var $iOEvT = parcelRequire("iOEvT");

var $f3FjI = parcelRequire("f3FjI");

var $h79Bo = parcelRequire("h79Bo");
function $1c18359a897fde52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c18359a897fde52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c18359a897fde52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $duejz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c18359a897fde52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1c18359a897fde52$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, ".concat((0, $f3FjI.N0), ")");
var $1c18359a897fde52$export$72502e51aebdd94e = "var(--ds-icon-subtle, ".concat((0, $f3FjI.N90), ")");
var $1c18359a897fde52$var$avatarDefaultIconStyles = (0, $3dJ4i.css)({
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: $1c18359a897fde52$export$72502e51aebdd94e
});
var $1c18359a897fde52$var$nestedAvatarStyles = Object.entries((0, $h79Bo.AVATAR_SIZES)).reduce(function(styles, _ref) {
    var _ref2 = (0, $jq2eH.default)(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $1c18359a897fde52$var$_objectSpread($1c18359a897fde52$var$_objectSpread({}, styles), {}, (0, $duejz.default)({}, key, (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '& svg': {
            width: "".concat(size, "px"),
            height: "".concat(size, "px")
        }
    })));
}, {});
var $1c18359a897fde52$var$avatarImageStyles = (0, $3dJ4i.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    flex: '1 1 100%'
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $1c18359a897fde52$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? '' : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $jq2eH.default)(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === 'circle' ? '50%' : "".concat((0, $h79Bo.AVATAR_RADIUS)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $1oC0p.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $3dJ4i.jsx)("span", {
        css: [
            $1c18359a897fde52$var$avatarDefaultIconStyles,
            $1c18359a897fde52$var$nestedAvatarStyles[size]
        ]
    }, appearance === 'circle' ? (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($50U23))), {
        label: alt,
        primaryColor: $1c18359a897fde52$export$ebe0b8fe8b6acbfd,
        secondaryColor: $1c18359a897fde52$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--person"),
        "aria-hidden": isHidden
    }) : (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iOEvT))), {
        label: alt,
        primaryColor: $1c18359a897fde52$export$ebe0b8fe8b6acbfd,
        secondaryColor: $1c18359a897fde52$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--ship"),
        "aria-hidden": isHidden
    }));
    return (0, $3dJ4i.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $1c18359a897fde52$var$avatarImageStyles,
        style: {
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden
    });
};
var $1c18359a897fde52$export$2e2bcd8739ae039 = $1c18359a897fde52$var$AvatarImage;

});
parcelRegister("jq2eH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e2322e0e002769e1$export$2e2bcd8739ae039; });

var $2tann = parcelRequire("2tann");

var $kOLNe = parcelRequire("kOLNe");

var $cpHpI = parcelRequire("cpHpI");

var $hraZX = parcelRequire("hraZX");
function $e2322e0e002769e1$export$2e2bcd8739ae039(r, e) {
    return (0, $2tann.default)(r) || (0, $kOLNe.default)(r, e) || (0, $cpHpI.default)(r, e) || (0, $hraZX.default)();
}

});
parcelRegister("2tann", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1cc656aca4bcecee$export$2e2bcd8739ae039; });
function $1cc656aca4bcecee$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("kOLNe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f27d8cd931558503$export$2e2bcd8739ae039; });
function $f27d8cd931558503$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("cpHpI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90997ee9b7efa34e$export$2e2bcd8739ae039; });

var $dU1lR = parcelRequire("dU1lR");
function $90997ee9b7efa34e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dU1lR.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dU1lR.default)(r, a) : void 0;
    }
}

});
parcelRegister("dU1lR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1f18dbc1b134a5c$export$2e2bcd8739ae039; });
function $a1f18dbc1b134a5c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("hraZX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb1d7d4e6fd77a84$export$2e2bcd8739ae039; });
function $cb1d7d4e6fd77a84$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("50U23", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a686aa35f10cfe3$var$_react = $3a686aa35f10cfe3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $fbesC = parcelRequire("fbesC");
function $3a686aa35f10cfe3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3a686aa35f10cfe3$var$PersonIcon = (props)=>/*#__PURE__*/ $3a686aa35f10cfe3$var$_react.default.createElement($fbesC.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$3a686aa35f10cfe3$var$PersonIcon.displayName = 'PersonIcon';
var $3a686aa35f10cfe3$var$_default = $3a686aa35f10cfe3$var$PersonIcon;
module.exports.default = $3a686aa35f10cfe3$var$_default;

});
parcelRegister("fbesC", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $b0d319a50045d84c$export$f04a61298a47a40f; });

var $fySjE = parcelRequire("fySjE");

var $duejz = parcelRequire("duejz");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $0jICj = parcelRequire("0jICj");

var $e5Z1Z = parcelRequire("e5Z1Z");
function $b0d319a50045d84c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0d319a50045d84c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0d319a50045d84c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $duejz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0d319a50045d84c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $b0d319a50045d84c$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': $b0d319a50045d84c$var$_objectSpread($b0d319a50045d84c$var$_objectSpread({}, (0, $e5Z1Z.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $b0d319a50045d84c$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $b0d319a50045d84c$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $b0d319a50045d84c$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $b0d319a50045d84c$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $e5Z1Z.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $3dJ4i.jsx)("span", (0, $fySjE.default)({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $0jICj.getBackground)()
        }
    }, glyphProps, {
        css: [
            $b0d319a50045d84c$var$iconStyles,
            $b0d319a50045d84c$var$baseHcmStyles,
            primaryColor === secondaryColor && $b0d319a50045d84c$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $b0d319a50045d84c$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $3dJ4i.css)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $b0d319a50045d84c$export$2e2bcd8739ae039 = $b0d319a50045d84c$export$f04a61298a47a40f;

});
parcelRegister("fySjE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b54429fe69afc879$export$2e2bcd8739ae039; });
function $b54429fe69afc879$export$2e2bcd8739ae039() {
    return $b54429fe69afc879$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b54429fe69afc879$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("0jICj", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $000f4be90f5d2e41$export$18cb9425622d4e06; });
var $000f4be90f5d2e41$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});

parcelRegister("e5Z1Z", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $a430dfd910303a0c$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $a430dfd910303a0c$export$3eb7d6130acfda37; });

var $1D1gW = parcelRequire("1D1gW");

var $3dJ4i = parcelRequire("3dJ4i");
var $a430dfd910303a0c$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $a430dfd910303a0c$var$smallStyles = (0, $3dJ4i.css)((0, $1D1gW.dimensions).small);
var $a430dfd910303a0c$var$mediumStyles = (0, $3dJ4i.css)((0, $1D1gW.dimensions).medium);
var $a430dfd910303a0c$var$largeStyles = (0, $3dJ4i.css)((0, $1D1gW.dimensions).large);
var $a430dfd910303a0c$var$xlargeStyles = (0, $3dJ4i.css)((0, $1D1gW.dimensions).xlarge);
var $a430dfd910303a0c$export$ef0ad74202575b64 = {
    small: $a430dfd910303a0c$var$smallStyles,
    medium: $a430dfd910303a0c$var$mediumStyles,
    large: $a430dfd910303a0c$var$largeStyles,
    xlarge: $a430dfd910303a0c$var$xlargeStyles
};
var $a430dfd910303a0c$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $1D1gW.dimensions)[size];
    return undefined;
};

});
parcelRegister("1D1gW", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $12fa6b99c2d55e7c$export$62ad7b0c781000e9; });
var $12fa6b99c2d55e7c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $12fa6b99c2d55e7c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $12fa6b99c2d55e7c$export$62ad7b0c781000e9 = {
    small: {
        width: $12fa6b99c2d55e7c$export$c647cb0ee6e282fe.small,
        height: $12fa6b99c2d55e7c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $12fa6b99c2d55e7c$export$c647cb0ee6e282fe.medium,
        height: $12fa6b99c2d55e7c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $12fa6b99c2d55e7c$export$c647cb0ee6e282fe.large,
        height: $12fa6b99c2d55e7c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $12fa6b99c2d55e7c$export$c647cb0ee6e282fe.xlarge,
        height: $12fa6b99c2d55e7c$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("iOEvT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db2c52a43d1ad75a$var$_react = $db2c52a43d1ad75a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $fbesC = parcelRequire("fbesC");
function $db2c52a43d1ad75a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $db2c52a43d1ad75a$var$ShipIcon = (props)=>/*#__PURE__*/ $db2c52a43d1ad75a$var$_react.default.createElement($fbesC.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 12h8v-2H6v2zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4V8.99z" fill-rule="nonzero"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6V7.005zm4 0V7H7.999c.005 0 .002.003.002.005V8h2v-.995z"/><path d="M4.5 17h13.994l1.002-3H4.14l.36 3zm-2.495-4.012A.862.862 0 012.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.149 1.149 0 01-1.118-.988l-.602-5.024z" fill-rule="nonzero"/></g></svg>`
    }, props));
$db2c52a43d1ad75a$var$ShipIcon.displayName = 'ShipIcon';
var $db2c52a43d1ad75a$var$_default = $db2c52a43d1ad75a$var$ShipIcon;
module.exports.default = $db2c52a43d1ad75a$var$_default;

});


parcelRegister("c1ZA3", function(module, exports) {
$parcel$export(module.exports, "PresenceWrapper", function () { return $8c2558a5f3c977ff$export$972c5e90200fa0ef; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $1oC0p = parcelRequire("1oC0p");

var $f3FjI = parcelRequire("f3FjI");

var $h79Bo = parcelRequire("h79Bo");

var $d91vI = parcelRequire("d91vI");
var $8c2558a5f3c977ff$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $f3FjI.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $f3FjI.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $8c2558a5f3c977ff$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $f3FjI.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $8c2558a5f3c977ff$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $f3FjI.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $f3FjI.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $8c2558a5f3c977ff$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $f3FjI.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $8c2558a5f3c977ff$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $8c2558a5f3c977ff$var$BusyIndicator;
        case 'focus':
            return $8c2558a5f3c977ff$var$FocusIndicator;
        case 'offline':
            return $8c2558a5f3c977ff$var$OfflineIndicator;
        case 'online':
            return $8c2558a5f3c977ff$var$OnlineIndicator;
    }
}
/**
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage).
 */ var $8c2558a5f3c977ff$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $d91vI.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $8c2558a5f3c977ff$var$getPresence(presence)) : children);
};
var $8c2558a5f3c977ff$export$2e2bcd8739ae039 = $8c2558a5f3c977ff$var$AvatarPresence;
var $8c2558a5f3c977ff$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === 'square' ? -4 : (0, $h79Bo.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            pointerEvents: 'none',
            position: 'absolute',
            bottom: "".concat(position, "px"),
            height: "".concat((0, $h79Bo.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            width: "".concat((0, $h79Bo.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($8c2558a5f3c977ff$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("d91vI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $991d499ad6f1f33f$export$2e2bcd8739ae039; });
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $3dJ4i = parcelRequire("3dJ4i");

var $f3FjI = parcelRequire("f3FjI");

var $h79Bo = parcelRequire("h79Bo");
var $991d499ad6f1f33f$var$iconWrapperStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: 'hidden'
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $991d499ad6f1f33f$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $f3FjI.N0), ")") : _ref$bgColor, children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $991d499ad6f1f33f$var$iconWrapperStyles,
        role: "presentation",
        style: {
            border: "".concat((0, $h79Bo.BORDER_WIDTH), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $991d499ad6f1f33f$export$2e2bcd8739ae039 = $991d499ad6f1f33f$var$IconWrapper;

});


parcelRegister("bxzu1", function(module, exports) {
$parcel$export(module.exports, "StatusWrapper", function () { return $866e4d0706205c34$export$8045894f255f9726; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $1oC0p = parcelRequire("1oC0p");

var $f3FjI = parcelRequire("f3FjI");

var $h79Bo = parcelRequire("h79Bo");

var $d91vI = parcelRequire("d91vI");
var $866e4d0706205c34$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $f3FjI.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $f3FjI.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $866e4d0706205c34$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $f3FjI.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $f3FjI.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $866e4d0706205c34$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $f3FjI.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $f3FjI.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $866e4d0706205c34$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $866e4d0706205c34$var$ApprovedIndicator;
        case 'declined':
            return $866e4d0706205c34$var$DeclinedIndicator;
        case 'locked':
            return $866e4d0706205c34$var$LockedIndicator;
    }
}
/**
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code).
 */ var $866e4d0706205c34$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $d91vI.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $866e4d0706205c34$var$getStatus(status)) : children);
};
var $866e4d0706205c34$export$2e2bcd8739ae039 = $866e4d0706205c34$var$AvatarStatus;
var $866e4d0706205c34$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === 'square' ? 0 : (0, $h79Bo.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            position: 'absolute',
            height: "".concat((0, $h79Bo.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            width: "".concat((0, $h79Bo.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($866e4d0706205c34$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});


parcelRegister("5KKfP", function(module, exports) {
$parcel$export(module.exports, "getInitials", function () { return $eab531519c87b866$export$de9bdbce6502b027; });
function $eab531519c87b866$export$de9bdbce6502b027(fullName) {
    return fullName.split(/[^\w]+/).reduce((result, part)=>{
        if (result.length < 3 && part.length > 0) return result + part[0]?.toUpperCase();
        else return result;
    }, '');
}

});


parcelRegister("2HpGy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6f8747a1ddf5c2c5$export$2e2bcd8739ae039; });
//@ts-nocheck

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $5YGzb = parcelRequire("5YGzb");
const $6f8747a1ddf5c2c5$var$DefaultHeader = ()=>{
    const intl = (0, $8e22h.default)();
    const logoLabel = intl.formatMessage({
        id: 'SiteSelectorModal.atlassianLogoLabel',
        defaultMessage: 'Atlassian logo'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
        size: "medium",
        label: logoLabel
    });
};
var $6f8747a1ddf5c2c5$export$2e2bcd8739ae039 = $6f8747a1ddf5c2c5$var$DefaultHeader;

});

parcelRegister("75T6S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $278ed3ae0dafea6f$export$2e2bcd8739ae039; });
//@ts-nocheck

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $lX14w = parcelRequire("lX14w");

var $lMnMS = parcelRequire("lMnMS");

var $5yxfX = parcelRequire("5yxfX");
const $278ed3ae0dafea6f$var$SiteSelectorForm = ({ sites: sites, onNewSiteSelected: onNewSiteSelected, onSiteSelected: onSiteSelected, onSwitchAccountClick: onSwitchAccountClick, onCancelClick: onCancelClick, onSiteChanged: onSiteChanged, fullScreenView: fullScreenView })=>{
    const handleFormSubmit = (data)=>{
        if (!data.site || data.site === '') onNewSiteSelected();
        else onSiteSelected(data.site);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: handleFormSubmit,
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                ...formProps,
                name: "site-selector",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5yxfX.default), {
                        sites: sites,
                        onSiteChanged: onSiteChanged
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lMnMS.default), {
                        canSubmit: !submitting,
                        onSwitchAccountClick: onSwitchAccountClick,
                        onCancelClick: onCancelClick,
                        fullScreenView: fullScreenView
                    })
                ]
            })
    });
};
var $278ed3ae0dafea6f$export$2e2bcd8739ae039 = $278ed3ae0dafea6f$var$SiteSelectorForm;

});
parcelRegister("lX14w", function(module, exports) {
$parcel$export(module.exports, "FormContext", function () { return $ffaff08d16b3e5f1$export$c24727297075ec6a; });
$parcel$export(module.exports, "IsDisabledContext", function () { return $ffaff08d16b3e5f1$export$c17cf6b332a82dbc; });
$parcel$export(module.exports, "default", function () { return $ffaff08d16b3e5f1$export$2e2bcd8739ae039; });

var $64c5S = parcelRequire("64c5S");

var $1oC0p = parcelRequire("1oC0p");

var $kQfSQ = parcelRequire("kQfSQ");

var $5WvoT = parcelRequire("5WvoT");

var $8WfyD = parcelRequire("8WfyD");
var $ffaff08d16b3e5f1$export$c24727297075ec6a = /*#__PURE__*/ (0, $1oC0p.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    }
});
var $ffaff08d16b3e5f1$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
function $ffaff08d16b3e5f1$export$2e2bcd8739ae039(props) {
    var formRef = (0, $1oC0p.useRef)(null);
    var onSubmitRef = (0, $1oC0p.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    var _useState = (0, $1oC0p.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $kQfSQ.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, $64c5S.default)(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var _initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === 'function' ? defaultValue(_initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($8WfyD)))(_initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($8WfyD)))(values, name, _value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $5WvoT.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        })(finalForm);
        return finalForm;
    }), _useState2 = (0, $64c5S.default)(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $1oC0p.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, $64c5S.default)(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $1oC0p.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $1oC0p.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $1oC0p.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $1oC0p.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue
        };
    }, [
        registerField,
        getCurrentValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($ffaff08d16b3e5f1$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($ffaff08d16b3e5f1$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: function getState() {
            return form.getState();
        },
        getValues: function getValues() {
            return form.getState().values;
        },
        // TODO: deprecate
        setFieldValue: form.change
    })));
}

});
parcelRegister("64c5S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $46ac7f5f9baf2b7d$export$2e2bcd8739ae039; });

var $4RY6L = parcelRequire("4RY6L");

var $7KaWJ = parcelRequire("7KaWJ");

var $248j0 = parcelRequire("248j0");

var $90YWj = parcelRequire("90YWj");
function $46ac7f5f9baf2b7d$export$2e2bcd8739ae039(r, e) {
    return (0, $4RY6L.default)(r) || (0, $7KaWJ.default)(r, e) || (0, $248j0.default)(r, e) || (0, $90YWj.default)();
}

});
parcelRegister("4RY6L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $38babcdb988c5284$export$2e2bcd8739ae039; });
function $38babcdb988c5284$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("7KaWJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5a3551f5cd970d15$export$2e2bcd8739ae039; });
function $5a3551f5cd970d15$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("248j0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $181265ccd88ae657$export$2e2bcd8739ae039; });

var $1RnBK = parcelRequire("1RnBK");
function $181265ccd88ae657$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1RnBK.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1RnBK.default)(r, a) : void 0;
    }
}

});
parcelRegister("1RnBK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $15ad0db55fe376e2$export$2e2bcd8739ae039; });
function $15ad0db55fe376e2$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("90YWj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $69036271f4286404$export$2e2bcd8739ae039; });
function $69036271f4286404$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kQfSQ", function(module, exports) {
$parcel$export(module.exports, "getIn", function () { return $f2c4fc210cfad135$export$c52e5867d5879e24; });
$parcel$export(module.exports, "createForm", function () { return $f2c4fc210cfad135$export$f681a8129d2e9d28; });

var $kakL3 = parcelRequire("kakL3");

var $3YCoD = parcelRequire("3YCoD");
//      
var $f2c4fc210cfad135$var$charCodeOfDot = ".".charCodeAt(0);
var $f2c4fc210cfad135$var$reEscapeChar = /\\(\\)?/g;
var $f2c4fc210cfad135$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f2c4fc210cfad135$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f2c4fc210cfad135$var$charCodeOfDot) result.push("");
    string.replace($f2c4fc210cfad135$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f2c4fc210cfad135$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f2c4fc210cfad135$var$keysCache = {};
var $f2c4fc210cfad135$var$keysRegex = /[.[\]]+/;
var $f2c4fc210cfad135$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f2c4fc210cfad135$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f2c4fc210cfad135$var$keysCache[key] = key.split($f2c4fc210cfad135$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f2c4fc210cfad135$var$keysCache[key] = $f2c4fc210cfad135$var$stringToPath(key);
    }
    return $f2c4fc210cfad135$var$keysCache[key];
};
//      
var $f2c4fc210cfad135$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f2c4fc210cfad135$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f2c4fc210cfad135$var$_toPropertyKey(arg) {
    var key = $f2c4fc210cfad135$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f2c4fc210cfad135$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f2c4fc210cfad135$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $3YCoD.default)(current, [
                key
            ].map($f2c4fc210cfad135$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kakL3.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f2c4fc210cfad135$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f2c4fc210cfad135$var$setInRecursor(state, 0, $f2c4fc210cfad135$var$toPath(key), value1, destroyArrays);
};
var $f2c4fc210cfad135$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f2c4fc210cfad135$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f2c4fc210cfad135$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f2c4fc210cfad135$export$c52e5867d5879e24(values, name);
    var error = $f2c4fc210cfad135$export$c52e5867d5879e24(errors, name);
    if (error && error[$f2c4fc210cfad135$export$735bebc8ffabf28a]) error = error[$f2c4fc210cfad135$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f2c4fc210cfad135$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f2c4fc210cfad135$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f2c4fc210cfad135$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f2c4fc210cfad135$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f2c4fc210cfad135$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f2c4fc210cfad135$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f2c4fc210cfad135$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f2c4fc210cfad135$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f2c4fc210cfad135$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f2c4fc210cfad135$var$subscriptionFilter(result, state, previousState, subscription, $f2c4fc210cfad135$export$41e855cb628c1b55, $f2c4fc210cfad135$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f2c4fc210cfad135$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f2c4fc210cfad135$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f2c4fc210cfad135$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f2c4fc210cfad135$var$subscriptionFilter(result, state, previousState, subscription, $f2c4fc210cfad135$export$f1ff97b9d1c7a3c3, $f2c4fc210cfad135$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f2c4fc210cfad135$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f2c4fc210cfad135$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f2c4fc210cfad135$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f2c4fc210cfad135$export$83d89fbfd8236492 = "4.20.10";
var $f2c4fc210cfad135$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f2c4fc210cfad135$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f2c4fc210cfad135$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f2c4fc210cfad135$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f2c4fc210cfad135$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f2c4fc210cfad135$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f2c4fc210cfad135$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f2c4fc210cfad135$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f2c4fc210cfad135$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f2c4fc210cfad135$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kakL3.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kakL3.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f2c4fc210cfad135$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f2c4fc210cfad135$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kakL3.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kakL3.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kakL3.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f2c4fc210cfad135$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f2c4fc210cfad135$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f2c4fc210cfad135$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f2c4fc210cfad135$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f2c4fc210cfad135$export$e6bdf135a54e021b,
                    shallowEqual: $f2c4fc210cfad135$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kakL3.default)({}, state.formState.values)); // clone to avoid writing
            if ($f2c4fc210cfad135$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f2c4fc210cfad135$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f2c4fc210cfad135$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f2c4fc210cfad135$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kakL3.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kakL3.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f2c4fc210cfad135$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f2c4fc210cfad135$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f2c4fc210cfad135$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f2c4fc210cfad135$export$735bebc8ffabf28a]) {
                    var existing = $f2c4fc210cfad135$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f2c4fc210cfad135$export$735bebc8ffabf28a] = error[$f2c4fc210cfad135$export$735bebc8ffabf28a];
                    merged = $f2c4fc210cfad135$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f2c4fc210cfad135$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f2c4fc210cfad135$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kakL3.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f2c4fc210cfad135$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f2c4fc210cfad135$var$notify(fieldSubscriber, fieldState, lastFieldState, $f2c4fc210cfad135$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f2c4fc210cfad135$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kakL3.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f2c4fc210cfad135$export$c52e5867d5879e24(formState.values, key), $f2c4fc210cfad135$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f2c4fc210cfad135$export$c52e5867d5879e24(formState.values, key), $f2c4fc210cfad135$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f2c4fc210cfad135$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f2c4fc210cfad135$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f2c4fc210cfad135$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f2c4fc210cfad135$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f2c4fc210cfad135$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f2c4fc210cfad135$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f2c4fc210cfad135$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f2c4fc210cfad135$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f2c4fc210cfad135$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f2c4fc210cfad135$var$notify(state.subscribers, nextFormState, lastFormState, $f2c4fc210cfad135$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kakL3.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f2c4fc210cfad135$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kakL3.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kakL3.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f2c4fc210cfad135$export$c52e5867d5879e24(formState.values, key), $f2c4fc210cfad135$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f2c4fc210cfad135$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f2c4fc210cfad135$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f2c4fc210cfad135$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f2c4fc210cfad135$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f2c4fc210cfad135$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f2c4fc210cfad135$export$c52e5867d5879e24(state.formState.values, name) === $f2c4fc210cfad135$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f2c4fc210cfad135$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f2c4fc210cfad135$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f2c4fc210cfad135$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f2c4fc210cfad135$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f2c4fc210cfad135$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f2c4fc210cfad135$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kakL3.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kakL3.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kakL3.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f2c4fc210cfad135$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f2c4fc210cfad135$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kakL3.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f2c4fc210cfad135$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f2c4fc210cfad135$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f2c4fc210cfad135$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f2c4fc210cfad135$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});
parcelRegister("kakL3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eae4d7e42f6635d7$export$2e2bcd8739ae039; });
function $eae4d7e42f6635d7$export$2e2bcd8739ae039() {
    return $eae4d7e42f6635d7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eae4d7e42f6635d7$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3YCoD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e54c26862ba66e5$export$2e2bcd8739ae039; });
function $2e54c26862ba66e5$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("5WvoT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $453ab9fe06b9eb1f$export$2e2bcd8739ae039; });

var $kQfSQ = parcelRequire("kQfSQ");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $453ab9fe06b9eb1f$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $453ab9fe06b9eb1f$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($453ab9fe06b9eb1f$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $453ab9fe06b9eb1f$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $kQfSQ.getIn)(errors, input.name);
    });
};
//      
var $453ab9fe06b9eb1f$var$noop = function noop() {};
var $453ab9fe06b9eb1f$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $453ab9fe06b9eb1f$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $453ab9fe06b9eb1f$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $453ab9fe06b9eb1f$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $453ab9fe06b9eb1f$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($453ab9fe06b9eb1f$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$453ab9fe06b9eb1f$export$2e2bcd8739ae039 = $453ab9fe06b9eb1f$var$createDecorator;

});

parcelRegister("8WfyD", function(module, exports) {

var $brerY = parcelRequire("brerY");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $681fceeafb0ef480$var$set(object, path, value) {
    return object == null ? object : $brerY(object, path, value);
}
module.exports = $681fceeafb0ef480$var$set;

});
parcelRegister("brerY", function(module, exports) {

var $c5uls = parcelRequire("c5uls");

var $hLLeA = parcelRequire("hLLeA");

var $f6osf = parcelRequire("f6osf");

var $ih96c = parcelRequire("ih96c");

var $119FI = parcelRequire("119FI");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $853d6cd5e61424eb$var$baseSet(object, path, value, customizer) {
    if (!$ih96c(object)) return object;
    path = $hLLeA(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $119FI(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $ih96c(objValue) ? objValue : $f6osf(path[index + 1]) ? [] : {};
        }
        $c5uls(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $853d6cd5e61424eb$var$baseSet;

});
parcelRegister("c5uls", function(module, exports) {

var $h6ZSp = parcelRequire("h6ZSp");

var $8tfJP = parcelRequire("8tfJP");
/** Used for built-in method references. */ var $8ccd7d974439e5bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8ccd7d974439e5bc$var$hasOwnProperty = $8ccd7d974439e5bc$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $8ccd7d974439e5bc$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($8ccd7d974439e5bc$var$hasOwnProperty.call(object, key) && $8tfJP(objValue, value)) || value === undefined && !(key in object)) $h6ZSp(object, key, value);
}
module.exports = $8ccd7d974439e5bc$var$assignValue;

});
parcelRegister("h6ZSp", function(module, exports) {

var $cmtMX = parcelRequire("cmtMX");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $c752fe9cf0e57306$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $cmtMX) $cmtMX(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $c752fe9cf0e57306$var$baseAssignValue;

});
parcelRegister("cmtMX", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");
var $8ffea588648ee2c8$var$defineProperty = function() {
    try {
        var func = $4jmfA(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $8ffea588648ee2c8$var$defineProperty;

});
parcelRegister("4jmfA", function(module, exports) {

var $kOEJm = parcelRequire("kOEJm");

var $jzMuy = parcelRequire("jzMuy");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $323a323e74dac9b0$var$getNative(object, key) {
    var value = $jzMuy(object, key);
    return $kOEJm(value) ? value : undefined;
}
module.exports = $323a323e74dac9b0$var$getNative;

});
parcelRegister("kOEJm", function(module, exports) {

var $i4iXI = parcelRequire("i4iXI");

var $hgKBD = parcelRequire("hgKBD");

var $ih96c = parcelRequire("ih96c");

var $j0oFE = parcelRequire("j0oFE");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $f2781269579fae61$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $f2781269579fae61$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $f2781269579fae61$var$funcProto = Function.prototype, $f2781269579fae61$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f2781269579fae61$var$funcToString = $f2781269579fae61$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f2781269579fae61$var$hasOwnProperty = $f2781269579fae61$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $f2781269579fae61$var$reIsNative = RegExp('^' + $f2781269579fae61$var$funcToString.call($f2781269579fae61$var$hasOwnProperty).replace($f2781269579fae61$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $f2781269579fae61$var$baseIsNative(value) {
    if (!$ih96c(value) || $hgKBD(value)) return false;
    var pattern = $i4iXI(value) ? $f2781269579fae61$var$reIsNative : $f2781269579fae61$var$reIsHostCtor;
    return pattern.test($j0oFE(value));
}
module.exports = $f2781269579fae61$var$baseIsNative;

});
parcelRegister("i4iXI", function(module, exports) {

var $2EKmr = parcelRequire("2EKmr");

var $ih96c = parcelRequire("ih96c");
/** `Object#toString` result references. */ var $d2774f32c2368ade$var$asyncTag = '[object AsyncFunction]', $d2774f32c2368ade$var$funcTag = '[object Function]', $d2774f32c2368ade$var$genTag = '[object GeneratorFunction]', $d2774f32c2368ade$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d2774f32c2368ade$var$isFunction(value) {
    if (!$ih96c(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $2EKmr(value);
    return tag == $d2774f32c2368ade$var$funcTag || tag == $d2774f32c2368ade$var$genTag || tag == $d2774f32c2368ade$var$asyncTag || tag == $d2774f32c2368ade$var$proxyTag;
}
module.exports = $d2774f32c2368ade$var$isFunction;

});
parcelRegister("2EKmr", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");

var $3Mlz9 = parcelRequire("3Mlz9");

var $8Kccf = parcelRequire("8Kccf");
/** `Object#toString` result references. */ var $1ef34784cc182df1$var$nullTag = '[object Null]', $1ef34784cc182df1$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $1ef34784cc182df1$var$symToStringTag = $3MHuE ? $3MHuE.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $1ef34784cc182df1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $1ef34784cc182df1$var$undefinedTag : $1ef34784cc182df1$var$nullTag;
    return $1ef34784cc182df1$var$symToStringTag && $1ef34784cc182df1$var$symToStringTag in Object(value) ? $3Mlz9(value) : $8Kccf(value);
}
module.exports = $1ef34784cc182df1$var$baseGetTag;

});
parcelRegister("3MHuE", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/** Built-in value references. */ var $2c1797a89baf34ff$var$Symbol = $bBiRC.Symbol;
module.exports = $2c1797a89baf34ff$var$Symbol;

});
parcelRegister("bBiRC", function(module, exports) {

var $aFUsE = parcelRequire("aFUsE");
/** Detect free variable `self`. */ var $8721c85917da650f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8721c85917da650f$var$root = $aFUsE || $8721c85917da650f$var$freeSelf || Function('return this')();
module.exports = $8721c85917da650f$var$root;

});
parcelRegister("aFUsE", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $7c5987b8ae931615$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $7c5987b8ae931615$var$freeGlobal;

});



parcelRegister("3Mlz9", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");
/** Used for built-in method references. */ var $2c0695565bbe49d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2c0695565bbe49d9$var$hasOwnProperty = $2c0695565bbe49d9$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2c0695565bbe49d9$var$nativeObjectToString = $2c0695565bbe49d9$var$objectProto.toString;
/** Built-in value references. */ var $2c0695565bbe49d9$var$symToStringTag = $3MHuE ? $3MHuE.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $2c0695565bbe49d9$var$getRawTag(value) {
    var isOwn = $2c0695565bbe49d9$var$hasOwnProperty.call(value, $2c0695565bbe49d9$var$symToStringTag), tag = value[$2c0695565bbe49d9$var$symToStringTag];
    try {
        value[$2c0695565bbe49d9$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $2c0695565bbe49d9$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$2c0695565bbe49d9$var$symToStringTag] = tag;
        else delete value[$2c0695565bbe49d9$var$symToStringTag];
    }
    return result;
}
module.exports = $2c0695565bbe49d9$var$getRawTag;

});

parcelRegister("8Kccf", function(module, exports) {
/** Used for built-in method references. */ var $65dc149b369a7ff2$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $65dc149b369a7ff2$var$nativeObjectToString = $65dc149b369a7ff2$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $65dc149b369a7ff2$var$objectToString(value) {
    return $65dc149b369a7ff2$var$nativeObjectToString.call(value);
}
module.exports = $65dc149b369a7ff2$var$objectToString;

});


parcelRegister("ih96c", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d4e0df6a90fdceef$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $d4e0df6a90fdceef$var$isObject;

});


parcelRegister("hgKBD", function(module, exports) {

var $5YfQ3 = parcelRequire("5YfQ3");
/** Used to detect methods masquerading as native. */ var $c92815411e2dcca7$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($5YfQ3 && $5YfQ3.keys && $5YfQ3.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c92815411e2dcca7$var$isMasked(func) {
    return !!$c92815411e2dcca7$var$maskSrcKey && $c92815411e2dcca7$var$maskSrcKey in func;
}
module.exports = $c92815411e2dcca7$var$isMasked;

});
parcelRegister("5YfQ3", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/** Used to detect overreaching core-js shims. */ var $458ed79228ca90e8$var$coreJsData = $bBiRC["__core-js_shared__"];
module.exports = $458ed79228ca90e8$var$coreJsData;

});


parcelRegister("j0oFE", function(module, exports) {
/** Used for built-in method references. */ var $dd6127861b2bc579$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $dd6127861b2bc579$var$funcToString = $dd6127861b2bc579$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $dd6127861b2bc579$var$toSource(func) {
    if (func != null) {
        try {
            return $dd6127861b2bc579$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $dd6127861b2bc579$var$toSource;

});


parcelRegister("jzMuy", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e406e6aaa58ba9d2$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $e406e6aaa58ba9d2$var$getValue;

});




parcelRegister("8tfJP", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $62ad3d6c594379e1$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $62ad3d6c594379e1$var$eq;

});


parcelRegister("hLLeA", function(module, exports) {

var $lPKNl = parcelRequire("lPKNl");

var $lIDFS = parcelRequire("lIDFS");

var $jQEwi = parcelRequire("jQEwi");

var $24uwp = parcelRequire("24uwp");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $0356a2f476d40338$var$castPath(value, object) {
    if ($lPKNl(value)) return value;
    return $lIDFS(value, object) ? [
        value
    ] : $jQEwi($24uwp(value));
}
module.exports = $0356a2f476d40338$var$castPath;

});
parcelRegister("lPKNl", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $fe52a8e5d8de2c87$var$isArray = Array.isArray;
module.exports = $fe52a8e5d8de2c87$var$isArray;

});

parcelRegister("lIDFS", function(module, exports) {

var $lPKNl = parcelRequire("lPKNl");

var $7K8RW = parcelRequire("7K8RW");
/** Used to match property names within property paths. */ var $fcfc7b9391aba5d4$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $fcfc7b9391aba5d4$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $fcfc7b9391aba5d4$var$isKey(value, object) {
    if ($lPKNl(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $7K8RW(value)) return true;
    return $fcfc7b9391aba5d4$var$reIsPlainProp.test(value) || !$fcfc7b9391aba5d4$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $fcfc7b9391aba5d4$var$isKey;

});
parcelRegister("7K8RW", function(module, exports) {

var $2EKmr = parcelRequire("2EKmr");

var $lhaWD = parcelRequire("lhaWD");
/** `Object#toString` result references. */ var $5a33b57e05cfde45$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5a33b57e05cfde45$var$isSymbol(value) {
    return typeof value == 'symbol' || $lhaWD(value) && $2EKmr(value) == $5a33b57e05cfde45$var$symbolTag;
}
module.exports = $5a33b57e05cfde45$var$isSymbol;

});
parcelRegister("lhaWD", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f7d3ace4fbc0cb6c$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $f7d3ace4fbc0cb6c$var$isObjectLike;

});



parcelRegister("jQEwi", function(module, exports) {

var $def7r = parcelRequire("def7r");
/** Used to match property names within property paths. */ var $e7324e0bbc1e54f1$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $e7324e0bbc1e54f1$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $e7324e0bbc1e54f1$var$stringToPath = $def7r(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($e7324e0bbc1e54f1$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($e7324e0bbc1e54f1$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $e7324e0bbc1e54f1$var$stringToPath;

});
parcelRegister("def7r", function(module, exports) {

var $8kjMP = parcelRequire("8kjMP");
/** Used as the maximum memoize cache size. */ var $9a184f8261aba1fc$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $9a184f8261aba1fc$var$memoizeCapped(func) {
    var result = $8kjMP(func, function(key) {
        if (cache.size === $9a184f8261aba1fc$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $9a184f8261aba1fc$var$memoizeCapped;

});
parcelRegister("8kjMP", function(module, exports) {

var $jCpAW = parcelRequire("jCpAW");
/** Error message constants. */ var $60ff8a3260337b86$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $60ff8a3260337b86$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($60ff8a3260337b86$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($60ff8a3260337b86$var$memoize.Cache || $jCpAW);
    return memoized;
}
// Expose `MapCache`.
$60ff8a3260337b86$var$memoize.Cache = $jCpAW;
module.exports = $60ff8a3260337b86$var$memoize;

});
parcelRegister("jCpAW", function(module, exports) {

var $h78Wc = parcelRequire("h78Wc");

var $xRrGF = parcelRequire("xRrGF");

var $fyYI4 = parcelRequire("fyYI4");

var $1PAvH = parcelRequire("1PAvH");

var $dcQs7 = parcelRequire("dcQs7");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e4856b84ebf4b36e$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$e4856b84ebf4b36e$var$MapCache.prototype.clear = $h78Wc;
$e4856b84ebf4b36e$var$MapCache.prototype['delete'] = $xRrGF;
$e4856b84ebf4b36e$var$MapCache.prototype.get = $fyYI4;
$e4856b84ebf4b36e$var$MapCache.prototype.has = $1PAvH;
$e4856b84ebf4b36e$var$MapCache.prototype.set = $dcQs7;
module.exports = $e4856b84ebf4b36e$var$MapCache;

});
parcelRegister("h78Wc", function(module, exports) {

var $7fj6B = parcelRequire("7fj6B");

var $eDehO = parcelRequire("eDehO");

var $8IbLS = parcelRequire("8IbLS");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $c75a05f88aec7cef$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $7fj6B,
        'map': new ($8IbLS || $eDehO),
        'string': new $7fj6B
    };
}
module.exports = $c75a05f88aec7cef$var$mapCacheClear;

});
parcelRegister("7fj6B", function(module, exports) {

var $40myf = parcelRequire("40myf");

var $hhPbu = parcelRequire("hhPbu");

var $9eZt0 = parcelRequire("9eZt0");

var $11GMU = parcelRequire("11GMU");

var $gxsOR = parcelRequire("gxsOR");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5468c10bcce1fa8f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$5468c10bcce1fa8f$var$Hash.prototype.clear = $40myf;
$5468c10bcce1fa8f$var$Hash.prototype['delete'] = $hhPbu;
$5468c10bcce1fa8f$var$Hash.prototype.get = $9eZt0;
$5468c10bcce1fa8f$var$Hash.prototype.has = $11GMU;
$5468c10bcce1fa8f$var$Hash.prototype.set = $gxsOR;
module.exports = $5468c10bcce1fa8f$var$Hash;

});
parcelRegister("40myf", function(module, exports) {

var $b5ZAC = parcelRequire("b5ZAC");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $2ea8a7baada3633c$var$hashClear() {
    this.__data__ = $b5ZAC ? $b5ZAC(null) : {};
    this.size = 0;
}
module.exports = $2ea8a7baada3633c$var$hashClear;

});
parcelRegister("b5ZAC", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");
/* Built-in method references that are verified to be native. */ var $813fefbba8bb3c6f$var$nativeCreate = $4jmfA(Object, 'create');
module.exports = $813fefbba8bb3c6f$var$nativeCreate;

});


parcelRegister("hhPbu", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c95bba5d61b6038b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $c95bba5d61b6038b$var$hashDelete;

});

parcelRegister("9eZt0", function(module, exports) {

var $b5ZAC = parcelRequire("b5ZAC");
/** Used to stand-in for `undefined` hash values. */ var $6ba519e23e626c3c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $6ba519e23e626c3c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6ba519e23e626c3c$var$hasOwnProperty = $6ba519e23e626c3c$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6ba519e23e626c3c$var$hashGet(key) {
    var data = this.__data__;
    if ($b5ZAC) {
        var result = data[key];
        return result === $6ba519e23e626c3c$var$HASH_UNDEFINED ? undefined : result;
    }
    return $6ba519e23e626c3c$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $6ba519e23e626c3c$var$hashGet;

});

parcelRegister("11GMU", function(module, exports) {

var $b5ZAC = parcelRequire("b5ZAC");
/** Used for built-in method references. */ var $0bf7133aceea7ddb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0bf7133aceea7ddb$var$hasOwnProperty = $0bf7133aceea7ddb$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0bf7133aceea7ddb$var$hashHas(key) {
    var data = this.__data__;
    return $b5ZAC ? data[key] !== undefined : $0bf7133aceea7ddb$var$hasOwnProperty.call(data, key);
}
module.exports = $0bf7133aceea7ddb$var$hashHas;

});

parcelRegister("gxsOR", function(module, exports) {

var $b5ZAC = parcelRequire("b5ZAC");
/** Used to stand-in for `undefined` hash values. */ var $c0a61554fb23c1e0$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c0a61554fb23c1e0$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $b5ZAC && value === undefined ? $c0a61554fb23c1e0$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $c0a61554fb23c1e0$var$hashSet;

});


parcelRegister("eDehO", function(module, exports) {

var $3w8VL = parcelRequire("3w8VL");

var $2kH0k = parcelRequire("2kH0k");

var $hxtOr = parcelRequire("hxtOr");

var $23MPl = parcelRequire("23MPl");

var $lYgtK = parcelRequire("lYgtK");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $aa6fca30bf81b050$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$aa6fca30bf81b050$var$ListCache.prototype.clear = $3w8VL;
$aa6fca30bf81b050$var$ListCache.prototype['delete'] = $2kH0k;
$aa6fca30bf81b050$var$ListCache.prototype.get = $hxtOr;
$aa6fca30bf81b050$var$ListCache.prototype.has = $23MPl;
$aa6fca30bf81b050$var$ListCache.prototype.set = $lYgtK;
module.exports = $aa6fca30bf81b050$var$ListCache;

});
parcelRegister("3w8VL", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $28fb49af6ab35412$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $28fb49af6ab35412$var$listCacheClear;

});

parcelRegister("2kH0k", function(module, exports) {

var $c3jPB = parcelRequire("c3jPB");
/** Used for built-in method references. */ var $1b2ecec95fcce67f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $1b2ecec95fcce67f$var$splice = $1b2ecec95fcce67f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1b2ecec95fcce67f$var$listCacheDelete(key) {
    var data = this.__data__, index = $c3jPB(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $1b2ecec95fcce67f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $1b2ecec95fcce67f$var$listCacheDelete;

});
parcelRegister("c3jPB", function(module, exports) {

var $8tfJP = parcelRequire("8tfJP");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8c6525f3a03f9e40$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($8tfJP(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $8c6525f3a03f9e40$var$assocIndexOf;

});


parcelRegister("hxtOr", function(module, exports) {

var $c3jPB = parcelRequire("c3jPB");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cc4ca4e5d757be14$var$listCacheGet(key) {
    var data = this.__data__, index = $c3jPB(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $cc4ca4e5d757be14$var$listCacheGet;

});

parcelRegister("23MPl", function(module, exports) {

var $c3jPB = parcelRequire("c3jPB");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1801bca4a34c449b$var$listCacheHas(key) {
    return $c3jPB(this.__data__, key) > -1;
}
module.exports = $1801bca4a34c449b$var$listCacheHas;

});

parcelRegister("lYgtK", function(module, exports) {

var $c3jPB = parcelRequire("c3jPB");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ffebfbeeec8e2c77$var$listCacheSet(key, value) {
    var data = this.__data__, index = $c3jPB(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ffebfbeeec8e2c77$var$listCacheSet;

});


parcelRegister("8IbLS", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $657b90540a3ba201$var$Map = $4jmfA($bBiRC, 'Map');
module.exports = $657b90540a3ba201$var$Map;

});


parcelRegister("xRrGF", function(module, exports) {

var $hD9zu = parcelRequire("hD9zu");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $065c8a5bb5f77697$var$mapCacheDelete(key) {
    var result = $hD9zu(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $065c8a5bb5f77697$var$mapCacheDelete;

});
parcelRegister("hD9zu", function(module, exports) {

var $f63Og = parcelRequire("f63Og");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $cd5d80deeaddb035$var$getMapData(map, key) {
    var data = map.__data__;
    return $f63Og(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $cd5d80deeaddb035$var$getMapData;

});
parcelRegister("f63Og", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $afda5f0ec4d42bec$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $afda5f0ec4d42bec$var$isKeyable;

});



parcelRegister("fyYI4", function(module, exports) {

var $hD9zu = parcelRequire("hD9zu");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b5491fb86db3eaa5$var$mapCacheGet(key) {
    return $hD9zu(this, key).get(key);
}
module.exports = $b5491fb86db3eaa5$var$mapCacheGet;

});

parcelRegister("1PAvH", function(module, exports) {

var $hD9zu = parcelRequire("hD9zu");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1556e01169f16fb5$var$mapCacheHas(key) {
    return $hD9zu(this, key).has(key);
}
module.exports = $1556e01169f16fb5$var$mapCacheHas;

});

parcelRegister("dcQs7", function(module, exports) {

var $hD9zu = parcelRequire("hD9zu");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $99d5155581ce7947$var$mapCacheSet(key, value) {
    var data = $hD9zu(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $99d5155581ce7947$var$mapCacheSet;

});





parcelRegister("24uwp", function(module, exports) {

var $eTlDy = parcelRequire("eTlDy");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $1823a17883502630$var$toString(value) {
    return value == null ? '' : $eTlDy(value);
}
module.exports = $1823a17883502630$var$toString;

});
parcelRegister("eTlDy", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");

var $3drJx = parcelRequire("3drJx");

var $lPKNl = parcelRequire("lPKNl");

var $7K8RW = parcelRequire("7K8RW");
/** Used as references for various `Number` constants. */ var $ad76fc6628bfc986$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $ad76fc6628bfc986$var$symbolProto = $3MHuE ? $3MHuE.prototype : undefined, $ad76fc6628bfc986$var$symbolToString = $ad76fc6628bfc986$var$symbolProto ? $ad76fc6628bfc986$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $ad76fc6628bfc986$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($lPKNl(value)) // Recursively convert values (susceptible to call stack limits).
    return $3drJx(value, $ad76fc6628bfc986$var$baseToString) + '';
    if ($7K8RW(value)) return $ad76fc6628bfc986$var$symbolToString ? $ad76fc6628bfc986$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$ad76fc6628bfc986$var$INFINITY ? '-0' : result;
}
module.exports = $ad76fc6628bfc986$var$baseToString;

});
parcelRegister("3drJx", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2578194ac196d7cb$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $2578194ac196d7cb$var$arrayMap;

});




parcelRegister("f6osf", function(module, exports) {
/** Used as references for various `Number` constants. */ var $afea62be5bb361f5$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $afea62be5bb361f5$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $afea62be5bb361f5$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $afea62be5bb361f5$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $afea62be5bb361f5$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $afea62be5bb361f5$var$isIndex;

});

parcelRegister("119FI", function(module, exports) {

var $7K8RW = parcelRequire("7K8RW");
/** Used as references for various `Number` constants. */ var $0bdd630ad253035c$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0bdd630ad253035c$var$toKey(value) {
    if (typeof value == 'string' || $7K8RW(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$0bdd630ad253035c$var$INFINITY ? '-0' : result;
}
module.exports = $0bdd630ad253035c$var$toKey;

});




parcelRegister("lMnMS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23aec631f00221d7$export$2e2bcd8739ae039; });
/* site-selector-form-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ //@ts-nocheck
// eslint-disable-next-line unused-imports/no-unused-imports

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $ddxTX = parcelRequire("ddxTX");

var $gacwQ = parcelRequire("gacwQ");

var $1Zr4f = parcelRequire("1Zr4f");
const $23aec631f00221d7$var$SiteSelectorFormFooter = ({ canSubmit: canSubmit, onSwitchAccountClick: onSwitchAccountClick, onCancelClick: onCancelClick, fullScreenView: fullScreenView })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gacwQ.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1pfhftgi _kqswh2mm _1bsb1osq _1e0c1txw _1n261g80 _e8gh1yb4 _q8t51h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1o9zidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                        appearance: "link",
                        type: "button",
                        spacing: "none",
                        onClick: ()=>onSwitchAccountClick(),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "SiteSelectorModal.switchAccount",
                            defaultMessage: "Sign in with a different account"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh7vkz _kiyaidpf _p7vbidpf _1t19kb7n _uj6kusic"
                    ]),
                    children: fullScreenView !== true ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_12l21y44 _1e0c1txw _1bahesu3"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                appearance: "subtle",
                                type: "button",
                                onClick: ()=>onCancelClick(),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "SiteSelectorModal.cancel",
                                    defaultMessage: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_ahbq1y44"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isDisabled: !canSubmit,
                                    iconAfter: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr4f))), {
                                        label: ""
                                    }),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "SiteSelectorModal.createPage",
                                        defaultMessage: "Create page"
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                        appearance: "primary",
                        type: "submit",
                        isDisabled: !canSubmit,
                        className: (0, $2jatx.default)([
                            "_12l21y44 _1e0c1txw _1bahesu3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "SiteSelectorModal.createPage",
                            defaultMessage: "Create page"
                        })
                    })
                })
            ]
        })
    });
};
const $23aec631f00221d7$var$actionContainerStyle = null;
const $23aec631f00221d7$var$leftActionsContainerStyle = null;
const $23aec631f00221d7$var$rightActionsContainerStyle = null;
const $23aec631f00221d7$var$inlineEndStyle = null;
const $23aec631f00221d7$var$primaryContainerStyle = null;
var $23aec631f00221d7$export$2e2bcd8739ae039 = $23aec631f00221d7$var$SiteSelectorFormFooter;

});
parcelRegister("iVyKn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dc7880e2ac12aa4c$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $4Hf5k = parcelRequire("4Hf5k");
function $dc7880e2ac12aa4c$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $d3IQL.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $d3IQL.__rest)(nextProps, [
        "values"
    ]);
    return (0, $4Hf5k.shallowEqual)(nextValues, values) && (0, $4Hf5k.shallowEqual)(otherProps, nextOtherProps);
}
function $dc7880e2ac12aa4c$var$FormattedMessage(props) {
    var intl = (0, $8e22h.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $1oC0p.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $1oC0p.createElement(Component, null, $1oC0p.Children.toArray(nodes));
    return $1oC0p.createElement($1oC0p.Fragment, null, nodes);
}
$dc7880e2ac12aa4c$var$FormattedMessage.displayName = 'FormattedMessage';
var $dc7880e2ac12aa4c$var$MemoizedFormattedMessage = $1oC0p.memo($dc7880e2ac12aa4c$var$FormattedMessage, $dc7880e2ac12aa4c$var$areEqual);
$dc7880e2ac12aa4c$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $dc7880e2ac12aa4c$export$2e2bcd8739ae039 = $dc7880e2ac12aa4c$var$MemoizedFormattedMessage;

});

parcelRegister("ddxTX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $99f6c96a28774b49$export$2e2bcd8739ae039; });

var $5ZfVn = parcelRequire("5ZfVn");

var $jdo1L = parcelRequire("jdo1L");

var $l8ft8 = parcelRequire("l8ft8");

var $1oC0p = parcelRequire("1oC0p");

var $5hlU3 = parcelRequire("5hlU3");

var $lPClK = parcelRequire("lPClK");

var $i60vt = parcelRequire("i60vt");

var $dolHT = parcelRequire("dolHT");

var $coysQ = parcelRequire("coysQ");
var $99f6c96a28774b49$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $99f6c96a28774b49$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $99f6c96a28774b49$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $5hlU3.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $5hlU3.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, $l8ft8.default)(_ref, $99f6c96a28774b49$var$_excluded);
    var _useGlobalTheme = (0, $lPClK.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $coysQ.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $jdo1L.default)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($99f6c96a28774b49$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $1oC0p.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($99f6c96a28774b49$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $1oC0p.useMemo)(function() {
        return (0, $dolHT.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i60vt.default), (0, $5ZfVn.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$99f6c96a28774b49$var$Button.displayName = 'Button';
var $99f6c96a28774b49$export$2e2bcd8739ae039 = $99f6c96a28774b49$var$Button;

});
parcelRegister("5ZfVn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $45bf00877bbc6e17$export$2e2bcd8739ae039; });
function $45bf00877bbc6e17$export$2e2bcd8739ae039() {
    return $45bf00877bbc6e17$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $45bf00877bbc6e17$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jdo1L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dfd1de94a892a397$export$2e2bcd8739ae039; });

var $cYwok = parcelRequire("cYwok");

var $b9xUp = parcelRequire("b9xUp");

var $cxurB = parcelRequire("cxurB");

var $3iNsx = parcelRequire("3iNsx");
function $dfd1de94a892a397$export$2e2bcd8739ae039(r, e) {
    return (0, $cYwok.default)(r) || (0, $b9xUp.default)(r, e) || (0, $cxurB.default)(r, e) || (0, $3iNsx.default)();
}

});
parcelRegister("cYwok", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $972436e1cbbb1fe9$export$2e2bcd8739ae039; });
function $972436e1cbbb1fe9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("b9xUp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $81ead6943b4bc8a4$export$2e2bcd8739ae039; });
function $81ead6943b4bc8a4$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("cxurB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92102eb1ceb4362e$export$2e2bcd8739ae039; });

var $cyDFM = parcelRequire("cyDFM");
function $92102eb1ceb4362e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cyDFM.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cyDFM.default)(r, a) : void 0;
    }
}

});
parcelRegister("cyDFM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92476f3d7bacbeea$export$2e2bcd8739ae039; });
function $92476f3d7bacbeea$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("3iNsx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26796b23969c0d67$export$2e2bcd8739ae039; });
function $26796b23969c0d67$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("l8ft8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6265822e7932198$export$2e2bcd8739ae039; });

var $iGNRh = parcelRequire("iGNRh");
function $f6265822e7932198$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $iGNRh.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("iGNRh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9b2d30edc37ccb8$export$2e2bcd8739ae039; });
function $d9b2d30edc37ccb8$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("5hlU3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d7f87c5201f04b7$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $3d7f87c5201f04b7$export$2e2bcd8739ae039() {}

});

parcelRegister("lPClK", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $fe4c1bde650fff9a$export$7692396083754928; });

var $eSp5W = parcelRequire("eSp5W");
// Create default global light theme
var $fe4c1bde650fff9a$var$_createTheme = (0, $eSp5W.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $fe4c1bde650fff9a$var$Provider = $fe4c1bde650fff9a$var$_createTheme.Provider, $fe4c1bde650fff9a$var$Consumer = $fe4c1bde650fff9a$var$_createTheme.Consumer, $fe4c1bde650fff9a$export$7692396083754928 = $fe4c1bde650fff9a$var$_createTheme.useTheme;
var $fe4c1bde650fff9a$export$2e2bcd8739ae039 = {
    Provider: $fe4c1bde650fff9a$var$Provider,
    Consumer: $fe4c1bde650fff9a$var$Consumer
};

});
parcelRegister("eSp5W", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $ad49931fd3fc4a35$export$25d302a5b900a763; });

var $l8ft8 = parcelRequire("l8ft8");

var $1oC0p = parcelRequire("1oC0p");
var $ad49931fd3fc4a35$var$_excluded = [
    "children"
];
function $ad49931fd3fc4a35$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $l8ft8.default)(props, $ad49931fd3fc4a35$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("i60vt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d2c92e1fe7c5abe3$export$2e2bcd8739ae039; });

var $5ZfVn = parcelRequire("5ZfVn");

var $l8ft8 = parcelRequire("l8ft8");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $5hlU3 = parcelRequire("5hlU3");

var $10uZw = parcelRequire("10uZw");

var $iENwh = parcelRequire("iENwh");

var $lp8ng = parcelRequire("lp8ng");

var $4o3jP = parcelRequire("4o3jP");

var $jHfPv = parcelRequire("jHfPv");

var $7dZ9n = parcelRequire("7dZ9n");

var $dolHT = parcelRequire("dolHT");

var $gUgJu = parcelRequire("gUgJu");
var $d2c92e1fe7c5abe3$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $d2c92e1fe7c5abe3$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
var $d2c92e1fe7c5abe3$var$iconBeforeSpacingFixStyle = (0, $3dJ4i.css)({
    marginLeft: "var(--ds-space-negative-025, -2px)"
});
var $d2c92e1fe7c5abe3$var$iconAfterSpacingFixStyle = (0, $3dJ4i.css)({
    marginRight: "var(--ds-space-negative-025, -2px)"
});
var $d2c92e1fe7c5abe3$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!(0, $4o3jP.getBooleanFF)('platform.design-system-team.icon-button-spacing-fix_o1zc5') || !children || (0, $gUgJu.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $d2c92e1fe7c5abe3$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $gUgJu.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $3dJ4i.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $d2c92e1fe7c5abe3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $5hlU3.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $5hlU3.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $l8ft8.default)(props, $d2c92e1fe7c5abe3$var$_excluded);
    var ourRef = (0, $1oC0p.useRef)();
    var setRef = (0, $1oC0p.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $10uZw.default)(ourRef, autoFocus);
    var interactionContext = (0, $1oC0p.useContext)((0, $lp8ng.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $gJJny.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "16.10.2",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1oC0p.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $3dJ4i.css)((0, $dolHT.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $jHfPv.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $jHfPv.N500), ")"), " !important")
        }
    };
    return (0, $3dJ4i.jsx)((0, $iENwh.default), null, (0, $3dJ4i.jsx)(Component, (0, $5ZfVn.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d2c92e1fe7c5abe3$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $7dZ9n.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            (0, $dolHT.getIconStyle)({
                spacing: spacing
            }),
            $d2c92e1fe7c5abe3$var$getSpacingFix(children, $d2c92e1fe7c5abe3$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, !(0, $4o3jP.getBooleanFF)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && children ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            (0, $dolHT.getContentStyle)({
                spacing: spacing
            })
        ]
    }, children) : null, (0, $4o3jP.getBooleanFF)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && $d2c92e1fe7c5abe3$var$getChildren(children, [
        fadeStyles,
        (0, $dolHT.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            (0, $dolHT.getIconStyle)({
                spacing: spacing
            }),
            $d2c92e1fe7c5abe3$var$getSpacingFix(children, $d2c92e1fe7c5abe3$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3dJ4i.jsx)("span", {
        css: [
            (0, $dolHT.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("gJJny", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $c2f40ca446c3c2d2$export$a4687b0234b40e28; });

var $9c1Qf = parcelRequire("9c1Qf");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $j10Ql = parcelRequire("j10Ql");
function $c2f40ca446c3c2d2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c2f40ca446c3c2d2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c2f40ca446c3c2d2$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $9c1Qf.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c2f40ca446c3c2d2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c2f40ca446c3c2d2$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $eY3N6.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $j10Ql.useTrackedRef)(analyticsData);
    var fnRef = (0, $j10Ql.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c2f40ca446c3c2d2$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("10uZw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0bbdd4c4e8e29cf3$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $0bbdd4c4e8e29cf3$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("iENwh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9525ffd30b8f662$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $d9525ffd30b8f662$var$BORDER_WIDTH = 2;
var $d9525ffd30b8f662$var$baseFocusOutsideStyles = (0, $3dJ4i.css)({
    outline: "".concat($d9525ffd30b8f662$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $d9525ffd30b8f662$var$BORDER_WIDTH
});
var $d9525ffd30b8f662$var$baseInsetStyles = (0, $3dJ4i.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    outlineOffset: -$d9525ffd30b8f662$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $d9525ffd30b8f662$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus-visible': $d9525ffd30b8f662$var$baseFocusOutsideStyles,
    '@supports not selector(*:focus-visible)': {
        '&:focus': $d9525ffd30b8f662$var$baseFocusOutsideStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $d9525ffd30b8f662$var$insetFocusRingStyles = (0, $3dJ4i.css)({
    '&:focus-visible': $d9525ffd30b8f662$var$baseInsetStyles,
    '@supports not selector(*:focus-visible)': {
        '&:focus': $d9525ffd30b8f662$var$baseInsetStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * There are known accessibility issues with this component.
 * Do not use without assistance from the Design System accessibility team.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $d9525ffd30b8f662$var$FocusRing = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $d9525ffd30b8f662$var$baseInsetStyles : $d9525ffd30b8f662$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $d9525ffd30b8f662$var$insetFocusRingStyles : $d9525ffd30b8f662$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $1oC0p.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1oC0p.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$d9525ffd30b8f662$var$FocusRing.displayName = 'FocusRing';
var $d9525ffd30b8f662$export$2e2bcd8739ae039 = $d9525ffd30b8f662$var$FocusRing;

});

parcelRegister("lp8ng", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9526dbb0df3ccd0$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $f9526dbb0df3ccd0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("4o3jP", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $331bfa60b786b116$export$470e5c2be1411c89; });

var $awRpn = parcelRequire("awRpn");
function $331bfa60b786b116$export$ba05d765b8392e5e(flagResolver) {
    (0, $awRpn.setBooleanResolver)(flagResolver);
}
function $331bfa60b786b116$export$470e5c2be1411c89(name) {
    return (0, $awRpn.resolveBooleanFlag)(name);
}

});
parcelRegister("awRpn", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $7aa6524b492d08d0$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $7aa6524b492d08d0$export$6333b6aff9fc6275; });

var $itDcs = parcelRequire("itDcs");

var $7t0tI = parcelRequire("7t0tI");
var $7aa6524b492d08d0$var$pkgName = '@atlaskit/platform-feature-flags';
var $7aa6524b492d08d0$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $7aa6524b492d08d0$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $7aa6524b492d08d0$var$ENV_ENABLE_PLATFORM_FF = $7aa6524b492d08d0$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $7aa6524b492d08d0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $7aa6524b492d08d0$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $7aa6524b492d08d0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $7aa6524b492d08d0$var$ENV_ENABLE_PLATFORM_FF || $7aa6524b492d08d0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $7aa6524b492d08d0$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $7aa6524b492d08d0$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$7aa6524b492d08d0$var$globalVar[$7aa6524b492d08d0$export$7e41b1b2bdee3f98] = $7aa6524b492d08d0$var$globalVar[$7aa6524b492d08d0$export$7e41b1b2bdee3f98] || $7aa6524b492d08d0$var$DEFAULT_PFF_GLOBAL;
function $7aa6524b492d08d0$export$f2b591175b3e424c(resolver) {
    $7aa6524b492d08d0$var$globalVar[$7aa6524b492d08d0$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $7aa6524b492d08d0$export$6333b6aff9fc6275(flagKey) {
    if ($7aa6524b492d08d0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $itDcs.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $7aa6524b492d08d0$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $7aa6524b492d08d0$var$globalVar[$7aa6524b492d08d0$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("itDcs", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $d73957ba84189590$export$1c9f709888824e05; });
var $d73957ba84189590$var$_ref, $d73957ba84189590$var$_globalThis$process, $d73957ba84189590$var$_globalThis$process$e, $d73957ba84189590$var$_globalThis$process2, $d73957ba84189590$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d73957ba84189590$var$TESTS_MODE = ($d73957ba84189590$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($d73957ba84189590$var$_globalThis$process = globalThis.process) === null || $d73957ba84189590$var$_globalThis$process === void 0 ? void 0 : ($d73957ba84189590$var$_globalThis$process$e = $d73957ba84189590$var$_globalThis$process.env) === null || $d73957ba84189590$var$_globalThis$process$e === void 0 ? void 0 : $d73957ba84189590$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $d73957ba84189590$var$_ref !== void 0) ? $d73957ba84189590$var$_ref : false;
var $d73957ba84189590$var$DEBUG_MODE = !$d73957ba84189590$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($d73957ba84189590$var$_globalThis$process2 = globalThis.process) === null || $d73957ba84189590$var$_globalThis$process2 === void 0 ? void 0 : ($d73957ba84189590$var$_globalThis$process2$ = $d73957ba84189590$var$_globalThis$process2.env) === null || $d73957ba84189590$var$_globalThis$process2$ === void 0 ? void 0 : $d73957ba84189590$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $d73957ba84189590$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d73957ba84189590$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("jHfPv", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $e56e4fee659d45d3$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $e56e4fee659d45d3$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $e56e4fee659d45d3$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $e56e4fee659d45d3$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $e56e4fee659d45d3$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $e56e4fee659d45d3$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $e56e4fee659d45d3$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $e56e4fee659d45d3$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $e56e4fee659d45d3$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $e56e4fee659d45d3$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $e56e4fee659d45d3$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $e56e4fee659d45d3$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $e56e4fee659d45d3$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $e56e4fee659d45d3$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $e56e4fee659d45d3$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $e56e4fee659d45d3$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $e56e4fee659d45d3$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $e56e4fee659d45d3$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $e56e4fee659d45d3$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $e56e4fee659d45d3$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $e56e4fee659d45d3$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $e56e4fee659d45d3$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $e56e4fee659d45d3$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $e56e4fee659d45d3$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN900", function () { return $e56e4fee659d45d3$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN500", function () { return $e56e4fee659d45d3$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "DN400", function () { return $e56e4fee659d45d3$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $e56e4fee659d45d3$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $e56e4fee659d45d3$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $e56e4fee659d45d3$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $e56e4fee659d45d3$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $e56e4fee659d45d3$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $e56e4fee659d45d3$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $e56e4fee659d45d3$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5A5Se = parcelRequire("5A5Se");
var $e56e4fee659d45d3$export$4b84fd0e2c617bd = '#FFEBE6';
var $e56e4fee659d45d3$export$b34b069eff244586 = '#FFBDAD';
var $e56e4fee659d45d3$export$be802dd0d8b57f35 = '#FF8F73';
var $e56e4fee659d45d3$export$60847d42f9da92a6 = '#FF7452';
var $e56e4fee659d45d3$export$4a7404f376229999 = '#FF5630';
var $e56e4fee659d45d3$export$2010d0fb4295b346 = '#DE350B';
var $e56e4fee659d45d3$export$2837b5a1a71d5c02 = '#BF2600';
var $e56e4fee659d45d3$export$8d9596b529bbb9cf = '#FFFAE6';
var $e56e4fee659d45d3$export$41060a744ab0b7ae = '#FFF0B3';
var $e56e4fee659d45d3$export$1cc05bbbf340e559 = '#FFE380';
var $e56e4fee659d45d3$export$5aae31392d72caaa = '#FFC400';
var $e56e4fee659d45d3$export$c6930421db9fa514 = '#FFAB00';
var $e56e4fee659d45d3$export$59619663aa6500fb = '#FF991F';
var $e56e4fee659d45d3$export$874739ea9e379ab6 = '#FF8B00';
var $e56e4fee659d45d3$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $e56e4fee659d45d3$export$69a3bf21b9686c2b = '#ABF5D1';
var $e56e4fee659d45d3$export$afbce1382ec95f73 = '#79F2C0';
var $e56e4fee659d45d3$export$747d86715d4175de = '#57D9A3';
var $e56e4fee659d45d3$export$940e1f69e873f202 = '#36B37E';
var $e56e4fee659d45d3$export$a49394138f7b8e85 = '#00875A';
var $e56e4fee659d45d3$export$6fa04827ac68a4fb = '#006644';
var $e56e4fee659d45d3$export$226de0355ed012f8 = '#DEEBFF';
var $e56e4fee659d45d3$export$8c13c2ee36917869 = '#B3D4FF';
var $e56e4fee659d45d3$export$ecfc1dff386a3e7a = '#4C9AFF';
var $e56e4fee659d45d3$export$215b7063051591f1 = '#2684FF';
var $e56e4fee659d45d3$export$e62e8919cca44969 = '#0065FF';
var $e56e4fee659d45d3$export$b3de0ae08da2ce64 = '#0052CC';
var $e56e4fee659d45d3$export$a6ee3d71bc067634 = '#0747A6';
var $e56e4fee659d45d3$export$363e4475840015bb = '#EAE6FF';
var $e56e4fee659d45d3$export$4b0a4417ed59760f = '#C0B6F2';
var $e56e4fee659d45d3$export$6011520a64d9a187 = '#998DD9';
var $e56e4fee659d45d3$export$a7175d4e9206bc80 = '#8777D9';
var $e56e4fee659d45d3$export$b48405b95304b5a1 = '#6554C0';
var $e56e4fee659d45d3$export$c71e4279dd54a18d = '#5243AA';
var $e56e4fee659d45d3$export$147899de772240ec = '#403294';
var $e56e4fee659d45d3$export$2cf711fe14c66f06 = '#E6FCFF';
var $e56e4fee659d45d3$export$7a8f4d33f6f9772c = '#B3F5FF';
var $e56e4fee659d45d3$export$776c9c497ef08533 = '#79E2F2';
var $e56e4fee659d45d3$export$69cb3ca10c1e330e = '#00C7E6';
var $e56e4fee659d45d3$export$9dc1ef0f3f48059b = '#00B8D9';
var $e56e4fee659d45d3$export$7c835c78b6fcdef8 = '#00A3BF';
var $e56e4fee659d45d3$export$6036577f95c3877e = '#008DA6';
var $e56e4fee659d45d3$export$29a4f05edc054374 = '#FFFFFF';
var $e56e4fee659d45d3$export$e655ef011c4aa1a2 = '#FAFBFC';
var $e56e4fee659d45d3$export$9fdfb749e33cdf97 = '#F4F5F7';
var $e56e4fee659d45d3$export$3e51e8f1440314ba = '#EBECF0';
var $e56e4fee659d45d3$export$1ce2d1575d444ceb = '#DFE1E6';
var $e56e4fee659d45d3$export$8754fc7e6d8b3000 = '#C1C7D0';
var $e56e4fee659d45d3$export$c2e91cbeada39b8b = '#B3BAC5';
var $e56e4fee659d45d3$export$5f71e19f3a7ad9de = '#A5ADBA';
var $e56e4fee659d45d3$export$eaa8c8a70ac22806 = '#97A0AF';
var $e56e4fee659d45d3$export$7c87d337fb91a97d = '#8993A4';
var $e56e4fee659d45d3$export$d6447c357493214f = '#7A869A';
var $e56e4fee659d45d3$export$f563ee71e9ee74cd = '#6B778C';
var $e56e4fee659d45d3$export$e2ef2124cf4024b1 = '#5E6C84';
var $e56e4fee659d45d3$export$eece5f492e429f08 = '#505F79';
var $e56e4fee659d45d3$export$c39c0fe0f26207ae = '#42526E';
var $e56e4fee659d45d3$export$7090862dc3038a9f = '#344563';
var $e56e4fee659d45d3$export$ad0bacf983b7ddaa = '#253858';
var $e56e4fee659d45d3$export$7d61b15e0da132af = '#172B4D';
var $e56e4fee659d45d3$export$fbda843f0a27fe96 = '#091E42';
var $e56e4fee659d45d3$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $e56e4fee659d45d3$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $e56e4fee659d45d3$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $e56e4fee659d45d3$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $e56e4fee659d45d3$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $e56e4fee659d45d3$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $e56e4fee659d45d3$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $e56e4fee659d45d3$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $e56e4fee659d45d3$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $e56e4fee659d45d3$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $e56e4fee659d45d3$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $e56e4fee659d45d3$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $e56e4fee659d45d3$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $e56e4fee659d45d3$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $e56e4fee659d45d3$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $e56e4fee659d45d3$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $e56e4fee659d45d3$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $e56e4fee659d45d3$export$2f6319cf7d736c2a = '#E6EDFA';
var $e56e4fee659d45d3$export$95126bc8884d6634 = '#DCE5F5';
var $e56e4fee659d45d3$export$8338d8c35d44ff1 = '#CED9EB';
var $e56e4fee659d45d3$export$5368d76ae4fbbda7 = '#B8C7E0';
var $e56e4fee659d45d3$export$9f0a771d16ec8d36 = '#ABBBD6';
var $e56e4fee659d45d3$export$abcf8c38338b4aa5 = '#9FB0CC';
var $e56e4fee659d45d3$export$97e81faa16a182c7 = '#8C9CB8';
var $e56e4fee659d45d3$export$bfe21c59123ecf33 = '#7988A3';
var $e56e4fee659d45d3$export$ee82aa2ea6a1558 = '#67758F';
var $e56e4fee659d45d3$export$682927c6ed76be02 = '#56637A';
var $e56e4fee659d45d3$export$91fd9994c5be9757 = '#455166';
var $e56e4fee659d45d3$export$d281fbfe3cff2df6 = '#3B475C';
var $e56e4fee659d45d3$export$3902c91d8b98a753 = '#313D52';
var $e56e4fee659d45d3$export$8e8133c1ba5845b5 = '#283447';
var $e56e4fee659d45d3$export$33ff357f6620b39 = '#202B3D';
var $e56e4fee659d45d3$export$633847cf062b69e0 = '#1B2638';
var $e56e4fee659d45d3$export$9776a6e503bdbf76 = '#121A29';
var $e56e4fee659d45d3$export$6c813d5160dff5db = '#0E1624';
var $e56e4fee659d45d3$export$3d4f271a500072a = '#0D1424';
var $e56e4fee659d45d3$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $e56e4fee659d45d3$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $e56e4fee659d45d3$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $e56e4fee659d45d3$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $e56e4fee659d45d3$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $e56e4fee659d45d3$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $e56e4fee659d45d3$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $e56e4fee659d45d3$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $e56e4fee659d45d3$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $e56e4fee659d45d3$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $e56e4fee659d45d3$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $e56e4fee659d45d3$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $e56e4fee659d45d3$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $e56e4fee659d45d3$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $e56e4fee659d45d3$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $e56e4fee659d45d3$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $e56e4fee659d45d3$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $e56e4fee659d45d3$export$8ce1fd94bee2f412 = (0, $5A5Se.default)({
    light: "var(--ds-surface, ".concat($e56e4fee659d45d3$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($e56e4fee659d45d3$export$633847cf062b69e0, ")")
});
var $e56e4fee659d45d3$export$b861914ea877b580 = (0, $5A5Se.default)({
    light: "var(--ds-background-selected, ".concat($e56e4fee659d45d3$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($e56e4fee659d45d3$export$8c13c2ee36917869, ")")
});
var $e56e4fee659d45d3$export$3f1b020df94387af = (0, $5A5Se.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($e56e4fee659d45d3$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($e56e4fee659d45d3$export$d281fbfe3cff2df6, ")")
});
var $e56e4fee659d45d3$export$c0183dbab98ca63e = (0, $5A5Se.default)({
    light: "var(--ds-surface-overlay, ".concat($e56e4fee659d45d3$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($e56e4fee659d45d3$export$8e8133c1ba5845b5, ")")
});
var $e56e4fee659d45d3$export$6f093cfa640b7166 = (0, $5A5Se.default)({
    light: "var(--ds-text, ".concat($e56e4fee659d45d3$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($e56e4fee659d45d3$export$5368d76ae4fbbda7, ")")
});
var $e56e4fee659d45d3$export$42f8e9c698766e7a = (0, $5A5Se.default)({
    light: "var(--ds-text, ".concat($e56e4fee659d45d3$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($e56e4fee659d45d3$export$5368d76ae4fbbda7, ")")
});
var $e56e4fee659d45d3$export$c2d157ca1c34b6e3 = (0, $5A5Se.default)({
    light: "var(--ds-text-selected, ".concat($e56e4fee659d45d3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($e56e4fee659d45d3$export$b3de0ae08da2ce64, ")")
});
var $e56e4fee659d45d3$export$1905ba28d7cf066f = (0, $5A5Se.default)({
    light: "var(--ds-text-subtlest, ".concat($e56e4fee659d45d3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e56e4fee659d45d3$export$97e81faa16a182c7, ")")
});
var $e56e4fee659d45d3$export$bd9002130d306d39 = (0, $5A5Se.default)({
    light: "var(--ds-text-subtlest, ".concat($e56e4fee659d45d3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e56e4fee659d45d3$export$bfe21c59123ecf33, ")")
});
var $e56e4fee659d45d3$export$46e4a324ac90507f = (0, $5A5Se.default)({
    light: "var(--ds-text, ".concat($e56e4fee659d45d3$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($e56e4fee659d45d3$export$5368d76ae4fbbda7, ")")
});
var $e56e4fee659d45d3$export$79f3f2b82beb0d36 = (0, $5A5Se.default)({
    light: "var(--ds-text-subtlest, ".concat($e56e4fee659d45d3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e56e4fee659d45d3$export$97e81faa16a182c7, ")")
});
var $e56e4fee659d45d3$export$7bb0d5c671655cc4 = (0, $5A5Se.default)({
    light: $e56e4fee659d45d3$export$9fdfb749e33cdf97,
    dark: $e56e4fee659d45d3$export$8e8133c1ba5845b5
});
var $e56e4fee659d45d3$export$9c30223ca0a664fb = (0, $5A5Se.default)({
    light: "var(--ds-link, ".concat($e56e4fee659d45d3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($e56e4fee659d45d3$export$ecfc1dff386a3e7a, ")")
});
var $e56e4fee659d45d3$export$7ed258b0728b004b = (0, $5A5Se.default)({
    light: "var(--ds-link-pressed, ".concat($e56e4fee659d45d3$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($e56e4fee659d45d3$export$215b7063051591f1, ")")
});
var $e56e4fee659d45d3$export$dfa920d8decc8a59 = (0, $5A5Se.default)({
    light: "var(--ds-link-pressed, ".concat($e56e4fee659d45d3$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($e56e4fee659d45d3$export$ecfc1dff386a3e7a, ")")
});
var $e56e4fee659d45d3$export$6069e6ad5c78f632 = (0, $5A5Se.default)({
    light: "var(--ds-border-focused, ".concat($e56e4fee659d45d3$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($e56e4fee659d45d3$export$215b7063051591f1, ")")
});
var $e56e4fee659d45d3$export$9ad721cf3b3debe0 = (0, $5A5Se.default)({
    light: "var(--ds-background-brand-bold, ".concat($e56e4fee659d45d3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($e56e4fee659d45d3$export$ecfc1dff386a3e7a, ")")
});
var $e56e4fee659d45d3$export$2aa0182783e7e9de = (0, $5A5Se.default)({
    light: $e56e4fee659d45d3$export$b3de0ae08da2ce64,
    dark: $e56e4fee659d45d3$export$ecfc1dff386a3e7a
});
var $e56e4fee659d45d3$export$8bf7dff220b82b4a = (0, $5A5Se.default)({
    light: $e56e4fee659d45d3$export$9dc1ef0f3f48059b,
    dark: $e56e4fee659d45d3$export$69cb3ca10c1e330e
});
var $e56e4fee659d45d3$export$e13cce2a2d16a9d4 = (0, $5A5Se.default)({
    light: $e56e4fee659d45d3$export$b48405b95304b5a1,
    dark: $e56e4fee659d45d3$export$6011520a64d9a187
});
var $e56e4fee659d45d3$export$a90204d1394caf30 = (0, $5A5Se.default)({
    light: $e56e4fee659d45d3$export$4a7404f376229999,
    dark: $e56e4fee659d45d3$export$4a7404f376229999
});
var $e56e4fee659d45d3$export$594c5a8758200c32 = (0, $5A5Se.default)({
    light: $e56e4fee659d45d3$export$c6930421db9fa514,
    dark: $e56e4fee659d45d3$export$c6930421db9fa514
});
var $e56e4fee659d45d3$export$955a2ebd2fb142ae = (0, $5A5Se.default)({
    light: $e56e4fee659d45d3$export$940e1f69e873f202,
    dark: $e56e4fee659d45d3$export$940e1f69e873f202
});
var $e56e4fee659d45d3$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($e56e4fee659d45d3$export$8d43898f60b96a82, ")");
};

});
parcelRegister("5A5Se", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4104def03b25fa60$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $2VO4Q = parcelRequire("2VO4Q");
// Unpack custom variants, and get correct value for the current theme
function $4104def03b25fa60$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $2VO4Q.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $4104def03b25fa60$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $4104def03b25fa60$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $2VO4Q.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("2VO4Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2227bfe6805dd200$export$2e2bcd8739ae039; });

var $lrHtb = parcelRequire("lrHtb");
function $2227bfe6805dd200$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $lrHtb.CHANNEL) in props.theme) return props.theme[0, $lrHtb.CHANNEL];
        else if ('mode' in props.theme && (0, $lrHtb.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $lrHtb.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("lrHtb", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $f9cdd6c790b2cd4d$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $f9cdd6c790b2cd4d$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $f9cdd6c790b2cd4d$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $f9cdd6c790b2cd4d$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $f9cdd6c790b2cd4d$export$85e3c3ca0c6fb93; });

var $dnOha = parcelRequire("dnOha");

var $jHfPv = parcelRequire("jHfPv");
var $f9cdd6c790b2cd4d$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $f9cdd6c790b2cd4d$export$c93026a968943f95 = 'light';
var $f9cdd6c790b2cd4d$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $f9cdd6c790b2cd4d$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $f9cdd6c790b2cd4d$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $f9cdd6c790b2cd4d$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $f9cdd6c790b2cd4d$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $f9cdd6c790b2cd4d$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $f9cdd6c790b2cd4d$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $f9cdd6c790b2cd4d$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $jHfPv.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f9cdd6c790b2cd4d$export$6d8204c2cb2e06b8() / 4;
    (0, $dnOha.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $f9cdd6c790b2cd4d$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $f9cdd6c790b2cd4d$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $f9cdd6c790b2cd4d$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $dnOha.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $f9cdd6c790b2cd4d$export$ba1d834b86d72a09 = $f9cdd6c790b2cd4d$export$a1b3edb637fb4f35;
var $f9cdd6c790b2cd4d$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $jHfPv.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $jHfPv.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $jHfPv.N30A), ")")
            }
        }
    };
};

});
parcelRegister("dnOha", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9be46c1c0a654c3e$export$2e2bcd8739ae039; });

var $wuYgy = parcelRequire("wuYgy");

var $7t0tI = parcelRequire("7t0tI");
function $9be46c1c0a654c3e$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $wuYgy.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $9be46c1c0a654c3e$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("wuYgy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $061b0379a364891d$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $061b0379a364891d$var$printed = {};
function $061b0379a364891d$export$2e2bcd8739ae039(message) {
    if ($061b0379a364891d$var$printed[message]) return;
    $061b0379a364891d$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("7dZ9n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $54292e7c9d17673e$export$2e2bcd8739ae039; });
function $54292e7c9d17673e$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $54292e7c9d17673e$var$tabKeyCode = 9;
function $54292e7c9d17673e$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $54292e7c9d17673e$var$tabKeyCode) return;
    $54292e7c9d17673e$var$abort(event);
}
var $54292e7c9d17673e$var$block = {
    onMouseDownCapture: $54292e7c9d17673e$var$abort,
    onMouseUpCapture: $54292e7c9d17673e$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $54292e7c9d17673e$var$onKey,
    onKeyUpCapture: $54292e7c9d17673e$var$onKey,
    onTouchStartCapture: $54292e7c9d17673e$var$abort,
    onTouchEndCapture: $54292e7c9d17673e$var$abort,
    onPointerDownCapture: $54292e7c9d17673e$var$abort,
    onPointerUpCapture: $54292e7c9d17673e$var$abort,
    onClickCapture: $54292e7c9d17673e$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $54292e7c9d17673e$var$abort
};
var $54292e7c9d17673e$var$doNotBlock = {};
function $54292e7c9d17673e$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $54292e7c9d17673e$var$doNotBlock : $54292e7c9d17673e$var$block;
}

});

parcelRegister("dolHT", function(module, exports) {
$parcel$export(module.exports, "getCss", function () { return $9bfe5acdf523b46d$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $9bfe5acdf523b46d$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $9bfe5acdf523b46d$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $9bfe5acdf523b46d$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $9bfe5acdf523b46d$export$1a9fe1b84c876bb5; });

var $1WkeW = parcelRequire("1WkeW");

var $3dJ4i = parcelRequire("3dJ4i");

var $lrHtb = parcelRequire("lrHtb");

var $8TITv = parcelRequire("8TITv");
function $9bfe5acdf523b46d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bfe5acdf523b46d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bfe5acdf523b46d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1WkeW.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bfe5acdf523b46d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9bfe5acdf523b46d$var$gridSize = (0, $lrHtb.gridSize)();
var $9bfe5acdf523b46d$var$fontSize = (0, $lrHtb.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $9bfe5acdf523b46d$var$heights = {
    default: "".concat($9bfe5acdf523b46d$var$gridSize * 4 / $9bfe5acdf523b46d$var$fontSize, "em"),
    // 32px
    compact: "".concat($9bfe5acdf523b46d$var$gridSize * 3 / $9bfe5acdf523b46d$var$fontSize, "em"),
    none: 'auto'
};
var $9bfe5acdf523b46d$var$lineHeights = {
    default: $9bfe5acdf523b46d$var$heights.default,
    compact: $9bfe5acdf523b46d$var$heights.compact,
    none: 'inherit'
};
var $9bfe5acdf523b46d$var$padding = {
    // 10px gutter
    default: "0 ".concat($9bfe5acdf523b46d$var$gridSize + $9bfe5acdf523b46d$var$gridSize / 4, "px"),
    compact: "0 ".concat($9bfe5acdf523b46d$var$gridSize + $9bfe5acdf523b46d$var$gridSize / 4, "px"),
    none: '0'
};
var $9bfe5acdf523b46d$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($9bfe5acdf523b46d$var$gridSize / 4, "px"),
    default: "0 ".concat($9bfe5acdf523b46d$var$gridSize / 4, "px"),
    none: '0'
};
var $9bfe5acdf523b46d$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $9bfe5acdf523b46d$var$innerMargin = {
    content: "0 ".concat($9bfe5acdf523b46d$var$gridSize / 4, "px"),
    icon: "0 ".concat($9bfe5acdf523b46d$var$gridSize / 4, "px")
};
function $9bfe5acdf523b46d$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $9bfe5acdf523b46d$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $9bfe5acdf523b46d$var$getColor({
            group: (0, $8TITv.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($9bfe5acdf523b46d$var$getColor({
            group: (0, $8TITv.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $9bfe5acdf523b46d$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $9bfe5acdf523b46d$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $9bfe5acdf523b46d$var$_objectSpread($9bfe5acdf523b46d$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, baseColors), {}, {
        cursor: 'pointer',
        height: $9bfe5acdf523b46d$var$heights[spacing],
        lineHeight: $9bfe5acdf523b46d$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $9bfe5acdf523b46d$var$singleIconPadding[spacing] : $9bfe5acdf523b46d$var$padding[spacing],
        verticalAlign: $9bfe5acdf523b46d$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        '&:visited': $9bfe5acdf523b46d$var$_objectSpread({}, baseColors),
        '&:hover': $9bfe5acdf523b46d$var$_objectSpread($9bfe5acdf523b46d$var$_objectSpread({}, $9bfe5acdf523b46d$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $9bfe5acdf523b46d$var$_objectSpread($9bfe5acdf523b46d$var$_objectSpread({}, $9bfe5acdf523b46d$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $9bfe5acdf523b46d$var$_objectSpread($9bfe5acdf523b46d$var$_objectSpread({}, $9bfe5acdf523b46d$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $9bfe5acdf523b46d$var$_objectSpread($9bfe5acdf523b46d$var$_objectSpread({}, $9bfe5acdf523b46d$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        }),
        '&[data-has-overlay="true"]': {
            cursor: 'default',
            textDecoration: 'none'
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $9bfe5acdf523b46d$var$_objectSpread({}, $9bfe5acdf523b46d$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        })),
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $9bfe5acdf523b46d$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $3dJ4i.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === 'none' ? 0 : $9bfe5acdf523b46d$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $9bfe5acdf523b46d$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === 'none' ? 0 : $9bfe5acdf523b46d$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $9bfe5acdf523b46d$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $3dJ4i.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $9bfe5acdf523b46d$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("1WkeW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $169ae87ccf8d70b0$export$2e2bcd8739ae039; });

var $6GLCy = parcelRequire("6GLCy");
function $169ae87ccf8d70b0$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $6GLCy.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("6GLCy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4deb9ada35edce79$export$2e2bcd8739ae039; });

var $lWJpI = parcelRequire("lWJpI");

var $5Xela = parcelRequire("5Xela");
function $4deb9ada35edce79$export$2e2bcd8739ae039(t) {
    var i = (0, $5Xela.default)(t, "string");
    return "symbol" == (0, $lWJpI.default)(i) ? i : i + "";
}

});
parcelRegister("lWJpI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ffa23e00a51f85b4$export$2e2bcd8739ae039; });
function $ffa23e00a51f85b4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ffa23e00a51f85b4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ffa23e00a51f85b4$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5Xela", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $455d96200de20972$export$2e2bcd8739ae039; });

var $lWJpI = parcelRequire("lWJpI");
function $455d96200de20972$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $lWJpI.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $lWJpI.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("8TITv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67a648da7f1001f9$export$2e2bcd8739ae039; });

var $jHfPv = parcelRequire("jHfPv");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $67a648da7f1001f9$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $67a648da7f1001f9$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($jHfPv.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($jHfPv.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($jHfPv.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($jHfPv.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($67a648da7f1001f9$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($jHfPv.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jHfPv.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jHfPv.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($jHfPv.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($jHfPv.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($jHfPv.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($jHfPv.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($jHfPv.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($jHfPv.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jHfPv.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jHfPv.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($jHfPv.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($jHfPv.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($jHfPv.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($jHfPv.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($jHfPv.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($jHfPv.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jHfPv.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jHfPv.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($jHfPv.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($jHfPv.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($jHfPv.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($jHfPv.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($jHfPv.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($jHfPv.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jHfPv.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jHfPv.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($jHfPv.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($jHfPv.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($67a648da7f1001f9$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($jHfPv.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.DN0, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jHfPv.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jHfPv.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($jHfPv.N500, ")"),
                dark: "var(--ds-text, ".concat($jHfPv.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jHfPv.B400, ")"),
                dark: "var(--ds-text, ".concat($jHfPv.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jHfPv.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jHfPv.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($jHfPv.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($jHfPv.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jHfPv.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jHfPv.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($jHfPv.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($jHfPv.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jHfPv.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jHfPv.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($jHfPv.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($jHfPv.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jHfPv.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jHfPv.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($jHfPv.B400, ")"),
                dark: "var(--ds-link, ".concat($jHfPv.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($jHfPv.B300, ")"),
                dark: "var(--ds-link, ".concat($jHfPv.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($jHfPv.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($jHfPv.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jHfPv.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jHfPv.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($jHfPv.N500, ")"),
                dark: "var(--ds-text, ".concat($jHfPv.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jHfPv.B400, ")"),
                dark: "var(--ds-text, ".concat($jHfPv.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jHfPv.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jHfPv.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.DN400, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($jHfPv.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($jHfPv.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($jHfPv.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($jHfPv.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jHfPv.N400, ")"),
                dark: "var(--ds-text, ".concat($jHfPv.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jHfPv.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jHfPv.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jHfPv.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jHfPv.DN400, ")")
            }
        }
    }
};
var $67a648da7f1001f9$export$2e2bcd8739ae039 = $67a648da7f1001f9$var$values;

});


parcelRegister("gUgJu", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $032d2490dc97f14f$export$20bbd2efb0d734c4; });

var $1oC0p = parcelRequire("1oC0p");

var $FapDU = parcelRequire("FapDU");
var $032d2490dc97f14f$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $1oC0p.isValidElement)(children) && children.type === (0, $FapDU.default);
};

});
parcelRegister("FapDU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $07bbe82c99fc3209$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $07bbe82c99fc3209$var$visuallyHiddenStyles = (0, $3dJ4i.css)({
    width: '1px',
    height: '1px',
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $07bbe82c99fc3209$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $3dJ4i.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $07bbe82c99fc3209$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $07bbe82c99fc3209$export$2e2bcd8739ae039 = $07bbe82c99fc3209$var$VisuallyHidden;

});



parcelRegister("coysQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $906275cde614a231$export$2e2bcd8739ae039; });

var $4o3jP = parcelRequire("4o3jP");

var $gUgJu = parcelRequire("gUgJu");
function $906275cde614a231$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $4o3jP.getBooleanFF)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && (0, $gUgJu.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("gacwQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc474c70e061b320$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");
var $bc474c70e061b320$var$formFooterWrapperStyles = (0, $3dJ4i.css)({
    display: 'flex',
    marginTop: "var(--ds-space-300, 24px)",
    justifyContent: 'flex-end'
});
var $bc474c70e061b320$var$justifyContentStyles = (0, $3dJ4i.css)({
    justifyContent: 'flex-start'
});
function $bc474c70e061b320$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? 'end' : _ref$align, children = _ref.children;
    return (0, $3dJ4i.jsx)("footer", {
        css: [
            $bc474c70e061b320$var$formFooterWrapperStyles,
            align === 'start' && $bc474c70e061b320$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("1Zr4f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3602017c9c0db571ac57dae4d1f426bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17307bfee1c30844$var$_react = $17307bfee1c30844$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $17307bfee1c30844$var$_baseNew = $17307bfee1c30844$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $17307bfee1c30844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17307bfee1c30844$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $17307bfee1c30844$var$_react.default.createElement($17307bfee1c30844$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$17307bfee1c30844$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $17307bfee1c30844$var$_default = module.exports.default = $17307bfee1c30844$var$LinkExternalIcon;

});


parcelRegister("5yxfX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e5c7fd09d3db6587$export$2e2bcd8739ae039; });
/* site-selector-radio-group.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $2vYc0 = parcelRequire("2vYc0");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $e5c7fd09d3db6587$var$SiteSelectorRadioGroup = ({ sites: sites, onSiteChanged: onSiteChanged })=>{
    const [state, setState] = (0, $1oC0p.useState)({
        fieldName: '',
        radioOptions: [],
        selectedSite: ''
    });
    const { fieldName: fieldName, radioOptions: radioOptions, selectedSite: selectedSite } = state;
    (0, $1oC0p.useEffect)(()=>{
        const fieldName = 'site';
        const radioOptions = getRadioOptions(sites, fieldName);
        const defaultValue = radioOptions[0]?.value;
        setState({
            fieldName: fieldName,
            radioOptions: radioOptions,
            selectedSite: defaultValue
        });
    }, [
        sites
    ]);
    const getRadioOptions = (sites, fieldName)=>{
        const radioOptions = sites.map((site)=>{
            // HOT-101715 fixes
            const { hostname: originalHostname, searchParams: searchParams } = new URL(site);
            let hostname = originalHostname;
            try {
                const continueVal = searchParams.get('continue');
                hostname = continueVal ? new URL(continueVal).hostname : originalHostname;
            } catch  {}
            return {
                name: fieldName,
                value: site,
                label: hostname
            };
        });
        // Include option to "Start a new site"
        radioOptions.push({
            name: fieldName,
            value: '',
            label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "SiteSelectorModal.startASite",
                defaultMessage: "Start a new site"
            })
        });
        return radioOptions;
    };
    const onValueChange = (event)=>{
        onSiteChanged();
        // In our custom onChange handler, we need to manage the RadioGroup state in our component's state
        const newValue = event.currentTarget.getAttribute('value');
        const newSiteSelected = newValue ? newValue : undefined;
        setState({
            ...state,
            selectedSite: newSiteSelected
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
        name: fieldName,
        label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "SiteSelectorModal.selectASite",
            defaultMessage: "Select a site"
        }),
        defaultValue: selectedSite,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_c71l4kif _18m91wug _y1duv77o _1gilm8mt"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2vYc0.default), {
                    ...fieldProps,
                    options: radioOptions,
                    onChange: onValueChange
                })
            })
    });
};
const $e5c7fd09d3db6587$var$radioGroupStyles = null;
var $e5c7fd09d3db6587$export$2e2bcd8739ae039 = $e5c7fd09d3db6587$var$SiteSelectorRadioGroup;

});
parcelRegister("igGC3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4cac6a0b3d8e592$export$2e2bcd8739ae039; });

var $4C7We = parcelRequire("4C7We");

var $64c5S = parcelRequire("64c5S");

var $fOc2E = parcelRequire("fOc2E");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $bLlgH = parcelRequire("bLlgH");
parcelRequire("lmxXn");

var $fqpc8 = parcelRequire("fqpc8");

var $lX14w = parcelRequire("lX14w");

var $aTd7T = parcelRequire("aTd7T");

var $gZ0V2 = parcelRequire("gZ0V2");

var $7t0tI = parcelRequire("7t0tI");
function $d4cac6a0b3d8e592$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4cac6a0b3d8e592$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4cac6a0b3d8e592$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4C7We.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4cac6a0b3d8e592$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d4cac6a0b3d8e592$var$fieldWrapperStyles = (0, $3dJ4i.css)({
    marginTop: "var(--ds-space-100, 8px)"
});
function $d4cac6a0b3d8e592$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $d4cac6a0b3d8e592$var$isFunction(x) {
    return typeof x === 'function';
}
function $d4cac6a0b3d8e592$var$usePreviousRef(current) {
    var ref = (0, $1oC0p.useRef)(current);
    // will be updated on the next render
    (0, $1oC0p.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $d4cac6a0b3d8e592$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, $fOc2E.default)(previousValue) === 'object' && (0, $fOc2E.default)(currentValue) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $d4cac6a0b3d8e592$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _useContext = (0, $1oC0p.useContext)((0, $lX14w.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $1oC0p.useContext)((0, $lX14w.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = $d4cac6a0b3d8e592$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $d4cac6a0b3d8e592$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$d4cac6a0b3d8e592$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $1oC0p.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explictly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, $64c5S.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $d4cac6a0b3d8e592$var$usePreviousRef(state);
    (0, $1oC0p.useEffect)(function() {
        typeof $7t0tI;
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $d4cac6a0b3d8e592$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($d4cac6a0b3d8e592$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var fieldId = (0, $1oC0p.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    function() {
        return props.id ? props.id : "".concat(props.name, "-").concat((0, $bLlgH.uid)({
            id: props.name
        }));
    }, [
        props.id,
        props.name
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $d4cac6a0b3d8e592$var$_objectSpread($d4cac6a0b3d8e592$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return (0, $3dJ4i.jsx)("div", {
        css: $d4cac6a0b3d8e592$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && (0, $3dJ4i.jsx)((0, $aTd7T.Label), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && (0, $3dJ4i.jsx)((0, $gZ0V2.default), null), props.elementAfterLabel), (0, $3dJ4i.jsx)((0, $fqpc8.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("4C7We", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35c0de65dc1462df$export$2e2bcd8739ae039; });

var $5p5B9 = parcelRequire("5p5B9");
function $35c0de65dc1462df$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5p5B9.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("5p5B9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ef3a138d0209c9f$export$2e2bcd8739ae039; });

var $fOc2E = parcelRequire("fOc2E");

var $iiUzF = parcelRequire("iiUzF");
function $3ef3a138d0209c9f$export$2e2bcd8739ae039(t) {
    var i = (0, $iiUzF.default)(t, "string");
    return "symbol" == (0, $fOc2E.default)(i) ? i : i + "";
}

});
parcelRegister("fOc2E", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b824ddc931652141$export$2e2bcd8739ae039; });
function $b824ddc931652141$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b824ddc931652141$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b824ddc931652141$export$2e2bcd8739ae039(o);
}

});

parcelRegister("iiUzF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d535cae33a08b982$export$2e2bcd8739ae039; });

var $fOc2E = parcelRequire("fOc2E");
function $d535cae33a08b982$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fOc2E.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fOc2E.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("lmxXn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f8d5fe23321daef8$export$2e2bcd8739ae039; });
var $f8d5fe23321daef8$var$isProduction = true;
var $f8d5fe23321daef8$var$prefix = 'Invariant failed';
function $f8d5fe23321daef8$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($f8d5fe23321daef8$var$isProduction) throw new Error($f8d5fe23321daef8$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($f8d5fe23321daef8$var$prefix, ": ").concat(provided) : $f8d5fe23321daef8$var$prefix;
    throw new Error(value);
}

});

parcelRegister("fqpc8", function(module, exports) {
$parcel$export(module.exports, "FieldId", function () { return $b3acd3e4823a98ef$export$3c4232819458a302; });

var $1oC0p = parcelRequire("1oC0p");
var $b3acd3e4823a98ef$export$3c4232819458a302 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("aTd7T", function(module, exports) {
$parcel$export(module.exports, "Label", function () { return $7ed9390af1973e36$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Legend", function () { return $7ed9390af1973e36$export$ed247974535929c7; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $ijG41 = parcelRequire("ijG41");

var $eVybS = parcelRequire("eVybS");
var $jo4dM = parcelRequire("jo4dM");

var $41Nco = parcelRequire("41Nco");

var $cWoYJ = parcelRequire("cWoYJ");
var $7ed9390af1973e36$var$fontFamily = (0, $41Nco.fontFamily)();
var $7ed9390af1973e36$var$fieldsetLabelStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    marginTop: 0,
    marginBottom: "var(--ds-space-050, 4px)",
    fontFamily: $7ed9390af1973e36$var$fontFamily
});
var $7ed9390af1973e36$var$getFieldsetLabelDynamicStyles = function getFieldsetLabelDynamicStyles(mode) {
    return (0, $3dJ4i.css)([
        (0, $cWoYJ.h200)({
            theme: {
                mode: mode
            }
        }),
        {
            color: (0, $eVybS.default)({
                dark: "var(--ds-text-subtle, ".concat((0, $ijG41.DN300), ")"),
                light: "var(--ds-text-subtle, ".concat((0, $ijG41.N200), ")")
            })({
                theme: {
                    mode: mode
                }
            })
        }
    ]);
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $7ed9390af1973e36$var$lightH200Styles = $7ed9390af1973e36$var$getFieldsetLabelDynamicStyles('light');
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $7ed9390af1973e36$var$darkH200Styles = $7ed9390af1973e36$var$getFieldsetLabelDynamicStyles('dark');
var $7ed9390af1973e36$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    var _useGlobalTheme = (0, $jo4dM.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("label", {
        css: [
            mode === 'light' ? $7ed9390af1973e36$var$lightH200Styles : $7ed9390af1973e36$var$darkH200Styles,
            $7ed9390af1973e36$var$fieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
};
var $7ed9390af1973e36$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    var _useGlobalTheme2 = (0, $jo4dM.useGlobalTheme)(), mode = _useGlobalTheme2.mode;
    return (0, $3dJ4i.jsx)("legend", {
        css: [
            mode === 'light' ? $7ed9390af1973e36$var$lightH200Styles : $7ed9390af1973e36$var$darkH200Styles,
            $7ed9390af1973e36$var$fieldsetLabelStyles
        ]
    }, children);
};
var $7ed9390af1973e36$export$2e2bcd8739ae039 = $7ed9390af1973e36$export$b04be29aa201d4f5;

});
parcelRegister("ijG41", function(module, exports) {
$parcel$export(module.exports, "R400", function () { return $d55aa156b4af7ad1$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B200", function () { return $d55aa156b4af7ad1$export$215b7063051591f1; });
$parcel$export(module.exports, "N200", function () { return $d55aa156b4af7ad1$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N30A", function () { return $d55aa156b4af7ad1$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN300", function () { return $d55aa156b4af7ad1$export$97e81faa16a182c7; });
$parcel$export(module.exports, "heading", function () { return $d55aa156b4af7ad1$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $d55aa156b4af7ad1$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "skeleton", function () { return $d55aa156b4af7ad1$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eVybS = parcelRequire("eVybS");
var $d55aa156b4af7ad1$export$4b84fd0e2c617bd = '#FFEBE6';
var $d55aa156b4af7ad1$export$b34b069eff244586 = '#FFBDAD';
var $d55aa156b4af7ad1$export$be802dd0d8b57f35 = '#FF8F73';
var $d55aa156b4af7ad1$export$60847d42f9da92a6 = '#FF7452';
var $d55aa156b4af7ad1$export$4a7404f376229999 = '#FF5630';
var $d55aa156b4af7ad1$export$2010d0fb4295b346 = '#DE350B';
var $d55aa156b4af7ad1$export$2837b5a1a71d5c02 = '#BF2600';
var $d55aa156b4af7ad1$export$8d9596b529bbb9cf = '#FFFAE6';
var $d55aa156b4af7ad1$export$41060a744ab0b7ae = '#FFF0B3';
var $d55aa156b4af7ad1$export$1cc05bbbf340e559 = '#FFE380';
var $d55aa156b4af7ad1$export$5aae31392d72caaa = '#FFC400';
var $d55aa156b4af7ad1$export$c6930421db9fa514 = '#FFAB00';
var $d55aa156b4af7ad1$export$59619663aa6500fb = '#FF991F';
var $d55aa156b4af7ad1$export$874739ea9e379ab6 = '#FF8B00';
var $d55aa156b4af7ad1$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d55aa156b4af7ad1$export$69a3bf21b9686c2b = '#ABF5D1';
var $d55aa156b4af7ad1$export$afbce1382ec95f73 = '#79F2C0';
var $d55aa156b4af7ad1$export$747d86715d4175de = '#57D9A3';
var $d55aa156b4af7ad1$export$940e1f69e873f202 = '#36B37E';
var $d55aa156b4af7ad1$export$a49394138f7b8e85 = '#00875A';
var $d55aa156b4af7ad1$export$6fa04827ac68a4fb = '#006644';
var $d55aa156b4af7ad1$export$226de0355ed012f8 = '#DEEBFF';
var $d55aa156b4af7ad1$export$8c13c2ee36917869 = '#B3D4FF';
var $d55aa156b4af7ad1$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d55aa156b4af7ad1$export$215b7063051591f1 = '#2684FF';
var $d55aa156b4af7ad1$export$e62e8919cca44969 = '#0065FF';
var $d55aa156b4af7ad1$export$b3de0ae08da2ce64 = '#0052CC';
var $d55aa156b4af7ad1$export$a6ee3d71bc067634 = '#0747A6';
var $d55aa156b4af7ad1$export$363e4475840015bb = '#EAE6FF';
var $d55aa156b4af7ad1$export$4b0a4417ed59760f = '#C0B6F2';
var $d55aa156b4af7ad1$export$6011520a64d9a187 = '#998DD9';
var $d55aa156b4af7ad1$export$a7175d4e9206bc80 = '#8777D9';
var $d55aa156b4af7ad1$export$b48405b95304b5a1 = '#6554C0';
var $d55aa156b4af7ad1$export$c71e4279dd54a18d = '#5243AA';
var $d55aa156b4af7ad1$export$147899de772240ec = '#403294';
var $d55aa156b4af7ad1$export$2cf711fe14c66f06 = '#E6FCFF';
var $d55aa156b4af7ad1$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d55aa156b4af7ad1$export$776c9c497ef08533 = '#79E2F2';
var $d55aa156b4af7ad1$export$69cb3ca10c1e330e = '#00C7E6';
var $d55aa156b4af7ad1$export$9dc1ef0f3f48059b = '#00B8D9';
var $d55aa156b4af7ad1$export$7c835c78b6fcdef8 = '#00A3BF';
var $d55aa156b4af7ad1$export$6036577f95c3877e = '#008DA6';
var $d55aa156b4af7ad1$export$29a4f05edc054374 = '#FFFFFF';
var $d55aa156b4af7ad1$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d55aa156b4af7ad1$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d55aa156b4af7ad1$export$3e51e8f1440314ba = '#EBECF0';
var $d55aa156b4af7ad1$export$1ce2d1575d444ceb = '#DFE1E6';
var $d55aa156b4af7ad1$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d55aa156b4af7ad1$export$c2e91cbeada39b8b = '#B3BAC5';
var $d55aa156b4af7ad1$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d55aa156b4af7ad1$export$eaa8c8a70ac22806 = '#97A0AF';
var $d55aa156b4af7ad1$export$7c87d337fb91a97d = '#8993A4';
var $d55aa156b4af7ad1$export$d6447c357493214f = '#7A869A';
var $d55aa156b4af7ad1$export$f563ee71e9ee74cd = '#6B778C';
var $d55aa156b4af7ad1$export$e2ef2124cf4024b1 = '#5E6C84';
var $d55aa156b4af7ad1$export$eece5f492e429f08 = '#505F79';
var $d55aa156b4af7ad1$export$c39c0fe0f26207ae = '#42526E';
var $d55aa156b4af7ad1$export$7090862dc3038a9f = '#344563';
var $d55aa156b4af7ad1$export$ad0bacf983b7ddaa = '#253858';
var $d55aa156b4af7ad1$export$7d61b15e0da132af = '#172B4D';
var $d55aa156b4af7ad1$export$fbda843f0a27fe96 = '#091E42';
var $d55aa156b4af7ad1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d55aa156b4af7ad1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d55aa156b4af7ad1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d55aa156b4af7ad1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d55aa156b4af7ad1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d55aa156b4af7ad1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d55aa156b4af7ad1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d55aa156b4af7ad1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d55aa156b4af7ad1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d55aa156b4af7ad1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d55aa156b4af7ad1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d55aa156b4af7ad1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d55aa156b4af7ad1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d55aa156b4af7ad1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d55aa156b4af7ad1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d55aa156b4af7ad1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d55aa156b4af7ad1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d55aa156b4af7ad1$export$2f6319cf7d736c2a = '#E6EDFA';
var $d55aa156b4af7ad1$export$95126bc8884d6634 = '#DCE5F5';
var $d55aa156b4af7ad1$export$8338d8c35d44ff1 = '#CED9EB';
var $d55aa156b4af7ad1$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d55aa156b4af7ad1$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d55aa156b4af7ad1$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d55aa156b4af7ad1$export$97e81faa16a182c7 = '#8C9CB8';
var $d55aa156b4af7ad1$export$bfe21c59123ecf33 = '#7988A3';
var $d55aa156b4af7ad1$export$ee82aa2ea6a1558 = '#67758F';
var $d55aa156b4af7ad1$export$682927c6ed76be02 = '#56637A';
var $d55aa156b4af7ad1$export$91fd9994c5be9757 = '#455166';
var $d55aa156b4af7ad1$export$d281fbfe3cff2df6 = '#3B475C';
var $d55aa156b4af7ad1$export$3902c91d8b98a753 = '#313D52';
var $d55aa156b4af7ad1$export$8e8133c1ba5845b5 = '#283447';
var $d55aa156b4af7ad1$export$33ff357f6620b39 = '#202B3D';
var $d55aa156b4af7ad1$export$633847cf062b69e0 = '#1B2638';
var $d55aa156b4af7ad1$export$9776a6e503bdbf76 = '#121A29';
var $d55aa156b4af7ad1$export$6c813d5160dff5db = '#0E1624';
var $d55aa156b4af7ad1$export$3d4f271a500072a = '#0D1424';
var $d55aa156b4af7ad1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d55aa156b4af7ad1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d55aa156b4af7ad1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d55aa156b4af7ad1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d55aa156b4af7ad1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d55aa156b4af7ad1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d55aa156b4af7ad1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d55aa156b4af7ad1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d55aa156b4af7ad1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d55aa156b4af7ad1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d55aa156b4af7ad1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d55aa156b4af7ad1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d55aa156b4af7ad1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d55aa156b4af7ad1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d55aa156b4af7ad1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d55aa156b4af7ad1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d55aa156b4af7ad1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d55aa156b4af7ad1$export$8ce1fd94bee2f412 = (0, $eVybS.default)({
    light: "var(--ds-surface, ".concat($d55aa156b4af7ad1$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($d55aa156b4af7ad1$export$633847cf062b69e0, ")")
});
var $d55aa156b4af7ad1$export$b861914ea877b580 = (0, $eVybS.default)({
    light: "var(--ds-background-selected, ".concat($d55aa156b4af7ad1$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($d55aa156b4af7ad1$export$8c13c2ee36917869, ")")
});
var $d55aa156b4af7ad1$export$3f1b020df94387af = (0, $eVybS.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($d55aa156b4af7ad1$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($d55aa156b4af7ad1$export$d281fbfe3cff2df6, ")")
});
var $d55aa156b4af7ad1$export$c0183dbab98ca63e = (0, $eVybS.default)({
    light: "var(--ds-surface-overlay, ".concat($d55aa156b4af7ad1$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($d55aa156b4af7ad1$export$8e8133c1ba5845b5, ")")
});
var $d55aa156b4af7ad1$export$6f093cfa640b7166 = (0, $eVybS.default)({
    light: "var(--ds-text, ".concat($d55aa156b4af7ad1$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($d55aa156b4af7ad1$export$5368d76ae4fbbda7, ")")
});
var $d55aa156b4af7ad1$export$42f8e9c698766e7a = (0, $eVybS.default)({
    light: "var(--ds-text, ".concat($d55aa156b4af7ad1$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d55aa156b4af7ad1$export$5368d76ae4fbbda7, ")")
});
var $d55aa156b4af7ad1$export$c2d157ca1c34b6e3 = (0, $eVybS.default)({
    light: "var(--ds-text-selected, ".concat($d55aa156b4af7ad1$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($d55aa156b4af7ad1$export$b3de0ae08da2ce64, ")")
});
var $d55aa156b4af7ad1$export$1905ba28d7cf066f = (0, $eVybS.default)({
    light: "var(--ds-text-subtlest, ".concat($d55aa156b4af7ad1$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d55aa156b4af7ad1$export$97e81faa16a182c7, ")")
});
var $d55aa156b4af7ad1$export$bd9002130d306d39 = (0, $eVybS.default)({
    light: "var(--ds-text-subtlest, ".concat($d55aa156b4af7ad1$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d55aa156b4af7ad1$export$bfe21c59123ecf33, ")")
});
var $d55aa156b4af7ad1$export$46e4a324ac90507f = (0, $eVybS.default)({
    light: "var(--ds-text, ".concat($d55aa156b4af7ad1$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d55aa156b4af7ad1$export$5368d76ae4fbbda7, ")")
});
var $d55aa156b4af7ad1$export$79f3f2b82beb0d36 = (0, $eVybS.default)({
    light: "var(--ds-text-subtlest, ".concat($d55aa156b4af7ad1$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d55aa156b4af7ad1$export$97e81faa16a182c7, ")")
});
var $d55aa156b4af7ad1$export$7bb0d5c671655cc4 = (0, $eVybS.default)({
    light: $d55aa156b4af7ad1$export$9fdfb749e33cdf97,
    dark: $d55aa156b4af7ad1$export$8e8133c1ba5845b5
});
var $d55aa156b4af7ad1$export$9c30223ca0a664fb = (0, $eVybS.default)({
    light: "var(--ds-link, ".concat($d55aa156b4af7ad1$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($d55aa156b4af7ad1$export$ecfc1dff386a3e7a, ")")
});
var $d55aa156b4af7ad1$export$7ed258b0728b004b = (0, $eVybS.default)({
    light: "var(--ds-link-pressed, ".concat($d55aa156b4af7ad1$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($d55aa156b4af7ad1$export$215b7063051591f1, ")")
});
var $d55aa156b4af7ad1$export$dfa920d8decc8a59 = (0, $eVybS.default)({
    light: "var(--ds-link-pressed, ".concat($d55aa156b4af7ad1$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($d55aa156b4af7ad1$export$ecfc1dff386a3e7a, ")")
});
var $d55aa156b4af7ad1$export$6069e6ad5c78f632 = (0, $eVybS.default)({
    light: "var(--ds-border-focused, ".concat($d55aa156b4af7ad1$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($d55aa156b4af7ad1$export$215b7063051591f1, ")")
});
var $d55aa156b4af7ad1$export$9ad721cf3b3debe0 = (0, $eVybS.default)({
    light: "var(--ds-background-brand-bold, ".concat($d55aa156b4af7ad1$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($d55aa156b4af7ad1$export$ecfc1dff386a3e7a, ")")
});
var $d55aa156b4af7ad1$export$2aa0182783e7e9de = (0, $eVybS.default)({
    light: $d55aa156b4af7ad1$export$b3de0ae08da2ce64,
    dark: $d55aa156b4af7ad1$export$ecfc1dff386a3e7a
});
var $d55aa156b4af7ad1$export$8bf7dff220b82b4a = (0, $eVybS.default)({
    light: $d55aa156b4af7ad1$export$9dc1ef0f3f48059b,
    dark: $d55aa156b4af7ad1$export$69cb3ca10c1e330e
});
var $d55aa156b4af7ad1$export$e13cce2a2d16a9d4 = (0, $eVybS.default)({
    light: $d55aa156b4af7ad1$export$b48405b95304b5a1,
    dark: $d55aa156b4af7ad1$export$6011520a64d9a187
});
var $d55aa156b4af7ad1$export$a90204d1394caf30 = (0, $eVybS.default)({
    light: $d55aa156b4af7ad1$export$4a7404f376229999,
    dark: $d55aa156b4af7ad1$export$4a7404f376229999
});
var $d55aa156b4af7ad1$export$594c5a8758200c32 = (0, $eVybS.default)({
    light: $d55aa156b4af7ad1$export$c6930421db9fa514,
    dark: $d55aa156b4af7ad1$export$c6930421db9fa514
});
var $d55aa156b4af7ad1$export$955a2ebd2fb142ae = (0, $eVybS.default)({
    light: $d55aa156b4af7ad1$export$940e1f69e873f202,
    dark: $d55aa156b4af7ad1$export$940e1f69e873f202
});
var $d55aa156b4af7ad1$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($d55aa156b4af7ad1$export$8d43898f60b96a82, ")");
};

});
parcelRegister("eVybS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ade0e912acafc638$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $bQzN4 = parcelRequire("bQzN4");
// Unpack custom variants, and get correct value for the current theme
function $ade0e912acafc638$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $bQzN4.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $ade0e912acafc638$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $ade0e912acafc638$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $bQzN4.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("bQzN4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8a0050453513f11c$export$2e2bcd8739ae039; });

var $41Nco = parcelRequire("41Nco");
function $8a0050453513f11c$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $41Nco.CHANNEL) in props.theme) return props.theme[0, $41Nco.CHANNEL];
        else if ('mode' in props.theme && (0, $41Nco.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $41Nco.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("41Nco", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $2eed6b4f86376571$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $2eed6b4f86376571$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $2eed6b4f86376571$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $2eed6b4f86376571$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $2eed6b4f86376571$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "fontFamily", function () { return $2eed6b4f86376571$export$a5975749f0374264; });

var $9jEBW = parcelRequire("9jEBW");

var $ijG41 = parcelRequire("ijG41");
var $2eed6b4f86376571$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $2eed6b4f86376571$export$c93026a968943f95 = 'light';
var $2eed6b4f86376571$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $2eed6b4f86376571$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $2eed6b4f86376571$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $2eed6b4f86376571$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $2eed6b4f86376571$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $2eed6b4f86376571$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $2eed6b4f86376571$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $2eed6b4f86376571$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $ijG41.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $2eed6b4f86376571$export$6d8204c2cb2e06b8() / 4;
    (0, $9jEBW.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $2eed6b4f86376571$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $2eed6b4f86376571$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $2eed6b4f86376571$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $9jEBW.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $2eed6b4f86376571$export$ba1d834b86d72a09 = $2eed6b4f86376571$export$a1b3edb637fb4f35;
var $2eed6b4f86376571$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $ijG41.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $ijG41.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $ijG41.N30A), ")")
            }
        }
    };
};

});
parcelRegister("9jEBW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6c8563e325dd59fd$export$2e2bcd8739ae039; });

var $2sukG = parcelRequire("2sukG");

var $7t0tI = parcelRequire("7t0tI");
function $6c8563e325dd59fd$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $2sukG.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $6c8563e325dd59fd$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("2sukG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1ca5b9b6e2886f86$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $1ca5b9b6e2886f86$var$printed = {};
function $1ca5b9b6e2886f86$export$2e2bcd8739ae039(message) {
    if ($1ca5b9b6e2886f86$var$printed[message]) return;
    $1ca5b9b6e2886f86$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("jo4dM", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $e1d3887a84ade126$export$7692396083754928; });

var $hL3Xt = parcelRequire("hL3Xt");
// Create default global light theme
var $e1d3887a84ade126$var$_createTheme = (0, $hL3Xt.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $e1d3887a84ade126$var$Provider = $e1d3887a84ade126$var$_createTheme.Provider, $e1d3887a84ade126$var$Consumer = $e1d3887a84ade126$var$_createTheme.Consumer, $e1d3887a84ade126$export$7692396083754928 = $e1d3887a84ade126$var$_createTheme.useTheme;
var $e1d3887a84ade126$export$2e2bcd8739ae039 = {
    Provider: $e1d3887a84ade126$var$Provider,
    Consumer: $e1d3887a84ade126$var$Consumer
};

});
parcelRegister("hL3Xt", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $ced9e57f8c9762b1$export$25d302a5b900a763; });

var $5mbSG = parcelRequire("5mbSG");

var $1oC0p = parcelRequire("1oC0p");
var $ced9e57f8c9762b1$var$_excluded = [
    "children"
];
function $ced9e57f8c9762b1$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $5mbSG.default)(props, $ced9e57f8c9762b1$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("5mbSG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e683921d5592cc7$export$2e2bcd8739ae039; });

var $hvSj3 = parcelRequire("hvSj3");
function $3e683921d5592cc7$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $hvSj3.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("hvSj3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cbff75014409ef7b$export$2e2bcd8739ae039; });
function $cbff75014409ef7b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("cWoYJ", function(module, exports) {
$parcel$export(module.exports, "h600", function () { return $96be470eddd77e57$export$1e8b2acea3fb3119; });
$parcel$export(module.exports, "h200", function () { return $96be470eddd77e57$export$7ccf32eb2150ac7e; });

var $4C7We = parcelRequire("4C7We");

var $ijG41 = parcelRequire("ijG41");

var $41Nco = parcelRequire("41Nco");
function $96be470eddd77e57$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $96be470eddd77e57$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $96be470eddd77e57$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4C7We.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $96be470eddd77e57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $96be470eddd77e57$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / (0, $41Nco.fontSize)(), "em"),
        fontStyle: 'inherit',
        lineHeight: lineHeight / size
    };
};
var $96be470eddd77e57$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $96be470eddd77e57$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h900.size, $96be470eddd77e57$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $ijG41.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $41Nco.gridSize)() * 6.5, "px")
    });
};
var $96be470eddd77e57$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h800.size, $96be470eddd77e57$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $ijG41.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $41Nco.gridSize)() * 5, "px")
    });
};
var $96be470eddd77e57$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h700.size, $96be470eddd77e57$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $ijG41.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $41Nco.gridSize)() * 5, "px")
    });
};
var $96be470eddd77e57$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h600.size, $96be470eddd77e57$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $ijG41.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $41Nco.gridSize)() * 3.5, "px")
    });
};
var $96be470eddd77e57$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h500.size, $96be470eddd77e57$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $ijG41.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $41Nco.gridSize)() * 3, "px")
    });
};
var $96be470eddd77e57$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h400.size, $96be470eddd77e57$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $ijG41.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $41Nco.gridSize)() * 2, "px")
    });
};
var $96be470eddd77e57$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h300.size, $96be470eddd77e57$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $ijG41.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $41Nco.gridSize)() * 2.5, "px"),
        textTransform: 'uppercase'
    });
};
var $96be470eddd77e57$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h200.size, $96be470eddd77e57$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $ijG41.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $41Nco.gridSize)() * 2, "px")
    });
};
var $96be470eddd77e57$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $96be470eddd77e57$var$_objectSpread($96be470eddd77e57$var$_objectSpread({}, $96be470eddd77e57$var$baseHeading($96be470eddd77e57$export$bc02e067df412c3b.h100.size, $96be470eddd77e57$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $ijG41.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $41Nco.gridSize)() * 2, "px")
    });
};

});


parcelRegister("gZ0V2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c5d30e533fe9613e$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $ijG41 = parcelRequire("ijG41");

var $41Nco = parcelRequire("41Nco");
var $c5d30e533fe9613e$var$fontFamily = (0, $41Nco.fontFamily)();
var $c5d30e533fe9613e$var$requiredIndicatorStyles = (0, $3dJ4i.css)({
    paddingLeft: "var(--ds-space-025, 2px)",
    color: "var(--ds-text-danger, ".concat((0, $ijG41.R400), ")"),
    fontFamily: $c5d30e533fe9613e$var$fontFamily
});
function $c5d30e533fe9613e$export$2e2bcd8739ae039() {
    return (0, $3dJ4i.jsx)("span", {
        css: $c5d30e533fe9613e$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("2vYc0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1d4d2b05f5db12ef$export$2e2bcd8739ae039; });

var $8qKvq = parcelRequire("8qKvq");

var $86Ln2 = parcelRequire("86Ln2");

var $cvjQp = parcelRequire("cvjQp");

var $1oC0p = parcelRequire("1oC0p");

var $iCi7j = parcelRequire("iCi7j");

var $7H48e = parcelRequire("7H48e");
var $1d4d2b05f5db12ef$var$noOptions = [];
function $1d4d2b05f5db12ef$export$2e2bcd8739ae039(props) {
    var onChange = props.onChange, _props$options = props.options, options = _props$options === void 0 ? $1d4d2b05f5db12ef$var$noOptions : _props$options, propValue = props.value, defaultValue = props.defaultValue, isDisabled = props.isDisabled, isRequired = props.isRequired, isInvalid = props.isInvalid, _props$onInvalid = props.onInvalid, onInvalid = _props$onInvalid === void 0 ? (0, $iCi7j.default) : _props$onInvalid, name = props.name, analyticsContext = props.analyticsContext, ariaLabelledBy = props['aria-labelledby'];
    var _useState = (0, $1oC0p.useState)(propValue !== undefined ? propValue : defaultValue), _useState2 = (0, $cvjQp.default)(_useState, 2), selectedValue = _useState2[0], setSelectedValue = _useState2[1];
    var onRadioChange = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    var value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy
    }, options.map(function(_ref, index) {
        var optionProps = (0, $86Ln2.default)({}, ((0, $8qKvq.default)(_ref), _ref));
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        var isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7H48e.default), (0, $86Ln2.default)({}, optionProps, {
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        }));
    }));
}

});
parcelRegister("8qKvq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6234d38e9cd33934$export$2e2bcd8739ae039; });
function $6234d38e9cd33934$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}

});

parcelRegister("86Ln2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e73a118e5fb6776$export$2e2bcd8739ae039; });
function $5e73a118e5fb6776$export$2e2bcd8739ae039() {
    return $5e73a118e5fb6776$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e73a118e5fb6776$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("cvjQp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $91a7c5f74c5919d2$export$2e2bcd8739ae039; });

var $ikEJN = parcelRequire("ikEJN");

var $h7n9J = parcelRequire("h7n9J");

var $krtFo = parcelRequire("krtFo");

var $c7CaY = parcelRequire("c7CaY");
function $91a7c5f74c5919d2$export$2e2bcd8739ae039(r, e) {
    return (0, $ikEJN.default)(r) || (0, $h7n9J.default)(r, e) || (0, $krtFo.default)(r, e) || (0, $c7CaY.default)();
}

});
parcelRegister("ikEJN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d589b1e804acf063$export$2e2bcd8739ae039; });
function $d589b1e804acf063$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("h7n9J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7650d6e8a31010b$export$2e2bcd8739ae039; });
function $c7650d6e8a31010b$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("krtFo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ee1d576a9b62cfad$export$2e2bcd8739ae039; });

var $e7IOm = parcelRequire("e7IOm");
function $ee1d576a9b62cfad$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $e7IOm.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $e7IOm.default)(r, a) : void 0;
    }
}

});
parcelRegister("e7IOm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4847abcdaa597ff$export$2e2bcd8739ae039; });
function $a4847abcdaa597ff$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("c7CaY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d33c06cb305bc7a$export$2e2bcd8739ae039; });
function $8d33c06cb305bc7a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("iCi7j", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8d9d443c8cf4cc5$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $d8d9d443c8cf4cc5$export$2e2bcd8739ae039() {}

});

parcelRegister("7H48e", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $599fc10a7edd81ac$export$2e2bcd8739ae039; });

var $86Ln2 = parcelRequire("86Ln2");

var $iaORU = parcelRequire("iaORU");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $iCi7j = parcelRequire("iCi7j");

var $6dqAn = parcelRequire("6dqAn");

var $i8Ub0 = parcelRequire("i8Ub0");

var $bpK89 = parcelRequire("bpK89");

var $bwqrv = parcelRequire("bwqrv");

var $ktBlO = parcelRequire("ktBlO");
var $599fc10a7edd81ac$var$_excluded = [
    "ariaLabel",
    "isDisabled",
    "isRequired",
    "isInvalid",
    "isChecked",
    "label",
    "mode",
    "name",
    "onChange",
    "value",
    "testId",
    "analyticsContext"
];
var $599fc10a7edd81ac$var$packageName = "@atlaskit/radio";
var $599fc10a7edd81ac$var$packageVersion = "5.6.10";
var $599fc10a7edd81ac$var$fontFamily = (0, $bwqrv.fontFamily)();
var $599fc10a7edd81ac$var$noop = (0, $iCi7j.default);
var $599fc10a7edd81ac$var$labelPaddingStyles = (0, $3dJ4i.css)({
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)")
});
var $599fc10a7edd81ac$var$labelStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    fontFamily: $599fc10a7edd81ac$var$fontFamily,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '&[data-disabled]': {
        color: "var(--ds-text-disabled, ".concat((0, $i8Ub0.N80), ")"),
        cursor: 'not-allowed'
    }
});
var $599fc10a7edd81ac$var$lightLabelStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, ".concat((0, $i8Ub0.N900), ")")
});
var $599fc10a7edd81ac$var$darkLabelStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, ".concat((0, $i8Ub0.DN600), ")")
});
var $599fc10a7edd81ac$var$radioStyles = (0, $3dJ4i.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
    The circle should be 14px * 14px centred in a 24px * 24px box.
    This is inclusive of a 2px border and inner circle with 2px radius.
    There is a Chrome bug that makes the circle become an oval and the
    inner circle not be centred at various zoom levels. This bug is fixed
    in all browsers if a scale of 14/24 is applied.
  */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
    inner circle not be centred at various zoom levels */ border: "".concat((0, $6dqAn.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-width, 1px)" : 'calc(2px * 12 / 7)', " solid var(--radio-border-color)"),
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
    Change the variables --radio-background-color, --radio-border-color,
    -radio-dot-color and -radio-dot-opacity according to user interactions.
    All other variables are constant
  */ '--radio-background-color': 'var(--local-background)',
    '--radio-border-color': 'var(--local-border)',
    '--radio-dot-color': 'var(--local-dot-checked)',
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': 'var(--local-background-hover)',
        '--radio-border-color': 'var(local-border-hover)'
    },
    '&:active': {
        '--radio-background-color': 'var(--local-background-active)'
    },
    '&:focus': {
        '--radio-border-color': 'var(--local-border-focus)'
    },
    '&:checked': {
        '--radio-background-color': 'var(--local-background-checked)',
        '--radio-border-color': 'var(--local-background-checked)',
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': 'var(--local-background-checked-hover)',
        '--radio-border-color': 'var(--local-background-checked-hover)'
    },
    '&:checked:active': {
        '--radio-background-color': 'var(--local-background-checked-active)',
        '--radio-border-color': 'var(--local-border-hover)',
        '--radio-dot-color': 'var(--local-dot-active)'
    },
    '&:checked:focus': {
        '--radio-border-color': 'var(--local-border-focus)'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': 'var(--local-invalid)'
    },
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': 'var(--local-background-disabled)',
        '--radio-border-color': 'var(--local-border-disabled)',
        '--radio-dot-color': 'var(--local-dot-disabled)'
    }
});
var $599fc10a7edd81ac$var$RadioWithMode = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function Radio(props, ref) {
    var ariaLabel = props.ariaLabel, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, isRequired = props.isRequired, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isChecked = props.isChecked, isChecked = _props$isChecked === void 0 ? false : _props$isChecked, label = props.label, mode = props.mode, name = props.name, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? $599fc10a7edd81ac$var$noop : _props$onChange, value = props.value, testId = props.testId, analyticsContext = props.analyticsContext, rest = (0, $iaORU.default)(props, $599fc10a7edd81ac$var$_excluded);
    var onChangeAnalytics = (0, $gJJny.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $599fc10a7edd81ac$var$packageName,
        packageVersion: $599fc10a7edd81ac$var$packageVersion
    });
    var radioCustomProperties = (0, $1oC0p.useMemo)(function() {
        return (0, $3dJ4i.css)((0, $ktBlO.default)(mode));
    }, [
        mode
    ]);
    return (0, $3dJ4i.jsx)("label", {
        "data-testid": testId && "".concat(testId, "--radio-label"),
        "data-disabled": isDisabled ? 'true' : undefined,
        css: [
            $599fc10a7edd81ac$var$labelStyles,
            mode === 'light' ? $599fc10a7edd81ac$var$lightLabelStyles : $599fc10a7edd81ac$var$darkLabelStyles
        ]
    }, (0, $3dJ4i.jsx)("input", (0, $86Ln2.default)({}, rest, {
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && "".concat(testId, "--radio-input"),
        "data-invalid": isInvalid ? 'true' : undefined,
        css: [
            $599fc10a7edd81ac$var$radioStyles,
            radioCustomProperties
        ],
        ref: ref
    })), label ? (0, $3dJ4i.jsx)("span", {
        css: $599fc10a7edd81ac$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ var $599fc10a7edd81ac$var$Radio = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Radio(props, ref) {
    return (0, $3dJ4i.jsx)((0, $bpK89.default).Consumer, null, function(_ref) {
        var mode = _ref.mode;
        return (0, $3dJ4i.jsx)($599fc10a7edd81ac$var$RadioWithMode, (0, $86Ln2.default)({}, props, {
            ref: ref,
            mode: mode
        }));
    });
}));
var $599fc10a7edd81ac$export$2e2bcd8739ae039 = $599fc10a7edd81ac$var$Radio;

});
parcelRegister("iaORU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3b09e9b4d9ee812$export$2e2bcd8739ae039; });

var $75Kb8 = parcelRequire("75Kb8");
function $d3b09e9b4d9ee812$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $75Kb8.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("75Kb8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $529cd21dd8b22115$export$2e2bcd8739ae039; });
function $529cd21dd8b22115$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("6dqAn", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $48689452fac5ba6d$export$470e5c2be1411c89; });

var $3sEDE = parcelRequire("3sEDE");
function $48689452fac5ba6d$export$ba05d765b8392e5e(flagResolver) {
    (0, $3sEDE.setBooleanResolver)(flagResolver);
}
function $48689452fac5ba6d$export$470e5c2be1411c89(name) {
    return (0, $3sEDE.resolveBooleanFlag)(name);
}

});
parcelRegister("3sEDE", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $2853829657310549$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $2853829657310549$export$6333b6aff9fc6275; });

var $38Mr3 = parcelRequire("38Mr3");

var $7t0tI = parcelRequire("7t0tI");
var $2853829657310549$var$pkgName = '@atlaskit/platform-feature-flags';
var $2853829657310549$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $2853829657310549$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $2853829657310549$var$ENV_ENABLE_PLATFORM_FF = $2853829657310549$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2853829657310549$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2853829657310549$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2853829657310549$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2853829657310549$var$ENV_ENABLE_PLATFORM_FF || $2853829657310549$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2853829657310549$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $2853829657310549$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$2853829657310549$var$globalVar[$2853829657310549$export$7e41b1b2bdee3f98] = $2853829657310549$var$globalVar[$2853829657310549$export$7e41b1b2bdee3f98] || $2853829657310549$var$DEFAULT_PFF_GLOBAL;
function $2853829657310549$export$f2b591175b3e424c(resolver) {
    $2853829657310549$var$globalVar[$2853829657310549$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $2853829657310549$export$6333b6aff9fc6275(flagKey) {
    if ($2853829657310549$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $38Mr3.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2853829657310549$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $2853829657310549$var$globalVar[$2853829657310549$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("38Mr3", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $2497b0b1909045b2$export$1c9f709888824e05; });
var $2497b0b1909045b2$var$_ref, $2497b0b1909045b2$var$_globalThis$process, $2497b0b1909045b2$var$_globalThis$process$e, $2497b0b1909045b2$var$_globalThis$process2, $2497b0b1909045b2$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $2497b0b1909045b2$var$TESTS_MODE = ($2497b0b1909045b2$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($2497b0b1909045b2$var$_globalThis$process = globalThis.process) === null || $2497b0b1909045b2$var$_globalThis$process === void 0 ? void 0 : ($2497b0b1909045b2$var$_globalThis$process$e = $2497b0b1909045b2$var$_globalThis$process.env) === null || $2497b0b1909045b2$var$_globalThis$process$e === void 0 ? void 0 : $2497b0b1909045b2$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $2497b0b1909045b2$var$_ref !== void 0) ? $2497b0b1909045b2$var$_ref : false;
var $2497b0b1909045b2$var$DEBUG_MODE = !$2497b0b1909045b2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($2497b0b1909045b2$var$_globalThis$process2 = globalThis.process) === null || $2497b0b1909045b2$var$_globalThis$process2 === void 0 ? void 0 : ($2497b0b1909045b2$var$_globalThis$process2$ = $2497b0b1909045b2$var$_globalThis$process2.env) === null || $2497b0b1909045b2$var$_globalThis$process2$ === void 0 ? void 0 : $2497b0b1909045b2$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $2497b0b1909045b2$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$2497b0b1909045b2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("i8Ub0", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $d3548cd244c57949$export$4a7404f376229999; });
$parcel$export(module.exports, "B50", function () { return $d3548cd244c57949$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $d3548cd244c57949$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $d3548cd244c57949$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $d3548cd244c57949$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $d3548cd244c57949$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $d3548cd244c57949$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $d3548cd244c57949$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $d3548cd244c57949$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $d3548cd244c57949$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $d3548cd244c57949$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $d3548cd244c57949$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $d3548cd244c57949$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N100", function () { return $d3548cd244c57949$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $d3548cd244c57949$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $d3548cd244c57949$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $d3548cd244c57949$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN200", function () { return $d3548cd244c57949$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN90", function () { return $d3548cd244c57949$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $d3548cd244c57949$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN30", function () { return $d3548cd244c57949$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN10", function () { return $d3548cd244c57949$export$6c813d5160dff5db; });
$parcel$export(module.exports, "skeleton", function () { return $d3548cd244c57949$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $fSBjK = parcelRequire("fSBjK");
var $d3548cd244c57949$export$4b84fd0e2c617bd = '#FFEBE6';
var $d3548cd244c57949$export$b34b069eff244586 = '#FFBDAD';
var $d3548cd244c57949$export$be802dd0d8b57f35 = '#FF8F73';
var $d3548cd244c57949$export$60847d42f9da92a6 = '#FF7452';
var $d3548cd244c57949$export$4a7404f376229999 = '#FF5630';
var $d3548cd244c57949$export$2010d0fb4295b346 = '#DE350B';
var $d3548cd244c57949$export$2837b5a1a71d5c02 = '#BF2600';
var $d3548cd244c57949$export$8d9596b529bbb9cf = '#FFFAE6';
var $d3548cd244c57949$export$41060a744ab0b7ae = '#FFF0B3';
var $d3548cd244c57949$export$1cc05bbbf340e559 = '#FFE380';
var $d3548cd244c57949$export$5aae31392d72caaa = '#FFC400';
var $d3548cd244c57949$export$c6930421db9fa514 = '#FFAB00';
var $d3548cd244c57949$export$59619663aa6500fb = '#FF991F';
var $d3548cd244c57949$export$874739ea9e379ab6 = '#FF8B00';
var $d3548cd244c57949$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d3548cd244c57949$export$69a3bf21b9686c2b = '#ABF5D1';
var $d3548cd244c57949$export$afbce1382ec95f73 = '#79F2C0';
var $d3548cd244c57949$export$747d86715d4175de = '#57D9A3';
var $d3548cd244c57949$export$940e1f69e873f202 = '#36B37E';
var $d3548cd244c57949$export$a49394138f7b8e85 = '#00875A';
var $d3548cd244c57949$export$6fa04827ac68a4fb = '#006644';
var $d3548cd244c57949$export$226de0355ed012f8 = '#DEEBFF';
var $d3548cd244c57949$export$8c13c2ee36917869 = '#B3D4FF';
var $d3548cd244c57949$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d3548cd244c57949$export$215b7063051591f1 = '#2684FF';
var $d3548cd244c57949$export$e62e8919cca44969 = '#0065FF';
var $d3548cd244c57949$export$b3de0ae08da2ce64 = '#0052CC';
var $d3548cd244c57949$export$a6ee3d71bc067634 = '#0747A6';
var $d3548cd244c57949$export$363e4475840015bb = '#EAE6FF';
var $d3548cd244c57949$export$4b0a4417ed59760f = '#C0B6F2';
var $d3548cd244c57949$export$6011520a64d9a187 = '#998DD9';
var $d3548cd244c57949$export$a7175d4e9206bc80 = '#8777D9';
var $d3548cd244c57949$export$b48405b95304b5a1 = '#6554C0';
var $d3548cd244c57949$export$c71e4279dd54a18d = '#5243AA';
var $d3548cd244c57949$export$147899de772240ec = '#403294';
var $d3548cd244c57949$export$2cf711fe14c66f06 = '#E6FCFF';
var $d3548cd244c57949$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d3548cd244c57949$export$776c9c497ef08533 = '#79E2F2';
var $d3548cd244c57949$export$69cb3ca10c1e330e = '#00C7E6';
var $d3548cd244c57949$export$9dc1ef0f3f48059b = '#00B8D9';
var $d3548cd244c57949$export$7c835c78b6fcdef8 = '#00A3BF';
var $d3548cd244c57949$export$6036577f95c3877e = '#008DA6';
var $d3548cd244c57949$export$29a4f05edc054374 = '#FFFFFF';
var $d3548cd244c57949$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d3548cd244c57949$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d3548cd244c57949$export$3e51e8f1440314ba = '#EBECF0';
var $d3548cd244c57949$export$1ce2d1575d444ceb = '#DFE1E6';
var $d3548cd244c57949$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d3548cd244c57949$export$c2e91cbeada39b8b = '#B3BAC5';
var $d3548cd244c57949$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d3548cd244c57949$export$eaa8c8a70ac22806 = '#97A0AF';
var $d3548cd244c57949$export$7c87d337fb91a97d = '#8993A4';
var $d3548cd244c57949$export$d6447c357493214f = '#7A869A';
var $d3548cd244c57949$export$f563ee71e9ee74cd = '#6B778C';
var $d3548cd244c57949$export$e2ef2124cf4024b1 = '#5E6C84';
var $d3548cd244c57949$export$eece5f492e429f08 = '#505F79';
var $d3548cd244c57949$export$c39c0fe0f26207ae = '#42526E';
var $d3548cd244c57949$export$7090862dc3038a9f = '#344563';
var $d3548cd244c57949$export$ad0bacf983b7ddaa = '#253858';
var $d3548cd244c57949$export$7d61b15e0da132af = '#172B4D';
var $d3548cd244c57949$export$fbda843f0a27fe96 = '#091E42';
var $d3548cd244c57949$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d3548cd244c57949$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d3548cd244c57949$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d3548cd244c57949$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d3548cd244c57949$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d3548cd244c57949$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d3548cd244c57949$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d3548cd244c57949$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d3548cd244c57949$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d3548cd244c57949$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d3548cd244c57949$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d3548cd244c57949$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d3548cd244c57949$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d3548cd244c57949$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d3548cd244c57949$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d3548cd244c57949$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d3548cd244c57949$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d3548cd244c57949$export$2f6319cf7d736c2a = '#E6EDFA';
var $d3548cd244c57949$export$95126bc8884d6634 = '#DCE5F5';
var $d3548cd244c57949$export$8338d8c35d44ff1 = '#CED9EB';
var $d3548cd244c57949$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d3548cd244c57949$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d3548cd244c57949$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d3548cd244c57949$export$97e81faa16a182c7 = '#8C9CB8';
var $d3548cd244c57949$export$bfe21c59123ecf33 = '#7988A3';
var $d3548cd244c57949$export$ee82aa2ea6a1558 = '#67758F';
var $d3548cd244c57949$export$682927c6ed76be02 = '#56637A';
var $d3548cd244c57949$export$91fd9994c5be9757 = '#455166';
var $d3548cd244c57949$export$d281fbfe3cff2df6 = '#3B475C';
var $d3548cd244c57949$export$3902c91d8b98a753 = '#313D52';
var $d3548cd244c57949$export$8e8133c1ba5845b5 = '#283447';
var $d3548cd244c57949$export$33ff357f6620b39 = '#202B3D';
var $d3548cd244c57949$export$633847cf062b69e0 = '#1B2638';
var $d3548cd244c57949$export$9776a6e503bdbf76 = '#121A29';
var $d3548cd244c57949$export$6c813d5160dff5db = '#0E1624';
var $d3548cd244c57949$export$3d4f271a500072a = '#0D1424';
var $d3548cd244c57949$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d3548cd244c57949$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d3548cd244c57949$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d3548cd244c57949$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d3548cd244c57949$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d3548cd244c57949$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d3548cd244c57949$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d3548cd244c57949$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d3548cd244c57949$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d3548cd244c57949$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d3548cd244c57949$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d3548cd244c57949$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d3548cd244c57949$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d3548cd244c57949$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d3548cd244c57949$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d3548cd244c57949$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d3548cd244c57949$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d3548cd244c57949$export$8ce1fd94bee2f412 = (0, $fSBjK.default)({
    light: "var(--ds-surface, ".concat($d3548cd244c57949$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($d3548cd244c57949$export$633847cf062b69e0, ")")
});
var $d3548cd244c57949$export$b861914ea877b580 = (0, $fSBjK.default)({
    light: "var(--ds-background-selected, ".concat($d3548cd244c57949$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($d3548cd244c57949$export$8c13c2ee36917869, ")")
});
var $d3548cd244c57949$export$3f1b020df94387af = (0, $fSBjK.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($d3548cd244c57949$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($d3548cd244c57949$export$d281fbfe3cff2df6, ")")
});
var $d3548cd244c57949$export$c0183dbab98ca63e = (0, $fSBjK.default)({
    light: "var(--ds-surface-overlay, ".concat($d3548cd244c57949$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($d3548cd244c57949$export$8e8133c1ba5845b5, ")")
});
var $d3548cd244c57949$export$6f093cfa640b7166 = (0, $fSBjK.default)({
    light: "var(--ds-text, ".concat($d3548cd244c57949$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($d3548cd244c57949$export$5368d76ae4fbbda7, ")")
});
var $d3548cd244c57949$export$42f8e9c698766e7a = (0, $fSBjK.default)({
    light: "var(--ds-text, ".concat($d3548cd244c57949$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d3548cd244c57949$export$5368d76ae4fbbda7, ")")
});
var $d3548cd244c57949$export$c2d157ca1c34b6e3 = (0, $fSBjK.default)({
    light: "var(--ds-text-selected, ".concat($d3548cd244c57949$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($d3548cd244c57949$export$b3de0ae08da2ce64, ")")
});
var $d3548cd244c57949$export$1905ba28d7cf066f = (0, $fSBjK.default)({
    light: "var(--ds-text-subtlest, ".concat($d3548cd244c57949$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d3548cd244c57949$export$97e81faa16a182c7, ")")
});
var $d3548cd244c57949$export$bd9002130d306d39 = (0, $fSBjK.default)({
    light: "var(--ds-text-subtlest, ".concat($d3548cd244c57949$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d3548cd244c57949$export$bfe21c59123ecf33, ")")
});
var $d3548cd244c57949$export$46e4a324ac90507f = (0, $fSBjK.default)({
    light: "var(--ds-text, ".concat($d3548cd244c57949$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d3548cd244c57949$export$5368d76ae4fbbda7, ")")
});
var $d3548cd244c57949$export$79f3f2b82beb0d36 = (0, $fSBjK.default)({
    light: "var(--ds-text-subtlest, ".concat($d3548cd244c57949$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d3548cd244c57949$export$97e81faa16a182c7, ")")
});
var $d3548cd244c57949$export$7bb0d5c671655cc4 = (0, $fSBjK.default)({
    light: $d3548cd244c57949$export$9fdfb749e33cdf97,
    dark: $d3548cd244c57949$export$8e8133c1ba5845b5
});
var $d3548cd244c57949$export$9c30223ca0a664fb = (0, $fSBjK.default)({
    light: "var(--ds-link, ".concat($d3548cd244c57949$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($d3548cd244c57949$export$ecfc1dff386a3e7a, ")")
});
var $d3548cd244c57949$export$7ed258b0728b004b = (0, $fSBjK.default)({
    light: "var(--ds-link-pressed, ".concat($d3548cd244c57949$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($d3548cd244c57949$export$215b7063051591f1, ")")
});
var $d3548cd244c57949$export$dfa920d8decc8a59 = (0, $fSBjK.default)({
    light: "var(--ds-link-pressed, ".concat($d3548cd244c57949$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($d3548cd244c57949$export$ecfc1dff386a3e7a, ")")
});
var $d3548cd244c57949$export$6069e6ad5c78f632 = (0, $fSBjK.default)({
    light: "var(--ds-border-focused, ".concat($d3548cd244c57949$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($d3548cd244c57949$export$215b7063051591f1, ")")
});
var $d3548cd244c57949$export$9ad721cf3b3debe0 = (0, $fSBjK.default)({
    light: "var(--ds-background-brand-bold, ".concat($d3548cd244c57949$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($d3548cd244c57949$export$ecfc1dff386a3e7a, ")")
});
var $d3548cd244c57949$export$2aa0182783e7e9de = (0, $fSBjK.default)({
    light: $d3548cd244c57949$export$b3de0ae08da2ce64,
    dark: $d3548cd244c57949$export$ecfc1dff386a3e7a
});
var $d3548cd244c57949$export$8bf7dff220b82b4a = (0, $fSBjK.default)({
    light: $d3548cd244c57949$export$9dc1ef0f3f48059b,
    dark: $d3548cd244c57949$export$69cb3ca10c1e330e
});
var $d3548cd244c57949$export$e13cce2a2d16a9d4 = (0, $fSBjK.default)({
    light: $d3548cd244c57949$export$b48405b95304b5a1,
    dark: $d3548cd244c57949$export$6011520a64d9a187
});
var $d3548cd244c57949$export$a90204d1394caf30 = (0, $fSBjK.default)({
    light: $d3548cd244c57949$export$4a7404f376229999,
    dark: $d3548cd244c57949$export$4a7404f376229999
});
var $d3548cd244c57949$export$594c5a8758200c32 = (0, $fSBjK.default)({
    light: $d3548cd244c57949$export$c6930421db9fa514,
    dark: $d3548cd244c57949$export$c6930421db9fa514
});
var $d3548cd244c57949$export$955a2ebd2fb142ae = (0, $fSBjK.default)({
    light: $d3548cd244c57949$export$940e1f69e873f202,
    dark: $d3548cd244c57949$export$940e1f69e873f202
});
var $d3548cd244c57949$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($d3548cd244c57949$export$8d43898f60b96a82, ")");
};

});
parcelRegister("fSBjK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8f8d8a725c12cdf$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $hkY3F = parcelRequire("hkY3F");
// Unpack custom variants, and get correct value for the current theme
function $b8f8d8a725c12cdf$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $hkY3F.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $b8f8d8a725c12cdf$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $b8f8d8a725c12cdf$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $hkY3F.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("hkY3F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c9f2e432f4afda1a$export$2e2bcd8739ae039; });

var $bwqrv = parcelRequire("bwqrv");
function $c9f2e432f4afda1a$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $bwqrv.CHANNEL) in props.theme) return props.theme[0, $bwqrv.CHANNEL];
        else if ('mode' in props.theme && (0, $bwqrv.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $bwqrv.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("bwqrv", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $863731d5445341aa$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $863731d5445341aa$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $863731d5445341aa$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "fontFamily", function () { return $863731d5445341aa$export$a5975749f0374264; });

var $kxLmE = parcelRequire("kxLmE");

var $i8Ub0 = parcelRequire("i8Ub0");
var $863731d5445341aa$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $863731d5445341aa$export$c93026a968943f95 = 'light';
var $863731d5445341aa$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $863731d5445341aa$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $863731d5445341aa$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $863731d5445341aa$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $863731d5445341aa$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $863731d5445341aa$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $863731d5445341aa$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $863731d5445341aa$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $i8Ub0.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $863731d5445341aa$export$6d8204c2cb2e06b8() / 4;
    (0, $kxLmE.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $863731d5445341aa$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $863731d5445341aa$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $863731d5445341aa$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $kxLmE.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $863731d5445341aa$export$ba1d834b86d72a09 = $863731d5445341aa$export$a1b3edb637fb4f35;
var $863731d5445341aa$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $i8Ub0.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $i8Ub0.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $i8Ub0.N30A), ")")
            }
        }
    };
};

});
parcelRegister("kxLmE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef4ba14a26672898$export$2e2bcd8739ae039; });

var $7sg27 = parcelRequire("7sg27");

var $7t0tI = parcelRequire("7t0tI");
function $ef4ba14a26672898$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $7sg27.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $ef4ba14a26672898$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("7sg27", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $56d795c23a2813d8$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $56d795c23a2813d8$var$printed = {};
function $56d795c23a2813d8$export$2e2bcd8739ae039(message) {
    if ($56d795c23a2813d8$var$printed[message]) return;
    $56d795c23a2813d8$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("bpK89", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $84f5d00d024b6b08$export$2e2bcd8739ae039; });

var $i8mSD = parcelRequire("i8mSD");
// Create default global light theme
var $84f5d00d024b6b08$var$_createTheme = (0, $i8mSD.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $84f5d00d024b6b08$var$Provider = $84f5d00d024b6b08$var$_createTheme.Provider, $84f5d00d024b6b08$var$Consumer = $84f5d00d024b6b08$var$_createTheme.Consumer, $84f5d00d024b6b08$export$7692396083754928 = $84f5d00d024b6b08$var$_createTheme.useTheme;
var $84f5d00d024b6b08$export$2e2bcd8739ae039 = {
    Provider: $84f5d00d024b6b08$var$Provider,
    Consumer: $84f5d00d024b6b08$var$Consumer
};

});
parcelRegister("i8mSD", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $d33ab8e50a44fc40$export$25d302a5b900a763; });

var $iaORU = parcelRequire("iaORU");

var $1oC0p = parcelRequire("1oC0p");
var $d33ab8e50a44fc40$var$_excluded = [
    "children"
];
function $d33ab8e50a44fc40$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $iaORU.default)(props, $d33ab8e50a44fc40$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("ktBlO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ee837d29e288eed0$export$2e2bcd8739ae039; });

var $6dqAn = parcelRequire("6dqAn");

var $i8Ub0 = parcelRequire("i8Ub0");
var $ee837d29e288eed0$var$radioThemeColors = {
    light: {
        background: "var(--ds-background-input, ".concat((0, $i8Ub0.N10), ")"),
        backgroundHover: "var(--ds-background-input-hovered, ".concat((0, $i8Ub0.N30), ")"),
        backgroundActive: "var(--ds-background-input-pressed, ".concat((0, $i8Ub0.N30), ")"),
        backgroundChecked: "var(--ds-background-selected-bold, ".concat((0, $i8Ub0.B400), ")"),
        backgroundCheckedHover: "var(--ds-background-selected-bold-hovered, ".concat((0, $i8Ub0.B300), ")"),
        backgroundCheckedActive: "var(--ds-background-selected-bold-pressed, ".concat((0, $i8Ub0.B50), ")"),
        backgroundDisabled: "var(--ds-background-disabled, ".concat((0, $i8Ub0.N20), ")"),
        dotChecked: "var(--ds-icon-inverse, ".concat((0, $i8Ub0.N10), ")"),
        dotDisabled: "var(--ds-icon-disabled, ".concat((0, $i8Ub0.N70), ")"),
        dotActive: "var(--ds-icon-inverse, ".concat((0, $i8Ub0.B400), ")"),
        border: (0, $6dqAn.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $i8Ub0.N100), ")") : "var(--ds-border-input, ".concat((0, $i8Ub0.N40), ")"),
        borderHover: (0, $6dqAn.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $i8Ub0.N100), ")") : "var(--ds-border-input, ".concat((0, $i8Ub0.N40), ")"),
        borderDisabled: "var(--ds-border-disabled, ".concat((0, $i8Ub0.N20), ")"),
        borderFocus: "var(--ds-border-focused, ".concat((0, $i8Ub0.B100), ")")
    },
    dark: {
        background: "var(--ds-background-input, ".concat((0, $i8Ub0.DN10), ")"),
        backgroundHover: "var(--ds-background-input-hovered, ".concat((0, $i8Ub0.DN30), ")"),
        backgroundActive: "var(--ds-background-input-pressed, ".concat((0, $i8Ub0.B200), ")"),
        backgroundChecked: "var(--ds-background-selected-bold, ".concat((0, $i8Ub0.B400), ")"),
        backgroundCheckedHover: "var(--ds-background-selected-bold-hovered, ".concat((0, $i8Ub0.B75), ")"),
        backgroundCheckedActive: "var(--ds-background-selected-bold-pressed, ".concat((0, $i8Ub0.B200), ")"),
        backgroundDisabled: "var(--ds-background-disabled, ".concat((0, $i8Ub0.DN10), ")"),
        dotChecked: "var(--ds-icon-inverse, ".concat((0, $i8Ub0.DN10), ")"),
        dotDisabled: "var(--ds-icon-disabled, ".concat((0, $i8Ub0.DN90), ")"),
        dotActive: "var(--ds-icon-inverse, ".concat((0, $i8Ub0.DN10), ")"),
        border: (0, $6dqAn.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $i8Ub0.DN200), ")") : "var(--ds-border-input, ".concat((0, $i8Ub0.DN80), ")"),
        borderHover: "var(--ds-border-input, ".concat((0, $i8Ub0.DN200), ")"),
        borderDisabled: "var(--ds-border-disabled, ".concat((0, $i8Ub0.DN10), ")"),
        borderFocus: "var(--ds-border-focused, ".concat((0, $i8Ub0.B75), ")")
    }
};
function $ee837d29e288eed0$export$2e2bcd8739ae039(mode) {
    var radioColors = $ee837d29e288eed0$var$radioThemeColors[mode];
    return {
        '--local-background': radioColors.background,
        '--local-background-active': radioColors.backgroundActive,
        '--local-background-checked': radioColors.backgroundChecked,
        '--local-background-checked-active': radioColors.backgroundCheckedActive,
        '--local-background-checked-hover': radioColors.backgroundCheckedHover,
        '--local-background-disabled': radioColors.backgroundDisabled,
        '--local-background-hover': radioColors.backgroundHover,
        '--local-border': radioColors.border,
        '--local-border-disabled': radioColors.borderDisabled,
        '--local-border-hover': radioColors.borderHover,
        '--local-border-focus': radioColors.borderFocus,
        '--local-dot-active': radioColors.dotActive,
        '--local-dot-checked': radioColors.dotChecked,
        '--local-dot-disabled': radioColors.dotDisabled,
        '--local-invalid': "var(--ds-icon-danger, ".concat((0, $i8Ub0.R300), ")")
    };
}

});








parcelRegister("iLjCW", function(module, exports) {
$parcel$export(module.exports, "GlobalFooter", function () { return $13b67f470c9a1c72$export$4bf04f8af9c4c55; });
/* global-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $ele2K = parcelRequire("ele2K");

var $kqVCv = parcelRequire("kqVCv");
const $13b67f470c9a1c72$var$globalFooterStyle = null;
const $13b67f470c9a1c72$var$globalFooterDarkThemeStyle = null;
const $13b67f470c9a1c72$var$globalFooterContentContainerStyle = null;
const $13b67f470c9a1c72$var$globalFooterContentContainerDarkThemeStyle = null;
const $13b67f470c9a1c72$export$4bf04f8af9c4c55 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "global-footer-v2",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _11q71afi _1e0c1txw _2lx2vrvc _1bah1h6o",
                isDarkTheme && "_11q7k553"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
                "--_19gw9o2": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark100'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1afi _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb",
                    isDarkTheme && "_bfhk1j28"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kqVCv.GlobalFooterTop), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ele2K.GlobalFooterBottom), {
                        selectedLanguage: selectedLanguage,
                        onLanguageChangeHandler: onLanguageChangeHandler
                    })
                ]
            })
        })
    });
};

});
parcelRegister("ele2K", function(module, exports) {
$parcel$export(module.exports, "GlobalFooterBottom", function () { return $c6f717578a63cbc4$export$8eb5df03385c4090; });
/* global-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $aKcYL = parcelRequire("aKcYL");

var $e3HD6 = parcelRequire("e3HD6");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");
// ==================================================================
// CSS styling
// ==================================================================
const $c6f717578a63cbc4$var$containerStyle = null;
const $c6f717578a63cbc4$var$linkStyle = null;
const $c6f717578a63cbc4$var$linkDarkThemeStyle = null;
const $c6f717578a63cbc4$var$copyrightStyle = null;
const $c6f717578a63cbc4$var$copyrightDarkThemeStyle = null;
const $c6f717578a63cbc4$var$linksAndLanguageStyle = null;
const $c6f717578a63cbc4$var$listStyle = null;
const $c6f717578a63cbc4$var$listDarkThemeStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
const $c6f717578a63cbc4$var$BottomLinks = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const intl = (0, $8e22h.default)();
    (0, $1oC0p.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (window?.AtlOneTrustWrapper?.updatePolicyLinks) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.AtlOneTrustWrapper.updatePolicyLinks();
    }, []);
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: 'globalfooterv2.bottom.privacy-policy',
                defaultMessage: 'Privacy policy'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy'),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: 'globalFooterv2.bottom.notice-at-collection',
                defaultMessage: 'Notice at Collection'
            }),
            // eslint-disable-next-line local/ensure-wac-token-usage
            href: '/legal/privacy-policy#additional-disclosures-for-ca-residents',
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: 'globalfooterv2.bottom.terms',
                defaultMessage: 'Terms'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/cloud-terms-of-service'),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: 'globalfooterv2.bottom.impressum',
                defaultMessage: 'Impressum'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/legal/impressum'),
            isOneTrustWrapped: false
        }
    ];
    return bottomLinks.map((bottomLink)=>{
        if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            className: 'link-wrapper atl-policy-link-container',
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e3HD6.LinkWithIcon), {
                linkText: bottomLink.text,
                href: bottomLink.href,
                type: "anchor",
                isHaveIcon: false,
                isUsePlainSpanTagForLinkText: true,
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1pfd _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                    'atl-policy-link'
                ]),
                spanLinkTextClassName: 'atl-policy-link-text',
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                }
            })
        }, bottomLink.text);
        else return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                text: bottomLink.text,
                href: bottomLink.href,
                type: "anchor",
                bgColor: isDarkTheme ? 'bgBlackBlue' : 'bgColored',
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1pfd _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                    isDarkTheme && "_syaz1141"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                }
            })
        }, bottomLink.text);
    });
};
const $c6f717578a63cbc4$var$copyRightYear = new Date().getFullYear();
const $c6f717578a63cbc4$var$containerStyles = null;
const $c6f717578a63cbc4$var$containerDarkThemeStyles = null;
const $c6f717578a63cbc4$var$labelStyles = null;
const $c6f717578a63cbc4$var$arrowStyles = null;
const $c6f717578a63cbc4$var$SelectorFallback = ({ selectedLanguage: selectedLanguage })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const intl = (0, $8e22h.default)();
    if (!selectedLanguage) selectedLanguage = intl.locale || 'en';
    const languageLabel = (0, $aKcYL.languages).find((lang)=>lang.value === selectedLanguage)?.label;
    const globeColor = isDarkTheme ? (0, $bNzAT.default)('color.neutral.light0') : '#42526e';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_syazvwuj _80omtlke _1e0c116y _4cvr1h6o",
            isDarkTheme && "_syaz1afi"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKcYL.LanguageGlobeIcon), {
                color: globeColor
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ahbq1b66 _1wyboxwj"
                ]),
                children: languageLabel
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_ahbq1b66 _1wyb1k8s"
                ]),
                children: "\u25BE"
            })
        ]
    });
};

const $c6f717578a63cbc4$var$LanguageSelectorLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(()=>(parcelRequire("ebGgc")).then(({ LanguageSelector: LanguageSelector })=>({
            default: LanguageSelector
        })).catch((error)=>{
        console.error(error);
        return {
            default: $c6f717578a63cbc4$var$SelectorFallback
        };
    }));
const $c6f717578a63cbc4$export$8eb5df03385c4090 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler, className: className })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const [isClient, setIsClient] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        setIsClient(true);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-v2-bottom",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $2jatx.default)([
                        "_syaz1qc2 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o",
                        isDarkTheme && "_syaz89wr"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light800')),
                        "--_3dffxf": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark800'))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $c6f717578a63cbc4$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
                            name: "global-footer-v2-bottom-links",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                className: (0, $2jatx.default)([
                                    "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o _1g451qgu _40h8yh40",
                                    isDarkTheme && "_1vjw1afi _43ds1141 _90151141 _1i3i1okz _13tc1okz _oxk41141 _1rmw1141"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
                                    "--_1hwkv7u": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1100'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6f717578a63cbc4$var$BottomLinks, {})
                            })
                        }),
                        isClient ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                            fallback: /*#__PURE__*/ (0, $7VQPk.jsx)($c6f717578a63cbc4$var$SelectorFallback, {
                                selectedLanguage: selectedLanguage
                            }),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6f717578a63cbc4$var$LanguageSelectorLazy, {
                                selectedLanguage: selectedLanguage,
                                onLanguageChangeHandler: onLanguageChangeHandler
                            })
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)($c6f717578a63cbc4$var$SelectorFallback, {
                            selectedLanguage: selectedLanguage
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("g1rTV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $baa261e43a407e47$export$2e2bcd8739ae039; });

var $jmcwM = parcelRequire("jmcwM");
var $baa261e43a407e47$export$2e2bcd8739ae039 = (0, $jmcwM.default);

});
parcelRegister("jmcwM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e179ca288361de98$export$2e2bcd8739ae039; });

var $kOzMB = parcelRequire("kOzMB");

var $gNkVH = parcelRequire("gNkVH");

var $1oC0p = parcelRequire("1oC0p");

var $iqOwP = parcelRequire("iqOwP");
function $e179ca288361de98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e179ca288361de98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e179ca288361de98$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e179ca288361de98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Annotate part of the react tree with a product name
 * ```
 * <UFOLabel name="card">
 *   <Card card={data} />
 * </UFOLabel>
 * ```
 */ var $e179ca288361de98$var$UFOLabel = function UFOLabel(_ref) {
    var name = _ref.name, children = _ref.children;
    var context = (0, $iqOwP.useInteractionContext)();
    var newContext = (0, $1oC0p.useMemo)(function() {
        if (context) return $e179ca288361de98$var$_objectSpread($e179ca288361de98$var$_objectSpread({}, context), {}, {
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [].concat((0, $kOzMB.default)(context.labelStack), [
                {
                    name: name
                }
            ])
        });
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iqOwP.default).Provider, {
        value: newContext
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
};
$e179ca288361de98$var$UFOLabel.displayName = 'UFOLabel';
var $e179ca288361de98$export$2e2bcd8739ae039 = $e179ca288361de98$var$UFOLabel;

});


parcelRegister("aKcYL", function(module, exports) {
$parcel$export(module.exports, "languages", function () { return $b2f263de047f7383$export$d0d68bb9ed2c643d; });
$parcel$export(module.exports, "LanguageGlobeIcon", function () { return $b2f263de047f7383$export$a7259a7df7627186; });

var $7VQPk = parcelRequire("7VQPk");
const $b2f263de047f7383$export$d0d68bb9ed2c643d = [
    {
        label: 'Deutsch',
        value: 'de'
    },
    {
        label: 'English',
        value: 'en'
    },
    {
        label: "Espa\xf1ol",
        value: 'es'
    },
    {
        label: "Fran\xe7ais",
        value: 'fr'
    },
    {
        label: 'Italiano',
        value: 'it'
    },
    {
        label: "\uD55C\uAD6D\uC5B4",
        value: 'ko'
    },
    {
        label: 'Nederlands',
        value: 'nl'
    },
    {
        label: "\u65E5\u672C\u8A9E",
        value: 'ja'
    },
    {
        label: 'Polski',
        value: 'pl'
    },
    {
        label: "Portugu\xeas",
        value: 'br'
    },
    {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439",
        value: 'ru'
    },
    {
        label: "\u4E2D\u6587",
        value: 'zh'
    }
];
const $b2f263de047f7383$export$a7259a7df7627186 = ({ color: color })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        id: "icon-wac-language-globe",
        "aria-hidden": "true",
        width: "18px",
        height: "18px",
        viewBox: "0 0 25 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M2.33514634,13.0909091 C2.80456741,17.1674997 5.87382928,20.4918664 9.91593939,21.5020963 C8.18760918,19.0069673 7.13798566,16.119686 6.87807529,13.0909091 L2.33514634,13.0909091 Z M2.33514634,10.9090909 L6.8751035,10.9090909 C7.12988231,7.89470494 8.18079774,5.00118821 9.91557751,2.49799419 C5.87364609,3.50833206 2.8045534,6.83262197 2.33514634,10.9090909 Z M22.6648537,10.9090909 C22.1954326,6.83250032 19.1261707,3.50813364 15.0840606,2.49790374 C16.8123908,4.99303266 17.8620143,7.88031403 18.1219247,10.9090909 L22.6648537,10.9090909 Z M22.6648537,13.0909091 L18.1248965,13.0909091 C17.8701177,16.1052951 16.8192023,18.9988118 15.0844225,21.5020058 C19.1263539,20.4916679 22.1954466,17.167378 22.6648537,13.0909091 Z M9.15315078,10.9090909 L15.843646,10.9090909 C15.5581939,7.94925479 14.3973512,5.12935736 12.4999751,2.78265622 C10.595448,5.13778492 9.43302782,7.96652031 9.15315078,10.9090909 Z M15.8468492,13.0909091 L9.15635402,13.0909091 C9.44180608,16.0507452 10.6026488,18.8706426 12.5000249,21.2173438 C14.404552,18.8622151 15.5669722,16.0334797 15.8468492,13.0909091 Z M12.5,24 C5.59644063,24 0,18.627417 0,12 C0,5.372583 5.59644063,0 12.5,0 C19.4035594,0 25,5.372583 25,12 C25,18.627417 19.4035594,24 12.5,24 Z",
                    id: "path-1"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Final-Designs-",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                    id: "WAC-Language-Banner-Drop-Down-Icon",
                    transform: "translate(-426.000000, -19.000000)",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        id: "Alert-banner",
                        transform: "translate(-4.000000, 0.000000)",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                            id: "language-globe-icon",
                            transform: "translate(430.000000, 19.000000)",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("mask", {
                                    id: "mask-2",
                                    fill: '#ffffff',
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("use", {
                                        xlinkHref: "#path-1"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                    id: "language-globe-icon-color",
                                    mask: "url(#mask-2)",
                                    fill: color,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                        transform: "translate(-1.000000, -1.000000)",
                                        id: "Rectangle",
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                                            x: "0",
                                            y: "0",
                                            width: "27.2727273",
                                            height: "26.4827586"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });

});

parcelRegister("e3HD6", function(module, exports) {
$parcel$export(module.exports, "LinkWithIcon", function () { return $45f09ea7f03b9e3c$export$e67e718b4b9e91b1; });
/* link-with-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $OKl9V = parcelRequire("OKl9V");
const $45f09ea7f03b9e3c$var$linkWithIconStyle = null;
const $45f09ea7f03b9e3c$var$linkIsUsePlainSpanTagForLinkTextClassStyle = null;
/**
 * Return a xs gray icon via iconNAme and linkText. This is specifically used for Global Nav header
 * This is not a WPL approved component, it's an one off. Do not use this anywhere else other than global nav
 * @param formatLinkTextProps
 * @returns
 */ const $45f09ea7f03b9e3c$var$formatLinkText = ({ isHaveIcon: isHaveIcon, isCustomIcon: isCustomIcon, iconName: iconName, linkText: linkText })=>{
    const formatLinkStyles = [
        isHaveIcon && null,
        !isHaveIcon && null,
        null
    ];
    const linkIconDivStyle = null;
    const linkTextStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            isHaveIcon && "_6rthv47k",
            !isHaveIcon && "_6rth14y2",
            "_lcxvglyw _1e0c1txw _4cvr1h6o"
        ]),
        children: [
            isHaveIcon && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3iv47k _1bsb1ul9 _1752v47k"
                ]),
                children: isCustomIcon ? iconName : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                    name: iconName,
                    size: 'xs',
                    color: 'n500'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1wybpxbi _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: linkText
            })
        ]
    });
};
const $45f09ea7f03b9e3c$export$e67e718b4b9e91b1 = ({ href: href, type: type, onClick: onClick, className: className, isHaveIcon: isHaveIcon, isCustomIcon: isCustomIcon, iconName: iconName, linkText: linkText, dataEventContainer: dataEventContainer, dataEventColumn: dataEventColumn, isUsePlainSpanTagForLinkText: isUsePlainSpanTagForLinkText = false, spanLinkTextClassName: spanLinkTextClassName })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        className: (0, $2jatx.default)([
            isUsePlainSpanTagForLinkText && "_4cvr1h6o _syazvwuj _4t3i1ou6 _1e0c116y _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw _1axpoelr _aelyoelr _pb8z1ltp _kj55u7gi _12lvu7gi _4bfu1r31 _1hmsglyw _ajmmnqa1 _11cgyh40",
            !isUsePlainSpanTagForLinkText && "_4cvr1h6o _syazvwuj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _30l3oelr _1up4glyw _16btglyw _1taiglyw _1e0c1ule _s7n4nkob _1axpvwuj _aelyvwuj",
            className
        ]),
        href: href,
        target: type === 'external' ? '_blank' : '',
        rel: type === 'external' ? 'noreferrer' : '',
        onClick: onClick,
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": dataEventContainer,
        "data-event-column": dataEventColumn,
        children: isUsePlainSpanTagForLinkText ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: spanLinkTextClassName,
            children: linkText
        }) : $45f09ea7f03b9e3c$var$formatLinkText({
            isHaveIcon: isHaveIcon,
            isCustomIcon: isCustomIcon,
            iconName: iconName,
            linkText: linkText
        })
    });
};

});
parcelRegister("OKl9V", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $5759bb31fbd7c46d$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $4zKhX = parcelRequire("4zKhX");

var $czBqu = parcelRequire("czBqu");

var $6tOY7 = parcelRequire("6tOY7");

var $3js76 = parcelRequire("3js76");

var $1KfY5 = parcelRequire("1KfY5");

var $dE0sS = parcelRequire("dE0sS");

var $kBlGf = parcelRequire("kBlGf");

var $f83zp = parcelRequire("f83zp");

var $4wteY = parcelRequire("4wteY");

var $4s6uD = parcelRequire("4s6uD");

var $4bavV = parcelRequire("4bavV");

var $dnK9X = parcelRequire("dnK9X");

var $dUFe3 = parcelRequire("dUFe3");

var $1veg3 = parcelRequire("1veg3");

var $lrxO9 = parcelRequire("lrxO9");

var $da5RG = parcelRequire("da5RG");

var $37jWv = parcelRequire("37jWv");

var $cjyDN = parcelRequire("cjyDN");

var $akQBl = parcelRequire("akQBl");

var $cgQdI = parcelRequire("cgQdI");

var $hHs95 = parcelRequire("hHs95");

var $8lpFI = parcelRequire("8lpFI");

var $bLP3d = parcelRequire("bLP3d");

var $8yCrk = parcelRequire("8yCrk");

var $fU9OW = parcelRequire("fU9OW");

var $9JxMI = parcelRequire("9JxMI");

var $2jNpj = parcelRequire("2jNpj");

var $cB2FD = parcelRequire("cB2FD");

var $Ya8xu = parcelRequire("Ya8xu");

var $9BX4N = parcelRequire("9BX4N");

var $5YeNo = parcelRequire("5YeNo");

var $8UbMK = parcelRequire("8UbMK");

var $e6y3D = parcelRequire("e6y3D");

var $7Zvff = parcelRequire("7Zvff");

var $1oEP4 = parcelRequire("1oEP4");

var $8tj4l = parcelRequire("8tj4l");

var $03v16 = parcelRequire("03v16");

var $hdGAb = parcelRequire("hdGAb");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5759bb31fbd7c46d$var$IconNames = [
    'adduser',
    'longhair',
    'caret',
    'checkmarkbasic',
    'checkmark',
    'checkmarkcircle',
    'featurecheckmark',
    'circleunions',
    'cross',
    'no',
    'diagramorgchart',
    'maximize',
    'pagemultiple',
    'bold',
    'building',
    'puzzlepiece',
    'securitycheckmark',
    'lightbulb',
    'locationpin',
    'lock',
    'video',
    'wrench',
    'cloudcheckmark',
    'datacenter',
    'accelerator',
    'team',
    'partners',
    'sparkle',
    'sparkle-ai',
    'lightning',
    'id',
    'info',
    'infocircle',
    'globe',
    'workflow',
    'foursquares',
    'openlock',
    'closedlock',
    'cog'
];
const $5759bb31fbd7c46d$var$IconSize = {
    xs: '24px',
    small: '32px',
    medium: '48px',
    large: '64px',
    default: '48px'
};
const $5759bb31fbd7c46d$var$basicStyle = null;
const $5759bb31fbd7c46d$export$aa4d92373c6fc66f = (name, size = 'default', color)=>{
    const iconSize = $5759bb31fbd7c46d$var$IconSize[size];
    switch(name){
        // avatar
        case 'adduser':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4zKhX.AddUser), {
                size: iconSize
            });
        case 'longhair':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $czBqu.LongHair), {
                size: iconSize
            });
        // basic
        case 'caret':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6tOY7.CaretIcon), {});
        case 'checkmarkbasic':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3js76.Checkmark), {
                size: iconSize
            });
        case 'checkmarkcircle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1KfY5.CheckmarkCircle), {
                size: iconSize
            });
        case 'featurecheckmark':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kBlGf.FeatureCheckmark), {
                size: iconSize
            });
        case 'cross':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                size: iconSize,
                color: color
            });
        case 'no':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4wteY.No), {
                size: iconSize
            });
        case 'infocircle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f83zp.InfoCircle), {
                size: iconSize
            });
        // content
        case 'checkmark':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dnK9X.Checkmark), {
                size: iconSize
            });
        case 'diagramorgchart':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dUFe3.DiagramOrgChart), {
                size: iconSize
            });
        case 'maximize':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lrxO9.Maximize), {
                size: iconSize
            });
        case 'pagemultiple':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $da5RG.PageMultiple), {
                size: iconSize
            });
        // object
        case 'bold':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hHs95.Bold), {
                size: iconSize
            });
        case 'building':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8lpFI.Building), {
                size: iconSize
            });
        case 'circleunions':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bLP3d.CircleUnions), {
                size: iconSize
            });
        case 'id':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2jNpj.Id), {
                size: iconSize
            });
        case 'puzzlepiece':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8UbMK.PuzzlePiece), {
                size: iconSize
            });
        case 'securitycheckmark':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e6y3D.SecurityCheckmark), {
                size: iconSize
            });
        case 'lightbulb':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cB2FD.Lightbulb), {
                size: iconSize
            });
        case 'locationpin':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Ya8xu.LocationPin), {
                size: iconSize
            });
        case 'lock':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9BX4N.Lock), {
                size: iconSize
            });
        case 'video':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Zvff.Video), {
                size: iconSize
            });
        case 'wrench':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8tj4l.Wrench), {
                size: iconSize
            });
        case 'accelerator':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4bavV.Accelerator), {
                size: iconSize
            });
        case 'team':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cgQdI.Team), {
                size: iconSize
            });
        case 'partners':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $37jWv.Partners), {
                size: iconSize
            });
        case 'sparkle':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cjyDN.Sparkle), {
                size: iconSize
            });
        case 'sparkle-ai':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $akQBl.SparkleAI), {
                size: iconSize
            });
        case 'lightning':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1veg3.Lightning), {
                size: iconSize
            });
        case 'globe':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9JxMI.Globe), {
                size: iconSize
            });
        case 'workflow':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oEP4.Workflow), {
                size: iconSize
            });
        case 'foursquares':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fU9OW.FourSquares), {
                size: iconSize
            });
        case 'openlock':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YeNo.OpenLock), {
                size: iconSize
            });
        case 'closedlock':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4s6uD.ClosedLock), {
                size: iconSize
            });
        case 'cog':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8yCrk.Cog), {
                size: iconSize
            });
        // software
        case 'cloudcheckmark':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $03v16.CloudCheckmark), {
                size: iconSize
            });
        case 'datacenter':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hdGAb.DataCenter), {
                size: iconSize
            });
        default:
            return null;
    }
};
const $5759bb31fbd7c46d$export$f04a61298a47a40f = ({ name: name, size: size, color: color })=>{
    const iconColor = color;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_vwz4idpf",
            "icon"
        ]),
        style: {
            color: iconColor ? iconColor : 'inherit'
        },
        children: $5759bb31fbd7c46d$export$aa4d92373c6fc66f(name, size, iconColor)
    });
};

});
parcelRegister("4zKhX", function(module, exports) {
$parcel$export(module.exports, "AddUser", function () { return $e61d1998bf6592fd$export$a2fae8d9b81b1013; });

var $7VQPk = parcelRequire("7VQPk");
const $e61d1998bf6592fd$export$a2fae8d9b81b1013 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-avatar-add user",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M32.0518,0 C14.3786,0 0.0518,14.3269 0.0518,32 C0.0518,42.7687 5.371,52.295 13.5254,58.0948 L13.5254,55.9989 C13.5254,47.9763 20.0291,41.4726 28.0517,41.4726 L36.0517,41.4726 C39.9589,41.4726 43.5058,43.0152 46.1166,45.5246 C48.0215,43.7503 50.5765,42.6649 53.385,42.6649 C56.3337,42.6649 59.0029,43.8614 60.9337,45.7953 C62.9325,41.6181 64.0517,36.9398 64.0517,32 C64.0517,14.3269 49.7249,0 32.0518,0 Z M32.0518,16.7006 C26.1608,16.7006 21.3852,21.4762 21.3852,27.3673 C21.3852,33.2583 26.1608,38.0339 32.0518,38.0339 C37.9429,38.0339 42.7185,33.2583 42.7185,27.3673 C42.7185,21.4762 37.9429,16.7006 32.0518,16.7006 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        transform: "translate(42.000000, 42.000000)",
                        opacity: "0.5",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M11.3854,21.9974 C17.2765,21.9974 22.0521,17.2218 22.0521,11.3307 C22.0521,5.4397 17.2765,0.6641 11.3854,0.6641 C5.4944,0.6641 0.7188,5.4397 0.7188,11.3307 C0.7188,17.2218 5.4944,21.9974 11.3854,21.9974 Z M13.3506,16.2717 C13.3506,17.2018 12.5966,17.9559 11.6664,17.9559 C10.7695,17.9559 10.0363,17.2547 9.9851,16.3706 L9.9822,16.2717 L9.9822,12.9029 L6.6137,12.9029 C5.6836,12.9029 4.9295,12.1489 4.9295,11.2187 C4.9295,10.3218 5.6307,9.5886 6.5148,9.5374 L6.6137,9.5345 L9.9822,9.5345 L9.9822,6.1664 C9.9822,5.2362 10.7363,4.4822 11.6664,4.4822 C12.5634,4.4822 13.2965,5.1833 13.3478,6.0674 L13.3506,6.1664 L13.3506,9.5345 L16.719,9.5345 C17.6492,9.5345 18.4032,10.2886 18.4032,11.2187 C18.4032,12.1157 17.7021,12.8489 16.818,12.9001 L16.719,12.9029 L13.3506,12.9029 L13.3506,16.2717 Z"
                        })
                    })
                ]
            })
        })
    });

});

parcelRegister("czBqu", function(module, exports) {
$parcel$export(module.exports, "LongHair", function () { return $84d6f80248294092$export$c8fa71fb10453bb; });

var $7VQPk = parcelRequire("7VQPk");
const $84d6f80248294092$export$c8fa71fb10453bb = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-avatar-long hair",
        width: size,
        height: size,
        viewBox: "0 0 65 59",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M21.9824,27.925 C22.0571,33.752 26.8037,38.452 32.6482,38.452 C38.4927,38.452 43.2393,33.752 43.314,27.925 L40.8203,27.925 C40.2702,27.925 39.7523,27.666 39.4223,27.226 L37.0441,24.055 C36.8111,23.745 36.3451,23.745 36.1121,24.055 L33.7339,27.226 C33.4039,27.666 32.886,27.925 32.336,27.925 L21.9824,27.925 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M32.6484,0.416 C14.9753,0.416 0.6484,14.743 0.6484,32.416 C0.6484,43.185 5.9677,52.711 14.1222,58.511 L14.1222,56.417 C14.1222,48.394 20.6258,41.89 28.6485,41.89 L36.6485,41.89 C44.6711,41.89 51.1748,48.394 51.1748,56.417 L51.1748,58.511 C59.3292,52.711 64.6484,43.185 64.6484,32.416 C64.6484,14.743 50.3215,0.416 32.6484,0.416 Z M24.3598,21.07 C22.8728,22.903 21.9818,25.239 21.9818,27.784 C21.9818,33.675 26.7574,38.451 32.6485,38.451 C38.5395,38.451 43.3151,33.675 43.3151,27.784 C43.3151,21.893 38.5395,17.117 32.6485,17.117 C32.2004,17.117 31.7588,17.145 31.3252,17.199 C31.3648,16.944 31.3853,16.683 31.3853,16.417 C31.3853,13.626 29.1232,11.364 26.3327,11.364 C23.5422,11.364 21.2801,13.626 21.2801,16.417 C21.2801,18.507 22.5496,20.301 24.3598,21.07 Z"
                    })
                ]
            })
        })
    });

});

parcelRegister("6tOY7", function(module, exports) {
$parcel$export(module.exports, "CaretIcon", function () { return $67b98918252241a3$export$b11d8ce5a0fb8536; });

var $7VQPk = parcelRequire("7VQPk");
const $67b98918252241a3$export$b11d8ce5a0fb8536 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "11",
        height: "6",
        viewBox: "0 0 11 6",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M9.19922 1.18176L5.19922 4.81813L1.19922 1.18176",
            stroke: "#FFFFFF",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });

});

parcelRegister("3js76", function(module, exports) {
$parcel$export(module.exports, "Checkmark", function () { return $8b4d08848775a3a0$export$4f481e0a96cfbed6; });

var $7VQPk = parcelRequire("7VQPk");
const $8b4d08848775a3a0$export$4f481e0a96cfbed6 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        fill: "none",
        stroke: "currentColor",
        version: "1.2",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 30",
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "m1.5 16.4c1.8-1.7 4.2-0.3 4.2-0.3l5.6 5.9 15.4-18.7c0 0 1.7-1.2 3.5 0.1 1.9 1.4 0.8 3.6 0.8 3.6l-18 22h-2l-9.1-8.7c0 0-2.1-2.2-0.4-3.9z"
        })
    });

});

parcelRegister("1KfY5", function(module, exports) {
$parcel$export(module.exports, "CheckmarkCircle", function () { return $aef0f9be3f88447a$export$7f2957f440d043b5; });

var $7VQPk = parcelRequire("7VQPk");
const $aef0f9be3f88447a$export$7f2957f440d043b5 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-basic-checkmark circle",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M32,0 C14.33,0 0,14.33 0,32 C0,49.67 14.33,64 32,64 C49.67,64 64,49.67 64,32 C64,14.33 49.67,0 32,0 Z M44.59,25.97 C45.49,24.97 45.46,23.44 44.5,22.48 L44.42,22.4 C43.43,21.49 41.89,21.52 40.93,22.48 L27.63,35.78 L23.07,31.21 L22.98,31.13 C21.99,30.23 20.45,30.25 19.5,31.21 C18.51,32.2 18.51,33.8 19.5,34.78 L25.85,41.14 L25.93,41.22 C26.92,42.12 28.46,42.09 29.42,41.14 L44.5,26.05 L44.59,25.97 Z"
                })
            })
        })
    });

});

parcelRegister("dE0sS", function(module, exports) {
$parcel$export(module.exports, "Cross", function () { return $8819bc792d4e328a$export$3c877bb842c36952; });

var $7VQPk = parcelRequire("7VQPk");
const $8819bc792d4e328a$export$3c877bb842c36952 = ({ size: size, style: style, color: color, ...props })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-basic-cross",
        // eslint-disable-next-line local/ensure-wac-token-usage
        style: {
            color: color ?? '#7a869a',
            ...style
        },
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z",
            fill: "currentColor"
        })
    });

});

parcelRegister("kBlGf", function(module, exports) {
$parcel$export(module.exports, "FeatureCheckmark", function () { return $5dbbe6951bb04571$export$7d54ddbe8d02bf0; });

var $7VQPk = parcelRequire("7VQPk");
const $5dbbe6951bb04571$export$7d54ddbe8d02bf0 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        fill: "currentColor",
        version: "1.2",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: size,
        height: size,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: "checked"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z"
            })
        ]
    });

});

parcelRegister("f83zp", function(module, exports) {
$parcel$export(module.exports, "InfoCircle", function () { return $3833549ab93c8029$export$6e50c69d980cc044; });

var $7VQPk = parcelRequire("7VQPk");
const $3833549ab93c8029$export$6e50c69d980cc044 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-basic-info circle",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M32,0 C14.33,0 0,14.327 0,32 C0,49.673 14.33,64 32,64 C49.67,64 64,49.673 64,32 C64,14.327 49.67,0 32,0 Z M32.28,17.964 C34.92,17.964 37.05,15.828 37.05,13.192 C37.05,10.557 34.92,8.42 32.28,8.42 C29.65,8.42 27.51,10.557 27.51,13.192 C27.51,15.828 29.65,17.964 32.28,17.964 Z M37.89,45.753 C39.29,45.753 40.42,46.884 40.42,48.28 C40.42,49.635 39.35,50.741 38.01,50.803 L37.89,50.806 L32.35,50.806 C32.34,50.806 32.33,50.806 32.31,50.806 C32.3,50.806 32.29,50.806 32.28,50.806 L26.7,50.806 C25.3,50.806 24.17,49.675 24.17,48.28 C24.17,46.924 25.24,45.818 26.58,45.756 L26.7,45.753 L29.79,45.753 L29.79,26.666 L26.67,26.666 C25.31,26.666 24.21,25.598 24.14,24.258 L24.14,24.139 C24.14,22.784 25.21,21.678 26.55,21.616 L26.67,21.613 L32.31,21.613 C33.67,21.613 34.78,22.681 34.84,24.021 L34.84,24.139 L34.84,45.753 L37.89,45.753 Z"
                })
            })
        })
    });

});

parcelRegister("4wteY", function(module, exports) {
$parcel$export(module.exports, "No", function () { return $c14845f4b67f30ad$export$830dad7b282f77fd; });

var $7VQPk = parcelRequire("7VQPk");
const $c14845f4b67f30ad$export$830dad7b282f77fd = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-basic-no",
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0,32 C0,14.33 14.33,0 32,0 C49.67,0 64,14.33 64,32 C64,49.77 50.14,64 32.56,64 C14.79,64 0,49.58 0,32 Z M58.99,32 C58.99,17.09 46.91,5.01 32,5.01 C17.09,5.01 5.01,17.09 5.01,32 C5.01,46.79 17.53,58.99 32.56,58.99 C47.34,58.99 58.99,47.03 58.99,32 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M54.36,9.64 C53.41,8.69 51.9,8.66 50.91,9.55 L50.82,9.64 L10.19,50.26 C9.22,51.24 9.22,52.83 10.19,53.81 C11.14,54.75 12.66,54.78 13.64,53.89 L13.74,53.81 L54.36,13.18 C55.34,12.2 55.34,10.62 54.36,9.64 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });

});

parcelRegister("4s6uD", function(module, exports) {
$parcel$export(module.exports, "ClosedLock", function () { return $0d5fed612fe3c1c5$export$e99a11ba60e1f463; });

var $7VQPk = parcelRequire("7VQPk");
const $0d5fed612fe3c1c5$export$e99a11ba60e1f463 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        id: "icon-object-closedlock",
        viewBox: "0 0 22 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 12H0V28H22V12L19 12V8C19 3.58172 15.4183 0 11 0C6.58172 0 3 3.58172 3 8L3 12ZM7 12V8C7 5.79086 8.79086 4 11 4C13.2091 4 15 5.79086 15 8V12L7 12Z",
            fill: "#1868DB"
        })
    });

});

parcelRegister("4bavV", function(module, exports) {
$parcel$export(module.exports, "Accelerator", function () { return $d8426620993085d8$export$427f6a19cea2f209; });

var $7VQPk = parcelRequire("7VQPk");
const $d8426620993085d8$export$427f6a19cea2f209 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        id: "icon-accelerator",
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMinYMin meet",
        viewBox: "0 0 36 36",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                style: {
                    opacity: 0.5,
                    fill: '#0065ff',
                    fillRule: 'evenodd'
                },
                d: "M17 10.37a1.38 1.38 0 0 1 2.28-1 1.31 1.31 0 0 1 .46 1V13a1.44 1.44 0 0 1-1.25 1.46 1.39 1.39 0 0 1-1.49-1.3v-2.79ZM8.9 24a1.26 1.26 0 0 1-1 .46H5.23a1.43 1.43 0 0 1-1.45-1.25 1.38 1.38 0 0 1 1.31-1.49h2.79A1.38 1.38 0 0 1 8.9 24Zm3.03-6.85a1.44 1.44 0 0 1-2 .06l-.06-.06-2-2a1.43 1.43 0 0 1 2-2.08h.05l2 2a1.46 1.46 0 0 1 .01 2.08ZM32 24a1.26 1.26 0 0 1-1 .46h-2.68a1.43 1.43 0 0 1-1.45-1.25 1.38 1.38 0 0 1 1.31-1.49H31A1.38 1.38 0 0 1 32 24Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                style: {
                    fill: '#0065ff',
                    fillRule: 'evenodd'
                },
                d: "M.29 20.43a18.5 18.5 0 0 0 1 10h33.4A17.84 17.84 0 0 0 36 23.61a17.88 17.88 0 0 0-18.24-18A18.18 18.18 0 0 0 .29 20.43ZM17 10.37a1.38 1.38 0 0 1 2.28-1 1.31 1.31 0 0 1 .46 1V13a1.44 1.44 0 0 1-1.25 1.46 1.39 1.39 0 0 1-1.49-1.3v-2.79ZM8.9 24a1.26 1.26 0 0 1-1 .46H5.23a1.43 1.43 0 0 1-1.45-1.25 1.38 1.38 0 0 1 1.31-1.49h2.79A1.38 1.38 0 0 1 8.9 24Zm3-6.82a1.44 1.44 0 0 1-2 .06l-.06-.06-2-2a1.43 1.43 0 0 1 2-2.08h.05l2 2a1.46 1.46 0 0 1 .04 2.05Zm6.12 10a3.78 3.78 0 0 1 0-7.55 4.29 4.29 0 0 1 1.48.27l5.75-5.74a1.43 1.43 0 0 1 2.07 2l-.05.05-5.71 5.59a3.37 3.37 0 0 1 .27 1.48 3.8 3.8 0 0 1-3.78 3.83ZM32 24a1.26 1.26 0 0 1-1 .46h-2.68a1.43 1.43 0 0 1-1.45-1.25 1.38 1.38 0 0 1 1.31-1.49H31A1.38 1.38 0 0 1 32 24Z"
            })
        ]
    });

});

parcelRegister("dnK9X", function(module, exports) {
$parcel$export(module.exports, "Checkmark", function () { return $b526114fa21fe656$export$4f481e0a96cfbed6; });

var $7VQPk = parcelRequire("7VQPk");
const $b526114fa21fe656$export$4f481e0a96cfbed6 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-content-checkmark",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M42.25,50.27 C46.37,50.27 49.71,46.93 49.71,42.81 L49.71,8.64 L56.54,8.64 C60.66,8.64 64,11.98 64,16.09 L64,57.1 C64,61.22 60.66,64.56 56.54,64.56 L15.53,64.56 C11.42,64.56 8.08,61.22 8.08,57.1 L8.08,50.27 L42.25,50.27 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M7.46,0.56 C3.34,0.56 0,3.9 0,8.02 L0,49.03 C0,53.15 3.34,56.48 7.46,56.48 L48.47,56.48 C52.58,56.48 55.92,53.15 55.92,49.03 L55.92,8.02 C55.92,3.9 52.58,0.56 48.47,0.56 L7.46,0.56 Z M41.89,21.84 C42.89,20.75 42.86,19.05 41.8,17.99 L41.71,17.89 C40.61,16.89 38.91,16.92 37.85,17.99 L23.13,32.7 L18.08,27.65 L17.98,27.56 C16.88,26.56 15.18,26.59 14.12,27.65 C13.03,28.74 13.03,30.51 14.12,31.61 L21.15,38.64 L21.25,38.73 C22.34,39.73 24.04,39.7 25.11,38.64 L41.8,21.94 L41.89,21.84 Z"
                    })
                ]
            })
        })
    });

});

parcelRegister("dUFe3", function(module, exports) {
$parcel$export(module.exports, "DiagramOrgChart", function () { return $438d437140dd2b64$export$50ccabbebab12b45; });

var $7VQPk = parcelRequire("7VQPk");
const $438d437140dd2b64$export$50ccabbebab12b45 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-content-diagram org chart",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        transform: "translate(8.000000, 6.000000)",
                        opacity: "0.5",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M26.57,2.63 C26.51,1.27 25.38,0.18 24,0.18 C22.58,0.18 21.43,1.33 21.43,2.75 L21.43,23.61 L10,23.61 L9.82,23.61 C4.69,23.71 0.57,27.89 0.57,33.04 L0.57,49.61 L0.57,49.73 C0.64,51.1 1.76,52.18 3.14,52.18 C4.56,52.18 5.71,51.03 5.71,49.61 L5.71,33.04 L5.72,32.9 C5.79,30.6 7.68,28.75 10,28.75 L23.99,28.75 C23.99,28.75 24,28.75 24,28.75 C24,28.75 24.01,28.75 24.01,28.75 L38,28.75 L38.14,28.76 C40.44,28.83 42.29,30.72 42.29,33.04 L42.29,49.61 L42.29,49.73 C42.35,51.1 43.48,52.18 44.86,52.18 C46.28,52.18 47.43,51.03 47.43,49.61 L47.43,33.04 L47.43,32.86 C47.33,27.73 43.15,23.61 38,23.61 L26.57,23.61 L26.57,2.75 L26.57,2.63 Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0,53.04 C0,46.89 4.99,41.9 11.14,41.9 C17.3,41.9 22.29,46.89 22.29,53.04 C22.29,59.2 17.3,64.18 11.14,64.18 C4.99,64.18 0,59.2 0,53.04 Z",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M41.71,53.04 C41.71,46.89 46.7,41.9 52.86,41.9 C59.01,41.9 64,46.89 64,53.04 C64,59.2 59.01,64.18 52.86,64.18 C46.7,64.18 41.71,59.2 41.71,53.04 Z",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M20.86,11.33 C20.86,5.17 25.85,0.18 32,0.18 C38.15,0.18 43.14,5.17 43.14,11.33 C43.14,17.48 38.15,22.47 32,22.47 C25.85,22.47 20.86,17.48 20.86,11.33 Z",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });

});

parcelRegister("1veg3", function(module, exports) {
$parcel$export(module.exports, "Lightning", function () { return $66712c2531b8e393$export$71809dd4a5478fb0; });

var $7VQPk = parcelRequire("7VQPk");
const $66712c2531b8e393$export$71809dd4a5478fb0 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMinYMin meet",
        viewBox: "0 0 36 36",
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            style: {
                fillRule: 'evenodd'
            },
            d: "M29.12 13.67h-8L22.8 1.2a1 1 0 0 0-1.88-.77L6 20.65a1.06 1.06 0 0 0 .85 1.68h8.05L13.2 34.8a1 1 0 0 0 1.88.77L30 15.35a1.06 1.06 0 0 0-.88-1.68Z"
        })
    });

});

parcelRegister("lrxO9", function(module, exports) {
$parcel$export(module.exports, "Maximize", function () { return $24330d9aac8d021a$export$641c2d00a5a05a3e; });

var $7VQPk = parcelRequire("7VQPk");
const $24330d9aac8d021a$export$641c2d00a5a05a3e = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-content-maximize",
        width: size,
        height: size,
        viewBox: "0 0 64 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M56.54,0.18 C60.66,0.18 64,3.52 64,7.64 L64,56.73 C64,60.85 60.66,64.18 56.54,64.18 L7.46,64.18 L7.42,64.18 L25.37,64.18 C29.2,64.18 32.31,61.08 32.31,57.24 L32.31,38.81 C32.31,38 32.17,37.21 31.91,36.49 L48.79,19.61 L48.79,26.83 L48.79,26.98 C48.86,28.45 50.09,29.63 51.58,29.63 C53.13,29.63 54.38,28.38 54.38,26.83 L54.38,12.54 L54.37,12.39 C54.3,10.92 53.08,9.74 51.58,9.74 L36.85,9.74 L36.7,9.75 C35.23,9.82 34.05,11.04 34.05,12.54 L34.06,12.68 C34.13,14.16 35.35,15.33 36.85,15.33 L45.15,15.33 L28.07,32.42 C27.24,32.07 26.33,31.87 25.37,31.87 L6.94,31.87 C3.11,31.87 0,34.98 0,38.81 L0,7.64 C0,3.52 3.34,0.18 7.46,0.18 L56.54,0.18 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M24.85,31.87 C25.96,31.87 27,32.11 27.95,32.54 L14,46.49 L13.91,46.58 C12.91,47.68 12.94,49.38 14,50.44 C15.09,51.53 16.86,51.53 17.96,50.44 L31.8,36.6 C32.13,37.45 32.31,38.37 32.31,39.33 L32.31,56.73 C32.31,60.85 28.97,64.18 24.85,64.18 L7.46,64.18 C3.34,64.18 0,60.85 0,56.73 L0,39.33 C0,35.21 3.34,31.87 7.46,31.87 L24.85,31.87 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("da5RG", function(module, exports) {
$parcel$export(module.exports, "PageMultiple", function () { return $813411772cd06f8b$export$23b02afe38134aca; });

var $7VQPk = parcelRequire("7VQPk");
const $813411772cd06f8b$export$23b02afe38134aca = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-content-page multiple",
        width: size,
        height: size,
        viewBox: "0 0 64 77",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        transform: "translate(49.000000, 0.000000)",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                            points: "15 15.27 0.19 15.27 0.19 0.46"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M42.07,76.31 C46,76.31 49.19,73.13 49.19,69.2 L49.19,30.09 L34.37,15.27 L7.11,15.27 C3.18,15.27 0,18.46 0,22.38 L0,69.2 C0,73.13 3.18,76.31 7.11,76.31 L42.07,76.31 Z M40.59,39.27 C40.59,37.8 39.4,36.61 37.93,36.61 L11.85,36.61 L11.73,36.61 C10.31,36.67 9.19,37.84 9.19,39.27 C9.19,40.75 10.38,41.94 11.85,41.94 L37.93,41.94 L38.05,41.94 C39.47,41.87 40.59,40.7 40.59,39.27 Z M24.89,50.24 C26.36,50.24 27.56,51.43 27.56,52.9 C27.56,54.33 26.43,55.5 25.01,55.57 L24.89,55.57 L11.85,55.57 C10.38,55.57 9.19,54.38 9.19,52.9 C9.19,51.47 10.31,50.3 11.73,50.24 L11.85,50.24 L24.89,50.24 Z M34.37,30.09 L49.19,30.09 L34.37,15.27 L34.37,30.09 Z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M56.89,61.49 C60.82,61.49 64,58.31 64,54.38 L64,15.27 L49.18,0.46 L21.93,0.46 C18,0.46 14.81,3.64 14.81,7.57 L14.81,33.64 L43.26,33.64 L43.26,61.49 L56.89,61.49 Z M34.37,30.09 L49.18,30.09 L34.37,15.27 L34.37,30.09 Z",
                                opacity: "0.5"
                            })
                        ]
                    })
                ]
            })
        })
    });

});

parcelRegister("37jWv", function(module, exports) {
$parcel$export(module.exports, "Partners", function () { return $bc739684bfa7e10b$export$31512ee37400d4d3; });

var $7VQPk = parcelRequire("7VQPk");
const $bc739684bfa7e10b$export$31512ee37400d4d3 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        id: "icon-content-process",
        width: size,
        height: size,
        viewBox: "0 0 28 31",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7 22C7 18.134 10.134 15 14 15C17.866 15 21 18.134 21 22V31H7V22Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20 6C20 9.31371 17.3137 12 14 12C10.6863 12 8 9.31371 8 6C8 2.68629 10.6863 0 14 0C17.3137 0 20 2.68629 20 6Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.8118 11.8824C21.1959 11.9595 21.5932 12 22 12C25.3137 12 28 9.31371 28 6C28 2.68629 25.3137 0 22 0C21.5932 0 21.1959 0.0404842 20.8118 0.117642C22.1753 1.69516 23 3.75127 23 6C23 8.24873 22.1753 10.3048 20.8118 11.8824Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.18821 0.117642C5.82473 1.69516 5 3.75127 5 6C5 8.24873 5.82473 10.3048 7.18821 11.8824C6.80413 11.9595 6.40679 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C6.4068 0 6.80413 0.0404842 7.18821 0.117642Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M6.85857 15C5.09032 16.8037 4 19.2745 4 22V31H0V20C0 17.2386 2.23858 15 5 15H6.85857Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 31V22C24 19.2745 22.9097 16.8037 21.1414 15H23C25.7614 15 28 17.2386 28 20V31H24Z",
                fill: "#FFA900"
            })
        ]
    });

});

parcelRegister("cjyDN", function(module, exports) {
$parcel$export(module.exports, "Sparkle", function () { return $9d6d5b2a668a373a$export$d350d3100fdc0b49; });

var $7VQPk = parcelRequire("7VQPk");
const $9d6d5b2a668a373a$export$d350d3100fdc0b49 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        id: "icon-content-process",
        width: size,
        height: size,
        viewBox: "0 0 28 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.3333 3.33333L18 5L21.3333 6.66667L23 10L24.6667 6.66667L28 5L24.6667 3.33333L23 0L21.3333 3.33333Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8 10L0 14L8 18L12 26L16 18L24 14L16 10L12 2L8 10Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17 23L20.3333 21.3333L22 18L23.6667 21.3333L27 23L23.6667 24.6667L22 28L20.3333 24.6667L17 23Z",
                fill: "#BF63F3"
            })
        ]
    });

});

parcelRegister("akQBl", function(module, exports) {
$parcel$export(module.exports, "SparkleAI", function () { return $b64f2f26c8c4c694$export$36eabe96998183b2; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $b64f2f26c8c4c694$export$36eabe96998183b2 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        id: "icon-content-sparkle-ai",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.5198 3.98611L12.4087 5.54167L15.5198 7.09722L17.0754 10.2083L18.6309 7.09722L21.742 5.54167L18.6309 3.98611L17.0754 0.875L15.5198 3.98611Z",
                fill: (0, $bNzAT.default)('color.primary.blue')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.96458 12.8889L3.07568 15.3333L7.96458 17.7778L10.409 22.6667L12.8535 17.7778L17.7424 15.3333L12.8535 12.8889L10.409 8L7.96458 12.8889Z",
                fill: (0, $bNzAT.default)('color.primary.blue')
            })
        ]
    });

});

parcelRegister("cgQdI", function(module, exports) {
$parcel$export(module.exports, "Team", function () { return $dff97c1a37f42cd0$export$3e5d0af8e738b082; });

var $7VQPk = parcelRequire("7VQPk");
const $dff97c1a37f42cd0$export$3e5d0af8e738b082 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMinYMin meet",
        viewBox: "0 0 36 36",
        width: size,
        height: size,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                style: {
                    opacity: 0.5,
                    fill: '#0065ff',
                    fillRule: 'evenodd'
                },
                d: "M10.84 28.07v-3.71a5.57 5.57 0 0 1 1.74-4.05 5.57 5.57 0 0 0-3.88-1.56H5.61A5.61 5.61 0 0 0 0 24.36v3.71a1 1 0 0 0 1 1h10.82a1 1 0 0 1-.98-1Zm-3.68-10.6A4.12 4.12 0 1 0 3 13.35a4.12 4.12 0 0 0 4.16 4.12Zm23.23 1.28H27.3a5.57 5.57 0 0 0-3.88 1.56 5.57 5.57 0 0 1 1.74 4.05v3.71a1 1 0 0 1-1 1H35a1 1 0 0 0 1-1v-3.71a5.61 5.61 0 0 0-5.61-5.61Zm-1.55-1.28a4.12 4.12 0 1 0-4.12-4.12 4.11 4.11 0 0 0 4.12 4.12Zm-13.99-6.75a4.08 4.08 0 0 0-.92 2.58h4a.65.65 0 0 0 .52-.26l.93-1.24a.22.22 0 0 1 .35 0l.93 1.24a.68.68 0 0 0 .53.26h.91A4.07 4.07 0 0 0 18 9.23a4.41 4.41 0 0 0-.52 0 2 2 0 0 0 0-.36 2 2 0 1 0-2.66 1.82Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                style: {
                    fill: '#0065ff',
                    fillRule: 'evenodd'
                },
                d: "M23.42 20.31a5.55 5.55 0 0 0-3.87-1.57h-3.09a5.65 5.65 0 0 0-5.62 5.62v4.69h13.34a1 1 0 0 0 1-1v-3.69a5.57 5.57 0 0 0-1.76-4.05Zm-2.8-7.22-.93-1.24a.22.22 0 0 0-.35 0l-.93 1.24a.65.65 0 0 1-.52.26h-4a1 1 0 0 0 0 .17 1.62 1.62 0 0 0 0 .22v.4c0 .06 0 .12.05.19s0 .13 0 .2l.07.18.07.19.09.17.08.18.11.17a1.4 1.4 0 0 0 .1.16l.12.17a1.71 1.71 0 0 0 .11.14l.14.16.12.13.16.15a.69.69 0 0 1 .13.11l.19.14.12.09.21.13.13.07a1.67 1.67 0 0 0 .23.12l.12.05.28.11h.09l.35.09a4.47 4.47 0 0 0 .82.08 4 4 0 0 0 1.21-.18l.34-.13h.06l.3-.15h.06l.27-.16.07-.05.24-.18.08-.07.21-.19.07-.08.19-.21.07-.09.17-.22.06-.11.14-.22.06-.13a1.63 1.63 0 0 0 .11-.23s0-.09.05-.13l.09-.24a.83.83 0 0 1 0-.15l.06-.24L22 14v-.24a.91.91 0 0 0 0-.17 1.48 1.48 0 0 0 0-.21h-.91a.68.68 0 0 1-.47-.29Z"
            })
        ]
    });

});

parcelRegister("hHs95", function(module, exports) {
$parcel$export(module.exports, "Bold", function () { return $3db5b03f6f2e43cd$export$95aa4184327d6b72; });

var $7VQPk = parcelRequire("7VQPk");
const $3db5b03f6f2e43cd$export$95aa4184327d6b72 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-bolt",
        width: size,
        height: size,
        viewBox: "0 0 44 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M27.28,1.13 C28.43,-0.43 30.91,0.57 30.64,2.49 L25.42,40.05 L2.32,40.05 C0.79,40.05 -0.09,38.31 0.82,37.08 L27.28,1.13 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M41.87,24.67 C43.4,24.67 44.29,26.41 43.38,27.65 L16.92,63.59 C15.77,65.16 13.29,64.15 13.56,62.23 L18.77,24.67 L41.87,24.67 Z"
                    })
                ]
            })
        })
    });

});

parcelRegister("8lpFI", function(module, exports) {
$parcel$export(module.exports, "Building", function () { return $cf949ade732cb245$export$bb414d9e15d07212; });

var $7VQPk = parcelRequire("7VQPk");
const $cf949ade732cb245$export$bb414d9e15d07212 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-building",
        width: size,
        height: size,
        viewBox: "0 0 65 41",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.99,15.13 C40.27,15.42 41.22,16.56 41.22,17.92 C41.22,19.49 39.94,20.77 38.35,20.77 C36.76,20.77 35.48,19.49 35.48,17.92 C35.48,16.56 36.43,15.42 37.7,15.13 L27.1,15.13 C28.57,15.25 29.73,16.48 29.73,17.98 C29.73,19.56 28.44,20.84 26.86,20.84 C25.27,20.84 23.99,19.56 23.99,17.98 C23.99,16.48 25.15,15.25 26.62,15.13 L10.24,15.13 C7.7,15.13 5.34,17.18 5.34,19.7 L5.34,39.45 L60.19,39.45 L60.19,19.7 C60.19,17.18 58.13,15.13 55.59,15.13 L38.99,15.13 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M16.71,37.14 L16.71,4.77 C16.71,2.24 18.77,0.19 21.3,0.19 L43.9,0.19 C46.44,0.19 48.5,2.24 48.5,4.77 L48.5,37.14 L62.67,37.14 C63.74,37.14 64.6,38 64.6,39.07 C64.6,40.14 63.74,41 62.67,41 L2.54,41 C1.47,41 0.6,40.14 0.6,39.07 C0.6,38 1.47,37.14 2.54,37.14 L16.71,37.14 Z M28.96,37.14 L28.96,31.16 C28.96,29.22 30.55,27.63 32.51,27.63 C34.47,27.63 36.06,29.22 36.06,31.16 L36.06,37.14 L28.96,37.14 Z M29.73,17.98 C29.73,16.4 28.44,15.12 26.86,15.12 C25.27,15.12 23.99,16.4 23.99,17.98 C23.99,19.56 25.27,20.84 26.86,20.84 C28.44,20.84 29.73,19.56 29.73,17.98 Z M38.35,15.06 C39.94,15.06 41.22,16.34 41.22,17.92 C41.22,19.49 39.94,20.77 38.35,20.77 C36.76,20.77 35.48,19.49 35.48,17.92 C35.48,16.34 36.76,15.06 38.35,15.06 Z M29.73,8.77 C29.73,7.19 28.44,5.91 26.86,5.91 C25.27,5.91 23.99,7.19 23.99,8.77 C23.99,10.35 25.27,11.63 26.86,11.63 C28.44,11.63 29.73,10.35 29.73,8.77 Z M38.35,5.91 C39.94,5.91 41.22,7.19 41.22,8.77 C41.22,10.35 39.94,11.63 38.35,11.63 C36.76,11.63 35.48,10.35 35.48,8.77 C35.48,7.19 36.76,5.91 38.35,5.91 Z"
                    })
                ]
            })
        })
    });

});

parcelRegister("bLP3d", function(module, exports) {
$parcel$export(module.exports, "CircleUnions", function () { return $b72d6ca2a4ff283f$export$f636abc3133e4e68; });

var $7VQPk = parcelRequire("7VQPk");
const $b72d6ca2a4ff283f$export$f636abc3133e4e68 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        id: "icon-object-circle-unions",
        width: size,
        height: size,
        viewBox: "0 0 29 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                opacity: "0.5",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9826 18.6349C15.2121 16.6342 12.3815 16.6342 11.611 18.6349L11.4673 19.0081L11.0941 19.1518C9.09347 19.9223 9.09347 22.7528 11.0941 23.5233L11.4673 23.6671L11.611 24.0402C12.3815 26.0409 15.2121 26.0409 15.9826 24.0402L16.1263 23.6671L16.4995 23.5233C18.5001 22.7528 18.5001 19.9223 16.4995 19.1518L16.1263 19.0081L15.9826 18.6349Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.5 0.923096C22.5081 0.923096 29 7.41497 29 15.4231C29 23.4312 22.5081 29.9231 14.5 29.9231C6.49187 29.9231 0 23.4312 0 15.4231C0 7.41497 6.49187 0.923096 14.5 0.923096ZM21.1305 12.0019C20.9409 11.5095 20.2442 11.5095 20.0546 12.0019L19.3272 13.8905L17.4385 14.6179C16.9461 14.8076 16.9461 15.5042 17.4385 15.6939L19.3272 16.4212L20.0546 18.3099C20.2442 18.8023 20.9409 18.8023 21.1305 18.3099L21.8579 16.4212L23.7465 15.6939C24.239 15.5042 24.239 14.8076 23.7465 14.6179L21.8579 13.8905L21.1305 12.0019ZM14.4147 18.1835C14.2251 17.6911 13.5284 17.6911 13.3388 18.1835L12.6114 20.0722L10.7228 20.7995C10.2303 20.9892 10.2303 21.6859 10.7228 21.8755L12.6114 22.6029L13.3388 24.4915C13.5284 24.9839 14.2251 24.9839 14.4147 24.4915L15.1421 22.6029L17.0308 21.8755C17.5232 21.6859 17.5232 20.9892 17.0308 20.7995L15.1421 20.0722L14.4147 18.1835ZM10.2929 6.98007C10.5205 6.38917 11.3565 6.38917 11.5841 6.98007L12.479 9.30358L14.8025 10.1984C15.3934 10.426 15.3934 11.262 14.8025 11.4896L12.479 12.3844L11.5841 14.7079C11.3565 15.2989 10.5205 15.2989 10.2929 14.7079L9.3981 12.3844L7.07459 11.4896C6.48369 11.262 6.48368 10.426 7.07459 10.1984L9.3981 9.30358L10.2929 6.98007Z",
                fill: "currentColor"
            })
        ]
    });

});

parcelRegister("8yCrk", function(module, exports) {
$parcel$export(module.exports, "Cog", function () { return $d02b85f700900776$export$1095c93890fce526; });

var $7VQPk = parcelRequire("7VQPk");
const $d02b85f700900776$export$1095c93890fce526 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        id: "icon-object-cog",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.4443 0H19.5554L21.7927 5.96613L28.0789 4.92051L31.6344 11.0789L27.5855 16.0005L31.6336 20.9211L28.078 27.0795L21.7927 26.034L19.5554 32H12.4443L10.2068 26.0334L3.9216 27.0789L0.366042 20.9205L4.41372 16.0005L0.365234 11.0795L3.92079 4.92108L10.2068 5.96668L12.4443 0ZM16.0003 22C19.314 22 22.0003 19.3137 22.0003 16C22.0003 12.6863 19.314 10 16.0003 10C12.6866 10 10.0003 12.6863 10.0003 16C10.0003 19.3137 12.6866 22 16.0003 22Z",
            fill: "#1868DB"
        })
    });

});

parcelRegister("fU9OW", function(module, exports) {
$parcel$export(module.exports, "FourSquares", function () { return $787ebc1a81433611$export$10f380d23ff76cec; });

var $7VQPk = parcelRequire("7VQPk");
const $787ebc1a81433611$export$10f380d23ff76cec = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        id: "icon-object-foursquares",
        height: size,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12 0H0V12H12V0Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12 16H0V28H12V16Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16 0H28V12H16V0Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28 16H16V28H28V16Z",
                fill: "#1868DB"
            })
        ]
    });

});

parcelRegister("9JxMI", function(module, exports) {
$parcel$export(module.exports, "Globe", function () { return $06efaeb56bd74436$export$3bc50e457b7f164b; });

var $7VQPk = parcelRequire("7VQPk");
const $06efaeb56bd74436$export$3bc50e457b7f164b = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        id: "icon-object-globe",
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M32 16C32 7.16345 24.8366 1.33914e-05 16 0C7.16347 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16ZM10.581 26.5722C10.6011 26.6284 10.6214 26.6845 10.642 26.7403C7.27482 25.0573 4.80972 21.8374 4.16592 18H9.04819C9.20644 21.2598 9.74831 24.2406 10.581 26.5722ZM13.0534 18C13.2081 20.8691 13.6881 23.3791 14.348 25.2268C14.7557 26.3685 15.1946 27.1508 15.5819 27.6095C15.7927 27.8591 15.9336 27.9535 16 27.9873C16.0664 27.9535 16.2073 27.8591 16.4181 27.6095C16.8054 27.1508 17.2443 26.3685 17.652 25.2268C18.3119 23.3791 18.7919 20.8691 18.9466 18L13.0534 18ZM18.9466 14L13.0534 14C13.2081 11.1309 13.6881 8.62094 14.348 6.77318C14.7557 5.63146 15.1946 4.84916 15.5819 4.3905C15.7927 4.14087 15.9336 4.04645 16 4.01268C16.0664 4.04645 16.2073 4.14088 16.4181 4.39049C16.8054 4.84916 17.2443 5.63146 17.652 6.77318C18.3119 8.62094 18.7919 11.1309 18.9466 14ZM22.9518 18C22.7936 21.2598 22.2517 24.2406 21.419 26.5722C21.3989 26.6284 21.3786 26.6845 21.358 26.7403C24.7252 25.0573 27.1903 21.8374 27.8341 18H22.9518ZM27.8341 14L22.9518 14C22.7936 10.7402 22.2517 7.75936 21.419 5.42783C21.3989 5.37157 21.3786 5.31551 21.358 5.25966C24.7252 6.9427 27.1903 10.1626 27.8341 14ZM9.04819 14L4.16592 14C4.80972 10.1626 7.27482 6.9427 10.642 5.25966C10.6214 5.31551 10.6011 5.37157 10.581 5.42783C9.74831 7.75936 9.20644 10.7402 9.04819 14Z",
            fill: "#1868DB"
        })
    });
};

});

parcelRegister("2jNpj", function(module, exports) {
$parcel$export(module.exports, "Id", function () { return $1042eaea30df6bd5$export$46b83a6aabf254e3; });

var $7VQPk = parcelRequire("7VQPk");
const $1042eaea30df6bd5$export$46b83a6aabf254e3 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-id",
        width: size,
        height: size,
        viewBox: "0 0 65 50",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M54.67,49.007 C60.22,49.007 64.72,44.508 64.72,38.958 C64.72,33.408 60.22,28.908 54.67,28.908 C49.12,28.908 44.62,33.408 44.62,38.958 C44.62,44.508 49.12,49.007 54.67,49.007 Z M60.89,37.253 C61.44,36.63 61.41,35.68 60.82,35.085 L60.74,35.014 C60.12,34.467 59.17,34.49 58.58,35.085 L53.8,39.864 L51.21,37.647 L51.13,37.584 C50.47,37.084 49.52,37.18 48.97,37.819 C48.4,38.485 48.48,39.486 49.14,40.057 L52.85,43.23 L52.93,43.295 C53.55,43.766 54.44,43.709 55,43.148 L60.82,37.329 L60.89,37.253 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                        transform: "translate(27.000000, 14.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M23.92,0.67 C25.23,0.67 26.3,1.736 26.3,3.05 C26.3,4.327 25.29,5.369 24.03,5.428 L23.92,5.43 L3.29,5.43 C1.97,5.43 0.91,4.365 0.91,3.05 C0.91,1.773 1.91,0.731 3.18,0.673 L3.29,0.67 L23.92,0.67 Z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M13.34,11.248 C14.65,11.248 15.72,12.314 15.72,13.628 C15.72,14.905 14.71,15.947 13.45,16.006 L13.34,16.008 L3.29,16.008 C1.97,16.008 0.91,14.943 0.91,13.628 C0.91,12.351 1.91,11.309 3.18,11.251 L3.29,11.248 L13.34,11.248 Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M7.07,0.346 C3.56,0.346 0.72,3.187 0.72,6.693 L0.72,37.899 C0.72,41.405 3.56,44.247 7.07,44.247 L46.13,44.247 C45.17,42.71 44.62,40.898 44.62,38.957 C44.62,33.407 49.12,28.908 54.67,28.908 C56.61,28.908 58.43,29.458 59.96,30.411 L59.96,6.693 C59.96,3.187 57.12,0.346 53.62,0.346 L7.07,0.346 Z M10.24,33.819 L19.76,33.819 C21.87,33.819 23.57,32.113 23.57,30.008 L23.57,28.121 C23.57,24.43 20.48,21.414 16.76,21.414 L13.07,21.414 C9.37,21.414 6.43,24.408 6.43,28.121 L6.43,30.008 C6.43,32.113 8.14,33.819 10.24,33.819 Z M15,10.287 C12.31,10.287 10.13,12.467 10.13,15.156 C10.13,17.845 12.31,20.024 15,20.024 C17.69,20.024 19.87,17.845 19.87,15.156 C19.87,12.467 17.69,10.287 15,10.287 Z M53.3,17.049 C53.3,15.735 52.23,14.669 50.92,14.669 L30.29,14.669 L30.18,14.672 C28.91,14.73 27.91,15.772 27.91,17.049 C27.91,18.364 28.97,19.429 30.29,19.429 L50.92,19.429 L51.03,19.427 C52.29,19.368 53.3,18.326 53.3,17.049 Z M40.34,25.248 C41.65,25.248 42.72,26.313 42.72,27.628 C42.72,28.905 41.71,29.947 40.45,30.005 L40.34,30.008 L30.29,30.008 C28.97,30.008 27.91,28.942 27.91,27.628 C27.91,26.351 28.91,25.309 30.18,25.25 L30.29,25.248 L40.34,25.248 Z"
                    })
                ]
            })
        })
    });

});

parcelRegister("cB2FD", function(module, exports) {
$parcel$export(module.exports, "Lightbulb", function () { return $942ffc932982c75e$export$3d88f82d313e52c; });

var $7VQPk = parcelRequire("7VQPk");
const $942ffc932982c75e$export$3d88f82d313e52c = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-lightbulb",
        width: size,
        height: size,
        viewBox: "0 0 46 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M39.49,38 C47.99,29.5 47.99,15.7 39.49,7.2 C30.59,-1.7 16.15,-1.7 7.24,7.2 C6.99,7.5 6.76,7.7 6.52,8 C-1.56,16.9 -0.9,30.6 7.99,38.7 L11.98,42.3 L11.98,49.7 L34.75,49.7 L34.75,42.3 L38.75,38.7 C39,38.5 39.25,38.2 39.49,38 Z M25.49,10 C25.49,8.6 24.33,7.4 22.91,7.4 C14.53,7.4 7.74,14.2 7.74,22.6 L7.74,23.2 L7.74,23.3 C7.8,24.7 8.93,25.8 10.31,25.8 C11.74,25.8 12.89,24.6 12.89,23.2 L12.89,22.6 L12.89,22.4 C12.99,17 17.44,12.6 22.91,12.6 C24.33,12.6 25.49,11.4 25.49,10 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M34.75,54.9 L34.75,54.9 L11.98,54.9 L11.98,56.9 C11.98,61.1 15.42,64.6 19.66,64.6 L27.07,64.6 C31.31,64.6 34.75,61.1 34.75,56.9 L34.75,54.9 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("Ya8xu", function(module, exports) {
$parcel$export(module.exports, "LocationPin", function () { return $e27752380c7bc440$export$31790a3eeff59d4a; });

var $7VQPk = parcelRequire("7VQPk");
const $e27752380c7bc440$export$31790a3eeff59d4a = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-location pin",
        width: size,
        height: size,
        viewBox: "0 0 56 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M47.87,8.1 C37.03,-2.7 19.46,-2.7 8.62,8.1 C-2.22,18.9 -2.22,36.4 8.62,47.2 L23.43,62 C26.09,64.6 30.4,64.6 33.06,62 L47.87,47.2 C58.71,36.4 58.71,18.9 47.87,8.1 Z M28.08,38.4 C34.02,38.4 38.84,33.6 38.84,27.7 C38.84,21.7 34.02,16.9 28.08,16.9 C22.13,16.9 17.31,21.7 17.31,27.7 C17.31,33.6 22.13,38.4 28.08,38.4 Z"
                })
            })
        })
    });

});

parcelRegister("9BX4N", function(module, exports) {
$parcel$export(module.exports, "Lock", function () { return $9fc175ddbbde8258$export$5b9db7ce80343746; });

var $7VQPk = parcelRequire("7VQPk");
const $9fc175ddbbde8258$export$5b9db7ce80343746 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-lock",
        width: size,
        height: size,
        viewBox: "0 0 52 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M29.03,28.9 L22.85,28.9 C18.36,28.9 14.71,25.3 14.71,20.8 L14.71,11.2 C14.71,5 19.74,0 25.94,0 C32.14,0 37.17,5 37.17,11.2 L37.17,20.8 C37.17,25.3 33.52,28.9 29.03,28.9 Z M22.85,23.8 L29.03,23.8 C30.73,23.8 32.12,22.5 32.12,20.8 L32.12,11.2 C32.12,7.8 29.35,5 25.94,5 C22.53,5 19.77,7.8 19.77,11.2 L19.77,20.8 C19.77,22.5 21.15,23.8 22.85,23.8 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M7.13,17.4 C3.41,17.4 0.4,20.4 0.4,24.1 L0.4,57.2 C0.4,61 3.41,64 7.13,64 L44.75,64 C48.47,64 51.49,61 51.49,57.2 L51.49,24.1 C51.49,20.4 48.47,17.4 44.75,17.4 L7.13,17.4 Z M25.94,48.3 C29.51,48.3 32.4,45.4 32.4,41.8 C32.4,38.2 29.51,35.4 25.94,35.4 C22.38,35.4 19.49,38.2 19.49,41.8 C19.49,45.4 22.38,48.3 25.94,48.3 Z"
                    })
                ]
            })
        })
    });

});

parcelRegister("5YeNo", function(module, exports) {
$parcel$export(module.exports, "OpenLock", function () { return $f4c76e88543d7f6e$export$5becfc352b495196; });

var $7VQPk = parcelRequire("7VQPk");
const $f4c76e88543d7f6e$export$5becfc352b495196 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        id: "icon-object-openlock",
        viewBox: "0 0 22 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M7 14L7 8C7 5.79086 8.79086 4 11 4C13.2091 4 15 5.79086 15 8H19C19 3.58172 15.4183 0 11 0C6.58172 0 3 3.58172 3 8L3 14H0V30H22V14H7Z",
            fill: "#1868DB"
        })
    });

});

parcelRegister("8UbMK", function(module, exports) {
$parcel$export(module.exports, "PuzzlePiece", function () { return $6cb05d75f62558f3$export$c8d5f6414677f141; });

var $7VQPk = parcelRequire("7VQPk");
const $6cb05d75f62558f3$export$c8d5f6414677f141 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-puzzle piece",
        width: size,
        height: size,
        viewBox: "0 0 65 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M48.46,10.6 C51.94,10.6 54.76,13.5 54.76,16.9 L54.76,58.4 C54.76,61.9 51.94,64.7 48.46,64.7 L36.33,64.7 C36.37,64.3 36.39,64 36.39,63.6 C36.39,58.7 32.4,54.7 27.48,54.7 C22.55,54.7 18.56,58.7 18.56,63.6 C18.56,64 18.58,64.3 18.62,64.7 L7.02,64.7 C3.54,64.7 0.72,61.9 0.72,58.4 L0.72,46.8 C1.07,46.8 1.42,46.8 1.77,46.8 C6.7,46.8 10.69,42.8 10.69,37.9 C10.69,33 6.7,29 1.77,29 C1.42,29 1.07,29 0.72,29.1 L0.72,16.9 C0.72,13.5 3.54,10.6 7.02,10.6 L48.46,10.6 Z"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M64.72,37.9 C64.72,42.8 60.73,46.8 55.8,46.8 C50.88,46.8 46.89,42.8 46.89,37.9 C46.89,33 50.88,29 55.8,29 C60.73,29 64.72,33 64.72,37.9 Z"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M36.39,9.6 C36.39,14.5 32.4,18.5 27.48,18.5 C22.55,18.5 18.56,14.5 18.56,9.6 C18.56,4.7 22.55,0.7 27.48,0.7 C32.4,0.7 36.39,4.7 36.39,9.6 Z"
                        })
                    ]
                })
            })
        })
    });

});

parcelRegister("e6y3D", function(module, exports) {
$parcel$export(module.exports, "SecurityCheckmark", function () { return $7bb1886bc9d6cb85$export$992764df22cf8b12; });

var $7VQPk = parcelRequire("7VQPk");
const $7bb1886bc9d6cb85$export$992764df22cf8b12 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-security checkmark",
        width: size,
        height: size,
        viewBox: "0 0 56 65",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M55.36,7.5 C55.71,6.6 55.94,6 54.78,6 L50.86,6 C43.02,6 32.95,2.3 29.32,0.8 C28.44,0.5 27.45,0.5 26.57,0.8 C22.94,2.3 12.87,6 5.03,6 L1.11,6 C-0.06,6 0.17,6.6 0.53,7.5 C0.75,8 1.02,8.7 1.02,9.4 L1.02,30.2 C1.02,43 8.21,54.8 19.64,60.7 L26.37,64.2 C27.36,64.7 28.53,64.7 29.52,64.2 L36.25,60.7 C47.68,54.8 54.87,43 54.87,30.2 L54.87,9.4 C54.87,8.7 55.14,8 55.36,7.5 Z M41.36,23.3 C42.28,22.3 42.25,20.7 41.28,19.8 L41.19,19.7 C40.18,18.8 38.61,18.8 37.63,19.8 L24.06,33.3 L19.4,28.7 L19.32,28.6 C18.3,27.7 16.74,27.7 15.76,28.7 C14.75,29.7 14.75,31.3 15.76,32.3 L22.24,38.8 L22.33,38.9 C23.34,39.8 24.91,39.8 25.88,38.8 L41.28,23.4 L41.36,23.3 Z"
                })
            })
        })
    });

});

parcelRegister("7Zvff", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $01badd5c2f6c771d$export$ae01dedf5c052bb; });

var $7VQPk = parcelRequire("7VQPk");
const $01badd5c2f6c771d$export$ae01dedf5c052bb = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-video",
        width: size,
        height: size,
        viewBox: "0 0 65 48",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M46.69,17.5 L58.31,6.2 C60.45,4.1 64.04,5.7 64.04,8.6 L64.04,39.3 C64.04,42.3 60.45,43.8 58.31,41.7 L46.69,30.5 L41.07,30.5 L41.07,17.5 L46.69,17.5 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M39.95,0.7 C43.67,0.7 46.69,3.7 46.69,7.4 L46.69,40.6 C46.69,44.3 43.67,47.3 39.95,47.3 L6.78,47.3 C3.06,47.3 0.04,44.3 0.04,40.6 L0.04,7.4 C0.04,3.7 3.06,0.7 6.78,0.7 L39.95,0.7 Z M38.82,13.3 C38.82,15.9 36.68,18.1 34.04,18.1 C31.4,18.1 29.27,15.9 29.27,13.3 C29.27,10.7 31.4,8.5 34.04,8.5 C36.68,8.5 38.82,10.7 38.82,13.3 Z M38.54,35.8 C38.54,34.4 37.41,33.3 36.01,33.3 L11.28,33.3 L11.16,33.3 C9.82,33.3 8.75,34.4 8.75,35.8 C8.75,37.2 9.88,38.3 11.28,38.3 L36.01,38.3 L36.13,38.3 C37.47,38.3 38.54,37.1 38.54,35.8 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        transform: "translate(8.000000, 33.000000)",
                        fillRule: "nonzero",
                        opacity: "0.5",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M28.01,0.3 C29.41,0.3 30.54,1.4 30.54,2.8 C30.54,4.1 29.47,5.3 28.13,5.3 L28.01,5.3 L3.28,5.3 C1.88,5.3 0.75,4.2 0.75,2.8 C0.75,1.4 1.82,0.3 3.16,0.3 L3.28,0.3 L28.01,0.3 Z"
                        })
                    })
                ]
            })
        })
    });

});

parcelRegister("1oEP4", function(module, exports) {
$parcel$export(module.exports, "Workflow", function () { return $c6d29c9a5dfe7dea$export$7123ae228ad720a; });

var $7VQPk = parcelRequire("7VQPk");
const $c6d29c9a5dfe7dea$export$7123ae228ad720a = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        id: "icon-object-workflow",
        viewBox: "0 0 32 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M22.416 7H20C18.8954 7 18 7.89543 18 9V21C18 24.3137 15.3137 27 12 27H9.58396C8.8124 28.7659 7.05032 30 5 30C2.23858 30 0 27.7614 0 25C0 22.2386 2.23858 20 5 20C7.05032 20 8.8124 21.2341 9.58396 23H12C13.1046 23 14 22.1046 14 21V9C14 5.68629 16.6863 3 20 3H22.416C23.1876 1.2341 24.9497 0 27 0C29.7614 0 32 2.23858 32 5C32 7.76142 29.7614 10 27 10C24.9497 10 23.1876 8.7659 22.416 7Z",
            fill: "#1868DB"
        })
    });

});

parcelRegister("8tj4l", function(module, exports) {
$parcel$export(module.exports, "Wrench", function () { return $ecc28d8cdaea436b$export$4421f7c88022a750; });

var $7VQPk = parcelRequire("7VQPk");
const $ecc28d8cdaea436b$export$4421f7c88022a750 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-object-magnifying glass_2",
        width: size,
        height: size,
        viewBox: "0 0 65 64",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M3.67,60.2 C8.27,64.8 15.73,64.8 20.33,60.2 L38.71,41.8 L22.05,25.1 L3.67,43.5 C-0.93,48.1 -0.93,55.6 3.67,60.2 Z M16.63,52.5 C16.63,49.5 14.15,47 11.09,47 C8.02,47 5.54,49.5 5.54,52.5 C5.54,55.6 8.02,58.1 11.09,58.1 C14.15,58.1 16.63,55.6 16.63,52.5 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M64.22,24.2 C64.22,37.4 53.54,48.1 40.38,48.1 C27.21,48.1 16.54,37.4 16.54,24.2 C16.54,11.1 27.21,0.4 40.38,0.4 C41.9,0.4 43.39,0.5 44.83,0.8 C45.66,1 45.94,2 45.35,2.6 L37.72,10.3 C33.06,14.9 33.07,22.5 37.73,27.1 C42.39,31.8 49.96,31.8 54.62,27.1 L62.1,19.7 C62.69,19.1 63.73,19.4 63.87,20.2 C64.1,21.5 64.22,22.9 64.22,24.2 Z"
                    })
                ]
            })
        })
    });

});

parcelRegister("03v16", function(module, exports) {
$parcel$export(module.exports, "CloudCheckmark", function () { return $04b52f78c8a988da$export$c680fbc74fda3897; });

var $7VQPk = parcelRequire("7VQPk");
const $04b52f78c8a988da$export$c680fbc74fda3897 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-software-cloud checkmark",
        width: size,
        height: size,
        viewBox: "0 0 65 44",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M44.93,8.67 C41.37,3.38 35.38,0.08 28.8,0.08 C18.68,0.08 10.37,7.81 9.45,17.69 C4.45,19.6 0.99,24.44 0.99,29.99 C0.99,37.26 6.88,43.15 14.15,43.15 L47.64,43.15 L47.93,43.15 C57.38,42.99 64.99,35.29 64.99,25.8 C64.99,16.22 57.22,8.46 47.64,8.46 C46.73,8.46 45.82,8.53 44.93,8.67 Z M44.06,19.15 C44.87,18.27 44.84,16.9 43.99,16.05 L43.91,15.98 C43.03,15.18 41.67,15.2 40.82,16.05 L29.01,27.86 L24.96,23.81 L24.88,23.73 C24,22.93 22.64,22.96 21.79,23.81 C20.91,24.68 20.91,26.1 21.79,26.98 L27.43,32.62 L27.5,32.69 C28.38,33.49 29.75,33.47 30.6,32.62 L43.99,19.22 L44.06,19.15 Z"
                })
            })
        })
    });

});

parcelRegister("hdGAb", function(module, exports) {
$parcel$export(module.exports, "DataCenter", function () { return $b22f77e989960198$export$f4645eafb2eadc0c; });

var $7VQPk = parcelRequire("7VQPk");
const $b22f77e989960198$export$f4645eafb2eadc0c = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-software-data center",
        width: size,
        height: size,
        viewBox: "0 0 65 71",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M64.93,51.51 L64.93,66.43 C64.93,68.49 63.26,70.15 61.2,70.15 L4.66,70.15 C2.6,70.15 0.93,68.49 0.93,66.43 L0.93,51.51 L64.93,51.51 Z M15.84,60.83 C15.84,62.89 14.17,64.56 12.11,64.56 C10.05,64.56 8.38,62.89 8.38,60.83 C8.38,58.77 10.05,57.1 12.11,57.1 C14.17,57.1 15.84,58.77 15.84,60.83 Z M57.78,60.83 C57.78,59.29 56.53,58.04 54.99,58.04 L27.65,58.04 L27.51,58.04 C26.03,58.11 24.85,59.33 24.85,60.83 C24.85,62.38 26.1,63.63 27.65,63.63 L54.99,63.63 L55.12,63.63 C56.6,63.56 57.78,62.33 57.78,60.83 Z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M64.93,26.04 L64.93,44.68 L0.93,44.68 L0.93,26.04 L64.93,26.04 Z M15.84,35.36 C15.84,37.42 14.17,39.08 12.11,39.08 C10.05,39.08 8.38,37.42 8.38,35.36 C8.38,33.3 10.05,31.63 12.11,31.63 C14.17,31.63 15.84,33.3 15.84,35.36 Z M57.78,35.36 C57.78,33.81 56.53,32.56 54.99,32.56 L27.65,32.56 L27.51,32.56 C26.03,32.63 24.85,33.86 24.85,35.36 C24.85,36.9 26.1,38.15 27.65,38.15 L54.99,38.15 L55.12,38.15 C56.6,38.08 57.78,36.86 57.78,35.36 Z"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M61.2,0.56 C63.26,0.56 64.93,2.23 64.93,4.29 L64.93,19.2 L0.93,19.2 L0.93,4.29 C0.93,2.23 2.6,0.56 4.66,0.56 L61.2,0.56 Z M15.84,9.88 C15.84,11.94 14.17,13.61 12.11,13.61 C10.05,13.61 8.38,11.94 8.38,9.88 C8.38,7.82 10.05,6.15 12.11,6.15 C14.17,6.15 15.84,7.82 15.84,9.88 Z M57.78,9.88 C57.78,8.34 56.53,7.09 54.99,7.09 L27.65,7.09 L27.51,7.09 C26.03,7.16 24.85,8.38 24.85,9.88 C24.85,11.43 26.1,12.68 27.65,12.68 L54.99,12.68 L55.12,12.68 C56.6,12.61 57.78,11.38 57.78,9.88 Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        x: "0.93",
                        y: "44.68",
                        width: "63.9997",
                        height: "6.83492"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        fillRule: "nonzero",
                        opacity: "0.5",
                        x: "0.93",
                        y: "19.2",
                        width: "63.9997",
                        height: "6.83492"
                    })
                ]
            })
        })
    });

});



parcelRegister("ebGgc", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("bNb0m"),
    $eao4m("evwwy"),
    $eao4m("8t8fq")
]).then(()=>parcelRequire('gieZF'));

});


parcelRegister("kqVCv", function(module, exports) {
$parcel$export(module.exports, "GlobalFooterTop", function () { return $ca63e0666ea1e8fa$export$38e7ae23a4703911; });
/* global-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $1ka2O = parcelRequire("1ka2O");

var $aejAB = parcelRequire("aejAB");
// ==================================================================
// CSS styling
// ==================================================================
const $ca63e0666ea1e8fa$var$containerStyle = null;
const $ca63e0666ea1e8fa$var$containerDarkThemeStyle = null;
const $ca63e0666ea1e8fa$var$linksWrapperStyle = null;
const $ca63e0666ea1e8fa$export$26b6a80e48da8316 = {
    margin: '0',
    padding: '0',
    border: '0',
    fontSize: '100%',
    verticalAlign: 'baseline'
};
const $ca63e0666ea1e8fa$export$38e7ae23a4703911 = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const productsLinkList = {
        headerText: intl.formatMessage({
            id: 'globalfooterv2.top.products',
            defaultMessage: 'Products'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.rovo',
                    defaultMessage: 'Rovo'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/rovo')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.jira-software',
                    defaultMessage: 'Jira'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/jira')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.jira-align',
                    defaultMessage: 'Jira Align'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/jira/align')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.jira-service-management',
                    defaultMessage: 'Jira Service Management'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.confluence',
                    defaultMessage: 'Confluence'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/confluence')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.loom',
                    defaultMessage: 'Loom'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/loom')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.trello',
                    defaultMessage: 'Trello'
                }),
                href: (0, $jQ0cd.useLocalizedHrefTrello)('/home')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.bitbucket',
                    defaultMessage: 'Bitbucket'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket')
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: 'globalfooterv2.top.see-all-products',
                defaultMessage: 'See all products'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/software'),
            bgColor: 'bgWhite'
        }
    };
    const isUnifiedTemplatesNavigationEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacUnifiedTemplatesNavigation);
    const templatesLink = {
        text: intl.formatMessage({
            id: 'globalfooterv2.top.templates',
            defaultMessage: 'Templates'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/templates')
    };
    const resourcesLinkList = {
        headerText: intl.formatMessage({
            id: 'globalfooterv2.top.resources',
            defaultMessage: 'Resources'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.technical-support',
                    defaultMessage: 'Technical support'
                }),
                href: intl.formatMessage({
                    id: 'globalfooterv2.top.technical-support.link',
                    defaultMessage: 'https://support.atlassian.com/'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.purchasing-and-licensing',
                    defaultMessage: 'Purchasing & licensing'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/licensing/purchase-licensing')
            },
            ...isUnifiedTemplatesNavigationEnabled ? [
                templatesLink
            ] : [],
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.atlassian-community',
                    defaultMessage: 'Atlassian Community'
                }),
                href: 'https://community.atlassian.com/'
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.knowledge-base',
                    defaultMessage: 'Knowledge base'
                }),
                href: intl.formatMessage({
                    id: 'globalfooterv2.top.knowledge-base.link',
                    defaultMessage: 'https://confluence.atlassian.com/kb'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.marketplace',
                    defaultMessage: 'Marketplace'
                }),
                href: 'https://marketplace.atlassian.com/'
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.my-account',
                    defaultMessage: 'My account'
                }),
                href: 'https://my.atlassian.com/products/index'
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: 'globalfooterv2.top.create-support-ticket',
                defaultMessage: 'Create support ticket'
            }),
            href: 'https://support.atlassian.com/contact/',
            bgColor: 'bgWhite'
        }
    };
    const learnLinkList = {
        headerText: intl.formatMessage({
            id: 'globalfooterv2.top.learn',
            defaultMessage: 'Learn'
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.partners',
                    defaultMessage: 'Partners'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/partners')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.training-and-certification',
                    defaultMessage: 'Training & certification'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/university')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.documentation',
                    defaultMessage: 'Documentation'
                }),
                href: intl.formatMessage({
                    id: 'globalfooterv2.top.documentation.link',
                    defaultMessage: 'https://confluence.atlassian.com/display/ALLDOC/Atlassian+Documentation'
                })
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.developer-resources',
                    defaultMessage: 'Developer resources'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/developers')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.enterprise-services',
                    defaultMessage: 'Enterprise services'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/enterprise/services')
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: 'globalfooterv2.top.see-all-resources',
                defaultMessage: 'See all resources'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/resources'),
            bgColor: 'bgWhite'
        }
    };
    const atlassianLinkList = {
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.company',
                    defaultMessage: 'Company'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/company')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.careers',
                    defaultMessage: 'Careers'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/company/careers')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.events',
                    defaultMessage: 'Events'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/company/events')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.blogs',
                    defaultMessage: 'Blogs'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/blog')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.investor-relations',
                    defaultMessage: 'Investor Relations'
                }),
                href: 'https://investors.atlassian.com'
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.atlassian-foundation',
                    defaultMessage: 'Atlassian Foundation'
                }),
                href: 'https://www.atlassianfoundation.org/'
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.press-kit',
                    defaultMessage: 'Press kit'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/company/news/press-kit')
            },
            {
                text: intl.formatMessage({
                    id: 'globalfooterv2.top.contact-us',
                    defaultMessage: 'Contact us'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/company/contact')
            }
        ]
    };
    // Adding pdf to french locale for compliance
    if (location.pathname.startsWith('/fr')) atlassianLinkList.listOfLinks.push({
        text: `Index de l'\xe9galit\xe9 professionnelle`,
        href: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qey7mu25028ek1rp0ru28l45l8y3fm5r/2025-France-Gender-Equality-Index.pdf'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-v2-top",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhkg7ng _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg",
                isDarkTheme && "_bfhk1j28"
            ]),
            style: {
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light100'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1x32"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...atlassianLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...productsLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...resourcesLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...learnLinkList
                    })
                ]
            })
        })
    });
};

});
parcelRegister("aejAB", function(module, exports) {
$parcel$export(module.exports, "LinkListContainer", function () { return $c55da0a2930aef1f$export$e07e28d16ae87608; });
/* global-footer-top-link-list-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $dPWka = parcelRequire("dPWka");
// ==================================================================
// Style Functions
// ==================================================================
const $c55da0a2930aef1f$var$listOfLinksColumnStyle = null;
const $c55da0a2930aef1f$var$listOfLinksUlStyle = null;
const $c55da0a2930aef1f$var$listOfLinksUlLiStyle = null;
const $c55da0a2930aef1f$var$listOfLinksUlLiAnchorTagStyle = null;
const $c55da0a2930aef1f$var$atlassianLinksLiAnchorTagStyle = null;
const $c55da0a2930aef1f$var$headerContainerStyle = null;
const $c55da0a2930aef1f$var$listOfLinksColumnHeaderStyle = null;
const $c55da0a2930aef1f$var$atlassianLogoStyle = null;
const $c55da0a2930aef1f$var$bottomViewAllLinkDivStyle = null;
const $c55da0a2930aef1f$var$bottomViewAllLinkLiAnchorStyle = null;
const $c55da0a2930aef1f$var$listOfLinksColumnDarkThemeStyle = null;
const $c55da0a2930aef1f$var$listOfLinksColumnHeaderDarkThemeStyle = null;
const $c55da0a2930aef1f$var$bottomViewAllLinkLiAnchorDarkThemeStyle = null;
const $c55da0a2930aef1f$export$e07e28d16ae87608 = ({ headerText: headerText, listOfLinks: listOfLinks, bottomViewAllLink: bottomViewAllLink, logoType: logoType })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1tket94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1osq _s7n41q9y _1e0c1ule _syazkhc1 _vchhusvi _1bsb1osq",
            isDarkTheme && "_syaz1afi"
        ]),
        style: {
            "--_n0ignx": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue1000')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
        },
        children: [
            headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wybw1gv _o10x10nf _1p1dangw _syaz1x3z _k48p53lb _ect48q0o",
                        isDarkTheme && "_syazuftu",
                        "eyebrow-md"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                    },
                    children: headerText.trim()
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3izwfg _6rthxy5q"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dPWka.LogoLinkContainer), {
                    logoType: logoType
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _bozggktf _qtt8glyw"
                ]),
                children: listOfLinks.map((listOfLink)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        className: (0, $2jatx.default)([
                            "_6rth8jkm _1pfhze3t _2mzuglyw _ahbq1fm0 _syaz1kw7 _1wyb1j6v _vwz4dlk8 _1g451qgu _40h8yh40"
                        ]),
                        style: {
                            "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: listOfLink.text,
                            href: listOfLink.href,
                            type: "anchor",
                            bgColor: isDarkTheme ? 'bgBlackBlue' : 'bgColored',
                            onClick: listOfLink.onClick,
                            className: (0, $2jatx.default)([
                                "_1wyboxwj _1dyz1a1y _ect4kipj _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw _1ygbdrmc _1ah3yh40",
                                !headerText && "_k48p1fw0 _ect48q0o _1dyz4jg8",
                                listOfLink.className
                            ]),
                            "aria-label": "footer-link",
                            style: {
                                "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                            }
                        })
                    }, listOfLink.text.trim().replace(' ', '-')))
            }),
            bottomViewAllLink && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_k48pbfng _1pfhxy5q _1rjcftgi _1g451qgu _40h8yh40"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    text: bottomViewAllLink.text,
                    href: bottomViewAllLink.href,
                    type: "primary",
                    bgColor: isDarkTheme ? 'bgBlackBlue' : 'bgColored',
                    onClick: bottomViewAllLink.onClick,
                    className: (0, $2jatx.default)([
                        "_syaz1pfd _1wyboxwj _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dyz1a1y _ect4kipj _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1 _1ygbdrmc _1ah3yh40",
                        isDarkTheme && "_syaz1afi _f8pj1okz _30l31okz _10531okz",
                        bottomViewAllLink.className
                    ]),
                    "aria-label": "footer-link",
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
                        "--_1hwkv7u": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1100'))
                    }
                })
            })
        ]
    });
};

});
parcelRegister("dPWka", function(module, exports) {
$parcel$export(module.exports, "LogoLinkContainer", function () { return $0b50367e54278f7f$export$8a742823b1bccd90; });
/* global-footer-top-logo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $eIRB3 = parcelRequire("eIRB3");
const $0b50367e54278f7f$var$logoDarkThemeStyle = null;
const $0b50367e54278f7f$export$8a742823b1bccd90 = ({ logoType: logoType })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const intl = (0, $8e22h.default)();
    const messages = (0, $fnHPc.defineMessages)({
        ariaLabelLogo: {
            id: 'globalfooterv2.top.logo-label',
            defaultMessage: 'Atlassian logo'
        }
    });
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/');
    const dataEvent = 'clicked';
    const dataEventComponent = 'linkButton';
    const dataEventContainer = 'globalFooterV2';
    // const dataProductKey = "TO DO: depends on page"
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        "aria-label": intl.formatMessage(messages.ariaLabelLogo),
        href: localizedHref,
        "data-event": dataEvent,
        "data-event-component": dataEventComponent,
        "data-event-container": dataEventContainer,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                isDarkTheme && "_kdam16sm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eIRB3.LogoV2), {
                brand: logoType || 'atlassian',
                type: "mark",
                appearance: "brand",
                width: 32,
                height: 32
            })
        })
    });
};

});
parcelRegister("fnHPc", function(module, exports) {
$parcel$export(module.exports, "defineMessages", function () { return $b32affb57c4a973e$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $b32affb57c4a973e$export$747d244ee58120dd; });
$parcel$export(module.exports, "FormattedDate", function () { return $b32affb57c4a973e$export$40ae3194919d16b; });
$parcel$export(module.exports, "FormattedTime", function () { return $b32affb57c4a973e$export$5b390a54f8a846f7; });
$parcel$export(module.exports, "FormattedNumber", function () { return $b32affb57c4a973e$export$db80edc1e6b2f63d; });
$parcel$export(module.exports, "FormattedList", function () { return $b32affb57c4a973e$export$f52b44e459e6e71d; });
$parcel$export(module.exports, "FormattedDisplayName", function () { return $b32affb57c4a973e$export$c2336ea5aaab92fa; });
$parcel$export(module.exports, "FormattedDateParts", function () { return $b32affb57c4a973e$export$7fdc7d2c91ce149b; });
$parcel$export(module.exports, "FormattedTimeParts", function () { return $b32affb57c4a973e$export$ec35873761676c2a; });
$parcel$export(module.exports, "FormattedDateTimeRange", function () { return (parcelRequire("gYl3A")).default; });
$parcel$export(module.exports, "FormattedMessage", function () { return (parcelRequire("iVyKn")).default; });
$parcel$export(module.exports, "FormattedPlural", function () { return (parcelRequire("bCEgB")).default; });
$parcel$export(module.exports, "FormattedRelativeTime", function () { return (parcelRequire("jLvuA")).default; });
$parcel$export(module.exports, "IntlContext", function () { return (parcelRequire("iZHH7")).Context; });
$parcel$export(module.exports, "IntlProvider", function () { return (parcelRequire("9GLx2")).default; });
$parcel$export(module.exports, "RawIntlProvider", function () { return (parcelRequire("iZHH7")).Provider; });
$parcel$export(module.exports, "createIntl", function () { return (parcelRequire("9GLx2")).createIntl; });
$parcel$export(module.exports, "injectIntl", function () { return (parcelRequire("iZHH7")).default; });
$parcel$export(module.exports, "useIntl", function () { return (parcelRequire("8e22h")).default; });
$parcel$export(module.exports, "createIntlCache", function () { return (parcelRequire("bceAk")).createIntlCache; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("iOyCd")).UnsupportedFormatterError; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("iOyCd")).InvalidConfigError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("iOyCd")).MissingDataError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("iOyCd")).MessageFormatError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("iOyCd")).MissingTranslationError; });
$parcel$export(module.exports, "ReactIntlErrorCode", function () { return (parcelRequire("iOyCd")).IntlErrorCode; });
$parcel$export(module.exports, "ReactIntlError", function () { return (parcelRequire("iOyCd")).IntlError; });
$parcel$export(module.exports, "FormattedNumberParts", function () { return (parcelRequire("cmiMH")).FormattedNumberParts; });
$parcel$export(module.exports, "FormattedListParts", function () { return (parcelRequire("cmiMH")).FormattedListParts; });

var $cmiMH = parcelRequire("cmiMH");

var $iZHH7 = parcelRequire("iZHH7");

var $8e22h = parcelRequire("8e22h");

var $9GLx2 = parcelRequire("9GLx2");

var $jLvuA = parcelRequire("jLvuA");

var $bCEgB = parcelRequire("bCEgB");

var $iVyKn = parcelRequire("iVyKn");

var $gYl3A = parcelRequire("gYl3A");

var $bceAk = parcelRequire("bceAk");
var $iOyCd = parcelRequire("iOyCd");
function $b32affb57c4a973e$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $b32affb57c4a973e$export$747d244ee58120dd(msg) {
    return msg;
}
var $b32affb57c4a973e$export$40ae3194919d16b = (0, $cmiMH.createFormattedComponent)('formatDate');
var $b32affb57c4a973e$export$5b390a54f8a846f7 = (0, $cmiMH.createFormattedComponent)('formatTime');
var $b32affb57c4a973e$export$db80edc1e6b2f63d = (0, $cmiMH.createFormattedComponent)('formatNumber');
var $b32affb57c4a973e$export$f52b44e459e6e71d = (0, $cmiMH.createFormattedComponent)('formatList');
var $b32affb57c4a973e$export$c2336ea5aaab92fa = (0, $cmiMH.createFormattedComponent)('formatDisplayName');
var $b32affb57c4a973e$export$7fdc7d2c91ce149b = (0, $cmiMH.createFormattedDateTimePartsComponent)('formatDate');
var $b32affb57c4a973e$export$ec35873761676c2a = (0, $cmiMH.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("cmiMH", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", function () { return $8ff61c53d4db2574$export$54d4989ed3eea1ea; });
$parcel$export(module.exports, "FormattedListParts", function () { return $8ff61c53d4db2574$export$5ac259c7da6d2188; });
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $8ff61c53d4db2574$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $8ff61c53d4db2574$export$b37e14176d001dec; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
var $8ff61c53d4db2574$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($8ff61c53d4db2574$var$DisplayName || ($8ff61c53d4db2574$var$DisplayName = {}));
var $8ff61c53d4db2574$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($8ff61c53d4db2574$var$DisplayNameParts || ($8ff61c53d4db2574$var$DisplayNameParts = {}));
var $8ff61c53d4db2574$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $8e22h.default)();
    var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$8ff61c53d4db2574$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $8ff61c53d4db2574$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $8e22h.default)();
    var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$8ff61c53d4db2574$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $8ff61c53d4db2574$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $8e22h.default)();
        var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $8ff61c53d4db2574$var$DisplayNameParts[name];
    return ComponentParts;
}
function $8ff61c53d4db2574$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $8e22h.default)();
        var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $1oC0p.Fragment;
        return $1oC0p.createElement(Text, null, formattedValue);
    };
    Component.displayName = $8ff61c53d4db2574$var$DisplayName[name];
    return Component;
}

});

parcelRegister("jLvuA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e63ad5d6fd9f3d5e$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $jcL53 = parcelRequire("jcL53");

var $8e22h = parcelRequire("8e22h");
var $e63ad5d6fd9f3d5e$var$MINUTE = 60;
var $e63ad5d6fd9f3d5e$var$HOUR = 3600;
var $e63ad5d6fd9f3d5e$var$DAY = 86400;
function $e63ad5d6fd9f3d5e$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $e63ad5d6fd9f3d5e$var$MINUTE) return 'second';
    if (absValue < $e63ad5d6fd9f3d5e$var$HOUR) return 'minute';
    if (absValue < $e63ad5d6fd9f3d5e$var$DAY) return 'hour';
    return 'day';
}
function $e63ad5d6fd9f3d5e$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $e63ad5d6fd9f3d5e$var$MINUTE;
        case 'hour':
            return $e63ad5d6fd9f3d5e$var$HOUR;
        default:
            return $e63ad5d6fd9f3d5e$var$DAY;
    }
}
function $e63ad5d6fd9f3d5e$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $e63ad5d6fd9f3d5e$var$MINUTE;
        default:
            return value * $e63ad5d6fd9f3d5e$var$HOUR;
    }
}
var $e63ad5d6fd9f3d5e$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $e63ad5d6fd9f3d5e$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $e63ad5d6fd9f3d5e$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $e63ad5d6fd9f3d5e$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $8e22h.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $d3IQL.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $1oC0p.createElement(Text, null, formattedRelativeTime);
    return $1oC0p.createElement($1oC0p.Fragment, null, formattedRelativeTime);
};
var $e63ad5d6fd9f3d5e$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $d3IQL.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $jcL53.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $e63ad5d6fd9f3d5e$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _b = $1oC0p.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $1oC0p.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $1oC0p.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($e63ad5d6fd9f3d5e$var$canIncrement(unit) ? $e63ad5d6fd9f3d5e$var$valueToSeconds(value, unit) : 0);
    }
    $1oC0p.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$e63ad5d6fd9f3d5e$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $e63ad5d6fd9f3d5e$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $e63ad5d6fd9f3d5e$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($e63ad5d6fd9f3d5e$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $e63ad5d6fd9f3d5e$var$selectUnit(currentValueInSeconds);
        var unitDuration = $e63ad5d6fd9f3d5e$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $1oC0p.createElement($e63ad5d6fd9f3d5e$var$SimpleFormattedRelativeTime, (0, $d3IQL.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$e63ad5d6fd9f3d5e$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
$e63ad5d6fd9f3d5e$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: 'second'
};
var $e63ad5d6fd9f3d5e$export$2e2bcd8739ae039 = $e63ad5d6fd9f3d5e$var$FormattedRelativeTime;

});

parcelRegister("bCEgB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87627a7362908e47$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
var $87627a7362908e47$var$FormattedPlural = function(props) {
    var _a = (0, $8e22h.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $1oC0p.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$87627a7362908e47$var$FormattedPlural.defaultProps = {
    type: 'cardinal'
};
$87627a7362908e47$var$FormattedPlural.displayName = 'FormattedPlural';
var $87627a7362908e47$export$2e2bcd8739ae039 = $87627a7362908e47$var$FormattedPlural;

});

parcelRegister("gYl3A", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c5b2955e4b8ef689$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
var $c5b2955e4b8ef689$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $8e22h.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $1oC0p.Fragment;
    return $1oC0p.createElement(Text, null, formattedValue);
};
$c5b2955e4b8ef689$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $c5b2955e4b8ef689$export$2e2bcd8739ae039 = $c5b2955e4b8ef689$var$FormattedDateTimeRange;

});


parcelRegister("eIRB3", function(module, exports) {
$parcel$export(module.exports, "LogoV2", function () { return $49d8dc236e3e02a7$export$274f51a57fd5e2dd; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $3zlWb = parcelRequire("3zlWb");

var $2f1ve = parcelRequire("2f1ve");

var $jTKTB = parcelRequire("jTKTB");

var $1WFXk = parcelRequire("1WFXk");

var $l2YUn = parcelRequire("l2YUn");

var $bvlrB = parcelRequire("bvlrB");

var $aHSNj = parcelRequire("aHSNj");

var $5Uj3F = parcelRequire("5Uj3F");

var $i4djl = parcelRequire("i4djl");

var $b9cqO = parcelRequire("b9cqO");

var $h6nLi = parcelRequire("h6nLi");

var $eRZDs = parcelRequire("eRZDs");

var $jB0Ze = parcelRequire("jB0Ze");

var $37fXF = parcelRequire("37fXF");

var $26Dc0 = parcelRequire("26Dc0");

var $lsNQ4 = parcelRequire("lsNQ4");

var $ixjDH = parcelRequire("ixjDH");

var $ghLSk = parcelRequire("ghLSk");

var $eAedM = parcelRequire("eAedM");

var $7WVgr = parcelRequire("7WVgr");

var $itb5R = parcelRequire("itb5R");

var $8zOID = parcelRequire("8zOID");

var $a0iUh = parcelRequire("a0iUh");

var $78YUQ = parcelRequire("78YUQ");

var $c5NPm = parcelRequire("c5NPm");
const $49d8dc236e3e02a7$var$Logos = {
    atlassian: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2f1ve.AtlassianMarkBrandV2), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3zlWb.AtlassianLogoBrandV2), {})
        }
    },
    bitbucket: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2YUn.BitbucketMarkBrandV2), {})
        }
    },
    compass: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bvlrB.CompassMarkBrandV2), {})
        }
    },
    confluence: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Uj3F.ConfluenceMarkBrandV2), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aHSNj.ConfluenceLogoBrandV2), {})
        }
    },
    guard: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b9cqO.GuardMarkBrand), {})
        }
    },
    focus: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i4djl.FocusMarkBrand), {})
        }
    },
    jira: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ixjDH.JiraMarkBrandV2), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lsNQ4.JiraLogoBrandV2), {})
        }
    },
    jiraalign: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h6nLi.JiraAlignMarkBrandV2), {})
        }
    },
    jiraservicemanagement: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $26Dc0.JiraServiceManagementMarkBrandV2), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $37fXF.JiraServiceManagementLogoBrandV2), {})
        }
    },
    jiraproductdiscovery: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eRZDs.JiraProductDiscoveryLogoBrandV2), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jB0Ze.JiraProductDiscoveryMarkBrandV2), {})
        }
    },
    loom: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ghLSk.LoomMarkBrandV2), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eAedM.LoomLogoBrandV2), {})
        }
    },
    rovo: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $itb5R.RovoMarkBrandV2), {})
        }
    },
    trello: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c5NPm.TrelloMarkBrandV2), {})
        }
    },
    opsgenie: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WVgr.OpsgenieMarkBrandV2), {})
        }
    },
    sourcetreeapp: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8zOID.SourcetreeMarkBrandV2), {})
        }
    },
    statuspage: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a0iUh.StatusPageMarkBrandV2), {})
        }
    },
    atlas: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jTKTB.AtlasMarkBrandV2), {})
        }
    },
    bamboo: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1WFXk.BambooMarkBrandV2), {})
        }
    },
    talent: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78YUQ.TalentMarkBrandLegacy), {})
        }
    }
};
const $49d8dc236e3e02a7$export$274f51a57fd5e2dd = ({ brand: brand, type: type, appearance: appearance, width: width, height: height })=>{
    const logo = $49d8dc236e3e02a7$var$Logos[brand]?.[type]?.[appearance];
    return logo ? /*#__PURE__*/ (0, $1oC0p.cloneElement)(logo, {
        width: width,
        height: height
    }) : logo;
};

});
parcelRegister("3zlWb", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogoBrandV2", function () { return $8feb73775e263968$export$abdce332a3b27941; });

var $7VQPk = parcelRequire("7VQPk");
const $8feb73775e263968$export$abdce332a3b27941 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 156 20",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            id: "Container",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M97.7501 14.46C97.7501 11.7182 96.2781 10.4194 92.1799 9.52476C89.8999 9.03412 89.3515 8.51462 89.3515 7.7931C89.3515 6.89841 90.1596 6.49436 91.6604 6.49436C93.4786 6.49436 95.268 7.04271 96.9708 7.82196V4.21434C95.7875 3.60826 93.9404 3.14648 91.7758 3.14648C87.7064 3.14648 85.5996 4.907 85.5996 7.82196C85.5996 10.1308 86.6674 11.9779 90.8811 12.786C93.3921 13.3055 93.9116 13.7096 93.9116 14.5466C93.9116 15.3547 93.3921 15.8742 91.6027 15.8742C89.5535 15.8742 87.1004 15.1815 85.513 14.2291V18.0099C86.7829 18.6448 88.4568 19.3375 91.5738 19.3375C95.9895 19.3375 97.7501 17.3749 97.7501 14.46Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M142.139 3.37741V19.1066H145.487V7.12934L146.901 10.304L151.634 19.1066H155.848V3.37741H152.5V13.5365L151.23 10.5927L147.421 3.37741H142.139Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M120.869 3.37741H117.204V19.0778H120.869V3.37741Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M112.96 14.46C112.96 11.7182 111.488 10.4194 107.39 9.52476C105.11 9.03412 104.561 8.51462 104.561 7.7931C104.561 6.89841 105.369 6.49436 106.87 6.49436C108.688 6.49436 110.478 7.04271 112.181 7.82196V4.21434C110.997 3.60826 109.15 3.14648 106.986 3.14648C102.916 3.14648 100.809 4.907 100.809 7.82196C100.809 10.1308 101.877 11.9779 106.091 12.786C108.602 13.3055 109.121 13.7096 109.121 14.5466C109.121 15.3547 108.602 15.8742 106.812 15.8742C104.763 15.8742 102.31 15.1815 100.723 14.2291V18.0099C101.993 18.6448 103.667 19.3375 106.784 19.3375C111.228 19.3375 112.96 17.3749 112.96 14.46Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M57.2012 3.37741V19.1066H64.705L65.8883 15.701H60.8665V3.37741H57.2012Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M42.3381 3.37753V6.78312H46.4075V19.1068H50.0729V6.78312H54.4309V3.37753H42.3381Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M36.9987 3.37731H32.1789L26.6953 19.1065H30.8802L31.6594 16.4513C32.5829 16.7111 33.5642 16.8842 34.6032 16.8842C35.6133 16.8842 36.5946 16.7399 37.547 16.4513L38.3263 19.1065H42.5111L36.9987 3.37731ZM34.5744 13.623C33.8817 13.623 33.189 13.5075 32.5541 13.3343L34.5744 6.46544L36.5946 13.3343C35.9597 13.5075 35.2959 13.623 34.5744 13.623Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M77.6921 3.37738H72.8723L67.3888 19.0777H71.5736L72.3528 16.4225C73.2764 16.6823 74.2577 16.8554 75.2967 16.8554C76.3068 16.8554 77.2881 16.7111 78.2405 16.4225L79.0197 19.0777H83.2046L77.6921 3.37738ZM75.2678 13.623C74.5751 13.623 73.8825 13.5076 73.2475 13.3344L75.2678 6.4655L77.2881 13.3344C76.6531 13.5076 75.9605 13.623 75.2678 13.623Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M134.029 3.37738H129.209L123.725 19.0777H127.91L128.69 16.4225C129.613 16.6823 130.594 16.8554 131.633 16.8554C132.643 16.8554 133.625 16.7111 134.577 16.4225L135.356 19.0777H139.541L134.029 3.37738ZM131.633 13.623C130.941 13.623 130.248 13.5076 129.613 13.3344L131.633 6.4655L133.654 13.3344C132.99 13.5076 132.326 13.623 131.633 13.623Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M5.68241 8.83154C5.3938 8.51407 4.96089 8.54293 4.75886 8.91813L0.0545261 18.2979C-0.11864 18.6731 0.141109 19.106 0.545162 19.106H7.06774C7.26977 19.106 7.47179 18.9906 7.55838 18.7886C9.00143 15.8736 8.1356 11.4579 5.68241 8.83154Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M9.11676 0.288996C6.49041 4.44497 6.66357 9.03387 8.39523 12.4972C10.1269 15.9605 11.4545 18.5868 11.5411 18.7889C11.6277 18.9909 11.8297 19.1063 12.0317 19.1063H18.5543C18.9583 19.1063 19.247 18.6734 19.0449 18.2982C19.0449 18.2982 10.2712 0.750771 10.0403 0.317857C9.86714 -0.0861967 9.3765 -0.115058 9.11676 0.288996Z",
                    fill: "#1868DB"
                })
            ]
        })
    });

});

parcelRegister("2f1ve", function(module, exports) {
$parcel$export(module.exports, "AtlassianMarkBrandV2", function () { return $ee71f13bcc0ecfbc$export$645b7a2693bb4b6d; });

var $7VQPk = parcelRequire("7VQPk");
const $ee71f13bcc0ecfbc$export$645b7a2693bb4b6d = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.3175 36.5672L25.4402 4.81262C25.1276 4.12502 24.8151 4 24.44 4C24.1275 4 23.7524 4.12502 23.3774 4.75011C21.127 8.31312 20.1269 12.4387 20.1269 16.7518C20.1269 22.7527 23.1898 28.3785 27.6905 37.4423C28.1906 38.4425 28.5656 38.63 29.4407 38.63H40.4423C41.2549 38.63 41.6925 38.3175 41.6925 37.6924C41.6925 37.3798 41.63 37.1923 41.3175 36.5672ZM18.2516 21.565C17.0014 19.6898 16.6264 19.5647 16.3138 19.5647C16.0013 19.5647 15.8138 19.6898 15.2512 20.8149L7.31255 36.6922C7.06251 37.1923 7 37.3798 7 37.6299C7 38.1299 7.43756 38.63 8.3752 38.63H19.5643C20.3144 38.63 20.877 38.0049 21.1895 36.8172C21.5646 35.317 21.6896 34.0043 21.6896 32.4416C21.6896 28.066 19.7518 23.8154 18.2516 21.565Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("jTKTB", function(module, exports) {
$parcel$export(module.exports, "AtlasMarkBrandV2", function () { return $2954379f62bf7a2e$export$a0f4d7d4fe07710b; });

var $7VQPk = parcelRequire("7VQPk");
const $2954379f62bf7a2e$export$a0f4d7d4fe07710b = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_16768_12264)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M24 42.798C14.016 42.798 5.89795 34.68 5.89795 24.696C5.89795 14.712 14.016 6.59399 24 6.59399V9.47599C15.604 9.47599 8.78095 16.299 8.78095 24.695C8.78095 33.091 15.604 39.914 24 39.914V42.796V42.798Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M24 42.798V39.916C32.396 39.916 39.219 33.093 39.219 24.697H42.101C42.101 34.681 33.983 42.799 23.999 42.799L24 42.798Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M42.102 24.696H39.22C39.22 16.3 32.397 9.477 24.001 9.477V6.595C33.985 6.595 42.103 14.713 42.103 24.697L42.102 24.696Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.711 30.238C29.7889 29.862 28.2719 29.18 25.7509 28.038C25.055 27.732 24.289 27.384 23.412 26.994C22.883 26.757 22.396 26.548 21.908 26.34C18.107 24.655 16.018 23.736 13.4559 23.736C11.6599 23.736 10.3089 24.223 9.55695 25.142C9.04195 25.755 8.83295 26.548 8.98595 27.314L6.15895 27.857C5.85295 26.242 6.26995 24.585 7.32895 23.304C8.24795 22.19 10.0579 20.853 13.4559 20.853C16.6309 20.853 19.1929 21.995 23.0779 23.708C23.5509 23.917 24.039 24.14 24.568 24.362C25.459 24.752 26.239 25.1 26.9349 25.42C29.344 26.506 30.667 27.105 32.268 27.411L31.711 30.238Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M34.5259 30.516C33.5649 30.516 32.6459 30.432 31.7129 30.238L32.2699 27.411C33.0219 27.564 33.7599 27.634 34.5259 27.634C36.3079 27.634 37.6589 27.188 38.4389 26.339C39.2189 25.49 39.2469 24.459 39.2049 23.916L42.0729 23.665C42.2259 25.419 41.6969 27.063 40.5689 28.288C39.6359 29.304 37.8399 30.516 34.5259 30.516Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M24.0001 42.798V39.916C28.1361 39.916 30.6001 35.697 30.6001 28.637C30.6001 21.577 28.0941 15.659 22.9561 10.187L25.0591 8.20999C30.7261 14.239 33.4831 20.923 33.4831 28.637C33.4831 37.368 29.8491 42.798 24.0001 42.798Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M23.998 42.798C17.774 42.798 14.209 37.73 14.209 28.888C14.209 18.57 18.721 12.805 22.94 8.224L25.057 10.173C20.142 15.52 17.092 20.505 17.092 28.887C17.092 38.007 20.852 39.915 23.999 39.915V42.797L23.998 42.798Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M16.285 26.2C18.146 26.2 19.655 24.691 19.655 22.83C19.655 20.969 18.146 19.46 16.285 19.46C14.424 19.46 12.915 20.969 12.915 22.83C12.915 24.691 14.424 26.2 16.285 26.2Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.8629 32.007C33.7239 32.007 35.2329 30.498 35.2329 28.637C35.2329 26.776 33.7239 25.267 31.8629 25.267C30.0019 25.267 28.4929 26.776 28.4929 28.637C28.4929 30.498 30.0019 32.007 31.8629 32.007Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M23.997 11.941C25.858 11.941 27.367 10.432 27.367 8.57099C27.367 6.70999 25.858 5.20099 23.997 5.20099C22.136 5.20099 20.627 6.70999 20.627 8.57099C20.627 10.432 22.136 11.941 23.997 11.941Z",
                        fill: "#1868DB"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_16768_12264",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white"
                    })
                })
            })
        ]
    });

});

parcelRegister("1WFXk", function(module, exports) {
$parcel$export(module.exports, "BambooMarkBrandV2", function () { return $5a85a0e7135ff674$export$c9beccc57a70ead8; });

var $7VQPk = parcelRequire("7VQPk");
const $5a85a0e7135ff674$export$c9beccc57a70ead8 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_16768_8499)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.2549 15.495L25.7369 25.379V25.378C25.0619 25.958 24.0179 25.478 24.0179 24.588V4.81997C24.0179 3.92997 25.0619 3.44997 25.7369 4.02997L37.2549 13.915C37.7389 14.33 37.7389 15.079 37.2549 15.495ZM31.573 25.6321H39.566V25.6331C40.17 25.6331 40.649 26.1461 40.609 26.7491C40.079 34.6571 33.964 41.0521 26.178 42.0681L24.017 32.1823V42.2231C15.582 42.2231 8.61002 35.9191 7.54602 27.7891H7.54702L17.453 25.6331C17.453 29.2441 20.398 32.1811 24.017 32.1811V32.1821C27.335 32.1821 30.086 29.7141 30.521 26.5201C30.591 26.0041 31.053 25.6321 31.573 25.6321ZM7.38794 25.632V25.474C7.46594 17.129 13.7569 10.253 21.8549 9.19702L24.0159 19.083C20.3969 19.083 17.4519 22.019 17.4519 25.632H7.38794Z",
                    fill: "#1868DB"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_16768_8499",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white"
                    })
                })
            })
        ]
    });

});

parcelRegister("l2YUn", function(module, exports) {
$parcel$export(module.exports, "BitbucketMarkBrandV2", function () { return $08eb9d1adbb0994a$export$5de0ae942520d39; });

var $7VQPk = parcelRequire("7VQPk");
const $08eb9d1adbb0994a$export$5de0ae942520d39 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M38.3789 23.417L35.9515 38.2453C35.7932 39.1424 35.16 39.6701 34.2629 39.6701H13.6827C12.7856 39.6701 12.1523 39.1424 11.994 38.2453L7.71967 11.8076C7.56136 10.9105 8.03629 10.3301 8.88061 10.3301H39.0649C39.9092 10.3301 40.3842 10.9105 40.2259 11.8076L39.0649 18.7732C38.9066 19.7759 38.3262 20.198 37.3763 20.198H19.2235C18.9596 20.198 18.8013 20.3563 18.8541 20.673L20.2789 29.4327C20.3317 29.6438 20.49 29.8021 20.701 29.8021H27.2445C27.4556 29.8021 27.6139 29.6438 27.6667 29.4327L28.6693 23.1004C28.7748 22.3088 29.3025 21.9922 30.0413 21.9922H37.1652C38.2206 21.9922 38.5372 22.5199 38.3789 23.417Z",
            fill: "#1868DB"
        })
    });

});

parcelRegister("bvlrB", function(module, exports) {
$parcel$export(module.exports, "CompassMarkBrandV2", function () { return $6368dac55168e09c$export$2eadba49aa9749d1; });

var $7VQPk = parcelRequire("7VQPk");
const $6368dac55168e09c$export$2eadba49aa9749d1 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            id: "Container",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M23.4999 23.1804V32.0934H14.5699V23.1804H23.4999V14.2734H7.20985C6.33985 14.2794 5.63985 14.9774 5.64585 15.8334C5.64585 15.8404 5.64585 15.8474 5.64585 15.8544V39.4664C5.62785 40.3224 6.31885 41.0294 7.18785 41.0474C7.19485 41.0474 7.20285 41.0474 7.20985 41.0474H30.8439C31.7139 41.0414 32.4139 40.3434 32.4079 39.4874C32.4079 39.4804 32.4079 39.4734 32.4079 39.4664V23.1804H23.4999Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M23.5 5.36084V14.2728H32.451V23.1798H41.354V6.92084C41.372 6.06484 40.681 5.35784 39.812 5.33984C39.805 5.33984 39.797 5.33984 39.79 5.33984L23.5 5.36084Z",
                    fill: "#1868DB"
                })
            ]
        })
    });

});

parcelRegister("aHSNj", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoBrandV2", function () { return $0348efe4ef4a1e80$export$c2a73c5959c3737f; });

var $7VQPk = parcelRequire("7VQPk");
const $0348efe4ef4a1e80$export$c2a73c5959c3737f = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 146 26",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                id: "Container",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M15.451 15.313c-4.937-2.388-6.38-2.745-8.46-2.745-2.442 0-4.522 1.016-6.38 3.87l-.306.466c-.25.385-.305.522-.305.686 0 .165.083.302.388.494l3.135 1.949c.166.11.305.165.444.165.166 0 .277-.083.444-.33l.499-.768c.777-1.18 1.47-1.564 2.358-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.082.86-.302l1.553-3.403c.167-.384.056-.631-.333-.823zM1.054 9.303c4.938 2.387 6.38 2.744 8.46 2.744 2.442 0 4.523-1.016 6.381-3.87l.305-.466c.25-.384.306-.522.306-.686 0-.165-.084-.302-.389-.494l-3.135-1.949c-.166-.11-.305-.164-.443-.164-.167 0-.278.082-.444.329l-.5.768c-.776 1.18-1.47 1.565-2.357 1.565-.777 0-1.693-.22-2.83-.769L3.135 4.774c-.333-.164-.694-.082-.86.302L.72 8.48c-.166.384-.055.631.333.824z",
                            fill: "#1868DB"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M129.367 9.357c-2.093 0-3.151 1.357-3.358 3.358h6.417c-.115-2.14-1.081-3.358-3.059-3.358zm4.416 9.476c-.943.506-2.392.69-3.565.69-4.301 0-6.187-2.484-6.187-6.003 0-3.473 1.932-5.957 5.428-5.957 3.542 0 4.968 2.46 4.968 5.957v.897h-8.395c.276 1.955 1.541 3.22 4.255 3.22a10.19 10.19 0 0 0 3.496-.621v1.817zM122.463 17.223v1.77c-.69.369-1.748.53-2.806.53-4.094 0-6.003-2.484-6.003-6.003 0-3.473 1.909-5.957 6.003-5.957 1.035 0 1.84.138 2.737.552v1.84c-.736-.345-1.518-.552-2.599-.552-2.99 0-4.209 1.886-4.209 4.117 0 2.23 1.242 4.117 4.255 4.117 1.173 0 1.909-.161 2.622-.414zM111.587 12.554v6.739h-1.978v-6.946c0-2.07-.828-2.99-2.714-2.99-1.84 0-3.105 1.219-3.105 3.542v6.394h-1.978v-11.5h1.978v1.886c.736-1.357 2.093-2.116 3.634-2.116 2.645 0 4.163 1.817 4.163 4.99zM94.396 9.357c-2.093 0-3.151 1.357-3.358 3.358h6.417c-.115-2.14-1.081-3.358-3.06-3.358zm4.416 9.476c-.943.506-2.392.69-3.565.69-4.301 0-6.187-2.484-6.187-6.003 0-3.473 1.932-5.957 5.428-5.957 3.542 0 4.968 2.46 4.968 5.957v.897H91.06c.276 1.955 1.54 3.22 4.255 3.22a10.19 10.19 0 0 0 3.496-.621v1.817zM76.986 14.532v-6.74h1.978v6.947c0 2.07.828 2.99 2.714 2.99 1.84 0 3.105-1.22 3.105-3.542V7.793h1.978v11.5h-1.978v-1.886c-.736 1.357-2.093 2.116-3.634 2.116-2.645 0-4.163-1.817-4.163-4.991zM75.314 19.27c-.161.046-.506.092-1.012.092-1.886 0-3.082-.897-3.082-3.013V2.986h1.978v13.133c0 1.035.69 1.403 1.54 1.403.208 0 .346 0 .576-.023v1.77zM66.117 6.574v1.219h2.967v1.84h-2.967v9.66h-1.932v-9.66h-1.863v-1.84h1.863V6.528c0-2.14 1.196-3.588 3.657-3.588.598 0 .99.092 1.334.184V4.94a6.526 6.526 0 0 0-1.242-.115c-1.219 0-1.817.713-1.817 1.748zM60.623 12.554v6.739h-1.978v-6.946c0-2.07-.828-2.99-2.714-2.99-1.84 0-3.105 1.219-3.105 3.542v6.394h-1.978v-11.5h1.978v1.886c.736-1.357 2.093-2.116 3.634-2.116 2.645 0 4.163 1.817 4.163 4.99zM43.12 19.523c-3.45 0-5.473-2.553-5.473-6.003s2.023-5.957 5.474-5.957c3.426 0 5.427 2.507 5.427 5.957 0 3.45-2 6.003-5.428 6.003zm0-10.12c-2.46 0-3.541 1.932-3.541 4.117s1.08 4.163 3.541 4.163c2.439 0 3.497-1.978 3.497-4.163 0-2.185-1.058-4.117-3.496-4.117zM36.196 16.625v2c-.943.622-2.438.898-4.002.898-4.968 0-7.774-2.99-7.774-7.751 0-4.6 2.806-7.82 7.728-7.82 1.472 0 2.944.276 4.025 1.058v2c-1.081-.69-2.277-1.057-4.025-1.057-3.542 0-5.658 2.346-5.658 5.819s2.185 5.773 5.773 5.773c1.587 0 2.829-.368 3.933-.92z",
                        fill: "#101214"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(0 .293)",
                        d: "M0 0h134.5v24H0z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(0 4.418)",
                        d: "M0 0h16.506v15.78H0z"
                    })
                ]
            })
        ]
    });

});

parcelRegister("5Uj3F", function(module, exports) {
$parcel$export(module.exports, "ConfluenceMarkBrandV2", function () { return $232c4578b79388ba$export$3dd8a6d61d16c272; });

var $7VQPk = parcelRequire("7VQPk");
const $232c4578b79388ba$export$3dd8a6d61d16c272 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.6528 30.0401C28.7772 25.265 25.8922 24.5514 21.7311 24.5514C16.8488 24.5514 12.6878 26.5822 8.97058 32.2905L8.36029 33.2236C7.86096 33.992 7.75 34.2664 7.75 34.5957C7.75 34.9251 7.91644 35.1995 8.52673 35.5837L14.7961 39.4807C15.1289 39.7002 15.4063 39.81 15.6837 39.81C16.0166 39.81 16.2386 39.6453 16.5714 39.1514L17.5701 37.6145C19.1236 35.2544 20.5106 34.486 22.286 34.486C23.8394 34.486 25.6703 34.9251 27.945 36.0228L34.4917 39.0965C35.1575 39.4258 35.8787 39.2611 36.2116 38.4927L39.3185 31.6867C39.6514 30.9183 39.4295 30.4243 38.6528 30.0401ZM9.85827 18.0199C19.7338 22.795 22.6188 23.5086 26.7799 23.5086C31.6622 23.5086 35.8233 21.4778 39.5405 15.7695L40.1507 14.8364C40.6501 14.068 40.761 13.7936 40.761 13.4643C40.761 13.1349 40.5946 12.8605 39.9843 12.4763L33.715 8.57932C33.3821 8.35977 33.1047 8.25 32.8273 8.25C32.4944 8.25 32.2725 8.41466 31.9396 8.90864L30.9409 10.4455C29.3875 12.8056 28.0005 13.574 26.2251 13.574C24.6716 13.574 22.8408 13.1349 20.566 12.0372L14.0193 8.96353C13.3536 8.63421 12.6323 8.79887 12.2994 9.56729L9.1925 16.3733C8.85961 17.1417 9.08154 17.6357 9.85827 18.0199Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("i4djl", function(module, exports) {
$parcel$export(module.exports, "FocusMarkBrand", function () { return $d4d5d8c47a490234$export$3707f16280c74624; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $d4d5d8c47a490234$export$3707f16280c74624 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fill: (0, $bNzAT.default)('color.primary.blue'),
            d: "m40.7 23.9c-3.3-3.3-8.6-3.2-11.8 0l-2.7 2.7c-1.5 1.5-3.9 1.5-5.4 0l-2.3-2.3-5.9 5.9 2.3 2.3c4.7 4.7 12.4 4.7 17.2 0zm-34.5-0.8c3.3 3.2 8.5 3.3 11.8 0l2.7-2.7c1.5-1.5 4-1.5 5.5 0l2.2 2.2 5.9-5.9-2.2-2.2c-4.8-4.8-12.5-4.8-17.2 0l-8.7 8.6z"
        })
    });

});

parcelRegister("b9cqO", function(module, exports) {
$parcel$export(module.exports, "GuardMarkBrand", function () { return $5d46b3acfc5be4c8$export$1d519f343b439cb1; });

var $7VQPk = parcelRequire("7VQPk");
const $5d46b3acfc5be4c8$export$1d519f343b439cb1 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.37669 21.2881H39.6216C40.5194 21.2881 40.9983 20.8092 40.9983 19.9114V9.37669C40.9983 8.47885 40.5194 8 39.6216 8H33.0374C32.1396 8 31.6607 8.47885 31.6607 9.37669V14.7039H28.6679V9.37669C28.6679 8.47885 28.1891 8 27.2912 8H20.707C19.8092 8 19.3304 8.47885 19.3304 9.37669V14.7039H16.3376V9.37669C16.3376 8.47885 15.8587 8 14.9609 8H8.37669C7.47885 8 7 8.47885 7 9.37669V19.9114C7 20.8092 7.47885 21.2881 8.37669 21.2881ZM8.9154 30.5059C8.25698 28.6504 7.83799 26.735 7.71827 24.5203C7.65842 23.7422 8.01755 23.3232 8.85554 23.3232H39.1427C39.9807 23.3232 40.3399 23.6823 40.3399 24.4006C40.2201 26.6153 39.8011 28.6504 39.0829 30.5059C38.7237 31.4636 38.185 31.8826 37.1675 31.8826H10.8308C9.81324 31.8826 9.27453 31.4636 8.9154 30.5059ZM36.6288 35.474C33.7557 39.0055 29.027 41.28 23.9991 41.28C18.9712 41.28 14.1229 39.0055 11.3096 35.474C10.5914 34.5163 10.9505 33.9177 11.6688 33.9177H36.3295C37.0478 33.9177 37.4069 34.5163 36.6288 35.474Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("h6nLi", function(module, exports) {
$parcel$export(module.exports, "JiraAlignMarkBrandV2", function () { return $eb0ca46bd89017c2$export$6a69abb7a71a8079; });

var $7VQPk = parcelRequire("7VQPk");
const $eb0ca46bd89017c2$export$6a69abb7a71a8079 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.2797 38.2807C38.2797 32.8745 33.8565 28.5059 28.5049 28.5059H19.4946V20.2601H9.71973V36.4786C9.71973 37.7346 10.2658 38.2807 11.5218 38.2807H38.2797ZM9.71973 9.7207C9.71973 15.1269 14.0338 19.4955 19.44 19.4955H28.5049V27.7414H38.2797V11.5228C38.2797 10.3214 37.679 9.7207 36.4777 9.7207H9.71973Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("eRZDs", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoBrandV2", function () { return $b296a5f752b3040c$export$4c9f7b428667c43c; });

var $7VQPk = parcelRequire("7VQPk");
const $b296a5f752b3040c$export$4c9f7b428667c43c = ({ width: width, height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 476 48",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_11686_137974)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        clipPath: "url(#clip1_11686_137974)",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M18.9824 7.51668C23.3432 8.79592 27.7467 8.79592 32.1075 7.51668C32.4923 7.43139 32.7488 7.68724 32.6633 8.07102C31.4235 12.5484 31.4235 16.6846 32.6633 21.1619C32.7488 21.5031 32.4923 21.8016 32.1075 21.6736C27.7467 20.4797 23.3432 20.4797 18.9824 21.6736C18.6403 21.8016 18.3411 21.5031 18.4693 21.1619C19.6236 16.6846 19.6236 12.5484 18.4693 8.07102C18.3411 7.68724 18.6403 7.43139 18.9824 7.51668ZM20.7352 23.3793V24.1042C20.7352 27.4729 18.3838 29.9461 15.4766 29.9461C12.5694 29.9461 10.2607 27.6008 10.2607 24.7012C10.2607 21.8016 12.6121 19.4989 15.9041 19.4989H16.7592V9.30762C16.3317 9.26498 15.9041 9.26498 15.4766 9.26498C6.92599 9.26498 0 16.1729 0 24.7438C0 33.3148 6.92599 40.18 15.4766 40.18C24.0272 40.18 30.996 33.2721 30.996 24.7438V23.3793H20.7352Z",
                            fill: "#1868DB"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M462.826 36.528H460.25L451.924 15H456.156L463.516 34.688L470.876 15H475.108L466.414 37.264C463.838 43.842 462.366 47.246 456.524 47.246C454.546 47.246 453.442 47.062 452.292 46.602V43.198C453.626 43.612 455.144 43.75 456.294 43.75C459.514 43.75 460.94 41.542 462.826 36.528Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M442.956 24.4301V38.0001H439.092V15.0001H442.956V19.0481C444.29 16.3341 446.59 14.4021 451.098 14.6781V18.5421C446.038 18.0361 442.956 19.5541 442.956 24.4301Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M424.261 18.128C420.075 18.128 417.959 20.842 417.545 24.844H430.379C430.149 20.566 428.217 18.128 424.261 18.128ZM433.093 37.08C431.207 38.092 428.309 38.46 425.963 38.46C417.361 38.46 413.589 33.492 413.589 26.454C413.589 19.508 417.453 14.54 424.445 14.54C431.529 14.54 434.381 19.462 434.381 26.454V28.248H417.591C418.143 32.158 420.673 34.688 426.101 34.688C428.769 34.688 431.023 34.182 433.093 33.446V37.08Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M403.517 38H398.227L389.303 15H393.443L400.895 34.642L408.301 15H412.441L403.517 38Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M377.324 38.46C370.424 38.46 366.376 33.354 366.376 26.454C366.376 19.554 370.424 14.54 377.324 14.54C384.178 14.54 388.18 19.554 388.18 26.454C388.18 33.354 384.178 38.46 377.324 38.46ZM377.324 18.22C372.402 18.22 370.24 22.084 370.24 26.454C370.24 30.824 372.402 34.78 377.324 34.78C382.2 34.78 384.316 30.824 384.316 26.454C384.316 22.084 382.2 18.22 377.324 18.22Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M363.24 33.86V37.402C361.86 38.138 359.744 38.46 357.628 38.46C349.44 38.46 345.622 33.492 345.622 26.454C345.622 19.508 349.44 14.54 357.628 14.54C359.698 14.54 361.308 14.816 363.102 15.644V19.324C361.63 18.634 360.066 18.22 357.904 18.22C351.924 18.22 349.486 21.992 349.486 26.454C349.486 30.916 351.97 34.688 357.996 34.688C360.342 34.688 361.814 34.366 363.24 33.86Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M342.432 31.744C342.432 35.562 339.948 38.46 333.784 38.46C330.334 38.46 327.528 37.678 325.78 36.758V32.572C327.758 33.722 331.07 34.826 333.968 34.826C337.004 34.826 338.568 33.584 338.568 31.79C338.568 30.042 337.234 29.03 332.864 27.972C327.758 26.73 325.596 24.752 325.596 20.98C325.596 16.978 328.678 14.54 333.922 14.54C336.912 14.54 339.626 15.276 341.328 16.196V20.29C338.568 18.91 336.314 18.174 333.876 18.174C330.978 18.174 329.414 19.186 329.414 20.98C329.414 22.59 330.518 23.602 334.75 24.614C339.856 25.856 342.432 27.742 342.432 31.744Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M315.898 8.92797C315.898 7.17997 317.048 6.16797 318.658 6.16797C320.268 6.16797 321.418 7.17997 321.418 8.92797C321.418 10.676 320.268 11.688 318.658 11.688C317.048 11.688 315.898 10.676 315.898 8.92797ZM316.634 38V15H320.59V38H316.634Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M297.516 11.7341H290.708V34.0441H297.746C304.646 34.0441 308.096 30.4101 308.096 23.0961C308.096 15.7361 304.83 11.7341 297.516 11.7341ZM286.568 38.0001V7.77808H297.7C307.498 7.77808 312.236 13.8961 312.236 22.9581C312.236 32.1121 307.452 38.0001 297.7 38.0001H286.568Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M266.45 30.87C266.45 32.894 267.646 34.274 270.084 34.274C271.004 34.274 271.878 34.09 272.568 33.952V37.77C271.878 37.954 271.096 38.138 269.9 38.138C264.978 38.138 262.586 35.24 262.586 30.962V18.68H258.86V15H262.586V10.124H266.45V15H272.568V18.68H266.45V30.87Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M256.46 33.86V37.402C255.08 38.138 252.964 38.46 250.848 38.46C242.66 38.46 238.842 33.492 238.842 26.454C238.842 19.508 242.66 14.54 250.848 14.54C252.918 14.54 254.528 14.816 256.322 15.644V19.324C254.85 18.634 253.286 18.22 251.124 18.22C245.144 18.22 242.706 21.992 242.706 26.454C242.706 30.916 245.19 34.688 251.216 34.688C253.562 34.688 255.034 34.366 256.46 33.86Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M214.696 28.478V15H218.652V28.892C218.652 33.032 220.308 34.872 224.08 34.872C227.76 34.872 230.29 32.434 230.29 27.788V15H234.246V38H230.29V34.228C228.818 36.942 226.104 38.46 223.022 38.46C217.732 38.46 214.696 34.826 214.696 28.478Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M192.216 26.5C192.216 32.02 194.424 34.78 198.518 34.78C202.06 34.78 205.234 32.526 205.234 27.42V25.58C205.234 20.474 202.336 18.22 198.978 18.22C194.516 18.22 192.216 21.164 192.216 26.5ZM205.234 38V33.86C203.762 36.896 201.002 38.46 197.46 38.46C191.342 38.46 188.26 33.262 188.26 26.5C188.26 20.014 191.48 14.54 197.92 14.54C201.278 14.54 203.854 16.058 205.234 19.048V5.38599H209.19V38H205.234Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M174.187 38.46C167.287 38.46 163.239 33.354 163.239 26.454C163.239 19.554 167.287 14.54 174.187 14.54C181.041 14.54 185.043 19.554 185.043 26.454C185.043 33.354 181.041 38.46 174.187 38.46ZM174.187 18.22C169.265 18.22 167.103 22.084 167.103 26.454C167.103 30.824 169.265 34.78 174.187 34.78C179.063 34.78 181.179 30.824 181.179 26.454C181.179 22.084 179.063 18.22 174.187 18.22Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M153.524 24.4301V38.0001H149.66V15.0001H153.524V19.0481C154.858 16.3341 157.158 14.4021 161.666 14.6781V18.5421C156.606 18.0361 153.524 19.5541 153.524 24.4301Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M146.02 17.8521C146.02 24.4301 142.34 28.1101 134.796 28.1101H128.77V38.0001H124.63V7.77808H134.796C142.34 7.77808 146.02 11.6421 146.02 17.8521ZM134.336 24.1541C139.672 24.3381 141.742 21.8081 141.742 17.9441C141.742 14.2641 139.672 11.7341 134.336 11.7341H128.77V24.1541H134.336Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M92.5347 26.5C92.5347 32.02 94.7427 34.78 98.8367 34.78C102.379 34.78 105.553 32.526 105.553 27.42V25.58C105.553 20.474 102.655 18.22 99.2967 18.22C94.8347 18.22 92.5347 21.164 92.5347 26.5ZM105.553 38V33.86C104.081 36.896 101.321 38.46 97.7787 38.46C91.6607 38.46 88.5787 33.262 88.5787 26.5C88.5787 20.014 91.7987 14.54 98.2387 14.54C101.597 14.54 104.173 16.058 105.553 19.048V15H109.509V38H105.553Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M78.8638 24.4301V38.0001H74.9998V15.0001H78.8638V19.0481C80.1978 16.3341 82.4978 14.4021 87.0058 14.6781V18.5421C81.9458 18.0361 78.8638 19.5541 78.8638 24.4301Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M64.3359 8.92797C64.3359 7.17997 65.4859 6.16797 67.0959 6.16797C68.7059 6.16797 69.8559 7.17997 69.8559 8.92797C69.8559 10.676 68.7059 11.688 67.0959 11.688C65.4859 11.688 64.3359 10.676 64.3359 8.92797ZM65.0719 38V15H69.0279V38H65.0719Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M55.43 29.0761V7.77808H59.57V28.8001C59.57 34.3661 57.132 38.1841 51.428 38.1841C49.266 38.1841 47.61 37.8161 46.46 37.4021V33.4001C47.702 33.9061 49.22 34.1821 50.738 34.1821C54.234 34.1821 55.43 32.0661 55.43 29.0761Z",
                        fill: "#101214"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_11686_137974",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "476",
                            height: "48",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip1_11686_137974",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "32.68",
                            height: "32.68",
                            fill: "white",
                            transform: "translate(0 7.5)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("jB0Ze", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryMarkBrandV2", function () { return $32a511942a08f8df$export$3e613b2a74610bda; });

var $7VQPk = parcelRequire("7VQPk");
const $32a511942a08f8df$export$3e613b2a74610bda = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.4824 8.51643C30.8432 9.79568 35.2467 9.79568 39.6075 8.51643C39.9923 8.43115 40.2488 8.687 40.1633 9.07077C38.9235 13.5481 38.9235 17.6844 40.1633 22.1617C40.2488 22.5028 39.9923 22.8013 39.6075 22.6734C35.2467 21.4794 30.8432 21.4794 26.4824 22.6734C26.1403 22.8013 25.8411 22.5028 25.9693 22.1617C27.1236 17.6844 27.1236 13.5481 25.9693 9.07077C25.8411 8.687 26.1403 8.43115 26.4824 8.51643ZM28.2352 24.3791V25.104C28.2352 28.4726 25.8838 30.9458 22.9766 30.9458C20.0694 30.9458 17.7607 28.6006 17.7607 25.7009C17.7607 22.8013 20.1121 20.4987 23.4041 20.4987H24.2592V10.3074C23.8317 10.2647 23.4041 10.2647 22.9766 10.2647C14.426 10.2647 7.5 17.1727 7.5 25.7436C7.5 34.3145 14.426 41.1798 22.9766 41.1798C31.5272 41.1798 38.496 34.2719 38.496 25.7436V24.3791H28.2352Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("37fXF", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoBrandV2", function () { return $8c2e7ce37ce2376f$export$ad8cbd489d86874b; });

var $7VQPk = parcelRequire("7VQPk");
const $8c2e7ce37ce2376f$export$ad8cbd489d86874b = ({ width: width, height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 542 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_11686_137903)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        clipPath: "url(#clip1_11686_137903)",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M21.1863 19.5744H32.1729C33.8229 19.5744 34.3863 21.1439 33.3802 22.3915L16.196 43.6C10.6424 39.1732 11.1655 32.1707 15.2302 27.0598L21.1863 19.5744ZM12.6948 28.0256H1.70823C0.058226 28.0256 -0.505189 26.4561 0.500909 25.2085L17.6851 4C23.2387 8.42683 22.6351 15.3488 18.6107 20.5L12.6948 28.0256Z",
                            fill: "#1868DB"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M535.611 30.87C535.611 32.894 536.807 34.274 539.245 34.274C540.165 34.274 541.039 34.09 541.729 33.952V37.77C541.039 37.954 540.257 38.138 539.061 38.138C534.139 38.138 531.747 35.24 531.747 30.962V18.68H528.021V15H531.747V10.124H535.611V15H541.729V18.68H535.611V30.87Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M524.62 24.522V38H520.664V24.108C520.664 19.968 519.008 18.128 515.236 18.128C511.556 18.128 509.026 20.566 509.026 25.212V38H505.07V15H509.026V18.772C510.498 16.058 513.212 14.54 516.294 14.54C521.584 14.54 524.62 18.174 524.62 24.522Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M490.239 18.128C486.053 18.128 483.937 20.842 483.523 24.844H496.357C496.127 20.566 494.195 18.128 490.239 18.128ZM499.071 37.08C497.185 38.092 494.287 38.46 491.941 38.46C483.339 38.46 479.567 33.492 479.567 26.454C479.567 19.508 483.431 14.54 490.423 14.54C497.507 14.54 500.359 19.462 500.359 26.454V28.248H483.569C484.121 32.158 486.651 34.688 492.079 34.688C494.747 34.688 497.001 34.182 499.071 33.446V37.08Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M459.843 25.212V38H455.887V24.108C455.887 19.968 454.231 18.128 450.459 18.128C446.779 18.128 444.249 20.566 444.249 25.212V38H440.293V15H444.249V18.772C445.721 16.058 448.435 14.54 451.517 14.54C455.427 14.54 458.095 16.518 459.245 20.152C460.533 16.61 463.615 14.54 467.433 14.54C472.585 14.54 475.437 18.036 475.437 24.522V38H471.481V25.212C471.481 20.474 469.825 18.128 466.053 18.128C462.373 18.128 459.843 20.566 459.843 25.212Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M425.462 18.128C421.276 18.128 419.16 20.842 418.746 24.844H431.58C431.35 20.566 429.418 18.128 425.462 18.128ZM434.294 37.08C432.408 38.092 429.51 38.46 427.164 38.46C418.562 38.46 414.79 33.492 414.79 26.454C414.79 19.508 418.654 14.54 425.646 14.54C432.73 14.54 435.582 19.462 435.582 26.454V28.248H418.792C419.344 32.158 421.874 34.688 427.302 34.688C429.97 34.688 432.224 34.182 434.294 33.446V37.08Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M406.336 36.16V33.86C404.864 36.896 402.104 38.46 398.562 38.46C392.49 38.46 389.454 33.262 389.454 26.5C389.454 20.014 392.628 14.54 399.022 14.54C402.38 14.54 404.956 16.058 406.336 19.048V15H410.2V35.93C410.2 42.692 407.026 47.246 398.792 47.246C394.928 47.246 392.812 46.74 390.604 46.004V42.14C393.134 42.968 395.756 43.52 398.608 43.52C404.358 43.52 406.336 40.438 406.336 36.16ZM393.318 26.5C393.318 32.02 395.526 34.78 399.62 34.78C403.162 34.78 406.336 32.526 406.336 27.42V25.58C406.336 20.474 403.438 18.22 400.08 18.22C395.618 18.22 393.318 21.164 393.318 26.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M367.894 26.5C367.894 32.02 370.102 34.78 374.196 34.78C377.738 34.78 380.912 32.526 380.912 27.42V25.58C380.912 20.474 378.014 18.22 374.656 18.22C370.194 18.22 367.894 21.164 367.894 26.5ZM380.912 38V33.86C379.44 36.896 376.68 38.46 373.138 38.46C367.02 38.46 363.938 33.262 363.938 26.5C363.938 20.014 367.158 14.54 373.598 14.54C376.956 14.54 379.532 16.058 380.912 19.048V15H384.868V38H380.912Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M359.802 24.522V38H355.846V24.108C355.846 19.968 354.19 18.128 350.418 18.128C346.738 18.128 344.208 20.566 344.208 25.212V38H340.252V15H344.208V18.772C345.68 16.058 348.394 14.54 351.476 14.54C356.766 14.54 359.802 18.174 359.802 24.522Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M317.312 26.5C317.312 32.02 319.52 34.78 323.614 34.78C327.156 34.78 330.33 32.526 330.33 27.42V25.58C330.33 20.474 327.432 18.22 324.074 18.22C319.612 18.22 317.312 21.164 317.312 26.5ZM330.33 38V33.86C328.858 36.896 326.098 38.46 322.556 38.46C316.438 38.46 313.356 33.262 313.356 26.5C313.356 20.014 316.576 14.54 323.016 14.54C326.374 14.54 328.95 16.058 330.33 19.048V15H334.286V38H330.33Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M283.162 21.4861L279.022 10.2621V38.0001H274.882V7.77808H282.058L288.912 25.1201L291.718 33.4461L294.524 25.1201L301.424 7.77808H308.094V38.0001H303.954V10.5841L300.412 21.4861L293.742 38.0001H289.74L283.162 21.4861Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M250.895 18.128C246.709 18.128 244.593 20.842 244.179 24.844H257.013C256.783 20.566 254.851 18.128 250.895 18.128ZM259.727 37.08C257.841 38.092 254.943 38.46 252.597 38.46C243.995 38.46 240.223 33.492 240.223 26.454C240.223 19.508 244.087 14.54 251.079 14.54C258.163 14.54 261.015 19.462 261.015 26.454V28.248H244.225C244.777 32.158 247.307 34.688 252.735 34.688C255.403 34.688 257.657 34.182 259.727 33.446V37.08Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M237.087 33.86V37.402C235.707 38.138 233.591 38.46 231.475 38.46C223.287 38.46 219.469 33.492 219.469 26.454C219.469 19.508 223.287 14.54 231.475 14.54C233.545 14.54 235.155 14.816 236.949 15.644V19.324C235.477 18.634 233.913 18.22 231.751 18.22C225.771 18.22 223.333 21.992 223.333 26.454C223.333 30.916 225.817 34.688 231.843 34.688C234.189 34.688 235.661 34.366 237.087 33.86Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M210.186 8.92797C210.186 7.17997 211.336 6.16797 212.946 6.16797C214.556 6.16797 215.706 7.17997 215.706 8.92797C215.706 10.676 214.556 11.688 212.946 11.688C211.336 11.688 210.186 10.676 210.186 8.92797ZM210.922 38V15H214.878V38H210.922Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M198.571 38H193.281L184.357 15H188.497L195.949 34.642L203.355 15H207.495L198.571 38Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M175.389 24.4301V38.0001H171.525V15.0001H175.389V19.0481C176.723 16.3341 179.023 14.4021 183.531 14.6781V18.5421C178.471 18.0361 175.389 19.5541 175.389 24.4301Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M156.694 18.128C152.508 18.128 150.392 20.842 149.978 24.844H162.812C162.582 20.566 160.65 18.128 156.694 18.128ZM165.526 37.08C163.64 38.092 160.742 38.46 158.396 38.46C149.794 38.46 146.022 33.492 146.022 26.454C146.022 19.508 149.886 14.54 156.878 14.54C163.962 14.54 166.814 19.462 166.814 26.454V28.248H150.024C150.576 32.158 153.106 34.688 158.534 34.688C161.202 34.688 163.456 34.182 165.526 33.446V37.08Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M142.536 29.6739C142.536 34.9179 139.408 38.4599 131.91 38.4599C126.068 38.4599 123.354 37.3099 121.008 36.1139V31.8819C123.814 33.3539 128.138 34.4119 132.14 34.4119C136.694 34.4119 138.396 32.6179 138.396 29.9499C138.396 27.2819 136.74 25.8559 130.99 24.4759C124.182 22.8199 121.146 20.4739 121.146 15.5059C121.146 10.8139 124.734 7.31787 131.772 7.31787C136.142 7.31787 138.948 8.37587 141.018 9.52587V13.6659C137.982 11.9179 134.716 11.3659 131.588 11.3659C127.632 11.3659 125.286 12.7459 125.286 15.5059C125.286 17.9899 127.218 19.2319 132.554 20.5659C138.948 22.1759 142.536 24.2459 142.536 29.6739Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M91.5347 26.5C91.5347 32.02 93.7427 34.78 97.8367 34.78C101.379 34.78 104.553 32.526 104.553 27.42V25.58C104.553 20.474 101.655 18.22 98.2967 18.22C93.8347 18.22 91.5347 21.164 91.5347 26.5ZM104.553 38V33.86C103.081 36.896 100.321 38.46 96.7787 38.46C90.6607 38.46 87.5787 33.262 87.5787 26.5C87.5787 20.014 90.7987 14.54 97.2387 14.54C100.597 14.54 103.173 16.058 104.553 19.048V15H108.509V38H104.553Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M77.8638 24.4301V38.0001H73.9998V15.0001H77.8638V19.0481C79.1978 16.3341 81.4978 14.4021 86.0058 14.6781V18.5421C80.9458 18.0361 77.8638 19.5541 77.8638 24.4301Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M63.3359 8.92797C63.3359 7.17997 64.4859 6.16797 66.0959 6.16797C67.7059 6.16797 68.8559 7.17997 68.8559 8.92797C68.8559 10.676 67.7059 11.688 66.0959 11.688C64.4859 11.688 63.3359 10.676 63.3359 8.92797ZM64.0719 38V15H68.0279V38H64.0719Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M54.43 29.0761V7.77808H58.57V28.8001C58.57 34.3661 56.132 38.1841 50.428 38.1841C48.266 38.1841 46.61 37.8161 45.46 37.4021V33.4001C46.702 33.9061 48.22 34.1821 49.738 34.1821C53.234 34.1821 54.43 32.0661 54.43 29.0761Z",
                        fill: "#101214"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_11686_137903",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "542",
                            height: "48",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip1_11686_137903",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "33.8809",
                            height: "39.6",
                            fill: "white",
                            transform: "translate(0 4)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("26Dc0", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementMarkBrandV2", function () { return $54db0a6a015c6695$export$7253200b26250b25; });

var $7VQPk = parcelRequire("7VQPk");
const $54db0a6a015c6695$export$7253200b26250b25 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.1863 19.5744H39.1729C40.8229 19.5744 41.3863 21.1439 40.3802 22.3915L23.196 43.6C17.6424 39.1732 18.1655 32.1707 22.2302 27.0598L28.1863 19.5744ZM19.6948 28.0256H8.70823C7.05823 28.0256 6.49481 26.4561 7.50091 25.2085L24.6851 4C30.2387 8.42683 29.6351 15.3488 25.6107 20.5L19.6948 28.0256Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("lsNQ4", function(module, exports) {
$parcel$export(module.exports, "JiraLogoBrandV2", function () { return $70b633a77cb3c2a3$export$1ddab17f7fb1073b; });

var $7VQPk = parcelRequire("7VQPk");
const $70b633a77cb3c2a3$export$1ddab17f7fb1073b = ({ width: width, height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 61 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            clipPath: "url(#clip0_2967_1690)",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M31.2078 5.90745H33.4436V17.1052C33.4436 20.0579 32.1134 22.1192 29.0285 22.1192C27.8681 22.1192 26.9625 21.9242 26.3398 21.7013V19.5565C27.0191 19.835 27.8398 19.9743 28.6606 19.9743C30.5568 19.9743 31.2078 18.8601 31.2078 17.2445V5.90745Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M37.5475 5.04395C38.4248 5.04395 39.0475 5.57319 39.0475 6.52027C39.0475 7.43949 38.4248 7.99659 37.5475 7.99659C36.6701 7.99659 36.0475 7.46734 36.0475 6.52027C36.0475 5.60105 36.6701 5.04395 37.5475 5.04395ZM36.4437 9.75147H38.5946V22.0077H36.4437V9.75147Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M43.9152 22.0077H41.8209V9.75146H43.9152V11.8963C44.6511 10.4478 45.8964 9.4172 48.3303 9.55648V11.6178C45.585 11.3392 43.9152 12.147 43.9152 14.7654V22.0077Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M58.3775 19.8072C57.585 21.4228 56.085 22.2584 54.1605 22.2584C50.8492 22.2584 49.1794 19.5008 49.1794 15.8796C49.1794 12.4256 50.9341 9.50077 54.4152 9.50077C56.2265 9.50077 57.6416 10.3086 58.3775 11.8963V9.75147H60.5284V22.0077H58.3775V19.8072ZM54.7265 20.3086C56.6511 20.3086 58.3492 19.1108 58.3492 16.381V15.4061C58.3492 12.6763 56.7926 11.4785 54.953 11.4785C52.5473 11.4785 51.302 13.0384 51.302 15.8796C51.3303 18.8322 52.519 20.3086 54.7265 20.3086Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M19.9721 3.40039H10.1797C10.1797 5.79593 12.1608 7.74579 14.5948 7.74579H16.4061V9.44496C16.4061 11.8405 18.3872 13.7904 20.8212 13.7904V4.23605C20.8212 3.76251 20.4533 3.40039 19.9721 3.40039Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M15.1323 8.19141H5.33984C5.33984 10.5869 7.32098 12.5368 9.75494 12.5368H11.5663V14.2638C11.5663 16.6594 13.5474 18.6092 15.9814 18.6092V9.02706C15.9814 8.58138 15.6134 8.19141 15.1323 8.19141Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M10.2925 13.0107H0.5C0.5 15.4063 2.48113 17.3561 4.91509 17.3561H6.72641V19.0553C6.72641 21.4509 8.70755 23.4007 11.1415 23.4007V13.8464C11.1415 13.3729 10.7453 13.0107 10.2925 13.0107Z",
                    fill: "#1868DB"
                })
            ]
        })
    });

});

parcelRegister("ixjDH", function(module, exports) {
$parcel$export(module.exports, "JiraMarkBrandV2", function () { return $e6cd4392f5130cd3$export$d4addebf13667441; });

var $7VQPk = parcelRequire("7VQPk");
const $e6cd4392f5130cd3$export$d4addebf13667441 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.5504 32.6743H13.2216C8.20121 32.6743 4.59961 29.5992 4.59961 25.0964H22.4984C23.4261 25.0964 24.0264 25.7554 24.0264 26.6889V44.7C19.5517 44.7 16.5504 41.0758 16.5504 36.0239V32.6743ZM25.3906 23.7236H22.0619C17.0415 23.7236 13.4399 20.7034 13.4399 16.2007H31.3387C32.2664 16.2007 32.9213 16.8047 32.9213 17.7382V35.7493C28.4465 35.7493 25.3906 32.1251 25.3906 27.0732V23.7236ZM34.2855 14.8279H30.9567C25.9363 14.8279 22.3347 11.7528 22.3347 7.25H40.2336C41.1613 7.25 41.7615 7.90894 41.7615 8.78754V26.7987C37.2868 26.7987 34.2855 23.1745 34.2855 18.1226V14.8279Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("ghLSk", function(module, exports) {
$parcel$export(module.exports, "LoomMarkBrandV2", function () { return $2ab3d847c0e60c53$export$e783a4d8175ce805; });

var $7VQPk = parcelRequire("7VQPk");
const $2ab3d847c0e60c53$export$e783a4d8175ce805 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M41 22.1094H31.0579L39.6682 17.1383L37.7774 13.8622L29.167 18.8334L34.1371 10.2237L30.861 8.33173L25.891 16.9414V7H22.109V16.9423L17.137 8.33173L13.862 10.2228L18.833 18.8324L10.2227 13.8622L8.33169 17.1373L16.942 22.1085H7V25.8906H16.9411L8.33169 30.8617L10.2227 34.1378L18.8321 29.1676L13.8611 37.7772L17.137 39.6682L22.1081 31.0577V41H25.8901V31.0586L30.8601 39.6682L34.136 37.7772L29.1651 29.1667L37.7754 34.1378L39.6664 30.8617L31.057 25.8915H40.998V22.1094H41ZM24 29.1437C21.1483 29.1437 18.8368 26.8324 18.8368 23.9805C18.8368 21.1287 21.1483 18.8172 24 18.8172C26.8517 18.8172 29.1631 21.1287 29.1631 23.9805C29.1631 26.8324 26.8517 29.1437 24 29.1437Z",
            fill: "#625DF5"
        })
    });

});

parcelRegister("eAedM", function(module, exports) {
$parcel$export(module.exports, "LoomLogoBrandV2", function () { return $cd00f0666106547b$export$dfd116e8ab5ce993; });

var $7VQPk = parcelRequire("7VQPk");
const $cd00f0666106547b$export$dfd116e8ab5ce993 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 79 26",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Container",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M21.95 10.019h-6.418l5.558-3.21-1.22-2.114-5.56 3.209 3.21-5.558-2.116-1.222-3.208 5.558V.264H9.754v6.42l-3.21-5.56L4.43 2.345l3.21 5.558-5.56-3.208L.86 6.809l5.558 3.21H0v2.441h6.418L.86 15.67l1.22 2.114 5.559-3.208-3.21 5.558 2.115 1.22 3.21-5.558v6.419h2.441v-6.419l3.209 5.559 2.115-1.221-3.21-5.559 5.56 3.21 1.22-2.116-5.558-3.208h6.418v-2.442h.001zM10.975 14.56a3.333 3.333 0 1 1 0-6.666 3.333 3.333 0 0 1 0 6.666z",
                            fill: "#565ADD"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M27.892 19.268V3.21h2.948v16.057h-2.948zM56.167 8.356h2.815v1.331c.599-1.064 1.996-1.641 3.192-1.641 1.486 0 2.683.643 3.237 1.818.864-1.331 2.017-1.818 3.458-1.818 2.017 0 3.946 1.22 3.946 4.147v7.075h-2.86v-6.476c0-1.176-.577-2.062-1.929-2.062-1.264 0-2.017.976-2.017 2.151v6.388h-2.926v-6.477c0-1.176-.598-2.062-1.929-2.062-1.286 0-2.04.954-2.04 2.151v6.388h-2.947V8.356zM37.502 19.584c-3.322 0-5.727-2.463-5.727-5.772 0-3.256 2.398-5.778 5.727-5.778 3.345 0 5.726 2.546 5.726 5.778 0 3.284-2.407 5.772-5.727 5.772zm0-8.879a3.11 3.11 0 0 0-3.107 3.108 3.11 3.11 0 0 0 3.106 3.107 3.11 3.11 0 0 0 3.106-3.107 3.11 3.11 0 0 0-3.105-3.108zM49.525 19.584c-3.321 0-5.726-2.463-5.726-5.772 0-3.256 2.397-5.778 5.726-5.778 3.345 0 5.726 2.546 5.726 5.778 0 3.284-2.408 5.772-5.726 5.772zm0-8.916a3.147 3.147 0 0 0-3.142 3.143 3.146 3.146 0 0 0 3.142 3.144 3.147 3.147 0 0 0 3.142-3.144 3.147 3.147 0 0 0-3.142-3.143z",
                            fill: "#252434"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(0 .264)",
                        d: "M0 0h73v24H0z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(0 .264)",
                        d: "M0 0h73v24H0z"
                    })
                ]
            })
        ]
    });

});

parcelRegister("7WVgr", function(module, exports) {
$parcel$export(module.exports, "OpsgenieMarkBrandV2", function () { return $3ae1b7275945cb10$export$a46c7fe09137762; });

var $7VQPk = parcelRequire("7VQPk");
const $3ae1b7275945cb10$export$a46c7fe09137762 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.6706 41.8796C24.493 42.7473 23.8733 42.6853 22.6957 41.8176C16.994 37.7273 11.7261 33.0791 8.19346 28.245C7.82161 27.7492 8.00753 27.0675 8.56531 26.7576L15.0108 22.7292C15.5685 22.3573 16.0643 22.4193 16.4982 22.9151C18.9772 25.766 21.3942 28.5549 24.1831 30.5381C26.972 28.5549 29.3891 25.766 31.8681 22.9151C32.3019 22.4193 32.7977 22.3573 33.3555 22.7292L39.801 26.7576C40.3587 27.0675 40.5447 27.7492 40.1728 28.245C36.6402 33.0791 31.3723 37.7273 25.6706 41.8796ZM24.1831 24.0927C29.2651 24.0927 33.4795 19.9403 33.4795 14.8583C33.4795 9.77631 29.2651 5.5 24.1831 5.5C19.1012 5.5 14.8868 9.71433 14.8868 14.8583C14.8868 20.0023 18.9772 24.0927 24.1831 24.0927Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("itb5R", function(module, exports) {
$parcel$export(module.exports, "RovoMarkBrandV2", function () { return $d00e7ee013274b00$export$28a953c878328858; });

var $7VQPk = parcelRequire("7VQPk");
const $d00e7ee013274b00$export$28a953c878328858 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            id: "Container",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.5892 6.05798C24.3225 5.32718 22.7638 5.31424 21.4868 6.01915C21.4636 6.03708 21.439 6.05366 21.413 6.0687L21.4128 6.0688L21.4101 6.07039C20.5015 6.59546 19.8373 7.43643 19.5247 8.4079C19.3974 8.80997 19.3301 9.23475 19.3301 9.6696V15.1817L26.235 19.1664L26.2355 19.1667C27.9314 20.1419 28.9712 21.9446 28.9712 23.8994L28.9712 38.1293C28.9712 38.7062 28.8797 39.2706 28.7071 39.8047C28.689 39.8614 28.67 39.9178 28.65 39.9738L37.9126 34.6261L37.9136 34.6255C39.2071 33.8818 40.0006 32.5074 40.0006 31.0144V16.7845C40.0006 15.2974 39.2025 13.917 37.9127 13.1729L37.9126 13.1728L25.5892 6.05798Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.08703 13.1871L18.3506 7.83887C18.3306 7.89514 18.3114 7.95179 18.2932 8.00878C18.1208 8.54258 18.0294 9.1067 18.0294 9.68334V23.9132C18.0294 25.8679 19.069 27.6704 20.7646 28.6457L20.7656 28.6462L27.6705 32.631V38.143C27.6705 38.5787 27.603 39.0042 27.4752 39.4069C27.162 40.3785 26.497 41.2193 25.5878 41.7438L25.5876 41.7439C25.5616 41.759 25.537 41.7756 25.5138 41.7935C24.2368 42.4984 22.6782 42.4855 21.4116 41.7548L21.4114 41.7547L9.08806 34.6398L9.08788 34.6397C7.79815 33.8957 7 32.5153 7 31.0281L7 16.7983C7 15.3052 7.79347 13.9308 9.08703 13.1871Z",
                    fill: "#1868DB"
                })
            ]
        })
    });

});

parcelRegister("8zOID", function(module, exports) {
$parcel$export(module.exports, "SourcetreeMarkBrandV2", function () { return $46c7741e728f5e2a$export$b7538bb6f3622b6b; });

var $7VQPk = parcelRequire("7VQPk");
const $46c7741e728f5e2a$export$b7538bb6f3622b6b = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.12988 20.1565C9.12988 26.7815 13.4195 32.358 19.3296 34.3598V41.5091C19.3296 42.2717 19.8062 42.7483 20.5688 42.7483H27.5751C28.3377 42.7483 28.8143 42.2717 28.8143 41.5091V29.6412C28.8143 26.9245 26.9078 25.161 24.4294 25.161C21.1407 25.161 19.0912 22.8732 19.0912 20.1088C19.0912 17.3444 21.093 15.1043 24.0481 15.1043C27.0031 15.1043 29.0526 17.2968 29.0526 20.1088C29.0526 21.777 28.2423 23.3022 27.0031 24.2078C28.9573 25.1133 30.2918 26.9722 30.2918 29.6412V33.7878C35.4393 31.4047 39.014 26.2096 39.014 20.1565C39.014 11.911 32.4843 5.23828 24.0481 5.23828C15.6119 5.23828 9.12988 11.911 9.12988 20.1565Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("a0iUh", function(module, exports) {
$parcel$export(module.exports, "StatusPageMarkBrandV2", function () { return $6f5773fdfc0af04e$export$67c04e9ff815ed1a; });

var $7VQPk = parcelRequire("7VQPk");
const $6f5773fdfc0af04e$export$67c04e9ff815ed1a = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.999 18.5942C19.4511 18.5942 15.0278 20.6502 11.4144 23.8275C11.0406 24.2013 10.6668 24.3882 10.293 24.3882C9.98145 24.3882 9.66995 24.2013 9.42075 23.8898L4.87283 18.5319C4.62362 18.2204 4.49902 17.9089 4.49902 17.6597C4.49902 17.2859 4.68592 16.9744 5.05973 16.6006C10.5422 11.7412 17.2083 9 23.999 9C30.7898 9 37.4559 11.7412 42.9383 16.6006C43.3121 16.9744 43.499 17.2859 43.499 17.6597C43.499 17.9089 43.3744 18.2204 43.1252 18.5319L38.5773 23.8898C38.3281 24.2013 38.0166 24.3882 37.7051 24.3882C37.3313 24.3882 36.9575 24.2013 36.5837 23.8275C32.9703 20.6502 28.5469 18.5942 23.999 18.5942ZM23.999 38.655C18.9527 38.655 14.8409 34.5431 14.8409 29.5591C14.8409 24.5751 18.9527 20.4633 23.999 20.4633C29.0453 20.4633 33.1572 24.5128 33.1572 29.5591C33.1572 34.6054 29.0453 38.655 23.999 38.655Z",
                fill: "#1868DB"
            })
        })
    });

});

parcelRegister("78YUQ", function(module, exports) {
$parcel$export(module.exports, "TalentMarkBrandLegacy", function () { return $293f32ec589a31cb$export$91c01f6a84d7db51; });

var $7VQPk = parcelRequire("7VQPk");
const $293f32ec589a31cb$export$91c01f6a84d7db51 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M16.6636 3.5L20.1851 11.3447L28.7329 12.2686L29.1431 13.5312L22.771 19.3037L24.5337 27.7197L23.4595 28.5L16.0005 24.2227L8.5415 28.5L7.46729 27.7197L9.229 19.3037L2.85693 13.5312L3.26709 12.2686L11.8159 11.3447L15.3364 3.5H16.6636ZM15.8892 17.3438C14.3034 17.344 13.0181 18.6291 13.0181 20.2148V21.2637C13.8269 21.7316 14.7642 22.0026 15.7642 22.0098H15.8462C16.9165 22.0021 17.9151 21.6924 18.7612 21.1621V20.2148C18.7612 18.6289 17.4751 17.3438 15.8892 17.3438ZM15.8892 12.1104C14.7 12.1106 13.736 13.0745 13.7358 14.2637C13.7358 15.453 14.6999 16.4177 15.8892 16.418C17.0786 16.418 18.0435 15.4531 18.0435 14.2637C18.0433 13.0744 17.0785 12.1104 15.8892 12.1104Z",
            fill: "#1868DB"
        })
    });

});

parcelRegister("c5NPm", function(module, exports) {
$parcel$export(module.exports, "TrelloMarkBrandV2", function () { return $5f0dbfc11b4dbabf$export$25be9ffc81f11ee4; });

var $7VQPk = parcelRequire("7VQPk");
const $5f0dbfc11b4dbabf$export$25be9ffc81f11ee4 = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Container",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.4293 7.69531H11.5713C9.43034 7.69531 7.69434 9.43131 7.69434 11.5723V36.4303C7.69434 38.5713 9.43034 40.3073 11.5713 40.3073H36.4293C38.5703 40.3073 40.3063 38.5713 40.3063 36.4303V11.5723C40.3063 9.43131 38.5703 7.69531 36.4293 7.69531ZM21.7423 31.1843C21.7423 31.8963 21.1653 32.4723 20.4543 32.4723H15.0033C14.2913 32.4723 13.7153 31.8953 13.7153 31.1843V15.0043C13.7153 14.2923 14.2923 13.7163 15.0033 13.7163H20.4543C21.1663 13.7163 21.7423 14.2933 21.7423 15.0043V31.1843ZM34.2853 23.7563C34.2853 24.4683 33.7083 25.0443 32.9973 25.0443H27.5463C26.8343 25.0443 26.2583 24.4673 26.2583 23.7563V15.0043C26.2583 14.2923 26.8353 13.7163 27.5463 13.7163H32.9973C33.7093 13.7163 34.2853 14.2933 34.2853 15.0043V23.7563V23.7563Z",
                fill: "#1868DB"
            })
        })
    });

});






parcelRegister("hCHU3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $790d703ef1df5e3c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("20OkY");
var $7gFRR = parcelRequire("7gFRR");

var $asbmK = parcelRequire("asbmK");

var $4UgZG = parcelRequire("4UgZG");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $iOXki = parcelRequire("iOXki");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $790d703ef1df5e3c$var$ConfluenceLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "confluence",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.ConfluenceLogo), {
        appearance: "brand"
    });
};
const $790d703ef1df5e3c$var$ConfluenceSoftwareNav = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=confluence&edition=free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $7gFRR.ProductKeys).CONFLUENCE,
        edition: (0, $7gFRR.Editions).FREE,
        redirectUrl: signupLink
    });
    const templatesDropdown = (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
            contentSections: [
                {
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.allTemplates',
                                defaultMessage: 'All templates'
                            }),
                            href: '/software/confluence/templates'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.design',
                                defaultMessage: 'Design'
                            }),
                            href: '/software/confluence/templates/categories/design'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.financeAndOperations',
                                defaultMessage: 'Finance & Ops'
                            }),
                            href: '/software/confluence/templates/categories/finance-and-operations'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.humanResources',
                                defaultMessage: 'Human Resources'
                            }),
                            href: '/software/confluence/templates/categories/human-resources'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.marketingAndSales',
                                defaultMessage: 'Marketing & Sales'
                            }),
                            href: '/software/confluence/templates/categories/marketing-and-sales'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.productManagement',
                                defaultMessage: 'Product Management'
                            }),
                            href: '/software/confluence/templates/categories/product-management'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.projectManagement',
                                defaultMessage: 'Project Management'
                            }),
                            href: '/software/confluence/templates/categories/project-management'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.recommended',
                                defaultMessage: 'Recommended'
                            }),
                            href: '/software/confluence/templates/categories/recommended'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'confluence.TemplateCategoriesDropdown.softwareDevelopmentAndIt',
                                defaultMessage: 'Software & IT'
                            }),
                            href: '/software/confluence/templates/categories/software-development-and-it'
                        }
                    ]
                }
            ]
        }), [
        intl
    ]);
    const featuresDropdown = (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
            contentSections: [
                {
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'ConfluenceSoftwarePageTemplate.navbar.features.allFeatures',
                                defaultMessage: 'All Features'
                            }),
                            href: '/software/confluence/features'
                        },
                        {
                            text: intl.formatMessage({
                                id: 'ConfluenceSoftwarePageTemplate.navbar.features.rovoInConfluence',
                                defaultMessage: 'Rovo in Confluence'
                            }),
                            href: '/software/confluence/ai'
                        }
                    ]
                }
            ]
        }), [
        intl
    ]);
    const templatesLinkContent = (0, $1oC0p.useMemo)(()=>{
        const common = {
            globalLinksKey: 'templates',
            linkText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.navbar.templates',
                defaultMessage: 'Templates'
            }),
            productKey: 'confluence'
        };
        return {
            ...common,
            hasSubnav: true,
            // TODO: replace with TemplateCategoriesDropdown to have dynamic categories
            content: templatesDropdown,
            dropdownType: 'templates',
            containerPosition: 'relative'
        };
    }, [
        intl,
        templatesDropdown
    ]);
    const ctaText = intl.formatMessage({
        id: 'ConfluenceSoftwarePageTemplate.navbar.getItFree',
        defaultMessage: 'Get it free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4UgZG.ConfluenceSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
                name: "confluence-pt-cfind-1234-confluenceSoftwareNav",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
                    productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/software/confluence'),
                    productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($790d703ef1df5e3c$var$ConfluenceLogoComponent, {}),
                    productLogoAriaLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePageTemplate.navbar.confluence-logo',
                        defaultMessage: 'Confluence logo'
                    }),
                    mobileCtaText: intl.formatMessage({
                        id: 'ConfluenceSoftwarePageTemplate.navbar.getitfree',
                        defaultMessage: 'Get it free'
                    }),
                    navigationTrynowCtaText: ctaText,
                    mobileCtaUrl: signupLink,
                    mobileCtaOnClick: openCrossFlow,
                    mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($790d703ef1df5e3c$var$ConfluenceLogoComponent, {}),
                    productPageNavLinks: [
                        {
                            globalLinksKey: 'features',
                            linkText: intl.formatMessage({
                                id: 'ConfluenceSoftwarePageTemplate.navbar.features',
                                defaultMessage: 'Features'
                            }),
                            hasSubnav: true,
                            content: featuresDropdown,
                            productKey: 'confluence',
                            containerPosition: 'relative'
                        },
                        {
                            globalLinksKey: 'resources',
                            linkText: intl.formatMessage({
                                id: 'ConfluenceSoftwarePageTemplate.navbar.resources',
                                defaultMessage: 'Resources'
                            }),
                            hasSubnav: false,
                            productKey: 'confluence',
                            href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/resources')
                        },
                        templatesLinkContent,
                        {
                            globalLinksKey: 'pricing',
                            linkText: intl.formatMessage({
                                id: 'ConfluenceSoftwarePageTemplate.navbar.pricing',
                                defaultMessage: 'Pricing'
                            }),
                            hasSubnav: false,
                            productKey: 'confluence',
                            href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/pricing')
                        },
                        {
                            globalLinksKey: 'enterprise',
                            linkText: intl.formatMessage({
                                id: 'ConfluenceSoftwarePageTemplate.navbar.enterprise',
                                defaultMessage: 'Enterprise'
                            }),
                            hasSubnav: false,
                            productKey: 'confluence',
                            href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/enterprise')
                        }
                    ],
                    navigationTrynowCtaUrl: signupLink,
                    navigationTrynowCtaOnClick: openCrossFlow,
                    mobileLinksSections: [
                        {
                            mobileLinkKey: 'mobile-confluence',
                            mobileLinksProps: [
                                {
                                    globalLinksKey: 'features',
                                    linkText: intl.formatMessage({
                                        id: 'ConfluenceSoftwarePageTemplate.navbar.features',
                                        defaultMessage: 'Features'
                                    }),
                                    hasSubnav: false,
                                    productKey: 'confluence',
                                    href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/features')
                                },
                                {
                                    globalLinksKey: 'resources',
                                    linkText: intl.formatMessage({
                                        id: 'ConfluenceSoftwarePageTemplate.navbar.resources',
                                        defaultMessage: 'Resources'
                                    }),
                                    hasSubnav: false,
                                    productKey: 'confluence',
                                    href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/resources')
                                },
                                templatesLinkContent,
                                {
                                    globalLinksKey: 'pricing',
                                    linkText: intl.formatMessage({
                                        id: 'ConfluenceSoftwarePageTemplate.navbar.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    hasSubnav: false,
                                    productKey: 'confluence',
                                    href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/pricing')
                                },
                                {
                                    globalLinksKey: 'enterprise',
                                    linkText: intl.formatMessage({
                                        id: 'ConfluenceSoftwarePageTemplate.navbar.enterprise',
                                        defaultMessage: 'Enterprise'
                                    }),
                                    hasSubnav: false,
                                    productKey: 'confluence',
                                    href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/enterprise')
                                }
                            ]
                        }
                    ],
                    additionalMenuPageObjectsArray: [
                        {
                            menuPageKey: 'templates',
                            menuPageObjects: templatesLinkContent?.content
                        }
                    ]
                })
            })
        ]
    });
};
$790d703ef1df5e3c$var$ConfluenceSoftwareNav.displayName = 'ConfluenceSoftwareNav';
var $790d703ef1df5e3c$export$2e2bcd8739ae039 = $790d703ef1df5e3c$var$ConfluenceSoftwareNav;

});
parcelRegister("asbmK", function(module, exports) {
$parcel$export(module.exports, "useCrossFlowFrontendTouchpoint", function () { return $158d66a1d1f28459$export$acccfb068b962644; });

var $1rObi = parcelRequire("1rObi");

var $3faDx = parcelRequire("3faDx");

var $6aWwD = parcelRequire("6aWwD");
const $158d66a1d1f28459$export$acccfb068b962644 = ({ productKey: productKey, screenName: screenName, redirectUrl: redirectUrl, edition: edition }, touchpointViewedOnMount = true)=>{
    const { isCrossFlowEnabled: isCrossFlowEnabled } = (0, $1rObi.useCrossFlowTouchpointContext)();
    const onCrossFlowComponentViewed = (0, $6aWwD.useCrossFlowFrontendTouchpointComponentViewed)({
        fireOnMount: isCrossFlowEnabled && touchpointViewedOnMount,
        productKey: productKey,
        screenName: screenName,
        edition: edition
    });
    const openCrossFlow = (0, $3faDx.useOpenCrossFlow)({
        productKey: productKey,
        screenName: screenName,
        redirectUrl: redirectUrl,
        edition: edition
    });
    if (!isCrossFlowEnabled) return {
        isEnabled: false,
        onCrossFlowComponentViewed: onCrossFlowComponentViewed
    };
    return {
        isEnabled: true,
        openCrossFlow: openCrossFlow,
        onCrossFlowComponentViewed: onCrossFlowComponentViewed
    };
};

});
parcelRegister("3faDx", function(module, exports) {
$parcel$export(module.exports, "useOpenCrossFlow", function () { return $a6d43955a447e179$export$f6033fcc5716710c; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("6xsdo");
var $aGE0q = parcelRequire("aGE0q");
var $2Hvh6 = parcelRequire("2Hvh6");

var $b31tm = parcelRequire("b31tm");
const $a6d43955a447e179$export$f6033fcc5716710c = ({ productKey: productKey, redirectUrl: redirectUrl, edition: edition, componentType: componentType = 'button', interactionName: interactionName = 'tryItFreeButton', screenName: screenName })=>{
    const { fireCrossFlowInteractedUIEvent: fireCrossFlowInteractedUIEvent, fireOperationalEvent: fireOperationalEvent, fireTrackEvent: fireTrackEvent } = (0, $b31tm.useFireEvent)({
        productKey: productKey,
        redirectUrl: redirectUrl,
        edition: edition,
        componentType: componentType,
        interactionName: interactionName,
        screenName: screenName
    });
    const crossFlow = (0, $2Hvh6.useCrossFlow)();
    const fireInteractionEvent = (0, $1oC0p.useCallback)(()=>{
        if (screenName && productKey) fireCrossFlowInteractedUIEvent({
            action: 'clicked',
            actionSubject: componentType,
            actionSubjectId: interactionName
        }, {
            source: screenName,
            targetProductId: productKey
        });
        else fireTrackEvent({
            action: 'clicked',
            actionSubject: componentType,
            actionSubjectId: interactionName
        });
    }, [
        componentType,
        fireCrossFlowInteractedUIEvent,
        fireTrackEvent,
        interactionName,
        productKey,
        screenName
    ]);
    const fireRedirectSuccessEvent = (0, $1oC0p.useCallback)(()=>{
        fireOperationalEvent({
            action: 'successful',
            actionSubject: 'crossFlowFallbackRedirectAttempt',
            eventType: 'operational'
        });
    }, [
        fireOperationalEvent
    ]);
    const fireRedirectFailedEvent = (0, $1oC0p.useCallback)((errorMessage)=>fireOperationalEvent({
            action: 'failed',
            actionSubject: 'crossFlowFallbackRedirectAttempt',
            attributes: {
                errorMessage: errorMessage
            }
        }), [
        fireOperationalEvent
    ]);
    const openCrossFlow = (0, $1oC0p.useCallback)(async (event, payload = {}, extensions)=>{
        if (event) event.preventDefault();
        const targetProduct = payload.productKey || productKey;
        const url = payload.redirectUrl || redirectUrl || '';
        const targetEdition = payload.edition || edition;
        try {
            fireInteractionEvent();
            if (!targetProduct || !crossFlow.isEnabled || (0, $b31tm.getRolloutFlagValue)(targetProduct, true) !== 'variation') {
                (0, $b31tm.redirectToDefaultUrl)(url, fireRedirectSuccessEvent, fireRedirectFailedEvent);
                return;
            }
            fireOperationalEvent({
                action: 'successful',
                actionSubject: 'crossFlowRequest'
            });
            if (targetEdition) extensions = {
                ...extensions,
                edition: targetEdition
            };
            await crossFlow.api.open({
                journey: (0, $aGE0q.Journeys).GET_STARTED,
                targetProduct: targetProduct,
                sourceComponent: screenName || (0, $b31tm.WAC_GENERIC_TOUCHPOINT_NAME),
                sourceContext: interactionName,
                extensions: extensions
            });
        } catch (error) {
            const errorData = error;
            fireOperationalEvent({
                action: 'failed',
                actionSubject: 'crossFlowRequest',
                attributes: {
                    errorMessage: errorData?.message,
                    errorStack: errorData?.stack,
                    url: url
                }
            });
            (0, $b31tm.redirectToDefaultUrl)(url, fireRedirectSuccessEvent, fireRedirectFailedEvent);
        }
    }, [
        productKey,
        redirectUrl,
        edition,
        fireInteractionEvent,
        crossFlow,
        fireOperationalEvent,
        screenName,
        interactionName,
        fireRedirectSuccessEvent,
        fireRedirectFailedEvent
    ]);
    return openCrossFlow;
};

});

parcelRegister("6aWwD", function(module, exports) {
$parcel$export(module.exports, "useCrossFlowFrontendTouchpointComponentViewed", function () { return $d29647299a5a1112$export$cffac58b53c8fc88; });

var $1oC0p = parcelRequire("1oC0p");

var $b31tm = parcelRequire("b31tm");
const $d29647299a5a1112$export$cffac58b53c8fc88 = ({ screenName: screenName, productKey: productKey, fireOnMount: fireOnMount, edition: edition })=>{
    const { fireCrossFlowViewedUIEvent: fireCrossFlowViewedUIEvent, fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)({
        productKey: productKey,
        fireOnMount: fireOnMount,
        edition: edition
    });
    const onCrossFlowComponentViewed = (0, $1oC0p.useCallback)(({ componentType: componentType = 'button', componentName: componentName })=>{
        if (componentName && screenName && productKey) fireCrossFlowViewedUIEvent({
            action: 'viewed',
            actionSubject: componentType,
            actionSubjectId: componentName
        }, {
            source: screenName,
            recommendedProductIds: [
                productKey
            ]
        });
        else fireUIEvent({
            action: 'viewed',
            actionSubject: (0, $b31tm.WAC_GENERIC_TOUCHPOINT_COMPONENT_NAME)
        });
    }, [
        fireCrossFlowViewedUIEvent,
        fireUIEvent,
        productKey,
        screenName
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (fireOnMount) onCrossFlowComponentViewed({});
    }, [
        onCrossFlowComponentViewed,
        fireOnMount
    ]);
    return onCrossFlowComponentViewed;
};

});


parcelRegister("4UgZG", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSmartBanner", function () { return $f9ce5899bf701c0b$export$9b9bd5e966b6bbd3; });
/* confluence-smart-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $63bv7 = parcelRequire("63bv7");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $2gCne = parcelRequire("2gCne");

var $lnHkK = parcelRequire("lnHkK");
const $f9ce5899bf701c0b$var$STORAGE_KEY = 'SmartBanner_dismiss-confluence';
const $f9ce5899bf701c0b$var$DISMISS_EXPIRY = 86400;
const $f9ce5899bf701c0b$var$IOS_APP_STORE_URL = 'https://apps.apple.com/app/confluence-cloud/id1006971684';
const $f9ce5899bf701c0b$var$APPLE_APP_ID = '1006971684';
// Android Intent URL with built-in Play Store fallback
const $f9ce5899bf701c0b$var$ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.atlassian.android.confluence.core';
const $f9ce5899bf701c0b$var$ANDROID_INTENT_URL = `intent://home#Intent;scheme=confluence;package=com.atlassian.android.confluence.core;S.browser_fallback_url=${encodeURIComponent($f9ce5899bf701c0b$var$ANDROID_PLAY_STORE_URL)};end`;
const $f9ce5899bf701c0b$var$useMobileDeviceInfo = ()=>{
    const [deviceInfo, setDeviceInfo] = (0, $1oC0p.useState)({
        isMobile: false,
        isIOS: false,
        isAndroid: false,
        isSafari: false
    });
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== 'undefined' && window.navigator) {
            const userAgent = window.navigator.userAgent;
            const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
            const isAndroid = /Android/i.test(userAgent);
            const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(userAgent) && isIOS;
            setDeviceInfo({
                isMobile: isIOS || isAndroid,
                isIOS: isIOS,
                isAndroid: isAndroid,
                isSafari: isSafari
            });
        }
    }, []);
    return deviceInfo;
};
const $f9ce5899bf701c0b$export$9b9bd5e966b6bbd3 = ({ className: className })=>{
    const { isMobile: isMobile, isAndroid: isAndroid, isSafari: isSafari } = $f9ce5899bf701c0b$var$useMobileDeviceInfo();
    const [isDismissed, setIsDismissed] = (0, $1oC0p.useState)(true);
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const experimentStatus = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp9508ConfluenceBannerIosNativeApp);
    const isExperimentEnabled = experimentStatus.type === 'enrolled' && experimentStatus.value === true;
    (0, $1oC0p.useEffect)(()=>{
        if (isExperimentEnabled && isSafari) {
            const meta = document.createElement('meta');
            meta.name = 'apple-itunes-app';
            meta.content = `app-id=${$f9ce5899bf701c0b$var$APPLE_APP_ID}, ct=wac_smart_banner`;
            document.head.appendChild(meta);
            return ()=>{
                if (meta.parentNode) meta.parentNode.removeChild(meta);
            };
        }
    }, [
        isExperimentEnabled,
        isSafari
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)($f9ce5899bf701c0b$var$STORAGE_KEY, true);
        if (dismissValue !== '1') setIsDismissed(false);
    }, []);
    const handleClose = ()=>{
        setIsDismissed(true);
        (0, $2gCne.setLocalStorage)($f9ce5899bf701c0b$var$STORAGE_KEY, '1', $f9ce5899bf701c0b$var$DISMISS_EXPIRY);
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartBannerClose',
            eventType: 'ui',
            attributes: {
                productKey: 'confluence',
                eventContainer: 'smartBanner'
            }
        }).fire();
    };
    const getDeepLinkUrl = (0, $1oC0p.useCallback)(()=>{
        if (isAndroid) return $f9ce5899bf701c0b$var$ANDROID_INTENT_URL;
        return $f9ce5899bf701c0b$var$IOS_APP_STORE_URL;
    }, [
        isAndroid
    ]);
    if (!isMobile || !isExperimentEnabled || isDismissed || isSafari) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lnHkK.SmartBanner), {
        appIcon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: intl.formatMessage({
            id: 'ConfluenceSmartBanner.title',
            defaultMessage: 'Get the Confluence app'
        }),
        subtitle: intl.formatMessage({
            id: 'ConfluenceSmartBanner.subtitle',
            defaultMessage: 'Collaborate on the go'
        }),
        buttonText: intl.formatMessage({
            id: 'ConfluenceSmartBanner.buttonText',
            defaultMessage: 'OPEN'
        }),
        buttonHref: getDeepLinkUrl(),
        buttonAriaLabel: intl.formatMessage({
            id: 'ConfluenceSmartBanner.buttonAriaLabel',
            defaultMessage: 'Open Confluence app'
        }),
        onClose: handleClose,
        className: className,
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event-container': 'smartBanner',
            'data-label': 'OPEN',
            'data-label-english': 'OPEN'
        }
    });
};
var $f9ce5899bf701c0b$export$2e2bcd8739ae039 = $f9ce5899bf701c0b$export$9b9bd5e966b6bbd3;

});
parcelRegister("63bv7", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", function () { return $467bf1b552d1fd27$export$d89497e7f33ca6f5; });
$parcel$export(module.exports, "CustomerServiceManagementIcon", function () { return $467bf1b552d1fd27$export$6da5aa77c402ba0f; });
$parcel$export(module.exports, "TalentIcon", function () { return $467bf1b552d1fd27$export$4b05688514531169; });
$parcel$export(module.exports, "BambooIcon", function () { return $467bf1b552d1fd27$export$e812398311cab9a3; });
$parcel$export(module.exports, "CrowdIcon", function () { return $467bf1b552d1fd27$export$eaf73f391f7103bd; });
$parcel$export(module.exports, "BitbucketIcon", function () { return $467bf1b552d1fd27$export$5fc1066e677788d4; });
$parcel$export(module.exports, "CompassIcon", function () { return $467bf1b552d1fd27$export$f7857fe64d7161d9; });
$parcel$export(module.exports, "ConfluenceIcon", function () { return $467bf1b552d1fd27$export$68f3db7f6af48bcb; });
$parcel$export(module.exports, "JiraAlignIcon", function () { return $467bf1b552d1fd27$export$407687b2dd89cc68; });
$parcel$export(module.exports, "JiraIcon", function () { return $467bf1b552d1fd27$export$c4b5b1f965d8b3eb; });
$parcel$export(module.exports, "JiraLogo", function () { return $467bf1b552d1fd27$export$17d3acb0b4379d02; });
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $467bf1b552d1fd27$export$21bfbeb62fdcce8d; });
$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $467bf1b552d1fd27$export$c49a2b642fe9eef4; });
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $467bf1b552d1fd27$export$3c6158790f5e01c4; });
$parcel$export(module.exports, "LoomIcon", function () { return $467bf1b552d1fd27$export$8d789f76fde3e05; });
$parcel$export(module.exports, "StatuspageIcon", function () { return $467bf1b552d1fd27$export$f3f5aa321d88adf9; });
$parcel$export(module.exports, "TrelloIcon", function () { return $467bf1b552d1fd27$export$4384da9b8b140bf4; });
$parcel$export(module.exports, "GuardIcon", function () { return $467bf1b552d1fd27$export$3f95fcfdc25a741d; });
$parcel$export(module.exports, "FocusIcon", function () { return $467bf1b552d1fd27$export$1e02e7298035a77c; });

var $hmzo1 = parcelRequire("hmzo1");
var $31TA4 = parcelRequire("31TA4");

var $fOwo5 = parcelRequire("fOwo5");
var $5g1S5 = parcelRequire("5g1S5");

var $2Xjom = parcelRequire("2Xjom");
var $1BZzR = parcelRequire("1BZzR");

var $70qoR = parcelRequire("70qoR");
var $7e9s4 = parcelRequire("7e9s4");

var $kbdWa = parcelRequire("kbdWa");
var $l3RIY = parcelRequire("l3RIY");

var $cxGmr = parcelRequire("cxGmr");
var $4RuXt = parcelRequire("4RuXt");

var $lnGOv = parcelRequire("lnGOv");
var $jDOgQ = parcelRequire("jDOgQ");

var $lfKpu = parcelRequire("lfKpu");
var $k1evh = parcelRequire("k1evh");

var $21A0C = parcelRequire("21A0C");
var $5qR8J = parcelRequire("5qR8J");

var $2mCmZ = parcelRequire("2mCmZ");
var $3yKNx = parcelRequire("3yKNx");

var $6CWdZ = parcelRequire("6CWdZ");
var $7S2jW = parcelRequire("7S2jW");

var $hHtoQ = parcelRequire("hHtoQ");
var $doj3j = parcelRequire("doj3j");

var $fQ2kV = parcelRequire("fQ2kV");
var $5XlOG = parcelRequire("5XlOG");

var $5aOLC = parcelRequire("5aOLC");
var $84d9S = parcelRequire("84d9S");

var $jQUou = parcelRequire("jQUou");

var $lHAY5 = parcelRequire("lHAY5");
var $fFxWm = parcelRequire("fFxWm");

var $32Iou = parcelRequire("32Iou");
var $6eUy8 = parcelRequire("6eUy8");

var $ddGCv = parcelRequire("ddGCv");
var $bwWQx = parcelRequire("bwWQx");

var $3obiE = parcelRequire("3obiE");
var $10Cwo = parcelRequire("10Cwo");

var $adcVm = parcelRequire("adcVm");
var $5gQdJ = parcelRequire("5gQdJ");

var $h5J3a = parcelRequire("h5J3a");
var $1tR0w = parcelRequire("1tR0w");

var $gTNoB = parcelRequire("gTNoB");
var $89x6g = parcelRequire("89x6g");

var $773g2 = parcelRequire("773g2");
var $8jhBH = parcelRequire("8jhBH");

var $7iKdn = parcelRequire("7iKdn");
var $4OCg1 = parcelRequire("4OCg1");

var $9OzfM = parcelRequire("9OzfM");
var $8aIK9 = parcelRequire("8aIK9");

var $9ja3T = parcelRequire("9ja3T");
var $5m4hC = parcelRequire("5m4hC");

var $2RPPG = parcelRequire("2RPPG");

var $bfq6M = parcelRequire("bfq6M");
var $6cWbd = parcelRequire("6cWbd");

var $6cujP = parcelRequire("6cujP");
var $O9ulh = parcelRequire("O9ulh");

var $lAHbT = parcelRequire("lAHbT");
var $2j6B5 = parcelRequire("2j6B5");

var $8jEWD = parcelRequire("8jEWD");
var $bepWJ = parcelRequire("bepWJ");

var $9gQF5 = parcelRequire("9gQF5");
var $81Tku = parcelRequire("81Tku");

var $iyubB = parcelRequire("iyubB");
var $2iCyk = parcelRequire("2iCyk");

var $2JmhH = parcelRequire("2JmhH");
var $9CPlP = parcelRequire("9CPlP");

var $9MPXR = parcelRequire("9MPXR");
var $hJLiA = parcelRequire("hJLiA");

var $9AxNa = parcelRequire("9AxNa");
var $f20db = parcelRequire("f20db");

var $68oHf = parcelRequire("68oHf");
var $17U6m = parcelRequire("17U6m");

var $ll0e2 = parcelRequire("ll0e2");
var $ffutL = parcelRequire("ffutL");

var $2wwNj = parcelRequire("2wwNj");
var $1Aji7 = parcelRequire("1Aji7");

var $5RDzb = parcelRequire("5RDzb");
var $gTa1W = parcelRequire("gTa1W");

var $62hIu = parcelRequire("62hIu");
var $3caL9 = parcelRequire("3caL9");

var $ex2Az = parcelRequire("ex2Az");
var $059d1 = parcelRequire("059d1");

var $1oYke = parcelRequire("1oYke");
var $9Fddb = parcelRequire("9Fddb");

var $cLMi5 = parcelRequire("cLMi5");
var $cyk7z = parcelRequire("cyk7z");

var $dinK7 = parcelRequire("dinK7");
var $gxZkM = parcelRequire("gxZkM");

var $kgbZM = parcelRequire("kgbZM");
var $1OG8V = parcelRequire("1OG8V");

var $bLYCy = parcelRequire("bLYCy");
var $UB6rg = parcelRequire("UB6rg");

var $csbFN = parcelRequire("csbFN");
var $3gas0 = parcelRequire("3gas0");

var $akiqO = parcelRequire("akiqO");
var $jHyCe = parcelRequire("jHyCe");

var $7FjrS = parcelRequire("7FjrS");
var $cyi5L = parcelRequire("cyi5L");

var $icMmC = parcelRequire("icMmC");
var $25WTg = parcelRequire("25WTg");

var $2zeHP = parcelRequire("2zeHP");
var $2XqtM = parcelRequire("2XqtM");

var $3KjHR = parcelRequire("3KjHR");
var $c3O0r = parcelRequire("c3O0r");

var $53ODU = parcelRequire("53ODU");
var $aUefO = parcelRequire("aUefO");

var $jQetv = parcelRequire("jQetv");
var $39z4h = parcelRequire("39z4h");

var $7dEOv = parcelRequire("7dEOv");
var $8mAZG = parcelRequire("8mAZG");

var $ljbbT = parcelRequire("ljbbT");
var $3ISql = parcelRequire("3ISql");

var $dTUCg = parcelRequire("dTUCg");
var $4oYxE = parcelRequire("4oYxE");

var $blhQc = parcelRequire("blhQc");
var $9GD6X = parcelRequire("9GD6X");

var $683e9 = parcelRequire("683e9");
var $3ij6w = parcelRequire("3ij6w");







var $dPIrG = parcelRequire("dPIrG");
var $467bf1b552d1fd27$export$ef8e5f836dd989d3 = (0, $dPIrG.tempSizeWrapper)((0, $hmzo1.AdminIcon));
var $467bf1b552d1fd27$export$ebcd30672e67406 = (0, $dPIrG.tempSizeWrapper)((0, $31TA4.AdminLogoCS));
var $467bf1b552d1fd27$export$af3460f51ce3602a = (0, $dPIrG.tempSizeWrapper)((0, $2Xjom.AnalyticsIcon));
var $467bf1b552d1fd27$export$c8415b6abe4a8587 = (0, $dPIrG.tempSizeWrapper)((0, $1BZzR.AnalyticsLogoCS));
var $467bf1b552d1fd27$export$d89497e7f33ca6f5 = (0, $dPIrG.tempSizeWrapper)((0, $70qoR.AssetsIcon));
var $467bf1b552d1fd27$export$48ca930f3071e3e4 = (0, $dPIrG.tempSizeWrapper)((0, $7e9s4.AssetsLogoCS));
var $467bf1b552d1fd27$export$52cd484a7ef4f2b9 = (0, $dPIrG.teamEUFlaggedIcon)((0, $lfKpu.ChatIcon), (0, $21A0C.ChatNewIcon));
var $467bf1b552d1fd27$export$9ca9881809919df8 = (0, $dPIrG.teamEUFlaggedIcon)((0, $k1evh.ChatLogoCS), (0, $5qR8J.ChatNewLogoCS));
var $467bf1b552d1fd27$export$6da5aa77c402ba0f = (0, $dPIrG.tempSizeWrapper)((0, $5aOLC.CustomerServiceManagementIcon));
var $467bf1b552d1fd27$export$abc95e6180bb1d88 = (0, $dPIrG.tempSizeWrapper)((0, $84d9S.CustomerServiceManagementLogoCS));
var $467bf1b552d1fd27$export$9eb74917ea768ed4 = (0, $dPIrG.tempSizeWrapper)((0, $32Iou.GoalsIcon));
var $467bf1b552d1fd27$export$d2577aa28451395f = (0, $dPIrG.tempSizeWrapper)((0, $6eUy8.GoalsLogoCS));
var $467bf1b552d1fd27$export$92c8767b874048d = (0, $dPIrG.tempSizeWrapper)((0, $3obiE.HomeIcon));
var $467bf1b552d1fd27$export$d5648119d5b68e90 = (0, $dPIrG.tempSizeWrapper)((0, $10Cwo.HomeLogoCS));
var $467bf1b552d1fd27$export$80b8b269d8b5014e = (0, $dPIrG.tempSizeWrapper)((0, $adcVm.HubIcon));
var $467bf1b552d1fd27$export$fc9bd6687b80fe3b = (0, $dPIrG.tempSizeWrapper)((0, $5gQdJ.HubLogoCS));
var $467bf1b552d1fd27$export$5ed3e1bb3b04fc02 = (0, $dPIrG.tempSizeWrapper)((0, $lAHbT.ProjectsIcon));
var $467bf1b552d1fd27$export$aeefab651bcf2338 = (0, $dPIrG.tempSizeWrapper)((0, $2j6B5.ProjectsLogoCS));
var $467bf1b552d1fd27$export$8b784b3227531b3e = (0, $dPIrG.tempSizeWrapper)((0, $9gQF5.RovoDevIcon));
var $467bf1b552d1fd27$export$f0750468d67c6902 = (0, $dPIrG.tempSizeWrapper)((0, $81Tku.RovoDevLogoCS));
var $467bf1b552d1fd27$export$813cff80931d9dbf = (0, $dPIrG.tempSizeWrapper)((0, $iyubB.RovoDevAgentIcon));
var $467bf1b552d1fd27$export$409b7a5b7f180eba = (0, $dPIrG.tempSizeWrapper)((0, $2iCyk.RovoDevAgentLogoCS));
var $467bf1b552d1fd27$export$82eafebb825fc23f = (0, $dPIrG.teamEUFlaggedIcon)((0, $9MPXR.SearchIcon), (0, $9AxNa.SearchNewIcon));
var $467bf1b552d1fd27$export$e4c5487c9a8ae3b1 = (0, $dPIrG.teamEUFlaggedIcon)((0, $hJLiA.SearchLogoCS), (0, $f20db.SearchNewLogoCS));
var $467bf1b552d1fd27$export$290a0f24614cde9f = (0, $dPIrG.teamEUFlaggedIcon)((0, $ll0e2.StudioIcon), (0, $2wwNj.StudioNewIcon));
var $467bf1b552d1fd27$export$8aceb78c659789b6 = (0, $dPIrG.teamEUFlaggedIcon)((0, $ffutL.StudioLogoCS), (0, $1Aji7.StudioNewLogoCS));
var $467bf1b552d1fd27$export$4b05688514531169 = (0, $dPIrG.tempSizeWrapper)((0, $5RDzb.TalentIcon));
var $467bf1b552d1fd27$export$4f6453e012279f89 = (0, $dPIrG.tempSizeWrapper)((0, $gTa1W.TalentLogoCS));
var $467bf1b552d1fd27$export$1bcbc9c337da86da = (0, $dPIrG.tempSizeWrapper)((0, $62hIu.TeamsIcon));
var $467bf1b552d1fd27$export$9b1a0a0c574cec2a = (0, $dPIrG.tempSizeWrapper)((0, $3caL9.TeamsLogoCS));
var $467bf1b552d1fd27$export$e812398311cab9a3 = (0, $dPIrG.tempSizeWrapper)((0, $kbdWa.BambooIcon));
var $467bf1b552d1fd27$export$765f5afcc1a5a7e3 = (0, $dPIrG.tempSizeWrapper)((0, $l3RIY.BambooLogoCS));
var $467bf1b552d1fd27$export$d3ab16bbf4f954ee = (0, $dPIrG.tempSizeWrapper)((0, $lnGOv.BitbucketDataCenterIcon));
var $467bf1b552d1fd27$export$36044946916e84a0 = (0, $dPIrG.tempSizeWrapper)((0, $jDOgQ.BitbucketDataCenterLogoCS));
var $467bf1b552d1fd27$export$53305f1f2855d3be = (0, $dPIrG.tempSizeWrapper)((0, $hHtoQ.ConfluenceDataCenterIcon));
var $467bf1b552d1fd27$export$5e06396bce773a3 = (0, $dPIrG.tempSizeWrapper)((0, $doj3j.ConfluenceDataCenterLogoCS));
var $467bf1b552d1fd27$export$eaf73f391f7103bd = (0, $dPIrG.tempSizeWrapper)((0, $fQ2kV.CrowdIcon));
var $467bf1b552d1fd27$export$6128b385660fd3c6 = (0, $dPIrG.tempSizeWrapper)((0, $5XlOG.CrowdLogoCS));
var $467bf1b552d1fd27$export$f8455b5667a3ee0c = (0, $dPIrG.tempSizeWrapper)((0, $gTNoB.JiraDataCenterIcon));
var $467bf1b552d1fd27$export$eb152ab3801b2ae3 = (0, $dPIrG.tempSizeWrapper)((0, $89x6g.JiraDataCenterLogoCS));
var $467bf1b552d1fd27$export$65fae0eaf343f2ca = (0, $dPIrG.tempSizeWrapper)((0, $9OzfM.JiraServiceManagementDataCenterIcon));
var $467bf1b552d1fd27$export$fffc0d480fb1ebf1 = (0, $dPIrG.tempSizeWrapper)((0, $8aIK9.JiraServiceManagementDataCenterLogoCS));
var $467bf1b552d1fd27$export$74517ed253186308 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $cLMi5.AtlassianAdministrationIcon), (0, $hmzo1.AdminIcon));
var $467bf1b552d1fd27$export$833abe6c2ce5ebfd = (0, $dPIrG.createFeatureFlaggedComponent)((0, $cyk7z.AtlassianAdministrationLogo), (0, $31TA4.AdminLogoCS));
var $467bf1b552d1fd27$export$84109e099492cb5f = (0, $dPIrG.createFeatureFlaggedComponent)((0, $1oYke.AtlassianAdminIcon), (0, $hmzo1.AdminIcon));
var $467bf1b552d1fd27$export$f845d9b9254f0541 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $9Fddb.AtlassianAdminLogo), (0, $31TA4.AdminLogoCS));
var $467bf1b552d1fd27$export$c42ad8a0b925c762 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $dinK7.AtlassianAnalyticsIcon), (0, $2Xjom.AnalyticsIcon));
var $467bf1b552d1fd27$export$e6470bfc39010cc4 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $gxZkM.AtlassianAnalyticsLogo), (0, $1BZzR.AnalyticsLogoCS));
var $467bf1b552d1fd27$export$5fc1066e677788d4 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $kgbZM.BitbucketIcon), (0, $cxGmr.BitbucketIcon));
var $467bf1b552d1fd27$export$bd40525f5333524b = (0, $dPIrG.createFeatureFlaggedComponent)((0, $1OG8V.BitbucketLogo), (0, $4RuXt.BitbucketLogoCS));
var $467bf1b552d1fd27$export$f7857fe64d7161d9 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $bLYCy.CompassIcon), (0, $2mCmZ.CompassIcon));
var $467bf1b552d1fd27$export$eb7d748e4f9c9676 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $UB6rg.CompassLogo), (0, $3yKNx.CompassLogoCS));
var $467bf1b552d1fd27$export$9951d02c2d848122 = (0, $dPIrG.tempSizeWrapper)((0, $jQUou.DxIcon));
var $467bf1b552d1fd27$export$68f3db7f6af48bcb = (0, $dPIrG.createFeatureFlaggedComponent)((0, $csbFN.ConfluenceIcon), (0, $6CWdZ.ConfluenceIcon));
var $467bf1b552d1fd27$export$1b2e4fe6ef471556 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $3gas0.ConfluenceLogo), (0, $7S2jW.ConfluenceLogoCS));
var $467bf1b552d1fd27$export$70a0c2f5862937b6 = (0, $dPIrG.tempSizeWrapper)((0, $fOwo5.AlignIcon));
var $467bf1b552d1fd27$export$1b8596b4b0ef673b = (0, $dPIrG.tempSizeWrapper)((0, $5g1S5.AlignLogoCS));
var $467bf1b552d1fd27$export$407687b2dd89cc68 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $2zeHP.JiraAlignIcon), (0, $fOwo5.AlignIcon));
var $467bf1b552d1fd27$export$ee11e928d3d045fd = (0, $dPIrG.createFeatureFlaggedComponent)((0, $2XqtM.JiraAlignLogo), (0, $5g1S5.AlignLogoCS));
var $467bf1b552d1fd27$export$c4b5b1f965d8b3eb = (0, $dPIrG.createFeatureFlaggedComponent)((0, $icMmC.JiraIcon), (0, $h5J3a.JiraIcon));
var $467bf1b552d1fd27$export$17d3acb0b4379d02 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $25WTg.JiraLogo), (0, $1tR0w.JiraLogoCS));
var $467bf1b552d1fd27$export$21bfbeb62fdcce8d = (0, $dPIrG.createFeatureFlaggedComponent)((0, $3KjHR.JiraProductDiscoveryIcon), (0, $773g2.JiraProductDiscoveryIcon));
var $467bf1b552d1fd27$export$c49a2b642fe9eef4 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $c3O0r.JiraProductDiscoveryLogo), (0, $8jhBH.JiraProductDiscoveryLogoCS));
var $467bf1b552d1fd27$export$3c6158790f5e01c4 = (0, $dPIrG.createFeatureFlaggedServiceCollectionComponent)((0, $53ODU.JiraServiceManagementIcon), (0, $7iKdn.JiraServiceManagementIcon));
var $467bf1b552d1fd27$export$dabef2be6cd28c20 = (0, $dPIrG.createFeatureFlaggedServiceCollectionComponent)((0, $aUefO.JiraServiceManagementLogo), (0, $4OCg1.JiraServiceManagementLogoCS));
var $467bf1b552d1fd27$export$8d789f76fde3e05 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $jQetv.LoomIcon), (0, $9ja3T.LoomIcon));
var $467bf1b552d1fd27$export$94e206806e36c2ec = (0, $dPIrG.createFeatureFlaggedComponent)((0, $39z4h.LoomLogo), (0, $5m4hC.LoomLogoCS));
var $467bf1b552d1fd27$export$1bf47cdade1a9fcb = (0, $dPIrG.createFeatureFlaggedComponent)((0, $7dEOv.LoomAttributionIcon), (0, $9ja3T.LoomIcon));
var $467bf1b552d1fd27$export$6e87ce8d41eda665 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $8mAZG.LoomAttributionLogo), (0, $2RPPG.LoomAttributionLogoCS));
var $467bf1b552d1fd27$export$e84e925618e0e5bc = (0, $dPIrG.tempSizeWrapper)((0, $6cWbd.LoomInternalLogoCS));
var $467bf1b552d1fd27$export$1940ba72c868b663 = (0, $dPIrG.tempSizeWrapper)((0, $bfq6M.LoomInternalIcon));
var $467bf1b552d1fd27$export$eeccc49dc7a12d9f = (0, $dPIrG.createFeatureFlaggedServiceCollectionComponent)((0, $ljbbT.OpsgenieIcon), (0, $6cujP.OpsgenieIcon));
var $467bf1b552d1fd27$export$a1c6484cdecc2c4b = (0, $dPIrG.createFeatureFlaggedServiceCollectionComponent)((0, $3ISql.OpsgenieLogo), (0, $O9ulh.OpsgenieLogoCS));
var $467bf1b552d1fd27$export$f3f5aa321d88adf9 = (0, $dPIrG.createFeatureFlaggedServiceCollectionComponent)((0, $blhQc.StatuspageIcon), (0, $68oHf.StatuspageIcon));
var $467bf1b552d1fd27$export$bb4ae5b41b43be04 = (0, $dPIrG.createFeatureFlaggedServiceCollectionComponent)((0, $9GD6X.StatuspageLogo), (0, $17U6m.StatuspageLogoCS));
var $467bf1b552d1fd27$export$4384da9b8b140bf4 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $683e9.TrelloIcon), (0, $ex2Az.TrelloIcon));
var $467bf1b552d1fd27$export$60e26212f3b61a28 = (0, $dPIrG.createFeatureFlaggedComponent)((0, $3ij6w.TrelloLogo), (0, $059d1.TrelloLogoCS));
var $467bf1b552d1fd27$export$e23ae35269442b4f = (0, $dPIrG.createFeatureFlaggedRovoComponent)((0, $dTUCg.RovoIcon), (0, $8jEWD.RovoIcon), (0, $2JmhH.RovoHexIcon));
var $467bf1b552d1fd27$export$a0f6cb8061290bbb = (0, $dPIrG.createFeatureFlaggedRovoComponent)((0, $4oYxE.RovoLogo), (0, $bepWJ.RovoLogoCS), (0, $9CPlP.RovoHexLogoCS));
var $467bf1b552d1fd27$export$3f95fcfdc25a741d = (0, $dPIrG.createFeatureFlaggedComponent)((0, $7FjrS.GuardIcon), (0, $ddGCv.GuardIcon));
var $467bf1b552d1fd27$export$a4a891d202775deb = (0, $dPIrG.createFeatureFlaggedComponent)((0, $cyi5L.GuardLogo), (0, $bwWQx.GuardLogoCS));
var $467bf1b552d1fd27$export$1e02e7298035a77c = (0, $dPIrG.createFeatureFlaggedComponent)((0, $akiqO.FocusIcon), (0, $lHAY5.FocusIcon));
var $467bf1b552d1fd27$export$33908560ea1b226d = (0, $dPIrG.createFeatureFlaggedComponent)((0, $jHyCe.FocusLogo), (0, $fFxWm.FocusLogoCS));

});
parcelRegister("hmzo1", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", function () { return $ca3ff0c06ab16b2f$export$ef8e5f836dd989d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::978af025984c14496c17f030fc144641>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ca3ff0c06ab16b2f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ca3ff0c06ab16b2f$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $ca3ff0c06ab16b2f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("kGaM3", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", function () { return $f0e01666ec5a87f2$export$be58b4326e23250f; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $ey7Qk = parcelRequire("ey7Qk");

var $39c3M = parcelRequire("39c3M");

var $jLY4R = parcelRequire("jLY4R");
var $f0e01666ec5a87f2$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $f0e01666ec5a87f2$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $f0e01666ec5a87f2$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $f0e01666ec5a87f2$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $f0e01666ec5a87f2$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $f0e01666ec5a87f2$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $f0e01666ec5a87f2$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $f0e01666ec5a87f2$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $f0e01666ec5a87f2$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $ey7Qk.default)([
            $f0e01666ec5a87f2$var$styles.root,
            $f0e01666ec5a87f2$var$sizeMap[size],
            colorMode === 'dark' ? $f0e01666ec5a87f2$var$dataCenterDarkAppearanceMap[appearance] : $f0e01666ec5a87f2$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $f0e01666ec5a87f2$var$rovoDarkAppearanceMap[appearance] : $f0e01666ec5a87f2$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $f0e01666ec5a87f2$var$cloudDarkAppearanceMap[appearance] : $f0e01666ec5a87f2$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $39c3M.fg)('assets-platform-branding') && $f0e01666ec5a87f2$var$styles.TEMP_assets
        ])
    });
}

});
parcelRegister("ey7Qk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a97a53254154b47a$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a97a53254154b47a$var$ATOMIC_GROUP_LENGTH = 5;
function $a97a53254154b47a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $a97a53254154b47a$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("jLY4R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e651023bfd7b2976$export$2e2bcd8739ae039; });

var $1doS4 = parcelRequire("1doS4");

var $1oC0p = parcelRequire("1oC0p");

var $2ZaQk = parcelRequire("2ZaQk");

var $4eTep = parcelRequire("4eTep");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $e651023bfd7b2976$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $1oC0p.useState)((0, $2ZaQk.default)()), _useState2 = (0, $1doS4.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        var observer = new (0, $4eTep.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $e651023bfd7b2976$export$2e2bcd8739ae039 = $e651023bfd7b2976$var$useThemeObserver;

});
parcelRegister("1doS4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e2a4c3e6aacd13b$export$2e2bcd8739ae039; });

var $7vK7S = parcelRequire("7vK7S");

var $hNsde = parcelRequire("hNsde");

var $hw1BF = parcelRequire("hw1BF");

var $eyvFh = parcelRequire("eyvFh");
function $0e2a4c3e6aacd13b$export$2e2bcd8739ae039(r, e) {
    return (0, $7vK7S.default)(r) || (0, $hNsde.default)(r, e) || (0, $hw1BF.default)(r, e) || (0, $eyvFh.default)();
}

});
parcelRegister("7vK7S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $577f35506f4925d7$export$2e2bcd8739ae039; });
function $577f35506f4925d7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("hNsde", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf4ce5af855ef094$export$2e2bcd8739ae039; });
function $cf4ce5af855ef094$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("hw1BF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc06abd812cda3f4$export$2e2bcd8739ae039; });

var $hcnDc = parcelRequire("hcnDc");
function $cc06abd812cda3f4$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $hcnDc.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $hcnDc.default)(r, a) : void 0;
    }
}

});
parcelRegister("hcnDc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c855e3508326ad4c$export$2e2bcd8739ae039; });
function $c855e3508326ad4c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("eyvFh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a98ccda3547f96dc$export$2e2bcd8739ae039; });
function $a98ccda3547f96dc$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2ZaQk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $22c9b07b5841ff11$export$2e2bcd8739ae039; });

var $20yn1 = parcelRequire("20yn1");

var $g6r1N = parcelRequire("g6r1N");

var $6ZnjB = parcelRequire("6ZnjB");

var $fWUSQ = parcelRequire("fWUSQ");
function $22c9b07b5841ff11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $22c9b07b5841ff11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $22c9b07b5841ff11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $20yn1.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $22c9b07b5841ff11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $22c9b07b5841ff11$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $6ZnjB.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $22c9b07b5841ff11$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $g6r1N.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $g6r1N.THEME_DATA_ATTRIBUTE)) || '';
    return $22c9b07b5841ff11$var$_objectSpread($22c9b07b5841ff11$var$_objectSpread({}, (0, $fWUSQ.themeStringToObject)(theme)), $22c9b07b5841ff11$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $22c9b07b5841ff11$export$2e2bcd8739ae039 = $22c9b07b5841ff11$var$getGlobalTheme;

});
parcelRegister("20yn1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17663e1362a05b47$export$2e2bcd8739ae039; });

var $3ooWw = parcelRequire("3ooWw");
function $17663e1362a05b47$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3ooWw.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("3ooWw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2786f621cf50f50b$export$2e2bcd8739ae039; });

var $43ahk = parcelRequire("43ahk");

var $axHBy = parcelRequire("axHBy");
function $2786f621cf50f50b$export$2e2bcd8739ae039(t) {
    var i = (0, $axHBy.default)(t, "string");
    return "symbol" == (0, $43ahk.default)(i) ? i : i + "";
}

});
parcelRegister("43ahk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f2f6a4ee0ca13b3$export$2e2bcd8739ae039; });
function $2f2f6a4ee0ca13b3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2f2f6a4ee0ca13b3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2f2f6a4ee0ca13b3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("axHBy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7acecf6fd4d90d74$export$2e2bcd8739ae039; });

var $43ahk = parcelRequire("43ahk");
function $7acecf6fd4d90d74$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $43ahk.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $43ahk.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("g6r1N", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $bb922c0f610f8316$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $bb922c0f610f8316$export$a00eac3f8684bcd0; });
var $bb922c0f610f8316$export$4ef52930e33717cd = 'data-theme';
var $bb922c0f610f8316$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $bb922c0f610f8316$export$a00eac3f8684bcd0 = 'data-color-mode';
var $bb922c0f610f8316$export$2112803007239c61 = 'data-contrast-mode';
var $bb922c0f610f8316$export$352e418ed5b6193a = 'data-custom-theme';
var $bb922c0f610f8316$export$6f0c6fb8c80fcc92 = 'ds';
var $bb922c0f610f8316$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $bb922c0f610f8316$export$dddac1532e822863 = "--".concat($bb922c0f610f8316$export$6f0c6fb8c80fcc92, "-token-not-found");
var $bb922c0f610f8316$export$9d7b58831ae93caa = "--".concat($bb922c0f610f8316$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("6ZnjB", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $516a867bc172d970$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $516a867bc172d970$export$7d43e72a58e3283f; });

var $39c3M = parcelRequire("39c3M");
var $516a867bc172d970$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $516a867bc172d970$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $516a867bc172d970$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $516a867bc172d970$var$themeOverrideIds = [];
var $516a867bc172d970$export$92ba366331403db2 = [].concat($516a867bc172d970$export$7d43e72a58e3283f, $516a867bc172d970$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $516a867bc172d970$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    }
};
var $516a867bc172d970$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $39c3M.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $516a867bc172d970$export$2e2bcd8739ae039 = $516a867bc172d970$var$themeConfig;

});

parcelRegister("fWUSQ", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $b9c865b466161f14$export$f19b488f7c0547ee; });

var $43ahk = parcelRequire("43ahk");

var $1doS4 = parcelRequire("1doS4");

var $6ZnjB = parcelRequire("6ZnjB");
var $b9c865b466161f14$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $b9c865b466161f14$var$customThemeOptions = 'UNSAFE_themeOptions';
var $b9c865b466161f14$var$isThemeKind = function isThemeKind(themeKind) {
    return $b9c865b466161f14$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $b9c865b466161f14$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $6ZnjB.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $b9c865b466161f14$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $b9c865b466161f14$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $1doS4.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $b9c865b466161f14$var$isColorMode(id)) themeObject[kind] = id;
        if ($b9c865b466161f14$var$isThemeKind(kind) && $b9c865b466161f14$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $b9c865b466161f14$var$customThemeOptions) try {
            themeObject[$b9c865b466161f14$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $b9c865b466161f14$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $1doS4.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $b9c865b466161f14$var$isColorMode(id) || // custom theme state
        kind === $b9c865b466161f14$var$customThemeOptions && (0, $43ahk.default)(id) === 'object' || // other theme states
        $b9c865b466161f14$var$isThemeKind(kind) && typeof id === 'string' && $b9c865b466161f14$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $43ahk.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("4eTep", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3163500d5743633d$export$2e2bcd8739ae039; });

var $aJSWF = parcelRequire("aJSWF");

var $4qc1O = parcelRequire("4qc1O");

var $20yn1 = parcelRequire("20yn1");

var $g6r1N = parcelRequire("g6r1N");

var $2ZaQk = parcelRequire("2ZaQk");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $3163500d5743633d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $aJSWF.default)(this, ThemeMutationObserver);
        (0, $20yn1.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $4qc1O.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $2ZaQk.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $g6r1N.THEME_DATA_ATTRIBUTE),
                            (0, $g6r1N.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $20yn1.default)($3163500d5743633d$export$2e2bcd8739ae039, "observer", null);
(0, $20yn1.default)($3163500d5743633d$export$2e2bcd8739ae039, "callbacks", new Set());

});
parcelRegister("aJSWF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7d18ba57f3c01970$export$2e2bcd8739ae039; });
function $7d18ba57f3c01970$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("4qc1O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3382ebb0bc559b43$export$2e2bcd8739ae039; });

var $3ooWw = parcelRequire("3ooWw");
function $3382ebb0bc559b43$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3ooWw.default)(o.key), o);
    }
}
function $3382ebb0bc559b43$export$2e2bcd8739ae039(e, r, t) {
    return r && $3382ebb0bc559b43$var$_defineProperties(e.prototype, r), t && $3382ebb0bc559b43$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});





parcelRegister("31TA4", function(module, exports) {
$parcel$export(module.exports, "AdminLogoCS", function () { return $234c944c5685c228$export$61afcb38c001e19; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6b875f42d16c31c8841f1ef82618390>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $234c944c5685c228$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $234c944c5685c228$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $234c944c5685c228$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("4skhl", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", function () { return $33e981e4156ad77a$export$f827d3c5a9c3f644; });
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $1oC0p = parcelRequire("1oC0p");

var $ey7Qk = parcelRequire("ey7Qk");

var $39c3M = parcelRequire("39c3M");

var $jLY4R = parcelRequire("jLY4R");
var $33e981e4156ad77a$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $33e981e4156ad77a$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $33e981e4156ad77a$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $33e981e4156ad77a$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $33e981e4156ad77a$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $33e981e4156ad77a$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $33e981e4156ad77a$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $33e981e4156ad77a$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $33e981e4156ad77a$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $33e981e4156ad77a$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $33e981e4156ad77a$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $33e981e4156ad77a$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $ey7Qk.default)([
            $33e981e4156ad77a$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $33e981e4156ad77a$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $33e981e4156ad77a$var$sizeMap[size],
            colorMode === 'dark' ? $33e981e4156ad77a$var$textDarkAppearanceMap[appearance] : $33e981e4156ad77a$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $33e981e4156ad77a$var$dataCenterDarkAppearanceMap[appearance] : $33e981e4156ad77a$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $33e981e4156ad77a$var$rovoDarkAppearanceMap[appearance] : $33e981e4156ad77a$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $33e981e4156ad77a$var$cloudDarkAppearanceMap[appearance] : $33e981e4156ad77a$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $39c3M.fg)('assets-platform-branding') && $33e981e4156ad77a$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("fOwo5", function(module, exports) {
$parcel$export(module.exports, "AlignIcon", function () { return $b834a6013820ef92$export$70a0c2f5862937b6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::722075a08a8f598253aef877e81d3776>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b834a6013820ef92$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $b834a6013820ef92$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $b834a6013820ef92$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5g1S5", function(module, exports) {
$parcel$export(module.exports, "AlignLogoCS", function () { return $3d3fe5fb071b5309$export$8b5103382c06639c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3765620b2b4a8b62ff9327c31a8491d2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3d3fe5fb071b5309$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $3d3fe5fb071b5309$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $3d3fe5fb071b5309$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2Xjom", function(module, exports) {
$parcel$export(module.exports, "AnalyticsIcon", function () { return $2270224e1fb78b8a$export$af3460f51ce3602a; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb69048bab05ca24708a4807daf973fa>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2270224e1fb78b8a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $2270224e1fb78b8a$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $2270224e1fb78b8a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1BZzR", function(module, exports) {
$parcel$export(module.exports, "AnalyticsLogoCS", function () { return $12c90324b9d27e84$export$f0bac2b7ac3e3504; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bacdce044c632033f444ff3fb8aec626>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $12c90324b9d27e84$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $12c90324b9d27e84$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $12c90324b9d27e84$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("70qoR", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", function () { return $519d0300a7041c30$export$d89497e7f33ca6f5; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdf3eea5e378fdf57510e12d7a73d069>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $519d0300a7041c30$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $519d0300a7041c30$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $519d0300a7041c30$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $519d0300a7041c30$var$svg,
        customThemeSvg: $519d0300a7041c30$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7e9s4", function(module, exports) {
$parcel$export(module.exports, "AssetsLogoCS", function () { return $54312c22cd0c6541$export$81c47abe19675c4c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0f34baf8663cd71b78e62846baabe5a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $54312c22cd0c6541$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $54312c22cd0c6541$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $54312c22cd0c6541$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kbdWa", function(module, exports) {
$parcel$export(module.exports, "BambooIcon", function () { return $eb0fa562902366c4$export$e812398311cab9a3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb2b70bfad61d30e19bb65dd0ce89de7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $eb0fa562902366c4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $eb0fa562902366c4$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $eb0fa562902366c4$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("l3RIY", function(module, exports) {
$parcel$export(module.exports, "BambooLogoCS", function () { return $f5538d5778b0a854$export$7c51958462d750e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2321f2dda4d95bdf7f57b6fa4abea572>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f5538d5778b0a854$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $f5538d5778b0a854$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $f5538d5778b0a854$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cxGmr", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", function () { return $92196d1db63f38c9$export$5fc1066e677788d4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::851eef4fe42af84bd69327ee9c4f8fd9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $92196d1db63f38c9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $92196d1db63f38c9$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $92196d1db63f38c9$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $92196d1db63f38c9$var$svg,
        customThemeSvg: $92196d1db63f38c9$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4RuXt", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogoCS", function () { return $38a4204ef9632049$export$f7ef5e5488e4b430; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478f827cfee38d4db58962bbd974c1b0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $38a4204ef9632049$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $38a4204ef9632049$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $38a4204ef9632049$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lnGOv", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterIcon", function () { return $f90cf4d35402bc72$export$d3ab16bbf4f954ee; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac8f22afdb6e4b999b2444d5d77ea16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f90cf4d35402bc72$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $f90cf4d35402bc72$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $f90cf4d35402bc72$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jDOgQ", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterLogoCS", function () { return $e4c8a7899eda0675$export$cc55e2a4c4b40552; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8ba6d4a8459456d84acb6ec3954e8bd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e4c8a7899eda0675$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $e4c8a7899eda0675$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $e4c8a7899eda0675$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lfKpu", function(module, exports) {
$parcel$export(module.exports, "ChatIcon", function () { return $f78effc19664e676$export$52cd484a7ef4f2b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746df89d4e9f9114099c723d030eeb4f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f78effc19664e676$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f78effc19664e676$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $f78effc19664e676$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("k1evh", function(module, exports) {
$parcel$export(module.exports, "ChatLogoCS", function () { return $e92f26bb7400e5f7$export$a529e78951cd6709; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1380d2508da72b3317d1f5d85a933aa>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e92f26bb7400e5f7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $e92f26bb7400e5f7$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $e92f26bb7400e5f7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("21A0C", function(module, exports) {
$parcel$export(module.exports, "ChatNewIcon", function () { return $17979b69275f8b07$export$402a257da320c93c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3fab57be3a885672ac53325ee0c1c49f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $17979b69275f8b07$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $17979b69275f8b07$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $17979b69275f8b07$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5qR8J", function(module, exports) {
$parcel$export(module.exports, "ChatNewLogoCS", function () { return $3f4899efb91672d8$export$a3af32a9109d706d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::081a9e6d7349520af47983a112236857>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3f4899efb91672d8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $3f4899efb91672d8$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $3f4899efb91672d8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2mCmZ", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", function () { return $1b8b665071b5e96f$export$f7857fe64d7161d9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9070ed1fb6d25ad0943826ab7bba1e15>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1b8b665071b5e96f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $1b8b665071b5e96f$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $1b8b665071b5e96f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3yKNx", function(module, exports) {
$parcel$export(module.exports, "CompassLogoCS", function () { return $2978d928e5866f89$export$a16f50a81d183ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e23709162b5f175d326f7ea087e40e7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2978d928e5866f89$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $2978d928e5866f89$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $2978d928e5866f89$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6CWdZ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", function () { return $4d3374e3526b8964$export$68f3db7f6af48bcb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::829e0f22b9c4efb73ab4df551090a45e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4d3374e3526b8964$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $4d3374e3526b8964$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $4d3374e3526b8964$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $4d3374e3526b8964$var$svg,
        customThemeSvg: $4d3374e3526b8964$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7S2jW", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoCS", function () { return $5baf605b8f17c0e4$export$a88b0b0da9ef63ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0daf403b816e69883a4b967c46646721>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5baf605b8f17c0e4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $5baf605b8f17c0e4$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $5baf605b8f17c0e4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hHtoQ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterIcon", function () { return $ce2d41f7d66a2b92$export$53305f1f2855d3be; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bce70ee3b947e0126577758400fc4f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ce2d41f7d66a2b92$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $ce2d41f7d66a2b92$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $ce2d41f7d66a2b92$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("doj3j", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", function () { return $9bfc4bb0d36e8cb8$export$b3e508cb103e1f93; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b75e0d02e27316bd7bdb7f42b65d9cdd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9bfc4bb0d36e8cb8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $9bfc4bb0d36e8cb8$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $9bfc4bb0d36e8cb8$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fQ2kV", function(module, exports) {
$parcel$export(module.exports, "CrowdIcon", function () { return $b87d8658772ccd63$export$eaf73f391f7103bd; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25ef791c6b8e2aa654d6c789ba21ad2c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b87d8658772ccd63$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $b87d8658772ccd63$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $b87d8658772ccd63$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5XlOG", function(module, exports) {
$parcel$export(module.exports, "CrowdLogoCS", function () { return $456362b70da5e7bf$export$3c371bdbcdfcdce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::982589d5ed3432ac5a8edfba2cd36cef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $456362b70da5e7bf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $456362b70da5e7bf$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $456362b70da5e7bf$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5aOLC", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", function () { return $3c454434234e3749$export$6da5aa77c402ba0f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1029c08533fbdcff5f0df8497f235af8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $3c454434234e3749$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $3c454434234e3749$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $3c454434234e3749$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $3c454434234e3749$var$svg,
        customThemeSvg: $3c454434234e3749$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("84d9S", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoCS", function () { return $5df8e7710393f2ca$export$f597f0f7fadce0b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a7ad488321186b3a9c29a86e47e09f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5df8e7710393f2ca$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $5df8e7710393f2ca$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $5df8e7710393f2ca$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jQUou", function(module, exports) {
$parcel$export(module.exports, "DxIcon", function () { return $e73e9e4d63dfa76e$export$9951d02c2d848122; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d6e69e54d35c5132352d2d869cff6623>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e73e9e4d63dfa76e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $e73e9e4d63dfa76e$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $e73e9e4d63dfa76e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lHAY5", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", function () { return $fcca4a3ecbc491a9$export$1e02e7298035a77c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5632c329668d03156b9d75797e5dc114>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fcca4a3ecbc491a9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $fcca4a3ecbc491a9$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $fcca4a3ecbc491a9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fFxWm", function(module, exports) {
$parcel$export(module.exports, "FocusLogoCS", function () { return $b685033141b29d8a$export$3a6e8b37e069a69d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c78daeae8d28d39afbbd3766abb4915>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b685033141b29d8a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $b685033141b29d8a$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $b685033141b29d8a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("32Iou", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", function () { return $2373feb6b8e0ea69$export$9eb74917ea768ed4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4207f3a6122eec8b52c0ed3ab03186>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2373feb6b8e0ea69$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $2373feb6b8e0ea69$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $2373feb6b8e0ea69$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6eUy8", function(module, exports) {
$parcel$export(module.exports, "GoalsLogoCS", function () { return $48afea6ef5da38c2$export$c527a545aa426db3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d5250a44d64b619624a2300ae730252c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $48afea6ef5da38c2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $48afea6ef5da38c2$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $48afea6ef5da38c2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ddGCv", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", function () { return $99fd8cb94ef41bb6$export$3f95fcfdc25a741d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c2c28215ef3af884cc4092d906edf31>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $99fd8cb94ef41bb6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $99fd8cb94ef41bb6$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $99fd8cb94ef41bb6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bwWQx", function(module, exports) {
$parcel$export(module.exports, "GuardLogoCS", function () { return $8650548f79577d7c$export$2b896c4d595a4331; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::626a07e2e2912ec06af277d2d5db332f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8650548f79577d7c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $8650548f79577d7c$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $8650548f79577d7c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3obiE", function(module, exports) {
$parcel$export(module.exports, "HomeIcon", function () { return $277c60ebe2138207$export$92c8767b874048d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab0c68a2f803392c4d77e5d4f8659ba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $277c60ebe2138207$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $277c60ebe2138207$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $277c60ebe2138207$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("10Cwo", function(module, exports) {
$parcel$export(module.exports, "HomeLogoCS", function () { return $0bc3ac1d43cc3b53$export$8b6b7f1b1b2367d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d61eb22cff5da1c656082efc821f6f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0bc3ac1d43cc3b53$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $0bc3ac1d43cc3b53$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $0bc3ac1d43cc3b53$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("adcVm", function(module, exports) {
$parcel$export(module.exports, "HubIcon", function () { return $76f524c01a615f1f$export$80b8b269d8b5014e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62c4afc29c8c7e7934b1ed03e01bed0a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $76f524c01a615f1f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $76f524c01a615f1f$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $76f524c01a615f1f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5gQdJ", function(module, exports) {
$parcel$export(module.exports, "HubLogoCS", function () { return $3d66f443552da94b$export$7a38180641471460; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a77d70c2c04e5e73e648a0ad5112dc40>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3d66f443552da94b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $3d66f443552da94b$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $3d66f443552da94b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("h5J3a", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", function () { return $c715d953cc599002$export$c4b5b1f965d8b3eb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f17f23e6bd151211e03a04b1664f0b0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c715d953cc599002$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $c715d953cc599002$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $c715d953cc599002$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $c715d953cc599002$var$svg,
        customThemeSvg: $c715d953cc599002$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1tR0w", function(module, exports) {
$parcel$export(module.exports, "JiraLogoCS", function () { return $11419e07abe75799$export$bf4c5f97b468e8d6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df776258869a3130361a6ba2c751d097>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $11419e07abe75799$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $11419e07abe75799$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $11419e07abe75799$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gTNoB", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterIcon", function () { return $c4d8195ccb86fd2c$export$f8455b5667a3ee0c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02b69897dd1f526e42aaff5e30bc839d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c4d8195ccb86fd2c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $c4d8195ccb86fd2c$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $c4d8195ccb86fd2c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("89x6g", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterLogoCS", function () { return $5ef8d6fb20bf835e$export$3224b07bc93ef23e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b08a11f7ffc5e2a665e1e2e29500a413>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5ef8d6fb20bf835e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $5ef8d6fb20bf835e$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $5ef8d6fb20bf835e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("773g2", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $52dbb6be66482633$export$21bfbeb62fdcce8d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ea9a70f21b9bf06f0562e8a589aebe3a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $52dbb6be66482633$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $52dbb6be66482633$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $52dbb6be66482633$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $52dbb6be66482633$var$svg,
        customThemeSvg: $52dbb6be66482633$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8jhBH", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", function () { return $60cdc17415eaf2ae$export$602140a6a10b02bf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46dae9c30d1c41e6105c8e55da0baf3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $60cdc17415eaf2ae$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $60cdc17415eaf2ae$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $60cdc17415eaf2ae$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7iKdn", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $550e101bafdce77a$export$3c6158790f5e01c4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2d37a9192bbf925d9b10d289d7da029>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $550e101bafdce77a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $550e101bafdce77a$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $550e101bafdce77a$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $550e101bafdce77a$var$svg,
        customThemeSvg: $550e101bafdce77a$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4OCg1", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", function () { return $3819820f5f9efc9e$export$de148263c75d2bc1; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4540a2dfb459d6f1eaf4284aabf73763>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3819820f5f9efc9e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $3819820f5f9efc9e$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $3819820f5f9efc9e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9OzfM", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", function () { return $7254212b2c0fae62$export$65fae0eaf343f2ca; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4937c2a7de5c7b37259bbb6dfd98c7b5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7254212b2c0fae62$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $7254212b2c0fae62$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $7254212b2c0fae62$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8aIK9", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", function () { return $5f31f6fc23845108$export$f64bc7a7f04428d0; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1505ad8f23324b28749a17c4fb70aef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5f31f6fc23845108$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $5f31f6fc23845108$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $5f31f6fc23845108$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9ja3T", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", function () { return $6c6db1739ffa3194$export$8d789f76fde3e05; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::469fe83de93b711b16f637f8e80db481>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6c6db1739ffa3194$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $6c6db1739ffa3194$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $6c6db1739ffa3194$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5m4hC", function(module, exports) {
$parcel$export(module.exports, "LoomLogoCS", function () { return $3e62545cecb0e856$export$78c0b4d8be34c9b2; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92775a97534ebe8c7c43289d98cf43c7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3e62545cecb0e856$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $3e62545cecb0e856$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $3e62545cecb0e856$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2RPPG", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogoCS", function () { return $2168bce5f9b35ffa$export$68d7391318cdef11; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a46bf694d751f816eb650ef61277af79>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2168bce5f9b35ffa$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $2168bce5f9b35ffa$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $2168bce5f9b35ffa$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bfq6M", function(module, exports) {
$parcel$export(module.exports, "LoomInternalIcon", function () { return $83055901857c79fa$export$38c7b37a3e5e8d70; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e02144c4c9c59030582cda1b1253ad33>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $83055901857c79fa$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $83055901857c79fa$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $83055901857c79fa$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6cWbd", function(module, exports) {
$parcel$export(module.exports, "LoomInternalLogoCS", function () { return $4850fe671fa2c535$export$71743a944cb62e48; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5be5723422b7854419d856a94f32ac63>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4850fe671fa2c535$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $4850fe671fa2c535$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $4850fe671fa2c535$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6cujP", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", function () { return $483b61bac8c02372$export$eeccc49dc7a12d9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::beefaa24a87f689ce1de7425b081e3a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $483b61bac8c02372$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $483b61bac8c02372$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $483b61bac8c02372$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("O9ulh", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogoCS", function () { return $096c07d2a420a45f$export$a5b9122e89b32ad3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c628c4e6fb32586c4ae7ee08ce8a67f3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $096c07d2a420a45f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $096c07d2a420a45f$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $096c07d2a420a45f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lAHbT", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", function () { return $fb7e768f0767b873$export$5ed3e1bb3b04fc02; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dd8a9cb4b351840981b01e2d2f3f81dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fb7e768f0767b873$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $fb7e768f0767b873$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $fb7e768f0767b873$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2j6B5", function(module, exports) {
$parcel$export(module.exports, "ProjectsLogoCS", function () { return $1ae27928a291aec0$export$e3d1678155aaab99; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a0db3f343269e63fd1e6e69f81074bb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1ae27928a291aec0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $1ae27928a291aec0$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $1ae27928a291aec0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8jEWD", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", function () { return $60dfdbd68109d15b$export$e23ae35269442b4f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::381f7987563be8499a0e54ff3032bfd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $60dfdbd68109d15b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $60dfdbd68109d15b$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $60dfdbd68109d15b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bepWJ", function(module, exports) {
$parcel$export(module.exports, "RovoLogoCS", function () { return $82d520e7df03c553$export$b0e15f0a1c9f4c55; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f01ddc6d7673bd212094955c82b9af78>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $82d520e7df03c553$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $82d520e7df03c553$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $82d520e7df03c553$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9gQF5", function(module, exports) {
$parcel$export(module.exports, "RovoDevIcon", function () { return $6bfe753656f74c0b$export$8b784b3227531b3e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd407d7bb5fab179d28c0061a631e8e8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6bfe753656f74c0b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $6bfe753656f74c0b$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $6bfe753656f74c0b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("81Tku", function(module, exports) {
$parcel$export(module.exports, "RovoDevLogoCS", function () { return $5d89560731202566$export$4145bd793c9ed1d0; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a68b50724bc9a8775db11ff04136c5ca>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5d89560731202566$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $5d89560731202566$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $5d89560731202566$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iyubB", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentIcon", function () { return $d822d14aecf3ba4d$export$813cff80931d9dbf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73933e32619ad2ec27398b610bcd63a9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d822d14aecf3ba4d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d822d14aecf3ba4d$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $d822d14aecf3ba4d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2iCyk", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentLogoCS", function () { return $1acb2af390e59170$export$58747af448450872; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1097e9235bd2bf7714fe3af3e77f7fcd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1acb2af390e59170$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $1acb2af390e59170$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $1acb2af390e59170$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2JmhH", function(module, exports) {
$parcel$export(module.exports, "RovoHexIcon", function () { return $1fd111f2bdcf5b3b$export$9e62346a60cfb459; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::368a9db7195075ae1012389340d31ec4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1fd111f2bdcf5b3b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $1fd111f2bdcf5b3b$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $1fd111f2bdcf5b3b$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9CPlP", function(module, exports) {
$parcel$export(module.exports, "RovoHexLogoCS", function () { return $701f7ee741981ed6$export$5e38d02efdb45577; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2febaef4c79ceb55003ced8071cfd766>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $701f7ee741981ed6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $701f7ee741981ed6$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $701f7ee741981ed6$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9MPXR", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", function () { return $7200e7d3196aedb6$export$82eafebb825fc23f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::75130c29b2f378bebaec50386a50a8f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7200e7d3196aedb6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7200e7d3196aedb6$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $7200e7d3196aedb6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hJLiA", function(module, exports) {
$parcel$export(module.exports, "SearchLogoCS", function () { return $ce9b542dc912f501$export$fa08cbfe393f2a68; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7d097901f1cc1f3bda7d447dd700321>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ce9b542dc912f501$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ce9b542dc912f501$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $ce9b542dc912f501$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9AxNa", function(module, exports) {
$parcel$export(module.exports, "SearchNewIcon", function () { return $6fb1b039952a9082$export$3599582ddc9fc5cf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed55e7b276490b3799d556c893e1267e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6fb1b039952a9082$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6fb1b039952a9082$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $6fb1b039952a9082$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("f20db", function(module, exports) {
$parcel$export(module.exports, "SearchNewLogoCS", function () { return $af1734f7aa3d9614$export$d669f6cbbb67e061; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::013a7cd7e2e1e4bf4f8e830bbe958755>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $af1734f7aa3d9614$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $af1734f7aa3d9614$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $af1734f7aa3d9614$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("68oHf", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", function () { return $0127133005d8e095$export$f3f5aa321d88adf9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd83e9aeafaa2f880babb870f3c31a26>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0127133005d8e095$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $0127133005d8e095$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $0127133005d8e095$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("17U6m", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogoCS", function () { return $0d21f681e8f6ca2a$export$2bc88a281410ffa7; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e27288819df7a1e20b51bb337bc50dec>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0d21f681e8f6ca2a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $0d21f681e8f6ca2a$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $0d21f681e8f6ca2a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ll0e2", function(module, exports) {
$parcel$export(module.exports, "StudioIcon", function () { return $f88bbbe9a2fac82a$export$290a0f24614cde9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::557dd965c02920b468bc15d2f1c373a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f88bbbe9a2fac82a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $f88bbbe9a2fac82a$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $f88bbbe9a2fac82a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ffutL", function(module, exports) {
$parcel$export(module.exports, "StudioLogoCS", function () { return $b19fe63fcfca493d$export$273fd56580e523ae; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b99049506cac915656bc5da47e2c0efd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b19fe63fcfca493d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $b19fe63fcfca493d$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $b19fe63fcfca493d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2wwNj", function(module, exports) {
$parcel$export(module.exports, "StudioNewIcon", function () { return $1d680238aac50c90$export$8bb9894377e04e04; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::195bd3a19deb671fe29f779e9de58b90>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1d680238aac50c90$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $1d680238aac50c90$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $1d680238aac50c90$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1Aji7", function(module, exports) {
$parcel$export(module.exports, "StudioNewLogoCS", function () { return $12781e107b39ea77$export$170353c338ac5f4a; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffb29c88c1e14c5de425429a700acab3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $12781e107b39ea77$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $12781e107b39ea77$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $12781e107b39ea77$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5RDzb", function(module, exports) {
$parcel$export(module.exports, "TalentIcon", function () { return $4450980bc2d90516$export$4b05688514531169; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1fd3fd4e53954a78af7441133f6a6a1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4450980bc2d90516$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4450980bc2d90516$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $4450980bc2d90516$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gTa1W", function(module, exports) {
$parcel$export(module.exports, "TalentLogoCS", function () { return $c4b99037e8353b3c$export$1b3979d995ebbc6e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d69737e709e7c4233a800f13f41c3e31>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c4b99037e8353b3c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $c4b99037e8353b3c$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $c4b99037e8353b3c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("62hIu", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", function () { return $4650ac1e815a5971$export$1bcbc9c337da86da; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::679db22f20a8bcb2df3bd71c0103c3c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4650ac1e815a5971$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $4650ac1e815a5971$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $4650ac1e815a5971$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3caL9", function(module, exports) {
$parcel$export(module.exports, "TeamsLogoCS", function () { return $253ad6b35995f75d$export$bfd8d1c4da84ce71; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c293c2724f1e375a5c30a276e34a2a8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $253ad6b35995f75d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $253ad6b35995f75d$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $253ad6b35995f75d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ex2Az", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", function () { return $a94627d810641ed2$export$4384da9b8b140bf4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da40a1303dd7741d385217c7a3d33831>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kGaM3 = parcelRequire("kGaM3");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a94627d810641ed2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $a94627d810641ed2$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $a94627d810641ed2$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGaM3.IconWrapper), {
        svg: $a94627d810641ed2$var$svg,
        customThemeSvg: $a94627d810641ed2$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("059d1", function(module, exports) {
$parcel$export(module.exports, "TrelloLogoCS", function () { return $00f79c7462a12733$export$1b13139dfc0336af; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecc5f242ac350bfbaf81aa84a699e7e9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $4skhl = parcelRequire("4skhl");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $00f79c7462a12733$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $00f79c7462a12733$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4skhl.LogoWrapper), {
        svg: $00f79c7462a12733$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1oYke", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminIcon", function () { return $1056d3b19e874308$export$84109e099492cb5f; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $1056d3b19e874308$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $1056d3b19e874308$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        svg: $1056d3b19e874308$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("2Le1e", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", function () { return $202ad86c22b031a9$export$438460117ae6b7ee; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $202ad86c22b031a9$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $202ad86c22b031a9$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("9n73X", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d2bbd9034aaa1a4$export$2e2bcd8739ae039; });
/* wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $lFXSz = parcelRequire("lFXSz");

var $20yn1 = parcelRequire("20yn1");

var $83DuP = parcelRequire("83DuP");

var $1oC0p = parcelRequire("1oC0p");

var $ey7Qk = parcelRequire("ey7Qk");
var $6d2bbd9034aaa1a4$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $6d2bbd9034aaa1a4$var$CSS_VAR_COLOR = '--logo-color';
var $6d2bbd9034aaa1a4$var$CSS_VAR_FILL = '--logo-fill';
var $6d2bbd9034aaa1a4$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $6d2bbd9034aaa1a4$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, $83DuP.default)(_ref, $6d2bbd9034aaa1a4$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $lFXSz.default)({
        "data-testid": testId,
        style: (0, $20yn1.default)((0, $20yn1.default)({}, $6d2bbd9034aaa1a4$var$CSS_VAR_COLOR, iconColor), $6d2bbd9034aaa1a4$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $ey7Qk.default)([
            $6d2bbd9034aaa1a4$var$styles.root,
            shouldApplyStopColor && $6d2bbd9034aaa1a4$var$styles.stop,
            size && $6d2bbd9034aaa1a4$var$styles[size]
        ])
    }));
};
var $6d2bbd9034aaa1a4$export$2e2bcd8739ae039 = $6d2bbd9034aaa1a4$var$Wrapper;

});
parcelRegister("lFXSz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc7be011e083a6b8$export$2e2bcd8739ae039; });
function $fc7be011e083a6b8$export$2e2bcd8739ae039() {
    return $fc7be011e083a6b8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fc7be011e083a6b8$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("83DuP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ddd3dad76f06a71$export$2e2bcd8739ae039; });

var $612c9 = parcelRequire("612c9");
function $5ddd3dad76f06a71$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $612c9.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("612c9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $461489f36b527e82$export$2e2bcd8739ae039; });
function $461489f36b527e82$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});



parcelRegister("g8bHf", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", function () { return $bbe677634bc19990$export$362a25f017e2bc8a; });
$parcel$export(module.exports, "getColorsFromAppearance", function () { return $bbe677634bc19990$export$bbacc3980e0f3029; });
$parcel$export(module.exports, "getColorsForLoom", function () { return $bbe677634bc19990$export$7818df200941dbbf; });

var $lypLB = parcelRequire("lypLB");
var $bbe677634bc19990$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $lypLB.B400);
            iconGradientStop = (0, $lypLB.B200);
            iconColor = (0, $lypLB.B200);
            textColor = "var(--ds-text, ".concat((0, $lypLB.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $lypLB.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $lypLB.N600);
            iconGradientStop = (0, $lypLB.N100);
            iconColor = (0, $lypLB.N100);
            textColor = (0, $lypLB.N400);
            atlassianLogoTextColor = (0, $lypLB.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $bbe677634bc19990$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $lypLB.N0);
            textColor = (0, $lypLB.N0);
            atlassianLogoTextColor = (0, $lypLB.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $bbe677634bc19990$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $bbe677634bc19990$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $bbe677634bc19990$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
parcelRegister("lypLB", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $fb10c2b83a1617ff$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $fb10c2b83a1617ff$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $fb10c2b83a1617ff$export$29a4f05edc054374; });
$parcel$export(module.exports, "N100", function () { return $fb10c2b83a1617ff$export$d6447c357493214f; });
$parcel$export(module.exports, "N400", function () { return $fb10c2b83a1617ff$export$eece5f492e429f08; });
$parcel$export(module.exports, "N600", function () { return $fb10c2b83a1617ff$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $fb10c2b83a1617ff$export$7d61b15e0da132af; });
// Reds
var $fb10c2b83a1617ff$export$4b84fd0e2c617bd = '#FFEBE6';
var $fb10c2b83a1617ff$export$b34b069eff244586 = '#FFBDAD';
var $fb10c2b83a1617ff$export$be802dd0d8b57f35 = '#FF8F73';
var $fb10c2b83a1617ff$export$60847d42f9da92a6 = '#FF7452';
var $fb10c2b83a1617ff$export$4a7404f376229999 = '#FF5630';
var $fb10c2b83a1617ff$export$2010d0fb4295b346 = '#DE350B';
var $fb10c2b83a1617ff$export$2837b5a1a71d5c02 = '#BF2600';
var $fb10c2b83a1617ff$export$8d9596b529bbb9cf = '#FFFAE6';
var $fb10c2b83a1617ff$export$41060a744ab0b7ae = '#FFF0B3';
var $fb10c2b83a1617ff$export$1cc05bbbf340e559 = '#FFE380';
var $fb10c2b83a1617ff$export$5aae31392d72caaa = '#FFC400';
var $fb10c2b83a1617ff$export$c6930421db9fa514 = '#FFAB00';
var $fb10c2b83a1617ff$export$59619663aa6500fb = '#FF991F';
var $fb10c2b83a1617ff$export$874739ea9e379ab6 = '#FF8B00';
var $fb10c2b83a1617ff$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $fb10c2b83a1617ff$export$69a3bf21b9686c2b = '#ABF5D1';
var $fb10c2b83a1617ff$export$afbce1382ec95f73 = '#79F2C0';
var $fb10c2b83a1617ff$export$747d86715d4175de = '#57D9A3';
var $fb10c2b83a1617ff$export$940e1f69e873f202 = '#36B37E';
var $fb10c2b83a1617ff$export$a49394138f7b8e85 = '#00875A';
var $fb10c2b83a1617ff$export$6fa04827ac68a4fb = '#006644';
var $fb10c2b83a1617ff$export$226de0355ed012f8 = '#DEEBFF';
var $fb10c2b83a1617ff$export$8c13c2ee36917869 = '#B3D4FF';
var $fb10c2b83a1617ff$export$ecfc1dff386a3e7a = '#4C9AFF';
var $fb10c2b83a1617ff$export$215b7063051591f1 = '#2684FF';
var $fb10c2b83a1617ff$export$e62e8919cca44969 = '#0065FF';
var $fb10c2b83a1617ff$export$b3de0ae08da2ce64 = '#0052CC';
var $fb10c2b83a1617ff$export$a6ee3d71bc067634 = '#0747A6';
var $fb10c2b83a1617ff$export$67f15409e87642a1 = '#669DF1';
var $fb10c2b83a1617ff$export$f0539dbc42dbb067 = '#8FB8F6';
var $fb10c2b83a1617ff$export$363e4475840015bb = '#EAE6FF';
var $fb10c2b83a1617ff$export$4b0a4417ed59760f = '#C0B6F2';
var $fb10c2b83a1617ff$export$6011520a64d9a187 = '#998DD9';
var $fb10c2b83a1617ff$export$a7175d4e9206bc80 = '#8777D9';
var $fb10c2b83a1617ff$export$b48405b95304b5a1 = '#6554C0';
var $fb10c2b83a1617ff$export$c71e4279dd54a18d = '#5243AA';
var $fb10c2b83a1617ff$export$147899de772240ec = '#403294';
var $fb10c2b83a1617ff$export$2cf711fe14c66f06 = '#E6FCFF';
var $fb10c2b83a1617ff$export$7a8f4d33f6f9772c = '#B3F5FF';
var $fb10c2b83a1617ff$export$776c9c497ef08533 = '#79E2F2';
var $fb10c2b83a1617ff$export$69cb3ca10c1e330e = '#00C7E6';
var $fb10c2b83a1617ff$export$9dc1ef0f3f48059b = '#00B8D9';
var $fb10c2b83a1617ff$export$7c835c78b6fcdef8 = '#00A3BF';
var $fb10c2b83a1617ff$export$6036577f95c3877e = '#008DA6';
var $fb10c2b83a1617ff$export$29a4f05edc054374 = '#FFFFFF';
var $fb10c2b83a1617ff$export$e655ef011c4aa1a2 = '#FAFBFC';
var $fb10c2b83a1617ff$export$9fdfb749e33cdf97 = '#F4F5F7';
var $fb10c2b83a1617ff$export$3e51e8f1440314ba = '#EBECF0';
var $fb10c2b83a1617ff$export$1ce2d1575d444ceb = '#DFE1E6';
var $fb10c2b83a1617ff$export$8754fc7e6d8b3000 = '#C1C7D0';
var $fb10c2b83a1617ff$export$c2e91cbeada39b8b = '#B3BAC5';
var $fb10c2b83a1617ff$export$5f71e19f3a7ad9de = '#A5ADBA';
var $fb10c2b83a1617ff$export$eaa8c8a70ac22806 = '#97A0AF';
var $fb10c2b83a1617ff$export$7c87d337fb91a97d = '#8993A4';
var $fb10c2b83a1617ff$export$d6447c357493214f = '#7A869A';
var $fb10c2b83a1617ff$export$f563ee71e9ee74cd = '#6B778C';
var $fb10c2b83a1617ff$export$e2ef2124cf4024b1 = '#5E6C84';
var $fb10c2b83a1617ff$export$eece5f492e429f08 = '#505F79';
var $fb10c2b83a1617ff$export$c39c0fe0f26207ae = '#42526E';
var $fb10c2b83a1617ff$export$7090862dc3038a9f = '#344563';
var $fb10c2b83a1617ff$export$ad0bacf983b7ddaa = '#253858';
var $fb10c2b83a1617ff$export$7d61b15e0da132af = '#172B4D';
var $fb10c2b83a1617ff$export$fbda843f0a27fe96 = '#091E42';
var $fb10c2b83a1617ff$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $fb10c2b83a1617ff$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $fb10c2b83a1617ff$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $fb10c2b83a1617ff$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $fb10c2b83a1617ff$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $fb10c2b83a1617ff$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $fb10c2b83a1617ff$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $fb10c2b83a1617ff$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $fb10c2b83a1617ff$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $fb10c2b83a1617ff$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $fb10c2b83a1617ff$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $fb10c2b83a1617ff$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $fb10c2b83a1617ff$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $fb10c2b83a1617ff$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $fb10c2b83a1617ff$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $fb10c2b83a1617ff$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $fb10c2b83a1617ff$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $fb10c2b83a1617ff$export$2f6319cf7d736c2a = '#E6EDFA';
var $fb10c2b83a1617ff$export$95126bc8884d6634 = '#DCE5F5';
var $fb10c2b83a1617ff$export$8338d8c35d44ff1 = '#CED9EB';
var $fb10c2b83a1617ff$export$5368d76ae4fbbda7 = '#B8C7E0';
var $fb10c2b83a1617ff$export$9f0a771d16ec8d36 = '#ABBBD6';
var $fb10c2b83a1617ff$export$abcf8c38338b4aa5 = '#9FB0CC';
var $fb10c2b83a1617ff$export$97e81faa16a182c7 = '#8C9CB8';
var $fb10c2b83a1617ff$export$bfe21c59123ecf33 = '#7988A3';
var $fb10c2b83a1617ff$export$ee82aa2ea6a1558 = '#67758F';
var $fb10c2b83a1617ff$export$682927c6ed76be02 = '#56637A';
var $fb10c2b83a1617ff$export$91fd9994c5be9757 = '#455166';
var $fb10c2b83a1617ff$export$d281fbfe3cff2df6 = '#3B475C';
var $fb10c2b83a1617ff$export$3902c91d8b98a753 = '#313D52';
var $fb10c2b83a1617ff$export$8e8133c1ba5845b5 = '#283447';
var $fb10c2b83a1617ff$export$33ff357f6620b39 = '#202B3D';
var $fb10c2b83a1617ff$export$633847cf062b69e0 = '#1B2638';
var $fb10c2b83a1617ff$export$9776a6e503bdbf76 = '#121A29';
var $fb10c2b83a1617ff$export$6c813d5160dff5db = '#0E1624';
var $fb10c2b83a1617ff$export$3d4f271a500072a = '#0D1424';
var $fb10c2b83a1617ff$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $fb10c2b83a1617ff$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $fb10c2b83a1617ff$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $fb10c2b83a1617ff$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $fb10c2b83a1617ff$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $fb10c2b83a1617ff$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $fb10c2b83a1617ff$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $fb10c2b83a1617ff$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $fb10c2b83a1617ff$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $fb10c2b83a1617ff$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $fb10c2b83a1617ff$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $fb10c2b83a1617ff$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $fb10c2b83a1617ff$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $fb10c2b83a1617ff$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $fb10c2b83a1617ff$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $fb10c2b83a1617ff$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $fb10c2b83a1617ff$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $fb10c2b83a1617ff$export$d2adc5dedf09fced = '#292A2E';
var $fb10c2b83a1617ff$export$f51762073d2bb381 = '#94C748';
var $fb10c2b83a1617ff$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("9Fddb", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminLogo", function () { return $709230f0ef8af52e$export$f845d9b9254f0541; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $709230f0ef8af52e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $709230f0ef8af52e$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $709230f0ef8af52e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cLMi5", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationIcon", function () { return $94bf5554114deef5$export$74517ed253186308; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $94bf5554114deef5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $94bf5554114deef5$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        svg: $94bf5554114deef5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cyk7z", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationLogo", function () { return $923844a74156f653$export$833abe6c2ce5ebfd; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $923844a74156f653$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $923844a74156f653$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $923844a74156f653$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dinK7", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsIcon", function () { return $9adf5f9e5507761e$export$c42ad8a0b925c762; });

var $1oC0p = parcelRequire("1oC0p");

var $hSCVp = parcelRequire("hSCVp");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $9adf5f9e5507761e$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $9adf5f9e5507761e$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $hSCVp.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $9adf5f9e5507761e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("hSCVp", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $d045ac801fc712f1$export$f680877a34711e37; });

var $43ahk = parcelRequire("43ahk");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $39c3M = parcelRequire("39c3M");
var $d045ac801fc712f1$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $d045ac801fc712f1$var$react18UseId = ($d045ac801fc712f1$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $d045ac801fc712f1$var$_React$useId !== void 0 ? $d045ac801fc712f1$var$_React$useId : undefined;
function $d045ac801fc712f1$export$f680877a34711e37() {
    if ($d045ac801fc712f1$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        if ((0, $39c3M.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $d045ac801fc712f1$var$react18UseId().replace(/[:«»]/g, '_');
        return $d045ac801fc712f1$var$react18UseId();
    }
    return "uid".concat((0, $6JmtO.useUID)());
}
var $d045ac801fc712f1$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d045ac801fc712f1$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $43ahk.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $43ahk.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d045ac801fc712f1$export$6ee17796e3d70de2() {
    if ($d045ac801fc712f1$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $d045ac801fc712f1$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6JmtO.useUIDSeed)();
}

});


parcelRegister("gxZkM", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsLogo", function () { return $c0bf4e133490535e$export$e6470bfc39010cc4; });

var $1oC0p = parcelRequire("1oC0p");

var $hSCVp = parcelRequire("hSCVp");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $c0bf4e133490535e$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $c0bf4e133490535e$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $hSCVp.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $c0bf4e133490535e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kgbZM", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", function () { return $ebfe9b4ee618bdb8$export$5fc1066e677788d4; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $ebfe9b4ee618bdb8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $ebfe9b4ee618bdb8$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $ebfe9b4ee618bdb8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1OG8V", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", function () { return $152b26acf65edef9$export$bd40525f5333524b; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $152b26acf65edef9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $152b26acf65edef9$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $152b26acf65edef9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bLYCy", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", function () { return $89231b8e839786ca$export$f7857fe64d7161d9; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $89231b8e839786ca$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $89231b8e839786ca$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $89231b8e839786ca$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("UB6rg", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", function () { return $0aa202ee46e39098$export$eb7d748e4f9c9676; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $0aa202ee46e39098$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $0aa202ee46e39098$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $0aa202ee46e39098$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("csbFN", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", function () { return $91112797e00bd27e$export$68f3db7f6af48bcb; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $91112797e00bd27e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $91112797e00bd27e$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $91112797e00bd27e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3gas0", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogo", function () { return $25faf8fd80f8a000$export$1b2e4fe6ef471556; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $25faf8fd80f8a000$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $25faf8fd80f8a000$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $25faf8fd80f8a000$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("akiqO", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", function () { return $784a11b86ac7e666$export$1e02e7298035a77c; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $784a11b86ac7e666$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $784a11b86ac7e666$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $784a11b86ac7e666$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jHyCe", function(module, exports) {
$parcel$export(module.exports, "FocusLogo", function () { return $e57ce26f2e2d7873$export$33908560ea1b226d; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $e57ce26f2e2d7873$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $e57ce26f2e2d7873$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $e57ce26f2e2d7873$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7FjrS", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", function () { return $594b72d4f0b8f6eb$export$3f95fcfdc25a741d; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $594b72d4f0b8f6eb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $594b72d4f0b8f6eb$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        svg: $594b72d4f0b8f6eb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cyi5L", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", function () { return $9236b1b025d5791d$export$a4a891d202775deb; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $9236b1b025d5791d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $9236b1b025d5791d$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $9236b1b025d5791d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("icMmC", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", function () { return $d40edd0207534dc3$export$c4b5b1f965d8b3eb; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $d40edd0207534dc3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $d40edd0207534dc3$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $d40edd0207534dc3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("25WTg", function(module, exports) {
$parcel$export(module.exports, "JiraLogo", function () { return $1869baca867b8ce9$export$17d3acb0b4379d02; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $1869baca867b8ce9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $1869baca867b8ce9$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $1869baca867b8ce9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2zeHP", function(module, exports) {
$parcel$export(module.exports, "JiraAlignIcon", function () { return $1dea41f06cbbea68$export$407687b2dd89cc68; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $1dea41f06cbbea68$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $1dea41f06cbbea68$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $1dea41f06cbbea68$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2XqtM", function(module, exports) {
$parcel$export(module.exports, "JiraAlignLogo", function () { return $2275a1afac92e8c9$export$ee11e928d3d045fd; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $2275a1afac92e8c9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $2275a1afac92e8c9$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2275a1afac92e8c9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3KjHR", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $2ba4f447a2ba43f3$export$21bfbeb62fdcce8d; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $2ba4f447a2ba43f3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $2ba4f447a2ba43f3$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $2ba4f447a2ba43f3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("c3O0r", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $8c7c8e034ac2f791$export$c49a2b642fe9eef4; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $8c7c8e034ac2f791$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $8c7c8e034ac2f791$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $8c7c8e034ac2f791$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("53ODU", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $3af484216c1c9991$export$3c6158790f5e01c4; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $3af484216c1c9991$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $3af484216c1c9991$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $3af484216c1c9991$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aUefO", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $7f0a30e49a389252$export$dabef2be6cd28c20; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $7f0a30e49a389252$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $7f0a30e49a389252$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7f0a30e49a389252$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jQetv", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", function () { return $e71e1a14b3b2dba8$export$8d789f76fde3e05; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $e71e1a14b3b2dba8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsForLoom)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $e71e1a14b3b2dba8$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $e71e1a14b3b2dba8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("39z4h", function(module, exports) {
$parcel$export(module.exports, "LoomLogo", function () { return $24bd6a266d0e7de4$export$94e206806e36c2ec; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $24bd6a266d0e7de4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsForLoom)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $24bd6a266d0e7de4$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $24bd6a266d0e7de4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7dEOv", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionIcon", function () { return $541968028906a148$export$1bf47cdade1a9fcb; });

var $1oC0p = parcelRequire("1oC0p");

var $2Le1e = parcelRequire("2Le1e");

var $jQetv = parcelRequire("jQetv");
var $541968028906a148$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jQetv.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("8mAZG", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", function () { return $616d1301e4e655bc$export$6e87ce8d41eda665; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $616d1301e4e655bc$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $616d1301e4e655bc$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $616d1301e4e655bc$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ljbbT", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", function () { return $f8340d9201888c2c$export$eeccc49dc7a12d9f; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $f8340d9201888c2c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $f8340d9201888c2c$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        svg: $f8340d9201888c2c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3ISql", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogo", function () { return $2b5fb29b89ed2232$export$a1c6484cdecc2c4b; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $2b5fb29b89ed2232$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $2b5fb29b89ed2232$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $2b5fb29b89ed2232$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dTUCg", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", function () { return $a1ec5436d307a92d$export$e23ae35269442b4f; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $a1ec5436d307a92d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $a1ec5436d307a92d$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        svg: $a1ec5436d307a92d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4oYxE", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", function () { return $33485da04cdf1b49$export$a0f6cb8061290bbb; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $33485da04cdf1b49$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $33485da04cdf1b49$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $33485da04cdf1b49$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("blhQc", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", function () { return $841f7eb2c81e5054$export$f3f5aa321d88adf9; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $841f7eb2c81e5054$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $841f7eb2c81e5054$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $841f7eb2c81e5054$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9GD6X", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogo", function () { return $70d65ff46156b126$export$bb4ae5b41b43be04; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $70d65ff46156b126$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $70d65ff46156b126$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $70d65ff46156b126$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("683e9", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", function () { return $4765fe4a46458d3e$export$4384da9b8b140bf4; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $4765fe4a46458d3e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $4765fe4a46458d3e$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        svg: $4765fe4a46458d3e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3ij6w", function(module, exports) {
$parcel$export(module.exports, "TrelloLogo", function () { return $2661df3f75f0de7d$export$60e26212f3b61a28; });

var $1oC0p = parcelRequire("1oC0p");

var $jLY4R = parcelRequire("jLY4R");

var $2Le1e = parcelRequire("2Le1e");

var $9n73X = parcelRequire("9n73X");

var $g8bHf = parcelRequire("g8bHf");
var $2661df3f75f0de7d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $g8bHf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $2661df3f75f0de7d$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2Le1e.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2Le1e.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2Le1e.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $jLY4R.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9n73X.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2661df3f75f0de7d$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dPIrG", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedComponent", function () { return $a12283bb365084e0$export$e30d2ddc605f6bb; });
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", function () { return $a12283bb365084e0$export$436fcf6e31fbacea; });
$parcel$export(module.exports, "createFeatureFlaggedRovoComponent", function () { return $a12283bb365084e0$export$2469203854060337; });
$parcel$export(module.exports, "tempSizeWrapper", function () { return $a12283bb365084e0$export$667425256e2e7296; });
$parcel$export(module.exports, "teamEUFlaggedIcon", function () { return $a12283bb365084e0$export$3fe521abfbbe6ab3; });

var $lFXSz = parcelRequire("lFXSz");

var $83DuP = parcelRequire("83DuP");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");
var $a12283bb365084e0$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $a12283bb365084e0$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $a12283bb365084e0$var$_excluded3 = [
    "shouldUseHexLogo"
], $a12283bb365084e0$var$_excluded4 = [
    "size"
];
var $a12283bb365084e0$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, $83DuP.default)(_ref, $a12283bb365084e0$var$_excluded);
        if ((0, $39c3M.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(NewComponent, (0, $lFXSz.default)({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LegacyComponent, (0, $lFXSz.default)({
            size: size
        }, props));
    };
};
var $a12283bb365084e0$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, $83DuP.default)(_ref2, $a12283bb365084e0$var$_excluded2);
        if ((0, $39c3M.fg)('platform-logo-rebrand-servco') || (0, $39c3M.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(NewComponent, (0, $lFXSz.default)({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LegacyComponent, (0, $lFXSz.default)({
            size: size
        }, props));
    };
};
var $a12283bb365084e0$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $a12283bb365084e0$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $a12283bb365084e0$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, $83DuP.default)(_ref3, $a12283bb365084e0$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $39c3M.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $a12283bb365084e0$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, $83DuP.default)(_ref4, $a12283bb365084e0$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(NewComponent, (0, $lFXSz.default)({
            size: size || 'medium'
        }, props));
    };
};
var $a12283bb365084e0$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $39c3M.fg)('platform-logo-rebrand-team-eu') ? $a12283bb365084e0$export$667425256e2e7296(NewComponent) : $a12283bb365084e0$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Logo, props);
    };
};
var $a12283bb365084e0$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $a12283bb365084e0$export$62e1212796a86b1b = $a12283bb365084e0$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $a12283bb365084e0$export$e0dee4a765830f4d = $a12283bb365084e0$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $a12283bb365084e0$export$a13ce90e90d7bfc1 = $a12283bb365084e0$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'agent' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $a12283bb365084e0$export$516fce44c502c1d3 = $a12283bb365084e0$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $a12283bb365084e0$export$b805fae8e798ed39 = $a12283bb365084e0$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $a12283bb365084e0$export$3f9abd26214cd85f = $a12283bb365084e0$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});

});


parcelRegister("lnHkK", function(module, exports) {
$parcel$export(module.exports, "SmartBanner", function () { return $1d4e63f072dc840e$export$d11b91f4723c589e; });
/* smart-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $dE0sS = parcelRequire("dE0sS");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $1d4e63f072dc840e$var$bannerStyles = null;
const $1d4e63f072dc840e$var$wrapperStyles = null;
const $1d4e63f072dc840e$var$avatarContainerStyles = null;
const $1d4e63f072dc840e$var$closeButtonStyles = null;
const $1d4e63f072dc840e$var$closeIconStyles = null;
const $1d4e63f072dc840e$var$appIconContainerStyles = null;
const $1d4e63f072dc840e$var$textContainerStyles = null;
const $1d4e63f072dc840e$var$titleStyles = null;
const $1d4e63f072dc840e$var$subtitleStyles = null;
const $1d4e63f072dc840e$var$buttonStyles = null;
const $1d4e63f072dc840e$export$d11b91f4723c589e = ({ appIcon: appIcon, title: title, subtitle: subtitle, buttonText: buttonText, buttonHref: buttonHref, buttonAriaLabel: buttonAriaLabel, onClose: onClose, className: className, dataEventProps: dataEventProps })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1rjc1crf _bozgf6fq _y4ti7vkz _bfhkdkka _16qs1a0j _kqswh2mm _1bsb1osq _vchhusvi",
            className
        ]),
        role: "banner",
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light200')),
            "--_1aetymw": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light500'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _16jlkb7n _1o9zidpf _i0dlf1ug _zulprdoj _4cvr1h6o _1tket94y _1ul9t94y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulp19bv _4cvr1h6o _1o9zidpf"
                        ]),
                        children: [
                            onClose && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                onClick: onClose,
                                "aria-label": "Close banner",
                                type: "button",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _bfhk1j28 _80omtlke _1bsbftgi _4t3iftgi _1o9zidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    "aria-hidden": "true",
                                    className: (0, $2jatx.default)([
                                        "_1bsbftgi _4t3iftgi _kqswh2mm _syaz1pfd"
                                    ]),
                                    style: {
                                        "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                                        size: "14"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                "aria-hidden": "true",
                                className: (0, $2jatx.default)([
                                    "_1bsb1ylp _4t3i1ylp _2rko19bv _1reo15vq _18m915vq _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _1lve1ylp _1pww1ylp"
                                ]),
                                children: appIcon
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _16jlkb7n _1o9zidpf _i0dlf1ug _2lx21bp4 _zulp1l7b _4cvr1y6m _1bah1h6o _1q51yh40 _1tket94y _1ul9t94y"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_ect4b1j9 _1wybdlk8 _vwz4dlk8 _k48pbfng _syaz1pfd _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1dyz1ha8 _o5721q9c"
                                ]),
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_ect4b1j9 _1wyb1skh _vwz41crf _k48pbfng _syazk0sw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c"
                                ]),
                                style: {
                                    "--_1e97w25": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light700'))
                                },
                                children: subtitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: buttonHref,
                "aria-label": buttonAriaLabel,
                "data-event": "clicked",
                "data-event-component": "smartBannerButton",
                ...dataEventProps,
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _1rjci2wt _18zrw1gv _2rko1ylp _bfhk5hrz _19itglyw _ect4z4z1 _1wybo7ao _vwz4f6fq _k48p1nn1 _syaz1afi _4bfu1r31 _1hmsglyw _ajmmnqa1 _y3gn1h6o _1dyz81m1 _o5721q9c _1o9zidpf _80omtlke"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue')),
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                },
                children: buttonText
            })
        ]
    });
};
var $1d4e63f072dc840e$export$2e2bcd8739ae039 = $1d4e63f072dc840e$export$d11b91f4723c589e;

});


parcelRegister("2Df35", function(module, exports) {
$parcel$export(module.exports, "LogoV3", function () { return $4dc1f19337306bef$export$69f5b385b2c2b585; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $deuMy = parcelRequire("deuMy");

var $lY9mQ = parcelRequire("lY9mQ");

var $9okfL = parcelRequire("9okfL");

var $cvpju = parcelRequire("cvpju");

var $ehLaM = parcelRequire("ehLaM");

var $iKGTm = parcelRequire("iKGTm");

var $quwDK = parcelRequire("quwDK");

var $kodXM = parcelRequire("kodXM");

var $eupP4 = parcelRequire("eupP4");

var $eu7cp = parcelRequire("eu7cp");

var $jyv8q = parcelRequire("jyv8q");

var $3dAc4 = parcelRequire("3dAc4");

var $iyxHK = parcelRequire("iyxHK");

var $dfmcY = parcelRequire("dfmcY");

var $3ufD2 = parcelRequire("3ufD2");

var $9cBfs = parcelRequire("9cBfs");

var $fWbT9 = parcelRequire("fWbT9");

var $46TV4 = parcelRequire("46TV4");

var $zMH4F = parcelRequire("zMH4F");

var $2U9yb = parcelRequire("2U9yb");

var $7yK4t = parcelRequire("7yK4t");

var $jgx2N = parcelRequire("jgx2N");

var $b1Nny = parcelRequire("b1Nny");

var $hcxdE = parcelRequire("hcxdE");

var $ePJI2 = parcelRequire("ePJI2");

var $evhqU = parcelRequire("evhqU");

var $fPTok = parcelRequire("fPTok");

var $abOrE = parcelRequire("abOrE");

var $lDqnU = parcelRequire("lDqnU");

var $ld6VA = parcelRequire("ld6VA");

var $dRHrS = parcelRequire("dRHrS");

var $jKMT0 = parcelRequire("jKMT0");

var $iOOjr = parcelRequire("iOOjr");

var $kvHRV = parcelRequire("kvHRV");

var $5xMyM = parcelRequire("5xMyM");

var $4dGNW = parcelRequire("4dGNW");

var $j5JD4 = parcelRequire("j5JD4");

var $bkJxb = parcelRequire("bkJxb");

var $f59AY = parcelRequire("f59AY");

var $gx7vL = parcelRequire("gx7vL");

var $aLKEe = parcelRequire("aLKEe");

var $4bdUn = parcelRequire("4bdUn");

var $6APt1 = parcelRequire("6APt1");

var $k9aBd = parcelRequire("k9aBd");

var $kQiXS = parcelRequire("kQiXS");

var $5pwBY = parcelRequire("5pwBY");

var $aYeUw = parcelRequire("aYeUw");
const $4dc1f19337306bef$var$Logos = {
    atlassian: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9okfL.AtlassianMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lY9mQ.AtlassianLogoBrandV3), {})
        }
    },
    assets: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $deuMy.AssetsMarkBrandV3), {})
        }
    },
    bamboo: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cvpju.BambooMarkBrandV3), {})
        }
    },
    bitbucket: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iKGTm.BitbucketMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ehLaM.BitbucketLogoBrandV3), {})
        }
    },
    collectionteamwork: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dfmcY.CollectionTeamworkMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyxHK.CollectionTeamworkLogoBrandV3), {})
        }
    },
    collectionservice: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eu7cp.CollectionServiceMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eupP4.CollectionServiceLogoBrandV3), {})
        }
    },
    collectionsoftware: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jyv8q.CollectionSoftwareMarkBrandV3), {})
        }
    },
    collectionstrategy: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3dAc4.CollectionStrategyMarkBrandV3), {})
        }
    },
    collectionproduct: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kodXM.CollectionProductMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $quwDK.CollectionProductLogoBrandV3), {})
        }
    },
    compass: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9cBfs.CompassMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3ufD2.CompassLogoBrandV3), {})
        }
    },
    confluence: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $46TV4.ConfluenceMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fWbT9.ConfluenceLogoBrandV3), {})
        }
    },
    customerservicemanagement: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $zMH4F.CustomerServiceManagementMarkBrandV3), {})
        }
    },
    dx: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2U9yb.DxMarkBrandV3), {})
        }
    },
    enterprise: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7yK4t.EnterpriseLogoBrandV3), {})
        }
    },
    focus: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgx2N.FocusMarkBrandV3), {})
        }
    },
    guard: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcxdE.GuardMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b1Nny.GuardLogoBrandV3), {})
        }
    },
    jira: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dRHrS.JiraMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ld6VA.JiraLogoBrandV3), {})
        }
    },
    jirasoftware: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dRHrS.JiraMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ld6VA.JiraLogoBrandV3), {})
        }
    },
    jiraalign: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ePJI2.JiraAlignMarkBrandV3), {})
        }
    },
    jiraproductdiscovery: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fPTok.JiraProductDiscoveryMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $evhqU.JiraProductDiscoveryLogoBrandV3), {})
        }
    },
    jiraservicemanagement: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lDqnU.JiraServiceManagementMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $abOrE.JiraServiceManagementLogoBrandV3), {})
        }
    },
    loom: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kvHRV.LoomMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jKMT0.LoomCharlieLogoBrandV3), {})
        }
    },
    loomcircular: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kvHRV.LoomMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOOjr.LoomCircularLogoBrandV3), {})
        }
    },
    opsgenie: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xMyM.OpsgenieMarkBrandV3), {})
        }
    },
    pipelines: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4dGNW.PipelinesMarkBrandV3), {})
        }
    },
    rovo: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gx7vL.RovoMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f59AY.RovoLogoBrandV3), {})
        }
    },
    rovodev: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bkJxb.RovoDevMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j5JD4.RovoDevLogoBrandV3), {})
        }
    },
    softwaredevelopment: {},
    sourcetree: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4bdUn.SourcetreeMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aLKEe.SourcetreeLogoBrandV3), {})
        }
    },
    statuspage: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k9aBd.StatuspageMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6APt1.StatuspageLogoBrandV3), {})
        }
    },
    talent: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kQiXS.TalentMarkBrandV3), {})
        }
    },
    trello: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYeUw.TrelloMarkBrandV3), {})
        },
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5pwBY.TrelloLogoBrandV3), {})
        }
    }
};
const $4dc1f19337306bef$export$69f5b385b2c2b585 = ({ brand: brand, type: type, appearance: appearance, width: width, height: height, lightMode: lightMode })=>{
    const logo = $4dc1f19337306bef$var$Logos[brand]?.[type]?.[appearance];
    return logo ? /*#__PURE__*/ (0, $1oC0p.cloneElement)(logo, {
        width: width,
        height: height,
        lightMode: lightMode
    }) : null;
};

});
parcelRegister("deuMy", function(module, exports) {
$parcel$export(module.exports, "AssetsMarkBrandV3", function () { return $322018e3efcef0c9$export$4b543ec3500aabf3; });

var $7VQPk = parcelRequire("7VQPk");
const $322018e3efcef0c9$export$4b543ec3500aabf3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FFC716"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.5002 23.1372C20.4405 22.7706 22.7708 20.4402 23.1375 17.5H27.2502V14.25H22.7153C21.751 11.8679 19.4156 10.1875 16.6877 10.1875C13.0979 10.1875 10.1877 13.0976 10.1877 16.6875C10.1877 19.4154 11.8681 21.7508 14.2502 22.715L14.2502 27.25H17.5002V23.1372ZM16.6877 19.125C18.0339 19.125 19.1252 18.0337 19.1252 16.6875C19.1252 15.3413 18.0339 14.25 16.6877 14.25C15.3416 14.25 14.2502 15.3413 14.2502 16.6875C14.2502 18.0337 15.3416 19.125 16.6877 19.125Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.0002 15.875C37.0002 18.1187 35.1814 19.9375 32.9377 19.9375C30.6941 19.9375 28.8752 18.1187 28.8752 15.875C28.8752 13.6313 30.6941 11.8125 32.9377 11.8125C35.1814 11.8125 37.0002 13.6313 37.0002 15.875Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.8752 37C18.1189 37 19.9377 35.1812 19.9377 32.9375C19.9377 30.6938 18.1189 28.875 15.8752 28.875C13.6316 28.875 11.8127 30.6938 11.8127 32.9375C11.8127 35.1812 13.6316 37 15.8752 37Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.9377 37C35.1814 37 37.0002 35.1812 37.0002 32.9375C37.0002 30.6938 35.1814 28.875 32.9377 28.875C30.6941 28.875 28.8752 30.6938 28.8752 32.9375C28.8752 35.1812 30.6941 37 32.9377 37Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.2502 31.3125H21.5627V34.5625H27.2502V31.3125Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.3127 21.5625V27.25H34.5627V21.5625H31.3127Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("lY9mQ", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogoBrandV3", function () { return $85bf05de479c3486$export$b30e78fa6b41e095; });

var $7VQPk = parcelRequire("7VQPk");
const $85bf05de479c3486$export$b30e78fa6b41e095 = ({ width: width = '100%', height: height = '100%' } = {})=>{
    const atlassianTitleId = 'atlassianTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 297 48",
        fill: "none",
        "aria-labelledby": atlassianTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: atlassianTitleId,
                children: "Atlassian"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M34.3175 36.5672L18.4402 4.81262C18.1276 4.12502 17.8151 4 17.44 4C17.1275 4 16.7524 4.12502 16.3774 4.75011C14.127 8.31312 13.1269 12.4387 13.1269 16.7518C13.1269 22.7527 16.1898 28.3785 20.6905 37.4423C21.1906 38.4425 21.5656 38.63 22.4407 38.63H33.4423C34.2549 38.63 34.6925 38.3175 34.6925 37.6924C34.6925 37.3798 34.63 37.1923 34.3175 36.5672ZM11.2516 21.565C10.0014 19.6898 9.62639 19.5647 9.31384 19.5647C9.0013 19.5647 8.81377 19.6898 8.25119 20.8149L0.312545 36.6922C0.062509 37.1923 0 37.3798 0 37.6299C0 38.1299 0.437563 38.63 1.3752 38.63H12.5643C13.3144 38.63 13.877 38.0049 14.1895 36.8172C14.5646 35.317 14.6896 34.0043 14.6896 32.4416C14.6896 28.066 12.7518 23.8154 11.2516 21.565Z",
                            fill: "#1868DB"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M161.171 16.2416C161.171 20.7005 163.188 24.2039 171.363 25.7964C176.14 26.8581 177.202 27.6012 177.202 29.1937C177.202 30.7861 176.14 31.7416 172.743 31.7416C168.815 31.7416 164.144 30.3615 161.065 28.5567V35.7759C163.507 36.9437 166.692 38.3238 172.743 38.3238C181.236 38.3238 184.527 34.5019 184.527 28.9813M184.527 29.0875C184.527 23.7793 181.767 21.3375 173.805 19.6389C169.452 18.6834 168.39 17.7279 168.39 16.3478C168.39 14.6491 169.983 13.906 172.849 13.906C176.353 13.906 179.75 14.9676 183.041 16.4539V9.55326C180.705 8.38545 177.202 7.53613 173.062 7.53613C165.205 7.53613 161.171 10.9334 161.171 16.4539",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M269.884 7.74829V38.0051H276.36V14.9675L279.014 21.0188L288.144 38.0051H296.213V7.74829H289.843V27.2825L287.401 21.5497L280.076 7.74829H269.884Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M228.904 7.74829H221.897V38.0051H228.904V7.74829Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M213.829 28.9813C213.829 23.6731 211.069 21.2313 203.106 19.5327C198.753 18.5772 197.692 17.6217 197.692 16.2416C197.692 14.5429 199.284 13.7998 202.151 13.7998C205.654 13.7998 209.051 14.8614 212.342 16.3477V9.44705C210.007 8.27925 206.503 7.42993 202.363 7.42993C194.507 7.42993 190.473 10.8272 190.473 16.3477C190.473 20.8066 192.49 24.3101 200.664 25.9025C205.442 26.9642 206.503 27.7073 206.503 29.2998C206.503 30.8923 205.442 31.8477 202.045 31.8477C198.116 31.8477 193.445 30.4676 190.366 28.6628V35.882C192.808 37.0498 195.993 38.4299 202.045 38.4299C210.432 38.4299 213.829 34.608 213.829 28.9813Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M106.603 7.74829V38.0051H121.041L123.271 31.4229H113.61V7.74829H106.603Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M78.0447 7.74829V14.2243H85.7947V38.0051H92.9077V14.2243H101.295V7.74829H78.0447Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M67.7466 7.74805H58.5103L48 38.0049H56.0685L57.5548 32.909C59.3596 33.4398 61.2705 33.7583 63.1815 33.7583C65.0925 33.7583 67.0034 33.4398 68.8082 32.909L70.2945 38.0049H78.363C78.2568 38.0049 67.7466 7.74805 67.7466 7.74805ZM63.0753 27.3885C61.6952 27.3885 60.4212 27.1761 59.2534 26.8576L63.0753 13.6933L66.8973 26.8576C65.7294 27.1761 64.4555 27.3885 63.0753 27.3885Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M145.99 7.74805H136.753L126.137 38.0049H134.205L135.692 32.909C137.497 33.4398 139.408 33.7583 141.318 33.7583C143.229 33.7583 145.14 33.4398 146.945 32.909L148.431 38.0049H156.5L145.99 7.74805ZM141.318 27.3885C139.938 27.3885 138.664 27.1761 137.497 26.8576L141.318 13.6933L145.14 26.8576C143.973 27.1761 142.699 27.3885 141.318 27.3885Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M254.277 7.74805H245.041L234.531 38.0049H242.599L244.086 32.909C245.89 33.4398 247.801 33.7583 249.712 33.7583C251.623 33.7583 253.534 33.4398 255.339 32.909L256.825 38.0049H264.894L254.277 7.74805ZM249.712 27.3885C248.332 27.3885 247.058 27.1761 245.89 26.8576L249.712 13.6933L253.534 26.8576C252.366 27.1761 250.986 27.3885 249.712 27.3885Z",
                        fill: "#1868DB"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("9okfL", function(module, exports) {
$parcel$export(module.exports, "AtlassianMarkBrandV3", function () { return $b5371d9a63c677d5$export$8667ca7352c1cb24; });

var $7VQPk = parcelRequire("7VQPk");
const $b5371d9a63c677d5$export$8667ca7352c1cb24 = ({ width: width = '48', height: height = '48' } = {})=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.2888 19.9252C16.7888 19.3252 15.9888 19.4252 15.5888 20.1252L7.08882 37.1252C6.78882 37.8252 7.28882 38.6252 7.98882 38.6252H19.7888C20.1888 38.6252 20.4888 38.4252 20.6888 38.0252C23.2888 32.7252 21.6888 24.7252 17.2888 19.9252Z",
                fill: "url(#paint0_linear_994_3683)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.4888 4.525C18.7888 12.025 19.0888 20.325 22.1888 26.625C25.2888 32.925 27.6888 37.625 27.8888 38.025C28.0888 38.425 28.3888 38.625 28.7888 38.625H40.5888C41.3888 38.625 41.7888 37.825 41.4888 37.125C41.4888 37.125 25.5888 5.325 25.1888 4.525C24.8888 3.825 23.8888 3.825 23.4888 4.525Z",
                fill: "#0082FF"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_994_3683",
                    x1: "21.9049",
                    y1: "22.5806",
                    x2: "12.9499",
                    y2: "38.0906",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0050D3"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.923",
                            stopColor: "#0082FF"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("cvpju", function(module, exports) {
$parcel$export(module.exports, "BambooMarkBrandV3", function () { return $2189f78c97d56f12$export$72fab257faab8c78; });

var $7VQPk = parcelRequire("7VQPk");
const $2189f78c97d56f12$export$72fab257faab8c78 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12 1H36C42.0751 1 47 5.92487 47 12V36C47 42.0751 42.0751 47 36 47H12C5.92487 47 1 42.0751 1 36V12C1 5.92487 5.92487 1 12 1Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12 1H36C42.0751 1 47 5.92487 47 12V36C47 42.0751 42.0751 47 36 47H12C5.92487 47 1 42.0751 1 36V12C1 5.92487 5.92487 1 12 1Z",
                stroke: "#DDDEE1",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.4297 25.3037C18.4297 28.3279 20.8959 30.788 23.9268 30.7881V39.1983C17.0832 39.1981 11.3897 34.2432 10.2305 27.7432L10.1328 27.1094L18.4297 25.3037ZM36.9492 25.3047C37.455 25.3047 37.8567 25.7343 37.8232 26.2393C37.3794 32.8622 32.258 38.2183 25.7373 39.0694L23.9268 30.7901C26.7055 30.7901 29.0096 28.7228 29.374 26.0479C29.4326 25.6159 29.8196 25.304 30.2549 25.3037H36.9492V25.3047ZM23.9258 19.8184C20.895 19.8186 18.4287 22.2779 18.4287 25.3037H10V25.1709C10.0655 18.1821 15.3342 12.4235 22.1162 11.5391L23.9258 19.8184ZM23.9277 7.87406C23.9277 7.12876 24.8019 6.72646 25.3672 7.21195L35.0137 15.4912C35.419 15.8388 35.419 16.4661 35.0137 16.8145L25.3672 25.0918V25.0909C24.8019 25.5766 23.9278 25.1751 23.9277 24.4297V7.87406Z",
                fill: "#1868DB"
            })
        ]
    });

});

parcelRegister("ehLaM", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogoBrandV3", function () { return $8afa74880018ff38$export$739850e594a184c8; });

var $7VQPk = parcelRequire("7VQPk");
const $8afa74880018ff38$export$739850e594a184c8 = ({ width: width, height: height = '100%' })=>{
    const bitbucketTitleId = 'bitbucketTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 248 48",
        fill: "none",
        "aria-labelledby": bitbucketTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: bitbucketTitleId,
                children: "Bitbucket"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M241.818 30.87C241.818 32.894 243.014 34.274 245.452 34.274C246.372 34.274 247.246 34.09 247.936 33.952V37.77C247.246 37.954 246.464 38.138 245.268 38.138C240.346 38.138 237.954 35.24 237.954 30.962V18.68H234.228V15H237.954V10.124H241.818V15H247.936V18.68H241.818V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M221.512 18.128C217.326 18.128 215.21 20.842 214.796 24.844H227.63C227.4 20.566 225.468 18.128 221.512 18.128ZM230.344 37.08C228.458 38.092 225.56 38.46 223.214 38.46C214.612 38.46 210.84 33.492 210.84 26.454C210.84 19.508 214.704 14.54 221.696 14.54C228.78 14.54 231.632 19.462 231.632 26.454V28.248H214.842C215.394 32.158 217.924 34.688 223.352 34.688C226.02 34.688 228.274 34.182 230.344 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M194.614 37.9997H190.658V5.38574H194.614V25.7637L204.504 14.9997H209.656L198.846 26.3157L210.116 37.9997H204.734L194.614 27.2357V37.9997Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M186.142 33.86V37.402C184.762 38.138 182.646 38.46 180.53 38.46C172.342 38.46 168.524 33.492 168.524 26.454C168.524 19.508 172.342 14.54 180.53 14.54C182.6 14.54 184.21 14.816 186.004 15.644V19.324C184.532 18.634 182.968 18.22 180.806 18.22C174.826 18.22 172.388 21.992 172.388 26.454C172.388 30.916 174.872 34.688 180.898 34.688C183.244 34.688 184.716 34.366 186.142 33.86Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M144.378 28.478V15H148.334V28.892C148.334 33.032 149.99 34.872 153.762 34.872C157.442 34.872 159.972 32.434 159.972 27.788V15H163.928V38H159.972V34.228C158.5 36.942 155.786 38.46 152.704 38.46C147.414 38.46 144.378 34.826 144.378 28.478Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M136.296 26.4997C136.296 20.9797 134.088 18.2197 129.994 18.2197C126.452 18.2197 123.278 20.4737 123.278 25.5797V27.4197C123.278 32.5257 126.176 34.7797 129.534 34.7797C133.996 34.7797 136.296 31.8357 136.296 26.4997ZM130.592 38.4597C127.234 38.4597 124.658 36.9417 123.278 33.9517V37.9997H119.322V5.38574H123.278V19.1397C124.75 16.1037 127.51 14.5397 131.052 14.5397C137.17 14.5397 140.252 19.7377 140.252 26.4997C140.252 32.9857 137.032 38.4597 130.592 38.4597Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M108.13 30.87C108.13 32.894 109.326 34.274 111.764 34.274C112.684 34.274 113.558 34.09 114.248 33.952V37.77C113.558 37.954 112.776 38.138 111.58 38.138C106.658 38.138 104.266 35.24 104.266 30.962V18.68H100.54V15H104.266V10.124H108.13V15H114.248V18.68H108.13V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.9922 8.92797C91.9922 7.17997 93.1422 6.16797 94.7522 6.16797C96.3622 6.16797 97.5122 7.17997 97.5122 8.92797C97.5122 10.676 96.3622 11.688 94.7522 11.688C93.1422 11.688 91.9922 10.676 91.9922 8.92797ZM92.7282 38V15H96.6842V38H92.7282Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M77.986 24.4293H68.694V33.8593H78.078C82.034 33.8593 83.828 32.4333 83.828 29.3973C83.828 26.1773 82.126 24.4293 77.986 24.4293ZM76.652 11.7333H68.694V20.7493H76.652C80.562 20.7493 82.172 18.9553 82.172 16.0573C82.172 13.1133 80.424 11.7333 76.652 11.7333ZM64.554 37.9993V7.77734H77.204C83.368 7.77734 86.358 10.8133 86.358 15.6893C86.358 19.3233 84.702 21.5773 81.298 22.4053C85.76 23.1413 87.968 25.5793 87.968 29.8573C87.968 34.6873 84.702 37.9993 77.94 37.9993H64.554Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.6852 23.5267L33.7129 35.5747C33.5843 36.3036 33.0698 36.7323 32.3409 36.7323H15.6195C14.8906 36.7323 14.3761 36.3036 14.2475 35.5747L10.7746 14.0941C10.6459 13.3652 11.0318 12.8936 11.7178 12.8936H36.2426C36.9286 12.8936 37.3145 13.3652 37.1858 14.0941L36.2426 19.7536C36.1139 20.5683 35.6423 20.9113 34.8706 20.9113H20.1214C19.907 20.9113 19.7784 21.0399 19.8213 21.2971L20.9789 28.4145C21.0218 28.586 21.1504 28.7146 21.3219 28.7146H26.6385C26.81 28.7146 26.9386 28.586 26.9815 28.4145L27.7961 23.2694C27.8819 22.6263 28.3106 22.369 28.9109 22.369H34.6991C35.5566 22.369 35.8138 22.7978 35.6852 23.5267Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("iKGTm", function(module, exports) {
$parcel$export(module.exports, "BitbucketMarkBrandV3", function () { return $c6153615833cc44d$export$50faf437fbbcdb93; });

var $7VQPk = parcelRequire("7VQPk");
const $c6153615833cc44d$export$50faf437fbbcdb93 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.6852 23.5267L33.7129 35.5747C33.5843 36.3036 33.0698 36.7323 32.3409 36.7323H15.6195C14.8906 36.7323 14.3761 36.3036 14.2475 35.5747L10.7746 14.0941C10.6459 13.3652 11.0318 12.8936 11.7178 12.8936H36.2426C36.9286 12.8936 37.3145 13.3652 37.1858 14.0941L36.2426 19.7536C36.1139 20.5683 35.6423 20.9113 34.8706 20.9113H20.1214C19.907 20.9113 19.7784 21.0399 19.8213 21.2971L20.9789 28.4145C21.0218 28.586 21.1504 28.7146 21.3219 28.7146H26.6385C26.81 28.7146 26.9386 28.586 26.9815 28.4145L27.7961 23.2694C27.8819 22.6263 28.3106 22.369 28.9109 22.369H34.6991C35.5566 22.369 35.8138 22.7978 35.6852 23.5267Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("quwDK", function(module, exports) {
$parcel$export(module.exports, "CollectionProductLogoBrandV3", function () { return $2ce324e68b4d1e25$export$e97d30c75022dad1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $2ce324e68b4d1e25$export$e97d30c75022dad1 = ({ width: width = 175, height: height = 48 } = {})=>{
    const intl = (0, $8e22h.default)();
    const ProductTitle = intl.formatMessage({
        id: 'software.collections.product.title',
        defaultMessage: 'Product Collection'
    });
    const productTitleId = (0, $1oC0p.useId)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 175 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-labelledby": productTitleId,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: productTitleId,
                suppressHydrationWarning: true,
                children: ProductTitle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M174.2 24.4991V30.2243H172.519V24.3232C172.519 22.5646 171.816 21.7831 170.213 21.7831C168.65 21.7831 167.576 22.8187 167.576 24.7922V30.2243H165.895V20.4543H167.576V22.0566C168.201 20.9038 169.354 20.2589 170.663 20.2589C172.91 20.2589 174.2 21.8026 174.2 24.4991Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M159.331 30.4197C156.4 30.4197 154.68 28.2507 154.68 25.3198C154.68 22.3888 156.4 20.2589 159.331 20.2589C162.242 20.2589 163.942 22.3888 163.942 25.3198C163.942 28.2507 162.242 30.4197 159.331 30.4197ZM159.331 21.8221C157.24 21.8221 156.322 23.4635 156.322 25.3198C156.322 27.176 157.24 28.8565 159.331 28.8565C161.402 28.8565 162.301 27.176 162.301 25.3198C162.301 23.4635 161.402 21.8221 159.331 21.8221Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M150.737 17.8751C150.737 17.1325 151.225 16.7027 151.909 16.7027C152.593 16.7027 153.082 17.1325 153.082 17.8751C153.082 18.6176 152.593 19.0475 151.909 19.0475C151.225 19.0475 150.737 18.6176 150.737 17.8751ZM151.049 30.2242V20.4543H152.73V30.2242H151.049Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M146.295 27.1956C146.295 28.0553 146.803 28.6415 147.839 28.6415C148.23 28.6415 148.601 28.5634 148.894 28.5047V30.1266C148.601 30.2047 148.269 30.2829 147.761 30.2829C145.67 30.2829 144.654 29.0519 144.654 27.2347V22.0175H143.071V20.4543H144.654V18.3831H146.295V20.4543H148.894V22.0175H146.295V27.1956Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M142.052 28.4657V29.9702C141.466 30.2829 140.567 30.4197 139.668 30.4197C136.19 30.4197 134.568 28.3094 134.568 25.3198C134.568 22.3693 136.19 20.2589 139.668 20.2589C140.547 20.2589 141.231 20.3762 141.993 20.7279V22.2911C141.368 21.998 140.704 21.8221 139.785 21.8221C137.245 21.8221 136.209 23.4244 136.209 25.3198C136.209 27.2151 137.265 28.8174 139.824 28.8174C140.821 28.8174 141.446 28.6806 142.052 28.4657Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M128.854 21.7831C127.076 21.7831 126.177 22.9359 126.002 24.6359H131.453C131.355 22.8187 130.535 21.7831 128.854 21.7831ZM132.606 29.8335C131.805 30.2633 130.574 30.4197 129.577 30.4197C125.923 30.4197 124.321 28.3094 124.321 25.3198C124.321 22.3693 125.963 20.2589 128.933 20.2589C131.942 20.2589 133.153 22.3497 133.153 25.3198V26.0818H126.021C126.256 27.7427 127.33 28.8174 129.636 28.8174C130.769 28.8174 131.727 28.6025 132.606 28.2898V29.8335Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M123.386 30.2048C123.249 30.2439 122.956 30.283 122.526 30.283C120.924 30.283 119.908 29.5209 119.908 27.7232V16.3706H121.588V27.5278C121.588 28.4071 122.174 28.7198 122.897 28.7198C123.073 28.7198 123.191 28.7198 123.386 28.7002V30.2048Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M118.291 30.2048C118.154 30.2439 117.861 30.283 117.431 30.283C115.829 30.283 114.813 29.5209 114.813 27.7232V16.3706H116.493V27.5278C116.493 28.4071 117.08 28.7198 117.803 28.7198C117.978 28.7198 118.096 28.7198 118.291 28.7002V30.2048Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M108.249 30.4197C105.318 30.4197 103.598 28.2507 103.598 25.3198C103.598 22.3888 105.318 20.2589 108.249 20.2589C111.16 20.2589 112.86 22.3888 112.86 25.3198C112.86 28.2507 111.16 30.4197 108.249 30.4197ZM108.249 21.8221C106.158 21.8221 105.24 23.4635 105.24 25.3198C105.24 27.176 106.158 28.8565 108.249 28.8565C110.32 28.8565 111.219 27.176 111.219 25.3198C111.219 23.4635 110.32 21.8221 108.249 21.8221Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M102.366 27.9576V29.6575C101.565 30.1851 100.294 30.4196 98.9658 30.4196C94.7452 30.4196 92.3613 27.8794 92.3613 23.8347C92.3613 19.9267 94.7452 17.1911 98.9267 17.1911C100.177 17.1911 101.428 17.4256 102.346 18.09V19.7899C101.428 19.2037 100.412 18.8911 98.9267 18.8911C95.9176 18.8911 94.1199 20.8842 94.1199 23.8347C94.1199 26.7852 95.9762 28.7392 99.0244 28.7392C100.373 28.7392 101.428 28.4265 102.366 27.9576Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "6.98242",
                width: "85.3805",
                height: "38.2301",
                transform: "rotate(-3 0 6.98242)",
                fill: "#C97CF4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M75.7501 25.7389C75.7501 26.3642 76.0627 26.6768 76.6684 26.6768C76.9615 26.6768 77.2351 26.6182 77.45 26.5791V29.725C76.942 29.8423 76.3753 29.94 75.4961 29.94C72.9559 29.94 72.0766 28.4354 72.0766 26.247V22.6516H71.1387V19.662H72.0766V17.6104H75.7501V19.662H77.45V22.6516H75.7501V25.7389Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M70.5485 26.2276V29.3735C69.8646 29.7643 68.9853 29.9988 67.9106 29.9988C64.198 29.9988 62.4785 27.8103 62.4785 24.7035C62.4785 21.6357 64.198 19.4277 67.6761 19.4277C68.8876 19.4277 69.6301 19.6427 70.5094 20.053V23.238C69.8646 22.9449 69.2002 22.7495 68.2623 22.7495C66.7382 22.7495 66.1129 23.6483 66.1129 24.7035C66.1129 25.7977 66.8164 26.5989 68.36 26.5989C69.4152 26.5989 69.9818 26.4425 70.5485 26.2276Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M51.7422 25.8172V19.6621H55.4352V25.6804C55.4352 26.5401 55.7088 26.9309 56.4513 26.9309C57.1938 26.9309 57.6823 26.4229 57.6823 25.2896V19.6621H61.3753V29.7837H57.6823V28.0056C57.1352 29.2757 56.1777 29.9987 54.7709 29.9987C52.6215 29.9987 51.7422 28.4746 51.7422 25.8172Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M43.9596 24.7231C43.9596 26.1495 44.4286 26.8529 45.3078 26.8529C46.0308 26.8529 46.6561 26.3254 46.6561 25.1139V24.3128C46.6561 23.0818 46.1285 22.5542 45.386 22.5542C44.4481 22.5542 43.9596 23.3358 43.9596 24.7231ZM46.6561 29.7839V27.9862C46.0699 29.3345 45.0148 29.9793 43.7447 29.9793C41.3999 29.9793 40.3252 27.7713 40.3252 24.7231C40.3252 21.8507 41.3999 19.4669 43.901 19.4669C45.2297 19.4669 46.1481 20.2485 46.6561 21.4013V15.9302H50.3491V29.7839H46.6561Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.5306 30.0379C31.2674 30.0379 29.3721 27.8885 29.3721 24.7035C29.3721 21.538 31.2674 19.4277 34.5306 19.4277C37.7547 19.4277 39.6109 21.538 39.6109 24.7035C39.6109 27.8885 37.7547 30.0379 34.5306 30.0379ZM34.5306 22.5932C33.4559 22.5932 32.9869 23.4334 32.9869 24.7035C32.9869 25.9931 33.4559 26.8919 34.5306 26.8919C35.5467 26.8919 36.0156 25.9931 36.0156 24.7035C36.0156 23.4334 35.5467 22.5932 34.5306 22.5932Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.2995 24.8792V29.7837H22.5869V19.662H26.2995V21.5769C26.8271 20.2091 27.6477 19.4471 28.9764 19.5253V23.316C27.0029 23.1792 26.2995 23.57 26.2995 24.8792Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.7616 21.8701C21.7616 24.9378 20.1007 26.6573 16.7008 26.6573H14.8445V29.7837H10.8389V16.946H16.7008C20.1007 16.946 21.7616 18.8414 21.7616 21.8701ZM16.3882 23.57C17.6387 23.5896 18.1077 22.9252 18.1077 21.9092C18.1077 20.9712 17.6387 20.3264 16.3882 20.3264H14.8445V23.57H16.3882Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("kodXM", function(module, exports) {
$parcel$export(module.exports, "CollectionProductMarkBrandV3", function () { return $e0649726dff6a35f$export$37eb56d997ee6c21; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $e0649726dff6a35f$export$37eb56d997ee6c21 = ({ width: width = 122, height: height = 14 } = {})=>{
    const intl = (0, $8e22h.default)();
    const ProductTitle = intl.formatMessage({
        id: 'software.collections.product.title',
        defaultMessage: 'Product Collection'
    });
    const productTitleId = (0, $1oC0p.useId)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 6 361 41",
        fill: "none",
        role: "img",
        "aria-labelledby": productTitleId,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: productTitleId,
                suppressHydrationWarning: true,
                children: ProductTitle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M360.254 24.5211V37.9991H356.298V24.1071C356.298 19.9671 354.642 18.1271 350.87 18.1271C347.19 18.1271 344.66 20.5651 344.66 25.2111V37.9991H340.704V14.9991H344.66V18.7711C346.132 16.0571 348.846 14.5391 351.928 14.5391C357.218 14.5391 360.254 18.1731 360.254 24.5211Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M325.25 38.4591C318.35 38.4591 314.302 33.3531 314.302 26.4531C314.302 19.5531 318.35 14.5391 325.25 14.5391C332.104 14.5391 336.106 19.5531 336.106 26.4531C336.106 33.3531 332.104 38.4591 325.25 38.4591ZM325.25 18.2191C320.328 18.2191 318.166 22.0831 318.166 26.4531C318.166 30.8231 320.328 34.7791 325.25 34.7791C330.126 34.7791 332.242 30.8231 332.242 26.4531C332.242 22.0831 330.126 18.2191 325.25 18.2191Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M305.018 8.92797C305.018 7.17997 306.168 6.16797 307.778 6.16797C309.388 6.16797 310.538 7.17997 310.538 8.92797C310.538 10.676 309.388 11.688 307.778 11.688C306.168 11.688 305.018 10.676 305.018 8.92797ZM305.754 38V15H309.71V38H305.754Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M294.562 30.869C294.562 32.893 295.758 34.273 298.196 34.273C299.116 34.273 299.99 34.089 300.68 33.951V37.769C299.99 37.953 299.208 38.137 298.012 38.137C293.09 38.137 290.698 35.239 290.698 30.961V18.679H286.972V14.999H290.698V10.123H294.562V14.999H300.68V18.679H294.562V30.869Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M284.572 33.8591V37.4011C283.192 38.1371 281.076 38.4591 278.96 38.4591C270.772 38.4591 266.954 33.4911 266.954 26.4531C266.954 19.5071 270.772 14.5391 278.96 14.5391C281.03 14.5391 282.64 14.8151 284.434 15.6431V19.3231C282.962 18.6331 281.398 18.2191 279.236 18.2191C273.256 18.2191 270.818 21.9911 270.818 26.4531C270.818 30.9151 273.302 34.6871 279.328 34.6871C281.674 34.6871 283.146 34.3651 284.572 33.8591Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M253.503 18.1271C249.317 18.1271 247.201 20.8411 246.787 24.8431H259.621C259.391 20.5651 257.459 18.1271 253.503 18.1271ZM262.335 37.0791C260.449 38.0911 257.551 38.4591 255.205 38.4591C246.603 38.4591 242.831 33.4911 242.831 26.4531C242.831 19.5071 246.695 14.5391 253.687 14.5391C260.771 14.5391 263.623 19.4611 263.623 26.4531V28.2471H246.833C247.385 32.1571 249.915 34.6871 255.343 34.6871C258.011 34.6871 260.265 34.1811 262.335 33.4451V37.0791Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M240.63 37.9547C240.308 38.0467 239.618 38.1387 238.606 38.1387C234.834 38.1387 232.442 36.3447 232.442 32.1127V5.38672H236.398V31.6527C236.398 33.7227 237.778 34.4587 239.48 34.4587C239.894 34.4587 240.17 34.4587 240.63 34.4127V37.9547Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M228.636 37.9547C228.314 38.0467 227.624 38.1387 226.612 38.1387C222.84 38.1387 220.448 36.3447 220.448 32.1127V5.38672H224.404V31.6527C224.404 33.7227 225.784 34.4587 227.486 34.4587C227.9 34.4587 228.176 34.4587 228.636 34.4127V37.9547Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M204.994 38.4591C198.094 38.4591 194.046 33.3531 194.046 26.4531C194.046 19.5531 198.094 14.5391 204.994 14.5391C211.848 14.5391 215.85 19.5531 215.85 26.4531C215.85 33.3531 211.848 38.4591 204.994 38.4591ZM204.994 18.2191C200.072 18.2191 197.91 22.0831 197.91 26.4531C197.91 30.8231 200.072 34.7791 204.994 34.7791C209.87 34.7791 211.986 30.8231 211.986 26.4531C211.986 22.0831 209.87 18.2191 204.994 18.2191Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M191.145 32.6644V36.6664C189.259 37.9084 186.269 38.4604 183.141 38.4604C173.205 38.4604 167.593 32.4804 167.593 22.9584C167.593 13.7584 173.205 7.31836 183.049 7.31836C185.993 7.31836 188.937 7.87036 191.099 9.43436V13.4364C188.937 12.0564 186.545 11.3204 183.049 11.3204C175.965 11.3204 171.733 16.0124 171.733 22.9584C171.733 29.9044 176.103 34.5044 183.279 34.5044C186.453 34.5044 188.937 33.7684 191.145 32.6644Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M152.811 28.4778C152.811 29.9498 153.547 30.6858 154.973 30.6858C155.663 30.6858 156.307 30.5478 156.813 30.4558V37.8618C155.617 38.1378 154.283 38.3678 152.213 38.3678C146.233 38.3678 144.163 34.8258 144.163 29.6738V21.2098H141.955V14.1718H144.163V9.3418H152.811V14.1718H156.813V21.2098H152.811V28.4778Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M140.567 29.6271V37.0331C138.957 37.9531 136.887 38.5051 134.357 38.5051C125.617 38.5051 121.569 33.3531 121.569 26.0391C121.569 18.8171 125.617 13.6191 133.805 13.6191C136.657 13.6191 138.405 14.1251 140.475 15.0911V22.5891C138.957 21.8991 137.393 21.4391 135.185 21.4391C131.597 21.4391 130.125 23.5551 130.125 26.0391C130.125 28.6151 131.781 30.5011 135.415 30.5011C137.899 30.5011 139.233 30.1331 140.567 29.6271Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M96.2942 28.6619V14.1719H104.988V28.3399C104.988 30.3639 105.632 31.2839 107.38 31.2839C109.128 31.2839 110.278 30.0879 110.278 27.4199V14.1719H118.972V37.9999H110.278V33.8139C108.99 36.8039 106.736 38.5059 103.424 38.5059C98.3642 38.5059 96.2942 34.9179 96.2942 28.6619Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M77.9708 26.0867C77.9708 29.4447 79.0748 31.1007 81.1448 31.1007C82.8468 31.1007 84.3188 29.8587 84.3188 27.0067V25.1207C84.3188 22.2227 83.0768 20.9807 81.3288 20.9807C79.1208 20.9807 77.9708 22.8207 77.9708 26.0867ZM84.3188 38.0007V33.7687C82.9388 36.9427 80.4548 38.4607 77.4648 38.4607C71.9448 38.4607 69.4148 33.2627 69.4148 26.0867C69.4148 19.3247 71.9448 13.7127 77.8328 13.7127C80.9608 13.7127 83.1228 15.5527 84.3188 18.2667V5.38672H93.0128V38.0007H84.3188Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M55.7734 38.5971C48.0914 38.5971 43.6294 33.5371 43.6294 26.0391C43.6294 18.5871 48.0914 13.6191 55.7734 13.6191C63.3634 13.6191 67.7334 18.5871 67.7334 26.0391C67.7334 33.5371 63.3634 38.5971 55.7734 38.5971ZM55.7734 21.0711C53.2434 21.0711 52.1394 23.0491 52.1394 26.0391C52.1394 29.0751 53.2434 31.1911 55.7734 31.1911C58.1654 31.1911 59.2694 29.0751 59.2694 26.0391C59.2694 23.0491 58.1654 21.0711 55.7734 21.0711Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.3977 26.4548V38.0008H27.6577V14.1728H36.3977V18.6808C37.6397 15.4608 39.5717 13.6668 42.6997 13.8508V22.7748C38.0537 22.4528 36.3977 23.3728 36.3977 26.4548Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.714 19.3693C25.714 26.5913 21.804 30.6393 13.8 30.6393H9.43V37.9993H0V7.77734H13.8C21.804 7.77734 25.714 12.2393 25.714 19.3693ZM13.064 23.3713C16.008 23.4173 17.112 21.8533 17.112 19.4613C17.112 17.2533 16.008 15.7353 13.064 15.7353H9.43V23.3713H13.064Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("eupP4", function(module, exports) {
$parcel$export(module.exports, "CollectionServiceLogoBrandV3", function () { return $5c3d3609a7042885$export$96cd239e520946b0; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $5c3d3609a7042885$export$96cd239e520946b0 = ({ width: width = 175, height: height = 48 } = {})=>{
    const intl = (0, $8e22h.default)();
    const ServiceTitle = intl.formatMessage({
        id: 'software.collections.service.title',
        defaultMessage: 'Service Collection'
    });
    const serviceTitleId = (0, $1oC0p.useId)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 175 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-labelledby": serviceTitleId,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: serviceTitleId,
                suppressHydrationWarning: true,
                children: ServiceTitle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M174.446 24.5462V30.2714H172.706V24.3704C172.706 22.6118 171.978 21.8302 170.319 21.8302C168.701 21.8302 167.588 22.8658 167.588 24.8393V30.2714H165.849V20.5015H167.588V22.1037C168.236 20.9509 169.429 20.3061 170.784 20.3061C173.111 20.3061 174.446 21.8497 174.446 24.5462Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M159.053 30.4668C156.019 30.4668 154.238 28.2979 154.238 25.3669C154.238 22.4359 156.019 20.3061 159.053 20.3061C162.067 20.3061 163.827 22.4359 163.827 25.3669C163.827 28.2979 162.067 30.4668 159.053 30.4668ZM159.053 21.8693C156.888 21.8693 155.938 23.5106 155.938 25.3669C155.938 27.2232 156.888 28.9036 159.053 28.9036C161.197 28.9036 162.128 27.2232 162.128 25.3669C162.128 23.5106 161.197 21.8693 159.053 21.8693Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M150.156 17.9222C150.156 17.1797 150.661 16.7498 151.369 16.7498C152.077 16.7498 152.583 17.1797 152.583 17.9222C152.583 18.6647 152.077 19.0946 151.369 19.0946C150.661 19.0946 150.156 18.6647 150.156 17.9222ZM150.479 30.2713V20.5014H152.219V30.2713H150.479Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M145.558 27.2427C145.558 28.1025 146.084 28.6886 147.156 28.6886C147.56 28.6886 147.945 28.6105 148.248 28.5519V30.1737C147.945 30.2518 147.601 30.33 147.075 30.33C144.91 30.33 143.858 29.099 143.858 27.2818V22.0646H142.22V20.5015H143.858V18.4302H145.558V20.5015H148.248V22.0646H145.558V27.2427Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M141.165 28.5128V30.0174C140.558 30.33 139.627 30.4668 138.697 30.4668C135.096 30.4668 133.417 28.3565 133.417 25.3669C133.417 22.4164 135.096 20.3061 138.697 20.3061C139.607 20.3061 140.315 20.4233 141.104 20.775V22.3382C140.457 22.0451 139.769 21.8693 138.818 21.8693C136.188 21.8693 135.116 23.4715 135.116 25.3669C135.116 27.2622 136.208 28.8645 138.858 28.8645C139.89 28.8645 140.537 28.7277 141.165 28.5128Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M127.502 21.8302C125.661 21.8302 124.73 22.983 124.548 24.683H130.192C130.091 22.8658 129.241 21.8302 127.502 21.8302ZM131.386 29.8806C130.556 30.3105 129.282 30.4668 128.25 30.4668C124.467 30.4668 122.809 28.3565 122.809 25.3669C122.809 22.4164 124.508 20.3061 127.583 20.3061C130.698 20.3061 131.952 22.3968 131.952 25.3669V26.1289H124.568C124.811 27.7898 125.924 28.8645 128.311 28.8645C129.484 28.8645 130.475 28.6496 131.386 28.3369V29.8806Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M121.84 30.2519C121.699 30.291 121.395 30.3301 120.95 30.3301C119.292 30.3301 118.24 29.568 118.24 27.7704V16.4177H119.979V27.575C119.979 28.4543 120.586 28.7669 121.335 28.7669C121.517 28.7669 121.638 28.7669 121.84 28.7474V30.2519Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M116.566 30.2519C116.424 30.291 116.121 30.3301 115.676 30.3301C114.017 30.3301 112.965 29.568 112.965 27.7704V16.4177H114.705V27.575C114.705 28.4543 115.312 28.7669 116.06 28.7669C116.242 28.7669 116.364 28.7669 116.566 28.7474V30.2519Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.169 30.4668C103.135 30.4668 101.355 28.2979 101.355 25.3669C101.355 22.4359 103.135 20.3061 106.169 20.3061C109.183 20.3061 110.943 22.4359 110.943 25.3669C110.943 28.2979 109.183 30.4668 106.169 30.4668ZM106.169 21.8693C104.005 21.8693 103.054 23.5106 103.054 25.3669C103.054 27.2232 104.005 28.9036 106.169 28.9036C108.314 28.9036 109.244 27.2232 109.244 25.3669C109.244 23.5106 108.314 21.8693 106.169 21.8693Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M100.079 28.0047V29.7047C99.2495 30.2322 97.9346 30.4667 96.559 30.4667C92.1896 30.4667 89.7217 27.9265 89.7217 23.8818C89.7217 19.9738 92.1896 17.2382 96.5186 17.2382C97.8132 17.2382 99.1079 17.4727 100.059 18.1371V19.837C99.1079 19.2508 98.056 18.9382 96.5186 18.9382C93.4033 18.9382 91.5423 20.9313 91.5423 23.8818C91.5423 26.8323 93.464 28.7863 96.6197 28.7863C98.0155 28.7863 99.1079 28.4736 100.079 28.0047Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                width: "83.1109",
                height: "38.2318",
                transform: "matrix(0.999432 0.0337121 -0.0361286 0.999347 1.38184 3.39819)",
                fill: "#FFC716"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M69.9525 22.4929C69.0017 22.4929 68.5162 23.1572 68.3949 24.4664H71.4494C71.3483 23.0986 70.8628 22.4929 69.9525 22.4929ZM74.4838 29.8594C73.4925 30.2111 72.1372 30.4651 70.7819 30.4651C66.5945 30.4651 64.7132 28.687 64.7132 25.3652C64.7132 22.1802 66.5338 19.9136 70.0132 19.9136C73.4521 19.9136 74.8681 22.1607 74.8681 25.3652V26.1273H68.4758C68.7185 27.1238 69.4265 27.4364 70.8628 27.4364C72.0765 27.4364 73.4116 27.2606 74.4838 26.9675V29.8594Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M63.941 26.7135V29.8594C63.233 30.2502 62.3227 30.4847 61.2101 30.4847C57.3666 30.4847 55.5865 28.2962 55.5865 25.1894C55.5865 22.1216 57.3666 19.9136 60.9674 19.9136C62.2216 19.9136 62.9903 20.1285 63.9006 20.5389V23.7239C63.233 23.4308 62.5452 23.2354 61.5742 23.2354C59.9964 23.2354 59.3491 24.1342 59.3491 25.1894C59.3491 26.2836 60.0773 27.0847 61.6754 27.0847C62.7678 27.0847 63.3544 26.9284 63.941 26.7135Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.2122 17.3344C50.2122 16.0643 51.2035 15.3218 52.5386 15.3218C53.9141 15.3218 54.8851 16.0643 54.8851 17.3344C54.8851 18.624 53.9141 19.3665 52.5386 19.3665C51.2035 19.3665 50.2122 18.624 50.2122 17.3344ZM50.637 30.2697V20.1481H54.4603V30.2697H50.637Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.2104 30.2697H41.9105L39.1593 20.1481H42.8815L44.6009 27.6709L46.3204 20.1481H49.9616L47.2104 30.2697Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.0888 25.3652V30.2697H32.2453V20.1481H36.0888V22.063C36.6349 20.6952 37.4846 19.9332 38.8601 20.0113V23.8021C36.817 23.6653 36.0888 24.0561 36.0888 25.3652Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.1758 22.4929C25.2251 22.4929 24.7396 23.1572 24.6182 24.4664H27.6727C27.5716 23.0986 27.0861 22.4929 26.1758 22.4929ZM30.7071 29.8594C29.7159 30.2111 28.3605 30.4651 27.0052 30.4651C22.8178 30.4651 20.9365 28.687 20.9365 25.3652C20.9365 22.1802 22.7571 19.9136 26.2365 19.9136C29.6754 19.9136 31.0914 22.1607 31.0914 25.3652V26.1273H24.6991C24.9418 27.1238 25.6499 27.4364 27.0861 27.4364C28.2998 27.4364 29.6349 27.2606 30.7071 26.9675V29.8594Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.162 26.2445C20.162 28.9019 18.6044 30.4846 14.7609 30.4846C12.4144 30.4846 10.7151 29.9766 9.62277 29.41V25.8928C10.8567 26.4399 13.1831 27.0456 14.7204 27.0456C15.651 27.0456 15.9949 26.7525 15.9949 26.2836C15.9949 25.7951 15.5903 25.5215 14.5384 25.3261C10.5938 24.7009 9.46094 23.1963 9.46094 21.2423C9.46094 18.7217 11.3827 17.2171 14.9025 17.2171C16.7636 17.2171 18.5235 17.6079 19.6563 18.1941V21.594C17.9368 20.9688 15.9544 20.5584 14.8014 20.5584C13.9315 20.5584 13.4865 20.8124 13.4865 21.3009C13.4865 21.7894 13.9518 22.0239 15.3475 22.2779C19.2315 22.8837 20.162 24.3296 20.162 26.2445Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("eu7cp", function(module, exports) {
$parcel$export(module.exports, "CollectionServiceMarkBrandV3", function () { return $1da726020be7a857$export$a0435fd872c6be96; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $1da726020be7a857$export$a0435fd872c6be96 = ({ width: width = 123, height: height = 13 } = {})=>{
    const intl = (0, $8e22h.default)();
    const ServiceTitle = intl.formatMessage({
        id: 'software.collections.service.title',
        defaultMessage: 'Service Collection'
    });
    const serviceTitleId = (0, $1oC0p.useId)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 123 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-labelledby": serviceTitleId,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: serviceTitleId,
                suppressHydrationWarning: true,
                children: ServiceTitle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.5283 6.10534C46.7891 6.10534 46.4117 6.64005 46.3173 7.69374H48.6921C48.6134 6.59287 48.236 6.10534 47.5283 6.10534ZM51.0511 12.0343C50.2805 12.3174 49.2268 12.5218 48.1731 12.5218C44.9177 12.5218 43.4551 11.0907 43.4551 8.41717C43.4551 5.85372 44.8705 4.02942 47.5755 4.02942C50.249 4.02942 51.3499 5.83799 51.3499 8.41717V9.03051H46.3802C46.569 9.83257 47.1194 10.0842 48.236 10.0842C49.1796 10.0842 50.2176 9.94266 51.0511 9.70676V12.0343Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.8547 9.50231V12.0343C42.3043 12.3488 41.5966 12.5376 40.7316 12.5376C37.7436 12.5376 36.3596 10.7762 36.3596 8.27563C36.3596 5.80654 37.7436 4.02942 40.5429 4.02942C41.518 4.02942 42.1156 4.20241 42.8233 4.53267V7.09613C42.3043 6.86022 41.7696 6.70296 41.0147 6.70296C39.788 6.70296 39.2848 7.42639 39.2848 8.27563C39.2848 9.15632 39.8509 9.80112 41.0934 9.80112C41.9426 9.80112 42.3987 9.6753 42.8547 9.50231Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.1816 1.95347C32.1816 0.931232 32.9522 0.333618 33.9902 0.333618C35.0596 0.333618 35.8145 0.931232 35.8145 1.95347C35.8145 2.99143 35.0596 3.58904 33.9902 3.58904C32.9522 3.58904 32.1816 2.99143 32.1816 1.95347ZM32.5119 12.3645V4.21811H35.4842V12.3645H32.5119Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.8478 12.3646H25.7275L23.5886 4.21814H26.4823L27.8191 10.2729L29.1559 4.21814H31.9867L29.8478 12.3646Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.2014 8.41692V12.3643H18.2134V4.21789H21.2014V5.75911C21.6261 4.65824 22.2866 4.04489 23.356 4.1078V7.15878C21.7676 7.04869 21.2014 7.36323 21.2014 8.41692Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.4948 6.10534C12.7557 6.10534 12.3783 6.64005 12.2839 7.69374H14.6586C14.58 6.59287 14.2025 6.10534 13.4948 6.10534ZM17.0176 12.0343C16.247 12.3174 15.1933 12.5218 14.1396 12.5218C10.8842 12.5218 9.42163 11.0907 9.42163 8.41717C9.42163 5.85372 10.837 4.02942 13.542 4.02942C16.2156 4.02942 17.3164 5.83799 17.3164 8.41717V9.03051H12.3468C12.5355 9.83257 13.086 10.0842 14.2025 10.0842C15.1461 10.0842 16.1841 9.94266 17.0176 9.70676V12.0343Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.81942 9.12487C8.81942 11.2637 7.60847 12.5376 4.62039 12.5376C2.7961 12.5376 1.47506 12.1287 0.625814 11.6726V8.84178C1.58514 9.28213 3.39371 9.76966 4.58894 9.76966C5.31237 9.76966 5.57972 9.53376 5.57972 9.15632C5.57972 8.76315 5.26519 8.54298 4.4474 8.38571C1.3807 7.88246 0.5 6.6715 0.5 5.09883C0.5 3.07009 1.99404 1.85913 4.73048 1.85913C6.17734 1.85913 7.54556 2.17367 8.42626 2.64547V5.38191C7.08949 4.87866 5.54827 4.5484 4.65185 4.5484C3.9756 4.5484 3.62961 4.75284 3.62961 5.14601C3.62961 5.53918 3.99133 5.7279 5.07647 5.93235C8.09599 6.41987 8.81942 7.58365 8.81942 9.12487Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.7679 10.1392V11.5402C64.1077 11.975 63.061 12.1682 61.966 12.1682C58.4878 12.1682 56.5232 10.0748 56.5232 6.74151C56.5232 3.5209 58.4878 1.26648 61.9338 1.26648C62.9644 1.26648 63.995 1.45972 64.7518 2.00722V3.40818C63.995 2.92509 63.1576 2.66744 61.9338 2.66744C59.4539 2.66744 57.9725 4.30995 57.9725 6.74151C57.9725 9.17306 59.5023 10.7834 62.0143 10.7834C63.1254 10.7834 63.995 10.5257 64.7679 10.1392Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M69.635 12.1684C67.2196 12.1684 65.8025 10.3809 65.8025 7.96548C65.8025 5.55003 67.2196 3.7948 69.635 3.7948C72.0344 3.7948 73.4353 5.55003 73.4353 7.96548C73.4353 10.3809 72.0344 12.1684 69.635 12.1684ZM69.635 5.08304C67.912 5.08304 67.1551 6.43569 67.1551 7.96548C67.1551 9.49527 67.912 10.8801 69.635 10.8801C71.3419 10.8801 72.0827 9.49527 72.0827 7.96548C72.0827 6.43569 71.3419 5.08304 69.635 5.08304Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M77.3363 12.1038C77.2236 12.136 76.982 12.1682 76.6278 12.1682C75.3073 12.1682 74.47 11.5402 74.47 10.0587V0.702881H75.8548V9.8977C75.8548 10.6223 76.3379 10.88 76.9337 10.88C77.0787 10.88 77.1753 10.88 77.3363 10.8639V12.1038Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M81.2374 12.1038C81.1247 12.136 80.8832 12.1682 80.5289 12.1682C79.2085 12.1682 78.3711 11.5402 78.3711 10.0587V0.702881H79.756V9.8977C79.756 10.6223 80.239 10.88 80.8349 10.88C80.9798 10.88 81.0764 10.88 81.2374 10.8639V12.1038Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M86.0079 5.05084C84.5425 5.05084 83.8018 6.00091 83.6568 7.40188H88.1496C88.0691 5.9043 87.3927 5.05084 86.0079 5.05084ZM89.0997 11.6853C88.4394 12.0395 87.4249 12.1684 86.6037 12.1684C83.5924 12.1684 82.272 10.4292 82.272 7.96548C82.272 5.53393 83.6246 3.7948 86.0723 3.7948C88.5521 3.7948 89.5505 5.51782 89.5505 7.96548V8.5935H83.6729C83.8662 9.96226 84.7518 10.8479 86.652 10.8479C87.586 10.8479 88.375 10.6708 89.0997 10.4131V11.6853Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M96.7529 10.5581V11.798C96.2698 12.0556 95.5291 12.1684 94.7883 12.1684C91.922 12.1684 90.5854 10.4292 90.5854 7.96548C90.5854 5.53393 91.922 3.7948 94.7883 3.7948C95.513 3.7948 96.0766 3.89142 96.7046 4.18127V5.46951C96.1893 5.22797 95.6418 5.08304 94.885 5.08304C92.7916 5.08304 91.9381 6.40349 91.9381 7.96548C91.9381 9.52747 92.8077 10.8479 94.9172 10.8479C95.7384 10.8479 96.2537 10.7352 96.7529 10.5581Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M100.445 9.62391C100.445 10.3324 100.863 10.8155 101.717 10.8155C102.039 10.8155 102.345 10.7511 102.586 10.7028V12.0394C102.345 12.1038 102.071 12.1682 101.652 12.1682C99.9293 12.1682 99.0919 11.1537 99.0919 9.65612V5.35661H97.7876V4.06837H99.0919V2.36145H100.445V4.06837H102.586V5.35661H100.445V9.62391Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M103.621 1.99121C103.621 1.37929 104.023 1.02502 104.587 1.02502C105.151 1.02502 105.553 1.37929 105.553 1.99121C105.553 2.60312 105.151 2.95739 104.587 2.95739C104.023 2.95739 103.621 2.60312 103.621 1.99121ZM103.878 12.1683V4.1168H105.263V12.1683H103.878Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M110.42 12.1684C108.005 12.1684 106.588 10.3809 106.588 7.96548C106.588 5.55003 108.005 3.7948 110.42 3.7948C112.82 3.7948 114.221 5.55003 114.221 7.96548C114.221 10.3809 112.82 12.1684 110.42 12.1684ZM110.42 5.08304C108.697 5.08304 107.941 6.43569 107.941 7.96548C107.941 9.49527 108.697 10.8801 110.42 10.8801C112.127 10.8801 112.868 9.49527 112.868 7.96548C112.868 6.43569 112.127 5.08304 110.42 5.08304Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M122.099 7.45017V12.1683H120.714V7.30524C120.714 5.85597 120.135 5.21185 118.814 5.21185C117.526 5.21185 116.64 6.06531 116.64 7.69171V12.1683H115.255V4.11684H116.64V5.43729C117.156 4.48721 118.106 3.95581 119.185 3.95581C121.036 3.95581 122.099 5.22795 122.099 7.45017Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("jyv8q", function(module, exports) {
$parcel$export(module.exports, "CollectionSoftwareMarkBrandV3", function () { return $1b518b66a3a7ca2b$export$e6103eb185eb0021; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $1b518b66a3a7ca2b$export$e6103eb185eb0021 = ({ width: width = 134, height: height = 12 } = {})=>{
    const intl = (0, $8e22h.default)();
    const SoftwareTitle = intl.formatMessage({
        id: 'software.collections.software.title',
        defaultMessage: 'Software Collection'
    });
    const softwareTitleId = (0, $1oC0p.useId)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 134 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-labelledby": softwareTitleId,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: softwareTitleId,
                suppressHydrationWarning: true,
                children: SoftwareTitle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M133.73 6.80811V11.3683H132.392V6.66804C132.392 5.2673 131.831 4.64476 130.555 4.64476C129.31 4.64476 128.454 5.46963 128.454 7.04157V11.3683H127.116V3.58642H128.454V4.86265C128.952 3.94439 129.87 3.43079 130.913 3.43079C132.703 3.43079 133.73 4.66032 133.73 6.80811Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M121.887 11.5239C119.552 11.5239 118.183 9.79635 118.183 7.46179C118.183 5.12723 119.552 3.43079 121.887 3.43079C124.206 3.43079 125.56 5.12723 125.56 7.46179C125.56 9.79635 124.206 11.5239 121.887 11.5239ZM121.887 4.67588C120.222 4.67588 119.49 5.98324 119.49 7.46179C119.49 8.94034 120.222 10.2788 121.887 10.2788C123.537 10.2788 124.253 8.94034 124.253 7.46179C124.253 5.98324 123.537 4.67588 121.887 4.67588Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M115.042 1.53197C115.042 0.940546 115.431 0.598145 115.976 0.598145C116.52 0.598145 116.909 0.940546 116.909 1.53197C116.909 2.12339 116.52 2.46579 115.976 2.46579C115.431 2.46579 115.042 2.12339 115.042 1.53197ZM115.291 11.3682V3.58638H116.629V11.3682H115.291Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M111.504 8.956C111.504 9.64081 111.909 10.1077 112.734 10.1077C113.045 10.1077 113.341 10.0455 113.574 9.99877V11.2906C113.341 11.3528 113.076 11.4151 112.671 11.4151C111.006 11.4151 110.197 10.4346 110.197 8.98713V4.83162H108.936V3.58652H110.197V1.93677H111.504V3.58652H113.574V4.83162H111.504V8.956Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M108.124 9.96755V11.166C107.657 11.415 106.941 11.5239 106.225 11.5239C103.455 11.5239 102.163 9.84304 102.163 7.46179C102.163 5.11167 103.455 3.43079 106.225 3.43079C106.926 3.43079 107.47 3.52417 108.077 3.80432V5.04941C107.579 4.81596 107.05 4.67588 106.319 4.67588C104.295 4.67588 103.471 5.95211 103.471 7.46179C103.471 8.97147 104.311 10.2477 106.35 10.2477C107.144 10.2477 107.642 10.1387 108.124 9.96755Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M97.6121 4.64476C96.1958 4.64476 95.4799 5.56302 95.3398 6.91706H99.6821C99.6043 5.46963 98.9506 4.64476 97.6121 4.64476ZM100.6 11.057C99.9622 11.3994 98.9817 11.5239 98.188 11.5239C95.2776 11.5239 94.0013 9.84304 94.0013 7.46179C94.0013 5.11167 95.3087 3.43079 97.6744 3.43079C100.071 3.43079 101.036 5.0961 101.036 7.46179V8.06877H95.3554C95.5422 9.39169 96.3982 10.2477 98.2347 10.2477C99.1374 10.2477 99.9 10.0765 100.6 9.82747V11.057Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M93.2564 11.3527C93.1475 11.3839 92.914 11.415 92.5716 11.415C91.2954 11.415 90.4861 10.808 90.4861 9.37614V0.333618H91.8246V9.2205C91.8246 9.92087 92.2915 10.1699 92.8673 10.1699C93.0074 10.1699 93.1008 10.1699 93.2564 10.1543V11.3527Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M89.1983 11.3527C89.0894 11.3839 88.8559 11.415 88.5135 11.415C87.2373 11.415 86.428 10.808 86.428 9.37614V0.333618H87.7665V9.2205C87.7665 9.92087 88.2334 10.1699 88.8092 10.1699C88.9493 10.1699 89.0427 10.1699 89.1983 10.1543V11.3527Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M81.1994 11.5239C78.8648 11.5239 77.4952 9.79635 77.4952 7.46179C77.4952 5.12723 78.8648 3.43079 81.1994 3.43079C83.5184 3.43079 84.8724 5.12723 84.8724 7.46179C84.8724 9.79635 83.5184 11.5239 81.1994 11.5239ZM81.1994 4.67588C79.5341 4.67588 78.8026 5.98324 78.8026 7.46179C78.8026 8.94034 79.5341 10.2788 81.1994 10.2788C82.8492 10.2788 83.5651 8.94034 83.5651 7.46179C83.5651 5.98324 82.8492 4.67588 81.1994 4.67588Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.5135 9.56291V10.917C75.8754 11.3372 74.8638 11.5239 73.8055 11.5239C70.4437 11.5239 68.5449 9.50066 68.5449 6.27897C68.5449 3.16623 70.4437 0.987305 73.7743 0.987305C74.7704 0.987305 75.7665 1.17407 76.498 1.70324V3.05728C75.7665 2.59037 74.9572 2.34135 73.7743 2.34135C71.3775 2.34135 69.9457 3.92885 69.9457 6.27897C69.9457 8.62909 71.4242 10.1855 73.8521 10.1855C74.926 10.1855 75.7665 9.93644 76.5135 9.56291Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.5354 5.32403C58.821 5.32403 58.4562 5.84083 58.365 6.85923H60.6602C60.5842 5.79523 60.2194 5.32403 59.5354 5.32403ZM62.9402 11.0544C62.1954 11.328 61.177 11.5256 60.1586 11.5256C57.0122 11.5256 55.5986 10.1424 55.5986 7.55843C55.5986 5.08083 56.9666 3.31763 59.581 3.31763C62.165 3.31763 63.229 5.06563 63.229 7.55843V8.15123H58.4258C58.6082 8.92643 59.1402 9.16963 60.2194 9.16963C61.1314 9.16963 62.1346 9.03283 62.9402 8.80483V11.0544Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M53.209 7.55847V11.3737H50.321V3.50007H53.209V4.98966C53.6194 3.92567 54.2578 3.33286 55.2914 3.39366V6.34246C53.7562 6.23606 53.209 6.54007 53.209 7.55847Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.2055 7.43682C44.2055 8.54642 44.5703 9.09362 45.2543 9.09362C45.8167 9.09362 46.3031 8.68322 46.3031 7.74082V7.11762C46.3031 6.16002 45.8927 5.74962 45.3151 5.74962C44.5855 5.74962 44.2055 6.35762 44.2055 7.43682ZM46.3031 11.3736V9.97522C45.8471 11.024 45.0263 11.5256 44.0383 11.5256C42.2143 11.5256 41.3783 9.80802 41.3783 7.43682C41.3783 5.20242 42.2143 3.34802 44.1599 3.34802C45.1935 3.34802 45.9079 3.95602 46.3031 4.85282V3.50002H49.1759V11.3736H46.3031Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M39.6036 11.3736H35.834L35.1652 8.668L34.7244 6.0384L34.2684 8.668L33.5844 11.3736H30.0124L28.2036 3.5H31.0156L32.034 9.5192L33.478 3.5H36.29L37.7492 9.5496L38.7524 3.5H41.4124L39.6036 11.3736Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.6307 8.22725C26.6307 8.71365 26.8739 8.95685 27.3451 8.95685C27.5731 8.95685 27.7859 8.91125 27.9531 8.88085V11.3281C27.5579 11.4193 27.1171 11.4953 26.4331 11.4953C24.4571 11.4953 23.7731 10.3249 23.7731 8.62245V5.82565H23.0435V3.50005H23.7731V1.90405H26.6307V3.50005H27.9531V5.82565H26.6307V8.22725Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.1239 3.10478V3.49998H22.6743V5.82558H21.1239V11.3736H18.2511V5.82558H17.5215V3.49998H18.2511V3.13518C18.2511 1.46318 18.9959 0.338379 21.4127 0.338379C21.8079 0.338379 22.3247 0.399178 22.6895 0.459978V2.43598C22.4919 2.39038 22.2183 2.35998 21.9447 2.35998C21.3823 2.35998 21.1239 2.66398 21.1239 3.10478Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.1356 11.5712C10.5972 11.5712 9.1228 9.89923 9.1228 7.42163C9.1228 4.95923 10.5972 3.31763 13.1356 3.31763C15.6436 3.31763 17.0876 4.95923 17.0876 7.42163C17.0876 9.89923 15.6436 11.5712 13.1356 11.5712ZM13.1356 5.78003C12.2996 5.78003 11.9348 6.43363 11.9348 7.42163C11.9348 8.42483 12.2996 9.12403 13.1356 9.12403C13.926 9.12403 14.2908 8.42483 14.2908 7.42163C14.2908 6.43363 13.926 5.78003 13.1356 5.78003Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.5408 8.24237C8.5408 10.3096 7.3704 11.5408 4.4824 11.5408C2.7192 11.5408 1.4424 11.1456 0.6216 10.7048V7.96877C1.5488 8.39437 3.2968 8.86557 4.452 8.86557C5.1512 8.86557 5.4096 8.63757 5.4096 8.27277C5.4096 7.89277 5.1056 7.67997 4.3152 7.52797C1.3512 7.04157 0.5 5.87117 0.5 4.35117C0.5 2.39037 1.944 1.21997 4.5888 1.21997C5.9872 1.21997 7.3096 1.52397 8.1608 1.97997V4.62477C6.8688 4.13837 5.3792 3.81917 4.5128 3.81917C3.8592 3.81917 3.5248 4.01677 3.5248 4.39677C3.5248 4.77677 3.8744 4.95917 4.9232 5.15677C7.8416 5.62797 8.5408 6.75277 8.5408 8.24237Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("3dAc4", function(module, exports) {
$parcel$export(module.exports, "CollectionStrategyMarkBrandV3", function () { return $54a64d23fb45274f$export$3543f43891f3f567; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $54a64d23fb45274f$export$3543f43891f3f567 = ({ width: width = 128, height: height = 14 } = {})=>{
    const intl = (0, $8e22h.default)();
    const StrategyTitle = intl.formatMessage({
        id: 'software.collections.strategy.title',
        defaultMessage: 'Strategy Collection'
    });
    const strategyTitleId = (0, $1oC0p.useId)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 128 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-labelledby": strategyTitleId,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: strategyTitleId,
                suppressHydrationWarning: true,
                children: StrategyTitle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M53.061 13.3338C51.9666 13.3338 51.541 13.2882 51.1154 13.1058V10.613C51.6474 10.7498 52.1186 10.7954 52.7266 10.7954C53.8362 10.7954 54.2314 10.3546 54.4442 9.56423H52.6658L50.781 2.40503H53.5778L54.8698 7.83143L56.177 2.40503H58.9738L56.9066 10.005C56.2986 12.2394 55.037 13.3338 53.061 13.3338Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.4164 9.30573V8.40893C46.9604 9.47293 46.1396 9.97453 45.1364 9.97453C43.3276 9.97453 42.4916 8.33293 42.4916 6.09853C42.4916 4.00093 43.3276 2.25293 45.2732 2.25293C46.3068 2.25293 47.0212 2.87613 47.4164 3.78813V2.40493H50.274V9.19933C50.274 11.6769 49.0428 13.3337 45.8052 13.3337C44.7564 13.3337 43.6468 13.1817 42.7804 12.9385V10.3849C43.662 10.7345 44.574 10.8865 45.5316 10.8865C46.93 10.8865 47.4164 10.2177 47.4164 9.30573ZM45.3188 6.09853C45.3188 7.11693 45.6836 7.63373 46.3676 7.63373C46.9756 7.63373 47.4164 7.20813 47.4164 6.20493V5.93133C47.4164 5.03453 46.9908 4.63933 46.4132 4.63933C45.6836 4.63933 45.3188 5.17133 45.3188 6.09853Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.2198 4.22906C37.5054 4.22906 37.1406 4.74586 37.0494 5.76426H39.3446C39.2686 4.70026 38.9038 4.22906 38.2198 4.22906ZM41.6246 9.95946C40.8798 10.2331 39.8614 10.4307 38.843 10.4307C35.6966 10.4307 34.283 9.04746 34.283 6.46346C34.283 3.98586 35.651 2.22266 38.2654 2.22266C40.8494 2.22266 41.9134 3.97066 41.9134 6.46346V7.05626H37.1102C37.2926 7.83146 37.8246 8.07466 38.9038 8.07466C39.8158 8.07466 40.819 7.93786 41.6246 7.70986V9.95946Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.3157 7.13228C32.3157 7.61868 32.5589 7.86188 33.0301 7.86188C33.2581 7.86188 33.4709 7.81628 33.6381 7.78588V10.2331C33.2429 10.3243 32.8021 10.4003 32.1181 10.4003C30.1421 10.4003 29.4581 9.22988 29.4581 7.52748V4.73068H28.7285V2.40508H29.4581V0.809082H32.3157V2.40508H33.6381V4.73068H32.3157V7.13228Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.0235 6.34173C23.0235 7.45133 23.3883 7.99853 24.0723 7.99853C24.6347 7.99853 25.1211 7.58813 25.1211 6.64573V6.02253C25.1211 5.06493 24.7107 4.65453 24.1331 4.65453C23.4035 4.65453 23.0235 5.26253 23.0235 6.34173ZM25.1211 10.2785V8.88013C24.6651 9.92893 23.8443 10.4305 22.8563 10.4305C21.0323 10.4305 20.1963 8.71293 20.1963 6.34173C20.1963 4.10733 21.0323 2.25293 22.9779 2.25293C24.0115 2.25293 24.7259 2.86093 25.1211 3.75773V2.40493H27.9939V10.2785H25.1211Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.8067 6.46325V10.2785H14.9187V2.40485H17.8067V3.89445C18.2171 2.83045 18.8555 2.23765 19.8891 2.29845V5.24725C18.3539 5.14085 17.8067 5.44485 17.8067 6.46325Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.5884 7.13228C12.5884 7.61868 12.8316 7.86188 13.3028 7.86188C13.5308 7.86188 13.7436 7.81628 13.9108 7.78588V10.2331C13.5156 10.3243 13.0748 10.4003 12.3908 10.4003C10.4148 10.4003 9.73082 9.22988 9.73082 7.52748V4.73068H9.00122V2.40508H9.73082V0.809082H12.5884V2.40508H13.9108V4.73068H12.5884V7.13228Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.5408 7.1474C8.5408 9.2146 7.3704 10.4458 4.4824 10.4458C2.7192 10.4458 1.4424 10.0506 0.6216 9.6098V6.8738C1.5488 7.2994 3.2968 7.7706 4.452 7.7706C5.1512 7.7706 5.4096 7.5426 5.4096 7.1778C5.4096 6.7978 5.1056 6.585 4.3152 6.433C1.3512 5.9466 0.5 4.7762 0.5 3.2562C0.5 1.2954 1.944 0.125 4.5888 0.125C5.9872 0.125 7.3096 0.429001 8.1608 0.885V3.5298C6.8688 3.0434 5.3792 2.7242 4.5128 2.7242C3.8592 2.7242 3.5248 2.9218 3.5248 3.3018C3.5248 3.6818 3.8744 3.8642 4.9232 4.0618C7.8416 4.533 8.5408 5.6578 8.5408 7.1474Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M71.9424 9.24529V10.5993C71.3043 11.0195 70.2926 11.2063 69.2343 11.2063C65.8725 11.2063 63.9738 9.18303 63.9738 5.96134C63.9738 2.8486 65.8725 0.669678 69.2032 0.669678C70.1992 0.669678 71.1953 0.856443 71.9268 1.38561V2.73965C71.1953 2.27274 70.386 2.02372 69.2032 2.02372C66.8064 2.02372 65.3745 3.61122 65.3745 5.96134C65.3745 8.31146 66.853 9.86783 69.281 9.86783C70.3549 9.86783 71.1953 9.61881 71.9424 9.24529Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.6465 11.2064C74.312 11.2064 72.9424 9.47884 72.9424 7.14428C72.9424 4.80973 74.312 3.11328 76.6465 3.11328C78.9655 3.11328 80.3196 4.80973 80.3196 7.14428C80.3196 9.47884 78.9655 11.2064 76.6465 11.2064ZM76.6465 4.35838C74.9812 4.35838 74.2497 5.66573 74.2497 7.14428C74.2497 8.62284 74.9812 9.96132 76.6465 9.96132C78.2963 9.96132 79.0122 8.62284 79.0122 7.14428C79.0122 5.66573 78.2963 4.35838 76.6465 4.35838Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M84.0899 11.1441C83.981 11.1752 83.7475 11.2064 83.4051 11.2064C82.1289 11.2064 81.3196 10.5994 81.3196 9.16752V0.125H82.6581V9.01188C82.6581 9.71225 83.125 9.96127 83.7008 9.96127C83.8409 9.96127 83.9343 9.96127 84.0899 9.94571V11.1441Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.8603 11.1441C87.7514 11.1752 87.5179 11.2064 87.1755 11.2064C85.8993 11.2064 85.09 10.5994 85.09 9.16752V0.125H86.4284V9.01188C86.4284 9.71225 86.8954 9.96127 87.4712 9.96127C87.6113 9.96127 87.7047 9.96127 87.8603 9.94571V11.1441Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.471 4.32725C91.0547 4.32725 90.3388 5.24551 90.1987 6.59955H94.541C94.4632 5.15213 93.8095 4.32725 92.471 4.32725ZM95.4592 10.7395C94.8211 11.0819 93.8406 11.2064 93.0469 11.2064C90.1365 11.2064 88.8602 9.52553 88.8602 7.14428C88.8602 4.79416 90.1676 3.11328 92.5333 3.11328C94.9301 3.11328 95.895 4.7786 95.895 7.14428V7.75127H90.2143C90.401 9.07418 91.257 9.93019 93.0936 9.93019C93.9963 9.93019 94.7589 9.75899 95.4592 9.50997V10.7395Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M102.856 9.65004V10.8484C102.389 11.0975 101.673 11.2064 100.957 11.2064C98.1868 11.2064 96.895 9.52553 96.895 7.14428C96.895 4.79416 98.1868 3.11328 100.957 3.11328C101.658 3.11328 102.202 3.20666 102.809 3.48681V4.73191C102.311 4.49845 101.782 4.35838 101.051 4.35838C99.0272 4.35838 98.2024 5.6346 98.2024 7.14428C98.2024 8.65396 99.0428 9.93019 101.082 9.93019C101.875 9.93019 102.373 9.82124 102.856 9.65004Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.424 8.74726C106.424 9.43207 106.829 9.89898 107.654 9.89898C107.965 9.89898 108.26 9.83672 108.494 9.79003V11.0818C108.26 11.1441 107.996 11.2063 107.591 11.2063C105.926 11.2063 105.117 10.2258 105.117 8.77839V4.62288H103.856V3.37778H105.117V1.72803H106.424V3.37778H108.494V4.62288H106.424V8.74726Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M109.494 1.3701C109.494 0.778681 109.883 0.436279 110.428 0.436279C110.972 0.436279 111.362 0.778681 111.362 1.3701C111.362 1.96152 110.972 2.30393 110.428 2.30393C109.883 2.30393 109.494 1.96152 109.494 1.3701ZM109.743 11.2064V3.42451H111.081V11.2064H109.743Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M116.066 11.2064C113.731 11.2064 112.362 9.47884 112.362 7.14428C112.362 4.80973 113.731 3.11328 116.066 3.11328C118.385 3.11328 119.739 4.80973 119.739 7.14428C119.739 9.47884 118.385 11.2064 116.066 11.2064ZM116.066 4.35838C114.4 4.35838 113.669 5.66573 113.669 7.14428C113.669 8.62284 114.4 9.96132 116.066 9.96132C117.715 9.96132 118.431 8.62284 118.431 7.14428C118.431 5.66573 117.715 4.35838 116.066 4.35838Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M127.353 6.64625V11.2064H126.015V6.50617C126.015 5.10544 125.455 4.48289 124.178 4.48289C122.933 4.48289 122.077 5.30777 122.077 6.8797V11.2064H120.739V3.42456H122.077V4.70078C122.575 3.78252 123.494 3.26892 124.536 3.26892C126.326 3.26892 127.353 4.49845 127.353 6.64625Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("iyxHK", function(module, exports) {
$parcel$export(module.exports, "CollectionTeamworkLogoBrandV3", function () { return $a59da3428f3f579d$export$22390c80912684cb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $a59da3428f3f579d$export$22390c80912684cb = ({ width: width = 201, height: height = 48 } = {})=>{
    const intl = (0, $8e22h.default)();
    const TeamworkTitle = intl.formatMessage({
        id: 'software.collections.teamwork.title',
        defaultMessage: 'Teamwork Collection'
    });
    const teamworkTitleId = (0, $1oC0p.useId)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 201 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-labelledby": teamworkTitleId,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: teamworkTitleId,
                suppressHydrationWarning: true,
                children: TeamworkTitle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M199.867 24.4996V30.2247H198.186V24.3237C198.186 22.5651 197.483 21.7835 195.88 21.7835C194.317 21.7835 193.243 22.8192 193.243 24.7927V30.2247H191.562V20.4548H193.243V22.0571C193.868 20.9043 195.021 20.2594 196.33 20.2594C198.577 20.2594 199.867 21.8031 199.867 24.4996Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M184.998 30.4201C182.067 30.4201 180.347 28.2512 180.347 25.3203C180.347 22.3893 182.067 20.2594 184.998 20.2594C187.909 20.2594 189.609 22.3893 189.609 25.3203C189.609 28.2512 187.909 30.4201 184.998 30.4201ZM184.998 21.8226C182.907 21.8226 181.989 23.464 181.989 25.3203C181.989 27.1765 182.907 28.857 184.998 28.857C187.069 28.857 187.968 27.1765 187.968 25.3203C187.968 23.464 187.069 21.8226 184.998 21.8226Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M176.404 17.8755C176.404 17.133 176.892 16.7032 177.576 16.7032C178.26 16.7032 178.749 17.133 178.749 17.8755C178.749 18.6181 178.26 19.0479 177.576 19.0479C176.892 19.0479 176.404 18.6181 176.404 17.8755ZM176.716 30.2247V20.4548H178.397V30.2247H176.716Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M171.962 27.1961C171.962 28.0558 172.47 28.642 173.506 28.642C173.897 28.642 174.268 28.5639 174.561 28.5052V30.127C174.268 30.2052 173.936 30.2834 173.428 30.2834C171.337 30.2834 170.321 29.0524 170.321 27.2351V22.018H168.738V20.4548H170.321V18.3836H171.962V20.4548H174.561V22.018H171.962V27.1961Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M167.719 28.4662V29.9707C167.133 30.2834 166.234 30.4201 165.335 30.4201C161.857 30.4201 160.235 28.3098 160.235 25.3203C160.235 22.3697 161.857 20.2594 165.335 20.2594C166.214 20.2594 166.898 20.3767 167.66 20.7284V22.2916C167.035 21.9985 166.371 21.8226 165.452 21.8226C162.912 21.8226 161.876 23.4249 161.876 25.3203C161.876 27.2156 162.932 28.8179 165.491 28.8179C166.488 28.8179 167.113 28.6811 167.719 28.4662Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M154.521 21.7835C152.743 21.7835 151.844 22.9364 151.669 24.6364H157.12C157.022 22.8192 156.202 21.7835 154.521 21.7835ZM158.273 29.834C157.472 30.2638 156.241 30.4201 155.244 30.4201C151.59 30.4201 149.988 28.3098 149.988 25.3203C149.988 22.3697 151.629 20.2594 154.6 20.2594C157.609 20.2594 158.82 22.3502 158.82 25.3203V26.0823H151.688C151.923 27.7432 152.997 28.8179 155.303 28.8179C156.436 28.8179 157.394 28.6029 158.273 28.2903V29.834Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M149.053 30.2053C148.916 30.2444 148.623 30.2834 148.193 30.2834C146.591 30.2834 145.575 29.5214 145.575 27.7237V16.3711H147.255V27.5283C147.255 28.4076 147.841 28.7203 148.564 28.7203C148.74 28.7203 148.858 28.7203 149.053 28.7007V30.2053Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M143.958 30.2053C143.821 30.2444 143.528 30.2834 143.098 30.2834C141.496 30.2834 140.48 29.5214 140.48 27.7237V16.3711H142.16V27.5283C142.16 28.4076 142.747 28.7203 143.47 28.7203C143.645 28.7203 143.763 28.7203 143.958 28.7007V30.2053Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M133.916 30.4201C130.985 30.4201 129.265 28.2512 129.265 25.3203C129.265 22.3893 130.985 20.2594 133.916 20.2594C136.827 20.2594 138.527 22.3893 138.527 25.3203C138.527 28.2512 136.827 30.4201 133.916 30.4201ZM133.916 21.8226C131.825 21.8226 130.907 23.464 130.907 25.3203C130.907 27.1765 131.825 28.857 133.916 28.857C135.987 28.857 136.886 27.1765 136.886 25.3203C136.886 23.464 135.987 21.8226 133.916 21.8226Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M128.033 27.9581V29.658C127.232 30.1856 125.961 30.4201 124.633 30.4201C120.412 30.4201 118.028 27.8799 118.028 23.8352C118.028 19.9272 120.412 17.1916 124.594 17.1916C125.844 17.1916 127.095 17.4261 128.013 18.0904V19.7904C127.095 19.2042 126.079 18.8916 124.594 18.8916C121.585 18.8916 119.787 20.8846 119.787 23.8352C119.787 26.7857 121.643 28.7397 124.691 28.7397C126.04 28.7397 127.095 28.427 128.033 27.9581Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "9.58862",
                width: "110.018",
                height: "38.2301",
                transform: "rotate(-5 0 9.58862)",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M96.5878 30.2141H92.8948V16.3604H96.5878V24.6257L98.913 20.0925H102.919L100.027 25.036L102.997 30.2141H98.9326L96.5878 25.6808V30.2141Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M89.3944 25.3096V30.2141H85.6818V20.0925H89.3944V22.0074C89.922 20.6396 90.7426 19.8775 92.0714 19.9557V23.7464C90.0978 23.6096 89.3944 24.0004 89.3944 25.3096Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M79.5161 30.4681C76.2529 30.4681 74.3576 28.3187 74.3576 25.1337C74.3576 21.9683 76.2529 19.858 79.5161 19.858C82.7402 19.858 84.5964 21.9683 84.5964 25.1337C84.5964 28.3187 82.7402 30.4681 79.5161 30.4681ZM79.5161 23.0234C78.4414 23.0234 77.9724 23.8636 77.9724 25.1337C77.9724 26.4234 78.4414 27.3222 79.5161 27.3222C80.5322 27.3222 81.0011 26.4234 81.0011 25.1337C81.0011 23.8636 80.5322 23.0234 79.5161 23.0234Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M72.0763 30.2141H67.2304L66.3707 26.736L65.804 23.3556L65.2178 26.736L64.3385 30.2141H59.7467L57.4214 20.0925H61.0363L62.3455 27.8302L64.2018 20.0925H67.8166L69.6924 27.8693L70.9821 20.0925H74.4015L72.0763 30.2141Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.9119 24.5866V30.2141H47.2189V24.1763C47.2189 23.3361 46.9258 22.9453 46.2028 22.9453C45.4603 22.9453 44.9523 23.4533 44.9523 24.5866V30.2141H41.2593V20.0925H44.9523V21.9097C45.4994 20.6005 46.4568 19.8775 47.8833 19.8775C49.4074 19.8775 50.2867 20.6396 50.6774 22.0465C51.2441 20.6591 52.2993 19.8775 53.882 19.8775C56.0118 19.8775 56.8716 21.3821 56.8716 24.0591V30.2141H53.1785V24.3131C53.1785 23.3947 52.8854 22.9453 52.1625 22.9453C51.42 22.9453 50.9119 23.4533 50.9119 24.5866Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.3977 25.1533C33.3977 26.5797 33.8666 27.2831 34.7459 27.2831C35.4689 27.2831 36.0942 26.7555 36.0942 25.5441V24.7429C36.0942 23.5119 35.5666 22.9843 34.8241 22.9843C33.8862 22.9843 33.3977 23.7659 33.3977 25.1533ZM36.0942 30.2141V28.4164C35.508 29.7647 34.4528 30.4095 33.1827 30.4095C30.838 30.4095 29.7633 28.2015 29.7633 25.1533C29.7633 22.2809 30.838 19.8971 33.3391 19.8971C34.6678 19.8971 35.5861 20.6786 36.0942 21.8315V20.0925H39.7872V30.2141H36.0942Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.2718 22.4372C23.3534 22.4372 22.8845 23.1016 22.7672 24.4108H25.7178C25.6201 23.043 25.1511 22.4372 24.2718 22.4372ZM28.6487 29.8038C27.6913 30.1555 26.3821 30.4095 25.0729 30.4095C21.0282 30.4095 19.211 28.6314 19.211 25.3096C19.211 22.1246 20.9696 19.858 24.3304 19.858C27.6522 19.858 29.02 22.1051 29.02 25.3096V26.0716H22.8454C23.0799 27.0682 23.7638 27.3808 25.1511 27.3808C26.3235 27.3808 27.6131 27.205 28.6487 26.9119V29.8038Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.95215 17.3764H19.5657V20.6787H16.7715V30.2141H12.7463V20.6787H9.95215V17.3764Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("dfmcY", function(module, exports) {
$parcel$export(module.exports, "CollectionTeamworkMarkBrandV3", function () { return $b567f7494e19be1b$export$b59717c2e9c04063; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
const $b567f7494e19be1b$export$b59717c2e9c04063 = ({ width: width = 146, height: height = 14 } = {})=>{
    const intl = (0, $8e22h.default)();
    const TeamworkTitle = intl.formatMessage({
        id: 'software.collections.teamwork.title',
        defaultMessage: 'Teamwork Collection'
    });
    const teamworkTitleId = (0, $1oC0p.useId)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 146 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-labelledby": teamworkTitleId,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: teamworkTitleId,
                suppressHydrationWarning: true,
                children: TeamworkTitle
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M69.7289 12.473H66.7566V1.32275H69.7289V7.97515L71.6004 4.32655H74.8244L72.4968 8.30541L74.8873 12.473H71.6161L69.7289 8.82439V12.473Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M63.9393 8.52544V12.4728H60.9512V4.32641H63.9393V5.86763C64.3639 4.76676 65.0244 4.15342 66.0939 4.21632V7.2673C64.5055 7.15721 63.9393 7.47175 63.9393 8.52544Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M55.9888 12.6775C53.3624 12.6775 51.8369 10.9476 51.8369 8.38415C51.8369 5.83642 53.3624 4.13794 55.9888 4.13794C58.5837 4.13794 60.0777 5.83642 60.0777 8.38415C60.0777 10.9476 58.5837 12.6775 55.9888 12.6775ZM55.9888 6.68566C55.1238 6.68566 54.7464 7.36191 54.7464 8.38415C54.7464 9.42211 55.1238 10.1455 55.9888 10.1455C56.8065 10.1455 57.184 9.42211 57.184 8.38415C57.184 7.36191 56.8065 6.68566 55.9888 6.68566Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.0008 12.4731H46.1006L45.4086 9.67374L44.9526 6.95302L44.4808 9.67374L43.7731 12.4731H40.0773L38.2058 4.32666H41.1152L42.1689 10.5544L43.663 4.32666H46.5724L48.0822 10.5859L49.1201 4.32666H51.8723L50.0008 12.4731Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.9665 7.9437V12.473H29.9942V7.61344C29.9942 6.93719 29.7583 6.62266 29.1764 6.62266C28.5787 6.62266 28.1699 7.03155 28.1699 7.9437V12.473H25.1975V4.32656H28.1699V5.78914C28.6102 4.73545 29.3808 4.15356 30.5289 4.15356C31.7555 4.15356 32.4632 4.76691 32.7778 5.89923C33.2339 4.78263 34.0831 4.15356 35.357 4.15356C37.0712 4.15356 37.7631 5.36452 37.7631 7.51908V12.473H34.7908V7.72353C34.7908 6.98437 34.5549 6.62266 33.973 6.62266C33.3754 6.62266 32.9665 7.03155 32.9665 7.9437Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.8702 8.39967C18.8702 9.54772 19.2476 10.1139 19.9553 10.1139C20.5372 10.1139 21.0405 9.68926 21.0405 8.7142V8.06941C21.0405 7.07863 20.6158 6.65401 20.0182 6.65401C19.2633 6.65401 18.8702 7.28308 18.8702 8.39967ZM21.0405 12.4729V11.026C20.5687 12.1112 19.7194 12.6302 18.6972 12.6302C16.81 12.6302 15.945 10.853 15.945 8.39967C15.945 6.08785 16.81 4.16919 18.823 4.16919C19.8924 4.16919 20.6316 4.79826 21.0405 5.72613V4.32646H24.0128V12.4729H21.0405Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.5252 6.21386C10.786 6.21386 10.4086 6.74857 10.3142 7.80226H12.689C12.6103 6.70139 12.2329 6.21386 11.5252 6.21386ZM15.048 12.1428C14.2774 12.4259 13.2237 12.6304 12.17 12.6304C8.91455 12.6304 7.45197 11.1992 7.45197 8.52569C7.45197 5.96224 8.86737 4.13794 11.5724 4.13794C14.2459 4.13794 15.3468 5.94651 15.3468 8.52569V9.13903H10.3771C10.5659 9.94109 11.1163 10.1927 12.2329 10.1927C13.1765 10.1927 14.2144 10.0512 15.048 9.81528V12.1428Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 2.14062H7.73754V4.79844H5.48862V12.4731H2.24892V4.79844H0V2.14062Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M88.3053 10.1862V11.5872C87.6451 12.022 86.5984 12.2152 85.5034 12.2152C82.0251 12.2152 80.0605 10.1218 80.0605 6.7885C80.0605 3.5679 82.0251 1.31348 85.4712 1.31348C86.5018 1.31348 87.5323 1.50671 88.2892 2.05422V3.45518C87.5323 2.97209 86.695 2.71444 85.4712 2.71444C82.9913 2.71444 81.5098 4.35695 81.5098 6.7885C81.5098 9.22006 83.0396 10.8304 85.5517 10.8304C86.6628 10.8304 87.5323 10.5727 88.3053 10.1862Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M93.1725 12.2154C90.757 12.2154 89.34 10.4279 89.34 8.01248C89.34 5.59703 90.757 3.8418 93.1725 3.8418C95.5718 3.8418 96.9728 5.59703 96.9728 8.01248C96.9728 10.4279 95.5718 12.2154 93.1725 12.2154ZM93.1725 5.13004C91.4495 5.13004 90.6926 6.48269 90.6926 8.01248C90.6926 9.54226 91.4495 10.9271 93.1725 10.9271C94.8794 10.9271 95.6201 9.54226 95.6201 8.01248C95.6201 6.48269 94.8794 5.13004 93.1725 5.13004Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M100.874 12.1509C100.761 12.1831 100.52 12.2153 100.165 12.2153C98.8448 12.2153 98.0074 11.5873 98.0074 10.1059V0.75H99.3923V9.94482C99.3923 10.6695 99.8754 10.9271 100.471 10.9271C100.616 10.9271 100.713 10.9271 100.874 10.911V12.1509Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M104.775 12.1509C104.662 12.1831 104.42 12.2153 104.066 12.2153C102.746 12.2153 101.908 11.5873 101.908 10.1059V0.75H103.293V9.94482C103.293 10.6695 103.776 10.9271 104.372 10.9271C104.517 10.9271 104.614 10.9271 104.775 10.911V12.1509Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M109.545 5.09783C108.08 5.09783 107.339 6.04791 107.194 7.44887H111.687C111.607 5.95129 110.93 5.09783 109.545 5.09783ZM112.637 11.7323C111.977 12.0865 110.962 12.2154 110.141 12.2154C107.13 12.2154 105.809 10.4762 105.809 8.01248C105.809 5.58092 107.162 3.8418 109.61 3.8418C112.09 3.8418 113.088 5.56482 113.088 8.01248V8.6405H107.21C107.404 10.0093 108.289 10.8949 110.189 10.8949C111.123 10.8949 111.912 10.7178 112.637 10.4601V11.7323Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M120.29 10.6051V11.845C119.807 12.1026 119.066 12.2154 118.326 12.2154C115.459 12.2154 114.123 10.4762 114.123 8.01248C114.123 5.58092 115.459 3.8418 118.326 3.8418C119.05 3.8418 119.614 3.93842 120.242 4.22827V5.51651C119.726 5.27497 119.179 5.13004 118.422 5.13004C116.329 5.13004 115.475 6.45049 115.475 8.01248C115.475 9.57447 116.345 10.8949 118.454 10.8949C119.276 10.8949 119.791 10.7822 120.29 10.6051Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M123.982 9.67115C123.982 10.3797 124.4 10.8628 125.254 10.8628C125.576 10.8628 125.882 10.7984 126.123 10.7501V12.0866C125.882 12.151 125.608 12.2154 125.189 12.2154C123.466 12.2154 122.629 11.2009 122.629 9.70336V5.40385H121.325V4.11561H122.629V2.40869H123.982V4.11561H126.123V5.40385H123.982V9.67115Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M127.158 2.0382C127.158 1.42629 127.561 1.07202 128.124 1.07202C128.688 1.07202 129.09 1.42629 129.09 2.0382C129.09 2.65012 128.688 3.00438 128.124 3.00438C127.561 3.00438 127.158 2.65012 127.158 2.0382ZM127.416 12.2153V4.1638H128.801V12.2153H127.416Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M133.958 12.2154C131.542 12.2154 130.125 10.4279 130.125 8.01248C130.125 5.59703 131.542 3.8418 133.958 3.8418C136.357 3.8418 137.758 5.59703 137.758 8.01248C137.758 10.4279 136.357 12.2154 133.958 12.2154ZM133.958 5.13004C132.235 5.13004 131.478 6.48269 131.478 8.01248C131.478 9.54226 132.235 10.9271 133.958 10.9271C135.665 10.9271 136.405 9.54226 136.405 8.01248C136.405 6.48269 135.665 5.13004 133.958 5.13004Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M145.636 7.49704V12.2152H144.252V7.35211C144.252 5.90284 143.672 5.25872 142.351 5.25872C141.063 5.25872 140.177 6.11218 140.177 7.73859V12.2152H138.793V4.16372H140.177V5.48416C140.693 4.53409 141.643 4.00269 142.722 4.00269C144.574 4.00269 145.636 5.27482 145.636 7.49704Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("3ufD2", function(module, exports) {
$parcel$export(module.exports, "CompassLogoBrandV3", function () { return $384b493b08b15da8$export$8a021a0f4cfbcc32; });

var $7VQPk = parcelRequire("7VQPk");
const $384b493b08b15da8$export$8a021a0f4cfbcc32 = ({ width: width, height: height = '100%' })=>{
    const compassTitleId = 'compassTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 243 48",
        fill: "none",
        "aria-labelledby": compassTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: compassTitleId,
                children: "Compass"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M242.69 31.744C242.69 35.562 240.206 38.46 234.042 38.46C230.592 38.46 227.786 37.678 226.038 36.758V32.572C228.016 33.722 231.328 34.826 234.226 34.826C237.262 34.826 238.826 33.584 238.826 31.79C238.826 30.042 237.492 29.03 233.122 27.972C228.016 26.73 225.854 24.752 225.854 20.98C225.854 16.978 228.936 14.54 234.18 14.54C237.17 14.54 239.884 15.276 241.586 16.196V20.29C238.826 18.91 236.572 18.174 234.134 18.174C231.236 18.174 229.672 19.186 229.672 20.98C229.672 22.59 230.776 23.602 235.008 24.614C240.114 25.856 242.69 27.742 242.69 31.744Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M222.251 31.744C222.251 35.562 219.767 38.46 213.603 38.46C210.153 38.46 207.347 37.678 205.599 36.758V32.572C207.577 33.722 210.889 34.826 213.787 34.826C216.823 34.826 218.387 33.584 218.387 31.79C218.387 30.042 217.053 29.03 212.683 27.972C207.577 26.73 205.415 24.752 205.415 20.98C205.415 16.978 208.497 14.54 213.741 14.54C216.731 14.54 219.445 15.276 221.147 16.196V20.29C218.387 18.91 216.133 18.174 213.695 18.174C210.797 18.174 209.233 19.186 209.233 20.98C209.233 22.59 210.337 23.602 214.569 24.614C219.675 25.856 222.251 27.742 222.251 31.744Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M183.441 26.5C183.441 32.02 185.649 34.78 189.743 34.78C193.285 34.78 196.459 32.526 196.459 27.42V25.58C196.459 20.474 193.561 18.22 190.203 18.22C185.741 18.22 183.441 21.164 183.441 26.5ZM196.459 38V33.86C194.987 36.896 192.227 38.46 188.685 38.46C182.567 38.46 179.485 33.262 179.485 26.5C179.485 20.014 182.705 14.54 189.145 14.54C192.503 14.54 195.079 16.058 196.459 19.048V15H200.415V38H196.459Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M172.323 26.5C172.323 20.98 170.115 18.22 166.021 18.22C162.479 18.22 159.305 20.474 159.305 25.58V27.42C159.305 32.526 162.203 34.78 165.561 34.78C170.023 34.78 172.323 31.836 172.323 26.5ZM166.619 38.46C163.261 38.46 160.685 36.942 159.305 33.952V46.97H155.349V15H159.305V19.14C160.777 16.104 163.537 14.54 167.079 14.54C173.197 14.54 176.279 19.738 176.279 26.5C176.279 32.986 173.059 38.46 166.619 38.46Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M134.245 25.212V38H130.289V24.108C130.289 19.968 128.633 18.128 124.861 18.128C121.181 18.128 118.651 20.566 118.651 25.212V38H114.695V15H118.651V18.772C120.123 16.058 122.837 14.54 125.919 14.54C129.829 14.54 132.497 16.518 133.647 20.152C134.935 16.61 138.017 14.54 141.835 14.54C146.987 14.54 149.839 18.036 149.839 24.522V38H145.883V25.212C145.883 20.474 144.227 18.128 140.455 18.128C136.775 18.128 134.245 20.566 134.245 25.212Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M99.2417 38.46C92.3417 38.46 88.2937 33.354 88.2937 26.454C88.2937 19.554 92.3417 14.54 99.2417 14.54C106.096 14.54 110.098 19.554 110.098 26.454C110.098 33.354 106.096 38.46 99.2417 38.46ZM99.2417 18.22C94.3197 18.22 92.1577 22.084 92.1577 26.454C92.1577 30.824 94.3197 34.78 99.2417 34.78C104.118 34.78 106.234 30.824 106.234 26.454C106.234 22.084 104.118 18.22 99.2417 18.22Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.3921 32.6644V36.6664C83.5061 37.9084 80.5161 38.4604 77.3881 38.4604C67.4521 38.4604 61.8401 32.4804 61.8401 22.9584C61.8401 13.7584 67.4521 7.31836 77.2961 7.31836C80.2401 7.31836 83.1841 7.87036 85.3461 9.43436V13.4364C83.1841 12.0564 80.7921 11.3204 77.2961 11.3204C70.2121 11.3204 65.9801 16.0124 65.9801 22.9584C65.9801 29.9044 70.3501 34.5044 77.5261 34.5044C80.7001 34.5044 83.1841 33.7684 85.3921 32.6644Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.0359 22.7418V29.108H18.6575V22.7418H25.0359V16.3799H13.4006C12.7791 16.3842 12.2792 16.8827 12.2834 17.4941C12.2834 17.4991 12.2834 17.5041 12.2834 17.5091V34.3743C12.2706 34.9857 12.7641 35.4907 13.3848 35.5036C13.3898 35.5036 13.3956 35.5036 13.4006 35.5036H30.2814C30.9029 35.4993 31.4028 35.0007 31.3986 34.3893C31.3986 34.3843 31.3986 34.3793 31.3986 34.3743V22.7418H25.0359Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.0361 10.015V16.3805H31.4295V22.7424H37.7886V11.1292C37.8014 10.5178 37.3079 10.0129 36.6872 10C36.6822 10 36.6765 10 36.6715 10L25.0361 10.015Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("9cBfs", function(module, exports) {
$parcel$export(module.exports, "CompassMarkBrandV3", function () { return $26fe511eeba98b8d$export$7db7f658128a12df; });

var $7VQPk = parcelRequire("7VQPk");
const $26fe511eeba98b8d$export$7db7f658128a12df = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12.5635C0 5.93606 5.37258 0.563477 12 0.563477H32C38.6274 0.563477 44 5.93606 44 12.5635V32.5635C44 39.1909 38.6274 44.5635 32 44.5635H12C5.37258 44.5635 0 39.1909 0 32.5635V12.5635Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.9497 21.4099V27.2456H17.1029V21.4099H22.9497V15.5781H12.284C11.7144 15.5821 11.2561 16.0391 11.26 16.5995C11.26 16.6041 11.26 16.6087 11.26 16.6133V32.073C11.2482 32.6335 11.7006 33.0964 12.2696 33.1082C12.2742 33.1082 12.2794 33.1082 12.284 33.1082H27.7582C28.3278 33.1042 28.7861 32.6472 28.7822 32.0868C28.7822 32.0822 28.7822 32.0776 28.7822 32.073V21.4099H22.9497Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.9492 9.74324V15.5783H28.8098V21.4101H34.639V10.7646C34.6508 10.2042 34.1983 9.74128 33.6294 9.72949C33.6248 9.72949 33.6195 9.72949 33.615 9.72949L22.9492 9.74324Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("fWbT9", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoBrandV3", function () { return $025a9d79ddde3369$export$18b0c494a4331a39; });

var $7VQPk = parcelRequire("7VQPk");
const $025a9d79ddde3369$export$18b0c494a4331a39 = ({ width: width, height: height = '100%' })=>{
    const confluenceTitleId = 'confluenceTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 282 48",
        fill: "none",
        "aria-labelledby": confluenceTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: confluenceTitleId,
                children: "Confluence"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M271.735 18.128C267.549 18.128 265.433 20.842 265.019 24.844H277.853C277.623 20.566 275.691 18.128 271.735 18.128ZM280.567 37.08C278.681 38.092 275.783 38.46 273.437 38.46C264.835 38.46 261.063 33.492 261.063 26.454C261.063 19.508 264.927 14.54 271.919 14.54C279.003 14.54 281.855 19.462 281.855 26.454V28.248H265.065C265.617 32.158 268.147 34.688 273.575 34.688C276.243 34.688 278.497 34.182 280.567 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M257.927 33.86V37.402C256.547 38.138 254.431 38.46 252.315 38.46C244.127 38.46 240.309 33.492 240.309 26.454C240.309 19.508 244.127 14.54 252.315 14.54C254.385 14.54 255.995 14.816 257.789 15.644V19.324C256.317 18.634 254.753 18.22 252.591 18.22C246.611 18.22 244.173 21.992 244.173 26.454C244.173 30.916 246.657 34.688 252.683 34.688C255.029 34.688 256.501 34.366 257.927 33.86Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M236.173 24.522V38H232.217V24.108C232.217 19.968 230.561 18.128 226.789 18.128C223.109 18.128 220.579 20.566 220.579 25.212V38H216.623V15H220.579V18.772C222.051 16.058 224.765 14.54 227.847 14.54C233.137 14.54 236.173 18.174 236.173 24.522Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M201.792 18.128C197.606 18.128 195.49 20.842 195.076 24.844H207.91C207.68 20.566 205.748 18.128 201.792 18.128ZM210.624 37.08C208.738 38.092 205.84 38.46 203.494 38.46C194.892 38.46 191.12 33.492 191.12 26.454C191.12 19.508 194.984 14.54 201.976 14.54C209.06 14.54 211.912 19.462 211.912 26.454V28.248H195.122C195.674 32.158 198.204 34.688 203.632 34.688C206.3 34.688 208.554 34.182 210.624 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M166.973 28.478V15H170.929V28.892C170.929 33.032 172.585 34.872 176.357 34.872C180.037 34.872 182.567 32.434 182.567 27.788V15H186.523V38H182.567V34.228C181.095 36.942 178.381 38.46 175.299 38.46C170.009 38.46 166.973 34.826 166.973 28.478Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M163.627 37.9537C163.305 38.0457 162.615 38.1377 161.603 38.1377C157.831 38.1377 155.439 36.3437 155.439 32.1117V5.38574H159.395V31.6517C159.395 33.7217 160.775 34.4577 162.477 34.4577C162.891 34.4577 163.167 34.4577 163.627 34.4117V37.9537Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M145.236 12.5619V14.9999H151.17V18.6799H145.236V37.9999H141.372V18.6799H137.646V14.9999H141.372V12.4699C141.372 8.19195 143.764 5.29395 148.686 5.29395C149.882 5.29395 150.664 5.47795 151.354 5.66195V9.29595C150.664 9.15795 149.79 9.06595 148.87 9.06595C146.432 9.06595 145.236 10.4919 145.236 12.5619Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M134.245 24.522V38H130.289V24.108C130.289 19.968 128.633 18.128 124.861 18.128C121.181 18.128 118.651 20.566 118.651 25.212V38H114.695V15H118.651V18.772C120.123 16.058 122.837 14.54 125.919 14.54C131.209 14.54 134.245 18.174 134.245 24.522Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M99.2417 38.46C92.3417 38.46 88.2937 33.354 88.2937 26.454C88.2937 19.554 92.3417 14.54 99.2417 14.54C106.096 14.54 110.098 19.554 110.098 26.454C110.098 33.354 106.096 38.46 99.2417 38.46ZM99.2417 18.22C94.3197 18.22 92.1577 22.084 92.1577 26.454C92.1577 30.824 94.3197 34.78 99.2417 34.78C104.118 34.78 106.234 30.824 106.234 26.454C106.234 22.084 104.118 18.22 99.2417 18.22Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.3921 32.6639V36.6659C83.5061 37.9079 80.5161 38.4599 77.3881 38.4599C67.4521 38.4599 61.8401 32.4799 61.8401 22.9579C61.8401 13.7579 67.4521 7.31787 77.2961 7.31787C80.2401 7.31787 83.1841 7.86987 85.3461 9.43387V13.4359C83.1841 12.0559 80.7921 11.3199 77.2961 11.3199C70.2121 11.3199 65.9801 16.0119 65.9801 22.9579C65.9801 29.9039 70.3501 34.5039 77.5261 34.5039C80.7001 34.5039 83.1841 33.7679 85.3921 32.6639Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.7396 28.5301C27.3329 24.9487 25.1692 24.4136 22.0484 24.4136C18.3866 24.4136 15.2658 25.9367 12.4779 30.2179L12.0202 30.9177C11.6457 31.494 11.5625 31.6998 11.5625 31.9468C11.5625 32.1938 11.6873 32.3996 12.145 32.6878L16.847 35.6105C17.0967 35.7752 17.3048 35.8575 17.5128 35.8575C17.7625 35.8575 17.9289 35.734 18.1786 35.3635L18.9276 34.2109C20.0927 32.4408 21.1329 31.8645 22.4645 31.8645C23.6296 31.8645 25.0027 32.1938 26.7087 33.0171L31.6188 35.3224C32.1181 35.5693 32.659 35.4458 32.9087 34.8695L35.2389 29.765C35.4886 29.1887 35.3221 28.8182 34.7396 28.5301ZM13.1437 19.5149C20.5504 23.0963 22.7141 23.6314 25.8349 23.6314C29.4966 23.6314 32.6174 22.1083 35.4053 17.8271L35.8631 17.1273C36.2376 16.551 36.3208 16.3452 36.3208 16.0982C36.3208 15.8512 36.1959 15.6454 35.7382 15.3572L31.0362 12.4345C30.7866 12.2698 30.5785 12.1875 30.3705 12.1875C30.1208 12.1875 29.9544 12.311 29.7047 12.6815L28.9557 13.8341C27.7906 15.6042 26.7504 16.1805 25.4188 16.1805C24.2537 16.1805 22.8806 15.8512 21.1745 15.0279L16.2645 12.7226C15.7652 12.4757 15.2242 12.5992 14.9746 13.1755L12.6444 18.28C12.3947 18.8563 12.5612 19.2268 13.1437 19.5149Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("46TV4", function(module, exports) {
$parcel$export(module.exports, "ConfluenceMarkBrandV3", function () { return $c3dab5df93195248$export$19b63dc5071054c; });

var $7VQPk = parcelRequire("7VQPk");
const $c3dab5df93195248$export$19b63dc5071054c = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12.5635C0 5.93606 5.37258 0.563477 12 0.563477H32C38.6274 0.563477 44 5.93606 44 12.5635V32.5635C44 39.1909 38.6274 44.5635 32 44.5635H12C5.37258 44.5635 0 39.1909 0 32.5635V12.5635Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.8453 26.7161C25.0558 23.4331 23.0724 22.9426 20.2116 22.9426C16.8551 22.9426 13.9943 24.3388 11.4388 28.2632L11.0192 28.9047C10.6759 29.433 10.5996 29.6216 10.5996 29.848C10.5996 30.0745 10.714 30.2631 11.1336 30.5273L15.4438 33.2064C15.6726 33.3574 15.8633 33.4329 16.0541 33.4329C16.2829 33.4329 16.4355 33.3196 16.6643 32.98L17.3509 31.9235C18.4189 30.3009 19.3725 29.7726 20.5931 29.7726C21.6611 29.7726 22.9198 30.0745 24.4837 30.8292L28.9845 32.9423C29.4423 33.1687 29.9381 33.0555 30.167 32.5272L32.303 27.8481C32.5318 27.3198 32.3793 26.9802 31.8453 26.7161ZM12.049 18.4521C18.8385 21.7351 20.8219 22.2256 23.6827 22.2256C27.0392 22.2256 29.9 20.8294 32.4556 16.905L32.8751 16.2635C33.2184 15.7352 33.2947 15.5466 33.2947 15.3202C33.2947 15.0937 33.1803 14.9051 32.7607 14.6409L28.4505 11.9618C28.2217 11.8108 28.031 11.7354 27.8402 11.7354C27.6114 11.7354 27.4588 11.8486 27.23 12.1882L26.5434 13.2447C25.4754 14.8673 24.5218 15.3956 23.3012 15.3956C22.2332 15.3956 20.9745 15.0937 19.4106 14.3391L14.9098 12.2259C14.4521 11.9995 13.9562 12.1127 13.7273 12.641L11.5913 17.3201C11.3625 17.8484 11.515 18.188 12.049 18.4521Z",
                fill: "white"
            })
        ]
    });

});

parcelRegister("zMH4F", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementMarkBrandV3", function () { return $0d84e6c4c6a36713$export$eb1f356d442ddf91; });

var $7VQPk = parcelRequire("7VQPk");
const $0d84e6c4c6a36713$export$eb1f356d442ddf91 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FFC716"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.8603 34.84C30.4469 36.8151 27.3618 38 24 38H12.8V37.0667L20.477 29.5031C21.4936 30.1552 22.7026 30.5333 24 30.5333C25.2975 30.5333 26.5066 30.1551 27.5232 29.5029L32.8603 34.84Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.8402 32.8601C36.8151 30.4467 38 27.3617 38 24C38 20.6383 36.8151 17.5533 34.8402 15.1399L29.5031 20.477C30.1552 21.4936 30.5333 22.7026 30.5333 24C30.5333 25.2974 30.1552 26.5064 29.5031 27.523L34.8402 32.8601Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.8603 13.16L27.5232 18.4971C26.5066 17.8449 25.2975 17.4667 24 17.4667C22.7026 17.4667 21.4936 17.8448 20.477 18.4969L15.1399 13.1598C17.5533 11.1849 20.6383 10 24 10C27.3618 10 30.4469 11.185 32.8603 13.16Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.16 15.1397C11.1849 17.5531 10 20.6382 10 24C10 27.3618 11.185 30.4469 13.16 32.8603L18.4971 27.5232C17.8449 26.5066 17.4667 25.2975 17.4667 24C17.4667 22.7025 17.8449 21.4934 18.4971 20.4768L13.16 15.1397Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("2U9yb", function(module, exports) {
$parcel$export(module.exports, "DxMarkBrandV3", function () { return $58f0c9c238ad533c$export$41081860009a686f; });

var $7VQPk = parcelRequire("7VQPk");
const $58f0c9c238ad533c$export$41081860009a686f = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 11C0 4.92487 4.92487 0 11 0H33C39.0751 0 44 4.92487 44 11V33C44 39.0751 39.0751 44 33 44H11C4.92487 44 0 39.0751 0 33V11Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.1979 24.5217L37.6936 31.1667H33.3132C32.8385 30.6206 32.3773 29.963 31.9689 29.3559C31.3424 28.4244 31.344 27.146 31.9913 26.2297L33.1979 24.5217Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.5124 19.4786L22.0168 12.8335H26.3972C26.8719 13.3797 27.3331 14.0374 27.7415 14.6445C28.368 15.5759 28.3664 16.8544 27.719 17.7707L26.5124 19.4786Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.9099 13.9607C33.3709 13.1893 33.8898 12.8927 34.6966 12.8927L38.27 12.8334L26.6452 30.4952C26.3932 30.8781 25.9746 31.1074 25.5272 31.1074H21.6277C25.3561 25.3789 29.3035 19.7688 32.9099 13.9607Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.33264 31.1076H13.6526C19.3034 31.1076 22.7485 27.5549 22.7485 21.9974C22.7485 16.4401 19.3034 12.8873 13.6526 12.8873H7.33264L11.2519 16.4654H9.63809C8.36482 16.4654 7.33264 17.528 7.33264 18.8387V27.5295V31.1076ZM11.3725 27.5295V16.4654H13.6279C16.8499 16.4654 18.6591 18.6478 18.6591 21.9974C18.6591 25.3472 16.8499 27.5295 13.6526 27.5295H11.3725Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("7yK4t", function(module, exports) {
$parcel$export(module.exports, "EnterpriseLogoBrandV3", function () { return $9e8c10583c232f60$export$1117ff999dd9d111; });

var $7VQPk = parcelRequire("7VQPk");
const $9e8c10583c232f60$export$1117ff999dd9d111 = ()=>{
    const enterpriseTitleId = 'enterpriseTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "98",
        height: "28",
        viewBox: "0 0 98 28",
        fill: "none",
        "aria-labelledby": enterpriseTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: enterpriseTitleId,
                children: "Enterprise"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 4H0.375V28H0V4Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.4455 11.3375C91.0255 11.3375 90.3055 12.3175 90.1455 13.6175C91.1255 13.4175 92.4855 13.3375 93.4055 13.3375H94.4656C94.3256 12.0575 93.6855 11.3375 92.4455 11.3375ZM97.0055 18.7775C96.1255 19.1775 94.8856 19.3775 93.1656 19.3775C89.2255 19.3775 87.1855 17.2575 87.1855 14.2575C87.1855 11.2975 89.0856 9.15747 92.5256 9.15747C96.0456 9.15747 97.4655 11.2775 97.4655 14.2575V14.9175H94.9656C93.3256 14.9175 91.6455 14.8775 90.1455 14.7775C90.3655 15.9775 91.3655 16.7375 93.4655 16.7375C94.7855 16.7375 95.8655 16.5975 97.0055 16.2975V18.7775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.6294 16.1975C85.6294 17.9375 84.4894 19.3975 81.3294 19.3975C79.5294 19.3975 78.0094 19.1575 77.1494 18.6975V16.2175C78.0694 16.6375 79.6894 17.0575 81.3294 17.0575C82.3094 17.0575 82.8694 16.8175 82.8694 16.3375C82.8694 15.8175 82.5094 15.5775 80.6494 15.3175C78.1494 14.9775 77.1094 14.0175 77.1094 12.2375C77.1094 10.3375 78.6894 9.15747 81.3494 9.15747C82.8894 9.15747 84.3094 9.41747 85.1694 9.81747V12.3375C83.8494 11.7175 82.4894 11.4575 81.1694 11.4575C80.2294 11.4575 79.8094 11.7375 79.8094 12.1975C79.8094 12.6975 80.2694 12.9175 82.0894 13.1575C84.4694 13.4975 85.6294 14.3975 85.6294 16.1975Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M71.4473 6.3175C71.4473 5.0575 72.2473 4.4375 73.4073 4.4375C74.5473 4.4375 75.3473 5.0575 75.3473 6.3175C75.3473 7.5775 74.5473 8.1975 73.4073 8.1975C72.2473 8.1975 71.4473 7.5775 71.4473 6.3175ZM71.8873 19.1775V9.3575H74.8473V19.1775H71.8873Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M67.4854 14.6774V19.1774H64.5254V9.35741H67.4854V11.8374C67.9254 10.2574 68.6054 9.13741 70.2054 9.21741V12.3974C68.4454 12.2574 67.4854 12.7974 67.4854 14.6774Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.2491 14.2775C59.2491 12.7375 58.4691 11.7975 57.0891 11.7975C55.8091 11.7975 54.8291 12.7775 54.8291 14.1975V14.3775C54.8291 15.9375 55.8091 16.7375 57.0891 16.7375C58.4091 16.7375 59.2491 15.8975 59.2491 14.2775ZM57.9291 19.3775C56.4891 19.3775 55.4091 18.6775 54.8291 17.2975V23.5775H51.8691V9.35747H54.8291V11.2775C55.4491 9.87747 56.6291 9.15747 58.1691 9.15747C60.7891 9.15747 62.2091 11.3775 62.2091 14.2775C62.2091 17.0375 60.7691 19.3775 57.9291 19.3775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.4659 14.6774V19.1774H44.5059V9.35741H47.4659V11.8374C47.9059 10.2574 48.5859 9.13741 50.1859 9.21741V12.3974C48.4259 12.2574 47.4659 12.7974 47.4659 14.6774Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.2698 11.3375C35.8498 11.3375 35.1298 12.3175 34.9698 13.6175C35.9498 13.4175 37.3098 13.3375 38.2298 13.3375H39.2898C39.1498 12.0575 38.5098 11.3375 37.2698 11.3375ZM41.8298 18.7775C40.9498 19.1775 39.7098 19.3775 37.9898 19.3775C34.0498 19.3775 32.0098 17.2575 32.0098 14.2575C32.0098 11.2975 33.9098 9.15747 37.3498 9.15747C40.8698 9.15747 42.2898 11.2775 42.2898 14.2575V14.9175H39.7898C38.1498 14.9175 36.4698 14.8775 34.9698 14.7775C35.1898 15.9775 36.1898 16.7375 38.2898 16.7375C39.6098 16.7375 40.6898 16.5975 41.8298 16.2975V18.7775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.7716 15.4574C27.7716 16.1574 28.2316 16.6174 29.1516 16.6174C29.6316 16.6174 30.1516 16.5374 30.5116 16.4774V19.1574C30.0316 19.2974 29.4516 19.3974 28.6316 19.3974C26.0716 19.3974 24.8116 17.8974 24.8116 15.6974V12.0174H23.3516V9.3574H24.8116V6.8374H27.7716V9.3574H30.4916V12.0174H27.7716V15.4574Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.6467 13.6775V19.1775H18.6667V13.8975C18.6667 12.4375 18.1467 11.7575 16.9467 11.7575C15.7067 11.7575 14.8667 12.4975 14.8667 13.8975V19.1775H11.8867V9.35747H14.8667V11.2575C15.4667 9.91747 16.6467 9.15747 18.1667 9.15747C20.5667 9.15747 21.6467 10.8775 21.6467 13.6775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 19.1776V6.0376H9.44V8.7976H3.04V11.3976H8.76V13.8976H3.04V16.4176H9.56V19.1776H0Z",
                fill: "black"
            })
        ]
    });
};

});

parcelRegister("jgx2N", function(module, exports) {
$parcel$export(module.exports, "FocusMarkBrandV3", function () { return $d7c9f56d34055e51$export$e9f8c879ca5c0ad6; });

var $7VQPk = parcelRequire("7VQPk");
const $d7c9f56d34055e51$export$e9f8c879ca5c0ad6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FB9700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.41 24.4082C38.1463 21.1445 32.8417 21.1792 29.6127 24.4082L26.8954 27.1255C25.3951 28.6258 22.9582 28.6258 21.4579 27.1255L19.2002 24.8678L13.3001 30.7679L15.5578 33.0256C20.316 37.7838 28.0344 37.7838 32.7926 33.0256L41.41 24.4082ZM6.9375 23.5957C10.2012 26.8594 15.4393 26.8912 18.7029 23.6275L21.455 20.8755C22.9553 19.3752 25.3922 19.3752 26.8925 20.8755L29.1502 23.1332L35.0503 17.2331L32.7926 14.9754C28.0344 10.2172 20.316 10.2172 15.5578 14.9754L6.94039 23.5928L6.9375 23.5957Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("b1Nny", function(module, exports) {
$parcel$export(module.exports, "GuardLogoBrandV3", function () { return $ccdd8d4d847a9a36$export$6f804086f23f6194; });

var $7VQPk = parcelRequire("7VQPk");
const $ccdd8d4d847a9a36$export$6f804086f23f6194 = ({ width: width, height: height = '100%' })=>{
    const guardTitleId = 'guardTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 180 48",
        fill: "none",
        "aria-labelledby": guardTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: guardTitleId,
                children: "Guard"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M162.597 26.4997C162.597 32.0197 164.805 34.7797 168.899 34.7797C172.441 34.7797 175.615 32.5257 175.615 27.4197V25.5797C175.615 20.4737 172.717 18.2197 169.359 18.2197C164.897 18.2197 162.597 21.1637 162.597 26.4997ZM175.615 37.9997V33.8597C174.143 36.8957 171.383 38.4597 167.841 38.4597C161.723 38.4597 158.641 33.2617 158.641 26.4997C158.641 20.0137 161.861 14.5397 168.301 14.5397C171.659 14.5397 174.235 16.0577 175.615 19.0477V5.38574H179.571V37.9997H175.615Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M148.926 24.4296V37.9996H145.062V14.9996H148.926V19.0476C150.26 16.3336 152.56 14.4016 157.068 14.6776V18.5416C152.008 18.0356 148.926 19.5536 148.926 24.4296Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M122.123 26.5C122.123 32.02 124.331 34.78 128.425 34.78C131.967 34.78 135.141 32.526 135.141 27.42V25.58C135.141 20.474 132.243 18.22 128.885 18.22C124.423 18.22 122.123 21.164 122.123 26.5ZM135.141 38V33.86C133.669 36.896 130.909 38.46 127.367 38.46C121.249 38.46 118.167 33.262 118.167 26.5C118.167 20.014 121.387 14.54 127.827 14.54C131.185 14.54 133.761 16.058 135.141 19.048V15H139.097V38H135.141Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M94.0203 28.478V15H97.9763V28.892C97.9763 33.032 99.6323 34.872 103.404 34.872C107.084 34.872 109.614 32.434 109.614 27.788V15H113.57V38H109.614V34.228C108.142 36.942 105.428 38.46 102.346 38.46C97.0563 38.46 94.0203 34.826 94.0203 28.478Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M88.0601 36.2975C85.6681 37.7235 81.2521 38.4595 77.8481 38.4595C67.4521 38.4595 61.8401 32.1115 61.8401 22.9575C61.8401 13.1135 68.2341 7.27148 78.9981 7.27148C81.3901 7.27148 84.1961 7.54748 86.8641 8.46749V12.6075C84.5641 11.6875 81.8501 11.2735 79.0441 11.2735C70.0741 11.2735 65.9801 15.7355 65.9801 22.8655C65.9801 29.8575 70.1201 34.5035 78.8141 34.5035C80.2401 34.5035 82.2181 34.3655 83.9201 33.8595V25.4415H76.1921V21.4855H88.0601V36.2975Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_45829_3620)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M12.2825 21.966H35.7162C36.3896 21.966 36.7487 21.6069 36.7487 20.9335V13.0325C36.7487 12.3591 36.3896 12 35.7162 12H30.7781C30.1047 12 29.7455 12.3591 29.7455 13.0325V17.0279H27.5009V13.0325C27.5009 12.3591 27.1418 12 26.4684 12H21.5303C20.8569 12 20.4978 12.3591 20.4978 13.0325V17.0279H18.2532V13.0325C18.2532 12.3591 17.894 12 17.2206 12H12.2825C11.6091 12 11.25 12.3591 11.25 13.0325V20.9335C11.25 21.6069 11.6091 21.966 12.2825 21.966ZM12.6865 28.8794C12.1927 27.4878 11.8785 26.0512 11.7887 24.3902C11.7438 23.8066 12.0132 23.4924 12.6417 23.4924H35.357C35.9855 23.4924 36.2549 23.7617 36.2549 24.3004C36.1651 25.9614 35.8509 27.4878 35.3122 28.8794C35.0428 29.5977 34.6388 29.9119 33.8756 29.9119H14.1231C13.3599 29.9119 12.9559 29.5977 12.6865 28.8794ZM33.4716 32.6055C31.3168 35.2541 27.7703 36.96 23.9994 36.96C20.2284 36.96 16.5922 35.2541 14.4822 32.6055C13.9435 31.8872 14.2129 31.4383 14.7516 31.4383H33.2471C33.7858 31.4383 34.0552 31.8872 33.4716 32.6055Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_45829_3620",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "25.4987",
                        height: "24.96",
                        fill: "white",
                        transform: "translate(11.25 12)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("hcxdE", function(module, exports) {
$parcel$export(module.exports, "GuardMarkBrandV3", function () { return $271e41cd8a251104$export$e444932b5137ba16; });

var $7VQPk = parcelRequire("7VQPk");
const $271e41cd8a251104$export$e444932b5137ba16 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12.5635C0 5.93606 5.37258 0.563477 12 0.563477H32C38.6274 0.563477 44 5.93606 44 12.5635V32.5635C44 39.1909 38.6274 44.5635 32 44.5635H12C5.37258 44.5635 0 39.1909 0 32.5635V12.5635Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.259 20.699H32.7398C33.3571 20.699 33.6863 20.3698 33.6863 19.7525V12.51C33.6863 11.8927 33.3571 11.5635 32.7398 11.5635H28.2132C27.596 11.5635 27.2667 11.8927 27.2667 12.51V16.1724H25.2092V12.51C25.2092 11.8927 24.88 11.5635 24.2627 11.5635H19.7361C19.1188 11.5635 18.7896 11.8927 18.7896 12.51V16.1724H16.7321V12.51C16.7321 11.8927 16.4029 11.5635 15.7856 11.5635H11.259C10.6417 11.5635 10.3125 11.8927 10.3125 12.51V19.7525C10.3125 20.3698 10.6417 20.699 11.259 20.699ZM11.6293 27.0363C11.1767 25.7606 10.8886 24.4438 10.8063 22.9212C10.7652 22.3862 11.0121 22.0982 11.5882 22.0982H32.4106C32.9867 22.0982 33.2337 22.3451 33.2337 22.8389C33.1513 24.3615 32.8633 25.7606 32.3695 27.0363C32.1226 27.6947 31.7522 27.9828 31.0526 27.9828H12.9462C12.2466 27.9828 11.8762 27.6947 11.6293 27.0363ZM30.6823 30.4518C28.707 32.8797 25.4561 34.4435 21.9994 34.4435C18.5427 34.4435 15.2095 32.8797 13.2754 30.4518C12.7816 29.7934 13.0285 29.3819 13.5223 29.3819H30.4765C30.9703 29.3819 31.2172 29.7934 30.6823 30.4518Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("ePJI2", function(module, exports) {
$parcel$export(module.exports, "JiraAlignMarkBrandV3", function () { return $98f47d98a37ddce8$export$5b06cd98ebdc05fe; });

var $7VQPk = parcelRequire("7VQPk");
const $98f47d98a37ddce8$export$5b06cd98ebdc05fe = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FB9700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.6022 35.6025C35.6022 31.2099 32.0083 27.6604 27.6602 27.6604H20.3393V20.9607H12.3972V34.1383C12.3972 35.1588 12.8409 35.6025 13.8614 35.6025H35.6022ZM12.3972 12.3975C12.3972 16.79 15.9024 20.3395 20.2949 20.3395H27.6602V27.0392H35.6022V13.8616C35.6022 12.8855 35.1142 12.3975 34.138 12.3975H12.3972Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("evhqU", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoBrandV3", function () { return $154c88a7ed8db6b4$export$cdfc30294145b7b; });

var $7VQPk = parcelRequire("7VQPk");
const $154c88a7ed8db6b4$export$cdfc30294145b7b = ({ width: width, height: height = '100%' })=>{
    const jiraProductDiscoveryTitleId = 'jiraProductDiscoveryTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 490 48",
        fill: "none",
        "aria-labelledby": jiraProductDiscoveryTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: jiraProductDiscoveryTitleId,
                children: "Jira Product Discovery"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M476.826 36.528H474.25L465.924 15H470.156L477.516 34.688L484.876 15H489.108L480.414 37.264C477.838 43.842 476.366 47.246 470.524 47.246C468.546 47.246 467.442 47.062 466.292 46.602V43.198C467.626 43.612 469.144 43.75 470.294 43.75C473.514 43.75 474.94 41.542 476.826 36.528Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M456.956 24.4296V37.9996H453.092V14.9996H456.956V19.0476C458.29 16.3336 460.59 14.4016 465.098 14.6776V18.5416C460.038 18.0356 456.956 19.5536 456.956 24.4296Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M438.26 18.128C434.074 18.128 431.958 20.842 431.544 24.844H444.378C444.148 20.566 442.216 18.128 438.26 18.128ZM447.092 37.08C445.206 38.092 442.308 38.46 439.962 38.46C431.36 38.46 427.588 33.492 427.588 26.454C427.588 19.508 431.452 14.54 438.444 14.54C445.528 14.54 448.38 19.462 448.38 26.454V28.248H431.59C432.142 32.158 434.672 34.688 440.1 34.688C442.768 34.688 445.022 34.182 447.092 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M417.517 38H412.227L403.303 15H407.443L414.895 34.642L422.301 15H426.441L417.517 38Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M391.324 38.46C384.424 38.46 380.375 33.354 380.375 26.454C380.375 19.554 384.424 14.54 391.324 14.54C398.178 14.54 402.18 19.554 402.18 26.454C402.18 33.354 398.178 38.46 391.324 38.46ZM391.324 18.22C386.402 18.22 384.24 22.084 384.24 26.454C384.24 30.824 386.402 34.78 391.324 34.78C396.2 34.78 398.315 30.824 398.315 26.454C398.315 22.084 396.2 18.22 391.324 18.22Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M377.24 33.86V37.402C375.86 38.138 373.744 38.46 371.628 38.46C363.44 38.46 359.622 33.492 359.622 26.454C359.622 19.508 363.44 14.54 371.628 14.54C373.698 14.54 375.308 14.816 377.102 15.644V19.324C375.63 18.634 374.066 18.22 371.904 18.22C365.924 18.22 363.486 21.992 363.486 26.454C363.486 30.916 365.97 34.688 371.996 34.688C374.342 34.688 375.814 34.366 377.24 33.86Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M356.432 31.744C356.432 35.562 353.948 38.46 347.784 38.46C344.334 38.46 341.528 37.678 339.78 36.758V32.572C341.758 33.722 345.07 34.826 347.968 34.826C351.004 34.826 352.568 33.584 352.568 31.79C352.568 30.042 351.234 29.03 346.864 27.972C341.758 26.73 339.596 24.752 339.596 20.98C339.596 16.978 342.678 14.54 347.922 14.54C350.912 14.54 353.626 15.276 355.328 16.196V20.29C352.568 18.91 350.314 18.174 347.876 18.174C344.978 18.174 343.414 19.186 343.414 20.98C343.414 22.59 344.518 23.602 348.75 24.614C353.856 25.856 356.432 27.742 356.432 31.744Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M329.898 8.92797C329.898 7.17997 331.048 6.16797 332.658 6.16797C334.268 6.16797 335.418 7.17997 335.418 8.92797C335.418 10.676 334.268 11.688 332.658 11.688C331.048 11.688 329.898 10.676 329.898 8.92797ZM330.634 38V15H334.59V38H330.634Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M311.516 11.7333H304.708V34.0433H311.746C318.646 34.0433 322.096 30.4093 322.096 23.0953C322.096 15.7353 318.83 11.7333 311.516 11.7333ZM300.568 37.9993V7.77734H311.7C321.498 7.77734 326.236 13.8953 326.236 22.9573C326.236 32.1113 321.452 37.9993 311.7 37.9993H300.568Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M280.45 30.87C280.45 32.894 281.646 34.274 284.084 34.274C285.004 34.274 285.878 34.09 286.568 33.952V37.77C285.878 37.954 285.096 38.138 283.9 38.138C278.978 38.138 276.586 35.24 276.586 30.962V18.68H272.86V15H276.586V10.124H280.45V15H286.568V18.68H280.45V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M270.46 33.86V37.402C269.08 38.138 266.964 38.46 264.848 38.46C256.66 38.46 252.842 33.492 252.842 26.454C252.842 19.508 256.66 14.54 264.848 14.54C266.918 14.54 268.528 14.816 270.322 15.644V19.324C268.85 18.634 267.286 18.22 265.124 18.22C259.144 18.22 256.706 21.992 256.706 26.454C256.706 30.916 259.19 34.688 265.216 34.688C267.562 34.688 269.034 34.366 270.46 33.86Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M228.696 28.478V15H232.652V28.892C232.652 33.032 234.308 34.872 238.08 34.872C241.76 34.872 244.29 32.434 244.29 27.788V15H248.246V38H244.29V34.228C242.818 36.942 240.104 38.46 237.022 38.46C231.732 38.46 228.696 34.826 228.696 28.478Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M206.216 26.4997C206.216 32.0197 208.424 34.7797 212.518 34.7797C216.06 34.7797 219.234 32.5257 219.234 27.4197V25.5797C219.234 20.4737 216.336 18.2197 212.978 18.2197C208.516 18.2197 206.216 21.1637 206.216 26.4997ZM219.234 37.9997V33.8597C217.762 36.8957 215.002 38.4597 211.46 38.4597C205.342 38.4597 202.26 33.2617 202.26 26.4997C202.26 20.0137 205.48 14.5397 211.92 14.5397C215.278 14.5397 217.854 16.0577 219.234 19.0477V5.38574H223.19V37.9997H219.234Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M188.187 38.46C181.287 38.46 177.239 33.354 177.239 26.454C177.239 19.554 181.287 14.54 188.187 14.54C195.041 14.54 199.043 19.554 199.043 26.454C199.043 33.354 195.041 38.46 188.187 38.46ZM188.187 18.22C183.265 18.22 181.103 22.084 181.103 26.454C181.103 30.824 183.265 34.78 188.187 34.78C193.063 34.78 195.179 30.824 195.179 26.454C195.179 22.084 193.063 18.22 188.187 18.22Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M167.524 24.4296V37.9996H163.66V14.9996H167.524V19.0476C168.858 16.3336 171.158 14.4016 175.666 14.6776V18.5416C170.606 18.0356 167.524 19.5536 167.524 24.4296Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M160.02 17.8513C160.02 24.4293 156.34 28.1093 148.796 28.1093H142.77V37.9993H138.63V7.77734H148.796C156.34 7.77734 160.02 11.6413 160.02 17.8513ZM148.336 24.1533C153.672 24.3373 155.742 21.8073 155.742 17.9433C155.742 14.2633 153.672 11.7333 148.336 11.7333H142.77V24.1533H148.336Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.535 26.5C106.535 32.02 108.743 34.78 112.837 34.78C116.379 34.78 119.553 32.526 119.553 27.42V25.58C119.553 20.474 116.655 18.22 113.297 18.22C108.835 18.22 106.535 21.164 106.535 26.5ZM119.553 38V33.86C118.081 36.896 115.321 38.46 111.779 38.46C105.661 38.46 102.579 33.262 102.579 26.5C102.579 20.014 105.799 14.54 112.239 14.54C115.597 14.54 118.173 16.058 119.553 19.048V15H123.509V38H119.553Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.8638 24.4296V37.9996H88.9998V14.9996H92.8638V19.0476C94.1978 16.3336 96.4978 14.4016 101.006 14.6776V18.5416C95.9458 18.0356 92.8638 19.5536 92.8638 24.4296Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M78.3359 8.92797C78.3359 7.17997 79.4859 6.16797 81.0959 6.16797C82.7059 6.16797 83.8559 7.17997 83.8559 8.92797C83.8559 10.676 82.7059 11.688 81.0959 11.688C79.4859 11.688 78.3359 10.676 78.3359 8.92797ZM79.0719 38V15H83.0279V38H79.0719Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M69.43 29.0753V7.77734H73.57V28.7993C73.57 34.3653 71.132 38.1833 65.428 38.1833C63.266 38.1833 61.61 37.8153 60.46 37.4013V33.3993C61.702 33.9053 63.22 34.1813 64.738 34.1813C68.234 34.1813 69.43 32.0653 69.43 29.0753Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#C97CF4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.1721 10.4519C29.9878 11.5712 33.8409 11.5712 37.6566 10.4519C37.9933 10.3773 38.2177 10.6011 38.1429 10.9369C37.0581 14.8546 37.0581 18.4738 38.1429 22.3915C38.2177 22.69 37.9933 22.9512 37.6566 22.8392C33.8409 21.7945 29.9878 21.7945 26.1721 22.8392C25.8728 22.9512 25.6109 22.69 25.7232 22.3915C26.7332 18.4738 26.7332 14.8546 25.7232 10.9369C25.6109 10.6011 25.8728 10.3773 26.1721 10.4519ZM27.7058 24.3317V24.966C27.7058 27.9136 25.6483 30.0776 23.1045 30.0776C20.5607 30.0776 18.5406 28.0255 18.5406 25.4883C18.5406 22.9512 20.5981 20.9364 23.4786 20.9364H24.2268V12.019C23.8527 11.9816 23.4786 11.9816 23.1045 11.9816C15.6227 11.9816 9.5625 18.0261 9.5625 25.5256C9.5625 33.0252 15.6227 39.0323 23.1045 39.0323C30.5863 39.0323 36.684 32.9879 36.684 25.5256V24.3317H27.7058Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("fPTok", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryMarkBrandV3", function () { return $ccec285077c0c873$export$adf1d54c8855db17; });

var $7VQPk = parcelRequire("7VQPk");
const $ccec285077c0c873$export$adf1d54c8855db17 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12.5635C0 5.93606 5.37258 0.563477 12 0.563477H32C38.6274 0.563477 44 5.93606 44 12.5635V32.5635C44 39.1909 38.6274 44.5635 32 44.5635H12C5.37258 44.5635 0 39.1909 0 32.5635V12.5635Z",
                fill: "#C97CF4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.9911 10.144C27.4888 11.1701 31.0208 11.1701 34.5185 10.144C34.8272 10.0756 35.0329 10.2808 34.9643 10.5887C33.9699 14.1799 33.9699 17.4975 34.9643 21.0887C35.0329 21.3623 34.8272 21.6017 34.5185 21.4991C31.0208 20.5415 27.4888 20.5415 23.9911 21.4991C23.7167 21.6017 23.4767 21.3623 23.5796 21.0887C24.5054 17.4975 24.5054 14.1799 23.5796 10.5887C23.4767 10.2808 23.7167 10.0756 23.9911 10.144ZM25.397 22.8672V23.4486C25.397 26.1506 23.511 28.1343 21.1792 28.1343C18.8473 28.1343 16.9956 26.2532 16.9956 23.9275C16.9956 21.6017 18.8816 19.7548 21.5221 19.7548H22.2079V11.5805C21.865 11.5463 21.5221 11.5463 21.1792 11.5463C14.3208 11.5463 8.76562 17.0871 8.76562 23.9617C8.76562 30.8363 14.3208 36.3428 21.1792 36.3428C28.0375 36.3428 33.627 30.8021 33.627 23.9617V22.8672H25.397Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("abOrE", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoBrandV3", function () { return $63d803679be5603b$export$9ff9d3dedd48b81d; });

var $7VQPk = parcelRequire("7VQPk");
const $63d803679be5603b$export$9ff9d3dedd48b81d = ({ width: width, height: height = '100%' })=>{
    const jiraServiceManagementTitleId = 'jiraServiceManagementTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 557 48",
        fill: "none",
        "aria-labelledby": jiraServiceManagementTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: jiraServiceManagementTitleId,
                children: "Jira Service Management"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M550.611 30.87C550.611 32.894 551.807 34.274 554.245 34.274C555.165 34.274 556.039 34.09 556.729 33.952V37.77C556.039 37.954 555.257 38.138 554.061 38.138C549.139 38.138 546.747 35.24 546.747 30.962V18.68H543.021V15H546.747V10.124H550.611V15H556.729V18.68H550.611V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M539.62 24.522V38H535.664V24.108C535.664 19.968 534.008 18.128 530.236 18.128C526.556 18.128 524.026 20.566 524.026 25.212V38H520.07V15H524.026V18.772C525.498 16.058 528.212 14.54 531.294 14.54C536.584 14.54 539.62 18.174 539.62 24.522Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M505.239 18.128C501.053 18.128 498.937 20.842 498.523 24.844H511.357C511.127 20.566 509.195 18.128 505.239 18.128ZM514.071 37.08C512.185 38.092 509.287 38.46 506.941 38.46C498.339 38.46 494.567 33.492 494.567 26.454C494.567 19.508 498.431 14.54 505.423 14.54C512.507 14.54 515.359 19.462 515.359 26.454V28.248H498.569C499.121 32.158 501.651 34.688 507.079 34.688C509.747 34.688 512.001 34.182 514.071 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M474.843 25.212V38H470.887V24.108C470.887 19.968 469.231 18.128 465.459 18.128C461.779 18.128 459.249 20.566 459.249 25.212V38H455.293V15H459.249V18.772C460.721 16.058 463.435 14.54 466.517 14.54C470.427 14.54 473.095 16.518 474.245 20.152C475.533 16.61 478.615 14.54 482.433 14.54C487.585 14.54 490.437 18.036 490.437 24.522V38H486.481V25.212C486.481 20.474 484.825 18.128 481.053 18.128C477.373 18.128 474.843 20.566 474.843 25.212Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M440.462 18.128C436.276 18.128 434.16 20.842 433.746 24.844H446.58C446.35 20.566 444.418 18.128 440.462 18.128ZM449.294 37.08C447.408 38.092 444.51 38.46 442.164 38.46C433.562 38.46 429.79 33.492 429.79 26.454C429.79 19.508 433.654 14.54 440.646 14.54C447.73 14.54 450.582 19.462 450.582 26.454V28.248H433.792C434.344 32.158 436.874 34.688 442.302 34.688C444.97 34.688 447.224 34.182 449.294 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M421.336 36.16V33.86C419.864 36.896 417.104 38.46 413.562 38.46C407.49 38.46 404.454 33.262 404.454 26.5C404.454 20.014 407.628 14.54 414.022 14.54C417.38 14.54 419.956 16.058 421.336 19.048V15H425.2V35.93C425.2 42.692 422.026 47.246 413.792 47.246C409.928 47.246 407.812 46.74 405.604 46.004V42.14C408.134 42.968 410.756 43.52 413.608 43.52C419.358 43.52 421.336 40.438 421.336 36.16ZM408.318 26.5C408.318 32.02 410.526 34.78 414.62 34.78C418.162 34.78 421.336 32.526 421.336 27.42V25.58C421.336 20.474 418.438 18.22 415.08 18.22C410.618 18.22 408.318 21.164 408.318 26.5Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M382.894 26.5C382.894 32.02 385.102 34.78 389.196 34.78C392.738 34.78 395.912 32.526 395.912 27.42V25.58C395.912 20.474 393.014 18.22 389.656 18.22C385.194 18.22 382.894 21.164 382.894 26.5ZM395.912 38V33.86C394.44 36.896 391.68 38.46 388.138 38.46C382.02 38.46 378.938 33.262 378.938 26.5C378.938 20.014 382.158 14.54 388.598 14.54C391.956 14.54 394.532 16.058 395.912 19.048V15H399.868V38H395.912Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M374.802 24.522V38H370.846V24.108C370.846 19.968 369.19 18.128 365.418 18.128C361.738 18.128 359.208 20.566 359.208 25.212V38H355.252V15H359.208V18.772C360.68 16.058 363.394 14.54 366.476 14.54C371.766 14.54 374.802 18.174 374.802 24.522Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M332.312 26.5C332.312 32.02 334.52 34.78 338.614 34.78C342.156 34.78 345.33 32.526 345.33 27.42V25.58C345.33 20.474 342.432 18.22 339.074 18.22C334.612 18.22 332.312 21.164 332.312 26.5ZM345.33 38V33.86C343.858 36.896 341.098 38.46 337.556 38.46C331.438 38.46 328.356 33.262 328.356 26.5C328.356 20.014 331.576 14.54 338.016 14.54C341.374 14.54 343.95 16.058 345.33 19.048V15H349.286V38H345.33Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M298.162 21.4858L294.022 10.2618V37.9998H289.882V7.77783H297.058L303.912 25.1198L306.718 33.4458L309.524 25.1198L316.424 7.77783H323.094V37.9998H318.954V10.5838L315.412 21.4858L308.742 37.9998H304.74L298.162 21.4858Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M265.895 18.128C261.709 18.128 259.593 20.842 259.179 24.844H272.013C271.783 20.566 269.851 18.128 265.895 18.128ZM274.727 37.08C272.841 38.092 269.943 38.46 267.597 38.46C258.995 38.46 255.223 33.492 255.223 26.454C255.223 19.508 259.087 14.54 266.079 14.54C273.163 14.54 276.015 19.462 276.015 26.454V28.248H259.225C259.777 32.158 262.307 34.688 267.735 34.688C270.403 34.688 272.657 34.182 274.727 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M252.087 33.86V37.402C250.707 38.138 248.591 38.46 246.475 38.46C238.287 38.46 234.469 33.492 234.469 26.454C234.469 19.508 238.287 14.54 246.475 14.54C248.545 14.54 250.155 14.816 251.949 15.644V19.324C250.477 18.634 248.913 18.22 246.751 18.22C240.771 18.22 238.333 21.992 238.333 26.454C238.333 30.916 240.817 34.688 246.843 34.688C249.189 34.688 250.661 34.366 252.087 33.86Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M225.186 8.92797C225.186 7.17997 226.336 6.16797 227.946 6.16797C229.556 6.16797 230.706 7.17997 230.706 8.92797C230.706 10.676 229.556 11.688 227.946 11.688C226.336 11.688 225.186 10.676 225.186 8.92797ZM225.922 38V15H229.878V38H225.922Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M213.571 38H208.281L199.357 15H203.497L210.949 34.642L218.355 15H222.495L213.571 38Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.389 24.4301V38.0001H186.525V15.0001H190.389V19.0481C191.723 16.3341 194.023 14.4021 198.531 14.6781V18.5421C193.471 18.0361 190.389 19.5541 190.389 24.4301Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M171.694 18.128C167.508 18.128 165.392 20.842 164.978 24.844H177.812C177.582 20.566 175.65 18.128 171.694 18.128ZM180.526 37.08C178.64 38.092 175.742 38.46 173.396 38.46C164.794 38.46 161.022 33.492 161.022 26.454C161.022 19.508 164.886 14.54 171.878 14.54C178.962 14.54 181.814 19.462 181.814 26.454V28.248H165.024C165.576 32.158 168.106 34.688 173.534 34.688C176.202 34.688 178.456 34.182 180.526 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M157.536 29.6739C157.536 34.9179 154.408 38.4599 146.91 38.4599C141.068 38.4599 138.354 37.3099 136.008 36.1139V31.8819C138.814 33.3539 143.138 34.4119 147.14 34.4119C151.694 34.4119 153.396 32.6179 153.396 29.9499C153.396 27.2819 151.74 25.8559 145.99 24.4759C139.182 22.8199 136.146 20.4739 136.146 15.5059C136.146 10.8139 139.734 7.31787 146.772 7.31787C151.142 7.31787 153.948 8.37587 156.018 9.52587V13.6659C152.982 11.9179 149.716 11.3659 146.588 11.3659C142.632 11.3659 140.286 12.7459 140.286 15.5059C140.286 17.9899 142.218 19.2319 147.554 20.5659C153.948 22.1759 157.536 24.2459 157.536 29.6739Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.535 26.5C106.535 32.02 108.743 34.78 112.837 34.78C116.379 34.78 119.553 32.526 119.553 27.42V25.58C119.553 20.474 116.655 18.22 113.297 18.22C108.835 18.22 106.535 21.164 106.535 26.5ZM119.553 38V33.86C118.081 36.896 115.321 38.46 111.779 38.46C105.661 38.46 102.579 33.262 102.579 26.5C102.579 20.014 105.799 14.54 112.239 14.54C115.597 14.54 118.173 16.058 119.553 19.048V15H123.509V38H119.553Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.8638 24.4301V38.0001H88.9998V15.0001H92.8638V19.0481C94.1978 16.3341 96.4978 14.4021 101.006 14.6781V18.5421C95.9458 18.0361 92.8638 19.5541 92.8638 24.4301Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M78.3359 8.92797C78.3359 7.17997 79.4859 6.16797 81.0959 6.16797C82.7059 6.16797 83.8559 7.17997 83.8559 8.92797C83.8559 10.676 82.7059 11.688 81.0959 11.688C79.4859 11.688 78.3359 10.676 78.3359 8.92797ZM79.0719 38V15H83.0279V38H79.0719Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M69.43 29.0758V7.77783H73.57V28.7998C73.57 34.3658 71.132 38.1838 65.428 38.1838C63.266 38.1838 61.61 37.8158 60.46 37.4018V33.3998C61.702 33.9058 63.22 34.1818 64.738 34.1818C68.234 34.1818 69.43 32.0658 69.43 29.0758Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FFC716"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.4014 20.4052H36.328C37.6686 20.4052 38.1264 21.6804 37.3089 22.694L23.3468 39.926C18.8344 36.3292 19.2595 30.6397 22.562 26.487L27.4014 20.4052ZM20.502 27.2718H11.5754C10.2348 27.2718 9.77703 25.9966 10.5945 24.9829L24.5566 7.75098C29.069 11.3478 28.5785 16.9719 25.3087 21.1572L20.502 27.2718Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("lDqnU", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementMarkBrandV3", function () { return $0d58b7b5cec2e58a$export$3d5b3b451f165ab6; });

var $7VQPk = parcelRequire("7VQPk");
const $0d58b7b5cec2e58a$export$3d5b3b451f165ab6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12.5635C0 5.93606 5.37258 0.563477 12 0.563477H32C38.6274 0.563477 44 5.93606 44 12.5635V32.5635C44 39.1909 38.6274 44.5635 32 44.5635H12C5.37258 44.5635 0 39.1909 0 32.5635V12.5635Z",
                fill: "#FFC716"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1173 19.2676H33.3C34.5289 19.2676 34.9485 20.4366 34.1992 21.3658L21.4006 37.1617C17.2642 33.8647 17.6539 28.6493 20.6812 24.8427L25.1173 19.2676ZM18.7929 25.562H10.6102C9.38126 25.562 8.96163 24.3931 9.71096 23.4639L22.5096 7.66797C26.6459 10.965 26.1963 16.1204 23.199 19.957L18.7929 25.562Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("ld6VA", function(module, exports) {
$parcel$export(module.exports, "JiraLogoBrandV3", function () { return $ef1c03635cd27e87$export$ae8a09e8a2773f0f; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $ef1c03635cd27e87$export$ae8a09e8a2773f0f = ({ width: width, height: height = '100%', lightMode: lightMode = false })=>{
    const jiraTitleId = 'jiraTitle';
    const textFill = lightMode ? (0, $bNzAT.default)('color.neutral.light0') : (0, $bNzAT.default)('color.primary.black');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 124 48",
        fill: "none",
        "aria-labelledby": jiraTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: jiraTitleId,
                children: "Jira"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.535 26.5C106.535 32.02 108.743 34.78 112.837 34.78C116.379 34.78 119.553 32.526 119.553 27.42V25.58C119.553 20.474 116.655 18.22 113.297 18.22C108.835 18.22 106.535 21.164 106.535 26.5ZM119.553 38V33.86C118.081 36.896 115.321 38.46 111.779 38.46C105.661 38.46 102.579 33.262 102.579 26.5C102.579 20.014 105.799 14.54 112.239 14.54C115.597 14.54 118.173 16.058 119.553 19.048V15H123.509V38H119.553Z",
                fill: textFill
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.8638 24.4301V38.0001H88.9998V15.0001H92.8638V19.0481C94.1978 16.3341 96.4978 14.4021 101.006 14.6781V18.5421C95.9458 18.0361 92.8638 19.5541 92.8638 24.4301Z",
                fill: textFill
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M78.3359 8.92797C78.3359 7.17997 79.4859 6.16797 81.0959 6.16797C82.7059 6.16797 83.8559 7.17997 83.8559 8.92797C83.8559 10.676 82.7059 11.688 81.0959 11.688C79.4859 11.688 78.3359 10.676 78.3359 8.92797ZM79.0719 38V15H83.0279V38H79.0719Z",
                fill: textFill
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M69.43 29.0758V7.77783H73.57V28.7998C73.57 34.3658 71.132 38.1838 65.428 38.1838C63.266 38.1838 61.61 37.8158 60.46 37.4018V33.3998C61.702 33.9058 63.22 34.1818 64.738 34.1818C68.234 34.1818 69.43 32.0658 69.43 29.0758Z",
                fill: textFill
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: (0, $bNzAT.default)('color.primary.blue')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.9475 31.0469H15.2429C11.1638 31.0469 8.23755 28.5484 8.23755 24.8899H22.7804C23.5341 24.8899 24.0218 25.4252 24.0218 26.1837V40.8178C20.3861 40.8178 17.9475 37.8731 17.9475 33.7684V31.0469ZM25.1303 23.7745H22.4257C18.3466 23.7745 15.4203 21.3206 15.4203 17.6621H29.9631C30.7168 17.6621 31.2489 18.1528 31.2489 18.9113V33.5454C27.6132 33.5454 25.1303 30.6007 25.1303 26.496V23.7745ZM32.3573 16.5467H29.6527C25.5736 16.5467 22.6473 14.0482 22.6473 10.3896H37.1902C37.9439 10.3896 38.4316 10.925 38.4316 11.6389V26.273C34.7959 26.273 32.3573 23.3283 32.3573 19.2236V16.5467Z",
                fill: (0, $bNzAT.default)('color.neutral.light0')
            })
        ]
    });
};

});

parcelRegister("dRHrS", function(module, exports) {
$parcel$export(module.exports, "JiraMarkBrandV3", function () { return $981f76218c77b5e0$export$6e3456f7850bfdc0; });

var $7VQPk = parcelRequire("7VQPk");
const $981f76218c77b5e0$export$6e3456f7850bfdc0 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 11.5635C0 5.48834 4.92487 0.563477 11 0.563477H33C39.0751 0.563477 44 5.48834 44 11.5635V33.5635C44 39.6386 39.0751 44.5635 33 44.5635H11C4.92487 44.5635 0 39.6386 0 33.5635V11.5635Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.4516 29.0237H13.9724C10.2332 29.0237 7.55078 26.7334 7.55078 23.3797H20.8817C21.5726 23.3797 22.0197 23.8705 22.0197 24.5658V37.9803C18.687 37.9803 16.4516 35.2811 16.4516 31.5185V29.0237ZM23.0358 22.3573H20.5565C16.8174 22.3573 14.1349 20.1079 14.1349 16.7543H27.4659C28.1568 16.7543 28.6445 17.2041 28.6445 17.8994V31.314C25.3118 31.314 23.0358 28.6147 23.0358 24.8521V22.3573ZM29.6606 15.7318H27.1814C23.4422 15.7318 20.7598 13.4415 20.7598 10.0879H34.0907C34.7816 10.0879 35.2287 10.5787 35.2287 11.233V24.6476C31.8959 24.6476 29.6606 21.9483 29.6606 18.1857V15.7318Z",
                fill: "white"
            })
        ]
    });

});

parcelRegister("jKMT0", function(module, exports) {
$parcel$export(module.exports, "LoomCharlieLogoBrandV3", function () { return $a5752ef96a9fe0e7$export$7a44bf4efe2beb83; });

var $7VQPk = parcelRequire("7VQPk");
const $a5752ef96a9fe0e7$export$7a44bf4efe2beb83 = ({ width: width, height: height = '100%' })=>{
    const loomTitleId = 'loomTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 170 48",
        fill: "none",
        "aria-labelledby": loomTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: loomTitleId,
                children: "Loom"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M154.37 25.212V38H150.414V24.108C150.414 19.968 148.758 18.128 144.986 18.128C141.306 18.128 138.776 20.566 138.776 25.212V38H134.82V15H138.776V18.772C140.248 16.058 142.962 14.54 146.044 14.54C149.954 14.54 152.622 16.518 153.772 20.152C155.06 16.61 158.142 14.54 161.96 14.54C167.112 14.54 169.964 18.036 169.964 24.522V38H166.008V25.212C166.008 20.474 164.352 18.128 160.58 18.128C156.9 18.128 154.37 20.566 154.37 25.212Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M119.367 38.46C112.467 38.46 108.419 33.354 108.419 26.454C108.419 19.554 112.467 14.54 119.367 14.54C126.221 14.54 130.223 19.554 130.223 26.454C130.223 33.354 126.221 38.46 119.367 38.46ZM119.367 18.22C114.445 18.22 112.283 22.084 112.283 26.454C112.283 30.824 114.445 34.78 119.367 34.78C124.243 34.78 126.359 30.824 126.359 26.454C126.359 22.084 124.243 18.22 119.367 18.22Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M94.3452 38.46C87.4452 38.46 83.3972 33.354 83.3972 26.454C83.3972 19.554 87.4452 14.54 94.3452 14.54C101.199 14.54 105.201 19.554 105.201 26.454C105.201 33.354 101.199 38.46 94.3452 38.46ZM94.3452 18.22C89.4232 18.22 87.2612 22.084 87.2612 26.454C87.2612 30.824 89.4232 34.78 94.3452 34.78C99.2212 34.78 101.337 30.824 101.337 26.454C101.337 22.084 99.2212 18.22 94.3452 18.22Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.094 7.77783H68.234V34.0438H81.942V37.9998H64.094V7.77783Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.0625 22.9644H29.9846L36.9804 18.9253L35.4441 16.2635L28.4482 20.3026L32.4864 13.3073L29.8246 11.77L25.7864 18.7653V10.688H22.7136V18.7661L18.6738 11.77L16.0129 13.3065L20.0518 20.3018L13.0559 16.2635L11.5195 18.9246L18.5154 22.9636H10.4375V26.0366H18.5146L11.5195 30.0757L13.0559 32.7375L20.0511 28.6991L16.0121 35.6945L18.6738 37.2309L22.7128 30.2349V38.313H25.7857V30.2356L29.8239 37.2309L32.4855 35.6945L28.4466 28.6984L35.4425 32.7375L36.979 30.0757L29.9838 26.0373H38.0609V22.9644H38.0625ZM24.25 28.6798C21.933 28.6798 20.0549 26.8018 20.0549 24.4847C20.0549 22.1676 21.933 20.2895 24.25 20.2895C26.567 20.2895 28.445 22.1676 28.445 24.4847C28.445 26.8018 26.567 28.6798 24.25 28.6798Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("iOOjr", function(module, exports) {
$parcel$export(module.exports, "LoomCircularLogoBrandV3", function () { return $a0b1e955509ad54d$export$fe0a531973916f9; });

var $7VQPk = parcelRequire("7VQPk");
const $a0b1e955509ad54d$export$fe0a531973916f9 = ({ width: width, height: height = '100%' })=>{
    const loomCircularTitleId = 'loomCircularTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 154 48",
        fill: "none",
        "aria-labelledby": loomCircularTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: loomCircularTitleId,
                children: "Loom"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.0625 22.9639H29.9846L36.9804 18.9248L35.4441 16.2631L28.4482 20.3021L32.4864 13.3068L29.8246 11.7695L25.7864 18.7649V10.6875H22.7136V18.7656L18.6738 11.7695L16.0129 13.306L20.0518 20.3013L13.0559 16.2631L11.5195 18.9241L18.5154 22.9631H10.4375V26.0361H18.5146L11.5195 30.0752L13.0559 32.737L20.0511 28.6987L16.0121 35.694L18.6738 37.2304L22.7128 30.2344V38.3125H25.7857V30.2351L29.8239 37.2304L32.4855 35.694L28.4466 28.6979L35.4425 32.737L36.979 30.0752L29.9838 26.0368H38.0609V22.9639H38.0625ZM24.25 28.6793C21.933 28.6793 20.0549 26.8013 20.0549 24.4842C20.0549 22.1671 21.933 20.289 24.25 20.289C26.567 20.289 28.445 22.1671 28.445 24.4842C28.445 26.8013 26.567 28.6793 24.25 28.6793Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64 38.0138V5.89941H69.8961V38.0138H64Z",
                fill: "#252434"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M120.551 16.1901H126.181V18.8525C127.378 16.7236 130.172 15.5693 132.565 15.5693C135.537 15.5693 137.93 16.8563 139.038 19.2064C140.766 16.544 143.074 15.5693 145.955 15.5693C149.989 15.5693 153.846 18.0093 153.846 23.8636V38.0138H148.127V25.0622C148.127 22.7108 146.974 20.9371 144.269 20.9371C141.741 20.9371 140.234 22.8891 140.234 25.2405V38.0152H134.383V25.0622C134.383 22.7108 133.187 20.9371 130.525 20.9371C127.953 20.9371 126.445 22.8448 126.445 25.2405V38.0152H120.551V16.1901Z",
                fill: "#252434"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.2203 38.6469C76.578 38.6469 71.7681 33.7203 71.7681 27.1032C71.7681 20.5916 76.5625 15.5479 83.2203 15.5479C89.9105 15.5479 94.6725 20.6385 94.6725 27.1032C94.6725 33.6721 89.8598 38.6469 83.2203 38.6469ZM83.2203 20.8896C79.7944 20.8896 77.0077 23.6769 77.0077 27.1046C77.0077 30.5321 79.7944 33.3195 83.2203 33.3195C86.6462 33.3195 89.4315 30.5321 89.4315 27.1046C89.4315 23.6769 86.6462 20.8896 83.2203 20.8896Z",
                fill: "#252434"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M107.267 38.6469C100.624 38.6469 95.8145 33.7203 95.8145 27.1032C95.8145 20.5916 100.609 15.5479 107.267 15.5479C113.957 15.5479 118.719 20.6385 118.719 27.1032C118.719 33.6721 113.904 38.6469 107.267 38.6469ZM107.267 20.8154C103.802 20.8154 100.983 23.6366 100.983 27.1018C100.983 30.5673 103.802 33.3885 107.267 33.3885C110.731 33.3885 113.551 30.5673 113.551 27.1018C113.549 23.6366 110.73 20.8154 107.267 20.8154Z",
                fill: "#252434"
            })
        ]
    });
};

});

parcelRegister("kvHRV", function(module, exports) {
$parcel$export(module.exports, "LoomMarkBrandV3", function () { return $60fdcd4b22aa4763$export$e4edd66f5e2db524; });

var $7VQPk = parcelRequire("7VQPk");
const $60fdcd4b22aa4763$export$e4edd66f5e2db524 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12.5635C0 5.93606 5.37258 0.563477 12 0.563477H32C38.6274 0.563477 44 5.93606 44 12.5635V32.5635C44 39.1909 38.6274 44.5635 32 44.5635H12C5.37258 44.5635 0 39.1909 0 32.5635V12.5635Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.8893 21.6137H27.4845L33.8974 17.9112L32.4891 15.4713L26.0762 19.1738L29.7779 12.7614L27.3379 11.3522L23.6362 17.7646V10.3604H20.8195V17.7653L17.1164 11.3522L14.6772 12.7607L18.3796 19.173L11.9666 15.4713L10.5582 17.9105L16.9712 21.613H9.56641V24.4299H16.9704L10.5582 28.1324L11.9666 30.5724L18.3788 26.8706L14.6765 33.2829L17.1164 34.6914L20.8188 28.2783V35.6833H23.6356V28.279L27.3372 34.6914L29.7771 33.2829L26.0748 26.8699L32.4877 30.5724L33.8961 28.1324L27.4839 24.4306H34.8879V21.6137H34.8893ZM22.2279 26.8528C20.1039 26.8528 18.3824 25.1313 18.3824 23.0073C18.3824 20.8833 20.1039 19.1617 22.2279 19.1617C24.3518 19.1617 26.0733 20.8833 26.0733 23.0073C26.0733 25.1313 24.3518 26.8528 22.2279 26.8528Z",
                fill: "white"
            })
        ]
    });

});

parcelRegister("5xMyM", function(module, exports) {
$parcel$export(module.exports, "OpsgenieMarkBrandV3", function () { return $90460ed635587a46$export$25d076a038ad6c06; });

var $7VQPk = parcelRequire("7VQPk");
const $90460ed635587a46$export$25d076a038ad6c06 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FFC716"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.3573 38.5272C24.4006 39.2322 23.897 39.1818 22.9403 38.4768C18.3076 35.1534 14.0274 31.3768 11.1572 27.4491C10.8551 27.0462 11.0061 26.4923 11.4593 26.2405L16.6962 22.9675C17.1494 22.6653 17.5523 22.7157 17.9048 23.1185C19.919 25.4349 21.8828 27.7008 24.1488 29.3122C26.4148 27.7008 28.3786 25.4349 30.3928 23.1185C30.7453 22.7157 31.1482 22.6653 31.6014 22.9675L36.8383 26.2405C37.2915 26.4923 37.4426 27.0462 37.1404 27.4491C34.2702 31.3768 29.99 35.1534 25.3573 38.5272ZM24.1488 24.0753C28.2779 24.0753 31.7021 20.7015 31.7021 16.5724C31.7021 12.4433 28.2779 8.96875 24.1488 8.96875C20.0197 8.96875 16.5955 12.3929 16.5955 16.5724C16.5955 20.7518 19.919 24.0753 24.1488 24.0753Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("4dGNW", function(module, exports) {
$parcel$export(module.exports, "PipelinesMarkBrandV3", function () { return $5974971ae6353fc2$export$a9b209956951d051; });

var $7VQPk = parcelRequire("7VQPk");
const $5974971ae6353fc2$export$a9b209956951d051 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.6334 28.5624C32.6618 31.2075 27.9965 31.6036 24.6746 28.6376L28.0145 25.1796C29.3553 26.1447 31.0751 26.0106 32.2926 25.1035L35.6334 28.5624Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.8441 27.2376C19.0033 28.9246 17.1906 30.4628 14.6172 30.6804V25.7722C15.9182 25.506 16.8335 24.4303 17.7862 23.5575L20.8441 27.2376Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.2487 21.3106C10.2217 21.4719 10.2013 21.638 10.1932 21.8092C10.1009 23.7619 11.3426 25.2246 12.8806 25.6871V30.6375C8.83287 30.0966 5.27686 26.5277 5.51141 21.5711C5.58303 20.0613 5.99133 18.7171 6.63934 17.5732L10.2487 21.3106Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.6934 21.4789L24.6916 21.4807L26.7827 23.9111L23.4625 27.3486L19.3062 22.5209L19.308 22.5182L17.5588 20.4861L20.879 17.0477L24.6934 21.4789Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.1226 13.3623C35.1689 13.9045 38.7234 17.4734 38.489 22.4287C38.3995 24.3191 37.7808 25.9499 36.8258 27.2528L33.4232 23.7294C33.6408 23.2759 33.7793 22.7604 33.8063 22.1905C33.8984 20.2391 32.6592 18.776 31.1226 18.3126V13.3623Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.385 18.2267C28.0846 18.4915 27.1684 19.5679 26.2161 20.4396L23.1232 16.7908C24.9759 15.0947 26.7947 13.5366 29.385 13.3184V18.2267Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.68671 16.114C10.6853 12.761 16.1091 12.1108 19.7036 15.7202L16.3852 19.1568C14.7413 17.5888 12.2894 17.9671 11.0186 19.5632L7.68671 16.114Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("j5JD4", function(module, exports) {
$parcel$export(module.exports, "RovoDevLogoBrandV3", function () { return $51c393c425bb605d$export$bbb45aadb6938a35; });

var $7VQPk = parcelRequire("7VQPk");
const $51c393c425bb605d$export$bbb45aadb6938a35 = ()=>{
    const rovoDevTitleId = 'rovoDevTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "247",
        height: "55",
        viewBox: "0 0 247 55",
        fill: "none",
        "aria-labelledby": rovoDevTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: rovoDevTitleId,
                children: "Rovo Dev"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M237.194 42.002H231.904L222.98 19.002H227.12L234.572 38.644L241.978 19.002H246.118L237.194 42.002Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M210.725 22.13C206.539 22.13 204.423 24.844 204.009 28.846H216.843C216.613 24.568 214.681 22.13 210.725 22.13ZM219.557 41.082C217.671 42.094 214.773 42.462 212.427 42.462C203.825 42.462 200.053 37.494 200.053 30.456C200.053 23.51 203.917 18.542 210.909 18.542C217.993 18.542 220.845 23.464 220.845 30.456V32.25H204.055C204.607 36.16 207.137 38.69 212.565 38.69C215.233 38.69 217.487 38.184 219.557 37.448V41.082Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M181.866 15.7363H175.058V38.0463H182.096C188.996 38.0463 192.446 34.4123 192.446 27.0983C192.446 19.7383 189.18 15.7363 181.866 15.7363ZM170.918 42.0023V11.7803H182.05C191.848 11.7803 196.586 17.8983 196.586 26.9603C196.586 36.1143 191.802 42.0023 182.05 42.0023H170.918Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M146.538 42.462C139.638 42.462 135.59 37.356 135.59 30.456C135.59 23.556 139.638 18.542 146.538 18.542C153.392 18.542 157.394 23.556 157.394 30.456C157.394 37.356 153.392 42.462 146.538 42.462ZM146.538 22.222C141.616 22.222 139.454 26.086 139.454 30.456C139.454 34.826 141.616 38.782 146.538 38.782C151.414 38.782 153.53 34.826 153.53 30.456C153.53 26.086 151.414 22.222 146.538 22.222Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M125.519 42.002H120.229L111.305 19.002H115.445L122.897 38.644L130.303 19.002H134.443L125.519 42.002Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M99.325 42.462C92.425 42.462 88.377 37.356 88.377 30.456C88.377 23.556 92.425 18.542 99.325 18.542C106.179 18.542 110.181 23.556 110.181 30.456C110.181 37.356 106.179 42.462 99.325 42.462ZM99.325 22.222C94.403 22.222 92.241 26.086 92.241 30.456C92.241 34.826 94.403 38.782 99.325 38.782C104.201 38.782 106.317 34.826 106.317 30.456C106.317 26.086 104.201 22.222 99.325 22.222Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.7725 15.7363H67.7005V26.7763H73.7725C79.1545 26.7763 80.8105 24.7063 80.8105 21.2563C80.8105 17.9903 79.1085 15.7363 73.7725 15.7363ZM84.9505 21.1643C84.9505 25.7183 83.0185 28.8003 79.0165 30.0883L86.4225 42.0023H81.5465L74.8765 30.7323C74.6925 30.7323 74.4625 30.7323 74.2325 30.7323H67.7005V42.0023H63.5605V11.7803H74.2325C81.4545 11.7803 84.9505 15.3683 84.9505 21.1643Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.519 0.843677C23.4682 -0.281225 25.8698 -0.281226 27.819 0.843676L46.189 11.445C48.1382 12.5699 49.339 14.6488 49.339 16.8986V38.1014C49.339 40.3512 48.1382 42.4301 46.189 43.555L27.819 54.1563C25.8698 55.2812 23.4683 55.2812 21.519 54.1563L3.14902 43.555C1.1998 42.4301 -0.000976562 40.3512 -0.000976562 38.1014V16.8986C-0.000976562 14.6488 1.1998 12.5699 3.14902 11.445L21.519 0.843677Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.3318 13.9697L12.5293 18.4735C11.4398 19.0997 10.7715 20.2571 10.7715 21.5144V33.4974C10.7715 34.7498 11.4437 35.9122 12.5301 36.5388L14.38 37.6066L22.9098 42.5303C23.9767 43.1456 25.2896 43.1566 26.3652 42.563C26.3847 42.5479 26.4054 42.5339 26.4274 42.5213C27.1938 42.0792 27.7543 41.3703 28.0178 40.5513C28.1251 40.2128 28.1818 39.8551 28.1818 39.4889V34.8472L23.6669 32.2422L22.3659 31.4916C20.9377 30.6703 20.0613 29.152 20.0613 27.5059V15.5229C20.0613 15.0387 20.1379 14.5649 20.2823 14.1165C20.298 14.0672 20.3145 14.0183 20.3318 13.9697Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.4285 12.47C25.3616 11.8546 24.0488 11.8437 22.9731 12.4373C22.9537 12.4524 22.9305 12.4678 22.9085 12.4805C22.1429 12.9228 21.5833 13.6315 21.3202 14.4501C21.2132 14.7883 21.1566 15.1456 21.1566 15.5114V20.1531L25.5317 22.6774L26.9728 23.5089C28.4013 24.3301 29.277 25.8482 29.277 27.4944V39.4774C29.277 39.9623 29.2003 40.4367 29.0554 40.8857C29.0399 40.9343 29.0236 40.9826 29.0066 41.0306L36.809 36.5268C37.8986 35.9005 38.5669 34.7432 38.5669 33.4859V21.5029C38.5669 20.2505 37.8945 19.088 36.8082 18.4614L34.8186 17.313L26.4285 12.47Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("bkJxb", function(module, exports) {
$parcel$export(module.exports, "RovoDevMarkBrandV3", function () { return $f1b4075f64c770b0$export$3915b11fcae6bd6; });

var $7VQPk = parcelRequire("7VQPk");
const $f1b4075f64c770b0$export$3915b11fcae6bd6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "40",
        height: "44",
        viewBox: "0 0 40 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.6152 0.674942C19.1746 -0.22498 21.0958 -0.224981 22.6552 0.67494L37.3512 9.15602C38.9106 10.0559 39.8712 11.7191 39.8712 13.5189V30.4811C39.8712 32.2809 38.9106 33.944 37.3512 34.844L22.6552 43.3251C21.0958 44.225 19.1746 44.225 17.6152 43.3251L2.9192 34.844C1.35982 33.944 0.3992 32.2809 0.3992 30.4811V13.5189C0.3992 11.7191 1.35982 10.0559 2.9192 9.15603L17.6152 0.674942Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.6654 11.1758L10.4234 14.7788C9.5518 15.2798 9.01715 16.2057 9.01715 17.2115V26.7979C9.01715 27.7998 9.55496 28.7298 10.424 29.231L11.904 30.0853L18.7278 34.0242C19.5813 34.5165 20.6317 34.5253 21.4921 34.0504C21.5077 34.0383 21.5243 34.0271 21.5419 34.017C22.155 33.6633 22.6034 33.0962 22.8142 32.4411C22.9 32.1702 22.9454 31.8841 22.9454 31.5911V27.8778L19.3335 25.7938L18.2927 25.1933C17.1501 24.5363 16.449 23.3216 16.449 22.0047V12.4183C16.449 12.0309 16.5103 11.6519 16.6258 11.2932C16.6384 11.2538 16.6515 11.2146 16.6654 11.1758Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.5428 9.976C20.6893 9.48368 19.639 9.47495 18.7785 9.94983C18.7629 9.96191 18.7443 9.97423 18.7268 9.98436C18.1143 10.3383 17.6666 10.9052 17.4561 11.5601C17.3705 11.8306 17.3252 12.1165 17.3252 12.4091V16.1225L20.8253 18.1419L21.9782 18.8071C23.121 19.4641 23.8216 20.6785 23.8216 21.9955V31.5819C23.8216 31.9698 23.7602 32.3494 23.6443 32.7085C23.6319 32.7474 23.6189 32.7861 23.6052 32.8245L29.8472 29.2214C30.7188 28.7204 31.2535 27.7945 31.2535 26.7887V17.2023C31.2535 16.2004 30.7155 15.2704 29.8465 14.7691L28.2548 13.8504L21.5428 9.976Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("f59AY", function(module, exports) {
$parcel$export(module.exports, "RovoLogoBrandV3", function () { return $2eca391e4c2f6a8a$export$386d77a349fc36df; });

var $7VQPk = parcelRequire("7VQPk");
const $2eca391e4c2f6a8a$export$386d77a349fc36df = ({ width: width, height: height = '100%', lightMode: lightMode = false })=>{
    const textFill = lightMode ? '#ffffff' : '#101214';
    const rovoTitleId = 'rovoTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 158 55",
        fill: "none",
        "aria-labelledby": rovoTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: rovoTitleId,
                children: "Rovo"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M146.534 42.46C139.634 42.46 135.586 37.354 135.586 30.454C135.586 23.554 139.634 18.54 146.534 18.54C153.388 18.54 157.39 23.554 157.39 30.454C157.39 37.354 153.388 42.46 146.534 42.46ZM146.534 22.22C141.612 22.22 139.45 26.084 139.45 30.454C139.45 34.824 141.612 38.78 146.534 38.78C151.41 38.78 153.526 34.824 153.526 30.454C153.526 26.084 151.41 22.22 146.534 22.22Z",
                fill: textFill
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M125.515 42H120.225L111.301 19H115.441L122.893 38.642L130.299 19H134.439L125.515 42Z",
                fill: textFill
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M99.3191 42.46C92.4191 42.46 88.3711 37.354 88.3711 30.454C88.3711 23.554 92.4191 18.54 99.3191 18.54C106.173 18.54 110.175 23.554 110.175 30.454C110.175 37.354 106.173 42.46 99.3191 42.46ZM99.3191 22.22C94.3971 22.22 92.2351 26.084 92.2351 30.454C92.2351 34.824 94.3971 38.78 99.3191 38.78C104.195 38.78 106.311 34.824 106.311 30.454C106.311 26.084 104.195 22.22 99.3191 22.22Z",
                fill: textFill
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.7667 15.7343H67.6947V26.7743H73.7667C79.1487 26.7743 80.8047 24.7043 80.8047 21.2543C80.8047 17.9883 79.1027 15.7343 73.7667 15.7343ZM84.9447 21.1623C84.9447 25.7163 83.0127 28.7983 79.0107 30.0863L86.4167 42.0003H81.5407L74.8707 30.7303C74.6867 30.7303 74.4567 30.7303 74.2267 30.7303H67.6947V42.0003H63.5547V11.7783H74.2267C81.4487 11.7783 84.9447 15.3663 84.9447 21.1623Z",
                fill: textFill
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.6586 0.775609C23.5679 -0.277535 25.8982 -0.258187 27.792 0.833652L42.6848 9.42602L46.2164 11.4636C48.1447 12.5753 49.3382 14.6378 49.3382 16.8597V38.1199C49.3382 40.3506 48.1519 42.404 46.2179 43.5151L32.3682 51.5057C32.3985 51.4205 32.4274 51.3348 32.455 51.2486C32.712 50.452 32.8483 49.6103 32.8483 48.7499V27.4898C32.8483 24.5691 31.2938 21.8758 28.7582 20.4188L26.2001 18.9435L18.4341 14.4649V6.22962C18.4341 5.58069 18.5345 4.94678 18.7245 4.3467C19.1915 2.89436 20.1849 1.63706 21.5439 0.852196L21.548 0.849818C21.5869 0.827342 21.624 0.802413 21.6586 0.775609Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.97 3.4944L3.12029 11.485C1.1863 12.5961 0 14.6495 0 16.8802V38.1404C0 40.3623 1.19329 42.4247 3.12155 43.5363L6.40529 45.4309L21.5462 54.1664C23.44 55.2581 25.7704 55.2776 27.6796 54.2245C27.7142 54.1977 27.751 54.1729 27.79 54.1504C29.1504 53.3661 30.1453 52.1083 30.6131 50.6554C30.8035 50.0547 30.9041 49.4201 30.9041 48.7705V40.5352L22.89 35.9134L20.5806 34.5817C18.0455 33.1246 16.4899 30.4307 16.4899 27.5103V6.25013C16.4899 5.39096 16.6258 4.55039 16.8822 3.75482C16.91 3.66745 16.9393 3.58063 16.97 3.4944Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.89 35.9134L6.40529 45.4309L3.12155 43.5363C1.19329 42.4247 0 40.3623 0 38.1404V16.8802C0 14.6495 1.1863 12.5961 3.12029 11.485L16.97 3.4944C16.9393 3.58063 16.91 3.66745 16.8822 3.75482C16.6258 4.55039 16.4899 5.39096 16.4899 6.25013V27.5103C16.4899 30.4307 18.0455 33.1246 20.5806 34.5817L22.89 35.9134Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.2001 18.9435L18.4341 14.4649V6.22962C18.4341 5.58069 18.5345 4.94678 18.7245 4.3467C19.1915 2.89436 20.1849 1.63706 21.5439 0.852196L21.548 0.849818C21.5869 0.827342 21.624 0.802413 21.6586 0.775609C23.5679 -0.277535 25.8982 -0.258187 27.792 0.833652L42.6848 9.42602L26.2001 18.9435Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M46.2164 11.4636L42.6848 9.42602L26.2001 18.9435L28.7582 20.4188C31.2938 21.8758 32.8483 24.5691 32.8483 27.4898V48.7499C32.8483 49.6103 32.712 50.452 32.455 51.2486C32.4274 51.3348 32.3985 51.4205 32.3682 51.5057L46.2179 43.5151C48.1519 42.404 49.3382 40.3506 49.3382 38.1199V16.8597C49.3382 14.6378 48.1447 12.5753 46.2164 11.4636Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.89 35.9134L6.40529 45.4309L21.5462 54.1664C23.44 55.2581 25.7704 55.2776 27.6796 54.2245C27.7142 54.1977 27.751 54.1729 27.79 54.1504C29.1504 53.3661 30.1453 52.1083 30.6131 50.6554C30.8035 50.0547 30.9041 49.4201 30.9041 48.7705V40.5352L22.89 35.9134Z",
                fill: "#6A9A23"
            })
        ]
    });
};

});

parcelRegister("gx7vL", function(module, exports) {
$parcel$export(module.exports, "RovoMarkBrandV3", function () { return $43debc2d2b7a687e$export$a06945c791a4f3a2; });

var $7VQPk = parcelRequire("7VQPk");
const $43debc2d2b7a687e$export$a06945c791a4f3a2 = ({ width: width = 50, height: height = 55 } = {})=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 50 55",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.887 35.9136L6.40233 45.431L3.11886 43.5365C1.19061 42.4248 -0.00268555 40.3624 -0.00268555 38.1405V16.8804C-0.00268555 14.6497 1.18361 12.5963 3.11759 11.4852L16.9673 3.49463C16.9366 3.58087 16.9073 3.66769 16.8795 3.75505C16.6231 4.55062 16.4872 5.39119 16.4872 6.25036V27.5105C16.4872 30.4308 18.0428 33.1247 20.5779 34.5818L22.887 35.9136Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.887 35.9136L6.40234 45.431L21.5432 54.1665C23.437 55.2582 25.7674 55.2776 27.6766 54.2245C27.7112 54.1977 27.748 54.173 27.787 54.1505C29.1474 53.3661 30.1423 52.1084 30.6101 50.6555C30.8005 50.0548 30.9011 49.4202 30.9011 48.7705V40.5353L22.887 35.9136Z",
                fill: "#6A9A23"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M46.2189 11.4643L42.6873 9.42676L26.2026 18.9442L28.7608 20.4195C31.2963 21.8765 32.8509 24.5698 32.8509 27.4905V48.7506C32.8509 49.6109 32.7146 50.4526 32.4575 51.2492C32.43 51.3354 32.4011 51.4212 32.3708 51.5063L46.2205 43.5157C48.1545 42.4046 49.3407 40.3512 49.3407 38.1205V16.8604C49.3407 14.6385 48.1472 12.576 46.2189 11.4643Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.1971 18.9434L18.4312 14.4649V6.2296C18.4312 5.58068 18.5315 4.94676 18.7215 4.34668C19.1886 2.89435 20.1819 1.63706 21.5409 0.852193L21.545 0.849816C21.584 0.827339 21.621 0.802411 21.6556 0.775607C23.5649 -0.277534 25.8952 -0.258187 27.7891 0.83365L42.6818 9.42599L26.1971 18.9434Z",
                fill: "#FCA700"
            })
        ]
    });

});

parcelRegister("aLKEe", function(module, exports) {
$parcel$export(module.exports, "SourcetreeLogoBrandV3", function () { return $f547b25554ec7454$export$b00b1c6aaf2bee55; });

var $7VQPk = parcelRequire("7VQPk");
const $f547b25554ec7454$export$b00b1c6aaf2bee55 = ()=>{
    const sourcetreeTitleId = 'sourcetreeTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "274",
        height: "48",
        viewBox: "0 0 274 48",
        fill: "none",
        "aria-labelledby": sourcetreeTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: sourcetreeTitleId,
                children: "Sourcetree"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M263.289 18.128C259.103 18.128 256.987 20.842 256.573 24.844H269.407C269.177 20.566 267.245 18.128 263.289 18.128ZM272.121 37.08C270.235 38.092 267.337 38.46 264.991 38.46C256.389 38.46 252.617 33.492 252.617 26.454C252.617 19.508 256.481 14.54 263.473 14.54C270.557 14.54 273.409 19.462 273.409 26.454V28.248H256.619C257.171 32.158 259.701 34.688 265.129 34.688C267.797 34.688 270.051 34.182 272.121 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M239.166 18.128C234.98 18.128 232.864 20.842 232.45 24.844H245.284C245.054 20.566 243.122 18.128 239.166 18.128ZM247.998 37.08C246.112 38.092 243.214 38.46 240.868 38.46C232.266 38.46 228.494 33.492 228.494 26.454C228.494 19.508 232.358 14.54 239.35 14.54C246.434 14.54 249.286 19.462 249.286 26.454V28.248H232.496C233.048 32.158 235.578 34.688 241.006 34.688C243.674 34.688 245.928 34.182 247.998 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M218.779 24.4306V38.0006H214.915V15.0006H218.779V19.0486C220.113 16.3346 222.413 14.4026 226.921 14.6786V18.5426C221.861 18.0366 218.779 19.5546 218.779 24.4306Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M203.724 30.87C203.724 32.894 204.92 34.274 207.358 34.274C208.278 34.274 209.152 34.09 209.842 33.952V37.77C209.152 37.954 208.37 38.138 207.174 38.138C202.252 38.138 199.86 35.24 199.86 30.962V18.68H196.134V15H199.86V10.124H203.724V15H209.842V18.68H203.724V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M183.418 18.128C179.232 18.128 177.116 20.842 176.702 24.844H189.536C189.306 20.566 187.374 18.128 183.418 18.128ZM192.25 37.08C190.364 38.092 187.466 38.46 185.12 38.46C176.518 38.46 172.746 33.492 172.746 26.454C172.746 19.508 176.61 14.54 183.602 14.54C190.686 14.54 193.538 19.462 193.538 26.454V28.248H176.748C177.3 32.158 179.83 34.688 185.258 34.688C187.926 34.688 190.18 34.182 192.25 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M169.61 33.86V37.402C168.23 38.138 166.114 38.46 163.998 38.46C155.81 38.46 151.992 33.492 151.992 26.454C151.992 19.508 155.81 14.54 163.998 14.54C166.068 14.54 167.678 14.816 169.472 15.644V19.324C168 18.634 166.436 18.22 164.274 18.22C158.294 18.22 155.856 21.992 155.856 26.454C155.856 30.916 158.34 34.688 164.366 34.688C166.712 34.688 168.184 34.366 169.61 33.86Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M142.277 24.4306V38.0006H138.413V15.0006H142.277V19.0486C143.611 16.3346 145.911 14.4026 150.419 14.6786V18.5426C145.359 18.0366 142.277 19.5546 142.277 24.4306Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M112.887 28.478V15H116.843V28.892C116.843 33.032 118.499 34.872 122.271 34.872C125.951 34.872 128.481 32.434 128.481 27.788V15H132.437V38H128.481V34.228C127.009 36.942 124.295 38.46 121.213 38.46C115.923 38.46 112.887 34.826 112.887 28.478Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M97.8933 38.46C90.9933 38.46 86.9453 33.354 86.9453 26.454C86.9453 19.554 90.9933 14.54 97.8933 14.54C104.747 14.54 108.749 19.554 108.749 26.454C108.749 33.354 104.747 38.46 97.8933 38.46ZM97.8933 18.22C92.9713 18.22 90.8093 22.084 90.8093 26.454C90.8093 30.824 92.9713 34.78 97.8933 34.78C102.769 34.78 104.885 30.824 104.885 26.454C104.885 22.084 102.769 18.22 97.8933 18.22Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.4596 29.6744C83.4596 34.9184 80.3316 38.4604 72.8336 38.4604C66.9916 38.4604 64.2776 37.3104 61.9316 36.1144V31.8824C64.7376 33.3544 69.0616 34.4124 73.0636 34.4124C77.6176 34.4124 79.3196 32.6184 79.3196 29.9504C79.3196 27.2824 77.6636 25.8564 71.9136 24.4764C65.1056 22.8204 62.0696 20.4744 62.0696 15.5064C62.0696 10.8144 65.6576 7.31836 72.6956 7.31836C77.0656 7.31836 79.8716 8.37636 81.9416 9.52636V13.6664C78.9056 11.9184 75.6396 11.3664 72.5116 11.3664C68.5556 11.3664 66.2096 12.7464 66.2096 15.5064C66.2096 17.9904 68.1416 19.2324 73.4776 20.5664C79.8716 22.1764 83.4596 24.2464 83.4596 29.6744Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.8496 20.8806C11.8496 26.2677 15.3376 30.8022 20.1434 32.4299V38.2433C20.1434 38.8634 20.5309 39.251 21.151 39.251H26.8482C27.4683 39.251 27.8558 38.8634 27.8558 38.2433V28.5931C27.8558 26.384 26.3056 24.95 24.2903 24.95C21.6161 24.95 19.9496 23.0897 19.9496 20.8419C19.9496 18.594 21.5774 16.7725 23.9802 16.7725C26.3831 16.7725 28.0496 18.5553 28.0496 20.8419C28.0496 22.1983 27.3908 23.4385 26.3831 24.1749C27.9721 24.9112 29.0573 26.4227 29.0573 28.5931V31.9648C33.2429 30.027 36.1496 25.8026 36.1496 20.8806C36.1496 14.1758 30.84 8.75 23.9802 8.75C17.1204 8.75 11.8496 14.1758 11.8496 20.8806Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("4bdUn", function(module, exports) {
$parcel$export(module.exports, "SourcetreeMarkBrandV3", function () { return $a60b6e81512ca014$export$e2f0398c27f793ea; });

var $7VQPk = parcelRequire("7VQPk");
const $a60b6e81512ca014$export$e2f0398c27f793ea = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#94C748"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.8501 20.8806C11.8501 26.2677 15.3381 30.8022 20.1439 32.4299V38.2433C20.1439 38.8634 20.5314 39.251 21.1515 39.251H26.8487C27.4688 39.251 27.8563 38.8634 27.8563 38.2433V28.5931C27.8563 26.384 26.3061 24.95 24.2908 24.95C21.6166 24.95 19.9501 23.0897 19.9501 20.8419C19.9501 18.594 21.5778 16.7725 23.9807 16.7725C26.3836 16.7725 28.0501 18.5553 28.0501 20.8419C28.0501 22.1983 27.3912 23.4385 26.3836 24.1749C27.9726 24.9112 29.0578 26.4227 29.0578 28.5931V31.9648C33.2434 30.027 36.1501 25.8026 36.1501 20.8806C36.1501 14.1758 30.8405 8.75 23.9807 8.75C17.1209 8.75 11.8501 14.1758 11.8501 20.8806Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("6APt1", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogoBrandV3", function () { return $f498fc3c5862bad6$export$383555a5dcffc0cc; });

var $7VQPk = parcelRequire("7VQPk");
const $f498fc3c5862bad6$export$383555a5dcffc0cc = ()=>{
    const statuspageTitleId = 'statuspageTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "288",
        height: "48",
        viewBox: "0 0 288 48",
        fill: "none",
        "aria-labelledby": statuspageTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: statuspageTitleId,
                children: "Statuspage"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M277.44 18.128C273.254 18.128 271.138 20.842 270.724 24.844H283.558C283.328 20.566 281.396 18.128 277.44 18.128ZM286.272 37.08C284.386 38.092 281.488 38.46 279.142 38.46C270.54 38.46 266.768 33.492 266.768 26.454C266.768 19.508 270.632 14.54 277.624 14.54C284.708 14.54 287.56 19.462 287.56 26.454V28.248H270.77C271.322 32.158 273.852 34.688 279.28 34.688C281.948 34.688 284.202 34.182 286.272 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M258.314 36.16V33.86C256.842 36.896 254.082 38.46 250.54 38.46C244.468 38.46 241.432 33.262 241.432 26.5C241.432 20.014 244.606 14.54 251 14.54C254.358 14.54 256.934 16.058 258.314 19.048V15H262.178V35.93C262.178 42.692 259.004 47.246 250.77 47.246C246.906 47.246 244.79 46.74 242.582 46.004V42.14C245.112 42.968 247.734 43.52 250.586 43.52C256.336 43.52 258.314 40.438 258.314 36.16ZM245.296 26.5C245.296 32.02 247.504 34.78 251.598 34.78C255.14 34.78 258.314 32.526 258.314 27.42V25.58C258.314 20.474 255.416 18.22 252.058 18.22C247.596 18.22 245.296 21.164 245.296 26.5Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M219.872 26.5C219.872 32.02 222.08 34.78 226.174 34.78C229.716 34.78 232.89 32.526 232.89 27.42V25.58C232.89 20.474 229.992 18.22 226.634 18.22C222.172 18.22 219.872 21.164 219.872 26.5ZM232.89 38V33.86C231.418 36.896 228.658 38.46 225.116 38.46C218.998 38.46 215.916 33.262 215.916 26.5C215.916 20.014 219.136 14.54 225.576 14.54C228.934 14.54 231.51 16.058 232.89 19.048V15H236.846V38H232.89Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M208.754 26.5C208.754 20.98 206.546 18.22 202.452 18.22C198.91 18.22 195.736 20.474 195.736 25.58V27.42C195.736 32.526 198.634 34.78 201.992 34.78C206.454 34.78 208.754 31.836 208.754 26.5ZM203.05 38.46C199.692 38.46 197.116 36.942 195.736 33.952V46.97H191.78V15H195.736V19.14C197.208 16.104 199.968 14.54 203.51 14.54C209.628 14.54 212.71 19.738 212.71 26.5C212.71 32.986 209.49 38.46 203.05 38.46Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M187.211 31.744C187.211 35.562 184.727 38.46 178.563 38.46C175.113 38.46 172.307 37.678 170.559 36.758V32.572C172.537 33.722 175.849 34.826 178.747 34.826C181.783 34.826 183.347 33.584 183.347 31.79C183.347 30.042 182.013 29.03 177.643 27.972C172.537 26.73 170.375 24.752 170.375 20.98C170.375 16.978 173.457 14.54 178.701 14.54C181.691 14.54 184.405 15.276 186.107 16.196V20.29C183.347 18.91 181.093 18.174 178.655 18.174C175.757 18.174 174.193 19.186 174.193 20.98C174.193 22.59 175.297 23.602 179.529 24.614C184.635 25.856 187.211 27.742 187.211 31.744Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M145.814 28.478V15H149.77V28.892C149.77 33.032 151.426 34.872 155.198 34.872C158.878 34.872 161.408 32.434 161.408 27.788V15H165.364V38H161.408V34.228C159.936 36.942 157.222 38.46 154.14 38.46C148.85 38.46 145.814 34.826 145.814 28.478Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M135.083 30.87C135.083 32.894 136.279 34.274 138.717 34.274C139.637 34.274 140.511 34.09 141.201 33.952V37.77C140.511 37.954 139.729 38.138 138.533 38.138C133.611 38.138 131.219 35.24 131.219 30.962V18.68H127.493V15H131.219V10.124H135.083V15H141.201V18.68H135.083V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.669 26.5C106.669 32.02 108.877 34.78 112.971 34.78C116.513 34.78 119.687 32.526 119.687 27.42V25.58C119.687 20.474 116.789 18.22 113.431 18.22C108.969 18.22 106.669 21.164 106.669 26.5ZM119.687 38V33.86C118.215 36.896 115.455 38.46 111.913 38.46C105.795 38.46 102.713 33.262 102.713 26.5C102.713 20.014 105.933 14.54 112.373 14.54C115.731 14.54 118.307 16.058 119.687 19.048V15H123.643V38H119.687Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M93.8 30.87C93.8 32.894 94.996 34.274 97.434 34.274C98.354 34.274 99.228 34.09 99.918 33.952V37.77C99.228 37.954 98.446 38.138 97.25 38.138C92.328 38.138 89.936 35.24 89.936 30.962V18.68H86.21V15H89.936V10.124H93.8V15H99.918V18.68H93.8V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.4596 29.6744C83.4596 34.9184 80.3316 38.4604 72.8336 38.4604C66.9916 38.4604 64.2776 37.3104 61.9316 36.1144V31.8824C64.7376 33.3544 69.0616 34.4124 73.0636 34.4124C77.6176 34.4124 79.3196 32.6184 79.3196 29.9504C79.3196 27.2824 77.6636 25.8564 71.9136 24.4764C65.1056 22.8204 62.0696 20.4744 62.0696 15.5064C62.0696 10.8144 65.6576 7.31836 72.6956 7.31836C77.0656 7.31836 79.8716 8.37636 81.9416 9.52636V13.6664C78.9056 11.9184 75.6396 11.3664 72.5116 11.3664C68.5556 11.3664 66.2096 12.7464 66.2096 15.5064C66.2096 17.9904 68.1416 19.2324 73.4776 20.5664C79.8716 22.1764 83.4596 24.2464 83.4596 29.6744Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FFC716"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.8438 19.7953C20.1486 19.7953 16.5546 21.4658 13.6187 24.0473C13.315 24.351 13.0113 24.5029 12.7076 24.5029C12.4545 24.5029 12.2014 24.351 11.9989 24.0979L8.30371 19.7447C8.10124 19.4916 8 19.2385 8 19.036C8 18.7323 8.15186 18.4792 8.45557 18.1755C12.91 14.2272 18.3263 12 23.8438 12C29.3612 12 34.7775 14.2272 39.2319 18.1755C39.5356 18.4792 39.6875 18.7323 39.6875 19.036C39.6875 19.2385 39.5863 19.4916 39.3838 19.7447L35.6886 24.0979C35.4861 24.351 35.233 24.5029 34.9799 24.5029C34.6762 24.5029 34.3725 24.351 34.0688 24.0473C31.1329 21.4658 27.5389 19.7953 23.8438 19.7953ZM23.8438 36.0947C19.7436 36.0947 16.4028 32.7538 16.4028 28.7043C16.4028 24.6548 19.7436 21.3139 23.8438 21.3139C27.9439 21.3139 31.2847 24.6041 31.2847 28.7043C31.2847 32.8044 27.9439 36.0947 23.8438 36.0947Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("k9aBd", function(module, exports) {
$parcel$export(module.exports, "StatuspageMarkBrandV3", function () { return $0cb38c47e091646f$export$15d8f2c4960d00d1; });

var $7VQPk = parcelRequire("7VQPk");
const $0cb38c47e091646f$export$15d8f2c4960d00d1 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FFC716"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.8438 19.7953C20.1486 19.7953 16.5546 21.4658 13.6187 24.0473C13.315 24.351 13.0113 24.5029 12.7076 24.5029C12.4545 24.5029 12.2014 24.351 11.9989 24.0979L8.30371 19.7447C8.10124 19.4916 8 19.2385 8 19.036C8 18.7323 8.15186 18.4792 8.45557 18.1755C12.91 14.2272 18.3263 12 23.8438 12C29.3612 12 34.7775 14.2272 39.2319 18.1755C39.5356 18.4792 39.6875 18.7323 39.6875 19.036C39.6875 19.2385 39.5863 19.4916 39.3838 19.7447L35.6886 24.0979C35.4861 24.351 35.233 24.5029 34.9799 24.5029C34.6762 24.5029 34.3725 24.351 34.0688 24.0473C31.1329 21.4658 27.5389 19.7953 23.8438 19.7953ZM23.8438 36.0947C19.7436 36.0947 16.4028 32.7538 16.4028 28.7043C16.4028 24.6548 19.7436 21.3139 23.8438 21.3139C27.9439 21.3139 31.2847 24.6041 31.2847 28.7043C31.2847 32.8044 27.9439 36.0947 23.8438 36.0947Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("kQiXS", function(module, exports) {
$parcel$export(module.exports, "TalentMarkBrandV3", function () { return $daa9533aaefcb2fb$export$152d518ed8ebb9d1; });

var $7VQPk = parcelRequire("7VQPk");
const $daa9533aaefcb2fb$export$152d518ed8ebb9d1 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#FB9700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.5931 17.5061L23.147 7.35986H24.8643L29.4181 17.5061L40.475 18.7017L41.0056 20.335L32.7632 27.8012L35.0429 38.6864L33.6535 39.6958L24.0056 34.164L14.3577 39.6958L12.9684 38.6864L15.248 27.8012L7.00562 20.335L7.53631 18.7017L18.5931 17.5061ZM20.1485 30.3367V28.9797C20.1485 26.9283 21.8114 25.2654 23.8627 25.2654C25.9141 25.2654 27.577 26.9283 27.577 28.9797V30.2051C26.4826 30.891 25.1908 31.2912 23.8062 31.3011H23.7008C22.4073 31.2919 21.1948 30.942 20.1485 30.3367ZM23.8627 24.0682C25.4013 24.0682 26.6485 22.821 26.6485 21.2825C26.6485 19.744 25.4013 18.4968 23.8627 18.4968C22.3242 18.4968 21.077 19.744 21.077 21.2825C21.077 22.821 22.3242 24.0682 23.8627 24.0682Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("5pwBY", function(module, exports) {
$parcel$export(module.exports, "TrelloLogoBrandV3", function () { return $c25adecc3d5776bf$export$73be974b775e1238; });

var $7VQPk = parcelRequire("7VQPk");
const $c25adecc3d5776bf$export$73be974b775e1238 = ()=>{
    const trelloTitleId = 'trelloTitle';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "169",
        height: "48",
        viewBox: "0 0 169 48",
        fill: "none",
        "aria-labelledby": trelloTitleId,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                id: trelloTitleId,
                children: "Trello"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M157.46 38.46C150.56 38.46 146.512 33.354 146.512 26.454C146.512 19.554 150.56 14.54 157.46 14.54C164.314 14.54 168.316 19.554 168.316 26.454C168.316 33.354 164.314 38.46 157.46 38.46ZM157.46 18.22C152.538 18.22 150.376 22.084 150.376 26.454C150.376 30.824 152.538 34.78 157.46 34.78C162.336 34.78 164.452 30.824 164.452 26.454C164.452 22.084 162.336 18.22 157.46 18.22Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M144.311 37.9537C143.989 38.0457 143.299 38.1377 142.287 38.1377C138.515 38.1377 136.123 36.3437 136.123 32.1117V5.38574H140.079V31.6517C140.079 33.7217 141.459 34.4577 143.161 34.4577C143.575 34.4577 143.851 34.4577 144.311 34.4117V37.9537Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M132.317 37.9537C131.995 38.0457 131.305 38.1377 130.293 38.1377C126.521 38.1377 124.129 36.3437 124.129 32.1117V5.38574H128.085V31.6517C128.085 33.7217 129.465 34.4577 131.167 34.4577C131.581 34.4577 131.857 34.4577 132.317 34.4117V37.9537Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M109.298 18.128C105.112 18.128 102.996 20.842 102.582 24.844H115.416C115.186 20.566 113.254 18.128 109.298 18.128ZM118.13 37.08C116.244 38.092 113.346 38.46 111 38.46C102.398 38.46 98.6256 33.492 98.6256 26.454C98.6256 19.508 102.49 14.54 109.482 14.54C116.566 14.54 119.418 19.462 119.418 26.454V28.248H102.628C103.18 32.158 105.71 34.688 111.138 34.688C113.806 34.688 116.06 34.182 118.13 33.446V37.08Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M88.9106 24.4296V37.9996H85.0466V14.9996H88.9106V19.0476C90.2446 16.3336 92.5446 14.4016 97.0526 14.6776V18.5416C91.9926 18.0356 88.9106 19.5536 88.9106 24.4296Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M60.414 7.77734H83.046V11.7333H73.8V37.9993H69.66V11.7333H60.414V7.77734Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.3456 36C20.2788 36 21.0362 35.263 21.0362 34.3519V13.6481C21.0362 12.7383 20.2801 12 19.3456 12H12.1906C11.2574 12 10.5 12.737 10.5 13.6481V34.3519C10.5 35.2617 11.2561 36 12.1906 36H19.3456Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.8094 26.4952C36.7426 26.4952 37.5 25.7582 37.5 24.8471V13.6481C37.5 12.7383 36.744 12 35.8094 12H28.6544C27.7212 12 26.9638 12.737 26.9638 13.6481V24.8471C26.9638 25.7569 27.7199 26.4952 28.6544 26.4952H35.8094Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("aYeUw", function(module, exports) {
$parcel$export(module.exports, "TrelloMarkBrandV3", function () { return $841577f658258867$export$68c800a1700ba45c; });

var $7VQPk = parcelRequire("7VQPk");
const $841577f658258867$export$68c800a1700ba45c = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.3456 36C20.2788 36 21.0362 35.263 21.0362 34.3519V13.6481C21.0362 12.7383 20.2801 12 19.3456 12H12.1906C11.2574 12 10.5 12.737 10.5 13.6481V34.3519C10.5 35.2617 11.2561 36 12.1906 36H19.3456Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.8094 26.4952C36.7426 26.4952 37.5 25.7582 37.5 24.8471V13.6481C37.5 12.7383 36.744 12 35.8094 12H28.6544C27.7212 12 26.9638 12.737 26.9638 13.6481V24.8471C26.9638 25.7569 27.7199 26.4952 28.6544 26.4952H35.8094Z",
                fill: "white"
            })
        ]
    });

});


parcelRegister("cR2Ov", function(module, exports) {
$parcel$export(module.exports, "DropdownContent", function () { return $3595375b0b89e56c$export$59308621e1a05692; });
/* dropdown-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
const $3595375b0b89e56c$export$59308621e1a05692 = (props)=>{
    const { contentSections: contentSections } = props;
    const { orientation: orientation = 'row' } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                orientation === 'row' && "_ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _1e0c1txw _2lx21bp4 _1bsb1osq _zulpzwfg _oqic1ylp _1rmj1ylp _cjbt1ylp _pnmb1ylp _1inivrvc",
                orientation === 'column' && "_ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp _1q51gktf _1e0c1txw _2lx21bp4 _1bsb1osq _zulp7vkz"
            ]),
            children: contentSections.map((section, idx)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($3595375b0b89e56c$var$DropdownContentSection, {
                            ...section
                        }),
                        orientation === 'column' && idx < contentSections.length - 1 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _mqm216cp"
                            ]),
                            style: {
                                "--_1q70ahv": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1000'))
                            }
                        })
                    ]
                }, `${section.header}-${idx}`))
        })
    });
};
const $3595375b0b89e56c$var$DropdownContentSection = ({ header: header, links: links })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
        children: [
            header && /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1p1dangw _syaz1pfd _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v",
                    "nav-column-header"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text'))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                role: "menu",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _umai1ylp _1bsbntd2 _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1pfh7vkz"
                ]),
                children: links.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        role: "none",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            role: "menuitem",
                            href: link.href,
                            ...link.dataEventProps,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "global-Product-Nav-link-in-dropdown",
                            onClick: link.onClick,
                            ...link.anchorProps,
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazqlpt _1wyboxwj _1wpzh9n0 _30l3u5k9"
                            ]),
                            style: {
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700'))
                            },
                            children: link.text
                        })
                    }, link.text))
            })
        ]
    });
};
const $3595375b0b89e56c$var$dropdownGridStyle = null;
const $3595375b0b89e56c$var$dropdownColumnStyles = null;
const $3595375b0b89e56c$var$dropdownColumnDividerStyles = null;
const $3595375b0b89e56c$var$headerStyle = null;
const $3595375b0b89e56c$var$linkColumnStyle = null;
const $3595375b0b89e56c$var$linkStyle = null;

});
parcelRegister("dfBhn", function(module, exports) {
$parcel$export(module.exports, "LinkColumn", function () { return $fb0deeb31b19d810$export$82633536c9b7c49a; });
/* subnav-link-columns.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $fb0deeb31b19d810$export$82633536c9b7c49a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "none",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4",
            "_oiwoidpf _1pssidpf _1hogidpf _1bliidpf _106iidpf _1h0cidpf _1rbiidpf _exjbidpf _ymruangw _new51pfd _1879oqnp _1igsz4z1 _1u7g1fw0 _ffd51j6v"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
            "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text'))
        },
        children: children
    });
};
const $fb0deeb31b19d810$var$navColumnHeaderStyles = null;

});

parcelRegister("9KOR3", function(module, exports) {
$parcel$export(module.exports, "SubnavLayout", function () { return $60ffa2cbf5dd7928$export$8a5d25b4588f0295; });
$parcel$export(module.exports, "GlobalNavProvider", function () { return $60ffa2cbf5dd7928$export$2e4075f1b160db09; });
$parcel$export(module.exports, "useGlobalNavContext", function () { return $60ffa2cbf5dd7928$export$65ce4fa28f5f4cfa; });
$parcel$export(module.exports, "DivOnHoverExit", function () { return $60ffa2cbf5dd7928$export$801171e56642f10e; });
$parcel$export(module.exports, "default", function () { return $60ffa2cbf5dd7928$export$2e2bcd8739ae039; });
/* nav-links-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $i2KlK = parcelRequire("i2KlK");

var $8vxK8 = parcelRequire("8vxK8");
// Dropdown visibility is driven by opacity + visibility transitions rather than
// keyframe animations that toggle display. Animating display: none↔block via
// keyframes is unreliable — the property is not interpolatable and causes
// flickering when multiple state changes happen in quick succession (e.g.
// mousedown closing the dropdown followed immediately by mouseenter re-opening
// it before the animation frame settles).
//
// Instead we keep the panel in the DOM at all times (no display toggling) and
// use:
//   - opacity: 0 + visibility: hidden  → invisible and non-interactive
//   - opacity: 1 + visibility: visible → visible and interactive
//   - transition on both properties    → smooth 125ms fade
//
// visibility: hidden is chosen over display: none because it participates in
// CSS transitions (unlike display) while still removing the element from tab
// order and pointer events.
const $60ffa2cbf5dd7928$var$TRANSITION_DURATION = '125ms';
const $60ffa2cbf5dd7928$var$dropdownTransitionBase = null;
const $60ffa2cbf5dd7928$var$dropdownHidden = null;
const $60ffa2cbf5dd7928$var$dropdownVisible = null;
// Overlay uses the same pattern at a lower opacity target
const $60ffa2cbf5dd7928$var$overlayHidden = null;
const $60ffa2cbf5dd7928$var$overlayVisible = null;
const $60ffa2cbf5dd7928$var$DropdownContentStyle = null;
const $60ffa2cbf5dd7928$var$DropdownContentStyleGlobalNav = null;
const $60ffa2cbf5dd7928$var$listContainer = null;
const $60ffa2cbf5dd7928$export$8a5d25b4588f0295 = {
    Product: 4,
    Teams: 3,
    WhyAtlassian: 4,
    Resources: 4,
    Solutions: 4
};
function $60ffa2cbf5dd7928$var$layoutToWidth(layout) {
    switch(layout){
        case 4:
            return '57rem';
        case 3:
            return '43.5rem';
        default:
            return 'auto';
    }
}
const $60ffa2cbf5dd7928$var$GlobalNavContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $60ffa2cbf5dd7928$export$2e4075f1b160db09 = ({ globalNavItemKeys: globalNavItemKeys, children: children })=>{
    const { forcedNavKey: forcedNavKey, isForcingNav: isForcingNav } = (0, $i2KlK.useForcedNav)();
    const [dropdownRefCurrentNode, setDropdownRefCurrent] = (0, $1oC0p.useState)(null);
    const [isLoggedInUserProfileDropdownOpen, setIsLoggedInUserProfileDropdownOpen] = (0, $1oC0p.useState)(false);
    // using callback ref to set the isGlobalNavDropdownOpen state when dropdownRef is updated
    const dropdownRefCallback = (0, $1oC0p.useCallback)((node)=>{
        setDropdownRefCurrent(node);
    }, []);
    const [state, dispatch] = (0, $1oC0p.useReducer)(function reducer(state, action) {
        // If we're forcing a nav item, ignore state changes (local dev only)
        if (isForcingNav && forcedNavKey) return {
            ...state,
            current: forcedNavKey,
            prev: state.current,
            isClickLocked: state.isClickLocked
        };
        const prev = state.current;
        if (action.type === 'click') // Click always updates current; lock is set when a subnav is
        // being opened (key is non-empty), cleared when closing.
        return {
            ...state,
            current: action.key,
            prev: prev,
            isClickLocked: !!action.key
        };
        // hover: only move current if we are NOT click-locked,
        // or if the hover is closing the nav (key is falsy / "exitDiv").
        if (state.isClickLocked && action.key) return state;
        return {
            ...state,
            current: action.key,
            prev: prev,
            isClickLocked: false
        };
    }, {
        // Initialize with forced nav if present (local development only)
        current: isForcingNav && forcedNavKey ? forcedNavKey : null,
        prev: null,
        isClickLocked: false
    });
    const { current: current, prev: prev, isClickLocked: isClickLocked } = state;
    // Hover-driven setter — will be blocked by click lock on other links
    const setCurrent = (0, $1oC0p.useCallback)((key)=>dispatch({
            type: 'hover',
            key: key
        }), []);
    // Click-driven setter — always wins and sets the click lock
    const setCurrentByClick = (0, $1oC0p.useCallback)((key)=>dispatch({
            type: 'click',
            key: key
        }), []);
    const value = (0, $1oC0p.useMemo)(()=>{
        return {
            current: current,
            prev: prev,
            isClickLocked: isClickLocked,
            globalNavItemKeys: globalNavItemKeys,
            direction: 'none',
            setCurrent: setCurrent,
            setCurrentByClick: setCurrentByClick,
            dropdownRefCallback: dropdownRefCallback,
            dropdownRefCurrentNode: dropdownRefCurrentNode,
            isLoggedInUserProfileDropdownOpen: isLoggedInUserProfileDropdownOpen,
            setIsLoggedInUserProfileDropdownOpen: setIsLoggedInUserProfileDropdownOpen
        };
    }, [
        current,
        prev,
        isClickLocked,
        globalNavItemKeys,
        setCurrent,
        setCurrentByClick,
        dropdownRefCallback,
        dropdownRefCurrentNode,
        isLoggedInUserProfileDropdownOpen,
        setIsLoggedInUserProfileDropdownOpen
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($60ffa2cbf5dd7928$var$GlobalNavContext.Provider, {
        value: value,
        children: children
    });
};
const $60ffa2cbf5dd7928$export$65ce4fa28f5f4cfa = ()=>{
    const context = (0, $1oC0p.useContext)($60ffa2cbf5dd7928$var$GlobalNavContext);
    if (!context) throw new Error('useGlobalNavContext must be used within GlobalNavProvider');
    return context;
};
const $60ffa2cbf5dd7928$export$d2589e93208d8ae2 = ()=>{
    const { setCurrent: setCurrent } = $60ffa2cbf5dd7928$export$65ce4fa28f5f4cfa();
    const handleMouseLeave = (0, $1oC0p.useCallback)(()=>{
        setCurrent('exitDiv');
    }, [
        setCurrent
    ]);
    return {
        handleMouseLeave: handleMouseLeave
    };
};
const $60ffa2cbf5dd7928$export$801171e56642f10e = ({ children: children })=>{
    const isHover = !(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwpGlobalNavHoverVClick);
    const { handleMouseLeave: handleMouseLeave } = $60ffa2cbf5dd7928$export$d2589e93208d8ae2();
    const navRef = (0, $1oC0p.useRef)(null);
    const handleBlur = (0, $1oC0p.useCallback)((e)=>{
        // Only close the dropdown if focus is moving outside the nav area
        if (navRef.current && e.relatedTarget && !navRef.current.contains(e.relatedTarget)) handleMouseLeave();
    }, [
        handleMouseLeave
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: navRef,
        onMouseLeave: isHover ? handleMouseLeave : undefined,
        onBlur: isHover ? handleBlur : undefined,
        className: (0, $2jatx.default)([
            "_4t3i1osq"
        ]),
        children: children
    });
};
const $60ffa2cbf5dd7928$var$MoreOrLess = ({ showButton: showButton, isShowingMore: isShowingMore, onClick: onClick, onExpand: onExpand })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const visibility = showButton ? 'visible' : 'hidden';
    const handleClick = ()=>{
        const wasShowingLess = !isShowingMore;
        onClick();
        // move focus to first revealed item when expanding
        if (wasShowingLess && onExpand) // using useEffect causes a race condition so using setTimeout to ensure state update
        // and DOM changes complete before focusing on the item
        setTimeout(()=>{
            onExpand();
        }, 0);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            source: isShowingMore ? 'globalNav-less' : 'globalNav-more',
            attributes: {
                label: isShowingMore ? 'less--' : 'more-+'
            }
        }).fire();
    };
    const onKeyDown = (e)=>{
        if (e.code === 'Enter' || e.code === 'Space') handleClick();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        "aria-hidden": visibility === 'hidden',
        role: "menuitem",
        style: {
            visibility: visibility,
            position: showButton ? 'initial' : 'absolute'
        },
        "data-element-globalnav": isShowingMore ? 'less' : 'more',
        "data-element-visibility": visibility,
        "data-testid": "moreOrLess-button",
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            role: "button",
            tabIndex: 0,
            onClick: handleClick,
            onKeyDown: onKeyDown,
            className: (0, $2jatx.default)([
                "_1q51u2gc _1e0c1txw _4cvr1h6o _vwz41j6v _80omtlke _30l3ftjs"
            ]),
            style: {
                "--_16ciuzt": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue800'))
            },
            children: isShowingMore ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_syazk0sw"
                ]),
                style: {
                    "--_1e97w25": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light700'))
                },
                children: intl.formatMessage({
                    id: 'globalNav.V2.navlink.lessMinus',
                    defaultMessage: 'Less -'
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: intl.formatMessage({
                    id: 'globalNav.V2.navlink.morePlus',
                    defaultMessage: 'More +'
                })
            })
        })
    });
};
/* eslint-disable complexity */ const $60ffa2cbf5dd7928$var$GlobalNavLinksContainer = ({ globalLinksProps: globalLinksProps, globalLinksRef: globalLinksRef, maxLinks: maxLinks = globalLinksProps.length, showMore: showMore, setShowMore: setShowMore, isSubnav: isSubnav = false })=>{
    const { current: current, setCurrent: setCurrent, setCurrentByClick: setCurrentByClick, dropdownRefCallback: dropdownRefCallback, dropdownRefCurrentNode: dropdownRefCurrentNode } = $60ffa2cbf5dd7928$export$65ce4fa28f5f4cfa();
    const intl = (0, $8e22h.default)();
    // Create refs for navigation links to manage focus
    const navLinkRefs = (0, $1oC0p.useRef)([]);
    const handleEscKeyEvent = (0, $1oC0p.useCallback)((event)=>{
        if (event.key === 'Escape') {
            // Find the parent nav link if in a subnav to reset focus there on dismiss
            const globalNavItem = document.activeElement?.closest('.glob-nav-links-container-ul > li');
            const navLink = globalNavItem?.querySelector('a.glob-nav-anchor-link');
            // Use setCurrentByClick to also clear the click lock
            setCurrentByClick('');
            navLink?.focus();
        }
    }, [
        setCurrentByClick
    ]);
    // In click mode (feature gate enabled), onMouseLeave on DivOnHoverExit is
    // disabled, so clicking outside the nav is the only way to dismiss an open
    // dropdown. We attach a mousedown listener for this — but we must exclude
    // clicks on the nav link anchors themselves, since onClick on those already
    // handles the toggle. Without this exclusion, mousedown would close the
    // dropdown before onClick fires, making onClick see isCurrentOpenDropdown
    // as false and re-open it (the original flicker race condition).
    // In hover mode this listener is not attached — DivOnHoverExit.onMouseLeave
    // handles dismissal and there is no click-outside scenario to handle.
    const isHover = !(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwpGlobalNavHoverVClick);
    const handleClickOutside = (0, $1oC0p.useCallback)((event)=>{
        if (dropdownRefCurrentNode && !dropdownRefCurrentNode.contains(event.target)) {
            // Also check the target isn't a nav link anchor — onClick on
            // those handles the toggle, and we must not race with it.
            const isNavAnchor = event.target?.closest?.('.glob-nav-anchor-link');
            if (!isNavAnchor) // Use setCurrentByClick to also clear the click lock
            setCurrentByClick('');
        }
    }, [
        setCurrentByClick,
        dropdownRefCurrentNode
    ]);
    (0, $1oC0p.useEffect)(()=>{
        document.addEventListener('keydown', handleEscKeyEvent, false);
        return ()=>{
            document.removeEventListener('keydown', handleEscKeyEvent, false);
        };
    }, [
        handleEscKeyEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (isHover) return;
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        isHover,
        handleClickOutside
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (current === 'exitDiv') // Use setCurrent (hover-driven) — mouse leaving the nav clears hover state
        // but does not interfere with click-lock (which is already false in hover mode).
        setCurrent('');
    }, [
        current,
        setCurrent
    ]);
    const showMoreButton = maxLinks < globalLinksProps.length;
    const showMoreGridTemplateColumns = showMore ? globalLinksProps.length + 1 : maxLinks === globalLinksProps.length ? maxLinks : maxLinks + 1;
    // focus the first newly revealed navigation item
    const handleFocusFirstHiddenItem = (0, $1oC0p.useCallback)(()=>{
        // focus the first hidden item (at index maxLinks)
        const firstHiddenLink = navLinkRefs.current[maxLinks];
        if (firstHiddenLink) {
            // find the first focusable element (the anchor tag) within the li
            const anchorElement = firstHiddenLink.querySelector('a');
            if (anchorElement) anchorElement.focus();
        }
    }, [
        maxLinks
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: ()=>setCurrentByClick(''),
                "aria-label": "Close navigation",
                tabIndex: -1,
                className: (0, $2jatx.default)([
                    "_kqsw1n9t _1bsb1osq _4t3i1osq _152tidpf _1e02idpf _rjxpidpf _u7coidpf _bfhk1afi _1pby1mrw _v5641tz5 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _r06hglyw",
                    current && globalLinksProps.some((l)=>l.globalLinksKey === current && l.hasSubnav) ? "_tzy415iw _3um0ewfl" : "_tzy4idpf _3um015vq"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($60ffa2cbf5dd7928$export$801171e56642f10e, {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                    role: "menubar",
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _yv0enq0k _4cvr1h6o _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1osq _kqswh2mm _3l1a1ejb",
                        "glob-nav-links-container-ul"
                    ]),
                    style: {
                        gridTemplateColumns: `repeat(${!isSubnav ? showMoreGridTemplateColumns : maxLinks}, max-content)`
                    },
                    ref: globalLinksRef,
                    children: [
                        globalLinksProps.map(// eslint-disable-next-line complexity
                        (globalLink, index)=>{
                            const containerPosition = globalLink.containerPosition || 'initial';
                            const isVisible = globalLink.hasSubnav && globalLink.globalLinksKey === current;
                            const shouldShowMore = index + 1 <= maxLinks || showMore;
                            const computedLayoutNumber = globalLink?.layout;
                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                    role: "none",
                                    ref: (el)=>{
                                        navLinkRefs.current[index] = el;
                                    },
                                    style: {
                                        position: shouldShowMore ? containerPosition : 'absolute',
                                        visibility: shouldShowMore ? 'visible' : 'hidden',
                                        // Ensure absolute items don't take up space in the grid
                                        // and are moved off-screen so we don't see a "flash" of items
                                        // when the hook is re-calculating the nav links size.
                                        // Using a very large negative value ensures they aren't visible
                                        // while they are being measured.
                                        insetBlockStart: shouldShowMore ? 'auto' : '-9999px',
                                        insetInlineStart: shouldShowMore ? 'auto' : '-9999px'
                                    },
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _4t3i1osq",
                                        isSubnav && "_6rth12x7"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8vxK8.default), {
                                            ...globalLink,
                                            isLinkVisible: shouldShowMore
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            "aria-label": intl.formatMessage({
                                                id: 'globalNav.V2.navlink.dropdownLabel',
                                                defaultMessage: '{linkText}: Dropdown Content'
                                            }, {
                                                linkText: globalLink.linkText
                                            }),
                                            role: "group",
                                            ref: isVisible ? dropdownRefCallback : null,
                                            "aria-hidden": !isVisible || !globalLink?.content,
                                            // @ts-expect-error -- inert is a valid HTML attribute but missing from @compiled/react types
                                            inert: !isVisible && globalLink?.content ? '' : undefined,
                                            className: (0, $2jatx.default)([
                                                "_tzy4idpf _3um015vq _lcxvglyw _152t88uy _1ul9ncxg _1bsb1ris _kqswstnw _1reo15vq _18m915vq _2rkoo7ao _19itglyw _16qsorjv _1f49b4wl _bfhk1afi _v5641s1c _1pbyzo7u",
                                                !isSubnav && "_dk5didpf _195g1wug _t9ecgjgj",
                                                "_v5641tz5",
                                                isVisible ? "_tzy4kb7n _3um0ewfl _lcxv1wug" : "_tzy4idpf _3um015vq _lcxvglyw"
                                            ]),
                                            style: {
                                                width: $60ffa2cbf5dd7928$var$layoutToWidth(computedLayoutNumber),
                                                ...globalLink?.containerStyles,
                                                "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300')),
                                                "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                                            },
                                            children: globalLink.content
                                        })
                                    ]
                                })
                            }, globalLink.globalLinksKey);
                        }),
                        !isSubnav && !!setShowMore && /*#__PURE__*/ (0, $7VQPk.jsx)($60ffa2cbf5dd7928$var$MoreOrLess, {
                            showButton: showMoreButton,
                            isShowingMore: showMore,
                            onClick: ()=>setShowMore((prev)=>!prev),
                            onExpand: handleFocusFirstHiddenItem
                        })
                    ]
                })
            })
        ]
    });
};
const $60ffa2cbf5dd7928$export$534659cdeeaf0451 = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: children
    });
var $60ffa2cbf5dd7928$export$2e2bcd8739ae039 = $60ffa2cbf5dd7928$var$GlobalNavLinksContainer;

});
parcelRegister("i2KlK", function(module, exports) {
$parcel$export(module.exports, "useForcedNav", function () { return $0f21d773838af7c4$export$90ca8111a9ef44f6; });

var $1oC0p = parcelRequire("1oC0p");
const $0f21d773838af7c4$export$90ca8111a9ef44f6 = ()=>{
    const forcedNavKey = (0, $1oC0p.useMemo)(()=>{
        typeof window;
        return null;
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const forceNavParam = urlParams.get('forceNav');
            if (forceNavParam !== null) {
                const validNavKeys = [
                    'products',
                    'solutions',
                    'why-atlassian',
                    'resources',
                    'teams'
                ];
                if (validNavKeys.includes(forceNavParam)) return forceNavParam;
            }
        } catch (error) {
        // not found
        }
        return null;
    }, []);
    return {
        forcedNavKey: forcedNavKey,
        isForcingNav: forcedNavKey !== null
    };
};

});

parcelRegister("8vxK8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3dffdd992d79cabf$export$2e2bcd8739ae039; });
/* nav-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $i2KlK = parcelRequire("i2KlK");

var $9KOR3 = parcelRequire("9KOR3");
const $3dffdd992d79cabf$var$buildAnchorLinkClassName = (navLinkIsCurrentPage, isCurrentOpenDropdown, hasSubnav, isActive)=>{
    return `glob-nav-anchor-link nav-link-anchor` + `${navLinkIsCurrentPage ? ' isCurrentPage ' : ''}` + `${!!isCurrentOpenDropdown && !!hasSubnav ? 'isActive' : ''}` + `${!hasSubnav ? 'isHoverableLink' : ''}` + `${isActive ? ' isActive ' : ''}`;
};
const $3dffdd992d79cabf$var$GlobalNavLink = (props)=>{
    // Using useGlobalNavContext hook which uses context, so component must memoize
    // to prevent unnecessary re-renders when context changes but props don't
    const { current: current, setCurrent: setCurrent, setCurrentByClick: setCurrentByClick, isClickLocked: isClickLocked } = (0, $9KOR3.useGlobalNavContext)();
    const { isForcingNav: isForcingNav, forcedNavKey: forcedNavKey } = (0, $i2KlK.useForcedNav)();
    const isHover = !(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwpGlobalNavHoverVClick);
    const isCurrentOpenDropdown = current === props.globalLinksKey;
    const normalizePathname = (path)=>path.replace(/\/$/, '');
    const navLinkIsCurrentPage = props.href && normalizePathname(globalThis.location.pathname) === normalizePathname(props.href);
    const anchorLinkClassName = $3dffdd992d79cabf$var$buildAnchorLinkClassName(!!navLinkIsCurrentPage, isCurrentOpenDropdown, !!props.hasSubnav, !!props.isActive);
    const linkClickAction = (e)=>{
        if (props.hasSubnav) {
            e.preventDefault();
            if (isForcingNav && forcedNavKey !== props.globalLinksKey) return;
            // Use isCurrentOpenDropdown (from context) as the source of truth
            // rather than local isOpen state, which can drift out of sync when
            // the user hovers between items or the context is updated externally.
            if (isCurrentOpenDropdown && isClickLocked) // Already click-locked open → second click closes it
            setCurrentByClick('');
            else if (isCurrentOpenDropdown && !isClickLocked) // Opened by hover, first click → keep it open and click-lock it
            setCurrentByClick(props.globalLinksKey);
            else // Not open → open it via click (click-locks it)
            setCurrentByClick(props.globalLinksKey);
        }
    };
    const rotate180deg = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
        className: (0, $2jatx.default)([
            "_1q51u2gc _1e0c1txw _4cvr1h6o _4t3i1osq _4bfu1r31 _1hmsglyw _ajmmnqa1 _vwz41j6v _bozgu2gc _y4ti1ejb _175uftjs _1ah312gs _30l35hrz _2oz41l7b _ulmp1r31 _5rleglyw _1ogcnqa1",
            anchorLinkClassName
        ]),
        href: props.href ?? '#',
        onClick: linkClickAction,
        onMouseEnter: isHover ? ()=>{
            if (isForcingNav && forcedNavKey !== props.globalLinksKey) return;
            // When a subnav is click-locked open, hovering other
            // links should not switch the active subnav.
            if (isClickLocked && !isCurrentOpenDropdown) return;
            setCurrent(props.globalLinksKey);
        } : undefined,
        onFocus: ()=>{
            return;
        } /* clicks are supported, using empty function for ratcheted @atlassian/a11y/mouse-events-have-key-events lint rule */ ,
        "aria-label": props.linkText,
        "aria-expanded": props.hasSubnav ? !!isCurrentOpenDropdown : undefined,
        "aria-current": navLinkIsCurrentPage ? 'page' : undefined,
        role: "menuitem",
        "aria-haspopup": props.hasSubnav ? 'true' : undefined,
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "headerDropdownLink",
        "data-product-key": props.productKey ?? 'jiraSoftware',
        style: {
            pointerEvents: props.isLinkVisible === false ? 'none' : 'auto',
            "--_16ciuzt": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue800')),
            "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
        },
        children: [
            props.linkText,
            !!props.hasSubnav && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _ahbqftgi _vwz4idpf _v5641doz",
                    isCurrentOpenDropdown && "_t9ec1sub",
                    "chevron-icon"
                ]),
                style: {
                    opacity: props.isLinkVisible === false ? 0 : 1
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "11",
                    height: "6",
                    viewBox: "0 0 11 6",
                    fill: "none",
                    "aria-hidden": "true",
                    focusable: "false",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M9.19922 1.18176L5.19922 4.81813L1.19922 1.18176",
                        stroke: isCurrentOpenDropdown ? (0, $bNzAT.default)('color.extended.blue800') : (0, $bNzAT.default)('color.primary.black'),
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    });
};
var // Memoize to prevent unnecessary re-renders when parent component updates
// but props haven't changed. This is important because GlobalNavLink consumes
// GlobalNavContext which updates frequently (when dropdowns open/close),
// and we only want to re-render this link if its props actually change.
$3dffdd992d79cabf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo($3dffdd992d79cabf$var$GlobalNavLink);

});



parcelRegister("iOXki", function(module, exports) {
$parcel$export(module.exports, "ProductPageSubNav", function () { return $baa9d0462e9c7f45$export$4f0322cadbe6a886; });
/* nav-product-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $zADBD = parcelRequire("zADBD");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $jUCHH = parcelRequire("jUCHH");

var $4Itfg = parcelRequire("4Itfg");

var $9KOR3 = parcelRequire("9KOR3");

var $7XaVV = parcelRequire("7XaVV");

var $96jet = parcelRequire("96jet");

var $5BEho = parcelRequire("5BEho");
const $baa9d0462e9c7f45$var$mobileWrapperCss = null;
const $baa9d0462e9c7f45$var$productPageMobileNav = null;
const $baa9d0462e9c7f45$var$atlasIconContainerStyle = null;
const $baa9d0462e9c7f45$var$atlasIconStyle = null;
const $baa9d0462e9c7f45$var$productPageSubNavStyle = null;
const $baa9d0462e9c7f45$var$productpageSubnavBar = null;
const $baa9d0462e9c7f45$var$wideProductPageSubnavBar = null;
const $baa9d0462e9c7f45$var$productpageSubnavLogoAndLinksContainer = null;
const $baa9d0462e9c7f45$var$productpageSubnavProductLogo = null;
const $baa9d0462e9c7f45$var$aNavBarLogoLink = null;
const $baa9d0462e9c7f45$var$productpageSearchBar = null;
// GALILEO-1972
// The following are used to fit the 'Templates' tab in the nav as part of this experiment:
// https://hello.atlassian.net/wiki/spaces/Growth/pages/4077753200/Templates+tab+in+WAC+header+iteration+GRW-1175
const $baa9d0462e9c7f45$var$getBuffer = (isTemplatesTabInHeader)=>isTemplatesTabInHeader ? 2 : undefined;
const $baa9d0462e9c7f45$var$smallerJsmLogoStyle = null;
const $baa9d0462e9c7f45$var$ProductPageSubNavLinks = ({ productLogo: productLogo, productLogoUrl: productLogoUrl, productLogoAriaLabel: productLogoAriaLabel, productKey: productKey, productPageNavLinks: productPageNavLinks, isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = true, tryNowCTAButtonBackgroundColor: tryNowCTAButtonBackgroundColor, isShowSearchButton: isShowSearchButton = true, isOpenSearch: isOpenSearch, setIsOpenSearch: setIsOpenSearch, navigationTrynowCtaText: navigationTrynowCtaText = 'Get it free', navigationTrynowCtaUrl: navigationTrynowCtaUrl = '/try', navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant = 'primary', positionTryNowCtaOnRight: positionTryNowCtaOnRight = false, isShowAppSwitcher: isShowAppSwitcher = true, isShowUserProfile: isShowUserProfile = true, isTemplatesTabInHeader: isTemplatesTabInHeader })=>{
    const intl = (0, $8e22h.default)();
    const linksRef = (0, $1oC0p.useRef)(null);
    const searchAndProfileRef = (0, $1oC0p.useRef)(null);
    const hasMounted = (0, $1oC0p.useRef)(false);
    const { showMoreItems: showMoreItems, shouldShowMoreItems: shouldShowMoreItems, maxItems: maxItems } = (0, $jUCHH.useMore)({
        leftElementRef: linksRef,
        rightElementRef: searchAndProfileRef,
        initialMaxItems: productPageNavLinks.length,
        buffer: $baa9d0462e9c7f45$var$getBuffer(isTemplatesTabInHeader)
    });
    // Focus the search button when the search bar is closed
    (0, $1oC0p.useEffect)(()=>{
        if (hasMounted.current) {
            const searchButton = document.getElementById('global-nav-search-bar-icon-desktop');
            if (searchButton) searchButton.focus();
        } else hasMounted.current = true;
    }, [
        isOpenSearch
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
        "aria-label": intl.formatMessage({
            id: 'productPageNav.main-nav-label',
            defaultMessage: 'Main'
        }),
        className: (0, $2jatx.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1h6o _4t3i1osq _bozg1svi _y4ti1wqb _1nnkx0bf _wborftgi _uuzvx0bf _ib4didpf"
        ]),
        style: {
            "--_wuy5mz": (0, $6ZVlx.default)(isTemplatesTabInHeader ? '18px' : '24px')
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _1bah1h6o _4cvr1h6o _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _b8yqtfvk",
                isTemplatesTabInHeader && "_b8yq3v0s",
                "productpage-subnav-bar"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug",
                        "productpage-subnav-logo-and-links-container"
                    ]),
                    style: {
                        alignItems: isOpenSearch ? 'center' : 'flex-end',
                        height: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5BEho.SkipToContent), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1q511l7b _1e0c1txw _1bah1h6o _4cvr1h6o",
                                "productpage-subnav-product-logo"
                            ]),
                            style: {
                                alignSelf: 'center',
                                paddingInlineEnd: "var(--ds-space-200, 16px)"
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bah1h6o _4cvrh9n0 _4t3i1ou6 _1xjx1ou6",
                                    isTemplatesTabInHeader && "_17521tcg",
                                    "navigation-bar-logo-link"
                                ]),
                                href: productLogoUrl,
                                "aria-label": productLogoAriaLabel,
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "productPageNav",
                                "data-product-key": productKey ?? 'jira',
                                children: productLogo
                            })
                        }),
                        isOpenSearch ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $96jet.default), {
                            isOpenSearch: isOpenSearch,
                            setIsOpenSearch: setIsOpenSearch,
                            parentType: "ProductNav",
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _b8yqtfvk"
                            ])
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.default), {
                            globalLinksProps: productPageNavLinks,
                            globalLinksRef: linksRef,
                            showMore: shouldShowMoreItems,
                            setShowMore: showMoreItems,
                            maxLinks: maxItems
                        })
                    ]
                }),
                !isOpenSearch && isShowSearchBarAndProfileContainer && !shouldShowMoreItems && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7XaVV.default), {
                    isShowTryNowLink: isShowTryNowLink,
                    // @ts-ignore
                    ctaButtonColor: tryNowCTAButtonBackgroundColor,
                    productKey: productKey,
                    isShowSearchButton: isShowSearchButton,
                    setIsOpenSearch: setIsOpenSearch,
                    navigationTrynowCtaText: navigationTrynowCtaText,
                    navigationTrynowCtaUrl: navigationTrynowCtaUrl,
                    navigationTrynowCtaOnClick: navigationTrynowCtaOnClick,
                    navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant,
                    searchAndProfileRef: searchAndProfileRef,
                    positionTryNowCtaOnRight: positionTryNowCtaOnRight,
                    isShowAppSwitcher: isShowAppSwitcher,
                    isShowUserProfile: isShowUserProfile,
                    navType: 'productNav'
                })
            ]
        })
    });
};
const $baa9d0462e9c7f45$export$4f0322cadbe6a886 = ({ productLogo: productLogo, productLogoUrl: productLogoUrl, productLogoAriaLabel: productLogoAriaLabel, productKey: productKey, productPageNavLinks: productPageNavLinks, isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = true, tryNowCTAButtonBackgroundColor: tryNowCTAButtonBackgroundColor, isShowSearchButton: isShowSearchButton = true, navigationTrynowCtaText: navigationTrynowCtaText, navigationTrynowCtaUrl: navigationTrynowCtaUrl = '/try', navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant = 'primary', mobileLogo: mobileLogo, mobileLinksSections: mobileLinksSections, isIncludeMobileCTA: isIncludeMobileCTA = true, mobileCtaText: mobileCtaText, mobileCtaUrl: mobileCtaUrl = '/software/jira/free', mobileCtaOnClick: mobileCtaOnClick, mobileCtaButtonVariant: mobileCtaButtonVariant = 'primary', isIncludeMobileAtlassianLogo: isIncludeMobileAtlassianLogo = true, additionalMenuPageObjectsArray: additionalMenuPageObjectsArray = [], positionTryNowCtaOnRight: positionTryNowCtaOnRight = false, isShowAppSwitcher: isShowAppSwitcher = true, isShowUserProfile: isShowUserProfile = true, isShowTabletDropdown: isShowTabletDropdown = true, isTemplatesTabInHeader: isTemplatesTabInHeader })=>{
    const intl = (0, $8e22h.default)();
    const [isOpenSearch, setIsOpenSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(false);
    const defaultCtaText = intl.formatMessage({
        id: 'productpagesubnav.try-now-button-label',
        defaultMessage: 'Get it free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: productPageNavLinks.map((link)=>link.globalLinksKey),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("header", {
            className: (0, $2jatx.default)([
                "_1e0c1ule _kqsw1if8 _152tidpf _1pbyqfx8 _1pvkglyw _qcqz1ule",
                "product-page-nav-container"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _1bah1y6m _kqswh2mm _4cvr1h6o _bfhk1afi _16jlkb7n _1o9zkb7n _i0dlf1ug _1pbyqfx8 _1bsb1osq _4t3i88uy",
                        "product-page-desktop-nav"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i88uy _1bsb88uy _1e0c1txw _4cvr1h6o _1bah1h6o _bfhku5k9"
                            ]),
                            style: {
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: (0, $jQ0cd.useLocalizedHref)('/'),
                                "aria-label": intl.formatMessage({
                                    id: 'productPageNav.logo-label',
                                    defaultMessage: 'Atlassian logo'
                                }),
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "productPageSubNav",
                                "data-product-key": "home",
                                className: (0, $2jatx.default)([
                                    "_4t3i8vuz _1bsb8vuz _1e0c1txw _1bah1h6o _4cvr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $zADBD.AtlassianIcon), {
                                    size: "medium",
                                    appearance: "inverse"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($baa9d0462e9c7f45$var$ProductPageSubNavLinks, {
                            productLogo: productLogo,
                            productLogoUrl: productLogoUrl,
                            productLogoAriaLabel: productLogoAriaLabel,
                            productKey: productKey,
                            productPageNavLinks: productPageNavLinks,
                            isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer,
                            isShowTryNowLink: isShowTryNowLink,
                            tryNowCTAButtonBackgroundColor: tryNowCTAButtonBackgroundColor,
                            isShowSearchButton: isShowSearchButton,
                            isOpenSearch: isOpenSearch,
                            setIsOpenSearch: setIsOpenSearch,
                            navigationTrynowCtaText: navigationTrynowCtaText ?? defaultCtaText,
                            navigationTrynowCtaUrl: navigationTrynowCtaUrl,
                            navigationTrynowCtaOnClick: navigationTrynowCtaOnClick,
                            navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant,
                            positionTryNowCtaOnRight: positionTryNowCtaOnRight,
                            isShowAppSwitcher: isShowAppSwitcher,
                            isShowUserProfile: isShowUserProfile,
                            isTemplatesTabInHeader: isTemplatesTabInHeader
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0cglyw",
                        "product-page-mobile-nav"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Itfg.MobileProductPageNav), {
                        productKey: productKey,
                        mobileLogo: mobileLogo,
                        mobileLogoAriaLabel: productLogoAriaLabel,
                        mobileLogoHref: productLogoUrl,
                        mobileLogoDataEventContainer: 'productPageNavLogo',
                        mobileLinksSections: mobileLinksSections,
                        isIncludeCTA: isIncludeMobileCTA,
                        ctaText: mobileCtaText ?? defaultCtaText,
                        ctaUrl: mobileCtaUrl,
                        ctaOnClick: mobileCtaOnClick,
                        ctaButtonVariant: mobileCtaButtonVariant,
                        isIncludeAtlassianLogo: isIncludeMobileAtlassianLogo,
                        isShowTryNowLink: isShowTryNowLink,
                        additionalMenuPageObjectsArray: additionalMenuPageObjectsArray,
                        isShowSearchButton: isShowSearchButton,
                        isShowAppSwitcher: isShowAppSwitcher,
                        isShowUserProfile: isShowUserProfile,
                        isShowTabletDropdown: isShowTabletDropdown,
                        navType: 'productNav'
                    })
                })
            ]
        })
    });
};

});
parcelRegister("jUCHH", function(module, exports) {
$parcel$export(module.exports, "useMore", function () { return $21d6eec05f361950$export$d4ac5645cddd37f3; });

var $1oC0p = parcelRequire("1oC0p");
function $21d6eec05f361950$var$isElementNode(node) {
    return node.nodeType === 1;
}
function $21d6eec05f361950$var$getElementWidth(node) {
    if (!node) return 0;
    if (node.clientWidth > 0) return node.clientWidth;
    // If clientWidth is 0 (likely because it's position: absolute/hidden),
    // try to measure the first child's width which should be the anchor tag
    const firstChild = node.firstElementChild;
    if (firstChild) {
        const rect = firstChild.getBoundingClientRect();
        return rect.width;
    }
    return 0;
}
/**
 * @description Calculates the max number of links can live in the global nav before having to render the 'show more' button
 *
 * It calculates the available width by comparing the distance between the 2 refs:
 * Left: <GlobalNavLinksContainer />
 * Right: <SearchAndProfile />
 *
 * It steps through all the children of the global nav links containers (children being the links).
 * On each loop it checks if the sum is greater than the availableWidth.
 *
 * If it is greater than the available width, then spit out the previous count as max children
 *
 * @param left Right element of global nav (<GlobalNavLinksContainer />)
 * @param right Right element of global nav (<SearchAndProfile />)
 * @param currentMaxChildren
 * @param buffer number of pixels to shrink available width by
 * @returns number of links that can be displayed in global nav bar
 */ // eslint-disable-next-line complexity
function $21d6eec05f361950$var$calculateMaxChildren(left, right, currentMaxChildren, buffer) {
    if (!left.current || !right.current) return 0;
    // with rewrite of global nav (JFIND-1024) it no longer uses gap but padding so this uses the default of 0px
    // if padding is changed so will the fallback number for it to accurately calculate maxChildren
    const unparsedGap = getComputedStyle(left.current).gap;
    const gap = unparsedGap.endsWith('px') ? parseInt(unparsedGap) : unparsedGap.endsWith('rem') ? parseInt(unparsedGap) * 16 : 0;
    // remove the More/Less button
    const totalChildren = left.current.childNodes.length - 1;
    const { right: leftElRight, left: leftElLeft } = left.current.getBoundingClientRect();
    const { left: rightElLeft } = right.current.getBoundingClientRect();
    // the more/less element is always the last element child
    const moreOrLessElement = left.current.lastElementChild;
    // if the current max is less than the total possible children,
    // we're hiding some and showing More+
    const moreOrLessVisible = currentMaxChildren < totalChildren;
    // skip calculation if the screen is large enough to hold both
    // sections plus the buffer
    if (rightElLeft - leftElRight >= buffer && !moreOrLessVisible) return totalChildren;
    // how large can the UList be for the links
    const availableWidth = rightElLeft - leftElLeft - buffer;
    let currentMaxWidth = 0;
    let maxChildren = 0;
    for (const [index, childNode] of left.current.childNodes.entries()){
        // skip non-element children; we shouldn't need this
        if (!$21d6eec05f361950$var$isElementNode(childNode)) continue;
        const node = childNode;
        // this is the More/Less button; don't try to place it, because we'll insert based on other elements
        if (index === left.current.childNodes.length - 1) continue;
        // skip last link element because we accounted for it in the previous element,
        // as there can't be fewer than two items in More menu
        if (index === left.current.childNodes.length - 2) continue;
        // look at the second-to-last link element, because More+ must always
        // include 2 or more items
        const isSecondToLastLinkElement = index === left.current.childNodes.length - 3;
        const lastTwoElementsWidth = $21d6eec05f361950$var$getElementWidth(node) + (node.nextElementSibling ? $21d6eec05f361950$var$getElementWidth(node.nextElementSibling) : 0);
        const nextWidth = currentMaxWidth + (isSecondToLastLinkElement ? lastTwoElementsWidth : $21d6eec05f361950$var$getElementWidth(node)) + gap;
        if (maxChildren === 0 || nextWidth + (!isSecondToLastLinkElement ? $21d6eec05f361950$var$getElementWidth(moreOrLessElement) : 0) < availableWidth) {
            currentMaxWidth = nextWidth;
            if (isSecondToLastLinkElement) maxChildren += 2;
            else maxChildren += 1;
            continue;
        } else break;
    }
    return maxChildren;
}
function $21d6eec05f361950$var$useResizeObserver(ref) {
    const [observer, setObserver] = (0, $1oC0p.useState)();
    const [rect, setRect] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        const obs = new ResizeObserver((entries)=>{
            requestAnimationFrame(()=>{
                if (entries[0]) setRect(entries[0].contentRect);
            });
        });
        setObserver(obs);
    }, [
        ref
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (ref.current) observer?.observe(ref.current);
        return ()=>observer && observer.disconnect();
    }, [
        observer,
        ref
    ]);
    return rect;
}
function $21d6eec05f361950$export$d4ac5645cddd37f3({ leftElementRef: leftElementRef, rightElementRef: rightElementRef, buffer: buffer = 16, initialMaxItems: initialMaxItems = 0 }) {
    const [maxLinks, setMaxLinks] = (0, $1oC0p.useState)(initialMaxItems);
    const [showMore, setShowMore] = (0, $1oC0p.useState)(false);
    const parentElRef = (0, $1oC0p.useRef)(leftElementRef.current?.parentElement);
    const [mutationTrigger, setMutationTrigger] = (0, $1oC0p.useState)(0);
    const mutationDebounceRef = (0, $1oC0p.useRef)(null);
    const lastCalculatedMaxRef = (0, $1oC0p.useRef)(initialMaxItems);
    (0, $1oC0p.useEffect)(()=>{
        if (leftElementRef.current) // This is the full left side that includes the logo, nav links and space before the search+profile component
        parentElRef.current = leftElementRef.current.closest?.('nav') ?? leftElementRef.current.parentElement?.parentElement;
    }, [
        leftElementRef
    ]);
    // Watch the right element (SearchAndProfile) for size changes that might affect layout
    (0, $1oC0p.useEffect)(()=>{
        if (!rightElementRef.current) return;
        let lastWidth = rightElementRef.current.clientWidth;
        const observer = new ResizeObserver(()=>{
            const currentWidth = rightElementRef.current?.clientWidth ?? 0;
            // Only trigger recalculation if width actually changed
            if (currentWidth !== lastWidth) {
                lastWidth = currentWidth;
                // Debounce updates to avoid excessive recalculations
                if (mutationDebounceRef.current) clearTimeout(mutationDebounceRef.current);
                mutationDebounceRef.current = setTimeout(()=>{
                    setMutationTrigger((prev)=>prev + 1);
                }, 50);
            }
        });
        observer.observe(rightElementRef.current);
        return ()=>{
            observer.disconnect();
            if (mutationDebounceRef.current) clearTimeout(mutationDebounceRef.current);
        };
    }, [
        rightElementRef
    ]);
    const rect = $21d6eec05f361950$var$useResizeObserver(parentElRef);
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (rect?.right) {
            const maxChildren = $21d6eec05f361950$var$calculateMaxChildren(leftElementRef, rightElementRef, lastCalculatedMaxRef.current, buffer);
            // Only update state if the calculated value actually changed
            if (maxChildren !== lastCalculatedMaxRef.current) {
                lastCalculatedMaxRef.current = maxChildren;
                setMaxLinks(maxChildren);
            }
        }
    }, [
        leftElementRef,
        rightElementRef,
        rect?.right,
        buffer,
        mutationTrigger
    ]);
    const output = (0, $1oC0p.useMemo)(()=>({
            maxItems: maxLinks,
            shouldShowMoreItems: showMore,
            showMoreItems: setShowMore
        }), [
        showMore,
        maxLinks
    ]);
    return output;
}

});

parcelRegister("4Itfg", function(module, exports) {
$parcel$export(module.exports, "MobileProductPageNav", function () { return $e0495d591c0cef42$export$50f88648a05b2bef; });
/* mobile-product-page-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7IesZ = parcelRequire("7IesZ");

var $59F4T = parcelRequire("59F4T");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $2Df35 = parcelRequire("2Df35");

var $kNyc7 = parcelRequire("kNyc7");

var $hiOEV = parcelRequire("hiOEV");

var $5BEho = parcelRequire("5BEho");

var $3PWZ2 = parcelRequire("3PWZ2");

var $3R5TL = parcelRequire("3R5TL");

var $2a9sZ = parcelRequire("2a9sZ");

var $ibZL7 = parcelRequire("ibZL7");

var $gQZpW = parcelRequire("gQZpW");
const $e0495d591c0cef42$var$containerCss = null;
const $e0495d591c0cef42$var$shownInnerMobileDropdownMenuStyle = null;
const $e0495d591c0cef42$var$hiddenInnerMobileDropdownMenuStyle = null;
const $e0495d591c0cef42$var$containerClosedCss = null;
const $e0495d591c0cef42$var$containerOpenCss = null;
const $e0495d591c0cef42$var$navBarClosedCss = null;
const $e0495d591c0cef42$var$navBarOpenCss = null;
const $e0495d591c0cef42$var$menuContentStyle = null;
const $e0495d591c0cef42$var$slideInLeft = null;
const $e0495d591c0cef42$var$slideInDown = null;
const $e0495d591c0cef42$var$slideInUp = null;
const $e0495d591c0cef42$var$slideInLeftCss = null;
const $e0495d591c0cef42$var$slideInUpCss = null;
const $e0495d591c0cef42$var$slideInDownCss = null;
const $e0495d591c0cef42$var$MobileNavProductPageDropdownMenu = ({ isUserLoggedIn: isUserLoggedIn, menuPage: menuPage = 'default', firstOpen: firstOpen, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, mobileLinksSections: mobileLinksSections, productKey: productKey, isIncludeCTA: isIncludeCTA = true, ctaText: ctaText = 'Get it free', ctaUrl: ctaUrl = '/software/jira/free', ctaOnClick: ctaOnClick, ctaButtonVariant: ctaButtonVariant = 'primary', isIncludeAtlassianLogo: isIncludeAtlassianLogo = true, additionalMenuPageObjectsArray: additionalMenuPageObjectsArray = [], isShowSearchButton: isShowSearchButton = true })=>{
    const MobileNavLinksMenuPage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3R5TL.MobileNavLinks), {
        isLoggedIn: isUserLoggedIn,
        handleMenuPage: handleMenuPage,
        mobileLinksSections: mobileLinksSections,
        productKey: productKey,
        isIncludeCTA: isIncludeCTA,
        ctaText: ctaText,
        ctaUrl: ctaUrl,
        ctaOnClick: ctaOnClick,
        ctaButtonVariant: ctaButtonVariant,
        isIncludeAtlassianLogo: isIncludeAtlassianLogo,
        isShowSearchButton: isShowSearchButton
    });
    const menuPages = [
        {
            pageKey: 'default',
            content: MobileNavLinksMenuPage
        }
    ];
    const intl = (0, $8e22h.default)();
    const isNavigatingBackRef = (0, $1oC0p.useRef)(false);
    if (additionalMenuPageObjectsArray.length > 0) for (const additionalMenuPageObject of additionalMenuPageObjectsArray){
        const { menuPageKey: menuPageKey, menuPageObjects: menuPageObjects } = additionalMenuPageObject;
        menuPages.push({
            pageKey: menuPageKey,
            content: menuPageObjects
        });
    }
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            menuPage === 'default' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    isNavigatingBackRef.current && "",
                    isNavigatingBackRef.current && "_tzy4idpf _y44vr3ys"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1bsb1osq _bozg7vkz _y4ti7vkz _1q511tcg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kNyc7.default), {
                        isMobileView: true,
                        readOnly: true,
                        parentType: "ProductNav",
                        menuPage: menuPage,
                        onFocus: ()=>{
                            if (!isNavigatingBackRef.current) handleMenuPage('search');
                            createAnalyticsEvent({
                                eventName: 'searchOpen',
                                eventType: 'ui',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'searchButtonMobileV2',
                                source: 'productNav',
                                attributes: {
                                    product: 'marketing',
                                    pageUrl: window.location.href,
                                    pagePath: window.location.pathname
                                }
                            }).fire();
                        }
                    }, "default-search-bar")
                })
            }),
            menuPages.map(({ pageKey: pageKey, content: content }, index)=>{
                const isDefault = menuPage === 'default';
                const isVisible = menuPage === pageKey;
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                isDefault && !firstOpen && "",
                                isDefault && !firstOpen && "_tzy4idpf _y44vr3ys",
                                !isDefault && "",
                                !isDefault && "_tzy4idpf _y44v108a",
                                isVisible ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                                "inner-mobile-dropdown-menu"
                            ]),
                            children: content
                        }, pageKey),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gQZpW.MobileProductPageNavDropdowns), {
                            productKey: productKey,
                            menuPage: menuPage
                        })
                    ]
                }, index);
            }),
            menuPage === 'search' && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                    "searchinnermenu inner-mobile-dropdown-menu"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        style: {
                            all: 'unset',
                            width: 'fit-content'
                        },
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            isNavigatingBackRef.current = true;
                            handleFirstOpen(false);
                            handleMenuPage('default');
                            // reset the flag after navigation
                            setTimeout(()=>{
                                isNavigatingBackRef.current = false;
                            }, 100);
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_tzy4idpf _y44v108a",
                                "_syaz6x5g _1e0c1txw _4cvr1h6o _1q511tcg"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                                    label: "",
                                    spacing: "spacious"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: intl.formatMessage({
                                        id: 'globalnavv2.menu-back',
                                        defaultMessage: 'Back'
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_tzy4idpf _y44v8blq",
                            "_1bsb1osq _kqswh2mm"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kNyc7.default), {
                            isMobileView: true,
                            parentType: "ProductNav",
                            menuPage: menuPage
                        })
                    })
                ]
            })
        ]
    });
};
const $e0495d591c0cef42$var$defaultJiraLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
    brand: "jira",
    type: "logo",
    appearance: "brand",
    height: '25.6px',
    width: '60px'
});
const $e0495d591c0cef42$export$50f88648a05b2bef = ({ productKey: productKey, mobileLogo: mobileLogo = $e0495d591c0cef42$var$defaultJiraLogo, mobileLogoAriaLabel: mobileLogoAriaLabel = 'Jira logo', mobileLogoHref: mobileLogoHref = '/', mobileLogoDataEventContainer: mobileLogoDataEventContainer = 'ProductPageNavJiraV2', mobileLinksSections: mobileLinksSections, isIncludeCTA: isIncludeCTA = true, ctaText: ctaText = 'Get it free', ctaUrl: ctaUrl = '/software/jira/free', ctaOnClick: ctaOnClick, ctaButtonVariant: ctaButtonVariant = 'primary', isIncludeAtlassianLogo: isIncludeAtlassianLogo = true, isShowTryNowLink: isShowTryNowLink = true, additionalMenuPageObjectsArray: additionalMenuPageObjectsArray = [], isShowSearchButton: isShowSearchButton = true, isShowAppSwitcher: isShowAppSwitcher = true, isShowUserProfile: isShowUserProfile = true, isShowTabletDropdown: isShowTabletDropdown = true, navType: navType = 'productNav' })=>{
    const [isOpenSearch, setIsOpenSearch] = (0, $1oC0p.useState)(false);
    const intl = (0, $8e22h.default)();
    const { userInfo: userInfo, showMenu: showMenu, isDisplayLoggedInUseDropdown: isDisplayLoggedInUseDropdown, firstOpen: firstOpen, menuPage: menuPage, handleToggleMenu: handleToggleMenu, handleFirstOpen: handleFirstOpen, handleMenuPage: handleMenuPage, handleClickAvatar: handleClickAvatar } = (0, $hiOEV.useMobileNavDisplay)(isOpenSearch);
    const { onSwitchAccountClick: onSwitchAccountClick, onManageProfileClick: onManageProfileClick, onManageLicensesClick: onManageLicensesClick, onLogOutClick: onLogOutClick } = (0, $59F4T.useGlobalNavUserProfileClickActions)({
        email: userInfo.email
    });
    const mobileGlobalNavDropdownMenu = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)($e0495d591c0cef42$var$MobileNavProductPageDropdownMenu, {
            isUserLoggedIn: userInfo.isUserLoggedIn,
            menuPage: menuPage,
            firstOpen: firstOpen,
            handleMenuPage: handleMenuPage,
            handleFirstOpen: handleFirstOpen,
            mobileLinksSections: mobileLinksSections,
            productKey: productKey,
            isIncludeCTA: isIncludeCTA,
            ctaText: ctaText,
            ctaButtonVariant: ctaButtonVariant,
            ctaUrl: ctaUrl,
            ctaOnClick: ctaOnClick,
            isIncludeAtlassianLogo: isIncludeAtlassianLogo,
            additionalMenuPageObjectsArray: additionalMenuPageObjectsArray,
            isShowSearchButton: isShowSearchButton
        });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
        "aria-label": intl.formatMessage({
            id: 'productPageNav.main-nav-label',
            defaultMessage: 'Main'
        }),
        className: (0, $2jatx.default)([
            "_11q71afi _1e0c1txw _2lx21bp4 _zulputpp",
            showMenu ? "_tnru1kxc _1rfm1osq _1o831wug _98bk1wug _13zm1n9t _xaejidpf _1kmxftgi _1ggm1tcg _1ykz1tcg _1mae1tcg _2rfoqfx8 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5BEho.SkipToContent), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    showMenu ? "_1wfqidpf _15vtpxbi _1e0c1txw _4cvr1h6o _1bah1yb4" : "_18zrpxbi _1wfqidpf _15vtpxbi _1e0c1txw _4cvr1h6o _1bah1yb4"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ibZL7.MobileNavTop), {
                    productKey: productKey,
                    isLoggedIn: userInfo.isUserLoggedIn,
                    userName: userInfo.name ?? '',
                    picture: userInfo.picture ?? '',
                    handleClickAvatar: handleClickAvatar,
                    showMenu: showMenu,
                    handleToggleMenu: handleToggleMenu,
                    menuPage: menuPage,
                    handleMenuPage: handleMenuPage,
                    handleFirstOpen: handleFirstOpen,
                    mobileLogo: mobileLogo,
                    mobileLogoAriaLabel: mobileLogoAriaLabel,
                    mobileLogoHref: mobileLogoHref,
                    mobileLogoDataEventContainer: mobileLogoDataEventContainer,
                    isOpenSearch: isOpenSearch,
                    setIsOpenSearch: setIsOpenSearch,
                    tabletDropdownMenu: mobileGlobalNavDropdownMenu(),
                    isProductPage: true,
                    isShowTryNowLink: isShowTryNowLink,
                    navigationTrynowCtaText: ctaText,
                    navigationTrynowCtaUrl: ctaUrl,
                    navigationTrynowCtaOnClick: ctaOnClick,
                    navigationTrynowCtaButtonVariant: ctaButtonVariant,
                    isShowSearchButton: isShowSearchButton,
                    isShowAppSwitcher: isShowAppSwitcher,
                    isShowUserProfile: isShowUserProfile,
                    isShowTabletDropdown: isShowTabletDropdown,
                    navType: navType
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                id: "nav-mobile-dropdown-menu",
                className: (0, $2jatx.default)([
                    "_1e0cglyw _1bsb1wug _181nglyw",
                    showMenu && "_1e0c1ule"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3PWZ2.Divider), {})
                    }),
                    isDisplayLoggedInUseDropdown ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2a9sZ.default), {
                        userInfo: {
                            displayName: userInfo.name || '',
                            email: userInfo.email || '',
                            avatar: userInfo.picture || ''
                        },
                        onLogOutClick: onLogOutClick,
                        onManageLicensesClick: onManageLicensesClick,
                        onManageProfileClick: onManageProfileClick,
                        onSwitchAccountClick: onSwitchAccountClick
                    }) : mobileGlobalNavDropdownMenu()
                ]
            })
        ]
    });
};

});
parcelRegister("59F4T", function(module, exports) {
$parcel$export(module.exports, "analyticsLabels", function () { return $4f4f420da0ba0873$export$6363339a4cf0caa7; });
$parcel$export(module.exports, "useGlobalNavUserProfileClickActions", function () { return $4f4f420da0ba0873$export$21423259c10ee0e; });
$parcel$export(module.exports, "GlobalNavUserProfile", function () { return $4f4f420da0ba0873$export$119e15e0a961cff6; });
/* user-profile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eY3N6 = parcelRequire("eY3N6");

var $gx3aw = parcelRequire("gx3aw");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $3riD8 = parcelRequire("3riD8");

var $4lDDF = parcelRequire("4lDDF");

var $b3mu7 = parcelRequire("b3mu7");

var $g9ZvA = parcelRequire("g9ZvA");
const $4f4f420da0ba0873$export$6363339a4cf0caa7 = {
    'JoinSiteUserDropdown.logOut': 'Log out',
    'JoinSiteUserDropdown.logIn': 'Sign in',
    'JoinSiteUserDropdown.joinTeam': 'Find my team',
    'JoinSiteUserDropdown.profile': 'Profile',
    'JoinSiteUserDropdown.switchAccount': 'Switch Account',
    'JoinSiteUserDropdown.licenses': 'Licenses'
};
const $4f4f420da0ba0873$var$NEXT_PUBLIC_API_MAC_URL = "https://my.atlassian.com";
const $4f4f420da0ba0873$var$NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
const $4f4f420da0ba0873$var$NEXT_PUBLIC_API_PRIVATE_BASE_URL = "https://www.atlassian.com/gateway/api";
const $4f4f420da0ba0873$var$generalSigninPromptParentDivStyle = null;
const $4f4f420da0ba0873$export$21423259c10ee0e = ({ email: email })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const onManageLicensesClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            name: 'bxp.globalnavdropdown.click.manage.licenses',
            label: $4f4f420da0ba0873$export$6363339a4cf0caa7['JoinSiteUserDropdown.licenses']
        }).fire();
        window.location.assign($4f4f420da0ba0873$var$NEXT_PUBLIC_API_MAC_URL);
    };
    const getManageProfileUrl = (userEmail)=>{
        const applicationParam = encodeURIComponent('wac');
        const continueUrlParam = encodeURIComponent(`${$4f4f420da0ba0873$var$NEXT_PUBLIC_IDENTITY_BASE_URL}/manage-profile`);
        const loginHintParam = encodeURIComponent(userEmail);
        return `${$4f4f420da0ba0873$var$NEXT_PUBLIC_IDENTITY_BASE_URL}/login?application=${applicationParam}&continue=${continueUrlParam}&login_hint=${loginHintParam}`;
    };
    const onManageProfileClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            name: 'bxp.globalnavdropdown.click.manage.profile',
            label: $4f4f420da0ba0873$export$6363339a4cf0caa7['JoinSiteUserDropdown.profile']
        }).fire();
        window.location.assign(getManageProfileUrl(email || ''));
    };
    const getLogoutUrl = ()=>{
        const continueUrl = window.location.href;
        return `${$4f4f420da0ba0873$var$NEXT_PUBLIC_IDENTITY_BASE_URL}/logout?continue=${encodeURIComponent(continueUrl)}`;
    };
    const onLogOutClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            name: 'bxp.globalnavdropdown.click.logout',
            label: $4f4f420da0ba0873$export$6363339a4cf0caa7['JoinSiteUserDropdown.logOut']
        }).fire();
        if (window.location.hostname === 'localhost') (0, $gx3aw.Cookie).writeCookie('login_user_detected', 'false', 3650, true);
        window.location.assign(getLogoutUrl());
    };
    const onLogInClick = ()=>{
        const baseUrl = $4f4f420da0ba0873$var$NEXT_PUBLIC_IDENTITY_BASE_URL;
        const stargateBaseUrl = $4f4f420da0ba0873$var$NEXT_PUBLIC_API_PRIVATE_BASE_URL;
        const continueUrl = stargateBaseUrl + `/start/authredirect?continue=${window.location.href}`;
        // Check if the user is on localhost and set the cookie for the domain localhost
        if (window.location.hostname === 'localhost') (0, $gx3aw.Cookie).writeCookie('login_user_detected', 'true', 3650, true);
        const isWacIcLoginEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacIcLogin);
        const applicationParam = isWacIcLoginEnabled ? '&application=wac--ic' : '';
        createAnalyticsEvent({
            action: 'clicked',
            name: 'bxp.globalnavdropdown.click.login',
            label: $4f4f420da0ba0873$export$6363339a4cf0caa7['JoinSiteUserDropdown.logIn']
        }).fire();
        const finalLoginUrl = `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}${applicationParam}`;
        window.location.assign(finalLoginUrl);
    };
    const getSwitchAccountURL = (continueUrlParam)=>{
        const continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return `${$4f4f420da0ba0873$var$NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(continueUrl)}`;
    };
    const onSwitchAccountClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            name: 'bxp.globalnavdropdown.click.switchAccount',
            label: $4f4f420da0ba0873$export$6363339a4cf0caa7['JoinSiteUserDropdown.switchAccount']
        }).fire();
        window.location.assign(getSwitchAccountURL());
    };
    return {
        onSwitchAccountClick: onSwitchAccountClick,
        onManageProfileClick: onManageProfileClick,
        onManageLicensesClick: onManageLicensesClick,
        onLogOutClick: onLogOutClick,
        onLogInClick: onLogInClick
    };
};
const $4f4f420da0ba0873$export$119e15e0a961cff6 = ({ isUseNewLoggedInUserDropdown: isUseNewLoggedInUserDropdown = false, isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig = false, setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig })=>{
    const userInfo = (0, $3riD8.useLoggedInUser)();
    const { onSwitchAccountClick: onSwitchAccountClick, onManageProfileClick: onManageProfileClick, onManageLicensesClick: onManageLicensesClick, onLogOutClick: onLogOutClick, onLogInClick: onLogInClick } = $4f4f420da0ba0873$export$21423259c10ee0e({
        email: userInfo.email
    });
    if (userInfo.requestInProgress) return 0, $g9ZvA.LoadingSpinner;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            isUseGeneralSigninPromptConfig && "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: userInfo.isUserLoggedIn ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4lDDF.LoggedInUser), {
            userInfo: {
                displayName: userInfo.name || '',
                email: userInfo.email || '',
                avatar: userInfo.picture || ''
            },
            onSwitchAccountClick: onSwitchAccountClick,
            onManageProfileClick: onManageProfileClick,
            onManageLicensesClick: onManageLicensesClick,
            onLogOutClick: onLogOutClick,
            isUseNewLoggedInUserDropdown: isUseNewLoggedInUserDropdown
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-4026-keep-land-users-on-wac",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b3mu7.LoggedOutUser), {
                onLogInClick: onLogInClick,
                isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig,
                setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig
            })
        })
    });
};

});
parcelRegister("izdHQ", function(module, exports) {
$parcel$export(module.exports, "useFeatureExposed", function () { return $cd2706265c75f9cc$export$700e85d1c81b218b; });
$parcel$export(module.exports, "FeatureExposed", function () { return $cd2706265c75f9cc$export$69e9515c65c24fd7; });
$parcel$export(module.exports, "withFeatureExposed", function () { return $cd2706265c75f9cc$export$5b987a3e4d0fe0df; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hBiKW");
var $8xWAi = parcelRequire("8xWAi");

var $fLpER = parcelRequire("fLpER");

var $iSeHD = parcelRequire("iSeHD");

var $dajtI = parcelRequire("dajtI");
function $cd2706265c75f9cc$export$700e85d1c81b218b(experimentKey, group, { conditions: conditions, metadata: metadata = {} } = {}) {
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const [enrichedMetadata, setEnrichedMetadata] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (!enrichedMetadata) setEnrichedMetadata((0, $fLpER.GASv3).enrichEventData(metadata));
    }, [
        enrichedMetadata,
        metadata
    ]);
    // Claim in commit phase so a discarded concurrent render never claims the slot.
    // Known limitation: same-key siblings in one render pass (<A /><A />) may both fire.
    const fireEligible = !!analyticsClient && (conditions ? conditions.every(Boolean) : true);
    const claimedKeyRef = (0, $1oC0p.useRef)(null);
    const claimedThisKey = claimedKeyRef.current === `${experimentKey}\u0000${group}`;
    const ownsExposure = claimedThisKey || !(0, $dajtI.hasFiredExposure)(experimentKey, group);
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (fireEligible && (0, $dajtI.claimExposureOncePerPage)(experimentKey, group)) claimedKeyRef.current = `${experimentKey}\u0000${group}`;
    }, [
        fireEligible,
        experimentKey,
        group
    ]);
    return (0, $8xWAi.useFeatureExposed)(experimentKey, group, {
        conditions: conditions ? [
            ...conditions,
            !!analyticsClient,
            ownsExposure
        ] : [
            !!analyticsClient,
            ownsExposure
        ],
        metadata: enrichedMetadata ?? metadata
    });
}
const $cd2706265c75f9cc$export$69e9515c65c24fd7 = ({ experimentKey: experimentKey, group: group, conditions: conditions, metadata: metadata, children: children })=>{
    $cd2706265c75f9cc$export$700e85d1c81b218b(experimentKey, group, {
        conditions: conditions,
        metadata: metadata
    });
    return children;
};
function $cd2706265c75f9cc$export$5b987a3e4d0fe0df(experimentKey, group, InnerComponent, options) {
    return ({ featureExposed: featureExposed, ...props })=>{
        $cd2706265c75f9cc$export$700e85d1c81b218b(experimentKey, group, {
            ...options,
            ...featureExposed
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, {
            ...props
        });
    };
}

});
parcelRegister("hBiKW", function(module, exports) {
$parcel$export(module.exports, "useFeatureExposed", function () { return (parcelRequire("8xWAi")).useFeatureExposed; });
parcelRequire("i8nHV");
var $8xWAi = parcelRequire("8xWAi");

});
parcelRegister("i8nHV", function(module, exports) {
$parcel$export(module.exports, "useFeatureExposed", function () { return (parcelRequire("8xWAi")).useFeatureExposed; });

var $leOLw = parcelRequire("leOLw");

var $8xWAi = parcelRequire("8xWAi");

var $i6AtL = parcelRequire("i6AtL");

});
parcelRegister("leOLw", function(module, exports) {

var $1oC0p = parcelRequire("1oC0p");

var $8xWAi = parcelRequire("8xWAi");
var $f76248c2cd9dfc21$export$69e9515c65c24fd7 = function FeatureExposed(_ref) {
    var experimentKey = _ref.experimentKey, group = _ref.group, conditions = _ref.conditions, metadata = _ref.metadata, children = _ref.children;
    (0, $8xWAi.useFeatureExposed)(experimentKey, group, {
        conditions: conditions,
        metadata: metadata
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children);
};

});
parcelRegister("8xWAi", function(module, exports) {
$parcel$export(module.exports, "useFeatureExposed", function () { return $638ed96d64f9611d$export$700e85d1c81b218b; });

var $f7e3P = parcelRequire("f7e3P");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $638ed96d64f9611d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $638ed96d64f9611d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $638ed96d64f9611d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f7e3P.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $638ed96d64f9611d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $638ed96d64f9611d$export$700e85d1c81b218b(experimentKey, group) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, conditions = _ref.conditions, metadata = _ref.metadata;
    var fired = (0, $1oC0p.useRef)(false);
    var _useAnalyticsEvents = (0, $eY3N6.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    (0, $1oC0p.useEffect)(function() {
        if (fired.current) return;
        var featureExposurePreconditionsMet = !conditions || conditions.filter(function(condition) {
            return !condition;
        }).length === 0;
        if (!featureExposurePreconditionsMet) return;
        // fire manual exposure event.
        createAnalyticsEvent({
            source: experimentKey,
            actionSubject: 'feature',
            action: 'exposed',
            actionSubjectId: experimentKey,
            attributes: $638ed96d64f9611d$var$_objectSpread({
                group: group
            }, metadata),
            eventType: 'track'
        }).fire();
        fired.current = true;
    }, [
        experimentKey,
        group,
        conditions,
        metadata,
        createAnalyticsEvent
    ]);
    return {
        hasFired: fired.current
    };
}

});
parcelRegister("f7e3P", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0126a9fad1b415f$export$2e2bcd8739ae039; });

var $XEYDl = parcelRequire("XEYDl");
function $b0126a9fad1b415f$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $XEYDl.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("XEYDl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0b354bf94b5f13a2$export$2e2bcd8739ae039; });

var $HTC0t = parcelRequire("HTC0t");

var $gHUDB = parcelRequire("gHUDB");
function $0b354bf94b5f13a2$export$2e2bcd8739ae039(t) {
    var i = (0, $gHUDB.default)(t, "string");
    return "symbol" == (0, $HTC0t.default)(i) ? i : i + "";
}

});
parcelRegister("HTC0t", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $083f27a7750aed12$export$2e2bcd8739ae039; });
function $083f27a7750aed12$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $083f27a7750aed12$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $083f27a7750aed12$export$2e2bcd8739ae039(o);
}

});

parcelRegister("gHUDB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c29c989775e1fe5d$export$2e2bcd8739ae039; });

var $HTC0t = parcelRequire("HTC0t");
function $c29c989775e1fe5d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $HTC0t.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $HTC0t.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("i6AtL", function(module, exports) {

var $f7e3P = parcelRequire("f7e3P");

var $kS96b = parcelRequire("kS96b");

var $1oC0p = parcelRequire("1oC0p");

var $8xWAi = parcelRequire("8xWAi");
var $d2e51588f02a5ab8$var$_excluded = [
    "featureExposed"
];
function $d2e51588f02a5ab8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d2e51588f02a5ab8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d2e51588f02a5ab8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f7e3P.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d2e51588f02a5ab8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d2e51588f02a5ab8$export$5b987a3e4d0fe0df(experimentKey, group, InnerComponent, options) {
    return function(_ref) {
        var featureExposed = _ref.featureExposed, props = (0, $kS96b.default)(_ref, $d2e51588f02a5ab8$var$_excluded);
        (0, $8xWAi.useFeatureExposed)(experimentKey, group, $d2e51588f02a5ab8$var$_objectSpread($d2e51588f02a5ab8$var$_objectSpread({}, options), featureExposed));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(InnerComponent, props);
    };
}

});
parcelRegister("kS96b", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f31fe8a1e032babb$export$2e2bcd8739ae039; });

var $c72ie = parcelRequire("c72ie");
function $f31fe8a1e032babb$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $c72ie.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("c72ie", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d17eadb73cd8101$export$2e2bcd8739ae039; });
function $8d17eadb73cd8101$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});






parcelRegister("4lDDF", function(module, exports) {
$parcel$export(module.exports, "LoggedInUser", function () { return $9d0c708cc01460a5$export$5effdf6804a02eac; });
/* loggedin-user-view.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $ddxTX = parcelRequire("ddxTX");

var $hCc2m = parcelRequire("hCc2m");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $9KOR3 = parcelRequire("9KOR3");

var $4CtXE = parcelRequire("4CtXE");

var $hZE0S = parcelRequire("hZE0S");

var $g9ZvA = parcelRequire("g9ZvA");

var $60Muw = parcelRequire("60Muw");

const $9d0c708cc01460a5$var$DropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(()=>// @ts-ignore
    (parcelRequire("g2SyO")).then(({ DropdownMenu: DropdownMenu })=>({
            default: DropdownMenu
        })));

const $9d0c708cc01460a5$var$DropdownItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(()=>(parcelRequire("g9iJq")).then(({ DropdownItem: DropdownItem })=>({
            default: DropdownItem
        })));

const $9d0c708cc01460a5$var$DropdownItemGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(()=>(parcelRequire("g9iJq")).then(({ DropdownItemGroup: DropdownItemGroup })=>({
            default: DropdownItemGroup
        })));
const $9d0c708cc01460a5$export$94d1de242beb0fe2 = ({ userInfo: userInfo, onLogOutClick: onLogOutClick, onManageLicensesClick: onManageLicensesClick, onManageProfileClick: onManageProfileClick, onSwitchAccountClick: onSwitchAccountClick })=>// @ts-ignore
    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownMenu, {
        shouldRenderToParent: true,
        spacing: "compact",
        placement: "bottom-end",
        // @ts-ignore
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                className: (0, $2jatx.default)([
                    "_1yt4ze3t _1bsbv47k _4t3iv47k _2rko1ssb",
                    "avatar-button"
                ]),
                ...props,
                iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hZE0S.WACAvatar), {
                    name: userInfo.displayName,
                    src: userInfo.avatar,
                    size: 'small',
                    showTooltip: true
                }),
                ref: triggerRef,
                style: {
                    backgroundColor: 'transparent'
                }
            }),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "global-nav-user-profile-container-user-loggedin",
            className: (0, $2jatx.default)([
                "_ect4q6fz _1bsbr0r7 _vwz4utpp _18e6b3bt _1umoze3t _1rzf1wug _3n48q6fz _by5nutpp"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)($9d0c708cc01460a5$var$DropdownItemGroup, {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        isDisabled: true,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $60Muw.UserDetailsCard), {
                            name: userInfo.displayName,
                            src: userInfo.avatar,
                            email: userInfo.email,
                            size: 'small'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        onClick: onSwitchAccountClick,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $4CtXE.messages).switchAccount
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        onClick: onManageProfileClick,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $4CtXE.messages).profile
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        onClick: onManageLicensesClick,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $4CtXE.messages).licenses
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        onClick: onLogOutClick,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $4CtXE.messages).logOut
                        })
                    })
                ]
            })
        })
    });
const $9d0c708cc01460a5$export$155fa01529662abd = ({ userInfo: userInfo, onLogOutClick: onLogOutClick, onManageLicensesClick: onManageLicensesClick, onManageProfileClick: onManageProfileClick, onSwitchAccountClick: onSwitchAccountClick })=>{
    const [isNameLengthExceedLimit, setIsNameLengthExceedLimit] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(false);
    const [displayedName, setDisplayedName] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(()=>userInfo.displayName ?? '');
    const { setIsLoggedInUserProfileDropdownOpen: setIsLoggedInUserProfileDropdownOpen } = (0, $9KOR3.useGlobalNavContext)();
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(()=>{
        if (userInfo.displayName.length > 15) {
            setIsNameLengthExceedLimit(true);
            setDisplayedName(userInfo.displayName.slice(0, 15));
        }
    }, [
        userInfo.displayName
    ]);
    return(// @ts-ignore
    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownMenu, {
        shouldRenderToParent: true,
        placement: "bottom-end",
        onOpenChange: (attrs)=>{
            setIsLoggedInUserProfileDropdownOpen(attrs.isOpen);
        },
        // @ts-ignore
        // eslint-disable-next-line react/no-unstable-nested-components
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                className: "avatar-button",
                ...props,
                iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hZE0S.WACAvatar), {
                    name: userInfo.displayName,
                    src: userInfo.avatar,
                    size: 'medium',
                    showTooltip: true
                }),
                ref: triggerRef,
                style: {
                    backgroundColor: 'transparent',
                    padding: '0px',
                    fontSize: '.875rem',
                    fontWeight: '600',
                    alignItems: 'center',
                    gap: '4px'
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    "aria-hidden": "true",
                    children: [
                        displayedName,
                        isNameLengthExceedLimit ? '...' : ''
                    ]
                })
            }),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "global-nav-user-profile-container-user-loggedin",
            className: (0, $2jatx.default)([
                "_1bsbncxg _1yt41jfw _vwz4pxbi _keweze3t _d4lf1crf _1t8v1j28 _j6fnglyw _1hw6glyw"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)($9d0c708cc01460a5$var$DropdownItemGroup, {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        isDisabled: true,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_1wyb1crf _k48p1fw0 _1p1dangw _syaz1pfd _vwz47vkz _ect4z4z1 _1e0c1ule"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text'))
                            },
                            children: userInfo.email
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        onClick: onSwitchAccountClick,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_1wybdlk8 _vwz41tcg _ect4z4z1 _1e0c1ule _30l3u5k9"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $4CtXE.messages).switchAccount
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        onClick: onManageProfileClick,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_1wybdlk8 _vwz41tcg _ect4z4z1 _1e0c1ule _30l3u5k9"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $4CtXE.messages).profile
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        onClick: onManageLicensesClick,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_1wybdlk8 _vwz41tcg _ect4z4z1 _1e0c1ule _30l3u5k9"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $4CtXE.messages).licenses
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$var$DropdownItem, {
                        onClick: onLogOutClick,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_1wybdlk8 _vwz41tcg _ect4z4z1 _1e0c1ule _30l3u5k9"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $4CtXE.messages).logOut
                            })
                        })
                    })
                ]
            })
        })
    }));
};
const $9d0c708cc01460a5$export$5effdf6804a02eac = ({ userInfo: userInfo, onLogOutClick: onLogOutClick, onManageLicensesClick: onManageLicensesClick, onManageProfileClick: onManageProfileClick, onSwitchAccountClick: onSwitchAccountClick, isUseNewLoggedInUserDropdown: isUseNewLoggedInUserDropdown = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        fallback: (0, $g9ZvA.LoadingSpinner),
        interactionName: 'loggedin-user-view',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "main-container",
            className: (0, $2jatx.default)([
                "_ect4q6fz"
            ]),
            children: isUseNewLoggedInUserDropdown ? /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$export$155fa01529662abd, {
                userInfo: userInfo,
                onLogOutClick: onLogOutClick,
                onManageLicensesClick: onManageLicensesClick,
                onManageProfileClick: onManageProfileClick,
                onSwitchAccountClick: onSwitchAccountClick
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)($9d0c708cc01460a5$export$94d1de242beb0fe2, {
                userInfo: userInfo,
                onLogOutClick: onLogOutClick,
                onManageLicensesClick: onManageLicensesClick,
                onManageProfileClick: onManageProfileClick,
                onSwitchAccountClick: onSwitchAccountClick
            })
        })
    });
};
const $9d0c708cc01460a5$var$mainContainer = null;
const $9d0c708cc01460a5$var$loggedInUserContainer = null;
const $9d0c708cc01460a5$var$updatedLoggedInUserContainer = null;
const $9d0c708cc01460a5$var$dropdownListStyle = null;
const $9d0c708cc01460a5$var$disabledItemStyle = null;
const $9d0c708cc01460a5$var$dropdownItemStyle = null;
const $9d0c708cc01460a5$var$overrideAvatarButtonStyle = null;

});
parcelRegister("4CtXE", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $f1ea35f652866264$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $f1ea35f652866264$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    logIn: {
        id: `JoinSiteUserDropdown.logIn`,
        defaultMessage: 'Sign in'
    },
    logInAlternative: {
        id: `JoinSiteUserDropdown.logInAlternative`,
        defaultMessage: 'Log in'
    },
    joinTeam: {
        id: `JoinSiteUserDropdown.joinTeam`,
        defaultMessage: 'Find my team'
    },
    profile: {
        id: `JoinSiteUserDropdown.profile`,
        defaultMessage: 'Profile'
    },
    licenses: {
        id: `JoinSiteUserDropdown.licenses`,
        defaultMessage: 'Licenses'
    },
    logOut: {
        id: `JoinSiteUserDropdown.logOut`,
        defaultMessage: 'Log out'
    },
    logOutTriggerText: {
        id: `JoinSiteUserDropdown.logOutTriggerText`,
        defaultMessage: 'My account'
    },
    switchAccount: {
        id: `JoinSiteUserDropdown.switchAccount`,
        defaultMessage: 'Switch Account'
    }
});

});

parcelRegister("hZE0S", function(module, exports) {
$parcel$export(module.exports, "WACAvatar", function () { return $a6d9c2fa1940860f$export$c4e152e3661f6058; });

var $7VQPk = parcelRequire("7VQPk");

var $4SA4u = parcelRequire("4SA4u");

var $hLJF4 = parcelRequire("hLJF4");
const $a6d9c2fa1940860f$export$c4e152e3661f6058 = (props)=>{
    return props.showTooltip ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
        content: props.name,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
            ...props,
            appearance: "circle"
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
        ...props,
        appearance: "circle"
    });
};

});
parcelRegister("hLJF4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cefa3edaaf7b1285$export$2e2bcd8739ae039; });

var $fhrqS = parcelRequire("fhrqS");

var $hObf1 = parcelRequire("hObf1");

var $43rKr = parcelRequire("43rKr");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $8670T = parcelRequire("8670T");

var $bEtzC = parcelRequire("bEtzC");

var $5tM8S = parcelRequire("5tM8S");

var $fJN0X = parcelRequire("fJN0X");
var $1OhUQ = parcelRequire("1OhUQ");

var $0350A = parcelRequire("0350A");

var $fTcln = parcelRequire("fTcln");

var $2bRWO = parcelRequire("2bRWO");

var $TKU93 = parcelRequire("TKU93");

var $2iv5o = parcelRequire("2iv5o");

var $7u7oJ = parcelRequire("7u7oJ");

var $5pzwy = parcelRequire("5pzwy");

var $5v1Pf = parcelRequire("5v1Pf");

var $hokAv = parcelRequire("hokAv");
function $cefa3edaaf7b1285$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cefa3edaaf7b1285$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cefa3edaaf7b1285$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $43rKr.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cefa3edaaf7b1285$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cefa3edaaf7b1285$var$tooltipZIndex = (0, $TKU93.layers).tooltip();
var $cefa3edaaf7b1285$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.3.0"
};
// Inverts motion direction
var $cefa3edaaf7b1285$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $cefa3edaaf7b1285$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
function $cefa3edaaf7b1285$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $5v1Pf.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $bEtzC.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $bEtzC.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $8670T.usePlatformLeafSyntheticEventHandler)($cefa3edaaf7b1285$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $cefa3edaaf7b1285$var$analyticsAttributes));
    var onHideHandler = (0, $8670T.usePlatformLeafSyntheticEventHandler)($cefa3edaaf7b1285$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $cefa3edaaf7b1285$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $hObf1.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $1oC0p.useRef)(state);
    var lastDelay = (0, $1oC0p.useRef)(delay);
    var lastHandlers = (0, $1oC0p.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $1oC0p.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, []);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $2iv5o.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $1oC0p.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $7u7oJ.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $5tM8S.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $bEtzC.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $hokAv.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $hokAv.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function() {
        showTooltip({
            type: 'keyboard'
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && lastState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== 'hide' && Boolean(content);
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $5pzwy.default)('tooltip', shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $1oC0p.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute('aria-describedby', tooltipId);
        else target.removeAttribute('aria-describedby');
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === 'function' ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children($cefa3edaaf7b1285$var$_objectSpread($cefa3edaaf7b1285$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $fhrqS.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2bRWO.default), {
        zIndex: $cefa3edaaf7b1285$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fTcln.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $cefa3edaaf7b1285$var$invertedDirection[$cefa3edaaf7b1285$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fJN0X.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1OhUQ.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === 'show-immediate' ? 0 : (0, $0350A.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $cefa3edaaf7b1285$var$_objectSpread($cefa3edaaf7b1285$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$cefa3edaaf7b1285$var$Tooltip.displayName = 'Tooltip';
var $cefa3edaaf7b1285$export$2e2bcd8739ae039 = $cefa3edaaf7b1285$var$Tooltip;

});
parcelRegister("fhrqS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b1fdb912045ec667$export$2e2bcd8739ae039; });
function $b1fdb912045ec667$export$2e2bcd8739ae039() {
    return $b1fdb912045ec667$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b1fdb912045ec667$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hObf1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf6fd3735a5e5317$export$2e2bcd8739ae039; });

var $3I3w6 = parcelRequire("3I3w6");

var $8T0av = parcelRequire("8T0av");

var $hlYJd = parcelRequire("hlYJd");

var $fbEld = parcelRequire("fbEld");
function $cf6fd3735a5e5317$export$2e2bcd8739ae039(r, e) {
    return (0, $3I3w6.default)(r) || (0, $8T0av.default)(r, e) || (0, $hlYJd.default)(r, e) || (0, $fbEld.default)();
}

});
parcelRegister("3I3w6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2b383586280aba68$export$2e2bcd8739ae039; });
function $2b383586280aba68$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("8T0av", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67839737b2521bdd$export$2e2bcd8739ae039; });
function $67839737b2521bdd$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("hlYJd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca2381375d9c4b5f$export$2e2bcd8739ae039; });

var $6kiCJ = parcelRequire("6kiCJ");
function $ca2381375d9c4b5f$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $6kiCJ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $6kiCJ.default)(r, a) : void 0;
    }
}

});
parcelRegister("6kiCJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $49b30ea3a2a39a53$export$2e2bcd8739ae039; });
function $49b30ea3a2a39a53$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("fbEld", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0e72d0104b4c58f$export$2e2bcd8739ae039; });
function $b0e72d0104b4c58f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("43rKr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f3cf76c2c9383d2$export$2e2bcd8739ae039; });

var $7sk4J = parcelRequire("7sk4J");
function $2f3cf76c2c9383d2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7sk4J.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("7sk4J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $56dab87bc6f15071$export$2e2bcd8739ae039; });

var $7uE4A = parcelRequire("7uE4A");

var $d7g4D = parcelRequire("d7g4D");
function $56dab87bc6f15071$export$2e2bcd8739ae039(t) {
    var i = (0, $d7g4D.default)(t, "string");
    return "symbol" == (0, $7uE4A.default)(i) ? i : i + "";
}

});
parcelRegister("7uE4A", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $574a6b63f4a2affb$export$2e2bcd8739ae039; });
function $574a6b63f4a2affb$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $574a6b63f4a2affb$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $574a6b63f4a2affb$export$2e2bcd8739ae039(o);
}

});

parcelRegister("d7g4D", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $98c865be56d6034a$export$2e2bcd8739ae039; });

var $7uE4A = parcelRequire("7uE4A");
function $98c865be56d6034a$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7uE4A.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7uE4A.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("8670T", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $5e5452f5b5a61704$export$1a04351537078b55; });

var $43rKr = parcelRequire("43rKr");

var $1oC0p = parcelRequire("1oC0p");

var $kBaYH = parcelRequire("kBaYH");

var $iZqZq = parcelRequire("iZqZq");
function $5e5452f5b5a61704$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e5452f5b5a61704$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e5452f5b5a61704$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $43rKr.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e5452f5b5a61704$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5e5452f5b5a61704$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $kBaYH.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $iZqZq.useTrackedRef)(analyticsData);
    var fnRef = (0, $iZqZq.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $5e5452f5b5a61704$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("kBaYH", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $efefc759ec39e5fd$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $6WSoI = parcelRequire("6WSoI");

var $hcUJX = parcelRequire("hcUJX");
function $efefc759ec39e5fd$export$5bf35293e545f20c() {
    var analyticsContext = (0, $hcUJX.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $6WSoI.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("6WSoI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $50f25b1afabd8cbc$export$2e2bcd8739ae039; });

var $6yi3t = parcelRequire("6yi3t");

var $fNtNz = parcelRequire("fNtNz");

var $b7qD5 = parcelRequire("b7qD5");

var $bTip7 = parcelRequire("bTip7");

var $cJwzI = parcelRequire("cJwzI");

var $aBlaw = parcelRequire("aBlaw");

var $eb7yK = parcelRequire("eb7yK");

var $9CZjn = parcelRequire("9CZjn");

var $43rKr = parcelRequire("43rKr");

var $kNUH4 = parcelRequire("kNUH4");
function $50f25b1afabd8cbc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $50f25b1afabd8cbc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $9CZjn.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $9CZjn.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $eb7yK.default)(this, result);
    };
}
function $50f25b1afabd8cbc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($50f25b1afabd8cbc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $50f25b1afabd8cbc$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $50f25b1afabd8cbc$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $50f25b1afabd8cbc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, $aBlaw.default)(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $50f25b1afabd8cbc$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $fNtNz.default)(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, $43rKr.default)((0, $bTip7.default)(_this), "_isUIAnalyticsEvent", true);
        (0, $43rKr.default)((0, $bTip7.default)(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $6yi3t.default)(_this.context);
            var handlers = (0, $6yi3t.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $43rKr.default)((0, $bTip7.default)(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, $bTip7.default)(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $b7qD5.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, $cJwzI.default)((0, $9CZjn.default)(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $kNUH4.default));

});
parcelRegister("6yi3t", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c53ec6b2ae333e4$export$2e2bcd8739ae039; });

var $adxhk = parcelRequire("adxhk");

var $lOU01 = parcelRequire("lOU01");

var $hlYJd = parcelRequire("hlYJd");

var $an6wI = parcelRequire("an6wI");
function $4c53ec6b2ae333e4$export$2e2bcd8739ae039(r) {
    return (0, $adxhk.default)(r) || (0, $lOU01.default)(r) || (0, $hlYJd.default)(r) || (0, $an6wI.default)();
}

});
parcelRegister("adxhk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7704eeb2bc77869e$export$2e2bcd8739ae039; });

var $6kiCJ = parcelRequire("6kiCJ");
function $7704eeb2bc77869e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $6kiCJ.default)(r);
}

});

parcelRegister("lOU01", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe29b4d0e025b23f$export$2e2bcd8739ae039; });
function $fe29b4d0e025b23f$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("an6wI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $78d11d67e60aac79$export$2e2bcd8739ae039; });
function $78d11d67e60aac79$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fNtNz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8028bfa23032780$export$2e2bcd8739ae039; });
function $b8028bfa23032780$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("b7qD5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8185013897b786a9$export$2e2bcd8739ae039; });

var $7sk4J = parcelRequire("7sk4J");
function $8185013897b786a9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $7sk4J.default)(o.key), o);
    }
}
function $8185013897b786a9$export$2e2bcd8739ae039(e, r, t) {
    return r && $8185013897b786a9$var$_defineProperties(e.prototype, r), t && $8185013897b786a9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("bTip7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8a831b77afe4ba33$export$2e2bcd8739ae039; });
function $8a831b77afe4ba33$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("cJwzI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9452f4bbec258170$export$2e2bcd8739ae039; });

var $cdBAf = parcelRequire("cdBAf");
function $9452f4bbec258170$export$2e2bcd8739ae039() {
    return $9452f4bbec258170$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $cdBAf.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $9452f4bbec258170$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("cdBAf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8e53da3dfc75469b$export$2e2bcd8739ae039; });

var $9CZjn = parcelRequire("9CZjn");
function $8e53da3dfc75469b$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $9CZjn.default)(t)););
    return t;
}

});
parcelRegister("9CZjn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $702738ddceabe7ab$export$2e2bcd8739ae039; });
function $702738ddceabe7ab$export$2e2bcd8739ae039(t) {
    return $702738ddceabe7ab$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $702738ddceabe7ab$export$2e2bcd8739ae039(t);
}

});



parcelRegister("aBlaw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b7dc7c571c7619a$export$2e2bcd8739ae039; });

var $fQuW3 = parcelRequire("fQuW3");
function $7b7dc7c571c7619a$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $fQuW3.default)(t, e);
}

});
parcelRegister("fQuW3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b893b57653d02037$export$2e2bcd8739ae039; });
function $b893b57653d02037$export$2e2bcd8739ae039(t, e) {
    return $b893b57653d02037$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b893b57653d02037$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("eb7yK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a527f4e9d3b11eda$export$2e2bcd8739ae039; });

var $7uE4A = parcelRequire("7uE4A");

var $bTip7 = parcelRequire("bTip7");
function $a527f4e9d3b11eda$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7uE4A.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $bTip7.default)(t);
}

});

parcelRegister("kNUH4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2545c68de3fc955$export$2e2bcd8739ae039; });

var $7uE4A = parcelRequire("7uE4A");

var $fNtNz = parcelRequire("fNtNz");

var $b7qD5 = parcelRequire("b7qD5");

var $43rKr = parcelRequire("43rKr");
function $f2545c68de3fc955$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2545c68de3fc955$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2545c68de3fc955$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $43rKr.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2545c68de3fc955$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f2545c68de3fc955$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f2545c68de3fc955$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $f2545c68de3fc955$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $fNtNz.default)(this, AnalyticsEvent);
        (0, $43rKr.default)(this, "_isAnalyticsEvent", true);
        (0, $43rKr.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $f2545c68de3fc955$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, $b7qD5.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $7uE4A.default)(updater) === 'object') this.payload = $f2545c68de3fc955$var$_objectSpread($f2545c68de3fc955$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("hcUJX", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $c86f92108d20c3a3$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $c86f92108d20c3a3$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("iZqZq", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $dd32dc1550a32918$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $dd32dc1550a32918$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("bEtzC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87ba5ecfd5ffd57e$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $87ba5ecfd5ffd57e$export$2e2bcd8739ae039() {}

});

parcelRegister("5tM8S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3fd5013d8999dfe1$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $1ZQuI = parcelRequire("1ZQuI");
function $3fd5013d8999dfe1$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $1ZQuI.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("1ZQuI", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", function () { return $1744353b6177cd0f$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $1744353b6177cd0f$export$390330c10ff2b9a1 = 'ArrowUp';
var $1744353b6177cd0f$export$a80636c6f41931fe = 'ArrowDown';
var $1744353b6177cd0f$export$4af703091671bc = 'Home';
var $1744353b6177cd0f$export$e2bc30913faa5db7 = 'End';
var $1744353b6177cd0f$export$10f6869ed0a7d75b = 'Tab';
var $1744353b6177cd0f$export$8152f929a25a0ff4 = 'Enter';
var $1744353b6177cd0f$export$e51a3576c045c8d5 = 'Space';
var $1744353b6177cd0f$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("fJN0X", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $b751143cc143fa70$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $b751143cc143fa70$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $3kQxF = parcelRequire("3kQxF");

var $b3sdk = parcelRequire("b3sdk");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $b751143cc143fa70$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $b751143cc143fa70$var$ExitingContext = /*#__PURE__*/ (0, $1oC0p.createContext)($b751143cc143fa70$var$emptyContext);
var $b751143cc143fa70$var$isAnyPreviousKeysMissingFromCurrent = function isAnyPreviousKeysMissingFromCurrent(currentMap, previous) {
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMap[_key]) return true;
    }
    return false;
};
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $b751143cc143fa70$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b751143cc143fa70$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b751143cc143fa70$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $b751143cc143fa70$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $b751143cc143fa70$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $b751143cc143fa70$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $b751143cc143fa70$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ var $b751143cc143fa70$var$hasAnyExitingChildMountedAgain = function hasAnyExitingChildMountedAgain(exitingChildren, children) {
    var exitingChildMountedAgain = false;
    children.forEach(function(child) {
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $b751143cc143fa70$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appearFromProp = _ref$appear === void 0 ? false : _ref$appear, childs = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var children = $b751143cc143fa70$var$childrenToArray(childs);
    var childrenObj = $b751143cc143fa70$var$childrenToObj(children);
    var previousChildren = (0, $1oC0p.useRef)([]);
    var persistedChildren = (0, $1oC0p.useRef)([]);
    var forceRender = (0, $b3sdk.useForceRender)();
    var exitingChildren = (0, $1oC0p.useRef)({});
    var appear = (0, $1oC0p.useRef)(appearFromProp);
    var defaultContextValue = (0, $1oC0p.useMemo)(function() {
        return {
            appear: appear.current,
            isExiting: false
        };
    }, // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $3kQxF.isReducedMotion)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $b751143cc143fa70$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $b751143cc143fa70$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : $b751143cc143fa70$var$spliceNewElementsIntoPrevious(children, persistedChildren.current)).map(function(child) {
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            var currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return $b751143cc143fa70$var$wrapChildWithContextProvider(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: function onFinish() {
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return $b751143cc143fa70$var$wrapChildWithContextProvider(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map(function(child) {
        return $b751143cc143fa70$var$wrapChildWithContextProvider(child, defaultContextValue);
    });
});
var $b751143cc143fa70$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)($b751143cc143fa70$var$ExitingContext);
};
$b751143cc143fa70$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $b751143cc143fa70$export$2e2bcd8739ae039 = $b751143cc143fa70$var$ExitingPersistence;

});
parcelRegister("3kQxF", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $26dbff1a0a1a5377$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $26dbff1a0a1a5377$export$f0f789643ba5a83c; });

var $hObf1 = parcelRequire("hObf1");

var $1oC0p = parcelRequire("1oC0p");

var $8adoU = parcelRequire("8adoU");
var $26dbff1a0a1a5377$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $26dbff1a0a1a5377$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$26dbff1a0a1a5377$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $26dbff1a0a1a5377$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $1oC0p.useState)($26dbff1a0a1a5377$export$b7baf7667a68d87c), _useState2 = (0, $hObf1.default)(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        if (!$26dbff1a0a1a5377$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $8adoU.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $26dbff1a0a1a5377$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $26dbff1a0a1a5377$export$ff7706047246b98b = function prefersReducedMotion() {
    return $26dbff1a0a1a5377$export$f0f789643ba5a83c;
};

});
parcelRegister("8adoU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $eo1zr = parcelRequire("eo1zr");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $eo1zr.bind;
    }
});

var $iLk8I = parcelRequire("iLk8I");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $iLk8I.bindAll;
    }
});

});
parcelRegister("eo1zr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $a794867e97cb1bc1$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $a794867e97cb1bc1$var$bind;

});

parcelRegister("iLk8I", function(module, exports) {
"use strict";
var $da8c3d110a18312e$var$__assign = module.exports && module.exports.__assign || function() {
    $da8c3d110a18312e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $da8c3d110a18312e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $eo1zr = parcelRequire("eo1zr");
function $da8c3d110a18312e$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $da8c3d110a18312e$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $da8c3d110a18312e$var$__assign($da8c3d110a18312e$var$__assign({}, original), {
        options: $da8c3d110a18312e$var$__assign($da8c3d110a18312e$var$__assign({}, $da8c3d110a18312e$var$toOptions(sharedOptions)), $da8c3d110a18312e$var$toOptions(original.options))
    });
    return binding;
}
function $da8c3d110a18312e$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $da8c3d110a18312e$var$getBinding(original, sharedOptions);
        return (0, $eo1zr.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $da8c3d110a18312e$var$bindAll;

});



parcelRegister("b3sdk", function(module, exports) {
$parcel$export(module.exports, "useForceRender", function () { return $80c5dc394ef8df12$export$b902f6ef73d6633a; });

var $hObf1 = parcelRequire("hObf1");

var $1oC0p = parcelRequire("1oC0p");
var $80c5dc394ef8df12$export$b902f6ef73d6633a = function useForceRender() {
    var _useState = (0, $1oC0p.useState)({}), _useState2 = (0, $hObf1.default)(_useState, 2), updateState = _useState2[1];
    var forceRender = (0, $1oC0p.useCallback)(function() {
        return updateState({});
    }, []);
    return forceRender;
};

});


parcelRegister("1OhUQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $15185ba66a70db93$export$2e2bcd8739ae039; });

var $43rKr = parcelRequire("43rKr");

var $1oC0p = parcelRequire("1oC0p");

var $Zq26z = parcelRequire("Zq26z");

var $0350A = parcelRequire("0350A");

var $dyE6J = parcelRequire("dyE6J");
function $15185ba66a70db93$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15185ba66a70db93$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15185ba66a70db93$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $43rKr.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15185ba66a70db93$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $15185ba66a70db93$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
var $15185ba66a70db93$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $15185ba66a70db93$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: $15185ba66a70db93$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $15185ba66a70db93$var$directionMotions[distance][direction]
        }),
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
var $15185ba66a70db93$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: $15185ba66a70db93$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $15185ba66a70db93$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $15185ba66a70db93$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $0350A.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $15185ba66a70db93$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dyE6J.default), {
        duration: duration,
        enteringAnimation: $15185ba66a70db93$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $15185ba66a70db93$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $Zq26z.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $15185ba66a70db93$export$2e2bcd8739ae039 = $15185ba66a70db93$var$FadeIn;

});
parcelRegister("Zq26z", function(module, exports) {
$parcel$export(module.exports, "easeInOut", function () { return $0b89e438c8347c41$export$c07234257a03d5e9; });
var $0b89e438c8347c41$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $0b89e438c8347c41$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $0b89e438c8347c41$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

});

parcelRegister("0350A", function(module, exports) {
$parcel$export(module.exports, "mediumDurationMs", function () { return $00942a81d4de1c7e$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $00942a81d4de1c7e$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $00942a81d4de1c7e$export$368bacef0dacbe05 = 25;
var $00942a81d4de1c7e$export$2023a81c8547415f = $00942a81d4de1c7e$export$368bacef0dacbe05 * 4;
var $00942a81d4de1c7e$export$6fa259be09e118a7 = $00942a81d4de1c7e$export$368bacef0dacbe05 * 14;
var $00942a81d4de1c7e$export$9424640c29bc466d = $00942a81d4de1c7e$export$368bacef0dacbe05 * 28;

});

parcelRegister("dyE6J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9ded8fdb3db5ed82$export$2e2bcd8739ae039; });

var $43rKr = parcelRequire("43rKr");

var $hObf1 = parcelRequire("hObf1");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $3kQxF = parcelRequire("3kQxF");

var $0350A = parcelRequire("0350A");

var $2MHoG = parcelRequire("2MHoG");

var $fJN0X = parcelRequire("fJN0X");

var $gTeqL = parcelRequire("gTeqL");
function $9ded8fdb3db5ed82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ded8fdb3db5ed82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ded8fdb3db5ed82$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $43rKr.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ded8fdb3db5ed82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $9ded8fdb3db5ed82$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $9ded8fdb3db5ed82$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $0350A.largeDurationMs) : _ref$duration;
    var staggered = (0, $gTeqL.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $fJN0X.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $2MHoG.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $1oC0p.useState)(appear), _useState2 = (0, $hObf1.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $9ded8fdb3db5ed82$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($9ded8fdb3db5ed82$var$_objectSpread($9ded8fdb3db5ed82$var$_objectSpread({}, (0, $3kQxF.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $9ded8fdb3db5ed82$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? 'forwards' : 'backwards',
                animationName: "".concat((0, $3dJ4i.keyframes)(isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? 'paused' : 'running',
                animationTimingFunction: animationTimingFunction(state)
            })) : ''
        }, state);
    });
};
var $9ded8fdb3db5ed82$export$2e2bcd8739ae039 = $9ded8fdb3db5ed82$var$EnteringMotion;

});
parcelRegister("2MHoG", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", function () { return $2071ba374be68f83$export$4f34107a2b00f39c; });

var $1oC0p = parcelRequire("1oC0p");
var $2071ba374be68f83$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2071ba374be68f83$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2071ba374be68f83$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $2071ba374be68f83$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2071ba374be68f83$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("gTeqL", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $c4bcfa0a192edb27$export$25c7213fc07ec080; });

var $hObf1 = parcelRequire("hObf1");

var $1oC0p = parcelRequire("1oC0p");

var $4xIOB = parcelRequire("4xIOB");

var $8HXwy = parcelRequire("8HXwy");

var $hWbrK = parcelRequire("hWbrK");
var $c4bcfa0a192edb27$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $4xIOB.default)
    };
});
var $c4bcfa0a192edb27$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $hWbrK.useUniqueId)();
    var context = (0, $1oC0p.useContext)($c4bcfa0a192edb27$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $c4bcfa0a192edb27$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $hObf1.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $8HXwy.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($c4bcfa0a192edb27$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $c4bcfa0a192edb27$export$2e2bcd8739ae039 = $c4bcfa0a192edb27$var$StaggeredEntrance;

});
parcelRegister("4xIOB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $34ed01d624085236$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $34ed01d624085236$export$2e2bcd8739ae039() {}

});

parcelRegister("8HXwy", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $65708319d508ea09$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $65708319d508ea09$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("hWbrK", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $d0f0bb7b09f767a7$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $d0f0bb7b09f767a7$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("fTcln", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $b915914a720c50ed$export$badac9ada3a0bdf9; });

var $6yi3t = parcelRequire("6yi3t");

var $hObf1 = parcelRequire("hObf1");

var $1oC0p = parcelRequire("1oC0p");

var $dgq3l = parcelRequire("dgq3l");

// Export types from PopperJS / React Popper
var $b915914a720c50ed$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    },
    {
        name: 'preventOverflow',
        options: {
            padding: 5,
            rootBoundary: 'document'
        }
    }
];
function $b915914a720c50ed$var$defaultChildrenFn() {
    return null;
}
var $b915914a720c50ed$var$defaultOffset = [
    0,
    8
];
function $b915914a720c50ed$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $b915914a720c50ed$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $b915914a720c50ed$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy;
    var _offset = (0, $hObf1.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($b915914a720c50ed$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $6yi3t.default)(internalModifiers), (0, $6yi3t.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dgq3l.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("dgq3l", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $9a80fa934b8e0f96$export$badac9ada3a0bdf9; });

var $1oC0p = parcelRequire("1oC0p");

var $KDOJM = parcelRequire("KDOJM");

var $3wqDw = parcelRequire("3wqDw");

var $9YAxy = parcelRequire("9YAxy");
var $9a80fa934b8e0f96$var$NOOP = function NOOP() {
    return void 0;
};
var $9a80fa934b8e0f96$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $9a80fa934b8e0f96$var$EMPTY_MODIFIERS = [];
function $9a80fa934b8e0f96$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $9a80fa934b8e0f96$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $1oC0p.useContext((0, $KDOJM.ManagerReferenceNodeContext));
    var _React$useState = $1oC0p.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $1oC0p.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $1oC0p.useEffect(function() {
        (0, $3wqDw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $1oC0p.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $9YAxy.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $1oC0p.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $9a80fa934b8e0f96$var$NOOP,
            update: update || $9a80fa934b8e0f96$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $3wqDw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("KDOJM", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $08c32ee34c5e1230$export$3dbd3405086fec7b; });

var $1oC0p = parcelRequire("1oC0p");
var $08c32ee34c5e1230$export$3dbd3405086fec7b = $1oC0p.createContext();
var $08c32ee34c5e1230$export$cbabb21c2529b130 = $1oC0p.createContext();
function $08c32ee34c5e1230$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $1oC0p.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $1oC0p.useRef(false);
    $1oC0p.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $1oC0p.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $1oC0p.createElement($08c32ee34c5e1230$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $1oC0p.createElement($08c32ee34c5e1230$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("3wqDw", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", function () { return $290905ad29607145$export$f52c55943429c8b6; });
$parcel$export(module.exports, "setRef", function () { return $290905ad29607145$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $290905ad29607145$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $290905ad29607145$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $290905ad29607145$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $290905ad29607145$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $290905ad29607145$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $290905ad29607145$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $290905ad29607145$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $290905ad29607145$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $1oC0p.useLayoutEffect : $1oC0p.useEffect;

});

parcelRegister("9YAxy", function(module, exports) {
$parcel$export(module.exports, "usePopper", function () { return $74360fcb60d8bbe9$export$f4d5bf230a36dd6e; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $2VPYh = parcelRequire("2VPYh");

var $6prbz = parcelRequire("6prbz");

var $3wqDw = parcelRequire("3wqDw");
var $74360fcb60d8bbe9$var$EMPTY_MODIFIERS = [];
var $74360fcb60d8bbe9$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $1oC0p.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $74360fcb60d8bbe9$var$EMPTY_MODIFIERS
    };
    var _React$useState = $1oC0p.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $1oC0p.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $gUjjH.flushSync(function() {
                    setState({
                        styles: (0, $3wqDw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $3wqDw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $1oC0p.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6prbz)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $1oC0p.useRef();
    (0, $3wqDw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $3wqDw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $2VPYh.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("2VPYh", function(module, exports) {
$parcel$export(module.exports, "createPopper", function () { return $2229380918292321$export$8f7491d57c8f97a9; });

var $7Sauo = parcelRequire("7Sauo");

var $1uECf = parcelRequire("1uECf");

var $13PsB = parcelRequire("13PsB");

var $3nJSQ = parcelRequire("3nJSQ");

var $fuuEF = parcelRequire("fuuEF");

var $3hFV9 = parcelRequire("3hFV9");

var $dEw51 = parcelRequire("dEw51");

var $kz6NI = parcelRequire("kz6NI");

var $9bfDx = parcelRequire("9bfDx");

var $aN98i = parcelRequire("aN98i");


var $2229380918292321$export$d34966752335dd47 = [
    (0, $1uECf.default),
    (0, $13PsB.default),
    (0, $3nJSQ.default),
    (0, $fuuEF.default),
    (0, $3hFV9.default),
    (0, $dEw51.default),
    (0, $kz6NI.default),
    (0, $9bfDx.default),
    (0, $aN98i.default)
];
var $2229380918292321$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $7Sauo.popperGenerator)({
    defaultModifiers: $2229380918292321$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("7Sauo", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", function () { return $017aac3bea9bc555$export$ed5e13716264f202; });

var $8nGJO = parcelRequire("8nGJO");

var $1LxVa = parcelRequire("1LxVa");

var $81JO8 = parcelRequire("81JO8");

var $8uJ6I = parcelRequire("8uJ6I");

var $keNL9 = parcelRequire("keNL9");

var $5kVVv = parcelRequire("5kVVv");

var $6rknN = parcelRequire("6rknN");


var $12uPh = parcelRequire("12uPh");
var $017aac3bea9bc555$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $017aac3bea9bc555$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $017aac3bea9bc555$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $017aac3bea9bc555$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $017aac3bea9bc555$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $12uPh.isElement)(reference) ? (0, $81JO8.default)(reference) : reference.contextElement ? (0, $81JO8.default)(reference.contextElement) : [],
                    popper: (0, $81JO8.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $keNL9.default)((0, $6rknN.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$017aac3bea9bc555$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $8nGJO.default)(reference, (0, $8uJ6I.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $1LxVa.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $5kVVv.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$017aac3bea9bc555$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $017aac3bea9bc555$export$8f7491d57c8f97a9 = /*#__PURE__*/ $017aac3bea9bc555$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8nGJO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61a19f902af55303$export$2e2bcd8739ae039; });

var $1ByS4 = parcelRequire("1ByS4");

var $gGegK = parcelRequire("gGegK");

var $eYRIX = parcelRequire("eYRIX");

var $12uPh = parcelRequire("12uPh");

var $cRrzK = parcelRequire("cRrzK");

var $6DxtY = parcelRequire("6DxtY");

var $25BE6 = parcelRequire("25BE6");

var $hstBa = parcelRequire("hstBa");
function $61a19f902af55303$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hstBa.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hstBa.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $61a19f902af55303$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $12uPh.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $12uPh.isHTMLElement)(offsetParent) && $61a19f902af55303$var$isElementScaled(offsetParent);
    var documentElement = (0, $6DxtY.default)(offsetParent);
    var rect = (0, $1ByS4.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $eYRIX.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $25BE6.default)(documentElement)) scroll = (0, $gGegK.default)(offsetParent);
        if ((0, $12uPh.isHTMLElement)(offsetParent)) {
            offsets = (0, $1ByS4.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $cRrzK.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("1ByS4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $12b44bcc4fc26e32$export$2e2bcd8739ae039; });

var $12uPh = parcelRequire("12uPh");

var $hstBa = parcelRequire("hstBa");

var $hnw2w = parcelRequire("hnw2w");

var $jMBpi = parcelRequire("jMBpi");
function $12b44bcc4fc26e32$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $12uPh.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hstBa.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hstBa.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $12uPh.isElement)(element) ? (0, $hnw2w.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $jMBpi.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("12uPh", function(module, exports) {
$parcel$export(module.exports, "isElement", function () { return $0c1de3c2af8bfce8$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0c1de3c2af8bfce8$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $0c1de3c2af8bfce8$export$af51f0f06c0f328a; });

var $hnw2w = parcelRequire("hnw2w");
function $0c1de3c2af8bfce8$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $hnw2w.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0c1de3c2af8bfce8$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $hnw2w.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0c1de3c2af8bfce8$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $hnw2w.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("hnw2w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca6d70165eb21e0b$export$2e2bcd8739ae039; });
function $ca6d70165eb21e0b$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("hstBa", function(module, exports) {
$parcel$export(module.exports, "max", function () { return $cb5c02d4853ef6c5$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $cb5c02d4853ef6c5$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $cb5c02d4853ef6c5$export$2077e0241d6afd3c; });
var $cb5c02d4853ef6c5$export$8960430cfd85939f = Math.max;
var $cb5c02d4853ef6c5$export$96ec731ed4dcb222 = Math.min;
var $cb5c02d4853ef6c5$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("jMBpi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e66f844064ab6f17$export$2e2bcd8739ae039; });

var $420hm = parcelRequire("420hm");
function $e66f844064ab6f17$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $420hm.default)());
}

});
parcelRegister("420hm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2ef790bcc50e8f13$export$2e2bcd8739ae039; });
function $2ef790bcc50e8f13$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("gGegK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c24ba322f9ca65f9$export$2e2bcd8739ae039; });

var $gTE9w = parcelRequire("gTE9w");

var $hnw2w = parcelRequire("hnw2w");

var $12uPh = parcelRequire("12uPh");

var $1DNaj = parcelRequire("1DNaj");
function $c24ba322f9ca65f9$export$2e2bcd8739ae039(node) {
    if (node === (0, $hnw2w.default)(node) || !(0, $12uPh.isHTMLElement)(node)) return (0, $gTE9w.default)(node);
    else return (0, $1DNaj.default)(node);
}

});
parcelRegister("gTE9w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c4d0ede1cf4d6657$export$2e2bcd8739ae039; });

var $hnw2w = parcelRequire("hnw2w");
function $c4d0ede1cf4d6657$export$2e2bcd8739ae039(node) {
    var win = (0, $hnw2w.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("1DNaj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $131f9227e87c4630$export$2e2bcd8739ae039; });
function $131f9227e87c4630$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("eYRIX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ae8057ccfd49553e$export$2e2bcd8739ae039; });
function $ae8057ccfd49553e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("cRrzK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $95cfd3326318fdca$export$2e2bcd8739ae039; });

var $1ByS4 = parcelRequire("1ByS4");

var $6DxtY = parcelRequire("6DxtY");

var $gTE9w = parcelRequire("gTE9w");
function $95cfd3326318fdca$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1ByS4.default)((0, $6DxtY.default)(element)).left + (0, $gTE9w.default)(element).scrollLeft;
}

});
parcelRegister("6DxtY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4d505b813db78327$export$2e2bcd8739ae039; });

var $12uPh = parcelRequire("12uPh");
function $4d505b813db78327$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $12uPh.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("25BE6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1859401864e49e40$export$2e2bcd8739ae039; });

var $5CrOJ = parcelRequire("5CrOJ");
function $1859401864e49e40$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5CrOJ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5CrOJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $417614496bfaac5a$export$2e2bcd8739ae039; });

var $hnw2w = parcelRequire("hnw2w");
function $417614496bfaac5a$export$2e2bcd8739ae039(element) {
    return (0, $hnw2w.default)(element).getComputedStyle(element);
}

});



parcelRegister("1LxVa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14947e4219b1ed2c$export$2e2bcd8739ae039; });

var $1ByS4 = parcelRequire("1ByS4");
function $14947e4219b1ed2c$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1ByS4.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("81JO8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d81f32d4da17369$export$2e2bcd8739ae039; });

var $6MLDp = parcelRequire("6MLDp");

var $bNWVz = parcelRequire("bNWVz");

var $hnw2w = parcelRequire("hnw2w");

var $25BE6 = parcelRequire("25BE6");
function $5d81f32d4da17369$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $6MLDp.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $hnw2w.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $25BE6.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($5d81f32d4da17369$export$2e2bcd8739ae039((0, $bNWVz.default)(target)));
}

});
parcelRegister("6MLDp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f0c2d07cb5b6921$export$2e2bcd8739ae039; });

var $bNWVz = parcelRequire("bNWVz");

var $25BE6 = parcelRequire("25BE6");

var $eYRIX = parcelRequire("eYRIX");

var $12uPh = parcelRequire("12uPh");
function $4f0c2d07cb5b6921$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $eYRIX.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $12uPh.isHTMLElement)(node) && (0, $25BE6.default)(node)) return node;
    return $4f0c2d07cb5b6921$export$2e2bcd8739ae039((0, $bNWVz.default)(node));
}

});
parcelRegister("bNWVz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8981fb1f73efb3e0$export$2e2bcd8739ae039; });

var $eYRIX = parcelRequire("eYRIX");

var $6DxtY = parcelRequire("6DxtY");

var $12uPh = parcelRequire("12uPh");
function $8981fb1f73efb3e0$export$2e2bcd8739ae039(element) {
    if ((0, $eYRIX.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $12uPh.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $6DxtY.default)(element) // fallback
    );
}

});



parcelRegister("8uJ6I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $62f41d6c5959cb0a$export$2e2bcd8739ae039; });

var $hnw2w = parcelRequire("hnw2w");

var $eYRIX = parcelRequire("eYRIX");

var $5CrOJ = parcelRequire("5CrOJ");

var $12uPh = parcelRequire("12uPh");

var $gcxYS = parcelRequire("gcxYS");

var $bNWVz = parcelRequire("bNWVz");

var $420hm = parcelRequire("420hm");
function $62f41d6c5959cb0a$var$getTrueOffsetParent(element) {
    if (!(0, $12uPh.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5CrOJ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $62f41d6c5959cb0a$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $420hm.default)());
    var isIE = /Trident/i.test((0, $420hm.default)());
    if (isIE && (0, $12uPh.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5CrOJ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $bNWVz.default)(element);
    if ((0, $12uPh.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $12uPh.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $eYRIX.default)(currentNode)) < 0){
        var css = (0, $5CrOJ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $62f41d6c5959cb0a$export$2e2bcd8739ae039(element) {
    var window = (0, $hnw2w.default)(element);
    var offsetParent = $62f41d6c5959cb0a$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $gcxYS.default)(offsetParent) && (0, $5CrOJ.default)(offsetParent).position === 'static')offsetParent = $62f41d6c5959cb0a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $eYRIX.default)(offsetParent) === 'html' || (0, $eYRIX.default)(offsetParent) === 'body' && (0, $5CrOJ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $62f41d6c5959cb0a$var$getContainingBlock(element) || window;
}

});
parcelRegister("gcxYS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcb8203c2230fe15$export$2e2bcd8739ae039; });

var $eYRIX = parcelRequire("eYRIX");
function $bcb8203c2230fe15$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $eYRIX.default)(element)) >= 0;
}

});


parcelRegister("keNL9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ebbbb6a0d3a1b7ab$export$2e2bcd8739ae039; });

var $1Uk8Z = parcelRequire("1Uk8Z");
function $ebbbb6a0d3a1b7ab$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $ebbbb6a0d3a1b7ab$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $ebbbb6a0d3a1b7ab$var$order(modifiers); // order based on phase
    return (0, $1Uk8Z.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1Uk8Z", function(module, exports) {
$parcel$export(module.exports, "top", function () { return $163aa596d7c6f579$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $163aa596d7c6f579$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $163aa596d7c6f579$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $163aa596d7c6f579$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $163aa596d7c6f579$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $163aa596d7c6f579$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $163aa596d7c6f579$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $163aa596d7c6f579$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $163aa596d7c6f579$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $163aa596d7c6f579$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $163aa596d7c6f579$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $163aa596d7c6f579$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $163aa596d7c6f579$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $163aa596d7c6f579$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $163aa596d7c6f579$export$d087d3878fdf71d5; });
var $163aa596d7c6f579$export$1e95b668f3b82d = 'top';
var $163aa596d7c6f579$export$40e543e69a8b3fbb = 'bottom';
var $163aa596d7c6f579$export$79ffe56a765070d2 = 'right';
var $163aa596d7c6f579$export$eabcd2c8791e7bf4 = 'left';
var $163aa596d7c6f579$export$dfb5619354ba860 = 'auto';
var $163aa596d7c6f579$export$aec2ce47c367b8c3 = [
    $163aa596d7c6f579$export$1e95b668f3b82d,
    $163aa596d7c6f579$export$40e543e69a8b3fbb,
    $163aa596d7c6f579$export$79ffe56a765070d2,
    $163aa596d7c6f579$export$eabcd2c8791e7bf4
];
var $163aa596d7c6f579$export$b3571188c770cc5a = 'start';
var $163aa596d7c6f579$export$bd5df0f255a350f8 = 'end';
var $163aa596d7c6f579$export$390fd549c5303b4d = 'clippingParents';
var $163aa596d7c6f579$export$d7b7311ec04a3e8f = 'viewport';
var $163aa596d7c6f579$export$ae5ab1c730825774 = 'popper';
var $163aa596d7c6f579$export$ca50aac9f3ba507f = 'reference';
var $163aa596d7c6f579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $163aa596d7c6f579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $163aa596d7c6f579$export$b3571188c770cc5a,
        placement + "-" + $163aa596d7c6f579$export$bd5df0f255a350f8
    ]);
}, []);
var $163aa596d7c6f579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($163aa596d7c6f579$export$aec2ce47c367b8c3, [
    $163aa596d7c6f579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $163aa596d7c6f579$export$b3571188c770cc5a,
        placement + "-" + $163aa596d7c6f579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $163aa596d7c6f579$export$421679a7c3d56e = 'beforeRead';
var $163aa596d7c6f579$export$aafa59e2e03f2942 = 'read';
var $163aa596d7c6f579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $163aa596d7c6f579$export$c65e99957a05207c = 'beforeMain';
var $163aa596d7c6f579$export$f22da7240b7add18 = 'main';
var $163aa596d7c6f579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $163aa596d7c6f579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $163aa596d7c6f579$export$68d8715fc104d294 = 'write';
var $163aa596d7c6f579$export$70a6e5159acce2e6 = 'afterWrite';
var $163aa596d7c6f579$export$d087d3878fdf71d5 = [
    $163aa596d7c6f579$export$421679a7c3d56e,
    $163aa596d7c6f579$export$aafa59e2e03f2942,
    $163aa596d7c6f579$export$6964f6c886723980,
    $163aa596d7c6f579$export$c65e99957a05207c,
    $163aa596d7c6f579$export$f22da7240b7add18,
    $163aa596d7c6f579$export$bab79516f2d662fe,
    $163aa596d7c6f579$export$8d4d2d70e7d46032,
    $163aa596d7c6f579$export$68d8715fc104d294,
    $163aa596d7c6f579$export$70a6e5159acce2e6
];

});


parcelRegister("5kVVv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e2bc107750d8522$export$2e2bcd8739ae039; });
function $3e2bc107750d8522$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("6rknN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b05134afaecb731$export$2e2bcd8739ae039; });
function $4b05134afaecb731$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("1uECf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1168193f7466b07f$export$2e2bcd8739ae039; });

var $hnw2w = parcelRequire("hnw2w");
var $1168193f7466b07f$var$passive = {
    passive: true
};
function $1168193f7466b07f$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $hnw2w.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1168193f7466b07f$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1168193f7466b07f$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1168193f7466b07f$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1168193f7466b07f$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1168193f7466b07f$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1168193f7466b07f$var$effect,
    data: {}
};

});

parcelRegister("13PsB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0c5dfd3901463dea$export$2e2bcd8739ae039; });

var $jZ9gv = parcelRequire("jZ9gv");
function $0c5dfd3901463dea$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $jZ9gv.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0c5dfd3901463dea$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0c5dfd3901463dea$var$popperOffsets,
    data: {}
};

});
parcelRegister("jZ9gv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8cae6ae8446a9dd$export$2e2bcd8739ae039; });

var $c0O4v = parcelRequire("c0O4v");

var $cyrC7 = parcelRequire("cyrC7");

var $7VLL8 = parcelRequire("7VLL8");

var $1Uk8Z = parcelRequire("1Uk8Z");
function $e8cae6ae8446a9dd$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c0O4v.default)(placement) : null;
    var variation = placement ? (0, $cyrC7.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1Uk8Z.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1Uk8Z.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1Uk8Z.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1Uk8Z.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $7VLL8.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1Uk8Z.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1Uk8Z.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("c0O4v", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8bec534e8d01258c$export$2e2bcd8739ae039; });

function $8bec534e8d01258c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("cyrC7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $923e1489dee6d1af$export$2e2bcd8739ae039; });
function $923e1489dee6d1af$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("7VLL8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c62e73d5253eeb0$export$2e2bcd8739ae039; });
function $5c62e73d5253eeb0$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("3nJSQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $27671c9ee7a67e6c$export$2e2bcd8739ae039; });

var $1Uk8Z = parcelRequire("1Uk8Z");

var $8uJ6I = parcelRequire("8uJ6I");

var $hnw2w = parcelRequire("hnw2w");

var $6DxtY = parcelRequire("6DxtY");

var $5CrOJ = parcelRequire("5CrOJ");

var $c0O4v = parcelRequire("c0O4v");

var $cyrC7 = parcelRequire("cyrC7");

var $hstBa = parcelRequire("hstBa");
var $27671c9ee7a67e6c$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $27671c9ee7a67e6c$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hstBa.round)(x * dpr) / dpr || 0,
        y: (0, $hstBa.round)(y * dpr) / dpr || 0
    };
}
function $27671c9ee7a67e6c$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1Uk8Z.left);
    var sideY = (0, $1Uk8Z.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8uJ6I.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $hnw2w.default)(popper)) {
            offsetParent = (0, $6DxtY.default)(popper);
            if ((0, $5CrOJ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1Uk8Z.top) || (placement === (0, $1Uk8Z.left) || placement === (0, $1Uk8Z.right)) && variation === (0, $1Uk8Z.end)) {
            sideY = (0, $1Uk8Z.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1Uk8Z.left) || (placement === (0, $1Uk8Z.top) || placement === (0, $1Uk8Z.bottom)) && variation === (0, $1Uk8Z.end)) {
            sideX = (0, $1Uk8Z.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $27671c9ee7a67e6c$var$unsetSides);
    var _ref4 = roundOffsets === true ? $27671c9ee7a67e6c$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $hnw2w.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $27671c9ee7a67e6c$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c0O4v.default)(state.placement),
        variation: (0, $cyrC7.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $27671c9ee7a67e6c$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $27671c9ee7a67e6c$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $27671c9ee7a67e6c$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $27671c9ee7a67e6c$var$computeStyles,
    data: {}
};

});

parcelRegister("fuuEF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b4716fc70b2a5f0a$export$2e2bcd8739ae039; });

var $eYRIX = parcelRequire("eYRIX");

var $12uPh = parcelRequire("12uPh");
// and applies them to the HTMLElements such as popper and arrow
function $b4716fc70b2a5f0a$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $12uPh.isHTMLElement)(element) || !(0, $eYRIX.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $b4716fc70b2a5f0a$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $12uPh.isHTMLElement)(element) || !(0, $eYRIX.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $b4716fc70b2a5f0a$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $b4716fc70b2a5f0a$var$applyStyles,
    effect: $b4716fc70b2a5f0a$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("3hFV9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26437a37ac15c095$export$2e2bcd8739ae039; });

var $c0O4v = parcelRequire("c0O4v");

var $1Uk8Z = parcelRequire("1Uk8Z");
function $26437a37ac15c095$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c0O4v.default)(placement);
    var invertDistance = [
        (0, $1Uk8Z.left),
        (0, $1Uk8Z.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1Uk8Z.left),
        (0, $1Uk8Z.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $26437a37ac15c095$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1Uk8Z.placements).reduce(function(acc, placement) {
        acc[placement] = $26437a37ac15c095$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $26437a37ac15c095$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $26437a37ac15c095$var$offset
};

});

parcelRegister("dEw51", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f07e5317380a832$export$2e2bcd8739ae039; });

var $aoLdu = parcelRequire("aoLdu");

var $c0O4v = parcelRequire("c0O4v");

var $2MMiH = parcelRequire("2MMiH");

var $cl9yU = parcelRequire("cl9yU");

var $k5ZCX = parcelRequire("k5ZCX");

var $1Uk8Z = parcelRequire("1Uk8Z");

var $cyrC7 = parcelRequire("cyrC7");
function $9f07e5317380a832$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c0O4v.default)(placement) === (0, $1Uk8Z.auto)) return [];
    var oppositePlacement = (0, $aoLdu.default)(placement);
    return [
        (0, $2MMiH.default)(placement),
        oppositePlacement,
        (0, $2MMiH.default)(oppositePlacement)
    ];
}
function $9f07e5317380a832$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c0O4v.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aoLdu.default)(preferredPlacement)
    ] : $9f07e5317380a832$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c0O4v.default)(placement) === (0, $1Uk8Z.auto) ? (0, $k5ZCX.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c0O4v.default)(placement);
        var isStartVariation = (0, $cyrC7.default)(placement) === (0, $1Uk8Z.start);
        var isVertical = [
            (0, $1Uk8Z.top),
            (0, $1Uk8Z.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $cl9yU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1Uk8Z.right) : (0, $1Uk8Z.left) : isStartVariation ? (0, $1Uk8Z.bottom) : (0, $1Uk8Z.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aoLdu.default)(mainVariationSide);
        var altVariationSide = (0, $aoLdu.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $9f07e5317380a832$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $9f07e5317380a832$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("aoLdu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7920c58591cf2333$export$2e2bcd8739ae039; });
var $7920c58591cf2333$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $7920c58591cf2333$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $7920c58591cf2333$var$hash[matched];
    });
}

});

parcelRegister("2MMiH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $207587fa78f583be$export$2e2bcd8739ae039; });
var $207587fa78f583be$var$hash = {
    start: 'end',
    end: 'start'
};
function $207587fa78f583be$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $207587fa78f583be$var$hash[matched];
    });
}

});

parcelRegister("cl9yU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8fbedd06e0338ca5$export$2e2bcd8739ae039; });

var $knlvf = parcelRequire("knlvf");

var $6DxtY = parcelRequire("6DxtY");

var $1ByS4 = parcelRequire("1ByS4");

var $jZ9gv = parcelRequire("jZ9gv");

var $7OePQ = parcelRequire("7OePQ");

var $1Uk8Z = parcelRequire("1Uk8Z");

var $12uPh = parcelRequire("12uPh");

var $4ferx = parcelRequire("4ferx");

var $bz1rv = parcelRequire("bz1rv");
function $8fbedd06e0338ca5$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1Uk8Z.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1Uk8Z.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1Uk8Z.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4ferx.default)(typeof padding !== 'number' ? padding : (0, $bz1rv.default)(padding, (0, $1Uk8Z.basePlacements)));
    var altContext = elementContext === (0, $1Uk8Z.popper) ? (0, $1Uk8Z.reference) : (0, $1Uk8Z.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $knlvf.default)((0, $12uPh.isElement)(element) ? element : element.contextElement || (0, $6DxtY.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1ByS4.default)(state.elements.reference);
    var popperOffsets = (0, $jZ9gv.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $7OePQ.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1Uk8Z.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1Uk8Z.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1Uk8Z.right),
                (0, $1Uk8Z.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1Uk8Z.top),
                (0, $1Uk8Z.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("knlvf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ed56a2b156181a3e$export$2e2bcd8739ae039; });

var $1Uk8Z = parcelRequire("1Uk8Z");

var $aDEdS = parcelRequire("aDEdS");

var $b8zCZ = parcelRequire("b8zCZ");

var $81JO8 = parcelRequire("81JO8");

var $8uJ6I = parcelRequire("8uJ6I");

var $6DxtY = parcelRequire("6DxtY");

var $5CrOJ = parcelRequire("5CrOJ");

var $12uPh = parcelRequire("12uPh");

var $1ByS4 = parcelRequire("1ByS4");

var $bNWVz = parcelRequire("bNWVz");

var $cfq3B = parcelRequire("cfq3B");

var $eYRIX = parcelRequire("eYRIX");

var $7OePQ = parcelRequire("7OePQ");

var $hstBa = parcelRequire("hstBa");
function $ed56a2b156181a3e$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1ByS4.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $ed56a2b156181a3e$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1Uk8Z.viewport) ? (0, $7OePQ.default)((0, $aDEdS.default)(element, strategy)) : (0, $12uPh.isElement)(clippingParent) ? $ed56a2b156181a3e$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $7OePQ.default)((0, $b8zCZ.default)((0, $6DxtY.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $ed56a2b156181a3e$var$getClippingParents(element) {
    var clippingParents = (0, $81JO8.default)((0, $bNWVz.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5CrOJ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $12uPh.isHTMLElement)(element) ? (0, $8uJ6I.default)(element) : element;
    if (!(0, $12uPh.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $12uPh.isElement)(clippingParent) && (0, $cfq3B.default)(clippingParent, clipperElement) && (0, $eYRIX.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $ed56a2b156181a3e$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $ed56a2b156181a3e$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $ed56a2b156181a3e$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hstBa.max)(rect.top, accRect.top);
        accRect.right = (0, $hstBa.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hstBa.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hstBa.max)(rect.left, accRect.left);
        return accRect;
    }, $ed56a2b156181a3e$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("aDEdS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7becbf536c5743f8$export$2e2bcd8739ae039; });

var $hnw2w = parcelRequire("hnw2w");

var $6DxtY = parcelRequire("6DxtY");

var $cRrzK = parcelRequire("cRrzK");

var $jMBpi = parcelRequire("jMBpi");
function $7becbf536c5743f8$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $hnw2w.default)(element);
    var html = (0, $6DxtY.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $jMBpi.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $cRrzK.default)(element),
        y: y
    };
}

});

parcelRegister("b8zCZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $81bc13ff4064e500$export$2e2bcd8739ae039; });

var $6DxtY = parcelRequire("6DxtY");

var $5CrOJ = parcelRequire("5CrOJ");

var $cRrzK = parcelRequire("cRrzK");

var $gTE9w = parcelRequire("gTE9w");

var $hstBa = parcelRequire("hstBa");
function $81bc13ff4064e500$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $6DxtY.default)(element);
    var winScroll = (0, $gTE9w.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hstBa.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hstBa.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $cRrzK.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5CrOJ.default)(body || html).direction === 'rtl') x += (0, $hstBa.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("cfq3B", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8eab1929e8f55e25$export$2e2bcd8739ae039; });

var $12uPh = parcelRequire("12uPh");
function $8eab1929e8f55e25$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $12uPh.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("7OePQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5af8b5e39040199b$export$2e2bcd8739ae039; });
function $5af8b5e39040199b$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("4ferx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3173c43ef85b49bb$export$2e2bcd8739ae039; });

var $dvrbt = parcelRequire("dvrbt");
function $3173c43ef85b49bb$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $dvrbt.default)(), paddingObject);
}

});
parcelRegister("dvrbt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d5341ceade19f2a$export$2e2bcd8739ae039; });
function $9d5341ceade19f2a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("bz1rv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $86b41516314ebad8$export$2e2bcd8739ae039; });
function $86b41516314ebad8$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("k5ZCX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea14142a14ebad3b$export$2e2bcd8739ae039; });

var $cyrC7 = parcelRequire("cyrC7");

var $1Uk8Z = parcelRequire("1Uk8Z");

var $cl9yU = parcelRequire("cl9yU");

var $c0O4v = parcelRequire("c0O4v");
function $ea14142a14ebad3b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1Uk8Z.placements) : _options$allowedAutoP;
    var variation = (0, $cyrC7.default)(placement);
    var placements = variation ? flipVariations ? (0, $1Uk8Z.variationPlacements) : (0, $1Uk8Z.variationPlacements).filter(function(placement) {
        return (0, $cyrC7.default)(placement) === variation;
    }) : (0, $1Uk8Z.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $cl9yU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c0O4v.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("kz6NI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef8c5a05989f511d$export$2e2bcd8739ae039; });

var $1Uk8Z = parcelRequire("1Uk8Z");

var $c0O4v = parcelRequire("c0O4v");

var $7VLL8 = parcelRequire("7VLL8");

var $kMm03 = parcelRequire("kMm03");

var $5l1vx = parcelRequire("5l1vx");

var $1LxVa = parcelRequire("1LxVa");

var $8uJ6I = parcelRequire("8uJ6I");

var $cl9yU = parcelRequire("cl9yU");

var $cyrC7 = parcelRequire("cyrC7");

var $dvrbt = parcelRequire("dvrbt");

var $hstBa = parcelRequire("hstBa");
function $ef8c5a05989f511d$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $cl9yU.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c0O4v.default)(state.placement);
    var variation = (0, $cyrC7.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $7VLL8.default)(basePlacement);
    var altAxis = (0, $kMm03.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1Uk8Z.top) : (0, $1Uk8Z.left);
        var altSide = mainAxis === 'y' ? (0, $1Uk8Z.bottom) : (0, $1Uk8Z.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1Uk8Z.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1Uk8Z.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $1LxVa.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $dvrbt.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $5l1vx.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8uJ6I.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $5l1vx.within)(tether ? (0, $hstBa.min)(min, tetherMin) : min, offset, tether ? (0, $hstBa.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1Uk8Z.top) : (0, $1Uk8Z.left);
        var _altSide = mainAxis === 'x' ? (0, $1Uk8Z.bottom) : (0, $1Uk8Z.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1Uk8Z.top),
            (0, $1Uk8Z.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $5l1vx.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $5l1vx.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ef8c5a05989f511d$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $ef8c5a05989f511d$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("kMm03", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2095b12327f4740$export$2e2bcd8739ae039; });
function $f2095b12327f4740$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("5l1vx", function(module, exports) {
$parcel$export(module.exports, "within", function () { return $3e30155228e27785$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $3e30155228e27785$export$86c8af6d3ef0b4a; });

var $hstBa = parcelRequire("hstBa");
function $3e30155228e27785$export$f28d906d67a997f3(min, value, max) {
    return (0, $hstBa.max)(min, (0, $hstBa.min)(value, max));
}
function $3e30155228e27785$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $3e30155228e27785$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("9bfDx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6af1454348ec4986$export$2e2bcd8739ae039; });

var $c0O4v = parcelRequire("c0O4v");

var $1LxVa = parcelRequire("1LxVa");

var $cfq3B = parcelRequire("cfq3B");

var $8uJ6I = parcelRequire("8uJ6I");

var $7VLL8 = parcelRequire("7VLL8");

var $5l1vx = parcelRequire("5l1vx");

var $4ferx = parcelRequire("4ferx");

var $bz1rv = parcelRequire("bz1rv");

var $1Uk8Z = parcelRequire("1Uk8Z");
var $6af1454348ec4986$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4ferx.default)(typeof padding !== 'number' ? padding : (0, $bz1rv.default)(padding, (0, $1Uk8Z.basePlacements)));
};
function $6af1454348ec4986$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c0O4v.default)(state.placement);
    var axis = (0, $7VLL8.default)(basePlacement);
    var isVertical = [
        (0, $1Uk8Z.left),
        (0, $1Uk8Z.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $6af1454348ec4986$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $1LxVa.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1Uk8Z.top) : (0, $1Uk8Z.left);
    var maxProp = axis === 'y' ? (0, $1Uk8Z.bottom) : (0, $1Uk8Z.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8uJ6I.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $5l1vx.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $6af1454348ec4986$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $cfq3B.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $6af1454348ec4986$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $6af1454348ec4986$var$arrow,
    effect: $6af1454348ec4986$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("aN98i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7db59098d2903058$export$2e2bcd8739ae039; });

var $1Uk8Z = parcelRequire("1Uk8Z");

var $cl9yU = parcelRequire("cl9yU");
function $7db59098d2903058$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7db59098d2903058$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1Uk8Z.top),
        (0, $1Uk8Z.right),
        (0, $1Uk8Z.bottom),
        (0, $1Uk8Z.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7db59098d2903058$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $cl9yU.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $cl9yU.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7db59098d2903058$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7db59098d2903058$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7db59098d2903058$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7db59098d2903058$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7db59098d2903058$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7db59098d2903058$var$hide
};

});


parcelRegister("6prbz", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $4aaa2a5e856afac0$var$hasElementType = typeof Element !== 'undefined';
var $4aaa2a5e856afac0$var$hasMap = typeof Map === 'function';
var $4aaa2a5e856afac0$var$hasSet = typeof Set === 'function';
var $4aaa2a5e856afac0$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $4aaa2a5e856afac0$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$4aaa2a5e856afac0$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($4aaa2a5e856afac0$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$4aaa2a5e856afac0$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($4aaa2a5e856afac0$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($4aaa2a5e856afac0$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($4aaa2a5e856afac0$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$4aaa2a5e856afac0$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $4aaa2a5e856afac0$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});




parcelRegister("2bRWO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $198674ba23beb82f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $hpUev = parcelRequire("hpUev");

var $1DCwh = parcelRequire("1DCwh");

var $6rk9c = parcelRequire("6rk9c");
function $198674ba23beb82f$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $1DCwh.default)(mountStrategy);
    (0, $6rk9c.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hpUev.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("hpUev", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cae064294fac1c16$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $fZTqf = parcelRequire("fZTqf");
function $cae064294fac1c16$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $fZTqf.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $fZTqf.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $fZTqf.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(children, container);
}

});
parcelRegister("fZTqf", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $ba578b3d6a255fdc$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $ba578b3d6a255fdc$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $ba578b3d6a255fdc$export$c582005add11e141; });

var $33jtF = parcelRequire("33jtF");
var $ba578b3d6a255fdc$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $33jtF.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $ba578b3d6a255fdc$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $ba578b3d6a255fdc$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $33jtF.portalParentSelector));
    if (!parentElement) {
        var parent = document.createElement('div');
        parent.className = (0, $33jtF.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $ba578b3d6a255fdc$var$getBody().appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $ba578b3d6a255fdc$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $ba578b3d6a255fdc$var$getPortalParent().removeChild(container);
};
var $ba578b3d6a255fdc$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $ba578b3d6a255fdc$var$getPortalParent().appendChild(container);
};

});
parcelRegister("33jtF", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $2390c2c0e2c8d544$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $2390c2c0e2c8d544$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $2390c2c0e2c8d544$export$13f57c02915787b3; });
var $2390c2c0e2c8d544$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $2390c2c0e2c8d544$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $2390c2c0e2c8d544$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("1DCwh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $131750285aac5c74$export$2e2bcd8739ae039; });

var $hObf1 = parcelRequire("hObf1");

var $1oC0p = parcelRequire("1oC0p");

var $ampp3 = parcelRequire("ampp3");
var $131750285aac5c74$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $hObf1.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $ampp3.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $hObf1.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $131750285aac5c74$export$2e2bcd8739ae039 = $131750285aac5c74$var$useIsSubsequentRender;

});
parcelRegister("ampp3", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $78afaa010df05c94$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $78afaa010df05c94$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});


parcelRegister("6rk9c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b04e48ea3eec181$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $eHKWW = parcelRequire("eHKWW");

var $3H66d = parcelRequire("3H66d");
var $4b04e48ea3eec181$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $3H66d.default)((0, $eHKWW.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $3H66d.default)((0, $eHKWW.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $4b04e48ea3eec181$export$2e2bcd8739ae039 = $4b04e48ea3eec181$var$useFirePortalEvent;

});
parcelRegister("eHKWW", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $ab49800cc38fbe55$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $ab49800cc38fbe55$export$80816bd900e5bd00; });
var $ab49800cc38fbe55$export$ed5835cc67e87f72 = 'akPortalMount';
var $ab49800cc38fbe55$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("3H66d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2b0a1e6c431bfb13$export$2e2bcd8739ae039; });
var $2b0a1e6c431bfb13$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $2b0a1e6c431bfb13$var$getLayerName = function getLayerName(zIndex) {
    return $2b0a1e6c431bfb13$var$zIndexToName.hasOwnProperty(zIndex) ? $2b0a1e6c431bfb13$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $2b0a1e6c431bfb13$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $2b0a1e6c431bfb13$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $2b0a1e6c431bfb13$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $2b0a1e6c431bfb13$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("TKU93", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $0a798570447c2ec6$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $0a798570447c2ec6$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $0a798570447c2ec6$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "layers", function () { return $0a798570447c2ec6$export$7be255094ccdc533; });

var $2QeNR = parcelRequire("2QeNR");

var $1FV6W = parcelRequire("1FV6W");
var $0a798570447c2ec6$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0a798570447c2ec6$export$c93026a968943f95 = 'light';
var $0a798570447c2ec6$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0a798570447c2ec6$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $0a798570447c2ec6$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $0a798570447c2ec6$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $0a798570447c2ec6$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $0a798570447c2ec6$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $0a798570447c2ec6$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $0a798570447c2ec6$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $1FV6W.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0a798570447c2ec6$export$6d8204c2cb2e06b8() / 4;
    (0, $2QeNR.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0a798570447c2ec6$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0a798570447c2ec6$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0a798570447c2ec6$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2QeNR.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0a798570447c2ec6$export$ba1d834b86d72a09 = $0a798570447c2ec6$export$a1b3edb637fb4f35;
var $0a798570447c2ec6$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $1FV6W.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $1FV6W.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $1FV6W.N30A), ")")
            }
        }
    };
};

});
parcelRegister("2QeNR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $211bebb8a08abe44$export$2e2bcd8739ae039; });

var $9cfq2 = parcelRequire("9cfq2");

var $7t0tI = parcelRequire("7t0tI");
function $211bebb8a08abe44$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $9cfq2.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $211bebb8a08abe44$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("9cfq2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b2131e8cbbfddf4$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $6b2131e8cbbfddf4$var$printed = {};
function $6b2131e8cbbfddf4$export$2e2bcd8739ae039(message) {
    if ($6b2131e8cbbfddf4$var$printed[message]) return;
    $6b2131e8cbbfddf4$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("1FV6W", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $1385ebd7961cb12e$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $1385ebd7961cb12e$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $1385ebd7961cb12e$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N30A", function () { return $1385ebd7961cb12e$export$920c0d5c49070351; });
$parcel$export(module.exports, "skeleton", function () { return $1385ebd7961cb12e$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $19l3Q = parcelRequire("19l3Q");
var $1385ebd7961cb12e$export$4b84fd0e2c617bd = '#FFEBE6';
var $1385ebd7961cb12e$export$b34b069eff244586 = '#FFBDAD';
var $1385ebd7961cb12e$export$be802dd0d8b57f35 = '#FF8F73';
var $1385ebd7961cb12e$export$60847d42f9da92a6 = '#FF7452';
var $1385ebd7961cb12e$export$4a7404f376229999 = '#FF5630';
var $1385ebd7961cb12e$export$2010d0fb4295b346 = '#DE350B';
var $1385ebd7961cb12e$export$2837b5a1a71d5c02 = '#BF2600';
var $1385ebd7961cb12e$export$8d9596b529bbb9cf = '#FFFAE6';
var $1385ebd7961cb12e$export$41060a744ab0b7ae = '#FFF0B3';
var $1385ebd7961cb12e$export$1cc05bbbf340e559 = '#FFE380';
var $1385ebd7961cb12e$export$5aae31392d72caaa = '#FFC400';
var $1385ebd7961cb12e$export$c6930421db9fa514 = '#FFAB00';
var $1385ebd7961cb12e$export$59619663aa6500fb = '#FF991F';
var $1385ebd7961cb12e$export$874739ea9e379ab6 = '#FF8B00';
var $1385ebd7961cb12e$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1385ebd7961cb12e$export$69a3bf21b9686c2b = '#ABF5D1';
var $1385ebd7961cb12e$export$afbce1382ec95f73 = '#79F2C0';
var $1385ebd7961cb12e$export$747d86715d4175de = '#57D9A3';
var $1385ebd7961cb12e$export$940e1f69e873f202 = '#36B37E';
var $1385ebd7961cb12e$export$a49394138f7b8e85 = '#00875A';
var $1385ebd7961cb12e$export$6fa04827ac68a4fb = '#006644';
var $1385ebd7961cb12e$export$226de0355ed012f8 = '#DEEBFF';
var $1385ebd7961cb12e$export$8c13c2ee36917869 = '#B3D4FF';
var $1385ebd7961cb12e$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1385ebd7961cb12e$export$215b7063051591f1 = '#2684FF';
var $1385ebd7961cb12e$export$e62e8919cca44969 = '#0065FF';
var $1385ebd7961cb12e$export$b3de0ae08da2ce64 = '#0052CC';
var $1385ebd7961cb12e$export$a6ee3d71bc067634 = '#0747A6';
var $1385ebd7961cb12e$export$363e4475840015bb = '#EAE6FF';
var $1385ebd7961cb12e$export$4b0a4417ed59760f = '#C0B6F2';
var $1385ebd7961cb12e$export$6011520a64d9a187 = '#998DD9';
var $1385ebd7961cb12e$export$a7175d4e9206bc80 = '#8777D9';
var $1385ebd7961cb12e$export$b48405b95304b5a1 = '#6554C0';
var $1385ebd7961cb12e$export$c71e4279dd54a18d = '#5243AA';
var $1385ebd7961cb12e$export$147899de772240ec = '#403294';
var $1385ebd7961cb12e$export$2cf711fe14c66f06 = '#E6FCFF';
var $1385ebd7961cb12e$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1385ebd7961cb12e$export$776c9c497ef08533 = '#79E2F2';
var $1385ebd7961cb12e$export$69cb3ca10c1e330e = '#00C7E6';
var $1385ebd7961cb12e$export$9dc1ef0f3f48059b = '#00B8D9';
var $1385ebd7961cb12e$export$7c835c78b6fcdef8 = '#00A3BF';
var $1385ebd7961cb12e$export$6036577f95c3877e = '#008DA6';
var $1385ebd7961cb12e$export$29a4f05edc054374 = '#FFFFFF';
var $1385ebd7961cb12e$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1385ebd7961cb12e$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1385ebd7961cb12e$export$3e51e8f1440314ba = '#EBECF0';
var $1385ebd7961cb12e$export$1ce2d1575d444ceb = '#DFE1E6';
var $1385ebd7961cb12e$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1385ebd7961cb12e$export$c2e91cbeada39b8b = '#B3BAC5';
var $1385ebd7961cb12e$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1385ebd7961cb12e$export$eaa8c8a70ac22806 = '#97A0AF';
var $1385ebd7961cb12e$export$7c87d337fb91a97d = '#8993A4';
var $1385ebd7961cb12e$export$d6447c357493214f = '#7A869A';
var $1385ebd7961cb12e$export$f563ee71e9ee74cd = '#6B778C';
var $1385ebd7961cb12e$export$e2ef2124cf4024b1 = '#5E6C84';
var $1385ebd7961cb12e$export$eece5f492e429f08 = '#505F79';
var $1385ebd7961cb12e$export$c39c0fe0f26207ae = '#42526E';
var $1385ebd7961cb12e$export$7090862dc3038a9f = '#344563';
var $1385ebd7961cb12e$export$ad0bacf983b7ddaa = '#253858';
var $1385ebd7961cb12e$export$7d61b15e0da132af = '#172B4D';
var $1385ebd7961cb12e$export$fbda843f0a27fe96 = '#091E42';
var $1385ebd7961cb12e$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1385ebd7961cb12e$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1385ebd7961cb12e$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1385ebd7961cb12e$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1385ebd7961cb12e$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1385ebd7961cb12e$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1385ebd7961cb12e$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1385ebd7961cb12e$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1385ebd7961cb12e$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1385ebd7961cb12e$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1385ebd7961cb12e$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1385ebd7961cb12e$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1385ebd7961cb12e$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1385ebd7961cb12e$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1385ebd7961cb12e$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1385ebd7961cb12e$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1385ebd7961cb12e$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1385ebd7961cb12e$export$2f6319cf7d736c2a = '#E6EDFA';
var $1385ebd7961cb12e$export$95126bc8884d6634 = '#DCE5F5';
var $1385ebd7961cb12e$export$8338d8c35d44ff1 = '#CED9EB';
var $1385ebd7961cb12e$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1385ebd7961cb12e$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1385ebd7961cb12e$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1385ebd7961cb12e$export$97e81faa16a182c7 = '#8C9CB8';
var $1385ebd7961cb12e$export$bfe21c59123ecf33 = '#7988A3';
var $1385ebd7961cb12e$export$ee82aa2ea6a1558 = '#67758F';
var $1385ebd7961cb12e$export$682927c6ed76be02 = '#56637A';
var $1385ebd7961cb12e$export$91fd9994c5be9757 = '#455166';
var $1385ebd7961cb12e$export$d281fbfe3cff2df6 = '#3B475C';
var $1385ebd7961cb12e$export$3902c91d8b98a753 = '#313D52';
var $1385ebd7961cb12e$export$8e8133c1ba5845b5 = '#283447';
var $1385ebd7961cb12e$export$33ff357f6620b39 = '#202B3D';
var $1385ebd7961cb12e$export$633847cf062b69e0 = '#1B2638';
var $1385ebd7961cb12e$export$9776a6e503bdbf76 = '#121A29';
var $1385ebd7961cb12e$export$6c813d5160dff5db = '#0E1624';
var $1385ebd7961cb12e$export$3d4f271a500072a = '#0D1424';
var $1385ebd7961cb12e$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1385ebd7961cb12e$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1385ebd7961cb12e$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1385ebd7961cb12e$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1385ebd7961cb12e$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1385ebd7961cb12e$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1385ebd7961cb12e$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1385ebd7961cb12e$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1385ebd7961cb12e$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1385ebd7961cb12e$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1385ebd7961cb12e$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1385ebd7961cb12e$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1385ebd7961cb12e$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1385ebd7961cb12e$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1385ebd7961cb12e$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1385ebd7961cb12e$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1385ebd7961cb12e$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1385ebd7961cb12e$export$8ce1fd94bee2f412 = (0, $19l3Q.default)({
    light: "var(--ds-surface, ".concat($1385ebd7961cb12e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($1385ebd7961cb12e$export$633847cf062b69e0, ")")
});
var $1385ebd7961cb12e$export$b861914ea877b580 = (0, $19l3Q.default)({
    light: "var(--ds-background-selected, ".concat($1385ebd7961cb12e$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($1385ebd7961cb12e$export$8c13c2ee36917869, ")")
});
var $1385ebd7961cb12e$export$3f1b020df94387af = (0, $19l3Q.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($1385ebd7961cb12e$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($1385ebd7961cb12e$export$d281fbfe3cff2df6, ")")
});
var $1385ebd7961cb12e$export$c0183dbab98ca63e = (0, $19l3Q.default)({
    light: "var(--ds-surface-overlay, ".concat($1385ebd7961cb12e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($1385ebd7961cb12e$export$8e8133c1ba5845b5, ")")
});
var $1385ebd7961cb12e$export$6f093cfa640b7166 = (0, $19l3Q.default)({
    light: "var(--ds-text, ".concat($1385ebd7961cb12e$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($1385ebd7961cb12e$export$5368d76ae4fbbda7, ")")
});
var $1385ebd7961cb12e$export$42f8e9c698766e7a = (0, $19l3Q.default)({
    light: "var(--ds-text, ".concat($1385ebd7961cb12e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($1385ebd7961cb12e$export$5368d76ae4fbbda7, ")")
});
var $1385ebd7961cb12e$export$c2d157ca1c34b6e3 = (0, $19l3Q.default)({
    light: "var(--ds-text-selected, ".concat($1385ebd7961cb12e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($1385ebd7961cb12e$export$b3de0ae08da2ce64, ")")
});
var $1385ebd7961cb12e$export$1905ba28d7cf066f = (0, $19l3Q.default)({
    light: "var(--ds-text-subtlest, ".concat($1385ebd7961cb12e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($1385ebd7961cb12e$export$97e81faa16a182c7, ")")
});
var $1385ebd7961cb12e$export$bd9002130d306d39 = (0, $19l3Q.default)({
    light: "var(--ds-text-subtlest, ".concat($1385ebd7961cb12e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($1385ebd7961cb12e$export$bfe21c59123ecf33, ")")
});
var $1385ebd7961cb12e$export$46e4a324ac90507f = (0, $19l3Q.default)({
    light: "var(--ds-text, ".concat($1385ebd7961cb12e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($1385ebd7961cb12e$export$5368d76ae4fbbda7, ")")
});
var $1385ebd7961cb12e$export$79f3f2b82beb0d36 = (0, $19l3Q.default)({
    light: "var(--ds-text-subtlest, ".concat($1385ebd7961cb12e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($1385ebd7961cb12e$export$97e81faa16a182c7, ")")
});
var $1385ebd7961cb12e$export$7bb0d5c671655cc4 = (0, $19l3Q.default)({
    light: $1385ebd7961cb12e$export$9fdfb749e33cdf97,
    dark: $1385ebd7961cb12e$export$8e8133c1ba5845b5
});
var $1385ebd7961cb12e$export$9c30223ca0a664fb = (0, $19l3Q.default)({
    light: "var(--ds-link, ".concat($1385ebd7961cb12e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($1385ebd7961cb12e$export$ecfc1dff386a3e7a, ")")
});
var $1385ebd7961cb12e$export$7ed258b0728b004b = (0, $19l3Q.default)({
    light: "var(--ds-link-pressed, ".concat($1385ebd7961cb12e$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($1385ebd7961cb12e$export$215b7063051591f1, ")")
});
var $1385ebd7961cb12e$export$dfa920d8decc8a59 = (0, $19l3Q.default)({
    light: "var(--ds-link-pressed, ".concat($1385ebd7961cb12e$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($1385ebd7961cb12e$export$ecfc1dff386a3e7a, ")")
});
var $1385ebd7961cb12e$export$6069e6ad5c78f632 = (0, $19l3Q.default)({
    light: "var(--ds-border-focused, ".concat($1385ebd7961cb12e$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($1385ebd7961cb12e$export$215b7063051591f1, ")")
});
var $1385ebd7961cb12e$export$9ad721cf3b3debe0 = (0, $19l3Q.default)({
    light: "var(--ds-background-brand-bold, ".concat($1385ebd7961cb12e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($1385ebd7961cb12e$export$ecfc1dff386a3e7a, ")")
});
var $1385ebd7961cb12e$export$2aa0182783e7e9de = (0, $19l3Q.default)({
    light: $1385ebd7961cb12e$export$b3de0ae08da2ce64,
    dark: $1385ebd7961cb12e$export$ecfc1dff386a3e7a
});
var $1385ebd7961cb12e$export$8bf7dff220b82b4a = (0, $19l3Q.default)({
    light: $1385ebd7961cb12e$export$9dc1ef0f3f48059b,
    dark: $1385ebd7961cb12e$export$69cb3ca10c1e330e
});
var $1385ebd7961cb12e$export$e13cce2a2d16a9d4 = (0, $19l3Q.default)({
    light: $1385ebd7961cb12e$export$b48405b95304b5a1,
    dark: $1385ebd7961cb12e$export$6011520a64d9a187
});
var $1385ebd7961cb12e$export$a90204d1394caf30 = (0, $19l3Q.default)({
    light: $1385ebd7961cb12e$export$4a7404f376229999,
    dark: $1385ebd7961cb12e$export$4a7404f376229999
});
var $1385ebd7961cb12e$export$594c5a8758200c32 = (0, $19l3Q.default)({
    light: $1385ebd7961cb12e$export$c6930421db9fa514,
    dark: $1385ebd7961cb12e$export$c6930421db9fa514
});
var $1385ebd7961cb12e$export$955a2ebd2fb142ae = (0, $19l3Q.default)({
    light: $1385ebd7961cb12e$export$940e1f69e873f202,
    dark: $1385ebd7961cb12e$export$940e1f69e873f202
});
var $1385ebd7961cb12e$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($1385ebd7961cb12e$export$8d43898f60b96a82, ")");
};

});
parcelRegister("19l3Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0d66f8016dc1efb6$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $5PjFa = parcelRequire("5PjFa");
// Unpack custom variants, and get correct value for the current theme
function $0d66f8016dc1efb6$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $5PjFa.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $0d66f8016dc1efb6$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $0d66f8016dc1efb6$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $5PjFa.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("5PjFa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43e0f7d8dcc041aa$export$2e2bcd8739ae039; });

var $TKU93 = parcelRequire("TKU93");
function $43e0f7d8dcc041aa$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $TKU93.CHANNEL) in props.theme) return props.theme[0, $TKU93.CHANNEL];
        else if ('mode' in props.theme && (0, $TKU93.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $TKU93.DEFAULT_THEME_MODE)
    };
}

});




parcelRegister("2iv5o", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $1ac5603a132ae45b$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $1ac5603a132ae45b$var$registrations = new Set();
var $1ac5603a132ae45b$var$cleanupEndEventListeners = null;
function $1ac5603a132ae45b$var$onDragStart() {
    if ($1ac5603a132ae45b$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $1ac5603a132ae45b$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $1ac5603a132ae45b$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $1ac5603a132ae45b$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $1ac5603a132ae45b$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($1ac5603a132ae45b$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $1ac5603a132ae45b$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $1ac5603a132ae45b$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $1ac5603a132ae45b$var$cleanupEndEventListeners = null;
    var clone = Array.from($1ac5603a132ae45b$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $1ac5603a132ae45b$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $1ac5603a132ae45b$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $1ac5603a132ae45b$var$onDragStart
        }
    ]);
}
var $1ac5603a132ae45b$var$cleanupStartEventListeners = null;
function $1ac5603a132ae45b$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$1ac5603a132ae45b$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $1ac5603a132ae45b$var$cleanupStartEventListeners = $1ac5603a132ae45b$var$bindStartEvents();
    $1ac5603a132ae45b$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $1ac5603a132ae45b$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $1ac5603a132ae45b$var$registrations.delete(registration);
        if ($1ac5603a132ae45b$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $1ac5603a132ae45b$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $1ac5603a132ae45b$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("7u7oJ", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $573112d6321c1ac5$export$57bf213be019eeb0; });

var $6pDoC = parcelRequire("6pDoC");
// This file is a singleton for managing tooltips
var $573112d6321c1ac5$var$active = null;
function $573112d6321c1ac5$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($573112d6321c1ac5$var$active && $573112d6321c1ac5$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $6pDoC.clearScheduled)();
            $573112d6321c1ac5$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $6pDoC.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $6pDoC.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $6pDoC.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($573112d6321c1ac5$var$active && $573112d6321c1ac5$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($573112d6321c1ac5$var$active) {
            (0, $6pDoC.clearScheduled)();
            $573112d6321c1ac5$var$active.entry.hide({
                isImmediate: true
            });
            $573112d6321c1ac5$var$active.entry.done();
            $573112d6321c1ac5$var$active = null;
        }
        // this tooltip is now the active tooltip
        $573112d6321c1ac5$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $6pDoC.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("6pDoC", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", function () { return $4ab3a3229a1436e0$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $4ab3a3229a1436e0$export$5f4d6617421d489b; });
var $4ab3a3229a1436e0$var$delayId = null;
function $4ab3a3229a1436e0$export$eaf678f6f93f5250() {
    if ($4ab3a3229a1436e0$var$delayId != null) {
        window.clearTimeout($4ab3a3229a1436e0$var$delayId);
        $4ab3a3229a1436e0$var$delayId = null;
    }
}
function $4ab3a3229a1436e0$export$5f4d6617421d489b(fn, delay) {
    $4ab3a3229a1436e0$export$eaf678f6f93f5250();
    $4ab3a3229a1436e0$var$delayId = window.setTimeout(function() {
        $4ab3a3229a1436e0$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("5pzwy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3f0ad7df2eef1570$export$2e2bcd8739ae039; });

var $6JmtO = parcelRequire("6JmtO");
function $3f0ad7df2eef1570$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $6JmtO.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("5v1Pf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4011437fffa2708c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $1FV6W = parcelRequire("1FV6W");

var $7za1x = parcelRequire("7za1x");
var $4011437fffa2708c$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    maxWidth: '240px',
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $1FV6W.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $1FV6W.N0), ")")
});
var $4011437fffa2708c$var$truncateStyles = (0, $3dJ4i.css)({
    maxWidth: '420px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $4011437fffa2708c$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $3dJ4i.jsx)((0, $7za1x.default), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $4011437fffa2708c$var$baseStyles,
            truncate ? $4011437fffa2708c$var$truncateStyles : null
        ]
    }, children);
});
$4011437fffa2708c$var$TooltipContainer.displayName = 'TooltipContainer';
var $4011437fffa2708c$export$2e2bcd8739ae039 = $4011437fffa2708c$var$TooltipContainer;

});
parcelRegister("7za1x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $582393c87d203f70$export$2e2bcd8739ae039; });

var $43rKr = parcelRequire("43rKr");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $TKU93 = parcelRequire("TKU93");
function $582393c87d203f70$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $582393c87d203f70$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $582393c87d203f70$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $43rKr.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $582393c87d203f70$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $582393c87d203f70$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $582393c87d203f70$var$primitiveStyles = (0, $3dJ4i.css)({
    zindex: "var(".concat($582393c87d203f70$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $582393c87d203f70$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $582393c87d203f70$var$_objectSpread($582393c87d203f70$var$_objectSpread({}, style), {}, (0, $43rKr.default)({}, $582393c87d203f70$var$VAR_PRIMITIVE_ZINDEX, (0, $TKU93.layers).tooltip()));
    return (0, $3dJ4i.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $3dJ4i.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $582393c87d203f70$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$582393c87d203f70$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $582393c87d203f70$export$2e2bcd8739ae039 = $582393c87d203f70$var$TooltipPrimitive;

});


parcelRegister("hokAv", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", function () { return $ca94a5e1f3bbf544$export$642213d516a9b928; });
function $ca94a5e1f3bbf544$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});



parcelRegister("g9ZvA", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $294ba0be8eaf4a94$export$b08b517936747730; });

var $7VQPk = parcelRequire("7VQPk");

var $7qFQI = parcelRequire("7qFQI");
const $294ba0be8eaf4a94$export$b08b517936747730 = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
    role: "alert",
    "aria-label": "Loading",
    "data-testid": "global-nav-user-profile-container-spinner",
    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {})
});

});
parcelRegister("7qFQI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $568b6c84e950283c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $8LJAk = parcelRequire("8LJAk");

var $bQtpa = parcelRequire("bQtpa");

var $6X520 = parcelRequire("6X520");

var $8SgZH = parcelRequire("8SgZH");
/**
 * Returns the appropriate circle stroke color.
 */ function $568b6c84e950283c$var$getStrokeColor(_ref) {
    var mode = _ref.mode, appearance = _ref.appearance;
    if (mode === 'light') return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $bQtpa.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $bQtpa.N0), ")");
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $bQtpa.DN900), ")") : "var(--ds-icon-inverse, ".concat((0, $bQtpa.DN500), ")");
}
var $568b6c84e950283c$var$rotate = (0, $3dJ4i.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $568b6c84e950283c$var$rotateStyles = (0, $3dJ4i.css)({
    animation: "".concat($568b6c84e950283c$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $568b6c84e950283c$var$loadIn = (0, $3dJ4i.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $568b6c84e950283c$var$loadInStyles = (0, $3dJ4i.css)({
    animation: "".concat($568b6c84e950283c$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $568b6c84e950283c$var$wrapperStyles = (0, $3dJ4i.css)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $568b6c84e950283c$var$circleStyles = (0, $3dJ4i.css)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $568b6c84e950283c$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
var $568b6c84e950283c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'inherit' : _ref2$appearance, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 0 : _ref2$delay, interactionName = _ref2.interactionName, label = _ref2.label, _ref2$size = _ref2.size, providedSize = _ref2$size === void 0 ? 'medium' : _ref2$size, testId = _ref2.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $8SgZH.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var _useGlobalTheme = (0, $6X520.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var stroke = $568b6c84e950283c$var$getStrokeColor({
        mode: mode,
        appearance: appearance
    });
    var context = (0, $1oC0p.useContext)((0, $8LJAk.default));
    $568b6c84e950283c$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $3dJ4i.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $568b6c84e950283c$var$wrapperStyles,
            $568b6c84e950283c$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $3dJ4i.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $568b6c84e950283c$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $3dJ4i.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $568b6c84e950283c$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));

});
parcelRegister("8LJAk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $662612b9ecc59355$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $662612b9ecc59355$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("bQtpa", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $89fb5c3e61d25bd4$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $89fb5c3e61d25bd4$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $89fb5c3e61d25bd4$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N30A", function () { return $89fb5c3e61d25bd4$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN900", function () { return $89fb5c3e61d25bd4$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN500", function () { return $89fb5c3e61d25bd4$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "skeleton", function () { return $89fb5c3e61d25bd4$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5Eb1o = parcelRequire("5Eb1o");
var $89fb5c3e61d25bd4$export$4b84fd0e2c617bd = '#FFEBE6';
var $89fb5c3e61d25bd4$export$b34b069eff244586 = '#FFBDAD';
var $89fb5c3e61d25bd4$export$be802dd0d8b57f35 = '#FF8F73';
var $89fb5c3e61d25bd4$export$60847d42f9da92a6 = '#FF7452';
var $89fb5c3e61d25bd4$export$4a7404f376229999 = '#FF5630';
var $89fb5c3e61d25bd4$export$2010d0fb4295b346 = '#DE350B';
var $89fb5c3e61d25bd4$export$2837b5a1a71d5c02 = '#BF2600';
var $89fb5c3e61d25bd4$export$8d9596b529bbb9cf = '#FFFAE6';
var $89fb5c3e61d25bd4$export$41060a744ab0b7ae = '#FFF0B3';
var $89fb5c3e61d25bd4$export$1cc05bbbf340e559 = '#FFE380';
var $89fb5c3e61d25bd4$export$5aae31392d72caaa = '#FFC400';
var $89fb5c3e61d25bd4$export$c6930421db9fa514 = '#FFAB00';
var $89fb5c3e61d25bd4$export$59619663aa6500fb = '#FF991F';
var $89fb5c3e61d25bd4$export$874739ea9e379ab6 = '#FF8B00';
var $89fb5c3e61d25bd4$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $89fb5c3e61d25bd4$export$69a3bf21b9686c2b = '#ABF5D1';
var $89fb5c3e61d25bd4$export$afbce1382ec95f73 = '#79F2C0';
var $89fb5c3e61d25bd4$export$747d86715d4175de = '#57D9A3';
var $89fb5c3e61d25bd4$export$940e1f69e873f202 = '#36B37E';
var $89fb5c3e61d25bd4$export$a49394138f7b8e85 = '#00875A';
var $89fb5c3e61d25bd4$export$6fa04827ac68a4fb = '#006644';
var $89fb5c3e61d25bd4$export$226de0355ed012f8 = '#DEEBFF';
var $89fb5c3e61d25bd4$export$8c13c2ee36917869 = '#B3D4FF';
var $89fb5c3e61d25bd4$export$ecfc1dff386a3e7a = '#4C9AFF';
var $89fb5c3e61d25bd4$export$215b7063051591f1 = '#2684FF';
var $89fb5c3e61d25bd4$export$e62e8919cca44969 = '#0065FF';
var $89fb5c3e61d25bd4$export$b3de0ae08da2ce64 = '#0052CC';
var $89fb5c3e61d25bd4$export$a6ee3d71bc067634 = '#0747A6';
var $89fb5c3e61d25bd4$export$363e4475840015bb = '#EAE6FF';
var $89fb5c3e61d25bd4$export$4b0a4417ed59760f = '#C0B6F2';
var $89fb5c3e61d25bd4$export$6011520a64d9a187 = '#998DD9';
var $89fb5c3e61d25bd4$export$a7175d4e9206bc80 = '#8777D9';
var $89fb5c3e61d25bd4$export$b48405b95304b5a1 = '#6554C0';
var $89fb5c3e61d25bd4$export$c71e4279dd54a18d = '#5243AA';
var $89fb5c3e61d25bd4$export$147899de772240ec = '#403294';
var $89fb5c3e61d25bd4$export$2cf711fe14c66f06 = '#E6FCFF';
var $89fb5c3e61d25bd4$export$7a8f4d33f6f9772c = '#B3F5FF';
var $89fb5c3e61d25bd4$export$776c9c497ef08533 = '#79E2F2';
var $89fb5c3e61d25bd4$export$69cb3ca10c1e330e = '#00C7E6';
var $89fb5c3e61d25bd4$export$9dc1ef0f3f48059b = '#00B8D9';
var $89fb5c3e61d25bd4$export$7c835c78b6fcdef8 = '#00A3BF';
var $89fb5c3e61d25bd4$export$6036577f95c3877e = '#008DA6';
var $89fb5c3e61d25bd4$export$29a4f05edc054374 = '#FFFFFF';
var $89fb5c3e61d25bd4$export$e655ef011c4aa1a2 = '#FAFBFC';
var $89fb5c3e61d25bd4$export$9fdfb749e33cdf97 = '#F4F5F7';
var $89fb5c3e61d25bd4$export$3e51e8f1440314ba = '#EBECF0';
var $89fb5c3e61d25bd4$export$1ce2d1575d444ceb = '#DFE1E6';
var $89fb5c3e61d25bd4$export$8754fc7e6d8b3000 = '#C1C7D0';
var $89fb5c3e61d25bd4$export$c2e91cbeada39b8b = '#B3BAC5';
var $89fb5c3e61d25bd4$export$5f71e19f3a7ad9de = '#A5ADBA';
var $89fb5c3e61d25bd4$export$eaa8c8a70ac22806 = '#97A0AF';
var $89fb5c3e61d25bd4$export$7c87d337fb91a97d = '#8993A4';
var $89fb5c3e61d25bd4$export$d6447c357493214f = '#7A869A';
var $89fb5c3e61d25bd4$export$f563ee71e9ee74cd = '#6B778C';
var $89fb5c3e61d25bd4$export$e2ef2124cf4024b1 = '#5E6C84';
var $89fb5c3e61d25bd4$export$eece5f492e429f08 = '#505F79';
var $89fb5c3e61d25bd4$export$c39c0fe0f26207ae = '#42526E';
var $89fb5c3e61d25bd4$export$7090862dc3038a9f = '#344563';
var $89fb5c3e61d25bd4$export$ad0bacf983b7ddaa = '#253858';
var $89fb5c3e61d25bd4$export$7d61b15e0da132af = '#172B4D';
var $89fb5c3e61d25bd4$export$fbda843f0a27fe96 = '#091E42';
var $89fb5c3e61d25bd4$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $89fb5c3e61d25bd4$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $89fb5c3e61d25bd4$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $89fb5c3e61d25bd4$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $89fb5c3e61d25bd4$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $89fb5c3e61d25bd4$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $89fb5c3e61d25bd4$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $89fb5c3e61d25bd4$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $89fb5c3e61d25bd4$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $89fb5c3e61d25bd4$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $89fb5c3e61d25bd4$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $89fb5c3e61d25bd4$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $89fb5c3e61d25bd4$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $89fb5c3e61d25bd4$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $89fb5c3e61d25bd4$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $89fb5c3e61d25bd4$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $89fb5c3e61d25bd4$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $89fb5c3e61d25bd4$export$2f6319cf7d736c2a = '#E6EDFA';
var $89fb5c3e61d25bd4$export$95126bc8884d6634 = '#DCE5F5';
var $89fb5c3e61d25bd4$export$8338d8c35d44ff1 = '#CED9EB';
var $89fb5c3e61d25bd4$export$5368d76ae4fbbda7 = '#B8C7E0';
var $89fb5c3e61d25bd4$export$9f0a771d16ec8d36 = '#ABBBD6';
var $89fb5c3e61d25bd4$export$abcf8c38338b4aa5 = '#9FB0CC';
var $89fb5c3e61d25bd4$export$97e81faa16a182c7 = '#8C9CB8';
var $89fb5c3e61d25bd4$export$bfe21c59123ecf33 = '#7988A3';
var $89fb5c3e61d25bd4$export$ee82aa2ea6a1558 = '#67758F';
var $89fb5c3e61d25bd4$export$682927c6ed76be02 = '#56637A';
var $89fb5c3e61d25bd4$export$91fd9994c5be9757 = '#455166';
var $89fb5c3e61d25bd4$export$d281fbfe3cff2df6 = '#3B475C';
var $89fb5c3e61d25bd4$export$3902c91d8b98a753 = '#313D52';
var $89fb5c3e61d25bd4$export$8e8133c1ba5845b5 = '#283447';
var $89fb5c3e61d25bd4$export$33ff357f6620b39 = '#202B3D';
var $89fb5c3e61d25bd4$export$633847cf062b69e0 = '#1B2638';
var $89fb5c3e61d25bd4$export$9776a6e503bdbf76 = '#121A29';
var $89fb5c3e61d25bd4$export$6c813d5160dff5db = '#0E1624';
var $89fb5c3e61d25bd4$export$3d4f271a500072a = '#0D1424';
var $89fb5c3e61d25bd4$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $89fb5c3e61d25bd4$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $89fb5c3e61d25bd4$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $89fb5c3e61d25bd4$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $89fb5c3e61d25bd4$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $89fb5c3e61d25bd4$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $89fb5c3e61d25bd4$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $89fb5c3e61d25bd4$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $89fb5c3e61d25bd4$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $89fb5c3e61d25bd4$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $89fb5c3e61d25bd4$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $89fb5c3e61d25bd4$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $89fb5c3e61d25bd4$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $89fb5c3e61d25bd4$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $89fb5c3e61d25bd4$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $89fb5c3e61d25bd4$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $89fb5c3e61d25bd4$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $89fb5c3e61d25bd4$export$8ce1fd94bee2f412 = (0, $5Eb1o.default)({
    light: "var(--ds-surface, ".concat($89fb5c3e61d25bd4$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($89fb5c3e61d25bd4$export$633847cf062b69e0, ")")
});
var $89fb5c3e61d25bd4$export$b861914ea877b580 = (0, $5Eb1o.default)({
    light: "var(--ds-background-selected, ".concat($89fb5c3e61d25bd4$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($89fb5c3e61d25bd4$export$8c13c2ee36917869, ")")
});
var $89fb5c3e61d25bd4$export$3f1b020df94387af = (0, $5Eb1o.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($89fb5c3e61d25bd4$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($89fb5c3e61d25bd4$export$d281fbfe3cff2df6, ")")
});
var $89fb5c3e61d25bd4$export$c0183dbab98ca63e = (0, $5Eb1o.default)({
    light: "var(--ds-surface-overlay, ".concat($89fb5c3e61d25bd4$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($89fb5c3e61d25bd4$export$8e8133c1ba5845b5, ")")
});
var $89fb5c3e61d25bd4$export$6f093cfa640b7166 = (0, $5Eb1o.default)({
    light: "var(--ds-text, ".concat($89fb5c3e61d25bd4$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($89fb5c3e61d25bd4$export$5368d76ae4fbbda7, ")")
});
var $89fb5c3e61d25bd4$export$42f8e9c698766e7a = (0, $5Eb1o.default)({
    light: "var(--ds-text, ".concat($89fb5c3e61d25bd4$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($89fb5c3e61d25bd4$export$5368d76ae4fbbda7, ")")
});
var $89fb5c3e61d25bd4$export$c2d157ca1c34b6e3 = (0, $5Eb1o.default)({
    light: "var(--ds-text-selected, ".concat($89fb5c3e61d25bd4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($89fb5c3e61d25bd4$export$b3de0ae08da2ce64, ")")
});
var $89fb5c3e61d25bd4$export$1905ba28d7cf066f = (0, $5Eb1o.default)({
    light: "var(--ds-text-subtlest, ".concat($89fb5c3e61d25bd4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($89fb5c3e61d25bd4$export$97e81faa16a182c7, ")")
});
var $89fb5c3e61d25bd4$export$bd9002130d306d39 = (0, $5Eb1o.default)({
    light: "var(--ds-text-subtlest, ".concat($89fb5c3e61d25bd4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($89fb5c3e61d25bd4$export$bfe21c59123ecf33, ")")
});
var $89fb5c3e61d25bd4$export$46e4a324ac90507f = (0, $5Eb1o.default)({
    light: "var(--ds-text, ".concat($89fb5c3e61d25bd4$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($89fb5c3e61d25bd4$export$5368d76ae4fbbda7, ")")
});
var $89fb5c3e61d25bd4$export$79f3f2b82beb0d36 = (0, $5Eb1o.default)({
    light: "var(--ds-text-subtlest, ".concat($89fb5c3e61d25bd4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($89fb5c3e61d25bd4$export$97e81faa16a182c7, ")")
});
var $89fb5c3e61d25bd4$export$7bb0d5c671655cc4 = (0, $5Eb1o.default)({
    light: $89fb5c3e61d25bd4$export$9fdfb749e33cdf97,
    dark: $89fb5c3e61d25bd4$export$8e8133c1ba5845b5
});
var $89fb5c3e61d25bd4$export$9c30223ca0a664fb = (0, $5Eb1o.default)({
    light: "var(--ds-link, ".concat($89fb5c3e61d25bd4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($89fb5c3e61d25bd4$export$ecfc1dff386a3e7a, ")")
});
var $89fb5c3e61d25bd4$export$7ed258b0728b004b = (0, $5Eb1o.default)({
    light: "var(--ds-link-pressed, ".concat($89fb5c3e61d25bd4$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($89fb5c3e61d25bd4$export$215b7063051591f1, ")")
});
var $89fb5c3e61d25bd4$export$dfa920d8decc8a59 = (0, $5Eb1o.default)({
    light: "var(--ds-link-pressed, ".concat($89fb5c3e61d25bd4$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($89fb5c3e61d25bd4$export$ecfc1dff386a3e7a, ")")
});
var $89fb5c3e61d25bd4$export$6069e6ad5c78f632 = (0, $5Eb1o.default)({
    light: "var(--ds-border-focused, ".concat($89fb5c3e61d25bd4$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($89fb5c3e61d25bd4$export$215b7063051591f1, ")")
});
var $89fb5c3e61d25bd4$export$9ad721cf3b3debe0 = (0, $5Eb1o.default)({
    light: "var(--ds-background-brand-bold, ".concat($89fb5c3e61d25bd4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($89fb5c3e61d25bd4$export$ecfc1dff386a3e7a, ")")
});
var $89fb5c3e61d25bd4$export$2aa0182783e7e9de = (0, $5Eb1o.default)({
    light: $89fb5c3e61d25bd4$export$b3de0ae08da2ce64,
    dark: $89fb5c3e61d25bd4$export$ecfc1dff386a3e7a
});
var $89fb5c3e61d25bd4$export$8bf7dff220b82b4a = (0, $5Eb1o.default)({
    light: $89fb5c3e61d25bd4$export$9dc1ef0f3f48059b,
    dark: $89fb5c3e61d25bd4$export$69cb3ca10c1e330e
});
var $89fb5c3e61d25bd4$export$e13cce2a2d16a9d4 = (0, $5Eb1o.default)({
    light: $89fb5c3e61d25bd4$export$b48405b95304b5a1,
    dark: $89fb5c3e61d25bd4$export$6011520a64d9a187
});
var $89fb5c3e61d25bd4$export$a90204d1394caf30 = (0, $5Eb1o.default)({
    light: $89fb5c3e61d25bd4$export$4a7404f376229999,
    dark: $89fb5c3e61d25bd4$export$4a7404f376229999
});
var $89fb5c3e61d25bd4$export$594c5a8758200c32 = (0, $5Eb1o.default)({
    light: $89fb5c3e61d25bd4$export$c6930421db9fa514,
    dark: $89fb5c3e61d25bd4$export$c6930421db9fa514
});
var $89fb5c3e61d25bd4$export$955a2ebd2fb142ae = (0, $5Eb1o.default)({
    light: $89fb5c3e61d25bd4$export$940e1f69e873f202,
    dark: $89fb5c3e61d25bd4$export$940e1f69e873f202
});
var $89fb5c3e61d25bd4$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($89fb5c3e61d25bd4$export$8d43898f60b96a82, ")");
};

});
parcelRegister("5Eb1o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $41c93ccb60aa762e$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $gSbfj = parcelRequire("gSbfj");
// Unpack custom variants, and get correct value for the current theme
function $41c93ccb60aa762e$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $gSbfj.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $41c93ccb60aa762e$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $41c93ccb60aa762e$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $gSbfj.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("gSbfj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c48a69b19120ba7d$export$2e2bcd8739ae039; });

var $ld4Ek = parcelRequire("ld4Ek");
function $c48a69b19120ba7d$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $ld4Ek.CHANNEL) in props.theme) return props.theme[0, $ld4Ek.CHANNEL];
        else if ('mode' in props.theme && (0, $ld4Ek.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $ld4Ek.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("ld4Ek", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $f70e6b2b538c9799$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $f70e6b2b538c9799$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $f70e6b2b538c9799$export$6ba72c8346b4c57e; });

var $fIS4u = parcelRequire("fIS4u");

var $bQtpa = parcelRequire("bQtpa");
var $f70e6b2b538c9799$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $f70e6b2b538c9799$export$c93026a968943f95 = 'light';
var $f70e6b2b538c9799$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $f70e6b2b538c9799$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $f70e6b2b538c9799$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $f70e6b2b538c9799$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $f70e6b2b538c9799$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $f70e6b2b538c9799$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $f70e6b2b538c9799$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $f70e6b2b538c9799$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $bQtpa.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f70e6b2b538c9799$export$6d8204c2cb2e06b8() / 4;
    (0, $fIS4u.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $f70e6b2b538c9799$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $f70e6b2b538c9799$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $f70e6b2b538c9799$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $fIS4u.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $f70e6b2b538c9799$export$ba1d834b86d72a09 = $f70e6b2b538c9799$export$a1b3edb637fb4f35;
var $f70e6b2b538c9799$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $bQtpa.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $bQtpa.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $bQtpa.N30A), ")")
            }
        }
    };
};

});
parcelRegister("fIS4u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b724e886199568dd$export$2e2bcd8739ae039; });

var $iz2x7 = parcelRequire("iz2x7");

var $7t0tI = parcelRequire("7t0tI");
function $b724e886199568dd$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $iz2x7.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $b724e886199568dd$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("iz2x7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d83d75e9c7449979$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $d83d75e9c7449979$var$printed = {};
function $d83d75e9c7449979$export$2e2bcd8739ae039(message) {
    if ($d83d75e9c7449979$var$printed[message]) return;
    $d83d75e9c7449979$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("6X520", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $50fc27dd4d477f75$export$7692396083754928; });

var $4biTO = parcelRequire("4biTO");
// Create default global light theme
var $50fc27dd4d477f75$var$_createTheme = (0, $4biTO.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $50fc27dd4d477f75$var$Provider = $50fc27dd4d477f75$var$_createTheme.Provider, $50fc27dd4d477f75$var$Consumer = $50fc27dd4d477f75$var$_createTheme.Consumer, $50fc27dd4d477f75$export$7692396083754928 = $50fc27dd4d477f75$var$_createTheme.useTheme;
var $50fc27dd4d477f75$export$2e2bcd8739ae039 = {
    Provider: $50fc27dd4d477f75$var$Provider,
    Consumer: $50fc27dd4d477f75$var$Consumer
};

});
parcelRegister("4biTO", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $30b6d9789ebd58d9$export$25d302a5b900a763; });

var $1Mabd = parcelRequire("1Mabd");

var $1oC0p = parcelRequire("1oC0p");
var $30b6d9789ebd58d9$var$_excluded = [
    "children"
];
function $30b6d9789ebd58d9$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $1Mabd.default)(props, $30b6d9789ebd58d9$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("1Mabd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14b22bacd730a2f2$export$2e2bcd8739ae039; });

var $2tcJx = parcelRequire("2tcJx");
function $14b22bacd730a2f2$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $2tcJx.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("2tcJx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1cc82ad3d55f4354$export$2e2bcd8739ae039; });
function $1cc82ad3d55f4354$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("8SgZH", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $67608c8e587e41e2$export$4e9f1640bbe7a1a8; });
var $67608c8e587e41e2$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("60Muw", function(module, exports) {
$parcel$export(module.exports, "UserDetailsCard", function () { return $c87933a3d5d4dcdf$export$23a905c82baae3c5; });
/* user-details-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hZE0S = parcelRequire("hZE0S");
const $c87933a3d5d4dcdf$export$23a905c82baae3c5 = ({ email: email, name: name, size: size, src: src })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _4cvr1h6o _1yt41pyq _1bsbr0r7 _bfhkalr3"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hZE0S.WACAvatar), {
                name: name,
                src: src,
                size: size
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1n261q9c _ahbqu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1wybpxbi _vwz4v47k _syazu67f"
                        ]),
                        children: [
                            name,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1wybutpp _vwz4utpp _syaz1kby _o5721q9c _1reo15vq _18m915vq _1bto1l2s"
                        ]),
                        children: [
                            email,
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};
const $c87933a3d5d4dcdf$var$userDetailsContainer = null;
const $c87933a3d5d4dcdf$var$userInfoContainer = null;
const $c87933a3d5d4dcdf$var$userNameLabel = null;
const $c87933a3d5d4dcdf$var$userEmailLabel = null;

});

parcelRegister("g2SyO", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("PtGJI"),
    $eao4m("hyT2F")
]).then(()=>parcelRequire('e9zf4'));

});

parcelRegister("g9iJq", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("PtGJI"),
    $eao4m("b8kt6")
]).then(()=>parcelRequire('9oBoa'));

});


parcelRegister("b3mu7", function(module, exports) {
$parcel$export(module.exports, "LoggedOutUser", function () { return $844cc1397e00c26b$export$8339543958fe900f; });
/* loggedout-user-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $ddxTX = parcelRequire("ddxTX");

var $h3qib = parcelRequire("h3qib");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $9KOR3 = parcelRequire("9KOR3");

var $4CtXE = parcelRequire("4CtXE");
const $844cc1397e00c26b$export$8339543958fe900f = ({ onLogInClick: onLogInClick, isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig = false, setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig })=>{
    const { dropdownRefCurrentNode: dropdownRefCurrentNode } = (0, $9KOR3.useGlobalNavContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        if (createAnalyticsEvent && isUseGeneralSigninPromptConfig) createAnalyticsEvent({
            eventName: 'gwp.generalSigninPrompt.modalDisplayed',
            eventType: 'ui',
            action: 'displayed',
            actionSubject: 'modal',
            actionSubjectId: 'GeneralSigninPromptModalDisplayed'
        }).fire();
    }, [
        createAnalyticsEvent,
        isUseGeneralSigninPromptConfig
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                    appearance: "subtle",
                    name: "sign-in",
                    onClick: onLogInClick,
                    role: "link",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_d0altlke"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_ect4q6fz _1wybpxbi _syazftjs"
                                ]),
                                style: {
                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue800'))
                                },
                                children: isUseGeneralSigninPromptConfig ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...(0, $4CtXE.messages).logInAlternative
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...(0, $4CtXE.messages).logIn
                                })
                            })
                        })
                    })
                })
            }),
            !dropdownRefCurrentNode && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h3qib.GeneralSigninPrompt), {
                isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig,
                setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig
            })
        ]
    });
};
const $844cc1397e00c26b$var$rootContainer = null;
const $844cc1397e00c26b$var$triggerContainer = null;
const $844cc1397e00c26b$var$titleLabel = null;

});
parcelRegister("h3qib", function(module, exports) {
$parcel$export(module.exports, "GeneralSigninPrompt", function () { return $eba98b3a70a5130f$export$6b94dec1be0ad04b; });
/* general-signin-prompt.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $h6Fsc = parcelRequire("h6Fsc");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $2gCne = parcelRequire("2gCne");

var $63cRr = parcelRequire("63cRr");

var $l9NXI = parcelRequire("l9NXI");

var $hqvnx = parcelRequire("hqvnx");

var $68EbF = parcelRequire("68EbF");
// CSS
const $eba98b3a70a5130f$var$signinPromptDropdownMenuStyles = null;
const $eba98b3a70a5130f$var$closeIconStyles = null;
const $eba98b3a70a5130f$var$headerTextStyles = null;
const $eba98b3a70a5130f$var$headerStyles = null;
const $eba98b3a70a5130f$var$subHeaderStyles = null;
const $eba98b3a70a5130f$var$closeIconWrapperStyles = null;
const $eba98b3a70a5130f$var$darkGrayTextCss = null;
const $eba98b3a70a5130f$var$accountCreationContainerStyles = null;
const $eba98b3a70a5130f$export$39e854c35d636741 = ({ setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleCloseButton = ()=>{
        const consecutiveXClicksItem = 'general_signin_prompt_x_clicks';
        const lastVisitTimestampItem = 'general_signin_prompt_last_visit_timestamp';
        const currentXClicks = Number((0, $2gCne.getLocalStorage)(consecutiveXClicksItem, true) || '0');
        (0, $2gCne.setLocalStorage)(consecutiveXClicksItem, String(currentXClicks + 1));
        (0, $2gCne.setLocalStorage)(lastVisitTimestampItem, new Date().toISOString());
        createAnalyticsEvent({
            eventName: 'gwp.generalSigninPrompt.dismissed',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'GeneralSigninPromptCloseIcon'
        }).fire();
        setIsUseGeneralSigninPromptConfig?.(false);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_zxndglyw _1e0c1ule _kqswstnw _152toahv _1yt41ejb _2rkou2gc _bfhk1afi _1pfhxy5q _1bsb1edt _p12f8ora _16qs130s _1pbyzyxb _y44v1p04 _wjvazwfg",
            "general-signin-prompt-dropdown-menu"
        ]),
        "data-testid": "genearl-signin-prompt-dropdown-menu",
        "aria-label": "global-nav-signin-prompt-dropdown-menu",
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _rjxp1ejb _152t1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        handleCloseButton();
                    },
                    "aria-label": "general-signin-prompt-modal-dismissal-button",
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _4t3i1ejb _11q7glyw _19itglyw _1e0c1txw _1aax1b4t _2lx21bp4 _kqswh2mm _d0altlke _1ohh1t9f _1ilwidpf _1bsb1ejb"
                    ]),
                    style: {
                        "--_8vca0i": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark0'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
                        label: 'close',
                        size: 'medium'
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f12hx _1i4q1hna _y3gn1e5h _1e0c1ule _syaz1pfd"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h5", {
                        className: (0, $2jatx.default)([
                            "_ect4z4z1 _1wybv47k _k48p1fw0 _vwz41f4h _18s8ze3t"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "genearl-signin-prompt.header.title",
                            defaultMessage: "You're logged out."
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syazazsu _ect48q0o _1wyb7vkz _vwz41tcg _zg8l4jg8 _k48p1nn1"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "genearl-signin-prompt.header.subtext",
                            defaultMessage: 'Log in to your account for a more personalized experience.'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1q51pxbi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63cRr.AccountSignin), {
                    Input: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_frvh1p0d _ie4m1cjc"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l9NXI.Input), {
                            labelText: intl.formatMessage({
                                id: 'genearl-signin-prompt.email-label',
                                defaultMessage: 'Email'
                            }),
                            helpText: ''
                        })
                    }),
                    Login: null,
                    Social: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "general-signin-prompt-social-wrapper",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hqvnx.Social), {
                            providers: {
                                google: 'Google',
                                microsoft: 'Microsoft'
                            }
                        })
                    }),
                    Submit: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "general-signin-prompt-submit-wrapper",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $68EbF.Submit), {
                            buttonText: intl.formatMessage({
                                id: 'genearl-signin-prompt.login-button',
                                defaultMessage: 'Log in'
                            })
                        })
                    })
                })
            })
        ]
    });
};
const $eba98b3a70a5130f$export$6b94dec1be0ad04b = ({ isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig = false, setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig })=>{
    return isUseGeneralSigninPromptConfig && /*#__PURE__*/ (0, $7VQPk.jsx)($eba98b3a70a5130f$export$39e854c35d636741, {
        setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig
    });
};
$eba98b3a70a5130f$export$6b94dec1be0ad04b.displayName = 'GeneralSigninPrompt';
var $eba98b3a70a5130f$export$2e2bcd8739ae039 = $eba98b3a70a5130f$export$6b94dec1be0ad04b;

});
parcelRegister("h6Fsc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::85cb292de644104b34b7dd23f5bdf435>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743270e9494495f$var$_react = $c743270e9494495f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c743270e9494495f$var$_baseNew = $c743270e9494495f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c743270e9494495f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743270e9494495f$var$CrossIcon = (props)=>/*#__PURE__*/ $c743270e9494495f$var$_react.default.createElement($c743270e9494495f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$c743270e9494495f$var$CrossIcon.displayName = 'CrossIcon';
var $c743270e9494495f$var$_default = module.exports.default = $c743270e9494495f$var$CrossIcon;

});

parcelRegister("63cRr", function(module, exports) {
$parcel$export(module.exports, "AccountSignin", function () { return $5b3609586075605e$export$a388ecbea8ea27a1; });

var $7VQPk = parcelRequire("7VQPk");

var $lX14w = parcelRequire("lX14w");

var $4qMMD = parcelRequire("4qMMD");

var $a8iOK = parcelRequire("a8iOK");

var $j8Zhp = parcelRequire("j8Zhp");

var $l9NXI = parcelRequire("l9NXI");

var $1gwYE = parcelRequire("1gwYE");

var $hqvnx = parcelRequire("hqvnx");

var $68EbF = parcelRequire("68EbF");
const $5b3609586075605e$var$AccountSigninContent = ({ Submit: Submit = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $68EbF.Submit), {}), Input: Input = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l9NXI.Input), {}), Social: Social = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hqvnx.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4qMMD.Separator), {}), Error: Error = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j8Zhp.Error), {}), Login: Login = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1gwYE.Login), {}) })=>{
    const { onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA } = (0, $a8iOK.useAccountSigninContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                onSubmit: onSubmitWithReCAPTCHA,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                        ...formProps,
                        autoComplete: "off",
                        "data-testid": "account-signin",
                        children: [
                            Input,
                            Submit
                        ]
                    })
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};
const $5b3609586075605e$export$a388ecbea8ea27a1 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a8iOK.AccountSigninContextProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($5b3609586075605e$var$AccountSigninContent, {
            ...props
        })
    });
};

});
parcelRegister("4qMMD", function(module, exports) {
$parcel$export(module.exports, "Separator", function () { return $6444b75ef76d6edd$export$1ff3c3f08ae963c0; });
/* separator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iTHVN = parcelRequire("iTHVN");
const $6444b75ef76d6edd$export$1ff3c3f08ae963c0 = ({ separatorText: separatorText })=>{
    const intl = (0, $8e22h.default)();
    if (separatorText === undefined) separatorText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.or',
        defaultMessage: 'Or continue with'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _1e0c1txw _vwz4400g _19pkviql _2hwxidpf _otyrviql _18u0idpf _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1h6dl3em _1dqonqa1 _189esoed _1e0c1ule _16jlkb7n _4t3iidpf _19pkidpf _2hwx1j6v _otyridpf _18u01j6v _tzy41acx"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazl3em"
                ]),
                children: separatorText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1h6dl3em _1dqonqa1 _189esoed _1e0c1ule _16jlkb7n _4t3iidpf _19pkidpf _2hwx1j6v _otyridpf _18u01j6v _tzy41acx"
                ])
            })
        ]
    });
};
const $6444b75ef76d6edd$var$separatorBorder = null;
const $6444b75ef76d6edd$var$separatorCss = null;
const $6444b75ef76d6edd$var$separatorTextCss = null;

});
parcelRegister("iTHVN", function(module, exports) {
$parcel$export(module.exports, "fontSize", function () { return $3535e8e54114512b$export$85e3c3ca0c6fb93; });
const $3535e8e54114512b$export$85e3c3ca0c6fb93 = {
    xs: '0.75rem',
    // 12px
    sm: '0.875rem',
    // 14px
    md: '1rem',
    // 16px
    lg: '1.25rem',
    // 20px
    xl: '2.25rem' // 36px
};

});


parcelRegister("a8iOK", function(module, exports) {
$parcel$export(module.exports, "useAccountSigninContext", function () { return $bf9c931dc39b802c$export$2c59dd2afee36b71; });
$parcel$export(module.exports, "AccountSigninContextProvider", function () { return $bf9c931dc39b802c$export$8e536810811eea25; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eLTTO = parcelRequire("eLTTO");

var $eY3N6 = parcelRequire("eY3N6");
parcelRequire("kNE9Z");
var $eRzlV = parcelRequire("eRzlV");

var $fFzjl = parcelRequire("fFzjl");

var $6aHao = parcelRequire("6aHao");

var $427NR = parcelRequire("427NR");

var $gPKCY = parcelRequire("gPKCY");

var $5Ntyw = parcelRequire("5Ntyw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $2gCne = parcelRequire("2gCne");

var $1ka2O = parcelRequire("1ka2O");
function $bf9c931dc39b802c$var$trackFormSubmit(createAnalyticsEvent) {
    createAnalyticsEvent({
        eventName: 'gwp.formCloudSignIn.submitWithCaptcha',
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'linkButton',
        actionSubjectId: 'GenearlSigninPromptSubmitWithCaptcha'
    }).fire();
}
function $bf9c931dc39b802c$var$trackContinueWithSocialSignin(createAnalyticsEvent, type) {
    createAnalyticsEvent({
        eventName: 'gwp.formCloudSignIn.socialButtonClick',
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'linkButton',
        actionSubjectId: 'GenearlSigninPromptSocialButtonClick',
        attributes: {
            socialProvider: type
        }
    }).fire();
}
const $bf9c931dc39b802c$export$b9c683feff8b5c21 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $bf9c931dc39b802c$export$2c59dd2afee36b71 = ()=>{
    const context = (0, $1oC0p.useContext)($bf9c931dc39b802c$export$b9c683feff8b5c21);
    if (!context) throw new Error('useAccountSigninContext must be used within an AccountSigninContextProvider');
    return context;
};
const $bf9c931dc39b802c$export$8e536810811eea25 = ({ children: children })=>{
    const location = (0, $1ka2O.useLocation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [isEmailValid, setIsEmailValid] = (0, $1oC0p.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [formError, setFormError] = (0, $1oC0p.useState)(false);
    const [, setEmail] = (0, $1oC0p.useState)('');
    const [typeAheadEmail, setTypeAheadEmail] = (0, $1oC0p.useState)('');
    const [onSubmitProps, setOnSubmitProps] = (0, $1oC0p.useState)(undefined);
    const [recaptchaFailedToLoad, setRecaptchaFailedToLoad] = (0, $1oC0p.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $1oC0p.useState)(60);
    const signupClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eLTTO.useGoogleReCaptcha)();
    const onSubmitWithReCAPTCHA = (0, $1oC0p.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            createAnalyticsEvent({
                eventName: 'gwp.formCloudSignIn.submitFailureInvalidEmail',
                eventType: 'ui',
                action: 'submitted',
                actionSubject: 'modal',
                actionSubjectId: 'GeneralSigninPromptSubmitFailureInvalidEmail',
                attributes: {
                    event: 'submitFailed'
                }
            }).fire();
            return;
        }
        setEmail(email);
        setOnSubmitProps({
            email: email
        });
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setFormError(true);
            setIsSubmitting(false);
            setRecaptchaFailedToLoad(true);
            return;
        }
        setRecaptchaFailedToLoad(false);
        const gRecaptchaResponse = await (0, $427NR.getRecaptcha)(email, executeRecaptcha);
        (0, $gPKCY.ufoEventAccountSignin).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse ?? 'none',
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: 'AccountSigninContextProvider'
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            createAnalyticsEvent({
                eventName: 'gwp.formCloudSignIn.submitFailureRecaptcha',
                eventType: 'ui',
                action: 'submitted',
                actionSubject: 'modal',
                actionSubjectId: 'GeneralSigninPromptSubmitFailureRecaptcha',
                attributes: {
                    event: 'submitFailed'
                }
            }).fire();
            const invalidRecaptchaError = new Error('Missing reCAPTCHA token');
            (0, $gPKCY.ufoEventAccountSignin).failure({
                customData: {
                    reactComponent: 'AccountSigninContextProvider'
                },
                error: invalidRecaptchaError
            });
            throw invalidRecaptchaError;
        }
        $bf9c931dc39b802c$var$trackFormSubmit(createAnalyticsEvent);
        const existingUserRedirectUrl = await (0, $6aHao.getMethodsAvailableRedirection)({
            email: email,
            application: 'wac',
            signupClient: signupClient,
            createAnalyticsEvent: createAnalyticsEvent,
            successRedirect: location.href
        }).catch((error)=>{
            setFormError(true);
            setIsSubmitting(false);
            createAnalyticsEvent({
                eventName: 'gwp.formCloudSignIn.getMethodsAvailableRedirection.submitFailure',
                eventType: 'ui',
                action: 'submitted',
                actionSubject: 'modal',
                actionSubjectId: 'getMethodsAvailableRedirectionFormSubmitFailed',
                attributes: {
                    event: 'submitFailed'
                }
            }).fire();
            throw new Error(error);
        });
        if (existingUserRedirectUrl) window.location.assign(existingUserRedirectUrl.replace('/initiate/password', ''));
        else {
            const isWacIcLoginEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacIcLogin);
            const applicationParam = isWacIcLoginEnabled ? '&application=wac--ic' : '';
            const finalLoginUrl = `${(0, $eRzlV.getIdentityBaseUrl)()}/login?login_hint=${email}&prompt=none&continue=${location.href}${applicationParam}`;
            window.location.assign(finalLoginUrl);
        }
        return;
    }, [
        createAnalyticsEvent,
        executeRecaptcha,
        isEmailValid,
        recaptchaRetryTimeRemainingSecond,
        signupClient
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) (0, $gPKCY.ufoEventAccountSignin).failure({
            customData: {
                reactComponent: 'AccountSigninContextProvider',
                recaptchaRetryTimeRemainingSecond: 0
            },
            error: new Error('Recaptcha retry failed')
        });
        if (onSubmitProps && recaptchaFailedToLoad && executeRecaptcha) onSubmitWithReCAPTCHA(onSubmitProps).then(()=>{
            (0, $gPKCY.ufoEventAccountSignin).success({
                customData: {
                    reactComponent: 'AccountSigninContextProvider',
                    analyticsEvent: 'succeeded',
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            setFormError(true);
            (0, $gPKCY.ufoEventAccountSignin).failure({
                customData: {
                    reactComponent: 'AccountSigninContextProvider',
                    analyticsEvent: 'errored',
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        }).finally(()=>{
            setIsSubmitting(false);
        });
    }, [
        executeRecaptcha,
        recaptchaFailedToLoad,
        onSubmitProps,
        onSubmitWithReCAPTCHA,
        recaptchaRetryTimeRemainingSecond
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    const resetClickCountLogic = (0, $1oC0p.useCallback)(()=>{
        // Click action on Signin Prompt CTA resets click count logic
        (0, $2gCne.setLocalStorage)('general_signin_prompt_x_clicks', '0');
        (0, $2gCne.setLocalStorage)('general_signin_prompt_last_visit_timestamp', new Date().toISOString());
    }, []);
    const onClickSocialButton = (0, $1oC0p.useCallback)((provider)=>{
        $bf9c931dc39b802c$var$trackContinueWithSocialSignin(createAnalyticsEvent, provider);
        const socialRedirectUrl = (0, $fFzjl.getSocialButtonUrl)({
            redirectTo: location.href,
            identityCobranding: 'wac',
            provider: provider
        });
        resetClickCountLogic();
        window.location.assign(socialRedirectUrl);
    }, [
        createAnalyticsEvent,
        location.href,
        resetClickCountLogic
    ]);
    const onClickSubmitButton = (0, $1oC0p.useCallback)(()=>{
        resetClickCountLogic();
        return createAnalyticsEvent({
            eventName: 'gwp.accountSignin.onclickSubmit',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'GenearlSigninPromptCtaSubmit'
        }).fire();
    }, [
        createAnalyticsEvent,
        resetClickCountLogic
    ]);
    const contextValue = (0, $1oC0p.useMemo)(()=>({
            formError: formError,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA,
            redirectTo: location.href,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail
        }), [
        formError,
        isReadyForInvalid,
        isSubmitting,
        onClickSocialButton,
        onClickSubmitButton,
        onSubmitWithReCAPTCHA,
        location.href,
        typeAheadEmail
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($bf9c931dc39b802c$export$b9c683feff8b5c21.Provider, {
        value: contextValue,
        children: children
    });
};

});
parcelRegister("fFzjl", function(module, exports) {
$parcel$export(module.exports, "getSocialButtonUrl", function () { return $ea8026c6edc6843d$export$2cf6d5d739970e9; });

var $aHTfr = parcelRequire("aHTfr");

var $eRzlV = parcelRequire("eRzlV");
function $ea8026c6edc6843d$export$bac9579d79d90f3d(provider) {
    const metadataId = `wac-signup-${provider}`;
    const originTracingOptions = {
        product: metadataId
    };
    if ((0, $eRzlV.isProduction)()) originTracingOptions.id = 'static-uuid-for-testing';
    const loginOrigin = new (0, $aHTfr.default)({
        ...originTracingOptions
    });
    return loginOrigin.encode();
}
function $ea8026c6edc6843d$export$2cf6d5d739970e9({ redirectTo: redirectTo, identityCobranding: identityCobranding, provider: provider }) {
    const continueUrl = new URL(redirectTo);
    continueUrl.searchParams.append('social-signup-login', 'true');
    const params = new URLSearchParams({
        application: identityCobranding,
        continue: continueUrl.href,
        prompt: 'select_account',
        atlOrigin: encodeURIComponent($ea8026c6edc6843d$export$bac9579d79d90f3d(provider))
    });
    return `${(0, $eRzlV.getIdentityBaseUrl)()}/login/initiate/${provider}?${params}`;
}

});

parcelRegister("6aHao", function(module, exports) {
$parcel$export(module.exports, "getMethodsAvailableRedirection", function () { return $d17369f6f41e3215$export$4263a11b8e392197; });

var $buVH1 = parcelRequire("buVH1");

var $9tcM4 = parcelRequire("9tcM4");
async function $d17369f6f41e3215$export$4263a11b8e392197({ email: email, application: application, signupClient: signupClient, createAnalyticsEvent: createAnalyticsEvent, successRedirect: successRedirect }) {
    const response = await signupClient.checkAuthenticationMethodsAvailable({
        email: email,
        application: application,
        successRedirect: successRedirect
    });
    const authenticationMethod = $d17369f6f41e3215$var$getAuthenticationMethod(response);
    if (!!authenticationMethod) (0, $buVH1.trackExistingUserRedirectTo)(createAnalyticsEvent, authenticationMethod.type);
    return authenticationMethod?.redirect_to;
}
const $d17369f6f41e3215$var$getAuthenticationMethod = (authenticationMethods)=>{
    const userExists = !!authenticationMethods?.methods && authenticationMethods.methods?.length !== 0;
    if (!userExists) return undefined;
    else {
        const samlMethod = authenticationMethods.methods.find((method)=>{
            return method.type === (0, $9tcM4.AuthenticationMethodsType).SAML || method.type === (0, $9tcM4.AuthenticationMethodsType).GOOGLE;
        });
        const passwordMethod = authenticationMethods.methods.find((method)=>{
            return method.type === (0, $9tcM4.AuthenticationMethodsType).PASSWORD;
        });
        if (userExists && passwordMethod) return passwordMethod;
        if (!passwordMethod && samlMethod) return samlMethod;
        else return undefined;
    }
};

});
parcelRegister("buVH1", function(module, exports) {
$parcel$export(module.exports, "trackContinueWithSocialSignups", function () { return $94240686cc30dd83$export$4428eebd17d6479c; });
$parcel$export(module.exports, "trackDataFoundationsAccountCreationComponent", function () { return $94240686cc30dd83$export$62620cf1a802febb; });
$parcel$export(module.exports, "trackFormSubmit", function () { return $94240686cc30dd83$export$d33a5bb646105e4c; });
$parcel$export(module.exports, "trackRecaptchaFailure", function () { return $94240686cc30dd83$export$e21bb4008f4ff913; });
$parcel$export(module.exports, "trackInvalidEmail", function () { return $94240686cc30dd83$export$27e93220908fe284; });
$parcel$export(module.exports, "trackSubmitSuccess", function () { return $94240686cc30dd83$export$3c51ee8e4e3bf212; });
$parcel$export(module.exports, "trackSubmitButtonClick", function () { return $94240686cc30dd83$export$13c344f9722da1bb; });
$parcel$export(module.exports, "trackSignFormLoad", function () { return $94240686cc30dd83$export$3e6eac21d1f30b49; });
$parcel$export(module.exports, "trackTimeToFormReady", function () { return $94240686cc30dd83$export$2658f7c96dfef24d; });
$parcel$export(module.exports, "trackExistingUserRedirectTo", function () { return $94240686cc30dd83$export$1b2e3c8e72aee447; });
$parcel$export(module.exports, "trackSiteActivationViewed", function () { return $94240686cc30dd83$export$c6f968f2362d473c; });
$parcel$export(module.exports, "trackSignupStarted", function () { return $94240686cc30dd83$export$7dc03aba83ab29ea; });
$parcel$export(module.exports, "trackSitePickerSubmit", function () { return $94240686cc30dd83$export$368d4956b510ce82; });
$parcel$export(module.exports, "trackSiteNameChangedFromRecommendedSiteName", function () { return $94240686cc30dd83$export$c4a4a9cfd7e6466d; });
$parcel$export(module.exports, "trackCrossFlowActivationPlanFetched", function () { return $94240686cc30dd83$export$2b13b15eb4720c82; });
$parcel$export(module.exports, "trackCrossFlowActivationPlanFailed", function () { return $94240686cc30dd83$export$90856470efa7c02d; });

var $l7lLR = parcelRequire("l7lLR");
const $94240686cc30dd83$export$7d74883aad292166 = {
    PAGE_LOADED: 'check_email_page_loaded',
    OPEN_GMAIL_CLICKED: 'check_email_page_open_gmail_clicked',
    OPEN_OUTLOOK_CLICKED: 'check_email_page_open_outlook_clicked',
    CONTACT_LINK_CLICKED: 'check_email_page_contact_link_clicked',
    RESEND_EMAIL_CLICKED: 'check_email_page_resend_email_clicked',
    RESEND_EMAIL_API_SUCCESS: 'check_email_page_resend_email_api_success',
    RESEND_EMAIL_API_FAILURE: 'check_email_page_resend_email_api_failure'
};
function $94240686cc30dd83$export$4428eebd17d6479c(createAnalyticsEvent, type, productKey, edition) {
    const ajcbGrsData = (0, $l7lLR.getGrsDataFromLocalStorage)(productKey);
    const recoSessionId = ajcbGrsData?.recoSessionId;
    const recoEntityId = ajcbGrsData?.recoEntityId;
    createAnalyticsEvent({
        event: 'clicked',
        eventComponent: 'button',
        eventName: `wac-signup-${type}`
    }).fire('signup');
    // DATA FOUNDATIONS TRACKING
    createAnalyticsEvent({
        eventType: 'track',
        action: 'started',
        actionSubject: 'accountCreation',
        containerId: 'bxp-ui-signup',
        actionSubjectId: 'social',
        attributes: {
            socialProvider: type,
            productKey: productKey,
            edition: edition,
            recoSessionId: recoSessionId,
            recoEntityId: recoEntityId
        }
    }).fire();
}
function $94240686cc30dd83$export$62620cf1a802febb(createAnalyticsEvent, payload) {
    // DATA FOUNDATIONS TRACKING
    const { actionSubjectId: actionSubjectId, productKey: productKey, edition: edition } = payload;
    createAnalyticsEvent({
        eventType: 'ui',
        action: 'viewed',
        actionSubject: 'accountCreationComponent',
        containerId: 'bxp-ui-signup',
        actionSubjectId: actionSubjectId,
        attributes: {
            productKey: productKey,
            edition: edition
        }
    }).fire();
}
function $94240686cc30dd83$export$d33a5bb646105e4c(createAnalyticsEvent, productKey, edition) {
    const ajcbGrsData = (0, $l7lLR.getGrsDataFromLocalStorage)(productKey);
    const recoSessionId = ajcbGrsData?.recoSessionId;
    const recoEntityId = ajcbGrsData?.recoEntityId;
    createAnalyticsEvent({
        event: 'clicked',
        eventComponent: 'button',
        eventName: 'bxp.formCloudSignup.submitWithCaptcha'
    }).fire('signup');
    createAnalyticsEvent({
        data: {
            type: 'N2N'
        },
        event: 'clicked',
        eventComponent: 'button',
        eventName: 'bxp.formCloudSignup.formSubmit'
    }).fire('signup');
    // DATA FOUNDATIONS TRACKING
    createAnalyticsEvent({
        eventType: 'track',
        action: 'started',
        actionSubject: 'accountCreation',
        containerId: 'bxp-ui-form',
        actionSubjectId: 'email',
        attributes: {
            productKey: productKey,
            edition: edition,
            recoSessionId: recoSessionId,
            recoEntityId: recoEntityId
        }
    }).fire();
}
function $94240686cc30dd83$export$e21bb4008f4ff913(createAnalyticsEvent, eventColumn) {
    createAnalyticsEvent({
        data: {
            event: 'submitFailed',
            uuid: 'reactSignUpForm'
        },
        event: 'clicked',
        eventComponent: 'button',
        eventColumn: eventColumn,
        eventName: 'bxp.formCloudSignup.submitFailureRecaptcha'
    }).fire('signup');
}
function $94240686cc30dd83$export$27e93220908fe284(createAnalyticsEvent) {
    createAnalyticsEvent({
        data: {
            event: 'submitFailed',
            uuid: 'reactSignUpForm'
        },
        event: 'clicked',
        eventComponent: 'button',
        eventName: 'bxp.formCloudSignup.submitFailureInvalidEmail'
    }).fire('signup');
}
function $94240686cc30dd83$export$3c51ee8e4e3bf212(createAnalyticsEvent) {
    createAnalyticsEvent({
        data: {
            event: 'submitSucceeded',
            uuid: 'reactSignUpForm'
        },
        event: 'clicked',
        eventComponent: 'button',
        eventName: 'reactSignUpFormSubmitSucceeded'
    }).fire('signup');
}
function $94240686cc30dd83$export$1d7461d370f0b7ae(createAnalyticsEvent) {
    createAnalyticsEvent({
        data: {
            event: 'submitFailed',
            uuid: 'reactSignUpForm'
        },
        event: 'clicked',
        eventComponent: 'button',
        eventName: 'reactSignUpFormSubmitFailed'
    }).fire('signup');
}
function $94240686cc30dd83$export$13c344f9722da1bb(createAnalyticsEvent) {
    createAnalyticsEvent({
        event: 'clicked',
        eventComponent: 'button',
        eventName: 'wac-try-signup'
    }).fire('signup');
}
function $94240686cc30dd83$export$3e6eac21d1f30b49(createAnalyticsEvent) {
    createAnalyticsEvent({
        event: 'loaded',
        eventColumn: 'signUp',
        eventComponent: 'signUp',
        eventName: 'signUpLoaded',
        eventType: 'ui'
    }).fire('signup');
}
function $94240686cc30dd83$export$2658f7c96dfef24d(createAnalyticsEvent, performanceStartTime) {
    createAnalyticsEvent({
        eventName: 'bxp.formCloudSignup.timeToFormReady',
        performanceDuration: performance.now() - performanceStartTime,
        isLoggedIn: false
    }).fire('signup');
}
function $94240686cc30dd83$export$1b2e3c8e72aee447(createAnalyticsEvent, type) {
    createAnalyticsEvent({
        eventName: 'reactSignUpFormSubmitExistingUserRedirect',
        eventComponent: 'button',
        event: 'clicked',
        data: {
            event: `submitRedirectTo${type}`,
            uuid: 'reactSignUpForm'
        }
    }).fire('signup');
}
function $94240686cc30dd83$export$c6f968f2362d473c(createAnalyticsEvent, { actionSubjectId: actionSubjectId, cohort: cohort, productKey: productKey, edition: edition, userType: userType, domainType: domainType, companyType: companyType, numTxas: numTxas }) {
    // DATA FOUNDATIONS TRACKING
    createAnalyticsEvent({
        eventType: 'ui',
        action: 'viewed',
        actionSubject: 'siteActivationComponent',
        actionSubjectId: actionSubjectId,
        attributes: {
            cohort: cohort,
            productKey: productKey,
            edition: edition,
            userType: userType,
            domainType: domainType,
            companyType: companyType,
            numTxas: numTxas
        }
    }).fire();
}
function $94240686cc30dd83$export$7dc03aba83ab29ea(createAnalyticsEvent, signupId, productKey, edition, isN2N, domainType) {
    const ajcbGrsData = (0, $l7lLR.getGrsDataFromLocalStorage)(productKey);
    const recoSessionId = ajcbGrsData?.recoSessionId;
    const recoEntityId = ajcbGrsData?.recoEntityId;
    // DATA FOUNDATIONS TRACKING
    createAnalyticsEvent({
        eventType: 'track',
        action: 'started',
        actionSubject: 'signUp',
        containerId: 'bxp-ui-form',
        attributes: {
            signupIdGenerated: signupId,
            productKey: productKey,
            edition: edition,
            isN2N: isN2N,
            domainType: domainType,
            recoSessionId: recoSessionId,
            recoEntityId: recoEntityId
        }
    }).fire();
}
function $94240686cc30dd83$export$1b422383e527079d(createAnalyticsEvent) {
    createAnalyticsEvent({
        eventName: 'bxp.formCloudSignup.navigatedToCheckEmail'
    }).fire('signup');
}
function $94240686cc30dd83$export$f2abbb0771548615(createAnalyticsEvent) {
    createAnalyticsEvent({
        event: 'clicked',
        eventComponent: 'button',
        eventName: 'wac-try-signup'
    }).fire('signup');
}
function $94240686cc30dd83$export$2d9d642f73466f45(createAnalyticsEvent) {
    createAnalyticsEvent({
        event: 'clicked',
        eventComponent: 'button',
        eventName: 'wac-signup-existing-user-signin'
    }).fire('signup');
}
function $94240686cc30dd83$export$8b3bf199b2b24d90(createAnalyticsEvent) {
    createAnalyticsEvent({
        eventName: 'reactSignUpFormSubmitButtonClicked',
        eventComponent: 'button',
        event: 'clicked'
    }).fire('signup');
}
function $94240686cc30dd83$export$368d4956b510ce82({ createAnalyticsEvent: createAnalyticsEvent, ...rest }) {
    createAnalyticsEvent({
        eventName: 'bxp.formCloudSignup.N2ESubmit',
        event: 'clicked',
        eventComponent: 'button',
        ...rest
    }).fire('signup');
}
function $94240686cc30dd83$export$c4a4a9cfd7e6466d(createAnalyticsEvent, siteName, recommendedSiteName) {
    createAnalyticsEvent({
        data: {
            siteName: siteName,
            recommendedSiteName: recommendedSiteName
        },
        eventName: 'reactSignUpFormSubmitButtonClicked',
        eventComponent: 'button',
        event: 'clicked'
    }).fire('signup');
}
function $94240686cc30dd83$export$5af14efd12a72b0b(createAnalyticsEvent) {
    createAnalyticsEvent({
        event: 'loaded',
        eventName: $94240686cc30dd83$export$7d74883aad292166.PAGE_LOADED,
        eventType: 'ui',
        eventComponent: 'signUp',
        eventColumn: 'signUp'
    }).fire('signup');
}
const $94240686cc30dd83$export$a2d1e1f811dcdfac = (createAnalyticsEvent, type)=>{
    let eventName = '';
    switch(type){
        case 'gmail':
            eventName = $94240686cc30dd83$export$7d74883aad292166.OPEN_GMAIL_CLICKED;
            break;
        case 'outlook':
            eventName = $94240686cc30dd83$export$7d74883aad292166.OPEN_OUTLOOK_CLICKED;
            break;
    }
    createAnalyticsEvent({
        event: 'clicked',
        eventComponent: 'button',
        eventName: eventName
    }).fire('signup');
};
function $94240686cc30dd83$export$b31e32f99dfd3536(createAnalyticsEvent) {
    createAnalyticsEvent({
        event: 'clicked',
        eventComponent: 'button',
        eventName: $94240686cc30dd83$export$7d74883aad292166.RESEND_EMAIL_CLICKED
    }).fire('signup');
}
const $94240686cc30dd83$export$b042eb9d0e47e73b = (createAnalyticsEvent)=>{
    createAnalyticsEvent({
        eventName: $94240686cc30dd83$export$7d74883aad292166.RESEND_EMAIL_API_SUCCESS
    }).fire('signup');
};
const $94240686cc30dd83$export$2c5bece45899a515 = (createAnalyticsEvent)=>{
    createAnalyticsEvent({
        eventName: $94240686cc30dd83$export$7d74883aad292166.RESEND_EMAIL_API_FAILURE
    }).fire('signup');
};
const $94240686cc30dd83$export$c087584f68c97d7b = (createAnalyticsEvent)=>{
    createAnalyticsEvent({
        event: 'clicked',
        eventComponent: 'button',
        eventName: $94240686cc30dd83$export$7d74883aad292166.CONTACT_LINK_CLICKED
    }).fire('signup');
};
const $94240686cc30dd83$export$2b13b15eb4720c82 = ({ createAnalyticsEvent: createAnalyticsEvent, cloudId: cloudId, productKey: productKey })=>{
    createAnalyticsEvent({
        actionSubject: 'crossFlowActivationPlan',
        action: 'fetched',
        attributes: {
            cloudId: cloudId,
            productKey: productKey
        },
        eventType: 'operational'
    }).fire();
};
const $94240686cc30dd83$export$90856470efa7c02d = ({ createAnalyticsEvent: createAnalyticsEvent, cloudId: cloudId, productKey: productKey, error: error })=>{
    createAnalyticsEvent({
        actionSubject: 'crossFlowActivationPlan',
        action: 'failed',
        attributes: {
            cloudId: cloudId,
            productKey: productKey,
            error: error
        },
        eventType: 'operational'
    }).fire();
};

});
parcelRegister("l7lLR", function(module, exports) {
$parcel$export(module.exports, "JIRA_FEATURES_ASSET_CONTROL", function () { return $67ece75223da0660$export$c6c80df38fdd97e2; });
$parcel$export(module.exports, "CONFLUENCE_FEATURES_ASSET_CONTROL", function () { return $67ece75223da0660$export$cf870f7c67df5499; });
$parcel$export(module.exports, "BANDITS_PRODUCT", function () { return $67ece75223da0660$export$991535786f6b9533; });
$parcel$export(module.exports, "isConfluenceSubAnchorAssetControl", function () { return $67ece75223da0660$export$73ecc59895754336; });
$parcel$export(module.exports, "BANDITS_USE_CASE", function () { return $67ece75223da0660$export$eebd7b1f45feba3c; });
$parcel$export(module.exports, "nullBanditsContent", function () { return $67ece75223da0660$export$33a5d89cd13c214e; });
$parcel$export(module.exports, "getGrsAndContentfulContent", function () { return $67ece75223da0660$export$1f77d6e006a81792; });
$parcel$export(module.exports, "setGrsDataToLocalStorage", function () { return $67ece75223da0660$export$931b6efd587bc3e3; });
$parcel$export(module.exports, "getGrsDataFromLocalStorage", function () { return $67ece75223da0660$export$4e5182d7e2a1114a; });

var $lr38U = parcelRequire("lr38U");

var $fcO7r = parcelRequire("fcO7r");

var $2gCne = parcelRequire("2gCne");
const $67ece75223da0660$export$c6c80df38fdd97e2 = '7yKtyC5Ec3V0aQXKE50Qbq';
const $67ece75223da0660$export$cf870f7c67df5499 = '5WpVwJ5Ki0W7djUXQMcT4H';
const $67ece75223da0660$var$GRS_LOCAL_STORAGE_KEY = 'ajcbGrsData';
const $67ece75223da0660$export$458cb8a0fc07c720 = 'none';
const $67ece75223da0660$export$991535786f6b9533 = {
    JIRA: 'jira',
    CONFLUENCE: 'confluence'
};
const $67ece75223da0660$export$f6245c2b5423955a = [
    'JzUk3oQfopbEmhR8ONXP8',
    '29N6b3o6vLuo2S24XPBGnP',
    '5ZftPkmfc27ibbzmPzSkPE',
    '1wxWMGtRGQZfFJ3gqtdrSA',
    '5SzCidnsDeHt2bAV0X9izm',
    '6kxU3osFAP8V6dFGau4aW3',
    '5kCs5NZLiEmhTIAx3JpFXw',
    '7vvOZr5lpHNa6aR1PTdbBl'
];
const $67ece75223da0660$export$513b31276b5c8e7b = [
    '4TFYI2PTQPXpV3HJCmZux6',
    '5SLIVmANacuG4y3kTFzrbD',
    '5kqxmW3jxAt0bGim0IjrY9',
    '1OWBBaXF71fNyZ4ofE6IiM',
    '1YEianjrFDwfKTOnMqcYMe',
    '12YX7o5r4iUAoAIuiAPVjX',
    '18MP6JZJcFJTcftdj7bYYX',
    '5chJUEmBtkOFrtig0hYYjt'
];
const $67ece75223da0660$var$DEFAULT_CONF_BRANDED_SUB_ANCHOR = 'default (catch all)';
const $67ece75223da0660$var$normalizeSubAnchor = (subAnchor = '')=>subAnchor.trim().toLowerCase();
const $67ece75223da0660$var$CONF_BRANDED_SUB_ANCHORS = [
    'core terms',
    'official site',
    'confluence online',
    'confluence as a solution',
    'confluence wiki',
    'confluence help',
    'confluence reviews',
    'confluence pricing',
    'confluence os',
    'get confluence',
    'confluence for personal use',
    'confluence alternatives',
    'create an account',
    'signup for confluence for free',
    'start a confluence trial',
    'collaboration software',
    'documentation software',
    'spreadsheet',
    'project tracking',
    'how to use confluence',
    'what is confluence',
    'confluence cloud',
    'confluence license',
    'confluence connections',
    'confluence features',
    'whiteboard features',
    'knowledge base',
    'business plan template',
    'confluence program',
    'download confluence',
    'install confluence',
    'login to confluence',
    'confluence server',
    'confluence demo',
    'confluence for design teams',
    'confluence for legal teams',
    'confluence for customer service teams',
    'website creation',
    $67ece75223da0660$var$DEFAULT_CONF_BRANDED_SUB_ANCHOR
];
const $67ece75223da0660$export$13b8fe595673438f = (subAnchor = '')=>$67ece75223da0660$var$CONF_BRANDED_SUB_ANCHORS.includes($67ece75223da0660$var$normalizeSubAnchor(subAnchor));
const $67ece75223da0660$export$73ecc59895754336 = (assetId)=>{
    return $67ece75223da0660$export$f6245c2b5423955a.includes(assetId);
};
const $67ece75223da0660$export$8f2efca1468c6af9 = (headlineId)=>{
    return $67ece75223da0660$export$513b31276b5c8e7b.includes(headlineId);
};
const $67ece75223da0660$export$eebd7b1f45feba3c = {
    ANCHOR_JOURNEY: 'wacAnchorJourney',
    ANCHOR_JOURNEY_SUB_ANCHOR: 'wacAnchorJourneySubAnchor',
    ANCHOR_JOURNEY_JIRA_BPS: 'wacAnchorJourneyJiraBPS',
    ANCHOR_JOURNEY_CONFLUENCE_BRAND_DEFAULT: 'wacAjConfSubAnchor'
};
const $67ece75223da0660$export$33a5d89cd13c214e = {
    headline: null,
    asset: null,
    recoSessionId: '',
    recoEntityId: ''
};
const $67ece75223da0660$export$87f52e60582b0680 = ({ product: product, subAnchor: subAnchor = '', subproduct: subproduct = 'software', locale: locale = 'en_US', keyword: keyword, channel: channel = '', sessionId: sessionId = '', tenantId: tenantId = '', orgId: orgId = '', anonymousId: anonymousId = '', utmContent: utmContent = '', utmCampaign: utmCampaign = '', useCase: useCase = $67ece75223da0660$export$eebd7b1f45feba3c.ANCHOR_JOURNEY })=>{
    const resolvedChannel = useCase === $67ece75223da0660$export$eebd7b1f45feba3c.ANCHOR_JOURNEY ? 'paid-search-branded' : channel;
    // The check for lower case is new for only Jira BPS use case
    const resolvedSubAnchor = useCase === $67ece75223da0660$export$eebd7b1f45feba3c.ANCHOR_JOURNEY_JIRA_BPS ? subAnchor.toLowerCase() : subAnchor;
    // The check for lower case is new for only Jira BPS use case
    const resolvedKeyword = useCase === $67ece75223da0660$export$eebd7b1f45feba3c.ANCHOR_JOURNEY_JIRA_BPS ? keyword.toLowerCase() : keyword;
    const query = `
query WacAnchorJourney {
    growthRecommendations {
        recommendations(
            context:{
                tenantId: "${tenantId}",
                product: "${product}",
                subproduct: "${subproduct}",
                containers: null,
                sessionId: "${sessionId}",
                locale: "${locale}",
                orgId: "${orgId}",
                workspaceId: null,
                useCase: "${useCase}",
                anonymousId: "${anonymousId}",
                custom: {
                    keyword: "${resolvedKeyword}",
                    channel: "${resolvedChannel}",
                    subAnchor: "${resolvedSubAnchor}"
                    utmContent: "${utmContent}",
                    utmCampaign: "${utmCampaign}",
                }
            },
            first: 1,
            rerank: []
        ) {
            ... on GrowthRecRecommendations {
                data {
                    entityId,
                    reasons,
                },
                context {
                    sessionId
                }
            }
            ... on QueryError {
                identifier
                message
            }
        }
    }
}
`;
    return {
        query: query,
        variables: {}
    };
};
const $67ece75223da0660$export$ecddac92d62e846b = (data)=>{
    const recommendations = data?.growthRecommendations?.recommendations;
    const sessionId = recommendations?.context?.sessionId ?? '';
    if (!recommendations) {
        console.error('No recommendations found in GRS response.');
        return [];
    }
    if (Array.isArray(recommendations.data)) return recommendations.data.map((rec)=>{
        const { entityId: entityId, reasons: reasons } = rec;
        let textId = null;
        let assetId = null;
        if (typeof entityId === 'string') {
            const parts = entityId.split('+');
            for (const part of parts){
                if (part.startsWith('text:')) textId = part.substring(5);
                else if (part.startsWith('asset:')) assetId = part.substring(6);
            }
        }
        return {
            textId: textId,
            assetId: assetId,
            reasons: reasons,
            sessionId: sessionId
        };
    });
    console.error('Unknown response format for GRS recommendations', recommendations);
    return [];
};
const $67ece75223da0660$export$f77ef816d236f23 = (locale = 'en-US', keyword)=>{
    return {
        query: `
query keywordAnchors {
  anchorKeywordMappingCollection(
    locale: "${locale}"
    limit: 1
    where: {keywords_contains_all: ["${keyword}"]}
  ) {
    items {
      headlinesCollection {
        items {
          sys {
            id
          }
          headlineTitleExternal
          headlineSubheading
        }
      }
      assetContentsCollection {
        items {
          sys {
            id
          }
          image1 {
            url
            description
          }
          video1Mp4 {
            url
            description
          }
          video1Webm {
            url
            description
          }
          primaryText1
          secondaryText1
          image2 {
            url
            description
          }
          video2Mp4 {
            url
            description
          }
          video2Webm {
            url
            description
          }
          primaryText2
          secondaryText2
          image3 {
            url
            description
          }
          video3Mp4 {
            url
            description
          }
          video3Webm {
            url
            description
          }
          primaryText3
          secondaryText3
        }
      }
    }
  }
}
`,
        variables: {}
    };
};
const $67ece75223da0660$export$8b1f6b9fa582beb0 = (locale = 'en-US', anchorGroup)=>{
    return {
        query: `
        query ConfluenceSubAnchorContent {
  anchorKeywordMappingCollection(
    locale: "${locale}"
    limit: 1
    where: {anchorGroup_contains: "confluence subAnchor: ${anchorGroup}"}
  ) {
    items {
      anchorGroup
      headlinesCollection {
        items {
          sys {
            id
          }
          headlineTitleExternal
          headlineSubheading
        }
      }
      assetContentsCollection {
        items {
          sys {
            id
          }
          image1OrangeLogic {
            assetUrl
            alt
          }
        }
      }
    }
  }
}
        `,
        variables: {}
    };
};
const $67ece75223da0660$export$6ed46c1280a84b84 = (locale = 'en-US', keyword)=>{
    const lowerCaseKeyword = keyword.toLowerCase();
    return {
        query: `
query JiraBPSContent {
  anchorKeywordMappingCollection(
    locale: "${locale}"
    limit: 1
    where: {anchorGroup_contains: "jira subanchor:",
        keywords_contains_all: ["${lowerCaseKeyword}"]}
  ) {
    items {
      anchorGroup
      headlinesCollection {
        items {
          sys {
            id
          }
          headlineTitleExternal
          headlineSubheading
        }
      }
      assetContentsCollection {
        items {
          sys {
            id
          }
          image1OrangeLogic {
            assetUrl
            alt
          }
        }
      }
    }
  }
}
        `,
        variables: {}
    };
};
const $67ece75223da0660$export$58058b967c6ffa5 = (locale = 'en-US', subAnchor)=>{
    const lowerCaseSubAnchor = subAnchor.toLowerCase();
    return {
        query: `
query ConfBrandDefault {
  anchorKeywordMappingCollection(
    locale: "${locale}"
    limit: 1
    where: {
      contentfulMetadata: {
        tags: {id_contains_all: "conf-bps-v2"}
      }
      anchorGroup_contains: "${lowerCaseSubAnchor}"
    }
  ) {
    items {
      anchorGroup
      headlinesCollection {
        items {
          sys {
            id
          }
          headlineTitleExternal
          headlineSubheading
        }
      }
      assetContentsCollection {
        items {
          sys {
            id
          }
          image1OrangeLogic {
            assetUrl
            alt
          }
        }
      }
    }
  }
}
        `,
        variables: {}
    };
};
const $67ece75223da0660$export$3d362ee9a98d14f1 = (data)=>{
    const mapping = data?.anchorKeywordMappingCollection?.items?.[0];
    const headlines = new Map();
    const assetContents = new Map();
    if (!mapping) {
        console.error('No anchor mapping found for the specified keyword.');
        return {
            headlines: headlines,
            assetContents: assetContents
        };
    }
    mapping.headlinesCollection?.items?.forEach((headline)=>{
        headlines.set(headline.sys.id, {
            id: headline.sys.id,
            title: headline.headlineTitleExternal,
            subheading: headline.headlineSubheading
        });
    });
    mapping.assetContentsCollection?.items?.forEach((asset)=>{
        assetContents.set(asset.sys.id, {
            id: asset.sys.id,
            image1: asset.image1,
            image1OrangeLogic: asset.image1OrangeLogic,
            video1Mp4: asset.video1Mp4,
            video1Webm: asset.video1Webm,
            primaryText1: asset.primaryText1,
            secondaryText1: asset.secondaryText1,
            image2: asset.image2,
            video2Mp4: asset.video2Mp4,
            video2Webm: asset.video2Webm,
            primaryText2: asset.primaryText2,
            secondaryText2: asset.secondaryText2,
            image3: asset.image3,
            video3Mp4: asset.video3Mp4,
            video3Webm: asset.video3Webm,
            primaryText3: asset.primaryText3,
            secondaryText3: asset.secondaryText3
        });
    });
    return {
        headlines: headlines,
        assetContents: assetContents
    };
};
const $67ece75223da0660$var$fetchContentful = async (query, variables)=>{
    const contentfulUrl = `${"https://graphql.contentful.com"}/content/v1/spaces/${"xjcz23wx147q"}/environments/${"master"}`;
    const contentfulAuthKey = "fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8";
    const response = await fetch(contentfulUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${contentfulAuthKey}`
        },
        credentials: 'same-origin',
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
    if (!response.ok) {
        console.error(`Contentful request failed with status ${response.status}`);
        return {
            data: null
        };
    }
    return response.json();
};
async function $67ece75223da0660$export$1f77d6e006a81792(params) {
    const aggClient = new (0, $lr38U.AGGClient)({
        gatewayUrl: 'https://www.atlassian.com/gateway/api/graphql'
    });
    const requestedSubAnchor = params.subAnchor ?? '';
    // 1. Fetch content from Contentful
    let contentQuery = $67ece75223da0660$export$f77ef816d236f23(params.locale, params.keyword);
    // use sub anchor query for sub anchor use case
    if (params.useCase === $67ece75223da0660$export$eebd7b1f45feba3c.ANCHOR_JOURNEY_SUB_ANCHOR) contentQuery = $67ece75223da0660$export$8b1f6b9fa582beb0(params.locale, requestedSubAnchor);
    // use query for Jira BPS use case
    if (params.useCase === $67ece75223da0660$export$eebd7b1f45feba3c.ANCHOR_JOURNEY_JIRA_BPS) contentQuery = $67ece75223da0660$export$6ed46c1280a84b84(params.locale, params.keyword);
    const isConfBrandDefaultUseCase = params.useCase === $67ece75223da0660$export$eebd7b1f45feba3c.ANCHOR_JOURNEY_CONFLUENCE_BRAND_DEFAULT;
    const resolvedSubAnchor = isConfBrandDefaultUseCase && !$67ece75223da0660$export$13b8fe595673438f(requestedSubAnchor.toLowerCase()) ? $67ece75223da0660$var$DEFAULT_CONF_BRANDED_SUB_ANCHOR : requestedSubAnchor.toLowerCase();
    if (isConfBrandDefaultUseCase) contentQuery = $67ece75223da0660$export$58058b967c6ffa5(params.locale, resolvedSubAnchor);
    const contentResult = await $67ece75223da0660$var$fetchContentful(contentQuery.query, contentQuery.variables);
    const { headlines: headlines, assetContents: assetContents } = $67ece75223da0660$export$3d362ee9a98d14f1(contentResult.data);
    // 2 Fetch recommendations from GRS
    const grsQuery = $67ece75223da0660$export$87f52e60582b0680({
        keyword: params.keyword,
        subAnchor: resolvedSubAnchor,
        product: params.product,
        locale: params.locale,
        subproduct: 'software',
        channel: params.channel ?? '',
        anonymousId: params.anonymousId,
        useCase: params.useCase ?? $67ece75223da0660$export$eebd7b1f45feba3c.ANCHOR_JOURNEY,
        utmContent: params.utmContent ?? '',
        utmCampaign: params.utmCampaign ?? ''
    });
    const grsResult = await aggClient.query(grsQuery.query, grsQuery.variables);
    const recommendations = $67ece75223da0660$export$ecddac92d62e846b(grsResult.data);
    // get top ranked recommendation
    const recommendation = recommendations[0];
    const results = {
        ...$67ece75223da0660$export$33a5d89cd13c214e
    };
    if (!recommendation) {
        console.error('No recommendation from GRS');
        return results;
    }
    // 3. Find the matching content
    const headline = headlines.get(recommendation.textId ?? '');
    const asset = assetContents.get(recommendation.assetId ?? '');
    const recoSessionId = recommendation.sessionId;
    if (!headline && !asset) {
        console.error('Could not match GRS recommendation to Contentful content');
        return results;
    }
    results.headline = headline ?? null;
    results.asset = asset ?? null;
    results.recoSessionId = recoSessionId;
    results.recoEntityId = `text:${headline?.id}+asset:${asset?.id}`;
    return results;
}
const $67ece75223da0660$export$931b6efd587bc3e3 = (data, productKey = $67ece75223da0660$export$458cb8a0fc07c720)=>{
    try {
        const existingData = JSON.parse((0, $2gCne.getLocalStorage)($67ece75223da0660$var$GRS_LOCAL_STORAGE_KEY) || '{}');
        const updatedData = {
            ...existingData,
            [productKey]: {
                recoSessionId: data.recoSessionId,
                recoEntityId: data.recoEntityId
            }
        };
        (0, $2gCne.setLocalStorage)($67ece75223da0660$var$GRS_LOCAL_STORAGE_KEY, JSON.stringify(updatedData));
    } catch  {
        // If parsing fails, create new structure with just this product
        (0, $2gCne.setLocalStorage)($67ece75223da0660$var$GRS_LOCAL_STORAGE_KEY, JSON.stringify({
            [productKey]: {
                recoSessionId: data.recoSessionId,
                recoEntityId: data.recoEntityId
            }
        }));
    }
};
const $67ece75223da0660$export$4e5182d7e2a1114a = (productKey)=>{
    if (productKey === undefined || productKey !== $67ece75223da0660$export$458cb8a0fc07c720 && !Object.values((0, $fcO7r.ProductKey)).includes(productKey)) return {};
    try {
        const data = JSON.parse((0, $2gCne.getLocalStorage)($67ece75223da0660$var$GRS_LOCAL_STORAGE_KEY) || '{}');
        return data[productKey] || {};
    } catch  {
        return {};
    }
};

});
parcelRegister("lr38U", function(module, exports) {
$parcel$export(module.exports, "AGGClient", function () { return $f6975c0296e03777$export$b44e5dafe13af7b3; });
//@ts-nocheck

var $g7Jsj = parcelRequire("g7Jsj");
const $f6975c0296e03777$var$GATEWAY_URL = '/gateway/api/graphql';
const $f6975c0296e03777$var$DEFAULT_OPTIONS = {
    gatewayUrl: $f6975c0296e03777$var$GATEWAY_URL
};
const $f6975c0296e03777$var$GET_TEMPLATES_QUERY = `#graphql
    query getTemplates($first: Int = 50, $after: String) {
        templates(search: {queries: {first: $first, after: $after}}) {
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    templateId
                    name
                    contributor {
                        __typename
                        ... on ContentPlatformOrganization {
                            ...contentPlatformOrganization
                        }
                        ... on ContentPlatformAuthor {
                            name
                            jobTitle
                            shortBiography
                            authorPicture {
                                ...contentPlatformImageAsset
                            }
                            organization {
                                ...contentPlatformOrganization
                            }
                        }
                    }
                    previewBlurb
                    templateIcon {
                        ...contentPlatformImageAsset
                    }
                    templatePreview {
                        ...contentPlatformImageAsset
                    }
                    oneLinerHeadline
                    aboutThisTemplate
                    howToUseThisTemplate {
                        name
                        steps {
                            name
                            description
                            asset {
                                ...contentPlatformImageAsset
                            }
                        }
                    }
                    category {
                        id
                        name
                        urlSlug
                        shortDescriptionOneLiner
                        description
                    }
                    relatedTemplates {
                        templateId
                    }
                    targetAudience {
                        userRoleId
                        roleDescription
                        userRole
                    }
                    targetOrganizationSize {
                        shortDescription
                        name
                    }
                    templateType {
                        id
                        templateTypeName
                    }
                }
            }
        }
    }

    fragment contentPlatformImageAsset on ContentPlatformTemplateImageAsset {
        description
        title
        url
        details
        fileName
        contentType
    }

    fragment contentPlatformOrganization on ContentPlatformOrganization {
        name
        tagline
        shortDescription
        logo {
            ...contentPlatformImageAsset
        }
        industry {
            name
            shortDescription
        }
    }
    `;
function $f6975c0296e03777$var$imageFromContentPlatformImage(node) {
    // TODO: Assert the shape of this JSON blob?
    const details = node.details;
    return {
        name: node.title,
        size: details.size,
        height: details.image?.height,
        width: details.image?.width,
        url: node.url
    };
}
function $f6975c0296e03777$var$contributorFromContentPlatformContributor(node) {
    if (node?.__typename === 'ContentPlatformOrganization') return {
        name: node.name,
        tagline: node.tagline,
        shortDescription: node.shortDescription,
        logo: node.logo?.map($f6975c0296e03777$var$imageFromContentPlatformImage),
        industry: node.industry?.map((industry)=>({
                name: industry.name,
                shortDescription: industry.shortDescription
            }))
    };
    else if (node?.__typename === 'ContentPlatformAuthor') return {
        name: node.name,
        jobTitle: node.jobTitle,
        shortBiography: node.shortBiography,
        authorPicture: node.authorPicture ? $f6975c0296e03777$var$imageFromContentPlatformImage(node.authorPicture) : null,
        organization: $f6975c0296e03777$var$contributorFromContentPlatformContributor(node.organization)
    };
    return null;
}
function $f6975c0296e03777$var$templateFromContentPlatformTemplate(node) {
    return {
        templateId: node.templateId,
        name: node.name,
        contributor: $f6975c0296e03777$var$contributorFromContentPlatformContributor(node.contributor),
        previewBlurb: node.previewBlurb,
        templateIcon: node.templateIcon ? $f6975c0296e03777$var$imageFromContentPlatformImage(node.templateIcon) : null,
        templatePreview: node.templatePreview?.map($f6975c0296e03777$var$imageFromContentPlatformImage),
        oneLinerHeadline: node.oneLinerHeadline,
        aboutThisTemplate: node.aboutThisTemplate,
        howToUseThisTemplate: node.howToUseThisTemplate?.map((guide)=>({
                name: guide.name,
                steps: guide.steps?.map((step)=>({
                        name: step.name,
                        description: step.description,
                        asset: step.asset ? $f6975c0296e03777$var$imageFromContentPlatformImage(step.asset) : null
                    })) ?? []
            })),
        category: node.category?.map((category)=>({
                id: category.id,
                name: category.name,
                urlSlug: category.urlSlug,
                shortDescriptionOneLiner: category.shortDescriptionOneLiner,
                description: category.description
            })),
        relatedTemplates: node.relatedTemplates?.map($f6975c0296e03777$var$templateFromContentPlatformTemplate),
        targetAudience: node.targetAudience,
        targetOrganizationSize: node.targetOrganizationSize?.map((size)=>({
                name: size.name,
                shortDescription: size.shortDescription
            }))
    };
}
class $f6975c0296e03777$export$b44e5dafe13af7b3 {
    constructor(opts = $f6975c0296e03777$var$DEFAULT_OPTIONS){
        this.opts = opts;
    }
    async query(query, variables, customHeaders) {
        const headers = new Headers({
            'Content-Type': 'application/json'
        });
        if (customHeaders) Object.keys(customHeaders).forEach((key, value)=>{
            headers.append(key, customHeaders[key] ?? '');
        });
        const response = await fetch(this.opts?.gatewayUrl ?? $f6975c0296e03777$var$GATEWAY_URL, {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            body: JSON.stringify({
                query: query,
                variables: variables
            })
        });
        if (response.ok) return response.json();
        throw new (0, $g7Jsj.UnsuccessfulFetchError)({
            response: response
        });
    }
    async getTemplates() {
        const templates = [];
        let pageInfo;
        do {
            const { data: data } = await this.query($f6975c0296e03777$var$GET_TEMPLATES_QUERY, {
                after: pageInfo?.endCursor
            });
            pageInfo = data.templates.pageInfo;
            templates.push(...data.templates.edges.map(({ node: node })=>$f6975c0296e03777$var$templateFromContentPlatformTemplate(node)));
        }while (pageInfo?.hasNextPage);
        return templates;
    }
}

});
parcelRegister("g7Jsj", function(module, exports) {
$parcel$export(module.exports, "UnsuccessfulFetchError", function () { return $833906822b2e4aa7$export$da6dec65957b7041; });
class $833906822b2e4aa7$export$da6dec65957b7041 extends Error {
    constructor({ message: message, response: response }){
        super(message ?? response.statusText);
        this.name = $833906822b2e4aa7$export$da6dec65957b7041.name;
        this.response = response;
    }
    get url() {
        return this.response.url;
    }
    get status() {
        return this.response.status;
    }
}
function $833906822b2e4aa7$export$24a0e392ef274e28(value) {
    return value.name === $833906822b2e4aa7$export$da6dec65957b7041.name;
}

});





parcelRegister("427NR", function(module, exports) {
$parcel$export(module.exports, "getRecaptcha", function () { return $0098da27caaf2c52$export$38b9d75d8815e68b; });

var $92PV0 = parcelRequire("92PV0");

var $gPKCY = parcelRequire("gPKCY");
const $0098da27caaf2c52$export$38b9d75d8815e68b = async (email, executeRecaptcha)=>{
    (0, $gPKCY.ufoEventGetRecaptcha).start({
        webPlatform: 'bxp-ui'
    });
    const shouldSkipRecaptcha = (email)=>{
        const botTestPattern = /(bottest@usersinbuckets.com|bottest@atl-paid-dev.com|bottest@bxpwpi.com)$/;
        return botTestPattern.test(email);
    };
    let gRecaptchaResponse = '';
    const skipRecaptcha = shouldSkipRecaptcha(email);
    if (skipRecaptcha) gRecaptchaResponse = 'reCaptcha';
    else {
        if (!executeRecaptcha) {
            (0, $gPKCY.ufoEventGetRecaptcha).failure({
                customData: {
                    gRecaptchaResponse: gRecaptchaResponse ?? 'none',
                    executeRecaptchaExists: Boolean(executeRecaptcha),
                    reactComponent: 'getRecaptcha',
                    analyticsEvent: 'notFound'
                },
                error: new Error('executeRecaptcha not found')
            });
            console.log('Execute recaptcha not yet available');
            return;
        }
        try {
            gRecaptchaResponse = await executeRecaptcha('userSignup');
            (0, $gPKCY.ufoEventGetRecaptcha).success({
                customData: {
                    gRecaptchaResponse: gRecaptchaResponse ?? 'none',
                    executeRecaptchaExists: Boolean(executeRecaptcha),
                    reactComponent: 'getRecaptcha',
                    analyticsEvent: 'succeeded'
                }
            });
        } catch (error) {
            (0, $gPKCY.ufoEventGetRecaptcha).failure({
                customData: {
                    gRecaptchaResponse: gRecaptchaResponse ?? 'none',
                    executeRecaptchaExists: Boolean(executeRecaptcha),
                    reactComponent: 'getRecaptcha',
                    analyticsEvent: 'errored'
                },
                error: error
            });
            console.log('Error executing recaptcha', error);
            (0, $92PV0.Tracking).trackEvent('bxp.formCloudSignup.reCaptchaError', {
                eventContainer: 'bxp-ui-signup'
            });
            return;
        }
    }
    return gRecaptchaResponse;
};

});


parcelRegister("j8Zhp", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return $19900f809c4af40d$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $a8iOK = parcelRequire("a8iOK");
const $19900f809c4af40d$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const { formError: formError } = (0, $a8iOK.useAccountSigninContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === 'en' // temporary fix until translation is available
     ? formatMessage({
        id: 'gwp.accountSignin.userSignupError',
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $19900f809c4af40d$var$contactUsLink
    }) : formatMessage({
        id: 'gwp.accountSignin.formError',
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $19900f809c4af40d$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        role: "alert",
        className: (0, $2jatx.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $19900f809c4af40d$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $19900f809c4af40d$var$errorCss = null;

});

parcelRegister("l9NXI", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return $1b7ac554a404029c$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $kCGk7 = parcelRequire("kCGk7");

var $78jg9 = parcelRequire("78jg9");

var $8KJ2x = parcelRequire("8KJ2x");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $a8iOK = parcelRequire("a8iOK");
const $1b7ac554a404029c$var$HELP_TEXT_ID = 'account_signin_email_help_text';
const $1b7ac554a404029c$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $a8iOK.useAccountSigninContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: 'gwp.accountSignin.helperText',
        defaultMessage: 'Using a work email helps find teammates and boost collaboration.'
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: 'gwp.accountSignin.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: 'gwp.accountSignin.workEmail',
        defaultMessage: 'Work email'
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: 'gwp.accountSignin.emailPlaceholder',
        defaultMessage: 'you@company.com'
    });
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $gM7M2.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth7vkz _1rwquftu _1heuz4z1 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rnz4z1 _1q9pbfng _d78pglyw"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_zbay183y",
                        isValid === true && "_1lo61ea4",
                        isValid === false && "_1lo611jk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                            ...fieldProps,
                            autoComplete: "on",
                            "aria-describedby": $1b7ac554a404029c$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)($1b7ac554a404029c$export$f8fea9f50a4bfae6, {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        }),
                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $1b7ac554a404029c$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $2jatx.default)([
                                "_syazweb4 _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $1b7ac554a404029c$var$HELP_TEXT_ID,
                            className: (0, $2jatx.default)([
                                "_syaz1ezn _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_xluqsf": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark500')),
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $1b7ac554a404029c$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const validMessage = formatMessage({
        id: 'gwp.accountSignin.validEmailIcon',
        defaultMessage: 'Email is valid'
    });
    const invalidMessage = formatMessage({
        id: 'gwp.accountSignin.invalidEmailIcon',
        defaultMessage: 'Email is invalid'
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswu1afi _1wyb1syg _y4tiftgi _syazxawg"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78jg9))), {
            label: validMessage
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswu1afi _1wyb1syg _y4tiftgi _syazp84t"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kCGk7))), {
            label: invalidMessage
        })
    });
};
const $1b7ac554a404029c$var$green600 = '#22A06B';
const $1b7ac554a404029c$var$red700 = '#C9372C';
const $1b7ac554a404029c$var$red600 = '#E2483D';
const $1b7ac554a404029c$var$errorMessageCss = null;
const $1b7ac554a404029c$var$helpTextCss = null;
const $1b7ac554a404029c$var$fieldCss = null;
const $1b7ac554a404029c$var$iconWrapperStyle = {
    alignItems: 'center',
    display: 'flex',
    fill: (0, $bNzAT.default)('color.neutral.light0'),
    fontSize: (0, $iTHVN.fontSize).md,
    paddingInlineEnd: 8
};
const $1b7ac554a404029c$var$iconValidCss = null;
const $1b7ac554a404029c$var$iconInvalidCss = null;
const $1b7ac554a404029c$var$inputCss = null;
const $1b7ac554a404029c$var$inputInvalidCss = null;
const $1b7ac554a404029c$var$inputValidCss = null;

});
parcelRegister("kCGk7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f99ea99a006a4f29d6a537b27790dcf5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0382fcee6ac15e2$var$_react = $f0382fcee6ac15e2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f0382fcee6ac15e2$var$_baseNew = $f0382fcee6ac15e2$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f0382fcee6ac15e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0382fcee6ac15e2$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $f0382fcee6ac15e2$var$_react.default.createElement($f0382fcee6ac15e2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$f0382fcee6ac15e2$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $f0382fcee6ac15e2$var$_default = module.exports.default = $f0382fcee6ac15e2$var$StatusErrorIcon;

});

parcelRegister("78jg9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5318385017ce2573$var$_react = $5318385017ce2573$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5318385017ce2573$var$_baseNew = $5318385017ce2573$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5318385017ce2573$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5318385017ce2573$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $5318385017ce2573$var$_react.default.createElement($5318385017ce2573$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$5318385017ce2573$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $5318385017ce2573$var$_default = module.exports.default = $5318385017ce2573$var$StatusSuccessIcon;

});

parcelRegister("8KJ2x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $65f58e965691f00d$export$2e2bcd8739ae039; });

var $5JI2S = parcelRequire("5JI2S");

var $c5OQP = parcelRequire("c5OQP");

var $eHTZG = parcelRequire("eHTZG");

var $9mgU1 = parcelRequire("9mgU1");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $ehT5I = parcelRequire("ehT5I");

var $jSxRg = parcelRequire("jSxRg");
var $65f58e965691f00d$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $65f58e965691f00d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65f58e965691f00d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65f58e965691f00d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHTZG.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65f58e965691f00d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $65f58e965691f00d$var$analyticsParams = {
    componentName: 'textField',
    packageName: "@atlaskit/textfield",
    packageVersion: "5.6.8"
};
var $65f58e965691f00d$var$Textfield = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, $9mgU1.default)(props, $65f58e965691f00d$var$_excluded);
    var inputRef = (0, $1oC0p.useRef)(null);
    var _useGlobalTheme = (0, $ehT5I.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var handleOnFocus = (0, $gJJny.usePlatformLeafEventHandler)($65f58e965691f00d$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $65f58e965691f00d$var$analyticsParams));
    var handleOnBlur = (0, $gJJny.usePlatformLeafEventHandler)($65f58e965691f00d$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $65f58e965691f00d$var$analyticsParams));
    var handleOnMouseDown = (0, $1oC0p.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $1oC0p.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, $c5OQP.default)(ref) === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    var containerStyles = (0, $1oC0p.useMemo)(function() {
        return (0, $jSxRg.containerStyles)(appearance, mode, width);
    }, [
        appearance,
        mode,
        width
    ]);
    var inputStyle = (0, $1oC0p.useMemo)(function() {
        return (0, $jSxRg.inputStyles)(mode);
    }, [
        mode
    ]);
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ (0, $3dJ4i.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        css: containerStyles,
        className: className
    }, elemBeforeInput, (0, $3dJ4i.jsx)("input", (0, $5JI2S.default)({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    })), elemAfterInput));
});
$65f58e965691f00d$var$Textfield.displayName = 'Textfield';
var /**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ $65f58e965691f00d$export$2e2bcd8739ae039 // The above generic is used to let ERTC know what props to extract.
 // See: https://github.com/atlassian/extract-react-types/issues/201
 = /*#__PURE__*/ (0, $1oC0p.memo)($65f58e965691f00d$var$Textfield);

});
parcelRegister("5JI2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $42d35232c6af1d2f$export$2e2bcd8739ae039; });
function $42d35232c6af1d2f$export$2e2bcd8739ae039() {
    return $42d35232c6af1d2f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $42d35232c6af1d2f$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("c5OQP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8cdd65a3c55597dc$export$2e2bcd8739ae039; });
function $8cdd65a3c55597dc$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8cdd65a3c55597dc$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8cdd65a3c55597dc$export$2e2bcd8739ae039(o);
}

});

parcelRegister("eHTZG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab50840c63d2c70b$export$2e2bcd8739ae039; });

var $ezolX = parcelRequire("ezolX");
function $ab50840c63d2c70b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $ezolX.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("ezolX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a9b7399b23311173$export$2e2bcd8739ae039; });

var $c5OQP = parcelRequire("c5OQP");

var $5eKuz = parcelRequire("5eKuz");
function $a9b7399b23311173$export$2e2bcd8739ae039(t) {
    var i = (0, $5eKuz.default)(t, "string");
    return "symbol" == (0, $c5OQP.default)(i) ? i : i + "";
}

});
parcelRegister("5eKuz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d0252e50f1e8682$export$2e2bcd8739ae039; });

var $c5OQP = parcelRequire("c5OQP");
function $3d0252e50f1e8682$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $c5OQP.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $c5OQP.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("9mgU1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d03479b8aa3e2d1$export$2e2bcd8739ae039; });

var $cxsY2 = parcelRequire("cxsY2");
function $6d03479b8aa3e2d1$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $cxsY2.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("cxsY2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $920f096db58049c9$export$2e2bcd8739ae039; });
function $920f096db58049c9$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("ehT5I", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $a66d632dd5c195ac$export$7692396083754928; });

var $j7HPb = parcelRequire("j7HPb");
// Create default global light theme
var $a66d632dd5c195ac$var$_createTheme = (0, $j7HPb.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $a66d632dd5c195ac$var$Provider = $a66d632dd5c195ac$var$_createTheme.Provider, $a66d632dd5c195ac$var$Consumer = $a66d632dd5c195ac$var$_createTheme.Consumer, $a66d632dd5c195ac$export$7692396083754928 = $a66d632dd5c195ac$var$_createTheme.useTheme;
var $a66d632dd5c195ac$export$2e2bcd8739ae039 = {
    Provider: $a66d632dd5c195ac$var$Provider,
    Consumer: $a66d632dd5c195ac$var$Consumer
};

});
parcelRegister("j7HPb", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $dec0aa66bea87ac0$export$25d302a5b900a763; });

var $9mgU1 = parcelRequire("9mgU1");

var $1oC0p = parcelRequire("1oC0p");
var $dec0aa66bea87ac0$var$_excluded = [
    "children"
];
function $dec0aa66bea87ac0$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $9mgU1.default)(props, $dec0aa66bea87ac0$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("jSxRg", function(module, exports) {
$parcel$export(module.exports, "containerStyles", function () { return $e78d52fb12dbf7ad$export$5972a68b6e54f38f; });
$parcel$export(module.exports, "inputStyles", function () { return $e78d52fb12dbf7ad$export$3eeb47dc8e6249d9; });

var $eHTZG = parcelRequire("eHTZG");

var $jkuIt = parcelRequire("jkuIt");

var $33OLH = parcelRequire("33OLH");

var $duYBc = parcelRequire("duYBc");

var $57T0Z = parcelRequire("57T0Z");
function $e78d52fb12dbf7ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e78d52fb12dbf7ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e78d52fb12dbf7ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHTZG.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e78d52fb12dbf7ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e78d52fb12dbf7ad$var$fontSize = (0, $duYBc.fontSize)();
var $e78d52fb12dbf7ad$var$gridSize = (0, $duYBc.gridSize)();
var $e78d52fb12dbf7ad$var$disabledRules = {
    light: {
        backgroundColor: $57T0Z.disabledBackgroundColor.light,
        backgroundColorHover: $57T0Z.disabledBackgroundColor.light,
        borderColor: $57T0Z.disabledBackgroundColor.light,
        textColor: $57T0Z.disabledTextColor.light
    },
    dark: {
        backgroundColor: $57T0Z.disabledBackgroundColor.dark,
        backgroundColorHover: $57T0Z.disabledBackgroundColor.dark,
        borderColor: $57T0Z.disabledBackgroundColor.dark,
        textColor: $57T0Z.disabledTextColor.dark
    }
};
var $e78d52fb12dbf7ad$var$invalidRules = {
    light: {
        // ----
        backgroundColor: $57T0Z.defaultBackgroundColor.light,
        backgroundColorHover: $57T0Z.defaultBackgroundColorHover.light,
        // ^--- the above values aren't used directly they remain because its exposed by the `textFieldColors` export
        backgroundColorFocus: $57T0Z.defaultBackgroundColorFocus.light,
        borderColor: "var(--ds-border-danger, ".concat((0, $33OLH.R400), ")"),
        borderColorFocus: $57T0Z.defaultBorderColorFocus.light
    },
    dark: {
        // ----
        backgroundColor: $57T0Z.defaultBackgroundColor.dark,
        backgroundColorHover: $57T0Z.defaultBackgroundColorHover.dark,
        // ^--- the above values aren't used directly they remain because its exposed by the `textFieldColors` export
        backgroundColorFocus: $57T0Z.defaultBackgroundColorFocus.dark,
        borderColor: "var(--ds-border-danger, ".concat((0, $33OLH.R400), ")"),
        borderColorFocus: $57T0Z.defaultBorderColorFocus.dark
    }
};
var $e78d52fb12dbf7ad$var$backgroundColor = {
    standard: $57T0Z.defaultBackgroundColor,
    subtle: $57T0Z.transparent,
    none: $57T0Z.transparent
};
var $e78d52fb12dbf7ad$var$backgroundColorFocus = {
    standard: $57T0Z.defaultBackgroundColorFocus,
    subtle: $57T0Z.defaultBackgroundColorFocus,
    none: $57T0Z.transparent
};
var $e78d52fb12dbf7ad$var$backgroundColorHover = {
    standard: $57T0Z.defaultBackgroundColorHover,
    subtle: $57T0Z.defaultBackgroundColorHover,
    none: $57T0Z.transparent
};
var $e78d52fb12dbf7ad$var$borderColor = {
    standard: $57T0Z.defaultBorderColor,
    subtle: $57T0Z.transparent,
    none: $57T0Z.transparent
};
var $e78d52fb12dbf7ad$var$borderColorFocus = {
    standard: $57T0Z.defaultBorderColorFocus,
    subtle: $57T0Z.defaultBorderColorFocus,
    none: $57T0Z.transparent
};
var $e78d52fb12dbf7ad$var$borderColorHover = {
    standard: $57T0Z.defaultBorderColor,
    subtle: $57T0Z.subtleBorderColorHover,
    none: $57T0Z.transparent
};
var $e78d52fb12dbf7ad$var$getContainerTextBgAndBorderColor = function getContainerTextBgAndBorderColor(appearance, mode) {
    return {
        backgroundColor: $e78d52fb12dbf7ad$var$backgroundColor[appearance][mode],
        borderColor: $e78d52fb12dbf7ad$var$borderColor[appearance][mode],
        color: $57T0Z.textColor[mode],
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $e78d52fb12dbf7ad$var$backgroundColorHover[appearance][mode],
            borderColor: $e78d52fb12dbf7ad$var$borderColorHover[appearance][mode]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $e78d52fb12dbf7ad$var$backgroundColorFocus[appearance][mode],
            borderColor: $e78d52fb12dbf7ad$var$borderColorFocus[appearance][mode],
            boxShadow: (0, $jkuIt.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $e78d52fb12dbf7ad$var$borderColorFocus[appearance][mode]) : undefined
        },
        '&[data-disabled]': $e78d52fb12dbf7ad$var$_objectSpread({
            color: $e78d52fb12dbf7ad$var$disabledRules[mode].textColor,
            cursor: 'not-allowed'
        }, appearance === 'standard' && {
            backgroundColor: $e78d52fb12dbf7ad$var$disabledRules[mode].backgroundColor,
            borderColor: $e78d52fb12dbf7ad$var$disabledRules[mode].borderColor
        }),
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: $e78d52fb12dbf7ad$var$invalidRules[mode].borderColor,
            boxShadow: (0, $jkuIt.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $e78d52fb12dbf7ad$var$invalidRules[mode].borderColor) : undefined
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: $e78d52fb12dbf7ad$var$invalidRules[mode].backgroundColorFocus,
            borderColor: $e78d52fb12dbf7ad$var$invalidRules[mode].borderColorFocus,
            boxShadow: (0, $jkuIt.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $e78d52fb12dbf7ad$var$invalidRules[mode].borderColorFocus) : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    };
};
var $e78d52fb12dbf7ad$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $e78d52fb12dbf7ad$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $e78d52fb12dbf7ad$var$widthMap ? $e78d52fb12dbf7ad$var$widthMap[width] : +width;
};
var $e78d52fb12dbf7ad$export$5972a68b6e54f38f = function containerStyles(appearance, mode, width) {
    return $e78d52fb12dbf7ad$var$_objectSpread($e78d52fb12dbf7ad$var$_objectSpread($e78d52fb12dbf7ad$var$_objectSpread({
        alignItems: 'center'
    }, $e78d52fb12dbf7ad$var$getContainerTextBgAndBorderColor(appearance, mode)), {}, {
        borderRadius: 3,
        borderWidth: (0, $jkuIt.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "var(--ds-border-width, 1px)" : 2
    }, (0, $jkuIt.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') && appearance !== 'none' ? {
        padding: "var(--ds-border-width, 1px)".concat(" 0")
    } : {}), {}, {
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        fontSize: $e78d52fb12dbf7ad$var$fontSize,
        justifyContent: 'space-between',
        maxWidth: $e78d52fb12dbf7ad$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
};
var $e78d52fb12dbf7ad$export$3eeb47dc8e6249d9 = function inputStyles(mode) {
    return {
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: $e78d52fb12dbf7ad$var$fontSize,
        minWidth: '0',
        outline: 'none',
        width: '100%',
        lineHeight: $e78d52fb12dbf7ad$var$gridSize * 2.5 / $e78d52fb12dbf7ad$var$fontSize,
        fontFamily: (0, $duYBc.fontFamily)(),
        '&[data-monospaced]': {
            fontFamily: (0, $duYBc.codeFontFamily)()
        },
        '&[data-compact]': {
            padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-075, 6px)"),
            height: "".concat(($e78d52fb12dbf7ad$var$gridSize * 3.5 / $e78d52fb12dbf7ad$var$fontSize).toFixed(2), "em")
        },
        '&:not([data-compact])': {
            padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-075, 6px)"),
            height: "".concat(($e78d52fb12dbf7ad$var$gridSize * 4.5 / $e78d52fb12dbf7ad$var$fontSize).toFixed(2), "em")
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: $e78d52fb12dbf7ad$var$disabledRules[mode].textColor
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: $57T0Z.placeholderTextColor[mode],
            '&:disabled': {
                color: $e78d52fb12dbf7ad$var$disabledRules[mode].textColor
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    };
};
var $e78d52fb12dbf7ad$export$63455fa235453645 = {
    backgroundColor: $e78d52fb12dbf7ad$var$backgroundColor,
    backgroundColorFocus: $e78d52fb12dbf7ad$var$backgroundColorFocus,
    backgroundColorHover: $e78d52fb12dbf7ad$var$backgroundColorHover,
    borderColor: $e78d52fb12dbf7ad$var$borderColor,
    borderColorFocus: $e78d52fb12dbf7ad$var$borderColorFocus,
    borderColorHover: $e78d52fb12dbf7ad$var$borderColorHover,
    placeholderTextColor: $57T0Z.placeholderTextColor,
    textColor: $57T0Z.textColor,
    invalidRules: $e78d52fb12dbf7ad$var$invalidRules,
    disabledRules: $e78d52fb12dbf7ad$var$disabledRules
};

});
parcelRegister("jkuIt", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $e127b6301ead6157$export$470e5c2be1411c89; });

var $fv6zG = parcelRequire("fv6zG");
function $e127b6301ead6157$export$ba05d765b8392e5e(flagResolver) {
    (0, $fv6zG.setBooleanResolver)(flagResolver);
}
function $e127b6301ead6157$export$470e5c2be1411c89(name) {
    return (0, $fv6zG.resolveBooleanFlag)(name);
}

});
parcelRegister("fv6zG", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $b48ed9d20182c1fe$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $b48ed9d20182c1fe$export$6333b6aff9fc6275; });

var $4Mj9S = parcelRequire("4Mj9S");

var $7t0tI = parcelRequire("7t0tI");
var $b48ed9d20182c1fe$var$pkgName = '@atlaskit/platform-feature-flags';
var $b48ed9d20182c1fe$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $b48ed9d20182c1fe$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $b48ed9d20182c1fe$var$ENV_ENABLE_PLATFORM_FF = $b48ed9d20182c1fe$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $b48ed9d20182c1fe$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $b48ed9d20182c1fe$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $b48ed9d20182c1fe$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $b48ed9d20182c1fe$var$ENV_ENABLE_PLATFORM_FF || $b48ed9d20182c1fe$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $b48ed9d20182c1fe$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $b48ed9d20182c1fe$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$b48ed9d20182c1fe$var$globalVar[$b48ed9d20182c1fe$export$7e41b1b2bdee3f98] = $b48ed9d20182c1fe$var$globalVar[$b48ed9d20182c1fe$export$7e41b1b2bdee3f98] || $b48ed9d20182c1fe$var$DEFAULT_PFF_GLOBAL;
function $b48ed9d20182c1fe$export$f2b591175b3e424c(resolver) {
    $b48ed9d20182c1fe$var$globalVar[$b48ed9d20182c1fe$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $b48ed9d20182c1fe$export$6333b6aff9fc6275(flagKey) {
    if ($b48ed9d20182c1fe$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $4Mj9S.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $b48ed9d20182c1fe$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $b48ed9d20182c1fe$var$globalVar[$b48ed9d20182c1fe$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("4Mj9S", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $37aa81947e140797$export$1c9f709888824e05; });
var $37aa81947e140797$var$_ref, $37aa81947e140797$var$_globalThis$process, $37aa81947e140797$var$_globalThis$process$e, $37aa81947e140797$var$_globalThis$process2, $37aa81947e140797$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $37aa81947e140797$var$TESTS_MODE = ($37aa81947e140797$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($37aa81947e140797$var$_globalThis$process = globalThis.process) === null || $37aa81947e140797$var$_globalThis$process === void 0 ? void 0 : ($37aa81947e140797$var$_globalThis$process$e = $37aa81947e140797$var$_globalThis$process.env) === null || $37aa81947e140797$var$_globalThis$process$e === void 0 ? void 0 : $37aa81947e140797$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $37aa81947e140797$var$_ref !== void 0) ? $37aa81947e140797$var$_ref : false;
var $37aa81947e140797$var$DEBUG_MODE = !$37aa81947e140797$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($37aa81947e140797$var$_globalThis$process2 = globalThis.process) === null || $37aa81947e140797$var$_globalThis$process2 === void 0 ? void 0 : ($37aa81947e140797$var$_globalThis$process2$ = $37aa81947e140797$var$_globalThis$process2.env) === null || $37aa81947e140797$var$_globalThis$process2$ === void 0 ? void 0 : $37aa81947e140797$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $37aa81947e140797$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$37aa81947e140797$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("33OLH", function(module, exports) {
$parcel$export(module.exports, "R400", function () { return $23a9086c9ea35a11$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B100", function () { return $23a9086c9ea35a11$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $23a9086c9ea35a11$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $23a9086c9ea35a11$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $23a9086c9ea35a11$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N30", function () { return $23a9086c9ea35a11$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $23a9086c9ea35a11$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $23a9086c9ea35a11$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N100", function () { return $23a9086c9ea35a11$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $23a9086c9ea35a11$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N900", function () { return $23a9086c9ea35a11$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $23a9086c9ea35a11$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $23a9086c9ea35a11$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN200", function () { return $23a9086c9ea35a11$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN90", function () { return $23a9086c9ea35a11$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN40", function () { return $23a9086c9ea35a11$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $23a9086c9ea35a11$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN10", function () { return $23a9086c9ea35a11$export$6c813d5160dff5db; });
$parcel$export(module.exports, "skeleton", function () { return $23a9086c9ea35a11$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cjglC = parcelRequire("cjglC");
var $23a9086c9ea35a11$export$4b84fd0e2c617bd = '#FFEBE6';
var $23a9086c9ea35a11$export$b34b069eff244586 = '#FFBDAD';
var $23a9086c9ea35a11$export$be802dd0d8b57f35 = '#FF8F73';
var $23a9086c9ea35a11$export$60847d42f9da92a6 = '#FF7452';
var $23a9086c9ea35a11$export$4a7404f376229999 = '#FF5630';
var $23a9086c9ea35a11$export$2010d0fb4295b346 = '#DE350B';
var $23a9086c9ea35a11$export$2837b5a1a71d5c02 = '#BF2600';
var $23a9086c9ea35a11$export$8d9596b529bbb9cf = '#FFFAE6';
var $23a9086c9ea35a11$export$41060a744ab0b7ae = '#FFF0B3';
var $23a9086c9ea35a11$export$1cc05bbbf340e559 = '#FFE380';
var $23a9086c9ea35a11$export$5aae31392d72caaa = '#FFC400';
var $23a9086c9ea35a11$export$c6930421db9fa514 = '#FFAB00';
var $23a9086c9ea35a11$export$59619663aa6500fb = '#FF991F';
var $23a9086c9ea35a11$export$874739ea9e379ab6 = '#FF8B00';
var $23a9086c9ea35a11$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $23a9086c9ea35a11$export$69a3bf21b9686c2b = '#ABF5D1';
var $23a9086c9ea35a11$export$afbce1382ec95f73 = '#79F2C0';
var $23a9086c9ea35a11$export$747d86715d4175de = '#57D9A3';
var $23a9086c9ea35a11$export$940e1f69e873f202 = '#36B37E';
var $23a9086c9ea35a11$export$a49394138f7b8e85 = '#00875A';
var $23a9086c9ea35a11$export$6fa04827ac68a4fb = '#006644';
var $23a9086c9ea35a11$export$226de0355ed012f8 = '#DEEBFF';
var $23a9086c9ea35a11$export$8c13c2ee36917869 = '#B3D4FF';
var $23a9086c9ea35a11$export$ecfc1dff386a3e7a = '#4C9AFF';
var $23a9086c9ea35a11$export$215b7063051591f1 = '#2684FF';
var $23a9086c9ea35a11$export$e62e8919cca44969 = '#0065FF';
var $23a9086c9ea35a11$export$b3de0ae08da2ce64 = '#0052CC';
var $23a9086c9ea35a11$export$a6ee3d71bc067634 = '#0747A6';
var $23a9086c9ea35a11$export$363e4475840015bb = '#EAE6FF';
var $23a9086c9ea35a11$export$4b0a4417ed59760f = '#C0B6F2';
var $23a9086c9ea35a11$export$6011520a64d9a187 = '#998DD9';
var $23a9086c9ea35a11$export$a7175d4e9206bc80 = '#8777D9';
var $23a9086c9ea35a11$export$b48405b95304b5a1 = '#6554C0';
var $23a9086c9ea35a11$export$c71e4279dd54a18d = '#5243AA';
var $23a9086c9ea35a11$export$147899de772240ec = '#403294';
var $23a9086c9ea35a11$export$2cf711fe14c66f06 = '#E6FCFF';
var $23a9086c9ea35a11$export$7a8f4d33f6f9772c = '#B3F5FF';
var $23a9086c9ea35a11$export$776c9c497ef08533 = '#79E2F2';
var $23a9086c9ea35a11$export$69cb3ca10c1e330e = '#00C7E6';
var $23a9086c9ea35a11$export$9dc1ef0f3f48059b = '#00B8D9';
var $23a9086c9ea35a11$export$7c835c78b6fcdef8 = '#00A3BF';
var $23a9086c9ea35a11$export$6036577f95c3877e = '#008DA6';
var $23a9086c9ea35a11$export$29a4f05edc054374 = '#FFFFFF';
var $23a9086c9ea35a11$export$e655ef011c4aa1a2 = '#FAFBFC';
var $23a9086c9ea35a11$export$9fdfb749e33cdf97 = '#F4F5F7';
var $23a9086c9ea35a11$export$3e51e8f1440314ba = '#EBECF0';
var $23a9086c9ea35a11$export$1ce2d1575d444ceb = '#DFE1E6';
var $23a9086c9ea35a11$export$8754fc7e6d8b3000 = '#C1C7D0';
var $23a9086c9ea35a11$export$c2e91cbeada39b8b = '#B3BAC5';
var $23a9086c9ea35a11$export$5f71e19f3a7ad9de = '#A5ADBA';
var $23a9086c9ea35a11$export$eaa8c8a70ac22806 = '#97A0AF';
var $23a9086c9ea35a11$export$7c87d337fb91a97d = '#8993A4';
var $23a9086c9ea35a11$export$d6447c357493214f = '#7A869A';
var $23a9086c9ea35a11$export$f563ee71e9ee74cd = '#6B778C';
var $23a9086c9ea35a11$export$e2ef2124cf4024b1 = '#5E6C84';
var $23a9086c9ea35a11$export$eece5f492e429f08 = '#505F79';
var $23a9086c9ea35a11$export$c39c0fe0f26207ae = '#42526E';
var $23a9086c9ea35a11$export$7090862dc3038a9f = '#344563';
var $23a9086c9ea35a11$export$ad0bacf983b7ddaa = '#253858';
var $23a9086c9ea35a11$export$7d61b15e0da132af = '#172B4D';
var $23a9086c9ea35a11$export$fbda843f0a27fe96 = '#091E42';
var $23a9086c9ea35a11$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $23a9086c9ea35a11$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $23a9086c9ea35a11$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $23a9086c9ea35a11$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $23a9086c9ea35a11$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $23a9086c9ea35a11$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $23a9086c9ea35a11$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $23a9086c9ea35a11$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $23a9086c9ea35a11$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $23a9086c9ea35a11$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $23a9086c9ea35a11$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $23a9086c9ea35a11$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $23a9086c9ea35a11$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $23a9086c9ea35a11$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $23a9086c9ea35a11$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $23a9086c9ea35a11$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $23a9086c9ea35a11$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $23a9086c9ea35a11$export$2f6319cf7d736c2a = '#E6EDFA';
var $23a9086c9ea35a11$export$95126bc8884d6634 = '#DCE5F5';
var $23a9086c9ea35a11$export$8338d8c35d44ff1 = '#CED9EB';
var $23a9086c9ea35a11$export$5368d76ae4fbbda7 = '#B8C7E0';
var $23a9086c9ea35a11$export$9f0a771d16ec8d36 = '#ABBBD6';
var $23a9086c9ea35a11$export$abcf8c38338b4aa5 = '#9FB0CC';
var $23a9086c9ea35a11$export$97e81faa16a182c7 = '#8C9CB8';
var $23a9086c9ea35a11$export$bfe21c59123ecf33 = '#7988A3';
var $23a9086c9ea35a11$export$ee82aa2ea6a1558 = '#67758F';
var $23a9086c9ea35a11$export$682927c6ed76be02 = '#56637A';
var $23a9086c9ea35a11$export$91fd9994c5be9757 = '#455166';
var $23a9086c9ea35a11$export$d281fbfe3cff2df6 = '#3B475C';
var $23a9086c9ea35a11$export$3902c91d8b98a753 = '#313D52';
var $23a9086c9ea35a11$export$8e8133c1ba5845b5 = '#283447';
var $23a9086c9ea35a11$export$33ff357f6620b39 = '#202B3D';
var $23a9086c9ea35a11$export$633847cf062b69e0 = '#1B2638';
var $23a9086c9ea35a11$export$9776a6e503bdbf76 = '#121A29';
var $23a9086c9ea35a11$export$6c813d5160dff5db = '#0E1624';
var $23a9086c9ea35a11$export$3d4f271a500072a = '#0D1424';
var $23a9086c9ea35a11$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $23a9086c9ea35a11$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $23a9086c9ea35a11$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $23a9086c9ea35a11$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $23a9086c9ea35a11$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $23a9086c9ea35a11$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $23a9086c9ea35a11$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $23a9086c9ea35a11$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $23a9086c9ea35a11$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $23a9086c9ea35a11$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $23a9086c9ea35a11$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $23a9086c9ea35a11$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $23a9086c9ea35a11$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $23a9086c9ea35a11$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $23a9086c9ea35a11$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $23a9086c9ea35a11$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $23a9086c9ea35a11$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $23a9086c9ea35a11$export$8ce1fd94bee2f412 = (0, $cjglC.default)({
    light: "var(--ds-surface, ".concat($23a9086c9ea35a11$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($23a9086c9ea35a11$export$633847cf062b69e0, ")")
});
var $23a9086c9ea35a11$export$b861914ea877b580 = (0, $cjglC.default)({
    light: "var(--ds-background-selected, ".concat($23a9086c9ea35a11$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($23a9086c9ea35a11$export$8c13c2ee36917869, ")")
});
var $23a9086c9ea35a11$export$3f1b020df94387af = (0, $cjglC.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($23a9086c9ea35a11$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($23a9086c9ea35a11$export$d281fbfe3cff2df6, ")")
});
var $23a9086c9ea35a11$export$c0183dbab98ca63e = (0, $cjglC.default)({
    light: "var(--ds-surface-overlay, ".concat($23a9086c9ea35a11$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($23a9086c9ea35a11$export$8e8133c1ba5845b5, ")")
});
var $23a9086c9ea35a11$export$6f093cfa640b7166 = (0, $cjglC.default)({
    light: "var(--ds-text, ".concat($23a9086c9ea35a11$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($23a9086c9ea35a11$export$5368d76ae4fbbda7, ")")
});
var $23a9086c9ea35a11$export$42f8e9c698766e7a = (0, $cjglC.default)({
    light: "var(--ds-text, ".concat($23a9086c9ea35a11$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($23a9086c9ea35a11$export$5368d76ae4fbbda7, ")")
});
var $23a9086c9ea35a11$export$c2d157ca1c34b6e3 = (0, $cjglC.default)({
    light: "var(--ds-text-selected, ".concat($23a9086c9ea35a11$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($23a9086c9ea35a11$export$b3de0ae08da2ce64, ")")
});
var $23a9086c9ea35a11$export$1905ba28d7cf066f = (0, $cjglC.default)({
    light: "var(--ds-text-subtlest, ".concat($23a9086c9ea35a11$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($23a9086c9ea35a11$export$97e81faa16a182c7, ")")
});
var $23a9086c9ea35a11$export$bd9002130d306d39 = (0, $cjglC.default)({
    light: "var(--ds-text-subtlest, ".concat($23a9086c9ea35a11$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($23a9086c9ea35a11$export$bfe21c59123ecf33, ")")
});
var $23a9086c9ea35a11$export$46e4a324ac90507f = (0, $cjglC.default)({
    light: "var(--ds-text, ".concat($23a9086c9ea35a11$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($23a9086c9ea35a11$export$5368d76ae4fbbda7, ")")
});
var $23a9086c9ea35a11$export$79f3f2b82beb0d36 = (0, $cjglC.default)({
    light: "var(--ds-text-subtlest, ".concat($23a9086c9ea35a11$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($23a9086c9ea35a11$export$97e81faa16a182c7, ")")
});
var $23a9086c9ea35a11$export$7bb0d5c671655cc4 = (0, $cjglC.default)({
    light: $23a9086c9ea35a11$export$9fdfb749e33cdf97,
    dark: $23a9086c9ea35a11$export$8e8133c1ba5845b5
});
var $23a9086c9ea35a11$export$9c30223ca0a664fb = (0, $cjglC.default)({
    light: "var(--ds-link, ".concat($23a9086c9ea35a11$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($23a9086c9ea35a11$export$ecfc1dff386a3e7a, ")")
});
var $23a9086c9ea35a11$export$7ed258b0728b004b = (0, $cjglC.default)({
    light: "var(--ds-link-pressed, ".concat($23a9086c9ea35a11$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($23a9086c9ea35a11$export$215b7063051591f1, ")")
});
var $23a9086c9ea35a11$export$dfa920d8decc8a59 = (0, $cjglC.default)({
    light: "var(--ds-link-pressed, ".concat($23a9086c9ea35a11$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($23a9086c9ea35a11$export$ecfc1dff386a3e7a, ")")
});
var $23a9086c9ea35a11$export$6069e6ad5c78f632 = (0, $cjglC.default)({
    light: "var(--ds-border-focused, ".concat($23a9086c9ea35a11$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($23a9086c9ea35a11$export$215b7063051591f1, ")")
});
var $23a9086c9ea35a11$export$9ad721cf3b3debe0 = (0, $cjglC.default)({
    light: "var(--ds-background-brand-bold, ".concat($23a9086c9ea35a11$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($23a9086c9ea35a11$export$ecfc1dff386a3e7a, ")")
});
var $23a9086c9ea35a11$export$2aa0182783e7e9de = (0, $cjglC.default)({
    light: $23a9086c9ea35a11$export$b3de0ae08da2ce64,
    dark: $23a9086c9ea35a11$export$ecfc1dff386a3e7a
});
var $23a9086c9ea35a11$export$8bf7dff220b82b4a = (0, $cjglC.default)({
    light: $23a9086c9ea35a11$export$9dc1ef0f3f48059b,
    dark: $23a9086c9ea35a11$export$69cb3ca10c1e330e
});
var $23a9086c9ea35a11$export$e13cce2a2d16a9d4 = (0, $cjglC.default)({
    light: $23a9086c9ea35a11$export$b48405b95304b5a1,
    dark: $23a9086c9ea35a11$export$6011520a64d9a187
});
var $23a9086c9ea35a11$export$a90204d1394caf30 = (0, $cjglC.default)({
    light: $23a9086c9ea35a11$export$4a7404f376229999,
    dark: $23a9086c9ea35a11$export$4a7404f376229999
});
var $23a9086c9ea35a11$export$594c5a8758200c32 = (0, $cjglC.default)({
    light: $23a9086c9ea35a11$export$c6930421db9fa514,
    dark: $23a9086c9ea35a11$export$c6930421db9fa514
});
var $23a9086c9ea35a11$export$955a2ebd2fb142ae = (0, $cjglC.default)({
    light: $23a9086c9ea35a11$export$940e1f69e873f202,
    dark: $23a9086c9ea35a11$export$940e1f69e873f202
});
var $23a9086c9ea35a11$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($23a9086c9ea35a11$export$8d43898f60b96a82, ")");
};

});
parcelRegister("cjglC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8f63f0b848ebe676$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $k3Bo5 = parcelRequire("k3Bo5");
// Unpack custom variants, and get correct value for the current theme
function $8f63f0b848ebe676$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $k3Bo5.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $8f63f0b848ebe676$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $8f63f0b848ebe676$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $k3Bo5.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("k3Bo5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9a116dc1debe701$export$2e2bcd8739ae039; });

var $duYBc = parcelRequire("duYBc");
function $e9a116dc1debe701$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $duYBc.CHANNEL) in props.theme) return props.theme[0, $duYBc.CHANNEL];
        else if ('mode' in props.theme && (0, $duYBc.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $duYBc.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("duYBc", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $9d3d1564af90f0db$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $9d3d1564af90f0db$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $9d3d1564af90f0db$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $9d3d1564af90f0db$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $9d3d1564af90f0db$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "fontFamily", function () { return $9d3d1564af90f0db$export$a5975749f0374264; });
$parcel$export(module.exports, "codeFontFamily", function () { return $9d3d1564af90f0db$export$356129969ee49c55; });

var $a1xm4 = parcelRequire("a1xm4");

var $33OLH = parcelRequire("33OLH");
var $9d3d1564af90f0db$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $9d3d1564af90f0db$export$c93026a968943f95 = 'light';
var $9d3d1564af90f0db$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $9d3d1564af90f0db$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $9d3d1564af90f0db$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $9d3d1564af90f0db$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $9d3d1564af90f0db$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $9d3d1564af90f0db$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $9d3d1564af90f0db$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $9d3d1564af90f0db$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $33OLH.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9d3d1564af90f0db$export$6d8204c2cb2e06b8() / 4;
    (0, $a1xm4.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $9d3d1564af90f0db$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $9d3d1564af90f0db$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $9d3d1564af90f0db$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $a1xm4.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $9d3d1564af90f0db$export$ba1d834b86d72a09 = $9d3d1564af90f0db$export$a1b3edb637fb4f35;
var $9d3d1564af90f0db$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $33OLH.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $33OLH.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $33OLH.N30A), ")")
            }
        }
    };
};

});
parcelRegister("a1xm4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74c3def92c610246$export$2e2bcd8739ae039; });

var $b9VcA = parcelRequire("b9VcA");

var $7t0tI = parcelRequire("7t0tI");
function $74c3def92c610246$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $b9VcA.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $74c3def92c610246$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("b9VcA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $81fce8161fcedf61$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $81fce8161fcedf61$var$printed = {};
function $81fce8161fcedf61$export$2e2bcd8739ae039(message) {
    if ($81fce8161fcedf61$var$printed[message]) return;
    $81fce8161fcedf61$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("57T0Z", function(module, exports) {
$parcel$export(module.exports, "disabledBackgroundColor", function () { return $3bb848051ed26581$export$425be610a1df3a3d; });
$parcel$export(module.exports, "defaultBackgroundColor", function () { return $3bb848051ed26581$export$b13414ee9ac9cae6; });
$parcel$export(module.exports, "defaultBackgroundColorFocus", function () { return $3bb848051ed26581$export$21287e4b7f134f09; });
$parcel$export(module.exports, "defaultBackgroundColorHover", function () { return $3bb848051ed26581$export$bca15982c103d57b; });
$parcel$export(module.exports, "defaultBorderColor", function () { return $3bb848051ed26581$export$dafd83031c202ca8; });
$parcel$export(module.exports, "defaultBorderColorFocus", function () { return $3bb848051ed26581$export$e8320c09dc1e4012; });
$parcel$export(module.exports, "subtleBorderColorHover", function () { return $3bb848051ed26581$export$a87538d56ee366ec; });
$parcel$export(module.exports, "transparent", function () { return $3bb848051ed26581$export$f4d082c200a4b4b8; });
$parcel$export(module.exports, "textColor", function () { return $3bb848051ed26581$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "disabledTextColor", function () { return $3bb848051ed26581$export$eb4a7d363eec53c8; });
$parcel$export(module.exports, "placeholderTextColor", function () { return $3bb848051ed26581$export$5e076b2557ef7bbb; });

var $jkuIt = parcelRequire("jkuIt");

var $33OLH = parcelRequire("33OLH");
var $3bb848051ed26581$export$425be610a1df3a3d = {
    light: "var(--ds-background-disabled, ".concat((0, $33OLH.N10), ")"),
    dark: "var(--ds-background-disabled, ".concat((0, $33OLH.DN10), ")")
};
var $3bb848051ed26581$export$b13414ee9ac9cae6 = {
    light: "var(--ds-background-input, ".concat((0, $33OLH.N10), ")"),
    dark: "var(--ds-background-input, ".concat((0, $33OLH.DN10), ")")
};
var $3bb848051ed26581$export$21287e4b7f134f09 = {
    light: "var(--ds-background-input-pressed, ".concat((0, $33OLH.N0), ")"),
    dark: "var(--ds-background-input-pressed, ".concat((0, $33OLH.DN10), ")")
};
var $3bb848051ed26581$export$bca15982c103d57b = {
    light: "var(--ds-background-input-hovered, ".concat((0, $33OLH.N30), ")"),
    dark: "var(--ds-background-input-hovered, ".concat((0, $33OLH.DN30), ")")
};
var $3bb848051ed26581$export$dafd83031c202ca8 = {
    light: "var(--ds-border-input, ".concat((0, $jkuIt.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? (0, $33OLH.N100) : (0, $33OLH.N40), ")"),
    dark: "var(--ds-border-input, ".concat((0, $jkuIt.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? (0, $33OLH.DN200) : (0, $33OLH.DN40), ")")
};
var $3bb848051ed26581$export$e8320c09dc1e4012 = {
    light: "var(--ds-border-focused, ".concat((0, $33OLH.B200), ")"),
    dark: "var(--ds-border-focused, ".concat((0, $33OLH.B100), ")")
};
var $3bb848051ed26581$export$a87538d56ee366ec = {
    light: "var(--ds-border-input, transparent)",
    dark: "var(--ds-border-input, transparent)"
};
var $3bb848051ed26581$export$f4d082c200a4b4b8 = {
    light: 'transparent',
    dark: 'transparent'
};
var $3bb848051ed26581$export$32f78bffcd82ff28 = {
    light: "var(--ds-text, ".concat((0, $33OLH.N900), ")"),
    dark: "var(--ds-text, ".concat((0, $33OLH.DN600), ")")
};
var $3bb848051ed26581$export$eb4a7d363eec53c8 = {
    light: "var(--ds-text-disabled, ".concat((0, $33OLH.N70), ")"),
    dark: "var(--ds-text-disabled, ".concat((0, $33OLH.DN90), ")")
};
var $3bb848051ed26581$export$5e076b2557ef7bbb = {
    light: "var(--ds-text-subtlest, ".concat((0, $33OLH.N200), ")"),
    dark: "var(--ds-text-subtlest, ".concat((0, $33OLH.DN200), ")")
};

});



parcelRegister("gM7M2", function(module, exports) {
$parcel$export(module.exports, "emailIsValid", function () { return $9d6b21e2ca146c85$export$d50f899ba637ed24; });
// Common TLD typos that should be rejected
const $9d6b21e2ca146c85$var$INVALID_TLDS = new Set([
    'con',
    'cmo',
    'ocm',
    'coom',
    'comm',
    'comn',
    'conm',
    'coml',
    'col',
    'vom',
    'xom',
    'fom',
    'cim',
    'ckm',
    'clm',
    'nett',
    'ney',
    'met',
    'ner',
    'orgg',
    'ogr',
    'orf',
    'eduu',
    'eud',
    'govv',
    'gob',
    'ioo',
    'ino'
]);
const $9d6b21e2ca146c85$export$d50f899ba637ed24 = (value = '')=>{
    const emailMatch = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))(?<!-)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const passesRegex = emailMatch.test(value);
    const [address, domain] = value.split('@');
    if (!passesRegex || !address || !domain) return false;
    if (address.length >= 65 || domain.length >= 254) return false;
    // Check for common TLD typos
    const tld = domain.split('.').pop()?.toLowerCase();
    if (tld && $9d6b21e2ca146c85$var$INVALID_TLDS.has(tld)) return false;
    return true;
};

});


parcelRegister("1gwYE", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return $068548e1fbd9eee7$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iTHVN = parcelRequire("iTHVN");

var $gZgIU = parcelRequire("gZgIU");

var $iPPTB = parcelRequire("iPPTB");

var $1ka2O = parcelRequire("1ka2O");
const $068548e1fbd9eee7$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: 'gwp.signinForm.loginText',
        defaultMessage: '<logInLink>Log in</logInLink>'
    }, {
        logInLink: (text)=>$068548e1fbd9eee7$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
        },
        children: loginText
    });
};
const $068548e1fbd9eee7$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $gZgIU.getLoginUrl)(location)
    });
const $068548e1fbd9eee7$var$existingProductCss = null;

});

parcelRegister("hqvnx", function(module, exports) {
$parcel$export(module.exports, "Social", function () { return $43c1e1264f475ff9$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lHKk6 = parcelRequire("lHKk6");

var $jUqeL = parcelRequire("jUqeL");

var $a8iOK = parcelRequire("a8iOK");
const $43c1e1264f475ff9$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $a8iOK.useAccountSigninContext)();
    if (providers === undefined) providers = {
        google: 'Google',
        microsoft: 'Microsoft',
        apple: 'Apple',
        slack: 'Slack'
    };
    const buttons = Object.entries(providers);
    const buttonGridCss = null;
    const buttonListCss = null;
    /* eslint-disable jsx-a11y/no-redundant-roles */ /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lHKk6.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: 'social.label.signin',
                        defaultMessage: 'sign in with {provider}'
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUqeL.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};

});
parcelRegister("lHKk6", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return $9144d69d43d4b62a$export$ce671d21b66bb548; });
/* logo-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");
const $9144d69d43d4b62a$export$ce671d21b66bb548 = ({ children: children, type: type = 'button', ...rest })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: type,
        role: "link",
        ...rest,
        // Stable selector so containers (e.g. ProductOverlayTemplate)
        // can override the corner radius via CSS without prop-drilling
        // or a feature flag. Placed AFTER {...rest} so callers cannot
        // accidentally clobber the selector that ProductOverlayTemplate
        // relies on.
        "data-component": "signup-social-button",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhkvuon _19itj0fz _2rko183y _syazazsu _80omtlke _1e0c1txw _ect41kw7 _1wyb1kw7 _zulp1kwk _4t3i1ylp _1bah1h6o _ca0q1kwk _u5f3oqnp _n3td1kwk _19bvoqnp _1bsb1osq _jomr19i6 _irr319i6 _1ah3t94y",
            isDarkTheme && "_bfhkvkha _19ittf30 _syaz1afi _jomrf329 _irr3f329"
        ]),
        style: {
            "--_1mehvmr": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark200')),
            "--_vimidu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark600')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1osm7si": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark300'))
        },
        children: children
    });
};
const $9144d69d43d4b62a$var$logoButtonCss = null;
const $9144d69d43d4b62a$var$darkThemeLogoButtonCss = null;

});

parcelRegister("jUqeL", function(module, exports) {
$parcel$export(module.exports, "ProviderLogo", function () { return $28856c8ab4e34085$export$a48c0a0510fd5b7a; });
/* provider-logo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $28856c8ab4e34085$export$a48c0a0510fd5b7a = ({ logo: logo })=>{
    switch(logo){
        case 'google':
            return /*#__PURE__*/ (0, $7VQPk.jsx)($28856c8ab4e34085$export$deb5eaa840e39fbf, {});
        case 'microsoft':
            return /*#__PURE__*/ (0, $7VQPk.jsx)($28856c8ab4e34085$export$416f81fce45348, {});
        case 'apple':
            return /*#__PURE__*/ (0, $7VQPk.jsx)($28856c8ab4e34085$export$570c8af14df4c066, {});
        case 'slack':
            return /*#__PURE__*/ (0, $7VQPk.jsx)($28856c8ab4e34085$export$741d0a87d063b83b, {});
        default:
            return null;
    }
};
const $28856c8ab4e34085$export$570c8af14df4c066 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        viewBox: "0 0 170 170",
        className: (0, $2jatx.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.197-2.12-9.973-3.17-14.34-3.17-4.58 0-9.492 1.05-14.746 3.17-5.262 2.13-9.501 3.24-12.742 3.35-4.929.21-9.842-1.96-14.746-6.52-3.13-2.73-7.045-7.41-11.735-14.04-5.032-7.08-9.169-15.29-12.41-24.65-3.471-10.11-5.211-19.9-5.211-29.378 0-10.857 2.346-20.221 7.045-28.068 3.693-6.303 8.606-11.275 14.755-14.925s12.793-5.51 19.948-5.629c3.915 0 9.049 1.211 15.429 3.591 6.362 2.388 10.447 3.599 12.238 3.599 1.339 0 5.877-1.416 13.57-4.239 7.275-2.618 13.415-3.702 18.445-3.275 13.63 1.1 23.87 6.473 30.68 16.153-12.19 7.386-18.22 17.731-18.1 31.002.11 10.337 3.86 18.939 11.23 25.769 3.34 3.17 7.07 5.62 11.22 7.36-.9 2.61-1.85 5.11-2.86 7.51zM119.11 7.24c0 8.102-2.96 15.667-8.86 22.669-7.12 8.324-15.732 13.134-25.071 12.375a25.222 25.222 0 0 1-.188-3.07c0-7.778 3.386-16.102 9.399-22.908 3.002-3.446 6.82-6.311 11.45-8.597 4.62-2.252 8.99-3.497 13.1-3.71.12 1.083.17 2.166.17 3.24z"
        })
    });
const $28856c8ab4e34085$export$deb5eaa840e39fbf = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 18 18",
        className: (0, $2jatx.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z",
                fill: "#EA4335"
            })
        ]
    });
const $28856c8ab4e34085$export$416f81fce45348 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 21 21",
        className: (0, $2jatx.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#f25022",
                d: "M1 1h9v9H1z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#00a4ef",
                d: "M1 11h9v9H1z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#7fba00",
                d: "M11 1h9v9h-9z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#ffb900",
                d: "M11 11h9v9h-9z"
            })
        ]
    });
const $28856c8ab4e34085$export$741d0a87d063b83b = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 127 127",
        className: (0, $2jatx.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.2 80c0 7.3-5.9 13.2-13.2 13.2C6.7 93.2.8 87.3.8 80c0-7.3 5.9-13.2 13.2-13.2h13.2V80zm6.6 0c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V80z",
                fill: "#E01E5A"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47 27c-7.3 0-13.2-5.9-13.2-13.2C33.8 6.5 39.7.6 47 .6c7.3 0 13.2 5.9 13.2 13.2V27H47zm0 6.7c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H13.9C6.6 60.1.7 54.2.7 46.9c0-7.3 5.9-13.2 13.2-13.2H47z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M99.9 46.9c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H99.9V46.9zm-6.6 0c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V13.8C66.9 6.5 72.8.6 80.1.6c7.3 0 13.2 5.9 13.2 13.2v33.1z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M80.1 99.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V99.8h13.2zm0-6.6c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2h33.1c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H80.1z",
                fill: "#ECB22E"
            })
        ]
    });
const $28856c8ab4e34085$var$logoCss = null;

});


parcelRegister("68EbF", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return $adf7944ee245ec94$export$2c4cf1f7b42ef78c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $lmQGF = parcelRequire("lmQGF");

var $a8iOK = parcelRequire("a8iOK");
const $adf7944ee245ec94$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $a8iOK.useAccountSigninContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: 'gwp.accountSignin.submit',
        defaultMessage: 'Log in'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || formError,
        isFullWidth: true,
        isLoading: isSubmitting || formError,
        onClick: onClickSubmitButton,
        children: buttonText
    });
};

});
parcelRegister("lmQGF", function(module, exports) {
$parcel$export(module.exports, "Adg4Button", function () { return $6d38715d06a4a11b$export$d72da1e82b9a8118; });
/* button.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $7qFQI = parcelRequire("7qFQI");

var $jQ0cd = parcelRequire("jQ0cd");
const $6d38715d06a4a11b$var$getButtonSize = (size)=>{
    const buttonSize = size;
    if (buttonSize && buttonSize === 'small') return 'small';
    return 'large';
};
const $6d38715d06a4a11b$var$getButtonVariant = (type)=>{
    const buttonType = type;
    if (buttonType === 'secondary') return 'secondary';
    return 'primary';
};
const $6d38715d06a4a11b$var$isButtonColor = (color)=>{
    return color === 'blue' || color === 'yellow' || color === 'white' || color === 'black' || color === 'light_grey';
};
const $6d38715d06a4a11b$var$getButtonColor = (color, variant)=>{
    const buttonColor = color;
    if (buttonColor && $6d38715d06a4a11b$var$isButtonColor(buttonColor)) {
        if (variant === 'primary') {
            if (buttonColor === 'blue' || buttonColor === 'yellow' || buttonColor === 'light_grey') return buttonColor;
            else return 'blue';
        } else {
            if (buttonColor === 'black' || buttonColor === 'white' || buttonColor === 'light_grey') return buttonColor;
            else return 'black';
        }
    }
    return 'blue';
};
const $6d38715d06a4a11b$var$isColorAgainst = (color)=>{
    return color === 'black' || color === 'other';
};
const $6d38715d06a4a11b$var$getColorAgainst = (color)=>{
    const colorAgainst = color;
    if (colorAgainst && $6d38715d06a4a11b$var$isColorAgainst(colorAgainst)) return colorAgainst;
    return 'black';
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6d38715d06a4a11b$var$buttonPrimaryStyles = {
    primary_blue: "_syazu67f _bfhkdoyu _19itglyw _mizudoyu _ra3xnqa1 _128myh40 _irr36tgj",
    primary_yellow: "_syazqlpt _bfhkh727 _19itglyw _mizudoyu _ra3xnqa1 _128myh40 _irr31m13",
    primary_light_grey: "_syazqlpt _bfhk1ret _19itglyw _mizudoyu _ra3xnqa1 _128myh40 _irr31fkg",
    secondary_white_against_black: "_syazu67f _bfhk1j28 _19ithba0 _mizuu67f _ra3xnqa1 _128myh40 _irr3jy62",
    secondary_white_against_other: "_syazu67f _bfhk1j28 _19ithba0 _mizuu67f _ra3xnqa1 _128myh40 _irr31u7u _ufqu1n0t",
    secondary_black: "_syazqlpt _bfhk1j28 _19itburr _mizudoyu _ra3xnqa1 _128myh40 _irr317fj",
    secondary_light_grey: "_syazqlpt _bfhk1ret _19itburr _mizudoyu _ra3xnqa1 _128myh40 _irr31fkg"
};
const $6d38715d06a4a11b$var$baseStyles = null;
const $6d38715d06a4a11b$var$fontAndHeightStyles = {
    large: "_1wyb1k92 _vwz41k8s _4t3i184x _1tke1ady _1ul968cl",
    small: "_1wyb1j6v _vwz41k92 _4t3i184x _1tke1ylp _1ul953f4 _p12f122r"
};
const $6d38715d06a4a11b$var$fullWidthStyles = null;
const $6d38715d06a4a11b$var$disabledStyles = null;
function $6d38715d06a4a11b$var$isLinkArgs(props) {
    return 'href' in props;
}
const $6d38715d06a4a11b$var$isSignInUrl = (href)=>{
    const baseUrl = "https://id.atlassian.com";
    const stargateBaseUrl = "https://www.atlassian.com/gateway/api";
    const continueUrl = stargateBaseUrl + '/start/authredirect';
    const signInUrl = `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}`;
    // Check if href matches sign-in URL with or without application parameter, or is start-trial
    return href === signInUrl || href.startsWith(signInUrl + '&application=') || href === '#start-trial';
};
const $6d38715d06a4a11b$var$isNonSigninOrWacUrl = (href)=>{
    return !(0, $jQ0cd.isLocalizableHref)(href) && !$6d38715d06a4a11b$var$isSignInUrl(href);
};
const $6d38715d06a4a11b$export$d72da1e82b9a8118 = ({ variant: variant, color: color, colorAgainst: colorAgainst, size: size, className: className, children: children, dataEventProps: dataEventProps, isLoading: isLoading, isDisabled: isDisabled = false, isFullWidth: isFullWidth = false, ...props })=>{
    const isLink = $6d38715d06a4a11b$var$isLinkArgs(props);
    const buttonVariant = $6d38715d06a4a11b$var$getButtonVariant(variant);
    const buttonColor = $6d38715d06a4a11b$var$getButtonColor(color, buttonVariant);
    const buttonColorAgainst = $6d38715d06a4a11b$var$getColorAgainst(colorAgainst);
    const buttonSize = $6d38715d06a4a11b$var$getButtonSize(size);
    const styles = buttonVariant === 'secondary' && buttonColor === 'white' ? `${buttonVariant}_${buttonColor}_against_${buttonColorAgainst}` : `${buttonVariant}_${buttonColor}`;
    const variantStyles = $6d38715d06a4a11b$var$buttonPrimaryStyles[styles];
    const fontAndHeightStyle = $6d38715d06a4a11b$var$fontAndHeightStyles[buttonSize];
    const appearance = $6d38715d06a4a11b$var$getButtonVariant(variant) === 'secondary' ? 'inherit' : 'invert';
    const handleOnClick = (e)=>{
        if (isDisabled) e.preventDefault();
        else if (props.onClick) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        props.onClick(e);
    };
    return isLink ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1bah1h6o _vchhusvi _1e0c116y _k48pbfng _ect4lnmy _vwz41k8s _ca0q19bv _u5f31tcg _n3td19bv _19bv1tcg _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1ylp _v564fnf5 _1ah31y44 _d0altlke",
            $6d38715d06a4a11b$var$buttonPrimaryStyles[styles],
            $6d38715d06a4a11b$var$fontAndHeightStyles[buttonSize],
            isFullWidth && "_1bsb1osq _p12fglyw",
            isDisabled && "_d0al13gf _irr314je _30l3u67f _bfw7glyw _bfhk14je _syazu67f _19itglyw",
            className
        ]),
        ...props,
        ...dataEventProps,
        onClick: handleOnClick,
        href: props.href,
        target: typeof props.target === 'string' ? props.target : props.href && /* redirecting to new tab if the href is not on WAC and not a Signin link */ $6d38715d06a4a11b$var$isNonSigninOrWacUrl(props.href) ? '_blank' : '',
        rel: props.href && $6d38715d06a4a11b$var$isNonSigninOrWacUrl(props.href) ? 'noreferrer' : '',
        children: children
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1bah1h6o _vchhusvi _1e0c116y _k48pbfng _ect4lnmy _vwz41k8s _ca0q19bv _u5f31tcg _n3td19bv _19bv1tcg _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1ylp _v564fnf5 _1ah31y44 _d0altlke",
            $6d38715d06a4a11b$var$buttonPrimaryStyles[styles],
            $6d38715d06a4a11b$var$fontAndHeightStyles[buttonSize],
            isFullWidth && "_1bsb1osq _p12fglyw",
            isDisabled && "_d0al13gf _irr314je _30l3u67f _bfw7glyw _bfhk14je _syazu67f _19itglyw",
            className
        ]),
        disabled: isLoading || isDisabled,
        ...props,
        ...dataEventProps,
        onClick: handleOnClick,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            interactionName: "load",
            label: "Loading",
            appearance: appearance
        }) : children
    });
}; /* eslint-enable complexity */ 

});






parcelRegister("kNyc7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $361ba234fe5b0903$export$2e2bcd8739ae039; });
/* auto-complete-search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bZmYH = parcelRequire("bZmYH");

var $92PV0 = parcelRequire("92PV0");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $dE0sS = parcelRequire("dE0sS");

var $jsxHL = parcelRequire("jsxHL");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $1Q6XY = parcelRequire("1Q6XY");

var $iEjCK = parcelRequire("iEjCK");

var $bj0AD = parcelRequire("bj0AD");

var $9bvfr = parcelRequire("9bvfr");
const $361ba234fe5b0903$var$aaAutoCompContainerPanelStyle = null;
const $361ba234fe5b0903$var$aaFormStyle = null;
const $361ba234fe5b0903$var$aaInputWrapperPrefixStyle = null;
const $361ba234fe5b0903$var$aaInputWrapperPrefixStyleWithFeatureFlag = null;
const $361ba234fe5b0903$var$aaLabelStyle = null;
const $361ba234fe5b0903$var$aaSubmitButtonStyle = null;
const $361ba234fe5b0903$var$aaInputWrapperStyle = null;
const $361ba234fe5b0903$var$aaInputWrapperStyleWithFeatureFlag = null;
const $361ba234fe5b0903$var$aaInputStyle = null;
const $361ba234fe5b0903$var$aaInputWrapperSuffixStyle = null;
const $361ba234fe5b0903$var$aaInputWrapperSuffixStyleWithFeatureFlag = null;
const $361ba234fe5b0903$var$aaCrossIconStyle = null;
const $361ba234fe5b0903$var$aaClearButtonStyle = null;
const $361ba234fe5b0903$var$aaPanelLayoutStyle = null;
const $361ba234fe5b0903$var$aaSourceStyle = null;
const $361ba234fe5b0903$var$aaListStyle = null;
const $361ba234fe5b0903$var$SearchBaraaFormaaFormFocusStyle = null;
const $361ba234fe5b0903$var$searchBarInputWrapperStyle = null;
const $361ba234fe5b0903$var$searchBarInputWrapperStyleWithFeatureFlag = null;
const $361ba234fe5b0903$var$searchBarStyle = null;
const $361ba234fe5b0903$var$searchBarMobileStyle = null;
const $361ba234fe5b0903$var$searchBarMobileFullWidthStyle = null;
const $361ba234fe5b0903$var$searchBarMobileProductNavStyle = null;
const $361ba234fe5b0903$var$searchBarMobileProductNavButtonMatchStyle = null;
const $361ba234fe5b0903$var$seeAllButtonStyle = null;
const $361ba234fe5b0903$var$aiEnabledSearchIconCss = null;
const $361ba234fe5b0903$var$aiEnabledClearButtonCss = null;
const $361ba234fe5b0903$var$AutoCompleteSearchBar = ({ isOpenSearch: isOpenSearch, setIsOpenSearch: setIsOpenSearch, isMobileView: isMobileView = false, aiEnabled: aiEnabled = false, onFocus: onFocus, readOnly: readOnly = false, parentType: parentType = 'GlobalNav', menuPage: menuPage, fullWidth: fullWidth = false, matchButtonSize: matchButtonSize = false })=>{
    const intl = (0, $8e22h.default)();
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(null);
    const formRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(null);
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(null);
    const lastTrackedQueryRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $izdHQ.useFeatureExposed)('wac-search-indexv3', 'Test');
    const isSearchIndexV3_2Enabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacSearchIndexV3_2);
    const hitsPerPageObject = {
        hitsPerPage: 7
    };
    const isAnalyticsEnabled = (0, $1Q6XY.shouldEnableAlgoliaAnalytics)();
    const queryParams = {
        facetFilters: [
            `locale:${intl.locale ?? 'en'}`
        ],
        clickAnalytics: isAnalyticsEnabled,
        // enables click analytics
        attributesToRetrieve: [
            'url',
            'title',
            'description',
            'locale',
            'category',
            'objectID'
        ],
        ...hitsPerPageObject,
        ...aiEnabled ? {
            restrictSearchableAttributes: [
                'title'
            ],
            minProximity: 2
        } : {}
    };
    const { autocompleteState: autocompleteState, autocomplete: autocomplete } = (0, $9bvfr.default)({
        searchIndex: isSearchIndexV3_2Enabled ? (0, $1Q6XY.activeSearchIndexV3_2) : (0, $1Q6XY.activeSearchIndexV3),
        ALGOLIA_FACET_KEY: $1Q6XY.ALGOLIA_FACET_KEY,
        ALGOLIA_APP_ID: $1Q6XY.ALGOLIA_APP_ID,
        ALGOLIA_SEARCH_API_KEY: $1Q6XY.ALGOLIA_SEARCH_API_KEY,
        queryParams: queryParams,
        aiEnabled: aiEnabled
    });
    const { getEnvironmentProps: getEnvironmentProps } = autocomplete;
    (0, $1oC0p.useEffect)(()=>{
        if (isOpenSearch) {
            if (inputRef.current) inputRef.current.focus();
        }
    }, [
        isOpenSearch
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!formRef.current || !panelRef.current || !inputRef.current) return undefined;
        const { onTouchStart: onTouchStart, onTouchMove: onTouchMove, onMouseDown: onMouseDown } = getEnvironmentProps({
            formElement: formRef.current,
            inputElement: inputRef.current,
            panelElement: panelRef.current
        });
        window.addEventListener('mousedown', onMouseDown);
        window.addEventListener('touchstart', onTouchStart);
        window.addEventListener('touchmove', onTouchMove);
        return ()=>{
            window.removeEventListener('mousedown', onMouseDown);
            window.removeEventListener('touchstart', onTouchStart);
            window.removeEventListener('touchmove', onTouchMove);
        };
    }, [
        getEnvironmentProps,
        autocompleteState.isOpen
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(()=>{
        if (!readOnly && inputRef.current) inputRef.current.focus();
    }, [
        readOnly
    ]);
    const isNotEmptyQuery = (searchQuery)=>searchQuery.length > 0;
    const searchPagePath = (0, $jQ0cd.useLocalizedHref)(`/search?q=${autocompleteState.query || ''}`);
    const handleSearchFormSubmit = (event)=>{
        event.preventDefault();
        if (isNotEmptyQuery(autocompleteState.query)) {
            createAnalyticsEvent({
                eventName: 'submitSearchForm',
                eventType: 'ui',
                action: 'submitted',
                actionSubject: 'search',
                actionSubjectId: 'globalNavSearchBar',
                eventContainer: 'globalNavSearchBar',
                source: 'globalNav',
                attributes: {
                    product: 'search',
                    pageUrl: window.location.href,
                    pagePath: window.location.pathname
                }
            }).fire();
            window.location.assign(searchPagePath);
        }
    };
    const handleRenderAutocompleteResult = (item, source)=>{
        // check if any product landing pages have the same url
        // as the result from Algolia.
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bj0AD.DefaultAutocompleteResult), {
            item: item,
            source: source,
            autocomplete: autocomplete,
            isMobileView: isMobileView
        });
    };
    const { dropdownAnnouncement: dropdownAnnouncement } = (0, $1Q6XY.useA11yDropdownAnnouncement)({
        resultsCount: autocompleteState.collections.filter((collection)=>collection.source.sourceId !== 'ai-assistant').reduce((total, collection)=>total + collection.items.length, 0),
        searchTerm: autocompleteState.query
    });
    (0, $1oC0p.useEffect)(()=>{
        if (!autocompleteState.query) {
            lastTrackedQueryRef.current = '';
            return;
        }
        if (lastTrackedQueryRef.current === autocompleteState.query) return;
        // Ensure that the algolia search has finished loading before firing the analytics event
        if (autocompleteState.status === 'loading' || autocompleteState.status === 'stalled') return;
        // Debounce the analytics event to prevent firing until the user has stopped typing
        let queryId = autocompleteState.collections[0]?.items[0]?.queryID || null;
        if (aiEnabled) // AI Result is considered collection 0 so we need to get the query ID from the second collection
        queryId = autocompleteState.collections[1]?.items[0]?.queryID || null;
        const timeoutId = setTimeout(()=>{
            createAnalyticsEvent({
                eventName: 'displayAutocompleteSearchResults',
                eventType: 'ui',
                action: 'displayed',
                actionSubject: 'search',
                actionSubjectId: 'globalNavAutoCompleteResults',
                eventContainer: 'globalNavSearchBar',
                source: 'globalNav',
                attributes: {
                    product: 'search',
                    pageUrl: window.location.href,
                    pagePath: window.location.pathname,
                    resultsCount: autocompleteState.collections.reduce((total, collection)=>total + collection.items.length, 0),
                    queryId: queryId,
                    searchQuery: autocompleteState.query,
                    searchIndex: 'v3'
                }
            }).fire();
            lastTrackedQueryRef.current = autocompleteState.query;
        }, 500);
        return ()=>clearTimeout(timeoutId);
    }, [
        autocompleteState.query,
        autocompleteState.collections,
        autocompleteState.status,
        createAnalyticsEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (autocompleteState.isOpen && aiEnabled) (0, $92PV0.Tracking).autoTrackLinks(true);
    }, [
        autocompleteState.isOpen,
        aiEnabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syazvkha _ect41kw7 _1wyb7vkz _k48p1nn1 _vwz41x4e _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1e5h",
                isMobileView && (parentType === 'ProductNav' || parentType === 'GlobalNav') ? matchButtonSize ? "_1bsb1osq _1bah1h6o _kqswh2mm _1pfhftgi _6rthftgi" : fullWidth ? parentType === 'ProductNav' ? "_1bsb1osq _1bah1h6o _kqswh2mm _1q511tcg _85i51tcg _y4tiidpf _bozgidpf" : "_1bsb1osq _1bah1h6o _kqswh2mm" : "_1bsb1osq _1bah1h6o _85i51tcg" : "_kqswh2mm _u7coidpf _ahbqgktf _12l2gktf _1bsb1wug _p12f1osq _1pbyqfx8 _1e0c1ule _1bah1h6o",
                "aa-Autocomplete"
            ]),
            "data-testid": "aa-Autocomplete",
            style: {
                "--_1mehvmr": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark200'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                    ref: formRef,
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _bfhk1afi _19it1baz _2rko1l7b _1e0c1txw _vwz41x4e _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _1bsb1osq _858uxxzy _7ehiqzde",
                        "_19itglyw _1h6d1j28 _12ji1j28 _1qu2nqa1 _12y31o36 _16qsglyw",
                        isMobileView && (parentType === 'GlobalNav' || parentType === 'ProductNav') && menuPage === 'search' && "_85i51tcg",
                        isMobileView && parentType === 'ProductNav' && (fullWidth || matchButtonSize) && "_4t3i14no",
                        "aa-Form"
                    ]),
                    ...autocomplete.getFormProps({
                        inputElement: inputRef.current
                    }),
                    onSubmit: handleSearchFormSubmit,
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                isMobileView ? "_4cvr1h6o _1e0c1txw _1o9zidpf _4t3ickbl _1f49kb7n" : "_4cvr1h6o _1e0c1txw _1o9zidpf _4t3ior1b _1f49kb7n",
                                isMobileView && parentType === 'ProductNav' && (fullWidth || matchButtonSize) && "_4t3i14no",
                                "aa-InputWrapperPrefix"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                isMobileView ? "_1f4911wp _kqswh2mm _1bsb1osq _4t3ickbl" : "_1f4911wp _kqswh2mm _1bsb1osq _4t3ior1b",
                                isMobileView ? "_kqswh2mm _1e0c1txw _s7n4nkob _4cvr1h6o _4t3iyn4p _1dqonqa1 _ca0qidpf _u5f31tcg _n3tdidpf _19bv1tcg _2rko16uj _1h6dg7ng _bfhkg7ng" : "_kqswh2mm _1e0c1txw _s7n4nkob _4cvr1h6o _4t3iahaf _189et94y _1dqonqa1 _2rko16uj _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _1h6dg7ng _bfhkg7ng",
                                isMobileView && parentType === 'ProductNav' && (fullWidth || matchButtonSize) && "_4t3i14no",
                                "aa-InputWrapper"
                            ]),
                            style: {
                                "--_1lg4sj9": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light100'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    className: (0, $2jatx.default)([
                                        "_r06hglyw _11q7glyw _19itidpf _syaz1pfd _11c81kw7 _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1n5du5k9 _858uglyw _7ehiglyw _nt751r31 _49pcglyw _1hvw1o36 _1idr1ezn _1wfakb7n _lu7aglyw _q1fpglyw _1av4glyw _14jrglyw",
                                        "aa-Input"
                                    ]),
                                    "aria-label": "Search by Keywords",
                                    "data-testid": "aa-Input",
                                    ref: inputRef,
                                    readOnly: readOnly,
                                    ...autocomplete.getRootProps({}),
                                    ...autocomplete.getInputProps({
                                        inputElement: inputRef.current,
                                        onFocus: ()=>{
                                            onFocus?.();
                                        }
                                    }),
                                    "aria-labelledby": undefined,
                                    style: {
                                        "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
                                        "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700')),
                                        "--_xluqsf": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark500'))
                                    }
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                    className: (0, $2jatx.default)([
                                        "_80om1wug _1o9zidpf _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1e5h",
                                        "aa-Label"
                                    ]),
                                    ...autocomplete.getLabelProps({}),
                                    htmlFor: "autocomplete"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    className: (0, $2jatx.default)([
                                        "_4t3i1osq _bozg1skh _y4tiftgi _1bsbfhn8 _19itglyw _11q7glyw _vwz4kb7n",
                                        aiEnabled && "_w8l51tcg _17521tcg _d4kss3kk",
                                        "aa-SubmitButton"
                                    ]),
                                    "data-testid": "search-submit-button",
                                    "aria-label": intl.formatMessage({
                                        id: 'globalnav.search.submit-button',
                                        defaultMessage: 'Submit search'
                                    }),
                                    type: "submit",
                                    title: "Submit",
                                    disabled: !isNotEmptyQuery(autocompleteState.query),
                                    style: {
                                        "--_1xfz4lx": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light400'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                                        label: 'search label',
                                        size: "medium"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                isMobileView ? "_4cvr1h6o _1e0c1txw _4t3ickbl _1f49egat" : "_4cvr1h6o _1e0c1txw _4t3ior1b _1f49egat",
                                isMobileView && parentType === 'ProductNav' && (fullWidth || matchButtonSize) && "_4t3i14no",
                                "aa-InputWrapperSuffix"
                            ]),
                            children: !isMobileView ? /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _11q7glyw _19itidpf _80omtlke _1e0c1txw _4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvzwfg _xqg4glyw",
                                    aiEnabled && "_d4ks1pfd",
                                    "aa-ClearButton"
                                ]),
                                "data-testid": "search-close-button",
                                "aria-label": intl.formatMessage({
                                    id: 'globalnav.search.close-button',
                                    defaultMessage: 'Close search input field'
                                }),
                                title: "Close",
                                type: "reset",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    if (setIsOpenSearch) {
                                        setIsOpenSearch(false);
                                        lastTrackedQueryRef.current = '';
                                        createAnalyticsEvent({
                                            eventName: 'searchClose',
                                            eventType: 'ui',
                                            action: 'clicked',
                                            actionSubject: 'button',
                                            actionSubjectId: 'searchCloseButtonDesktop',
                                            source: 'globalNav',
                                            attributes: {
                                                product: 'search',
                                                pageUrl: window.location.href,
                                                pagePath: window.location.pathname
                                            }
                                        }).fire();
                                    }
                                },
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                                    size: "20",
                                    className: (0, $2jatx.default)([
                                        "_syazp4k8 _f8pjvkha _30l3vkha"
                                    ]),
                                    style: {
                                        "--_1aetymw": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light500')),
                                        "--_1mehvmr": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark200'))
                                    }
                                })
                            }) : null
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Q6XY.HiddenAriaLiveAnnouncement), {
                    children: dropdownAnnouncement
                }),
                autocompleteState.isOpen && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bj0AD.AutoCompleteResultsDropdown), {
                    isMobileView: isMobileView,
                    panelRef: panelRef,
                    autocompleteState: autocompleteState,
                    autocomplete: autocomplete,
                    aiEnabled: aiEnabled,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _c71lstmo _18m91wug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _y3gn1e5h _fiawglyw",
                                "aa-PanelLayout"
                            ]),
                            "data-testid": "aa-PanelLayout",
                            children: autocompleteState.collections.map((collection, index)=>{
                                const { source: source, items: items } = collection;
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _1bsb1osq _fiawglyw",
                                        "aa-Source"
                                    ]),
                                    children: items.length > 0 && /*#__PURE__*/ (0, $1oC0p.createElement)("ul", {
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                                            "aa-List"
                                        ]),
                                        ...autocomplete.getListProps(),
                                        key: `list-${items.length}`
                                    }, items.slice(0, isMobileView ? 5 : items.length).map((item)=>{
                                        if (source.sourceId === 'ai-assistant') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iEjCK.default), {
                                            query: autocompleteState.query,
                                            autocomplete: autocomplete,
                                            source: source,
                                            item: item
                                        }, item.objectID);
                                        return handleRenderAutocompleteResult(item, source);
                                    }))
                                }, `source-${index}`);
                            })
                        }),
                        aiEnabled && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            onMouseEnter: ()=>{
                                autocomplete.setActiveItemId(null);
                            },
                            onFocus: ()=>{
                                autocomplete.setActiveItemId(null);
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                text: intl.formatMessage({
                                    id: 'globalnav.searchresult.see-all',
                                    defaultMessage: 'See all'
                                }),
                                href: '/search?q=' + autocompleteState.query,
                                type: 'primary',
                                dataEventProps: {
                                    'data-product-key': 'search',
                                    'data-event': 'clicked',
                                    'data-event-component': 'linkButton',
                                    'data-event-container': 'globalNavSearchResult',
                                    'data-label-english': 'See all'
                                },
                                // ariaLabel prop does not satisfy eslint@atlassian/a11y/anchor-has-content rule
                                "aria-label": intl.formatMessage({
                                    id: 'globalnav.searchresult.see-all',
                                    defaultMessage: 'See all'
                                }),
                                className: (0, $2jatx.default)([
                                    "_bozgftgi _1q511y44"
                                ])
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $361ba234fe5b0903$export$2e2bcd8739ae039 = $361ba234fe5b0903$var$AutoCompleteSearchBar;

});
parcelRegister("bZmYH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c2ea3862f75cebada30b1178c22cdb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ba73725c57b607d$var$_react = $8ba73725c57b607d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8ba73725c57b607d$var$_baseNew = $8ba73725c57b607d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8ba73725c57b607d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ba73725c57b607d$var$SearchIcon = (props)=>/*#__PURE__*/ $8ba73725c57b607d$var$_react.default.createElement($8ba73725c57b607d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$8ba73725c57b607d$var$SearchIcon.displayName = 'SearchIcon';
var $8ba73725c57b607d$var$_default = module.exports.default = $8ba73725c57b607d$var$SearchIcon;

});

parcelRegister("jsxHL", function(module, exports) {
$parcel$export(module.exports, "TypographyStyles", function () { return $70605651e47248b8$export$9b8951af549c970c; });
/* typography-styles.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $i4BST = parcelRequire("i4BST");
// Create a context to track if we're inside TypographyStyles
const $70605651e47248b8$var$TypographyStylesContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
// FY24 rebrand type matrix rules as per https://www.figma.com/file/RZRs55BkCWtX6zBPUD7dRb/Type-Matrix-React---FY24-Updates?type=design&node-id=323-741&mode=design&t=7RUZPtxLZpLvX1Q5-0
// Colors are set via CSS custom properties (--wac-color-heading, --wac-color-body) defined in
// index.css so they can be overridden in any scope without specificity battles.
const $70605651e47248b8$var$typographyStyles = null;
// These styles are being added for Team 26 and the WAC Refresh design
const $70605651e47248b8$var$typographyStylesRefresh = null;
const $70605651e47248b8$export$9b8951af549c970c = ({ children: children })=>{
    const isInsideTypographyStyles = (0, $1oC0p.useContext)($70605651e47248b8$var$TypographyStylesContext);
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    // If we're already inside TypographyStyles, just render children without the styles
    if (isInsideTypographyStyles) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: children
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($70605651e47248b8$var$TypographyStylesContext.Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_sx0t1vau _cadt1vau _7mla9y44 _1twl9y44 _kzxweipq _1ndaeipq _1dc68pqr _1vfh8pqr _1xen1p2n _1xd21p2n _apnwyn4p _1av5yn4p _1rij1tnc _fumj1tnc _1gk31wto _12nw1wto _1he11k7u _1e6q1k7u _a4kb1nn1 _bj019y44 _10z61vau _ajao1vau _1ka71vau _zi0u1vau _1ja01tnc _1aeo1tnc _1xgm1tnc _1by31tnc _swwc1b9w _sok01b9w _1gif1b9w _utzm1b9w _1s4zeipq _m1ddeipq _foqreipq _e14veipq _5l4c1b9w _ic9o1b9w _ah2z1b9w _i34u1b9w _3yh317rr _10t417rr _9yoj17rr _5wuc17rr _fswh17rr _4him17rr _1mnb17rr _7ubc17rr _vds11lev _1xnk1lev _1eew1lev _18ak1lev _39zl9y44 _17im9y44 _1law1nn1 _foqb1nn1 _u5ox9y44 _akm39y44 _6pwu1vau _8v2f1vau _8v6f1fw0 _l5k11fw0 _1ikbeipq _cg41eipq _oh64viql _11ebviql _190011uf _17z411uf _1qlfahaf _1x1pahaf _ck5d13ei _mykc13ei _gu0r8pqr _j2698pqr _jl5x1wto _o9hx1wto _2fvj1vau _1yzi1vau _180l1fw0 _r8nt1fw0 _1r0meipq _qliyeipq _1myo1k8s _ggmh1k8s _152fl07h _1axil07h _1s7u1m1q _j9zg1m1q _qmitc5mb _3gzzc5mb _ui58viql _1xemviql _156e11uf _16kz11uf _1t621vau _16011vau _7j3v1fw0 _1a7k1fw0 _1rs4eipq _1rhqeipq _gzon1k92 _8kc91k92 _15ds1slo _1euy1slo _1t31imiu _1c8simiu _tj9o1m1q _1unv1m1q _8vtt1k8s _1syp1k8s _54uzl07h _1svhl07h _1l3g1vau _qen61vau _bsqx1fw0 _5gkf1fw0 _i7q91cby _wm401cby _12xf1slo _c9nz1slo _1gngeipq _jl6weipq _rwey1k92 _1rnl1k92 _1ha11m1q _2vke1m1q _5j9p1vau _1w2a1vau _gntg1fw0 _1kwr1fw0 _ejce1j6v _1p6o1j6v _1b2m1k8s _1lbi1k8s _ifsueipq _s974eipq _c54kzzfg _1rsbviql _15i811uf _14ek1fw0 _1gugahaf _5akr13ei _9zyt1fw0 _1vw88pqr _195p1wto _tgd81fw0 _3hsgd0co _tj7d82ui _1l99ni7l _w0jiz4z1 _1ljg1nn1 _1i7t1cby _18f11slo _9wqll3em _160r1k92 _1viv1m1q _1tkfz4z1 _1csaz4z1 _gwfg1nn1 _1adi1nn1 _1an71j6v _q7gq1j6v _dxjr1k8s _zcqx1k8s _1loel3em _125xl3em _1pwoz4z1 _bcfk1nn1 _1716oxwj _gp0i1k92 _16j4l3em _qdle1vau _9k4q1k92 _1eo61fw0 _2o921slo _v8gmeipq _yslqnl7k _l4z7imiu _v1cc1m1q _1yvs1k8s _4254l07h _148i1vau _1xq41cby _1jdh1fw0 _laz51k8s _12pweipq _8oxmnl7k _1gx11k92 _3k0a1slo _1xz2z4z1 _eyym1nn1 _1a8noqnp _imba1cby _1jssl3em _huy7z4z1 _1h5p1nn1 _fz4hud5o _bdb31j6v _gjl4l3em _sss8z4z1 _duut1j6v _1xie1k8s _1givni7l _12ikl3em _1pvkz4z1 _878r1fw0 _18eb1j6v _14xe1k8s _rvtmangw _x3e9l3em _whptz4z1 _18nk1nn1 _1kn5oxwj _gday1cby _amuvangw _iwqyl3em _960kz4z1 _z2l31nn1 _1ekkoqnp _19f51j6v _11cbangw _d51rl3em _1f0m1vau _1791owjs _136l1k92 _18ck1m1q _mh6cl3em _1y721k8s _8m8fviql _1nfg1nn1 _1aaq1m1q _117r8pqr _sxjn1vau _1msfowjs _1a0x1m1q _19tl8pqr _7324l3em _1vswviql _1o7pyn4p _yczd1nn1 _1j59ahaf _1dsu1wto _p5bk1vau _hrlh9y44 _2w9e5hrz _1hj917rr _bn9a1lev _12bg1b9w _fb2a17rr _1ja81tnc _1nm51b9w _110f1vau _1wp09y44 _jb775hrz _1qq08pqr _159b1p2n _psrdyn4p _7exb1tnc _n6o61wto _980q1k7u",
                isWacRefresh && "_j49pbfng _1iojbfng _1m0cwebb _wseowebb _l82782ui _tsvr82ui _ngmq1vau _13oqni7l _v09i12bs _v19zd0co _101hwebb _3upf82ui _jeyf1n1a _19o3gad4 _lvg1ts0x _vpn21n1a _q8wv1mu5 _13j81ymo _1o141n1a _39zlni7l _1k8410uk _je9v10uk _1q7o10uk _xrj010uk _91g3bfng _8tivbfng _8ywyd0co _1ns7d0co _14hk82ui _dlm982ui _gz4jbfng _1sxubfng _rvs0qf5o _1ty6qf5o _18641b9w _12bs1b9w _gzhbbfng _nd8pbfng _ph9k8pqr _1d058pqr _1yph1wto _1sbq1wto _kyd9bfng _fb01bfng _11ceviql _1r9hviql _7mm28pqr _16v18pqr _660qbfng _avz5bfng _reey1k8s _16o71k8s _4nv6viql _1w6qviql _1c571k8s _15upviql _inuobfng _1pjc1k8s _1obyviql _1qoq1cby _cbmh1cby _1rdd1slo _17bi1slo _65fvni7l _d2pu1cby _l2q01slo _19211j6v _1db41k8s _1wvfbfng _1i8w8pqr _x4tg1wto _1rl0bfng _jk351k8s _n7moviql _hmq8oxwj _aheuahaf _1yfrz4z1 _y6qg1cby _b4741slo _1x9sbfng _klortxnc _1lvt1n0t _1rxq1ck0 _a69k1n0t _3w3x105o _1c9m1n0t _ye88glyw _3brfftgi _koidnqa1 _1z0fyh40 _ptg8yh40 _1nsb1kw7 _hto51k92 _jveu1k8s _192xz4z1 _x0mr1j6v _1t9j1k8s _1pdzbfng _ft8ftxnc _1o281n0t _1hf61ck0 _1m221n0t _qw42105o _tgv21n0t _llcwglyw _3nkeftgi _11slnqa1 _74ljyh40 _1gyhyh40 _ajgu1kw7 _d7ek1cby _kw8i1slo _10afz4z1 _1af4oxwj _1ybz1k92 _1saqbfng _rd8btxnc _1ud81n0t _10qu1ck0 _qdya1n0t _1h8m105o _19iy1n0t _1hv1glyw _17yaftgi _187knqa1 _igjzyh40 _dhwryh40 _1o591kw7 _tflm1j6v _f1ek1k8s _878rbfng _18eb1j6v _14xe1cby _1y9v1u7z _do0m1cby _s8sq1slo _18nkbfng _19w31u7z _1gwo1j6v _x0o41k8s _z2l3bfng _gdv41u7z _1v0yoxwj _16hj1cby _17911nn1 _xjm0viql _1az08pqr _1msf1nn1 _1bq28pqr _wxjnqf5o _1wv11vau _kkvj1nn1 _re4y1cby _1b9j1slo _8an3l3em _w6sf1k92 _1gb31m1q _12um1k8s _1dtaviql _qsea1m1q _1aj88pqr"
            ]),
            style: {
                "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display')),
                "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
                "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
            },
            children: children
        })
    });
};

});

parcelRegister("1Q6XY", function(module, exports) {
$parcel$export(module.exports, "ALGOLIA_APP_ID", function () { return $c40342c1af869cf5$export$17b978e8ab9e4c58; });
$parcel$export(module.exports, "ALGOLIA_SEARCH_API_KEY", function () { return $c40342c1af869cf5$export$ac6f6796ae1ab0c1; });
$parcel$export(module.exports, "ALGOLIA_FACET_KEY", function () { return $c40342c1af869cf5$export$b23c3af39ccf497d; });
$parcel$export(module.exports, "activeSearchIndexV3", function () { return $c40342c1af869cf5$export$b337d69b7a65e111; });
$parcel$export(module.exports, "activeSearchIndexV3_2", function () { return $c40342c1af869cf5$export$a3935c9976467739; });
$parcel$export(module.exports, "AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY", function () { return $c40342c1af869cf5$export$5049c8654c52de2a; });
$parcel$export(module.exports, "sendConversionEventAlgolia", function () { return $c40342c1af869cf5$export$b887d873139badc3; });
$parcel$export(module.exports, "handleAlgoliaConversionMetrics", function () { return $c40342c1af869cf5$export$120e7b764d5fde54; });
$parcel$export(module.exports, "useA11yDropdownAnnouncement", function () { return $c40342c1af869cf5$export$3d596a295dd7fc61; });
$parcel$export(module.exports, "HiddenAriaLiveAnnouncement", function () { return $c40342c1af869cf5$export$e96bd116e2b4049a; });
$parcel$export(module.exports, "shouldEnableAlgoliaAnalytics", function () { return $c40342c1af869cf5$export$607d0b571396563a; });
/* auto-complete-helpers.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2fcu1 = parcelRequire("2fcu1");

var $8e22h = parcelRequire("8e22h");

var $gx3aw = parcelRequire("gx3aw");

var $2gCne = parcelRequire("2gCne");
const $c40342c1af869cf5$export$17b978e8ab9e4c58 = "CU5KFWE75C";
const $c40342c1af869cf5$export$ac6f6796ae1ab0c1 = "8cb0497a0549da256319b1b8178e5421";
const $c40342c1af869cf5$export$b23c3af39ccf497d = 'category';
const $c40342c1af869cf5$export$9af986fa17e71039 = 'www.atlassian.com.v3';
const $c40342c1af869cf5$export$f589a8a3c0d7dcca = 'www.atlassian.com.v3-2';
const $c40342c1af869cf5$export$a7eaf02eb519d647 = 'www.atlassian.com.v3_dev';
const $c40342c1af869cf5$export$b337d69b7a65e111 = $c40342c1af869cf5$export$9af986fa17e71039;
const $c40342c1af869cf5$export$a3935c9976467739 = $c40342c1af869cf5$export$f589a8a3c0d7dcca;
const $c40342c1af869cf5$export$5049c8654c52de2a = 'aa-autocomplete-pce';
async function $c40342c1af869cf5$export$b887d873139badc3({ objectID: objectID, queryID: queryID, searchIndex: searchIndex = $c40342c1af869cf5$export$b337d69b7a65e111 }) {
    const algoliaApplicationID = $c40342c1af869cf5$export$17b978e8ab9e4c58;
    const algoliaAdminAPIKey = $c40342c1af869cf5$export$ac6f6796ae1ab0c1;
    const insightsURL = `https://insights.algolia.io/1/events`;
    const anonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id');
    let decodedAnonymousId;
    if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
    decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, '');
    const eventData = {
        events: [
            {
                eventType: 'conversion',
                eventName: 'Result clicked (global nav)',
                index: searchIndex,
                userToken: decodedAnonymousId,
                objectIDs: [
                    objectID
                ],
                queryID: queryID
            }
        ]
    };
    try {
        const response = await (0, $2fcu1.fetch)(insightsURL, {
            method: 'POST',
            headers: {
                'X-Algolia-Application-Id': algoliaApplicationID,
                'X-Algolia-API-Key': algoliaAdminAPIKey,
                'Content-Type': 'text/plain;charset=UTF-8'
            },
            body: JSON.stringify(eventData)
        });
        if (!response.ok) throw new Error(`Error: ${response.statusText}`);
    } catch (error) {
        console.error('Failed to send event:', error);
    }
}
const $c40342c1af869cf5$var$removeConversionEventLocalStorageIfAlreadyExist = ()=>{
    if ((0, $2gCne.getLocalStorage)($c40342c1af869cf5$export$5049c8654c52de2a, true)) (0, $2gCne.removeLocalStorage)($c40342c1af869cf5$export$5049c8654c52de2a);
};
const $c40342c1af869cf5$var$setPotentialConversionEventLocalStorage = (stringifyConversionEventObject)=>{
    // reset localstorage if already exist
    $c40342c1af869cf5$var$removeConversionEventLocalStorageIfAlreadyExist();
    (0, $2gCne.setLocalStorage)($c40342c1af869cf5$export$5049c8654c52de2a, stringifyConversionEventObject, 3600 // per code comment, ttl in seconds for the localstorage. 3600 secs = 1hr
    );
};
const $c40342c1af869cf5$export$120e7b764d5fde54 = (item)=>{
    if (item.url.includes('/signup')) {
        $c40342c1af869cf5$var$removeConversionEventLocalStorageIfAlreadyExist();
        $c40342c1af869cf5$export$b887d873139badc3({
            objectID: item.objectID,
            queryID: item.queryID,
            position: item.position
        });
    } else if (item.url.includes('/software/')) {
        const stringifyAttributes = JSON.stringify({
            objectID: item.objectID,
            queryID: item.queryID,
            position: item.position
        });
        $c40342c1af869cf5$var$setPotentialConversionEventLocalStorage(stringifyAttributes);
    }
};
function $c40342c1af869cf5$export$3d596a295dd7fc61(props) {
    const { resultsCount: resultsCount, searchTerm: searchTerm } = props;
    const [dropdownAnnouncement, setDropdownAnnouncement] = (0, $1oC0p.useState)('');
    (0, $1oC0p.useEffect)(()=>{
        setDropdownAnnouncement('');
    }, [
        searchTerm
    ]);
    const intl = (0, $8e22h.default)();
    (0, $1oC0p.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDropdownAnnouncement(intl.formatMessage({
                id: 'AutoCompleteSearchBar.dropdown.announcement',
                defaultMessage: '{resultsCount} results displayed for search-term "{searchTerm}"'
            }, {
                resultsCount: resultsCount,
                searchTerm: searchTerm
            }));
        }, 2000);
        return ()=>clearTimeout(timer);
    }, [
        resultsCount,
        searchTerm
    ]);
    return {
        dropdownAnnouncement: dropdownAnnouncement
    };
}
const $c40342c1af869cf5$export$e96bd116e2b4049a = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "aria-live": "polite",
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsbt94y _4t3it94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogtohxbz _1reo15vq _18m915vq"
        ]),
        children: props.children
    });
};
function $c40342c1af869cf5$export$607d0b571396563a() {
    return !(typeof window !== 'undefined' && window.navigator.userAgent.includes('Pollinator'));
}

});

parcelRegister("iEjCK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $59dd781c7d89d3d4$export$2e2bcd8739ae039; });
/* auto-complete-search-ai-result.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $9r2RE = parcelRequire("9r2RE");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $59dd781c7d89d3d4$var$aiResultContainerStyle = null;
const $59dd781c7d89d3d4$var$aiIconSearchWrapperStyle = null;
const $59dd781c7d89d3d4$var$queryStyle = null;
const $59dd781c7d89d3d4$var$aiSearchTextStyle = null;
const $59dd781c7d89d3d4$var$AutoCompleteSearchAIResult = ({ query: query, autocomplete: autocomplete, source: source, item: item })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const href = `/search?q=${query}`;
    const aiSearchText = intl.formatMessage({
        id: 'ai.search.text',
        defaultMessage: 'AI search'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: "aa-Item",
        ...autocomplete.getItemProps({
            item: item,
            source: source
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            href: href,
            onClick: (event)=>{
                event.preventDefault();
                createAnalyticsEvent({
                    eventName: 'clickAutocompleteSearchResult',
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'linkButton',
                    actionSubjectId: 'globalNavSearchResults',
                    source: 'globalNav',
                    attributes: {
                        product: 'search',
                        queryId: item.queryID,
                        objectId: item.objectID,
                        linkUrl: href,
                        pageUrl: window.location.href,
                        pagePath: window.location.pathname,
                        rank: 0
                    }
                }).fire();
                window.location.href = href;
            },
            className: (0, $2jatx.default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o _2rko1y44 _1tke1ylp _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _6rthc4v4 _bfhk1bjw _80omtlke _1ka1idpf _1yegidpf _lz8gewfl _1fpidkka"
            ]),
            style: {
                "--_lwvw50": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue100')),
                "--_1kg2hiy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light200'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bah1y6m _4cvr1h6o _zulp19bv"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9r2RE))), {
                            color: "var(--ds-icon-brand, #1868DB)",
                            label: "",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l"
                            ]),
                            children: query
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_syazinbi _1wyb1crf"
                    ]),
                    style: {
                        "--_1tiihzy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light600'))
                    },
                    children: aiSearchText
                })
            ]
        })
    });
};
var $59dd781c7d89d3d4$export$2e2bcd8739ae039 = $59dd781c7d89d3d4$var$AutoCompleteSearchAIResult;

});
parcelRegister("9r2RE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aeea3452b156c1a88293b0f0d28d725d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6de8db783343dd60$var$_react = $6de8db783343dd60$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6de8db783343dd60$var$_baseNew = $6de8db783343dd60$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6de8db783343dd60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6de8db783343dd60$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $6de8db783343dd60$var$_react.default.createElement($6de8db783343dd60$var$_baseNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$6de8db783343dd60$var$GenerativeIndicatorIcon.displayName = 'GenerativeIndicatorIcon';
var $6de8db783343dd60$var$_default = module.exports.default = $6de8db783343dd60$var$GenerativeIndicatorIcon;

});
parcelRegister("jcI35", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("bIDl8")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("bIDl8")).Icon; });

var $bIDl8 = parcelRequire("bIDl8");

});
parcelRegister("bIDl8", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $888251d9bf7486f1$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $888251d9bf7486f1$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $888251d9bf7486f1$var$svgStyles = null;
var $888251d9bf7486f1$var$iconStyles = null;
var $888251d9bf7486f1$var$smallIconStyles = null;
var $888251d9bf7486f1$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $888251d9bf7486f1$var$baseHcmStyles = null;
var $888251d9bf7486f1$var$scaleSize = null;
var $888251d9bf7486f1$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $888251d9bf7486f1$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $888251d9bf7486f1$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $888251d9bf7486f1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $888251d9bf7486f1$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $2jatx.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $888251d9bf7486f1$var$coreSizeSmall[spacing] : $888251d9bf7486f1$var$coreSizeMedium[spacing]
        ])
    }));
});
var $888251d9bf7486f1$export$2e2bcd8739ae039 = $888251d9bf7486f1$export$f04a61298a47a40f;

});




parcelRegister("bj0AD", function(module, exports) {
$parcel$export(module.exports, "AutoCompleteResultsDropdown", function () { return $025152267586e8a9$export$47dfd164a9ccfb8b; });
$parcel$export(module.exports, "DefaultAutocompleteResult", function () { return $025152267586e8a9$export$44851d96ff92d93f; });
/* auto-complete-search-results.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $c9cyU = parcelRequire("c9cyU");

var $eY3N6 = parcelRequire("eY3N6");

var $bZmYH = parcelRequire("bZmYH");

var $bNzAT = parcelRequire("bNzAT");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $1Q6XY = parcelRequire("1Q6XY");
const $025152267586e8a9$var$aaPanel = null;
const $025152267586e8a9$var$aaPanelAI = null;
const $025152267586e8a9$var$aaPanelStalled = null;
const $025152267586e8a9$var$aaItem = null;
const $025152267586e8a9$var$aaItemAI = null;
const $025152267586e8a9$var$aaItemContent = null;
const $025152267586e8a9$var$aaItemContentAI = null;
const $025152267586e8a9$var$aaItemContentBodyAI = null;
const $025152267586e8a9$var$aaItemContentTitle = null;
const $025152267586e8a9$var$aaItemContentTitleAI = null;
const $025152267586e8a9$var$aaItemWrapper = null;
const $025152267586e8a9$var$aaItemLink = null;
const $025152267586e8a9$var$decodeHtml = (html)=>{
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};
const $025152267586e8a9$export$fd660bdfc5e2a1ce = ({ hit: hit })=>{
    return /*#__PURE__*/ (0, $1oC0p.createElement)((0, $1oC0p.Fragment), {}, (0, $c9cyU.parseAlgoliaHitHighlight)({
        hit: hit,
        attribute: 'title'
    }).map(({ value: value, isHighlighted: isHighlighted }, index)=>{
        const decodedValue = $025152267586e8a9$var$decodeHtml(value);
        if (isHighlighted) return /*#__PURE__*/ (0, $1oC0p.createElement)('mark', {
            key: index,
            style: {
                color: (0, $bNzAT.default)('color.neutral.dark200'),
                fontStyle: 'normal',
                fontWeight: '600',
                backgroundColor: 'transparent'
            }
        }, decodedValue);
        return decodedValue;
    }));
};
const $025152267586e8a9$export$47dfd164a9ccfb8b = ({ isMobileView: isMobileView = false, panelRef: panelRef, autocompleteState: autocompleteState, autocomplete: autocomplete, children: children, aiEnabled: aiEnabled })=>{
    if (!isMobileView) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: panelRef,
        className: (0, $2jatx.default)([
            "_bfhk1afi _16qs1le1 _19pkftgi _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _kqswstnw _v5641vzh _2rko3i6a _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _1bsb1y37 _1kmxftgi _1ggmftgi _1ykzftgi _1maeftgi _1rfm1osq",
            aiEnabled && "_ca0q1tcg _u5f37vkz _n3td1tcg _19bv7vkz",
            autocompleteState.status === 'stalled' && "_kdam1r8n _tzy4txnc",
            [
                'aa-Panel',
                'aa-Panel--desktop',
                autocompleteState.status === 'stalled' && 'aa-Panel--stalled'
            ].filter(Boolean).join(' ')
        ]),
        ...autocomplete.getPanelProps({}),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300'))
        },
        children: children
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    });
};
const $025152267586e8a9$export$44851d96ff92d93f = ({ item: item, source: source, autocomplete: autocomplete, isMobileView: isMobileView = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const wacAISearchSummaryExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).wacAISearchSummaryV2);
    const isAISearchSummaryEnabled = wacAISearchSummaryExperiment.type === 'enrolled' && wacAISearchSummaryExperiment.value;
    const handleSearchResultClick = (item)=>{
        (0, $1Q6XY.handleAlgoliaConversionMetrics)(item);
        createAnalyticsEvent({
            eventName: 'clickAutocompleteSearchResult',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'globalNavSearchResults',
            source: 'globalNav',
            attributes: {
                product: 'search',
                queryId: item.queryID,
                objectId: item.objectID,
                linkUrl: item.url,
                pageUrl: window.location.href,
                pagePath: window.location.pathname,
                rank: item.position
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _2rko1l7b _80omtlke _1e0c11p5 _1tke1ylp _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _1pfhftgi _6rthftgi _1ka1idpf _lz8gewfl _1fpidkka",
            isAISearchSummaryEnabled && "_ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi",
            "aa-Item"
        ]),
        ...autocomplete.getItemProps({
            item: item,
            source: source
        }),
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light200'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _syaz1kw7 _1e0c11p5 _zulp1y44 _727q1y44 _wij21bp4 _1bah1yb4 _1bsb1osq _4bfu1r31 _1hmsglyw _ajmmnqa1",
                "aa-ItemLink"
            ]),
            "aria-label": item.title,
            href: item.url,
            onClick: (event)=>{
                event.preventDefault();
                const relativeUrlPath = item?.url?.split('https://www.atlassian.com')[1] || item?.url;
                handleSearchResultClick(item);
                window.location.href = relativeUrlPath;
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _syaz1kw7 _1e0c11p5 _zulp1y44 _727q1y44 _wij21bp4 _1bah1yb4 _1bsb1osq",
                    "aa-ItemWrapper"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _80omtlke _1e0c11p5 _zulpftgi _727qftgi _wij21bp4 _vwz41xfb _1reo15vq _18m915vq _fiawglyw",
                        isAISearchSummaryEnabled && "_zulp19bv _727q19bv",
                        "aa-ItemContent"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            isAISearchSummaryEnabled && "_1e0c11p5 _yv0e5bpd _zulp19bv _727q19bv _ny56yh40",
                            "aa-ItemContentBody"
                        ]),
                        children: [
                            isAISearchSummaryEnabled && !isMobileView && /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                                label: "Search result",
                                size: "medium",
                                color: "var(--ds-icon-accent-gray, #7D818A)"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1k13 _zulpftgi _1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_grzls": (0, $6ZVlx.default)(isMobileView ? 'flex-start' : 'center')
                                },
                                children: [
                                    isMobileView && /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                                        label: "Search result",
                                        size: "small",
                                        color: "var(--ds-icon, #292A2E)"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1o8l _19pkidpf _2hwxhage _otyridpf _18u0idpf _p12f1osq _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _o5724jg8",
                                            isAISearchSummaryEnabled && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1ul9idpf",
                                            "aa-ItemContentTitle"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($025152267586e8a9$export$fd660bdfc5e2a1ce, {
                                            hit: item
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    }, item.objectID);
};

});
parcelRegister("c9cyU", function(module, exports) {
$parcel$export(module.exports, "parseAlgoliaHitHighlight", function () { return $8d8011dd476885bb$export$8d253e1eb996c525; });

var $bIaaN = parcelRequire("bIaaN");

var $exXHN = parcelRequire("exXHN");
function $8d8011dd476885bb$var$_toConsumableArray(arr) {
    return $8d8011dd476885bb$var$_arrayWithoutHoles(arr) || $8d8011dd476885bb$var$_iterableToArray(arr) || $8d8011dd476885bb$var$_unsupportedIterableToArray(arr) || $8d8011dd476885bb$var$_nonIterableSpread();
}
function $8d8011dd476885bb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8d8011dd476885bb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8d8011dd476885bb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8d8011dd476885bb$var$_arrayLikeToArray(o, minLen);
}
function $8d8011dd476885bb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8d8011dd476885bb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8d8011dd476885bb$var$_arrayLikeToArray(arr);
}
function $8d8011dd476885bb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8d8011dd476885bb$export$8d253e1eb996c525(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute;
    var path = Array.isArray(attribute) ? attribute : [
        attribute
    ];
    var highlightedValue = (0, $bIaaN.getAttributeValueByPath)(hit, [
        '_highlightResult'
    ].concat($8d8011dd476885bb$var$_toConsumableArray(path), [
        'value'
    ]));
    if (typeof highlightedValue !== 'string') highlightedValue = (0, $bIaaN.getAttributeValueByPath)(hit, path) || '';
    return (0, $exXHN.parseAttribute)({
        highlightedValue: highlightedValue
    });
}

});
parcelRegister("bIaaN", function(module, exports) {
$parcel$export(module.exports, "getAttributeValueByPath", function () { return $886bb1f5065faf28$export$3219add52b18c0d7; });
function $886bb1f5065faf28$export$3219add52b18c0d7(record, path) {
    return path.reduce(function(current, key) {
        return current && current[key];
    }, record);
}

});

parcelRegister("exXHN", function(module, exports) {
$parcel$export(module.exports, "parseAttribute", function () { return $a97275fb64869fc6$export$dd369bc78e81a241; });

var $9ypTb = parcelRequire("9ypTb");
/**
 * Creates a data structure that allows to concatenate similar highlighting
 * parts in a single value.
 */ function $a97275fb64869fc6$var$createAttributeSet() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var value = initialValue;
    return {
        get: function get() {
            return value;
        },
        add: function add(part) {
            var lastPart = value[value.length - 1];
            if ((lastPart === null || lastPart === void 0 ? void 0 : lastPart.isHighlighted) === part.isHighlighted) value[value.length - 1] = {
                value: lastPart.value + part.value,
                isHighlighted: lastPart.isHighlighted
            };
            else value.push(part);
        }
    };
}
function $a97275fb64869fc6$export$dd369bc78e81a241(_ref) {
    var highlightedValue = _ref.highlightedValue;
    var preTagParts = highlightedValue.split((0, $9ypTb.HIGHLIGHT_PRE_TAG));
    var firstValue = preTagParts.shift();
    var parts = $a97275fb64869fc6$var$createAttributeSet(firstValue ? [
        {
            value: firstValue,
            isHighlighted: false
        }
    ] : []);
    preTagParts.forEach(function(part) {
        var postTagParts = part.split((0, $9ypTb.HIGHLIGHT_POST_TAG));
        parts.add({
            value: postTagParts[0],
            isHighlighted: true
        });
        if (postTagParts[1] !== '') parts.add({
            value: postTagParts[1],
            isHighlighted: false
        });
    });
    return parts.get();
}

});
parcelRegister("9ypTb", function(module, exports) {
$parcel$export(module.exports, "HIGHLIGHT_PRE_TAG", function () { return $6f4b5f0d2e62503e$export$2df5424f792538bd; });
$parcel$export(module.exports, "HIGHLIGHT_POST_TAG", function () { return $6f4b5f0d2e62503e$export$2681d4c6a4ae86; });
var $6f4b5f0d2e62503e$export$2df5424f792538bd = '__aa-highlight__';
var $6f4b5f0d2e62503e$export$2681d4c6a4ae86 = '__/aa-highlight__';

});




parcelRegister("9bvfr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $522f71a41fda09d4$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $5OxO8 = parcelRequire("5OxO8");

var $bjz6g = parcelRequire("bjz6g");

var $cddhv = parcelRequire("cddhv");

var $8e22h = parcelRequire("8e22h");
const $522f71a41fda09d4$var$useAlogoliaAutoComplete = ({ searchIndex: searchIndex, ALGOLIA_FACET_KEY: ALGOLIA_FACET_KEY, ALGOLIA_APP_ID: ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY: ALGOLIA_SEARCH_API_KEY, queryParams: queryParams, aiEnabled: aiEnabled = false })=>{
    const intl = (0, $8e22h.default)();
    const algoliaSearchClient = (0, $cddhv.default)(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);
    const [autocompleteState, setAutocompleteState] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState({
        collections: [],
        completion: null,
        context: {},
        isOpen: false,
        query: '',
        activeItemId: null,
        status: 'idle'
    });
    let placeholder = intl.formatMessage({
        id: 'globalnav.v2.search-bar.placeholder',
        defaultMessage: 'Search Keywords'
    });
    if (aiEnabled) placeholder = intl.formatMessage({
        id: 'globalnav.v2.search-bar.ai-enabled.placeholder',
        defaultMessage: "Search or ask anything like \u201CHow much does Jira cost?\u201D"
    });
    const autocomplete = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useMemo(()=>(0, $5OxO8.createAutocomplete)({
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            onStateChange ({ state: state }) {
                setAutocompleteState(state);
            },
            insights: true,
            getSources () {
                const sources = [];
                // Add AI source if enabled
                if (aiEnabled) sources.push({
                    sourceId: 'ai-assistant',
                    getItems ({ query: query }) {
                        // Only show AI result if there's a query
                        if (!query?.trim()) return [];
                        return [
                            {
                                objectID: 'ai-assistant',
                                title: `${query}`,
                                url: '#',
                                queryID: 'ai-assistant',
                                position: 0
                            }
                        ];
                    },
                    getItemUrl () {
                        return '#';
                    }
                });
                // Add regular Algolia source
                sources.push({
                    sourceId: ALGOLIA_FACET_KEY,
                    getItems ({ query: query }) {
                        return (0, $bjz6g.getAlgoliaResults)({
                            searchClient: algoliaSearchClient,
                            queries: [
                                {
                                    indexName: searchIndex,
                                    query: query,
                                    params: queryParams
                                }
                            ],
                            transformResponse ({ results: results, hits: hits }) {
                                // tranform response so that each hit also contains its position and queryID for analytics purposes
                                const [result] = results;
                                const queryID = result?.queryID;
                                const [originalHits] = hits;
                                return originalHits?.map((hit, index)=>({
                                        ...hit,
                                        queryID: queryID,
                                        position: index + 1
                                    }));
                            }
                        });
                    },
                    getItemUrl ({ item: item }) {
                        return item.url;
                    }
                });
                return sources;
            },
            placeholder: placeholder,
            openOnFocus: false,
            stallThreshold: 500
        }), [
        aiEnabled
    ]);
    return {
        autocompleteState: autocompleteState,
        autocomplete: autocomplete
    };
};
var $522f71a41fda09d4$export$2e2bcd8739ae039 = $522f71a41fda09d4$var$useAlogoliaAutoComplete;

});
parcelRegister("5OxO8", function(module, exports) {
$parcel$export(module.exports, "createAutocomplete", function () { return $43bbd8be1c071533$export$b00b86c416695282; });

var $jsluc = parcelRequire("jsluc");

var $j2WnX = parcelRequire("j2WnX");

var $8LL7M = parcelRequire("8LL7M");

var $6SMZr = parcelRequire("6SMZr");

var $enUj9 = parcelRequire("enUj9");

var $84v4f = parcelRequire("84v4f");

var $9vYhF = parcelRequire("9vYhF");

var $i73ye = parcelRequire("i73ye");

var $7tfug = parcelRequire("7tfug");
function $43bbd8be1c071533$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $43bbd8be1c071533$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $43bbd8be1c071533$var$_typeof(obj);
}
function $43bbd8be1c071533$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $43bbd8be1c071533$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $43bbd8be1c071533$var$ownKeys(Object(source), !0).forEach(function(key) {
            $43bbd8be1c071533$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $43bbd8be1c071533$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $43bbd8be1c071533$var$_defineProperty(obj, key, value) {
    key = $43bbd8be1c071533$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $43bbd8be1c071533$var$_toPropertyKey(arg) {
    var key = $43bbd8be1c071533$var$_toPrimitive(arg, "string");
    return $43bbd8be1c071533$var$_typeof(key) === "symbol" ? key : String(key);
}
function $43bbd8be1c071533$var$_toPrimitive(input, hint) {
    if ($43bbd8be1c071533$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($43bbd8be1c071533$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $43bbd8be1c071533$export$b00b86c416695282(options) {
    (0, $j2WnX.checkOptions)(options);
    var subscribers = [];
    var props = (0, $enUj9.getDefaultProps)(options, subscribers);
    var store = (0, $8LL7M.createStore)((0, $7tfug.stateReducer), props, onStoreStateChange);
    var setters = (0, $6SMZr.getAutocompleteSetters)({
        store: store
    });
    var propGetters = (0, $84v4f.getPropGetters)($43bbd8be1c071533$var$_objectSpread({
        props: props,
        refresh: refresh,
        store: store,
        navigator: props.navigator
    }, setters));
    function onStoreStateChange(_ref) {
        var _state$context, _state$context$algoli;
        var prevState = _ref.prevState, state = _ref.state;
        props.onStateChange($43bbd8be1c071533$var$_objectSpread({
            prevState: prevState,
            state: state,
            refresh: refresh,
            navigator: props.navigator
        }, setters));
        if (!isAlgoliaInsightsPluginEnabled() && (_state$context = state.context) !== null && _state$context !== void 0 && (_state$context$algoli = _state$context.algoliaInsightsPlugin) !== null && _state$context$algoli !== void 0 && _state$context$algoli.__automaticInsights && props.insights !== false) {
            var plugin = (0, $jsluc.createAlgoliaInsightsPlugin)({
                __autocomplete_clickAnalytics: false
            });
            props.plugins.push(plugin);
            subscribePlugins([
                plugin
            ]);
        }
    }
    function refresh() {
        return (0, $i73ye.onInput)($43bbd8be1c071533$var$_objectSpread({
            event: new Event('input'),
            nextState: {
                isOpen: store.getState().isOpen
            },
            props: props,
            navigator: props.navigator,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters));
    }
    function subscribePlugins(plugins) {
        plugins.forEach(function(plugin) {
            var _plugin$subscribe;
            return (_plugin$subscribe = plugin.subscribe) === null || _plugin$subscribe === void 0 ? void 0 : _plugin$subscribe.call(plugin, $43bbd8be1c071533$var$_objectSpread($43bbd8be1c071533$var$_objectSpread({}, setters), {}, {
                navigator: props.navigator,
                refresh: refresh,
                onSelect: function onSelect(fn) {
                    subscribers.push({
                        onSelect: fn
                    });
                },
                onActive: function onActive(fn) {
                    subscribers.push({
                        onActive: fn
                    });
                },
                onResolve: function onResolve(fn) {
                    subscribers.push({
                        onResolve: fn
                    });
                }
            }));
        });
    }
    function isAlgoliaInsightsPluginEnabled() {
        return props.plugins.some(function(plugin) {
            return plugin.name === 'aa.algoliaInsightsPlugin';
        });
    }
    if (props.insights && !isAlgoliaInsightsPluginEnabled()) {
        var insightsParams = typeof props.insights === 'boolean' ? {} : props.insights;
        props.plugins.push((0, $jsluc.createAlgoliaInsightsPlugin)(insightsParams));
    }
    subscribePlugins(props.plugins);
    (0, $9vYhF.injectMetadata)({
        metadata: (0, $9vYhF.getMetadata)({
            plugins: props.plugins,
            options: options
        }),
        environment: props.environment
    });
    return $43bbd8be1c071533$var$_objectSpread($43bbd8be1c071533$var$_objectSpread({
        refresh: refresh,
        navigator: props.navigator
    }, propGetters), setters);
}

});
parcelRegister("jsluc", function(module, exports) {
$parcel$export(module.exports, "createAlgoliaInsightsPlugin", function () { return $e2a14c843efa33e6$export$89ab4208990a3782; });

var $dHaCz = parcelRequire("dHaCz");
var $gdpl5 = parcelRequire("gdpl5");
var $3fSZq = parcelRequire("3fSZq");
var $4UBPb = parcelRequire("4UBPb");
var $7RwCp = parcelRequire("7RwCp");

var $86Cvh = parcelRequire("86Cvh");

var $bKEzF = parcelRequire("bKEzF");

var $9HLBL = parcelRequire("9HLBL");

var $9Z09P = parcelRequire("9Z09P");
function $e2a14c843efa33e6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e2a14c843efa33e6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e2a14c843efa33e6$var$_typeof(obj);
}
function $e2a14c843efa33e6$var$_toConsumableArray(arr) {
    return $e2a14c843efa33e6$var$_arrayWithoutHoles(arr) || $e2a14c843efa33e6$var$_iterableToArray(arr) || $e2a14c843efa33e6$var$_unsupportedIterableToArray(arr) || $e2a14c843efa33e6$var$_nonIterableSpread();
}
function $e2a14c843efa33e6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e2a14c843efa33e6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e2a14c843efa33e6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e2a14c843efa33e6$var$_arrayLikeToArray(o, minLen);
}
function $e2a14c843efa33e6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e2a14c843efa33e6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e2a14c843efa33e6$var$_arrayLikeToArray(arr);
}
function $e2a14c843efa33e6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e2a14c843efa33e6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e2a14c843efa33e6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e2a14c843efa33e6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e2a14c843efa33e6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e2a14c843efa33e6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e2a14c843efa33e6$var$_defineProperty(obj, key, value) {
    key = $e2a14c843efa33e6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e2a14c843efa33e6$var$_toPropertyKey(arg) {
    var key = $e2a14c843efa33e6$var$_toPrimitive(arg, "string");
    return $e2a14c843efa33e6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e2a14c843efa33e6$var$_toPrimitive(input, hint) {
    if ($e2a14c843efa33e6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e2a14c843efa33e6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e2a14c843efa33e6$var$VIEW_EVENT_DELAY = 400;
var $e2a14c843efa33e6$var$ALGOLIA_INSIGHTS_VERSION = '2.15.0';
var $e2a14c843efa33e6$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($e2a14c843efa33e6$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
var $e2a14c843efa33e6$var$sendViewedObjectIDs = (0, $gdpl5.debounce)(function(_ref) {
    var onItemsChange = _ref.onItemsChange, items = _ref.items, insights = _ref.insights, state = _ref.state;
    onItemsChange({
        insights: insights,
        insightsEvents: (0, $9HLBL.createViewedEvents)({
            items: items
        }).map(function(event) {
            return $e2a14c843efa33e6$var$_objectSpread({
                eventName: 'Items Viewed'
            }, event);
        }),
        state: state
    });
}, $e2a14c843efa33e6$var$VIEW_EVENT_DELAY);
function $e2a14c843efa33e6$export$89ab4208990a3782(options) {
    var _getOptions = $e2a14c843efa33e6$var$getOptions(options), providedInsightsClient = _getOptions.insightsClient, insightsInitParams = _getOptions.insightsInitParams, onItemsChange = _getOptions.onItemsChange, onSelectEvent = _getOptions.onSelect, onActiveEvent = _getOptions.onActive, __autocomplete_clickAnalytics = _getOptions.__autocomplete_clickAnalytics;
    var insightsClient = providedInsightsClient;
    if (!providedInsightsClient) (0, $7RwCp.safelyRunOnBrowser)(function(_ref2) {
        var window = _ref2.window;
        var pointer = window.AlgoliaAnalyticsObject || 'aa';
        if (typeof pointer === 'string') insightsClient = window[pointer];
        if (!insightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) window[pointer] = function() {
                if (!window[pointer].queue) window[pointer].queue = [];
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                window[pointer].queue.push(args);
            };
            window[pointer].version = $e2a14c843efa33e6$var$ALGOLIA_INSIGHTS_VERSION;
            insightsClient = window[pointer];
            $e2a14c843efa33e6$var$loadInsights(window);
        }
    });
    // We return an empty plugin if `insightsClient` is still undefined at
    // this stage, which can happen in server environments.
    if (!insightsClient) return {};
    if (insightsInitParams) insightsClient('init', $e2a14c843efa33e6$var$_objectSpread({
        partial: true
    }, insightsInitParams));
    var insights = (0, $bKEzF.createSearchInsightsApi)(insightsClient);
    var previousItems = (0, $dHaCz.createRef)([]);
    var debouncedOnStateChange = (0, $gdpl5.debounce)(function(_ref3) {
        var state = _ref3.state;
        if (!state.isOpen) return;
        var items = state.collections.reduce(function(acc, current) {
            return [].concat($e2a14c843efa33e6$var$_toConsumableArray(acc), $e2a14c843efa33e6$var$_toConsumableArray(current.items));
        }, []).filter((0, $9Z09P.isAlgoliaInsightsHit));
        if (!(0, $3fSZq.isEqual)(previousItems.current.map(function(x) {
            return x.objectID;
        }), items.map(function(x) {
            return x.objectID;
        }))) {
            previousItems.current = items;
            if (items.length > 0) $e2a14c843efa33e6$var$sendViewedObjectIDs({
                onItemsChange: onItemsChange,
                items: items,
                insights: insights,
                state: state
            });
        }
    }, 0);
    return {
        name: 'aa.algoliaInsightsPlugin',
        subscribe: function subscribe(_ref4) {
            var setContext = _ref4.setContext, onSelect = _ref4.onSelect, onActive = _ref4.onActive;
            function setInsightsContext(userToken) {
                setContext({
                    algoliaInsightsPlugin: {
                        __algoliaSearchParameters: $e2a14c843efa33e6$var$_objectSpread($e2a14c843efa33e6$var$_objectSpread({}, __autocomplete_clickAnalytics ? {
                            clickAnalytics: true
                        } : {}), userToken ? {
                            userToken: $e2a14c843efa33e6$var$normalizeUserToken(userToken)
                        } : {}),
                        insights: insights
                    }
                });
            }
            insightsClient('addAlgoliaAgent', 'insights-plugin');
            setInsightsContext();
            // Handles user token changes
            insightsClient('onUserTokenChange', function(userToken) {
                setInsightsContext(userToken);
            });
            insightsClient('getUserToken', null, function(_error, userToken) {
                setInsightsContext(userToken);
            });
            onSelect(function(_ref5) {
                var item = _ref5.item, state = _ref5.state, event = _ref5.event, source = _ref5.source;
                if (!(0, $9Z09P.isAlgoliaInsightsHit)(item)) return;
                onSelectEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $e2a14c843efa33e6$var$_objectSpread({
                            eventName: 'Item Selected'
                        }, (0, $86Cvh.createClickedEvent)({
                            item: item,
                            items: source.getItems().filter((0, $9Z09P.isAlgoliaInsightsHit))
                        }))
                    ]
                });
            });
            onActive(function(_ref6) {
                var item = _ref6.item, source = _ref6.source, state = _ref6.state, event = _ref6.event;
                if (!(0, $9Z09P.isAlgoliaInsightsHit)(item)) return;
                onActiveEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $e2a14c843efa33e6$var$_objectSpread({
                            eventName: 'Item Active'
                        }, (0, $86Cvh.createClickedEvent)({
                            item: item,
                            items: source.getItems().filter((0, $9Z09P.isAlgoliaInsightsHit))
                        }))
                    ]
                });
            });
        },
        onStateChange: function onStateChange(_ref7) {
            var state = _ref7.state;
            debouncedOnStateChange({
                state: state
            });
        },
        __autocomplete_pluginOptions: options
    };
}
function $e2a14c843efa33e6$var$getAlgoliaSources() {
    var _context$algoliaInsig;
    var algoliaSourceBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var context = arguments.length > 1 ? arguments[1] : undefined;
    return [].concat($e2a14c843efa33e6$var$_toConsumableArray(algoliaSourceBase), [
        'autocomplete-internal'
    ], $e2a14c843efa33e6$var$_toConsumableArray((_context$algoliaInsig = context.algoliaInsightsPlugin) !== null && _context$algoliaInsig !== void 0 && _context$algoliaInsig.__automaticInsights ? [
        'autocomplete-automatic'
    ] : []));
}
function $e2a14c843efa33e6$var$getOptions(options) {
    return $e2a14c843efa33e6$var$_objectSpread({
        onItemsChange: function onItemsChange(_ref8) {
            var insights = _ref8.insights, insightsEvents = _ref8.insightsEvents, state = _ref8.state;
            insights.viewedObjectIDs.apply(insights, $e2a14c843efa33e6$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $e2a14c843efa33e6$var$_objectSpread($e2a14c843efa33e6$var$_objectSpread({}, event), {}, {
                    algoliaSource: $e2a14c843efa33e6$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onSelect: function onSelect(_ref9) {
            var insights = _ref9.insights, insightsEvents = _ref9.insightsEvents, state = _ref9.state;
            insights.clickedObjectIDsAfterSearch.apply(insights, $e2a14c843efa33e6$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $e2a14c843efa33e6$var$_objectSpread($e2a14c843efa33e6$var$_objectSpread({}, event), {}, {
                    algoliaSource: $e2a14c843efa33e6$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onActive: (0, $4UBPb.noop),
        __autocomplete_clickAnalytics: true
    }, options);
}
function $e2a14c843efa33e6$var$loadInsights(environment) {
    var errorMessage = "[Autocomplete]: Could not load search-insights.js. Please load it manually following https://alg.li/insights-autocomplete";
    try {
        var script = environment.document.createElement('script');
        script.async = true;
        script.src = $e2a14c843efa33e6$var$ALGOLIA_INSIGHTS_SRC;
        script.onerror = function() {
            // eslint-disable-next-line no-console
            console.error(errorMessage);
        };
        document.body.appendChild(script);
    } catch (cause) {
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $e2a14c843efa33e6$var$normalizeUserToken(userToken) {
    return typeof userToken === 'number' ? userToken.toString() : userToken;
}

});
parcelRegister("dHaCz", function(module, exports) {
$parcel$export(module.exports, "createRef", function () { return $9f8787a0522eba1c$export$7d1e3a5e95ceca43; });
function $9f8787a0522eba1c$export$7d1e3a5e95ceca43(initialValue) {
    return {
        current: initialValue
    };
}

});

parcelRegister("gdpl5", function(module, exports) {
$parcel$export(module.exports, "debounce", function () { return $bce1840ad8fd5ca1$export$61fc7d43ac8f84b0; });
function $bce1840ad8fd5ca1$export$61fc7d43ac8f84b0(fn, time) {
    var timerId = undefined;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(function() {
            return fn.apply(void 0, args);
        }, time);
    };
}

});

parcelRegister("3fSZq", function(module, exports) {
$parcel$export(module.exports, "isEqual", function () { return $25ed6da2ea1906ba$export$248d38f6296296c5; });
function $25ed6da2ea1906ba$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $25ed6da2ea1906ba$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($25ed6da2ea1906ba$var$isPrimitive(first) || $25ed6da2ea1906ba$var$isPrimitive(second) || typeof first === 'function' || typeof second === 'function') return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$25ed6da2ea1906ba$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

});

parcelRegister("4UBPb", function(module, exports) {
$parcel$export(module.exports, "noop", function () { return $3939bb8985e28a14$export$8793edee2d425525; });
var $3939bb8985e28a14$export$8793edee2d425525 = function noop() {};

});

parcelRegister("7RwCp", function(module, exports) {
$parcel$export(module.exports, "safelyRunOnBrowser", function () { return $5b96c902e2d124e1$export$39f19eed34acd2f1; });
/**
 * Safely runs code meant for browser environments only.
 */ function $5b96c902e2d124e1$export$39f19eed34acd2f1(callback) {
    if (typeof window !== 'undefined') return callback({
        window: window
    });
    return undefined;
}

});

parcelRegister("86Cvh", function(module, exports) {
$parcel$export(module.exports, "createClickedEvent", function () { return $5e6cc042acc76c7a$export$285269928260a84d; });
function $5e6cc042acc76c7a$export$285269928260a84d(_ref) {
    var item = _ref.item, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items;
    return {
        index: item.__autocomplete_indexName,
        items: [
            item
        ],
        positions: [
            1 + items.findIndex(function(x) {
                return x.objectID === item.objectID;
            })
        ],
        queryID: item.__autocomplete_queryID,
        algoliaSource: [
            'autocomplete'
        ]
    };
}

});

parcelRegister("bKEzF", function(module, exports) {
$parcel$export(module.exports, "createSearchInsightsApi", function () { return $88e376c62986461c$export$96bc93a891c6f784; });

var $44Zrb = parcelRequire("44Zrb");
var $88e376c62986461c$var$_excluded = [
    "items"
], $88e376c62986461c$var$_excluded2 = [
    "items"
];
function $88e376c62986461c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $88e376c62986461c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $88e376c62986461c$var$_typeof(obj);
}
function $88e376c62986461c$var$_toConsumableArray(arr) {
    return $88e376c62986461c$var$_arrayWithoutHoles(arr) || $88e376c62986461c$var$_iterableToArray(arr) || $88e376c62986461c$var$_unsupportedIterableToArray(arr) || $88e376c62986461c$var$_nonIterableSpread();
}
function $88e376c62986461c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $88e376c62986461c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $88e376c62986461c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $88e376c62986461c$var$_arrayLikeToArray(o, minLen);
}
function $88e376c62986461c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $88e376c62986461c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $88e376c62986461c$var$_arrayLikeToArray(arr);
}
function $88e376c62986461c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $88e376c62986461c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $88e376c62986461c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $88e376c62986461c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $88e376c62986461c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $88e376c62986461c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $88e376c62986461c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $88e376c62986461c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $88e376c62986461c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $88e376c62986461c$var$_defineProperty(obj, key, value) {
    key = $88e376c62986461c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $88e376c62986461c$var$_toPropertyKey(arg) {
    var key = $88e376c62986461c$var$_toPrimitive(arg, "string");
    return $88e376c62986461c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $88e376c62986461c$var$_toPrimitive(input, hint) {
    if ($88e376c62986461c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($88e376c62986461c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $88e376c62986461c$var$chunk(item) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < item.objectIDs.length; i += chunkSize)chunks.push($88e376c62986461c$var$_objectSpread($88e376c62986461c$var$_objectSpread({}, item), {}, {
        objectIDs: item.objectIDs.slice(i, i + chunkSize)
    }));
    return chunks;
}
function $88e376c62986461c$var$mapToInsightsParamsApi(params) {
    return params.map(function(_ref) {
        var items = _ref.items, param = $88e376c62986461c$var$_objectWithoutProperties(_ref, $88e376c62986461c$var$_excluded);
        return $88e376c62986461c$var$_objectSpread($88e376c62986461c$var$_objectSpread({}, param), {}, {
            objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref2) {
                var objectID = _ref2.objectID;
                return objectID;
            })) || param.objectIDs
        });
    });
}
function $88e376c62986461c$export$96bc93a891c6f784(searchInsights) {
    var canSendHeaders = (0, $44Zrb.isModernInsightsClient)(searchInsights);
    function sendToInsights(method, payloads, items) {
        if (canSendHeaders && typeof items !== 'undefined') {
            var _items$0$__autocomple = items[0].__autocomplete_algoliaCredentials, appId = _items$0$__autocomple.appId, apiKey = _items$0$__autocomple.apiKey;
            var headers = {
                'X-Algolia-Application-Id': appId,
                'X-Algolia-API-Key': apiKey
            };
            searchInsights.apply(void 0, [
                method
            ].concat($88e376c62986461c$var$_toConsumableArray(payloads), [
                {
                    headers: headers
                }
            ]));
        } else searchInsights.apply(void 0, [
            method
        ].concat($88e376c62986461c$var$_toConsumableArray(payloads)));
    }
    return {
        /**
     * Initializes Insights with Algolia credentials.
     */ init: function init(appId, apiKey) {
            searchInsights('init', {
                appId: appId,
                apiKey: apiKey
            });
        },
        /**
     * Sets the authenticated user token to attach to events.
     * Unsets the authenticated token by passing `undefined`.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/set-authenticated-user-token/
     */ setAuthenticatedUserToken: function setAuthenticatedUserToken(authenticatedUserToken) {
            searchInsights('setAuthenticatedUserToken', authenticatedUserToken);
        },
        /**
     * Sets the user token to attach to events.
     */ setUserToken: function setUserToken(userToken) {
            searchInsights('setUserToken', userToken);
        },
        /**
     * Sends click events to capture a query and its clicked items and positions.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids-after-search/
     */ clickedObjectIDsAfterSearch: function clickedObjectIDsAfterSearch() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++)params[_key] = arguments[_key];
            if (params.length > 0) sendToInsights('clickedObjectIDsAfterSearch', $88e376c62986461c$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids/
     */ clickedObjectIDs: function clickedObjectIDs() {
            for(var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)params[_key2] = arguments[_key2];
            if (params.length > 0) sendToInsights('clickedObjectIDs', $88e376c62986461c$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture the filters a user clicks on.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-filters/
     */ clickedFilters: function clickedFilters() {
            for(var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)params[_key3] = arguments[_key3];
            if (params.length > 0) searchInsights.apply(void 0, [
                'clickedFilters'
            ].concat(params));
        },
        /**
     * Sends conversion events to capture a query and its clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids-after-search/
     */ convertedObjectIDsAfterSearch: function convertedObjectIDsAfterSearch() {
            for(var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)params[_key4] = arguments[_key4];
            if (params.length > 0) sendToInsights('convertedObjectIDsAfterSearch', $88e376c62986461c$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids/
     */ convertedObjectIDs: function convertedObjectIDs() {
            for(var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)params[_key5] = arguments[_key5];
            if (params.length > 0) sendToInsights('convertedObjectIDs', $88e376c62986461c$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture the filters a user uses when converting.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-filters/
     */ convertedFilters: function convertedFilters() {
            for(var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)params[_key6] = arguments[_key6];
            if (params.length > 0) searchInsights.apply(void 0, [
                'convertedFilters'
            ].concat(params));
        },
        /**
     * Sends view events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-object-ids/
     */ viewedObjectIDs: function viewedObjectIDs() {
            for(var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)params[_key7] = arguments[_key7];
            if (params.length > 0) params.reduce(function(acc, _ref3) {
                var items = _ref3.items, param = $88e376c62986461c$var$_objectWithoutProperties(_ref3, $88e376c62986461c$var$_excluded2);
                return [].concat($88e376c62986461c$var$_toConsumableArray(acc), $88e376c62986461c$var$_toConsumableArray($88e376c62986461c$var$chunk($88e376c62986461c$var$_objectSpread($88e376c62986461c$var$_objectSpread({}, param), {}, {
                    objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref4) {
                        var objectID = _ref4.objectID;
                        return objectID;
                    })) || param.objectIDs
                })).map(function(payload) {
                    return {
                        items: items,
                        payload: payload
                    };
                })));
            }, []).forEach(function(_ref5) {
                var items = _ref5.items, payload = _ref5.payload;
                return sendToInsights('viewedObjectIDs', [
                    payload
                ], items);
            });
        },
        /**
     * Sends view events to capture the filters a user uses when viewing.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-filters/
     */ viewedFilters: function viewedFilters() {
            for(var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)params[_key8] = arguments[_key8];
            if (params.length > 0) searchInsights.apply(void 0, [
                'viewedFilters'
            ].concat(params));
        }
    };
}

});
parcelRegister("44Zrb", function(module, exports) {
$parcel$export(module.exports, "isModernInsightsClient", function () { return $2f873158ce4c7e36$export$5c9cfc0c9d3b5e01; });
function $2f873158ce4c7e36$var$_slicedToArray(arr, i) {
    return $2f873158ce4c7e36$var$_arrayWithHoles(arr) || $2f873158ce4c7e36$var$_iterableToArrayLimit(arr, i) || $2f873158ce4c7e36$var$_unsupportedIterableToArray(arr, i) || $2f873158ce4c7e36$var$_nonIterableRest();
}
function $2f873158ce4c7e36$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2f873158ce4c7e36$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2f873158ce4c7e36$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2f873158ce4c7e36$var$_arrayLikeToArray(o, minLen);
}
function $2f873158ce4c7e36$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2f873158ce4c7e36$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $2f873158ce4c7e36$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2f873158ce4c7e36$export$5c9cfc0c9d3b5e01(client) {
    var _split$map = (client.version || '').split('.').map(Number), _split$map2 = $2f873158ce4c7e36$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/camelcase */ var v3 = major >= 3;
    var v2_4 = major === 2 && minor >= 4;
    var v1_10 = major === 1 && minor >= 10;
    return v3 || v2_4 || v1_10;
/* eslint-enable @typescript-eslint/camelcase */ }

});


parcelRegister("9HLBL", function(module, exports) {
$parcel$export(module.exports, "createViewedEvents", function () { return $710d0f34d6416872$export$8bae0094a47f6972; });
function $710d0f34d6416872$export$8bae0094a47f6972(_ref) {
    var items = _ref.items;
    var itemsByIndexName = items.reduce(function(acc, current) {
        var _acc$current$__autoco;
        acc[current.__autocomplete_indexName] = ((_acc$current$__autoco = acc[current.__autocomplete_indexName]) !== null && _acc$current$__autoco !== void 0 ? _acc$current$__autoco : []).concat(current);
        return acc;
    }, {});
    return Object.keys(itemsByIndexName).map(function(indexName) {
        var items = itemsByIndexName[indexName];
        return {
            index: indexName,
            items: items,
            algoliaSource: [
                'autocomplete'
            ]
        };
    });
}

});

parcelRegister("9Z09P", function(module, exports) {
$parcel$export(module.exports, "isAlgoliaInsightsHit", function () { return $7449eed7d362106d$export$977f4849b4f88a72; });
function $7449eed7d362106d$export$977f4849b4f88a72(hit) {
    return hit.objectID && hit.__autocomplete_indexName && hit.__autocomplete_queryID;
}

});


parcelRegister("j2WnX", function(module, exports) {
$parcel$export(module.exports, "checkOptions", function () { return $dddb7e5d71867e5c$export$6fe837ce0e0e0cdf; });

function $dddb7e5d71867e5c$export$6fe837ce0e0e0cdf(options) {}

});

parcelRegister("8LL7M", function(module, exports) {
$parcel$export(module.exports, "createStore", function () { return $662744772491c4ad$export$f51a9068ac82ea43; });

var $eeAhU = parcelRequire("eeAhU");
function $662744772491c4ad$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $662744772491c4ad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $662744772491c4ad$var$_typeof(obj);
}
function $662744772491c4ad$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $662744772491c4ad$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $662744772491c4ad$var$ownKeys(Object(source), !0).forEach(function(key) {
            $662744772491c4ad$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $662744772491c4ad$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $662744772491c4ad$var$_defineProperty(obj, key, value) {
    key = $662744772491c4ad$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $662744772491c4ad$var$_toPropertyKey(arg) {
    var key = $662744772491c4ad$var$_toPrimitive(arg, "string");
    return $662744772491c4ad$var$_typeof(key) === "symbol" ? key : String(key);
}
function $662744772491c4ad$var$_toPrimitive(input, hint) {
    if ($662744772491c4ad$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($662744772491c4ad$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $662744772491c4ad$export$f51a9068ac82ea43(reducer, props, onStoreStateChange) {
    var state = props.initialState;
    return {
        getState: function getState() {
            return state;
        },
        dispatch: function dispatch(action, payload) {
            var prevState = $662744772491c4ad$var$_objectSpread({}, state);
            state = reducer(state, {
                type: action,
                props: props,
                payload: payload
            });
            onStoreStateChange({
                state: state,
                prevState: prevState
            });
        },
        pendingRequests: (0, $eeAhU.createCancelablePromiseList)()
    };
}

});
parcelRegister("eeAhU", function(module, exports) {
$parcel$export(module.exports, "createCancelablePromiseList", function () { return $a5ce858165e5ea4c$export$9661f890aacb4415; });
function $a5ce858165e5ea4c$export$9661f890aacb4415() {
    var list = [];
    return {
        add: function add(cancelablePromise) {
            list.push(cancelablePromise);
            return cancelablePromise.finally(function() {
                list = list.filter(function(item) {
                    return item !== cancelablePromise;
                });
            });
        },
        cancelAll: function cancelAll() {
            list.forEach(function(promise) {
                return promise.cancel();
            });
        },
        isEmpty: function isEmpty() {
            return list.length === 0;
        }
    };
}

});


parcelRegister("6SMZr", function(module, exports) {
$parcel$export(module.exports, "getAutocompleteSetters", function () { return $502dc9a29b2096a6$export$5085b122b817cee; });

var $1vxGN = parcelRequire("1vxGN");
function $502dc9a29b2096a6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $502dc9a29b2096a6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $502dc9a29b2096a6$var$_typeof(obj);
}
function $502dc9a29b2096a6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $502dc9a29b2096a6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $502dc9a29b2096a6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $502dc9a29b2096a6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $502dc9a29b2096a6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $502dc9a29b2096a6$var$_defineProperty(obj, key, value) {
    key = $502dc9a29b2096a6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $502dc9a29b2096a6$var$_toPropertyKey(arg) {
    var key = $502dc9a29b2096a6$var$_toPrimitive(arg, "string");
    return $502dc9a29b2096a6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $502dc9a29b2096a6$var$_toPrimitive(input, hint) {
    if ($502dc9a29b2096a6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($502dc9a29b2096a6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $502dc9a29b2096a6$export$5085b122b817cee(_ref) {
    var store = _ref.store;
    var setActiveItemId = function setActiveItemId(value) {
        store.dispatch('setActiveItemId', value);
    };
    var setQuery = function setQuery(value) {
        store.dispatch('setQuery', value);
    };
    var setCollections = function setCollections(rawValue) {
        var baseItemId = 0;
        var value = rawValue.map(function(collection) {
            return $502dc9a29b2096a6$var$_objectSpread($502dc9a29b2096a6$var$_objectSpread({}, collection), {}, {
                // We flatten the stored items to support calling `getAlgoliaResults`
                // from the source itself.
                items: (0, $1vxGN.flatten)(collection.items).map(function(item) {
                    return $502dc9a29b2096a6$var$_objectSpread($502dc9a29b2096a6$var$_objectSpread({}, item), {}, {
                        __autocomplete_id: baseItemId++
                    });
                })
            });
        });
        store.dispatch('setCollections', value);
    };
    var setIsOpen = function setIsOpen(value) {
        store.dispatch('setIsOpen', value);
    };
    var setStatus = function setStatus(value) {
        store.dispatch('setStatus', value);
    };
    var setContext = function setContext(value) {
        store.dispatch('setContext', value);
    };
    return {
        setActiveItemId: setActiveItemId,
        setQuery: setQuery,
        setCollections: setCollections,
        setIsOpen: setIsOpen,
        setStatus: setStatus,
        setContext: setContext
    };
}

});
parcelRegister("1vxGN", function(module, exports) {
$parcel$export(module.exports, "flatten", function () { return $1192d1ab55f1a918$export$bffa455ba8c619a6; });
function $1192d1ab55f1a918$export$bffa455ba8c619a6(values) {
    return values.reduce(function(a, b) {
        return a.concat(b);
    }, []);
}

});


parcelRegister("enUj9", function(module, exports) {
$parcel$export(module.exports, "getDefaultProps", function () { return $a78ee44022efa971$export$61b94149aeb1f59; });

var $1vxGN = parcelRequire("1vxGN");
var $sg5dP = parcelRequire("sg5dP");
var $jEZ6e = parcelRequire("jEZ6e");

var $3Ikn5 = parcelRequire("3Ikn5");
function $a78ee44022efa971$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a78ee44022efa971$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a78ee44022efa971$var$_typeof(obj);
}
function $a78ee44022efa971$var$_toConsumableArray(arr) {
    return $a78ee44022efa971$var$_arrayWithoutHoles(arr) || $a78ee44022efa971$var$_iterableToArray(arr) || $a78ee44022efa971$var$_unsupportedIterableToArray(arr) || $a78ee44022efa971$var$_nonIterableSpread();
}
function $a78ee44022efa971$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a78ee44022efa971$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a78ee44022efa971$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a78ee44022efa971$var$_arrayLikeToArray(o, minLen);
}
function $a78ee44022efa971$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a78ee44022efa971$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a78ee44022efa971$var$_arrayLikeToArray(arr);
}
function $a78ee44022efa971$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a78ee44022efa971$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a78ee44022efa971$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a78ee44022efa971$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a78ee44022efa971$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a78ee44022efa971$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a78ee44022efa971$var$_defineProperty(obj, key, value) {
    key = $a78ee44022efa971$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a78ee44022efa971$var$_toPropertyKey(arg) {
    var key = $a78ee44022efa971$var$_toPrimitive(arg, "string");
    return $a78ee44022efa971$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a78ee44022efa971$var$_toPrimitive(input, hint) {
    if ($a78ee44022efa971$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a78ee44022efa971$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a78ee44022efa971$export$61b94149aeb1f59(props, pluginSubscribers) {
    var _props$id;
    /* eslint-disable no-restricted-globals */ var environment = typeof window !== 'undefined' ? window : {};
    /* eslint-enable no-restricted-globals */ var plugins = props.plugins || [];
    return $a78ee44022efa971$var$_objectSpread($a78ee44022efa971$var$_objectSpread({
        debug: false,
        openOnFocus: false,
        enterKeyHint: undefined,
        ignoreCompositionEvents: false,
        placeholder: '',
        autoFocus: false,
        defaultActiveItemId: null,
        stallThreshold: 300,
        insights: undefined,
        environment: environment,
        shouldPanelOpen: function shouldPanelOpen(_ref) {
            var state = _ref.state;
            return (0, $jEZ6e.getItemsCount)(state) > 0;
        },
        reshape: function reshape(_ref2) {
            var sources = _ref2.sources;
            return sources;
        }
    }, props), {}, {
        // Since `generateAutocompleteId` triggers a side effect (it increments
        // an internal counter), we don't want to execute it if unnecessary.
        id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : (0, $sg5dP.generateAutocompleteId)(),
        plugins: plugins,
        // The following props need to be deeply defaulted.
        initialState: $a78ee44022efa971$var$_objectSpread({
            activeItemId: null,
            query: '',
            completion: null,
            collections: [],
            isOpen: false,
            status: 'idle',
            context: {}
        }, props.initialState),
        onStateChange: function onStateChange(params) {
            var _props$onStateChange;
            (_props$onStateChange = props.onStateChange) === null || _props$onStateChange === void 0 || _props$onStateChange.call(props, params);
            plugins.forEach(function(x) {
                var _x$onStateChange;
                return (_x$onStateChange = x.onStateChange) === null || _x$onStateChange === void 0 ? void 0 : _x$onStateChange.call(x, params);
            });
        },
        onSubmit: function onSubmit(params) {
            var _props$onSubmit;
            (_props$onSubmit = props.onSubmit) === null || _props$onSubmit === void 0 || _props$onSubmit.call(props, params);
            plugins.forEach(function(x) {
                var _x$onSubmit;
                return (_x$onSubmit = x.onSubmit) === null || _x$onSubmit === void 0 ? void 0 : _x$onSubmit.call(x, params);
            });
        },
        onReset: function onReset(params) {
            var _props$onReset;
            (_props$onReset = props.onReset) === null || _props$onReset === void 0 || _props$onReset.call(props, params);
            plugins.forEach(function(x) {
                var _x$onReset;
                return (_x$onReset = x.onReset) === null || _x$onReset === void 0 ? void 0 : _x$onReset.call(x, params);
            });
        },
        getSources: function getSources(params) {
            return Promise.all([].concat($a78ee44022efa971$var$_toConsumableArray(plugins.map(function(plugin) {
                return plugin.getSources;
            })), [
                props.getSources
            ]).filter(Boolean).map(function(getSources) {
                return (0, $3Ikn5.getNormalizedSources)(getSources, params);
            })).then(function(nested) {
                return (0, $1vxGN.flatten)(nested);
            }).then(function(sources) {
                return sources.map(function(source) {
                    return $a78ee44022efa971$var$_objectSpread($a78ee44022efa971$var$_objectSpread({}, source), {}, {
                        onSelect: function onSelect(params) {
                            source.onSelect(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onSelect;
                                return (_x$onSelect = x.onSelect) === null || _x$onSelect === void 0 ? void 0 : _x$onSelect.call(x, params);
                            });
                        },
                        onActive: function onActive(params) {
                            source.onActive(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onActive;
                                return (_x$onActive = x.onActive) === null || _x$onActive === void 0 ? void 0 : _x$onActive.call(x, params);
                            });
                        },
                        onResolve: function onResolve(params) {
                            source.onResolve(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onResolve;
                                return (_x$onResolve = x.onResolve) === null || _x$onResolve === void 0 ? void 0 : _x$onResolve.call(x, params);
                            });
                        }
                    });
                });
            });
        },
        navigator: $a78ee44022efa971$var$_objectSpread({
            navigate: function navigate(_ref3) {
                var itemUrl = _ref3.itemUrl;
                environment.location.assign(itemUrl);
            },
            navigateNewTab: function navigateNewTab(_ref4) {
                var itemUrl = _ref4.itemUrl;
                var windowReference = environment.open(itemUrl, '_blank', 'noopener');
                windowReference === null || windowReference === void 0 || windowReference.focus();
            },
            navigateNewWindow: function navigateNewWindow(_ref5) {
                var itemUrl = _ref5.itemUrl;
                environment.open(itemUrl, '_blank', 'noopener');
            }
        }, props.navigator)
    });
}

});
parcelRegister("sg5dP", function(module, exports) {
$parcel$export(module.exports, "generateAutocompleteId", function () { return $054f176efd652a15$export$46ae397d8484b6c2; });
var $054f176efd652a15$var$autocompleteId = 0;
function $054f176efd652a15$export$46ae397d8484b6c2() {
    return "autocomplete-".concat($054f176efd652a15$var$autocompleteId++);
}

});

parcelRegister("jEZ6e", function(module, exports) {
$parcel$export(module.exports, "getItemsCount", function () { return $e50125d4924f9fa4$export$dd01a43948d7de86; });
function $e50125d4924f9fa4$export$dd01a43948d7de86(state) {
    if (state.collections.length === 0) return 0;
    return state.collections.reduce(function(sum, collection) {
        return sum + collection.items.length;
    }, 0);
}

});

parcelRegister("3Ikn5", function(module, exports) {
$parcel$export(module.exports, "getNormalizedSources", function () { return $2b454881a4508d18$export$c7afda361f77b571; });

var $ff2jI = parcelRequire("ff2jI");
var $d8L6Z = parcelRequire("d8L6Z");
var $4UBPb = parcelRequire("4UBPb");
function $2b454881a4508d18$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2b454881a4508d18$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2b454881a4508d18$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2b454881a4508d18$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2b454881a4508d18$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2b454881a4508d18$var$_defineProperty(obj, key, value) {
    key = $2b454881a4508d18$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2b454881a4508d18$var$_toPropertyKey(arg) {
    var key = $2b454881a4508d18$var$_toPrimitive(arg, "string");
    return $2b454881a4508d18$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2b454881a4508d18$var$_toPrimitive(input, hint) {
    if ($2b454881a4508d18$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2b454881a4508d18$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2b454881a4508d18$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2b454881a4508d18$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2b454881a4508d18$var$_typeof(obj);
}
function $2b454881a4508d18$export$c7afda361f77b571(getSources, params) {
    var seenSourceIds = [];
    return Promise.resolve(getSources(params)).then(function(sources) {
        (0, $d8L6Z.invariant)(Array.isArray(sources), function() {
            return "The `getSources` function must return an array of sources but returned type ".concat(JSON.stringify($2b454881a4508d18$var$_typeof(sources)), ":\n\n").concat(JSON.stringify((0, $ff2jI.decycle)(sources), null, 2));
        });
        return Promise.all(sources// We allow `undefined` and `false` sources to allow users to use
        // `Boolean(query) && source` (=> `false`).
        // We need to remove these values at this point.
        .filter(function(maybeSource) {
            return Boolean(maybeSource);
        }).map(function(source) {
            (0, $d8L6Z.invariant)(typeof source.sourceId === 'string', 'A source must provide a `sourceId` string.');
            if (seenSourceIds.includes(source.sourceId)) throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(source.sourceId), " is not unique."));
            seenSourceIds.push(source.sourceId);
            var defaultSource = {
                getItemInputValue: function getItemInputValue(_ref) {
                    var state = _ref.state;
                    return state.query;
                },
                getItemUrl: function getItemUrl() {
                    return undefined;
                },
                onSelect: function onSelect(_ref2) {
                    var setIsOpen = _ref2.setIsOpen;
                    setIsOpen(false);
                },
                onActive: (0, $4UBPb.noop),
                onResolve: (0, $4UBPb.noop)
            };
            Object.keys(defaultSource).forEach(function(key) {
                defaultSource[key].__default = true;
            });
            var normalizedSource = $2b454881a4508d18$var$_objectSpread($2b454881a4508d18$var$_objectSpread({}, defaultSource), source);
            return Promise.resolve(normalizedSource);
        }));
    });
}

});
parcelRegister("ff2jI", function(module, exports) {
$parcel$export(module.exports, "decycle", function () { return $b18a0dd8026d8b1e$export$ed3e2bdb532b061f; });
function $b18a0dd8026d8b1e$var$_slicedToArray(arr, i) {
    return $b18a0dd8026d8b1e$var$_arrayWithHoles(arr) || $b18a0dd8026d8b1e$var$_iterableToArrayLimit(arr, i) || $b18a0dd8026d8b1e$var$_unsupportedIterableToArray(arr, i) || $b18a0dd8026d8b1e$var$_nonIterableRest();
}
function $b18a0dd8026d8b1e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b18a0dd8026d8b1e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b18a0dd8026d8b1e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b18a0dd8026d8b1e$var$_arrayLikeToArray(o, minLen);
}
function $b18a0dd8026d8b1e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b18a0dd8026d8b1e$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $b18a0dd8026d8b1e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b18a0dd8026d8b1e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b18a0dd8026d8b1e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b18a0dd8026d8b1e$var$_typeof(obj);
}
function $b18a0dd8026d8b1e$export$ed3e2bdb532b061f(obj) {
    var seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    var newSeen;
    return obj;
}

});

parcelRegister("d8L6Z", function(module, exports) {
$parcel$export(module.exports, "invariant", function () { return $99109120b82184bf$export$f5708dca728d7177; });
/**
 * Throws an error if the condition is not met in development mode.
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */ function $99109120b82184bf$export$f5708dca728d7177(condition, message) {
    return;
}

});



parcelRegister("84v4f", function(module, exports) {
$parcel$export(module.exports, "getPropGetters", function () { return $5e06cbd046db1ce0$export$a4b47c9a40a3a795; });

var $4UBPb = parcelRequire("4UBPb");

var $i73ye = parcelRequire("i73ye");

var $6vTFw = parcelRequire("6vTFw");

var $4yZqM = parcelRequire("4yZqM");
var $fjO3C = parcelRequire("fjO3C");
var $5lcGl = parcelRequire("5lcGl");
var $5JUtW = parcelRequire("5JUtW");
var $e1A1D = parcelRequire("e1A1D");
function $5e06cbd046db1ce0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5e06cbd046db1ce0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5e06cbd046db1ce0$var$_typeof(obj);
}
var $5e06cbd046db1ce0$var$_excluded = [
    "props",
    "refresh",
    "store"
], $5e06cbd046db1ce0$var$_excluded2 = [
    "inputElement",
    "formElement",
    "panelElement"
], $5e06cbd046db1ce0$var$_excluded3 = [
    "inputElement"
], $5e06cbd046db1ce0$var$_excluded4 = [
    "inputElement",
    "maxLength"
], $5e06cbd046db1ce0$var$_excluded5 = [
    "source"
], $5e06cbd046db1ce0$var$_excluded6 = [
    "item",
    "source"
];
function $5e06cbd046db1ce0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5e06cbd046db1ce0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5e06cbd046db1ce0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5e06cbd046db1ce0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5e06cbd046db1ce0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5e06cbd046db1ce0$var$_defineProperty(obj, key, value) {
    key = $5e06cbd046db1ce0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5e06cbd046db1ce0$var$_toPropertyKey(arg) {
    var key = $5e06cbd046db1ce0$var$_toPrimitive(arg, "string");
    return $5e06cbd046db1ce0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5e06cbd046db1ce0$var$_toPrimitive(input, hint) {
    if ($5e06cbd046db1ce0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5e06cbd046db1ce0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5e06cbd046db1ce0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5e06cbd046db1ce0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5e06cbd046db1ce0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5e06cbd046db1ce0$export$a4b47c9a40a3a795(_ref) {
    var props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $5e06cbd046db1ce0$var$_objectWithoutProperties(_ref, $5e06cbd046db1ce0$var$_excluded);
    var getEnvironmentProps = function getEnvironmentProps(providedProps) {
        var inputElement = providedProps.inputElement, formElement = providedProps.formElement, panelElement = providedProps.panelElement, rest = $5e06cbd046db1ce0$var$_objectWithoutProperties(providedProps, $5e06cbd046db1ce0$var$_excluded2);
        function onMouseDownOrTouchStart(event) {
            // The `onTouchStart`/`onMouseDown` events shouldn't trigger the `blur`
            // handler when it's not an interaction with Autocomplete.
            // We detect it with the following heuristics:
            // - the panel is closed AND there are no pending requests
            //   (no interaction with the autocomplete, no future state updates)
            // - OR the touched target is the input element (should open the panel)
            var isAutocompleteInteraction = store.getState().isOpen || !store.pendingRequests.isEmpty();
            if (!isAutocompleteInteraction || event.target === inputElement) return;
            // @TODO: support cases where there are multiple Autocomplete instances.
            // Right now, a second instance makes this computation return false.
            var isTargetWithinAutocomplete = [
                formElement,
                panelElement
            ].some(function(contextNode) {
                return (0, $5JUtW.isOrContainsNode)(contextNode, event.target);
            });
            if (isTargetWithinAutocomplete === false) {
                store.dispatch('blur', null);
                // If requests are still pending when the user closes the panel, they
                // could reopen the panel once they resolve.
                // We want to prevent any subsequent query from reopening the panel
                // because it would result in an unsolicited UI behavior.
                if (!props.debug) store.pendingRequests.cancelAll();
            }
        }
        return $5e06cbd046db1ce0$var$_objectSpread({
            // We do not rely on the native `blur` event of the input to close the
            // panel, but rather on a custom `touchstart`/`mousedown` event outside
            // of the autocomplete elements.
            // This ensures we don't mistakenly interpret interactions within the
            // autocomplete (but outside of the input) as a signal to close the panel.
            // For example, clicking reset button causes an input blur, but if
            // `openOnFocus=true`, it shouldn't close the panel.
            // On touch devices, scrolling results (`touchmove`) causes an input blur
            // but shouldn't close the panel.
            onTouchStart: onMouseDownOrTouchStart,
            onMouseDown: onMouseDownOrTouchStart,
            // When scrolling on touch devices (mobiles, tablets, etc.), we want to
            // mimic the native platform behavior where the input is blurred to
            // hide the virtual keyboard. This gives more vertical space to
            // discover all the suggestions showing up in the panel.
            onTouchMove: function onTouchMove(event) {
                if (store.getState().isOpen === false || inputElement !== props.environment.document.activeElement || event.target === inputElement) return;
                inputElement.blur();
            }
        }, rest);
    };
    var getRootProps = function getRootProps(rest) {
        return $5e06cbd046db1ce0$var$_objectSpread({
            role: 'combobox',
            'aria-expanded': store.getState().isOpen,
            'aria-haspopup': 'listbox',
            'aria-controls': store.getState().isOpen ? store.getState().collections.map(function(_ref2) {
                var source = _ref2.source;
                return (0, $fjO3C.getAutocompleteElementId)(props.id, 'list', source);
            }).join(' ') : undefined,
            'aria-labelledby': (0, $fjO3C.getAutocompleteElementId)(props.id, 'label')
        }, rest);
    };
    var getFormProps = function getFormProps(providedProps) {
        var inputElement = providedProps.inputElement, rest = $5e06cbd046db1ce0$var$_objectWithoutProperties(providedProps, $5e06cbd046db1ce0$var$_excluded3);
        return $5e06cbd046db1ce0$var$_objectSpread({
            action: '',
            noValidate: true,
            role: 'search',
            onSubmit: function onSubmit(event) {
                var _providedProps$inputE;
                event.preventDefault();
                props.onSubmit($5e06cbd046db1ce0$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch('submit', null);
                (_providedProps$inputE = providedProps.inputElement) === null || _providedProps$inputE === void 0 || _providedProps$inputE.blur();
            },
            onReset: function onReset(event) {
                var _providedProps$inputE2;
                event.preventDefault();
                props.onReset($5e06cbd046db1ce0$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch('reset', null);
                (_providedProps$inputE2 = providedProps.inputElement) === null || _providedProps$inputE2 === void 0 || _providedProps$inputE2.focus();
            }
        }, rest);
    };
    var getInputProps = function getInputProps(providedProps) {
        var _props$environment$na;
        function onFocus(event) {
            // We want to trigger a query when `openOnFocus` is true
            // because the panel should open with the current query.
            if (props.openOnFocus || Boolean(store.getState().query)) (0, $i73ye.onInput)($5e06cbd046db1ce0$var$_objectSpread({
                event: event,
                props: props,
                query: store.getState().completion || store.getState().query,
                refresh: refresh,
                store: store
            }, setters));
            store.dispatch('focus', null);
        }
        var _ref3 = providedProps || {}, inputElement = _ref3.inputElement, _ref3$maxLength = _ref3.maxLength, maxLength = _ref3$maxLength === void 0 ? 512 : _ref3$maxLength, rest = $5e06cbd046db1ce0$var$_objectWithoutProperties(_ref3, $5e06cbd046db1ce0$var$_excluded4);
        var activeItem = (0, $4yZqM.getActiveItem)(store.getState());
        var userAgent = ((_props$environment$na = props.environment.navigator) === null || _props$environment$na === void 0 ? void 0 : _props$environment$na.userAgent) || '';
        var shouldFallbackKeyHint = (0, $e1A1D.isSamsung)(userAgent);
        var enterKeyHint = props.enterKeyHint || (activeItem !== null && activeItem !== void 0 && activeItem.itemUrl && !shouldFallbackKeyHint ? 'go' : 'search');
        return $5e06cbd046db1ce0$var$_objectSpread({
            'aria-autocomplete': 'both',
            'aria-activedescendant': store.getState().isOpen && store.getState().activeItemId !== null ? (0, $fjO3C.getAutocompleteElementId)(props.id, "item-".concat(store.getState().activeItemId), activeItem === null || activeItem === void 0 ? void 0 : activeItem.source) : undefined,
            'aria-controls': store.getState().isOpen ? store.getState().collections.map(function(_ref4) {
                var source = _ref4.source;
                return (0, $fjO3C.getAutocompleteElementId)(props.id, 'list', source);
            }).join(' ') : undefined,
            'aria-labelledby': (0, $fjO3C.getAutocompleteElementId)(props.id, 'label'),
            value: store.getState().completion || store.getState().query,
            id: (0, $fjO3C.getAutocompleteElementId)(props.id, 'input'),
            autoComplete: 'off',
            autoCorrect: 'off',
            autoCapitalize: 'off',
            enterKeyHint: enterKeyHint,
            spellCheck: 'false',
            autoFocus: props.autoFocus,
            placeholder: props.placeholder,
            maxLength: maxLength,
            type: 'search',
            onChange: function onChange(event) {
                var value = event.currentTarget.value;
                if (props.ignoreCompositionEvents && (0, $5lcGl.getNativeEvent)(event).isComposing) {
                    setters.setQuery(value);
                    return;
                }
                (0, $i73ye.onInput)($5e06cbd046db1ce0$var$_objectSpread({
                    event: event,
                    props: props,
                    query: value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onCompositionEnd: function onCompositionEnd(event) {
                (0, $i73ye.onInput)($5e06cbd046db1ce0$var$_objectSpread({
                    event: event,
                    props: props,
                    query: event.currentTarget.value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onKeyDown: function onKeyDown(event) {
                if ((0, $5lcGl.getNativeEvent)(event).isComposing) return;
                (0, $6vTFw.onKeyDown)($5e06cbd046db1ce0$var$_objectSpread({
                    event: event,
                    props: props,
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onFocus: onFocus,
            // We don't rely on the `blur` event.
            // See explanation in `onTouchStart`/`onMouseDown`.
            // @MAJOR See if we need to keep this handler.
            onBlur: (0, $4UBPb.noop),
            onClick: function onClick(event) {
                // When the panel is closed and you click on the input while
                // the input is focused, the `onFocus` event is not triggered
                // (default browser behavior).
                // In an autocomplete context, it makes sense to open the panel in this
                // case.
                // We mimic this event by catching the `onClick` event which
                // triggers the `onFocus` for the panel to open.
                if (providedProps.inputElement === props.environment.document.activeElement && !store.getState().isOpen) onFocus(event);
            }
        }, rest);
    };
    var getLabelProps = function getLabelProps(rest) {
        return $5e06cbd046db1ce0$var$_objectSpread({
            htmlFor: (0, $fjO3C.getAutocompleteElementId)(props.id, 'input'),
            id: (0, $fjO3C.getAutocompleteElementId)(props.id, 'label')
        }, rest);
    };
    var getListProps = function getListProps(providedProps) {
        var _ref5 = providedProps || {}, source = _ref5.source, rest = $5e06cbd046db1ce0$var$_objectWithoutProperties(_ref5, $5e06cbd046db1ce0$var$_excluded5);
        return $5e06cbd046db1ce0$var$_objectSpread({
            role: 'listbox',
            'aria-labelledby': (0, $fjO3C.getAutocompleteElementId)(props.id, 'label'),
            id: (0, $fjO3C.getAutocompleteElementId)(props.id, 'list', source)
        }, rest);
    };
    var getPanelProps = function getPanelProps(rest) {
        return $5e06cbd046db1ce0$var$_objectSpread({
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the panel so
                // that the blur event is not triggered, otherwise it closes the
                // panel.
                event.preventDefault();
            },
            onMouseLeave: function onMouseLeave() {
                store.dispatch('mouseleave', null);
            }
        }, rest);
    };
    var getItemProps = function getItemProps(providedProps) {
        var item = providedProps.item, source = providedProps.source, rest = $5e06cbd046db1ce0$var$_objectWithoutProperties(providedProps, $5e06cbd046db1ce0$var$_excluded6);
        return $5e06cbd046db1ce0$var$_objectSpread({
            id: (0, $fjO3C.getAutocompleteElementId)(props.id, "item-".concat(item.__autocomplete_id), source),
            role: 'option',
            'aria-selected': store.getState().activeItemId === item.__autocomplete_id,
            onMouseMove: function onMouseMove(event) {
                if (item.__autocomplete_id === store.getState().activeItemId) return;
                store.dispatch('mousemove', item.__autocomplete_id);
                var activeItem = (0, $4yZqM.getActiveItem)(store.getState());
                if (store.getState().activeItemId !== null && activeItem) {
                    var _item = activeItem.item, itemInputValue = activeItem.itemInputValue, itemUrl = activeItem.itemUrl, _source = activeItem.source;
                    _source.onActive($5e06cbd046db1ce0$var$_objectSpread({
                        event: event,
                        item: _item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: _source,
                        state: store.getState()
                    }, setters));
                }
            },
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the item so it
                // can remain with the current `activeElement`.
                event.preventDefault();
            },
            onClick: function onClick(event) {
                var itemInputValue = source.getItemInputValue({
                    item: item,
                    state: store.getState()
                });
                var itemUrl = source.getItemUrl({
                    item: item,
                    state: store.getState()
                });
                // If `getItemUrl` is provided, it means that the suggestion
                // is a link, not plain text that aims at updating the query.
                // We can therefore skip the state change because it will update
                // the `activeItemId`, resulting in a UI flash, especially
                // noticeable on mobile.
                var runPreCommand = itemUrl ? Promise.resolve() : (0, $i73ye.onInput)($5e06cbd046db1ce0$var$_objectSpread({
                    event: event,
                    nextState: {
                        isOpen: false
                    },
                    props: props,
                    query: itemInputValue,
                    refresh: refresh,
                    store: store
                }, setters));
                runPreCommand.then(function() {
                    source.onSelect($5e06cbd046db1ce0$var$_objectSpread({
                        event: event,
                        item: item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: source,
                        state: store.getState()
                    }, setters));
                });
            }
        }, rest);
    };
    return {
        getEnvironmentProps: getEnvironmentProps,
        getRootProps: getRootProps,
        getFormProps: getFormProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getPanelProps: getPanelProps,
        getListProps: getListProps,
        getItemProps: getItemProps
    };
}

});
parcelRegister("i73ye", function(module, exports) {
$parcel$export(module.exports, "onInput", function () { return $d2fba2a437525ada$export$7fbc06d7c1beb512; });

var $bEL20 = parcelRequire("bEL20");

var $gTzdr = parcelRequire("gTzdr");

var $cXQgl = parcelRequire("cXQgl");
var $cZbLb = parcelRequire("cZbLb");
var $4yZqM = parcelRequire("4yZqM");
function $d2fba2a437525ada$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d2fba2a437525ada$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d2fba2a437525ada$var$_typeof(obj);
}
var $d2fba2a437525ada$var$_excluded = [
    "event",
    "nextState",
    "props",
    "query",
    "refresh",
    "store"
];
function $d2fba2a437525ada$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d2fba2a437525ada$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d2fba2a437525ada$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d2fba2a437525ada$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d2fba2a437525ada$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d2fba2a437525ada$var$_defineProperty(obj, key, value) {
    key = $d2fba2a437525ada$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d2fba2a437525ada$var$_toPropertyKey(arg) {
    var key = $d2fba2a437525ada$var$_toPrimitive(arg, "string");
    return $d2fba2a437525ada$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d2fba2a437525ada$var$_toPrimitive(input, hint) {
    if ($d2fba2a437525ada$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d2fba2a437525ada$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d2fba2a437525ada$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d2fba2a437525ada$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d2fba2a437525ada$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d2fba2a437525ada$var$lastStalledId = null;
var $d2fba2a437525ada$var$runConcurrentSafePromise = (0, $cZbLb.createConcurrentSafePromise)();
function $d2fba2a437525ada$export$7fbc06d7c1beb512(_ref) {
    var event = _ref.event, _ref$nextState = _ref.nextState, nextState = _ref$nextState === void 0 ? {} : _ref$nextState, props = _ref.props, query = _ref.query, refresh = _ref.refresh, store = _ref.store, setters = $d2fba2a437525ada$var$_objectWithoutProperties(_ref, $d2fba2a437525ada$var$_excluded);
    if ($d2fba2a437525ada$var$lastStalledId) props.environment.clearTimeout($d2fba2a437525ada$var$lastStalledId);
    var setCollections = setters.setCollections, setIsOpen = setters.setIsOpen, setQuery = setters.setQuery, setActiveItemId = setters.setActiveItemId, setStatus = setters.setStatus, setContext = setters.setContext;
    setQuery(query);
    setActiveItemId(props.defaultActiveItemId);
    if (!query && props.openOnFocus === false) {
        var _nextState$isOpen;
        var collections = store.getState().collections.map(function(collection) {
            return $d2fba2a437525ada$var$_objectSpread($d2fba2a437525ada$var$_objectSpread({}, collection), {}, {
                items: []
            });
        });
        setStatus('idle');
        setCollections(collections);
        setIsOpen((_nextState$isOpen = nextState.isOpen) !== null && _nextState$isOpen !== void 0 ? _nextState$isOpen : props.shouldPanelOpen({
            state: store.getState()
        }));
        // We make sure to update the latest resolved value of the tracked
        // promises to keep late resolving promises from "cancelling" the state
        // updates performed in this code path.
        // We chain with a void promise to respect `onInput`'s expected return type.
        var _request = (0, $cXQgl.cancelable)($d2fba2a437525ada$var$runConcurrentSafePromise(collections).then(function() {
            return Promise.resolve();
        }));
        return store.pendingRequests.add(_request);
    }
    setStatus('loading');
    $d2fba2a437525ada$var$lastStalledId = props.environment.setTimeout(function() {
        setStatus('stalled');
    }, props.stallThreshold);
    // We track the entire promise chain triggered by `onInput` before mutating
    // the Autocomplete state to make sure that any state manipulation is based on
    // fresh data regardless of when promises individually resolve.
    // We don't track nested promises and only rely on the full chain resolution,
    // meaning we should only ever manipulate the state once this concurrent-safe
    // promise is resolved.
    var request = (0, $cXQgl.cancelable)($d2fba2a437525ada$var$runConcurrentSafePromise(props.getSources($d2fba2a437525ada$var$_objectSpread({
        query: query,
        refresh: refresh,
        state: store.getState()
    }, setters)).then(function(sources) {
        return Promise.all(sources.map(function(source) {
            return Promise.resolve(source.getItems($d2fba2a437525ada$var$_objectSpread({
                query: query,
                refresh: refresh,
                state: store.getState()
            }, setters))).then(function(itemsOrDescription) {
                return (0, $gTzdr.preResolve)(itemsOrDescription, source.sourceId, store.getState());
            });
        })).then((0, $gTzdr.resolve)).then(function(responses) {
            var __automaticInsights = responses.some(function(_ref2) {
                var items = _ref2.items;
                return $d2fba2a437525ada$var$isSearchResponseWithAutomaticInsightsFlag(items);
            });
            // No need to pollute the context if `__automaticInsights=false`
            if (__automaticInsights) {
                var _store$getState$conte;
                setContext({
                    algoliaInsightsPlugin: $d2fba2a437525ada$var$_objectSpread($d2fba2a437525ada$var$_objectSpread({}, ((_store$getState$conte = store.getState().context) === null || _store$getState$conte === void 0 ? void 0 : _store$getState$conte.algoliaInsightsPlugin) || {}), {}, {
                        __automaticInsights: __automaticInsights
                    })
                });
            }
            return (0, $gTzdr.postResolve)(responses, sources, store);
        }).then(function(collections) {
            return (0, $bEL20.reshape)({
                collections: collections,
                props: props,
                state: store.getState()
            });
        });
    }))).then(function(collections) {
        var _nextState$isOpen2;
        // Parameters passed to `onInput` could be stale when the following code
        // executes, because `onInput` calls may not resolve in order.
        // If it becomes a problem we'll need to save the last passed parameters.
        // See: https://codesandbox.io/s/agitated-cookies-y290z
        setStatus('idle');
        setCollections(collections);
        var isPanelOpen = props.shouldPanelOpen({
            state: store.getState()
        });
        setIsOpen((_nextState$isOpen2 = nextState.isOpen) !== null && _nextState$isOpen2 !== void 0 ? _nextState$isOpen2 : props.openOnFocus && !query && isPanelOpen || isPanelOpen);
        var highlightedItem = (0, $4yZqM.getActiveItem)(store.getState());
        if (store.getState().activeItemId !== null && highlightedItem) {
            var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
            source.onActive($d2fba2a437525ada$var$_objectSpread({
                event: event,
                item: item,
                itemInputValue: itemInputValue,
                itemUrl: itemUrl,
                refresh: refresh,
                source: source,
                state: store.getState()
            }, setters));
        }
    }).finally(function() {
        setStatus('idle');
        if ($d2fba2a437525ada$var$lastStalledId) props.environment.clearTimeout($d2fba2a437525ada$var$lastStalledId);
    });
    return store.pendingRequests.add(request);
}
function $d2fba2a437525ada$var$isSearchResponseWithAutomaticInsightsFlag(items) {
    return !Array.isArray(items) && Boolean(items === null || items === void 0 ? void 0 : items._automaticInsights);
}

});
parcelRegister("bEL20", function(module, exports) {
$parcel$export(module.exports, "reshape", function () { return $87c7e99318e36415$export$9eaad88cf88cee2b; });

var $1vxGN = parcelRequire("1vxGN");
function $87c7e99318e36415$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $87c7e99318e36415$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $87c7e99318e36415$var$_typeof(obj);
}
function $87c7e99318e36415$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87c7e99318e36415$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87c7e99318e36415$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87c7e99318e36415$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87c7e99318e36415$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87c7e99318e36415$var$_defineProperty(obj, key, value) {
    key = $87c7e99318e36415$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87c7e99318e36415$var$_toPropertyKey(arg) {
    var key = $87c7e99318e36415$var$_toPrimitive(arg, "string");
    return $87c7e99318e36415$var$_typeof(key) === "symbol" ? key : String(key);
}
function $87c7e99318e36415$var$_toPrimitive(input, hint) {
    if ($87c7e99318e36415$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($87c7e99318e36415$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $87c7e99318e36415$export$9eaad88cf88cee2b(_ref) {
    var collections = _ref.collections, props = _ref.props, state = _ref.state;
    // Sources are grouped by `sourceId` to conveniently pick them via destructuring.
    // Example: `const { recentSearchesPlugin } = sourcesBySourceId`
    var originalSourcesBySourceId = collections.reduce(function(acc, collection) {
        return $87c7e99318e36415$var$_objectSpread($87c7e99318e36415$var$_objectSpread({}, acc), {}, $87c7e99318e36415$var$_defineProperty({}, collection.source.sourceId, $87c7e99318e36415$var$_objectSpread($87c7e99318e36415$var$_objectSpread({}, collection.source), {}, {
            getItems: function getItems() {
                // We provide the resolved items from the collection to the `reshape` prop.
                return (0, $1vxGN.flatten)(collection.items);
            }
        })));
    }, {});
    var _props$plugins$reduce = props.plugins.reduce(function(acc, plugin) {
        if (plugin.reshape) return plugin.reshape(acc);
        return acc;
    }, {
        sourcesBySourceId: originalSourcesBySourceId,
        state: state
    }), sourcesBySourceId = _props$plugins$reduce.sourcesBySourceId;
    var reshapeSources = props.reshape({
        sourcesBySourceId: sourcesBySourceId,
        sources: Object.values(sourcesBySourceId),
        state: state
    });
    // We reconstruct the collections with the items modified by the `reshape` prop.
    return (0, $1vxGN.flatten)(reshapeSources).filter(Boolean).map(function(source) {
        return {
            source: source,
            items: source.getItems()
        };
    });
}

});

parcelRegister("gTzdr", function(module, exports) {
$parcel$export(module.exports, "preResolve", function () { return $c4cd198721b49c67$export$ae3cd3529c74e69e; });
$parcel$export(module.exports, "resolve", function () { return $c4cd198721b49c67$export$f7ad0328861e2f03; });
$parcel$export(module.exports, "postResolve", function () { return $c4cd198721b49c67$export$c1b3edf5a28f586; });

var $ff2jI = parcelRequire("ff2jI");
var $1vxGN = parcelRequire("1vxGN");
var $d8L6Z = parcelRequire("d8L6Z");

var $8JJ1U = parcelRequire("8JJ1U");
function $c4cd198721b49c67$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c4cd198721b49c67$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c4cd198721b49c67$var$_typeof(obj);
}
function $c4cd198721b49c67$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c4cd198721b49c67$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c4cd198721b49c67$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c4cd198721b49c67$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c4cd198721b49c67$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c4cd198721b49c67$var$_defineProperty(obj, key, value) {
    key = $c4cd198721b49c67$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c4cd198721b49c67$var$_toPropertyKey(arg) {
    var key = $c4cd198721b49c67$var$_toPrimitive(arg, "string");
    return $c4cd198721b49c67$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c4cd198721b49c67$var$_toPrimitive(input, hint) {
    if ($c4cd198721b49c67$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c4cd198721b49c67$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c4cd198721b49c67$var$_toConsumableArray(arr) {
    return $c4cd198721b49c67$var$_arrayWithoutHoles(arr) || $c4cd198721b49c67$var$_iterableToArray(arr) || $c4cd198721b49c67$var$_unsupportedIterableToArray(arr) || $c4cd198721b49c67$var$_nonIterableSpread();
}
function $c4cd198721b49c67$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c4cd198721b49c67$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c4cd198721b49c67$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c4cd198721b49c67$var$_arrayLikeToArray(o, minLen);
}
function $c4cd198721b49c67$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c4cd198721b49c67$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c4cd198721b49c67$var$_arrayLikeToArray(arr);
}
function $c4cd198721b49c67$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c4cd198721b49c67$var$isDescription(item) {
    return Boolean(item.execute);
}
function $c4cd198721b49c67$var$isRequesterDescription(description) {
    return Boolean(description === null || description === void 0 ? void 0 : description.execute);
}
function $c4cd198721b49c67$export$ae3cd3529c74e69e(itemsOrDescription, sourceId, state) {
    if ($c4cd198721b49c67$var$isRequesterDescription(itemsOrDescription)) {
        var contextParameters = itemsOrDescription.requesterId === 'algolia' ? Object.assign.apply(Object, [
            {}
        ].concat($c4cd198721b49c67$var$_toConsumableArray(Object.keys(state.context).map(function(key) {
            var _state$context$key;
            return (_state$context$key = state.context[key]) === null || _state$context$key === void 0 ? void 0 : _state$context$key.__algoliaSearchParameters;
        })))) : {};
        return $c4cd198721b49c67$var$_objectSpread($c4cd198721b49c67$var$_objectSpread({}, itemsOrDescription), {}, {
            requests: itemsOrDescription.queries.map(function(query) {
                return {
                    query: itemsOrDescription.requesterId === 'algolia' ? $c4cd198721b49c67$var$_objectSpread($c4cd198721b49c67$var$_objectSpread({}, query), {}, {
                        params: $c4cd198721b49c67$var$_objectSpread($c4cd198721b49c67$var$_objectSpread({}, contextParameters), query.params)
                    }) : query,
                    sourceId: sourceId,
                    transformResponse: itemsOrDescription.transformResponse
                };
            })
        });
    }
    return {
        items: itemsOrDescription,
        sourceId: sourceId
    };
}
function $c4cd198721b49c67$export$f7ad0328861e2f03(items) {
    var packed = items.reduce(function(acc, current) {
        if (!$c4cd198721b49c67$var$isDescription(current)) {
            acc.push(current);
            return acc;
        }
        var searchClient = current.searchClient, execute = current.execute, requesterId = current.requesterId, requests = current.requests;
        var container = acc.find(function(item) {
            return $c4cd198721b49c67$var$isDescription(current) && $c4cd198721b49c67$var$isDescription(item) && item.searchClient === searchClient && Boolean(requesterId) && item.requesterId === requesterId;
        });
        if (container) {
            var _container$items;
            (_container$items = container.items).push.apply(_container$items, $c4cd198721b49c67$var$_toConsumableArray(requests));
        } else {
            var request = {
                execute: execute,
                requesterId: requesterId,
                items: requests,
                searchClient: searchClient
            };
            acc.push(request);
        }
        return acc;
    }, []);
    var values = packed.map(function(maybeDescription) {
        if (!$c4cd198721b49c67$var$isDescription(maybeDescription)) return Promise.resolve(maybeDescription);
        var _ref = maybeDescription, execute = _ref.execute, items = _ref.items, searchClient = _ref.searchClient;
        return execute({
            searchClient: searchClient,
            requests: items
        });
    });
    return Promise.all(values).then(function(responses) {
        return (0, $1vxGN.flatten)(responses);
    });
}
function $c4cd198721b49c67$export$c1b3edf5a28f586(responses, sources, store) {
    return sources.map(function(source) {
        var matches = responses.filter(function(response) {
            return response.sourceId === source.sourceId;
        });
        var results = matches.map(function(_ref2) {
            var items = _ref2.items;
            return items;
        });
        var transform = matches[0].transformResponse;
        var items = transform ? transform((0, $8JJ1U.mapToAlgoliaResponse)(results)) : results;
        source.onResolve({
            source: source,
            results: results,
            items: items,
            state: store.getState()
        });
        (0, $d8L6Z.invariant)(Array.isArray(items), function() {
            return "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned type ").concat(JSON.stringify($c4cd198721b49c67$var$_typeof(items)), ":\n\n").concat(JSON.stringify((0, $ff2jI.decycle)(items), null, 2), ".\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems");
        });
        (0, $d8L6Z.invariant)(items.every(Boolean), "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned ").concat(JSON.stringify(undefined), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"));
        return {
            source: source,
            items: items
        };
    });
}

});
parcelRegister("8JJ1U", function(module, exports) {
$parcel$export(module.exports, "mapToAlgoliaResponse", function () { return $65c574af18360563$export$23042d7bd0b8d14b; });
function $65c574af18360563$export$23042d7bd0b8d14b(rawResults) {
    return {
        results: rawResults,
        hits: rawResults.map(function(result) {
            return result.hits;
        }).filter(Boolean),
        facetHits: rawResults.map(function(result) {
            var _facetHits;
            return (_facetHits = result.facetHits) === null || _facetHits === void 0 ? void 0 : _facetHits.map(function(facetHit) {
                // Bring support for the highlighting components.
                return {
                    label: facetHit.value,
                    count: facetHit.count,
                    _highlightResult: {
                        label: {
                            value: facetHit.highlighted
                        }
                    }
                };
            });
        }).filter(Boolean)
    };
}

});


parcelRegister("cXQgl", function(module, exports) {
$parcel$export(module.exports, "cancelable", function () { return $970388fbebd6055f$export$95ff25b64c2b7c9d; });
function $970388fbebd6055f$var$createInternalCancelablePromise(promise, initialState) {
    var state = initialState;
    return {
        then: function then(onfulfilled, onrejected) {
            return $970388fbebd6055f$var$createInternalCancelablePromise(promise.then($970388fbebd6055f$var$createCallback(onfulfilled, state, promise), $970388fbebd6055f$var$createCallback(onrejected, state, promise)), state);
        },
        catch: function _catch(onrejected) {
            return $970388fbebd6055f$var$createInternalCancelablePromise(promise.catch($970388fbebd6055f$var$createCallback(onrejected, state, promise)), state);
        },
        finally: function _finally(onfinally) {
            if (onfinally) state.onCancelList.push(onfinally);
            return $970388fbebd6055f$var$createInternalCancelablePromise(promise.finally($970388fbebd6055f$var$createCallback(onfinally && function() {
                state.onCancelList = [];
                return onfinally();
            }, state, promise)), state);
        },
        cancel: function cancel() {
            state.isCanceled = true;
            var callbacks = state.onCancelList;
            state.onCancelList = [];
            callbacks.forEach(function(callback) {
                callback();
            });
        },
        isCanceled: function isCanceled() {
            return state.isCanceled === true;
        }
    };
}
function $970388fbebd6055f$export$72af18a8b033265c(executor) {
    return $970388fbebd6055f$var$createInternalCancelablePromise(new Promise(function(resolve, reject) {
        return executor(resolve, reject);
    }), {
        isCanceled: false,
        onCancelList: []
    });
}
$970388fbebd6055f$export$72af18a8b033265c.resolve = function(value) {
    return $970388fbebd6055f$export$95ff25b64c2b7c9d(Promise.resolve(value));
};
$970388fbebd6055f$export$72af18a8b033265c.reject = function(reason) {
    return $970388fbebd6055f$export$95ff25b64c2b7c9d(Promise.reject(reason));
};
function $970388fbebd6055f$export$95ff25b64c2b7c9d(promise) {
    return $970388fbebd6055f$var$createInternalCancelablePromise(promise, {
        isCanceled: false,
        onCancelList: []
    });
}
function $970388fbebd6055f$var$createCallback(onResult, state, fallback) {
    if (!onResult) return fallback;
    return function callback(arg) {
        if (state.isCanceled) return arg;
        return onResult(arg);
    };
}

});

parcelRegister("cZbLb", function(module, exports) {
$parcel$export(module.exports, "createConcurrentSafePromise", function () { return $97444dd51d290f6d$export$8829b68d73f73d13; });
/**
 * Creates a runner that executes promises in a concurrent-safe way.
 *
 * This is useful to prevent older promises to resolve after a newer promise,
 * otherwise resulting in stale resolved values.
 */ function $97444dd51d290f6d$export$8829b68d73f73d13() {
    var basePromiseId = -1;
    var latestResolvedId = -1;
    var latestResolvedValue = undefined;
    return function runConcurrentSafePromise(promise) {
        basePromiseId++;
        var currentPromiseId = basePromiseId;
        return Promise.resolve(promise).then(function(x) {
            // The promise might take too long to resolve and get outdated. This would
            // result in resolving stale values.
            // When this happens, we ignore the promise value and return the one
            // coming from the latest resolved value.
            //
            // +----------------------------------+
            // |        100ms                     |
            // | run(1) +--->  R1                 |
            // |        300ms                     |
            // | run(2) +-------------> R2 (SKIP) |
            // |        200ms                     |
            // | run(3) +--------> R3             |
            // +----------------------------------+
            if (latestResolvedValue && currentPromiseId < latestResolvedId) return latestResolvedValue;
            latestResolvedId = currentPromiseId;
            latestResolvedValue = x;
            return x;
        });
    };
}

});

parcelRegister("4yZqM", function(module, exports) {
$parcel$export(module.exports, "getActiveItem", function () { return $3529fd535f995c61$export$f0f14253205ef68f; });
// We don't have access to the autocomplete source when we call `onKeyDown`
// or `onClick` because those are native browser events.
// However, we can get the source from the suggestion index.
function $3529fd535f995c61$var$getCollectionFromActiveItemId(state) {
    // Given 3 sources with respectively 1, 2 and 3 suggestions: [1, 2, 3]
    // We want to get the accumulated counts:
    // [1, 1 + 2, 1 + 2 + 3] = [1, 3, 3 + 3] = [1, 3, 6]
    var accumulatedCollectionsCount = state.collections.map(function(collections) {
        return collections.items.length;
    }).reduce(function(acc, collectionsCount, index) {
        var previousValue = acc[index - 1] || 0;
        var nextValue = previousValue + collectionsCount;
        acc.push(nextValue);
        return acc;
    }, []);
    // Based on the accumulated counts, we can infer the index of the suggestion.
    var collectionIndex = accumulatedCollectionsCount.reduce(function(acc, current) {
        if (current <= state.activeItemId) return acc + 1;
        return acc;
    }, 0);
    return state.collections[collectionIndex];
}
/**
 * Gets the highlighted index relative to a suggestion object (not the absolute
 * highlighted index).
 *
 * Example:
 *  [['a', 'b'], ['c', 'd', 'e'], ['f']]
 *                      ↑
 *         (absolute: 3, relative: 1)
 */ function $3529fd535f995c61$var$getRelativeActiveItemId(_ref) {
    var state = _ref.state, collection = _ref.collection;
    var isOffsetFound = false;
    var counter = 0;
    var previousItemsOffset = 0;
    while(isOffsetFound === false){
        var currentCollection = state.collections[counter];
        if (currentCollection === collection) {
            isOffsetFound = true;
            break;
        }
        previousItemsOffset += currentCollection.items.length;
        counter++;
    }
    return state.activeItemId - previousItemsOffset;
}
function $3529fd535f995c61$export$f0f14253205ef68f(state) {
    var collection = $3529fd535f995c61$var$getCollectionFromActiveItemId(state);
    if (!collection) return null;
    var item = collection.items[$3529fd535f995c61$var$getRelativeActiveItemId({
        state: state,
        collection: collection
    })];
    var source = collection.source;
    var itemInputValue = source.getItemInputValue({
        item: item,
        state: state
    });
    var itemUrl = source.getItemUrl({
        item: item,
        state: state
    });
    return {
        item: item,
        itemInputValue: itemInputValue,
        itemUrl: itemUrl,
        source: source
    };
}

});


parcelRegister("6vTFw", function(module, exports) {
$parcel$export(module.exports, "onKeyDown", function () { return $4be0d1f4dc0e3866$export$de8e1b1372cdb41b; });

var $i73ye = parcelRequire("i73ye");

var $4yZqM = parcelRequire("4yZqM");
var $fjO3C = parcelRequire("fjO3C");
function $4be0d1f4dc0e3866$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4be0d1f4dc0e3866$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4be0d1f4dc0e3866$var$_typeof(obj);
}
var $4be0d1f4dc0e3866$var$_excluded = [
    "event",
    "props",
    "refresh",
    "store"
];
function $4be0d1f4dc0e3866$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4be0d1f4dc0e3866$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4be0d1f4dc0e3866$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4be0d1f4dc0e3866$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4be0d1f4dc0e3866$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4be0d1f4dc0e3866$var$_defineProperty(obj, key, value) {
    key = $4be0d1f4dc0e3866$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4be0d1f4dc0e3866$var$_toPropertyKey(arg) {
    var key = $4be0d1f4dc0e3866$var$_toPrimitive(arg, "string");
    return $4be0d1f4dc0e3866$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4be0d1f4dc0e3866$var$_toPrimitive(input, hint) {
    if ($4be0d1f4dc0e3866$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4be0d1f4dc0e3866$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4be0d1f4dc0e3866$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4be0d1f4dc0e3866$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4be0d1f4dc0e3866$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4be0d1f4dc0e3866$export$de8e1b1372cdb41b(_ref) {
    var event = _ref.event, props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $4be0d1f4dc0e3866$var$_objectWithoutProperties(_ref, $4be0d1f4dc0e3866$var$_excluded);
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        // eslint-disable-next-line no-inner-declarations
        var triggerScrollIntoView = function triggerScrollIntoView() {
            var highlightedItem = (0, $4yZqM.getActiveItem)(store.getState());
            var nodeItem = props.environment.document.getElementById((0, $fjO3C.getAutocompleteElementId)(props.id, "item-".concat(store.getState().activeItemId), highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.source));
            if (nodeItem) {
                if (nodeItem.scrollIntoViewIfNeeded) nodeItem.scrollIntoViewIfNeeded(false);
                else nodeItem.scrollIntoView(false);
            }
        }; // eslint-disable-next-line no-inner-declarations
        var triggerOnActive = function triggerOnActive() {
            var highlightedItem = (0, $4yZqM.getActiveItem)(store.getState());
            if (store.getState().activeItemId !== null && highlightedItem) {
                var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
                source.onActive($4be0d1f4dc0e3866$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            }
        }; // Default browser behavior changes the caret placement on ArrowUp and
        // ArrowDown.
        event.preventDefault();
        // When re-opening the panel, we need to split the logic to keep the actions
        // synchronized as `onInput` returns a promise.
        if (store.getState().isOpen === false && (props.openOnFocus || Boolean(store.getState().query))) (0, $i73ye.onInput)($4be0d1f4dc0e3866$var$_objectSpread({
            event: event,
            props: props,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters)).then(function() {
            store.dispatch(event.key, {
                nextActiveItemId: props.defaultActiveItemId
            });
            triggerOnActive();
            // Since we rely on the DOM, we need to wait for all the micro tasks to
            // finish (which include re-opening the panel) to make sure all the
            // elements are available.
            setTimeout(triggerScrollIntoView, 0);
        });
        else {
            store.dispatch(event.key, {});
            triggerOnActive();
            triggerScrollIntoView();
        }
    } else if (event.key === 'Escape') {
        // This prevents the default browser behavior on `input[type="search"]`
        // from removing the query right away because we first want to close the
        // panel.
        event.preventDefault();
        store.dispatch(event.key, null);
        // Hitting the `Escape` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === 'Tab') {
        store.dispatch('blur', null);
        // Hitting the `Tab` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === 'Enter') {
        // No active item, so we let the browser handle the native `onSubmit` form
        // event.
        if (store.getState().activeItemId === null || store.getState().collections.every(function(collection) {
            return collection.items.length === 0;
        })) {
            // If requests are still pending when the panel closes, they could reopen
            // the panel once they resolve.
            // We want to prevent any subsequent query from reopening the panel
            // because it would result in an unsolicited UI behavior.
            if (!props.debug) store.pendingRequests.cancelAll();
            return;
        }
        // This prevents the `onSubmit` event to be sent because an item is
        // highlighted.
        event.preventDefault();
        var _ref2 = (0, $4yZqM.getActiveItem)(store.getState()), item = _ref2.item, itemInputValue = _ref2.itemInputValue, itemUrl = _ref2.itemUrl, source = _ref2.source;
        if (event.metaKey || event.ctrlKey) {
            if (itemUrl !== undefined) {
                source.onSelect($4be0d1f4dc0e3866$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewTab({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.shiftKey) {
            if (itemUrl !== undefined) {
                source.onSelect($4be0d1f4dc0e3866$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewWindow({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.altKey) ;
        else {
            if (itemUrl !== undefined) {
                source.onSelect($4be0d1f4dc0e3866$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigate({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
                return;
            }
            (0, $i73ye.onInput)($4be0d1f4dc0e3866$var$_objectSpread({
                event: event,
                nextState: {
                    isOpen: false
                },
                props: props,
                query: itemInputValue,
                refresh: refresh,
                store: store
            }, setters)).then(function() {
                source.onSelect($4be0d1f4dc0e3866$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            });
        }
    }
}

});
parcelRegister("fjO3C", function(module, exports) {
$parcel$export(module.exports, "getAutocompleteElementId", function () { return $b26f75b4ada9a02c$export$17f5bb35a44b3f03; });
/**
 * Returns a full element id for an autocomplete element.
 *
 * @param autocompleteInstanceId The id of the autocomplete instance
 * @param elementId The specific element id
 * @param source The source of the element, when it needs to be scoped
 */ function $b26f75b4ada9a02c$export$17f5bb35a44b3f03(autocompleteInstanceId, elementId, source) {
    return [
        autocompleteInstanceId,
        source === null || source === void 0 ? void 0 : source.sourceId,
        elementId
    ].filter(Boolean).join('-').replace(/\s/g, '');
}

});


parcelRegister("5lcGl", function(module, exports) {
$parcel$export(module.exports, "getNativeEvent", function () { return $3e38c04b6e376dcb$export$4abe0e945399ac1d; });
function $3e38c04b6e376dcb$export$4abe0e945399ac1d(event) {
    return event.nativeEvent || event;
}

});

parcelRegister("5JUtW", function(module, exports) {
$parcel$export(module.exports, "isOrContainsNode", function () { return $42dcf7deb891be56$export$428954767edfafa7; });
function $42dcf7deb891be56$export$428954767edfafa7(parent, child) {
    return parent === child || parent.contains(child);
}

});

parcelRegister("e1A1D", function(module, exports) {
$parcel$export(module.exports, "isSamsung", function () { return $a35d1a94a9355c73$export$838732a363f40fc6; });
var $a35d1a94a9355c73$var$regex = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i;
function $a35d1a94a9355c73$export$838732a363f40fc6(userAgent) {
    return Boolean(userAgent && userAgent.match($a35d1a94a9355c73$var$regex));
}

});


parcelRegister("9vYhF", function(module, exports) {
$parcel$export(module.exports, "getMetadata", function () { return $6ed5c57237c1c2a7$export$8548546c0aa631e6; });
$parcel$export(module.exports, "injectMetadata", function () { return $6ed5c57237c1c2a7$export$404feeb97c870f44; });

var $9INBx = parcelRequire("9INBx");
function $6ed5c57237c1c2a7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6ed5c57237c1c2a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6ed5c57237c1c2a7$var$_typeof(obj);
}
function $6ed5c57237c1c2a7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ed5c57237c1c2a7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6ed5c57237c1c2a7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6ed5c57237c1c2a7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6ed5c57237c1c2a7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ed5c57237c1c2a7$var$_defineProperty(obj, key, value) {
    key = $6ed5c57237c1c2a7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ed5c57237c1c2a7$var$_toPropertyKey(arg) {
    var key = $6ed5c57237c1c2a7$var$_toPrimitive(arg, "string");
    return $6ed5c57237c1c2a7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6ed5c57237c1c2a7$var$_toPrimitive(input, hint) {
    if ($6ed5c57237c1c2a7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6ed5c57237c1c2a7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6ed5c57237c1c2a7$export$8548546c0aa631e6(_ref) {
    var _, _options$__autocomple, _options$__autocomple2, _options$__autocomple3;
    var plugins = _ref.plugins, options = _ref.options;
    var optionsKey = (_ = (((_options$__autocomple = options.__autocomplete_metadata) === null || _options$__autocomple === void 0 ? void 0 : _options$__autocomple.userAgents) || [])[0]) === null || _ === void 0 ? void 0 : _.segment;
    var extraOptions = optionsKey ? $6ed5c57237c1c2a7$var$_defineProperty({}, optionsKey, Object.keys(((_options$__autocomple2 = options.__autocomplete_metadata) === null || _options$__autocomple2 === void 0 ? void 0 : _options$__autocomple2.options) || {})) : {};
    return {
        plugins: plugins.map(function(plugin) {
            return {
                name: plugin.name,
                options: Object.keys(plugin.__autocomplete_pluginOptions || [])
            };
        }),
        options: $6ed5c57237c1c2a7$var$_objectSpread({
            'autocomplete-core': Object.keys(options)
        }, extraOptions),
        ua: (0, $9INBx.userAgents).concat(((_options$__autocomple3 = options.__autocomplete_metadata) === null || _options$__autocomple3 === void 0 ? void 0 : _options$__autocomple3.userAgents) || [])
    };
}
function $6ed5c57237c1c2a7$export$404feeb97c870f44(_ref3) {
    var _environment$navigato, _environment$navigato2;
    var metadata = _ref3.metadata, environment = _ref3.environment;
    var isMetadataEnabled = (_environment$navigato = environment.navigator) === null || _environment$navigato === void 0 ? void 0 : (_environment$navigato2 = _environment$navigato.userAgent) === null || _environment$navigato2 === void 0 ? void 0 : _environment$navigato2.includes('Algolia Crawler');
    if (isMetadataEnabled) {
        var metadataContainer = environment.document.createElement('meta');
        var headRef = environment.document.querySelector('head');
        metadataContainer.name = 'algolia:metadata';
        setTimeout(function() {
            metadataContainer.content = JSON.stringify(metadata);
            headRef.appendChild(metadataContainer);
        }, 0);
    }
}

});
parcelRegister("9INBx", function(module, exports) {
$parcel$export(module.exports, "userAgents", function () { return $713eb387dd2ca1de$export$9536ea83a4cbd560; });

var $czqGF = parcelRequire("czqGF");
var $713eb387dd2ca1de$export$9536ea83a4cbd560 = [
    {
        segment: 'autocomplete-core',
        version: (0, $czqGF.version)
    }
];

});
parcelRegister("czqGF", function(module, exports) {
$parcel$export(module.exports, "version", function () { return $926d747112804a34$export$83d89fbfd8236492; });
var $926d747112804a34$export$83d89fbfd8236492 = '1.18.0';

});



parcelRegister("7tfug", function(module, exports) {
$parcel$export(module.exports, "stateReducer", function () { return $57074145fe6fe54c$export$ca8ebd435faad836; });

var $jEZ6e = parcelRequire("jEZ6e");
var $d8L6Z = parcelRequire("d8L6Z");

var $lsEW4 = parcelRequire("lsEW4");

var $1D5y1 = parcelRequire("1D5y1");
function $57074145fe6fe54c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $57074145fe6fe54c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $57074145fe6fe54c$var$_typeof(obj);
}
function $57074145fe6fe54c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $57074145fe6fe54c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $57074145fe6fe54c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $57074145fe6fe54c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $57074145fe6fe54c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $57074145fe6fe54c$var$_defineProperty(obj, key, value) {
    key = $57074145fe6fe54c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $57074145fe6fe54c$var$_toPropertyKey(arg) {
    var key = $57074145fe6fe54c$var$_toPrimitive(arg, "string");
    return $57074145fe6fe54c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $57074145fe6fe54c$var$_toPrimitive(input, hint) {
    if ($57074145fe6fe54c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($57074145fe6fe54c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $57074145fe6fe54c$export$ca8ebd435faad836 = function stateReducer(state, action) {
    switch(action.type){
        case 'setActiveItemId':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case 'setQuery':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                query: action.payload,
                completion: null
            });
        case 'setCollections':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                collections: action.payload
            });
        case 'setIsOpen':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                isOpen: action.payload
            });
        case 'setStatus':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                status: action.payload
            });
        case 'setContext':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                context: $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state.context), action.payload)
            });
        case 'ArrowDown':
            var nextState = $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload.hasOwnProperty('nextActiveItemId') ? action.payload.nextActiveItemId : (0, $1D5y1.getNextActiveItemId)(1, state.activeItemId, (0, $jEZ6e.getItemsCount)(state), action.props.defaultActiveItemId)
            });
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, nextState), {}, {
                completion: (0, $lsEW4.getCompletion)({
                    state: nextState
                })
            });
        case 'ArrowUp':
            var _nextState = $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: (0, $1D5y1.getNextActiveItemId)(-1, state.activeItemId, (0, $jEZ6e.getItemsCount)(state), action.props.defaultActiveItemId)
            });
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, _nextState), {}, {
                completion: (0, $lsEW4.getCompletion)({
                    state: _nextState
                })
            });
        case 'Escape':
            if (state.isOpen) return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                completion: null
            });
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                query: '',
                status: 'idle',
                collections: []
            });
        case 'submit':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                status: 'idle'
            });
        case 'reset':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: // Since we open the panel on reset when openOnFocus=true
                // we need to restore the highlighted index to the defaultActiveItemId. (DocSearch use-case)
                // Since we close the panel when openOnFocus=false
                // we lose track of the highlighted index. (Query-suggestions use-case)
                action.props.openOnFocus === true ? action.props.defaultActiveItemId : null,
                status: 'idle',
                completion: null,
                query: ''
            });
        case 'focus':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId,
                isOpen: (action.props.openOnFocus || Boolean(state.query)) && action.props.shouldPanelOpen({
                    state: state
                })
            });
        case 'blur':
            if (action.props.debug) return state;
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                isOpen: false,
                activeItemId: null
            });
        case 'mousemove':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case 'mouseleave':
            return $57074145fe6fe54c$var$_objectSpread($57074145fe6fe54c$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId
            });
        default:
            (0, $d8L6Z.invariant)(false, "The reducer action ".concat(JSON.stringify(action.type), " is not supported."));
            return state;
    }
};

});
parcelRegister("lsEW4", function(module, exports) {
$parcel$export(module.exports, "getCompletion", function () { return $f9fbf77c6ab43fb5$export$6c69e642446172b6; });

var $4yZqM = parcelRequire("4yZqM");
function $f9fbf77c6ab43fb5$export$6c69e642446172b6(_ref) {
    var _getActiveItem;
    var state = _ref.state;
    if (state.isOpen === false || state.activeItemId === null) return null;
    return ((_getActiveItem = (0, $4yZqM.getActiveItem)(state)) === null || _getActiveItem === void 0 ? void 0 : _getActiveItem.itemInputValue) || null;
}

});

parcelRegister("1D5y1", function(module, exports) {
$parcel$export(module.exports, "getNextActiveItemId", function () { return $12fdbc9ceaf5da64$export$9e353209669d8620; });
/**
 * Returns the next active item ID from the current state.
 *
 * We allow circular keyboard navigation from the base index.
 * The base index can either be `null` (nothing is highlighted) or `0`
 * (the first item is highlighted).
 * The base index is allowed to get assigned `null` only if
 * `props.defaultActiveItemId` is `null`. This pattern allows to "stop"
 * by the actual query before navigating to other suggestions as seen on
 * Google or Amazon.
 *
 * @param moveAmount The offset to increment (or decrement) the last index
 * @param baseIndex The current index to compute the next index from
 * @param itemCount The number of items
 * @param defaultActiveItemId The default active index to fallback to
 */ function $12fdbc9ceaf5da64$export$9e353209669d8620(moveAmount, baseIndex, itemCount, defaultActiveItemId) {
    if (!itemCount) return null;
    if (moveAmount < 0 && (baseIndex === null || defaultActiveItemId !== null && baseIndex === 0)) return itemCount + moveAmount;
    var numericIndex = (baseIndex === null ? -1 : baseIndex) + moveAmount;
    if (numericIndex <= -1 || numericIndex >= itemCount) return defaultActiveItemId === null ? null : 0;
    return numericIndex;
}

});



parcelRegister("bjz6g", function(module, exports) {
$parcel$export(module.exports, "getAlgoliaResults", function () { return $83ccb22de4954486$export$d82b34328f310205; });

var $d8L6Z = parcelRequire("d8L6Z");

var $91vwA = parcelRequire("91vwA");
function $83ccb22de4954486$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $83ccb22de4954486$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $83ccb22de4954486$var$_typeof(obj);
}
function $83ccb22de4954486$export$d82b34328f310205(requestParams) {
    (0, $d8L6Z.invariant)($83ccb22de4954486$var$_typeof(requestParams.searchClient) === 'object', 'The `searchClient` parameter is required for getAlgoliaResults({ searchClient }).');
    var requester = (0, $91vwA.createAlgoliaRequester)({
        transformResponse: function transformResponse(response) {
            return response.hits;
        }
    });
    return requester(requestParams);
}

});
parcelRegister("91vwA", function(module, exports) {
$parcel$export(module.exports, "createAlgoliaRequester", function () { return $691ca92c8ae31355$export$9f082baead25d83b; });

var $d5QLc = parcelRequire("d5QLc");

var $hKgri = parcelRequire("hKgri");
var $691ca92c8ae31355$export$9f082baead25d83b = (0, $hKgri.createRequester)((0, $d5QLc.fetchAlgoliaResults), 'algolia');

});
parcelRegister("d5QLc", function(module, exports) {
$parcel$export(module.exports, "fetchAlgoliaResults", function () { return $9884ab18b82e3bf9$export$9e16a9ccc61ab625; });

var $d8L6Z = parcelRequire("d8L6Z");
var $9INBx = parcelRequire("9INBx");

var $9ypTb = parcelRequire("9ypTb");

var $FA4nS = parcelRequire("FA4nS");
function $9884ab18b82e3bf9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9884ab18b82e3bf9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9884ab18b82e3bf9$var$_typeof(obj);
}
var $9884ab18b82e3bf9$var$_excluded = [
    "params"
];
function $9884ab18b82e3bf9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9884ab18b82e3bf9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9884ab18b82e3bf9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9884ab18b82e3bf9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9884ab18b82e3bf9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9884ab18b82e3bf9$var$_defineProperty(obj, key, value) {
    key = $9884ab18b82e3bf9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9884ab18b82e3bf9$var$_toPropertyKey(arg) {
    var key = $9884ab18b82e3bf9$var$_toPrimitive(arg, "string");
    return $9884ab18b82e3bf9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9884ab18b82e3bf9$var$_toPrimitive(input, hint) {
    if ($9884ab18b82e3bf9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9884ab18b82e3bf9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9884ab18b82e3bf9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9884ab18b82e3bf9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9884ab18b82e3bf9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9884ab18b82e3bf9$var$_toConsumableArray(arr) {
    return $9884ab18b82e3bf9$var$_arrayWithoutHoles(arr) || $9884ab18b82e3bf9$var$_iterableToArray(arr) || $9884ab18b82e3bf9$var$_unsupportedIterableToArray(arr) || $9884ab18b82e3bf9$var$_nonIterableSpread();
}
function $9884ab18b82e3bf9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9884ab18b82e3bf9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9884ab18b82e3bf9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9884ab18b82e3bf9$var$_arrayLikeToArray(o, minLen);
}
function $9884ab18b82e3bf9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9884ab18b82e3bf9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9884ab18b82e3bf9$var$_arrayLikeToArray(arr);
}
function $9884ab18b82e3bf9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9884ab18b82e3bf9$export$9e16a9ccc61ab625(_ref) {
    var searchClient = _ref.searchClient, queries = _ref.queries, _ref$userAgents = _ref.userAgents, userAgents = _ref$userAgents === void 0 ? [] : _ref$userAgents;
    if (typeof searchClient.addAlgoliaAgent === 'function') {
        var algoliaAgents = [].concat($9884ab18b82e3bf9$var$_toConsumableArray((0, $9INBx.userAgents)), $9884ab18b82e3bf9$var$_toConsumableArray(userAgents));
        algoliaAgents.forEach(function(_ref2) {
            var segment = _ref2.segment, version = _ref2.version;
            searchClient.addAlgoliaAgent(segment, version);
        });
    }
    var _getAppIdAndApiKey = (0, $FA4nS.getAppIdAndApiKey)(searchClient), appId = _getAppIdAndApiKey.appId, apiKey = _getAppIdAndApiKey.apiKey;
    (0, $d8L6Z.invariant)(Boolean(appId), 'The Algolia `appId` was not accessible from the searchClient passed.');
    (0, $d8L6Z.invariant)(Boolean(apiKey), 'The Algolia `apiKey` was not accessible from the searchClient passed.');
    return searchClient.search(queries.map(function(searchParameters) {
        var params = searchParameters.params, headers = $9884ab18b82e3bf9$var$_objectWithoutProperties(searchParameters, $9884ab18b82e3bf9$var$_excluded);
        return $9884ab18b82e3bf9$var$_objectSpread($9884ab18b82e3bf9$var$_objectSpread({}, headers), {}, {
            params: $9884ab18b82e3bf9$var$_objectSpread({
                hitsPerPage: 5,
                highlightPreTag: (0, $9ypTb.HIGHLIGHT_PRE_TAG),
                highlightPostTag: (0, $9ypTb.HIGHLIGHT_POST_TAG)
            }, params)
        });
    })).then(function(response) {
        return response.results.map(function(result, resultIndex) {
            var _result$hits;
            return $9884ab18b82e3bf9$var$_objectSpread($9884ab18b82e3bf9$var$_objectSpread({}, result), {}, {
                hits: (_result$hits = result.hits) === null || _result$hits === void 0 ? void 0 : _result$hits.map(function(hit) {
                    return $9884ab18b82e3bf9$var$_objectSpread($9884ab18b82e3bf9$var$_objectSpread({}, hit), {}, {
                        // Bring support for the Insights plugin.
                        __autocomplete_indexName: result.index || queries[resultIndex].indexName,
                        __autocomplete_queryID: result.queryID,
                        __autocomplete_algoliaCredentials: {
                            appId: appId,
                            apiKey: apiKey
                        }
                    });
                })
            });
        });
    });
}

});
parcelRegister("FA4nS", function(module, exports) {
$parcel$export(module.exports, "getAppIdAndApiKey", function () { return $07cfcf24c1f09621$export$58f35ab8a1251bc0; });
// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $07cfcf24c1f09621$export$58f35ab8a1251bc0(searchClient) {
    var transporter = searchClient.transporter || {};
    var headers = transporter.headers || transporter.baseHeaders || {};
    var queryParameters = transporter.queryParameters || transporter.baseQueryParameters || {};
    var APP_ID = 'x-algolia-application-id';
    var API_KEY = 'x-algolia-api-key';
    var appId = headers[APP_ID] || queryParameters[APP_ID];
    var apiKey = headers[API_KEY] || queryParameters[API_KEY];
    return {
        appId: appId,
        apiKey: apiKey
    };
}

});


parcelRegister("hKgri", function(module, exports) {
$parcel$export(module.exports, "createRequester", function () { return $ceb37c0a6413c324$export$8d54726fdbf08e0a; });
function $ceb37c0a6413c324$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ceb37c0a6413c324$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ceb37c0a6413c324$var$_typeof(obj);
}
function $ceb37c0a6413c324$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ceb37c0a6413c324$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ceb37c0a6413c324$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ceb37c0a6413c324$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ceb37c0a6413c324$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ceb37c0a6413c324$var$_defineProperty(obj, key, value) {
    key = $ceb37c0a6413c324$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ceb37c0a6413c324$var$_toPropertyKey(arg) {
    var key = $ceb37c0a6413c324$var$_toPrimitive(arg, "string");
    return $ceb37c0a6413c324$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ceb37c0a6413c324$var$_toPrimitive(input, hint) {
    if ($ceb37c0a6413c324$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ceb37c0a6413c324$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ceb37c0a6413c324$export$8d54726fdbf08e0a(fetcher, requesterId) {
    function execute(fetcherParams) {
        return fetcher({
            searchClient: fetcherParams.searchClient,
            queries: fetcherParams.requests.map(function(x) {
                return x.query;
            })
        }).then(function(responses) {
            return responses.map(function(response, index) {
                var _fetcherParams$reques = fetcherParams.requests[index], sourceId = _fetcherParams$reques.sourceId, transformResponse = _fetcherParams$reques.transformResponse;
                return {
                    items: response,
                    sourceId: sourceId,
                    transformResponse: transformResponse
                };
            });
        });
    }
    return function createSpecifiedRequester(requesterParams) {
        return function requester(requestParams) {
            return $ceb37c0a6413c324$var$_objectSpread($ceb37c0a6413c324$var$_objectSpread({
                requesterId: requesterId,
                execute: execute
            }, requesterParams), requestParams);
        };
    };
}

});



parcelRegister("cddhv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8e4100550b5207f0$export$2e2bcd8739ae039; });
function $8e4100550b5207f0$var$createBrowserLocalStorageCache(options) {
    const namespaceKey = `algoliasearch-client-js-${options.key}`;
    // eslint-disable-next-line functional/no-let
    let storage;
    const getStorage = ()=>{
        if (storage === undefined) storage = options.localStorage || window.localStorage;
        return storage;
    };
    const getNamespace = ()=>{
        return JSON.parse(getStorage().getItem(namespaceKey) || '{}');
    };
    const setNamespace = (namespace)=>{
        getStorage().setItem(namespaceKey, JSON.stringify(namespace));
    };
    const removeOutdatedCacheItems = ()=>{
        const timeToLive = options.timeToLive ? options.timeToLive * 1000 : null;
        const namespace = getNamespace();
        const filteredNamespaceWithoutOldFormattedCacheItems = Object.fromEntries(Object.entries(namespace).filter(([, cacheItem])=>{
            return cacheItem.timestamp !== undefined;
        }));
        setNamespace(filteredNamespaceWithoutOldFormattedCacheItems);
        if (!timeToLive) return;
        const filteredNamespaceWithoutExpiredItems = Object.fromEntries(Object.entries(filteredNamespaceWithoutOldFormattedCacheItems).filter(([, cacheItem])=>{
            const currentTimestamp = new Date().getTime();
            const isExpired = cacheItem.timestamp + timeToLive < currentTimestamp;
            return !isExpired;
        }));
        setNamespace(filteredNamespaceWithoutExpiredItems);
    };
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return Promise.resolve().then(()=>{
                removeOutdatedCacheItems();
                const keyAsString = JSON.stringify(key);
                return getNamespace()[keyAsString];
            }).then((value)=>{
                return Promise.all([
                    value ? value.value : defaultValue(),
                    value !== undefined
                ]);
            }).then(([value, exists])=>{
                return Promise.all([
                    value,
                    exists || events.miss(value)
                ]);
            }).then(([value])=>value);
        },
        set (key, value) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                // eslint-disable-next-line functional/immutable-data
                namespace[JSON.stringify(key)] = {
                    timestamp: new Date().getTime(),
                    value: value
                };
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
                return value;
            });
        },
        delete (key) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                // eslint-disable-next-line functional/immutable-data
                delete namespace[JSON.stringify(key)];
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
            });
        },
        clear () {
            return Promise.resolve().then(()=>{
                getStorage().removeItem(namespaceKey);
            });
        }
    };
}
// @todo Add logger on options to debug when caches go wrong.
function $8e4100550b5207f0$var$createFallbackableCache(options) {
    const caches = [
        ...options.caches
    ];
    const current = caches.shift(); // eslint-disable-line functional/immutable-data
    if (current === undefined) return $8e4100550b5207f0$var$createNullCache();
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return current.get(key, defaultValue, events).catch(()=>{
                return $8e4100550b5207f0$var$createFallbackableCache({
                    caches: caches
                }).get(key, defaultValue, events);
            });
        },
        set (key, value) {
            return current.set(key, value).catch(()=>{
                return $8e4100550b5207f0$var$createFallbackableCache({
                    caches: caches
                }).set(key, value);
            });
        },
        delete (key) {
            return current.delete(key).catch(()=>{
                return $8e4100550b5207f0$var$createFallbackableCache({
                    caches: caches
                }).delete(key);
            });
        },
        clear () {
            return current.clear().catch(()=>{
                return $8e4100550b5207f0$var$createFallbackableCache({
                    caches: caches
                }).clear();
            });
        }
    };
}
function $8e4100550b5207f0$var$createNullCache() {
    return {
        get (_key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const value = defaultValue();
            return value.then((result)=>Promise.all([
                    result,
                    events.miss(result)
                ])).then(([result])=>result);
        },
        set (_key, value) {
            return Promise.resolve(value);
        },
        delete (_key) {
            return Promise.resolve();
        },
        clear () {
            return Promise.resolve();
        }
    };
}
function $8e4100550b5207f0$var$createInMemoryCache(options = {
    serializable: true
}) {
    // eslint-disable-next-line functional/no-let
    let cache = {};
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const keyAsString = JSON.stringify(key);
            if (keyAsString in cache) return Promise.resolve(options.serializable ? JSON.parse(cache[keyAsString]) : cache[keyAsString]);
            const promise = defaultValue();
            const miss = events && events.miss || (()=>Promise.resolve());
            return promise.then((value)=>miss(value)).then(()=>promise);
        },
        set (key, value) {
            // eslint-disable-next-line functional/immutable-data
            cache[JSON.stringify(key)] = options.serializable ? JSON.stringify(value) : value;
            return Promise.resolve(value);
        },
        delete (key) {
            // eslint-disable-next-line functional/immutable-data
            delete cache[JSON.stringify(key)];
            return Promise.resolve();
        },
        clear () {
            cache = {};
            return Promise.resolve();
        }
    };
}
function $8e4100550b5207f0$var$createAuth(authMode, appId, apiKey) {
    const credentials = {
        'x-algolia-api-key': apiKey,
        'x-algolia-application-id': appId
    };
    return {
        headers () {
            return authMode === $8e4100550b5207f0$var$AuthMode.WithinHeaders ? credentials : {};
        },
        queryParameters () {
            return authMode === $8e4100550b5207f0$var$AuthMode.WithinQueryParameters ? credentials : {};
        }
    };
}
// eslint-disable-next-line functional/prefer-readonly-type
function $8e4100550b5207f0$var$shuffle(array) {
    let c = array.length - 1; // eslint-disable-line functional/no-let
    // eslint-disable-next-line functional/no-loop-statement
    for(c; c > 0; c--){
        const b = Math.floor(Math.random() * (c + 1));
        const a = array[c];
        array[c] = array[b]; // eslint-disable-line functional/immutable-data, no-param-reassign
        array[b] = a; // eslint-disable-line functional/immutable-data, no-param-reassign
    }
    return array;
}
function $8e4100550b5207f0$var$addMethods(base, methods) {
    if (!methods) return base;
    Object.keys(methods).forEach((key)=>{
        // eslint-disable-next-line functional/immutable-data, no-param-reassign
        base[key] = methods[key](base);
    });
    return base;
}
function $8e4100550b5207f0$var$encode(format, ...args) {
    // eslint-disable-next-line functional/no-let
    let i = 0;
    return format.replace(/%s/g, ()=>encodeURIComponent(args[i++]));
}
const $8e4100550b5207f0$var$version = '4.24.0';
const $8e4100550b5207f0$var$AuthMode = {
    /**
     * If auth credentials should be in query parameters.
     */ WithinQueryParameters: 0,
    /**
     * If auth credentials should be in headers.
     */ WithinHeaders: 1
};
function $8e4100550b5207f0$var$createMappedRequestOptions(requestOptions, timeout) {
    const options = requestOptions || {};
    const data = options.data || {};
    Object.keys(options).forEach((key)=>{
        if ([
            'timeout',
            'headers',
            'queryParameters',
            'data',
            'cacheable'
        ].indexOf(key) === -1) data[key] = options[key]; // eslint-disable-line functional/immutable-data
    });
    return {
        data: Object.entries(data).length > 0 ? data : undefined,
        timeout: options.timeout || timeout,
        headers: options.headers || {},
        queryParameters: options.queryParameters || {},
        cacheable: options.cacheable
    };
}
const $8e4100550b5207f0$var$CallEnum = {
    /**
     * If the host is read only.
     */ Read: 1,
    /**
     * If the host is write only.
     */ Write: 2,
    /**
     * If the host is both read and write.
     */ Any: 3
};
const $8e4100550b5207f0$var$HostStatusEnum = {
    Up: 1,
    Down: 2,
    Timeouted: 3
};
// By default, API Clients at Algolia have expiration delay
// of 5 mins. In the JavaScript client, we have 2 mins.
const $8e4100550b5207f0$var$EXPIRATION_DELAY = 120000;
function $8e4100550b5207f0$var$createStatefulHost(host, status = $8e4100550b5207f0$var$HostStatusEnum.Up) {
    return {
        ...host,
        status: status,
        lastUpdate: Date.now()
    };
}
function $8e4100550b5207f0$var$isStatefulHostUp(host) {
    return host.status === $8e4100550b5207f0$var$HostStatusEnum.Up || Date.now() - host.lastUpdate > $8e4100550b5207f0$var$EXPIRATION_DELAY;
}
function $8e4100550b5207f0$var$isStatefulHostTimeouted(host) {
    return host.status === $8e4100550b5207f0$var$HostStatusEnum.Timeouted && Date.now() - host.lastUpdate <= $8e4100550b5207f0$var$EXPIRATION_DELAY;
}
function $8e4100550b5207f0$var$createStatelessHost(options) {
    if (typeof options === 'string') return {
        protocol: 'https',
        url: options,
        accept: $8e4100550b5207f0$var$CallEnum.Any
    };
    return {
        protocol: options.protocol || 'https',
        url: options.url,
        accept: options.accept || $8e4100550b5207f0$var$CallEnum.Any
    };
}
const $8e4100550b5207f0$var$MethodEnum = {
    Delete: 'DELETE',
    Get: 'GET',
    Post: 'POST',
    Put: 'PUT'
};
function $8e4100550b5207f0$var$createRetryableOptions(hostsCache, statelessHosts) {
    return Promise.all(statelessHosts.map((statelessHost)=>{
        return hostsCache.get(statelessHost, ()=>{
            return Promise.resolve($8e4100550b5207f0$var$createStatefulHost(statelessHost));
        });
    })).then((statefulHosts)=>{
        const hostsUp = statefulHosts.filter((host)=>$8e4100550b5207f0$var$isStatefulHostUp(host));
        const hostsTimeouted = statefulHosts.filter((host)=>$8e4100550b5207f0$var$isStatefulHostTimeouted(host));
        /**
         * Note, we put the hosts that previously timeouted on the end of the list.
         */ const hostsAvailable = [
            ...hostsUp,
            ...hostsTimeouted
        ];
        const statelessHostsAvailable = hostsAvailable.length > 0 ? hostsAvailable.map((host)=>$8e4100550b5207f0$var$createStatelessHost(host)) : statelessHosts;
        return {
            getTimeout (timeoutsCount, baseTimeout) {
                /**
                 * Imagine that you have 4 hosts, if timeouts will increase
                 * on the following way: 1 (timeouted) > 4 (timeouted) > 5 (200)
                 *
                 * Note that, the very next request, we start from the previous timeout
                 *
                 *  5 (timeouted) > 6 (timeouted) > 7 ...
                 *
                 * This strategy may need to be reviewed, but is the strategy on the our
                 * current v3 version.
                 */ const timeoutMultiplier = hostsTimeouted.length === 0 && timeoutsCount === 0 ? 1 : hostsTimeouted.length + 3 + timeoutsCount;
                return timeoutMultiplier * baseTimeout;
            },
            statelessHosts: statelessHostsAvailable
        };
    });
}
const $8e4100550b5207f0$var$isNetworkError = ({ isTimedOut: isTimedOut, status: status })=>{
    return !isTimedOut && ~~status === 0;
};
const $8e4100550b5207f0$var$isRetryable = (response)=>{
    const status = response.status;
    const isTimedOut = response.isTimedOut;
    return isTimedOut || $8e4100550b5207f0$var$isNetworkError(response) || ~~(status / 100) !== 2 && ~~(status / 100) !== 4;
};
const $8e4100550b5207f0$var$isSuccess = ({ status: status })=>{
    return ~~(status / 100) === 2;
};
const $8e4100550b5207f0$var$retryDecision = (response, outcomes)=>{
    if ($8e4100550b5207f0$var$isRetryable(response)) return outcomes.onRetry(response);
    if ($8e4100550b5207f0$var$isSuccess(response)) return outcomes.onSuccess(response);
    return outcomes.onFail(response);
};
function $8e4100550b5207f0$var$retryableRequest(transporter, statelessHosts, request, requestOptions) {
    const stackTrace = []; // eslint-disable-line functional/prefer-readonly-type
    /**
     * First we prepare the payload that do not depend from hosts.
     */ const data = $8e4100550b5207f0$var$serializeData(request, requestOptions);
    const headers = $8e4100550b5207f0$var$serializeHeaders(transporter, requestOptions);
    const method = request.method;
    // On `GET`, the data is proxied to query parameters.
    const dataQueryParameters = request.method !== $8e4100550b5207f0$var$MethodEnum.Get ? {} : {
        ...request.data,
        ...requestOptions.data
    };
    const queryParameters = {
        'x-algolia-agent': transporter.userAgent.value,
        ...transporter.queryParameters,
        ...dataQueryParameters,
        ...requestOptions.queryParameters
    };
    let timeoutsCount = 0; // eslint-disable-line functional/no-let
    const retry = (hosts, getTimeout)=>{
        /**
         * We iterate on each host, until there is no host left.
         */ const host = hosts.pop(); // eslint-disable-line functional/immutable-data
        if (host === undefined) throw $8e4100550b5207f0$var$createRetryError($8e4100550b5207f0$var$stackTraceWithoutCredentials(stackTrace));
        const payload = {
            data: data,
            headers: headers,
            method: method,
            url: $8e4100550b5207f0$var$serializeUrl(host, request.path, queryParameters),
            connectTimeout: getTimeout(timeoutsCount, transporter.timeouts.connect),
            responseTimeout: getTimeout(timeoutsCount, requestOptions.timeout)
        };
        /**
         * The stackFrame is pushed to the stackTrace so we
         * can have information about onRetry and onFailure
         * decisions.
         */ const pushToStackTrace = (response)=>{
            const stackFrame = {
                request: payload,
                response: response,
                host: host,
                triesLeft: hosts.length
            };
            // eslint-disable-next-line functional/immutable-data
            stackTrace.push(stackFrame);
            return stackFrame;
        };
        const decisions = {
            onSuccess: (response)=>$8e4100550b5207f0$var$deserializeSuccess(response),
            onRetry (response) {
                const stackFrame = pushToStackTrace(response);
                /**
                 * If response is a timeout, we increaset the number of
                 * timeouts so we can increase the timeout later.
                 */ if (response.isTimedOut) timeoutsCount++;
                return Promise.all([
                    /**
                     * Failures are individually send the logger, allowing
                     * the end user to debug / store stack frames even
                     * when a retry error does not happen.
                     */ transporter.logger.info('Retryable failure', $8e4100550b5207f0$var$stackFrameWithoutCredentials(stackFrame)),
                    /**
                     * We also store the state of the host in failure cases. If the host, is
                     * down it will remain down for the next 2 minutes. In a timeout situation,
                     * this host will be added end of the list of hosts on the next request.
                     */ transporter.hostsCache.set(host, $8e4100550b5207f0$var$createStatefulHost(host, response.isTimedOut ? $8e4100550b5207f0$var$HostStatusEnum.Timeouted : $8e4100550b5207f0$var$HostStatusEnum.Down))
                ]).then(()=>retry(hosts, getTimeout));
            },
            onFail (response) {
                pushToStackTrace(response);
                throw $8e4100550b5207f0$var$deserializeFailure(response, $8e4100550b5207f0$var$stackTraceWithoutCredentials(stackTrace));
            }
        };
        return transporter.requester.send(payload).then((response)=>{
            return $8e4100550b5207f0$var$retryDecision(response, decisions);
        });
    };
    /**
     * Finally, for each retryable host perform request until we got a non
     * retryable response. Some notes here:
     *
     * 1. The reverse here is applied so we can apply a `pop` later on => more performant.
     * 2. We also get from the retryable options a timeout multiplier that is tailored
     * for the current context.
     */ return $8e4100550b5207f0$var$createRetryableOptions(transporter.hostsCache, statelessHosts).then((options)=>{
        return retry([
            ...options.statelessHosts
        ].reverse(), options.getTimeout);
    });
}
function $8e4100550b5207f0$var$createTransporter(options) {
    const { hostsCache: hostsCache, logger: logger, requester: requester, requestsCache: requestsCache, responsesCache: responsesCache, timeouts: timeouts, userAgent: userAgent, hosts: hosts, queryParameters: queryParameters, headers: headers } = options;
    const transporter = {
        hostsCache: hostsCache,
        logger: logger,
        requester: requester,
        requestsCache: requestsCache,
        responsesCache: responsesCache,
        timeouts: timeouts,
        userAgent: userAgent,
        headers: headers,
        queryParameters: queryParameters,
        hosts: hosts.map((host)=>$8e4100550b5207f0$var$createStatelessHost(host)),
        read (request, requestOptions) {
            /**
             * First, we compute the user request options. Now, keep in mind,
             * that using request options the user is able to modified the intire
             * payload of the request. Such as headers, query parameters, and others.
             */ const mappedRequestOptions = $8e4100550b5207f0$var$createMappedRequestOptions(requestOptions, transporter.timeouts.read);
            const createRetryableRequest = ()=>{
                /**
                 * Then, we prepare a function factory that contains the construction of
                 * the retryable request. At this point, we may *not* perform the actual
                 * request. But we want to have the function factory ready.
                 */ return $8e4100550b5207f0$var$retryableRequest(transporter, transporter.hosts.filter((host)=>(host.accept & $8e4100550b5207f0$var$CallEnum.Read) !== 0), request, mappedRequestOptions);
            };
            /**
             * Once we have the function factory ready, we need to determine of the
             * request is "cacheable" - should be cached. Note that, once again,
             * the user can force this option.
             */ const cacheable = mappedRequestOptions.cacheable !== undefined ? mappedRequestOptions.cacheable : request.cacheable;
            /**
             * If is not "cacheable", we immediatly trigger the retryable request, no
             * need to check cache implementations.
             */ if (cacheable !== true) return createRetryableRequest();
            /**
             * If the request is "cacheable", we need to first compute the key to ask
             * the cache implementations if this request is on progress or if the
             * response already exists on the cache.
             */ const key = {
                request: request,
                mappedRequestOptions: mappedRequestOptions,
                transporter: {
                    queryParameters: transporter.queryParameters,
                    headers: transporter.headers
                }
            };
            /**
             * With the computed key, we first ask the responses cache
             * implemention if this request was been resolved before.
             */ return transporter.responsesCache.get(key, ()=>{
                /**
                 * If the request has never resolved before, we actually ask if there
                 * is a current request with the same key on progress.
                 */ return transporter.requestsCache.get(key, ()=>{
                    return transporter.requestsCache/**
                         * Finally, if there is no request in progress with the same key,
                         * this `createRetryableRequest()` will actually trigger the
                         * retryable request.
                         */ .set(key, createRetryableRequest()).then((response)=>Promise.all([
                            transporter.requestsCache.delete(key),
                            response
                        ]), (err)=>Promise.all([
                            transporter.requestsCache.delete(key),
                            Promise.reject(err)
                        ])).then(([_, response])=>response);
                });
            }, {
                /**
                 * Of course, once we get this response back from the server, we
                 * tell response cache to actually store the received response
                 * to be used later.
                 */ miss: (response)=>transporter.responsesCache.set(key, response)
            });
        },
        write (request, requestOptions) {
            /**
             * On write requests, no cache mechanisms are applied, and we
             * proxy the request immediately to the requester.
             */ return $8e4100550b5207f0$var$retryableRequest(transporter, transporter.hosts.filter((host)=>(host.accept & $8e4100550b5207f0$var$CallEnum.Write) !== 0), request, $8e4100550b5207f0$var$createMappedRequestOptions(requestOptions, transporter.timeouts.write));
        }
    };
    return transporter;
}
function $8e4100550b5207f0$var$createUserAgent(version) {
    const userAgent = {
        value: `Algolia for JavaScript (${version})`,
        add (options) {
            const addedUserAgent = `; ${options.segment}${options.version !== undefined ? ` (${options.version})` : ''}`;
            if (userAgent.value.indexOf(addedUserAgent) === -1) // eslint-disable-next-line functional/immutable-data
            userAgent.value = `${userAgent.value}${addedUserAgent}`;
            return userAgent;
        }
    };
    return userAgent;
}
function $8e4100550b5207f0$var$deserializeSuccess(response) {
    // eslint-disable-next-line functional/no-try-statement
    try {
        return JSON.parse(response.content);
    } catch (e) {
        throw $8e4100550b5207f0$var$createDeserializationError(e.message, response);
    }
}
function $8e4100550b5207f0$var$deserializeFailure({ content: content, status: status }, stackFrame) {
    // eslint-disable-next-line functional/no-let
    let message = content;
    // eslint-disable-next-line functional/no-try-statement
    try {
        message = JSON.parse(content).message;
    } catch (e) {
    // ..
    }
    return $8e4100550b5207f0$var$createApiError(message, status, stackFrame);
}
function $8e4100550b5207f0$var$serializeUrl(host, path, queryParameters) {
    const queryParametersAsString = $8e4100550b5207f0$var$serializeQueryParameters(queryParameters);
    // eslint-disable-next-line functional/no-let
    let url = `${host.protocol}://${host.url}/${path.charAt(0) === '/' ? path.substr(1) : path}`;
    if (queryParametersAsString.length) url += `?${queryParametersAsString}`;
    return url;
}
function $8e4100550b5207f0$var$serializeQueryParameters(parameters) {
    const isObjectOrArray = (value)=>Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]';
    return Object.keys(parameters).map((key)=>$8e4100550b5207f0$var$encode('%s=%s', key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key])).join('&');
}
function $8e4100550b5207f0$var$serializeData(request, requestOptions) {
    if (request.method === $8e4100550b5207f0$var$MethodEnum.Get || request.data === undefined && requestOptions.data === undefined) return undefined;
    const data = Array.isArray(request.data) ? request.data : {
        ...request.data,
        ...requestOptions.data
    };
    return JSON.stringify(data);
}
function $8e4100550b5207f0$var$serializeHeaders(transporter, requestOptions) {
    const headers = {
        ...transporter.headers,
        ...requestOptions.headers
    };
    const serializedHeaders = {};
    Object.keys(headers).forEach((header)=>{
        const value = headers[header];
        // @ts-ignore
        // eslint-disable-next-line functional/immutable-data
        serializedHeaders[header.toLowerCase()] = value;
    });
    return serializedHeaders;
}
function $8e4100550b5207f0$var$stackTraceWithoutCredentials(stackTrace) {
    return stackTrace.map((stackFrame)=>$8e4100550b5207f0$var$stackFrameWithoutCredentials(stackFrame));
}
function $8e4100550b5207f0$var$stackFrameWithoutCredentials(stackFrame) {
    const modifiedHeaders = stackFrame.request.headers['x-algolia-api-key'] ? {
        'x-algolia-api-key': '*****'
    } : {};
    return {
        ...stackFrame,
        request: {
            ...stackFrame.request,
            headers: {
                ...stackFrame.request.headers,
                ...modifiedHeaders
            }
        }
    };
}
function $8e4100550b5207f0$var$createApiError(message, status, transporterStackTrace) {
    return {
        name: 'ApiError',
        message: message,
        status: status,
        transporterStackTrace: transporterStackTrace
    };
}
function $8e4100550b5207f0$var$createDeserializationError(message, response) {
    return {
        name: 'DeserializationError',
        message: message,
        response: response
    };
}
function $8e4100550b5207f0$var$createRetryError(transporterStackTrace) {
    return {
        name: 'RetryError',
        message: 'Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .',
        transporterStackTrace: transporterStackTrace
    };
}
const $8e4100550b5207f0$var$createSearchClient = (options)=>{
    const appId = options.appId;
    const auth = $8e4100550b5207f0$var$createAuth(options.authMode !== undefined ? options.authMode : $8e4100550b5207f0$var$AuthMode.WithinHeaders, appId, options.apiKey);
    const transporter = $8e4100550b5207f0$var$createTransporter({
        hosts: [
            {
                url: `${appId}-dsn.algolia.net`,
                accept: $8e4100550b5207f0$var$CallEnum.Read
            },
            {
                url: `${appId}.algolia.net`,
                accept: $8e4100550b5207f0$var$CallEnum.Write
            }
        ].concat($8e4100550b5207f0$var$shuffle([
            {
                url: `${appId}-1.algolianet.com`
            },
            {
                url: `${appId}-2.algolianet.com`
            },
            {
                url: `${appId}-3.algolianet.com`
            }
        ])),
        ...options,
        headers: {
            ...auth.headers(),
            'content-type': 'application/x-www-form-urlencoded',
            ...options.headers
        },
        queryParameters: {
            ...auth.queryParameters(),
            ...options.queryParameters
        }
    });
    const base = {
        transporter: transporter,
        appId: appId,
        addAlgoliaAgent (segment, version) {
            transporter.userAgent.add({
                segment: segment,
                version: version
            });
        },
        clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>undefined);
        }
    };
    return $8e4100550b5207f0$var$addMethods(base, options.methods);
};
const $8e4100550b5207f0$var$customRequest = (base)=>{
    return (request, requestOptions)=>{
        if (request.method === $8e4100550b5207f0$var$MethodEnum.Get) return base.transporter.read(request, requestOptions);
        return base.transporter.write(request, requestOptions);
    };
};
const $8e4100550b5207f0$var$initIndex = (base)=>{
    return (indexName, options = {})=>{
        const searchIndex = {
            transporter: base.transporter,
            appId: base.appId,
            indexName: indexName
        };
        return $8e4100550b5207f0$var$addMethods(searchIndex, options.methods);
    };
};
const $8e4100550b5207f0$var$multipleQueries = (base)=>{
    return (queries, requestOptions)=>{
        const requests = queries.map((query)=>{
            return {
                ...query,
                params: $8e4100550b5207f0$var$serializeQueryParameters(query.params || {})
            };
        });
        return base.transporter.read({
            method: $8e4100550b5207f0$var$MethodEnum.Post,
            path: '1/indexes/*/queries',
            data: {
                requests: requests
            },
            cacheable: true
        }, requestOptions);
    };
};
const $8e4100550b5207f0$var$multipleSearchForFacetValues = (base)=>{
    return (queries, requestOptions)=>{
        return Promise.all(queries.map((query)=>{
            const { facetName: facetName, facetQuery: facetQuery, ...params } = query.params;
            return $8e4100550b5207f0$var$initIndex(base)(query.indexName, {
                methods: {
                    searchForFacetValues: $8e4100550b5207f0$var$searchForFacetValues
                }
            }).searchForFacetValues(facetName, facetQuery, {
                ...requestOptions,
                ...params
            });
        }));
    };
};
const $8e4100550b5207f0$var$findAnswers = (base)=>{
    return (query, queryLanguages, requestOptions)=>{
        return base.transporter.read({
            method: $8e4100550b5207f0$var$MethodEnum.Post,
            path: $8e4100550b5207f0$var$encode('1/answers/%s/prediction', base.indexName),
            data: {
                query: query,
                queryLanguages: queryLanguages
            },
            cacheable: true
        }, requestOptions);
    };
};
const $8e4100550b5207f0$var$search = (base)=>{
    return (query, requestOptions)=>{
        return base.transporter.read({
            method: $8e4100550b5207f0$var$MethodEnum.Post,
            path: $8e4100550b5207f0$var$encode('1/indexes/%s/query', base.indexName),
            data: {
                query: query
            },
            cacheable: true
        }, requestOptions);
    };
};
const $8e4100550b5207f0$var$searchForFacetValues = (base)=>{
    return (facetName, facetQuery, requestOptions)=>{
        return base.transporter.read({
            method: $8e4100550b5207f0$var$MethodEnum.Post,
            path: $8e4100550b5207f0$var$encode('1/indexes/%s/facets/%s/query', base.indexName, facetName),
            data: {
                facetQuery: facetQuery
            },
            cacheable: true
        }, requestOptions);
    };
};
const $8e4100550b5207f0$var$LogLevelEnum = {
    Debug: 1,
    Info: 2,
    Error: 3
};
/* eslint no-console: 0 */ function $8e4100550b5207f0$var$createConsoleLogger(logLevel) {
    return {
        debug (message, args) {
            if ($8e4100550b5207f0$var$LogLevelEnum.Debug >= logLevel) console.debug(message, args);
            return Promise.resolve();
        },
        info (message, args) {
            if ($8e4100550b5207f0$var$LogLevelEnum.Info >= logLevel) console.info(message, args);
            return Promise.resolve();
        },
        error (message, args) {
            console.error(message, args);
            return Promise.resolve();
        }
    };
}
const $8e4100550b5207f0$var$getRecommendations = (base)=>{
    return (queries, requestOptions)=>{
        const requests = queries.map((query)=>({
                ...query,
                // The `threshold` param is required by the endpoint to make it easier
                // to provide a default value later, so we default it in the client
                // so that users don't have to provide a value.
                threshold: query.threshold || 0
            }));
        return base.transporter.read({
            method: $8e4100550b5207f0$var$MethodEnum.Post,
            path: '1/indexes/*/recommendations',
            data: {
                requests: requests
            },
            cacheable: true
        }, requestOptions);
    };
};
function $8e4100550b5207f0$var$createBrowserXhrRequester() {
    return {
        send (request) {
            return new Promise((resolve)=>{
                const baseRequester = new XMLHttpRequest();
                baseRequester.open(request.method, request.url, true);
                Object.keys(request.headers).forEach((key)=>baseRequester.setRequestHeader(key, request.headers[key]));
                const createTimeout = (timeout, content)=>{
                    return setTimeout(()=>{
                        baseRequester.abort();
                        resolve({
                            status: 0,
                            content: content,
                            isTimedOut: true
                        });
                    }, timeout * 1000);
                };
                const connectTimeout = createTimeout(request.connectTimeout, 'Connection timeout');
                // eslint-disable-next-line functional/no-let
                let responseTimeout;
                // eslint-disable-next-line functional/immutable-data
                baseRequester.onreadystatechange = ()=>{
                    if (baseRequester.readyState > baseRequester.OPENED && responseTimeout === undefined) {
                        clearTimeout(connectTimeout);
                        responseTimeout = createTimeout(request.responseTimeout, 'Socket timeout');
                    }
                };
                // eslint-disable-next-line functional/immutable-data
                baseRequester.onerror = ()=>{
                    // istanbul ignore next
                    if (baseRequester.status === 0) {
                        clearTimeout(connectTimeout);
                        clearTimeout(responseTimeout);
                        resolve({
                            content: baseRequester.responseText || 'Network request failed',
                            status: baseRequester.status,
                            isTimedOut: false
                        });
                    }
                };
                //  eslint-disable-next-line functional/immutable-data
                baseRequester.onload = ()=>{
                    clearTimeout(connectTimeout);
                    clearTimeout(responseTimeout);
                    resolve({
                        content: baseRequester.responseText,
                        status: baseRequester.status,
                        isTimedOut: false
                    });
                };
                baseRequester.send(request.data);
            });
        }
    };
}
function $8e4100550b5207f0$var$algoliasearch(appId, apiKey, options) {
    const commonOptions = {
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: 1,
            read: 2,
            write: 30
        },
        requester: $8e4100550b5207f0$var$createBrowserXhrRequester(),
        logger: $8e4100550b5207f0$var$createConsoleLogger($8e4100550b5207f0$var$LogLevelEnum.Error),
        responsesCache: $8e4100550b5207f0$var$createInMemoryCache(),
        requestsCache: $8e4100550b5207f0$var$createInMemoryCache({
            serializable: false
        }),
        hostsCache: $8e4100550b5207f0$var$createFallbackableCache({
            caches: [
                $8e4100550b5207f0$var$createBrowserLocalStorageCache({
                    key: `${$8e4100550b5207f0$var$version}-${appId}`
                }),
                $8e4100550b5207f0$var$createInMemoryCache()
            ]
        }),
        userAgent: $8e4100550b5207f0$var$createUserAgent($8e4100550b5207f0$var$version).add({
            segment: 'Browser',
            version: 'lite'
        }),
        authMode: $8e4100550b5207f0$var$AuthMode.WithinQueryParameters
    };
    return $8e4100550b5207f0$var$createSearchClient({
        ...commonOptions,
        ...options,
        methods: {
            search: $8e4100550b5207f0$var$multipleQueries,
            searchForFacetValues: $8e4100550b5207f0$var$multipleSearchForFacetValues,
            multipleQueries: $8e4100550b5207f0$var$multipleQueries,
            multipleSearchForFacetValues: $8e4100550b5207f0$var$multipleSearchForFacetValues,
            customRequest: $8e4100550b5207f0$var$customRequest,
            initIndex: (base)=>(indexName)=>{
                    return $8e4100550b5207f0$var$initIndex(base)(indexName, {
                        methods: {
                            search: $8e4100550b5207f0$var$search,
                            searchForFacetValues: $8e4100550b5207f0$var$searchForFacetValues,
                            findAnswers: $8e4100550b5207f0$var$findAnswers
                        }
                    });
                },
            getRecommendations: $8e4100550b5207f0$var$getRecommendations
        }
    });
}
// eslint-disable-next-line functional/immutable-data
$8e4100550b5207f0$var$algoliasearch.version = $8e4100550b5207f0$var$version;
var $8e4100550b5207f0$export$2e2bcd8739ae039 = $8e4100550b5207f0$var$algoliasearch;

});



parcelRegister("hiOEV", function(module, exports) {
$parcel$export(module.exports, "useMobileNavDisplay", function () { return $3d5da6dd71159d78$export$5d09230d0dd28d47; });

var $1oC0p = parcelRequire("1oC0p");

var $3riD8 = parcelRequire("3riD8");
const $3d5da6dd71159d78$export$5d09230d0dd28d47 = (isOpenSearch)=>{
    const userInfo = (0, $3riD8.useLoggedInUser)();
    const [showMenu, setShowMenu] = (0, $1oC0p.useState)(false);
    const [isDisplayLoggedInUseDropdown, setIsDisplayLoggedInUseDropdown] = (0, $1oC0p.useState)(false);
    const [firstOpen, setFirstOpen] = (0, $1oC0p.useState)(false);
    const [menuPage, setMenuPage] = (0, $1oC0p.useState)('default');
    const handleToggleMenu = (showMenu)=>{
        setShowMenu(showMenu);
        if (isDisplayLoggedInUseDropdown) setIsDisplayLoggedInUseDropdown(false);
    };
    const handleFirstOpen = (firstOpen)=>{
        setFirstOpen(firstOpen);
    };
    const handleMenuPage = (menuPage)=>{
        setMenuPage(menuPage);
    };
    const handleClickAvatar = ()=>{
        if (!isDisplayLoggedInUseDropdown && showMenu) setIsDisplayLoggedInUseDropdown((isDisplayLoggedInUseDropdown)=>!isDisplayLoggedInUseDropdown);
        else {
            setIsDisplayLoggedInUseDropdown((isDisplayLoggedInUseDropdown)=>!isDisplayLoggedInUseDropdown);
            setShowMenu((showMenu)=>!showMenu);
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        if (isOpenSearch) {
            setShowMenu(false);
            setFirstOpen(false);
            setIsDisplayLoggedInUseDropdown(false);
        }
    }, [
        isOpenSearch
    ]);
    return {
        userInfo: userInfo,
        showMenu: showMenu,
        isDisplayLoggedInUseDropdown: isDisplayLoggedInUseDropdown,
        firstOpen: firstOpen,
        menuPage: menuPage,
        handleToggleMenu: handleToggleMenu,
        handleFirstOpen: handleFirstOpen,
        handleMenuPage: handleMenuPage,
        handleClickAvatar: handleClickAvatar
    };
};

});

parcelRegister("5BEho", function(module, exports) {
$parcel$export(module.exports, "SkipToContent", function () { return $5511a2a3304ae0a6$export$917322b080de1474; });
/* skip-to-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $5511a2a3304ae0a6$export$917322b080de1474 = ()=>{
    const intl = (0, $8e22h.default)();
    const skipToContentStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: "#content",
        className: (0, $2jatx.default)([
            "_kqswstnw _1pby18h8 _1pfhv77o _18zrpxbi _1rjc19bv _bfhk1afi _syaz1pfd _152t1osq _1e02xq2a _1axu1wug",
            "skip-to-content"
        ]),
        "data-testid": "skip-to-content",
        // needed so that the link is the first thing tabbed, but still positioned correctly
        // eslint-disable-next-line jsx-a11y/tabindex-no-positive
        tabIndex: 1,
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
        },
        children: intl.formatMessage({
            id: 'nav.skipToContent',
            defaultMessage: 'Skip to content'
        })
    });
};

});

parcelRegister("3PWZ2", function(module, exports) {
$parcel$export(module.exports, "Divider", function () { return $65a164886de516c0$export$2e0a83ec2e27ecbb; });

var $7VQPk = parcelRequire("7VQPk");
const $65a164886de516c0$export$2e0a83ec2e27ecbb = ({ width: width = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            display: 'block'
        },
        width: width,
        height: "2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("line", {
            x1: "0.5",
            y1: "1.19824",
            x2: width,
            y2: "1.19824",
            stroke: "#DDDEE1",
            strokeLinecap: "round",
            strokeDasharray: "0.5 4"
        })
    });

});

parcelRegister("3R5TL", function(module, exports) {
$parcel$export(module.exports, "MobileNavLinks", function () { return $a8e8f05bf649c0b2$export$eb036d214dd5e2d7; });
/* mobile-nav-links-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lmQGF = parcelRequire("lmQGF");

var $59F4T = parcelRequire("59F4T");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $1fDFs = parcelRequire("1fDFs");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $aTTHV = parcelRequire("aTTHV");

var $2uCL0 = parcelRequire("2uCL0");

var $3PWZ2 = parcelRequire("3PWZ2");

var $yTguz = parcelRequire("yTguz");
const $a8e8f05bf649c0b2$var$linkContainerCss = null;
const $a8e8f05bf649c0b2$var$signInContainerCss = null;
const $a8e8f05bf649c0b2$var$returnToHomeStyle = null;
const $a8e8f05bf649c0b2$var$getItFreeCss = null;
const $a8e8f05bf649c0b2$var$atlassianArrowLinkContainerStyle = null;
const $a8e8f05bf649c0b2$var$signInCss = null;
const $a8e8f05bf649c0b2$export$a789aef643e6e22a = ({ handleMenuPage: handleMenuPage, mobileLinkKey: mobileLinkKey, mobileLinksProps: mobileLinksProps, isIncludeBottomDivider: isIncludeBottomDivider = true })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3td1tcg _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1fw0 _1wybdlk8",
                    mobileLinkKey
                ]),
                children: mobileLinksProps.map((mobileLink, index)=>{
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        className: "nav-link",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $yTguz.MobileNavLink), {
                            handleMenuPage: handleMenuPage,
                            ...mobileLink
                        })
                    }, `${mobileLink.globalLinksKey}-${index}`);
                })
            }),
            isIncludeBottomDivider && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3PWZ2.Divider), {})
        ]
    });
};
const $a8e8f05bf649c0b2$export$eb036d214dd5e2d7 = ({ isLoggedIn: isLoggedIn, handleMenuPage: handleMenuPage, mobileLinksSections: mobileLinksSections, productKey: productKey = 'jira', isIncludeCTA: isIncludeCTA = false, ctaText: ctaText = 'Get it free', ctaUrl: ctaUrl = '/software/jira/free', ctaOnClick: ctaOnClick, ctaButtonVariant: ctaButtonVariant = 'primary', isIncludeAtlassianLogo: isIncludeAtlassianLogo = false, isShowSearchButton: isShowSearchButton = true })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const baseUrl = "https://id.atlassian.com";
    const stargateBaseUrl = "https://www.atlassian.com/gateway/api";
    const continueUrl = stargateBaseUrl + '/start/authredirect';
    const isWacIcLoginEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacIcLogin);
    const applicationParam = isWacIcLoginEnabled ? '&application=wac--ic' : '';
    const signInUrl = `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}${applicationParam}`;
    const homeHref = (0, $jQ0cd.useLocalizedHref)('/');
    const signinLink = {
        text: intl.formatMessage({
            id: 'globalnavv2.mobile.navlink.signin',
            defaultMessage: 'Sign in'
        }),
        href: signInUrl
    };
    const onLogInClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            name: 'bxp.globalnavdropdown.click.login',
            label: (0, $59F4T.analyticsLabels)['JoinSiteUserDropdown.logIn']
        }).fire();
    };
    // Mobile search improvements: hide search button (moved to top of menu)
    isShowSearchButton = false;
    const { isEligible: showContactSalesCta } = (0, $aTTHV.useContactSalesCtaEligibility)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            showContactSalesCta ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1txw _ag851h6o _nssp1h6o _476dftgi _srwzftgi _tnru14no"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTTHV.ContactSalesCta), {
                    isFullWidth: true
                })
            }) : isIncludeCTA && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1txw _ag851h6o _nssp1h6o _476dftgi _srwzftgi _tnru14no"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                    className: "mobile-nav-dropdown-menu-cta",
                    variant: ctaButtonVariant,
                    href: ctaOnClick ? undefined : ctaUrl,
                    dataEventProps: {
                        'data-product-key': productKey,
                        'data-event': 'clicked',
                        'data-event-component': 'linkButton',
                        'data-event-container': 'navbar',
                        'data-label': ctaText,
                        'data-label-english': 'Get it free',
                        'data-track-event': `${productKey}.get-it-free-button-clicked`
                    },
                    style: {
                        width: '100%',
                        fontSize: '1rem',
                        lineHeight: '1.25rem'
                    },
                    onClick: ctaOnClick,
                    children: ctaText
                })
            }),
            mobileLinksSections.map(({ mobileLinkKey: mobileLinkKey, mobileLinksProps: mobileLinksProps }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($a8e8f05bf649c0b2$export$a789aef643e6e22a, {
                        mobileLinkKey: mobileLinkKey,
                        mobileLinksProps: mobileLinksProps,
                        handleMenuPage: handleMenuPage,
                        isIncludeBottomDivider: false
                    })
                }, index)),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3PWZ2.Divider), {}),
            isIncludeAtlassianLogo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _1q51zwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        className: "navigation-bar-atlas-icon",
                        href: homeHref,
                        "aria-label": intl.formatMessage({
                            id: 'productPageNav.atlassian-logo-label',
                            defaultMessage: 'Atlassian logo'
                        }),
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "productPageMobileNav",
                        "data-product-key": "home",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1fDFs.AtlassianLogoArrowLinkBrand), {
                            width: '311px',
                            height: '15.29px'
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _1q51ftgi _85i5ftgi _181nglyw"
                ]),
                children: [
                    isShowSearchButton && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2uCL0.default), {
                        buttonId: 'global-nav-search-bar-icon-mobile',
                        onClick: (e)=>{
                            e.preventDefault();
                            handleMenuPage('search');
                            createAnalyticsEvent({
                                eventName: 'searchOpen',
                                eventType: 'ui',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'searchButtonMobile',
                                source: 'globalNav',
                                attributes: {
                                    product: 'search'
                                }
                            }).fire();
                        }
                    }),
                    !isLoggedIn && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        href: signinLink.href,
                        onClick: onLogInClick,
                        "aria-label": intl.formatMessage({
                            id: 'globalnavv2.mobile.navlink.signin.ariaLabel',
                            defaultMessage: 'Sign in link'
                        }),
                        "data-product-key": productKey,
                        "data-event-component": "linkButton",
                        "data-event-container": "navbarDropdown",
                        "data-label": signinLink.text,
                        "data-event": "clicked",
                        className: (0, $2jatx.default)([
                            "_1rjcxy5q _4cvr1h6o _1e0c116y _syazu5k9 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1053irhu _f8pjftjs _30l3ftjs _16btglyw _1up4glyw _1ien1hz9 _n0fx1hz9 _1lwiglyw _1bas1l7b _ra3xnqa1 _1ah3yh40 _128myh40 _mizu5hrz"
                        ]),
                        style: {
                            "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700')),
                            "--_208vpz": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.purple800')),
                            "--_16ciuzt": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue800')),
                            "--_b2nmim": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.purple900')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                        },
                        children: signinLink.text
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1fDFs", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogoArrowLinkBrand", function () { return $12a36d8c633962d2$export$b793bf6d3c800d0e; });

var $7VQPk = parcelRequire("7VQPk");
const $12a36d8c633962d2$export$b793bf6d3c800d0e = ({ width: width = '100%', height: height = '100%' })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 311 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_2380_3097)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M89.2393 7.06523C89.0084 6.81126 88.6621 6.83435 88.5004 7.1345L84.737 14.6384C84.5984 14.9385 84.8062 15.2848 85.1295 15.2848H90.3476C90.5092 15.2848 90.6708 15.1925 90.7401 15.0309C91.8945 12.6989 91.2018 9.16631 89.2393 7.06523Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M91.9879 0.231197C89.8869 3.55598 90.0254 7.22709 91.4107 9.99775C92.796 12.7684 93.8581 14.8695 93.9274 15.0311C93.9967 15.1927 94.1583 15.2851 94.3199 15.2851H99.538C99.8612 15.2851 100.092 14.9387 99.9305 14.6386C99.9305 14.6386 92.9115 0.600617 92.7268 0.254285C92.5882 -0.0689573 92.1957 -0.0920461 91.9879 0.231197Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M162.826 10.2168C162.826 8.02338 161.649 6.98439 158.37 6.26863C156.546 5.87612 156.107 5.46053 156.107 4.88331C156.107 4.16756 156.754 3.84431 157.954 3.84431C159.409 3.84431 160.841 4.283 162.203 4.9064V2.0203C161.256 1.53544 159.779 1.16602 158.047 1.16602C154.791 1.16602 153.106 2.57443 153.106 4.9064C153.106 6.7535 153.96 8.23118 157.331 8.87767C159.34 9.29326 159.755 9.61651 159.755 10.2861C159.755 10.9326 159.34 11.3482 157.908 11.3482C156.269 11.3482 154.306 10.794 153.037 10.0321V13.0567C154.052 13.5647 155.392 14.1188 157.885 14.1188C161.418 14.1188 162.826 12.5488 162.826 10.2168Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M198.337 1.35076V13.9341H201.016V4.3523L202.147 6.89206L205.934 13.9341H209.305V1.35076H206.626V9.478L205.61 7.12295L202.563 1.35076H198.337Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M181.321 1.35076H178.389V13.911H181.321V1.35076Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M174.994 10.2168C174.994 8.02338 173.817 6.98439 170.538 6.26863C168.714 5.87612 168.275 5.46053 168.275 4.88331C168.275 4.16756 168.922 3.84431 170.122 3.84431C171.577 3.84431 173.008 4.283 174.371 4.9064V2.0203C173.424 1.53544 171.946 1.16602 170.215 1.16602C166.959 1.16602 165.274 2.57443 165.274 4.9064C165.274 6.7535 166.128 8.23118 169.499 8.87767C171.508 9.29326 171.923 9.61651 171.923 10.2861C171.923 10.9326 171.508 11.3482 170.076 11.3482C168.437 11.3482 166.474 10.794 165.204 10.0321V13.0567C166.22 13.5647 167.559 14.1188 170.053 14.1188C173.609 14.1188 174.994 12.5488 174.994 10.2168Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M130.387 1.35076V13.9341H136.39L137.337 11.2097H133.319V1.35076H130.387Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.497 1.35085V4.07532H121.752V13.9342H124.684V4.07532H128.171V1.35085H118.497Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M114.225 1.35068H110.369L105.982 13.9341H109.33L109.954 11.8099C110.693 12.0177 111.478 12.1562 112.309 12.1562C113.117 12.1562 113.902 12.0408 114.664 11.8099L115.287 13.9341H118.635L114.225 1.35068ZM112.286 9.54719C111.732 9.54719 111.177 9.45484 110.669 9.3163L112.286 3.82118L113.902 9.3163C113.394 9.45484 112.863 9.54719 112.286 9.54719Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M146.78 1.35073H142.924L138.537 13.911H141.885L142.508 11.7869C143.247 11.9947 144.032 12.1332 144.864 12.1332C145.672 12.1332 146.457 12.0177 147.219 11.7869L147.842 13.911H151.19L146.78 1.35073ZM144.84 9.54724C144.286 9.54724 143.732 9.45489 143.224 9.31635L144.84 3.82123L146.457 9.31635C145.949 9.45489 145.395 9.54724 144.84 9.54724Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M191.849 1.35073H187.993L183.607 13.911H186.954L187.578 11.7869C188.317 11.9947 189.102 12.1332 189.933 12.1332C190.741 12.1332 191.526 12.0177 192.288 11.7869L192.911 13.911H196.259L191.849 1.35073ZM189.933 9.54724C189.379 9.54724 188.825 9.45489 188.317 9.31635L189.933 3.82123L191.549 9.31635C191.018 9.45489 190.487 9.54724 189.933 9.54724Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M222.713 3.64258L221.633 4.84467L223.383 6.79227H216.068C215.647 6.79227 215.305 7.17296 215.305 7.64201C215.305 8.11107 215.647 8.49175 216.068 8.49175H223.383L221.633 10.4405L222.713 11.6426L226.305 7.64201L222.713 3.64258Z",
                        fill: "#0065FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_2380_3097",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "141.612",
                        height: "15.2851",
                        fill: "white",
                        transform: "translate(84.6934)"
                    })
                })
            })
        ]
    });

});

parcelRegister("aTTHV", function(module, exports) {
$parcel$export(module.exports, "useContactSalesCtaEligibility", function () { return $61f19aadceb13ab3$export$377aadabe770924e; });
$parcel$export(module.exports, "ContactSalesCta", function () { return $61f19aadceb13ab3$export$c816bec35c3748e1; });
/* contact-sales-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $lr38U = parcelRequire("lr38U");

var $eY3N6 = parcelRequire("eY3N6");

var $92PV0 = parcelRequire("92PV0");

var $iSeHD = parcelRequire("iSeHD");

var $lqyi6 = parcelRequire("lqyi6");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $3riD8 = parcelRequire("3riD8");

var $6oFz2 = parcelRequire("6oFz2");
const $61f19aadceb13ab3$var$fullWidthStyles = null;
const $61f19aadceb13ab3$export$377aadabe770924e = ()=>{
    const { accountId: accountId } = (0, $3riD8.useLoggedInUser)();
    // feature gate has configuration to only be enabled on specified page paths
    // https://switcheroo.atlassian.com/ui/gates/c5b6c155-5937-4f7d-9a5f-154015312a23/key/wac_sales_leads_cta_global_nav
    const isFeatureGateEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacSalesLeadsCtaGlobalNav);
    const [isSalesLead, setIsSalesLead] = (0, $1oC0p.useState)(false);
    const [isLoading, setIsLoading] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (!isFeatureGateEnabled || !accountId) return;
        setIsLoading(true);
        const aggClient = new (0, $lr38U.AGGClient)({
            gatewayUrl: 'https://www.atlassian.com/gateway/api/graphql'
        });
        (0, $6oFz2.getIsSMBSalesLead)({
            accountId: accountId,
            aggClient: aggClient
        }).then((response)=>{
            setIsSalesLead(!!response);
        }).catch(()=>{
            console.error('Error fetching GUPS user profile for SMB Sales lead');
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        accountId,
        isFeatureGateEnabled
    ]);
    if (!accountId || !isFeatureGateEnabled) return {
        isEligible: false,
        isLoading: false
    };
    return {
        isEligible: isSalesLead,
        isLoading: isLoading
    };
};
const $61f19aadceb13ab3$export$c816bec35c3748e1 = ({ isFullWidth: isFullWidth })=>{
    const { isEligible: isEligible, isLoading: isLoading } = $61f19aadceb13ab3$export$377aadabe770924e();
    const productKey = (0, $1oC0p.useMemo)(()=>{
        const pathname = globalThis.location?.pathname ?? '';
        if (pathname.includes('/software/jira')) return 'jira';
        if (pathname.includes('/software/confluence')) return 'confluence';
        if (pathname.includes('/enterprise/contact')) return 'enterpriseContactSales';
        if (pathname === '/') return 'home';
        return undefined;
    }, []);
    if (isLoading || !isEligible) return;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($61f19aadceb13ab3$var$CtaButtonRenderer, {
        isFullWidth: isFullWidth,
        productKey: productKey
    });
};
const $61f19aadceb13ab3$var$CtaButtonRenderer = ({ isFullWidth: isFullWidth, productKey: productKey })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features');
    const hasFiredRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (analyticsClient && !hasFiredRef.current) {
            hasFiredRef.current = true;
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'viewed',
                actionSubject: 'button',
                actionSubjectId: 'contactSalesCta',
                source: 'globalNav',
                attributes: {
                    isMobile: !!isFullWidth,
                    productKey: productKey
                }
            }).fire();
        }
    }, [
        analyticsClient,
        createAnalyticsEvent,
        isFullWidth
    ]);
    (0, $1oC0p.useEffect)(()=>{
        (0, $92PV0.Tracking).autoTrackLinks(true);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        variant: "primary_alt",
        href: localizedHref,
        dataEventProps: {
            'data-product-key': productKey,
            'data-event': 'clicked',
            'data-event-component': 'linkButton',
            'data-event-container': 'navbar',
            'data-label-english': 'Contact us'
        },
        className: (0, $2jatx.default)([
            isFullWidth && "_p12fglyw _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "global-nav.contact-sales-cta.label",
            defaultMessage: "Contact us"
        })
    });
};

});
parcelRegister("lqyi6", function(module, exports) {
$parcel$export(module.exports, "Button", function () { return $338d3412a6aa938d$export$353f5b6fc5456de1; });
/* button.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $7qFQI = parcelRequire("7qFQI");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $i4BST = parcelRequire("i4BST");
// CSS Map does not allow tokens
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $338d3412a6aa938d$var$buttonVariantStyles = {
    primary: "_syazu67f _bfhkdoyu _19it1vrj _irr36tgj",
    primary_alt: "_syazqlpt _bfhkh727 _19it1vrj _irr31m13",
    secondary_against_white: "_syazqlpt _bfhk1j28 _19itburr _1yajqlpt _1axpqlpt _irr3lhvh",
    secondary_against_black: "_syazu67f _bfhk1j28 _19ithba0 _1yaju67f _1axpu67f _irr3jy62",
    secondary_against_other: "_syazu67f _bfhk1j28 _19ithba0 _1yaju67f _1axpu67f _irr3dq67 _ufqu1n0t"
};
const $338d3412a6aa938d$var$baseStyles = null;
// CSS Map does not allow tokens
// Focus styles map for different background types
const $338d3412a6aa938d$var$focusStyles = {
    lightBackground: "_mizudoyu _ra3xnqa1 _128myh40 _1ah31y44",
    otherBackground: "_mizuu67f _ra3xnqa1 _128myh40 _1ah31y44"
};
// CSS Map does not allow tokens
const $338d3412a6aa938d$var$fontAndHeightStyles = {
    xlarge: "_1wyb1k8s _vwz4viql _4t3i184x _1tkeckbl",
    large: "_1wyb1k92 _vwz41k8s _4t3i184x _1tke1ylp",
    small: "_1wyb1j6v _vwz41k92 _4t3i184x _1tke14no"
};
const $338d3412a6aa938d$var$noMaxWidthStyle = null;
const $338d3412a6aa938d$var$disabledStyles = null;
const $338d3412a6aa938d$var$loadingStyles = null;
const $338d3412a6aa938d$var$animatedStyles = null;
const $338d3412a6aa938d$var$largeSizeStyles = null;
const $338d3412a6aa938d$var$smallSizeStyles = null;
// Responsive size styles per viewport using cssMap.
// Compiled CSS requires media query keys to be static string literals.
// The strings below are the exact values of the @atlaskit/primitives media constants:
//   mobile     → media.below.sm = "@media not all and (min-width: 48rem)"
//   tablet     → media.only.sm  = "@media (min-width: 48rem) and (max-width: 63.99rem)"
//   desktop    → media.only.md  = "@media (min-width: 64rem) and (max-width: 89.99rem)"
//   xl_desktop → media.above.lg = "@media (min-width: 90rem)"
const $338d3412a6aa938d$var$mobileResponsiveSizeStylesMap = {
    xlarge: "_1kmxdlk8 _1ggm10mc _1ykzdlk8 _1mae10mc _12b611ux _1rkb1feq _1cqs1tcg _1jw81nn1 _1byszwfg _tnru184x _1rgcckbl _1u8n1y44",
    large: "_1kmxdlk8 _1ggm1ou6 _1ykzdlk8 _1mae1ou6 _12b668cl _1rkb1feq _1cqsgktf _1jw81nn1 _1bys1ou6 _tnru184x _1rgc1ylp _1u8nyh40",
    small: "_1kmx19bv _1ggmqslr _1ykz19bv _1maeqslr _12b653f4 _1rkb1feq _1cqsf6fq _1jw81nn1 _1bys1tcg _tnru184x _1rgc14no _xp3c1fac _1u8nyh40"
};
const $338d3412a6aa938d$var$tabletResponsiveSizeStylesMap = {
    xlarge: "_i6jxdlk8 _1lh710mc _z3ncdlk8 _wpai10mc _yir311ux _j6qu1feq _1lzo1tcg _20s51nn1 _119zzwfg _1vkh184x _1x6lckbl _1uzr1y44",
    large: "_i6jxdlk8 _1lh71ou6 _z3ncdlk8 _wpai1ou6 _yir368cl _j6qu1feq _1lzogktf _20s51nn1 _119z1ou6 _1vkh184x _1x6l1ylp _1uzryh40",
    small: "_i6jx19bv _1lh7qslr _z3nc19bv _wpaiqslr _yir353f4 _j6qu1feq _1lzof6fq _20s51nn1 _119z1tcg _1vkh184x _1x6l14no _18ox1fac _1uzryh40"
};
const $338d3412a6aa938d$var$desktopResponsiveSizeStylesMap = {
    xlarge: "_3vshdlk8 _op2c10mc _gos3dlk8 _50ab10mc _1rsv11ux _ceho1feq _flz01tcg _1wy61nn1 _280zzwfg _1595184x _xut1ckbl _1hd81y44",
    large: "_3vshdlk8 _op2c1ou6 _gos3dlk8 _50ab1ou6 _1rsv68cl _ceho1feq _flz0gktf _1wy61nn1 _280z1ou6 _1595184x _xut11ylp _1hd8yh40",
    small: "_3vsh19bv _op2cqslr _gos319bv _50abqslr _1rsv53f4 _ceho1feq _flz0f6fq _1wy61nn1 _280z1tcg _1595184x _xut114no _ed0h1fac _1hd8yh40"
};
const $338d3412a6aa938d$var$xlDesktopResponsiveSizeStylesMap = {
    xlarge: "_2tdedlk8 _1a8710mc _uwpcdlk8 _3r7o10mc _ytj911ux _1i7q1feq _fz891tcg _161g1nn1 _1ol9zwfg _1ikw184x _yyta1y44",
    large: "_2tdedlk8 _1a871ou6 _uwpcdlk8 _3r7o1ou6 _ytj968cl _1i7q1feq _fz89gktf _161g1nn1 _1ol91ou6 _1ikw184x _jx401ylp _yytayh40",
    small: "_2tde19bv _1a87qslr _uwpc19bv _3r7oqslr _ytj953f4 _1i7q1feq _fz89f6fq _161g1nn1 _1ol91tcg _1ikw184x _jx4014no _4byv1fac _yytayh40"
};
function $338d3412a6aa938d$var$isLinkArgs(props) {
    return 'href' in props;
}
const $338d3412a6aa938d$var$isSignInUrl = (href)=>{
    const baseUrl = "https://id.atlassian.com";
    const stargateBaseUrl = "https://www.atlassian.com/gateway/api";
    const continueUrl = stargateBaseUrl + '/start/authredirect';
    const signInUrl = `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}`;
    // Check if href matches sign-in URL with or without application parameter, or is start-trial
    return href === signInUrl || href.startsWith(signInUrl + '&application=') || href === '#start-trial';
};
const $338d3412a6aa938d$var$isHyperlinkRef = (href)=>{
    return href.startsWith('#');
};
const $338d3412a6aa938d$var$isNonSigninOrWacUrl = (href)=>{
    return !(0, $jQ0cd.isLocalizableHref)(href) && !$338d3412a6aa938d$var$isSignInUrl(href) && !$338d3412a6aa938d$var$isHyperlinkRef(href);
};
const $338d3412a6aa938d$var$getButtonVariant = (variant, colorAgainst)=>{
    if (variant === 'primary' || variant === 'primary_alt') return variant;
    if (colorAgainst === undefined) return 'secondary_against_white';
    return `secondary_against_${colorAgainst}`;
};
const $338d3412a6aa938d$var$isLightBackground = (colorAgainst)=>{
    return colorAgainst === 'white' || colorAgainst === undefined;
};
const $338d3412a6aa938d$var$arrowIcon = /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
    id: "arrow-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "12",
    viewBox: "0 0 16 12",
    "aria-hidden": "true",
    className: (0, $2jatx.default)([
        "_1o9zidpf _ahbqu2gc _v56412ha"
    ]),
    style: {
        "--_m369gh": (0, $6ZVlx.default)((0, $bNzAT.default)('motion.duration.250ms')),
        "--_dolbo3": (0, $6ZVlx.default)((0, $bNzAT.default)('motion.easing.ease-both'))
    },
    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.1432 0.355029C9.61658 -0.118343 10.3839 -0.118343 10.8573 0.355029L15.6452 5.143C15.7172 5.21496 15.777 5.29436 15.8271 5.37785C15.836 5.39278 15.8462 5.40702 15.8545 5.42236L15.8612 5.43562C15.8922 5.49457 15.9163 5.55608 15.9369 5.61839C15.9398 5.62691 15.9428 5.63534 15.9454 5.64395C15.9526 5.66746 15.9586 5.69116 15.9644 5.71498C15.9686 5.73229 15.9733 5.74947 15.9767 5.76706C15.9994 5.88356 16.0054 6.00249 15.9937 6.12029C15.9883 6.17526 15.9778 6.22872 15.9653 6.28128C15.9593 6.30667 15.9531 6.332 15.9454 6.35704C15.9427 6.36603 15.9389 6.37465 15.936 6.38355C15.9279 6.40785 15.921 6.43263 15.9114 6.45647C15.9096 6.46077 15.9065 6.4645 15.9047 6.46878C15.8818 6.52321 15.8545 6.57499 15.8242 6.62503C15.816 6.63867 15.8094 6.65333 15.8006 6.6667C15.7994 6.66838 15.7979 6.66976 15.7968 6.67144C15.7894 6.68253 15.7808 6.6928 15.7731 6.70363C15.7584 6.72411 15.7447 6.74545 15.7286 6.76519C15.7027 6.79691 15.6748 6.82747 15.6452 6.85705L10.8573 11.645C10.3839 12.1183 9.61657 12.1183 9.1432 11.645C8.66985 11.1717 8.66988 10.4043 9.1432 9.93097L11.862 7.21217H1.21215C0.542727 7.21217 4.7978e-05 6.66943 0 6.00002C0 5.33057 0.542698 4.78788 1.21215 4.78788H11.862L9.1432 2.06908C8.66985 1.59572 8.66988 0.828404 9.1432 0.355029Z"
    })
});
const $338d3412a6aa938d$export$353f5b6fc5456de1 = ({ variant: variant = 'primary', size: size = 'large', responsiveSize: responsiveSize, colorAgainst: colorAgainst, className: className, children: children, dataEventProps: dataEventProps, isLoading: isLoading, isDisabled: isDisabled = false, ariaLabelledby: ariaLabelledby, ...props })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const buttonSize = variant === 'secondary' ? 'small' : size;
    const isLink = $338d3412a6aa938d$var$isLinkArgs(props);
    const fontAndHeightStyle = $338d3412a6aa938d$var$fontAndHeightStyles[buttonSize];
    const buttonVariant = $338d3412a6aa938d$var$getButtonVariant(variant, colorAgainst);
    const variantStyles = $338d3412a6aa938d$var$buttonVariantStyles[buttonVariant];
    const focusStylesKey = $338d3412a6aa938d$var$isLightBackground(colorAgainst) ? 'lightBackground' : 'otherBackground';
    const buttonFocusStyles = $338d3412a6aa938d$var$focusStyles[focusStylesKey];
    const handleOnClick = (e)=>{
        if (isDisabled) e.preventDefault();
        else if (props.onClick) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        props.onClick(e);
    };
    const cssList = [
        $338d3412a6aa938d$var$baseStyles,
        variantStyles,
        fontAndHeightStyle,
        buttonFocusStyles,
        isDisabled && !isLoading && $338d3412a6aa938d$var$disabledStyles,
        isLoading && $338d3412a6aa938d$var$loadingStyles,
        isWacRefresh && $338d3412a6aa938d$var$animatedStyles,
        buttonSize === 'large' && $338d3412a6aa938d$var$largeSizeStyles,
        buttonSize === 'small' && $338d3412a6aa938d$var$smallSizeStyles,
        isWacRefresh && responsiveSize?.mobile && $338d3412a6aa938d$var$mobileResponsiveSizeStylesMap[responsiveSize.mobile],
        isWacRefresh && responsiveSize?.tablet && $338d3412a6aa938d$var$tabletResponsiveSizeStylesMap[responsiveSize.tablet],
        isWacRefresh && responsiveSize?.desktop && $338d3412a6aa938d$var$desktopResponsiveSizeStylesMap[responsiveSize.desktop],
        isWacRefresh && responsiveSize?.xl_desktop && $338d3412a6aa938d$var$xlDesktopResponsiveSizeStylesMap[responsiveSize.xl_desktop],
        isWacRefresh && variant === 'secondary' && $338d3412a6aa938d$var$noMaxWidthStyle
    ];
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(isLink ? props.href ?? '' : '');
    if (isLink) return /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1bah1h6o _vchhusvi _1e0c116y _k48pbfng _ect4z4z1 _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1mv1 _d0altlke _1v1udejf _mizu1r31 _ra3xglyw _128m1o36",
            $338d3412a6aa938d$var$buttonVariantStyles[buttonVariant],
            $338d3412a6aa938d$var$fontAndHeightStyles[buttonSize],
            $338d3412a6aa938d$var$focusStyles[focusStylesKey],
            isDisabled && !isLoading && "_bfhks3kk _syaz1afi _1h6d1j28 _1yaj1afi _1axp1afi _d0al13gf _irr3s3kk _30l31afi _4cvx1j28 _1a5f1afi _1loy1afi _1v1uglyw _z760glyw",
            isLoading && "_d0al13gf _irr3glyw",
            isWacRefresh && "_1d1f1o2u _1ggl1yeg _v5641dxf",
            buttonSize === 'large' && "_1yt4pp4v _1ul968cl _p12f1feq",
            buttonSize === 'small' && "_1yt4eg7l _1ul953f4 _p12f1feq",
            isWacRefresh && responsiveSize?.mobile && $338d3412a6aa938d$var$mobileResponsiveSizeStylesMap[responsiveSize.mobile],
            isWacRefresh && responsiveSize?.tablet && $338d3412a6aa938d$var$tabletResponsiveSizeStylesMap[responsiveSize.tablet],
            isWacRefresh && responsiveSize?.desktop && $338d3412a6aa938d$var$desktopResponsiveSizeStylesMap[responsiveSize.desktop],
            isWacRefresh && responsiveSize?.xl_desktop && $338d3412a6aa938d$var$xlDesktopResponsiveSizeStylesMap[responsiveSize.xl_desktop],
            isWacRefresh && variant === 'secondary' && "_p12fglyw",
            className
        ]),
        ...props,
        ...dataEventProps,
        onClick: handleOnClick,
        href: localizedHref,
        target: typeof props.target === 'string' ? props.target : props.href && /* redirecting to new tab if the href is not on WAC and not a Signin link */ $338d3412a6aa938d$var$isNonSigninOrWacUrl(props.href) ? '_blank' : '',
        rel: props.href && $338d3412a6aa938d$var$isNonSigninOrWacUrl(props.href) ? 'noreferrer' : '',
        "aria-labelledby": ariaLabelledby,
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
            "--_hjrx1n": (0, $6ZVlx.default)((0, $bNzAT.default)('corner.radius.pill')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light400')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1ykghpn": (0, $6ZVlx.default)((0, $bNzAT.default)('motion.duration.100ms')),
            "--_kqkuu4": (0, $6ZVlx.default)((0, $bNzAT.default)('motion.easing.ease40-in-out')),
            "--_pysqvm": (0, $6ZVlx.default)((0, $bNzAT.default)('motion.duration.150ms'))
        },
        children: [
            children,
            isWacRefresh && variant === 'secondary' && $338d3412a6aa938d$var$arrowIcon
        ]
    });
    // Primary Blue and Secondary (against anything other than white) should have a white spinner
    const spinnerAppearance = variant === 'primary' || variant === 'secondary' && !!colorAgainst && colorAgainst !== 'white' ? 'invert' : 'inherit';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1bah1h6o _vchhusvi _1e0c116y _k48pbfng _ect4z4z1 _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko1mv1 _d0altlke _1v1udejf _mizu1r31 _ra3xglyw _128m1o36",
            $338d3412a6aa938d$var$buttonVariantStyles[buttonVariant],
            $338d3412a6aa938d$var$fontAndHeightStyles[buttonSize],
            $338d3412a6aa938d$var$focusStyles[focusStylesKey],
            isDisabled && !isLoading && "_bfhks3kk _syaz1afi _1h6d1j28 _1yaj1afi _1axp1afi _d0al13gf _irr3s3kk _30l31afi _4cvx1j28 _1a5f1afi _1loy1afi _1v1uglyw _z760glyw",
            isLoading && "_d0al13gf _irr3glyw",
            isWacRefresh && "_1d1f1o2u _1ggl1yeg _v5641dxf",
            buttonSize === 'large' && "_1yt4pp4v _1ul968cl _p12f1feq",
            buttonSize === 'small' && "_1yt4eg7l _1ul953f4 _p12f1feq",
            isWacRefresh && responsiveSize?.mobile && $338d3412a6aa938d$var$mobileResponsiveSizeStylesMap[responsiveSize.mobile],
            isWacRefresh && responsiveSize?.tablet && $338d3412a6aa938d$var$tabletResponsiveSizeStylesMap[responsiveSize.tablet],
            isWacRefresh && responsiveSize?.desktop && $338d3412a6aa938d$var$desktopResponsiveSizeStylesMap[responsiveSize.desktop],
            isWacRefresh && responsiveSize?.xl_desktop && $338d3412a6aa938d$var$xlDesktopResponsiveSizeStylesMap[responsiveSize.xl_desktop],
            isWacRefresh && variant === 'secondary' && "_p12fglyw",
            className
        ]),
        disabled: isLoading || isDisabled,
        type: 'button' /* this default value is overridable within the following props */ ,
        ...props,
        ...dataEventProps,
        onClick: handleOnClick,
        "aria-labelledby": ariaLabelledby,
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
            "--_hjrx1n": (0, $6ZVlx.default)((0, $bNzAT.default)('corner.radius.pill')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light400')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1ykghpn": (0, $6ZVlx.default)((0, $bNzAT.default)('motion.duration.100ms')),
            "--_kqkuu4": (0, $6ZVlx.default)((0, $bNzAT.default)('motion.easing.ease40-in-out')),
            "--_pysqvm": (0, $6ZVlx.default)((0, $bNzAT.default)('motion.duration.150ms'))
        },
        children: [
            isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
                interactionName: "load",
                label: "Loading",
                appearance: spinnerAppearance,
                size: buttonSize === 'small' ? 'small' : 'medium'
            }) : children,
            !isLoading && isWacRefresh && variant === 'secondary' && $338d3412a6aa938d$var$arrowIcon
        ]
    });
};

});

parcelRegister("6oFz2", function(module, exports) {
$parcel$export(module.exports, "getIsSMBSalesLead", function () { return $d97ac33575431e97$export$7ff16243701dc0d3; });

var $lr38U = parcelRequire("lr38U");
const $d97ac33575431e97$var$createQuery = (accountId)=>{
    return `#graphql
    query InboundSalesQuery {
        growthUnifiedProfile_getUnifiedProfile(accountId: "${accountId}"){
            userProfile{
                domainType
                smbUserVisitedPricingPages
            }
            sites{
                cloudId
                displayName
                products{
                    productKey
                    productName
                    productEdition
                }
            }
        }
    }
`;
};
const $d97ac33575431e97$export$7ff16243701dc0d3 = async ({ accountId: accountId, aggClient: aggClient = new (0, $lr38U.AGGClient)() })=>{
    const customHeaders = {
        'x-use-case': 'sales-inbound'
    };
    const { data: data, errors: errors } = await aggClient.query($d97ac33575431e97$var$createQuery(accountId), undefined, customHeaders);
    if (errors) {
        console.error(`GRS API failed`, errors[0]?.message);
        throw new Error(errors[0]?.message);
    }
    const isSMBSalesLead = data?.growthUnifiedProfile_getUnifiedProfile?.userProfile?.smbUserVisitedPricingPages;
    return isSMBSalesLead;
};

});


parcelRegister("2uCL0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90ea6dece7c9a6dd$export$2e2bcd8739ae039; });
/* search-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $hLJF4 = parcelRequire("hLJF4");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $2gCne = parcelRequire("2gCne");
const $90ea6dece7c9a6dd$var$searchIconStyle = null;
const $90ea6dece7c9a6dd$var$searchIconStyleAI = null;
const $90ea6dece7c9a6dd$var$svgStyle = null;
const $90ea6dece7c9a6dd$var$tooltipStyle = null;
const $90ea6dece7c9a6dd$var$popoutBackgroundStyle = null;
const $90ea6dece7c9a6dd$var$expandBackgroundStyle = null;
const $90ea6dece7c9a6dd$var$fadeInKeyframes = null;
const $90ea6dece7c9a6dd$var$fadeOutKeyframes = null;
const $90ea6dece7c9a6dd$var$popOutTextStyle = null;
const $90ea6dece7c9a6dd$var$popInTextStyle = null;
const $90ea6dece7c9a6dd$var$baseTextStyle = null;
const $90ea6dece7c9a6dd$var$SEARCH_AI_ANIMATION_LOCAL_STORAGE_KEY = 'search_ai_animation_played';
const $90ea6dece7c9a6dd$var$SEARCH_AI_ANIMATION_PLAYED_COUNT = 'search_ai_played_count';
const $90ea6dece7c9a6dd$var$DEFAULT_SEARCH_AI_ANIMATION_EXPIRY = 86400; // show once every 24 hours
const $90ea6dece7c9a6dd$var$MAX_SEARCH_AI_ANIMATION_EXPIRY = 31536000; // set expiry to 1 year for permanent
const $90ea6dece7c9a6dd$var$MAX_SEARCH_AI_ANIMATION_PLAYED_COUNT = 3; // show max 3 times
const $90ea6dece7c9a6dd$var$SearchButton = (props)=>{
    const intl = (0, $8e22h.default)();
    const [showSearchPopout, setShowSearchPopout] = (0, $1oC0p.useState)(false);
    const [hasShownPopout, setHasShownPopout] = (0, $1oC0p.useState)(false);
    const hasPlayedPopoutAnimation = (0, $2gCne.getLocalStorage)($90ea6dece7c9a6dd$var$SEARCH_AI_ANIMATION_LOCAL_STORAGE_KEY) === 'true';
    const searchAiAnimationPlayedCount = parseInt((0, $2gCne.getLocalStorage)($90ea6dece7c9a6dd$var$SEARCH_AI_ANIMATION_PLAYED_COUNT) || '0');
    const translated = {
        searchLabel: intl.formatMessage({
            id: 'globalnav.v2.search.label',
            defaultMessage: 'Search'
        })
    };
    const tooltipText = props.aiEnabled ? intl.formatMessage({
        id: 'globalnav.v2.search-bar.ai-enabled.tooltip',
        defaultMessage: 'Search or ask anything'
    }) : null;
    (0, $1oC0p.useEffect)(()=>{
        const shouldShowSearchAiAnimation = props.aiEnabled && !showSearchPopout && !hasPlayedPopoutAnimation && searchAiAnimationPlayedCount < $90ea6dece7c9a6dd$var$MAX_SEARCH_AI_ANIMATION_PLAYED_COUNT;
        if (shouldShowSearchAiAnimation) {
            const timeout = setTimeout(()=>{
                setShowSearchPopout(true);
                setHasShownPopout(true);
                const playedCount = searchAiAnimationPlayedCount + 1;
                if (playedCount >= $90ea6dece7c9a6dd$var$MAX_SEARCH_AI_ANIMATION_PLAYED_COUNT) (0, $2gCne.setLocalStorage)($90ea6dece7c9a6dd$var$SEARCH_AI_ANIMATION_LOCAL_STORAGE_KEY, 'true', $90ea6dece7c9a6dd$var$MAX_SEARCH_AI_ANIMATION_EXPIRY);
                else (0, $2gCne.setLocalStorage)($90ea6dece7c9a6dd$var$SEARCH_AI_ANIMATION_LOCAL_STORAGE_KEY, 'true', $90ea6dece7c9a6dd$var$DEFAULT_SEARCH_AI_ANIMATION_EXPIRY); // show once every 24 hours
                (0, $2gCne.setLocalStorage)($90ea6dece7c9a6dd$var$SEARCH_AI_ANIMATION_PLAYED_COUNT, playedCount.toString(), $90ea6dece7c9a6dd$var$MAX_SEARCH_AI_ANIMATION_EXPIRY);
                setTimeout(()=>{
                    setShowSearchPopout(false);
                }, 2500);
            }, 3000);
            return ()=>clearTimeout(timeout);
        }
        return undefined;
    }, [
        props.aiEnabled,
        showSearchPopout
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("search", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            props.aiEnabled && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _rjxpidpf _bfhkg7ng _syaz1ezn _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _2rko1ylp _1wyb1crf _k48pbfng _o5721q9c _1bsb1ylp _4t3i1ylp _1pby1mrw _lcxvglyw _v5641xr4",
                    showSearchPopout && "_1bsbnxnw"
                ]),
                style: {
                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light100')),
                    "--_xluqsf": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark500'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_tzy4idpf",
                        showSearchPopout && "",
                        showSearchPopout && "_y44v16f6",
                        !showSearchPopout && hasShownPopout && "",
                        !showSearchPopout && hasShownPopout && "_y44vro3o"
                    ]),
                    children: "Search"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                content: tooltipText,
                className: (0, $2jatx.default)([
                    "_11q71bd0 _syaz15cr _1wyb1crf _zg8l4jg8 _k48pni7l _ca0qyh40 _u5f3ftgi _n3tdyh40 _19bvftgi _zulpv77o"
                ]),
                style: {
                    "--_1kmobfd": (0, $6ZVlx.default)((0, $bNzAT.default)('color.secondary.navy'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    onClick: (e)=>{
                        if (props.aiEnabled) (0, $2gCne.setLocalStorage)($90ea6dece7c9a6dd$var$SEARCH_AI_ANIMATION_LOCAL_STORAGE_KEY, 'true', $90ea6dece7c9a6dd$var$MAX_SEARCH_AI_ANIMATION_EXPIRY);
                        props.onClick(e);
                    },
                    id: props.buttonId,
                    "aria-label": String(translated.searchLabel).toLowerCase(),
                    "data-testid": "global-nav-search-icon",
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "globalNavWac",
                    "data-product-key": "jiraSoftware",
                    "data-ai-enabled": props.aiEnabled,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _19itidpf _80omtlke",
                        props.aiEnabled && "_1bahesu3 _kqswh2mm _2rko1ylp _v564eq78 _1pbycs5v _ahbq1a70 _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                        width: "23",
                        height: "25",
                        viewBox: "0 0 23 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: (0, $2jatx.default)([
                            "_1bsb1tcg _4t3i1tcg _1pbykb7n _1otx1ezn _1tin5hrz"
                        ]),
                        style: {
                            "--_xluqsf": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark500')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M17.0918 18.5623L20.2497 21.7201",
                                stroke: "#101214",
                                strokeWidth: "2.75",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M10.8417 19.1316C15.289 19.1316 18.8943 15.5263 18.8943 11.079C18.8943 6.63165 15.289 3.02637 10.8417 3.02637C6.39435 3.02637 2.78906 6.63165 2.78906 11.079C2.78906 15.5263 6.39435 19.1316 10.8417 19.1316Z",
                                stroke: "#101214",
                                strokeWidth: "2.25"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $90ea6dece7c9a6dd$export$2e2bcd8739ae039 = $90ea6dece7c9a6dd$var$SearchButton;

});

parcelRegister("yTguz", function(module, exports) {
$parcel$export(module.exports, "MobileNavLink", function () { return $d334173082660eb8$export$99526554844bced1; });
/* mobile-nav-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $9BG80 = parcelRequire("9BG80");

var $jQ0cd = parcelRequire("jQ0cd");
const $d334173082660eb8$var$containerCss = null;
const $d334173082660eb8$var$headerCss = null;
const $d334173082660eb8$var$hrefCss = null;
const $d334173082660eb8$var$LinkContent = ({ linkText: linkText, hasSubnav: hasSubnav, href: href })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1yb4 _1rjcpxbi",
            !hasSubnav && !href && "_1p1dangw _k48p1nn1 _1wyb1crf _vwz4gktf _1rjc1crf",
            href && "_1rjcpxbi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: linkText
            }),
            hasSubnav && /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                label: "",
                spacing: "spacious"
            })
        ]
    });
};
const $d334173082660eb8$export$99526554844bced1 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: props.href ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: props.href,
            target: (0, $jQ0cd.isLocalizableHref)(props.href) ? '' : '_blank',
            rel: (0, $jQ0cd.isLocalizableHref)(props.href) ? '' : 'noreferrer',
            "aria-label": props.linkText,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "navbarDropdown",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($d334173082660eb8$var$LinkContent, {
                ...props
            })
        }) : props.hasSubnav ? /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            style: {
                all: 'unset',
                width: '100%',
                cursor: 'pointer'
            },
            onClick: (e)=>{
                e.preventDefault();
                if (props.dropdownType !== undefined) props.handleMenuPage(props.dropdownType);
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($d334173082660eb8$var$LinkContent, {
                ...props
            })
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)($d334173082660eb8$var$LinkContent, {
            ...props
        })
    });
};

});
parcelRegister("9BG80", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9b5ca0894f9a89607a0f553a633e25>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fe83f80b176d994$var$_react = $6fe83f80b176d994$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6fe83f80b176d994$var$_baseNew = $6fe83f80b176d994$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6fe83f80b176d994$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fe83f80b176d994$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $6fe83f80b176d994$var$_react.default.createElement($6fe83f80b176d994$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$6fe83f80b176d994$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $6fe83f80b176d994$var$_default = module.exports.default = $6fe83f80b176d994$var$ChevronRightIcon;

});



parcelRegister("2a9sZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $71e87b474b5c89c9$export$2e2bcd8739ae039; });
/* mobile-nav-logged-in-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $i99jD = parcelRequire("i99jD");
var $aKsx2 = parcelRequire("aKsx2");

var $4CtXE = parcelRequire("4CtXE");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $71e87b474b5c89c9$var$emailStyle = null;
const $71e87b474b5c89c9$var$displayNameStyle = null;
const $71e87b474b5c89c9$var$userInfoStyle = null;
const $71e87b474b5c89c9$var$MobileLoggedInUseDropdown = ({ userInfo: userInfo, onLogOutClick: onLogOutClick, onManageLicensesClick: onManageLicensesClick, onManageProfileClick: onManageProfileClick, onSwitchAccountClick: onSwitchAccountClick })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "mobile-logged-in-user-container",
        "data-testid": "global-nav-mobile-user-profile-container-user-loggedin",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $aKsx2.default), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
                    isDisabled: true,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1q517vkz _85i57vkz",
                            "global-nav-userinfo"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_syaz1qc2 _1pfhftgi _6rthftgi",
                                    "global-nav-userinfo-displayName"
                                ]),
                                style: {
                                    "--_1fww9ud": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light800'))
                                },
                                children: userInfo.displayName
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_syaz1pfd _k48p1fw0 _1pfhftgi _6rthftgi",
                                    "global-nav-userinfo-email"
                                ]),
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                                },
                                children: userInfo.email
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
                    onClick: onSwitchAccountClick,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $4CtXE.messages).switchAccount
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
                    onClick: onManageProfileClick,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $4CtXE.messages).profile
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
                    onClick: onManageLicensesClick,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $4CtXE.messages).licenses
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
                    onClick: onLogOutClick,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $4CtXE.messages).logOut
                    })
                })
            ]
        })
    });
};
var $71e87b474b5c89c9$export$2e2bcd8739ae039 = $71e87b474b5c89c9$var$MobileLoggedInUseDropdown;

});
parcelRegister("i99jD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3604b272545594b$export$2e2bcd8739ae039; });

var $6Mntg = parcelRequire("6Mntg");

var $8s4f2 = parcelRequire("8s4f2");

var $1oC0p = parcelRequire("1oC0p");

var $9eBsh = parcelRequire("9eBsh");

var $41r9a = parcelRequire("41r9a");

var $3EeSh = parcelRequire("3EeSh");

var $apvjf = parcelRequire("apvjf");

var $9go2L = parcelRequire("9go2L");
var $d3604b272545594b$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ var $d3604b272545594b$var$DropdownMenuItem = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, rest = (0, $8s4f2.default)(_ref, $d3604b272545594b$var$_excluded);
    var itemRef = (0, $9go2L.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3EeSh.default), (0, $6Mntg.default)({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $9eBsh.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $apvjf.default), (0, $6Mntg.default)({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $9eBsh.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $41r9a.default), (0, $6Mntg.default)({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $9eBsh.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, rest), children);
});
var $d3604b272545594b$export$2e2bcd8739ae039 = $d3604b272545594b$var$DropdownMenuItem;

});
parcelRegister("6Mntg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ef96e9cb83f1787$export$2e2bcd8739ae039; });
function $4ef96e9cb83f1787$export$2e2bcd8739ae039() {
    return $4ef96e9cb83f1787$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4ef96e9cb83f1787$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8s4f2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $62743a85c0036efe$export$2e2bcd8739ae039; });

var $2q9xA = parcelRequire("2q9xA");
function $62743a85c0036efe$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $2q9xA.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("2q9xA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1c35690bedfc2a61$export$2e2bcd8739ae039; });
function $1c35690bedfc2a61$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("9eBsh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b9279b1c8f4b333$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $6b9279b1c8f4b333$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("41r9a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2edc503b4e67a757$export$2e2bcd8739ae039; });

var $6Mntg = parcelRequire("6Mntg");

var $8s4f2 = parcelRequire("8s4f2");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $ja6hR = parcelRequire("ja6hR");

var $gfKh0 = parcelRequire("gfKh0");

var $75Hol = parcelRequire("75Hol");

var $dks1c = parcelRequire("dks1c");
var $2edc503b4e67a757$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2edc503b4e67a757$var$ButtonItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $gfKh0.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, rest = (0, $8s4f2.default)(props, $2edc503b4e67a757$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $ja6hR.propDeprecationWarning)("@atlaskit/menu", 'cssFn', cssFn !== (0, $gfKh0.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $3dJ4i.jsx)((0, $dks1c.default), (0, $6Mntg.default)({
        className: (0, $75Hol.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $3dJ4i.jsx)("button", (0, $6Mntg.default)({
            "data-testid": testId
        }, rest, {
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $2edc503b4e67a757$export$2e2bcd8739ae039 = $2edc503b4e67a757$var$ButtonItem;

});
parcelRegister("ja6hR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df33d3f51abd3ebd$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "propDeprecationWarning", function () { return $df33d3f51abd3ebd$export$eb1decd851a5ae56; });

var $5Ua54 = parcelRequire("5Ua54");

var $7t0tI = parcelRequire("7t0tI");
function $df33d3f51abd3ebd$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $5Ua54.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $df33d3f51abd3ebd$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("5Ua54", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44ca00910cd7e46b$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $44ca00910cd7e46b$var$printed = {};
function $44ca00910cd7e46b$export$2e2bcd8739ae039(message) {
    if ($44ca00910cd7e46b$var$printed[message]) return;
    $44ca00910cd7e46b$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("gfKh0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bd51f0fae84bf75c$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $bd51f0fae84bf75c$export$2e2bcd8739ae039() {}

});

parcelRegister("75Hol", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $529aa8bb22df20e0$export$470e5c2be1411c89; });

var $9Uwf5 = parcelRequire("9Uwf5");
function $529aa8bb22df20e0$export$ba05d765b8392e5e(flagResolver) {
    (0, $9Uwf5.setBooleanResolver)(flagResolver);
}
function $529aa8bb22df20e0$export$470e5c2be1411c89(name) {
    return (0, $9Uwf5.resolveBooleanFlag)(name);
}

});
parcelRegister("9Uwf5", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $73725aa6a93d1e63$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $73725aa6a93d1e63$export$6333b6aff9fc6275; });

var $aLZEy = parcelRequire("aLZEy");

var $7t0tI = parcelRequire("7t0tI");
var $73725aa6a93d1e63$var$pkgName = '@atlaskit/platform-feature-flags';
var $73725aa6a93d1e63$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $73725aa6a93d1e63$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $73725aa6a93d1e63$var$ENV_ENABLE_PLATFORM_FF = $73725aa6a93d1e63$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $73725aa6a93d1e63$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $73725aa6a93d1e63$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $73725aa6a93d1e63$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $73725aa6a93d1e63$var$ENV_ENABLE_PLATFORM_FF || $73725aa6a93d1e63$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $73725aa6a93d1e63$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $73725aa6a93d1e63$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$73725aa6a93d1e63$var$globalVar[$73725aa6a93d1e63$export$7e41b1b2bdee3f98] = $73725aa6a93d1e63$var$globalVar[$73725aa6a93d1e63$export$7e41b1b2bdee3f98] || $73725aa6a93d1e63$var$DEFAULT_PFF_GLOBAL;
function $73725aa6a93d1e63$export$f2b591175b3e424c(resolver) {
    $73725aa6a93d1e63$var$globalVar[$73725aa6a93d1e63$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $73725aa6a93d1e63$export$6333b6aff9fc6275(flagKey) {
    if ($73725aa6a93d1e63$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $aLZEy.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $73725aa6a93d1e63$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $73725aa6a93d1e63$var$globalVar[$73725aa6a93d1e63$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("aLZEy", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $7d7e1e31dfe75780$export$1c9f709888824e05; });
var $7d7e1e31dfe75780$var$_ref, $7d7e1e31dfe75780$var$_globalThis$process, $7d7e1e31dfe75780$var$_globalThis$process$e, $7d7e1e31dfe75780$var$_globalThis$process2, $7d7e1e31dfe75780$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $7d7e1e31dfe75780$var$TESTS_MODE = ($7d7e1e31dfe75780$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($7d7e1e31dfe75780$var$_globalThis$process = globalThis.process) === null || $7d7e1e31dfe75780$var$_globalThis$process === void 0 ? void 0 : ($7d7e1e31dfe75780$var$_globalThis$process$e = $7d7e1e31dfe75780$var$_globalThis$process.env) === null || $7d7e1e31dfe75780$var$_globalThis$process$e === void 0 ? void 0 : $7d7e1e31dfe75780$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $7d7e1e31dfe75780$var$_ref !== void 0) ? $7d7e1e31dfe75780$var$_ref : false;
var $7d7e1e31dfe75780$var$DEBUG_MODE = !$7d7e1e31dfe75780$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($7d7e1e31dfe75780$var$_globalThis$process2 = globalThis.process) === null || $7d7e1e31dfe75780$var$_globalThis$process2 === void 0 ? void 0 : ($7d7e1e31dfe75780$var$_globalThis$process2$ = $7d7e1e31dfe75780$var$_globalThis$process2.env) === null || $7d7e1e31dfe75780$var$_globalThis$process2$ === void 0 ? void 0 : $7d7e1e31dfe75780$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $7d7e1e31dfe75780$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$7d7e1e31dfe75780$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("dks1c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b42e07f73f19e96$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $ja6hR = parcelRequire("ja6hR");

var $4tCgC = parcelRequire("4tCgC");

var $75Hol = parcelRequire("75Hol");

var $j9pVa = parcelRequire("j9pVa");

var $6mgZr = parcelRequire("6mgZr");

var $8UYGb = parcelRequire("8UYGb");
var $9b42e07f73f19e96$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $3dJ4i.jsx)(Component, props));
};
var $9b42e07f73f19e96$var$beforeAfterElementStyles = (0, $3dJ4i.css)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
});
var $9b42e07f73f19e96$var$contentStyles = (0, $3dJ4i.css)({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flexGrow: 1,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
var $9b42e07f73f19e96$var$truncateStyles = (0, $3dJ4i.css)({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $9b42e07f73f19e96$var$wordBreakStyles = (0, $3dJ4i.css)({
    wordBreak: 'break-word'
});
var $9b42e07f73f19e96$var$descriptionStyles = (0, $3dJ4i.css)({
    marginTop: "var(--ds-space-050, 4px)",
    color: "var(--ds-text-subtlest, ".concat((0, $6mgZr.N200), ")"),
    fontSize: "var(--ds-font-size-075, 12px)"
});
var $9b42e07f73f19e96$var$disabledDescriptionStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-disabled, ".concat((0, $6mgZr.N200), ")")
});
var $9b42e07f73f19e96$var$positionRelativeStyles = (0, $3dJ4i.css)({
    position: 'relative'
});
var $9b42e07f73f19e96$var$primitiveStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: 'center',
    border: 0,
    fontSize: "var(--ds-font-size-100, 14px)",
    outline: 0,
    textDecoration: 'none',
    userSelect: 'none',
    '::-moz-focus-inner': {
        border: 0
    },
    ':hover': {
        textDecoration: 'none'
    }
});
var $9b42e07f73f19e96$var$spacingMapStyles = {
    cozy: (0, $3dJ4i.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $3dJ4i.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $9b42e07f73f19e96$var$interactiveStyles = (0, $3dJ4i.css)({
    cursor: 'pointer'
});
var $9b42e07f73f19e96$var$unselectedStyles = (0, $3dJ4i.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    ':visited': {
        color: 'currentColor'
    },
    ':hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $6mgZr.N20), ")"),
        color: 'currentColor'
    },
    ':active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $6mgZr.N30), ")"),
        boxShadow: 'none',
        color: 'currentColor'
    }
});
var $9b42e07f73f19e96$var$disabledStyles = (0, $3dJ4i.css)({
    cursor: 'not-allowed',
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $6mgZr.N200), ")")
    }
});
var $9b42e07f73f19e96$var$selectedBorderStyles = (0, $3dJ4i.css)({
    '&::before': {
        width: 2,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        background: "var(--ds-border-selected, transparent)",
        content: '""'
    }
});
var $9b42e07f73f19e96$var$selectedNotchStyles = (0, $3dJ4i.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)",
        left: 0,
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""'
    }
});
var $9b42e07f73f19e96$var$selectedStyles = (0, $3dJ4i.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $6mgZr.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    ':visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    ':hover': {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $6mgZr.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    ':active': {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $6mgZr.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $9b42e07f73f19e96$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $9b42e07f73f19e96$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $ja6hR.propDeprecationWarning)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $1oC0p.useContext)((0, $8UYGb.SpacingContext));
    var selectionStyle = (0, $1oC0p.useContext)((0, $8UYGb.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $9b42e07f73f19e96$var$defaultRender;
    var UNSAFE_className = (0, $75Hol.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_externalClassName;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $3dJ4i.jsx)((0, $4tCgC.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $9b42e07f73f19e96$var$positionRelativeStyles,
                    $9b42e07f73f19e96$var$primitiveStyles,
                    $9b42e07f73f19e96$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $9b42e07f73f19e96$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $9b42e07f73f19e96$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $9b42e07f73f19e96$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $9b42e07f73f19e96$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $9b42e07f73f19e96$var$disabledStyles : $9b42e07f73f19e96$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $3dJ4i.jsx)((0, $j9pVa.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $9b42e07f73f19e96$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $3dJ4i.jsx)("span", {
                "data-item-elem-before": true,
                css: $9b42e07f73f19e96$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $3dJ4i.jsx)("span", {
                css: $9b42e07f73f19e96$var$contentStyles
            }, renderTitle('span', {
                children: title,
                className: cn(shouldTitleWrap ? $9b42e07f73f19e96$var$wordBreakStyles : $9b42e07f73f19e96$var$truncateStyles),
                'data-item-title': true
            }), description && (0, $3dJ4i.jsx)("span", {
                "data-item-description": true,
                css: [
                    $9b42e07f73f19e96$var$descriptionStyles,
                    isDisabled && $9b42e07f73f19e96$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $9b42e07f73f19e96$var$wordBreakStyles : $9b42e07f73f19e96$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $3dJ4i.jsx)("span", {
                "data-item-elem-after": true,
                css: $9b42e07f73f19e96$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $9b42e07f73f19e96$export$2e2bcd8739ae039 = $9b42e07f73f19e96$var$MenuItemPrimitive;

});
parcelRegister("4tCgC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $34278de88236f19c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $34278de88236f19c$var$BORDER_WIDTH = 2;
var $34278de88236f19c$var$baseFocusOutsideStyles = (0, $3dJ4i.css)({
    outline: "".concat($34278de88236f19c$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $34278de88236f19c$var$BORDER_WIDTH
});
var $34278de88236f19c$var$baseInsetStyles = (0, $3dJ4i.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    outlineOffset: -$34278de88236f19c$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $34278de88236f19c$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus-visible': $34278de88236f19c$var$baseFocusOutsideStyles,
    '@supports not selector(*:focus-visible)': {
        '&:focus': $34278de88236f19c$var$baseFocusOutsideStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $34278de88236f19c$var$insetFocusRingStyles = (0, $3dJ4i.css)({
    '&:focus-visible': $34278de88236f19c$var$baseInsetStyles,
    '@supports not selector(*:focus-visible)': {
        '&:focus': $34278de88236f19c$var$baseInsetStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $34278de88236f19c$var$FocusRing = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $34278de88236f19c$var$baseInsetStyles : $34278de88236f19c$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $34278de88236f19c$var$insetFocusRingStyles : $34278de88236f19c$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $1oC0p.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1oC0p.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$34278de88236f19c$var$FocusRing.displayName = 'FocusRing';
var $34278de88236f19c$export$2e2bcd8739ae039 = $34278de88236f19c$var$FocusRing;

});

parcelRegister("j9pVa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df12f6f61c2f8beb$export$2e2bcd8739ae039; });

var $cSc1s = parcelRequire("cSc1s");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $dZCXq = parcelRequire("dZCXq");

var $jgHg3 = parcelRequire("jgHg3");
var $df12f6f61c2f8beb$var$flexGrowMap = {
    hug: (0, $dZCXq.xcss)({
        flexGrow: 0
    }),
    fill: (0, $dZCXq.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $df12f6f61c2f8beb$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $df12f6f61c2f8beb$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $df12f6f61c2f8beb$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $df12f6f61c2f8beb$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($df12f6f61c2f8beb$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $df12f6f61c2f8beb$var$flexGrowMap[grow]
    ].concat((0, $cSc1s.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $jgHg3.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$df12f6f61c2f8beb$var$Inline.displayName = 'Inline';
var $df12f6f61c2f8beb$export$2e2bcd8739ae039 = $df12f6f61c2f8beb$var$Inline;

});
parcelRegister("cSc1s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $95f3da94742562a7$export$2e2bcd8739ae039; });

var $h7dCU = parcelRequire("h7dCU");

var $hpTZB = parcelRequire("hpTZB");

var $jIBIQ = parcelRequire("jIBIQ");

var $ggpcn = parcelRequire("ggpcn");
function $95f3da94742562a7$export$2e2bcd8739ae039(r) {
    return (0, $h7dCU.default)(r) || (0, $hpTZB.default)(r) || (0, $jIBIQ.default)(r) || (0, $ggpcn.default)();
}

});
parcelRegister("h7dCU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c75da9139920e48a$export$2e2bcd8739ae039; });

var $4eybp = parcelRequire("4eybp");
function $c75da9139920e48a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $4eybp.default)(r);
}

});
parcelRegister("4eybp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3152fc47fe40dadc$export$2e2bcd8739ae039; });
function $3152fc47fe40dadc$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("hpTZB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cae03468255b8674$export$2e2bcd8739ae039; });
function $cae03468255b8674$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("jIBIQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e5af6341a6b135fa$export$2e2bcd8739ae039; });

var $4eybp = parcelRequire("4eybp");
function $e5af6341a6b135fa$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $4eybp.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $4eybp.default)(r, a) : void 0;
    }
}

});

parcelRegister("ggpcn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bd71afe22a6019d7$export$2e2bcd8739ae039; });
function $bd71afe22a6019d7$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("dZCXq", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $a2ff31089816c14a$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $a2ff31089816c14a$export$f6c783d06584602c; });

var $cSc1s = parcelRequire("cSc1s");

var $6ya4i = parcelRequire("6ya4i");

var $1zxBZ = parcelRequire("1zxBZ");

var $k02U7 = parcelRequire("k02U7");

var $3dJ4i = parcelRequire("3dJ4i");

var $kx0XT = parcelRequire("kx0XT");

var $7t0tI = parcelRequire("7t0tI");
function $a2ff31089816c14a$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $a2ff31089816c14a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a2ff31089816c14a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a2ff31089816c14a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a2ff31089816c14a$var$_arrayLikeToArray(o, minLen);
}
function $a2ff31089816c14a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $a2ff31089816c14a$export$9a199fbafee0014e = {
    backgroundColor: (0, $kx0XT.backgroundColorMap),
    blockSize: (0, $kx0XT.dimensionMap),
    borderBlockColor: (0, $kx0XT.borderColorMap),
    borderBlockEndColor: (0, $kx0XT.borderColorMap),
    borderBlockEndWidth: (0, $kx0XT.borderWidthMap),
    borderBlockStartColor: (0, $kx0XT.borderColorMap),
    borderBlockStartWidth: (0, $kx0XT.borderWidthMap),
    borderBlockWidth: (0, $kx0XT.borderWidthMap),
    borderBottomColor: (0, $kx0XT.borderColorMap),
    borderBottomLeftRadius: (0, $kx0XT.borderRadiusMap),
    borderBottomRightRadius: (0, $kx0XT.borderRadiusMap),
    borderBottomWidth: (0, $kx0XT.borderWidthMap),
    borderColor: (0, $kx0XT.borderColorMap),
    borderEndEndRadius: (0, $kx0XT.borderRadiusMap),
    borderEndStartRadius: (0, $kx0XT.borderRadiusMap),
    borderInlineColor: (0, $kx0XT.borderColorMap),
    borderInlineEndColor: (0, $kx0XT.borderColorMap),
    borderInlineEndWidth: (0, $kx0XT.borderWidthMap),
    borderInlineStartColor: (0, $kx0XT.borderColorMap),
    borderInlineStartWidth: (0, $kx0XT.borderWidthMap),
    borderInlineWidth: (0, $kx0XT.borderWidthMap),
    borderLeftColor: (0, $kx0XT.borderColorMap),
    borderLeftWidth: (0, $kx0XT.borderWidthMap),
    borderRadius: (0, $kx0XT.borderRadiusMap),
    borderRightColor: (0, $kx0XT.borderColorMap),
    borderRightWidth: (0, $kx0XT.borderWidthMap),
    borderStartEndRadius: (0, $kx0XT.borderRadiusMap),
    borderStartStartRadius: (0, $kx0XT.borderRadiusMap),
    borderTopColor: (0, $kx0XT.borderColorMap),
    borderTopLeftRadius: (0, $kx0XT.borderRadiusMap),
    borderTopRightRadius: (0, $kx0XT.borderRadiusMap),
    borderTopWidth: (0, $kx0XT.borderWidthMap),
    borderWidth: (0, $kx0XT.borderWidthMap),
    bottom: (0, $kx0XT.allSpaceMap),
    boxShadow: (0, $kx0XT.shadowMap),
    color: (0, $kx0XT.textColorMap),
    columnGap: (0, $kx0XT.positiveSpaceMap),
    gap: (0, $kx0XT.positiveSpaceMap),
    height: (0, $kx0XT.dimensionMap),
    inlineSize: (0, $kx0XT.dimensionMap),
    inset: (0, $kx0XT.allSpaceMap),
    insetBlock: (0, $kx0XT.allSpaceMap),
    insetBlockEnd: (0, $kx0XT.allSpaceMap),
    insetBlockStart: (0, $kx0XT.allSpaceMap),
    insetInline: (0, $kx0XT.allSpaceMap),
    insetInlineEnd: (0, $kx0XT.allSpaceMap),
    insetInlineStart: (0, $kx0XT.allSpaceMap),
    left: (0, $kx0XT.allSpaceMap),
    margin: (0, $kx0XT.allSpaceMap),
    marginBlock: (0, $kx0XT.allSpaceMap),
    marginBlockEnd: (0, $kx0XT.allSpaceMap),
    marginBlockStart: (0, $kx0XT.allSpaceMap),
    marginBottom: (0, $kx0XT.allSpaceMap),
    marginInline: (0, $kx0XT.allSpaceMap),
    marginInlineEnd: (0, $kx0XT.allSpaceMap),
    marginInlineStart: (0, $kx0XT.allSpaceMap),
    marginLeft: (0, $kx0XT.allSpaceMap),
    marginRight: (0, $kx0XT.allSpaceMap),
    marginTop: (0, $kx0XT.allSpaceMap),
    maxBlockSize: (0, $kx0XT.dimensionMap),
    maxHeight: (0, $kx0XT.dimensionMap),
    maxInlineSize: (0, $kx0XT.dimensionMap),
    maxWidth: (0, $kx0XT.dimensionMap),
    minBlockSize: (0, $kx0XT.dimensionMap),
    minHeight: (0, $kx0XT.dimensionMap),
    minInlineSize: (0, $kx0XT.dimensionMap),
    minWidth: (0, $kx0XT.dimensionMap),
    opacity: (0, $kx0XT.opacityMap),
    outlineColor: (0, $kx0XT.borderColorMap),
    outlineOffset: (0, $kx0XT.positiveSpaceMap),
    outlineWidth: (0, $kx0XT.borderWidthMap),
    padding: (0, $kx0XT.positiveSpaceMap),
    paddingBlock: (0, $kx0XT.positiveSpaceMap),
    paddingBlockEnd: (0, $kx0XT.positiveSpaceMap),
    paddingBlockStart: (0, $kx0XT.positiveSpaceMap),
    paddingBottom: (0, $kx0XT.positiveSpaceMap),
    paddingInline: (0, $kx0XT.positiveSpaceMap),
    paddingInlineEnd: (0, $kx0XT.positiveSpaceMap),
    paddingInlineStart: (0, $kx0XT.positiveSpaceMap),
    paddingLeft: (0, $kx0XT.positiveSpaceMap),
    paddingRight: (0, $kx0XT.positiveSpaceMap),
    paddingTop: (0, $kx0XT.positiveSpaceMap),
    right: (0, $kx0XT.allSpaceMap),
    rowGap: (0, $kx0XT.positiveSpaceMap),
    top: (0, $kx0XT.allSpaceMap),
    width: (0, $kx0XT.dimensionMap),
    zIndex: (0, $kx0XT.layerMap)
};
var $a2ff31089816c14a$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $a2ff31089816c14a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $k02U7.default)($7t0tI)) === 'object' && (0, $k02U7.default)($7t0tI.env) === 'object' && false;
};
var $a2ff31089816c14a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $a2ff31089816c14a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $a2ff31089816c14a$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $k02U7.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $1zxBZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $k02U7.default)(value) === 'object' && $a2ff31089816c14a$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($a2ff31089816c14a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($a2ff31089816c14a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $a2ff31089816c14a$export$9a199fbafee0014e)) return;
        var tokenValue = $a2ff31089816c14a$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $a2ff31089816c14a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $a2ff31089816c14a$var$transformStyles(style);
    return (0, $6ya4i.default)({}, $a2ff31089816c14a$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
var $a2ff31089816c14a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $a2ff31089816c14a$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $cSc1s.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$a2ff31089816c14a$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $a2ff31089816c14a$export$f6c783d06584602c(style) {
    return $a2ff31089816c14a$var$baseXcss(style);
}

});
parcelRegister("6ya4i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c4dba6773246134$export$2e2bcd8739ae039; });

var $hec5t = parcelRequire("hec5t");
function $4c4dba6773246134$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $hec5t.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("hec5t", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8ad1ec30571b04a$export$2e2bcd8739ae039; });

var $k02U7 = parcelRequire("k02U7");

var $4TTR7 = parcelRequire("4TTR7");
function $c8ad1ec30571b04a$export$2e2bcd8739ae039(t) {
    var i = (0, $4TTR7.default)(t, "string");
    return "symbol" == (0, $k02U7.default)(i) ? i : i + "";
}

});
parcelRegister("k02U7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8f60f757608bb46$export$2e2bcd8739ae039; });
function $e8f60f757608bb46$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e8f60f757608bb46$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e8f60f757608bb46$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4TTR7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3917a04416f164da$export$2e2bcd8739ae039; });

var $k02U7 = parcelRequire("k02U7");
function $3917a04416f164da$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $k02U7.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $k02U7.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("1zxBZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $125321e669fd52d2$export$2e2bcd8739ae039; });

var $cJicF = parcelRequire("cJicF");

var $5urrK = parcelRequire("5urrK");

var $jIBIQ = parcelRequire("jIBIQ");

var $3SL8x = parcelRequire("3SL8x");
function $125321e669fd52d2$export$2e2bcd8739ae039(r, e) {
    return (0, $cJicF.default)(r) || (0, $5urrK.default)(r, e) || (0, $jIBIQ.default)(r, e) || (0, $3SL8x.default)();
}

});
parcelRegister("cJicF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9447ceccc5a80965$export$2e2bcd8739ae039; });
function $9447ceccc5a80965$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("5urrK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ff50b63934aff1e$export$2e2bcd8739ae039; });
function $3ff50b63934aff1e$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("3SL8x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2d3afa9a9761b6e9$export$2e2bcd8739ae039; });
function $2d3afa9a9761b6e9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kx0XT", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $ef27a35dce16848e$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $ef27a35dce16848e$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $ef27a35dce16848e$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $ef27a35dce16848e$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $ef27a35dce16848e$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $ef27a35dce16848e$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $ef27a35dce16848e$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $ef27a35dce16848e$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $ef27a35dce16848e$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $ef27a35dce16848e$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $ef27a35dce16848e$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $ef27a35dce16848e$export$bf46c3f9eeafc71f; });

var $6ya4i = parcelRequire("6ya4i");

var $3dJ4i = parcelRequire("3dJ4i");

var $9u5NS = parcelRequire("9u5NS");
function $ef27a35dce16848e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef27a35dce16848e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef27a35dce16848e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6ya4i.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef27a35dce16848e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef27a35dce16848e$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $ef27a35dce16848e$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $ef27a35dce16848e$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $ef27a35dce16848e$export$632685d741f3dbbf = $ef27a35dce16848e$var$_objectSpread($ef27a35dce16848e$var$_objectSpread({}, $ef27a35dce16848e$export$958d0ae7f2977ae4), $ef27a35dce16848e$export$d2dc61f58390201c);
var $ef27a35dce16848e$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $ef27a35dce16848e$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $ef27a35dce16848e$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ef27a35dce16848e$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $ef27a35dce16848e$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $ef27a35dce16848e$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ef27a35dce16848e$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $ef27a35dce16848e$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $ef27a35dce16848e$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ef27a35dce16848e$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $ef27a35dce16848e$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $ef27a35dce16848e$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $ef27a35dce16848e$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $ef27a35dce16848e$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $ef27a35dce16848e$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $ef27a35dce16848e$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $6ya4i.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ef27a35dce16848e$export$e615f061ca585a6c = $ef27a35dce16848e$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ef27a35dce16848e$var$getSerializedStylesMap(spacingProperty, $ef27a35dce16848e$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ef27a35dce16848e$export$bf46c3f9eeafc71f = $ef27a35dce16848e$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ef27a35dce16848e$var$getSerializedStylesMap(spacingProperty, $ef27a35dce16848e$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ef27a35dce16848e$export$e7af83bafe7f9e63 = $ef27a35dce16848e$var$getSerializedStylesMap('backgroundColor', $ef27a35dce16848e$export$d1d79bf68ac056bd);
var $ef27a35dce16848e$export$3a1bcba60b23d7f0 = $ef27a35dce16848e$var$getSerializedStylesMap('color', $ef27a35dce16848e$export$8473307aa00d6ea1);
var $ef27a35dce16848e$export$45f3f4fe16f9f7d5 = $ef27a35dce16848e$var$getSerializedStylesMap('fontWeight', $ef27a35dce16848e$export$303e322c6b1ed114);
var $ef27a35dce16848e$export$68cc305da27dbaa4 = $ef27a35dce16848e$var$getSerializedStylesMap('fontFamily', $ef27a35dce16848e$export$3c7e9587132614b4);
var $ef27a35dce16848e$export$128f10c238242f83 = $ef27a35dce16848e$var$getSerializedStylesMap('font', $ef27a35dce16848e$export$6cc560b4dedf3816);
var $ef27a35dce16848e$export$ff257d957d48c421 = $ef27a35dce16848e$var$getSerializedStylesMap((0, $9u5NS.CURRENT_SURFACE_CSS_VAR), $ef27a35dce16848e$export$41a358c9c2356760);
var $ef27a35dce16848e$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ef27a35dce16848e$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("9u5NS", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $6e7b6adeecc98453$export$9d7b58831ae93caa; });
var $6e7b6adeecc98453$export$4ef52930e33717cd = 'data-theme';
var $6e7b6adeecc98453$export$a00eac3f8684bcd0 = 'data-color-mode';
var $6e7b6adeecc98453$export$2112803007239c61 = 'data-contrast-mode';
var $6e7b6adeecc98453$export$352e418ed5b6193a = 'data-custom-theme';
var $6e7b6adeecc98453$export$2faeed762aac6741 = 'light';
var $6e7b6adeecc98453$export$6f0c6fb8c80fcc92 = 'ds';
var $6e7b6adeecc98453$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $6e7b6adeecc98453$export$dddac1532e822863 = "--".concat($6e7b6adeecc98453$export$6f0c6fb8c80fcc92, "-token-not-found");
var $6e7b6adeecc98453$export$9d7b58831ae93caa = "--".concat($6e7b6adeecc98453$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("jgHg3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e071111079858bc1$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $kx0XT = parcelRequire("kx0XT");

var $dZCXq = parcelRequire("dZCXq");
var $e071111079858bc1$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $e071111079858bc1$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $e071111079858bc1$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $e071111079858bc1$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $e071111079858bc1$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $e071111079858bc1$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $dZCXq.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $e071111079858bc1$var$baseStyles,
            gap && (0, $kx0XT.spaceStylesMap).gap[gap],
            columnGap && (0, $kx0XT.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $kx0XT.spaceStylesMap).rowGap[rowGap],
            alignItems && $e071111079858bc1$var$alignItemsMap[alignItems],
            direction && $e071111079858bc1$var$flexDirectionMap[direction],
            justifyContent && $e071111079858bc1$var$justifyContentMap[justifyContent],
            wrap && $e071111079858bc1$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$e071111079858bc1$var$Flex.displayName = 'Flex';
var $e071111079858bc1$export$2e2bcd8739ae039 = $e071111079858bc1$var$Flex;

});


parcelRegister("6mgZr", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $4a11fa08c62325f5$export$215b7063051591f1; });
$parcel$export(module.exports, "N20", function () { return $4a11fa08c62325f5$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $4a11fa08c62325f5$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N200", function () { return $4a11fa08c62325f5$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $4a11fa08c62325f5$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N30A", function () { return $4a11fa08c62325f5$export$920c0d5c49070351; });
$parcel$export(module.exports, "heading", function () { return $4a11fa08c62325f5$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $4a11fa08c62325f5$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "skeleton", function () { return $4a11fa08c62325f5$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $fd2ps = parcelRequire("fd2ps");
var $4a11fa08c62325f5$export$4b84fd0e2c617bd = '#FFEBE6';
var $4a11fa08c62325f5$export$b34b069eff244586 = '#FFBDAD';
var $4a11fa08c62325f5$export$be802dd0d8b57f35 = '#FF8F73';
var $4a11fa08c62325f5$export$60847d42f9da92a6 = '#FF7452';
var $4a11fa08c62325f5$export$4a7404f376229999 = '#FF5630';
var $4a11fa08c62325f5$export$2010d0fb4295b346 = '#DE350B';
var $4a11fa08c62325f5$export$2837b5a1a71d5c02 = '#BF2600';
var $4a11fa08c62325f5$export$8d9596b529bbb9cf = '#FFFAE6';
var $4a11fa08c62325f5$export$41060a744ab0b7ae = '#FFF0B3';
var $4a11fa08c62325f5$export$1cc05bbbf340e559 = '#FFE380';
var $4a11fa08c62325f5$export$5aae31392d72caaa = '#FFC400';
var $4a11fa08c62325f5$export$c6930421db9fa514 = '#FFAB00';
var $4a11fa08c62325f5$export$59619663aa6500fb = '#FF991F';
var $4a11fa08c62325f5$export$874739ea9e379ab6 = '#FF8B00';
var $4a11fa08c62325f5$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $4a11fa08c62325f5$export$69a3bf21b9686c2b = '#ABF5D1';
var $4a11fa08c62325f5$export$afbce1382ec95f73 = '#79F2C0';
var $4a11fa08c62325f5$export$747d86715d4175de = '#57D9A3';
var $4a11fa08c62325f5$export$940e1f69e873f202 = '#36B37E';
var $4a11fa08c62325f5$export$a49394138f7b8e85 = '#00875A';
var $4a11fa08c62325f5$export$6fa04827ac68a4fb = '#006644';
var $4a11fa08c62325f5$export$226de0355ed012f8 = '#DEEBFF';
var $4a11fa08c62325f5$export$8c13c2ee36917869 = '#B3D4FF';
var $4a11fa08c62325f5$export$ecfc1dff386a3e7a = '#4C9AFF';
var $4a11fa08c62325f5$export$215b7063051591f1 = '#2684FF';
var $4a11fa08c62325f5$export$e62e8919cca44969 = '#0065FF';
var $4a11fa08c62325f5$export$b3de0ae08da2ce64 = '#0052CC';
var $4a11fa08c62325f5$export$a6ee3d71bc067634 = '#0747A6';
var $4a11fa08c62325f5$export$363e4475840015bb = '#EAE6FF';
var $4a11fa08c62325f5$export$4b0a4417ed59760f = '#C0B6F2';
var $4a11fa08c62325f5$export$6011520a64d9a187 = '#998DD9';
var $4a11fa08c62325f5$export$a7175d4e9206bc80 = '#8777D9';
var $4a11fa08c62325f5$export$b48405b95304b5a1 = '#6554C0';
var $4a11fa08c62325f5$export$c71e4279dd54a18d = '#5243AA';
var $4a11fa08c62325f5$export$147899de772240ec = '#403294';
var $4a11fa08c62325f5$export$2cf711fe14c66f06 = '#E6FCFF';
var $4a11fa08c62325f5$export$7a8f4d33f6f9772c = '#B3F5FF';
var $4a11fa08c62325f5$export$776c9c497ef08533 = '#79E2F2';
var $4a11fa08c62325f5$export$69cb3ca10c1e330e = '#00C7E6';
var $4a11fa08c62325f5$export$9dc1ef0f3f48059b = '#00B8D9';
var $4a11fa08c62325f5$export$7c835c78b6fcdef8 = '#00A3BF';
var $4a11fa08c62325f5$export$6036577f95c3877e = '#008DA6';
var $4a11fa08c62325f5$export$29a4f05edc054374 = '#FFFFFF';
var $4a11fa08c62325f5$export$e655ef011c4aa1a2 = '#FAFBFC';
var $4a11fa08c62325f5$export$9fdfb749e33cdf97 = '#F4F5F7';
var $4a11fa08c62325f5$export$3e51e8f1440314ba = '#EBECF0';
var $4a11fa08c62325f5$export$1ce2d1575d444ceb = '#DFE1E6';
var $4a11fa08c62325f5$export$8754fc7e6d8b3000 = '#C1C7D0';
var $4a11fa08c62325f5$export$c2e91cbeada39b8b = '#B3BAC5';
var $4a11fa08c62325f5$export$5f71e19f3a7ad9de = '#A5ADBA';
var $4a11fa08c62325f5$export$eaa8c8a70ac22806 = '#97A0AF';
var $4a11fa08c62325f5$export$7c87d337fb91a97d = '#8993A4';
var $4a11fa08c62325f5$export$d6447c357493214f = '#7A869A';
var $4a11fa08c62325f5$export$f563ee71e9ee74cd = '#6B778C';
var $4a11fa08c62325f5$export$e2ef2124cf4024b1 = '#5E6C84';
var $4a11fa08c62325f5$export$eece5f492e429f08 = '#505F79';
var $4a11fa08c62325f5$export$c39c0fe0f26207ae = '#42526E';
var $4a11fa08c62325f5$export$7090862dc3038a9f = '#344563';
var $4a11fa08c62325f5$export$ad0bacf983b7ddaa = '#253858';
var $4a11fa08c62325f5$export$7d61b15e0da132af = '#172B4D';
var $4a11fa08c62325f5$export$fbda843f0a27fe96 = '#091E42';
var $4a11fa08c62325f5$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $4a11fa08c62325f5$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $4a11fa08c62325f5$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $4a11fa08c62325f5$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $4a11fa08c62325f5$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $4a11fa08c62325f5$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $4a11fa08c62325f5$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $4a11fa08c62325f5$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $4a11fa08c62325f5$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $4a11fa08c62325f5$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $4a11fa08c62325f5$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $4a11fa08c62325f5$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $4a11fa08c62325f5$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $4a11fa08c62325f5$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $4a11fa08c62325f5$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $4a11fa08c62325f5$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $4a11fa08c62325f5$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $4a11fa08c62325f5$export$2f6319cf7d736c2a = '#E6EDFA';
var $4a11fa08c62325f5$export$95126bc8884d6634 = '#DCE5F5';
var $4a11fa08c62325f5$export$8338d8c35d44ff1 = '#CED9EB';
var $4a11fa08c62325f5$export$5368d76ae4fbbda7 = '#B8C7E0';
var $4a11fa08c62325f5$export$9f0a771d16ec8d36 = '#ABBBD6';
var $4a11fa08c62325f5$export$abcf8c38338b4aa5 = '#9FB0CC';
var $4a11fa08c62325f5$export$97e81faa16a182c7 = '#8C9CB8';
var $4a11fa08c62325f5$export$bfe21c59123ecf33 = '#7988A3';
var $4a11fa08c62325f5$export$ee82aa2ea6a1558 = '#67758F';
var $4a11fa08c62325f5$export$682927c6ed76be02 = '#56637A';
var $4a11fa08c62325f5$export$91fd9994c5be9757 = '#455166';
var $4a11fa08c62325f5$export$d281fbfe3cff2df6 = '#3B475C';
var $4a11fa08c62325f5$export$3902c91d8b98a753 = '#313D52';
var $4a11fa08c62325f5$export$8e8133c1ba5845b5 = '#283447';
var $4a11fa08c62325f5$export$33ff357f6620b39 = '#202B3D';
var $4a11fa08c62325f5$export$633847cf062b69e0 = '#1B2638';
var $4a11fa08c62325f5$export$9776a6e503bdbf76 = '#121A29';
var $4a11fa08c62325f5$export$6c813d5160dff5db = '#0E1624';
var $4a11fa08c62325f5$export$3d4f271a500072a = '#0D1424';
var $4a11fa08c62325f5$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $4a11fa08c62325f5$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $4a11fa08c62325f5$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $4a11fa08c62325f5$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $4a11fa08c62325f5$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $4a11fa08c62325f5$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $4a11fa08c62325f5$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $4a11fa08c62325f5$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $4a11fa08c62325f5$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $4a11fa08c62325f5$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $4a11fa08c62325f5$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $4a11fa08c62325f5$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $4a11fa08c62325f5$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $4a11fa08c62325f5$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $4a11fa08c62325f5$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $4a11fa08c62325f5$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $4a11fa08c62325f5$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $4a11fa08c62325f5$export$8ce1fd94bee2f412 = (0, $fd2ps.default)({
    light: "var(--ds-surface, ".concat($4a11fa08c62325f5$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($4a11fa08c62325f5$export$633847cf062b69e0, ")")
});
var $4a11fa08c62325f5$export$b861914ea877b580 = (0, $fd2ps.default)({
    light: "var(--ds-background-selected, ".concat($4a11fa08c62325f5$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($4a11fa08c62325f5$export$8c13c2ee36917869, ")")
});
var $4a11fa08c62325f5$export$3f1b020df94387af = (0, $fd2ps.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($4a11fa08c62325f5$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($4a11fa08c62325f5$export$d281fbfe3cff2df6, ")")
});
var $4a11fa08c62325f5$export$c0183dbab98ca63e = (0, $fd2ps.default)({
    light: "var(--ds-surface-overlay, ".concat($4a11fa08c62325f5$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($4a11fa08c62325f5$export$8e8133c1ba5845b5, ")")
});
var $4a11fa08c62325f5$export$6f093cfa640b7166 = (0, $fd2ps.default)({
    light: "var(--ds-text, ".concat($4a11fa08c62325f5$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($4a11fa08c62325f5$export$5368d76ae4fbbda7, ")")
});
var $4a11fa08c62325f5$export$42f8e9c698766e7a = (0, $fd2ps.default)({
    light: "var(--ds-text, ".concat($4a11fa08c62325f5$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($4a11fa08c62325f5$export$5368d76ae4fbbda7, ")")
});
var $4a11fa08c62325f5$export$c2d157ca1c34b6e3 = (0, $fd2ps.default)({
    light: "var(--ds-text-selected, ".concat($4a11fa08c62325f5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($4a11fa08c62325f5$export$b3de0ae08da2ce64, ")")
});
var $4a11fa08c62325f5$export$1905ba28d7cf066f = (0, $fd2ps.default)({
    light: "var(--ds-text-subtlest, ".concat($4a11fa08c62325f5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($4a11fa08c62325f5$export$97e81faa16a182c7, ")")
});
var $4a11fa08c62325f5$export$bd9002130d306d39 = (0, $fd2ps.default)({
    light: "var(--ds-text-subtlest, ".concat($4a11fa08c62325f5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($4a11fa08c62325f5$export$bfe21c59123ecf33, ")")
});
var $4a11fa08c62325f5$export$46e4a324ac90507f = (0, $fd2ps.default)({
    light: "var(--ds-text, ".concat($4a11fa08c62325f5$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($4a11fa08c62325f5$export$5368d76ae4fbbda7, ")")
});
var $4a11fa08c62325f5$export$79f3f2b82beb0d36 = (0, $fd2ps.default)({
    light: "var(--ds-text-subtlest, ".concat($4a11fa08c62325f5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($4a11fa08c62325f5$export$97e81faa16a182c7, ")")
});
var $4a11fa08c62325f5$export$7bb0d5c671655cc4 = (0, $fd2ps.default)({
    light: $4a11fa08c62325f5$export$9fdfb749e33cdf97,
    dark: $4a11fa08c62325f5$export$8e8133c1ba5845b5
});
var $4a11fa08c62325f5$export$9c30223ca0a664fb = (0, $fd2ps.default)({
    light: "var(--ds-link, ".concat($4a11fa08c62325f5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($4a11fa08c62325f5$export$ecfc1dff386a3e7a, ")")
});
var $4a11fa08c62325f5$export$7ed258b0728b004b = (0, $fd2ps.default)({
    light: "var(--ds-link-pressed, ".concat($4a11fa08c62325f5$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($4a11fa08c62325f5$export$215b7063051591f1, ")")
});
var $4a11fa08c62325f5$export$dfa920d8decc8a59 = (0, $fd2ps.default)({
    light: "var(--ds-link-pressed, ".concat($4a11fa08c62325f5$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($4a11fa08c62325f5$export$ecfc1dff386a3e7a, ")")
});
var $4a11fa08c62325f5$export$6069e6ad5c78f632 = (0, $fd2ps.default)({
    light: "var(--ds-border-focused, ".concat($4a11fa08c62325f5$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($4a11fa08c62325f5$export$215b7063051591f1, ")")
});
var $4a11fa08c62325f5$export$9ad721cf3b3debe0 = (0, $fd2ps.default)({
    light: "var(--ds-background-brand-bold, ".concat($4a11fa08c62325f5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($4a11fa08c62325f5$export$ecfc1dff386a3e7a, ")")
});
var $4a11fa08c62325f5$export$2aa0182783e7e9de = (0, $fd2ps.default)({
    light: $4a11fa08c62325f5$export$b3de0ae08da2ce64,
    dark: $4a11fa08c62325f5$export$ecfc1dff386a3e7a
});
var $4a11fa08c62325f5$export$8bf7dff220b82b4a = (0, $fd2ps.default)({
    light: $4a11fa08c62325f5$export$9dc1ef0f3f48059b,
    dark: $4a11fa08c62325f5$export$69cb3ca10c1e330e
});
var $4a11fa08c62325f5$export$e13cce2a2d16a9d4 = (0, $fd2ps.default)({
    light: $4a11fa08c62325f5$export$b48405b95304b5a1,
    dark: $4a11fa08c62325f5$export$6011520a64d9a187
});
var $4a11fa08c62325f5$export$a90204d1394caf30 = (0, $fd2ps.default)({
    light: $4a11fa08c62325f5$export$4a7404f376229999,
    dark: $4a11fa08c62325f5$export$4a7404f376229999
});
var $4a11fa08c62325f5$export$594c5a8758200c32 = (0, $fd2ps.default)({
    light: $4a11fa08c62325f5$export$c6930421db9fa514,
    dark: $4a11fa08c62325f5$export$c6930421db9fa514
});
var $4a11fa08c62325f5$export$955a2ebd2fb142ae = (0, $fd2ps.default)({
    light: $4a11fa08c62325f5$export$940e1f69e873f202,
    dark: $4a11fa08c62325f5$export$940e1f69e873f202
});
var $4a11fa08c62325f5$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($4a11fa08c62325f5$export$8d43898f60b96a82, ")");
};

});
parcelRegister("fd2ps", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b129f0630b7a7970$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $iYQHd = parcelRequire("iYQHd");
// Unpack custom variants, and get correct value for the current theme
function $b129f0630b7a7970$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $iYQHd.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $b129f0630b7a7970$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $b129f0630b7a7970$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $iYQHd.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("iYQHd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dd16b4f0de5f1eaa$export$2e2bcd8739ae039; });

var $hZR5o = parcelRequire("hZR5o");
function $dd16b4f0de5f1eaa$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $hZR5o.CHANNEL) in props.theme) return props.theme[0, $hZR5o.CHANNEL];
        else if ('mode' in props.theme && (0, $hZR5o.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $hZR5o.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("hZR5o", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $d1a14ff3907292e0$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $d1a14ff3907292e0$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $d1a14ff3907292e0$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $d1a14ff3907292e0$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $d1a14ff3907292e0$export$85e3c3ca0c6fb93; });

var $lmhXW = parcelRequire("lmhXW");

var $6mgZr = parcelRequire("6mgZr");
var $d1a14ff3907292e0$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $d1a14ff3907292e0$export$c93026a968943f95 = 'light';
var $d1a14ff3907292e0$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $d1a14ff3907292e0$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $d1a14ff3907292e0$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $d1a14ff3907292e0$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $d1a14ff3907292e0$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $d1a14ff3907292e0$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $d1a14ff3907292e0$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $d1a14ff3907292e0$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $6mgZr.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d1a14ff3907292e0$export$6d8204c2cb2e06b8() / 4;
    (0, $lmhXW.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $d1a14ff3907292e0$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $d1a14ff3907292e0$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $d1a14ff3907292e0$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $lmhXW.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $d1a14ff3907292e0$export$ba1d834b86d72a09 = $d1a14ff3907292e0$export$a1b3edb637fb4f35;
var $d1a14ff3907292e0$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $6mgZr.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $6mgZr.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $6mgZr.N30A), ")")
            }
        }
    };
};

});
parcelRegister("lmhXW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f8c996b1ec791b9b$export$2e2bcd8739ae039; });

var $9qVWT = parcelRequire("9qVWT");

var $7t0tI = parcelRequire("7t0tI");
function $f8c996b1ec791b9b$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $9qVWT.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $f8c996b1ec791b9b$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("9qVWT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6de37e31abbfc099$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $6de37e31abbfc099$var$printed = {};
function $6de37e31abbfc099$export$2e2bcd8739ae039(message) {
    if ($6de37e31abbfc099$var$printed[message]) return;
    $6de37e31abbfc099$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("8UYGb", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", function () { return $67e29f5979c67d36$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $67e29f5979c67d36$export$9ca534b70725964d; });

var $1oC0p = parcelRequire("1oC0p");
var $67e29f5979c67d36$export$443076ec7ebce042 = /*#__PURE__*/ (0, $1oC0p.createContext)('cozy');
var $67e29f5979c67d36$export$9ca534b70725964d = /*#__PURE__*/ (0, $1oC0p.createContext)('border');

});



parcelRegister("3EeSh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2a80a54feced396b$export$2e2bcd8739ae039; });

var $6Mntg = parcelRequire("6Mntg");

var $8s4f2 = parcelRequire("8s4f2");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $ja6hR = parcelRequire("ja6hR");

var $gfKh0 = parcelRequire("gfKh0");

var $75Hol = parcelRequire("75Hol");

var $dks1c = parcelRequire("dks1c");
var $2a80a54feced396b$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
var $2a80a54feced396b$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2a80a54feced396b$var$CustomItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $gfKh0.default) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, rest = (0, $8s4f2.default)(_ref, $2a80a54feced396b$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!Component) return null;
    (0, $ja6hR.propDeprecationWarning)("@atlaskit/menu", 'cssFn', cssFn !== (0, $gfKh0.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $3dJ4i.jsx)((0, $dks1c.default), (0, $6Mntg.default)({
        className: (0, $75Hol.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $3dJ4i.css)(cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $3dJ4i.jsx)(Component, (0, $6Mntg.default)({
            "data-testid": testId
        }, rest, {
            className: className,
            ref: ref,
            draggable: false,
            onDragStart: $2a80a54feced396b$var$preventEvent,
            onMouseDown: isDisabled ? $2a80a54feced396b$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $2a80a54feced396b$var$preventEvent : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $2a80a54feced396b$export$2e2bcd8739ae039 = $2a80a54feced396b$var$CustomItem;

});

parcelRegister("apvjf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7944869bb7103549$export$2e2bcd8739ae039; });

var $6Mntg = parcelRequire("6Mntg");

var $8s4f2 = parcelRequire("8s4f2");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $ja6hR = parcelRequire("ja6hR");

var $gfKh0 = parcelRequire("gfKh0");

var $75Hol = parcelRequire("75Hol");

var $dks1c = parcelRequire("dks1c");
var $7944869bb7103549$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
var $7944869bb7103549$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $7944869bb7103549$var$LinkItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $gfKh0.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, rest = (0, $8s4f2.default)(props, $7944869bb7103549$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $ja6hR.propDeprecationWarning)("@atlaskit/menu", 'cssFn', cssFn !== (0, $gfKh0.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $3dJ4i.jsx)((0, $dks1c.default), (0, $6Mntg.default)({}, rest, {
        className: (0, $75Hol.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $3dJ4i.jsx)("a", (0, $6Mntg.default)({
            "data-testid": testId
        }, rest, {
            className: className,
            href: isDisabled ? undefined : href,
            draggable: false,
            onDragStart: $7944869bb7103549$var$preventEvent,
            onMouseDown: isDisabled ? $7944869bb7103549$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $7944869bb7103549$var$preventEvent : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $7944869bb7103549$export$2e2bcd8739ae039 = $7944869bb7103549$var$LinkItem;

});

parcelRegister("9go2L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $01bd8d749334c744$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $aS3sB = parcelRequire("aS3sB");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $01bd8d749334c744$var$useRegisterItemWithFocusManager() {
    var _useContext = (0, $1oC0p.useContext)((0, $aS3sB.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $01bd8d749334c744$export$2e2bcd8739ae039 = $01bd8d749334c744$var$useRegisterItemWithFocusManager;

});
parcelRegister("aS3sB", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", function () { return $7ea1a1b27ee1c00f$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $7ea1a1b27ee1c00f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $gfKh0 = parcelRequire("gfKh0");

var $bJyuB = parcelRequire("bJyuB");

var $2klc9 = parcelRequire("2klc9");
var $7ea1a1b27ee1c00f$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    menuItemRefs: [],
    registerRef: (0, $gfKh0.default)
});
/**
 * Focus manager logic.
 */ var $7ea1a1b27ee1c00f$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $1oC0p.useRef)([]);
    var registerRef = (0, $1oC0p.useCallback)(function(ref) {
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    var _UNSAFE_useLayering = (0, $bJyuB.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bind)(window, {
            type: 'keydown',
            listener: (0, $2klc9.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($7ea1a1b27ee1c00f$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $7ea1a1b27ee1c00f$export$2e2bcd8739ae039 = $7ea1a1b27ee1c00f$var$FocusManager;

});
parcelRegister("bJyuB", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $88aea72b6b5b1f5c$export$cec37b93989366d4; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $1Vqjf = parcelRequire("1Vqjf");
var $88aea72b6b5b1f5c$var$ESCAPE = 'Escape';
function $88aea72b6b5b1f5c$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var _UNSAFE_useLayering = $88aea72b6b5b1f5c$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $88aea72b6b5b1f5c$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $88aea72b6b5b1f5c$export$cec37b93989366d4() {
    var currentLevel = (0, $1oC0p.useContext)((0, $1Vqjf.LevelContext));
    var _useContext = (0, $1oC0p.useContext)((0, $1Vqjf.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});
parcelRegister("1Vqjf", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $166f85d38af91086$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $166f85d38af91086$export$48b383b280e20440; });
$parcel$export(module.exports, "UNSAFE_LAYERING", function () { return $166f85d38af91086$export$a183686c3f6f4ea8; });

var $1oC0p = parcelRequire("1oC0p");

var $gfKh0 = parcelRequire("gfKh0");
var $166f85d38af91086$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $166f85d38af91086$export$48b383b280e20440 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $gfKh0.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $166f85d38af91086$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $1oC0p.useContext)($166f85d38af91086$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $1oC0p.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($166f85d38af91086$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $166f85d38af91086$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $1oC0p.useRef)(0);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($166f85d38af91086$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $166f85d38af91086$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $1oC0p.useContext)($166f85d38af91086$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($166f85d38af91086$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($166f85d38af91086$var$LayeringProvider, null, content);
};

});


parcelRegister("2klc9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1b1de3e7f974b973$export$2e2bcd8739ae039; });

var $6ya4i = parcelRequire("6ya4i");

var $4G4vL = parcelRequire("4G4vL");
var $1b1de3e7f974b973$var$_actionMap;
var $1b1de3e7f974b973$var$actionMap = ($1b1de3e7f974b973$var$_actionMap = {}, (0, $6ya4i.default)($1b1de3e7f974b973$var$_actionMap, (0, $4G4vL.KEY_DOWN), 'next'), (0, $6ya4i.default)($1b1de3e7f974b973$var$_actionMap, (0, $4G4vL.KEY_UP), 'prev'), (0, $6ya4i.default)($1b1de3e7f974b973$var$_actionMap, (0, $4G4vL.KEY_HOME), 'first'), (0, $6ya4i.default)($1b1de3e7f974b973$var$_actionMap, (0, $4G4vL.KEY_END), 'last'), $1b1de3e7f974b973$var$_actionMap);
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $1b1de3e7f974b973$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $1b1de3e7f974b973$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $1b1de3e7f974b973$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var currentFocusedIdx = refs.findIndex(function(el) {
            var _document$activeEleme;
            return (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el);
        });
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $4G4vL.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $1b1de3e7f974b973$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    var _nextFocusableElement = $1b1de3e7f974b973$var$getNextFocusableElement(refs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $1b1de3e7f974b973$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $1b1de3e7f974b973$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $1b1de3e7f974b973$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $1b1de3e7f974b973$var$getNextFocusableElement(refs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $1b1de3e7f974b973$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("4G4vL", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", function () { return $367e9585d2617817$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $367e9585d2617817$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $367e9585d2617817$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $367e9585d2617817$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $367e9585d2617817$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $367e9585d2617817$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $367e9585d2617817$export$e51a3576c045c8d5; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $367e9585d2617817$export$390330c10ff2b9a1 = 'ArrowUp';
var $367e9585d2617817$export$a80636c6f41931fe = 'ArrowDown';
var $367e9585d2617817$export$4af703091671bc = 'Home';
var $367e9585d2617817$export$e2bc30913faa5db7 = 'End';
var $367e9585d2617817$export$10f6869ed0a7d75b = 'Tab';
var $367e9585d2617817$export$8152f929a25a0ff4 = 'Enter';
var $367e9585d2617817$export$e51a3576c045c8d5 = 'Space';
var $367e9585d2617817$export$2bb790b9008907b4 = 'Escape';

});





parcelRegister("aKsx2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7d3455142758c91c$export$2e2bcd8739ae039; });
/**
 * __Section__
 *
 * A dropdown item group includes all the actions or items in a dropdown menu.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-group/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-group/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-group/usage)
 */ 
var $fDjAX = parcelRequire("fDjAX");
var $7d3455142758c91c$export$2e2bcd8739ae039 = (0, $fDjAX.default);

});
parcelRegister("fDjAX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b619b2b8dae7edbf$export$2e2bcd8739ae039; });

var $6Mntg = parcelRequire("6Mntg");

var $8s4f2 = parcelRequire("8s4f2");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $ja6hR = parcelRequire("ja6hR");

var $75Hol = parcelRequire("75Hol");

var $6mgZr = parcelRequire("6mgZr");

var $hZR5o = parcelRequire("hZR5o");

var $lBGZN = parcelRequire("lBGZN");

var $f1Td0 = parcelRequire("f1Td0");
var $b619b2b8dae7edbf$var$_excluded = [
    "children",
    "overrides",
    "title",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $b619b2b8dae7edbf$var$gridSize = (0, $hZR5o.gridSize)();
var $b619b2b8dae7edbf$var$itemHeadingTopMargin = $b619b2b8dae7edbf$var$gridSize * 2.5;
var $b619b2b8dae7edbf$var$itemHeadingBottomMargin = $b619b2b8dae7edbf$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $b619b2b8dae7edbf$var$itemHeadingContentHeight = (0, $lBGZN.headingSizes).h100.lineHeight;
var $b619b2b8dae7edbf$var$skeletonHeadingHeight = $b619b2b8dae7edbf$var$gridSize;
var $b619b2b8dae7edbf$var$skeletonHeadingMarginOffset = 3;
var $b619b2b8dae7edbf$var$skeletonHeadingTopMargin = $b619b2b8dae7edbf$var$itemHeadingTopMargin + ($b619b2b8dae7edbf$var$itemHeadingContentHeight - $b619b2b8dae7edbf$var$skeletonHeadingHeight) - $b619b2b8dae7edbf$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $b619b2b8dae7edbf$var$skeletonHeadingBottomMargin = $b619b2b8dae7edbf$var$itemHeadingBottomMargin + $b619b2b8dae7edbf$var$skeletonHeadingMarginOffset;
var $b619b2b8dae7edbf$var$sectionPaddingTopBottom = $b619b2b8dae7edbf$var$gridSize * 0.75;
var $b619b2b8dae7edbf$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
var $b619b2b8dae7edbf$var$sectionStyles = (0, $3dJ4i.css)({
    '&::before, &::after': {
        display: 'block',
        height: $b619b2b8dae7edbf$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& [data-ds--menu--heading-item]': {
        marginBlockEnd: $b619b2b8dae7edbf$var$itemHeadingBottomMargin,
        marginBlockStart: $b619b2b8dae7edbf$var$itemHeadingTopMargin,
        '&:first-of-type': {
            marginBlockStart: $b619b2b8dae7edbf$var$itemHeadingTopMargin - $b619b2b8dae7edbf$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& [data-ds--menu--skeleton-heading-item]': {
        marginBlockEnd: $b619b2b8dae7edbf$var$skeletonHeadingBottomMargin,
        marginBlockStart: $b619b2b8dae7edbf$var$skeletonHeadingTopMargin,
        '&:first-of-type': {
            marginBlockStart: $b619b2b8dae7edbf$var$skeletonHeadingTopMargin - $b619b2b8dae7edbf$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $b619b2b8dae7edbf$var$scrollableStyles = (0, $3dJ4i.css)({
    flexShrink: 1,
    overflow: 'auto'
});
var $b619b2b8dae7edbf$var$unscrollableStyles = (0, $3dJ4i.css)({
    flexShrink: 0
});
var $b619b2b8dae7edbf$var$thickSeparatorStyles = (0, $3dJ4i.css)({
    borderBlockStart: "2px solid var(".concat($b619b2b8dae7edbf$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $6mgZr.N30A), ")"), ")")
});
var $b619b2b8dae7edbf$var$thinSeparatorStyles = (0, $3dJ4i.css)({
    borderBlockStart: "1px solid var(".concat($b619b2b8dae7edbf$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $6mgZr.N30A), ")"), ")")
});
var $b619b2b8dae7edbf$var$noSeparatorStyles = (0, $3dJ4i.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $b619b2b8dae7edbf$var$Section = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, $8s4f2.default)(_ref, $b619b2b8dae7edbf$var$_excluded);
    (0, $ja6hR.propDeprecationWarning)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = (0, $75Hol.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $3dJ4i.jsx)("ul", {
        style: {
            margin: 0,
            padding: 0
        }
    }, (0, $1oC0p.Children).map((0, $1oC0p.Children).toArray(children), function(child, index) {
        return (0, $3dJ4i.jsx)("li", {
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, (0, $3dJ4i.jsx)((0, $f1Td0.default), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, content);
    return (0, $3dJ4i.jsx)("div", (0, $6Mntg.default)({}, rest, {
        className: (0, $75Hol.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className,
        id: id,
        css: [
            $b619b2b8dae7edbf$var$sectionStyles,
            isScrollable ? $b619b2b8dae7edbf$var$scrollableStyles : $b619b2b8dae7edbf$var$unscrollableStyles,
            hasSeparator ? (0, $75Hol.getBooleanFF)('platform.design-system-team.section-1px-seperator-borders') ? $b619b2b8dae7edbf$var$thinSeparatorStyles : $b619b2b8dae7edbf$var$thickSeparatorStyles : $b619b2b8dae7edbf$var$noSeparatorStyles
        ],
        "aria-label": title,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $b619b2b8dae7edbf$export$2e2bcd8739ae039 = $b619b2b8dae7edbf$var$Section;

});
parcelRegister("lBGZN", function(module, exports) {
$parcel$export(module.exports, "headingSizes", function () { return $fbae67ba8f830568$export$bc02e067df412c3b; });

var $6ya4i = parcelRequire("6ya4i");

var $6mgZr = parcelRequire("6mgZr");

var $hZR5o = parcelRequire("hZR5o");
function $fbae67ba8f830568$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fbae67ba8f830568$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fbae67ba8f830568$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6ya4i.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fbae67ba8f830568$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fbae67ba8f830568$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $fbae67ba8f830568$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / (0, $hZR5o.fontSize)(), "em"),
        fontStyle: 'inherit',
        lineHeight: lineHeight / size
    };
};
var $fbae67ba8f830568$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $fbae67ba8f830568$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h900.size, $fbae67ba8f830568$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $6mgZr.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 6.5, "px")
    });
};
var $fbae67ba8f830568$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h800.size, $fbae67ba8f830568$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $6mgZr.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 5, "px")
    });
};
var $fbae67ba8f830568$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h700.size, $fbae67ba8f830568$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $6mgZr.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 5, "px")
    });
};
var $fbae67ba8f830568$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h600.size, $fbae67ba8f830568$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $6mgZr.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 3.5, "px")
    });
};
var $fbae67ba8f830568$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h500.size, $fbae67ba8f830568$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $6mgZr.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 3, "px")
    });
};
var $fbae67ba8f830568$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h400.size, $fbae67ba8f830568$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $6mgZr.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 2, "px")
    });
};
var $fbae67ba8f830568$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h300.size, $fbae67ba8f830568$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $6mgZr.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 2.5, "px"),
        textTransform: 'uppercase'
    });
};
var $fbae67ba8f830568$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h200.size, $fbae67ba8f830568$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $6mgZr.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 2, "px")
    });
};
var $fbae67ba8f830568$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $fbae67ba8f830568$var$_objectSpread($fbae67ba8f830568$var$_objectSpread({}, $fbae67ba8f830568$var$baseHeading($fbae67ba8f830568$export$bc02e067df412c3b.h100.size, $fbae67ba8f830568$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $6mgZr.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $hZR5o.gridSize)() * 2, "px")
    });
};

});

parcelRegister("f1Td0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af11c64cd59fb2b5$export$2e2bcd8739ae039; });

var $6Mntg = parcelRequire("6Mntg");

var $8s4f2 = parcelRequire("8s4f2");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $ja6hR = parcelRequire("ja6hR");

var $gfKh0 = parcelRequire("gfKh0");

var $75Hol = parcelRequire("75Hol");

var $6mgZr = parcelRequire("6mgZr");

var $lBGZN = parcelRequire("lBGZN");
var $af11c64cd59fb2b5$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $af11c64cd59fb2b5$var$itemHeadingContentHeight = (0, $lBGZN.headingSizes).h100.lineHeight;
var $af11c64cd59fb2b5$var$itemHeadingFontSize = (0, $lBGZN.headingSizes).h100.size;
var $af11c64cd59fb2b5$var$headingStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, ".concat((0, $6mgZr.N300), ")"),
    fontSize: $af11c64cd59fb2b5$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    lineHeight: $af11c64cd59fb2b5$var$itemHeadingContentHeight / $af11c64cd59fb2b5$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $af11c64cd59fb2b5$var$HeadingItem = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $gfKh0.default) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, $8s4f2.default)(_ref, $af11c64cd59fb2b5$var$_excluded);
    (0, $ja6hR.propDeprecationWarning)("@atlaskit/menu", 'cssFn', cssFn !== (0, $gfKh0.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_overrides = (0, $75Hol.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : (0, $3dJ4i.css)(cssFn(undefined));
    return (0, $3dJ4i.jsx)("div", (0, $6Mntg.default)({
        css: [
            $af11c64cd59fb2b5$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $75Hol.getBooleanFF)('platform.design-system-team.unsafe-overrides-killswitch_c8j9m') ? undefined : UNSAFE_className
    }, rest), children);
});
var $af11c64cd59fb2b5$export$2e2bcd8739ae039 = $af11c64cd59fb2b5$var$HeadingItem;

});




parcelRegister("ibZL7", function(module, exports) {
$parcel$export(module.exports, "MobileNavTop", function () { return $4a329fce10f17c32$export$c2b4db2d88a6ed62; });
/* mobile-nav-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $7IesZ = parcelRequire("7IesZ");

var $zADBD = parcelRequire("zADBD");

var $hZE0S = parcelRequire("hZE0S");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $7XaVV = parcelRequire("7XaVV");

var $96jet = parcelRequire("96jet");

var $9EZaR = parcelRequire("9EZaR");

var $iWF0s = parcelRequire("iWF0s");
const $4a329fce10f17c32$var$mobileLogoCss = null;
const $4a329fce10f17c32$var$tabletLogoCss = null;
const $4a329fce10f17c32$var$productPageLogoCss = null;
const $4a329fce10f17c32$var$logoCss = null;
const $4a329fce10f17c32$var$backButtonCss = null;
const $4a329fce10f17c32$var$profileAndMenuButtonCss = null;
const $4a329fce10f17c32$var$mobileNavUserProfileCss = null;
const $4a329fce10f17c32$var$mobileIconContainerCss = null;
const $4a329fce10f17c32$var$mobileDropdownMenuCss = null;
const $4a329fce10f17c32$var$tabletIconContainerCss = null;
const $4a329fce10f17c32$var$profileCss = null;
const $4a329fce10f17c32$var$DefaultAtlassianLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
    brand: "atlassian",
    type: "logo",
    appearance: "brand",
    height: 20,
    width: 156
});
const $4a329fce10f17c32$export$c2b4db2d88a6ed62 = ({ productKey: productKey, isLoggedIn: isLoggedIn, userName: userName, picture: picture, handleClickAvatar: handleClickAvatar, showMenu: showMenu, handleToggleMenu: handleToggleMenu, menuPage: menuPage, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, mobileLogo: mobileLogo = $4a329fce10f17c32$var$DefaultAtlassianLogo, mobileLogoAriaLabel: mobileLogoAriaLabel = 'Atlassian logo', mobileLogoHref: mobileLogoHref = '/', mobileLogoDataEventContainer: mobileLogoDataEventContainer = 'globalNavWacV2', isShowSearchButton: isShowSearchButton = true, isOpenSearch: isOpenSearch, setIsOpenSearch: setIsOpenSearch, tabletDropdownMenu: tabletDropdownMenu, isProductPage: isProductPage = false, isShowTryNowLink: isShowTryNowLink = false, navigationTrynowCtaText: navigationTrynowCtaText, navigationTrynowCtaUrl: navigationTrynowCtaUrl, navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant = 'primary', isShowAppSwitcher: isShowAppSwitcher = true, isShowUserProfile: isShowUserProfile = true, isShowTabletDropdown: isShowTabletDropdown = true, navType: navType = 'globalNav' })=>{
    const intl = (0, $8e22h.default)();
    const searchAndProfileRef = (0, $1oC0p.useRef)(null);
    const atlasUrl = (0, $jQ0cd.useLocalizedHref)('/');
    const [mobileDropdownMenu, setMobileDropdownMenu] = (0, $1oC0p.useState)(null);
    const handleClickOutside = (0, $1oC0p.useCallback)((event)=>{
        const path = event.composedPath && event.composedPath();
        if (mobileDropdownMenu) {
            const style = window.getComputedStyle(mobileDropdownMenu);
            const insideTabletMobileDropdownMenu = Array.prototype.includes.call(Array.prototype.map.call(path, (el)=>{
                return el.id === 'nav-tablet-mobile-dropdown-menu-button';
            }), true);
            if (!insideTabletMobileDropdownMenu && style.display !== 'none') {
                handleToggleMenu(false);
                handleMenuPage('default');
                handleFirstOpen(false);
            }
        }
    }, [
        mobileDropdownMenu,
        handleToggleMenu,
        handleMenuPage,
        handleFirstOpen
    ]);
    const handleKeydown = (0, $1oC0p.useCallback)((event)=>{
        if (event.code === 'Escape' && showMenu) {
            handleToggleMenu(false);
            handleMenuPage('default');
            handleFirstOpen(false);
        }
    }, [
        handleToggleMenu,
        handleMenuPage,
        handleFirstOpen,
        showMenu
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const element = document.getElementById('nav-tablet-mobile-dropdown-menu-button');
        setMobileDropdownMenu(element);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        document.addEventListener('click', handleClickOutside);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        handleClickOutside,
        handleKeydown
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _181nglyw",
                    "mobile-nav-company-logo"
                ]),
                children: menuPage === 'default' || !showMenu || menuPage === 'search' || menuPage === 'resources' || menuPage === 'product-everyone' || menuPage === 'product-developer' || menuPage === 'product-product-managers' || menuPage === 'product-it-professionals' || menuPage === 'product-business-teams' || menuPage === 'product-leadership-teams' || menuPage === 'solutions' || menuPage === 'why-atlassian' ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: mobileLogoHref,
                    "aria-label": mobileLogoAriaLabel,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": mobileLogoDataEventContainer,
                    "data-product-key": productKey,
                    className: (0, $2jatx.default)([
                        "_4t3i183y"
                    ]),
                    children: mobileLogo
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    style: {
                        all: 'unset',
                        width: '100%'
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        handleMenuPage('default');
                        handleFirstOpen(false);
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1wyboxwj _syaz6x5g _1e0c1txw _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                                label: "",
                                spacing: "spacious"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: intl.formatMessage({
                                    id: 'globalnavv2.menu-back',
                                    defaultMessage: 'Back'
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _181n1txw _q8t51h6o",
                    isProductPage && "_zulp10yn",
                    "tablet-nav-company-logo"
                ]),
                children: [
                    isProductPage && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i88uy _1bsb88uy _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkftjs",
                            "productpage-subnav-atlas-icon"
                        ]),
                        style: {
                            "--_16ciuzt": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue800'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            className: (0, $2jatx.default)([
                                "_4t3i8vuz _1bsb8vuz _1e0c1txw _1bah1h6o _4cvr1h6o",
                                "navigation-bar-atlas-icon"
                            ]),
                            href: atlasUrl,
                            "aria-label": intl.formatMessage({
                                id: 'productPageNav.logo-label',
                                defaultMessage: 'Atlassian logo'
                            }),
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "productPageSubNav",
                            "data-product-key": "home",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $zADBD.AtlassianIcon), {
                                size: "large",
                                appearance: "inverse"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        href: mobileLogoHref,
                        "aria-label": mobileLogoAriaLabel,
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": mobileLogoDataEventContainer,
                        "data-product-key": productKey,
                        className: (0, $2jatx.default)([
                            "_4t3i183y"
                        ]),
                        children: mobileLogo
                    })
                ]
            }),
            isOpenSearch ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $96jet.default), {
                isOpenSearch: isOpenSearch,
                setIsOpenSearch: setIsOpenSearch,
                isMobile: true
            }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulppxbi _ae4v1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _181n1txw _1lp7vrvc _q8t51h6o",
                            "mobile-nav-user-profile"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7XaVV.default), {
                                isShowTryNowLink: isShowTryNowLink,
                                productKey: productKey,
                                isShowSearchButton: isShowSearchButton,
                                navigationTrynowCtaText: navigationTrynowCtaText,
                                navigationTrynowCtaUrl: navigationTrynowCtaUrl,
                                navigationTrynowCtaOnClick: navigationTrynowCtaOnClick,
                                navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant,
                                setIsOpenSearch: setIsOpenSearch,
                                searchAndProfileRef: searchAndProfileRef,
                                isDisplayDivider: false,
                                isShowAppSwitcher: isShowAppSwitcher,
                                isShowUserProfile: isShowUserProfile,
                                navType: navType
                            }),
                            isShowTabletDropdown && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_191wn5xp _1bsbt94y _4t3i1tcg _ahbqu2gc _12l2u2gc",
                                    "navigation-switcher-divider"
                                ]),
                                style: {
                                    "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300'))
                                }
                            })
                        ]
                    }),
                    isShowUserProfile && isLoggedIn && userName && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _181nglyw",
                            "mobile-nav-profile-avatar"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            style: {
                                all: 'unset'
                            },
                            "aria-label": intl.formatMessage({
                                id: 'globalnavv2.menu-icon.toggle',
                                defaultMessage: 'Toggle Menu'
                            }),
                            onClick: (e)=>{
                                e.preventDefault();
                                handleClickAvatar();
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hZE0S.WACAvatar), {
                                name: userName,
                                src: picture,
                                size: 'medium'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i14no _1e0c1txw _4cvr1h6o _181nglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            style: {
                                all: 'unset'
                            },
                            "aria-label": intl.formatMessage({
                                id: 'globalnavv2.menu-icon.toggle',
                                defaultMessage: 'Toggle Menu'
                            }),
                            className: "globalnavV2ToggleMenu",
                            onClick: (e)=>{
                                e.preventDefault();
                                handleToggleMenu(!showMenu);
                                handleMenuPage('default');
                                handleFirstOpen(!showMenu);
                            },
                            children: showMenu ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9EZaR.CloseIcon), {
                                label: intl.formatMessage({
                                    id: 'globalnavv2.menu-icon.close',
                                    defaultMessage: 'Close Menu'
                                })
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iWF0s.MenuIcon), {
                                label: intl.formatMessage({
                                    id: 'globalnavv2.menu-icon.open',
                                    defaultMessage: 'Open Menu'
                                })
                            })
                        })
                    }),
                    isShowTabletDropdown && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        id: "nav-tablet-mobile-dropdown-menu-button",
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _181n1txw _q8t51h6o _1rqih2mm"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: "mobile-dropdown-menu-button",
                                style: {
                                    all: 'unset',
                                    width: '35px',
                                    height: '35px'
                                },
                                "aria-label": intl.formatMessage({
                                    id: 'globalnavv2.menu-icon.toggle',
                                    defaultMessage: 'Toggle Menu'
                                }),
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleToggleMenu(!showMenu);
                                    handleMenuPage('default');
                                    handleFirstOpen(!showMenu);
                                },
                                children: showMenu ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9EZaR.CloseIcon), {
                                    label: intl.formatMessage({
                                        id: 'globalnavv2.menu-icon.close',
                                        defaultMessage: 'Close Menu'
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iWF0s.MenuIcon), {
                                    label: intl.formatMessage({
                                        id: 'globalnavv2.menu-icon.open',
                                        defaultMessage: 'Open Menu'
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0cglyw _1lpykb7n _e7o81dj1 _12ho1osq _1yd3xncg _1d2yxilx _14b51ris _1rqistnw _1xlo1j15 _sfejpt1k _dwk3usvi _nv391wug _1bv01wug _1kkmgktf _19d9edjr _nxbczf9h _6o24b4wl _1jb31afi _1ocvidpf _1cac122b _1gw0zo7u _164f1ur6",
                                    showMenu && "_181n1ule",
                                    "mobile-dropdown-menu"
                                ]),
                                style: {
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                                },
                                children: tabletDropdownMenu
                            })
                        ]
                    }),
                    showMenu && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqsw1n9t _1e0c1ule _1bsb1osq _4t3i1osq _152tidpf _1e02idpf _rjxpidpf _u7coidpf _bfhk1ebw _1pby1mrw",
                            "overlay"
                        ])
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7XaVV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $57a6f62dc55ec35f$export$2e2bcd8739ae039; });
/* nav-search-and-profile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7qFQI = parcelRequire("7qFQI");

var $59F4T = parcelRequire("59F4T");

var $1pppr = parcelRequire("1pppr");

var $gfjAv = parcelRequire("gfjAv");

var $2WL8B = parcelRequire("2WL8B");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $4Ois3 = parcelRequire("4Ois3");

var $2hTwF = parcelRequire("2hTwF");

var $jQ0cd = parcelRequire("jQ0cd");

var $OKl9V = parcelRequire("OKl9V");

var $2Df35 = parcelRequire("2Df35");

var $gx3aw = parcelRequire("gx3aw");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $2gCne = parcelRequire("2gCne");

var $1ka2O = parcelRequire("1ka2O");

var $3riD8 = parcelRequire("3riD8");

var $aTTHV = parcelRequire("aTTHV");

var $2uCL0 = parcelRequire("2uCL0");
const $57a6f62dc55ec35f$var$dropdownStyles = null;
const $57a6f62dc55ec35f$var$displayFlex = null;
const $57a6f62dc55ec35f$var$dropdownItemStyles = null;
const $57a6f62dc55ec35f$var$productTextLayout = null;
const $57a6f62dc55ec35f$var$productSummaryTextStyles = null;
const $57a6f62dc55ec35f$var$productTitleTextStyles = null;
const $57a6f62dc55ec35f$var$productMarkStyles = null;
const $57a6f62dc55ec35f$var$tryNowContainerStyles = null;
const $57a6f62dc55ec35f$var$openOverlayStyles = null;
const $57a6f62dc55ec35f$var$closedOverlayStyles = null;
const $57a6f62dc55ec35f$var$fadeOutKeyframes = null;
const $57a6f62dc55ec35f$var$fadeOutAnimation = null;
const $57a6f62dc55ec35f$var$fadeInKeyframes = null;
const $57a6f62dc55ec35f$var$fadeInAnimation = null;
const $57a6f62dc55ec35f$var$rotate180deg = null;
const $57a6f62dc55ec35f$var$seeAllProductsStyles = null;
const $57a6f62dc55ec35f$var$caretStyles = null;
const $57a6f62dc55ec35f$var$dividerStyle = null;
const $57a6f62dc55ec35f$var$appSwitcherContainerStyle = null;
const $57a6f62dc55ec35f$var$navigationActionStyle = null;
const $57a6f62dc55ec35f$var$navigationActionLinkStyle = null;

const $57a6f62dc55ec35f$var$WacAppSwitcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(()=>// without the line ts-ignored below TSC throws this error:
    // "Relative import paths need explicit file extensions in EcmaScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Did you mean '../../../components/global-nav/app-switcher/src/index.js'?"
    // the file of course ends in .tsx, when you try to add that there is a different error:
    // "An import path can only end with a '.tsx' extension when 'allowImportingTsExtensions' is enabled."
    (parcelRequire("kZMuH")).then((module)=>({
            default: module.WacAppSwitcher
        })));
const $57a6f62dc55ec35f$var$ComprehensiveProductData = ()=>{
    const sunsetCompass = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp1072SunsetCompass);
    const intl = (0, $8e22h.default)();
    const comprehensiveProducts = [
        {
            productKey: 'jira',
            productName: 'Jira',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira'),
            signupHref: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&edition=free'),
            subtitle: intl.formatMessage({
                id: 'globalnav.v2.try-now-jira-subtitle',
                defaultMessage: 'Flexible project management'
            }),
            productMark: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                brand: "jira",
                type: "mark",
                appearance: "brand"
            })
        },
        {
            productKey: 'jsm',
            productName: 'Jira Service Management',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management'),
            signupHref: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-service-management&edition=free'),
            subtitle: intl.formatMessage({
                id: 'globalnav.v2.try-now-jsm-subtitle',
                defaultMessage: 'High-velocity service delivery'
            }),
            productMark: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                brand: "jiraservicemanagement",
                type: "mark",
                appearance: "brand"
            })
        },
        {
            productKey: 'confluence',
            productName: 'Confluence',
            href: (0, $jQ0cd.useLocalizedHref)('/software/confluence'),
            signupHref: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=confluence&edition=free'),
            subtitle: intl.formatMessage({
                id: 'globalnav.v2.try-now-connie-subtitle',
                defaultMessage: 'Knowledge all in one place'
            }),
            productMark: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                brand: "confluence",
                type: "mark",
                appearance: "brand"
            })
        },
        {
            productKey: 'jpd',
            productName: 'Jira Product Discovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery'),
            signupHref: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-product-discovery'),
            subtitle: intl.formatMessage({
                id: 'globalnav.v2.try-now-jpd-subtitle',
                defaultMessage: 'Capture & prioritize ideas'
            }),
            productMark: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                brand: "jiraproductdiscovery",
                type: "mark",
                appearance: "brand"
            })
        },
        // Uncomment the following block when the respective products are available in GUPs
        // {
        //     productKey: "rovo",
        //     productName: "Rovo",
        //     href: useLocalizedHref("/software/rovo"),
        //     signupHref: useLocalizedHref("/software/rovo/start"),
        //     subtitle: intl.formatMessage({
        //         id: "globalnav.v2.try-now-rovo-subtitle",
        //         defaultMessage: "Transform teamwork with AI"
        //     }),
        //     productMark: <LogoV3 brand="rovo" type="mark" appearance="brand" />
        // },
        // {
        //     productKey: "loom",
        //     productName: "Loom",
        //     href: useLocalizedHref("/software/loom"),
        //     signupHref: "https://www.loom.com/signup",
        //     subtitle: intl.formatMessage({
        //         id: "globalnav.v2.try-now-loom-subtitle",
        //         defaultMessage: "Quick, async video updates"
        //     }),
        //     productMark: <LogoV3 brand="loom" type="mark" appearance="brand" />
        // },
        // {
        //     productKey: "guard",
        //     productName: "Guard",
        //     href: useLocalizedHref("/software/access"),
        //     signupHref: "https://admin.atlassian.com/atlassian-access",
        //     subtitle: intl.formatMessage({
        //         id: "globalnav.v2.try-now-guard-subtitle",
        //         defaultMessage: "Enhanced cloud security"
        //     }),
        //     productMark: <LogoV3 brand="guard" type="mark" appearance="brand" />
        // },
        {
            productKey: 'compass',
            productName: 'Compass',
            href: (0, $jQ0cd.useLocalizedHref)('/software/compass'),
            signupHref: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=compass'),
            subtitle: intl.formatMessage({
                id: 'globalnav.v2.try-now-compass-subtitle',
                defaultMessage: 'Elevate your developer experience'
            }),
            productMark: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                brand: "compass",
                type: "mark",
                appearance: "brand"
            })
        }
    ];
    if (sunsetCompass) comprehensiveProducts.pop();
    return comprehensiveProducts;
};
let $57a6f62dc55ec35f$var$GupsDataProcessed = false;
const $57a6f62dc55ec35f$var$LoadingSpinnerStyles = null;
const $57a6f62dc55ec35f$var$LoadingSpinner = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
    className: (0, $2jatx.default)([
        "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq _4t3i1osq _1ul91svw _c71l1mcy _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _vchhusvi"
    ]),
    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
        interactionName: "load",
        label: "Loading",
        appearance: "inherit"
    })
});
const $57a6f62dc55ec35f$var$getAnonymousId = ()=>{
    const analyticsAnonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id');
    if (!analyticsAnonymousId) throw new Error('Failed to get anonymousId from Cookie');
    const decodedAnonymousId = decodeURIComponent(analyticsAnonymousId).replace(/['"]+/g, '');
    return decodedAnonymousId;
};
const $57a6f62dc55ec35f$export$8acaf5c5c3c3363e = async ()=>{
    if (!$57a6f62dc55ec35f$var$GupsDataProcessed) {
        const anonId = $57a6f62dc55ec35f$var$getAnonymousId();
        const client = new (0, $4Ois3.GrowthUnifiedProfileClient)();
        try {
            const { data: data, error: error } = await client.getProfile({
                anonymousId: anonId
            }, [
                (0, $2hTwF.OptionalFields).USER_FOOTPRINTS
            ]);
            if (error) throw new Error(`Failed to execute call to get profile: ${error?.message || error}`);
            return data;
        } catch (err) {
            console.error('An unexpected error occurred while getting the profile data:', err);
        }
    }
    return null;
};
const $57a6f62dc55ec35f$var$getExistingProductsList = (data)=>{
    const products = data?.userFootprints?.products;
    return products;
};
const $57a6f62dc55ec35f$export$62df9bdd72f7e904 = (productData, existingProductNames)=>{
    const rankedProducts = [
        ...productData
    ];
    const filteredProductData = productData.filter((product)=>!existingProductNames.includes(product.productKey));
    if (filteredProductData.length >= 3) return filteredProductData.slice(0, 3);
    while(filteredProductData.length < 3){
        const currProduct = rankedProducts.shift();
        const currProductKey = currProduct?.productKey;
        // opposite logic to above as we are now adding duplicates to fill the 3 product slots
        if (currProductKey && existingProductNames.includes(currProductKey)) filteredProductData.push(currProduct);
    }
    return filteredProductData;
};
const $57a6f62dc55ec35f$export$5865ec32a0eba211 = ({ products: products, buttonText: buttonText })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $1oC0p.useState)(false);
    const [FilteredProductData, setFilteredProductData] = (0, $1oC0p.useState)(products.slice(0, 3));
    const [isLoading, setLoading] = (0, $1oC0p.useState)(!$57a6f62dc55ec35f$var$GupsDataProcessed);
    const tryLink = (0, $jQ0cd.useLocalizedHref)('/try');
    const openDropdown = ()=>{
        if (isDropdownOpen) return;
        setIsDropdownOpen(true);
    };
    const closeDropdown = ()=>{
        if (!isDropdownOpen) return;
        setIsDropdownOpen(false);
    };
    const handleClick = ()=>{
        if (isDropdownOpen) closeDropdown();
        else openDropdown();
    };
    const getProductData = async ()=>{
        if (!$57a6f62dc55ec35f$var$GupsDataProcessed) try {
            const gupsData = await $57a6f62dc55ec35f$export$8acaf5c5c3c3363e();
            const existingProducts = $57a6f62dc55ec35f$var$getExistingProductsList(gupsData);
            const filteredData = $57a6f62dc55ec35f$export$62df9bdd72f7e904(products, existingProducts);
            setFilteredProductData(filteredData);
        } finally{
            $57a6f62dc55ec35f$var$GupsDataProcessed = true;
            setLoading(false);
        }
    };
    (0, $izdHQ.useFeatureExposed)('gwp-3947-try-now-cta-dropdown', 'Test', {
        conditions: [
            isDropdownOpen
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        onMouseLeave: closeDropdown,
        onBlur: closeDropdown,
        role: "button",
        tabIndex: 0,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClick();
            }
        },
        onClick: async (e)=>{
            e.preventDefault();
            handleClick();
            await getProductData();
            createAnalyticsEvent({
                eventName: 'buttonClicked',
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalNavCtaDropdownButtonClicked',
                source: 'globalNav',
                attributes: {
                    product: 'marketing'
                }
            }).fire();
        },
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1o8l _85i5dlk8 _1q51dlk8"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lqyi6.Button), {
                variant: "primary",
                size: "small",
                onMouseEnter: async ()=>{
                    openDropdown();
                    await getProductData();
                    createAnalyticsEvent({
                        eventName: 'buttonHovered',
                        eventType: 'ui',
                        action: 'hovered',
                        actionSubject: 'button',
                        actionSubjectId: 'globalNavCtaDropdownButtonHovered',
                        source: 'globalNav',
                        attributes: {
                            product: 'marketing'
                        }
                    }).fire();
                },
                className: (0, $2jatx.default)([
                    "_syaz1afi _v564pw66 _1tke1ylp"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                },
                children: [
                    buttonText,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ahbqftgi _v564bf4l _1e0c1o8l",
                            isDropdownOpen && "_t9ec1sub",
                            "caretStyles"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                            name: "caret",
                            size: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    isDropdownOpen && "_kqsw1n9t _1e0c1ule _1bsb1osq _4t3i1osq _152tidpf _1e02idpf _rjxpidpf _u7coidpf _bfhk1ebw _1pby1mrw",
                    !isDropdownOpen && "_kqsw1n9t _1e0cglyw _1bsb1osq _4t3i1osq _152tidpf _1e02idpf _rjxpidpf _u7coidpf _bfhk1ebw _1pby1mrw",
                    isDropdownOpen && "",
                    isDropdownOpen && "_y44v11aa",
                    !isDropdownOpen && "",
                    !isDropdownOpen && "_y44v10i3"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _kqswstnw _152t1osq _1e02qkx9 _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _1bah1y6m _4cvr1fhb _2rkogktf _11q71afi _1ul9r0r7 _16qsfl7y",
                    isDropdownOpen && "",
                    isDropdownOpen && "_y44v11aa",
                    !isDropdownOpen && "",
                    !isDropdownOpen && "_y44v10i3",
                    isDropdownOpen && "_1e0c1txw",
                    "dropdown-menu"
                ]),
                onMouseLeave: closeDropdown,
                onBlur: closeDropdown,
                role: "menu",
                tabIndex: 0,
                onKeyDown: (e)=>{
                    if (e.key === 'Escape') closeDropdown();
                },
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                },
                children: isLoading ? $57a6f62dc55ec35f$var$LoadingSpinner : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        FilteredProductData.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                href: product.signupHref,
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    createAnalyticsEvent({
                                        eventType: 'ui',
                                        action: 'clicked',
                                        actionSubject: 'linkButton',
                                        source: 'globalNav-cta-desktop-product-link',
                                        attributes: {
                                            productKey: product.productKey,
                                            productName: product.productName,
                                            linkUrl: product.signupHref
                                        }
                                    }).fire();
                                },
                                role: "button",
                                tabIndex: 0,
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
                                },
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb3sup _4t3i12am _6rth7vkz _1w6b5hrz _1tpudkka"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue')),
                                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light200'))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ady _4t3i1ady _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _bfhk1ret _2rko1y44 _12l21crf _w8l5zwfg _1752zwfg",
                                            "product-mark"
                                        ]),
                                        children: product.productMark
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1y6m _zulpyh40"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1pfd _1wybdlk8 _ect4kipj _zg8l4jg8 _k48p1fw0 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                                    "product-title"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                                                },
                                                children: product.productName
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1sqi _1wyb1crf _ect48q0o _zg8l4jg8 _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: product.subtitle
                                            })
                                        ]
                                    })
                                ]
                            }, product.productName)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: intl.formatMessage({
                                id: 'globalnav.v2.try-now-dropdown-see-all-products',
                                defaultMessage: 'See all products'
                            }),
                            href: tryLink,
                            type: 'primary',
                            onClick: (e)=>{
                                e.stopPropagation();
                                createAnalyticsEvent({
                                    eventType: 'ui',
                                    action: 'clicked',
                                    actionSubject: 'linkButton',
                                    source: 'globalNav-cta-desktop-cta-dropdown-content',
                                    attributes: {
                                        label: 'see-all-products',
                                        linkUrl: tryLink
                                    }
                                }).fire();
                            },
                            "aria-label": intl.formatMessage({
                                id: 'globalnav.v2.try-now-dropdown-see-all-products',
                                defaultMessage: 'See all products'
                            }),
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx2vrvc _4cvresu3 _1bsb3sup _4t3izwfg _1wybdlk8 _vwz4gktf"
                            ])
                        })
                    ]
                })
            })
        ]
    });
};
const $57a6f62dc55ec35f$var$SearchAndProfile = ({ isShowTryNowLink: // the \"Try now\" CTA in the global nav is meant to be shown by default, to hide it set isShowTryNowLink prop to false
// read more at https://hello.atlassian.net/wiki/spaces/~857563384/pages/3849594563/Re-introduce+the+global+nav+Try+now+button
isShowTryNowLink = true, productKey: productKey = 'home', isShowSearchButton: isShowSearchButton = true, setIsOpenSearch: setIsOpenSearch, navigationTrynowCtaText: navigationTrynowCtaText, navigationTrynowCtaUrl: navigationTrynowCtaUrl, navigationTrynowCtaOnClick: navigationTrynowCtaOnClick, searchAndProfileRef: searchAndProfileRef, isDisplayDivider: isDisplayDivider = true, positionTryNowCtaOnRight: positionTryNowCtaOnRight = false, isShowAppSwitcher: isShowAppSwitcher = true, isShowUserProfile: isShowUserProfile = true, navType: navType = 'globalNav', navigationTrynowCtaButtonVariant: navigationTrynowCtaButtonVariant = 'primary' })=>{
    const intl = (0, $8e22h.default)();
    const [isDisplayCTADropdownButton, setIsDisplayCTADropdownButton] = (0, $1oC0p.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { product: product, edition: edition } = (0, $1pppr.useProductIntent)();
    const wacAISearchSummaryExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).wacAISearchSummaryV2);
    const [isUseGeneralSigninPromptConfig, setIsUseGeneralSigninPromptConfig] = (0, $1oC0p.useState)(false);
    const [aiEnabled, setAiEnabled] = (0, $1oC0p.useState)(false);
    const { isEligible: showContactSalesCta, isLoading: isContactSalesCtaLoading } = (0, $aTTHV.useContactSalesCtaEligibility)();
    const shouldRenderTryNowButton = !positionTryNowCtaOnRight && isShowTryNowLink;
    /* TODO: Implement setIsUserLoggedIn, user logged in status (in useEffect), once GWP-51 in implemented  */ const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const defaultCTAUrl = (0, $jQ0cd.useLocalizedHref)('/try');
    const buttonText = navigationTrynowCtaText ?? intl.formatMessage({
        id: 'globalnav.v2.try-now-exp-button-label',
        defaultMessage: 'Get it free'
    });
    const buttonUrl = navigationTrynowCtaUrl ?? defaultCTAUrl;
    const isDesktop = (0, $2WL8B.useIsDesktop)();
    const hasExistingSites = (0, $2WL8B.useLoggedOutHasExistingSites)();
    const { pathname: pathname } = (0, $1ka2O.useLocation)();
    const isHomepage = pathname === '/' || pathname === '';
    const isEligibleForGeneralSigninPrompt = isDesktop && hasExistingSites && isHomepage;
    const isNewDay = (lastVisitDate)=>{
        const lastVisit = new Date(lastVisitDate);
        const today = new Date();
        return lastVisit.getDate() !== today.getDate() || lastVisit.getMonth() !== today.getMonth() || lastVisit.getFullYear() !== today.getFullYear();
    };
    (0, $1oC0p.useEffect)(()=>{
        let timeoutId = null;
        const consecutiveXClicks = Number((0, $2gCne.getLocalStorage)('general_signin_prompt_x_clicks', true) || '');
        const lastVisitDate = (0, $2gCne.getLocalStorage)('general_signin_prompt_last_visit_timestamp', true);
        const showImmediately = !lastVisitDate || consecutiveXClicks > 0 && consecutiveXClicks < 3 && lastVisitDate && isNewDay(lastVisitDate);
        const showAfterDelay = Boolean(lastVisitDate && consecutiveXClicks === 0);
        // If user has clicked X 2 times, never show again
        if (showImmediately && isEligibleForGeneralSigninPrompt) setIsUseGeneralSigninPromptConfig(true);
        else if (showAfterDelay && isEligibleForGeneralSigninPrompt) // Delay showing the signin prompt by 3 seconds
        timeoutId = setTimeout(()=>{
            setIsUseGeneralSigninPromptConfig(true);
        }, 3000);
        else // catch statement for all other cases
        setIsUseGeneralSigninPromptConfig(false);
        // Cleanup timeout on unmount or effect re-run
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        isEligibleForGeneralSigninPrompt
    ]);
    const productLandingPagesData = $57a6f62dc55ec35f$var$ComprehensiveProductData();
    (0, $1oC0p.useEffect)(()=>{
        if (navType === 'globalNav' && !isUserLoggedIn && !requestInProgress) setIsDisplayCTADropdownButton(true);
    }, [
        requestInProgress,
        isUserLoggedIn
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (isShowSearchButton && wacAISearchSummaryExperiment && wacAISearchSummaryExperiment.type === 'enrolled' && wacAISearchSummaryExperiment.value) setAiEnabled(true);
    }, [
        isShowSearchButton,
        wacAISearchSummaryExperiment
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: searchAndProfileRef,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulp7vkz"
        ]),
        children: [
            showContactSalesCta ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTTHV.ContactSalesCta), {}) : isContactSalesCtaLoading ? null : shouldRenderTryNowButton && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.TryIntent), {
                intentType: 'button',
                containerId: 'navbar',
                productKey: product?.key,
                edition: edition,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1o8l _85i5dlk8 _1q51dlk8"
                    ]),
                    children: isDisplayCTADropdownButton ? // if the dropdown exp is enabled, show dropdown version of button with the try now/get it free variation,
                    // else show the regular button with the existing experiment conditions
                    /*#__PURE__*/ (0, $7VQPk.jsx)($57a6f62dc55ec35f$export$5865ec32a0eba211, {
                        products: productLandingPagesData,
                        buttonText: buttonText,
                        productKey: productKey
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                        variant: navigationTrynowCtaButtonVariant,
                        size: "small",
                        href: buttonUrl,
                        dataEventProps: {
                            'data-product-key': productKey,
                            'data-event': 'clicked',
                            'data-event-component': 'linkButton',
                            'data-event-container': 'navbar',
                            'data-label': buttonText,
                            'data-label-english': 'Get it free',
                            'data-track-event': `${productKey}.get-it-free-button-clicked`
                        },
                        onClick: (e)=>{
                            if (navigationTrynowCtaOnClick) navigationTrynowCtaOnClick(e);
                            else if (buttonUrl) window.location.href = buttonUrl;
                        },
                        className: (0, $2jatx.default)([
                            "_1tke1ylp"
                        ]),
                        children: buttonText
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: isShowSearchButton && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2uCL0.default), {
                    buttonId: 'global-nav-search-bar-icon-desktop',
                    aiEnabled: aiEnabled,
                    onClick: (e)=>{
                        e.preventDefault();
                        setIsOpenSearch(true);
                        if (wacAISearchSummaryExperiment && wacAISearchSummaryExperiment.type === 'enrolled' && wacAISearchSummaryExperiment.fireExposure) wacAISearchSummaryExperiment.fireExposure();
                        createAnalyticsEvent({
                            eventName: 'searchOpen',
                            eventType: 'ui',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'searchButtonDesktop',
                            source: 'globalNav',
                            attributes: {
                                product: 'search',
                                pageUrl: window.location.href,
                                pagePath: window.location.pathname,
                                aiEnabled: aiEnabled
                            }
                        }).fire();
                    }
                })
            }),
            isDisplayDivider ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_191wn5xp _1bsbt94y _4t3i1tcg _1wpz1h6o"
                ]),
                style: {
                    "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300'))
                }
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c1txw _2lx2vrvc _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _2lx2vrvc"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                            children: isUserLoggedIn && isShowAppSwitcher && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_12l27vkz"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($57a6f62dc55ec35f$var$WacAppSwitcher, {
                                    allowJoinSitesProvider: true,
                                    appSwitcherLabel: '',
                                    // @ts-expect-error type error
                                    appSwitcherIconPrimaryColor: '#42526e',
                                    isUseV2AppSwitcherStyle: true,
                                    isDisplayBorderAndHoverEffect: false
                                })
                            })
                        })
                    }),
                    isShowUserProfile ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _2lx2vrvc"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $59F4T.GlobalNavUserProfile), {
                            isUseNewLoggedInUserDropdown: true,
                            isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig,
                            setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig,
                            positionTryNowCtaOnRight: positionTryNowCtaOnRight
                        })
                    }) : null,
                    positionTryNowCtaOnRight && isShowTryNowLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.TryIntent), {
                        intentType: 'button',
                        containerId: 'navbar',
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o _4cvr1h6o _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                variant: navigationTrynowCtaButtonVariant,
                                size: "small",
                                href: buttonUrl,
                                dataEventProps: {
                                    'data-product-key': productKey,
                                    'data-event': 'clicked',
                                    'data-event-component': 'linkButton',
                                    'data-event-container': 'navbar',
                                    'data-label': buttonText,
                                    'data-label-english': 'Get it free',
                                    'data-track-event': `${productKey}.get-it-free-button-clicked`
                                },
                                onClick: (e)=>{
                                    if (navigationTrynowCtaOnClick) navigationTrynowCtaOnClick(e);
                                    else if (buttonUrl) window.location.href = buttonUrl;
                                },
                                className: (0, $2jatx.default)([
                                    "_1tke1ylp"
                                ]),
                                children: buttonText
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $57a6f62dc55ec35f$export$2e2bcd8739ae039 = $57a6f62dc55ec35f$var$SearchAndProfile;

});
parcelRegister("1pppr", function(module, exports) {
$parcel$export(module.exports, "useProductIntent", function () { return $f58cfccdb837a19b$export$93cccec4b411f62; });

var $1oC0p = parcelRequire("1oC0p");

var $4kwlm = parcelRequire("4kwlm");
const $f58cfccdb837a19b$export$93cccec4b411f62 = ()=>// eslint-disable-next-line complexity
    (0, $1oC0p.useMemo)(()=>{
        let edition;
        let product;
        if (typeof window === 'undefined') return {
            edition: edition,
            product: product
        };
        const params = new URLSearchParams(window.location.search);
        if (window.location.pathname.includes('/software/jira/product-discovery')) {
            product = {
                bundle: 'jira-product-discovery',
                description: 'Jira Product Discovery',
                key: (0, $4kwlm.ProductKey).JIRA_PRODUCT_DISCOVERY,
                name: 'jira-product-discovery'
            };
            edition = 'free';
        } else if (window.location.pathname.includes('/software/jira/service-management')) {
            product = {
                bundle: 'jira-service-management',
                description: 'Jira Service Management',
                key: (0, $4kwlm.ProductKey).JIRA_SERVICE_MANAGEMENT,
                name: 'jira-servicedesk'
            };
            edition = 'free';
        } else if (window.location.pathname.includes('/software/jira')) {
            product = {
                bundle: 'jira-software',
                description: 'Jira',
                key: (0, $4kwlm.ProductKey).JIRA_SOFTWARE,
                name: 'jira'
            };
            edition = 'free';
        }
        if (window.location.pathname.includes('/software/confluence')) {
            product = {
                bundle: 'confluence',
                description: 'Confluence',
                key: (0, $4kwlm.ProductKey).CONFLUENCE,
                name: 'confluence'
            };
            edition = 'free';
        }
        const isSignupPage = window.location.pathname.endsWith('/try/cloud/signup');
        const isConfirmationPage = window.location.pathname.endsWith('/ondemand/signup/confirmation');
        if (isSignupPage || isConfirmationPage || window.IS_STORYBOOK) {
            // defaults for the signup page
            if (isSignupPage) {
                edition = 'free';
                product = {
                    bundle: 'jira-software',
                    description: 'Jira',
                    key: (0, $4kwlm.ProductKey).JIRA_SOFTWARE,
                    name: 'jira'
                };
            }
            // determine product
            if (params.has('product')) product = (0, $4kwlm.products).find((product)=>product.key === params.get('product'));
            else if (params.has('bundle')) product = (0, $4kwlm.products).find((product)=>product.bundle === params.get('bundle'));
            else if (params.has('products')) product = (0, $4kwlm.products).find((product)=>product.key === params.get('products')?.split(',')[0]);
            // determine edition
            const editionParam = params.get('edition');
            if (editionParam === 'free') edition = 'free';
            else if (editionParam === 'standard') edition = 'standard';
            else if (editionParam === 'premium') edition = 'premium';
        }
        return {
            edition: edition,
            product: product
        };
    }, []);

});
parcelRegister("4kwlm", function(module, exports) {
$parcel$export(module.exports, "ProductKey", function () { return $58bb2aae7b7563b2$export$f3a53bd43617a593; });
$parcel$export(module.exports, "products", function () { return $58bb2aae7b7563b2$export$b6aad051bad07f12; });
var $58bb2aae7b7563b2$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    return ProductKey;
}({});
const $58bb2aae7b7563b2$export$b6aad051bad07f12 = [
    {
        bundle: 'jira-software',
        description: 'Jira',
        key: "jira-software.ondemand",
        name: 'jira'
    },
    {
        bundle: 'confluence',
        description: 'Confluence',
        key: "confluence.ondemand",
        name: 'confluence'
    },
    {
        bundle: 'jira-service-management',
        description: 'Jira Service Management',
        key: "jira-servicedesk.ondemand",
        name: 'jira-servicedesk'
    },
    {
        bundle: 'jira-product-discovery',
        description: 'Jira Product Discovery',
        key: "jira-product-discovery",
        name: 'jira-product-discovery'
    }
];

});


parcelRegister("gfjAv", function(module, exports) {
$parcel$export(module.exports, "TryIntent", function () { return $b1c94d1e7a88e3d0$export$ecf5e601bca64bc1; });
$parcel$export(module.exports, "default", function () { return $b1c94d1e7a88e3d0$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $2wDsW = parcelRequire("2wDsW");
const $b1c94d1e7a88e3d0$export$ecf5e601bca64bc1 = (props)=>{
    const { children: children, ...hookProps } = props;
    const { onClick: onClick, onKeyDown: onKeyDown } = (0, $2wDsW.useTryIntent)(hookProps);
    return(// This is just a wrapper that doesn't affect user interactivity. Okay to ignore this a11y rule.
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": 'try-intent-wrapper',
        onKeyDown: onKeyDown,
        onClick: onClick,
        children: children
    }));
};
var $b1c94d1e7a88e3d0$export$2e2bcd8739ae039 = $b1c94d1e7a88e3d0$export$ecf5e601bca64bc1;

});
parcelRegister("2wDsW", function(module, exports) {
$parcel$export(module.exports, "useTryIntent", function () { return $5b10d2afdc721907$export$8369115ea76258b; });

var $eY3N6 = parcelRequire("eY3N6");
function $5b10d2afdc721907$export$8369115ea76258b(props) {
    const { intentType: intentType, containerId: containerId, productKey: productKey, edition: edition, onAnalyticsEventFired: onAnalyticsEventFired } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const onClick = ()=>{
        createAnalyticsEvent({
            eventType: 'track',
            action: 'interacted',
            actionSubject: 'tryIntentComponent',
            containerId: containerId,
            actionSubjectId: intentType,
            attributes: {
                productKey: productKey,
                edition: edition
            }
        }).fire();
        onAnalyticsEventFired && onAnalyticsEventFired();
    };
    const onKeyDown = (e)=>{
        if (e.code !== 'Tab' && e.code !== 'Enter' && e.code !== 'Space') {
            createAnalyticsEvent({
                eventType: 'track',
                action: 'interacted',
                actionSubject: 'tryIntentComponent',
                containerId: containerId,
                actionSubjectId: intentType,
                attributes: {
                    productKey: productKey,
                    edition: edition
                }
            }).fire();
            onAnalyticsEventFired && onAnalyticsEventFired();
        }
    };
    return {
        onClick: onClick,
        onKeyDown: onKeyDown
    };
}

});


parcelRegister("kZMuH", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("XcKNY"),
    $eao4m("9zfys"),
    $eao4m("ch50F"),
    $eao4m("jkAF2")
]).then(()=>parcelRequire('2cQYI'));

});


parcelRegister("96jet", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3b93aab61bbcede$export$2e2bcd8739ae039; });
/* search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $kNyc7 = parcelRequire("kNyc7");
const $d3b93aab61bbcede$var$mobileSearchBarStyle = null;
const $d3b93aab61bbcede$var$productNavSearchBarStyle = null;
const $d3b93aab61bbcede$var$globalNavSearchBarStyle = null;
const $d3b93aab61bbcede$var$SearchBar = ({ isOpenSearch: isOpenSearch, setIsOpenSearch: setIsOpenSearch, isMobile: isMobile = false, parentType: parentType = 'GlobalNav' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const wacAISearchSummaryExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).wacAISearchSummaryV2);
    const [renderSearchButton, setRenderSearchButton] = (0, $1oC0p.useState)(false);
    const [aiEnabled, setAiEnabled] = (0, $1oC0p.useState)(false);
    const handleEscKeyEvent = (0, $1oC0p.useCallback)((event)=>{
        if (event.key === 'Escape') {
            setIsOpenSearch(false);
            createAnalyticsEvent({
                eventName: 'searchClose',
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'searchBarEscapeKey',
                source: 'globalNav',
                attributes: {
                    product: 'search',
                    pageUrl: window.location.href,
                    pagePath: window.location.pathname
                }
            }).fire();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener('keydown', handleEscKeyEvent, false);
        // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener('keydown', handleEscKeyEvent, false);
        };
    }, [
        handleEscKeyEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (wacAISearchSummaryExperiment && wacAISearchSummaryExperiment.type !== 'indeterminate') setRenderSearchButton(true);
        if (wacAISearchSummaryExperiment && wacAISearchSummaryExperiment.type === 'enrolled' && wacAISearchSummaryExperiment.value) setAiEnabled(true);
    }, [
        wacAISearchSummaryExperiment
    ]);
    if (!renderSearchButton) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ahbq10yn _12l210yn _1bsb1osq",
            isMobile && "_ahbq10yn _12l210yn _1bsb1osq",
            parentType === 'ProductNav' ? "_1bsb1osq _b8yqtfvk" : "_ahbq10yn _12l210yn _1bsb1osq",
            "search-bar"
        ]),
        "data-testid": "search-bar",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kNyc7.default), {
            isOpenSearch: isOpenSearch,
            setIsOpenSearch: setIsOpenSearch,
            aiEnabled: aiEnabled,
            parentType: parentType
        })
    });
};
var $d3b93aab61bbcede$export$2e2bcd8739ae039 = $d3b93aab61bbcede$var$SearchBar;

});

parcelRegister("9EZaR", function(module, exports) {
$parcel$export(module.exports, "CloseIcon", function () { return $379a2975b30899dd$export$cae179f078f4b4a4; });
/* close.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $379a2975b30899dd$export$cae179f078f4b4a4 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb183y _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "17",
            height: "35",
            viewBox: "0 0 17 35",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M15 26L2.27208 13.2721",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M2 26L14.7279 13.2721",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                })
            ]
        })
    });

});

parcelRegister("iWF0s", function(module, exports) {
$parcel$export(module.exports, "MenuIcon", function () { return $bc363e8c859f82f1$export$46e1d66043f363e6; });
/* menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $bc363e8c859f82f1$export$46e1d66043f363e6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb183y _1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "25",
                height: "4",
                viewBox: "0 0 25 4",
                fill: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M2 2H23",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "25",
                height: "4",
                viewBox: "0 0 25 4",
                fill: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M2 2H23",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "25",
                height: "4",
                viewBox: "0 0 25 4",
                fill: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M2 2H23",
                    stroke: "black",
                    strokeWidth: "3",
                    strokeLinecap: "round"
                })
            })
        ]
    });

});


parcelRegister("gQZpW", function(module, exports) {
$parcel$export(module.exports, "MobileProductPageNavDropdowns", function () { return $baf67fe4bbfdb925$export$775cfc571e018bea; });
/* mobile-product-page-nav-dropdowns.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6HH3C = parcelRequire("6HH3C");
const $baf67fe4bbfdb925$var$slideInRight = null;
const $baf67fe4bbfdb925$var$slideInRightCss = null;
const $baf67fe4bbfdb925$var$shownInnerMobileDropdownMenuStyle = null;
const $baf67fe4bbfdb925$var$hiddenInnerMobileDropdownMenuStyle = null;
const $baf67fe4bbfdb925$export$998b37ddcfb0e866 = ({ menuPage: menuPage, productKey: productKey })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_tzy4idpf _y44vw6g5",
            menuPage === 'why-bitbucket' ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
            "inner-mobile-dropdown-menu"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6HH3C.MobileNavWhyBitbucket), {
            productKey: productKey
        })
    });
};
const $baf67fe4bbfdb925$export$775cfc571e018bea = ({ productKey: productKey, menuPage: menuPage })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: productKey === 'bitbucket' && /*#__PURE__*/ (0, $7VQPk.jsx)($baf67fe4bbfdb925$export$998b37ddcfb0e866, {
            productKey: productKey,
            menuPage: menuPage
        })
    });
};

});
parcelRegister("6HH3C", function(module, exports) {
$parcel$export(module.exports, "MobileNavWhyBitbucket", function () { return $8a4cc214baecb643$export$6cee6a43a16688f9; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $gNUpZ = parcelRequire("gNUpZ");
const $8a4cc214baecb643$export$6cee6a43a16688f9 = ({ productKey: productKey = 'bitbucket' })=>{
    const intl = (0, $8e22h.default)();
    function useWhyBitbucketLinks() {
        return [
            {
                key: 'features',
                name: intl.formatMessage((0, $fnHPc.defineMessage)({
                    id: 'globalnavv2.subnav.whybitbucket.links.features',
                    defaultMessage: 'Features'
                })),
                links: [
                    {
                        key: 'ci-cd',
                        text: intl.formatMessage((0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.whybitbucket.links.ci-cd',
                            defaultMessage: 'CI/CD'
                        })),
                        href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/pipelines')
                    },
                    {
                        key: 'cloud-security',
                        text: intl.formatMessage((0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.whybitbucket.links.it-service-management',
                            defaultMessage: 'Cloud Security'
                        })),
                        href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/cloud-security')
                    },
                    {
                        key: 'dev-sec-ops',
                        text: intl.formatMessage((0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.whybitbucket.links.dev-sec-ops',
                            defaultMessage: 'DevSecOps'
                        })),
                        href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/devsecops')
                    },
                    {
                        key: 'code-review',
                        text: intl.formatMessage((0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.whybitbucket.links.code-review',
                            defaultMessage: 'Code Review'
                        })),
                        href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/code-review')
                    },
                    {
                        key: 'jira-integrations',
                        text: intl.formatMessage((0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.whybitbucket.links.jira-integrations',
                            defaultMessage: 'Jira Integrations'
                        })),
                        href: (0, $jQ0cd.useLocalizedHref)('/software/jira/bitbucket-integration')
                    }
                ]
            },
            {
                key: 'Plans',
                name: intl.formatMessage((0, $fnHPc.defineMessage)({
                    id: 'globalnavv2.subnav.whybitbucket.links.plans',
                    defaultMessage: 'Plans'
                })),
                links: [
                    {
                        key: 'bitbucket-cloud-premium',
                        text: intl.formatMessage((0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.whybitbucket.links.bitbucket-cloud-premium',
                            defaultMessage: 'Bitbucket Cloud Premium'
                        })),
                        href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/premium')
                    }
                ]
            }
        ];
    }
    const whyBitbucketLinks = useWhyBitbucketLinks();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gNUpZ.MobileNavMenuPage), {
        pageLabel: intl.formatMessage({
            id: 'globalnav.v2.whybitbucket.title',
            defaultMessage: 'Why Bitbucket'
        }),
        cards: [],
        linksSections: whyBitbucketLinks,
        productKey: productKey
    });
};

});
parcelRegister("gNUpZ", function(module, exports) {
$parcel$export(module.exports, "MobileNavMenuPage", function () { return $78ec93d066091426$export$eb971653a31a8e4d; });
/* mobile-nav-menu-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $kxzNq = parcelRequire("kxzNq");

var $czH8Q = parcelRequire("czH8Q");

var $bvLTq = parcelRequire("bvLTq");

var $3PWZ2 = parcelRequire("3PWZ2");

var $jbgN3 = parcelRequire("jbgN3");
const $78ec93d066091426$var$topLinksContainerCss = null;
const $78ec93d066091426$var$labelCss = null;
const $78ec93d066091426$var$pageLabelCss = null;
const $78ec93d066091426$var$sectionLabelCss = null;
const $78ec93d066091426$var$bottomContainerCss = null;
const $78ec93d066091426$var$linkContainerCss = null;
const $78ec93d066091426$var$SubnavLink = ({ href: href, text: text, productKey: productKey = 'home' })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1rjcpxbi _ect48q0o _1wybdlk8 _k48p1fw0 _vwz41343"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            type: "anchor",
            href: href,
            text: text,
            "aria-label": text,
            dataEventProps: {
                'data-product-key': productKey,
                'data-event-component': 'linkButton',
                'data-event-container': 'globalNavWacDropdownContainer',
                'data-event': 'clicked'
            }
        })
    });
};
const $78ec93d066091426$export$eb971653a31a8e4d = ({ pageLabel: pageLabel, cards: cards, linksSections: linksSections, productKey: productKey = 'home' })=>{
    const { shouldShowGlobalNavProductRecommendations: shouldShowGlobalNavProductRecommendations, mobileNavPageLabelFeaturedProducts: mobileNavPageLabelFeaturedProducts, fireGlobalNavProductRecoEventsWhenInView: fireGlobalNavProductRecoEventsWhenInView } = (0, $1oC0p.useContext)((0, $bvLTq.NavProductRecommendationsContext));
    const containerRef = (0, $1oC0p.useRef)(null);
    // Observe the container to fire the event screen when it's in view
    (0, $1oC0p.useLayoutEffect)(()=>{
        // Check if IntersectionObserver is supported
        if (typeof IntersectionObserver === 'undefined') return;
        if (pageLabel !== mobileNavPageLabelFeaturedProducts) return;
        const currentContainer = containerRef.current;
        // Check if container is currently in view
        const observer = new IntersectionObserver(([entry])=>{
            if (entry?.isIntersecting) fireGlobalNavProductRecoEventsWhenInView({
                isMobile: true
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        });
        if (currentContainer) observer.observe(currentContainer);
        return ()=>{
            if (currentContainer) observer.unobserve(currentContainer);
        };
    }, [
        fireGlobalNavProductRecoEventsWhenInView,
        mobileNavPageLabelFeaturedProducts,
        pageLabel
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: containerRef,
                className: (0, $2jatx.default)([
                    "_85i51tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1pfd _1p1dangw _ect48q0o _1wybw1gv",
                            "_1rjcutpp _vwz41dkv"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: pageLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: pageLabel === mobileNavPageLabelFeaturedProducts && shouldShowGlobalNavProductRecommendations ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $czH8Q.GlobalNavProductRecommendations), {
                            isMobile: true
                        }) : cards.map(({ key: key, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavCard), {
                                productKey: productKey,
                                ...rest
                            }, key))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kxzNq.RovoSection), {})
                ]
            }),
            linksSections && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_bfhkdkka _18s8xi3e _1yt41hnh"
                ]),
                style: {
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light200'))
                },
                children: linksSections?.map(({ key: key, name: name, links: links }, numSection)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            numSection !== 0 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3PWZ2.Divider), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_syaz1pfd _1p1dangw _ect48q0o _1wybw1gv",
                                    "_1rjc1kz8 _vwz419xd _k48pbfng"
                                ]),
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: name
                                })
                            }),
                            links.map(({ key: key, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)($78ec93d066091426$var$SubnavLink, {
                                    productKey: productKey,
                                    ...rest
                                }, key))
                        ]
                    }, `section-${key}`))
            })
        ]
    });
};

});
parcelRegister("kxzNq", function(module, exports) {
$parcel$export(module.exports, "RovoSection", function () { return $a297aad2e5a415c0$export$58f6a9c112528b0e; });
/* rovo-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");
const $a297aad2e5a415c0$var$rovoSectionStyles = null;
const $a297aad2e5a415c0$var$rovoTitleStyles = null;
const $a297aad2e5a415c0$var$rovoDescriptionStyles = null;
const $a297aad2e5a415c0$var$rovoLogoContainerStyles = null;
const $a297aad2e5a415c0$export$58f6a9c112528b0e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $jQ0cd.useLocalizedHref)('/software/rovo'),
        target: "_blank",
        rel: "noreferrer",
        "data-product-key": "rovo",
        "data-event-component": "linkButton",
        "data-event-container": "globalNavSubnav",
        "data-event": "clicked",
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt41lhf _18s8ppv5 _2rko1ylz _19itn5xp _16qs1mzg _v5648uld _1dbz130s _15paidpf _qwozidpf _8fz6eo28 _6ssj2ex7"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $bNzAT.default)('corner.radius.card')),
            "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _zulppxbi _2osn1crf _wkq4xy5q _rulpxy5q _19ekxy5q"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                    brand: "rovo",
                    type: "mark",
                    appearance: "brand",
                    width: 36,
                    height: 36
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_1hgn1ule _nk1ipxbi _yx871pd9 _10yykb7n _1548idpf _1fgpidpf _lg2qidpf _pnsridpf _1ywu1pfd",
                        "rovo-title"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                    },
                    children: "Rovo"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_12qgidpf _sk0uidpf _18m0idpf _1h2iidpf _1tna1qc2 _15kooxwj _qhbnnqt0",
                        "rovo-description"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light800'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "GlobalNav.RovoSection.Title",
                        defaultMessage: "AI-powered apps \u2013 driven by your team's knowledge."
                    })
                })
            ]
        })
    });
};

});

parcelRegister("czH8Q", function(module, exports) {
$parcel$export(module.exports, "GlobalNavProductRecommendations", function () { return $d1b27165a9a04f99$export$3317373a678672ee; });
/* global-nav-product-recommendations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6iKF0 = parcelRequire("6iKF0");

var $cIsCk = parcelRequire("cIsCk");

var $bvLTq = parcelRequire("bvLTq");

var $8v5Z4 = parcelRequire("8v5Z4");

var $eGkHJ = parcelRequire("eGkHJ");

var $j26f4 = parcelRequire("j26f4");
const $d1b27165a9a04f99$var$GlobalNavProductRecommendationsImplementation = ({ isMobile: isMobile })=>{
    const { recommendations: recommendations, isRecommendationLoading: isRecommendationLoading } = (0, $1oC0p.useContext)((0, $bvLTq.NavProductRecommendationsContext));
    const recommendedProductIds = recommendations.map((ccpId)=>(0, $cIsCk.ccpKeyToProductId)[ccpId]).filter(Boolean);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulputpp _1tkelti4",
            !isMobile && "_zulpxy5q _1q511jfw _85i51jfw _bozgxy5q _y4ti1jfw"
        ]),
        children: [
            isRecommendationLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j26f4.SkeletonGrid), {
                numProducts: (0, $cIsCk.NUM_DISPLAY_RECOMMENDATIONS),
                isMobile: isMobile
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eGkHJ.ProductRecommendationsContainer), {
                recommendedProductIds: recommendedProductIds,
                isMobile: isMobile
            }),
            isRecommendationLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j26f4.SkeletonGrid), {
                numProducts: 3,
                isMobile: isMobile
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8v5Z4.NewProductsContainer), {
                excludedProducts: recommendedProductIds,
                isMobile: isMobile
            })
        ]
    });
};
const $d1b27165a9a04f99$export$3317373a678672ee = ({ isMobile: isMobile = false })=>{
    const { onGlobalNavProductRecommendationsFailed: onGlobalNavProductRecommendationsFailed } = (0, $1oC0p.useContext)((0, $bvLTq.NavProductRecommendationsContext));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
        fallback: null,
        onError: onGlobalNavProductRecommendationsFailed,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($d1b27165a9a04f99$var$GlobalNavProductRecommendationsImplementation, {
            isMobile: isMobile
        })
    });
};

});
parcelRegister("6iKF0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $917a9f367b5b7366$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $i0bD5 = parcelRequire("i0bD5");
class $917a9f367b5b7366$export$2e2bcd8739ae039 extends (0, $1oC0p.Component) {
    constructor(props){
        super(props), /** In the event that we only want to show a fallback for a specific error,
   * we can pass a function to shouldShowFallback that will determine if the fallback should be shown
   * Returns true if shouldShowFallback is not provided or if the function returns true
   **/ this.shouldRenderFallback = ()=>{
            if (!this.state.error) return false;
            if (!this.props.shouldShowFallback) return true;
            return this.props.shouldShowFallback(this.state.error);
        };
        this.state = {};
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Call onError callback if provided
        this.props.onError?.(error, info);
        // Log the error
        (0, $i0bD5.Helpers).sendWrapperLoadError(error.message, info.componentStack ?? undefined);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        if (this.shouldRenderFallback()) return fallback;
        return children;
    }
}

});

parcelRegister("cIsCk", function(module, exports) {
$parcel$export(module.exports, "ccpKeyToProductId", function () { return $93e6b21380fdce81$export$cab6f2e2bea54493; });
$parcel$export(module.exports, "NUM_DISPLAY_RECOMMENDATIONS", function () { return $93e6b21380fdce81$export$48153fdb47027133; });
$parcel$export(module.exports, "NUM_DISPLAY_NEW_PRODUCTS", function () { return $93e6b21380fdce81$export$d5d57039edb427b6; });
const $93e6b21380fdce81$export$8c4b34997a57bbe6 = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $93e6b21380fdce81$export$53249da30dded4df = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $93e6b21380fdce81$export$195fe00ecf4255b = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $93e6b21380fdce81$export$1634dd7b92b44267 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $93e6b21380fdce81$export$c9645048cb6236bb = 'fbc7e14b-2f9c-45a9-9bcb-3993a4eac0ce';
const $93e6b21380fdce81$export$cab6f2e2bea54493 = {
    [$93e6b21380fdce81$export$1634dd7b92b44267]: 'jira',
    [$93e6b21380fdce81$export$195fe00ecf4255b]: 'confluence',
    [$93e6b21380fdce81$export$8c4b34997a57bbe6]: 'jsm',
    [$93e6b21380fdce81$export$53249da30dded4df]: 'jpd',
    [$93e6b21380fdce81$export$c9645048cb6236bb]: 'csm'
};
const $93e6b21380fdce81$export$48153fdb47027133 = 2;
const $93e6b21380fdce81$export$d5d57039edb427b6 = 4;

});

parcelRegister("bvLTq", function(module, exports) {
$parcel$export(module.exports, "NavProductRecommendationsContext", function () { return $92d824f521304c1c$export$f08ef568e4cd62e3; });

var $1oC0p = parcelRequire("1oC0p");
const $92d824f521304c1c$var$noop = ()=>{
// do nothing
};
const $92d824f521304c1c$export$f08ef568e4cd62e3 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    onGlobalNavProductRecommendationsFailed: $92d824f521304c1c$var$noop,
    shouldShowGlobalNavProductRecommendations: false,
    recommendations: [],
    isRecommendationLoading: false,
    mobileNavPageLabelFeaturedProducts: '',
    fireGlobalNavProductRecoEventsWhenInView: $92d824f521304c1c$var$noop
});

});

parcelRegister("8v5Z4", function(module, exports) {
$parcel$export(module.exports, "NewProductsContainer", function () { return $97b38d766be60fb5$export$ad1d3bb1d128b2fe; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hupQs = parcelRequire("hupQs");

var $cIsCk = parcelRequire("cIsCk");

var $R6IAB = parcelRequire("R6IAB");
const $97b38d766be60fb5$var$title = (0, $fnHPc.defineMessage)({
    id: 'globalnav.v2.products.featured.new',
    defaultMessage: 'New products'
});
const $97b38d766be60fb5$export$ad1d3bb1d128b2fe = ({ excludedProducts: excludedProducts, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $hupQs.useProductData)();
    const products = (0, $1oC0p.useMemo)(()=>productsByTag[(0, $hupQs.ProductCategory).Featured].filter((product)=>product.treatment === (0, $hupQs.Treatment).New).filter(({ id: id })=>!excludedProducts.includes(id)).slice(0, (0, $cIsCk.NUM_DISPLAY_NEW_PRODUCTS)), [
        productsByTag,
        excludedProducts
    ]);
    if (products.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $R6IAB.ProductsGrid), {
        products: products,
        title: formatMessage($97b38d766be60fb5$var$title),
        isMobile: isMobile,
        container: 'NewProductsContainer'
    });
};

});
parcelRegister("hupQs", function(module, exports) {
$parcel$export(module.exports, "ProductCategory", function () { return $4d2b589493338094$export$81fb35662c98d436; });
$parcel$export(module.exports, "Treatment", function () { return $4d2b589493338094$export$abc76b16efda437; });
$parcel$export(module.exports, "categories", function () { return $4d2b589493338094$export$2c76aca27257bcfa; });
$parcel$export(module.exports, "useProductData", function () { return $4d2b589493338094$export$59dc636aee1f545e; });
$parcel$export(module.exports, "Pill", function () { return $4d2b589493338094$export$d2cf3038149dd1b5; });
$parcel$export(module.exports, "ProductItem", function () { return $4d2b589493338094$export$38dd9abaed3bfffb; });
$parcel$export(module.exports, "ProductGrid", function () { return $4d2b589493338094$export$e17b9f4149d989a1; });
$parcel$export(module.exports, "ProductSubnav", function () { return $4d2b589493338094$export$14e06e14f1d7e1b8; });
/* product-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $jsxHL = parcelRequire("jsxHL");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $8nFt2 = parcelRequire("8nFt2");

var $kxzNq = parcelRequire("kxzNq");

var $czH8Q = parcelRequire("czH8Q");

var $bvLTq = parcelRequire("bvLTq");

var $6BzCS = parcelRequire("6BzCS");

var $9KOR3 = parcelRequire("9KOR3");

var $avq6k = parcelRequire("avq6k");
const $4d2b589493338094$export$81fb35662c98d436 = {
    Featured: 0,
    Developers: 1,
    ProductManagers: 2,
    ITProfessionals: 3,
    BusinessTeams: 4,
    LeadershipTeams: 5
};
const $4d2b589493338094$export$abc76b16efda437 = {
    New: 0,
    Pending: 1
};
const $4d2b589493338094$export$2c76aca27257bcfa = {
    [$4d2b589493338094$export$81fb35662c98d436.Featured]: {
        id: $4d2b589493338094$export$81fb35662c98d436.Featured,
        title: (0, $fnHPc.defineMessage)({
            id: 'globalnav.v2.products.tabs.everyone',
            defaultMessage: 'Featured'
        })
    },
    [$4d2b589493338094$export$81fb35662c98d436.Developers]: {
        id: $4d2b589493338094$export$81fb35662c98d436.Developers,
        title: (0, $fnHPc.defineMessage)({
            id: 'globalnav.v2.products.tabs.developers',
            defaultMessage: 'Developers'
        })
    },
    [$4d2b589493338094$export$81fb35662c98d436.ProductManagers]: {
        id: $4d2b589493338094$export$81fb35662c98d436.ProductManagers,
        title: (0, $fnHPc.defineMessage)({
            id: 'globalnav.v2.products.tabs.product-managers',
            defaultMessage: 'Product Managers'
        })
    },
    [$4d2b589493338094$export$81fb35662c98d436.ITProfessionals]: {
        id: $4d2b589493338094$export$81fb35662c98d436.ITProfessionals,
        title: (0, $fnHPc.defineMessage)({
            id: 'globalnav.v2.products.tabs.it-professionals',
            defaultMessage: 'IT professionals'
        })
    },
    [$4d2b589493338094$export$81fb35662c98d436.BusinessTeams]: {
        id: $4d2b589493338094$export$81fb35662c98d436.BusinessTeams,
        title: (0, $fnHPc.defineMessage)({
            id: 'globalnav.v2.products.tabs.business-teams',
            defaultMessage: 'Business Teams'
        })
    },
    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: {
        id: $4d2b589493338094$export$81fb35662c98d436.LeadershipTeams,
        title: (0, $fnHPc.defineMessage)({
            id: 'globalnav.v2.products.tabs.leadership-teams',
            defaultMessage: 'Leadership Teams'
        })
    }
};
function $4d2b589493338094$export$59dc636aee1f545e() {
    const { locale: locale } = (0, $8e22h.default)();
    const sunsetCompass = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp1072SunsetCompass);
    const showProductCollections = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9582ProductCollection);
    const loomUrl = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacProductsLoomURL) ? '/software/loom' : '//loom.com';
    // we could move this to top of the module, but expecting this structure will
    // be derived from dynamic data at some point
    const products = (0, $1oC0p.useMemo)(()=>{
        return {
            jira: {
                id: 'jira',
                name: 'Jira',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.jira.description',
                    defaultMessage: 'Flexible project management'
                }),
                href: '/software/jira',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Developers,
                    $4d2b589493338094$export$81fb35662c98d436.ProductManagers,
                    $4d2b589493338094$export$81fb35662c98d436.BusinessTeams
                ],
                logo: 'jira',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: 1,
                    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: 2,
                    [$4d2b589493338094$export$81fb35662c98d436.ProductManagers]: 2
                },
                customHref: {
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: '/software/jira/dev'
                }
            },
            confluence: {
                id: 'confluence',
                name: 'Confluence',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.confluence.description',
                    defaultMessage: 'Knowledge, all in one place'
                }),
                href: '/software/confluence',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.ProductManagers,
                    $4d2b589493338094$export$81fb35662c98d436.BusinessTeams
                ],
                logo: 'confluence',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: 4,
                    [$4d2b589493338094$export$81fb35662c98d436.ProductManagers]: 3
                }
            },
            jsm: {
                id: 'jsm',
                name: 'Jira Service Management',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.jsm.description',
                    defaultMessage: 'Deliver service at high velocity'
                }),
                href: '/software/jira/service-management',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.ITProfessionals,
                    $4d2b589493338094$export$81fb35662c98d436.BusinessTeams
                ],
                logo: 'jiraservicemanagement',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.BusinessTeams]: 5
                }
            },
            customerservicemanagement: {
                id: 'customerservicemanagement',
                name: 'Customer Service Management',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.customerservicemanagement.description',
                    defaultMessage: 'Customer experiences reimagined'
                }),
                href: '/software/customer-service-management',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.BusinessTeams
                ],
                logo: 'customerservicemanagement',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.BusinessTeams]: 6
                }
            },
            trello: {
                id: 'trello',
                name: 'Trello',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.trello.description',
                    defaultMessage: 'Capture and organize your tasks'
                }),
                href: '//trello.com/home',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.BusinessTeams
                ],
                logo: 'trello'
            },
            rovo: {
                id: 'rovo',
                name: 'Rovo',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.rovo.description',
                    defaultMessage: 'Transform teamwork with AI'
                }),
                href: `/software/rovo`,
                tags: [],
                logo: 'rovo'
            },
            jpd: {
                id: 'jpd',
                name: 'Jira Product Discovery',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.jpd.description',
                    defaultMessage: 'Capture & prioritize ideas'
                }),
                href: '/software/jira/product-discovery',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.ProductManagers
                ],
                logo: 'jiraproductdiscovery',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.ProductManagers]: 1
                }
            },
            compass: {
                id: 'compass',
                name: 'Compass',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.compass.description',
                    defaultMessage: 'Software catalog for teams'
                }),
                href: '/software/compass',
                tags: sunsetCompass ? [] : [
                    $4d2b589493338094$export$81fb35662c98d436.Developers
                ],
                logo: 'compass',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: 6
                }
            },
            guard: {
                id: 'guard',
                name: 'Guard',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.guard.description',
                    defaultMessage: 'Enhanced cloud security'
                }),
                href: '/software/guard',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.ITProfessionals
                ],
                logo: 'guard'
            },
            loom: {
                id: 'loom',
                name: 'Loom',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.loom.description',
                    defaultMessage: 'Quick, async video updates'
                }),
                href: loomUrl,
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.BusinessTeams
                ],
                logo: 'loom',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: 6
                }
            },
            bitbucket: {
                id: 'bitbucket',
                name: 'Bitbucket',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.bitbucket.description',
                    defaultMessage: 'Source code and CI/CD'
                }),
                href: '/software/bitbucket',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Developers
                ],
                logo: 'bitbucket',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: 2
                }
            },
            jiraalign: {
                id: 'jiraalign',
                name: 'Align',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.jiraalign.description',
                    defaultMessage: 'Enterprise-wide work planning & value'
                }),
                href: '/software/jira/align',
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.LeadershipTeams
                ],
                logo: 'jiraalign',
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: 3
                }
            },
            focus: {
                id: 'focus',
                logo: 'focus',
                href: '/software/focus',
                name: 'Focus',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.focus.description',
                    defaultMessage: 'Enterprise-scale strategic planning'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.LeadershipTeams
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: 1
                }
            },
            talent: {
                id: 'talent',
                logo: 'talent',
                href: '/software/talent',
                name: 'Talent',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.talent.description',
                    defaultMessage: 'Knowledge workforce planning'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.LeadershipTeams
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: 2
                }
            },
            dx: {
                id: 'dx',
                logo: 'dx',
                href: '/collections/software',
                name: 'DX',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.dx.description',
                    defaultMessage: 'Measure productivity and AI impact'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Developers
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: 5
                }
            },
            pipelines: {
                id: 'pipelines',
                logo: 'pipelines',
                href: '/software/bitbucket/features/pipelines',
                name: 'Pipelines',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.pipelines.description',
                    defaultMessage: 'Scalable CI/CD automation'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Developers
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: 4
                }
            },
            rovodev: {
                id: 'rovodev',
                logo: 'rovodev',
                href: '/software/rovo-dev',
                name: 'Rovo Dev',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.rovodev.description',
                    defaultMessage: 'Agentic AI for developers'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Developers
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: 3
                }
            },
            collectionteamwork: {
                id: 'collectionteamwork',
                logo: 'collectionteamwork',
                href: '/collections/teamwork',
                name: 'Teamwork Collection',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.collectionteamwork.description',
                    defaultMessage: 'Supercharge teamwork seamlessly'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Featured,
                    $4d2b589493338094$export$81fb35662c98d436.ProductManagers,
                    $4d2b589493338094$export$81fb35662c98d436.BusinessTeams
                ],
                isCollection: true,
                associatedProducts: [
                    'Jira',
                    'Confluence',
                    'Loom'
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.ProductManagers]: 5,
                    [$4d2b589493338094$export$81fb35662c98d436.BusinessTeams]: 7
                }
            },
            collectionstrategy: {
                id: 'collectionstrategy',
                logo: 'collectionstrategy',
                href: '/collections/strategy',
                name: 'Strategy Collection',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.collectionstrategy.description',
                    defaultMessage: 'Optimize strategy and outcomes confidently'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Featured,
                    $4d2b589493338094$export$81fb35662c98d436.LeadershipTeams
                ],
                isCollection: true,
                associatedProducts: [
                    'Focus',
                    'Talent',
                    'Align'
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: 5
                }
            },
            collectionservice: {
                id: 'collectionservice',
                logo: 'collectionservice',
                href: '/collections/service',
                name: 'Service Collection',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.collectionservice.description',
                    defaultMessage: 'Deliver service at high-velocity'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Featured
                ],
                isCollection: true,
                associatedProducts: [
                    'Jira Service Management',
                    'Customer Service Management',
                    'Assets'
                ],
                order: {}
            },
            collectionsoftware: {
                id: 'collectionsoftware',
                logo: 'collectionsoftware',
                href: '/collections/software',
                name: 'Software Collection',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.collectionsoftware.description',
                    defaultMessage: 'Ship high-quality software fast'
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.Featured,
                    $4d2b589493338094$export$81fb35662c98d436.Developers
                ],
                isCollection: true,
                associatedProducts: sunsetCompass ? [
                    'Rovo Dev',
                    'DX',
                    'Pipelines',
                    'Bitbucket'
                ] : [
                    'Rovo Dev',
                    'DX',
                    'Pipelines',
                    'Bitbucket',
                    'Compass'
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: 7
                }
            },
            collectionproduct: {
                id: 'collectionproduct',
                logo: 'collectionproduct',
                href: '/collections/product',
                name: 'Product Collection',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.collectionproduct.description',
                    defaultMessage: 'Build products with confidence'
                }),
                tags: showProductCollections ? [
                    $4d2b589493338094$export$81fb35662c98d436.Featured,
                    $4d2b589493338094$export$81fb35662c98d436.ProductManagers
                ] : [],
                isCollection: true,
                associatedProducts: [
                    'Jira Product Discovery',
                    'Feedback',
                    'Rovo'
                ],
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.Featured]: 5,
                    [$4d2b589493338094$export$81fb35662c98d436.ProductManagers]: 6
                }
            },
            blankspace: {
                id: 'blankspace',
                name: '',
                logo: 'jira',
                href: '',
                description: (0, $fnHPc.defineMessage)({
                    id: 'globalnav.v2.products.blankspace.description',
                    defaultMessage: ''
                }),
                tags: [
                    $4d2b589493338094$export$81fb35662c98d436.ProductManagers,
                    $4d2b589493338094$export$81fb35662c98d436.LeadershipTeams,
                    $4d2b589493338094$export$81fb35662c98d436.Developers
                ],
                isBlankSpace: true,
                order: {
                    [$4d2b589493338094$export$81fb35662c98d436.ProductManagers]: 4,
                    [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: 4,
                    [$4d2b589493338094$export$81fb35662c98d436.Developers]: sunsetCompass ? 6 : 8
                }
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locale
    ]);
    // eslint-disable-next-line complexity
    const productsByTag = (0, $1oC0p.useMemo)(()=>{
        const productsByTag = Object.values(products).reduce((acc, product)=>{
            product.tags.forEach((tag)=>{
                acc[tag] = acc[tag].concat(product);
            });
            return acc;
        }, {
            [$4d2b589493338094$export$81fb35662c98d436.Featured]: [],
            [$4d2b589493338094$export$81fb35662c98d436.Developers]: [],
            [$4d2b589493338094$export$81fb35662c98d436.ProductManagers]: [],
            [$4d2b589493338094$export$81fb35662c98d436.ITProfessionals]: [],
            [$4d2b589493338094$export$81fb35662c98d436.BusinessTeams]: [],
            [$4d2b589493338094$export$81fb35662c98d436.LeadershipTeams]: []
        });
        for(const key in productsByTag)productsByTag[key].sort((a, b)=>{
            const categoryKey = key;
            const aOrder = a.order && categoryKey in a.order ? a.order[categoryKey] ?? 0 : 0;
            const bOrder = b.order && categoryKey in b.order ? b.order[categoryKey] ?? 0 : 0;
            return aOrder - bOrder;
        });
        return productsByTag;
    }, [
        products
    ]);
    return {
        products: products,
        productsByTag: productsByTag
    };
}
const $4d2b589493338094$export$f01a785a5ae81e49 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_k48p8ydi _syaz1qc2 _1wyboqnp"
        ]),
        style: {
            "--_1fww9ud": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light800'))
        },
        children: intl.formatMessage({
            id: 'globalnav.treatment.pending',
            defaultMessage: '(Pending acquisition)'
        })
    });
};
const $4d2b589493338094$export$d2cf3038149dd1b5 = ({ color: color = (0, $bNzAT.default)('color.secondary.navy'), backgroundColor: backgroundColor = (0, $bNzAT.default)('color.extended.blue200'), children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            color: color,
            backgroundColor: backgroundColor
        },
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _18zri2wt _1rjcyh40 _2rko1tcg"
        ]),
        children: children
    });
};
const $4d2b589493338094$var$treatments = {
    [$4d2b589493338094$export$abc76b16efda437.New]: /*#__PURE__*/ (0, $7VQPk.jsx)($4d2b589493338094$export$d2cf3038149dd1b5, {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_1wyb19bv _k48p1fw0 _1p1dangw"
            ]),
            children: "New"
        })
    }),
    [$4d2b589493338094$export$abc76b16efda437.Pending]: /*#__PURE__*/ (0, $7VQPk.jsx)($4d2b589493338094$export$f01a785a5ae81e49, {})
};
const $4d2b589493338094$var$productItemCss = null;
const $4d2b589493338094$var$associatedProductsCss = null;
const $4d2b589493338094$export$38dd9abaed3bfffb = ({ id: id, logo: logo, name: name, treatment: treatment, isCollection: isCollection, description: description, href: href, associatedProducts: associatedProducts, isBlankSpace: isBlankSpace, customHref: customHref, currentCategory: currentCategory })=>{
    const intl = (0, $8e22h.default)();
    // Use customHref for the current category if available, otherwise fall back to default href
    const effectiveHref = currentCategory !== undefined && customHref?.[currentCategory] ? customHref[currentCategory] : href;
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(effectiveHref);
    const formattedHref = (0, $jQ0cd.isLocalizableHref)(effectiveHref) ? localizedHref : effectiveHref;
    if (isBlankSpace) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: "blank-space",
        children: "\xa0"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        id: id,
        className: (0, $2jatx.default)([
            "_1e0c1txw _p12feo28 _1q511ejb _85i51ejb _1kav1ady _1tfx1ady _1hsl1vau _fkleidpf _fjkoidpf _1okhidpf _180nidpf _vp0w1crf _upjw1nn1 _1tt11qc2 _1mx24jg8 _4e9q1wug _xkllidpf _1ljc1wug _1lwo1wug _f13oz4z1 _q1y3oxwj _nmeukb7n _1onl1txw _1sxn1q9c _1y4yesu3 _179nidpf _118qidpf _1goeidpf _m45bidpf _fmax1pfd",
            isCollection ? 'collection-container' : ''
        ]),
        style: {
            "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display')),
            "--_1fww9ud": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light800')),
            "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1h6o _1cspu5k9 _vladg7ng _1r1p1ejb _i2ip1osq _owkr1ylz _16oj1bp4 _61gx1y6m _1qah1mzg _15m28uld _5cs9130s",
                isCollection ? 'collection-link' : ''
            ]),
            href: formattedHref,
            target: (0, $jQ0cd.isLocalizableHref)(href) ? '' : '_blank',
            rel: (0, $jQ0cd.isLocalizableHref)(href) ? '' : 'noreferrer',
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavSubnav",
            "data-product-key": id,
            style: {
                "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700')),
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light100')),
                "--_6td02k": (0, $6ZVlx.default)((0, $bNzAT.default)('corner.radius.card'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _12l2utpp _2rko1y44 _1wpz1q9y",
                        "logo-container"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                        brand: logo,
                        type: "mark",
                        appearance: "brand",
                        width: isCollection ? undefined : 32,
                        height: isCollection ? undefined : 32
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulp12x7",
                        "product-description-container"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "product-header",
                            children: [
                                !isCollection && /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                    className: (0, $2jatx.default)([
                                        "_12l2i2wt"
                                    ]),
                                    children: name
                                }),
                                typeof treatment !== 'undefined' ? $4d2b589493338094$var$treatments[treatment] : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: "product-description",
                            children: intl.formatMessage(description)
                        }),
                        isCollection && associatedProducts && associatedProducts.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1wyboqnp _vwz4nqt0 _ect4z4z1 _syaz1qc2 _1sazb3bt _w5s7nkob _19dh1o8l _5hf0idpf _1o48idpf _1xgi1ssb _qpoiidpf _dzmf14y2 _1buc1y44 _1vfv14y2 _oyket7zv"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text')),
                                "--_1fww9ud": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light800'))
                            },
                            children: associatedProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: product
                                }, product))
                        })
                    ]
                })
            ]
        })
    });
};
const $4d2b589493338094$export$e17b9f4149d989a1 = ({ children: children, isRovoTitle: isRovoTitle, header: header })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                // The inline (left/right) padding here must stay in sync with
                // the inline padding the inner <ul> previously had — both the
                // optional `header` (e.g. recommendations + section heading on
                // the Featured tab) and the product list need to share the
                // same horizontal alignment with the rest of the subnav.
                className: (0, $2jatx.default)([
                    "_18zr1lqf _1q511jfw _1bhl1nty _xc2iidpf"
                ]),
                children: [
                    header,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _yv0ewxkt _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _gy1p1ejb _85i51ejb _1mjb1txw _na0i1bp4"
                        ]),
                        children: children
                    })
                ]
            }),
            isRovoTitle && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1p1dangw _1wyboqnp _18s8ergx _17p312pl"
                ]),
                children: intl.formatMessage({
                    id: 'GlobalNav.RovoSection.PoweredBy',
                    defaultMessage: 'Powered by'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kxzNq.RovoSection), {})
        ]
    });
};
const $4d2b589493338094$var$FeaturedTemplate = (props)=>{
    if (props.isCollections) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $avq6k.ProductFeaturedCollectionSubnav), {
        isMobile: false
    });
    else if (props.isRecs) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $czH8Q.GlobalNavProductRecommendations), {});
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
};
const $4d2b589493338094$export$14e06e14f1d7e1b8 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = $4d2b589493338094$export$59dc636aee1f545e();
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    const { shouldShowGlobalNavProductRecommendations: shouldShowGlobalNavProductRecommendations, fireGlobalNavProductRecoEventsWhenInView: fireGlobalNavProductRecoEventsWhenInView } = (0, $1oC0p.useContext)((0, $bvLTq.NavProductRecommendationsContext));
    const featuredProductIndex = (0, $1oC0p.useMemo)(()=>Object.values($4d2b589493338094$export$2c76aca27257bcfa).findIndex((category)=>category.id === $4d2b589493338094$export$81fb35662c98d436.Featured), []);
    const onTabInView = (0, $1oC0p.useCallback)((index)=>{
        if (featuredProductIndex === index) fireGlobalNavProductRecoEventsWhenInView({
            isMobile: false
        });
    }, [
        featuredProductIndex,
        fireGlobalNavProductRecoEventsWhenInView
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
            direction: direction,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6BzCS.SubnavWithSidebarTabs), {
                tabs: Object.values($4d2b589493338094$export$2c76aca27257bcfa).map((category)=>{
                    return {
                        id: category.id.toString(),
                        title: intl.formatMessage(category.title),
                        content: category.id === $4d2b589493338094$export$81fb35662c98d436.Featured ? /*#__PURE__*/ (0, $7VQPk.jsx)($4d2b589493338094$var$FeaturedTemplate, {
                            isRecs: shouldShowGlobalNavProductRecommendations,
                            isCollections: true
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)($4d2b589493338094$export$e17b9f4149d989a1, {
                            children: productsByTag[category.id].map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)($4d2b589493338094$export$38dd9abaed3bfffb, {
                                    ...product,
                                    currentCategory: category.id
                                }, product.id))
                        })
                    };
                }),
                onTabInView: onTabInView,
                links: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_nd5l1p4q _1e0c1txw _4cvr1h6o _4t3i1ris _bozg1jfw _y4tipxbi"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_bozgpxbi _19tbdlk8"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            href: (0, $jQ0cd.useLocalizedHref)('/software'),
                            text: intl.formatMessage({
                                id: 'globalnav.v2.subnav.tabs.see-all-apps',
                                defaultMessage: 'See all apps'
                            }),
                            "aria-label": intl.formatMessage({
                                id: 'globalnav.v2.subnav.tabs.see-all-apps-arialabel',
                                defaultMessage: 'See all apps link'
                            }),
                            ariaLabel: intl.formatMessage({
                                id: 'globalnav.v2.subnav.tabs.see-all-apps-arialabel',
                                defaultMessage: 'See all apps link'
                            }),
                            dataEventProps: {
                                'data-product-key': productKey,
                                'data-event-component': 'linkButton',
                                'data-event-container': 'navbarDropdown',
                                'data-label': 'See all products',
                                'data-event': 'clicked'
                            },
                            type: "primary"
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("8nFt2", function(module, exports) {
$parcel$export(module.exports, "MotionContainer", function () { return $e4df3f77a9b54f09$export$4dd9dde56f290330; });
/* motion-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $e4df3f77a9b54f09$var$slideUpKeyframes = null;
const $e4df3f77a9b54f09$var$slideDownKeyframes = null;
const $e4df3f77a9b54f09$var$slideRightKeyframes = null;
const $e4df3f77a9b54f09$var$slideLeftKeyframes = null;
function $e4df3f77a9b54f09$export$305f7d4e9d4624f2(collection, predicate) {
    for(let i = 0; i < collection.length; i++){
        const item = collection[i];
        if (predicate(item)) return i;
    }
    return -1;
}
const $e4df3f77a9b54f09$export$4dd9dde56f290330 = ({ direction: direction = 'up', children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            direction === 'left' && "",
            direction === 'left' && "_j7hq5r0o",
            direction === 'right' && "",
            direction === 'right' && "_j7hq11sw",
            direction === 'up' && "",
            direction === 'up' && "_j7hq1dic",
            direction === 'down' && "",
            direction === 'down' && "_j7hqw29o",
            "_5sag1doz"
        ]),
        children: children
    });
};

});

parcelRegister("6BzCS", function(module, exports) {
$parcel$export(module.exports, "SubnavWithSidebarTabs", function () { return $7427ee589d78598f$export$1908a6b6f2723c34; });
/* subnav-with-sidebar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $7427ee589d78598f$var$useSafeLayoutEffect = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);
const $7427ee589d78598f$var$tabContainerStyles = null;
const $7427ee589d78598f$var$tablistWrapperStyle = null;
const $7427ee589d78598f$var$tablistStyles = null;
const $7427ee589d78598f$var$tabpanelStyles = null;
function $7427ee589d78598f$var$isValidTab(tabs, index) {
    return Array.isArray(tabs) && index > -1 && index < tabs.length;
}
function $7427ee589d78598f$var$noop() {
    return false;
}
function $7427ee589d78598f$var$useEventHandler({ previous: previous = $7427ee589d78598f$var$noop, next: next = $7427ee589d78598f$var$noop, select: select = $7427ee589d78598f$var$noop, deleteFocus: deleteFocus = $7427ee589d78598f$var$noop }) {
    const keyMap = {
        ArrowUp: (start)=>previous(start),
        ArrowDown: (start)=>next(start),
        Delete: (panel)=>deleteFocus(panel)
    };
    return {
        createOnClick: (index)=>(_evt)=>select(index),
        createOnKeyDown: (index)=>{
            return (evt)=>{
                const moveAction = keyMap[evt.key];
                if (!moveAction) return;
                const next = moveAction(index);
                if (next === false) return;
                evt.preventDefault();
                if (typeof next !== 'undefined' && typeof next !== 'boolean') select(next);
            };
        }
    };
}
const $7427ee589d78598f$var$tabStyle = null;
const $7427ee589d78598f$var$activeTabStyle = null;
const $7427ee589d78598f$var$Tab = ({ tab: tab, onClick: onClick, onKeyDown: onKeyDown, isActive: isActive, isFocused: isFocused })=>{
    const { id: id, title: title } = tab;
    const tabRef = (0, $1oC0p.useRef)(null);
    $7427ee589d78598f$var$useSafeLayoutEffect(()=>{
        if (isFocused && tabRef.current) tabRef.current.focus();
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: `tab-${id}`,
        ref: tabRef,
        role: "tab",
        onClick: onClick,
        onKeyDown: onKeyDown,
        "aria-selected": isActive,
        "aria-controls": `panel-${id}`,
        tabIndex: isActive ? 0 : -1,
        className: (0, $2jatx.default)([
            "_bfhk1kw7 _syaz1pfd _1e0c1txw _bozgpxbi _y4tixy5q _1q51utpp _85i5utpp _1wybdlk8 _k48p1fw0 _ojc91afi _80omtlke _2rkodjii _1bsbntd2",
            isActive && "_bfhk1afi _syaz5hrz"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            children: title
        })
    });
};
const $7427ee589d78598f$export$1908a6b6f2723c34 = ({ tabs: tabs, links: links, defaultTab: defaultTab = 0, onTabInView: onTabInView })=>{
    const intl = (0, $8e22h.default)();
    const containerRef = (0, $1oC0p.useRef)(null);
    const [activeTabIndex, setActiveTabIndex] = (0, $1oC0p.useState)(()=>{
        if ($7427ee589d78598f$var$isValidTab(tabs, defaultTab)) return defaultTab;
        return 0;
    });
    const [focusTab, setFocusTab] = (0, $1oC0p.useState)();
    const selectFocusableTab = (tab)=>{
        let nextTab = 0;
        if (tab < tabs.length) nextTab = tab;
        else if (tab - 2 >= 0) nextTab = tab - 2;
        setActiveTabIndex(nextTab);
        setFocusTab(nextTab);
    };
    const { createOnClick: createOnClick, createOnKeyDown: createOnKeyDown } = $7427ee589d78598f$var$useEventHandler({
        previous: (start)=>{
            const nextIndex = start - 1;
            return $7427ee589d78598f$var$isValidTab(tabs, nextIndex) ? nextIndex : tabs.length - 1;
        },
        next: (start)=>{
            const nextIndex = start + 1;
            return $7427ee589d78598f$var$isValidTab(tabs, nextIndex) ? nextIndex : 0;
        },
        select: selectFocusableTab
    });
    // Observes the tab container to determine when a tab is in view
    (0, $1oC0p.useLayoutEffect)(()=>{
        // Check if IntersectionObserver is supported
        if (typeof IntersectionObserver === 'undefined') return;
        if (!onTabInView) return;
        const currentContainer = containerRef.current;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry?.isIntersecting) onTabInView(activeTabIndex);
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        });
        if (currentContainer) observer.observe(currentContainer);
        return ()=>{
            if (currentContainer) observer.unobserve(currentContainer);
        };
    }, [
        activeTabIndex,
        onTabInView,
        tabs
    ]);
    // Handle Backspace key at document level to catch events from all children
    (0, $1oC0p.useEffect)(()=>{
        const handleDocumentKeyDown = (event)=>{
            if (!(event instanceof KeyboardEvent)) return;
            const keyboardEvent = event;
            if (keyboardEvent.key === 'Backspace' && containerRef.current?.contains(event.target)) {
                const nextTabIndex = activeTabIndex == tabs.length - 1 ? activeTabIndex - 1 : activeTabIndex + 1;
                setActiveTabIndex(nextTabIndex);
                setFocusTab(nextTabIndex);
                keyboardEvent.preventDefault();
                keyboardEvent.stopPropagation();
            }
        };
        document.addEventListener('keydown', handleDocumentKeyDown, true);
        return ()=>{
            document.removeEventListener('keydown', handleDocumentKeyDown, true);
        };
    }, [
        activeTabIndex,
        tabs.length
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1lmcyf54 _yv0e1ris _bfhkg7ng _ect4kipj"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light100'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_nd5l1p4q _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhkg7ng _1q511ylp _85i51ylp _4t3i1ris _1bsb194s _zulp1epz"
                ]),
                style: {
                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light100'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        role: "tablist",
                        "aria-label": intl.formatMessage({
                            id: 'globalnav.v2.subnav.tabs.aria-label-tablist',
                            defaultMessage: 'Products by user category'
                        }),
                        "aria-orientation": "vertical",
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _syaz1pfd _bozg1jfw"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                        },
                        children: tabs.map((tab, index)=>{
                            const isActive = index === activeTabIndex;
                            const isFocused = index === focusTab;
                            return /*#__PURE__*/ (0, $7VQPk.jsx)($7427ee589d78598f$var$Tab, {
                                isActive: isActive,
                                isFocused: isFocused,
                                tab: tab,
                                onClick: createOnClick(index),
                                onKeyDown: createOnKeyDown(activeTabIndex)
                            }, `key-${tab.id}`);
                        })
                    }),
                    links ?? null
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_nd5l15ve _bfhk1afi _kqswh2mm"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                },
                children: tabs.map((tab, index)=>{
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        id: `panel-${tab.id}`,
                        role: "tabpanel",
                        "aria-labelledby": `tab-${tab.id}`,
                        tabIndex: activeTabIndex === index ? -1 : undefined,
                        "aria-hidden": activeTabIndex !== index,
                        style: {
                            position: activeTabIndex == index ? 'static' : 'absolute',
                            insetBlockStart: '0',
                            height: '100%',
                            visibility: activeTabIndex == index ? 'visible' : 'hidden'
                        },
                        children: tab.content
                    }, index);
                })
            })
        ]
    });
};

});

parcelRegister("avq6k", function(module, exports) {
$parcel$export(module.exports, "ProductFeaturedCollectionSubnav", function () { return $df142c732e972eff$export$ae84f9fa7b9a83d2; });
/* product-featured-collection-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $2dsWk = parcelRequire("2dsWk");

var $hupQs = parcelRequire("hupQs");
const $df142c732e972eff$export$ae84f9fa7b9a83d2 = ({ isMobile: isMobile })=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $hupQs.useProductData)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "collections-container-with-rovo",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hupQs.ProductGrid), {
            isRovoTitle: true,
            header: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2dsWk.GlobalNavProductRecommendationsSimple), {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_hbu3oqnp _1ldiidpf _skt2idpf _emr2idpf _r1lidpf _14waangw _jwbz1pfd _1aky1nn1 _1d1f1n44 _1rnfgktf",
                            "collections-four"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                        },
                        children: intl.formatMessage({
                            id: 'GlobalNav.collections.featured.atlassiancollections.title',
                            defaultMessage: 'Atlassian Collections'
                        })
                    })
                ]
            }),
            children: productsByTag[(0, $hupQs.ProductCategory).Featured].map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hupQs.ProductItem), {
                    ...product,
                    currentCategory: (0, $hupQs.ProductCategory).Featured
                }, product.id))
        })
    });
};
const $df142c732e972eff$var$CollectionsTitle = null;

});
parcelRegister("2dsWk", function(module, exports) {
$parcel$export(module.exports, "GlobalNavProductRecommendationsSimple", function () { return $5460045e6dde061c$export$9eb7aff5460bd308; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $6iKF0 = parcelRequire("6iKF0");

var $cIsCk = parcelRequire("cIsCk");

var $bvLTq = parcelRequire("bvLTq");

var $eGkHJ = parcelRequire("eGkHJ");

var $j26f4 = parcelRequire("j26f4");
const $5460045e6dde061c$var$GlobalNavProductRecommendationsSimpleImplementation = ({ isMobile: isMobile = false })=>{
    const intl = (0, $8e22h.default)();
    const { recommendations: recommendations, isRecommendationLoading: isRecommendationLoading } = (0, $1oC0p.useContext)((0, $bvLTq.NavProductRecommendationsContext));
    const rawRecommendedProductIds = recommendations.map((ccpId)=>(0, $cIsCk.ccpKeyToProductId)[ccpId]).filter(Boolean);
    const recommendedTitle = intl.formatMessage({
        id: 'GlobalNav.collections.featured.recommended.apps',
        defaultMessage: 'Recommended based on your existing Atlassian apps'
    });
    const recommendedProductIds = rawRecommendedProductIds.slice(0, 3);
    const fallbackIds = [
        'jira',
        'confluence',
        'jsm'
    ];
    const fallbackTitle = intl.formatMessage({
        id: 'GlobalNav.collections.featured.featuredapps',
        defaultMessage: 'Featured apps'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "global-nav-product-recommendations-3-max",
        children: isRecommendationLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j26f4.SkeletonGrid), {
            numProducts: (0, $cIsCk.NUM_DISPLAY_RECOMMENDATIONS)
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eGkHJ.ProductRecommendationsContainer), {
            recommendedProductIds: recommendedProductIds.length > 0 ? recommendedProductIds : fallbackIds,
            isMobile: isMobile,
            customTitle: recommendedProductIds.length > 0 ? recommendedTitle : fallbackTitle
        })
    });
};
const $5460045e6dde061c$export$9eb7aff5460bd308 = ({ isMobile: isMobile = false })=>{
    const { onGlobalNavProductRecommendationsFailed: onGlobalNavProductRecommendationsFailed } = (0, $1oC0p.useContext)((0, $bvLTq.NavProductRecommendationsContext));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
        fallback: null,
        onError: onGlobalNavProductRecommendationsFailed,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($5460045e6dde061c$var$GlobalNavProductRecommendationsSimpleImplementation, {
            isMobile: isMobile
        })
    });
};

});
parcelRegister("eGkHJ", function(module, exports) {
$parcel$export(module.exports, "ProductRecommendationsContainer", function () { return $b4111ce58ec79f54$export$7e176c4401e77096; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hupQs = parcelRequire("hupQs");

var $R6IAB = parcelRequire("R6IAB");
const $b4111ce58ec79f54$var$title = (0, $fnHPc.defineMessage)({
    id: 'globalnav.v2.products.featured.recommendations',
    defaultMessage: 'Recommended based on your existing Atlassian apps'
});
const $b4111ce58ec79f54$export$7e176c4401e77096 = ({ recommendedProductIds: recommendedProductIds, isMobile: isMobile, customTitle: customTitle })=>{
    const intl = (0, $8e22h.default)();
    const { products: products } = (0, $hupQs.useProductData)();
    if (recommendedProductIds.length === 0) return null;
    const productsToRender = recommendedProductIds.map((id)=>products[id]).filter((product)=>product !== undefined);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $R6IAB.ProductsGrid), {
        products: productsToRender,
        title: customTitle ? customTitle : intl.formatMessage($b4111ce58ec79f54$var$title),
        isMobile: isMobile,
        container: 'ProductsRecommendationsContainer'
    });
};

});
parcelRegister("R6IAB", function(module, exports) {
$parcel$export(module.exports, "ProductsGrid", function () { return $724c3b16ad58acf7$export$710ab4b4285b1a69; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $jbgN3 = parcelRequire("jbgN3");

var $hupQs = parcelRequire("hupQs");

var $fJROq = parcelRequire("fJROq");

var $j39Xq = parcelRequire("j39Xq");
// Wrapper component to add analytics tracking to MobileNavCard
// MobileNavCard returns an <a> tag, so we wrap it in an <li> and attach the click handler.
const $724c3b16ad58acf7$var$MobileNavCardWithAnalytics = ({ product: product, description: description, isNew: isNew, onCardClick: onCardClick })=>{
    const liRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const anchor = liRef.current?.querySelector('a');
        if (anchor) {
            const handleClick = ()=>{
                onCardClick();
            // Don't prevent default - let the anchor handle navigation
            };
            anchor.addEventListener('click', handleClick);
            return ()=>{
                anchor.removeEventListener('click', handleClick);
            };
        }
    }, [
        onCardClick
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        ref: liRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavCard), {
            ...product,
            description: description,
            isNew: isNew,
            productKey: 'home'
        })
    });
};
// Wrapper component to add analytics tracking to ProductItem
// ProductItem already returns an <li>, so we can't wrap it in another element.
// Instead, we use the product id to find the anchor and attach the click handler.
const $724c3b16ad58acf7$var$ProductItemWithAnalytics = ({ product: product, onCardClick: onCardClick })=>{
    (0, $1oC0p.useEffect)(()=>{
        // Find the anchor by the product id (ProductItem sets id on the <li>)
        const li = document.getElementById(product.id);
        const anchor = li?.querySelector('a');
        if (anchor) {
            const handleClick = ()=>{
                onCardClick();
            // Don't prevent default - let the anchor handle navigation
            };
            anchor.addEventListener('click', handleClick);
            return ()=>{
                anchor.removeEventListener('click', handleClick);
            };
        }
    }, [
        product.id,
        onCardClick
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hupQs.ProductItem), {
        ...product
    });
};
const $724c3b16ad58acf7$export$710ab4b4285b1a69 = ({ products: products, title: title, isMobile: isMobile, container: container })=>{
    const intl = (0, $8e22h.default)();
    const { fireCardClicked: fireCardClicked } = (0, $fJROq.useAnalytics)();
    const handleCardClick = (product)=>{
        fireCardClicked({
            container: container,
            product: product,
            isMobile: isMobile
        });
    };
    const productItems = products.map((product)=>{
        if (isMobile) return /*#__PURE__*/ (0, $7VQPk.jsx)($724c3b16ad58acf7$var$MobileNavCardWithAnalytics, {
            product: product,
            description: intl.formatMessage(product.description),
            isNew: product.treatment === (0, $hupQs.Treatment).New,
            onCardClick: ()=>handleCardClick(product)
        }, product.id);
        // For desktop, ProductItem already returns an <li> with an <a> inside.
        // We use it directly and attach analytics via a wrapper component.
        return /*#__PURE__*/ (0, $7VQPk.jsx)($724c3b16ad58acf7$var$ProductItemWithAnalytics, {
            product: product,
            onCardClick: ()=>handleCardClick(product)
        }, product.id);
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j39Xq.BaseGrid), {
        products: productItems,
        title: title,
        isMobile: isMobile
    });
};

});
parcelRegister("jbgN3", function(module, exports) {
$parcel$export(module.exports, "MobileNavTitle", function () { return $be4107dd3ba6510e$export$9282cbc99a667022; });
$parcel$export(module.exports, "MobileNavCard", function () { return $be4107dd3ba6510e$export$76722d91c2a9f074; });
/* mobile-nav-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");
const $be4107dd3ba6510e$var$mobileTitleCss = null;
const $be4107dd3ba6510e$export$9282cbc99a667022 = ({ title: title })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1wyboqnp _vwz44jg8 _1p1dangw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4zu5n _syaz1pfd"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
        },
        children: title
    });
};
const $be4107dd3ba6510e$var$containerCss = null;
const $be4107dd3ba6510e$var$logoCss = null;
const $be4107dd3ba6510e$var$textContainerCss = null;
const $be4107dd3ba6510e$var$nameCss = null;
const $be4107dd3ba6510e$var$descriptionCss = null;
const $be4107dd3ba6510e$var$basicLinkCss = null;
const $be4107dd3ba6510e$var$pillContainerCss = null;
const $be4107dd3ba6510e$var$pillTextCss = null;
const $be4107dd3ba6510e$export$d2cf3038149dd1b5 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_syaz1bd0 _bfhkcafw _1e0c1txw _4cvr1h6o _18zr14y2 _2rko1tcg _ahbqi2wt"
        ]),
        style: {
            "--_1kmobfd": (0, $6ZVlx.default)((0, $bNzAT.default)('color.secondary.navy')),
            "--_1bnl49": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue200'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_1wybud5o _k48p1fw0 _1p1dangw"
            ]),
            children: intl.formatMessage({
                id: 'globalnav.v2.pill',
                defaultMessage: 'New'
            })
        })
    });
};
const $be4107dd3ba6510e$export$76722d91c2a9f074 = ({ logo: logo, href: href, name: name, description: description, isNew: isNew, productKey: productKey = 'home' })=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(href);
    const formattedHref = (0, $jQ0cd.isLocalizableHref)(href) ? localizedHref : href;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: description ? /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            href: formattedHref,
            "aria-label": name,
            target: (0, $jQ0cd.isLocalizableHref)(href) ? '' : '_blank',
            rel: (0, $jQ0cd.isLocalizableHref)(href) ? '' : 'noreferrer',
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "navbarDropdown",
            "data-product-key": productKey,
            className: (0, $2jatx.default)([
                "_1rjc1tcg _1e0c1txw _4cvr1h6o _zulputpp"
            ]),
            children: [
                logo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bsb1ady _4t3i1ady _1bah1h6o _4cvr1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                        brand: logo,
                        type: "mark",
                        appearance: "brand",
                        width: 32,
                        height: 32
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1yt4ze3t _2lx21bp4 _1bah1h6o _4cvr1y6m _16jlkb7n _1o9zidpf _i0dlf1ug"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("h5", {
                            className: (0, $2jatx.default)([
                                "_ggmhoxwj _r8nt1fw0 _1axicjiy _syaz1pfd _ect4kipj _1yt4ze3t _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: name
                                }),
                                isNew && /*#__PURE__*/ (0, $7VQPk.jsx)($be4107dd3ba6510e$export$d2cf3038149dd1b5, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_syaz1qc2 _ect48q0o _1wyboqnp _k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            style: {
                                "--_1fww9ud": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light800'))
                            },
                            children: description
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            text: name,
            href: formattedHref,
            type: "primary",
            "aria-label": name,
            dataEventProps: {
                'data-product-key': productKey,
                'data-event-component': 'linkButton',
                'data-event-container': 'navbarDropdown',
                'data-label': name,
                'data-event': 'clicked'
            },
            className: (0, $2jatx.default)([
                "_ect48q0o _1wyb7vkz _vwz4gktf _1rjc1tcg"
            ])
        })
    });
};

});

parcelRegister("fJROq", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", function () { return $80c08fb0f25e84c4$export$e955abb82869dc84; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $80c08fb0f25e84c4$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const commonProps = (0, $1oC0p.useMemo)(()=>({
            product: 'marketing'
        }), []);
    const fireCardClicked = (0, $1oC0p.useCallback)(({ container: container, product: product, isMobile: isMobile })=>{
        createAnalyticsEvent({
            ...commonProps,
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'recommendedProduct',
            attributes: {
                productKey: product.id,
                eventContainer: container,
                isMobile: isMobile
            }
        }).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    const fireGlobalNavProductRecommendationsViewed = (0, $1oC0p.useCallback)(({ recommendations: recommendations, isMobile: isMobile })=>{
        createAnalyticsEvent({
            ...commonProps,
            eventType: 'screen',
            name: 'productNavRecommendation',
            attributes: {
                recommendedProductKeys: recommendations,
                isMobile: isMobile
            }
        }).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    const fireFetchGrowthRecommendationSucceeded = (0, $1oC0p.useCallback)((recommendedProductIds, elapsedTimeMiliseconds)=>{
        createAnalyticsEvent({
            ...commonProps,
            eventType: 'operational',
            actionSubject: 'fetchGrowthRecommendation',
            action: 'succeeded',
            attributes: {
                recommendedProductIds: recommendedProductIds,
                elapsedTime: elapsedTimeMiliseconds / 1000
            }
        }).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    const fireFetchGrowthRecommendationFailed = (0, $1oC0p.useCallback)((error, elapsedTimeMiliseconds)=>{
        createAnalyticsEvent({
            ...commonProps,
            eventType: 'operational',
            actionSubject: 'fetchGrowthRecommendation',
            action: 'failed',
            attributes: {
                errorMessage: error,
                elapsedTime: elapsedTimeMiliseconds / 1000
            }
        }).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    const fireRenderGlobalNavProductRecommendationsFailed = (0, $1oC0p.useCallback)((error, errorInfo)=>{
        createAnalyticsEvent({
            ...commonProps,
            eventType: 'operational',
            actionSubject: 'renderGlobalNavProductRecommendations',
            action: 'failed',
            attributes: {
                errorMessage: error.message,
                stackTrace: errorInfo.componentStack
            }
        }).fire();
    }, [
        commonProps,
        createAnalyticsEvent
    ]);
    return {
        fireCardClicked: fireCardClicked,
        fireGlobalNavProductRecommendationsViewed: fireGlobalNavProductRecommendationsViewed,
        fireFetchGrowthRecommendationSucceeded: fireFetchGrowthRecommendationSucceeded,
        fireFetchGrowthRecommendationFailed: fireFetchGrowthRecommendationFailed,
        fireRenderGlobalNavProductRecommendationsFailed: fireRenderGlobalNavProductRecommendationsFailed
    };
}

});

parcelRegister("j39Xq", function(module, exports) {
$parcel$export(module.exports, "BaseGrid", function () { return $d09f0d1642f1fd86$export$194584af1cd4d0df; });
/* base-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $d09f0d1642f1fd86$export$194584af1cd4d0df = ({ products: products, title: title, isMobile: isMobile })=>{
    const columns = '1fr 1fr 1fr';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_j6qusb0t _1fqfidpf _1igvidpf _9703idpf _hpnpidpf _15xeidpf _aa9fidpf _1wayidpf _ldybidpf _19vu1pfd _13a6dlk8 _1yuq1nn1 _stho1n44 _24ktgktf _scn3angw _1tkroqnp"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
        },
        children: [
            /*#__PURE__*/ (0, $1oC0p.isValidElement)(title) ? title : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: "base-products-grid-title base-products-grid-title-3-max",
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _yv0ev4b3 _gy1pxy5q _lwlj19bv _d865xy5q _17pfxy5q _llpou2gc _1wm6v77o _3867hkll",
                    "base-products-grid base-products-grid-3-max"
                ]),
                "data-testid": "product-grid",
                style: {
                    "--_dy6cn": (0, $6ZVlx.default)(isMobile ? '1fr' : columns)
                },
                children: products
            })
        ]
    });
};

});



parcelRegister("j26f4", function(module, exports) {
$parcel$export(module.exports, "SkeletonGrid", function () { return $b1d46e500df0f473$export$5e6fdfe27f754986; });
/* skeleton-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $j39Xq = parcelRequire("j39Xq");
const $b1d46e500df0f473$var$shimmer = null;
const $b1d46e500df0f473$var$LoadingSkeleton = /*#__PURE__*/ (0, $1oC0p.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, marginRightPx: marginRightPx, marginTopPx: marginTopPx, marginBottomPx: marginBottomPx, marginLeftPx: marginLeftPx, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10sf6bt": (0, $6ZVlx.default)(__cmplp.borderRadius),
            "--_10ib6lf": (0, $6ZVlx.default)(__cmplp.height),
            "--_1vcp0mh": (0, $6ZVlx.default)(__cmplp.width),
            "--_rd4u3e": (0, $6ZVlx.default)(__cmplp.marginRightPx, "px"),
            "--_1ukeoag": (0, $6ZVlx.default)(__cmplp.marginTopPx, "px"),
            "--_998uhw": (0, $6ZVlx.default)(__cmplp.marginBottomPx, "px"),
            "--_tmcb3z": (0, $6ZVlx.default)(__cmplp.marginLeftPx, "px")
        },
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _12vemgnk _bfhk1ezx _1itkjeoh",
            __cmplp.borderRadius ? "_2rko1fbf" : "_2rko1l7b",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1crf",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
            __cmplp.marginRightPx ? "_2hwxh3nu" : "_2hwxidpf",
            __cmplp.marginTopPx ? "_19pk4aab" : "_19pkidpf",
            __cmplp.marginBottomPx ? "_otyrfz3k" : "_otyridpf",
            __cmplp.marginLeftPx ? "_18u0g7qm" : "_18u0idpf",
            __cmplp.className
        ])
    });
});
const $b1d46e500df0f473$var$SkeletonTitle = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)($b1d46e500df0f473$var$LoadingSkeleton, {
        width: "328px",
        height: "16px",
        borderRadius: "3px",
        "data-testid": "skeleton-title"
    });
const $b1d46e500df0f473$var$SkeletonItem = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        "data-testid": "skeleton-item",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulppxbi _1q51xy5q _85i5v47k"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($b1d46e500df0f473$var$LoadingSkeleton, {
                width: "44px",
                height: "44px",
                borderRadius: "3px"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulputpp _1q51u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($b1d46e500df0f473$var$LoadingSkeleton, {
                        width: "80px",
                        height: "8px",
                        borderRadius: "3px"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($b1d46e500df0f473$var$LoadingSkeleton, {
                        width: "160px",
                        height: "8px",
                        borderRadius: "3px"
                    })
                ]
            })
        ]
    });
const $b1d46e500df0f473$export$5e6fdfe27f754986 = ({ numProducts: numProducts, isMobile: isMobile })=>{
    const skeletonProducts = (0, $1oC0p.useMemo)(()=>{
        const products = [];
        for(let i = 0; i < numProducts; i++)products.push(/*#__PURE__*/ (0, $7VQPk.jsx)($b1d46e500df0f473$var$SkeletonItem, {}, i));
        return products;
    }, [
        numProducts
    ]);
    if (!numProducts) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j39Xq.BaseGrid), {
        products: skeletonProducts,
        title: /*#__PURE__*/ (0, $7VQPk.jsx)($b1d46e500df0f473$var$SkeletonTitle, {}),
        isMobile: isMobile
    });
};

});













parcelRegister("3dnVb", function(module, exports) {
$parcel$export(module.exports, "useQueryLocale", function () { return $a6fa76e7098ccdd9$export$3c0a4971d97d71e2; });
$parcel$export(module.exports, "parseQueryLocale", function () { return $a6fa76e7098ccdd9$export$8e9087082df73586; });

var $hu7gH = parcelRequire("hu7gH");

var $17RBn = parcelRequire("17RBn");

var $kf4PU = parcelRequire("kf4PU");
const $a6fa76e7098ccdd9$export$3c0a4971d97d71e2 = ()=>{
    const locale = (0, $17RBn.useLocale)();
    return (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || 'en-US';
};
const $a6fa76e7098ccdd9$export$8e9087082df73586 = (location)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || 'en-US';
};

});
parcelRegister("kf4PU", function(module, exports) {
$parcel$export(module.exports, "WAC_TO_CPAPI_LOCALE_MAP", function () { return $75fb9622f9acf368$export$9367d1c6d4e06c7e; });
$parcel$export(module.exports, "TEMPLATE_CATEGORY_OBJ", function () { return $75fb9622f9acf368$export$8a30761f5ebaff2; });
$parcel$export(module.exports, "RECO_TEMPLATE_LOCAL_STORAGE_NAME", function () { return $75fb9622f9acf368$export$68486ec0ba4ac32f; });
const $75fb9622f9acf368$var$isProductionEnvironment = true;
const $75fb9622f9acf368$var$commonLocales = {
    br: 'pt-BR',
    de: 'de-DE',
    en: 'en-US',
    es: 'es',
    fr: 'fr-FR',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    zh: 'zh-CN'
};
const $75fb9622f9acf368$var$nonProdLocales = {
    xx: 'en-US',
    zz: 'en-US'
};
const $75fb9622f9acf368$export$9367d1c6d4e06c7e = $75fb9622f9acf368$var$isProductionEnvironment ? $75fb9622f9acf368$var$commonLocales : {
    ...$75fb9622f9acf368$var$commonLocales,
    ...$75fb9622f9acf368$var$nonProdLocales
};
const $75fb9622f9acf368$export$8a30761f5ebaff2 = {
    id: '7ckISKU5UGRFKMEQyFf123',
    name: 'Recommended for you',
    urlSlug: 'recommended',
    shortDescriptionOneLiner: 'Check out our personalized list of templates relevant to you and your team.',
    pageTitle: 'Recommended templates for you',
    description: null,
    experiment: false
};
const $75fb9622f9acf368$export$68486ec0ba4ac32f = 'template_reco';

});


parcelRegister("Cepma", function(module, exports) {
$parcel$export(module.exports, "CollectionAboutSection", function () { return $1a02cc51db59ba9b$export$47cbf275a64a5835; });
/* collection-about-section-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $f3gS9 = parcelRequire("f3gS9");
var $1a02cc51db59ba9b$var$_collectionAboutSectionContentfulRelayFragment;
const $1a02cc51db59ba9b$var$collectionAboutTitle = null;
const $1a02cc51db59ba9b$var$collectionAboutWrapper = null;
const $1a02cc51db59ba9b$var$collectionAboutInfo = null;
const $1a02cc51db59ba9b$var$collectionAboutStyle = null;
const $1a02cc51db59ba9b$var$aboutImage = null;

const $1a02cc51db59ba9b$var$CollectionAboutSectionRelayFragment = $1a02cc51db59ba9b$var$_collectionAboutSectionContentfulRelayFragment !== void 0 ? $1a02cc51db59ba9b$var$_collectionAboutSectionContentfulRelayFragment : ($1a02cc51db59ba9b$var$_collectionAboutSectionContentfulRelayFragment = (parcelRequire("aheEL")), $1a02cc51db59ba9b$var$_collectionAboutSectionContentfulRelayFragment.hash && $1a02cc51db59ba9b$var$_collectionAboutSectionContentfulRelayFragment.hash !== "33b71e01173f5038aa6d6f4435ea2c8a" && console.error("The definition of 'collectionAboutSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $1a02cc51db59ba9b$var$_collectionAboutSectionContentfulRelayFragment);
const $1a02cc51db59ba9b$export$47cbf275a64a5835 = ({ collection: collection })=>{
    const { collectionNameExternal: collectionNameExternal, aboutThisCollectionHeader: aboutThisCollectionHeader, aboutThisCollection: aboutThisCollection, aboutThisCollectionImage: aboutThisCollectionImage } = (0, $f3gS9.useFragment)($1a02cc51db59ba9b$var$CollectionAboutSectionRelayFragment, collection);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1q51vbgk _zulp1tcg _1gde1bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulp1ylp _2lx21bp4 _y3gn1e5h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kzs1k8s _16cb1m1q"
                        ]),
                        children: aboutThisCollectionHeader
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: aboutThisCollection
                    })
                ]
            }),
            aboutThisCollectionImage && /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                src: aboutThisCollectionImage.url ?? undefined,
                alt: collectionNameExternal ?? aboutThisCollectionImage.name ?? undefined,
                className: (0, $2jatx.default)([
                    "_p12fsb0t _c71luuw1"
                ])
            })
        ]
    });
};

});
parcelRegister("aheEL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $553185300e6a12f1$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<88cf3bfc29c34f6f4a87d27aec108067>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $553185300e6a12f1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionAboutSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "collectionNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aboutThisCollectionHeader",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aboutThisCollection",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "aboutThisCollectionImage",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                },
                {
                    "alias": "name",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "TemplateCollection",
    "abstractKey": null
};
$553185300e6a12f1$var$node.hash = "33b71e01173f5038aa6d6f4435ea2c8a";
var $553185300e6a12f1$export$2e2bcd8739ae039 = $553185300e6a12f1$var$node;

});


parcelRegister("bbAhH", function(module, exports) {
$parcel$export(module.exports, "CollectionGuideSection", function () { return $8e4a34bfbb0d67be$export$152a602189556441; });
/* collection-guide-section-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $f3gS9 = parcelRequire("f3gS9");

var $gVC4y = parcelRequire("gVC4y");

var $cml5G = parcelRequire("cml5G");

var $lRFwv = parcelRequire("lRFwv");

var $6SdoX = parcelRequire("6SdoX");

var $jQ0cd = parcelRequire("jQ0cd");

var $1Ztwq = parcelRequire("1Ztwq");
var $8e4a34bfbb0d67be$var$_collectionGuideSectionContentfulRelayFragment;
const $8e4a34bfbb0d67be$var$guideSectionStyle = null;
const $8e4a34bfbb0d67be$var$stepContainerStyle = null;
const $8e4a34bfbb0d67be$var$guideSectionHeading = null;
const $8e4a34bfbb0d67be$var$stepHeading = null;
const $8e4a34bfbb0d67be$var$stepSubHeading = null;
const $8e4a34bfbb0d67be$var$stepContentWrapper = null;
const $8e4a34bfbb0d67be$var$stepCardWrapper = null;
const $8e4a34bfbb0d67be$var$stepTemplateLinkStyle = null;
const $8e4a34bfbb0d67be$var$CollectionDetailStep = ({ step: step })=>{
    const stepTemplateLink = (0, $jQ0cd.useLocalizedHref)(`/software/confluence/templates/${step?.relatedTemplate?.urlSlug}`);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1yb4 _6rthys9h _zulp8pqr _1gde1bp4 _8164viql _1ckvidpf"
        ]),
        children: [
            step?.relatedTemplate && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_16jlidpf _1o9zidpf _y3gn1e5h _19pkidpf _2hwx1wug _otyridpf _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Ztwq.TemplateCard), {
                    template: step.relatedTemplate,
                    background: // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg1.svg)'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_1wyb1k8s _vwz4viql _k48pbfng _1dyznl7k _syazdtn8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rthzwfg _1cqs1k92 _1bys1k8s"
                        ]),
                        children: step?.stepNameExternal
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wyb1k92 _vwz41k8s _k48pbfng _1dyznl7k _syazdtn8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1tcg _1cqs1j6v _1bys1k92"
                        ]),
                        children: step?.stepSubheading
                    }),
                    step?.stepDescription && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6SdoX.SanitizedRichText), {
                        innerHTML: (0, $gVC4y.richTextToHTML)(step?.stepDescription?.json)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                        href: stepTemplateLink,
                        ...(0, $lRFwv.ConfluenceTemplateAnalytics).viewTemplateAnalyticProps(step?.relatedTemplate?.urlSlug),
                        className: (0, $2jatx.default)([
                            "_1pfh1tcg _syazrbzz _k48pbfng _4bfu1r31 _1hms8stv _ajmmnqa1 _30l3oelr _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _1053rbzz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $cml5G.ConfluenceTemplateMessages).collectionViewTemplate
                            }),
                            " \u2192"
                        ]
                    })
                ]
            })
        ]
    });
};

const $8e4a34bfbb0d67be$var$CollectionGuideSectionRelayFragment = $8e4a34bfbb0d67be$var$_collectionGuideSectionContentfulRelayFragment !== void 0 ? $8e4a34bfbb0d67be$var$_collectionGuideSectionContentfulRelayFragment : ($8e4a34bfbb0d67be$var$_collectionGuideSectionContentfulRelayFragment = (parcelRequire("luddA")), $8e4a34bfbb0d67be$var$_collectionGuideSectionContentfulRelayFragment.hash && $8e4a34bfbb0d67be$var$_collectionGuideSectionContentfulRelayFragment.hash !== "1322567ec9bf43ef4ca8dc0fe46bd69f" && console.error("The definition of 'collectionGuideSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $8e4a34bfbb0d67be$var$_collectionGuideSectionContentfulRelayFragment);
const $8e4a34bfbb0d67be$export$152a602189556441 = ({ collectionGuide: collectionGuide })=>{
    const { templateCollectionGuideNameExternal: templateCollectionGuideNameExternal, collectionStepsCollection: collectionStepsCollection } = (0, $f3gS9.useFragment)($8e4a34bfbb0d67be$var$CollectionGuideSectionRelayFragment, collectionGuide);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1pfhys9h _ahbq1wug _12l21wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: templateCollectionGuideNameExternal
            }),
            collectionStepsCollection?.items?.map((step, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($8e4a34bfbb0d67be$var$CollectionDetailStep, {
                    step: step
                }, `step-${index}`))
        ]
    });
};

});
parcelRegister("gVC4y", function(module, exports) {
$parcel$export(module.exports, "richTextToHTML", function () { return $2c047a038fe766c8$export$57b6590c18f70792; });
$parcel$export(module.exports, "stripContentfulMetadata", function () { return $2c047a038fe766c8$export$da246082e8e63708; });
$parcel$export(module.exports, "getShouldStripExcessData", function () { return $2c047a038fe766c8$export$320635ee8bc75ec9; });

var $gA8LO = parcelRequire("gA8LO");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $2c047a038fe766c8$export$57b6590c18f70792 = (richText)=>{
    let htmlString = (0, $gA8LO.documentToHtmlString)(richText);
    htmlString = htmlString.replace(/\n/g, '<br />');
    return htmlString;
};
const $2c047a038fe766c8$var$DEFAULT_STRIP_KEYS = new Set([
    'sys',
    'metadata',
    'createdAt',
    'updatedAt'
]);
const $2c047a038fe766c8$export$da246082e8e63708 = (data, options = {})=>{
    const keysToStrip = options.keys !== null && options.keys !== undefined ? new Set(options.keys) : $2c047a038fe766c8$var$DEFAULT_STRIP_KEYS;
    const walk = (node)=>{
        if (Array.isArray(node)) node.forEach(walk);
        else if (node !== null && typeof node === 'object') {
            const obj = node;
            for (const key of keysToStrip)delete obj[key];
            for (const value of Object.values(obj))walk(value);
        }
    };
    walk(data);
};
const $2c047a038fe766c8$export$320635ee8bc75ec9 = ()=>{
    return (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).waePricingStripExcessData);
};

});
parcelRegister("gA8LO", function(module, exports) {
$parcel$export(module.exports, "documentToHtmlString", function () { return $c126cfb8d60b79c3$export$7baf571c7f59ce7c; }, function (v) { return $c126cfb8d60b79c3$export$7baf571c7f59ce7c = v; });
var $c126cfb8d60b79c3$export$7baf571c7f59ce7c;
'use strict';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $c126cfb8d60b79c3$var$__assign = function() {
    $c126cfb8d60b79c3$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c126cfb8d60b79c3$var$__assign.apply(this, arguments);
};
typeof SuppressedError === "function" && SuppressedError;
var $c126cfb8d60b79c3$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $c126cfb8d60b79c3$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $c126cfb8d60b79c3$var$dist = {};
var $c126cfb8d60b79c3$var$blocks = {};
Object.defineProperty($c126cfb8d60b79c3$var$blocks, "__esModule", {
    value: true
});
$c126cfb8d60b79c3$var$blocks.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $c126cfb8d60b79c3$var$BLOCKS;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($c126cfb8d60b79c3$var$BLOCKS || ($c126cfb8d60b79c3$var$blocks.BLOCKS = $c126cfb8d60b79c3$var$BLOCKS = {}));
var $c126cfb8d60b79c3$var$inlines = {};
Object.defineProperty($c126cfb8d60b79c3$var$inlines, "__esModule", {
    value: true
});
$c126cfb8d60b79c3$var$inlines.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $c126cfb8d60b79c3$var$INLINES;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($c126cfb8d60b79c3$var$INLINES || ($c126cfb8d60b79c3$var$inlines.INLINES = $c126cfb8d60b79c3$var$INLINES = {}));
var $c126cfb8d60b79c3$var$marks = {};
Object.defineProperty($c126cfb8d60b79c3$var$marks, "__esModule", {
    value: true
});
$c126cfb8d60b79c3$var$marks.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */ var $c126cfb8d60b79c3$var$MARKS;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($c126cfb8d60b79c3$var$MARKS || ($c126cfb8d60b79c3$var$marks.MARKS = $c126cfb8d60b79c3$var$MARKS = {}));
var $c126cfb8d60b79c3$var$schemaConstraints = {};
(function(exports1) {
    var __spreadArray = $c126cfb8d60b79c3$var$commonjsGlobal && $c126cfb8d60b79c3$var$commonjsGlobal.__spreadArray || function(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };
    var _a;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.V1_MARKS = exports1.V1_NODE_TYPES = exports1.TEXT_CONTAINERS = exports1.HEADINGS = exports1.CONTAINERS = exports1.VOID_BLOCKS = exports1.TABLE_BLOCKS = exports1.LIST_ITEM_BLOCKS = exports1.TOP_LEVEL_BLOCKS = void 0;
    var blocks_1 = $c126cfb8d60b79c3$var$blocks;
    var inlines_1 = $c126cfb8d60b79c3$var$inlines;
    var marks_1 = $c126cfb8d60b79c3$var$marks;
    /**
	 * Array of all top level block types.
	 * Only these block types can be the direct children of the document.
	 */ exports1.TOP_LEVEL_BLOCKS = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE,
        blocks_1.BLOCKS.TABLE
    ];
    /**
	 * Array of all allowed block types inside list items
	 */ exports1.LIST_ITEM_BLOCKS = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE
    ];
    exports1.TABLE_BLOCKS = [
        blocks_1.BLOCKS.TABLE,
        blocks_1.BLOCKS.TABLE_ROW,
        blocks_1.BLOCKS.TABLE_CELL,
        blocks_1.BLOCKS.TABLE_HEADER_CELL
    ];
    /**
	 * Array of all void block types
	 */ exports1.VOID_BLOCKS = [
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE
    ];
    /**
	 * Dictionary of all container block types, and the set block types they accept as children.
	 *
	 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
	 */ exports1.CONTAINERS = (_a = {}, _a[blocks_1.BLOCKS.OL_LIST] = [
        blocks_1.BLOCKS.LIST_ITEM
    ], _a[blocks_1.BLOCKS.UL_LIST] = [
        blocks_1.BLOCKS.LIST_ITEM
    ], _a[blocks_1.BLOCKS.LIST_ITEM] = exports1.LIST_ITEM_BLOCKS, _a[blocks_1.BLOCKS.QUOTE] = [
        blocks_1.BLOCKS.PARAGRAPH
    ], _a[blocks_1.BLOCKS.TABLE] = [
        blocks_1.BLOCKS.TABLE_ROW
    ], _a[blocks_1.BLOCKS.TABLE_ROW] = [
        blocks_1.BLOCKS.TABLE_CELL,
        blocks_1.BLOCKS.TABLE_HEADER_CELL
    ], _a[blocks_1.BLOCKS.TABLE_CELL] = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.OL_LIST
    ], _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [
        blocks_1.BLOCKS.PARAGRAPH
    ], _a);
    /**
	 * Array of all heading levels
	 */ exports1.HEADINGS = [
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6
    ];
    /**
	 * Array of all block types that may contain text and inline nodes.
	 */ exports1.TEXT_CONTAINERS = __spreadArray([
        blocks_1.BLOCKS.PARAGRAPH
    ], exports1.HEADINGS, true);
    /**
	 * Node types before `tables` release.
	 */ exports1.V1_NODE_TYPES = [
        blocks_1.BLOCKS.DOCUMENT,
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.LIST_ITEM,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        inlines_1.INLINES.HYPERLINK,
        inlines_1.INLINES.ENTRY_HYPERLINK,
        inlines_1.INLINES.ASSET_HYPERLINK,
        inlines_1.INLINES.EMBEDDED_ENTRY,
        'text'
    ];
    /**
	 * Marks before `superscript` & `subscript` release.
	 */ exports1.V1_MARKS = [
        marks_1.MARKS.BOLD,
        marks_1.MARKS.CODE,
        marks_1.MARKS.ITALIC,
        marks_1.MARKS.UNDERLINE
    ];
})($c126cfb8d60b79c3$var$schemaConstraints);
var $c126cfb8d60b79c3$var$types = {};
Object.defineProperty($c126cfb8d60b79c3$var$types, "__esModule", {
    value: true
});
var $c126cfb8d60b79c3$var$nodeTypes = {};
Object.defineProperty($c126cfb8d60b79c3$var$nodeTypes, "__esModule", {
    value: true
});
var $c126cfb8d60b79c3$var$emptyDocument = {};
Object.defineProperty($c126cfb8d60b79c3$var$emptyDocument, "__esModule", {
    value: true
});
$c126cfb8d60b79c3$var$emptyDocument.EMPTY_DOCUMENT = void 0;
var $c126cfb8d60b79c3$var$blocks_1$1 = $c126cfb8d60b79c3$var$blocks;
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ $c126cfb8d60b79c3$var$emptyDocument.EMPTY_DOCUMENT = {
    nodeType: $c126cfb8d60b79c3$var$blocks_1$1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $c126cfb8d60b79c3$var$blocks_1$1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};
var $c126cfb8d60b79c3$var$helpers = {};
Object.defineProperty($c126cfb8d60b79c3$var$helpers, "__esModule", {
    value: true
});
$c126cfb8d60b79c3$var$helpers.isInline = $c126cfb8d60b79c3$var$isInline;
$c126cfb8d60b79c3$var$helpers.isBlock = $c126cfb8d60b79c3$var$isBlock;
$c126cfb8d60b79c3$var$helpers.isText = $c126cfb8d60b79c3$var$isText;
var $c126cfb8d60b79c3$var$blocks_1 = $c126cfb8d60b79c3$var$blocks;
var $c126cfb8d60b79c3$var$inlines_1 = $c126cfb8d60b79c3$var$inlines;
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $c126cfb8d60b79c3$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $c126cfb8d60b79c3$var$isInline(node) {
    return $c126cfb8d60b79c3$var$hasValue($c126cfb8d60b79c3$var$inlines_1.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $c126cfb8d60b79c3$var$isBlock(node) {
    return $c126cfb8d60b79c3$var$hasValue($c126cfb8d60b79c3$var$blocks_1.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $c126cfb8d60b79c3$var$isText(node) {
    return node.nodeType === 'text';
}
function $c126cfb8d60b79c3$var$commonjsRequire(path) {
    throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $c126cfb8d60b79c3$var$schemas = {};
Object.defineProperty($c126cfb8d60b79c3$var$schemas, "__esModule", {
    value: true
});
$c126cfb8d60b79c3$var$schemas.getSchemaWithNodeType = $c126cfb8d60b79c3$var$getSchemaWithNodeType;
function $c126cfb8d60b79c3$var$getSchemaWithNodeType(nodeType) {
    try {
        return $c126cfb8d60b79c3$var$commonjsRequire("./generated/".concat(nodeType, ".json"));
    } catch (error) {
        throw new Error("Schema for nodeType \"".concat(nodeType, "\" was not found."));
    }
}
(function(exports1) {
    var __createBinding = $c126cfb8d60b79c3$var$commonjsGlobal && $c126cfb8d60b79c3$var$commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m[k];
            }
        };
        Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var __setModuleDefault = $c126cfb8d60b79c3$var$commonjsGlobal && $c126cfb8d60b79c3$var$commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
        Object.defineProperty(o, "default", {
            enumerable: true,
            value: v
        });
    } : function(o, v) {
        o["default"] = v;
    });
    var __exportStar = $c126cfb8d60b79c3$var$commonjsGlobal && $c126cfb8d60b79c3$var$commonjsGlobal.__exportStar || function(m, exports1) {
        for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
    };
    var __importStar = $c126cfb8d60b79c3$var$commonjsGlobal && $c126cfb8d60b79c3$var$commonjsGlobal.__importStar || function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.getSchemaWithNodeType = exports1.helpers = exports1.EMPTY_DOCUMENT = exports1.MARKS = exports1.INLINES = exports1.BLOCKS = void 0;
    var blocks_1 = $c126cfb8d60b79c3$var$blocks;
    Object.defineProperty(exports1, "BLOCKS", {
        enumerable: true,
        get: function() {
            return blocks_1.BLOCKS;
        }
    });
    var inlines_1 = $c126cfb8d60b79c3$var$inlines;
    Object.defineProperty(exports1, "INLINES", {
        enumerable: true,
        get: function() {
            return inlines_1.INLINES;
        }
    });
    var marks_1 = $c126cfb8d60b79c3$var$marks;
    Object.defineProperty(exports1, "MARKS", {
        enumerable: true,
        get: function() {
            return marks_1.MARKS;
        }
    });
    __exportStar($c126cfb8d60b79c3$var$schemaConstraints, exports1);
    __exportStar($c126cfb8d60b79c3$var$types, exports1);
    __exportStar($c126cfb8d60b79c3$var$nodeTypes, exports1);
    var emptyDocument_1 = $c126cfb8d60b79c3$var$emptyDocument;
    Object.defineProperty(exports1, "EMPTY_DOCUMENT", {
        enumerable: true,
        get: function() {
            return emptyDocument_1.EMPTY_DOCUMENT;
        }
    });
    var helpers$1 = __importStar($c126cfb8d60b79c3$var$helpers);
    exports1.helpers = helpers$1;
    var schemas_1 = $c126cfb8d60b79c3$var$schemas;
    Object.defineProperty(exports1, "getSchemaWithNodeType", {
        enumerable: true,
        get: function() {
            return schemas_1.getSchemaWithNodeType;
        }
    });
})($c126cfb8d60b79c3$var$dist);
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */ /**
 * Module variables.
 * @private
 */ var $c126cfb8d60b79c3$var$matchHtmlRegExp = /["'&<>]/;
/**
 * Module exports.
 * @public
 */ var $c126cfb8d60b79c3$var$escapeHtml_1 = $c126cfb8d60b79c3$var$escapeHtml;
/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */ function $c126cfb8d60b79c3$var$escapeHtml(string) {
    var str = '' + string;
    var match = $c126cfb8d60b79c3$var$matchHtmlRegExp.exec(str);
    if (!match) return str;
    var escape;
    var html = '';
    var index = 0;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escape = '&quot;';
                break;
            case 38:
                escape = '&amp;';
                break;
            case 39:
                escape = '&#39;';
                break;
            case 60:
                escape = '&lt;';
                break;
            case 62:
                escape = '&gt;';
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.substring(lastIndex, index);
        lastIndex = index + 1;
        html += escape;
    }
    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
var $c126cfb8d60b79c3$var$escape = /*@__PURE__*/ $c126cfb8d60b79c3$var$getDefaultExportFromCjs($c126cfb8d60b79c3$var$escapeHtml_1);
var $c126cfb8d60b79c3$var$_a, $c126cfb8d60b79c3$var$_b;
var $c126cfb8d60b79c3$var$attributeValue = function(value) {
    return "\"".concat(value.replace(/"/g, '&quot;'), "\"");
};
var $c126cfb8d60b79c3$var$defaultNodeRenderers = ($c126cfb8d60b79c3$var$_a = {}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.PARAGRAPH] = function(node, next) {
    return "<p>".concat(next(node.content), "</p>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.HEADING_1] = function(node, next) {
    return "<h1>".concat(next(node.content), "</h1>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.HEADING_2] = function(node, next) {
    return "<h2>".concat(next(node.content), "</h2>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.HEADING_3] = function(node, next) {
    return "<h3>".concat(next(node.content), "</h3>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.HEADING_4] = function(node, next) {
    return "<h4>".concat(next(node.content), "</h4>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.HEADING_5] = function(node, next) {
    return "<h5>".concat(next(node.content), "</h5>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.HEADING_6] = function(node, next) {
    return "<h6>".concat(next(node.content), "</h6>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.EMBEDDED_ENTRY] = function(node, next) {
    return "<div>".concat(next(node.content), "</div>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.EMBEDDED_RESOURCE] = function(node, next) {
    return "<div>".concat(next(node.content), "</div>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.UL_LIST] = function(node, next) {
    return "<ul>".concat(next(node.content), "</ul>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.OL_LIST] = function(node, next) {
    return "<ol>".concat(next(node.content), "</ol>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.LIST_ITEM] = function(node, next) {
    return "<li>".concat(next(node.content), "</li>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.QUOTE] = function(node, next) {
    return "<blockquote>".concat(next(node.content), "</blockquote>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.HR] = function() {
    return '<hr/>';
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.TABLE] = function(node, next) {
    return "<table>".concat(next(node.content), "</table>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.TABLE_ROW] = function(node, next) {
    return "<tr>".concat(next(node.content), "</tr>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.TABLE_HEADER_CELL] = function(node, next) {
    return "<th>".concat(next(node.content), "</th>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.BLOCKS.TABLE_CELL] = function(node, next) {
    return "<td>".concat(next(node.content), "</td>");
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.INLINES.ASSET_HYPERLINK] = function(node) {
    return $c126cfb8d60b79c3$var$defaultInline($c126cfb8d60b79c3$var$dist.INLINES.ASSET_HYPERLINK, node);
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.INLINES.ENTRY_HYPERLINK] = function(node) {
    return $c126cfb8d60b79c3$var$defaultInline($c126cfb8d60b79c3$var$dist.INLINES.ENTRY_HYPERLINK, node);
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.INLINES.RESOURCE_HYPERLINK] = function(node) {
    return $c126cfb8d60b79c3$var$defaultInlineResource($c126cfb8d60b79c3$var$dist.INLINES.RESOURCE_HYPERLINK, node);
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.INLINES.EMBEDDED_ENTRY] = function(node) {
    return $c126cfb8d60b79c3$var$defaultInline($c126cfb8d60b79c3$var$dist.INLINES.EMBEDDED_ENTRY, node);
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.INLINES.EMBEDDED_RESOURCE] = function(node) {
    return $c126cfb8d60b79c3$var$defaultInlineResource($c126cfb8d60b79c3$var$dist.INLINES.EMBEDDED_RESOURCE, node);
}, $c126cfb8d60b79c3$var$_a[$c126cfb8d60b79c3$var$dist.INLINES.HYPERLINK] = function(node, next) {
    var href = typeof node.data.uri === 'string' ? node.data.uri : '';
    return "<a href=".concat($c126cfb8d60b79c3$var$attributeValue(href), ">").concat(next(node.content), "</a>");
}, $c126cfb8d60b79c3$var$_a);
var $c126cfb8d60b79c3$var$defaultMarkRenderers = ($c126cfb8d60b79c3$var$_b = {}, $c126cfb8d60b79c3$var$_b[$c126cfb8d60b79c3$var$dist.MARKS.BOLD] = function(text) {
    return "<b>".concat(text, "</b>");
}, $c126cfb8d60b79c3$var$_b[$c126cfb8d60b79c3$var$dist.MARKS.ITALIC] = function(text) {
    return "<i>".concat(text, "</i>");
}, $c126cfb8d60b79c3$var$_b[$c126cfb8d60b79c3$var$dist.MARKS.UNDERLINE] = function(text) {
    return "<u>".concat(text, "</u>");
}, $c126cfb8d60b79c3$var$_b[$c126cfb8d60b79c3$var$dist.MARKS.CODE] = function(text) {
    return "<code>".concat(text, "</code>");
}, $c126cfb8d60b79c3$var$_b[$c126cfb8d60b79c3$var$dist.MARKS.SUPERSCRIPT] = function(text) {
    return "<sup>".concat(text, "</sup>");
}, $c126cfb8d60b79c3$var$_b[$c126cfb8d60b79c3$var$dist.MARKS.SUBSCRIPT] = function(text) {
    return "<sub>".concat(text, "</sub>");
}, $c126cfb8d60b79c3$var$_b[$c126cfb8d60b79c3$var$dist.MARKS.STRIKETHROUGH] = function(text) {
    return "<s>".concat(text, "</s>");
}, $c126cfb8d60b79c3$var$_b);
var $c126cfb8d60b79c3$var$defaultInline = function(type, node) {
    return "<span>type: ".concat($c126cfb8d60b79c3$var$escape(type), " id: ").concat($c126cfb8d60b79c3$var$escape(node.data.target.sys.id), "</span>");
};
var $c126cfb8d60b79c3$var$defaultInlineResource = function(type, node) {
    return "<span>type: ".concat($c126cfb8d60b79c3$var$escape(type), " urn: ").concat($c126cfb8d60b79c3$var$escape(node.data.target.sys.urn), "</span>");
};
/**
 * Serialize a Contentful Rich Text `document` to an html string.
 */ function $c126cfb8d60b79c3$var$documentToHtmlString(richTextDocument, options) {
    if (options === void 0) options = {};
    if (!richTextDocument || !richTextDocument.content) return '';
    return $c126cfb8d60b79c3$var$nodeListToHtmlString(richTextDocument.content, {
        renderNode: $c126cfb8d60b79c3$var$__assign($c126cfb8d60b79c3$var$__assign({}, $c126cfb8d60b79c3$var$defaultNodeRenderers), options.renderNode),
        renderMark: $c126cfb8d60b79c3$var$__assign($c126cfb8d60b79c3$var$__assign({}, $c126cfb8d60b79c3$var$defaultMarkRenderers), options.renderMark),
        preserveWhitespace: options.preserveWhitespace
    });
}
function $c126cfb8d60b79c3$var$nodeListToHtmlString(nodes, _a) {
    var renderNode = _a.renderNode, renderMark = _a.renderMark, preserveWhitespace = _a.preserveWhitespace;
    return nodes.map(function(node) {
        return $c126cfb8d60b79c3$var$nodeToHtmlString(node, {
            renderNode: renderNode,
            renderMark: renderMark,
            preserveWhitespace: preserveWhitespace
        });
    }).join('');
}
function $c126cfb8d60b79c3$var$nodeToHtmlString(node, _a) {
    var renderNode = _a.renderNode, renderMark = _a.renderMark, preserveWhitespace = _a.preserveWhitespace;
    if ($c126cfb8d60b79c3$var$dist.helpers.isText(node)) {
        var nodeValue = $c126cfb8d60b79c3$var$escape(node.value);
        // If preserveWhitespace is true, handle line breaks and spaces.
        if (preserveWhitespace) nodeValue = nodeValue.replace(/\n/g, '<br/>').replace(/ {2,}/g, function(match) {
            return '&nbsp;'.repeat(match.length);
        });
        if (node.marks.length > 0) return node.marks.reduce(function(value, mark) {
            if (!renderMark[mark.type]) return value;
            return renderMark[mark.type](value);
        }, nodeValue);
        return nodeValue;
    } else {
        var nextNode = function(nodes) {
            return $c126cfb8d60b79c3$var$nodeListToHtmlString(nodes, {
                renderMark: renderMark,
                renderNode: renderNode,
                preserveWhitespace: preserveWhitespace
            });
        };
        if (!node.nodeType || !renderNode[node.nodeType]) // TODO: Figure what to return when passed an unrecognized node.
        return '';
        return renderNode[node.nodeType](node, nextNode);
    }
}
$c126cfb8d60b79c3$export$7baf571c7f59ce7c = $c126cfb8d60b79c3$var$documentToHtmlString;

});


parcelRegister("cml5G", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateMessages", function () { return $0e205cf17683e443$export$9e0b4d6f2449eaf; });

var $fnHPc = parcelRequire("fnHPc");
const $0e205cf17683e443$export$9e0b4d6f2449eaf = (0, $fnHPc.defineMessages)({
    templateTitle: {
        id: 'confluence.templates.detail.template.title',
        defaultMessage: '{templateName} template',
        description: "Template title, ex. 'Meeting notes template'"
    },
    templateAuthorByLine: {
        id: 'confluence.templates.detail.author.by',
        defaultMessage: 'by {author}',
        description: 'Author byline'
    },
    useTemplate: {
        id: 'confluence.templates.card.use-template',
        defaultMessage: 'Use template'
    },
    templateCategoriesLabel: {
        id: 'confluence.templates.categories.label',
        defaultMessage: 'Categories'
    },
    cardLearnMore: {
        id: 'confluence.templates.card.learn-more',
        defaultMessage: 'Learn more'
    },
    belongsToCollections: {
        id: 'confluence.templates.detail.belongs-to-collections',
        defaultMessage: 'Collections this template belongs to'
    },
    moreCollections: {
        id: 'confluence.templates.collection-details.more-collections',
        defaultMessage: 'More collections'
    },
    viewAllCollections: {
        id: 'confluence.templates.collection-details.view-all',
        defaultMessage: 'View all'
    },
    viewAllCollectionsLink: {
        id: 'confluence.templates.detail.collections-view-all',
        defaultMessage: 'View all'
    },
    viewAllCategoryTemplates: {
        id: 'confluence.templates.detail.category-view-all',
        defaultMessage: 'View all'
    },
    backToGallery: {
        id: 'confluence.templates.collection-details.back-to-gallery',
        defaultMessage: 'Back to template gallery'
    },
    collectionViewTemplate: {
        id: 'confluence.templates.collection-details.view-template',
        defaultMessage: 'View template'
    },
    moreTemplates: {
        id: 'confluence.templates.detail.more-templates',
        defaultMessage: 'More {category} templates'
    },
    searchInput: {
        id: 'confluence.templates.search.input.placeholder',
        defaultMessage: 'Search templates',
        description: 'Placeholder text for the confluence template search bar'
    },
    searchAriaLabel: {
        id: 'confluence.templates.search.submit',
        defaultMessage: 'Search',
        description: 'Aria label for the search button'
    },
    searchBackAriaLabel: {
        id: 'confluence.templates.search.back',
        defaultMessage: 'Back',
        description: 'Aria label for the back button'
    },
    carouselPreviousLabel: {
        id: 'confluence.templates.carousel.previous',
        defaultMessage: 'View previous'
    },
    carouselNextLabel: {
        id: 'confluence.templates.carousel.next',
        defaultMessage: 'View next'
    },
    fuzzySearchInputText: {
        id: 'confluence.templates.fuzzy.search.input.placeholder.text',
        defaultMessage: 'Search for Confluence templates',
        description: 'Placeholder text for the confluence template fuzzy search bar'
    },
    searchLabel: {
        id: 'confluence.templates.fuzzy.search.label',
        defaultMessage: 'Search'
    },
    closeLabel: {
        id: 'confluence.templates.fuzzy.close.label',
        defaultMessage: 'Close'
    },
    fuzzySearchAriaLabel: {
        id: 'confluence.templates.fuzzy.search.aria.label',
        defaultMessage: 'Search for Confluence templates',
        description: 'Aria label for the confluence template fuzzy search input'
    },
    templateAuthorBy: {
        id: 'confluence.templates.author.by',
        defaultMessage: 'By {author}',
        description: 'Author byline'
    },
    headerText: {
        id: 'confluence.main.area.title',
        defaultMessage: '{categoryName} Templates for Confluence',
        description: 'categoryName Templates for Confluence'
    },
    subHeaderText: {
        id: 'confluence.main.area.subHeaderText',
        defaultMessage: "Use Confluence to get a head start on your team's projects and docs.",
        description: 'subheader text for Confluence hero section'
    },
    loadMoreTemplatesButtonText: {
        id: 'confluence.templates.load.more.button.text',
        defaultMessage: 'Load more templates',
        description: 'Load More Templates button text'
    },
    noTemplatesAvailableText: {
        id: 'confluence.templates.no.templates.available.text',
        defaultMessage: 'No templates available.',
        description: 'No Templates available text'
    },
    defaultHeaderText: {
        id: 'confluence.main.area.default.header.text',
        defaultMessage: 'Templates for Confluence',
        description: 'Templates for Confluence header text'
    },
    additionalCategoriesText: {
        id: 'confluence.main.area.additional.categories.text',
        defaultMessage: 'Additional template categories',
        description: 'Templates Additional categories text'
    },
    relatedTemplatesTitle: {
        id: 'confluence.templates.related.templates.title',
        defaultMessage: 'Related Templates',
        description: 'Related templates title'
    },
    useTemplateButtonAriaText: {
        id: 'confluence.templates.useTemplate.button.aria.label',
        defaultMessage: 'Use {template}'
    }
});

});

parcelRegister("lRFwv", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateAnalytics", function () { return $30813192f9231baa$export$8c63aa07406e59c6; });

var $92PV0 = parcelRequire("92PV0");
const $30813192f9231baa$var$PREFIX = 'wac.showroom.';
class $30813192f9231baa$export$8c63aa07406e59c6 {
    static #_ = this.LearnMore = $30813192f9231baa$var$PREFIX + 'learn-more';
    static #_2 = this.ViewTemplates = $30813192f9231baa$var$PREFIX + 'view-templates';
    static #_3 = this.ViewTemplateCategory = $30813192f9231baa$var$PREFIX + 'view-template-category';
    static #_4 = this.ViewPartnerTemplate = $30813192f9231baa$var$PREFIX + 'view-partner-template';
    static #_5 = this.SearchBack = $30813192f9231baa$var$PREFIX + 'search-back';
    static #_6 = this.ViewAllCollections = $30813192f9231baa$var$PREFIX + 'view-all-more-collections';
    static #_7 = this.ViewAllCollectionsBelong = $30813192f9231baa$var$PREFIX + 'view-all-more-collections-belong';
    static #_8 = this.ViewAllTemplates = $30813192f9231baa$var$PREFIX + 'view-all-more-templates';
    static #_9 = this.BackToGallery = $30813192f9231baa$var$PREFIX + 'back-to-gallery';
    static #_10 = this.ViewTemplate = $30813192f9231baa$var$PREFIX + 'view-template';
    static #_11 = this.ViewTemplateTaxonomyCategory = $30813192f9231baa$var$PREFIX + 'view-template-taxonomy-category';
    static #_12 = this.DefaultProps = {
        'data-event-container': 'confluenceTemplates',
        'data-product-key': 'confluence'
    };
    /**
   * when the user clicks learn more
   * @param urlSlug
   * @param cardVariant
   */ static learnMoreButton(urlSlug, cardVariant) {
        // Example to list variant without firing experiment exposure
        // FeatureGates.getExperimentValue('experiment-key', 'variant', false, {
        //     fireExperimentExposure: false
        // });
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-cs-override-id': `template-card-overlay-${urlSlug}`,
            'data-event-component': 'linkButton',
            'data-template-key': urlSlug,
            'data-label': 'learn-more',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.LearnMore,
            'data-card-variant': cardVariant ?? 'modal'
        };
    }
    /**
   * when the user views a collection
   * @param urlSlug
   */ static viewTemplatesCollection(urlSlug) {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-collection-key': urlSlug,
            'data-label': 'view-templates',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.ViewTemplates
        };
    }
    /**
   * when the user selects a category to view templates
   * @param urlSlug
   */ static viewTemplateCategory(urlSlug) {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-category-key': urlSlug,
            'data-label': 'view-template-category',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.ViewTemplateCategory
        };
    }
    /**
   * when the user clicks view template on a partner template
   * @param urlSlug
   */ static viewPartnerTemplate(urlSlug) {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-template-key': urlSlug,
            'data-label': 'view-template',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.ViewPartnerTemplate
        };
    }
    /**
   * when the user clicks back button
   */ static searchBackButton() {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-label': 'search-back',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.SearchBack
        };
    }
    /**
   * when the user clicks view all collections on collection page
   */ static viewAllCollections() {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-label': 'view-all-collections',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.ViewAllCollections
        };
    }
    /**
   * when the user clicks view all templates in category on template page
   * @param urlSlug
   */ static viewAllCategoryTemplates(urlSlug) {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-category-key': urlSlug,
            'data-label': 'view-all-templates',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.ViewAllTemplates
        };
    }
    /**
   * when the user clicks view all collections a template belongs to
   */ static viewAllCollectionsBelong() {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-label': 'view-all-collections-belong',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.ViewAllCollectionsBelong
        };
    }
    /**
   * when the user clicks back to gallery from a collection
   */ static backToGalleryAnalyticProps() {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-label': 'back-to-gallery',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.BackToGallery
        };
    }
    /**
   * when a clicks view template in a collection page
   * @param urlSlug
   */ static viewTemplateAnalyticProps(urlSlug) {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-template-key': urlSlug,
            'data-label': 'view-template',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.ViewTemplate
        };
    }
    /**
   * when the user navigates through the partner template carousel
   * @param currentSlide
   * @param nextSlide
   * @param totalSlides
   */ static sendPartnerCarouselAnalytic(currentSlide, nextSlide, totalSlides) {
        // infinite so we will loop around so consider the direction
        const isRight = nextSlide > currentSlide || nextSlide === 0 && currentSlide === totalSlides - 1;
        (0, $92PV0.Tracking).trackEvent('wac.showroom.partner-template-carousel', {
            eventComponent: 'carouselItem',
            eventContainer: 'confluenceTemplates',
            carouselDirection: isRight ? 'right' : 'left'
        });
    }
    /**
   * Fired when the user navigates through the collection carousel
   * @param currentSlide
   * @param nextSlide
   * @param totalSlides
   */ static sendCollectionCarouselAnalytic(currentSlide, nextSlide, totalSlides) {
        // infinite so we will loop around so consider the direction
        const isRight = nextSlide > currentSlide || nextSlide === 0 && currentSlide === totalSlides - 1;
        (0, $92PV0.Tracking).trackEvent('wac.showroom.collection-carousel', {
            eventComponent: 'carouselItem',
            eventContainer: 'confluenceTemplates',
            carouselDirection: isRight ? 'right' : 'left'
        });
    }
    /**
   *
   * Fired when the user submits on a search
   */ static sendTemplateSearchAnalytic() {
        (0, $92PV0.Tracking).trackEvent('wac.showroom.template-search', {
            eventComponent: 'searchInput',
            eventContainer: 'confluenceTemplates'
        });
    }
    /**
   * when the user enters data into search we want to see how many results are returned
   */ static sendTemplateSearchResultsAnalytic(searchResults) {
        (0, $92PV0.Tracking).trackEvent('wac.showroom.template-search-results', {
            eventComponent: 'search',
            eventContainer: 'confluenceTemplates',
            searchResults: searchResults
        });
    }
    /**
   * when the user enters data into search
   */ static sendTemplateFuzzySearchAnalytic() {
        (0, $92PV0.Tracking).trackEvent('wac.showroom.template-fuzzy-search', {
            eventComponent: 'fuzzySearchInput',
            eventContainer: 'confluenceTemplates'
        });
    }
    /**
   * when the user clicks into search
   */ static sendTemplateFuzzySearchFocusAnalytic() {
        (0, $92PV0.Tracking).trackEvent('wac.showroom.template-fuzzy-search-focus', {
            eventComponent: 'fuzzySearchFocus',
            eventContainer: 'confluenceTemplates'
        });
    }
    /**
   * when the user enters data into fuzzy search we want to see how many results are returned
   */ static sendTemplateFuzzySearchResultsAnalytic(searchResults) {
        (0, $92PV0.Tracking).trackEvent('wac.showroom.template-fuzzy-search-results', {
            eventComponent: 'fuzzySearch',
            eventContainer: 'confluenceTemplates',
            searchResults: searchResults
        });
    }
    /**
   * when the user clicks on any preview item
   */ static sendTemplateFuzzySearchPreviewAnalytic(searchItem) {
        (0, $92PV0.Tracking).trackEvent('wac.showroom.template-fuzzy-search-preview', {
            eventComponent: 'previewItem',
            eventContainer: 'confluenceTemplates',
            searchItemName: searchItem?.name ?? '',
            searchItemId: searchItem?.id ?? '',
            searchItemType: searchItem.type ?? ''
        });
    }
    /**
   * when the user selects a category to view templates on unified page
   * @param urlSlug
   */ static viewTemplateFuzzySearchCategory(urlSlug) {
        return {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            'data-event-component': 'linkButton',
            'data-category-key': urlSlug,
            'data-label': 'view-template-fuzzy-search-category',
            'data-track-event': $30813192f9231baa$export$8c63aa07406e59c6.ViewTemplateCategory
        };
    }
    /**
   * when the user selects a taxonomy category to view templates on unified page
   * @param urlSlug
   */ static viewTemplatesTaxonomyCategory(urlSlug) {
        (0, $92PV0.Tracking).trackEvent($30813192f9231baa$export$8c63aa07406e59c6.ViewTemplateTaxonomyCategory, {
            ...$30813192f9231baa$export$8c63aa07406e59c6.DefaultProps,
            eventComponent: 'linkButton',
            eventContainer: 'confluenceTemplates',
            categoryName: urlSlug
        });
    }
}

});

parcelRegister("6SdoX", function(module, exports) {
$parcel$export(module.exports, "SanitizedRichText", function () { return $f729c225e2cabe6e$export$efb77abbd0a81997; });
/* sanitized-rich-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $a0utR = parcelRequire("a0utR");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $f729c225e2cabe6e$var$styles = null;
const $f729c225e2cabe6e$export$efb77abbd0a81997 = ({ innerHTML: innerHTML, tagName: Component = 'span', className: className })=>{
    if (typeof innerHTML === 'string') return /*#__PURE__*/ (0, $7VQPk.jsx)(Component, {
        className: (0, $2jatx.default)([
            "_754n1j6v _1ci51k8s _zgxm1nn1 _171salr3 _1xssz4z1 _1vapidpf _1qwqidpf _14qeidpf _18obidpf _1ps4rbzz _qs4s1r31 _iidjglyw _jopknqa1 _1dipoelr _1bw11r31 _swvz8stv _1vxgnqa1 _1uo11r31 _gugqglyw _1l07nqa1 _mvak1r31 _17u5glyw _1ldznqa1 _116xrbzz _15zsidpf _150widpf _1g0midpf _1s9iidpf _xbdr1tcg",
            `styled-text ${className ?? ''}`
        ]),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(innerHTML)
        },
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text'))
        }
    });
    else return null;
};

});

parcelRegister("1Ztwq", function(module, exports) {
$parcel$export(module.exports, "TemplateCard", function () { return $758a83f5314d1da9$export$ba340e850b866867; });
/* template-card-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("20OkY");
var $7gFRR = parcelRequire("7gFRR");

var $cml5G = parcelRequire("cml5G");

var $isyQr = parcelRequire("isyQr");

var $4QdnC = parcelRequire("4QdnC");

var $lRFwv = parcelRequire("lRFwv");

var $iHYHa = parcelRequire("iHYHa");

var $jQ0cd = parcelRequire("jQ0cd");
var $758a83f5314d1da9$var$_templateCardContentfulRelayFragment;
const $758a83f5314d1da9$var$fontCharlieText = `"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $758a83f5314d1da9$var$fontCharlieDisplay = `"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $758a83f5314d1da9$var$defaultImgSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/p17h52fiv34d06123v38e23cbi421x61.svg';
const $758a83f5314d1da9$var$templateCardContainerStyles = null;
const $758a83f5314d1da9$var$templateCardInfoStyles = null;
const $758a83f5314d1da9$var$templateCardInfoWrapper = null;
const $758a83f5314d1da9$var$templateCardTitleStyles = null;
const $758a83f5314d1da9$var$templateCardDescriptionStyles = null;
const $758a83f5314d1da9$var$templateCardActionStyles = null;
const $758a83f5314d1da9$var$templateCardActionOverlayStyles = null;
const $758a83f5314d1da9$var$templateCardLearnMoreStyles = null;
const $758a83f5314d1da9$var$templatePreviewStyles = null;
const $758a83f5314d1da9$var$templateImageWrapper = null;
const $758a83f5314d1da9$var$templateCardLearnMoreLinkStyle = null;
const $758a83f5314d1da9$var$templateCardInfoHeaderAuthorStyles = null;

const $758a83f5314d1da9$var$TemplateCardFragment = $758a83f5314d1da9$var$_templateCardContentfulRelayFragment !== void 0 ? $758a83f5314d1da9$var$_templateCardContentfulRelayFragment : ($758a83f5314d1da9$var$_templateCardContentfulRelayFragment = (parcelRequire("23BdP")), $758a83f5314d1da9$var$_templateCardContentfulRelayFragment.hash && $758a83f5314d1da9$var$_templateCardContentfulRelayFragment.hash !== "6185ffb3a68cb45e8c6384f28e728c05" && console.error("The definition of 'templateCardContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $758a83f5314d1da9$var$_templateCardContentfulRelayFragment);
const $758a83f5314d1da9$export$ba340e850b866867 = ({ template: template, background: background })=>{
    const data = (0, $f3gS9.useFragment)($758a83f5314d1da9$var$TemplateCardFragment, template);
    const intl = (0, $8e22h.default)();
    const learnMoreHref = (0, $jQ0cd.useLocalizedHref)(`/software/confluence/templates/${data.urlSlug}`);
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    let companyName;
    switch(data.contributor?.__typename){
        case 'CompanyNameInternal':
            companyName = data.contributor.organizationNameExternal;
            break;
        case 'Author':
            companyName = data.contributor.organization?.organizationNameExternal;
            break;
    }
    const templateName = intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).templateTitle, {
        templateName: data.templateNameExternal ?? ''
    });
    const handleCardClick = ()=>{
        const templateId = data.pluginModuleKey ?? '';
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'linkButton',
            attributes: {
                templateName: templateName,
                label: templateName,
                path: location.pathname,
                event_type: 'ui',
                url: location.href,
                product: (0, $7gFRR.ProductKeys).CONFLUENCE,
                templateId: templateId,
                sandbox: true,
                trackEventName: 'wac.showroom.clicked-use-template'
            }
        }).fire();
        openModalForTemplate({
            templateId: templateId,
            templateName: templateName,
            productKey: (0, $7gFRR.ProductKeys).CONFLUENCE
        });
    };
    const [imgSrc, setImgSrc] = (0, $1oC0p.useState)((0, $isyQr.templateSvgLinks)[data.urlSlug ?? ''] ?? `https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/taxonomy/${data.urlSlug}.svg`);
    const imgRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useLayoutEffect)(()=>{
        // If the img load completes before hydration,
        // a broken img won't be caught by the onError handler.
        // So, we check if the img is complete and set the src again.
        // If it is broken, the onError handler will catch it and
        // switch to the default image.
        if (imgRef.current?.complete && imgSrc !== $758a83f5314d1da9$var$defaultImgSrc) imgRef.current.src = imgSrc;
    }, [
        imgSrc
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-templates-card-cfind1795",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-cs-override-id": `template-card-container-${data.sys.id}`,
            className: (0, $2jatx.default)([
                "_kqswh2mm _2rkoi2wt _1bsb1feq _1tke1kdj _16qs58tj _1reo15vq _18m915vq _vchhusvi _v5641vti _1dbzdtw3 _am7mkb7n _1cr5ejb5 _12rrnklw _1llynklw"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-cs-override-id": `template-card-${data.sys.id}`,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1yb4 _1reo15vq _18m915vq _4t3i1osq _1wpz1fhb"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_16jlidpf _1o9zkb7n _i0dluuw1 _1reo15vq _18m915vq _938ridpf _1tihkb7n _1oqbuuw1 _1lrw1dfr _12vemgnk _1o9zidpf",
                                "_11q7izeb",
                                "templateHoverStyles"
                            ]),
                            style: {
                                "--_1k9t07z": (0, $6ZVlx.default)(background)
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                ref: imgRef,
                                src: imgSrc,
                                alt: "",
                                onError: imgSrc !== $758a83f5314d1da9$var$defaultImgSrc ? ()=>setImgSrc($758a83f5314d1da9$var$defaultImgSrc) : undefined,
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _ca0q1tcg _u5f31tcg _n3tdidpf _19bv1tcg"
                                ])
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            onClick: handleCardClick,
                            "data-testid": "template-card-clickable",
                            className: (0, $2jatx.default)([
                                "_1pbykb7n _16jlkb7n _1o9zkb7n _i0dlf1ug _bfhku67f _1e0c1txw _2lx21bp4 _1bah1yb4 _ca0q1tcg _u5f3idpf _n3tdidpf _19bv1tcg _2rkoi2wt _80omtlke _4t3i1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_ect41bwv _1wybgktf _k48p1fw0 _vwz41ul9 _1dyznl7k _syazqlpt _19pkidpf _2hwxidpf _otyridpf _18u0idpf _16liqslr _1rf11f4h"
                                    ]),
                                    children: data.templateNameExternal
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_ect41fn2 _1wyb7vkz _k48p1nn1 _vwz41tcg _syaz1bqd _ca0qftgi _u5f31tcg _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _17gq183y"
                                    ]),
                                    children: data.previewBlurb
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: companyName && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_ect41fn2 _1wybdlk8 _k48p1nn1 _vwz4gktf _ca0q7vkz _u5f31tcg _n3td7vkz _19bvidpf _syazuxx4"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            ...(0, $cml5G.ConfluenceTemplateMessages).templateAuthorBy,
                                            values: {
                                                author: companyName
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1nrf _2rko1y44 _bfhk1ret _v564yoi0 _tzy4idpf _1vkhmlf1 _1g6w1ssb",
                        "templateHoverStyles"
                    ]),
                    "data-cs-override-id": `template-card-actions-${data.sys.id}`,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1osq _kqswh2mm _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1h6o _zulpgktf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: learnMoreHref,
                                ...(0, $lRFwv.ConfluenceTemplateAnalytics).learnMoreButton(data.urlSlug, 'template'),
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _1e02idpf _u7coidpf _rjxpidpf"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4QdnC.UseTemplateButton), {
                                templateName: templateName,
                                blueprintModuleKey: data.pluginModuleKey
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_syazoelr _19itglyw _lcxvglyw _1bah1h6o _4cvr1h6o _ect41fn2 _1wybdlk8 _k48pni7l _vwz4gktf _zulp1y44"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...(0, $cml5G.ConfluenceTemplateMessages).cardLearnMore
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("isyQr", function(module, exports) {
$parcel$export(module.exports, "templateSvgLinks", function () { return $8df29e3b044f8e90$export$b8127259d87ee605; });
// temporary until these images gets stored in Contentful, after experiment is complete.
const $8df29e3b044f8e90$export$b8127259d87ee605 = {
    '2x2-prioritization-method': 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ss00s8n0e7a1vbx607r36gyd31j838k.svg',
    '4-ls-retro': 'https://dam-cdn.atl.orangelogic.com/AssetLink/ahpu48768s010f08n7h04ys2all11542.svg',
    '4-ls-retro-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/ahpu48768s010f08n7h04ys2all11542.svg',
    'annual-calendar': 'https://dam-cdn.atl.orangelogic.com/AssetLink/0cb43td53sjh56j0twgpnox5mu2ggnh8.svg',
    brainwriting: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l21dg4ufcg8x64374ga618j0s7i6y74q.svg',
    'concept-map': 'https://dam-cdn.atl.orangelogic.com/AssetLink/7aa8s2d05pq1kkh1142pl6r1mt132t14.svg',
    'crazy-8s-brainstorming': 'https://dam-cdn.atl.orangelogic.com/AssetLink/0y47r03480410d08og3y0y236xn5i1p2.svg',
    'daily-sync': 'https://dam-cdn.atl.orangelogic.com/AssetLink/on4p61563x4q84m08eg40rx276451p1s.svg',
    'daily-sync-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/on4p61563x4q84m08eg40rx276451p1s.svg',
    'disruptive-brainstorm': 'https://dam-cdn.atl.orangelogic.com/AssetLink/0o18f3kmo75u42072lrg0svmd852ku8k.svg',
    'disruptive-brainstorm-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/0o18f3kmo75u42072lrg0svmd852ku8k.svg',
    'dot-voting': 'https://dam-cdn.atl.orangelogic.com/AssetLink/30p313k12tr5p056jfr53x26f0l7b2e2.svg',
    'elevator-pitch-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/5u8b4i1104l3d762gb8023m1itq7l34x.svg',
    'flow-chart': 'https://dam-cdn.atl.orangelogic.com/AssetLink/1021auuw5ap1q5d044fxix2dolqo3475.svg',
    flowchart: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1021auuw5ap1q5d044fxix2dolqo3475.svg',
    'gap-analysis': 'https://dam-cdn.atl.orangelogic.com/AssetLink/p0q3jn0n301l1r78ap6ahi41v56e76o8.svg',
    'ice-breakers': 'https://dam-cdn.atl.orangelogic.com/AssetLink/0b1dp17lk40qvb60qsk13nd45810rn75.svg',
    'incident-postmortem-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/c87g57cy3580dq5u43wrw0640k421357.svg',
    'kanban-board': 'https://dam-cdn.atl.orangelogic.com/AssetLink/7812ri8hq4fdk33640406bm35q224u63.svg',
    'kanban-board-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/7812ri8hq4fdk33640406bm35q224u63.svg',
    'lean-coffee': 'https://dam-cdn.atl.orangelogic.com/AssetLink/tc862c45s8o8fqbsb5d11p65md4qv884.svg',
    'lennys-performance-review': 'https://dam-cdn.atl.orangelogic.com/AssetLink/g52c3m5s2b606v0nn08s74x7642q1m8w.svg',
    'lennys-product-requirements': 'https://dam-cdn.atl.orangelogic.com/AssetLink/010tg8dm786876o2e1mvvq77u72yyd37.svg',
    'lennys-state-of-me': 'https://dam-cdn.atl.orangelogic.com/AssetLink/g5iyq61bypd420831yjg4k7n55jbkc41.svg',
    'network-of-teams': 'https://dam-cdn.atl.orangelogic.com/AssetLink/q301rqo02n88c0ykj2v06ah6rs52t1wj.svg',
    'team-mapping': 'https://dam-cdn.atl.orangelogic.com/AssetLink/q301rqo02n88c0ykj2v06ah6rs52t1wj.svg',
    'org-chart': 'https://dam-cdn.atl.orangelogic.com/AssetLink/od84s4w4bpe151hgpeg82n367qgd17s5.svg',
    'pi-planning': 'https://dam-cdn.atl.orangelogic.com/AssetLink/5iac63j10ps155ve2q57540f5t4gus4k.svg',
    'prioritization-matrix-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/oaa52dq7f1eev7pj0h3e85fplx2f7711.svg',
    'product-roadmap-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/65psukwnmo16f2dtjv75dt4em8728ew6.svg',
    'product-vision-board': 'https://dam-cdn.atl.orangelogic.com/AssetLink/f258y408b41i0pxgjb38r361a3bu3q8i.svg',
    rice: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8vj4aachd5nx3yhn1rb81708a1c72rv4.svg',
    'sailboat-retro': 'https://dam-cdn.atl.orangelogic.com/AssetLink/kvjdg3p2j2e351m321w414001a42bk3n.svg',
    'sailboat-retrospective': 'https://dam-cdn.atl.orangelogic.com/AssetLink/kvjdg3p2j2e351m321w414001a42bk3n.svg',
    'service-blueprint': 'https://dam-cdn.atl.orangelogic.com/AssetLink/6ws4u3jxp67sj58h8d16001a128x0u3c.svg',
    'simple-retrospective': 'https://dam-cdn.atl.orangelogic.com/AssetLink/j404k1p0iopj0qn8s5p84c1224na3md5.svg',
    'retrospective-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/j404k1p0iopj0qn8s5p84c1224na3md5.svg',
    'sprint-planning': 'https://dam-cdn.atl.orangelogic.com/AssetLink/854es1j4ew547vjsl42uy64p22n4r62h.svg',
    'sprint-planning-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/854es1j4ew547vjsl42uy64p22n4r62h.svg',
    'sticky-note-pack': 'https://dam-cdn.atl.orangelogic.com/AssetLink/77127jatwnyd7c21k20441lof708l584.svg',
    swimlanes: 'https://dam-cdn.atl.orangelogic.com/AssetLink/524evc254n0s468r3c42861xvm25c58n.svg',
    'swimlane-diagram': 'https://dam-cdn.atl.orangelogic.com/AssetLink/524evc254n0s468r3c42861xvm25c58n.svg',
    'team-formation-guide': 'https://dam-cdn.atl.orangelogic.com/AssetLink/uj6k4b0a158cey576h6ohbawnqx2i1fl.svg',
    'team-charter': 'https://dam-cdn.atl.orangelogic.com/AssetLink/uj6k4b0a158cey576h6ohbawnqx2i1fl.svg',
    timeline: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y4104l55rku2e36w4rdtl10d4bm27ag8.svg',
    'timeline-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/y4104l55rku2e36w4rdtl10d4bm27ag8.svg',
    'timeline-workflow': 'https://dam-cdn.atl.orangelogic.com/AssetLink/2pt0c544fu3fiu7ww6shud0hgsyd02am.svg',
    'user-story-map': 'https://dam-cdn.atl.orangelogic.com/AssetLink/c74prcgjt52068iow25tubf380cr73jy.svg',
    workflow: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1h0710ii7766ye00x2v81m0br1eef0fq.svg',
    'workflow-whiteboard': 'https://dam-cdn.atl.orangelogic.com/AssetLink/1h0710ii7766ye00x2v81m0br1eef0fq.svg',
    'fishbone-diagram': 'https://dam-cdn.atl.orangelogic.com/AssetLink/xmsbpvd507saev2hrtr7pwdgvwgs607m.svg'
};

});

parcelRegister("4QdnC", function(module, exports) {
$parcel$export(module.exports, "UseTemplateButton", function () { return $9922aac537ccdce1$export$b71133107678fe41; });
/* use-template-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");
parcelRequire("20OkY");
var $7gFRR = parcelRequire("7gFRR");

var $cml5G = parcelRequire("cml5G");

var $iHYHa = parcelRequire("iHYHa");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $dqd4k = parcelRequire("dqd4k");
const $9922aac537ccdce1$var$templateButtonActionLinkStyles = null;
const $9922aac537ccdce1$export$b71133107678fe41 = ({ blueprintModuleKey: blueprintModuleKey, templateName: templateName })=>{
    const intl = (0, $8e22h.default)();
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const { addTemplateCardCallback: addTemplateCardCallback } = (0, $dqd4k.useGupsStatus)();
    const navigateToUseTemplate = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        const templateId = blueprintModuleKey ?? '';
        openModalForTemplate({
            templateId: templateId,
            templateName: templateName,
            productKey: (0, $7gFRR.ProductKeys).CONFLUENCE
        });
        addTemplateCardCallback(templateId);
    };
    const buttonTemplateId = templateName.replace(/ /g, '-');
    const buttonId = `use-template-button-${buttonTemplateId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: navigateToUseTemplate,
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1bah1h6o _11q7u5k9 _2rko6mu8 _vchhusvi _1e0c116y _1ul91qr7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1wug _1tkezwfg _19itglyw _vwz4qgp8 _y3gn1h6o _80omtlke _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _1wyboxwj _k48pbfng _ect41dpo _syazu67f _4bfu1r31 _1hmsglyw _ajmmnqa1 _1pbykb7n _19lcftjs _1du2ftjs _1bg41y44 _j6xtftjs",
            "doNotAutoTrack"
        ]),
        "aria-label": intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).useTemplateButtonAriaText, {
            template: templateName
        }),
        id: buttonId,
        style: {
            "--_5dnsy5": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue700')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue800'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            ...(0, $cml5G.ConfluenceTemplateMessages).useTemplate
        })
    });
};

});

parcelRegister("23BdP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $036ea3c10f43b0f5$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<caf5ee8a635e003641b575392964526f>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $036ea3c10f43b0f5$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateCardContentfulRelayFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateNameExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlSlug",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pluginModuleKey",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previewBlurb",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateTypeCollection",
                "kind": "LinkedField",
                "name": "templateTypeCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyTemplateType",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "templateTypeNameExternal",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contributor",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternal",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": v1 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "type": "Author",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v1 /*: any*/ ,
                        "type": "CompanyNameInternal",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ProductTemplate",
        "abstractKey": null
    };
}();
$036ea3c10f43b0f5$var$node.hash = "6185ffb3a68cb45e8c6384f28e728c05";
var $036ea3c10f43b0f5$export$2e2bcd8739ae039 = $036ea3c10f43b0f5$var$node;

});


parcelRegister("luddA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $ac159e2b33cd34e1$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<770c9ad79067fe196d20e1c07a092f99>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ac159e2b33cd34e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionGuideSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateCollectionGuideNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "CollectionGuideCollectionStepsCollection",
            "kind": "LinkedField",
            "name": "collectionStepsCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateCollectionStep",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stepNameExternal",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stepSubheading",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateCollectionStepStepDescription",
                            "kind": "LinkedField",
                            "name": "stepDescription",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "json",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "relatedTemplate",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "urlSlug",
                                    "storageKey": null
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateCardContentfulRelayFragment"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "CollectionGuide",
    "abstractKey": null
};
$ac159e2b33cd34e1$var$node.hash = "1322567ec9bf43ef4ca8dc0fe46bd69f";
var $ac159e2b33cd34e1$export$2e2bcd8739ae039 = $ac159e2b33cd34e1$var$node;

});


parcelRegister("lkdtg", function(module, exports) {
$parcel$export(module.exports, "CollectionHeaderSection", function () { return $59c44d99c048a319$export$e0a60425c82b7176; });
/* collection-header-section-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $f3gS9 = parcelRequire("f3gS9");
var $59c44d99c048a319$var$_collectionHeaderSectionContentfulRelayFragment;
const $59c44d99c048a319$var$backgroundStyles = null;
const $59c44d99c048a319$var$collectionHeadingSection = null;
const $59c44d99c048a319$var$collectionTitle = null;
const $59c44d99c048a319$var$collectionHeadline = null;
const $59c44d99c048a319$var$dividerStyle = null;

const $59c44d99c048a319$var$CollectionHeaderSectionRelayFragment = $59c44d99c048a319$var$_collectionHeaderSectionContentfulRelayFragment !== void 0 ? $59c44d99c048a319$var$_collectionHeaderSectionContentfulRelayFragment : ($59c44d99c048a319$var$_collectionHeaderSectionContentfulRelayFragment = (parcelRequire("4qZ6c")), $59c44d99c048a319$var$_collectionHeaderSectionContentfulRelayFragment.hash && $59c44d99c048a319$var$_collectionHeaderSectionContentfulRelayFragment.hash !== "2db096abc2188a39c11adfc4c3107e1b" && console.error("The definition of 'collectionHeaderSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $59c44d99c048a319$var$_collectionHeaderSectionContentfulRelayFragment);
const $59c44d99c048a319$export$e0a60425c82b7176 = ({ collection: collection })=>{
    const { collectionNameExternal: collectionNameExternal, oneLinerHeadline: oneLinerHeadline } = (0, $f3gS9.useFragment)($59c44d99c048a319$var$CollectionHeaderSectionRelayFragment, collection);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("header", {
        className: (0, $2jatx.default)([
            "_1q51vbgk _11q79eel _xc2iidpf _w0geglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_y3gn1h6o _p12fyl33 _1q51ys9h _bozgys9h _y4tiys9h _85i51h39 _19pkidpf _2hwx1wug _otyridpf _18u01wug _bfhku67f _144tidpf _q9tovbgk _17arvbgk _1tbzzwfg _6881zwfg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wyb1wto _vwz41k7u _k48pbfng _syazalr3 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1j6v _flz0yn4p _280z1tnc _so7d8pqr _19q11p2n"
                    ]),
                    children: collectionNameExternal
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1wyb1k92 _vwz41m1q _k48p1nn1 _syazalr3 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ejb _1v871k92 _kuia1m1q _1egl1jfw"
                    ]),
                    children: oneLinerHeadline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                    className: (0, $2jatx.default)([
                        "_1e0cglyw _1bsb11ux _19itywev _19pkidpf _2hwx1wug _otyridpf _18u01wug _1mjb1ule"
                    ])
                })
            ]
        })
    });
};

});
parcelRegister("4qZ6c", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $c4099efd90db0910$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<90e1499508d9a481b7541d70b15282fe>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c4099efd90db0910$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionHeaderSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "collectionNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oneLinerHeadline",
            "storageKey": null
        }
    ],
    "type": "TemplateCollection",
    "abstractKey": null
};
$c4099efd90db0910$var$node.hash = "2db096abc2188a39c11adfc4c3107e1b";
var $c4099efd90db0910$export$2e2bcd8739ae039 = $c4099efd90db0910$var$node;

});


parcelRegister("iERy6", function(module, exports) {
$parcel$export(module.exports, "CollectionRelatedSection", function () { return $04a59f74c95fc91b$export$87a43c2b2ebc1974; });
/* collection-related-section-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $f3gS9 = parcelRequire("f3gS9");

var $cml5G = parcelRequire("cml5G");

var $lRFwv = parcelRequire("lRFwv");

var $jQ0cd = parcelRequire("jQ0cd");

var $b8G12 = parcelRequire("b8G12");
var $04a59f74c95fc91b$var$_collectionRelatedSectionContentfulRelayFragment;
const $04a59f74c95fc91b$var$sectionStyle = null;
const $04a59f74c95fc91b$var$headingStyle = null;
const $04a59f74c95fc91b$var$collectionsBox = null;
const $04a59f74c95fc91b$var$hrefStyle = null;
const $04a59f74c95fc91b$var$backWrapper = null;

const $04a59f74c95fc91b$var$CollectionRelatedSectionRelayFragment = $04a59f74c95fc91b$var$_collectionRelatedSectionContentfulRelayFragment !== void 0 ? $04a59f74c95fc91b$var$_collectionRelatedSectionContentfulRelayFragment : ($04a59f74c95fc91b$var$_collectionRelatedSectionContentfulRelayFragment = (parcelRequire("cHAuX")), $04a59f74c95fc91b$var$_collectionRelatedSectionContentfulRelayFragment.hash && $04a59f74c95fc91b$var$_collectionRelatedSectionContentfulRelayFragment.hash !== "c7fa5bba8ccaa025e0048f8a3ee9d86d" && console.error("The definition of 'collectionRelatedSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $04a59f74c95fc91b$var$_collectionRelatedSectionContentfulRelayFragment);
const $04a59f74c95fc91b$export$87a43c2b2ebc1974 = ({ collections: collections })=>{
    const data = (0, $f3gS9.useFragment)($04a59f74c95fc91b$var$CollectionRelatedSectionRelayFragment, collections);
    const viewAllHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/templates');
    if (!data || !Array.isArray(data)) return null;
    const firstTwoCollections = data.slice(0, 2);
    if (firstTwoCollections.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                "data-testid": "confluence-template-collection-related",
                className: (0, $2jatx.default)([
                    "_1q5116xz"
                ]),
                children: firstTwoCollections && firstTwoCollections.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                            className: (0, $2jatx.default)([
                                "_1wyb1k8s _vwz4viql _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqs1k92 _1bys1k8s"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...(0, $cml5G.ConfluenceTemplateMessages).moreCollections
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: viewAllHref,
                                    ...(0, $lRFwv.ConfluenceTemplateAnalytics).viewAllCollections(),
                                    className: (0, $2jatx.default)([
                                        "_syazrbzz _k48pbfng _1wyb1j6v _vwz41k92 _4bfu1r31 _1hms8stv _ajmmnqa1 _ahbq7vkz _30l3oelr _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _1053rbzz"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $cml5G.ConfluenceTemplateMessages).viewAllCollections
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1q51zwfg _1e0c1txw _zulpzwfg _1n261g80 _81647vkz"
                            ]),
                            children: firstTwoCollections.map((collection)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $b8G12.CollectionCardRelay), {
                                    collection: collection
                                }, collection.sys.id))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _1q5116xz _85i516xz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: viewAllHref,
                    ...(0, $lRFwv.ConfluenceTemplateAnalytics).backToGalleryAnalyticProps(),
                    className: (0, $2jatx.default)([
                        "_syazrbzz _k48pbfng _1wyb1j6v _vwz41k92 _4bfu1r31 _1hms8stv _ajmmnqa1 _ahbq7vkz _30l3oelr _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _1053rbzz"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $cml5G.ConfluenceTemplateMessages).backToGallery
                    })
                })
            })
        ]
    });
};

});
parcelRegister("b8G12", function(module, exports) {
$parcel$export(module.exports, "CollectionCardRelay", function () { return $504902a179795756$export$38139bbb746460cb; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $7fFNY = parcelRequire("7fFNY");
var $504902a179795756$var$_collectionCardContentfulRelayFragment;

const $504902a179795756$var$CollectionCardFragment = $504902a179795756$var$_collectionCardContentfulRelayFragment !== void 0 ? $504902a179795756$var$_collectionCardContentfulRelayFragment : ($504902a179795756$var$_collectionCardContentfulRelayFragment = (parcelRequire("8NlzJ")), $504902a179795756$var$_collectionCardContentfulRelayFragment.hash && $504902a179795756$var$_collectionCardContentfulRelayFragment.hash !== "d8241124bca686ed67a1144a13588d49" && console.error("The definition of 'collectionCardContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $504902a179795756$var$_collectionCardContentfulRelayFragment);
const $504902a179795756$export$38139bbb746460cb = ({ collection: collection })=>{
    const data = (0, $f3gS9.useFragment)($504902a179795756$var$CollectionCardFragment, collection);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7fFNY.CollectionCard), {
        urlSlug: data.urlSlug,
        templateCount: data.howToUseThisCollection?.collectionStepsCollection?.total ?? 0,
        name: data.collectionNameExternal ?? ''
    });
};

});
parcelRegister("7fFNY", function(module, exports) {
$parcel$export(module.exports, "CollectionCard", function () { return $b86285dae20ce764$export$d5597bfe96a524db; });
/* collection-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");
// Utility function to sanitize strings for use as HTML IDs
const $b86285dae20ce764$var$sanitizeId = (str)=>{
    return str.toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
};
const $b86285dae20ce764$var$rootCss = null;
const $b86285dae20ce764$var$contentCss = null;
const $b86285dae20ce764$var$imageContainerCss = null;
const $b86285dae20ce764$var$textContainerCss = null;
const $b86285dae20ce764$var$titleCss = null;
const $b86285dae20ce764$var$textLinkCss = null;
const $b86285dae20ce764$var$imageUrls = {
    'project-management': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/project-management.svg',
    'strategic-planning': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/strategic-planning.svg',
    'product-managers': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/product-managers.svg',
    hr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/hr.svg',
    'knowledge-base': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/knowledge-base.svg',
    'remote-work': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/remote-work.svg',
    'software-development': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/software-development.svg',
    'product-launch': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/product-launch.svg',
    'designs-at-scale': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/designs-at-scale.svg',
    'marketing-strategy': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-strategy.svg',
    'employee-development': 'https://wac-cdn.atlassian.com/misc-assets/webp-images/employee-development.svg'
};
const $b86285dae20ce764$export$d5597bfe96a524db = (props)=>{
    const localizedLink = (0, $jQ0cd.useLocalizedHref)(`/software/confluence/templates/collections/${props.urlSlug}`);
    const imageUrl = $b86285dae20ce764$var$imageUrls[props.urlSlug];
    const uniquePartnerTemplateId = $b86285dae20ce764$var$sanitizeId(props.urlSlug || '');
    // Generate unique IDs for accessibility
    const headingId = `collection-heading-${uniquePartnerTemplateId}`;
    const linkId = `collection-link-${uniquePartnerTemplateId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "confluence-templates-collection-card",
        className: (0, $2jatx.default)([
            "_2rkoi2wt _bfhku67f _16qsdtw3 _1bsb1feq _g65p1j89"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: localizedLink,
            id: linkId,
            "aria-labelledby": `${linkId} ${headingId}`,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1rp4"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                            src: imageUrl,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulpftgi _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                id: headingId,
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _ect4kipj _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: props.name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_syazoelr _1wyb7vkz _ect48q0o",
                                    "collection-card-text-link"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "confluence.templates.collection-card.view-link",
                                        defaultMessage: `View {count} templates`,
                                        values: {
                                            count: props.templateCount
                                        }
                                    }),
                                    " \u2192"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});

parcelRegister("8NlzJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $6cf8d0d377045a20$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<8e438726ee554b0daca048ba04f18906>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6cf8d0d377045a20$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionCardContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Sys",
            "kind": "LinkedField",
            "name": "sys",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "collectionNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urlSlug",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "collectionIcon",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "CollectionGuide",
            "kind": "LinkedField",
            "name": "howToUseThisCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CollectionGuideCollectionStepsCollection",
                    "kind": "LinkedField",
                    "name": "collectionStepsCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "TemplateCollection",
    "abstractKey": null
};
$6cf8d0d377045a20$var$node.hash = "d8241124bca686ed67a1144a13588d49";
var $6cf8d0d377045a20$export$2e2bcd8739ae039 = $6cf8d0d377045a20$var$node;

});


parcelRegister("cHAuX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $9678a4913ce94bec$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<e31ba45688eb4e8629ac33b2708fcd33>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9678a4913ce94bec$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "collectionRelatedSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Sys",
            "kind": "LinkedField",
            "name": "sys",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "collectionCardContentfulRelayFragment"
        }
    ],
    "type": "TemplateCollection",
    "abstractKey": null
};
$9678a4913ce94bec$var$node.hash = "c7fa5bba8ccaa025e0048f8a3ee9d86d";
var $9678a4913ce94bec$export$2e2bcd8739ae039 = $9678a4913ce94bec$var$node;

});


parcelRegister("hfq9I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $a0c0885f0b2aff55$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<f2317d59fd6baa2d3e1d9491742fff06>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a0c0885f0b2aff55$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "relatedCollectionUrlSlugs"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "urlSlug"
    }, v3 = {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        },
        v3 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "urlSlug",
                    "variableName": "urlSlug"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "collectionNameExternal",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oneLinerHeadline",
        "storageKey": null
    }, v8 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 2
        },
        v3 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "urlSlug_in",
                    "variableName": "relatedCollectionUrlSlugs"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v9 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v11 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ], v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "confluenceTemplateCollectionDetailsContentfulRelayPageQuery",
            "selections": [
                {
                    "alias": "collections",
                    "args": v4 /*: any*/ ,
                    "concreteType": "TemplateCollectionCollection",
                    "kind": "LinkedField",
                    "name": "templateCollectionCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateCollection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CollectionGuide",
                                    "kind": "LinkedField",
                                    "name": "howToUseThisCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "collectionGuideSectionContentfulRelayFragment"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "collectionHeaderSectionContentfulRelayFragment"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "collectionAboutSectionContentfulRelayFragment"
                                },
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "relatedCollections",
                    "args": v8 /*: any*/ ,
                    "concreteType": "TemplateCollectionCollection",
                    "kind": "LinkedField",
                    "name": "templateCollectionCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateCollection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "collectionRelatedSectionContentfulRelayFragment"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "confluenceTemplateCollectionDetailsContentfulRelayPageQuery",
            "selections": [
                {
                    "alias": "collections",
                    "args": v4 /*: any*/ ,
                    "concreteType": "TemplateCollectionCollection",
                    "kind": "LinkedField",
                    "name": "templateCollectionCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateCollection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CollectionGuide",
                                    "kind": "LinkedField",
                                    "name": "howToUseThisCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "templateCollectionGuideNameExternal",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CollectionGuideCollectionStepsCollection",
                                            "kind": "LinkedField",
                                            "name": "collectionStepsCollection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateCollectionStep",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "stepNameExternal",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "stepSubheading",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TemplateCollectionStepStepDescription",
                                                            "kind": "LinkedField",
                                                            "name": "stepDescription",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "json",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ProductTemplate",
                                                            "kind": "LinkedField",
                                                            "name": "relatedTemplate",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "templateNameExternal",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "pluginModuleKey",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "previewBlurb",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductTemplateTemplateTypeCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "templateTypeCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyTemplateType",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "templateTypeNameExternal",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "contributor",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CompanyNameInternal",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "organization",
                                                                                    "plural": false,
                                                                                    "selections": v11 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "Author",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v11 /*: any*/ ,
                                                                            "type": "CompanyNameInternal",
                                                                            "abstractKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "aboutThisCollectionHeader",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "aboutThisCollection",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Asset",
                                    "kind": "LinkedField",
                                    "name": "aboutThisCollectionImage",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "alias": "name",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "title",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                v5 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "relatedCollections",
                    "args": v8 /*: any*/ ,
                    "concreteType": "TemplateCollectionCollection",
                    "kind": "LinkedField",
                    "name": "templateCollectionCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateCollection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v6 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Asset",
                                    "kind": "LinkedField",
                                    "name": "collectionIcon",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ 
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CollectionGuide",
                                    "kind": "LinkedField",
                                    "name": "howToUseThisCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CollectionGuideCollectionStepsCollection",
                                            "kind": "LinkedField",
                                            "name": "collectionStepsCollection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "total",
                                                    "storageKey": null
                                                },
                                                v10 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "26a17c29a628b3eb7b2fd6693778bc06",
            "id": null,
            "metadata": {},
            "name": "confluenceTemplateCollectionDetailsContentfulRelayPageQuery",
            "operationKind": "query",
            "text": "query confluenceTemplateCollectionDetailsContentfulRelayPageQuery(\n  $locale: String\n  $urlSlug: String!\n  $relatedCollectionUrlSlugs: [String!]!\n) {\n  collections: templateCollectionCollection(limit: 1, locale: $locale, where: {urlSlug: $urlSlug}) {\n    items {\n      howToUseThisCollection {\n        ...collectionGuideSectionContentfulRelayFragment\n      }\n      ...collectionHeaderSectionContentfulRelayFragment\n      ...collectionAboutSectionContentfulRelayFragment\n      urlSlug\n      collectionNameExternal\n      oneLinerHeadline\n    }\n  }\n  relatedCollections: templateCollectionCollection(limit: 2, locale: $locale, where: {urlSlug_in: $relatedCollectionUrlSlugs}) {\n    items {\n      ...collectionRelatedSectionContentfulRelayFragment\n    }\n  }\n}\n\nfragment collectionAboutSectionContentfulRelayFragment on TemplateCollection {\n  collectionNameExternal\n  aboutThisCollectionHeader\n  aboutThisCollection\n  aboutThisCollectionImage {\n    url\n    name: title\n  }\n}\n\nfragment collectionCardContentfulRelayFragment on TemplateCollection {\n  sys {\n    id\n  }\n  collectionNameExternal\n  urlSlug\n  collectionIcon {\n    url\n  }\n  howToUseThisCollection {\n    collectionStepsCollection {\n      total\n      __typename\n    }\n  }\n}\n\nfragment collectionGuideSectionContentfulRelayFragment on CollectionGuide {\n  templateCollectionGuideNameExternal\n  collectionStepsCollection {\n    items {\n      stepNameExternal\n      stepSubheading\n      stepDescription {\n        json\n      }\n      relatedTemplate {\n        urlSlug\n        ...templateCardContentfulRelayFragment\n      }\n    }\n  }\n}\n\nfragment collectionHeaderSectionContentfulRelayFragment on TemplateCollection {\n  collectionNameExternal\n  oneLinerHeadline\n}\n\nfragment collectionRelatedSectionContentfulRelayFragment on TemplateCollection {\n  sys {\n    id\n  }\n  ...collectionCardContentfulRelayFragment\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n"
        }
    };
}();
$a0c0885f0b2aff55$var$node.hash = "8adafe8a7c1234e7e0232bb6cf9f2458";
var $a0c0885f0b2aff55$export$2e2bcd8739ae039 = $a0c0885f0b2aff55$var$node;

});


parcelRegister("1YXN8", function(module, exports) {
$parcel$export(module.exports, "tranformCategories", function () { return $1716d4dd863735a4$export$11d1018ed96344e4; });
$parcel$export(module.exports, "ConfluenceTemplatesUnifiedRelayPageQuery", function () { return $1716d4dd863735a4$export$a7bd550e56f5a21b; });
$parcel$export(module.exports, "getConfluenceTemplatesUnifiedRelayPageQueryVars", function () { return $1716d4dd863735a4$export$3f75a9344b1789fe; });
$parcel$export(module.exports, "ConfluenceTemplatesUnifiedRelayPageTemplate", function () { return $1716d4dd863735a4$export$378bb9d0f4f4e808; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $6Llis = parcelRequire("6Llis");

var $02XxA = parcelRequire("02XxA");

var $lRFwv = parcelRequire("lRFwv");

var $4EfnG = parcelRequire("4EfnG");

var $jBOxZ = parcelRequire("jBOxZ");

var $17RBn = parcelRequire("17RBn");

var $1iUL9 = parcelRequire("1iUL9");

var $6fJ4x = parcelRequire("6fJ4x");

var $hfzfc = parcelRequire("hfzfc");

var $4X0dO = parcelRequire("4X0dO");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $1ka2O = parcelRequire("1ka2O");

var $ePBzs = parcelRequire("ePBzs");

var $lxcl6 = parcelRequire("lxcl6");

var $kb0X5 = parcelRequire("kb0X5");

var $2lca6 = parcelRequire("2lca6");
parcelRequire("7D10U");
var $ePBzs = parcelRequire("ePBzs");
var $7D10U = parcelRequire("7D10U");

var $3dnVb = parcelRequire("3dnVb");

var $dJ115 = parcelRequire("dJ115");

var $7lcJ5 = parcelRequire("7lcJ5");

var $7Lif4 = parcelRequire("7Lif4");

var $26Nro = parcelRequire("26Nro");

var $9S4cS = parcelRequire("9S4cS");
var $1716d4dd863735a4$var$_confluenceTemplatesUnifiedContentfulRelayPageQuery;
const $1716d4dd863735a4$var$parseIsRecommended = (pathname)=>{
    return pathname.endsWith('/templates') || pathname.endsWith('/categories/recommended');
};
const $1716d4dd863735a4$var$parseSearchTerm = (params)=>{
    const search = new URLSearchParams(params);
    return search.get('term');
};
const $1716d4dd863735a4$var$slugOrder = (0, $ePBzs.AdditionalSlugs).reduce((acc, slug, index)=>{
    acc[slug] = index;
    return acc;
}, {});
const $1716d4dd863735a4$var$useAdditionalCategories = (categories)=>{
    const transformedCategories = $1716d4dd863735a4$export$11d1018ed96344e4(categories);
    const templateCategories = (0, $1oC0p.useMemo)(()=>{
        return transformedCategories.edges.map(({ node: { context: context } })=>context).filter((category)=>// @ts-expect-error Contentful category context urlSlug is not narrowed by generated Relay type.
            (0, $ePBzs.AdditionalSlugs).includes(category.urlSlug)).sort((a, b)=>($1716d4dd863735a4$var$slugOrder[a.urlSlug] ?? 0) - ($1716d4dd863735a4$var$slugOrder[b.urlSlug] ?? 0));
    }, [
        transformedCategories
    ]);
    return templateCategories;
};
const $1716d4dd863735a4$var$useSortedCategories = (categories)=>{
    const transformedCategories = $1716d4dd863735a4$export$11d1018ed96344e4(categories);
    const adjustedCategories = (0, $1oC0p.useMemo)(()=>{
        return transformedCategories.edges.map(({ node: { context: context } })=>({
                ...context,
                // @ts-expect-error Contentful category context urlSlug is not narrowed by generated Relay type.
                ...(0, $6Llis.getIcons)(context.urlSlug)
            }))// @ts-expect-error Contentful category context urlSlug is not narrowed by generated Relay type.
        .filter((category)=>(0, $ePBzs.DisplayedSlugs).includes(category.urlSlug)).sort((a, b)=>{
            const indexA = (0, $ePBzs.CategoryOrder)[a.urlSlug] ?? Number.MAX_VALUE;
            const indexB = (0, $ePBzs.CategoryOrder)[b.urlSlug] ?? Number.MAX_VALUE;
            return indexA - indexB;
        });
    }, [
        transformedCategories
    ]);
    return adjustedCategories;
};
const $1716d4dd863735a4$export$11d1018ed96344e4 = (categories)=>{
    if (!categories?.items) return {
        edges: []
    };
    // First map all items to nodes
    const nodes = categories.items?.filter((item)=>{
        // Skip if item is null or has no category collection
        if (!item?.categoryCollection?.items) return false;
        // Filter out null items
        const validItems = item.categoryCollection.items.filter(Boolean);
        // Check if any remaining items have templates
        const hasTemplates = validItems.some((category)=>{
            const total = category?.linkedFrom?.productTemplateCollection?.total ?? 0;
            return total > 0;
        });
        return validItems.length > 0 && hasTemplates;
    }).flatMap((item)=>{
        return item?.categoryCollection?.items.map((categoryItem)=>({
                node: {
                    context: {
                        id: categoryItem?.sys?.id || '',
                        urlSlug: categoryItem?.urlSlug || '',
                        name: categoryItem?.categoryNameExternal || '',
                        shortDescriptionOneLiner: categoryItem?.shortDescriptionOneLiner || '',
                        experiment: categoryItem?.experiment || false
                    },
                    field: 'category'
                }
            })) || [];
    }) || [];
    // Then remove duplicates based on urlSlug
    const uniqueNodes = nodes.reduce((acc, node)=>{
        const urlSlug = node.node.context.urlSlug;
        if (!urlSlug || acc.some((existing)=>existing.node.context.urlSlug === urlSlug)) return acc;
        acc.push(node);
        return acc;
    }, []);
    return {
        edges: uniqueNodes
    };
};

const $1716d4dd863735a4$export$a7bd550e56f5a21b = $1716d4dd863735a4$var$_confluenceTemplatesUnifiedContentfulRelayPageQuery !== void 0 ? $1716d4dd863735a4$var$_confluenceTemplatesUnifiedContentfulRelayPageQuery : ($1716d4dd863735a4$var$_confluenceTemplatesUnifiedContentfulRelayPageQuery = (parcelRequire("gO9l2")), $1716d4dd863735a4$var$_confluenceTemplatesUnifiedContentfulRelayPageQuery.hash && $1716d4dd863735a4$var$_confluenceTemplatesUnifiedContentfulRelayPageQuery.hash !== "07a7f8b979e3e44fe68d35fcfbf01207" && console.error("The definition of 'confluenceTemplatesUnifiedContentfulRelayPageQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $1716d4dd863735a4$var$_confluenceTemplatesUnifiedContentfulRelayPageQuery);
const $1716d4dd863735a4$export$3f75a9344b1789fe = (location, partialVars)=>{
    const isSearch = partialVars?.isSearch ?? ($1716d4dd863735a4$var$parseIsRecommended(location.pathname) || $1716d4dd863735a4$var$parseSearchTerm(location.search) !== null);
    const locale = partialVars?.locale ?? (0, $3dnVb.parseQueryLocale)(location);
    const searchQuery = (0, $2lca6.parseSearchQuery)(location);
    return {
        locale: locale,
        partnerTemplatesDataUrlSlugs: partialVars?.partnerTemplatesDataUrlSlugs ?? (0, $6fJ4x.partnerTemplatesDataUrlSlugs),
        limit: searchQuery?.first ?? 9,
        skip: 0,
        urlSlugs: searchQuery?.whereClause?.['urlSlugs'] ?? [],
        templateIds: searchQuery?.whereClause?.['templateIds'] ?? [],
        categoryUrlSlugs: searchQuery?.whereClause?.['categoryUrlSlugs'] ?? [],
        isSearch: isSearch
    };
};
const $1716d4dd863735a4$var$getRoute = (locale, searchTerm)=>{
    let prefix = locale === 'en' ? '' : `/${locale}`;
    prefix = `${prefix}/software/confluence/templates`;
    if (typeof searchTerm === 'string') return `${prefix}/search?term=${searchTerm}`;
    else if (searchTerm?.type === 'template' && searchTerm.name) return `${prefix}/search?term=${searchTerm.name}`;
    else if (searchTerm?.type === 'category' && searchTerm.id && searchTerm.id !== (0, $ePBzs.DEFAULT_CATEGORY_SLUG)) return `${prefix}/categories/${searchTerm.id}`;
    else return `${prefix}`;
};
const $1716d4dd863735a4$export$378bb9d0f4f4e808 = ({ queryRef: queryRef })=>{
    const location = (0, $1ka2O.useLocation)();
    const locale = (0, $17RBn.useLocale)();
    const categorySlug = (0, $7D10U.useCategorySlug)();
    const { categories: categories, collections: collections, partnerTemplates: partnerTemplates, preloadedSearchResults: preloadedSearchResults } = (0, $f3gS9.usePreloadedQuery)($1716d4dd863735a4$export$a7bd550e56f5a21b, queryRef);
    const transformedCategories = $1716d4dd863735a4$export$11d1018ed96344e4(categories);
    const categoryName = (0, $1oC0p.useMemo)(()=>{
        if (!categorySlug || categorySlug === (0, $ePBzs.DEFAULT_CATEGORY_SLUG)) return null;
        const category = transformedCategories.edges.find(({ node: { context: context } })=>context.urlSlug === categorySlug);
        return category?.node.context.name ?? null;
    }, [
        transformedCategories,
        categorySlug
    ]);
    const [searchTerm, setSearchTerm] = (0, $1oC0p.useState)(()=>{
        let term = $1716d4dd863735a4$var$parseSearchTerm(location.search);
        if (!term) {
            term = (0, $7D10U.parseCategorySlug)(location.pathname);
            if (term && term !== (0, $ePBzs.DEFAULT_CATEGORY_SLUG)) return {
                type: 'category',
                id: term
            };
            else return null;
        }
        return term;
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleCategoryChange = (0, $1oC0p.useCallback)((id)=>{
        const searchTerm = {
            type: 'category',
            id: id
        };
        setSearchTerm(searchTerm.id === (0, $ePBzs.DEFAULT_CATEGORY_SLUG) ? null : searchTerm);
        const url = $1716d4dd863735a4$var$getRoute(locale, searchTerm);
        history.replaceState(null, '', url);
        createAnalyticsEvent({
            action: 'viewed',
            eventType: 'screen',
            name: 'page',
            attributes: {
                category: id,
                page_path: url,
                originProduct: `wac-software-confluence-templates-categories-${id}`,
                isMarketingEvent: true
            }
        }).fire();
        (0, $lRFwv.ConfluenceTemplateAnalytics).viewTemplatesTaxonomyCategory(id);
    }, [
        createAnalyticsEvent,
        locale
    ]);
    const handleSearchSubmit = (0, $1oC0p.useCallback)((searchTerm)=>{
        setSearchTerm(searchTerm);
        history.replaceState(null, '', $1716d4dd863735a4$var$getRoute(locale, searchTerm));
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "confluence-templates-relay-page",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
            name: "confluence-templates-relay",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1iUL9.SharedHeaderFooterContainer), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $4EfnG.default), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfzfc.ExperimentView), {
                            experiment: (0, $4X0dO.experiments).cfindTemplatesHeroIntentValueV6,
                            render: (isEnabled)=>isEnabled ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lxcl6.TemplateHeroVariant), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Lif4.TemplateHeroSection), {
                                    categoryName: categoryName ?? undefined,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7lcJ5.TemplateFuzzySearch), {
                                        onSubmit: handleSearchSubmit,
                                        value: typeof searchTerm === 'string' ? searchTerm : undefined
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $02XxA.TemplateSectionWrapper), {
                            columnOrientation: true,
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kb0X5.TemplateCategories), {
                                    categories: $1716d4dd863735a4$var$useSortedCategories(categories),
                                    onCategoryChange: handleCategoryChange
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9S4cS.TemplateSearchResultsSection), {
                                    preloadedSearchResults: preloadedSearchResults,
                                    searchTerm: searchTerm
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJ115.SectionDivider), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJ115.TemplateCarouselSection), {
                            collections: collections?.items?.filter((item)=>item !== null) ?? []
                        }),
                        (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacUnifiedTemplatesNavigation) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jBOxZ.UnifiedTemplatesNavigationSection), {
                            product: "confluence"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $26Nro.TemplateLearnFromLeadersSection), {
                            templates: partnerTemplates?.items?.filter((item)=>item !== null) ?? [],
                            categories: $1716d4dd863735a4$var$useAdditionalCategories(categories)
                        })
                    ]
                })
            })
        })
    });
};

});
parcelRegister("6Llis", function(module, exports) {
$parcel$export(module.exports, "getIcons", function () { return $ae854534b93f9652$export$1ec38b273a97258f; });

var $7VQPk = parcelRequire("7VQPk");

var $9LMMY = parcelRequire("9LMMY");

var $1eleh = parcelRequire("1eleh");

var $fM0Af = parcelRequire("fM0Af");

var $j4KkA = parcelRequire("j4KkA");

var $6mDjS = parcelRequire("6mDjS");

var $fiGQF = parcelRequire("fiGQF");

var $eVijF = parcelRequire("eVijF");

var $cUy98 = parcelRequire("cUy98");
function $ae854534b93f9652$export$1ec38b273a97258f(key) {
    switch(key){
        case 'recommended':
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eVijF.Recommended), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eVijF.RecommendedHovered), {})
            };
        case 'project-management':
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fiGQF.ProjectManagement), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fiGQF.ProjectManagementHovered), {})
            };
        case 'software-development-and-it':
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cUy98.Software), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cUy98.SoftwareHovered), {})
            };
        case 'product-management':
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6mDjS.ProductManagement), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6mDjS.ProductManagementHovered), {})
            };
        case 'marketing-and-sales':
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j4KkA.Marketing), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j4KkA.MarketingHovered), {})
            };
        case 'design':
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9LMMY.Design), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9LMMY.DesignHovered), {})
            };
        case 'finance-and-operations':
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1eleh.Finance), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1eleh.FinanceHovered), {})
            };
        case 'human-resources':
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fM0Af.Hr), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fM0Af.HrHovered), {})
            };
        default:
            return {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9LMMY.Design), {}),
                iconHovered: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9LMMY.DesignHovered), {})
            };
    }
}

});
parcelRegister("9LMMY", function(module, exports) {
$parcel$export(module.exports, "Design", function () { return $4768e36bbebb72ff$export$5f050e5bc8f2deef; });
$parcel$export(module.exports, "DesignHovered", function () { return $4768e36bbebb72ff$export$8dbd971f6241d9f9; });

var $7VQPk = parcelRequire("7VQPk");
const $4768e36bbebb72ff$export$5f050e5bc8f2deef = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.4292 21.0958C25.4958 20.725 25.5292 20.325 25.5292 19.9083C25.5292 19.4917 25.4958 19.0833 25.425 18.7042C25.0208 16.4583 23.4625 15.075 21.2708 14.7167C20.8958 14.6542 20.5042 14.625 20.1 14.625C19.6958 14.625 19.2667 14.6583 18.8792 14.725C16.6917 15.0917 15.1333 16.4708 14.7292 18.7042C14.6625 19.0833 14.625 19.4833 14.625 19.9083C14.625 20.3333 14.6583 20.725 14.725 21.0958C15.125 23.325 16.6833 24.7083 18.8792 25.075C19.2667 25.1417 19.675 25.175 20.1 25.175C20.525 25.175 20.9 25.1458 21.2708 25.0833C23.4625 24.725 25.025 23.3417 25.425 21.0958H25.4292Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.37083 19.3167L13.8708 8.17505L20.3708 19.3167H7.37083Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.8458 14.9917C16.2042 15.5667 15.0625 16.8375 14.7292 18.7042C14.6917 18.9042 14.6667 19.1042 14.6458 19.3167H20.3667L17.8458 14.9917Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.9167 20.8833H20.7833V30.0166H29.9167V20.8833Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.7833 20.8875V25.1458C20.95 25.1291 21.1125 25.1083 21.275 25.0833C23.4667 24.7291 25.025 23.3416 25.4292 21.0958C25.4417 21.0291 25.4542 20.9583 25.4625 20.8875H20.7833Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4768e36bbebb72ff$export$8dbd971f6241d9f9 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.4292 21.0958C25.4958 20.725 25.5292 20.325 25.5292 19.9083C25.5292 19.4917 25.4958 19.0833 25.425 18.7042C25.0208 16.4583 23.4625 15.075 21.2708 14.7167C20.8958 14.6542 20.5042 14.625 20.1 14.625C19.6958 14.625 19.2667 14.6583 18.8792 14.725C16.6917 15.0917 15.1333 16.4708 14.7292 18.7042C14.6625 19.0833 14.625 19.4833 14.625 19.9083C14.625 20.3333 14.6583 20.725 14.725 21.0958C15.125 23.325 16.6833 24.7083 18.8792 25.075C19.2667 25.1417 19.675 25.175 20.1 25.175C20.525 25.175 20.9 25.1458 21.2708 25.0833C23.4625 24.725 25.025 23.3417 25.425 21.0958H25.4292Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.37083 19.3167L13.8708 8.17505L20.3708 19.3167H7.37083Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.8458 14.9917C16.2042 15.5667 15.0625 16.8375 14.7292 18.7042C14.6917 18.9042 14.6667 19.1042 14.6458 19.3167H20.3667L17.8458 14.9917Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.9167 20.8833H20.7833V30.0166H29.9167V20.8833Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.7833 20.8875V25.1458C20.95 25.1291 21.1125 25.1083 21.275 25.0833C23.4667 24.7291 25.025 23.3416 25.4292 21.0958C25.4417 21.0291 25.4542 20.9583 25.4625 20.8875H20.7833Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.6573 24.1083C32.6727 23.9625 31.9279 22.1906 31.7235 22.7784C31.8329 23.0686 31.9006 23.4521 31.9929 23.7434C32.0561 23.9795 32.1186 24.2633 32.1711 24.5107C32.0835 24.4411 31.9883 24.3695 31.8806 24.2953C31.8826 24.3558 31.8841 24.4175 31.9154 24.4649C30.9513 23.3977 29.3467 22.7848 28.0086 22.141C28.0102 22.1839 27.9569 22.195 27.9253 22.1605L27.9569 22.1208C27.0888 21.8904 26.5881 21.555 25.6989 21.4867C25.6989 21.4867 25.8086 21.4513 25.8114 21.4511C23.3726 20.8352 20.4334 20.3782 17.9807 21.6129C16.011 17.6439 10.3322 17.994 8.43097 22.0586C8.42139 22.1357 8.54372 22.0318 8.84629 21.7191L8.83042 21.8196C9.36783 21.0518 10.1386 20.5656 10.7941 20.0192C10.8651 19.8167 10.8611 19.7946 11.1372 19.6649C12.3175 19.6072 13.4346 18.5834 15.1229 19.5565C15.1057 19.5547 14.9964 19.5553 14.9816 19.5574C15.5401 19.8314 16.7212 20.5083 17.1091 21.0624C17.2248 21.2086 17.2268 21.2444 17.0308 21.0987C17.1989 21.341 17.3652 21.6057 17.5178 21.8919C17.0128 22.219 16.5598 22.6769 16.2371 23.1741L16.2528 23.1637L16.2536 23.1742C16.3952 22.9466 17.2859 22.1548 17.5876 22.0263C15.6967 23.5742 15.6842 24.7841 15.6855 24.6975C15.4417 27.5055 20.361 26.4965 18.4072 22.4488C18.4148 22.5525 18.6631 23.0327 18.5478 23.1702C18.4612 22.8321 18.3268 22.5176 18.1808 22.2227C18.2051 22.2147 18.2351 22.1815 18.2558 22.1878C18.2558 22.1878 18.2545 22.1844 18.2539 22.1827C19.5859 21.5034 21.189 21.4483 22.5557 21.6629L22.5267 21.6383C26.0013 21.6507 29.3046 23.1019 32.1572 25.0556C32.1469 25.1281 32.1419 25.1825 32.1471 25.1834C31.8685 25.3527 30.991 25.3261 30.8093 25.591L30.3528 25.6112C30.1981 25.7413 29.9911 25.8336 30.0884 25.9221C30.1856 26.0106 32.2754 25.8397 32.7822 25.4901L32.7753 25.487C32.7753 25.487 32.9401 25.3963 32.9401 25.421C32.9308 25.0054 32.9404 24.4179 32.6572 24.1054L32.6573 24.1083ZM18.0792 23.3755C18.5821 27.6974 14.0363 24.9458 17.7893 22.4624C17.913 22.7517 18.0119 23.0561 18.0792 23.3755ZM31.9154 24.4649C31.9362 24.4524 31.9531 24.4454 31.9605 24.4443C31.9559 24.4452 31.9429 24.4496 31.9154 24.4649ZM31.9612 24.449L31.9488 24.4551C31.9583 24.4492 31.9645 24.4447 31.9605 24.4443C31.965 24.4434 31.9662 24.444 31.96 24.4485L31.9612 24.449Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("1eleh", function(module, exports) {
$parcel$export(module.exports, "Finance", function () { return $91fdd64d05ffa2eb$export$753765228a08ccbe; });
$parcel$export(module.exports, "FinanceHovered", function () { return $91fdd64d05ffa2eb$export$c3f9b4e556a64c63; });

var $7VQPk = parcelRequire("7VQPk");
const $91fdd64d05ffa2eb$export$753765228a08ccbe = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.9458 22.2458V19.8291C31.9458 19.2041 31.3792 18.6958 30.675 18.6958H16.4333C15.7291 18.6958 15.1625 19.2 15.1625 19.8291V22.2458H31.9458Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.9458 23.8291H15.1625V28.8041C15.1625 29.425 15.7291 29.9375 16.4333 29.9375H30.675C31.3792 29.9375 31.9458 29.4291 31.9458 28.8041V23.8291Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1 13.4919V11.0752C25.1 10.4502 24.5334 9.94189 23.8292 9.94189H9.58754C8.88337 9.94189 8.3167 10.4461 8.3167 11.0752V13.4919H25.1Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1 15.0752H8.3167V20.0502C8.3167 20.6711 8.88337 21.1836 9.58754 21.1836H23.8292C24.5334 21.1836 25.1 20.6752 25.1 20.0502V15.0752Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1 18.6917V20.0458C25.1 20.6708 24.5333 21.1833 23.8292 21.1833H15.1625V19.8292C15.1625 19.2 15.7333 18.6917 16.4333 18.6917H25.1Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.1 18.6917V20.0458C25.1 20.6708 24.5333 21.1833 23.8292 21.1833H15.1625V19.8292C15.1625 19.2 15.7333 18.6917 16.4333 18.6917H25.1Z",
                fill: "#AE2A19"
            })
        ]
    });
const $91fdd64d05ffa2eb$export$c3f9b4e556a64c63 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_337_22200)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.9458 22.2458V19.8291C31.9458 19.2041 31.3792 18.6958 30.675 18.6958H16.4333C15.7291 18.6958 15.1625 19.2 15.1625 19.8291V22.2458H31.9458Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.9458 23.8291H15.1625V28.8041C15.1625 29.425 15.7291 29.9375 16.4333 29.9375H30.675C31.3792 29.9375 31.9458 29.4291 31.9458 28.8041V23.8291Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.1 13.4919V11.0752C25.1 10.4502 24.5334 9.94189 23.8292 9.94189H9.58754C8.88337 9.94189 8.3167 10.4461 8.3167 11.0752V13.4919H25.1Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.1 15.0752H8.3167V20.0502C8.3167 20.6711 8.88337 21.1836 9.58754 21.1836H23.8292C24.5334 21.1836 25.1 20.6752 25.1 20.0502V15.0752Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.1 18.6917V20.0458C25.1 20.6708 24.5333 21.1833 23.8292 21.1833H15.1625V19.8292C15.1625 19.2 15.7333 18.6917 16.4333 18.6917H25.1Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.1 18.6917V20.0458C25.1 20.6708 24.5333 21.1833 23.8292 21.1833H15.1625V19.8292C15.1625 19.2 15.7333 18.6917 16.4333 18.6917H25.1Z",
                        fill: "#AE2A19"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M27.433 8.44993C27.1418 8.09173 26.8079 7.7776 26.4664 7.48389C26.4664 7.48389 26.3751 7.37145 26.2061 7.20553C26.0476 7.03099 25.8059 6.81977 25.5366 6.59632C24.9876 6.15807 24.2548 5.77173 23.7818 5.68871C22.7549 5.15927 21.6106 4.83415 20.4329 4.78088C20.4329 4.78088 20.3417 4.7896 20.1947 4.79882C20.0513 4.81031 19.8521 4.82231 19.6435 4.87379C19.4379 4.91212 19.2161 4.96044 19.0283 5.03505C18.8391 5.10376 18.6795 5.16564 18.5879 5.23969C18.3543 5.41191 18.2356 5.56995 18.2389 5.67794C18.2399 5.78957 18.3666 5.85343 18.6311 5.84182C18.7614 5.82717 18.9306 5.80658 19.1447 5.77868C19.3548 5.73309 19.613 5.70742 19.9215 5.65765C19.936 5.66671 19.9887 5.67936 19.9964 5.69932C20.6484 5.57614 21.3169 5.68529 21.9406 5.88251C22.5679 6.082 23.1613 6.37636 23.7611 6.68478C23.7746 6.6226 23.8404 6.59803 23.8609 6.64611L23.8128 6.70696C24.2509 6.854 24.5442 7.0874 24.8253 7.30811C25.1078 7.53472 25.3699 7.75363 25.763 7.94836C25.763 7.94836 25.6219 7.95622 25.6183 7.95395C26.132 8.4408 26.6327 9.04564 26.981 9.75727C27.3338 10.4616 27.5506 11.2628 27.4843 12.0488C27.4465 12.8375 27.0828 13.5744 26.5811 14.1848C26.4442 14.3315 26.3073 14.4782 26.1654 14.6167C26.0135 14.7389 25.8531 14.8911 25.7148 14.9915C25.459 15.1751 25.1583 15.2852 24.847 15.2828L24.8615 15.2919L24.8524 15.3064C24.9632 15.3553 25.3226 15.3776 25.6361 15.2553C25.7912 15.2007 25.93 15.1157 26.0474 15.0325C26.1603 14.9566 26.2324 14.9057 26.2324 14.9057C26.16 15.0219 26.0816 15.1396 25.9886 15.2481C25.8953 15.3412 25.7946 15.4298 25.6753 15.4916C25.4381 15.6212 25.1546 15.6714 24.8805 15.6417C24.3218 15.591 23.8645 15.2403 23.5751 14.863L23.6612 14.8057C23.8934 15.1372 24.2765 15.2348 24.4072 15.2356C24.0953 15.0966 23.7565 14.8147 23.6263 14.4005C23.5608 14.1982 23.5319 13.9532 23.5813 13.8175C23.6283 13.6854 23.7353 13.5705 23.9398 13.4609C24.3585 13.2427 25.0069 13.198 25.5596 13.2097C26.13 13.2173 26.656 13.288 27.0722 13.3407C27.0444 13.2477 26.5086 13.3222 26.4184 13.0541C26.8446 13.1231 27.2762 13.1753 27.6729 13.2915C27.6313 13.4472 27.4189 13.3349 27.3671 13.3531C27.5265 13.4373 28.5165 13.7268 29.7632 14.3327C31.004 14.9399 32.4825 15.9023 33.6003 17.0383C34.7323 18.168 35.4342 19.4533 35.774 20.2353C36.0924 21.0191 36.2746 21.269 36.2084 20.3801L36.3137 20.4458C36.0823 19.5548 35.7867 18.8558 35.3828 17.9582C35.2929 17.8516 35.2969 17.8289 35.2307 17.8785C35.198 17.8581 35.1435 17.8241 35.1254 17.8532C34.9654 17.9804 34.8675 17.6923 34.7766 17.5953C35.0828 17.4684 34.6361 16.8417 33.9939 16.3101C33.6792 16.0381 33.3169 15.8021 33.0258 15.6054C32.7198 15.4247 32.4886 15.2856 32.4046 15.2181C32.5132 14.9225 31.738 14.7418 31.5885 14.5123C31.6098 14.5105 31.7405 14.5113 31.7595 14.5131C31.7158 14.3647 30.8151 13.9241 30.0343 13.639C29.2558 13.3503 28.614 13.1821 29.1785 13.1911C28.6913 12.9125 28.122 12.6685 27.4829 12.4717C26.8474 12.2772 26.1443 12.1264 25.3738 12.0999C24.9899 12.0926 24.5897 12.0953 24.1673 12.1901C23.7544 12.2858 23.299 12.4256 22.9009 12.813C22.8139 12.9202 22.7138 13.0242 22.6426 13.1464C22.5824 13.2753 22.5104 13.407 22.4801 13.5445C22.4558 13.6807 22.4232 13.8218 22.4261 13.9548C22.4312 14.0841 22.4422 14.2121 22.4569 14.3423C22.5404 14.8232 22.785 15.2885 23.1434 15.6281C23.8524 16.3275 24.9621 16.4898 25.8357 16.1163C26.0502 16.0231 26.2661 15.8954 26.4307 15.7609C26.5871 15.6314 26.7458 15.4983 26.9022 15.3688C27.045 15.2207 27.1892 15.0785 27.3297 14.9341C27.4616 14.7792 27.5826 14.6176 27.7109 14.4604C28.1899 13.8056 28.4872 13.0375 28.5949 12.2823C28.7026 11.5271 28.6388 10.7961 28.5075 10.1492L28.478 10.1964C28.4839 10.1546 28.4234 10.0412 28.4528 9.99402C28.3128 9.76546 28.0819 9.3591 27.8583 9.03805C27.637 8.71337 27.4298 8.46309 27.4298 8.46309L27.433 8.44993ZM23.1768 15.0485C23.1768 15.0485 23.1591 15.0526 23.1605 15.0585C23.165 15.0513 23.0918 14.9098 23.015 14.766C22.9486 14.6136 22.894 14.4585 22.903 14.4439L23.0033 14.4207C23.0847 14.5572 23.1543 14.7368 23.2289 14.9246C23.2721 15.0171 23.3094 15.111 23.3476 15.1954C23.3917 15.2784 23.4322 15.3591 23.464 15.4294C23.5345 15.5591 23.574 15.6494 23.5177 15.6345C23.4674 15.6182 23.2998 15.4986 23.1384 15.1507C23.0889 15.1249 23.1551 15.0753 23.1768 15.0485ZM26.5764 12.6228C26.6794 12.6518 26.7884 12.6794 26.9141 12.7124C26.1985 12.7353 25.4015 12.6218 24.568 12.6721C24.1583 12.7142 23.7273 12.7986 23.3808 13.0467C23.2874 13.0994 23.2199 13.1835 23.1523 13.2675C23.0762 13.3411 23.0413 13.4455 22.9979 13.5394C22.9277 13.7328 22.9175 13.9434 22.9613 14.1321C22.9013 14.0745 22.8477 13.9907 22.8104 13.8968C22.7885 13.8024 22.7802 13.6862 22.7824 13.5614C22.8108 13.443 22.8484 13.31 22.9172 13.1915C23.002 13.0879 23.0762 12.9526 23.1942 12.8849C23.6422 12.5387 24.178 12.5045 24.5106 12.4647C25.197 12.2621 26.0144 12.4641 26.58 12.6251L26.5764 12.6228ZM34.3376 16.9078L34.3793 16.8733L34.4125 16.9091C34.4125 16.9091 34.3857 16.9277 34.3748 16.9209C34.363 16.9237 34.3426 16.916 34.3399 16.9042L34.3376 16.9078ZM27.6362 9.23249C27.7637 9.28682 27.8885 9.6774 27.6278 9.50477C27.6232 9.43126 27.4692 9.28984 27.6362 9.23249ZM28.083 13.1032C28.1313 12.9367 28.632 13.0723 28.5578 13.2884C28.3912 13.24 28.2391 13.1603 28.083 13.1032ZM24.9144 6.52616C24.7039 6.59671 24.8458 6.45816 24.8707 6.33743C24.8884 6.37371 24.9847 6.45394 24.9162 6.5071L24.9144 6.52616ZM22.743 5.55044C22.6823 5.62356 22.5389 5.63505 22.4803 5.62377C22.3427 5.51273 22.6962 5.45565 22.743 5.55044ZM18.9015 5.31925C18.9175 5.41498 18.8359 5.46497 18.7904 5.37608C18.7799 5.30394 18.8833 5.22715 18.9233 5.33284C18.9233 5.33284 18.9147 5.32241 18.9051 5.32151L18.9015 5.31925ZM30.1089 14.296C29.8632 14.4959 29.5565 14.0978 29.2992 14.0736C29.4605 13.8311 29.7817 14.1979 29.9668 14.2326C30.0236 14.263 30.0717 14.2829 30.1089 14.296ZM27.5837 12.9735C27.4602 12.9369 27.4805 12.8234 27.5348 12.6958C27.5796 12.5674 27.638 12.4171 27.6261 12.3391L27.7264 12.3562C27.7229 12.4751 27.7212 12.575 27.7159 12.6725C27.701 12.7692 27.6634 12.8618 27.5882 12.9662L27.5837 12.9735ZM25.6974 13.0938C25.5995 13.1942 25.451 13.0764 25.3562 13.0828C25.3574 12.9272 25.7721 12.9336 25.6974 13.0938ZM23.5381 14.623C23.3984 14.7175 23.3937 14.5228 23.365 14.4798C23.4109 14.5033 23.5207 14.5214 23.5348 14.5554C23.5462 14.5776 23.5312 14.5935 23.5381 14.623ZM27.6243 13.1754C27.5428 13.3466 27.474 13.5458 27.3625 13.7084L27.2753 13.654C27.3832 13.4892 27.4429 13.3045 27.5303 13.1319L27.6206 13.1731L27.6243 13.1754ZM26.4219 14.6505L26.3519 14.5766C26.4724 14.3187 26.6826 14.4751 26.4264 14.6432L26.4219 14.6505ZM27.6227 10.7427C27.6259 10.7699 27.6273 10.8162 27.6364 10.8421C27.7262 11.2159 27.2566 10.7716 27.6227 10.7427ZM26.6671 8.9258C26.6307 8.90315 26.5776 8.87507 26.5599 8.83879C26.4112 8.59979 26.7853 8.71195 26.6671 8.9258Z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_337_22200",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: 40,
                        height: 40,
                        fill: "white"
                    })
                })
            })
        ]
    });

});

parcelRegister("fM0Af", function(module, exports) {
$parcel$export(module.exports, "Hr", function () { return $cb5d75438541c9f9$export$c65504044f62f430; });
$parcel$export(module.exports, "HrHovered", function () { return $cb5d75438541c9f9$export$c533749fa8372f81; });

var $7VQPk = parcelRequire("7VQPk");
const $cb5d75438541c9f9$export$c65504044f62f430 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.2375 11.7458H11.7042V33.3458H28.2375V11.7458Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.6833 28.9165C16.6833 27.0124 18.225 25.4707 20.1291 25.4707C22.0333 25.4707 23.575 27.0124 23.575 28.9165V33.3457H16.6833V28.9165Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.0833 21.0416C23.0833 22.6707 21.7625 23.9957 20.1291 23.9957C18.4958 23.9957 17.175 22.6749 17.175 21.0416C17.175 19.4082 18.4958 18.0874 20.1291 18.0874C21.7625 18.0874 23.0833 19.4082 23.0833 21.0416Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.9083 9.95415V15.0833H14.0291V9.95415H17.5208C17.5208 8.59998 18.6166 7.50415 19.9708 7.50415C21.325 7.50415 22.4166 8.59998 22.4166 9.95415H25.9083Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.9083 11.7458H14.0291V15.0834H25.9083V11.7458Z",
                fill: "#164B35"
            })
        ]
    });
const $cb5d75438541c9f9$export$c533749fa8372f81 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.2375 11.7458H11.7042V33.3458H28.2375V11.7458Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.6833 28.9165C16.6833 27.0124 18.225 25.4707 20.1291 25.4707C22.0333 25.4707 23.575 27.0124 23.575 28.9165V33.3457H16.6833V28.9165Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.0833 21.0416C23.0833 22.6707 21.7625 23.9957 20.1291 23.9957C18.4958 23.9957 17.175 22.6749 17.175 21.0416C17.175 19.4082 18.4958 18.0874 20.1291 18.0874C21.7625 18.0874 23.0833 19.4082 23.0833 21.0416Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.9083 9.95415V15.0833H14.0291V9.95415H17.5208C17.5208 8.59998 18.6166 7.50415 19.9708 7.50415C21.325 7.50415 22.4166 8.59998 22.4166 9.95415H25.9083Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.9083 11.7458H14.0291V15.0834H25.9083V11.7458Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.8496 13.1845C30.1777 12.9655 31.2802 11.7034 30.2252 11.9996C29.9417 12.22 28.6421 13.9188 27.9282 14.7948C27.7713 14.4354 27.3208 14.0423 26.9912 13.843C26.7912 13.6618 26.7106 13.9609 26.7106 13.9609C26.7667 14.0409 26.8257 14.1673 26.9625 14.2683C27.115 14.3806 27.1352 14.6137 27.3856 14.792C28.2664 15.4167 27.8692 16.3363 28.7212 14.7428C29.0148 14.0437 29.7517 13.8163 29.8481 13.1845H29.8496Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.4165 13.1327C35.4237 11.3175 35.1201 8.47036 33.0965 7.7979C34.4997 9.63139 35.3503 12.5852 34.5688 14.8581C33.8449 18.4591 28.2563 20.4793 24.8885 18.3931C25.2339 18.7132 26.0241 19.0768 26.5091 19.2172C25.2224 19.4896 22.3296 16.3196 24.3776 18.0449C18.5659 10.8022 27.767 3.87542 33.0634 10.1312C31.5608 7.29391 27.659 6.32381 25.2555 7.70385C13.6754 16.6495 33.6722 27.2433 35.4151 13.1327H35.4165Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("j4KkA", function(module, exports) {
$parcel$export(module.exports, "Marketing", function () { return $04c67226f35661b4$export$4d6f2a278d19adf3; });
$parcel$export(module.exports, "MarketingHovered", function () { return $04c67226f35661b4$export$a7fb67e0933d1252; });

var $7VQPk = parcelRequire("7VQPk");
const $04c67226f35661b4$export$4d6f2a278d19adf3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.3958 10.9084L20.3042 14.5459V24.2459L29.3958 27.8834V10.9084Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.6333 15.1501V23.6251H17.8792V29.0918H14.2417V23.6251H10.6042V15.1501H22.6333Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.6333 15.1501H20.3042V23.621H22.6333V15.1501Z",
                fill: "#AE2A19"
            })
        ]
    });
const $04c67226f35661b4$export$a7fb67e0933d1252 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.3958 10.9084L20.3042 14.5459V24.2459L29.3958 27.8834V10.9084Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.6333 15.1501V23.6251H17.8792V29.0918H14.2417V23.6251H10.6042V15.1501H22.6333Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.6333 15.1501H20.3042V23.621H22.6333V15.1501Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.646 27.4742C40.6989 22.9822 40.0846 19.2569 39.5955 16.7935C40.0267 15.4867 36.5821 9.605 37.4977 13.2676C38.8445 14.8411 39.5074 20.1781 38.2186 23.119C38.921 23.9797 35.2585 29.5005 37.646 27.4719L37.646 27.4742Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.481 25.0378C37.1245 23.2917 36.9506 20.7252 36.8208 19.6672C37.354 20.519 37.1083 18.2528 36.837 17.8852C36.8602 18.2438 36.6215 18.0556 36.596 17.7575C37.2357 17.6633 35.736 13.7273 34.9618 14.7987C35.2191 15.2761 34.9896 15.5137 35.4995 15.5563C34.8945 15.7961 35.7592 16.287 35.8264 16.4507C35.7082 16.8003 35.5621 16.7914 35.9121 17.2464C35.9121 17.8561 35.7383 18.728 35.9353 19.7524C35.984 21.1802 35.5273 21.9558 35.4091 23.137C35.219 23.6347 34.0044 26.1205 35.4764 25.0423L35.481 25.0378Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.1351 22.8903C33.7448 22.1909 34.1041 21.3078 34.0229 20.0705C33.5756 20.5905 33.5872 20.1041 33.8027 19.7724C34.2942 20.4314 34.1736 18.358 33.7517 18.8915C33.6497 18.7525 33.7123 18.5978 33.8282 18.7032C34.1922 17.9299 32.4119 15.5651 32.7967 17.4883C33.1119 17.3986 32.3424 17.7394 33.0957 17.9926C32.8871 18.2885 32.7735 18.1943 33.0633 18.4543C33.0447 18.7278 32.697 19.2658 32.9196 19.8149C33.1096 20.5972 32.4003 20.8819 32.8152 21.4692C32.5046 21.8189 32.1778 23.4865 33.1375 22.8858L33.1351 22.8903Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("6mDjS", function(module, exports) {
$parcel$export(module.exports, "ProductManagement", function () { return $108a96784966800c$export$5cb1bfa2c03562f7; });
$parcel$export(module.exports, "ProductManagementHovered", function () { return $108a96784966800c$export$a17b6ca511e66375; });

var $7VQPk = parcelRequire("7VQPk");
const $108a96784966800c$export$5cb1bfa2c03562f7 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.675 9.37085H17.5625L18.7834 12.6333L22.2209 12.0625L24.1625 15.4292L21.95 18.1208L24.1625 20.8083L22.2209 24.175L18.7875 23.6042L17.5667 26.8667H13.6792L12.4584 23.6042L9.02504 24.175L7.08337 20.8083L9.29587 18.1208L7.08337 15.4333L9.02504 12.0667L12.4625 12.6375L13.6834 9.37502L13.675 9.37085ZM15.6167 21.3958C17.4292 21.3958 18.8959 19.9292 18.8959 18.1167C18.8959 16.3042 17.4292 14.8375 15.6167 14.8375C13.8042 14.8375 12.3375 16.3042 12.3375 18.1167C12.3375 19.9292 13.8042 21.3958 15.6167 21.3958Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.6292 17.1001H27.8375L28.8458 19.7918L31.6833 19.3209L33.2875 22.1001L31.4583 24.3209L33.2833 26.5418L31.6792 29.3209L28.8417 28.8501L27.8333 31.5418H24.625L23.6167 28.8501L20.7792 29.3209L19.175 26.5418L21 24.3209L19.175 22.1001L20.7792 19.3209L23.6167 19.7918L24.625 17.1001H24.6292ZM26.2333 27.0293C27.7292 27.0293 28.9417 25.8168 28.9417 24.3209C28.9417 22.8251 27.7292 21.6126 26.2333 21.6126C24.7375 21.6126 23.525 22.8251 23.525 24.3209C23.525 25.8168 24.7375 27.0293 26.2333 27.0293Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.95 18.1167L24.1625 15.4292L22.2208 12.0625L18.7833 12.6333L17.5625 9.375H13.675L12.45 12.6333L9.01668 12.0625L7.07501 15.4292L9.28751 18.1167L7.07501 20.8083L9.01668 24.175L12.45 23.6L13.675 26.8625H17.5625L18.7833 23.6L20.675 23.9167L22.2208 24.175L24.1625 20.8083L23.2792 19.7333L21.95 18.1167ZM15.6167 21.3958C13.8083 21.3958 12.3375 19.9292 12.3375 18.1167C12.3375 16.3042 13.8083 14.8375 15.6167 14.8375C17.425 14.8375 18.8958 16.3083 18.8958 18.1167C18.8958 19.925 17.4292 21.3958 15.6167 21.3958Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.2792 19.7333L20.7834 19.3208L19.1792 22.1L20.675 23.9166L22.2209 24.175L24.1625 20.8083L23.2792 19.7333Z",
                fill: "#AE2A19"
            })
        ]
    });
const $108a96784966800c$export$a17b6ca511e66375 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.675 9.37085H17.5625L18.7834 12.6333L22.2209 12.0625L24.1625 15.4292L21.95 18.1208L24.1625 20.8083L22.2209 24.175L18.7875 23.6042L17.5667 26.8667H13.6792L12.4584 23.6042L9.02504 24.175L7.08337 20.8083L9.29587 18.1208L7.08337 15.4333L9.02504 12.0667L12.4625 12.6375L13.6834 9.37502L13.675 9.37085ZM15.6167 21.3958C17.4292 21.3958 18.8959 19.9292 18.8959 18.1167C18.8959 16.3042 17.4292 14.8375 15.6167 14.8375C13.8042 14.8375 12.3375 16.3042 12.3375 18.1167C12.3375 19.9292 13.8042 21.3958 15.6167 21.3958Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.6292 17.1001H27.8375L28.8458 19.7918L31.6833 19.3209L33.2875 22.1001L31.4583 24.3209L33.2833 26.5418L31.6792 29.3209L28.8417 28.8501L27.8333 31.5418H24.625L23.6167 28.8501L20.7792 29.3209L19.175 26.5418L21 24.3209L19.175 22.1001L20.7792 19.3209L23.6167 19.7918L24.625 17.1001H24.6292ZM26.2333 27.0293C27.7292 27.0293 28.9417 25.8168 28.9417 24.3209C28.9417 22.8251 27.7292 21.6126 26.2333 21.6126C24.7375 21.6126 23.525 22.8251 23.525 24.3209C23.525 25.8168 24.7375 27.0293 26.2333 27.0293Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.95 18.1167L24.1625 15.4292L22.2208 12.0625L18.7833 12.6333L17.5625 9.375H13.675L12.45 12.6333L9.01668 12.0625L7.07501 15.4292L9.28751 18.1167L7.07501 20.8083L9.01668 24.175L12.45 23.6L13.675 26.8625H17.5625L18.7833 23.6L20.675 23.9167L22.2208 24.175L24.1625 20.8083L23.2792 19.7333L21.95 18.1167ZM15.6167 21.3958C13.8083 21.3958 12.3375 19.9292 12.3375 18.1167C12.3375 16.3042 13.8083 14.8375 15.6167 14.8375C17.425 14.8375 18.8958 16.3083 18.8958 18.1167C18.8958 19.925 17.4292 21.3958 15.6167 21.3958Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.2792 19.7333L20.7834 19.3208L19.1792 22.1L20.675 23.9166L22.2209 24.175L24.1625 20.8083L23.2792 19.7333Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.5643 17.1429C36.5528 17.0682 36.5294 16.9383 36.4662 16.7544L36.5399 16.8075C36.1836 16.0824 35.8391 15.2675 35.2615 14.7438C35.2347 14.7255 35.1889 14.6956 35.1843 14.7188C35.1141 14.8011 34.969 14.5831 34.8825 14.5071C34.7842 13.708 32.4606 12.7304 31.7274 12.2736C31.7446 12.2744 31.8482 12.2815 31.8621 12.2815C31.7035 11.9963 28.862 11.4492 29.4863 11.4533C29.2359 11.3703 28.9651 11.295 28.679 11.2299C28.8041 10.4456 28.6359 9.56881 28.3642 8.89949L28.3605 8.93799C26.8261 6.11374 21.829 3.77129 19.1274 6.06324C20.6861 5.73195 22.4215 5.29954 24.147 6.13C24.1432 6.09425 24.1911 6.08296 24.2195 6.1132L24.1926 6.14711C24.9642 6.36981 25.3464 6.73832 26.0478 7.08048C26.0467 7.08021 25.948 7.07195 25.9456 7.0725C27.1747 7.94801 28.3008 9.50075 28.1107 11.1214C19.8796 9.92165 26.0397 18.7191 28.5873 11.6838C31.7093 12.0755 35.3009 14.6457 36.5638 17.1451L36.5643 17.1429ZM28.0255 11.5769C27.7292 12.524 27.0772 13.6867 26.023 13.8752L26.0355 13.8807L26.0306 13.8864C26.4799 13.9236 26.9669 13.5852 27.2418 13.2753C26.7931 14.2251 25.4459 14.2876 24.7752 13.5507L24.818 13.5184C25.0179 13.7257 25.3054 13.8596 25.5824 13.8726C22.7395 12.3788 26.1014 11.2759 27.7158 11.5697C27.6792 11.5212 27.2175 11.5852 27.1041 11.4539C27.4215 11.4584 27.7391 11.4711 28.0439 11.5026L28.0255 11.5769Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("fiGQF", function(module, exports) {
$parcel$export(module.exports, "ProjectManagement", function () { return $e0590c5a806b447c$export$41e2b78bfeca3ed; });
$parcel$export(module.exports, "ProjectManagementHovered", function () { return $e0590c5a806b447c$export$353b70727d2726fd; });

var $7VQPk = parcelRequire("7VQPk");
const $e0590c5a806b447c$export$41e2b78bfeca3ed = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.275 18.1208H12.9792V28.0375H33.275V18.1208Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.9667 11.9624H6.67084V21.8791H26.9667V11.9624Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.9667 18.1208H12.9792V21.8792H26.9667V18.1208Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.0125 21.7042L27.6417 26.075L25.3834 23.7542L26.3584 22.8083L27.6584 24.1417L31.0542 20.7458L32.0167 21.7083L32.0125 21.7042Z",
                fill: "white"
            })
        ]
    });
const $e0590c5a806b447c$export$353b70727d2726fd = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.275 18.1208H12.9792V28.0375H33.275V18.1208Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.9667 11.9624H6.67084V21.8791H26.9667V11.9624Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.9667 18.1208H12.9792V21.8792H26.9667V18.1208Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.0125 21.7042L27.6417 26.075L25.3834 23.7542L26.3584 22.8083L27.6584 24.1417L31.0542 20.7458L32.0167 21.7083L32.0125 21.7042Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.197 8.96999C17.9677 8.92297 17.8414 8.6968 17.5653 8.83114C16.7371 9.23641 15.6773 10.562 15.3428 11.1128C14.5403 11.5225 13.1085 13.3541 12.5353 14.3012C12.1914 14.9125 11.2252 16.4977 11.2252 16.4977L11.1058 16.4888C11.1058 16.4888 9.24824 14.1019 8.30306 13.6138C8.13461 13.5601 7.94979 13.6116 7.78836 13.8512C7.7018 13.9362 8.3405 14.693 8.49023 14.702C8.63528 14.6258 9.30205 15.6021 9.70913 16.0947C10.9842 17.6441 11.2322 17.7784 11.8334 17.2814C12.8348 16.4529 17.1606 10.5396 18.197 8.96775V8.96999Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("eVijF", function(module, exports) {
$parcel$export(module.exports, "Recommended", function () { return $70309a04f3840ebd$export$a83bcf183f49ea9; });
$parcel$export(module.exports, "RecommendedHovered", function () { return $70309a04f3840ebd$export$2802fc4d26e7edfd; });

var $7VQPk = parcelRequire("7VQPk");
const $70309a04f3840ebd$export$a83bcf183f49ea9 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.2708 18.8332C33.2708 19.7957 32.6542 20.6166 31.7958 20.9249V26.2166C31.7958 27.8499 30.4708 29.1707 28.8417 29.1707H12.5958V17.6999H18.5458C21.1083 16.7791 22.9375 14.3249 22.9375 11.4457C22.9375 10.6332 23.6 9.96655 24.4167 9.96655C25.2333 9.96655 25.8958 10.6291 25.8958 11.4457V16.6166H31.0625C32.2875 16.6166 33.2792 17.6082 33.2792 18.8332H33.2708Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.5374 16.0457H7.51245V30.7248H16.5374V16.0457Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.5417 17.7041H12.5958V29.1749H16.5417V17.7041Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.5417 17.7041H12.5958V29.1749H16.5417V17.7041Z",
                fill: "#AE2A19"
            })
        ]
    });
const $70309a04f3840ebd$export$2802fc4d26e7edfd = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.2708 18.8332C33.2708 19.7957 32.6542 20.6166 31.7958 20.9249V26.2166C31.7958 27.8499 30.4708 29.1707 28.8417 29.1707H12.5958V17.6999H18.5458C21.1083 16.7791 22.9375 14.3249 22.9375 11.4457C22.9375 10.6332 23.6 9.96655 24.4167 9.96655C25.2333 9.96655 25.8958 10.6291 25.8958 11.4457V16.6166H31.0625C32.2875 16.6166 33.2792 17.6082 33.2792 18.8332H33.2708Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.5374 16.0457H7.51245V30.7248H16.5374V16.0457Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.5417 17.7041H12.5958V29.1749H16.5417V17.7041Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.5417 17.7041H12.5958V29.1749H16.5417V17.7041Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.019 9.59021C20.9102 9.65746 18.7947 7.04253 18.2912 5.75447C17.7724 5.75447 17.0841 5.36652 16.7172 4.74318C14.3916 4.52075 17.2865 6.97787 18.2076 7.72794C18.071 6.92355 18.8732 8.672 19.2325 8.79356C19.1338 8.66424 21.1354 11.23 21.1734 10.1515C21.2923 10.1954 21.1025 9.42985 21.0216 9.59021H21.019Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.3462 2.87304C24.8629 2.33247 24.8047 1.65741 24.9236 0.907331C23.3547 -1.02476 23.8 3.30241 23.9215 4.34993C23.9215 4.34993 24.0961 6.19407 23.9797 6.02595C23.7747 6.3027 23.4711 9.20214 24.4529 8.52707C24.5516 8.04341 24.3492 7.1278 24.668 6.94157C25.2728 6.35444 24.8654 3.93607 25.3437 2.87045L25.3462 2.87304Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.7501 5.26027C33.2642 3.73684 31.3688 6.27415 30.4148 6.93112C30.4148 6.93112 29.39 7.55705 29.2204 7.90881C29.3697 7.81828 25.865 10.2521 28.2032 9.77622C28.2437 9.72708 29.4583 8.88647 29.4583 8.88647C31.3486 8.27089 32.7657 6.69834 33.7501 5.25768V5.26027Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("cUy98", function(module, exports) {
$parcel$export(module.exports, "Software", function () { return $336d37ef48b5b511$export$99e8984809c19d2d; });
$parcel$export(module.exports, "SoftwareHovered", function () { return $336d37ef48b5b511$export$95b9ca195be2f85d; });

var $7VQPk = parcelRequire("7VQPk");
const $336d37ef48b5b511$export$99e8984809c19d2d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.6417 10.3875H8.35834V25.6333H31.6417V10.3875Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.2542 27.7208V30.3125H13.7458V27.7208H17.9125V23.0708H22.0875V27.7208H26.2542Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.0875 23.0708H17.9125V25.6375H22.0875V23.0708Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20 21.6291C21.9975 21.6291 23.6167 20.0098 23.6167 18.0124C23.6167 16.015 21.9975 14.3958 20 14.3958C18.0026 14.3958 16.3834 16.015 16.3834 18.0124C16.3834 20.0098 18.0026 21.6291 20 21.6291Z",
                fill: "white"
            })
        ]
    });
const $336d37ef48b5b511$export$95b9ca195be2f85d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.6417 10.3875H8.35834V25.6333H31.6417V10.3875Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.2542 27.7208V30.3125H13.7458V27.7208H17.9125V23.0708H22.0875V27.7208H26.2542Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.0875 23.0708H17.9125V25.6375H22.0875V23.0708Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20 21.6291C21.9975 21.6291 23.6167 20.0098 23.6167 18.0124C23.6167 16.015 21.9975 14.3958 20 14.3958C18.0026 14.3958 16.3834 16.015 16.3834 18.0124C16.3834 20.0098 18.0026 21.6291 20 21.6291Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.1635 10.5598C32.5086 10.5305 37.1259 9.43487 35.9147 9.19715C35.4655 9.32066 35.1163 9.19582 34.8917 9.5305C34.8267 9.13606 33.9458 9.76558 33.8104 9.78948C33.7495 9.49066 32.3692 10.2596 32.5709 9.98205C31.9443 9.99002 31.1662 10.2052 30.357 10.4575C29.9605 10.1932 31.6601 8.30733 30.9456 8.71505C30.9957 8.6088 31.1879 8.14929 31.1621 8.45342C31.3881 8.19312 33.8483 4.20886 32.8253 4.88353C32.1351 5.70561 31.6168 7.08284 31.0322 7.76282C30.4639 7.99258 30.0701 9.96612 29.4368 9.76956C29.0673 9.32598 28.1146 3.89411 27.438 4.37621C27.5557 4.79854 27.4488 5.17703 27.7777 5.38023C27.3758 5.44398 28.0172 6.30856 28.0416 6.44137C27.7438 6.49715 28.5152 7.85711 28.2378 7.6579C28.2432 8.04172 28.3312 8.4853 28.4584 8.95677C28.2892 8.8306 28.1038 8.5424 27.9969 8.4999C26.8575 8.04702 25.9941 7.00581 24.8073 6.44137C23.81 7.68844 32.6291 10.8347 27.1606 11.3048C26.1321 11.9635 24.7654 12.0645 23.6178 12.698C23.519 14.0699 30.0606 10.2849 28.1728 12.4589C27.8792 13.378 27.4434 14.4099 26.8412 15.3156C26.4569 18.77 29.725 9.38574 29.5897 12.9663C30.0403 13.8215 30.476 14.8521 30.6993 15.9133C32.2975 18.2135 30.1161 12.1282 29.8874 11.2663C30.7535 10.9037 34.1014 15.0155 34.7076 14.3674C34.7361 14.2758 34.2543 13.7671 34.1082 13.7126C34.0094 13.7618 33.9593 13.8016 33.9011 13.7113C34.1948 13.4337 33.1649 13.0831 33.0675 12.9875C33.284 12.7763 31.8509 12.0897 32.1987 12.1003C31.9308 11.7325 31.5208 11.3619 31.0539 10.9887C31.8821 10.832 32.242 10.2583 32.1662 10.5571L32.1635 10.5598Z",
                fill: "#101214"
            })
        ]
    });

});


parcelRegister("02XxA", function(module, exports) {
$parcel$export(module.exports, "TemplateSectionWrapper", function () { return $af20672793ccd347$export$7ae0d5b2f60aede8; });
/* template-section-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $af20672793ccd347$var$backgroundStyle = null;
const $af20672793ccd347$var$sectionStyle = null;
const $af20672793ccd347$var$unifiedSectionStyle = null;
const $af20672793ccd347$var$variantBackgroundStyle = null;
const $af20672793ccd347$var$unifiedVariantBackgroundStyle = null;
const $af20672793ccd347$export$7ae0d5b2f60aede8 = ({ children: children, shortPadding: shortPadding = false, columnOrientation: columnOrientation = false })=>{
    if (columnOrientation) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhku67f _85i58vuz",
            "_bozgzwfg _y4tizwfg"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _1n261q9c _19pkidpf _2hwx1wug _otyridpf _18u01wug _2lx21bp4 _p12fwg1u _zulpviql _85i58vuz"
            ]),
            children: children
        })
    });
    return shortPadding ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhku67f _85i58vuz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _1n261q9c _p12f1w69 _19pkidpf _2hwx1wug _otyridpf _18u01wug _85i58vuz _2osnviql _na0i1bp4 _mnhno812 _9ha5weo2 _3s7l1unt _zl7jk3xj _226y1ylp"
            ]),
            children: children
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhku67f _1yt4r2fv _18vt5uws _199d5uws"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _1n261q9c _p12f1w69 _19pkidpf _2hwx1wug _otyridpf _18u01wug _85i58vuz _2osnviql _na0i1bp4 _mnhno812 _9ha5weo2 _3s7l1unt _zl7jk3xj _226y1ylp"
            ]),
            children: children
        })
    });
};

});

parcelRegister("jBOxZ", function(module, exports) {
$parcel$export(module.exports, "UnifiedTemplatesNavigationSection", function () { return $71f98f39b5a1f613$export$7319ca81852e6fb4; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("kbpa7");
var $wjvXx = parcelRequire("wjvXx");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $2axoc = parcelRequire("2axoc");
const $71f98f39b5a1f613$var$sectionStyles = null;
const $71f98f39b5a1f613$var$TEMPLATES_HUB_PATH = '/templates';
const $71f98f39b5a1f613$export$7319ca81852e6fb4 = ({ product: product })=>{
    const intl = (0, $8e22h.default)();
    const linkText = intl.formatMessage({
        id: 'unified-templates-gallery.navigation-section.link-text',
        defaultMessage: 'All Atlassian templates'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q51xncg _85i5xncg _bfhkvuon"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $wjvXx.ColumnLayout), {
                layout: "10",
                tabletLayout: "10",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                    titleAs: "h2",
                    alignment: "center",
                    title: intl.formatMessage({
                        id: 'unified-templates-gallery.navigation-section.heading',
                        defaultMessage: 'Explore more templates to supercharge teamwork'
                    }),
                    text: intl.formatMessage({
                        id: 'unified-templates-gallery.navigation-section.body',
                        defaultMessage: 'Empower everyone, on every team. Build, connect, and deliver your biggest ideas seamlessly across Atlassian apps using our complete collection of ready-made workflows.'
                    }),
                    callToActionProps: {
                        link: {
                            text: linkText,
                            href: (0, $jQ0cd.getLocalizedHref)({
                                locale: intl.locale,
                                href: $71f98f39b5a1f613$var$TEMPLATES_HUB_PATH
                            }),
                            dataEventProps: {
                                'data-product-key': product,
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'unifiedTemplatesNavigationSection',
                                'data-label': linkText,
                                'data-label-english': 'All Atlassian templates'
                            }
                        }
                    }
                })
            })
        })
    });
};

});
parcelRegister("2axoc", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return $741f81fa1b361254$export$eb38b3b9c7f5f31b; });
/* content-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $8cYSw = parcelRequire("8cYSw");
parcelRequire("lTkkF");
var $5cqxx = parcelRequire("5cqxx");
var $21Swq = parcelRequire("21Swq");

var $6ltia = parcelRequire("6ltia");

var $i4BST = parcelRequire("i4BST");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");
const $741f81fa1b361254$export$6f93246b3457621f = {
    teamworkCollection: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/20d60pj8j2ju10y33n8jslya4i4a0125.svg',
        height: 62.5,
        alt: 'Teamwork Collection logo'
    },
    jira: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1m4xip711l01021jmk8k33gj82grm078.svg',
        height: 32,
        alt: 'Jira logo'
    },
    jiraProductDiscovery: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/lnuk8307fp65406pfvj4radajgkw48c5.svg',
        height: 32,
        alt: 'Jira Product Discovery logo'
    },
    jiraServiceManagement: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1x20y6tg7hdjl45x6l8a4iy22n3vhff2.svg',
        height: 32,
        alt: 'Jira Service Management logo'
    },
    statuspage: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r237roxi4i14gj1i4t362kw1g06h63tv.svg',
        height: 32,
        alt: 'Statuspage logo'
    },
    confluence: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ou687o50873egmj4l236et86h6178ylm.svg',
        height: 32,
        alt: 'Confluence logo'
    },
    trello: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gf3q277c3idu533i28bg3855yp2mwrlg.svg',
        height: 32,
        alt: 'Trello logo'
    },
    loom: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5ncpek557ni2al3s7s5v0dmkcs4ogt05.svg',
        height: 32,
        alt: 'Loom logo'
    },
    bitbucket: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xqweg4il0228mpa8ega4i5hi78p0k16v.svg',
        height: 32,
        alt: 'Bitbucket logo'
    },
    rovoDev: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg',
        height: 32,
        alt: 'Rovo Dev logo'
    },
    sourcetree: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/01u3w2aypa025m62s70p8uo6u21qg3i2.svg',
        height: 32,
        alt: 'Sourcetree logo'
    },
    compass: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yiu46gin8eoxy7f57m1g76a6b22uuf1b.svg',
        height: 32,
        alt: 'Compass logo'
    },
    guard: {
        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7085415d2l112j5j545y8nv6ir6t262w.svg',
        height: 32,
        alt: 'Guard logo'
    }
};
const $741f81fa1b361254$var$zeroMarginCss = null;
const $741f81fa1b361254$var$linkFocusOutlineBufferStyles = null;
const $741f81fa1b361254$var$wordWrapStyles = null;
const $741f81fa1b361254$var$contentColumnsLayout = {
    10: {
        assetSpan: 3,
        contentStart: 2
    },
    // 10 columns content block means 3 columns for asset, 7 for text
    12: {
        assetSpan: 4,
        contentStart: 1
    }
};
const $741f81fa1b361254$var$renderCta = ({ ctaProps: ctaProps, buttonSize: buttonSize, alignment: alignment, backgroundColor: backgroundColor, titleId: titleId, buttonId: buttonId, linkId: linkId })=>{
    if ('button' in ctaProps && ctaProps.button !== undefined) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bahv2pz _e8gh13g9 _msupokkc"
        ]),
        style: {
            "--_1k0ic5x": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.mobile),
            "--_y1mwbz": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.tablet),
            "--_isgew2": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.desktop)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                ...ctaProps.button,
                id: buttonId,
                size: buttonSize,
                variant: backgroundColor && backgroundColor === '#1868DB' && (ctaProps.buttonVariant === 'primary' || !ctaProps.buttonVariant) ? 'secondary' : ctaProps.buttonVariant ?? 'primary',
                responsiveSize: ctaProps.responsiveSize,
                colorAgainst: backgroundColor === '#1868DB' ? 'other' : 'white',
                ariaLabelledby: `${buttonId} ${titleId}`,
                dataEventProps: ctaProps.dataEventProps,
                className: (0, $2jatx.default)([
                    "_i0dl1ris"
                ]),
                children: ctaProps.buttonText
            }),
            ctaProps.link && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_85i51b66"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    id: linkId,
                    ariaLabelledby: `${linkId} ${titleId}`,
                    type: "primary",
                    bgColor: $741f81fa1b361254$var$isDarkBackgroundColor(backgroundColor) ? 'bgBlackBlue' : undefined,
                    "aria-label": ctaProps.link.text,
                    ...ctaProps.link
                })
            })
        ]
    });
    if (!ctaProps.link) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            "_85i51b66"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            id: linkId,
            ariaLabelledby: `${linkId} ${titleId}`,
            type: "primary",
            bgColor: $741f81fa1b361254$var$isDarkBackgroundColor(backgroundColor) ? 'bgBlackBlue' : undefined,
            "aria-label": ctaProps.link.text,
            ...ctaProps.link
        })
    });
};
const $741f81fa1b361254$var$renderIcon = ({ linkedIcon: { size: size = 'medium', url: url, alt: alt, paddingIncluded: paddingIncluded = false } = {}, iconComponent: iconComponent })=>{
    if (url) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
            src: url,
            alt: alt ?? '',
            style: {
                width: `${(0, $8cYSw.iconSizesPaddingIncluded)[size]}px`,
                height: `${(0, $8cYSw.iconSizesPaddingIncluded)[size]}px`,
                padding: `${paddingIncluded ? 0 : ((0, $8cYSw.iconSizesPaddingIncluded)[size] - (0, $8cYSw.iconSizesPaddingExcluded)[size]) / 2}px`,
                objectPosition: 'center'
            }
        })
    });
    if (iconComponent) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: iconComponent
    });
    return null;
};
const $741f81fa1b361254$var$isDarkBackgroundColor = (color)=>{
    return color ? (0, $6ltia.isDarkColor)(color) : false;
};
const $741f81fa1b361254$export$eb38b3b9c7f5f31b = ({ logo: logo, eyebrow: eyebrow, title: title, anchorLinkId: anchorLinkId, text: text, imageProps: imageProps, imageAspectRatio: imageAspectRatio = '16 / 9', spotIllustration: spotIllustration, icon: icon, callToActionProps: callToActionProps, alignment: alignment = 'start', orientation: orientation = 'vertical', columns: columns = 10, backgroundColor: backgroundColor, hat: hat, pants: pants, buttonSize: buttonSizeProp, imageBackgroundColor: imageBackgroundColor, ...props })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = 'h3', titleAppearsAs: titleAppearsAs } = props;
    const isLargeTextStyling = TitleComponent === 'h2' && (!titleAppearsAs || titleAppearsAs === 'h2');
    const isSmallDetailStyling = TitleComponent === 'h4';
    // Explicit `buttonSize` prop wins over the auto-derived value. This lets a
    // caller opt into a compact CTA (e.g. "small" secondary button) without
    // changing the semantic heading level.
    const buttonSize = buttonSizeProp ?? (isSmallDetailStyling ? 'small' : 'large');
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = anchorLinkId ?? `content-block-title-${uniqueId}`;
    const buttonId = `content-block-button-${uniqueId}`;
    const linkId = `content-block-link-${uniqueId}`;
    // for anchor links, to ensure scroll height is pushed down below nav
    (0, $1oC0p.useEffect)(()=>{
        if (anchorLinkId) (0, $21Swq.updateStickyNavOffset)();
    }, [
        anchorLinkId
    ]);
    const lightTextStyles = null;
    const textElement = typeof text === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            $741f81fa1b361254$var$isDarkBackgroundColor(backgroundColor) && "_125x1afi _9wql1afi _1loe1afi _v8gm1afi _1ikb1afi _1r0m1afi _1rs41afi _1gng1afi _489d1afi _m41t1afi _cg411afi _qliy1afi _1rhq1afi _jl6w1afi",
            isLargeTextStyling ? 'body-lg' : 'body-md'
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
        },
        children: text
    }) : text;
    const bgColorStyle = null;
    const backgroundColorMargin = null;
    const textContent = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _1q51hl9w _1bah1h6o _1b1q1cw5",
            $741f81fa1b361254$var$isDarkBackgroundColor(backgroundColor) && "_125x1afi _9wql1afi _1loe1afi _v8gm1afi _1ikb1afi _1r0m1afi _1rs41afi _1gng1afi _489d1afi _m41t1afi _cg411afi _qliy1afi _1rhq1afi _jl6w1afi"
        ]),
        style: {
            "--_1jxeyjv": (0, $6ZVlx.default)(orientation === 'horizontal' ? "var(--ds-space-100, 8px)" : undefined),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpu2gc"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: $741f81fa1b361254$export$6f93246b3457621f[logo].src,
                        alt: $741f81fa1b361254$export$6f93246b3457621f[logo].alt,
                        height: $741f81fa1b361254$export$6f93246b3457621f[logo].height,
                        style: {
                            objectPosition: 'left top',
                            objectFit: 'contain'
                        }
                    }),
                    eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            isSmallDetailStyling ? 'eyebrow-sm' : 'eyebrow-md'
                        ]),
                        children: eyebrow
                    }),
                    title && /*#__PURE__*/ (0, $7VQPk.jsx)(TitleComponent, {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "_1i4q1hna _3fcw150s",
                            anchorLinkId && "_j4orl2ab",
                            titleAppearsAs ? titleAppearsAs : undefined
                        ]),
                        id: titleId,
                        children: title
                    }),
                    text && textElement
                ]
            }),
            callToActionProps && $741f81fa1b361254$var$renderCta({
                ctaProps: callToActionProps,
                buttonSize: buttonSize,
                alignment: alignment,
                backgroundColor: backgroundColor,
                titleId: titleId,
                buttonId: buttonId,
                linkId: linkId
            })
        ]
    });
    const assetStyles = null;
    const imageStyle = null;
    const roundedCornersStyle = null;
    const horizontalSpotIllustrationStyles = null;
    const assetContent = imageProps ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: imageBackgroundColor ? {
            backgroundColor: imageBackgroundColor,
            borderRadius: (0, $bNzAT.default)('corner.radius.card')
        } : {},
        className: (0, $2jatx.default)([
            "_1b1q7d4p"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
            ...imageProps,
            alt: imageProps.alt ?? '',
            className: (0, $2jatx.default)([
                "_1h1tee60 _1bsb1osq _4t3i1wug _5ral1f51",
                isWacRefresh && "_2rko1ylz"
            ]),
            style: {
                "--_f8wnbo": (0, $6ZVlx.default)(imageAspectRatio),
                "--_6td02k": (0, $6ZVlx.default)((0, $bNzAT.default)('corner.radius.card'))
            }
        })
    }) : spotIllustration ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1b1q7d4p",
            orientation === 'horizontal' && "_181n1txw _q8t51h6o _e8gh1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
            src: spotIllustration.src,
            alt: '',
            style: {
                width: spotIllustration.width ?? 'auto'
            },
            className: (0, $2jatx.default)([
                "_p12f1osq"
            ])
        })
    }) : icon ? $741f81fa1b361254$var$renderIcon(icon) : null;
    const gapBetweenIconAndText = null;
    if (orientation === 'vertical') return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e1faxbu",
            "_y3gnv2pz _uj6k13g9 _10hlokkc _1e0c1txw _2lx21bp4 _zulp1ejb _11q79r5u",
            icon && "_zulppxbi"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1k0ic5x": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.mobile),
            "--_y1mwbz": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.tablet),
            "--_isgew2": (0, $6ZVlx.default)(typeof alignment === 'string' ? alignment : alignment.desktop)
        },
        children: [
            assetContent,
            textContent
        ]
    });
    const fullWidthGridStyles = null;
    const horizontalContentBlock = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bcx6w _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg",
            "_1e1faxbu",
            "_kqswh2mm _1pbykb7n _85i5xy5q _1v6zvn47 _1oyh1c27",
            backgroundColor && "_1q51xy5q _85i5xncg"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1mhd7en": (0, $6ZVlx.default)(orientation === 'horizontal-reverse' ? $741f81fa1b361254$var$contentColumnsLayout[numColumns]['contentStart'] : $741f81fa1b361254$var$contentColumnsLayout[numColumns]['contentStart'] + $741f81fa1b361254$var$contentColumnsLayout[numColumns]['assetSpan']),
            "--_4xfsov": (0, $6ZVlx.default)(numColumns - $741f81fa1b361254$var$contentColumnsLayout[numColumns]['assetSpan']),
            "--_1fmoioe": (0, $6ZVlx.default)(orientation === 'horizontal' ? $741f81fa1b361254$var$contentColumnsLayout[numColumns]['contentStart'] : $741f81fa1b361254$var$contentColumnsLayout[numColumns]['contentStart'] + numColumns - $741f81fa1b361254$var$contentColumnsLayout[numColumns]['assetSpan']),
            "--_1d5meks": (0, $6ZVlx.default)($741f81fa1b361254$var$contentColumnsLayout[numColumns]['assetSpan'])
        },
        children: [
            orientation === 'horizontal' ? assetContent : null,
            textContent,
            orientation === 'horizontal-reverse' ? assetContent : null
        ]
    });
    switch(numColumns){
        case 10:
        case 12:
            if (backgroundColor) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e1faxbu",
                    "_vhvkte8j _wsfy5ydn _11nb1pej _tqhl1w1x _9s88xx3z _1rcble4j",
                    "_1bsb1osq _kqswh2mm _1pfh1m3o _6rth1aiy"
                ]),
                style: {
                    "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                    "--_1qkf21h": (0, $6ZVlx.default)(hat ? `${(0, $5cqxx.SECTION_DIVIDER_HEIGHTS).mobile}px` : '0px'),
                    "--_lmjtl5": (0, $6ZVlx.default)(pants ? `${(0, $5cqxx.SECTION_DIVIDER_HEIGHTS).mobile}px` : '0px'),
                    "--_1gqad6k": (0, $6ZVlx.default)(hat ? `${(0, $5cqxx.SECTION_DIVIDER_HEIGHTS).tablet}px` : '0px'),
                    "--_j464eu": (0, $6ZVlx.default)(pants ? `${(0, $5cqxx.SECTION_DIVIDER_HEIGHTS).tablet}px` : '0px'),
                    "--_1dzqs6e": (0, $6ZVlx.default)(hat ? `${(0, $5cqxx.SECTION_DIVIDER_HEIGHTS).desktop}px` : '0px'),
                    "--_10c1sh1": (0, $6ZVlx.default)(pants ? `${(0, $5cqxx.SECTION_DIVIDER_HEIGHTS).desktop}px` : '0px')
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1bsbauwl _14b5zqdx _b8yq87gh _4t3i1osq _1e021ssb _t9eczr6s _11q79r5u",
                            hat && "_1kt9b3bt _1cs8h2mm _cfu11ule _kfgt1m3o _1s6k9r5u _iajm18y9",
                            hat && hat === 'high-right' ? "_tgsmkyn1" : "_tgsmvrmp",
                            pants && "_aetrb3bt _18poh2mm _1ywu1ule _1qdg1aiy _16r29r5u _19nql9tr",
                            pants && pants === 'high-right' ? "_1oj4snn3" : "_1oj4df5m"
                        ])
                    }),
                    horizontalContentBlock
                ]
            });
            return horizontalContentBlock;
    }
};
const $741f81fa1b361254$var$anchorLinkStyle = null;
const $741f81fa1b361254$var$hatCommonStyle = null;
const $741f81fa1b361254$var$hatHighLeft = null;
const $741f81fa1b361254$var$hatHighRight = null;
const $741f81fa1b361254$var$pantsCommonStyle = null;
const $741f81fa1b361254$var$pantsHighLeft = null;
const $741f81fa1b361254$var$pantsHighRight = null;

});
parcelRegister("8cYSw", function(module, exports) {
$parcel$export(module.exports, "iconSizesPaddingExcluded", function () { return $170a6939546b7903$export$a96543b1dfdce302; });
$parcel$export(module.exports, "iconSizesPaddingIncluded", function () { return $170a6939546b7903$export$4ee04976bc3201e6; });
const $170a6939546b7903$export$a96543b1dfdce302 = {
    'x-small': 24,
    small: 32,
    medium: 48,
    large: 64
};
const $170a6939546b7903$export$4ee04976bc3201e6 = {
    'x-small': 32,
    small: 48,
    medium: 88,
    large: 128
};

});

parcelRegister("lTkkF", function(module, exports) {
$parcel$export(module.exports, "RichTextComponent", function () { return (parcelRequire("cXZQx")).RichTextComponent; });
$parcel$export(module.exports, "updateStickyNavOffset", function () { return (parcelRequire("21Swq")).updateStickyNavOffset; });
$parcel$export(module.exports, "SECTION_DIVIDER_HEIGHTS", function () { return (parcelRequire("5cqxx")).SECTION_DIVIDER_HEIGHTS; });
$parcel$export(module.exports, "generateSafeIds", function () { return (parcelRequire("3pCWN")).generateSafeIds; });
$parcel$export(module.exports, "spaceTokenValues", function () { return (parcelRequire("bmJB7")).spaceTokenValues; });

var $cXZQx = parcelRequire("cXZQx");

var $5cqxx = parcelRequire("5cqxx");

var $bmJB7 = parcelRequire("bmJB7");

var $21Swq = parcelRequire("21Swq");

var $3pCWN = parcelRequire("3pCWN");

});
parcelRegister("cXZQx", function(module, exports) {
$parcel$export(module.exports, "RichTextComponent", function () { return $4582aa505fd4df07$export$f7b0c3f1955f2d70; });
/* rich-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $3fFrT = parcelRequire("3fFrT");

var $17RBn = parcelRequire("17RBn");

var $jQ0cd = parcelRequire("jQ0cd");
// Defined outside RichTextComponent to avoid re-definition on render; used with memoization
// to prevent DOM reconciliation issues with context providers. Uniform may omit a leading
// slash on path slugs; normalize before useLocalizedHref (same as Link/Button: hook applies
// absolute→relative and locale/WAC rules).
const $4582aa505fd4df07$var$linkPathToHrefInput = (path)=>{
    if (!path || path.startsWith('/') || path.startsWith('#') || /^https?:\/\//i.test(path) || /^[a-z][a-z0-9+.-]*:/i.test(path)) return path;
    return `/${path}`;
};
const $4582aa505fd4df07$var$LinkRenderer = ({ node: node, children: children, dataEventProps: dataEventProps })=>{
    const path = node['link'].path;
    const localizedHref = (0, $jQ0cd.useLocalizedHref)($4582aa505fd4df07$var$linkPathToHrefInput(path));
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: localizedHref,
        ...dataEventProps,
        children: children
    });
};
const $4582aa505fd4df07$var$createLinkRendererWithContext = (dataEventProps)=>{
    const BoundLinkRenderer = ({ node: node, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)($4582aa505fd4df07$var$LinkRenderer, {
            node: node,
            dataEventProps: dataEventProps,
            children: children
        });
    return BoundLinkRenderer;
};
const $4582aa505fd4df07$export$f7b0c3f1955f2d70 = ({ text: text, uniformParameter: uniformParameter, uniformRichText: uniformRichText, bgColor: bgColor })=>{
    // NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
    const richTextCss = null;
    const containerRef = (0, $1oC0p.useRef)(null);
    const localeCode = (0, $17RBn.useLocale)();
    const dataEventProps = {
        'data-product-key': undefined,
        'data-event-component': 'linkButton',
        'data-event': 'clicked',
        'data-event-container': 'bodyContentInline'
    };
    const html = (0, $1oC0p.useMemo)(()=>{
        let initialHtml = text || '';
        // Hacky stuff pt1: Need to fix relative localized links
        const relativeLinkRegex = /(?:\"https:\/\/\/)(?<urlSlug>.+?)\"/g;
        initialHtml = initialHtml.replace(relativeLinkRegex, (_match, _p1, _offset, _string, groups)=>{
            return `"/${(0, $jQ0cd.getLocalizedHrefForPathSlug)(groups.urlSlug, localeCode)}"`;
        });
        // similar to above, but for relative anchor links, fix but don't localize them
        const relativeAnchorLinkRegex = /(?:\"https:\/\/\#)(?<anchor>.+?)\"/g;
        initialHtml = initialHtml.replace(relativeAnchorLinkRegex, (_match, _p1, _offset, _string, groups)=>{
            return `"#${groups.anchor}"`;
        });
        // handle case where link is relative and not localized
        const relativeUrlRegex = new RegExp(`href="\\/(${localeCode}\\/)?([^"]*)"`, 'g');
        initialHtml = initialHtml.replace(relativeUrlRegex, (_match, _p1, _p2)=>{
            // If already localized, return the match as is
            const href = `/${_p2}`;
            const alreadyLocalized = (0, $3fFrT.LOCALES).some((locale)=>href.startsWith(`/${locale}/`)) || (0, $3fFrT.LOCALES).some((locale)=>href === `/${locale}`);
            // If already localized, return the match as is
            if (alreadyLocalized) return _match;
            // Otherwise, prepend the current locale code to the URL
            return `href="/${(0, $jQ0cd.getLocalizedHrefForPathSlug)(_p2, localeCode)}"`;
        });
        // handle case where absolute WAC links are not localized
        const absolutePathRegex = /\"https:\/\/www\.atlassian\.com\/(?![a-z]{2}\/)(?<urlSlug>.+?)\"/g;
        initialHtml = initialHtml.replace(absolutePathRegex, (_match, _p1, _offset, _string, groups)=>{
            return `"/${(0, $jQ0cd.getLocalizedHrefForPathSlug)(groups.urlSlug, localeCode)}"`;
        });
        // Hacky stuff pt2: replace &amp;nbsp; with &nbsp;
        initialHtml = initialHtml.replace(/&amp;nbsp;/g, '&nbsp;').replace(/&amp;amp;/g, '&amp;');
        // Move leading and trailing whitespace outside anchor tags
        // This handles cases where Contentful includes spaces in link text
        // Spaces are preserved but moved outside the link so they're not underlined
        initialHtml = initialHtml.replace(/<a\s*([^>]*)>([\s\S]*?)<\/a>/g, (_match, attributes, innerContent)=>{
            // Extract leading whitespace (spaces, tabs, newlines, non-breaking spaces)
            const leadingWhitespaceMatch = innerContent.match(/^([\s\u00A0]+)/);
            const leadingWhitespace = leadingWhitespaceMatch ? leadingWhitespaceMatch[1] : '';
            // Extract trailing whitespace
            const trailingWhitespaceMatch = innerContent.match(/([\s\u00A0]+)$/);
            const trailingWhitespace = trailingWhitespaceMatch ? trailingWhitespaceMatch[1] : '';
            // Get trimmed inner content
            const trimmed = innerContent.replace(/^[\s\u00A0]+/, '').replace(/[\s\u00A0]+$/, '');
            // Preserve attributes with proper spacing
            const attrs = attributes.trim();
            const dataAttrs = Object.entries(dataEventProps).map(([key, value])=>`${key}="${value}"`).join(' ');
            const anchorTag = `<a ${attrs ? `${attrs} ` : ''}${dataAttrs}>${trimmed}</a>`;
            // Return with whitespace moved outside the anchor tag
            return `${leadingWhitespace}${anchorTag}${trailingWhitespace}`;
        });
        initialHtml = initialHtml.replace(/<pre\s*([^>]*)>\s*<code\s*([^>]*)>([\s\S]*?)<\/code>\s*<\/pre>/g, (_match, preAttributes, codeAttributes, innerContent)=>{
            // Preserve <pre> attributes with proper spacing
            const preAttrs = preAttributes.trim();
            const preOpenTag = preAttrs ? `<pre ${preAttrs}>` : `<pre>`;
            // Preserve <code> attributes with proper spacing
            const codeAttrs = codeAttributes.trim();
            const codeOpenTag = codeAttrs ? `<code class="code-block" ${codeAttrs}>` : `<code class="code-block">`;
            const lines = innerContent.split(/\r\n|\n|\r/i);
            const wrapped = lines.map((line, index)=>{
                const isFirst = index === 0;
                const isLast = index === lines.length - 1;
                const dataAttrs = [
                    isFirst ? 'data-first-line' : '',
                    isLast ? 'data-last-line' : ''
                ].filter(Boolean).join(' ');
                // Make <html> within code block display as text
                const escapedLine = line.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                return `<span class="code-line"${dataAttrs ? ` ${dataAttrs}` : ''}><span class="line-number" aria-hidden="true">${index + 1}</span><span class="line-content">${escapedLine}</span></span>`;
            }).join('\n');
            return `${preOpenTag}${codeOpenTag}${wrapped}</code></pre>`;
        });
        return initialHtml;
    }, [
        text,
        localeCode
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const root = containerRef.current;
        if (!root) return;
        // Transform function — wraps each "line" inside code blocks with <span>
        const processCodeBlocks = ()=>{
            // @ts-ignore - dataset spanned property access
            root.querySelectorAll('pre > code').forEach((codeNode)=>{
                const el = codeNode;
                // Avoid double-processing - check if already processed by regex or DOM manipulation
                if (el.dataset['spanned'] === '1') return;
                // Check if already processed by regex replacement (contains code-line structure)
                if (el.querySelector('.code-line')) return;
                if (!el.classList.contains('code-block')) el.classList.add('code-block');
                const raw = el.innerHTML;
                const lines = raw.split(/<br\s*\/?>|\r\n|\n|\r/i);
                const wrapped = lines.map((line, index)=>{
                    const isFirst = index === 0;
                    const isLast = index === lines.length - 1;
                    const dataAttrs = [
                        isFirst ? 'data-first-line' : '',
                        isLast ? 'data-last-line' : ''
                    ].filter(Boolean).join(' ');
                    return `<span class="code-line"${dataAttrs ? ` ${dataAttrs}` : ''}><span class="line-number" aria-hidden="true">${index + 1}</span><span class="line-content">${line}</span></span>`;
                }).join('\n');
                el.innerHTML = wrapped;
                el.dataset['spanned'] = '1';
            });
        };
        const processAll = ()=>{
            processCodeBlocks();
        };
        processAll();
        // Observe DOM changes so we catch async content rendered by UniformRichText
        const mo = new MutationObserver(()=>{
            processAll();
        });
        mo.observe(root, {
            childList: true,
            subtree: true
        });
        return ()=>mo.disconnect();
    }, [
        uniformParameter,
        text
    ]);
    // Memoized renderer that uses the factory function to create a bound component
    // This ensures the component itself is never defined during render
    const memoizedLinkRenderer = (0, $1oC0p.useMemo)(()=>$4582aa505fd4df07$var$createLinkRendererWithContext(dataEventProps), [
        localeCode
    ]);
    // Memoized renderer resolver to prevent recreation on each render
    // This prevents React from treating the renderer as a new node each time,
    // which was causing insertBefore errors with context providers
    const memoizedRichTextRenderer = (0, $1oC0p.useMemo)(()=>(richTextNode)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (richTextNode.type === 'link') return memoizedLinkRenderer;
            return undefined;
        }, [
        memoizedLinkRenderer
    ]);
    return uniformParameter ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _wphk7vkz _59381r31 _yha28stv _1nmznqa1 _2cc6v77o _43ds13ks _1cay1tbu _oavva7pe _oxk4a7pe _1byu1aoq _1o7v1aoq _1gw29y44 _l5k11fw0 _r8nt1fw0 _1a7k1fw0 _5gkf1fw0 _r8f31fw0 _1cnc1b66 _jw8h1b66 _1o6v1b66 _k6x01b66 _1t0h1b66 _1wvv1b66 _17q8oahv _d62soahv _fvk9xy5q _6bbs1ejb _oio31ejb _ukz11ejb _12ogidpf _102oidpf _3fjiidpf _1kvxidpf _pezqidpf _1ysjidpf _1yf6idpf _17d4idpf _1lmscfaq _1c56idpf _1s5ridpf _1glg12lh _1d9p1ule _1806idpf _1of3zh62 _1fr8ftgi _1160ftgi _lxprftgi _il49ftgi _xhev1e5h _o6n98xuz _1rm5idpf _1ht62e77 _wqy81e5h _1c2j1okz _yb6gnqa1 _2b5et94y _a2nzpxbi _134q1ule _1mjs1wug _22rsxncg _1txxidpf _1gc1idpf _1133dkka _ui351pfd _1gc7v77o _b6z312x7 _t94soxwj _5beh14y2 _11gzidpf _1oyzidpf _ixhlidpf _6bjwidpf _sw6v1wug _1jicdkka _16fxi2wt _kzghpxbi _184qh2mm _7nqy1mxr _1qwj1o8l _z4yy1ul9 _11bbusic _1i7pv77o _otxn1b66 _y83cpxbi _6mush2mm _1bam1okz _2dw3v8ft _1a5ib3bt _1uk3stnw _5f7vidpf _1l0i1bs0 _111rftgi _1xrg1osq _1knm6qu4 _1xapu2gc _1r0fi2wt _8xo6u2gc _z5lvi2wt"
        ]),
        style: {
            "--_vhq2pv": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].defaultColor),
            "--_3fl7q1": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].visitedColor),
            "--_162q9r": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].hoverColor),
            "--_n3jpy8": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].visitedHoverColor),
            "--_1hwkv7u": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1100')),
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light200')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
            "--_vimidu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark600')),
            "--_1q70ahv": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1000'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichText), {
            parameterId: uniformParameter,
            resolveRichTextRenderer: memoizedRichTextRenderer
        })
    }) : uniformRichText ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _wphk7vkz _59381r31 _yha28stv _1nmznqa1 _2cc6v77o _43ds13ks _1cay1tbu _oavva7pe _oxk4a7pe _1byu1aoq _1o7v1aoq _1gw29y44 _l5k11fw0 _r8nt1fw0 _1a7k1fw0 _5gkf1fw0 _r8f31fw0 _1cnc1b66 _jw8h1b66 _1o6v1b66 _k6x01b66 _1t0h1b66 _1wvv1b66 _17q8oahv _d62soahv _fvk9xy5q _6bbs1ejb _oio31ejb _ukz11ejb _12ogidpf _102oidpf _3fjiidpf _1kvxidpf _pezqidpf _1ysjidpf _1yf6idpf _17d4idpf _1lmscfaq _1c56idpf _1s5ridpf _1glg12lh _1d9p1ule _1806idpf _1of3zh62 _1fr8ftgi _1160ftgi _lxprftgi _il49ftgi _xhev1e5h _o6n98xuz _1rm5idpf _1ht62e77 _wqy81e5h _1c2j1okz _yb6gnqa1 _2b5et94y _a2nzpxbi _134q1ule _1mjs1wug _22rsxncg _1txxidpf _1gc1idpf _1133dkka _ui351pfd _1gc7v77o _b6z312x7 _t94soxwj _5beh14y2 _11gzidpf _1oyzidpf _ixhlidpf _6bjwidpf _sw6v1wug _1jicdkka _16fxi2wt _kzghpxbi _184qh2mm _7nqy1mxr _1qwj1o8l _z4yy1ul9 _11bbusic _1i7pv77o _otxn1b66 _y83cpxbi _6mush2mm _1bam1okz _2dw3v8ft _1a5ib3bt _1uk3stnw _5f7vidpf _1l0i1bs0 _111rftgi _1xrg1osq _1knm6qu4 _1xapu2gc _1r0fi2wt _8xo6u2gc _z5lvi2wt",
            "_1e0c1ule"
        ]),
        style: {
            "--_vhq2pv": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].defaultColor),
            "--_3fl7q1": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].visitedColor),
            "--_162q9r": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].hoverColor),
            "--_n3jpy8": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].visitedHoverColor),
            "--_1hwkv7u": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1100')),
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light200')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
            "--_vimidu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark600')),
            "--_1q70ahv": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1000'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
            node: uniformRichText,
            resolveRichTextRenderer: memoizedRichTextRenderer
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        dangerouslySetInnerHTML: {
            __html: html
        },
        className: (0, $2jatx.default)([
            "_clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _wphk7vkz _59381r31 _yha28stv _1nmznqa1 _2cc6v77o _43ds13ks _1cay1tbu _oavva7pe _oxk4a7pe _1byu1aoq _1o7v1aoq _1gw29y44 _l5k11fw0 _r8nt1fw0 _1a7k1fw0 _5gkf1fw0 _r8f31fw0 _1cnc1b66 _jw8h1b66 _1o6v1b66 _k6x01b66 _1t0h1b66 _1wvv1b66 _17q8oahv _d62soahv _fvk9xy5q _6bbs1ejb _oio31ejb _ukz11ejb _12ogidpf _102oidpf _3fjiidpf _1kvxidpf _pezqidpf _1ysjidpf _1yf6idpf _17d4idpf _1lmscfaq _1c56idpf _1s5ridpf _1glg12lh _1d9p1ule _1806idpf _1of3zh62 _1fr8ftgi _1160ftgi _lxprftgi _il49ftgi _xhev1e5h _o6n98xuz _1rm5idpf _1ht62e77 _wqy81e5h _1c2j1okz _yb6gnqa1 _2b5et94y _a2nzpxbi _134q1ule _1mjs1wug _22rsxncg _1txxidpf _1gc1idpf _1133dkka _ui351pfd _1gc7v77o _b6z312x7 _t94soxwj _5beh14y2 _11gzidpf _1oyzidpf _ixhlidpf _6bjwidpf _sw6v1wug _1jicdkka _16fxi2wt _kzghpxbi _184qh2mm _7nqy1mxr _1qwj1o8l _z4yy1ul9 _11bbusic _1i7pv77o _otxn1b66 _y83cpxbi _6mush2mm _1bam1okz _2dw3v8ft _1a5ib3bt _1uk3stnw _5f7vidpf _1l0i1bs0 _111rftgi _1xrg1osq _1knm6qu4 _1xapu2gc _1r0fi2wt _8xo6u2gc _z5lvi2wt"
        ]),
        style: {
            "--_vhq2pv": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].defaultColor),
            "--_3fl7q1": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].visitedColor),
            "--_162q9r": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].hoverColor),
            "--_n3jpy8": (0, $6ZVlx.default)((0, $iPPTB.linkColors)[bgColor || 'bgWhite'].visitedHoverColor),
            "--_1hwkv7u": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1100')),
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light200')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black')),
            "--_vimidu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark600')),
            "--_1q70ahv": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark1000'))
        }
    });
};

});
parcelRegister("01zo5", function(module, exports) {
$parcel$export(module.exports, "useUniformCurrentComposition", function () { return $004b8b53321b75a6$export$6d4c4b62941f5043; });
$parcel$export(module.exports, "UniformComposition", function () { return $004b8b53321b75a6$export$427b0dbdb756b3fe; });
$parcel$export(module.exports, "UniformSlot", function () { return $004b8b53321b75a6$export$3ef263bb67afc85b; });
$parcel$export(module.exports, "UniformPlayground", function () { return $004b8b53321b75a6$export$5bf20c552edca720; });
$parcel$export(module.exports, "UniformRichTextNode", function () { return $004b8b53321b75a6$export$fba07398d032ca85; });
$parcel$export(module.exports, "UniformRichText", function () { return $004b8b53321b75a6$export$914217645a759423; });

var $f2QWG = parcelRequire("f2QWG");

var $1oC0p = parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $eSosQ = parcelRequire("eSosQ");

var $dZNgt = parcelRequire("dZNgt");
'use client';
var $004b8b53321b75a6$var$wrapperStyles = {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    borderLeft: "4px solid #e42535",
    padding: "16px",
    fontSize: "16px",
    borderRadius: "0 8px 8px 0",
    margin: "8px",
    backgroundColor: "rgba(255, 255, 255, 0.45)",
    color: "#1d3557"
};
function $004b8b53321b75a6$export$60d0cb61694fb8bc(props) {
    var _a, _b, _c;
    const componentType = (_a = props.component) == null ? void 0 : _a.type;
    if (!componentType) return null;
    if (componentType === (0, $f2QWG.EMPTY_COMPOSITION).type) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("style", null, `@keyframes _uniformDelayedFadeIn { 0%,75% { opacity: 0; } to { opacity: 1; } }`), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", {
        style: {
            animation: "_uniformDelayedFadeIn 3s"
        }
    }, "This component only works inside Uniform Canvas editor.", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("br", null), "If you think this is an error, try", " ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("a", {
        href: "",
        style: {
            fontWeight: "bolder",
            textDecoration: "underline"
        }
    }, "reloading the page"), "."));
    if (componentType === (0, $f2QWG.CANVAS_LOCALIZATION_TYPE)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        style: $004b8b53321b75a6$var$wrapperStyles
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", null, "Seems like localization is not enabled in your application. Please read our documentation on how to", " ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("a", {
        href: "https://docs.uniform.app/guides/composition/localization#activate-front-end",
        target: "_blank",
        style: {
            fontWeight: "bolder",
            textDecoration: "underline"
        },
        rel: "noreferrer"
    }, "enable localization in your front-end application.")));
    const proposedFileName = `${componentType[0].toUpperCase()}${componentType.substring(1)}`;
    const probableProps = Object.keys((_b = props.component.parameters) != null ? _b : {});
    const probableSlots = Object.keys((_c = props.component.slots) != null ? _c : {});
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        style: $004b8b53321b75a6$var$wrapperStyles
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("h2", {
        style: {
            fontSize: "1.2rem"
        }
    }, "Unknown Component"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", null, "Received request from Uniform to render a component with the public ID: ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("code", null, componentType), "."), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("code", null, "<UniformComposition />"), " does not have ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("code", null, componentType), " mapped to a React component yet."), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", null, "To teach your app how to render this component:"), " ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("ul", {
        style: {
            listStyleType: "disc",
            marginLeft: "1rem",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem"
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("li", null, "Create a React component and register it with Uniform, for example", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pre", null, `function ${proposedFileName}(${probableProps.length > 0 ? `{ ${probableProps.join(", ")} }` : ""}) {
  return (
    <div>
      ${proposedFileName}!
      ${probableSlots.length > 0 ? probableSlots.map((slot)=>`<UniformSlot name="${slot}" />`).join("\n      ") : ""}
    </div>
  )
}

registerUniformComponent({ type: "${componentType}", component: ${proposedFileName} })`), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("details", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("summary", {
        style: {
            cursor: "pointer"
        }
    }, "Props that your React component will receive"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pre", null, JSON.stringify(props, null, 2)))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("li", null, "Import the component into the file where ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("code", null, "<UniformComposition />"), " is defined, for example ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pre", null, `import "../components/${proposedFileName}.tsx"`))), " ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", null, "Need more help?", " ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("a", {
        href: "https://docs.uniform.app/docs/guides/composition/rendering",
        target: "_blank",
        rel: "noreferrer",
        style: {
            textDecoration: "underline"
        }
    }, "Check out the documentation.")));
}
// src/helpers/convertComponentToProps.ts
function $004b8b53321b75a6$export$840ce7a9a49cf2fd(component) {
    var _a;
    const parameters = (_a = component.parameters) != null ? _a : {};
    const renderComponentProps = {
        ...Object.keys(parameters).reduce((acc, cur)=>{
            acc[cur] = parameters[cur].value;
            return acc;
        }, {}),
        ...component.data,
        component: component
    };
    return renderComponentProps;
}
// src/storeDefinition.ts
var $004b8b53321b75a6$export$778e7aa1c9e6bd35 = "__not_implemented__";
var $004b8b53321b75a6$var$getTypeWithVariant = (type, variantId)=>`${type}${variantId ? `__${variantId}` : ""}`;
var $004b8b53321b75a6$export$b034044f602d83ac = ()=>{
    const components = /* @__PURE__ */ new Map();
    components.set($004b8b53321b75a6$export$778e7aa1c9e6bd35, $004b8b53321b75a6$export$60d0cb61694fb8bc);
    return {
        register: ({ type: type, component: component, variantId: variantId })=>{
            components.set($004b8b53321b75a6$var$getTypeWithVariant(type, variantId), component);
        },
        get: (type, variantId)=>{
            return components.get($004b8b53321b75a6$var$getTypeWithVariant(type, variantId));
        },
        getComponentsMap: ()=>new Map(components)
    };
};
var $004b8b53321b75a6$export$ac19878f39242c72 = ({ store: store, defaultComponent: defaultComponent = $004b8b53321b75a6$export$60d0cb61694fb8bc })=>{
    return (component)=>{
        var _a;
        const resolved = (_a = store.get($004b8b53321b75a6$var$getTypeWithVariant(component.type, component.variant))) != null ? _a : store.get($004b8b53321b75a6$var$getTypeWithVariant(component.type));
        return resolved || defaultComponent;
    };
};
// src/store.ts
var $004b8b53321b75a6$export$5b736590a80984cb = $004b8b53321b75a6$export$b034044f602d83ac();
var $004b8b53321b75a6$export$fcb7a055f278d82f = ({ type: type, variantId: variantId, component: component })=>{
    $004b8b53321b75a6$export$5b736590a80984cb.register({
        type: type,
        variantId: variantId,
        component: component
    });
};
var $004b8b53321b75a6$export$e9e5a4e1ee6e0dca = $004b8b53321b75a6$export$ac19878f39242c72({
    store: $004b8b53321b75a6$export$5b736590a80984cb
});
function $004b8b53321b75a6$var$useClientVisibilityRules() {
    const quirks = (0, $dNSrU.useQuirks)({
        throwOnMissingProvider: false
    });
    return (0, $1oC0p.useMemo)(()=>{
        return {
            ...(0, $f2QWG.createQuirksVisibilityRule)(quirks)
        };
    }, [
        quirks
    ]);
}
// src/hooks/useClientConditionsComposition.ts
function $004b8b53321b75a6$var$useClientConditionsComposition(data) {
    const rules = $004b8b53321b75a6$var$useClientVisibilityRules();
    const preprocessedValue = (0, $1oC0p.useMemo)(()=>{
        if (!data) return data;
        try {
            return (0, $eSosQ.produce)(data, (draft)=>{
                (0, $f2QWG.walkNodeTree)(draft, (context)=>{
                    if (!(0, $f2QWG.evaluateWalkTreeNodeVisibility)({
                        context: context,
                        rules: rules,
                        showIndeterminate: false
                    })) return;
                    (0, $f2QWG.evaluateWalkTreePropertyCriteria)({
                        node: context.node,
                        rules: rules,
                        keepIndeterminate: false
                    });
                });
            });
        } catch (e) {
            console.error("Error evaluating visibility rules:", e.stack);
            return data;
        }
    }, [
        data,
        rules
    ]);
    return preprocessedValue;
}
var $004b8b53321b75a6$var$registeredCompositionIds = /* @__PURE__ */ new Set();
var $004b8b53321b75a6$export$26d2f187c88f68ad = ({ initialCompositionValue: initialCompositionValue, enhance: enhance = (message)=>message.composition })=>{
    const [contextualComposition, setContextualComposition] = (0, $1oC0p.useState)();
    const latestEventTimeStamp = (0, $1oC0p.useRef)();
    const channel = (0, $1oC0p.useMemo)(()=>{
        var _a;
        if (!$004b8b53321b75a6$var$isInContextEditingMode()) return;
        const channel2 = (0, $f2QWG.createCanvasChannel)({
            broadcastTo: [
                (_a = window.opener) != null ? _a : window.top
            ],
            listenTo: [
                window
            ]
        });
        return channel2;
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if ((contextualComposition == null ? void 0 : contextualComposition._id) && (initialCompositionValue == null ? void 0 : initialCompositionValue._id) !== (0, $f2QWG.EMPTY_COMPOSITION)._id && (initialCompositionValue == null ? void 0 : initialCompositionValue._id) !== (contextualComposition == null ? void 0 : contextualComposition._id)) {
            setContextualComposition(void 0);
            return;
        }
        if (!channel || $004b8b53321b75a6$var$registeredCompositionIds.has(initialCompositionValue == null ? void 0 : initialCompositionValue._id)) return;
        const unsubscribeFromCompositionUpdates = channel.on("update-composition-internal", async (message)=>{
            if (!(0, $f2QWG.isUpdateCompositionInternalMessage)(message)) return;
            if (latestEventTimeStamp.current && message.eventTimestamp && message.eventTimestamp <= latestEventTimeStamp.current) return;
            const enhancedComposition = await enhance(message);
            setContextualComposition(enhancedComposition);
            latestEventTimeStamp.current = message.eventTimestamp;
        });
        $004b8b53321b75a6$var$registeredCompositionIds.add(initialCompositionValue == null ? void 0 : initialCompositionValue._id);
        return ()=>{
            unsubscribeFromCompositionUpdates();
            $004b8b53321b75a6$var$registeredCompositionIds.delete(initialCompositionValue == null ? void 0 : initialCompositionValue._id);
        };
    }, [
        channel,
        enhance,
        initialCompositionValue == null ? void 0 : initialCompositionValue._id,
        contextualComposition == null ? void 0 : contextualComposition._id
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!$004b8b53321b75a6$var$isInContextEditingMode()) return;
        const existingScript = document.getElementById((0, $f2QWG.IN_CONTEXT_EDITOR_EMBED_SCRIPT_ID));
        if (existingScript) return;
        window.__UNIFORM_CONTEXTUAL_EDITING__ = {
            framework: "React",
            // Make sure to also update the value in canvas-vue
            version: 2,
            canvasPackageVersion: (0, $f2QWG.version)
        };
        const script = document.createElement("script");
        script.id = (0, $f2QWG.IN_CONTEXT_EDITOR_EMBED_SCRIPT_ID);
        script.src = $004b8b53321b75a6$var$getCanvasInContextEmbedScriptUrl();
        script.async = true;
        document.head.appendChild(script);
    }, [
        initialCompositionValue == null ? void 0 : initialCompositionValue._id
    ]);
    return {
        composition: contextualComposition ? contextualComposition : initialCompositionValue,
        isContextualEditing: Boolean(contextualComposition)
    };
};
function $004b8b53321b75a6$var$getCanvasInContextEmbedScriptUrl() {
    const scriptUrl = `${window.document.referrer}files/canvas-in-context-embed/index.js`;
    return scriptUrl;
}
function $004b8b53321b75a6$var$isInContextEditingMode() {
    if (typeof window === "undefined") return false;
    const isOpenedByInContextEditor = new URLSearchParams(window.location.search).has((0, $f2QWG.IN_CONTEXT_EDITOR_QUERY_STRING_PARAM));
    return isOpenedByInContextEditor && (0, $f2QWG.isAllowedReferrer)(window.document.referrer);
}
var $004b8b53321b75a6$var$PureContextualEditingComponentWrapper = ({ children: children, isPlaceholder: isPlaceholder, parentComponent: parentComponent, component: component, slotName: slotName, indexInSlot: indexInSlot, slotChildrenCount: slotChildrenCount, isReadOnly: isReadOnly })=>{
    var _a, _b, _c, _d;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("script", {
        "data-role": (0, $f2QWG.IN_CONTEXT_EDITOR_COMPONENT_START_ROLE),
        "data-parent-id": parentComponent == null ? void 0 : parentComponent._id,
        "data-parent-type": parentComponent == null ? void 0 : parentComponent.type,
        "data-component-id": component == null ? void 0 : component._id,
        "data-slot-name": slotName != null ? slotName : "",
        "data-component-index": indexInSlot != null ? indexInSlot : "",
        "data-total-components": slotChildrenCount != null ? slotChildrenCount : "",
        "data-component-name": component == null ? void 0 : component.type,
        "data-is-placeholder": isPlaceholder ? "true" : void 0,
        "data-is-localized": ((_a = component == null ? void 0 : component.parameters) == null ? void 0 : _a[0, $f2QWG.CANVAS_LOCALE_TAG_PARAM]) ? "true" : void 0,
        "data-component-title": (_d = (_c = (_b = component == null ? void 0 : component.parameters) == null ? void 0 : _b.title) == null ? void 0 : _c.value) != null ? _d : "",
        "data-is-readonly": isReadOnly
    }), children, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("script", {
        "data-role": (0, $f2QWG.IN_CONTEXT_EDITOR_COMPONENT_END_ROLE)
    }));
};
// src/components/ContextualEditingComponentWrapper.tsx
function $004b8b53321b75a6$var$ContextualEditingComponentWrapper({ component: component, parentComponent: parentComponent, slotName: slotName, indexInSlot: indexInSlot, slotChildrenCount: slotChildrenCount, emptyPlaceholder: emptyPlaceholder, children: children }) {
    var _a;
    const isPlaceholder = (0, $f2QWG.isComponentPlaceholderId)(component == null ? void 0 : component._id);
    const { isContextualEditing: isContextualEditing } = $004b8b53321b75a6$export$6d4c4b62941f5043();
    const isReadOnly = ((_a = component == null ? void 0 : component._contextualEditing) == null ? void 0 : _a.isEditable) ? void 0 : "true";
    if (!isContextualEditing) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    if (isPlaceholder && emptyPlaceholder === null) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$var$PureContextualEditingComponentWrapper, {
        isPlaceholder: isPlaceholder,
        parentComponent: parentComponent,
        component: component,
        slotName: slotName,
        indexInSlot: indexInSlot,
        slotChildrenCount: slotChildrenCount,
        isReadOnly: isReadOnly
    }, isPlaceholder && emptyPlaceholder !== void 0 ? emptyPlaceholder : children);
}
// src/components/UniformComposition.tsx
var $004b8b53321b75a6$export$56f83fd199142a7b = (0, $1oC0p.createContext)({
    data: void 0,
    isContextualEditing: false
});
function $004b8b53321b75a6$export$6d4c4b62941f5043() {
    return (0, $1oC0p.useContext)($004b8b53321b75a6$export$56f83fd199142a7b);
}
function $004b8b53321b75a6$export$427b0dbdb756b3fe({ data: data, behaviorTracking: behaviorTracking = "onView", children: children, resolveRenderer: resolveRenderer, contextualEditingEnhancer: contextualEditingEnhancer, contextualEditingDefaultPlaceholder: contextualEditingDefaultPlaceholder, matchedRoute: // provide default non-undefined values to avoid serialization issues
matchedRoute = "", dynamicInputs: dynamicInputs = {} }) {
    const maybeContext = (0, $dNSrU.useUniformContext)({
        throwOnMissingProvider: false
    });
    (0, $1oC0p.useEffect)(()=>{
        if ((maybeContext == null ? void 0 : maybeContext.context) && (data == null ? void 0 : data._id)) maybeContext.context.updateCompositionMetadata({
            compositionId: data._id,
            matchedRoute: matchedRoute,
            dynamicInputs: dynamicInputs
        });
    }, [
        data == null ? void 0 : data._id,
        maybeContext == null ? void 0 : maybeContext.context,
        matchedRoute,
        dynamicInputs
    ]);
    const ruledComposition = $004b8b53321b75a6$var$useClientConditionsComposition(data);
    const { composition: composition, isContextualEditing: isContextualEditing } = $004b8b53321b75a6$export$26d2f187c88f68ad({
        initialCompositionValue: ruledComposition,
        enhance: contextualEditingEnhancer
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$56f83fd199142a7b.Provider, {
        value: {
            data: composition,
            behaviorTracking: behaviorTracking,
            resolveRenderer: resolveRenderer,
            isContextualEditing: isContextualEditing,
            matchedRoute: matchedRoute,
            dynamicInputs: dynamicInputs
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$var$ContextualEditingComponentWrapper, {
        component: composition
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$14090f26548cfe46, {
        data: composition,
        behaviorTracking: behaviorTracking,
        resolveRenderer: resolveRenderer,
        contextualEditingDefaultPlaceholder: contextualEditingDefaultPlaceholder
    }, children)));
}
// src/defaultSystemComponentResolver.tsx
var $004b8b53321b75a6$var$defaultSystemComponentResolver = {
    test: function TestComponent(component, key, renderChild) {
        var _a, _b, _c, _d, _e;
        const testComponent = component;
        const variants = (_b = (_a = testComponent.slots) == null ? void 0 : _a.test) != null ? _b : [];
        const testName = (_e = (_d = (_c = testComponent.parameters) == null ? void 0 : _c.test) == null ? void 0 : _d.value) != null ? _e : "Untitled Test";
        const finalVariants = (0, $f2QWG.mapSlotToTestVariations)(variants);
        const { data: data, matchedRoute: matchedRoute, dynamicInputs: dynamicInputs } = $004b8b53321b75a6$export$6d4c4b62941f5043();
        return /* @__PURE__ */ $1oC0p.createElement((0, $dNSrU.Test), {
            key: key,
            variations: finalVariants,
            name: testName,
            component: (variation)=>renderChild(variation, key),
            compositionMetadata: (data == null ? void 0 : data._id) ? {
                compositionId: data._id,
                matchedRoute: matchedRoute,
                dynamicInputs: dynamicInputs
            } : void 0
        });
    },
    personalization: function PersonalizeComponent(component, key, renderChild) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        const pzComponent = component;
        const processedVariants = (0, $f2QWG.mapSlotToPersonalizedVariations)((_a = pzComponent == null ? void 0 : pzComponent.slots) == null ? void 0 : _a.pz);
        const { data: data, matchedRoute: matchedRoute, dynamicInputs: dynamicInputs } = $004b8b53321b75a6$export$6d4c4b62941f5043();
        return /* @__PURE__ */ $1oC0p.createElement((0, $dNSrU.Personalize), {
            key: key,
            variations: processedVariants,
            count: Number((_d = (_c = (_b = pzComponent.parameters) == null ? void 0 : _b[0, $f2QWG.CANVAS_PERSONALIZATION_TAKE_PARAM]) == null ? void 0 : _c.value) != null ? _d : 1),
            name: (_g = (_f = (_e = pzComponent.parameters) == null ? void 0 : _e[0, $f2QWG.CANVAS_PERSONALIZATION_EVENT_NAME_PARAM]) == null ? void 0 : _f.value) != null ? _g : "Untitled Personalization",
            component: (variation)=>renderChild(variation, 0),
            compositionMetadata: (data == null ? void 0 : data._id) ? {
                compositionId: data._id,
                matchedRoute: matchedRoute,
                dynamicInputs: dynamicInputs
            } : void 0,
            algorithm: (_i = (_h = pzComponent.parameters) == null ? void 0 : _h[0, $f2QWG.CANVAS_PERSONALIZATION_ALGORITHM_PARAM]) == null ? void 0 : _i.value,
            compositionId: data == null ? void 0 : data._id,
            matchedRoute: matchedRoute,
            dynamicInputs: dynamicInputs
        });
    }
};
// src/components/UniformSlot.tsx
function $004b8b53321b75a6$export$3ef263bb67afc85b({ name: name, resolveRenderer: resolveRenderer, emptyPlaceholder: emptyPlaceholder, wrapperComponent: wrapperComponent }) {
    var _a;
    const { data: parentData, resolveRenderer: parentResolveRenderer } = $004b8b53321b75a6$export$a869d0b83591d04f();
    if (!parentData) throw new Error("Cannot use Slot without a <UniformComponent /> wrapper.");
    const slot = (_a = parentData.slots) == null ? void 0 : _a[name];
    if (!slot || !Array.isArray(slot)) return null;
    const resolver = resolveRenderer != null ? resolveRenderer : parentResolveRenderer;
    const finalChildren = slot.map((component, index)=>{
        const child = $004b8b53321b75a6$var$renderComponent({
            component: component,
            resolveRenderer: resolver,
            key: `inner-${index}`,
            indexInSlot: index,
            slotName: name,
            parentComponent: parentData,
            slotChildrenCount: slot.length,
            emptyPlaceholder: emptyPlaceholder
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
            key: index
        }, child);
    });
    if (!wrapperComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, void 0, finalChildren);
    const Wrapper = wrapperComponent;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Wrapper, {
        items: finalChildren,
        slotName: name
    });
}
function $004b8b53321b75a6$var$renderComponent({ component: component, resolveRenderer: resolveRenderer, key: key = 0, indexInSlot: indexInSlot, slotName: slotName, parentComponent: parentComponent, slotChildrenCount: slotChildrenCount, emptyPlaceholder: emptyPlaceholder }) {
    const RenderComponent = resolveRenderer == null ? void 0 : resolveRenderer(component);
    if (component.type === (0, $f2QWG.CANVAS_TEST_TYPE)) {
        const testComponent = $004b8b53321b75a6$var$defaultSystemComponentResolver.test(component, key, (variantComponent, key2)=>{
            var _a, _b;
            return $004b8b53321b75a6$var$renderComponent({
                component: variantComponent,
                resolveRenderer: resolveRenderer,
                key: key2,
                parentComponent: component,
                slotName: (0, $f2QWG.CANVAS_TEST_SLOT),
                slotChildrenCount: (_a = component == null ? void 0 : component.slots) == null ? void 0 : _a[0, $f2QWG.CANVAS_TEST_SLOT].length,
                indexInSlot: (_b = component == null ? void 0 : component.slots) == null ? void 0 : _b[0, $f2QWG.CANVAS_TEST_SLOT].findIndex(({ _id: _id })=>variantComponent._id === _id)
            });
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$var$ContextualEditingComponentWrapper, {
            component: component,
            parentComponent: parentComponent,
            slotName: slotName,
            indexInSlot: indexInSlot,
            slotChildrenCount: slotChildrenCount,
            emptyPlaceholder: emptyPlaceholder
        }, testComponent);
    } else if (component.type === (0, $f2QWG.CANVAS_PERSONALIZE_TYPE)) {
        const personalizationComponent = $004b8b53321b75a6$var$defaultSystemComponentResolver.personalization(component, key, (variantComponent, key2)=>{
            var _a, _b;
            return $004b8b53321b75a6$var$renderComponent({
                component: variantComponent,
                resolveRenderer: resolveRenderer,
                key: key2,
                parentComponent: component,
                slotName: (0, $f2QWG.CANVAS_PERSONALIZE_SLOT),
                slotChildrenCount: (_a = component == null ? void 0 : component.slots) == null ? void 0 : _a[0, $f2QWG.CANVAS_PERSONALIZE_SLOT].length,
                indexInSlot: (_b = component == null ? void 0 : component.slots) == null ? void 0 : _b[0, $f2QWG.CANVAS_PERSONALIZE_SLOT].findIndex(({ _id: _id })=>variantComponent._id === _id)
            });
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$var$ContextualEditingComponentWrapper, {
            component: component,
            parentComponent: parentComponent,
            slotName: slotName,
            indexInSlot: indexInSlot,
            slotChildrenCount: slotChildrenCount,
            emptyPlaceholder: emptyPlaceholder
        }, personalizationComponent);
    } else if (RenderComponent) {
        const props = $004b8b53321b75a6$export$840ce7a9a49cf2fd(component);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$14090f26548cfe46, {
            key: key,
            data: component,
            resolveRenderer: resolveRenderer
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$var$ContextualEditingComponentWrapper, {
            component: component,
            parentComponent: parentComponent,
            slotName: slotName,
            indexInSlot: indexInSlot,
            slotChildrenCount: slotChildrenCount,
            emptyPlaceholder: emptyPlaceholder
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(RenderComponent, {
            ...props
        })));
    }
    return null;
}
// src/components/UniformComponent.tsx
var $004b8b53321b75a6$var$UniformComponentContext = (0, $1oC0p.createContext)({});
function $004b8b53321b75a6$export$a869d0b83591d04f() {
    return (0, $1oC0p.useContext)($004b8b53321b75a6$var$UniformComponentContext);
}
function $004b8b53321b75a6$export$14090f26548cfe46({ data: data, resolveRenderer: resolveRenderer, children: children, behaviorTracking: behaviorTracking, contextualEditingDefaultPlaceholder: contextualEditingDefaultPlaceholder }) {
    var _a, _b, _c;
    const parentData = $004b8b53321b75a6$export$a869d0b83591d04f();
    const contextContextProviderPresent = (0, $dNSrU.useUniformContext)({
        throwOnMissingProvider: false
    }) !== void 0;
    if (!data) return null;
    const contextValue = {
        data: data,
        resolveRenderer: resolveRenderer || parentData.resolveRenderer || $004b8b53321b75a6$export$e9e5a4e1ee6e0dca,
        behaviorTracking: (_a = behaviorTracking != null ? behaviorTracking : parentData == null ? void 0 : parentData.behaviorTracking) != null ? _a : "onView",
        contextualEditingDefaultPlaceholder: contextualEditingDefaultPlaceholder != null ? contextualEditingDefaultPlaceholder : parentData.contextualEditingDefaultPlaceholder
    };
    const enrichmentTags = (_c = (_b = data.parameters) == null ? void 0 : _b[0, $f2QWG.CANVAS_ENRICHMENT_TAG_PARAM]) == null ? void 0 : _c.value;
    const TrackComponent = contextValue.behaviorTracking === "onLoad" ? (0, $dNSrU.TrackFragment) : (0, $dNSrU.Track);
    const resolvedChildren = $004b8b53321b75a6$var$resolveChildren({
        children: children,
        data: data,
        hasParentLayout: Boolean(parentData.data),
        resolveRenderer: contextValue.resolveRenderer
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$var$UniformComponentContext.Provider, {
        value: contextValue
    }, contextContextProviderPresent ? /* auto-track behavior signals when in a Canvas context */ /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(TrackComponent, {
        behavior: enrichmentTags
    }, resolvedChildren) : resolvedChildren);
}
function $004b8b53321b75a6$var$resolveChildren({ children: children, data: data, hasParentLayout: hasParentLayout, resolveRenderer: resolveRenderer }) {
    var _a;
    if (!children && !hasParentLayout) {
        const topLevelComponent = resolveRenderer({
            type: data.type
        });
        if (topLevelComponent) children = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(topLevelComponent, $004b8b53321b75a6$export$840ce7a9a49cf2fd(data));
        else {
            Object.keys((_a = data.slots) != null ? _a : {}).length;
            children = Object.keys(data.slots || {}).map((slotName)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$3ef263bb67afc85b, {
                    key: slotName,
                    name: slotName
                }));
        }
    }
    const renderChildren = typeof children === "function" ? children($004b8b53321b75a6$export$840ce7a9a49cf2fd(data)) : children;
    return renderChildren;
}
var $004b8b53321b75a6$export$5bf20c552edca720 = ({ resolveRenderer: resolveRenderer, decorators: decorators = [], contextualEditingEnhancer: contextualEditingEnhancer, behaviorTracking: behaviorTracking, contextualEditingDefaultPlaceholder: contextualEditingDefaultPlaceholder })=>{
    const { composition: composition, isContextualEditing: isContextualEditing } = $004b8b53321b75a6$export$26d2f187c88f68ad({
        initialCompositionValue: (0, $f2QWG.EMPTY_COMPOSITION),
        enhance: contextualEditingEnhancer
    });
    const renderedComponent = (0, $1oC0p.useMemo)(()=>{
        if (!composition) return null;
        let component = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$var$ContextualEditingComponentWrapper, {
            component: composition
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$14090f26548cfe46, {
            data: composition,
            behaviorTracking: behaviorTracking,
            resolveRenderer: resolveRenderer,
            contextualEditingDefaultPlaceholder: contextualEditingDefaultPlaceholder
        }));
        decorators.forEach((Decorator)=>{
            component = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Decorator, {
                data: composition
            }, component);
        });
        return component;
    }, [
        resolveRenderer,
        decorators,
        composition,
        behaviorTracking,
        contextualEditingDefaultPlaceholder
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$56f83fd199142a7b.Provider, {
        value: {
            data: composition,
            behaviorTracking: behaviorTracking,
            resolveRenderer: resolveRenderer,
            isContextualEditing: isContextualEditing
        }
    }, renderedComponent);
};
var $004b8b53321b75a6$var$AssetRichTextNode = ({ node: node })=>{
    var _a, _b;
    const { __asset: __asset } = node;
    if (__asset === void 0) return null;
    if (__asset.type === "image") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("figure", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("img", {
        src: __asset.fields.url.value,
        alt: (_a = __asset.fields.title) == null ? void 0 : _a.value
    }), ((_b = __asset.fields.description) == null ? void 0 : _b.value) ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("figcaption", null, __asset.fields.description.value) : null);
    if (__asset.type === "video") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("video", {
        src: __asset.fields.url.value,
        controls: true
    });
    if (__asset.type === "audio") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("audio", {
        src: __asset.fields.url.value,
        controls: true
    });
    return null;
};
var $004b8b53321b75a6$var$HeadingRichTextNode = ({ children: children, node: node })=>{
    const { tag: tag } = node;
    const HTag = tag != null ? tag : "h1";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(HTag, null, children);
};
var $004b8b53321b75a6$var$LinebreakRichTextNode = ()=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("br", null);
};
var $004b8b53321b75a6$var$LinkRichTextNode = ({ children: children, node: node })=>{
    const { link: link } = node;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("a", {
        href: (0, $dZNgt.linkParamValueToHref)(link)
    }, children);
};
var $004b8b53321b75a6$var$ListItemRichTextNode = ({ children: children, node: node })=>{
    const { value: value } = node;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("li", {
        value: Number.isFinite(value) && value > 0 ? value : void 0
    }, children);
};
var $004b8b53321b75a6$var$ListRichTextNode = ({ children: children, node: node })=>{
    const { tag: tag, start: start } = node;
    const ListTag = tag != null ? tag : "ul";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ListTag, {
        start: Number.isFinite(start) && start > 0 ? start : void 0
    }, children);
};
var $004b8b53321b75a6$var$ParagraphRichTextNode = ({ children: children, node: node })=>{
    const { format: format, direction: direction } = node;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", {
        dir: (0, $dZNgt.isPureDirection)(direction) ? direction : void 0,
        style: (0, $dZNgt.isPureTextAlign)(format) ? {
            textAlign: format
        } : void 0
    }, children);
};
var $004b8b53321b75a6$var$TableCellRichTextNode = ({ children: children, node: node })=>{
    const { headerState: headerState } = node;
    const TableCellTag = (0, $dZNgt.getRichTextTagFromTableCellHeaderState)(headerState);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(TableCellTag, null, children);
};
var $004b8b53321b75a6$var$TabRichTextNode = ()=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, "	");
};
var $004b8b53321b75a6$var$TextRichTextNode = ({ node: node })=>{
    const { text: text, format: format } = node;
    const tags = (0, $dZNgt.getRichTextTagsFromTextFormat)(format);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, tags.length > 0 ? tags.reduceRight((children, Tag)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Tag, null, children), text) : text);
};
// src/components/UniformRichText/UniformRichTextNode.tsx
function $004b8b53321b75a6$export$fba07398d032ca85({ node: node, ...props }) {
    var _a;
    if (!(0, $dZNgt.isRichTextNode)(node)) return null;
    let NodeRenderer = (_a = props.resolveRichTextRenderer) == null ? void 0 : _a.call(props, node);
    if (typeof NodeRenderer === "undefined") NodeRenderer = $004b8b53321b75a6$var$resolveRichTextDefaultRenderer(node);
    if (!NodeRenderer) return null;
    const children = node.children ? node.children.map((childNode, i)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$fba07398d032ca85, {
            ...props,
            key: i,
            node: childNode
        })) : null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(NodeRenderer, {
        node: node
    }, children);
}
var $004b8b53321b75a6$var$rendererMap = /* @__PURE__ */ new Map([
    [
        "heading",
        $004b8b53321b75a6$var$HeadingRichTextNode
    ],
    [
        "linebreak",
        $004b8b53321b75a6$var$LinebreakRichTextNode
    ],
    [
        "link",
        $004b8b53321b75a6$var$LinkRichTextNode
    ],
    [
        "list",
        $004b8b53321b75a6$var$ListRichTextNode
    ],
    [
        "listitem",
        $004b8b53321b75a6$var$ListItemRichTextNode
    ],
    [
        "paragraph",
        $004b8b53321b75a6$var$ParagraphRichTextNode
    ],
    [
        "quote",
        ({ children: children })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("blockquote", null, children)
    ],
    [
        "code",
        ({ children: children })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("pre", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("code", null, children))
    ],
    [
        "root",
        ({ children: children })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children)
    ],
    [
        "text",
        $004b8b53321b75a6$var$TextRichTextNode
    ],
    [
        "tab",
        $004b8b53321b75a6$var$TabRichTextNode
    ],
    [
        "table",
        ({ children: children })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("table", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("tbody", null, children))
    ],
    [
        "tablerow",
        ({ children: children })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("tr", null, children)
    ],
    [
        "tablecell",
        $004b8b53321b75a6$var$TableCellRichTextNode
    ],
    [
        "asset",
        $004b8b53321b75a6$var$AssetRichTextNode
    ]
]);
var $004b8b53321b75a6$var$resolveRichTextDefaultRenderer = (node)=>{
    return $004b8b53321b75a6$var$rendererMap.get(node.type);
};
// src/components/UniformRichText/UniformRichText.tsx
var $004b8b53321b75a6$export$914217645a759423 = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function UniformRichText2({ parameterId: parameterId, resolveRichTextRenderer: resolveRichTextRenderer, as: Tag = "div", placeholder: placeholder, ...props }, ref) {
    var _a;
    const { data: componentData, contextualEditingDefaultPlaceholder: contextualEditingDefaultPlaceholder } = $004b8b53321b75a6$export$a869d0b83591d04f();
    const { isContextualEditing: isContextualEditing } = $004b8b53321b75a6$export$6d4c4b62941f5043();
    const parameter = (_a = componentData == null ? void 0 : componentData.parameters) == null ? void 0 : _a[parameterId];
    if (!parameter) return null;
    const placeholderProp = placeholder != null ? placeholder : contextualEditingDefaultPlaceholder;
    const computedPlaceholder = typeof placeholderProp === "function" ? placeholderProp({
        id: parameterId
    }) : placeholderProp;
    const value = parameter.value;
    if (!value || !(0, $dZNgt.isRichTextValue)(value)) return null;
    if (!isContextualEditing && (0, $dZNgt.isRichTextValueConsideredEmpty)(value)) return null;
    if (!Tag) return isContextualEditing && (0, $dZNgt.isRichTextValueConsideredEmpty)(value) ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", {
        [(0, $f2QWG.ATTRIBUTE_COMPONENT_ID)]: componentData == null ? void 0 : componentData._id,
        [(0, $f2QWG.ATTRIBUTE_PARAMETER_ID)]: parameterId,
        [(0, $f2QWG.ATTRIBUTE_PARAMETER_TYPE)]: "richText"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("i", null, computedPlaceholder)) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$fba07398d032ca85, {
        node: value.root,
        resolveRichTextRenderer: resolveRichTextRenderer
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Tag, {
        ref: ref,
        ...props,
        ...isContextualEditing ? {
            [(0, $f2QWG.ATTRIBUTE_COMPONENT_ID)]: componentData == null ? void 0 : componentData._id,
            [(0, $f2QWG.ATTRIBUTE_PARAMETER_ID)]: parameterId,
            [(0, $f2QWG.ATTRIBUTE_PARAMETER_TYPE)]: "richText"
        } : {}
    }, (0, $dZNgt.isRichTextValueConsideredEmpty)(value) ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("i", null, computedPlaceholder)) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$export$fba07398d032ca85, {
        node: value.root,
        resolveRichTextRenderer: resolveRichTextRenderer
    }));
});
var $004b8b53321b75a6$var$PureUniformText = ({ as: Tag = "span", parameterId: parameterId, component: component, skipCustomRendering: skipCustomRendering, isContextualEditing: isContextualEditing, isMultiline: isMultiline = false, placeholder: placeholder, render: render = (value)=>value, ...props })=>{
    var _a;
    const parameter = (_a = component == null ? void 0 : component.parameters) == null ? void 0 : _a[parameterId];
    const value = parameter == null ? void 0 : parameter.value;
    if (!parameter) return null;
    if (!isContextualEditing) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Tag, {
        style: isMultiline ? {
            whiteSpace: "pre-wrap"
        } : {},
        ...props
    }, render(value));
    const computedPlaceholder = typeof placeholder === "function" ? placeholder({
        id: parameterId
    }) : placeholder;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Tag, {
        ...props,
        ...$004b8b53321b75a6$export$5e8e0a3470b8184({
            component: component,
            id: parameterId,
            isMultiline: isMultiline
        }),
        "data-uniform-parameter-type": "text",
        "data-uniform-placeholder": computedPlaceholder,
        style: isMultiline ? {
            whiteSpace: "pre-wrap"
        } : {}
    }, skipCustomRendering ? value : render(value));
};
// src/components/UniformText.tsx
var $004b8b53321b75a6$export$bd5da47596094494 = ({ as: tag = "span", parameterId: parameterId, isMultiline: isMultiline = false, placeholder: placeholder, render: render = (value)=>value, ...props })=>{
    var _a, _b, _c;
    const { data: componentData, contextualEditingDefaultPlaceholder: contextualEditingDefaultPlaceholder } = $004b8b53321b75a6$export$a869d0b83591d04f();
    const { isContextualEditing: isContextualEditing } = $004b8b53321b75a6$export$6d4c4b62941f5043();
    const [isFocused, setIsFocused] = (0, $1oC0p.useState)(false);
    const parameter = (_a = componentData == null ? void 0 : componentData.parameters) == null ? void 0 : _a[parameterId];
    const isEditable = (_c = (_b = parameter == null ? void 0 : parameter._contextualEditing) == null ? void 0 : _b.isEditable) != null ? _c : false;
    const shouldSkipCustomRendering = isFocused && isEditable;
    if (!parameter) return null;
    const placeholderProp = placeholder != null ? placeholder : contextualEditingDefaultPlaceholder;
    const computedPlaceholder = typeof placeholderProp === "function" ? placeholderProp({
        id: parameterId
    }) : placeholderProp;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($004b8b53321b75a6$var$PureUniformText, {
        ...props,
        as: tag,
        parameterId: parameterId,
        component: componentData,
        skipCustomRendering: shouldSkipCustomRendering,
        isContextualEditing: isContextualEditing,
        placeholder: computedPlaceholder,
        render: render,
        isMultiline: isMultiline,
        onFocus: ()=>{
            setIsFocused(true);
        },
        onBlur: ()=>{
            setIsFocused(false);
        }
    });
};
var $004b8b53321b75a6$export$5e8e0a3470b8184 = (options)=>{
    return {
        ...(0, $f2QWG.getParameterAttributes)(options),
        suppressContentEditableWarning: true
    };
};
var $004b8b53321b75a6$export$487be5a9616f3784 = ({ global: global = false } = {})=>{
    const { isContextualEditing: isContextualEditing } = $004b8b53321b75a6$export$6d4c4b62941f5043();
    const { data: componentData } = $004b8b53321b75a6$export$a869d0b83591d04f();
    const [selectedComponentReference, setSelectedComponentReference] = (0, $1oC0p.useState)();
    const [previewMode, setPreviewMode] = (0, $1oC0p.useState)(isContextualEditing ? "editor" : void 0);
    const channel = (0, $1oC0p.useMemo)(()=>{
        if (!isContextualEditing) return;
        const channel2 = (0, $f2QWG.createCanvasChannel)({
            broadcastTo: [
                window
            ],
            listenTo: [
                window
            ]
        });
        return channel2;
    }, [
        isContextualEditing
    ]);
    (0, $1oC0p.useEffect)(()=>{
        var _a, _b;
        if (!channel) return;
        if (typeof window !== "undefined") setPreviewMode((_b = (_a = window.__UNIFORM_CONTEXTUAL_EDITING__) == null ? void 0 : _a.state) == null ? void 0 : _b.previewMode);
        const unsubscribe = channel.on("update-contextual-editing-state-internal", async (message)=>{
            var _a2;
            if (!(0, $f2QWG.isUpdateContextualEditingStateInternalMessage)(message)) return;
            setPreviewMode(message.state.previewMode);
            if (!global && (componentData == null ? void 0 : componentData._id) !== ((_a2 = message.state.selectedComponentReference) == null ? void 0 : _a2.parentId)) {
                setSelectedComponentReference(void 0);
                return;
            }
            setSelectedComponentReference(message.state.selectedComponentReference);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        global,
        channel,
        componentData == null ? void 0 : componentData._id,
        setSelectedComponentReference,
        setPreviewMode
    ]);
    return (0, $1oC0p.useMemo)(()=>({
            isContextualEditing: isContextualEditing,
            selectedComponentReference: selectedComponentReference,
            previewMode: previewMode
        }), [
        isContextualEditing,
        selectedComponentReference,
        previewMode
    ]);
};

});
parcelRegister("f2QWG", function(module, exports) {
$parcel$export(module.exports, "CANVAS_PERSONALIZE_TYPE", function () { return $af401cd1bc7a3c41$export$a439de129e0de5a6; });
$parcel$export(module.exports, "CANVAS_TEST_TYPE", function () { return $af401cd1bc7a3c41$export$e115756c5e622701; });
$parcel$export(module.exports, "CANVAS_LOCALIZATION_TYPE", function () { return $af401cd1bc7a3c41$export$9656110639e729a7; });
$parcel$export(module.exports, "CANVAS_LOCALE_TAG_PARAM", function () { return $af401cd1bc7a3c41$export$58a1b975993a5f83; });
$parcel$export(module.exports, "CANVAS_PERSONALIZE_SLOT", function () { return $af401cd1bc7a3c41$export$b6d6f48a1ccec5c4; });
$parcel$export(module.exports, "CANVAS_TEST_SLOT", function () { return $af401cd1bc7a3c41$export$3116fbcb69b49769; });
$parcel$export(module.exports, "CANVAS_PERSONALIZATION_EVENT_NAME_PARAM", function () { return $af401cd1bc7a3c41$export$360a83009579aa85; });
$parcel$export(module.exports, "CANVAS_PERSONALIZATION_ALGORITHM_PARAM", function () { return $af401cd1bc7a3c41$export$420ac9f66f7157b; });
$parcel$export(module.exports, "CANVAS_PERSONALIZATION_TAKE_PARAM", function () { return $af401cd1bc7a3c41$export$d5535f327661f75f; });
$parcel$export(module.exports, "CANVAS_ENRICHMENT_TAG_PARAM", function () { return $af401cd1bc7a3c41$export$d674a70432da69ae; });
$parcel$export(module.exports, "IN_CONTEXT_EDITOR_QUERY_STRING_PARAM", function () { return $af401cd1bc7a3c41$export$69fd613f16ae867f; });
$parcel$export(module.exports, "IN_CONTEXT_EDITOR_COMPONENT_START_ROLE", function () { return $af401cd1bc7a3c41$export$b7c82480d5e73c22; });
$parcel$export(module.exports, "IN_CONTEXT_EDITOR_COMPONENT_END_ROLE", function () { return $af401cd1bc7a3c41$export$e0c2a63b4a806361; });
$parcel$export(module.exports, "IN_CONTEXT_EDITOR_EMBED_SCRIPT_ID", function () { return $af401cd1bc7a3c41$export$6551318158a36a54; });
$parcel$export(module.exports, "EMPTY_COMPOSITION", function () { return $af401cd1bc7a3c41$export$1767d608c3fa1c06; });
$parcel$export(module.exports, "flattenValues", function () { return $af401cd1bc7a3c41$export$ee1ead7e9266f0cd; });
$parcel$export(module.exports, "walkNodeTree", function () { return $af401cd1bc7a3c41$export$edadceaf63f106a9; });
$parcel$export(module.exports, "enhance", function () { return $af401cd1bc7a3c41$export$7ff6d543f13c7390; });
$parcel$export(module.exports, "EnhancerBuilder", function () { return $af401cd1bc7a3c41$export$367a729fad01195b; });
$parcel$export(module.exports, "evaluateWalkTreeNodeVisibility", function () { return $af401cd1bc7a3c41$export$28d93765f76623c; });
$parcel$export(module.exports, "evaluateWalkTreePropertyCriteria", function () { return $af401cd1bc7a3c41$export$bc8380d589ae0dbd; });
$parcel$export(module.exports, "createQuirksVisibilityRule", function () { return $af401cd1bc7a3c41$export$92a9faf2ed02d83b; });
$parcel$export(module.exports, "isUpdateCompositionInternalMessage", function () { return $af401cd1bc7a3c41$export$9f35164c015f8c5b; });
$parcel$export(module.exports, "isUpdateContextualEditingStateInternalMessage", function () { return $af401cd1bc7a3c41$export$f3b512beb9ef7726; });
$parcel$export(module.exports, "createCanvasChannel", function () { return $af401cd1bc7a3c41$export$19ed7e48ee6f59a7; });
$parcel$export(module.exports, "ATTRIBUTE_COMPONENT_ID", function () { return $af401cd1bc7a3c41$export$f1c7f022b26798f3; });
$parcel$export(module.exports, "ATTRIBUTE_PARAMETER_ID", function () { return $af401cd1bc7a3c41$export$351f6badae6cd6b0; });
$parcel$export(module.exports, "ATTRIBUTE_PARAMETER_TYPE", function () { return $af401cd1bc7a3c41$export$27ded32ac921fd43; });
$parcel$export(module.exports, "getParameterAttributes", function () { return $af401cd1bc7a3c41$export$5e8e0a3470b8184; });
$parcel$export(module.exports, "isAllowedReferrer", function () { return $af401cd1bc7a3c41$export$612a58267bbb22e8; });
$parcel$export(module.exports, "mapSlotToPersonalizedVariations", function () { return $af401cd1bc7a3c41$export$3f95bb24f65542b9; });
$parcel$export(module.exports, "mapSlotToTestVariations", function () { return $af401cd1bc7a3c41$export$2b50c06aa2371be6; });
$parcel$export(module.exports, "isComponentPlaceholderId", function () { return $af401cd1bc7a3c41$export$459c05917fa64e5c; });
$parcel$export(module.exports, "version", function () { return $af401cd1bc7a3c41$export$83d89fbfd8236492; });

var $hAokw = parcelRequire("hAokw");

var $gcM5m = parcelRequire("gcM5m");
var $af401cd1bc7a3c41$var$__create = Object.create;
var $af401cd1bc7a3c41$var$__defProp = Object.defineProperty;
var $af401cd1bc7a3c41$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $af401cd1bc7a3c41$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $af401cd1bc7a3c41$var$__getProtoOf = Object.getPrototypeOf;
var $af401cd1bc7a3c41$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $af401cd1bc7a3c41$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $af401cd1bc7a3c41$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$af401cd1bc7a3c41$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $af401cd1bc7a3c41$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $af401cd1bc7a3c41$var$__getOwnPropNames(from))if (!$af401cd1bc7a3c41$var$__hasOwnProp.call(to, key) && key !== except) $af401cd1bc7a3c41$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $af401cd1bc7a3c41$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $af401cd1bc7a3c41$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $af401cd1bc7a3c41$var$__create($af401cd1bc7a3c41$var$__getProtoOf(mod)) : {}, $af401cd1bc7a3c41$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $af401cd1bc7a3c41$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $af401cd1bc7a3c41$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $af401cd1bc7a3c41$var$__typeError("Cannot " + msg);
var $af401cd1bc7a3c41$var$__privateGet = (obj, member, getter)=>($af401cd1bc7a3c41$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $af401cd1bc7a3c41$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $af401cd1bc7a3c41$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// ../../node_modules/.pnpm/yocto-queue@0.1.0/node_modules/yocto-queue/index.js
var $af401cd1bc7a3c41$var$require_yocto_queue = $af401cd1bc7a3c41$var$__commonJS({
    "../../node_modules/.pnpm/yocto-queue@0.1.0/node_modules/yocto-queue/index.js" (exports, module) {
        "use strict";
        var Node = class {
            /// value;
            /// next;
            constructor(value){
                this.value = value;
                this.next = void 0;
            }
        };
        var Queue = class {
            // TODO: Use private class fields when targeting Node.js 12.
            // #_head;
            // #_tail;
            // #_size;
            constructor(){
                this.clear();
            }
            enqueue(value) {
                const node = new Node(value);
                if (this._head) {
                    this._tail.next = node;
                    this._tail = node;
                } else {
                    this._head = node;
                    this._tail = node;
                }
                this._size++;
            }
            dequeue() {
                const current = this._head;
                if (!current) return;
                this._head = this._head.next;
                this._size--;
                return current.value;
            }
            clear() {
                this._head = void 0;
                this._tail = void 0;
                this._size = 0;
            }
            get size() {
                return this._size;
            }
            *[Symbol.iterator]() {
                let current = this._head;
                while(current){
                    yield current.value;
                    current = current.next;
                }
            }
        };
        module.exports = Queue;
    }
});
// ../../node_modules/.pnpm/p-limit@3.1.0/node_modules/p-limit/index.js
var $af401cd1bc7a3c41$var$require_p_limit = $af401cd1bc7a3c41$var$__commonJS({
    "../../node_modules/.pnpm/p-limit@3.1.0/node_modules/p-limit/index.js" (exports, module) {
        "use strict";
        var Queue = $af401cd1bc7a3c41$var$require_yocto_queue();
        var pLimit2 = (concurrency)=>{
            if (!((Number.isInteger(concurrency) || concurrency === Infinity) && concurrency > 0)) throw new TypeError("Expected `concurrency` to be a number from 1 and up");
            const queue = new Queue();
            let activeCount = 0;
            const next = ()=>{
                activeCount--;
                if (queue.size > 0) queue.dequeue()();
            };
            const run = async (fn, resolve, ...args)=>{
                activeCount++;
                const result = (async ()=>fn(...args))();
                resolve(result);
                try {
                    await result;
                } catch (e) {}
                next();
            };
            const enqueue = (fn, resolve, ...args)=>{
                queue.enqueue(run.bind(null, fn, resolve, ...args));
                (async ()=>{
                    await Promise.resolve();
                    if (activeCount < concurrency && queue.size > 0) queue.dequeue()();
                })();
            };
            const generator = (fn, ...args)=>new Promise((resolve)=>{
                    enqueue(fn, resolve, ...args);
                });
            Object.defineProperties(generator, {
                activeCount: {
                    get: ()=>activeCount
                },
                pendingCount: {
                    get: ()=>queue.size
                },
                clearQueue: {
                    value: ()=>{
                        queue.clear();
                    }
                }
            });
            return generator;
        };
        module.exports = pLimit2;
    }
});
// ../../node_modules/.pnpm/retry@0.13.1/node_modules/retry/lib/retry_operation.js
var $af401cd1bc7a3c41$var$require_retry_operation = $af401cd1bc7a3c41$var$__commonJS({
    "../../node_modules/.pnpm/retry@0.13.1/node_modules/retry/lib/retry_operation.js" (exports, module) {
        "use strict";
        function RetryOperation(timeouts, options) {
            if (typeof options === "boolean") options = {
                forever: options
            };
            this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
            this._timeouts = timeouts;
            this._options = options || {};
            this._maxRetryTime = options && options.maxRetryTime || Infinity;
            this._fn = null;
            this._errors = [];
            this._attempts = 1;
            this._operationTimeout = null;
            this._operationTimeoutCb = null;
            this._timeout = null;
            this._operationStart = null;
            this._timer = null;
            if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
        }
        module.exports = RetryOperation;
        RetryOperation.prototype.reset = function() {
            this._attempts = 1;
            this._timeouts = this._originalTimeouts.slice(0);
        };
        RetryOperation.prototype.stop = function() {
            if (this._timeout) clearTimeout(this._timeout);
            if (this._timer) clearTimeout(this._timer);
            this._timeouts = [];
            this._cachedTimeouts = null;
        };
        RetryOperation.prototype.retry = function(err) {
            if (this._timeout) clearTimeout(this._timeout);
            if (!err) return false;
            var currentTime = /* @__PURE__ */ new Date().getTime();
            if (err && currentTime - this._operationStart >= this._maxRetryTime) {
                this._errors.push(err);
                this._errors.unshift(new Error("RetryOperation timeout occurred"));
                return false;
            }
            this._errors.push(err);
            var timeout = this._timeouts.shift();
            if (timeout === void 0) {
                if (this._cachedTimeouts) {
                    this._errors.splice(0, this._errors.length - 1);
                    timeout = this._cachedTimeouts.slice(-1);
                } else return false;
            }
            var self = this;
            this._timer = setTimeout(function() {
                self._attempts++;
                if (self._operationTimeoutCb) {
                    self._timeout = setTimeout(function() {
                        self._operationTimeoutCb(self._attempts);
                    }, self._operationTimeout);
                    if (self._options.unref) self._timeout.unref();
                }
                self._fn(self._attempts);
            }, timeout);
            if (this._options.unref) this._timer.unref();
            return true;
        };
        RetryOperation.prototype.attempt = function(fn, timeoutOps) {
            this._fn = fn;
            if (timeoutOps) {
                if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
                if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
            }
            var self = this;
            if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
                self._operationTimeoutCb();
            }, self._operationTimeout);
            this._operationStart = /* @__PURE__ */ new Date().getTime();
            this._fn(this._attempts);
        };
        RetryOperation.prototype.try = function(fn) {
            console.log("Using RetryOperation.try() is deprecated");
            this.attempt(fn);
        };
        RetryOperation.prototype.start = function(fn) {
            console.log("Using RetryOperation.start() is deprecated");
            this.attempt(fn);
        };
        RetryOperation.prototype.start = RetryOperation.prototype.try;
        RetryOperation.prototype.errors = function() {
            return this._errors;
        };
        RetryOperation.prototype.attempts = function() {
            return this._attempts;
        };
        RetryOperation.prototype.mainError = function() {
            if (this._errors.length === 0) return null;
            var counts = {};
            var mainError = null;
            var mainErrorCount = 0;
            for(var i = 0; i < this._errors.length; i++){
                var error = this._errors[i];
                var message = error.message;
                var count = (counts[message] || 0) + 1;
                counts[message] = count;
                if (count >= mainErrorCount) {
                    mainError = error;
                    mainErrorCount = count;
                }
            }
            return mainError;
        };
    }
});
// ../../node_modules/.pnpm/retry@0.13.1/node_modules/retry/lib/retry.js
var $af401cd1bc7a3c41$var$require_retry = $af401cd1bc7a3c41$var$__commonJS({
    "../../node_modules/.pnpm/retry@0.13.1/node_modules/retry/lib/retry.js" (exports) {
        "use strict";
        var RetryOperation = $af401cd1bc7a3c41$var$require_retry_operation();
        exports.operation = function(options) {
            var timeouts = exports.timeouts(options);
            return new RetryOperation(timeouts, {
                forever: options && (options.forever || options.retries === Infinity),
                unref: options && options.unref,
                maxRetryTime: options && options.maxRetryTime
            });
        };
        exports.timeouts = function(options) {
            if (options instanceof Array) return [].concat(options);
            var opts = {
                retries: 10,
                factor: 2,
                minTimeout: 1000,
                maxTimeout: Infinity,
                randomize: false
            };
            for(var key in options)opts[key] = options[key];
            if (opts.minTimeout > opts.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
            var timeouts = [];
            for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
            if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
            timeouts.sort(function(a, b) {
                return a - b;
            });
            return timeouts;
        };
        exports.createTimeout = function(attempt, opts) {
            var random = opts.randomize ? Math.random() + 1 : 1;
            var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
            timeout = Math.min(timeout, opts.maxTimeout);
            return timeout;
        };
        exports.wrap = function(obj, options, methods) {
            if (options instanceof Array) {
                methods = options;
                options = null;
            }
            if (!methods) {
                methods = [];
                for(var key in obj)if (typeof obj[key] === "function") methods.push(key);
            }
            for(var i = 0; i < methods.length; i++){
                var method = methods[i];
                var original = obj[method];
                obj[method] = (function retryWrapper(original2) {
                    var op = exports.operation(options);
                    var args = Array.prototype.slice.call(arguments, 1);
                    var callback = args.pop();
                    args.push(function(err) {
                        if (op.retry(err)) return;
                        if (err) arguments[0] = op.mainError();
                        callback.apply(this, arguments);
                    });
                    op.attempt(function() {
                        original2.apply(obj, args);
                    });
                }).bind(obj, original);
                obj[method].options = options;
            }
        };
    }
});
// ../../node_modules/.pnpm/retry@0.13.1/node_modules/retry/index.js
var $af401cd1bc7a3c41$var$require_retry2 = $af401cd1bc7a3c41$var$__commonJS({
    "../../node_modules/.pnpm/retry@0.13.1/node_modules/retry/index.js" (exports, module) {
        "use strict";
        module.exports = $af401cd1bc7a3c41$var$require_retry();
    }
});
// src/enhancement/createLimitPolicy.ts
var $af401cd1bc7a3c41$var$import_p_limit = $af401cd1bc7a3c41$var$__toESM($af401cd1bc7a3c41$var$require_p_limit());
// ../../node_modules/.pnpm/p-retry@5.1.2/node_modules/p-retry/index.js
var $af401cd1bc7a3c41$var$import_retry = $af401cd1bc7a3c41$var$__toESM($af401cd1bc7a3c41$var$require_retry2(), 1);
var $af401cd1bc7a3c41$var$networkErrorMsgs = /* @__PURE__ */ new Set([
    "Failed to fetch",
    // Chrome
    "NetworkError when attempting to fetch resource.",
    // Firefox
    "The Internet connection appears to be offline.",
    // Safari
    "Network request failed",
    // `cross-fetch`
    "fetch failed"
]);
var $af401cd1bc7a3c41$var$AbortError = class extends Error {
    constructor(message){
        super();
        if (message instanceof Error) {
            this.originalError = message;
            ({ message: message } = message);
        } else {
            this.originalError = new Error(message);
            this.originalError.stack = this.stack;
        }
        this.name = "AbortError";
        this.message = message;
    }
};
var $af401cd1bc7a3c41$var$decorateErrorWithCounts = (error, attemptNumber, options)=>{
    const retriesLeft = options.retries - (attemptNumber - 1);
    error.attemptNumber = attemptNumber;
    error.retriesLeft = retriesLeft;
    return error;
};
var $af401cd1bc7a3c41$var$isNetworkError = (errorMessage)=>$af401cd1bc7a3c41$var$networkErrorMsgs.has(errorMessage);
var $af401cd1bc7a3c41$var$getDOMException = (errorMessage)=>globalThis.DOMException === void 0 ? new Error(errorMessage) : new DOMException(errorMessage);
async function $af401cd1bc7a3c41$var$pRetry(input, options) {
    return new Promise((resolve, reject)=>{
        options = {
            onFailedAttempt () {},
            retries: 10,
            ...options
        };
        const operation = $af401cd1bc7a3c41$var$import_retry.default.operation(options);
        operation.attempt(async (attemptNumber)=>{
            try {
                resolve(await input(attemptNumber));
            } catch (error) {
                if (!(error instanceof Error)) {
                    reject(new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`));
                    return;
                }
                if (error instanceof $af401cd1bc7a3c41$var$AbortError) {
                    operation.stop();
                    reject(error.originalError);
                } else if (error instanceof TypeError && !$af401cd1bc7a3c41$var$isNetworkError(error.message)) {
                    operation.stop();
                    reject(error);
                } else {
                    $af401cd1bc7a3c41$var$decorateErrorWithCounts(error, attemptNumber, options);
                    try {
                        await options.onFailedAttempt(error);
                    } catch (error2) {
                        reject(error2);
                        return;
                    }
                    if (!operation.retry(error)) reject(operation.mainError());
                }
            }
        });
        if (options.signal && !options.signal.aborted) options.signal.addEventListener("abort", ()=>{
            operation.stop();
            const reason = options.signal.reason === void 0 ? $af401cd1bc7a3c41$var$getDOMException("The operation was aborted.") : options.signal.reason;
            reject(reason instanceof Error ? reason : $af401cd1bc7a3c41$var$getDOMException(reason));
        }, {
            once: true
        });
    });
}
// ../../node_modules/.pnpm/p-throttle@5.0.0/node_modules/p-throttle/index.js
var $af401cd1bc7a3c41$var$AbortError2 = class extends Error {
    constructor(){
        super("Throttled function aborted");
        this.name = "AbortError";
    }
};
function $af401cd1bc7a3c41$var$pThrottle({ limit: limit, interval: interval, strict: strict }) {
    if (!Number.isFinite(limit)) throw new TypeError("Expected `limit` to be a finite number");
    if (!Number.isFinite(interval)) throw new TypeError("Expected `interval` to be a finite number");
    const queue = /* @__PURE__ */ new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $af401cd1bc7a3c41$var$AbortError2());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
}
// src/enhancement/createLimitPolicy.ts
function $af401cd1bc7a3c41$export$dcc6636e254f409b({ throttle: throttle = {
    interval: 1e3,
    limit: 10
}, retry: retry2 = {
    retries: 1,
    factor: 1.66
}, limit: limit = 10 }) {
    const throttler = throttle ? $af401cd1bc7a3c41$var$pThrottle(throttle) : null;
    const limiter = limit ? (0, $af401cd1bc7a3c41$var$import_p_limit.default)(limit) : null;
    return function limitPolicy(func) {
        let currentFunc = async ()=>await func();
        if (throttler) {
            const throttleFunc = currentFunc;
            currentFunc = throttler(throttleFunc);
        }
        if (limiter) {
            const limitFunc = currentFunc;
            currentFunc = ()=>limiter(limitFunc);
        }
        if (retry2) {
            const retryFunc = currentFunc;
            currentFunc = ()=>$af401cd1bc7a3c41$var$pRetry(retryFunc, {
                    ...retry2,
                    onFailedAttempt: async (error)=>{
                        if (retry2.onFailedAttempt) await retry2.onFailedAttempt(error);
                        if (error instanceof (0, $hAokw.ApiClientError) && typeof error.statusCode === "number" && error.statusCode >= 400 && error.statusCode < 500 && error.statusCode !== 429 && error.statusCode !== 408) throw error;
                    }
                });
        }
        return currentFunc();
    };
}
var $af401cd1bc7a3c41$export$f0a5e0d6a7620156 = async (func)=>await func();
// src/utils/rewriteFilters.ts
var $af401cd1bc7a3c41$var$isPlainObject = (obj)=>typeof obj === "object" && obj !== null && !Array.isArray(obj);
function $af401cd1bc7a3c41$var$rewriteFilters(filters) {
    return Object.entries(filters != null ? filters : {}).reduce((acc, [key, value])=>{
        const lhs = `filters.${key}` + ($af401cd1bc7a3c41$var$isPlainObject(value) ? `[${Object.keys(value)[0]}]` : "");
        const rhs = $af401cd1bc7a3c41$var$isPlainObject(value) ? Object.values(value)[0] : value;
        return {
            ...acc,
            [lhs]: Array.isArray(rhs) ? rhs.map((v)=>`${v}`.trim()).join(",") : `${rhs}`.trim()
        };
    }, {});
}
// src/CanvasClient.ts
var $af401cd1bc7a3c41$var$CANVAS_URL = "/api/v1/canvas";
var $af401cd1bc7a3c41$export$85860541c04dc1ff = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        var _a;
        if (!options.limitPolicy) options.limitPolicy = $af401cd1bc7a3c41$export$dcc6636e254f409b({});
        super(options);
        this.edgeApiHost = (_a = options.edgeApiHost) != null ? _a : "https://uniform.global";
        this.edgeApiRequestInit = options.disableSWR ? {
            headers: {
                "x-disable-swr": "true"
            }
        } : void 0;
    }
    /** Fetches lists of Canvas compositions, optionally by type */ async getCompositionList(params = {}) {
        const { projectId: projectId } = this.options;
        const { resolveData: resolveData, filters: filters, ...originParams } = params;
        const rewrittenFilters = $af401cd1bc7a3c41$var$rewriteFilters(filters);
        if (!resolveData) {
            const fetchUri = this.createUrl($af401cd1bc7a3c41$var$CANVAS_URL, {
                ...originParams,
                projectId: projectId,
                ...rewrittenFilters
            });
            return this.apiClient(fetchUri);
        }
        const edgeParams = {
            ...originParams,
            projectId: projectId,
            diagnostics: typeof params.diagnostics === "boolean" ? params.diagnostics : params.diagnostics === "no-data" ? "no-data" : void 0,
            ...rewrittenFilters
        };
        const edgeUrl = this.createUrl("/api/v1/compositions", edgeParams, this.edgeApiHost);
        return this.apiClient(edgeUrl, this.edgeApiRequestInit);
    }
    getCompositionByNodePath(options) {
        return this.getOneComposition(options);
    }
    getCompositionByNodeId(options) {
        return this.getOneComposition(options);
    }
    getCompositionBySlug(options) {
        return this.getOneComposition(options);
    }
    getCompositionById(options) {
        return this.getOneComposition(options);
    }
    getCompositionDefaults(options) {
        return this.getOneComposition(options);
    }
    /** Fetches historical versions of a composition or pattern */ async getCompositionHistory(options) {
        const historyUrl = this.createUrl("/api/v1/canvas-history", {
            ...options,
            projectId: this.options.projectId
        });
        return this.apiClient(historyUrl);
    }
    getOneComposition({ skipDataResolution: skipDataResolution, diagnostics: diagnostics, ...params }) {
        const { projectId: projectId } = this.options;
        if (skipDataResolution) return this.apiClient(this.createUrl($af401cd1bc7a3c41$var$CANVAS_URL, {
            ...params,
            projectId: projectId
        }));
        const edgeParams = {
            ...params,
            projectId: projectId,
            diagnostics: typeof diagnostics === "boolean" ? diagnostics : diagnostics === "no-data" ? "no-data" : void 0
        };
        const edgeUrl = this.createUrl("/api/v1/composition", edgeParams, this.edgeApiHost);
        return this.apiClient(edgeUrl, this.edgeApiRequestInit);
    }
    /** Updates or creates a Canvas component definition */ async updateComposition(body, options) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$CANVAS_URL);
        const headers = {};
        if (options == null ? void 0 : options.ifUnmodifiedSince) headers["x-if-unmodified-since"] = options.ifUnmodifiedSince;
        const { response: response } = await this.apiClientWithResponse(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true,
            headers: headers
        });
        return {
            modified: response.headers.get("x-modified-at")
        };
    }
    /** Deletes a Canvas component definition */ async removeComposition(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$CANVAS_URL);
        const { projectId: projectId } = this.options;
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: projectId
            }),
            expectNoContent: true
        });
    }
    /** Fetches all Canvas component definitions */ async getComponentDefinitions(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl("/api/v1/canvas-definitions", {
            ...options,
            projectId: projectId
        });
        return this.apiClient(fetchUri);
    }
    /** Updates or creates a Canvas component definition */ async updateComponentDefinition(body) {
        const fetchUri = this.createUrl("/api/v1/canvas-definitions");
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a Canvas component definition */ async removeComponentDefinition(body) {
        const fetchUri = this.createUrl("/api/v1/canvas-definitions");
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
var $af401cd1bc7a3c41$export$ae54a93490f74ec3 = class extends $af401cd1bc7a3c41$export$85860541c04dc1ff {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $af401cd1bc7a3c41$var$CATEGORIES_URL = "/api/v1/categories";
var $af401cd1bc7a3c41$export$59a20b61e4ba7bba = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        if (!options.limitPolicy) options.limitPolicy = $af401cd1bc7a3c41$export$dcc6636e254f409b({});
        super(options);
    }
    /** Fetches all categories created in given project */ async getCategories(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl("/api/v1/categories", {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates a category, also used to re-order them */ async upsertCategories(categories) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$CATEGORIES_URL);
        return await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                categories: categories,
                projectId: projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a category */ async removeCategory(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$CATEGORIES_URL);
        return await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                projectId: projectId,
                categoryId: options.categoryId
            }),
            expectNoContent: true
        });
    }
};
var $af401cd1bc7a3c41$export$f22d4a8a1c2c3383 = class extends $af401cd1bc7a3c41$export$59a20b61e4ba7bba {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $af401cd1bc7a3c41$var$_contentTypesUrl, $af401cd1bc7a3c41$var$_entriesUrl;
var $af401cd1bc7a3c41$var$_ContentClient = class _ContentClient extends (0, $hAokw.ApiClient) {
    constructor(options){
        var _a;
        super(options);
        this.edgeApiHost = (_a = options.edgeApiHost) != null ? _a : "https://uniform.global";
    }
    getContentTypes(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ContentClient, $af401cd1bc7a3c41$var$_contentTypesUrl), {
            ...options,
            projectId: projectId
        });
        return this.apiClient(fetchUri);
    }
    getEntries(options) {
        const { projectId: projectId } = this.options;
        const { skipDataResolution: skipDataResolution, filters: filters, ...params } = options;
        const rewrittenFilters = $af401cd1bc7a3c41$var$rewriteFilters(filters);
        if (skipDataResolution) {
            const url = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ContentClient, $af401cd1bc7a3c41$var$_entriesUrl), {
                ...params,
                ...rewrittenFilters,
                projectId: projectId
            });
            return this.apiClient(url);
        }
        const edgeUrl = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ContentClient, $af401cd1bc7a3c41$var$_entriesUrl), {
            ...this.getEdgeOptions(params),
            ...rewrittenFilters
        }, this.edgeApiHost);
        return this.apiClient(edgeUrl, this.options.disableSWR ? {
            headers: {
                "x-disable-swr": "true"
            }
        } : void 0);
    }
    /** Fetches historical versions of an entry */ async getEntryHistory(options) {
        const historyUrl = this.createUrl("/api/v1/entries-history", {
            ...options,
            projectId: this.options.projectId
        });
        return this.apiClient(historyUrl);
    }
    async upsertContentType(body, opts = {}) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ContentClient, $af401cd1bc7a3c41$var$_contentTypesUrl));
        if (typeof body.contentType.slugSettings === "object" && body.contentType.slugSettings !== null && Object.keys(body.contentType.slugSettings).length === 0) delete body.contentType.slugSettings;
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true,
            headers: opts.autogenerateDataTypes ? {
                "x-uniform-autogenerate-data-types": "true"
            } : {}
        });
    }
    async upsertEntry(body, options) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ContentClient, $af401cd1bc7a3c41$var$_entriesUrl));
        const headers = {};
        if (options == null ? void 0 : options.ifUnmodifiedSince) headers["x-if-unmodified-since"] = options.ifUnmodifiedSince;
        const { response: response } = await this.apiClientWithResponse(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true,
            headers: headers
        });
        return {
            modified: response.headers.get("x-modified-at")
        };
    }
    async deleteContentType(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ContentClient, $af401cd1bc7a3c41$var$_contentTypesUrl));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    async deleteEntry(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ContentClient, $af401cd1bc7a3c41$var$_entriesUrl));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    getEdgeOptions(options) {
        const { projectId: projectId } = this.options;
        const { skipDataResolution: skipDataResolution, ...params } = options;
        return {
            projectId: projectId,
            ...params,
            diagnostics: typeof options.diagnostics === "boolean" ? options.diagnostics : options.diagnostics === "no-data" ? "no-data" : void 0
        };
    }
};
$af401cd1bc7a3c41$var$_contentTypesUrl = new WeakMap();
$af401cd1bc7a3c41$var$_entriesUrl = new WeakMap();
$af401cd1bc7a3c41$var$__privateAdd($af401cd1bc7a3c41$var$_ContentClient, $af401cd1bc7a3c41$var$_contentTypesUrl, "/api/v1/content-types");
$af401cd1bc7a3c41$var$__privateAdd($af401cd1bc7a3c41$var$_ContentClient, $af401cd1bc7a3c41$var$_entriesUrl, "/api/v1/entries");
var $af401cd1bc7a3c41$export$10ef7e002e8fafcf = $af401cd1bc7a3c41$var$_ContentClient;
var $af401cd1bc7a3c41$export$a3e2ea88109b94e0 = class extends $af401cd1bc7a3c41$export$10ef7e002e8fafcf {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $af401cd1bc7a3c41$var$dataSourceUrl = "/api/v1/data-source";
var $af401cd1bc7a3c41$var$dataSourcesUrl = "/api/v1/data-sources";
var $af401cd1bc7a3c41$export$6cc912837fdbaf77 = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches all DataSources for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$dataSourceUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Fetches all DataSources for a project */ async getList(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$dataSourcesUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a DataSource */ async upsert(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$dataSourceUrl);
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a DataSource */ async remove(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$dataSourceUrl);
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
var $af401cd1bc7a3c41$var$_url;
var $af401cd1bc7a3c41$var$_DataTypeClient = class _DataTypeClient extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches all DataTypes for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_DataTypeClient, $af401cd1bc7a3c41$var$_url), {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a DataType */ async upsert(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_DataTypeClient, $af401cd1bc7a3c41$var$_url));
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a DataType */ async remove(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_DataTypeClient, $af401cd1bc7a3c41$var$_url));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
$af401cd1bc7a3c41$var$_url = new WeakMap();
$af401cd1bc7a3c41$var$__privateAdd($af401cd1bc7a3c41$var$_DataTypeClient, $af401cd1bc7a3c41$var$_url, "/api/v1/data-types");
var $af401cd1bc7a3c41$export$5a2b7c0d413f3681 = $af401cd1bc7a3c41$var$_DataTypeClient;
// src/enhancement/batchEnhancer.ts
var $af401cd1bc7a3c41$export$84c103dec340029c = class {
    constructor(_resolve, _reject, args){
        this._resolve = _resolve;
        this._reject = _reject;
        this.args = args;
        this._isCompleted = false;
    }
    /** Mark the batch entry as successfully completed. */ resolve(result) {
        this._resolve(result);
        this._isCompleted = true;
    }
    /** Mark the batch entry as failed. */ reject(reason) {
        this._reject(reason);
        this._isCompleted = true;
    }
    /** @return Whether the batch entry has been completed (resolved or rejected). */ get isCompleted() {
        return this._isCompleted;
    }
};
function $af401cd1bc7a3c41$export$e14c1c093c4c493f({ handleBatch: handleBatch, shouldQueue: shouldQueue, limitPolicy: limitPolicy }) {
    let queue = [];
    const batchedFn = async (options)=>{
        if (!shouldQueue || shouldQueue(options)) return new Promise((resolve, reject)=>{
            queue.push(new $af401cd1bc7a3c41$export$84c103dec340029c(resolve, reject, options));
        });
        else return void 0;
    };
    const complete = async ()=>{
        if (queue.length > 0) {
            try {
                await handleBatch(queue);
            } catch (e) {
                queue.forEach((entry)=>entry.reject(e));
            }
            if (queue.some((entry)=>!entry.isCompleted)) throw new Error("The completeAll() function failed to resolve or reject all promises in the batch!");
        }
        const processed = queue.length;
        queue = [];
        return processed;
    };
    return {
        enhanceOne: batchedFn,
        completeAll: complete,
        limitPolicy: limitPolicy
    };
}
// src/enhancement/compose.ts
var $af401cd1bc7a3c41$export$f672e0b6f7222cd7 = (input, ...composers)=>{
    const composed = {
        enhanceOne: (value)=>{
            let result = "enhanceOne" in input ? input.enhanceOne(value) : input(value);
            for (const currentComposed of composers){
                const current = $af401cd1bc7a3c41$var$isPromise(result) ? result : Promise.resolve(result);
                const enhanceOne = "enhanceOne" in currentComposed ? currentComposed.enhanceOne : currentComposed;
                result = current.then((res)=>enhanceOne({
                        ...value,
                        parameter: {
                            type: value.parameter.type,
                            value: res
                        }
                    }));
            }
            return result;
        },
        completeAll: async ()=>{
            var _a, _b;
            for (const currentComposed of composers){
                if ("completeAll" in currentComposed) throw new Error("Only the first enhancer in a compose chain can use the completeAll function (batching)");
            }
            return (_b = "completeAll" in input ? (_a = input.completeAll) == null ? void 0 : _a.call(input) : 0) != null ? _b : 0;
        }
    };
    return composed;
};
function $af401cd1bc7a3c41$var$isPromise(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
}
// src/enhancement/getComponentPath.ts
function $af401cd1bc7a3c41$export$934fe982cedca2f(ancestorsAndSelf) {
    const path = [];
    for(let i = ancestorsAndSelf.length - 1; i >= 0; i--){
        const currentLocation = ancestorsAndSelf[i];
        const parentLocation = ancestorsAndSelf[i + 1];
        if ("type" in currentLocation && currentLocation.type !== "slot") {
            if (currentLocation.type === "block") {
                const { fieldName: fieldName, blockIndexFn: blockIndexFn } = currentLocation;
                const blockIndex = blockIndexFn();
                if (fieldName && blockIndex !== void 0) {
                    const noun = parentLocation && "type" in parentLocation && parentLocation.type === "block" ? "fields" : "parameters";
                    path.push(`${noun}.${fieldName}.value[${blockIndex}]`);
                }
            }
            continue;
        }
        const parentSlotIndex = currentLocation.parentSlotIndexFn();
        const { parentSlot: parentSlot } = currentLocation;
        if (parentSlot && parentSlotIndex !== void 0) path.push(`${parentSlot}[${parentSlotIndex}]`);
    }
    return `.${path.join(".")}`;
}
// src/utils/constants.ts
var $af401cd1bc7a3c41$export$a439de129e0de5a6 = "$personalization";
var $af401cd1bc7a3c41$export$e115756c5e622701 = "$test";
var $af401cd1bc7a3c41$export$9656110639e729a7 = "$localization";
var $af401cd1bc7a3c41$export$76fd55dc71716f06 = "$slotSection";
var $af401cd1bc7a3c41$export$11af2dddcad0928d = "intentTag";
var $af401cd1bc7a3c41$export$58a1b975993a5f83 = "locale";
var $af401cd1bc7a3c41$export$121a3fe47ae2b70a = "$block";
var $af401cd1bc7a3c41$export$b6d6f48a1ccec5c4 = "pz";
var $af401cd1bc7a3c41$export$3116fbcb69b49769 = "test";
var $af401cd1bc7a3c41$export$6ba47e5f98556fde = "localized";
var $af401cd1bc7a3c41$export$3813b1eae9b12efa = "$slotSectionItems";
var $af401cd1bc7a3c41$export$fa529f6420842eda = 0;
var $af401cd1bc7a3c41$export$f20c1529e01bf63b = 64;
var $af401cd1bc7a3c41$export$f6c2c31d47a9f8a8 = 63;
var $af401cd1bc7a3c41$export$b72a0bcc64d2087b = "$pzCrit";
var $af401cd1bc7a3c41$export$360a83009579aa85 = "trackingEventName";
var $af401cd1bc7a3c41$export$420ac9f66f7157b = "algorithm";
var $af401cd1bc7a3c41$export$e3aef484ade8ba30 = "pzAlgorithm";
var $af401cd1bc7a3c41$export$d5535f327661f75f = "count";
var $af401cd1bc7a3c41$export$1c227eb56be4fa11 = "$tstVrnt";
var $af401cd1bc7a3c41$export$d674a70432da69ae = "$enr";
var $af401cd1bc7a3c41$export$6f21b878045974de = "$contextualEditing";
var $af401cd1bc7a3c41$export$2090ed332d42ea1d = "secret";
var $af401cd1bc7a3c41$export$69fd613f16ae867f = "is_incontext_editing_mode";
var $af401cd1bc7a3c41$export$a12386617f7e71c5 = "is_incontext_editing_playground";
var $af401cd1bc7a3c41$export$76c8db4d36dfd98c = "is_incontext_editing_forced_settings";
var $af401cd1bc7a3c41$export$1993ed28d9404f25 = "is_config_check";
var $af401cd1bc7a3c41$export$b7c82480d5e73c22 = "uniform-component-start";
var $af401cd1bc7a3c41$export$e0c2a63b4a806361 = "uniform-component-end";
var $af401cd1bc7a3c41$export$6551318158a36a54 = "uniform-canvas-preview-script";
var $af401cd1bc7a3c41$export$f81939f7f916064b = "data-is-rendered-by-uniform";
var $af401cd1bc7a3c41$export$b1a6d9fad9703edf = "placeholder";
var $af401cd1bc7a3c41$export$1767d608c3fa1c06 = {
    _id: "_empty_composition_id",
    _name: "An empty composition used for contextual editing",
    type: "_empty_composition_type"
};
var $af401cd1bc7a3c41$export$10cb7ec081407943 = 10;
var $af401cd1bc7a3c41$export$6005b607672ef043 = 86400;
var $af401cd1bc7a3c41$export$557752ed803b64ae = 30;
var $af401cd1bc7a3c41$export$2c95948d1430f61b = -1;
var $af401cd1bc7a3c41$export$4722a507c3b4aebf = "asset";
var $af401cd1bc7a3c41$export$a058b4e4e9261b7 = "uniform-assets";
var $af401cd1bc7a3c41$export$b886f8d95f46db8d = "custom-url";
// src/utils/guards.ts
function $af401cd1bc7a3c41$export$724543431ab8008a(root) {
    return root.type === "root" && $af401cd1bc7a3c41$export$2dbc46ea47a0ba09(root.node);
}
function $af401cd1bc7a3c41$export$2dbc46ea47a0ba09(entryData) {
    return Boolean(entryData && typeof entryData === "object" && "fields" in entryData);
}
function $af401cd1bc7a3c41$export$c64deeb5e9e2e553(value) {
    return Array.isArray(value) && (value.length > 0 ? $af401cd1bc7a3c41$export$9222616b154e17c1(value[0]) : true);
}
function $af401cd1bc7a3c41$export$9222616b154e17c1(item) {
    return Boolean(item instanceof Object && "_source" in item && "fields" in item && item.fields instanceof Object && "url" in item.fields && item.fields.url instanceof Object);
}
function $af401cd1bc7a3c41$export$eee6b66f71e54357(value) {
    return typeof value === "object" && value !== null && "type" in value && "path" in value;
}
// src/utils/properties.ts
function $af401cd1bc7a3c41$export$ac2195b73bd89f9(entity) {
    return "parameters" in entity && entity.parameters ? entity.parameters : "fields" in entity && entity.fields ? entity.fields : void 0;
}
function $af401cd1bc7a3c41$export$43f74a9dc6b257c6(parameter) {
    if (!parameter) return parameter;
    const localizedValues = /* @__PURE__ */ new Map();
    if (typeof parameter.value !== "undefined") localizedValues.set(void 0, parameter.value);
    if (parameter.locales !== void 0) for (const [locale, localeValue] of Object.entries(parameter.locales))localizedValues.set(locale, localeValue);
    return localizedValues;
}
function $af401cd1bc7a3c41$export$ee1ead7e9266f0cd(data, options = {}) {
    if (!data) return data;
    else if (Array.isArray(data) && options.toSingle) return data.length > 0 ? $af401cd1bc7a3c41$var$flattenSingleNodeValues(data[0]) : void 0;
    else if (Array.isArray(data)) return data.map((node)=>$af401cd1bc7a3c41$var$flattenSingleNodeValues(node, options));
    else return $af401cd1bc7a3c41$var$flattenSingleNodeValues(data, options);
}
function $af401cd1bc7a3c41$var$flattenSingleNodeValues(data, options = {}) {
    const { levels: levels = 1 } = options;
    const properties = $af401cd1bc7a3c41$export$ac2195b73bd89f9(data);
    return properties ? Object.fromEntries(Object.entries(properties).map(([id, parameter])=>{
        const value = parameter ? parameter.value : parameter;
        if (levels > 0 && Array.isArray(value) && // In the future ASSET_PARAMETER_TYPE will be a nested data type
        ($af401cd1bc7a3c41$export$fc3682805f179cf3(parameter.type) || parameter.type === $af401cd1bc7a3c41$export$4722a507c3b4aebf)) {
            const nestedOptions = {
                ...options,
                levels: levels - 1
            };
            return [
                id,
                value.map((item)=>$af401cd1bc7a3c41$export$ee1ead7e9266f0cd(item, nestedOptions))
            ];
        } else return [
            id,
            value
        ];
    })) : properties;
}
// src/utils/variables/parseVariableExpression.ts
var $af401cd1bc7a3c41$var$escapeCharacter = "\\";
var $af401cd1bc7a3c41$var$variablePrefix = "${";
var $af401cd1bc7a3c41$var$variableSuffix = "}";
function $af401cd1bc7a3c41$export$a1a7b5a9f0f65e01(serialized, onToken) {
    if (typeof serialized !== "string") throw new TypeError("Variable expression must be a string");
    let bufferStartIndex = 0;
    let bufferEndIndex = 0;
    let tokenCount = 0;
    const handleToken = (token, type)=>{
        tokenCount++;
        return onToken == null ? void 0 : onToken(token, type);
    };
    let state = "text";
    for(let index = 0; index < serialized.length; index++){
        const char = serialized[index];
        if (bufferStartIndex > bufferEndIndex) bufferEndIndex = bufferStartIndex;
        if (char === $af401cd1bc7a3c41$var$variablePrefix[0] && serialized[index + 1] === $af401cd1bc7a3c41$var$variablePrefix[1]) {
            if (serialized[index - 1] === $af401cd1bc7a3c41$var$escapeCharacter) {
                bufferEndIndex -= $af401cd1bc7a3c41$var$escapeCharacter.length;
                if (handleToken(serialized.substring(bufferStartIndex, bufferEndIndex), "text") === false) return tokenCount;
                bufferStartIndex = index;
                bufferEndIndex = index + 1;
                continue;
            }
            state = "variable";
            if (bufferEndIndex > bufferStartIndex) {
                if (handleToken(serialized.substring(bufferStartIndex, bufferEndIndex), "text") === false) return tokenCount;
                bufferStartIndex = bufferEndIndex;
            }
            index += $af401cd1bc7a3c41$var$variablePrefix.length - 1;
            bufferStartIndex += $af401cd1bc7a3c41$var$variablePrefix.length;
            continue;
        }
        if (char === $af401cd1bc7a3c41$var$variableSuffix && state === "variable") {
            if (serialized[index - 1] === $af401cd1bc7a3c41$var$escapeCharacter) {
                bufferEndIndex++;
                continue;
            }
            state = "text";
            if (bufferEndIndex > bufferStartIndex) {
                const unescapedVariableName = serialized.substring(bufferStartIndex, bufferEndIndex).replace(/\\([${}])/g, "$1");
                if (handleToken(unescapedVariableName, "variable") === false) return tokenCount;
                bufferStartIndex = bufferEndIndex + $af401cd1bc7a3c41$var$variableSuffix.length;
            }
            continue;
        }
        bufferEndIndex++;
    }
    if (bufferEndIndex > bufferStartIndex) {
        if (state === "variable") {
            state = "text";
            bufferStartIndex -= $af401cd1bc7a3c41$var$variablePrefix.length;
        }
        handleToken(serialized.substring(bufferStartIndex), state);
    }
    return tokenCount;
}
// src/utils/variables/hasReferencedVariables.ts
function $af401cd1bc7a3c41$export$181bc3bc0bea1e05(value) {
    if (value === void 0) return 0;
    let variableTokenCount = 0;
    $af401cd1bc7a3c41$export$a1a7b5a9f0f65e01(value, (_, tokenType)=>{
        if (tokenType === "variable") variableTokenCount++;
    });
    return variableTokenCount;
}
// src/enhancement/walkNodeTree.ts
function $af401cd1bc7a3c41$export$edadceaf63f106a9(node, visitor, options) {
    var _a, _b;
    const componentQueue = [
        {
            ancestorsAndSelf: Array.isArray(node) ? node : [
                {
                    node: node,
                    type: "root"
                }
            ],
            context: options == null ? void 0 : options.initialContext
        }
    ];
    const childContexts = /* @__PURE__ */ new Map();
    do {
        const currentQueueEntry = componentQueue.pop();
        if (!currentQueueEntry) continue;
        const currentComponent = currentQueueEntry.ancestorsAndSelf[0];
        let visitDescendants = true;
        let descendantContext = (_a = childContexts.get(currentComponent.node)) != null ? _a : currentQueueEntry.context;
        let visitorInfo;
        if (currentComponent.type === "root" && $af401cd1bc7a3c41$export$724543431ab8008a(currentComponent) || currentComponent.type === "block") visitorInfo = {
            type: "entry",
            node: currentComponent.node,
            ancestorsAndSelf: currentQueueEntry.ancestorsAndSelf,
            actions: {
                replace: (replacementNode)=>{
                    Object.assign(currentComponent.node, replacementNode);
                    const propertiesToCheck = [
                        "fields",
                        "_dataResources",
                        "_author"
                    ];
                    propertiesToCheck.forEach((property)=>{
                        if (!replacementNode[property]) delete currentComponent.node[property];
                    });
                },
                remove: ()=>{
                    const currentComponentLocation = currentQueueEntry.ancestorsAndSelf[0];
                    const parentComponent = currentQueueEntry.ancestorsAndSelf[1];
                    if (currentComponentLocation.type === "block") {
                        const { fieldName: fieldName, blockIndexFn: blockIndexFn } = currentComponentLocation;
                        const blockIndex = blockIndexFn();
                        const blockValue = $af401cd1bc7a3c41$export$ed4f0e5e2fc9033c(parentComponent.node, fieldName);
                        blockValue.splice(blockIndex, 1);
                        if (blockValue.length === 0) {
                            const properties2 = $af401cd1bc7a3c41$export$ac2195b73bd89f9(parentComponent.node);
                            delete properties2[fieldName];
                        }
                    } else throw new Error("Unknown node type");
                    visitDescendants = false;
                },
                insertAfter: (nodes)=>{
                    const currentNodeInfo = currentQueueEntry.ancestorsAndSelf[0];
                    if (currentNodeInfo.type !== "block") throw new Error("Unknown type");
                    const { fieldName: fieldName, blockIndexFn: blockIndexFn } = currentNodeInfo;
                    const blockIndex = blockIndexFn();
                    const parentComponent = currentQueueEntry.ancestorsAndSelf[1];
                    const nodesToInsert = Array.isArray(nodes) ? nodes : [
                        nodes
                    ];
                    if (fieldName && typeof blockIndex !== "undefined") {
                        $af401cd1bc7a3c41$export$ac2195b73bd89f9(parentComponent.node)[fieldName].value.splice(blockIndex + 1, 0, ...nodesToInsert);
                        componentQueue.unshift(...nodesToInsert.map((enqueueingComponent)=>{
                            const blockIndexFn2 = ()=>{
                                const parentArray = $af401cd1bc7a3c41$export$ac2195b73bd89f9(parentComponent.node)[fieldName].value;
                                return parentArray.findIndex((x)=>x === enqueueingComponent);
                            };
                            return {
                                ancestorsAndSelf: [
                                    {
                                        type: "block",
                                        node: enqueueingComponent,
                                        fieldName: fieldName,
                                        blockIndexFn: blockIndexFn2
                                    },
                                    // slice removes 'self' since we are inserting a peer of self
                                    ...currentQueueEntry.ancestorsAndSelf.slice(1)
                                ],
                                context: descendantContext
                            };
                        }));
                    }
                },
                stopProcessingDescendants () {
                    visitDescendants = false;
                },
                setDescendantsContext (context) {
                    descendantContext = context;
                },
                setChildContext (child, context) {
                    childContexts.set(child, context);
                }
            },
            context: descendantContext
        };
        else visitorInfo = {
            type: "component",
            node: currentComponent.node,
            ancestorsAndSelf: currentQueueEntry.ancestorsAndSelf,
            actions: {
                replace: (replacementComponent)=>{
                    Object.assign(currentComponent.node, replacementComponent);
                    const propertiesToCheck = [
                        "parameters",
                        "variant",
                        "slots",
                        "data",
                        "_pattern",
                        "_patternError",
                        "_dataResources",
                        "_overridability",
                        "_overrides",
                        "_patternDataResources"
                    ];
                    propertiesToCheck.forEach((property)=>{
                        if (!replacementComponent[property]) delete currentComponent.node[property];
                    });
                },
                remove: ()=>{
                    const currentComponentLocation = currentQueueEntry.ancestorsAndSelf[0];
                    const parentComponent = currentQueueEntry.ancestorsAndSelf[1];
                    if (currentComponentLocation.type === "root") throw new Error("Unable to delete root node.");
                    if (currentComponentLocation.type === "slot") {
                        const { parentSlot: parentSlot, parentSlotIndexFn: parentSlotIndexFn } = currentComponentLocation;
                        const parentSlotIndex = parentSlotIndexFn();
                        parentComponent.node.slots[parentSlot].splice(parentSlotIndex, 1);
                    } else throw new Error("Unknown node type");
                    visitDescendants = false;
                },
                insertAfter: (nodes)=>{
                    const nodesToInsert = Array.isArray(nodes) ? nodes : [
                        nodes
                    ];
                    const currentNodeInfo = currentQueueEntry.ancestorsAndSelf[0];
                    if (currentNodeInfo.type === "root") throw new Error("Unable to insert after root node.");
                    if (currentNodeInfo.type === "slot") {
                        const { parentSlot: parentSlot, parentSlotIndexFn: parentSlotIndexFn } = currentNodeInfo;
                        const parentSlotIndex = parentSlotIndexFn();
                        const parentComponent = currentQueueEntry.ancestorsAndSelf[1];
                        if (parentSlot && typeof parentSlotIndex !== "undefined") {
                            parentComponent.node.slots[parentSlot].splice(parentSlotIndex + 1, 0, ...nodesToInsert);
                            componentQueue.unshift(...nodesToInsert.map((enqueueingComponent)=>{
                                const parentSlotIndexFn2 = ()=>{
                                    return parentComponent.node.slots[parentSlot].findIndex((x)=>x === enqueueingComponent);
                                };
                                return {
                                    type: "slot",
                                    ancestorsAndSelf: [
                                        {
                                            type: "slot",
                                            node: enqueueingComponent,
                                            parentSlot: parentSlot,
                                            parentSlotIndexFn: parentSlotIndexFn2
                                        },
                                        // slice removes 'self' since we are inserting a peer of self
                                        ...currentQueueEntry.ancestorsAndSelf.slice(1)
                                    ],
                                    context: descendantContext
                                };
                            }));
                        }
                    } else throw new Error("Unknown type");
                },
                stopProcessingDescendants () {
                    visitDescendants = false;
                },
                setDescendantsContext (context) {
                    descendantContext = context;
                },
                setChildContext (child, context) {
                    childContexts.set(child, context);
                }
            },
            context: descendantContext
        };
        visitor(visitorInfo);
        if (!visitDescendants) continue;
        const slots = "slots" in currentComponent.node && currentComponent.node.slots;
        if (slots) {
            const slotKeys = Object.keys(slots);
            for(let slotIndex = slotKeys.length - 1; slotIndex >= 0; slotIndex--){
                const slotKey = slotKeys[slotIndex];
                const components = slots[slotKey];
                for(let componentIndex = components.length - 1; componentIndex >= 0; componentIndex--){
                    const enqueueingComponent = components[componentIndex];
                    const parentSlotIndexFn = ()=>{
                        const result = currentComponent.node.slots[slotKey].findIndex((x)=>x === enqueueingComponent);
                        return result;
                    };
                    componentQueue.push({
                        ancestorsAndSelf: [
                            {
                                type: "slot",
                                node: enqueueingComponent,
                                parentSlot: slotKey,
                                parentSlotIndexFn: parentSlotIndexFn
                            },
                            ...currentQueueEntry.ancestorsAndSelf
                        ],
                        context: descendantContext
                    });
                }
            }
        }
        const properties = $af401cd1bc7a3c41$export$ac2195b73bd89f9(currentComponent.node);
        if (properties) {
            const propertyEntries = Object.entries(properties);
            for(let propIndex = propertyEntries.length - 1; propIndex >= 0; propIndex--){
                const [propKey, propObject] = propertyEntries[propIndex];
                if (!$af401cd1bc7a3c41$export$fc3682805f179cf3(propObject.type)) continue;
                if (typeof propObject.value === "string" && $af401cd1bc7a3c41$export$181bc3bc0bea1e05(propObject.value) > 0) continue;
                if (!Array.isArray(propObject.value)) {
                    const error = new $af401cd1bc7a3c41$export$74c3cf988232aadb(`${$af401cd1bc7a3c41$export$934fe982cedca2f(currentQueueEntry.ancestorsAndSelf)}`, propKey, propObject.value);
                    if (options == null ? void 0 : options.throwForInvalidBlockValues) throw error;
                    else {
                        console.warn(`Skipped invalid block value: ${error.message}}`);
                        continue;
                    }
                }
                const blocks = (_b = propObject.value) != null ? _b : [];
                for(let blockIndex = blocks.length - 1; blockIndex >= 0; blockIndex--){
                    const enqueueingBlock = blocks[blockIndex];
                    const blockIndexFn = ()=>{
                        return $af401cd1bc7a3c41$export$ed4f0e5e2fc9033c(currentComponent.node, propKey).findIndex((x)=>x === enqueueingBlock);
                    };
                    componentQueue.push({
                        ancestorsAndSelf: [
                            {
                                type: "block",
                                node: enqueueingBlock,
                                fieldName: propKey,
                                blockIndexFn: blockIndexFn
                            },
                            ...currentQueueEntry.ancestorsAndSelf
                        ],
                        context: descendantContext
                    });
                }
            }
        }
    }while (componentQueue.length > 0);
}
function $af401cd1bc7a3c41$export$fc3682805f179cf3(type) {
    return type === $af401cd1bc7a3c41$export$121a3fe47ae2b70a;
}
function $af401cd1bc7a3c41$export$ed4f0e5e2fc9033c(component, parameterName) {
    var _a;
    const parameter = (_a = $af401cd1bc7a3c41$export$ac2195b73bd89f9(component)) == null ? void 0 : _a[parameterName];
    if ((parameter == null ? void 0 : parameter.value) && parameter.type === $af401cd1bc7a3c41$export$121a3fe47ae2b70a && Array.isArray(parameter.value)) return parameter.value;
    return [];
}
var $af401cd1bc7a3c41$export$74c3cf988232aadb = class _BlockFormatError extends Error {
    constructor(componentPath, propertyId, blockValue){
        super(`${componentPath} has an invalid block property value on ${propertyId}. Block values must be arrays of blocks (BlockValue type), but received ${blockValue === null ? "null" : typeof blockValue}`);
        this.componentPath = componentPath;
        this.propertyId = propertyId;
        this.blockValue = blockValue;
        Object.setPrototypeOf(this, _BlockFormatError.prototype);
    }
};
// src/enhancement/enhance.ts
async function $af401cd1bc7a3c41$export$7ff6d543f13c7390({ composition: composition, enhancers: enhancers, context: context, onErrors: onErrors = (errors)=>{
    throw new Error(errors.map((error)=>`${error.message}
 ${typeof error.error === "object" && "stack" in error.error ? error.error.stack : error.error}`).join("\n\n"));
} }) {
    const promises = [];
    const usedComponentEnhancers = /* @__PURE__ */ new Set();
    const usedParameterEnhancers = /* @__PURE__ */ new Set();
    $af401cd1bc7a3c41$export$edadceaf63f106a9(composition, ({ type: type, node: node, ancestorsAndSelf: ancestorsAndSelf, actions: actions })=>{
        var _a;
        if (type !== "component") {
            actions.stopProcessingDescendants();
            return;
        }
        Object.entries((_a = node.parameters) != null ? _a : {}).forEach(([paramName, paramValue])=>{
            const enhancer = enhancers.resolveParameterEnhancer(node, paramName, paramValue);
            if (enhancer) {
                usedParameterEnhancers.add(enhancer);
                promises.push($af401cd1bc7a3c41$var$enhanceParameter(node, ancestorsAndSelf, paramName, paramValue, enhancer, context));
            }
        });
        const componentEnhancers = enhancers.resolveComponentEnhancers(node);
        promises.push($af401cd1bc7a3c41$var$enhanceComponent(node, ancestorsAndSelf, componentEnhancers, context));
        usedComponentEnhancers.add(componentEnhancers);
    });
    promises.push(...Array.from(usedComponentEnhancers).flatMap((enhancerSet)=>Array.from(enhancerSet).map(async ([, enhancer])=>{
            var _a;
            try {
                if (enhancer.completeAll) {
                    const limitPolicy = (_a = enhancer.limitPolicy) != null ? _a : $af401cd1bc7a3c41$export$f0a5e0d6a7620156;
                    await limitPolicy(()=>enhancer.completeAll());
                }
            } catch (error) {
                return {
                    error: error,
                    message: "Batch component enhancer failed. Individual failed components should receive their own rejections."
                };
            }
        })));
    promises.push(...Array.from(usedParameterEnhancers).map(async (enhancer)=>{
        var _a;
        try {
            if (enhancer.completeAll) {
                const limitPolicy = (_a = enhancer.limitPolicy) != null ? _a : $af401cd1bc7a3c41$export$f0a5e0d6a7620156;
                await limitPolicy(()=>enhancer.completeAll());
            }
        } catch (error) {
            return {
                error: error,
                message: "Batch parameter enhancer failed. Individual failed parameters should receive their own rejections."
            };
        }
    }));
    const issues = (await Promise.all(promises)).flatMap((issue)=>Array.isArray(issue) ? issue : [
            issue
        ]).filter((issue)=>issue);
    if (issues.length) onErrors(issues);
}
async function $af401cd1bc7a3c41$var$enhanceComponent(component, componentContext, enhancers, context) {
    if (enhancers.size) component.data = {};
    return await Promise.all(Array.from(enhancers).map(async ([enhancerName, enhancer])=>{
        var _a;
        try {
            const limitPolicy = enhancer.completeAll ? $af401cd1bc7a3c41$export$f0a5e0d6a7620156 : (_a = enhancer.limitPolicy) != null ? _a : $af401cd1bc7a3c41$export$f0a5e0d6a7620156;
            const result = await limitPolicy(async ()=>enhancer.enhanceOne({
                    component: component,
                    context: context
                }));
            if (result !== void 0 && result !== null) component.data[enhancerName] = result;
        } catch (error) {
            const message = `Component ${$af401cd1bc7a3c41$export$934fe982cedca2f(componentContext)} (type: ${component.type}): data.${enhancerName} enhancer threw exception. Data key will not be present.`;
            delete component.data[enhancerName];
            return {
                message: message,
                error: error
            };
        }
    }));
}
async function $af401cd1bc7a3c41$var$enhanceParameter(component, componentContext, parameterName, parameter, enhancer, context) {
    var _a;
    try {
        const limitPolicy = enhancer.completeAll ? $af401cd1bc7a3c41$export$f0a5e0d6a7620156 : (_a = enhancer.limitPolicy) != null ? _a : $af401cd1bc7a3c41$export$f0a5e0d6a7620156;
        const enhancedValue = await limitPolicy(async ()=>enhancer.enhanceOne({
                parameter: parameter,
                parameterName: parameterName,
                component: component,
                context: context
            }));
        if (enhancedValue === null) delete component.parameters[parameterName];
        else if (typeof enhancedValue === "undefined") component.parameters[parameterName] = {
            ...parameter,
            value: parameter.value
        };
        else component.parameters[parameterName] = {
            ...parameter,
            value: enhancedValue
        };
    } catch (error) {
        const message = `Component ${$af401cd1bc7a3c41$export$934fe982cedca2f(componentContext)} (type: ${component.type}): enhancing parameter ${parameterName} (type: ${parameter.type}) threw exception. Parameter will be removed.`;
        delete component.parameters[parameterName];
        return {
            message: message,
            error: error
        };
    }
}
// src/enhancement/EnhancerBuilder.ts
var $af401cd1bc7a3c41$export$8ea072cdda86c373 = class {
    constructor(){
        this._paramMatches = Array();
        this._dataMatches = /* @__PURE__ */ new Map();
    }
    /** Targets an enhancer to modify the value of any parameter */ parameter(enhancer) {
        this._paramMatches.push({
            enhancer: this._resolveParameterEnhancer(enhancer)
        });
        return this;
    }
    /** Targets an enhancer to modify the value of any parameter with a specific name */ parameterName(name, enhancer) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name2)=>this._paramMatches.push({
                name: name2,
                enhancer: this._resolveParameterEnhancer(enhancer)
            }));
        return this;
    }
    /** Targets an enhancer to modify the value of any parameter with a specific type */ parameterType(type, enhancer) {
        const types = Array.isArray(type) ? type : [
            type
        ];
        types.forEach((type2)=>this._paramMatches.push({
                type: type2,
                enhancer: this._resolveParameterEnhancer(enhancer)
            }));
        return this;
    }
    /**
   * Targets an enhancer to set a specific object key on the component's `data` property.
   * Note: an exception will be thrown if the same key is registered more than once.
   */ data(name, enhancer) {
        if (this._dataMatches.has(name)) throw new Error(`${name} enhancer data key has been used more than once. This will cause data loss.`);
        this._dataMatches.set(name, typeof enhancer === "function" ? {
            enhanceOne: enhancer
        } : enhancer);
        return this;
    }
    /**
   * Resolves the parameter enhancer for a given parameter, if one exists.
   * The first matching enhancer by registration order is returned, if more than one could match.
   */ resolveParameterEnhancer(parameterName, parameter) {
        var _a;
        return (_a = this._paramMatches.find((m)=>m.name && m.name === parameterName || m.type && m.type === parameter.type || !m.type && !m.name)) == null ? void 0 : _a.enhancer;
    }
    /**
   * Resolves component enhancer(s) for a given component.
   * Returns a Map where the key is the name of the data property and the value is the enhancer.
   */ resolveComponentEnhancers() {
        return this._dataMatches;
    }
    _resolveParameterEnhancer(enhancer) {
        if (typeof enhancer === "function") return {
            enhanceOne: enhancer
        };
        else return enhancer;
    }
};
var $af401cd1bc7a3c41$export$367a729fad01195b = class {
    constructor(){
        this._componentIndex = {};
        this._rootBuilder = new $af401cd1bc7a3c41$export$8ea072cdda86c373();
    }
    /** Targets an enhancer to modify the value of any parameter */ parameter(enhancer) {
        this._rootBuilder.parameter(enhancer);
        return this;
    }
    /** Targets an enhancer to modify the value of any parameter with a specific name */ parameterName(name, enhancer) {
        this._rootBuilder.parameterName(name, enhancer);
        return this;
    }
    /** Targets an enhancer to modify the value of any parameter with a specific type */ parameterType(type, enhancer) {
        this._rootBuilder.parameterType(type, enhancer);
        return this;
    }
    /**
   * Targets an enhancer to set a specific object key on the component's `data` property.
   * Note: an exception will be thrown if the same key is registered more than once.
   */ data(name, enhancer) {
        this._rootBuilder.data(name, enhancer);
        return this;
    }
    /**
   * Targets a subset of enhancers at a specific component type.
   * Global enhancers will still be run if no matching enhancer is registered for this component's properties.
   */ component(name, builder) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name2)=>{
            this._componentIndex[name2] = this._componentIndex[name2] || new $af401cd1bc7a3c41$export$8ea072cdda86c373();
            builder(this._componentIndex[name2]);
        });
        return this;
    }
    /**
   * Resolves the parameter enhancer for a given parameter, if one exists.
   * The first matching enhancer by registration order is returned, if more than one could match.
   */ resolveParameterEnhancer(component, parameterName, parameter) {
        const eb = this._componentIndex[component.type];
        if (eb) {
            const targetedResolver = eb.resolveParameterEnhancer(parameterName, parameter);
            if (targetedResolver) return targetedResolver;
        }
        return this._rootBuilder.resolveParameterEnhancer(parameterName, parameter);
    }
    /**
   * Resolves component enhancer(s) for a given component.
   * Returns a Map where the key is the name of the data property and the value is the enhancer.
   */ resolveComponentEnhancers(component) {
        let componentEnhancers = this._rootBuilder.resolveComponentEnhancers();
        const eb = this._componentIndex[component.type];
        if (eb) {
            componentEnhancers = new Map(componentEnhancers);
            for (const [key, value] of eb.resolveComponentEnhancers())componentEnhancers.set(key, value);
        }
        return componentEnhancers;
    }
};
// src/enhancement/getComponentJsonPointer.ts
function $af401cd1bc7a3c41$export$d985bb13932f5794(ancestorsAndSelf) {
    const path = [];
    for(let i = ancestorsAndSelf.length - 1; i >= 0; i--){
        const currentLocation = ancestorsAndSelf[i];
        const parentLocation = ancestorsAndSelf[i + 1];
        if ("type" in currentLocation && currentLocation.type !== "slot") {
            if (currentLocation.type === "block") {
                const { fieldName: parameterName, blockIndexFn: blockIndexFn } = currentLocation;
                const blockIndex = blockIndexFn();
                if (parameterName && blockIndex !== void 0) {
                    const noun = $af401cd1bc7a3c41$export$b545d7f9b3adc117(parentLocation);
                    path.push(`${noun}/${parameterName}/value/${blockIndex}`);
                }
            }
            continue;
        }
        const parentSlotIndex = currentLocation.parentSlotIndexFn();
        const { parentSlot: parentSlot } = currentLocation;
        if (parentSlot && parentSlotIndex !== void 0) path.push(`slots/${parentSlot}/${parentSlotIndex}`);
    }
    return `/${path.join("/")}`;
}
function $af401cd1bc7a3c41$export$b545d7f9b3adc117(parentLocation) {
    let noun = "parameters";
    if (parentLocation && "type" in parentLocation) {
        if (parentLocation.type === "block" || $af401cd1bc7a3c41$export$724543431ab8008a(parentLocation)) noun = "fields";
    }
    return noun;
}
function $af401cd1bc7a3c41$export$c6178047051b9384(node) {
    let noun = "parameters";
    if ($af401cd1bc7a3c41$export$2dbc46ea47a0ba09(node)) noun = "fields";
    return noun;
}
// src/enhancement/findInNodeTree.ts
function $af401cd1bc7a3c41$export$52df5db1aa8d61f1(data, predicate) {
    const results = [];
    $af401cd1bc7a3c41$export$edadceaf63f106a9(data, ({ node: node, ancestorsAndSelf: ancestorsAndSelf })=>{
        const parameters = $af401cd1bc7a3c41$export$ac2195b73bd89f9(node);
        if (parameters) Object.entries(parameters).filter(([key, field])=>predicate(field, key, node)).forEach(([key, field])=>{
            results.push({
                key: key,
                pointer: (ancestorsAndSelf.length === 1 ? "" : $af401cd1bc7a3c41$export$d985bb13932f5794(ancestorsAndSelf)) + `/${$af401cd1bc7a3c41$export$c6178047051b9384(node)}/${key}`,
                parameter: field
            });
        });
    });
    return results;
}
// src/utils/variables/convertToBindExpression.ts
var $af401cd1bc7a3c41$export$6e9f8534e6b2dd2 = "#";
var $af401cd1bc7a3c41$export$ac3f846081c2b2e9 = /* @__PURE__ */ new Set([
    "#",
    "\\",
    "[",
    "]",
    ":"
]);
function $af401cd1bc7a3c41$export$33aaae65bc8bfa08(binding) {
    if (binding.syntax === "jptr") {
        const expressionComponents = [
            `${$af401cd1bc7a3c41$export$6e9f8534e6b2dd2}${binding.syntax}:${$af401cd1bc7a3c41$var$escapeNestedVariableExpressions($af401cd1bc7a3c41$var$escapeBindExpressionReservedChars(binding.pointer))}`
        ];
        if (binding.failureAction && binding.failureAction !== "t") expressionComponents.push(`fa=${binding.failureAction}`);
        if (binding.failureLogLevel && binding.failureLogLevel !== "w") expressionComponents.push(`fl=${binding.failureLogLevel}`);
        if (binding.failureDefault) expressionComponents.push(`fd=${$af401cd1bc7a3c41$export$c483094cb373ec93(binding.failureDefault)}`);
        return expressionComponents.join(":");
    }
    throw new Error(`Unsupported dynamic token binding syntax '${binding.syntax}'`);
}
function $af401cd1bc7a3c41$var$escapeNestedVariableExpressions(pointer) {
    return pointer.replace(/\$\{([^}]+)\}/g, "$[$1]");
}
function $af401cd1bc7a3c41$var$escapeBindExpressionReservedChars(pointer) {
    return pointer.split("").map((c)=>$af401cd1bc7a3c41$export$ac3f846081c2b2e9.has(c) ? `\\${c === ":" ? ";" : c}` : c).join("");
}
function $af401cd1bc7a3c41$export$c483094cb373ec93(defaultValue) {
    return $af401cd1bc7a3c41$var$escapeBindExpressionReservedChars(defaultValue).replace("=", "\\+");
}
// src/utils/variables/createVariableReference.ts
function $af401cd1bc7a3c41$export$3903215ff3a39d9c(variableName) {
    return `\${${variableName.replace(/([${}])/g, "\\$1")}}`;
}
// src/enhancement/getEffectivePropertyValue.ts
function $af401cd1bc7a3c41$export$8227f7ae78e45d99({ property: property, conditionIndex: conditionIndex, locale: locale, strict: strict, greedyLocaleMatching: greedyLocaleMatching }) {
    var _a, _b, _c, _d;
    if (!property) return void 0;
    let effectiveValue = property.value;
    if (conditionIndex >= 0) {
        const conditionalValue = (_b = (_a = property.conditions) == null ? void 0 : _a[conditionIndex]) == null ? void 0 : _b.value;
        if (conditionalValue === null) return void 0;
        if (conditionalValue !== void 0 || strict) effectiveValue = conditionalValue;
    }
    if (locale) {
        const localeValue = $af401cd1bc7a3c41$var$getLocaleMatch(property.locales, locale, greedyLocaleMatching);
        if (localeValue !== void 0 || strict) effectiveValue = localeValue;
        if (conditionIndex >= 0) {
            const localeConditionalValue = (_d = (_c = $af401cd1bc7a3c41$var$getLocaleMatch(property.localesConditions, locale, greedyLocaleMatching)) == null ? void 0 : _c[conditionIndex]) == null ? void 0 : _d.value;
            if (localeConditionalValue === null) return void 0;
            if (localeConditionalValue !== void 0 || strict) effectiveValue = localeConditionalValue;
        }
    }
    if (property.connectedData) effectiveValue = $af401cd1bc7a3c41$export$3903215ff3a39d9c($af401cd1bc7a3c41$export$33aaae65bc8bfa08(property.connectedData));
    return effectiveValue;
}
function $af401cd1bc7a3c41$var$getLocaleMatch(index, locale, greedy) {
    if (!index) return void 0;
    const match = index[locale];
    if (match === void 0 && greedy) return Object.values(index)[0];
    return match;
}
// src/enhancement/visibility/evaluateVisibilityCriteriaGroup.ts
function $af401cd1bc7a3c41$export$a15e60ee03baddab(options) {
    const { criteriaGroup: criteriaGroup, simplifyCriteria: simplifyCriteria } = options;
    const earlyExitResult = criteriaGroup.op === "&" || !criteriaGroup.op ? false : true;
    let hasIndeterminateClauses = false;
    for(let index = criteriaGroup.clauses.length - 1; index >= 0; index--){
        const clause = criteriaGroup.clauses[index];
        const criteriaResult = $af401cd1bc7a3c41$var$evaluateCriterion(clause, options);
        if (criteriaResult === null) hasIndeterminateClauses = true;
        else if (criteriaResult === earlyExitResult) return earlyExitResult;
        else if (criteriaResult !== null && simplifyCriteria) criteriaGroup.clauses.splice(index, 1);
    }
    return hasIndeterminateClauses ? null : !earlyExitResult;
}
function $af401cd1bc7a3c41$var$evaluateCriterion(clause, rootOptions) {
    var _a;
    if ("clauses" in clause) return $af401cd1bc7a3c41$export$a15e60ee03baddab({
        ...rootOptions,
        criteriaGroup: clause
    });
    const lhs = (_a = clause.source) != null ? _a : clause.rule;
    const rhs = Array.isArray(clause.value) ? clause.value : clause.value !== void 0 ? [
        clause.value
    ] : void 0;
    if (typeof lhs === "string" && $af401cd1bc7a3c41$export$181bc3bc0bea1e05(lhs) > 0 || (rhs == null ? void 0 : rhs.some((rhv)=>typeof rhv === "string" && $af401cd1bc7a3c41$export$181bc3bc0bea1e05(rhv) > 0))) return null;
    const rule = rootOptions.rules[clause.rule];
    if (rule) return rule(clause);
    return null;
}
// src/enhancement/visibility/evaluateNodeVisibilityParameter.ts
function $af401cd1bc7a3c41$export$bf353be0f0a7b99e({ parameter: parameter, ...evaluateGroupOptions }) {
    if (parameter == null ? void 0 : parameter.explicitlyHidden) return false;
    if (!(parameter == null ? void 0 : parameter.criteria)) return true;
    const result = $af401cd1bc7a3c41$export$a15e60ee03baddab({
        ...evaluateGroupOptions,
        criteriaGroup: parameter.criteria
    });
    return result;
}
// src/enhancement/visibility/evaluatePropertyCriteria.ts
function $af401cd1bc7a3c41$export$f9a41a3e541643ae({ baseValue: baseValue, conditionalValues: conditionalValues, keepIndeterminate: keepIndeterminate, ...evaluateGroupOptions }) {
    let authoritative = true;
    const result = {
        currentValue: baseValue,
        remainingConditionalValues: evaluateGroupOptions.simplifyCriteria && conditionalValues ? [
            ...conditionalValues
        ] : conditionalValues,
        currentConditionIndex: -1
    };
    if (!conditionalValues) return result;
    const conditionIndexesToRemove = [];
    for(let i = 0; i < conditionalValues.length; i++){
        const conditionalVariant = conditionalValues[i];
        if (result.matched) {
            conditionIndexesToRemove.push(i);
            continue;
        }
        const evaluationResult = $af401cd1bc7a3c41$export$a15e60ee03baddab({
            ...evaluateGroupOptions,
            criteriaGroup: conditionalVariant.when
        });
        if (evaluationResult === null) {
            if (keepIndeterminate) authoritative = false;
            else conditionIndexesToRemove.push(i);
        } else if (evaluationResult === true) {
            result.matched = conditionalVariant;
            result.currentValue = conditionalVariant.value;
            result.currentConditionIndex = i;
            conditionIndexesToRemove.push(i);
        } else conditionIndexesToRemove.push(i);
    }
    if (evaluateGroupOptions.simplifyCriteria) for(let i = conditionIndexesToRemove.length - 1; i >= 0; i--)result.remainingConditionalValues.splice(conditionIndexesToRemove[i], 1);
    if (authoritative) result.remainingConditionalValues = void 0;
    return result;
}
// src/enhancement/visibility/types.ts
var $af401cd1bc7a3c41$export$a8970c65192cae4c = "$viz";
// src/enhancement/visibility/evaluateNodeVisibility.ts
function $af401cd1bc7a3c41$var$evaluateNodeVisibility({ node: node, ...evaluateGroupOptions }) {
    var _a;
    const properties = $af401cd1bc7a3c41$export$ac2195b73bd89f9(node);
    const vizCriteria = (_a = properties == null ? void 0 : properties[$af401cd1bc7a3c41$export$a8970c65192cae4c]) == null ? void 0 : _a.value;
    const result = $af401cd1bc7a3c41$export$bf353be0f0a7b99e({
        ...evaluateGroupOptions,
        parameter: vizCriteria
    });
    if ((vizCriteria == null ? void 0 : vizCriteria.criteria) && vizCriteria.criteria.clauses.length === 0 && evaluateGroupOptions.simplifyCriteria) properties == null || delete properties[$af401cd1bc7a3c41$export$a8970c65192cae4c];
    return result;
}
// src/enhancement/visibility/evaluateWalkTreeNodeVisibility.ts
function $af401cd1bc7a3c41$export$28d93765f76623c({ rules: rules, showIndeterminate: showIndeterminate, rootNodeInvisibleHandling: rootNodeInvisibleHandling = "throw", context: context }) {
    const { type: type, node: node, actions: actions, ancestorsAndSelf: ancestorsAndSelf } = context;
    if (type !== "component") return true;
    const result = $af401cd1bc7a3c41$var$evaluateNodeVisibility({
        node: node,
        rules: rules,
        simplifyCriteria: true
    });
    if (result === null && !showIndeterminate || result === false) {
        if (ancestorsAndSelf.length === 1 && rootNodeInvisibleHandling === "ignore") ;
        else actions.remove();
        return false;
    }
    return true;
}
// src/enhancement/visibility/evaluateWalkTreePropertyCriteria.ts
function $af401cd1bc7a3c41$export$bc8380d589ae0dbd({ rules: rules, node: node, keepIndeterminate: keepIndeterminate }) {
    const properties = $af401cd1bc7a3c41$export$ac2195b73bd89f9(node);
    if (!properties) return;
    Object.entries(properties).forEach(([propertyName, property])=>{
        var _a, _b, _c;
        if (property.locales || property.localesConditions) {
            const localesDefined = [
                ...Object.keys((_a = property.locales) != null ? _a : {}),
                ...Object.keys((_b = property.localesConditions) != null ? _b : {})
            ];
            localesDefined.forEach((locale)=>{
                var _a2, _b2, _c2, _d, _e, _f;
                const { currentValue: currentValue, remainingConditionalValues: remainingConditionalValues } = $af401cd1bc7a3c41$export$f9a41a3e541643ae({
                    baseValue: (_a2 = property.locales) == null ? void 0 : _a2[locale],
                    conditionalValues: (_b2 = property.localesConditions) == null ? void 0 : _b2[locale],
                    rules: rules,
                    simplifyCriteria: true,
                    keepIndeterminate: keepIndeterminate
                });
                if (currentValue === null || currentValue === void 0) (_c2 = property.locales) == null || delete _c2[locale];
                else {
                    (_d = property.locales) != null ? _d : property.locales = {};
                    property.locales[locale] = currentValue;
                }
                if (!(remainingConditionalValues == null ? void 0 : remainingConditionalValues.length)) (_e = property.localesConditions) == null || delete _e[locale];
                else {
                    (_f = property.localesConditions) != null ? _f : property.localesConditions = {};
                    property.localesConditions[locale] = remainingConditionalValues;
                }
            });
            if (!Object.keys((_c = property.localesConditions) != null ? _c : {}).length) delete property.localesConditions;
            if (!property.locales && !property.localesConditions) delete properties[propertyName];
        } else {
            const { currentValue: currentValue, remainingConditionalValues: remainingConditionalValues } = $af401cd1bc7a3c41$export$f9a41a3e541643ae({
                baseValue: property.value,
                conditionalValues: property.conditions,
                rules: rules,
                simplifyCriteria: true,
                keepIndeterminate: keepIndeterminate
            });
            if (currentValue === null) delete properties[propertyName];
            else if (currentValue !== void 0) property.value = currentValue;
            else delete property.value;
            if (remainingConditionalValues === void 0) delete property.conditions;
            else property.conditions = remainingConditionalValues;
        }
    });
}
// src/enhancement/visibility/rules/evaluateStringMatch.ts
var $af401cd1bc7a3c41$var$isEvaluator = (criteria, matchValue)=>{
    if (Array.isArray(criteria)) return criteria.includes(matchValue);
    return criteria === matchValue;
};
var $af401cd1bc7a3c41$var$containsEvaluator = (criteria, matchValue)=>{
    if (Array.isArray(criteria)) return criteria.some((criterion)=>matchValue.includes(criterion));
    return matchValue.includes(criteria);
};
var $af401cd1bc7a3c41$var$startsWithEvaluator = (criteria, matchValue)=>{
    if (Array.isArray(criteria)) return criteria.some((criterion)=>matchValue.startsWith(criterion));
    return matchValue.startsWith(criteria);
};
var $af401cd1bc7a3c41$var$endsWithEvaluator = (criteria, matchValue)=>{
    if (Array.isArray(criteria)) return criteria.some((criterion)=>matchValue.endsWith(criterion));
    return matchValue.endsWith(criteria);
};
var $af401cd1bc7a3c41$var$emptyEvaluator = (_, matchValue)=>{
    return matchValue === "";
};
var $af401cd1bc7a3c41$var$stringOperatorEvaluators = {
    is: $af401cd1bc7a3c41$var$isEvaluator,
    has: $af401cd1bc7a3c41$var$containsEvaluator,
    startswith: $af401cd1bc7a3c41$var$startsWithEvaluator,
    endswith: $af401cd1bc7a3c41$var$endsWithEvaluator,
    empty: $af401cd1bc7a3c41$var$emptyEvaluator
};
function $af401cd1bc7a3c41$var$evaluateStringMatch(criteria, matchValue, allow) {
    const { op: op, value: value } = criteria;
    if (allow && !allow.has(op)) return null;
    let opMatch = op;
    const negation = op.startsWith("!");
    if (negation) opMatch = opMatch.slice(1);
    const evaluator = $af401cd1bc7a3c41$var$stringOperatorEvaluators[opMatch];
    if (!evaluator) return null;
    const result = evaluator(value, matchValue);
    return negation ? !result : result;
}
// src/enhancement/visibility/rules/createDynamicInputVisibilityRule.ts
var $af401cd1bc7a3c41$var$dynamicInputVisibilityOperators = /* @__PURE__ */ new Set([
    "is",
    "!is",
    "has",
    "!has",
    "startswith",
    "!startswith",
    "endswith",
    "!endswith",
    "empty",
    "!empty"
]);
var $af401cd1bc7a3c41$export$a7d93b6b1543223a = "$di";
function $af401cd1bc7a3c41$export$8267c522d69994cb(dynamicInputs) {
    return {
        [$af401cd1bc7a3c41$export$a7d93b6b1543223a]: (criterion)=>{
            const { source: source } = criterion;
            const diValue = source ? dynamicInputs[source] : void 0;
            return $af401cd1bc7a3c41$var$evaluateStringMatch(criterion, diValue != null ? diValue : "", $af401cd1bc7a3c41$var$dynamicInputVisibilityOperators);
        }
    };
}
// src/enhancement/visibility/rules/createDynamicTokenVisibilityRule.ts
var $af401cd1bc7a3c41$var$dynamicTokenVisibilityOperators = /* @__PURE__ */ new Set([
    "is",
    "!is",
    "has",
    "!has",
    "startswith",
    "!startswith",
    "endswith",
    "!endswith",
    "empty",
    "!empty"
]);
var $af401cd1bc7a3c41$export$fd62276f7d250474 = "$dt";
function $af401cd1bc7a3c41$export$9afae0a340d12923() {
    return {
        [$af401cd1bc7a3c41$export$fd62276f7d250474]: (criterion)=>{
            var _a;
            if (typeof criterion.source !== "string" || $af401cd1bc7a3c41$export$181bc3bc0bea1e05(criterion.source)) return null;
            return $af401cd1bc7a3c41$var$evaluateStringMatch(criterion, (_a = criterion.source) != null ? _a : "", $af401cd1bc7a3c41$var$dynamicTokenVisibilityOperators);
        }
    };
}
// src/enhancement/visibility/rules/createLocaleVisibilityRule.ts
var $af401cd1bc7a3c41$var$localeVisibilityOperators = /* @__PURE__ */ new Set([
    "is",
    "!is"
]);
var $af401cd1bc7a3c41$export$e3c9142c41e23904 = "$locale";
function $af401cd1bc7a3c41$export$a0ee1f478c2b629a(currentLocale) {
    return {
        [$af401cd1bc7a3c41$export$e3c9142c41e23904]: (criterion)=>{
            if (!currentLocale) return false;
            return $af401cd1bc7a3c41$var$evaluateStringMatch(criterion, currentLocale, $af401cd1bc7a3c41$var$localeVisibilityOperators);
        }
    };
}
// src/enhancement/visibility/rules/createQuirksVisibilityRule.ts
var $af401cd1bc7a3c41$var$quirksVisibilityOperators = /* @__PURE__ */ new Set([
    "is",
    "!is",
    "has",
    "!has",
    "startswith",
    "!startswith",
    "endswith",
    "!endswith",
    "empty",
    "!empty"
]);
var $af401cd1bc7a3c41$export$11d56ccabde51402 = "$qk";
function $af401cd1bc7a3c41$export$92a9faf2ed02d83b(quirks) {
    return {
        [$af401cd1bc7a3c41$export$11d56ccabde51402]: (criterion)=>{
            const { source: source } = criterion;
            const quirkValue = source ? quirks[source] : void 0;
            return $af401cd1bc7a3c41$var$evaluateStringMatch(criterion, quirkValue != null ? quirkValue : "", $af401cd1bc7a3c41$var$quirksVisibilityOperators);
        }
    };
}
// src/enhancement/localize.ts
function $af401cd1bc7a3c41$export$3b6a484e0748b845({ component: component }) {
    var _a;
    const variations = {};
    const slot = (_a = component.slots) == null ? void 0 : _a[$af401cd1bc7a3c41$export$6ba47e5f98556fde];
    slot == null || slot.forEach((slotComponent)=>{
        var _a2;
        const localeParameter = (_a2 = slotComponent.parameters) == null ? void 0 : _a2[$af401cd1bc7a3c41$export$58a1b975993a5f83];
        if ((localeParameter == null ? void 0 : localeParameter.value) && typeof localeParameter.value === "string") {
            variations[localeParameter.value] = variations[localeParameter.value] || [];
            variations[localeParameter.value].push(slotComponent);
        }
    });
    return variations;
}
function $af401cd1bc7a3c41$export$b3bd0bc58e36cd63(options) {
    const nodes = options.nodes;
    const locale = options.locale;
    if (!locale) return;
    const vizControlLocaleRule = $af401cd1bc7a3c41$export$a0ee1f478c2b629a(locale);
    $af401cd1bc7a3c41$export$edadceaf63f106a9(nodes, (context)=>{
        const { type: type, node: node, actions: actions } = context;
        if (type !== "component") {
            $af401cd1bc7a3c41$var$localizeProperties(node, locale, vizControlLocaleRule);
            return;
        }
        const result = $af401cd1bc7a3c41$export$28d93765f76623c({
            context: context,
            rules: vizControlLocaleRule,
            showIndeterminate: true,
            rootNodeInvisibleHandling: "ignore"
        });
        if (!result) return;
        if (node.type === $af401cd1bc7a3c41$export$9656110639e729a7) {
            const locales = $af401cd1bc7a3c41$export$3b6a484e0748b845({
                component: node
            });
            let replaceComponent;
            if (locale) replaceComponent = locales[locale];
            if (replaceComponent == null ? void 0 : replaceComponent.length) {
                replaceComponent.forEach((component)=>{
                    $af401cd1bc7a3c41$var$removeLocaleProperty(component);
                    $af401cd1bc7a3c41$var$localizeProperties(component, locale, vizControlLocaleRule);
                });
                const [first, ...rest] = replaceComponent;
                actions.replace(first);
                if (rest.length) actions.insertAfter(rest);
            } else actions.remove();
        } else $af401cd1bc7a3c41$var$localizeProperties(node, locale, vizControlLocaleRule);
    });
}
function $af401cd1bc7a3c41$var$removeLocaleProperty(component) {
    const properties = $af401cd1bc7a3c41$export$ac2195b73bd89f9(component);
    const localeTagProperty = properties == null ? void 0 : properties[$af401cd1bc7a3c41$export$58a1b975993a5f83];
    if (localeTagProperty) delete properties[$af401cd1bc7a3c41$export$58a1b975993a5f83];
    if (properties && Object.keys(properties).length === 0) {
        if ("fields" in component) delete component.fields;
        if ("parameters" in component) delete component.parameters;
    }
}
function $af401cd1bc7a3c41$var$localizeProperties(node, locale, rules) {
    const properties = $af401cd1bc7a3c41$export$ac2195b73bd89f9(node);
    if (!properties) return void 0;
    Object.entries(properties).forEach(([propertyId, propertyValue])=>{
        var _a, _b;
        if (!locale) {
            delete propertyValue.locales;
            delete propertyValue.localesConditions;
        }
        const currentLocaleValue = locale ? (_a = propertyValue.locales) == null ? void 0 : _a[locale] : void 0;
        if (currentLocaleValue !== void 0) propertyValue.value = currentLocaleValue;
        const currentLocaleConditionalValues = locale ? (_b = propertyValue.localesConditions) == null ? void 0 : _b[locale] : void 0;
        if (currentLocaleConditionalValues !== void 0) propertyValue.conditions = currentLocaleConditionalValues;
        delete propertyValue.locales;
        delete propertyValue.localesConditions;
        if (propertyValue.value === void 0 && propertyValue.conditions === void 0) delete properties[propertyId];
    });
    $af401cd1bc7a3c41$export$bc8380d589ae0dbd({
        node: node,
        rules: rules,
        keepIndeterminate: true
    });
}
// src/enhancement/UniqueBatchEntries.ts
var $af401cd1bc7a3c41$export$cc56ac7a9ba543ff = class {
    constructor(entries, uniqueKeySelector){
        this.groups = entries.reduce((acc, task)=>{
            var _a;
            const key = uniqueKeySelector(task.args);
            acc[key] = (_a = acc[key]) != null ? _a : [];
            acc[key].push(task);
            return acc;
        }, {});
    }
    /** Resolves all entries in a group key with the same result value. */ resolveKey(key, result) {
        this.groups[key].forEach((task)=>task.resolve(result));
    }
    /** Resolves all remaining entries that have not been otherwise resolved with a specific value */ resolveRemaining(value) {
        Object.keys(this.groups).forEach((key)=>{
            this.groups[key].forEach((task)=>{
                if (!task.isCompleted) task.resolve(value);
            });
        });
    }
};
// src/enhancement/walkPropertyValues.ts
function $af401cd1bc7a3c41$export$d2d095414e586da(property, visitor) {
    var _a, _b;
    const definedLocales = /* @__PURE__ */ new Set([
        ...Object.keys((_a = property.locales) != null ? _a : {}),
        ...Object.keys((_b = property.localesConditions) != null ? _b : {})
    ]);
    const propertyLocales = [
        void 0,
        ...definedLocales
    ];
    propertyLocales.forEach((locale)=>{
        var _a2, _b2;
        const conditionalValues = (_b2 = locale === void 0 ? property.conditions : (_a2 = property.localesConditions) == null ? void 0 : _a2[locale]) != null ? _b2 : [];
        for(let conditionIndex = conditionalValues.length - 1; conditionIndex >= -1; conditionIndex--){
            const value = $af401cd1bc7a3c41$export$8227f7ae78e45d99({
                property: property,
                locale: locale,
                conditionIndex: conditionIndex,
                strict: true
            });
            visitor({
                locale: locale,
                conditionIndex: conditionIndex,
                value: value
            });
        }
    });
}
var $af401cd1bc7a3c41$var$releaseContentsUrl = "/api/v1/entity-releases";
var $af401cd1bc7a3c41$export$57c26a0073c63d77 = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches entity across all releases (and base) */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$releaseContentsUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
};
var $af401cd1bc7a3c41$var$_baseUrl;
var $af401cd1bc7a3c41$var$_IntegrationPropertyEditorsClient = class _IntegrationPropertyEditorsClient extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
        this.teamId = options.teamId;
    }
    /**
   * Gets a list of property type and hook names for the current team, including public integrations' hooks.
   */ get(options) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_IntegrationPropertyEditorsClient, $af401cd1bc7a3c41$var$_baseUrl), {
            ...options,
            teamId: this.teamId
        });
        return this.apiClient(fetchUri);
    }
    /**
   * Creates or updates a custom AI property editor on a Mesh app.
   */ async deploy(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_IntegrationPropertyEditorsClient, $af401cd1bc7a3c41$var$_baseUrl));
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                teamId: this.teamId
            }),
            expectNoContent: true
        });
    }
    /**
   * Removes a custom AI property editor from a Mesh app.
   */ async delete(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_IntegrationPropertyEditorsClient, $af401cd1bc7a3c41$var$_baseUrl));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                teamId: this.teamId
            }),
            expectNoContent: true
        });
    }
};
$af401cd1bc7a3c41$var$_baseUrl = new WeakMap();
$af401cd1bc7a3c41$var$__privateAdd($af401cd1bc7a3c41$var$_IntegrationPropertyEditorsClient, $af401cd1bc7a3c41$var$_baseUrl, "/api/v1/integration-property-editors");
var $af401cd1bc7a3c41$export$48660e948d1f10d3 = $af401cd1bc7a3c41$var$_IntegrationPropertyEditorsClient;
var $af401cd1bc7a3c41$var$localesUrl = "/api/v1/locales";
var $af401cd1bc7a3c41$export$90db114dc5a17540 = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches all locales for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$localesUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a locale */ async upsert(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$localesUrl);
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a locale */ async remove(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$localesUrl);
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
// src/utils/hash.ts
var $af401cd1bc7a3c41$export$daf4c137c5f56404 = ({ composition: composition, secret: secret })=>{
    if (!secret) return void 0;
    const str = `${JSON.stringify(composition)}-${secret}`;
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
};
// src/messaging/channel.ts
var $af401cd1bc7a3c41$export$3fc9223289e5c88 = (message)=>{
    return message.type === "select-component" && message.id !== void 0;
};
var $af401cd1bc7a3c41$export$c4578088774ce38 = (message)=>{
    return message.type === "ready";
};
var $af401cd1bc7a3c41$export$e882912e74180a4 = (message)=>{
    return message.type === "trigger-component-action";
};
var $af401cd1bc7a3c41$export$90df1ed5f44b70af = (message)=>{
    return message.type === "update-composition";
};
var $af401cd1bc7a3c41$export$9f35164c015f8c5b = (message)=>{
    return message.type === "update-composition-internal";
};
var $af401cd1bc7a3c41$export$23813a8e58016e5d = (message)=>{
    return message.type === "add-component";
};
var $af401cd1bc7a3c41$export$60b3943a60454309 = (message)=>{
    return message.type === "move-component";
};
var $af401cd1bc7a3c41$export$632f45dd2eaa53bc = (message)=>{
    return message.type === "update-component-parameter";
};
var $af401cd1bc7a3c41$export$3beb5538f991cb5f = (message)=>{
    return message.type === "dismiss-placeholder";
};
var $af401cd1bc7a3c41$export$1a50137c104094c3 = (message)=>{
    return message.type === "trigger-composition-action";
};
var $af401cd1bc7a3c41$export$152f7bfc02d5556a = (message)=>{
    return message.type === "update-preview-settings";
};
var $af401cd1bc7a3c41$export$162d69a4875b9f9a = (message)=>{
    return message.type === "update-feature-flags";
};
var $af401cd1bc7a3c41$export$42af5cc3350b1721 = (message)=>{
    return message.type === "update-ai-actions";
};
var $af401cd1bc7a3c41$export$f3b512beb9ef7726 = (message)=>{
    return message.type === "update-contextual-editing-state-internal";
};
var $af401cd1bc7a3c41$export$42cdd5cb405ac49e = (message)=>{
    return message.type === "report-rendered-compositions";
};
var $af401cd1bc7a3c41$export$6ad141f6785257a7 = (message)=>{
    return message.type === "select-parameter";
};
var $af401cd1bc7a3c41$export$882e0fd421a0f927 = (message)=>{
    return message.type === "open-parameter-editor";
};
var $af401cd1bc7a3c41$export$db4eff925babdd20 = (message)=>{
    return message.type === "update-component-references";
};
var $af401cd1bc7a3c41$export$e78170945585ae91 = (message)=>{
    return message.type === "request-component-suggestion";
};
var $af401cd1bc7a3c41$export$d9a3ab49d95611e8 = (message)=>{
    return message.type === "suggest-component";
};
var $af401cd1bc7a3c41$export$778d4d7ed09b38a8 = (message)=>{
    return message.type === "context-storage-command-executed";
};
var $af401cd1bc7a3c41$export$19ed7e48ee6f59a7 = ({ listenTo: listenTo, broadcastTo: broadcastTo })=>{
    let handlerCounter = 0;
    const handlers = {};
    const broadcastToItems = [
        ...broadcastTo
    ];
    const postMessage = (message)=>{
        broadcastToItems.forEach((item)=>item == null ? void 0 : item.postMessage(JSON.stringify(message), "*"));
        for(const handlerId in handlers){
            const handler = handlers[handlerId];
            if (handler.types.includes(message.type)) handler.handler(message, new MessageEvent(message.type));
        }
    };
    const selectComponent = (id)=>{
        const message = {
            type: "select-component",
            id: id
        };
        postMessage(message);
    };
    const ready = (options)=>{
        var _a, _b, _c;
        if (typeof window === "undefined") return;
        const framework = (_a = window.__UNIFORM_CONTEXTUAL_EDITING__) == null ? void 0 : _a.framework;
        const version2 = (_b = window.__UNIFORM_CONTEXTUAL_EDITING__) == null ? void 0 : _b.version;
        const canvasPackageVersion = (_c = window.__UNIFORM_CONTEXTUAL_EDITING__) == null ? void 0 : _c.canvasPackageVersion;
        const message = {
            type: "ready",
            framework: framework,
            version: version2,
            rsc: options == null ? void 0 : options.rsc,
            canvasPackageVersion: canvasPackageVersion
        };
        postMessage(message);
    };
    const on = (types, handler)=>{
        const handlerId = ++handlerCounter;
        handlers[handlerId] = {
            types: Array.isArray(types) ? types : [
                types
            ],
            handler: handler
        };
        return ()=>{
            delete handlers[handlerId];
        };
    };
    const updateComposition = (composition, secret)=>{
        const message = {
            type: "update-composition",
            composition: composition,
            hash: $af401cd1bc7a3c41$export$daf4c137c5f56404({
                composition: composition,
                secret: secret
            }),
            eventTimestamp: Date.now()
        };
        postMessage(message);
    };
    const updateCompositionInternal = (composition, hash, eventTimestamp)=>{
        const message = {
            type: "update-composition-internal",
            composition: composition,
            hash: hash,
            eventTimestamp: eventTimestamp != null ? eventTimestamp : Date.now()
        };
        postMessage(message);
    };
    const triggerComponentAction = (options)=>{
        const message = {
            ...options,
            type: "trigger-component-action"
        };
        postMessage(message);
    };
    const addComponent = (options)=>{
        const message = {
            ...options,
            type: "add-component"
        };
        postMessage(message);
    };
    const moveComponent = (options)=>{
        const message = {
            ...options,
            type: "move-component"
        };
        postMessage(message);
    };
    const updateComponentParameter = (options)=>{
        const message = {
            ...options,
            type: "update-component-parameter"
        };
        postMessage(message);
    };
    const dismissPlaceholder = (options)=>{
        const message = {
            ...options,
            type: "dismiss-placeholder"
        };
        postMessage(message);
    };
    const triggerCompositionAction = (options)=>{
        const message = {
            ...options,
            type: "trigger-composition-action"
        };
        postMessage(message);
    };
    const updatePreviewSettings = (options)=>{
        const message = {
            ...options,
            type: "update-preview-settings"
        };
        postMessage(message);
    };
    const requestPageHtml = (options)=>{
        const message = {
            ...options,
            type: "request-page-html"
        };
        postMessage(message);
    };
    const sendPageHtml = (options)=>{
        const message = {
            ...options,
            type: "send-page-html"
        };
        postMessage(message);
    };
    const updateContextualEditingStateInternal = (options)=>{
        const message = {
            ...options,
            type: "update-contextual-editing-state-internal"
        };
        postMessage(message);
    };
    const reportRenderedCompositions = (options)=>{
        const message = {
            ...options,
            type: "report-rendered-compositions"
        };
        postMessage(message);
    };
    const selectParameter = (options)=>{
        const message = {
            ...options,
            type: "select-parameter"
        };
        postMessage(message);
    };
    const openParameterEditor = (options)=>{
        const message = {
            ...options,
            type: "open-parameter-editor"
        };
        postMessage(message);
    };
    const editorStateUpdated = ()=>{
        const message = {
            type: "editor-state-updated"
        };
        postMessage(message);
    };
    const updateComponentReferences = (options)=>{
        const message = {
            ...options,
            type: "update-component-references"
        };
        postMessage(message);
    };
    const requestComponentSuggestion = (options)=>{
        const message = {
            ...options,
            type: "request-component-suggestion"
        };
        postMessage(message);
    };
    const suggestComponent = (options)=>{
        const message = {
            ...options,
            type: "suggest-component"
        };
        postMessage(message);
    };
    const updateFeatureFlags = (options)=>{
        const message = {
            ...options,
            type: "update-feature-flags"
        };
        postMessage(message);
    };
    const updateAiActions = (options)=>{
        const message = {
            ...options,
            type: "update-ai-actions"
        };
        postMessage(message);
    };
    const contextStorageUpdated = (options)=>{
        const message = {
            ...options,
            type: "context-storage-command-executed"
        };
        postMessage(message);
    };
    const messageEventListener = (event)=>{
        if (typeof event.data !== "string") return;
        let message = null;
        try {
            const parsedMessage = JSON.parse(event.data);
            if (Object.hasOwn(parsedMessage, "type")) message = parsedMessage;
        } catch (e) {}
        if (!message) return;
        for(const handlerId in handlers){
            const handler = handlers[handlerId];
            if (handler.types.includes(message.type)) handler.handler(message, event);
        }
    };
    listenTo.forEach((item)=>item.addEventListener("message", messageEventListener));
    const destroy = ()=>{
        listenTo.forEach((item)=>item.removeEventListener("message", messageEventListener));
    };
    return {
        broadcastTo: broadcastTo,
        ready: ready,
        destroy: destroy,
        triggerComponentAction: triggerComponentAction,
        selectComponent: selectComponent,
        updateComposition: updateComposition,
        updateCompositionInternal: updateCompositionInternal,
        on: on,
        addComponent: addComponent,
        moveComponent: moveComponent,
        updateComponentParameter: updateComponentParameter,
        dismissPlaceholder: dismissPlaceholder,
        triggerCompositionAction: triggerCompositionAction,
        updatePreviewSettings: updatePreviewSettings,
        updateFeatureFlags: updateFeatureFlags,
        updateAiActions: updateAiActions,
        updateContextualEditingStateInternal: updateContextualEditingStateInternal,
        selectParameter: selectParameter,
        openParameterEditor: openParameterEditor,
        reportRenderedCompositions: reportRenderedCompositions,
        editorStateUpdated: editorStateUpdated,
        updateComponentReferences: updateComponentReferences,
        requestComponentSuggestion: requestComponentSuggestion,
        suggestComponent: suggestComponent,
        requestPageHtml: requestPageHtml,
        sendPageHtml: sendPageHtml,
        contextStorageUpdated: contextStorageUpdated
    };
};
var $af401cd1bc7a3c41$var$previewUrlsUrl = "/api/v1/preview-urls";
var $af401cd1bc7a3c41$var$previewViewportsUrl = "/api/v1/preview-viewports";
var $af401cd1bc7a3c41$export$1b989cd273caeb75 = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches a preview URL by ID */ async getPreviewUrl({ id: id }) {
        var _a;
        const result = await this.getPreviewUrls({
            id: id
        });
        return (_a = result.previewUrls[0]) != null ? _a : null;
    }
    /** Fetches all preview URLs for a project */ async getPreviewUrls(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$previewUrlsUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Creates or updates a preview URL */ async upsertPreviewUrl(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$previewUrlsUrl);
        return await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            })
        });
    }
    /** Deletes a preview URL */ async deletePreviewUrl(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$previewUrlsUrl);
        return await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            })
        });
    }
    /** Fetches a preview viewport by ID */ async getPreviewViewport({ id: id }) {
        var _a;
        const result = await this.getPreviewViewports({
            id: id
        });
        return (_a = result.previewViewports[0]) != null ? _a : null;
    }
    /** Fetches all preview viewports for a project */ async getPreviewViewports(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$previewViewportsUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Creates or updates a preview viewport */ async upsertPreviewViewport(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$previewViewportsUrl);
        return await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            })
        });
    }
    /** Deletes a preview viewport */ async deletePreviewViewport(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$previewViewportsUrl);
        return await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            })
        });
    }
};
var $af401cd1bc7a3c41$var$_url2;
var $af401cd1bc7a3c41$var$_ProjectClient = class _ProjectClient extends (0, $hAokw.ApiClient) {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
    /** Fetches single Project */ async get(options) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ProjectClient, $af401cd1bc7a3c41$var$_url2), {
            ...options
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a Project */ async upsert(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ProjectClient, $af401cd1bc7a3c41$var$_url2));
        return await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body
            })
        });
    }
    /** Deletes a Project */ async delete(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$__privateGet(_ProjectClient, $af401cd1bc7a3c41$var$_url2));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body
            }),
            expectNoContent: true
        });
    }
};
$af401cd1bc7a3c41$var$_url2 = new WeakMap();
$af401cd1bc7a3c41$var$__privateAdd($af401cd1bc7a3c41$var$_ProjectClient, $af401cd1bc7a3c41$var$_url2, "/api/v1/project");
var $af401cd1bc7a3c41$export$b9d177aefa060cdc = $af401cd1bc7a3c41$var$_ProjectClient;
var $af401cd1bc7a3c41$var$PromptsUrl = "/api/v1/prompts";
var $af401cd1bc7a3c41$export$8808d97f0df7c70e = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches Prompts for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$PromptsUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a Prompt */ async upsert(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$PromptsUrl);
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a Prompt */ async remove(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$PromptsUrl);
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
var $af401cd1bc7a3c41$var$RELATIONSHIPS_URL = "/api/v1/relationships";
var $af401cd1bc7a3c41$export$52cc5e52614e77d9 = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
        this.get = async (options)=>{
            const { projectId: projectId } = this.options;
            const url = this.createUrl($af401cd1bc7a3c41$var$RELATIONSHIPS_URL, {
                ...options,
                projectId: projectId
            });
            return this.apiClient(url);
        };
    }
};
var $af401cd1bc7a3c41$var$releasesUrl = "/api/v1/releases";
var $af401cd1bc7a3c41$export$bc4f9cb70d319e44 = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches all releases for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$releasesUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a release */ async upsert(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$releasesUrl);
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a release */ async remove(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$releasesUrl);
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Readies or unreadies a release for merging */ async ready(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$releasesUrl);
        await this.apiClient(fetchUri, {
            method: "PATCH",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
var $af401cd1bc7a3c41$var$releaseContentsUrl2 = "/api/v1/release-contents";
var $af401cd1bc7a3c41$export$68e8a4bc76dd9118 = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches all entities added to a release */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$releaseContentsUrl2, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Removes a release content from a release */ async remove(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$releaseContentsUrl2);
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
var $af401cd1bc7a3c41$var$ROUTE_URL = "/api/v1/route";
var $af401cd1bc7a3c41$export$f9dbf2820a922e5c = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        var _a;
        if (!options.limitPolicy) options.limitPolicy = $af401cd1bc7a3c41$export$dcc6636e254f409b({});
        super(options);
        this.edgeApiHost = (_a = options.edgeApiHost) != null ? _a : "https://uniform.global";
    }
    /** Fetches lists of Canvas compositions, optionally by type */ async getRoute(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$ROUTE_URL, {
            ...options,
            projectId: projectId
        }, this.edgeApiHost);
        return await this.apiClient(fetchUri, this.options.disableSWR ? {
            headers: {
                "x-disable-swr": "true"
            }
        } : void 0);
    }
};
// src/types/locales.ts
var $af401cd1bc7a3c41$export$d62ffa5f710aa9e7 = "locale";
// src/utils/assetConfig.ts
var $af401cd1bc7a3c41$export$ab60e585e0d755f7 = (config)=>{
    var _a;
    return {
        ...config,
        // For backwards compatibility reasons undefined represents restriction to
        // image types
        allowedTypes: (_a = config.allowedTypes) != null ? _a : [
            "image"
        ]
    };
};
// src/utils/autoFixParameterGroups.ts
function $af401cd1bc7a3c41$export$9455e311943afbd2(properties) {
    var _a;
    const remainingGroups = (_a = properties.filter((param)=>param.type === "group")) != null ? _a : [];
    if (remainingGroups.length === 0) return false;
    let result = false;
    while(remainingGroups.length > 0){
        const group = remainingGroups.shift();
        const groupParamsConfig = group.typeConfig && typeof group.typeConfig === "object" && "childrenParams" in group.typeConfig && Array.isArray(group.typeConfig.childrenParams) ? group.typeConfig.childrenParams : [];
        const expectedParamsToFindFollowingGroup = new Set(groupParamsConfig);
        const groupStartIndex = properties.findIndex((param)=>param.id === group.id);
        const groupItemsCount = expectedParamsToFindFollowingGroup.size;
        for(let i = groupStartIndex + 1; i <= groupStartIndex + groupItemsCount; i++){
            const param = properties[i];
            if (!param) continue;
            if (expectedParamsToFindFollowingGroup.has(param.id)) expectedParamsToFindFollowingGroup.delete(param.id);
            else break;
        }
        if (expectedParamsToFindFollowingGroup.size > 0) {
            const paramsToMove = Array.from(expectedParamsToFindFollowingGroup);
            let leadingGroupIndex = groupStartIndex + groupItemsCount - expectedParamsToFindFollowingGroup.size;
            for (const paramId of paramsToMove){
                const paramIndex = properties.findIndex((param)=>param.id === paramId);
                if (paramIndex !== -1) {
                    const [param] = properties.splice(paramIndex, 1);
                    if (paramIndex > leadingGroupIndex) leadingGroupIndex++;
                    properties.splice(leadingGroupIndex, 0, param);
                } else groupParamsConfig.splice(groupParamsConfig.indexOf(paramId), 1);
            }
            result = true;
        }
    }
    return result;
}
// src/utils/createApiEnhancer.ts
var $af401cd1bc7a3c41$export$dcc8ed67f4b1a188 = ({ apiUrl: apiUrl })=>{
    return async (message)=>{
        const response = await fetch(apiUrl, {
            method: "post",
            body: JSON.stringify({
                composition: message.composition,
                hash: message.hash
            }),
            headers: {
                "Content-Type": "application/json"
            }
        });
        const json = await response.json();
        if (!response.ok) throw new Error("Error reading enhanced composition");
        const body = json;
        return body.composition;
    };
};
// src/utils/entryConverter.ts
function $af401cd1bc7a3c41$export$15e3d066c70e7774(entry) {
    return {
        entry: {
            type: entry.entry.type,
            _dataResources: entry.entry._dataResources,
            _id: entry.entry._id,
            _name: entry.entry._name,
            _slug: entry.entry._slug,
            _pattern: entry.entry._pattern,
            _overridability: entry.entry._overridability,
            _overrides: entry.entry._overrides,
            fields: entry.entry.fields,
            _locales: entry.entry._locales,
            _thumbnail: entry.entry._thumbnail,
            _patternDataResources: entry.entry._patternDataResources
        },
        pattern: entry.pattern,
        state: entry.state,
        projectId: entry.projectId,
        releaseId: entry.releaseId,
        workflowId: entry.workflowId,
        workflowStageId: entry.workflowStageId,
        editionId: entry.editionId,
        editionName: entry.editionName,
        editionPriority: entry.editionPriority
    };
}
// src/utils/getDataSourceVariantFromRouteGetParams.ts
var $af401cd1bc7a3c41$export$5ddbabf865fe701c = (params, defaultPreviewState)=>{
    var _a, _b;
    const dataSourceVariant = // support explicit 'undefined' as a way to opt out of data resources variant
    "dataSourceVariant" in params ? params.dataSourceVariant : // in case of DRAFT state we still want to fetch unpublished data
    ((_b = (_a = params == null ? void 0 : params.state) != null ? _a : defaultPreviewState) != null ? _b : $af401cd1bc7a3c41$export$f20c1529e01bf63b) !== $af401cd1bc7a3c41$export$f20c1529e01bf63b ? "unpublished" : void 0;
    return dataSourceVariant;
};
// src/utils/getParameterAttributes.ts
var $af401cd1bc7a3c41$export$f1c7f022b26798f3 = "data-uniform-component-id";
var $af401cd1bc7a3c41$export$351f6badae6cd6b0 = "data-uniform-parameter-id";
var $af401cd1bc7a3c41$export$84d2b2c8b2e8d352 = "data-uniform-parameter-value";
var $af401cd1bc7a3c41$export$27ded32ac921fd43 = "data-uniform-parameter-type";
var $af401cd1bc7a3c41$export$8d4904a470a1c249 = "data-uniform-placeholder";
var $af401cd1bc7a3c41$export$8a912ba3ef9ab5fb = "data-uniform-is-multiline";
var $af401cd1bc7a3c41$export$5e8e0a3470b8184 = ({ id: id, component: component, placeholder: placeholder, isMultiline: isMultiline = false })=>{
    var _a, _b, _c;
    const componentId = component == null ? void 0 : component._id;
    const parameter = (_a = component == null ? void 0 : component.parameters) == null ? void 0 : _a[id];
    const value = parameter == null ? void 0 : parameter.value;
    const type = parameter == null ? void 0 : parameter.type;
    const isEditable = (_c = (_b = parameter == null ? void 0 : parameter._contextualEditing) == null ? void 0 : _b.isEditable) != null ? _c : false;
    return {
        [$af401cd1bc7a3c41$export$f1c7f022b26798f3]: componentId,
        [$af401cd1bc7a3c41$export$351f6badae6cd6b0]: id,
        [$af401cd1bc7a3c41$export$84d2b2c8b2e8d352]: String(value != null ? value : ""),
        [$af401cd1bc7a3c41$export$27ded32ac921fd43]: type,
        [$af401cd1bc7a3c41$export$8d4904a470a1c249]: placeholder,
        [$af401cd1bc7a3c41$export$8a912ba3ef9ab5fb]: isMultiline,
        contentEditable: isEditable
    };
};
// src/utils/isAllowedReferrer.ts
var $af401cd1bc7a3c41$export$612a58267bbb22e8 = (referrer)=>{
    return Boolean(referrer == null ? void 0 : referrer.match(/(^https:\/\/|\.)(uniform.app|uniform.wtf|localhost:\d{4})\//));
};
// src/utils/isSystemComponentDefinition.ts
var $af401cd1bc7a3c41$export$d1ba0fadad10080d = (componentType)=>{
    return componentType.startsWith("$");
};
// src/utils/mapSlotToPersonalizedVariations.ts
function $af401cd1bc7a3c41$export$3f95bb24f65542b9(slot) {
    if (!slot) return [];
    return slot.map((v, i)=>{
        var _a, _b;
        const contextTag = (_b = (_a = v.parameters) == null ? void 0 : _a[$af401cd1bc7a3c41$export$b72a0bcc64d2087b]) == null ? void 0 : _b.value;
        const id = (contextTag == null ? void 0 : contextTag.name) || `pz-${i}-${v.type}`;
        return {
            ...v,
            id: id,
            pz: contextTag
        };
    });
}
// src/utils/mapSlotToTestVariations.ts
function $af401cd1bc7a3c41$export$2b50c06aa2371be6(slot) {
    if (!slot) return [];
    return slot.map((v, i)=>{
        var _a, _b, _c;
        const contextTag = (_b = (_a = v.parameters) == null ? void 0 : _a[$af401cd1bc7a3c41$export$1c227eb56be4fa11]) == null ? void 0 : _b.value;
        const id = (_c = contextTag == null ? void 0 : contextTag.id) != null ? _c : "testId" in v ? v.testId : `ab-${i}-${v.type}`;
        return {
            ...v,
            id: id,
            testDistribution: contextTag == null ? void 0 : contextTag.testDistribution,
            control: contextTag == null ? void 0 : contextTag.control
        };
    });
}
// src/utils/placeholder.ts
var $af401cd1bc7a3c41$var$SEPARATOR = "_";
var $af401cd1bc7a3c41$export$459c05917fa64e5c = (id)=>{
    if (id === $af401cd1bc7a3c41$export$b1a6d9fad9703edf) return true;
    if (typeof id !== "string") return false;
    return id == null ? void 0 : id.startsWith($af401cd1bc7a3c41$export$b1a6d9fad9703edf);
};
var $af401cd1bc7a3c41$export$dffcc6ad8b025a62 = (randomId, sdkVersion, parent)=>{
    if (sdkVersion === 1) return $af401cd1bc7a3c41$export$b1a6d9fad9703edf;
    let idParts = [
        $af401cd1bc7a3c41$export$b1a6d9fad9703edf,
        randomId
    ];
    if (parent) idParts = [
        ...idParts,
        parent.nodeId,
        parent.slotId
    ];
    return idParts.join($af401cd1bc7a3c41$var$SEPARATOR);
};
var $af401cd1bc7a3c41$export$4c946a6322a72a60 = (id)=>{
    if (!$af401cd1bc7a3c41$export$459c05917fa64e5c(id)) return;
    const idParts = id.split($af401cd1bc7a3c41$var$SEPARATOR);
    const result = {
        id: idParts[1]
    };
    if (idParts[2]) result.parent = {
        nodeId: idParts[2],
        slotId: idParts[3]
    };
    return result;
};
// src/utils/variables/bindVariables.ts
function $af401cd1bc7a3c41$export$77cfc08b5f411d06({ variables: variables, value: value, errorPrefix: errorPrefix = "Variable", handleBinding: handleBinding }) {
    let boundCount = 0;
    let tokenCount = 0;
    const errors = [];
    const defaultHandleBinding = (variableName, variables2, errors2)=>{
        const variableValue = variables2[variableName];
        if (variableValue === void 0) {
            errors2.push(`${errorPrefix} "${variableName}" is not defined`);
            return "";
        }
        return variableValue;
    };
    const result = [];
    $af401cd1bc7a3c41$export$a1a7b5a9f0f65e01(value, (token, tokenType)=>{
        tokenCount++;
        if (tokenType === "text") {
            result.push(token);
            return;
        }
        const variableValue = (handleBinding != null ? handleBinding : defaultHandleBinding)(token, variables, errors);
        boundCount++;
        result.push(variableValue);
    });
    return {
        result: tokenCount === 1 ? result[0] : result.join(""),
        boundCount: boundCount,
        errors: errors.length > 0 ? errors : void 0
    };
}
function $af401cd1bc7a3c41$export$85c937ca18c6d5b5(options) {
    return $af401cd1bc7a3c41$var$bindVariablesToObjectRecursive(options);
}
function $af401cd1bc7a3c41$var$bindVariablesToObjectRecursive({ value: value, recursivePath: recursivePath, ...bindVariablesOptions }) {
    let boundCount = 0;
    const errors = [];
    if (typeof value === "string") return $af401cd1bc7a3c41$export$77cfc08b5f411d06({
        ...bindVariablesOptions,
        value: value
    });
    if (typeof value !== "object" || value === null) return {
        boundCount: 0,
        result: value
    };
    const richTextNodeResult = $af401cd1bc7a3c41$var$handleRichTextNodeBinding(value, bindVariablesOptions);
    if (richTextNodeResult !== void 0) return richTextNodeResult;
    const produceToUse = !(0, $gcM5m.isDraft)(value) ? (0, $gcM5m.produce) : (produceValue, producer)=>{
        producer(produceValue);
        return produceValue;
    };
    const result = produceToUse(value, (draft)=>{
        Object.entries(draft).forEach(([property, oldValue])=>{
            const currentObjectPath = recursivePath ? `${recursivePath}.${property}` : property;
            if (typeof oldValue === "string") {
                const bindResult = $af401cd1bc7a3c41$export$77cfc08b5f411d06({
                    ...bindVariablesOptions,
                    value: oldValue
                });
                if (oldValue !== bindResult.result || bindResult.errors) {
                    boundCount += bindResult.boundCount;
                    draft[property] = bindResult.result;
                    if (bindResult.errors) errors.push(...bindResult.errors.map((e)=>{
                        if (typeof e === "string") return `${currentObjectPath}: ${e}`;
                        e.message = `${currentObjectPath}: ${e.message}`;
                        return e;
                    }));
                }
                return;
            }
            const childBind = $af401cd1bc7a3c41$var$bindVariablesToObjectRecursive({
                ...bindVariablesOptions,
                value: oldValue,
                recursivePath: currentObjectPath
            });
            if (childBind.boundCount || childBind.errors) {
                boundCount += childBind.boundCount;
                draft[property] = childBind.result;
                if (childBind.errors) errors.push(...childBind.errors);
            }
        });
    });
    return {
        boundCount: boundCount,
        result: result,
        errors: errors.length > 0 ? errors : void 0
    };
}
function $af401cd1bc7a3c41$var$handleRichTextNodeBinding(object, options) {
    if ("type" in object && object.type === "variable" && "reference" in object && typeof object.reference === "string" && "version" in object && object.version === 1) {
        const value = $af401cd1bc7a3c41$export$3903215ff3a39d9c(object.reference);
        const bindResult = $af401cd1bc7a3c41$export$77cfc08b5f411d06({
            ...options,
            value: value
        });
        const bindResultAsTextNode = {
            detail: 0,
            format: 0,
            mode: "normal",
            style: "",
            text: bindResult.result,
            type: "text",
            version: 1
        };
        return {
            ...bindResult,
            result: bindResultAsTextNode
        };
    }
    return void 0;
}
// src/.version.ts
var $af401cd1bc7a3c41$export$83d89fbfd8236492 = "20.46.0";
var $af401cd1bc7a3c41$var$workflowsUrl = "/api/v1/workflows";
var $af401cd1bc7a3c41$export$26f68b59ee3c59eb = class extends (0, $hAokw.ApiClient) {
    constructor(options){
        super(options);
    }
    /** Fetches workflows for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$workflowsUrl, {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates a workflow definition */ async upsert(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$workflowsUrl);
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a workflow definition */ async remove(body) {
        const fetchUri = this.createUrl($af401cd1bc7a3c41$var$workflowsUrl);
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
// src/index.ts
var $af401cd1bc7a3c41$export$e6bddb90468f550c = (0, $hAokw.ApiClientError);

});
parcelRegister("hAokw", function(module, exports) {
$parcel$export(module.exports, "ApiClientError", function () { return $ccd8abe5642e6687$export$40f4c0b52fedfe21; });
$parcel$export(module.exports, "ApiClient", function () { return $ccd8abe5642e6687$export$dc890958d2b428da; });

var $NegAH = parcelRequire("NegAH");
var $ccd8abe5642e6687$var$__defProp = Object.defineProperty;
var $ccd8abe5642e6687$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $ccd8abe5642e6687$var$__defNormalProp = (obj, key, value)=>key in obj ? $ccd8abe5642e6687$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ccd8abe5642e6687$var$__publicField = (obj, key, value)=>$ccd8abe5642e6687$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $ccd8abe5642e6687$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $ccd8abe5642e6687$var$__typeError("Cannot " + msg);
var $ccd8abe5642e6687$var$__privateGet = (obj, member, getter)=>($ccd8abe5642e6687$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $ccd8abe5642e6687$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $ccd8abe5642e6687$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $ccd8abe5642e6687$export$f0a5e0d6a7620156 = async (func)=>await func();
var $ccd8abe5642e6687$export$96af132e0d424df5 = (0, (/*@__PURE__*/$parcel$interopDefault($NegAH)))(6);
var $ccd8abe5642e6687$export$40f4c0b52fedfe21 = class _ApiClientError extends Error {
    constructor(errorMessage, fetchMethod, fetchUri, statusCode, statusText, requestId){
        super(`${errorMessage}
 ${statusCode}${statusText ? " " + statusText : ""} (${fetchMethod} ${fetchUri}${requestId ? ` Request ID: ${requestId}` : ""})`);
        this.errorMessage = errorMessage;
        this.fetchMethod = fetchMethod;
        this.fetchUri = fetchUri;
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.requestId = requestId;
        Object.setPrototypeOf(this, _ApiClientError.prototype);
    }
};
// src/api/ApiClient.ts
var $ccd8abe5642e6687$export$dc890958d2b428da = class _ApiClient {
    constructor(options){
        $ccd8abe5642e6687$var$__publicField(this, "options");
        var _a, _b, _c, _d, _e;
        if (!options.apiKey && !options.bearerToken) throw new Error("You must provide an API key or a bearer token");
        let leFetch = options.fetch;
        if (!leFetch) {
            if (typeof window !== "undefined") leFetch = window.fetch.bind(window);
            else if (typeof fetch !== "undefined") leFetch = fetch;
            else throw new Error("You must provide or polyfill a fetch implementation when not in a browser");
        }
        this.options = {
            ...options,
            fetch: leFetch,
            apiHost: this.ensureApiHost(options.apiHost),
            apiKey: (_a = options.apiKey) != null ? _a : null,
            projectId: (_b = options.projectId) != null ? _b : null,
            bearerToken: (_c = options.bearerToken) != null ? _c : null,
            limitPolicy: (_d = options.limitPolicy) != null ? _d : $ccd8abe5642e6687$export$96af132e0d424df5,
            bypassCache: (_e = options.bypassCache) != null ? _e : false
        };
    }
    async apiClient(fetchUri, options) {
        return (await this.apiClientWithResponse(fetchUri, options)).body;
    }
    async apiClientWithResponse(fetchUri, options) {
        return this.options.limitPolicy(async ()=>{
            var _a;
            const coreHeaders = this.options.apiKey ? {
                "x-api-key": this.options.apiKey
            } : {
                Authorization: `Bearer ${this.options.bearerToken}`
            };
            if (this.options.bypassCache) coreHeaders["x-bypass-cache"] = "true";
            const { fetch: fetch2, signal: signal } = this.options;
            const callApi = ()=>fetch2(fetchUri.toString(), {
                    ...options,
                    signal: signal,
                    headers: {
                        ...options == null ? void 0 : options.headers,
                        ...coreHeaders
                    }
                });
            const apiResponse = await $ccd8abe5642e6687$export$ecae9ba9c2795e3(callApi);
            if (!apiResponse.ok) {
                let message = "";
                try {
                    const responseText = await apiResponse.text();
                    try {
                        const parsed = JSON.parse(responseText);
                        if (parsed.errorMessage) message = Array.isArray(parsed.errorMessage) ? parsed.errorMessage.join(", ") : parsed.errorMessage;
                        else message = responseText;
                    } catch (e) {
                        message = responseText;
                    }
                } catch (e) {
                    message = `General error`;
                }
                throw new $ccd8abe5642e6687$export$40f4c0b52fedfe21(message, (_a = options == null ? void 0 : options.method) != null ? _a : "GET", fetchUri.toString(), apiResponse.status, apiResponse.statusText, _ApiClient.getRequestId(apiResponse));
            }
            if (options == null ? void 0 : options.expectNoContent) return {
                response: apiResponse,
                body: null
            };
            return {
                response: apiResponse,
                body: await apiResponse.json()
            };
        });
    }
    createUrl(path, queryParams, hostOverride) {
        const url = new URL(`${hostOverride != null ? hostOverride : this.options.apiHost}${path}`);
        Object.entries(queryParams != null ? queryParams : {}).forEach(([key, value])=>{
            var _a;
            if (typeof value !== "undefined" && value !== null) url.searchParams.append(key, Array.isArray(value) ? value.join(",") : (_a = value == null ? void 0 : value.toString()) != null ? _a : "");
        });
        return url;
    }
    ensureApiHost(apiHost) {
        if (!apiHost) return "https://uniform.app";
        if (!(apiHost == null ? void 0 : apiHost.startsWith("http"))) throw new Error('Your apiHost must start with "http"');
        if (apiHost.indexOf("/", 8) > -1) throw new Error("Your apiHost must not contain a path element after the domain");
        if (apiHost.indexOf("?") > -1) throw new Error("Your apiHost must not contain a query string");
        if (apiHost == null ? void 0 : apiHost.endsWith("/")) apiHost = apiHost.substring(0, apiHost.length - 1);
        return apiHost;
    }
    static getRequestId(response) {
        const apigRequestId = response.headers.get("apigw-requestid");
        if (apigRequestId) return apigRequestId;
        return void 0;
    }
};
async function $ccd8abe5642e6687$export$ecae9ba9c2795e3(callApi) {
    var _a;
    const backoffRetries = 5;
    let backoffRetriesLeft = backoffRetries;
    let response;
    while(backoffRetriesLeft > 0){
        response = await callApi();
        if (response.status !== 429) break;
        let resetWait = 0;
        try {
            const responseClone = response.clone();
            const dateHeader = responseClone.headers.get("date");
            const serverTime = dateHeader ? new Date(dateHeader).getTime() : void 0;
            const body = await responseClone.json();
            const resetTime = (_a = body == null ? void 0 : body.info) == null ? void 0 : _a.reset;
            if (typeof serverTime === "number" && typeof resetTime === "number") resetWait = Math.max(0, Math.min(Math.round(1.1 * (resetTime - serverTime)), 1e4));
        } catch (e) {}
        const base = Math.pow(2, backoffRetries - backoffRetriesLeft) * 333;
        const backoffWait = base + Math.round(Math.random() * (base / 2)) * (Math.random() > 0.5 ? 1 : -1);
        await new Promise((resolve)=>setTimeout(resolve, resetWait + backoffWait));
        backoffRetriesLeft -= 1;
    }
    return response;
}
// src/api/AggregateClient.ts
var $ccd8abe5642e6687$var$_url;
var $ccd8abe5642e6687$var$_AggregateClient = class _AggregateClient extends $ccd8abe5642e6687$export$dc890958d2b428da {
    constructor(options){
        super(options);
    }
    /** Fetches all aggregates for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_AggregateClient, $ccd8abe5642e6687$var$_url), {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) an Aggregate */ async upsert(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_AggregateClient, $ccd8abe5642e6687$var$_url));
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes an Aggregate */ async remove(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_AggregateClient, $ccd8abe5642e6687$var$_url));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
$ccd8abe5642e6687$var$_url = new WeakMap();
$ccd8abe5642e6687$var$__privateAdd($ccd8abe5642e6687$var$_AggregateClient, $ccd8abe5642e6687$var$_url, "/api/v2/aggregate");
var $ccd8abe5642e6687$export$85028357983c60cb = $ccd8abe5642e6687$var$_AggregateClient;
var $ccd8abe5642e6687$export$8cadc3e97d0473a8 = class extends $ccd8abe5642e6687$export$85028357983c60cb {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $ccd8abe5642e6687$export$346698c4ea3b8fcf = class extends $ccd8abe5642e6687$export$85028357983c60cb {
    constructor(options){
        super({
            ...options,
            bypassCache: false
        });
    }
};
// src/manifest/constants.ts
var $ccd8abe5642e6687$var$ENR_SEPARATOR = "_";
// src/api/computeDimensionDisplayName.ts
function $ccd8abe5642e6687$export$57d8989cf959e47d(dim) {
    const type = dim.category === "ENR" ? "Enrichment" : dim.category === "SIG" ? "Signal" : dim.subcategory === "1" ? "Intent" : dim.subcategory === "0" ? "Audience" : "Aggregate";
    return {
        dim: dim.dim,
        name: dim.name,
        type: type,
        category: dim.category === "ENR" ? dim.subcategory : void 0
    };
}
function $ccd8abe5642e6687$export$f408fc4ee8b52b95(dim, manifest) {
    var _a, _b, _c, _d;
    if ((_b = (_a = manifest.project.pz) == null ? void 0 : _a.agg) == null ? void 0 : _b[dim]) return {
        dim: dim,
        name: dim,
        type: "Aggregate"
    };
    else if ((_d = (_c = manifest.project.pz) == null ? void 0 : _c.sig) == null ? void 0 : _d[dim]) return {
        dim: dim,
        name: dim,
        type: "Signal"
    };
    else if (dim.indexOf($ccd8abe5642e6687$var$ENR_SEPARATOR) >= 0) {
        const [cat, value] = dim.split($ccd8abe5642e6687$var$ENR_SEPARATOR);
        return {
            dim: dim,
            name: value,
            type: "Enrichment",
            category: cat
        };
    }
    return void 0;
}
function $ccd8abe5642e6687$export$5b2521e91ba81726(dim) {
    const { type: type, name: name } = $ccd8abe5642e6687$export$57d8989cf959e47d(dim);
    return `${type}: ${name}`;
}
// src/api/DimensionClient.ts
var $ccd8abe5642e6687$var$_url2;
var $ccd8abe5642e6687$var$_DimensionClient = class _DimensionClient extends $ccd8abe5642e6687$export$dc890958d2b428da {
    constructor(options){
        super(options);
    }
    /** Fetches the known score dimensions for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_DimensionClient, $ccd8abe5642e6687$var$_url2), {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
};
$ccd8abe5642e6687$var$_url2 = new WeakMap();
$ccd8abe5642e6687$var$__privateAdd($ccd8abe5642e6687$var$_DimensionClient, $ccd8abe5642e6687$var$_url2, "/api/v2/dimension");
var $ccd8abe5642e6687$export$e36b649536ba8933 = $ccd8abe5642e6687$var$_DimensionClient;
var $ccd8abe5642e6687$export$437a86374a6f3c76 = class extends $ccd8abe5642e6687$export$e36b649536ba8933 {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $ccd8abe5642e6687$export$c3faa5e4c08b45ee = class extends $ccd8abe5642e6687$export$e36b649536ba8933 {
    constructor(options){
        super({
            ...options,
            bypassCache: false
        });
    }
};
// src/api/EnrichmentClient.ts
var $ccd8abe5642e6687$var$_url3, $ccd8abe5642e6687$var$_valueUrl;
var $ccd8abe5642e6687$var$_EnrichmentClient = class _EnrichmentClient extends $ccd8abe5642e6687$export$dc890958d2b428da {
    constructor(options){
        super(options);
    }
    /** Fetches all enrichments and values for a project, grouped by category */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_EnrichmentClient, $ccd8abe5642e6687$var$_url3), {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) an enrichment category */ async upsertCategory(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_EnrichmentClient, $ccd8abe5642e6687$var$_url3));
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes an enrichment category */ async removeCategory(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_EnrichmentClient, $ccd8abe5642e6687$var$_url3));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Updates or creates (based on id) an enrichment value within an enrichment category */ async upsertValue(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_EnrichmentClient, $ccd8abe5642e6687$var$_valueUrl));
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes an enrichment value within an enrichment category. The category is left alone. */ async removeValue(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_EnrichmentClient, $ccd8abe5642e6687$var$_valueUrl));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
$ccd8abe5642e6687$var$_url3 = new WeakMap();
$ccd8abe5642e6687$var$_valueUrl = new WeakMap();
$ccd8abe5642e6687$var$__privateAdd($ccd8abe5642e6687$var$_EnrichmentClient, $ccd8abe5642e6687$var$_url3, "/api/v1/enrichments");
$ccd8abe5642e6687$var$__privateAdd($ccd8abe5642e6687$var$_EnrichmentClient, $ccd8abe5642e6687$var$_valueUrl, "/api/v1/enrichment-values");
var $ccd8abe5642e6687$export$e691956653330a34 = $ccd8abe5642e6687$var$_EnrichmentClient;
var $ccd8abe5642e6687$export$8cd949fbf2d8236c = class extends $ccd8abe5642e6687$export$e691956653330a34 {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $ccd8abe5642e6687$export$ad4bff4ee04c835 = class extends $ccd8abe5642e6687$export$e691956653330a34 {
    constructor(options){
        super({
            ...options,
            bypassCache: false
        });
    }
};
// src/api/ManifestClient.ts
var $ccd8abe5642e6687$var$_url4;
var $ccd8abe5642e6687$var$_ManifestClient = class _ManifestClient extends $ccd8abe5642e6687$export$dc890958d2b428da {
    constructor(options){
        super(options);
    }
    /** Fetches the Context manifest for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_ManifestClient, $ccd8abe5642e6687$var$_url4), {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Publishes the Context manifest for a project */ async publish() {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl("/api/v1/publish", {
            siteId: projectId
        });
        await this.apiClient(fetchUri, {
            method: "POST",
            expectNoContent: true
        });
    }
};
$ccd8abe5642e6687$var$_url4 = new WeakMap();
$ccd8abe5642e6687$var$__privateAdd($ccd8abe5642e6687$var$_ManifestClient, $ccd8abe5642e6687$var$_url4, "/api/v2/manifest");
var $ccd8abe5642e6687$export$300b3dc6c278556b = $ccd8abe5642e6687$var$_ManifestClient;
var $ccd8abe5642e6687$export$9d2624862118d80a = class extends $ccd8abe5642e6687$export$300b3dc6c278556b {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $ccd8abe5642e6687$export$ec219304308e29d0 = class extends $ccd8abe5642e6687$export$300b3dc6c278556b {
    constructor(options){
        super({
            ...options,
            bypassCache: false
        });
    }
};
// src/api/QuirkClient.ts
var $ccd8abe5642e6687$var$_url5;
var $ccd8abe5642e6687$var$_QuirkClient = class _QuirkClient extends $ccd8abe5642e6687$export$dc890958d2b428da {
    constructor(options){
        super(options);
    }
    /** Fetches all Quirks for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_QuirkClient, $ccd8abe5642e6687$var$_url5), {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a Quirk */ async upsert(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_QuirkClient, $ccd8abe5642e6687$var$_url5));
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a Quirk */ async remove(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_QuirkClient, $ccd8abe5642e6687$var$_url5));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
$ccd8abe5642e6687$var$_url5 = new WeakMap();
$ccd8abe5642e6687$var$__privateAdd($ccd8abe5642e6687$var$_QuirkClient, $ccd8abe5642e6687$var$_url5, "/api/v2/quirk");
var $ccd8abe5642e6687$export$f4477b1c45bb6390 = $ccd8abe5642e6687$var$_QuirkClient;
var $ccd8abe5642e6687$export$fb34f44ae0a14e25 = class extends $ccd8abe5642e6687$export$f4477b1c45bb6390 {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $ccd8abe5642e6687$export$780d94a2d74ed2aa = class extends $ccd8abe5642e6687$export$f4477b1c45bb6390 {
    constructor(options){
        super({
            ...options,
            bypassCache: false
        });
    }
};
// src/api/SignalClient.ts
var $ccd8abe5642e6687$var$_url6;
var $ccd8abe5642e6687$var$_SignalClient = class _SignalClient extends $ccd8abe5642e6687$export$dc890958d2b428da {
    constructor(options){
        super(options);
    }
    /** Fetches all Signals for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_SignalClient, $ccd8abe5642e6687$var$_url6), {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a Signal */ async upsert(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_SignalClient, $ccd8abe5642e6687$var$_url6));
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a Signal */ async remove(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_SignalClient, $ccd8abe5642e6687$var$_url6));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
$ccd8abe5642e6687$var$_url6 = new WeakMap();
$ccd8abe5642e6687$var$__privateAdd($ccd8abe5642e6687$var$_SignalClient, $ccd8abe5642e6687$var$_url6, "/api/v2/signal");
var $ccd8abe5642e6687$export$1c8cf8deb105d00 = $ccd8abe5642e6687$var$_SignalClient;
var $ccd8abe5642e6687$export$e084c05d87d42cd8 = class extends $ccd8abe5642e6687$export$1c8cf8deb105d00 {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $ccd8abe5642e6687$export$836215b325b7c61b = class extends $ccd8abe5642e6687$export$1c8cf8deb105d00 {
    constructor(options){
        super({
            ...options,
            bypassCache: false
        });
    }
};
// src/api/TestClient.ts
var $ccd8abe5642e6687$var$_url7;
var $ccd8abe5642e6687$var$_TestClient = class _TestClient extends $ccd8abe5642e6687$export$dc890958d2b428da {
    constructor(options){
        super(options);
    }
    /** Fetches all Tests for a project */ async get(options) {
        const { projectId: projectId } = this.options;
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_TestClient, $ccd8abe5642e6687$var$_url7), {
            ...options,
            projectId: projectId
        });
        return await this.apiClient(fetchUri);
    }
    /** Updates or creates (based on id) a Test */ async upsert(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_TestClient, $ccd8abe5642e6687$var$_url7));
        await this.apiClient(fetchUri, {
            method: "PUT",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
    /** Deletes a Test */ async remove(body) {
        const fetchUri = this.createUrl($ccd8abe5642e6687$var$__privateGet(_TestClient, $ccd8abe5642e6687$var$_url7));
        await this.apiClient(fetchUri, {
            method: "DELETE",
            body: JSON.stringify({
                ...body,
                projectId: this.options.projectId
            }),
            expectNoContent: true
        });
    }
};
$ccd8abe5642e6687$var$_url7 = new WeakMap();
$ccd8abe5642e6687$var$__privateAdd($ccd8abe5642e6687$var$_TestClient, $ccd8abe5642e6687$var$_url7, "/api/v2/test");
var $ccd8abe5642e6687$export$6f0be7d976f1bc1c = $ccd8abe5642e6687$var$_TestClient;
var $ccd8abe5642e6687$export$b73d54ea1ec118d = class extends $ccd8abe5642e6687$export$6f0be7d976f1bc1c {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $ccd8abe5642e6687$export$b0e3dcbcd3614202 = class extends $ccd8abe5642e6687$export$6f0be7d976f1bc1c {
    constructor(options){
        super({
            ...options,
            bypassCache: false
        });
    }
};
// src/api/ContextClient.ts
var $ccd8abe5642e6687$export$8d93d342356cb9a0 = class {
    constructor(options){
        $ccd8abe5642e6687$var$__publicField(this, "enrichments");
        $ccd8abe5642e6687$var$__publicField(this, "aggregates");
        $ccd8abe5642e6687$var$__publicField(this, "dimensions");
        $ccd8abe5642e6687$var$__publicField(this, "manifest");
        $ccd8abe5642e6687$var$__publicField(this, "quirks");
        $ccd8abe5642e6687$var$__publicField(this, "signals");
        $ccd8abe5642e6687$var$__publicField(this, "tests");
        this.enrichments = new $ccd8abe5642e6687$export$e691956653330a34(options);
        this.aggregates = new $ccd8abe5642e6687$export$85028357983c60cb(options);
        this.dimensions = new $ccd8abe5642e6687$export$e36b649536ba8933(options);
        this.manifest = new $ccd8abe5642e6687$export$300b3dc6c278556b(options);
        this.quirks = new $ccd8abe5642e6687$export$f4477b1c45bb6390(options);
        this.signals = new $ccd8abe5642e6687$export$1c8cf8deb105d00(options);
        this.tests = new $ccd8abe5642e6687$export$6f0be7d976f1bc1c(options);
    }
};
var $ccd8abe5642e6687$export$843996f142cfc3c = class extends $ccd8abe5642e6687$export$8d93d342356cb9a0 {
    constructor(options){
        super({
            ...options,
            bypassCache: true
        });
    }
};
var $ccd8abe5642e6687$export$37eddf40d574b854 = class extends $ccd8abe5642e6687$export$8d93d342356cb9a0 {
    constructor(options){
        super({
            ...options,
            bypassCache: false
        });
    }
};

});
parcelRegister("NegAH", function(module, exports) {
'use strict';

var $7XkHK = parcelRequire("7XkHK");
const $093fa4c4438bf5c7$var$pLimit = (concurrency)=>{
    if (!((Number.isInteger(concurrency) || concurrency === Infinity) && concurrency > 0)) throw new TypeError('Expected `concurrency` to be a number from 1 and up');
    const queue = new $7XkHK();
    let activeCount = 0;
    const next = ()=>{
        activeCount--;
        if (queue.size > 0) queue.dequeue()();
    };
    const run = async (fn, resolve, ...args)=>{
        activeCount++;
        const result = (async ()=>fn(...args))();
        resolve(result);
        try {
            await result;
        } catch  {}
        next();
    };
    const enqueue = (fn, resolve, ...args)=>{
        queue.enqueue(run.bind(null, fn, resolve, ...args));
        (async ()=>{
            // This function needs to wait until the next microtask before comparing
            // `activeCount` to `concurrency`, because `activeCount` is updated asynchronously
            // when the run function is dequeued and called. The comparison in the if-statement
            // needs to happen asynchronously as well to get an up-to-date value for `activeCount`.
            await Promise.resolve();
            if (activeCount < concurrency && queue.size > 0) queue.dequeue()();
        })();
    };
    const generator = (fn, ...args)=>new Promise((resolve)=>{
            enqueue(fn, resolve, ...args);
        });
    Object.defineProperties(generator, {
        activeCount: {
            get: ()=>activeCount
        },
        pendingCount: {
            get: ()=>queue.size
        },
        clearQueue: {
            value: ()=>{
                queue.clear();
            }
        }
    });
    return generator;
};
module.exports = $093fa4c4438bf5c7$var$pLimit;

});
parcelRegister("7XkHK", function(module, exports) {
class $5cae1a975a91c4c7$var$Node {
    /// value;
    /// next;
    constructor(value){
        this.value = value;
        // TODO: Remove this when targeting Node.js 12.
        this.next = undefined;
    }
}
class $5cae1a975a91c4c7$var$Queue {
    // TODO: Use private class fields when targeting Node.js 12.
    // #_head;
    // #_tail;
    // #_size;
    constructor(){
        this.clear();
    }
    enqueue(value) {
        const node = new $5cae1a975a91c4c7$var$Node(value);
        if (this._head) {
            this._tail.next = node;
            this._tail = node;
        } else {
            this._head = node;
            this._tail = node;
        }
        this._size++;
    }
    dequeue() {
        const current = this._head;
        if (!current) return;
        this._head = this._head.next;
        this._size--;
        return current.value;
    }
    clear() {
        this._head = undefined;
        this._tail = undefined;
        this._size = 0;
    }
    get size() {
        return this._size;
    }
    *[Symbol.iterator]() {
        let current = this._head;
        while(current){
            yield current.value;
            current = current.next;
        }
    }
}
module.exports = $5cae1a975a91c4c7$var$Queue;

});



parcelRegister("gcM5m", function(module, exports) {
$parcel$export(module.exports, "isDraft", function () { return $bcc3111dd5a49141$export$541ac630993a4c84; });
$parcel$export(module.exports, "produce", function () { return $bcc3111dd5a49141$export$b46cabe22e78bc00; });
// src/utils/env.ts
var $bcc3111dd5a49141$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $bcc3111dd5a49141$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $bcc3111dd5a49141$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $bcc3111dd5a49141$var$errors = [];
function $bcc3111dd5a49141$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $bcc3111dd5a49141$var$getPrototypeOf = Object.getPrototypeOf;
function $bcc3111dd5a49141$export$541ac630993a4c84(value) {
    return !!value && !!value[$bcc3111dd5a49141$var$DRAFT_STATE];
}
function $bcc3111dd5a49141$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $bcc3111dd5a49141$var$isPlainObject(value) || Array.isArray(value) || !!value[$bcc3111dd5a49141$export$6ee2082928bcb0ee] || !!value.constructor?.[$bcc3111dd5a49141$export$6ee2082928bcb0ee] || $bcc3111dd5a49141$var$isMap(value) || $bcc3111dd5a49141$var$isSet(value);
}
var $bcc3111dd5a49141$var$objectCtorString = Object.prototype.constructor.toString();
function $bcc3111dd5a49141$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $bcc3111dd5a49141$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $bcc3111dd5a49141$var$objectCtorString;
}
function $bcc3111dd5a49141$export$22e8af3f75a010e3(value) {
    if (!$bcc3111dd5a49141$export$541ac630993a4c84(value)) $bcc3111dd5a49141$var$die(15, value);
    return value[$bcc3111dd5a49141$var$DRAFT_STATE].base_;
}
function $bcc3111dd5a49141$var$each(obj, iter) {
    if ($bcc3111dd5a49141$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $bcc3111dd5a49141$var$getArchtype(thing) {
    const state = thing[$bcc3111dd5a49141$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $bcc3111dd5a49141$var$isMap(thing) ? 2 /* Map */  : $bcc3111dd5a49141$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $bcc3111dd5a49141$var$has(thing, prop) {
    return $bcc3111dd5a49141$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $bcc3111dd5a49141$var$get(thing, prop) {
    return $bcc3111dd5a49141$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $bcc3111dd5a49141$var$set(thing, propOrOldValue, value) {
    const t = $bcc3111dd5a49141$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $bcc3111dd5a49141$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $bcc3111dd5a49141$var$isMap(target) {
    return target instanceof Map;
}
function $bcc3111dd5a49141$var$isSet(target) {
    return target instanceof Set;
}
function $bcc3111dd5a49141$var$latest(state) {
    return state.copy_ || state.base_;
}
function $bcc3111dd5a49141$var$shallowCopy(base, strict) {
    if ($bcc3111dd5a49141$var$isMap(base)) return new Map(base);
    if ($bcc3111dd5a49141$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $bcc3111dd5a49141$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$bcc3111dd5a49141$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($bcc3111dd5a49141$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $bcc3111dd5a49141$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $bcc3111dd5a49141$export$792f3d81ea979f55(obj, deep = false) {
    if ($bcc3111dd5a49141$var$isFrozen(obj) || $bcc3111dd5a49141$export$541ac630993a4c84(obj) || !$bcc3111dd5a49141$export$16e3aed3edb85946(obj)) return obj;
    if ($bcc3111dd5a49141$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $bcc3111dd5a49141$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$bcc3111dd5a49141$export$792f3d81ea979f55(value, true));
    return obj;
}
function $bcc3111dd5a49141$var$dontMutateFrozenCollections() {
    $bcc3111dd5a49141$var$die(2);
}
function $bcc3111dd5a49141$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $bcc3111dd5a49141$var$plugins = {};
function $bcc3111dd5a49141$var$getPlugin(pluginKey) {
    const plugin = $bcc3111dd5a49141$var$plugins[pluginKey];
    if (!plugin) $bcc3111dd5a49141$var$die(0, pluginKey);
    return plugin;
}
function $bcc3111dd5a49141$var$loadPlugin(pluginKey, implementation) {
    if (!$bcc3111dd5a49141$var$plugins[pluginKey]) $bcc3111dd5a49141$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $bcc3111dd5a49141$var$currentScope;
function $bcc3111dd5a49141$var$getCurrentScope() {
    return $bcc3111dd5a49141$var$currentScope;
}
function $bcc3111dd5a49141$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $bcc3111dd5a49141$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $bcc3111dd5a49141$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $bcc3111dd5a49141$var$revokeScope(scope) {
    $bcc3111dd5a49141$var$leaveScope(scope);
    scope.drafts_.forEach($bcc3111dd5a49141$var$revokeDraft);
    scope.drafts_ = null;
}
function $bcc3111dd5a49141$var$leaveScope(scope) {
    if (scope === $bcc3111dd5a49141$var$currentScope) $bcc3111dd5a49141$var$currentScope = scope.parent_;
}
function $bcc3111dd5a49141$var$enterScope(immer2) {
    return $bcc3111dd5a49141$var$currentScope = $bcc3111dd5a49141$var$createScope($bcc3111dd5a49141$var$currentScope, immer2);
}
function $bcc3111dd5a49141$var$revokeDraft(draft) {
    const state = draft[$bcc3111dd5a49141$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $bcc3111dd5a49141$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$bcc3111dd5a49141$var$DRAFT_STATE].modified_) {
            $bcc3111dd5a49141$var$revokeScope(scope);
            $bcc3111dd5a49141$var$die(4);
        }
        if ($bcc3111dd5a49141$export$16e3aed3edb85946(result)) {
            result = $bcc3111dd5a49141$var$finalize(scope, result);
            if (!scope.parent_) $bcc3111dd5a49141$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $bcc3111dd5a49141$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$bcc3111dd5a49141$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $bcc3111dd5a49141$var$finalize(scope, baseDraft, []);
    $bcc3111dd5a49141$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $bcc3111dd5a49141$export$45b790e32b2810ee ? result : void 0;
}
function $bcc3111dd5a49141$var$finalize(rootScope, value, path) {
    if ($bcc3111dd5a49141$var$isFrozen(value)) return value;
    const state = value[$bcc3111dd5a49141$var$DRAFT_STATE];
    if (!state) {
        $bcc3111dd5a49141$var$each(value, (key, childValue)=>$bcc3111dd5a49141$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $bcc3111dd5a49141$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $bcc3111dd5a49141$var$each(resultEach, (key, childValue)=>$bcc3111dd5a49141$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $bcc3111dd5a49141$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $bcc3111dd5a49141$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $bcc3111dd5a49141$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($bcc3111dd5a49141$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$bcc3111dd5a49141$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $bcc3111dd5a49141$var$finalize(rootScope, childValue, path);
        $bcc3111dd5a49141$var$set(targetObject, prop, res);
        if ($bcc3111dd5a49141$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($bcc3111dd5a49141$export$16e3aed3edb85946(childValue) && !$bcc3111dd5a49141$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $bcc3111dd5a49141$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $bcc3111dd5a49141$var$maybeFreeze(rootScope, childValue);
    }
}
function $bcc3111dd5a49141$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $bcc3111dd5a49141$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $bcc3111dd5a49141$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $bcc3111dd5a49141$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $bcc3111dd5a49141$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $bcc3111dd5a49141$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $bcc3111dd5a49141$var$objectTraps = {
    get (state, prop) {
        if (prop === $bcc3111dd5a49141$var$DRAFT_STATE) return state;
        const source = $bcc3111dd5a49141$var$latest(state);
        if (!$bcc3111dd5a49141$var$has(source, prop)) return $bcc3111dd5a49141$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$bcc3111dd5a49141$export$16e3aed3edb85946(value)) return value;
        if (value === $bcc3111dd5a49141$var$peek(state.base_, prop)) {
            $bcc3111dd5a49141$var$prepareCopy(state);
            return state.copy_[prop] = $bcc3111dd5a49141$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $bcc3111dd5a49141$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($bcc3111dd5a49141$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $bcc3111dd5a49141$var$getDescriptorFromProto($bcc3111dd5a49141$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $bcc3111dd5a49141$var$peek($bcc3111dd5a49141$var$latest(state), prop);
            const currentState = current2?.[$bcc3111dd5a49141$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($bcc3111dd5a49141$var$is(value, current2) && (value !== void 0 || $bcc3111dd5a49141$var$has(state.base_, prop))) return true;
            $bcc3111dd5a49141$var$prepareCopy(state);
            $bcc3111dd5a49141$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($bcc3111dd5a49141$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $bcc3111dd5a49141$var$prepareCopy(state);
            $bcc3111dd5a49141$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $bcc3111dd5a49141$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $bcc3111dd5a49141$var$die(11);
    },
    getPrototypeOf (state) {
        return $bcc3111dd5a49141$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $bcc3111dd5a49141$var$die(12);
    }
};
var $bcc3111dd5a49141$var$arrayTraps = {};
$bcc3111dd5a49141$var$each($bcc3111dd5a49141$var$objectTraps, (key, fn)=>{
    $bcc3111dd5a49141$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$bcc3111dd5a49141$var$arrayTraps.deleteProperty = function(state, prop) {
    return $bcc3111dd5a49141$var$arrayTraps.set.call(this, state, prop, void 0);
};
$bcc3111dd5a49141$var$arrayTraps.set = function(state, prop, value) {
    return $bcc3111dd5a49141$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $bcc3111dd5a49141$var$peek(draft, prop) {
    const state = draft[$bcc3111dd5a49141$var$DRAFT_STATE];
    const source = state ? $bcc3111dd5a49141$var$latest(state) : draft;
    return source[prop];
}
function $bcc3111dd5a49141$var$readPropFromProto(state, source, prop) {
    const desc = $bcc3111dd5a49141$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $bcc3111dd5a49141$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $bcc3111dd5a49141$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $bcc3111dd5a49141$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $bcc3111dd5a49141$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $bcc3111dd5a49141$var$markChanged(state.parent_);
    }
}
function $bcc3111dd5a49141$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $bcc3111dd5a49141$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $bcc3111dd5a49141$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $bcc3111dd5a49141$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $bcc3111dd5a49141$var$die(7);
            let result;
            if ($bcc3111dd5a49141$export$16e3aed3edb85946(base)) {
                const scope = $bcc3111dd5a49141$var$enterScope(this);
                const proxy = $bcc3111dd5a49141$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $bcc3111dd5a49141$var$revokeScope(scope);
                    else $bcc3111dd5a49141$var$leaveScope(scope);
                }
                $bcc3111dd5a49141$var$usePatchesInScope(scope, patchListener);
                return $bcc3111dd5a49141$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $bcc3111dd5a49141$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $bcc3111dd5a49141$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $bcc3111dd5a49141$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $bcc3111dd5a49141$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof config?.autoFreeze === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof config?.useStrictShallowCopy === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$bcc3111dd5a49141$export$16e3aed3edb85946(base)) $bcc3111dd5a49141$var$die(8);
        if ($bcc3111dd5a49141$export$541ac630993a4c84(base)) base = $bcc3111dd5a49141$export$97aac956da55dae9(base);
        const scope = $bcc3111dd5a49141$var$enterScope(this);
        const proxy = $bcc3111dd5a49141$var$createProxy(base, void 0);
        proxy[$bcc3111dd5a49141$var$DRAFT_STATE].isManual_ = true;
        $bcc3111dd5a49141$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$bcc3111dd5a49141$var$DRAFT_STATE];
        if (!state || !state.isManual_) $bcc3111dd5a49141$var$die(9);
        const { scope_: scope } = state;
        $bcc3111dd5a49141$var$usePatchesInScope(scope, patchListener);
        return $bcc3111dd5a49141$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $bcc3111dd5a49141$var$getPlugin("Patches").applyPatches_;
        if ($bcc3111dd5a49141$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $bcc3111dd5a49141$var$createProxy(value, parent) {
    const draft = $bcc3111dd5a49141$var$isMap(value) ? $bcc3111dd5a49141$var$getPlugin("MapSet").proxyMap_(value, parent) : $bcc3111dd5a49141$var$isSet(value) ? $bcc3111dd5a49141$var$getPlugin("MapSet").proxySet_(value, parent) : $bcc3111dd5a49141$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $bcc3111dd5a49141$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $bcc3111dd5a49141$export$97aac956da55dae9(value) {
    if (!$bcc3111dd5a49141$export$541ac630993a4c84(value)) $bcc3111dd5a49141$var$die(10, value);
    return $bcc3111dd5a49141$var$currentImpl(value);
}
function $bcc3111dd5a49141$var$currentImpl(value) {
    if (!$bcc3111dd5a49141$export$16e3aed3edb85946(value) || $bcc3111dd5a49141$var$isFrozen(value)) return value;
    const state = value[$bcc3111dd5a49141$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $bcc3111dd5a49141$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $bcc3111dd5a49141$var$shallowCopy(value, true);
    $bcc3111dd5a49141$var$each(copy, (key, childValue)=>{
        $bcc3111dd5a49141$var$set(copy, key, $bcc3111dd5a49141$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $bcc3111dd5a49141$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $bcc3111dd5a49141$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $bcc3111dd5a49141$var$get(base_, key);
            const value = $bcc3111dd5a49141$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $bcc3111dd5a49141$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $bcc3111dd5a49141$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $bcc3111dd5a49141$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $bcc3111dd5a49141$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $bcc3111dd5a49141$var$die(errorOffset + 3);
                base = $bcc3111dd5a49141$var$get(base, p);
                if (typeof base !== "object") $bcc3111dd5a49141$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $bcc3111dd5a49141$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $bcc3111dd5a49141$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $bcc3111dd5a49141$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$bcc3111dd5a49141$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($bcc3111dd5a49141$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($bcc3111dd5a49141$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($bcc3111dd5a49141$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($bcc3111dd5a49141$var$has(obj, $bcc3111dd5a49141$export$6ee2082928bcb0ee)) cloned[$bcc3111dd5a49141$export$6ee2082928bcb0ee] = obj[$bcc3111dd5a49141$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($bcc3111dd5a49141$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $bcc3111dd5a49141$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $bcc3111dd5a49141$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$bcc3111dd5a49141$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $bcc3111dd5a49141$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $bcc3111dd5a49141$var$latest(this[$bcc3111dd5a49141$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $bcc3111dd5a49141$var$latest(this[$bcc3111dd5a49141$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$bcc3111dd5a49141$var$latest(state).has(key) || $bcc3111dd5a49141$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $bcc3111dd5a49141$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $bcc3111dd5a49141$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($bcc3111dd5a49141$var$latest(state).size) {
                prepareMapCopy(state);
                $bcc3111dd5a49141$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $bcc3111dd5a49141$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            $bcc3111dd5a49141$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $bcc3111dd5a49141$var$latest(state).get(key);
            if (state.finalized_ || !$bcc3111dd5a49141$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $bcc3111dd5a49141$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $bcc3111dd5a49141$var$latest(this[$bcc3111dd5a49141$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($bcc3111dd5a49141$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$bcc3111dd5a49141$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $bcc3111dd5a49141$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $bcc3111dd5a49141$var$latest(this[$bcc3111dd5a49141$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $bcc3111dd5a49141$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $bcc3111dd5a49141$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($bcc3111dd5a49141$var$latest(state).size) {
                prepareSetCopy(state);
                $bcc3111dd5a49141$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$bcc3111dd5a49141$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($bcc3111dd5a49141$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($bcc3111dd5a49141$export$16e3aed3edb85946(value)) {
                    const draft = $bcc3111dd5a49141$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $bcc3111dd5a49141$var$die(3, JSON.stringify($bcc3111dd5a49141$var$latest(state)));
    }
    $bcc3111dd5a49141$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $bcc3111dd5a49141$var$immer = new $bcc3111dd5a49141$export$aaadc6ff0f822719();
var $bcc3111dd5a49141$export$b46cabe22e78bc00 = $bcc3111dd5a49141$var$immer.produce;
var $bcc3111dd5a49141$export$4da66d41c9492c78 = $bcc3111dd5a49141$var$immer.produceWithPatches.bind($bcc3111dd5a49141$var$immer);
var $bcc3111dd5a49141$export$573f26f60825c493 = $bcc3111dd5a49141$var$immer.setAutoFreeze.bind($bcc3111dd5a49141$var$immer);
var $bcc3111dd5a49141$export$333ce65961cbe047 = $bcc3111dd5a49141$var$immer.setUseStrictShallowCopy.bind($bcc3111dd5a49141$var$immer);
var $bcc3111dd5a49141$export$a8b8e03e6bbe5473 = $bcc3111dd5a49141$var$immer.applyPatches.bind($bcc3111dd5a49141$var$immer);
var $bcc3111dd5a49141$export$3c3214997190395f = $bcc3111dd5a49141$var$immer.createDraft.bind($bcc3111dd5a49141$var$immer);
var $bcc3111dd5a49141$export$c60f5e69c521b528 = $bcc3111dd5a49141$var$immer.finishDraft.bind($bcc3111dd5a49141$var$immer);
function $bcc3111dd5a49141$export$c05b21e3257751e5(value) {
    return value;
}
function $bcc3111dd5a49141$export$20f911b3f8cf0b74(value) {
    return value;
}

});


parcelRegister("dNSrU", function(module, exports) {
$parcel$export(module.exports, "useQuirks", function () { return $a0ca16739822c68d$export$8e45130e60564551; });
$parcel$export(module.exports, "useUniformContext", function () { return $a0ca16739822c68d$export$9e15abfeafdb1169; });
$parcel$export(module.exports, "Personalize", function () { return $a0ca16739822c68d$export$41c6104d68145ae7; });
$parcel$export(module.exports, "Test", function () { return $a0ca16739822c68d$export$1b16fc9eb974a84d; });
$parcel$export(module.exports, "Track", function () { return $a0ca16739822c68d$export$13921ac0cc260818; });
$parcel$export(module.exports, "TrackFragment", function () { return $a0ca16739822c68d$export$a00da852751fef16; });
$parcel$export(module.exports, "UniformContext", function () { return $a0ca16739822c68d$export$3f6dec04ae507c15; });

var $1oC0p = parcelRequire("1oC0p");

var $hT7VS = parcelRequire("hT7VS");

var $ajzpT = parcelRequire("ajzpT");

var $8JMLR = parcelRequire("8JMLR");
'use client';
function $a0ca16739822c68d$export$8e45130e60564551(options) {
    var _a;
    const { context: context } = $a0ca16739822c68d$export$9e15abfeafdb1169(options) || {};
    const [quirks, setQuirks] = (0, $1oC0p.useState)((_a = context == null ? void 0 : context.quirks) != null ? _a : {});
    const quirkChangeListener = (updatedQuirks)=>{
        setQuirks(updatedQuirks);
    };
    (0, $1oC0p.useEffect)(()=>{
        context == null || context.events.on("quirksUpdated", quirkChangeListener);
        return ()=>{
            context == null || context.events.off("quirksUpdated", quirkChangeListener);
        };
    }, [
        context
    ]);
    return quirks;
}
function $a0ca16739822c68d$export$eaad1823da0c9d37() {
    const { context: context } = $a0ca16739822c68d$export$9e15abfeafdb1169();
    const [scores, setScores] = (0, $1oC0p.useState)(context.scores);
    (0, $1oC0p.useEffect)(()=>{
        const scoringChangeListener = (updatedScores)=>{
            setScores(updatedScores);
        };
        const currentScores = context.scores;
        if (!(0, $hT7VS.dequal)(scores, currentScores)) setScores(currentScores);
        context.events.on("scoresUpdated", scoringChangeListener);
        return ()=>{
            context.events.off("scoresUpdated", scoringChangeListener);
        };
    }, [
        context
    ]);
    return scores;
}
var $a0ca16739822c68d$var$UniformContextContext = (0, $1oC0p.createContext)(void 0);
var $a0ca16739822c68d$var$PersonalizationContext = (0, $1oC0p.createContext)({});
// src/hooks/useUniformContext.ts
function $a0ca16739822c68d$export$9e15abfeafdb1169(options = {}) {
    const { throwOnMissingProvider: throwOnMissingProvider = true } = options;
    const value = (0, $1oC0p.useContext)($a0ca16739822c68d$var$UniformContextContext);
    if (throwOnMissingProvider) {
        if (value === void 0) throw new Error("useUniformContext must be used within a <UniformContext> provider");
        return value;
    }
    return value;
}
// src/constants.ts
var $a0ca16739822c68d$var$isServer = typeof window === "undefined";
var $a0ca16739822c68d$var$EdgeTag = (props)=>{
    return (0, $1oC0p.createElement)((0, $ajzpT.EdgeNodeTagName), props);
};
// src/components/PersonalizeEdge.tsx
function $a0ca16739822c68d$var$PersonalizeEdge(props) {
    const { variations: variations, count: count, component: component } = props;
    const options = {
        name: props.name,
        count: count != null ? count : 1,
        algorithm: props.algorithm
    };
    const Component = component;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$EdgeTag, {
        "data-type": (0, $ajzpT.ScriptType).ListStart,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(options)
        }
    }), variations.map((variant)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), {
            key: variant.id
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$EdgeTag, {
            "data-type": (0, $ajzpT.ScriptType).ListItemSettings,
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    id: variant.id,
                    pz: variant.pz || null
                })
            }
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$EdgeTag, {
            "data-type": (0, $ajzpT.ScriptType).ListItem
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Component, {
            key: variant.id,
            personalizationResult: {
                variation: variant,
                personalizationOccurred: false
            },
            ...variant
        })))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$EdgeTag, {
        "data-type": (0, $ajzpT.ScriptType).ListEnd
    }));
}
function $a0ca16739822c68d$var$PersonalizeStandard({ variations: variations, component: component, wrapperComponent: wrapperComponent, name: name, algorithm: algorithm, count: count = 1, compositionMetadata: compositionMetadata }) {
    const { context: context } = $a0ca16739822c68d$export$9e15abfeafdb1169();
    const scores = $a0ca16739822c68d$export$eaad1823da0c9d37();
    const quirks = $a0ca16739822c68d$export$8e45130e60564551();
    const { variations: personalizedVariations, personalized: personalizationOccurred } = (0, $1oC0p.useMemo)(()=>context.personalize({
            name: name,
            variations: variations,
            take: count,
            algorithm: algorithm,
            compositionMetadata: compositionMetadata
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        scores,
        quirks,
        context,
        count,
        name,
        variations,
        compositionMetadata
    ]);
    const Wrapper = wrapperComponent != null ? wrapperComponent : ({ children: children })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    const Component = component;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$PersonalizationContext.Provider, {
        value: {
            personalized: true
        }
    }, personalizedVariations.length ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Wrapper, {
        personalizationOccurred: personalizationOccurred
    }, personalizedVariations.map((variant)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Component, {
            key: variant.id,
            personalizationResult: {
                variation: variant,
                personalizationOccurred: personalizationOccurred
            },
            ...variant
        }))) : null);
}
// src/components/Personalize.tsx
function $a0ca16739822c68d$export$41c6104d68145ae7(props) {
    var _a;
    const { outputType: outputType } = (_a = $a0ca16739822c68d$export$9e15abfeafdb1169({
        throwOnMissingProvider: false
    })) != null ? _a : {};
    if (!outputType) throw new Error("Using the <Personalize /> component requires the <UniformContext> provider to be present.");
    if (!$a0ca16739822c68d$var$isServer || outputType === "standard") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$PersonalizeStandard, {
        ...props
    });
    else if (outputType === "edge") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$PersonalizeEdge, {
        ...props
    });
    return null;
}
function $a0ca16739822c68d$var$TestEdge(props) {
    const { name: name, variations: variations, component: component } = props;
    const options = {
        name: name
    };
    const Component = component;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$EdgeTag, {
        "data-type": (0, $ajzpT.ScriptType).TestStart,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(options)
        }
    }), variations.map((variation, index)=>{
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), {
            key: variation.id
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$EdgeTag, {
            "data-type": (0, $ajzpT.ScriptType).ListItemSettings,
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    id: variation.id,
                    testDistribution: variation.testDistribution
                })
            }
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$EdgeTag, {
            "data-type": (0, $ajzpT.ScriptType).ListItem
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Component, {
            key: index,
            ...variation
        })));
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$EdgeTag, {
        "data-type": (0, $ajzpT.ScriptType).TestEnd
    }));
}
var $a0ca16739822c68d$var$TestStandard = ({ name: name, variations: variations, component: component, compositionMetadata: compositionMetadata })=>{
    const { context: context } = $a0ca16739822c68d$export$9e15abfeafdb1169();
    const { result: result } = context.test({
        name: name,
        variations: variations,
        compositionMetadata: compositionMetadata
    });
    if (!result) return null;
    const Component = component;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Component, {
        ...result
    });
};
// src/components/Test.tsx
var $a0ca16739822c68d$export$1b16fc9eb974a84d = (props)=>{
    var _a;
    const { outputType: outputType } = (_a = $a0ca16739822c68d$export$9e15abfeafdb1169({
        throwOnMissingProvider: false
    })) != null ? _a : {};
    if (!outputType) throw new Error("Using the <Test /> component requires the <UniformContext> provider to be present.");
    if (!$a0ca16739822c68d$var$isServer || outputType === "standard") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$TestStandard, {
        ...props
    });
    else if (outputType === "edge") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$TestEdge, {
        ...props
    });
    return null;
};
var $a0ca16739822c68d$var$useIsPersonalized = (options)=>{
    const { personalized: personalized } = (0, $1oC0p.useContext)($a0ca16739822c68d$var$PersonalizationContext);
    if (typeof personalized !== "undefined") return personalized;
    if (typeof (options == null ? void 0 : options.personalized) !== "undefined") return options.personalized;
    return false;
};
// src/components/Track.tsx
var $a0ca16739822c68d$export$13921ac0cc260818 = ({ behavior: behavior, children: children, tagName: tagName = "div", threshold: threshold = 0.5, disableVisibilityTrigger: disableVisibilityTrigger = typeof window === "undefined" || !("IntersectionObserver" in window), ...rest })=>{
    const currentUrl = typeof document === "undefined" ? "__uniform_ssr_url" : document.location.href;
    const { context: context } = $a0ca16739822c68d$export$9e15abfeafdb1169();
    const insidePersonalizeComponent = $a0ca16739822c68d$var$useIsPersonalized();
    const [lastUrl, setLastUrl] = (0, $1oC0p.useState)();
    const [hasTracked, setHasTracked] = (0, $1oC0p.useState)(false);
    const wrapperEl = (0, $1oC0p.useRef)(null);
    const disconnect = (0, $1oC0p.useRef)();
    (0, $1oC0p.useEffect)(()=>{
        const urlHasChanged = lastUrl !== currentUrl;
        if (urlHasChanged) {
            setHasTracked(false);
            setLastUrl(currentUrl);
        }
    }, [
        currentUrl,
        lastUrl
    ]);
    (0, $1oC0p.useEffect)(()=>{
        var _a;
        const hasNoBehaviorValue = !behavior || Array.isArray(behavior) && !behavior.length;
        const cannotTrack = insidePersonalizeComponent || hasNoBehaviorValue;
        if (cannotTrack || !wrapperEl.current) return;
        const enrichments = Array.isArray(behavior) ? behavior : [
            behavior
        ];
        const pushBehaviorEnrichment = ()=>{
            var _a2;
            if (hasTracked) return;
            context.update({
                enrichments: enrichments
            });
            setHasTracked(true);
            (_a2 = disconnect.current) == null || _a2.call(disconnect);
        };
        if (disableVisibilityTrigger) pushBehaviorEnrichment();
        else {
            (_a = disconnect.current) == null || _a.call(disconnect);
            const instance = new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting) pushBehaviorEnrichment();
            }, {
                threshold: threshold
            });
            instance.observe(wrapperEl.current);
            disconnect.current = ()=>{
                var _a2;
                return (_a2 = instance.disconnect) == null ? void 0 : _a2.call(instance);
            };
        }
        return ()=>{
            var _a2;
            (_a2 = disconnect.current) == null || _a2.call(disconnect);
        };
    }, [
        context,
        behavior,
        disableVisibilityTrigger,
        threshold,
        insidePersonalizeComponent,
        lastUrl,
        currentUrl,
        hasTracked
    ]);
    const debugProps = {};
    const element = (0, $1oC0p.createElement)(tagName, {
        ...debugProps,
        ...rest,
        ref: wrapperEl
    }, children);
    return element;
};
var $a0ca16739822c68d$export$a00da852751fef16 = ({ behavior: behavior, children: children })=>{
    const currentUrl = typeof document === "undefined" ? "__uniform_ssr_url" : document.location.href;
    const { context: context } = $a0ca16739822c68d$export$9e15abfeafdb1169();
    const insidePersonalizeComponent = $a0ca16739822c68d$var$useIsPersonalized();
    const [lastUrl, setLastUrl] = (0, $1oC0p.useState)();
    const [hasTracked, setHasTracked] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const urlHasChanged = lastUrl !== currentUrl;
        if (urlHasChanged) {
            setHasTracked(false);
            setLastUrl(currentUrl);
        }
    }, [
        currentUrl,
        lastUrl
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const hasNoBehaviorValue = !behavior || Array.isArray(behavior) && !behavior.length;
        const cannotTrack = insidePersonalizeComponent || hasNoBehaviorValue;
        if (cannotTrack) return;
        const pushBehaviorEnrichment = ()=>{
            if (hasTracked) return;
            const enrichments = Array.isArray(behavior) ? behavior : [
                behavior
            ];
            context.update({
                enrichments: enrichments
            });
            setHasTracked(true);
        };
        pushBehaviorEnrichment();
    }, [
        context,
        behavior,
        insidePersonalizeComponent,
        hasTracked
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
};
var $a0ca16739822c68d$export$3f6dec04ae507c15 = ({ context: context, children: children, outputType: outputType = "standard", trackRouteOnRender: trackRouteOnRender = true, includeTransferState: includeTransferState = "server-only" })=>{
    (0, $1oC0p.useEffect)(()=>{
        if ($a0ca16739822c68d$var$isServer || !trackRouteOnRender) return;
        context.update({
            url: new URL(window.location.href),
            cookies: (0, $8JMLR.parse)(document.cookie)
        });
    });
    const showTransferState = includeTransferState === "always" || includeTransferState === "server-only" && $a0ca16739822c68d$var$isServer;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$UniformContextContext.Provider, {
        value: {
            context: context,
            outputType: outputType
        }
    }, children, showTransferState ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($a0ca16739822c68d$var$TransferState, null) : null);
};
function $a0ca16739822c68d$var$TransferState() {
    const { context: context } = $a0ca16739822c68d$export$9e15abfeafdb1169();
    const transferState = context.getServerToClientTransitionState();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("script", {
        id: (0, $ajzpT.SERVER_STATE_ID),
        type: "application/json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(transferState)
        }
    });
}

});
parcelRegister("8JMLR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $65c85b9b76c5deb1$var$parse;
module.exports.serialize = $65c85b9b76c5deb1$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 */ const $65c85b9b76c5deb1$var$cookieNameRegExp = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 */ const $65c85b9b76c5deb1$var$cookieValueRegExp = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $65c85b9b76c5deb1$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $65c85b9b76c5deb1$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $65c85b9b76c5deb1$var$__toString = Object.prototype.toString;
const $65c85b9b76c5deb1$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $65c85b9b76c5deb1$var$parse(str, options) {
    const obj = new $65c85b9b76c5deb1$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $65c85b9b76c5deb1$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $65c85b9b76c5deb1$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $65c85b9b76c5deb1$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $65c85b9b76c5deb1$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $65c85b9b76c5deb1$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $65c85b9b76c5deb1$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $65c85b9b76c5deb1$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $65c85b9b76c5deb1$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$65c85b9b76c5deb1$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$65c85b9b76c5deb1$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$65c85b9b76c5deb1$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$65c85b9b76c5deb1$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$65c85b9b76c5deb1$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : options.sameSite;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $65c85b9b76c5deb1$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $65c85b9b76c5deb1$var$isDate(val) {
    return $65c85b9b76c5deb1$var$__toString.call(val) === "[object Date]";
}

});


parcelRegister("eSosQ", function(module, exports) {
$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $ad4915e603c65d9e$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $ad4915e603c65d9e$export$2e2bcd8739ae039 = fn;

});

parcelRegister("dZNgt", function(module, exports) {
$parcel$export(module.exports, "isPureTextAlign", function () { return $a3072fd4d6f8ea7f$export$8553002765ef8155; });
$parcel$export(module.exports, "isPureDirection", function () { return $a3072fd4d6f8ea7f$export$2d8458e4858dd6bc; });
$parcel$export(module.exports, "isRichTextNode", function () { return $a3072fd4d6f8ea7f$export$5397ae48e85521ee; });
$parcel$export(module.exports, "isRichTextValue", function () { return $a3072fd4d6f8ea7f$export$bce37bf8275274bb; });
$parcel$export(module.exports, "isRichTextNodeType", function () { return $a3072fd4d6f8ea7f$export$76356ac770fe566f; });
$parcel$export(module.exports, "isRichTextValueConsideredEmpty", function () { return $a3072fd4d6f8ea7f$export$3113f85f4f2c043b; });
$parcel$export(module.exports, "linkParamValueToHref", function () { return $a3072fd4d6f8ea7f$export$14401f8b485975ea; });
$parcel$export(module.exports, "getRichTextTagFromTableCellHeaderState", function () { return $a3072fd4d6f8ea7f$export$37fd5c6d3c00d303; });
$parcel$export(module.exports, "getRichTextTagsFromTextFormat", function () { return $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2; });
$parcel$export(module.exports, "walkRichTextTree", function () { return $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e; });
// src/elements.ts
var $a3072fd4d6f8ea7f$var$rendererTypeTagMap = /* @__PURE__ */ new Map([
    [
        "linebreak",
        [
            "br"
        ]
    ],
    [
        "quote",
        [
            "blockquote"
        ]
    ],
    [
        "code",
        [
            "pre",
            "code"
        ]
    ]
]);
function $a3072fd4d6f8ea7f$export$a4ec677d66b3eef3(text) {
    return text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $a3072fd4d6f8ea7f$export$8553002765ef8155(format) {
    return Boolean(format && [
        "center",
        "end",
        "justify",
        "left",
        "right",
        "start"
    ].includes(format));
}
function $a3072fd4d6f8ea7f$export$2d8458e4858dd6bc(direction) {
    return Boolean(direction && [
        "ltr",
        "rtl"
    ].includes(direction));
}
var $a3072fd4d6f8ea7f$var$voidElements = /* @__PURE__ */ new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "source",
    "track",
    "wbr"
]);
function $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, attributes, children) {
    const attributesString = attributes && attributes.size > 0 ? " " + Array.from(attributes).reduce((result, [key, value])=>[
            ...result,
            `${key}="${value}"`
        ], []).join(" ") : "";
    return $a3072fd4d6f8ea7f$var$voidElements.has(tag) ? `<${tag}${attributesString}>` : `<${tag}${attributesString}>${children != null ? children : ""}</${tag}>`;
}
// src/guards.ts
function $a3072fd4d6f8ea7f$export$70f15e3e004ad6dd(arr) {
    return Array.isArray(arr) && arr.length > 0;
}
function $a3072fd4d6f8ea7f$export$5397ae48e85521ee(node) {
    return !!node && typeof node === "object" && "type" in node;
}
function $a3072fd4d6f8ea7f$export$bce37bf8275274bb(value) {
    return typeof value === "object" && value !== null && "root" in value && $a3072fd4d6f8ea7f$export$5397ae48e85521ee(value.root);
}
function $a3072fd4d6f8ea7f$export$76356ac770fe566f(node, type) {
    return $a3072fd4d6f8ea7f$export$5397ae48e85521ee(node) && node.type === type;
}
function $a3072fd4d6f8ea7f$export$3113f85f4f2c043b(value) {
    if (!value) return true;
    if (value.root.children.length === 0) return true;
    if (value.root.children.length > 1) return false;
    const child = value.root.children[0];
    if (!$a3072fd4d6f8ea7f$export$76356ac770fe566f(child, "paragraph")) return false;
    return child.children === void 0 || child.children.length === 0;
}
function $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(node) {
    return "children" in node && $a3072fd4d6f8ea7f$export$70f15e3e004ad6dd(node.children);
}
// src/nodes/asset.ts
var $a3072fd4d6f8ea7f$export$7b8470edeb266d2d = ({ context: context })=>{
    var _a, _b;
    const node = context.currentNode;
    if (node.__asset === void 0) return "";
    if (node.__asset.type !== "image") return "";
    const imgAttributes = /* @__PURE__ */ new Map();
    imgAttributes.set("src", node.__asset.fields.url.value);
    if ((_a = node.__asset.fields.title) == null ? void 0 : _a.value) imgAttributes.set("alt", node.__asset.fields.title.value);
    const img = $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("img", imgAttributes);
    const figcaption = ((_b = node.__asset.fields.description) == null ? void 0 : _b.value) ? $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("figcaption", null, node.__asset.fields.description.value) : "";
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("figure", null, `${img}${figcaption}`);
};
// src/nodes/heading.ts
var $a3072fd4d6f8ea7f$export$bf6388ba992fa09c = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "h1", null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$headingTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/link.ts
var $a3072fd4d6f8ea7f$export$936fe693edb52ead = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    const href = $a3072fd4d6f8ea7f$export$14401f8b485975ea(node.link);
    if (href) attributes.set("href", href);
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("a", attributes, renderChildren(context.currentNode.children));
};
function $a3072fd4d6f8ea7f$export$14401f8b485975ea(link) {
    switch(link == null ? void 0 : link.type){
        case "email":
            return `mailto:${link.path}`;
        case "tel":
            return `tel:${link.path}`;
        case "url":
            return link.path;
        case "projectMapNode":
            return link.path;
    }
}
// src/nodes/list.ts
var $a3072fd4d6f8ea7f$export$7d9d55832c255604 = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (node.start > 1) attributes.set("start", node.start.toString());
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "ul", attributes, renderChildren(context.currentNode.children));
};
// src/nodes/listitem.ts
var $a3072fd4d6f8ea7f$export$7db814f6895f686a = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (Number.isFinite(node.value) && node.value > 0) attributes.set("value", node.value.toString());
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("li", attributes, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$listitemTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    if (!$a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode)) return "";
    const childrenRendered = renderChildren(context.currentNode.children);
    if (childrenRendered.endsWith(" ")) return childrenRendered;
    return `${childrenRendered} `;
};
// src/nodes/paragraph.ts
var $a3072fd4d6f8ea7f$export$8bcf4977d6029c8 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if ($a3072fd4d6f8ea7f$export$8553002765ef8155(node.format)) attributes.set("style", `text-align: ${node.format};`);
    if ($a3072fd4d6f8ea7f$export$2d8458e4858dd6bc(node.direction)) attributes.set("dir", node.direction);
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("p", attributes, $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "<br>");
};
var $a3072fd4d6f8ea7f$var$paragraphTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/root.ts
var $a3072fd4d6f8ea7f$export$1a6e4df79d5098f8 = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "";
};
// src/nodes/table.ts
var $a3072fd4d6f8ea7f$export$29b37b9cb24833f8 = ({ context: context, renderChildren: renderChildren })=>{
    return [
        "table",
        "tbody"
    ].reduceRight((children, tag)=>{
        return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
    }, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tableTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/tablecell.ts
var $a3072fd4d6f8ea7f$export$5bdbd5436df1f109 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const tag = $a3072fd4d6f8ea7f$export$37fd5c6d3c00d303(node.headerState);
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tablecellTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
function $a3072fd4d6f8ea7f$export$37fd5c6d3c00d303(headerState) {
    if (headerState === 0) return "td";
    return "th";
}
// src/nodes/tablerow.ts
var $a3072fd4d6f8ea7f$export$28c41253e2c9901a = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("tr", null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tablerowTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/text.ts
var $a3072fd4d6f8ea7f$export$56ed6376d093860 = ({ context: context })=>{
    const node = context.currentNode;
    const tags = $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2(node.format);
    const pureText = $a3072fd4d6f8ea7f$export$a4ec677d66b3eef3(node.text);
    return tags.length === 0 ? pureText : tags.reduceRight((children, tag)=>{
        return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
    }, pureText);
};
var $a3072fd4d6f8ea7f$var$textTextRenderer = ({ context: context })=>{
    const node = context.currentNode;
    return node.text;
};
function $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2(format) {
    const tags = [];
    if (format & 1) tags.push("strong");
    if (format & 2) tags.push("em");
    if (format & 4) tags.push("s");
    if (format & 8) tags.push("u");
    if (format & 16) tags.push("code");
    if (format & 32) tags.push("sub");
    if (format & 64) tags.push("sup");
    return tags;
}
// src/nodes/tab.ts
var $a3072fd4d6f8ea7f$var$tabHtmlRenderer = ()=>{
    return "	";
};
var $a3072fd4d6f8ea7f$var$tabTextRenderer = ()=>{
    return "	";
};
// src/renderToHtml.ts
var $a3072fd4d6f8ea7f$var$rendererTypeMap = /* @__PURE__ */ new Map([
    [
        "heading",
        $a3072fd4d6f8ea7f$export$bf6388ba992fa09c
    ],
    [
        "link",
        $a3072fd4d6f8ea7f$export$936fe693edb52ead
    ],
    [
        "list",
        $a3072fd4d6f8ea7f$export$7d9d55832c255604
    ],
    [
        "listitem",
        $a3072fd4d6f8ea7f$export$7db814f6895f686a
    ],
    [
        "paragraph",
        $a3072fd4d6f8ea7f$export$8bcf4977d6029c8
    ],
    [
        "root",
        $a3072fd4d6f8ea7f$export$1a6e4df79d5098f8
    ],
    [
        "text",
        $a3072fd4d6f8ea7f$export$56ed6376d093860
    ],
    [
        "tab",
        $a3072fd4d6f8ea7f$var$tabHtmlRenderer
    ],
    [
        "table",
        $a3072fd4d6f8ea7f$export$29b37b9cb24833f8
    ],
    [
        "tablecell",
        $a3072fd4d6f8ea7f$export$5bdbd5436df1f109
    ],
    [
        "tablerow",
        $a3072fd4d6f8ea7f$export$28c41253e2c9901a
    ],
    [
        "asset",
        $a3072fd4d6f8ea7f$export$7b8470edeb266d2d
    ]
]);
var $a3072fd4d6f8ea7f$export$28174e313edd87cd = (context)=>{
    const renderer = $a3072fd4d6f8ea7f$var$rendererTypeMap.get(context.currentNode.type);
    if (renderer) return renderer;
    const tags = $a3072fd4d6f8ea7f$var$rendererTypeTagMap.get(context.currentNode.type);
    if (tags) return ({ renderChildren: renderChildren })=>{
        var _a;
        return (_a = tags.reduceRight((children, tag)=>{
            return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
        }, $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : void 0)) != null ? _a : "";
    };
    return ()=>`<!-- WARNING: No renderer for type ${context.currentNode.type} -->`;
};
function $a3072fd4d6f8ea7f$var$initializeRenderContext(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return {
        ...parentContext != null ? parentContext : {},
        currentNode: node,
        ancestorNodes: ancestorNodes
    };
}
function $a3072fd4d6f8ea7f$export$32f1246b4326e182(node, parentContext) {
    var _a;
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return "";
    const context = $a3072fd4d6f8ea7f$var$initializeRenderContext(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $a3072fd4d6f8ea7f$export$28174e313edd87cd(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$a3072fd4d6f8ea7f$export$e4421ac256b62cb6(children, context);
    if (renderer) return renderer({
        context: context,
        renderChildren: renderChildren
    });
    else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $a3072fd4d6f8ea7f$export$e4421ac256b62cb6(children, context) {
    return Array.isArray(children) ? children.map((node)=>$a3072fd4d6f8ea7f$export$32f1246b4326e182(node, context)).join("") : "";
}
// src/nodes/linebreak.ts
var $a3072fd4d6f8ea7f$var$linebreakTextRenderer = ()=>{
    return " ";
};
// src/renderToText.ts
var $a3072fd4d6f8ea7f$var$rendererTypeMap2 = /* @__PURE__ */ new Map([
    [
        "text",
        $a3072fd4d6f8ea7f$var$textTextRenderer
    ],
    [
        "tab",
        $a3072fd4d6f8ea7f$var$tabTextRenderer
    ],
    [
        "linebreak",
        $a3072fd4d6f8ea7f$var$linebreakTextRenderer
    ],
    [
        "paragraph",
        $a3072fd4d6f8ea7f$var$paragraphTextRenderer
    ],
    [
        "listitem",
        $a3072fd4d6f8ea7f$var$listitemTextRenderer
    ],
    [
        "heading",
        $a3072fd4d6f8ea7f$var$headingTextRenderer
    ],
    [
        "table",
        $a3072fd4d6f8ea7f$var$tableTextRenderer
    ],
    [
        "tablecell",
        $a3072fd4d6f8ea7f$var$tablecellTextRenderer
    ],
    [
        "tablerow",
        $a3072fd4d6f8ea7f$var$tablerowTextRenderer
    ]
]);
var $a3072fd4d6f8ea7f$export$dd531e7b53a0cbec = (context)=>{
    const renderer = $a3072fd4d6f8ea7f$var$rendererTypeMap2.get(context.currentNode.type);
    if (renderer) return renderer;
    return ({ context: context2, renderChildren: renderChildren })=>{
        return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context2.currentNode) ? renderChildren(context2.currentNode.children) : "";
    };
};
function $a3072fd4d6f8ea7f$var$initializeRenderContext2(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return {
        ...parentContext != null ? parentContext : {},
        currentNode: node,
        ancestorNodes: ancestorNodes
    };
}
function $a3072fd4d6f8ea7f$export$f21c5276b1e9847a(node, parentContext) {
    var _a;
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return "";
    const context = $a3072fd4d6f8ea7f$var$initializeRenderContext2(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $a3072fd4d6f8ea7f$export$dd531e7b53a0cbec(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$a3072fd4d6f8ea7f$export$6ba9468a0a4c5ffc(children, context);
    if (renderer) {
        const rendered = renderer({
            context: context,
            renderChildren: renderChildren
        });
        return context.ancestorNodes.length > 0 ? rendered : rendered.trim();
    } else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $a3072fd4d6f8ea7f$export$6ba9468a0a4c5ffc(children, context) {
    return Array.isArray(children) ? children.map((node)=>$a3072fd4d6f8ea7f$export$f21c5276b1e9847a(node, context)).join("") : "";
}
// src/utils.ts
var $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e = (node, callback, parent)=>{
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return;
    callback(node, parent);
    if (Array.isArray(node.children)) {
        let i = 0;
        while(node.children.length > i){
            $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e(node.children[i], callback, node);
            i += 1;
        }
    }
};
var $a3072fd4d6f8ea7f$export$4593e5e0513f0a70 = [
    {
        label: "Heading 1",
        type: "h1"
    },
    {
        label: "Heading 2",
        type: "h2"
    },
    {
        label: "Heading 3",
        type: "h3"
    },
    {
        label: "Heading 4",
        type: "h4"
    },
    {
        label: "Heading 5",
        type: "h5"
    },
    {
        label: "Heading 6",
        type: "h6"
    },
    {
        label: "Bullet List",
        type: "unorderedList"
    },
    {
        label: "Ordered List",
        type: "orderedList"
    },
    {
        label: "Link",
        type: "link"
    },
    {
        label: "Blockquote",
        type: "quote"
    },
    {
        label: "Code Block",
        type: "code"
    },
    {
        label: "Table",
        type: "table"
    },
    {
        label: "Asset",
        type: "asset"
    },
    {
        label: "Dynamic Token",
        type: "variable"
    }
];
var $a3072fd4d6f8ea7f$export$1c57de179d11d54c = [
    {
        label: "Bold",
        type: "bold"
    },
    {
        label: "Italic",
        type: "italic"
    },
    {
        label: "Underline",
        type: "underline"
    },
    {
        label: "Strikethrough",
        type: "strikethrough"
    },
    {
        label: "Code",
        type: "code"
    },
    {
        label: "Superscript",
        type: "superscript"
    },
    {
        label: "Subscript",
        type: "subscript"
    }
];
var $a3072fd4d6f8ea7f$export$401e495ff5af005a = (type)=>{
    var _a;
    if (type === "paragraph") return "Normal";
    const element = $a3072fd4d6f8ea7f$export$4593e5e0513f0a70.find((element2)=>element2.type === type);
    return (_a = element == null ? void 0 : element.label) != null ? _a : type;
};
var $a3072fd4d6f8ea7f$export$419f7a872c5c801f = (type)=>{
    var _a;
    const format = $a3072fd4d6f8ea7f$export$1c57de179d11d54c.find((element)=>element.type === type);
    return (_a = format == null ? void 0 : format.label) != null ? _a : type;
};
var $a3072fd4d6f8ea7f$export$ea67c934009c1e06 = {
    root: {
        type: "root",
        version: 1,
        direction: null,
        format: "",
        indent: 0,
        children: [
            {
                type: "paragraph",
                version: 1,
                format: "start",
                indent: 0,
                direction: null,
                children: [],
                textFormat: 0,
                textStyle: ""
            }
        ]
    }
};
var $a3072fd4d6f8ea7f$export$730a30483768c78a = {
    required: false,
    formatting: {
        builtIn: $a3072fd4d6f8ea7f$export$1c57de179d11d54c.map((format)=>format.type)
    },
    elements: {
        builtIn: $a3072fd4d6f8ea7f$export$4593e5e0513f0a70.map((element)=>element.type)
    },
    elementsConfig: {
        asset: {
            allowedTypes: [
                "image"
            ]
        }
    }
};

});



parcelRegister("5cqxx", function(module, exports) {
$parcel$export(module.exports, "SECTION_DIVIDER_HEIGHTS", function () { return $5cd43511f2ec089b$export$d52c6e6227393e10; });
const $5cd43511f2ec089b$export$d52c6e6227393e10 = {
    mobile: 60,
    tablet: 80,
    desktop: 120
};

});

parcelRegister("bmJB7", function(module, exports) {
$parcel$export(module.exports, "spaceTokenValues", function () { return $97d097f5bec31277$export$e41352f00f500eea; });
const $97d097f5bec31277$export$e41352f00f500eea = {
    'space.0': '0',
    'space.025': '025',
    'space.050': '050',
    'space.075': '075',
    'space.100': '100',
    'space.150': '150',
    'space.200': '200',
    'space.250': '250',
    'space.300': '300',
    'space.400': '400',
    'space.500': '500',
    'space.600': '600',
    'space.800': '800',
    'space.1000': '1000'
};

});

parcelRegister("21Swq", function(module, exports) {
$parcel$export(module.exports, "updateStickyNavOffset", function () { return $746d550b4eee3230$export$55d684ebfd475810; });

var $gNr0R = parcelRequire("gNr0R");
const $746d550b4eee3230$export$55d684ebfd475810 = ()=>{
    // Ensure that the header height is recalculated when the component mounts
    if (0, $gNr0R.isClient) {
        const header = document.querySelector('header');
        const navs = document.querySelectorAll('nav');
        if (header || navs) {
            const headerHeight = header ? header.offsetHeight : 0;
            const navHeight = Array.from(navs).filter((nav)=>!nav.id.includes('side-nav') && (!header || !header.contains(nav))).reduce((total, n)=>total + n.offsetHeight, 0);
            document.documentElement.style.setProperty('--wae-header-height', `${headerHeight + navHeight}px`);
        }
    }
}; // example usage in UniformContainer component:
 //
 // useEffect(() => {
 //     updateStickyNavOffset();
 // }, []);

});

parcelRegister("3pCWN", function(module, exports) {
$parcel$export(module.exports, "generateSafeIds", function () { return $cd55c0b0d65c912a$export$6e55eb04cbe6e08b; });
/**
 * Generate safe IDs with fallback to prevent "panelundefined" and "tabundefined"
 * First tab (index 0) will be named "panel" and "tab" instead of "panel0" and "tab0"
 * Only applies when no ID is supplied - supplied IDs are used as-is
 */ function $cd55c0b0d65c912a$export$6e55eb04cbe6e08b(id, panelIndex) {
    const idString = id !== null && id !== undefined ? String(id) : '';
    const isValidId = id !== null && id !== undefined && idString !== 'undefined' && idString !== '' && idString !== 'null';
    let safeId;
    if (isValidId) safeId = id;
    else if (panelIndex !== null && panelIndex !== undefined && typeof panelIndex === 'number') safeId = panelIndex === 0 ? '' : panelIndex;
    else safeId = 'default';
    const safeIdString = String(safeId);
    return {
        panelId: `panel${safeIdString}`,
        tabId: `tab${safeIdString}`
    };
}

});


parcelRegister("6ltia", function(module, exports) {
$parcel$export(module.exports, "isDarkColor", function () { return $b5498c054a22c1d6$export$e14f59b6761c5109; });
/**
 * Calculates the relative luminance of a color using the WCAG formula
 * @param hexColor - Color in hex format (e.g., "#1868DB" or "1868DB")
 * @returns Relative luminance value between 0 and 1
 * @see https://www.w3.org/TR/WCAG20/#relativeluminancedef
 */ const $b5498c054a22c1d6$export$c852d90bf7403b62 = (hexColor)=>{
    // remove # if present
    const hex = hexColor.replace('#', '');
    // validate hex format
    if (!/^[0-9A-Fa-f]{6}$/.test(hex)) throw new Error(`Invalid hex color format: ${hexColor}. Expected format: #RRGGBB or RRGGBB`);
    // convert to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // calculate relative luminance using WCAG formula
    // L = 0.299 * R + 0.587 * G + 0.114 * B
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance;
};
const $b5498c054a22c1d6$export$e14f59b6761c5109 = (hexColor)=>{
    return $b5498c054a22c1d6$export$c852d90bf7403b62(hexColor) < 0.5;
};

});

parcelRegister("bSVv5", function(module, exports) {
$parcel$export(module.exports, "Image", function () { return $19cb10e6a9dd6c2e$export$3e431a229df88919; });
/* image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $19cb10e6a9dd6c2e$var$DOMAIN_ORANGE_LOGIC = 'atl.orangelogic.com';
const $19cb10e6a9dd6c2e$var$DOMAIN_CONTENTFUL = 'ctfassets.net';
const $19cb10e6a9dd6c2e$export$3e431a229df88919 = ({ src: src, alt: alt, caption: caption, ...rest })=>{
    if (!src) return null;
    // This is being positioned as the primary Design Image component going forward to more closely align with how images are used across WAC,
    // but it needs to be vetted and rolled out before it becomes a default
    const image = src.includes($19cb10e6a9dd6c2e$var$DOMAIN_ORANGE_LOGIC) ? /*#__PURE__*/ (0, $7VQPk.jsx)($19cb10e6a9dd6c2e$var$ImageOrangeLogic, {
        src: src,
        alt: alt,
        ...rest
    }) : src.includes($19cb10e6a9dd6c2e$var$DOMAIN_CONTENTFUL) ? /*#__PURE__*/ (0, $7VQPk.jsx)($19cb10e6a9dd6c2e$var$ImageContentful, {
        src: src,
        alt: alt,
        ...rest
    }) : // eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        loading: "lazy",
        ...rest,
        src: src,
        alt: alt
    });
    return caption ? /*#__PURE__*/ (0, $7VQPk.jsxs)("figure", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: [
            image,
            /*#__PURE__*/ (0, $7VQPk.jsx)("figcaption", {
                className: (0, $2jatx.default)([
                    "_1pfhu2gc",
                    "body-sm"
                ]),
                children: caption
            })
        ]
    }) : image;
};
/* CPAPI images are hosted on Contentful which allows transformations on images
https://www.contentful.com/developers/docs/references/images-api/#/reference/changing-formats

The basic piece is to convert all PNGs to webp,
but we can also do more with responsive images and srcset, etc
*/ const $19cb10e6a9dd6c2e$var$ImageContentful = ({ contentType: contentType, src: src, alt: alt, maxPossibleWidth: maxPossibleWidth, ...rest })=>{
    const queryPairs = [];
    let srcSet = [];
    if (contentType === 'image/png') queryPairs.push('fm=webp');
    if (maxPossibleWidth) {
        srcSet = $19cb10e6a9dd6c2e$export$1f415823d076ddbe(src, maxPossibleWidth, queryPairs);
        queryPairs.push(`w=${maxPossibleWidth}`);
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join('&')}` : '';
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        loading: "lazy",
        ...rest,
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(',') : undefined,
        alt: alt
    }));
};
const $19cb10e6a9dd6c2e$export$1f415823d076ddbe = (src, baseWidth, queryPairs)=>{
    return [
        baseWidth,
        baseWidth * 1.8,
        baseWidth * 2.6
    ].map((w, i)=>{
        const srcSetQueryPairs = [
            ...queryPairs,
            `w=${Math.ceil(w)}`
        ];
        return `${src}?${srcSetQueryPairs.join('&')} ${i + 1}x`;
    });
};
/*
OrangeLogic allows transformations on images
[TODO Find reference link]
*/ const $19cb10e6a9dd6c2e$var$ImageOrangeLogic = ({ contentType: contentType, src: src, alt: alt, maxPossibleWidth: maxPossibleWidth, className: className, ...rest })=>{
    let srcSet = [];
    const urlParts = $19cb10e6a9dd6c2e$export$af1599c6e466b2be(src);
    if (maxPossibleWidth && maxPossibleWidth > 0 && urlParts?.extension && urlParts.extension !== '.svg') srcSet = $19cb10e6a9dd6c2e$export$3655a1ad1ba6357e(urlParts, maxPossibleWidth);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        loading: "lazy",
        ...rest,
        // classNames to persist compiled css styles from the parent component
        className: (0, $2jatx.default)([
            "_1bsb1osq",
            className
        ]),
        src: src,
        srcSet: srcSet.length > 0 ? srcSet.join(',') : undefined,
        alt: alt
    });
};
const $19cb10e6a9dd6c2e$var$ASSET_LINK_LABEL = 'AssetLink';
const $19cb10e6a9dd6c2e$export$af1599c6e466b2be = (url)=>{
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    const parts = pathname.split('/');
    const labelIndex = parts.indexOf($19cb10e6a9dd6c2e$var$ASSET_LINK_LABEL);
    let assetId;
    if (labelIndex > -1) {
        const assetIdParts = parts[labelIndex + 1]?.split('.');
        assetId = assetIdParts?.[0];
    }
    const lastDotIndex = pathname.lastIndexOf('.');
    const extension = lastDotIndex > -1 ? pathname.substring(lastDotIndex) : undefined;
    const baseUrl = parsedUrl.origin;
    return {
        baseUrl: baseUrl,
        assetId: assetId,
        extension: extension
    };
};
const $19cb10e6a9dd6c2e$export$3655a1ad1ba6357e = (urlParts, baseWidth)=>{
    const { baseUrl: baseUrl, assetId: assetId, extension: extension } = urlParts;
    return [
        baseWidth,
        baseWidth * 1.8,
        baseWidth * 2.6
    ].map((w, i)=>{
        const transformParams = `/t/re_w_${Math.ceil(w)}/`;
        return `${baseUrl}/AssetLink/${assetId}${transformParams}${extension} ${i + 1}x`;
    });
};

});



parcelRegister("6fJ4x", function(module, exports) {
$parcel$export(module.exports, "partnerTemplatesDataUrlSlugs", function () { return $89e7561c9a227811$export$b7b5cb118a316bab; });
$parcel$export(module.exports, "testPartnerTemplatesData", function () { return $89e7561c9a227811$export$88e216f6036b695f; });
const $89e7561c9a227811$export$2b52c791239006bd = [
    {
        id: '7ckISKU5UGRFKMEQyFfmH1',
        name: 'Featured',
        urlSlug: 'featured',
        shortDescriptionOneLiner: 'Check out the latest and greatest templates from Confluence Cloud.',
        pageTitle: 'Featured Confluence Templates',
        description: null,
        experiment: false
    },
    {
        id: '7ckISKU5UGRFKMEQyFfmH2',
        name: 'Partners',
        urlSlug: 'partners',
        shortDescriptionOneLiner: 'Learn how the pros do it with templates from our partners.',
        pageTitle: 'Partner Templates',
        description: null,
        experiment: false
    },
    {
        id: '3L5l3wY9ZWRYMqVpAewmcG',
        name: 'Business Strategy',
        urlSlug: 'business-strategy',
        shortDescriptionOneLiner: 'Identify goals, assess risks, and implement business tactics with these business strategy templates.',
        pageTitle: 'Business Strategy Templates',
        description: null,
        experiment: false
    },
    {
        id: '3L5l3wY9ZWRYMqVpAewmcr',
        name: 'Design',
        urlSlug: 'design',
        shortDescriptionOneLiner: "Use Confluence\u2019s collection of design templates to create design systems, brainstorm ideas, and run design sprints like an expert.",
        pageTitle: 'Design Templates',
        description: null,
        experiment: false
    },
    {
        id: '3L5l3wY9ZWRYMqVpAewmc1',
        name: 'Docs & Reports',
        urlSlug: 'docs-and-reports',
        shortDescriptionOneLiner: 'Improve documentation and create great reports to share with your team and other stakeholders.',
        pageTitle: 'Docs & Reports Templates',
        description: null,
        experiment: false
    },
    {
        id: '3L5l3wY9ZWRYMqVpAewmc2',
        name: 'Human Resources',
        urlSlug: 'human-resources',
        shortDescriptionOneLiner: 'Simplify recruiting and employee development with these Confluence templates for HR pros.',
        pageTitle: 'Human Resources Templates',
        description: null,
        experiment: false
    },
    {
        id: '3L5l3wY9ZWRYMqVpAewmc3',
        name: 'Marketing & Sales',
        urlSlug: 'marketing-and-sales',
        shortDescriptionOneLiner: 'Write a creative brief, craft user personas, coordinate campaigns, and a whole lot more. Check out our top marketing and sales templates here.',
        pageTitle: 'Marketing & Sales Templates',
        description: null,
        experiment: false
    },
    {
        id: '3L5l3wY9ZWRYMqVpAewmc4',
        name: 'Personal',
        urlSlug: 'personal',
        shortDescriptionOneLiner: 'Jot down notes, organize your work, and much more in the safe space of Confluence.',
        pageTitle: 'Personal Templates',
        description: null,
        experiment: false
    },
    {
        id: '5K1kNHZzKqwQBpU3XThCQW',
        name: 'Product Management',
        urlSlug: 'product-management',
        shortDescriptionOneLiner: 'Master the product management lifecycle from brainstorming to launch with templates tailor-made for PMs.',
        pageTitle: 'Product Management Templates',
        description: null,
        experiment: false
    },
    {
        id: '5K1kNHZzKqwQBpU3XThCQ1',
        name: 'Productivity',
        urlSlug: 'productivity',
        shortDescriptionOneLiner: "Keep track of where you're going and what you need to accomplish with our productivity templates, including to-do lists, meeting notes and more.",
        pageTitle: 'Productivity Templates',
        description: null,
        experiment: false
    },
    {
        id: '5K1kNHZzKqwQBpU3XThCQ2',
        name: 'Project Planning',
        urlSlug: 'project-planning',
        shortDescriptionOneLiner: 'Oversee projects, report progress, and prepare for project deadlines and launches.',
        pageTitle: 'Project Planning Templates',
        description: null,
        experiment: false
    },
    {
        id: '5K1kNHZzKqwQBpU3XThCQ3',
        name: 'Software Development / IT',
        urlSlug: 'software-development',
        shortDescriptionOneLiner: 'Support your engineering team and develop products faster with our software and IT templates.',
        pageTitle: 'Software Development / IT Templates',
        description: null,
        experiment: false
    },
    {
        id: '5lnoDFfbaQh3DA2Ajm9WSH',
        name: 'Startup',
        urlSlug: 'startup',
        shortDescriptionOneLiner: 'Get started with resources for early-stage companies to help your team scale.',
        pageTitle: 'Startup Templates',
        description: null,
        experiment: false
    },
    {
        id: '5lnoDFfbaQh3DA2Ajm9WS1',
        name: 'Teamwork',
        urlSlug: 'teamwork',
        shortDescriptionOneLiner: 'Monitor the health of your teams and organize meeting minutes and notes.',
        pageTitle: 'Teamwork Templates',
        description: null,
        experiment: false
    }
];
const $89e7561c9a227811$export$854c18731465d750 = [
    {
        id: '7ckISKU5UGRFKMEQyFf223',
        name: 'Recommended templates',
        urlSlug: 'recommended',
        shortDescriptionOneLiner: 'Check out our personalized list of templates relevant to you and your team.',
        pageTitle: 'Recommended templates',
        description: null,
        experiment: false
    },
    {
        id: '3L5l3wY9ZWRYMqVpAewmc1',
        name: 'Human Resources',
        urlSlug: 'human-resources',
        shortDescriptionOneLiner: 'Simplify recruiting and employee development with these Confluence templates for HR pros.',
        pageTitle: 'Human Resources Templates',
        description: null,
        experiment: false
    },
    {
        id: '3L5l3wY9ZWRYMqVpAewmee',
        name: 'Design',
        urlSlug: 'design',
        shortDescriptionOneLiner: "Use Confluence\u2019s collection of design templates to create design systems, brainstorm ideas, and run design sprints like an expert.",
        pageTitle: 'Design Templates',
        description: null,
        experiment: false
    },
    {
        id: '5K1kNHZzKqwQBpU3XThw2Q3',
        name: 'Software Development & IT',
        urlSlug: 'software-development',
        shortDescriptionOneLiner: 'Support your engineering team and develop products faster with our software and IT templates.',
        pageTitle: 'Software Development / IT Templates',
        description: null,
        experiment: false
    },
    {
        id: '5K1kNHZzKqwQBpU3XThwww',
        name: 'Product Management',
        urlSlug: 'product-management',
        shortDescriptionOneLiner: 'Master the product management lifecycle from brainstorming to launch with templates tailor-made for PMs.',
        pageTitle: 'Product Management Templates',
        description: null,
        experiment: false
    }
];
const $89e7561c9a227811$export$b7b5cb118a316bab = [
    'team-homepage',
    'job-description',
    'experiment-plan-and-results',
    'design-sprint',
    'customer-impact-assessment',
    'project-status',
    'brainstorming',
    'business-plan-one-pager',
    'aws-architecture-diagram',
    'risk-assessment',
    'team-poster'
];
const $89e7561c9a227811$export$88e216f6036b695f = [
    {
        templateId: 'tXbjwEb4mL6WURJ4cq411',
        name: 'Team homepage',
        urlSlug: 'team-homepage',
        partnerDescription: 'Invite your organization at large to get to know your team.',
        contributor: {
            name: 'HubSpot',
            logo: [
                {
                    name: 'hubspot-logo',
                    size: 4833,
                    url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/hubspot-logo-full.webp',
                    height: 109,
                    width: 460
                }
            ]
        },
        previewBlurb: 'Invite your organization at large to get to know your team.',
        templateIcon: {
            name: 'HubSpot logo',
            size: 4833,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/hubspot-logo-full.webp',
            height: 64,
            width: 64
        },
        partnerImage: {
            name: 'hubspot',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-hubspot-media-kit.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: '2WbcCVrA7SH6ZVuXCsyDtu',
        name: 'Job description',
        urlSlug: 'job-description',
        partnerDescription: 'Finding the right talent starts here.',
        contributor: {
            name: 'Indeed',
            logo: [
                {
                    name: 'indeed-logo-full',
                    size: 74906,
                    url: '//images.ctfassets.net/xjcz23wx147q/49VpFL28CtHeNkuSH2F9lP/30d40c925537d3953199ca05ec30a9af/indeed-logo-full.svg',
                    height: 201,
                    width: 731
                }
            ]
        },
        previewBlurb: 'Use this template to build job descriptions that will attract the highest quality candidates.',
        templateIcon: {
            name: 'hiring-process',
            size: 6317,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:641d5550-46de-4938-8028-eb39e9c48f82/indeed-logo-full.svg?cdnVersion=1426',
            height: 64,
            width: 64
        },
        partnerImage: {
            name: 'indeed',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-indeed-unsplash.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: 'tXbjwEb4mL6WURJ4cq41D',
        name: 'Experiment plan and results',
        urlSlug: 'experiment-plan-and-results',
        partnerDescription: 'Streamline your process and improve your business.',
        contributor: {
            name: 'Optimizely',
            logo: [
                {
                    name: 'optimizely-logo',
                    size: 4833,
                    url: '//images.ctfassets.net/xjcz23wx147q/6UgZ8U62VhRebuxWTC6fx3/31d9d8888ef58eb6d73cfdb6c3e66570/optimizely-logo.png',
                    height: 109,
                    width: 460
                }
            ]
        },
        previewBlurb: 'Document the details of your experiment including your hypothesis, variations, and results.',
        templateIcon: {
            name: 'Optimizely logo',
            size: 420871,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:e2ed4cbc-94fd-494f-a04b-9646b797ef25/optimizely-logo-full.png?cdnVersion=1426',
            height: 64,
            width: 64
        },
        partnerImage: {
            name: 'optimizely',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-optimizely-unsplash.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: 'tXbjwEb4mL6WURJ4cq413',
        name: 'Design sprint ',
        urlSlug: 'design-sprint',
        partnerDescription: 'Run a well-planned print, understand design problems and brainstorm solutions. ',
        contributor: {
            name: 'Figma',
            logo: [
                {
                    name: 'figma-logo',
                    size: 4833,
                    url: 'https://wac-cdn.atlassian.com/dam/jcr:3a696f17-0629-4a92-895b-cdaf3fdd3d08/figma-logo-full.svg?cdnVersion=1392',
                    height: 109,
                    width: 460
                }
            ]
        },
        previewBlurb: 'Run a well-planned print, understand design problems and brainstorm solutions. ',
        templateIcon: {
            name: 'figma logo',
            size: 420871,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:3a696f17-0629-4a92-895b-cdaf3fdd3d08/figma-logo-full.svg?cdnVersion=1392',
            height: 64,
            width: 64
        },
        partnerImage: {
            name: 'figma',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-figma-unsplash.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: '38qTifwO0eMcG6r8Idr2c1',
        name: ' Customer impact assessment',
        urlSlug: 'customer-impact-assessment',
        partnerDescription: 'Make a change with zero pain with the right process. ',
        contributor: {
            name: 'ZENDESK',
            logo: [
                {
                    name: 'zendesk-logo',
                    size: 34708,
                    url: 'https://wac-cdn.atlassian.com/dam/jcr:6c868fb8-1f02-467b-b5a5-799502e17d82/zendesk-logo-full.png?cdnVersion=1418'
                }
            ]
        },
        previewBlurb: 'Make a change with zero pain with the right process. ',
        templateIcon: {
            name: 'Brainstorming icon',
            size: 9247,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:6c868fb8-1f02-467b-b5a5-799502e17d82/zendesk-logo-full.png?cdnVersion=1418',
            height: 236,
            width: 248
        },
        partnerImage: {
            name: 'zendesk',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-zendesk-unsplash.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: '3iLfGIDUjhn3vSBpnpzcNM',
        name: 'Project status',
        urlSlug: 'project-status',
        partnerDescription: 'Easily update your teams on project status using Confluence and Jira data.',
        contributor: {
            name: 'Arizona State University',
            logo: [
                {
                    name: 'arizona-state-university-logo',
                    size: 11030,
                    url: '//images.ctfassets.net/xjcz23wx147q/5JVzU07vgxDAgmfK1PQLS6/5ff1f25fd7df230329bc97219c35da6e/arizona-state-university-asu.svg',
                    height: 595,
                    width: 1813
                }
            ]
        },
        previewBlurb: 'Easily report progress on your projects to stakeholders using Confluence and Jira together.',
        templateIcon: {
            name: 'project-status-icon',
            size: 12929,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/asu-logo-full.webp',
            height: 64,
            width: 64
        },
        partnerImage: {
            name: 'arizonastateuniversity',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-asu-media-kit.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: '38qTifwO0eMcG6r8Idr2cH',
        name: 'Brainstorming',
        urlSlug: 'brainstorming',
        partnerDescription: ' Lead a super productive brainstorming session.',
        contributor: {
            name: 'MURAL',
            logo: [
                {
                    name: 'mural-logo',
                    size: 34708,
                    url: '//images.ctfassets.net/xjcz23wx147q/6HaL8jfJ8lZV0pPTuFarDS/12db840ecd288b695bf4601c2102c5e2/mural-139x26.svg'
                }
            ]
        },
        previewBlurb: 'Lead a super productive brainstorming session',
        templateIcon: {
            name: 'Brainstorming icon',
            size: 9247,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:642ced63-c988-4f5f-9ec4-34e0757d7d61/mural-logo-full.svg?cdnVersion=1426',
            height: 236,
            width: 248
        },
        partnerImage: {
            name: 'Brainstorming',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-mural-media-kit.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: '01p85VZkOsDbJaRMrZjqzW',
        name: 'Business plan one-pager',
        urlSlug: 'business-plan-one-pager',
        partnerDescription: 'Set your strategy (and stick to it) with a short and simple plan.',
        contributor: {
            name: 'Isos Technology',
            logo: [
                {
                    name: 'isos-logo',
                    size: 7862,
                    url: '//images.ctfassets.net/xjcz23wx147q/6sRPBfEdDyxaNiPh5scG7K/d92019fc67cabc1327bd18c5d0a247b5/isos-logo-full.png',
                    height: 225,
                    width: 800
                }
            ]
        },
        previewBlurb: 'Set your strategy (and stick to it) with a short and simple plan',
        templateIcon: {
            name: 'Isos logo',
            size: 8506,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/isos-logo-full.webp',
            height: 250,
            width: 212
        },
        partnerImage: {
            name: 'isostech',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-isos-unsplash.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: 'Aen4GRrwytCXzfh3VGboA',
        name: 'AWS architecture diagram',
        urlSlug: 'aws-architecture-diagram',
        partnerDescription: "Visualize your AWS network with this guide from Lucidchart\u2019s.",
        contributor: {
            name: 'Lucidchart',
            logo: [
                {
                    name: 'lucidchart-logo-full',
                    size: 8025,
                    url: '//images.ctfassets.net/xjcz23wx147q/2FoqenBRbSpjDs8tG0842m/aa85152afba56f04c3b2e70e9d1f6022/lucidchart-logo-full.png',
                    height: 150,
                    width: 600
                },
                {
                    name: 'lucidchat-pictorial-logo',
                    size: 2841,
                    url: '//images.ctfassets.net/xjcz23wx147q/48Wzj474xufBid0gFLHItY/e8175b3a56c0b6a56063c17e8def0558/aws-architecture-diagram.svg',
                    height: 64,
                    width: 64
                }
            ]
        },
        previewBlurb: 'Visualize your AWS network with this guide from Lucidchart',
        templateIcon: {
            name: 'lucidchat-pictorial-logo',
            size: 2841,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/lucidchart-logo-full.webp',
            height: 64,
            width: 64
        },
        partnerImage: {
            name: 'lucidchart',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-lucidchart-unsplash.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: '2lGZVe8PSvCrXFIjT4w4tC',
        name: 'Risk assessment matrix',
        urlSlug: 'risk-assessment',
        partnerDescription: 'Identify, prioritize, plan for (and avoid) worst-case scenarios.',
        contributor: {
            name: 'Stiltsoft',
            logo: [
                {
                    name: 'stiltsoft-logo-full',
                    size: 3822,
                    url: '//images.ctfassets.net/xjcz23wx147q/5q6RcuZ7KD8K0DT8OQs2w4/b249a1d8810e85d6f8378464b92d2333/stiltsoft-logo-full.svg',
                    height: 63,
                    width: 474
                }
            ]
        },
        previewBlurb: 'Identify and prioritize risks, then define what further actions you need to take to control.',
        templateIcon: {
            name: 'risk-assessment-icon',
            size: 11682,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:05d75cb9-faf0-4ebe-8b11-707adc1dbf58/stiltsoft-logo-full.svg?cdnVersion=1426',
            height: 64,
            width: 64
        },
        partnerImage: {
            name: 'Stiltsoft',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-stiltsoft-unsplash.webp',
            height: 64,
            width: 64
        }
    },
    {
        templateId: 'tXbjwEb4mL6WURJ4cq412',
        name: 'Team poster',
        urlSlug: 'team-poster',
        partnerDescription: 'Invite your organization at large to get to know your team.',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'atlassian-logo',
                    size: 4833,
                    url: 'https://wac-cdn.atlassian.com/dam/jcr:97f4fdbe-96d6-4c84-9ad3-e6f597d9ba37/logos-Atlassian-horizontal-blue-onecolor-rgb.svg?cdnVersion=1392',
                    height: 109,
                    width: 460
                }
            ]
        },
        previewBlurb: 'Invite your organization at large to get to know your team.',
        templateIcon: {
            name: 'Atlassian logo',
            size: 420871,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:97f4fdbe-96d6-4c84-9ad3-e6f597d9ba37/logos-Atlassian-horizontal-blue-onecolor-rgb.svg?cdnVersion=1426',
            height: 64,
            width: 64
        },
        partnerImage: {
            name: 'atlassian',
            size: 1137,
            url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-atlassian-thumbnail.webp',
            height: 64,
            width: 64
        }
    }
];
const $89e7561c9a227811$var$sampleSteps = {
    id: '',
    collectionSteps: [
        {
            id: '',
            stepDescription: 'Step 1'
        },
        {
            id: '',
            stepDescription: 'Step 2'
        },
        {
            id: '',
            stepDescription: 'Step 3'
        }
    ]
};
const $89e7561c9a227811$export$9578745d40b4ae81 = [
    {
        collectionId: '3ik7wHavyuXTaGC6kuLdAr',
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'Knowledge base icon',
            size: 8155,
            url: '//images.ctfassets.net/xjcz23wx147q/4qkSS5QJ1cT7R5uJbMAqMe/9827806bb0ecd039b5c0ddfceaff63d2/Knowledge_base.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: {
            ...$89e7561c9a227811$var$sampleSteps,
            collectionSteps: [
                ...$89e7561c9a227811$var$sampleSteps.collectionSteps,
                ...$89e7561c9a227811$var$sampleSteps.collectionSteps
            ]
        },
        name: 'Knowledge base templates to empower your ITSM teams',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'knowledge-base'
    },
    {
        collectionId: '7y4A5e4DukGLpsw2Y82tb6',
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'embrace-remote-work',
            size: 17503,
            url: '//images.ctfassets.net/xjcz23wx147q/3E4zNs0kiYj8n1q5b1vYI9/5c75145fe4fd1c24c51cb6d0100eaffe/embrace-remote-work.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Embrace remote work',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'remote-work'
    },
    {
        collectionId: '6y8eul7vGwE0qNYlvmfY6r',
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'start-your-product-development-strong',
            size: 8781,
            url: '//images.ctfassets.net/xjcz23wx147q/6g3GrmDju2QqQlJHxbJgaH/3b9cdaf7cb41eda9e1e10dc07b0942a1/start-your-product-development-strong.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Start strong with product development',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'product-launch'
    },
    {
        collectionId: '5tt7SIBtpeXiFpqLeMVNoQ',
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'create-effective-designs-at-scale',
            size: 5769,
            url: '//images.ctfassets.net/xjcz23wx147q/7dfqAeL5gybVJPpnsZpeDR/aa38e401dc29ff938a41b5b1eb6d9a64/create-effective-designs-at-scale.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Create effective designs at scale',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'designs-at-scale'
    },
    {
        collectionId: '6iSmUiUUnTA3aUH5J32WWo',
        aboutThisCollection: "Developing a marketing strategy is no small feat nor is it something you decide in an afternoon and never look at again. It\u2019s a blueprint for the future growth of your business, your method to creatively in order to stand out from your competition. Use this collection of templates to ensure you have all the information, research, and messaging you need to run a strategy that wins new customers.",
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'develop-a-marketing-strategy',
            size: 8119,
            url: '//images.ctfassets.net/xjcz23wx147q/4E52tjazaLHfNuVSPDQJLh/c6a9772f930df5dd8fd6b3541a2de93e/develop-a-marketing-strategy.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Templates for developing and executing on marketing strategies',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'marketing-strategy'
    },
    {
        collectionId: '6uHvaetmIdE2Tg5bgNdkkv',
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'Human resource templates collection icon',
            size: 19098,
            url: '//images.ctfassets.net/xjcz23wx147q/5udLs4sXtDAhyJt86QRfL0/af961f5a5ba4c5c5e687258bbfdf5859/Human_resource.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Human resource templates collection',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'hr'
    },
    {
        collectionId: '4SNJ54RF0ffN5vDdEYgZLm',
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'Free templates for product managers icon',
            size: 11250,
            url: '//images.ctfassets.net/xjcz23wx147q/4glb7QLDwcptCYw6cUqoLX/8ea9f86a939815d70d8bf23090934ec5/Product_managers.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Free templates for product managers',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'product-managers'
    },
    {
        collectionId: '2dzGklmVHNAr8AoA78It8m',
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'Strategic planning icon',
            size: 10750,
            url: '//images.ctfassets.net/xjcz23wx147q/6Bxo0Y6CwvWLTf8zf3D4xm/009f6b02ac599f22d87e44bb437bfe51/Strategic_planning.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Strategic planning templates',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'strategic-planning'
    },
    {
        collectionId: '6vwCMnz8wnVCxQI5Vmw79M',
        aboutThisCollectionHeader: 'About this collection',
        collectionIcon: {
            name: 'Project management icon',
            size: 17700,
            url: '//images.ctfassets.net/xjcz23wx147q/4XP2rbdIeeKMsFH8PhAhAq/40fb29aad42b9c554a5e404f0c53d3a7/Project_management.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Project management templates',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'project-management'
    },
    {
        collectionId: '7dHBMNb4S2pleQYqTKdLH1',
        aboutThisCollectionHeader: 'About this template',
        collectionIcon: {
            name: 'nailing-the-employee-development-lifecycle',
            size: 4413,
            url: '//images.ctfassets.net/xjcz23wx147q/7nEOM0fbrOQjCB87xfljyl/af0da7d687856fb56b24625187905682/nailing-the-employee-development-lifecycle.svg',
            height: 225,
            width: 208
        },
        howToUseThisCollection: $89e7561c9a227811$var$sampleSteps,
        name: 'Employee development templates',
        oneLinerHeadline: null,
        targetAudience: [],
        targetOrganizationSize: [],
        urlSlug: 'employee-development'
    }
];
const $89e7561c9a227811$export$509b560281ccf57b = [
    {
        templateId: '1od1B5ZbkxE7Wj1LF3tJUg',
        name: 'Strategic plan',
        urlSlug: 'annual-plan-one-pager',
        contributor: {
            name: 'Atlassian',
            tagline: 'Connect globally, meet locally. ',
            shortDescription: 'Atlassian is an enterprise software company that develops products for software developers, project managers, and content management.',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/f86abb82f4c010a0b2e5f5daa57aed7b/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    height: 150,
                    width: 540
                }
            ],
            industry: [
                {
                    name: 'Software & Design',
                    shortDescription: null
                }
            ]
        },
        previewBlurb: 'Capture and present your business strategy to the executive team and board of directors.',
        templateIcon: {
            name: 'business-strategy',
            size: 1123,
            url: '//images.ctfassets.net/xjcz23wx147q/2zGYT0BKy10XKLPS2m7YiJ/b54a2a6632f8a7fa1978cb43c097cf60/business-strategy.svg',
            height: 64,
            width: 64
        },
        oneLinerHeadline: 'Present your business vision and help your team understand your strategic plan',
        aboutThisTemplate: "<p>The meeting\u2019s scheduled. Your strategy\u2019s ready. Use the business strategy template to focus your thoughts before you present your vision and strategic plan to executive leadership and your team. Once everyone understands your strategy, use our template to organize how you\u2019ll get it done.</p>"
    },
    {
        templateId: '31d4aEberzjkvYKQ8n44Ua',
        name: '4Ls retrospective',
        urlSlug: '4-ls-retrospective',
        previewBlurb: 'Use this template to conduct a 4Ls retrospective with your team.',
        templateIcon: {
            name: '',
            size: 981,
            url: '//images.ctfassets.net/xjcz23wx147q/3mQwck0AMkvTR9OWmbRZ13/62ec77b3a1688d2120c1e98e0eaf9470/4-ls-retrospective.svg',
            height: 64,
            width: 64
        },
        contributor: {
            name: 'Atlassian'
        },
        oneLinerHeadline: 'Present your business vision and help your team understand your strategic plan',
        aboutThisTemplate: "<p>The meeting\u2019s scheduled. Your strategy\u2019s ready. Use the business strategy template to focus your thoughts before you present your vision and strategic plan to executive leadership and your team. Once everyone understands your strategy, use our template to organize how you\u2019ll get it done.</p>"
    },
    {
        oneLinerHeadline: 'Visually map project elements and phases to enhance collaboration, creativity, and clear communication.',
        templateId: '5TmCRGGKBO787ikpmuFmdC',
        name: 'Storyboard',
        urlSlug: 'storyboard',
        pluginModuleKey: 'whiteboard:storyboard',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    description: 'Atlassian',
                    contentType: 'image/svg+xml',
                    height: 150,
                    width: 540
                }
            ]
        },
        previewBlurb: 'Visually map project elements and phases to enhance collaboration, creativity, and clear communication.',
        templateIcon: {
            name: 'orange compass',
            size: 1069,
            url: '//images.ctfassets.net/xjcz23wx147q/5mHEuKFbJaShSUXs9rT7r/8bc6b01bc0201b69bea45b136e31cb71/orange_compass.svg',
            description: 'orange compass',
            contentType: 'image/svg+xml',
            height: 64,
            width: 64
        }
    },
    {
        oneLinerHeadline: 'Determine the root cause of an issue so you can correct it and prevent it from happening again.',
        templateId: '2RaEEfqb3kdvsAjzmwsAhp',
        name: 'Root cause analysis',
        urlSlug: 'root-cause-analysis',
        pluginModuleKey: 'whiteboard:root-cause-analysis',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    description: 'Atlassian',
                    contentType: 'image/svg+xml',
                    height: 150,
                    width: 540
                }
            ]
        },
        previewBlurb: 'Determine the root cause of an issue so you can correct it and prevent it from happening again.',
        templateIcon: {
            name: 'root cause',
            size: 1530,
            url: '//images.ctfassets.net/xjcz23wx147q/1Viyd8zZkdQFrako1yDQvU/d4cdffc5fdac2c3a982dc2568fc36c3f/root_cause.svg',
            description: 'root cause',
            contentType: 'image/svg+xml',
            height: 64,
            width: 64
        }
    },
    {
        oneLinerHeadline: 'Engage your stakeholders with a compelling executive summary.',
        templateId: '5VmMjamQzV7R3Kc8s8j6Dc',
        name: 'Executive summary',
        urlSlug: 'executive-summary',
        pluginModuleKey: 'whiteboard:executive-summary',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    description: 'Atlassian',
                    contentType: 'image/svg+xml',
                    height: 150,
                    width: 540
                }
            ]
        },
        previewBlurb: 'Engage your stakeholders with a compelling executive summary.',
        templateIcon: {
            name: 'executive summary',
            size: 979,
            url: '//images.ctfassets.net/xjcz23wx147q/7mkcp70u0q1S5BhJjb86Zb/efabd5726217eda0b42788133bfc1dda/colorkit__1_.svg',
            description: 'executive summary',
            contentType: 'image/svg+xml',
            height: 64,
            width: 64
        }
    },
    {
        oneLinerHeadline: 'Visualize and manage stakeholder relationships effortlessly.',
        templateId: 'UdR3Eu5xU9Fqn5czzy12f',
        name: 'Stakeholder mapping',
        urlSlug: 'stakeholder-mapping',
        pluginModuleKey: 'whiteboard:stakeholder-mapping',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    description: 'Atlassian',
                    contentType: 'image/svg+xml',
                    height: 150,
                    width: 540
                }
            ]
        },
        previewBlurb: 'Visualize and manage stakeholder relationships effortlessly.',
        templateIcon: {
            name: 'stakeholder',
            size: 1454,
            url: '//images.ctfassets.net/xjcz23wx147q/3GljwrDpF9T38tv5DGazZD/1653b6bb09c4d5b9f40d6c22fab175dc/colorkit__2_.svg',
            description: 'stakeholder',
            contentType: 'image/svg+xml',
            height: 64,
            width: 64
        }
    },
    {
        oneLinerHeadline: 'Outline tasks, deadlines, and responsibilities to streamline project management.',
        templateId: '2gS1aySwQ5QxchfO9w40tD',
        name: 'Action plan',
        urlSlug: 'action-plan',
        pluginModuleKey: 'whiteboard:action-plan',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    description: 'Atlassian',
                    contentType: 'image/svg+xml',
                    height: 150,
                    width: 540
                }
            ]
        },
        templatePreview: [
            {
                name: 'Action plan Template',
                size: 1367267,
                url: '//images.ctfassets.net/xjcz23wx147q/4Rs7ZxIGnrW4ylftHINTZn/71b9e1552b2e4f8bb8f03d59b0efcd70/Action_plan_Template.png',
                description: '',
                contentType: 'image/png',
                height: 3956,
                width: 5590
            }
        ],
        previewBlurb: 'Outline tasks, deadlines, and responsibilities to streamline project management.',
        templateIcon: {
            name: 'action plan',
            size: 1763,
            url: '//images.ctfassets.net/xjcz23wx147q/ydw9xcNPenHDtZdqRehfy/2d946d9d9892aec163dde14dd02b2373/colorkit.svg',
            description: 'action plan',
            contentType: 'image/svg+xml',
            height: 64,
            width: 64
        },
        category: [
            {
                id: '2y7zzkEt4A2t7p38WvTdVk',
                name: 'Project Planning',
                urlSlug: 'project-planning',
                shortDescriptionOneLiner: 'Oversee projects, report progress, and prepare for project deadlines and launches.',
                description: null,
                experiment: false
            },
            {
                id: '5WiLnaoQfSGi9MQAx9C3qP',
                name: 'Productivity',
                urlSlug: 'productivity',
                shortDescriptionOneLiner: "Keep track of where you're going and what you need to accomplish with our productivity templates, including to-do lists, meeting notes and more.",
                description: null,
                experiment: false
            }
        ],
        templateType: [
            {
                id: '1HlskYfRNciSnQ02SDhCPs',
                templateTypeName: 'Whiteboard'
            }
        ]
    },
    {
        oneLinerHeadline: 'Aid collaboration and decision-making by visualizing areas of overlap and differences ',
        templateId: '5XrDBPLAS4fuGMwYYyogGz',
        name: 'Venn diagram',
        urlSlug: 'venn-diagram',
        pluginModuleKey: 'whiteboard:venn-diagram',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    description: 'Atlassian',
                    contentType: 'image/svg+xml',
                    height: 150,
                    width: 540
                }
            ]
        },
        previewBlurb: 'Aid collaboration and decision-making by visualizing areas of overlap and differences ',
        templateIcon: {
            name: 'lightbulb',
            size: 1629,
            url: '//images.ctfassets.net/xjcz23wx147q/4r4KW9rTM9KJbI7qAWDlhg/8b0253f2344945c91d6ffe04338a71b9/red_light_bulb.svg',
            description: 'red lighbulb',
            contentType: 'image/svg+xml',
            height: 64,
            width: 64
        }
    },
    {
        oneLinerHeadline: 'Visually organize goals and align teams with strategic objectives using images, quotes, and critical ideas.',
        templateId: '4TXUuBydISenQDDVGqPspt',
        name: 'Vision board',
        urlSlug: 'vision-board',
        pluginModuleKey: 'whiteboard:vision-board',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    description: 'Atlassian',
                    contentType: 'image/svg+xml',
                    height: 150,
                    width: 540
                }
            ]
        },
        previewBlurb: 'Visually organize goals and align teams with strategic objectives using images, quotes, and critical ideas.',
        templateIcon: {
            name: 'vision green',
            size: 1161,
            url: '//images.ctfassets.net/xjcz23wx147q/12Z7neu8XssW0wqDevegjB/76146c9c3da7e57d155a8ef6d6e3fbbb/vision_green.svg',
            description: 'green eye',
            contentType: 'image/svg+xml',
            height: 64,
            width: 64
        }
    },
    {
        oneLinerHeadline: 'Visualize complex ideas and structure thoughts and relationships clearly with a concept map.',
        templateId: 'myk4F2b7OpOyOPecvKG4Z',
        name: 'Concept map',
        urlSlug: 'concept-map',
        pluginModuleKey: 'whiteboard:concept-map',
        contributor: {
            name: 'Atlassian',
            logo: [
                {
                    name: 'Atlassian Logo',
                    size: 3121,
                    url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
                    description: 'Atlassian',
                    contentType: 'image/svg+xml',
                    height: 150,
                    width: 540
                }
            ]
        },
        templatePreview: [
            {
                name: 'Concept Map',
                size: 1196608,
                url: '//images.ctfassets.net/xjcz23wx147q/4E2On1jD8u0ACoLrRLtoEI/98fc5ff96e6c617ece8171ed6b26a72c/Concept_Map.png',
                description: '',
                contentType: 'image/png',
                height: 3344,
                width: 5446
            }
        ],
        previewBlurb: 'Visualize complex ideas and structure thoughts and relationships clearly with a concept map.',
        templateIcon: {
            name: 'Writing guidelines template icon',
            size: 3257,
            url: '//images.ctfassets.net/xjcz23wx147q/3ISJnVflfZMmHRCkz7pgnY/11e3157b66407a88a8efd9c5f4d05c02/Screenshot_2024-01-22_at_3.42.30_PM.png',
            description: 'Writing guidelines template icon',
            contentType: 'image/png',
            height: 110,
            width: 112
        }
    }
];
const $89e7561c9a227811$export$a62db09738abefde = $89e7561c9a227811$export$509b560281ccf57b.map((template)=>template.templateId);

});

parcelRegister("hfzfc", function(module, exports) {
$parcel$export(module.exports, "ExperimentView", function () { return $575253490bcb9c9d$export$c539d512d4f3f800; });

var $1oC0p = parcelRequire("1oC0p");

var $gIKKj = parcelRequire("gIKKj");
/**
 * ExperimentView is a component that performs a check on an experiment and its value. It will render the children if the experiment is enrolled and the value matches the expected value, otherwise it will render the fallback element.
 * @param experiment The experiment to check.
 * @param indeterminate The fallback element to render if the experiment is indeterminate.
 * @param render The children to render if the experiment is enrolled and the value matches the expected value.
 * @returns The ReactNode from the render method if the experiment is enrolled or not enrolled, otherwise the indeterminate element.
 */ const $575253490bcb9c9d$var$ExperimentViewComponent = ({ experiment: experiment, indeterminate: indeterminate, notEnrolled: notEnrolled, render: render })=>{
    const experimentResult = (0, $gIKKj.useExperiment)(experiment);
    const shouldManuallyFireExposure = !experiment.options.fireExperimentExposure;
    // Track the last fired enrollment type to prevent re-firing on component re-renders
    const lastFiredEnrollmentRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (shouldManuallyFireExposure && experimentResult.type === 'enrolled' && experimentResult.type !== lastFiredEnrollmentRef.current) {
            experimentResult.fireExposure();
            lastFiredEnrollmentRef.current = 'enrolled';
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        experimentResult.type,
        shouldManuallyFireExposure
    ]);
    if (experimentResult.type === 'indeterminate' && indeterminate) return indeterminate;
    if (experimentResult.type === 'enrolled') return render(experimentResult.value);
    if (notEnrolled && experimentResult.type === 'notEnrolled') return notEnrolled;
    // render based on default value if not enrolled
    return render(experiment.defaultValue);
};
const $575253490bcb9c9d$export$c539d512d4f3f800 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo($575253490bcb9c9d$var$ExperimentViewComponent);

});

parcelRegister("ePBzs", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CATEGORY_SLUG", function () { return $c1b488c26e62912e$export$de3f30a556cb52c8; });
$parcel$export(module.exports, "DisplayedSlugs", function () { return $c1b488c26e62912e$export$d7bd06a99a9e0fd; });
$parcel$export(module.exports, "AdditionalSlugs", function () { return $c1b488c26e62912e$export$4ee35d119a2e78b0; });
$parcel$export(module.exports, "CategoryOrder", function () { return $c1b488c26e62912e$export$fcfa3a0e12afcc03; });
$parcel$export(module.exports, "CategoryTemplateOrder", function () { return $c1b488c26e62912e$export$9b3667c881290523; });
const $c1b488c26e62912e$export$de3f30a556cb52c8 = 'recommended';
const $c1b488c26e62912e$export$d7bd06a99a9e0fd = [
    $c1b488c26e62912e$export$de3f30a556cb52c8,
    'project-management',
    'software-development-and-it',
    'product-management',
    'marketing-and-sales',
    'design',
    'finance-and-operations',
    'human-resources'
];
const $c1b488c26e62912e$export$4ee35d119a2e78b0 = [
    'project-planning',
    'business-strategy',
    'productivity',
    'docs-and-reports',
    'startup',
    'personal'
];
const $c1b488c26e62912e$export$fcfa3a0e12afcc03 = {
    [$c1b488c26e62912e$export$de3f30a556cb52c8]: 1,
    'project-management': 2,
    'software-development-and-it': 3,
    'product-management': 4,
    'marketing-and-sales': 5,
    design: 6,
    'finance-and-operations': 7,
    'human-resources': 8,
    // Additional categories
    'project-planning': 9,
    'business-strategy': 10,
    productivity: 11,
    'docs-and-reports': 12,
    startup: 13,
    personal: 14
};
const $c1b488c26e62912e$export$9b3667c881290523 = {
    [$c1b488c26e62912e$export$de3f30a556cb52c8]: {
        'strategic-plan': 1,
        'project-plan': 2,
        flowchart: 3,
        'product-requirements': 4,
        'retrospective-whiteboard': 5,
        'vision-to-values': 6,
        brainstorming: 7,
        'business-status-update': 8,
        brainwriting: 9,
        'annual-plan-one-pager': 10,
        'product-roadmap': 11,
        'smart-goals': 12,
        'marketing-plan': 13,
        okrs: 14,
        'competitive-analysis': 15,
        'business-plan-one-pager': 16,
        'swot-analysis': 17,
        retrospective: 18,
        'meeting-notes': 19,
        'marketing-campaign': 20,
        decision: 21,
        'master-project-documentation': 22,
        'marketing-united': 23,
        'daily-stand-up': 24,
        'software-architecture-review': 25,
        'product-launch': 26,
        'devops-runbook': 27,
        'sales-account-planning': 28
    },
    'project-management': {
        'project-plan': 1,
        'strategic-plan': 2,
        'simple-retrospective': 3,
        'retrospective-whiteboard': 3,
        'vision-to-values': 4,
        brainstorming: 5,
        'product-vision-board': 6,
        'business-status-update': 7,
        'project-status': 8,
        'project-poster': 9,
        'smart-goals': 10,
        'kanban-board': 11,
        'kanban-board-whiteboard': 11,
        okrs: 12,
        'competitive-analysis': 13,
        'swot-analysis': 14,
        retrospective: 15,
        'meeting-notes': 16,
        'prioritization-matrix-whiteboard': 17,
        decision: 18,
        'master-project-documentation': 19,
        'daily-stand-up': 20,
        '4-ls-retro': 21,
        '4-ls-retro-whiteboard': 21,
        'team-poster': 22,
        'to-do-list': 23,
        'daily-sync': 24,
        'daily-sync-whiteboard': 24,
        'team-homepage': 25,
        'end-of-week-status-report': 26,
        'sprint-planning': 27,
        'sprint-planning-whiteboard': 27,
        '1-on-1-meeting': 28,
        'weekly-meeting-notes': 29,
        'roles-and-responsibilities': 30,
        timeline: 31,
        'timeline-whiteboard': 31,
        'my-user-manual': 32,
        'workshop-planner': 33,
        swimlanes: 34,
        'swimlane-diagram': 34,
        '5-whys-analysis': 35,
        'transition-plan': 36,
        '4-ls-retrospective': 37,
        'elevator-pitch-whiteboard': 38,
        'out-of-office-plan': 39,
        'project-kickoff': 40,
        'lean-coffee': 41,
        'risk-assessment': 42,
        'mvp-ideation': 43,
        'change-management-plan': 44,
        '90-day-plan': 45,
        '2x2-prioritization-method': 46,
        'dependency-mapping': 47,
        'work-trip-planner': 48,
        'mutual-action-plan': 49,
        'timeline-workflow': 50,
        'all-hands-meeting': 51,
        'design-your-ideal-workweek': 52,
        'voting-table': 53,
        'pi-planning': 54,
        'quarterly-check-in': 55,
        'working-agreements': 56,
        premortem: 57,
        'service-blueprint': 58,
        'executive-business-review': 59,
        'year-in-review': 60,
        'disruptive-brainstorming': 61,
        workflow: 62,
        'workflow-whiteboard': 62,
        'introductory-blog': 63,
        'project-team-health-monitor': 64,
        'presenter-mode': 65,
        'ooo-team-notification': 66,
        'virtual-event': 67,
        'ritual-reset': 68
    },
    'software-development-and-it': {
        'product-requirements': 1,
        'kanban-board': 2,
        'kanban-board-whiteboard': 2,
        'product-roadmap': 3,
        retrospective: 4,
        'software-architecture-review': 5,
        'incident-postmortem-whiteboard': 6,
        'how-to-article': 7,
        'it-project-poster': 8,
        'simple-retrospective': 9,
        'retrospective-whiteboard': 9,
        'itsm-runbook': 10,
        'concept-map': 11,
        'itsm-known-errors': 12,
        'daily-sync': 13,
        'daily-sync-whiteboard': 13,
        'sprint-planning-meeting': 14,
        workflow: 15,
        'workflow-whiteboard': 15,
        'experiment-plan-and-results': 16,
        'capacity-planning': 17,
        'pi-planning': 18,
        'incident-communication': 19,
        'sprint-planning': 20,
        'sprint-planning-whiteboard': 20,
        'itsm-change-management': 21,
        '4-ls-retro': 22,
        '4-ls-retro-whiteboard': 22,
        'risk-assessment': 23,
        'timeline-workflow': 24,
        'mvp-ideation': 25,
        'flow-chart': 26,
        flowchart: 26,
        'aws-architecture-diagram': 27,
        'troubleshooting-article': 28,
        'itsm-post-incident-review': 29,
        'product-roadmap-whiteboard': 30,
        'design-your-ideal-workweek': 31,
        'working-agreements': 32,
        'product-vision-board': 33,
        'incident-postmortem': 34,
        rice: 35,
        'itsm-weekly-major-incident-report': 36,
        'service-blueprint': 37,
        'devops-change-management': 38,
        timeline: 39,
        'timeline-whiteboard': 39,
        'project-team-health-monitor': 40,
        'service-team-health-monitor': 41
    },
    'product-management': {
        'strategic-plan': 1,
        'product-requirements': 2,
        'product-roadmap': 3,
        brainwriting: 4,
        'lennys-product-requirements': 5,
        'product-roadmap-whiteboard': 6,
        okrs: 7,
        'daily-stand-up': 8,
        'daily-sync': 9,
        'daily-sync-whiteboard': 9,
        'product-launch': 10,
        'kanban-board': 11,
        'kanban-board-whiteboard': 11,
        'simple-retrospective': 12,
        'retrospective-whiteboard': 12,
        'how-to-article': 13,
        rice: 14,
        'sprint-planning-meeting': 15,
        'lean-coffee': 16,
        'team-homepage': 17,
        'network-of-teams': 18,
        'team-mapping': 18,
        'experiment-plan-and-results': 19,
        'product-vision-board': 20,
        'capacity-planning': 21,
        'end-of-week-status-report': 22,
        '4-ls-retro': 23,
        '4-ls-retro-whiteboard': 23,
        'weekly-meeting-notes': 24,
        workflow: 25,
        'workflow-whiteboard': 25,
        'customer-journey-mapping': 26,
        'project-kickoff': 27,
        'mvp-ideation': 28,
        timeline: 29,
        'timeline-whiteboard': 29,
        'dependency-mapping': 30,
        'project-poster': 31,
        'timeline-workflow': 32,
        'customer-interview-report': 33,
        'startup-pitch-deck': 34,
        'pi-planning': 35,
        'voting-table': 36,
        'concept-map': 37,
        'working-agreements': 38,
        'crazy-8s-brainstorming': 39,
        'elevator-pitch': 40,
        'gap-analysis': 41,
        'executive-business-review': 42,
        'user-story-map': 43,
        'prioritization-matrix': 44,
        'sailboat-retro': 45,
        'sailboat-retrospective': 45,
        'year-in-review': 46,
        'problem-framing': 47,
        'goals-signals-measures': 48
    },
    'marketing-and-sales': {
        'marketing-plan': 1,
        'business-status-update': 2,
        'strategic-plan': 3,
        brainwriting: 4,
        'competitive-analysis': 5,
        'business-plan-one-pager': 6,
        'timeline-workflow': 7,
        'swot-analysis': 8,
        'content-strategy': 9,
        'meeting-notes': 10,
        'annual-calendar': 11,
        'marketing-campaign': 12,
        'user-story-map': 13,
        'master-project-documentation': 14,
        'gap-analysis': 15,
        'marketing-united': 16,
        'product-launch': 17,
        timeline: 18,
        'timeline-whiteboard': 18,
        'sales-account-planning': 19,
        'disruptive-brainstorm': 20,
        'disruptive-brainstorm-whiteboard': 20,
        'customer-journey-mapping': 21,
        'email-drip': 22,
        'crazy-8s-brainstorming': 23,
        'safe-lean-business-case': 24,
        'customer-interview-report': 25,
        'ice-breakers': 26,
        'creative-brief': 27,
        'dot-voting': 28,
        'message-house': 29,
        'sales-portal': 30,
        'elevator-pitch-whiteboard': 31,
        'stakeholder-communications': 32,
        'prioritization-matrix-whiteboard': 33,
        'customer-impact-assessment': 34,
        'sticky-note-pack': 35,
        'marketing-blog-post': 36,
        'presenter-mode': 37,
        'qtc-acquisition': 38,
        'ritual-reset': 39
    },
    design: {
        'design-system': 1,
        'content-strategy': 2,
        'concept-map': 3,
        'design-sprint': 4,
        'flow-chart': 5,
        flowchart: 5,
        'design-decision': 6,
        'sticky-note-pack': 7,
        persona: 8,
        'email-drip': 9,
        'product-roadmap-whiteboard': 10,
        brainwriting: 11,
        'writing-guidelines': 12,
        '4-ls-retro': 13,
        '4-ls-retro-whiteboard': 13,
        'disruptive-brainstorm': 14,
        'disruptive-brainstorm-whiteboard': 14,
        'design-component': 15,
        'user-story-map': 16,
        'annual-calendar': 17,
        'product-vision-board': 18,
        'design-review': 19,
        'sailboat-retro': 20,
        'sailboat-retrospective': 20,
        'content-design-glossary': 21,
        timeline: 22,
        'timeline-whiteboard': 22,
        'creative-brief': 23,
        '2x2-prioritization-method': 24,
        'message-house': 25,
        'crazy-8s-brainstorming': 26,
        'ice-breakers': 27,
        'disruptive-brainstorming': 28,
        'dot-voting': 29,
        sparring: 30,
        'org-chart': 31
    },
    'finance-and-operations': {
        'business-status-update': 1,
        'annual-plan-one-pager': 2,
        'competitive-analysis': 3,
        'annual-calendar': 4,
        'business-plan-one-pager': 5,
        'swot-analysis': 6,
        'master-project-documentation': 7,
        'sticky-note-pack': 8,
        'sales-account-planning': 9,
        'team-poster': 10,
        'to-do-list': 11,
        'project-status': 12,
        'service-blueprint': 13,
        'roles-and-responsibilities': 14,
        'change-management-plan': 15,
        'gap-analysis': 16,
        'safe-lean-business-case': 17,
        'mutual-action-plan': 18,
        'all-hands-meeting': 19,
        'startup-pitch-deck': 20,
        rice: 21,
        'sales-portal': 22,
        'elevator-pitch': 23,
        'lean-coffee': 24,
        'executive-business-review': 25,
        'stakeholder-communications': 26,
        'customer-impact-assessment': 27,
        timeline: 28,
        'timeline-whiteboard': 28,
        'vendor-agreement': 29,
        'remote-team-meeting': 30,
        'problem-framing': 31,
        'leadership-team-health': 32,
        'fundraising-database': 33,
        'qtc-acquisition': 34
    },
    'human-resources': {
        'team-poster': 1,
        'career-development-plan': 2,
        'annual-calendar': 3,
        '1-on-1-meeting': 4,
        'workshop-planner': 5,
        'org-chart': 6,
        'transition-plan': 7,
        'lennys-performance-review': 8,
        'ice-breakers': 9,
        '4-ls-retrospective': 10,
        'dot-voting': 11,
        'out-of-office-plan': 12,
        '90-day-plan': 13,
        '2x2-prioritization-method': 14,
        'hr-knowledge-base': 15,
        'performance-improvement-plan': 16,
        'team-formation-guide': 17,
        'team-charter': 17,
        'employee-handbook': 18,
        'work-trip-planner': 19,
        'all-hands-meeting': 20,
        timeline: 21,
        'timeline-whiteboard': 21,
        'hiring-process': 22,
        'daily-sync': 23,
        'daily-sync-whiteboard': 23,
        'quarterly-check-in': 24,
        'interview-feedback': 25,
        'network-of-teams': 26,
        'team-mapping': 26,
        'job-description': 27,
        'job-offer-letter': 28,
        'sticky-note-pack': 29,
        'introductory-blog': 30,
        'employee-promotion-letter': 31,
        swimlanes: 32,
        'swimlane-diagram': 32,
        'virtual-event': 33,
        'virtual-team-lunch': 34
    },
    // Additional categories
    productivity: {
        'to-do-list': 1,
        'end-of-week-status-report': 2,
        'daily-stand-up': 3,
        'dependency-mapping': 4,
        'my-user-manual': 5,
        'meeting-notes': 6,
        'weekly-meeting-notes': 7,
        'smart-goals': 8,
        '1-on-1-meeting': 9,
        retrospective: 10,
        'mutual-action-plan': 11,
        '5-whys-analysis': 12,
        'working-agreements': 13,
        decision: 14,
        'problem-framing': 15,
        'voting-table': 16,
        'out-of-office-plan': 17,
        'workshop-planner': 18,
        'all-hands-meeting': 19,
        'remote-team-meeting': 20,
        '4-ls-retrospective': 21,
        'work-trip-planner': 22,
        'itsm-post-incident-review': 23,
        'virtual-event': 24
    },
    startup: {
        'business-plan-one-pager': 1,
        'project-plan': 2,
        'startup-pitch-deck': 3,
        'product-requirements': 4,
        'team-homepage': 5,
        'strategic-plan': 6,
        'product-launch': 7,
        'roles-and-responsibilities': 8,
        'mvp-ideation': 9,
        okrs: 10,
        'project-kickoff': 11,
        'end-of-week-status-report': 12,
        brainstorming: 13,
        'swot-analysis': 14,
        'fundraising-database': 15,
        'risk-assessment': 16,
        'executive-business-review': 17,
        'problem-framing': 18,
        'smart-goals': 19,
        'goals-signals-measures': 20,
        'business-status-update': 21,
        'competitive-analysis': 22,
        'elevator-pitch': 23,
        'working-agreements': 24,
        'experiment-plan-and-results': 25,
        'year-in-review': 26,
        'daily-stand-up': 27,
        '5-whys-analysis': 28,
        'vision-to-values': 29,
        '1-on-1-meeting': 30,
        'introductory-blog': 31,
        'workshop-planner': 32,
        'remote-team-meeting': 33,
        sparring: 34,
        'all-hands-meeting': 35,
        'virtual-team-lunch': 36,
        '4-ls-retrospective': 37,
        'qtc-acquisition': 38
    },
    'business-strategy': {
        'strategic-plan': 1,
        'business-plan-one-pager': 2,
        'customer-journey-mapping': 3,
        'change-management-plan': 4,
        'swot-analysis': 5,
        okrs: 6,
        'business-status-update': 7,
        'smart-goals': 8,
        'roles-and-responsibilities': 9,
        'executive-business-review': 10,
        'mvp-ideation': 11,
        'startup-pitch-deck': 12,
        'annual-plan-one-pager': 13,
        '5-whys-analysis': 14,
        'elevator-pitch': 15,
        'problem-framing': 16,
        'vision-to-values': 17,
        'risk-assessment': 18,
        'leadership-team-health-monitor': 19,
        'vendor-agreement': 20,
        'all-hands-meeting': 21,
        'safe-lean-business-case': 22,
        'ritual-reset': 23,
        'itsm-change-management': 24,
        '4-ls-retrospective': 25,
        'fundraising-database': 26,
        'customer-impact-assessment': 27,
        'marketing-united': 28
    },
    'project-planning': {
        'project-plan': 1,
        'product-roadmap': 2,
        'master-project-documentation': 3,
        'dependency-mapping': 4,
        'project-status': 5,
        'end-of-week-status-report': 6,
        'project-kickoff': 7,
        'weekly-meeting-notes': 8,
        'project-poster': 9,
        'roles-and-responsibilities': 10,
        'daily-stand-up': 11,
        'capacity-planning': 12,
        'product-launch': 13,
        'change-management-plan': 14,
        retrospective: 15,
        'business-status-update': 16,
        'it-project-poster': 17,
        okrs: 18,
        'transition-plan': 19,
        'working-agreements': 19,
        'mvp-ideation': 20,
        'mutual-action-plan': 21,
        'smart-goals': 22,
        'goals-signals-measures': 23,
        brainstorming: 24,
        'workshop-planner': 25,
        decision: 26,
        'team-poster': 27,
        premortem: 28,
        'safe-lean-business-case': 29,
        'startup-pitch-deck': 30,
        'remote-team-meeting': 31,
        'ooo-team-notification': 32,
        'virtual-event': 33
    },
    'docs-and-reports': {
        'master-project-documentation': 1,
        'how-to-article': 2,
        'hr-knowledge-base': 3,
        'writing-guidelines': 4,
        'roles-and-responsibilities': 5,
        'design-component': 6,
        'design-your-ideal-workweek': 7,
        'troubleshooting-article': 8,
        'design-review': 9,
        'itsm-weekly-major-incident-report': 10,
        'vendor-agreement': 11,
        'itsm-known-errors': 12,
        'qtc-acquisition': 13
    },
    personal: {
        'to-do-list': 1,
        'my-user-manual': 2,
        'work-trip-planner': 3,
        'out-of-office-plan': 4,
        'year-in-review': 5,
        'transition-plan': 6,
        'quarterly-check-in': 7,
        'introductory-blog': 8,
        'ooo-team-notification': 9
    }
};

});

parcelRegister("lxcl6", function(module, exports) {
$parcel$export(module.exports, "TemplateHeroVariant", function () { return $e45f560f588e178c$export$d84a2033831b4316; });
/* template-hero-cfind-6457.tsx generated by @compiled/babel-plugin v0.28.8 */ /**
 * Treatment variant hero for the cfind_templates_hero_intent_value_v6 Switcheroo experiment.
 *
 * Replaces the default TemplateHeroSection with an intent-matched heading,
 * value proposition, social proof, yellow CTA, and a featured template card.
 *
 * @see https://switcheroo.atlassian.com/ui/gates/1ffdeb2c-8438-431a-9d14-e37309bc1143/key/cfind_templates_hero_intent_value_v6
 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");
const $e45f560f588e178c$var$messages = (0, $fnHPc.defineMessages)({
    heading: {
        id: 'confluence.templates.hero.variant.heading',
        defaultMessage: 'Free Project Templates for Confluence',
        description: 'Intent-matched heading for the templates hero experiment treatment'
    },
    valueProp: {
        id: 'confluence.templates.hero.variant.value-prop',
        defaultMessage: "Get a head start with ready-made templates for project plans, meeting notes, product specs, and 100+ more \u2014 all free with Confluence.",
        description: 'Value proposition text for the templates hero treatment'
    },
    socialProof: {
        id: 'confluence.templates.hero.variant.social-proof',
        defaultMessage: 'Trusted by 300,000+ teams worldwide',
        description: 'Social proof text for the templates hero treatment'
    },
    primaryCta: {
        id: 'confluence.templates.hero.variant.cta-primary',
        defaultMessage: 'Get started free',
        description: 'Primary CTA button text for the templates hero treatment'
    },
    secondaryCta: {
        id: 'confluence.templates.hero.variant.cta-secondary',
        defaultMessage: 'Browse all templates',
        description: 'Secondary CTA link text for the templates hero treatment'
    },
    trustBadge: {
        id: 'confluence.templates.hero.variant.trust-badge',
        defaultMessage: "Free forever \xb7 No credit card required",
        description: 'Trust badge text below primary CTA'
    },
    featuredTemplateTitle: {
        id: 'confluence.templates.hero.variant.featured-title',
        defaultMessage: 'Project Plan Template',
        description: 'Featured template card title'
    },
    featuredTemplateDescription: {
        id: 'confluence.templates.hero.variant.featured-description',
        defaultMessage: 'Define scope, timeline, milestones, and deliverables for any project.',
        description: 'Featured template card description'
    },
    learnMore: {
        id: 'confluence.templates.hero.variant.learn-more',
        defaultMessage: 'Learn more',
        description: 'Learn more link text on featured template card'
    }
});
const $e45f560f588e178c$export$d84a2033831b4316 = ()=>{
    const signupUrl = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=confluence');
    const templateUrl = (0, $jQ0cd.useLocalizedHref)('/software/confluence/templates/project-plan');
    const intl = (0, $8e22h.default)();
    const browseText = intl.formatMessage($e45f560f588e178c$var$messages.secondaryCta);
    const scrollToTemplates = ()=>{
        const tabsElement = document.getElementById('confluence-template-categories');
        tabsElement?.scrollIntoView({
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("header", {
            "data-testid": "template-hero-variant",
            className: (0, $2jatx.default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx2vrvc _4cvr1h6o _2rkogktf _1mou66rk _ca0qckbl _u5f38vuz _n3tdckbl _19bv8vuz _1bsb1osq _p12f15ao _11q73dpe _syaz1afi _1tke1hiv _195gcae7 _zulpckbl _91qczwfg _1eog1ylp _qjx3zwfg _1cel1ylp _5n7azwfg _1yytzwfg _1gde1bp4 _1n041tcg _1kmxzwfg _1ggm1tcg _1ykzzwfg _1mae1tcg _81641tcg _t95d7vkz"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_16jlcjiy _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _zulp7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect41vau _k48pbfng _1wyb1ady _vwz41btq _1cqszwfg"
                            ]),
                            style: {
                                "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...$e45f560f588e178c$var$messages.heading
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybl52n _k48p1nn1 _vwz4bs82 _syaz1bjw"
                            ]),
                            style: {
                                "--_lwvw50": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue100'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...$e45f560f588e178c$var$messages.valueProp
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _zulpftgi _1wybdlk8 _k48pbfng _syaz1bjw"
                            ]),
                            style: {
                                "--_lwvw50": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue100'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: "\u2B50"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...$e45f560f588e178c$var$messages.socialProof
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _zulp7vkz _1pfhftgi _1n261g80"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "primary_alt",
                                    href: signupUrl,
                                    "data-testid": "template-hero-variant-cta-primary",
                                    dataEventProps: {
                                        'data-product-key': 'confluence',
                                        'data-event': 'clicked',
                                        'data-event-component': 'button',
                                        'data-event-container': 'heroSection',
                                        'data-label': 'Get started free',
                                        'data-label-english': 'Get started free',
                                        'data-track-event': 'confluence-pt.templates.hero.cta-primary'
                                    },
                                    className: (0, $2jatx.default)([
                                        "_1rfm1osq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...$e45f560f588e178c$var$messages.primaryCta
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    text: browseText,
                                    "aria-label": browseText,
                                    href: "#confluence-template-categories",
                                    type: "primary",
                                    bgColor: "bgBlackBlue",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        scrollToTemplates();
                                    },
                                    dataEventProps: {
                                        'data-product-key': 'confluence',
                                        'data-event': 'clicked',
                                        'data-event-component': 'linkButton',
                                        'data-event-container': 'heroSection',
                                        'data-label': 'Browse all templates',
                                        'data-label-english': 'Browse all templates',
                                        'data-track-event': 'confluence-pt.templates.hero.cta-secondary'
                                    },
                                    anchorProps: {
                                        'data-testid': 'template-hero-variant-cta-secondary'
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            className: (0, $2jatx.default)([
                                "_1wybdlk8 _k48p1nn1 _syaz1bjw"
                            ]),
                            style: {
                                "--_lwvw50": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue100'))
                            },
                            children: [
                                "\u2713 ",
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...$e45f560f588e178c$var$messages.trustBadge
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_16jl6xdd _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1h6o _sugaglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bsb1osq _p12fxilx _bfhk1afi _2rko1crf _1reo15vq _18m915vq _16qst7xp"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_4t3i11ux _bfhk1bjw _1e0c1txw _4cvr1h6o _ca0qgktf _u5f31tcg _n3tdgktf _19bv1tcg _zulp7vkz"
                                ]),
                                style: {
                                    "--_lwvw50": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue100'))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1bsb1ylp _4t3i1ylp _2rkoftgi _bfhk5hrz _1e0c1txw _4cvr1h6o _1bah1h6o _syaz1afi _1wybgktf _1o9zidpf"
                                        ]),
                                        style: {
                                            "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue')),
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                                        },
                                        children: "\uD83D\uDCCB"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulpftgi _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3iftgi _2rko1y44 _bfhk6u2e"
                                                ]),
                                                style: {
                                                    width: '100%',
                                                    "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3iftgi _2rko1y44 _bfhk6u2e"
                                                ]),
                                                style: {
                                                    width: '85%',
                                                    "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3iftgi _2rko1y44 _bfhk6u2e"
                                                ]),
                                                style: {
                                                    width: '70%',
                                                    "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3iftgi _2rko1y44 _bfhk6u2e"
                                                ]),
                                                style: {
                                                    width: '55%',
                                                    "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300'))
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_ca0qgktf _u5f31tcg _n3tdgktf _19bv1tcg _1e0c1txw _2lx21bp4 _zulpftgi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb7vkz _k48pni7l _syaz1pfd"
                                        ]),
                                        style: {
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.black'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            ...$e45f560f588e178c$var$messages.featuredTemplateTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybw1gv _k48p1nn1 _syazk0sw _vwz419ii"
                                        ]),
                                        style: {
                                            "--_1e97w25": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light700'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            ...$e45f560f588e178c$var$messages.featuredTemplateDescription
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                        href: templateUrl,
                                        "data-testid": "template-hero-variant-card-cta",
                                        "data-product-key": "confluence",
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "heroSection",
                                        "data-label": "Learn more",
                                        "data-label-english": "Learn more",
                                        "data-track-event": "confluence-pt.templates.hero.featured-learn-more",
                                        className: (0, $2jatx.default)([
                                            "_1e0c116y _4cvr1h6o _zulp1y44 _ca0qftgi _u5f37vkz _n3tdftgi _19bv7vkz _1wybw1gv _k48pbfng _syaz5hrz _bfhk1j28 _19itj8n7 _2rkoi2wt _80omtlke _4bfu1r31 _1hmsglyw _ajmmnqa1 _1bsb1ns9 _19pk1y44 _irr31bjw"
                                        ]),
                                        style: {
                                            "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue')),
                                            "--_lwvw50": (0, $6ZVlx.default)((0, $bNzAT.default)('color.extended.blue100'))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                ...$e45f560f588e178c$var$messages.learnMore
                                            }),
                                            " \u2192"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
$e45f560f588e178c$export$d84a2033831b4316.displayName = 'TemplateHeroVariant';
// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const $e45f560f588e178c$var$containerStyles = null;
const $e45f560f588e178c$var$heroStyles = null;
const $e45f560f588e178c$var$leftColumnStyles = null;
const $e45f560f588e178c$var$headingStyles = null;
const $e45f560f588e178c$var$valueStyles = null;
const $e45f560f588e178c$var$socialProofStyles = null;
const $e45f560f588e178c$var$ctaContainerStyles = null;
const $e45f560f588e178c$var$primaryCtaStyles = null;
const $e45f560f588e178c$var$trustBadgeStyles = null;
const $e45f560f588e178c$var$rightColumnStyles = null;
const $e45f560f588e178c$var$cardStyles = null;
const $e45f560f588e178c$var$cardPreviewStyles = null;
const $e45f560f588e178c$var$cardIconStyles = null;
const $e45f560f588e178c$var$cardLinesStyles = null;
const $e45f560f588e178c$var$cardLineStyles = null;
const $e45f560f588e178c$var$cardBodyStyles = null;
const $e45f560f588e178c$var$cardTitleStyles = null;
const $e45f560f588e178c$var$cardDescriptionStyles = null;
const $e45f560f588e178c$var$cardCtaStyles = null;

});

parcelRegister("kb0X5", function(module, exports) {
$parcel$export(module.exports, "TemplateCategories", function () { return $46c61af71c722658$export$121dc1a9b075ffc; });
/* template-categories-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $iyOcM = parcelRequire("iyOcM");

var $dAWx1 = parcelRequire("dAWx1");

var $17RBn = parcelRequire("17RBn");

var $izdHQ = parcelRequire("izdHQ");

var $1ka2O = parcelRequire("1ka2O");
parcelRequire("7D10U");
var $ePBzs = parcelRequire("ePBzs");
var $7D10U = parcelRequire("7D10U");
const $46c61af71c722658$var$displayPanel = null;
const $46c61af71c722658$var$categoriesSearchContainer = null;
const $46c61af71c722658$var$categoriesContainer = null;
const $46c61af71c722658$var$localizedLinkForCategory = (locale, categoryId)=>{
    const prefix = locale === 'en' ? '' : `/${locale}`;
    if (categoryId === 'recommended') return `${prefix}/software/confluence/templates`;
    return `${prefix}/software/confluence/templates/categories/${categoryId}`;
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $46c61af71c722658$var$NOOP = ()=>{};
const $46c61af71c722658$var$TemplateCategoriesComponent = ({ categories: categories, onCategoryChange: onCategoryChange, onCategoryChangeIntent: onCategoryChangeIntent })=>{
    const locale = (0, $17RBn.useLocale)();
    const location = (0, $1ka2O.useLocation)();
    let currentSlug = (0, $7D10U.useCategorySlug)();
    // Use default slug if no category is selected and no search term is present.
    currentSlug = (0, $1oC0p.useMemo)(()=>{
        if (!currentSlug) {
            if (new URLSearchParams(location.search).get('term') === null) return 0, $ePBzs.DEFAULT_CATEGORY_SLUG;
        }
        return currentSlug;
    }, [
        currentSlug,
        location.search
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo1wug _kqsw1if8 _152t8vuz _1pbykb7n _bfhku67f _ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            id: "confluence-template-categories",
            className: (0, $2jatx.default)([
                "_1e0c1txw _1bsb1osq _zulp7vkz"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyOcM.Adg4Tabs), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $90TSV.Adg4DraggableTabList), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "data-testid": 'category-list',
                            className: (0, $2jatx.default)([
                                "_16jlkb7n _1o9zkb7n _i0dlgrho _1ul9idpf _1e0c1txw _zulpftgi _1bah1h6o _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                            ]),
                            children: categories.map((category)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dAWx1.Tile), {
                                        href: $46c61af71c722658$var$localizedLinkForCategory(locale, category.urlSlug),
                                        label: category.name,
                                        onFocus: category.urlSlug !== currentSlug ? ()=>onCategoryChangeIntent?.(category.urlSlug) : undefined,
                                        onMouseEnter: category.urlSlug !== currentSlug ? ()=>onCategoryChangeIntent?.(category.urlSlug) : undefined,
                                        onClick: category.urlSlug !== currentSlug ? ()=>onCategoryChange(category.urlSlug) : $46c61af71c722658$var$NOOP,
                                        isActive: category.urlSlug === currentSlug,
                                        icon: category.icon,
                                        iconHovered: category.iconHovered
                                    })
                                }, category.urlSlug))
                        })
                    })
                })
            })
        })
    });
};
const $46c61af71c722658$export$121dc1a9b075ffc = (0, $izdHQ.withFeatureExposed)('cfind-1795-refresh-template-categories', 'enrolled', $46c61af71c722658$var$TemplateCategoriesComponent);

});
parcelRegister("9s3Hk", function(module, exports) {
$parcel$export(module.exports, "Adg4DraggableTab", function () { return $6b3ca05235ecf326$export$fcab306d86bc97bb; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6jJHH = parcelRequire("6jJHH");

var $iyOcM = parcelRequire("iyOcM");
const $6b3ca05235ecf326$var$plainStyle = null;
/**
 * @deprecated - Please use @/libraries/design/patterns/tabs instead
 */ const $6b3ca05235ecf326$export$fcab306d86bc97bb = ({ id: id, focus: focus, tabIndex: tabIndex, label: label, dataEventProps: dataEventProps, className: className, children: children, as: Component = 'li', ...props })=>{
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $iyOcM.useAdg4TabsContext)();
    const startX = (0, $1oC0p.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $1oC0p.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
        // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            if (tabRef.current.parentElement?.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: 'smooth'
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event('select'));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        startX.current = e.clientX ?? 0;
        props.onMouseDown?.(e);
    };
    const onClick = (0, $1oC0p.useCallback)((e)=>{
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        props.onClick?.(e);
        if (isTabSelected) return;
        goToTab(tabIndex, true);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === 'Space' || e.code === 'Enter') {
            goToTab(tabIndex, true);
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)(Component, {
        ...props,
        ref: tabRef,
        className: (0, $2jatx.default)([
            "_1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _80omtlke _19itglyw _bfhk1j28 _uiztglyw",
            className
        ]),
        id: `tab${id}`,
        "aria-selected": isTabSelected,
        "aria-controls": `panel${id}`,
        "aria-label": label,
        title: label,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onKeyDown: onKeyDown,
        // Tech debt that should be fixed. See ldr/0012-jsx-a11y-strict.md for details.
        role: "tab",
        tabIndex: isTabSelected ? 0 : -1,
        ...dataEventProps,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isSelected: isTabSelected
            });
        })
    });
};
$6b3ca05235ecf326$export$fcab306d86bc97bb.tabsRole = 'Adg4Tab';

});

parcelRegister("90TSV", function(module, exports) {
$parcel$export(module.exports, "Adg4DraggableTabList", function () { return $e0d682756f666cea$export$6aebfd772942dd72; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iyOcM = parcelRequire("iyOcM");
const $e0d682756f666cea$export$6aebfd772942dd72 = ({ className: className, children: children, rowGap: rowGap = '16px', ...props })=>{
    const containerRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const mouseDown = (0, $1oC0p.useRef)(false);
    const startX = (0, $1oC0p.useRef)(0);
    const scrollLeft = (0, $1oC0p.useRef)(0);
    const canDrag = (0, $1oC0p.useRef)(false);
    const { onKeyDown: onKeyDown, tabListScrollRef: tabListScrollRef } = (0, $iyOcM.useAdg4TabsContext)();
    const startDragging = (mouse, touch)=>{
        if (!canDrag.current) return;
        // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener('mouseup', stopDragging);
        document.addEventListener('mousemove', move);
        mouseDown.current = true;
        startX.current = (touch && touch.touches[0] ? touch.touches[0].clientX : mouse?.clientX) ?? 0;
        scrollLeft.current = containerRef.current?.scrollLeft ?? 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
        // Stop listening for mouseup and mousemove events
        document.removeEventListener('mouseup', stopDragging);
        document.removeEventListener('mousemove', move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        // mouse.preventDefault();
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    // on resize, check if we can drag
    (0, $1oC0p.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        if (!containerRef.current) return;
        updateCanDrag();
        const observer = new ResizeObserver(()=>{
            // Use requestAnimationFrame to defer DOM updates and prevent ResizeObserver loop limit errors
            // This helps prevent the "ResizeObserver loop limit exceeded" warning by deferring DOM updates
            requestAnimationFrame(()=>{
                updateCanDrag();
            });
        });
        observer.observe(containerRef.current);
        return ()=>{
            // Cleanup the observer by unobserving all elements
            observer.disconnect();
        };
    }, [
        containerRef
    ]);
    const propsStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            ref: tabListScrollRef,
            onTouchStart: (e)=>startDragging(undefined, e),
            onMouseDown: (e)=>startDragging(e),
            onTouchEnd: (e)=>{
                move(undefined, e);
                stopDragging();
            },
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwx1wug _otyridpf _18u01wug _qtt8glyw _1bsb1ns9 _p12f1osq",
                "_zulp1k1x",
                className
            ]),
            tabIndex: -1,
            // Tech debt that should be fixed. See ldr/0012-jsx-a11y-strict.md for details.
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            role: "tablist",
            ...props,
            style: {
                "--_668noo": (0, $6ZVlx.default)(rowGap)
            },
            children: children
        })
    });
};
const $e0d682756f666cea$var$tabsContainerStyles = null;
const $e0d682756f666cea$var$wrapperStyle = null;
$e0d682756f666cea$export$6aebfd772942dd72.tabsRole = 'Adg4TabList';

});

parcelRegister("dAWx1", function(module, exports) {
$parcel$export(module.exports, "Tile", function () { return $8b18078b7678a9d5$export$235cb65c20ad2b7; });
/* tile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $8b18078b7678a9d5$var$rootCss = null;
const $8b18078b7678a9d5$var$rootInactiveCss = null;
const $8b18078b7678a9d5$var$rootActiveCss = null;
const $8b18078b7678a9d5$var$buttonResetStyle = null;
const $8b18078b7678a9d5$var$imageContainerCss = null;
const $8b18078b7678a9d5$var$labelCss = null;
const $8b18078b7678a9d5$var$labelActiveCss = null;
const $8b18078b7678a9d5$export$235cb65c20ad2b7 = (props)=>{
    const ElementType = props.href ? 'a' : 'button';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)(ElementType, {
        href: props.href,
        onClick: (e)=>{
            e.preventDefault();
            props.onClick();
        },
        onMouseEnter: props.onMouseEnter,
        onFocus: props.onFocus,
        className: (0, $2jatx.default)([
            "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _d0altlke",
            "_1e0c1txw _1bsb1llu _1tke1l8a _ca0q19bv _u5f3ftgi _n3td1crf _19bvftgi _2lx21bp4 _4cvr1h6o _1bah1yb4 _1o9zidpf _2rkogktf _19it6akv _bfhk1ret _ju49glyw _1123glyw _i9qz1ule _16qsdtw3",
            props.isActive ? "_19it7514" : "_19itd01g"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1ylp _4t3i1ylp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "tile-icon",
                        children: props.icon
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "tile-icon-hovered",
                        children: props.iconHovered !== undefined && !props.isActive ? props.iconHovered : props.icon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_syazqlpt _y3gn1h6o _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz47vkz _16jlkb7n _1e0c1txw _2lx21bp4 _1bah1h6o",
                    props.isActive && "_k48p1fw0"
                ]),
                children: props.label
            })
        ]
    });
};

});

parcelRegister("7D10U", function(module, exports) {
$parcel$export(module.exports, "parseCategorySlug", function () { return $d3a6098afce7f735$export$59d3f99bb6a1345a; });
$parcel$export(module.exports, "useCategorySlug", function () { return $d3a6098afce7f735$export$5287abfd57aa87f9; });
$parcel$export(module.exports, "DEFAULT_CATEGORY_SLUG", function () { return (parcelRequire("ePBzs")).DEFAULT_CATEGORY_SLUG; });

var $1oC0p = parcelRequire("1oC0p");

var $1ka2O = parcelRequire("1ka2O");

var $ePBzs = parcelRequire("ePBzs");
const $d3a6098afce7f735$export$59d3f99bb6a1345a = (pathname)=>{
    let slug = null;
    const [segment, prefix] = pathname.split('/').reverse();
    if (prefix === 'categories') slug = segment ?? slug;
    return slug;
};
const $d3a6098afce7f735$export$5287abfd57aa87f9 = ()=>{
    const { pathname: pathname } = (0, $1ka2O.useLocation)();
    return (0, $1oC0p.useMemo)(()=>$d3a6098afce7f735$export$59d3f99bb6a1345a(pathname), [
        pathname
    ]);
};

});


parcelRegister("2lca6", function(module, exports) {
$parcel$export(module.exports, "TemplateInitialSearchResultsRelayQuery", function () { return $ef1799d87dfbef1c$export$fee2596ff0f50842; });
$parcel$export(module.exports, "parseSearchQuery", function () { return $ef1799d87dfbef1c$export$6298490de4ddc3eb; });
$parcel$export(module.exports, "TemplateInitialSearchResults", function () { return $ef1799d87dfbef1c$export$9413a327540cb4c1; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $ePBzs = parcelRequire("ePBzs");
parcelRequire("7D10U");
var $ePBzs = parcelRequire("ePBzs");
var $7D10U = parcelRequire("7D10U");

var $7t71d = parcelRequire("7t71d");
var $ef1799d87dfbef1c$var$_templateInitialSearchResultsContentfulRelayQuery;

const $ef1799d87dfbef1c$export$fee2596ff0f50842 = $ef1799d87dfbef1c$var$_templateInitialSearchResultsContentfulRelayQuery !== void 0 ? $ef1799d87dfbef1c$var$_templateInitialSearchResultsContentfulRelayQuery : ($ef1799d87dfbef1c$var$_templateInitialSearchResultsContentfulRelayQuery = (parcelRequire("h0B3T")), $ef1799d87dfbef1c$var$_templateInitialSearchResultsContentfulRelayQuery.hash && $ef1799d87dfbef1c$var$_templateInitialSearchResultsContentfulRelayQuery.hash !== "0a051c0ee28540a725e60d886cd79ce5" && console.error("The definition of 'templateInitialSearchResultsContentfulRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $ef1799d87dfbef1c$var$_templateInitialSearchResultsContentfulRelayQuery);
function $ef1799d87dfbef1c$var$buildWhereClause(value) {
    const filters = {
        templateIds: [],
        urlSlugs: [],
        categoryUrlSlugs: []
    };
    if (Array.isArray(value) && value.length < 1) // An empty array of templateIds indicates that we received no recomendations
    // from the service, so we should fall back to showing the default category.
    value = null;
    if (Array.isArray(value)) filters['templateIds'] = value;
    else if (value?.type === 'template' && value.id) filters['urlSlugs'] = [
        value.id
    ];
    else {
        const categorySlug = value?.type === 'category' ? value.id : (0, $ePBzs.DEFAULT_CATEGORY_SLUG);
        const orderedTemplates = (0, $ePBzs.CategoryTemplateOrder)[categorySlug];
        if (orderedTemplates) filters['urlSlugs'] = Array.from(Object.keys(orderedTemplates));
        else filters['categoryUrlSlugs'] = [
            categorySlug
        ];
    }
    return filters;
}
function $ef1799d87dfbef1c$var$isLocation(value) {
    return value != null && typeof value !== 'string' && !Array.isArray(value) && !value.type;
}
function $ef1799d87dfbef1c$export$6298490de4ddc3eb(searchTerm) {
    let whereClause;
    if ($ef1799d87dfbef1c$var$isLocation(searchTerm)) {
        const id = (0, $7D10U.parseCategorySlug)(searchTerm.pathname);
        whereClause = $ef1799d87dfbef1c$var$buildWhereClause(id ? {
            type: 'category',
            id: id
        } : null);
    } else whereClause = $ef1799d87dfbef1c$var$buildWhereClause(searchTerm);
    let first = 9;
    // if the whereClause has conditions that amount to more than `first`,
    // we need to set the first to the necessary count to fullfill the where clause.
    if (whereClause['templateIds']) first = Math.max(first, whereClause['templateIds'].length);
    if (whereClause['urlSlugs']) first = Math.max(first, whereClause['urlSlugs'].length);
    if (whereClause['categoryUrlSlugs']) first = Math.max(first, whereClause['categoryUrlSlugs'].length);
    return {
        first: first,
        whereClause: whereClause
    };
}
const $ef1799d87dfbef1c$export$9413a327540cb4c1 = ({ urlSlugs: urlSlugs, templateIds: templateIds, categoryUrlSlugs: categoryUrlSlugs, limit: limit, skip: skip, locale: locale, searchKey: searchKey, sortLookup: sortLookup })=>{
    const { initialSearchResults: initialSearchResults } = (0, $f3gS9.useLazyLoadQuery)($ef1799d87dfbef1c$export$fee2596ff0f50842, {
        urlSlugs: urlSlugs,
        templateIds: templateIds,
        categoryUrlSlugs: categoryUrlSlugs,
        limit: limit,
        skip: skip,
        locale: locale
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7t71d.TemplatePaginatedSearchResults), {
        initialSearchResults: initialSearchResults,
        urlSlugs: [
            ...urlSlugs
        ],
        templateIds: [
            ...templateIds
        ],
        categoryUrlSlugs: [
            ...categoryUrlSlugs
        ],
        limit: limit,
        skip: skip,
        locale: locale,
        sortLookup: sortLookup
    }, searchKey);
};

});
parcelRegister("7t71d", function(module, exports) {
$parcel$export(module.exports, "TemplatePaginatedSearchResults", function () { return $64b355595ceca4a8$export$34d7ee3ccf5488b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");

var $aHkxS = parcelRequire("aHkxS");

var $8yRjz = parcelRequire("8yRjz");
var $64b355595ceca4a8$var$_templatePaginatedSearchResultsContentfulRelayRefetchableFragment;
const $64b355595ceca4a8$export$90091b93f6cf4241 = 9;
function $64b355595ceca4a8$var$hasPage(pages, page) {
    return pages.some((p)=>{
        return p.templates?.items?.length === page.templates?.items?.length && p.templates?.total === page.templates?.total;
    });
}
function $64b355595ceca4a8$var$sortBy(// @ts-ignore
items, sortBy) {
    if (!sortBy) return [
        ...items
    ];
    if (sortBy === 'templateNameExternal') return [
        ...items
    ].sort((a, b)=>a.templateNameExternal && b.templateNameExternal ? a.templateNameExternal.localeCompare(b.templateNameExternal) : a.templateNameExternal ? -1 : 1);
    return [
        ...items
    ].sort((a, b)=>{
        const aRank = a.urlSlug ? sortBy[a.urlSlug] : undefined;
        const bRank = b.urlSlug ? sortBy[b.urlSlug] : undefined;
        // Sort by rank 1 is higher than 2
        // if aRank is undefined, it should be sorted lower than bRank
        if (aRank === undefined) return bRank === undefined ? 0 : 1;
        if (bRank === undefined) return -1;
        return aRank - bRank;
    });
}
function $64b355595ceca4a8$var$dataToPages(data, sortLookup) {
    if (!data.templates?.items) return [
        data
    ];
    const items = data.templates.items;
    if (items.length > $64b355595ceca4a8$export$90091b93f6cf4241) {
        const sortedItems = $64b355595ceca4a8$var$sortBy(items, sortLookup);
        const initialItems = sortedItems.slice(0, $64b355595ceca4a8$export$90091b93f6cf4241);
        const additionalItems = sortedItems.slice($64b355595ceca4a8$export$90091b93f6cf4241);
        return [
            {
                ...data,
                templates: {
                    ...data.templates,
                    items: initialItems
                }
            },
            {
                ...data,
                templates: {
                    ...data.templates,
                    items: additionalItems
                }
            }
        ];
    }
    return [
        data
    ];
}

const $64b355595ceca4a8$export$e030e6c15fa0f6b4 = $64b355595ceca4a8$var$_templatePaginatedSearchResultsContentfulRelayRefetchableFragment !== void 0 ? $64b355595ceca4a8$var$_templatePaginatedSearchResultsContentfulRelayRefetchableFragment : ($64b355595ceca4a8$var$_templatePaginatedSearchResultsContentfulRelayRefetchableFragment = (parcelRequire("6dChG")), $64b355595ceca4a8$var$_templatePaginatedSearchResultsContentfulRelayRefetchableFragment.hash && $64b355595ceca4a8$var$_templatePaginatedSearchResultsContentfulRelayRefetchableFragment.hash !== "251a112050a3678aba1b8b73da60c6b5" && console.error("The definition of 'templatePaginatedSearchResultsContentfulRelayRefetchableFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $64b355595ceca4a8$var$_templatePaginatedSearchResultsContentfulRelayRefetchableFragment);
// @ts-ignore
const $64b355595ceca4a8$var$filterConfluenceTemplates = (items)=>{
    // @ts-ignore
    return items.filter((item)=>{
        const productNameId = item.productCollection?.items?.[0]?.productNameReference?.productNameId;
        return productNameId === 'confluence';
    });
};
const $64b355595ceca4a8$export$34d7ee3ccf5488b = ({ initialSearchResults: initialSearchResults, urlSlugs: urlSlugs, templateIds: templateIds, categoryUrlSlugs: categoryUrlSlugs, limit: limit, skip: skip, locale: locale, sortLookup: sortLookup = 'templateNameExternal', wasPreloaded: wasPreloaded = false })=>{
    const [loadMorePending, startLoadMore] = (0, $1oC0p.useTransition)();
    const [currentPage, setCurrentPage] = (0, $1oC0p.useState)(1);
    const [data, refetchFragment] = (0, $f3gS9.useRefetchableFragment)($64b355595ceca4a8$export$e030e6c15fa0f6b4, initialSearchResults);
    const [prevSearchParams, setPrevSearchParams] = (0, $1oC0p.useState)({
        urlSlugs: urlSlugs,
        templateIds: templateIds,
        categoryUrlSlugs: categoryUrlSlugs,
        limit: limit,
        skip: skip,
        locale: locale
    });
    const [prevData, setPrevData] = (0, $1oC0p.useState)(data);
    /** A ref to the latest refetch request. */ const refetchRef = (0, $1oC0p.useRef)();
    const [paginatedSearchResults, setPaginatedSearchResults] = (0, $1oC0p.useState)(()=>$64b355595ceca4a8$var$dataToPages(data, sortLookup));
    const resetSearchResults = (0, $1oC0p.useCallback)((data)=>{
        setCurrentPage(1);
        setPaginatedSearchResults(data ? $64b355595ceca4a8$var$dataToPages(data, sortLookup) : []);
    }, [
        sortLookup
    ]);
    const addSearchResults = (0, $1oC0p.useCallback)((data)=>{
        const pagesToAdd = $64b355595ceca4a8$var$dataToPages(data, sortLookup).filter((newPage)=>!$64b355595ceca4a8$var$hasPage(paginatedSearchResults, newPage));
        if (pagesToAdd.length > 0) setPaginatedSearchResults((prev)=>[
                ...prev,
                ...pagesToAdd
            ]);
    }, [
        paginatedSearchResults,
        sortLookup
    ]);
    const [hasNextPage, setHasNextPage] = (0, $1oC0p.useState)(currentPage < paginatedSearchResults.length);
    (0, $1oC0p.useEffect)(()=>{
        setHasNextPage(currentPage < paginatedSearchResults.length);
    }, [
        currentPage,
        paginatedSearchResults
    ]);
    const currentSearchResults = (0, $1oC0p.useMemo)(()=>{
        const results = paginatedSearchResults.slice(0, currentPage).reduce((acc, { templates: templates })=>({
                ...acc,
                // @ts-ignore
                items: [
                    ...acc.items,
                    ...templates?.items ?? []
                ],
                total: templates?.total ?? 0
            }), {
            items: [],
            total: 0
        });
        // Filter to only include Confluence templates
        const filteredResults = {
            ...results,
            // @ts-ignore
            items: $64b355595ceca4a8$var$filterConfluenceTemplates(results.items)
        };
        return filteredResults;
    }, [
        currentPage,
        paginatedSearchResults
    ]);
    const loadMore = (0, $1oC0p.useCallback)(()=>{
        if (hasNextPage) {
            setCurrentPage((prev)=>prev + 1);
            const nextSkip = (currentPage - 1) * limit;
            startLoadMore(()=>{
                refetchRef.current?.dispose();
                refetchRef.current = refetchFragment({
                    urlSlugs: urlSlugs,
                    templateIds: templateIds,
                    categoryUrlSlugs: categoryUrlSlugs,
                    limit: limit,
                    skip: nextSkip,
                    locale: locale
                });
            });
        }
    }, [
        hasNextPage,
        currentPage,
        limit,
        refetchFragment,
        urlSlugs,
        templateIds,
        categoryUrlSlugs,
        locale
    ]);
    // Reset the search results when the search query changes,
    // or add search results when the data changes.
    (0, $1oC0p.useEffect)(()=>{
        const arraysEqual = (a, b)=>a === b || !!a && !!b && a.length === b.length && a.every((v, i)=>v === b[i]);
        const searchParamsChanged = !arraysEqual(prevSearchParams.urlSlugs, urlSlugs) || !arraysEqual(prevSearchParams.templateIds, templateIds) || !arraysEqual(prevSearchParams.categoryUrlSlugs, categoryUrlSlugs) || prevSearchParams.limit !== limit || prevSearchParams.skip !== skip || prevSearchParams.locale !== locale;
        if (searchParamsChanged) {
            setPrevSearchParams({
                urlSlugs: urlSlugs,
                templateIds: templateIds,
                categoryUrlSlugs: categoryUrlSlugs,
                limit: limit,
                skip: skip,
                locale: locale
            });
            setPrevData(data);
            resetSearchResults(data);
        } else if (prevData !== data) {
            setPrevData(data);
            addSearchResults(data);
        }
    }, [
        addSearchResults,
        data,
        prevData,
        prevSearchParams,
        resetSearchResults,
        urlSlugs,
        templateIds,
        categoryUrlSlugs,
        limit,
        skip,
        locale
    ]);
    // TODO: Figure out if this is the right place to do this.
    // Reinitialize tracking when displayed templates changes.
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        currentSearchResults
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8yRjz.TemplateCardGrid), {
        // @ts-ignore
        templates: currentSearchResults,
        hasNextPage: hasNextPage,
        onLoadMore: loadMore,
        initialAnimation: !wasPreloaded,
        loadMorePending: loadMorePending
    });
};

});
parcelRegister("8yRjz", function(module, exports) {
$parcel$export(module.exports, "TemplateCardGrid", function () { return $90c94bab75eb6826$export$f056ebcbe4e91b54; });
/* template-card-grid-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $64WSq = parcelRequire("64WSq");

var $cml5G = parcelRequire("cml5G");

var $1Ztwq = parcelRequire("1Ztwq");
const $90c94bab75eb6826$var$gridStyles = null;
const $90c94bab75eb6826$var$gridContainerStyles = null;
const $90c94bab75eb6826$var$gridItemStyles = null;
const $90c94bab75eb6826$var$gridItemVisibleStyles = null;
const $90c94bab75eb6826$var$inViewAnimation = null;
const $90c94bab75eb6826$var$buttonStyle = null;
const $90c94bab75eb6826$export$dfa39f9572fef8d2 = [
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg1.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg2.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg3.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg4.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg5.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg6.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg7.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg8.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg9.svg)'
];
const $90c94bab75eb6826$export$f056ebcbe4e91b54 = ({ templates: templates, hasNextPage: hasNextPage, onLoadMore: onLoadMore, loadMorePending: loadMorePending = false, initialAnimation: initialAnimation = true })=>{
    const [shouldShowCards, setShouldShowCards] = (0, $1oC0p.useState)(!initialAnimation);
    const [shouldAnimate, setShouldAnimate] = (0, $1oC0p.useState)(initialAnimation);
    const [pageOffset, setPageOffset] = (0, $1oC0p.useState)(0);
    const [previousTemplates, setPreviousTemplates] = (0, $1oC0p.useState)(templates);
    if (previousTemplates !== templates) {
        if (templates?.items.length && previousTemplates?.items.length && templates?.items.length <= previousTemplates?.items.length) setPageOffset(0);
        else setPageOffset(previousTemplates?.items.length ?? 0);
        setPreviousTemplates(templates);
        setShouldShowCards(false);
        setShouldAnimate(true);
    }
    (0, $1oC0p.useEffect)(()=>{
        let timeoutid;
        if (!shouldShowCards) timeoutid = setTimeout(()=>{
            setShouldShowCards(true);
        }, 100);
        return ()=>{
            clearTimeout(timeoutid);
        };
    }, [
        shouldShowCards
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-template-card-grid",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "template-card-grid",
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: templates?.items.length === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    ...(0, $cml5G.ConfluenceTemplateMessages).noTemplatesAvailableText
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _qtt8glyw _1x8w1vji _bozgidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _zulpvbgk _nvs8pl2w _e6atzwfg _1bah1h6o"
                        ]),
                        children: [
                            templates?.items.map((template, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    style: {
                                        '--offset': index - pageOffset
                                    },
                                    "data-testid": `template-card-grid-item-${index}`,
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1txw _1n261g80 _tzy4idpf _t9ec13hh",
                                        (shouldShowCards || index < pageOffset) && "_tzy4kb7n _t9ec161g",
                                        shouldShowCards && shouldAnimate && index >= pageOffset && "_v564p5ws _1lwwgs82"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Ztwq.TemplateCard), {
                                        // @ts-ignore
                                        template: template,
                                        background: $90c94bab75eb6826$export$dfa39f9572fef8d2[index % $90c94bab75eb6826$export$dfa39f9572fef8d2.length]
                                    })
                                }, `${template?.sys?.id}-${index}`)),
                            loadMorePending && Array.from({
                                length: // @ts-ignore
                                3 - templates?.items.length % 3
                            }, (_, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1txw _1n261g80 _tzy4idpf _t9ec13hh",
                                        "_tzy4kb7n _t9ec161g"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $64WSq.SkeletonTemplateCard), {
                                        index: // @ts-ignore
                                        templates?.items.length + index,
                                        background: $90c94bab75eb6826$export$dfa39f9572fef8d2[// @ts-ignore
                                        (templates?.items.length + index) % $90c94bab75eb6826$export$dfa39f9572fef8d2.length]
                                    })
                                }, `placeholder-${// @ts-ignore
                                templates?.items.length + index}`))
                        ]
                    }),
                    hasNextPage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                        variant: "secondary",
                        size: "small",
                        color: 'black',
                        style: {
                            marginTop: '60px',
                            textAlign: 'center'
                        },
                        onClick: ()=>onLoadMore?.(),
                        dataEventProps: {
                            'data-product-key': 'confluence',
                            'data-event': 'clicked',
                            'data-event-component': 'linkButton',
                            'data-event-container': 'templatesSection',
                            'data-label': 'load-more-templates-button',
                            'data-label-english': 'Load more templates',
                            'data-track-event': 'confluence.load-more-templates.cta'
                        },
                        className: (0, $2jatx.default)([
                            "_1bsbdlvw _4t3i1ady _1bah1h6o _4cvr1h6o _1e0c1txw _zulp19bv _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $cml5G.ConfluenceTemplateMessages).loadMoreTemplatesButtonText
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("64WSq", function(module, exports) {
$parcel$export(module.exports, "SkeletonTemplateCard", function () { return $c9ef0857174f8890$export$26a64434b86f8af4; });
/* skeleton-template-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
const $c9ef0857174f8890$var$skeletonTemplateCardContainerStyles = null;
const $c9ef0857174f8890$var$skeletonTemplateCardImageStyles = null;
const $c9ef0857174f8890$var$skeletonTemplateCardInfoStyles = null;
const $c9ef0857174f8890$var$skeletonTemplateCardInfoWrapper = null;
const $c9ef0857174f8890$var$skeletonTemplateCardTitleStyles = null;
const $c9ef0857174f8890$var$skeletonTemplateCardDescriptionContainerStyles = null;
const $c9ef0857174f8890$var$skeletonTemplateCardDescriptionStyles = null;
const $c9ef0857174f8890$var$skeletonTemplateCardInfoAuthorStyles = null;
const $c9ef0857174f8890$var$PERCENTS = [
    10,
    5,
    25,
    15,
    20
];
const $c9ef0857174f8890$export$26a64434b86f8af4 = ({ background: background, index: index })=>{
    const titleLine = 40 + ($c9ef0857174f8890$var$PERCENTS[index % $c9ef0857174f8890$var$PERCENTS.length] ?? 0) + '%';
    const descLine1 = 100 - ($c9ef0857174f8890$var$PERCENTS[index % $c9ef0857174f8890$var$PERCENTS.length] ?? 0) + '%';
    const descLine2 = 60 + ($c9ef0857174f8890$var$PERCENTS[index % $c9ef0857174f8890$var$PERCENTS.length] ?? 0) + '%';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _2rkoi2wt _1bsb1feq _1tke1kdj _16qs58tj _1reo15vq _18m915vq _vchhusvi _v5641vti _1dbzdtw3 _12rrnklw _1llynklw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _1bah1yb4 _1reo15vq _18m915vq _4t3i1osq _1wpz1fhb"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_16jlidpf _1o9zkb7n _i0dluuw1 _1reo15vq _18m915vq _938ridpf _1tihkb7n _1oqbuuw1 _1lrw1dfr _12vemgnk _1o9zidpf",
                        "_11q7izeb"
                    ]),
                    style: {
                        "--_1k9t07z": (0, $6ZVlx.default)(background)
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_16jlkb7n _1o9zkb7n _i0dlf1ug _bfhku67f _1e0c1txw _2lx21bp4 _1bah1yb4 _ca0q1tcg _u5f31tcg _n3td7vkz _19bv1tcg _2rkoi2wt _4t3i1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            style: {
                                width: titleLine
                            },
                            className: (0, $2jatx.default)([
                                "_4t3i1ul9 _bfhk4m1f _2rko1l7b _1kne1f4h"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulp1y44"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    style: {
                                        width: descLine1
                                    },
                                    className: (0, $2jatx.default)([
                                        "_4t3igktf _bfhk4m1f _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2rko1l7b"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    style: {
                                        width: descLine2
                                    },
                                    className: (0, $2jatx.default)([
                                        "_4t3igktf _bfhk4m1f _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2rko1l7b"
                                    ])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3igktf _1bsbhwvj _bfhk4m1f _2rko1l7b"
                            ])
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("6dChG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $026794daeb10b9d8$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<9d72aba52deac75607410fe37ca1b0be>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $iRqzG = parcelRequire("iRqzG");
const $026794daeb10b9d8$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "categoryUrlSlugs"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "urlSlugs"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "connection": null,
            "fragmentPathInResult": [],
            "operation": (0, $iRqzG.default)
        }
    },
    "name": "templatePaginatedSearchResultsContentfulRelayRefetchableFragment",
    "selections": [
        {
            "alias": "templates",
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "skip",
                    "variableName": "skip"
                },
                {
                    "fields": [
                        {
                            "items": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "urlSlug_in",
                                            "variableName": "urlSlugs"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "OR.0"
                                },
                                {
                                    "fields": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "id_in",
                                                    "variableName": "templateIds"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "sys"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "OR.1"
                                },
                                {
                                    "fields": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "urlSlug_in",
                                                    "variableName": "categoryUrlSlugs"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "category"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "OR.2"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "OR"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "where"
                }
            ],
            "concreteType": "ProductTemplateCollection",
            "kind": "LinkedField",
            "name": "productTemplateCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductTemplate",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sys",
                            "kind": "LinkedField",
                            "name": "sys",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "limit",
                                    "value": 1
                                }
                            ],
                            "concreteType": "ProductTemplateProductCollection",
                            "kind": "LinkedField",
                            "name": "productCollection",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductListing",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductName",
                                            "kind": "LinkedField",
                                            "name": "productNameReference",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "productNameId",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": "productCollection(limit:1)"
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateNameExternal",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "urlSlug",
                            "storageKey": null
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "templateCardContentfulRelayFragment"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Query",
    "abstractKey": null
};
$026794daeb10b9d8$var$node.hash = "251a112050a3678aba1b8b73da60c6b5";
var $026794daeb10b9d8$export$2e2bcd8739ae039 = $026794daeb10b9d8$var$node;

});
parcelRegister("iRqzG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $891c8c6fb3906a05$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<5f8cf0c4bb71ee05ac5adcfaa6af8eaa>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $891c8c6fb3906a05$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "categoryUrlSlugs"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "urlSlugs"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
    }, v2 = {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
    }, v3 = {
        "kind": "Variable",
        "name": "skip",
        "variableName": "skip"
    }, v4 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v5 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "templatePaginatedSearchResultsRefetchableQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "categoryUrlSlugs",
                            "variableName": "categoryUrlSlugs"
                        },
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "templateIds",
                            "variableName": "templateIds"
                        },
                        {
                            "kind": "Variable",
                            "name": "urlSlugs",
                            "variableName": "urlSlugs"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "templatePaginatedSearchResultsContentfulRelayRefetchableFragment"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "templatePaginatedSearchResultsRefetchableQuery",
            "selections": [
                {
                    "alias": "templates",
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "fields": [
                                {
                                    "items": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "urlSlug_in",
                                                    "variableName": "urlSlugs"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "OR.0"
                                        },
                                        {
                                            "fields": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "id_in",
                                                            "variableName": "templateIds"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "sys"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "OR.1"
                                        },
                                        {
                                            "fields": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "urlSlug_in",
                                                            "variableName": "categoryUrlSlugs"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "category"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "OR.2"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "OR"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "where"
                        }
                    ],
                    "concreteType": "ProductTemplateCollection",
                    "kind": "LinkedField",
                    "name": "productTemplateCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "limit",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "ProductTemplateProductCollection",
                                    "kind": "LinkedField",
                                    "name": "productCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductListing",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProductName",
                                                    "kind": "LinkedField",
                                                    "name": "productNameReference",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "productNameId",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "productCollection(limit:1)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "templateNameExternal",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "urlSlug",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pluginModuleKey",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previewBlurb",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateTemplateTypeCollection",
                                    "kind": "LinkedField",
                                    "name": "templateTypeCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaxonomyTemplateType",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "templateTypeNameExternal",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "contributor",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CompanyNameInternal",
                                                    "kind": "LinkedField",
                                                    "name": "organization",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ ,
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Author",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v5 /*: any*/ ,
                                            "type": "CompanyNameInternal",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "9544b5eb957258ac177eff651cb92da8",
            "id": null,
            "metadata": {},
            "name": "templatePaginatedSearchResultsRefetchableQuery",
            "operationKind": "query",
            "text": "query templatePaginatedSearchResultsRefetchableQuery(\n  $categoryUrlSlugs: [String!]!\n  $limit: Int!\n  $locale: String!\n  $skip: Int!\n  $templateIds: [String!]!\n  $urlSlugs: [String!]!\n) {\n  ...templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P on Query {\n  templates: productTemplateCollection(limit: $limit, skip: $skip, locale: $locale, where: {OR: [{urlSlug_in: $urlSlugs}, {sys: {id_in: $templateIds}}, {category: {urlSlug_in: $categoryUrlSlugs}}]}) {\n    items {\n      sys {\n        id\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      templateNameExternal\n      urlSlug\n      ...templateCardContentfulRelayFragment\n    }\n    total\n  }\n}\n"
        }
    };
}();
$891c8c6fb3906a05$var$node.hash = "251a112050a3678aba1b8b73da60c6b5";
var $891c8c6fb3906a05$export$2e2bcd8739ae039 = $891c8c6fb3906a05$var$node;

});



parcelRegister("h0B3T", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $26076eb2bf330840$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<703214d4fd92fb76545618df9db203e5>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $26076eb2bf330840$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryUrlSlugs"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skip"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "urlSlugs"
    }, v6 = {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
    }, v7 = {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
    }, v8 = {
        "kind": "Variable",
        "name": "skip",
        "variableName": "skip"
    }, v9 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v10 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "templateInitialSearchResultsContentfulRelayQuery",
            "selections": [
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "categoryUrlSlugs",
                                        "variableName": "categoryUrlSlugs"
                                    },
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "templateIds",
                                        "variableName": "templateIds"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "urlSlugs",
                                        "variableName": "urlSlugs"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "templatePaginatedSearchResultsContentfulRelayRefetchableFragment"
                            }
                        ],
                        "type": "Query",
                        "abstractKey": null
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "initialSearchResults"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "templateInitialSearchResultsContentfulRelayQuery",
            "selections": [
                {
                    "alias": "templates",
                    "args": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "fields": [
                                {
                                    "items": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "urlSlug_in",
                                                    "variableName": "urlSlugs"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "OR.0"
                                        },
                                        {
                                            "fields": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "id_in",
                                                            "variableName": "templateIds"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "sys"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "OR.1"
                                        },
                                        {
                                            "fields": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "urlSlug_in",
                                                            "variableName": "categoryUrlSlugs"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "category"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "OR.2"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "OR"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "where"
                        }
                    ],
                    "concreteType": "ProductTemplateCollection",
                    "kind": "LinkedField",
                    "name": "productTemplateCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "limit",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "ProductTemplateProductCollection",
                                    "kind": "LinkedField",
                                    "name": "productCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductListing",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProductName",
                                                    "kind": "LinkedField",
                                                    "name": "productNameReference",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "productNameId",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "productCollection(limit:1)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "templateNameExternal",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "urlSlug",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pluginModuleKey",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previewBlurb",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateTemplateTypeCollection",
                                    "kind": "LinkedField",
                                    "name": "templateTypeCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaxonomyTemplateType",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "templateTypeNameExternal",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "contributor",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CompanyNameInternal",
                                                    "kind": "LinkedField",
                                                    "name": "organization",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Author",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v10 /*: any*/ ,
                                            "type": "CompanyNameInternal",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "e928119e639c68d84d6c2d68d0017fd9",
            "id": null,
            "metadata": {},
            "name": "templateInitialSearchResultsContentfulRelayQuery",
            "operationKind": "query",
            "text": "query templateInitialSearchResultsContentfulRelayQuery(\n  $urlSlugs: [String!]!\n  $templateIds: [String!]!\n  $categoryUrlSlugs: [String!]!\n  $limit: Int!\n  $skip: Int!\n  $locale: String!\n) {\n  ...templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P on Query {\n  templates: productTemplateCollection(limit: $limit, skip: $skip, locale: $locale, where: {OR: [{urlSlug_in: $urlSlugs}, {sys: {id_in: $templateIds}}, {category: {urlSlug_in: $categoryUrlSlugs}}]}) {\n    items {\n      sys {\n        id\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      templateNameExternal\n      urlSlug\n      ...templateCardContentfulRelayFragment\n    }\n    total\n  }\n}\n"
        }
    };
}();
$26076eb2bf330840$var$node.hash = "0a051c0ee28540a725e60d886cd79ce5";
var $26076eb2bf330840$export$2e2bcd8739ae039 = $26076eb2bf330840$var$node;

});


parcelRegister("dJ115", function(module, exports) {
$parcel$export(module.exports, "TemplateCarouselSection", function () { return $6ea59d8b1d12bca6$export$52652adcb6c112bc; });
$parcel$export(module.exports, "SectionDivider", function () { return $6ea59d8b1d12bca6$export$6d837e605d1c4f23; });
/* template-carousel-section-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $3DBn8 = parcelRequire("3DBn8");
const $6ea59d8b1d12bca6$var$collectionsWrapperStyles = null;
const $6ea59d8b1d12bca6$var$sectionDividerStyles = null;
const $6ea59d8b1d12bca6$var$templateSectionStyles = null;
const $6ea59d8b1d12bca6$var$carouselTitleStyles = null;
const $6ea59d8b1d12bca6$var$subTextStyles = null;
const $6ea59d8b1d12bca6$export$52652adcb6c112bc = ({ collections: collections })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "template-carousel-section-relay",
        className: (0, $2jatx.default)([
            "_u7coobt3 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _n3tdckbl _1bsb1fra _1e0c1txw _2lx21bp4 _4cvr1h6o _1opx1r39 _g65pko4j _w0lq1gzr _41q616yw _1nbc1u0r _q1ve1yw0 _19xn1v6t _wsqf1c3h"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybahaf _vwz413ei _k48pbfng _syazdtn8 _ect41vau _19pkidpf _2hwxidpf _otyrftgi _18u0idpf _y3gn1h6o _1cqsviql _1bys11uf"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "confluence.template.carousel.heading",
                    defaultMessage: "Template collections"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "confluence.template.carousel.subtext",
                    defaultMessage: "See curated templates targeted to help achieve work and collaboration goals"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3DBn8.CollectionCardCarousel), {
                    collections: collections
                })
            })
        ]
    });
};
$6ea59d8b1d12bca6$export$52652adcb6c112bc.displayName = 'TemplateCarouselSection';
const $6ea59d8b1d12bca6$export$6d837e605d1c4f23 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3it94y _11q76u2e _kqswh2mm _152t1uiu _1bsb1fra _1opx1r39 _g65pko4j _w0lq1gzr _41q616yw _1nbc1u0r _q1ve1yw0 _19xn1v6t _wsqf1c3h _1jco1wug _n3j91wug _bj5y1wug _k2i01wug"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light300'))
        }
    });

});
parcelRegister("3DBn8", function(module, exports) {
$parcel$export(module.exports, "CollectionCardCarousel", function () { return $ed0a4f3e1920346a$export$66943dda138bdb3; });
/* collection-card-carousel-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $ggSCt = parcelRequire("ggSCt");

var $cml5G = parcelRequire("cml5G");

var $lRFwv = parcelRequire("lRFwv");

var $b8G12 = parcelRequire("b8G12");
var $ed0a4f3e1920346a$var$_collectionCardCarouselContentfulRelayFragment;
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $ed0a4f3e1920346a$var$slickStyle = null;
const $ed0a4f3e1920346a$var$carouselContainer = null;
const $ed0a4f3e1920346a$var$carouselCardWrapper = null;

const $ed0a4f3e1920346a$var$CollectionCardCarouselFragment = $ed0a4f3e1920346a$var$_collectionCardCarouselContentfulRelayFragment !== void 0 ? $ed0a4f3e1920346a$var$_collectionCardCarouselContentfulRelayFragment : ($ed0a4f3e1920346a$var$_collectionCardCarouselContentfulRelayFragment = (parcelRequire("hPvyI")), $ed0a4f3e1920346a$var$_collectionCardCarouselContentfulRelayFragment.hash && $ed0a4f3e1920346a$var$_collectionCardCarouselContentfulRelayFragment.hash !== "fdf5e06b0b871f667490c5a097846cff" && console.error("The definition of 'collectionCardCarouselContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $ed0a4f3e1920346a$var$_collectionCardCarouselContentfulRelayFragment);
const $ed0a4f3e1920346a$export$66943dda138bdb3 = ({ collections: collections })=>{
    const data = (0, $f3gS9.useFragment)($ed0a4f3e1920346a$var$CollectionCardCarouselFragment, collections);
    const settings = (0, $1oC0p.useMemo)(()=>({
            infinite: Array.isArray(data) && data.length > 3,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: /*#__PURE__*/ (0, $7VQPk.jsx)($ed0a4f3e1920346a$var$LeftArrow, {}),
            nextArrow: /*#__PURE__*/ (0, $7VQPk.jsx)($ed0a4f3e1920346a$var$RightArrow, {}),
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: Array.isArray(data) && data.length > 2
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: Array.isArray(data) && data.length > 1
                    }
                }
            ]
        }), [
        data
    ]);
    const beforeChange = (currentSlide, nextSlide)=>{
        (0, $lRFwv.ConfluenceTemplateAnalytics).sendCollectionCarouselAnalytic(currentSlide, nextSlide, Array.isArray(data) ? data.length : 0);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1fra _g65p1feq _41q6v36b _q1vejxaq _wsqf1c3h"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), {
                ...settings,
                beforeChange: beforeChange,
                children: Array.isArray(data) && data.map((collection)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c13la _1bah1h6o _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz _1kpjftgi _1puuftgi _6iqbftgi _1st5ftgi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b8G12.CollectionCardRelay), {
                            collection: collection
                        })
                    }, collection.sys.id))
            })
        })
    });
};
const $ed0a4f3e1920346a$var$buttonLeft = null;
const $ed0a4f3e1920346a$var$buttonLeftArrow = null;
const $ed0a4f3e1920346a$var$LeftArrow = ({ onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const previousLabel = intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).carouselPreviousLabel);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        "aria-label": previousLabel,
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_bfhku67f _1e0c1ule _kqswstnw _vchhusvi _152t1ssb _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _1n3y1bs0 _1bsb1ylp _4t3i1ylp _1e02myb0"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_t9eczk8b _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbqmyb0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz _syazvwuj"
            ])
        })
    });
};
const $ed0a4f3e1920346a$var$buttonRight = null;
const $ed0a4f3e1920346a$var$buttonRightArrow = null;
const $ed0a4f3e1920346a$var$RightArrow = ({ onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const nextLabel = intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).carouselNextLabel);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        "aria-label": nextLabel,
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_bfhku67f _vchhusvi _1e0c1ule _kqswstnw _152t1ssb _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _f43l1bs0 _1bsb1ylp _4t3i1ylp _rjxpmyb0"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_t9ec1hke _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbq1bs0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz _syazvwuj"
            ])
        })
    });
};

});
parcelRegister("ggSCt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $bd88823ebdd00cce$var$_slider = $bd88823ebdd00cce$var$_interopRequireDefault((parcelRequire("idWQj")));
function $bd88823ebdd00cce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $bd88823ebdd00cce$var$_default = $bd88823ebdd00cce$var$_slider["default"];
module.exports["default"] = $bd88823ebdd00cce$var$_default;

});
parcelRegister("idWQj", function(module, exports) {
"use strict";
function $d44715d713004abd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d44715d713004abd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d44715d713004abd$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d44715d713004abd$var$_react = $d44715d713004abd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $55fHA = parcelRequire("55fHA");

var $d44715d713004abd$var$_json2mq = $d44715d713004abd$var$_interopRequireDefault((parcelRequire("av2jA")));

var $d44715d713004abd$var$_defaultProps = $d44715d713004abd$var$_interopRequireDefault((parcelRequire("cVWBi")));

var $2mBRs = parcelRequire("2mBRs");
function $d44715d713004abd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d44715d713004abd$var$_extends() {
    $d44715d713004abd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d44715d713004abd$var$_extends.apply(this, arguments);
}
function $d44715d713004abd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d44715d713004abd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d44715d713004abd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d44715d713004abd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d44715d713004abd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d44715d713004abd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d44715d713004abd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d44715d713004abd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d44715d713004abd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d44715d713004abd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d44715d713004abd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d44715d713004abd$var$_setPrototypeOf(subClass, superClass);
}
function $d44715d713004abd$var$_setPrototypeOf(o, p) {
    $d44715d713004abd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d44715d713004abd$var$_setPrototypeOf(o, p);
}
function $d44715d713004abd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d44715d713004abd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d44715d713004abd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d44715d713004abd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d44715d713004abd$var$_possibleConstructorReturn(this, result);
    };
}
function $d44715d713004abd$var$_possibleConstructorReturn(self, call) {
    if (call && ($d44715d713004abd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d44715d713004abd$var$_assertThisInitialized(self);
}
function $d44715d713004abd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d44715d713004abd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d44715d713004abd$var$_getPrototypeOf(o) {
    $d44715d713004abd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d44715d713004abd$var$_getPrototypeOf(o);
}
function $d44715d713004abd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $d44715d713004abd$var$enquire = (0, $2mBRs.canUseDOM)() && (parcelRequire("6WTPO"));
var $d44715d713004abd$var$Slider = /*#__PURE__*/ function(_React$Component) {
    $d44715d713004abd$var$_inherits(Slider, _React$Component);
    var _super = $d44715d713004abd$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $d44715d713004abd$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $d44715d713004abd$var$_defineProperty($d44715d713004abd$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $d44715d713004abd$var$_defineProperty($d44715d713004abd$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $d44715d713004abd$var$_defineProperty($d44715d713004abd$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $d44715d713004abd$var$_defineProperty($d44715d713004abd$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $d44715d713004abd$var$_defineProperty($d44715d713004abd$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $d44715d713004abd$var$_defineProperty($d44715d713004abd$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $d44715d713004abd$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                $d44715d713004abd$var$enquire.register(query, handler);
                this._responsiveMediaHandlers.push({
                    query: query,
                    handler: handler
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    }); // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $d44715d713004abd$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $d44715d713004abd$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                         // when not using server side rendering
                        (0, $2mBRs.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    }); // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $d44715d713004abd$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $2mBRs.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    $d44715d713004abd$var$enquire.unregister(obj.query, obj.handler);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $d44715d713004abd$var$_objectSpread($d44715d713004abd$var$_objectSpread($d44715d713004abd$var$_objectSpread({}, $d44715d713004abd$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $d44715d713004abd$var$_objectSpread($d44715d713004abd$var$_objectSpread({}, $d44715d713004abd$var$_defaultProps["default"]), this.props);
                 // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                } // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                } // makes sure that children is an array, even when there is only 1 child
                var children = $d44715d713004abd$var$_react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                }); // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $d44715d713004abd$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $d44715d713004abd$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $d44715d713004abd$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $d44715d713004abd$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $d44715d713004abd$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow) settings.unslick = true;
                return /*#__PURE__*/ $d44715d713004abd$var$_react["default"].createElement($55fHA.InnerSlider, $d44715d713004abd$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, settings), newChildren);
            }
        }
    ]);
    return Slider;
}($d44715d713004abd$var$_react["default"].Component);
module.exports["default"] = $d44715d713004abd$var$Slider;

});
parcelRegister("55fHA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $3b39997d37bce9ab$var$_react = $3b39997d37bce9ab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3b39997d37bce9ab$var$_initialState = $3b39997d37bce9ab$var$_interopRequireDefault((parcelRequire("6BBDP")));

var $3b39997d37bce9ab$var$_lodash = $3b39997d37bce9ab$var$_interopRequireDefault((parcelRequire("2h3gd")));

var $3b39997d37bce9ab$var$_classnames = $3b39997d37bce9ab$var$_interopRequireDefault((parcelRequire("e6Vv3")));

var $2mBRs = parcelRequire("2mBRs");

var $dqXgQ = parcelRequire("dqXgQ");

var $fNgQv = parcelRequire("fNgQv");

var $blULd = parcelRequire("blULd");

var $3b39997d37bce9ab$var$_resizeObserverPolyfill = $3b39997d37bce9ab$var$_interopRequireDefault((parcelRequire("lpuUz")));
function $3b39997d37bce9ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3b39997d37bce9ab$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3b39997d37bce9ab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3b39997d37bce9ab$var$_typeof(obj);
}
function $3b39997d37bce9ab$var$_extends() {
    $3b39997d37bce9ab$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3b39997d37bce9ab$var$_extends.apply(this, arguments);
}
function $3b39997d37bce9ab$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3b39997d37bce9ab$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3b39997d37bce9ab$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3b39997d37bce9ab$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3b39997d37bce9ab$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3b39997d37bce9ab$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3b39997d37bce9ab$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3b39997d37bce9ab$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3b39997d37bce9ab$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3b39997d37bce9ab$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3b39997d37bce9ab$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3b39997d37bce9ab$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3b39997d37bce9ab$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3b39997d37bce9ab$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3b39997d37bce9ab$var$_setPrototypeOf(subClass, superClass);
}
function $3b39997d37bce9ab$var$_setPrototypeOf(o, p) {
    $3b39997d37bce9ab$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3b39997d37bce9ab$var$_setPrototypeOf(o, p);
}
function $3b39997d37bce9ab$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3b39997d37bce9ab$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3b39997d37bce9ab$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3b39997d37bce9ab$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3b39997d37bce9ab$var$_possibleConstructorReturn(this, result);
    };
}
function $3b39997d37bce9ab$var$_possibleConstructorReturn(self, call) {
    if (call && ($3b39997d37bce9ab$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3b39997d37bce9ab$var$_assertThisInitialized(self);
}
function $3b39997d37bce9ab$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3b39997d37bce9ab$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3b39997d37bce9ab$var$_getPrototypeOf(o) {
    $3b39997d37bce9ab$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3b39997d37bce9ab$var$_getPrototypeOf(o);
}
function $3b39997d37bce9ab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3b39997d37bce9ab$var$InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $3b39997d37bce9ab$var$_inherits(InnerSlider, _React$Component);
    var _super = $3b39997d37bce9ab$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $3b39997d37bce9ab$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
                _this.list.style.height = (0, $2mBRs.getHeight)(elem) + "px";
            }
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $2mBRs.getOnDemandLazySlides)($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $3b39997d37bce9ab$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $3b39997d37bce9ab$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $2mBRs.getOnDemandLazySlides)($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            } // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $3b39997d37bce9ab$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $3b39997d37bce9ab$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $3b39997d37bce9ab$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            }); // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $2mBRs.initializedState)(spec);
            spec = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $2mBRs.getTrackLeft)(spec);
            spec = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $2mBRs.getTrackCSS)(spec);
            if (setTrackStyle || $3b39997d37bce9ab$var$_react["default"].Children.count(_this.props.children) !== $3b39997d37bce9ab$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $2mBRs.getPreClones)($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $2mBRs.getPostClones)($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $3b39997d37bce9ab$var$_react["default"].Children.count(_this.props.children);
            var spec = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $2mBRs.getPreClones)(spec) + (0, $2mBRs.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $2mBRs.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function() {
                        prevClickHandler();
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $2mBRs.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $2mBRs.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $2mBRs.slideHandler)($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $3b39997d37bce9ab$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $2mBRs.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $2mBRs.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $2mBRs.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $2mBRs.swipeMove)(e, $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $2mBRs.swipeEnd)(e, $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $2mBRs.canGoNext)($3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $3b39997d37bce9ab$var$_defineProperty($3b39997d37bce9ab$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $3b39997d37bce9ab$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $2mBRs.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $2mBRs.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $3b39997d37bce9ab$var$_react["default"].createElement($fNgQv.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $2mBRs.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $3b39997d37bce9ab$var$_react["default"].createElement($blULd.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $3b39997d37bce9ab$var$_react["default"].createElement($blULd.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className
                };
            }
            return /*#__PURE__*/ $3b39997d37bce9ab$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $3b39997d37bce9ab$var$_react["default"].createElement("div", $3b39997d37bce9ab$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $3b39997d37bce9ab$var$_react["default"].createElement($dqXgQ.Track, $3b39997d37bce9ab$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, $3b39997d37bce9ab$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            slideCount: $3b39997d37bce9ab$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $3b39997d37bce9ab$var$_objectSpread($3b39997d37bce9ab$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $3b39997d37bce9ab$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($3b39997d37bce9ab$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $3b39997d37bce9ab$var$_react["default"].Children.count(this.props.children) !== $3b39997d37bce9ab$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($3b39997d37bce9ab$var$_react["default"].Component);
module.exports.InnerSlider = $3b39997d37bce9ab$var$InnerSlider;

});
parcelRegister("6BBDP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $4cf365935c7a7173$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $4cf365935c7a7173$var$_default = $4cf365935c7a7173$var$initialState;
module.exports["default"] = $4cf365935c7a7173$var$_default;

});

parcelRegister("2h3gd", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $1a7fb2c96d66d343$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $1a7fb2c96d66d343$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $1a7fb2c96d66d343$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $1a7fb2c96d66d343$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $1a7fb2c96d66d343$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $1a7fb2c96d66d343$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $1a7fb2c96d66d343$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $1a7fb2c96d66d343$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $1a7fb2c96d66d343$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $1a7fb2c96d66d343$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1a7fb2c96d66d343$var$root = $1a7fb2c96d66d343$var$freeGlobal || $1a7fb2c96d66d343$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $1a7fb2c96d66d343$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1a7fb2c96d66d343$var$objectToString = $1a7fb2c96d66d343$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1a7fb2c96d66d343$var$nativeMax = Math.max, $1a7fb2c96d66d343$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1a7fb2c96d66d343$var$now = function() {
    return $1a7fb2c96d66d343$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1a7fb2c96d66d343$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($1a7fb2c96d66d343$var$FUNC_ERROR_TEXT);
    wait = $1a7fb2c96d66d343$var$toNumber(wait) || 0;
    if ($1a7fb2c96d66d343$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $1a7fb2c96d66d343$var$nativeMax($1a7fb2c96d66d343$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $1a7fb2c96d66d343$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1a7fb2c96d66d343$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1a7fb2c96d66d343$var$now());
    }
    function debounced() {
        var time = $1a7fb2c96d66d343$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1a7fb2c96d66d343$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1a7fb2c96d66d343$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1a7fb2c96d66d343$var$isSymbol(value) {
    return typeof value == 'symbol' || $1a7fb2c96d66d343$var$isObjectLike(value) && $1a7fb2c96d66d343$var$objectToString.call(value) == $1a7fb2c96d66d343$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $1a7fb2c96d66d343$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($1a7fb2c96d66d343$var$isSymbol(value)) return $1a7fb2c96d66d343$var$NAN;
    if ($1a7fb2c96d66d343$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $1a7fb2c96d66d343$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($1a7fb2c96d66d343$var$reTrim, '');
    var isBinary = $1a7fb2c96d66d343$var$reIsBinary.test(value);
    return isBinary || $1a7fb2c96d66d343$var$reIsOctal.test(value) ? $1a7fb2c96d66d343$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $1a7fb2c96d66d343$var$reIsBadHex.test(value) ? $1a7fb2c96d66d343$var$NAN : +value;
}
module.exports = $1a7fb2c96d66d343$var$debounce;

});

parcelRegister("e6Vv3", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("2mBRs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $1b8b0149b99cdfc1$var$clamp;
module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = module.exports.extractObject = void 0;

var $1b8b0149b99cdfc1$var$_react = $1b8b0149b99cdfc1$var$_interopRequireDefault((parcelRequire("1oC0p")));
function $1b8b0149b99cdfc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1b8b0149b99cdfc1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1b8b0149b99cdfc1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1b8b0149b99cdfc1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1b8b0149b99cdfc1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1b8b0149b99cdfc1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1b8b0149b99cdfc1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1b8b0149b99cdfc1$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $1b8b0149b99cdfc1$var$safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
module.exports.safePreventDefault = $1b8b0149b99cdfc1$var$safePreventDefault;
var $1b8b0149b99cdfc1$var$getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $1b8b0149b99cdfc1$var$lazyStartIndex(spec);
    var endIndex = $1b8b0149b99cdfc1$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
}; // return list of slides that need to be present
module.exports.getOnDemandLazySlides = $1b8b0149b99cdfc1$var$getOnDemandLazySlides;
var $1b8b0149b99cdfc1$var$getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $1b8b0149b99cdfc1$var$lazyStartIndex(spec);
    var endIndex = $1b8b0149b99cdfc1$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
}; // startIndex that needs to be present
module.exports.getRequiredLazySlides = $1b8b0149b99cdfc1$var$getRequiredLazySlides;
var $1b8b0149b99cdfc1$var$lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $1b8b0149b99cdfc1$var$lazySlidesOnLeft(spec);
};
module.exports.lazyStartIndex = $1b8b0149b99cdfc1$var$lazyStartIndex;
var $1b8b0149b99cdfc1$var$lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $1b8b0149b99cdfc1$var$lazySlidesOnRight(spec);
};
module.exports.lazyEndIndex = $1b8b0149b99cdfc1$var$lazyEndIndex;
var $1b8b0149b99cdfc1$var$lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
module.exports.lazySlidesOnLeft = $1b8b0149b99cdfc1$var$lazySlidesOnLeft;
var $1b8b0149b99cdfc1$var$lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element
module.exports.lazySlidesOnRight = $1b8b0149b99cdfc1$var$lazySlidesOnRight;
var $1b8b0149b99cdfc1$var$getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
module.exports.getWidth = $1b8b0149b99cdfc1$var$getWidth;
var $1b8b0149b99cdfc1$var$getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
module.exports.getHeight = $1b8b0149b99cdfc1$var$getHeight;
var $1b8b0149b99cdfc1$var$getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
}; // whether or not we can go next
module.exports.getSwipeDirection = $1b8b0149b99cdfc1$var$getSwipeDirection;
var $1b8b0149b99cdfc1$var$canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
}; // given an object and a list of keys, return new object with given keys
module.exports.canGoNext = $1b8b0149b99cdfc1$var$canGoNext;
var $1b8b0149b99cdfc1$var$extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
}; // get initialized state
module.exports.extractObject = $1b8b0149b99cdfc1$var$extractObject;
var $1b8b0149b99cdfc1$var$initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $1b8b0149b99cdfc1$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($1b8b0149b99cdfc1$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($1b8b0149b99cdfc1$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $1b8b0149b99cdfc1$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $1b8b0149b99cdfc1$var$getOnDemandLazySlides($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
module.exports.initializedState = $1b8b0149b99cdfc1$var$initializedState;
var $1b8b0149b99cdfc1$var$slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $1b8b0149b99cdfc1$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$1b8b0149b99cdfc1$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $1b8b0149b99cdfc1$var$getTrackLeft($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $1b8b0149b99cdfc1$var$getTrackLeft($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($1b8b0149b99cdfc1$var$getOnDemandLazySlides($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $1b8b0149b99cdfc1$var$getTrackCSS($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $1b8b0149b99cdfc1$var$getTrackAnimateCSS($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $1b8b0149b99cdfc1$var$getTrackCSS($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
module.exports.slideHandler = $1b8b0149b99cdfc1$var$slideHandler;
var $1b8b0149b99cdfc1$var$changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $1b8b0149b99cdfc1$var$siblingDirection($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
module.exports.changeSlide = $1b8b0149b99cdfc1$var$changeSlide;
var $1b8b0149b99cdfc1$var$keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
module.exports.keyHandler = $1b8b0149b99cdfc1$var$keyHandler;
var $1b8b0149b99cdfc1$var$swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $1b8b0149b99cdfc1$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
module.exports.swipeStart = $1b8b0149b99cdfc1$var$swipeStart;
var $1b8b0149b99cdfc1$var$swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $1b8b0149b99cdfc1$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $1b8b0149b99cdfc1$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $1b8b0149b99cdfc1$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $1b8b0149b99cdfc1$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$1b8b0149b99cdfc1$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $1b8b0149b99cdfc1$var$getTrackCSS($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $1b8b0149b99cdfc1$var$safePreventDefault(e);
    }
    return state;
};
module.exports.swipeMove = $1b8b0149b99cdfc1$var$swipeMove;
var $1b8b0149b99cdfc1$var$swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $1b8b0149b99cdfc1$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $1b8b0149b99cdfc1$var$getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $1b8b0149b99cdfc1$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $1b8b0149b99cdfc1$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $1b8b0149b99cdfc1$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $1b8b0149b99cdfc1$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $1b8b0149b99cdfc1$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $1b8b0149b99cdfc1$var$getTrackLeft(spec);
        state["trackStyle"] = $1b8b0149b99cdfc1$var$getTrackAnimateCSS($1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
module.exports.swipeEnd = $1b8b0149b99cdfc1$var$swipeEnd;
var $1b8b0149b99cdfc1$var$getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
module.exports.getNavigableIndexes = $1b8b0149b99cdfc1$var$getNavigableIndexes;
var $1b8b0149b99cdfc1$var$checkNavigable = function checkNavigable(spec, index) {
    var navigables = $1b8b0149b99cdfc1$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
module.exports.checkNavigable = $1b8b0149b99cdfc1$var$checkNavigable;
var $1b8b0149b99cdfc1$var$getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $1b8b0149b99cdfc1$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $1b8b0149b99cdfc1$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
module.exports.getSlideCount = $1b8b0149b99cdfc1$var$getSlideCount;
var $1b8b0149b99cdfc1$var$checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
module.exports.checkSpecKeys = $1b8b0149b99cdfc1$var$checkSpecKeys;
var $1b8b0149b99cdfc1$var$getTrackCSS = function getTrackCSS(spec) {
    $1b8b0149b99cdfc1$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $1b8b0149b99cdfc1$var$getTotalSlides(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $1b8b0149b99cdfc1$var$_objectSpread($1b8b0149b99cdfc1$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight; // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
module.exports.getTrackCSS = $1b8b0149b99cdfc1$var$getTrackCSS;
var $1b8b0149b99cdfc1$var$getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $1b8b0149b99cdfc1$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $1b8b0149b99cdfc1$var$getTrackCSS(spec); // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
module.exports.getTrackAnimateCSS = $1b8b0149b99cdfc1$var$getTrackAnimateCSS;
var $1b8b0149b99cdfc1$var$getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $1b8b0149b99cdfc1$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$1b8b0149b99cdfc1$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
         // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $1b8b0149b99cdfc1$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $1b8b0149b99cdfc1$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
module.exports.getTrackLeft = $1b8b0149b99cdfc1$var$getTrackLeft;
var $1b8b0149b99cdfc1$var$getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
module.exports.getPreClones = $1b8b0149b99cdfc1$var$getPreClones;
var $1b8b0149b99cdfc1$var$getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
module.exports.getPostClones = $1b8b0149b99cdfc1$var$getPostClones;
var $1b8b0149b99cdfc1$var$getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $1b8b0149b99cdfc1$var$getPreClones(spec) + spec.slideCount + $1b8b0149b99cdfc1$var$getPostClones(spec);
};
module.exports.getTotalSlides = $1b8b0149b99cdfc1$var$getTotalSlides;
var $1b8b0149b99cdfc1$var$siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $1b8b0149b99cdfc1$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $1b8b0149b99cdfc1$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
module.exports.siblingDirection = $1b8b0149b99cdfc1$var$siblingDirection;
var $1b8b0149b99cdfc1$var$slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
module.exports.slidesOnRight = $1b8b0149b99cdfc1$var$slidesOnRight;
var $1b8b0149b99cdfc1$var$slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
module.exports.slidesOnLeft = $1b8b0149b99cdfc1$var$slidesOnLeft;
var $1b8b0149b99cdfc1$var$canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
module.exports.canUseDOM = $1b8b0149b99cdfc1$var$canUseDOM;

});

parcelRegister("dqXgQ", function(module, exports) {
"use strict";
function $9c7bae01f3cabdf8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9c7bae01f3cabdf8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9c7bae01f3cabdf8$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $9c7bae01f3cabdf8$var$_react = $9c7bae01f3cabdf8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9c7bae01f3cabdf8$var$_classnames = $9c7bae01f3cabdf8$var$_interopRequireDefault((parcelRequire("e6Vv3")));

var $2mBRs = parcelRequire("2mBRs");
function $9c7bae01f3cabdf8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9c7bae01f3cabdf8$var$_extends() {
    $9c7bae01f3cabdf8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c7bae01f3cabdf8$var$_extends.apply(this, arguments);
}
function $9c7bae01f3cabdf8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9c7bae01f3cabdf8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9c7bae01f3cabdf8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9c7bae01f3cabdf8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9c7bae01f3cabdf8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9c7bae01f3cabdf8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9c7bae01f3cabdf8$var$_setPrototypeOf(subClass, superClass);
}
function $9c7bae01f3cabdf8$var$_setPrototypeOf(o, p) {
    $9c7bae01f3cabdf8$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9c7bae01f3cabdf8$var$_setPrototypeOf(o, p);
}
function $9c7bae01f3cabdf8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9c7bae01f3cabdf8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9c7bae01f3cabdf8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9c7bae01f3cabdf8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9c7bae01f3cabdf8$var$_possibleConstructorReturn(this, result);
    };
}
function $9c7bae01f3cabdf8$var$_possibleConstructorReturn(self, call) {
    if (call && ($9c7bae01f3cabdf8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9c7bae01f3cabdf8$var$_assertThisInitialized(self);
}
function $9c7bae01f3cabdf8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9c7bae01f3cabdf8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9c7bae01f3cabdf8$var$_getPrototypeOf(o) {
    $9c7bae01f3cabdf8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9c7bae01f3cabdf8$var$_getPrototypeOf(o);
}
function $9c7bae01f3cabdf8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9c7bae01f3cabdf8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9c7bae01f3cabdf8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9c7bae01f3cabdf8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9c7bae01f3cabdf8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9c7bae01f3cabdf8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $9c7bae01f3cabdf8$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $9c7bae01f3cabdf8$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $9c7bae01f3cabdf8$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $9c7bae01f3cabdf8$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $9c7bae01f3cabdf8$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $2mBRs.lazyStartIndex)(spec);
    var endIndex = (0, $2mBRs.lazyEndIndex)(spec);
    $9c7bae01f3cabdf8$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        }; // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $9c7bae01f3cabdf8$var$_react["default"].createElement("div", null);
        var childStyle = $9c7bae01f3cabdf8$var$getSlideStyle($9c7bae01f3cabdf8$var$_objectSpread($9c7bae01f3cabdf8$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $9c7bae01f3cabdf8$var$getSlideClasses($9c7bae01f3cabdf8$var$_objectSpread($9c7bae01f3cabdf8$var$_objectSpread({}, spec), {}, {
            index: index
        })); // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $9c7bae01f3cabdf8$var$_react["default"].cloneElement(child, {
            key: "original" + $9c7bae01f3cabdf8$var$getKey(child, index),
            "data-index": index,
            className: (0, $9c7bae01f3cabdf8$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $9c7bae01f3cabdf8$var$_objectSpread($9c7bae01f3cabdf8$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        })); // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $2mBRs.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $9c7bae01f3cabdf8$var$getSlideClasses($9c7bae01f3cabdf8$var$_objectSpread($9c7bae01f3cabdf8$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $9c7bae01f3cabdf8$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $9c7bae01f3cabdf8$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $9c7bae01f3cabdf8$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $9c7bae01f3cabdf8$var$_objectSpread($9c7bae01f3cabdf8$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            if (childrenCount !== spec.slidesToShow) {
                key = childrenCount + index;
                if (key < endIndex) child = elem;
                slideClasses = $9c7bae01f3cabdf8$var$getSlideClasses($9c7bae01f3cabdf8$var$_objectSpread($9c7bae01f3cabdf8$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                postCloneSlides.push(/*#__PURE__*/ $9c7bae01f3cabdf8$var$_react["default"].cloneElement(child, {
                    key: "postcloned" + $9c7bae01f3cabdf8$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $9c7bae01f3cabdf8$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $9c7bae01f3cabdf8$var$_objectSpread($9c7bae01f3cabdf8$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $9c7bae01f3cabdf8$var$Track = /*#__PURE__*/ function(_React$PureComponent) {
    $9c7bae01f3cabdf8$var$_inherits(Track, _React$PureComponent);
    var _super = $9c7bae01f3cabdf8$var$_createSuper(Track);
    function Track() {
        var _this;
        $9c7bae01f3cabdf8$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $9c7bae01f3cabdf8$var$_defineProperty($9c7bae01f3cabdf8$var$_assertThisInitialized(_this), "node", null);
        $9c7bae01f3cabdf8$var$_defineProperty($9c7bae01f3cabdf8$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $9c7bae01f3cabdf8$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $9c7bae01f3cabdf8$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $9c7bae01f3cabdf8$var$_react["default"].createElement("div", $9c7bae01f3cabdf8$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($9c7bae01f3cabdf8$var$_react["default"].PureComponent);
module.exports.Track = $9c7bae01f3cabdf8$var$Track;

});

parcelRegister("fNgQv", function(module, exports) {
"use strict";
function $b7f87fd951449ca1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b7f87fd951449ca1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b7f87fd951449ca1$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $b7f87fd951449ca1$var$_react = $b7f87fd951449ca1$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b7f87fd951449ca1$var$_classnames = $b7f87fd951449ca1$var$_interopRequireDefault((parcelRequire("e6Vv3")));

var $2mBRs = parcelRequire("2mBRs");
function $b7f87fd951449ca1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b7f87fd951449ca1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b7f87fd951449ca1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b7f87fd951449ca1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b7f87fd951449ca1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b7f87fd951449ca1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b7f87fd951449ca1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b7f87fd951449ca1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b7f87fd951449ca1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b7f87fd951449ca1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b7f87fd951449ca1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b7f87fd951449ca1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b7f87fd951449ca1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b7f87fd951449ca1$var$_setPrototypeOf(subClass, superClass);
}
function $b7f87fd951449ca1$var$_setPrototypeOf(o, p) {
    $b7f87fd951449ca1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b7f87fd951449ca1$var$_setPrototypeOf(o, p);
}
function $b7f87fd951449ca1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b7f87fd951449ca1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b7f87fd951449ca1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b7f87fd951449ca1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b7f87fd951449ca1$var$_possibleConstructorReturn(this, result);
    };
}
function $b7f87fd951449ca1$var$_possibleConstructorReturn(self, call) {
    if (call && ($b7f87fd951449ca1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b7f87fd951449ca1$var$_assertThisInitialized(self);
}
function $b7f87fd951449ca1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b7f87fd951449ca1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b7f87fd951449ca1$var$_getPrototypeOf(o) {
    $b7f87fd951449ca1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b7f87fd951449ca1$var$_getPrototypeOf(o);
}
var $b7f87fd951449ca1$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $b7f87fd951449ca1$var$Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $b7f87fd951449ca1$var$_inherits(Dots, _React$PureComponent);
    var _super = $b7f87fd951449ca1$var$_createSuper(Dots);
    function Dots() {
        $b7f87fd951449ca1$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $b7f87fd951449ca1$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $b7f87fd951449ca1$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $2mBRs.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $2mBRs.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $b7f87fd951449ca1$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $b7f87fd951449ca1$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $b7f87fd951449ca1$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $b7f87fd951449ca1$var$_react["default"].cloneElement(this.props.appendDots(dots), $b7f87fd951449ca1$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($b7f87fd951449ca1$var$_react["default"].PureComponent);
module.exports.Dots = $b7f87fd951449ca1$var$Dots;

});

parcelRegister("blULd", function(module, exports) {
"use strict";
function $843daf53abfa1369$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $843daf53abfa1369$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $843daf53abfa1369$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $843daf53abfa1369$var$_react = $843daf53abfa1369$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $843daf53abfa1369$var$_classnames = $843daf53abfa1369$var$_interopRequireDefault((parcelRequire("e6Vv3")));

var $2mBRs = parcelRequire("2mBRs");
function $843daf53abfa1369$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $843daf53abfa1369$var$_extends() {
    $843daf53abfa1369$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $843daf53abfa1369$var$_extends.apply(this, arguments);
}
function $843daf53abfa1369$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $843daf53abfa1369$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $843daf53abfa1369$var$ownKeys(Object(source), !0).forEach(function(key) {
            $843daf53abfa1369$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $843daf53abfa1369$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $843daf53abfa1369$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $843daf53abfa1369$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $843daf53abfa1369$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $843daf53abfa1369$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $843daf53abfa1369$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $843daf53abfa1369$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $843daf53abfa1369$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $843daf53abfa1369$var$_setPrototypeOf(subClass, superClass);
}
function $843daf53abfa1369$var$_setPrototypeOf(o, p) {
    $843daf53abfa1369$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $843daf53abfa1369$var$_setPrototypeOf(o, p);
}
function $843daf53abfa1369$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $843daf53abfa1369$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $843daf53abfa1369$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $843daf53abfa1369$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $843daf53abfa1369$var$_possibleConstructorReturn(this, result);
    };
}
function $843daf53abfa1369$var$_possibleConstructorReturn(self, call) {
    if (call && ($843daf53abfa1369$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $843daf53abfa1369$var$_assertThisInitialized(self);
}
function $843daf53abfa1369$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $843daf53abfa1369$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $843daf53abfa1369$var$_getPrototypeOf(o) {
    $843daf53abfa1369$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $843daf53abfa1369$var$_getPrototypeOf(o);
}
var $843daf53abfa1369$var$PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $843daf53abfa1369$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $843daf53abfa1369$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $843daf53abfa1369$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $843daf53abfa1369$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $843daf53abfa1369$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $843daf53abfa1369$var$_react["default"].cloneElement(this.props.prevArrow, $843daf53abfa1369$var$_objectSpread($843daf53abfa1369$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $843daf53abfa1369$var$_react["default"].createElement("button", $843daf53abfa1369$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($843daf53abfa1369$var$_react["default"].PureComponent);
module.exports.PrevArrow = $843daf53abfa1369$var$PrevArrow;
var $843daf53abfa1369$var$NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $843daf53abfa1369$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $843daf53abfa1369$var$_createSuper(NextArrow);
    function NextArrow() {
        $843daf53abfa1369$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $843daf53abfa1369$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $2mBRs.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $843daf53abfa1369$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $843daf53abfa1369$var$_react["default"].cloneElement(this.props.nextArrow, $843daf53abfa1369$var$_objectSpread($843daf53abfa1369$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $843daf53abfa1369$var$_react["default"].createElement("button", $843daf53abfa1369$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($843daf53abfa1369$var$_react["default"].PureComponent);
module.exports.NextArrow = $843daf53abfa1369$var$NextArrow;

});

parcelRegister("lpuUz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $f963e91e8b16ab8d$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $f963e91e8b16ab8d$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $f963e91e8b16ab8d$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $f963e91e8b16ab8d$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $f963e91e8b16ab8d$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($f963e91e8b16ab8d$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $f963e91e8b16ab8d$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $f963e91e8b16ab8d$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $f963e91e8b16ab8d$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $f963e91e8b16ab8d$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $f963e91e8b16ab8d$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $f963e91e8b16ab8d$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $f963e91e8b16ab8d$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $f963e91e8b16ab8d$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $f963e91e8b16ab8d$var$throttle(this.refresh.bind(this), $f963e91e8b16ab8d$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$f963e91e8b16ab8d$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($f963e91e8b16ab8d$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$f963e91e8b16ab8d$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $f963e91e8b16ab8d$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $f963e91e8b16ab8d$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $f963e91e8b16ab8d$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $f963e91e8b16ab8d$var$global$1;
};
// Placeholder of an empty content rectangle.
var $f963e91e8b16ab8d$var$emptyRect = $f963e91e8b16ab8d$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $f963e91e8b16ab8d$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $f963e91e8b16ab8d$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $f963e91e8b16ab8d$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $f963e91e8b16ab8d$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $f963e91e8b16ab8d$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $f963e91e8b16ab8d$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $f963e91e8b16ab8d$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $f963e91e8b16ab8d$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $f963e91e8b16ab8d$var$emptyRect;
    var styles = $f963e91e8b16ab8d$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $f963e91e8b16ab8d$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $f963e91e8b16ab8d$var$toFloat(styles.width), height = $f963e91e8b16ab8d$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $f963e91e8b16ab8d$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $f963e91e8b16ab8d$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$f963e91e8b16ab8d$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $f963e91e8b16ab8d$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $f963e91e8b16ab8d$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $f963e91e8b16ab8d$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $f963e91e8b16ab8d$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $f963e91e8b16ab8d$var$isDocumentElement(target) {
    return target === $f963e91e8b16ab8d$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $f963e91e8b16ab8d$var$getContentRect(target) {
    if (!$f963e91e8b16ab8d$var$isBrowser) return $f963e91e8b16ab8d$var$emptyRect;
    if ($f963e91e8b16ab8d$var$isSVGGraphicsElement(target)) return $f963e91e8b16ab8d$var$getSVGContentRect(target);
    return $f963e91e8b16ab8d$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $f963e91e8b16ab8d$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $f963e91e8b16ab8d$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $f963e91e8b16ab8d$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $f963e91e8b16ab8d$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $f963e91e8b16ab8d$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $f963e91e8b16ab8d$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $f963e91e8b16ab8d$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $f963e91e8b16ab8d$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $f963e91e8b16ab8d$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $f963e91e8b16ab8d$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $f963e91e8b16ab8d$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $f963e91e8b16ab8d$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $f963e91e8b16ab8d$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $f963e91e8b16ab8d$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $f963e91e8b16ab8d$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $f963e91e8b16ab8d$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $f963e91e8b16ab8d$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $f963e91e8b16ab8d$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $f963e91e8b16ab8d$var$ResizeObserverController.getInstance();
        var observer = new $f963e91e8b16ab8d$var$ResizeObserverSPI(callback, controller, this);
        $f963e91e8b16ab8d$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $f963e91e8b16ab8d$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $f963e91e8b16ab8d$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $f963e91e8b16ab8d$var$index = function() {
    // Export existing implementation if available.
    if (typeof $f963e91e8b16ab8d$var$global$1.ResizeObserver !== 'undefined') return $f963e91e8b16ab8d$var$global$1.ResizeObserver;
    return $f963e91e8b16ab8d$var$ResizeObserver;
}();
var $f963e91e8b16ab8d$export$2e2bcd8739ae039 = $f963e91e8b16ab8d$var$index;

});


parcelRegister("av2jA", function(module, exports) {

var $9ITqa = parcelRequire("9ITqa");
var $7a4e98533b4c422f$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $7a4e98533b4c422f$var$obj2mq = function(obj) {
    var mq = '';
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $9ITqa(feature);
        // Add px to dimension features
        if ($7a4e98533b4c422f$var$isDimension(feature) && typeof value === 'number') value = value + 'px';
        if (value === true) mq += feature;
        else if (value === false) mq += 'not ' + feature;
        else mq += '(' + feature + ': ' + value + ')';
        if (index < features.length - 1) mq += ' and ';
    });
    return mq;
};
var $7a4e98533b4c422f$var$json2mq = function(query) {
    var mq = '';
    if (typeof query === 'string') return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $7a4e98533b4c422f$var$obj2mq(q);
            if (index < query.length - 1) mq += ', ';
        });
        return mq;
    }
    // Handling single media query
    return $7a4e98533b4c422f$var$obj2mq(query);
};
module.exports = $7a4e98533b4c422f$var$json2mq;

});
parcelRegister("9ITqa", function(module, exports) {
var $7143368fc70b9b73$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return '-' + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $7143368fc70b9b73$var$camel2hyphen;

});


parcelRegister("cVWBi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $96a843c81cb6a731$var$_react = $96a843c81cb6a731$var$_interopRequireDefault((parcelRequire("1oC0p")));
function $96a843c81cb6a731$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $96a843c81cb6a731$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $96a843c81cb6a731$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $96a843c81cb6a731$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true
};
var $96a843c81cb6a731$var$_default = $96a843c81cb6a731$var$defaultProps;
module.exports["default"] = $96a843c81cb6a731$var$_default;

});

parcelRegister("6WTPO", function(module, exports) {

var $bEtTA = parcelRequire("bEtTA");
module.exports = new $bEtTA();

});
parcelRegister("bEtTA", function(module, exports) {

var $1AOsb = parcelRequire("1AOsb");

var $7CUTI = parcelRequire("7CUTI");
var $87ba9ec8c1c62a40$var$each = $7CUTI.each;
var $87ba9ec8c1c62a40$var$isFunction = $7CUTI.isFunction;
var $87ba9ec8c1c62a40$var$isArray = $7CUTI.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */ function $87ba9ec8c1c62a40$var$MediaQueryDispatch() {
    if (!window.matchMedia) throw new Error('matchMedia not present, legacy browsers require a polyfill');
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}
$87ba9ec8c1c62a40$var$MediaQueryDispatch.prototype = {
    constructor: $87ba9ec8c1c62a40$var$MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */ register: function(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) queries[q] = new $1AOsb(q, isUnconditional);
        //normalise to object in an array
        if ($87ba9ec8c1c62a40$var$isFunction(options)) options = {
            match: options
        };
        if (!$87ba9ec8c1c62a40$var$isArray(options)) options = [
            options
        ];
        $87ba9ec8c1c62a40$var$each(options, function(handler) {
            if ($87ba9ec8c1c62a40$var$isFunction(handler)) handler = {
                match: handler
            };
            queries[q].addHandler(handler);
        });
        return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */ unregister: function(q, handler) {
        var query = this.queries[q];
        if (query) {
            if (handler) query.removeHandler(handler);
            else {
                query.clear();
                delete this.queries[q];
            }
        }
        return this;
    }
};
module.exports = $87ba9ec8c1c62a40$var$MediaQueryDispatch;

});
parcelRegister("1AOsb", function(module, exports) {

var $kbCPJ = parcelRequire("kbCPJ");

var $7CUTI = parcelRequire("7CUTI");
var $12904a472c6cbd7a$require$each = $7CUTI.each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */ function $12904a472c6cbd7a$var$MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}
$12904a472c6cbd7a$var$MediaQuery.prototype = {
    constuctor: $12904a472c6cbd7a$var$MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */ addHandler: function(handler) {
        var qh = new $kbCPJ(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */ removeHandler: function(handler) {
        var handlers = this.handlers;
        $12904a472c6cbd7a$require$each(handlers, function(h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */ matches: function() {
        return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */ clear: function() {
        $12904a472c6cbd7a$require$each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */ assess: function() {
        var action = this.matches() ? 'on' : 'off';
        $12904a472c6cbd7a$require$each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};
module.exports = $12904a472c6cbd7a$var$MediaQuery;

});
parcelRegister("kbCPJ", function(module, exports) {
/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */ function $eb22f53a8d22825e$var$QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}
$eb22f53a8d22825e$var$QueryHandler.prototype = {
    constructor: $eb22f53a8d22825e$var$QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */ setup: function() {
        if (this.options.setup) this.options.setup();
        this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */ on: function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */ off: function() {
        this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */ destroy: function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */ equals: function(target) {
        return this.options === target || this.options.match === target;
    }
};
module.exports = $eb22f53a8d22825e$var$QueryHandler;

});

parcelRegister("7CUTI", function(module, exports) {
/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */ function $58d837b8175dff68$var$each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for(i; i < length; i++){
        cont = fn(collection[i], i);
        if (cont === false) break; //allow early exit
    }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */ function $58d837b8175dff68$var$isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */ function $58d837b8175dff68$var$isFunction(target) {
    return typeof target === 'function';
}
module.exports = {
    isFunction: $58d837b8175dff68$var$isFunction,
    isArray: $58d837b8175dff68$var$isArray,
    each: $58d837b8175dff68$var$each
};

});






parcelRegister("hPvyI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $08c724d146cbc953$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<a560ea44b2ab03f435923f2706ff854c>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $08c724d146cbc953$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "collectionCardCarouselContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Sys",
            "kind": "LinkedField",
            "name": "sys",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "collectionCardContentfulRelayFragment"
        }
    ],
    "type": "TemplateCollection",
    "abstractKey": null
};
$08c724d146cbc953$var$node.hash = "fdf5e06b0b871f667490c5a097846cff";
var $08c724d146cbc953$export$2e2bcd8739ae039 = $08c724d146cbc953$var$node;

});



parcelRegister("7lcJ5", function(module, exports) {
$parcel$export(module.exports, "TemplateFuzzySearch", function () { return $f8018f90df859daf$export$6cd85f399bebc53c; });
/* template-fuzzy-search-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $ddxTX = parcelRequire("ddxTX");

var $h6Fsc = parcelRequire("h6Fsc");

var $bZmYH = parcelRequire("bZmYH");

var $8KJ2x = parcelRequire("8KJ2x");

var $cml5G = parcelRequire("cml5G");

var $lRFwv = parcelRequire("lRFwv");

var $4EfnG = parcelRequire("4EfnG");

var $1mBr4 = parcelRequire("1mBr4");

var $377u5 = parcelRequire("377u5");
const $f8018f90df859daf$var$searchBarContainer = null;
const $f8018f90df859daf$var$searchBar = null;
const $f8018f90df859daf$var$searchIconStyle = null;
const $f8018f90df859daf$var$searchIconResultsStyle = null;
const $f8018f90df859daf$var$closeButtonStyles = null;
const $f8018f90df859daf$var$closeIconSectionStyles = null;
const $f8018f90df859daf$var$TemplateFuzzySearchIcon = /*#__PURE__*/ (0, $1oC0p.memo)(({ variant: variant })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3i1l27 _1bsb4bvh _syaztwqo _1e0c1txw _1bah1h6o _4cvr1h6o",
            variant == 'results' && "_sugaglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
            label: intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).searchLabel),
            size: "medium"
        })
    });
});
const $f8018f90df859daf$var$TemplateFuzzySearchCloseIcon = /*#__PURE__*/ (0, $1oC0p.memo)(({ onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bahesu3 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _4cvr1h6o _1pfhftgi _szfsglyw _8ycoglyw _g2chglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
            id: "clear-button",
            type: "submit",
            color: "#fff",
            onClick: onClick,
            testId: "clear-button",
            className: (0, $2jatx.default)([
                "_syaztwqo _19itglyw _1o9zidpf _80omtlke"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
                label: intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).closeLabel),
                color: "var(--ds-icon-subtle, #505258)",
                size: "medium"
            })
        })
    });
});
const $f8018f90df859daf$var$SET_INPUT_VALUE = 'SET_INPUT_VALUE';
const $f8018f90df859daf$var$SET_SUGGESTION = 'SET_SUGGESTION';
const $f8018f90df859daf$var$ACCEPT_SUGGESTION = 'ACCEPT_SUGGESTION';
const $f8018f90df859daf$var$HIDE_SUGGESTIONS = 'HIDE_SUGGESTIONS';
const $f8018f90df859daf$var$SHOW_SUGGESTIONS = 'SHOW_SUGGESTIONS';
const $f8018f90df859daf$var$reduceSearchState = (state, action)=>{
    switch(action.type){
        case $f8018f90df859daf$var$SET_INPUT_VALUE:
            if (action.value !== state.inputValue) return {
                ...state,
                inputValue: action.value,
                shouldShowSuggestions: true
            };
            return state;
        case $f8018f90df859daf$var$SET_SUGGESTION:
            if (action.value !== state.currentSuggestion) return {
                ...state,
                currentSuggestion: action.value,
                shouldShowSuggestions: true
            };
            return state;
        case $f8018f90df859daf$var$ACCEPT_SUGGESTION:
            return {
                ...state,
                inputValue: action.value,
                shouldShowSuggestions: false,
                currentSuggestion: null
            };
        case $f8018f90df859daf$var$HIDE_SUGGESTIONS:
            if (state.shouldShowSuggestions) return {
                ...state,
                shouldShowSuggestions: false
            };
            return state;
        case $f8018f90df859daf$var$SHOW_SUGGESTIONS:
            if (!state.shouldShowSuggestions) return {
                ...state,
                shouldShowSuggestions: true
            };
            return state;
        default:
            {
                const exhaustiveCheck = action;
                console.error(`Invalid action type ${exhaustiveCheck}`);
                return state;
            }
    }
};
const $f8018f90df859daf$var$toInputDisplay = (searchTerm)=>{
    if (!searchTerm) return '';
    if (typeof searchTerm === 'string') return searchTerm;
    return searchTerm.name ?? '';
};
const $f8018f90df859daf$var$useSearchState = (initialSearchTerm)=>{
    const [state, dispatch] = (0, $1oC0p.useReducer)($f8018f90df859daf$var$reduceSearchState, {
        inputValue: initialSearchTerm ?? null,
        shouldShowSuggestions: false
    });
    const actions = (0, $1oC0p.useMemo)(()=>({
            setInputValue: (value)=>{
                dispatch({
                    type: $f8018f90df859daf$var$SET_INPUT_VALUE,
                    value: value
                });
            },
            acceptSuggestion: (value)=>{
                dispatch({
                    type: $f8018f90df859daf$var$ACCEPT_SUGGESTION,
                    value: value
                });
            },
            setSuggestion: (value)=>{
                dispatch({
                    type: $f8018f90df859daf$var$SET_SUGGESTION,
                    value: value
                });
            },
            hideSuggestions: ()=>{
                dispatch({
                    type: $f8018f90df859daf$var$HIDE_SUGGESTIONS
                });
            },
            showSuggestions: ()=>{
                dispatch({
                    type: $f8018f90df859daf$var$SHOW_SUGGESTIONS
                });
            }
        }), []);
    return (0, $1oC0p.useMemo)(()=>[
            state,
            actions
        ], [
        state,
        actions
    ]);
};
const $f8018f90df859daf$export$6cd85f399bebc53c = ({ value: value, onSubmit: onSubmit })=>{
    const intl = (0, $8e22h.default)();
    const [{ inputValue: inputValue, currentSuggestion: currentSuggestion, shouldShowSuggestions: shouldShowSuggestions }, { setInputValue: setInputValue, setSuggestion: setSuggestion, acceptSuggestion: acceptSuggestion, hideSuggestions: hideSuggestions, showSuggestions: showSuggestions }] = $f8018f90df859daf$var$useSearchState(value);
    const searchRef = (0, $1oC0p.useRef)(null);
    const inputRef = (0, $1oC0p.useRef)(null);
    const hasSentAnalytic = (0, $1oC0p.useRef)(false);
    const onSubmitRef = (0, $1oC0p.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [suggestions, loadSuggestionsQuery] = (0, $377u5.useSearchSuggestionsLoader)();
    const [, startLoadSuggestions] = (0, $1oC0p.useTransition)();
    // Hide suggestions when the search term changes.
    (0, $1oC0p.useEffect)(hideSuggestions, [
        hideSuggestions,
        value
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldShowSuggestions) return;
        //Handling clicking outside the suggestion list, so it automatically closes when not the focus
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) hideSuggestions();
        };
        const handleEsc = (event)=>{
            if (event.key === 'Escape') hideSuggestions();
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEsc, false);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEsc, false);
        };
    }, [
        hideSuggestions,
        shouldShowSuggestions
    ]);
    const handleInputChange = (event)=>{
        event.preventDefault();
        // Send analytics data only the first time
        if (!hasSentAnalytic.current) {
            (0, $lRFwv.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchAnalytic();
            hasSentAnalytic.current = true; // Set the flag to true after the first call
        }
        setInputValue(event?.target?.value);
        if (event?.target?.value.length === 0) hideSuggestions();
    };
    const handleInputFocus = ()=>{
        if (!suggestions) startLoadSuggestions(loadSuggestionsQuery);
        (0, $lRFwv.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchFocusAnalytic();
        showSuggestions();
    };
    const handleMouseEnter = ()=>{
        if (!suggestions) startLoadSuggestions(loadSuggestionsQuery);
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'Enter') {
            if (inputValue) onSubmitRef.current?.(inputValue);
        }
    };
    const handleSuggestionClick = (suggestion)=>{
        acceptSuggestion(suggestion);
        if (suggestion) onSubmitRef.current?.(suggestion);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1q511u1b"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: searchRef,
            className: (0, $2jatx.default)([
                "_19itgzvk _1bsb1fa8 _4t3i1mcy _2rko1v6z _bfhku67f _w4ky1y6m _125x7vkz _yizh1nn1 _1r1b1tcg _psgkr3uz _1heulnmy _1ru31q9c _1yzy15vq _bgrh15vq _509t1l2s _wr7noxwj _1hr2dgin _12rrdgin _7bcc12aa _1qwo12aa"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                    ref: inputRef,
                    id: "templates-fuzzy-search-input",
                    testId: "templates-fuzzy-search-input",
                    placeholder: intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).fuzzySearchInputText),
                    onChange: handleInputChange,
                    onFocus: handleInputFocus,
                    onMouseEnter: handleMouseEnter,
                    onKeyDown: handleKeyDown,
                    value: $f8018f90df859daf$var$toInputDisplay(inputValue),
                    autoComplete: "off",
                    // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
                    role: "combobox",
                    "aria-haspopup": "listbox",
                    "aria-owns": "suggestion-box",
                    "aria-expanded": shouldShowSuggestions,
                    "aria-activedescendant": currentSuggestion ? `option-${currentSuggestion.id}` : undefined,
                    elemBeforeInput: /*#__PURE__*/ (0, $7VQPk.jsx)($f8018f90df859daf$var$TemplateFuzzySearchIcon, {}),
                    elemAfterInput: inputValue ? /*#__PURE__*/ (0, $7VQPk.jsx)($f8018f90df859daf$var$TemplateFuzzySearchCloseIcon, {
                        onClick: ()=>setInputValue(null)
                    }) : null
                }),
                shouldShowSuggestions && suggestions && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
                    fallback: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {}),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                        fallback: inputValue && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1mBr4.TemplateFuzzySearchSuggestionsLoading), {}),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1mBr4.TemplateFuzzySearchSuggestions), {
                            queryRefSuggestions: suggestions,
                            currentSuggestion: currentSuggestion,
                            inputValue: inputValue,
                            onSelect: setSuggestion,
                            onSubmit: handleSuggestionClick
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("1mBr4", function(module, exports) {
$parcel$export(module.exports, "TemplateFuzzySearchSuggestions", function () { return $c82bafea681136ed$export$71b42e992a111c35; });
$parcel$export(module.exports, "TemplateFuzzySearchSuggestionsLoading", function () { return $c82bafea681136ed$export$92f6255a57b0e383; });
/* template-fuzzy-search-suggestions-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bZmYH = parcelRequire("bZmYH");

var $20Gca = parcelRequire("20Gca");

var $7qFQI = parcelRequire("7qFQI");

var $cml5G = parcelRequire("cml5G");

var $lRFwv = parcelRequire("lRFwv");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $377u5 = parcelRequire("377u5");
const $c82bafea681136ed$var$suggestionContainerStyle = null;
const $c82bafea681136ed$var$suggestionSpinnerStyle = null;
const $c82bafea681136ed$var$suggestionListStyle = null;
const $c82bafea681136ed$var$suggestionItemStyle = null;
const $c82bafea681136ed$var$searchIconStyle = null;
const $c82bafea681136ed$var$searchIconResultsStyle = null;
const $c82bafea681136ed$var$TemplateFuzzySearchIcon = /*#__PURE__*/ (0, $1oC0p.memo)(({ variant: variant })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3i1l27 _1bsb4bvh _syaztwqo _1e0c1txw _1bah1h6o _4cvr1h6o",
            variant == 'results' && "_sugaglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
            label: intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).searchLabel),
            size: "medium"
        })
    });
});
const $c82bafea681136ed$var$SuggestionItem = ({ suggestion: suggestion })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($c82bafea681136ed$var$TemplateFuzzySearchIcon, {
                variant: "results"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bah1y6m _1wyb1j6v _k48pbfng _vwz41tcg _syazr3uz _ect4z4z1 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1cqsoxwj"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.text'))
                },
                children: suggestion.name
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                children: [
                    suggestion.type === 'category' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                        appearance: "success",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "confluence.main.area.cfind.fuzzysearch.label.category",
                            defaultMessage: "CATEGORY"
                        })
                    }),
                    suggestion.type === 'template' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                        appearance: "inprogress",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "confluence.main.area.cfind.fuzzysearch.label.template",
                            defaultMessage: "TEMPLATE"
                        })
                    })
                ]
            })
        ]
    });
};
const $c82bafea681136ed$var$currentSuggestionIsValid = (currentSuggestion, suggestions)=>{
    if (!currentSuggestion) return true;
    if (!suggestions) return false;
    return suggestions.includes(currentSuggestion);
};
const $c82bafea681136ed$var$nextSuggestion = (suggestions, currentSuggestion, onSelect)=>{
    if (!onSelect) return;
    let nextSuggestion = suggestions?.[0] ?? null;
    if (currentSuggestion) {
        const index = suggestions?.indexOf(currentSuggestion) ?? -1;
        if (index > -1) nextSuggestion = suggestions?.[index + 1] ?? currentSuggestion;
    }
    onSelect?.(nextSuggestion);
};
const $c82bafea681136ed$var$prevSuggestion = (suggestions, currentSuggestion, onSelect)=>{
    if (!onSelect) return;
    let prevSuggestion = suggestions?.[suggestions.length - 1] ?? null;
    if (currentSuggestion) {
        const index = suggestions?.indexOf(currentSuggestion) ?? -1;
        if (index > -1) prevSuggestion = suggestions?.[index - 1] ?? currentSuggestion;
    }
    onSelect?.(prevSuggestion);
};
const $c82bafea681136ed$var$acceptSuggestion = (suggestion, onSubmit)=>{
    onSubmit?.(suggestion);
    (0, $lRFwv.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchPreviewAnalytic(// @ts-ignore: SearchSuggestion is a union type roughly equivalent to TemplateSearchItem
    suggestion);
};
const $c82bafea681136ed$export$71b42e992a111c35 = ({ currentSuggestion: currentSuggestion, queryRefSuggestions: queryRefSuggestions, inputValue: inputValue, onSubmit: onSubmit, onSelect: onSelect })=>{
    const suggestions = (0, $377u5.useSearchSuggestions)(queryRefSuggestions, inputValue);
    (0, $1oC0p.useEffect)(()=>{
        if (currentSuggestion) document.getElementById(`option-${currentSuggestion.id}`)?.scrollIntoView({
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        currentSuggestion
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                $c82bafea681136ed$var$nextSuggestion(suggestions, currentSuggestion, onSelect);
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                $c82bafea681136ed$var$prevSuggestion(suggestions, currentSuggestion, onSelect);
            } else if (event.key === 'Enter') {
                if (currentSuggestion) {
                    event.preventDefault();
                    $c82bafea681136ed$var$acceptSuggestion(currentSuggestion, onSubmit);
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        suggestions,
        currentSuggestion,
        onSelect,
        onSubmit
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (inputValue) (0, $lRFwv.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchResultsAnalytic((suggestions?.length ?? 0).toString());
    }, [
        inputValue,
        suggestions
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!$c82bafea681136ed$var$currentSuggestionIsValid(currentSuggestion, suggestions)) onSelect?.(null);
    }, [
        currentSuggestion,
        suggestions,
        onSelect
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "suggestion-box",
        "data-testid": "template-fuzzy-search-suggestions",
        role: "listbox",
        "aria-labelledby": currentSuggestion ? `option-${currentSuggestion.id}` : undefined,
        className: (0, $2jatx.default)([
            "_bfhku67f _19it8ned _kdam152l _y3gn1e5h _1wpz1fhb _c71l37m0 _18m91wug _kqswh2mm _1pbycs5v _2rko1v6z"
        ]),
        children: suggestions?.map((suggestion)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                id: `option-${suggestion.id}`,
                // Tech debt that should be fixed. See ldr/0012-jsx-a11y-strict.md for details.
                // eslint-disable-next-line @atlassian/a11y/aria-role
                role: "value",
                "aria-label": `Select ${suggestion.name}`,
                "aria-selected": currentSuggestion?.id === suggestion.id,
                onClick: ()=>$c82bafea681136ed$var$acceptSuggestion(suggestion, onSubmit),
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _80omtlke _irr335wh _1fpi35wh _jomr35wh _1di635wh _v73619bv _chtu19bv _nssp1yb4"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c82bafea681136ed$var$SuggestionItem, {
                    suggestion: suggestion
                })
            }, suggestion.id))
    });
};
const $c82bafea681136ed$export$92f6255a57b0e383 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "suggestion-box",
        "data-testid": "template-fuzzy-search-suggestions",
        role: "listbox",
        className: (0, $2jatx.default)([
            "_bfhku67f _19it8ned _kdam152l _y3gn1e5h _1wpz1fhb _c71l37m0 _18m91wug _kqswh2mm _1pbycs5v _2rko1v6z"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "template-fuzzy-search-suggestions-spinner",
            className: (0, $2jatx.default)([
                "_ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {})
        })
    });
};

});
parcelRegister("20Gca", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $176c4ff09b93c636$export$2e2bcd8739ae039; });
/* eslint-disable @atlassian/tangerine/import/entry-points */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
var $1oC0p = parcelRequire("1oC0p");

var $gnCSJ = parcelRequire("gnCSJ");

var $6jhtl = parcelRequire("6jhtl");
var $cOi0j = parcelRequire("cOi0j");
var $176c4ff09b93c636$var$baseStyles = (0, $cOi0j.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    position: 'static',
    overflow: 'hidden'
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $176c4ff09b93c636$var$Lozenge = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = appearance in $176c4ff09b93c636$var$backgroundColors[appearanceStyle] ? appearance : 'default';
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6jhtl.default), {
        as: "span",
        backgroundColor: $176c4ff09b93c636$var$backgroundColors[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $176c4ff09b93c636$var$baseStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gnCSJ.default), {
        fontSize: "size.050",
        fontWeight: "bold",
        lineHeight: "lineHeight.100",
        textTransform: "uppercase",
        color: $176c4ff09b93c636$var$textColors[appearanceStyle][appearanceType],
        shouldTruncate: true,
        UNSAFE_style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        testId: testId && "".concat(testId, "--text")
    }, children));
});
$176c4ff09b93c636$var$Lozenge.displayName = 'Lozenge';
var $176c4ff09b93c636$export$2e2bcd8739ae039 = $176c4ff09b93c636$var$Lozenge;
// Lozenge colors
var $176c4ff09b93c636$var$backgroundColors = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
var $176c4ff09b93c636$var$textColors = {
    bold: {
        default: 'inverse',
        inprogress: 'inverse',
        moved: 'warning.inverse',
        new: 'inverse',
        removed: 'inverse',
        success: 'inverse'
    },
    subtle: {
        default: 'subtle',
        inprogress: 'information',
        moved: 'warning',
        new: 'discovery',
        removed: 'danger',
        success: 'success'
    }
};

});
parcelRegister("gnCSJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $beccf46a71e52176$export$2e2bcd8739ae039; });

var $7kHKh = parcelRequire("7kHKh");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $bGqub = parcelRequire("bGqub");

var $aYDF4 = parcelRequire("aYDF4");
var $beccf46a71e52176$var$_excluded = [
    "children"
];
var $beccf46a71e52176$var$asAllowlist = [
    'span',
    'div',
    'p',
    'strong'
];
var $beccf46a71e52176$var$textAlignMap = {
    center: (0, $3dJ4i.css)({
        textAlign: 'center'
    }),
    end: (0, $3dJ4i.css)({
        textAlign: 'end'
    }),
    start: (0, $3dJ4i.css)({
        textAlign: 'start'
    })
};
var $beccf46a71e52176$var$textTransformMap = {
    none: (0, $3dJ4i.css)({
        textTransform: 'none'
    }),
    lowercase: (0, $3dJ4i.css)({
        textTransform: 'lowercase'
    }),
    uppercase: (0, $3dJ4i.css)({
        textTransform: 'uppercase'
    })
};
var $beccf46a71e52176$var$verticalAlignMap = {
    top: (0, $3dJ4i.css)({
        verticalAlign: 'top'
    }),
    middle: (0, $3dJ4i.css)({
        verticalAlign: 'middle'
    }),
    bottom: (0, $3dJ4i.css)({
        verticalAlign: 'bottom'
    })
};
var $beccf46a71e52176$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)"
});
var $beccf46a71e52176$var$truncateStyles = (0, $3dJ4i.css)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $beccf46a71e52176$var$useColor = function useColor(colorProp) {
    var surface = (0, $aYDF4.useSurface)();
    var inverseTextColor = (0, $bGqub.default)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $beccf46a71e52176$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $beccf46a71e52176$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($beccf46a71e52176$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $beccf46a71e52176$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, $7kHKh.default)(_ref, $beccf46a71e52176$var$_excluded);
    var _props$as = props.as, Component = _props$as === void 0 ? 'span' : _props$as, colorProp = props.color, fontSize = props.fontSize, fontWeight = props.fontWeight, lineHeight = props.lineHeight, _props$shouldTruncate = props.shouldTruncate, shouldTruncate = _props$shouldTruncate === void 0 ? false : _props$shouldTruncate, textAlign = props.textAlign, textTransform = props.textTransform, verticalAlign = props.verticalAlign, testId = props.testId, UNSAFE_style = props.UNSAFE_style, id = props.id;
    (0, $lmxXn.default)($beccf46a71e52176$var$asAllowlist.includes(Component), "@atlaskit/ds-explorations: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var color = $beccf46a71e52176$var$useColor(colorProp);
    var isWrapped = $beccf46a71e52176$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, children);
    var component = (0, $3dJ4i.jsx)(Component, {
        style: UNSAFE_style,
        css: [
            $beccf46a71e52176$var$baseStyles,
            $beccf46a71e52176$var$fontFamilyMap.sans,
            color && $beccf46a71e52176$var$textColorMap[color],
            fontSize && $beccf46a71e52176$var$fontSizeMap[fontSize],
            fontWeight && $beccf46a71e52176$var$fontWeightMap[fontWeight],
            lineHeight && $beccf46a71e52176$var$lineHeightMap[lineHeight],
            shouldTruncate && $beccf46a71e52176$var$truncateStyles,
            textAlign && $beccf46a71e52176$var$textAlignMap[textAlign],
            textTransform && $beccf46a71e52176$var$textTransformMap[textTransform],
            verticalAlign && $beccf46a71e52176$var$verticalAlignMap[verticalAlign]
        ],
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $3dJ4i.jsx)($beccf46a71e52176$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $beccf46a71e52176$export$2e2bcd8739ae039 = $beccf46a71e52176$var$Text;
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f42dabbb2f08c0ca0dd8a46fc3508937>>
 * @codegenId typography
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["fontSize", "fontWeight", "fontFamily", "lineHeight"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-typography.tsx <<SignedSource::ca98df97c16967b7984f4ad4d557cc48>>
 */ var $beccf46a71e52176$var$fontSizeMap = {
    'size.050': (0, $3dJ4i.css)({
        fontSize: "var(--ds-font-size-050, 11px)"
    }),
    'size.075': (0, $3dJ4i.css)({
        fontSize: "var(--ds-font-size-075, 12px)"
    }),
    'size.100': (0, $3dJ4i.css)({
        fontSize: "var(--ds-font-size-100, 14px)"
    }),
    'size.200': (0, $3dJ4i.css)({
        fontSize: "var(--ds-font-size-200, 16px)"
    }),
    'size.300': (0, $3dJ4i.css)({
        fontSize: "var(--ds-font-size-300, 20px)"
    }),
    'size.400': (0, $3dJ4i.css)({
        fontSize: "var(--ds-font-size-400, 24px)"
    }),
    'size.500': (0, $3dJ4i.css)({
        fontSize: "var(--ds-font-size-500, 29px)"
    }),
    'size.600': (0, $3dJ4i.css)({
        fontSize: "var(--ds-font-size-600, 35px)"
    })
};
var $beccf46a71e52176$var$fontWeightMap = {
    bold: (0, $3dJ4i.css)({
        fontWeight: "var(--ds-font-weight-bold, 700)"
    }),
    medium: (0, $3dJ4i.css)({
        fontWeight: "var(--ds-font-weight-medium, 500)"
    }),
    regular: (0, $3dJ4i.css)({
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }),
    semibold: (0, $3dJ4i.css)({
        fontWeight: "var(--ds-font-weight-semibold, 600)"
    })
};
var $beccf46a71e52176$var$fontFamilyMap = {
    body: (0, $3dJ4i.css)({
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    brand: (0, $3dJ4i.css)({
        fontFamily: "var(--ds-font-family-brand, Charlie Sans)"
    }),
    code: (0, $3dJ4i.css)({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
    }),
    heading: (0, $3dJ4i.css)({
        fontFamily: "var(--ds-font-family-heading, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    monospace: (0, $3dJ4i.css)({
        fontFamily: "var(--ds-font-family-monospace, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
    }),
    sans: (0, $3dJ4i.css)({
        fontFamily: "var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"
    })
};
var $beccf46a71e52176$var$lineHeightMap = {
    'lineHeight.1': (0, $3dJ4i.css)({
        lineHeight: "var(--ds-font-lineHeight-1, 1)"
    }),
    'lineHeight.100': (0, $3dJ4i.css)({
        lineHeight: "var(--ds-font-lineHeight-100, 16px)"
    }),
    'lineHeight.200': (0, $3dJ4i.css)({
        lineHeight: "var(--ds-font-lineHeight-200, 20px)"
    }),
    'lineHeight.300': (0, $3dJ4i.css)({
        lineHeight: "var(--ds-font-lineHeight-300, 24px)"
    }),
    'lineHeight.400': (0, $3dJ4i.css)({
        lineHeight: "var(--ds-font-lineHeight-400, 28px)"
    }),
    'lineHeight.500': (0, $3dJ4i.css)({
        lineHeight: "var(--ds-font-lineHeight-500, 32px)"
    }),
    'lineHeight.600': (0, $3dJ4i.css)({
        lineHeight: "var(--ds-font-lineHeight-600, 40px)"
    })
};
/**
 * @codegenEnd
 */ /**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95d4f240e36e302a634e8633a0782cba>>
 * @codegenId colors
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["text"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::f1021f8d47ab63374e371ce18db72a1c>>
 */ var $beccf46a71e52176$var$textColorMap = {
    'color.text': (0, $3dJ4i.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    disabled: (0, $3dJ4i.css)({
        color: "var(--ds-text-disabled, #A5ADBA)"
    }),
    inverse: (0, $3dJ4i.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    selected: (0, $3dJ4i.css)({
        color: "var(--ds-text-selected, #0052CC)"
    }),
    brand: (0, $3dJ4i.css)({
        color: "var(--ds-text-brand, #0065FF)"
    }),
    danger: (0, $3dJ4i.css)({
        color: "var(--ds-text-danger, #DE350B)"
    }),
    warning: (0, $3dJ4i.css)({
        color: "var(--ds-text-warning, #974F0C)"
    }),
    'warning.inverse': (0, $3dJ4i.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }),
    success: (0, $3dJ4i.css)({
        color: "var(--ds-text-success, #006644)"
    }),
    discovery: (0, $3dJ4i.css)({
        color: "var(--ds-text-discovery, #403294)"
    }),
    information: (0, $3dJ4i.css)({
        color: "var(--ds-text-information, #0052CC)"
    }),
    subtlest: (0, $3dJ4i.css)({
        color: "var(--ds-text-subtlest, #7A869A)"
    }),
    subtle: (0, $3dJ4i.css)({
        color: "var(--ds-text-subtle, #42526E)"
    })
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("7kHKh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $556c5598016f205d$export$2e2bcd8739ae039; });

var $8YND7 = parcelRequire("8YND7");
function $556c5598016f205d$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $8YND7.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("8YND7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $689a6cc68af6d6ec$export$2e2bcd8739ae039; });
function $689a6cc68af6d6ec$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("bGqub", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $881829824dd04f58$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * The color map is used to map a background color token to a matching text color that will meet contrast.
 *
 * @codegen <<SignedSource::9db207c6fd205f6abc46eeb73ba02789>>
 * @codegenCommand yarn codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::f1021f8d47ab63374e371ce18db72a1c>>
 */ var $881829824dd04f58$export$2e2bcd8739ae039 = {
    'neutral.bold': 'inverse',
    'neutral.bold.hovered': 'inverse',
    'neutral.bold.pressed': 'inverse',
    'selected.bold': 'inverse',
    'selected.bold.hovered': 'inverse',
    'selected.bold.pressed': 'inverse',
    'brand.bold': 'inverse',
    'brand.bold.hovered': 'inverse',
    'brand.bold.pressed': 'inverse',
    'brand.boldest': 'inverse',
    'brand.boldest.hovered': 'inverse',
    'brand.boldest.pressed': 'inverse',
    'danger.bold': 'inverse',
    'danger.bold.hovered': 'inverse',
    'danger.bold.pressed': 'inverse',
    'warning.bold': 'warning.inverse',
    'warning.bold.hovered': 'warning.inverse',
    'warning.bold.pressed': 'warning.inverse',
    'success.bold': 'inverse',
    'success.bold.hovered': 'inverse',
    'success.bold.pressed': 'inverse',
    'discovery.bold': 'inverse',
    'discovery.bold.hovered': 'inverse',
    'discovery.bold.pressed': 'inverse',
    'information.bold': 'inverse',
    'information.bold.hovered': 'inverse',
    'information.bold.pressed': 'inverse'
};

});

parcelRegister("aYDF4", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $7fde45eb2e8aa580$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $7fde45eb2e8aa580$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $7fde45eb2e8aa580$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($7fde45eb2e8aa580$export$1ca2a26fecb070ae);
};
$7fde45eb2e8aa580$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("6jhtl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $49821214d806179b$export$2e2bcd8739ae039; });

var $8LGxC = parcelRequire("8LGxC");

var $62LTP = parcelRequire("62LTP");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $csq11 = parcelRequire("csq11");

var $cOi0j = parcelRequire("cOi0j");

var $ltA5J = parcelRequire("ltA5J");
var $49821214d806179b$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $49821214d806179b$var$_excluded2 = [
    "className"
];
var $49821214d806179b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $62LTP.default)(_ref, $49821214d806179b$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $62LTP.default)(htmlAttributes, $49821214d806179b$var$_excluded2);
    var className = xcss && (0, $cOi0j.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $8LGxC.default)({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $49821214d806179b$var$baseStyles,
            backgroundColor && (0, $csq11.backgroundColorStylesMap)[backgroundColor],
            (0, $csq11.isSurfaceColorToken)(backgroundColor) && (0, $csq11.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $csq11.paddingStylesMap).padding[padding],
            paddingBlock && (0, $csq11.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $csq11.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $csq11.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $csq11.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $csq11.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $csq11.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $ltA5J.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $49821214d806179b$export$2e2bcd8739ae039 = $49821214d806179b$export$e71c4d32a2263218;
var $49821214d806179b$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("8LGxC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6623b64c98e04589$export$2e2bcd8739ae039; });
function $6623b64c98e04589$export$2e2bcd8739ae039() {
    return $6623b64c98e04589$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6623b64c98e04589$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("62LTP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $466815d4c9735cc4$export$2e2bcd8739ae039; });

var $k5UQ8 = parcelRequire("k5UQ8");
function $466815d4c9735cc4$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $k5UQ8.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("k5UQ8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea105d78813c415f$export$2e2bcd8739ae039; });
function $ea105d78813c415f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("csq11", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $911c47b3f333df55$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "spaceMap", function () { return $911c47b3f333df55$export$1f52408f03b1c9b4; });
$parcel$export(module.exports, "borderColorMap", function () { return $911c47b3f333df55$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $911c47b3f333df55$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "shadowMap", function () { return $911c47b3f333df55$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "textColorMap", function () { return $911c47b3f333df55$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $911c47b3f333df55$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $911c47b3f333df55$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $911c47b3f333df55$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $911c47b3f333df55$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $911c47b3f333df55$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $911c47b3f333df55$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $911c47b3f333df55$export$5e65a44e5b6ecadb; });

var $1yFQ0 = parcelRequire("1yFQ0");

var $3dJ4i = parcelRequire("3dJ4i");

var $drZAJ = parcelRequire("drZAJ");
var $911c47b3f333df55$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $911c47b3f333df55$export$1f52408f03b1c9b4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $911c47b3f333df55$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $911c47b3f333df55$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $911c47b3f333df55$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $911c47b3f333df55$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $911c47b3f333df55$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $911c47b3f333df55$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)"
};
var $911c47b3f333df55$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $911c47b3f333df55$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $911c47b3f333df55$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $911c47b3f333df55$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $911c47b3f333df55$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $911c47b3f333df55$export$6cc560b4dedf3816 = {
    'font.size.050': "var(--ds-font-size-050, 11px)",
    'font.size.075': "var(--ds-font-size-075, 12px)",
    'font.size.100': "var(--ds-font-size-100, 14px)",
    'font.size.200': "var(--ds-font-size-200, 16px)",
    'font.size.300': "var(--ds-font-size-300, 20px)",
    'font.size.400': "var(--ds-font-size-400, 24px)",
    'font.size.500': "var(--ds-font-size-500, 29px)",
    'font.size.600': "var(--ds-font-size-600, 35px)"
};
var $911c47b3f333df55$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $911c47b3f333df55$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand': "var(--ds-font-family-brand, Charlie Sans)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.monospace': "var(--ds-font-family-monospace, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.sans': "var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"
};
var $911c47b3f333df55$export$360c29a380c1a34 = {
    'font.lineHeight.1': "var(--ds-font-lineHeight-1, 1)",
    'font.lineHeight.100': "var(--ds-font-lineHeight-100, 16px)",
    'font.lineHeight.200': "var(--ds-font-lineHeight-200, 20px)",
    'font.lineHeight.300': "var(--ds-font-lineHeight-300, 24px)",
    'font.lineHeight.400': "var(--ds-font-lineHeight-400, 28px)",
    'font.lineHeight.500': "var(--ds-font-lineHeight-500, 32px)",
    'font.lineHeight.600': "var(--ds-font-lineHeight-600, 40px)"
};
var $911c47b3f333df55$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px var(--ds-font-family-body))",
    'body.large': "var(--ds-font-body-large, normal 400 16px/24px var(--ds-font-family-body))",
    'body.small': "var(--ds-font-body-small, normal 400 11px/20px var(--ds-font-family-body))"
};
var $911c47b3f333df55$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 400 14px/1 var(--ds-font-family-body))",
    'ui.small': "var(--ds-font-ui-small, normal 400 11px/1 var(--ds-font-family-body))"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $911c47b3f333df55$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $911c47b3f333df55$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $1yFQ0.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $911c47b3f333df55$export$e615f061ca585a6c = $911c47b3f333df55$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $911c47b3f333df55$var$getSerializedStylesMap(spacingProperty, $911c47b3f333df55$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $911c47b3f333df55$export$bf46c3f9eeafc71f = $911c47b3f333df55$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $911c47b3f333df55$var$getSerializedStylesMap(spacingProperty, $911c47b3f333df55$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $911c47b3f333df55$export$e7af83bafe7f9e63 = $911c47b3f333df55$var$getSerializedStylesMap('backgroundColor', $911c47b3f333df55$export$d1d79bf68ac056bd);
var $911c47b3f333df55$export$3a1bcba60b23d7f0 = $911c47b3f333df55$var$getSerializedStylesMap('color', $911c47b3f333df55$export$8473307aa00d6ea1);
var $911c47b3f333df55$export$f7183c9e2dbc2543 = $911c47b3f333df55$var$getSerializedStylesMap('fontSize', $911c47b3f333df55$export$6cc560b4dedf3816);
var $911c47b3f333df55$export$45f3f4fe16f9f7d5 = $911c47b3f333df55$var$getSerializedStylesMap('fontWeight', $911c47b3f333df55$export$303e322c6b1ed114);
var $911c47b3f333df55$export$68cc305da27dbaa4 = $911c47b3f333df55$var$getSerializedStylesMap('fontFamily', $911c47b3f333df55$export$3c7e9587132614b4);
var $911c47b3f333df55$export$8be4a21014f48eb1 = $911c47b3f333df55$var$getSerializedStylesMap('lineHeight', $911c47b3f333df55$export$360c29a380c1a34);
var $911c47b3f333df55$export$a1962444bbf058e = $911c47b3f333df55$var$getSerializedStylesMap('font', $911c47b3f333df55$export$b5bac06d7d8fd0d1);
var $911c47b3f333df55$export$ca3e246f24657bd6 = $911c47b3f333df55$var$getSerializedStylesMap('font', $911c47b3f333df55$export$b27166c9cf2c9f74);
var $911c47b3f333df55$export$ff257d957d48c421 = $911c47b3f333df55$var$getSerializedStylesMap((0, $drZAJ.CURRENT_SURFACE_CSS_VAR), $911c47b3f333df55$export$41a358c9c2356760);
var $911c47b3f333df55$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $911c47b3f333df55$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("1yFQ0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $12296b8cece5b2f4$export$2e2bcd8739ae039; });

var $eHBDp = parcelRequire("eHBDp");
function $12296b8cece5b2f4$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $eHBDp.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("eHBDp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab42464c47c0a18f$export$2e2bcd8739ae039; });

var $iWEUX = parcelRequire("iWEUX");

var $dP49s = parcelRequire("dP49s");
function $ab42464c47c0a18f$export$2e2bcd8739ae039(t) {
    var i = (0, $dP49s.default)(t, "string");
    return "symbol" == (0, $iWEUX.default)(i) ? i : i + "";
}

});
parcelRegister("iWEUX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dcad622e926fb44a$export$2e2bcd8739ae039; });
function $dcad622e926fb44a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $dcad622e926fb44a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dcad622e926fb44a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("dP49s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a10342336f30c32e$export$2e2bcd8739ae039; });

var $iWEUX = parcelRequire("iWEUX");
function $a10342336f30c32e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $iWEUX.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $iWEUX.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("drZAJ", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $9cad92c689159526$export$9d7b58831ae93caa; });
var $9cad92c689159526$export$4ef52930e33717cd = 'data-theme';
var $9cad92c689159526$export$a00eac3f8684bcd0 = 'data-color-mode';
var $9cad92c689159526$export$2112803007239c61 = 'data-contrast-mode';
var $9cad92c689159526$export$352e418ed5b6193a = 'data-custom-theme';
var $9cad92c689159526$export$2faeed762aac6741 = 'light';
var $9cad92c689159526$export$6f0c6fb8c80fcc92 = 'ds';
var $9cad92c689159526$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $9cad92c689159526$export$dddac1532e822863 = "--".concat($9cad92c689159526$export$6f0c6fb8c80fcc92, "-token-not-found");
var $9cad92c689159526$export$9d7b58831ae93caa = "--".concat($9cad92c689159526$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("cOi0j", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $95381ec639b7ae84$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $95381ec639b7ae84$export$f6c783d06584602c; });

var $1yFQ0 = parcelRequire("1yFQ0");

var $4QQQt = parcelRequire("4QQQt");

var $iWEUX = parcelRequire("iWEUX");

var $3dJ4i = parcelRequire("3dJ4i");

var $csq11 = parcelRequire("csq11");

var $7t0tI = parcelRequire("7t0tI");
var $95381ec639b7ae84$var$tokensMap = {
    backgroundColor: (0, $csq11.backgroundColorMap),
    blockSize: (0, $csq11.dimensionMap),
    borderColor: (0, $csq11.borderColorMap),
    borderRadius: (0, $csq11.borderRadiusMap),
    borderWidth: (0, $csq11.borderWidthMap),
    bottom: (0, $csq11.spaceMap),
    boxShadow: (0, $csq11.shadowMap),
    color: (0, $csq11.textColorMap),
    columnGap: (0, $csq11.spaceMap),
    gap: (0, $csq11.spaceMap),
    height: (0, $csq11.dimensionMap),
    inlineSize: (0, $csq11.dimensionMap),
    inset: (0, $csq11.spaceMap),
    insetBlock: (0, $csq11.spaceMap),
    insetBlockEnd: (0, $csq11.spaceMap),
    insetBlockStart: (0, $csq11.spaceMap),
    insetInline: (0, $csq11.spaceMap),
    insetInlineEnd: (0, $csq11.spaceMap),
    insetInlineStart: (0, $csq11.spaceMap),
    margin: (0, $csq11.spaceMap),
    marginBlock: (0, $csq11.spaceMap),
    marginBlockEnd: (0, $csq11.spaceMap),
    marginBlockStart: (0, $csq11.spaceMap),
    marginBottom: (0, $csq11.spaceMap),
    marginInline: (0, $csq11.spaceMap),
    marginInlineEnd: (0, $csq11.spaceMap),
    marginInlineStart: (0, $csq11.spaceMap),
    marginLeft: (0, $csq11.spaceMap),
    marginRight: (0, $csq11.spaceMap),
    marginTop: (0, $csq11.spaceMap),
    left: (0, $csq11.spaceMap),
    maxBlockSize: (0, $csq11.dimensionMap),
    maxHeight: (0, $csq11.dimensionMap),
    maxInlineSize: (0, $csq11.dimensionMap),
    maxWidth: (0, $csq11.dimensionMap),
    minBlockSize: (0, $csq11.dimensionMap),
    minHeight: (0, $csq11.dimensionMap),
    minInlineSize: (0, $csq11.dimensionMap),
    minWidth: (0, $csq11.dimensionMap),
    outlineOffset: (0, $csq11.spaceMap),
    outlineWidth: (0, $csq11.borderWidthMap),
    outlineColor: (0, $csq11.borderColorMap),
    padding: (0, $csq11.spaceMap),
    paddingBlock: (0, $csq11.spaceMap),
    paddingBlockEnd: (0, $csq11.spaceMap),
    paddingBlockStart: (0, $csq11.spaceMap),
    paddingBottom: (0, $csq11.spaceMap),
    paddingInline: (0, $csq11.spaceMap),
    paddingInlineEnd: (0, $csq11.spaceMap),
    paddingInlineStart: (0, $csq11.spaceMap),
    paddingLeft: (0, $csq11.spaceMap),
    paddingRight: (0, $csq11.spaceMap),
    paddingTop: (0, $csq11.spaceMap),
    right: (0, $csq11.spaceMap),
    rowGap: (0, $csq11.spaceMap),
    top: (0, $csq11.spaceMap),
    width: (0, $csq11.dimensionMap),
    zIndex: (0, $csq11.layerMap)
};
var $95381ec639b7ae84$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $95381ec639b7ae84$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $iWEUX.default)($7t0tI)) === 'object' && (0, $iWEUX.default)($7t0tI.env) === 'object' && false;
};
var $95381ec639b7ae84$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $95381ec639b7ae84$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $95381ec639b7ae84$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $iWEUX.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $4QQQt.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $iWEUX.default)(value) === 'object' && $95381ec639b7ae84$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($95381ec639b7ae84$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($95381ec639b7ae84$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $95381ec639b7ae84$var$tokensMap)) return;
        var tokenValue = $95381ec639b7ae84$var$tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $95381ec639b7ae84$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $95381ec639b7ae84$var$transformStyles(style);
    return (0, $1yFQ0.default)({}, $95381ec639b7ae84$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
var $95381ec639b7ae84$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$95381ec639b7ae84$var$uniqueSymbol];
    typeof $7t0tI === "undefined" || (0, $iWEUX.default)($7t0tI);
    return styles;
};
function $95381ec639b7ae84$export$f6c783d06584602c(style) {
    return $95381ec639b7ae84$var$baseXcss(style);
}

});
parcelRegister("4QQQt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $388502bf7584d521$export$2e2bcd8739ae039; });

var $dsK1g = parcelRequire("dsK1g");

var $fAr3q = parcelRequire("fAr3q");

var $3JLwG = parcelRequire("3JLwG");

var $e7ZlA = parcelRequire("e7ZlA");
function $388502bf7584d521$export$2e2bcd8739ae039(r, e) {
    return (0, $dsK1g.default)(r) || (0, $fAr3q.default)(r, e) || (0, $3JLwG.default)(r, e) || (0, $e7ZlA.default)();
}

});
parcelRegister("dsK1g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9cd19663d83cd41e$export$2e2bcd8739ae039; });
function $9cd19663d83cd41e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("fAr3q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b58f3436b4a8578a$export$2e2bcd8739ae039; });
function $b58f3436b4a8578a$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("3JLwG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2b8a70cb6c539b9b$export$2e2bcd8739ae039; });

var $cLbTx = parcelRequire("cLbTx");
function $2b8a70cb6c539b9b$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cLbTx.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cLbTx.default)(r, a) : void 0;
    }
}

});
parcelRegister("cLbTx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $94a319e2e35f6511$export$2e2bcd8739ae039; });
function $94a319e2e35f6511$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("e7ZlA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4914e63d4eb81d0$export$2e2bcd8739ae039; });
function $a4914e63d4eb81d0$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("ltA5J", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $fa284d6519bbb85c$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $fa284d6519bbb85c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $fa284d6519bbb85c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($fa284d6519bbb85c$export$1ca2a26fecb070ae);
};
$fa284d6519bbb85c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("377u5", function(module, exports) {
$parcel$export(module.exports, "FUSE_OPTIONS", function () { return $b50777ddec43fa25$export$3f017e5a86c4357e; });
$parcel$export(module.exports, "parseTemplateSearchItems", function () { return $b50777ddec43fa25$export$40e6048120e8f1aa; });
$parcel$export(module.exports, "parseCategorySearchItems", function () { return $b50777ddec43fa25$export$c4f88d3d4eb94ce2; });
$parcel$export(module.exports, "UseSearchSuggestionsQuery", function () { return $b50777ddec43fa25$export$815a5dab52bbf225; });
$parcel$export(module.exports, "useSearchSuggestionsLoader", function () { return $b50777ddec43fa25$export$a5b5215eff520376; });
$parcel$export(module.exports, "useSearchSuggestions", function () { return $b50777ddec43fa25$export$688cc0524c0f6b2f; });

var $1oC0p = parcelRequire("1oC0p");

var $djfBw = parcelRequire("djfBw");

var $f3gS9 = parcelRequire("f3gS9");

var $1YXN8 = parcelRequire("1YXN8");

var $3dnVb = parcelRequire("3dnVb");
var $b50777ddec43fa25$var$_useSearchSuggestionsContentfulQuery;
const $b50777ddec43fa25$export$3f017e5a86c4357e = {
    keys: [
        {
            name: 'name',
            weight: 0.8
        },
        // Increased weight for better matches on name
        {
            name: 'description',
            weight: 0.5
        },
        {
            name: 'contributor',
            weight: 0.3
        },
        {
            name: 'contributorOrganization',
            weight: 0.3
        },
        {
            name: 'customTag',
            weight: 0.3
        }
    ],
    includeScore: true,
    threshold: 0.4
};
const $b50777ddec43fa25$var$FUSE_RESULT_LIMIT = 35;
const $b50777ddec43fa25$var$SLUG_TO_TAGS = {
    'project-plan': [
        'proposal',
        'gantt',
        'timeline'
    ],
    'master-project-documentation': [
        'proposal'
    ],
    'annual-plan-one-pager': [
        'proposal'
    ],
    'mutual-action-plan': [
        'proposal'
    ],
    'executive-business-review': [
        'proposal'
    ],
    'devops-runbook': [
        'gantt',
        'timeline'
    ],
    'software-architecture-review': [
        'gantt'
    ],
    'problem-framing': [
        'faq'
    ],
    'safe-lean-business-case': [
        'faq'
    ],
    'hr-knowledge-base': [
        'faq'
    ],
    'design-sprint': [
        'timeline'
    ],
    'project-kickoff': [
        'timeline'
    ],
    'year-in-review': [
        'timeline'
    ]
};
const $b50777ddec43fa25$export$228c248010eea3fe = '1HlskYfRNciSnQ02SDhCPs';
const $b50777ddec43fa25$var$getAuthor = (template)=>{
    return template.contributor?.__typename === 'Author' ? template.contributor : null;
};
const $b50777ddec43fa25$var$getOrganization = (template)=>{
    return template.contributor?.__typename === 'CompanyNameInternal' ? template.contributor : template.contributor?.__typename === 'Author' ? template.contributor?.organization : null;
};
const $b50777ddec43fa25$var$addCustomTagToTemplatesBasedOnSearchTerm = (template)=>{
    const tags = (template.urlSlug ? $b50777ddec43fa25$var$SLUG_TO_TAGS[template.urlSlug] : []) ?? [];
    /**
   * Whiteboard templates for custom tag search term "whiteboard templates"
   */ if (template.templateType?.items?.some((type)=>type?.sys?.id === $b50777ddec43fa25$export$228c248010eea3fe)) tags.push('whiteboard templates');
    return tags;
};
const $b50777ddec43fa25$export$40e6048120e8f1aa = (templates)=>{
    // filter out any templates that are not Confluence
    templates = {
        items: templates?.items?.filter((template)=>template?.productCollection?.items[0]?.productNameReference?.productNameId === 'confluence') || []
    };
    const items = [];
    if (!templates || !templates.items) return items;
    for (const template of templates.items)if (template?.urlSlug) items.push({
        id: template.urlSlug,
        name: template.name,
        description: template.previewBlurb,
        contributor: $b50777ddec43fa25$var$getAuthor(template)?.name,
        contributorOrganization: $b50777ddec43fa25$var$getOrganization(template)?.name,
        customTag: $b50777ddec43fa25$var$addCustomTagToTemplatesBasedOnSearchTerm(template),
        type: 'template',
        templateType: template.templateType?.items?.[0]?.templateTypeName
    });
    return items;
};
const $b50777ddec43fa25$export$c4f88d3d4eb94ce2 = (categories)=>{
    const transformedCategories = (0, $1YXN8.tranformCategories)(categories);
    const items = [];
    for (const { node: node } of transformedCategories.edges)if (node.context.urlSlug !== 'featured' && node.context.urlSlug !== 'recommended' && node.context.urlSlug !== 'project-planning' && node.context.urlSlug !== 'business-strategy' && node.context.urlSlug !== 'productivity' && node.context.urlSlug !== 'docs-and-reports' && node.context.urlSlug !== 'startup' && node.context.urlSlug !== 'personal') items.push({
        id: node.context.urlSlug,
        name: node.context.name,
        description: node.context.shortDescriptionOneLiner,
        type: 'category'
    });
    return items;
};

const $b50777ddec43fa25$export$815a5dab52bbf225 = $b50777ddec43fa25$var$_useSearchSuggestionsContentfulQuery !== void 0 ? $b50777ddec43fa25$var$_useSearchSuggestionsContentfulQuery : ($b50777ddec43fa25$var$_useSearchSuggestionsContentfulQuery = (parcelRequire("1ULeZ")), $b50777ddec43fa25$var$_useSearchSuggestionsContentfulQuery.hash && $b50777ddec43fa25$var$_useSearchSuggestionsContentfulQuery.hash !== "c6647e2bb22f7d85228f8a378d540d89" && console.error("The definition of 'useSearchSuggestionsContentfulQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $b50777ddec43fa25$var$_useSearchSuggestionsContentfulQuery);
const $b50777ddec43fa25$export$a5b5215eff520376 = ()=>{
    const locale = (0, $3dnVb.useQueryLocale)();
    const [queryRef, loadQuery] = (0, $f3gS9.useQueryLoader)($b50777ddec43fa25$export$815a5dab52bbf225);
    const loadSearchSuggestionsQuery = (0, $1oC0p.useCallback)(()=>{
        loadQuery({
            locale: locale
        });
    }, [
        loadQuery,
        locale
    ]);
    return [
        queryRef,
        loadSearchSuggestionsQuery
    ];
};
const $b50777ddec43fa25$export$688cc0524c0f6b2f = (queryRef, inputValue)=>{
    const { categories: categories, productTemplateCollection: productTemplateCollection } = (0, $f3gS9.usePreloadedQuery)($b50777ddec43fa25$export$815a5dab52bbf225, queryRef);
    const fuse = (0, $1oC0p.useMemo)(()=>new (0, $djfBw.default)([
            ...$b50777ddec43fa25$export$40e6048120e8f1aa(productTemplateCollection),
            ...$b50777ddec43fa25$export$c4f88d3d4eb94ce2(categories)
        ], $b50777ddec43fa25$export$3f017e5a86c4357e), [
        productTemplateCollection,
        categories
    ]);
    return (0, $1oC0p.useMemo)(()=>{
        let results = [];
        // remove duplicates, but keep best (lowest) score
        if (inputValue) {
            // Create a Map to track items and their scores
            const itemMap = new Map();
            fuse.search(typeof inputValue === 'string' ? inputValue : inputValue?.name ?? '').forEach((result)=>{
                const existing = itemMap.get(result.item.id);
                // Keep the item with the better (lower) score
                if (!existing || (result.score ?? Infinity) < existing.score) itemMap.set(result.item.id, {
                    item: result.item,
                    score: result.score ?? Infinity
                });
            });
            // Sort by score and convert to array
            results = Array.from(itemMap.values()).sort((a, b)=>a.score - b.score).slice(0, $b50777ddec43fa25$var$FUSE_RESULT_LIMIT).map(({ item: item })=>item);
        }
        return results;
    }, [
        fuse,
        inputValue
    ]);
};

});
parcelRegister("djfBw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b0927607b3f6936$export$2e2bcd8739ae039; });
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $9b0927607b3f6936$var$isArray(value) {
    return !Array.isArray ? $9b0927607b3f6936$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $9b0927607b3f6936$var$INFINITY = 1 / 0;
function $9b0927607b3f6936$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$9b0927607b3f6936$var$INFINITY ? '-0' : result;
}
function $9b0927607b3f6936$var$toString(value) {
    return value == null ? '' : $9b0927607b3f6936$var$baseToString(value);
}
function $9b0927607b3f6936$var$isString(value) {
    return typeof value === 'string';
}
function $9b0927607b3f6936$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $9b0927607b3f6936$var$isBoolean(value) {
    return value === true || value === false || $9b0927607b3f6936$var$isObjectLike(value) && $9b0927607b3f6936$var$getTag(value) == '[object Boolean]';
}
function $9b0927607b3f6936$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $9b0927607b3f6936$var$isObjectLike(value) {
    return $9b0927607b3f6936$var$isObject(value) && value !== null;
}
function $9b0927607b3f6936$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $9b0927607b3f6936$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $9b0927607b3f6936$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $9b0927607b3f6936$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $9b0927607b3f6936$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $9b0927607b3f6936$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $9b0927607b3f6936$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $9b0927607b3f6936$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $9b0927607b3f6936$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $9b0927607b3f6936$var$hasOwn = Object.prototype.hasOwnProperty;
class $9b0927607b3f6936$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $9b0927607b3f6936$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $9b0927607b3f6936$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($9b0927607b3f6936$var$isString(key) || $9b0927607b3f6936$var$isArray(key)) {
        src = key;
        path = $9b0927607b3f6936$var$createKeyPath(key);
        id = $9b0927607b3f6936$var$createKeyId(key);
    } else {
        if (!$9b0927607b3f6936$var$hasOwn.call(key, 'name')) throw new Error($9b0927607b3f6936$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($9b0927607b3f6936$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($9b0927607b3f6936$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $9b0927607b3f6936$var$createKeyPath(name);
        id = $9b0927607b3f6936$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $9b0927607b3f6936$var$createKeyPath(key) {
    return $9b0927607b3f6936$var$isArray(key) ? key : key.split('.');
}
function $9b0927607b3f6936$var$createKeyId(key) {
    return $9b0927607b3f6936$var$isArray(key) ? key.join('.') : key;
}
function $9b0927607b3f6936$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$9b0927607b3f6936$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$9b0927607b3f6936$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($9b0927607b3f6936$var$isString(value) || $9b0927607b3f6936$var$isNumber(value) || $9b0927607b3f6936$var$isBoolean(value))) list.push($9b0927607b3f6936$var$toString(value));
            else if ($9b0927607b3f6936$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $9b0927607b3f6936$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $9b0927607b3f6936$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $9b0927607b3f6936$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $9b0927607b3f6936$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $9b0927607b3f6936$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $9b0927607b3f6936$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $9b0927607b3f6936$var$Config = {
    ...$9b0927607b3f6936$var$BasicOptions,
    ...$9b0927607b3f6936$var$MatchOptions,
    ...$9b0927607b3f6936$var$FuzzyOptions,
    ...$9b0927607b3f6936$var$AdvancedOptions
};
const $9b0927607b3f6936$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $9b0927607b3f6936$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($9b0927607b3f6936$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $9b0927607b3f6936$var$FuseIndex {
    constructor({ getFn: getFn = $9b0927607b3f6936$var$Config.getFn, fieldNormWeight: fieldNormWeight = $9b0927607b3f6936$var$Config.fieldNormWeight } = {}){
        this.norm = $9b0927607b3f6936$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($9b0927607b3f6936$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($9b0927607b3f6936$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$9b0927607b3f6936$var$isDefined(doc) || $9b0927607b3f6936$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$9b0927607b3f6936$var$isDefined(value)) return;
            if ($9b0927607b3f6936$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$9b0927607b3f6936$var$isDefined(value)) continue;
                    if ($9b0927607b3f6936$var$isString(value) && !$9b0927607b3f6936$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($9b0927607b3f6936$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($9b0927607b3f6936$var$isString(value) && !$9b0927607b3f6936$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $9b0927607b3f6936$var$createIndex(keys, docs, { getFn: getFn = $9b0927607b3f6936$var$Config.getFn, fieldNormWeight: fieldNormWeight = $9b0927607b3f6936$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $9b0927607b3f6936$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($9b0927607b3f6936$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $9b0927607b3f6936$var$parseIndex(data, { getFn: getFn = $9b0927607b3f6936$var$Config.getFn, fieldNormWeight: fieldNormWeight = $9b0927607b3f6936$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $9b0927607b3f6936$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $9b0927607b3f6936$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $9b0927607b3f6936$var$Config.distance, ignoreLocation: ignoreLocation = $9b0927607b3f6936$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $9b0927607b3f6936$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $9b0927607b3f6936$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $9b0927607b3f6936$var$MAX_BITS = 32;
function $9b0927607b3f6936$var$search(text, pattern, patternAlphabet, { location: location = $9b0927607b3f6936$var$Config.location, distance: distance = $9b0927607b3f6936$var$Config.distance, threshold: threshold = $9b0927607b3f6936$var$Config.threshold, findAllMatches: findAllMatches = $9b0927607b3f6936$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $9b0927607b3f6936$var$Config.minMatchCharLength, includeMatches: includeMatches = $9b0927607b3f6936$var$Config.includeMatches, ignoreLocation: ignoreLocation = $9b0927607b3f6936$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $9b0927607b3f6936$var$MAX_BITS) throw new Error($9b0927607b3f6936$var$PATTERN_LENGTH_TOO_LARGE($9b0927607b3f6936$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $9b0927607b3f6936$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $9b0927607b3f6936$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $9b0927607b3f6936$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $9b0927607b3f6936$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $9b0927607b3f6936$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $9b0927607b3f6936$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $9b0927607b3f6936$var$BitapSearch {
    constructor(pattern, { location: location = $9b0927607b3f6936$var$Config.location, threshold: threshold = $9b0927607b3f6936$var$Config.threshold, distance: distance = $9b0927607b3f6936$var$Config.distance, includeMatches: includeMatches = $9b0927607b3f6936$var$Config.includeMatches, findAllMatches: findAllMatches = $9b0927607b3f6936$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $9b0927607b3f6936$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $9b0927607b3f6936$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $9b0927607b3f6936$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $9b0927607b3f6936$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $9b0927607b3f6936$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $9b0927607b3f6936$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $9b0927607b3f6936$var$MAX_BITS), i);
                i += $9b0927607b3f6936$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $9b0927607b3f6936$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $9b0927607b3f6936$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $9b0927607b3f6936$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $9b0927607b3f6936$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $9b0927607b3f6936$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $9b0927607b3f6936$var$ExactMatch extends $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $9b0927607b3f6936$var$InverseExactMatch extends $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $9b0927607b3f6936$var$PrefixExactMatch extends $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $9b0927607b3f6936$var$InversePrefixExactMatch extends $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $9b0927607b3f6936$var$SuffixExactMatch extends $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $9b0927607b3f6936$var$InverseSuffixExactMatch extends $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $9b0927607b3f6936$var$FuzzyMatch extends $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern, { location: location = $9b0927607b3f6936$var$Config.location, threshold: threshold = $9b0927607b3f6936$var$Config.threshold, distance: distance = $9b0927607b3f6936$var$Config.distance, includeMatches: includeMatches = $9b0927607b3f6936$var$Config.includeMatches, findAllMatches: findAllMatches = $9b0927607b3f6936$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $9b0927607b3f6936$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $9b0927607b3f6936$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $9b0927607b3f6936$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $9b0927607b3f6936$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $9b0927607b3f6936$var$IncludeMatch extends $9b0927607b3f6936$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $9b0927607b3f6936$var$searchers = [
    $9b0927607b3f6936$var$ExactMatch,
    $9b0927607b3f6936$var$IncludeMatch,
    $9b0927607b3f6936$var$PrefixExactMatch,
    $9b0927607b3f6936$var$InversePrefixExactMatch,
    $9b0927607b3f6936$var$InverseSuffixExactMatch,
    $9b0927607b3f6936$var$SuffixExactMatch,
    $9b0927607b3f6936$var$InverseExactMatch,
    $9b0927607b3f6936$var$FuzzyMatch
];
const $9b0927607b3f6936$var$searchersLen = $9b0927607b3f6936$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $9b0927607b3f6936$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $9b0927607b3f6936$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $9b0927607b3f6936$var$parseQuery(pattern, options = {}) {
    return pattern.split($9b0927607b3f6936$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($9b0927607b3f6936$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $9b0927607b3f6936$var$searchersLen){
                const searcher = $9b0927607b3f6936$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $9b0927607b3f6936$var$searchersLen){
                const searcher = $9b0927607b3f6936$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $9b0927607b3f6936$var$MultiMatchSet = new Set([
    $9b0927607b3f6936$var$FuzzyMatch.type,
    $9b0927607b3f6936$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $9b0927607b3f6936$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $9b0927607b3f6936$var$Config.isCaseSensitive, includeMatches: includeMatches = $9b0927607b3f6936$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $9b0927607b3f6936$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $9b0927607b3f6936$var$Config.ignoreLocation, findAllMatches: findAllMatches = $9b0927607b3f6936$var$Config.findAllMatches, location: location = $9b0927607b3f6936$var$Config.location, threshold: threshold = $9b0927607b3f6936$var$Config.threshold, distance: distance = $9b0927607b3f6936$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $9b0927607b3f6936$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($9b0927607b3f6936$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $9b0927607b3f6936$var$registeredSearchers = [];
function $9b0927607b3f6936$var$register(...args) {
    $9b0927607b3f6936$var$registeredSearchers.push(...args);
}
function $9b0927607b3f6936$var$createSearcher(pattern, options) {
    for(let i = 0, len = $9b0927607b3f6936$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $9b0927607b3f6936$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $9b0927607b3f6936$var$BitapSearch(pattern, options);
}
const $9b0927607b3f6936$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $9b0927607b3f6936$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $9b0927607b3f6936$var$isExpression = (query)=>!!(query[$9b0927607b3f6936$var$LogicalOperator.AND] || query[$9b0927607b3f6936$var$LogicalOperator.OR]);
const $9b0927607b3f6936$var$isPath = (query)=>!!query[$9b0927607b3f6936$var$KeyType.PATH];
const $9b0927607b3f6936$var$isLeaf = (query)=>!$9b0927607b3f6936$var$isArray(query) && $9b0927607b3f6936$var$isObject(query) && !$9b0927607b3f6936$var$isExpression(query);
const $9b0927607b3f6936$var$convertToExplicit = (query)=>({
        [$9b0927607b3f6936$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $9b0927607b3f6936$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $9b0927607b3f6936$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$9b0927607b3f6936$var$isExpression(query)) return next($9b0927607b3f6936$var$convertToExplicit(query));
        if ($9b0927607b3f6936$var$isLeaf(query)) {
            const key = isQueryPath ? query[$9b0927607b3f6936$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$9b0927607b3f6936$var$KeyType.PATTERN] : query[key];
            if (!$9b0927607b3f6936$var$isString(pattern)) throw new Error($9b0927607b3f6936$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $9b0927607b3f6936$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $9b0927607b3f6936$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($9b0927607b3f6936$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$9b0927607b3f6936$var$isExpression(query)) query = $9b0927607b3f6936$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $9b0927607b3f6936$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $9b0927607b3f6936$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $9b0927607b3f6936$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$9b0927607b3f6936$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$9b0927607b3f6936$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $9b0927607b3f6936$var$transformScore(result, data) {
    data.score = result.score;
}
function $9b0927607b3f6936$var$format(results, docs, { includeMatches: includeMatches = $9b0927607b3f6936$var$Config.includeMatches, includeScore: includeScore = $9b0927607b3f6936$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($9b0927607b3f6936$var$transformMatches);
    if (includeScore) transformers.push($9b0927607b3f6936$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $9b0927607b3f6936$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$9b0927607b3f6936$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $9b0927607b3f6936$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $9b0927607b3f6936$var$FuseIndex)) throw new Error($9b0927607b3f6936$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $9b0927607b3f6936$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$9b0927607b3f6936$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $9b0927607b3f6936$var$isString(query) ? $9b0927607b3f6936$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $9b0927607b3f6936$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($9b0927607b3f6936$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $9b0927607b3f6936$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $9b0927607b3f6936$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$9b0927607b3f6936$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $9b0927607b3f6936$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $9b0927607b3f6936$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($9b0927607b3f6936$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $9b0927607b3f6936$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$9b0927607b3f6936$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$9b0927607b3f6936$var$isDefined(value)) return [];
        let matches = [];
        if ($9b0927607b3f6936$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$9b0927607b3f6936$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$9b0927607b3f6936$export$2e2bcd8739ae039.version = '6.6.2';
$9b0927607b3f6936$export$2e2bcd8739ae039.createIndex = $9b0927607b3f6936$var$createIndex;
$9b0927607b3f6936$export$2e2bcd8739ae039.parseIndex = $9b0927607b3f6936$var$parseIndex;
$9b0927607b3f6936$export$2e2bcd8739ae039.config = $9b0927607b3f6936$var$Config;
$9b0927607b3f6936$export$2e2bcd8739ae039.parseQuery = $9b0927607b3f6936$var$parse;
$9b0927607b3f6936$var$register($9b0927607b3f6936$var$ExtendedSearch);

});

parcelRegister("1ULeZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $4668fd9556907225$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<1a15c163c8ac00d5a360d1a21319e737>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4668fd9556907225$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 400
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v5 = [
        {
            "alias": "name",
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
    }, v7 = [
        {
            "alias": null,
            "args": v1 /*: any*/ ,
            "concreteType": "ProductTemplateCollection",
            "kind": "LinkedField",
            "name": "productTemplateCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductTemplate",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": v2 /*: any*/ ,
                            "concreteType": "ProductTemplateProductCollection",
                            "kind": "LinkedField",
                            "name": "productCollection",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductListing",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductName",
                                            "kind": "LinkedField",
                                            "name": "productNameReference",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "productNameId",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": "productCollection(limit:1)"
                        },
                        v3 /*: any*/ ,
                        {
                            "alias": "name",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateNameExternal",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "previewBlurb",
                            "storageKey": null
                        },
                        {
                            "alias": "templateType",
                            "args": null,
                            "concreteType": "ProductTemplateTemplateTypeCollection",
                            "kind": "LinkedField",
                            "name": "templateTypeCollection",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaxonomyTemplateType",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "alias": "templateTypeName",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "templateTypeNameExternal",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "contributor",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v5 /*: any*/ ,
                                    "type": "CompanyNameInternal",
                                    "abstractKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "name",
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "authorNameExternal",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CompanyNameInternal",
                                            "kind": "LinkedField",
                                            "name": "organization",
                                            "plural": false,
                                            "selections": v5 /*: any*/ ,
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "Author",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": "categories",
            "args": v1 /*: any*/ ,
            "concreteType": "ProductTemplateCollection",
            "kind": "LinkedField",
            "name": "productTemplateCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductTemplate",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "limit",
                                    "value": 10
                                }
                            ],
                            "concreteType": "ProductTemplateCategoryCollection",
                            "kind": "LinkedField",
                            "name": "categoryCollection",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaxonomyTemplateCategory",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "categoryNameExternal",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "shortDescriptionOneLiner",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "experiment",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "allowedLocales",
                                                    "value": [
                                                        "en-US",
                                                        "es",
                                                        "ja-JP",
                                                        "pt-BR",
                                                        "fr-FR",
                                                        "de-DE",
                                                        "nl-NL",
                                                        "it-IT",
                                                        "ko-KR",
                                                        "pl-PL",
                                                        "ru-RU",
                                                        "zh-CN"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "TaxonomyTemplateCategoryLinkingCollections",
                                            "kind": "LinkedField",
                                            "name": "linkedFrom",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "ProductTemplateCollection",
                                                    "kind": "LinkedField",
                                                    "name": "productTemplateCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "storageKey": "productTemplateCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": "categoryCollection(limit:10)"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "useSearchSuggestionsContentfulQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSearchSuggestionsContentfulQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "f8b550bfee302d4326bebe096c54994b",
            "id": null,
            "metadata": {},
            "name": "useSearchSuggestionsContentfulQuery",
            "operationKind": "query",
            "text": "query useSearchSuggestionsContentfulQuery(\n  $locale: String!\n) {\n  productTemplateCollection(limit: 400, locale: $locale) {\n    items {\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      urlSlug\n      name: templateNameExternal\n      previewBlurb\n      templateType: templateTypeCollection {\n        items {\n          sys {\n            id\n          }\n          templateTypeName: templateTypeNameExternal\n        }\n      }\n      contributor {\n        __typename\n        ... on CompanyNameInternal {\n          name: organizationNameExternal\n        }\n        ... on Author {\n          name: authorNameExternal\n          organization {\n            name: organizationNameExternal\n          }\n        }\n      }\n    }\n  }\n  categories: productTemplateCollection(limit: 400, locale: $locale) {\n    items {\n      categoryCollection(limit: 10) {\n        total\n        items {\n          sys {\n            id\n          }\n          urlSlug\n          categoryNameExternal\n          shortDescriptionOneLiner\n          experiment\n          linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n            productTemplateCollection(limit: 1) {\n              total\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$4668fd9556907225$var$node.hash = "c6647e2bb22f7d85228f8a378d540d89";
var $4668fd9556907225$export$2e2bcd8739ae039 = $4668fd9556907225$var$node;

});




parcelRegister("7Lif4", function(module, exports) {
$parcel$export(module.exports, "TemplateHeroSection", function () { return $ff8b77f38e58bd59$export$c4846c3d98668d95; });
/* template-hero-section-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $cml5G = parcelRequire("cml5G");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");
const $ff8b77f38e58bd59$var$containerStyles = null;
const $ff8b77f38e58bd59$var$variantHeaderStyles = null;
const $ff8b77f38e58bd59$var$titleStyles = null;
const $ff8b77f38e58bd59$var$subTitleStyles = null;
const $ff8b77f38e58bd59$export$c4846c3d98668d95 = ({ categoryName: categoryName, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("header", {
            className: (0, $2jatx.default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o _2rkogktf _1mou66rk _18zr1y44 _1bsb15ao _11q73dpe _syazu67f _4t3i1hiv _195gcae7 _91qczwfg _1n041tcg _15sjkpet _t95d7vkz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect41vau _k48pbfng _1wyb1ex1 _1cqs14no"
                    ]),
                    style: {
                        "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display'))
                    },
                    children: categoryName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $cml5G.ConfluenceTemplateMessages).headerText,
                        values: {
                            categoryName: categoryName
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $cml5G.ConfluenceTemplateMessages).defaultHeaderText
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wybgktf _1cqs7vkz _1rfm122r"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...(0, $cml5G.ConfluenceTemplateMessages).subHeaderText
                    })
                }),
                children
            ]
        })
    });
};
$ff8b77f38e58bd59$export$c4846c3d98668d95.displayName = 'TemplateHeroSection';

});

parcelRegister("26Nro", function(module, exports) {
$parcel$export(module.exports, "TemplateLearnFromLeadersSection", function () { return $eb4454f29065edfe$export$2ae50b08eee2162f; });
/* template-learn-from-leaders-section-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $1fXGt = parcelRequire("1fXGt");

var $9lnnX = parcelRequire("9lnnX");
const $eb4454f29065edfe$var$sectionStyles = null;
const $eb4454f29065edfe$var$textContentSection = null;
const $eb4454f29065edfe$var$headerStyles = null;
const $eb4454f29065edfe$var$partnerSectionStyles = null;
const $eb4454f29065edfe$export$2ae50b08eee2162f = ({ templates: templates, categories: categories })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "data-testid": "template-learn-from-leaders-section-relay",
        className: (0, $2jatx.default)([
            "_kqswh2mm _ca0qzwfg _u5f3idpf _n3tdidpf _19bvidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1itksawm _1lrw1dfr _12vemgnk _ouxlyfq0 _kqswh2mm _1pbykb7n"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_syaz1sq1 _ca0q1ylp _otyr1wqb _y3gn1h6o _vwz4ckbl _ect41td8 _1wyb1ylp _k48p1fw0 _g65po812 _r9upidpf _1sr21wug _f4g41ylp _101c1wug _16et1k8s _41q6weo2 _ef9cidpf _tnim1wug _sw271ylp _1q5p1wug _q1veweo2 _xam0idpf _6b6x1wug _r1061ylp _po3f1wug"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "confluence.templates.learn.from.industry.leaders",
                            defaultMessage: "Learn from industry leaders"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ca0qidpf _u5f3idpf _n3td1obz _19bvn0up"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1fXGt.PartnerTemplateCardCarousel), {
                            templates: templates
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9lnnX.AdditionalCategoriesSection), {
                categories: categories
            })
        ]
    });
};
$eb4454f29065edfe$export$2ae50b08eee2162f.displayName = 'TemplateLearnFromLeadersSection';

});
parcelRegister("1fXGt", function(module, exports) {
$parcel$export(module.exports, "PartnerTemplateCardCarousel", function () { return $dfc17f7b5046b64e$export$ef1cff7c35a5b4cd; });
/* partner-template-card-carousel-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $ggSCt = parcelRequire("ggSCt");

var $cml5G = parcelRequire("cml5G");

var $lRFwv = parcelRequire("lRFwv");

var $6fJ4x = parcelRequire("6fJ4x");

var $llvKv = parcelRequire("llvKv");
var $dfc17f7b5046b64e$var$_partnerTemplateCardCarouselContentfulRelayFragment;
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $dfc17f7b5046b64e$var$slickStyle = null;
const $dfc17f7b5046b64e$var$carouselContainer = null;
const $dfc17f7b5046b64e$var$carouselCardWrapper = null;
const $dfc17f7b5046b64e$var$buttonLeft = null;
const $dfc17f7b5046b64e$var$buttonRight = null;
const $dfc17f7b5046b64e$var$buttonLeftArrow = null;
const $dfc17f7b5046b64e$var$buttonRightArrow = null;
const $dfc17f7b5046b64e$var$buttonRoundedArrow = null;
const $dfc17f7b5046b64e$var$buttonRoundedLeftArrow = null;
const $dfc17f7b5046b64e$var$buttonRoundedRightArrow = null;

const $dfc17f7b5046b64e$var$PartnerTemplateCardCarouselFragment = $dfc17f7b5046b64e$var$_partnerTemplateCardCarouselContentfulRelayFragment !== void 0 ? $dfc17f7b5046b64e$var$_partnerTemplateCardCarouselContentfulRelayFragment : ($dfc17f7b5046b64e$var$_partnerTemplateCardCarouselContentfulRelayFragment = (parcelRequire("1LCQu")), $dfc17f7b5046b64e$var$_partnerTemplateCardCarouselContentfulRelayFragment.hash && $dfc17f7b5046b64e$var$_partnerTemplateCardCarouselContentfulRelayFragment.hash !== "a57260ce7f63b1ced209b80cea6f087b" && console.error("The definition of 'partnerTemplateCardCarouselContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $dfc17f7b5046b64e$var$_partnerTemplateCardCarouselContentfulRelayFragment);
const $dfc17f7b5046b64e$export$ef1cff7c35a5b4cd = ({ templates: templates })=>{
    const data = (0, $f3gS9.useFragment)($dfc17f7b5046b64e$var$PartnerTemplateCardCarouselFragment, templates);
    const partnerTemplates = (0, $1oC0p.useMemo)(()=>data.map((item)=>item).sort((a, b)=>(0, $6fJ4x.partnerTemplatesDataUrlSlugs).indexOf(a.urlSlug ?? '') - (0, $6fJ4x.partnerTemplatesDataUrlSlugs).indexOf(b.urlSlug ?? '')), [
        data
    ]);
    const intl = (0, $8e22h.default)();
    const previousLabel = intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).carouselPreviousLabel);
    const nextLabel = intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).carouselNextLabel);
    const LeftArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: onClick,
            className: (0, $2jatx.default)([
                "_1e0c1ule _kqswstnw _152t1ssb _1bsbzwfg _4t3izwfg _19it8cnq _t9ecovhh _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazvwuj _vwz4an13 _1e02101a _bfhk1j28 _g7fridpf _lsvakb7n _1jq9u67f _1xq41a7r",
                "doNotAutoTrack"
            ]),
            "aria-label": previousLabel,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_t9eczk8b _1bsb1crf _4t3i1crf _vwz4grho _kqswstnw _1pfhyjp0 _mqm2pqxa _191wpqxa _g1edpqxa _syazvwuj _1wyb7vkz"
                ])
            })
        });
    const RightArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: onClick,
            className: (0, $2jatx.default)([
                "_1e0c1ule _kqswstnw _152t1ssb _1bsbzwfg _4t3izwfg _19it8cnq _t9ecovhh _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazvwuj _vwz4an13 _rjxp101a _bfhk1j28 _z1s5idpf _lsvakb7n _1jq9u67f _1xq41a7r",
                "doNotAutoTrack"
            ]),
            "aria-label": nextLabel,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_t9ec1hke _1bsb1crf _4t3i1crf _vwz4grho _kqswstnw _1pfhyjp0 _mqm2pqxa _191wpqxa _syazvwuj _1wyb7vkz"
                ])
            })
        });
    const LeftArrowRounded = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: onClick,
            className: (0, $2jatx.default)([
                "_1e0c1ule _kqswstnw _152t1ssb _1bsbzwfg _4t3izwfg _19it8cnq _t9ecovhh _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazvwuj _vwz4an13 _1e02101a _bfhk1j28 _g7fridpf _lsvakb7n _1jq9u67f _1xq41a7r",
                "doNotAutoTrack"
            ]),
            "aria-label": previousLabel,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1bsb1crf _4t3i1crf _1e0c1o8l _vwz4t94y _kqswstnw _1pfhyjp0 _vchhusvi _mqm2pqxa _191wpqxa _g1edpqxa _syazrbzz _1wyb7vkz",
                    "_t9eczk8b _ahbqmyb0"
                ])
            })
        });
    const RightArrowRounded = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: onClick,
            className: (0, $2jatx.default)([
                "_1e0c1ule _kqswstnw _152t1ssb _1bsbzwfg _4t3izwfg _19it8cnq _t9ecovhh _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazvwuj _vwz4an13 _rjxp101a _bfhk1j28 _z1s5idpf _lsvakb7n _1jq9u67f _1xq41a7r",
                "doNotAutoTrack"
            ]),
            "aria-label": nextLabel,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1bsb1crf _4t3i1crf _1e0c1o8l _vwz4t94y _kqswstnw _1pfhyjp0 _vchhusvi _mqm2pqxa _191wpqxa _g1edpqxa _syazrbzz _1wyb7vkz",
                    "_t9ec1hke _ahbq1bs0"
                ])
            })
        });
    const settings = {
        prevArrow: /*#__PURE__*/ (0, $7VQPk.jsx)(LeftArrow, {}),
        nextArrow: /*#__PURE__*/ (0, $7VQPk.jsx)(RightArrow, {}),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    prevArrow: /*#__PURE__*/ (0, $7VQPk.jsx)(LeftArrowRounded, {}),
                    nextArrow: /*#__PURE__*/ (0, $7VQPk.jsx)(RightArrowRounded, {})
                }
            }
        ]
    };
    const beforeChange = (currentSlide, nextSlide)=>{
        (0, $lRFwv.ConfluenceTemplateAnalytics).sendPartnerCarouselAnalytic(currentSlide, nextSlide, partnerTemplates.length);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb4tsx _19pkidpf _2hwx1wug _otyridpf _18u01wug _vnwpsb0t _1x9m1y37 _ppgvweo2 _5251idpf _11ad1wug _sdb5idpf _fdc01wug _wsqf5o3v"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), {
                ...settings,
                beforeChange: beforeChange,
                children: partnerTemplates.map((partnerTemplate)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1o8l _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $llvKv.PartnerTemplateCard), {
                            template: partnerTemplate
                        })
                    }, partnerTemplate?.sys?.id))
            })
        })
    });
};

});
parcelRegister("llvKv", function(module, exports) {
$parcel$export(module.exports, "PartnerTemplateCard", function () { return $261d686ac65cd6f2$export$bf388d2348a06d1b; });
/* partner-template-card-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $lRFwv = parcelRequire("lRFwv");

var $lDJBO = parcelRequire("lDJBO");

var $jQ0cd = parcelRequire("jQ0cd");

var $6fJ4x = parcelRequire("6fJ4x");
var $261d686ac65cd6f2$var$_partnerTemplateCardContentfulRelayFragment;
const $261d686ac65cd6f2$export$589d68befb1fa281 = '"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';
const $261d686ac65cd6f2$export$b2dcbe10044f9854 = '"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';
const $261d686ac65cd6f2$var$partnerTemplateCardWrapperStyles = null;
const $261d686ac65cd6f2$var$partnerTemplateCardContentStyles = null;
const $261d686ac65cd6f2$var$partnerTemplateCardLogoStyles = null;
const $261d686ac65cd6f2$var$partnerTemplateCardInfoStyles = null;
const $261d686ac65cd6f2$var$partnerTemplateCardTitleStyles = null;
const $261d686ac65cd6f2$var$partnerTemplateCardDescriptionStyles = null;
const $261d686ac65cd6f2$var$cardLink = null;

const $261d686ac65cd6f2$var$PartnerTemplateCardFragment = $261d686ac65cd6f2$var$_partnerTemplateCardContentfulRelayFragment !== void 0 ? $261d686ac65cd6f2$var$_partnerTemplateCardContentfulRelayFragment : ($261d686ac65cd6f2$var$_partnerTemplateCardContentfulRelayFragment = (parcelRequire("3yLIj")), $261d686ac65cd6f2$var$_partnerTemplateCardContentfulRelayFragment.hash && $261d686ac65cd6f2$var$_partnerTemplateCardContentfulRelayFragment.hash !== "ca73d5016af7e32a730f30a64afc6a76" && console.error("The definition of 'partnerTemplateCardContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $261d686ac65cd6f2$var$_partnerTemplateCardContentfulRelayFragment);
const $261d686ac65cd6f2$export$bf388d2348a06d1b = ({ template: template })=>{
    const data = (0, $f3gS9.useFragment)($261d686ac65cd6f2$var$PartnerTemplateCardFragment, template);
    // Note that some fields are still using the existing hardcoded partner template data,
    // as the images or icons are not rendering properly.
    const testData = (0, $1oC0p.useMemo)(()=>{
        const testData = (0, $6fJ4x.testPartnerTemplatesData).find((x)=>x.urlSlug === data.urlSlug);
        // Use CPAPI data where possible, otherwise use hardcoded data
        return {
            templateId: data.sys?.id,
            name: data.templateNameExternal,
            urlSlug: data.urlSlug,
            partnerDescription: data.oneLinerHeadline,
            contributor: testData?.contributor,
            previewBlurb: data.oneLinerHeadline,
            templateIcon: testData?.templateIcon,
            partnerImage: testData?.partnerImage
        };
    }, [
        data
    ]);
    const intl = (0, $8e22h.default)();
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(`/software/confluence/templates/${testData.urlSlug}`);
    const partnerTemplateImageStyles = null;
    const viewTemplateText = intl.formatMessage({
        id: 'confluence.templates.partner-template-card.view-link',
        defaultMessage: 'View template'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _19pkidpf _2hwxgktf _otyridpf _18u0gktf _16qso5yx _1sag1bp4 _11nd1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1y37 _4t3i1kdj _ouxl1ssb _1lrw1dfr _nnst1osq _4mbad36x _nvs81ssb _1itkae7d"
                ]),
                style: {
                    "--_1h6fgdw": (0, $6ZVlx.default)(testData.partnerImage?.url, ")", "url(")
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1y37 _2lx21bp4 _1bah1yb4 _4cvr1y6m _ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp _bfhku67f _nnst1osq _4mbao812 _y65n1ylp _1qavgktf _15y9gktf _p4rcgktf _1k331ssb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: testData.templateIcon?.url,
                        alt: '',
                        className: (0, $2jatx.default)([
                            "_p12fuuw1 _c71l1ylp _1bsb1wug _4t3i1wug _s7n4yfq0 _4mbazwfg"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1yb4 _4cvr1y6m _4t3i13i4 _4mba1j4a"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1tcg _k48pbfng _1dyzdky6 _syazalr3 _ect41lim _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1v87gktf _1nmn1mpp _kuia1tcg"
                                ]),
                                children: testData.name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41tcg _syazalr3 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect411r6 _1v877vkz _kuia7vkz _1nmn1mpp _6drocj1k _b6pb1e54 _sxdqqfx8 _1ajf15vq _blov15vq _uelygktf"
                                ]),
                                children: testData.partnerDescription
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lDJBO.Link), {
                                text: viewTemplateText,
                                href: localizedHref,
                                dataEventProps: {
                                    ...(0, $lRFwv.ConfluenceTemplateAnalytics).viewPartnerTemplate(testData.urlSlug),
                                    'data-event': 'clicked',
                                    'data-event-component': 'link'
                                },
                                className: (0, $2jatx.default)([
                                    "_1e0c1ule _syazrbzz _k48pbfng _1pbykb7n _vwz4kb7n _ect411r6 _1v871crf"
                                ])
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("lDJBO", function(module, exports) {
$parcel$export(module.exports, "Link", function () { return $322aa4f5a77a3466$export$a6c7ac8248d6e38a; });
/* link.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $jQ0cd = parcelRequire("jQ0cd");
//CSS
const $322aa4f5a77a3466$var$linkColors = {
    bgWhite: {
        default: '#1868DB',
        hover: '#0747A6',
        visited: '#403294'
    },
    bgLight: {
        default: '#172B4D',
        hover: '#0747A6',
        visited: '#403294'
    },
    bgDark: {
        default: '#FAFBFC',
        hover: '#4C9AFF',
        visited: '#C0B6F2'
    }
};
//Functions
const $322aa4f5a77a3466$var$Icon = (type)=>{
    if (type === 'basic' || type === 'basic-underline' || type === 'inline-basic') return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_19pk14y2 _2hwxidpf _otyrt94y _18u014y2 _v564x7w3"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });
    if (type === 'external' || type === 'external-icon') return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "7",
        height: "8",
        viewBox: "0 0 7 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_19pk14y2 _2hwxidpf _otyryh40 _18u014y2"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.04815 0.5V1.98788H4.46059L0.217983 6.22935C-0.0726609 6.51998 -0.0726609 6.99114 0.217983 7.28178C0.363801 7.4266 0.553265 7.5 0.744713 7.5C0.935169 7.5 1.12463 7.4266 1.27045 7.28178L5.51206 3.04031V5.45168H7V0.5H2.04815Z"
        })
    });
    if (type === 'video') return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_12l2ftgi"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.3561 7.10299L4.79449 4.21918V9.78082L10.3561 7.10299Z"
        })
    });
    return;
};
const $322aa4f5a77a3466$var$formatLinkText = (text, type)=>{
    const typeOfLink = type ? type : 'basic';
    if (type === 'video') return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: [
            $322aa4f5a77a3466$var$Icon(typeOfLink),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: text
            })
        ]
    });
    if (type === 'external-icon') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            children: [
                text,
                $322aa4f5a77a3466$var$Icon(typeOfLink)
            ]
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            children: [
                text,
                $322aa4f5a77a3466$var$Icon(typeOfLink)
            ]
        })
    });
};
const $322aa4f5a77a3466$var$isSignInUrl = (href)=>{
    const baseUrl = "https://id.atlassian.com";
    const stargateBaseUrl = "https://www.atlassian.com/gateway/api";
    const continueUrl = stargateBaseUrl + '/start/authredirect';
    const signInUrl = `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}`;
    // Check if href matches sign-in URL with or without application parameter
    return href === signInUrl || href.startsWith(signInUrl + '&application=');
};
const $322aa4f5a77a3466$var$isHyperlinkRef = (href)=>{
    return href.startsWith('#');
};
const $322aa4f5a77a3466$var$isNonSigninOrWacUrl = (href)=>{
    return !(0, $jQ0cd.isLocalizableHref)(href) && !$322aa4f5a77a3466$var$isSignInUrl(href) && !$322aa4f5a77a3466$var$isHyperlinkRef(href);
};
const $322aa4f5a77a3466$export$39aecc95f0365819 = (props)=>{
    const children = (0, $1oC0p.Children).toArray(props.children);
    if (props.type === 'inline' || props.type === 'inline-basic') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: children.map((child)=>child)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "link-wrapper",
        children: children.map((child)=>child)
    });
};
const $322aa4f5a77a3466$export$a6c7ac8248d6e38a = ({ text: text, href: href, type: type, customLinkColor: customLinkColor, bgColor: bgColor, onClick: onClick, className: className, doesArrowAnimate: doesArrowAnimate = false, ariaLabel: ariaLabel, dataEventProps: dataEventProps, isStyleOnly: isStyleOnly = false, anchorProps: anchorProps = {} })=>{
    const bg = bgColor ? bgColor : 'bgWhite';
    let colorDefault = $322aa4f5a77a3466$var$linkColors[bg].default;
    let colorHover = $322aa4f5a77a3466$var$linkColors[bg].hover;
    let colorVisited = $322aa4f5a77a3466$var$linkColors[bg].visited;
    if (customLinkColor) colorDefault = colorHover = colorVisited = customLinkColor;
    const linkStyles = [
        customLinkColor && null,
        !customLinkColor && null,
        type === 'basic-underline' && null,
        type === 'modal' && null,
        (type === 'inline' || type === 'inline-basic') && null,
        type !== 'modal' && type !== 'inline' && type !== 'inline-basic' && null,
        doesArrowAnimate && (type === 'basic' || type === 'basic-underline' || type === 'inline-basic') && null,
        null
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)($322aa4f5a77a3466$export$39aecc95f0365819, {
        type: type,
        text: text,
        href: href,
        children: [
            !isStyleOnly && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                className: (0, $2jatx.default)([
                    customLinkColor && "_16bt1q1b _1up41q1b",
                    !customLinkColor && "",
                    type === 'basic-underline' && "_9oik1r31 _1bnx8stv _jf4cnqa1",
                    type === 'modal' && "_1hms8stv _ajmmgq9o _1kegt94y _l7ed1l7b",
                    (type === 'inline' || type === 'inline-basic') && "_4bfu1r31 _1hms8stv _ajmmnqa1",
                    type !== 'modal' && type !== 'inline' && type !== 'inline-basic' && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                    doesArrowAnimate && (type === 'basic' || type === 'basic-underline' || type === 'inline-basic') && "_1up4glyw _12sv54rc",
                    "_4cvr1h6o _syazaexi _1e0c116y _10531pdu _f8pji0o6 _30l3i0o6 _1axpaexi _aelyaexi _pb8z1pdu _kj55i0o6 _12lvi0o6 _l8kux7w3",
                    className
                ]),
                href: href,
                target: type === 'external' || /* redirecting to new tab if the href is not on WAC and not a Signin link */ $322aa4f5a77a3466$var$isNonSigninOrWacUrl(href) ? '_blank' : '',
                rel: type === 'external' || $322aa4f5a77a3466$var$isNonSigninOrWacUrl(href) ? 'noreferrer' : '',
                "aria-label": ariaLabel,
                onClick: onClick,
                ...dataEventProps,
                ...anchorProps,
                style: {
                    "--_1bmh097": (0, $6ZVlx.default)(colorDefault),
                    "--_d4pjwz": (0, $6ZVlx.default)(colorVisited),
                    "--_amadh5": (0, $6ZVlx.default)(colorHover)
                },
                children: $322aa4f5a77a3466$var$formatLinkText(text, type)
            }),
            isStyleOnly && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    customLinkColor && "_16bt1q1b _1up41q1b",
                    !customLinkColor && "",
                    type === 'basic-underline' && "_9oik1r31 _1bnx8stv _jf4cnqa1",
                    type === 'modal' && "_1hms8stv _ajmmgq9o _1kegt94y _l7ed1l7b",
                    (type === 'inline' || type === 'inline-basic') && "_4bfu1r31 _1hms8stv _ajmmnqa1",
                    type !== 'modal' && type !== 'inline' && type !== 'inline-basic' && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
                    doesArrowAnimate && (type === 'basic' || type === 'basic-underline' || type === 'inline-basic') && "_1up4glyw _12sv54rc",
                    "_4cvr1h6o _syazaexi _1e0c116y _10531pdu _f8pji0o6 _30l3i0o6 _1axpaexi _aelyaexi _pb8z1pdu _kj55i0o6 _12lvi0o6 _l8kux7w3",
                    className
                ]),
                style: {
                    "--_1bmh097": (0, $6ZVlx.default)(colorDefault),
                    "--_d4pjwz": (0, $6ZVlx.default)(colorVisited),
                    "--_amadh5": (0, $6ZVlx.default)(colorHover)
                },
                children: $322aa4f5a77a3466$var$formatLinkText(text, type)
            })
        ]
    });
};

});

parcelRegister("3yLIj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $6b02249a5b86653a$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<3432ad567a0db7656508c7ac084b6d67>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6b02249a5b86653a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "partnerTemplateCardContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Sys",
            "kind": "LinkedField",
            "name": "sys",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urlSlug",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oneLinerHeadline",
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$6b02249a5b86653a$var$node.hash = "ca73d5016af7e32a730f30a64afc6a76";
var $6b02249a5b86653a$export$2e2bcd8739ae039 = $6b02249a5b86653a$var$node;

});


parcelRegister("1LCQu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $6742c103c48326cf$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<130ca463cf11c4821f42c29e4a040693>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6742c103c48326cf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "partnerTemplateCardCarouselContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Sys",
            "kind": "LinkedField",
            "name": "sys",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urlSlug",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "partnerTemplateCardContentfulRelayFragment"
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$6742c103c48326cf$var$node.hash = "a57260ce7f63b1ced209b80cea6f087b";
var $6742c103c48326cf$export$2e2bcd8739ae039 = $6742c103c48326cf$var$node;

});


parcelRegister("9lnnX", function(module, exports) {
$parcel$export(module.exports, "AdditionalCategoriesSection", function () { return $c5b8cfda99bde745$export$5770244d10930a; });
/* additional-categories-section-contentful-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $cml5G = parcelRequire("cml5G");

var $lRFwv = parcelRequire("lRFwv");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $17RBn = parcelRequire("17RBn");
const $c5b8cfda99bde745$var$containerStyles = null;
const $c5b8cfda99bde745$var$additionalCategoriesTextStyles = null;
const $c5b8cfda99bde745$var$categoryList = null;
const $c5b8cfda99bde745$var$categoryListItem = null;
const $c5b8cfda99bde745$var$localizedLinkForCategory = (locale, categoryId)=>{
    const prefix = locale === 'en' ? '' : `/${locale}`;
    if (categoryId === 'recommended') return `${prefix}/software/confluence/templates`;
    return `${prefix}/software/confluence/templates/categories/${categoryId}`;
};
const $c5b8cfda99bde745$export$5770244d10930a = ({ categories: categories })=>{
    const locale = (0, $17RBn.useLocale)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4t3i1qr7 _1bah1h6o _1o9zidpf _bfhk1ret _kqswh2mm _152tkfja _4cvresu3 _85i5zwfg _1g4s1y6m _8m2k1bp4 _9h171g80 _15951e9a _1u5xidpf _19vu1y6m _55br1bp4 _dype1g80 _1vkh1e9a _l549idpf _ag851y6m _1gde1bp4 _navj1g80 _tnrur0r7 _xlt1idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_syazqlpt _y3gn1h6o _ect41vau _1wybqslr _k48p1fw0 _vwz41f4h _12l212am _j2j21h6o _1yy3idpf _1po41tcg _tkvq1ylp _tgvv1tcg _gq9a1h6o _vyruidpf _qtem1tcg _1fqp1ylp _98081tcg _xsmr1h6o _1178idpf _srwz1tcg _11cg1ylp _476d1tcg"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    ...(0, $cml5G.ConfluenceTemplateMessages).additionalCategoriesText
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _ect41vau _1wybdlk8 _k48p1nn1 _1dyz1a1y _syazqlpt _zulpvbgk _slp31hna _1bah1yb4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbycs5v _n6ov11p5 _i48j16hb _9kowftgi _1yt81qr7 _kzvi11p5 _1da716hb _kd3kftgi _bcla1qr7 _suga11p5 _19d7fsjm _131yftgi _1d4svbgk"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display'))
                },
                children: categories.map((category)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        className: (0, $2jatx.default)([
                            "_2mzuglyw _vwz41f4h"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: $c5b8cfda99bde745$var$localizedLinkForCategory(locale, category.urlSlug),
                            ...(0, $lRFwv.ConfluenceTemplateAnalytics).viewTemplateCategory(category.urlSlug),
                            children: category.name
                        })
                    }, category.id))
            })
        ]
    });
};
$c5b8cfda99bde745$export$5770244d10930a.displayName = 'AdditionalCategoriesSection';

});


parcelRegister("9S4cS", function(module, exports) {
$parcel$export(module.exports, "TemplateSearchResultsSection", function () { return $899aa5b7c163fe85$export$a8f9e91d316b33f6; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");

var $gwk9T = parcelRequire("gwk9T");

var $dLCMY = parcelRequire("dLCMY");

var $he4zb = parcelRequire("he4zb");

var $2lca6 = parcelRequire("2lca6");

var $ax6BG = parcelRequire("ax6BG");
parcelRequire("7D10U");
var $ePBzs = parcelRequire("ePBzs");

var $3dnVb = parcelRequire("3dnVb");
const $899aa5b7c163fe85$var$CATEGORY = 'category';
const $899aa5b7c163fe85$var$SEARCH = 'search';
const $899aa5b7c163fe85$var$RECOMMENDED = 'recommended';
const $899aa5b7c163fe85$var$isSearchType = (searchTerm)=>{
    return typeof searchTerm === 'string' || searchTerm?.type === 'template';
};
const $899aa5b7c163fe85$var$isCategoryType = (searchTerm)=>{
    return typeof searchTerm !== 'string' && searchTerm?.type === 'category';
};
/**
 * Create a unique key to identify the search term.
 * This is used to force a new instance
 * of `TemplatePaginatedSearchResults`
 * when the search term changes.
 */ const $899aa5b7c163fe85$var$getSearchKey = (searchTerm)=>{
    if ($899aa5b7c163fe85$var$isCategoryType(searchTerm)) return searchTerm.id;
    if ($899aa5b7c163fe85$var$isSearchType(searchTerm)) return typeof searchTerm === 'string' ? searchTerm : searchTerm.id;
    return $899aa5b7c163fe85$var$RECOMMENDED;
};
const $899aa5b7c163fe85$var$getInitialState = (searchTerm, preloadedSearchResults)=>{
    if (preloadedSearchResults != null && $899aa5b7c163fe85$var$isCategoryType(searchTerm)) return {
        type: $899aa5b7c163fe85$var$CATEGORY,
        key: $899aa5b7c163fe85$var$getSearchKey(searchTerm),
        term: searchTerm,
        hasPreloadedSearchResults: true
    };
    return {
        type: null
    };
};
const $899aa5b7c163fe85$var$getNextState = (state, searchTerm)=>{
    const newKey = $899aa5b7c163fe85$var$getSearchKey(searchTerm);
    if (state.type == null || newKey !== state?.key) {
        if ($899aa5b7c163fe85$var$isCategoryType(searchTerm)) return {
            type: $899aa5b7c163fe85$var$CATEGORY,
            key: newKey,
            term: searchTerm,
            hasPreloadedSearchResults: false
        };
        else if ($899aa5b7c163fe85$var$isSearchType(searchTerm)) return {
            type: $899aa5b7c163fe85$var$SEARCH,
            key: newKey,
            term: searchTerm
        };
        else return {
            key: newKey,
            type: $899aa5b7c163fe85$var$RECOMMENDED
        };
    }
    return state;
};
const $899aa5b7c163fe85$export$a8f9e91d316b33f6 = ({ preloadedSearchResults: preloadedSearchResults, searchTerm: searchTerm, searchIntent: searchIntent })=>{
    const [searchTypePending, startSearchTypeTransition] = (0, $1oC0p.useTransition)();
    const locale = (0, $3dnVb.useQueryLocale)();
    const [state, setState] = (0, $1oC0p.useState)(()=>$899aa5b7c163fe85$var$getInitialState(searchTerm, preloadedSearchResults));
    const [, preloadSearchIntent] = (0, $f3gS9.useQueryLoader)((0, $2lca6.TemplateInitialSearchResultsRelayQuery));
    (0, $1oC0p.useEffect)(()=>{
        if (state.type == null || $899aa5b7c163fe85$var$getSearchKey(searchTerm) !== state.key) startSearchTypeTransition(()=>{
            setState((prevState)=>$899aa5b7c163fe85$var$getNextState(prevState, searchTerm));
        });
    }, [
        searchTerm,
        state
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (searchIntent && $899aa5b7c163fe85$var$isCategoryType(searchIntent)) {
            if (searchIntent.id != (0, $ePBzs.DEFAULT_CATEGORY_SLUG)) {
                const searchQuery = (0, $2lca6.parseSearchQuery)(searchIntent);
                preloadSearchIntent({
                    urlSlugs: searchQuery.whereClause?.['urlSlugs'] ?? [],
                    templateIds: searchQuery.whereClause?.['templateIds'] ?? [],
                    categoryUrlSlugs: searchQuery.whereClause?.['categoryUrlSlugs'] ?? [],
                    limit: searchQuery.first ?? 9,
                    skip: 0,
                    locale: locale
                });
            }
        }
    }, [
        locale,
        preloadSearchIntent,
        searchIntent
    ]);
    return searchTypePending ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwk9T.SkeletonTemplateRecommendationCardGrid), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwk9T.SkeletonTemplateRecommendationCardGrid), {}),
        children: state.type === $899aa5b7c163fe85$var$RECOMMENDED ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ax6BG.TemplateRecommendationsSearchResults), {}) : state.type === $899aa5b7c163fe85$var$SEARCH ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $he4zb.TemplateFuzzySearchResults), {
            searchKey: state.key,
            searchTerm: state.term
        }) : state.type === $899aa5b7c163fe85$var$CATEGORY ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dLCMY.TemplateCategorySearchResults), {
            searchKey: state.key,
            searchTerm: state.term,
            preloadedSearchResults: state.hasPreloadedSearchResults ? preloadedSearchResults : null
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gwk9T.SkeletonTemplateRecommendationCardGrid), {})
    });
};

});
parcelRegister("gwk9T", function(module, exports) {
$parcel$export(module.exports, "SkeletonTemplateRecommendationCardGrid", function () { return $b3c7f09f578f0519$export$8a3cccd4602e30ad; });
/* skeleton-template-card-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bQjAr = parcelRequire("bQjAr");

var $7pqky = parcelRequire("7pqky");

var $64WSq = parcelRequire("64WSq");
const $b3c7f09f578f0519$var$gridContainerStyles = null;
const $b3c7f09f578f0519$var$gridItemStyles = null;
const $b3c7f09f578f0519$export$8a3cccd4602e30ad = ()=>{
    const NUMBER_OF_PLACEHOLDER_CARD = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-template-skeleton-card-grid",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            "data-testid": "skeleton-template-recommendation-card-grid",
            className: (0, $2jatx.default)([
                "_1e0c1txw _1n261g80 _qtt8glyw _1x8w1vji _bozgidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _zulpvbgk _nvs8pl2w _e6atzwfg _1bah1h6o"
            ]),
            children: NUMBER_OF_PLACEHOLDER_CARD.map((cardNumber, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    "data-testid": `placeholder-template-card-grid-item-${index}`,
                    className: (0, $2jatx.default)([
                        "_2mzuglyw _1e0c1txw _1n261g80 _qtt8glyw _tzy4kb7n"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $64WSq.SkeletonTemplateCard), {
                        index: index,
                        background: (0, $7pqky.TEMPLATE_CARD_BACKGROUNDS)[index % (0, $7pqky.TEMPLATE_CARD_BACKGROUNDS).length]
                    })
                }, cardNumber))
        })
    });
};

});
parcelRegister("7pqky", function(module, exports) {
$parcel$export(module.exports, "TEMPLATE_CARD_BACKGROUNDS", function () { return $683990a6ad7763a9$export$dfa39f9572fef8d2; });
$parcel$export(module.exports, "TemplateCardGrid", function () { return $683990a6ad7763a9$export$f056ebcbe4e91b54; });
/* template-card-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $182sf = parcelRequire("182sf");

var $9RqQh = parcelRequire("9RqQh");

var $cml5G = parcelRequire("cml5G");
const $683990a6ad7763a9$var$gridStyles = null;
const $683990a6ad7763a9$var$gridContainerStyles = null;
const $683990a6ad7763a9$var$gridItemStyles = null;
const $683990a6ad7763a9$var$inViewAnimation = null;
const $683990a6ad7763a9$var$buttonStyle = null;
const $683990a6ad7763a9$var$CARD_FADE_UP_ANIMATION_DELAY = 0.2;
function $683990a6ad7763a9$var$getFadeUpAnimationDelay(shouldAnimate, index) {
    if (!shouldAnimate) return '0s';
    const calculated = $683990a6ad7763a9$var$CARD_FADE_UP_ANIMATION_DELAY * index;
    return calculated > 1.2 ? `1.2s` : `${calculated}s`;
}
const $683990a6ad7763a9$export$dfa39f9572fef8d2 = [
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg1.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg2.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg3.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg4.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg5.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg6.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg7.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg8.svg)',
    'url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg9.svg)'
];
const $683990a6ad7763a9$export$f056ebcbe4e91b54 = ({ templates: templates = [] })=>{
    const [shouldAnimate, setShouldAnimate] = (0, $1oC0p.useState)(false);
    const [showAll, setShowAll] = (0, $1oC0p.useState)(false);
    const [visibleTemplates, setVisibleTemplates] = (0, $1oC0p.useState)(templates.slice(0, 9));
    const { currentCategory: currentCategory } = (0, $182sf.useTemplateFuzzySearchContext)();
    const loadMoreTemplates = ()=>setShowAll(true);
    (0, $1oC0p.useEffect)(()=>{
        setTimeout(()=>{
            setShouldAnimate(true);
        }, 100);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (typeof templates !== 'undefined') setVisibleTemplates(showAll ? templates : templates.slice(0, 9));
    }, [
        templates,
        showAll
    ]);
    // Effect hook to reset `showAll` and `visibleTemplates` when `currentCategory` changes
    (0, $1oC0p.useEffect)(()=>{
        setShowAll(false);
        setVisibleTemplates(templates.slice(0, 9)); // Reset to initial state for new category
    }, [
        currentCategory,
        templates
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-template-card-grid",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: templates.length === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    ...(0, $cml5G.ConfluenceTemplateMessages).noTemplatesAvailableText
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _qtt8glyw _1x8w1vji _bozgidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _zulpvbgk _nvs8pl2w _e6atzwfg _1bah1h6o"
                        ]),
                        children: visibleTemplates.map((template, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                style: {
                                    transitionDelay: `${$683990a6ad7763a9$var$getFadeUpAnimationDelay(shouldAnimate, index)}`
                                },
                                "data-testid": `template-card-grid-item-${index}`,
                                className: (0, $2jatx.default)([
                                    "_qtt8glyw _2mzuglyw _1e0c1txw _1n261g80 _tzy4idpf _t9ec13hh",
                                    shouldAnimate && "_tzy4kb7n _t9ec161g _v564p5ws"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9RqQh.TemplateCard), {
                                    template: template,
                                    background: $683990a6ad7763a9$export$dfa39f9572fef8d2[index % $683990a6ad7763a9$export$dfa39f9572fef8d2.length]
                                })
                            }, template.templateId))
                    }),
                    templates?.length > 9 && !showAll && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                        variant: "secondary",
                        size: "small",
                        color: 'black',
                        style: {
                            marginTop: '60px',
                            textAlign: 'center'
                        },
                        onClick: loadMoreTemplates,
                        dataEventProps: {
                            'data-product-key': 'confluence',
                            'data-event': 'clicked',
                            'data-event-component': 'linkButton',
                            'data-event-container': 'templatesSection',
                            'data-label': 'load-more-templates-button',
                            'data-label-english': 'Load more templates',
                            'data-track-event': 'confluence.load-more-templates.cta'
                        },
                        className: (0, $2jatx.default)([
                            "_1bsbdlvw _4t3i1ady _1bah1h6o _4cvr1h6o _1e0c1txw _zulp19bv _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $cml5G.ConfluenceTemplateMessages).loadMoreTemplatesButtonText
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("182sf", function(module, exports) {
$parcel$export(module.exports, "useTemplateFuzzySearchContext", function () { return $ad1f76041e617b4e$export$aa00b9a74b4ef1e0; });
$parcel$export(module.exports, "TemplateFuzzySearchContextProvider", function () { return $ad1f76041e617b4e$export$8d7fff680f8d0f63; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $djfBw = parcelRequire("djfBw");

var $yagHz = parcelRequire("yagHz");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lRFwv = parcelRequire("lRFwv");

var $9L6Rz = parcelRequire("9L6Rz");

var $ePBzs = parcelRequire("ePBzs");

var $kf4PU = parcelRequire("kf4PU");

var $aHkxS = parcelRequire("aHkxS");

var $dtupn = parcelRequire("dtupn");
const $ad1f76041e617b4e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $ad1f76041e617b4e$export$aa00b9a74b4ef1e0 = ()=>{
    const context = (0, $1oC0p.useContext)($ad1f76041e617b4e$export$2e2bcd8739ae039);
    if (!context) throw new Error('useTemplateFuzzySearchContext must be used within a TemplateFuzzySearchContextProvider');
    return context;
};
const $ad1f76041e617b4e$export$8c8744f7312990d4 = (categories, templates)=>{
    const items = [];
    templates.forEach((template)=>{
        if (template.name) items.push({
            id: template.urlSlug,
            name: template.name,
            description: template.previewBlurb,
            contributor: template.contributor?.name,
            contributorOrganization: template.contributor?.organization?.name,
            customTag: $ad1f76041e617b4e$var$addCustomTagToTemplatesBasedOnSearchTerm(template),
            type: 'template',
            templateType: template.templateType?.[0]?.templateTypeName
        });
    });
    categories.forEach((category)=>{
        //skip recommended and other additional categories from search
        if (category.urlSlug === 'recommended' || category.urlSlug === 'project-planning' || category.urlSlug === 'business-strategy' || category.urlSlug === 'productivity' || category.urlSlug === 'docs-and-reports' || category.urlSlug === 'startup' || category.urlSlug === 'personal') return;
        if (category.name) items.push({
            id: category.urlSlug,
            name: category.name,
            description: category.shortDescriptionOneLiner,
            type: 'category'
        });
    });
    const options = {
        keys: [
            {
                name: 'name',
                weight: 0.8
            },
            // Increased weight for better matches on name
            {
                name: 'description',
                weight: 0.5
            },
            {
                name: 'contributor',
                weight: 0.3
            },
            {
                name: 'contributorOrganization',
                weight: 0.3
            },
            {
                name: 'customTag',
                weight: 0.3
            },
            {
                name: 'templateType',
                weight: 0.2
            }
        ],
        includeScore: true,
        threshold: 0.4
    };
    return new (0, $djfBw.default)(items, options);
};
const $ad1f76041e617b4e$var$slugToSearchTermMap = {
    'project-plan': [
        'proposal',
        'gantt',
        'timeline'
    ],
    'master-project-documentation': [
        'proposal'
    ],
    'annual-plan-one-pager': [
        'proposal'
    ],
    'mutual-action-plan': [
        'proposal'
    ],
    'executive-business-review': [
        'proposal'
    ],
    'devops-runbook': [
        'gantt',
        'timeline'
    ],
    'software-architecture-review': [
        'gantt'
    ],
    'problem-framing': [
        'faq'
    ],
    'safe-lean-business-case': [
        'faq'
    ],
    'hr-knowledge-base': [
        'faq'
    ],
    'design-sprint': [
        'timeline'
    ],
    'project-kickoff': [
        'timeline'
    ],
    'year-in-review': [
        'timeline'
    ]
};
const $ad1f76041e617b4e$var$WHITEBOARD_TYPE_ID = '1HlskYfRNciSnQ02SDhCPs';
// This function is used to add custom tags  for templates based on url slug
const $ad1f76041e617b4e$var$addCustomTagToTemplatesBasedOnSearchTerm = (template)=>{
    const tags = (template.urlSlug ? $ad1f76041e617b4e$var$slugToSearchTermMap[template.urlSlug] : []) ?? [];
    /**
   * Whiteboard templates for custom tag search term "whiteboard templates"
   */ if (template.templateType?.some((type)=>type.id === $ad1f76041e617b4e$var$WHITEBOARD_TYPE_ID)) tags.push('whiteboard templates');
    return tags;
};
const $ad1f76041e617b4e$export$2115c2c0a84eef61 = (searchTerm, fuseInstance, limit = 35)=>{
    if (searchTerm && fuseInstance) {
        const results = fuseInstance.search(searchTerm);
        return results.sort((a, b)=>(a.score ?? Infinity) - (b.score ?? Infinity)) // Sort by score in ascending order
        .slice(0, limit) // Get the top results
        .map((result)=>({
                id: result.item.id,
                name: result.item.name,
                type: result.item.type,
                description: result.item.description,
                templateType: result.item.templateType
            }));
    }
    return [];
};
function $ad1f76041e617b4e$var$getCategoryTemplates(templates, id) {
    return templates.filter((template)=>{
        return template.category?.some((category)=>category.id === id);
    });
}
const $ad1f76041e617b4e$export$eb4ccf52914a0861 = (templates, categorySlug, id)=>{
    let categoryTemplates;
    // If the category is recommended, we need to check if the user is enrolled in the experiment
    // If the user is enrolled in the experiment, we need to show the experiment templates if the recommended templates from ML recommendations are empty.
    if (id === (0, $kf4PU.TEMPLATE_CATEGORY_OBJ).id) categoryTemplates = $ad1f76041e617b4e$var$getCategoryTemplates(templates, id);
    else // if experiment is enabled the new categories take precedence we need to show the templates that match the category slug and experiment value=true
    //if experiment is enabled but the category is not part of experiment we need to show the templates that match the category slug and experiment value=false
    //We are specifically doing this to prevent the templates from showing up from both experiment and non experiment categories having same name i.e. product-management, design & marketing-and-sales
    if ((0, $ePBzs.CategoryTemplateOrder)[categorySlug]) categoryTemplates = templates.filter((template)=>{
        return template.category?.some((category)=>category.urlSlug === categorySlug);
    });
    else categoryTemplates = templates.filter((template)=>{
        return template.category?.some((category)=>category.urlSlug === categorySlug);
    });
    const sortLookup = (0, $ePBzs.CategoryTemplateOrder)[categorySlug] ?? undefined;
    return $ad1f76041e617b4e$var$sortBy(categoryTemplates, sortLookup ?? 'name');
};
function $ad1f76041e617b4e$var$sortBy(items, sortBy) {
    if (!sortBy) return [
        ...items
    ];
    if (sortBy === 'name') return [
        ...items
    ].sort((a, b)=>a.name && b.name ? a.name.localeCompare(b.name) : a.name ? -1 : 1);
    return [
        ...items
    ].sort((a, b)=>{
        const aRank = a.urlSlug ? sortBy[a.urlSlug] : undefined;
        const bRank = b.urlSlug ? sortBy[b.urlSlug] : undefined;
        // Sort by rank 1 is higher than 2
        // if aRank is undefined, it should be sorted lower than bRank
        if (aRank === undefined) return bRank === undefined ? 0 : 1;
        if (bRank === undefined) return -1;
        return aRank - bRank;
    });
}
const $ad1f76041e617b4e$var$filterTemplatesByTemplate = (templates, templateSlug)=>{
    return templates.filter((template)=>template.urlSlug === templateSlug);
};
const $ad1f76041e617b4e$export$4f8d371ef2c61f3c = (templates, categories, fuseInstance, filter)=>{
    if (filter.searchItem) {
        if (filter?.searchItem.type === 'category') {
            const categorySlug = filter.searchItem.id;
            // Find the category that matches the slug, or use feature or recommended
            const category = categories.find((c)=>c.urlSlug === categorySlug) || categories.find((c)=>c.urlSlug === 'recommended');
            return {
                category: category,
                displayedTemplates: $ad1f76041e617b4e$export$eb4ccf52914a0861(templates, category?.urlSlug ?? categorySlug, category?.id)
            };
        } else if (filter.searchItem.type === 'template') return {
            category: undefined,
            displayedTemplates: $ad1f76041e617b4e$var$filterTemplatesByTemplate(templates, filter.searchItem.id)
        };
    } else if (filter.searchTerm) {
        if (!fuseInstance) return {
            category: undefined,
            displayedTemplates: templates
        };
        const searchDisplayedTemplates = $ad1f76041e617b4e$export$2115c2c0a84eef61(filter.searchTerm, fuseInstance)// put categories at the end
        .sort((a)=>a.type === 'category' ? 1 : -1).map((item)=>{
            if (item.type === 'category') {
                const categorySlug = item.id;
                // Find the category that matches the slug, or use feature or recommended
                const category = categories.find((c)=>c.urlSlug === categorySlug || c.urlSlug === 'recommended');
                return $ad1f76041e617b4e$export$eb4ccf52914a0861(templates, category?.urlSlug ?? categorySlug);
            } else return templates.find((t)=>item.type === 'template' && item.id === t.urlSlug);
        })//flatten the array for templates matched to category and templates matched to search term and remove undefined values
        .flat().filter((t)=>t !== undefined);
        return {
            category: undefined,
            // need to remove duplicates as there could be between templates and those from the category
            displayedTemplates: (0, (/*@__PURE__*/$parcel$interopDefault($yagHz))).uniqBy(searchDisplayedTemplates, 'urlSlug')
        };
    }
    const category = $ad1f76041e617b4e$var$getInitialCategory(categories);
    return {
        category: category,
        displayedTemplates: $ad1f76041e617b4e$export$eb4ccf52914a0861(templates, category?.urlSlug, category?.id)
    };
};
const $ad1f76041e617b4e$export$8d7fff680f8d0f63 = ({ children: children })=>{
    const templates = (0, $9L6Rz.useTemplates)();
    const { adjustedCategories: categories } = (0, $dtupn.useRecommendedTemplates)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    // Search term used for fuzzy search
    const [searchTerm, setSearchTerm] = (0, $1oC0p.useState)($ad1f76041e617b4e$var$getInitialSearch());
    // Currently selected category
    const [currentCategory, setCurrentCategory] = (0, $1oC0p.useState)(searchTerm ? undefined : $ad1f76041e617b4e$var$getInitialCategory(categories));
    // Current filter applied to the displayed templates
    const [currentFilter, setCurrentFilter] = (0, $1oC0p.useState)({
        searchTerm: searchTerm,
        searchItem: currentCategory ? {
            type: 'category',
            id: currentCategory.urlSlug,
            name: currentCategory.name
        } : undefined
    });
    // Search suggestion results
    const [matchingSearchItems, setMatchingSearchItems] = (0, $1oC0p.useState)([]);
    // Templates to display
    const [displayedTemplates, setDisplayedTemplates] = (0, $1oC0p.useState)($ad1f76041e617b4e$export$4f8d371ef2c61f3c(templates, categories, null, currentFilter).displayedTemplates);
    const fuseInstance = (0, $1oC0p.useRef)($ad1f76041e617b4e$export$8c8744f7312990d4(categories, templates));
    const urlWithLocale = (0, $1oC0p.useCallback)((url)=>{
        const prefix = intl.locale === 'en' ? '' : `/${intl.locale}`;
        return `${prefix}${url}`;
    }, [
        intl
    ]);
    (0, $1oC0p.useEffect)(()=>{
        fuseInstance.current = $ad1f76041e617b4e$export$8c8744f7312990d4(categories, templates);
    }, [
        categories,
        templates
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (searchTerm) {
            const fuzzySearchResults = $ad1f76041e617b4e$export$2115c2c0a84eef61(searchTerm, fuseInstance.current);
            setMatchingSearchItems(fuzzySearchResults);
            (0, $lRFwv.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchResultsAnalytic(fuzzySearchResults?.length.toString());
        }
    }, [
        searchTerm,
        fuseInstance
    ]);
    // Update displayed templates based on current filter
    (0, $1oC0p.useEffect)(()=>{
        if (templates.length === 0 || categories.length === 0) return;
        const { category: category, displayedTemplates: updatedDisplay } = $ad1f76041e617b4e$export$4f8d371ef2c61f3c(templates, categories, fuseInstance.current, currentFilter || {});
        setCurrentCategory(category);
        setDisplayedTemplates(updatedDisplay);
    }, [
        currentFilter,
        templates,
        categories
    ]);
    // Reinitialize tracking when displayed templates changes
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        displayedTemplates
    ]);
    const changeSearchTerm = (newSearchTerm)=>{
        setSearchTerm(newSearchTerm);
    };
    const searchSubmit = (0, $1oC0p.useCallback)((options)=>{
        setCurrentFilter(options);
        if (options.searchTerm || options.searchItem?.type === 'template') // Update the history and search
        history.replaceState(null, '', urlWithLocale(`/software/confluence/templates/search?term=${options.searchTerm ?? options.searchItem?.name}`));
        else if (options.searchItem?.type === 'category') history.replaceState(null, '', urlWithLocale(`/software/confluence/templates/categories/${options.searchItem.id}`));
    }, [
        urlWithLocale
    ]);
    const setCategory = (0, $1oC0p.useCallback)((category)=>{
        if (category.urlSlug === currentCategory?.urlSlug) return;
        setCurrentFilter({
            searchItem: {
                type: 'category',
                id: category.urlSlug,
                name: category.name
            }
        });
        const url = urlWithLocale(category.urlSlug === 'recommended' ? `/software/confluence/templates` : `/software/confluence/templates/categories/${category.urlSlug}`);
        history.replaceState(null, '', url);
        createAnalyticsEvent({
            action: 'viewed',
            eventType: 'screen',
            name: 'page',
            attributes: {
                category: category.urlSlug,
                page_path: url,
                originProduct: `wac-software-confluence-templates-categories-${category.urlSlug}`,
                isMarketingEvent: true
            }
        }).fire();
        //firing a new template category event
        (0, $lRFwv.ConfluenceTemplateAnalytics).viewTemplatesTaxonomyCategory(category.urlSlug);
        setSearchTerm('');
    }, [
        currentCategory,
        urlWithLocale
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($ad1f76041e617b4e$export$2e2bcd8739ae039.Provider, {
        value: {
            searchTerm: searchTerm,
            setSearchTerm: changeSearchTerm,
            searchSubmit: searchSubmit,
            setCategory: setCategory,
            matchingSearchItems: matchingSearchItems,
            currentCategory: currentCategory,
            displayedTemplates: displayedTemplates
        },
        children: children
    });
};
$ad1f76041e617b4e$export$8d7fff680f8d0f63.displayName = 'TemplateFuzzySearchContextProvider';
function $ad1f76041e617b4e$var$getInitialSearch() {
    try {
        return new URLSearchParams(location.search).get('term') ?? undefined;
    } catch  {
        return undefined;
    }
}
function $ad1f76041e617b4e$var$getInitialCategory(categories) {
    const term = location.pathname;
    const [categoryUrlSlug, prefix] = term.split('/').reverse();
    if (term && categories?.length > 0 && prefix === 'categories') {
        const initialCategory = categories.find((category)=>category.urlSlug === categoryUrlSlug);
        if (initialCategory) return initialCategory;
    }
    return categories.find((category)=>category.urlSlug === 'recommended');
}

});
parcelRegister("9L6Rz", function(module, exports) {
$parcel$export(module.exports, "TemplateProvider", function () { return $6f9c51e94d9cb248$export$5abfb1150fa6da6a; });
$parcel$export(module.exports, "useTemplates", function () { return $6f9c51e94d9cb248$export$b0a9bce6cbec665b; });
$parcel$export(module.exports, "useCollections", function () { return $6f9c51e94d9cb248$export$2b5787016ed09c4d; });
$parcel$export(module.exports, "useCategories", function () { return $6f9c51e94d9cb248$export$17897f9a67d1488d; });
$parcel$export(module.exports, "usePartnerTemplates", function () { return $6f9c51e94d9cb248$export$7a2976c4e84c1f65; });

var $7VQPk = parcelRequire("7VQPk");

var $lr38U = parcelRequire("lr38U");

var $1oC0p = parcelRequire("1oC0p");

var $ePBzs = parcelRequire("ePBzs");

var $4U3Z4 = parcelRequire("4U3Z4");

var $df0Hj = parcelRequire("df0Hj");
const $6f9c51e94d9cb248$var$DEFAULT_TEMPLATE_CONTEXT_VALUE = {
    templates: [],
    partnerTemplates: [],
    collections: [],
    categories: []
};
const $6f9c51e94d9cb248$var$TemplateContext = /*#__PURE__*/ (0, $1oC0p.createContext)($6f9c51e94d9cb248$var$DEFAULT_TEMPLATE_CONTEXT_VALUE);
function $6f9c51e94d9cb248$var$isTemplateContextValue(partial) {
    let key;
    for(key in $6f9c51e94d9cb248$var$DEFAULT_TEMPLATE_CONTEXT_VALUE){
        const defaultValue = $6f9c51e94d9cb248$var$DEFAULT_TEMPLATE_CONTEXT_VALUE[key];
        const value = partial[key];
        if (typeof defaultValue !== typeof value || Array.isArray(defaultValue) !== Array.isArray(value)) return false;
    }
    return true;
}
function $6f9c51e94d9cb248$var$createQueryState() {
    const client = new (0, $lr38U.AGGClient)({
        gatewayUrl: 'https://www.atlassian.com/gateway/api/graphql'
    });
    const { route: route, locale: locale } = (0, $df0Hj.getCurrentRoute)();
    const state = {
        status: 'pending',
        promise: (0, $4U3Z4.getTemplateData)(route, locale, client).then((result)=>{
            state.status = 'resolved';
            state.value = result;
        }).catch((err)=>{
            state.status = 'rejected';
            state.error = err;
        })
    };
    return state;
}
function $6f9c51e94d9cb248$var$sortBy(items, sortBy) {
    if (!sortBy) return [
        ...items
    ];
    if (sortBy === 'name') return [
        ...items
    ].sort((a, b)=>a.name && b.name ? a.name.localeCompare(b.name) : a.name ? -1 : 1);
    return [
        ...items
    ].sort((a, b)=>{
        const aRank = a.urlSlug ? sortBy[a.urlSlug] : undefined;
        const bRank = b.urlSlug ? sortBy[b.urlSlug] : undefined;
        // Sort by rank 1 is higher than 2
        // if aRank is undefined, it should be sorted lower than bRank
        if (aRank === undefined) return bRank === undefined ? 0 : 1;
        if (bRank === undefined) return -1;
        return aRank - bRank;
    });
}
/**
 * Creates a context value for `TemplateContext` from partial data.
 * If any of the required context is missing, this function will
 * log a warning and replace the missing context with defaults.
 *
 * NOTE: It does not throw because doing so could cause SSR to fail.
 * The assumption is that the missing context will be resolved by
 * a client-side query (see `toTemplateContextValueDeferred`).
 */ function $6f9c51e94d9cb248$var$toTemplateContextValue(props, sortProps) {
    const result = {};
    let key;
    for(key in $6f9c51e94d9cb248$var$DEFAULT_TEMPLATE_CONTEXT_VALUE){
        const value = props[key];
        if (!value) {
            console.warn(`TemplateProvider is missing required prop: ${key}`);
            // @ts-ignore
            result[key] = $6f9c51e94d9cb248$var$DEFAULT_TEMPLATE_CONTEXT_VALUE[key];
        } else {
            const sortProp = sortProps[`${key}SortBy`];
            if (sortProp) // @ts-ignore
            result[key] = $6f9c51e94d9cb248$var$sortBy(value, sortProp);
            else // @ts-ignore
            result[key] = value;
        }
    }
    return result;
}
/**
 * Like `toTemplateContextValue`, but creates getters for the missing properties
 * that will throw a promise until the query for data resolves. The getters
 * will then be replaced with the resolved values.
 *
 * NOTE: This effectively implements a fallback behavior for any context that was
 * missing during SSR, or if the consuming page is being served from static fallback.
 */ function $6f9c51e94d9cb248$var$toTemplateContextValueDeferred(props, sortProps) {
    let state;
    /**
   * Creates a getter that will throw a promise until the query for
   * `templates` data resolves. The getter will then be replaced with
   * the resolved value.
   */ function deferred(obj, name) {
        return ()=>{
            state ??= $6f9c51e94d9cb248$var$createQueryState();
            switch(state.status){
                case 'pending':
                    throw state.promise;
                case 'rejected':
                    throw state.error;
                case 'resolved':
                    // Replace the getter with the resolved value, so
                    // that future calls to this property will no longer
                    // see the getter on this object.
                    const value = $6f9c51e94d9cb248$var$sortBy(state.value[name], sortProps[`${name}SortBy`]);
                    Object.defineProperty(obj, name, {
                        writable: false,
                        enumerable: true,
                        value: value
                    });
                    return value;
            }
        };
    }
    const value = {
        ...props
    };
    let key;
    for(key in $6f9c51e94d9cb248$var$DEFAULT_TEMPLATE_CONTEXT_VALUE)if (!value[key]) Object.defineProperty(value, key, {
        enumerable: true,
        get: deferred(value, key)
    });
    return value;
}
/**
 * Creates a context value for `TemplateContext` from partial data.
 *
 * On the server, this function will replace any missing context
 * with defaults. On the client, this function will replace
 * any missing context with getters that will throw a promise
 * until the the data load resolves.
 *
 * See `toTemplateContextValue` and `toTemplateContextValueDeferred` for more.
 */ function $6f9c51e94d9cb248$var$useTemplatesContextValue({ templates: templates, partnerTemplates: partnerTemplates, collections: collections, categories: categories, templatesSortBy: templatesSortBy, partnerTemplatesSortBy: partnerTemplatesSortBy = templatesSortBy, collectionsSortBy: collectionsSortBy, categoriesSortBy: categoriesSortBy = (0, $ePBzs.CategoryOrder) }) {
    const contextProps = (0, $1oC0p.useMemo)(()=>({
            templates: templates,
            partnerTemplates: partnerTemplates,
            collections: collections,
            categories: categories
        }), [
        templates,
        partnerTemplates,
        collections,
        categories
    ]);
    const sortProps = (0, $1oC0p.useMemo)(()=>({
            templatesSortBy: templatesSortBy,
            partnerTemplatesSortBy: partnerTemplatesSortBy,
            collectionsSortBy: collectionsSortBy,
            categoriesSortBy: categoriesSortBy
        }), [
        templatesSortBy,
        partnerTemplatesSortBy,
        collectionsSortBy,
        categoriesSortBy
    ]);
    const [{ contextValue: contextValue, isPartialValue: isPartialValue }, setContextValue] = (0, $1oC0p.useState)(()=>({
            contextValue: $6f9c51e94d9cb248$var$toTemplateContextValue(contextProps, sortProps),
            isPartialValue: !$6f9c51e94d9cb248$var$isTemplateContextValue(contextProps)
        }));
    (0, $1oC0p.useEffect)(()=>{
        if (isPartialValue) setContextValue({
            contextValue: $6f9c51e94d9cb248$var$toTemplateContextValueDeferred(contextProps, sortProps),
            isPartialValue: false
        });
    }, [
        contextProps,
        sortProps,
        isPartialValue
    ]);
    return contextValue;
}
const $6f9c51e94d9cb248$export$5abfb1150fa6da6a = ({ templates: templates, partnerTemplates: partnerTemplates, collections: collections, categories: categories, templatesSortBy: templatesSortBy, collectionsSortBy: collectionsSortBy, categoriesSortBy: categoriesSortBy, children: children })=>{
    const value = $6f9c51e94d9cb248$var$useTemplatesContextValue({
        templates: templates,
        partnerTemplates: partnerTemplates,
        collections: collections,
        categories: categories,
        templatesSortBy: templatesSortBy,
        collectionsSortBy: collectionsSortBy,
        categoriesSortBy: categoriesSortBy
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($6f9c51e94d9cb248$var$TemplateContext.Provider, {
        value: value,
        children: children
    });
};
const $6f9c51e94d9cb248$export$b0a9bce6cbec665b = ()=>{
    const context = (0, $1oC0p.useContext)($6f9c51e94d9cb248$var$TemplateContext);
    if (!context) throw new Error('calls to useTemplates must be wrapped in <TemplateProvider>');
    return context.templates;
};
const $6f9c51e94d9cb248$export$2b5787016ed09c4d = ()=>{
    const context = (0, $1oC0p.useContext)($6f9c51e94d9cb248$var$TemplateContext);
    if (!context) throw new Error('calls to useCollections must be wrapped in <TemplateProvider>');
    return context.collections;
};
const $6f9c51e94d9cb248$export$17897f9a67d1488d = ()=>{
    const context = (0, $1oC0p.useContext)($6f9c51e94d9cb248$var$TemplateContext);
    if (!context) throw new Error('calls to useCategories must be wrapped in <TemplateProvider>');
    return context.categories;
};
const $6f9c51e94d9cb248$export$7a2976c4e84c1f65 = ()=>{
    const context = (0, $1oC0p.useContext)($6f9c51e94d9cb248$var$TemplateContext);
    if (!context) throw new Error('calls to usePartnerTemplates must be wrapped in <TemplateProvider>');
    return context.partnerTemplates;
};

});
parcelRegister("4U3Z4", function(module, exports) {
$parcel$export(module.exports, "flattenTemplateImageAssets", function () { return $ac905b52aa11c6df$export$a9354d2b695974a0; });
$parcel$export(module.exports, "getTemplateData", function () { return $ac905b52aa11c6df$export$21a65498e0e24008; });
$parcel$export(module.exports, "getRecommendedTemplates", function () { return $ac905b52aa11c6df$export$391892a5db6cf2f7; });

var $7P2jM = parcelRequire("7P2jM");

var $hR4hv = parcelRequire("hR4hv");

var $lr38U = parcelRequire("lr38U");

var $ePBzs = parcelRequire("ePBzs");

var $8UY3F = parcelRequire("8UY3F");

var $kf4PU = parcelRequire("kf4PU");
function $ac905b52aa11c6df$var$imageFromContentPlatformImage(node //ContentPlatformTemplateImageAsset
) {
    const details = node.details;
    const parsedImage = {
        name: node.title,
        size: details.size,
        url: node.url,
        description: node.description,
        contentType: node.contentType
    };
    if (details.image) return {
        ...parsedImage,
        height: details.image.height,
        width: details.image.width
    };
    return parsedImage;
}
// for the template-landing loader
function $ac905b52aa11c6df$var$contributorFromContentPlatformContributor(node //ContentPlatformTemplate["contributor"]
) {
    if (node?.__typename === 'ContentPlatformOrganization') return {
        name: node.name,
        tagline: node.tagline,
        shortDescription: node.shortDescription,
        logo: node.logo?.map($ac905b52aa11c6df$var$imageFromContentPlatformImage),
        industry: node.industry?.map((industry)=>({
                name: industry.name,
                shortDescription: industry.shortDescription
            }))
    };
    else if (node?.__typename === 'ContentPlatformAuthor') return {
        name: node.name,
        jobTitle: node.jobTitle,
        shortBiography: node.shortBiography,
        authorPicture: node.authorPicture ? $ac905b52aa11c6df$var$imageFromContentPlatformImage(node.authorPicture) : null,
        organization: $ac905b52aa11c6df$var$contributorFromContentPlatformContributor(node.organization)
    };
    return null;
}
const $ac905b52aa11c6df$export$2e2dbd43b49fd373 = (node)=>{
    return {
        ...node,
        contributor: $ac905b52aa11c6df$var$contributorFromContentPlatformContributor(node.contributor),
        templateIcon: node.templateIcon ? $ac905b52aa11c6df$var$imageFromContentPlatformImage(node.templateIcon) : null,
        templatePreview: node.templatePreview?.map($ac905b52aa11c6df$var$imageFromContentPlatformImage),
        howToUseThisTemplate: node.howToUseThisTemplate?.map((guide)=>({
                name: guide.name,
                steps: guide.steps?.map((step)=>({
                        name: step.name,
                        description: step.description,
                        asset: step.asset ? $ac905b52aa11c6df$var$imageFromContentPlatformImage(step.asset) : null
                    })) ?? []
            })),
        relatedTemplates: node.relatedTemplates?.map((template)=>({
                ...template,
                templateIcon: template.templateIcon ? $ac905b52aa11c6df$var$imageFromContentPlatformImage(template.templateIcon) : null
            }))
    };
};
const $ac905b52aa11c6df$export$ca3a18b68253a5ff = (node)=>{
    return {
        ...node,
        aboutThisCollectionImage: node.aboutThisCollectionImage ? $ac905b52aa11c6df$var$imageFromContentPlatformImage(node.aboutThisCollectionImage) : null,
        collectionIcon: node.collectionIcon ? $ac905b52aa11c6df$var$imageFromContentPlatformImage(node.collectionIcon) : null
    };
};
const $ac905b52aa11c6df$export$2d9dfae9dd50d547 = (edges, locale = 'en-US')=>{
    const categories = [];
    let localizedName, localizedShortDescriptionOneLiner, experiment;
    for (const { node: node } of edges){
        // TODO: GWP-1522 - Remove this check once we are returning delocalized data from CPAPI
        if (typeof node.context.name === 'object' && node.context.name != null) localizedName = node.context.name[locale] ?? node.context.name[`${locale}-fallback`];
        else localizedName = node.context.name;
        if (typeof node.context.shortDescriptionOneLiner === 'object' && node.context.shortDescriptionOneLiner != null) localizedShortDescriptionOneLiner = node.context.shortDescriptionOneLiner[locale] ?? node.context.shortDescriptionOneLiner[`${locale}-fallback`];
        else localizedShortDescriptionOneLiner = node.context.shortDescriptionOneLiner;
        if (node.context.experiment != null) experiment = node.context.experiment;
        else experiment = false;
        categories.push({
            id: node.context.id,
            name: localizedName,
            shortDescriptionOneLiner: localizedShortDescriptionOneLiner,
            urlSlug: node.context.urlSlug,
            experiment: experiment
        });
    }
    return categories.sort((a, b)=>(0, $ePBzs.CategoryOrder)[a.urlSlug] - (0, $ePBzs.CategoryOrder)[b.urlSlug]);
};
const $ac905b52aa11c6df$var$GET_RECOMMENDED_TEMPLATE_IDS = `#graphql
query GetTemplateIdRecommendations($anonymousId: ID!, $userId: ID!, $custom: JSON, $first:Int) {
    growthRecommendations {
      recommendations(context: { useCase: "wacConfluenceTemplates", anonymousId: $anonymousId, userId: $userId, product: "marketing", custom: $custom }, first:$first) {
           ... on GrowthRecRecommendations {
              data {
              entityId
            }
        }
      }
    }
  }
`;
const $ac905b52aa11c6df$var$GET_TEMPLATES_BY_ID = `#graphql
    query getTemplates($ids: [String!]) {
        templates(search: {queries: [{ first:75, where: { fieldNamed: "templateId", havingValues: $ids} }]}) {
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    ...lightTemplateFragment
                }
            }
        }
    }
    ${(0, $7P2jM.lightTemplateFragment)}
    ${(0, $hR4hv.assetFragment)}
    `;
const $ac905b52aa11c6df$export$a9354d2b695974a0 = (node)=>{
    if (node.__typename === 'ContentPlatformTemplateImageAsset' || node.__typename === 'TemplateImageAsset') return $ac905b52aa11c6df$var$imageFromContentPlatformImage(node);
    for (const key of Object.keys(node)){
        if (node[key] && typeof node[key] === 'object') node[key] = $ac905b52aa11c6df$export$a9354d2b695974a0(node[key]);
        if (Array.isArray(node[key])) node[key] = node[key].map($ac905b52aa11c6df$export$a9354d2b695974a0);
    }
    return node;
};
const $ac905b52aa11c6df$export$ae482c6d049f1bf = {};
const $ac905b52aa11c6df$export$21a65498e0e24008 = async (route, locale = 'en', aggClient = new (0, $lr38U.AGGClient)())=>{
    const matcher = Object.values((0, $8UY3F.LoaderMatchers)).find((loader)=>loader.match.test(route) && !loader.requireMlTemplateIds);
    const cpapiLocale = (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || 'en-US';
    if (!matcher) {
        console.warn(`No loader matcher found for route ${route}`);
        return;
    }
    const templatePageLoader = $ac905b52aa11c6df$export$ae482c6d049f1bf[matcher.name];
    if (!templatePageLoader) {
        console.warn(`No template page loader found for route ${route}`);
        return;
    }
    const { getQueryData: getQueryData, parseData: parseData, multiplePagesQuery: multiplePagesQuery } = templatePageLoader;
    const matchGroup = matcher.match.exec(route);
    let urlSlug = '';
    if (matchGroup && matchGroup.groups) urlSlug = matchGroup.groups['urlSlug'];
    const { query: query, variables: variables } = getQueryData(urlSlug, cpapiLocale);
    const { data: data } = await aggClient.query(query, variables);
    // this is only for grabbing additional Confluence templates
    if (matcher.name !== 'agile-overview-page') while(multiplePagesQuery && data.templates.pageInfo?.hasNextPage && data.templates.pageInfo?.endCursor){
        const { query: followUpQuery, variables: followUpVariables } = getQueryData(urlSlug, cpapiLocale, data.templates.pageInfo.endCursor);
        const { data: newData } = await aggClient.query(followUpQuery, {
            ...followUpVariables
        });
        data.templates.edges.push(...newData.templates.edges);
        data.templates.pageInfo = newData.templates.pageInfo;
    }
    return parseData ? parseData(data, cpapiLocale) : data;
};
const $ac905b52aa11c6df$export$391892a5db6cf2f7 = async ({ anonymousId: anonymousId, userId: userId, aggClient: aggClient = new (0, $lr38U.AGGClient)(), recommendedTemplateIds: recommendedTemplateIds, custom: custom, first: first = 9 })=>{
    let recommendedIds = [];
    const { data: recommendationData, errors: errors } = await aggClient.query($ac905b52aa11c6df$var$GET_RECOMMENDED_TEMPLATE_IDS, {
        anonymousId: anonymousId,
        userId: userId,
        custom: custom,
        first: first
    });
    // will use fallback if one available
    if (errors) {
        console.error(`GRS API failed`, errors[0]?.message);
        if (recommendedTemplateIds) // Load data from browser storage
        recommendedIds = recommendedTemplateIds;
    } else recommendedIds = recommendationData.growthRecommendations.recommendations.data.map((recommendation)=>recommendation.entityId);
    const { data: data } = await aggClient.query($ac905b52aa11c6df$var$GET_TEMPLATES_BY_ID, {
        ids: recommendedIds
    });
    return {
        recommendedTemplateIds: recommendedIds,
        templates: data.templates.edges.map((edge)=>edge.node)
    };
};
const $ac905b52aa11c6df$export$a3e0b58baa455034 = async ({ aggClient: aggClient = new (0, $lr38U.AGGClient)(), templateIds: templateIds })=>{
    const { data: data } = await aggClient.query($ac905b52aa11c6df$var$GET_TEMPLATES_BY_ID, {
        ids: templateIds
    });
    return data.templates.edges.map((edge)=>edge.node);
};

});
parcelRegister("7P2jM", function(module, exports) {
$parcel$export(module.exports, "lightTemplateFragment", function () { return $7d890c8e35a61625$export$1f70950885ffade1; });
const $7d890c8e35a61625$export$1f70950885ffade1 = `
    fragment lightTemplateFragment on ContentPlatformTemplate {
        templateId
        name
        urlSlug
        pluginModuleKey
        contributor {
            __typename
            ... on ContentPlatformOrganization {
                ...contentPlatformOrganization
            }
            ... on ContentPlatformAuthor {
                name
                jobTitle
                authorPicture {
                    ...contentPlatformImageAsset
                }
                organization {
                    __typename
                    ...contentPlatformOrganization
                }
            }
        }
        templatePreview {
            ...contentPlatformImageAsset
        }
        previewBlurb
        templateIcon {
            ...contentPlatformImageAsset
        }
        category {
            id
            name
            urlSlug
            shortDescriptionOneLiner
            description
            experiment
        }
        templateType {
            id
            templateTypeName
        }
    }

    fragment contentPlatformOrganization on ContentPlatformOrganization {
        name
        logo {
            ...contentPlatformImageAsset
        }
    }
`;

});

parcelRegister("hR4hv", function(module, exports) {
$parcel$export(module.exports, "assetFragment", function () { return $1fb607c794a66376$export$b91f97eabd541f37; });
const $1fb607c794a66376$export$b91f97eabd541f37 = `
    fragment contentPlatformImageAsset on ContentPlatformTemplateImageAsset {
        __typename
        description
        title
        url
        details
        fileName
        contentType
    }
`;

});

parcelRegister("8UY3F", function(module, exports) {
$parcel$export(module.exports, "LoaderMatchers", function () { return $f98c99f821e1c5d8$export$6a8ace3b32415e83; });
const $f98c99f821e1c5d8$export$6a8ace3b32415e83 = [
    {
        match: /templates$/,
        name: 'confluence-templates-page'
    },
    {
        match: /templates\/search$/,
        name: 'confluence-template-search-page'
    },
    {
        match: /templates\/(?<urlSlug>[a-z0-9-]+)$/,
        name: 'confluence-template-details-page',
        getPageMetadata: ({ templates: templates, urlSlug: urlSlug })=>{
            const template = templates?.find((template)=>template.urlSlug === urlSlug);
            return template ? {
                title: template?.name,
                description: template?.oneLinerHeadline,
                titleSuffix: 'template'
            } : undefined;
        }
    },
    {
        match: /templates\/collections\/(?<urlSlug>[a-z0-9-]+)$/,
        name: 'confluence-template-collection-details-page',
        getPageMetadata: ({ collections: collections, urlSlug: urlSlug })=>{
            const collection = collections?.find((collection)=>collection.urlSlug === urlSlug);
            return collection ? {
                title: collection?.name,
                description: collection?.oneLinerHeadline,
                titleSuffix: 'collection'
            } : undefined;
        }
    },
    {
        match: /templates\/categories\/(?<urlSlug>[a-z0-9-]+)$/,
        name: 'confluence-template-category-page',
        getPageMetadata: ({ categories: categories, urlSlug: urlSlug })=>{
            // use testCategoriesData for now
            const category = categories?.find((category)=>category.urlSlug === urlSlug);
            return category ? {
                title: category?.name,
                description: category?.shortDescriptionOneLiner
            } : undefined;
        }
    },
    {
        match: /customers$/,
        name: 'customers-landing-page'
    }
];

});


parcelRegister("df0Hj", function(module, exports) {
$parcel$export(module.exports, "getCurrentRoute", function () { return $83ee79e725f93420$export$37f66388eb16a733; });

var $80kL5 = parcelRequire("80kL5");
function $83ee79e725f93420$export$37f66388eb16a733() {
    if (typeof window == 'undefined') throw new Error('getCurrentRoute can only be called in the browser');
    // Logic copied from parseRoute in wac-routes.ts
    const noSlashPrefixPath = window.location.pathname.replace(/^\/+/, '');
    const potentialLocale = noSlashPrefixPath.split('/')[0] || '';
    const localeIsValid = (0, $80kL5.isValidLocale)(potentialLocale);
    const locale = localeIsValid ? potentialLocale : 'en';
    return {
        route: window.location.pathname,
        locale: locale
    };
}

});


parcelRegister("dtupn", function(module, exports) {
$parcel$export(module.exports, "SHOW_RECOMMENDED_TEMPLATES_PATH", function () { return $5a243b75609bfed6$export$3b61feff4bda2189; });
$parcel$export(module.exports, "useRecommendedTemplates", function () { return $5a243b75609bfed6$export$c030528d69b775a4; });
$parcel$export(module.exports, "RecommendedTemplatesProvider", function () { return $5a243b75609bfed6$export$b2bb52db5bbf1084; });

var $7VQPk = parcelRequire("7VQPk");

var $lr38U = parcelRequire("lr38U");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $9L6Rz = parcelRequire("9L6Rz");

var $kf4PU = parcelRequire("kf4PU");

var $4U3Z4 = parcelRequire("4U3Z4");

var $2gCne = parcelRequire("2gCne");
const $5a243b75609bfed6$export$3b61feff4bda2189 = '/software/confluence/templates';
const $5a243b75609bfed6$var$RecommendedTemplatesContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    enrolledInRecommended: false,
    recommendedTemplates: [],
    recommendedTemplateIds: [],
    recommendedTemplatesStatus: null,
    adjustedCategories: []
});
const $5a243b75609bfed6$export$c030528d69b775a4 = ()=>{
    const context = (0, $1oC0p.useContext)($5a243b75609bfed6$var$RecommendedTemplatesContext);
    if (!context) throw new Error('useRecommendedTemplates must be used within a RecommendedTemplatesProvider');
    return context;
};
const $5a243b75609bfed6$export$b2bb52db5bbf1084 = ({ children: children })=>{
    const templateCategories = (0, $9L6Rz.useCategories)();
    const templates = (0, $9L6Rz.useTemplates)();
    const [adjustedCategories, setAdjustedCategories] = (0, $1oC0p.useState)(templateCategories);
    const [recommendedTemplates, setRecommendedTemplates] = (0, $1oC0p.useState)([]);
    const [recommendedTemplateIds, setRecommendedTemplateIds] = (0, $1oC0p.useState)([]);
    const [recoTemplatePromiseStatus, setRecoTemplatePromiseStatus] = (0, $1oC0p.useState)(null);
    const term = location.pathname;
    const showRecommendedTemplates = term === $5a243b75609bfed6$export$3b61feff4bda2189 && // Request has finished, and you have recommendations
    recoTemplatePromiseStatus === 'resolved' && recommendedTemplateIds.length > 0;
    (0, $1oC0p.useEffect)(()=>{
        if (showRecommendedTemplates) {
            // remove featured and add recommendations
            const updatedCategories = templateCategories.filter((category)=>category.urlSlug !== 'recommended');
            updatedCategories.unshift((0, $kf4PU.TEMPLATE_CATEGORY_OBJ));
            setAdjustedCategories(updatedCategories);
        } else setAdjustedCategories(templateCategories);
    }, [
        templateCategories,
        showRecommendedTemplates
    ]);
    // Update template categories with recommended category
    (0, $1oC0p.useEffect)(()=>{
        for (const template of templates){
            if (template.category) {
                const index = template.category.findIndex((category)=>category.id === (0, $kf4PU.TEMPLATE_CATEGORY_OBJ).id);
                if (index > -1) template.category.splice(index, 1);
            }
            if (recommendedTemplateIds.includes(template.templateId)) {
                if (!template.category) template.category = [
                    (0, $kf4PU.TEMPLATE_CATEGORY_OBJ)
                ];
                else template.category.push((0, $kf4PU.TEMPLATE_CATEGORY_OBJ));
            }
        }
    }, [
        templates,
        recommendedTemplateIds
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (term === $5a243b75609bfed6$export$3b61feff4bda2189) {
            const aggClient = new (0, $lr38U.AGGClient)({
                gatewayUrl: 'https://www.atlassian.com/gateway/api/graphql'
            });
            let recommendedTemplateIds;
            try {
                recommendedTemplateIds = JSON.parse((0, $2gCne.getLocalStorage)((0, $kf4PU.RECO_TEMPLATE_LOCAL_STORAGE_NAME)));
            } catch (error) {
                console.log(`Error parsing localstorage ${error}`);
            }
            let anonymousId = '';
            try {
                anonymousId = JSON.parse(decodeURIComponent((0, $6GqRO.default).get('ajs_anonymous_id') || `""`));
            } catch (error) {
                console.log(`Error parsing anonymousId ${error}`);
                anonymousId = (0, $6GqRO.default).get('ajs_anonymous_id') || '';
            }
            const url = new URL(window.location.href);
            const paidSearchTerm = url.searchParams.get('keyword');
            const userId = (0, $6GqRO.default).get('__aid_user_id') || '';
            setRecoTemplatePromiseStatus('pending');
            (0, $4U3Z4.getRecommendedTemplates)({
                anonymousId: anonymousId,
                userId: userId,
                aggClient: aggClient,
                recommendedTemplateIds: recommendedTemplateIds,
                custom: {
                    paidSearchTerm: paidSearchTerm
                }
            }).then((recoTemplates)=>{
                setRecommendedTemplateIds(recoTemplates.recommendedTemplateIds);
                setRecommendedTemplates(recoTemplates.templates);
                setRecoTemplatePromiseStatus('resolved');
                (0, $2gCne.setLocalStorage)((0, $kf4PU.RECO_TEMPLATE_LOCAL_STORAGE_NAME), JSON.stringify(recoTemplates.recommendedTemplateIds));
            }).catch((err)=>{
                setRecoTemplatePromiseStatus('rejected');
                console.log(err);
            });
        }
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($5a243b75609bfed6$var$RecommendedTemplatesContext.Provider, {
        value: {
            enrolledInRecommended: term === $5a243b75609bfed6$export$3b61feff4bda2189,
            recommendedTemplates: recommendedTemplates,
            recommendedTemplateIds: recommendedTemplateIds,
            recommendedTemplatesStatus: recoTemplatePromiseStatus,
            adjustedCategories: adjustedCategories
        },
        children: children
    });
};

});


parcelRegister("9RqQh", function(module, exports) {
$parcel$export(module.exports, "TemplateCard", function () { return $c2dc346c0b5d6811$export$ba340e850b866867; });
/* template-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("20OkY");
var $7gFRR = parcelRequire("7gFRR");

var $cml5G = parcelRequire("cml5G");

var $4QdnC = parcelRequire("4QdnC");

var $lRFwv = parcelRequire("lRFwv");

var $fCblX = parcelRequire("fCblX");

var $iHYHa = parcelRequire("iHYHa");
parcelRequire("kbpa7");
var $bNzAT = parcelRequire("bNzAT");

var $jQ0cd = parcelRequire("jQ0cd");

var $isyQr = parcelRequire("isyQr");
const $c2dc346c0b5d6811$var$fontCharlieText = `"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $c2dc346c0b5d6811$var$fontCharlieDisplay = `"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $c2dc346c0b5d6811$var$templateCardContainerStyles = null;
const $c2dc346c0b5d6811$var$templateCardInfoStyles = null;
const $c2dc346c0b5d6811$var$templateCardInfoWrapper = null;
const $c2dc346c0b5d6811$var$templateCardTitleStyles = null;
const $c2dc346c0b5d6811$var$templateCardDescriptionStyles = null;
const $c2dc346c0b5d6811$var$templateCardActionStyles = null;
const $c2dc346c0b5d6811$var$templateCardActionOverlayStyles = null;
const $c2dc346c0b5d6811$var$templateCardLearnMoreStyles = null;
const $c2dc346c0b5d6811$var$templatePreviewStyles = null;
const $c2dc346c0b5d6811$var$templateImageWrapper = null;
const $c2dc346c0b5d6811$var$templateCardLearnMoreLinkStyle = null;
const $c2dc346c0b5d6811$var$templateCardInfoHeaderAuthorStyles = null;
const $c2dc346c0b5d6811$export$ba340e850b866867 = ({ template: template, background: background })=>{
    const intl = (0, $8e22h.default)();
    const learnMoreHref = (0, $jQ0cd.useLocalizedHref)(`/software/confluence/templates/${template.urlSlug}`);
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const author = (0, $fCblX.isAuthor)(template) ? template.contributor : null;
    const companyName = (0, $fCblX.isAuthor)(template) ? author?.organization?.name : template.contributor?.name;
    const templateName = intl.formatMessage((0, $cml5G.ConfluenceTemplateMessages).templateTitle, {
        templateName: template.name ?? ''
    });
    const handleCardClick = ()=>{
        const templateId = template.pluginModuleKey ?? '';
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'linkButton',
            attributes: {
                templateName: templateName,
                label: templateName,
                path: location.pathname,
                event_type: 'ui',
                url: location.href,
                product: (0, $7gFRR.ProductKeys).CONFLUENCE,
                templateId: templateId,
                sandbox: true,
                trackEventName: 'wac.showroom.clicked-use-template'
            }
        }).fire();
        openModalForTemplate({
            templateId: templateId,
            templateName: templateName,
            productKey: (0, $7gFRR.ProductKeys).CONFLUENCE
        });
    };
    const imgSrc = (0, $isyQr.templateSvgLinks)[template.urlSlug ?? ''] ?? `https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/taxonomy/${template.urlSlug}.svg`;
    const defaultImgSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/p17h52fiv34d06123v38e23cbi421x61.svg';
    const handleImageError = (event)=>{
        if (event.currentTarget.src !== defaultImgSrc) event.currentTarget.src = defaultImgSrc;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-templates-card",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-cs-override-id": `template-card-container-${template.templateId}`,
            className: (0, $2jatx.default)([
                "_kqswh2mm _2rkoi2wt _1bsb1feq _1tke1kdj _16qs58tj _1reo15vq _18m915vq _vchhusvi _v5641vti _1dbzdtw3 _am7mtxnc _1owrg7ng _12rrnklw _1llynklw"
            ]),
            style: {
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light100'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-cs-override-id": `template-card-${template.templateId}`,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1yb4 _1reo15vq _18m915vq _4t3i1osq _1wpz1fhb"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_16jlidpf _1o9zkb7n _i0dluuw1 _1reo15vq _18m915vq _938ridpf _1tihkb7n _1oqbuuw1 _1lrw1dfr _12vemgnk _1o9zidpf",
                                "_11q7izeb",
                                "templateHoverStyles"
                            ]),
                            style: {
                                "--_1k9t07z": (0, $6ZVlx.default)(background)
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                src: imgSrc,
                                alt: "",
                                onError: handleImageError,
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _ca0q1tcg _u5f31tcg _n3tdidpf _19bv1tcg"
                                ])
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            onClick: handleCardClick,
                            "data-testid": "template-card-clickable",
                            className: (0, $2jatx.default)([
                                "_1pbykb7n _16jlkb7n _1o9zkb7n _i0dlf1ug _bfhk1afi _1e0c1txw _2lx21bp4 _1bah1yb4 _ca0q1tcg _u5f3idpf _n3tdidpf _19bv1tcg _2rkoi2wt _80omtlke _4t3i1osq"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_ect41bwv _1wybgktf _k48p1fw0 _vwz41ul9 _1dyznl7k _syazqlpt _19pkidpf _2hwxidpf _otyridpf _18u0idpf _16liqslr _1rf11f4h"
                                    ]),
                                    children: template.name
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_ect41fn2 _1wyb7vkz _k48p1nn1 _vwz41tcg _syaz1bqd _ca0qftgi _u5f31tcg _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _17gq183y"
                                    ]),
                                    children: template.previewBlurb
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: companyName && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_ect41fn2 _1wybdlk8 _k48p1nn1 _vwz4gktf _ca0q7vkz _u5f31tcg _n3td7vkz _19bvidpf _syazk0sw"
                                        ]),
                                        style: {
                                            "--_1e97w25": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light700'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            ...(0, $cml5G.ConfluenceTemplateMessages).templateAuthorBy,
                                            values: {
                                                author: companyName
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1nrf _2rko1y44 _bfhk1ret _v564yoi0 _tzy4idpf _1vkhmlf1 _1g6w1ssb",
                        "templateHoverStyles"
                    ]),
                    "data-cs-override-id": `template-card-actions-${template.templateId}`,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1osq _kqswh2mm _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1h6o _zulpgktf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: learnMoreHref,
                                ...(0, $lRFwv.ConfluenceTemplateAnalytics).learnMoreButton(template.urlSlug, 'template'),
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _1e02idpf _u7coidpf _rjxpidpf"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4QdnC.UseTemplateButton), {
                                templateName: templateName,
                                blueprintModuleKey: template.pluginModuleKey
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_syaz5hrz _19itglyw _lcxvglyw _1bah1h6o _4cvr1h6o _ect41fn2 _1wybdlk8 _k48pni7l _vwz4gktf _zulp1y44"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $bNzAT.default)('color.primary.blue'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...(0, $cml5G.ConfluenceTemplateMessages).cardLearnMore
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("fCblX", function(module, exports) {
$parcel$export(module.exports, "isAuthor", function () { return $391d0ced7072d175$export$d5c768d72e587443; });
$parcel$export(module.exports, "getTemplateByLine", function () { return $391d0ced7072d175$export$3318e3b3ab5bcdc4; });
$parcel$export(module.exports, "getTemplateType", function () { return $391d0ced7072d175$export$ce187cada8d3b1f0; });

var $1wldG = parcelRequire("1wldG");

var $ePBzs = parcelRequire("ePBzs");
function $391d0ced7072d175$export$d5c768d72e587443(template) {
    return template.contributor?.organization !== undefined || template.contributor?.jobTitle !== undefined;
}
function $391d0ced7072d175$export$3318e3b3ab5bcdc4(template) {
    const author = $391d0ced7072d175$export$d5c768d72e587443(template) ? template.contributor : null;
    // Default to name from contributor if author is not available
    let contributorName = template.contributor?.name;
    if (author) {
        const authorDetail = $391d0ced7072d175$export$4357a7c301f06195(author);
        if (authorDetail) contributorName += `, ${authorDetail}`;
    }
    return contributorName ?? undefined;
}
function $391d0ced7072d175$export$4357a7c301f06195(author) {
    // Default to name from contributor if author is not available
    let authorDetail = author.jobTitle;
    if (!authorDetail) return undefined;
    if (author.organization?.name) {
        if (authorDetail) authorDetail += ' @ ';
        authorDetail += author.organization.name;
    }
    return authorDetail ?? undefined;
}
function $391d0ced7072d175$export$bc1a36214c5a02e2(categoriesToDisplay) {
    return categoriesToDisplay.sort((a, b)=>{
        const indexA = (0, $ePBzs.CategoryOrder)[a.urlSlug] !== undefined ? (0, $ePBzs.CategoryOrder)[a.urlSlug] : Number.MAX_VALUE;
        const indexB = (0, $ePBzs.CategoryOrder)[b.urlSlug] !== undefined ? (0, $ePBzs.CategoryOrder)[b.urlSlug] : Number.MAX_VALUE;
        return indexA - indexB;
    });
}
function $391d0ced7072d175$export$ce187cada8d3b1f0(template) {
    const templateType = template.templateType ? template.templateType[0] : {
        id: null,
        templateTypeName: null
    };
    return {
        type: templateType?.id === '1HlskYfRNciSnQ02SDhCPs' ? (0, $1wldG.TemplateType).Whiteboard : (0, $1wldG.TemplateType).Page,
        label: templateType?.templateTypeName ?? (0, $1wldG.TemplateType).Page
    };
}

});
parcelRegister("1wldG", function(module, exports) {
$parcel$export(module.exports, "TemplateType", function () { return $851cc27419758cdb$export$fd0446c06165ed92; });
var $851cc27419758cdb$export$fd0446c06165ed92 = /*#__PURE__*/ function(TemplateType) {
    TemplateType["Page"] = "page";
    TemplateType["Whiteboard"] = "whiteboard";
    return TemplateType;
}({});

});





parcelRegister("dLCMY", function(module, exports) {
$parcel$export(module.exports, "TemplateCategorySearchResults", function () { return $851687a580222563$export$23b7cd6a76b2bbac; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $ePBzs = parcelRequire("ePBzs");

var $3dnVb = parcelRequire("3dnVb");

var $2lca6 = parcelRequire("2lca6");

var $7t71d = parcelRequire("7t71d");
const $851687a580222563$export$23b7cd6a76b2bbac = ({ preloadedSearchResults: preloadedSearchResults, searchTerm: searchTerm, searchKey: searchKey })=>{
    const locale = (0, $3dnVb.useQueryLocale)();
    const searchQuery = (0, $1oC0p.useMemo)(()=>(0, $2lca6.parseSearchQuery)(searchTerm), [
        searchTerm
    ]);
    const sortLookup = (0, $ePBzs.CategoryTemplateOrder)[searchTerm.id] ?? 'name';
    return preloadedSearchResults ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7t71d.TemplatePaginatedSearchResults), {
        initialSearchResults: preloadedSearchResults,
        urlSlugs: searchQuery.whereClause?.['urlSlugs'] ?? [],
        templateIds: searchQuery.whereClause?.['templateIds'] ?? [],
        categoryUrlSlugs: searchQuery.whereClause?.['categoryUrlSlugs'] ?? [],
        limit: searchQuery.first,
        skip: 0,
        locale: locale,
        sortLookup: sortLookup,
        wasPreloaded: true
    }, searchKey) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2lca6.TemplateInitialSearchResults), {
        searchKey: searchKey,
        urlSlugs: searchQuery.whereClause?.['urlSlugs'] ?? [],
        templateIds: searchQuery.whereClause?.['templateIds'] ?? [],
        categoryUrlSlugs: searchQuery.whereClause?.['categoryUrlSlugs'] ?? [],
        limit: searchQuery.first,
        skip: 0,
        locale: locale,
        sortLookup: sortLookup
    });
};

});

parcelRegister("he4zb", function(module, exports) {
$parcel$export(module.exports, "TemplateFuzzySearchResults", function () { return $6c0a39117283dd45$export$7dd0ac5165a78454; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $djfBw = parcelRequire("djfBw");

var $f3gS9 = parcelRequire("f3gS9");

var $ePBzs = parcelRequire("ePBzs");

var $377u5 = parcelRequire("377u5");

var $3dnVb = parcelRequire("3dnVb");

var $2lca6 = parcelRequire("2lca6");
function $6c0a39117283dd45$var$parseSearchQueryFromSuggestions(templateMatches, categoryMatches) {
    const filters = {
        templateIds: [],
        urlSlugs: [],
        categoryUrlSlugs: []
    };
    const templateIds = templateMatches.map((result)=>result.id).filter((id)=>typeof id === 'string');
    if (templateIds.length > 0) filters['urlSlugs'] = templateIds;
    const categoryIds = categoryMatches.map((result)=>result.id).filter((id)=>typeof id === 'string');
    if (categoryIds.length > 0) filters['categoryUrlSlugs'] = categoryIds;
    return {
        whereClause: filters
    };
}
const $6c0a39117283dd45$export$7dd0ac5165a78454 = ({ searchTerm: searchTerm, searchKey: searchKey })=>{
    const locale = (0, $3dnVb.useQueryLocale)();
    const suggestionData = (0, $f3gS9.useLazyLoadQuery)((0, $377u5.UseSearchSuggestionsQuery), {
        locale: locale
    });
    const fuse = (0, $1oC0p.useMemo)(()=>{
        return new (0, $djfBw.default)([
            ...(0, $377u5.parseTemplateSearchItems)(suggestionData.productTemplateCollection),
            ...(0, $377u5.parseCategorySearchItems)(suggestionData.categories)
        ], (0, $377u5.FUSE_OPTIONS));
    }, [
        suggestionData
    ]);
    const [templateMatches, categoryMatches] = (0, $1oC0p.useMemo)(()=>{
        const matches = fuse.search(typeof searchTerm === 'string' ? searchTerm : searchTerm.name ?? searchTerm.id)// Sort by score in descending order
        // Lower scores are a better match
        .sort((a, b)=>(a.score ?? Infinity) - (b.score ?? Infinity)).map((result)=>result.item);
        return matches.slice(0, 35) // Get the top 35 results
        .reduce((acc, result)=>{
            if (result.type === 'template') acc[0].push(result);
            else if (result.type === 'category') acc[1].push(result);
            return acc;
        }, [
            [],
            []
        ]);
    }, [
        fuse,
        searchTerm
    ]);
    const sortLookup = (0, $1oC0p.useMemo)(()=>{
        const lookup = {};
        let rank = 1;
        // Rank template matches before category matches.
        for (const template of templateMatches)if (template.type === 'template') {
            lookup[template.id] = rank;
            rank++;
        }
        // Use hardcoded category order for ranking category matches.
        for (const category of categoryMatches)if (category.type === 'category') {
            const categoryLookup = (0, $ePBzs.CategoryTemplateOrder)[category.id];
            if (categoryLookup) {
                for(const slug in categoryLookup)// Exclude templates that are already ranked.
                if (!(slug in lookup)) {
                    lookup[slug] = rank;
                    rank++;
                }
            }
        }
        return lookup;
    }, [
        categoryMatches,
        templateMatches
    ]);
    const searchQuery = (0, $1oC0p.useMemo)(()=>{
        return $6c0a39117283dd45$var$parseSearchQueryFromSuggestions(templateMatches, categoryMatches);
    }, [
        categoryMatches,
        templateMatches
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2lca6.TemplateInitialSearchResults), {
        searchKey: searchKey,
        urlSlugs: searchQuery.whereClause?.['urlSlugs'] ?? [],
        templateIds: searchQuery.whereClause?.['templateIds'] ?? [],
        categoryUrlSlugs: searchQuery.whereClause?.['categoryUrlSlugs'] ?? [],
        limit: Object.keys(sortLookup).length,
        skip: 0,
        locale: locale,
        sortLookup: sortLookup
    });
};

});

parcelRegister("ax6BG", function(module, exports) {
$parcel$export(module.exports, "TemplateRecommendationsSearchResults", function () { return $1782885cd2f70cf1$export$4ad333e0617c8599; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $ePBzs = parcelRequire("ePBzs");

var $3dnVb = parcelRequire("3dnVb");

var $4BkXJ = parcelRequire("4BkXJ");

var $2lca6 = parcelRequire("2lca6");
function $1782885cd2f70cf1$export$e8ce39216243ee23(location) {
    let anonymousId = '';
    try {
        anonymousId = JSON.parse(decodeURIComponent((0, $6GqRO.default).get('ajs_anonymous_id') || `""`));
    } catch (error) {
        console.log(`Error parsing anonymousId ${error}`);
        anonymousId = (0, $6GqRO.default).get('ajs_anonymous_id') || '';
    }
    return {
        // NOTE: There is a hardcoded exemption in GRS to return nothing when
        // the first 9 recommendations match a default set. This appears to have
        // been a specific ask, but is nonetheless very unexpected.
        // See: https://atlassian.slack.com/archives/C053051JN9Y/p1729642717332069?thread_ts=1729620526.565589&cid=C053051JN9Y
        first: 9,
        context: {
            useCase: 'wacConfluenceTemplates',
            product: 'marketing',
            anonymousId: anonymousId,
            userId: (0, $6GqRO.default).get('__aid_user_id') || '',
            custom: {
                paidSearchTerm: new URLSearchParams(location.search).get('keyword')
            }
        }
    };
}
const $1782885cd2f70cf1$export$4ad333e0617c8599 = /*#__PURE__*/ (0, $1oC0p.memo)(()=>{
    const recommendationData = (0, $4BkXJ.useSearchRecommendations)();
    const locale = (0, $3dnVb.useQueryLocale)();
    const searchQuery = (0, $1oC0p.useMemo)(()=>{
        return (0, $2lca6.parseSearchQuery)(// @ts-ignore
        recommendationData.growthRecommendations?.recommendations?.data?.map(// @ts-ignore
        (rec)=>rec.entityId) ?? {
            type: 'category',
            id: 'recommended'
        });
    }, [
        recommendationData
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2lca6.TemplateInitialSearchResults), {
        searchKey: "recommended",
        urlSlugs: searchQuery.whereClause?.['urlSlugs'] ?? [],
        templateIds: searchQuery.whereClause?.['templateIds'] ?? [],
        categoryUrlSlugs: searchQuery.whereClause?.['categoryUrlSlugs'] ?? [],
        sortLookup: (0, $ePBzs.CategoryTemplateOrder)['recommended'],
        limit: searchQuery.first,
        skip: 0,
        locale: locale
    });
});

});
parcelRegister("4BkXJ", function(module, exports) {
$parcel$export(module.exports, "useSearchRecommendations", function () { return $d81c68e88ee96463$export$78466b24e0df5979; });

var $6GqRO = parcelRequire("6GqRO");

var $f3gS9 = parcelRequire("f3gS9");

var $gRpMo = parcelRequire("gRpMo");
var $d81c68e88ee96463$var$_useSearchRecommendationsQuery;
function $d81c68e88ee96463$var$getTemplateRecommendationsSearchResultsQueryVars(location) {
    let anonymousId = '';
    try {
        anonymousId = JSON.parse(decodeURIComponent((0, $6GqRO.default).get('ajs_anonymous_id') || `""`));
    } catch (error) {
        console.log(`Error parsing anonymousId ${error}`);
        anonymousId = (0, $6GqRO.default).get('ajs_anonymous_id') || '';
    }
    return {
        // NOTE: There is a hardcoded exemption in GRS to return nothing when
        // the first 9 recommendations match a default set. This appears to have
        // been a specific ask, but is nonetheless very unexpected.
        // See: https://atlassian.slack.com/archives/C053051JN9Y/p1729642717332069?thread_ts=1729620526.565589&cid=C053051JN9Y
        first: 9,
        context: {
            useCase: 'wacConfluenceTemplates',
            product: 'marketing',
            anonymousId: anonymousId,
            userId: (0, $6GqRO.default).get('__aid_user_id') || '',
            custom: {
                paidSearchTerm: new URLSearchParams(location.search).get('keyword')
            }
        }
    };
}

const $d81c68e88ee96463$var$TemplateRecommendationsSearchResultsRelayQuery = $d81c68e88ee96463$var$_useSearchRecommendationsQuery !== void 0 ? $d81c68e88ee96463$var$_useSearchRecommendationsQuery : ($d81c68e88ee96463$var$_useSearchRecommendationsQuery = (parcelRequire("eNEq4")), $d81c68e88ee96463$var$_useSearchRecommendationsQuery.hash && $d81c68e88ee96463$var$_useSearchRecommendationsQuery.hash !== "d1325379d7100beb456ed1b6e5bc220a" && console.error("The definition of 'useSearchRecommendationsQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $d81c68e88ee96463$var$_useSearchRecommendationsQuery);
const $d81c68e88ee96463$export$78466b24e0df5979 = async ()=>{
    const GATEWAY_URL = 'https://www.atlassian.com/gateway/api/graphql';
    const fetchGraphQL = async (request, variables)=>{
        const resp = await fetch(GATEWAY_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: request.text,
                variables: variables
            })
        });
        if (!resp.ok) throw new Error('Response failed.');
        return await resp.json();
    };
    const environment = new (0, $gRpMo.Environment)({
        store: new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)({})),
        network: (0, $gRpMo.Network).create(fetchGraphQL)
    });
    const recommendationData = await (0, $f3gS9.fetchQuery)(environment, $d81c68e88ee96463$var$TemplateRecommendationsSearchResultsRelayQuery, $d81c68e88ee96463$var$getTemplateRecommendationsSearchResultsQueryVars(window.location)).toPromise().then((data)=>data).catch((error)=>{
        console.log(error);
    });
    return recommendationData;
};

});
parcelRegister("eNEq4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $5f0d994aa02441f5$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<6d28712e82d6c72896f0d668ad724ac4>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f0d994aa02441f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityId",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "useSearchRecommendationsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSearchRecommendationsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "0ef28162efabf00e4a9717b186eded38",
            "id": null,
            "metadata": {},
            "name": "useSearchRecommendationsQuery",
            "operationKind": "query",
            "text": "query useSearchRecommendationsQuery(\n  $context: GrowthRecContext!\n  $first: Int\n) {\n  growthRecommendations {\n    recommendations(first: $first, context: $context) {\n      __typename\n      ... on GrowthRecRecommendations {\n        data {\n          __typename\n          entityId\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$5f0d994aa02441f5$var$node.hash = "d1325379d7100beb456ed1b6e5bc220a";
var $5f0d994aa02441f5$export$2e2bcd8739ae039 = $5f0d994aa02441f5$var$node;

});




parcelRegister("gO9l2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $27b1967c5d15897a$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<87994347e55657a50a8d6fbf72f56ce2>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $27b1967c5d15897a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryUrlSlugs"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSearch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "partnerTemplatesDataUrlSlugs"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skip"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "urlSlugs"
    }, v8 = {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 50
        },
        v8 /*: any*/ 
    ], v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v13 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        }
    ], v14 = {
        "alias": "categories",
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 400
            },
            v8 /*: any*/ 
        ],
        "concreteType": "ProductTemplateCollection",
        "kind": "LinkedField",
        "name": "productTemplateCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplate",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 10
                            }
                        ],
                        "concreteType": "ProductTemplateCategoryCollection",
                        "kind": "LinkedField",
                        "name": "categoryCollection",
                        "plural": false,
                        "selections": [
                            v10 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaxonomyTemplateCategory",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    v11 /*: any*/ ,
                                    v12 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "categoryNameExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "shortDescriptionOneLiner",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "experiment",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "allowedLocales",
                                                "value": [
                                                    "en-US",
                                                    "es",
                                                    "ja-JP",
                                                    "pt-BR",
                                                    "fr-FR",
                                                    "de-DE",
                                                    "nl-NL",
                                                    "it-IT",
                                                    "ko-KR",
                                                    "pl-PL",
                                                    "ru-RU",
                                                    "zh-CN"
                                                ]
                                            }
                                        ],
                                        "concreteType": "TaxonomyTemplateCategoryLinkingCollections",
                                        "kind": "LinkedField",
                                        "name": "linkedFrom",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": v13 /*: any*/ ,
                                                "concreteType": "ProductTemplateCollection",
                                                "kind": "LinkedField",
                                                "name": "productTemplateCollection",
                                                "plural": false,
                                                "selections": [
                                                    v10 /*: any*/ 
                                                ],
                                                "storageKey": "productTemplateCollection(limit:1)"
                                            }
                                        ],
                                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "categoryCollection(limit:10)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v15 = [
        v8 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "urlSlug_in",
                    "variableName": "partnerTemplatesDataUrlSlugs"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v16 = {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
    }, v17 = {
        "kind": "Variable",
        "name": "skip",
        "variableName": "skip"
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "templateNameExternal",
        "storageKey": null
    }, v20 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "confluenceTemplatesUnifiedContentfulRelayPageQuery",
            "selections": [
                {
                    "alias": "collections",
                    "args": v9 /*: any*/ ,
                    "concreteType": "TemplateCollectionCollection",
                    "kind": "LinkedField",
                    "name": "templateCollectionCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateCollection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "collectionCardCarouselContentfulRelayFragment"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v14 /*: any*/ ,
                {
                    "alias": "partnerTemplates",
                    "args": v15 /*: any*/ ,
                    "concreteType": "ProductTemplateCollection",
                    "kind": "LinkedField",
                    "name": "productTemplateCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "partnerTemplateCardCarouselContentfulRelayFragment"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "condition": "isSearch",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "categoryUrlSlugs",
                                                "variableName": "categoryUrlSlugs"
                                            },
                                            v16 /*: any*/ ,
                                            v8 /*: any*/ ,
                                            v17 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "templateIds",
                                                "variableName": "templateIds"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "urlSlugs",
                                                "variableName": "urlSlugs"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "templatePaginatedSearchResultsContentfulRelayRefetchableFragment"
                                    }
                                ],
                                "type": "Query",
                                "abstractKey": null
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "preloadedSearchResults"
                        }
                    ]
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "confluenceTemplatesUnifiedContentfulRelayPageQuery",
            "selections": [
                {
                    "alias": "collections",
                    "args": v9 /*: any*/ ,
                    "concreteType": "TemplateCollectionCollection",
                    "kind": "LinkedField",
                    "name": "templateCollectionCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateCollection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v11 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "collectionNameExternal",
                                    "storageKey": null
                                },
                                v12 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Asset",
                                    "kind": "LinkedField",
                                    "name": "collectionIcon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CollectionGuide",
                                    "kind": "LinkedField",
                                    "name": "howToUseThisCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CollectionGuideCollectionStepsCollection",
                                            "kind": "LinkedField",
                                            "name": "collectionStepsCollection",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v18 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v14 /*: any*/ ,
                {
                    "alias": "partnerTemplates",
                    "args": v15 /*: any*/ ,
                    "concreteType": "ProductTemplateCollection",
                    "kind": "LinkedField",
                    "name": "productTemplateCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "oneLinerHeadline",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "condition": "isSearch",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "templates",
                            "args": [
                                v16 /*: any*/ ,
                                v8 /*: any*/ ,
                                v17 /*: any*/ ,
                                {
                                    "fields": [
                                        {
                                            "items": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "urlSlug_in",
                                                            "variableName": "urlSlugs"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "OR.0"
                                                },
                                                {
                                                    "fields": [
                                                        {
                                                            "fields": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "id_in",
                                                                    "variableName": "templateIds"
                                                                }
                                                            ],
                                                            "kind": "ObjectValue",
                                                            "name": "sys"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "OR.1"
                                                },
                                                {
                                                    "fields": [
                                                        {
                                                            "fields": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "urlSlug_in",
                                                                    "variableName": "categoryUrlSlugs"
                                                                }
                                                            ],
                                                            "kind": "ObjectValue",
                                                            "name": "category"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "OR.2"
                                                }
                                            ],
                                            "kind": "ListValue",
                                            "name": "OR"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "where"
                                }
                            ],
                            "concreteType": "ProductTemplateCollection",
                            "kind": "LinkedField",
                            "name": "productTemplateCollection",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplate",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "ProductTemplateProductCollection",
                                            "kind": "LinkedField",
                                            "name": "productCollection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProductListing",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ProductName",
                                                            "kind": "LinkedField",
                                                            "name": "productNameReference",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "productNameId",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "productCollection(limit:1)"
                                        },
                                        v19 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "pluginModuleKey",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "previewBlurb",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductTemplateTemplateTypeCollection",
                                            "kind": "LinkedField",
                                            "name": "templateTypeCollection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TaxonomyTemplateType",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "templateTypeNameExternal",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "contributor",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CompanyNameInternal",
                                                            "kind": "LinkedField",
                                                            "name": "organization",
                                                            "plural": false,
                                                            "selections": v20 /*: any*/ ,
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "Author",
                                                    "abstractKey": null
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v20 /*: any*/ ,
                                                    "type": "CompanyNameInternal",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                v10 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f7e0983cf6c22e16df9a03db88467a5a",
            "id": null,
            "metadata": {},
            "name": "confluenceTemplatesUnifiedContentfulRelayPageQuery",
            "operationKind": "query",
            "text": "query confluenceTemplatesUnifiedContentfulRelayPageQuery(\n  $locale: String!\n  $partnerTemplatesDataUrlSlugs: [String!]!\n  $urlSlugs: [String!]!\n  $templateIds: [String!]!\n  $categoryUrlSlugs: [String!]!\n  $limit: Int!\n  $skip: Int!\n  $isSearch: Boolean = false\n) {\n  collections: templateCollectionCollection(limit: 50, locale: $locale) {\n    items {\n      ...collectionCardCarouselContentfulRelayFragment\n    }\n  }\n  categories: productTemplateCollection(limit: 400, locale: $locale) {\n    items {\n      categoryCollection(limit: 10) {\n        total\n        items {\n          sys {\n            id\n          }\n          urlSlug\n          categoryNameExternal\n          shortDescriptionOneLiner\n          experiment\n          linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n            productTemplateCollection(limit: 1) {\n              total\n            }\n          }\n        }\n      }\n    }\n  }\n  partnerTemplates: productTemplateCollection(locale: $locale, where: {urlSlug_in: $partnerTemplatesDataUrlSlugs}) {\n    items {\n      ...partnerTemplateCardCarouselContentfulRelayFragment\n    }\n  }\n  ...templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P @skip(if: $isSearch)\n}\n\nfragment collectionCardCarouselContentfulRelayFragment on TemplateCollection {\n  sys {\n    id\n  }\n  ...collectionCardContentfulRelayFragment\n}\n\nfragment collectionCardContentfulRelayFragment on TemplateCollection {\n  sys {\n    id\n  }\n  collectionNameExternal\n  urlSlug\n  collectionIcon {\n    url\n  }\n  howToUseThisCollection {\n    collectionStepsCollection {\n      total\n      __typename\n    }\n  }\n}\n\nfragment partnerTemplateCardCarouselContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  urlSlug\n  ...partnerTemplateCardContentfulRelayFragment\n}\n\nfragment partnerTemplateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  urlSlug\n  templateNameExternal\n  oneLinerHeadline\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P on Query {\n  templates: productTemplateCollection(limit: $limit, skip: $skip, locale: $locale, where: {OR: [{urlSlug_in: $urlSlugs}, {sys: {id_in: $templateIds}}, {category: {urlSlug_in: $categoryUrlSlugs}}]}) {\n    items {\n      sys {\n        id\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      templateNameExternal\n      urlSlug\n      ...templateCardContentfulRelayFragment\n    }\n    total\n  }\n}\n"
        }
    };
}();
$27b1967c5d15897a$var$node.hash = "07a7f8b979e3e44fe68d35fcfbf01207";
var $27b1967c5d15897a$export$2e2bcd8739ae039 = $27b1967c5d15897a$var$node;

});





parcelRegister("hZy36", function(module, exports) {
$parcel$export(module.exports, "configureCastle", function () { return $1c83f3417492b7df$export$4e4a638d8f40206a; });
$parcel$export(module.exports, "getCastleRequestToken", function () { return $1c83f3417492b7df$export$8cbdca1a2ad79c4e; });
$parcel$export(module.exports, "sendCastleCustomEvent", function () { return $1c83f3417492b7df$export$a9c930ba925786ea; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
let $1c83f3417492b7df$var$isCastleConfigured = false;
let $1c83f3417492b7df$var$castleSdkPromise = null;
let $1c83f3417492b7df$var$configurePromise = null;
const $1c83f3417492b7df$var$NORMALIZED_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $1c83f3417492b7df$var$MAX_EMAIL_LENGTH = 254;
const $1c83f3417492b7df$var$normalizeCastleEmail = (email)=>{
    if (!email) return undefined;
    const trimmed = email.trim().toLowerCase();
    if (trimmed.length === 0 || trimmed.length > $1c83f3417492b7df$var$MAX_EMAIL_LENGTH) return undefined;
    if (!$1c83f3417492b7df$var$NORMALIZED_EMAIL_PATTERN.test(trimmed)) return undefined;
    return trimmed;
};
const $1c83f3417492b7df$export$911ef79b11287758 = ()=>"pk_GZyDdbqtYhpAqRAwJj8pWZVJWauqK6qE";

const $1c83f3417492b7df$var$loadCastleSdk = ()=>{
    if (typeof window === 'undefined') return Promise.resolve(null);
    if (!$1c83f3417492b7df$var$castleSdkPromise) $1c83f3417492b7df$var$castleSdkPromise = (parcelRequire("c5mWC")).then(({ configure: configure, custom: custom, createRequestToken: createRequestToken })=>({
            configure: configure,
            custom: custom,
            createRequestToken: createRequestToken
        })).catch(()=>{
        console.error('Failed to load Castle SDK');
        $1c83f3417492b7df$var$castleSdkPromise = null;
        return null;
    });
    return $1c83f3417492b7df$var$castleSdkPromise;
};
const $1c83f3417492b7df$var$dispatchCastleCustomEvent = (Castle, { name: name, properties: properties, email: email })=>{
    try {
        const normalizedEmail = $1c83f3417492b7df$var$normalizeCastleEmail(email);
        if (!normalizedEmail) return;
        Promise.resolve(Castle.custom({
            name: name,
            properties: properties,
            user: {
                id: normalizedEmail,
                email: normalizedEmail
            }
        })).catch(()=>{
            console.error('Failed to send Castle custom event');
        });
    } catch  {
        console.error('Failed to send Castle custom event');
    }
};
const $1c83f3417492b7df$export$4e4a638d8f40206a = ()=>{
    if (typeof window === 'undefined') return;
    const publishableKey = $1c83f3417492b7df$export$911ef79b11287758();
    if (!publishableKey || $1c83f3417492b7df$var$configurePromise) return;
    $1c83f3417492b7df$var$configurePromise = $1c83f3417492b7df$var$loadCastleSdk().then((Castle)=>{
        if (!Castle || $1c83f3417492b7df$var$isCastleConfigured) return;
        try {
            Castle.configure({
                pk: publishableKey,
                throttling: false
            });
            $1c83f3417492b7df$var$isCastleConfigured = true;
        } catch  {
            console.error('Failed to configure Castle');
        }
    }).catch(()=>{
        console.error('Failed to configure Castle');
    });
};
const $1c83f3417492b7df$export$74269be236d4f24 = 100;
const $1c83f3417492b7df$export$8cbdca1a2ad79c4e = async (timeoutMs = $1c83f3417492b7df$export$74269be236d4f24)=>{
    if (typeof window === 'undefined') return undefined;
    if (!(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).castleIoEvent)) return undefined;
    if (!$1c83f3417492b7df$var$isCastleConfigured || !$1c83f3417492b7df$var$castleSdkPromise) return undefined;
    let timeoutId;
    try {
        const timeoutPromise = new Promise((resolve)=>{
            timeoutId = setTimeout(()=>resolve(undefined), timeoutMs);
        });
        const tokenPromise = $1c83f3417492b7df$var$castleSdkPromise.then(async (Castle)=>{
            if (!Castle) return undefined;
            try {
                const token = await Castle.createRequestToken();
                return typeof token === 'string' && token.length > 0 ? token : undefined;
            } catch  {
                return undefined;
            }
        });
        return await Promise.race([
            tokenPromise,
            timeoutPromise
        ]);
    } catch  {
        return undefined;
    } finally{
        if (timeoutId) clearTimeout(timeoutId);
    }
};
const $1c83f3417492b7df$export$a9c930ba925786ea = (event)=>{
    if (typeof window === 'undefined') return;
    if (!(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).castleIoEvent)) return;
    if (!$1c83f3417492b7df$var$isCastleConfigured || !$1c83f3417492b7df$var$castleSdkPromise) return;
    $1c83f3417492b7df$var$castleSdkPromise.then((Castle)=>{
        if (Castle) $1c83f3417492b7df$var$dispatchCastleCustomEvent(Castle, event);
    }).catch(()=>{
        console.error('Failed to send Castle custom event');
    });
};

});
parcelRegister("c5mWC", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("lFGVE").then(()=>parcelRequire('jmPwX'));

});


parcelRegister("3H7QB", function(module, exports) {
$parcel$export(module.exports, "DynamicConfigClient", function () { return $8fcb6be624dadaa4$export$5c4400ca98bd0186; });

var $bzwLA = parcelRequire("bzwLA");
var $gH5tc = parcelRequire("gH5tc");
/**
 * FFS base URL — sourced from `STATSIG_FFS_BASE_URL` defined in
 * `services/wac-web/.env.{production|dev|staging|local}` and inlined at
 * build time. Defined inline (vs. switching on NODE_ENV) so the env file
 * is the single source of truth.
 */ const $8fcb6be624dadaa4$var$getFfsBaseUrl = ()=>"https://api.atlassian.com/flags" ?? '';
/**
 * FFS API key — sourced from `FEATURE_GATES_KEY` defined in
 * `services/wac-web/.env.{production|dev|staging|local}` and inlined at
 * build time.
 */ const $8fcb6be624dadaa4$var$getFfsApiKey = ()=>"4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f" ?? '';
class $8fcb6be624dadaa4$export$5c4400ca98bd0186 {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor, @typescript-eslint/no-empty-function
    constructor(){
        this.collection = (0, $gH5tc.ConfigCollection).empty();
        this.initialized = false;
    // Singleton: instances are only created via `getInstance`.
    }
    static getInstance() {
        if (!$8fcb6be624dadaa4$export$5c4400ca98bd0186.instance) $8fcb6be624dadaa4$export$5c4400ca98bd0186.instance = new $8fcb6be624dadaa4$export$5c4400ca98bd0186();
        return $8fcb6be624dadaa4$export$5c4400ca98bd0186.instance;
    }
    /** Reset the singleton — for tests only. */ static __resetForTests() {
        $8fcb6be624dadaa4$export$5c4400ca98bd0186.instance = undefined;
    }
    isInitialized() {
        return this.initialized;
    }
    getCollection() {
        return this.collection;
    }
    async initialize(options) {
        if (this.initializePromise) return this.initializePromise;
        this.initializePromise = this.doInitialize(options).finally(()=>{
            this.initialized = true;
        });
        return this.initializePromise;
    }
    async doInitialize(options) {
        // 1. Prefer SSR-bootstrapped values from
        //    `window.__DYNAMIC_CONFIG_BOOTSTRAP` (set by SSR via
        //    `generateBootstrapScript` + `fetchSsrBootstrap`) —
        //    NO network request is made on this path.
        const ssrBootstrap = typeof window !== 'undefined' ? window.__DYNAMIC_CONFIG_BOOTSTRAP : undefined;
        if (ssrBootstrap?.payload) try {
            this.collection = (0, $gH5tc.ConfigCollection).fromValues(ssrBootstrap.payload, {
                throw: true
            });
            return {
                payload: this.collection.toJson('minimal')
            };
        } catch (error) {
            // Fall through to live fetch on parse failure.
            console.error('DynamicConfigClient: failed to parse SSR bootstrap payload, falling back to live fetch', error);
        }
        // 2. No SSR payload or during SSR request — fall back to a live FFS fetch using the
        //    identifiers from `featureGateBootstrapValues`.
        try {
            this.collection = await (0, $bzwLA.ConfigClient).fetch({
                ffsBaseUrl: $8fcb6be624dadaa4$var$getFfsBaseUrl(),
                ffsApiKey: $8fcb6be624dadaa4$var$getFfsApiKey(),
                context: {
                    namespace: 'bxp-web-platform_web',
                    identifiers: options.bootstrapValues.identifiers,
                    metadata: {}
                }
            });
            return {
                payload: this.collection.toJson('minimal')
            };
        } catch (error) {
            console.error('DynamicConfigClient: failed to fetch dynamic configs', error);
            this.collection = (0, $gH5tc.ConfigCollection).empty();
            return undefined;
        }
    }
}

});
parcelRegister("bzwLA", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", function () { return $86cc61548f971709$export$8489e2f039bfcc4c; });

var $76aHI = parcelRequire("76aHI");

var $iVg47 = parcelRequire("iVg47");

var $7TR5g = parcelRequire("7TR5g");

var $9wr9h = parcelRequire("9wr9h");

var $gH5tc = parcelRequire("gH5tc");
var $86cc61548f971709$export$8489e2f039bfcc4c = /*#__PURE__*/ function() {
    function ConfigClient() {
        (0, $iVg47.default)(this, ConfigClient);
    }
    return (0, $7TR5g.default)(ConfigClient, null, [
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, $76aHI.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9wr9h))).mark(function _callee(options) {
                    var _options$fetch;
                    var fetch, response, valuesPayload;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9wr9h))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                fetch = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : globalThis.fetch;
                                _context.next = 3;
                                return fetch("".concat(options.ffsBaseUrl, "/api/v2/configurations"), {
                                    method: 'POST',
                                    body: JSON.stringify(options.context),
                                    headers: {
                                        'content-type': 'application/json',
                                        'x-api-key': options.ffsApiKey
                                    }
                                });
                            case 3:
                                response = _context.sent;
                                if (response.ok) {
                                    _context.next = 12;
                                    break;
                                }
                                _context.t0 = Error;
                                _context.t1 = "Unexpected response ".concat(response.status, ": ");
                                _context.next = 9;
                                return response.text();
                            case 9:
                                _context.t2 = _context.sent;
                                _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
                                throw new _context.t0(_context.t3);
                            case 12:
                                _context.next = 14;
                                return response.text();
                            case 14:
                                valuesPayload = _context.sent;
                                return _context.abrupt("return", (0, $gH5tc.ConfigCollection).fromValues(valuesPayload));
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function fetch(_x) {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        }
    ]);
}();

});
parcelRegister("76aHI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $52b165939476c81c$export$2e2bcd8739ae039; });
function $52b165939476c81c$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $52b165939476c81c$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $52b165939476c81c$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $52b165939476c81c$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("iVg47", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dc6a0320f9f9628c$export$2e2bcd8739ae039; });
function $dc6a0320f9f9628c$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7TR5g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c06d8d66ec17b5a$export$2e2bcd8739ae039; });

var $kKBAz = parcelRequire("kKBAz");
function $5c06d8d66ec17b5a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $kKBAz.default)(o.key), o);
    }
}
function $5c06d8d66ec17b5a$export$2e2bcd8739ae039(e, r, t) {
    return r && $5c06d8d66ec17b5a$var$_defineProperties(e.prototype, r), t && $5c06d8d66ec17b5a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("kKBAz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f1b542e6cd3f9d57$export$2e2bcd8739ae039; });

var $RkNP2 = parcelRequire("RkNP2");

var $5O2Y1 = parcelRequire("5O2Y1");
function $f1b542e6cd3f9d57$export$2e2bcd8739ae039(t) {
    var i = (0, $5O2Y1.default)(t, "string");
    return "symbol" == (0, $RkNP2.default)(i) ? i : i + "";
}

});
parcelRegister("RkNP2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0a05164fcb91c681$export$2e2bcd8739ae039; });
function $0a05164fcb91c681$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0a05164fcb91c681$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a05164fcb91c681$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5O2Y1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43a3ec756237485d$export$2e2bcd8739ae039; });

var $RkNP2 = parcelRequire("RkNP2");
function $43a3ec756237485d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $RkNP2.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $RkNP2.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("9wr9h", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $6eec295e16fc14ac$var$runtime = (parcelRequire("fzIUG"))();
module.exports = $6eec295e16fc14ac$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $6eec295e16fc14ac$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $6eec295e16fc14ac$var$runtime;
    else Function("r", "regeneratorRuntime = r")($6eec295e16fc14ac$var$runtime);
}

});
parcelRegister("fzIUG", function(module, exports) {

var $jJbdv = parcelRequire("jJbdv");

var $1Zi8i = parcelRequire("1Zi8i");

var $6liOM = parcelRequire("6liOM");

var $l8Enw = parcelRequire("l8Enw");

var $7mMwZ = parcelRequire("7mMwZ");

var $5mKQQ = parcelRequire("5mKQQ");

var $cwFb6 = parcelRequire("cwFb6");
function $b56cf6b744035b45$var$_regeneratorRuntime() {
    "use strict";
    var r = $1Zi8i(), e = r.m($b56cf6b744035b45$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $cwFb6(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $b56cf6b744035b45$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $jJbdv(r, e);
            },
            AsyncIterator: $7mMwZ,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $l8Enw : $6liOM)(a(r), e, t, o, u);
            },
            keys: $5mKQQ,
            values: $cwFb6
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $b56cf6b744035b45$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jJbdv", function(module, exports) {
function $e5caebb78877fafb$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $e5caebb78877fafb$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1Zi8i", function(module, exports) {

var $fIEMn = parcelRequire("fIEMn");
function $17298dc5b2be00e3$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $fIEMn(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($fIEMn(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $fIEMn(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $fIEMn(u, "constructor", GeneratorFunctionPrototype), $fIEMn(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $fIEMn(GeneratorFunctionPrototype, o, "GeneratorFunction"), $fIEMn(u), $fIEMn(u, o, "Generator"), $fIEMn(u, n, function() {
        return this;
    }), $fIEMn(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $17298dc5b2be00e3$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $17298dc5b2be00e3$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fIEMn", function(module, exports) {
function $b71a98fd4b849464$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $b71a98fd4b849464$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $b71a98fd4b849464$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b71a98fd4b849464$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $b71a98fd4b849464$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6liOM", function(module, exports) {

var $l8Enw = parcelRequire("l8Enw");
function $49e34d1eee306845$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $l8Enw(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $49e34d1eee306845$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("l8Enw", function(module, exports) {

var $1Zi8i = parcelRequire("1Zi8i");

var $7mMwZ = parcelRequire("7mMwZ");
function $f639aaa622270a81$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $7mMwZ($1Zi8i().w(r, e, t, o), n || Promise);
}
module.exports = $f639aaa622270a81$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7mMwZ", function(module, exports) {

var $jJbdv = parcelRequire("jJbdv");

var $fIEMn = parcelRequire("fIEMn");
function $55d03bbec28a1465$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $jJbdv ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($fIEMn($55d03bbec28a1465$var$AsyncIterator.prototype), $fIEMn($55d03bbec28a1465$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $fIEMn(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $55d03bbec28a1465$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("5mKQQ", function(module, exports) {
function $3e83598b8a4ec960$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $3e83598b8a4ec960$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cwFb6", function(module, exports) {

var $16EoK = parcelRequire("16EoK");
var $91e86a4b5d489a5b$var$_typeof = $16EoK.default;
function $91e86a4b5d489a5b$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($91e86a4b5d489a5b$var$_typeof(e) + " is not iterable");
}
module.exports = $91e86a4b5d489a5b$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("16EoK", function(module, exports) {
function $0ce5b03aacbd7215$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $0ce5b03aacbd7215$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0ce5b03aacbd7215$var$_typeof(o);
}
module.exports = $0ce5b03aacbd7215$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("gH5tc", function(module, exports) {
$parcel$export(module.exports, "ConfigCollection", function () { return $c274e7b5600627ba$export$2be5653e4dada0a3; });

var $ghOo2 = parcelRequire("ghOo2");

var $2mrU5 = parcelRequire("2mrU5");

var $35AD7 = parcelRequire("35AD7");

var $30NLg = parcelRequire("30NLg");

var $d9QQo = parcelRequire("d9QQo");

var $5bqDh = parcelRequire("5bqDh");

var $739Qk = parcelRequire("739Qk");
function $c274e7b5600627ba$var$_callSuper(t, o, e) {
    return o = (0, $30NLg.default)(o), (0, $35AD7.default)(t, $c274e7b5600627ba$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $30NLg.default)(t).constructor) : o.apply(t, e));
}
function $c274e7b5600627ba$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c274e7b5600627ba$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c274e7b5600627ba$export$f9c837a54db411d = /*#__PURE__*/ function(_Error) {
    function ParseError(message, cause) {
        var _this;
        (0, $2mrU5.default)(this, ParseError);
        _this = $c274e7b5600627ba$var$_callSuper(this, ParseError, [
            message
        ]);
        _this.cause = cause;
        return _this;
    }
    (0, $d9QQo.default)(ParseError, _Error);
    return (0, $ghOo2.default)(ParseError);
}(/*#__PURE__*/ (0, $5bqDh.default)(Error));
function $c274e7b5600627ba$var$safeParse(json) {
    try {
        return {
            data: (0, $739Qk.AnyConfigSchema).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $c274e7b5600627ba$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
var $c274e7b5600627ba$export$2be5653e4dada0a3 = /*#__PURE__*/ function() {
    function ConfigCollection(config) {
        (0, $2mrU5.default)(this, ConfigCollection);
        this.config = config;
    }
    return (0, $ghOo2.default)(ConfigCollection, [
        {
            key: "toJson",
            value: function toJson(format) {
                switch(format){
                    case 'standard':
                        return JSON.stringify((0, $739Qk.mapToStandard)(this.config));
                    case 'minimal':
                        return JSON.stringify((0, $739Qk.mapToMinimal)(this.config));
                }
            }
        },
        {
            key: "getBoolean",
            value: function getBoolean(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $739Qk.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'boolean') return {
                    error: (0, $739Qk.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getString",
            value: function getString(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $739Qk.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'string') return {
                    error: (0, $739Qk.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumber",
            value: function getNumber(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $739Qk.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'number') return {
                    error: (0, $739Qk.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getStringList",
            value: function getStringList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $739Qk.ConfigError).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === 'string';
                })) return {
                    error: (0, $739Qk.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumberList",
            value: function getNumberList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $739Qk.ConfigError).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === 'number';
                })) return {
                    error: (0, $739Qk.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        }
    ], [
        {
            key: "fromValues",
            value: function fromValues(values, options) {
                var result = $c274e7b5600627ba$var$safeParse(values);
                if (!result.success) {
                    var parseError = new $c274e7b5600627ba$export$f9c837a54db411d('Failed to deserialize config', result.error);
                    if (options !== null && options !== void 0 && options.throw) throw parseError;
                    // eslint-disable-next-line no-console
                    console.error(parseError);
                    return ConfigCollection.empty();
                }
                return new ConfigCollection(Array.isArray(result.data) ? (0, $739Qk.minimalToMap)(result.data) : (0, $739Qk.standardToMap)(result.data));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new ConfigCollection(new Map());
            }
        }
    ]);
}();

});
parcelRegister("ghOo2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bdb551a1180c0514$export$2e2bcd8739ae039; });

var $24UqN = parcelRequire("24UqN");
function $bdb551a1180c0514$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $24UqN.default)(o.key), o);
    }
}
function $bdb551a1180c0514$export$2e2bcd8739ae039(e, r, t) {
    return r && $bdb551a1180c0514$var$_defineProperties(e.prototype, r), t && $bdb551a1180c0514$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("24UqN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1837ba8e3e01c06c$export$2e2bcd8739ae039; });

var $gBCAD = parcelRequire("gBCAD");

var $izsSe = parcelRequire("izsSe");
function $1837ba8e3e01c06c$export$2e2bcd8739ae039(t) {
    var i = (0, $izsSe.default)(t, "string");
    return "symbol" == (0, $gBCAD.default)(i) ? i : i + "";
}

});
parcelRegister("gBCAD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c16e0932d83d2201$export$2e2bcd8739ae039; });
function $c16e0932d83d2201$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c16e0932d83d2201$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c16e0932d83d2201$export$2e2bcd8739ae039(o);
}

});

parcelRegister("izsSe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d851e49534bb7303$export$2e2bcd8739ae039; });

var $gBCAD = parcelRequire("gBCAD");
function $d851e49534bb7303$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $gBCAD.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $gBCAD.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("2mrU5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1b8347ef7223a0b0$export$2e2bcd8739ae039; });
function $1b8347ef7223a0b0$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("35AD7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23fe40afa6039aa6$export$2e2bcd8739ae039; });

var $gBCAD = parcelRequire("gBCAD");

var $k0Kv4 = parcelRequire("k0Kv4");
function $23fe40afa6039aa6$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $gBCAD.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $k0Kv4.default)(t);
}

});
parcelRegister("k0Kv4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $03c2731b9838c89c$export$2e2bcd8739ae039; });
function $03c2731b9838c89c$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("30NLg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2317f8bf1a7b7228$export$2e2bcd8739ae039; });
function $2317f8bf1a7b7228$export$2e2bcd8739ae039(t) {
    return $2317f8bf1a7b7228$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $2317f8bf1a7b7228$export$2e2bcd8739ae039(t);
}

});

parcelRegister("d9QQo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $99451b5ae8dfbbc7$export$2e2bcd8739ae039; });

var $iu5eT = parcelRequire("iu5eT");
function $99451b5ae8dfbbc7$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $iu5eT.default)(t, e);
}

});
parcelRegister("iu5eT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d74f17ba00b9be02$export$2e2bcd8739ae039; });
function $d74f17ba00b9be02$export$2e2bcd8739ae039(t, e) {
    return $d74f17ba00b9be02$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d74f17ba00b9be02$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("5bqDh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3c62a3803ebd037f$export$2e2bcd8739ae039; });

var $30NLg = parcelRequire("30NLg");

var $iu5eT = parcelRequire("iu5eT");

var $cOkVp = parcelRequire("cOkVp");

var $9kpxr = parcelRequire("9kpxr");
function $3c62a3803ebd037f$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $3c62a3803ebd037f$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $cOkVp.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $9kpxr.default)(t, arguments, (0, $30NLg.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $iu5eT.default)(Wrapper, t);
    }, $3c62a3803ebd037f$export$2e2bcd8739ae039(t);
}

});
parcelRegister("cOkVp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $953a62d4252af1d3$export$2e2bcd8739ae039; });
function $953a62d4252af1d3$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("9kpxr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6ca9caae75433cad$export$2e2bcd8739ae039; });

var $6aD80 = parcelRequire("6aD80");

var $iu5eT = parcelRequire("iu5eT");
function $6ca9caae75433cad$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $6aD80.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $iu5eT.default)(p, r.prototype), p;
}

});
parcelRegister("6aD80", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $47e20746487ac765$export$2e2bcd8739ae039; });
function $47e20746487ac765$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($47e20746487ac765$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});



parcelRegister("739Qk", function(module, exports) {
$parcel$export(module.exports, "ConfigError", function () { return $522072db591bffae$export$c5fb415882705cf4; });
$parcel$export(module.exports, "AnyConfigSchema", function () { return $522072db591bffae$export$960d45de79bd7d81; });
$parcel$export(module.exports, "minimalToMap", function () { return $522072db591bffae$export$c29ba52779f58587; });
$parcel$export(module.exports, "standardToMap", function () { return $522072db591bffae$export$be5b69ecb011d7cc; });
$parcel$export(module.exports, "mapToMinimal", function () { return $522072db591bffae$export$460f06addafd9f86; });
$parcel$export(module.exports, "mapToStandard", function () { return $522072db591bffae$export$9d0101ad8235e092; });

var $gBCAD = parcelRequire("gBCAD");

var $ecV9B = parcelRequire("ecV9B");

var $3nFRC = parcelRequire("3nFRC");
function $522072db591bffae$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $522072db591bffae$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $522072db591bffae$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $522072db591bffae$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $522072db591bffae$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $522072db591bffae$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $522072db591bffae$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
var $522072db591bffae$export$e94ee64b2671e155 = $3nFRC.record($3nFRC.string(), $3nFRC.object({
    value: $3nFRC.union([
        $3nFRC.boolean(),
        $3nFRC.string(),
        $3nFRC.number(),
        $3nFRC.string().array(),
        $3nFRC.number().array()
    ])
}));
var $522072db591bffae$export$e38f7b10db0e126a = $3nFRC.tuple([
    // list of boolean configs which are on
    $3nFRC.string().array(),
    // list of string config tuples
    $3nFRC.array($3nFRC.string()).refine(function(arr) {
        return arr.length % 2 === 0;
    }),
    // list of number config tuples
    $3nFRC.array($3nFRC.union([
        $3nFRC.string(),
        $3nFRC.number()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    $3nFRC.array($3nFRC.union([
        $3nFRC.string(),
        $3nFRC.string().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === 'string';
            })) return false;
        }
        return true;
    }),
    // list of number list config tuples
    $3nFRC.array($3nFRC.union([
        $3nFRC.string(),
        $3nFRC.number().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === 'number';
            })) return false;
        }
        return true;
    })
]);
var $522072db591bffae$export$960d45de79bd7d81 = $3nFRC.union([
    $522072db591bffae$export$e94ee64b2671e155,
    $522072db591bffae$export$e38f7b10db0e126a
]);
var $522072db591bffae$export$ac2e9c88ba5d7cbb = $3nFRC.map($3nFRC.string(), $3nFRC.object({
    value: $3nFRC.union([
        $3nFRC.boolean(),
        $3nFRC.string(),
        $3nFRC.number(),
        $3nFRC.string().array(),
        $3nFRC.number().array()
    ])
}));
function $522072db591bffae$var$pairs(arr, fn) {
    for(var i = 0; i < arr.length; i += 2){
        var key = arr[i];
        var val = arr[i + 1];
        if (typeof key !== 'string') throw new Error("Expected a string while iterating pairs, got: ".concat(arr[i]));
        fn(key, val);
    }
}
function $522072db591bffae$export$c29ba52779f58587(minimal) {
    var map = new Map();
    minimal[0].forEach(function(boolean) {
        return map.set(boolean, {
            value: true
        });
    });
    $522072db591bffae$var$pairs(minimal[1], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $522072db591bffae$var$pairs(minimal[2], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $522072db591bffae$var$pairs(minimal[3], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $522072db591bffae$var$pairs(minimal[4], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    return map;
}
function $522072db591bffae$export$be5b69ecb011d7cc(standard) {
    var map = new Map();
    Object.entries(standard).forEach(function(_ref) {
        var _ref2 = (0, $ecV9B.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return map.set(key, value);
    });
    return map;
}
function $522072db591bffae$export$460f06addafd9f86(map) {
    var minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    var _iterator = $522072db591bffae$var$_createForOfIteratorHelper(map.entries()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, $ecV9B.default)(_step.value, 2), key = _step$value[0], value = _step$value[1].value;
            switch((0, $gBCAD.default)(value)){
                case 'boolean':
                    if (value) minimal[0].push(key);
                    break;
                case 'string':
                    minimal[1].push(key, value);
                    break;
                case 'number':
                    minimal[2].push(key, value);
                    break;
                default:
                    if (!Array.isArray(value)) throw new Error("Unexpected configuration value: ".concat(value));
                    var allStrings = value.every(function(x) {
                        return typeof x === 'string';
                    });
                    if (allStrings) {
                        minimal[3].push(key, value);
                        break;
                    }
                    var allNumbers = value.every(function(x) {
                        return typeof x === 'number';
                    });
                    if (allNumbers) {
                        minimal[4].push(key, value);
                        break;
                    }
                    throw new Error("Unexpected configuration value: ".concat(value));
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return minimal;
}
function $522072db591bffae$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}

});
parcelRegister("ecV9B", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a57e853f89da97e0$export$2e2bcd8739ae039; });

var $dv5Qa = parcelRequire("dv5Qa");

var $ldiX3 = parcelRequire("ldiX3");

var $27GAR = parcelRequire("27GAR");

var $eFvPZ = parcelRequire("eFvPZ");
function $a57e853f89da97e0$export$2e2bcd8739ae039(r, e) {
    return (0, $dv5Qa.default)(r) || (0, $ldiX3.default)(r, e) || (0, $27GAR.default)(r, e) || (0, $eFvPZ.default)();
}

});
parcelRegister("dv5Qa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d42b366e9c0eb1e$export$2e2bcd8739ae039; });
function $9d42b366e9c0eb1e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("ldiX3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f7198337fc3f24ca$export$2e2bcd8739ae039; });
function $f7198337fc3f24ca$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("27GAR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $18bd4665994839bf$export$2e2bcd8739ae039; });

var $2okzU = parcelRequire("2okzU");
function $18bd4665994839bf$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2okzU.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2okzU.default)(r, a) : void 0;
    }
}

});
parcelRegister("2okzU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1bddc911fd12113d$export$2e2bcd8739ae039; });
function $1bddc911fd12113d$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("eFvPZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aadd974cd1881131$export$2e2bcd8739ae039; });
function $aadd974cd1881131$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3nFRC", function(module, exports) {
$parcel$export(module.exports, "string", function () { return $2763fe62416eb379$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $2763fe62416eb379$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $2763fe62416eb379$export$4a21f16c33752377; });
$parcel$export(module.exports, "array", function () { return $2763fe62416eb379$export$2f23118c22fb2630; });
$parcel$export(module.exports, "object", function () { return $2763fe62416eb379$export$be5493f9613cbbe; });
$parcel$export(module.exports, "union", function () { return $2763fe62416eb379$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "tuple", function () { return $2763fe62416eb379$export$65e3907585753458; });
$parcel$export(module.exports, "record", function () { return $2763fe62416eb379$export$e5185e241753e543; });
$parcel$export(module.exports, "map", function () { return $2763fe62416eb379$export$871de8747c9eaa88; });
var $2763fe62416eb379$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($2763fe62416eb379$export$7debb50ef11d5e0b || ($2763fe62416eb379$export$7debb50ef11d5e0b = {}));
var $2763fe62416eb379$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($2763fe62416eb379$export$4aa2142c225fd5c7 || ($2763fe62416eb379$export$4aa2142c225fd5c7 = {}));
const $2763fe62416eb379$export$5716da67bfaa244d = $2763fe62416eb379$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $2763fe62416eb379$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $2763fe62416eb379$export$5716da67bfaa244d.undefined;
        case "string":
            return $2763fe62416eb379$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $2763fe62416eb379$export$5716da67bfaa244d.nan : $2763fe62416eb379$export$5716da67bfaa244d.number;
        case "boolean":
            return $2763fe62416eb379$export$5716da67bfaa244d.boolean;
        case "function":
            return $2763fe62416eb379$export$5716da67bfaa244d.function;
        case "bigint":
            return $2763fe62416eb379$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $2763fe62416eb379$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $2763fe62416eb379$export$5716da67bfaa244d.array;
            if (data === null) return $2763fe62416eb379$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $2763fe62416eb379$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $2763fe62416eb379$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $2763fe62416eb379$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $2763fe62416eb379$export$5716da67bfaa244d.date;
            return $2763fe62416eb379$export$5716da67bfaa244d.object;
        default:
            return $2763fe62416eb379$export$5716da67bfaa244d.unknown;
    }
};
const $2763fe62416eb379$export$5ba560653e4a1035 = $2763fe62416eb379$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $2763fe62416eb379$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $2763fe62416eb379$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $2763fe62416eb379$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $2763fe62416eb379$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$2763fe62416eb379$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $2763fe62416eb379$export$f98dac4b251ab333(issues);
    return error;
};
const $2763fe62416eb379$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $2763fe62416eb379$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $2763fe62416eb379$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$2763fe62416eb379$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$2763fe62416eb379$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$2763fe62416eb379$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $2763fe62416eb379$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $2763fe62416eb379$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $2763fe62416eb379$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $2763fe62416eb379$var$overrideErrorMap = $2763fe62416eb379$export$341b0b6e0a6f5099;
function $2763fe62416eb379$export$1097a8289cfd22d7(map) {
    $2763fe62416eb379$var$overrideErrorMap = map;
}
function $2763fe62416eb379$export$32f27c719778d4c4() {
    return $2763fe62416eb379$var$overrideErrorMap;
}
const $2763fe62416eb379$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $2763fe62416eb379$export$1526d2e05f74572 = [];
function $2763fe62416eb379$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $2763fe62416eb379$export$32f27c719778d4c4();
    const issue = $2763fe62416eb379$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $2763fe62416eb379$export$341b0b6e0a6f5099 ? undefined : $2763fe62416eb379$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $2763fe62416eb379$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $2763fe62416eb379$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $2763fe62416eb379$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $2763fe62416eb379$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $2763fe62416eb379$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $2763fe62416eb379$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $2763fe62416eb379$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $2763fe62416eb379$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $2763fe62416eb379$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2763fe62416eb379$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $2763fe62416eb379$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($2763fe62416eb379$var$errorUtil || ($2763fe62416eb379$var$errorUtil = {}));
var $2763fe62416eb379$var$_ZodEnum_cache, $2763fe62416eb379$var$_ZodNativeEnum_cache;
class $2763fe62416eb379$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $2763fe62416eb379$var$handleResult = (ctx, result)=>{
    if ($2763fe62416eb379$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $2763fe62416eb379$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $2763fe62416eb379$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $2763fe62416eb379$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $2763fe62416eb379$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $2763fe62416eb379$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $2763fe62416eb379$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($2763fe62416eb379$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $2763fe62416eb379$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $2763fe62416eb379$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $2763fe62416eb379$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($2763fe62416eb379$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $2763fe62416eb379$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $2763fe62416eb379$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $2763fe62416eb379$export$a60af00cc0ce2582({
            schema: this,
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $2763fe62416eb379$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $2763fe62416eb379$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $2763fe62416eb379$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $2763fe62416eb379$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $2763fe62416eb379$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $2763fe62416eb379$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $2763fe62416eb379$export$a60af00cc0ce2582({
            ...$2763fe62416eb379$var$processCreateParams(this._def),
            schema: this,
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $2763fe62416eb379$export$bb19b37874861e7e({
            ...$2763fe62416eb379$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $2763fe62416eb379$export$66b0c798a395271f({
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$2763fe62416eb379$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $2763fe62416eb379$export$75a44ec6249ac76b({
            ...$2763fe62416eb379$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $2763fe62416eb379$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $2763fe62416eb379$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $2763fe62416eb379$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $2763fe62416eb379$var$cuid2Regex = /^[0-9a-z]+$/;
const $2763fe62416eb379$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $2763fe62416eb379$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $2763fe62416eb379$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $2763fe62416eb379$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $2763fe62416eb379$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $2763fe62416eb379$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $2763fe62416eb379$var$emojiRegex;
// faster, simpler, safer
const $2763fe62416eb379$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $2763fe62416eb379$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $2763fe62416eb379$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $2763fe62416eb379$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $2763fe62416eb379$var$dateRegex = new RegExp(`^${$2763fe62416eb379$var$dateRegexSource}$`);
function $2763fe62416eb379$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $2763fe62416eb379$var$timeRegex(args) {
    return new RegExp(`^${$2763fe62416eb379$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $2763fe62416eb379$export$a4b563879add27a(args) {
    let regex = `${$2763fe62416eb379$var$dateRegexSource}T${$2763fe62416eb379$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $2763fe62416eb379$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $2763fe62416eb379$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $2763fe62416eb379$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $2763fe62416eb379$export$1230eb29b8d3b502 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const status = new $2763fe62416eb379$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$2763fe62416eb379$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$2763fe62416eb379$var$emojiRegex) $2763fe62416eb379$var$emojiRegex = new RegExp($2763fe62416eb379$var$_emojiRegex, "u");
                if (!$2763fe62416eb379$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$2763fe62416eb379$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$2763fe62416eb379$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$2763fe62416eb379$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$2763fe62416eb379$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$2763fe62416eb379$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $2763fe62416eb379$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $2763fe62416eb379$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $2763fe62416eb379$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$2763fe62416eb379$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$2763fe62416eb379$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$2763fe62416eb379$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2763fe62416eb379$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_string,
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $2763fe62416eb379$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$2763fe62416eb379$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$2763fe62416eb379$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$2763fe62416eb379$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$2763fe62416eb379$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$2763fe62416eb379$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $2763fe62416eb379$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $2763fe62416eb379$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $2763fe62416eb379$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $2763fe62416eb379$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$2763fe62416eb379$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $2763fe62416eb379$export$1230eb29b8d3b502({
        checks: [],
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $2763fe62416eb379$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $2763fe62416eb379$export$5b070a55c0c43e09 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $2763fe62416eb379$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$2763fe62416eb379$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($2763fe62416eb379$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2763fe62416eb379$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $2763fe62416eb379$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $2763fe62416eb379$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $2763fe62416eb379$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $2763fe62416eb379$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $2763fe62416eb379$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $2763fe62416eb379$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $2763fe62416eb379$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $2763fe62416eb379$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$2763fe62416eb379$export$5b070a55c0c43e09.create = (params)=>{
    return new $2763fe62416eb379$export$5b070a55c0c43e09({
        checks: [],
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$67d741fd70ff98f4 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $2763fe62416eb379$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2763fe62416eb379$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $2763fe62416eb379$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $2763fe62416eb379$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $2763fe62416eb379$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $2763fe62416eb379$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $2763fe62416eb379$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $2763fe62416eb379$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $2763fe62416eb379$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$2763fe62416eb379$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $2763fe62416eb379$export$67d741fd70ff98f4({
        checks: [],
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$723d146f80596191 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
}
$2763fe62416eb379$export$723d146f80596191.create = (params)=>{
    return new $2763fe62416eb379$export$723d146f80596191({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$e974be33bdc55521 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_date
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const status = new $2763fe62416eb379$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $2763fe62416eb379$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $2763fe62416eb379$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $2763fe62416eb379$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$2763fe62416eb379$export$e974be33bdc55521.create = (params)=>{
    return new $2763fe62416eb379$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodDate,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$bcc3b40f6b638044 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
}
$2763fe62416eb379$export$bcc3b40f6b638044.create = (params)=>{
    return new $2763fe62416eb379$export$bcc3b40f6b638044({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodSymbol,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$4e780e961c30340d extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
}
$2763fe62416eb379$export$4e780e961c30340d.create = (params)=>{
    return new $2763fe62416eb379$export$4e780e961c30340d({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodUndefined,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$a96281f914484f2d extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
}
$2763fe62416eb379$export$a96281f914484f2d.create = (params)=>{
    return new $2763fe62416eb379$export$a96281f914484f2d({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodNull,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$b9d1edb536b4e4eb extends $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
}
$2763fe62416eb379$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $2763fe62416eb379$export$b9d1edb536b4e4eb({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodAny,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$ef3b1bb1630977ae extends $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
}
$2763fe62416eb379$export$ef3b1bb1630977ae.create = (params)=>{
    return new $2763fe62416eb379$export$ef3b1bb1630977ae({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodUnknown,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$1e576a20c3ce9fb5 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
            code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
            expected: $2763fe62416eb379$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $2763fe62416eb379$export$9a105a556e65c2c0;
    }
}
$2763fe62416eb379$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $2763fe62416eb379$export$1e576a20c3ce9fb5({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodNever,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$7d39f5df85f21031 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
}
$2763fe62416eb379$export$7d39f5df85f21031.create = (params)=>{
    return new $2763fe62416eb379$export$7d39f5df85f21031({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodVoid,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$7acfc3e64785411 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.array) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $2763fe62416eb379$export$5ba560653e4a1035.too_big : $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                    code: $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                    code: $2763fe62416eb379$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $2763fe62416eb379$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $2763fe62416eb379$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $2763fe62416eb379$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $2763fe62416eb379$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $2763fe62416eb379$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $2763fe62416eb379$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$2763fe62416eb379$export$7acfc3e64785411.create = (schema, params)=>{
    return new $2763fe62416eb379$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodArray,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
function $2763fe62416eb379$var$deepPartialify(schema) {
    if (schema instanceof $2763fe62416eb379$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $2763fe62416eb379$export$aa56fec1e9d629b8.create($2763fe62416eb379$var$deepPartialify(fieldSchema));
        }
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $2763fe62416eb379$export$7acfc3e64785411) return new $2763fe62416eb379$export$7acfc3e64785411({
        ...schema._def,
        type: $2763fe62416eb379$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $2763fe62416eb379$export$aa56fec1e9d629b8) return $2763fe62416eb379$export$aa56fec1e9d629b8.create($2763fe62416eb379$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $2763fe62416eb379$export$aaac0b8b429cef5) return $2763fe62416eb379$export$aaac0b8b429cef5.create($2763fe62416eb379$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $2763fe62416eb379$export$e2a18bb771d8e6a3) return $2763fe62416eb379$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$2763fe62416eb379$var$deepPartialify(item)));
    else return schema;
}
class $2763fe62416eb379$export$736315c5b55efbad extends $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $2763fe62416eb379$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $2763fe62416eb379$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $2763fe62416eb379$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                        code: $2763fe62416eb379$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $2763fe62416eb379$var$errorUtil.errToObj;
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $2763fe62416eb379$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $2763fe62416eb379$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $2763fe62416eb379$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $2763fe62416eb379$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $2763fe62416eb379$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $2763fe62416eb379$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $2763fe62416eb379$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $2763fe62416eb379$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $2763fe62416eb379$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $2763fe62416eb379$var$createZodEnum($2763fe62416eb379$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$2763fe62416eb379$export$736315c5b55efbad.create = (shape, params)=>{
    return new $2763fe62416eb379$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $2763fe62416eb379$export$1e576a20c3ce9fb5.create(),
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodObject,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
$2763fe62416eb379$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $2763fe62416eb379$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $2763fe62416eb379$export$1e576a20c3ce9fb5.create(),
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodObject,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
$2763fe62416eb379$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $2763fe62416eb379$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $2763fe62416eb379$export$1e576a20c3ce9fb5.create(),
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodObject,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$a8b236cb5070a311 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $2763fe62416eb379$export$f98dac4b251ab333(result.ctx.common.issues));
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $2763fe62416eb379$export$f98dac4b251ab333(issues));
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$2763fe62416eb379$export$a8b236cb5070a311.create = (types, params)=>{
    return new $2763fe62416eb379$export$a8b236cb5070a311({
        options: types,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodUnion,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $2763fe62416eb379$var$getDiscriminator = (type)=>{
    if (type instanceof $2763fe62416eb379$export$378d0cfce37406e6) return $2763fe62416eb379$var$getDiscriminator(type.schema);
    else if (type instanceof $2763fe62416eb379$export$a60af00cc0ce2582) return $2763fe62416eb379$var$getDiscriminator(type.innerType());
    else if (type instanceof $2763fe62416eb379$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $2763fe62416eb379$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $2763fe62416eb379$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $2763fe62416eb379$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $2763fe62416eb379$export$bb19b37874861e7e) return $2763fe62416eb379$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $2763fe62416eb379$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $2763fe62416eb379$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $2763fe62416eb379$export$aa56fec1e9d629b8) return [
        undefined,
        ...$2763fe62416eb379$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $2763fe62416eb379$export$aaac0b8b429cef5) return [
        null,
        ...$2763fe62416eb379$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $2763fe62416eb379$export$66b0c798a395271f) return $2763fe62416eb379$var$getDiscriminator(type.unwrap());
    else if (type instanceof $2763fe62416eb379$export$5d1f7ef05c4e493a) return $2763fe62416eb379$var$getDiscriminator(type.unwrap());
    else if (type instanceof $2763fe62416eb379$export$75a44ec6249ac76b) return $2763fe62416eb379$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $2763fe62416eb379$export$5ef2424805ac76a3 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.object) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $2763fe62416eb379$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $2763fe62416eb379$export$5ef2424805ac76a3({
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$2763fe62416eb379$var$processCreateParams(params)
        });
    }
}
function $2763fe62416eb379$var$mergeValues(a, b) {
    const aType = $2763fe62416eb379$export$3e9057828ebd5c7a(a);
    const bType = $2763fe62416eb379$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $2763fe62416eb379$export$5716da67bfaa244d.object && bType === $2763fe62416eb379$export$5716da67bfaa244d.object) {
        const bKeys = $2763fe62416eb379$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $2763fe62416eb379$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $2763fe62416eb379$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $2763fe62416eb379$export$5716da67bfaa244d.array && bType === $2763fe62416eb379$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $2763fe62416eb379$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $2763fe62416eb379$export$5716da67bfaa244d.date && bType === $2763fe62416eb379$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $2763fe62416eb379$export$c02deaf0bb5203d4 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($2763fe62416eb379$export$afa861e3c5730743(parsedLeft) || $2763fe62416eb379$export$afa861e3c5730743(parsedRight)) return $2763fe62416eb379$export$9a105a556e65c2c0;
            const merged = $2763fe62416eb379$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                    code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $2763fe62416eb379$export$9a105a556e65c2c0;
            }
            if ($2763fe62416eb379$export$910b6cdd390341b3(parsedLeft) || $2763fe62416eb379$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$2763fe62416eb379$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $2763fe62416eb379$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodIntersection,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$e2a18bb771d8e6a3 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.array) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $2763fe62416eb379$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$2763fe62416eb379$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $2763fe62416eb379$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$a2acc09968cb4b7f extends $2763fe62416eb379$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.object) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $2763fe62416eb379$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $2763fe62416eb379$export$19342e026b58ebb7) return new $2763fe62416eb379$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodRecord,
            ...$2763fe62416eb379$var$processCreateParams(third)
        });
        return new $2763fe62416eb379$export$a2acc09968cb4b7f({
            keyType: $2763fe62416eb379$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodRecord,
            ...$2763fe62416eb379$var$processCreateParams(second)
        });
    }
}
class $2763fe62416eb379$export$163b6a2b712d9542 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.map) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$2763fe62416eb379$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $2763fe62416eb379$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodMap,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$977057706f816712 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.set) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                    code: $2763fe62416eb379$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                    code: $2763fe62416eb379$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $2763fe62416eb379$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $2763fe62416eb379$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $2763fe62416eb379$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $2763fe62416eb379$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $2763fe62416eb379$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$2763fe62416eb379$export$977057706f816712.create = (valueType, params)=>{
    return new $2763fe62416eb379$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodSet,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$d4602ba55673f53c extends $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.function) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $2763fe62416eb379$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $2763fe62416eb379$export$32f27c719778d4c4(),
                    $2763fe62416eb379$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $2763fe62416eb379$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $2763fe62416eb379$export$32f27c719778d4c4(),
                    $2763fe62416eb379$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $2763fe62416eb379$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $2763fe62416eb379$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $2763fe62416eb379$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $2763fe62416eb379$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $2763fe62416eb379$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $2763fe62416eb379$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $2763fe62416eb379$export$d4602ba55673f53c({
            ...this._def,
            args: $2763fe62416eb379$export$e2a18bb771d8e6a3.create(items).rest($2763fe62416eb379$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $2763fe62416eb379$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $2763fe62416eb379$export$d4602ba55673f53c({
            args: args ? args : $2763fe62416eb379$export$e2a18bb771d8e6a3.create([]).rest($2763fe62416eb379$export$ef3b1bb1630977ae.create()),
            returns: returns || $2763fe62416eb379$export$ef3b1bb1630977ae.create(),
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodFunction,
            ...$2763fe62416eb379$var$processCreateParams(params)
        });
    }
}
class $2763fe62416eb379$export$378d0cfce37406e6 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$2763fe62416eb379$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $2763fe62416eb379$export$378d0cfce37406e6({
        getter: getter,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodLazy,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$7e44096782a165d3 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$2763fe62416eb379$export$7e44096782a165d3.create = (value, params)=>{
    return new $2763fe62416eb379$export$7e44096782a165d3({
        value: value,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodLiteral,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
function $2763fe62416eb379$var$createZodEnum(values, params) {
    return new $2763fe62416eb379$export$d325d1f0e1c20179({
        values: values,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodEnum,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
}
class $2763fe62416eb379$export$d325d1f0e1c20179 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $2763fe62416eb379$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                expected: $2763fe62416eb379$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        if (!$2763fe62416eb379$var$__classPrivateFieldGet(this, $2763fe62416eb379$var$_ZodEnum_cache, "f")) $2763fe62416eb379$var$__classPrivateFieldSet(this, $2763fe62416eb379$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$2763fe62416eb379$var$__classPrivateFieldGet(this, $2763fe62416eb379$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $2763fe62416eb379$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $2763fe62416eb379$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$2763fe62416eb379$var$_ZodEnum_cache = new WeakMap();
$2763fe62416eb379$export$d325d1f0e1c20179.create = $2763fe62416eb379$var$createZodEnum;
class $2763fe62416eb379$export$370b2e8d6d6f5c56 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $2763fe62416eb379$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $2763fe62416eb379$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.string && ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.number) {
            const expectedValues = $2763fe62416eb379$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                expected: $2763fe62416eb379$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        if (!$2763fe62416eb379$var$__classPrivateFieldGet(this, $2763fe62416eb379$var$_ZodNativeEnum_cache, "f")) $2763fe62416eb379$var$__classPrivateFieldSet(this, $2763fe62416eb379$var$_ZodNativeEnum_cache, new Set($2763fe62416eb379$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$2763fe62416eb379$var$__classPrivateFieldGet(this, $2763fe62416eb379$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $2763fe62416eb379$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return $2763fe62416eb379$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$2763fe62416eb379$var$_ZodNativeEnum_cache = new WeakMap();
$2763fe62416eb379$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $2763fe62416eb379$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodNativeEnum,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$3f196b0127d6e50a extends $2763fe62416eb379$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $2763fe62416eb379$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $2763fe62416eb379$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$2763fe62416eb379$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $2763fe62416eb379$export$3f196b0127d6e50a({
        type: schema,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodPromise,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$a60af00cc0ce2582 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $2763fe62416eb379$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $2763fe62416eb379$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $2763fe62416eb379$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $2763fe62416eb379$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $2763fe62416eb379$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $2763fe62416eb379$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$2763fe62416eb379$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$2763fe62416eb379$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $2763fe62416eb379$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$2763fe62416eb379$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $2763fe62416eb379$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
$2763fe62416eb379$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $2763fe62416eb379$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodEffects,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$aa56fec1e9d629b8 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $2763fe62416eb379$export$5716da67bfaa244d.undefined) return $2763fe62416eb379$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$2763fe62416eb379$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $2763fe62416eb379$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodOptional,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$aaac0b8b429cef5 extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $2763fe62416eb379$export$5716da67bfaa244d.null) return $2763fe62416eb379$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$2763fe62416eb379$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $2763fe62416eb379$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodNullable,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$bb19b37874861e7e extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $2763fe62416eb379$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$2763fe62416eb379$export$bb19b37874861e7e.create = (type, params)=>{
    return new $2763fe62416eb379$export$bb19b37874861e7e({
        innerType: type,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$75a44ec6249ac76b extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($2763fe62416eb379$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $2763fe62416eb379$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $2763fe62416eb379$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$2763fe62416eb379$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $2763fe62416eb379$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
class $2763fe62416eb379$export$26ccfa0145e8511f extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2763fe62416eb379$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $2763fe62416eb379$export$db7caee60e5d514d(ctx, {
                code: $2763fe62416eb379$export$5ba560653e4a1035.invalid_type,
                expected: $2763fe62416eb379$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $2763fe62416eb379$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$2763fe62416eb379$export$26ccfa0145e8511f.create = (params)=>{
    return new $2763fe62416eb379$export$26ccfa0145e8511f({
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodNaN,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
const $2763fe62416eb379$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $2763fe62416eb379$export$66b0c798a395271f extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $2763fe62416eb379$export$a3c3ef8a0e95c6da extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $2763fe62416eb379$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $2763fe62416eb379$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $2763fe62416eb379$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $2763fe62416eb379$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $2763fe62416eb379$export$5d1f7ef05c4e493a extends $2763fe62416eb379$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($2763fe62416eb379$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $2763fe62416eb379$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$2763fe62416eb379$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $2763fe62416eb379$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $2763fe62416eb379$export$558106ce543bd011.ZodReadonly,
        ...$2763fe62416eb379$var$processCreateParams(params)
    });
};
function $2763fe62416eb379$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $2763fe62416eb379$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $2763fe62416eb379$export$b9d1edb536b4e4eb.create();
}
const $2763fe62416eb379$export$1ee8ee30835eab8b = {
    object: $2763fe62416eb379$export$736315c5b55efbad.lazycreate
};
var $2763fe62416eb379$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($2763fe62416eb379$export$558106ce543bd011 || ($2763fe62416eb379$export$558106ce543bd011 = {}));
const $2763fe62416eb379$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$2763fe62416eb379$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $2763fe62416eb379$export$22b082955e083ec3 = $2763fe62416eb379$export$1230eb29b8d3b502.create;
const $2763fe62416eb379$export$98e628dec113755e = $2763fe62416eb379$export$5b070a55c0c43e09.create;
const $2763fe62416eb379$export$9e06de0973666692 = $2763fe62416eb379$export$26ccfa0145e8511f.create;
const $2763fe62416eb379$export$a0f65b52274bcc00 = $2763fe62416eb379$export$67d741fd70ff98f4.create;
const $2763fe62416eb379$export$4a21f16c33752377 = $2763fe62416eb379$export$723d146f80596191.create;
const $2763fe62416eb379$export$324d90190a8b822a = $2763fe62416eb379$export$e974be33bdc55521.create;
const $2763fe62416eb379$export$8f701197936bc2a6 = $2763fe62416eb379$export$bcc3b40f6b638044.create;
const $2763fe62416eb379$export$1db45310990710a5 = $2763fe62416eb379$export$4e780e961c30340d.create;
const $2763fe62416eb379$export$7b1b591b262c240 = $2763fe62416eb379$export$a96281f914484f2d.create;
const $2763fe62416eb379$export$4154a199d7d90455 = $2763fe62416eb379$export$b9d1edb536b4e4eb.create;
const $2763fe62416eb379$export$19282c40b967aec6 = $2763fe62416eb379$export$ef3b1bb1630977ae.create;
const $2763fe62416eb379$export$b3e22bcfd64c1022 = $2763fe62416eb379$export$1e576a20c3ce9fb5.create;
const $2763fe62416eb379$export$490e536ee7389aeb = $2763fe62416eb379$export$7d39f5df85f21031.create;
const $2763fe62416eb379$export$2f23118c22fb2630 = $2763fe62416eb379$export$7acfc3e64785411.create;
const $2763fe62416eb379$export$be5493f9613cbbe = $2763fe62416eb379$export$736315c5b55efbad.create;
const $2763fe62416eb379$export$8fb0df5f40d0b477 = $2763fe62416eb379$export$736315c5b55efbad.strictCreate;
const $2763fe62416eb379$export$971dd5b0dfd021b6 = $2763fe62416eb379$export$a8b236cb5070a311.create;
const $2763fe62416eb379$export$4b888e40c4ee26dd = $2763fe62416eb379$export$5ef2424805ac76a3.create;
const $2763fe62416eb379$export$bc86dfbf7795668c = $2763fe62416eb379$export$c02deaf0bb5203d4.create;
const $2763fe62416eb379$export$65e3907585753458 = $2763fe62416eb379$export$e2a18bb771d8e6a3.create;
const $2763fe62416eb379$export$e5185e241753e543 = $2763fe62416eb379$export$a2acc09968cb4b7f.create;
const $2763fe62416eb379$export$871de8747c9eaa88 = $2763fe62416eb379$export$163b6a2b712d9542.create;
const $2763fe62416eb379$export$adaa4cf7ef1b65be = $2763fe62416eb379$export$977057706f816712.create;
const $2763fe62416eb379$export$44e51c8aac7c2deb = $2763fe62416eb379$export$d4602ba55673f53c.create;
const $2763fe62416eb379$export$488013bae63b21da = $2763fe62416eb379$export$378d0cfce37406e6.create;
const $2763fe62416eb379$export$c8ec6e1ec9fefcb0 = $2763fe62416eb379$export$7e44096782a165d3.create;
const $2763fe62416eb379$export$78a99c8d44d72635 = $2763fe62416eb379$export$d325d1f0e1c20179.create;
const $2763fe62416eb379$export$6fe7eca19ebe5199 = $2763fe62416eb379$export$370b2e8d6d6f5c56.create;
const $2763fe62416eb379$export$c957ef27a0ebfd4 = $2763fe62416eb379$export$3f196b0127d6e50a.create;
const $2763fe62416eb379$export$dc573d8a6576cdb3 = $2763fe62416eb379$export$a60af00cc0ce2582.create;
const $2763fe62416eb379$export$516e28dec6a4b6d4 = $2763fe62416eb379$export$aa56fec1e9d629b8.create;
const $2763fe62416eb379$export$133fc36489ac9add = $2763fe62416eb379$export$aaac0b8b429cef5.create;
const $2763fe62416eb379$export$fc37fe19dfda43ee = $2763fe62416eb379$export$a60af00cc0ce2582.createWithPreprocess;
const $2763fe62416eb379$export$43f28b24e1eb8181 = $2763fe62416eb379$export$a3c3ef8a0e95c6da.create;
const $2763fe62416eb379$export$3b3d07727c5b702c = ()=>$2763fe62416eb379$export$22b082955e083ec3().optional();
const $2763fe62416eb379$export$eb150471a61fced6 = ()=>$2763fe62416eb379$export$98e628dec113755e().optional();
const $2763fe62416eb379$export$269251733cdcbbf1 = ()=>$2763fe62416eb379$export$4a21f16c33752377().optional();
const $2763fe62416eb379$export$8c14e57e778d3873 = {
    string: (arg)=>$2763fe62416eb379$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$2763fe62416eb379$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$2763fe62416eb379$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$2763fe62416eb379$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$2763fe62416eb379$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $2763fe62416eb379$export$96c94437c95d7862 = $2763fe62416eb379$export$9a105a556e65c2c0;
var $2763fe62416eb379$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $2763fe62416eb379$export$341b0b6e0a6f5099,
    setErrorMap: $2763fe62416eb379$export$1097a8289cfd22d7,
    getErrorMap: $2763fe62416eb379$export$32f27c719778d4c4,
    makeIssue: $2763fe62416eb379$export$244a85fde9c419ed,
    EMPTY_PATH: $2763fe62416eb379$export$1526d2e05f74572,
    addIssueToContext: $2763fe62416eb379$export$db7caee60e5d514d,
    ParseStatus: $2763fe62416eb379$export$5b20a5c3d05c1f6f,
    INVALID: $2763fe62416eb379$export$9a105a556e65c2c0,
    DIRTY: $2763fe62416eb379$export$325a211da9693fcf,
    OK: $2763fe62416eb379$export$c6813a8d51f77eaf,
    isAborted: $2763fe62416eb379$export$afa861e3c5730743,
    isDirty: $2763fe62416eb379$export$910b6cdd390341b3,
    isValid: $2763fe62416eb379$export$1ea939691cdc45b8,
    isAsync: $2763fe62416eb379$export$aefee5ebe1dcfd9e,
    get util () {
        return $2763fe62416eb379$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $2763fe62416eb379$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $2763fe62416eb379$export$5716da67bfaa244d,
    getParsedType: $2763fe62416eb379$export$3e9057828ebd5c7a,
    ZodType: $2763fe62416eb379$export$19342e026b58ebb7,
    datetimeRegex: $2763fe62416eb379$export$a4b563879add27a,
    ZodString: $2763fe62416eb379$export$1230eb29b8d3b502,
    ZodNumber: $2763fe62416eb379$export$5b070a55c0c43e09,
    ZodBigInt: $2763fe62416eb379$export$67d741fd70ff98f4,
    ZodBoolean: $2763fe62416eb379$export$723d146f80596191,
    ZodDate: $2763fe62416eb379$export$e974be33bdc55521,
    ZodSymbol: $2763fe62416eb379$export$bcc3b40f6b638044,
    ZodUndefined: $2763fe62416eb379$export$4e780e961c30340d,
    ZodNull: $2763fe62416eb379$export$a96281f914484f2d,
    ZodAny: $2763fe62416eb379$export$b9d1edb536b4e4eb,
    ZodUnknown: $2763fe62416eb379$export$ef3b1bb1630977ae,
    ZodNever: $2763fe62416eb379$export$1e576a20c3ce9fb5,
    ZodVoid: $2763fe62416eb379$export$7d39f5df85f21031,
    ZodArray: $2763fe62416eb379$export$7acfc3e64785411,
    ZodObject: $2763fe62416eb379$export$736315c5b55efbad,
    ZodUnion: $2763fe62416eb379$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $2763fe62416eb379$export$5ef2424805ac76a3,
    ZodIntersection: $2763fe62416eb379$export$c02deaf0bb5203d4,
    ZodTuple: $2763fe62416eb379$export$e2a18bb771d8e6a3,
    ZodRecord: $2763fe62416eb379$export$a2acc09968cb4b7f,
    ZodMap: $2763fe62416eb379$export$163b6a2b712d9542,
    ZodSet: $2763fe62416eb379$export$977057706f816712,
    ZodFunction: $2763fe62416eb379$export$d4602ba55673f53c,
    ZodLazy: $2763fe62416eb379$export$378d0cfce37406e6,
    ZodLiteral: $2763fe62416eb379$export$7e44096782a165d3,
    ZodEnum: $2763fe62416eb379$export$d325d1f0e1c20179,
    ZodNativeEnum: $2763fe62416eb379$export$370b2e8d6d6f5c56,
    ZodPromise: $2763fe62416eb379$export$3f196b0127d6e50a,
    ZodEffects: $2763fe62416eb379$export$a60af00cc0ce2582,
    ZodTransformer: $2763fe62416eb379$export$a60af00cc0ce2582,
    ZodOptional: $2763fe62416eb379$export$aa56fec1e9d629b8,
    ZodNullable: $2763fe62416eb379$export$aaac0b8b429cef5,
    ZodDefault: $2763fe62416eb379$export$bb19b37874861e7e,
    ZodCatch: $2763fe62416eb379$export$75a44ec6249ac76b,
    ZodNaN: $2763fe62416eb379$export$26ccfa0145e8511f,
    BRAND: $2763fe62416eb379$export$cf2deea74cde46b4,
    ZodBranded: $2763fe62416eb379$export$66b0c798a395271f,
    ZodPipeline: $2763fe62416eb379$export$a3c3ef8a0e95c6da,
    ZodReadonly: $2763fe62416eb379$export$5d1f7ef05c4e493a,
    custom: $2763fe62416eb379$export$4c00f665f0d4b443,
    Schema: $2763fe62416eb379$export$19342e026b58ebb7,
    ZodSchema: $2763fe62416eb379$export$19342e026b58ebb7,
    late: $2763fe62416eb379$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $2763fe62416eb379$export$558106ce543bd011;
    },
    coerce: $2763fe62416eb379$export$8c14e57e778d3873,
    any: $2763fe62416eb379$export$4154a199d7d90455,
    array: $2763fe62416eb379$export$2f23118c22fb2630,
    bigint: $2763fe62416eb379$export$a0f65b52274bcc00,
    boolean: $2763fe62416eb379$export$4a21f16c33752377,
    date: $2763fe62416eb379$export$324d90190a8b822a,
    discriminatedUnion: $2763fe62416eb379$export$4b888e40c4ee26dd,
    effect: $2763fe62416eb379$export$dc573d8a6576cdb3,
    'enum': $2763fe62416eb379$export$78a99c8d44d72635,
    'function': $2763fe62416eb379$export$44e51c8aac7c2deb,
    'instanceof': $2763fe62416eb379$export$3d916e7c22dbd8b5,
    intersection: $2763fe62416eb379$export$bc86dfbf7795668c,
    lazy: $2763fe62416eb379$export$488013bae63b21da,
    literal: $2763fe62416eb379$export$c8ec6e1ec9fefcb0,
    map: $2763fe62416eb379$export$871de8747c9eaa88,
    nan: $2763fe62416eb379$export$9e06de0973666692,
    nativeEnum: $2763fe62416eb379$export$6fe7eca19ebe5199,
    never: $2763fe62416eb379$export$b3e22bcfd64c1022,
    'null': $2763fe62416eb379$export$7b1b591b262c240,
    nullable: $2763fe62416eb379$export$133fc36489ac9add,
    number: $2763fe62416eb379$export$98e628dec113755e,
    object: $2763fe62416eb379$export$be5493f9613cbbe,
    oboolean: $2763fe62416eb379$export$269251733cdcbbf1,
    onumber: $2763fe62416eb379$export$eb150471a61fced6,
    optional: $2763fe62416eb379$export$516e28dec6a4b6d4,
    ostring: $2763fe62416eb379$export$3b3d07727c5b702c,
    pipeline: $2763fe62416eb379$export$43f28b24e1eb8181,
    preprocess: $2763fe62416eb379$export$fc37fe19dfda43ee,
    promise: $2763fe62416eb379$export$c957ef27a0ebfd4,
    record: $2763fe62416eb379$export$e5185e241753e543,
    set: $2763fe62416eb379$export$adaa4cf7ef1b65be,
    strictObject: $2763fe62416eb379$export$8fb0df5f40d0b477,
    string: $2763fe62416eb379$export$22b082955e083ec3,
    symbol: $2763fe62416eb379$export$8f701197936bc2a6,
    transformer: $2763fe62416eb379$export$dc573d8a6576cdb3,
    tuple: $2763fe62416eb379$export$65e3907585753458,
    'undefined': $2763fe62416eb379$export$1db45310990710a5,
    union: $2763fe62416eb379$export$971dd5b0dfd021b6,
    unknown: $2763fe62416eb379$export$19282c40b967aec6,
    'void': $2763fe62416eb379$export$490e536ee7389aeb,
    NEVER: $2763fe62416eb379$export$96c94437c95d7862,
    ZodIssueCode: $2763fe62416eb379$export$5ba560653e4a1035,
    quotelessJson: $2763fe62416eb379$export$913eddeaf297cfea,
    ZodError: $2763fe62416eb379$export$f98dac4b251ab333
});

});





parcelRegister("hp3ar", function(module, exports) {
$parcel$export(module.exports, "overrideAjsAnonIdFromCookie", function () { return $534439a8b1a12b2f$export$75c240835cb5475c; });
$parcel$export(module.exports, "overrideCustomAttributes", function () { return $534439a8b1a12b2f$export$b2a3977b094972c0; });
$parcel$export(module.exports, "isEdgeCachingPath", function () { return $534439a8b1a12b2f$export$ec83ebeeef177d86; });
// Util file to help override the default values of the feature gate bootstrap values for lambda edge work

var $kS3iu = parcelRequire("kS3iu");

var $hu7gH = parcelRequire("hu7gH");

var $fKfE1 = parcelRequire("fKfE1");

var $gx3aw = parcelRequire("gx3aw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5b6JC = parcelRequire("5b6JC");

var $3mZSr = parcelRequire("3mZSr");
const $534439a8b1a12b2f$var$DEVICE_TYPE = 'deviceType';
const $534439a8b1a12b2f$export$7ce6b212accbfff8 = ()=>{
    const data = {};
    const atlCohort = (0, $gx3aw.Cookie).readCookie((0, $fKfE1.ATL_COHORT));
    if (atlCohort) data[0, $fKfE1.ATL_COHORT] = JSON.parse(atlCohort).bucketAll.index;
    const userAgent = navigator.userAgent;
    const { isTablet: isTablet, isMobile: isMobile, isDesktop: isDesktop, browserName: browserName, browserVersion: browserVersion, osName: osName } = (0, $kS3iu.getSelectorsByUserAgent)(userAgent) ?? {};
    if (isTablet) data[$534439a8b1a12b2f$var$DEVICE_TYPE] = 'tablet';
    else if (isMobile) data[$534439a8b1a12b2f$var$DEVICE_TYPE] = 'mobile';
    else if (isDesktop) data[$534439a8b1a12b2f$var$DEVICE_TYPE] = 'desktop';
    else data[$534439a8b1a12b2f$var$DEVICE_TYPE] = 'other';
    data.platform = 'uip';
    data.browserName = browserName;
    data.browserVersion = browserVersion;
    data.browserOS = osName;
    // Scrub Personal Data from the query string before exposing it to Statsig
    // as a user attribute. See sanitize-query-params.ts and the PD standard
    // at https://hello.atlassian.net/wiki/spaces/PMP/pages/139161617.
    data.queryParams = (0, $5b6JC.sanitizeQueryParams)(location.search);
    data.requestPath = location.pathname;
    data.referer = document.referrer;
    data.locale = (0, $hu7gH.parseRoute)(location).locale;
    const cloudSessionToken = (0, $gx3aw.Cookie).readCookie('cloud.session.token') || (0, $gx3aw.Cookie).readCookie('cloud.session.token.stg');
    data.loginUserDetected = cloudSessionToken !== null;
    // @ts-ignore
    data.edgeTraceId = (0, $gx3aw.Cookie).readCookie('X-Experiments-Trace-Id');
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    return data;
};
function $534439a8b1a12b2f$export$75c240835cb5475c() {
    try {
        const ajsAnonIdFromCookie = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id');
        if (!ajsAnonIdFromCookie) return; // Early return if no cookie exists
        const featureGateBootstrapValues = window.featureGateBootstrapValues;
        if (!featureGateBootstrapValues) {
            console.warn('featureGateBootstrapValues is not defined');
            return;
        }
        try {
            const decodedAjsAnonId = decodeURIComponent(ajsAnonIdFromCookie).replace(/['"]+/g, '');
            // Update identifiers
            if (featureGateBootstrapValues.identifiers) featureGateBootstrapValues.identifiers.analyticsAnonymousId = decodedAjsAnonId;
            else console.warn('Could not set analyticsAnonymousId in identifiers - Object path is incomplete.');
            // Update experimentValues.user.customIDs
            if (featureGateBootstrapValues.experimentValues?.user?.customIDs) featureGateBootstrapValues.experimentValues.user.customIDs.analyticsAnonymousId = decodedAjsAnonId;
            else console.warn('Could not set analyticsAnonymousId inside experimentValues.user.customIDs - Object path is incomplete.');
            // Update experimentValues.evaluated_keys.customIDs
            if (featureGateBootstrapValues.experimentValues?.evaluated_keys?.customIDs) featureGateBootstrapValues.experimentValues.evaluated_keys.customIDs.analyticsAnonymousId = decodedAjsAnonId;
            else console.warn('Could not set analyticsAnonymousId inside experimentValues.evaluated_keys - Object path is incomplete.');
        } catch (decodeError) {
            console.error('Error decoding or setting anonymous ID:', decodeError);
        }
    } catch (error) {
        console.error('Error in overrideAjsAnonIdFromCookie:', error);
    }
}
function $534439a8b1a12b2f$export$b2a3977b094972c0() {
    try {
        const newCustomAttributes = $534439a8b1a12b2f$export$7ce6b212accbfff8();
        if (!newCustomAttributes) {
            console.warn('No custom attributes found to override');
            return;
        }
        const featureGateBootstrapValues = window.featureGateBootstrapValues;
        if (!featureGateBootstrapValues) {
            console.warn('featureGateBootstrapValues is not defined');
            return;
        }
        try {
            // Update customAttributes
            if (featureGateBootstrapValues.customAttributes) Object.assign(featureGateBootstrapValues.customAttributes, newCustomAttributes);
            else console.warn('Could not set customAttributes inside featureGateBootstrapValues.customAttributes - Object path is incomplete.');
            // Update experimentValues.user.custom
            if (featureGateBootstrapValues?.experimentValues?.user?.custom) Object.assign(featureGateBootstrapValues.experimentValues.user.custom, newCustomAttributes);
            else console.warn('Could not set customAttributes inside experimentValues.user.custom - Object path is incomplete.');
        } catch (assignError) {
            console.error('Error assigning custom attributes:', assignError);
        }
    } catch (error) {
        console.error('Error in overrideCustomAttributes:', error);
    }
}
const $534439a8b1a12b2f$var$baseEdgePaths = [
    '/',
    '/software/jira/product-discovery'
];
// Pre-compile the regex for customer paths
const $534439a8b1a12b2f$var$CUSTOMERS_REGEX = new RegExp(`^(/[a-z]{2})?/customers(/.*)?$`);
const $534439a8b1a12b2f$var$CONFLUENCE_TEMPLATES_DETAILS_REGEX = new RegExp(`^(/[a-z]{2})?/software/confluence/templates/[^/]+$`);
const $534439a8b1a12b2f$var$CONFLUENCE_TEMPLATES_EXCLUDED_REGEX = new RegExp(`^(/[a-z]{2})?/software/confluence/templates/(categories|search)$`);
const $534439a8b1a12b2f$var$WORK_MANAGEMENT_REGEX = new RegExp(`^(/[a-z]{2})?/work-management(/.*)?$`);
const $534439a8b1a12b2f$var$GIT_REGEX = new RegExp(`^(/[a-z]{2})?/git(/.*)?$`);
const $534439a8b1a12b2f$var$ITSM_REGEX = new RegExp(`^(/[a-z]{2})?/itsm(/.*)?$`);
const $534439a8b1a12b2f$var$INCIDENT_MANAGEMENT_REGEX = new RegExp(`^(/[a-z]{2})?/incident-management(/.*)?$`);
const $534439a8b1a12b2f$var$INCIDENT_MANAGEMENT_EXCLUDED_REGEX = new RegExp(`^(/[a-z]{2})?/incident-management/(get-the-handbook|incident-communication/handbook|20[0-9]{2}-state-of-incident-management)(/.*)?$`);
const $534439a8b1a12b2f$var$AGILE_REGEX = new RegExp(`^(/[a-z]{2})?/agile(/.*)?$`);
const $534439a8b1a12b2f$var$AGILE_EXCLUDED_REGEX = new RegExp(`^(/[a-z]{2})?/agile(/agile-at-scale/beyond-the-basics-whitepaper|/articles|/about(/.*)?)$`);
function $534439a8b1a12b2f$var$generateEdgeCachingPaths(edgePaths) {
    const locales = [
        'br',
        'de',
        'en',
        'es',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'pl',
        'ru',
        'zh'
    ];
    const allPaths = new Set();
    edgePaths.forEach((path)=>{
        // Add the original path
        allPaths.add(path);
        // For root ("/"), just add /ja, /br, etc.
        if (path === '/') locales.forEach((locale)=>{
            allPaths.add(`/${locale}`);
        });
        else // Add localized versions like /ja/customers
        locales.forEach((locale)=>{
            allPaths.add(`/${locale}${path}`);
        });
    });
    return Array.from(allPaths).sort();
}
const $534439a8b1a12b2f$export$91c37d93d1160fb = $534439a8b1a12b2f$var$generateEdgeCachingPaths($534439a8b1a12b2f$var$baseEdgePaths);
function $534439a8b1a12b2f$export$80a69667330d7488() {
    return typeof window !== 'undefined' && (0, $3mZSr.isSourcetreeHostname)(window.location.hostname) && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).edgeCacheSourcetreapp);
}
function $534439a8b1a12b2f$export$ec83ebeeef177d86(location1) {
    // Check if the request is from sourcetreeapp.com — all paths are edge cached
    if ((0, $3mZSr.isSourcetreeHostname)(location1.hostname)) return (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).edgeCacheSourcetreapp);
    // First check if it's a customer path (fast regex check)
    if ($534439a8b1a12b2f$var$CUSTOMERS_REGEX.test(location1.pathname)) return true;
    // Explicit exclusions for templates categories/search pages
    if ($534439a8b1a12b2f$var$CONFLUENCE_TEMPLATES_EXCLUDED_REGEX.test(location1.pathname)) return false;
    if ($534439a8b1a12b2f$var$CONFLUENCE_TEMPLATES_DETAILS_REGEX.test(location1.pathname)) return true;
    // Check work-management paths
    if ($534439a8b1a12b2f$var$WORK_MANAGEMENT_REGEX.test(location1.pathname)) return true;
    // Check git paths
    if ($534439a8b1a12b2f$var$GIT_REGEX.test(location1.pathname)) return true;
    // Check ITSM paths
    if ($534439a8b1a12b2f$var$ITSM_REGEX.test(location1.pathname)) return true;
    // Explicit exclusions for incident-management paths
    if ($534439a8b1a12b2f$var$INCIDENT_MANAGEMENT_EXCLUDED_REGEX.test(location1.pathname)) return false;
    // Check incident-management paths
    if ($534439a8b1a12b2f$var$INCIDENT_MANAGEMENT_REGEX.test(location1.pathname)) return true;
    // Explicit exclusions for agile paths
    if ($534439a8b1a12b2f$var$AGILE_EXCLUDED_REGEX.test(location1.pathname)) return false;
    // Check agile paths
    if ($534439a8b1a12b2f$var$AGILE_REGEX.test(location1.pathname)) return true;
    // Then check other paths
    return $534439a8b1a12b2f$export$91c37d93d1160fb.includes(location1.pathname);
}

});
parcelRegister("3mZSr", function(module, exports) {
$parcel$export(module.exports, "isSourcetreeHostname", function () { return $a8d89457e9bb527d$export$e17696603c3b4232; });
$parcel$export(module.exports, "isVanityHostname", function () { return $a8d89457e9bb527d$export$3569b76c454065a1; });
$parcel$export(module.exports, "getVanitySegment", function () { return $a8d89457e9bb527d$export$f8f9c36210d4b7c2; });
const $a8d89457e9bb527d$var$SOURCETREEAPP_VANITY_DOMAIN = 'sourcetreeapp.com';
const $a8d89457e9bb527d$var$SOURCETREEAPP_STG_DOMAIN = 'sourcetreeapp.stg.internal.atlassian.com';
const $a8d89457e9bb527d$var$BITBUCKET_VANITY_DOMAIN = 'bitbucket.org';
/**
 * Checks whether a hostname matches a vanity domain (bare or www).
 * Other subdomains (e.g. `foo.bitbucket.org`) are intentionally not matched;
 * use a path-based segment on the WAC host instead.
 */ function $a8d89457e9bb527d$var$isVanityDomain(hostname, domain) {
    if (!hostname) return false;
    const host = hostname.toLowerCase();
    return host === domain || host === `www.${domain}`;
}
function $a8d89457e9bb527d$export$e17696603c3b4232(hostname) {
    return $a8d89457e9bb527d$var$isVanityDomain(hostname, $a8d89457e9bb527d$var$SOURCETREEAPP_VANITY_DOMAIN) || hostname === $a8d89457e9bb527d$var$SOURCETREEAPP_STG_DOMAIN;
}
function $a8d89457e9bb527d$export$683a03a94090657e(hostname) {
    return $a8d89457e9bb527d$var$isVanityDomain(hostname, $a8d89457e9bb527d$var$BITBUCKET_VANITY_DOMAIN);
}
function $a8d89457e9bb527d$export$3569b76c454065a1(hostname) {
    return $a8d89457e9bb527d$export$683a03a94090657e(hostname);
}
function $a8d89457e9bb527d$export$f8f9c36210d4b7c2(hostname) {
    if ($a8d89457e9bb527d$export$683a03a94090657e(hostname)) return 'bitbucketapp';
    return null;
}

});


parcelRegister("idVA4", function(module, exports) {
$parcel$export(module.exports, "processExperimentAndFeatureGateOverrides", function () { return $bffb2577897b0e28$export$54e00feca1927558; });

var $g57Lc = parcelRequire("g57Lc");

var $4X0dO = parcelRequire("4X0dO");

var $ai3ZP = parcelRequire("ai3ZP");
const $bffb2577897b0e28$export$8022ee0ca9bf74d6 = (parsedRequestCookies)=>{
    const expOverride = 'atlassian_exp_overrides';
    for (const cookieKey of Object.keys(parsedRequestCookies)){
        if (cookieKey === expOverride && parsedRequestCookies[expOverride]) return $bffb2577897b0e28$export$d180d40f1827eef7(parsedRequestCookies[expOverride]);
    }
    return {}; // return empty overrides if none are found
};
const $bffb2577897b0e28$export$219a3f64f0a96356 = (parsedRequestCookies)=>{
    const fgOverride = 'atlassian_feature_gate_overrides';
    for (const cookieKey of Object.keys(parsedRequestCookies)){
        if (cookieKey === fgOverride && parsedRequestCookies[fgOverride]) return $bffb2577897b0e28$export$d180d40f1827eef7(parsedRequestCookies[fgOverride]);
    }
    return {}; // return empty overrides if none are found
};
const $bffb2577897b0e28$export$d180d40f1827eef7 = (cookie)=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($g57Lc))).decompressFromBase64(cookie));
    } catch (e) {
        return {};
    }
};
const $bffb2577897b0e28$export$54e00feca1927558 = (parsedRequestCookies, userAgent, isPerfOnetrustEnabled)=>{
    const filteredParsedRequestCookies = Object.fromEntries(Object.entries(parsedRequestCookies).filter(([_, value])=>value !== undefined));
    const experimentOverrides = $bffb2577897b0e28$export$8022ee0ca9bf74d6(filteredParsedRequestCookies);
    const featureGateOverrides = $bffb2577897b0e28$export$219a3f64f0a96356(filteredParsedRequestCookies);
    const pollinatorCheck = userAgent.includes('Pollinator');
    const criterionCheck = userAgent.includes('Criterion');
    let finalExperimentOverrides = experimentOverrides;
    let finalFeatureGateOverrides = featureGateOverrides;
    if (pollinatorCheck || criterionCheck) {
        // @ts-ignore - Merge cookie overrides with defaults, cookie overrides take precedence
        finalExperimentOverrides = Object.values((0, $4X0dO.experiments)).reduce((acc, experiment)=>{
            // @ts-ignore
            acc[experiment.experimentName] = {
                // @ts-ignore
                [experiment.parameterName]: experiment.defaultValue,
                // @ts-ignore
                ...experimentOverrides[experiment.experimentName] || {}
            };
            return acc;
        }, {});
        finalFeatureGateOverrides = Object.entries((0, $ai3ZP.featureFlags)).reduce((acc, [, featureFlagObj])=>{
            acc[featureFlagObj.featureFlagName] = featureGateOverrides[featureFlagObj.featureFlagName] ?? false;
            return acc;
        }, {});
        console.log('Overriding ALL experiments to control and ALL feature gates to false, with cookie overrides applied');
    } else if (!isPerfOnetrustEnabled) {
        // @ts-ignore - Only merge cookie overrides with defaults, cookie overrides do NOT take precedence
        finalExperimentOverrides = Object.values((0, $4X0dO.experiments)).reduce((acc, experiment)=>{
            // @ts-ignore
            acc[experiment.experimentName] = {
                // @ts-ignore
                [experiment.parameterName]: experiment.defaultValue
            };
            return acc;
        }, {});
        console.log('Overriding ALL experiments to control, ignoring cookie overrides');
    }
    return {
        finalExperimentOverrides: finalExperimentOverrides,
        finalFeatureGateOverrides: finalFeatureGateOverrides
    };
};

});


//# sourceMappingURL=404.7b3d22c9.js.map
